﻿/* tslint:disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v11.17.21.0 (NJsonSchema v9.10.63.0 (Newtonsoft.Json v9.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, from as _observableFrom, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

import * as moment from 'moment';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');
export const API_BASE_URL_NEW = new InjectionToken<string>('API_BASE_URL_NEW');

@Injectable()
export class AccountServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    isTenantAvailable(input: IsTenantAvailableInput | null | undefined): Observable<IsTenantAvailableOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/IsTenantAvailable";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processIsTenantAvailable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsTenantAvailable(<any>response_);
                } catch (e) {
                    return <Observable<IsTenantAvailableOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<IsTenantAvailableOutput>><any>_observableThrow(response_);
        }));
    }

    protected processIsTenantAvailable(response: HttpResponseBase): Observable<IsTenantAvailableOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? IsTenantAvailableOutput.fromJS(resultData200) : new IsTenantAvailableOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IsTenantAvailableOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    resolveTenantId(input: ResolveTenantIdInput | null | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Account/ResolveTenantId";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processResolveTenantId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResolveTenantId(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processResolveTenantId(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    register(input: RegisterInput | null | undefined): Observable<RegisterOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/Register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processRegister(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegister(<any>response_);
                } catch (e) {
                    return <Observable<RegisterOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<RegisterOutput>><any>_observableThrow(response_);
        }));
    }

    protected processRegister(response: HttpResponseBase): Observable<RegisterOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? RegisterOutput.fromJS(resultData200) : new RegisterOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RegisterOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    resetPassword(input: ResetPasswordInput | null | undefined): Observable<ResetPasswordOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/ResetPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processResetPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetPassword(<any>response_);
                } catch (e) {
                    return <Observable<ResetPasswordOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResetPasswordOutput>><any>_observableThrow(response_);
        }));
    }

    protected processResetPassword(response: HttpResponseBase): Observable<ResetPasswordOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? ResetPasswordOutput.fromJS(resultData200) : new ResetPasswordOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResetPasswordOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    sendEmailActivationLink(input: SendEmailActivationLinkInput | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Account/SendEmailActivationLink";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSendEmailActivationLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendEmailActivationLink(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSendEmailActivationLink(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    activateEmail(input: ActivateEmailInput | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Account/ActivateEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processActivateEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActivateEmail(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processActivateEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    impersonate(input: ImpersonateInput | null | undefined): Observable<ImpersonateOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/Impersonate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processImpersonate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImpersonate(<any>response_);
                } catch (e) {
                    return <Observable<ImpersonateOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<ImpersonateOutput>><any>_observableThrow(response_);
        }));
    }

    protected processImpersonate(response: HttpResponseBase): Observable<ImpersonateOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? ImpersonateOutput.fromJS(resultData200) : new ImpersonateOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ImpersonateOutput>(<any>null);
    }

    /**
     * @return Success
     */
    backToImpersonator(): Observable<ImpersonateOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/BackToImpersonator";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processBackToImpersonator(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBackToImpersonator(<any>response_);
                } catch (e) {
                    return <Observable<ImpersonateOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<ImpersonateOutput>><any>_observableThrow(response_);
        }));
    }

    protected processBackToImpersonator(response: HttpResponseBase): Observable<ImpersonateOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? ImpersonateOutput.fromJS(resultData200) : new ImpersonateOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ImpersonateOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    switchToLinkedAccount(input: SwitchToLinkedAccountInput | null | undefined): Observable<SwitchToLinkedAccountOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/SwitchToLinkedAccount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSwitchToLinkedAccount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSwitchToLinkedAccount(<any>response_);
                } catch (e) {
                    return <Observable<SwitchToLinkedAccountOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<SwitchToLinkedAccountOutput>><any>_observableThrow(response_);
        }));
    }

    protected processSwitchToLinkedAccount(response: HttpResponseBase): Observable<SwitchToLinkedAccountOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? SwitchToLinkedAccountOutput.fromJS(resultData200) : new SwitchToLinkedAccountOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwitchToLinkedAccountOutput>(<any>null);
    }
}

@Injectable()
export class ActionRulesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param codeFilter (optional) 
     * @param nameFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param maxEffectiveFromFilter (optional) 
     * @param minEffectiveFromFilter (optional) 
     * @param maxEffectiveToFilter (optional) 
     * @param minEffectiveToFilter (optional) 
     * @param cronFilter (optional) 
     * @param maxStartTimeFilter (optional) 
     * @param minStartTimeFilter (optional) 
     * @param maxEndTimeFilter (optional) 
     * @param minEndTimeFilter (optional) 
     * @param actionFilterFilter (optional) 
     * @param maxValueFilter (optional) 
     * @param minValueFilter (optional) 
     * @param maxPointValueFilter (optional) 
     * @param minPointValueFilter (optional) 
     * @param maxCoinValueFilter (optional) 
     * @param minCoinValueFilter (optional) 
     * @param maxMaxSetFilter (optional) 
     * @param minMaxSetFilter (optional) 
     * @param typeFilter (optional) 
     * @param maxMaxSetPerActionFilter (optional) 
     * @param minMaxSetPerActionFilter (optional) 
     * @param timeZoneFilter (optional) 
     * @param isActiveFilter (optional) 
     * @param actionCodeFilter (optional) 
     * @param targetAudienceCodeFilter (optional) 
     * @param campaignCodeFilter (optional) 
     * @param campaignIdFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, codeFilter: string | null | undefined, nameFilter: string | null | undefined, descriptionFilter: string | null | undefined, maxEffectiveFromFilter: moment.Moment | null | undefined, minEffectiveFromFilter: moment.Moment | null | undefined, maxEffectiveToFilter: moment.Moment | null | undefined, minEffectiveToFilter: moment.Moment | null | undefined, cronFilter: string | null | undefined, maxStartTimeFilter: moment.Moment | null | undefined, minStartTimeFilter: moment.Moment | null | undefined, maxEndTimeFilter: moment.Moment | null | undefined, minEndTimeFilter: moment.Moment | null | undefined, actionFilterFilter: string | null | undefined, maxValueFilter: number | null | undefined, minValueFilter: number | null | undefined, maxPointValueFilter: number | null | undefined, minPointValueFilter: number | null | undefined, maxCoinValueFilter: number | null | undefined, minCoinValueFilter: number | null | undefined, maxMaxSetFilter: number | null | undefined, minMaxSetFilter: number | null | undefined, typeFilter: number | null | undefined, maxMaxSetPerActionFilter: number | null | undefined, minMaxSetPerActionFilter: number | null | undefined, timeZoneFilter: string | null | undefined, isActiveFilter: number | null | undefined, actionCodeFilter: string | null | undefined, targetAudienceCodeFilter: string | null | undefined, campaignCodeFilter: string | null | undefined, campaignIdFilter: number | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetActionRuleForView> {
        let url_ = this.baseUrl + "/api/services/app/ActionRules/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&";
        if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&";
        if (maxEffectiveFromFilter !== undefined)
            url_ += "MaxEffectiveFromFilter=" + encodeURIComponent(maxEffectiveFromFilter ? "" + maxEffectiveFromFilter.toJSON() : "") + "&";
        if (minEffectiveFromFilter !== undefined)
            url_ += "MinEffectiveFromFilter=" + encodeURIComponent(minEffectiveFromFilter ? "" + minEffectiveFromFilter.toJSON() : "") + "&";
        if (maxEffectiveToFilter !== undefined)
            url_ += "MaxEffectiveToFilter=" + encodeURIComponent(maxEffectiveToFilter ? "" + maxEffectiveToFilter.toJSON() : "") + "&";
        if (minEffectiveToFilter !== undefined)
            url_ += "MinEffectiveToFilter=" + encodeURIComponent(minEffectiveToFilter ? "" + minEffectiveToFilter.toJSON() : "") + "&";
        if (cronFilter !== undefined)
            url_ += "CronFilter=" + encodeURIComponent("" + cronFilter) + "&";
        if (maxStartTimeFilter !== undefined)
            url_ += "MaxStartTimeFilter=" + encodeURIComponent(maxStartTimeFilter ? "" + maxStartTimeFilter.toJSON() : "") + "&";
        if (minStartTimeFilter !== undefined)
            url_ += "MinStartTimeFilter=" + encodeURIComponent(minStartTimeFilter ? "" + minStartTimeFilter.toJSON() : "") + "&";
        if (maxEndTimeFilter !== undefined)
            url_ += "MaxEndTimeFilter=" + encodeURIComponent(maxEndTimeFilter ? "" + maxEndTimeFilter.toJSON() : "") + "&";
        if (minEndTimeFilter !== undefined)
            url_ += "MinEndTimeFilter=" + encodeURIComponent(minEndTimeFilter ? "" + minEndTimeFilter.toJSON() : "") + "&";
        if (actionFilterFilter !== undefined)
            url_ += "ActionFilterFilter=" + encodeURIComponent("" + actionFilterFilter) + "&";
        if (maxValueFilter !== undefined)
            url_ += "MaxValueFilter=" + encodeURIComponent("" + maxValueFilter) + "&";
        if (minValueFilter !== undefined)
            url_ += "MinValueFilter=" + encodeURIComponent("" + minValueFilter) + "&";
        if (maxPointValueFilter !== undefined)
            url_ += "MaxPointValueFilter=" + encodeURIComponent("" + maxPointValueFilter) + "&";
        if (minPointValueFilter !== undefined)
            url_ += "MinPointValueFilter=" + encodeURIComponent("" + minPointValueFilter) + "&";
        if (maxCoinValueFilter !== undefined)
            url_ += "MaxCoinValueFilter=" + encodeURIComponent("" + maxCoinValueFilter) + "&";
        if (minCoinValueFilter !== undefined)
            url_ += "MinCoinValueFilter=" + encodeURIComponent("" + minCoinValueFilter) + "&";
        if (maxMaxSetFilter !== undefined)
            url_ += "MaxMaxSetFilter=" + encodeURIComponent("" + maxMaxSetFilter) + "&";
        if (minMaxSetFilter !== undefined)
            url_ += "MinMaxSetFilter=" + encodeURIComponent("" + minMaxSetFilter) + "&";
        if (typeFilter !== undefined)
            url_ += "TypeFilter=" + encodeURIComponent("" + typeFilter) + "&";
        if (maxMaxSetPerActionFilter !== undefined)
            url_ += "MaxMaxSetPerActionFilter=" + encodeURIComponent("" + maxMaxSetPerActionFilter) + "&";
        if (minMaxSetPerActionFilter !== undefined)
            url_ += "MinMaxSetPerActionFilter=" + encodeURIComponent("" + minMaxSetPerActionFilter) + "&";
        if (timeZoneFilter !== undefined)
            url_ += "TimeZoneFilter=" + encodeURIComponent("" + timeZoneFilter) + "&";
        if (isActiveFilter !== undefined)
            url_ += "IsActiveFilter=" + encodeURIComponent("" + isActiveFilter) + "&";
        if (actionCodeFilter !== undefined)
            url_ += "ActionCodeFilter=" + encodeURIComponent("" + actionCodeFilter) + "&";
        if (targetAudienceCodeFilter !== undefined)
            url_ += "TargetAudienceCodeFilter=" + encodeURIComponent("" + targetAudienceCodeFilter) + "&";
        if (campaignCodeFilter !== undefined)
            url_ += "CampaignCodeFilter=" + encodeURIComponent("" + campaignCodeFilter) + "&";
        if (campaignIdFilter !== undefined)
            url_ += "CampaignIdFilter=" + encodeURIComponent("" + campaignIdFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetActionRuleForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetActionRuleForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetActionRuleForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetActionRuleForView.fromJS(resultData200) : new PagedResultDtoOfGetActionRuleForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetActionRuleForView>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getActionRuleForEdit(id: number | null | undefined): Observable<GetActionRuleForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/ActionRules/GetActionRuleForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetActionRuleForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActionRuleForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetActionRuleForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetActionRuleForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetActionRuleForEdit(response: HttpResponseBase): Observable<GetActionRuleForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetActionRuleForEditOutput.fromJS(resultData200) : new GetActionRuleForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetActionRuleForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditActionRuleDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ActionRules/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ActionRules/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllActionForLookupTable(filter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfActionLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/ActionRules/GetAllActionForLookupTable?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllActionForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllActionForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfActionLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfActionLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllActionForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfActionLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfActionLookupTableDto.fromJS(resultData200) : new PagedResultDtoOfActionLookupTableDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfActionLookupTableDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllSettingParamForLookupTable(filter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfSettingParamLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/ActionRules/GetAllSettingParamForLookupTable?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllSettingParamForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSettingParamForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfSettingParamLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfSettingParamLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllSettingParamForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfSettingParamLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfSettingParamLookupTableDto.fromJS(resultData200) : new PagedResultDtoOfSettingParamLookupTableDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfSettingParamLookupTableDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllCampaignForLookupTable(filter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfCampaignLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/ActionRules/GetAllCampaignForLookupTable?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllCampaignForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCampaignForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfCampaignLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfCampaignLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllCampaignForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfCampaignLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfCampaignLookupTableDto.fromJS(resultData200) : new PagedResultDtoOfCampaignLookupTableDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfCampaignLookupTableDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    search(input: GetAllActionRulesInput | null | undefined): Observable<PagedResultDtoOfGetActionRuleForView> {
        let url_ = this.baseUrl + "/api/services/app/ActionRules/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetActionRuleForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetActionRuleForView>><any>_observableThrow(response_);
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<PagedResultDtoOfGetActionRuleForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetActionRuleForView.fromJS(resultData200) : new PagedResultDtoOfGetActionRuleForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetActionRuleForView>(<any>null);
    }
}

@Injectable()
export class ActionsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param codeFilter (optional) 
     * @param nameFilter (optional) 
     * @param isActiveFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, codeFilter: string | null | undefined, nameFilter: string | null | undefined, isActiveFilter: number | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetActionForView> {
        let url_ = this.baseUrl + "/api/services/app/Actions/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&";
        if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (isActiveFilter !== undefined)
            url_ += "IsActiveFilter=" + encodeURIComponent("" + isActiveFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetActionForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetActionForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetActionForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetActionForView.fromJS(resultData200) : new PagedResultDtoOfGetActionForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetActionForView>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getActionForEdit(id: number | null | undefined): Observable<GetActionForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Actions/GetActionForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetActionForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActionForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetActionForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetActionForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetActionForEdit(response: HttpResponseBase): Observable<GetActionForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetActionForEditOutput.fromJS(resultData200) : new GetActionForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetActionForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditActionDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Actions/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Actions/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteValidate(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Actions/DeleteValidate?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteValidate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteValidate(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteValidate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param code (optional) 
     * @return Success
     */
    getByCode(code: string | null | undefined): Observable<GetActionForView> {
        let url_ = this.baseUrl + "/api/services/app/Actions/GetByCode?";
        if (code !== undefined)
            url_ += "Code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetByCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByCode(<any>response_);
                } catch (e) {
                    return <Observable<GetActionForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetActionForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetByCode(response: HttpResponseBase): Observable<GetActionForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetActionForView.fromJS(resultData200) : new GetActionForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetActionForView>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getById(id: number | null | undefined): Observable<GetActionForView> {
        let url_ = this.baseUrl + "/api/services/app/Actions/GetById?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(<any>response_);
                } catch (e) {
                    return <Observable<GetActionForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetActionForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<GetActionForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetActionForView.fromJS(resultData200) : new GetActionForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetActionForView>(<any>null);
    }
}

@Injectable()
export class ActionTransactionsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param actionCodeFilter (optional) 
     * @param memberCode (optional) 
     * @param maxTransactionTimeFilter (optional) 
     * @param minTransactionTimeFilter (optional) 
     * @param maxValueFilter (optional) 
     * @param minValueFilter (optional) 
     * @param actionRuleSettingIdFilter (optional) 
     * @param transactionCodeFilter (optional) 
     * @param tagsFilter (optional) 
     * @param actionFilterFilter (optional) 
     * @param maxSetFilter (optional) 
     * @param minSetFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, actionCodeFilter: string | null | undefined, memberCode: string | null | undefined, maxTransactionTimeFilter: moment.Moment | null | undefined, minTransactionTimeFilter: moment.Moment | null | undefined, maxValueFilter: number | null | undefined, minValueFilter: number | null | undefined, actionRuleSettingIdFilter: string | null | undefined, transactionCodeFilter: string | null | undefined, tagsFilter: string | null | undefined, actionFilterFilter: string | null | undefined, maxSetFilter: number | null | undefined, minSetFilter: number | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetActionTransactionForView> {
        let url_ = this.baseUrl + "/api/services/app/ActionTransactions/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (actionCodeFilter !== undefined)
            url_ += "ActionCodeFilter=" + encodeURIComponent("" + actionCodeFilter) + "&";
        if (memberCode !== undefined)
            url_ += "MemberCode=" + encodeURIComponent("" + memberCode) + "&";
        if (maxTransactionTimeFilter !== undefined)
            url_ += "MaxTransactionTimeFilter=" + encodeURIComponent(maxTransactionTimeFilter ? "" + maxTransactionTimeFilter.toJSON() : "") + "&";
        if (minTransactionTimeFilter !== undefined)
            url_ += "MinTransactionTimeFilter=" + encodeURIComponent(minTransactionTimeFilter ? "" + minTransactionTimeFilter.toJSON() : "") + "&";
        if (maxValueFilter !== undefined)
            url_ += "MaxValueFilter=" + encodeURIComponent("" + maxValueFilter) + "&";
        if (minValueFilter !== undefined)
            url_ += "MinValueFilter=" + encodeURIComponent("" + minValueFilter) + "&";
        if (actionRuleSettingIdFilter !== undefined)
            url_ += "ActionRuleSettingIdFilter=" + encodeURIComponent("" + actionRuleSettingIdFilter) + "&";
        if (transactionCodeFilter !== undefined)
            url_ += "TransactionCodeFilter=" + encodeURIComponent("" + transactionCodeFilter) + "&";
        if (tagsFilter !== undefined)
            url_ += "TagsFilter=" + encodeURIComponent("" + tagsFilter) + "&";
        if (actionFilterFilter !== undefined)
            url_ += "ActionFilterFilter=" + encodeURIComponent("" + actionFilterFilter) + "&";
        if (maxSetFilter !== undefined)
            url_ += "MaxSetFilter=" + encodeURIComponent("" + maxSetFilter) + "&";
        if (minSetFilter !== undefined)
            url_ += "MinSetFilter=" + encodeURIComponent("" + minSetFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetActionTransactionForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetActionTransactionForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetActionTransactionForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetActionTransactionForView.fromJS(resultData200) : new PagedResultDtoOfGetActionTransactionForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetActionTransactionForView>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getActionTransactionForEdit(id: number | null | undefined): Observable<GetActionTransactionForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/ActionTransactions/GetActionTransactionForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetActionTransactionForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActionTransactionForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetActionTransactionForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetActionTransactionForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetActionTransactionForEdit(response: HttpResponseBase): Observable<GetActionTransactionForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetActionTransactionForEditOutput.fromJS(resultData200) : new GetActionTransactionForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetActionTransactionForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditActionTransactionDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ActionTransactions/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ActionTransactions/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllActionForLookupTable(filter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfActionLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/ActionTransactions/GetAllActionForLookupTable?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllActionForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllActionForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfActionLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfActionLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllActionForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfActionLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfActionLookupTableDto.fromJS(resultData200) : new PagedResultDtoOfActionLookupTableDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfActionLookupTableDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllTransactionForLookupTable(filter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfTransactionLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/ActionTransactions/GetAllTransactionForLookupTable?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllTransactionForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTransactionForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfTransactionLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfTransactionLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllTransactionForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfTransactionLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfTransactionLookupTableDto.fromJS(resultData200) : new PagedResultDtoOfTransactionLookupTableDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfTransactionLookupTableDto>(<any>null);
    }
}

@Injectable()
export class ActivationCodeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditActivationCodeInput | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ActivationCode/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param activationCode (optional) 
     * @param serial (optional) 
     * @return Success
     */
    checkExistActiveCodeAndSerialNumber(activationCode: string | null | undefined, serial: string | null | undefined): Observable<ResponseStatusDtoOfBoolean> {
        let url_ = this.baseUrl + "/api/services/app/ActivationCode/CheckExistActiveCodeAndSerialNumber?";
        if (activationCode !== undefined)
            url_ += "activationCode=" + encodeURIComponent("" + activationCode) + "&";
        if (serial !== undefined)
            url_ += "serial=" + encodeURIComponent("" + serial) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCheckExistActiveCodeAndSerialNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckExistActiveCodeAndSerialNumber(<any>response_);
                } catch (e) {
                    return <Observable<ResponseStatusDtoOfBoolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResponseStatusDtoOfBoolean>><any>_observableThrow(response_);
        }));
    }

    protected processCheckExistActiveCodeAndSerialNumber(response: HttpResponseBase): Observable<ResponseStatusDtoOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? ResponseStatusDtoOfBoolean.fromJS(resultData200) : new ResponseStatusDtoOfBoolean();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseStatusDtoOfBoolean>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ActivationCode/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param activationCode (optional) 
     * @param memberCode (optional) 
     * @param serial (optional) 
     * @return Success
     */
    checkActivationCode(activationCode: string | null | undefined, memberCode: string | null | undefined, serial: string | null | undefined): Observable<ResponseDataDtoOfString> {
        let url_ = this.baseUrl + "/api/services/app/ActivationCode/CheckActivationCode?";
        if (activationCode !== undefined)
            url_ += "activationCode=" + encodeURIComponent("" + activationCode) + "&";
        if (memberCode !== undefined)
            url_ += "memberCode=" + encodeURIComponent("" + memberCode) + "&";
        if (serial !== undefined)
            url_ += "serial=" + encodeURIComponent("" + serial) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCheckActivationCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckActivationCode(<any>response_);
                } catch (e) {
                    return <Observable<ResponseDataDtoOfString>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResponseDataDtoOfString>><any>_observableThrow(response_);
        }));
    }

    protected processCheckActivationCode(response: HttpResponseBase): Observable<ResponseDataDtoOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? ResponseDataDtoOfString.fromJS(resultData200) : new ResponseDataDtoOfString();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseDataDtoOfString>(<any>null);
    }

    /**
     * @param code (optional) 
     * @param serial (optional) 
     * @param status (optional) 
     * @param massOrder (optional) 
     * @param importDate (optional) 
     * @param activeDate (optional) 
     * @param isCancel (optional) 
     * @param note (optional) 
     * @param salemanCode (optional) 
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(code: string | null | undefined, serial: string | null | undefined, status: string | null | undefined, massOrder: string | null | undefined, importDate: moment.Moment | null | undefined, activeDate: moment.Moment | null | undefined, isCancel: boolean | null | undefined, note: string | null | undefined, salemanCode: string | null | undefined, fromDate: moment.Moment | null | undefined, toDate: moment.Moment | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetActivationCodeForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/ActivationCode/GetAll?";
        if (code !== undefined)
            url_ += "Code=" + encodeURIComponent("" + code) + "&";
        if (serial !== undefined)
            url_ += "Serial=" + encodeURIComponent("" + serial) + "&";
        if (status !== undefined)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (massOrder !== undefined)
            url_ += "MassOrder=" + encodeURIComponent("" + massOrder) + "&";
        if (importDate !== undefined)
            url_ += "ImportDate=" + encodeURIComponent(importDate ? "" + importDate.toJSON() : "") + "&";
        if (activeDate !== undefined)
            url_ += "ActiveDate=" + encodeURIComponent(activeDate ? "" + activeDate.toJSON() : "") + "&";
        if (isCancel !== undefined)
            url_ += "IsCancel=" + encodeURIComponent("" + isCancel) + "&";
        if (note !== undefined)
            url_ += "Note=" + encodeURIComponent("" + note) + "&";
        if (salemanCode !== undefined)
            url_ += "SalemanCode=" + encodeURIComponent("" + salemanCode) + "&";
        if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toJSON() : "") + "&";
        if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toJSON() : "") + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetActivationCodeForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetActivationCodeForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetActivationCodeForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetActivationCodeForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetActivationCodeForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetActivationCodeForViewDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    exportFile(input: GetActivationCodeInput | null | undefined): Observable<SocialRetailerFileDto> {
        let url_ = this.baseUrl + "/api/services/app/ActivationCode/ExportFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processExportFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportFile(<any>response_);
                } catch (e) {
                    return <Observable<SocialRetailerFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SocialRetailerFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processExportFile(response: HttpResponseBase): Observable<SocialRetailerFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? SocialRetailerFileDto.fromJS(resultData200) : new SocialRetailerFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SocialRetailerFileDto>(<any>null);
    }

    /**
     * @param arg (optional) 
     * @return Success
     */
    importActiveCodeInsert(arg: CommonImportAgrs | null | undefined): Observable<StatusImportDistributeDto> {
        let url_ = this.baseUrl + "/api/services/app/ActivationCode/ImportActiveCodeInsert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(arg);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processImportActiveCodeInsert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportActiveCodeInsert(<any>response_);
                } catch (e) {
                    return <Observable<StatusImportDistributeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<StatusImportDistributeDto>><any>_observableThrow(response_);
        }));
    }

    protected processImportActiveCodeInsert(response: HttpResponseBase): Observable<StatusImportDistributeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? StatusImportDistributeDto.fromJS(resultData200) : new StatusImportDistributeDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StatusImportDistributeDto>(<any>null);
    }

    /**
     * @param arg (optional) 
     * @return Success
     */
    importActiveCodeUpdate(arg: CommonImportAgrs | null | undefined): Observable<StatusImportDistributeDto> {
        let url_ = this.baseUrl + "/api/services/app/ActivationCode/ImportActiveCodeUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(arg);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processImportActiveCodeUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportActiveCodeUpdate(<any>response_);
                } catch (e) {
                    return <Observable<StatusImportDistributeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<StatusImportDistributeDto>><any>_observableThrow(response_);
        }));
    }

    protected processImportActiveCodeUpdate(response: HttpResponseBase): Observable<StatusImportDistributeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? StatusImportDistributeDto.fromJS(resultData200) : new StatusImportDistributeDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StatusImportDistributeDto>(<any>null);
    }
}

@Injectable()
export class AdjustmentFileStatusServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param codeFilter (optional) 
     * @param fileNameFilter (optional) 
     * @param statusFilter (optional) 
     * @param maxProcessTimeFilter (optional) 
     * @param minProcessTimeFilter (optional) 
     * @param typeFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, codeFilter: string | null | undefined, fileNameFilter: string | null | undefined, statusFilter: string | null | undefined, maxProcessTimeFilter: moment.Moment | null | undefined, minProcessTimeFilter: moment.Moment | null | undefined, typeFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetAdjustmentFileStatusForView> {
        let url_ = this.baseUrl + "/api/services/app/AdjustmentFileStatus/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&";
        if (fileNameFilter !== undefined)
            url_ += "FileNameFilter=" + encodeURIComponent("" + fileNameFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (maxProcessTimeFilter !== undefined)
            url_ += "MaxProcessTimeFilter=" + encodeURIComponent(maxProcessTimeFilter ? "" + maxProcessTimeFilter.toJSON() : "") + "&";
        if (minProcessTimeFilter !== undefined)
            url_ += "MinProcessTimeFilter=" + encodeURIComponent(minProcessTimeFilter ? "" + minProcessTimeFilter.toJSON() : "") + "&";
        if (typeFilter !== undefined)
            url_ += "TypeFilter=" + encodeURIComponent("" + typeFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetAdjustmentFileStatusForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetAdjustmentFileStatusForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetAdjustmentFileStatusForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetAdjustmentFileStatusForView.fromJS(resultData200) : new PagedResultDtoOfGetAdjustmentFileStatusForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetAdjustmentFileStatusForView>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getAdjustmentFileStatusForEdit(id: number | null | undefined): Observable<GetAdjustmentFileStatusForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/AdjustmentFileStatus/GetAdjustmentFileStatusForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAdjustmentFileStatusForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAdjustmentFileStatusForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetAdjustmentFileStatusForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetAdjustmentFileStatusForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetAdjustmentFileStatusForEdit(response: HttpResponseBase): Observable<GetAdjustmentFileStatusForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetAdjustmentFileStatusForEditOutput.fromJS(resultData200) : new GetAdjustmentFileStatusForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAdjustmentFileStatusForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditAdjustmentFileStatusDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AdjustmentFileStatus/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AdjustmentFileStatus/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param arg (optional) 
     * @return Success
     */
    importAdjustment(arg: AdjustmentImportJobArgs | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AdjustmentFileStatus/ImportAdjustment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(arg);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processImportAdjustment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportAdjustment(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processImportAdjustment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param arg (optional) 
     * @return Success
     */
    importRankAdjustment(arg: RankAdjustmentImportJobArgs | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AdjustmentFileStatus/ImportRankAdjustment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(arg);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processImportRankAdjustment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportRankAdjustment(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processImportRankAdjustment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    export(input: ExportRankAdjustmentInput | null | undefined): Observable<PointFileDto> {
        let url_ = this.baseUrl + "/api/services/app/AdjustmentFileStatus/Export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExport(<any>response_);
                } catch (e) {
                    return <Observable<PointFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PointFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processExport(response: HttpResponseBase): Observable<PointFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PointFileDto.fromJS(resultData200) : new PointFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PointFileDto>(<any>null);
    }

    /**
     * @return Success
     */
    getFileTemplate(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/AdjustmentFileStatus/GetFileTemplate";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetFileTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFileTemplate(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetFileTemplate(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }
}

@Injectable()
export class AlbumServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param albumCodeFilter (optional) 
     * @param statusFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(albumCodeFilter: string | null | undefined, statusFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetAlbumForApp> {
        let url_ = this.baseUrl + "/api/services/app/Album/GetAll?";
        if (albumCodeFilter !== undefined)
            url_ += "AlbumCodeFilter=" + encodeURIComponent("" + albumCodeFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetAlbumForApp>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetAlbumForApp>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetAlbumForApp> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetAlbumForApp.fromJS(resultData200) : new PagedResultDtoOfGetAlbumForApp();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetAlbumForApp>(<any>null);
    }

    /**
     * @param code (optional) 
     * @return Success
     */
    getDetail(code: string | null | undefined): Observable<AlbumForAppDto> {
        let url_ = this.baseUrl + "/api/services/app/Album/GetDetail?";
        if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDetail(<any>response_);
                } catch (e) {
                    return <Observable<AlbumForAppDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<AlbumForAppDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetDetail(response: HttpResponseBase): Observable<AlbumForAppDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? AlbumForAppDto.fromJS(resultData200) : new AlbumForAppDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AlbumForAppDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getAlbumForEdit(id: number | null | undefined): Observable<GetAlbumForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Album/GetAlbumForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAlbumForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAlbumForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetAlbumForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetAlbumForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetAlbumForEdit(response: HttpResponseBase): Observable<GetAlbumForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetAlbumForEditOutput.fromJS(resultData200) : new GetAlbumForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAlbumForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditAlbumInput | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Album/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param status (optional) 
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllForView(filter: string | null | undefined, status: string | null | undefined, fromDate: moment.Moment | null | undefined, toDate: moment.Moment | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetAlbumForView> {
        let url_ = this.baseUrl + "/api/services/app/Album/GetAllForView?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (status !== undefined)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toJSON() : "") + "&";
        if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toJSON() : "") + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllForView(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetAlbumForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetAlbumForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllForView(response: HttpResponseBase): Observable<PagedResultDtoOfGetAlbumForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetAlbumForView.fromJS(resultData200) : new PagedResultDtoOfGetAlbumForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetAlbumForView>(<any>null);
    }
}

@Injectable()
export class AppBehaviorServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param inputs (optional) 
     * @return Success
     */
    log(inputs: LogInputSalesTrackingDto[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AppBehavior/Log";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inputs);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processLog(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLog(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processLog(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class AppBehaviorLogsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param memberCodeFilter (optional) 
     * @param deviceImeiFilter (optional) 
     * @param deviceSerialFilter (optional) 
     * @param deviceNameFilter (optional) 
     * @param deviceManufacturerFilter (optional) 
     * @param deviceOSFilter (optional) 
     * @param deviceOSVersionFilter (optional) 
     * @param appNameFilter (optional) 
     * @param appVersionFilter (optional) 
     * @param appAreaFilter (optional) 
     * @param actionInfoFilter (optional) 
     * @param actionNameFilter (optional) 
     * @param maxActionStartTimeFilter (optional) 
     * @param minActionStartTimeFilter (optional) 
     * @param maxActionEndTimeFilter (optional) 
     * @param minActionEndTimeFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, memberCodeFilter: string | null | undefined, deviceImeiFilter: string | null | undefined, deviceSerialFilter: string | null | undefined, deviceNameFilter: string | null | undefined, deviceManufacturerFilter: string | null | undefined, deviceOSFilter: string | null | undefined, deviceOSVersionFilter: string | null | undefined, appNameFilter: string | null | undefined, appVersionFilter: string | null | undefined, appAreaFilter: string | null | undefined, actionInfoFilter: string | null | undefined, actionNameFilter: string | null | undefined, maxActionStartTimeFilter: moment.Moment | null | undefined, minActionStartTimeFilter: moment.Moment | null | undefined, maxActionEndTimeFilter: moment.Moment | null | undefined, minActionEndTimeFilter: moment.Moment | null | undefined, descriptionFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetAppBehaviorLogForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/AppBehaviorLogs/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (memberCodeFilter !== undefined)
            url_ += "MemberCodeFilter=" + encodeURIComponent("" + memberCodeFilter) + "&";
        if (deviceImeiFilter !== undefined)
            url_ += "DeviceImeiFilter=" + encodeURIComponent("" + deviceImeiFilter) + "&";
        if (deviceSerialFilter !== undefined)
            url_ += "DeviceSerialFilter=" + encodeURIComponent("" + deviceSerialFilter) + "&";
        if (deviceNameFilter !== undefined)
            url_ += "DeviceNameFilter=" + encodeURIComponent("" + deviceNameFilter) + "&";
        if (deviceManufacturerFilter !== undefined)
            url_ += "DeviceManufacturerFilter=" + encodeURIComponent("" + deviceManufacturerFilter) + "&";
        if (deviceOSFilter !== undefined)
            url_ += "DeviceOSFilter=" + encodeURIComponent("" + deviceOSFilter) + "&";
        if (deviceOSVersionFilter !== undefined)
            url_ += "DeviceOSVersionFilter=" + encodeURIComponent("" + deviceOSVersionFilter) + "&";
        if (appNameFilter !== undefined)
            url_ += "AppNameFilter=" + encodeURIComponent("" + appNameFilter) + "&";
        if (appVersionFilter !== undefined)
            url_ += "AppVersionFilter=" + encodeURIComponent("" + appVersionFilter) + "&";
        if (appAreaFilter !== undefined)
            url_ += "AppAreaFilter=" + encodeURIComponent("" + appAreaFilter) + "&";
        if (actionInfoFilter !== undefined)
            url_ += "ActionInfoFilter=" + encodeURIComponent("" + actionInfoFilter) + "&";
        if (actionNameFilter !== undefined)
            url_ += "ActionNameFilter=" + encodeURIComponent("" + actionNameFilter) + "&";
        if (maxActionStartTimeFilter !== undefined)
            url_ += "MaxActionStartTimeFilter=" + encodeURIComponent(maxActionStartTimeFilter ? "" + maxActionStartTimeFilter.toJSON() : "") + "&";
        if (minActionStartTimeFilter !== undefined)
            url_ += "MinActionStartTimeFilter=" + encodeURIComponent(minActionStartTimeFilter ? "" + minActionStartTimeFilter.toJSON() : "") + "&";
        if (maxActionEndTimeFilter !== undefined)
            url_ += "MaxActionEndTimeFilter=" + encodeURIComponent(maxActionEndTimeFilter ? "" + maxActionEndTimeFilter.toJSON() : "") + "&";
        if (minActionEndTimeFilter !== undefined)
            url_ += "MinActionEndTimeFilter=" + encodeURIComponent(minActionEndTimeFilter ? "" + minActionEndTimeFilter.toJSON() : "") + "&";
        if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetAppBehaviorLogForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetAppBehaviorLogForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetAppBehaviorLogForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetAppBehaviorLogForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetAppBehaviorLogForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetAppBehaviorLogForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getAppBehaviorLogForEdit(id: number | null | undefined): Observable<GetAppBehaviorLogForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/AppBehaviorLogs/GetAppBehaviorLogForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAppBehaviorLogForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAppBehaviorLogForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetAppBehaviorLogForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetAppBehaviorLogForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetAppBehaviorLogForEdit(response: HttpResponseBase): Observable<GetAppBehaviorLogForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetAppBehaviorLogForEditOutput.fromJS(resultData200) : new GetAppBehaviorLogForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAppBehaviorLogForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditAppBehaviorLogDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AppBehaviorLogs/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AppBehaviorLogs/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param memberCodeFilter (optional) 
     * @param deviceImeiFilter (optional) 
     * @param deviceSerialFilter (optional) 
     * @param deviceNameFilter (optional) 
     * @param deviceManufacturerFilter (optional) 
     * @param deviceOSFilter (optional) 
     * @param deviceOSVersionFilter (optional) 
     * @param appNameFilter (optional) 
     * @param appVersionFilter (optional) 
     * @param appAreaFilter (optional) 
     * @param actionInfoFilter (optional) 
     * @param actionNameFilter (optional) 
     * @param maxActionStartTimeFilter (optional) 
     * @param minActionStartTimeFilter (optional) 
     * @param maxActionEndTimeFilter (optional) 
     * @param minActionEndTimeFilter (optional) 
     * @param descriptionFilter (optional) 
     * @return Success
     */
    getAppBehaviorLogsToExcel(filter: string | null | undefined, memberCodeFilter: string | null | undefined, deviceImeiFilter: string | null | undefined, deviceSerialFilter: string | null | undefined, deviceNameFilter: string | null | undefined, deviceManufacturerFilter: string | null | undefined, deviceOSFilter: string | null | undefined, deviceOSVersionFilter: string | null | undefined, appNameFilter: string | null | undefined, appVersionFilter: string | null | undefined, appAreaFilter: string | null | undefined, actionInfoFilter: string | null | undefined, actionNameFilter: string | null | undefined, maxActionStartTimeFilter: moment.Moment | null | undefined, minActionStartTimeFilter: moment.Moment | null | undefined, maxActionEndTimeFilter: moment.Moment | null | undefined, minActionEndTimeFilter: moment.Moment | null | undefined, descriptionFilter: string | null | undefined): Observable<ConsumerDBFileDto> {
        let url_ = this.baseUrl + "/api/services/app/AppBehaviorLogs/GetAppBehaviorLogsToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (memberCodeFilter !== undefined)
            url_ += "MemberCodeFilter=" + encodeURIComponent("" + memberCodeFilter) + "&";
        if (deviceImeiFilter !== undefined)
            url_ += "DeviceImeiFilter=" + encodeURIComponent("" + deviceImeiFilter) + "&";
        if (deviceSerialFilter !== undefined)
            url_ += "DeviceSerialFilter=" + encodeURIComponent("" + deviceSerialFilter) + "&";
        if (deviceNameFilter !== undefined)
            url_ += "DeviceNameFilter=" + encodeURIComponent("" + deviceNameFilter) + "&";
        if (deviceManufacturerFilter !== undefined)
            url_ += "DeviceManufacturerFilter=" + encodeURIComponent("" + deviceManufacturerFilter) + "&";
        if (deviceOSFilter !== undefined)
            url_ += "DeviceOSFilter=" + encodeURIComponent("" + deviceOSFilter) + "&";
        if (deviceOSVersionFilter !== undefined)
            url_ += "DeviceOSVersionFilter=" + encodeURIComponent("" + deviceOSVersionFilter) + "&";
        if (appNameFilter !== undefined)
            url_ += "AppNameFilter=" + encodeURIComponent("" + appNameFilter) + "&";
        if (appVersionFilter !== undefined)
            url_ += "AppVersionFilter=" + encodeURIComponent("" + appVersionFilter) + "&";
        if (appAreaFilter !== undefined)
            url_ += "AppAreaFilter=" + encodeURIComponent("" + appAreaFilter) + "&";
        if (actionInfoFilter !== undefined)
            url_ += "ActionInfoFilter=" + encodeURIComponent("" + actionInfoFilter) + "&";
        if (actionNameFilter !== undefined)
            url_ += "ActionNameFilter=" + encodeURIComponent("" + actionNameFilter) + "&";
        if (maxActionStartTimeFilter !== undefined)
            url_ += "MaxActionStartTimeFilter=" + encodeURIComponent(maxActionStartTimeFilter ? "" + maxActionStartTimeFilter.toJSON() : "") + "&";
        if (minActionStartTimeFilter !== undefined)
            url_ += "MinActionStartTimeFilter=" + encodeURIComponent(minActionStartTimeFilter ? "" + minActionStartTimeFilter.toJSON() : "") + "&";
        if (maxActionEndTimeFilter !== undefined)
            url_ += "MaxActionEndTimeFilter=" + encodeURIComponent(maxActionEndTimeFilter ? "" + maxActionEndTimeFilter.toJSON() : "") + "&";
        if (minActionEndTimeFilter !== undefined)
            url_ += "MinActionEndTimeFilter=" + encodeURIComponent(minActionEndTimeFilter ? "" + minActionEndTimeFilter.toJSON() : "") + "&";
        if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAppBehaviorLogsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAppBehaviorLogsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<ConsumerDBFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ConsumerDBFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAppBehaviorLogsToExcel(response: HttpResponseBase): Observable<ConsumerDBFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? ConsumerDBFileDto.fromJS(resultData200) : new ConsumerDBFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ConsumerDBFileDto>(<any>null);
    }

    /**
     * @param inputs (optional) 
     * @return Success
     */
    log(inputs: LogInputDto[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AppBehaviorLogs/Log";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inputs);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processLog(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLog(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processLog(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class AppPushTransactionsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param senderFilter (optional) 
     * @param receiverFilter (optional) 
     * @param referenceCodeFilter (optional) 
     * @param contentFilter (optional) 
     * @param titleFilter (optional) 
     * @param statusFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, senderFilter: string | null | undefined, receiverFilter: string | null | undefined, referenceCodeFilter: string | null | undefined, contentFilter: string | null | undefined, titleFilter: string | null | undefined, statusFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetAppPushTransactionForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/AppPushTransactions/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (senderFilter !== undefined)
            url_ += "SenderFilter=" + encodeURIComponent("" + senderFilter) + "&";
        if (receiverFilter !== undefined)
            url_ += "ReceiverFilter=" + encodeURIComponent("" + receiverFilter) + "&";
        if (referenceCodeFilter !== undefined)
            url_ += "ReferenceCodeFilter=" + encodeURIComponent("" + referenceCodeFilter) + "&";
        if (contentFilter !== undefined)
            url_ += "ContentFilter=" + encodeURIComponent("" + contentFilter) + "&";
        if (titleFilter !== undefined)
            url_ += "TitleFilter=" + encodeURIComponent("" + titleFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetAppPushTransactionForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetAppPushTransactionForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetAppPushTransactionForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetAppPushTransactionForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetAppPushTransactionForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetAppPushTransactionForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getAppPushTransactionForEdit(id: number | null | undefined): Observable<GetAppPushTransactionForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/AppPushTransactions/GetAppPushTransactionForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAppPushTransactionForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAppPushTransactionForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetAppPushTransactionForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetAppPushTransactionForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetAppPushTransactionForEdit(response: HttpResponseBase): Observable<GetAppPushTransactionForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetAppPushTransactionForEditOutput.fromJS(resultData200) : new GetAppPushTransactionForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAppPushTransactionForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditAppPushTransactionDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AppPushTransactions/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AppPushTransactions/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    updateNotiToSeen(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/AppPushTransactions/UpdateNotiToSeen";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateNotiToSeen(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateNotiToSeen(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateNotiToSeen(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param memberCode (optional) 
     * @return Success
     */
    getCountNotificationUnreadAsync(memberCode: string | null | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/AppPushTransactions/GetCountNotificationUnreadAsync?";
        if (memberCode !== undefined)
            url_ += "memberCode=" + encodeURIComponent("" + memberCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCountNotificationUnreadAsync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCountNotificationUnreadAsync(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processGetCountNotificationUnreadAsync(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param memberCode (optional) 
     * @param statusFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getNotificationByMemberCodeAsync(memberCode: string | null | undefined, statusFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetListNotificationForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/AppPushTransactions/GetNotificationByMemberCodeAsync?";
        if (memberCode !== undefined)
            url_ += "MemberCode=" + encodeURIComponent("" + memberCode) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetNotificationByMemberCodeAsync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNotificationByMemberCodeAsync(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetListNotificationForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetListNotificationForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetNotificationByMemberCodeAsync(response: HttpResponseBase): Observable<PagedResultDtoOfGetListNotificationForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetListNotificationForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetListNotificationForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetListNotificationForViewDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    updateReadStatusAsync(input: UpdateReadStatus[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AppPushTransactions/UpdateReadStatusAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateReadStatusAsync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateReadStatusAsync(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateReadStatusAsync(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param memberCode (optional) 
     * @return Success
     */
    getTotalUnseenNotificationNoWrap(memberCode: string | null | undefined): Observable<UserNotificationUnseenCountDto> {
        let url_ = this.baseUrl + "/api/services/app/AppPushTransactions/GetTotalUnseenNotificationNoWrap?";
        if (memberCode !== undefined)
            url_ += "memberCode=" + encodeURIComponent("" + memberCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetTotalUnseenNotificationNoWrap(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTotalUnseenNotificationNoWrap(<any>response_);
                } catch (e) {
                    return <Observable<UserNotificationUnseenCountDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserNotificationUnseenCountDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetTotalUnseenNotificationNoWrap(response: HttpResponseBase): Observable<UserNotificationUnseenCountDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? UserNotificationUnseenCountDto.fromJS(resultData200) : new UserNotificationUnseenCountDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserNotificationUnseenCountDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    markAsSeenUserNotificationNoWrap(input: MarkAsSeenUserNotificationInput | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AppPushTransactions/MarkAsSeenUserNotificationNoWrap";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processMarkAsSeenUserNotificationNoWrap(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkAsSeenUserNotificationNoWrap(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processMarkAsSeenUserNotificationNoWrap(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param memberCode (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getUserNotificationNoWrap(memberCode: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfUserNotificationDto> {
        let url_ = this.baseUrl + "/api/services/app/AppPushTransactions/GetUserNotificationNoWrap?";
        if (memberCode !== undefined)
            url_ += "MemberCode=" + encodeURIComponent("" + memberCode) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetUserNotificationNoWrap(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserNotificationNoWrap(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfUserNotificationDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfUserNotificationDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserNotificationNoWrap(response: HttpResponseBase): Observable<PagedResultDtoOfUserNotificationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfUserNotificationDto.fromJS(resultData200) : new PagedResultDtoOfUserNotificationDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfUserNotificationDto>(<any>null);
    }

    /**
     * @param memberCode (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getUserNotificationAsync(memberCode: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfUserNotificationDto> {
        let url_ = this.baseUrl + "/api/services/app/AppPushTransactions/GetUserNotificationAsync?";
        if (memberCode !== undefined)
            url_ += "MemberCode=" + encodeURIComponent("" + memberCode) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetUserNotificationAsync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserNotificationAsync(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfUserNotificationDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfUserNotificationDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserNotificationAsync(response: HttpResponseBase): Observable<PagedResultDtoOfUserNotificationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfUserNotificationDto.fromJS(resultData200) : new PagedResultDtoOfUserNotificationDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfUserNotificationDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    markAsSeenUserNotificationAsync(input: MarkAsSeenUserNotificationInput | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AppPushTransactions/MarkAsSeenUserNotificationAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processMarkAsSeenUserNotificationAsync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkAsSeenUserNotificationAsync(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processMarkAsSeenUserNotificationAsync(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class ArticleServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param statusFilter (optional) 
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param tagsFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, statusFilter: string | null | undefined, fromDate: moment.Moment | null | undefined, toDate: moment.Moment | null | undefined, tagsFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetArticleForView> {
        let url_ = this.baseUrl + "/api/services/app/Article/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toJSON() : "") + "&";
        if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toJSON() : "") + "&";
        if (tagsFilter !== undefined)
            url_ += "TagsFilter=" + encodeURIComponent("" + tagsFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetArticleForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetArticleForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetArticleForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetArticleForView.fromJS(resultData200) : new PagedResultDtoOfGetArticleForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetArticleForView>(<any>null);
    }

    /**
     * @param articleCategoryCodeFilter (optional) 
     * @param articleStatusFilter (optional) 
     * @param typeArrticleCategoryFilter (optional) 
     * @param isUpcomming (optional) 
     * @param articleCodeFilter (optional) 
     * @param articleCategoryStatusFilter (optional) 
     * @param memberCode (optional) 
     * @param tagFilter (optional) 
     * @param date (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getListArticle(articleCategoryCodeFilter: string | null | undefined, articleStatusFilter: string | null | undefined, typeArrticleCategoryFilter: string | null | undefined, isUpcomming: boolean | null | undefined, articleCodeFilter: string | null | undefined, articleCategoryStatusFilter: string | null | undefined, memberCode: string | null | undefined, tagFilter: string | null | undefined, date: moment.Moment | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetListArticleForView> {
        let url_ = this.baseUrl + "/api/services/app/Article/GetListArticle?";
        if (articleCategoryCodeFilter !== undefined)
            url_ += "ArticleCategoryCodeFilter=" + encodeURIComponent("" + articleCategoryCodeFilter) + "&";
        if (articleStatusFilter !== undefined)
            url_ += "ArticleStatusFilter=" + encodeURIComponent("" + articleStatusFilter) + "&";
        if (typeArrticleCategoryFilter !== undefined)
            url_ += "TypeArrticleCategoryFilter=" + encodeURIComponent("" + typeArrticleCategoryFilter) + "&";
        if (isUpcomming !== undefined)
            url_ += "IsUpcomming=" + encodeURIComponent("" + isUpcomming) + "&";
        if (articleCodeFilter !== undefined)
            url_ += "ArticleCodeFilter=" + encodeURIComponent("" + articleCodeFilter) + "&";
        if (articleCategoryStatusFilter !== undefined)
            url_ += "ArticleCategoryStatusFilter=" + encodeURIComponent("" + articleCategoryStatusFilter) + "&";
        if (memberCode !== undefined)
            url_ += "MemberCode=" + encodeURIComponent("" + memberCode) + "&";
        if (tagFilter !== undefined)
            url_ += "TagFilter=" + encodeURIComponent("" + tagFilter) + "&";
        if (date !== undefined)
            url_ += "Date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetListArticle(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetListArticle(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetListArticleForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetListArticleForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetListArticle(response: HttpResponseBase): Observable<PagedResultDtoOfGetListArticleForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetListArticleForView.fromJS(resultData200) : new PagedResultDtoOfGetListArticleForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetListArticleForView>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getArticleForEdit(id: number | null | undefined): Observable<GetArticleForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Article/GetArticleForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetArticleForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetArticleForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetArticleForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetArticleForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetArticleForEdit(response: HttpResponseBase): Observable<GetArticleForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetArticleForEditOutput.fromJS(resultData200) : new GetArticleForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetArticleForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: ArticleDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Article/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    clone(input: CloneArticleDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Article/Clone";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processClone(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClone(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processClone(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    search(input: GetAllArticleInput | null | undefined): Observable<PagedResultDtoOfGetArticleForView> {
        let url_ = this.baseUrl + "/api/services/app/Article/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetArticleForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetArticleForView>><any>_observableThrow(response_);
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<PagedResultDtoOfGetArticleForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetArticleForView.fromJS(resultData200) : new PagedResultDtoOfGetArticleForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetArticleForView>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getArticleForViewOrEditAsync(id: number | null | undefined): Observable<ArticleForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Article/GetArticleForViewOrEditAsync?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetArticleForViewOrEditAsync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetArticleForViewOrEditAsync(<any>response_);
                } catch (e) {
                    return <Observable<ArticleForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ArticleForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetArticleForViewOrEditAsync(response: HttpResponseBase): Observable<ArticleForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? ArticleForViewDto.fromJS(resultData200) : new ArticleForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ArticleForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getArticleForViewOnly(id: number | null | undefined): Observable<GetArticleForView> {
        let url_ = this.baseUrl + "/api/services/app/Article/GetArticleForViewOnly?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetArticleForViewOnly(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetArticleForViewOnly(<any>response_);
                } catch (e) {
                    return <Observable<GetArticleForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetArticleForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetArticleForViewOnly(response: HttpResponseBase): Observable<GetArticleForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetArticleForView.fromJS(resultData200) : new GetArticleForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetArticleForView>(<any>null);
    }

    /**
     * @param tag (optional) 
     * @return Success
     */
    getArticleByTagForMemberAppAsync(tag: string | null | undefined): Observable<GetArticleForView> {
        let url_ = this.baseUrl + "/api/services/app/Article/GetArticleByTagForMemberAppAsync?";
        if (tag !== undefined)
            url_ += "tag=" + encodeURIComponent("" + tag) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetArticleByTagForMemberAppAsync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetArticleByTagForMemberAppAsync(<any>response_);
                } catch (e) {
                    return <Observable<GetArticleForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetArticleForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetArticleByTagForMemberAppAsync(response: HttpResponseBase): Observable<GetArticleForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetArticleForView.fromJS(resultData200) : new GetArticleForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetArticleForView>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getArticleForViewOrEditExtAsync(id: number | null | undefined): Observable<GetArticleForView> {
        let url_ = this.baseUrl + "/api/services/app/Article/GetArticleForViewOrEditExtAsync?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetArticleForViewOrEditExtAsync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetArticleForViewOrEditExtAsync(<any>response_);
                } catch (e) {
                    return <Observable<GetArticleForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetArticleForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetArticleForViewOrEditExtAsync(response: HttpResponseBase): Observable<GetArticleForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetArticleForView.fromJS(resultData200) : new GetArticleForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetArticleForView>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getArticleForViewOrEditExtFreeAsync(id: number | null | undefined): Observable<GetArticleForView> {
        let url_ = this.baseUrl + "/api/services/app/Article/GetArticleForViewOrEditExtFreeAsync?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetArticleForViewOrEditExtFreeAsync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetArticleForViewOrEditExtFreeAsync(<any>response_);
                } catch (e) {
                    return <Observable<GetArticleForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetArticleForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetArticleForViewOrEditExtFreeAsync(response: HttpResponseBase): Observable<GetArticleForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetArticleForView.fromJS(resultData200) : new GetArticleForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetArticleForView>(<any>null);
    }

    /**
     * @return Success
     */
    getLinkLoyaltyWebArticle(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Article/GetLinkLoyaltyWebArticle";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetLinkLoyaltyWebArticle(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLinkLoyaltyWebArticle(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetLinkLoyaltyWebArticle(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param type (optional) 
     * @return Success
     */
    getTargetAudiences(type: string | null | undefined): Observable<GetTargetAudienceForViewArticleDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Article/GetTargetAudiences?";
        if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetTargetAudiences(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTargetAudiences(<any>response_);
                } catch (e) {
                    return <Observable<GetTargetAudienceForViewArticleDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetTargetAudienceForViewArticleDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetTargetAudiences(response: HttpResponseBase): Observable<GetTargetAudienceForViewArticleDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(GetTargetAudienceForViewArticleDto.fromJS(item));
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTargetAudienceForViewArticleDto[]>(<any>null);
    }

    /**
     * @param args (optional) 
     * @return Success
     */
    importQueue(args: ArticleInfoAgrs | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Article/ImportQueue";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(args);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processImportQueue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportQueue(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processImportQueue(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEditAsync(input: ArticleDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Article/CreateOrEditAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEditAsync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditAsync(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEditAsync(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param listId (optional) 
     * @return Success
     */
    batchDeleteAsync(listId: DeleteArticleDto | null | undefined): Observable<MessageResultCMS> {
        let url_ = this.baseUrl + "/api/services/app/Article/BatchDeleteAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listId);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processBatchDeleteAsync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBatchDeleteAsync(<any>response_);
                } catch (e) {
                    return <Observable<MessageResultCMS>><any>_observableThrow(e);
                }
            } else
                return <Observable<MessageResultCMS>><any>_observableThrow(response_);
        }));
    }

    protected processBatchDeleteAsync(response: HttpResponseBase): Observable<MessageResultCMS> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? MessageResultCMS.fromJS(resultData200) : new MessageResultCMS();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MessageResultCMS>(<any>null);
    }
}

@Injectable()
export class ArticleTargetAudienceDetailsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param maxArticleTargetAudienceIDFilter (optional) 
     * @param minArticleTargetAudienceIDFilter (optional) 
     * @param nameFilter (optional) 
     * @param phoneFilter (optional) 
     * @param zaloChatIDFilter (optional) 
     * @param emailFilter (optional) 
     * @param facebookIDFilter (optional) 
     * @param memberCodeFilter (optional) 
     * @param communicationLanguageFilter (optional) 
     * @param communicationChannelFilter (optional) 
     * @param outletCodeFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, maxArticleTargetAudienceIDFilter: number | null | undefined, minArticleTargetAudienceIDFilter: number | null | undefined, nameFilter: string | null | undefined, phoneFilter: string | null | undefined, zaloChatIDFilter: string | null | undefined, emailFilter: string | null | undefined, facebookIDFilter: string | null | undefined, memberCodeFilter: string | null | undefined, communicationLanguageFilter: string | null | undefined, communicationChannelFilter: string | null | undefined, outletCodeFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetArticleTargetAudienceDetailForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/ArticleTargetAudienceDetails/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxArticleTargetAudienceIDFilter !== undefined)
            url_ += "MaxArticleTargetAudienceIDFilter=" + encodeURIComponent("" + maxArticleTargetAudienceIDFilter) + "&";
        if (minArticleTargetAudienceIDFilter !== undefined)
            url_ += "MinArticleTargetAudienceIDFilter=" + encodeURIComponent("" + minArticleTargetAudienceIDFilter) + "&";
        if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (phoneFilter !== undefined)
            url_ += "PhoneFilter=" + encodeURIComponent("" + phoneFilter) + "&";
        if (zaloChatIDFilter !== undefined)
            url_ += "ZaloChatIDFilter=" + encodeURIComponent("" + zaloChatIDFilter) + "&";
        if (emailFilter !== undefined)
            url_ += "EmailFilter=" + encodeURIComponent("" + emailFilter) + "&";
        if (facebookIDFilter !== undefined)
            url_ += "FacebookIDFilter=" + encodeURIComponent("" + facebookIDFilter) + "&";
        if (memberCodeFilter !== undefined)
            url_ += "MemberCodeFilter=" + encodeURIComponent("" + memberCodeFilter) + "&";
        if (communicationLanguageFilter !== undefined)
            url_ += "CommunicationLanguageFilter=" + encodeURIComponent("" + communicationLanguageFilter) + "&";
        if (communicationChannelFilter !== undefined)
            url_ += "CommunicationChannelFilter=" + encodeURIComponent("" + communicationChannelFilter) + "&";
        if (outletCodeFilter !== undefined)
            url_ += "OutletCodeFilter=" + encodeURIComponent("" + outletCodeFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetArticleTargetAudienceDetailForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetArticleTargetAudienceDetailForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetArticleTargetAudienceDetailForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetArticleTargetAudienceDetailForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetArticleTargetAudienceDetailForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetArticleTargetAudienceDetailForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getArticleTargetAudienceDetailForEdit(id: number | null | undefined): Observable<GetArticleTargetAudienceDetailForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/ArticleTargetAudienceDetails/GetArticleTargetAudienceDetailForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetArticleTargetAudienceDetailForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetArticleTargetAudienceDetailForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetArticleTargetAudienceDetailForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetArticleTargetAudienceDetailForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetArticleTargetAudienceDetailForEdit(response: HttpResponseBase): Observable<GetArticleTargetAudienceDetailForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetArticleTargetAudienceDetailForEditOutput.fromJS(resultData200) : new GetArticleTargetAudienceDetailForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetArticleTargetAudienceDetailForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditArticleTargetAudienceDetailDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ArticleTargetAudienceDetails/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ArticleTargetAudienceDetails/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class ArticleTargetAudiencesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param targetAudienceNameFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param statusFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, targetAudienceNameFilter: string | null | undefined, descriptionFilter: string | null | undefined, statusFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetArticleTargetAudienceForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/ArticleTargetAudiences/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (targetAudienceNameFilter !== undefined)
            url_ += "TargetAudienceNameFilter=" + encodeURIComponent("" + targetAudienceNameFilter) + "&";
        if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetArticleTargetAudienceForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetArticleTargetAudienceForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetArticleTargetAudienceForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetArticleTargetAudienceForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetArticleTargetAudienceForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetArticleTargetAudienceForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getArticleTargetAudienceForEdit(id: number | null | undefined): Observable<GetArticleTargetAudienceForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/ArticleTargetAudiences/GetArticleTargetAudienceForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetArticleTargetAudienceForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetArticleTargetAudienceForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetArticleTargetAudienceForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetArticleTargetAudienceForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetArticleTargetAudienceForEdit(response: HttpResponseBase): Observable<GetArticleTargetAudienceForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetArticleTargetAudienceForEditOutput.fromJS(resultData200) : new GetArticleTargetAudienceForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetArticleTargetAudienceForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditArticleTargetAudienceDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ArticleTargetAudiences/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ArticleTargetAudiences/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class ArticleUsersServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param memberCodeFilter (optional) 
     * @param articleCodeFilter (optional) 
     * @param categoryCodeFilter (optional) 
     * @param maxCategoryTypeFilter (optional) 
     * @param minCategoryTypeFilter (optional) 
     * @param statusFilter (optional) 
     * @param isUpcomming (optional) 
     * @param language (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, memberCodeFilter: string | null | undefined, articleCodeFilter: string | null | undefined, categoryCodeFilter: string | null | undefined, maxCategoryTypeFilter: number | null | undefined, minCategoryTypeFilter: number | null | undefined, statusFilter: string | null | undefined, isUpcomming: boolean | null | undefined, language: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetArticleUserForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/ArticleUsers/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (memberCodeFilter !== undefined)
            url_ += "MemberCodeFilter=" + encodeURIComponent("" + memberCodeFilter) + "&";
        if (articleCodeFilter !== undefined)
            url_ += "ArticleCodeFilter=" + encodeURIComponent("" + articleCodeFilter) + "&";
        if (categoryCodeFilter !== undefined)
            url_ += "CategoryCodeFilter=" + encodeURIComponent("" + categoryCodeFilter) + "&";
        if (maxCategoryTypeFilter !== undefined)
            url_ += "MaxCategoryTypeFilter=" + encodeURIComponent("" + maxCategoryTypeFilter) + "&";
        if (minCategoryTypeFilter !== undefined)
            url_ += "MinCategoryTypeFilter=" + encodeURIComponent("" + minCategoryTypeFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (isUpcomming !== undefined)
            url_ += "IsUpcomming=" + encodeURIComponent("" + isUpcomming) + "&";
        if (language !== undefined)
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetArticleUserForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetArticleUserForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetArticleUserForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetArticleUserForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetArticleUserForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetArticleUserForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getArticleUserForEdit(id: number | null | undefined): Observable<GetArticleUserForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/ArticleUsers/GetArticleUserForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetArticleUserForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetArticleUserForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetArticleUserForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetArticleUserForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetArticleUserForEdit(response: HttpResponseBase): Observable<GetArticleUserForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetArticleUserForEditOutput.fromJS(resultData200) : new GetArticleUserForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetArticleUserForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditArticleUserDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ArticleUsers/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: CreateOrEditArticleUserDto | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/ArticleUsers/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ArticleUsers/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param memberCodeFilter (optional) 
     * @param articleCodeFilter (optional) 
     * @param categoryCodeFilter (optional) 
     * @param maxCategoryTypeFilter (optional) 
     * @param minCategoryTypeFilter (optional) 
     * @param statusFilter (optional) 
     * @return Success
     */
    getArticleUsersToExcel(filter: string | null | undefined, memberCodeFilter: string | null | undefined, articleCodeFilter: string | null | undefined, categoryCodeFilter: string | null | undefined, maxCategoryTypeFilter: number | null | undefined, minCategoryTypeFilter: number | null | undefined, statusFilter: string | null | undefined): Observable<CMSFileDto> {
        let url_ = this.baseUrl + "/api/services/app/ArticleUsers/GetArticleUsersToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (memberCodeFilter !== undefined)
            url_ += "MemberCodeFilter=" + encodeURIComponent("" + memberCodeFilter) + "&";
        if (articleCodeFilter !== undefined)
            url_ += "ArticleCodeFilter=" + encodeURIComponent("" + articleCodeFilter) + "&";
        if (categoryCodeFilter !== undefined)
            url_ += "CategoryCodeFilter=" + encodeURIComponent("" + categoryCodeFilter) + "&";
        if (maxCategoryTypeFilter !== undefined)
            url_ += "MaxCategoryTypeFilter=" + encodeURIComponent("" + maxCategoryTypeFilter) + "&";
        if (minCategoryTypeFilter !== undefined)
            url_ += "MinCategoryTypeFilter=" + encodeURIComponent("" + minCategoryTypeFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetArticleUsersToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetArticleUsersToExcel(<any>response_);
                } catch (e) {
                    return <Observable<CMSFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CMSFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetArticleUsersToExcel(response: HttpResponseBase): Observable<CMSFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? CMSFileDto.fromJS(resultData200) : new CMSFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CMSFileDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    bookmarkAsync(input: GetAllArticleUsersForBookmarkInput | null | undefined): Observable<PagedResultDtoOfGetArticleUserForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/ArticleUsers/BookmarkAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processBookmarkAsync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBookmarkAsync(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetArticleUserForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetArticleUserForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processBookmarkAsync(response: HttpResponseBase): Observable<PagedResultDtoOfGetArticleUserForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetArticleUserForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetArticleUserForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetArticleUserForViewDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    updateStatusBookmarkAsync(input: UpdateStatusBookmarkInput | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ArticleUsers/UpdateStatusBookmarkAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateStatusBookmarkAsync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateStatusBookmarkAsync(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateStatusBookmarkAsync(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class AuditLogServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param userName (optional) 
     * @param serviceName (optional) 
     * @param methodName (optional) 
     * @param browserInfo (optional) 
     * @param hasException (optional) 
     * @param minExecutionDuration (optional) 
     * @param maxExecutionDuration (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getAuditLogs(startDate: moment.Moment | null | undefined, endDate: moment.Moment | null | undefined, userName: string | null | undefined, serviceName: string | null | undefined, methodName: string | null | undefined, browserInfo: string | null | undefined, hasException: boolean | null | undefined, minExecutionDuration: number | null | undefined, maxExecutionDuration: number | null | undefined, sorting: string | null | undefined, maxResultCount: number | null | undefined, skipCount: number | null | undefined): Observable<PagedResultDtoOfAuditLogListDto> {
        let url_ = this.baseUrl + "/api/services/app/AuditLog/GetAuditLogs?";
        if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&";
        if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&";
        if (userName !== undefined)
            url_ += "UserName=" + encodeURIComponent("" + userName) + "&";
        if (serviceName !== undefined)
            url_ += "ServiceName=" + encodeURIComponent("" + serviceName) + "&";
        if (methodName !== undefined)
            url_ += "MethodName=" + encodeURIComponent("" + methodName) + "&";
        if (browserInfo !== undefined)
            url_ += "BrowserInfo=" + encodeURIComponent("" + browserInfo) + "&";
        if (hasException !== undefined)
            url_ += "HasException=" + encodeURIComponent("" + hasException) + "&";
        if (minExecutionDuration !== undefined)
            url_ += "MinExecutionDuration=" + encodeURIComponent("" + minExecutionDuration) + "&";
        if (maxExecutionDuration !== undefined)
            url_ += "MaxExecutionDuration=" + encodeURIComponent("" + maxExecutionDuration) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAuditLogs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAuditLogs(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfAuditLogListDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfAuditLogListDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAuditLogs(response: HttpResponseBase): Observable<PagedResultDtoOfAuditLogListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfAuditLogListDto.fromJS(resultData200) : new PagedResultDtoOfAuditLogListDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfAuditLogListDto>(<any>null);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param userName (optional) 
     * @param serviceName (optional) 
     * @param methodName (optional) 
     * @param browserInfo (optional) 
     * @param hasException (optional) 
     * @param minExecutionDuration (optional) 
     * @param maxExecutionDuration (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getAuditLogsToExcel(startDate: moment.Moment | null | undefined, endDate: moment.Moment | null | undefined, userName: string | null | undefined, serviceName: string | null | undefined, methodName: string | null | undefined, browserInfo: string | null | undefined, hasException: boolean | null | undefined, minExecutionDuration: number | null | undefined, maxExecutionDuration: number | null | undefined, sorting: string | null | undefined, maxResultCount: number | null | undefined, skipCount: number | null | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/AuditLog/GetAuditLogsToExcel?";
        if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&";
        if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&";
        if (userName !== undefined)
            url_ += "UserName=" + encodeURIComponent("" + userName) + "&";
        if (serviceName !== undefined)
            url_ += "ServiceName=" + encodeURIComponent("" + serviceName) + "&";
        if (methodName !== undefined)
            url_ += "MethodName=" + encodeURIComponent("" + methodName) + "&";
        if (browserInfo !== undefined)
            url_ += "BrowserInfo=" + encodeURIComponent("" + browserInfo) + "&";
        if (hasException !== undefined)
            url_ += "HasException=" + encodeURIComponent("" + hasException) + "&";
        if (minExecutionDuration !== undefined)
            url_ += "MinExecutionDuration=" + encodeURIComponent("" + minExecutionDuration) + "&";
        if (maxExecutionDuration !== undefined)
            url_ += "MaxExecutionDuration=" + encodeURIComponent("" + maxExecutionDuration) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAuditLogsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAuditLogsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAuditLogsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @return Success
     */
    getEntityHistoryObjectTypes(): Observable<NameValueDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AuditLog/GetEntityHistoryObjectTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetEntityHistoryObjectTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEntityHistoryObjectTypes(<any>response_);
                } catch (e) {
                    return <Observable<NameValueDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<NameValueDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetEntityHistoryObjectTypes(response: HttpResponseBase): Observable<NameValueDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(NameValueDto.fromJS(item));
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NameValueDto[]>(<any>null);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param userName (optional) 
     * @param entityTypeFullName (optional) 
     * @param changeType (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getEntityChanges(startDate: moment.Moment | null | undefined, endDate: moment.Moment | null | undefined, userName: string | null | undefined, entityTypeFullName: string | null | undefined, changeType: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | null | undefined, skipCount: number | null | undefined): Observable<PagedResultDtoOfEntityChangeListDto> {
        let url_ = this.baseUrl + "/api/services/app/AuditLog/GetEntityChanges?";
        if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&";
        if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&";
        if (userName !== undefined)
            url_ += "UserName=" + encodeURIComponent("" + userName) + "&";
        if (entityTypeFullName !== undefined)
            url_ += "EntityTypeFullName=" + encodeURIComponent("" + entityTypeFullName) + "&";
        if (changeType !== undefined)
            url_ += "ChangeType=" + encodeURIComponent("" + changeType) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetEntityChanges(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEntityChanges(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfEntityChangeListDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfEntityChangeListDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetEntityChanges(response: HttpResponseBase): Observable<PagedResultDtoOfEntityChangeListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfEntityChangeListDto.fromJS(resultData200) : new PagedResultDtoOfEntityChangeListDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfEntityChangeListDto>(<any>null);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param userName (optional) 
     * @param entityTypeFullName (optional) 
     * @param changeType (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getEntityChangesToExcel(startDate: moment.Moment | null | undefined, endDate: moment.Moment | null | undefined, userName: string | null | undefined, entityTypeFullName: string | null | undefined, changeType: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | null | undefined, skipCount: number | null | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/AuditLog/GetEntityChangesToExcel?";
        if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&";
        if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&";
        if (userName !== undefined)
            url_ += "UserName=" + encodeURIComponent("" + userName) + "&";
        if (entityTypeFullName !== undefined)
            url_ += "EntityTypeFullName=" + encodeURIComponent("" + entityTypeFullName) + "&";
        if (changeType !== undefined)
            url_ += "ChangeType=" + encodeURIComponent("" + changeType) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetEntityChangesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEntityChangesToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetEntityChangesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param userName (optional) 
     * @param entityTypeFullName (optional) 
     * @param changeType (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getEntityChangesWithPropertyToExcel(startDate: moment.Moment | null | undefined, endDate: moment.Moment | null | undefined, userName: string | null | undefined, entityTypeFullName: string | null | undefined, changeType: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | null | undefined, skipCount: number | null | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/AuditLog/GetEntityChangesWithPropertyToExcel?";
        if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&";
        if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&";
        if (userName !== undefined)
            url_ += "UserName=" + encodeURIComponent("" + userName) + "&";
        if (entityTypeFullName !== undefined)
            url_ += "EntityTypeFullName=" + encodeURIComponent("" + entityTypeFullName) + "&";
        if (changeType !== undefined)
            url_ += "ChangeType=" + encodeURIComponent("" + changeType) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetEntityChangesWithPropertyToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEntityChangesWithPropertyToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetEntityChangesWithPropertyToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param entityChangeId (optional) 
     * @return Success
     */
    getEntityPropertyChanges(entityChangeId: number | null | undefined): Observable<EntityPropertyChangeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AuditLog/GetEntityPropertyChanges?";
        if (entityChangeId !== undefined)
            url_ += "entityChangeId=" + encodeURIComponent("" + entityChangeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetEntityPropertyChanges(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEntityPropertyChanges(<any>response_);
                } catch (e) {
                    return <Observable<EntityPropertyChangeDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<EntityPropertyChangeDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetEntityPropertyChanges(response: HttpResponseBase): Observable<EntityPropertyChangeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(EntityPropertyChangeDto.fromJS(item));
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EntityPropertyChangeDto[]>(<any>null);
    }
}

@Injectable()
export class AutoReplySettingsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param keywordsFilter (optional) 
     * @param contentFilter (optional) 
     * @param statusFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, nameFilter: string | null | undefined, keywordsFilter: string | null | undefined, contentFilter: string | null | undefined, statusFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetAutoReplySettingForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/AutoReplySettings/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (keywordsFilter !== undefined)
            url_ += "KeywordsFilter=" + encodeURIComponent("" + keywordsFilter) + "&";
        if (contentFilter !== undefined)
            url_ += "ContentFilter=" + encodeURIComponent("" + contentFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetAutoReplySettingForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetAutoReplySettingForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetAutoReplySettingForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetAutoReplySettingForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetAutoReplySettingForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetAutoReplySettingForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getAutoReplySettingForEdit(id: number | null | undefined): Observable<GetAutoReplySettingForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/AutoReplySettings/GetAutoReplySettingForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAutoReplySettingForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAutoReplySettingForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetAutoReplySettingForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetAutoReplySettingForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetAutoReplySettingForEdit(response: HttpResponseBase): Observable<GetAutoReplySettingForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetAutoReplySettingForEditOutput.fromJS(resultData200) : new GetAutoReplySettingForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAutoReplySettingForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditAutoReplySettingDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AutoReplySettings/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AutoReplySettings/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param keywordsFilter (optional) 
     * @param contentFilter (optional) 
     * @param statusFilter (optional) 
     * @return Success
     */
    getAutoReplySettingsToExcel(filter: string | null | undefined, nameFilter: string | null | undefined, keywordsFilter: string | null | undefined, contentFilter: string | null | undefined, statusFilter: string | null | undefined): Observable<SocialRetailerFileDto> {
        let url_ = this.baseUrl + "/api/services/app/AutoReplySettings/GetAutoReplySettingsToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (keywordsFilter !== undefined)
            url_ += "KeywordsFilter=" + encodeURIComponent("" + keywordsFilter) + "&";
        if (contentFilter !== undefined)
            url_ += "ContentFilter=" + encodeURIComponent("" + contentFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAutoReplySettingsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAutoReplySettingsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<SocialRetailerFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SocialRetailerFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAutoReplySettingsToExcel(response: HttpResponseBase): Observable<SocialRetailerFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? SocialRetailerFileDto.fromJS(resultData200) : new SocialRetailerFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SocialRetailerFileDto>(<any>null);
    }

    /**
     * @return Success
     */
    getToken(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/AutoReplySettings/GetToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetToken(<any>response_);
                } catch (e) {
                    return <Observable<string[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<string[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetToken(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(item);
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string[]>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getAutoReplySettingForEditExt(id: number | null | undefined): Observable<GetAutoReplySettingForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/AutoReplySettings/GetAutoReplySettingForEditExt?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAutoReplySettingForEditExt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAutoReplySettingForEditExt(<any>response_);
                } catch (e) {
                    return <Observable<GetAutoReplySettingForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetAutoReplySettingForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetAutoReplySettingForEditExt(response: HttpResponseBase): Observable<GetAutoReplySettingForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetAutoReplySettingForEditOutput.fromJS(resultData200) : new GetAutoReplySettingForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAutoReplySettingForEditOutput>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param keywordsFilter (optional) 
     * @param contentFilter (optional) 
     * @param statusFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllExt(filter: string | null | undefined, nameFilter: string | null | undefined, keywordsFilter: string | null | undefined, contentFilter: string | null | undefined, statusFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetAutoReplySettingForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/AutoReplySettings/GetAllExt?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (keywordsFilter !== undefined)
            url_ += "KeywordsFilter=" + encodeURIComponent("" + keywordsFilter) + "&";
        if (contentFilter !== undefined)
            url_ += "ContentFilter=" + encodeURIComponent("" + contentFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllExt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllExt(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetAutoReplySettingForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetAutoReplySettingForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllExt(response: HttpResponseBase): Observable<PagedResultDtoOfGetAutoReplySettingForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetAutoReplySettingForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetAutoReplySettingForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetAutoReplySettingForViewDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEditExt(input: CreateOrEditAutoReplySettingDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AutoReplySettings/CreateOrEditExt";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEditExt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditExt(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEditExt(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteExt(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AutoReplySettings/DeleteExt?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteExt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteExt(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteExt(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param keyword (optional) 
     * @return Success
     */
    checkKeywordsAsync(keyword: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/AutoReplySettings/CheckKeywordsAsync?";
        if (keyword !== undefined)
            url_ += "keyword=" + encodeURIComponent("" + keyword) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCheckKeywordsAsync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckKeywordsAsync(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processCheckKeywordsAsync(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param arg (optional) 
     * @return Success
     */
    importKeyWords(arg: AutoReplySettingImportAgrs | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AutoReplySettings/ImportKeyWords";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(arg);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processImportKeyWords(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportKeyWords(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processImportKeyWords(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class BaseLineRedeemServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    processCoin(input: BaseLineInput | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BaseLineRedeem/ProcessCoin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processProcessCoin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProcessCoin(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processProcessCoin(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    addCoin(input: BaseLineInput | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BaseLineRedeem/AddCoin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processAddCoin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddCoin(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processAddCoin(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    revokeCoin(input: BaseLineInput | null | undefined): Observable<RevokeBaseLineOutput> {
        let url_ = this.baseUrl + "/api/services/app/BaseLineRedeem/RevokeCoin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processRevokeCoin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRevokeCoin(<any>response_);
                } catch (e) {
                    return <Observable<RevokeBaseLineOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<RevokeBaseLineOutput>><any>_observableThrow(response_);
        }));
    }

    protected processRevokeCoin(response: HttpResponseBase): Observable<RevokeBaseLineOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? RevokeBaseLineOutput.fromJS(resultData200) : new RevokeBaseLineOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RevokeBaseLineOutput>(<any>null);
    }
}

@Injectable()
export class BaseSettingsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param codeFilter (optional) 
     * @param nameFilter (optional) 
     * @param maxEffectiveFromFilter (optional) 
     * @param minEffectiveFromFilter (optional) 
     * @param maxEffectiveToFilter (optional) 
     * @param minEffectiveToFilter (optional) 
     * @param isActiveFilter (optional) 
     * @param targetAudienceCodeFilter (optional) 
     * @param campaignCodeFilter (optional) 
     * @param targetAudienceNameFilter (optional) 
     * @param campaignNameFilter (optional) 
     * @param type (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, codeFilter: string | null | undefined, nameFilter: string | null | undefined, maxEffectiveFromFilter: moment.Moment | null | undefined, minEffectiveFromFilter: moment.Moment | null | undefined, maxEffectiveToFilter: moment.Moment | null | undefined, minEffectiveToFilter: moment.Moment | null | undefined, isActiveFilter: number | null | undefined, targetAudienceCodeFilter: string | null | undefined, campaignCodeFilter: string | null | undefined, targetAudienceNameFilter: string | null | undefined, campaignNameFilter: string | null | undefined, type: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetBaseSettingForView> {
        let url_ = this.baseUrl + "/api/services/app/BaseSettings/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&";
        if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (maxEffectiveFromFilter !== undefined)
            url_ += "MaxEffectiveFromFilter=" + encodeURIComponent(maxEffectiveFromFilter ? "" + maxEffectiveFromFilter.toJSON() : "") + "&";
        if (minEffectiveFromFilter !== undefined)
            url_ += "MinEffectiveFromFilter=" + encodeURIComponent(minEffectiveFromFilter ? "" + minEffectiveFromFilter.toJSON() : "") + "&";
        if (maxEffectiveToFilter !== undefined)
            url_ += "MaxEffectiveToFilter=" + encodeURIComponent(maxEffectiveToFilter ? "" + maxEffectiveToFilter.toJSON() : "") + "&";
        if (minEffectiveToFilter !== undefined)
            url_ += "MinEffectiveToFilter=" + encodeURIComponent(minEffectiveToFilter ? "" + minEffectiveToFilter.toJSON() : "") + "&";
        if (isActiveFilter !== undefined)
            url_ += "IsActiveFilter=" + encodeURIComponent("" + isActiveFilter) + "&";
        if (targetAudienceCodeFilter !== undefined)
            url_ += "TargetAudienceCodeFilter=" + encodeURIComponent("" + targetAudienceCodeFilter) + "&";
        if (campaignCodeFilter !== undefined)
            url_ += "CampaignCodeFilter=" + encodeURIComponent("" + campaignCodeFilter) + "&";
        if (targetAudienceNameFilter !== undefined)
            url_ += "TargetAudienceNameFilter=" + encodeURIComponent("" + targetAudienceNameFilter) + "&";
        if (campaignNameFilter !== undefined)
            url_ += "CampaignNameFilter=" + encodeURIComponent("" + campaignNameFilter) + "&";
        if (type !== undefined)
            url_ += "Type=" + encodeURIComponent("" + type) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetBaseSettingForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetBaseSettingForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetBaseSettingForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetBaseSettingForView.fromJS(resultData200) : new PagedResultDtoOfGetBaseSettingForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetBaseSettingForView>(<any>null);
    }

    /**
     * @param isActiveFilter (optional) 
     * @param campainId (optional) 
     * @param type (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllSettingParamsFields(isActiveFilter: number | null | undefined, campainId: number | null | undefined, type: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<ListResultDtoOfBaseSettingDto> {
        let url_ = this.baseUrl + "/api/services/app/BaseSettings/GetAllSettingParamsFields?";
        if (isActiveFilter !== undefined)
            url_ += "IsActiveFilter=" + encodeURIComponent("" + isActiveFilter) + "&";
        if (campainId !== undefined)
            url_ += "CampainId=" + encodeURIComponent("" + campainId) + "&";
        if (type !== undefined)
            url_ += "Type=" + encodeURIComponent("" + type) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllSettingParamsFields(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSettingParamsFields(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfBaseSettingDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfBaseSettingDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllSettingParamsFields(response: HttpResponseBase): Observable<ListResultDtoOfBaseSettingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? ListResultDtoOfBaseSettingDto.fromJS(resultData200) : new ListResultDtoOfBaseSettingDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfBaseSettingDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getBaseSettingForEdit(id: number | null | undefined): Observable<GetBaseSettingForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/BaseSettings/GetBaseSettingForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetBaseSettingForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBaseSettingForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetBaseSettingForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetBaseSettingForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetBaseSettingForEdit(response: HttpResponseBase): Observable<GetBaseSettingForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetBaseSettingForEditOutput.fromJS(resultData200) : new GetBaseSettingForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetBaseSettingForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditBaseSettingDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BaseSettings/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BaseSettings/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllSettingParamForLookupTable(filter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfSettingParamLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/BaseSettings/GetAllSettingParamForLookupTable?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllSettingParamForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSettingParamForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfSettingParamLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfSettingParamLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllSettingParamForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfSettingParamLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfSettingParamLookupTableDto.fromJS(resultData200) : new PagedResultDtoOfSettingParamLookupTableDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfSettingParamLookupTableDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllCampaignForLookupTable(filter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfCampaignLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/BaseSettings/GetAllCampaignForLookupTable?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllCampaignForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCampaignForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfCampaignLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfCampaignLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllCampaignForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfCampaignLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfCampaignLookupTableDto.fromJS(resultData200) : new PagedResultDtoOfCampaignLookupTableDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfCampaignLookupTableDto>(<any>null);
    }

    /**
     * @param code (optional) 
     * @return Success
     */
    getBaseSettingByCode(code: string | null | undefined): Observable<GetBaseSettingForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/BaseSettings/GetBaseSettingByCode?";
        if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetBaseSettingByCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBaseSettingByCode(<any>response_);
                } catch (e) {
                    return <Observable<GetBaseSettingForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetBaseSettingForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetBaseSettingByCode(response: HttpResponseBase): Observable<GetBaseSettingForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetBaseSettingForEditOutput.fromJS(resultData200) : new GetBaseSettingForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetBaseSettingForEditOutput>(<any>null);
    }
}

@Injectable()
export class BeatPlanDetailsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param beatPlanCodeFilter (optional) 
     * @param outletCodeFilter (optional) 
     * @param statusFilter (optional) 
     * @param masterNameUnSignFilter (optional) 
     * @param salesmanCodeFilter (optional) 
     * @param frequencyFilter (optional) 
     * @param priorityFilter (optional) 
     * @param maxFromDateFilter (optional) 
     * @param minFromDateFilter (optional) 
     * @param maxToDateFilter (optional) 
     * @param minToDateFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, beatPlanCodeFilter: string | null | undefined, outletCodeFilter: string | null | undefined, statusFilter: string | null | undefined, masterNameUnSignFilter: string | null | undefined, salesmanCodeFilter: string | null | undefined, frequencyFilter: string | null | undefined, priorityFilter: number | null | undefined, maxFromDateFilter: moment.Moment | null | undefined, minFromDateFilter: moment.Moment | null | undefined, maxToDateFilter: moment.Moment | null | undefined, minToDateFilter: moment.Moment | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetBeatPlanDetailForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/BeatPlanDetails/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (beatPlanCodeFilter !== undefined)
            url_ += "BeatPlanCodeFilter=" + encodeURIComponent("" + beatPlanCodeFilter) + "&";
        if (outletCodeFilter !== undefined)
            url_ += "OutletCodeFilter=" + encodeURIComponent("" + outletCodeFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (masterNameUnSignFilter !== undefined)
            url_ += "MasterNameUnSignFilter=" + encodeURIComponent("" + masterNameUnSignFilter) + "&";
        if (salesmanCodeFilter !== undefined)
            url_ += "SalesmanCodeFilter=" + encodeURIComponent("" + salesmanCodeFilter) + "&";
        if (frequencyFilter !== undefined)
            url_ += "FrequencyFilter=" + encodeURIComponent("" + frequencyFilter) + "&";
        if (priorityFilter !== undefined)
            url_ += "PriorityFilter=" + encodeURIComponent("" + priorityFilter) + "&";
        if (maxFromDateFilter !== undefined)
            url_ += "MaxFromDateFilter=" + encodeURIComponent(maxFromDateFilter ? "" + maxFromDateFilter.toJSON() : "") + "&";
        if (minFromDateFilter !== undefined)
            url_ += "MinFromDateFilter=" + encodeURIComponent(minFromDateFilter ? "" + minFromDateFilter.toJSON() : "") + "&";
        if (maxToDateFilter !== undefined)
            url_ += "MaxToDateFilter=" + encodeURIComponent(maxToDateFilter ? "" + maxToDateFilter.toJSON() : "") + "&";
        if (minToDateFilter !== undefined)
            url_ += "MinToDateFilter=" + encodeURIComponent(minToDateFilter ? "" + minToDateFilter.toJSON() : "") + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetBeatPlanDetailForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetBeatPlanDetailForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetBeatPlanDetailForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetBeatPlanDetailForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetBeatPlanDetailForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetBeatPlanDetailForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getBeatPlanDetailForEdit(id: number | null | undefined): Observable<GetBeatPlanDetailForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/BeatPlanDetails/GetBeatPlanDetailForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetBeatPlanDetailForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBeatPlanDetailForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetBeatPlanDetailForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetBeatPlanDetailForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetBeatPlanDetailForEdit(response: HttpResponseBase): Observable<GetBeatPlanDetailForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetBeatPlanDetailForEditOutput.fromJS(resultData200) : new GetBeatPlanDetailForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetBeatPlanDetailForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditBeatPlanDetailDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BeatPlanDetails/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BeatPlanDetails/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param beatPlanCodeFilter (optional) 
     * @param outletCodeFilter (optional) 
     * @param statusFilter (optional) 
     * @param masterNameUnSignFilter (optional) 
     * @param salesmanCodeFilter (optional) 
     * @param frequencyFilter (optional) 
     * @param priorityFilter (optional) 
     * @return Success
     */
    getBeatPlanDetailsToExcel(filter: string | null | undefined, beatPlanCodeFilter: string | null | undefined, outletCodeFilter: string | null | undefined, statusFilter: string | null | undefined, masterNameUnSignFilter: string | null | undefined, salesmanCodeFilter: string | null | undefined, frequencyFilter: string | null | undefined, priorityFilter: number | null | undefined): Observable<SocialRetailerFileDto> {
        let url_ = this.baseUrl + "/api/services/app/BeatPlanDetails/GetBeatPlanDetailsToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (beatPlanCodeFilter !== undefined)
            url_ += "BeatPlanCodeFilter=" + encodeURIComponent("" + beatPlanCodeFilter) + "&";
        if (outletCodeFilter !== undefined)
            url_ += "OutletCodeFilter=" + encodeURIComponent("" + outletCodeFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (masterNameUnSignFilter !== undefined)
            url_ += "MasterNameUnSignFilter=" + encodeURIComponent("" + masterNameUnSignFilter) + "&";
        if (salesmanCodeFilter !== undefined)
            url_ += "SalesmanCodeFilter=" + encodeURIComponent("" + salesmanCodeFilter) + "&";
        if (frequencyFilter !== undefined)
            url_ += "FrequencyFilter=" + encodeURIComponent("" + frequencyFilter) + "&";
        if (priorityFilter !== undefined)
            url_ += "PriorityFilter=" + encodeURIComponent("" + priorityFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetBeatPlanDetailsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBeatPlanDetailsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<SocialRetailerFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SocialRetailerFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetBeatPlanDetailsToExcel(response: HttpResponseBase): Observable<SocialRetailerFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? SocialRetailerFileDto.fromJS(resultData200) : new SocialRetailerFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SocialRetailerFileDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @return Success
     */
    getAllActiveOutletForBeatPlan(filter: string | null | undefined): Observable<OutletForBeatPlanDetailDto[]> {
        let url_ = this.baseUrl + "/api/services/app/BeatPlanDetails/GetAllActiveOutletForBeatPlan?";
        if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllActiveOutletForBeatPlan(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllActiveOutletForBeatPlan(<any>response_);
                } catch (e) {
                    return <Observable<OutletForBeatPlanDetailDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<OutletForBeatPlanDetailDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllActiveOutletForBeatPlan(response: HttpResponseBase): Observable<OutletForBeatPlanDetailDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(OutletForBeatPlanDetailDto.fromJS(item));
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OutletForBeatPlanDetailDto[]>(<any>null);
    }

    /**
     * @param beatPlanCode (optional) 
     * @param salesmanCode (optional) 
     * @param outletCode (optional) 
     * @param frequency (optional) 
     * @param priority (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getSearchBeatPlanDetails(beatPlanCode: string | null | undefined, salesmanCode: string | null | undefined, outletCode: string | null | undefined, frequency: string | null | undefined, priority: number | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetBeatPlanDetailsResultForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/BeatPlanDetails/GetSearchBeatPlanDetails?";
        if (beatPlanCode !== undefined)
            url_ += "BeatPlanCode=" + encodeURIComponent("" + beatPlanCode) + "&";
        if (salesmanCode !== undefined)
            url_ += "SalesmanCode=" + encodeURIComponent("" + salesmanCode) + "&";
        if (outletCode !== undefined)
            url_ += "OutletCode=" + encodeURIComponent("" + outletCode) + "&";
        if (frequency !== undefined)
            url_ += "Frequency=" + encodeURIComponent("" + frequency) + "&";
        if (priority !== undefined)
            url_ += "Priority=" + encodeURIComponent("" + priority) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSearchBeatPlanDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSearchBeatPlanDetails(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetBeatPlanDetailsResultForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetBeatPlanDetailsResultForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetSearchBeatPlanDetails(response: HttpResponseBase): Observable<PagedResultDtoOfGetBeatPlanDetailsResultForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetBeatPlanDetailsResultForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetBeatPlanDetailsResultForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetBeatPlanDetailsResultForViewDto>(<any>null);
    }

    /**
     * @param entities (optional) 
     * @return Success
     */
    batchDeleteAsync(entities: BeatPlanDetailsResultDto[] | null | undefined): Observable<MessageResultSocialRetailer> {
        let url_ = this.baseUrl + "/api/services/app/BeatPlanDetails/BatchDeleteAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entities);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processBatchDeleteAsync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBatchDeleteAsync(<any>response_);
                } catch (e) {
                    return <Observable<MessageResultSocialRetailer>><any>_observableThrow(e);
                }
            } else
                return <Observable<MessageResultSocialRetailer>><any>_observableThrow(response_);
        }));
    }

    protected processBatchDeleteAsync(response: HttpResponseBase): Observable<MessageResultSocialRetailer> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? MessageResultSocialRetailer.fromJS(resultData200) : new MessageResultSocialRetailer();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MessageResultSocialRetailer>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param beatPlanCodeFilter (optional) 
     * @param outletCodeFilter (optional) 
     * @param statusFilter (optional) 
     * @param masterNameUnSignFilter (optional) 
     * @param salesmanCodeFilter (optional) 
     * @param frequencyFilter (optional) 
     * @param priorityFilter (optional) 
     * @return Success
     */
    getBeatPlanDetailsToExcelAsync(filter: string | null | undefined, beatPlanCodeFilter: string | null | undefined, outletCodeFilter: string | null | undefined, statusFilter: string | null | undefined, masterNameUnSignFilter: string | null | undefined, salesmanCodeFilter: string | null | undefined, frequencyFilter: string | null | undefined, priorityFilter: number | null | undefined): Observable<SocialRetailerFileDto> {
        let url_ = this.baseUrl + "/api/services/app/BeatPlanDetails/GetBeatPlanDetailsToExcelAsync?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (beatPlanCodeFilter !== undefined)
            url_ += "BeatPlanCodeFilter=" + encodeURIComponent("" + beatPlanCodeFilter) + "&";
        if (outletCodeFilter !== undefined)
            url_ += "OutletCodeFilter=" + encodeURIComponent("" + outletCodeFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (masterNameUnSignFilter !== undefined)
            url_ += "MasterNameUnSignFilter=" + encodeURIComponent("" + masterNameUnSignFilter) + "&";
        if (salesmanCodeFilter !== undefined)
            url_ += "SalesmanCodeFilter=" + encodeURIComponent("" + salesmanCodeFilter) + "&";
        if (frequencyFilter !== undefined)
            url_ += "FrequencyFilter=" + encodeURIComponent("" + frequencyFilter) + "&";
        if (priorityFilter !== undefined)
            url_ += "PriorityFilter=" + encodeURIComponent("" + priorityFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetBeatPlanDetailsToExcelAsync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBeatPlanDetailsToExcelAsync(<any>response_);
                } catch (e) {
                    return <Observable<SocialRetailerFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SocialRetailerFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetBeatPlanDetailsToExcelAsync(response: HttpResponseBase): Observable<SocialRetailerFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? SocialRetailerFileDto.fromJS(resultData200) : new SocialRetailerFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SocialRetailerFileDto>(<any>null);
    }

    /**
     * @param arg (optional) 
     * @return Success
     */
    importQueue(arg: BeatPlanDetailImportAgrs | null | undefined): Observable<CommonImportFileResponse> {
        let url_ = this.baseUrl + "/api/services/app/BeatPlanDetails/ImportQueue";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(arg);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processImportQueue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportQueue(<any>response_);
                } catch (e) {
                    return <Observable<CommonImportFileResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<CommonImportFileResponse>><any>_observableThrow(response_);
        }));
    }

    protected processImportQueue(response: HttpResponseBase): Observable<CommonImportFileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? CommonImportFileResponse.fromJS(resultData200) : new CommonImportFileResponse();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CommonImportFileResponse>(<any>null);
    }

    /**
     * @param salesManCode (optional) 
     * @return Success
     */
    checkSalesManAsync(salesManCode: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/BeatPlanDetails/CheckSalesManAsync?";
        if (salesManCode !== undefined)
            url_ += "salesManCode=" + encodeURIComponent("" + salesManCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCheckSalesManAsync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckSalesManAsync(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processCheckSalesManAsync(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEditUnsignAsync(input: CreateOrEditOutletForBeatPlanDetailDto[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BeatPlanDetails/CreateOrEditUnsignAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEditUnsignAsync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditUnsignAsync(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEditUnsignAsync(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getBeatPlanOutletAsync(salesmanCode: string, beatPlanCode: string, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetBeatPlanOutletDto> {
        let url_ = this.baseUrl + "/api/services/app/BeatPlanDetails/GetBeatPlanOutletAsync?";
        if (salesmanCode === undefined || salesmanCode === null)
            throw new Error("The parameter 'salesmanCode' must be defined and cannot be null.");
        else
            url_ += "SalesmanCode=" + encodeURIComponent("" + salesmanCode) + "&";
        if (beatPlanCode === undefined || beatPlanCode === null)
            throw new Error("The parameter 'beatPlanCode' must be defined and cannot be null.");
        else
            url_ += "BeatPlanCode=" + encodeURIComponent("" + beatPlanCode) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetBeatPlanOutletAsync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBeatPlanOutletAsync(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetBeatPlanOutletDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetBeatPlanOutletDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetBeatPlanOutletAsync(response: HttpResponseBase): Observable<PagedResultDtoOfGetBeatPlanOutletDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetBeatPlanOutletDto.fromJS(resultData200) : new PagedResultDtoOfGetBeatPlanOutletDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetBeatPlanOutletDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param beatPlanCode (optional) 
     * @param salesmanCode (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllOutLetActiveAsync(filter: string | null | undefined, beatPlanCode: string | null | undefined, salesmanCode: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetOutletActiveForView> {
        let url_ = this.baseUrl + "/api/services/app/BeatPlanDetails/GetAllOutLetActiveAsync?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (beatPlanCode !== undefined)
            url_ += "BeatPlanCode=" + encodeURIComponent("" + beatPlanCode) + "&";
        if (salesmanCode !== undefined)
            url_ += "SalesmanCode=" + encodeURIComponent("" + salesmanCode) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllOutLetActiveAsync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllOutLetActiveAsync(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetOutletActiveForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetOutletActiveForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllOutLetActiveAsync(response: HttpResponseBase): Observable<PagedResultDtoOfGetOutletActiveForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetOutletActiveForView.fromJS(resultData200) : new PagedResultDtoOfGetOutletActiveForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetOutletActiveForView>(<any>null);
    }
}

@Injectable()
export class BeatPlanHeadersServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param beatPlanCodeFilter (optional) 
     * @param beatPlanNameFilter (optional) 
     * @param salesmanCodeFilter (optional) 
     * @param statusFilter (optional) 
     * @param masterNameUnSignFilter (optional) 
     * @param maxFromDateFilter (optional) 
     * @param minFromDateFilter (optional) 
     * @param maxToDateFilter (optional) 
     * @param minToDateFilter (optional) 
     * @param salesmanFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, beatPlanCodeFilter: string | null | undefined, beatPlanNameFilter: string | null | undefined, salesmanCodeFilter: string | null | undefined, statusFilter: string | null | undefined, masterNameUnSignFilter: string | null | undefined, maxFromDateFilter: moment.Moment | null | undefined, minFromDateFilter: moment.Moment | null | undefined, maxToDateFilter: moment.Moment | null | undefined, minToDateFilter: moment.Moment | null | undefined, salesmanFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetBeatPlanHeaderForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/BeatPlanHeaders/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (beatPlanCodeFilter !== undefined)
            url_ += "BeatPlanCodeFilter=" + encodeURIComponent("" + beatPlanCodeFilter) + "&";
        if (beatPlanNameFilter !== undefined)
            url_ += "BeatPlanNameFilter=" + encodeURIComponent("" + beatPlanNameFilter) + "&";
        if (salesmanCodeFilter !== undefined)
            url_ += "SalesmanCodeFilter=" + encodeURIComponent("" + salesmanCodeFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (masterNameUnSignFilter !== undefined)
            url_ += "MasterNameUnSignFilter=" + encodeURIComponent("" + masterNameUnSignFilter) + "&";
        if (maxFromDateFilter !== undefined)
            url_ += "MaxFromDateFilter=" + encodeURIComponent(maxFromDateFilter ? "" + maxFromDateFilter.toJSON() : "") + "&";
        if (minFromDateFilter !== undefined)
            url_ += "MinFromDateFilter=" + encodeURIComponent(minFromDateFilter ? "" + minFromDateFilter.toJSON() : "") + "&";
        if (maxToDateFilter !== undefined)
            url_ += "MaxToDateFilter=" + encodeURIComponent(maxToDateFilter ? "" + maxToDateFilter.toJSON() : "") + "&";
        if (minToDateFilter !== undefined)
            url_ += "MinToDateFilter=" + encodeURIComponent(minToDateFilter ? "" + minToDateFilter.toJSON() : "") + "&";
        if (salesmanFilter !== undefined)
            url_ += "SalesmanFilter=" + encodeURIComponent("" + salesmanFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetBeatPlanHeaderForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetBeatPlanHeaderForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetBeatPlanHeaderForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetBeatPlanHeaderForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetBeatPlanHeaderForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetBeatPlanHeaderForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getBeatPlanHeaderForEdit(id: number | null | undefined): Observable<GetBeatPlanHeaderForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/BeatPlanHeaders/GetBeatPlanHeaderForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetBeatPlanHeaderForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBeatPlanHeaderForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetBeatPlanHeaderForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetBeatPlanHeaderForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetBeatPlanHeaderForEdit(response: HttpResponseBase): Observable<GetBeatPlanHeaderForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetBeatPlanHeaderForEditOutput.fromJS(resultData200) : new GetBeatPlanHeaderForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetBeatPlanHeaderForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditBeatPlanHeaderDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BeatPlanHeaders/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BeatPlanHeaders/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createForSalesApp(input: CreateOrEditBeatPlanHeaderForAppDto | null | undefined): Observable<BeatPlanHeaderForAppResponse> {
        let url_ = this.baseUrl + "/api/services/app/BeatPlanHeaders/CreateForSalesApp";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateForSalesApp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateForSalesApp(<any>response_);
                } catch (e) {
                    return <Observable<BeatPlanHeaderForAppResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<BeatPlanHeaderForAppResponse>><any>_observableThrow(response_);
        }));
    }

    protected processCreateForSalesApp(response: HttpResponseBase): Observable<BeatPlanHeaderForAppResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? BeatPlanHeaderForAppResponse.fromJS(resultData200) : new BeatPlanHeaderForAppResponse();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BeatPlanHeaderForAppResponse>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param beatPlanCodeFilter (optional) 
     * @param beatPlanNameFilter (optional) 
     * @param salesmanCodeFilter (optional) 
     * @param statusFilter (optional) 
     * @param masterNameUnSignFilter (optional) 
     * @param maxFromDateFilter (optional) 
     * @param minFromDateFilter (optional) 
     * @param maxToDateFilter (optional) 
     * @param minToDateFilter (optional) 
     * @param salesmanFilter (optional) 
     * @return Success
     */
    getBeatPlanHeadersToExcel(filter: string | null | undefined, beatPlanCodeFilter: string | null | undefined, beatPlanNameFilter: string | null | undefined, salesmanCodeFilter: string | null | undefined, statusFilter: string | null | undefined, masterNameUnSignFilter: string | null | undefined, maxFromDateFilter: moment.Moment | null | undefined, minFromDateFilter: moment.Moment | null | undefined, maxToDateFilter: moment.Moment | null | undefined, minToDateFilter: moment.Moment | null | undefined, salesmanFilter: string | null | undefined): Observable<SocialRetailerFileDto> {
        let url_ = this.baseUrl + "/api/services/app/BeatPlanHeaders/GetBeatPlanHeadersToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (beatPlanCodeFilter !== undefined)
            url_ += "BeatPlanCodeFilter=" + encodeURIComponent("" + beatPlanCodeFilter) + "&";
        if (beatPlanNameFilter !== undefined)
            url_ += "BeatPlanNameFilter=" + encodeURIComponent("" + beatPlanNameFilter) + "&";
        if (salesmanCodeFilter !== undefined)
            url_ += "SalesmanCodeFilter=" + encodeURIComponent("" + salesmanCodeFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (masterNameUnSignFilter !== undefined)
            url_ += "MasterNameUnSignFilter=" + encodeURIComponent("" + masterNameUnSignFilter) + "&";
        if (maxFromDateFilter !== undefined)
            url_ += "MaxFromDateFilter=" + encodeURIComponent(maxFromDateFilter ? "" + maxFromDateFilter.toJSON() : "") + "&";
        if (minFromDateFilter !== undefined)
            url_ += "MinFromDateFilter=" + encodeURIComponent(minFromDateFilter ? "" + minFromDateFilter.toJSON() : "") + "&";
        if (maxToDateFilter !== undefined)
            url_ += "MaxToDateFilter=" + encodeURIComponent(maxToDateFilter ? "" + maxToDateFilter.toJSON() : "") + "&";
        if (minToDateFilter !== undefined)
            url_ += "MinToDateFilter=" + encodeURIComponent(minToDateFilter ? "" + minToDateFilter.toJSON() : "") + "&";
        if (salesmanFilter !== undefined)
            url_ += "SalesmanFilter=" + encodeURIComponent("" + salesmanFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetBeatPlanHeadersToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBeatPlanHeadersToExcel(<any>response_);
                } catch (e) {
                    return <Observable<SocialRetailerFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SocialRetailerFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetBeatPlanHeadersToExcel(response: HttpResponseBase): Observable<SocialRetailerFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? SocialRetailerFileDto.fromJS(resultData200) : new SocialRetailerFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SocialRetailerFileDto>(<any>null);
    }

    /**
     * @param entities (optional) 
     * @return Success
     */
    batchDeleteAsync(entities: BeatPlanHeaderDto[] | null | undefined): Observable<MessageResultSocialRetailer> {
        let url_ = this.baseUrl + "/api/services/app/BeatPlanHeaders/BatchDeleteAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entities);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processBatchDeleteAsync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBatchDeleteAsync(<any>response_);
                } catch (e) {
                    return <Observable<MessageResultSocialRetailer>><any>_observableThrow(e);
                }
            } else
                return <Observable<MessageResultSocialRetailer>><any>_observableThrow(response_);
        }));
    }

    protected processBatchDeleteAsync(response: HttpResponseBase): Observable<MessageResultSocialRetailer> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? MessageResultSocialRetailer.fromJS(resultData200) : new MessageResultSocialRetailer();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MessageResultSocialRetailer>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEditUnsignAsync(input: CreateOrEditBeatPlanHeaderDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BeatPlanHeaders/CreateOrEditUnsignAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEditUnsignAsync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditUnsignAsync(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEditUnsignAsync(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param beatPlanCodeFilter (optional) 
     * @param beatPlanNameFilter (optional) 
     * @param salesmanCodeFilter (optional) 
     * @param statusFilter (optional) 
     * @param masterNameUnSignFilter (optional) 
     * @param maxFromDateFilter (optional) 
     * @param minFromDateFilter (optional) 
     * @param maxToDateFilter (optional) 
     * @param minToDateFilter (optional) 
     * @param salesmanFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getSearchAsync(filter: string | null | undefined, beatPlanCodeFilter: string | null | undefined, beatPlanNameFilter: string | null | undefined, salesmanCodeFilter: string | null | undefined, statusFilter: string | null | undefined, masterNameUnSignFilter: string | null | undefined, maxFromDateFilter: moment.Moment | null | undefined, minFromDateFilter: moment.Moment | null | undefined, maxToDateFilter: moment.Moment | null | undefined, minToDateFilter: moment.Moment | null | undefined, salesmanFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetBeatPlanHeaderForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/BeatPlanHeaders/GetSearchAsync?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (beatPlanCodeFilter !== undefined)
            url_ += "BeatPlanCodeFilter=" + encodeURIComponent("" + beatPlanCodeFilter) + "&";
        if (beatPlanNameFilter !== undefined)
            url_ += "BeatPlanNameFilter=" + encodeURIComponent("" + beatPlanNameFilter) + "&";
        if (salesmanCodeFilter !== undefined)
            url_ += "SalesmanCodeFilter=" + encodeURIComponent("" + salesmanCodeFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (masterNameUnSignFilter !== undefined)
            url_ += "MasterNameUnSignFilter=" + encodeURIComponent("" + masterNameUnSignFilter) + "&";
        if (maxFromDateFilter !== undefined)
            url_ += "MaxFromDateFilter=" + encodeURIComponent(maxFromDateFilter ? "" + maxFromDateFilter.toJSON() : "") + "&";
        if (minFromDateFilter !== undefined)
            url_ += "MinFromDateFilter=" + encodeURIComponent(minFromDateFilter ? "" + minFromDateFilter.toJSON() : "") + "&";
        if (maxToDateFilter !== undefined)
            url_ += "MaxToDateFilter=" + encodeURIComponent(maxToDateFilter ? "" + maxToDateFilter.toJSON() : "") + "&";
        if (minToDateFilter !== undefined)
            url_ += "MinToDateFilter=" + encodeURIComponent(minToDateFilter ? "" + minToDateFilter.toJSON() : "") + "&";
        if (salesmanFilter !== undefined)
            url_ += "SalesmanFilter=" + encodeURIComponent("" + salesmanFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSearchAsync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSearchAsync(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetBeatPlanHeaderForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetBeatPlanHeaderForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetSearchAsync(response: HttpResponseBase): Observable<PagedResultDtoOfGetBeatPlanHeaderForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetBeatPlanHeaderForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetBeatPlanHeaderForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetBeatPlanHeaderForViewDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param beatPlanCodeFilter (optional) 
     * @param beatPlanNameFilter (optional) 
     * @param salesmanCodeFilter (optional) 
     * @param statusFilter (optional) 
     * @param masterNameUnSignFilter (optional) 
     * @param maxFromDateFilter (optional) 
     * @param minFromDateFilter (optional) 
     * @param maxToDateFilter (optional) 
     * @param minToDateFilter (optional) 
     * @param salesmanFilter (optional) 
     * @return Success
     */
    getBeatPlanHeadersToExportAsync(filter: string | null | undefined, beatPlanCodeFilter: string | null | undefined, beatPlanNameFilter: string | null | undefined, salesmanCodeFilter: string | null | undefined, statusFilter: string | null | undefined, masterNameUnSignFilter: string | null | undefined, maxFromDateFilter: moment.Moment | null | undefined, minFromDateFilter: moment.Moment | null | undefined, maxToDateFilter: moment.Moment | null | undefined, minToDateFilter: moment.Moment | null | undefined, salesmanFilter: string | null | undefined): Observable<SocialRetailerFileDto> {
        let url_ = this.baseUrl + "/api/services/app/BeatPlanHeaders/GetBeatPlanHeadersToExportAsync?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (beatPlanCodeFilter !== undefined)
            url_ += "BeatPlanCodeFilter=" + encodeURIComponent("" + beatPlanCodeFilter) + "&";
        if (beatPlanNameFilter !== undefined)
            url_ += "BeatPlanNameFilter=" + encodeURIComponent("" + beatPlanNameFilter) + "&";
        if (salesmanCodeFilter !== undefined)
            url_ += "SalesmanCodeFilter=" + encodeURIComponent("" + salesmanCodeFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (masterNameUnSignFilter !== undefined)
            url_ += "MasterNameUnSignFilter=" + encodeURIComponent("" + masterNameUnSignFilter) + "&";
        if (maxFromDateFilter !== undefined)
            url_ += "MaxFromDateFilter=" + encodeURIComponent(maxFromDateFilter ? "" + maxFromDateFilter.toJSON() : "") + "&";
        if (minFromDateFilter !== undefined)
            url_ += "MinFromDateFilter=" + encodeURIComponent(minFromDateFilter ? "" + minFromDateFilter.toJSON() : "") + "&";
        if (maxToDateFilter !== undefined)
            url_ += "MaxToDateFilter=" + encodeURIComponent(maxToDateFilter ? "" + maxToDateFilter.toJSON() : "") + "&";
        if (minToDateFilter !== undefined)
            url_ += "MinToDateFilter=" + encodeURIComponent(minToDateFilter ? "" + minToDateFilter.toJSON() : "") + "&";
        if (salesmanFilter !== undefined)
            url_ += "SalesmanFilter=" + encodeURIComponent("" + salesmanFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetBeatPlanHeadersToExportAsync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBeatPlanHeadersToExportAsync(<any>response_);
                } catch (e) {
                    return <Observable<SocialRetailerFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SocialRetailerFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetBeatPlanHeadersToExportAsync(response: HttpResponseBase): Observable<SocialRetailerFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? SocialRetailerFileDto.fromJS(resultData200) : new SocialRetailerFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SocialRetailerFileDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteSalesmanAsync(id: number | null | undefined): Observable<MessageResultSocialRetailer> {
        let url_ = this.baseUrl + "/api/services/app/BeatPlanHeaders/DeleteSalesmanAsync?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteSalesmanAsync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteSalesmanAsync(<any>response_);
                } catch (e) {
                    return <Observable<MessageResultSocialRetailer>><any>_observableThrow(e);
                }
            } else
                return <Observable<MessageResultSocialRetailer>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteSalesmanAsync(response: HttpResponseBase): Observable<MessageResultSocialRetailer> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? MessageResultSocialRetailer.fromJS(resultData200) : new MessageResultSocialRetailer();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MessageResultSocialRetailer>(<any>null);
    }

    /**
     * @param arg (optional) 
     * @return Success
     */
    importQueue(arg: BeatPlanImportAgrs | null | undefined): Observable<CommonImportFileResponse> {
        let url_ = this.baseUrl + "/api/services/app/BeatPlanHeaders/ImportQueue";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(arg);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processImportQueue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportQueue(<any>response_);
                } catch (e) {
                    return <Observable<CommonImportFileResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<CommonImportFileResponse>><any>_observableThrow(response_);
        }));
    }

    protected processImportQueue(response: HttpResponseBase): Observable<CommonImportFileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? CommonImportFileResponse.fromJS(resultData200) : new CommonImportFileResponse();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CommonImportFileResponse>(<any>null);
    }

    /**
     * @param salesmanCode (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getBeatPlanAsync(salesmanCode: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetBeatPlanForViewMobileDto> {
        let url_ = this.baseUrl + "/api/services/app/BeatPlanHeaders/GetBeatPlanAsync?";
        if (salesmanCode !== undefined)
            url_ += "SalesmanCode=" + encodeURIComponent("" + salesmanCode) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetBeatPlanAsync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBeatPlanAsync(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetBeatPlanForViewMobileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetBeatPlanForViewMobileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetBeatPlanAsync(response: HttpResponseBase): Observable<PagedResultDtoOfGetBeatPlanForViewMobileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetBeatPlanForViewMobileDto.fromJS(resultData200) : new PagedResultDtoOfGetBeatPlanForViewMobileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetBeatPlanForViewMobileDto>(<any>null);
    }
}

@Injectable()
export class BeatPlanResultsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditBeatPlanResultInput | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BeatPlanResults/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BeatPlanResults/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param beatPlanCodeFilter (optional) 
     * @param beatPlanNameFilter (optional) 
     * @param salemanCodeFilter (optional) 
     * @param outletCodeFilter (optional) 
     * @param checkInTimeFilter (optional) 
     * @param checkOutTimeFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, beatPlanCodeFilter: string | null | undefined, beatPlanNameFilter: string | null | undefined, salemanCodeFilter: string | null | undefined, outletCodeFilter: string | null | undefined, checkInTimeFilter: moment.Moment | null | undefined, checkOutTimeFilter: moment.Moment | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetBeatPlanResultForView> {
        let url_ = this.baseUrl + "/api/services/app/BeatPlanResults/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (beatPlanCodeFilter !== undefined)
            url_ += "BeatPlanCodeFilter=" + encodeURIComponent("" + beatPlanCodeFilter) + "&";
        if (beatPlanNameFilter !== undefined)
            url_ += "BeatPlanNameFilter=" + encodeURIComponent("" + beatPlanNameFilter) + "&";
        if (salemanCodeFilter !== undefined)
            url_ += "SalemanCodeFilter=" + encodeURIComponent("" + salemanCodeFilter) + "&";
        if (outletCodeFilter !== undefined)
            url_ += "OutletCodeFilter=" + encodeURIComponent("" + outletCodeFilter) + "&";
        if (checkInTimeFilter !== undefined)
            url_ += "CheckInTimeFilter=" + encodeURIComponent(checkInTimeFilter ? "" + checkInTimeFilter.toJSON() : "") + "&";
        if (checkOutTimeFilter !== undefined)
            url_ += "CheckOutTimeFilter=" + encodeURIComponent(checkOutTimeFilter ? "" + checkOutTimeFilter.toJSON() : "") + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetBeatPlanResultForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetBeatPlanResultForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetBeatPlanResultForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetBeatPlanResultForView.fromJS(resultData200) : new PagedResultDtoOfGetBeatPlanResultForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetBeatPlanResultForView>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param beatPlanCodeFilter (optional) 
     * @param beatPlanNameFilter (optional) 
     * @param salemanCodeFilter (optional) 
     * @param outletCodeFilter (optional) 
     * @param checkInTimeFilter (optional) 
     * @param checkOutTimeFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getSearchAsync(filter: string | null | undefined, beatPlanCodeFilter: string | null | undefined, beatPlanNameFilter: string | null | undefined, salemanCodeFilter: string | null | undefined, outletCodeFilter: string | null | undefined, checkInTimeFilter: moment.Moment | null | undefined, checkOutTimeFilter: moment.Moment | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetBeatPlanResultForView> {
        let url_ = this.baseUrl + "/api/services/app/BeatPlanResults/GetSearchAsync?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (beatPlanCodeFilter !== undefined)
            url_ += "BeatPlanCodeFilter=" + encodeURIComponent("" + beatPlanCodeFilter) + "&";
        if (beatPlanNameFilter !== undefined)
            url_ += "BeatPlanNameFilter=" + encodeURIComponent("" + beatPlanNameFilter) + "&";
        if (salemanCodeFilter !== undefined)
            url_ += "SalemanCodeFilter=" + encodeURIComponent("" + salemanCodeFilter) + "&";
        if (outletCodeFilter !== undefined)
            url_ += "OutletCodeFilter=" + encodeURIComponent("" + outletCodeFilter) + "&";
        if (checkInTimeFilter !== undefined)
            url_ += "CheckInTimeFilter=" + encodeURIComponent(checkInTimeFilter ? "" + checkInTimeFilter.toJSON() : "") + "&";
        if (checkOutTimeFilter !== undefined)
            url_ += "CheckOutTimeFilter=" + encodeURIComponent(checkOutTimeFilter ? "" + checkOutTimeFilter.toJSON() : "") + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSearchAsync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSearchAsync(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetBeatPlanResultForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetBeatPlanResultForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetSearchAsync(response: HttpResponseBase): Observable<PagedResultDtoOfGetBeatPlanResultForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetBeatPlanResultForView.fromJS(resultData200) : new PagedResultDtoOfGetBeatPlanResultForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetBeatPlanResultForView>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getBeatPlanResultDetail(id: number | null | undefined): Observable<GetBeatPlanResultForView> {
        let url_ = this.baseUrl + "/api/services/app/BeatPlanResults/GetBeatPlanResultDetail?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetBeatPlanResultDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBeatPlanResultDetail(<any>response_);
                } catch (e) {
                    return <Observable<GetBeatPlanResultForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetBeatPlanResultForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetBeatPlanResultDetail(response: HttpResponseBase): Observable<GetBeatPlanResultForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetBeatPlanResultForView.fromJS(resultData200) : new GetBeatPlanResultForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetBeatPlanResultForView>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param beatPlanCodeFilter (optional) 
     * @param beatPlanNameFilter (optional) 
     * @param salemanCodeFilter (optional) 
     * @param outletCodeFilter (optional) 
     * @param checkInTimeFilter (optional) 
     * @param checkOutTimeFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getBeatPlanHeadersToExcel(filter: string | null | undefined, beatPlanCodeFilter: string | null | undefined, beatPlanNameFilter: string | null | undefined, salemanCodeFilter: string | null | undefined, outletCodeFilter: string | null | undefined, checkInTimeFilter: moment.Moment | null | undefined, checkOutTimeFilter: moment.Moment | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<SocialRetailerFileDto> {
        let url_ = this.baseUrl + "/api/services/app/BeatPlanResults/GetBeatPlanHeadersToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (beatPlanCodeFilter !== undefined)
            url_ += "BeatPlanCodeFilter=" + encodeURIComponent("" + beatPlanCodeFilter) + "&";
        if (beatPlanNameFilter !== undefined)
            url_ += "BeatPlanNameFilter=" + encodeURIComponent("" + beatPlanNameFilter) + "&";
        if (salemanCodeFilter !== undefined)
            url_ += "SalemanCodeFilter=" + encodeURIComponent("" + salemanCodeFilter) + "&";
        if (outletCodeFilter !== undefined)
            url_ += "OutletCodeFilter=" + encodeURIComponent("" + outletCodeFilter) + "&";
        if (checkInTimeFilter !== undefined)
            url_ += "CheckInTimeFilter=" + encodeURIComponent(checkInTimeFilter ? "" + checkInTimeFilter.toJSON() : "") + "&";
        if (checkOutTimeFilter !== undefined)
            url_ += "CheckOutTimeFilter=" + encodeURIComponent(checkOutTimeFilter ? "" + checkOutTimeFilter.toJSON() : "") + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetBeatPlanHeadersToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBeatPlanHeadersToExcel(<any>response_);
                } catch (e) {
                    return <Observable<SocialRetailerFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SocialRetailerFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetBeatPlanHeadersToExcel(response: HttpResponseBase): Observable<SocialRetailerFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? SocialRetailerFileDto.fromJS(resultData200) : new SocialRetailerFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SocialRetailerFileDto>(<any>null);
    }
}

@Injectable()
export class BrandServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param brandCodeFilter (optional) 
     * @param brandNameFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param statusFilter (optional) 
     * @param maxOrdinalFilter (optional) 
     * @param minOrdinalFilter (optional) 
     * @param extraFilter (optional) 
     * @param maxLevelFilter (optional) 
     * @param minLevelFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, brandCodeFilter: string | null | undefined, brandNameFilter: string | null | undefined, descriptionFilter: string | null | undefined, statusFilter: string | null | undefined, maxOrdinalFilter: number | null | undefined, minOrdinalFilter: number | null | undefined, extraFilter: string | null | undefined, maxLevelFilter: number | null | undefined, minLevelFilter: number | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetBrandForView> {
        let url_ = this.baseUrl + "/api/services/app/Brand/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (brandCodeFilter !== undefined)
            url_ += "BrandCodeFilter=" + encodeURIComponent("" + brandCodeFilter) + "&";
        if (brandNameFilter !== undefined)
            url_ += "BrandNameFilter=" + encodeURIComponent("" + brandNameFilter) + "&";
        if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (maxOrdinalFilter !== undefined)
            url_ += "MaxOrdinalFilter=" + encodeURIComponent("" + maxOrdinalFilter) + "&";
        if (minOrdinalFilter !== undefined)
            url_ += "MinOrdinalFilter=" + encodeURIComponent("" + minOrdinalFilter) + "&";
        if (extraFilter !== undefined)
            url_ += "ExtraFilter=" + encodeURIComponent("" + extraFilter) + "&";
        if (maxLevelFilter !== undefined)
            url_ += "MaxLevelFilter=" + encodeURIComponent("" + maxLevelFilter) + "&";
        if (minLevelFilter !== undefined)
            url_ += "MinLevelFilter=" + encodeURIComponent("" + minLevelFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetBrandForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetBrandForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetBrandForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetBrandForView.fromJS(resultData200) : new PagedResultDtoOfGetBrandForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetBrandForView>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getBrandForEdit(id: number | null | undefined): Observable<GetBrandForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Brand/GetBrandForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetBrandForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBrandForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetBrandForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetBrandForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetBrandForEdit(response: HttpResponseBase): Observable<GetBrandForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetBrandForEditOutput.fromJS(resultData200) : new GetBrandForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetBrandForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditBrandDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Brand/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Brand/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param memberCode (optional) 
     * @param type (optional) 
     * @param brandCode (optional) 
     * @return Success
     */
    getRevenueHistory(memberCode: string | null | undefined, type: string | null | undefined, brandCode: string | null | undefined): Observable<RevenueHistoryDtoForView> {
        let url_ = this.baseUrl + "/api/services/app/Brand/GetRevenueHistory?";
        if (memberCode !== undefined)
            url_ += "MemberCode=" + encodeURIComponent("" + memberCode) + "&";
        if (type !== undefined)
            url_ += "Type=" + encodeURIComponent("" + type) + "&";
        if (brandCode !== undefined)
            url_ += "BrandCode=" + encodeURIComponent("" + brandCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetRevenueHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRevenueHistory(<any>response_);
                } catch (e) {
                    return <Observable<RevenueHistoryDtoForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<RevenueHistoryDtoForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetRevenueHistory(response: HttpResponseBase): Observable<RevenueHistoryDtoForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? RevenueHistoryDtoForView.fromJS(resultData200) : new RevenueHistoryDtoForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RevenueHistoryDtoForView>(<any>null);
    }
}

@Injectable()
export class BrandActualServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param memberCodeFilter (optional) 
     * @param maxYearFilter (optional) 
     * @param minYearFilter (optional) 
     * @param maxMonthFilter (optional) 
     * @param minMonthFilter (optional) 
     * @param maxSalesAmountFilter (optional) 
     * @param minSalesAmountFilter (optional) 
     * @param brandCodeFilter (optional) 
     * @param brandNameFilter (optional) 
     * @param monthFilter (optional) 
     * @param yearFilter (optional) 
     * @param maxSalesTargetFilter (optional) 
     * @param minSalesTargetFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, memberCodeFilter: string | null | undefined, maxYearFilter: number | null | undefined, minYearFilter: number | null | undefined, maxMonthFilter: number | null | undefined, minMonthFilter: number | null | undefined, maxSalesAmountFilter: number | null | undefined, minSalesAmountFilter: number | null | undefined, brandCodeFilter: string | null | undefined, brandNameFilter: string | null | undefined, monthFilter: number | null | undefined, yearFilter: number | null | undefined, maxSalesTargetFilter: number | null | undefined, minSalesTargetFilter: number | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetBrandActualForView> {
        let url_ = this.baseUrl + "/api/services/app/BrandActual/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (memberCodeFilter !== undefined)
            url_ += "MemberCodeFilter=" + encodeURIComponent("" + memberCodeFilter) + "&";
        if (maxYearFilter !== undefined)
            url_ += "MaxYearFilter=" + encodeURIComponent("" + maxYearFilter) + "&";
        if (minYearFilter !== undefined)
            url_ += "MinYearFilter=" + encodeURIComponent("" + minYearFilter) + "&";
        if (maxMonthFilter !== undefined)
            url_ += "MaxMonthFilter=" + encodeURIComponent("" + maxMonthFilter) + "&";
        if (minMonthFilter !== undefined)
            url_ += "MinMonthFilter=" + encodeURIComponent("" + minMonthFilter) + "&";
        if (maxSalesAmountFilter !== undefined)
            url_ += "MaxSalesAmountFilter=" + encodeURIComponent("" + maxSalesAmountFilter) + "&";
        if (minSalesAmountFilter !== undefined)
            url_ += "MinSalesAmountFilter=" + encodeURIComponent("" + minSalesAmountFilter) + "&";
        if (brandCodeFilter !== undefined)
            url_ += "BrandCodeFilter=" + encodeURIComponent("" + brandCodeFilter) + "&";
        if (brandNameFilter !== undefined)
            url_ += "BrandNameFilter=" + encodeURIComponent("" + brandNameFilter) + "&";
        if (monthFilter !== undefined)
            url_ += "MonthFilter=" + encodeURIComponent("" + monthFilter) + "&";
        if (yearFilter !== undefined)
            url_ += "YearFilter=" + encodeURIComponent("" + yearFilter) + "&";
        if (maxSalesTargetFilter !== undefined)
            url_ += "MaxSalesTargetFilter=" + encodeURIComponent("" + maxSalesTargetFilter) + "&";
        if (minSalesTargetFilter !== undefined)
            url_ += "MinSalesTargetFilter=" + encodeURIComponent("" + minSalesTargetFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetBrandActualForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetBrandActualForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetBrandActualForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetBrandActualForView.fromJS(resultData200) : new PagedResultDtoOfGetBrandActualForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetBrandActualForView>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getBrandActualForEdit(id: number | null | undefined): Observable<GetBrandActualForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/BrandActual/GetBrandActualForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetBrandActualForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBrandActualForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetBrandActualForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetBrandActualForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetBrandActualForEdit(response: HttpResponseBase): Observable<GetBrandActualForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetBrandActualForEditOutput.fromJS(resultData200) : new GetBrandActualForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetBrandActualForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditBrandActualDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BrandActual/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BrandActual/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param memberCodeFilter (optional) 
     * @param maxYearFilter (optional) 
     * @param minYearFilter (optional) 
     * @param maxMonthFilter (optional) 
     * @param minMonthFilter (optional) 
     * @param maxSalesAmountFilter (optional) 
     * @param minSalesAmountFilter (optional) 
     * @param brandCodeFilter (optional) 
     * @param brandNameFilter (optional) 
     * @param monthFilter (optional) 
     * @param yearFilter (optional) 
     * @param maxSalesTargetFilter (optional) 
     * @param minSalesTargetFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getBrandActualToExcel(filter: string | null | undefined, memberCodeFilter: string | null | undefined, maxYearFilter: number | null | undefined, minYearFilter: number | null | undefined, maxMonthFilter: number | null | undefined, minMonthFilter: number | null | undefined, maxSalesAmountFilter: number | null | undefined, minSalesAmountFilter: number | null | undefined, brandCodeFilter: string | null | undefined, brandNameFilter: string | null | undefined, monthFilter: number | null | undefined, yearFilter: number | null | undefined, maxSalesTargetFilter: number | null | undefined, minSalesTargetFilter: number | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/BrandActual/GetBrandActualToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (memberCodeFilter !== undefined)
            url_ += "MemberCodeFilter=" + encodeURIComponent("" + memberCodeFilter) + "&";
        if (maxYearFilter !== undefined)
            url_ += "MaxYearFilter=" + encodeURIComponent("" + maxYearFilter) + "&";
        if (minYearFilter !== undefined)
            url_ += "MinYearFilter=" + encodeURIComponent("" + minYearFilter) + "&";
        if (maxMonthFilter !== undefined)
            url_ += "MaxMonthFilter=" + encodeURIComponent("" + maxMonthFilter) + "&";
        if (minMonthFilter !== undefined)
            url_ += "MinMonthFilter=" + encodeURIComponent("" + minMonthFilter) + "&";
        if (maxSalesAmountFilter !== undefined)
            url_ += "MaxSalesAmountFilter=" + encodeURIComponent("" + maxSalesAmountFilter) + "&";
        if (minSalesAmountFilter !== undefined)
            url_ += "MinSalesAmountFilter=" + encodeURIComponent("" + minSalesAmountFilter) + "&";
        if (brandCodeFilter !== undefined)
            url_ += "BrandCodeFilter=" + encodeURIComponent("" + brandCodeFilter) + "&";
        if (brandNameFilter !== undefined)
            url_ += "BrandNameFilter=" + encodeURIComponent("" + brandNameFilter) + "&";
        if (monthFilter !== undefined)
            url_ += "MonthFilter=" + encodeURIComponent("" + monthFilter) + "&";
        if (yearFilter !== undefined)
            url_ += "YearFilter=" + encodeURIComponent("" + yearFilter) + "&";
        if (maxSalesTargetFilter !== undefined)
            url_ += "MaxSalesTargetFilter=" + encodeURIComponent("" + maxSalesTargetFilter) + "&";
        if (minSalesTargetFilter !== undefined)
            url_ += "MinSalesTargetFilter=" + encodeURIComponent("" + minSalesTargetFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetBrandActualToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBrandActualToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetBrandActualToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }
}

@Injectable()
export class BrandActualInterfaceInsertHandlerServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param message (optional) 
     * @return Success
     */
    handle(message: SalesTrackingBrandActualInterfaceEventData | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BrandActualInterfaceInsertHandler/Handle";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(message);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processHandle(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHandle(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processHandle(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class BrandActualLogsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param maxBaselineDateFilter (optional) 
     * @param minBaselineDateFilter (optional) 
     * @param invoiceCodeFilter (optional) 
     * @param memberCodeFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, maxBaselineDateFilter: moment.Moment | null | undefined, minBaselineDateFilter: moment.Moment | null | undefined, invoiceCodeFilter: string | null | undefined, memberCodeFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetBrandActualLogForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/BrandActualLogs/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxBaselineDateFilter !== undefined)
            url_ += "MaxBaselineDateFilter=" + encodeURIComponent(maxBaselineDateFilter ? "" + maxBaselineDateFilter.toJSON() : "") + "&";
        if (minBaselineDateFilter !== undefined)
            url_ += "MinBaselineDateFilter=" + encodeURIComponent(minBaselineDateFilter ? "" + minBaselineDateFilter.toJSON() : "") + "&";
        if (invoiceCodeFilter !== undefined)
            url_ += "InvoiceCodeFilter=" + encodeURIComponent("" + invoiceCodeFilter) + "&";
        if (memberCodeFilter !== undefined)
            url_ += "MemberCodeFilter=" + encodeURIComponent("" + memberCodeFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetBrandActualLogForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetBrandActualLogForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetBrandActualLogForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetBrandActualLogForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetBrandActualLogForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetBrandActualLogForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getBrandActualLogForEdit(id: number | null | undefined): Observable<GetBrandActualLogForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/BrandActualLogs/GetBrandActualLogForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetBrandActualLogForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBrandActualLogForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetBrandActualLogForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetBrandActualLogForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetBrandActualLogForEdit(response: HttpResponseBase): Observable<GetBrandActualLogForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetBrandActualLogForEditOutput.fromJS(resultData200) : new GetBrandActualLogForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetBrandActualLogForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditBrandActualLogDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BrandActualLogs/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BrandActualLogs/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param maxBaselineDateFilter (optional) 
     * @param minBaselineDateFilter (optional) 
     * @param invoiceCodeFilter (optional) 
     * @param memberCodeFilter (optional) 
     * @return Success
     */
    getBrandActualLogsToExcel(filter: string | null | undefined, maxBaselineDateFilter: moment.Moment | null | undefined, minBaselineDateFilter: moment.Moment | null | undefined, invoiceCodeFilter: string | null | undefined, memberCodeFilter: string | null | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/BrandActualLogs/GetBrandActualLogsToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxBaselineDateFilter !== undefined)
            url_ += "MaxBaselineDateFilter=" + encodeURIComponent(maxBaselineDateFilter ? "" + maxBaselineDateFilter.toJSON() : "") + "&";
        if (minBaselineDateFilter !== undefined)
            url_ += "MinBaselineDateFilter=" + encodeURIComponent(minBaselineDateFilter ? "" + minBaselineDateFilter.toJSON() : "") + "&";
        if (invoiceCodeFilter !== undefined)
            url_ += "InvoiceCodeFilter=" + encodeURIComponent("" + invoiceCodeFilter) + "&";
        if (memberCodeFilter !== undefined)
            url_ += "MemberCodeFilter=" + encodeURIComponent("" + memberCodeFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetBrandActualLogsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBrandActualLogsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetBrandActualLogsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }
}

@Injectable()
export class BroadcastCategoryServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param masterCodeFilter (optional) 
     * @param detailCodeFilter (optional) 
     * @param parentCodeFilter (optional) 
     * @param nodePathFilter (optional) 
     * @param maxOrdinalFilter (optional) 
     * @param minOrdinalFilter (optional) 
     * @param statusFilter (optional) 
     * @param maxDetailValueNumberFilter (optional) 
     * @param minDetailValueNumberFilter (optional) 
     * @param maxLevelFilter (optional) 
     * @param minLevelFilter (optional) 
     * @param detailValueFilter (optional) 
     * @param detailValueUnSignFilter (optional) 
     * @param metaDataType (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllCategory(filter: string | null | undefined, masterCodeFilter: string | null | undefined, detailCodeFilter: string | null | undefined, parentCodeFilter: string | null | undefined, nodePathFilter: string | null | undefined, maxOrdinalFilter: number | null | undefined, minOrdinalFilter: number | null | undefined, statusFilter: string | null | undefined, maxDetailValueNumberFilter: number | null | undefined, minDetailValueNumberFilter: number | null | undefined, maxLevelFilter: number | null | undefined, minLevelFilter: number | null | undefined, detailValueFilter: string | null | undefined, detailValueUnSignFilter: string | null | undefined, metaDataType: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetMasterDetailForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/BroadcastCategory/GetAllCategory?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (masterCodeFilter !== undefined)
            url_ += "MasterCodeFilter=" + encodeURIComponent("" + masterCodeFilter) + "&";
        if (detailCodeFilter !== undefined)
            url_ += "DetailCodeFilter=" + encodeURIComponent("" + detailCodeFilter) + "&";
        if (parentCodeFilter !== undefined)
            url_ += "ParentCodeFilter=" + encodeURIComponent("" + parentCodeFilter) + "&";
        if (nodePathFilter !== undefined)
            url_ += "NodePathFilter=" + encodeURIComponent("" + nodePathFilter) + "&";
        if (maxOrdinalFilter !== undefined)
            url_ += "MaxOrdinalFilter=" + encodeURIComponent("" + maxOrdinalFilter) + "&";
        if (minOrdinalFilter !== undefined)
            url_ += "MinOrdinalFilter=" + encodeURIComponent("" + minOrdinalFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (maxDetailValueNumberFilter !== undefined)
            url_ += "MaxDetailValueNumberFilter=" + encodeURIComponent("" + maxDetailValueNumberFilter) + "&";
        if (minDetailValueNumberFilter !== undefined)
            url_ += "MinDetailValueNumberFilter=" + encodeURIComponent("" + minDetailValueNumberFilter) + "&";
        if (maxLevelFilter !== undefined)
            url_ += "MaxLevelFilter=" + encodeURIComponent("" + maxLevelFilter) + "&";
        if (minLevelFilter !== undefined)
            url_ += "MinLevelFilter=" + encodeURIComponent("" + minLevelFilter) + "&";
        if (detailValueFilter !== undefined)
            url_ += "DetailValueFilter=" + encodeURIComponent("" + detailValueFilter) + "&";
        if (detailValueUnSignFilter !== undefined)
            url_ += "DetailValueUnSignFilter=" + encodeURIComponent("" + detailValueUnSignFilter) + "&";
        if (metaDataType !== undefined)
            url_ += "MetaDataType=" + encodeURIComponent("" + metaDataType) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllCategory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCategory(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetMasterDetailForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetMasterDetailForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllCategory(response: HttpResponseBase): Observable<PagedResultDtoOfGetMasterDetailForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetMasterDetailForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetMasterDetailForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetMasterDetailForViewDto>(<any>null);
    }

    /**
     * @param ids (optional) 
     * @return Success
     */
    batchDeleteCategory(ids: number[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BroadcastCategory/BatchDeleteCategory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ids);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processBatchDeleteCategory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBatchDeleteCategory(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processBatchDeleteCategory(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEditCategory(input: CreateOrEditMasterDetailDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BroadcastCategory/CreateOrEditCategory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEditCategory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditCategory(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEditCategory(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    getAllMasterDetailForCommunication(): Observable<MasterDetailDto[]> {
        let url_ = this.baseUrl + "/api/services/app/BroadcastCategory/GetAllMasterDetailForCommunication";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllMasterDetailForCommunication(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllMasterDetailForCommunication(<any>response_);
                } catch (e) {
                    return <Observable<MasterDetailDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<MasterDetailDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllMasterDetailForCommunication(response: HttpResponseBase): Observable<MasterDetailDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(MasterDetailDto.fromJS(item));
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MasterDetailDto[]>(<any>null);
    }
}

@Injectable()
export class ButtonInteractionOverviewsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param maxYearFilter (optional) 
     * @param minYearFilter (optional) 
     * @param buttonEventFilter (optional) 
     * @param maxTotalCountInteractionFilter (optional) 
     * @param minTotalCountInteractionFilter (optional) 
     * @param maxCalculateDateFilter (optional) 
     * @param minCalculateDateFilter (optional) 
     * @param maxMonthFilter (optional) 
     * @param minMonthFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, maxYearFilter: number | null | undefined, minYearFilter: number | null | undefined, buttonEventFilter: string | null | undefined, maxTotalCountInteractionFilter: number | null | undefined, minTotalCountInteractionFilter: number | null | undefined, maxCalculateDateFilter: moment.Moment | null | undefined, minCalculateDateFilter: moment.Moment | null | undefined, maxMonthFilter: number | null | undefined, minMonthFilter: number | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetButtonInteractionOverviewForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/ButtonInteractionOverviews/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxYearFilter !== undefined)
            url_ += "MaxYearFilter=" + encodeURIComponent("" + maxYearFilter) + "&";
        if (minYearFilter !== undefined)
            url_ += "MinYearFilter=" + encodeURIComponent("" + minYearFilter) + "&";
        if (buttonEventFilter !== undefined)
            url_ += "ButtonEventFilter=" + encodeURIComponent("" + buttonEventFilter) + "&";
        if (maxTotalCountInteractionFilter !== undefined)
            url_ += "MaxTotalCountInteractionFilter=" + encodeURIComponent("" + maxTotalCountInteractionFilter) + "&";
        if (minTotalCountInteractionFilter !== undefined)
            url_ += "MinTotalCountInteractionFilter=" + encodeURIComponent("" + minTotalCountInteractionFilter) + "&";
        if (maxCalculateDateFilter !== undefined)
            url_ += "MaxCalculateDateFilter=" + encodeURIComponent(maxCalculateDateFilter ? "" + maxCalculateDateFilter.toJSON() : "") + "&";
        if (minCalculateDateFilter !== undefined)
            url_ += "MinCalculateDateFilter=" + encodeURIComponent(minCalculateDateFilter ? "" + minCalculateDateFilter.toJSON() : "") + "&";
        if (maxMonthFilter !== undefined)
            url_ += "MaxMonthFilter=" + encodeURIComponent("" + maxMonthFilter) + "&";
        if (minMonthFilter !== undefined)
            url_ += "MinMonthFilter=" + encodeURIComponent("" + minMonthFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetButtonInteractionOverviewForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetButtonInteractionOverviewForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetButtonInteractionOverviewForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetButtonInteractionOverviewForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetButtonInteractionOverviewForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetButtonInteractionOverviewForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getButtonInteractionOverviewForEdit(id: number | null | undefined): Observable<GetButtonInteractionOverviewForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/ButtonInteractionOverviews/GetButtonInteractionOverviewForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetButtonInteractionOverviewForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetButtonInteractionOverviewForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetButtonInteractionOverviewForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetButtonInteractionOverviewForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetButtonInteractionOverviewForEdit(response: HttpResponseBase): Observable<GetButtonInteractionOverviewForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetButtonInteractionOverviewForEditOutput.fromJS(resultData200) : new GetButtonInteractionOverviewForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetButtonInteractionOverviewForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditButtonInteractionOverviewDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ButtonInteractionOverviews/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ButtonInteractionOverviews/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param maxYearFilter (optional) 
     * @param minYearFilter (optional) 
     * @param buttonEventFilter (optional) 
     * @param maxTotalCountInteractionFilter (optional) 
     * @param minTotalCountInteractionFilter (optional) 
     * @param maxCalculateDateFilter (optional) 
     * @param minCalculateDateFilter (optional) 
     * @param maxMonthFilter (optional) 
     * @param minMonthFilter (optional) 
     * @return Success
     */
    getButtonInteractionOverviewsToExcel(filter: string | null | undefined, maxYearFilter: number | null | undefined, minYearFilter: number | null | undefined, buttonEventFilter: string | null | undefined, maxTotalCountInteractionFilter: number | null | undefined, minTotalCountInteractionFilter: number | null | undefined, maxCalculateDateFilter: moment.Moment | null | undefined, minCalculateDateFilter: moment.Moment | null | undefined, maxMonthFilter: number | null | undefined, minMonthFilter: number | null | undefined): Observable<PointFileDto> {
        let url_ = this.baseUrl + "/api/services/app/ButtonInteractionOverviews/GetButtonInteractionOverviewsToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxYearFilter !== undefined)
            url_ += "MaxYearFilter=" + encodeURIComponent("" + maxYearFilter) + "&";
        if (minYearFilter !== undefined)
            url_ += "MinYearFilter=" + encodeURIComponent("" + minYearFilter) + "&";
        if (buttonEventFilter !== undefined)
            url_ += "ButtonEventFilter=" + encodeURIComponent("" + buttonEventFilter) + "&";
        if (maxTotalCountInteractionFilter !== undefined)
            url_ += "MaxTotalCountInteractionFilter=" + encodeURIComponent("" + maxTotalCountInteractionFilter) + "&";
        if (minTotalCountInteractionFilter !== undefined)
            url_ += "MinTotalCountInteractionFilter=" + encodeURIComponent("" + minTotalCountInteractionFilter) + "&";
        if (maxCalculateDateFilter !== undefined)
            url_ += "MaxCalculateDateFilter=" + encodeURIComponent(maxCalculateDateFilter ? "" + maxCalculateDateFilter.toJSON() : "") + "&";
        if (minCalculateDateFilter !== undefined)
            url_ += "MinCalculateDateFilter=" + encodeURIComponent(minCalculateDateFilter ? "" + minCalculateDateFilter.toJSON() : "") + "&";
        if (maxMonthFilter !== undefined)
            url_ += "MaxMonthFilter=" + encodeURIComponent("" + maxMonthFilter) + "&";
        if (minMonthFilter !== undefined)
            url_ += "MinMonthFilter=" + encodeURIComponent("" + minMonthFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetButtonInteractionOverviewsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetButtonInteractionOverviewsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<PointFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PointFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetButtonInteractionOverviewsToExcel(response: HttpResponseBase): Observable<PointFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PointFileDto.fromJS(resultData200) : new PointFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PointFileDto>(<any>null);
    }
}

@Injectable()
export class CachingServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAllCaches(): Observable<ListResultDtoOfCacheDto> {
        let url_ = this.baseUrl + "/api/services/app/Caching/GetAllCaches";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllCaches(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCaches(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfCacheDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfCacheDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllCaches(response: HttpResponseBase): Observable<ListResultDtoOfCacheDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? ListResultDtoOfCacheDto.fromJS(resultData200) : new ListResultDtoOfCacheDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfCacheDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    clearCache(input: EntityDtoOfString | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Caching/ClearCache";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processClearCache(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClearCache(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processClearCache(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    clearAllCaches(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Caching/ClearAllCaches";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processClearAllCaches(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClearAllCaches(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processClearAllCaches(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class CampaignServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param text (optional) 
     * @param status (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllCampaignAppServic(text: string | null | undefined, status: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfCampaignResource> {
        let url_ = this.baseUrl + "/api/services/app/Campaign/GetAllCampaignAppServic?";
        if (text !== undefined)
            url_ += "Text=" + encodeURIComponent("" + text) + "&";
        if (status !== undefined)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllCampaignAppServic(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCampaignAppServic(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfCampaignResource>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfCampaignResource>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllCampaignAppServic(response: HttpResponseBase): Observable<PagedResultDtoOfCampaignResource> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfCampaignResource.fromJS(resultData200) : new PagedResultDtoOfCampaignResource();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfCampaignResource>(<any>null);
    }

    /**
     * @param memberCode (optional) 
     * @param memberSegment (optional) 
     * @return Success
     */
    getAllCampaignForApp(memberCode: string | null | undefined, memberSegment: string | null | undefined): Observable<GetCampaignViewForApp[]> {
        let url_ = this.baseUrl + "/api/services/app/Campaign/GetAllCampaignForApp?";
        if (memberCode !== undefined)
            url_ += "memberCode=" + encodeURIComponent("" + memberCode) + "&";
        if (memberSegment !== undefined)
            url_ += "memberSegment=" + encodeURIComponent("" + memberSegment) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllCampaignForApp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCampaignForApp(<any>response_);
                } catch (e) {
                    return <Observable<GetCampaignViewForApp[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetCampaignViewForApp[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllCampaignForApp(response: HttpResponseBase): Observable<GetCampaignViewForApp[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(GetCampaignViewForApp.fromJS(item));
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCampaignViewForApp[]>(<any>null);
    }

    /**
     * @param id (optional) 
     * @param memberCode (optional) 
     * @return Success
     */
    getCampaignViewForApp(id: number | null | undefined, memberCode: string | null | undefined): Observable<GetCampaignViewForAppDetail> {
        let url_ = this.baseUrl + "/api/services/app/Campaign/GetCampaignViewForApp?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (memberCode !== undefined)
            url_ += "MemberCode=" + encodeURIComponent("" + memberCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCampaignViewForApp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCampaignViewForApp(<any>response_);
                } catch (e) {
                    return <Observable<GetCampaignViewForAppDetail>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetCampaignViewForAppDetail>><any>_observableThrow(response_);
        }));
    }

    protected processGetCampaignViewForApp(response: HttpResponseBase): Observable<GetCampaignViewForAppDetail> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetCampaignViewForAppDetail.fromJS(resultData200) : new GetCampaignViewForAppDetail();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCampaignViewForAppDetail>(<any>null);
    }
}

@Injectable()
export class CampaignConditionsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param maxCampaignIDFilter (optional) 
     * @param minCampaignIDFilter (optional) 
     * @param maxProductIDFilter (optional) 
     * @param minProductIDFilter (optional) 
     * @param maxRequireQtyFilter (optional) 
     * @param minRequireQtyFilter (optional) 
     * @param maxRequireAmoFilter (optional) 
     * @param minRequireAmoFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, maxCampaignIDFilter: number | null | undefined, minCampaignIDFilter: number | null | undefined, maxProductIDFilter: number | null | undefined, minProductIDFilter: number | null | undefined, maxRequireQtyFilter: number | null | undefined, minRequireQtyFilter: number | null | undefined, maxRequireAmoFilter: number | null | undefined, minRequireAmoFilter: number | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetCampaignConditionForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/CampaignConditions/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxCampaignIDFilter !== undefined)
            url_ += "MaxCampaignIDFilter=" + encodeURIComponent("" + maxCampaignIDFilter) + "&";
        if (minCampaignIDFilter !== undefined)
            url_ += "MinCampaignIDFilter=" + encodeURIComponent("" + minCampaignIDFilter) + "&";
        if (maxProductIDFilter !== undefined)
            url_ += "MaxProductIDFilter=" + encodeURIComponent("" + maxProductIDFilter) + "&";
        if (minProductIDFilter !== undefined)
            url_ += "MinProductIDFilter=" + encodeURIComponent("" + minProductIDFilter) + "&";
        if (maxRequireQtyFilter !== undefined)
            url_ += "MaxRequireQtyFilter=" + encodeURIComponent("" + maxRequireQtyFilter) + "&";
        if (minRequireQtyFilter !== undefined)
            url_ += "MinRequireQtyFilter=" + encodeURIComponent("" + minRequireQtyFilter) + "&";
        if (maxRequireAmoFilter !== undefined)
            url_ += "MaxRequireAmoFilter=" + encodeURIComponent("" + maxRequireAmoFilter) + "&";
        if (minRequireAmoFilter !== undefined)
            url_ += "MinRequireAmoFilter=" + encodeURIComponent("" + minRequireAmoFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetCampaignConditionForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetCampaignConditionForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetCampaignConditionForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetCampaignConditionForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetCampaignConditionForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetCampaignConditionForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getCampaignConditionForEdit(id: number | null | undefined): Observable<GetCampaignConditionForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/CampaignConditions/GetCampaignConditionForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCampaignConditionForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCampaignConditionForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetCampaignConditionForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetCampaignConditionForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetCampaignConditionForEdit(response: HttpResponseBase): Observable<GetCampaignConditionForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetCampaignConditionForEditOutput.fromJS(resultData200) : new GetCampaignConditionForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCampaignConditionForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditCampaignConditionDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CampaignConditions/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CampaignConditions/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param maxCampaignIDFilter (optional) 
     * @param minCampaignIDFilter (optional) 
     * @param maxProductIDFilter (optional) 
     * @param minProductIDFilter (optional) 
     * @param maxRequireQtyFilter (optional) 
     * @param minRequireQtyFilter (optional) 
     * @param maxRequireAmoFilter (optional) 
     * @param minRequireAmoFilter (optional) 
     * @return Success
     */
    getCampaignConditionsToExcel(filter: string | null | undefined, maxCampaignIDFilter: number | null | undefined, minCampaignIDFilter: number | null | undefined, maxProductIDFilter: number | null | undefined, minProductIDFilter: number | null | undefined, maxRequireQtyFilter: number | null | undefined, minRequireQtyFilter: number | null | undefined, maxRequireAmoFilter: number | null | undefined, minRequireAmoFilter: number | null | undefined): Observable<CampaignManagementFileDto> {
        let url_ = this.baseUrl + "/api/services/app/CampaignConditions/GetCampaignConditionsToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxCampaignIDFilter !== undefined)
            url_ += "MaxCampaignIDFilter=" + encodeURIComponent("" + maxCampaignIDFilter) + "&";
        if (minCampaignIDFilter !== undefined)
            url_ += "MinCampaignIDFilter=" + encodeURIComponent("" + minCampaignIDFilter) + "&";
        if (maxProductIDFilter !== undefined)
            url_ += "MaxProductIDFilter=" + encodeURIComponent("" + maxProductIDFilter) + "&";
        if (minProductIDFilter !== undefined)
            url_ += "MinProductIDFilter=" + encodeURIComponent("" + minProductIDFilter) + "&";
        if (maxRequireQtyFilter !== undefined)
            url_ += "MaxRequireQtyFilter=" + encodeURIComponent("" + maxRequireQtyFilter) + "&";
        if (minRequireQtyFilter !== undefined)
            url_ += "MinRequireQtyFilter=" + encodeURIComponent("" + minRequireQtyFilter) + "&";
        if (maxRequireAmoFilter !== undefined)
            url_ += "MaxRequireAmoFilter=" + encodeURIComponent("" + maxRequireAmoFilter) + "&";
        if (minRequireAmoFilter !== undefined)
            url_ += "MinRequireAmoFilter=" + encodeURIComponent("" + minRequireAmoFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCampaignConditionsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCampaignConditionsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<CampaignManagementFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CampaignManagementFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetCampaignConditionsToExcel(response: HttpResponseBase): Observable<CampaignManagementFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? CampaignManagementFileDto.fromJS(resultData200) : new CampaignManagementFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CampaignManagementFileDto>(<any>null);
    }

    /**
     * @param campaignId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllConditionByCampaignId(campaignId: number | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetCampaignConditionForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/CampaignConditions/GetAllConditionByCampaignId?";
        if (campaignId !== undefined)
            url_ += "CampaignId=" + encodeURIComponent("" + campaignId) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllConditionByCampaignId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllConditionByCampaignId(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetCampaignConditionForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetCampaignConditionForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllConditionByCampaignId(response: HttpResponseBase): Observable<PagedResultDtoOfGetCampaignConditionForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetCampaignConditionForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetCampaignConditionForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetCampaignConditionForViewDto>(<any>null);
    }
}

@Injectable()
export class CampaignInfosServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param campaignNameFilter (optional) 
     * @param maxFromDateFilter (optional) 
     * @param minFromDateFilter (optional) 
     * @param maxToDateFilter (optional) 
     * @param minToDateFilter (optional) 
     * @param statusFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param addressFilter (optional) 
     * @param lNGFilter (optional) 
     * @param lATFilter (optional) 
     * @param campaignTypeFilter (optional) 
     * @param maxBudgetFilter (optional) 
     * @param minBudgetFilter (optional) 
     * @param maxNumberOfLeadFilter (optional) 
     * @param minNumberOfLeadFilter (optional) 
     * @param campaignCodeFilter (optional) 
     * @param campaignNameUnSignFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, campaignNameFilter: string | null | undefined, maxFromDateFilter: moment.Moment | null | undefined, minFromDateFilter: moment.Moment | null | undefined, maxToDateFilter: moment.Moment | null | undefined, minToDateFilter: moment.Moment | null | undefined, statusFilter: string | null | undefined, descriptionFilter: string | null | undefined, addressFilter: string | null | undefined, lNGFilter: string | null | undefined, lATFilter: string | null | undefined, campaignTypeFilter: string | null | undefined, maxBudgetFilter: number | null | undefined, minBudgetFilter: number | null | undefined, maxNumberOfLeadFilter: number | null | undefined, minNumberOfLeadFilter: number | null | undefined, campaignCodeFilter: string | null | undefined, campaignNameUnSignFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetCampaignInfoForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/CampaignInfos/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (campaignNameFilter !== undefined)
            url_ += "CampaignNameFilter=" + encodeURIComponent("" + campaignNameFilter) + "&";
        if (maxFromDateFilter !== undefined)
            url_ += "MaxFromDateFilter=" + encodeURIComponent(maxFromDateFilter ? "" + maxFromDateFilter.toJSON() : "") + "&";
        if (minFromDateFilter !== undefined)
            url_ += "MinFromDateFilter=" + encodeURIComponent(minFromDateFilter ? "" + minFromDateFilter.toJSON() : "") + "&";
        if (maxToDateFilter !== undefined)
            url_ += "MaxToDateFilter=" + encodeURIComponent(maxToDateFilter ? "" + maxToDateFilter.toJSON() : "") + "&";
        if (minToDateFilter !== undefined)
            url_ += "MinToDateFilter=" + encodeURIComponent(minToDateFilter ? "" + minToDateFilter.toJSON() : "") + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&";
        if (addressFilter !== undefined)
            url_ += "AddressFilter=" + encodeURIComponent("" + addressFilter) + "&";
        if (lNGFilter !== undefined)
            url_ += "LNGFilter=" + encodeURIComponent("" + lNGFilter) + "&";
        if (lATFilter !== undefined)
            url_ += "LATFilter=" + encodeURIComponent("" + lATFilter) + "&";
        if (campaignTypeFilter !== undefined)
            url_ += "CampaignTypeFilter=" + encodeURIComponent("" + campaignTypeFilter) + "&";
        if (maxBudgetFilter !== undefined)
            url_ += "MaxBudgetFilter=" + encodeURIComponent("" + maxBudgetFilter) + "&";
        if (minBudgetFilter !== undefined)
            url_ += "MinBudgetFilter=" + encodeURIComponent("" + minBudgetFilter) + "&";
        if (maxNumberOfLeadFilter !== undefined)
            url_ += "MaxNumberOfLeadFilter=" + encodeURIComponent("" + maxNumberOfLeadFilter) + "&";
        if (minNumberOfLeadFilter !== undefined)
            url_ += "MinNumberOfLeadFilter=" + encodeURIComponent("" + minNumberOfLeadFilter) + "&";
        if (campaignCodeFilter !== undefined)
            url_ += "CampaignCodeFilter=" + encodeURIComponent("" + campaignCodeFilter) + "&";
        if (campaignNameUnSignFilter !== undefined)
            url_ += "CampaignNameUnSignFilter=" + encodeURIComponent("" + campaignNameUnSignFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetCampaignInfoForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetCampaignInfoForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetCampaignInfoForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetCampaignInfoForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetCampaignInfoForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetCampaignInfoForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getCampaignInfoForEdit(id: number | null | undefined): Observable<GetCampaignInfoForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/CampaignInfos/GetCampaignInfoForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCampaignInfoForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCampaignInfoForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetCampaignInfoForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetCampaignInfoForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetCampaignInfoForEdit(response: HttpResponseBase): Observable<GetCampaignInfoForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetCampaignInfoForEditOutput.fromJS(resultData200) : new GetCampaignInfoForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCampaignInfoForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditCampaignInfoDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CampaignInfos/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CampaignInfos/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param campaignNameFilter (optional) 
     * @param maxFromDateFilter (optional) 
     * @param minFromDateFilter (optional) 
     * @param maxToDateFilter (optional) 
     * @param minToDateFilter (optional) 
     * @param statusFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param addressFilter (optional) 
     * @param lNGFilter (optional) 
     * @param lATFilter (optional) 
     * @param campaignTypeFilter (optional) 
     * @param maxBudgetFilter (optional) 
     * @param minBudgetFilter (optional) 
     * @param maxNumberOfLeadFilter (optional) 
     * @param minNumberOfLeadFilter (optional) 
     * @param campaignCodeFilter (optional) 
     * @param campaignNameUnSignFilter (optional) 
     * @return Success
     */
    getCampaignInfosToExcel(filter: string | null | undefined, campaignNameFilter: string | null | undefined, maxFromDateFilter: moment.Moment | null | undefined, minFromDateFilter: moment.Moment | null | undefined, maxToDateFilter: moment.Moment | null | undefined, minToDateFilter: moment.Moment | null | undefined, statusFilter: string | null | undefined, descriptionFilter: string | null | undefined, addressFilter: string | null | undefined, lNGFilter: string | null | undefined, lATFilter: string | null | undefined, campaignTypeFilter: string | null | undefined, maxBudgetFilter: number | null | undefined, minBudgetFilter: number | null | undefined, maxNumberOfLeadFilter: number | null | undefined, minNumberOfLeadFilter: number | null | undefined, campaignCodeFilter: string | null | undefined, campaignNameUnSignFilter: string | null | undefined): Observable<CampaignManagementFileDto> {
        let url_ = this.baseUrl + "/api/services/app/CampaignInfos/GetCampaignInfosToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (campaignNameFilter !== undefined)
            url_ += "CampaignNameFilter=" + encodeURIComponent("" + campaignNameFilter) + "&";
        if (maxFromDateFilter !== undefined)
            url_ += "MaxFromDateFilter=" + encodeURIComponent(maxFromDateFilter ? "" + maxFromDateFilter.toJSON() : "") + "&";
        if (minFromDateFilter !== undefined)
            url_ += "MinFromDateFilter=" + encodeURIComponent(minFromDateFilter ? "" + minFromDateFilter.toJSON() : "") + "&";
        if (maxToDateFilter !== undefined)
            url_ += "MaxToDateFilter=" + encodeURIComponent(maxToDateFilter ? "" + maxToDateFilter.toJSON() : "") + "&";
        if (minToDateFilter !== undefined)
            url_ += "MinToDateFilter=" + encodeURIComponent(minToDateFilter ? "" + minToDateFilter.toJSON() : "") + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&";
        if (addressFilter !== undefined)
            url_ += "AddressFilter=" + encodeURIComponent("" + addressFilter) + "&";
        if (lNGFilter !== undefined)
            url_ += "LNGFilter=" + encodeURIComponent("" + lNGFilter) + "&";
        if (lATFilter !== undefined)
            url_ += "LATFilter=" + encodeURIComponent("" + lATFilter) + "&";
        if (campaignTypeFilter !== undefined)
            url_ += "CampaignTypeFilter=" + encodeURIComponent("" + campaignTypeFilter) + "&";
        if (maxBudgetFilter !== undefined)
            url_ += "MaxBudgetFilter=" + encodeURIComponent("" + maxBudgetFilter) + "&";
        if (minBudgetFilter !== undefined)
            url_ += "MinBudgetFilter=" + encodeURIComponent("" + minBudgetFilter) + "&";
        if (maxNumberOfLeadFilter !== undefined)
            url_ += "MaxNumberOfLeadFilter=" + encodeURIComponent("" + maxNumberOfLeadFilter) + "&";
        if (minNumberOfLeadFilter !== undefined)
            url_ += "MinNumberOfLeadFilter=" + encodeURIComponent("" + minNumberOfLeadFilter) + "&";
        if (campaignCodeFilter !== undefined)
            url_ += "CampaignCodeFilter=" + encodeURIComponent("" + campaignCodeFilter) + "&";
        if (campaignNameUnSignFilter !== undefined)
            url_ += "CampaignNameUnSignFilter=" + encodeURIComponent("" + campaignNameUnSignFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCampaignInfosToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCampaignInfosToExcel(<any>response_);
                } catch (e) {
                    return <Observable<CampaignManagementFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CampaignManagementFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetCampaignInfosToExcel(response: HttpResponseBase): Observable<CampaignManagementFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? CampaignManagementFileDto.fromJS(resultData200) : new CampaignManagementFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CampaignManagementFileDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param campaignNameFilter (optional) 
     * @param maxFromDateFilter (optional) 
     * @param minFromDateFilter (optional) 
     * @param maxToDateFilter (optional) 
     * @param minToDateFilter (optional) 
     * @param statusFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param addressFilter (optional) 
     * @param lNGFilter (optional) 
     * @param lATFilter (optional) 
     * @param campaignTypeFilter (optional) 
     * @param maxBudgetFilter (optional) 
     * @param minBudgetFilter (optional) 
     * @param maxNumberOfLeadFilter (optional) 
     * @param minNumberOfLeadFilter (optional) 
     * @param campaignCodeFilter (optional) 
     * @param campaignNameUnSignFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getSearchCampaignInfoAsync(filter: string | null | undefined, campaignNameFilter: string | null | undefined, maxFromDateFilter: moment.Moment | null | undefined, minFromDateFilter: moment.Moment | null | undefined, maxToDateFilter: moment.Moment | null | undefined, minToDateFilter: moment.Moment | null | undefined, statusFilter: string | null | undefined, descriptionFilter: string | null | undefined, addressFilter: string | null | undefined, lNGFilter: string | null | undefined, lATFilter: string | null | undefined, campaignTypeFilter: string | null | undefined, maxBudgetFilter: number | null | undefined, minBudgetFilter: number | null | undefined, maxNumberOfLeadFilter: number | null | undefined, minNumberOfLeadFilter: number | null | undefined, campaignCodeFilter: string | null | undefined, campaignNameUnSignFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetCampaignInfoForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/CampaignInfos/GetSearchCampaignInfoAsync?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (campaignNameFilter !== undefined)
            url_ += "CampaignNameFilter=" + encodeURIComponent("" + campaignNameFilter) + "&";
        if (maxFromDateFilter !== undefined)
            url_ += "MaxFromDateFilter=" + encodeURIComponent(maxFromDateFilter ? "" + maxFromDateFilter.toJSON() : "") + "&";
        if (minFromDateFilter !== undefined)
            url_ += "MinFromDateFilter=" + encodeURIComponent(minFromDateFilter ? "" + minFromDateFilter.toJSON() : "") + "&";
        if (maxToDateFilter !== undefined)
            url_ += "MaxToDateFilter=" + encodeURIComponent(maxToDateFilter ? "" + maxToDateFilter.toJSON() : "") + "&";
        if (minToDateFilter !== undefined)
            url_ += "MinToDateFilter=" + encodeURIComponent(minToDateFilter ? "" + minToDateFilter.toJSON() : "") + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&";
        if (addressFilter !== undefined)
            url_ += "AddressFilter=" + encodeURIComponent("" + addressFilter) + "&";
        if (lNGFilter !== undefined)
            url_ += "LNGFilter=" + encodeURIComponent("" + lNGFilter) + "&";
        if (lATFilter !== undefined)
            url_ += "LATFilter=" + encodeURIComponent("" + lATFilter) + "&";
        if (campaignTypeFilter !== undefined)
            url_ += "CampaignTypeFilter=" + encodeURIComponent("" + campaignTypeFilter) + "&";
        if (maxBudgetFilter !== undefined)
            url_ += "MaxBudgetFilter=" + encodeURIComponent("" + maxBudgetFilter) + "&";
        if (minBudgetFilter !== undefined)
            url_ += "MinBudgetFilter=" + encodeURIComponent("" + minBudgetFilter) + "&";
        if (maxNumberOfLeadFilter !== undefined)
            url_ += "MaxNumberOfLeadFilter=" + encodeURIComponent("" + maxNumberOfLeadFilter) + "&";
        if (minNumberOfLeadFilter !== undefined)
            url_ += "MinNumberOfLeadFilter=" + encodeURIComponent("" + minNumberOfLeadFilter) + "&";
        if (campaignCodeFilter !== undefined)
            url_ += "CampaignCodeFilter=" + encodeURIComponent("" + campaignCodeFilter) + "&";
        if (campaignNameUnSignFilter !== undefined)
            url_ += "CampaignNameUnSignFilter=" + encodeURIComponent("" + campaignNameUnSignFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSearchCampaignInfoAsync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSearchCampaignInfoAsync(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetCampaignInfoForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetCampaignInfoForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetSearchCampaignInfoAsync(response: HttpResponseBase): Observable<PagedResultDtoOfGetCampaignInfoForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetCampaignInfoForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetCampaignInfoForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetCampaignInfoForViewDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEditUnsignAsync(input: GetCampaignInfoForEditOutput | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CampaignInfos/CreateOrEditUnsignAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEditUnsignAsync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditUnsignAsync(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEditUnsignAsync(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param entities (optional) 
     * @return Success
     */
    batchDeleteAsync(entities: CampaignInfoDto[] | null | undefined): Observable<MessageResultCampaignManagement> {
        let url_ = this.baseUrl + "/api/services/app/CampaignInfos/BatchDeleteAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entities);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processBatchDeleteAsync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBatchDeleteAsync(<any>response_);
                } catch (e) {
                    return <Observable<MessageResultCampaignManagement>><any>_observableThrow(e);
                }
            } else
                return <Observable<MessageResultCampaignManagement>><any>_observableThrow(response_);
        }));
    }

    protected processBatchDeleteAsync(response: HttpResponseBase): Observable<MessageResultCampaignManagement> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? MessageResultCampaignManagement.fromJS(resultData200) : new MessageResultCampaignManagement();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MessageResultCampaignManagement>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param campaignNameFilter (optional) 
     * @param maxFromDateFilter (optional) 
     * @param minFromDateFilter (optional) 
     * @param maxToDateFilter (optional) 
     * @param minToDateFilter (optional) 
     * @param statusFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param addressFilter (optional) 
     * @param lNGFilter (optional) 
     * @param lATFilter (optional) 
     * @param campaignTypeFilter (optional) 
     * @param maxBudgetFilter (optional) 
     * @param minBudgetFilter (optional) 
     * @param maxNumberOfLeadFilter (optional) 
     * @param minNumberOfLeadFilter (optional) 
     * @param campaignCodeFilter (optional) 
     * @param campaignNameUnSignFilter (optional) 
     * @return Success
     */
    getCampaignInfosToExcelExtAsync(filter: string | null | undefined, campaignNameFilter: string | null | undefined, maxFromDateFilter: moment.Moment | null | undefined, minFromDateFilter: moment.Moment | null | undefined, maxToDateFilter: moment.Moment | null | undefined, minToDateFilter: moment.Moment | null | undefined, statusFilter: string | null | undefined, descriptionFilter: string | null | undefined, addressFilter: string | null | undefined, lNGFilter: string | null | undefined, lATFilter: string | null | undefined, campaignTypeFilter: string | null | undefined, maxBudgetFilter: number | null | undefined, minBudgetFilter: number | null | undefined, maxNumberOfLeadFilter: number | null | undefined, minNumberOfLeadFilter: number | null | undefined, campaignCodeFilter: string | null | undefined, campaignNameUnSignFilter: string | null | undefined): Observable<CampaignManagementFileDto> {
        let url_ = this.baseUrl + "/api/services/app/CampaignInfos/GetCampaignInfosToExcelExtAsync?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (campaignNameFilter !== undefined)
            url_ += "CampaignNameFilter=" + encodeURIComponent("" + campaignNameFilter) + "&";
        if (maxFromDateFilter !== undefined)
            url_ += "MaxFromDateFilter=" + encodeURIComponent(maxFromDateFilter ? "" + maxFromDateFilter.toJSON() : "") + "&";
        if (minFromDateFilter !== undefined)
            url_ += "MinFromDateFilter=" + encodeURIComponent(minFromDateFilter ? "" + minFromDateFilter.toJSON() : "") + "&";
        if (maxToDateFilter !== undefined)
            url_ += "MaxToDateFilter=" + encodeURIComponent(maxToDateFilter ? "" + maxToDateFilter.toJSON() : "") + "&";
        if (minToDateFilter !== undefined)
            url_ += "MinToDateFilter=" + encodeURIComponent(minToDateFilter ? "" + minToDateFilter.toJSON() : "") + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&";
        if (addressFilter !== undefined)
            url_ += "AddressFilter=" + encodeURIComponent("" + addressFilter) + "&";
        if (lNGFilter !== undefined)
            url_ += "LNGFilter=" + encodeURIComponent("" + lNGFilter) + "&";
        if (lATFilter !== undefined)
            url_ += "LATFilter=" + encodeURIComponent("" + lATFilter) + "&";
        if (campaignTypeFilter !== undefined)
            url_ += "CampaignTypeFilter=" + encodeURIComponent("" + campaignTypeFilter) + "&";
        if (maxBudgetFilter !== undefined)
            url_ += "MaxBudgetFilter=" + encodeURIComponent("" + maxBudgetFilter) + "&";
        if (minBudgetFilter !== undefined)
            url_ += "MinBudgetFilter=" + encodeURIComponent("" + minBudgetFilter) + "&";
        if (maxNumberOfLeadFilter !== undefined)
            url_ += "MaxNumberOfLeadFilter=" + encodeURIComponent("" + maxNumberOfLeadFilter) + "&";
        if (minNumberOfLeadFilter !== undefined)
            url_ += "MinNumberOfLeadFilter=" + encodeURIComponent("" + minNumberOfLeadFilter) + "&";
        if (campaignCodeFilter !== undefined)
            url_ += "CampaignCodeFilter=" + encodeURIComponent("" + campaignCodeFilter) + "&";
        if (campaignNameUnSignFilter !== undefined)
            url_ += "CampaignNameUnSignFilter=" + encodeURIComponent("" + campaignNameUnSignFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCampaignInfosToExcelExtAsync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCampaignInfosToExcelExtAsync(<any>response_);
                } catch (e) {
                    return <Observable<CampaignManagementFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CampaignManagementFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetCampaignInfosToExcelExtAsync(response: HttpResponseBase): Observable<CampaignManagementFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? CampaignManagementFileDto.fromJS(resultData200) : new CampaignManagementFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CampaignManagementFileDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getCampaignSettingForEditCustomAsync(id: number | null | undefined): Observable<GetCampaignInfoForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/CampaignInfos/GetCampaignSettingForEditCustomAsync?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCampaignSettingForEditCustomAsync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCampaignSettingForEditCustomAsync(<any>response_);
                } catch (e) {
                    return <Observable<GetCampaignInfoForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetCampaignInfoForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetCampaignSettingForEditCustomAsync(response: HttpResponseBase): Observable<GetCampaignInfoForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetCampaignInfoForEditOutput.fromJS(resultData200) : new GetCampaignInfoForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCampaignInfoForEditOutput>(<any>null);
    }

    /**
     * @return Success
     */
    getGenerateCampaignInfosCode(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/CampaignInfos/GetGenerateCampaignInfosCode";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetGenerateCampaignInfosCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGenerateCampaignInfosCode(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetGenerateCampaignInfosCode(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }
}

@Injectable()
export class CampaignManagementServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param keyword (optional) 
     * @param status (optional) 
     * @param memberSegment (optional) 
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getListCampaign(keyword: string | null | undefined, status: string | null | undefined, memberSegment: string | null | undefined, fromDate: moment.Moment | null | undefined, toDate: moment.Moment | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfCampaignManagementDTO> {
        let url_ = this.baseUrl + "/api/services/app/CampaignManagement/GetListCampaign?";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (status !== undefined)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (memberSegment !== undefined)
            url_ += "MemberSegment=" + encodeURIComponent("" + memberSegment) + "&";
        if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toJSON() : "") + "&";
        if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toJSON() : "") + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetListCampaign(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetListCampaign(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfCampaignManagementDTO>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfCampaignManagementDTO>><any>_observableThrow(response_);
        }));
    }

    protected processGetListCampaign(response: HttpResponseBase): Observable<PagedResultDtoOfCampaignManagementDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfCampaignManagementDTO.fromJS(resultData200) : new PagedResultDtoOfCampaignManagementDTO();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfCampaignManagementDTO>(<any>null);
    }

    /**
     * @param campaignId (optional) 
     * @return Success
     */
    getCampaignById(campaignId: number | null | undefined): Observable<CampaignManagementDTO> {
        let url_ = this.baseUrl + "/api/services/app/CampaignManagement/GetCampaignById?";
        if (campaignId !== undefined)
            url_ += "campaignId=" + encodeURIComponent("" + campaignId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCampaignById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCampaignById(<any>response_);
                } catch (e) {
                    return <Observable<CampaignManagementDTO>><any>_observableThrow(e);
                }
            } else
                return <Observable<CampaignManagementDTO>><any>_observableThrow(response_);
        }));
    }

    protected processGetCampaignById(response: HttpResponseBase): Observable<CampaignManagementDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? CampaignManagementDTO.fromJS(resultData200) : new CampaignManagementDTO();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CampaignManagementDTO>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditCampaignManagementDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CampaignManagement/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    updateActive(input: UpdateActiveDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CampaignManagement/UpdateActive";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateActive(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateActive(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateActive(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param campaignId (optional) 
     * @return Success
     */
    getAllRewardItem(campaignId: number | null | undefined): Observable<RewardItemForListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CampaignManagement/GetAllRewardItem?";
        if (campaignId !== undefined)
            url_ += "campaignId=" + encodeURIComponent("" + campaignId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllRewardItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllRewardItem(<any>response_);
                } catch (e) {
                    return <Observable<RewardItemForListDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<RewardItemForListDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllRewardItem(response: HttpResponseBase): Observable<RewardItemForListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(RewardItemForListDto.fromJS(item));
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RewardItemForListDto[]>(<any>null);
    }

    /**
     * @param campaignId (optional) 
     * @return Success
     */
    getListRewardItem(campaignId: number | null | undefined): Observable<CampaignRewardItemForListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CampaignManagement/GetListRewardItem?";
        if (campaignId !== undefined)
            url_ += "campaignId=" + encodeURIComponent("" + campaignId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetListRewardItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetListRewardItem(<any>response_);
                } catch (e) {
                    return <Observable<CampaignRewardItemForListDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<CampaignRewardItemForListDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetListRewardItem(response: HttpResponseBase): Observable<CampaignRewardItemForListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(CampaignRewardItemForListDto.fromJS(item));
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CampaignRewardItemForListDto[]>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    insertCampaignReward(input: CampaignRewardItemForListDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CampaignManagement/InsertCampaignReward";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processInsertCampaignReward(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInsertCampaignReward(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processInsertCampaignReward(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param campaignId (optional) 
     * @return Success
     */
    cloneCampaign(campaignId: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CampaignManagement/CloneCampaign?";
        if (campaignId !== undefined)
            url_ += "campaignId=" + encodeURIComponent("" + campaignId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCloneCampaign(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCloneCampaign(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCloneCampaign(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class CampaignOverviewServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getData(): Observable<CampaignOverviewDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CampaignOverview/GetData";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetData(<any>response_);
                } catch (e) {
                    return <Observable<CampaignOverviewDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<CampaignOverviewDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetData(response: HttpResponseBase): Observable<CampaignOverviewDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(CampaignOverviewDto.fromJS(item));
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CampaignOverviewDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    exportFile(): Observable<PointFileDto> {
        let url_ = this.baseUrl + "/api/services/app/CampaignOverview/ExportFile";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processExportFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportFile(<any>response_);
                } catch (e) {
                    return <Observable<PointFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PointFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processExportFile(response: HttpResponseBase): Observable<PointFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PointFileDto.fromJS(resultData200) : new PointFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PointFileDto>(<any>null);
    }
}

@Injectable()
export class CampaignPerformanceOverviewsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param campaignNameFilter (optional) 
     * @param maxNumberOfSentFilter (optional) 
     * @param minNumberOfSentFilter (optional) 
     * @param maxNumberOfReceivedFilter (optional) 
     * @param minNumberOfReceivedFilter (optional) 
     * @param maxNumberOfSeenFilter (optional) 
     * @param minNumberOfSeenFilter (optional) 
     * @param maxNumberOfFailFilter (optional) 
     * @param minNumberOfFailFilter (optional) 
     * @param maxMonthFilter (optional) 
     * @param minMonthFilter (optional) 
     * @param maxYearFilter (optional) 
     * @param minYearFilter (optional) 
     * @param maxCampaignIdFilter (optional) 
     * @param minCampaignIdFilter (optional) 
     * @param maxCalculateDateFilter (optional) 
     * @param minCalculateDateFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, campaignNameFilter: string | null | undefined, maxNumberOfSentFilter: number | null | undefined, minNumberOfSentFilter: number | null | undefined, maxNumberOfReceivedFilter: number | null | undefined, minNumberOfReceivedFilter: number | null | undefined, maxNumberOfSeenFilter: number | null | undefined, minNumberOfSeenFilter: number | null | undefined, maxNumberOfFailFilter: number | null | undefined, minNumberOfFailFilter: number | null | undefined, maxMonthFilter: number | null | undefined, minMonthFilter: number | null | undefined, maxYearFilter: number | null | undefined, minYearFilter: number | null | undefined, maxCampaignIdFilter: number | null | undefined, minCampaignIdFilter: number | null | undefined, maxCalculateDateFilter: moment.Moment | null | undefined, minCalculateDateFilter: moment.Moment | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetCampaignPerformanceOverviewForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/CampaignPerformanceOverviews/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (campaignNameFilter !== undefined)
            url_ += "CampaignNameFilter=" + encodeURIComponent("" + campaignNameFilter) + "&";
        if (maxNumberOfSentFilter !== undefined)
            url_ += "MaxNumberOfSentFilter=" + encodeURIComponent("" + maxNumberOfSentFilter) + "&";
        if (minNumberOfSentFilter !== undefined)
            url_ += "MinNumberOfSentFilter=" + encodeURIComponent("" + minNumberOfSentFilter) + "&";
        if (maxNumberOfReceivedFilter !== undefined)
            url_ += "MaxNumberOfReceivedFilter=" + encodeURIComponent("" + maxNumberOfReceivedFilter) + "&";
        if (minNumberOfReceivedFilter !== undefined)
            url_ += "MinNumberOfReceivedFilter=" + encodeURIComponent("" + minNumberOfReceivedFilter) + "&";
        if (maxNumberOfSeenFilter !== undefined)
            url_ += "MaxNumberOfSeenFilter=" + encodeURIComponent("" + maxNumberOfSeenFilter) + "&";
        if (minNumberOfSeenFilter !== undefined)
            url_ += "MinNumberOfSeenFilter=" + encodeURIComponent("" + minNumberOfSeenFilter) + "&";
        if (maxNumberOfFailFilter !== undefined)
            url_ += "MaxNumberOfFailFilter=" + encodeURIComponent("" + maxNumberOfFailFilter) + "&";
        if (minNumberOfFailFilter !== undefined)
            url_ += "MinNumberOfFailFilter=" + encodeURIComponent("" + minNumberOfFailFilter) + "&";
        if (maxMonthFilter !== undefined)
            url_ += "MaxMonthFilter=" + encodeURIComponent("" + maxMonthFilter) + "&";
        if (minMonthFilter !== undefined)
            url_ += "MinMonthFilter=" + encodeURIComponent("" + minMonthFilter) + "&";
        if (maxYearFilter !== undefined)
            url_ += "MaxYearFilter=" + encodeURIComponent("" + maxYearFilter) + "&";
        if (minYearFilter !== undefined)
            url_ += "MinYearFilter=" + encodeURIComponent("" + minYearFilter) + "&";
        if (maxCampaignIdFilter !== undefined)
            url_ += "MaxCampaignIdFilter=" + encodeURIComponent("" + maxCampaignIdFilter) + "&";
        if (minCampaignIdFilter !== undefined)
            url_ += "MinCampaignIdFilter=" + encodeURIComponent("" + minCampaignIdFilter) + "&";
        if (maxCalculateDateFilter !== undefined)
            url_ += "MaxCalculateDateFilter=" + encodeURIComponent(maxCalculateDateFilter ? "" + maxCalculateDateFilter.toJSON() : "") + "&";
        if (minCalculateDateFilter !== undefined)
            url_ += "MinCalculateDateFilter=" + encodeURIComponent(minCalculateDateFilter ? "" + minCalculateDateFilter.toJSON() : "") + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetCampaignPerformanceOverviewForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetCampaignPerformanceOverviewForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetCampaignPerformanceOverviewForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetCampaignPerformanceOverviewForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetCampaignPerformanceOverviewForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetCampaignPerformanceOverviewForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getCampaignPerformanceOverviewForEdit(id: number | null | undefined): Observable<GetCampaignPerformanceOverviewForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/CampaignPerformanceOverviews/GetCampaignPerformanceOverviewForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCampaignPerformanceOverviewForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCampaignPerformanceOverviewForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetCampaignPerformanceOverviewForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetCampaignPerformanceOverviewForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetCampaignPerformanceOverviewForEdit(response: HttpResponseBase): Observable<GetCampaignPerformanceOverviewForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetCampaignPerformanceOverviewForEditOutput.fromJS(resultData200) : new GetCampaignPerformanceOverviewForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCampaignPerformanceOverviewForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditCampaignPerformanceOverviewDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CampaignPerformanceOverviews/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CampaignPerformanceOverviews/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param campaignNameFilter (optional) 
     * @param maxNumberOfSentFilter (optional) 
     * @param minNumberOfSentFilter (optional) 
     * @param maxNumberOfReceivedFilter (optional) 
     * @param minNumberOfReceivedFilter (optional) 
     * @param maxNumberOfSeenFilter (optional) 
     * @param minNumberOfSeenFilter (optional) 
     * @param maxNumberOfFailFilter (optional) 
     * @param minNumberOfFailFilter (optional) 
     * @param maxMonthFilter (optional) 
     * @param minMonthFilter (optional) 
     * @param maxYearFilter (optional) 
     * @param minYearFilter (optional) 
     * @param maxCampaignIdFilter (optional) 
     * @param minCampaignIdFilter (optional) 
     * @param maxCalculateDateFilter (optional) 
     * @param minCalculateDateFilter (optional) 
     * @return Success
     */
    getCampaignPerformanceOverviewsToExcel(filter: string | null | undefined, campaignNameFilter: string | null | undefined, maxNumberOfSentFilter: number | null | undefined, minNumberOfSentFilter: number | null | undefined, maxNumberOfReceivedFilter: number | null | undefined, minNumberOfReceivedFilter: number | null | undefined, maxNumberOfSeenFilter: number | null | undefined, minNumberOfSeenFilter: number | null | undefined, maxNumberOfFailFilter: number | null | undefined, minNumberOfFailFilter: number | null | undefined, maxMonthFilter: number | null | undefined, minMonthFilter: number | null | undefined, maxYearFilter: number | null | undefined, minYearFilter: number | null | undefined, maxCampaignIdFilter: number | null | undefined, minCampaignIdFilter: number | null | undefined, maxCalculateDateFilter: moment.Moment | null | undefined, minCalculateDateFilter: moment.Moment | null | undefined): Observable<PointFileDto> {
        let url_ = this.baseUrl + "/api/services/app/CampaignPerformanceOverviews/GetCampaignPerformanceOverviewsToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (campaignNameFilter !== undefined)
            url_ += "CampaignNameFilter=" + encodeURIComponent("" + campaignNameFilter) + "&";
        if (maxNumberOfSentFilter !== undefined)
            url_ += "MaxNumberOfSentFilter=" + encodeURIComponent("" + maxNumberOfSentFilter) + "&";
        if (minNumberOfSentFilter !== undefined)
            url_ += "MinNumberOfSentFilter=" + encodeURIComponent("" + minNumberOfSentFilter) + "&";
        if (maxNumberOfReceivedFilter !== undefined)
            url_ += "MaxNumberOfReceivedFilter=" + encodeURIComponent("" + maxNumberOfReceivedFilter) + "&";
        if (minNumberOfReceivedFilter !== undefined)
            url_ += "MinNumberOfReceivedFilter=" + encodeURIComponent("" + minNumberOfReceivedFilter) + "&";
        if (maxNumberOfSeenFilter !== undefined)
            url_ += "MaxNumberOfSeenFilter=" + encodeURIComponent("" + maxNumberOfSeenFilter) + "&";
        if (minNumberOfSeenFilter !== undefined)
            url_ += "MinNumberOfSeenFilter=" + encodeURIComponent("" + minNumberOfSeenFilter) + "&";
        if (maxNumberOfFailFilter !== undefined)
            url_ += "MaxNumberOfFailFilter=" + encodeURIComponent("" + maxNumberOfFailFilter) + "&";
        if (minNumberOfFailFilter !== undefined)
            url_ += "MinNumberOfFailFilter=" + encodeURIComponent("" + minNumberOfFailFilter) + "&";
        if (maxMonthFilter !== undefined)
            url_ += "MaxMonthFilter=" + encodeURIComponent("" + maxMonthFilter) + "&";
        if (minMonthFilter !== undefined)
            url_ += "MinMonthFilter=" + encodeURIComponent("" + minMonthFilter) + "&";
        if (maxYearFilter !== undefined)
            url_ += "MaxYearFilter=" + encodeURIComponent("" + maxYearFilter) + "&";
        if (minYearFilter !== undefined)
            url_ += "MinYearFilter=" + encodeURIComponent("" + minYearFilter) + "&";
        if (maxCampaignIdFilter !== undefined)
            url_ += "MaxCampaignIdFilter=" + encodeURIComponent("" + maxCampaignIdFilter) + "&";
        if (minCampaignIdFilter !== undefined)
            url_ += "MinCampaignIdFilter=" + encodeURIComponent("" + minCampaignIdFilter) + "&";
        if (maxCalculateDateFilter !== undefined)
            url_ += "MaxCalculateDateFilter=" + encodeURIComponent(maxCalculateDateFilter ? "" + maxCalculateDateFilter.toJSON() : "") + "&";
        if (minCalculateDateFilter !== undefined)
            url_ += "MinCalculateDateFilter=" + encodeURIComponent(minCalculateDateFilter ? "" + minCalculateDateFilter.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCampaignPerformanceOverviewsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCampaignPerformanceOverviewsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<PointFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PointFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetCampaignPerformanceOverviewsToExcel(response: HttpResponseBase): Observable<PointFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PointFileDto.fromJS(resultData200) : new PointFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PointFileDto>(<any>null);
    }
}

@Injectable()
export class CampaignsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param codeFilter (optional) 
     * @param nameFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param isActiveFilter (optional) 
     * @param maxEffectiveFromFilter (optional) 
     * @param minEffectiveFromFilter (optional) 
     * @param maxEffectiveToFilter (optional) 
     * @param minEffectiveToFilter (optional) 
     * @param maxEstimatedMembersFilter (optional) 
     * @param minEstimatedMembersFilter (optional) 
     * @param maxEstimatedBudgetFilter (optional) 
     * @param minEstimatedBudgetFilter (optional) 
     * @param maxEstimatedRevenueFilter (optional) 
     * @param minEstimatedRevenueFilter (optional) 
     * @param approverFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, codeFilter: string | null | undefined, nameFilter: string | null | undefined, descriptionFilter: string | null | undefined, isActiveFilter: number | null | undefined, maxEffectiveFromFilter: moment.Moment | null | undefined, minEffectiveFromFilter: moment.Moment | null | undefined, maxEffectiveToFilter: moment.Moment | null | undefined, minEffectiveToFilter: moment.Moment | null | undefined, maxEstimatedMembersFilter: number | null | undefined, minEstimatedMembersFilter: number | null | undefined, maxEstimatedBudgetFilter: number | null | undefined, minEstimatedBudgetFilter: number | null | undefined, maxEstimatedRevenueFilter: number | null | undefined, minEstimatedRevenueFilter: number | null | undefined, approverFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetCampaignForView> {
        let url_ = this.baseUrl + "/api/services/app/Campaigns/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&";
        if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&";
        if (isActiveFilter !== undefined)
            url_ += "IsActiveFilter=" + encodeURIComponent("" + isActiveFilter) + "&";
        if (maxEffectiveFromFilter !== undefined)
            url_ += "MaxEffectiveFromFilter=" + encodeURIComponent(maxEffectiveFromFilter ? "" + maxEffectiveFromFilter.toJSON() : "") + "&";
        if (minEffectiveFromFilter !== undefined)
            url_ += "MinEffectiveFromFilter=" + encodeURIComponent(minEffectiveFromFilter ? "" + minEffectiveFromFilter.toJSON() : "") + "&";
        if (maxEffectiveToFilter !== undefined)
            url_ += "MaxEffectiveToFilter=" + encodeURIComponent(maxEffectiveToFilter ? "" + maxEffectiveToFilter.toJSON() : "") + "&";
        if (minEffectiveToFilter !== undefined)
            url_ += "MinEffectiveToFilter=" + encodeURIComponent(minEffectiveToFilter ? "" + minEffectiveToFilter.toJSON() : "") + "&";
        if (maxEstimatedMembersFilter !== undefined)
            url_ += "MaxEstimatedMembersFilter=" + encodeURIComponent("" + maxEstimatedMembersFilter) + "&";
        if (minEstimatedMembersFilter !== undefined)
            url_ += "MinEstimatedMembersFilter=" + encodeURIComponent("" + minEstimatedMembersFilter) + "&";
        if (maxEstimatedBudgetFilter !== undefined)
            url_ += "MaxEstimatedBudgetFilter=" + encodeURIComponent("" + maxEstimatedBudgetFilter) + "&";
        if (minEstimatedBudgetFilter !== undefined)
            url_ += "MinEstimatedBudgetFilter=" + encodeURIComponent("" + minEstimatedBudgetFilter) + "&";
        if (maxEstimatedRevenueFilter !== undefined)
            url_ += "MaxEstimatedRevenueFilter=" + encodeURIComponent("" + maxEstimatedRevenueFilter) + "&";
        if (minEstimatedRevenueFilter !== undefined)
            url_ += "MinEstimatedRevenueFilter=" + encodeURIComponent("" + minEstimatedRevenueFilter) + "&";
        if (approverFilter !== undefined)
            url_ += "ApproverFilter=" + encodeURIComponent("" + approverFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetCampaignForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetCampaignForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetCampaignForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetCampaignForView.fromJS(resultData200) : new PagedResultDtoOfGetCampaignForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetCampaignForView>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getCampaignForEdit(id: number | null | undefined): Observable<GetCampaignForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Campaigns/GetCampaignForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCampaignForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCampaignForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetCampaignForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetCampaignForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetCampaignForEdit(response: HttpResponseBase): Observable<GetCampaignForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetCampaignForEditOutput.fromJS(resultData200) : new GetCampaignForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCampaignForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditCampaignDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Campaigns/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Campaigns/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param codeFilter (optional) 
     * @param nameFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param isActiveFilter (optional) 
     * @param maxEffectiveFromFilter (optional) 
     * @param minEffectiveFromFilter (optional) 
     * @param maxEffectiveToFilter (optional) 
     * @param minEffectiveToFilter (optional) 
     * @param maxEstimatedMembersFilter (optional) 
     * @param minEstimatedMembersFilter (optional) 
     * @param maxEstimatedBudgetFilter (optional) 
     * @param minEstimatedBudgetFilter (optional) 
     * @param maxEstimatedRevenueFilter (optional) 
     * @param minEstimatedRevenueFilter (optional) 
     * @param approverFilter (optional) 
     * @return Success
     */
    getCampaignsToExcel(filter: string | null | undefined, codeFilter: string | null | undefined, nameFilter: string | null | undefined, descriptionFilter: string | null | undefined, isActiveFilter: number | null | undefined, maxEffectiveFromFilter: moment.Moment | null | undefined, minEffectiveFromFilter: moment.Moment | null | undefined, maxEffectiveToFilter: moment.Moment | null | undefined, minEffectiveToFilter: moment.Moment | null | undefined, maxEstimatedMembersFilter: number | null | undefined, minEstimatedMembersFilter: number | null | undefined, maxEstimatedBudgetFilter: number | null | undefined, minEstimatedBudgetFilter: number | null | undefined, maxEstimatedRevenueFilter: number | null | undefined, minEstimatedRevenueFilter: number | null | undefined, approverFilter: string | null | undefined): Observable<PointFileDto> {
        let url_ = this.baseUrl + "/api/services/app/Campaigns/GetCampaignsToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&";
        if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&";
        if (isActiveFilter !== undefined)
            url_ += "IsActiveFilter=" + encodeURIComponent("" + isActiveFilter) + "&";
        if (maxEffectiveFromFilter !== undefined)
            url_ += "MaxEffectiveFromFilter=" + encodeURIComponent(maxEffectiveFromFilter ? "" + maxEffectiveFromFilter.toJSON() : "") + "&";
        if (minEffectiveFromFilter !== undefined)
            url_ += "MinEffectiveFromFilter=" + encodeURIComponent(minEffectiveFromFilter ? "" + minEffectiveFromFilter.toJSON() : "") + "&";
        if (maxEffectiveToFilter !== undefined)
            url_ += "MaxEffectiveToFilter=" + encodeURIComponent(maxEffectiveToFilter ? "" + maxEffectiveToFilter.toJSON() : "") + "&";
        if (minEffectiveToFilter !== undefined)
            url_ += "MinEffectiveToFilter=" + encodeURIComponent(minEffectiveToFilter ? "" + minEffectiveToFilter.toJSON() : "") + "&";
        if (maxEstimatedMembersFilter !== undefined)
            url_ += "MaxEstimatedMembersFilter=" + encodeURIComponent("" + maxEstimatedMembersFilter) + "&";
        if (minEstimatedMembersFilter !== undefined)
            url_ += "MinEstimatedMembersFilter=" + encodeURIComponent("" + minEstimatedMembersFilter) + "&";
        if (maxEstimatedBudgetFilter !== undefined)
            url_ += "MaxEstimatedBudgetFilter=" + encodeURIComponent("" + maxEstimatedBudgetFilter) + "&";
        if (minEstimatedBudgetFilter !== undefined)
            url_ += "MinEstimatedBudgetFilter=" + encodeURIComponent("" + minEstimatedBudgetFilter) + "&";
        if (maxEstimatedRevenueFilter !== undefined)
            url_ += "MaxEstimatedRevenueFilter=" + encodeURIComponent("" + maxEstimatedRevenueFilter) + "&";
        if (minEstimatedRevenueFilter !== undefined)
            url_ += "MinEstimatedRevenueFilter=" + encodeURIComponent("" + minEstimatedRevenueFilter) + "&";
        if (approverFilter !== undefined)
            url_ += "ApproverFilter=" + encodeURIComponent("" + approverFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCampaignsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCampaignsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<PointFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PointFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetCampaignsToExcel(response: HttpResponseBase): Observable<PointFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PointFileDto.fromJS(resultData200) : new PointFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PointFileDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    checkOrAdjustmentPoint(input: CheckOrAdjustmentPointInput | null | undefined): Observable<CheckOrAdjustmentPointResponse> {
        let url_ = this.baseUrl + "/api/services/app/Campaigns/CheckOrAdjustmentPoint";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCheckOrAdjustmentPoint(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckOrAdjustmentPoint(<any>response_);
                } catch (e) {
                    return <Observable<CheckOrAdjustmentPointResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<CheckOrAdjustmentPointResponse>><any>_observableThrow(response_);
        }));
    }

    protected processCheckOrAdjustmentPoint(response: HttpResponseBase): Observable<CheckOrAdjustmentPointResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? CheckOrAdjustmentPointResponse.fromJS(resultData200) : new CheckOrAdjustmentPointResponse();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CheckOrAdjustmentPointResponse>(<any>null);
    }

    /**
     * @return Success
     */
    getAllCampaign(): Observable<PagedResultDtoOfGetCampaignForView> {
        let url_ = this.baseUrl + "/api/services/app/Campaigns/GetAllCampaign";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllCampaign(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCampaign(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetCampaignForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetCampaignForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllCampaign(response: HttpResponseBase): Observable<PagedResultDtoOfGetCampaignForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetCampaignForView.fromJS(resultData200) : new PagedResultDtoOfGetCampaignForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetCampaignForView>(<any>null);
    }
}

@Injectable()
export class CampaignSettingsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditCampaignSettingDto | null | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/CampaignSettings/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }
}

@Injectable()
export class CampaignWorkshiftInfosServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param maxCampaignIDFilter (optional) 
     * @param minCampaignIDFilter (optional) 
     * @param workshiftNameFilter (optional) 
     * @param maxFromdateFilter (optional) 
     * @param minFromdateFilter (optional) 
     * @param maxTodateFilter (optional) 
     * @param minTodateFilter (optional) 
     * @param statusFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, maxCampaignIDFilter: number | null | undefined, minCampaignIDFilter: number | null | undefined, workshiftNameFilter: string | null | undefined, maxFromdateFilter: moment.Moment | null | undefined, minFromdateFilter: moment.Moment | null | undefined, maxTodateFilter: moment.Moment | null | undefined, minTodateFilter: moment.Moment | null | undefined, statusFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetCampaignWorkshiftInfoForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/CampaignWorkshiftInfos/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxCampaignIDFilter !== undefined)
            url_ += "MaxCampaignIDFilter=" + encodeURIComponent("" + maxCampaignIDFilter) + "&";
        if (minCampaignIDFilter !== undefined)
            url_ += "MinCampaignIDFilter=" + encodeURIComponent("" + minCampaignIDFilter) + "&";
        if (workshiftNameFilter !== undefined)
            url_ += "WorkshiftNameFilter=" + encodeURIComponent("" + workshiftNameFilter) + "&";
        if (maxFromdateFilter !== undefined)
            url_ += "MaxFromdateFilter=" + encodeURIComponent(maxFromdateFilter ? "" + maxFromdateFilter.toJSON() : "") + "&";
        if (minFromdateFilter !== undefined)
            url_ += "MinFromdateFilter=" + encodeURIComponent(minFromdateFilter ? "" + minFromdateFilter.toJSON() : "") + "&";
        if (maxTodateFilter !== undefined)
            url_ += "MaxTodateFilter=" + encodeURIComponent(maxTodateFilter ? "" + maxTodateFilter.toJSON() : "") + "&";
        if (minTodateFilter !== undefined)
            url_ += "MinTodateFilter=" + encodeURIComponent(minTodateFilter ? "" + minTodateFilter.toJSON() : "") + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetCampaignWorkshiftInfoForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetCampaignWorkshiftInfoForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetCampaignWorkshiftInfoForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetCampaignWorkshiftInfoForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetCampaignWorkshiftInfoForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetCampaignWorkshiftInfoForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getCampaignWorkshiftInfoForEdit(id: number | null | undefined): Observable<GetCampaignWorkshiftInfoForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/CampaignWorkshiftInfos/GetCampaignWorkshiftInfoForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCampaignWorkshiftInfoForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCampaignWorkshiftInfoForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetCampaignWorkshiftInfoForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetCampaignWorkshiftInfoForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetCampaignWorkshiftInfoForEdit(response: HttpResponseBase): Observable<GetCampaignWorkshiftInfoForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetCampaignWorkshiftInfoForEditOutput.fromJS(resultData200) : new GetCampaignWorkshiftInfoForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCampaignWorkshiftInfoForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditCampaignWorkshiftInfoDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CampaignWorkshiftInfos/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CampaignWorkshiftInfos/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param maxCampaignIDFilter (optional) 
     * @param minCampaignIDFilter (optional) 
     * @param workshiftNameFilter (optional) 
     * @param maxFromdateFilter (optional) 
     * @param minFromdateFilter (optional) 
     * @param maxTodateFilter (optional) 
     * @param minTodateFilter (optional) 
     * @param statusFilter (optional) 
     * @return Success
     */
    getCampaignWorkshiftInfosToExcel(filter: string | null | undefined, maxCampaignIDFilter: number | null | undefined, minCampaignIDFilter: number | null | undefined, workshiftNameFilter: string | null | undefined, maxFromdateFilter: moment.Moment | null | undefined, minFromdateFilter: moment.Moment | null | undefined, maxTodateFilter: moment.Moment | null | undefined, minTodateFilter: moment.Moment | null | undefined, statusFilter: string | null | undefined): Observable<CampaignManagementFileDto> {
        let url_ = this.baseUrl + "/api/services/app/CampaignWorkshiftInfos/GetCampaignWorkshiftInfosToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxCampaignIDFilter !== undefined)
            url_ += "MaxCampaignIDFilter=" + encodeURIComponent("" + maxCampaignIDFilter) + "&";
        if (minCampaignIDFilter !== undefined)
            url_ += "MinCampaignIDFilter=" + encodeURIComponent("" + minCampaignIDFilter) + "&";
        if (workshiftNameFilter !== undefined)
            url_ += "WorkshiftNameFilter=" + encodeURIComponent("" + workshiftNameFilter) + "&";
        if (maxFromdateFilter !== undefined)
            url_ += "MaxFromdateFilter=" + encodeURIComponent(maxFromdateFilter ? "" + maxFromdateFilter.toJSON() : "") + "&";
        if (minFromdateFilter !== undefined)
            url_ += "MinFromdateFilter=" + encodeURIComponent(minFromdateFilter ? "" + minFromdateFilter.toJSON() : "") + "&";
        if (maxTodateFilter !== undefined)
            url_ += "MaxTodateFilter=" + encodeURIComponent(maxTodateFilter ? "" + maxTodateFilter.toJSON() : "") + "&";
        if (minTodateFilter !== undefined)
            url_ += "MinTodateFilter=" + encodeURIComponent(minTodateFilter ? "" + minTodateFilter.toJSON() : "") + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCampaignWorkshiftInfosToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCampaignWorkshiftInfosToExcel(<any>response_);
                } catch (e) {
                    return <Observable<CampaignManagementFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CampaignManagementFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetCampaignWorkshiftInfosToExcel(response: HttpResponseBase): Observable<CampaignManagementFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? CampaignManagementFileDto.fromJS(resultData200) : new CampaignManagementFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CampaignManagementFileDto>(<any>null);
    }
}

@Injectable()
export class CashierAccountServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    loginCasherAsync(input: CasherInfoInput | null | undefined): Observable<CasherInfoDto> {
        let url_ = this.baseUrl + "/api/services/app/CashierAccountService/LoginCasherAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processLoginCasherAsync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLoginCasherAsync(<any>response_);
                } catch (e) {
                    return <Observable<CasherInfoDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CasherInfoDto>><any>_observableThrow(response_);
        }));
    }

    protected processLoginCasherAsync(response: HttpResponseBase): Observable<CasherInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? CasherInfoDto.fromJS(resultData200) : new CasherInfoDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CasherInfoDto>(<any>null);
    }
}

@Injectable()
export class CategoryServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param codeFilter (optional) 
     * @param nameFilter (optional) 
     * @param maxOrdinalFilter (optional) 
     * @param minOrdinalFilter (optional) 
     * @param statusFilter (optional) 
     * @param typeFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, codeFilter: string | null | undefined, nameFilter: string | null | undefined, maxOrdinalFilter: number | null | undefined, minOrdinalFilter: number | null | undefined, statusFilter: string | null | undefined, typeFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetCategoryForView> {
        let url_ = this.baseUrl + "/api/services/app/Category/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&";
        if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (maxOrdinalFilter !== undefined)
            url_ += "MaxOrdinalFilter=" + encodeURIComponent("" + maxOrdinalFilter) + "&";
        if (minOrdinalFilter !== undefined)
            url_ += "MinOrdinalFilter=" + encodeURIComponent("" + minOrdinalFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (typeFilter !== undefined)
            url_ += "TypeFilter=" + encodeURIComponent("" + typeFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetCategoryForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetCategoryForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetCategoryForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetCategoryForView.fromJS(resultData200) : new PagedResultDtoOfGetCategoryForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetCategoryForView>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getCategoryForEdit(id: number | null | undefined): Observable<GetCategoryForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Category/GetCategoryForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCategoryForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCategoryForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetCategoryForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetCategoryForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetCategoryForEdit(response: HttpResponseBase): Observable<GetCategoryForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetCategoryForEditOutput.fromJS(resultData200) : new GetCategoryForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCategoryForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditCategoryDto | null | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Category/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Category/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    generateCode(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Category/GenerateCode";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGenerateCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateCode(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGenerateCode(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param memberCode (optional) 
     * @return Success
     */
    homePage(memberCode: string | null | undefined): Observable<HomePageCategoryForView> {
        let url_ = this.baseUrl + "/api/services/app/Category/HomePage?";
        if (memberCode !== undefined)
            url_ += "memberCode=" + encodeURIComponent("" + memberCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processHomePage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHomePage(<any>response_);
                } catch (e) {
                    return <Observable<HomePageCategoryForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<HomePageCategoryForView>><any>_observableThrow(response_);
        }));
    }

    protected processHomePage(response: HttpResponseBase): Observable<HomePageCategoryForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? HomePageCategoryForView.fromJS(resultData200) : new HomePageCategoryForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HomePageCategoryForView>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param codeFilter (optional) 
     * @param nameFilter (optional) 
     * @param maxOrdinalFilter (optional) 
     * @param minOrdinalFilter (optional) 
     * @param statusFilter (optional) 
     * @param typeFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllExt(filter: string | null | undefined, codeFilter: string | null | undefined, nameFilter: string | null | undefined, maxOrdinalFilter: number | null | undefined, minOrdinalFilter: number | null | undefined, statusFilter: string | null | undefined, typeFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetCategoryForView> {
        let url_ = this.baseUrl + "/api/services/app/Category/GetAllExt?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&";
        if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (maxOrdinalFilter !== undefined)
            url_ += "MaxOrdinalFilter=" + encodeURIComponent("" + maxOrdinalFilter) + "&";
        if (minOrdinalFilter !== undefined)
            url_ += "MinOrdinalFilter=" + encodeURIComponent("" + minOrdinalFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (typeFilter !== undefined)
            url_ += "TypeFilter=" + encodeURIComponent("" + typeFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllExt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllExt(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetCategoryForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetCategoryForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllExt(response: HttpResponseBase): Observable<PagedResultDtoOfGetCategoryForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetCategoryForView.fromJS(resultData200) : new PagedResultDtoOfGetCategoryForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetCategoryForView>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param categoryCodeFilter (optional) 
     * @param statusFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllArticleActvieAsync(filter: string | null | undefined, categoryCodeFilter: string | null | undefined, statusFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetArticleForView> {
        let url_ = this.baseUrl + "/api/services/app/Category/GetAllArticleActvieAsync?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (categoryCodeFilter !== undefined)
            url_ += "CategoryCodeFilter=" + encodeURIComponent("" + categoryCodeFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllArticleActvieAsync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllArticleActvieAsync(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetArticleForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetArticleForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllArticleActvieAsync(response: HttpResponseBase): Observable<PagedResultDtoOfGetArticleForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetArticleForView.fromJS(resultData200) : new PagedResultDtoOfGetArticleForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetArticleForView>(<any>null);
    }

    /**
     * @param listId (optional) 
     * @return Success
     */
    batchDeleteAsync(listId: DeleteCategoryDto | null | undefined): Observable<MessageResultCMS> {
        let url_ = this.baseUrl + "/api/services/app/Category/BatchDeleteAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listId);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processBatchDeleteAsync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBatchDeleteAsync(<any>response_);
                } catch (e) {
                    return <Observable<MessageResultCMS>><any>_observableThrow(e);
                }
            } else
                return <Observable<MessageResultCMS>><any>_observableThrow(response_);
        }));
    }

    protected processBatchDeleteAsync(response: HttpResponseBase): Observable<MessageResultCMS> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? MessageResultCMS.fromJS(resultData200) : new MessageResultCMS();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MessageResultCMS>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEditExt(input: CreateOrEditCategoryDto | null | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Category/CreateOrEditExt";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEditExt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditExt(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEditExt(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }
}

@Injectable()
export class CodeGeneratorServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    generateCode(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/CodeGenerator/GenerateCode";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGenerateCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateCode(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGenerateCode(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }
}

@Injectable()
export class CodeGeneratorArticleServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    generateCode(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/CodeGeneratorArticle/GenerateCode";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGenerateCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateCode(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGenerateCode(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }
}

@Injectable()
export class CoinBaselinesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param memberCodeFilter (optional) 
     * @param maxMonthFilter (optional) 
     * @param minMonthFilter (optional) 
     * @param maxCoinGrantedFilter (optional) 
     * @param minCoinGrantedFilter (optional) 
     * @param maxCoinRedeemedFilter (optional) 
     * @param minCoinRedeemedFilter (optional) 
     * @param maxCoinAvailableFilter (optional) 
     * @param minCoinAvailableFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, memberCodeFilter: string | null | undefined, maxMonthFilter: number | null | undefined, minMonthFilter: number | null | undefined, maxCoinGrantedFilter: number | null | undefined, minCoinGrantedFilter: number | null | undefined, maxCoinRedeemedFilter: number | null | undefined, minCoinRedeemedFilter: number | null | undefined, maxCoinAvailableFilter: number | null | undefined, minCoinAvailableFilter: number | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetCoinBaselineForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/CoinBaselines/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (memberCodeFilter !== undefined)
            url_ += "MemberCodeFilter=" + encodeURIComponent("" + memberCodeFilter) + "&";
        if (maxMonthFilter !== undefined)
            url_ += "MaxMonthFilter=" + encodeURIComponent("" + maxMonthFilter) + "&";
        if (minMonthFilter !== undefined)
            url_ += "MinMonthFilter=" + encodeURIComponent("" + minMonthFilter) + "&";
        if (maxCoinGrantedFilter !== undefined)
            url_ += "MaxCoinGrantedFilter=" + encodeURIComponent("" + maxCoinGrantedFilter) + "&";
        if (minCoinGrantedFilter !== undefined)
            url_ += "MinCoinGrantedFilter=" + encodeURIComponent("" + minCoinGrantedFilter) + "&";
        if (maxCoinRedeemedFilter !== undefined)
            url_ += "MaxCoinRedeemedFilter=" + encodeURIComponent("" + maxCoinRedeemedFilter) + "&";
        if (minCoinRedeemedFilter !== undefined)
            url_ += "MinCoinRedeemedFilter=" + encodeURIComponent("" + minCoinRedeemedFilter) + "&";
        if (maxCoinAvailableFilter !== undefined)
            url_ += "MaxCoinAvailableFilter=" + encodeURIComponent("" + maxCoinAvailableFilter) + "&";
        if (minCoinAvailableFilter !== undefined)
            url_ += "MinCoinAvailableFilter=" + encodeURIComponent("" + minCoinAvailableFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetCoinBaselineForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetCoinBaselineForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetCoinBaselineForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetCoinBaselineForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetCoinBaselineForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetCoinBaselineForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getCoinBaselineForEdit(id: number | null | undefined): Observable<GetCoinBaselineForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/CoinBaselines/GetCoinBaselineForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCoinBaselineForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCoinBaselineForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetCoinBaselineForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetCoinBaselineForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetCoinBaselineForEdit(response: HttpResponseBase): Observable<GetCoinBaselineForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetCoinBaselineForEditOutput.fromJS(resultData200) : new GetCoinBaselineForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCoinBaselineForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditCoinBaselineDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CoinBaselines/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CoinBaselines/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class CoinExpirationSettingServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param codeFilter (optional) 
     * @param isActiveFilter (optional) 
     * @param validCoinTypeFilter (optional) 
     * @param maxValidCoinMonthsFilter (optional) 
     * @param minValidCoinMonthsFilter (optional) 
     * @param maxValidCoinPeriodDurationFilter (optional) 
     * @param minValidCoinPeriodDurationFilter (optional) 
     * @param maxValidCoinPeriodExtendMonthsFilter (optional) 
     * @param minValidCoinPeriodExtendMonthsFilter (optional) 
     * @param maxValidCoinPeriodStartMonthFilter (optional) 
     * @param minValidCoinPeriodStartMonthFilter (optional) 
     * @param sourceFilter (optional) 
     * @param maxValidCoinDaysFilter (optional) 
     * @param minValidCoinDaysFilter (optional) 
     * @param cronFilter (optional) 
     * @param timezoneFilter (optional) 
     * @param maxCalculationPeriodDurationFilter (optional) 
     * @param minCalculationPeriodDurationFilter (optional) 
     * @param maxCalculationPeriodStartMonthFilter (optional) 
     * @param minCalculationPeriodStartMonthFilter (optional) 
     * @param calculationTypeFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, codeFilter: string | null | undefined, isActiveFilter: number | null | undefined, validCoinTypeFilter: string | null | undefined, maxValidCoinMonthsFilter: number | null | undefined, minValidCoinMonthsFilter: number | null | undefined, maxValidCoinPeriodDurationFilter: number | null | undefined, minValidCoinPeriodDurationFilter: number | null | undefined, maxValidCoinPeriodExtendMonthsFilter: number | null | undefined, minValidCoinPeriodExtendMonthsFilter: number | null | undefined, maxValidCoinPeriodStartMonthFilter: moment.Moment | null | undefined, minValidCoinPeriodStartMonthFilter: moment.Moment | null | undefined, sourceFilter: string | null | undefined, maxValidCoinDaysFilter: number | null | undefined, minValidCoinDaysFilter: number | null | undefined, cronFilter: string | null | undefined, timezoneFilter: string | null | undefined, maxCalculationPeriodDurationFilter: number | null | undefined, minCalculationPeriodDurationFilter: number | null | undefined, maxCalculationPeriodStartMonthFilter: moment.Moment | null | undefined, minCalculationPeriodStartMonthFilter: moment.Moment | null | undefined, calculationTypeFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetCoinExpirationSettingForView> {
        let url_ = this.baseUrl + "/api/services/app/CoinExpirationSetting/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&";
        if (isActiveFilter !== undefined)
            url_ += "IsActiveFilter=" + encodeURIComponent("" + isActiveFilter) + "&";
        if (validCoinTypeFilter !== undefined)
            url_ += "ValidCoinTypeFilter=" + encodeURIComponent("" + validCoinTypeFilter) + "&";
        if (maxValidCoinMonthsFilter !== undefined)
            url_ += "MaxValidCoinMonthsFilter=" + encodeURIComponent("" + maxValidCoinMonthsFilter) + "&";
        if (minValidCoinMonthsFilter !== undefined)
            url_ += "MinValidCoinMonthsFilter=" + encodeURIComponent("" + minValidCoinMonthsFilter) + "&";
        if (maxValidCoinPeriodDurationFilter !== undefined)
            url_ += "MaxValidCoinPeriodDurationFilter=" + encodeURIComponent("" + maxValidCoinPeriodDurationFilter) + "&";
        if (minValidCoinPeriodDurationFilter !== undefined)
            url_ += "MinValidCoinPeriodDurationFilter=" + encodeURIComponent("" + minValidCoinPeriodDurationFilter) + "&";
        if (maxValidCoinPeriodExtendMonthsFilter !== undefined)
            url_ += "MaxValidCoinPeriodExtendMonthsFilter=" + encodeURIComponent("" + maxValidCoinPeriodExtendMonthsFilter) + "&";
        if (minValidCoinPeriodExtendMonthsFilter !== undefined)
            url_ += "MinValidCoinPeriodExtendMonthsFilter=" + encodeURIComponent("" + minValidCoinPeriodExtendMonthsFilter) + "&";
        if (maxValidCoinPeriodStartMonthFilter !== undefined)
            url_ += "MaxValidCoinPeriodStartMonthFilter=" + encodeURIComponent(maxValidCoinPeriodStartMonthFilter ? "" + maxValidCoinPeriodStartMonthFilter.toJSON() : "") + "&";
        if (minValidCoinPeriodStartMonthFilter !== undefined)
            url_ += "MinValidCoinPeriodStartMonthFilter=" + encodeURIComponent(minValidCoinPeriodStartMonthFilter ? "" + minValidCoinPeriodStartMonthFilter.toJSON() : "") + "&";
        if (sourceFilter !== undefined)
            url_ += "SourceFilter=" + encodeURIComponent("" + sourceFilter) + "&";
        if (maxValidCoinDaysFilter !== undefined)
            url_ += "MaxValidCoinDaysFilter=" + encodeURIComponent("" + maxValidCoinDaysFilter) + "&";
        if (minValidCoinDaysFilter !== undefined)
            url_ += "MinValidCoinDaysFilter=" + encodeURIComponent("" + minValidCoinDaysFilter) + "&";
        if (cronFilter !== undefined)
            url_ += "CronFilter=" + encodeURIComponent("" + cronFilter) + "&";
        if (timezoneFilter !== undefined)
            url_ += "TimezoneFilter=" + encodeURIComponent("" + timezoneFilter) + "&";
        if (maxCalculationPeriodDurationFilter !== undefined)
            url_ += "MaxCalculationPeriodDurationFilter=" + encodeURIComponent("" + maxCalculationPeriodDurationFilter) + "&";
        if (minCalculationPeriodDurationFilter !== undefined)
            url_ += "MinCalculationPeriodDurationFilter=" + encodeURIComponent("" + minCalculationPeriodDurationFilter) + "&";
        if (maxCalculationPeriodStartMonthFilter !== undefined)
            url_ += "MaxCalculationPeriodStartMonthFilter=" + encodeURIComponent(maxCalculationPeriodStartMonthFilter ? "" + maxCalculationPeriodStartMonthFilter.toJSON() : "") + "&";
        if (minCalculationPeriodStartMonthFilter !== undefined)
            url_ += "MinCalculationPeriodStartMonthFilter=" + encodeURIComponent(minCalculationPeriodStartMonthFilter ? "" + minCalculationPeriodStartMonthFilter.toJSON() : "") + "&";
        if (calculationTypeFilter !== undefined)
            url_ += "CalculationTypeFilter=" + encodeURIComponent("" + calculationTypeFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetCoinExpirationSettingForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetCoinExpirationSettingForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetCoinExpirationSettingForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetCoinExpirationSettingForView.fromJS(resultData200) : new PagedResultDtoOfGetCoinExpirationSettingForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetCoinExpirationSettingForView>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getCoinExpirationSettingForEdit(id: number | null | undefined): Observable<GetCoinExpirationSettingForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/CoinExpirationSetting/GetCoinExpirationSettingForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCoinExpirationSettingForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCoinExpirationSettingForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetCoinExpirationSettingForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetCoinExpirationSettingForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetCoinExpirationSettingForEdit(response: HttpResponseBase): Observable<GetCoinExpirationSettingForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetCoinExpirationSettingForEditOutput.fromJS(resultData200) : new GetCoinExpirationSettingForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCoinExpirationSettingForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditCoinExpirationSettingDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CoinExpirationSetting/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CoinExpirationSetting/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param timeRequest (optional) 
     * @return Success
     */
    getTimeBaseLineGiftTransaction(timeRequest: moment.Moment | null | undefined): Observable<ReponseTimeCalBaseLine> {
        let url_ = this.baseUrl + "/api/services/app/CoinExpirationSetting/GetTimeBaseLineGiftTransaction?";
        if (timeRequest !== undefined)
            url_ += "timeRequest=" + encodeURIComponent(timeRequest ? "" + timeRequest.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetTimeBaseLineGiftTransaction(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTimeBaseLineGiftTransaction(<any>response_);
                } catch (e) {
                    return <Observable<ReponseTimeCalBaseLine>><any>_observableThrow(e);
                }
            } else
                return <Observable<ReponseTimeCalBaseLine>><any>_observableThrow(response_);
        }));
    }

    protected processGetTimeBaseLineGiftTransaction(response: HttpResponseBase): Observable<ReponseTimeCalBaseLine> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? ReponseTimeCalBaseLine.fromJS(resultData200) : new ReponseTimeCalBaseLine();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReponseTimeCalBaseLine>(<any>null);
    }
}

@Injectable()
export class CoinUsageHistoriesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param maxConsumerIDFilter (optional) 
     * @param minConsumerIDFilter (optional) 
     * @param memberCodeFilter (optional) 
     * @param transactionCodeFilter (optional) 
     * @param maxBusinessTimeFilter (optional) 
     * @param minBusinessTimeFilter (optional) 
     * @param maxTransactionCoinBaselineIDFilter (optional) 
     * @param minTransactionCoinBaselineIDFilter (optional) 
     * @param maxCoinUsedFilter (optional) 
     * @param minCoinUsedFilter (optional) 
     * @param maxLastCoinFilter (optional) 
     * @param minLastCoinFilter (optional) 
     * @param reasonFilter (optional) 
     * @param sourceFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, maxConsumerIDFilter: number | null | undefined, minConsumerIDFilter: number | null | undefined, memberCodeFilter: string | null | undefined, transactionCodeFilter: string | null | undefined, maxBusinessTimeFilter: moment.Moment | null | undefined, minBusinessTimeFilter: moment.Moment | null | undefined, maxTransactionCoinBaselineIDFilter: number | null | undefined, minTransactionCoinBaselineIDFilter: number | null | undefined, maxCoinUsedFilter: number | null | undefined, minCoinUsedFilter: number | null | undefined, maxLastCoinFilter: number | null | undefined, minLastCoinFilter: number | null | undefined, reasonFilter: string | null | undefined, sourceFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetCoinUsageHistoryForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/CoinUsageHistories/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxConsumerIDFilter !== undefined)
            url_ += "MaxConsumerIDFilter=" + encodeURIComponent("" + maxConsumerIDFilter) + "&";
        if (minConsumerIDFilter !== undefined)
            url_ += "MinConsumerIDFilter=" + encodeURIComponent("" + minConsumerIDFilter) + "&";
        if (memberCodeFilter !== undefined)
            url_ += "MemberCodeFilter=" + encodeURIComponent("" + memberCodeFilter) + "&";
        if (transactionCodeFilter !== undefined)
            url_ += "TransactionCodeFilter=" + encodeURIComponent("" + transactionCodeFilter) + "&";
        if (maxBusinessTimeFilter !== undefined)
            url_ += "MaxBusinessTimeFilter=" + encodeURIComponent(maxBusinessTimeFilter ? "" + maxBusinessTimeFilter.toJSON() : "") + "&";
        if (minBusinessTimeFilter !== undefined)
            url_ += "MinBusinessTimeFilter=" + encodeURIComponent(minBusinessTimeFilter ? "" + minBusinessTimeFilter.toJSON() : "") + "&";
        if (maxTransactionCoinBaselineIDFilter !== undefined)
            url_ += "MaxTransactionCoinBaselineIDFilter=" + encodeURIComponent("" + maxTransactionCoinBaselineIDFilter) + "&";
        if (minTransactionCoinBaselineIDFilter !== undefined)
            url_ += "MinTransactionCoinBaselineIDFilter=" + encodeURIComponent("" + minTransactionCoinBaselineIDFilter) + "&";
        if (maxCoinUsedFilter !== undefined)
            url_ += "MaxCoinUsedFilter=" + encodeURIComponent("" + maxCoinUsedFilter) + "&";
        if (minCoinUsedFilter !== undefined)
            url_ += "MinCoinUsedFilter=" + encodeURIComponent("" + minCoinUsedFilter) + "&";
        if (maxLastCoinFilter !== undefined)
            url_ += "MaxLastCoinFilter=" + encodeURIComponent("" + maxLastCoinFilter) + "&";
        if (minLastCoinFilter !== undefined)
            url_ += "MinLastCoinFilter=" + encodeURIComponent("" + minLastCoinFilter) + "&";
        if (reasonFilter !== undefined)
            url_ += "ReasonFilter=" + encodeURIComponent("" + reasonFilter) + "&";
        if (sourceFilter !== undefined)
            url_ += "SourceFilter=" + encodeURIComponent("" + sourceFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetCoinUsageHistoryForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetCoinUsageHistoryForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetCoinUsageHistoryForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetCoinUsageHistoryForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetCoinUsageHistoryForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetCoinUsageHistoryForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getCoinUsageHistoryForEdit(id: number | null | undefined): Observable<GetCoinUsageHistoryForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/CoinUsageHistories/GetCoinUsageHistoryForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCoinUsageHistoryForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCoinUsageHistoryForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetCoinUsageHistoryForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetCoinUsageHistoryForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetCoinUsageHistoryForEdit(response: HttpResponseBase): Observable<GetCoinUsageHistoryForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetCoinUsageHistoryForEditOutput.fromJS(resultData200) : new GetCoinUsageHistoryForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCoinUsageHistoryForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditCoinUsageHistoryDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CoinUsageHistories/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CoinUsageHistories/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param maxConsumerIDFilter (optional) 
     * @param minConsumerIDFilter (optional) 
     * @param memberCodeFilter (optional) 
     * @param transactionCodeFilter (optional) 
     * @param maxBusinessTimeFilter (optional) 
     * @param minBusinessTimeFilter (optional) 
     * @param maxTransactionCoinBaselineIDFilter (optional) 
     * @param minTransactionCoinBaselineIDFilter (optional) 
     * @param maxCoinUsedFilter (optional) 
     * @param minCoinUsedFilter (optional) 
     * @param maxLastCoinFilter (optional) 
     * @param minLastCoinFilter (optional) 
     * @param reasonFilter (optional) 
     * @param sourceFilter (optional) 
     * @return Success
     */
    getCoinUsageHistoriesToExcel(filter: string | null | undefined, maxConsumerIDFilter: number | null | undefined, minConsumerIDFilter: number | null | undefined, memberCodeFilter: string | null | undefined, transactionCodeFilter: string | null | undefined, maxBusinessTimeFilter: moment.Moment | null | undefined, minBusinessTimeFilter: moment.Moment | null | undefined, maxTransactionCoinBaselineIDFilter: number | null | undefined, minTransactionCoinBaselineIDFilter: number | null | undefined, maxCoinUsedFilter: number | null | undefined, minCoinUsedFilter: number | null | undefined, maxLastCoinFilter: number | null | undefined, minLastCoinFilter: number | null | undefined, reasonFilter: string | null | undefined, sourceFilter: string | null | undefined): Observable<PointFileDto> {
        let url_ = this.baseUrl + "/api/services/app/CoinUsageHistories/GetCoinUsageHistoriesToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxConsumerIDFilter !== undefined)
            url_ += "MaxConsumerIDFilter=" + encodeURIComponent("" + maxConsumerIDFilter) + "&";
        if (minConsumerIDFilter !== undefined)
            url_ += "MinConsumerIDFilter=" + encodeURIComponent("" + minConsumerIDFilter) + "&";
        if (memberCodeFilter !== undefined)
            url_ += "MemberCodeFilter=" + encodeURIComponent("" + memberCodeFilter) + "&";
        if (transactionCodeFilter !== undefined)
            url_ += "TransactionCodeFilter=" + encodeURIComponent("" + transactionCodeFilter) + "&";
        if (maxBusinessTimeFilter !== undefined)
            url_ += "MaxBusinessTimeFilter=" + encodeURIComponent(maxBusinessTimeFilter ? "" + maxBusinessTimeFilter.toJSON() : "") + "&";
        if (minBusinessTimeFilter !== undefined)
            url_ += "MinBusinessTimeFilter=" + encodeURIComponent(minBusinessTimeFilter ? "" + minBusinessTimeFilter.toJSON() : "") + "&";
        if (maxTransactionCoinBaselineIDFilter !== undefined)
            url_ += "MaxTransactionCoinBaselineIDFilter=" + encodeURIComponent("" + maxTransactionCoinBaselineIDFilter) + "&";
        if (minTransactionCoinBaselineIDFilter !== undefined)
            url_ += "MinTransactionCoinBaselineIDFilter=" + encodeURIComponent("" + minTransactionCoinBaselineIDFilter) + "&";
        if (maxCoinUsedFilter !== undefined)
            url_ += "MaxCoinUsedFilter=" + encodeURIComponent("" + maxCoinUsedFilter) + "&";
        if (minCoinUsedFilter !== undefined)
            url_ += "MinCoinUsedFilter=" + encodeURIComponent("" + minCoinUsedFilter) + "&";
        if (maxLastCoinFilter !== undefined)
            url_ += "MaxLastCoinFilter=" + encodeURIComponent("" + maxLastCoinFilter) + "&";
        if (minLastCoinFilter !== undefined)
            url_ += "MinLastCoinFilter=" + encodeURIComponent("" + minLastCoinFilter) + "&";
        if (reasonFilter !== undefined)
            url_ += "ReasonFilter=" + encodeURIComponent("" + reasonFilter) + "&";
        if (sourceFilter !== undefined)
            url_ += "SourceFilter=" + encodeURIComponent("" + sourceFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCoinUsageHistoriesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCoinUsageHistoriesToExcel(<any>response_);
                } catch (e) {
                    return <Observable<PointFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PointFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetCoinUsageHistoriesToExcel(response: HttpResponseBase): Observable<PointFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PointFileDto.fromJS(resultData200) : new PointFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PointFileDto>(<any>null);
    }
}

@Injectable()
export class CommonLookupServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param onlyFreeItems (optional) 
     * @return Success
     */
    getEditionsForCombobox(onlyFreeItems: boolean | null | undefined): Observable<ListResultDtoOfSubscribableEditionComboboxItemDto> {
        let url_ = this.baseUrl + "/api/services/app/CommonLookup/GetEditionsForCombobox?";
        if (onlyFreeItems !== undefined)
            url_ += "onlyFreeItems=" + encodeURIComponent("" + onlyFreeItems) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetEditionsForCombobox(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEditionsForCombobox(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfSubscribableEditionComboboxItemDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfSubscribableEditionComboboxItemDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetEditionsForCombobox(response: HttpResponseBase): Observable<ListResultDtoOfSubscribableEditionComboboxItemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? ListResultDtoOfSubscribableEditionComboboxItemDto.fromJS(resultData200) : new ListResultDtoOfSubscribableEditionComboboxItemDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfSubscribableEditionComboboxItemDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    findUsers(input: FindUsersInput | null | undefined): Observable<PagedResultDtoOfNameValueDto> {
        let url_ = this.baseUrl + "/api/services/app/CommonLookup/FindUsers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processFindUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFindUsers(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfNameValueDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfNameValueDto>><any>_observableThrow(response_);
        }));
    }

    protected processFindUsers(response: HttpResponseBase): Observable<PagedResultDtoOfNameValueDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfNameValueDto.fromJS(resultData200) : new PagedResultDtoOfNameValueDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfNameValueDto>(<any>null);
    }

    /**
     * @return Success
     */
    getDefaultEditionName(): Observable<GetDefaultEditionNameOutput> {
        let url_ = this.baseUrl + "/api/services/app/CommonLookup/GetDefaultEditionName";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetDefaultEditionName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDefaultEditionName(<any>response_);
                } catch (e) {
                    return <Observable<GetDefaultEditionNameOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetDefaultEditionNameOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetDefaultEditionName(response: HttpResponseBase): Observable<GetDefaultEditionNameOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetDefaultEditionNameOutput.fromJS(resultData200) : new GetDefaultEditionNameOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetDefaultEditionNameOutput>(<any>null);
    }
}

@Injectable()
export class CommunicationsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param channelFilter (optional) 
     * @param languageDefaultFilter (optional) 
     * @param nameFilter (optional) 
     * @param statusFilter (optional) 
     * @param maxCommunicationTargetAudienceIDFilter (optional) 
     * @param minCommunicationTargetAudienceIDFilter (optional) 
     * @param cronFilter (optional) 
     * @param maxFromDateFilter (optional) 
     * @param minFromDateFilter (optional) 
     * @param maxToDateFilter (optional) 
     * @param minToDateFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param messageTypeFilter (optional) 
     * @param messageActionFilter (optional) 
     * @param contentTypeFilter (optional) 
     * @param contentVNFilter (optional) 
     * @param contentENFilter (optional) 
     * @param subjectVNFilter (optional) 
     * @param subjectENFilter (optional) 
     * @param imageURLFilter (optional) 
     * @param extraURLFilter (optional) 
     * @param nameUnsignFilter (optional) 
     * @param extraParamFilter (optional) 
     * @param targetAudienceTypeFilter (optional) 
     * @param immediatelyOnEventFilter (optional) 
     * @param eventTypeFilter (optional) 
     * @param broadcastCategoryFilter (optional) 
     * @param actionsFilter (optional) 
     * @param targetScreenFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, channelFilter: string | null | undefined, languageDefaultFilter: string | null | undefined, nameFilter: string | null | undefined, statusFilter: string | null | undefined, maxCommunicationTargetAudienceIDFilter: number | null | undefined, minCommunicationTargetAudienceIDFilter: number | null | undefined, cronFilter: string | null | undefined, maxFromDateFilter: moment.Moment | null | undefined, minFromDateFilter: moment.Moment | null | undefined, maxToDateFilter: moment.Moment | null | undefined, minToDateFilter: moment.Moment | null | undefined, descriptionFilter: string | null | undefined, messageTypeFilter: string | null | undefined, messageActionFilter: string | null | undefined, contentTypeFilter: string | null | undefined, contentVNFilter: string | null | undefined, contentENFilter: string | null | undefined, subjectVNFilter: string | null | undefined, subjectENFilter: string | null | undefined, imageURLFilter: string | null | undefined, extraURLFilter: string | null | undefined, nameUnsignFilter: string | null | undefined, extraParamFilter: string | null | undefined, targetAudienceTypeFilter: string | null | undefined, immediatelyOnEventFilter: number | null | undefined, eventTypeFilter: string | null | undefined, broadcastCategoryFilter: string | null | undefined, actionsFilter: string | null | undefined, targetScreenFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetCommunicationForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Communications/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (channelFilter !== undefined)
            url_ += "ChannelFilter=" + encodeURIComponent("" + channelFilter) + "&";
        if (languageDefaultFilter !== undefined)
            url_ += "LanguageDefaultFilter=" + encodeURIComponent("" + languageDefaultFilter) + "&";
        if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (maxCommunicationTargetAudienceIDFilter !== undefined)
            url_ += "MaxCommunicationTargetAudienceIDFilter=" + encodeURIComponent("" + maxCommunicationTargetAudienceIDFilter) + "&";
        if (minCommunicationTargetAudienceIDFilter !== undefined)
            url_ += "MinCommunicationTargetAudienceIDFilter=" + encodeURIComponent("" + minCommunicationTargetAudienceIDFilter) + "&";
        if (cronFilter !== undefined)
            url_ += "CronFilter=" + encodeURIComponent("" + cronFilter) + "&";
        if (maxFromDateFilter !== undefined)
            url_ += "MaxFromDateFilter=" + encodeURIComponent(maxFromDateFilter ? "" + maxFromDateFilter.toJSON() : "") + "&";
        if (minFromDateFilter !== undefined)
            url_ += "MinFromDateFilter=" + encodeURIComponent(minFromDateFilter ? "" + minFromDateFilter.toJSON() : "") + "&";
        if (maxToDateFilter !== undefined)
            url_ += "MaxToDateFilter=" + encodeURIComponent(maxToDateFilter ? "" + maxToDateFilter.toJSON() : "") + "&";
        if (minToDateFilter !== undefined)
            url_ += "MinToDateFilter=" + encodeURIComponent(minToDateFilter ? "" + minToDateFilter.toJSON() : "") + "&";
        if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&";
        if (messageTypeFilter !== undefined)
            url_ += "MessageTypeFilter=" + encodeURIComponent("" + messageTypeFilter) + "&";
        if (messageActionFilter !== undefined)
            url_ += "MessageActionFilter=" + encodeURIComponent("" + messageActionFilter) + "&";
        if (contentTypeFilter !== undefined)
            url_ += "ContentTypeFilter=" + encodeURIComponent("" + contentTypeFilter) + "&";
        if (contentVNFilter !== undefined)
            url_ += "ContentVNFilter=" + encodeURIComponent("" + contentVNFilter) + "&";
        if (contentENFilter !== undefined)
            url_ += "ContentENFilter=" + encodeURIComponent("" + contentENFilter) + "&";
        if (subjectVNFilter !== undefined)
            url_ += "SubjectVNFilter=" + encodeURIComponent("" + subjectVNFilter) + "&";
        if (subjectENFilter !== undefined)
            url_ += "SubjectENFilter=" + encodeURIComponent("" + subjectENFilter) + "&";
        if (imageURLFilter !== undefined)
            url_ += "ImageURLFilter=" + encodeURIComponent("" + imageURLFilter) + "&";
        if (extraURLFilter !== undefined)
            url_ += "ExtraURLFilter=" + encodeURIComponent("" + extraURLFilter) + "&";
        if (nameUnsignFilter !== undefined)
            url_ += "NameUnsignFilter=" + encodeURIComponent("" + nameUnsignFilter) + "&";
        if (extraParamFilter !== undefined)
            url_ += "ExtraParamFilter=" + encodeURIComponent("" + extraParamFilter) + "&";
        if (targetAudienceTypeFilter !== undefined)
            url_ += "TargetAudienceTypeFilter=" + encodeURIComponent("" + targetAudienceTypeFilter) + "&";
        if (immediatelyOnEventFilter !== undefined)
            url_ += "ImmediatelyOnEventFilter=" + encodeURIComponent("" + immediatelyOnEventFilter) + "&";
        if (eventTypeFilter !== undefined)
            url_ += "EventTypeFilter=" + encodeURIComponent("" + eventTypeFilter) + "&";
        if (broadcastCategoryFilter !== undefined)
            url_ += "BroadcastCategoryFilter=" + encodeURIComponent("" + broadcastCategoryFilter) + "&";
        if (actionsFilter !== undefined)
            url_ += "ActionsFilter=" + encodeURIComponent("" + actionsFilter) + "&";
        if (targetScreenFilter !== undefined)
            url_ += "TargetScreenFilter=" + encodeURIComponent("" + targetScreenFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetCommunicationForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetCommunicationForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetCommunicationForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetCommunicationForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetCommunicationForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetCommunicationForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getCommunicationForEdit(id: number | null | undefined): Observable<GetCommunicationForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Communications/GetCommunicationForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCommunicationForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCommunicationForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetCommunicationForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetCommunicationForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetCommunicationForEdit(response: HttpResponseBase): Observable<GetCommunicationForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetCommunicationForEditOutput.fromJS(resultData200) : new GetCommunicationForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCommunicationForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditCommunicationDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Communications/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Communications/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    getNotificationByUser(): Observable<PagedResultDtoOfNotificationByUserResponse> {
        let url_ = this.baseUrl + "/api/services/app/Communications/GetNotificationByUser";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetNotificationByUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNotificationByUser(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfNotificationByUserResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfNotificationByUserResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetNotificationByUser(response: HttpResponseBase): Observable<PagedResultDtoOfNotificationByUserResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfNotificationByUserResponse.fromJS(resultData200) : new PagedResultDtoOfNotificationByUserResponse();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfNotificationByUserResponse>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param channelFilter (optional) 
     * @param languageDefaultFilter (optional) 
     * @param nameFilter (optional) 
     * @param statusFilter (optional) 
     * @param maxCommunicationTargetAudienceIDFilter (optional) 
     * @param minCommunicationTargetAudienceIDFilter (optional) 
     * @param cronFilter (optional) 
     * @param maxFromDateFilter (optional) 
     * @param minFromDateFilter (optional) 
     * @param maxToDateFilter (optional) 
     * @param minToDateFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param messageTypeFilter (optional) 
     * @param messageActionFilter (optional) 
     * @param contentTypeFilter (optional) 
     * @param contentVNFilter (optional) 
     * @param contentENFilter (optional) 
     * @param subjectVNFilter (optional) 
     * @param subjectENFilter (optional) 
     * @param imageURLFilter (optional) 
     * @param extraURLFilter (optional) 
     * @param nameUnsignFilter (optional) 
     * @param extraParamFilter (optional) 
     * @param targetAudienceTypeFilter (optional) 
     * @param immediatelyOnEventFilter (optional) 
     * @param eventTypeFilter (optional) 
     * @param broadcastCategoryFilter (optional) 
     * @param actionsFilter (optional) 
     * @param targetScreenFilter (optional) 
     * @return Success
     */
    getCommunicationsToExcel(filter: string | null | undefined, channelFilter: string | null | undefined, languageDefaultFilter: string | null | undefined, nameFilter: string | null | undefined, statusFilter: string | null | undefined, maxCommunicationTargetAudienceIDFilter: number | null | undefined, minCommunicationTargetAudienceIDFilter: number | null | undefined, cronFilter: string | null | undefined, maxFromDateFilter: moment.Moment | null | undefined, minFromDateFilter: moment.Moment | null | undefined, maxToDateFilter: moment.Moment | null | undefined, minToDateFilter: moment.Moment | null | undefined, descriptionFilter: string | null | undefined, messageTypeFilter: string | null | undefined, messageActionFilter: string | null | undefined, contentTypeFilter: string | null | undefined, contentVNFilter: string | null | undefined, contentENFilter: string | null | undefined, subjectVNFilter: string | null | undefined, subjectENFilter: string | null | undefined, imageURLFilter: string | null | undefined, extraURLFilter: string | null | undefined, nameUnsignFilter: string | null | undefined, extraParamFilter: string | null | undefined, targetAudienceTypeFilter: string | null | undefined, immediatelyOnEventFilter: number | null | undefined, eventTypeFilter: string | null | undefined, broadcastCategoryFilter: string | null | undefined, actionsFilter: string | null | undefined, targetScreenFilter: string | null | undefined): Observable<CommunicationsFileDto> {
        let url_ = this.baseUrl + "/api/services/app/Communications/GetCommunicationsToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (channelFilter !== undefined)
            url_ += "ChannelFilter=" + encodeURIComponent("" + channelFilter) + "&";
        if (languageDefaultFilter !== undefined)
            url_ += "LanguageDefaultFilter=" + encodeURIComponent("" + languageDefaultFilter) + "&";
        if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (maxCommunicationTargetAudienceIDFilter !== undefined)
            url_ += "MaxCommunicationTargetAudienceIDFilter=" + encodeURIComponent("" + maxCommunicationTargetAudienceIDFilter) + "&";
        if (minCommunicationTargetAudienceIDFilter !== undefined)
            url_ += "MinCommunicationTargetAudienceIDFilter=" + encodeURIComponent("" + minCommunicationTargetAudienceIDFilter) + "&";
        if (cronFilter !== undefined)
            url_ += "CronFilter=" + encodeURIComponent("" + cronFilter) + "&";
        if (maxFromDateFilter !== undefined)
            url_ += "MaxFromDateFilter=" + encodeURIComponent(maxFromDateFilter ? "" + maxFromDateFilter.toJSON() : "") + "&";
        if (minFromDateFilter !== undefined)
            url_ += "MinFromDateFilter=" + encodeURIComponent(minFromDateFilter ? "" + minFromDateFilter.toJSON() : "") + "&";
        if (maxToDateFilter !== undefined)
            url_ += "MaxToDateFilter=" + encodeURIComponent(maxToDateFilter ? "" + maxToDateFilter.toJSON() : "") + "&";
        if (minToDateFilter !== undefined)
            url_ += "MinToDateFilter=" + encodeURIComponent(minToDateFilter ? "" + minToDateFilter.toJSON() : "") + "&";
        if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&";
        if (messageTypeFilter !== undefined)
            url_ += "MessageTypeFilter=" + encodeURIComponent("" + messageTypeFilter) + "&";
        if (messageActionFilter !== undefined)
            url_ += "MessageActionFilter=" + encodeURIComponent("" + messageActionFilter) + "&";
        if (contentTypeFilter !== undefined)
            url_ += "ContentTypeFilter=" + encodeURIComponent("" + contentTypeFilter) + "&";
        if (contentVNFilter !== undefined)
            url_ += "ContentVNFilter=" + encodeURIComponent("" + contentVNFilter) + "&";
        if (contentENFilter !== undefined)
            url_ += "ContentENFilter=" + encodeURIComponent("" + contentENFilter) + "&";
        if (subjectVNFilter !== undefined)
            url_ += "SubjectVNFilter=" + encodeURIComponent("" + subjectVNFilter) + "&";
        if (subjectENFilter !== undefined)
            url_ += "SubjectENFilter=" + encodeURIComponent("" + subjectENFilter) + "&";
        if (imageURLFilter !== undefined)
            url_ += "ImageURLFilter=" + encodeURIComponent("" + imageURLFilter) + "&";
        if (extraURLFilter !== undefined)
            url_ += "ExtraURLFilter=" + encodeURIComponent("" + extraURLFilter) + "&";
        if (nameUnsignFilter !== undefined)
            url_ += "NameUnsignFilter=" + encodeURIComponent("" + nameUnsignFilter) + "&";
        if (extraParamFilter !== undefined)
            url_ += "ExtraParamFilter=" + encodeURIComponent("" + extraParamFilter) + "&";
        if (targetAudienceTypeFilter !== undefined)
            url_ += "TargetAudienceTypeFilter=" + encodeURIComponent("" + targetAudienceTypeFilter) + "&";
        if (immediatelyOnEventFilter !== undefined)
            url_ += "ImmediatelyOnEventFilter=" + encodeURIComponent("" + immediatelyOnEventFilter) + "&";
        if (eventTypeFilter !== undefined)
            url_ += "EventTypeFilter=" + encodeURIComponent("" + eventTypeFilter) + "&";
        if (broadcastCategoryFilter !== undefined)
            url_ += "BroadcastCategoryFilter=" + encodeURIComponent("" + broadcastCategoryFilter) + "&";
        if (actionsFilter !== undefined)
            url_ += "ActionsFilter=" + encodeURIComponent("" + actionsFilter) + "&";
        if (targetScreenFilter !== undefined)
            url_ += "TargetScreenFilter=" + encodeURIComponent("" + targetScreenFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCommunicationsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCommunicationsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<CommunicationsFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CommunicationsFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetCommunicationsToExcel(response: HttpResponseBase): Observable<CommunicationsFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? CommunicationsFileDto.fromJS(resultData200) : new CommunicationsFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CommunicationsFileDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param channelFilter (optional) 
     * @param languageDefaultFilter (optional) 
     * @param nameFilter (optional) 
     * @param statusFilter (optional) 
     * @param maxCommunicationTargetAudienceIDFilter (optional) 
     * @param minCommunicationTargetAudienceIDFilter (optional) 
     * @param cronFilter (optional) 
     * @param maxFromDateFilter (optional) 
     * @param minFromDateFilter (optional) 
     * @param maxToDateFilter (optional) 
     * @param minToDateFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param messageTypeFilter (optional) 
     * @param messageActionFilter (optional) 
     * @param contentTypeFilter (optional) 
     * @param contentVNFilter (optional) 
     * @param contentENFilter (optional) 
     * @param subjectVNFilter (optional) 
     * @param subjectENFilter (optional) 
     * @param imageURLFilter (optional) 
     * @param extraURLFilter (optional) 
     * @param nameUnsignFilter (optional) 
     * @param extraParamFilter (optional) 
     * @param targetAudienceTypeFilter (optional) 
     * @param immediatelyOnEventFilter (optional) 
     * @param eventTypeFilter (optional) 
     * @param broadcastCategoryFilter (optional) 
     * @param actionsFilter (optional) 
     * @param targetScreenFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllExt(filter: string | null | undefined, channelFilter: string | null | undefined, languageDefaultFilter: string | null | undefined, nameFilter: string | null | undefined, statusFilter: string | null | undefined, maxCommunicationTargetAudienceIDFilter: number | null | undefined, minCommunicationTargetAudienceIDFilter: number | null | undefined, cronFilter: string | null | undefined, maxFromDateFilter: moment.Moment | null | undefined, minFromDateFilter: moment.Moment | null | undefined, maxToDateFilter: moment.Moment | null | undefined, minToDateFilter: moment.Moment | null | undefined, descriptionFilter: string | null | undefined, messageTypeFilter: string | null | undefined, messageActionFilter: string | null | undefined, contentTypeFilter: string | null | undefined, contentVNFilter: string | null | undefined, contentENFilter: string | null | undefined, subjectVNFilter: string | null | undefined, subjectENFilter: string | null | undefined, imageURLFilter: string | null | undefined, extraURLFilter: string | null | undefined, nameUnsignFilter: string | null | undefined, extraParamFilter: string | null | undefined, targetAudienceTypeFilter: string | null | undefined, immediatelyOnEventFilter: number | null | undefined, eventTypeFilter: string | null | undefined, broadcastCategoryFilter: string | null | undefined, actionsFilter: string | null | undefined, targetScreenFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetCommunicationForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Communications/GetAllExt?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (channelFilter !== undefined)
            url_ += "ChannelFilter=" + encodeURIComponent("" + channelFilter) + "&";
        if (languageDefaultFilter !== undefined)
            url_ += "LanguageDefaultFilter=" + encodeURIComponent("" + languageDefaultFilter) + "&";
        if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (maxCommunicationTargetAudienceIDFilter !== undefined)
            url_ += "MaxCommunicationTargetAudienceIDFilter=" + encodeURIComponent("" + maxCommunicationTargetAudienceIDFilter) + "&";
        if (minCommunicationTargetAudienceIDFilter !== undefined)
            url_ += "MinCommunicationTargetAudienceIDFilter=" + encodeURIComponent("" + minCommunicationTargetAudienceIDFilter) + "&";
        if (cronFilter !== undefined)
            url_ += "CronFilter=" + encodeURIComponent("" + cronFilter) + "&";
        if (maxFromDateFilter !== undefined)
            url_ += "MaxFromDateFilter=" + encodeURIComponent(maxFromDateFilter ? "" + maxFromDateFilter.toJSON() : "") + "&";
        if (minFromDateFilter !== undefined)
            url_ += "MinFromDateFilter=" + encodeURIComponent(minFromDateFilter ? "" + minFromDateFilter.toJSON() : "") + "&";
        if (maxToDateFilter !== undefined)
            url_ += "MaxToDateFilter=" + encodeURIComponent(maxToDateFilter ? "" + maxToDateFilter.toJSON() : "") + "&";
        if (minToDateFilter !== undefined)
            url_ += "MinToDateFilter=" + encodeURIComponent(minToDateFilter ? "" + minToDateFilter.toJSON() : "") + "&";
        if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&";
        if (messageTypeFilter !== undefined)
            url_ += "MessageTypeFilter=" + encodeURIComponent("" + messageTypeFilter) + "&";
        if (messageActionFilter !== undefined)
            url_ += "MessageActionFilter=" + encodeURIComponent("" + messageActionFilter) + "&";
        if (contentTypeFilter !== undefined)
            url_ += "ContentTypeFilter=" + encodeURIComponent("" + contentTypeFilter) + "&";
        if (contentVNFilter !== undefined)
            url_ += "ContentVNFilter=" + encodeURIComponent("" + contentVNFilter) + "&";
        if (contentENFilter !== undefined)
            url_ += "ContentENFilter=" + encodeURIComponent("" + contentENFilter) + "&";
        if (subjectVNFilter !== undefined)
            url_ += "SubjectVNFilter=" + encodeURIComponent("" + subjectVNFilter) + "&";
        if (subjectENFilter !== undefined)
            url_ += "SubjectENFilter=" + encodeURIComponent("" + subjectENFilter) + "&";
        if (imageURLFilter !== undefined)
            url_ += "ImageURLFilter=" + encodeURIComponent("" + imageURLFilter) + "&";
        if (extraURLFilter !== undefined)
            url_ += "ExtraURLFilter=" + encodeURIComponent("" + extraURLFilter) + "&";
        if (nameUnsignFilter !== undefined)
            url_ += "NameUnsignFilter=" + encodeURIComponent("" + nameUnsignFilter) + "&";
        if (extraParamFilter !== undefined)
            url_ += "ExtraParamFilter=" + encodeURIComponent("" + extraParamFilter) + "&";
        if (targetAudienceTypeFilter !== undefined)
            url_ += "TargetAudienceTypeFilter=" + encodeURIComponent("" + targetAudienceTypeFilter) + "&";
        if (immediatelyOnEventFilter !== undefined)
            url_ += "ImmediatelyOnEventFilter=" + encodeURIComponent("" + immediatelyOnEventFilter) + "&";
        if (eventTypeFilter !== undefined)
            url_ += "EventTypeFilter=" + encodeURIComponent("" + eventTypeFilter) + "&";
        if (broadcastCategoryFilter !== undefined)
            url_ += "BroadcastCategoryFilter=" + encodeURIComponent("" + broadcastCategoryFilter) + "&";
        if (actionsFilter !== undefined)
            url_ += "ActionsFilter=" + encodeURIComponent("" + actionsFilter) + "&";
        if (targetScreenFilter !== undefined)
            url_ += "TargetScreenFilter=" + encodeURIComponent("" + targetScreenFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllExt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllExt(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetCommunicationForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetCommunicationForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllExt(response: HttpResponseBase): Observable<PagedResultDtoOfGetCommunicationForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetCommunicationForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetCommunicationForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetCommunicationForViewDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    batchDelete(input: CommunicationDto[] | null | undefined): Observable<MessageResultCommunication> {
        let url_ = this.baseUrl + "/api/services/app/Communications/BatchDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processBatchDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBatchDelete(<any>response_);
                } catch (e) {
                    return <Observable<MessageResultCommunication>><any>_observableThrow(e);
                }
            } else
                return <Observable<MessageResultCommunication>><any>_observableThrow(response_);
        }));
    }

    protected processBatchDelete(response: HttpResponseBase): Observable<MessageResultCommunication> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? MessageResultCommunication.fromJS(resultData200) : new MessageResultCommunication();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MessageResultCommunication>(<any>null);
    }

    /**
     * @param type (optional) 
     * @return Success
     */
    getTargetAudiences(type: string | null | undefined): Observable<GetTargetAudienceForViewDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Communications/GetTargetAudiences?";
        if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetTargetAudiences(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTargetAudiences(<any>response_);
                } catch (e) {
                    return <Observable<GetTargetAudienceForViewDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetTargetAudienceForViewDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetTargetAudiences(response: HttpResponseBase): Observable<GetTargetAudienceForViewDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(GetTargetAudienceForViewDto.fromJS(item));
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTargetAudienceForViewDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getAllHashTag(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/Communications/GetAllHashTag";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllHashTag(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllHashTag(<any>response_);
                } catch (e) {
                    return <Observable<string[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<string[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllHashTag(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(item);
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string[]>(<any>null);
    }

    /**
     * @param type (optional) 
     * @param targetId (optional) 
     * @param communicationId (optional) 
     * @return Success
     */
    checkTarget(type: string | null | undefined, targetId: number | null | undefined, communicationId: number | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Communications/CheckTarget?";
        if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (targetId !== undefined)
            url_ += "targetId=" + encodeURIComponent("" + targetId) + "&";
        if (communicationId !== undefined)
            url_ += "CommunicationId=" + encodeURIComponent("" + communicationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCheckTarget(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckTarget(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processCheckTarget(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param args (optional) 
     * @return Success
     */
    importQueue(args: CommunicationInfoAgrs | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Communications/ImportQueue";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(args);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processImportQueue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportQueue(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processImportQueue(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param eventType (optional) 
     * @return Success
     */
    getToken(eventType: string | null | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/Communications/GetToken?";
        if (eventType !== undefined)
            url_ += "eventType=" + encodeURIComponent("" + eventType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetToken(<any>response_);
                } catch (e) {
                    return <Observable<string[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<string[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetToken(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(item);
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string[]>(<any>null);
    }

    /**
     * @return Success
     */
    getAllToken(): Observable<Token[]> {
        let url_ = this.baseUrl + "/api/services/app/Communications/GetAllToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllToken(<any>response_);
                } catch (e) {
                    return <Observable<Token[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<Token[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllToken(response: HttpResponseBase): Observable<Token[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(Token.fromJS(item));
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Token[]>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param statusFilter (optional) 
     * @param communicationId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getReportByCommunicationId(filter: string | null | undefined, statusFilter: string | null | undefined, communicationId: number | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetCommunicationReportsForView> {
        let url_ = this.baseUrl + "/api/services/app/Communications/GetReportByCommunicationId?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (communicationId !== undefined)
            url_ += "CommunicationId=" + encodeURIComponent("" + communicationId) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetReportByCommunicationId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportByCommunicationId(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetCommunicationReportsForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetCommunicationReportsForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetReportByCommunicationId(response: HttpResponseBase): Observable<PagedResultDtoOfGetCommunicationReportsForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetCommunicationReportsForView.fromJS(resultData200) : new PagedResultDtoOfGetCommunicationReportsForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetCommunicationReportsForView>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    exportCommunicationReportsToExcel(input: GetAllForCommunicationReportsInput | null | undefined): Observable<CommunicationsFileDto> {
        let url_ = this.baseUrl + "/api/services/app/Communications/ExportCommunicationReportsToExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processExportCommunicationReportsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportCommunicationReportsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<CommunicationsFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CommunicationsFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processExportCommunicationReportsToExcel(response: HttpResponseBase): Observable<CommunicationsFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? CommunicationsFileDto.fromJS(resultData200) : new CommunicationsFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CommunicationsFileDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEditExt(input: CreateOrEditCommunicationDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Communications/CreateOrEditExt";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEditExt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditExt(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEditExt(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getCommunicationForEditExt(id: number | null | undefined): Observable<GetCommunicationForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Communications/GetCommunicationForEditExt?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCommunicationForEditExt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCommunicationForEditExt(<any>response_);
                } catch (e) {
                    return <Observable<GetCommunicationForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetCommunicationForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetCommunicationForEditExt(response: HttpResponseBase): Observable<GetCommunicationForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetCommunicationForEditOutput.fromJS(resultData200) : new GetCommunicationForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCommunicationForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    clone(input: CloneCommunicationDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Communications/Clone";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processClone(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClone(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processClone(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    getListEventSystemTrigger(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/Communications/GetListEventSystemTrigger";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetListEventSystemTrigger(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetListEventSystemTrigger(<any>response_);
                } catch (e) {
                    return <Observable<string[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<string[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetListEventSystemTrigger(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(item);
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string[]>(<any>null);
    }

    /**
     * @return Success
     */
    getAllExtAysnc(): Observable<CommunicationSurveyDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Communications/GetAllExtAysnc";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllExtAysnc(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllExtAysnc(<any>response_);
                } catch (e) {
                    return <Observable<CommunicationSurveyDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<CommunicationSurveyDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllExtAysnc(response: HttpResponseBase): Observable<CommunicationSurveyDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(CommunicationSurveyDto.fromJS(item));
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CommunicationSurveyDto[]>(<any>null);
    }

    /**
     * @param referenceId (optional) 
     * @return Success
     */
    getCommunicationByReferenceIdAysnc(referenceId: number | null | undefined): Observable<CommunicationDto> {
        let url_ = this.baseUrl + "/api/services/app/Communications/GetCommunicationByReferenceIdAysnc?";
        if (referenceId !== undefined)
            url_ += "referenceId=" + encodeURIComponent("" + referenceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCommunicationByReferenceIdAysnc(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCommunicationByReferenceIdAysnc(<any>response_);
                } catch (e) {
                    return <Observable<CommunicationDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CommunicationDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetCommunicationByReferenceIdAysnc(response: HttpResponseBase): Observable<CommunicationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? CommunicationDto.fromJS(resultData200) : new CommunicationDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CommunicationDto>(<any>null);
    }
}

@Injectable()
export class CommunicationsWebhookServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param jObject (optional) 
     * @return Success
     */
    webHookSocial(jObject: any | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CommunicationsWebhookService/WebHookSocial";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(jObject);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processWebHookSocial(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWebHookSocial(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processWebHookSocial(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class CommunicationTargetAudiencesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param targetAudienceNameFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param statusFilter (optional) 
     * @param maxTargetAudienceLinkIDFilter (optional) 
     * @param minTargetAudienceLinkIDFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, targetAudienceNameFilter: string | null | undefined, descriptionFilter: string | null | undefined, statusFilter: string | null | undefined, maxTargetAudienceLinkIDFilter: number | null | undefined, minTargetAudienceLinkIDFilter: number | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetCommunicationTargetAudienceForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/CommunicationTargetAudiences/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (targetAudienceNameFilter !== undefined)
            url_ += "TargetAudienceNameFilter=" + encodeURIComponent("" + targetAudienceNameFilter) + "&";
        if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (maxTargetAudienceLinkIDFilter !== undefined)
            url_ += "MaxTargetAudienceLinkIDFilter=" + encodeURIComponent("" + maxTargetAudienceLinkIDFilter) + "&";
        if (minTargetAudienceLinkIDFilter !== undefined)
            url_ += "MinTargetAudienceLinkIDFilter=" + encodeURIComponent("" + minTargetAudienceLinkIDFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetCommunicationTargetAudienceForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetCommunicationTargetAudienceForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetCommunicationTargetAudienceForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetCommunicationTargetAudienceForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetCommunicationTargetAudienceForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetCommunicationTargetAudienceForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getCommunicationTargetAudienceForEdit(id: number | null | undefined): Observable<GetCommunicationTargetAudienceForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/CommunicationTargetAudiences/GetCommunicationTargetAudienceForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCommunicationTargetAudienceForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCommunicationTargetAudienceForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetCommunicationTargetAudienceForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetCommunicationTargetAudienceForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetCommunicationTargetAudienceForEdit(response: HttpResponseBase): Observable<GetCommunicationTargetAudienceForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetCommunicationTargetAudienceForEditOutput.fromJS(resultData200) : new GetCommunicationTargetAudienceForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCommunicationTargetAudienceForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditCommunicationTargetAudienceDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CommunicationTargetAudiences/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CommunicationTargetAudiences/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param targetAudienceNameFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param statusFilter (optional) 
     * @param maxTargetAudienceLinkIDFilter (optional) 
     * @param minTargetAudienceLinkIDFilter (optional) 
     * @return Success
     */
    getCommunicationTargetAudiencesToExcel(filter: string | null | undefined, targetAudienceNameFilter: string | null | undefined, descriptionFilter: string | null | undefined, statusFilter: string | null | undefined, maxTargetAudienceLinkIDFilter: number | null | undefined, minTargetAudienceLinkIDFilter: number | null | undefined): Observable<CommunicationsFileDto> {
        let url_ = this.baseUrl + "/api/services/app/CommunicationTargetAudiences/GetCommunicationTargetAudiencesToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (targetAudienceNameFilter !== undefined)
            url_ += "TargetAudienceNameFilter=" + encodeURIComponent("" + targetAudienceNameFilter) + "&";
        if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (maxTargetAudienceLinkIDFilter !== undefined)
            url_ += "MaxTargetAudienceLinkIDFilter=" + encodeURIComponent("" + maxTargetAudienceLinkIDFilter) + "&";
        if (minTargetAudienceLinkIDFilter !== undefined)
            url_ += "MinTargetAudienceLinkIDFilter=" + encodeURIComponent("" + minTargetAudienceLinkIDFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCommunicationTargetAudiencesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCommunicationTargetAudiencesToExcel(<any>response_);
                } catch (e) {
                    return <Observable<CommunicationsFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CommunicationsFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetCommunicationTargetAudiencesToExcel(response: HttpResponseBase): Observable<CommunicationsFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? CommunicationsFileDto.fromJS(resultData200) : new CommunicationsFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CommunicationsFileDto>(<any>null);
    }
}

@Injectable()
export class CommunicationTransactionsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param communicationIDFilter (optional) 
     * @param channelFilter (optional) 
     * @param memberNameFilter (optional) 
     * @param phoneFilter (optional) 
     * @param zaloChatIDFilter (optional) 
     * @param emailFilter (optional) 
     * @param facebookIDFilter (optional) 
     * @param memberCodeFilter (optional) 
     * @param contentFilter (optional) 
     * @param subjectFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, communicationIDFilter: string | null | undefined, channelFilter: string | null | undefined, memberNameFilter: string | null | undefined, phoneFilter: string | null | undefined, zaloChatIDFilter: string | null | undefined, emailFilter: string | null | undefined, facebookIDFilter: string | null | undefined, memberCodeFilter: string | null | undefined, contentFilter: string | null | undefined, subjectFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetCommunicationTransactionForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/CommunicationTransactions/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (communicationIDFilter !== undefined)
            url_ += "CommunicationIDFilter=" + encodeURIComponent("" + communicationIDFilter) + "&";
        if (channelFilter !== undefined)
            url_ += "ChannelFilter=" + encodeURIComponent("" + channelFilter) + "&";
        if (memberNameFilter !== undefined)
            url_ += "MemberNameFilter=" + encodeURIComponent("" + memberNameFilter) + "&";
        if (phoneFilter !== undefined)
            url_ += "PhoneFilter=" + encodeURIComponent("" + phoneFilter) + "&";
        if (zaloChatIDFilter !== undefined)
            url_ += "ZaloChatIDFilter=" + encodeURIComponent("" + zaloChatIDFilter) + "&";
        if (emailFilter !== undefined)
            url_ += "EmailFilter=" + encodeURIComponent("" + emailFilter) + "&";
        if (facebookIDFilter !== undefined)
            url_ += "FacebookIDFilter=" + encodeURIComponent("" + facebookIDFilter) + "&";
        if (memberCodeFilter !== undefined)
            url_ += "MemberCodeFilter=" + encodeURIComponent("" + memberCodeFilter) + "&";
        if (contentFilter !== undefined)
            url_ += "ContentFilter=" + encodeURIComponent("" + contentFilter) + "&";
        if (subjectFilter !== undefined)
            url_ += "SubjectFilter=" + encodeURIComponent("" + subjectFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetCommunicationTransactionForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetCommunicationTransactionForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetCommunicationTransactionForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetCommunicationTransactionForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetCommunicationTransactionForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetCommunicationTransactionForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getCommunicationTransactionForEdit(id: number | null | undefined): Observable<GetCommunicationTransactionForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/CommunicationTransactions/GetCommunicationTransactionForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCommunicationTransactionForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCommunicationTransactionForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetCommunicationTransactionForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetCommunicationTransactionForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetCommunicationTransactionForEdit(response: HttpResponseBase): Observable<GetCommunicationTransactionForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetCommunicationTransactionForEditOutput.fromJS(resultData200) : new GetCommunicationTransactionForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCommunicationTransactionForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditCommunicationTransactionDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CommunicationTransactions/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CommunicationTransactions/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param communicationIDFilter (optional) 
     * @param channelFilter (optional) 
     * @param memberNameFilter (optional) 
     * @param phoneFilter (optional) 
     * @param zaloChatIDFilter (optional) 
     * @param emailFilter (optional) 
     * @param facebookIDFilter (optional) 
     * @param memberCodeFilter (optional) 
     * @param contentFilter (optional) 
     * @param subjectFilter (optional) 
     * @return Success
     */
    getCommunicationTransactionsToExcel(filter: string | null | undefined, communicationIDFilter: string | null | undefined, channelFilter: string | null | undefined, memberNameFilter: string | null | undefined, phoneFilter: string | null | undefined, zaloChatIDFilter: string | null | undefined, emailFilter: string | null | undefined, facebookIDFilter: string | null | undefined, memberCodeFilter: string | null | undefined, contentFilter: string | null | undefined, subjectFilter: string | null | undefined): Observable<CommunicationsFileDto> {
        let url_ = this.baseUrl + "/api/services/app/CommunicationTransactions/GetCommunicationTransactionsToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (communicationIDFilter !== undefined)
            url_ += "CommunicationIDFilter=" + encodeURIComponent("" + communicationIDFilter) + "&";
        if (channelFilter !== undefined)
            url_ += "ChannelFilter=" + encodeURIComponent("" + channelFilter) + "&";
        if (memberNameFilter !== undefined)
            url_ += "MemberNameFilter=" + encodeURIComponent("" + memberNameFilter) + "&";
        if (phoneFilter !== undefined)
            url_ += "PhoneFilter=" + encodeURIComponent("" + phoneFilter) + "&";
        if (zaloChatIDFilter !== undefined)
            url_ += "ZaloChatIDFilter=" + encodeURIComponent("" + zaloChatIDFilter) + "&";
        if (emailFilter !== undefined)
            url_ += "EmailFilter=" + encodeURIComponent("" + emailFilter) + "&";
        if (facebookIDFilter !== undefined)
            url_ += "FacebookIDFilter=" + encodeURIComponent("" + facebookIDFilter) + "&";
        if (memberCodeFilter !== undefined)
            url_ += "MemberCodeFilter=" + encodeURIComponent("" + memberCodeFilter) + "&";
        if (contentFilter !== undefined)
            url_ += "ContentFilter=" + encodeURIComponent("" + contentFilter) + "&";
        if (subjectFilter !== undefined)
            url_ += "SubjectFilter=" + encodeURIComponent("" + subjectFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCommunicationTransactionsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCommunicationTransactionsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<CommunicationsFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CommunicationsFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetCommunicationTransactionsToExcel(response: HttpResponseBase): Observable<CommunicationsFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? CommunicationsFileDto.fromJS(resultData200) : new CommunicationsFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CommunicationsFileDto>(<any>null);
    }
}

@Injectable()
export class CommunicationUsersServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param phoneFilter (optional) 
     * @param zaloChatIDFilter (optional) 
     * @param emailFilter (optional) 
     * @param facebookIDFilter (optional) 
     * @param memberCodeFilter (optional) 
     * @param communicationLanguageFilter (optional) 
     * @param maxTargetAudienceLinkIDFilter (optional) 
     * @param minTargetAudienceLinkIDFilter (optional) 
     * @param maxCommunicationTargetAudienceIDFilter (optional) 
     * @param minCommunicationTargetAudienceIDFilter (optional) 
     * @param communicationChannelFilter (optional) 
     * @param outletCodeFilter (optional) 
     * @param param1Filter (optional) 
     * @param param2Filter (optional) 
     * @param param3Filter (optional) 
     * @param param4Filter (optional) 
     * @param param5Filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, nameFilter: string | null | undefined, phoneFilter: string | null | undefined, zaloChatIDFilter: string | null | undefined, emailFilter: string | null | undefined, facebookIDFilter: string | null | undefined, memberCodeFilter: string | null | undefined, communicationLanguageFilter: string | null | undefined, maxTargetAudienceLinkIDFilter: number | null | undefined, minTargetAudienceLinkIDFilter: number | null | undefined, maxCommunicationTargetAudienceIDFilter: number | null | undefined, minCommunicationTargetAudienceIDFilter: number | null | undefined, communicationChannelFilter: string | null | undefined, outletCodeFilter: string | null | undefined, param1Filter: string | null | undefined, param2Filter: string | null | undefined, param3Filter: string | null | undefined, param4Filter: string | null | undefined, param5Filter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetCommunicationUserForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/CommunicationUsers/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (phoneFilter !== undefined)
            url_ += "PhoneFilter=" + encodeURIComponent("" + phoneFilter) + "&";
        if (zaloChatIDFilter !== undefined)
            url_ += "ZaloChatIDFilter=" + encodeURIComponent("" + zaloChatIDFilter) + "&";
        if (emailFilter !== undefined)
            url_ += "EmailFilter=" + encodeURIComponent("" + emailFilter) + "&";
        if (facebookIDFilter !== undefined)
            url_ += "FacebookIDFilter=" + encodeURIComponent("" + facebookIDFilter) + "&";
        if (memberCodeFilter !== undefined)
            url_ += "MemberCodeFilter=" + encodeURIComponent("" + memberCodeFilter) + "&";
        if (communicationLanguageFilter !== undefined)
            url_ += "CommunicationLanguageFilter=" + encodeURIComponent("" + communicationLanguageFilter) + "&";
        if (maxTargetAudienceLinkIDFilter !== undefined)
            url_ += "MaxTargetAudienceLinkIDFilter=" + encodeURIComponent("" + maxTargetAudienceLinkIDFilter) + "&";
        if (minTargetAudienceLinkIDFilter !== undefined)
            url_ += "MinTargetAudienceLinkIDFilter=" + encodeURIComponent("" + minTargetAudienceLinkIDFilter) + "&";
        if (maxCommunicationTargetAudienceIDFilter !== undefined)
            url_ += "MaxCommunicationTargetAudienceIDFilter=" + encodeURIComponent("" + maxCommunicationTargetAudienceIDFilter) + "&";
        if (minCommunicationTargetAudienceIDFilter !== undefined)
            url_ += "MinCommunicationTargetAudienceIDFilter=" + encodeURIComponent("" + minCommunicationTargetAudienceIDFilter) + "&";
        if (communicationChannelFilter !== undefined)
            url_ += "CommunicationChannelFilter=" + encodeURIComponent("" + communicationChannelFilter) + "&";
        if (outletCodeFilter !== undefined)
            url_ += "OutletCodeFilter=" + encodeURIComponent("" + outletCodeFilter) + "&";
        if (param1Filter !== undefined)
            url_ += "Param1Filter=" + encodeURIComponent("" + param1Filter) + "&";
        if (param2Filter !== undefined)
            url_ += "Param2Filter=" + encodeURIComponent("" + param2Filter) + "&";
        if (param3Filter !== undefined)
            url_ += "Param3Filter=" + encodeURIComponent("" + param3Filter) + "&";
        if (param4Filter !== undefined)
            url_ += "Param4Filter=" + encodeURIComponent("" + param4Filter) + "&";
        if (param5Filter !== undefined)
            url_ += "Param5Filter=" + encodeURIComponent("" + param5Filter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetCommunicationUserForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetCommunicationUserForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetCommunicationUserForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetCommunicationUserForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetCommunicationUserForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetCommunicationUserForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getCommunicationUserForEdit(id: number | null | undefined): Observable<GetCommunicationUserForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/CommunicationUsers/GetCommunicationUserForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCommunicationUserForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCommunicationUserForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetCommunicationUserForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetCommunicationUserForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetCommunicationUserForEdit(response: HttpResponseBase): Observable<GetCommunicationUserForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetCommunicationUserForEditOutput.fromJS(resultData200) : new GetCommunicationUserForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCommunicationUserForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditCommunicationUserDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CommunicationUsers/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CommunicationUsers/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param phoneFilter (optional) 
     * @param zaloChatIDFilter (optional) 
     * @param emailFilter (optional) 
     * @param facebookIDFilter (optional) 
     * @param memberCodeFilter (optional) 
     * @param communicationLanguageFilter (optional) 
     * @param maxTargetAudienceLinkIDFilter (optional) 
     * @param minTargetAudienceLinkIDFilter (optional) 
     * @param maxCommunicationTargetAudienceIDFilter (optional) 
     * @param minCommunicationTargetAudienceIDFilter (optional) 
     * @param communicationChannelFilter (optional) 
     * @param outletCodeFilter (optional) 
     * @param param1Filter (optional) 
     * @param param2Filter (optional) 
     * @param param3Filter (optional) 
     * @param param4Filter (optional) 
     * @param param5Filter (optional) 
     * @return Success
     */
    getCommunicationUsersToExcel(filter: string | null | undefined, nameFilter: string | null | undefined, phoneFilter: string | null | undefined, zaloChatIDFilter: string | null | undefined, emailFilter: string | null | undefined, facebookIDFilter: string | null | undefined, memberCodeFilter: string | null | undefined, communicationLanguageFilter: string | null | undefined, maxTargetAudienceLinkIDFilter: number | null | undefined, minTargetAudienceLinkIDFilter: number | null | undefined, maxCommunicationTargetAudienceIDFilter: number | null | undefined, minCommunicationTargetAudienceIDFilter: number | null | undefined, communicationChannelFilter: string | null | undefined, outletCodeFilter: string | null | undefined, param1Filter: string | null | undefined, param2Filter: string | null | undefined, param3Filter: string | null | undefined, param4Filter: string | null | undefined, param5Filter: string | null | undefined): Observable<CommunicationsFileDto> {
        let url_ = this.baseUrl + "/api/services/app/CommunicationUsers/GetCommunicationUsersToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (phoneFilter !== undefined)
            url_ += "PhoneFilter=" + encodeURIComponent("" + phoneFilter) + "&";
        if (zaloChatIDFilter !== undefined)
            url_ += "ZaloChatIDFilter=" + encodeURIComponent("" + zaloChatIDFilter) + "&";
        if (emailFilter !== undefined)
            url_ += "EmailFilter=" + encodeURIComponent("" + emailFilter) + "&";
        if (facebookIDFilter !== undefined)
            url_ += "FacebookIDFilter=" + encodeURIComponent("" + facebookIDFilter) + "&";
        if (memberCodeFilter !== undefined)
            url_ += "MemberCodeFilter=" + encodeURIComponent("" + memberCodeFilter) + "&";
        if (communicationLanguageFilter !== undefined)
            url_ += "CommunicationLanguageFilter=" + encodeURIComponent("" + communicationLanguageFilter) + "&";
        if (maxTargetAudienceLinkIDFilter !== undefined)
            url_ += "MaxTargetAudienceLinkIDFilter=" + encodeURIComponent("" + maxTargetAudienceLinkIDFilter) + "&";
        if (minTargetAudienceLinkIDFilter !== undefined)
            url_ += "MinTargetAudienceLinkIDFilter=" + encodeURIComponent("" + minTargetAudienceLinkIDFilter) + "&";
        if (maxCommunicationTargetAudienceIDFilter !== undefined)
            url_ += "MaxCommunicationTargetAudienceIDFilter=" + encodeURIComponent("" + maxCommunicationTargetAudienceIDFilter) + "&";
        if (minCommunicationTargetAudienceIDFilter !== undefined)
            url_ += "MinCommunicationTargetAudienceIDFilter=" + encodeURIComponent("" + minCommunicationTargetAudienceIDFilter) + "&";
        if (communicationChannelFilter !== undefined)
            url_ += "CommunicationChannelFilter=" + encodeURIComponent("" + communicationChannelFilter) + "&";
        if (outletCodeFilter !== undefined)
            url_ += "OutletCodeFilter=" + encodeURIComponent("" + outletCodeFilter) + "&";
        if (param1Filter !== undefined)
            url_ += "Param1Filter=" + encodeURIComponent("" + param1Filter) + "&";
        if (param2Filter !== undefined)
            url_ += "Param2Filter=" + encodeURIComponent("" + param2Filter) + "&";
        if (param3Filter !== undefined)
            url_ += "Param3Filter=" + encodeURIComponent("" + param3Filter) + "&";
        if (param4Filter !== undefined)
            url_ += "Param4Filter=" + encodeURIComponent("" + param4Filter) + "&";
        if (param5Filter !== undefined)
            url_ += "Param5Filter=" + encodeURIComponent("" + param5Filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCommunicationUsersToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCommunicationUsersToExcel(<any>response_);
                } catch (e) {
                    return <Observable<CommunicationsFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CommunicationsFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetCommunicationUsersToExcel(response: HttpResponseBase): Observable<CommunicationsFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? CommunicationsFileDto.fromJS(resultData200) : new CommunicationsFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CommunicationsFileDto>(<any>null);
    }
}

@Injectable()
export class CompanyInfosServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param typeFilter (optional) 
     * @param dataFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, typeFilter: string | null | undefined, dataFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetCompanyInfoForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/CompanyInfos/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (typeFilter !== undefined)
            url_ += "TypeFilter=" + encodeURIComponent("" + typeFilter) + "&";
        if (dataFilter !== undefined)
            url_ += "DataFilter=" + encodeURIComponent("" + dataFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetCompanyInfoForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetCompanyInfoForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetCompanyInfoForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetCompanyInfoForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetCompanyInfoForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetCompanyInfoForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getCompanyInfoForEdit(id: number | null | undefined): Observable<GetCompanyInfoForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/CompanyInfos/GetCompanyInfoForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCompanyInfoForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompanyInfoForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetCompanyInfoForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetCompanyInfoForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetCompanyInfoForEdit(response: HttpResponseBase): Observable<GetCompanyInfoForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetCompanyInfoForEditOutput.fromJS(resultData200) : new GetCompanyInfoForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCompanyInfoForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditCompanyInfoDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CompanyInfos/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CompanyInfos/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param typeFilter (optional) 
     * @param dataFilter (optional) 
     * @return Success
     */
    getCompanyInfosToExcel(filter: string | null | undefined, typeFilter: string | null | undefined, dataFilter: string | null | undefined): Observable<ConsumerDBFileDto> {
        let url_ = this.baseUrl + "/api/services/app/CompanyInfos/GetCompanyInfosToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (typeFilter !== undefined)
            url_ += "TypeFilter=" + encodeURIComponent("" + typeFilter) + "&";
        if (dataFilter !== undefined)
            url_ += "DataFilter=" + encodeURIComponent("" + dataFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCompanyInfosToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompanyInfosToExcel(<any>response_);
                } catch (e) {
                    return <Observable<ConsumerDBFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ConsumerDBFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetCompanyInfosToExcel(response: HttpResponseBase): Observable<ConsumerDBFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? ConsumerDBFileDto.fromJS(resultData200) : new ConsumerDBFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ConsumerDBFileDto>(<any>null);
    }
}

@Injectable()
export class ConsentReportsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param memberCodeFilter (optional) 
     * @param maxSentDateFilter (optional) 
     * @param minSentDateFilter (optional) 
     * @param contentFilter (optional) 
     * @param phoneNumberFilter (optional) 
     * @param oTPFilter (optional) 
     * @param isAcceptFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, memberCodeFilter: string | null | undefined, maxSentDateFilter: moment.Moment | null | undefined, minSentDateFilter: moment.Moment | null | undefined, contentFilter: string | null | undefined, phoneNumberFilter: string | null | undefined, oTPFilter: string | null | undefined, isAcceptFilter: number | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetConsentReportForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/ConsentReports/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (memberCodeFilter !== undefined)
            url_ += "MemberCodeFilter=" + encodeURIComponent("" + memberCodeFilter) + "&";
        if (maxSentDateFilter !== undefined)
            url_ += "MaxSentDateFilter=" + encodeURIComponent(maxSentDateFilter ? "" + maxSentDateFilter.toJSON() : "") + "&";
        if (minSentDateFilter !== undefined)
            url_ += "MinSentDateFilter=" + encodeURIComponent(minSentDateFilter ? "" + minSentDateFilter.toJSON() : "") + "&";
        if (contentFilter !== undefined)
            url_ += "ContentFilter=" + encodeURIComponent("" + contentFilter) + "&";
        if (phoneNumberFilter !== undefined)
            url_ += "PhoneNumberFilter=" + encodeURIComponent("" + phoneNumberFilter) + "&";
        if (oTPFilter !== undefined)
            url_ += "OTPFilter=" + encodeURIComponent("" + oTPFilter) + "&";
        if (isAcceptFilter !== undefined)
            url_ += "IsAcceptFilter=" + encodeURIComponent("" + isAcceptFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetConsentReportForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetConsentReportForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetConsentReportForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetConsentReportForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetConsentReportForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetConsentReportForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getConsentReportForEdit(id: number | null | undefined): Observable<GetConsentReportForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/ConsentReports/GetConsentReportForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetConsentReportForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConsentReportForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetConsentReportForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetConsentReportForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetConsentReportForEdit(response: HttpResponseBase): Observable<GetConsentReportForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetConsentReportForEditOutput.fromJS(resultData200) : new GetConsentReportForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetConsentReportForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditConsentReportDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ConsentReports/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ConsentReports/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    search(input: GetAllConsentReportsInput | null | undefined): Observable<PagedResultDtoOfGetConsentReportForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/ConsentReports/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetConsentReportForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetConsentReportForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<PagedResultDtoOfGetConsentReportForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetConsentReportForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetConsentReportForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetConsentReportForViewDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    exportConsentToExcel(input: GetAllConsentReportsInput | null | undefined): Observable<SocialRetailerFileDto> {
        let url_ = this.baseUrl + "/api/services/app/ConsentReports/ExportConsentToExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processExportConsentToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportConsentToExcel(<any>response_);
                } catch (e) {
                    return <Observable<SocialRetailerFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SocialRetailerFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processExportConsentToExcel(response: HttpResponseBase): Observable<SocialRetailerFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? SocialRetailerFileDto.fromJS(resultData200) : new SocialRetailerFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SocialRetailerFileDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEditExt(input: CreateOrEditConsentReportDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ConsentReports/CreateOrEditExt";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEditExt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditExt(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEditExt(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class ConsumerActivitiesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param memberCodeFilter (optional) 
     * @param activityTypeFilter (optional) 
     * @param maxActivityTimeFilter (optional) 
     * @param minActivityTimeFilter (optional) 
     * @param referrenceCodeFilter (optional) 
     * @param customerCodeFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, memberCodeFilter: string | null | undefined, activityTypeFilter: string | null | undefined, maxActivityTimeFilter: moment.Moment | null | undefined, minActivityTimeFilter: moment.Moment | null | undefined, referrenceCodeFilter: string | null | undefined, customerCodeFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetConsumerActivityForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/ConsumerActivities/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (memberCodeFilter !== undefined)
            url_ += "MemberCodeFilter=" + encodeURIComponent("" + memberCodeFilter) + "&";
        if (activityTypeFilter !== undefined)
            url_ += "ActivityTypeFilter=" + encodeURIComponent("" + activityTypeFilter) + "&";
        if (maxActivityTimeFilter !== undefined)
            url_ += "MaxActivityTimeFilter=" + encodeURIComponent(maxActivityTimeFilter ? "" + maxActivityTimeFilter.toJSON() : "") + "&";
        if (minActivityTimeFilter !== undefined)
            url_ += "MinActivityTimeFilter=" + encodeURIComponent(minActivityTimeFilter ? "" + minActivityTimeFilter.toJSON() : "") + "&";
        if (referrenceCodeFilter !== undefined)
            url_ += "ReferrenceCodeFilter=" + encodeURIComponent("" + referrenceCodeFilter) + "&";
        if (customerCodeFilter !== undefined)
            url_ += "CustomerCodeFilter=" + encodeURIComponent("" + customerCodeFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetConsumerActivityForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetConsumerActivityForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetConsumerActivityForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetConsumerActivityForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetConsumerActivityForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetConsumerActivityForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getConsumerActivityForEdit(id: number | null | undefined): Observable<GetConsumerActivityForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/ConsumerActivities/GetConsumerActivityForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetConsumerActivityForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConsumerActivityForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetConsumerActivityForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetConsumerActivityForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetConsumerActivityForEdit(response: HttpResponseBase): Observable<GetConsumerActivityForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetConsumerActivityForEditOutput.fromJS(resultData200) : new GetConsumerActivityForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetConsumerActivityForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditConsumerActivityDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ConsumerActivities/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ConsumerActivities/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param memberCodeFilter (optional) 
     * @param activityTypeFilter (optional) 
     * @param maxActivityTimeFilter (optional) 
     * @param minActivityTimeFilter (optional) 
     * @param referrenceCodeFilter (optional) 
     * @param customerCodeFilter (optional) 
     * @return Success
     */
    getConsumerActivitiesToExcel(filter: string | null | undefined, memberCodeFilter: string | null | undefined, activityTypeFilter: string | null | undefined, maxActivityTimeFilter: moment.Moment | null | undefined, minActivityTimeFilter: moment.Moment | null | undefined, referrenceCodeFilter: string | null | undefined, customerCodeFilter: string | null | undefined): Observable<ConsumerDBFileDto> {
        let url_ = this.baseUrl + "/api/services/app/ConsumerActivities/GetConsumerActivitiesToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (memberCodeFilter !== undefined)
            url_ += "MemberCodeFilter=" + encodeURIComponent("" + memberCodeFilter) + "&";
        if (activityTypeFilter !== undefined)
            url_ += "ActivityTypeFilter=" + encodeURIComponent("" + activityTypeFilter) + "&";
        if (maxActivityTimeFilter !== undefined)
            url_ += "MaxActivityTimeFilter=" + encodeURIComponent(maxActivityTimeFilter ? "" + maxActivityTimeFilter.toJSON() : "") + "&";
        if (minActivityTimeFilter !== undefined)
            url_ += "MinActivityTimeFilter=" + encodeURIComponent(minActivityTimeFilter ? "" + minActivityTimeFilter.toJSON() : "") + "&";
        if (referrenceCodeFilter !== undefined)
            url_ += "ReferrenceCodeFilter=" + encodeURIComponent("" + referrenceCodeFilter) + "&";
        if (customerCodeFilter !== undefined)
            url_ += "CustomerCodeFilter=" + encodeURIComponent("" + customerCodeFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetConsumerActivitiesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConsumerActivitiesToExcel(<any>response_);
                } catch (e) {
                    return <Observable<ConsumerDBFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ConsumerDBFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetConsumerActivitiesToExcel(response: HttpResponseBase): Observable<ConsumerDBFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? ConsumerDBFileDto.fromJS(resultData200) : new ConsumerDBFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ConsumerDBFileDto>(<any>null);
    }
}

@Injectable()
export class ConsumerDbProductsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param productCodeFilter (optional) 
     * @param productName1Filter (optional) 
     * @param productName2Filter (optional) 
     * @param hierarchyL1Filter (optional) 
     * @param hierarchyL2Filter (optional) 
     * @param hierarchyL3Filter (optional) 
     * @param hierarchyL4Filter (optional) 
     * @param hierarchyL5Filter (optional) 
     * @param statusFilter (optional) 
     * @param productName2UnSignFilter (optional) 
     * @param productName1UnSignFilter (optional) 
     * @param imageLinkFilter (optional) 
     * @param referenceCodeFilter (optional) 
     * @param uOMCodeFilter (optional) 
     * @param maxOldPriceFilter (optional) 
     * @param minOldPriceFilter (optional) 
     * @param maxNewPriceFilter (optional) 
     * @param minNewPriceFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param isNewFilter (optional) 
     * @param tagFilter (optional) 
     * @param contentVNFilter (optional) 
     * @param contentENFilter (optional) 
     * @param linkDirectFilter (optional) 
     * @param isFeatureFilter (optional) 
     * @param hierarchyFullLevelFilter (optional) 
     * @param isOnApp (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, productCodeFilter: string | null | undefined, productName1Filter: string | null | undefined, productName2Filter: string | null | undefined, hierarchyL1Filter: string | null | undefined, hierarchyL2Filter: string | null | undefined, hierarchyL3Filter: string | null | undefined, hierarchyL4Filter: string | null | undefined, hierarchyL5Filter: string | null | undefined, statusFilter: string | null | undefined, productName2UnSignFilter: string | null | undefined, productName1UnSignFilter: string | null | undefined, imageLinkFilter: string | null | undefined, referenceCodeFilter: string | null | undefined, uOMCodeFilter: string | null | undefined, maxOldPriceFilter: number | null | undefined, minOldPriceFilter: number | null | undefined, maxNewPriceFilter: number | null | undefined, minNewPriceFilter: number | null | undefined, descriptionFilter: string | null | undefined, isNewFilter: number | null | undefined, tagFilter: string | null | undefined, contentVNFilter: string | null | undefined, contentENFilter: string | null | undefined, linkDirectFilter: string | null | undefined, isFeatureFilter: number | null | undefined, hierarchyFullLevelFilter: string | null | undefined, isOnApp: boolean | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetProductForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/ConsumerDbProducts/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (productCodeFilter !== undefined)
            url_ += "ProductCodeFilter=" + encodeURIComponent("" + productCodeFilter) + "&";
        if (productName1Filter !== undefined)
            url_ += "ProductName1Filter=" + encodeURIComponent("" + productName1Filter) + "&";
        if (productName2Filter !== undefined)
            url_ += "ProductName2Filter=" + encodeURIComponent("" + productName2Filter) + "&";
        if (hierarchyL1Filter !== undefined)
            url_ += "HierarchyL1Filter=" + encodeURIComponent("" + hierarchyL1Filter) + "&";
        if (hierarchyL2Filter !== undefined)
            url_ += "HierarchyL2Filter=" + encodeURIComponent("" + hierarchyL2Filter) + "&";
        if (hierarchyL3Filter !== undefined)
            url_ += "HierarchyL3Filter=" + encodeURIComponent("" + hierarchyL3Filter) + "&";
        if (hierarchyL4Filter !== undefined)
            url_ += "HierarchyL4Filter=" + encodeURIComponent("" + hierarchyL4Filter) + "&";
        if (hierarchyL5Filter !== undefined)
            url_ += "HierarchyL5Filter=" + encodeURIComponent("" + hierarchyL5Filter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (productName2UnSignFilter !== undefined)
            url_ += "ProductName2UnSignFilter=" + encodeURIComponent("" + productName2UnSignFilter) + "&";
        if (productName1UnSignFilter !== undefined)
            url_ += "ProductName1UnSignFilter=" + encodeURIComponent("" + productName1UnSignFilter) + "&";
        if (imageLinkFilter !== undefined)
            url_ += "ImageLinkFilter=" + encodeURIComponent("" + imageLinkFilter) + "&";
        if (referenceCodeFilter !== undefined)
            url_ += "ReferenceCodeFilter=" + encodeURIComponent("" + referenceCodeFilter) + "&";
        if (uOMCodeFilter !== undefined)
            url_ += "UOMCodeFilter=" + encodeURIComponent("" + uOMCodeFilter) + "&";
        if (maxOldPriceFilter !== undefined)
            url_ += "MaxOldPriceFilter=" + encodeURIComponent("" + maxOldPriceFilter) + "&";
        if (minOldPriceFilter !== undefined)
            url_ += "MinOldPriceFilter=" + encodeURIComponent("" + minOldPriceFilter) + "&";
        if (maxNewPriceFilter !== undefined)
            url_ += "MaxNewPriceFilter=" + encodeURIComponent("" + maxNewPriceFilter) + "&";
        if (minNewPriceFilter !== undefined)
            url_ += "MinNewPriceFilter=" + encodeURIComponent("" + minNewPriceFilter) + "&";
        if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&";
        if (isNewFilter !== undefined)
            url_ += "IsNewFilter=" + encodeURIComponent("" + isNewFilter) + "&";
        if (tagFilter !== undefined)
            url_ += "TagFilter=" + encodeURIComponent("" + tagFilter) + "&";
        if (contentVNFilter !== undefined)
            url_ += "ContentVNFilter=" + encodeURIComponent("" + contentVNFilter) + "&";
        if (contentENFilter !== undefined)
            url_ += "ContentENFilter=" + encodeURIComponent("" + contentENFilter) + "&";
        if (linkDirectFilter !== undefined)
            url_ += "LinkDirectFilter=" + encodeURIComponent("" + linkDirectFilter) + "&";
        if (isFeatureFilter !== undefined)
            url_ += "IsFeatureFilter=" + encodeURIComponent("" + isFeatureFilter) + "&";
        if (hierarchyFullLevelFilter !== undefined)
            url_ += "HierarchyFullLevelFilter=" + encodeURIComponent("" + hierarchyFullLevelFilter) + "&";
        if (isOnApp !== undefined)
            url_ += "IsOnApp=" + encodeURIComponent("" + isOnApp) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetProductForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetProductForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetProductForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetProductForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetProductForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetProductForViewDto>(<any>null);
    }

    /**
     * @return Success
     */
    getExchanged(): Observable<PagedResultDtoOfGetProductExchangedForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/ConsumerDbProducts/GetExchanged";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetExchanged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExchanged(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetProductExchangedForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetProductExchangedForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetExchanged(response: HttpResponseBase): Observable<PagedResultDtoOfGetProductExchangedForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetProductExchangedForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetProductExchangedForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetProductExchangedForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getProductForEdit(id: number | null | undefined): Observable<GetConsumerDbProductForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/ConsumerDbProducts/GetProductForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetProductForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetConsumerDbProductForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetConsumerDbProductForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetProductForEdit(response: HttpResponseBase): Observable<GetConsumerDbProductForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetConsumerDbProductForEditOutput.fromJS(resultData200) : new GetConsumerDbProductForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetConsumerDbProductForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditConsumerDbProductDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ConsumerDbProducts/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ConsumerDbProducts/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param productCodeFilter (optional) 
     * @param productName1Filter (optional) 
     * @param productName2Filter (optional) 
     * @param hierarchyL1Filter (optional) 
     * @param hierarchyL2Filter (optional) 
     * @param hierarchyL3Filter (optional) 
     * @param hierarchyL4Filter (optional) 
     * @param hierarchyL5Filter (optional) 
     * @param statusFilter (optional) 
     * @param productName2UnSignFilter (optional) 
     * @param productName1UnSignFilter (optional) 
     * @param imageLinkFilter (optional) 
     * @param referenceCodeFilter (optional) 
     * @param uOMCodeFilter (optional) 
     * @param maxOldPriceFilter (optional) 
     * @param minOldPriceFilter (optional) 
     * @param maxNewPriceFilter (optional) 
     * @param minNewPriceFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param isNewFilter (optional) 
     * @param tagFilter (optional) 
     * @param contentVNFilter (optional) 
     * @param contentENFilter (optional) 
     * @param linkDirectFilter (optional) 
     * @param isFeatureFilter (optional) 
     * @return Success
     */
    getProductsToExcel(filter: string | null | undefined, productCodeFilter: string | null | undefined, productName1Filter: string | null | undefined, productName2Filter: string | null | undefined, hierarchyL1Filter: string | null | undefined, hierarchyL2Filter: string | null | undefined, hierarchyL3Filter: string | null | undefined, hierarchyL4Filter: string | null | undefined, hierarchyL5Filter: string | null | undefined, statusFilter: string | null | undefined, productName2UnSignFilter: string | null | undefined, productName1UnSignFilter: string | null | undefined, imageLinkFilter: string | null | undefined, referenceCodeFilter: string | null | undefined, uOMCodeFilter: string | null | undefined, maxOldPriceFilter: number | null | undefined, minOldPriceFilter: number | null | undefined, maxNewPriceFilter: number | null | undefined, minNewPriceFilter: number | null | undefined, descriptionFilter: string | null | undefined, isNewFilter: number | null | undefined, tagFilter: string | null | undefined, contentVNFilter: string | null | undefined, contentENFilter: string | null | undefined, linkDirectFilter: string | null | undefined, isFeatureFilter: number | null | undefined): Observable<ConsumerDBFileDto> {
        let url_ = this.baseUrl + "/api/services/app/ConsumerDbProducts/GetProductsToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (productCodeFilter !== undefined)
            url_ += "ProductCodeFilter=" + encodeURIComponent("" + productCodeFilter) + "&";
        if (productName1Filter !== undefined)
            url_ += "ProductName1Filter=" + encodeURIComponent("" + productName1Filter) + "&";
        if (productName2Filter !== undefined)
            url_ += "ProductName2Filter=" + encodeURIComponent("" + productName2Filter) + "&";
        if (hierarchyL1Filter !== undefined)
            url_ += "HierarchyL1Filter=" + encodeURIComponent("" + hierarchyL1Filter) + "&";
        if (hierarchyL2Filter !== undefined)
            url_ += "HierarchyL2Filter=" + encodeURIComponent("" + hierarchyL2Filter) + "&";
        if (hierarchyL3Filter !== undefined)
            url_ += "HierarchyL3Filter=" + encodeURIComponent("" + hierarchyL3Filter) + "&";
        if (hierarchyL4Filter !== undefined)
            url_ += "HierarchyL4Filter=" + encodeURIComponent("" + hierarchyL4Filter) + "&";
        if (hierarchyL5Filter !== undefined)
            url_ += "HierarchyL5Filter=" + encodeURIComponent("" + hierarchyL5Filter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (productName2UnSignFilter !== undefined)
            url_ += "ProductName2UnSignFilter=" + encodeURIComponent("" + productName2UnSignFilter) + "&";
        if (productName1UnSignFilter !== undefined)
            url_ += "ProductName1UnSignFilter=" + encodeURIComponent("" + productName1UnSignFilter) + "&";
        if (imageLinkFilter !== undefined)
            url_ += "ImageLinkFilter=" + encodeURIComponent("" + imageLinkFilter) + "&";
        if (referenceCodeFilter !== undefined)
            url_ += "ReferenceCodeFilter=" + encodeURIComponent("" + referenceCodeFilter) + "&";
        if (uOMCodeFilter !== undefined)
            url_ += "UOMCodeFilter=" + encodeURIComponent("" + uOMCodeFilter) + "&";
        if (maxOldPriceFilter !== undefined)
            url_ += "MaxOldPriceFilter=" + encodeURIComponent("" + maxOldPriceFilter) + "&";
        if (minOldPriceFilter !== undefined)
            url_ += "MinOldPriceFilter=" + encodeURIComponent("" + minOldPriceFilter) + "&";
        if (maxNewPriceFilter !== undefined)
            url_ += "MaxNewPriceFilter=" + encodeURIComponent("" + maxNewPriceFilter) + "&";
        if (minNewPriceFilter !== undefined)
            url_ += "MinNewPriceFilter=" + encodeURIComponent("" + minNewPriceFilter) + "&";
        if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&";
        if (isNewFilter !== undefined)
            url_ += "IsNewFilter=" + encodeURIComponent("" + isNewFilter) + "&";
        if (tagFilter !== undefined)
            url_ += "TagFilter=" + encodeURIComponent("" + tagFilter) + "&";
        if (contentVNFilter !== undefined)
            url_ += "ContentVNFilter=" + encodeURIComponent("" + contentVNFilter) + "&";
        if (contentENFilter !== undefined)
            url_ += "ContentENFilter=" + encodeURIComponent("" + contentENFilter) + "&";
        if (linkDirectFilter !== undefined)
            url_ += "LinkDirectFilter=" + encodeURIComponent("" + linkDirectFilter) + "&";
        if (isFeatureFilter !== undefined)
            url_ += "IsFeatureFilter=" + encodeURIComponent("" + isFeatureFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetProductsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<ConsumerDBFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ConsumerDBFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetProductsToExcel(response: HttpResponseBase): Observable<ConsumerDBFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? ConsumerDBFileDto.fromJS(resultData200) : new ConsumerDBFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ConsumerDBFileDto>(<any>null);
    }

    /**
     * @param listProductId (optional) 
     * @return Success
     */
    searchRelatedProduct(listProductId: number[] | null | undefined): Observable<PagedResultDtoOfGetProductForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/ConsumerDbProducts/SearchRelatedProduct";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listProductId);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSearchRelatedProduct(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchRelatedProduct(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetProductForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetProductForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processSearchRelatedProduct(response: HttpResponseBase): Observable<PagedResultDtoOfGetProductForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetProductForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetProductForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetProductForViewDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    search(input: GetAllConsumerDbProductsInput | null | undefined): Observable<PagedResultDtoOfGetProductForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/ConsumerDbProducts/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetProductForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetProductForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<PagedResultDtoOfGetProductForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetProductForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetProductForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetProductForViewDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    exportProductsToExcel(input: GetAllConsumerDbProductsInput | null | undefined): Observable<ConsumerDBFileDto> {
        let url_ = this.baseUrl + "/api/services/app/ConsumerDbProducts/ExportProductsToExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processExportProductsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportProductsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<ConsumerDBFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ConsumerDBFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processExportProductsToExcel(response: HttpResponseBase): Observable<ConsumerDBFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? ConsumerDBFileDto.fromJS(resultData200) : new ConsumerDBFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ConsumerDBFileDto>(<any>null);
    }

    /**
     * @return Success
     */
    getConditionSearchProduct(): Observable<ConditionSearchProduct> {
        let url_ = this.baseUrl + "/api/services/app/ConsumerDbProducts/GetConditionSearchProduct";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetConditionSearchProduct(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConditionSearchProduct(<any>response_);
                } catch (e) {
                    return <Observable<ConditionSearchProduct>><any>_observableThrow(e);
                }
            } else
                return <Observable<ConditionSearchProduct>><any>_observableThrow(response_);
        }));
    }

    protected processGetConditionSearchProduct(response: HttpResponseBase): Observable<ConditionSearchProduct> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? ConditionSearchProduct.fromJS(resultData200) : new ConditionSearchProduct();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ConditionSearchProduct>(<any>null);
    }

    /**
     * @param arg (optional) 
     * @return Success
     */
    importQueue(arg: ProductInfoAgrs | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ConsumerDbProducts/ImportQueue";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(arg);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processImportQueue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportQueue(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processImportQueue(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEditExt(input: CreateOrEditConsumerDbProductDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ConsumerDbProducts/CreateOrEditExt";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEditExt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditExt(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEditExt(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param productCodeFilter (optional) 
     * @param productName1Filter (optional) 
     * @param productName2Filter (optional) 
     * @param hierarchyL1Filter (optional) 
     * @param hierarchyL2Filter (optional) 
     * @param hierarchyL3Filter (optional) 
     * @param hierarchyL4Filter (optional) 
     * @param hierarchyL5Filter (optional) 
     * @param statusFilter (optional) 
     * @param productName2UnSignFilter (optional) 
     * @param productName1UnSignFilter (optional) 
     * @param imageLinkFilter (optional) 
     * @param referenceCodeFilter (optional) 
     * @param uOMCodeFilter (optional) 
     * @param maxOldPriceFilter (optional) 
     * @param minOldPriceFilter (optional) 
     * @param maxNewPriceFilter (optional) 
     * @param minNewPriceFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param isNewFilter (optional) 
     * @param tagFilter (optional) 
     * @param contentVNFilter (optional) 
     * @param contentENFilter (optional) 
     * @param linkDirectFilter (optional) 
     * @param isFeatureFilter (optional) 
     * @param hierarchyFullLevelFilter (optional) 
     * @param isOnApp (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllExt(filter: string | null | undefined, productCodeFilter: string | null | undefined, productName1Filter: string | null | undefined, productName2Filter: string | null | undefined, hierarchyL1Filter: string | null | undefined, hierarchyL2Filter: string | null | undefined, hierarchyL3Filter: string | null | undefined, hierarchyL4Filter: string | null | undefined, hierarchyL5Filter: string | null | undefined, statusFilter: string | null | undefined, productName2UnSignFilter: string | null | undefined, productName1UnSignFilter: string | null | undefined, imageLinkFilter: string | null | undefined, referenceCodeFilter: string | null | undefined, uOMCodeFilter: string | null | undefined, maxOldPriceFilter: number | null | undefined, minOldPriceFilter: number | null | undefined, maxNewPriceFilter: number | null | undefined, minNewPriceFilter: number | null | undefined, descriptionFilter: string | null | undefined, isNewFilter: number | null | undefined, tagFilter: string | null | undefined, contentVNFilter: string | null | undefined, contentENFilter: string | null | undefined, linkDirectFilter: string | null | undefined, isFeatureFilter: number | null | undefined, hierarchyFullLevelFilter: string | null | undefined, isOnApp: boolean | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetProductForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/ConsumerDbProducts/GetAllExt?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (productCodeFilter !== undefined)
            url_ += "ProductCodeFilter=" + encodeURIComponent("" + productCodeFilter) + "&";
        if (productName1Filter !== undefined)
            url_ += "ProductName1Filter=" + encodeURIComponent("" + productName1Filter) + "&";
        if (productName2Filter !== undefined)
            url_ += "ProductName2Filter=" + encodeURIComponent("" + productName2Filter) + "&";
        if (hierarchyL1Filter !== undefined)
            url_ += "HierarchyL1Filter=" + encodeURIComponent("" + hierarchyL1Filter) + "&";
        if (hierarchyL2Filter !== undefined)
            url_ += "HierarchyL2Filter=" + encodeURIComponent("" + hierarchyL2Filter) + "&";
        if (hierarchyL3Filter !== undefined)
            url_ += "HierarchyL3Filter=" + encodeURIComponent("" + hierarchyL3Filter) + "&";
        if (hierarchyL4Filter !== undefined)
            url_ += "HierarchyL4Filter=" + encodeURIComponent("" + hierarchyL4Filter) + "&";
        if (hierarchyL5Filter !== undefined)
            url_ += "HierarchyL5Filter=" + encodeURIComponent("" + hierarchyL5Filter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (productName2UnSignFilter !== undefined)
            url_ += "ProductName2UnSignFilter=" + encodeURIComponent("" + productName2UnSignFilter) + "&";
        if (productName1UnSignFilter !== undefined)
            url_ += "ProductName1UnSignFilter=" + encodeURIComponent("" + productName1UnSignFilter) + "&";
        if (imageLinkFilter !== undefined)
            url_ += "ImageLinkFilter=" + encodeURIComponent("" + imageLinkFilter) + "&";
        if (referenceCodeFilter !== undefined)
            url_ += "ReferenceCodeFilter=" + encodeURIComponent("" + referenceCodeFilter) + "&";
        if (uOMCodeFilter !== undefined)
            url_ += "UOMCodeFilter=" + encodeURIComponent("" + uOMCodeFilter) + "&";
        if (maxOldPriceFilter !== undefined)
            url_ += "MaxOldPriceFilter=" + encodeURIComponent("" + maxOldPriceFilter) + "&";
        if (minOldPriceFilter !== undefined)
            url_ += "MinOldPriceFilter=" + encodeURIComponent("" + minOldPriceFilter) + "&";
        if (maxNewPriceFilter !== undefined)
            url_ += "MaxNewPriceFilter=" + encodeURIComponent("" + maxNewPriceFilter) + "&";
        if (minNewPriceFilter !== undefined)
            url_ += "MinNewPriceFilter=" + encodeURIComponent("" + minNewPriceFilter) + "&";
        if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&";
        if (isNewFilter !== undefined)
            url_ += "IsNewFilter=" + encodeURIComponent("" + isNewFilter) + "&";
        if (tagFilter !== undefined)
            url_ += "TagFilter=" + encodeURIComponent("" + tagFilter) + "&";
        if (contentVNFilter !== undefined)
            url_ += "ContentVNFilter=" + encodeURIComponent("" + contentVNFilter) + "&";
        if (contentENFilter !== undefined)
            url_ += "ContentENFilter=" + encodeURIComponent("" + contentENFilter) + "&";
        if (linkDirectFilter !== undefined)
            url_ += "LinkDirectFilter=" + encodeURIComponent("" + linkDirectFilter) + "&";
        if (isFeatureFilter !== undefined)
            url_ += "IsFeatureFilter=" + encodeURIComponent("" + isFeatureFilter) + "&";
        if (hierarchyFullLevelFilter !== undefined)
            url_ += "HierarchyFullLevelFilter=" + encodeURIComponent("" + hierarchyFullLevelFilter) + "&";
        if (isOnApp !== undefined)
            url_ += "IsOnApp=" + encodeURIComponent("" + isOnApp) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllExt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllExt(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetProductForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetProductForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllExt(response: HttpResponseBase): Observable<PagedResultDtoOfGetProductForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetProductForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetProductForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetProductForViewDto>(<any>null);
    }

    /**
     * @param listClone (optional) 
     * @return Success
     */
    clone(listClone: CreateOrEditConsumerDbProductDto[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ConsumerDbProducts/Clone";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listClone);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processClone(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClone(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processClone(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param listId (optional) 
     * @return Success
     */
    batchDeleteAsync(listId: number[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ConsumerDbProducts/BatchDeleteAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listId);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processBatchDeleteAsync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBatchDeleteAsync(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processBatchDeleteAsync(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param listId (optional) 
     * @return Success
     */
    isListProductActive(listId: number[] | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/ConsumerDbProducts/IsListProductActive";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listId);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processIsListProductActive(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsListProductActive(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processIsListProductActive(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param productCode (optional) 
     * @return Success
     */
    checkProductCodeAsync(productCode: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/ConsumerDbProducts/CheckProductCodeAsync?";
        if (productCode !== undefined)
            url_ += "productCode=" + encodeURIComponent("" + productCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCheckProductCodeAsync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckProductCodeAsync(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processCheckProductCodeAsync(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getProductById(id: number | null | undefined): Observable<GetConsumerDbProductForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/ConsumerDbProducts/GetProductById?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetProductById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductById(<any>response_);
                } catch (e) {
                    return <Observable<GetConsumerDbProductForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetConsumerDbProductForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetProductById(response: HttpResponseBase): Observable<GetConsumerDbProductForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetConsumerDbProductForEditOutput.fromJS(resultData200) : new GetConsumerDbProductForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetConsumerDbProductForEditOutput>(<any>null);
    }

    /**
     * @return Success
     */
    exportTemplate(): Observable<ConsumerDBFileDto> {
        let url_ = this.baseUrl + "/api/services/app/ConsumerDbProducts/ExportTemplate";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processExportTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportTemplate(<any>response_);
                } catch (e) {
                    return <Observable<ConsumerDBFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ConsumerDBFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processExportTemplate(response: HttpResponseBase): Observable<ConsumerDBFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? ConsumerDBFileDto.fromJS(resultData200) : new ConsumerDBFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ConsumerDBFileDto>(<any>null);
    }
}

@Injectable()
export class ConsumerLoginsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param memberCodeFilter (optional) 
     * @param nameFilter (optional) 
     * @param phoneFilter (optional) 
     * @param emailFilter (optional) 
     * @param facebookIDFilter (optional) 
     * @param googleIDFilter (optional) 
     * @param isLogOutFilter (optional) 
     * @param deviceIDFilter (optional) 
     * @param maxLastLoginFilter (optional) 
     * @param minLastLoginFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, memberCodeFilter: string | null | undefined, nameFilter: string | null | undefined, phoneFilter: string | null | undefined, emailFilter: string | null | undefined, facebookIDFilter: string | null | undefined, googleIDFilter: string | null | undefined, isLogOutFilter: number | null | undefined, deviceIDFilter: string | null | undefined, maxLastLoginFilter: moment.Moment | null | undefined, minLastLoginFilter: moment.Moment | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetConsumerLoginForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/ConsumerLogins/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (memberCodeFilter !== undefined)
            url_ += "MemberCodeFilter=" + encodeURIComponent("" + memberCodeFilter) + "&";
        if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (phoneFilter !== undefined)
            url_ += "PhoneFilter=" + encodeURIComponent("" + phoneFilter) + "&";
        if (emailFilter !== undefined)
            url_ += "EmailFilter=" + encodeURIComponent("" + emailFilter) + "&";
        if (facebookIDFilter !== undefined)
            url_ += "FacebookIDFilter=" + encodeURIComponent("" + facebookIDFilter) + "&";
        if (googleIDFilter !== undefined)
            url_ += "GoogleIDFilter=" + encodeURIComponent("" + googleIDFilter) + "&";
        if (isLogOutFilter !== undefined)
            url_ += "IsLogOutFilter=" + encodeURIComponent("" + isLogOutFilter) + "&";
        if (deviceIDFilter !== undefined)
            url_ += "DeviceIDFilter=" + encodeURIComponent("" + deviceIDFilter) + "&";
        if (maxLastLoginFilter !== undefined)
            url_ += "MaxLastLoginFilter=" + encodeURIComponent(maxLastLoginFilter ? "" + maxLastLoginFilter.toJSON() : "") + "&";
        if (minLastLoginFilter !== undefined)
            url_ += "MinLastLoginFilter=" + encodeURIComponent(minLastLoginFilter ? "" + minLastLoginFilter.toJSON() : "") + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetConsumerLoginForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetConsumerLoginForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetConsumerLoginForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetConsumerLoginForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetConsumerLoginForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetConsumerLoginForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getConsumerLoginForEdit(id: number | null | undefined): Observable<GetConsumerLoginForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/ConsumerLogins/GetConsumerLoginForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetConsumerLoginForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConsumerLoginForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetConsumerLoginForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetConsumerLoginForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetConsumerLoginForEdit(response: HttpResponseBase): Observable<GetConsumerLoginForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetConsumerLoginForEditOutput.fromJS(resultData200) : new GetConsumerLoginForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetConsumerLoginForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditConsumerLoginDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ConsumerLogins/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ConsumerLogins/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param memberCodeFilter (optional) 
     * @param nameFilter (optional) 
     * @param phoneFilter (optional) 
     * @param emailFilter (optional) 
     * @param facebookIDFilter (optional) 
     * @param googleIDFilter (optional) 
     * @param isLogOutFilter (optional) 
     * @param deviceIDFilter (optional) 
     * @param maxLastLoginFilter (optional) 
     * @param minLastLoginFilter (optional) 
     * @return Success
     */
    getConsumerLoginsToExcel(filter: string | null | undefined, memberCodeFilter: string | null | undefined, nameFilter: string | null | undefined, phoneFilter: string | null | undefined, emailFilter: string | null | undefined, facebookIDFilter: string | null | undefined, googleIDFilter: string | null | undefined, isLogOutFilter: number | null | undefined, deviceIDFilter: string | null | undefined, maxLastLoginFilter: moment.Moment | null | undefined, minLastLoginFilter: moment.Moment | null | undefined): Observable<ConsumerDBFileDto> {
        let url_ = this.baseUrl + "/api/services/app/ConsumerLogins/GetConsumerLoginsToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (memberCodeFilter !== undefined)
            url_ += "MemberCodeFilter=" + encodeURIComponent("" + memberCodeFilter) + "&";
        if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (phoneFilter !== undefined)
            url_ += "PhoneFilter=" + encodeURIComponent("" + phoneFilter) + "&";
        if (emailFilter !== undefined)
            url_ += "EmailFilter=" + encodeURIComponent("" + emailFilter) + "&";
        if (facebookIDFilter !== undefined)
            url_ += "FacebookIDFilter=" + encodeURIComponent("" + facebookIDFilter) + "&";
        if (googleIDFilter !== undefined)
            url_ += "GoogleIDFilter=" + encodeURIComponent("" + googleIDFilter) + "&";
        if (isLogOutFilter !== undefined)
            url_ += "IsLogOutFilter=" + encodeURIComponent("" + isLogOutFilter) + "&";
        if (deviceIDFilter !== undefined)
            url_ += "DeviceIDFilter=" + encodeURIComponent("" + deviceIDFilter) + "&";
        if (maxLastLoginFilter !== undefined)
            url_ += "MaxLastLoginFilter=" + encodeURIComponent(maxLastLoginFilter ? "" + maxLastLoginFilter.toJSON() : "") + "&";
        if (minLastLoginFilter !== undefined)
            url_ += "MinLastLoginFilter=" + encodeURIComponent(minLastLoginFilter ? "" + minLastLoginFilter.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetConsumerLoginsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConsumerLoginsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<ConsumerDBFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ConsumerDBFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetConsumerLoginsToExcel(response: HttpResponseBase): Observable<ConsumerDBFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? ConsumerDBFileDto.fromJS(resultData200) : new ConsumerDBFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ConsumerDBFileDto>(<any>null);
    }
}

@Injectable()
export class ConsumerProfilesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param memberCodeFilter (optional) 
     * @param nameFilter (optional) 
     * @param phoneFilter (optional) 
     * @param emailFilter (optional) 
     * @param genderFilter (optional) 
     * @param maxBirthdayFilter (optional) 
     * @param minBirthdayFilter (optional) 
     * @param maxRegistrationDateFilter (optional) 
     * @param minRegistrationDateFilter (optional) 
     * @param pIDFilter (optional) 
     * @param sourceIDFilter (optional) 
     * @param receiveAdsFilter (optional) 
     * @param rankCodeFilter (optional) 
     * @param maxRankValidDateFilter (optional) 
     * @param minRankValidDateFilter (optional) 
     * @param maxCurrentPointFilter (optional) 
     * @param minCurrentPointFilter (optional) 
     * @param nationalityCodeFilter (optional) 
     * @param occupationCodeFilter (optional) 
     * @param hobbyFilter (optional) 
     * @param addressFilter (optional) 
     * @param wardFilter (optional) 
     * @param districtFilter (optional) 
     * @param provinceFilter (optional) 
     * @param countryFilter (optional) 
     * @param statusFilter (optional) 
     * @param maxLastActivityTimeFilter (optional) 
     * @param minLastActivityTimeFilter (optional) 
     * @param maxLastPurchaseTimeFilter (optional) 
     * @param minLastPurchaseTimeFilter (optional) 
     * @param communicationChannelsFilter (optional) 
     * @param communicationLanguageFilter (optional) 
     * @param notesFilter (optional) 
     * @param rankProposeFilter (optional) 
     * @param pINCodeFilter (optional) 
     * @param nameUnSignFilter (optional) 
     * @param avatarFilter (optional) 
     * @param workingPermitFilter (optional) 
     * @param customerCodeFilter (optional) 
     * @param interestOfFilter (optional) 
     * @param isInterestCobrandFilter (optional) 
     * @param memberCardFilter (optional) 
     * @param isForeignerFilter (optional) 
     * @param isSyncedFilter (optional) 
     * @param referralCodeFilter (optional) 
     * @param maxAccumulationPointFilter (optional) 
     * @param minAccumulationPointFilter (optional) 
     * @param outletCodeFilter (optional) 
     * @param zaloNameFilter (optional) 
     * @param distributorCodeFilter (optional) 
     * @param distributorNameFilter (optional) 
     * @param regionCodeFilter (optional) 
     * @param maxTargetRevenueFilter (optional) 
     * @param minTargetRevenueFilter (optional) 
     * @param maxActualRevenueFilter (optional) 
     * @param minActualRevenueFilter (optional) 
     * @param maxBonusFilter (optional) 
     * @param minBonusFilter (optional) 
     * @param maxMissingRevenueFilter (optional) 
     * @param minMissingRevenueFilter (optional) 
     * @param maxRevenueUpdateDateFilter (optional) 
     * @param minRevenueUpdateDateFilter (optional) 
     * @param note1Filter (optional) 
     * @param note2Filter (optional) 
     * @param note3Filter (optional) 
     * @param note4Filter (optional) 
     * @param note5Filter (optional) 
     * @param metaDataFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, memberCodeFilter: string | null | undefined, nameFilter: string | null | undefined, phoneFilter: string | null | undefined, emailFilter: string | null | undefined, genderFilter: string | null | undefined, maxBirthdayFilter: number | null | undefined, minBirthdayFilter: number | null | undefined, maxRegistrationDateFilter: number | null | undefined, minRegistrationDateFilter: number | null | undefined, pIDFilter: string | null | undefined, sourceIDFilter: string | null | undefined, receiveAdsFilter: number | null | undefined, rankCodeFilter: string | null | undefined, maxRankValidDateFilter: number | null | undefined, minRankValidDateFilter: number | null | undefined, maxCurrentPointFilter: number | null | undefined, minCurrentPointFilter: number | null | undefined, nationalityCodeFilter: string | null | undefined, occupationCodeFilter: string | null | undefined, hobbyFilter: string | null | undefined, addressFilter: string | null | undefined, wardFilter: string | null | undefined, districtFilter: string | null | undefined, provinceFilter: string | null | undefined, countryFilter: string | null | undefined, statusFilter: string | null | undefined, maxLastActivityTimeFilter: moment.Moment | null | undefined, minLastActivityTimeFilter: moment.Moment | null | undefined, maxLastPurchaseTimeFilter: moment.Moment | null | undefined, minLastPurchaseTimeFilter: moment.Moment | null | undefined, communicationChannelsFilter: string | null | undefined, communicationLanguageFilter: string | null | undefined, notesFilter: string | null | undefined, rankProposeFilter: string | null | undefined, pINCodeFilter: string | null | undefined, nameUnSignFilter: string | null | undefined, avatarFilter: string | null | undefined, workingPermitFilter: number | null | undefined, customerCodeFilter: string | null | undefined, interestOfFilter: string | null | undefined, isInterestCobrandFilter: number | null | undefined, memberCardFilter: string | null | undefined, isForeignerFilter: number | null | undefined, isSyncedFilter: number | null | undefined, referralCodeFilter: string | null | undefined, maxAccumulationPointFilter: number | null | undefined, minAccumulationPointFilter: number | null | undefined, outletCodeFilter: string | null | undefined, zaloNameFilter: string | null | undefined, distributorCodeFilter: string | null | undefined, distributorNameFilter: string | null | undefined, regionCodeFilter: string | null | undefined, maxTargetRevenueFilter: number | null | undefined, minTargetRevenueFilter: number | null | undefined, maxActualRevenueFilter: number | null | undefined, minActualRevenueFilter: number | null | undefined, maxBonusFilter: number | null | undefined, minBonusFilter: number | null | undefined, maxMissingRevenueFilter: number | null | undefined, minMissingRevenueFilter: number | null | undefined, maxRevenueUpdateDateFilter: number | null | undefined, minRevenueUpdateDateFilter: number | null | undefined, note1Filter: string | null | undefined, note2Filter: string | null | undefined, note3Filter: string | null | undefined, note4Filter: string | null | undefined, note5Filter: string | null | undefined, metaDataFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetConsumerProfileForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/ConsumerProfiles/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (memberCodeFilter !== undefined)
            url_ += "MemberCodeFilter=" + encodeURIComponent("" + memberCodeFilter) + "&";
        if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (phoneFilter !== undefined)
            url_ += "PhoneFilter=" + encodeURIComponent("" + phoneFilter) + "&";
        if (emailFilter !== undefined)
            url_ += "EmailFilter=" + encodeURIComponent("" + emailFilter) + "&";
        if (genderFilter !== undefined)
            url_ += "GenderFilter=" + encodeURIComponent("" + genderFilter) + "&";
        if (maxBirthdayFilter !== undefined)
            url_ += "MaxBirthdayFilter=" + encodeURIComponent("" + maxBirthdayFilter) + "&";
        if (minBirthdayFilter !== undefined)
            url_ += "MinBirthdayFilter=" + encodeURIComponent("" + minBirthdayFilter) + "&";
        if (maxRegistrationDateFilter !== undefined)
            url_ += "MaxRegistrationDateFilter=" + encodeURIComponent("" + maxRegistrationDateFilter) + "&";
        if (minRegistrationDateFilter !== undefined)
            url_ += "MinRegistrationDateFilter=" + encodeURIComponent("" + minRegistrationDateFilter) + "&";
        if (pIDFilter !== undefined)
            url_ += "PIDFilter=" + encodeURIComponent("" + pIDFilter) + "&";
        if (sourceIDFilter !== undefined)
            url_ += "SourceIDFilter=" + encodeURIComponent("" + sourceIDFilter) + "&";
        if (receiveAdsFilter !== undefined)
            url_ += "ReceiveAdsFilter=" + encodeURIComponent("" + receiveAdsFilter) + "&";
        if (rankCodeFilter !== undefined)
            url_ += "RankCodeFilter=" + encodeURIComponent("" + rankCodeFilter) + "&";
        if (maxRankValidDateFilter !== undefined)
            url_ += "MaxRankValidDateFilter=" + encodeURIComponent("" + maxRankValidDateFilter) + "&";
        if (minRankValidDateFilter !== undefined)
            url_ += "MinRankValidDateFilter=" + encodeURIComponent("" + minRankValidDateFilter) + "&";
        if (maxCurrentPointFilter !== undefined)
            url_ += "MaxCurrentPointFilter=" + encodeURIComponent("" + maxCurrentPointFilter) + "&";
        if (minCurrentPointFilter !== undefined)
            url_ += "MinCurrentPointFilter=" + encodeURIComponent("" + minCurrentPointFilter) + "&";
        if (nationalityCodeFilter !== undefined)
            url_ += "NationalityCodeFilter=" + encodeURIComponent("" + nationalityCodeFilter) + "&";
        if (occupationCodeFilter !== undefined)
            url_ += "OccupationCodeFilter=" + encodeURIComponent("" + occupationCodeFilter) + "&";
        if (hobbyFilter !== undefined)
            url_ += "HobbyFilter=" + encodeURIComponent("" + hobbyFilter) + "&";
        if (addressFilter !== undefined)
            url_ += "AddressFilter=" + encodeURIComponent("" + addressFilter) + "&";
        if (wardFilter !== undefined)
            url_ += "WardFilter=" + encodeURIComponent("" + wardFilter) + "&";
        if (districtFilter !== undefined)
            url_ += "DistrictFilter=" + encodeURIComponent("" + districtFilter) + "&";
        if (provinceFilter !== undefined)
            url_ += "ProvinceFilter=" + encodeURIComponent("" + provinceFilter) + "&";
        if (countryFilter !== undefined)
            url_ += "CountryFilter=" + encodeURIComponent("" + countryFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (maxLastActivityTimeFilter !== undefined)
            url_ += "MaxLastActivityTimeFilter=" + encodeURIComponent(maxLastActivityTimeFilter ? "" + maxLastActivityTimeFilter.toJSON() : "") + "&";
        if (minLastActivityTimeFilter !== undefined)
            url_ += "MinLastActivityTimeFilter=" + encodeURIComponent(minLastActivityTimeFilter ? "" + minLastActivityTimeFilter.toJSON() : "") + "&";
        if (maxLastPurchaseTimeFilter !== undefined)
            url_ += "MaxLastPurchaseTimeFilter=" + encodeURIComponent(maxLastPurchaseTimeFilter ? "" + maxLastPurchaseTimeFilter.toJSON() : "") + "&";
        if (minLastPurchaseTimeFilter !== undefined)
            url_ += "MinLastPurchaseTimeFilter=" + encodeURIComponent(minLastPurchaseTimeFilter ? "" + minLastPurchaseTimeFilter.toJSON() : "") + "&";
        if (communicationChannelsFilter !== undefined)
            url_ += "CommunicationChannelsFilter=" + encodeURIComponent("" + communicationChannelsFilter) + "&";
        if (communicationLanguageFilter !== undefined)
            url_ += "CommunicationLanguageFilter=" + encodeURIComponent("" + communicationLanguageFilter) + "&";
        if (notesFilter !== undefined)
            url_ += "NotesFilter=" + encodeURIComponent("" + notesFilter) + "&";
        if (rankProposeFilter !== undefined)
            url_ += "RankProposeFilter=" + encodeURIComponent("" + rankProposeFilter) + "&";
        if (pINCodeFilter !== undefined)
            url_ += "PINCodeFilter=" + encodeURIComponent("" + pINCodeFilter) + "&";
        if (nameUnSignFilter !== undefined)
            url_ += "NameUnSignFilter=" + encodeURIComponent("" + nameUnSignFilter) + "&";
        if (avatarFilter !== undefined)
            url_ += "AvatarFilter=" + encodeURIComponent("" + avatarFilter) + "&";
        if (workingPermitFilter !== undefined)
            url_ += "WorkingPermitFilter=" + encodeURIComponent("" + workingPermitFilter) + "&";
        if (customerCodeFilter !== undefined)
            url_ += "CustomerCodeFilter=" + encodeURIComponent("" + customerCodeFilter) + "&";
        if (interestOfFilter !== undefined)
            url_ += "InterestOfFilter=" + encodeURIComponent("" + interestOfFilter) + "&";
        if (isInterestCobrandFilter !== undefined)
            url_ += "isInterestCobrandFilter=" + encodeURIComponent("" + isInterestCobrandFilter) + "&";
        if (memberCardFilter !== undefined)
            url_ += "MemberCardFilter=" + encodeURIComponent("" + memberCardFilter) + "&";
        if (isForeignerFilter !== undefined)
            url_ += "IsForeignerFilter=" + encodeURIComponent("" + isForeignerFilter) + "&";
        if (isSyncedFilter !== undefined)
            url_ += "IsSyncedFilter=" + encodeURIComponent("" + isSyncedFilter) + "&";
        if (referralCodeFilter !== undefined)
            url_ += "ReferralCodeFilter=" + encodeURIComponent("" + referralCodeFilter) + "&";
        if (maxAccumulationPointFilter !== undefined)
            url_ += "MaxAccumulationPointFilter=" + encodeURIComponent("" + maxAccumulationPointFilter) + "&";
        if (minAccumulationPointFilter !== undefined)
            url_ += "MinAccumulationPointFilter=" + encodeURIComponent("" + minAccumulationPointFilter) + "&";
        if (outletCodeFilter !== undefined)
            url_ += "OutletCodeFilter=" + encodeURIComponent("" + outletCodeFilter) + "&";
        if (zaloNameFilter !== undefined)
            url_ += "ZaloNameFilter=" + encodeURIComponent("" + zaloNameFilter) + "&";
        if (distributorCodeFilter !== undefined)
            url_ += "DistributorCodeFilter=" + encodeURIComponent("" + distributorCodeFilter) + "&";
        if (distributorNameFilter !== undefined)
            url_ += "DistributorNameFilter=" + encodeURIComponent("" + distributorNameFilter) + "&";
        if (regionCodeFilter !== undefined)
            url_ += "RegionCodeFilter=" + encodeURIComponent("" + regionCodeFilter) + "&";
        if (maxTargetRevenueFilter !== undefined)
            url_ += "MaxTargetRevenueFilter=" + encodeURIComponent("" + maxTargetRevenueFilter) + "&";
        if (minTargetRevenueFilter !== undefined)
            url_ += "MinTargetRevenueFilter=" + encodeURIComponent("" + minTargetRevenueFilter) + "&";
        if (maxActualRevenueFilter !== undefined)
            url_ += "MaxActualRevenueFilter=" + encodeURIComponent("" + maxActualRevenueFilter) + "&";
        if (minActualRevenueFilter !== undefined)
            url_ += "MinActualRevenueFilter=" + encodeURIComponent("" + minActualRevenueFilter) + "&";
        if (maxBonusFilter !== undefined)
            url_ += "MaxBonusFilter=" + encodeURIComponent("" + maxBonusFilter) + "&";
        if (minBonusFilter !== undefined)
            url_ += "MinBonusFilter=" + encodeURIComponent("" + minBonusFilter) + "&";
        if (maxMissingRevenueFilter !== undefined)
            url_ += "MaxMissingRevenueFilter=" + encodeURIComponent("" + maxMissingRevenueFilter) + "&";
        if (minMissingRevenueFilter !== undefined)
            url_ += "MinMissingRevenueFilter=" + encodeURIComponent("" + minMissingRevenueFilter) + "&";
        if (maxRevenueUpdateDateFilter !== undefined)
            url_ += "MaxRevenueUpdateDateFilter=" + encodeURIComponent("" + maxRevenueUpdateDateFilter) + "&";
        if (minRevenueUpdateDateFilter !== undefined)
            url_ += "MinRevenueUpdateDateFilter=" + encodeURIComponent("" + minRevenueUpdateDateFilter) + "&";
        if (note1Filter !== undefined)
            url_ += "Note1Filter=" + encodeURIComponent("" + note1Filter) + "&";
        if (note2Filter !== undefined)
            url_ += "Note2Filter=" + encodeURIComponent("" + note2Filter) + "&";
        if (note3Filter !== undefined)
            url_ += "Note3Filter=" + encodeURIComponent("" + note3Filter) + "&";
        if (note4Filter !== undefined)
            url_ += "Note4Filter=" + encodeURIComponent("" + note4Filter) + "&";
        if (note5Filter !== undefined)
            url_ += "Note5Filter=" + encodeURIComponent("" + note5Filter) + "&";
        if (metaDataFilter !== undefined)
            url_ += "MetaDataFilter=" + encodeURIComponent("" + metaDataFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetConsumerProfileForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetConsumerProfileForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetConsumerProfileForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetConsumerProfileForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetConsumerProfileForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetConsumerProfileForViewDto>(<any>null);
    }

    /**
     * @param memberCode (optional) 
     * @return Success
     */
    getByMemberCode(memberCode: string | null | undefined): Observable<GetConsumerProfileForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/ConsumerProfiles/GetByMemberCode?";
        if (memberCode !== undefined)
            url_ += "memberCode=" + encodeURIComponent("" + memberCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetByMemberCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByMemberCode(<any>response_);
                } catch (e) {
                    return <Observable<GetConsumerProfileForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetConsumerProfileForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetByMemberCode(response: HttpResponseBase): Observable<GetConsumerProfileForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetConsumerProfileForViewDto.fromJS(resultData200) : new GetConsumerProfileForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetConsumerProfileForViewDto>(<any>null);
    }

    /**
     * @param phoneNumber (optional) 
     * @return Success
     */
    getByPhoneNumber(phoneNumber: string | null | undefined): Observable<GetConsumerProfileDtoForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/ConsumerProfiles/GetByPhoneNumber?";
        if (phoneNumber !== undefined)
            url_ += "phoneNumber=" + encodeURIComponent("" + phoneNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetByPhoneNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByPhoneNumber(<any>response_);
                } catch (e) {
                    return <Observable<GetConsumerProfileDtoForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetConsumerProfileDtoForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetByPhoneNumber(response: HttpResponseBase): Observable<GetConsumerProfileDtoForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetConsumerProfileDtoForViewDto.fromJS(resultData200) : new GetConsumerProfileDtoForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetConsumerProfileDtoForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getConsumerProfileForEdit(id: number | null | undefined): Observable<GetConsumerProfileForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/ConsumerProfiles/GetConsumerProfileForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetConsumerProfileForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConsumerProfileForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetConsumerProfileForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetConsumerProfileForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetConsumerProfileForEdit(response: HttpResponseBase): Observable<GetConsumerProfileForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetConsumerProfileForEditOutput.fromJS(resultData200) : new GetConsumerProfileForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetConsumerProfileForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditConsumerProfileDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ConsumerProfiles/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ConsumerProfiles/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param memberCodeFilter (optional) 
     * @param nameFilter (optional) 
     * @param phoneFilter (optional) 
     * @param emailFilter (optional) 
     * @param genderFilter (optional) 
     * @param maxBirthdayFilter (optional) 
     * @param minBirthdayFilter (optional) 
     * @param maxRegistrationDateFilter (optional) 
     * @param minRegistrationDateFilter (optional) 
     * @param pIDFilter (optional) 
     * @param sourceIDFilter (optional) 
     * @param receiveAdsFilter (optional) 
     * @param rankCodeFilter (optional) 
     * @param maxRankValidDateFilter (optional) 
     * @param minRankValidDateFilter (optional) 
     * @param maxCurrentPointFilter (optional) 
     * @param minCurrentPointFilter (optional) 
     * @param nationalityCodeFilter (optional) 
     * @param occupationCodeFilter (optional) 
     * @param hobbyFilter (optional) 
     * @param addressFilter (optional) 
     * @param wardFilter (optional) 
     * @param districtFilter (optional) 
     * @param provinceFilter (optional) 
     * @param countryFilter (optional) 
     * @param statusFilter (optional) 
     * @param maxLastActivityTimeFilter (optional) 
     * @param minLastActivityTimeFilter (optional) 
     * @param maxLastPurchaseTimeFilter (optional) 
     * @param minLastPurchaseTimeFilter (optional) 
     * @param communicationChannelsFilter (optional) 
     * @param communicationLanguageFilter (optional) 
     * @param notesFilter (optional) 
     * @param rankProposeFilter (optional) 
     * @param pINCodeFilter (optional) 
     * @param nameUnSignFilter (optional) 
     * @param avatarFilter (optional) 
     * @param workingPermitFilter (optional) 
     * @param customerCodeFilter (optional) 
     * @param interestOfFilter (optional) 
     * @param isInterestCobrandFilter (optional) 
     * @param memberCardFilter (optional) 
     * @param isForeignerFilter (optional) 
     * @param isSyncedFilter (optional) 
     * @param referralCodeFilter (optional) 
     * @param maxAccumulationPointFilter (optional) 
     * @param minAccumulationPointFilter (optional) 
     * @param outletCodeFilter (optional) 
     * @param zaloNameFilter (optional) 
     * @param distributorCodeFilter (optional) 
     * @param distributorNameFilter (optional) 
     * @param regionCodeFilter (optional) 
     * @param maxTargetRevenueFilter (optional) 
     * @param minTargetRevenueFilter (optional) 
     * @param maxActualRevenueFilter (optional) 
     * @param minActualRevenueFilter (optional) 
     * @param maxBonusFilter (optional) 
     * @param minBonusFilter (optional) 
     * @param maxMissingRevenueFilter (optional) 
     * @param minMissingRevenueFilter (optional) 
     * @param maxRevenueUpdateDateFilter (optional) 
     * @param minRevenueUpdateDateFilter (optional) 
     * @param note1Filter (optional) 
     * @param note2Filter (optional) 
     * @param note3Filter (optional) 
     * @param note4Filter (optional) 
     * @param note5Filter (optional) 
     * @param metaDataFilter (optional) 
     * @return Success
     */
    getConsumerProfilesToExcel(filter: string | null | undefined, memberCodeFilter: string | null | undefined, nameFilter: string | null | undefined, phoneFilter: string | null | undefined, emailFilter: string | null | undefined, genderFilter: string | null | undefined, maxBirthdayFilter: number | null | undefined, minBirthdayFilter: number | null | undefined, maxRegistrationDateFilter: number | null | undefined, minRegistrationDateFilter: number | null | undefined, pIDFilter: string | null | undefined, sourceIDFilter: string | null | undefined, receiveAdsFilter: number | null | undefined, rankCodeFilter: string | null | undefined, maxRankValidDateFilter: number | null | undefined, minRankValidDateFilter: number | null | undefined, maxCurrentPointFilter: number | null | undefined, minCurrentPointFilter: number | null | undefined, nationalityCodeFilter: string | null | undefined, occupationCodeFilter: string | null | undefined, hobbyFilter: string | null | undefined, addressFilter: string | null | undefined, wardFilter: string | null | undefined, districtFilter: string | null | undefined, provinceFilter: string | null | undefined, countryFilter: string | null | undefined, statusFilter: string | null | undefined, maxLastActivityTimeFilter: moment.Moment | null | undefined, minLastActivityTimeFilter: moment.Moment | null | undefined, maxLastPurchaseTimeFilter: moment.Moment | null | undefined, minLastPurchaseTimeFilter: moment.Moment | null | undefined, communicationChannelsFilter: string | null | undefined, communicationLanguageFilter: string | null | undefined, notesFilter: string | null | undefined, rankProposeFilter: string | null | undefined, pINCodeFilter: string | null | undefined, nameUnSignFilter: string | null | undefined, avatarFilter: string | null | undefined, workingPermitFilter: number | null | undefined, customerCodeFilter: string | null | undefined, interestOfFilter: string | null | undefined, isInterestCobrandFilter: number | null | undefined, memberCardFilter: string | null | undefined, isForeignerFilter: number | null | undefined, isSyncedFilter: number | null | undefined, referralCodeFilter: string | null | undefined, maxAccumulationPointFilter: number | null | undefined, minAccumulationPointFilter: number | null | undefined, outletCodeFilter: string | null | undefined, zaloNameFilter: string | null | undefined, distributorCodeFilter: string | null | undefined, distributorNameFilter: string | null | undefined, regionCodeFilter: string | null | undefined, maxTargetRevenueFilter: number | null | undefined, minTargetRevenueFilter: number | null | undefined, maxActualRevenueFilter: number | null | undefined, minActualRevenueFilter: number | null | undefined, maxBonusFilter: number | null | undefined, minBonusFilter: number | null | undefined, maxMissingRevenueFilter: number | null | undefined, minMissingRevenueFilter: number | null | undefined, maxRevenueUpdateDateFilter: number | null | undefined, minRevenueUpdateDateFilter: number | null | undefined, note1Filter: string | null | undefined, note2Filter: string | null | undefined, note3Filter: string | null | undefined, note4Filter: string | null | undefined, note5Filter: string | null | undefined, metaDataFilter: string | null | undefined): Observable<ConsumerDBFileDto> {
        let url_ = this.baseUrl + "/api/services/app/ConsumerProfiles/GetConsumerProfilesToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (memberCodeFilter !== undefined)
            url_ += "MemberCodeFilter=" + encodeURIComponent("" + memberCodeFilter) + "&";
        if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (phoneFilter !== undefined)
            url_ += "PhoneFilter=" + encodeURIComponent("" + phoneFilter) + "&";
        if (emailFilter !== undefined)
            url_ += "EmailFilter=" + encodeURIComponent("" + emailFilter) + "&";
        if (genderFilter !== undefined)
            url_ += "GenderFilter=" + encodeURIComponent("" + genderFilter) + "&";
        if (maxBirthdayFilter !== undefined)
            url_ += "MaxBirthdayFilter=" + encodeURIComponent("" + maxBirthdayFilter) + "&";
        if (minBirthdayFilter !== undefined)
            url_ += "MinBirthdayFilter=" + encodeURIComponent("" + minBirthdayFilter) + "&";
        if (maxRegistrationDateFilter !== undefined)
            url_ += "MaxRegistrationDateFilter=" + encodeURIComponent("" + maxRegistrationDateFilter) + "&";
        if (minRegistrationDateFilter !== undefined)
            url_ += "MinRegistrationDateFilter=" + encodeURIComponent("" + minRegistrationDateFilter) + "&";
        if (pIDFilter !== undefined)
            url_ += "PIDFilter=" + encodeURIComponent("" + pIDFilter) + "&";
        if (sourceIDFilter !== undefined)
            url_ += "SourceIDFilter=" + encodeURIComponent("" + sourceIDFilter) + "&";
        if (receiveAdsFilter !== undefined)
            url_ += "ReceiveAdsFilter=" + encodeURIComponent("" + receiveAdsFilter) + "&";
        if (rankCodeFilter !== undefined)
            url_ += "RankCodeFilter=" + encodeURIComponent("" + rankCodeFilter) + "&";
        if (maxRankValidDateFilter !== undefined)
            url_ += "MaxRankValidDateFilter=" + encodeURIComponent("" + maxRankValidDateFilter) + "&";
        if (minRankValidDateFilter !== undefined)
            url_ += "MinRankValidDateFilter=" + encodeURIComponent("" + minRankValidDateFilter) + "&";
        if (maxCurrentPointFilter !== undefined)
            url_ += "MaxCurrentPointFilter=" + encodeURIComponent("" + maxCurrentPointFilter) + "&";
        if (minCurrentPointFilter !== undefined)
            url_ += "MinCurrentPointFilter=" + encodeURIComponent("" + minCurrentPointFilter) + "&";
        if (nationalityCodeFilter !== undefined)
            url_ += "NationalityCodeFilter=" + encodeURIComponent("" + nationalityCodeFilter) + "&";
        if (occupationCodeFilter !== undefined)
            url_ += "OccupationCodeFilter=" + encodeURIComponent("" + occupationCodeFilter) + "&";
        if (hobbyFilter !== undefined)
            url_ += "HobbyFilter=" + encodeURIComponent("" + hobbyFilter) + "&";
        if (addressFilter !== undefined)
            url_ += "AddressFilter=" + encodeURIComponent("" + addressFilter) + "&";
        if (wardFilter !== undefined)
            url_ += "WardFilter=" + encodeURIComponent("" + wardFilter) + "&";
        if (districtFilter !== undefined)
            url_ += "DistrictFilter=" + encodeURIComponent("" + districtFilter) + "&";
        if (provinceFilter !== undefined)
            url_ += "ProvinceFilter=" + encodeURIComponent("" + provinceFilter) + "&";
        if (countryFilter !== undefined)
            url_ += "CountryFilter=" + encodeURIComponent("" + countryFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (maxLastActivityTimeFilter !== undefined)
            url_ += "MaxLastActivityTimeFilter=" + encodeURIComponent(maxLastActivityTimeFilter ? "" + maxLastActivityTimeFilter.toJSON() : "") + "&";
        if (minLastActivityTimeFilter !== undefined)
            url_ += "MinLastActivityTimeFilter=" + encodeURIComponent(minLastActivityTimeFilter ? "" + minLastActivityTimeFilter.toJSON() : "") + "&";
        if (maxLastPurchaseTimeFilter !== undefined)
            url_ += "MaxLastPurchaseTimeFilter=" + encodeURIComponent(maxLastPurchaseTimeFilter ? "" + maxLastPurchaseTimeFilter.toJSON() : "") + "&";
        if (minLastPurchaseTimeFilter !== undefined)
            url_ += "MinLastPurchaseTimeFilter=" + encodeURIComponent(minLastPurchaseTimeFilter ? "" + minLastPurchaseTimeFilter.toJSON() : "") + "&";
        if (communicationChannelsFilter !== undefined)
            url_ += "CommunicationChannelsFilter=" + encodeURIComponent("" + communicationChannelsFilter) + "&";
        if (communicationLanguageFilter !== undefined)
            url_ += "CommunicationLanguageFilter=" + encodeURIComponent("" + communicationLanguageFilter) + "&";
        if (notesFilter !== undefined)
            url_ += "NotesFilter=" + encodeURIComponent("" + notesFilter) + "&";
        if (rankProposeFilter !== undefined)
            url_ += "RankProposeFilter=" + encodeURIComponent("" + rankProposeFilter) + "&";
        if (pINCodeFilter !== undefined)
            url_ += "PINCodeFilter=" + encodeURIComponent("" + pINCodeFilter) + "&";
        if (nameUnSignFilter !== undefined)
            url_ += "NameUnSignFilter=" + encodeURIComponent("" + nameUnSignFilter) + "&";
        if (avatarFilter !== undefined)
            url_ += "AvatarFilter=" + encodeURIComponent("" + avatarFilter) + "&";
        if (workingPermitFilter !== undefined)
            url_ += "WorkingPermitFilter=" + encodeURIComponent("" + workingPermitFilter) + "&";
        if (customerCodeFilter !== undefined)
            url_ += "CustomerCodeFilter=" + encodeURIComponent("" + customerCodeFilter) + "&";
        if (interestOfFilter !== undefined)
            url_ += "InterestOfFilter=" + encodeURIComponent("" + interestOfFilter) + "&";
        if (isInterestCobrandFilter !== undefined)
            url_ += "isInterestCobrandFilter=" + encodeURIComponent("" + isInterestCobrandFilter) + "&";
        if (memberCardFilter !== undefined)
            url_ += "MemberCardFilter=" + encodeURIComponent("" + memberCardFilter) + "&";
        if (isForeignerFilter !== undefined)
            url_ += "IsForeignerFilter=" + encodeURIComponent("" + isForeignerFilter) + "&";
        if (isSyncedFilter !== undefined)
            url_ += "IsSyncedFilter=" + encodeURIComponent("" + isSyncedFilter) + "&";
        if (referralCodeFilter !== undefined)
            url_ += "ReferralCodeFilter=" + encodeURIComponent("" + referralCodeFilter) + "&";
        if (maxAccumulationPointFilter !== undefined)
            url_ += "MaxAccumulationPointFilter=" + encodeURIComponent("" + maxAccumulationPointFilter) + "&";
        if (minAccumulationPointFilter !== undefined)
            url_ += "MinAccumulationPointFilter=" + encodeURIComponent("" + minAccumulationPointFilter) + "&";
        if (outletCodeFilter !== undefined)
            url_ += "OutletCodeFilter=" + encodeURIComponent("" + outletCodeFilter) + "&";
        if (zaloNameFilter !== undefined)
            url_ += "ZaloNameFilter=" + encodeURIComponent("" + zaloNameFilter) + "&";
        if (distributorCodeFilter !== undefined)
            url_ += "DistributorCodeFilter=" + encodeURIComponent("" + distributorCodeFilter) + "&";
        if (distributorNameFilter !== undefined)
            url_ += "DistributorNameFilter=" + encodeURIComponent("" + distributorNameFilter) + "&";
        if (regionCodeFilter !== undefined)
            url_ += "RegionCodeFilter=" + encodeURIComponent("" + regionCodeFilter) + "&";
        if (maxTargetRevenueFilter !== undefined)
            url_ += "MaxTargetRevenueFilter=" + encodeURIComponent("" + maxTargetRevenueFilter) + "&";
        if (minTargetRevenueFilter !== undefined)
            url_ += "MinTargetRevenueFilter=" + encodeURIComponent("" + minTargetRevenueFilter) + "&";
        if (maxActualRevenueFilter !== undefined)
            url_ += "MaxActualRevenueFilter=" + encodeURIComponent("" + maxActualRevenueFilter) + "&";
        if (minActualRevenueFilter !== undefined)
            url_ += "MinActualRevenueFilter=" + encodeURIComponent("" + minActualRevenueFilter) + "&";
        if (maxBonusFilter !== undefined)
            url_ += "MaxBonusFilter=" + encodeURIComponent("" + maxBonusFilter) + "&";
        if (minBonusFilter !== undefined)
            url_ += "MinBonusFilter=" + encodeURIComponent("" + minBonusFilter) + "&";
        if (maxMissingRevenueFilter !== undefined)
            url_ += "MaxMissingRevenueFilter=" + encodeURIComponent("" + maxMissingRevenueFilter) + "&";
        if (minMissingRevenueFilter !== undefined)
            url_ += "MinMissingRevenueFilter=" + encodeURIComponent("" + minMissingRevenueFilter) + "&";
        if (maxRevenueUpdateDateFilter !== undefined)
            url_ += "MaxRevenueUpdateDateFilter=" + encodeURIComponent("" + maxRevenueUpdateDateFilter) + "&";
        if (minRevenueUpdateDateFilter !== undefined)
            url_ += "MinRevenueUpdateDateFilter=" + encodeURIComponent("" + minRevenueUpdateDateFilter) + "&";
        if (note1Filter !== undefined)
            url_ += "Note1Filter=" + encodeURIComponent("" + note1Filter) + "&";
        if (note2Filter !== undefined)
            url_ += "Note2Filter=" + encodeURIComponent("" + note2Filter) + "&";
        if (note3Filter !== undefined)
            url_ += "Note3Filter=" + encodeURIComponent("" + note3Filter) + "&";
        if (note4Filter !== undefined)
            url_ += "Note4Filter=" + encodeURIComponent("" + note4Filter) + "&";
        if (note5Filter !== undefined)
            url_ += "Note5Filter=" + encodeURIComponent("" + note5Filter) + "&";
        if (metaDataFilter !== undefined)
            url_ += "MetaDataFilter=" + encodeURIComponent("" + metaDataFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetConsumerProfilesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConsumerProfilesToExcel(<any>response_);
                } catch (e) {
                    return <Observable<ConsumerDBFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ConsumerDBFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetConsumerProfilesToExcel(response: HttpResponseBase): Observable<ConsumerDBFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? ConsumerDBFileDto.fromJS(resultData200) : new ConsumerDBFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ConsumerDBFileDto>(<any>null);
    }

    /**
     * @param memberCode (optional) 
     * @return Success
     */
    runSegmentSingleMember(memberCode: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ConsumerProfiles/RunSegmentSingleMember?";
        if (memberCode !== undefined)
            url_ += "memberCode=" + encodeURIComponent("" + memberCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processRunSegmentSingleMember(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRunSegmentSingleMember(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processRunSegmentSingleMember(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param statusFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllOutLet(filter: string | null | undefined, statusFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetConsumerProfileForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/ConsumerProfiles/GetAllOutLet?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllOutLet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllOutLet(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetConsumerProfileForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetConsumerProfileForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllOutLet(response: HttpResponseBase): Observable<PagedResultDtoOfGetConsumerProfileForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetConsumerProfileForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetConsumerProfileForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetConsumerProfileForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getOutletForEdit(id: number | null | undefined): Observable<GetOutletForEdit> {
        let url_ = this.baseUrl + "/api/services/app/ConsumerProfiles/GetOutletForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetOutletForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOutletForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetOutletForEdit>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetOutletForEdit>><any>_observableThrow(response_);
        }));
    }

    protected processGetOutletForEdit(response: HttpResponseBase): Observable<GetOutletForEdit> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetOutletForEdit.fromJS(resultData200) : new GetOutletForEdit();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetOutletForEdit>(<any>null);
    }

    /**
     * @param ids (optional) 
     * @return Success
     */
    batchDeleteOutlet(ids: number[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ConsumerProfiles/BatchDeleteOutlet";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ids);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processBatchDeleteOutlet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBatchDeleteOutlet(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processBatchDeleteOutlet(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    exportCustomOutlet(input: GetAllOutletInput | null | undefined): Observable<ConsumerDBFileDto> {
        let url_ = this.baseUrl + "/api/services/app/ConsumerProfiles/ExportCustomOutlet";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processExportCustomOutlet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportCustomOutlet(<any>response_);
                } catch (e) {
                    return <Observable<ConsumerDBFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ConsumerDBFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processExportCustomOutlet(response: HttpResponseBase): Observable<ConsumerDBFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? ConsumerDBFileDto.fromJS(resultData200) : new ConsumerDBFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ConsumerDBFileDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    editOutlet(input: GetOutletForEdit | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ConsumerProfiles/EditOutlet";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processEditOutlet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditOutlet(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processEditOutlet(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param arg (optional) 
     * @return Success
     */
    importQueueOutlet(arg: ConsumerProfileAgrs | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ConsumerProfiles/ImportQueueOutlet";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(arg);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processImportQueueOutlet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportQueueOutlet(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processImportQueueOutlet(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEditCustom(input: CreateOrEditConsumerProfileDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ConsumerProfiles/CreateOrEditCustom";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEditCustom(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditCustom(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEditCustom(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    search(input: GetAllConsumerProfilesInput | null | undefined): Observable<PagedResultDtoOfGetConsumerProfileForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/ConsumerProfiles/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetConsumerProfileForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetConsumerProfileForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<PagedResultDtoOfGetConsumerProfileForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetConsumerProfileForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetConsumerProfileForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetConsumerProfileForViewDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    exportCSV(input: GetAllConsumerProfilesInput | null | undefined): Observable<ConsumerDBFileDto> {
        let url_ = this.baseUrl + "/api/services/app/ConsumerProfiles/ExportCSV";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processExportCSV(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportCSV(<any>response_);
                } catch (e) {
                    return <Observable<ConsumerDBFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ConsumerDBFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processExportCSV(response: HttpResponseBase): Observable<ConsumerDBFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? ConsumerDBFileDto.fromJS(resultData200) : new ConsumerDBFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ConsumerDBFileDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    exportCustom(input: GetAllConsumerProfilesInput | null | undefined): Observable<ConsumerDBFileDto> {
        let url_ = this.baseUrl + "/api/services/app/ConsumerProfiles/ExportCustom";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processExportCustom(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportCustom(<any>response_);
                } catch (e) {
                    return <Observable<ConsumerDBFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ConsumerDBFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processExportCustom(response: HttpResponseBase): Observable<ConsumerDBFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? ConsumerDBFileDto.fromJS(resultData200) : new ConsumerDBFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ConsumerDBFileDto>(<any>null);
    }

    /**
     * @param arg (optional) 
     * @return Success
     */
    importQueue(arg: ConsumerProfileAgrs | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ConsumerProfiles/ImportQueue";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(arg);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processImportQueue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportQueue(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processImportQueue(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param request (optional) 
     * @return Success
     */
    postGetPointHistory(request: GetPointHistoryRequest | null | undefined): Observable<GetPointHistoryResponse> {
        let url_ = this.baseUrl + "/api/services/app/ConsumerProfiles/PostGetPointHistory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processPostGetPointHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostGetPointHistory(<any>response_);
                } catch (e) {
                    return <Observable<GetPointHistoryResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetPointHistoryResponse>><any>_observableThrow(response_);
        }));
    }

    protected processPostGetPointHistory(response: HttpResponseBase): Observable<GetPointHistoryResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetPointHistoryResponse.fromJS(resultData200) : new GetPointHistoryResponse();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPointHistoryResponse>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getConsumerProfileForEditCustom(id: number | null | undefined): Observable<GetConsumerProfileForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/ConsumerProfiles/GetConsumerProfileForEditCustom?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetConsumerProfileForEditCustom(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConsumerProfileForEditCustom(<any>response_);
                } catch (e) {
                    return <Observable<GetConsumerProfileForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetConsumerProfileForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetConsumerProfileForEditCustom(response: HttpResponseBase): Observable<GetConsumerProfileForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetConsumerProfileForEditOutput.fromJS(resultData200) : new GetConsumerProfileForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetConsumerProfileForEditOutput>(<any>null);
    }

    /**
     * @param chatId (optional) 
     * @return Success
     */
    verifyChatId(chatId: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/ConsumerProfiles/VerifyChatId?";
        if (chatId !== undefined)
            url_ += "chatId=" + encodeURIComponent("" + chatId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processVerifyChatId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerifyChatId(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processVerifyChatId(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param memberCode (optional) 
     * @return Success
     */
    getmemberInfoValidation(memberCode: string | null | undefined): Observable<MemberInfoValidationDto> {
        let url_ = this.baseUrl + "/api/services/app/ConsumerProfiles/GetmemberInfoValidation?";
        if (memberCode !== undefined)
            url_ += "memberCode=" + encodeURIComponent("" + memberCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetmemberInfoValidation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetmemberInfoValidation(<any>response_);
                } catch (e) {
                    return <Observable<MemberInfoValidationDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<MemberInfoValidationDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetmemberInfoValidation(response: HttpResponseBase): Observable<MemberInfoValidationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? MemberInfoValidationDto.fromJS(resultData200) : new MemberInfoValidationDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MemberInfoValidationDto>(<any>null);
    }

    /**
     * @param memberCode (optional) 
     * @return Success
     */
    updateStatusValidation(memberCode: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/ConsumerProfiles/UpdateStatusValidation?";
        if (memberCode !== undefined)
            url_ += "memberCode=" + encodeURIComponent("" + memberCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateStatusValidation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateStatusValidation(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateStatusValidation(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }
}

@Injectable()
export class ConversationStatusesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param retailerCodeFilter (optional) 
     * @param userIDFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, retailerCodeFilter: string | null | undefined, userIDFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetConversationStatusForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/ConversationStatuses/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (retailerCodeFilter !== undefined)
            url_ += "RetailerCodeFilter=" + encodeURIComponent("" + retailerCodeFilter) + "&";
        if (userIDFilter !== undefined)
            url_ += "UserIDFilter=" + encodeURIComponent("" + userIDFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetConversationStatusForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetConversationStatusForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetConversationStatusForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetConversationStatusForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetConversationStatusForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetConversationStatusForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getConversationStatusForEdit(id: number | null | undefined): Observable<GetConversationStatusForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/ConversationStatuses/GetConversationStatusForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetConversationStatusForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConversationStatusForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetConversationStatusForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetConversationStatusForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetConversationStatusForEdit(response: HttpResponseBase): Observable<GetConversationStatusForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetConversationStatusForEditOutput.fromJS(resultData200) : new GetConversationStatusForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetConversationStatusForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditConversationStatusDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ConversationStatuses/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ConversationStatuses/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param retailerCodeFilter (optional) 
     * @param userIDFilter (optional) 
     * @return Success
     */
    getConversationStatusesToExcel(filter: string | null | undefined, retailerCodeFilter: string | null | undefined, userIDFilter: string | null | undefined): Observable<SocialRetailerFileDto> {
        let url_ = this.baseUrl + "/api/services/app/ConversationStatuses/GetConversationStatusesToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (retailerCodeFilter !== undefined)
            url_ += "RetailerCodeFilter=" + encodeURIComponent("" + retailerCodeFilter) + "&";
        if (userIDFilter !== undefined)
            url_ += "UserIDFilter=" + encodeURIComponent("" + userIDFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetConversationStatusesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConversationStatusesToExcel(<any>response_);
                } catch (e) {
                    return <Observable<SocialRetailerFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SocialRetailerFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetConversationStatusesToExcel(response: HttpResponseBase): Observable<SocialRetailerFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? SocialRetailerFileDto.fromJS(resultData200) : new SocialRetailerFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SocialRetailerFileDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createExt(input: CreateOrEditConversationStatusDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ConversationStatuses/CreateExt";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateExt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateExt(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateExt(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param retailerCode (optional) 
     * @return Success
     */
    deleteExt(retailerCode: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ConversationStatuses/DeleteExt?";
        if (retailerCode !== undefined)
            url_ += "retailerCode=" + encodeURIComponent("" + retailerCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteExt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteExt(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteExt(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param userID (optional) 
     * @return Success
     */
    getNameSupport(userID: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/ConversationStatuses/GetNameSupport?";
        if (userID !== undefined)
            url_ += "userID=" + encodeURIComponent("" + userID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetNameSupport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNameSupport(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetNameSupport(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }
}

@Injectable()
export class CusLevelGEOsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param slsRegion_Level_8Filter (optional) 
     * @param slsRegion_Level_7Filter (optional) 
     * @param slsRegion_Level_6Filter (optional) 
     * @param slsRegion_Level_5Filter (optional) 
     * @param slsRegion_Level_4Filter (optional) 
     * @param slsRegion_Level_3Filter (optional) 
     * @param slsRegion_Level_2Filter (optional) 
     * @param slsRegion_Level_1Filter (optional) 
     * @param name_Level_8Filter (optional) 
     * @param name_Level_7Filter (optional) 
     * @param name_Level_6Filter (optional) 
     * @param name_Level_5Filter (optional) 
     * @param name_Level_4Filter (optional) 
     * @param name_Level_3Filter (optional) 
     * @param name_Level_2Filter (optional) 
     * @param name_Level_1Filter (optional) 
     * @param cUST_CDFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, slsRegion_Level_8Filter: string | null | undefined, slsRegion_Level_7Filter: string | null | undefined, slsRegion_Level_6Filter: string | null | undefined, slsRegion_Level_5Filter: string | null | undefined, slsRegion_Level_4Filter: string | null | undefined, slsRegion_Level_3Filter: string | null | undefined, slsRegion_Level_2Filter: string | null | undefined, slsRegion_Level_1Filter: string | null | undefined, name_Level_8Filter: string | null | undefined, name_Level_7Filter: string | null | undefined, name_Level_6Filter: string | null | undefined, name_Level_5Filter: string | null | undefined, name_Level_4Filter: string | null | undefined, name_Level_3Filter: string | null | undefined, name_Level_2Filter: string | null | undefined, name_Level_1Filter: string | null | undefined, cUST_CDFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetCusLevelGEOForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/CusLevelGEOs/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (slsRegion_Level_8Filter !== undefined)
            url_ += "SlsRegion_Level_8Filter=" + encodeURIComponent("" + slsRegion_Level_8Filter) + "&";
        if (slsRegion_Level_7Filter !== undefined)
            url_ += "SlsRegion_Level_7Filter=" + encodeURIComponent("" + slsRegion_Level_7Filter) + "&";
        if (slsRegion_Level_6Filter !== undefined)
            url_ += "SlsRegion_Level_6Filter=" + encodeURIComponent("" + slsRegion_Level_6Filter) + "&";
        if (slsRegion_Level_5Filter !== undefined)
            url_ += "SlsRegion_Level_5Filter=" + encodeURIComponent("" + slsRegion_Level_5Filter) + "&";
        if (slsRegion_Level_4Filter !== undefined)
            url_ += "SlsRegion_Level_4Filter=" + encodeURIComponent("" + slsRegion_Level_4Filter) + "&";
        if (slsRegion_Level_3Filter !== undefined)
            url_ += "SlsRegion_Level_3Filter=" + encodeURIComponent("" + slsRegion_Level_3Filter) + "&";
        if (slsRegion_Level_2Filter !== undefined)
            url_ += "SlsRegion_Level_2Filter=" + encodeURIComponent("" + slsRegion_Level_2Filter) + "&";
        if (slsRegion_Level_1Filter !== undefined)
            url_ += "SlsRegion_Level_1Filter=" + encodeURIComponent("" + slsRegion_Level_1Filter) + "&";
        if (name_Level_8Filter !== undefined)
            url_ += "Name_Level_8Filter=" + encodeURIComponent("" + name_Level_8Filter) + "&";
        if (name_Level_7Filter !== undefined)
            url_ += "Name_Level_7Filter=" + encodeURIComponent("" + name_Level_7Filter) + "&";
        if (name_Level_6Filter !== undefined)
            url_ += "Name_Level_6Filter=" + encodeURIComponent("" + name_Level_6Filter) + "&";
        if (name_Level_5Filter !== undefined)
            url_ += "Name_Level_5Filter=" + encodeURIComponent("" + name_Level_5Filter) + "&";
        if (name_Level_4Filter !== undefined)
            url_ += "Name_Level_4Filter=" + encodeURIComponent("" + name_Level_4Filter) + "&";
        if (name_Level_3Filter !== undefined)
            url_ += "Name_Level_3Filter=" + encodeURIComponent("" + name_Level_3Filter) + "&";
        if (name_Level_2Filter !== undefined)
            url_ += "Name_Level_2Filter=" + encodeURIComponent("" + name_Level_2Filter) + "&";
        if (name_Level_1Filter !== undefined)
            url_ += "Name_Level_1Filter=" + encodeURIComponent("" + name_Level_1Filter) + "&";
        if (cUST_CDFilter !== undefined)
            url_ += "CUST_CDFilter=" + encodeURIComponent("" + cUST_CDFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetCusLevelGEOForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetCusLevelGEOForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetCusLevelGEOForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetCusLevelGEOForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetCusLevelGEOForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetCusLevelGEOForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getCusLevelGEOForEdit(id: number | null | undefined): Observable<GetCusLevelGEOForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/CusLevelGEOs/GetCusLevelGEOForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCusLevelGEOForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCusLevelGEOForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetCusLevelGEOForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetCusLevelGEOForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetCusLevelGEOForEdit(response: HttpResponseBase): Observable<GetCusLevelGEOForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetCusLevelGEOForEditOutput.fromJS(resultData200) : new GetCusLevelGEOForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCusLevelGEOForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditCusLevelGEODto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CusLevelGEOs/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CusLevelGEOs/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class CustomerPerformanceReportServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @return Success
     */
    exportFile(filter: string | null | undefined): Observable<PointFileDto> {
        let url_ = this.baseUrl + "/api/services/app/CustomerPerformanceReport/ExportFile?";
        if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processExportFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportFile(<any>response_);
                } catch (e) {
                    return <Observable<PointFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PointFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processExportFile(response: HttpResponseBase): Observable<PointFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PointFileDto.fromJS(resultData200) : new PointFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PointFileDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @return Success
     */
    getCustomerPerformanceRank(filter: string | null | undefined): Observable<CustomerPerformanceRankDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CustomerPerformanceReport/GetCustomerPerformanceRank?";
        if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCustomerPerformanceRank(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustomerPerformanceRank(<any>response_);
                } catch (e) {
                    return <Observable<CustomerPerformanceRankDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<CustomerPerformanceRankDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetCustomerPerformanceRank(response: HttpResponseBase): Observable<CustomerPerformanceRankDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(CustomerPerformanceRankDto.fromJS(item));
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerPerformanceRankDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getCustomerPerformanceStatus(): Observable<CustomerPerformanceStatusDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CustomerPerformanceReport/GetCustomerPerformanceStatus";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCustomerPerformanceStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustomerPerformanceStatus(<any>response_);
                } catch (e) {
                    return <Observable<CustomerPerformanceStatusDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<CustomerPerformanceStatusDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetCustomerPerformanceStatus(response: HttpResponseBase): Observable<CustomerPerformanceStatusDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(CustomerPerformanceStatusDto.fromJS(item));
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerPerformanceStatusDto[]>(<any>null);
    }
}

@Injectable()
export class CustomersServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param codeFilter (optional) 
     * @param nameFilter (optional) 
     * @param isActiveFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, codeFilter: string | null | undefined, nameFilter: string | null | undefined, isActiveFilter: number | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetCustomerForView> {
        let url_ = this.baseUrl + "/api/services/app/Customers/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&";
        if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (isActiveFilter !== undefined)
            url_ += "IsActiveFilter=" + encodeURIComponent("" + isActiveFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetCustomerForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetCustomerForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetCustomerForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetCustomerForView.fromJS(resultData200) : new PagedResultDtoOfGetCustomerForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetCustomerForView>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getCustomerForEdit(id: number | null | undefined): Observable<GetCustomerForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Customers/GetCustomerForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCustomerForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustomerForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetCustomerForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetCustomerForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetCustomerForEdit(response: HttpResponseBase): Observable<GetCustomerForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetCustomerForEditOutput.fromJS(resultData200) : new GetCustomerForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCustomerForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditCustomerDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Customers/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Customers/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param customerCode (optional) 
     * @return Success
     */
    isExistCustomer(customerCode: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Customers/IsExistCustomer?";
        if (customerCode !== undefined)
            url_ += "CustomerCode=" + encodeURIComponent("" + customerCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processIsExistCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsExistCustomer(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processIsExistCustomer(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param entities (optional) 
     * @return Success
     */
    sync(entities: CreateOrEditCustomerDto[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Customers/Sync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entities);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSync(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSync(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class ChallengeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param memberCode (optional) 
     * @return Success
     */
    getListChallenge(memberCode: string | null | undefined): Observable<GetListChallengeResponse> {
        let url_ = this.baseUrl + "/api/services/app/Challenge/GetListChallenge?";
        if (memberCode !== undefined)
            url_ += "memberCode=" + encodeURIComponent("" + memberCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetListChallenge(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetListChallenge(<any>response_);
                } catch (e) {
                    return <Observable<GetListChallengeResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetListChallengeResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetListChallenge(response: HttpResponseBase): Observable<GetListChallengeResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetListChallengeResponse.fromJS(resultData200) : new GetListChallengeResponse();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetListChallengeResponse>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    submitChallenge(input: ChallengeResultSubmitInput | null | undefined): Observable<SubmitChallengeResponse> {
        let url_ = this.baseUrl + "/api/services/app/Challenge/SubmitChallenge";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSubmitChallenge(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubmitChallenge(<any>response_);
                } catch (e) {
                    return <Observable<SubmitChallengeResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<SubmitChallengeResponse>><any>_observableThrow(response_);
        }));
    }

    protected processSubmitChallenge(response: HttpResponseBase): Observable<SubmitChallengeResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? SubmitChallengeResponse.fromJS(resultData200) : new SubmitChallengeResponse();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SubmitChallengeResponse>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    submitAction(input: SubmitActionInput | null | undefined): Observable<SubmitChallengeResponse> {
        let url_ = this.baseUrl + "/api/services/app/Challenge/SubmitAction";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSubmitAction(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubmitAction(<any>response_);
                } catch (e) {
                    return <Observable<SubmitChallengeResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<SubmitChallengeResponse>><any>_observableThrow(response_);
        }));
    }

    protected processSubmitAction(response: HttpResponseBase): Observable<SubmitChallengeResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? SubmitChallengeResponse.fromJS(resultData200) : new SubmitChallengeResponse();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SubmitChallengeResponse>(<any>null);
    }

    /**
     * @param arg (optional) 
     * @return Success
     */
    importQueue(arg: ChallengeResultImportAgrs | null | undefined): Observable<CommonImportFileResponse> {
        let url_ = this.baseUrl + "/api/services/app/Challenge/ImportQueue";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(arg);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processImportQueue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportQueue(<any>response_);
                } catch (e) {
                    return <Observable<CommonImportFileResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<CommonImportFileResponse>><any>_observableThrow(response_);
        }));
    }

    protected processImportQueue(response: HttpResponseBase): Observable<CommonImportFileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? CommonImportFileResponse.fromJS(resultData200) : new CommonImportFileResponse();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CommonImportFileResponse>(<any>null);
    }

    /**
     * @param programName (optional) 
     * @param provinceCode (optional) 
     * @param regionCode (optional) 
     * @param memberCode (optional) 
     * @param status (optional) 
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param fromDate1 (optional) 
     * @param toDate1 (optional) 
     * @param number (optional) 
     * @param phone (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getListChallengeResult(programName: string | null | undefined, provinceCode: string | null | undefined, regionCode: string | null | undefined, memberCode: string | null | undefined, status: string | null | undefined, fromDate: moment.Moment | null | undefined, toDate: moment.Moment | null | undefined, fromDate1: moment.Moment | null | undefined, toDate1: moment.Moment | null | undefined, number: number | null | undefined, phone: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetListChallengeResultResponse> {
        let url_ = this.baseUrl + "/api/services/app/Challenge/GetListChallengeResult?";
        if (programName !== undefined)
            url_ += "ProgramName=" + encodeURIComponent("" + programName) + "&";
        if (provinceCode !== undefined)
            url_ += "ProvinceCode=" + encodeURIComponent("" + provinceCode) + "&";
        if (regionCode !== undefined)
            url_ += "RegionCode=" + encodeURIComponent("" + regionCode) + "&";
        if (memberCode !== undefined)
            url_ += "MemberCode=" + encodeURIComponent("" + memberCode) + "&";
        if (status !== undefined)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toJSON() : "") + "&";
        if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent(toDate ? "" + toDate.toJSON() : "") + "&";
        if (fromDate1 !== undefined)
            url_ += "fromDate1=" + encodeURIComponent(fromDate1 ? "" + fromDate1.toJSON() : "") + "&";
        if (toDate1 !== undefined)
            url_ += "toDate1=" + encodeURIComponent(toDate1 ? "" + toDate1.toJSON() : "") + "&";
        if (number !== undefined)
            url_ += "Number=" + encodeURIComponent("" + number) + "&";
        if (phone !== undefined)
            url_ += "Phone=" + encodeURIComponent("" + phone) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetListChallengeResult(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetListChallengeResult(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetListChallengeResultResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetListChallengeResultResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetListChallengeResult(response: HttpResponseBase): Observable<PagedResultDtoOfGetListChallengeResultResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetListChallengeResultResponse.fromJS(resultData200) : new PagedResultDtoOfGetListChallengeResultResponse();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetListChallengeResultResponse>(<any>null);
    }

    /**
     * @param programName (optional) 
     * @param provinceCode (optional) 
     * @param regionCode (optional) 
     * @param memberCode (optional) 
     * @param status (optional) 
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param fromDate1 (optional) 
     * @param toDate1 (optional) 
     * @param number (optional) 
     * @param phone (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getListProgramName(programName: string | null | undefined, provinceCode: string | null | undefined, regionCode: string | null | undefined, memberCode: string | null | undefined, status: string | null | undefined, fromDate: moment.Moment | null | undefined, toDate: moment.Moment | null | undefined, fromDate1: moment.Moment | null | undefined, toDate1: moment.Moment | null | undefined, number: number | null | undefined, phone: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfString> {
        let url_ = this.baseUrl + "/api/services/app/Challenge/GetListProgramName?";
        if (programName !== undefined)
            url_ += "ProgramName=" + encodeURIComponent("" + programName) + "&";
        if (provinceCode !== undefined)
            url_ += "ProvinceCode=" + encodeURIComponent("" + provinceCode) + "&";
        if (regionCode !== undefined)
            url_ += "RegionCode=" + encodeURIComponent("" + regionCode) + "&";
        if (memberCode !== undefined)
            url_ += "MemberCode=" + encodeURIComponent("" + memberCode) + "&";
        if (status !== undefined)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toJSON() : "") + "&";
        if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent(toDate ? "" + toDate.toJSON() : "") + "&";
        if (fromDate1 !== undefined)
            url_ += "fromDate1=" + encodeURIComponent(fromDate1 ? "" + fromDate1.toJSON() : "") + "&";
        if (toDate1 !== undefined)
            url_ += "toDate1=" + encodeURIComponent(toDate1 ? "" + toDate1.toJSON() : "") + "&";
        if (number !== undefined)
            url_ += "Number=" + encodeURIComponent("" + number) + "&";
        if (phone !== undefined)
            url_ += "Phone=" + encodeURIComponent("" + phone) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetListProgramName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetListProgramName(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfString>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfString>><any>_observableThrow(response_);
        }));
    }

    protected processGetListProgramName(response: HttpResponseBase): Observable<PagedResultDtoOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfString.fromJS(resultData200) : new PagedResultDtoOfString();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfString>(<any>null);
    }

    /**
     * @param programName (optional) 
     * @param provinceCode (optional) 
     * @param regionCode (optional) 
     * @param memberCode (optional) 
     * @param status (optional) 
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param fromDate1 (optional) 
     * @param toDate1 (optional) 
     * @param number (optional) 
     * @param phone (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getChallengesToExcel(programName: string | null | undefined, provinceCode: string | null | undefined, regionCode: string | null | undefined, memberCode: string | null | undefined, status: string | null | undefined, fromDate: moment.Moment | null | undefined, toDate: moment.Moment | null | undefined, fromDate1: moment.Moment | null | undefined, toDate1: moment.Moment | null | undefined, number: number | null | undefined, phone: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<SocialRetailerFileDto> {
        let url_ = this.baseUrl + "/api/services/app/Challenge/GetChallengesToExcel?";
        if (programName !== undefined)
            url_ += "ProgramName=" + encodeURIComponent("" + programName) + "&";
        if (provinceCode !== undefined)
            url_ += "ProvinceCode=" + encodeURIComponent("" + provinceCode) + "&";
        if (regionCode !== undefined)
            url_ += "RegionCode=" + encodeURIComponent("" + regionCode) + "&";
        if (memberCode !== undefined)
            url_ += "MemberCode=" + encodeURIComponent("" + memberCode) + "&";
        if (status !== undefined)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toJSON() : "") + "&";
        if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent(toDate ? "" + toDate.toJSON() : "") + "&";
        if (fromDate1 !== undefined)
            url_ += "fromDate1=" + encodeURIComponent(fromDate1 ? "" + fromDate1.toJSON() : "") + "&";
        if (toDate1 !== undefined)
            url_ += "toDate1=" + encodeURIComponent(toDate1 ? "" + toDate1.toJSON() : "") + "&";
        if (number !== undefined)
            url_ += "Number=" + encodeURIComponent("" + number) + "&";
        if (phone !== undefined)
            url_ += "Phone=" + encodeURIComponent("" + phone) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetChallengesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetChallengesToExcel(<any>response_);
                } catch (e) {
                    return <Observable<SocialRetailerFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SocialRetailerFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetChallengesToExcel(response: HttpResponseBase): Observable<SocialRetailerFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? SocialRetailerFileDto.fromJS(resultData200) : new SocialRetailerFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SocialRetailerFileDto>(<any>null);
    }

    /**
     * @param programCode (optional) 
     * @param programName (optional) 
     * @param imageType (optional) 
     * @param status (optional) 
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getListChallengeHeader(programCode: string | null | undefined, programName: string | null | undefined, imageType: string | null | undefined, status: string | null | undefined, fromDate: moment.Moment | null | undefined, toDate: moment.Moment | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetListChallengeHeaderResponse> {
        let url_ = this.baseUrl + "/api/services/app/Challenge/GetListChallengeHeader?";
        if (programCode !== undefined)
            url_ += "ProgramCode=" + encodeURIComponent("" + programCode) + "&";
        if (programName !== undefined)
            url_ += "ProgramName=" + encodeURIComponent("" + programName) + "&";
        if (imageType !== undefined)
            url_ += "ImageType=" + encodeURIComponent("" + imageType) + "&";
        if (status !== undefined)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toJSON() : "") + "&";
        if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toJSON() : "") + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetListChallengeHeader(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetListChallengeHeader(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetListChallengeHeaderResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetListChallengeHeaderResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetListChallengeHeader(response: HttpResponseBase): Observable<PagedResultDtoOfGetListChallengeHeaderResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetListChallengeHeaderResponse.fromJS(resultData200) : new PagedResultDtoOfGetListChallengeHeaderResponse();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetListChallengeHeaderResponse>(<any>null);
    }

    /**
     * @return Success
     */
    getAllTargetAudienceImported(): Observable<PagedResultDtoOfChallengeTargetAudienceResponse> {
        let url_ = this.baseUrl + "/api/services/app/Challenge/GetAllTargetAudienceImported";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllTargetAudienceImported(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTargetAudienceImported(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfChallengeTargetAudienceResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfChallengeTargetAudienceResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllTargetAudienceImported(response: HttpResponseBase): Observable<PagedResultDtoOfChallengeTargetAudienceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfChallengeTargetAudienceResponse.fromJS(resultData200) : new PagedResultDtoOfChallengeTargetAudienceResponse();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfChallengeTargetAudienceResponse>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEditChallenge(input: CreateOrEditChallengeInput | null | undefined): Observable<CreateOrEditChallengeResponse> {
        let url_ = this.baseUrl + "/api/services/app/Challenge/CreateOrEditChallenge";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEditChallenge(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditChallenge(<any>response_);
                } catch (e) {
                    return <Observable<CreateOrEditChallengeResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<CreateOrEditChallengeResponse>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEditChallenge(response: HttpResponseBase): Observable<CreateOrEditChallengeResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? CreateOrEditChallengeResponse.fromJS(resultData200) : new CreateOrEditChallengeResponse();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateOrEditChallengeResponse>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getChallengeHeaderForEdit(id: number | null | undefined): Observable<GetChallengeHeaderForEditResponse> {
        let url_ = this.baseUrl + "/api/services/app/Challenge/GetChallengeHeaderForEdit?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetChallengeHeaderForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetChallengeHeaderForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetChallengeHeaderForEditResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetChallengeHeaderForEditResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetChallengeHeaderForEdit(response: HttpResponseBase): Observable<GetChallengeHeaderForEditResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetChallengeHeaderForEditResponse.fromJS(resultData200) : new GetChallengeHeaderForEditResponse();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetChallengeHeaderForEditResponse>(<any>null);
    }

    /**
     * @param challengeId (optional) 
     * @param status (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getListChallengeFollowForEdit(challengeId: number | null | undefined, status: number | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetListChallengeFollowForEditResponse> {
        let url_ = this.baseUrl + "/api/services/app/Challenge/GetListChallengeFollowForEdit?";
        if (challengeId !== undefined)
            url_ += "ChallengeId=" + encodeURIComponent("" + challengeId) + "&";
        if (status !== undefined)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetListChallengeFollowForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetListChallengeFollowForEdit(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetListChallengeFollowForEditResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetListChallengeFollowForEditResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetListChallengeFollowForEdit(response: HttpResponseBase): Observable<PagedResultDtoOfGetListChallengeFollowForEditResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetListChallengeFollowForEditResponse.fromJS(resultData200) : new PagedResultDtoOfGetListChallengeFollowForEditResponse();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetListChallengeFollowForEditResponse>(<any>null);
    }

    /**
     * @param challengeId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getListChallengeResultForEdit(challengeId: number | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetListChallengeResultForEditResponse> {
        let url_ = this.baseUrl + "/api/services/app/Challenge/GetListChallengeResultForEdit?";
        if (challengeId !== undefined)
            url_ += "ChallengeId=" + encodeURIComponent("" + challengeId) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetListChallengeResultForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetListChallengeResultForEdit(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetListChallengeResultForEditResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetListChallengeResultForEditResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetListChallengeResultForEdit(response: HttpResponseBase): Observable<PagedResultDtoOfGetListChallengeResultForEditResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetListChallengeResultForEditResponse.fromJS(resultData200) : new PagedResultDtoOfGetListChallengeResultForEditResponse();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetListChallengeResultForEditResponse>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEditChallengeFollow(input: CreateOrEditChallengeFollowInput | null | undefined): Observable<CreateOrEditChallengeFollowResponse> {
        let url_ = this.baseUrl + "/api/services/app/Challenge/CreateOrEditChallengeFollow";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEditChallengeFollow(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditChallengeFollow(<any>response_);
                } catch (e) {
                    return <Observable<CreateOrEditChallengeFollowResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<CreateOrEditChallengeFollowResponse>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEditChallengeFollow(response: HttpResponseBase): Observable<CreateOrEditChallengeFollowResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? CreateOrEditChallengeFollowResponse.fromJS(resultData200) : new CreateOrEditChallengeFollowResponse();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateOrEditChallengeFollowResponse>(<any>null);
    }
}

@Injectable()
export class ChannelConfigsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param channelCodeFilter (optional) 
     * @param channelTypeFilter (optional) 
     * @param channelConfigurationsFilter (optional) 
     * @param statusFilter (optional) 
     * @param channelChannelCodeFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, channelCodeFilter: string | null | undefined, channelTypeFilter: string | null | undefined, channelConfigurationsFilter: string | null | undefined, statusFilter: string | null | undefined, channelChannelCodeFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetChannelConfigForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/ChannelConfigs/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (channelCodeFilter !== undefined)
            url_ += "ChannelCodeFilter=" + encodeURIComponent("" + channelCodeFilter) + "&";
        if (channelTypeFilter !== undefined)
            url_ += "ChannelTypeFilter=" + encodeURIComponent("" + channelTypeFilter) + "&";
        if (channelConfigurationsFilter !== undefined)
            url_ += "ChannelConfigurationsFilter=" + encodeURIComponent("" + channelConfigurationsFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (channelChannelCodeFilter !== undefined)
            url_ += "ChannelChannelCodeFilter=" + encodeURIComponent("" + channelChannelCodeFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetChannelConfigForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetChannelConfigForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetChannelConfigForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetChannelConfigForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetChannelConfigForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetChannelConfigForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getChannelConfigForEdit(id: number | null | undefined): Observable<GetChannelConfigForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/ChannelConfigs/GetChannelConfigForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetChannelConfigForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetChannelConfigForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetChannelConfigForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetChannelConfigForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetChannelConfigForEdit(response: HttpResponseBase): Observable<GetChannelConfigForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetChannelConfigForEditOutput.fromJS(resultData200) : new GetChannelConfigForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetChannelConfigForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditChannelConfigDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ChannelConfigs/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ChannelConfigs/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param channelCodeFilter (optional) 
     * @param channelTypeFilter (optional) 
     * @param channelConfigurationsFilter (optional) 
     * @param statusFilter (optional) 
     * @param channelChannelCodeFilter (optional) 
     * @return Success
     */
    getChannelConfigsToExcel(filter: string | null | undefined, channelCodeFilter: string | null | undefined, channelTypeFilter: string | null | undefined, channelConfigurationsFilter: string | null | undefined, statusFilter: string | null | undefined, channelChannelCodeFilter: string | null | undefined): Observable<NotificationFileDto> {
        let url_ = this.baseUrl + "/api/services/app/ChannelConfigs/GetChannelConfigsToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (channelCodeFilter !== undefined)
            url_ += "ChannelCodeFilter=" + encodeURIComponent("" + channelCodeFilter) + "&";
        if (channelTypeFilter !== undefined)
            url_ += "ChannelTypeFilter=" + encodeURIComponent("" + channelTypeFilter) + "&";
        if (channelConfigurationsFilter !== undefined)
            url_ += "ChannelConfigurationsFilter=" + encodeURIComponent("" + channelConfigurationsFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (channelChannelCodeFilter !== undefined)
            url_ += "ChannelChannelCodeFilter=" + encodeURIComponent("" + channelChannelCodeFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetChannelConfigsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetChannelConfigsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<NotificationFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<NotificationFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetChannelConfigsToExcel(response: HttpResponseBase): Observable<NotificationFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? NotificationFileDto.fromJS(resultData200) : new NotificationFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NotificationFileDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllChannelForLookupTable(filter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfChannelLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/ChannelConfigs/GetAllChannelForLookupTable?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllChannelForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllChannelForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfChannelLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfChannelLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllChannelForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfChannelLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfChannelLookupTableDto.fromJS(resultData200) : new PagedResultDtoOfChannelLookupTableDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfChannelLookupTableDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param channelCodeFilter (optional) 
     * @param channelTypeFilter (optional) 
     * @param channelConfigurationsFilter (optional) 
     * @param statusFilter (optional) 
     * @param channelChannelCodeFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllExt(filter: string | null | undefined, channelCodeFilter: string | null | undefined, channelTypeFilter: string | null | undefined, channelConfigurationsFilter: string | null | undefined, statusFilter: string | null | undefined, channelChannelCodeFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetChannelConfigForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/ChannelConfigs/GetAllExt?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (channelCodeFilter !== undefined)
            url_ += "ChannelCodeFilter=" + encodeURIComponent("" + channelCodeFilter) + "&";
        if (channelTypeFilter !== undefined)
            url_ += "ChannelTypeFilter=" + encodeURIComponent("" + channelTypeFilter) + "&";
        if (channelConfigurationsFilter !== undefined)
            url_ += "ChannelConfigurationsFilter=" + encodeURIComponent("" + channelConfigurationsFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (channelChannelCodeFilter !== undefined)
            url_ += "ChannelChannelCodeFilter=" + encodeURIComponent("" + channelChannelCodeFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllExt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllExt(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetChannelConfigForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetChannelConfigForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllExt(response: HttpResponseBase): Observable<PagedResultDtoOfGetChannelConfigForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetChannelConfigForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetChannelConfigForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetChannelConfigForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getChannelConfigForEditExt(id: number | null | undefined): Observable<GetChannelConfigForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/ChannelConfigs/GetChannelConfigForEditExt?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetChannelConfigForEditExt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetChannelConfigForEditExt(<any>response_);
                } catch (e) {
                    return <Observable<GetChannelConfigForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetChannelConfigForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetChannelConfigForEditExt(response: HttpResponseBase): Observable<GetChannelConfigForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetChannelConfigForEditOutput.fromJS(resultData200) : new GetChannelConfigForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetChannelConfigForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEditExt(input: CreateOrEditChannelConfigDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ChannelConfigs/CreateOrEditExt";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEditExt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditExt(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEditExt(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllChannelForLookupTableExt(filter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfChannelLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/ChannelConfigs/GetAllChannelForLookupTableExt?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllChannelForLookupTableExt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllChannelForLookupTableExt(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfChannelLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfChannelLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllChannelForLookupTableExt(response: HttpResponseBase): Observable<PagedResultDtoOfChannelLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfChannelLookupTableDto.fromJS(resultData200) : new PagedResultDtoOfChannelLookupTableDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfChannelLookupTableDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    batchDeleteChannel(input: EntityDto[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ChannelConfigs/BatchDeleteChannel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processBatchDeleteChannel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBatchDeleteChannel(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processBatchDeleteChannel(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class ChannelConfigsExcelExporterServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param channelConfigs (optional) 
     * @return Success
     */
    exportToFile(channelConfigs: GetChannelConfigForViewDto[] | null | undefined): Observable<NotificationFileDto> {
        let url_ = this.baseUrl + "/api/services/app/ChannelConfigsExcelExporter/ExportToFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(channelConfigs);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processExportToFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportToFile(<any>response_);
                } catch (e) {
                    return <Observable<NotificationFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<NotificationFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processExportToFile(response: HttpResponseBase): Observable<NotificationFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? NotificationFileDto.fromJS(resultData200) : new NotificationFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NotificationFileDto>(<any>null);
    }
}

@Injectable()
export class ChannelsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param channelCodeFilter (optional) 
     * @param channelDescriptionFilter (optional) 
     * @param channelTypeFilter (optional) 
     * @param statusFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, channelCodeFilter: string | null | undefined, channelDescriptionFilter: string | null | undefined, channelTypeFilter: string | null | undefined, statusFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetChannelForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Channels/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (channelCodeFilter !== undefined)
            url_ += "ChannelCodeFilter=" + encodeURIComponent("" + channelCodeFilter) + "&";
        if (channelDescriptionFilter !== undefined)
            url_ += "ChannelDescriptionFilter=" + encodeURIComponent("" + channelDescriptionFilter) + "&";
        if (channelTypeFilter !== undefined)
            url_ += "ChannelTypeFilter=" + encodeURIComponent("" + channelTypeFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetChannelForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetChannelForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetChannelForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetChannelForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetChannelForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetChannelForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getChannelForEdit(id: number | null | undefined): Observable<GetChannelForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Channels/GetChannelForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetChannelForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetChannelForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetChannelForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetChannelForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetChannelForEdit(response: HttpResponseBase): Observable<GetChannelForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetChannelForEditOutput.fromJS(resultData200) : new GetChannelForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetChannelForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditChannelDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Channels/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Channels/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param channelCodeFilter (optional) 
     * @param channelDescriptionFilter (optional) 
     * @param channelTypeFilter (optional) 
     * @param statusFilter (optional) 
     * @return Success
     */
    getChannelsToExcel(filter: string | null | undefined, channelCodeFilter: string | null | undefined, channelDescriptionFilter: string | null | undefined, channelTypeFilter: string | null | undefined, statusFilter: string | null | undefined): Observable<NotificationFileDto> {
        let url_ = this.baseUrl + "/api/services/app/Channels/GetChannelsToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (channelCodeFilter !== undefined)
            url_ += "ChannelCodeFilter=" + encodeURIComponent("" + channelCodeFilter) + "&";
        if (channelDescriptionFilter !== undefined)
            url_ += "ChannelDescriptionFilter=" + encodeURIComponent("" + channelDescriptionFilter) + "&";
        if (channelTypeFilter !== undefined)
            url_ += "ChannelTypeFilter=" + encodeURIComponent("" + channelTypeFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetChannelsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetChannelsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<NotificationFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<NotificationFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetChannelsToExcel(response: HttpResponseBase): Observable<NotificationFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? NotificationFileDto.fromJS(resultData200) : new NotificationFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NotificationFileDto>(<any>null);
    }
}

@Injectable()
export class ChannelsExcelExporterServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param channels (optional) 
     * @return Success
     */
    exportToFile(channels: GetChannelForViewDto[] | null | undefined): Observable<NotificationFileDto> {
        let url_ = this.baseUrl + "/api/services/app/ChannelsExcelExporter/ExportToFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(channels);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processExportToFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportToFile(<any>response_);
                } catch (e) {
                    return <Observable<NotificationFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<NotificationFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processExportToFile(response: HttpResponseBase): Observable<NotificationFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? NotificationFileDto.fromJS(resultData200) : new NotificationFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NotificationFileDto>(<any>null);
    }
}

@Injectable()
export class ChannelTypesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param codeFilter (optional) 
     * @param nameFilter (optional) 
     * @param isActiveFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, codeFilter: string | null | undefined, nameFilter: string | null | undefined, isActiveFilter: number | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetChannelTypeForView> {
        let url_ = this.baseUrl + "/api/services/app/ChannelTypes/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&";
        if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (isActiveFilter !== undefined)
            url_ += "IsActiveFilter=" + encodeURIComponent("" + isActiveFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetChannelTypeForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetChannelTypeForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetChannelTypeForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetChannelTypeForView.fromJS(resultData200) : new PagedResultDtoOfGetChannelTypeForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetChannelTypeForView>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getChannelTypeForEdit(id: number | null | undefined): Observable<GetChannelTypeForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/ChannelTypes/GetChannelTypeForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetChannelTypeForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetChannelTypeForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetChannelTypeForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetChannelTypeForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetChannelTypeForEdit(response: HttpResponseBase): Observable<GetChannelTypeForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetChannelTypeForEditOutput.fromJS(resultData200) : new GetChannelTypeForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetChannelTypeForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditChannelTypeDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ChannelTypes/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ChannelTypes/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class ChatServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getUserChatFriendsWithSettings(): Observable<GetUserChatFriendsWithSettingsOutput> {
        let url_ = this.baseUrl + "/api/services/app/Chat/GetUserChatFriendsWithSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetUserChatFriendsWithSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserChatFriendsWithSettings(<any>response_);
                } catch (e) {
                    return <Observable<GetUserChatFriendsWithSettingsOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetUserChatFriendsWithSettingsOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserChatFriendsWithSettings(response: HttpResponseBase): Observable<GetUserChatFriendsWithSettingsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetUserChatFriendsWithSettingsOutput.fromJS(resultData200) : new GetUserChatFriendsWithSettingsOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetUserChatFriendsWithSettingsOutput>(<any>null);
    }

    /**
     * @param tenantId (optional) 
     * @param userId (optional) 
     * @param minMessageId (optional) 
     * @return Success
     */
    getUserChatMessages(tenantId: number | null | undefined, userId: number | null | undefined, minMessageId: number | null | undefined): Observable<ListResultDtoOfChatMessageDto> {
        let url_ = this.baseUrl + "/api/services/app/Chat/GetUserChatMessages?";
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (minMessageId !== undefined)
            url_ += "MinMessageId=" + encodeURIComponent("" + minMessageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetUserChatMessages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserChatMessages(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfChatMessageDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfChatMessageDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserChatMessages(response: HttpResponseBase): Observable<ListResultDtoOfChatMessageDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? ListResultDtoOfChatMessageDto.fromJS(resultData200) : new ListResultDtoOfChatMessageDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfChatMessageDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    markAllUnreadMessagesOfUserAsRead(input: MarkAllUnreadMessagesOfUserAsReadInput | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Chat/MarkAllUnreadMessagesOfUserAsRead";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processMarkAllUnreadMessagesOfUserAsRead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkAllUnreadMessagesOfUserAsRead(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processMarkAllUnreadMessagesOfUserAsRead(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class DashboardServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param salemanCode (optional) 
     * @return Success
     */
    getDashboard(salemanCode: string | null | undefined): Observable<DashboardDto> {
        let url_ = this.baseUrl + "/api/services/app/Dashboard/GetDashboard?";
        if (salemanCode !== undefined)
            url_ += "salemanCode=" + encodeURIComponent("" + salemanCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetDashboard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDashboard(<any>response_);
                } catch (e) {
                    return <Observable<DashboardDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<DashboardDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetDashboard(response: HttpResponseBase): Observable<DashboardDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? DashboardDto.fromJS(resultData200) : new DashboardDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DashboardDto>(<any>null);
    }

    /**
     * @param salemanCode (optional) 
     * @param month (optional) 
     * @param year (optional) 
     * @return Success
     */
    getDashboardManager(salemanCode: string | null | undefined, month: number | null | undefined, year: number | null | undefined): Observable<DashboardManagerDto> {
        let url_ = this.baseUrl + "/api/services/app/Dashboard/GetDashboardManager?";
        if (salemanCode !== undefined)
            url_ += "salemanCode=" + encodeURIComponent("" + salemanCode) + "&";
        if (month !== undefined)
            url_ += "month=" + encodeURIComponent("" + month) + "&";
        if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetDashboardManager(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDashboardManager(<any>response_);
                } catch (e) {
                    return <Observable<DashboardManagerDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<DashboardManagerDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetDashboardManager(response: HttpResponseBase): Observable<DashboardManagerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? DashboardManagerDto.fromJS(resultData200) : new DashboardManagerDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DashboardManagerDto>(<any>null);
    }
}

@Injectable()
export class DashboardServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param timeRun (optional) 
     * @param memberCode (optional) 
     * @return Success
     */
    getAllBrand(timeRun: string | null | undefined, memberCode: string | null | undefined): Observable<GetAllBrandReponse> {
        let url_ = this.baseUrl + "/api/services/app/DashboardService/GetAllBrand?";
        if (timeRun !== undefined)
            url_ += "TimeRun=" + encodeURIComponent("" + timeRun) + "&";
        if (memberCode !== undefined)
            url_ += "MemberCode=" + encodeURIComponent("" + memberCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllBrand(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllBrand(<any>response_);
                } catch (e) {
                    return <Observable<GetAllBrandReponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetAllBrandReponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllBrand(response: HttpResponseBase): Observable<GetAllBrandReponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetAllBrandReponse.fromJS(resultData200) : new GetAllBrandReponse();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAllBrandReponse>(<any>null);
    }

    /**
     * @param timeRun (optional) 
     * @param memberCode (optional) 
     * @return Success
     */
    getPointEarningHistory(timeRun: moment.Moment | null | undefined, memberCode: string | null | undefined): Observable<GetPointEarningHistoryReponse> {
        let url_ = this.baseUrl + "/api/services/app/DashboardService/GetPointEarningHistory?";
        if (timeRun !== undefined)
            url_ += "TimeRun=" + encodeURIComponent(timeRun ? "" + timeRun.toJSON() : "") + "&";
        if (memberCode !== undefined)
            url_ += "MemberCode=" + encodeURIComponent("" + memberCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetPointEarningHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPointEarningHistory(<any>response_);
                } catch (e) {
                    return <Observable<GetPointEarningHistoryReponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetPointEarningHistoryReponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetPointEarningHistory(response: HttpResponseBase): Observable<GetPointEarningHistoryReponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetPointEarningHistoryReponse.fromJS(resultData200) : new GetPointEarningHistoryReponse();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPointEarningHistoryReponse>(<any>null);
    }

    /**
     * @param brandCode (optional) 
     * @param memberCode (optional) 
     * @param isAll (optional) 
     * @param timeRun (optional) 
     * @return Success
     */
    getSalesByBrand(brandCode: string | null | undefined, memberCode: string | null | undefined, isAll: boolean | null | undefined, timeRun: string | null | undefined): Observable<GetSalesByBrandOutput> {
        let url_ = this.baseUrl + "/api/services/app/DashboardService/GetSalesByBrand?";
        if (brandCode !== undefined)
            url_ += "BrandCode=" + encodeURIComponent("" + brandCode) + "&";
        if (memberCode !== undefined)
            url_ += "MemberCode=" + encodeURIComponent("" + memberCode) + "&";
        if (isAll !== undefined)
            url_ += "IsAll=" + encodeURIComponent("" + isAll) + "&";
        if (timeRun !== undefined)
            url_ += "TimeRun=" + encodeURIComponent("" + timeRun) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSalesByBrand(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSalesByBrand(<any>response_);
                } catch (e) {
                    return <Observable<GetSalesByBrandOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetSalesByBrandOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetSalesByBrand(response: HttpResponseBase): Observable<GetSalesByBrandOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetSalesByBrandOutput.fromJS(resultData200) : new GetSalesByBrandOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSalesByBrandOutput>(<any>null);
    }

    /**
     * @param memberCode (optional) 
     * @param timeRun (optional) 
     * @param objectType (optional) 
     * @return Success
     */
    getSalesObjective(memberCode: string | null | undefined, timeRun: moment.Moment | null | undefined, objectType: string | null | undefined): Observable<GetSaleObjectOutput> {
        let url_ = this.baseUrl + "/api/services/app/DashboardService/GetSalesObjective?";
        if (memberCode !== undefined)
            url_ += "MemberCode=" + encodeURIComponent("" + memberCode) + "&";
        if (timeRun !== undefined)
            url_ += "TimeRun=" + encodeURIComponent(timeRun ? "" + timeRun.toJSON() : "") + "&";
        if (objectType !== undefined)
            url_ += "ObjectType=" + encodeURIComponent("" + objectType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSalesObjective(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSalesObjective(<any>response_);
                } catch (e) {
                    return <Observable<GetSaleObjectOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetSaleObjectOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetSalesObjective(response: HttpResponseBase): Observable<GetSaleObjectOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetSaleObjectOutput.fromJS(resultData200) : new GetSaleObjectOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSaleObjectOutput>(<any>null);
    }

    /**
     * @param timeRun (optional) 
     * @param memberCode (optional) 
     * @return Success
     */
    getPSKUProgram(timeRun: moment.Moment | null | undefined, memberCode: string | null | undefined): Observable<GetPSKUProgramReponse> {
        let url_ = this.baseUrl + "/api/services/app/DashboardService/GetPSKUProgram?";
        if (timeRun !== undefined)
            url_ += "TimeRun=" + encodeURIComponent(timeRun ? "" + timeRun.toJSON() : "") + "&";
        if (memberCode !== undefined)
            url_ += "MemberCode=" + encodeURIComponent("" + memberCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetPSKUProgram(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPSKUProgram(<any>response_);
                } catch (e) {
                    return <Observable<GetPSKUProgramReponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetPSKUProgramReponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetPSKUProgram(response: HttpResponseBase): Observable<GetPSKUProgramReponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetPSKUProgramReponse.fromJS(resultData200) : new GetPSKUProgramReponse();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPSKUProgramReponse>(<any>null);
    }
}

@Injectable()
export class DeleteProfileRequestsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param memberCodeFilter (optional) 
     * @param memberNameFilter (optional) 
     * @param phoneFilter (optional) 
     * @param typeOfRequestFilter (optional) 
     * @param maxRequestDateFilter (optional) 
     * @param minRequestDateFilter (optional) 
     * @param requestByFilter (optional) 
     * @param credentialsFilter (optional) 
     * @param statusFilter (optional) 
     * @param maxApproveDateFilter (optional) 
     * @param minApproveDateFilter (optional) 
     * @param approveByFilter (optional) 
     * @param reasonFilter (optional) 
     * @param reasonCodeFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, memberCodeFilter: string | null | undefined, memberNameFilter: string | null | undefined, phoneFilter: string | null | undefined, typeOfRequestFilter: string | null | undefined, maxRequestDateFilter: moment.Moment | null | undefined, minRequestDateFilter: moment.Moment | null | undefined, requestByFilter: string | null | undefined, credentialsFilter: string | null | undefined, statusFilter: string | null | undefined, maxApproveDateFilter: moment.Moment | null | undefined, minApproveDateFilter: moment.Moment | null | undefined, approveByFilter: string | null | undefined, reasonFilter: string | null | undefined, reasonCodeFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetDeleteProfileRequestForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/DeleteProfileRequests/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (memberCodeFilter !== undefined)
            url_ += "MemberCodeFilter=" + encodeURIComponent("" + memberCodeFilter) + "&";
        if (memberNameFilter !== undefined)
            url_ += "MemberNameFilter=" + encodeURIComponent("" + memberNameFilter) + "&";
        if (phoneFilter !== undefined)
            url_ += "PhoneFilter=" + encodeURIComponent("" + phoneFilter) + "&";
        if (typeOfRequestFilter !== undefined)
            url_ += "TypeOfRequestFilter=" + encodeURIComponent("" + typeOfRequestFilter) + "&";
        if (maxRequestDateFilter !== undefined)
            url_ += "MaxRequestDateFilter=" + encodeURIComponent(maxRequestDateFilter ? "" + maxRequestDateFilter.toJSON() : "") + "&";
        if (minRequestDateFilter !== undefined)
            url_ += "MinRequestDateFilter=" + encodeURIComponent(minRequestDateFilter ? "" + minRequestDateFilter.toJSON() : "") + "&";
        if (requestByFilter !== undefined)
            url_ += "RequestByFilter=" + encodeURIComponent("" + requestByFilter) + "&";
        if (credentialsFilter !== undefined)
            url_ += "CredentialsFilter=" + encodeURIComponent("" + credentialsFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (maxApproveDateFilter !== undefined)
            url_ += "MaxApproveDateFilter=" + encodeURIComponent(maxApproveDateFilter ? "" + maxApproveDateFilter.toJSON() : "") + "&";
        if (minApproveDateFilter !== undefined)
            url_ += "MinApproveDateFilter=" + encodeURIComponent(minApproveDateFilter ? "" + minApproveDateFilter.toJSON() : "") + "&";
        if (approveByFilter !== undefined)
            url_ += "ApproveByFilter=" + encodeURIComponent("" + approveByFilter) + "&";
        if (reasonFilter !== undefined)
            url_ += "ReasonFilter=" + encodeURIComponent("" + reasonFilter) + "&";
        if (reasonCodeFilter !== undefined)
            url_ += "ReasonCodeFilter=" + encodeURIComponent("" + reasonCodeFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetDeleteProfileRequestForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetDeleteProfileRequestForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetDeleteProfileRequestForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetDeleteProfileRequestForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetDeleteProfileRequestForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetDeleteProfileRequestForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getDeleteProfileRequestForEdit(id: number | null | undefined): Observable<GetDeleteProfileRequestForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/DeleteProfileRequests/GetDeleteProfileRequestForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetDeleteProfileRequestForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDeleteProfileRequestForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetDeleteProfileRequestForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetDeleteProfileRequestForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetDeleteProfileRequestForEdit(response: HttpResponseBase): Observable<GetDeleteProfileRequestForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetDeleteProfileRequestForEditOutput.fromJS(resultData200) : new GetDeleteProfileRequestForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetDeleteProfileRequestForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditDeleteProfileRequestDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DeleteProfileRequests/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DeleteProfileRequests/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    exportDeleteProfileRequestsToExcel(input: GetAllDeleteProfileRequestsForExcelInput | null | undefined): Observable<ConsumerDBFileDto> {
        let url_ = this.baseUrl + "/api/services/app/DeleteProfileRequests/ExportDeleteProfileRequestsToExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processExportDeleteProfileRequestsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportDeleteProfileRequestsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<ConsumerDBFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ConsumerDBFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processExportDeleteProfileRequestsToExcel(response: HttpResponseBase): Observable<ConsumerDBFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? ConsumerDBFileDto.fromJS(resultData200) : new ConsumerDBFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ConsumerDBFileDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    search(input: GetAllDeleteProfileRequestsInput | null | undefined): Observable<PagedResultDtoOfGetDeleteProfileRequestForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/DeleteProfileRequests/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetDeleteProfileRequestForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetDeleteProfileRequestForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<PagedResultDtoOfGetDeleteProfileRequestForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetDeleteProfileRequestForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetDeleteProfileRequestForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetDeleteProfileRequestForViewDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    exportCustom(input: GetAllDeleteProfileRequestsInput | null | undefined): Observable<ConsumerDBFileDto> {
        let url_ = this.baseUrl + "/api/services/app/DeleteProfileRequests/ExportCustom";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processExportCustom(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportCustom(<any>response_);
                } catch (e) {
                    return <Observable<ConsumerDBFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ConsumerDBFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processExportCustom(response: HttpResponseBase): Observable<ConsumerDBFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? ConsumerDBFileDto.fromJS(resultData200) : new ConsumerDBFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ConsumerDBFileDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    reactivateProfile(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DeleteProfileRequests/ReactivateProfile?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processReactivateProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReactivateProfile(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processReactivateProfile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    approveRequest(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DeleteProfileRequests/ApproveRequest?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processApproveRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApproveRequest(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processApproveRequest(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    rejectRequest(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DeleteProfileRequests/RejectRequest?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processRejectRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRejectRequest(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processRejectRequest(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createInactiveUserRequest(input: InactiveDeleteUserRequestDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DeleteProfileRequests/CreateInactiveUserRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateInactiveUserRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateInactiveUserRequest(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateInactiveUserRequest(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createDeleteUserRequest(input: InactiveDeleteUserRequestDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DeleteProfileRequests/CreateDeleteUserRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateDeleteUserRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateDeleteUserRequest(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateDeleteUserRequest(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createInactiveUserRequestForApp(input: InactiveDeleteUserRequestDto | null | undefined): Observable<DeleteUserRequestResponse> {
        let url_ = this.baseUrl + "/api/services/app/DeleteProfileRequests/CreateInactiveUserRequestForApp";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateInactiveUserRequestForApp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateInactiveUserRequestForApp(<any>response_);
                } catch (e) {
                    return <Observable<DeleteUserRequestResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<DeleteUserRequestResponse>><any>_observableThrow(response_);
        }));
    }

    protected processCreateInactiveUserRequestForApp(response: HttpResponseBase): Observable<DeleteUserRequestResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? DeleteUserRequestResponse.fromJS(resultData200) : new DeleteUserRequestResponse();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DeleteUserRequestResponse>(<any>null);
    }
}

@Injectable()
export class DemoUiComponentsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param date (optional) 
     * @return Success
     */
    sendAndGetDate(date: moment.Moment | null | undefined): Observable<DateToStringOutput> {
        let url_ = this.baseUrl + "/api/services/app/DemoUiComponents/SendAndGetDate?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSendAndGetDate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendAndGetDate(<any>response_);
                } catch (e) {
                    return <Observable<DateToStringOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<DateToStringOutput>><any>_observableThrow(response_);
        }));
    }

    protected processSendAndGetDate(response: HttpResponseBase): Observable<DateToStringOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? DateToStringOutput.fromJS(resultData200) : new DateToStringOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DateToStringOutput>(<any>null);
    }

    /**
     * @param date (optional) 
     * @return Success
     */
    sendAndGetDateTime(date: moment.Moment | null | undefined): Observable<DateToStringOutput> {
        let url_ = this.baseUrl + "/api/services/app/DemoUiComponents/SendAndGetDateTime?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSendAndGetDateTime(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendAndGetDateTime(<any>response_);
                } catch (e) {
                    return <Observable<DateToStringOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<DateToStringOutput>><any>_observableThrow(response_);
        }));
    }

    protected processSendAndGetDateTime(response: HttpResponseBase): Observable<DateToStringOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? DateToStringOutput.fromJS(resultData200) : new DateToStringOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DateToStringOutput>(<any>null);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return Success
     */
    sendAndGetDateRange(startDate: moment.Moment | null | undefined, endDate: moment.Moment | null | undefined): Observable<DateToStringOutput> {
        let url_ = this.baseUrl + "/api/services/app/DemoUiComponents/SendAndGetDateRange?";
        if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&";
        if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSendAndGetDateRange(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendAndGetDateRange(<any>response_);
                } catch (e) {
                    return <Observable<DateToStringOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<DateToStringOutput>><any>_observableThrow(response_);
        }));
    }

    protected processSendAndGetDateRange(response: HttpResponseBase): Observable<DateToStringOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? DateToStringOutput.fromJS(resultData200) : new DateToStringOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DateToStringOutput>(<any>null);
    }

    /**
     * @param searchTerm (optional) 
     * @return Success
     */
    getCountries(searchTerm: string | null | undefined): Observable<NameValueOfString[]> {
        let url_ = this.baseUrl + "/api/services/app/DemoUiComponents/GetCountries?";
        if (searchTerm !== undefined)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCountries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCountries(<any>response_);
                } catch (e) {
                    return <Observable<NameValueOfString[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<NameValueOfString[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetCountries(response: HttpResponseBase): Observable<NameValueOfString[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(NameValueOfString.fromJS(item));
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NameValueOfString[]>(<any>null);
    }

    /**
     * @param selectedCountries (optional) 
     * @return Success
     */
    sendAndGetSelectedCountries(selectedCountries: NameValueOfString[] | null | undefined): Observable<NameValueOfString[]> {
        let url_ = this.baseUrl + "/api/services/app/DemoUiComponents/SendAndGetSelectedCountries";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(selectedCountries);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSendAndGetSelectedCountries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendAndGetSelectedCountries(<any>response_);
                } catch (e) {
                    return <Observable<NameValueOfString[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<NameValueOfString[]>><any>_observableThrow(response_);
        }));
    }

    protected processSendAndGetSelectedCountries(response: HttpResponseBase): Observable<NameValueOfString[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(NameValueOfString.fromJS(item));
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NameValueOfString[]>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    sendAndGetValue(input: string | null | undefined): Observable<StringOutput> {
        let url_ = this.baseUrl + "/api/services/app/DemoUiComponents/SendAndGetValue?";
        if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSendAndGetValue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendAndGetValue(<any>response_);
                } catch (e) {
                    return <Observable<StringOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<StringOutput>><any>_observableThrow(response_);
        }));
    }

    protected processSendAndGetValue(response: HttpResponseBase): Observable<StringOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? StringOutput.fromJS(resultData200) : new StringOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StringOutput>(<any>null);
    }
}

@Injectable()
export class DeparmentsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param codeFilter (optional) 
     * @param nameFilter (optional) 
     * @param maxLevelFilter (optional) 
     * @param minLevelFilter (optional) 
     * @param parentCodeFilter (optional) 
     * @param isActiveFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, codeFilter: string | null | undefined, nameFilter: string | null | undefined, maxLevelFilter: number | null | undefined, minLevelFilter: number | null | undefined, parentCodeFilter: string | null | undefined, isActiveFilter: number | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetDeparmentForView> {
        let url_ = this.baseUrl + "/api/services/app/Deparments/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&";
        if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (maxLevelFilter !== undefined)
            url_ += "MaxLevelFilter=" + encodeURIComponent("" + maxLevelFilter) + "&";
        if (minLevelFilter !== undefined)
            url_ += "MinLevelFilter=" + encodeURIComponent("" + minLevelFilter) + "&";
        if (parentCodeFilter !== undefined)
            url_ += "ParentCodeFilter=" + encodeURIComponent("" + parentCodeFilter) + "&";
        if (isActiveFilter !== undefined)
            url_ += "IsActiveFilter=" + encodeURIComponent("" + isActiveFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetDeparmentForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetDeparmentForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetDeparmentForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetDeparmentForView.fromJS(resultData200) : new PagedResultDtoOfGetDeparmentForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetDeparmentForView>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getDeparmentForEdit(id: number | null | undefined): Observable<GetDeparmentForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Deparments/GetDeparmentForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetDeparmentForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDeparmentForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetDeparmentForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetDeparmentForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetDeparmentForEdit(response: HttpResponseBase): Observable<GetDeparmentForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetDeparmentForEditOutput.fromJS(resultData200) : new GetDeparmentForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetDeparmentForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditDeparmentDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Deparments/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Deparments/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param entities (optional) 
     * @return Success
     */
    sync(entities: CreateOrEditDeparmentDto[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Deparments/Sync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entities);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSync(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSync(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param codeFilter (optional) 
     * @param nameFilter (optional) 
     * @param maxLevelFilter (optional) 
     * @param minLevelFilter (optional) 
     * @param parentCodeFilter (optional) 
     * @param isActiveFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllExt(filter: string | null | undefined, codeFilter: string | null | undefined, nameFilter: string | null | undefined, maxLevelFilter: number | null | undefined, minLevelFilter: number | null | undefined, parentCodeFilter: string | null | undefined, isActiveFilter: number | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetDeparmentForView> {
        let url_ = this.baseUrl + "/api/services/app/Deparments/GetAllExt?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&";
        if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (maxLevelFilter !== undefined)
            url_ += "MaxLevelFilter=" + encodeURIComponent("" + maxLevelFilter) + "&";
        if (minLevelFilter !== undefined)
            url_ += "MinLevelFilter=" + encodeURIComponent("" + minLevelFilter) + "&";
        if (parentCodeFilter !== undefined)
            url_ += "ParentCodeFilter=" + encodeURIComponent("" + parentCodeFilter) + "&";
        if (isActiveFilter !== undefined)
            url_ += "IsActiveFilter=" + encodeURIComponent("" + isActiveFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllExt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllExt(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetDeparmentForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetDeparmentForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllExt(response: HttpResponseBase): Observable<PagedResultDtoOfGetDeparmentForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetDeparmentForView.fromJS(resultData200) : new PagedResultDtoOfGetDeparmentForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetDeparmentForView>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEditExt(input: CreateOrEditDeparmentDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Deparments/CreateOrEditExt";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEditExt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditExt(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEditExt(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteExt(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Deparments/DeleteExt?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteExt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteExt(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteExt(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class EditionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getEditions(): Observable<ListResultDtoOfEditionListDto> {
        let url_ = this.baseUrl + "/api/services/app/Edition/GetEditions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetEditions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEditions(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfEditionListDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfEditionListDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetEditions(response: HttpResponseBase): Observable<ListResultDtoOfEditionListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? ListResultDtoOfEditionListDto.fromJS(resultData200) : new ListResultDtoOfEditionListDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfEditionListDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getEditionForEdit(id: number | null | undefined): Observable<GetEditionEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Edition/GetEditionForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetEditionForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEditionForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetEditionEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetEditionEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetEditionForEdit(response: HttpResponseBase): Observable<GetEditionEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetEditionEditOutput.fromJS(resultData200) : new GetEditionEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetEditionEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrUpdateEdition(input: CreateOrUpdateEditionDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Edition/CreateOrUpdateEdition";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrUpdateEdition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateEdition(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrUpdateEdition(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteEdition(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Edition/DeleteEdition?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteEdition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteEdition(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteEdition(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param selectedEditionId (optional) 
     * @param addAllItem (optional) 
     * @param onlyFreeItems (optional) 
     * @return Success
     */
    getEditionComboboxItems(selectedEditionId: number | null | undefined, addAllItem: boolean | null | undefined, onlyFreeItems: boolean | null | undefined): Observable<SubscribableEditionComboboxItemDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Edition/GetEditionComboboxItems?";
        if (selectedEditionId !== undefined)
            url_ += "selectedEditionId=" + encodeURIComponent("" + selectedEditionId) + "&";
        if (addAllItem !== undefined)
            url_ += "addAllItem=" + encodeURIComponent("" + addAllItem) + "&";
        if (onlyFreeItems !== undefined)
            url_ += "onlyFreeItems=" + encodeURIComponent("" + onlyFreeItems) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetEditionComboboxItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEditionComboboxItems(<any>response_);
                } catch (e) {
                    return <Observable<SubscribableEditionComboboxItemDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<SubscribableEditionComboboxItemDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetEditionComboboxItems(response: HttpResponseBase): Observable<SubscribableEditionComboboxItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(SubscribableEditionComboboxItemDto.fromJS(item));
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SubscribableEditionComboboxItemDto[]>(<any>null);
    }
}

@Injectable()
export class EgiftGamesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param codeFilter (optional) 
     * @param maxExpiredDateFilter (optional) 
     * @param minExpiredDateFilter (optional) 
     * @param rewardCodeFilter (optional) 
     * @param statusFilter (optional) 
     * @param usedStatusFilter (optional) 
     * @param serialCodeFilter (optional) 
     * @param maxHistoryIdFilter (optional) 
     * @param minHistoryIdFilter (optional) 
     * @param extraDataFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, codeFilter: string | null | undefined, maxExpiredDateFilter: moment.Moment | null | undefined, minExpiredDateFilter: moment.Moment | null | undefined, rewardCodeFilter: string | null | undefined, statusFilter: string | null | undefined, usedStatusFilter: string | null | undefined, serialCodeFilter: string | null | undefined, maxHistoryIdFilter: number | null | undefined, minHistoryIdFilter: number | null | undefined, extraDataFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetEgiftGameForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/EgiftGames/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&";
        if (maxExpiredDateFilter !== undefined)
            url_ += "MaxExpiredDateFilter=" + encodeURIComponent(maxExpiredDateFilter ? "" + maxExpiredDateFilter.toJSON() : "") + "&";
        if (minExpiredDateFilter !== undefined)
            url_ += "MinExpiredDateFilter=" + encodeURIComponent(minExpiredDateFilter ? "" + minExpiredDateFilter.toJSON() : "") + "&";
        if (rewardCodeFilter !== undefined)
            url_ += "RewardCodeFilter=" + encodeURIComponent("" + rewardCodeFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (usedStatusFilter !== undefined)
            url_ += "UsedStatusFilter=" + encodeURIComponent("" + usedStatusFilter) + "&";
        if (serialCodeFilter !== undefined)
            url_ += "SerialCodeFilter=" + encodeURIComponent("" + serialCodeFilter) + "&";
        if (maxHistoryIdFilter !== undefined)
            url_ += "MaxHistoryIdFilter=" + encodeURIComponent("" + maxHistoryIdFilter) + "&";
        if (minHistoryIdFilter !== undefined)
            url_ += "MinHistoryIdFilter=" + encodeURIComponent("" + minHistoryIdFilter) + "&";
        if (extraDataFilter !== undefined)
            url_ += "ExtraDataFilter=" + encodeURIComponent("" + extraDataFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetEgiftGameForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetEgiftGameForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetEgiftGameForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetEgiftGameForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetEgiftGameForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetEgiftGameForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getEgiftGameForEdit(id: number | null | undefined): Observable<GetEgiftGameForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/EgiftGames/GetEgiftGameForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetEgiftGameForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEgiftGameForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetEgiftGameForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetEgiftGameForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetEgiftGameForEdit(response: HttpResponseBase): Observable<GetEgiftGameForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetEgiftGameForEditOutput.fromJS(resultData200) : new GetEgiftGameForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetEgiftGameForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditEgiftGameDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EgiftGames/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EgiftGames/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param codeFilter (optional) 
     * @param maxExpiredDateFilter (optional) 
     * @param minExpiredDateFilter (optional) 
     * @param rewardCodeFilter (optional) 
     * @param statusFilter (optional) 
     * @param usedStatusFilter (optional) 
     * @param serialCodeFilter (optional) 
     * @param maxHistoryIdFilter (optional) 
     * @param minHistoryIdFilter (optional) 
     * @param extraDataFilter (optional) 
     * @return Success
     */
    getEgiftGamesToExcel(filter: string | null | undefined, codeFilter: string | null | undefined, maxExpiredDateFilter: moment.Moment | null | undefined, minExpiredDateFilter: moment.Moment | null | undefined, rewardCodeFilter: string | null | undefined, statusFilter: string | null | undefined, usedStatusFilter: string | null | undefined, serialCodeFilter: string | null | undefined, maxHistoryIdFilter: number | null | undefined, minHistoryIdFilter: number | null | undefined, extraDataFilter: string | null | undefined): Observable<GamificationFileDto> {
        let url_ = this.baseUrl + "/api/services/app/EgiftGames/GetEgiftGamesToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&";
        if (maxExpiredDateFilter !== undefined)
            url_ += "MaxExpiredDateFilter=" + encodeURIComponent(maxExpiredDateFilter ? "" + maxExpiredDateFilter.toJSON() : "") + "&";
        if (minExpiredDateFilter !== undefined)
            url_ += "MinExpiredDateFilter=" + encodeURIComponent(minExpiredDateFilter ? "" + minExpiredDateFilter.toJSON() : "") + "&";
        if (rewardCodeFilter !== undefined)
            url_ += "RewardCodeFilter=" + encodeURIComponent("" + rewardCodeFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (usedStatusFilter !== undefined)
            url_ += "UsedStatusFilter=" + encodeURIComponent("" + usedStatusFilter) + "&";
        if (serialCodeFilter !== undefined)
            url_ += "SerialCodeFilter=" + encodeURIComponent("" + serialCodeFilter) + "&";
        if (maxHistoryIdFilter !== undefined)
            url_ += "MaxHistoryIdFilter=" + encodeURIComponent("" + maxHistoryIdFilter) + "&";
        if (minHistoryIdFilter !== undefined)
            url_ += "MinHistoryIdFilter=" + encodeURIComponent("" + minHistoryIdFilter) + "&";
        if (extraDataFilter !== undefined)
            url_ += "ExtraDataFilter=" + encodeURIComponent("" + extraDataFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetEgiftGamesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEgiftGamesToExcel(<any>response_);
                } catch (e) {
                    return <Observable<GamificationFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GamificationFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetEgiftGamesToExcel(response: HttpResponseBase): Observable<GamificationFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GamificationFileDto.fromJS(resultData200) : new GamificationFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GamificationFileDto>(<any>null);
    }

    /**
     * @param playHistoryID (optional) 
     * @return Success
     */
    getEGiftDetail(playHistoryID: number | null | undefined): Observable<ERewardDetailDto> {
        let url_ = this.baseUrl + "/api/services/app/EgiftGames/GetEGiftDetail?";
        if (playHistoryID !== undefined)
            url_ += "playHistoryID=" + encodeURIComponent("" + playHistoryID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetEGiftDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEGiftDetail(<any>response_);
                } catch (e) {
                    return <Observable<ERewardDetailDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ERewardDetailDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetEGiftDetail(response: HttpResponseBase): Observable<ERewardDetailDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? ERewardDetailDto.fromJS(resultData200) : new ERewardDetailDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ERewardDetailDto>(<any>null);
    }
}

@Injectable()
export class EgiftGamesExcelExporterServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param egiftGames (optional) 
     * @return Success
     */
    exportToFile(egiftGames: GetEgiftGameForViewDto[] | null | undefined): Observable<GamificationFileDto> {
        let url_ = this.baseUrl + "/api/services/app/EgiftGamesExcelExporter/ExportToFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(egiftGames);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processExportToFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportToFile(<any>response_);
                } catch (e) {
                    return <Observable<GamificationFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GamificationFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processExportToFile(response: HttpResponseBase): Observable<GamificationFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GamificationFileDto.fromJS(resultData200) : new GamificationFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GamificationFileDto>(<any>null);
    }
}

@Injectable()
export class EGiftInforsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param typeFilter (optional) 
     * @param codeFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param statusFilter (optional) 
     * @param usedStatusFilter (optional) 
     * @param maxExpiredDateFilter (optional) 
     * @param minExpiredDateFilter (optional) 
     * @param giftCodeFilter (optional) 
     * @param giftIdFilter (optional) 
     * @param serialCodeFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, typeFilter: string | null | undefined, codeFilter: string | null | undefined, descriptionFilter: string | null | undefined, statusFilter: string | null | undefined, usedStatusFilter: string | null | undefined, maxExpiredDateFilter: moment.Moment | null | undefined, minExpiredDateFilter: moment.Moment | null | undefined, giftCodeFilter: string | null | undefined, giftIdFilter: number | null | undefined, serialCodeFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetEGiftInforForView> {
        let url_ = this.baseUrl + "/api/services/app/EGiftInfors/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (typeFilter !== undefined)
            url_ += "TypeFilter=" + encodeURIComponent("" + typeFilter) + "&";
        if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&";
        if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (usedStatusFilter !== undefined)
            url_ += "UsedStatusFilter=" + encodeURIComponent("" + usedStatusFilter) + "&";
        if (maxExpiredDateFilter !== undefined)
            url_ += "MaxExpiredDateFilter=" + encodeURIComponent(maxExpiredDateFilter ? "" + maxExpiredDateFilter.toJSON() : "") + "&";
        if (minExpiredDateFilter !== undefined)
            url_ += "MinExpiredDateFilter=" + encodeURIComponent(minExpiredDateFilter ? "" + minExpiredDateFilter.toJSON() : "") + "&";
        if (giftCodeFilter !== undefined)
            url_ += "GiftCodeFilter=" + encodeURIComponent("" + giftCodeFilter) + "&";
        if (giftIdFilter !== undefined)
            url_ += "GiftIdFilter=" + encodeURIComponent("" + giftIdFilter) + "&";
        if (serialCodeFilter !== undefined)
            url_ += "SerialCodeFilter=" + encodeURIComponent("" + serialCodeFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetEGiftInforForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetEGiftInforForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetEGiftInforForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetEGiftInforForView.fromJS(resultData200) : new PagedResultDtoOfGetEGiftInforForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetEGiftInforForView>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getEGiftInforForEdit(id: number | null | undefined): Observable<GetEGiftInforForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/EGiftInfors/GetEGiftInforForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetEGiftInforForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEGiftInforForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetEGiftInforForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetEGiftInforForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetEGiftInforForEdit(response: HttpResponseBase): Observable<GetEGiftInforForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetEGiftInforForEditOutput.fromJS(resultData200) : new GetEGiftInforForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetEGiftInforForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditEGiftInforDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EGiftInfors/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EGiftInfors/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    batchDelete(input: number[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EGiftInfors/BatchDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processBatchDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBatchDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processBatchDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllGiftInforForLookupTable(filter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGiftInforLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/EGiftInfors/GetAllGiftInforForLookupTable?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllGiftInforForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllGiftInforForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGiftInforLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGiftInforLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllGiftInforForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfGiftInforLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGiftInforLookupTableDto.fromJS(resultData200) : new PagedResultDtoOfGiftInforLookupTableDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGiftInforLookupTableDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param typeFilter (optional) 
     * @param codeFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param statusFilter (optional) 
     * @param usedStatusFilter (optional) 
     * @param maxExpiredDateFilter (optional) 
     * @param minExpiredDateFilter (optional) 
     * @param giftCodeFilter (optional) 
     * @param giftIdFilter (optional) 
     * @param isGetData (optional) 
     * @param serialCodeFilter (optional) 
     * @return Success
     */
    getEgiftToExcel(filter: string | null | undefined, typeFilter: string | null | undefined, codeFilter: string | null | undefined, descriptionFilter: string | null | undefined, statusFilter: string | null | undefined, usedStatusFilter: string | null | undefined, maxExpiredDateFilter: moment.Moment | null | undefined, minExpiredDateFilter: moment.Moment | null | undefined, giftCodeFilter: string | null | undefined, giftIdFilter: number | null | undefined, isGetData: boolean | null | undefined, serialCodeFilter: string | null | undefined): Observable<PointFileDto> {
        let url_ = this.baseUrl + "/api/services/app/EGiftInfors/GetEgiftToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (typeFilter !== undefined)
            url_ += "TypeFilter=" + encodeURIComponent("" + typeFilter) + "&";
        if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&";
        if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (usedStatusFilter !== undefined)
            url_ += "UsedStatusFilter=" + encodeURIComponent("" + usedStatusFilter) + "&";
        if (maxExpiredDateFilter !== undefined)
            url_ += "MaxExpiredDateFilter=" + encodeURIComponent(maxExpiredDateFilter ? "" + maxExpiredDateFilter.toJSON() : "") + "&";
        if (minExpiredDateFilter !== undefined)
            url_ += "MinExpiredDateFilter=" + encodeURIComponent(minExpiredDateFilter ? "" + minExpiredDateFilter.toJSON() : "") + "&";
        if (giftCodeFilter !== undefined)
            url_ += "GiftCodeFilter=" + encodeURIComponent("" + giftCodeFilter) + "&";
        if (giftIdFilter !== undefined)
            url_ += "GiftIdFilter=" + encodeURIComponent("" + giftIdFilter) + "&";
        if (isGetData !== undefined)
            url_ += "IsGetData=" + encodeURIComponent("" + isGetData) + "&";
        if (serialCodeFilter !== undefined)
            url_ += "SerialCodeFilter=" + encodeURIComponent("" + serialCodeFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetEgiftToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEgiftToExcel(<any>response_);
                } catch (e) {
                    return <Observable<PointFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PointFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetEgiftToExcel(response: HttpResponseBase): Observable<PointFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PointFileDto.fromJS(resultData200) : new PointFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PointFileDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param typeFilter (optional) 
     * @param codeFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param statusFilter (optional) 
     * @param usedStatusFilter (optional) 
     * @param maxExpiredDateFilter (optional) 
     * @param minExpiredDateFilter (optional) 
     * @param giftCodeFilter (optional) 
     * @param giftIdFilter (optional) 
     * @param serialCodeFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllExt(filter: string | null | undefined, typeFilter: string | null | undefined, codeFilter: string | null | undefined, descriptionFilter: string | null | undefined, statusFilter: string | null | undefined, usedStatusFilter: string | null | undefined, maxExpiredDateFilter: moment.Moment | null | undefined, minExpiredDateFilter: moment.Moment | null | undefined, giftCodeFilter: string | null | undefined, giftIdFilter: number | null | undefined, serialCodeFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetEGiftInforForView> {
        let url_ = this.baseUrl + "/api/services/app/EGiftInfors/GetAllExt?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (typeFilter !== undefined)
            url_ += "TypeFilter=" + encodeURIComponent("" + typeFilter) + "&";
        if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&";
        if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (usedStatusFilter !== undefined)
            url_ += "UsedStatusFilter=" + encodeURIComponent("" + usedStatusFilter) + "&";
        if (maxExpiredDateFilter !== undefined)
            url_ += "MaxExpiredDateFilter=" + encodeURIComponent(maxExpiredDateFilter ? "" + maxExpiredDateFilter.toJSON() : "") + "&";
        if (minExpiredDateFilter !== undefined)
            url_ += "MinExpiredDateFilter=" + encodeURIComponent(minExpiredDateFilter ? "" + minExpiredDateFilter.toJSON() : "") + "&";
        if (giftCodeFilter !== undefined)
            url_ += "GiftCodeFilter=" + encodeURIComponent("" + giftCodeFilter) + "&";
        if (giftIdFilter !== undefined)
            url_ += "GiftIdFilter=" + encodeURIComponent("" + giftIdFilter) + "&";
        if (serialCodeFilter !== undefined)
            url_ += "SerialCodeFilter=" + encodeURIComponent("" + serialCodeFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllExt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllExt(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetEGiftInforForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetEGiftInforForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllExt(response: HttpResponseBase): Observable<PagedResultDtoOfGetEGiftInforForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetEGiftInforForView.fromJS(resultData200) : new PagedResultDtoOfGetEGiftInforForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetEGiftInforForView>(<any>null);
    }

    /**
     * @param egiftId (optional) 
     * @return Success
     */
    updateEgiftUsedStatus(egiftId: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EGiftInfors/UpdateEgiftUsedStatus?";
        if (egiftId !== undefined)
            url_ += "egiftId=" + encodeURIComponent("" + egiftId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateEgiftUsedStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateEgiftUsedStatus(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateEgiftUsedStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class EmailTemplatesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param titleFilter (optional) 
     * @param bodyFilter (optional) 
     * @param previewFilter (optional) 
     * @param communicationNameFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, titleFilter: string | null | undefined, bodyFilter: string | null | undefined, previewFilter: string | null | undefined, communicationNameFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetEmailTemplateForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/EmailTemplates/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (titleFilter !== undefined)
            url_ += "TitleFilter=" + encodeURIComponent("" + titleFilter) + "&";
        if (bodyFilter !== undefined)
            url_ += "BodyFilter=" + encodeURIComponent("" + bodyFilter) + "&";
        if (previewFilter !== undefined)
            url_ += "PreviewFilter=" + encodeURIComponent("" + previewFilter) + "&";
        if (communicationNameFilter !== undefined)
            url_ += "CommunicationNameFilter=" + encodeURIComponent("" + communicationNameFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetEmailTemplateForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetEmailTemplateForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetEmailTemplateForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetEmailTemplateForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetEmailTemplateForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetEmailTemplateForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getEmailTemplateForEdit(id: number | null | undefined): Observable<GetEmailTemplateForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/EmailTemplates/GetEmailTemplateForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetEmailTemplateForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmailTemplateForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetEmailTemplateForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetEmailTemplateForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetEmailTemplateForEdit(response: HttpResponseBase): Observable<GetEmailTemplateForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetEmailTemplateForEditOutput.fromJS(resultData200) : new GetEmailTemplateForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetEmailTemplateForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditEmailTemplateDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EmailTemplates/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EmailTemplates/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param titleFilter (optional) 
     * @param bodyFilter (optional) 
     * @param previewFilter (optional) 
     * @param communicationNameFilter (optional) 
     * @return Success
     */
    getEmailTemplatesToExcel(filter: string | null | undefined, titleFilter: string | null | undefined, bodyFilter: string | null | undefined, previewFilter: string | null | undefined, communicationNameFilter: string | null | undefined): Observable<CommunicationsFileDto> {
        let url_ = this.baseUrl + "/api/services/app/EmailTemplates/GetEmailTemplatesToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (titleFilter !== undefined)
            url_ += "TitleFilter=" + encodeURIComponent("" + titleFilter) + "&";
        if (bodyFilter !== undefined)
            url_ += "BodyFilter=" + encodeURIComponent("" + bodyFilter) + "&";
        if (previewFilter !== undefined)
            url_ += "PreviewFilter=" + encodeURIComponent("" + previewFilter) + "&";
        if (communicationNameFilter !== undefined)
            url_ += "CommunicationNameFilter=" + encodeURIComponent("" + communicationNameFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetEmailTemplatesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmailTemplatesToExcel(<any>response_);
                } catch (e) {
                    return <Observable<CommunicationsFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CommunicationsFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetEmailTemplatesToExcel(response: HttpResponseBase): Observable<CommunicationsFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? CommunicationsFileDto.fromJS(resultData200) : new CommunicationsFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CommunicationsFileDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllCommunicationForLookupTable(filter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfCommunicationLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/EmailTemplates/GetAllCommunicationForLookupTable?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllCommunicationForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCommunicationForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfCommunicationLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfCommunicationLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllCommunicationForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfCommunicationLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfCommunicationLookupTableDto.fromJS(resultData200) : new PagedResultDtoOfCommunicationLookupTableDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfCommunicationLookupTableDto>(<any>null);
    }
}

@Injectable()
export class EventAmountSettingsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetEventAmountSettingForView> {
        let url_ = this.baseUrl + "/api/services/app/EventAmountSettings/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetEventAmountSettingForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetEventAmountSettingForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetEventAmountSettingForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetEventAmountSettingForView.fromJS(resultData200) : new PagedResultDtoOfGetEventAmountSettingForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetEventAmountSettingForView>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getEventAmountSettingForEdit(id: number | null | undefined): Observable<GetEventAmountSettingForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/EventAmountSettings/GetEventAmountSettingForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetEventAmountSettingForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEventAmountSettingForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetEventAmountSettingForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetEventAmountSettingForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetEventAmountSettingForEdit(response: HttpResponseBase): Observable<GetEventAmountSettingForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetEventAmountSettingForEditOutput.fromJS(resultData200) : new GetEventAmountSettingForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetEventAmountSettingForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditEventAmountSettingDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EventAmountSettings/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EventAmountSettings/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class EventSettingsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param codeFilter (optional) 
     * @param nameFilter (optional) 
     * @param maxEffectiveFromFilter (optional) 
     * @param minEffectiveFromFilter (optional) 
     * @param maxEffectiveToFilter (optional) 
     * @param minEffectiveToFilter (optional) 
     * @param isActiveFilter (optional) 
     * @param targetAudienceFilter (optional) 
     * @param campaignFilter (optional) 
     * @param campaignId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, codeFilter: string | null | undefined, nameFilter: string | null | undefined, maxEffectiveFromFilter: moment.Moment | null | undefined, minEffectiveFromFilter: moment.Moment | null | undefined, maxEffectiveToFilter: moment.Moment | null | undefined, minEffectiveToFilter: moment.Moment | null | undefined, isActiveFilter: number | null | undefined, targetAudienceFilter: string | null | undefined, campaignFilter: string | null | undefined, campaignId: number | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetEventSettingForView> {
        let url_ = this.baseUrl + "/api/services/app/EventSettings/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&";
        if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (maxEffectiveFromFilter !== undefined)
            url_ += "MaxEffectiveFromFilter=" + encodeURIComponent(maxEffectiveFromFilter ? "" + maxEffectiveFromFilter.toJSON() : "") + "&";
        if (minEffectiveFromFilter !== undefined)
            url_ += "MinEffectiveFromFilter=" + encodeURIComponent(minEffectiveFromFilter ? "" + minEffectiveFromFilter.toJSON() : "") + "&";
        if (maxEffectiveToFilter !== undefined)
            url_ += "MaxEffectiveToFilter=" + encodeURIComponent(maxEffectiveToFilter ? "" + maxEffectiveToFilter.toJSON() : "") + "&";
        if (minEffectiveToFilter !== undefined)
            url_ += "MinEffectiveToFilter=" + encodeURIComponent(minEffectiveToFilter ? "" + minEffectiveToFilter.toJSON() : "") + "&";
        if (isActiveFilter !== undefined)
            url_ += "IsActiveFilter=" + encodeURIComponent("" + isActiveFilter) + "&";
        if (targetAudienceFilter !== undefined)
            url_ += "TargetAudienceFilter=" + encodeURIComponent("" + targetAudienceFilter) + "&";
        if (campaignFilter !== undefined)
            url_ += "CampaignFilter=" + encodeURIComponent("" + campaignFilter) + "&";
        if (campaignId !== undefined)
            url_ += "CampaignId=" + encodeURIComponent("" + campaignId) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetEventSettingForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetEventSettingForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetEventSettingForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetEventSettingForView.fromJS(resultData200) : new PagedResultDtoOfGetEventSettingForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetEventSettingForView>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditEventSettingDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EventSettings/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EventSettings/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getEventSettingForEdit(id: number | null | undefined): Observable<GetEventSettingForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/EventSettings/GetEventSettingForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetEventSettingForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEventSettingForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetEventSettingForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetEventSettingForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetEventSettingForEdit(response: HttpResponseBase): Observable<GetEventSettingForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetEventSettingForEditOutput.fromJS(resultData200) : new GetEventSettingForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetEventSettingForEditOutput>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param codeFilter (optional) 
     * @param nameFilter (optional) 
     * @param maxEffectiveFromFilter (optional) 
     * @param minEffectiveFromFilter (optional) 
     * @param maxEffectiveToFilter (optional) 
     * @param minEffectiveToFilter (optional) 
     * @param isActiveFilter (optional) 
     * @param targetAudienceFilter (optional) 
     * @param campaignFilter (optional) 
     * @param campaignId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllCustom(filter: string | null | undefined, codeFilter: string | null | undefined, nameFilter: string | null | undefined, maxEffectiveFromFilter: moment.Moment | null | undefined, minEffectiveFromFilter: moment.Moment | null | undefined, maxEffectiveToFilter: moment.Moment | null | undefined, minEffectiveToFilter: moment.Moment | null | undefined, isActiveFilter: number | null | undefined, targetAudienceFilter: string | null | undefined, campaignFilter: string | null | undefined, campaignId: number | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<ListResultDtoOfEventSettingDto> {
        let url_ = this.baseUrl + "/api/services/app/EventSettings/GetAllCustom?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&";
        if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (maxEffectiveFromFilter !== undefined)
            url_ += "MaxEffectiveFromFilter=" + encodeURIComponent(maxEffectiveFromFilter ? "" + maxEffectiveFromFilter.toJSON() : "") + "&";
        if (minEffectiveFromFilter !== undefined)
            url_ += "MinEffectiveFromFilter=" + encodeURIComponent(minEffectiveFromFilter ? "" + minEffectiveFromFilter.toJSON() : "") + "&";
        if (maxEffectiveToFilter !== undefined)
            url_ += "MaxEffectiveToFilter=" + encodeURIComponent(maxEffectiveToFilter ? "" + maxEffectiveToFilter.toJSON() : "") + "&";
        if (minEffectiveToFilter !== undefined)
            url_ += "MinEffectiveToFilter=" + encodeURIComponent(minEffectiveToFilter ? "" + minEffectiveToFilter.toJSON() : "") + "&";
        if (isActiveFilter !== undefined)
            url_ += "IsActiveFilter=" + encodeURIComponent("" + isActiveFilter) + "&";
        if (targetAudienceFilter !== undefined)
            url_ += "TargetAudienceFilter=" + encodeURIComponent("" + targetAudienceFilter) + "&";
        if (campaignFilter !== undefined)
            url_ += "CampaignFilter=" + encodeURIComponent("" + campaignFilter) + "&";
        if (campaignId !== undefined)
            url_ += "CampaignId=" + encodeURIComponent("" + campaignId) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllCustom(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCustom(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfEventSettingDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfEventSettingDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllCustom(response: HttpResponseBase): Observable<ListResultDtoOfEventSettingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? ListResultDtoOfEventSettingDto.fromJS(resultData200) : new ListResultDtoOfEventSettingDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfEventSettingDto>(<any>null);
    }

    /**
     * @param code (optional) 
     * @return Success
     */
    getEventSettingByCode(code: string | null | undefined): Observable<GetEventSettingForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/EventSettings/GetEventSettingByCode?";
        if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetEventSettingByCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEventSettingByCode(<any>response_);
                } catch (e) {
                    return <Observable<GetEventSettingForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetEventSettingForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetEventSettingByCode(response: HttpResponseBase): Observable<GetEventSettingForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetEventSettingForEditOutput.fromJS(resultData200) : new GetEventSettingForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetEventSettingForEditOutput>(<any>null);
    }
}

@Injectable()
export class EventSubscriptionDetailsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param maxEventTemplateIDFilter (optional) 
     * @param minEventTemplateIDFilter (optional) 
     * @param eventTemplateGroupFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, maxEventTemplateIDFilter: number | null | undefined, minEventTemplateIDFilter: number | null | undefined, eventTemplateGroupFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetEventSubscriptionDetailForView> {
        let url_ = this.baseUrl + "/api/services/app/EventSubscriptionDetails/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxEventTemplateIDFilter !== undefined)
            url_ += "MaxEventTemplateIDFilter=" + encodeURIComponent("" + maxEventTemplateIDFilter) + "&";
        if (minEventTemplateIDFilter !== undefined)
            url_ += "MinEventTemplateIDFilter=" + encodeURIComponent("" + minEventTemplateIDFilter) + "&";
        if (eventTemplateGroupFilter !== undefined)
            url_ += "EventTemplateGroupFilter=" + encodeURIComponent("" + eventTemplateGroupFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetEventSubscriptionDetailForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetEventSubscriptionDetailForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetEventSubscriptionDetailForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetEventSubscriptionDetailForView.fromJS(resultData200) : new PagedResultDtoOfGetEventSubscriptionDetailForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetEventSubscriptionDetailForView>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getEventSubscriptionDetailForEdit(id: number | null | undefined): Observable<GetEventSubscriptionDetailForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/EventSubscriptionDetails/GetEventSubscriptionDetailForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetEventSubscriptionDetailForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEventSubscriptionDetailForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetEventSubscriptionDetailForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetEventSubscriptionDetailForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetEventSubscriptionDetailForEdit(response: HttpResponseBase): Observable<GetEventSubscriptionDetailForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetEventSubscriptionDetailForEditOutput.fromJS(resultData200) : new GetEventSubscriptionDetailForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetEventSubscriptionDetailForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditEventSubscriptionDetailDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EventSubscriptionDetails/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EventSubscriptionDetails/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEditEventSubscriptionDetail(input: CreateOrEditEventSubscriptionDetailDto[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EventSubscriptionDetails/CreateOrEditEventSubscriptionDetail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEditEventSubscriptionDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditEventSubscriptionDetail(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEditEventSubscriptionDetail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    getAllNoPaging(): Observable<CreateOrEditEventSubscriptionDetailDto[]> {
        let url_ = this.baseUrl + "/api/services/app/EventSubscriptionDetails/GetAllNoPaging";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllNoPaging(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllNoPaging(<any>response_);
                } catch (e) {
                    return <Observable<CreateOrEditEventSubscriptionDetailDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<CreateOrEditEventSubscriptionDetailDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllNoPaging(response: HttpResponseBase): Observable<CreateOrEditEventSubscriptionDetailDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(CreateOrEditEventSubscriptionDetailDto.fromJS(item));
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateOrEditEventSubscriptionDetailDto[]>(<any>null);
    }
}

@Injectable()
export class EventSubscriptionHeadersServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param isActiveFilter (optional) 
     * @param secretKeyFilter (optional) 
     * @param uRLFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param settingParamCodeFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, isActiveFilter: number | null | undefined, secretKeyFilter: string | null | undefined, uRLFilter: string | null | undefined, descriptionFilter: string | null | undefined, settingParamCodeFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetEventSubscriptionHeaderForView> {
        let url_ = this.baseUrl + "/api/services/app/EventSubscriptionHeaders/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (isActiveFilter !== undefined)
            url_ += "IsActiveFilter=" + encodeURIComponent("" + isActiveFilter) + "&";
        if (secretKeyFilter !== undefined)
            url_ += "SecretKeyFilter=" + encodeURIComponent("" + secretKeyFilter) + "&";
        if (uRLFilter !== undefined)
            url_ += "URLFilter=" + encodeURIComponent("" + uRLFilter) + "&";
        if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&";
        if (settingParamCodeFilter !== undefined)
            url_ += "SettingParamCodeFilter=" + encodeURIComponent("" + settingParamCodeFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetEventSubscriptionHeaderForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetEventSubscriptionHeaderForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetEventSubscriptionHeaderForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetEventSubscriptionHeaderForView.fromJS(resultData200) : new PagedResultDtoOfGetEventSubscriptionHeaderForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetEventSubscriptionHeaderForView>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getEventSubscriptionHeaderForEdit(id: number | null | undefined): Observable<GetEventSubscriptionHeaderForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/EventSubscriptionHeaders/GetEventSubscriptionHeaderForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetEventSubscriptionHeaderForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEventSubscriptionHeaderForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetEventSubscriptionHeaderForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetEventSubscriptionHeaderForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetEventSubscriptionHeaderForEdit(response: HttpResponseBase): Observable<GetEventSubscriptionHeaderForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetEventSubscriptionHeaderForEditOutput.fromJS(resultData200) : new GetEventSubscriptionHeaderForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetEventSubscriptionHeaderForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditEventSubscriptionHeaderDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EventSubscriptionHeaders/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EventSubscriptionHeaders/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllSettingParamForLookupTable(filter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfSettingParamLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/EventSubscriptionHeaders/GetAllSettingParamForLookupTable?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllSettingParamForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSettingParamForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfSettingParamLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfSettingParamLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllSettingParamForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfSettingParamLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfSettingParamLookupTableDto.fromJS(resultData200) : new PagedResultDtoOfSettingParamLookupTableDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfSettingParamLookupTableDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param maxEventTemplateIDFilter (optional) 
     * @param minEventTemplateIDFilter (optional) 
     * @param eventTemplateGroupFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllWebHook(filter: string | null | undefined, maxEventTemplateIDFilter: number | null | undefined, minEventTemplateIDFilter: number | null | undefined, eventTemplateGroupFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetEventSubscriptionDetailForView> {
        let url_ = this.baseUrl + "/api/services/app/EventSubscriptionHeaders/GetAllWebHook?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxEventTemplateIDFilter !== undefined)
            url_ += "MaxEventTemplateIDFilter=" + encodeURIComponent("" + maxEventTemplateIDFilter) + "&";
        if (minEventTemplateIDFilter !== undefined)
            url_ += "MinEventTemplateIDFilter=" + encodeURIComponent("" + minEventTemplateIDFilter) + "&";
        if (eventTemplateGroupFilter !== undefined)
            url_ += "EventTemplateGroupFilter=" + encodeURIComponent("" + eventTemplateGroupFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllWebHook(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllWebHook(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetEventSubscriptionDetailForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetEventSubscriptionDetailForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllWebHook(response: HttpResponseBase): Observable<PagedResultDtoOfGetEventSubscriptionDetailForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetEventSubscriptionDetailForView.fromJS(resultData200) : new PagedResultDtoOfGetEventSubscriptionDetailForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetEventSubscriptionDetailForView>(<any>null);
    }

    /**
     * @return Success
     */
    getEventSubscriptionHeader(): Observable<GetEventSubscriptionHeaderForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/EventSubscriptionHeaders/GetEventSubscriptionHeader";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetEventSubscriptionHeader(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEventSubscriptionHeader(<any>response_);
                } catch (e) {
                    return <Observable<GetEventSubscriptionHeaderForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetEventSubscriptionHeaderForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetEventSubscriptionHeader(response: HttpResponseBase): Observable<GetEventSubscriptionHeaderForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetEventSubscriptionHeaderForEditOutput.fromJS(resultData200) : new GetEventSubscriptionHeaderForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetEventSubscriptionHeaderForEditOutput>(<any>null);
    }
}

@Injectable()
export class ExportCsvServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param tenantId (optional) 
     * @param interfaceName (optional) 
     * @return Success
     */
    exportCSVAsync(tenantId: number | null | undefined, interfaceName: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/ExportCsv/ExportCSVAsync?";
        if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (interfaceName !== undefined)
            url_ += "interfaceName=" + encodeURIComponent("" + interfaceName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processExportCSVAsync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportCSVAsync(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processExportCSVAsync(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }
}

@Injectable()
export class ExtendActiveSerialServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param serial (optional) 
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(serial: string | null | undefined, fromDate: moment.Moment | null | undefined, toDate: moment.Moment | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfExtendActiveSerialDto> {
        let url_ = this.baseUrl + "/api/services/app/ExtendActiveSerial/GetAll?";
        if (serial !== undefined)
            url_ += "Serial=" + encodeURIComponent("" + serial) + "&";
        if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toJSON() : "") + "&";
        if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toJSON() : "") + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfExtendActiveSerialDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfExtendActiveSerialDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfExtendActiveSerialDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfExtendActiveSerialDto.fromJS(resultData200) : new PagedResultDtoOfExtendActiveSerialDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfExtendActiveSerialDto>(<any>null);
    }

    /**
     * @param arg (optional) 
     * @return Success
     */
    importQueue(arg: CommonImportAgrs | null | undefined): Observable<StatusImportDistributeDto> {
        let url_ = this.baseUrl + "/api/services/app/ExtendActiveSerial/ImportQueue";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(arg);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processImportQueue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportQueue(<any>response_);
                } catch (e) {
                    return <Observable<StatusImportDistributeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<StatusImportDistributeDto>><any>_observableThrow(response_);
        }));
    }

    protected processImportQueue(response: HttpResponseBase): Observable<StatusImportDistributeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? StatusImportDistributeDto.fromJS(resultData200) : new StatusImportDistributeDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StatusImportDistributeDto>(<any>null);
    }
}

@Injectable()
export class FAQServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param codeFilter (optional) 
     * @param questionFilter (optional) 
     * @param answerFilter (optional) 
     * @param maxOrdinalFilter (optional) 
     * @param minOrdinalFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, codeFilter: string | null | undefined, questionFilter: string | null | undefined, answerFilter: string | null | undefined, maxOrdinalFilter: number | null | undefined, minOrdinalFilter: number | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetFAQForView> {
        let url_ = this.baseUrl + "/api/services/app/FAQ/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&";
        if (questionFilter !== undefined)
            url_ += "QuestionFilter=" + encodeURIComponent("" + questionFilter) + "&";
        if (answerFilter !== undefined)
            url_ += "AnswerFilter=" + encodeURIComponent("" + answerFilter) + "&";
        if (maxOrdinalFilter !== undefined)
            url_ += "MaxOrdinalFilter=" + encodeURIComponent("" + maxOrdinalFilter) + "&";
        if (minOrdinalFilter !== undefined)
            url_ += "MinOrdinalFilter=" + encodeURIComponent("" + minOrdinalFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetFAQForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetFAQForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetFAQForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetFAQForView.fromJS(resultData200) : new PagedResultDtoOfGetFAQForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetFAQForView>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getFAQForEdit(id: number | null | undefined): Observable<GetFAQForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/FAQ/GetFAQForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetFAQForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFAQForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetFAQForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetFAQForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetFAQForEdit(response: HttpResponseBase): Observable<GetFAQForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetFAQForEditOutput.fromJS(resultData200) : new GetFAQForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetFAQForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditFAQDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/FAQ/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/FAQ/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    batchDelete(input: number[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/FAQ/BatchDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processBatchDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBatchDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processBatchDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class FileServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param file (optional) 
     * @param folderName (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    upload(file: any | null | undefined, folderName: string | null | undefined, tenantId: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/File/Upload?";
        if (file !== undefined)
            url_ += "file=" + encodeURIComponent("" + file) + "&";
        if (folderName !== undefined)
            url_ += "folderName=" + encodeURIComponent("" + folderName) + "&";
        if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpload(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpload(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param file (optional) 
     * @param folderName (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    uploadImage(file: any | null | undefined, folderName: string | null | undefined, tenantId: number | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/File/UploadImage?";
        if (file !== undefined)
            url_ += "file=" + encodeURIComponent("" + file) + "&";
        if (folderName !== undefined)
            url_ += "folderName=" + encodeURIComponent("" + folderName) + "&";
        if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUploadImage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadImage(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processUploadImage(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }
}

@Injectable()
export class FormulaSettingsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param codeFilter (optional) 
     * @param isActiveFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, codeFilter: string | null | undefined, isActiveFilter: number | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetFormulaSettingForView> {
        let url_ = this.baseUrl + "/api/services/app/FormulaSettings/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&";
        if (isActiveFilter !== undefined)
            url_ += "IsActiveFilter=" + encodeURIComponent("" + isActiveFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetFormulaSettingForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetFormulaSettingForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetFormulaSettingForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetFormulaSettingForView.fromJS(resultData200) : new PagedResultDtoOfGetFormulaSettingForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetFormulaSettingForView>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getFormulaSettingForEdit(id: number | null | undefined): Observable<GetFormulaSettingForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/FormulaSettings/GetFormulaSettingForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetFormulaSettingForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFormulaSettingForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetFormulaSettingForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetFormulaSettingForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetFormulaSettingForEdit(response: HttpResponseBase): Observable<GetFormulaSettingForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetFormulaSettingForEditOutput.fromJS(resultData200) : new GetFormulaSettingForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetFormulaSettingForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditFormulaSettingDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/FormulaSettings/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/FormulaSettings/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrentFormulaSetting(): Observable<GetFormulaSettingForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/FormulaSettings/GetCurrentFormulaSetting";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCurrentFormulaSetting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentFormulaSetting(<any>response_);
                } catch (e) {
                    return <Observable<GetFormulaSettingForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetFormulaSettingForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetCurrentFormulaSetting(response: HttpResponseBase): Observable<GetFormulaSettingForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetFormulaSettingForEditOutput.fromJS(resultData200) : new GetFormulaSettingForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetFormulaSettingForEditOutput>(<any>null);
    }
}

@Injectable()
export class FriendshipServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createFriendshipRequest(input: CreateFriendshipRequestInput | null | undefined): Observable<FriendDto> {
        let url_ = this.baseUrl + "/api/services/app/Friendship/CreateFriendshipRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateFriendshipRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateFriendshipRequest(<any>response_);
                } catch (e) {
                    return <Observable<FriendDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FriendDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreateFriendshipRequest(response: HttpResponseBase): Observable<FriendDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? FriendDto.fromJS(resultData200) : new FriendDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FriendDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createFriendshipRequestByUserName(input: CreateFriendshipRequestByUserNameInput | null | undefined): Observable<FriendDto> {
        let url_ = this.baseUrl + "/api/services/app/Friendship/CreateFriendshipRequestByUserName";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateFriendshipRequestByUserName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateFriendshipRequestByUserName(<any>response_);
                } catch (e) {
                    return <Observable<FriendDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FriendDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreateFriendshipRequestByUserName(response: HttpResponseBase): Observable<FriendDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? FriendDto.fromJS(resultData200) : new FriendDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FriendDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    blockUser(input: BlockUserInput | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Friendship/BlockUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processBlockUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBlockUser(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processBlockUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    unblockUser(input: UnblockUserInput | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Friendship/UnblockUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUnblockUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnblockUser(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUnblockUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    acceptFriendshipRequest(input: AcceptFriendshipRequestInput | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Friendship/AcceptFriendshipRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processAcceptFriendshipRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAcceptFriendshipRequest(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processAcceptFriendshipRequest(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class GameServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    insertGameInfor(input: GameGotItArgs | null | undefined): Observable<GameInfor> {
        let url_ = this.baseUrl + "/api/services/app/Game/InsertGameInfor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processInsertGameInfor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInsertGameInfor(<any>response_);
                } catch (e) {
                    return <Observable<GameInfor>><any>_observableThrow(e);
                }
            } else
                return <Observable<GameInfor>><any>_observableThrow(response_);
        }));
    }

    protected processInsertGameInfor(response: HttpResponseBase): Observable<GameInfor> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GameInfor.fromJS(resultData200) : new GameInfor();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GameInfor>(<any>null);
    }

    /**
     * @param rowToHandle (optional) 
     * @return Success
     */
    verifyGameInfor(rowToHandle: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Game/VerifyGameInfor?";
        if (rowToHandle !== undefined)
            url_ += "rowToHandle=" + encodeURIComponent("" + rowToHandle) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processVerifyGameInfor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerifyGameInfor(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processVerifyGameInfor(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param init (optional) 
     * @return Success
     */
    initGame(init: InitGameDto | null | undefined): Observable<GameGotItIssueOutput> {
        let url_ = this.baseUrl + "/api/services/app/Game/InitGame";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(init);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processInitGame(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInitGame(<any>response_);
                } catch (e) {
                    return <Observable<GameGotItIssueOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GameGotItIssueOutput>><any>_observableThrow(response_);
        }));
    }

    protected processInitGame(response: HttpResponseBase): Observable<GameGotItIssueOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GameGotItIssueOutput.fromJS(resultData200) : new GameGotItIssueOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GameGotItIssueOutput>(<any>null);
    }

    /**
     * @param phone (optional) 
     * @param campaign (optional) 
     * @return Success
     */
    check(phone: string | null | undefined, campaign: string | null | undefined): Observable<GameGotItCheckOutput> {
        let url_ = this.baseUrl + "/api/services/app/Game/Check?";
        if (phone !== undefined)
            url_ += "phone=" + encodeURIComponent("" + phone) + "&";
        if (campaign !== undefined)
            url_ += "campaign=" + encodeURIComponent("" + campaign) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCheck(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheck(<any>response_);
                } catch (e) {
                    return <Observable<GameGotItCheckOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GameGotItCheckOutput>><any>_observableThrow(response_);
        }));
    }

    protected processCheck(response: HttpResponseBase): Observable<GameGotItCheckOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GameGotItCheckOutput.fromJS(resultData200) : new GameGotItCheckOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GameGotItCheckOutput>(<any>null);
    }
}

@Injectable()
export class GameInforsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param campaignIDFilter (optional) 
     * @param campaignNameFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param outletCodeFilter (optional) 
     * @param zaloChatIDFilter (optional) 
     * @param memberCodeFilter (optional) 
     * @param phoneFilter (optional) 
     * @param maxQuantityFilter (optional) 
     * @param minQuantityFilter (optional) 
     * @param maxUsedFilter (optional) 
     * @param minUsedFilter (optional) 
     * @param maxRemainFilter (optional) 
     * @param minRemainFilter (optional) 
     * @param linkFilter (optional) 
     * @param maxFromDateFilter (optional) 
     * @param minFromDateFilter (optional) 
     * @param maxToDateFilter (optional) 
     * @param minToDateFilter (optional) 
     * @param promotionMasterCodeFilter (optional) 
     * @param promotionCodeFilter (optional) 
     * @param statusFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, campaignIDFilter: string | null | undefined, campaignNameFilter: string | null | undefined, descriptionFilter: string | null | undefined, outletCodeFilter: string | null | undefined, zaloChatIDFilter: string | null | undefined, memberCodeFilter: string | null | undefined, phoneFilter: string | null | undefined, maxQuantityFilter: number | null | undefined, minQuantityFilter: number | null | undefined, maxUsedFilter: number | null | undefined, minUsedFilter: number | null | undefined, maxRemainFilter: number | null | undefined, minRemainFilter: number | null | undefined, linkFilter: string | null | undefined, maxFromDateFilter: moment.Moment | null | undefined, minFromDateFilter: moment.Moment | null | undefined, maxToDateFilter: moment.Moment | null | undefined, minToDateFilter: moment.Moment | null | undefined, promotionMasterCodeFilter: string | null | undefined, promotionCodeFilter: string | null | undefined, statusFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetGameInforForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/GameInfors/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (campaignIDFilter !== undefined)
            url_ += "CampaignIDFilter=" + encodeURIComponent("" + campaignIDFilter) + "&";
        if (campaignNameFilter !== undefined)
            url_ += "CampaignNameFilter=" + encodeURIComponent("" + campaignNameFilter) + "&";
        if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&";
        if (outletCodeFilter !== undefined)
            url_ += "OutletCodeFilter=" + encodeURIComponent("" + outletCodeFilter) + "&";
        if (zaloChatIDFilter !== undefined)
            url_ += "ZaloChatIDFilter=" + encodeURIComponent("" + zaloChatIDFilter) + "&";
        if (memberCodeFilter !== undefined)
            url_ += "MemberCodeFilter=" + encodeURIComponent("" + memberCodeFilter) + "&";
        if (phoneFilter !== undefined)
            url_ += "PhoneFilter=" + encodeURIComponent("" + phoneFilter) + "&";
        if (maxQuantityFilter !== undefined)
            url_ += "MaxQuantityFilter=" + encodeURIComponent("" + maxQuantityFilter) + "&";
        if (minQuantityFilter !== undefined)
            url_ += "MinQuantityFilter=" + encodeURIComponent("" + minQuantityFilter) + "&";
        if (maxUsedFilter !== undefined)
            url_ += "MaxUsedFilter=" + encodeURIComponent("" + maxUsedFilter) + "&";
        if (minUsedFilter !== undefined)
            url_ += "MinUsedFilter=" + encodeURIComponent("" + minUsedFilter) + "&";
        if (maxRemainFilter !== undefined)
            url_ += "MaxRemainFilter=" + encodeURIComponent("" + maxRemainFilter) + "&";
        if (minRemainFilter !== undefined)
            url_ += "MinRemainFilter=" + encodeURIComponent("" + minRemainFilter) + "&";
        if (linkFilter !== undefined)
            url_ += "LinkFilter=" + encodeURIComponent("" + linkFilter) + "&";
        if (maxFromDateFilter !== undefined)
            url_ += "MaxFromDateFilter=" + encodeURIComponent(maxFromDateFilter ? "" + maxFromDateFilter.toJSON() : "") + "&";
        if (minFromDateFilter !== undefined)
            url_ += "MinFromDateFilter=" + encodeURIComponent(minFromDateFilter ? "" + minFromDateFilter.toJSON() : "") + "&";
        if (maxToDateFilter !== undefined)
            url_ += "MaxToDateFilter=" + encodeURIComponent(maxToDateFilter ? "" + maxToDateFilter.toJSON() : "") + "&";
        if (minToDateFilter !== undefined)
            url_ += "MinToDateFilter=" + encodeURIComponent(minToDateFilter ? "" + minToDateFilter.toJSON() : "") + "&";
        if (promotionMasterCodeFilter !== undefined)
            url_ += "PromotionMasterCodeFilter=" + encodeURIComponent("" + promotionMasterCodeFilter) + "&";
        if (promotionCodeFilter !== undefined)
            url_ += "PromotionCodeFilter=" + encodeURIComponent("" + promotionCodeFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetGameInforForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetGameInforForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetGameInforForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetGameInforForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetGameInforForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetGameInforForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getGameInforForEdit(id: number | null | undefined): Observable<GetGameInforForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/GameInfors/GetGameInforForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetGameInforForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGameInforForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetGameInforForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetGameInforForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetGameInforForEdit(response: HttpResponseBase): Observable<GetGameInforForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetGameInforForEditOutput.fromJS(resultData200) : new GetGameInforForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetGameInforForEditOutput>(<any>null);
    }

    /**
     * @param phone (optional) 
     * @param campaignID (optional) 
     * @return Success
     */
    getGameInfor(phone: string | null | undefined, campaignID: string | null | undefined): Observable<GetGameInforForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/GameInfors/GetGameInfor?";
        if (phone !== undefined)
            url_ += "phone=" + encodeURIComponent("" + phone) + "&";
        if (campaignID !== undefined)
            url_ += "campaignID=" + encodeURIComponent("" + campaignID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetGameInfor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGameInfor(<any>response_);
                } catch (e) {
                    return <Observable<GetGameInforForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetGameInforForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetGameInfor(response: HttpResponseBase): Observable<GetGameInforForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetGameInforForEditOutput.fromJS(resultData200) : new GetGameInforForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetGameInforForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditGameInforDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GameInfors/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GameInfors/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param campaignIDFilter (optional) 
     * @param campaignNameFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param outletCodeFilter (optional) 
     * @param zaloChatIDFilter (optional) 
     * @param memberCodeFilter (optional) 
     * @param phoneFilter (optional) 
     * @param maxQuantityFilter (optional) 
     * @param minQuantityFilter (optional) 
     * @param maxUsedFilter (optional) 
     * @param minUsedFilter (optional) 
     * @param maxRemainFilter (optional) 
     * @param minRemainFilter (optional) 
     * @param linkFilter (optional) 
     * @param maxFromDateFilter (optional) 
     * @param minFromDateFilter (optional) 
     * @param maxToDateFilter (optional) 
     * @param minToDateFilter (optional) 
     * @param promotionMasterCodeFilter (optional) 
     * @param promotionCodeFilter (optional) 
     * @param statusFilter (optional) 
     * @return Success
     */
    getGameInforsToExcel(filter: string | null | undefined, campaignIDFilter: string | null | undefined, campaignNameFilter: string | null | undefined, descriptionFilter: string | null | undefined, outletCodeFilter: string | null | undefined, zaloChatIDFilter: string | null | undefined, memberCodeFilter: string | null | undefined, phoneFilter: string | null | undefined, maxQuantityFilter: number | null | undefined, minQuantityFilter: number | null | undefined, maxUsedFilter: number | null | undefined, minUsedFilter: number | null | undefined, maxRemainFilter: number | null | undefined, minRemainFilter: number | null | undefined, linkFilter: string | null | undefined, maxFromDateFilter: moment.Moment | null | undefined, minFromDateFilter: moment.Moment | null | undefined, maxToDateFilter: moment.Moment | null | undefined, minToDateFilter: moment.Moment | null | undefined, promotionMasterCodeFilter: string | null | undefined, promotionCodeFilter: string | null | undefined, statusFilter: string | null | undefined): Observable<RewardsFileDto> {
        let url_ = this.baseUrl + "/api/services/app/GameInfors/GetGameInforsToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (campaignIDFilter !== undefined)
            url_ += "CampaignIDFilter=" + encodeURIComponent("" + campaignIDFilter) + "&";
        if (campaignNameFilter !== undefined)
            url_ += "CampaignNameFilter=" + encodeURIComponent("" + campaignNameFilter) + "&";
        if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&";
        if (outletCodeFilter !== undefined)
            url_ += "OutletCodeFilter=" + encodeURIComponent("" + outletCodeFilter) + "&";
        if (zaloChatIDFilter !== undefined)
            url_ += "ZaloChatIDFilter=" + encodeURIComponent("" + zaloChatIDFilter) + "&";
        if (memberCodeFilter !== undefined)
            url_ += "MemberCodeFilter=" + encodeURIComponent("" + memberCodeFilter) + "&";
        if (phoneFilter !== undefined)
            url_ += "PhoneFilter=" + encodeURIComponent("" + phoneFilter) + "&";
        if (maxQuantityFilter !== undefined)
            url_ += "MaxQuantityFilter=" + encodeURIComponent("" + maxQuantityFilter) + "&";
        if (minQuantityFilter !== undefined)
            url_ += "MinQuantityFilter=" + encodeURIComponent("" + minQuantityFilter) + "&";
        if (maxUsedFilter !== undefined)
            url_ += "MaxUsedFilter=" + encodeURIComponent("" + maxUsedFilter) + "&";
        if (minUsedFilter !== undefined)
            url_ += "MinUsedFilter=" + encodeURIComponent("" + minUsedFilter) + "&";
        if (maxRemainFilter !== undefined)
            url_ += "MaxRemainFilter=" + encodeURIComponent("" + maxRemainFilter) + "&";
        if (minRemainFilter !== undefined)
            url_ += "MinRemainFilter=" + encodeURIComponent("" + minRemainFilter) + "&";
        if (linkFilter !== undefined)
            url_ += "LinkFilter=" + encodeURIComponent("" + linkFilter) + "&";
        if (maxFromDateFilter !== undefined)
            url_ += "MaxFromDateFilter=" + encodeURIComponent(maxFromDateFilter ? "" + maxFromDateFilter.toJSON() : "") + "&";
        if (minFromDateFilter !== undefined)
            url_ += "MinFromDateFilter=" + encodeURIComponent(minFromDateFilter ? "" + minFromDateFilter.toJSON() : "") + "&";
        if (maxToDateFilter !== undefined)
            url_ += "MaxToDateFilter=" + encodeURIComponent(maxToDateFilter ? "" + maxToDateFilter.toJSON() : "") + "&";
        if (minToDateFilter !== undefined)
            url_ += "MinToDateFilter=" + encodeURIComponent(minToDateFilter ? "" + minToDateFilter.toJSON() : "") + "&";
        if (promotionMasterCodeFilter !== undefined)
            url_ += "PromotionMasterCodeFilter=" + encodeURIComponent("" + promotionMasterCodeFilter) + "&";
        if (promotionCodeFilter !== undefined)
            url_ += "PromotionCodeFilter=" + encodeURIComponent("" + promotionCodeFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetGameInforsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGameInforsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<RewardsFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<RewardsFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetGameInforsToExcel(response: HttpResponseBase): Observable<RewardsFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? RewardsFileDto.fromJS(resultData200) : new RewardsFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RewardsFileDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    searchAllGameTicket(input: GetAllGameTicketHerderInput | null | undefined): Observable<PagedResultDtoOfGetGameInforForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/GameInfors/SearchAllGameTicket";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSearchAllGameTicket(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchAllGameTicket(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetGameInforForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetGameInforForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processSearchAllGameTicket(response: HttpResponseBase): Observable<PagedResultDtoOfGetGameInforForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetGameInforForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetGameInforForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetGameInforForViewDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    searchAllDetailGameTicket(input: GetAllGameTicketDetailInput | null | undefined): Observable<PagedResultDtoOfGameDetailDto> {
        let url_ = this.baseUrl + "/api/services/app/GameInfors/SearchAllDetailGameTicket";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSearchAllDetailGameTicket(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchAllDetailGameTicket(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGameDetailDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGameDetailDto>><any>_observableThrow(response_);
        }));
    }

    protected processSearchAllDetailGameTicket(response: HttpResponseBase): Observable<PagedResultDtoOfGameDetailDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGameDetailDto.fromJS(resultData200) : new PagedResultDtoOfGameDetailDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGameDetailDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    syncGotIt(input: GetAllGameTicketDetailInput | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GameInfors/SyncGotIt";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSyncGotIt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSyncGotIt(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSyncGotIt(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param details (optional) 
     * @return Success
     */
    syncGotItWithSelected(details: GameDetailDto[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GameInfors/SyncGotItWithSelected";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(details);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSyncGotItWithSelected(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSyncGotItWithSelected(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSyncGotItWithSelected(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    exportGameDetail(input: GetAllGameTicketDetailInput | null | undefined): Observable<RewardsFileDto> {
        let url_ = this.baseUrl + "/api/services/app/GameInfors/ExportGameDetail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processExportGameDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportGameDetail(<any>response_);
                } catch (e) {
                    return <Observable<RewardsFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<RewardsFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processExportGameDetail(response: HttpResponseBase): Observable<RewardsFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? RewardsFileDto.fromJS(resultData200) : new RewardsFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RewardsFileDto>(<any>null);
    }
}

@Injectable()
export class GameInfosServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param gameCodeFilter (optional) 
     * @param gameNameENFilter (optional) 
     * @param gameNameVNFilter (optional) 
     * @param maxStartTimeFilter (optional) 
     * @param minStartTimeFilter (optional) 
     * @param maxEndTimeFilter (optional) 
     * @param minEndTimeFilter (optional) 
     * @param statusFilter (optional) 
     * @param gameTypeFilter (optional) 
     * @param targetAudienceTypeFilter (optional) 
     * @param maxTargetAudienceIDFilter (optional) 
     * @param minTargetAudienceIDFilter (optional) 
     * @param eventFilter (optional) 
     * @param actionFilterFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param backgroundImageFilter (optional) 
     * @param gameRuleImageFilter (optional) 
     * @param maxMaxRewardPerPlayerFilter (optional) 
     * @param minMaxRewardPerPlayerFilter (optional) 
     * @param descriptionOutOfRewardFilter (optional) 
     * @param maxTimeToExpiredTicketFilter (optional) 
     * @param minTimeToExpiredTicketFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, gameCodeFilter: string | null | undefined, gameNameENFilter: string | null | undefined, gameNameVNFilter: string | null | undefined, maxStartTimeFilter: moment.Moment | null | undefined, minStartTimeFilter: moment.Moment | null | undefined, maxEndTimeFilter: moment.Moment | null | undefined, minEndTimeFilter: moment.Moment | null | undefined, statusFilter: string | null | undefined, gameTypeFilter: string | null | undefined, targetAudienceTypeFilter: string | null | undefined, maxTargetAudienceIDFilter: number | null | undefined, minTargetAudienceIDFilter: number | null | undefined, eventFilter: string | null | undefined, actionFilterFilter: string | null | undefined, descriptionFilter: string | null | undefined, backgroundImageFilter: string | null | undefined, gameRuleImageFilter: string | null | undefined, maxMaxRewardPerPlayerFilter: number | null | undefined, minMaxRewardPerPlayerFilter: number | null | undefined, descriptionOutOfRewardFilter: string | null | undefined, maxTimeToExpiredTicketFilter: number | null | undefined, minTimeToExpiredTicketFilter: number | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetGameInfoForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/GameInfos/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (gameCodeFilter !== undefined)
            url_ += "GameCodeFilter=" + encodeURIComponent("" + gameCodeFilter) + "&";
        if (gameNameENFilter !== undefined)
            url_ += "GameNameENFilter=" + encodeURIComponent("" + gameNameENFilter) + "&";
        if (gameNameVNFilter !== undefined)
            url_ += "GameNameVNFilter=" + encodeURIComponent("" + gameNameVNFilter) + "&";
        if (maxStartTimeFilter !== undefined)
            url_ += "MaxStartTimeFilter=" + encodeURIComponent(maxStartTimeFilter ? "" + maxStartTimeFilter.toJSON() : "") + "&";
        if (minStartTimeFilter !== undefined)
            url_ += "MinStartTimeFilter=" + encodeURIComponent(minStartTimeFilter ? "" + minStartTimeFilter.toJSON() : "") + "&";
        if (maxEndTimeFilter !== undefined)
            url_ += "MaxEndTimeFilter=" + encodeURIComponent(maxEndTimeFilter ? "" + maxEndTimeFilter.toJSON() : "") + "&";
        if (minEndTimeFilter !== undefined)
            url_ += "MinEndTimeFilter=" + encodeURIComponent(minEndTimeFilter ? "" + minEndTimeFilter.toJSON() : "") + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (gameTypeFilter !== undefined)
            url_ += "GameTypeFilter=" + encodeURIComponent("" + gameTypeFilter) + "&";
        if (targetAudienceTypeFilter !== undefined)
            url_ += "TargetAudienceTypeFilter=" + encodeURIComponent("" + targetAudienceTypeFilter) + "&";
        if (maxTargetAudienceIDFilter !== undefined)
            url_ += "MaxTargetAudienceIDFilter=" + encodeURIComponent("" + maxTargetAudienceIDFilter) + "&";
        if (minTargetAudienceIDFilter !== undefined)
            url_ += "MinTargetAudienceIDFilter=" + encodeURIComponent("" + minTargetAudienceIDFilter) + "&";
        if (eventFilter !== undefined)
            url_ += "EventFilter=" + encodeURIComponent("" + eventFilter) + "&";
        if (actionFilterFilter !== undefined)
            url_ += "ActionFilterFilter=" + encodeURIComponent("" + actionFilterFilter) + "&";
        if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&";
        if (backgroundImageFilter !== undefined)
            url_ += "BackgroundImageFilter=" + encodeURIComponent("" + backgroundImageFilter) + "&";
        if (gameRuleImageFilter !== undefined)
            url_ += "GameRuleImageFilter=" + encodeURIComponent("" + gameRuleImageFilter) + "&";
        if (maxMaxRewardPerPlayerFilter !== undefined)
            url_ += "MaxMaxRewardPerPlayerFilter=" + encodeURIComponent("" + maxMaxRewardPerPlayerFilter) + "&";
        if (minMaxRewardPerPlayerFilter !== undefined)
            url_ += "MinMaxRewardPerPlayerFilter=" + encodeURIComponent("" + minMaxRewardPerPlayerFilter) + "&";
        if (descriptionOutOfRewardFilter !== undefined)
            url_ += "DescriptionOutOfRewardFilter=" + encodeURIComponent("" + descriptionOutOfRewardFilter) + "&";
        if (maxTimeToExpiredTicketFilter !== undefined)
            url_ += "MaxTimeToExpiredTicketFilter=" + encodeURIComponent("" + maxTimeToExpiredTicketFilter) + "&";
        if (minTimeToExpiredTicketFilter !== undefined)
            url_ += "MinTimeToExpiredTicketFilter=" + encodeURIComponent("" + minTimeToExpiredTicketFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetGameInfoForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetGameInfoForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetGameInfoForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetGameInfoForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetGameInfoForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetGameInfoForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getGameInfoForEdit(id: number | null | undefined): Observable<GetGameInfoForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/GameInfos/GetGameInfoForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetGameInfoForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGameInfoForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetGameInfoForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetGameInfoForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetGameInfoForEdit(response: HttpResponseBase): Observable<GetGameInfoForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetGameInfoForEditOutput.fromJS(resultData200) : new GetGameInfoForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetGameInfoForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditGameInfoDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GameInfos/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GameInfos/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param gameCodeFilter (optional) 
     * @param gameNameENFilter (optional) 
     * @param gameNameVNFilter (optional) 
     * @param maxStartTimeFilter (optional) 
     * @param minStartTimeFilter (optional) 
     * @param maxEndTimeFilter (optional) 
     * @param minEndTimeFilter (optional) 
     * @param statusFilter (optional) 
     * @param gameTypeFilter (optional) 
     * @param targetAudienceTypeFilter (optional) 
     * @param maxTargetAudienceIDFilter (optional) 
     * @param minTargetAudienceIDFilter (optional) 
     * @param eventFilter (optional) 
     * @param actionFilterFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param backgroundImageFilter (optional) 
     * @param gameRuleImageFilter (optional) 
     * @param maxMaxRewardPerPlayerFilter (optional) 
     * @param minMaxRewardPerPlayerFilter (optional) 
     * @param descriptionOutOfRewardFilter (optional) 
     * @param maxTimeToExpiredTicketFilter (optional) 
     * @param minTimeToExpiredTicketFilter (optional) 
     * @return Success
     */
    getGameInfosToExcel(filter: string | null | undefined, gameCodeFilter: string | null | undefined, gameNameENFilter: string | null | undefined, gameNameVNFilter: string | null | undefined, maxStartTimeFilter: moment.Moment | null | undefined, minStartTimeFilter: moment.Moment | null | undefined, maxEndTimeFilter: moment.Moment | null | undefined, minEndTimeFilter: moment.Moment | null | undefined, statusFilter: string | null | undefined, gameTypeFilter: string | null | undefined, targetAudienceTypeFilter: string | null | undefined, maxTargetAudienceIDFilter: number | null | undefined, minTargetAudienceIDFilter: number | null | undefined, eventFilter: string | null | undefined, actionFilterFilter: string | null | undefined, descriptionFilter: string | null | undefined, backgroundImageFilter: string | null | undefined, gameRuleImageFilter: string | null | undefined, maxMaxRewardPerPlayerFilter: number | null | undefined, minMaxRewardPerPlayerFilter: number | null | undefined, descriptionOutOfRewardFilter: string | null | undefined, maxTimeToExpiredTicketFilter: number | null | undefined, minTimeToExpiredTicketFilter: number | null | undefined): Observable<GamificationFileDto> {
        let url_ = this.baseUrl + "/api/services/app/GameInfos/GetGameInfosToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (gameCodeFilter !== undefined)
            url_ += "GameCodeFilter=" + encodeURIComponent("" + gameCodeFilter) + "&";
        if (gameNameENFilter !== undefined)
            url_ += "GameNameENFilter=" + encodeURIComponent("" + gameNameENFilter) + "&";
        if (gameNameVNFilter !== undefined)
            url_ += "GameNameVNFilter=" + encodeURIComponent("" + gameNameVNFilter) + "&";
        if (maxStartTimeFilter !== undefined)
            url_ += "MaxStartTimeFilter=" + encodeURIComponent(maxStartTimeFilter ? "" + maxStartTimeFilter.toJSON() : "") + "&";
        if (minStartTimeFilter !== undefined)
            url_ += "MinStartTimeFilter=" + encodeURIComponent(minStartTimeFilter ? "" + minStartTimeFilter.toJSON() : "") + "&";
        if (maxEndTimeFilter !== undefined)
            url_ += "MaxEndTimeFilter=" + encodeURIComponent(maxEndTimeFilter ? "" + maxEndTimeFilter.toJSON() : "") + "&";
        if (minEndTimeFilter !== undefined)
            url_ += "MinEndTimeFilter=" + encodeURIComponent(minEndTimeFilter ? "" + minEndTimeFilter.toJSON() : "") + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (gameTypeFilter !== undefined)
            url_ += "GameTypeFilter=" + encodeURIComponent("" + gameTypeFilter) + "&";
        if (targetAudienceTypeFilter !== undefined)
            url_ += "TargetAudienceTypeFilter=" + encodeURIComponent("" + targetAudienceTypeFilter) + "&";
        if (maxTargetAudienceIDFilter !== undefined)
            url_ += "MaxTargetAudienceIDFilter=" + encodeURIComponent("" + maxTargetAudienceIDFilter) + "&";
        if (minTargetAudienceIDFilter !== undefined)
            url_ += "MinTargetAudienceIDFilter=" + encodeURIComponent("" + minTargetAudienceIDFilter) + "&";
        if (eventFilter !== undefined)
            url_ += "EventFilter=" + encodeURIComponent("" + eventFilter) + "&";
        if (actionFilterFilter !== undefined)
            url_ += "ActionFilterFilter=" + encodeURIComponent("" + actionFilterFilter) + "&";
        if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&";
        if (backgroundImageFilter !== undefined)
            url_ += "BackgroundImageFilter=" + encodeURIComponent("" + backgroundImageFilter) + "&";
        if (gameRuleImageFilter !== undefined)
            url_ += "GameRuleImageFilter=" + encodeURIComponent("" + gameRuleImageFilter) + "&";
        if (maxMaxRewardPerPlayerFilter !== undefined)
            url_ += "MaxMaxRewardPerPlayerFilter=" + encodeURIComponent("" + maxMaxRewardPerPlayerFilter) + "&";
        if (minMaxRewardPerPlayerFilter !== undefined)
            url_ += "MinMaxRewardPerPlayerFilter=" + encodeURIComponent("" + minMaxRewardPerPlayerFilter) + "&";
        if (descriptionOutOfRewardFilter !== undefined)
            url_ += "DescriptionOutOfRewardFilter=" + encodeURIComponent("" + descriptionOutOfRewardFilter) + "&";
        if (maxTimeToExpiredTicketFilter !== undefined)
            url_ += "MaxTimeToExpiredTicketFilter=" + encodeURIComponent("" + maxTimeToExpiredTicketFilter) + "&";
        if (minTimeToExpiredTicketFilter !== undefined)
            url_ += "MinTimeToExpiredTicketFilter=" + encodeURIComponent("" + minTimeToExpiredTicketFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetGameInfosToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGameInfosToExcel(<any>response_);
                } catch (e) {
                    return <Observable<GamificationFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GamificationFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetGameInfosToExcel(response: HttpResponseBase): Observable<GamificationFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GamificationFileDto.fromJS(resultData200) : new GamificationFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GamificationFileDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    search(input: GetAllGameInfosInput | null | undefined): Observable<PagedResultDtoOfGetGameInfoForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/GameInfos/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetGameInfoForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetGameInfoForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<PagedResultDtoOfGetGameInfoForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetGameInfoForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetGameInfoForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetGameInfoForViewDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    searchExt(input: GetAllGameInfosInput | null | undefined): Observable<PagedResultDtoOfGetGameInfoForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/GameInfos/SearchExt";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSearchExt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchExt(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetGameInfoForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetGameInfoForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processSearchExt(response: HttpResponseBase): Observable<PagedResultDtoOfGetGameInfoForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetGameInfoForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetGameInfoForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetGameInfoForViewDto>(<any>null);
    }

    /**
     * @param gameId (optional) 
     * @return Success
     */
    getGameCampaignForEdit(gameId: number | null | undefined): Observable<CreateOrEditGameCampaignCustomDto> {
        let url_ = this.baseUrl + "/api/services/app/GameInfos/GetGameCampaignForEdit?";
        if (gameId !== undefined)
            url_ += "gameId=" + encodeURIComponent("" + gameId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetGameCampaignForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGameCampaignForEdit(<any>response_);
                } catch (e) {
                    return <Observable<CreateOrEditGameCampaignCustomDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CreateOrEditGameCampaignCustomDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetGameCampaignForEdit(response: HttpResponseBase): Observable<CreateOrEditGameCampaignCustomDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? CreateOrEditGameCampaignCustomDto.fromJS(resultData200) : new CreateOrEditGameCampaignCustomDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateOrEditGameCampaignCustomDto>(<any>null);
    }

    /**
     * @param gameCampaign (optional) 
     * @return Success
     */
    createOrEditGameCampaign(gameCampaign: CreateOrEditGameCampaignCustomDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GameInfos/CreateOrEditGameCampaign";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(gameCampaign);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEditGameCampaign(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditGameCampaign(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEditGameCampaign(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    getGameCampaignMaster(): Observable<GameCampaignMasterData> {
        let url_ = this.baseUrl + "/api/services/app/GameInfos/GetGameCampaignMaster";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetGameCampaignMaster(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGameCampaignMaster(<any>response_);
                } catch (e) {
                    return <Observable<GameCampaignMasterData>><any>_observableThrow(e);
                }
            } else
                return <Observable<GameCampaignMasterData>><any>_observableThrow(response_);
        }));
    }

    protected processGetGameCampaignMaster(response: HttpResponseBase): Observable<GameCampaignMasterData> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GameCampaignMasterData.fromJS(resultData200) : new GameCampaignMasterData();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GameCampaignMasterData>(<any>null);
    }

    /**
     * @param ids (optional) 
     * @return Success
     */
    batchDelete(ids: number[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GameInfos/BatchDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ids);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processBatchDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBatchDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processBatchDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param gameCampaign (optional) 
     * @return Success
     */
    approveGameCampaign(gameCampaign: CreateOrEditGameCampaignCustomDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GameInfos/ApproveGameCampaign";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(gameCampaign);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processApproveGameCampaign(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApproveGameCampaign(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processApproveGameCampaign(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param memberCode (optional) 
     * @return Success
     */
    getGameList(memberCode: string | null | undefined): Observable<GameInforationDto[]> {
        let url_ = this.baseUrl + "/api/services/app/GameInfos/GetGameList?";
        if (memberCode !== undefined)
            url_ += "memberCode=" + encodeURIComponent("" + memberCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetGameList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGameList(<any>response_);
                } catch (e) {
                    return <Observable<GameInforationDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<GameInforationDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetGameList(response: HttpResponseBase): Observable<GameInforationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(GameInforationDto.fromJS(item));
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GameInforationDto[]>(<any>null);
    }

    /**
     * @param memberCode (optional) 
     * @param gameCode (optional) 
     * @return Success
     */
    getGamePlayInfo(memberCode: string | null | undefined, gameCode: string | null | undefined): Observable<GameInformationDetailDto> {
        let url_ = this.baseUrl + "/api/services/app/GameInfos/GetGamePlayInfo?";
        if (memberCode !== undefined)
            url_ += "memberCode=" + encodeURIComponent("" + memberCode) + "&";
        if (gameCode !== undefined)
            url_ += "gameCode=" + encodeURIComponent("" + gameCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetGamePlayInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGamePlayInfo(<any>response_);
                } catch (e) {
                    return <Observable<GameInformationDetailDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GameInformationDetailDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetGamePlayInfo(response: HttpResponseBase): Observable<GameInformationDetailDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GameInformationDetailDto.fromJS(resultData200) : new GameInformationDetailDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GameInformationDetailDto>(<any>null);
    }

    /**
     * @param gameCode (optional) 
     * @param memberCode (optional) 
     * @return Success
     */
    spin(gameCode: string | null | undefined, memberCode: string | null | undefined): Observable<SpinGameResult> {
        let url_ = this.baseUrl + "/api/services/app/GameInfos/Spin?";
        if (gameCode !== undefined)
            url_ += "gameCode=" + encodeURIComponent("" + gameCode) + "&";
        if (memberCode !== undefined)
            url_ += "memberCode=" + encodeURIComponent("" + memberCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSpin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSpin(<any>response_);
                } catch (e) {
                    return <Observable<SpinGameResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<SpinGameResult>><any>_observableThrow(response_);
        }));
    }

    protected processSpin(response: HttpResponseBase): Observable<SpinGameResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? SpinGameResult.fromJS(resultData200) : new SpinGameResult();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SpinGameResult>(<any>null);
    }
}

@Injectable()
export class GameInfosExcelExporterServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param gameInfos (optional) 
     * @return Success
     */
    exportToFile(gameInfos: GetGameInfoForViewDto[] | null | undefined): Observable<GamificationFileDto> {
        let url_ = this.baseUrl + "/api/services/app/GameInfosExcelExporter/ExportToFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(gameInfos);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processExportToFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportToFile(<any>response_);
                } catch (e) {
                    return <Observable<GamificationFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GamificationFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processExportToFile(response: HttpResponseBase): Observable<GamificationFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GamificationFileDto.fromJS(resultData200) : new GamificationFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GamificationFileDto>(<any>null);
    }
}

@Injectable()
export class GamePlayHistorysServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param gameCodeFilter (optional) 
     * @param playerCodeFilter (optional) 
     * @param ticketCodeFilter (optional) 
     * @param rewardCodeFilter (optional) 
     * @param maxRewardQuantityFilter (optional) 
     * @param minRewardQuantityFilter (optional) 
     * @param isRedeemedFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, gameCodeFilter: string | null | undefined, playerCodeFilter: string | null | undefined, ticketCodeFilter: string | null | undefined, rewardCodeFilter: string | null | undefined, maxRewardQuantityFilter: number | null | undefined, minRewardQuantityFilter: number | null | undefined, isRedeemedFilter: number | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetGamePlayHistoryForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/GamePlayHistorys/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (gameCodeFilter !== undefined)
            url_ += "GameCodeFilter=" + encodeURIComponent("" + gameCodeFilter) + "&";
        if (playerCodeFilter !== undefined)
            url_ += "PlayerCodeFilter=" + encodeURIComponent("" + playerCodeFilter) + "&";
        if (ticketCodeFilter !== undefined)
            url_ += "TicketCodeFilter=" + encodeURIComponent("" + ticketCodeFilter) + "&";
        if (rewardCodeFilter !== undefined)
            url_ += "RewardCodeFilter=" + encodeURIComponent("" + rewardCodeFilter) + "&";
        if (maxRewardQuantityFilter !== undefined)
            url_ += "MaxRewardQuantityFilter=" + encodeURIComponent("" + maxRewardQuantityFilter) + "&";
        if (minRewardQuantityFilter !== undefined)
            url_ += "MinRewardQuantityFilter=" + encodeURIComponent("" + minRewardQuantityFilter) + "&";
        if (isRedeemedFilter !== undefined)
            url_ += "IsRedeemedFilter=" + encodeURIComponent("" + isRedeemedFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetGamePlayHistoryForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetGamePlayHistoryForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetGamePlayHistoryForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetGamePlayHistoryForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetGamePlayHistoryForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetGamePlayHistoryForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getGamePlayHistoryForEdit(id: number | null | undefined): Observable<GetGamePlayHistoryForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/GamePlayHistorys/GetGamePlayHistoryForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetGamePlayHistoryForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGamePlayHistoryForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetGamePlayHistoryForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetGamePlayHistoryForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetGamePlayHistoryForEdit(response: HttpResponseBase): Observable<GetGamePlayHistoryForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetGamePlayHistoryForEditOutput.fromJS(resultData200) : new GetGamePlayHistoryForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetGamePlayHistoryForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditGamePlayHistoryDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GamePlayHistorys/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GamePlayHistorys/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param gameCodeFilter (optional) 
     * @param playerCodeFilter (optional) 
     * @param ticketCodeFilter (optional) 
     * @param rewardCodeFilter (optional) 
     * @param maxRewardQuantityFilter (optional) 
     * @param minRewardQuantityFilter (optional) 
     * @param isRedeemedFilter (optional) 
     * @return Success
     */
    getGamePlayHistorysToExcel(filter: string | null | undefined, gameCodeFilter: string | null | undefined, playerCodeFilter: string | null | undefined, ticketCodeFilter: string | null | undefined, rewardCodeFilter: string | null | undefined, maxRewardQuantityFilter: number | null | undefined, minRewardQuantityFilter: number | null | undefined, isRedeemedFilter: number | null | undefined): Observable<GamificationFileDto> {
        let url_ = this.baseUrl + "/api/services/app/GamePlayHistorys/GetGamePlayHistorysToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (gameCodeFilter !== undefined)
            url_ += "GameCodeFilter=" + encodeURIComponent("" + gameCodeFilter) + "&";
        if (playerCodeFilter !== undefined)
            url_ += "PlayerCodeFilter=" + encodeURIComponent("" + playerCodeFilter) + "&";
        if (ticketCodeFilter !== undefined)
            url_ += "TicketCodeFilter=" + encodeURIComponent("" + ticketCodeFilter) + "&";
        if (rewardCodeFilter !== undefined)
            url_ += "RewardCodeFilter=" + encodeURIComponent("" + rewardCodeFilter) + "&";
        if (maxRewardQuantityFilter !== undefined)
            url_ += "MaxRewardQuantityFilter=" + encodeURIComponent("" + maxRewardQuantityFilter) + "&";
        if (minRewardQuantityFilter !== undefined)
            url_ += "MinRewardQuantityFilter=" + encodeURIComponent("" + minRewardQuantityFilter) + "&";
        if (isRedeemedFilter !== undefined)
            url_ += "IsRedeemedFilter=" + encodeURIComponent("" + isRedeemedFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetGamePlayHistorysToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGamePlayHistorysToExcel(<any>response_);
                } catch (e) {
                    return <Observable<GamificationFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GamificationFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetGamePlayHistorysToExcel(response: HttpResponseBase): Observable<GamificationFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GamificationFileDto.fromJS(resultData200) : new GamificationFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GamificationFileDto>(<any>null);
    }

    /**
     * @param memberCode (optional) 
     * @param gameCode (optional) 
     * @return Success
     */
    getGiftBox(memberCode: string | null | undefined, gameCode: string | null | undefined): Observable<GiftBoxDto[]> {
        let url_ = this.baseUrl + "/api/services/app/GamePlayHistorys/GetGiftBox?";
        if (memberCode !== undefined)
            url_ += "memberCode=" + encodeURIComponent("" + memberCode) + "&";
        if (gameCode !== undefined)
            url_ += "gameCode=" + encodeURIComponent("" + gameCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetGiftBox(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGiftBox(<any>response_);
                } catch (e) {
                    return <Observable<GiftBoxDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<GiftBoxDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetGiftBox(response: HttpResponseBase): Observable<GiftBoxDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(GiftBoxDto.fromJS(item));
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GiftBoxDto[]>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    search(input: GetAllGamePlayHistorysInput | null | undefined): Observable<PagedResultDtoOfGetGamePlayHistoryForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/GamePlayHistorys/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetGamePlayHistoryForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetGamePlayHistoryForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<PagedResultDtoOfGetGamePlayHistoryForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetGamePlayHistoryForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetGamePlayHistoryForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetGamePlayHistoryForViewDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    exportGamePlayHistorysToExcelExt(input: GetAllGamePlayHistorysForExcelInput | null | undefined): Observable<GamificationFileDto> {
        let url_ = this.baseUrl + "/api/services/app/GamePlayHistorys/ExportGamePlayHistorysToExcelExt";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processExportGamePlayHistorysToExcelExt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportGamePlayHistorysToExcelExt(<any>response_);
                } catch (e) {
                    return <Observable<GamificationFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GamificationFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processExportGamePlayHistorysToExcelExt(response: HttpResponseBase): Observable<GamificationFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GamificationFileDto.fromJS(resultData200) : new GamificationFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GamificationFileDto>(<any>null);
    }
}

@Injectable()
export class GamePlayHistorysExcelExporterServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param gamePlayHistorys (optional) 
     * @return Success
     */
    exportToFile(gamePlayHistorys: GetGamePlayHistoryForViewDto[] | null | undefined): Observable<GamificationFileDto> {
        let url_ = this.baseUrl + "/api/services/app/GamePlayHistorysExcelExporter/ExportToFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(gamePlayHistorys);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processExportToFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportToFile(<any>response_);
                } catch (e) {
                    return <Observable<GamificationFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GamificationFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processExportToFile(response: HttpResponseBase): Observable<GamificationFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GamificationFileDto.fromJS(resultData200) : new GamificationFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GamificationFileDto>(<any>null);
    }

    /**
     * @param gamePlayHistorys (optional) 
     * @return Success
     */
    exportToFileExt(gamePlayHistorys: GetGamePlayHistoryForViewDto[] | null | undefined): Observable<GamificationFileDto> {
        let url_ = this.baseUrl + "/api/services/app/GamePlayHistorysExcelExporter/ExportToFileExt";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(gamePlayHistorys);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processExportToFileExt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportToFileExt(<any>response_);
                } catch (e) {
                    return <Observable<GamificationFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GamificationFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processExportToFileExt(response: HttpResponseBase): Observable<GamificationFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GamificationFileDto.fromJS(resultData200) : new GamificationFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GamificationFileDto>(<any>null);
    }
}

@Injectable()
export class GameRewardsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param gameCodeFilter (optional) 
     * @param rewardCodeFilter (optional) 
     * @param rewardNameENFilter (optional) 
     * @param rewardNameVNFilter (optional) 
     * @param maxStartTimeFilter (optional) 
     * @param minStartTimeFilter (optional) 
     * @param maxEndTimeFilter (optional) 
     * @param minEndTimeFilter (optional) 
     * @param statusFilter (optional) 
     * @param imageLinkFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param maxOrderFilter (optional) 
     * @param minOrderFilter (optional) 
     * @param maxWeightRatioFilter (optional) 
     * @param minWeightRatioFilter (optional) 
     * @param maxBudgetFilter (optional) 
     * @param minBudgetFilter (optional) 
     * @param maxUsedBudgetFilter (optional) 
     * @param minUsedBudgetFilter (optional) 
     * @param maxMaxPerPlayerFilter (optional) 
     * @param minMaxPerPlayerFilter (optional) 
     * @param itemCodeFilter (optional) 
     * @param rewardTypeFilter (optional) 
     * @param rewardPartnerFilter (optional) 
     * @param vendorCodeFilter (optional) 
     * @param maxAmountFilter (optional) 
     * @param minAmountFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, gameCodeFilter: string | null | undefined, rewardCodeFilter: string | null | undefined, rewardNameENFilter: string | null | undefined, rewardNameVNFilter: string | null | undefined, maxStartTimeFilter: moment.Moment | null | undefined, minStartTimeFilter: moment.Moment | null | undefined, maxEndTimeFilter: moment.Moment | null | undefined, minEndTimeFilter: moment.Moment | null | undefined, statusFilter: string | null | undefined, imageLinkFilter: string | null | undefined, descriptionFilter: string | null | undefined, maxOrderFilter: number | null | undefined, minOrderFilter: number | null | undefined, maxWeightRatioFilter: number | null | undefined, minWeightRatioFilter: number | null | undefined, maxBudgetFilter: number | null | undefined, minBudgetFilter: number | null | undefined, maxUsedBudgetFilter: number | null | undefined, minUsedBudgetFilter: number | null | undefined, maxMaxPerPlayerFilter: number | null | undefined, minMaxPerPlayerFilter: number | null | undefined, itemCodeFilter: string | null | undefined, rewardTypeFilter: string | null | undefined, rewardPartnerFilter: string | null | undefined, vendorCodeFilter: string | null | undefined, maxAmountFilter: number | null | undefined, minAmountFilter: number | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetGameRewardForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/GameRewards/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (gameCodeFilter !== undefined)
            url_ += "GameCodeFilter=" + encodeURIComponent("" + gameCodeFilter) + "&";
        if (rewardCodeFilter !== undefined)
            url_ += "RewardCodeFilter=" + encodeURIComponent("" + rewardCodeFilter) + "&";
        if (rewardNameENFilter !== undefined)
            url_ += "RewardNameENFilter=" + encodeURIComponent("" + rewardNameENFilter) + "&";
        if (rewardNameVNFilter !== undefined)
            url_ += "RewardNameVNFilter=" + encodeURIComponent("" + rewardNameVNFilter) + "&";
        if (maxStartTimeFilter !== undefined)
            url_ += "MaxStartTimeFilter=" + encodeURIComponent(maxStartTimeFilter ? "" + maxStartTimeFilter.toJSON() : "") + "&";
        if (minStartTimeFilter !== undefined)
            url_ += "MinStartTimeFilter=" + encodeURIComponent(minStartTimeFilter ? "" + minStartTimeFilter.toJSON() : "") + "&";
        if (maxEndTimeFilter !== undefined)
            url_ += "MaxEndTimeFilter=" + encodeURIComponent(maxEndTimeFilter ? "" + maxEndTimeFilter.toJSON() : "") + "&";
        if (minEndTimeFilter !== undefined)
            url_ += "MinEndTimeFilter=" + encodeURIComponent(minEndTimeFilter ? "" + minEndTimeFilter.toJSON() : "") + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (imageLinkFilter !== undefined)
            url_ += "ImageLinkFilter=" + encodeURIComponent("" + imageLinkFilter) + "&";
        if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&";
        if (maxOrderFilter !== undefined)
            url_ += "MaxOrderFilter=" + encodeURIComponent("" + maxOrderFilter) + "&";
        if (minOrderFilter !== undefined)
            url_ += "MinOrderFilter=" + encodeURIComponent("" + minOrderFilter) + "&";
        if (maxWeightRatioFilter !== undefined)
            url_ += "MaxWeightRatioFilter=" + encodeURIComponent("" + maxWeightRatioFilter) + "&";
        if (minWeightRatioFilter !== undefined)
            url_ += "MinWeightRatioFilter=" + encodeURIComponent("" + minWeightRatioFilter) + "&";
        if (maxBudgetFilter !== undefined)
            url_ += "MaxBudgetFilter=" + encodeURIComponent("" + maxBudgetFilter) + "&";
        if (minBudgetFilter !== undefined)
            url_ += "MinBudgetFilter=" + encodeURIComponent("" + minBudgetFilter) + "&";
        if (maxUsedBudgetFilter !== undefined)
            url_ += "MaxUsedBudgetFilter=" + encodeURIComponent("" + maxUsedBudgetFilter) + "&";
        if (minUsedBudgetFilter !== undefined)
            url_ += "MinUsedBudgetFilter=" + encodeURIComponent("" + minUsedBudgetFilter) + "&";
        if (maxMaxPerPlayerFilter !== undefined)
            url_ += "MaxMaxPerPlayerFilter=" + encodeURIComponent("" + maxMaxPerPlayerFilter) + "&";
        if (minMaxPerPlayerFilter !== undefined)
            url_ += "MinMaxPerPlayerFilter=" + encodeURIComponent("" + minMaxPerPlayerFilter) + "&";
        if (itemCodeFilter !== undefined)
            url_ += "ItemCodeFilter=" + encodeURIComponent("" + itemCodeFilter) + "&";
        if (rewardTypeFilter !== undefined)
            url_ += "RewardTypeFilter=" + encodeURIComponent("" + rewardTypeFilter) + "&";
        if (rewardPartnerFilter !== undefined)
            url_ += "RewardPartnerFilter=" + encodeURIComponent("" + rewardPartnerFilter) + "&";
        if (vendorCodeFilter !== undefined)
            url_ += "VendorCodeFilter=" + encodeURIComponent("" + vendorCodeFilter) + "&";
        if (maxAmountFilter !== undefined)
            url_ += "MaxAmountFilter=" + encodeURIComponent("" + maxAmountFilter) + "&";
        if (minAmountFilter !== undefined)
            url_ += "MinAmountFilter=" + encodeURIComponent("" + minAmountFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetGameRewardForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetGameRewardForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetGameRewardForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetGameRewardForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetGameRewardForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetGameRewardForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getGameRewardForEdit(id: number | null | undefined): Observable<GetGameRewardForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/GameRewards/GetGameRewardForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetGameRewardForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGameRewardForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetGameRewardForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetGameRewardForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetGameRewardForEdit(response: HttpResponseBase): Observable<GetGameRewardForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetGameRewardForEditOutput.fromJS(resultData200) : new GetGameRewardForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetGameRewardForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditGameRewardDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GameRewards/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GameRewards/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param gameCodeFilter (optional) 
     * @param rewardCodeFilter (optional) 
     * @param rewardNameENFilter (optional) 
     * @param rewardNameVNFilter (optional) 
     * @param maxStartTimeFilter (optional) 
     * @param minStartTimeFilter (optional) 
     * @param maxEndTimeFilter (optional) 
     * @param minEndTimeFilter (optional) 
     * @param statusFilter (optional) 
     * @param imageLinkFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param maxOrderFilter (optional) 
     * @param minOrderFilter (optional) 
     * @param maxWeightRatioFilter (optional) 
     * @param minWeightRatioFilter (optional) 
     * @param maxBudgetFilter (optional) 
     * @param minBudgetFilter (optional) 
     * @param maxUsedBudgetFilter (optional) 
     * @param minUsedBudgetFilter (optional) 
     * @param maxMaxPerPlayerFilter (optional) 
     * @param minMaxPerPlayerFilter (optional) 
     * @param itemCodeFilter (optional) 
     * @param rewardTypeFilter (optional) 
     * @param rewardPartnerFilter (optional) 
     * @param vendorCodeFilter (optional) 
     * @param maxAmountFilter (optional) 
     * @param minAmountFilter (optional) 
     * @return Success
     */
    getGameRewardsToExcel(filter: string | null | undefined, gameCodeFilter: string | null | undefined, rewardCodeFilter: string | null | undefined, rewardNameENFilter: string | null | undefined, rewardNameVNFilter: string | null | undefined, maxStartTimeFilter: moment.Moment | null | undefined, minStartTimeFilter: moment.Moment | null | undefined, maxEndTimeFilter: moment.Moment | null | undefined, minEndTimeFilter: moment.Moment | null | undefined, statusFilter: string | null | undefined, imageLinkFilter: string | null | undefined, descriptionFilter: string | null | undefined, maxOrderFilter: number | null | undefined, minOrderFilter: number | null | undefined, maxWeightRatioFilter: number | null | undefined, minWeightRatioFilter: number | null | undefined, maxBudgetFilter: number | null | undefined, minBudgetFilter: number | null | undefined, maxUsedBudgetFilter: number | null | undefined, minUsedBudgetFilter: number | null | undefined, maxMaxPerPlayerFilter: number | null | undefined, minMaxPerPlayerFilter: number | null | undefined, itemCodeFilter: string | null | undefined, rewardTypeFilter: string | null | undefined, rewardPartnerFilter: string | null | undefined, vendorCodeFilter: string | null | undefined, maxAmountFilter: number | null | undefined, minAmountFilter: number | null | undefined): Observable<GamificationFileDto> {
        let url_ = this.baseUrl + "/api/services/app/GameRewards/GetGameRewardsToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (gameCodeFilter !== undefined)
            url_ += "GameCodeFilter=" + encodeURIComponent("" + gameCodeFilter) + "&";
        if (rewardCodeFilter !== undefined)
            url_ += "RewardCodeFilter=" + encodeURIComponent("" + rewardCodeFilter) + "&";
        if (rewardNameENFilter !== undefined)
            url_ += "RewardNameENFilter=" + encodeURIComponent("" + rewardNameENFilter) + "&";
        if (rewardNameVNFilter !== undefined)
            url_ += "RewardNameVNFilter=" + encodeURIComponent("" + rewardNameVNFilter) + "&";
        if (maxStartTimeFilter !== undefined)
            url_ += "MaxStartTimeFilter=" + encodeURIComponent(maxStartTimeFilter ? "" + maxStartTimeFilter.toJSON() : "") + "&";
        if (minStartTimeFilter !== undefined)
            url_ += "MinStartTimeFilter=" + encodeURIComponent(minStartTimeFilter ? "" + minStartTimeFilter.toJSON() : "") + "&";
        if (maxEndTimeFilter !== undefined)
            url_ += "MaxEndTimeFilter=" + encodeURIComponent(maxEndTimeFilter ? "" + maxEndTimeFilter.toJSON() : "") + "&";
        if (minEndTimeFilter !== undefined)
            url_ += "MinEndTimeFilter=" + encodeURIComponent(minEndTimeFilter ? "" + minEndTimeFilter.toJSON() : "") + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (imageLinkFilter !== undefined)
            url_ += "ImageLinkFilter=" + encodeURIComponent("" + imageLinkFilter) + "&";
        if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&";
        if (maxOrderFilter !== undefined)
            url_ += "MaxOrderFilter=" + encodeURIComponent("" + maxOrderFilter) + "&";
        if (minOrderFilter !== undefined)
            url_ += "MinOrderFilter=" + encodeURIComponent("" + minOrderFilter) + "&";
        if (maxWeightRatioFilter !== undefined)
            url_ += "MaxWeightRatioFilter=" + encodeURIComponent("" + maxWeightRatioFilter) + "&";
        if (minWeightRatioFilter !== undefined)
            url_ += "MinWeightRatioFilter=" + encodeURIComponent("" + minWeightRatioFilter) + "&";
        if (maxBudgetFilter !== undefined)
            url_ += "MaxBudgetFilter=" + encodeURIComponent("" + maxBudgetFilter) + "&";
        if (minBudgetFilter !== undefined)
            url_ += "MinBudgetFilter=" + encodeURIComponent("" + minBudgetFilter) + "&";
        if (maxUsedBudgetFilter !== undefined)
            url_ += "MaxUsedBudgetFilter=" + encodeURIComponent("" + maxUsedBudgetFilter) + "&";
        if (minUsedBudgetFilter !== undefined)
            url_ += "MinUsedBudgetFilter=" + encodeURIComponent("" + minUsedBudgetFilter) + "&";
        if (maxMaxPerPlayerFilter !== undefined)
            url_ += "MaxMaxPerPlayerFilter=" + encodeURIComponent("" + maxMaxPerPlayerFilter) + "&";
        if (minMaxPerPlayerFilter !== undefined)
            url_ += "MinMaxPerPlayerFilter=" + encodeURIComponent("" + minMaxPerPlayerFilter) + "&";
        if (itemCodeFilter !== undefined)
            url_ += "ItemCodeFilter=" + encodeURIComponent("" + itemCodeFilter) + "&";
        if (rewardTypeFilter !== undefined)
            url_ += "RewardTypeFilter=" + encodeURIComponent("" + rewardTypeFilter) + "&";
        if (rewardPartnerFilter !== undefined)
            url_ += "RewardPartnerFilter=" + encodeURIComponent("" + rewardPartnerFilter) + "&";
        if (vendorCodeFilter !== undefined)
            url_ += "VendorCodeFilter=" + encodeURIComponent("" + vendorCodeFilter) + "&";
        if (maxAmountFilter !== undefined)
            url_ += "MaxAmountFilter=" + encodeURIComponent("" + maxAmountFilter) + "&";
        if (minAmountFilter !== undefined)
            url_ += "MinAmountFilter=" + encodeURIComponent("" + minAmountFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetGameRewardsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGameRewardsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<GamificationFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GamificationFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetGameRewardsToExcel(response: HttpResponseBase): Observable<GamificationFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GamificationFileDto.fromJS(resultData200) : new GamificationFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GamificationFileDto>(<any>null);
    }

    /**
     * @param gameCode (optional) 
     * @return Success
     */
    getGameRewards(gameCode: string | null | undefined): Observable<CreateOrEditGameRewardDto[]> {
        let url_ = this.baseUrl + "/api/services/app/GameRewards/GetGameRewards?";
        if (gameCode !== undefined)
            url_ += "gameCode=" + encodeURIComponent("" + gameCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetGameRewards(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGameRewards(<any>response_);
                } catch (e) {
                    return <Observable<CreateOrEditGameRewardDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<CreateOrEditGameRewardDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetGameRewards(response: HttpResponseBase): Observable<CreateOrEditGameRewardDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(CreateOrEditGameRewardDto.fromJS(item));
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateOrEditGameRewardDto[]>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    search(input: GetAllGameRewardsInput | null | undefined): Observable<PagedResultDtoOfGetGameRewardForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/GameRewards/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetGameRewardForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetGameRewardForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<PagedResultDtoOfGetGameRewardForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetGameRewardForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetGameRewardForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetGameRewardForViewDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    exportGameRewardsToExcel(input: GetAllGameRewardsForExcelInput | null | undefined): Observable<GamificationFileDto> {
        let url_ = this.baseUrl + "/api/services/app/GameRewards/ExportGameRewardsToExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processExportGameRewardsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportGameRewardsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<GamificationFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GamificationFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processExportGameRewardsToExcel(response: HttpResponseBase): Observable<GamificationFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GamificationFileDto.fromJS(resultData200) : new GamificationFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GamificationFileDto>(<any>null);
    }
}

@Injectable()
export class GameRewardsExcelExporterServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param gameRewards (optional) 
     * @return Success
     */
    exportToFile(gameRewards: GetGameRewardForViewDto[] | null | undefined): Observable<GamificationFileDto> {
        let url_ = this.baseUrl + "/api/services/app/GameRewardsExcelExporter/ExportToFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(gameRewards);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processExportToFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportToFile(<any>response_);
                } catch (e) {
                    return <Observable<GamificationFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GamificationFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processExportToFile(response: HttpResponseBase): Observable<GamificationFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GamificationFileDto.fromJS(resultData200) : new GamificationFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GamificationFileDto>(<any>null);
    }

    /**
     * @param gameRewards (optional) 
     * @return Success
     */
    exportToFileExt(gameRewards: GetGameRewardForViewDto[] | null | undefined): Observable<GamificationFileDto> {
        let url_ = this.baseUrl + "/api/services/app/GameRewardsExcelExporter/ExportToFileExt";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(gameRewards);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processExportToFileExt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportToFileExt(<any>response_);
                } catch (e) {
                    return <Observable<GamificationFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GamificationFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processExportToFileExt(response: HttpResponseBase): Observable<GamificationFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GamificationFileDto.fromJS(resultData200) : new GamificationFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GamificationFileDto>(<any>null);
    }
}

@Injectable()
export class GameSettingsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param codeFilter (optional) 
     * @param nameFilter (optional) 
     * @param maxEffectiveFromFilter (optional) 
     * @param minEffectiveFromFilter (optional) 
     * @param maxEffectiveToFilter (optional) 
     * @param minEffectiveToFilter (optional) 
     * @param fullLinkFilter (optional) 
     * @param statusFilter (optional) 
     * @param imageLinkFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param lotteryCodeFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, codeFilter: string | null | undefined, nameFilter: string | null | undefined, maxEffectiveFromFilter: moment.Moment | null | undefined, minEffectiveFromFilter: moment.Moment | null | undefined, maxEffectiveToFilter: moment.Moment | null | undefined, minEffectiveToFilter: moment.Moment | null | undefined, fullLinkFilter: string | null | undefined, statusFilter: string | null | undefined, imageLinkFilter: string | null | undefined, descriptionFilter: string | null | undefined, lotteryCodeFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetGameSettingForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/GameSettings/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&";
        if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (maxEffectiveFromFilter !== undefined)
            url_ += "MaxEffectiveFromFilter=" + encodeURIComponent(maxEffectiveFromFilter ? "" + maxEffectiveFromFilter.toJSON() : "") + "&";
        if (minEffectiveFromFilter !== undefined)
            url_ += "MinEffectiveFromFilter=" + encodeURIComponent(minEffectiveFromFilter ? "" + minEffectiveFromFilter.toJSON() : "") + "&";
        if (maxEffectiveToFilter !== undefined)
            url_ += "MaxEffectiveToFilter=" + encodeURIComponent(maxEffectiveToFilter ? "" + maxEffectiveToFilter.toJSON() : "") + "&";
        if (minEffectiveToFilter !== undefined)
            url_ += "MinEffectiveToFilter=" + encodeURIComponent(minEffectiveToFilter ? "" + minEffectiveToFilter.toJSON() : "") + "&";
        if (fullLinkFilter !== undefined)
            url_ += "FullLinkFilter=" + encodeURIComponent("" + fullLinkFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (imageLinkFilter !== undefined)
            url_ += "ImageLinkFilter=" + encodeURIComponent("" + imageLinkFilter) + "&";
        if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&";
        if (lotteryCodeFilter !== undefined)
            url_ += "LotteryCodeFilter=" + encodeURIComponent("" + lotteryCodeFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetGameSettingForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetGameSettingForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetGameSettingForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetGameSettingForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetGameSettingForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetGameSettingForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getGameSettingForEdit(id: number | null | undefined): Observable<GetGameSettingForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/GameSettings/GetGameSettingForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetGameSettingForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGameSettingForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetGameSettingForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetGameSettingForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetGameSettingForEdit(response: HttpResponseBase): Observable<GetGameSettingForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetGameSettingForEditOutput.fromJS(resultData200) : new GetGameSettingForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetGameSettingForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditGameSettingDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GameSettings/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GameSettings/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param codeFilter (optional) 
     * @param nameFilter (optional) 
     * @param maxEffectiveFromFilter (optional) 
     * @param minEffectiveFromFilter (optional) 
     * @param maxEffectiveToFilter (optional) 
     * @param minEffectiveToFilter (optional) 
     * @param fullLinkFilter (optional) 
     * @param statusFilter (optional) 
     * @param imageLinkFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param lotteryCodeFilter (optional) 
     * @return Success
     */
    getGameSettingsToExcel(filter: string | null | undefined, codeFilter: string | null | undefined, nameFilter: string | null | undefined, maxEffectiveFromFilter: moment.Moment | null | undefined, minEffectiveFromFilter: moment.Moment | null | undefined, maxEffectiveToFilter: moment.Moment | null | undefined, minEffectiveToFilter: moment.Moment | null | undefined, fullLinkFilter: string | null | undefined, statusFilter: string | null | undefined, imageLinkFilter: string | null | undefined, descriptionFilter: string | null | undefined, lotteryCodeFilter: string | null | undefined): Observable<SocialRetailerFileDto> {
        let url_ = this.baseUrl + "/api/services/app/GameSettings/GetGameSettingsToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&";
        if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (maxEffectiveFromFilter !== undefined)
            url_ += "MaxEffectiveFromFilter=" + encodeURIComponent(maxEffectiveFromFilter ? "" + maxEffectiveFromFilter.toJSON() : "") + "&";
        if (minEffectiveFromFilter !== undefined)
            url_ += "MinEffectiveFromFilter=" + encodeURIComponent(minEffectiveFromFilter ? "" + minEffectiveFromFilter.toJSON() : "") + "&";
        if (maxEffectiveToFilter !== undefined)
            url_ += "MaxEffectiveToFilter=" + encodeURIComponent(maxEffectiveToFilter ? "" + maxEffectiveToFilter.toJSON() : "") + "&";
        if (minEffectiveToFilter !== undefined)
            url_ += "MinEffectiveToFilter=" + encodeURIComponent(minEffectiveToFilter ? "" + minEffectiveToFilter.toJSON() : "") + "&";
        if (fullLinkFilter !== undefined)
            url_ += "FullLinkFilter=" + encodeURIComponent("" + fullLinkFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (imageLinkFilter !== undefined)
            url_ += "ImageLinkFilter=" + encodeURIComponent("" + imageLinkFilter) + "&";
        if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&";
        if (lotteryCodeFilter !== undefined)
            url_ += "LotteryCodeFilter=" + encodeURIComponent("" + lotteryCodeFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetGameSettingsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGameSettingsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<SocialRetailerFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SocialRetailerFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetGameSettingsToExcel(response: HttpResponseBase): Observable<SocialRetailerFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? SocialRetailerFileDto.fromJS(resultData200) : new SocialRetailerFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SocialRetailerFileDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    gametingList(input: GetAllGameSettingsInput | null | undefined): Observable<PagedResultDtoOfGetGameSettingForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/GameSettings/GametingList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGametingList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGametingList(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetGameSettingForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetGameSettingForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGametingList(response: HttpResponseBase): Observable<PagedResultDtoOfGetGameSettingForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetGameSettingForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetGameSettingForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetGameSettingForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getGameSettingForEditExt(id: number | null | undefined): Observable<GetGameSettingForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/GameSettings/GetGameSettingForEditExt?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetGameSettingForEditExt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGameSettingForEditExt(<any>response_);
                } catch (e) {
                    return <Observable<GetGameSettingForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetGameSettingForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetGameSettingForEditExt(response: HttpResponseBase): Observable<GetGameSettingForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetGameSettingForEditOutput.fromJS(resultData200) : new GetGameSettingForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetGameSettingForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEditExt(input: CreateOrEditGameSettingDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GameSettings/CreateOrEditExt";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEditExt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditExt(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEditExt(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param ids (optional) 
     * @return Success
     */
    batchDeleGameSetting(ids: number[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GameSettings/BatchDeleGameSetting";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ids);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processBatchDeleGameSetting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBatchDeleGameSetting(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processBatchDeleGameSetting(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    genCodeGameAsync(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/GameSettings/GenCodeGameAsync";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGenCodeGameAsync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenCodeGameAsync(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGenCodeGameAsync(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param codeFilter (optional) 
     * @param nameFilter (optional) 
     * @param maxEffectiveFromFilter (optional) 
     * @param minEffectiveFromFilter (optional) 
     * @param maxEffectiveToFilter (optional) 
     * @param minEffectiveToFilter (optional) 
     * @param fullLinkFilter (optional) 
     * @param statusFilter (optional) 
     * @param imageLinkFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param lotteryCodeFilter (optional) 
     * @return Success
     */
    getGameSettingsToExcelOutlet(filter: string | null | undefined, codeFilter: string | null | undefined, nameFilter: string | null | undefined, maxEffectiveFromFilter: moment.Moment | null | undefined, minEffectiveFromFilter: moment.Moment | null | undefined, maxEffectiveToFilter: moment.Moment | null | undefined, minEffectiveToFilter: moment.Moment | null | undefined, fullLinkFilter: string | null | undefined, statusFilter: string | null | undefined, imageLinkFilter: string | null | undefined, descriptionFilter: string | null | undefined, lotteryCodeFilter: string | null | undefined): Observable<SocialRetailerFileDto> {
        let url_ = this.baseUrl + "/api/services/app/GameSettings/GetGameSettingsToExcelOutlet?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&";
        if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (maxEffectiveFromFilter !== undefined)
            url_ += "MaxEffectiveFromFilter=" + encodeURIComponent(maxEffectiveFromFilter ? "" + maxEffectiveFromFilter.toJSON() : "") + "&";
        if (minEffectiveFromFilter !== undefined)
            url_ += "MinEffectiveFromFilter=" + encodeURIComponent(minEffectiveFromFilter ? "" + minEffectiveFromFilter.toJSON() : "") + "&";
        if (maxEffectiveToFilter !== undefined)
            url_ += "MaxEffectiveToFilter=" + encodeURIComponent(maxEffectiveToFilter ? "" + maxEffectiveToFilter.toJSON() : "") + "&";
        if (minEffectiveToFilter !== undefined)
            url_ += "MinEffectiveToFilter=" + encodeURIComponent(minEffectiveToFilter ? "" + minEffectiveToFilter.toJSON() : "") + "&";
        if (fullLinkFilter !== undefined)
            url_ += "FullLinkFilter=" + encodeURIComponent("" + fullLinkFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (imageLinkFilter !== undefined)
            url_ += "ImageLinkFilter=" + encodeURIComponent("" + imageLinkFilter) + "&";
        if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&";
        if (lotteryCodeFilter !== undefined)
            url_ += "LotteryCodeFilter=" + encodeURIComponent("" + lotteryCodeFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetGameSettingsToExcelOutlet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGameSettingsToExcelOutlet(<any>response_);
                } catch (e) {
                    return <Observable<SocialRetailerFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SocialRetailerFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetGameSettingsToExcelOutlet(response: HttpResponseBase): Observable<SocialRetailerFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? SocialRetailerFileDto.fromJS(resultData200) : new SocialRetailerFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SocialRetailerFileDto>(<any>null);
    }
}

@Injectable()
export class GameTargetAudienceDetailsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param maxGameTargetAudienceIDFilter (optional) 
     * @param minGameTargetAudienceIDFilter (optional) 
     * @param nameFilter (optional) 
     * @param phoneFilter (optional) 
     * @param zaloChatIDFilter (optional) 
     * @param emailFilter (optional) 
     * @param facebookIDFilter (optional) 
     * @param memberCodeFilter (optional) 
     * @param communicationLanguageFilter (optional) 
     * @param communicationChannelFilter (optional) 
     * @param outletCodeFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, maxGameTargetAudienceIDFilter: number | null | undefined, minGameTargetAudienceIDFilter: number | null | undefined, nameFilter: string | null | undefined, phoneFilter: string | null | undefined, zaloChatIDFilter: string | null | undefined, emailFilter: string | null | undefined, facebookIDFilter: string | null | undefined, memberCodeFilter: string | null | undefined, communicationLanguageFilter: string | null | undefined, communicationChannelFilter: string | null | undefined, outletCodeFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetGameTargetAudienceDetailForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/GameTargetAudienceDetails/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxGameTargetAudienceIDFilter !== undefined)
            url_ += "MaxGameTargetAudienceIDFilter=" + encodeURIComponent("" + maxGameTargetAudienceIDFilter) + "&";
        if (minGameTargetAudienceIDFilter !== undefined)
            url_ += "MinGameTargetAudienceIDFilter=" + encodeURIComponent("" + minGameTargetAudienceIDFilter) + "&";
        if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (phoneFilter !== undefined)
            url_ += "PhoneFilter=" + encodeURIComponent("" + phoneFilter) + "&";
        if (zaloChatIDFilter !== undefined)
            url_ += "ZaloChatIDFilter=" + encodeURIComponent("" + zaloChatIDFilter) + "&";
        if (emailFilter !== undefined)
            url_ += "EmailFilter=" + encodeURIComponent("" + emailFilter) + "&";
        if (facebookIDFilter !== undefined)
            url_ += "FacebookIDFilter=" + encodeURIComponent("" + facebookIDFilter) + "&";
        if (memberCodeFilter !== undefined)
            url_ += "MemberCodeFilter=" + encodeURIComponent("" + memberCodeFilter) + "&";
        if (communicationLanguageFilter !== undefined)
            url_ += "CommunicationLanguageFilter=" + encodeURIComponent("" + communicationLanguageFilter) + "&";
        if (communicationChannelFilter !== undefined)
            url_ += "CommunicationChannelFilter=" + encodeURIComponent("" + communicationChannelFilter) + "&";
        if (outletCodeFilter !== undefined)
            url_ += "OutletCodeFilter=" + encodeURIComponent("" + outletCodeFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetGameTargetAudienceDetailForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetGameTargetAudienceDetailForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetGameTargetAudienceDetailForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetGameTargetAudienceDetailForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetGameTargetAudienceDetailForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetGameTargetAudienceDetailForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getGameTargetAudienceDetailForEdit(id: number | null | undefined): Observable<GetGameTargetAudienceDetailForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/GameTargetAudienceDetails/GetGameTargetAudienceDetailForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetGameTargetAudienceDetailForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGameTargetAudienceDetailForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetGameTargetAudienceDetailForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetGameTargetAudienceDetailForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetGameTargetAudienceDetailForEdit(response: HttpResponseBase): Observable<GetGameTargetAudienceDetailForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetGameTargetAudienceDetailForEditOutput.fromJS(resultData200) : new GetGameTargetAudienceDetailForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetGameTargetAudienceDetailForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditGameTargetAudienceDetailDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GameTargetAudienceDetails/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GameTargetAudienceDetails/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param maxGameTargetAudienceIDFilter (optional) 
     * @param minGameTargetAudienceIDFilter (optional) 
     * @param nameFilter (optional) 
     * @param phoneFilter (optional) 
     * @param zaloChatIDFilter (optional) 
     * @param emailFilter (optional) 
     * @param facebookIDFilter (optional) 
     * @param memberCodeFilter (optional) 
     * @param communicationLanguageFilter (optional) 
     * @param communicationChannelFilter (optional) 
     * @param outletCodeFilter (optional) 
     * @return Success
     */
    getGameTargetAudienceDetailsToExcel(filter: string | null | undefined, maxGameTargetAudienceIDFilter: number | null | undefined, minGameTargetAudienceIDFilter: number | null | undefined, nameFilter: string | null | undefined, phoneFilter: string | null | undefined, zaloChatIDFilter: string | null | undefined, emailFilter: string | null | undefined, facebookIDFilter: string | null | undefined, memberCodeFilter: string | null | undefined, communicationLanguageFilter: string | null | undefined, communicationChannelFilter: string | null | undefined, outletCodeFilter: string | null | undefined): Observable<GamificationFileDto> {
        let url_ = this.baseUrl + "/api/services/app/GameTargetAudienceDetails/GetGameTargetAudienceDetailsToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxGameTargetAudienceIDFilter !== undefined)
            url_ += "MaxGameTargetAudienceIDFilter=" + encodeURIComponent("" + maxGameTargetAudienceIDFilter) + "&";
        if (minGameTargetAudienceIDFilter !== undefined)
            url_ += "MinGameTargetAudienceIDFilter=" + encodeURIComponent("" + minGameTargetAudienceIDFilter) + "&";
        if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (phoneFilter !== undefined)
            url_ += "PhoneFilter=" + encodeURIComponent("" + phoneFilter) + "&";
        if (zaloChatIDFilter !== undefined)
            url_ += "ZaloChatIDFilter=" + encodeURIComponent("" + zaloChatIDFilter) + "&";
        if (emailFilter !== undefined)
            url_ += "EmailFilter=" + encodeURIComponent("" + emailFilter) + "&";
        if (facebookIDFilter !== undefined)
            url_ += "FacebookIDFilter=" + encodeURIComponent("" + facebookIDFilter) + "&";
        if (memberCodeFilter !== undefined)
            url_ += "MemberCodeFilter=" + encodeURIComponent("" + memberCodeFilter) + "&";
        if (communicationLanguageFilter !== undefined)
            url_ += "CommunicationLanguageFilter=" + encodeURIComponent("" + communicationLanguageFilter) + "&";
        if (communicationChannelFilter !== undefined)
            url_ += "CommunicationChannelFilter=" + encodeURIComponent("" + communicationChannelFilter) + "&";
        if (outletCodeFilter !== undefined)
            url_ += "OutletCodeFilter=" + encodeURIComponent("" + outletCodeFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetGameTargetAudienceDetailsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGameTargetAudienceDetailsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<GamificationFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GamificationFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetGameTargetAudienceDetailsToExcel(response: HttpResponseBase): Observable<GamificationFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GamificationFileDto.fromJS(resultData200) : new GamificationFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GamificationFileDto>(<any>null);
    }
}

@Injectable()
export class GameTargetAudienceDetailsExcelExporterServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param gameTargetAudienceDetails (optional) 
     * @return Success
     */
    exportToFile(gameTargetAudienceDetails: GetGameTargetAudienceDetailForViewDto[] | null | undefined): Observable<GamificationFileDto> {
        let url_ = this.baseUrl + "/api/services/app/GameTargetAudienceDetailsExcelExporter/ExportToFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(gameTargetAudienceDetails);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processExportToFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportToFile(<any>response_);
                } catch (e) {
                    return <Observable<GamificationFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GamificationFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processExportToFile(response: HttpResponseBase): Observable<GamificationFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GamificationFileDto.fromJS(resultData200) : new GamificationFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GamificationFileDto>(<any>null);
    }
}

@Injectable()
export class GameTargetAudiencesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param targetAudienceNameFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param statusFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, targetAudienceNameFilter: string | null | undefined, descriptionFilter: string | null | undefined, statusFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetGameTargetAudienceForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/GameTargetAudiences/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (targetAudienceNameFilter !== undefined)
            url_ += "TargetAudienceNameFilter=" + encodeURIComponent("" + targetAudienceNameFilter) + "&";
        if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetGameTargetAudienceForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetGameTargetAudienceForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetGameTargetAudienceForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetGameTargetAudienceForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetGameTargetAudienceForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetGameTargetAudienceForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getGameTargetAudienceForEdit(id: number | null | undefined): Observable<GetGameTargetAudienceForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/GameTargetAudiences/GetGameTargetAudienceForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetGameTargetAudienceForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGameTargetAudienceForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetGameTargetAudienceForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetGameTargetAudienceForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetGameTargetAudienceForEdit(response: HttpResponseBase): Observable<GetGameTargetAudienceForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetGameTargetAudienceForEditOutput.fromJS(resultData200) : new GetGameTargetAudienceForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetGameTargetAudienceForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditGameTargetAudienceDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GameTargetAudiences/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GameTargetAudiences/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param targetAudienceNameFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param statusFilter (optional) 
     * @return Success
     */
    getGameTargetAudiencesToExcel(filter: string | null | undefined, targetAudienceNameFilter: string | null | undefined, descriptionFilter: string | null | undefined, statusFilter: string | null | undefined): Observable<GamificationFileDto> {
        let url_ = this.baseUrl + "/api/services/app/GameTargetAudiences/GetGameTargetAudiencesToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (targetAudienceNameFilter !== undefined)
            url_ += "TargetAudienceNameFilter=" + encodeURIComponent("" + targetAudienceNameFilter) + "&";
        if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetGameTargetAudiencesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGameTargetAudiencesToExcel(<any>response_);
                } catch (e) {
                    return <Observable<GamificationFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GamificationFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetGameTargetAudiencesToExcel(response: HttpResponseBase): Observable<GamificationFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GamificationFileDto.fromJS(resultData200) : new GamificationFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GamificationFileDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    search(input: GetAllGameTargetAudiencesInput | null | undefined): Observable<PagedResultDtoOfGetGameTargetAudienceForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/GameTargetAudiences/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetGameTargetAudienceForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetGameTargetAudienceForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<PagedResultDtoOfGetGameTargetAudienceForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetGameTargetAudienceForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetGameTargetAudienceForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetGameTargetAudienceForViewDto>(<any>null);
    }
}

@Injectable()
export class GameTargetAudiencesExcelExporterServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param gameTargetAudiences (optional) 
     * @return Success
     */
    exportToFile(gameTargetAudiences: GetGameTargetAudienceForViewDto[] | null | undefined): Observable<GamificationFileDto> {
        let url_ = this.baseUrl + "/api/services/app/GameTargetAudiencesExcelExporter/ExportToFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(gameTargetAudiences);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processExportToFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportToFile(<any>response_);
                } catch (e) {
                    return <Observable<GamificationFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GamificationFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processExportToFile(response: HttpResponseBase): Observable<GamificationFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GamificationFileDto.fromJS(resultData200) : new GamificationFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GamificationFileDto>(<any>null);
    }
}

@Injectable()
export class GeneratedVouchersServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param voucherGroupCodeFilter (optional) 
     * @param patternCodeFilter (optional) 
     * @param voucherCodeFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, voucherGroupCodeFilter: string | null | undefined, patternCodeFilter: string | null | undefined, voucherCodeFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetGeneratedVoucherForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/GeneratedVouchers/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (voucherGroupCodeFilter !== undefined)
            url_ += "VoucherGroupCodeFilter=" + encodeURIComponent("" + voucherGroupCodeFilter) + "&";
        if (patternCodeFilter !== undefined)
            url_ += "PatternCodeFilter=" + encodeURIComponent("" + patternCodeFilter) + "&";
        if (voucherCodeFilter !== undefined)
            url_ += "VoucherCodeFilter=" + encodeURIComponent("" + voucherCodeFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetGeneratedVoucherForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetGeneratedVoucherForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetGeneratedVoucherForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetGeneratedVoucherForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetGeneratedVoucherForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetGeneratedVoucherForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getGeneratedVoucherForEdit(id: number | null | undefined): Observable<GetGeneratedVoucherForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/GeneratedVouchers/GetGeneratedVoucherForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetGeneratedVoucherForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGeneratedVoucherForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetGeneratedVoucherForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetGeneratedVoucherForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetGeneratedVoucherForEdit(response: HttpResponseBase): Observable<GetGeneratedVoucherForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetGeneratedVoucherForEditOutput.fromJS(resultData200) : new GetGeneratedVoucherForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetGeneratedVoucherForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditGeneratedVoucherDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GeneratedVouchers/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GeneratedVouchers/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param voucherGroupCodeFilter (optional) 
     * @param patternCodeFilter (optional) 
     * @param voucherCodeFilter (optional) 
     * @return Success
     */
    getGeneratedVouchersToExcel(filter: string | null | undefined, voucherGroupCodeFilter: string | null | undefined, patternCodeFilter: string | null | undefined, voucherCodeFilter: string | null | undefined): Observable<RewardsFileDto> {
        let url_ = this.baseUrl + "/api/services/app/GeneratedVouchers/GetGeneratedVouchersToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (voucherGroupCodeFilter !== undefined)
            url_ += "VoucherGroupCodeFilter=" + encodeURIComponent("" + voucherGroupCodeFilter) + "&";
        if (patternCodeFilter !== undefined)
            url_ += "PatternCodeFilter=" + encodeURIComponent("" + patternCodeFilter) + "&";
        if (voucherCodeFilter !== undefined)
            url_ += "VoucherCodeFilter=" + encodeURIComponent("" + voucherCodeFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetGeneratedVouchersToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGeneratedVouchersToExcel(<any>response_);
                } catch (e) {
                    return <Observable<RewardsFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<RewardsFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetGeneratedVouchersToExcel(response: HttpResponseBase): Observable<RewardsFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? RewardsFileDto.fromJS(resultData200) : new RewardsFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RewardsFileDto>(<any>null);
    }
}

@Injectable()
export class GeneratorDetailsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param generatorCodeFilter (optional) 
     * @param maxOrdinalFilter (optional) 
     * @param minOrdinalFilter (optional) 
     * @param syntaxCodeFilter (optional) 
     * @param parameterValue1Filter (optional) 
     * @param parameterValue2Filter (optional) 
     * @param generatorDetailIDFilter (optional) 
     * @param lastValueFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, generatorCodeFilter: string | null | undefined, maxOrdinalFilter: number | null | undefined, minOrdinalFilter: number | null | undefined, syntaxCodeFilter: string | null | undefined, parameterValue1Filter: string | null | undefined, parameterValue2Filter: string | null | undefined, generatorDetailIDFilter: string | null | undefined, lastValueFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetGeneratorDetailForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/GeneratorDetails/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (generatorCodeFilter !== undefined)
            url_ += "GeneratorCodeFilter=" + encodeURIComponent("" + generatorCodeFilter) + "&";
        if (maxOrdinalFilter !== undefined)
            url_ += "MaxOrdinalFilter=" + encodeURIComponent("" + maxOrdinalFilter) + "&";
        if (minOrdinalFilter !== undefined)
            url_ += "MinOrdinalFilter=" + encodeURIComponent("" + minOrdinalFilter) + "&";
        if (syntaxCodeFilter !== undefined)
            url_ += "SyntaxCodeFilter=" + encodeURIComponent("" + syntaxCodeFilter) + "&";
        if (parameterValue1Filter !== undefined)
            url_ += "ParameterValue1Filter=" + encodeURIComponent("" + parameterValue1Filter) + "&";
        if (parameterValue2Filter !== undefined)
            url_ += "ParameterValue2Filter=" + encodeURIComponent("" + parameterValue2Filter) + "&";
        if (generatorDetailIDFilter !== undefined)
            url_ += "GeneratorDetailIDFilter=" + encodeURIComponent("" + generatorDetailIDFilter) + "&";
        if (lastValueFilter !== undefined)
            url_ += "LastValueFilter=" + encodeURIComponent("" + lastValueFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetGeneratorDetailForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetGeneratorDetailForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetGeneratorDetailForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetGeneratorDetailForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetGeneratorDetailForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetGeneratorDetailForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getGeneratorDetailForEdit(id: number | null | undefined): Observable<GetGeneratorDetailForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/GeneratorDetails/GetGeneratorDetailForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetGeneratorDetailForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGeneratorDetailForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetGeneratorDetailForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetGeneratorDetailForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetGeneratorDetailForEdit(response: HttpResponseBase): Observable<GetGeneratorDetailForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetGeneratorDetailForEditOutput.fromJS(resultData200) : new GetGeneratorDetailForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetGeneratorDetailForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditGeneratorDetailDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GeneratorDetails/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GeneratorDetails/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param generatorCodeFilter (optional) 
     * @param maxOrdinalFilter (optional) 
     * @param minOrdinalFilter (optional) 
     * @param syntaxCodeFilter (optional) 
     * @param parameterValue1Filter (optional) 
     * @param parameterValue2Filter (optional) 
     * @param generatorDetailIDFilter (optional) 
     * @param lastValueFilter (optional) 
     * @return Success
     */
    getGeneratorDetailsToExcel(filter: string | null | undefined, generatorCodeFilter: string | null | undefined, maxOrdinalFilter: number | null | undefined, minOrdinalFilter: number | null | undefined, syntaxCodeFilter: string | null | undefined, parameterValue1Filter: string | null | undefined, parameterValue2Filter: string | null | undefined, generatorDetailIDFilter: string | null | undefined, lastValueFilter: string | null | undefined): Observable<CodeGeneratorFileDto> {
        let url_ = this.baseUrl + "/api/services/app/GeneratorDetails/GetGeneratorDetailsToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (generatorCodeFilter !== undefined)
            url_ += "GeneratorCodeFilter=" + encodeURIComponent("" + generatorCodeFilter) + "&";
        if (maxOrdinalFilter !== undefined)
            url_ += "MaxOrdinalFilter=" + encodeURIComponent("" + maxOrdinalFilter) + "&";
        if (minOrdinalFilter !== undefined)
            url_ += "MinOrdinalFilter=" + encodeURIComponent("" + minOrdinalFilter) + "&";
        if (syntaxCodeFilter !== undefined)
            url_ += "SyntaxCodeFilter=" + encodeURIComponent("" + syntaxCodeFilter) + "&";
        if (parameterValue1Filter !== undefined)
            url_ += "ParameterValue1Filter=" + encodeURIComponent("" + parameterValue1Filter) + "&";
        if (parameterValue2Filter !== undefined)
            url_ += "ParameterValue2Filter=" + encodeURIComponent("" + parameterValue2Filter) + "&";
        if (generatorDetailIDFilter !== undefined)
            url_ += "GeneratorDetailIDFilter=" + encodeURIComponent("" + generatorDetailIDFilter) + "&";
        if (lastValueFilter !== undefined)
            url_ += "LastValueFilter=" + encodeURIComponent("" + lastValueFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetGeneratorDetailsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGeneratorDetailsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<CodeGeneratorFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CodeGeneratorFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetGeneratorDetailsToExcel(response: HttpResponseBase): Observable<CodeGeneratorFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? CodeGeneratorFileDto.fromJS(resultData200) : new CodeGeneratorFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CodeGeneratorFileDto>(<any>null);
    }
}

@Injectable()
export class GeneratorHeadersServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param generatorCodeFilter (optional) 
     * @param generatorNameFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param delimiterFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, generatorCodeFilter: string | null | undefined, generatorNameFilter: string | null | undefined, descriptionFilter: string | null | undefined, delimiterFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetGeneratorHeaderForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/GeneratorHeaders/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (generatorCodeFilter !== undefined)
            url_ += "GeneratorCodeFilter=" + encodeURIComponent("" + generatorCodeFilter) + "&";
        if (generatorNameFilter !== undefined)
            url_ += "GeneratorNameFilter=" + encodeURIComponent("" + generatorNameFilter) + "&";
        if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&";
        if (delimiterFilter !== undefined)
            url_ += "DelimiterFilter=" + encodeURIComponent("" + delimiterFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetGeneratorHeaderForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetGeneratorHeaderForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetGeneratorHeaderForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetGeneratorHeaderForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetGeneratorHeaderForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetGeneratorHeaderForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getGeneratorHeaderForEdit(id: number | null | undefined): Observable<GetGeneratorHeaderForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/GeneratorHeaders/GetGeneratorHeaderForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetGeneratorHeaderForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGeneratorHeaderForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetGeneratorHeaderForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetGeneratorHeaderForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetGeneratorHeaderForEdit(response: HttpResponseBase): Observable<GetGeneratorHeaderForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetGeneratorHeaderForEditOutput.fromJS(resultData200) : new GetGeneratorHeaderForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetGeneratorHeaderForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditGeneratorHeaderDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GeneratorHeaders/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GeneratorHeaders/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param generatorCodeFilter (optional) 
     * @param generatorNameFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param delimiterFilter (optional) 
     * @return Success
     */
    getGeneratorHeadersToExcel(filter: string | null | undefined, generatorCodeFilter: string | null | undefined, generatorNameFilter: string | null | undefined, descriptionFilter: string | null | undefined, delimiterFilter: string | null | undefined): Observable<CodeGeneratorFileDto> {
        let url_ = this.baseUrl + "/api/services/app/GeneratorHeaders/GetGeneratorHeadersToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (generatorCodeFilter !== undefined)
            url_ += "GeneratorCodeFilter=" + encodeURIComponent("" + generatorCodeFilter) + "&";
        if (generatorNameFilter !== undefined)
            url_ += "GeneratorNameFilter=" + encodeURIComponent("" + generatorNameFilter) + "&";
        if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&";
        if (delimiterFilter !== undefined)
            url_ += "DelimiterFilter=" + encodeURIComponent("" + delimiterFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetGeneratorHeadersToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGeneratorHeadersToExcel(<any>response_);
                } catch (e) {
                    return <Observable<CodeGeneratorFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CodeGeneratorFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetGeneratorHeadersToExcel(response: HttpResponseBase): Observable<CodeGeneratorFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? CodeGeneratorFileDto.fromJS(resultData200) : new CodeGeneratorFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CodeGeneratorFileDto>(<any>null);
    }

    /**
     * @return Success
     */
    genMemberID(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/GeneratorHeaders/GenMemberID";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGenMemberID(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenMemberID(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGenMemberID(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @return Success
     */
    autoGenGameSettingCodeAsync(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/GeneratorHeaders/AutoGenGameSettingCodeAsync";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processAutoGenGameSettingCodeAsync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAutoGenGameSettingCodeAsync(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processAutoGenGameSettingCodeAsync(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param generatorCode (optional) 
     * @param numberOfCodes (optional) 
     * @return Success
     */
    genCode(generatorCode: string | null | undefined, numberOfCodes: number | null | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/GeneratorHeaders/GenCode?";
        if (generatorCode !== undefined)
            url_ += "generatorCode=" + encodeURIComponent("" + generatorCode) + "&";
        if (numberOfCodes !== undefined)
            url_ += "numberOfCodes=" + encodeURIComponent("" + numberOfCodes) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGenCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenCode(<any>response_);
                } catch (e) {
                    return <Observable<string[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<string[]>><any>_observableThrow(response_);
        }));
    }

    protected processGenCode(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(item);
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string[]>(<any>null);
    }
}

@Injectable()
export class GiftCampaignsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param codeFilter (optional) 
     * @param nameFilter (optional) 
     * @param nameUnsignFilter (optional) 
     * @param targetAudienceTypeFilter (optional) 
     * @param maxTargetAudienceIDFilter (optional) 
     * @param minTargetAudienceIDFilter (optional) 
     * @param publisherCodeFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param imageLinkFilter (optional) 
     * @param statusFilter (optional) 
     * @param cronFilter (optional) 
     * @param giftMasterCodeFilter (optional) 
     * @param giftMasterNameFilter (optional) 
     * @param maxGiftMasterValueFilter (optional) 
     * @param minGiftMasterValueFilter (optional) 
     * @param maxQuantityFilter (optional) 
     * @param minQuantityFilter (optional) 
     * @param maxQuantityAllocatedFilter (optional) 
     * @param minQuantityAllocatedFilter (optional) 
     * @param maxRemainingQuantityFilter (optional) 
     * @param minRemainingQuantityFilter (optional) 
     * @param maxEffectiveFromFilter (optional) 
     * @param minEffectiveFromFilter (optional) 
     * @param maxEffectiveToFilter (optional) 
     * @param minEffectiveToFilter (optional) 
     * @param maxExpireDateFilter (optional) 
     * @param minExpireDateFilter (optional) 
     * @param isGrantedFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, codeFilter: string | null | undefined, nameFilter: string | null | undefined, nameUnsignFilter: string | null | undefined, targetAudienceTypeFilter: string | null | undefined, maxTargetAudienceIDFilter: number | null | undefined, minTargetAudienceIDFilter: number | null | undefined, publisherCodeFilter: string | null | undefined, descriptionFilter: string | null | undefined, imageLinkFilter: string | null | undefined, statusFilter: string | null | undefined, cronFilter: string | null | undefined, giftMasterCodeFilter: string | null | undefined, giftMasterNameFilter: string | null | undefined, maxGiftMasterValueFilter: number | null | undefined, minGiftMasterValueFilter: number | null | undefined, maxQuantityFilter: number | null | undefined, minQuantityFilter: number | null | undefined, maxQuantityAllocatedFilter: number | null | undefined, minQuantityAllocatedFilter: number | null | undefined, maxRemainingQuantityFilter: number | null | undefined, minRemainingQuantityFilter: number | null | undefined, maxEffectiveFromFilter: moment.Moment | null | undefined, minEffectiveFromFilter: moment.Moment | null | undefined, maxEffectiveToFilter: moment.Moment | null | undefined, minEffectiveToFilter: moment.Moment | null | undefined, maxExpireDateFilter: moment.Moment | null | undefined, minExpireDateFilter: moment.Moment | null | undefined, isGrantedFilter: number | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetGiftCampaignForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/GiftCampaigns/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&";
        if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (nameUnsignFilter !== undefined)
            url_ += "NameUnsignFilter=" + encodeURIComponent("" + nameUnsignFilter) + "&";
        if (targetAudienceTypeFilter !== undefined)
            url_ += "TargetAudienceTypeFilter=" + encodeURIComponent("" + targetAudienceTypeFilter) + "&";
        if (maxTargetAudienceIDFilter !== undefined)
            url_ += "MaxTargetAudienceIDFilter=" + encodeURIComponent("" + maxTargetAudienceIDFilter) + "&";
        if (minTargetAudienceIDFilter !== undefined)
            url_ += "MinTargetAudienceIDFilter=" + encodeURIComponent("" + minTargetAudienceIDFilter) + "&";
        if (publisherCodeFilter !== undefined)
            url_ += "PublisherCodeFilter=" + encodeURIComponent("" + publisherCodeFilter) + "&";
        if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&";
        if (imageLinkFilter !== undefined)
            url_ += "ImageLinkFilter=" + encodeURIComponent("" + imageLinkFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (cronFilter !== undefined)
            url_ += "CronFilter=" + encodeURIComponent("" + cronFilter) + "&";
        if (giftMasterCodeFilter !== undefined)
            url_ += "GiftMasterCodeFilter=" + encodeURIComponent("" + giftMasterCodeFilter) + "&";
        if (giftMasterNameFilter !== undefined)
            url_ += "GiftMasterNameFilter=" + encodeURIComponent("" + giftMasterNameFilter) + "&";
        if (maxGiftMasterValueFilter !== undefined)
            url_ += "MaxGiftMasterValueFilter=" + encodeURIComponent("" + maxGiftMasterValueFilter) + "&";
        if (minGiftMasterValueFilter !== undefined)
            url_ += "MinGiftMasterValueFilter=" + encodeURIComponent("" + minGiftMasterValueFilter) + "&";
        if (maxQuantityFilter !== undefined)
            url_ += "MaxQuantityFilter=" + encodeURIComponent("" + maxQuantityFilter) + "&";
        if (minQuantityFilter !== undefined)
            url_ += "MinQuantityFilter=" + encodeURIComponent("" + minQuantityFilter) + "&";
        if (maxQuantityAllocatedFilter !== undefined)
            url_ += "MaxQuantityAllocatedFilter=" + encodeURIComponent("" + maxQuantityAllocatedFilter) + "&";
        if (minQuantityAllocatedFilter !== undefined)
            url_ += "MinQuantityAllocatedFilter=" + encodeURIComponent("" + minQuantityAllocatedFilter) + "&";
        if (maxRemainingQuantityFilter !== undefined)
            url_ += "MaxRemainingQuantityFilter=" + encodeURIComponent("" + maxRemainingQuantityFilter) + "&";
        if (minRemainingQuantityFilter !== undefined)
            url_ += "MinRemainingQuantityFilter=" + encodeURIComponent("" + minRemainingQuantityFilter) + "&";
        if (maxEffectiveFromFilter !== undefined)
            url_ += "MaxEffectiveFromFilter=" + encodeURIComponent(maxEffectiveFromFilter ? "" + maxEffectiveFromFilter.toJSON() : "") + "&";
        if (minEffectiveFromFilter !== undefined)
            url_ += "MinEffectiveFromFilter=" + encodeURIComponent(minEffectiveFromFilter ? "" + minEffectiveFromFilter.toJSON() : "") + "&";
        if (maxEffectiveToFilter !== undefined)
            url_ += "MaxEffectiveToFilter=" + encodeURIComponent(maxEffectiveToFilter ? "" + maxEffectiveToFilter.toJSON() : "") + "&";
        if (minEffectiveToFilter !== undefined)
            url_ += "MinEffectiveToFilter=" + encodeURIComponent(minEffectiveToFilter ? "" + minEffectiveToFilter.toJSON() : "") + "&";
        if (maxExpireDateFilter !== undefined)
            url_ += "MaxExpireDateFilter=" + encodeURIComponent(maxExpireDateFilter ? "" + maxExpireDateFilter.toJSON() : "") + "&";
        if (minExpireDateFilter !== undefined)
            url_ += "MinExpireDateFilter=" + encodeURIComponent(minExpireDateFilter ? "" + minExpireDateFilter.toJSON() : "") + "&";
        if (isGrantedFilter !== undefined)
            url_ += "IsGrantedFilter=" + encodeURIComponent("" + isGrantedFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetGiftCampaignForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetGiftCampaignForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetGiftCampaignForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetGiftCampaignForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetGiftCampaignForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetGiftCampaignForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getGiftCampaignForEdit(id: number | null | undefined): Observable<GetGiftCampaignForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/GiftCampaigns/GetGiftCampaignForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetGiftCampaignForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGiftCampaignForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetGiftCampaignForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetGiftCampaignForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetGiftCampaignForEdit(response: HttpResponseBase): Observable<GetGiftCampaignForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetGiftCampaignForEditOutput.fromJS(resultData200) : new GetGiftCampaignForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetGiftCampaignForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditGiftCampaignDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GiftCampaigns/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GiftCampaigns/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param codeFilter (optional) 
     * @param nameFilter (optional) 
     * @param nameUnsignFilter (optional) 
     * @param targetAudienceTypeFilter (optional) 
     * @param maxTargetAudienceIDFilter (optional) 
     * @param minTargetAudienceIDFilter (optional) 
     * @param publisherCodeFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param imageLinkFilter (optional) 
     * @param statusFilter (optional) 
     * @param cronFilter (optional) 
     * @param giftMasterCodeFilter (optional) 
     * @param giftMasterNameFilter (optional) 
     * @param maxGiftMasterValueFilter (optional) 
     * @param minGiftMasterValueFilter (optional) 
     * @param maxQuantityFilter (optional) 
     * @param minQuantityFilter (optional) 
     * @param maxQuantityAllocatedFilter (optional) 
     * @param minQuantityAllocatedFilter (optional) 
     * @param maxRemainingQuantityFilter (optional) 
     * @param minRemainingQuantityFilter (optional) 
     * @param maxEffectiveFromFilter (optional) 
     * @param minEffectiveFromFilter (optional) 
     * @param maxEffectiveToFilter (optional) 
     * @param minEffectiveToFilter (optional) 
     * @param maxExpireDateFilter (optional) 
     * @param minExpireDateFilter (optional) 
     * @param isGrantedFilter (optional) 
     * @return Success
     */
    getGiftCampaignsToExcel(filter: string | null | undefined, codeFilter: string | null | undefined, nameFilter: string | null | undefined, nameUnsignFilter: string | null | undefined, targetAudienceTypeFilter: string | null | undefined, maxTargetAudienceIDFilter: number | null | undefined, minTargetAudienceIDFilter: number | null | undefined, publisherCodeFilter: string | null | undefined, descriptionFilter: string | null | undefined, imageLinkFilter: string | null | undefined, statusFilter: string | null | undefined, cronFilter: string | null | undefined, giftMasterCodeFilter: string | null | undefined, giftMasterNameFilter: string | null | undefined, maxGiftMasterValueFilter: number | null | undefined, minGiftMasterValueFilter: number | null | undefined, maxQuantityFilter: number | null | undefined, minQuantityFilter: number | null | undefined, maxQuantityAllocatedFilter: number | null | undefined, minQuantityAllocatedFilter: number | null | undefined, maxRemainingQuantityFilter: number | null | undefined, minRemainingQuantityFilter: number | null | undefined, maxEffectiveFromFilter: moment.Moment | null | undefined, minEffectiveFromFilter: moment.Moment | null | undefined, maxEffectiveToFilter: moment.Moment | null | undefined, minEffectiveToFilter: moment.Moment | null | undefined, maxExpireDateFilter: moment.Moment | null | undefined, minExpireDateFilter: moment.Moment | null | undefined, isGrantedFilter: number | null | undefined): Observable<GiftFileDto> {
        let url_ = this.baseUrl + "/api/services/app/GiftCampaigns/GetGiftCampaignsToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&";
        if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (nameUnsignFilter !== undefined)
            url_ += "NameUnsignFilter=" + encodeURIComponent("" + nameUnsignFilter) + "&";
        if (targetAudienceTypeFilter !== undefined)
            url_ += "TargetAudienceTypeFilter=" + encodeURIComponent("" + targetAudienceTypeFilter) + "&";
        if (maxTargetAudienceIDFilter !== undefined)
            url_ += "MaxTargetAudienceIDFilter=" + encodeURIComponent("" + maxTargetAudienceIDFilter) + "&";
        if (minTargetAudienceIDFilter !== undefined)
            url_ += "MinTargetAudienceIDFilter=" + encodeURIComponent("" + minTargetAudienceIDFilter) + "&";
        if (publisherCodeFilter !== undefined)
            url_ += "PublisherCodeFilter=" + encodeURIComponent("" + publisherCodeFilter) + "&";
        if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&";
        if (imageLinkFilter !== undefined)
            url_ += "ImageLinkFilter=" + encodeURIComponent("" + imageLinkFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (cronFilter !== undefined)
            url_ += "CronFilter=" + encodeURIComponent("" + cronFilter) + "&";
        if (giftMasterCodeFilter !== undefined)
            url_ += "GiftMasterCodeFilter=" + encodeURIComponent("" + giftMasterCodeFilter) + "&";
        if (giftMasterNameFilter !== undefined)
            url_ += "GiftMasterNameFilter=" + encodeURIComponent("" + giftMasterNameFilter) + "&";
        if (maxGiftMasterValueFilter !== undefined)
            url_ += "MaxGiftMasterValueFilter=" + encodeURIComponent("" + maxGiftMasterValueFilter) + "&";
        if (minGiftMasterValueFilter !== undefined)
            url_ += "MinGiftMasterValueFilter=" + encodeURIComponent("" + minGiftMasterValueFilter) + "&";
        if (maxQuantityFilter !== undefined)
            url_ += "MaxQuantityFilter=" + encodeURIComponent("" + maxQuantityFilter) + "&";
        if (minQuantityFilter !== undefined)
            url_ += "MinQuantityFilter=" + encodeURIComponent("" + minQuantityFilter) + "&";
        if (maxQuantityAllocatedFilter !== undefined)
            url_ += "MaxQuantityAllocatedFilter=" + encodeURIComponent("" + maxQuantityAllocatedFilter) + "&";
        if (minQuantityAllocatedFilter !== undefined)
            url_ += "MinQuantityAllocatedFilter=" + encodeURIComponent("" + minQuantityAllocatedFilter) + "&";
        if (maxRemainingQuantityFilter !== undefined)
            url_ += "MaxRemainingQuantityFilter=" + encodeURIComponent("" + maxRemainingQuantityFilter) + "&";
        if (minRemainingQuantityFilter !== undefined)
            url_ += "MinRemainingQuantityFilter=" + encodeURIComponent("" + minRemainingQuantityFilter) + "&";
        if (maxEffectiveFromFilter !== undefined)
            url_ += "MaxEffectiveFromFilter=" + encodeURIComponent(maxEffectiveFromFilter ? "" + maxEffectiveFromFilter.toJSON() : "") + "&";
        if (minEffectiveFromFilter !== undefined)
            url_ += "MinEffectiveFromFilter=" + encodeURIComponent(minEffectiveFromFilter ? "" + minEffectiveFromFilter.toJSON() : "") + "&";
        if (maxEffectiveToFilter !== undefined)
            url_ += "MaxEffectiveToFilter=" + encodeURIComponent(maxEffectiveToFilter ? "" + maxEffectiveToFilter.toJSON() : "") + "&";
        if (minEffectiveToFilter !== undefined)
            url_ += "MinEffectiveToFilter=" + encodeURIComponent(minEffectiveToFilter ? "" + minEffectiveToFilter.toJSON() : "") + "&";
        if (maxExpireDateFilter !== undefined)
            url_ += "MaxExpireDateFilter=" + encodeURIComponent(maxExpireDateFilter ? "" + maxExpireDateFilter.toJSON() : "") + "&";
        if (minExpireDateFilter !== undefined)
            url_ += "MinExpireDateFilter=" + encodeURIComponent(minExpireDateFilter ? "" + minExpireDateFilter.toJSON() : "") + "&";
        if (isGrantedFilter !== undefined)
            url_ += "IsGrantedFilter=" + encodeURIComponent("" + isGrantedFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetGiftCampaignsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGiftCampaignsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<GiftFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GiftFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetGiftCampaignsToExcel(response: HttpResponseBase): Observable<GiftFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GiftFileDto.fromJS(resultData200) : new GiftFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GiftFileDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param codeFilter (optional) 
     * @param nameFilter (optional) 
     * @param nameUnsignFilter (optional) 
     * @param targetAudienceTypeFilter (optional) 
     * @param maxTargetAudienceIDFilter (optional) 
     * @param minTargetAudienceIDFilter (optional) 
     * @param publisherCodeFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param imageLinkFilter (optional) 
     * @param statusFilter (optional) 
     * @param cronFilter (optional) 
     * @param giftMasterCodeFilter (optional) 
     * @param giftMasterNameFilter (optional) 
     * @param maxGiftMasterValueFilter (optional) 
     * @param minGiftMasterValueFilter (optional) 
     * @param maxQuantityFilter (optional) 
     * @param minQuantityFilter (optional) 
     * @param maxQuantityAllocatedFilter (optional) 
     * @param minQuantityAllocatedFilter (optional) 
     * @param maxRemainingQuantityFilter (optional) 
     * @param minRemainingQuantityFilter (optional) 
     * @param maxEffectiveFromFilter (optional) 
     * @param minEffectiveFromFilter (optional) 
     * @param maxEffectiveToFilter (optional) 
     * @param minEffectiveToFilter (optional) 
     * @param maxExpireDateFilter (optional) 
     * @param minExpireDateFilter (optional) 
     * @param isGrantedFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllExt(filter: string | null | undefined, codeFilter: string | null | undefined, nameFilter: string | null | undefined, nameUnsignFilter: string | null | undefined, targetAudienceTypeFilter: string | null | undefined, maxTargetAudienceIDFilter: number | null | undefined, minTargetAudienceIDFilter: number | null | undefined, publisherCodeFilter: string | null | undefined, descriptionFilter: string | null | undefined, imageLinkFilter: string | null | undefined, statusFilter: string | null | undefined, cronFilter: string | null | undefined, giftMasterCodeFilter: string | null | undefined, giftMasterNameFilter: string | null | undefined, maxGiftMasterValueFilter: number | null | undefined, minGiftMasterValueFilter: number | null | undefined, maxQuantityFilter: number | null | undefined, minQuantityFilter: number | null | undefined, maxQuantityAllocatedFilter: number | null | undefined, minQuantityAllocatedFilter: number | null | undefined, maxRemainingQuantityFilter: number | null | undefined, minRemainingQuantityFilter: number | null | undefined, maxEffectiveFromFilter: moment.Moment | null | undefined, minEffectiveFromFilter: moment.Moment | null | undefined, maxEffectiveToFilter: moment.Moment | null | undefined, minEffectiveToFilter: moment.Moment | null | undefined, maxExpireDateFilter: moment.Moment | null | undefined, minExpireDateFilter: moment.Moment | null | undefined, isGrantedFilter: number | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetGiftCampaignForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/GiftCampaigns/GetAllExt?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&";
        if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (nameUnsignFilter !== undefined)
            url_ += "NameUnsignFilter=" + encodeURIComponent("" + nameUnsignFilter) + "&";
        if (targetAudienceTypeFilter !== undefined)
            url_ += "TargetAudienceTypeFilter=" + encodeURIComponent("" + targetAudienceTypeFilter) + "&";
        if (maxTargetAudienceIDFilter !== undefined)
            url_ += "MaxTargetAudienceIDFilter=" + encodeURIComponent("" + maxTargetAudienceIDFilter) + "&";
        if (minTargetAudienceIDFilter !== undefined)
            url_ += "MinTargetAudienceIDFilter=" + encodeURIComponent("" + minTargetAudienceIDFilter) + "&";
        if (publisherCodeFilter !== undefined)
            url_ += "PublisherCodeFilter=" + encodeURIComponent("" + publisherCodeFilter) + "&";
        if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&";
        if (imageLinkFilter !== undefined)
            url_ += "ImageLinkFilter=" + encodeURIComponent("" + imageLinkFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (cronFilter !== undefined)
            url_ += "CronFilter=" + encodeURIComponent("" + cronFilter) + "&";
        if (giftMasterCodeFilter !== undefined)
            url_ += "GiftMasterCodeFilter=" + encodeURIComponent("" + giftMasterCodeFilter) + "&";
        if (giftMasterNameFilter !== undefined)
            url_ += "GiftMasterNameFilter=" + encodeURIComponent("" + giftMasterNameFilter) + "&";
        if (maxGiftMasterValueFilter !== undefined)
            url_ += "MaxGiftMasterValueFilter=" + encodeURIComponent("" + maxGiftMasterValueFilter) + "&";
        if (minGiftMasterValueFilter !== undefined)
            url_ += "MinGiftMasterValueFilter=" + encodeURIComponent("" + minGiftMasterValueFilter) + "&";
        if (maxQuantityFilter !== undefined)
            url_ += "MaxQuantityFilter=" + encodeURIComponent("" + maxQuantityFilter) + "&";
        if (minQuantityFilter !== undefined)
            url_ += "MinQuantityFilter=" + encodeURIComponent("" + minQuantityFilter) + "&";
        if (maxQuantityAllocatedFilter !== undefined)
            url_ += "MaxQuantityAllocatedFilter=" + encodeURIComponent("" + maxQuantityAllocatedFilter) + "&";
        if (minQuantityAllocatedFilter !== undefined)
            url_ += "MinQuantityAllocatedFilter=" + encodeURIComponent("" + minQuantityAllocatedFilter) + "&";
        if (maxRemainingQuantityFilter !== undefined)
            url_ += "MaxRemainingQuantityFilter=" + encodeURIComponent("" + maxRemainingQuantityFilter) + "&";
        if (minRemainingQuantityFilter !== undefined)
            url_ += "MinRemainingQuantityFilter=" + encodeURIComponent("" + minRemainingQuantityFilter) + "&";
        if (maxEffectiveFromFilter !== undefined)
            url_ += "MaxEffectiveFromFilter=" + encodeURIComponent(maxEffectiveFromFilter ? "" + maxEffectiveFromFilter.toJSON() : "") + "&";
        if (minEffectiveFromFilter !== undefined)
            url_ += "MinEffectiveFromFilter=" + encodeURIComponent(minEffectiveFromFilter ? "" + minEffectiveFromFilter.toJSON() : "") + "&";
        if (maxEffectiveToFilter !== undefined)
            url_ += "MaxEffectiveToFilter=" + encodeURIComponent(maxEffectiveToFilter ? "" + maxEffectiveToFilter.toJSON() : "") + "&";
        if (minEffectiveToFilter !== undefined)
            url_ += "MinEffectiveToFilter=" + encodeURIComponent(minEffectiveToFilter ? "" + minEffectiveToFilter.toJSON() : "") + "&";
        if (maxExpireDateFilter !== undefined)
            url_ += "MaxExpireDateFilter=" + encodeURIComponent(maxExpireDateFilter ? "" + maxExpireDateFilter.toJSON() : "") + "&";
        if (minExpireDateFilter !== undefined)
            url_ += "MinExpireDateFilter=" + encodeURIComponent(minExpireDateFilter ? "" + minExpireDateFilter.toJSON() : "") + "&";
        if (isGrantedFilter !== undefined)
            url_ += "IsGrantedFilter=" + encodeURIComponent("" + isGrantedFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllExt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllExt(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetGiftCampaignForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetGiftCampaignForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllExt(response: HttpResponseBase): Observable<PagedResultDtoOfGetGiftCampaignForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetGiftCampaignForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetGiftCampaignForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetGiftCampaignForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getGiftCampaignForEditExt(id: number | null | undefined): Observable<GetGiftCampaignForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/GiftCampaigns/GetGiftCampaignForEditExt?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetGiftCampaignForEditExt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGiftCampaignForEditExt(<any>response_);
                } catch (e) {
                    return <Observable<GetGiftCampaignForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetGiftCampaignForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetGiftCampaignForEditExt(response: HttpResponseBase): Observable<GetGiftCampaignForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetGiftCampaignForEditOutput.fromJS(resultData200) : new GetGiftCampaignForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetGiftCampaignForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEditExt(input: CreateOrEditGiftCampaignDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GiftCampaigns/CreateOrEditExt";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEditExt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditExt(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEditExt(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param ids (optional) 
     * @return Success
     */
    deleteExt(ids: number[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GiftCampaigns/DeleteExt?";
        if (ids !== undefined)
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteExt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteExt(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteExt(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param arg (optional) 
     * @return Success
     */
    importQueue(arg: GiftCampaignsImportAgrs | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GiftCampaigns/ImportQueue";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(arg);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processImportQueue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportQueue(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processImportQueue(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param codeFilter (optional) 
     * @param nameFilter (optional) 
     * @param nameUnsignFilter (optional) 
     * @param targetAudienceTypeFilter (optional) 
     * @param maxTargetAudienceIDFilter (optional) 
     * @param minTargetAudienceIDFilter (optional) 
     * @param publisherCodeFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param imageLinkFilter (optional) 
     * @param statusFilter (optional) 
     * @param cronFilter (optional) 
     * @param giftMasterCodeFilter (optional) 
     * @param giftMasterNameFilter (optional) 
     * @param maxGiftMasterValueFilter (optional) 
     * @param minGiftMasterValueFilter (optional) 
     * @param maxQuantityFilter (optional) 
     * @param minQuantityFilter (optional) 
     * @param maxQuantityAllocatedFilter (optional) 
     * @param minQuantityAllocatedFilter (optional) 
     * @param maxRemainingQuantityFilter (optional) 
     * @param minRemainingQuantityFilter (optional) 
     * @param maxEffectiveFromFilter (optional) 
     * @param minEffectiveFromFilter (optional) 
     * @param maxEffectiveToFilter (optional) 
     * @param minEffectiveToFilter (optional) 
     * @param maxExpireDateFilter (optional) 
     * @param minExpireDateFilter (optional) 
     * @param isGrantedFilter (optional) 
     * @return Success
     */
    getGiftCampaignsToExcelExt(filter: string | null | undefined, codeFilter: string | null | undefined, nameFilter: string | null | undefined, nameUnsignFilter: string | null | undefined, targetAudienceTypeFilter: string | null | undefined, maxTargetAudienceIDFilter: number | null | undefined, minTargetAudienceIDFilter: number | null | undefined, publisherCodeFilter: string | null | undefined, descriptionFilter: string | null | undefined, imageLinkFilter: string | null | undefined, statusFilter: string | null | undefined, cronFilter: string | null | undefined, giftMasterCodeFilter: string | null | undefined, giftMasterNameFilter: string | null | undefined, maxGiftMasterValueFilter: number | null | undefined, minGiftMasterValueFilter: number | null | undefined, maxQuantityFilter: number | null | undefined, minQuantityFilter: number | null | undefined, maxQuantityAllocatedFilter: number | null | undefined, minQuantityAllocatedFilter: number | null | undefined, maxRemainingQuantityFilter: number | null | undefined, minRemainingQuantityFilter: number | null | undefined, maxEffectiveFromFilter: moment.Moment | null | undefined, minEffectiveFromFilter: moment.Moment | null | undefined, maxEffectiveToFilter: moment.Moment | null | undefined, minEffectiveToFilter: moment.Moment | null | undefined, maxExpireDateFilter: moment.Moment | null | undefined, minExpireDateFilter: moment.Moment | null | undefined, isGrantedFilter: number | null | undefined): Observable<GiftFileDto> {
        let url_ = this.baseUrl + "/api/services/app/GiftCampaigns/GetGiftCampaignsToExcelExt?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&";
        if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (nameUnsignFilter !== undefined)
            url_ += "NameUnsignFilter=" + encodeURIComponent("" + nameUnsignFilter) + "&";
        if (targetAudienceTypeFilter !== undefined)
            url_ += "TargetAudienceTypeFilter=" + encodeURIComponent("" + targetAudienceTypeFilter) + "&";
        if (maxTargetAudienceIDFilter !== undefined)
            url_ += "MaxTargetAudienceIDFilter=" + encodeURIComponent("" + maxTargetAudienceIDFilter) + "&";
        if (minTargetAudienceIDFilter !== undefined)
            url_ += "MinTargetAudienceIDFilter=" + encodeURIComponent("" + minTargetAudienceIDFilter) + "&";
        if (publisherCodeFilter !== undefined)
            url_ += "PublisherCodeFilter=" + encodeURIComponent("" + publisherCodeFilter) + "&";
        if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&";
        if (imageLinkFilter !== undefined)
            url_ += "ImageLinkFilter=" + encodeURIComponent("" + imageLinkFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (cronFilter !== undefined)
            url_ += "CronFilter=" + encodeURIComponent("" + cronFilter) + "&";
        if (giftMasterCodeFilter !== undefined)
            url_ += "GiftMasterCodeFilter=" + encodeURIComponent("" + giftMasterCodeFilter) + "&";
        if (giftMasterNameFilter !== undefined)
            url_ += "GiftMasterNameFilter=" + encodeURIComponent("" + giftMasterNameFilter) + "&";
        if (maxGiftMasterValueFilter !== undefined)
            url_ += "MaxGiftMasterValueFilter=" + encodeURIComponent("" + maxGiftMasterValueFilter) + "&";
        if (minGiftMasterValueFilter !== undefined)
            url_ += "MinGiftMasterValueFilter=" + encodeURIComponent("" + minGiftMasterValueFilter) + "&";
        if (maxQuantityFilter !== undefined)
            url_ += "MaxQuantityFilter=" + encodeURIComponent("" + maxQuantityFilter) + "&";
        if (minQuantityFilter !== undefined)
            url_ += "MinQuantityFilter=" + encodeURIComponent("" + minQuantityFilter) + "&";
        if (maxQuantityAllocatedFilter !== undefined)
            url_ += "MaxQuantityAllocatedFilter=" + encodeURIComponent("" + maxQuantityAllocatedFilter) + "&";
        if (minQuantityAllocatedFilter !== undefined)
            url_ += "MinQuantityAllocatedFilter=" + encodeURIComponent("" + minQuantityAllocatedFilter) + "&";
        if (maxRemainingQuantityFilter !== undefined)
            url_ += "MaxRemainingQuantityFilter=" + encodeURIComponent("" + maxRemainingQuantityFilter) + "&";
        if (minRemainingQuantityFilter !== undefined)
            url_ += "MinRemainingQuantityFilter=" + encodeURIComponent("" + minRemainingQuantityFilter) + "&";
        if (maxEffectiveFromFilter !== undefined)
            url_ += "MaxEffectiveFromFilter=" + encodeURIComponent(maxEffectiveFromFilter ? "" + maxEffectiveFromFilter.toJSON() : "") + "&";
        if (minEffectiveFromFilter !== undefined)
            url_ += "MinEffectiveFromFilter=" + encodeURIComponent(minEffectiveFromFilter ? "" + minEffectiveFromFilter.toJSON() : "") + "&";
        if (maxEffectiveToFilter !== undefined)
            url_ += "MaxEffectiveToFilter=" + encodeURIComponent(maxEffectiveToFilter ? "" + maxEffectiveToFilter.toJSON() : "") + "&";
        if (minEffectiveToFilter !== undefined)
            url_ += "MinEffectiveToFilter=" + encodeURIComponent(minEffectiveToFilter ? "" + minEffectiveToFilter.toJSON() : "") + "&";
        if (maxExpireDateFilter !== undefined)
            url_ += "MaxExpireDateFilter=" + encodeURIComponent(maxExpireDateFilter ? "" + maxExpireDateFilter.toJSON() : "") + "&";
        if (minExpireDateFilter !== undefined)
            url_ += "MinExpireDateFilter=" + encodeURIComponent(minExpireDateFilter ? "" + minExpireDateFilter.toJSON() : "") + "&";
        if (isGrantedFilter !== undefined)
            url_ += "IsGrantedFilter=" + encodeURIComponent("" + isGrantedFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetGiftCampaignsToExcelExt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGiftCampaignsToExcelExt(<any>response_);
                } catch (e) {
                    return <Observable<GiftFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GiftFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetGiftCampaignsToExcelExt(response: HttpResponseBase): Observable<GiftFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GiftFileDto.fromJS(resultData200) : new GiftFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GiftFileDto>(<any>null);
    }
}

@Injectable()
export class GiftCampaignsReportServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    search(input: GetAllGiftCampaignsInput | null | undefined): Observable<PagedResultDtoOfGetGiftCampaignForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/GiftCampaignsReport/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetGiftCampaignForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetGiftCampaignForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<PagedResultDtoOfGetGiftCampaignForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetGiftCampaignForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetGiftCampaignForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetGiftCampaignForViewDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    searchGiftCampaignsReportDetail(input: GetAllGiftCampaignsReportInput | null | undefined): Observable<PagedResultDtoOfGetGiftCampaignReportDetailDto> {
        let url_ = this.baseUrl + "/api/services/app/GiftCampaignsReport/SearchGiftCampaignsReportDetail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSearchGiftCampaignsReportDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchGiftCampaignsReportDetail(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetGiftCampaignReportDetailDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetGiftCampaignReportDetailDto>><any>_observableThrow(response_);
        }));
    }

    protected processSearchGiftCampaignsReportDetail(response: HttpResponseBase): Observable<PagedResultDtoOfGetGiftCampaignReportDetailDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetGiftCampaignReportDetailDto.fromJS(resultData200) : new PagedResultDtoOfGetGiftCampaignReportDetailDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetGiftCampaignReportDetailDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    exportGiftCampaignsReport(input: GetAllGiftCampaignsReportInput | null | undefined): Observable<GiftFileDto> {
        let url_ = this.baseUrl + "/api/services/app/GiftCampaignsReport/ExportGiftCampaignsReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processExportGiftCampaignsReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportGiftCampaignsReport(<any>response_);
                } catch (e) {
                    return <Observable<GiftFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GiftFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processExportGiftCampaignsReport(response: HttpResponseBase): Observable<GiftFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GiftFileDto.fromJS(resultData200) : new GiftFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GiftFileDto>(<any>null);
    }
}

@Injectable()
export class GiftCampaignTargetAudienceDetailsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param maxGiftTargetAudienceIDFilter (optional) 
     * @param minGiftTargetAudienceIDFilter (optional) 
     * @param nameFilter (optional) 
     * @param phoneFilter (optional) 
     * @param zaloChatIDFilter (optional) 
     * @param emailFilter (optional) 
     * @param facebookIDFilter (optional) 
     * @param memberCodeFilter (optional) 
     * @param communicationLanguageFilter (optional) 
     * @param communicationChannelFilter (optional) 
     * @param outletCodeFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, maxGiftTargetAudienceIDFilter: number | null | undefined, minGiftTargetAudienceIDFilter: number | null | undefined, nameFilter: string | null | undefined, phoneFilter: string | null | undefined, zaloChatIDFilter: string | null | undefined, emailFilter: string | null | undefined, facebookIDFilter: string | null | undefined, memberCodeFilter: string | null | undefined, communicationLanguageFilter: string | null | undefined, communicationChannelFilter: string | null | undefined, outletCodeFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetGiftCampaignTargetAudienceDetailForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/GiftCampaignTargetAudienceDetails/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxGiftTargetAudienceIDFilter !== undefined)
            url_ += "MaxGiftTargetAudienceIDFilter=" + encodeURIComponent("" + maxGiftTargetAudienceIDFilter) + "&";
        if (minGiftTargetAudienceIDFilter !== undefined)
            url_ += "MinGiftTargetAudienceIDFilter=" + encodeURIComponent("" + minGiftTargetAudienceIDFilter) + "&";
        if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (phoneFilter !== undefined)
            url_ += "PhoneFilter=" + encodeURIComponent("" + phoneFilter) + "&";
        if (zaloChatIDFilter !== undefined)
            url_ += "ZaloChatIDFilter=" + encodeURIComponent("" + zaloChatIDFilter) + "&";
        if (emailFilter !== undefined)
            url_ += "EmailFilter=" + encodeURIComponent("" + emailFilter) + "&";
        if (facebookIDFilter !== undefined)
            url_ += "FacebookIDFilter=" + encodeURIComponent("" + facebookIDFilter) + "&";
        if (memberCodeFilter !== undefined)
            url_ += "MemberCodeFilter=" + encodeURIComponent("" + memberCodeFilter) + "&";
        if (communicationLanguageFilter !== undefined)
            url_ += "CommunicationLanguageFilter=" + encodeURIComponent("" + communicationLanguageFilter) + "&";
        if (communicationChannelFilter !== undefined)
            url_ += "CommunicationChannelFilter=" + encodeURIComponent("" + communicationChannelFilter) + "&";
        if (outletCodeFilter !== undefined)
            url_ += "OutletCodeFilter=" + encodeURIComponent("" + outletCodeFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetGiftCampaignTargetAudienceDetailForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetGiftCampaignTargetAudienceDetailForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetGiftCampaignTargetAudienceDetailForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetGiftCampaignTargetAudienceDetailForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetGiftCampaignTargetAudienceDetailForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetGiftCampaignTargetAudienceDetailForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getGiftCampaignTargetAudienceDetailForEdit(id: number | null | undefined): Observable<GetGiftCampaignTargetAudienceDetailForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/GiftCampaignTargetAudienceDetails/GetGiftCampaignTargetAudienceDetailForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetGiftCampaignTargetAudienceDetailForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGiftCampaignTargetAudienceDetailForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetGiftCampaignTargetAudienceDetailForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetGiftCampaignTargetAudienceDetailForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetGiftCampaignTargetAudienceDetailForEdit(response: HttpResponseBase): Observable<GetGiftCampaignTargetAudienceDetailForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetGiftCampaignTargetAudienceDetailForEditOutput.fromJS(resultData200) : new GetGiftCampaignTargetAudienceDetailForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetGiftCampaignTargetAudienceDetailForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditGiftCampaignTargetAudienceDetailDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GiftCampaignTargetAudienceDetails/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GiftCampaignTargetAudienceDetails/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param maxGiftTargetAudienceIDFilter (optional) 
     * @param minGiftTargetAudienceIDFilter (optional) 
     * @param nameFilter (optional) 
     * @param phoneFilter (optional) 
     * @param zaloChatIDFilter (optional) 
     * @param emailFilter (optional) 
     * @param facebookIDFilter (optional) 
     * @param memberCodeFilter (optional) 
     * @param communicationLanguageFilter (optional) 
     * @param communicationChannelFilter (optional) 
     * @param outletCodeFilter (optional) 
     * @return Success
     */
    getGiftCampaignTargetAudienceDetailsToExcel(filter: string | null | undefined, maxGiftTargetAudienceIDFilter: number | null | undefined, minGiftTargetAudienceIDFilter: number | null | undefined, nameFilter: string | null | undefined, phoneFilter: string | null | undefined, zaloChatIDFilter: string | null | undefined, emailFilter: string | null | undefined, facebookIDFilter: string | null | undefined, memberCodeFilter: string | null | undefined, communicationLanguageFilter: string | null | undefined, communicationChannelFilter: string | null | undefined, outletCodeFilter: string | null | undefined): Observable<GiftFileDto> {
        let url_ = this.baseUrl + "/api/services/app/GiftCampaignTargetAudienceDetails/GetGiftCampaignTargetAudienceDetailsToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxGiftTargetAudienceIDFilter !== undefined)
            url_ += "MaxGiftTargetAudienceIDFilter=" + encodeURIComponent("" + maxGiftTargetAudienceIDFilter) + "&";
        if (minGiftTargetAudienceIDFilter !== undefined)
            url_ += "MinGiftTargetAudienceIDFilter=" + encodeURIComponent("" + minGiftTargetAudienceIDFilter) + "&";
        if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (phoneFilter !== undefined)
            url_ += "PhoneFilter=" + encodeURIComponent("" + phoneFilter) + "&";
        if (zaloChatIDFilter !== undefined)
            url_ += "ZaloChatIDFilter=" + encodeURIComponent("" + zaloChatIDFilter) + "&";
        if (emailFilter !== undefined)
            url_ += "EmailFilter=" + encodeURIComponent("" + emailFilter) + "&";
        if (facebookIDFilter !== undefined)
            url_ += "FacebookIDFilter=" + encodeURIComponent("" + facebookIDFilter) + "&";
        if (memberCodeFilter !== undefined)
            url_ += "MemberCodeFilter=" + encodeURIComponent("" + memberCodeFilter) + "&";
        if (communicationLanguageFilter !== undefined)
            url_ += "CommunicationLanguageFilter=" + encodeURIComponent("" + communicationLanguageFilter) + "&";
        if (communicationChannelFilter !== undefined)
            url_ += "CommunicationChannelFilter=" + encodeURIComponent("" + communicationChannelFilter) + "&";
        if (outletCodeFilter !== undefined)
            url_ += "OutletCodeFilter=" + encodeURIComponent("" + outletCodeFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetGiftCampaignTargetAudienceDetailsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGiftCampaignTargetAudienceDetailsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<GiftFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GiftFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetGiftCampaignTargetAudienceDetailsToExcel(response: HttpResponseBase): Observable<GiftFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GiftFileDto.fromJS(resultData200) : new GiftFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GiftFileDto>(<any>null);
    }

    /**
     * @return Success
     */
    getAllGiftCampaignTargetAudienceDetails(): Observable<PagedResultDtoOfGetGiftCampaignTargetAudienceDetailForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/GiftCampaignTargetAudienceDetails/GetAllGiftCampaignTargetAudienceDetails";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllGiftCampaignTargetAudienceDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllGiftCampaignTargetAudienceDetails(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetGiftCampaignTargetAudienceDetailForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetGiftCampaignTargetAudienceDetailForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllGiftCampaignTargetAudienceDetails(response: HttpResponseBase): Observable<PagedResultDtoOfGetGiftCampaignTargetAudienceDetailForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetGiftCampaignTargetAudienceDetailForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetGiftCampaignTargetAudienceDetailForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetGiftCampaignTargetAudienceDetailForViewDto>(<any>null);
    }
}

@Injectable()
export class GiftCampaignTargetAudiencesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param targetAudienceNameFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param statusFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, targetAudienceNameFilter: string | null | undefined, descriptionFilter: string | null | undefined, statusFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetGiftCampaignTargetAudienceForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/GiftCampaignTargetAudiences/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (targetAudienceNameFilter !== undefined)
            url_ += "TargetAudienceNameFilter=" + encodeURIComponent("" + targetAudienceNameFilter) + "&";
        if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetGiftCampaignTargetAudienceForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetGiftCampaignTargetAudienceForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetGiftCampaignTargetAudienceForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetGiftCampaignTargetAudienceForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetGiftCampaignTargetAudienceForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetGiftCampaignTargetAudienceForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getGiftCampaignTargetAudienceForEdit(id: number | null | undefined): Observable<GetGiftCampaignTargetAudienceForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/GiftCampaignTargetAudiences/GetGiftCampaignTargetAudienceForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetGiftCampaignTargetAudienceForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGiftCampaignTargetAudienceForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetGiftCampaignTargetAudienceForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetGiftCampaignTargetAudienceForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetGiftCampaignTargetAudienceForEdit(response: HttpResponseBase): Observable<GetGiftCampaignTargetAudienceForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetGiftCampaignTargetAudienceForEditOutput.fromJS(resultData200) : new GetGiftCampaignTargetAudienceForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetGiftCampaignTargetAudienceForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditGiftCampaignTargetAudienceDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GiftCampaignTargetAudiences/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GiftCampaignTargetAudiences/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param targetAudienceNameFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param statusFilter (optional) 
     * @return Success
     */
    getGiftCampaignTargetAudiencesToExcel(filter: string | null | undefined, targetAudienceNameFilter: string | null | undefined, descriptionFilter: string | null | undefined, statusFilter: string | null | undefined): Observable<GiftFileDto> {
        let url_ = this.baseUrl + "/api/services/app/GiftCampaignTargetAudiences/GetGiftCampaignTargetAudiencesToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (targetAudienceNameFilter !== undefined)
            url_ += "TargetAudienceNameFilter=" + encodeURIComponent("" + targetAudienceNameFilter) + "&";
        if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetGiftCampaignTargetAudiencesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGiftCampaignTargetAudiencesToExcel(<any>response_);
                } catch (e) {
                    return <Observable<GiftFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GiftFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetGiftCampaignTargetAudiencesToExcel(response: HttpResponseBase): Observable<GiftFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GiftFileDto.fromJS(resultData200) : new GiftFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GiftFileDto>(<any>null);
    }

    /**
     * @return Success
     */
    getAllGiftCampaignTargetForCreate(): Observable<GetTargetGiftCampaignForView[]> {
        let url_ = this.baseUrl + "/api/services/app/GiftCampaignTargetAudiences/GetAllGiftCampaignTargetForCreate";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllGiftCampaignTargetForCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllGiftCampaignTargetForCreate(<any>response_);
                } catch (e) {
                    return <Observable<GetTargetGiftCampaignForView[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetTargetGiftCampaignForView[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllGiftCampaignTargetForCreate(response: HttpResponseBase): Observable<GetTargetGiftCampaignForView[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(GetTargetGiftCampaignForView.fromJS(item));
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTargetGiftCampaignForView[]>(<any>null);
    }
}

@Injectable()
export class GiftCategoryServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param codeFilter (optional) 
     * @param nameFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param statusFilter (optional) 
     * @param maxLevelFilter (optional) 
     * @param minLevelFilter (optional) 
     * @param parentCodeFilter (optional) 
     * @param giftCategoryGiftCategoryNameFilter (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, codeFilter: string | null | undefined, nameFilter: string | null | undefined, descriptionFilter: string | null | undefined, statusFilter: string | null | undefined, maxLevelFilter: number | null | undefined, minLevelFilter: number | null | undefined, parentCodeFilter: string | null | undefined, giftCategoryGiftCategoryNameFilter: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined, sorting: string | null | undefined): Observable<PagedResultDtoOfGetGiftCategoryForView> {
        let url_ = this.baseUrl + "/api/services/app/GiftCategory/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&";
        if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (maxLevelFilter !== undefined)
            url_ += "MaxLevelFilter=" + encodeURIComponent("" + maxLevelFilter) + "&";
        if (minLevelFilter !== undefined)
            url_ += "MinLevelFilter=" + encodeURIComponent("" + minLevelFilter) + "&";
        if (parentCodeFilter !== undefined)
            url_ += "ParentCodeFilter=" + encodeURIComponent("" + parentCodeFilter) + "&";
        if (giftCategoryGiftCategoryNameFilter !== undefined)
            url_ += "GiftCategoryGiftCategoryNameFilter=" + encodeURIComponent("" + giftCategoryGiftCategoryNameFilter) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetGiftCategoryForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetGiftCategoryForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetGiftCategoryForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetGiftCategoryForView.fromJS(resultData200) : new PagedResultDtoOfGetGiftCategoryForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetGiftCategoryForView>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditGiftCategoryDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GiftCategory/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GiftCategory/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllGiftCategoryForLookupTable(filter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGiftCategoryLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/GiftCategory/GetAllGiftCategoryForLookupTable?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllGiftCategoryForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllGiftCategoryForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGiftCategoryLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGiftCategoryLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllGiftCategoryForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfGiftCategoryLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGiftCategoryLookupTableDto.fromJS(resultData200) : new PagedResultDtoOfGiftCategoryLookupTableDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGiftCategoryLookupTableDto>(<any>null);
    }

    /**
     * @param giftCategoryId (optional) 
     * @return Success
     */
    getListForSearch(giftCategoryId: number | null | undefined): Observable<GiftCategoryForSearchDto[]> {
        let url_ = this.baseUrl + "/api/services/app/GiftCategory/GetListForSearch?";
        if (giftCategoryId !== undefined)
            url_ += "giftCategoryId=" + encodeURIComponent("" + giftCategoryId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetListForSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetListForSearch(<any>response_);
                } catch (e) {
                    return <Observable<GiftCategoryForSearchDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<GiftCategoryForSearchDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetListForSearch(response: HttpResponseBase): Observable<GiftCategoryForSearchDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(GiftCategoryForSearchDto.fromJS(item));
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GiftCategoryForSearchDto[]>(<any>null);
    }

    /**
     * @param listCode (optional) 
     * @return Success
     */
    getGiftCategoryFromListCode(listCode: string | null | undefined): Observable<GiftCategoryForSearchDto> {
        let url_ = this.baseUrl + "/api/services/app/GiftCategory/GetGiftCategoryFromListCode?";
        if (listCode !== undefined)
            url_ += "listCode=" + encodeURIComponent("" + listCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetGiftCategoryFromListCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGiftCategoryFromListCode(<any>response_);
                } catch (e) {
                    return <Observable<GiftCategoryForSearchDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GiftCategoryForSearchDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetGiftCategoryFromListCode(response: HttpResponseBase): Observable<GiftCategoryForSearchDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GiftCategoryForSearchDto.fromJS(resultData200) : new GiftCategoryForSearchDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GiftCategoryForSearchDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param levelFilter (optional) 
     * @param parentIdFilter (optional) 
     * @return Success
     */
    getAllCustom(filter: string | null | undefined, levelFilter: number | null | undefined, parentIdFilter: number | null | undefined): Observable<PagedResultDtoOfGetGiftCategoryForView> {
        let url_ = this.baseUrl + "/api/services/app/GiftCategory/GetAllCustom?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (levelFilter !== undefined)
            url_ += "LevelFilter=" + encodeURIComponent("" + levelFilter) + "&";
        if (parentIdFilter !== undefined)
            url_ += "ParentIdFilter=" + encodeURIComponent("" + parentIdFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllCustom(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCustom(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetGiftCategoryForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetGiftCategoryForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllCustom(response: HttpResponseBase): Observable<PagedResultDtoOfGetGiftCategoryForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetGiftCategoryForView.fromJS(resultData200) : new PagedResultDtoOfGetGiftCategoryForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetGiftCategoryForView>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteCustomAsync(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GiftCategory/DeleteCustomAsync?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteCustomAsync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCustomAsync(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteCustomAsync(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEditReturn(input: CreateOrEditGiftCategoryDto | null | undefined): Observable<GiftCategoryDto> {
        let url_ = this.baseUrl + "/api/services/app/GiftCategory/CreateOrEditReturn";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEditReturn(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditReturn(<any>response_);
                } catch (e) {
                    return <Observable<GiftCategoryDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GiftCategoryDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEditReturn(response: HttpResponseBase): Observable<GiftCategoryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GiftCategoryDto.fromJS(resultData200) : new GiftCategoryDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GiftCategoryDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getGiftCategoryForEdit(id: number | null | undefined): Observable<GetGiftCategoryForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/GiftCategory/GetGiftCategoryForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetGiftCategoryForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGiftCategoryForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetGiftCategoryForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetGiftCategoryForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetGiftCategoryForEdit(response: HttpResponseBase): Observable<GetGiftCategoryForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetGiftCategoryForEditOutput.fromJS(resultData200) : new GetGiftCategoryForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetGiftCategoryForEditOutput>(<any>null);
    }
}

@Injectable()
export class GiftGroupDetailsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param giftGroupCodeFilter (optional) 
     * @param giftCodeFilter (optional) 
     * @param statusFilter (optional) 
     * @param giftGroupGiftGroupNameFilter (optional) 
     * @param giftInforGiftNameFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, giftGroupCodeFilter: string | null | undefined, giftCodeFilter: string | null | undefined, statusFilter: string | null | undefined, giftGroupGiftGroupNameFilter: string | null | undefined, giftInforGiftNameFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetGiftGroupDetailForView> {
        let url_ = this.baseUrl + "/api/services/app/GiftGroupDetails/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (giftGroupCodeFilter !== undefined)
            url_ += "GiftGroupCodeFilter=" + encodeURIComponent("" + giftGroupCodeFilter) + "&";
        if (giftCodeFilter !== undefined)
            url_ += "GiftCodeFilter=" + encodeURIComponent("" + giftCodeFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (giftGroupGiftGroupNameFilter !== undefined)
            url_ += "GiftGroupGiftGroupNameFilter=" + encodeURIComponent("" + giftGroupGiftGroupNameFilter) + "&";
        if (giftInforGiftNameFilter !== undefined)
            url_ += "GiftInforGiftNameFilter=" + encodeURIComponent("" + giftInforGiftNameFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetGiftGroupDetailForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetGiftGroupDetailForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetGiftGroupDetailForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetGiftGroupDetailForView.fromJS(resultData200) : new PagedResultDtoOfGetGiftGroupDetailForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetGiftGroupDetailForView>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param giftGroupCodeFilter (optional) 
     * @param giftCodeFilter (optional) 
     * @param statusFilter (optional) 
     * @param giftGroupGiftGroupNameFilter (optional) 
     * @param giftInforGiftNameFilter (optional) 
     * @param giftGroupIdFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getByGiftGroup(filter: string | null | undefined, giftGroupCodeFilter: string | null | undefined, giftCodeFilter: string | null | undefined, statusFilter: string | null | undefined, giftGroupGiftGroupNameFilter: string | null | undefined, giftInforGiftNameFilter: string | null | undefined, giftGroupIdFilter: number | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetGiftGroupDetailForView> {
        let url_ = this.baseUrl + "/api/services/app/GiftGroupDetails/GetByGiftGroup?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (giftGroupCodeFilter !== undefined)
            url_ += "GiftGroupCodeFilter=" + encodeURIComponent("" + giftGroupCodeFilter) + "&";
        if (giftCodeFilter !== undefined)
            url_ += "GiftCodeFilter=" + encodeURIComponent("" + giftCodeFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (giftGroupGiftGroupNameFilter !== undefined)
            url_ += "GiftGroupGiftGroupNameFilter=" + encodeURIComponent("" + giftGroupGiftGroupNameFilter) + "&";
        if (giftInforGiftNameFilter !== undefined)
            url_ += "GiftInforGiftNameFilter=" + encodeURIComponent("" + giftInforGiftNameFilter) + "&";
        if (giftGroupIdFilter !== undefined)
            url_ += "GiftGroupIdFilter=" + encodeURIComponent("" + giftGroupIdFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetByGiftGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByGiftGroup(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetGiftGroupDetailForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetGiftGroupDetailForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetByGiftGroup(response: HttpResponseBase): Observable<PagedResultDtoOfGetGiftGroupDetailForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetGiftGroupDetailForView.fromJS(resultData200) : new PagedResultDtoOfGetGiftGroupDetailForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetGiftGroupDetailForView>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getGiftGroupDetailForEdit(id: number | null | undefined): Observable<GetGiftGroupDetailForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/GiftGroupDetails/GetGiftGroupDetailForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetGiftGroupDetailForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGiftGroupDetailForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetGiftGroupDetailForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetGiftGroupDetailForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetGiftGroupDetailForEdit(response: HttpResponseBase): Observable<GetGiftGroupDetailForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetGiftGroupDetailForEditOutput.fromJS(resultData200) : new GetGiftGroupDetailForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetGiftGroupDetailForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditGiftGroupDetailDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GiftGroupDetails/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GiftGroupDetails/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllGiftGroupForLookupTable(filter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGiftGroupLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/GiftGroupDetails/GetAllGiftGroupForLookupTable?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllGiftGroupForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllGiftGroupForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGiftGroupLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGiftGroupLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllGiftGroupForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfGiftGroupLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGiftGroupLookupTableDto.fromJS(resultData200) : new PagedResultDtoOfGiftGroupLookupTableDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGiftGroupLookupTableDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllGiftInforForLookupTable(filter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGiftInforLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/GiftGroupDetails/GetAllGiftInforForLookupTable?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllGiftInforForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllGiftInforForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGiftInforLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGiftInforLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllGiftInforForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfGiftInforLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGiftInforLookupTableDto.fromJS(resultData200) : new PagedResultDtoOfGiftInforLookupTableDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGiftInforLookupTableDto>(<any>null);
    }
}

@Injectable()
export class GiftGroupsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param codeFilter (optional) 
     * @param nameFilter (optional) 
     * @param statusFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, codeFilter: string | null | undefined, nameFilter: string | null | undefined, statusFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetGiftGroupForView> {
        let url_ = this.baseUrl + "/api/services/app/GiftGroups/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&";
        if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetGiftGroupForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetGiftGroupForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetGiftGroupForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetGiftGroupForView.fromJS(resultData200) : new PagedResultDtoOfGetGiftGroupForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetGiftGroupForView>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getGiftGroupForEdit(id: number | null | undefined): Observable<GetGiftGroupForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/GiftGroups/GetGiftGroupForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetGiftGroupForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGiftGroupForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetGiftGroupForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetGiftGroupForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetGiftGroupForEdit(response: HttpResponseBase): Observable<GetGiftGroupForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetGiftGroupForEditOutput.fromJS(resultData200) : new GetGiftGroupForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetGiftGroupForEditOutput>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getGiftGroupWithImageForEdit(id: number | null | undefined): Observable<GetGiftGroupForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/GiftGroups/GetGiftGroupWithImageForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetGiftGroupWithImageForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGiftGroupWithImageForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetGiftGroupForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetGiftGroupForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetGiftGroupWithImageForEdit(response: HttpResponseBase): Observable<GetGiftGroupForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetGiftGroupForEditOutput.fromJS(resultData200) : new GetGiftGroupForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetGiftGroupForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditGiftGroupDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GiftGroups/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GiftGroups/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param codeFilter (optional) 
     * @param nameFilter (optional) 
     * @param statusFilter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getAllWithImage(filter: string | null | undefined, codeFilter: string | null | undefined, nameFilter: string | null | undefined, statusFilter: string | null | undefined, sorting: string | null | undefined, maxResultCount: number | null | undefined, skipCount: number | null | undefined): Observable<PagedResultDtoOfGetGiftGroupForView> {
        let url_ = this.baseUrl + "/api/services/app/GiftGroups/GetAllWithImage?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&";
        if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllWithImage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllWithImage(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetGiftGroupForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetGiftGroupForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllWithImage(response: HttpResponseBase): Observable<PagedResultDtoOfGetGiftGroupForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetGiftGroupForView.fromJS(resultData200) : new PagedResultDtoOfGetGiftGroupForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetGiftGroupForView>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEditGiftWithAvatar(input: CreateOrEditGiftGroupWithAvatarDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GiftGroups/CreateOrEditGiftWithAvatar";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEditGiftWithAvatar(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditGiftWithAvatar(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEditGiftWithAvatar(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class GiftInforsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param codeFilter (optional) 
     * @param nameFilter (optional) 
     * @param introduceFilter (optional) 
     * @param fullGiftCategoryCodeFilter (optional) 
     * @param producerFilter (optional) 
     * @param vendorFilter (optional) 
     * @param statusFilter (optional) 
     * @param isEGiftFilter (optional) 
     * @param targetAudienceNameFilter (optional) 
     * @param giftGroupIdFilter (optional) 
     * @param maxAmountFilter (optional) 
     * @param minAmountFilter (optional) 
     * @param giftTypeFilter (optional) 
     * @param targetAudienceTypeFilter (optional) 
     * @param memberCodeFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, codeFilter: string | null | undefined, nameFilter: string | null | undefined, introduceFilter: string | null | undefined, fullGiftCategoryCodeFilter: string | null | undefined, producerFilter: string | null | undefined, vendorFilter: string | null | undefined, statusFilter: string | null | undefined, isEGiftFilter: number | null | undefined, targetAudienceNameFilter: string | null | undefined, giftGroupIdFilter: number | null | undefined, maxAmountFilter: number | null | undefined, minAmountFilter: number | null | undefined, giftTypeFilter: string | null | undefined, targetAudienceTypeFilter: string | null | undefined, memberCodeFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetGiftInforForView> {
        let url_ = this.baseUrl + "/api/services/app/GiftInfors/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&";
        if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (introduceFilter !== undefined)
            url_ += "IntroduceFilter=" + encodeURIComponent("" + introduceFilter) + "&";
        if (fullGiftCategoryCodeFilter !== undefined)
            url_ += "FullGiftCategoryCodeFilter=" + encodeURIComponent("" + fullGiftCategoryCodeFilter) + "&";
        if (producerFilter !== undefined)
            url_ += "ProducerFilter=" + encodeURIComponent("" + producerFilter) + "&";
        if (vendorFilter !== undefined)
            url_ += "VendorFilter=" + encodeURIComponent("" + vendorFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (isEGiftFilter !== undefined)
            url_ += "IsEGiftFilter=" + encodeURIComponent("" + isEGiftFilter) + "&";
        if (targetAudienceNameFilter !== undefined)
            url_ += "TargetAudienceNameFilter=" + encodeURIComponent("" + targetAudienceNameFilter) + "&";
        if (giftGroupIdFilter !== undefined)
            url_ += "GiftGroupIdFilter=" + encodeURIComponent("" + giftGroupIdFilter) + "&";
        if (maxAmountFilter !== undefined)
            url_ += "MaxAmountFilter=" + encodeURIComponent("" + maxAmountFilter) + "&";
        if (minAmountFilter !== undefined)
            url_ += "MinAmountFilter=" + encodeURIComponent("" + minAmountFilter) + "&";
        if (giftTypeFilter !== undefined)
            url_ += "GiftTypeFilter=" + encodeURIComponent("" + giftTypeFilter) + "&";
        if (targetAudienceTypeFilter !== undefined)
            url_ += "TargetAudienceTypeFilter=" + encodeURIComponent("" + targetAudienceTypeFilter) + "&";
        if (memberCodeFilter !== undefined)
            url_ += "MemberCodeFilter=" + encodeURIComponent("" + memberCodeFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetGiftInforForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetGiftInforForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetGiftInforForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetGiftInforForView.fromJS(resultData200) : new PagedResultDtoOfGetGiftInforForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetGiftInforForView>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getGiftInforForEdit(id: number | null | undefined): Observable<GetGiftInforForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/GiftInfors/GetGiftInforForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetGiftInforForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGiftInforForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetGiftInforForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetGiftInforForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetGiftInforForEdit(response: HttpResponseBase): Observable<GetGiftInforForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetGiftInforForEditOutput.fromJS(resultData200) : new GetGiftInforForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetGiftInforForEditOutput>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getGiftInforForViewOrEdit(id: number | null | undefined): Observable<GetGiftInforForViewOrEditDto> {
        let url_ = this.baseUrl + "/api/services/app/GiftInfors/GetGiftInforForViewOrEdit?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetGiftInforForViewOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGiftInforForViewOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetGiftInforForViewOrEditDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetGiftInforForViewOrEditDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetGiftInforForViewOrEdit(response: HttpResponseBase): Observable<GetGiftInforForViewOrEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetGiftInforForViewOrEditDto.fromJS(resultData200) : new GetGiftInforForViewOrEditDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetGiftInforForViewOrEditDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditGiftInforDto | null | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/GiftInfors/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GiftInfors/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllSettingParamForLookupTable(filter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfSettingParamLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/GiftInfors/GetAllSettingParamForLookupTable?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllSettingParamForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSettingParamForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfSettingParamLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfSettingParamLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllSettingParamForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfSettingParamLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfSettingParamLookupTableDto.fromJS(resultData200) : new PagedResultDtoOfSettingParamLookupTableDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfSettingParamLookupTableDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param codeFilter (optional) 
     * @param nameFilter (optional) 
     * @param introduceFilter (optional) 
     * @param fullGiftCategoryCodeFilter (optional) 
     * @param producerFilter (optional) 
     * @param vendorFilter (optional) 
     * @param statusFilter (optional) 
     * @param isEGiftFilter (optional) 
     * @param targetAudienceNameFilter (optional) 
     * @param giftGroupIdFilter (optional) 
     * @param maxAmountFilter (optional) 
     * @param minAmountFilter (optional) 
     * @param giftTypeFilter (optional) 
     * @param targetAudienceTypeFilter (optional) 
     * @param memberCodeFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getGiftByMemberCodeExt(filter: string | null | undefined, codeFilter: string | null | undefined, nameFilter: string | null | undefined, introduceFilter: string | null | undefined, fullGiftCategoryCodeFilter: string | null | undefined, producerFilter: string | null | undefined, vendorFilter: string | null | undefined, statusFilter: string | null | undefined, isEGiftFilter: number | null | undefined, targetAudienceNameFilter: string | null | undefined, giftGroupIdFilter: number | null | undefined, maxAmountFilter: number | null | undefined, minAmountFilter: number | null | undefined, giftTypeFilter: string | null | undefined, targetAudienceTypeFilter: string | null | undefined, memberCodeFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetGiftInforForView> {
        let url_ = this.baseUrl + "/api/services/app/GiftInfors/GetGiftByMemberCodeExt?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&";
        if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (introduceFilter !== undefined)
            url_ += "IntroduceFilter=" + encodeURIComponent("" + introduceFilter) + "&";
        if (fullGiftCategoryCodeFilter !== undefined)
            url_ += "FullGiftCategoryCodeFilter=" + encodeURIComponent("" + fullGiftCategoryCodeFilter) + "&";
        if (producerFilter !== undefined)
            url_ += "ProducerFilter=" + encodeURIComponent("" + producerFilter) + "&";
        if (vendorFilter !== undefined)
            url_ += "VendorFilter=" + encodeURIComponent("" + vendorFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (isEGiftFilter !== undefined)
            url_ += "IsEGiftFilter=" + encodeURIComponent("" + isEGiftFilter) + "&";
        if (targetAudienceNameFilter !== undefined)
            url_ += "TargetAudienceNameFilter=" + encodeURIComponent("" + targetAudienceNameFilter) + "&";
        if (giftGroupIdFilter !== undefined)
            url_ += "GiftGroupIdFilter=" + encodeURIComponent("" + giftGroupIdFilter) + "&";
        if (maxAmountFilter !== undefined)
            url_ += "MaxAmountFilter=" + encodeURIComponent("" + maxAmountFilter) + "&";
        if (minAmountFilter !== undefined)
            url_ += "MinAmountFilter=" + encodeURIComponent("" + minAmountFilter) + "&";
        if (giftTypeFilter !== undefined)
            url_ += "GiftTypeFilter=" + encodeURIComponent("" + giftTypeFilter) + "&";
        if (targetAudienceTypeFilter !== undefined)
            url_ += "TargetAudienceTypeFilter=" + encodeURIComponent("" + targetAudienceTypeFilter) + "&";
        if (memberCodeFilter !== undefined)
            url_ += "MemberCodeFilter=" + encodeURIComponent("" + memberCodeFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetGiftByMemberCodeExt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGiftByMemberCodeExt(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetGiftInforForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetGiftInforForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetGiftByMemberCodeExt(response: HttpResponseBase): Observable<PagedResultDtoOfGetGiftInforForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetGiftInforForView.fromJS(resultData200) : new PagedResultDtoOfGetGiftInforForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetGiftInforForView>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param codeFilter (optional) 
     * @param nameFilter (optional) 
     * @param introduceFilter (optional) 
     * @param fullGiftCategoryCodeFilter (optional) 
     * @param producerFilter (optional) 
     * @param vendorFilter (optional) 
     * @param statusFilter (optional) 
     * @param isEGiftFilter (optional) 
     * @param targetAudienceNameFilter (optional) 
     * @param giftGroupIdFilter (optional) 
     * @param maxAmountFilter (optional) 
     * @param minAmountFilter (optional) 
     * @param giftTypeFilter (optional) 
     * @param targetAudienceTypeFilter (optional) 
     * @param memberCodeFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllForCategory(filter: string | null | undefined, codeFilter: string | null | undefined, nameFilter: string | null | undefined, introduceFilter: string | null | undefined, fullGiftCategoryCodeFilter: string | null | undefined, producerFilter: string | null | undefined, vendorFilter: string | null | undefined, statusFilter: string | null | undefined, isEGiftFilter: number | null | undefined, targetAudienceNameFilter: string | null | undefined, giftGroupIdFilter: number | null | undefined, maxAmountFilter: number | null | undefined, minAmountFilter: number | null | undefined, giftTypeFilter: string | null | undefined, targetAudienceTypeFilter: string | null | undefined, memberCodeFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetGiftInforForView> {
        let url_ = this.baseUrl + "/api/services/app/GiftInfors/GetAllForCategory?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&";
        if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (introduceFilter !== undefined)
            url_ += "IntroduceFilter=" + encodeURIComponent("" + introduceFilter) + "&";
        if (fullGiftCategoryCodeFilter !== undefined)
            url_ += "FullGiftCategoryCodeFilter=" + encodeURIComponent("" + fullGiftCategoryCodeFilter) + "&";
        if (producerFilter !== undefined)
            url_ += "ProducerFilter=" + encodeURIComponent("" + producerFilter) + "&";
        if (vendorFilter !== undefined)
            url_ += "VendorFilter=" + encodeURIComponent("" + vendorFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (isEGiftFilter !== undefined)
            url_ += "IsEGiftFilter=" + encodeURIComponent("" + isEGiftFilter) + "&";
        if (targetAudienceNameFilter !== undefined)
            url_ += "TargetAudienceNameFilter=" + encodeURIComponent("" + targetAudienceNameFilter) + "&";
        if (giftGroupIdFilter !== undefined)
            url_ += "GiftGroupIdFilter=" + encodeURIComponent("" + giftGroupIdFilter) + "&";
        if (maxAmountFilter !== undefined)
            url_ += "MaxAmountFilter=" + encodeURIComponent("" + maxAmountFilter) + "&";
        if (minAmountFilter !== undefined)
            url_ += "MinAmountFilter=" + encodeURIComponent("" + minAmountFilter) + "&";
        if (giftTypeFilter !== undefined)
            url_ += "GiftTypeFilter=" + encodeURIComponent("" + giftTypeFilter) + "&";
        if (targetAudienceTypeFilter !== undefined)
            url_ += "TargetAudienceTypeFilter=" + encodeURIComponent("" + targetAudienceTypeFilter) + "&";
        if (memberCodeFilter !== undefined)
            url_ += "MemberCodeFilter=" + encodeURIComponent("" + memberCodeFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllForCategory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllForCategory(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetGiftInforForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetGiftInforForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllForCategory(response: HttpResponseBase): Observable<PagedResultDtoOfGetGiftInforForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetGiftInforForView.fromJS(resultData200) : new PagedResultDtoOfGetGiftInforForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetGiftInforForView>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    search(input: GetAllGiftInforsInput | null | undefined): Observable<PagedResultDtoOfGetGiftInforForView> {
        let url_ = this.baseUrl + "/api/services/app/GiftInfors/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetGiftInforForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetGiftInforForView>><any>_observableThrow(response_);
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<PagedResultDtoOfGetGiftInforForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetGiftInforForView.fromJS(resultData200) : new PagedResultDtoOfGetGiftInforForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetGiftInforForView>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteFromCategory(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GiftInfors/DeleteFromCategory?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteFromCategory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteFromCategory(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteFromCategory(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param giftCategoryCodeFilter (optional) 
     * @param giftGroupCodeFilter (optional) 
     * @param statusFilter (optional) 
     * @param producerFilter (optional) 
     * @param vendorFilter (optional) 
     * @param isEGiftFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllByMemberCode(memberCode: string, giftCategoryCodeFilter: string | null | undefined, giftGroupCodeFilter: string | null | undefined, statusFilter: string | null | undefined, producerFilter: string | null | undefined, vendorFilter: string | null | undefined, isEGiftFilter: number | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetGiftInforForView> {
        let url_ = this.baseUrl + "/api/services/app/GiftInfors/GetAllByMemberCode?";
        if (memberCode === undefined || memberCode === null)
            throw new Error("The parameter 'memberCode' must be defined and cannot be null.");
        else
            url_ += "MemberCode=" + encodeURIComponent("" + memberCode) + "&";
        if (giftCategoryCodeFilter !== undefined)
            url_ += "GiftCategoryCodeFilter=" + encodeURIComponent("" + giftCategoryCodeFilter) + "&";
        if (giftGroupCodeFilter !== undefined)
            url_ += "GiftGroupCodeFilter=" + encodeURIComponent("" + giftGroupCodeFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (producerFilter !== undefined)
            url_ += "ProducerFilter=" + encodeURIComponent("" + producerFilter) + "&";
        if (vendorFilter !== undefined)
            url_ += "VendorFilter=" + encodeURIComponent("" + vendorFilter) + "&";
        if (isEGiftFilter !== undefined)
            url_ += "IsEGiftFilter=" + encodeURIComponent("" + isEGiftFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllByMemberCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllByMemberCode(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetGiftInforForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetGiftInforForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllByMemberCode(response: HttpResponseBase): Observable<PagedResultDtoOfGetGiftInforForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetGiftInforForView.fromJS(resultData200) : new PagedResultDtoOfGetGiftInforForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetGiftInforForView>(<any>null);
    }

    /**
     * @return Success
     */
    getGiftByMemberCode(codeFilter: string, memberCode: string): Observable<GetGiftInforForView> {
        let url_ = this.baseUrl + "/api/services/app/GiftInfors/GetGiftByMemberCode?";
        if (codeFilter === undefined || codeFilter === null)
            throw new Error("The parameter 'codeFilter' must be defined and cannot be null.");
        else
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&";
        if (memberCode === undefined || memberCode === null)
            throw new Error("The parameter 'memberCode' must be defined and cannot be null.");
        else
            url_ += "MemberCode=" + encodeURIComponent("" + memberCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetGiftByMemberCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGiftByMemberCode(<any>response_);
                } catch (e) {
                    return <Observable<GetGiftInforForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetGiftInforForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetGiftByMemberCode(response: HttpResponseBase): Observable<GetGiftInforForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetGiftInforForView.fromJS(resultData200) : new GetGiftInforForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetGiftInforForView>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    searchByCodePG(input: GetByCodeInput | null | undefined): Observable<GetGiftInforForViewPG> {
        let url_ = this.baseUrl + "/api/services/app/GiftInfors/SearchByCodePG";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSearchByCodePG(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchByCodePG(<any>response_);
                } catch (e) {
                    return <Observable<GetGiftInforForViewPG>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetGiftInforForViewPG>><any>_observableThrow(response_);
        }));
    }

    protected processSearchByCodePG(response: HttpResponseBase): Observable<GetGiftInforForViewPG> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetGiftInforForViewPG.fromJS(resultData200) : new GetGiftInforForViewPG();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetGiftInforForViewPG>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    searchAllPG(input: GetAllGiftInforsPGInput | null | undefined): Observable<PagedResultDtoOfGetGiftInforGiftCategoryForViewPG> {
        let url_ = this.baseUrl + "/api/services/app/GiftInfors/SearchAllPG";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSearchAllPG(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchAllPG(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetGiftInforGiftCategoryForViewPG>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetGiftInforGiftCategoryForViewPG>><any>_observableThrow(response_);
        }));
    }

    protected processSearchAllPG(response: HttpResponseBase): Observable<PagedResultDtoOfGetGiftInforGiftCategoryForViewPG> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetGiftInforGiftCategoryForViewPG.fromJS(resultData200) : new PagedResultDtoOfGetGiftInforGiftCategoryForViewPG();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetGiftInforGiftCategoryForViewPG>(<any>null);
    }

    /**
     * @param code (optional) 
     * @return Success
     */
    deleteListFromCategory(code: string[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GiftInfors/DeleteListFromCategory?";
        if (code !== undefined)
            code && code.forEach(item => { url_ += "code=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteListFromCategory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteListFromCategory(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteListFromCategory(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param arg (optional) 
     * @return Success
     */
    importQueueEgift(arg: EGiftImportJobArgs | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GiftInfors/ImportQueueEgift";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(arg);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processImportQueueEgift(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportQueueEgift(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processImportQueueEgift(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEditExt(input: CreateOrEditGiftInforDto | null | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/GiftInfors/CreateOrEditExt";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEditExt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditExt(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEditExt(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param codeFilter (optional) 
     * @param nameFilter (optional) 
     * @param introduceFilter (optional) 
     * @param fullGiftCategoryCodeFilter (optional) 
     * @param producerFilter (optional) 
     * @param vendorFilter (optional) 
     * @param statusFilter (optional) 
     * @param isEGiftFilter (optional) 
     * @param targetAudienceNameFilter (optional) 
     * @param giftGroupIdFilter (optional) 
     * @param maxAmountFilter (optional) 
     * @param minAmountFilter (optional) 
     * @param giftTypeFilter (optional) 
     * @param targetAudienceTypeFilter (optional) 
     * @param memberCodeFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllExt(filter: string | null | undefined, codeFilter: string | null | undefined, nameFilter: string | null | undefined, introduceFilter: string | null | undefined, fullGiftCategoryCodeFilter: string | null | undefined, producerFilter: string | null | undefined, vendorFilter: string | null | undefined, statusFilter: string | null | undefined, isEGiftFilter: number | null | undefined, targetAudienceNameFilter: string | null | undefined, giftGroupIdFilter: number | null | undefined, maxAmountFilter: number | null | undefined, minAmountFilter: number | null | undefined, giftTypeFilter: string | null | undefined, targetAudienceTypeFilter: string | null | undefined, memberCodeFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetGiftInforForView> {
        let url_ = this.baseUrl + "/api/services/app/GiftInfors/GetAllExt?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&";
        if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (introduceFilter !== undefined)
            url_ += "IntroduceFilter=" + encodeURIComponent("" + introduceFilter) + "&";
        if (fullGiftCategoryCodeFilter !== undefined)
            url_ += "FullGiftCategoryCodeFilter=" + encodeURIComponent("" + fullGiftCategoryCodeFilter) + "&";
        if (producerFilter !== undefined)
            url_ += "ProducerFilter=" + encodeURIComponent("" + producerFilter) + "&";
        if (vendorFilter !== undefined)
            url_ += "VendorFilter=" + encodeURIComponent("" + vendorFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (isEGiftFilter !== undefined)
            url_ += "IsEGiftFilter=" + encodeURIComponent("" + isEGiftFilter) + "&";
        if (targetAudienceNameFilter !== undefined)
            url_ += "TargetAudienceNameFilter=" + encodeURIComponent("" + targetAudienceNameFilter) + "&";
        if (giftGroupIdFilter !== undefined)
            url_ += "GiftGroupIdFilter=" + encodeURIComponent("" + giftGroupIdFilter) + "&";
        if (maxAmountFilter !== undefined)
            url_ += "MaxAmountFilter=" + encodeURIComponent("" + maxAmountFilter) + "&";
        if (minAmountFilter !== undefined)
            url_ += "MinAmountFilter=" + encodeURIComponent("" + minAmountFilter) + "&";
        if (giftTypeFilter !== undefined)
            url_ += "GiftTypeFilter=" + encodeURIComponent("" + giftTypeFilter) + "&";
        if (targetAudienceTypeFilter !== undefined)
            url_ += "TargetAudienceTypeFilter=" + encodeURIComponent("" + targetAudienceTypeFilter) + "&";
        if (memberCodeFilter !== undefined)
            url_ += "MemberCodeFilter=" + encodeURIComponent("" + memberCodeFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllExt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllExt(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetGiftInforForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetGiftInforForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllExt(response: HttpResponseBase): Observable<PagedResultDtoOfGetGiftInforForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetGiftInforForView.fromJS(resultData200) : new PagedResultDtoOfGetGiftInforForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetGiftInforForView>(<any>null);
    }

    /**
     * @param args (optional) 
     * @return Success
     */
    importQueue(args: GiftInfoAgrs | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GiftInfors/ImportQueue";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(args);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processImportQueue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportQueue(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processImportQueue(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getGiftInforForViewOrEditExtAsync(id: number | null | undefined): Observable<GetGiftInforForViewOrEditExtDto> {
        let url_ = this.baseUrl + "/api/services/app/GiftInfors/GetGiftInforForViewOrEditExtAsync?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetGiftInforForViewOrEditExtAsync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGiftInforForViewOrEditExtAsync(<any>response_);
                } catch (e) {
                    return <Observable<GetGiftInforForViewOrEditExtDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetGiftInforForViewOrEditExtDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetGiftInforForViewOrEditExtAsync(response: HttpResponseBase): Observable<GetGiftInforForViewOrEditExtDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetGiftInforForViewOrEditExtDto.fromJS(resultData200) : new GetGiftInforForViewOrEditExtDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetGiftInforForViewOrEditExtDto>(<any>null);
    }

    /**
     * @param arg (optional) 
     * @return Success
     */
    importGiftInformationQueue(arg: GiftInformationAgrs | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GiftInfors/ImportGiftInformationQueue";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(arg);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processImportGiftInformationQueue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportGiftInformationQueue(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processImportGiftInformationQueue(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    exportTemplateGiftInformationAsync(): Observable<PointFileDto> {
        let url_ = this.baseUrl + "/api/services/app/GiftInfors/ExportTemplateGiftInformationAsync";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processExportTemplateGiftInformationAsync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportTemplateGiftInformationAsync(<any>response_);
                } catch (e) {
                    return <Observable<PointFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PointFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processExportTemplateGiftInformationAsync(response: HttpResponseBase): Observable<PointFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PointFileDto.fromJS(resultData200) : new PointFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PointFileDto>(<any>null);
    }
}

@Injectable()
export class GiftMastersServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param codeFilter (optional) 
     * @param nameFilter (optional) 
     * @param maxQuantityFilter (optional) 
     * @param minQuantityFilter (optional) 
     * @param maxPriceFilter (optional) 
     * @param minPriceFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param maxEffectiveFromFilter (optional) 
     * @param minEffectiveFromFilter (optional) 
     * @param maxEffectiveToFilter (optional) 
     * @param minEffectiveToFilter (optional) 
     * @param maxExpireDateFilter (optional) 
     * @param minExpireDateFilter (optional) 
     * @param statusFilter (optional) 
     * @param imageLinkFilter (optional) 
     * @param nameUnsignFilter (optional) 
     * @param productTypeFilter (optional) 
     * @param publisherFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, codeFilter: string | null | undefined, nameFilter: string | null | undefined, maxQuantityFilter: number | null | undefined, minQuantityFilter: number | null | undefined, maxPriceFilter: number | null | undefined, minPriceFilter: number | null | undefined, descriptionFilter: string | null | undefined, maxEffectiveFromFilter: moment.Moment | null | undefined, minEffectiveFromFilter: moment.Moment | null | undefined, maxEffectiveToFilter: moment.Moment | null | undefined, minEffectiveToFilter: moment.Moment | null | undefined, maxExpireDateFilter: moment.Moment | null | undefined, minExpireDateFilter: moment.Moment | null | undefined, statusFilter: string | null | undefined, imageLinkFilter: string | null | undefined, nameUnsignFilter: string | null | undefined, productTypeFilter: string | null | undefined, publisherFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetGiftMasterForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/GiftMasters/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&";
        if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (maxQuantityFilter !== undefined)
            url_ += "MaxQuantityFilter=" + encodeURIComponent("" + maxQuantityFilter) + "&";
        if (minQuantityFilter !== undefined)
            url_ += "MinQuantityFilter=" + encodeURIComponent("" + minQuantityFilter) + "&";
        if (maxPriceFilter !== undefined)
            url_ += "MaxPriceFilter=" + encodeURIComponent("" + maxPriceFilter) + "&";
        if (minPriceFilter !== undefined)
            url_ += "MinPriceFilter=" + encodeURIComponent("" + minPriceFilter) + "&";
        if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&";
        if (maxEffectiveFromFilter !== undefined)
            url_ += "MaxEffectiveFromFilter=" + encodeURIComponent(maxEffectiveFromFilter ? "" + maxEffectiveFromFilter.toJSON() : "") + "&";
        if (minEffectiveFromFilter !== undefined)
            url_ += "MinEffectiveFromFilter=" + encodeURIComponent(minEffectiveFromFilter ? "" + minEffectiveFromFilter.toJSON() : "") + "&";
        if (maxEffectiveToFilter !== undefined)
            url_ += "MaxEffectiveToFilter=" + encodeURIComponent(maxEffectiveToFilter ? "" + maxEffectiveToFilter.toJSON() : "") + "&";
        if (minEffectiveToFilter !== undefined)
            url_ += "MinEffectiveToFilter=" + encodeURIComponent(minEffectiveToFilter ? "" + minEffectiveToFilter.toJSON() : "") + "&";
        if (maxExpireDateFilter !== undefined)
            url_ += "MaxExpireDateFilter=" + encodeURIComponent(maxExpireDateFilter ? "" + maxExpireDateFilter.toJSON() : "") + "&";
        if (minExpireDateFilter !== undefined)
            url_ += "MinExpireDateFilter=" + encodeURIComponent(minExpireDateFilter ? "" + minExpireDateFilter.toJSON() : "") + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (imageLinkFilter !== undefined)
            url_ += "ImageLinkFilter=" + encodeURIComponent("" + imageLinkFilter) + "&";
        if (nameUnsignFilter !== undefined)
            url_ += "NameUnsignFilter=" + encodeURIComponent("" + nameUnsignFilter) + "&";
        if (productTypeFilter !== undefined)
            url_ += "ProductTypeFilter=" + encodeURIComponent("" + productTypeFilter) + "&";
        if (publisherFilter !== undefined)
            url_ += "PublisherFilter=" + encodeURIComponent("" + publisherFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetGiftMasterForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetGiftMasterForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetGiftMasterForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetGiftMasterForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetGiftMasterForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetGiftMasterForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getGiftMasterForEdit(id: number | null | undefined): Observable<GetGiftMasterForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/GiftMasters/GetGiftMasterForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetGiftMasterForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGiftMasterForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetGiftMasterForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetGiftMasterForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetGiftMasterForEdit(response: HttpResponseBase): Observable<GetGiftMasterForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetGiftMasterForEditOutput.fromJS(resultData200) : new GetGiftMasterForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetGiftMasterForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditGiftMasterDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GiftMasters/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GiftMasters/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param codeFilter (optional) 
     * @param nameFilter (optional) 
     * @param maxQuantityFilter (optional) 
     * @param minQuantityFilter (optional) 
     * @param maxPriceFilter (optional) 
     * @param minPriceFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param maxEffectiveFromFilter (optional) 
     * @param minEffectiveFromFilter (optional) 
     * @param maxEffectiveToFilter (optional) 
     * @param minEffectiveToFilter (optional) 
     * @param maxExpireDateFilter (optional) 
     * @param minExpireDateFilter (optional) 
     * @param statusFilter (optional) 
     * @param imageLinkFilter (optional) 
     * @param nameUnsignFilter (optional) 
     * @param productTypeFilter (optional) 
     * @param publisherFilter (optional) 
     * @return Success
     */
    getGiftMastersToExcel(filter: string | null | undefined, codeFilter: string | null | undefined, nameFilter: string | null | undefined, maxQuantityFilter: number | null | undefined, minQuantityFilter: number | null | undefined, maxPriceFilter: number | null | undefined, minPriceFilter: number | null | undefined, descriptionFilter: string | null | undefined, maxEffectiveFromFilter: moment.Moment | null | undefined, minEffectiveFromFilter: moment.Moment | null | undefined, maxEffectiveToFilter: moment.Moment | null | undefined, minEffectiveToFilter: moment.Moment | null | undefined, maxExpireDateFilter: moment.Moment | null | undefined, minExpireDateFilter: moment.Moment | null | undefined, statusFilter: string | null | undefined, imageLinkFilter: string | null | undefined, nameUnsignFilter: string | null | undefined, productTypeFilter: string | null | undefined, publisherFilter: string | null | undefined): Observable<GiftFileDto> {
        let url_ = this.baseUrl + "/api/services/app/GiftMasters/GetGiftMastersToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&";
        if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (maxQuantityFilter !== undefined)
            url_ += "MaxQuantityFilter=" + encodeURIComponent("" + maxQuantityFilter) + "&";
        if (minQuantityFilter !== undefined)
            url_ += "MinQuantityFilter=" + encodeURIComponent("" + minQuantityFilter) + "&";
        if (maxPriceFilter !== undefined)
            url_ += "MaxPriceFilter=" + encodeURIComponent("" + maxPriceFilter) + "&";
        if (minPriceFilter !== undefined)
            url_ += "MinPriceFilter=" + encodeURIComponent("" + minPriceFilter) + "&";
        if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&";
        if (maxEffectiveFromFilter !== undefined)
            url_ += "MaxEffectiveFromFilter=" + encodeURIComponent(maxEffectiveFromFilter ? "" + maxEffectiveFromFilter.toJSON() : "") + "&";
        if (minEffectiveFromFilter !== undefined)
            url_ += "MinEffectiveFromFilter=" + encodeURIComponent(minEffectiveFromFilter ? "" + minEffectiveFromFilter.toJSON() : "") + "&";
        if (maxEffectiveToFilter !== undefined)
            url_ += "MaxEffectiveToFilter=" + encodeURIComponent(maxEffectiveToFilter ? "" + maxEffectiveToFilter.toJSON() : "") + "&";
        if (minEffectiveToFilter !== undefined)
            url_ += "MinEffectiveToFilter=" + encodeURIComponent(minEffectiveToFilter ? "" + minEffectiveToFilter.toJSON() : "") + "&";
        if (maxExpireDateFilter !== undefined)
            url_ += "MaxExpireDateFilter=" + encodeURIComponent(maxExpireDateFilter ? "" + maxExpireDateFilter.toJSON() : "") + "&";
        if (minExpireDateFilter !== undefined)
            url_ += "MinExpireDateFilter=" + encodeURIComponent(minExpireDateFilter ? "" + minExpireDateFilter.toJSON() : "") + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (imageLinkFilter !== undefined)
            url_ += "ImageLinkFilter=" + encodeURIComponent("" + imageLinkFilter) + "&";
        if (nameUnsignFilter !== undefined)
            url_ += "NameUnsignFilter=" + encodeURIComponent("" + nameUnsignFilter) + "&";
        if (productTypeFilter !== undefined)
            url_ += "ProductTypeFilter=" + encodeURIComponent("" + productTypeFilter) + "&";
        if (publisherFilter !== undefined)
            url_ += "PublisherFilter=" + encodeURIComponent("" + publisherFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetGiftMastersToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGiftMastersToExcel(<any>response_);
                } catch (e) {
                    return <Observable<GiftFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GiftFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetGiftMastersToExcel(response: HttpResponseBase): Observable<GiftFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GiftFileDto.fromJS(resultData200) : new GiftFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GiftFileDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param codeFilter (optional) 
     * @param nameFilter (optional) 
     * @param maxQuantityFilter (optional) 
     * @param minQuantityFilter (optional) 
     * @param maxPriceFilter (optional) 
     * @param minPriceFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param maxEffectiveFromFilter (optional) 
     * @param minEffectiveFromFilter (optional) 
     * @param maxEffectiveToFilter (optional) 
     * @param minEffectiveToFilter (optional) 
     * @param maxExpireDateFilter (optional) 
     * @param minExpireDateFilter (optional) 
     * @param statusFilter (optional) 
     * @param imageLinkFilter (optional) 
     * @param nameUnsignFilter (optional) 
     * @param productTypeFilter (optional) 
     * @param publisherFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllAsync(filter: string | null | undefined, codeFilter: string | null | undefined, nameFilter: string | null | undefined, maxQuantityFilter: number | null | undefined, minQuantityFilter: number | null | undefined, maxPriceFilter: number | null | undefined, minPriceFilter: number | null | undefined, descriptionFilter: string | null | undefined, maxEffectiveFromFilter: moment.Moment | null | undefined, minEffectiveFromFilter: moment.Moment | null | undefined, maxEffectiveToFilter: moment.Moment | null | undefined, minEffectiveToFilter: moment.Moment | null | undefined, maxExpireDateFilter: moment.Moment | null | undefined, minExpireDateFilter: moment.Moment | null | undefined, statusFilter: string | null | undefined, imageLinkFilter: string | null | undefined, nameUnsignFilter: string | null | undefined, productTypeFilter: string | null | undefined, publisherFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetGiftMasterForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/GiftMasters/GetAllAsync?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&";
        if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (maxQuantityFilter !== undefined)
            url_ += "MaxQuantityFilter=" + encodeURIComponent("" + maxQuantityFilter) + "&";
        if (minQuantityFilter !== undefined)
            url_ += "MinQuantityFilter=" + encodeURIComponent("" + minQuantityFilter) + "&";
        if (maxPriceFilter !== undefined)
            url_ += "MaxPriceFilter=" + encodeURIComponent("" + maxPriceFilter) + "&";
        if (minPriceFilter !== undefined)
            url_ += "MinPriceFilter=" + encodeURIComponent("" + minPriceFilter) + "&";
        if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&";
        if (maxEffectiveFromFilter !== undefined)
            url_ += "MaxEffectiveFromFilter=" + encodeURIComponent(maxEffectiveFromFilter ? "" + maxEffectiveFromFilter.toJSON() : "") + "&";
        if (minEffectiveFromFilter !== undefined)
            url_ += "MinEffectiveFromFilter=" + encodeURIComponent(minEffectiveFromFilter ? "" + minEffectiveFromFilter.toJSON() : "") + "&";
        if (maxEffectiveToFilter !== undefined)
            url_ += "MaxEffectiveToFilter=" + encodeURIComponent(maxEffectiveToFilter ? "" + maxEffectiveToFilter.toJSON() : "") + "&";
        if (minEffectiveToFilter !== undefined)
            url_ += "MinEffectiveToFilter=" + encodeURIComponent(minEffectiveToFilter ? "" + minEffectiveToFilter.toJSON() : "") + "&";
        if (maxExpireDateFilter !== undefined)
            url_ += "MaxExpireDateFilter=" + encodeURIComponent(maxExpireDateFilter ? "" + maxExpireDateFilter.toJSON() : "") + "&";
        if (minExpireDateFilter !== undefined)
            url_ += "MinExpireDateFilter=" + encodeURIComponent(minExpireDateFilter ? "" + minExpireDateFilter.toJSON() : "") + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (imageLinkFilter !== undefined)
            url_ += "ImageLinkFilter=" + encodeURIComponent("" + imageLinkFilter) + "&";
        if (nameUnsignFilter !== undefined)
            url_ += "NameUnsignFilter=" + encodeURIComponent("" + nameUnsignFilter) + "&";
        if (productTypeFilter !== undefined)
            url_ += "ProductTypeFilter=" + encodeURIComponent("" + productTypeFilter) + "&";
        if (publisherFilter !== undefined)
            url_ += "PublisherFilter=" + encodeURIComponent("" + publisherFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllAsync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAsync(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetGiftMasterForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetGiftMasterForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllAsync(response: HttpResponseBase): Observable<PagedResultDtoOfGetGiftMasterForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetGiftMasterForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetGiftMasterForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetGiftMasterForViewDto>(<any>null);
    }

    /**
     * @param entities (optional) 
     * @return Success
     */
    batchDeleteAsync(entities: GiftMasterDto[] | null | undefined): Observable<MessageResultForDeleteGift> {
        let url_ = this.baseUrl + "/api/services/app/GiftMasters/BatchDeleteAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entities);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processBatchDeleteAsync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBatchDeleteAsync(<any>response_);
                } catch (e) {
                    return <Observable<MessageResultForDeleteGift>><any>_observableThrow(e);
                }
            } else
                return <Observable<MessageResultForDeleteGift>><any>_observableThrow(response_);
        }));
    }

    protected processBatchDeleteAsync(response: HttpResponseBase): Observable<MessageResultForDeleteGift> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? MessageResultForDeleteGift.fromJS(resultData200) : new MessageResultForDeleteGift();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MessageResultForDeleteGift>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEditUnsignAsync(input: CreateOrEditGiftMasterDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GiftMasters/CreateOrEditUnsignAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEditUnsignAsync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditUnsignAsync(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEditUnsignAsync(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    getAllPublisherAsync(): Observable<PublisherForGiftMasterDto[]> {
        let url_ = this.baseUrl + "/api/services/app/GiftMasters/GetAllPublisherAsync";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllPublisherAsync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPublisherAsync(<any>response_);
                } catch (e) {
                    return <Observable<PublisherForGiftMasterDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<PublisherForGiftMasterDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllPublisherAsync(response: HttpResponseBase): Observable<PublisherForGiftMasterDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(PublisherForGiftMasterDto.fromJS(item));
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PublisherForGiftMasterDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getProductAsync(): Observable<MessageResultGift> {
        let url_ = this.baseUrl + "/api/services/app/GiftMasters/GetProductAsync";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetProductAsync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductAsync(<any>response_);
                } catch (e) {
                    return <Observable<MessageResultGift>><any>_observableThrow(e);
                }
            } else
                return <Observable<MessageResultGift>><any>_observableThrow(response_);
        }));
    }

    protected processGetProductAsync(response: HttpResponseBase): Observable<MessageResultGift> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? MessageResultGift.fromJS(resultData200) : new MessageResultGift();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MessageResultGift>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param codeFilter (optional) 
     * @param nameFilter (optional) 
     * @param maxQuantityFilter (optional) 
     * @param minQuantityFilter (optional) 
     * @param maxPriceFilter (optional) 
     * @param minPriceFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param maxEffectiveFromFilter (optional) 
     * @param minEffectiveFromFilter (optional) 
     * @param maxEffectiveToFilter (optional) 
     * @param minEffectiveToFilter (optional) 
     * @param maxExpireDateFilter (optional) 
     * @param minExpireDateFilter (optional) 
     * @param statusFilter (optional) 
     * @param imageLinkFilter (optional) 
     * @param nameUnsignFilter (optional) 
     * @param productTypeFilter (optional) 
     * @param publisherFilter (optional) 
     * @return Success
     */
    getGiftMastersToExcelAsync(filter: string | null | undefined, codeFilter: string | null | undefined, nameFilter: string | null | undefined, maxQuantityFilter: number | null | undefined, minQuantityFilter: number | null | undefined, maxPriceFilter: number | null | undefined, minPriceFilter: number | null | undefined, descriptionFilter: string | null | undefined, maxEffectiveFromFilter: moment.Moment | null | undefined, minEffectiveFromFilter: moment.Moment | null | undefined, maxEffectiveToFilter: moment.Moment | null | undefined, minEffectiveToFilter: moment.Moment | null | undefined, maxExpireDateFilter: moment.Moment | null | undefined, minExpireDateFilter: moment.Moment | null | undefined, statusFilter: string | null | undefined, imageLinkFilter: string | null | undefined, nameUnsignFilter: string | null | undefined, productTypeFilter: string | null | undefined, publisherFilter: string | null | undefined): Observable<GiftFileDto> {
        let url_ = this.baseUrl + "/api/services/app/GiftMasters/GetGiftMastersToExcelAsync?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&";
        if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (maxQuantityFilter !== undefined)
            url_ += "MaxQuantityFilter=" + encodeURIComponent("" + maxQuantityFilter) + "&";
        if (minQuantityFilter !== undefined)
            url_ += "MinQuantityFilter=" + encodeURIComponent("" + minQuantityFilter) + "&";
        if (maxPriceFilter !== undefined)
            url_ += "MaxPriceFilter=" + encodeURIComponent("" + maxPriceFilter) + "&";
        if (minPriceFilter !== undefined)
            url_ += "MinPriceFilter=" + encodeURIComponent("" + minPriceFilter) + "&";
        if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&";
        if (maxEffectiveFromFilter !== undefined)
            url_ += "MaxEffectiveFromFilter=" + encodeURIComponent(maxEffectiveFromFilter ? "" + maxEffectiveFromFilter.toJSON() : "") + "&";
        if (minEffectiveFromFilter !== undefined)
            url_ += "MinEffectiveFromFilter=" + encodeURIComponent(minEffectiveFromFilter ? "" + minEffectiveFromFilter.toJSON() : "") + "&";
        if (maxEffectiveToFilter !== undefined)
            url_ += "MaxEffectiveToFilter=" + encodeURIComponent(maxEffectiveToFilter ? "" + maxEffectiveToFilter.toJSON() : "") + "&";
        if (minEffectiveToFilter !== undefined)
            url_ += "MinEffectiveToFilter=" + encodeURIComponent(minEffectiveToFilter ? "" + minEffectiveToFilter.toJSON() : "") + "&";
        if (maxExpireDateFilter !== undefined)
            url_ += "MaxExpireDateFilter=" + encodeURIComponent(maxExpireDateFilter ? "" + maxExpireDateFilter.toJSON() : "") + "&";
        if (minExpireDateFilter !== undefined)
            url_ += "MinExpireDateFilter=" + encodeURIComponent(minExpireDateFilter ? "" + minExpireDateFilter.toJSON() : "") + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (imageLinkFilter !== undefined)
            url_ += "ImageLinkFilter=" + encodeURIComponent("" + imageLinkFilter) + "&";
        if (nameUnsignFilter !== undefined)
            url_ += "NameUnsignFilter=" + encodeURIComponent("" + nameUnsignFilter) + "&";
        if (productTypeFilter !== undefined)
            url_ += "ProductTypeFilter=" + encodeURIComponent("" + productTypeFilter) + "&";
        if (publisherFilter !== undefined)
            url_ += "PublisherFilter=" + encodeURIComponent("" + publisherFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetGiftMastersToExcelAsync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGiftMastersToExcelAsync(<any>response_);
                } catch (e) {
                    return <Observable<GiftFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GiftFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetGiftMastersToExcelAsync(response: HttpResponseBase): Observable<GiftFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GiftFileDto.fromJS(resultData200) : new GiftFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GiftFileDto>(<any>null);
    }

    /**
     * @param arg (optional) 
     * @return Success
     */
    importQueue(arg: GiftMasterImportAgrs | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GiftMasters/ImportQueue";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(arg);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processImportQueue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportQueue(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processImportQueue(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    getGenerateCode(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/GiftMasters/GetGenerateCode";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetGenerateCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGenerateCode(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetGenerateCode(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }
}

@Injectable()
export class GiftRedeemLogsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param memberCodeFilter (optional) 
     * @param giftCodeFilter (optional) 
     * @param transactionCodeFilter (optional) 
     * @param referenceCodeFilter (optional) 
     * @param typeFilter (optional) 
     * @param dataFilter (optional) 
     * @param statusFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, memberCodeFilter: string | null | undefined, giftCodeFilter: string | null | undefined, transactionCodeFilter: string | null | undefined, referenceCodeFilter: string | null | undefined, typeFilter: string | null | undefined, dataFilter: string | null | undefined, statusFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetGiftRedeemLogForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/GiftRedeemLogs/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (memberCodeFilter !== undefined)
            url_ += "MemberCodeFilter=" + encodeURIComponent("" + memberCodeFilter) + "&";
        if (giftCodeFilter !== undefined)
            url_ += "GiftCodeFilter=" + encodeURIComponent("" + giftCodeFilter) + "&";
        if (transactionCodeFilter !== undefined)
            url_ += "TransactionCodeFilter=" + encodeURIComponent("" + transactionCodeFilter) + "&";
        if (referenceCodeFilter !== undefined)
            url_ += "ReferenceCodeFilter=" + encodeURIComponent("" + referenceCodeFilter) + "&";
        if (typeFilter !== undefined)
            url_ += "TypeFilter=" + encodeURIComponent("" + typeFilter) + "&";
        if (dataFilter !== undefined)
            url_ += "DataFilter=" + encodeURIComponent("" + dataFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetGiftRedeemLogForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetGiftRedeemLogForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetGiftRedeemLogForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetGiftRedeemLogForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetGiftRedeemLogForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetGiftRedeemLogForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getGiftRedeemLogForEdit(id: number | null | undefined): Observable<GetGiftRedeemLogForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/GiftRedeemLogs/GetGiftRedeemLogForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetGiftRedeemLogForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGiftRedeemLogForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetGiftRedeemLogForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetGiftRedeemLogForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetGiftRedeemLogForEdit(response: HttpResponseBase): Observable<GetGiftRedeemLogForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetGiftRedeemLogForEditOutput.fromJS(resultData200) : new GetGiftRedeemLogForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetGiftRedeemLogForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditGiftRedeemLogDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GiftRedeemLogs/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GiftRedeemLogs/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class GiftRedeemTransactionsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param codeFilter (optional) 
     * @param giftCodeFilter (optional) 
     * @param memberCodeFilter (optional) 
     * @param giftFilter (optional) 
     * @param eGiftCodeFilter (optional) 
     * @param maxQuantityFilter (optional) 
     * @param minQuantityFilter (optional) 
     * @param statusFilter (optional) 
     * @param memberNameFilter (optional) 
     * @param giftTenantIdFilter (optional) 
     * @param fromDateFilter (optional) 
     * @param toDateFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, codeFilter: string | null | undefined, giftCodeFilter: string | null | undefined, memberCodeFilter: string | null | undefined, giftFilter: string | null | undefined, eGiftCodeFilter: string | null | undefined, maxQuantityFilter: number | null | undefined, minQuantityFilter: number | null | undefined, statusFilter: string | null | undefined, memberNameFilter: string | null | undefined, giftTenantIdFilter: string | null | undefined, fromDateFilter: moment.Moment | null | undefined, toDateFilter: moment.Moment | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetGiftRedeemTransactionForView> {
        let url_ = this.baseUrl + "/api/services/app/GiftRedeemTransactions/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&";
        if (giftCodeFilter !== undefined)
            url_ += "GiftCodeFilter=" + encodeURIComponent("" + giftCodeFilter) + "&";
        if (memberCodeFilter !== undefined)
            url_ += "MemberCodeFilter=" + encodeURIComponent("" + memberCodeFilter) + "&";
        if (giftFilter !== undefined)
            url_ += "GiftFilter=" + encodeURIComponent("" + giftFilter) + "&";
        if (eGiftCodeFilter !== undefined)
            url_ += "EGiftCodeFilter=" + encodeURIComponent("" + eGiftCodeFilter) + "&";
        if (maxQuantityFilter !== undefined)
            url_ += "MaxQuantityFilter=" + encodeURIComponent("" + maxQuantityFilter) + "&";
        if (minQuantityFilter !== undefined)
            url_ += "MinQuantityFilter=" + encodeURIComponent("" + minQuantityFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (memberNameFilter !== undefined)
            url_ += "MemberNameFilter=" + encodeURIComponent("" + memberNameFilter) + "&";
        if (giftTenantIdFilter !== undefined)
            url_ += "GiftTenantIdFilter=" + encodeURIComponent("" + giftTenantIdFilter) + "&";
        if (fromDateFilter !== undefined)
            url_ += "FromDateFilter=" + encodeURIComponent(fromDateFilter ? "" + fromDateFilter.toJSON() : "") + "&";
        if (toDateFilter !== undefined)
            url_ += "ToDateFilter=" + encodeURIComponent(toDateFilter ? "" + toDateFilter.toJSON() : "") + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetGiftRedeemTransactionForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetGiftRedeemTransactionForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetGiftRedeemTransactionForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetGiftRedeemTransactionForView.fromJS(resultData200) : new PagedResultDtoOfGetGiftRedeemTransactionForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetGiftRedeemTransactionForView>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getGiftTransactionForEdit(id: number | null | undefined): Observable<GetGiftRedeemTransactionForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/GiftRedeemTransactions/GetGiftTransactionForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetGiftTransactionForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGiftTransactionForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetGiftRedeemTransactionForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetGiftRedeemTransactionForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetGiftTransactionForEdit(response: HttpResponseBase): Observable<GetGiftRedeemTransactionForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetGiftRedeemTransactionForEditOutput.fromJS(resultData200) : new GetGiftRedeemTransactionForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetGiftRedeemTransactionForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditGiftRedeemTransactionDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GiftRedeemTransactions/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GiftRedeemTransactions/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllSecondaryCustomerForLookupTable(filter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfSecondaryCustomerLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/GiftRedeemTransactions/GetAllSecondaryCustomerForLookupTable?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllSecondaryCustomerForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSecondaryCustomerForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfSecondaryCustomerLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfSecondaryCustomerLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllSecondaryCustomerForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfSecondaryCustomerLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfSecondaryCustomerLookupTableDto.fromJS(resultData200) : new PagedResultDtoOfSecondaryCustomerLookupTableDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfSecondaryCustomerLookupTableDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllGiftInforForLookupTable(filter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGiftInforLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/GiftRedeemTransactions/GetAllGiftInforForLookupTable?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllGiftInforForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllGiftInforForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGiftInforLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGiftInforLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllGiftInforForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfGiftInforLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGiftInforLookupTableDto.fromJS(resultData200) : new PagedResultDtoOfGiftInforLookupTableDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGiftInforLookupTableDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param codeFilter (optional) 
     * @param giftCodeFilter (optional) 
     * @param memberCodeFilter (optional) 
     * @param giftFilter (optional) 
     * @param eGiftCodeFilter (optional) 
     * @param maxQuantityFilter (optional) 
     * @param minQuantityFilter (optional) 
     * @param statusFilter (optional) 
     * @param memberNameFilter (optional) 
     * @param giftTenantIdFilter (optional) 
     * @param fromDateFilter (optional) 
     * @param toDateFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllGiftTransaction(filter: string | null | undefined, codeFilter: string | null | undefined, giftCodeFilter: string | null | undefined, memberCodeFilter: string | null | undefined, giftFilter: string | null | undefined, eGiftCodeFilter: string | null | undefined, maxQuantityFilter: number | null | undefined, minQuantityFilter: number | null | undefined, statusFilter: string | null | undefined, memberNameFilter: string | null | undefined, giftTenantIdFilter: string | null | undefined, fromDateFilter: moment.Moment | null | undefined, toDateFilter: moment.Moment | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetGiftRedeemTransactionForView> {
        let url_ = this.baseUrl + "/api/services/app/GiftRedeemTransactions/GetAllGiftTransaction?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&";
        if (giftCodeFilter !== undefined)
            url_ += "GiftCodeFilter=" + encodeURIComponent("" + giftCodeFilter) + "&";
        if (memberCodeFilter !== undefined)
            url_ += "MemberCodeFilter=" + encodeURIComponent("" + memberCodeFilter) + "&";
        if (giftFilter !== undefined)
            url_ += "GiftFilter=" + encodeURIComponent("" + giftFilter) + "&";
        if (eGiftCodeFilter !== undefined)
            url_ += "EGiftCodeFilter=" + encodeURIComponent("" + eGiftCodeFilter) + "&";
        if (maxQuantityFilter !== undefined)
            url_ += "MaxQuantityFilter=" + encodeURIComponent("" + maxQuantityFilter) + "&";
        if (minQuantityFilter !== undefined)
            url_ += "MinQuantityFilter=" + encodeURIComponent("" + minQuantityFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (memberNameFilter !== undefined)
            url_ += "MemberNameFilter=" + encodeURIComponent("" + memberNameFilter) + "&";
        if (giftTenantIdFilter !== undefined)
            url_ += "GiftTenantIdFilter=" + encodeURIComponent("" + giftTenantIdFilter) + "&";
        if (fromDateFilter !== undefined)
            url_ += "FromDateFilter=" + encodeURIComponent(fromDateFilter ? "" + fromDateFilter.toJSON() : "") + "&";
        if (toDateFilter !== undefined)
            url_ += "ToDateFilter=" + encodeURIComponent(toDateFilter ? "" + toDateFilter.toJSON() : "") + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllGiftTransaction(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllGiftTransaction(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetGiftRedeemTransactionForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetGiftRedeemTransactionForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllGiftTransaction(response: HttpResponseBase): Observable<PagedResultDtoOfGetGiftRedeemTransactionForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetGiftRedeemTransactionForView.fromJS(resultData200) : new PagedResultDtoOfGetGiftRedeemTransactionForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetGiftRedeemTransactionForView>(<any>null);
    }

    /**
     * @param idGiftTransaction (optional) 
     * @param oldStastus (optional) 
     * @param newStatus (optional) 
     * @return Success
     */
    swichStatusGiftTransaction(idGiftTransaction: number | null | undefined, oldStastus: string | null | undefined, newStatus: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/GiftRedeemTransactions/SwichStatusGiftTransaction?";
        if (idGiftTransaction !== undefined)
            url_ += "idGiftTransaction=" + encodeURIComponent("" + idGiftTransaction) + "&";
        if (oldStastus !== undefined)
            url_ += "oldStastus=" + encodeURIComponent("" + oldStastus) + "&";
        if (newStatus !== undefined)
            url_ += "newStatus=" + encodeURIComponent("" + newStatus) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSwichStatusGiftTransaction(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSwichStatusGiftTransaction(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processSwichStatusGiftTransaction(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param inputs (optional) 
     * @param status (optional) 
     * @return Success
     */
    updateStatus(inputs: GetGiftRedeemTransactionForView[] | null | undefined, status: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GiftRedeemTransactions/UpdateStatus?";
        if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inputs);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateStatus(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param codeFilter (optional) 
     * @param memberCodeFilter (optional) 
     * @param giftFilter (optional) 
     * @param eGiftCodeFilter (optional) 
     * @param statusFilter (optional) 
     * @param memberNameFilter (optional) 
     * @param giftTenantIdFilter (optional) 
     * @param fromDateFilter (optional) 
     * @param toDateFilter (optional) 
     * @return Success
     */
    getGiftTransactionToExcel(filter: string | null | undefined, codeFilter: string | null | undefined, memberCodeFilter: string | null | undefined, giftFilter: string | null | undefined, eGiftCodeFilter: string | null | undefined, statusFilter: string | null | undefined, memberNameFilter: string | null | undefined, giftTenantIdFilter: string | null | undefined, fromDateFilter: moment.Moment | null | undefined, toDateFilter: moment.Moment | null | undefined): Observable<PointFileDto> {
        let url_ = this.baseUrl + "/api/services/app/GiftRedeemTransactions/GetGiftTransactionToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&";
        if (memberCodeFilter !== undefined)
            url_ += "MemberCodeFilter=" + encodeURIComponent("" + memberCodeFilter) + "&";
        if (giftFilter !== undefined)
            url_ += "GiftFilter=" + encodeURIComponent("" + giftFilter) + "&";
        if (eGiftCodeFilter !== undefined)
            url_ += "EGiftCodeFilter=" + encodeURIComponent("" + eGiftCodeFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (memberNameFilter !== undefined)
            url_ += "MemberNameFilter=" + encodeURIComponent("" + memberNameFilter) + "&";
        if (giftTenantIdFilter !== undefined)
            url_ += "GiftTenantIdFilter=" + encodeURIComponent("" + giftTenantIdFilter) + "&";
        if (fromDateFilter !== undefined)
            url_ += "FromDateFilter=" + encodeURIComponent(fromDateFilter ? "" + fromDateFilter.toJSON() : "") + "&";
        if (toDateFilter !== undefined)
            url_ += "ToDateFilter=" + encodeURIComponent(toDateFilter ? "" + toDateFilter.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetGiftTransactionToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGiftTransactionToExcel(<any>response_);
                } catch (e) {
                    return <Observable<PointFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PointFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetGiftTransactionToExcel(response: HttpResponseBase): Observable<PointFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PointFileDto.fromJS(resultData200) : new PointFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PointFileDto>(<any>null);
    }

    /**
     * @param statusFilter (optional) 
     * @param fromDateFilter (optional) 
     * @param toDateFilter (optional) 
     * @param giftTransactionCode (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getAllWithEGift(memberCodeFilter: string, statusFilter: string | null | undefined, fromDateFilter: moment.Moment | null | undefined, toDateFilter: moment.Moment | null | undefined, giftTransactionCode: string | null | undefined, maxResultCount: number | null | undefined, skipCount: number | null | undefined, sorting: string | null | undefined): Observable<PagedResultDtoOfGetGiftTransactionWithEGiftForView> {
        let url_ = this.baseUrl + "/api/services/app/GiftRedeemTransactions/GetAllWithEGift?";
        if (memberCodeFilter === undefined || memberCodeFilter === null)
            throw new Error("The parameter 'memberCodeFilter' must be defined and cannot be null.");
        else
            url_ += "MemberCodeFilter=" + encodeURIComponent("" + memberCodeFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (fromDateFilter !== undefined)
            url_ += "FromDateFilter=" + encodeURIComponent(fromDateFilter ? "" + fromDateFilter.toJSON() : "") + "&";
        if (toDateFilter !== undefined)
            url_ += "ToDateFilter=" + encodeURIComponent(toDateFilter ? "" + toDateFilter.toJSON() : "") + "&";
        if (giftTransactionCode !== undefined)
            url_ += "GiftTransactionCode=" + encodeURIComponent("" + giftTransactionCode) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllWithEGift(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllWithEGift(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetGiftTransactionWithEGiftForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetGiftTransactionWithEGiftForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllWithEGift(response: HttpResponseBase): Observable<PagedResultDtoOfGetGiftTransactionWithEGiftForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetGiftTransactionWithEGiftForView.fromJS(resultData200) : new PagedResultDtoOfGetGiftTransactionWithEGiftForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetGiftTransactionWithEGiftForView>(<any>null);
    }

    /**
     * @param statusFilter (optional) 
     * @param fromDateFilter (optional) 
     * @param toDateFilter (optional) 
     * @param giftTransactionCode (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getAllWithEGiftExt(memberCodeFilter: string, statusFilter: string | null | undefined, fromDateFilter: moment.Moment | null | undefined, toDateFilter: moment.Moment | null | undefined, giftTransactionCode: string | null | undefined, maxResultCount: number | null | undefined, skipCount: number | null | undefined, sorting: string | null | undefined): Observable<PagedResultDtoOfGetGiftTransactionWithEGiftForView> {
        let url_ = this.baseUrl + "/api/services/app/GiftRedeemTransactions/GetAllWithEGiftExt?";
        if (memberCodeFilter === undefined || memberCodeFilter === null)
            throw new Error("The parameter 'memberCodeFilter' must be defined and cannot be null.");
        else
            url_ += "MemberCodeFilter=" + encodeURIComponent("" + memberCodeFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (fromDateFilter !== undefined)
            url_ += "FromDateFilter=" + encodeURIComponent(fromDateFilter ? "" + fromDateFilter.toJSON() : "") + "&";
        if (toDateFilter !== undefined)
            url_ += "ToDateFilter=" + encodeURIComponent(toDateFilter ? "" + toDateFilter.toJSON() : "") + "&";
        if (giftTransactionCode !== undefined)
            url_ += "GiftTransactionCode=" + encodeURIComponent("" + giftTransactionCode) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllWithEGiftExt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllWithEGiftExt(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetGiftTransactionWithEGiftForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetGiftTransactionWithEGiftForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllWithEGiftExt(response: HttpResponseBase): Observable<PagedResultDtoOfGetGiftTransactionWithEGiftForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetGiftTransactionWithEGiftForView.fromJS(resultData200) : new PagedResultDtoOfGetGiftTransactionWithEGiftForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetGiftTransactionWithEGiftForView>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    checkCreateRedeemTransaction(input: RequestDataCheckRedeemTransaction | null | undefined): Observable<ReponseCheckDataRedeemTransaction> {
        let url_ = this.baseUrl + "/api/services/app/GiftRedeemTransactions/CheckCreateRedeemTransaction";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCheckCreateRedeemTransaction(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckCreateRedeemTransaction(<any>response_);
                } catch (e) {
                    return <Observable<ReponseCheckDataRedeemTransaction>><any>_observableThrow(e);
                }
            } else
                return <Observable<ReponseCheckDataRedeemTransaction>><any>_observableThrow(response_);
        }));
    }

    protected processCheckCreateRedeemTransaction(response: HttpResponseBase): Observable<ReponseCheckDataRedeemTransaction> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? ReponseCheckDataRedeemTransaction.fromJS(resultData200) : new ReponseCheckDataRedeemTransaction();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReponseCheckDataRedeemTransaction>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createRedeemTransaction(input: RequestCreateRedeemTransaction | null | undefined): Observable<ReponseDataRedeemTransaction> {
        let url_ = this.baseUrl + "/api/services/app/GiftRedeemTransactions/CreateRedeemTransaction";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateRedeemTransaction(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateRedeemTransaction(<any>response_);
                } catch (e) {
                    return <Observable<ReponseDataRedeemTransaction>><any>_observableThrow(e);
                }
            } else
                return <Observable<ReponseDataRedeemTransaction>><any>_observableThrow(response_);
        }));
    }

    protected processCreateRedeemTransaction(response: HttpResponseBase): Observable<ReponseDataRedeemTransaction> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? ReponseDataRedeemTransaction.fromJS(resultData200) : new ReponseDataRedeemTransaction();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReponseDataRedeemTransaction>(<any>null);
    }
}

@Injectable()
export class GiftTargetAudienceDetailsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param maxGiftTargetAudienceIDFilter (optional) 
     * @param minGiftTargetAudienceIDFilter (optional) 
     * @param nameFilter (optional) 
     * @param phoneFilter (optional) 
     * @param zaloChatIDFilter (optional) 
     * @param emailFilter (optional) 
     * @param facebookIDFilter (optional) 
     * @param memberCodeFilter (optional) 
     * @param communicationLanguageFilter (optional) 
     * @param communicationChannelFilter (optional) 
     * @param outletCodeFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, maxGiftTargetAudienceIDFilter: number | null | undefined, minGiftTargetAudienceIDFilter: number | null | undefined, nameFilter: string | null | undefined, phoneFilter: string | null | undefined, zaloChatIDFilter: string | null | undefined, emailFilter: string | null | undefined, facebookIDFilter: string | null | undefined, memberCodeFilter: string | null | undefined, communicationLanguageFilter: string | null | undefined, communicationChannelFilter: string | null | undefined, outletCodeFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetGiftTargetAudienceDetailForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/GiftTargetAudienceDetails/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxGiftTargetAudienceIDFilter !== undefined)
            url_ += "MaxGiftTargetAudienceIDFilter=" + encodeURIComponent("" + maxGiftTargetAudienceIDFilter) + "&";
        if (minGiftTargetAudienceIDFilter !== undefined)
            url_ += "MinGiftTargetAudienceIDFilter=" + encodeURIComponent("" + minGiftTargetAudienceIDFilter) + "&";
        if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (phoneFilter !== undefined)
            url_ += "PhoneFilter=" + encodeURIComponent("" + phoneFilter) + "&";
        if (zaloChatIDFilter !== undefined)
            url_ += "ZaloChatIDFilter=" + encodeURIComponent("" + zaloChatIDFilter) + "&";
        if (emailFilter !== undefined)
            url_ += "EmailFilter=" + encodeURIComponent("" + emailFilter) + "&";
        if (facebookIDFilter !== undefined)
            url_ += "FacebookIDFilter=" + encodeURIComponent("" + facebookIDFilter) + "&";
        if (memberCodeFilter !== undefined)
            url_ += "MemberCodeFilter=" + encodeURIComponent("" + memberCodeFilter) + "&";
        if (communicationLanguageFilter !== undefined)
            url_ += "CommunicationLanguageFilter=" + encodeURIComponent("" + communicationLanguageFilter) + "&";
        if (communicationChannelFilter !== undefined)
            url_ += "CommunicationChannelFilter=" + encodeURIComponent("" + communicationChannelFilter) + "&";
        if (outletCodeFilter !== undefined)
            url_ += "OutletCodeFilter=" + encodeURIComponent("" + outletCodeFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetGiftTargetAudienceDetailForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetGiftTargetAudienceDetailForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetGiftTargetAudienceDetailForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetGiftTargetAudienceDetailForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetGiftTargetAudienceDetailForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetGiftTargetAudienceDetailForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getGiftTargetAudienceDetailForEdit(id: number | null | undefined): Observable<GetGiftTargetAudienceDetailForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/GiftTargetAudienceDetails/GetGiftTargetAudienceDetailForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetGiftTargetAudienceDetailForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGiftTargetAudienceDetailForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetGiftTargetAudienceDetailForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetGiftTargetAudienceDetailForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetGiftTargetAudienceDetailForEdit(response: HttpResponseBase): Observable<GetGiftTargetAudienceDetailForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetGiftTargetAudienceDetailForEditOutput.fromJS(resultData200) : new GetGiftTargetAudienceDetailForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetGiftTargetAudienceDetailForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditGiftTargetAudienceDetailDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GiftTargetAudienceDetails/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GiftTargetAudienceDetails/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class GiftTargetAudiencesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param targetAudienceNameFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param statusFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, targetAudienceNameFilter: string | null | undefined, descriptionFilter: string | null | undefined, statusFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetGiftTargetAudienceForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/GiftTargetAudiences/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (targetAudienceNameFilter !== undefined)
            url_ += "TargetAudienceNameFilter=" + encodeURIComponent("" + targetAudienceNameFilter) + "&";
        if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetGiftTargetAudienceForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetGiftTargetAudienceForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetGiftTargetAudienceForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetGiftTargetAudienceForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetGiftTargetAudienceForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetGiftTargetAudienceForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getGiftTargetAudienceForEdit(id: number | null | undefined): Observable<GetGiftTargetAudienceForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/GiftTargetAudiences/GetGiftTargetAudienceForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetGiftTargetAudienceForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGiftTargetAudienceForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetGiftTargetAudienceForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetGiftTargetAudienceForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetGiftTargetAudienceForEdit(response: HttpResponseBase): Observable<GetGiftTargetAudienceForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetGiftTargetAudienceForEditOutput.fromJS(resultData200) : new GetGiftTargetAudienceForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetGiftTargetAudienceForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditGiftTargetAudienceDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GiftTargetAudiences/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GiftTargetAudiences/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class GiftTransactionsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param giftCampaignCodeFilter (optional) 
     * @param outletCodeFilter (optional) 
     * @param outletNameFilter (optional) 
     * @param zaloChatIDFilter (optional) 
     * @param maxPublishDateFilter (optional) 
     * @param minPublishDateFilter (optional) 
     * @param maxRequestDateFilter (optional) 
     * @param minRequestDateFilter (optional) 
     * @param giftMasterCodeFilter (optional) 
     * @param giftCodeFilter (optional) 
     * @param statusFilter (optional) 
     * @param transactionIDFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, giftCampaignCodeFilter: string | null | undefined, outletCodeFilter: string | null | undefined, outletNameFilter: string | null | undefined, zaloChatIDFilter: string | null | undefined, maxPublishDateFilter: moment.Moment | null | undefined, minPublishDateFilter: moment.Moment | null | undefined, maxRequestDateFilter: moment.Moment | null | undefined, minRequestDateFilter: moment.Moment | null | undefined, giftMasterCodeFilter: string | null | undefined, giftCodeFilter: string | null | undefined, statusFilter: string | null | undefined, transactionIDFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetGiftTransactionForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/GiftTransactions/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (giftCampaignCodeFilter !== undefined)
            url_ += "GiftCampaignCodeFilter=" + encodeURIComponent("" + giftCampaignCodeFilter) + "&";
        if (outletCodeFilter !== undefined)
            url_ += "OutletCodeFilter=" + encodeURIComponent("" + outletCodeFilter) + "&";
        if (outletNameFilter !== undefined)
            url_ += "OutletNameFilter=" + encodeURIComponent("" + outletNameFilter) + "&";
        if (zaloChatIDFilter !== undefined)
            url_ += "ZaloChatIDFilter=" + encodeURIComponent("" + zaloChatIDFilter) + "&";
        if (maxPublishDateFilter !== undefined)
            url_ += "MaxPublishDateFilter=" + encodeURIComponent(maxPublishDateFilter ? "" + maxPublishDateFilter.toJSON() : "") + "&";
        if (minPublishDateFilter !== undefined)
            url_ += "MinPublishDateFilter=" + encodeURIComponent(minPublishDateFilter ? "" + minPublishDateFilter.toJSON() : "") + "&";
        if (maxRequestDateFilter !== undefined)
            url_ += "MaxRequestDateFilter=" + encodeURIComponent(maxRequestDateFilter ? "" + maxRequestDateFilter.toJSON() : "") + "&";
        if (minRequestDateFilter !== undefined)
            url_ += "MinRequestDateFilter=" + encodeURIComponent(minRequestDateFilter ? "" + minRequestDateFilter.toJSON() : "") + "&";
        if (giftMasterCodeFilter !== undefined)
            url_ += "GiftMasterCodeFilter=" + encodeURIComponent("" + giftMasterCodeFilter) + "&";
        if (giftCodeFilter !== undefined)
            url_ += "GiftCodeFilter=" + encodeURIComponent("" + giftCodeFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (transactionIDFilter !== undefined)
            url_ += "TransactionIDFilter=" + encodeURIComponent("" + transactionIDFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetGiftTransactionForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetGiftTransactionForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetGiftTransactionForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetGiftTransactionForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetGiftTransactionForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetGiftTransactionForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getGiftTransactionForEdit(id: number | null | undefined): Observable<GetGiftTransactionForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/GiftTransactions/GetGiftTransactionForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetGiftTransactionForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGiftTransactionForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetGiftTransactionForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetGiftTransactionForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetGiftTransactionForEdit(response: HttpResponseBase): Observable<GetGiftTransactionForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetGiftTransactionForEditOutput.fromJS(resultData200) : new GetGiftTransactionForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetGiftTransactionForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditGiftTransactionDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GiftTransactions/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GiftTransactions/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param giftCampaignCodeFilter (optional) 
     * @param outletCodeFilter (optional) 
     * @param outletNameFilter (optional) 
     * @param zaloChatIDFilter (optional) 
     * @param maxPublishDateFilter (optional) 
     * @param minPublishDateFilter (optional) 
     * @param maxRequestDateFilter (optional) 
     * @param minRequestDateFilter (optional) 
     * @param giftMasterCodeFilter (optional) 
     * @param giftCodeFilter (optional) 
     * @param statusFilter (optional) 
     * @param transactionIDFilter (optional) 
     * @return Success
     */
    getGiftTransactionsToExcel(filter: string | null | undefined, giftCampaignCodeFilter: string | null | undefined, outletCodeFilter: string | null | undefined, outletNameFilter: string | null | undefined, zaloChatIDFilter: string | null | undefined, maxPublishDateFilter: moment.Moment | null | undefined, minPublishDateFilter: moment.Moment | null | undefined, maxRequestDateFilter: moment.Moment | null | undefined, minRequestDateFilter: moment.Moment | null | undefined, giftMasterCodeFilter: string | null | undefined, giftCodeFilter: string | null | undefined, statusFilter: string | null | undefined, transactionIDFilter: string | null | undefined): Observable<GiftFileDto> {
        let url_ = this.baseUrl + "/api/services/app/GiftTransactions/GetGiftTransactionsToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (giftCampaignCodeFilter !== undefined)
            url_ += "GiftCampaignCodeFilter=" + encodeURIComponent("" + giftCampaignCodeFilter) + "&";
        if (outletCodeFilter !== undefined)
            url_ += "OutletCodeFilter=" + encodeURIComponent("" + outletCodeFilter) + "&";
        if (outletNameFilter !== undefined)
            url_ += "OutletNameFilter=" + encodeURIComponent("" + outletNameFilter) + "&";
        if (zaloChatIDFilter !== undefined)
            url_ += "ZaloChatIDFilter=" + encodeURIComponent("" + zaloChatIDFilter) + "&";
        if (maxPublishDateFilter !== undefined)
            url_ += "MaxPublishDateFilter=" + encodeURIComponent(maxPublishDateFilter ? "" + maxPublishDateFilter.toJSON() : "") + "&";
        if (minPublishDateFilter !== undefined)
            url_ += "MinPublishDateFilter=" + encodeURIComponent(minPublishDateFilter ? "" + minPublishDateFilter.toJSON() : "") + "&";
        if (maxRequestDateFilter !== undefined)
            url_ += "MaxRequestDateFilter=" + encodeURIComponent(maxRequestDateFilter ? "" + maxRequestDateFilter.toJSON() : "") + "&";
        if (minRequestDateFilter !== undefined)
            url_ += "MinRequestDateFilter=" + encodeURIComponent(minRequestDateFilter ? "" + minRequestDateFilter.toJSON() : "") + "&";
        if (giftMasterCodeFilter !== undefined)
            url_ += "GiftMasterCodeFilter=" + encodeURIComponent("" + giftMasterCodeFilter) + "&";
        if (giftCodeFilter !== undefined)
            url_ += "GiftCodeFilter=" + encodeURIComponent("" + giftCodeFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (transactionIDFilter !== undefined)
            url_ += "TransactionIDFilter=" + encodeURIComponent("" + transactionIDFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetGiftTransactionsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGiftTransactionsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<GiftFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GiftFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetGiftTransactionsToExcel(response: HttpResponseBase): Observable<GiftFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GiftFileDto.fromJS(resultData200) : new GiftFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GiftFileDto>(<any>null);
    }

    /**
     * @param chatId (optional) 
     * @return Success
     */
    getListGiftForOutLetAsync(chatId: string | null | undefined): Observable<GiftListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/GiftTransactions/GetListGiftForOutLetAsync?";
        if (chatId !== undefined)
            url_ += "chatId=" + encodeURIComponent("" + chatId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetListGiftForOutLetAsync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetListGiftForOutLetAsync(<any>response_);
                } catch (e) {
                    return <Observable<GiftListDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<GiftListDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetListGiftForOutLetAsync(response: HttpResponseBase): Observable<GiftListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(GiftListDto.fromJS(item));
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GiftListDto[]>(<any>null);
    }

    /**
     * @param voucherRefId (optional) 
     * @return Success
     */
    checkGiftGotItAsync(voucherRefId: string | null | undefined): Observable<GetResponseGotitIntegrationDtoCheck> {
        let url_ = this.baseUrl + "/api/services/app/GiftTransactions/CheckGiftGotItAsync?";
        if (voucherRefId !== undefined)
            url_ += "voucherRefId=" + encodeURIComponent("" + voucherRefId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCheckGiftGotItAsync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckGiftGotItAsync(<any>response_);
                } catch (e) {
                    return <Observable<GetResponseGotitIntegrationDtoCheck>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetResponseGotitIntegrationDtoCheck>><any>_observableThrow(response_);
        }));
    }

    protected processCheckGiftGotItAsync(response: HttpResponseBase): Observable<GetResponseGotitIntegrationDtoCheck> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetResponseGotitIntegrationDtoCheck.fromJS(resultData200) : new GetResponseGotitIntegrationDtoCheck();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetResponseGotitIntegrationDtoCheck>(<any>null);
    }
}

@Injectable()
export class HostDashboardServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param incomeStatisticsDateInterval (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return Success
     */
    getDashboardStatisticsData(incomeStatisticsDateInterval: IncomeStatisticsDateInterval | null | undefined, startDate: moment.Moment | null | undefined, endDate: moment.Moment | null | undefined): Observable<HostDashboardData> {
        let url_ = this.baseUrl + "/api/services/app/HostDashboard/GetDashboardStatisticsData?";
        if (incomeStatisticsDateInterval !== undefined)
            url_ += "IncomeStatisticsDateInterval=" + encodeURIComponent("" + incomeStatisticsDateInterval) + "&";
        if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&";
        if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetDashboardStatisticsData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDashboardStatisticsData(<any>response_);
                } catch (e) {
                    return <Observable<HostDashboardData>><any>_observableThrow(e);
                }
            } else
                return <Observable<HostDashboardData>><any>_observableThrow(response_);
        }));
    }

    protected processGetDashboardStatisticsData(response: HttpResponseBase): Observable<HostDashboardData> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? HostDashboardData.fromJS(resultData200) : new HostDashboardData();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HostDashboardData>(<any>null);
    }

    /**
     * @param incomeStatisticsDateInterval (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return Success
     */
    getIncomeStatistics(incomeStatisticsDateInterval: IncomeStatisticsDateInterval2 | null | undefined, startDate: moment.Moment | null | undefined, endDate: moment.Moment | null | undefined): Observable<GetIncomeStatisticsDataOutput> {
        let url_ = this.baseUrl + "/api/services/app/HostDashboard/GetIncomeStatistics?";
        if (incomeStatisticsDateInterval !== undefined)
            url_ += "IncomeStatisticsDateInterval=" + encodeURIComponent("" + incomeStatisticsDateInterval) + "&";
        if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&";
        if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetIncomeStatistics(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIncomeStatistics(<any>response_);
                } catch (e) {
                    return <Observable<GetIncomeStatisticsDataOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetIncomeStatisticsDataOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetIncomeStatistics(response: HttpResponseBase): Observable<GetIncomeStatisticsDataOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetIncomeStatisticsDataOutput.fromJS(resultData200) : new GetIncomeStatisticsDataOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetIncomeStatisticsDataOutput>(<any>null);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return Success
     */
    getEditionTenantStatistics(startDate: moment.Moment | null | undefined, endDate: moment.Moment | null | undefined): Observable<GetEditionTenantStatisticsOutput> {
        let url_ = this.baseUrl + "/api/services/app/HostDashboard/GetEditionTenantStatistics?";
        if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&";
        if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetEditionTenantStatistics(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEditionTenantStatistics(<any>response_);
                } catch (e) {
                    return <Observable<GetEditionTenantStatisticsOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetEditionTenantStatisticsOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetEditionTenantStatistics(response: HttpResponseBase): Observable<GetEditionTenantStatisticsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetEditionTenantStatisticsOutput.fromJS(resultData200) : new GetEditionTenantStatisticsOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetEditionTenantStatisticsOutput>(<any>null);
    }
}

@Injectable()
export class HostSettingsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param tenantFilter (optional) 
     * @param userFilter (optional) 
     * @param nameFilter (optional) 
     * @param valueFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(tenantFilter: number | null | undefined, userFilter: number | null | undefined, nameFilter: string | null | undefined, valueFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetSettingForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/HostSettings/GetAll?";
        if (tenantFilter !== undefined)
            url_ += "TenantFilter=" + encodeURIComponent("" + tenantFilter) + "&";
        if (userFilter !== undefined)
            url_ += "UserFilter=" + encodeURIComponent("" + userFilter) + "&";
        if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (valueFilter !== undefined)
            url_ += "ValueFilter=" + encodeURIComponent("" + valueFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetSettingForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetSettingForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetSettingForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetSettingForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetSettingForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetSettingForViewDto>(<any>null);
    }

    /**
     * @param dto (optional) 
     * @return Success
     */
    createNewSetting(dto: SettingDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HostSettings/CreateNewSetting";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateNewSetting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateNewSetting(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateNewSetting(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    updateExt(input: SettingDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HostSettings/UpdateExt";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateExt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateExt(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateExt(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    getAllSettings(): Observable<HostSettingsEditDto> {
        let url_ = this.baseUrl + "/api/services/app/HostSettings/GetAllSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSettings(<any>response_);
                } catch (e) {
                    return <Observable<HostSettingsEditDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<HostSettingsEditDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllSettings(response: HttpResponseBase): Observable<HostSettingsEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? HostSettingsEditDto.fromJS(resultData200) : new HostSettingsEditDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HostSettingsEditDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    updateAllSettings(input: HostSettingsEditDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HostSettings/UpdateAllSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateAllSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAllSettings(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateAllSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    sendTestEmail(input: SendTestEmailInput | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HostSettings/SendTestEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSendTestEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendTestEmail(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSendTestEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class ImageServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param type (optional) 
     * @return Success
     */
    uploadImage(type: string | null | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/api/Image/UploadImage?";
        if (type !== undefined)
            url_ += "Type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUploadImage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadImage(<any>response_);
                } catch (e) {
                    return <Observable<string[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<string[]>><any>_observableThrow(response_);
        }));
    }

    protected processUploadImage(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(item);
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string[]>(<any>null);
    }

    /**
     * @return Success
     */
    uploadFileFromService(): Observable<void> {
        let url_ = this.baseUrl + "/api/Image/UploadFileFromService";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUploadFileFromService(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadFileFromService(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUploadFileFromService(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param type (optional) 
     * @return Success
     */
    getBackgroundImage(type: string | null | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/api/Image/GetBackgroundImage?";
        if (type !== undefined)
            url_ += "Type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetBackgroundImage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBackgroundImage(<any>response_);
                } catch (e) {
                    return <Observable<string[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<string[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetBackgroundImage(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(item);
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string[]>(<any>null);
    }

    /**
     * @param file (optional) 
     * @param type (optional) 
     * @param ordinal (optional) 
     * @return Success
     */
    upload(file: any | null | undefined, type: string | null | undefined, ordinal: number | null | undefined): Observable<UploadImageOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/Image/Upload?";
        if (file !== undefined)
            url_ += "file=" + encodeURIComponent("" + file) + "&";
        if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (ordinal !== undefined)
            url_ += "ordinal=" + encodeURIComponent("" + ordinal) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpload(<any>response_);
                } catch (e) {
                    return <Observable<UploadImageOutputDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UploadImageOutputDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpload(response: HttpResponseBase): Observable<UploadImageOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? UploadImageOutputDto.fromJS(resultData200) : new UploadImageOutputDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UploadImageOutputDto>(<any>null);
    }

    /**
     * @param file (optional) 
     * @param type (optional) 
     * @param ordinal (optional) 
     * @return Success
     */
    uploadForImageEditor(file: any | null | undefined, type: string | null | undefined, ordinal: number | null | undefined): Observable<EditorImageResponse> {
        let url_ = this.baseUrl + "/api/services/app/Image/UploadForImageEditor?";
        if (file !== undefined)
            url_ += "file=" + encodeURIComponent("" + file) + "&";
        if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (ordinal !== undefined)
            url_ += "ordinal=" + encodeURIComponent("" + ordinal) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUploadForImageEditor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadForImageEditor(<any>response_);
                } catch (e) {
                    return <Observable<EditorImageResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<EditorImageResponse>><any>_observableThrow(response_);
        }));
    }

    protected processUploadForImageEditor(response: HttpResponseBase): Observable<EditorImageResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? EditorImageResponse.fromJS(resultData200) : new EditorImageResponse();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EditorImageResponse>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getImageLinkForEdit(id: number | null | undefined): Observable<GetImageForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Image/GetImageLinkForEdit?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetImageLinkForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetImageLinkForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetImageForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetImageForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetImageLinkForEdit(response: HttpResponseBase): Observable<GetImageForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetImageForEditOutput.fromJS(resultData200) : new GetImageForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetImageForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    editImageLink(input: EditImageInput | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Image/EditImageLink";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processEditImageLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditImageLink(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processEditImageLink(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class ImageLinksServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param codeFilter (optional) 
     * @param typeFilter (optional) 
     * @param linkFilter (optional) 
     * @param isActiveFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, codeFilter: string | null | undefined, typeFilter: string | null | undefined, linkFilter: string | null | undefined, isActiveFilter: number | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetImageLinkForView> {
        let url_ = this.baseUrl + "/api/services/app/ImageLinks/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&";
        if (typeFilter !== undefined)
            url_ += "TypeFilter=" + encodeURIComponent("" + typeFilter) + "&";
        if (linkFilter !== undefined)
            url_ += "LinkFilter=" + encodeURIComponent("" + linkFilter) + "&";
        if (isActiveFilter !== undefined)
            url_ += "isActiveFilter=" + encodeURIComponent("" + isActiveFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetImageLinkForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetImageLinkForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetImageLinkForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetImageLinkForView.fromJS(resultData200) : new PagedResultDtoOfGetImageLinkForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetImageLinkForView>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getImageLinkForEdit(id: number | null | undefined): Observable<GetImageLinkForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/ImageLinks/GetImageLinkForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetImageLinkForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetImageLinkForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetImageLinkForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetImageLinkForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetImageLinkForEdit(response: HttpResponseBase): Observable<GetImageLinkForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetImageLinkForEditOutput.fromJS(resultData200) : new GetImageLinkForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetImageLinkForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditImageLinkDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ImageLinks/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ImageLinks/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class ImportServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param type (optional) 
     * @return Success
     */
    checkStatusImport(type: string | null | undefined): Observable<StatusImportDistributeDto> {
        let url_ = this.baseUrl + "/api/Import/CheckStatusImport?";
        if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCheckStatusImport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckStatusImport(<any>response_);
                } catch (e) {
                    return <Observable<StatusImportDistributeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<StatusImportDistributeDto>><any>_observableThrow(response_);
        }));
    }

    protected processCheckStatusImport(response: HttpResponseBase): Observable<StatusImportDistributeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? StatusImportDistributeDto.fromJS(resultData200) : new StatusImportDistributeDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StatusImportDistributeDto>(<any>null);
    }

    /**
     * @param importType (optional) 
     * @param file (optional) 
     * @param giftInfoId (optional) 
     * @param expiredDate (optional) 
     * @param type (optional) 
     * @param reason (optional) 
     * @param approver (optional) 
     * @param codePrefix (optional) 
     * @return Success
     */
    receiveErrorFile(importType: string | null | undefined, file: any | null | undefined, giftInfoId: number | null | undefined, expiredDate: moment.Moment | null | undefined, type: string | null | undefined, reason: string | null | undefined, approver: string | null | undefined, codePrefix: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Import/ReceiveErrorFile?";
        if (file !== undefined)
            url_ += "File=" + encodeURIComponent("" + file) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (importType !== null && importType !== undefined)
            content_.append("ImportType", importType.toString());
        if (giftInfoId !== null && giftInfoId !== undefined)
            content_.append("GiftInfoId", giftInfoId.toString());
        if (expiredDate !== null && expiredDate !== undefined)
            content_.append("ExpiredDate", expiredDate.toString());
        if (type !== null && type !== undefined)
            content_.append("Type", type.toString());
        if (reason !== null && reason !== undefined)
            content_.append("Reason", reason.toString());
        if (approver !== null && approver !== undefined)
            content_.append("Approver", approver.toString());
        if (codePrefix !== null && codePrefix !== undefined)
            content_.append("CodePrefix", codePrefix.toString());

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processReceiveErrorFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReceiveErrorFile(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processReceiveErrorFile(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param importType (optional) 
     * @param file (optional) 
     * @param giftInfoId (optional) 
     * @param expiredDate (optional) 
     * @param type (optional) 
     * @param reason (optional) 
     * @param approver (optional) 
     * @param codePrefix (optional) 
     * @return Success
     */
    upload(importType: string | null | undefined, file: any | null | undefined, giftInfoId: number | null | undefined, expiredDate: moment.Moment | null | undefined, type: string | null | undefined, reason: string | null | undefined, approver: string | null | undefined, codePrefix: string | null | undefined): Observable<ImportOutputDto> {
        let url_ = this.baseUrl + "/api/Import/Upload?";
        if (file !== undefined)
            url_ += "File=" + encodeURIComponent("" + file) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (importType !== null && importType !== undefined)
            content_.append("ImportType", importType.toString());
        if (giftInfoId !== null && giftInfoId !== undefined)
            content_.append("GiftInfoId", giftInfoId.toString());
        if (expiredDate !== null && expiredDate !== undefined)
            content_.append("ExpiredDate", expiredDate.toString());
        if (type !== null && type !== undefined)
            content_.append("Type", type.toString());
        if (reason !== null && reason !== undefined)
            content_.append("Reason", reason.toString());
        if (approver !== null && approver !== undefined)
            content_.append("Approver", approver.toString());
        if (codePrefix !== null && codePrefix !== undefined)
            content_.append("CodePrefix", codePrefix.toString());

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpload(<any>response_);
                } catch (e) {
                    return <Observable<ImportOutputDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ImportOutputDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpload(response: HttpResponseBase): Observable<ImportOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? ImportOutputDto.fromJS(resultData200) : new ImportOutputDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ImportOutputDto>(<any>null);
    }

    /**
     * @param days (optional) 
     * @return Success
     */
    deleteTemplateExcel(days: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Import/DeleteTemplateExcel?";
        if (days !== undefined)
            url_ += "days=" + encodeURIComponent("" + days) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteTemplateExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteTemplateExcel(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteTemplateExcel(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param importType (optional) 
     * @param fileName (optional) 
     * @param filePath (optional) 
     * @param properties (optional) 
     * @return Success
     */
    enqueue(importType: string | null | undefined, fileName: string | null | undefined, filePath: string | null | undefined, properties: any[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Import/Enqueue?";
        if (importType !== undefined)
            url_ += "ImportType=" + encodeURIComponent("" + importType) + "&";
        if (fileName !== undefined)
            url_ += "FileName=" + encodeURIComponent("" + fileName) + "&";
        if (filePath !== undefined)
            url_ += "FilePath=" + encodeURIComponent("" + filePath) + "&";
        if (properties !== undefined)
            properties && properties.forEach((item, index) => {
                for (let attr in item)
                    url_ += "Properties[" + index + "]." + attr + "=" + encodeURIComponent("" + item[attr]) + "&";
            });
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processEnqueue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEnqueue(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processEnqueue(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param importType (optional) 
     * @param file (optional) 
     * @param giftInfoId (optional) 
     * @param expiredDate (optional) 
     * @param type (optional) 
     * @param reason (optional) 
     * @param approver (optional) 
     * @param codePrefix (optional) 
     * @return Success
     */
    uploadFileAdjust(importType: string | null | undefined, file: any | null | undefined, giftInfoId: number | null | undefined, expiredDate: moment.Moment | null | undefined, type: string | null | undefined, reason: string | null | undefined, approver: string | null | undefined, codePrefix: string | null | undefined): Observable<ImportOutputDto> {
        let url_ = this.baseUrl + "/api/Import/UploadFileAdjust?";
        if (file !== undefined)
            url_ += "File=" + encodeURIComponent("" + file) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (importType !== null && importType !== undefined)
            content_.append("ImportType", importType.toString());
        if (giftInfoId !== null && giftInfoId !== undefined)
            content_.append("GiftInfoId", giftInfoId.toString());
        if (expiredDate !== null && expiredDate !== undefined)
            content_.append("ExpiredDate", expiredDate.toString());
        if (type !== null && type !== undefined)
            content_.append("Type", type.toString());
        if (reason !== null && reason !== undefined)
            content_.append("Reason", reason.toString());
        if (approver !== null && approver !== undefined)
            content_.append("Approver", approver.toString());
        if (codePrefix !== null && codePrefix !== undefined)
            content_.append("CodePrefix", codePrefix.toString());

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUploadFileAdjust(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadFileAdjust(<any>response_);
                } catch (e) {
                    return <Observable<ImportOutputDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ImportOutputDto>><any>_observableThrow(response_);
        }));
    }

    protected processUploadFileAdjust(response: HttpResponseBase): Observable<ImportOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? ImportOutputDto.fromJS(resultData200) : new ImportOutputDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ImportOutputDto>(<any>null);
    }
}

@Injectable()
export class InstallServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    setup(input: InstallDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Install/Setup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSetup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetup(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSetup(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    getAppSettingsJson(): Observable<AppSettingsJsonDto> {
        let url_ = this.baseUrl + "/api/services/app/Install/GetAppSettingsJson";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAppSettingsJson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAppSettingsJson(<any>response_);
                } catch (e) {
                    return <Observable<AppSettingsJsonDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<AppSettingsJsonDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAppSettingsJson(response: HttpResponseBase): Observable<AppSettingsJsonDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? AppSettingsJsonDto.fromJS(resultData200) : new AppSettingsJsonDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AppSettingsJsonDto>(<any>null);
    }

    /**
     * @return Success
     */
    checkDatabase(): Observable<CheckDatabaseOutput> {
        let url_ = this.baseUrl + "/api/services/app/Install/CheckDatabase";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCheckDatabase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckDatabase(<any>response_);
                } catch (e) {
                    return <Observable<CheckDatabaseOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<CheckDatabaseOutput>><any>_observableThrow(response_);
        }));
    }

    protected processCheckDatabase(response: HttpResponseBase): Observable<CheckDatabaseOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? CheckDatabaseOutput.fromJS(resultData200) : new CheckDatabaseOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CheckDatabaseOutput>(<any>null);
    }
}

@Injectable()
export class InteractiveTimeRangesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param maxYearFilter (optional) 
     * @param minYearFilter (optional) 
     * @param timeRangeFilter (optional) 
     * @param maxTotalCountInteractionFilter (optional) 
     * @param minTotalCountInteractionFilter (optional) 
     * @param maxMonthFilter (optional) 
     * @param minMonthFilter (optional) 
     * @param maxCalculateDateFilter (optional) 
     * @param minCalculateDateFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, maxYearFilter: number | null | undefined, minYearFilter: number | null | undefined, timeRangeFilter: string | null | undefined, maxTotalCountInteractionFilter: number | null | undefined, minTotalCountInteractionFilter: number | null | undefined, maxMonthFilter: number | null | undefined, minMonthFilter: number | null | undefined, maxCalculateDateFilter: moment.Moment | null | undefined, minCalculateDateFilter: moment.Moment | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetInteractiveTimeRangeForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/InteractiveTimeRanges/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxYearFilter !== undefined)
            url_ += "MaxYearFilter=" + encodeURIComponent("" + maxYearFilter) + "&";
        if (minYearFilter !== undefined)
            url_ += "MinYearFilter=" + encodeURIComponent("" + minYearFilter) + "&";
        if (timeRangeFilter !== undefined)
            url_ += "TimeRangeFilter=" + encodeURIComponent("" + timeRangeFilter) + "&";
        if (maxTotalCountInteractionFilter !== undefined)
            url_ += "MaxTotalCountInteractionFilter=" + encodeURIComponent("" + maxTotalCountInteractionFilter) + "&";
        if (minTotalCountInteractionFilter !== undefined)
            url_ += "MinTotalCountInteractionFilter=" + encodeURIComponent("" + minTotalCountInteractionFilter) + "&";
        if (maxMonthFilter !== undefined)
            url_ += "MaxMonthFilter=" + encodeURIComponent("" + maxMonthFilter) + "&";
        if (minMonthFilter !== undefined)
            url_ += "MinMonthFilter=" + encodeURIComponent("" + minMonthFilter) + "&";
        if (maxCalculateDateFilter !== undefined)
            url_ += "MaxCalculateDateFilter=" + encodeURIComponent(maxCalculateDateFilter ? "" + maxCalculateDateFilter.toJSON() : "") + "&";
        if (minCalculateDateFilter !== undefined)
            url_ += "MinCalculateDateFilter=" + encodeURIComponent(minCalculateDateFilter ? "" + minCalculateDateFilter.toJSON() : "") + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetInteractiveTimeRangeForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetInteractiveTimeRangeForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetInteractiveTimeRangeForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetInteractiveTimeRangeForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetInteractiveTimeRangeForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetInteractiveTimeRangeForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getInteractiveTimeRangeForEdit(id: number | null | undefined): Observable<GetInteractiveTimeRangeForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/InteractiveTimeRanges/GetInteractiveTimeRangeForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetInteractiveTimeRangeForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInteractiveTimeRangeForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetInteractiveTimeRangeForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetInteractiveTimeRangeForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetInteractiveTimeRangeForEdit(response: HttpResponseBase): Observable<GetInteractiveTimeRangeForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetInteractiveTimeRangeForEditOutput.fromJS(resultData200) : new GetInteractiveTimeRangeForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetInteractiveTimeRangeForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditInteractiveTimeRangeDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/InteractiveTimeRanges/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/InteractiveTimeRanges/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param maxYearFilter (optional) 
     * @param minYearFilter (optional) 
     * @param timeRangeFilter (optional) 
     * @param maxTotalCountInteractionFilter (optional) 
     * @param minTotalCountInteractionFilter (optional) 
     * @param maxMonthFilter (optional) 
     * @param minMonthFilter (optional) 
     * @param maxCalculateDateFilter (optional) 
     * @param minCalculateDateFilter (optional) 
     * @return Success
     */
    getInteractiveTimeRangesToExcel(filter: string | null | undefined, maxYearFilter: number | null | undefined, minYearFilter: number | null | undefined, timeRangeFilter: string | null | undefined, maxTotalCountInteractionFilter: number | null | undefined, minTotalCountInteractionFilter: number | null | undefined, maxMonthFilter: number | null | undefined, minMonthFilter: number | null | undefined, maxCalculateDateFilter: moment.Moment | null | undefined, minCalculateDateFilter: moment.Moment | null | undefined): Observable<PointFileDto> {
        let url_ = this.baseUrl + "/api/services/app/InteractiveTimeRanges/GetInteractiveTimeRangesToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxYearFilter !== undefined)
            url_ += "MaxYearFilter=" + encodeURIComponent("" + maxYearFilter) + "&";
        if (minYearFilter !== undefined)
            url_ += "MinYearFilter=" + encodeURIComponent("" + minYearFilter) + "&";
        if (timeRangeFilter !== undefined)
            url_ += "TimeRangeFilter=" + encodeURIComponent("" + timeRangeFilter) + "&";
        if (maxTotalCountInteractionFilter !== undefined)
            url_ += "MaxTotalCountInteractionFilter=" + encodeURIComponent("" + maxTotalCountInteractionFilter) + "&";
        if (minTotalCountInteractionFilter !== undefined)
            url_ += "MinTotalCountInteractionFilter=" + encodeURIComponent("" + minTotalCountInteractionFilter) + "&";
        if (maxMonthFilter !== undefined)
            url_ += "MaxMonthFilter=" + encodeURIComponent("" + maxMonthFilter) + "&";
        if (minMonthFilter !== undefined)
            url_ += "MinMonthFilter=" + encodeURIComponent("" + minMonthFilter) + "&";
        if (maxCalculateDateFilter !== undefined)
            url_ += "MaxCalculateDateFilter=" + encodeURIComponent(maxCalculateDateFilter ? "" + maxCalculateDateFilter.toJSON() : "") + "&";
        if (minCalculateDateFilter !== undefined)
            url_ += "MinCalculateDateFilter=" + encodeURIComponent(minCalculateDateFilter ? "" + minCalculateDateFilter.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetInteractiveTimeRangesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInteractiveTimeRangesToExcel(<any>response_);
                } catch (e) {
                    return <Observable<PointFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PointFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetInteractiveTimeRangesToExcel(response: HttpResponseBase): Observable<PointFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PointFileDto.fromJS(resultData200) : new PointFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PointFileDto>(<any>null);
    }
}

@Injectable()
export class InvoiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getInvoiceInfo(id: number | null | undefined): Observable<InvoiceDto> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/GetInvoiceInfo?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetInvoiceInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInvoiceInfo(<any>response_);
                } catch (e) {
                    return <Observable<InvoiceDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<InvoiceDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetInvoiceInfo(response: HttpResponseBase): Observable<InvoiceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? InvoiceDto.fromJS(resultData200) : new InvoiceDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InvoiceDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createInvoice(input: CreateInvoiceDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/CreateInvoice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateInvoice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateInvoice(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateInvoice(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class KindsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param codeFilter (optional) 
     * @param nameFilter (optional) 
     * @param maxLevelFilter (optional) 
     * @param minLevelFilter (optional) 
     * @param parentCodeFilter (optional) 
     * @param isActiveFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, codeFilter: string | null | undefined, nameFilter: string | null | undefined, maxLevelFilter: number | null | undefined, minLevelFilter: number | null | undefined, parentCodeFilter: string | null | undefined, isActiveFilter: number | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetKindForView> {
        let url_ = this.baseUrl + "/api/services/app/Kinds/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&";
        if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (maxLevelFilter !== undefined)
            url_ += "MaxLevelFilter=" + encodeURIComponent("" + maxLevelFilter) + "&";
        if (minLevelFilter !== undefined)
            url_ += "MinLevelFilter=" + encodeURIComponent("" + minLevelFilter) + "&";
        if (parentCodeFilter !== undefined)
            url_ += "ParentCodeFilter=" + encodeURIComponent("" + parentCodeFilter) + "&";
        if (isActiveFilter !== undefined)
            url_ += "IsActiveFilter=" + encodeURIComponent("" + isActiveFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetKindForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetKindForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetKindForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetKindForView.fromJS(resultData200) : new PagedResultDtoOfGetKindForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetKindForView>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getKindForEdit(id: number | null | undefined): Observable<GetKindForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Kinds/GetKindForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetKindForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetKindForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetKindForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetKindForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetKindForEdit(response: HttpResponseBase): Observable<GetKindForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetKindForEditOutput.fromJS(resultData200) : new GetKindForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetKindForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditKindDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Kinds/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Kinds/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param codeFilter (optional) 
     * @param nameFilter (optional) 
     * @param maxLevelFilter (optional) 
     * @param minLevelFilter (optional) 
     * @param parentCodeFilter (optional) 
     * @param isActiveFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllExt(filter: string | null | undefined, codeFilter: string | null | undefined, nameFilter: string | null | undefined, maxLevelFilter: number | null | undefined, minLevelFilter: number | null | undefined, parentCodeFilter: string | null | undefined, isActiveFilter: number | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetKindForView> {
        let url_ = this.baseUrl + "/api/services/app/Kinds/GetAllExt?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&";
        if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (maxLevelFilter !== undefined)
            url_ += "MaxLevelFilter=" + encodeURIComponent("" + maxLevelFilter) + "&";
        if (minLevelFilter !== undefined)
            url_ += "MinLevelFilter=" + encodeURIComponent("" + minLevelFilter) + "&";
        if (parentCodeFilter !== undefined)
            url_ += "ParentCodeFilter=" + encodeURIComponent("" + parentCodeFilter) + "&";
        if (isActiveFilter !== undefined)
            url_ += "IsActiveFilter=" + encodeURIComponent("" + isActiveFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllExt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllExt(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetKindForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetKindForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllExt(response: HttpResponseBase): Observable<PagedResultDtoOfGetKindForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetKindForView.fromJS(resultData200) : new PagedResultDtoOfGetKindForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetKindForView>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEditExt(input: CreateOrEditKindDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Kinds/CreateOrEditExt";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEditExt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditExt(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEditExt(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteExt(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Kinds/DeleteExt?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteExt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteExt(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteExt(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class LanguageServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getLanguages(): Observable<GetLanguagesOutput> {
        let url_ = this.baseUrl + "/api/services/app/Language/GetLanguages";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetLanguages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLanguages(<any>response_);
                } catch (e) {
                    return <Observable<GetLanguagesOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetLanguagesOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetLanguages(response: HttpResponseBase): Observable<GetLanguagesOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetLanguagesOutput.fromJS(resultData200) : new GetLanguagesOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLanguagesOutput>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getLanguageForEdit(id: number | null | undefined): Observable<GetLanguageForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Language/GetLanguageForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetLanguageForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLanguageForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetLanguageForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetLanguageForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetLanguageForEdit(response: HttpResponseBase): Observable<GetLanguageForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetLanguageForEditOutput.fromJS(resultData200) : new GetLanguageForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLanguageForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrUpdateLanguage(input: CreateOrUpdateLanguageInput | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Language/CreateOrUpdateLanguage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrUpdateLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateLanguage(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrUpdateLanguage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteLanguage(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Language/DeleteLanguage?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteLanguage(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteLanguage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    setDefaultLanguage(input: SetDefaultLanguageInput | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Language/SetDefaultLanguage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSetDefaultLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetDefaultLanguage(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSetDefaultLanguage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param sorting (optional) 
     * @param baseLanguageName (optional) 
     * @param targetValueFilter (optional) 
     * @param filterText (optional) 
     * @return Success
     */
    getLanguageTexts(maxResultCount: number | null | undefined, skipCount: number | null | undefined, sorting: string | null | undefined, sourceName: string, baseLanguageName: string | null | undefined, targetLanguageName: string, targetValueFilter: string | null | undefined, filterText: string | null | undefined): Observable<PagedResultDtoOfLanguageTextListDto> {
        let url_ = this.baseUrl + "/api/services/app/Language/GetLanguageTexts?";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (sourceName === undefined || sourceName === null)
            throw new Error("The parameter 'sourceName' must be defined and cannot be null.");
        else
            url_ += "SourceName=" + encodeURIComponent("" + sourceName) + "&";
        if (baseLanguageName !== undefined)
            url_ += "BaseLanguageName=" + encodeURIComponent("" + baseLanguageName) + "&";
        if (targetLanguageName === undefined || targetLanguageName === null)
            throw new Error("The parameter 'targetLanguageName' must be defined and cannot be null.");
        else
            url_ += "TargetLanguageName=" + encodeURIComponent("" + targetLanguageName) + "&";
        if (targetValueFilter !== undefined)
            url_ += "TargetValueFilter=" + encodeURIComponent("" + targetValueFilter) + "&";
        if (filterText !== undefined)
            url_ += "FilterText=" + encodeURIComponent("" + filterText) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetLanguageTexts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLanguageTexts(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfLanguageTextListDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfLanguageTextListDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetLanguageTexts(response: HttpResponseBase): Observable<PagedResultDtoOfLanguageTextListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfLanguageTextListDto.fromJS(resultData200) : new PagedResultDtoOfLanguageTextListDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfLanguageTextListDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    updateLanguageText(input: UpdateLanguageTextInput | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Language/UpdateLanguageText";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateLanguageText(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateLanguageText(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateLanguageText(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class LogsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param triggerByFilter (optional) 
     * @param senderFilter (optional) 
     * @param receiverFilter (optional) 
     * @param channelCodeFilter (optional) 
     * @param referenceCodeFilter (optional) 
     * @param typeFilter (optional) 
     * @param contentFilter (optional) 
     * @param titleFilter (optional) 
     * @param actionsFilter (optional) 
     * @param itemsFilter (optional) 
     * @param statusFilter (optional) 
     * @param messageFilter (optional) 
     * @param triggerNameFilter (optional) 
     * @param channelMemberIDFilter (optional) 
     * @param channelTransactionIDFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, triggerByFilter: string | null | undefined, senderFilter: string | null | undefined, receiverFilter: string | null | undefined, channelCodeFilter: string | null | undefined, referenceCodeFilter: string | null | undefined, typeFilter: string | null | undefined, contentFilter: string | null | undefined, titleFilter: string | null | undefined, actionsFilter: string | null | undefined, itemsFilter: string | null | undefined, statusFilter: string | null | undefined, messageFilter: string | null | undefined, triggerNameFilter: string | null | undefined, channelMemberIDFilter: string | null | undefined, channelTransactionIDFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetLogForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Logs/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (triggerByFilter !== undefined)
            url_ += "TriggerByFilter=" + encodeURIComponent("" + triggerByFilter) + "&";
        if (senderFilter !== undefined)
            url_ += "SenderFilter=" + encodeURIComponent("" + senderFilter) + "&";
        if (receiverFilter !== undefined)
            url_ += "ReceiverFilter=" + encodeURIComponent("" + receiverFilter) + "&";
        if (channelCodeFilter !== undefined)
            url_ += "ChannelCodeFilter=" + encodeURIComponent("" + channelCodeFilter) + "&";
        if (referenceCodeFilter !== undefined)
            url_ += "ReferenceCodeFilter=" + encodeURIComponent("" + referenceCodeFilter) + "&";
        if (typeFilter !== undefined)
            url_ += "TypeFilter=" + encodeURIComponent("" + typeFilter) + "&";
        if (contentFilter !== undefined)
            url_ += "ContentFilter=" + encodeURIComponent("" + contentFilter) + "&";
        if (titleFilter !== undefined)
            url_ += "TitleFilter=" + encodeURIComponent("" + titleFilter) + "&";
        if (actionsFilter !== undefined)
            url_ += "ActionsFilter=" + encodeURIComponent("" + actionsFilter) + "&";
        if (itemsFilter !== undefined)
            url_ += "ItemsFilter=" + encodeURIComponent("" + itemsFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (messageFilter !== undefined)
            url_ += "MessageFilter=" + encodeURIComponent("" + messageFilter) + "&";
        if (triggerNameFilter !== undefined)
            url_ += "TriggerNameFilter=" + encodeURIComponent("" + triggerNameFilter) + "&";
        if (channelMemberIDFilter !== undefined)
            url_ += "ChannelMemberIDFilter=" + encodeURIComponent("" + channelMemberIDFilter) + "&";
        if (channelTransactionIDFilter !== undefined)
            url_ += "ChannelTransactionIDFilter=" + encodeURIComponent("" + channelTransactionIDFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetLogForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetLogForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetLogForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetLogForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetLogForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetLogForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getLogForEdit(id: number | null | undefined): Observable<GetLogForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Logs/GetLogForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetLogForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLogForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetLogForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetLogForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetLogForEdit(response: HttpResponseBase): Observable<GetLogForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetLogForEditOutput.fromJS(resultData200) : new GetLogForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLogForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditLogDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Logs/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Logs/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param triggerByFilter (optional) 
     * @param senderFilter (optional) 
     * @param receiverFilter (optional) 
     * @param channelCodeFilter (optional) 
     * @param referenceCodeFilter (optional) 
     * @param typeFilter (optional) 
     * @param contentFilter (optional) 
     * @param titleFilter (optional) 
     * @param actionsFilter (optional) 
     * @param itemsFilter (optional) 
     * @param statusFilter (optional) 
     * @param messageFilter (optional) 
     * @param triggerNameFilter (optional) 
     * @param channelMemberIDFilter (optional) 
     * @param channelTransactionIDFilter (optional) 
     * @return Success
     */
    getLogsToExcel(filter: string | null | undefined, triggerByFilter: string | null | undefined, senderFilter: string | null | undefined, receiverFilter: string | null | undefined, channelCodeFilter: string | null | undefined, referenceCodeFilter: string | null | undefined, typeFilter: string | null | undefined, contentFilter: string | null | undefined, titleFilter: string | null | undefined, actionsFilter: string | null | undefined, itemsFilter: string | null | undefined, statusFilter: string | null | undefined, messageFilter: string | null | undefined, triggerNameFilter: string | null | undefined, channelMemberIDFilter: string | null | undefined, channelTransactionIDFilter: string | null | undefined): Observable<NotificationFileDto> {
        let url_ = this.baseUrl + "/api/services/app/Logs/GetLogsToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (triggerByFilter !== undefined)
            url_ += "TriggerByFilter=" + encodeURIComponent("" + triggerByFilter) + "&";
        if (senderFilter !== undefined)
            url_ += "SenderFilter=" + encodeURIComponent("" + senderFilter) + "&";
        if (receiverFilter !== undefined)
            url_ += "ReceiverFilter=" + encodeURIComponent("" + receiverFilter) + "&";
        if (channelCodeFilter !== undefined)
            url_ += "ChannelCodeFilter=" + encodeURIComponent("" + channelCodeFilter) + "&";
        if (referenceCodeFilter !== undefined)
            url_ += "ReferenceCodeFilter=" + encodeURIComponent("" + referenceCodeFilter) + "&";
        if (typeFilter !== undefined)
            url_ += "TypeFilter=" + encodeURIComponent("" + typeFilter) + "&";
        if (contentFilter !== undefined)
            url_ += "ContentFilter=" + encodeURIComponent("" + contentFilter) + "&";
        if (titleFilter !== undefined)
            url_ += "TitleFilter=" + encodeURIComponent("" + titleFilter) + "&";
        if (actionsFilter !== undefined)
            url_ += "ActionsFilter=" + encodeURIComponent("" + actionsFilter) + "&";
        if (itemsFilter !== undefined)
            url_ += "ItemsFilter=" + encodeURIComponent("" + itemsFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (messageFilter !== undefined)
            url_ += "MessageFilter=" + encodeURIComponent("" + messageFilter) + "&";
        if (triggerNameFilter !== undefined)
            url_ += "TriggerNameFilter=" + encodeURIComponent("" + triggerNameFilter) + "&";
        if (channelMemberIDFilter !== undefined)
            url_ += "ChannelMemberIDFilter=" + encodeURIComponent("" + channelMemberIDFilter) + "&";
        if (channelTransactionIDFilter !== undefined)
            url_ += "ChannelTransactionIDFilter=" + encodeURIComponent("" + channelTransactionIDFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetLogsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLogsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<NotificationFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<NotificationFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetLogsToExcel(response: HttpResponseBase): Observable<NotificationFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? NotificationFileDto.fromJS(resultData200) : new NotificationFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NotificationFileDto>(<any>null);
    }
}

@Injectable()
export class LogsExcelExporterServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param logs (optional) 
     * @return Success
     */
    exportToFile(logs: GetLogForViewDto[] | null | undefined): Observable<NotificationFileDto> {
        let url_ = this.baseUrl + "/api/services/app/LogsExcelExporter/ExportToFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(logs);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processExportToFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportToFile(<any>response_);
                } catch (e) {
                    return <Observable<NotificationFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<NotificationFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processExportToFile(response: HttpResponseBase): Observable<NotificationFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? NotificationFileDto.fromJS(resultData200) : new NotificationFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NotificationFileDto>(<any>null);
    }
}

@Injectable()
export class LoyaltySummaryReportServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getData(): Observable<LoyaltySummaryDto> {
        let url_ = this.baseUrl + "/api/services/app/LoyaltySummaryReport/GetData";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetData(<any>response_);
                } catch (e) {
                    return <Observable<LoyaltySummaryDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<LoyaltySummaryDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetData(response: HttpResponseBase): Observable<LoyaltySummaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? LoyaltySummaryDto.fromJS(resultData200) : new LoyaltySummaryDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LoyaltySummaryDto>(<any>null);
    }

    /**
     * @param currentDate (optional) 
     * @return Success
     */
    dayLeft(currentDate: moment.Moment | null | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/LoyaltySummaryReport/DayLeft?";
        if (currentDate !== undefined)
            url_ += "currentDate=" + encodeURIComponent(currentDate ? "" + currentDate.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDayLeft(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDayLeft(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processDayLeft(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }
}

@Injectable()
export class MasterDataServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    checkAPiKey(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/MasterData/CheckAPiKey";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCheckAPiKey(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckAPiKey(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processCheckAPiKey(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    serialData(input: CreateSerialRequestDto | null | undefined): Observable<CreateSerialResponseDto> {
        let url_ = this.baseUrl + "/api/services/app/MasterData/SerialData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSerialData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSerialData(<any>response_);
                } catch (e) {
                    return <Observable<CreateSerialResponseDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CreateSerialResponseDto>><any>_observableThrow(response_);
        }));
    }

    protected processSerialData(response: HttpResponseBase): Observable<CreateSerialResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? CreateSerialResponseDto.fromJS(resultData200) : new CreateSerialResponseDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateSerialResponseDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    receiveSerial(input: MasterDataGlcRequestReceiveDto | null | undefined): Observable<MasterDataGlcResponseDto> {
        let url_ = this.baseUrl + "/api/services/app/MasterData/ReceiveSerial";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processReceiveSerial(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReceiveSerial(<any>response_);
                } catch (e) {
                    return <Observable<MasterDataGlcResponseDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<MasterDataGlcResponseDto>><any>_observableThrow(response_);
        }));
    }

    protected processReceiveSerial(response: HttpResponseBase): Observable<MasterDataGlcResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? MasterDataGlcResponseDto.fromJS(resultData200) : new MasterDataGlcResponseDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MasterDataGlcResponseDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    exportSerial(input: MasterDataGlcRequestExportDto | null | undefined): Observable<GLCResponseCheckSerial> {
        let url_ = this.baseUrl + "/api/services/app/MasterData/ExportSerial";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processExportSerial(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportSerial(<any>response_);
                } catch (e) {
                    return <Observable<GLCResponseCheckSerial>><any>_observableThrow(e);
                }
            } else
                return <Observable<GLCResponseCheckSerial>><any>_observableThrow(response_);
        }));
    }

    protected processExportSerial(response: HttpResponseBase): Observable<GLCResponseCheckSerial> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GLCResponseCheckSerial.fromJS(resultData200) : new GLCResponseCheckSerial();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GLCResponseCheckSerial>(<any>null);
    }

    /**
     * @param serial (optional) 
     * @param yourReference (optional) 
     * @param doNumber (optional) 
     * @param materialNumber (optional) 
     * @param vehicleNumber (optional) 
     * @param plant (optional) 
     * @param inboundType (optional) 
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getWarehouseSerialReceived(serial: string | null | undefined, yourReference: string | null | undefined, doNumber: string | null | undefined, materialNumber: string | null | undefined, vehicleNumber: string | null | undefined, plant: string | null | undefined, inboundType: string | null | undefined, fromDate: moment.Moment | null | undefined, toDate: moment.Moment | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfWarehouseSerialResponse> {
        let url_ = this.baseUrl + "/api/services/app/MasterData/GetWarehouseSerialReceived?";
        if (serial !== undefined)
            url_ += "Serial=" + encodeURIComponent("" + serial) + "&";
        if (yourReference !== undefined)
            url_ += "YourReference=" + encodeURIComponent("" + yourReference) + "&";
        if (doNumber !== undefined)
            url_ += "DoNumber=" + encodeURIComponent("" + doNumber) + "&";
        if (materialNumber !== undefined)
            url_ += "MaterialNumber=" + encodeURIComponent("" + materialNumber) + "&";
        if (vehicleNumber !== undefined)
            url_ += "VehicleNumber=" + encodeURIComponent("" + vehicleNumber) + "&";
        if (plant !== undefined)
            url_ += "Plant=" + encodeURIComponent("" + plant) + "&";
        if (inboundType !== undefined)
            url_ += "InboundType=" + encodeURIComponent("" + inboundType) + "&";
        if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toJSON() : "") + "&";
        if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toJSON() : "") + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetWarehouseSerialReceived(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWarehouseSerialReceived(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfWarehouseSerialResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfWarehouseSerialResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetWarehouseSerialReceived(response: HttpResponseBase): Observable<PagedResultDtoOfWarehouseSerialResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfWarehouseSerialResponse.fromJS(resultData200) : new PagedResultDtoOfWarehouseSerialResponse();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfWarehouseSerialResponse>(<any>null);
    }

    /**
     * @param serial (optional) 
     * @param yourReference (optional) 
     * @param doNumber (optional) 
     * @param materialNumber (optional) 
     * @param vehicleNumber (optional) 
     * @param plant (optional) 
     * @param inboundType (optional) 
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    exportWarehouseSerialReceived(serial: string | null | undefined, yourReference: string | null | undefined, doNumber: string | null | undefined, materialNumber: string | null | undefined, vehicleNumber: string | null | undefined, plant: string | null | undefined, inboundType: string | null | undefined, fromDate: moment.Moment | null | undefined, toDate: moment.Moment | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MasterData/ExportWarehouseSerialReceived?";
        if (serial !== undefined)
            url_ += "Serial=" + encodeURIComponent("" + serial) + "&";
        if (yourReference !== undefined)
            url_ += "YourReference=" + encodeURIComponent("" + yourReference) + "&";
        if (doNumber !== undefined)
            url_ += "DoNumber=" + encodeURIComponent("" + doNumber) + "&";
        if (materialNumber !== undefined)
            url_ += "MaterialNumber=" + encodeURIComponent("" + materialNumber) + "&";
        if (vehicleNumber !== undefined)
            url_ += "VehicleNumber=" + encodeURIComponent("" + vehicleNumber) + "&";
        if (plant !== undefined)
            url_ += "Plant=" + encodeURIComponent("" + plant) + "&";
        if (inboundType !== undefined)
            url_ += "InboundType=" + encodeURIComponent("" + inboundType) + "&";
        if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toJSON() : "") + "&";
        if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toJSON() : "") + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processExportWarehouseSerialReceived(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportWarehouseSerialReceived(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processExportWarehouseSerialReceived(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class MasterDetailsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param masterCodeFilter (optional) 
     * @param detailCodeFilter (optional) 
     * @param parentCodeFilter (optional) 
     * @param nodePathFilter (optional) 
     * @param maxOrdinalFilter (optional) 
     * @param minOrdinalFilter (optional) 
     * @param statusFilter (optional) 
     * @param maxDetailValueNumberFilter (optional) 
     * @param minDetailValueNumberFilter (optional) 
     * @param maxLevelFilter (optional) 
     * @param minLevelFilter (optional) 
     * @param detailValueFilter (optional) 
     * @param detailValueUnSignFilter (optional) 
     * @param metaDataType (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, masterCodeFilter: string | null | undefined, detailCodeFilter: string | null | undefined, parentCodeFilter: string | null | undefined, nodePathFilter: string | null | undefined, maxOrdinalFilter: number | null | undefined, minOrdinalFilter: number | null | undefined, statusFilter: string | null | undefined, maxDetailValueNumberFilter: number | null | undefined, minDetailValueNumberFilter: number | null | undefined, maxLevelFilter: number | null | undefined, minLevelFilter: number | null | undefined, detailValueFilter: string | null | undefined, detailValueUnSignFilter: string | null | undefined, metaDataType: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetMasterDetailForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/MasterDetails/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (masterCodeFilter !== undefined)
            url_ += "MasterCodeFilter=" + encodeURIComponent("" + masterCodeFilter) + "&";
        if (detailCodeFilter !== undefined)
            url_ += "DetailCodeFilter=" + encodeURIComponent("" + detailCodeFilter) + "&";
        if (parentCodeFilter !== undefined)
            url_ += "ParentCodeFilter=" + encodeURIComponent("" + parentCodeFilter) + "&";
        if (nodePathFilter !== undefined)
            url_ += "NodePathFilter=" + encodeURIComponent("" + nodePathFilter) + "&";
        if (maxOrdinalFilter !== undefined)
            url_ += "MaxOrdinalFilter=" + encodeURIComponent("" + maxOrdinalFilter) + "&";
        if (minOrdinalFilter !== undefined)
            url_ += "MinOrdinalFilter=" + encodeURIComponent("" + minOrdinalFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (maxDetailValueNumberFilter !== undefined)
            url_ += "MaxDetailValueNumberFilter=" + encodeURIComponent("" + maxDetailValueNumberFilter) + "&";
        if (minDetailValueNumberFilter !== undefined)
            url_ += "MinDetailValueNumberFilter=" + encodeURIComponent("" + minDetailValueNumberFilter) + "&";
        if (maxLevelFilter !== undefined)
            url_ += "MaxLevelFilter=" + encodeURIComponent("" + maxLevelFilter) + "&";
        if (minLevelFilter !== undefined)
            url_ += "MinLevelFilter=" + encodeURIComponent("" + minLevelFilter) + "&";
        if (detailValueFilter !== undefined)
            url_ += "DetailValueFilter=" + encodeURIComponent("" + detailValueFilter) + "&";
        if (detailValueUnSignFilter !== undefined)
            url_ += "DetailValueUnSignFilter=" + encodeURIComponent("" + detailValueUnSignFilter) + "&";
        if (metaDataType !== undefined)
            url_ += "MetaDataType=" + encodeURIComponent("" + metaDataType) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetMasterDetailForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetMasterDetailForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetMasterDetailForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetMasterDetailForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetMasterDetailForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetMasterDetailForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getMasterDetailForEdit(id: number | null | undefined): Observable<GetMasterDetailForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/MasterDetails/GetMasterDetailForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetMasterDetailForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMasterDetailForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetMasterDetailForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetMasterDetailForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetMasterDetailForEdit(response: HttpResponseBase): Observable<GetMasterDetailForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetMasterDetailForEditOutput.fromJS(resultData200) : new GetMasterDetailForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetMasterDetailForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditMasterDetailDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MasterDetails/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MasterDetails/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param masterCodeFilter (optional) 
     * @param detailCodeFilter (optional) 
     * @param parentCodeFilter (optional) 
     * @param nodePathFilter (optional) 
     * @param maxOrdinalFilter (optional) 
     * @param minOrdinalFilter (optional) 
     * @param statusFilter (optional) 
     * @param maxDetailValueNumberFilter (optional) 
     * @param minDetailValueNumberFilter (optional) 
     * @param maxLevelFilter (optional) 
     * @param minLevelFilter (optional) 
     * @param detailValueFilter (optional) 
     * @param detailValueUnSignFilter (optional) 
     * @return Success
     */
    getMasterDetailsToExcel(filter: string | null | undefined, masterCodeFilter: string | null | undefined, detailCodeFilter: string | null | undefined, parentCodeFilter: string | null | undefined, nodePathFilter: string | null | undefined, maxOrdinalFilter: number | null | undefined, minOrdinalFilter: number | null | undefined, statusFilter: string | null | undefined, maxDetailValueNumberFilter: number | null | undefined, minDetailValueNumberFilter: number | null | undefined, maxLevelFilter: number | null | undefined, minLevelFilter: number | null | undefined, detailValueFilter: string | null | undefined, detailValueUnSignFilter: string | null | undefined): Observable<ConsumerDBFileDto> {
        let url_ = this.baseUrl + "/api/services/app/MasterDetails/GetMasterDetailsToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (masterCodeFilter !== undefined)
            url_ += "MasterCodeFilter=" + encodeURIComponent("" + masterCodeFilter) + "&";
        if (detailCodeFilter !== undefined)
            url_ += "DetailCodeFilter=" + encodeURIComponent("" + detailCodeFilter) + "&";
        if (parentCodeFilter !== undefined)
            url_ += "ParentCodeFilter=" + encodeURIComponent("" + parentCodeFilter) + "&";
        if (nodePathFilter !== undefined)
            url_ += "NodePathFilter=" + encodeURIComponent("" + nodePathFilter) + "&";
        if (maxOrdinalFilter !== undefined)
            url_ += "MaxOrdinalFilter=" + encodeURIComponent("" + maxOrdinalFilter) + "&";
        if (minOrdinalFilter !== undefined)
            url_ += "MinOrdinalFilter=" + encodeURIComponent("" + minOrdinalFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (maxDetailValueNumberFilter !== undefined)
            url_ += "MaxDetailValueNumberFilter=" + encodeURIComponent("" + maxDetailValueNumberFilter) + "&";
        if (minDetailValueNumberFilter !== undefined)
            url_ += "MinDetailValueNumberFilter=" + encodeURIComponent("" + minDetailValueNumberFilter) + "&";
        if (maxLevelFilter !== undefined)
            url_ += "MaxLevelFilter=" + encodeURIComponent("" + maxLevelFilter) + "&";
        if (minLevelFilter !== undefined)
            url_ += "MinLevelFilter=" + encodeURIComponent("" + minLevelFilter) + "&";
        if (detailValueFilter !== undefined)
            url_ += "DetailValueFilter=" + encodeURIComponent("" + detailValueFilter) + "&";
        if (detailValueUnSignFilter !== undefined)
            url_ += "DetailValueUnSignFilter=" + encodeURIComponent("" + detailValueUnSignFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetMasterDetailsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMasterDetailsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<ConsumerDBFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ConsumerDBFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetMasterDetailsToExcel(response: HttpResponseBase): Observable<ConsumerDBFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? ConsumerDBFileDto.fromJS(resultData200) : new ConsumerDBFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ConsumerDBFileDto>(<any>null);
    }

    /**
     * @param entities (optional) 
     * @return Success
     */
    batchDeleteAsync(entities: MasterDetailDto[] | null | undefined): Observable<MessageResultConsumerDB> {
        let url_ = this.baseUrl + "/api/services/app/MasterDetails/BatchDeleteAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entities);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processBatchDeleteAsync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBatchDeleteAsync(<any>response_);
                } catch (e) {
                    return <Observable<MessageResultConsumerDB>><any>_observableThrow(e);
                }
            } else
                return <Observable<MessageResultConsumerDB>><any>_observableThrow(response_);
        }));
    }

    protected processBatchDeleteAsync(response: HttpResponseBase): Observable<MessageResultConsumerDB> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? MessageResultConsumerDB.fromJS(resultData200) : new MessageResultConsumerDB();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MessageResultConsumerDB>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEditUnsignAsync(input: CreateOrEditMasterDetailDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MasterDetails/CreateOrEditUnsignAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEditUnsignAsync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditUnsignAsync(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEditUnsignAsync(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEditCustom(input: CreateOrEditMasterDetailDto | null | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/MasterDetails/CreateOrEditCustom";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEditCustom(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditCustom(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEditCustom(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @return Success
     */
    searchCustom(): Observable<GetMasterDetailCustom> {
        let url_ = this.baseUrl + "/api/services/app/MasterDetails/SearchCustom";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSearchCustom(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchCustom(<any>response_);
                } catch (e) {
                    return <Observable<GetMasterDetailCustom>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetMasterDetailCustom>><any>_observableThrow(response_);
        }));
    }

    protected processSearchCustom(response: HttpResponseBase): Observable<GetMasterDetailCustom> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetMasterDetailCustom.fromJS(resultData200) : new GetMasterDetailCustom();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetMasterDetailCustom>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    search(input: GetAllMasterDetailsInput | null | undefined): Observable<PagedResultDtoOfGetMasterDetailForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/MasterDetails/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetMasterDetailForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetMasterDetailForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<PagedResultDtoOfGetMasterDetailForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetMasterDetailForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetMasterDetailForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetMasterDetailForViewDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    searchCityByRegion(input: GetAllMasterDetailsInput | null | undefined): Observable<PagedResultDtoOfGetMasterDetailForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/MasterDetails/SearchCityByRegion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSearchCityByRegion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchCityByRegion(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetMasterDetailForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetMasterDetailForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processSearchCityByRegion(response: HttpResponseBase): Observable<PagedResultDtoOfGetMasterDetailForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetMasterDetailForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetMasterDetailForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetMasterDetailForViewDto>(<any>null);
    }

    /**
     * @return Success
     */
    getAllProductClass(): Observable<MasterDetailDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MasterDetails/GetAllProductClass";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllProductClass(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllProductClass(<any>response_);
                } catch (e) {
                    return <Observable<MasterDetailDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<MasterDetailDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllProductClass(response: HttpResponseBase): Observable<MasterDetailDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(MasterDetailDto.fromJS(item));
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MasterDetailDto[]>(<any>null);
    }

    /**
     * @param parentCode (optional) 
     * @return Success
     */
    getAllProductBrand(parentCode: string[] | null | undefined): Observable<MasterDetailDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MasterDetails/GetAllProductBrand?";
        if (parentCode !== undefined)
            parentCode && parentCode.forEach(item => { url_ += "parentCode=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllProductBrand(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllProductBrand(<any>response_);
                } catch (e) {
                    return <Observable<MasterDetailDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<MasterDetailDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllProductBrand(response: HttpResponseBase): Observable<MasterDetailDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(MasterDetailDto.fromJS(item));
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MasterDetailDto[]>(<any>null);
    }

    /**
     * @param masterHeaderCode (optional) 
     * @param level (optional) 
     * @param parentCode (optional) 
     * @return Success
     */
    getAllMasterDetail(masterHeaderCode: string | null | undefined, level: number | null | undefined, parentCode: string[] | null | undefined): Observable<MasterDetailDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MasterDetails/GetAllMasterDetail?";
        if (masterHeaderCode !== undefined)
            url_ += "masterHeaderCode=" + encodeURIComponent("" + masterHeaderCode) + "&";
        if (level !== undefined)
            url_ += "level=" + encodeURIComponent("" + level) + "&";
        if (parentCode !== undefined)
            parentCode && parentCode.forEach(item => { url_ += "parentCode=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllMasterDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllMasterDetail(<any>response_);
                } catch (e) {
                    return <Observable<MasterDetailDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<MasterDetailDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllMasterDetail(response: HttpResponseBase): Observable<MasterDetailDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(MasterDetailDto.fromJS(item));
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MasterDetailDto[]>(<any>null);
    }

    /**
     * @param arg (optional) 
     * @return Success
     */
    importQueue(arg: MetaDataAgrs | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MasterDetails/ImportQueue";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(arg);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processImportQueue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportQueue(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processImportQueue(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    exportCustom(input: GetAllMasterDetailsInput | null | undefined): Observable<ConsumerDBFileDto> {
        let url_ = this.baseUrl + "/api/services/app/MasterDetails/ExportCustom";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processExportCustom(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportCustom(<any>response_);
                } catch (e) {
                    return <Observable<ConsumerDBFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ConsumerDBFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processExportCustom(response: HttpResponseBase): Observable<ConsumerDBFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? ConsumerDBFileDto.fromJS(resultData200) : new ConsumerDBFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ConsumerDBFileDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @param masterCode (optional) 
     * @param level (optional) 
     * @param detailCode (optional) 
     * @return Success
     */
    deleteCustom(id: number | null | undefined, masterCode: string | null | undefined, level: number | null | undefined, detailCode: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MasterDetails/DeleteCustom?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (masterCode !== undefined)
            url_ += "MasterCode=" + encodeURIComponent("" + masterCode) + "&";
        if (level !== undefined)
            url_ += "Level=" + encodeURIComponent("" + level) + "&";
        if (detailCode !== undefined)
            url_ += "DetailCode=" + encodeURIComponent("" + detailCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteCustom(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCustom(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteCustom(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param masterCode (optional) 
     * @param detailCode (optional) 
     * @param level (optional) 
     * @return Success
     */
    getChild(masterCode: string | null | undefined, detailCode: string | null | undefined, level: number | null | undefined): Observable<MasterDetail[]> {
        let url_ = this.baseUrl + "/api/services/app/MasterDetails/GetChild?";
        if (masterCode !== undefined)
            url_ += "masterCode=" + encodeURIComponent("" + masterCode) + "&";
        if (detailCode !== undefined)
            url_ += "detailCode=" + encodeURIComponent("" + detailCode) + "&";
        if (level !== undefined)
            url_ += "level=" + encodeURIComponent("" + level) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetChild(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetChild(<any>response_);
                } catch (e) {
                    return <Observable<MasterDetail[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<MasterDetail[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetChild(response: HttpResponseBase): Observable<MasterDetail[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(MasterDetail.fromJS(item));
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MasterDetail[]>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param masterCodeFilter (optional) 
     * @param detailCodeFilter (optional) 
     * @param parentCodeFilter (optional) 
     * @param nodePathFilter (optional) 
     * @param maxOrdinalFilter (optional) 
     * @param minOrdinalFilter (optional) 
     * @param statusFilter (optional) 
     * @param maxDetailValueNumberFilter (optional) 
     * @param minDetailValueNumberFilter (optional) 
     * @param maxLevelFilter (optional) 
     * @param minLevelFilter (optional) 
     * @param detailValueFilter (optional) 
     * @param detailValueUnSignFilter (optional) 
     * @param metaDataType (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllCategory(filter: string | null | undefined, masterCodeFilter: string | null | undefined, detailCodeFilter: string | null | undefined, parentCodeFilter: string | null | undefined, nodePathFilter: string | null | undefined, maxOrdinalFilter: number | null | undefined, minOrdinalFilter: number | null | undefined, statusFilter: string | null | undefined, maxDetailValueNumberFilter: number | null | undefined, minDetailValueNumberFilter: number | null | undefined, maxLevelFilter: number | null | undefined, minLevelFilter: number | null | undefined, detailValueFilter: string | null | undefined, detailValueUnSignFilter: string | null | undefined, metaDataType: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetMasterDetailForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/MasterDetails/GetAllCategory?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (masterCodeFilter !== undefined)
            url_ += "MasterCodeFilter=" + encodeURIComponent("" + masterCodeFilter) + "&";
        if (detailCodeFilter !== undefined)
            url_ += "DetailCodeFilter=" + encodeURIComponent("" + detailCodeFilter) + "&";
        if (parentCodeFilter !== undefined)
            url_ += "ParentCodeFilter=" + encodeURIComponent("" + parentCodeFilter) + "&";
        if (nodePathFilter !== undefined)
            url_ += "NodePathFilter=" + encodeURIComponent("" + nodePathFilter) + "&";
        if (maxOrdinalFilter !== undefined)
            url_ += "MaxOrdinalFilter=" + encodeURIComponent("" + maxOrdinalFilter) + "&";
        if (minOrdinalFilter !== undefined)
            url_ += "MinOrdinalFilter=" + encodeURIComponent("" + minOrdinalFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (maxDetailValueNumberFilter !== undefined)
            url_ += "MaxDetailValueNumberFilter=" + encodeURIComponent("" + maxDetailValueNumberFilter) + "&";
        if (minDetailValueNumberFilter !== undefined)
            url_ += "MinDetailValueNumberFilter=" + encodeURIComponent("" + minDetailValueNumberFilter) + "&";
        if (maxLevelFilter !== undefined)
            url_ += "MaxLevelFilter=" + encodeURIComponent("" + maxLevelFilter) + "&";
        if (minLevelFilter !== undefined)
            url_ += "MinLevelFilter=" + encodeURIComponent("" + minLevelFilter) + "&";
        if (detailValueFilter !== undefined)
            url_ += "DetailValueFilter=" + encodeURIComponent("" + detailValueFilter) + "&";
        if (detailValueUnSignFilter !== undefined)
            url_ += "DetailValueUnSignFilter=" + encodeURIComponent("" + detailValueUnSignFilter) + "&";
        if (metaDataType !== undefined)
            url_ += "MetaDataType=" + encodeURIComponent("" + metaDataType) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllCategory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCategory(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetMasterDetailForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetMasterDetailForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllCategory(response: HttpResponseBase): Observable<PagedResultDtoOfGetMasterDetailForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetMasterDetailForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetMasterDetailForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetMasterDetailForViewDto>(<any>null);
    }

    /**
     * @param ids (optional) 
     * @return Success
     */
    batchDeleteMasterDetail(ids: number[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MasterDetails/BatchDeleteMasterDetail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ids);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processBatchDeleteMasterDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBatchDeleteMasterDetail(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processBatchDeleteMasterDetail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEditCategory(input: CreateOrEditMasterDetailDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MasterDetails/CreateOrEditCategory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEditCategory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditCategory(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEditCategory(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteExt(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MasterDetails/DeleteExt?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteExt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteExt(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteExt(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param province (optional) 
     * @param district (optional) 
     * @return Success
     */
    getRegion(province: string | null | undefined, district: string | null | undefined): Observable<PagedResultDtoOfRegionViewDto> {
        let url_ = this.baseUrl + "/api/services/app/MasterDetails/GetRegion?";
        if (province !== undefined)
            url_ += "Province=" + encodeURIComponent("" + province) + "&";
        if (district !== undefined)
            url_ += "District=" + encodeURIComponent("" + district) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetRegion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRegion(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfRegionViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfRegionViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetRegion(response: HttpResponseBase): Observable<PagedResultDtoOfRegionViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfRegionViewDto.fromJS(resultData200) : new PagedResultDtoOfRegionViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfRegionViewDto>(<any>null);
    }

    /**
     * @return Success
     */
    getAllRegionAsync(): Observable<MasterDetailDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MasterDetails/GetAllRegionAsync";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllRegionAsync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllRegionAsync(<any>response_);
                } catch (e) {
                    return <Observable<MasterDetailDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<MasterDetailDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllRegionAsync(response: HttpResponseBase): Observable<MasterDetailDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(MasterDetailDto.fromJS(item));
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MasterDetailDto[]>(<any>null);
    }

    /**
     * @param code (optional) 
     * @param level (optional) 
     * @return Success
     */
    getRegionByCodeAndLevelAsync(code: string | null | undefined, level: number | null | undefined): Observable<RegionsForViewDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MasterDetails/GetRegionByCodeAndLevelAsync?";
        if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        if (level !== undefined)
            url_ += "level=" + encodeURIComponent("" + level) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetRegionByCodeAndLevelAsync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRegionByCodeAndLevelAsync(<any>response_);
                } catch (e) {
                    return <Observable<RegionsForViewDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<RegionsForViewDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetRegionByCodeAndLevelAsync(response: HttpResponseBase): Observable<RegionsForViewDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(RegionsForViewDto.fromJS(item));
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RegionsForViewDto[]>(<any>null);
    }
}

@Injectable()
export class MasterHeadersServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param masterCodeFilter (optional) 
     * @param masterNameFilter (optional) 
     * @param statusFilter (optional) 
     * @param typeFilter (optional) 
     * @param isSystemFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, masterCodeFilter: string | null | undefined, masterNameFilter: string | null | undefined, statusFilter: string | null | undefined, typeFilter: string | null | undefined, isSystemFilter: number | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetMasterHeaderForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/MasterHeaders/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (masterCodeFilter !== undefined)
            url_ += "MasterCodeFilter=" + encodeURIComponent("" + masterCodeFilter) + "&";
        if (masterNameFilter !== undefined)
            url_ += "MasterNameFilter=" + encodeURIComponent("" + masterNameFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (typeFilter !== undefined)
            url_ += "TypeFilter=" + encodeURIComponent("" + typeFilter) + "&";
        if (isSystemFilter !== undefined)
            url_ += "IsSystemFilter=" + encodeURIComponent("" + isSystemFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetMasterHeaderForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetMasterHeaderForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetMasterHeaderForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetMasterHeaderForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetMasterHeaderForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetMasterHeaderForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getMasterHeaderForEdit(id: number | null | undefined): Observable<GetMasterHeaderForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/MasterHeaders/GetMasterHeaderForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetMasterHeaderForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMasterHeaderForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetMasterHeaderForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetMasterHeaderForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetMasterHeaderForEdit(response: HttpResponseBase): Observable<GetMasterHeaderForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetMasterHeaderForEditOutput.fromJS(resultData200) : new GetMasterHeaderForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetMasterHeaderForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditMasterHeaderDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MasterHeaders/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MasterHeaders/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param masterCodeFilter (optional) 
     * @param masterNameFilter (optional) 
     * @param statusFilter (optional) 
     * @param typeFilter (optional) 
     * @param isSystemFilter (optional) 
     * @return Success
     */
    getMasterHeadersToExcel(filter: string | null | undefined, masterCodeFilter: string | null | undefined, masterNameFilter: string | null | undefined, statusFilter: string | null | undefined, typeFilter: string | null | undefined, isSystemFilter: number | null | undefined): Observable<ConsumerDBFileDto> {
        let url_ = this.baseUrl + "/api/services/app/MasterHeaders/GetMasterHeadersToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (masterCodeFilter !== undefined)
            url_ += "MasterCodeFilter=" + encodeURIComponent("" + masterCodeFilter) + "&";
        if (masterNameFilter !== undefined)
            url_ += "MasterNameFilter=" + encodeURIComponent("" + masterNameFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (typeFilter !== undefined)
            url_ += "TypeFilter=" + encodeURIComponent("" + typeFilter) + "&";
        if (isSystemFilter !== undefined)
            url_ += "IsSystemFilter=" + encodeURIComponent("" + isSystemFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetMasterHeadersToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMasterHeadersToExcel(<any>response_);
                } catch (e) {
                    return <Observable<ConsumerDBFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ConsumerDBFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetMasterHeadersToExcel(response: HttpResponseBase): Observable<ConsumerDBFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? ConsumerDBFileDto.fromJS(resultData200) : new ConsumerDBFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ConsumerDBFileDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEditCustom(input: CreateOrEditMasterHeaderDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MasterHeaders/CreateOrEditCustom";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEditCustom(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditCustom(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEditCustom(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    search(input: GetAllMasterHeadersInput | null | undefined): Observable<PagedResultDtoOfGetMasterHeaderForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/MasterHeaders/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetMasterHeaderForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetMasterHeaderForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<PagedResultDtoOfGetMasterHeaderForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetMasterHeaderForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetMasterHeaderForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetMasterHeaderForViewDto>(<any>null);
    }

    /**
     * @param masterCode (optional) 
     * @param masterName (optional) 
     * @param status (optional) 
     * @param type (optional) 
     * @param isSystem (optional) 
     * @param masterNameUnSign (optional) 
     * @param lastModificationTime (optional) 
     * @param id (optional) 
     * @return Success
     */
    deleteCustom(masterCode: string | null | undefined, masterName: string | null | undefined, status: string | null | undefined, type: string | null | undefined, isSystem: boolean | null | undefined, masterNameUnSign: string | null | undefined, lastModificationTime: moment.Moment | null | undefined, id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MasterHeaders/DeleteCustom?";
        if (masterCode !== undefined)
            url_ += "MasterCode=" + encodeURIComponent("" + masterCode) + "&";
        if (masterName !== undefined)
            url_ += "MasterName=" + encodeURIComponent("" + masterName) + "&";
        if (status !== undefined)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (type !== undefined)
            url_ += "Type=" + encodeURIComponent("" + type) + "&";
        if (isSystem !== undefined)
            url_ += "IsSystem=" + encodeURIComponent("" + isSystem) + "&";
        if (masterNameUnSign !== undefined)
            url_ += "MasterNameUnSign=" + encodeURIComponent("" + masterNameUnSign) + "&";
        if (lastModificationTime !== undefined)
            url_ += "LastModificationTime=" + encodeURIComponent(lastModificationTime ? "" + lastModificationTime.toJSON() : "") + "&";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteCustom(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCustom(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteCustom(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    defaultOAAsync(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/MasterHeaders/DefaultOAAsync";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDefaultOAAsync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDefaultOAAsync(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processDefaultOAAsync(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }
}

@Injectable()
export class MemberServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    loginByFacebook(input: MemberLoginFbInput | null | undefined): Observable<MemberLoginResult> {
        let url_ = this.baseUrl + "/api/services/app/Member/LoginByFacebook";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processLoginByFacebook(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLoginByFacebook(<any>response_);
                } catch (e) {
                    return <Observable<MemberLoginResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<MemberLoginResult>><any>_observableThrow(response_);
        }));
    }

    protected processLoginByFacebook(response: HttpResponseBase): Observable<MemberLoginResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? MemberLoginResult.fromJS(resultData200) : new MemberLoginResult();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MemberLoginResult>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    loginByGoogle(input: MemberLoginByGoogleInput | null | undefined): Observable<MemberLoginResult> {
        let url_ = this.baseUrl + "/api/services/app/Member/LoginByGoogle";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processLoginByGoogle(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLoginByGoogle(<any>response_);
                } catch (e) {
                    return <Observable<MemberLoginResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<MemberLoginResult>><any>_observableThrow(response_);
        }));
    }

    protected processLoginByGoogle(response: HttpResponseBase): Observable<MemberLoginResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? MemberLoginResult.fromJS(resultData200) : new MemberLoginResult();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MemberLoginResult>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    sendOTPToEmail(input: MemberSendOTPViaEmailInput | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Member/SendOTPToEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSendOTPToEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendOTPToEmail(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSendOTPToEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    sendOTPToPhoneNumber(input: MemberSendOTPViaPhoneNumberInput | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Member/SendOTPToPhoneNumber";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSendOTPToPhoneNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendOTPToPhoneNumber(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSendOTPToPhoneNumber(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    loginOTPByPhoneNumber(input: MemberLoginOTPViaPhoneNumberInput | null | undefined): Observable<MemberLoginResult> {
        let url_ = this.baseUrl + "/api/services/app/Member/LoginOTPByPhoneNumber";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processLoginOTPByPhoneNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLoginOTPByPhoneNumber(<any>response_);
                } catch (e) {
                    return <Observable<MemberLoginResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<MemberLoginResult>><any>_observableThrow(response_);
        }));
    }

    protected processLoginOTPByPhoneNumber(response: HttpResponseBase): Observable<MemberLoginResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? MemberLoginResult.fromJS(resultData200) : new MemberLoginResult();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MemberLoginResult>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    verifyForRegisterAsync(input: MemberLoginOTPViaPhoneNumberInputDto | null | undefined): Observable<MemberLoginResult> {
        let url_ = this.baseUrl + "/api/services/app/Member/VerifyForRegisterAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processVerifyForRegisterAsync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerifyForRegisterAsync(<any>response_);
                } catch (e) {
                    return <Observable<MemberLoginResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<MemberLoginResult>><any>_observableThrow(response_);
        }));
    }

    protected processVerifyForRegisterAsync(response: HttpResponseBase): Observable<MemberLoginResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? MemberLoginResult.fromJS(resultData200) : new MemberLoginResult();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MemberLoginResult>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    loginOTPByEmail(input: MemberLoginOTPViaEmailInput | null | undefined): Observable<MemberLoginResult> {
        let url_ = this.baseUrl + "/api/services/app/Member/LoginOTPByEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processLoginOTPByEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLoginOTPByEmail(<any>response_);
                } catch (e) {
                    return <Observable<MemberLoginResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<MemberLoginResult>><any>_observableThrow(response_);
        }));
    }

    protected processLoginOTPByEmail(response: HttpResponseBase): Observable<MemberLoginResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? MemberLoginResult.fromJS(resultData200) : new MemberLoginResult();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MemberLoginResult>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    mappingMembership(input: MapingMembershipDto | null | undefined): Observable<ConsumerProfileDto> {
        let url_ = this.baseUrl + "/api/services/app/Member/MappingMembership";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processMappingMembership(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMappingMembership(<any>response_);
                } catch (e) {
                    return <Observable<ConsumerProfileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ConsumerProfileDto>><any>_observableThrow(response_);
        }));
    }

    protected processMappingMembership(response: HttpResponseBase): Observable<ConsumerProfileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? ConsumerProfileDto.fromJS(resultData200) : new ConsumerProfileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ConsumerProfileDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createNewMembership(input: CreateOrEditConsumerProfileDto | null | undefined): Observable<ConsumerProfileDto> {
        let url_ = this.baseUrl + "/api/services/app/Member/CreateNewMembership";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateNewMembership(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateNewMembership(<any>response_);
                } catch (e) {
                    return <Observable<ConsumerProfileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ConsumerProfileDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreateNewMembership(response: HttpResponseBase): Observable<ConsumerProfileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? ConsumerProfileDto.fromJS(resultData200) : new ConsumerProfileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ConsumerProfileDto>(<any>null);
    }

    /**
     * @param memberCode (optional) 
     * @param membershipCardId (optional) 
     * @param id (optional) 
     * @return Success
     */
    getMemberInformation(memberCode: string | null | undefined, membershipCardId: string | null | undefined, id: number | null | undefined): Observable<ConsumerProfileDto> {
        let url_ = this.baseUrl + "/api/services/app/Member/GetMemberInformation?";
        if (memberCode !== undefined)
            url_ += "MemberCode=" + encodeURIComponent("" + memberCode) + "&";
        if (membershipCardId !== undefined)
            url_ += "MembershipCardId=" + encodeURIComponent("" + membershipCardId) + "&";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetMemberInformation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMemberInformation(<any>response_);
                } catch (e) {
                    return <Observable<ConsumerProfileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ConsumerProfileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetMemberInformation(response: HttpResponseBase): Observable<ConsumerProfileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? ConsumerProfileDto.fromJS(resultData200) : new ConsumerProfileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ConsumerProfileDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    changeMemberInformation(input: CreateOrEditConsumerProfileDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Member/ChangeMemberInformation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processChangeMemberInformation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeMemberInformation(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processChangeMemberInformation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    linkMemberConfirm(input: LinkMemberInput | null | undefined): Observable<LinkMemberConfirmDto> {
        let url_ = this.baseUrl + "/api/services/app/Member/LinkMemberConfirm";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processLinkMemberConfirm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLinkMemberConfirm(<any>response_);
                } catch (e) {
                    return <Observable<LinkMemberConfirmDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<LinkMemberConfirmDto>><any>_observableThrow(response_);
        }));
    }

    protected processLinkMemberConfirm(response: HttpResponseBase): Observable<LinkMemberConfirmDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? LinkMemberConfirmDto.fromJS(resultData200) : new LinkMemberConfirmDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LinkMemberConfirmDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    verifyLinkMemberOTP(input: LinkMemberConfirmInput | null | undefined): Observable<MemberLoginResult> {
        let url_ = this.baseUrl + "/api/services/app/Member/VerifyLinkMemberOTP";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processVerifyLinkMemberOTP(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerifyLinkMemberOTP(<any>response_);
                } catch (e) {
                    return <Observable<MemberLoginResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<MemberLoginResult>><any>_observableThrow(response_);
        }));
    }

    protected processVerifyLinkMemberOTP(response: HttpResponseBase): Observable<MemberLoginResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? MemberLoginResult.fromJS(resultData200) : new MemberLoginResult();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MemberLoginResult>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    saveChannelInformation(input: MemberChannelInformationDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Member/SaveChannelInformation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSaveChannelInformation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveChannelInformation(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSaveChannelInformation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param memberCode (optional) 
     * @param channelCode (optional) 
     * @param memberChannelId (optional) 
     * @param appId (optional) 
     * @param appVersion (optional) 
     * @param systemOS (optional) 
     * @return Success
     */
    deleteChannelInformation(memberCode: string | null | undefined, channelCode: string | null | undefined, memberChannelId: string | null | undefined, appId: string | null | undefined, appVersion: string | null | undefined, systemOS: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Member/DeleteChannelInformation?";
        if (memberCode !== undefined)
            url_ += "MemberCode=" + encodeURIComponent("" + memberCode) + "&";
        if (channelCode !== undefined)
            url_ += "ChannelCode=" + encodeURIComponent("" + channelCode) + "&";
        if (memberChannelId !== undefined)
            url_ += "MemberChannelId=" + encodeURIComponent("" + memberChannelId) + "&";
        if (appId !== undefined)
            url_ += "AppId=" + encodeURIComponent("" + appId) + "&";
        if (appVersion !== undefined)
            url_ += "AppVersion=" + encodeURIComponent("" + appVersion) + "&";
        if (systemOS !== undefined)
            url_ += "SystemOS=" + encodeURIComponent("" + systemOS) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteChannelInformation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteChannelInformation(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteChannelInformation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param validateMemberInformation (optional) 
     * @return Success
     */
    validateMemberInformation(validateMemberInformation: ValidateMemberInformation | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Member/ValidateMemberInformation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(validateMemberInformation);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processValidateMemberInformation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateMemberInformation(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processValidateMemberInformation(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param memberLoginDto (optional) 
     * @return Success
     */
    loginMemberAsync(memberLoginDto: MemberLoginDto | null | undefined): Observable<MemberLoginResult> {
        let url_ = this.baseUrl + "/api/services/app/Member/LoginMemberAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(memberLoginDto);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processLoginMemberAsync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLoginMemberAsync(<any>response_);
                } catch (e) {
                    return <Observable<MemberLoginResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<MemberLoginResult>><any>_observableThrow(response_);
        }));
    }

    protected processLoginMemberAsync(response: HttpResponseBase): Observable<MemberLoginResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? MemberLoginResult.fromJS(resultData200) : new MemberLoginResult();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MemberLoginResult>(<any>null);
    }

    /**
     * @param linkMemberOTP (optional) 
     * @return Success
     */
    linkMemberOTPAsync(linkMemberOTP: LinkMemberOTP | null | undefined): Observable<MemberLoginResult> {
        let url_ = this.baseUrl + "/api/services/app/Member/LinkMemberOTPAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(linkMemberOTP);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processLinkMemberOTPAsync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLinkMemberOTPAsync(<any>response_);
                } catch (e) {
                    return <Observable<MemberLoginResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<MemberLoginResult>><any>_observableThrow(response_);
        }));
    }

    protected processLinkMemberOTPAsync(response: HttpResponseBase): Observable<MemberLoginResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? MemberLoginResult.fromJS(resultData200) : new MemberLoginResult();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MemberLoginResult>(<any>null);
    }

    /**
     * @param phoneNumber (optional) 
     * @return Success
     */
    validatePhoneNumberAsync(phoneNumber: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Member/ValidatePhoneNumberAsync?";
        if (phoneNumber !== undefined)
            url_ += "phoneNumber=" + encodeURIComponent("" + phoneNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processValidatePhoneNumberAsync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidatePhoneNumberAsync(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processValidatePhoneNumberAsync(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param memberLoginOTPViaPhoneNumberInput (optional) 
     * @return Success
     */
    verifyOTPWithPhoneNumber(memberLoginOTPViaPhoneNumberInput: MemberLoginOTPViaPhoneNumberInput | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Member/VerifyOTPWithPhoneNumber";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(memberLoginOTPViaPhoneNumberInput);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processVerifyOTPWithPhoneNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerifyOTPWithPhoneNumber(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processVerifyOTPWithPhoneNumber(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param changePassword (optional) 
     * @return Success
     */
    updatePasswordAsync(changePassword: ChangePasswordDto | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Member/UpdatePasswordAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(changePassword);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdatePasswordAsync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePasswordAsync(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processUpdatePasswordAsync(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param verifyPasswordForViewProfileDto (optional) 
     * @return Success
     */
    verifyPasswordAsync(verifyPasswordForViewProfileDto: VerifyPasswordForViewProfileDto | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Member/VerifyPasswordAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(verifyPasswordForViewProfileDto);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processVerifyPasswordAsync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerifyPasswordAsync(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processVerifyPasswordAsync(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param changePassword (optional) 
     * @return Success
     */
    changePasswordAsync(changePassword: ChangePasswordForViewProfileDto | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Member/ChangePasswordAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(changePassword);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processChangePasswordAsync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangePasswordAsync(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processChangePasswordAsync(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param phoneNumber (optional) 
     * @param otpCode (optional) 
     * @return Success
     */
    verifyOTPCode(phoneNumber: string | null | undefined, otpCode: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Member/VerifyOTPCode?";
        if (phoneNumber !== undefined)
            url_ += "phoneNumber=" + encodeURIComponent("" + phoneNumber) + "&";
        if (otpCode !== undefined)
            url_ += "otpCode=" + encodeURIComponent("" + otpCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processVerifyOTPCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerifyOTPCode(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processVerifyOTPCode(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    checkMemberInformation(input: CreateOrEditConsumerProfileDto | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Member/CheckMemberInformation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCheckMemberInformation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckMemberInformation(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processCheckMemberInformation(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }
}

@Injectable()
export class MemberActivityRuleServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param isActiveFilter (optional) 
     * @param sourceFilter (optional) 
     * @param memberStatusFilter (optional) 
     * @param typeFilter (optional) 
     * @param valueFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, isActiveFilter: number | null | undefined, sourceFilter: string | null | undefined, memberStatusFilter: string | null | undefined, typeFilter: string | null | undefined, valueFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetMemberActivityRuleForView> {
        let url_ = this.baseUrl + "/api/services/app/MemberActivityRule/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (isActiveFilter !== undefined)
            url_ += "IsActiveFilter=" + encodeURIComponent("" + isActiveFilter) + "&";
        if (sourceFilter !== undefined)
            url_ += "SourceFilter=" + encodeURIComponent("" + sourceFilter) + "&";
        if (memberStatusFilter !== undefined)
            url_ += "MemberStatusFilter=" + encodeURIComponent("" + memberStatusFilter) + "&";
        if (typeFilter !== undefined)
            url_ += "TypeFilter=" + encodeURIComponent("" + typeFilter) + "&";
        if (valueFilter !== undefined)
            url_ += "ValueFilter=" + encodeURIComponent("" + valueFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetMemberActivityRuleForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetMemberActivityRuleForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetMemberActivityRuleForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetMemberActivityRuleForView.fromJS(resultData200) : new PagedResultDtoOfGetMemberActivityRuleForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetMemberActivityRuleForView>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getMemberActivityRuleForEdit(id: number | null | undefined): Observable<GetMemberActivityRuleForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/MemberActivityRule/GetMemberActivityRuleForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetMemberActivityRuleForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMemberActivityRuleForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetMemberActivityRuleForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetMemberActivityRuleForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetMemberActivityRuleForEdit(response: HttpResponseBase): Observable<GetMemberActivityRuleForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetMemberActivityRuleForEditOutput.fromJS(resultData200) : new GetMemberActivityRuleForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetMemberActivityRuleForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditMemberActivityRuleDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MemberActivityRule/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MemberActivityRule/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEditMulti(input: CreateOrEditMemberActivityRuleDto[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MemberActivityRule/CreateOrEditMulti";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEditMulti(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditMulti(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEditMulti(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    checkActivityOfMember(input: CheckActivityOfMemberDto | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/MemberActivityRule/CheckActivityOfMember";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCheckActivityOfMember(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckActivityOfMember(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processCheckActivityOfMember(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }
}

@Injectable()
export class MemberInfoServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetSecondaryCustomerInfoForView> {
        let url_ = this.baseUrl + "/api/services/app/MemberInfo/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetSecondaryCustomerInfoForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetSecondaryCustomerInfoForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetSecondaryCustomerInfoForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetSecondaryCustomerInfoForView.fromJS(resultData200) : new PagedResultDtoOfGetSecondaryCustomerInfoForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetSecondaryCustomerInfoForView>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getSecondaryCustomerInfoForEdit(id: number | null | undefined): Observable<GetSecondaryCustomerInfoForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/MemberInfo/GetSecondaryCustomerInfoForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSecondaryCustomerInfoForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSecondaryCustomerInfoForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetSecondaryCustomerInfoForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetSecondaryCustomerInfoForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetSecondaryCustomerInfoForEdit(response: HttpResponseBase): Observable<GetSecondaryCustomerInfoForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetSecondaryCustomerInfoForEditOutput.fromJS(resultData200) : new GetSecondaryCustomerInfoForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSecondaryCustomerInfoForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditSecondaryCustomerInfoDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MemberInfo/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MemberInfo/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param memberCode (optional) 
     * @return Success
     */
    getByCode(memberCode: string | null | undefined): Observable<SecondaryCustomerInfoDto> {
        let url_ = this.baseUrl + "/api/services/app/MemberInfo/GetByCode?";
        if (memberCode !== undefined)
            url_ += "MemberCode=" + encodeURIComponent("" + memberCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetByCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByCode(<any>response_);
                } catch (e) {
                    return <Observable<SecondaryCustomerInfoDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SecondaryCustomerInfoDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetByCode(response: HttpResponseBase): Observable<SecondaryCustomerInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? SecondaryCustomerInfoDto.fromJS(resultData200) : new SecondaryCustomerInfoDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SecondaryCustomerInfoDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    registerMember(input: RegisterMemberDto | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/MemberInfo/RegisterMember";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processRegisterMember(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegisterMember(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processRegisterMember(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param memberChannelId (optional) 
     * @param code (optional) 
     * @param phone (optional) 
     * @param id (optional) 
     * @return Success
     */
    getMemberInformation(memberChannelId: string | null | undefined, code: string | null | undefined, phone: string | null | undefined, id: number | null | undefined): Observable<SecondaryCustomerMemberDto> {
        let url_ = this.baseUrl + "/api/services/app/MemberInfo/GetMemberInformation?";
        if (memberChannelId !== undefined)
            url_ += "MemberChannelId=" + encodeURIComponent("" + memberChannelId) + "&";
        if (code !== undefined)
            url_ += "Code=" + encodeURIComponent("" + code) + "&";
        if (phone !== undefined)
            url_ += "Phone=" + encodeURIComponent("" + phone) + "&";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetMemberInformation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMemberInformation(<any>response_);
                } catch (e) {
                    return <Observable<SecondaryCustomerMemberDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SecondaryCustomerMemberDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetMemberInformation(response: HttpResponseBase): Observable<SecondaryCustomerMemberDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? SecondaryCustomerMemberDto.fromJS(resultData200) : new SecondaryCustomerMemberDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SecondaryCustomerMemberDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    changeMemberInformation(input: SecondaryCustomerMemberDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MemberInfo/ChangeMemberInformation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processChangeMemberInformation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeMemberInformation(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processChangeMemberInformation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param zaloChatId (optional) 
     * @return Success
     */
    registeredMember(zaloChatId: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/MemberInfo/RegisteredMember?";
        if (zaloChatId !== undefined)
            url_ += "zaloChatId=" + encodeURIComponent("" + zaloChatId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processRegisteredMember(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegisteredMember(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processRegisteredMember(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param phoneNumber (optional) 
     * @return Success
     */
    isExistPhoneNumber(phoneNumber: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/MemberInfo/IsExistPhoneNumber?";
        if (phoneNumber !== undefined)
            url_ += "phoneNumber=" + encodeURIComponent("" + phoneNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processIsExistPhoneNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsExistPhoneNumber(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processIsExistPhoneNumber(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param memberLoginDto (optional) 
     * @return Success
     */
    loginMemberAsync(memberLoginDto: MemberInfoDto | null | undefined): Observable<MemberInfoResult> {
        let url_ = this.baseUrl + "/api/services/app/MemberInfo/LoginMemberAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(memberLoginDto);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processLoginMemberAsync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLoginMemberAsync(<any>response_);
                } catch (e) {
                    return <Observable<MemberInfoResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<MemberInfoResult>><any>_observableThrow(response_);
        }));
    }

    protected processLoginMemberAsync(response: HttpResponseBase): Observable<MemberInfoResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? MemberInfoResult.fromJS(resultData200) : new MemberInfoResult();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MemberInfoResult>(<any>null);
    }

    /**
     * @param memberLoginDto (optional) 
     * @return Success
     */
    verifyPasswordAsync(memberLoginDto: MemberInfoDto | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/MemberInfo/VerifyPasswordAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(memberLoginDto);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processVerifyPasswordAsync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerifyPasswordAsync(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processVerifyPasswordAsync(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param changePassword (optional) 
     * @return Success
     */
    changePasswordAsync(changePassword: MemberChangePasswordDto | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/MemberInfo/ChangePasswordAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(changePassword);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processChangePasswordAsync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangePasswordAsync(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processChangePasswordAsync(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param memberCode (optional) 
     * @return Success
     */
    stopBeingMembership(memberCode: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MemberInfo/StopBeingMembership?";
        if (memberCode !== undefined)
            url_ += "memberCode=" + encodeURIComponent("" + memberCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processStopBeingMembership(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStopBeingMembership(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processStopBeingMembership(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class MemberRankOverViewReportServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getData(): Observable<MemberRankOverviewReportOutput> {
        let url_ = this.baseUrl + "/api/services/app/MemberRankOverViewReport/GetData";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetData(<any>response_);
                } catch (e) {
                    return <Observable<MemberRankOverviewReportOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<MemberRankOverviewReportOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetData(response: HttpResponseBase): Observable<MemberRankOverviewReportOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? MemberRankOverviewReportOutput.fromJS(resultData200) : new MemberRankOverviewReportOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MemberRankOverviewReportOutput>(<any>null);
    }

    /**
     * @return Success
     */
    exportFile(): Observable<PointFileDto> {
        let url_ = this.baseUrl + "/api/services/app/MemberRankOverViewReport/ExportFile";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processExportFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportFile(<any>response_);
                } catch (e) {
                    return <Observable<PointFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PointFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processExportFile(response: HttpResponseBase): Observable<PointFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PointFileDto.fromJS(resultData200) : new PointFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PointFileDto>(<any>null);
    }
}

@Injectable()
export class MetadataServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getReason(masterCode: string, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetReasonDto> {
        let url_ = this.baseUrl + "/api/services/app/Metadata/GetReason?";
        if (masterCode === undefined || masterCode === null)
            throw new Error("The parameter 'masterCode' must be defined and cannot be null.");
        else
            url_ += "MasterCode=" + encodeURIComponent("" + masterCode) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetReason(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReason(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetReasonDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetReasonDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetReason(response: HttpResponseBase): Observable<PagedResultDtoOfGetReasonDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetReasonDto.fromJS(resultData200) : new PagedResultDtoOfGetReasonDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetReasonDto>(<any>null);
    }
}

@Injectable()
export class MissionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param missionCodeFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, missionCodeFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetMissionForView> {
        let url_ = this.baseUrl + "/api/services/app/Mission/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (missionCodeFilter !== undefined)
            url_ += "MissionCodeFilter=" + encodeURIComponent("" + missionCodeFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetMissionForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetMissionForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetMissionForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetMissionForView.fromJS(resultData200) : new PagedResultDtoOfGetMissionForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetMissionForView>(<any>null);
    }

    /**
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllForView(sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetMissionForView> {
        let url_ = this.baseUrl + "/api/services/app/Mission/GetAllForView?";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllForView(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetMissionForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetMissionForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllForView(response: HttpResponseBase): Observable<PagedResultDtoOfGetMissionForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetMissionForView.fromJS(resultData200) : new PagedResultDtoOfGetMissionForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetMissionForView>(<any>null);
    }

    /**
     * @param inputDto (optional) 
     * @return Success
     */
    claim(inputDto: ClaimMissionInputDto | null | undefined): Observable<ClaimMissionOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/Mission/Claim";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inputDto);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processClaim(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClaim(<any>response_);
                } catch (e) {
                    return <Observable<ClaimMissionOutputDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ClaimMissionOutputDto>><any>_observableThrow(response_);
        }));
    }

    protected processClaim(response: HttpResponseBase): Observable<ClaimMissionOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? ClaimMissionOutputDto.fromJS(resultData200) : new ClaimMissionOutputDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ClaimMissionOutputDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param missionCodeFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getMissionDetail(filter: string | null | undefined, missionCodeFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<GetMissionForView> {
        let url_ = this.baseUrl + "/api/services/app/Mission/GetMissionDetail?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (missionCodeFilter !== undefined)
            url_ += "MissionCodeFilter=" + encodeURIComponent("" + missionCodeFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetMissionDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMissionDetail(<any>response_);
                } catch (e) {
                    return <Observable<GetMissionForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetMissionForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetMissionDetail(response: HttpResponseBase): Observable<GetMissionForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetMissionForView.fromJS(resultData200) : new GetMissionForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetMissionForView>(<any>null);
    }

    /**
     * @param inputDto (optional) 
     * @return Success
     */
    claimV2(inputDto: ClaimMissionInputDto | null | undefined): Observable<ClaimMissionOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/Mission/ClaimV2";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inputDto);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processClaimV2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClaimV2(<any>response_);
                } catch (e) {
                    return <Observable<ClaimMissionOutputDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ClaimMissionOutputDto>><any>_observableThrow(response_);
        }));
    }

    protected processClaimV2(response: HttpResponseBase): Observable<ClaimMissionOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? ClaimMissionOutputDto.fromJS(resultData200) : new ClaimMissionOutputDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ClaimMissionOutputDto>(<any>null);
    }
}

@Injectable()
export class MobileConfigurationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getMobileInitialData(): Observable<MobileInitialData> {
        let url_ = this.baseUrl + "/api/MobileConfiguration/GetMobileInitialData";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetMobileInitialData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMobileInitialData(<any>response_);
                } catch (e) {
                    return <Observable<MobileInitialData>><any>_observableThrow(e);
                }
            } else
                return <Observable<MobileInitialData>><any>_observableThrow(response_);
        }));
    }

    protected processGetMobileInitialData(response: HttpResponseBase): Observable<MobileInitialData> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? MobileInitialData.fromJS(resultData200) : new MobileInitialData();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MobileInitialData>(<any>null);
    }
}

@Injectable()
export class NewPaymentTransactionHandlerServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param message (optional) 
     * @return Success
     */
    handle(message: NewPaymentTransactionMessageEventData | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/NewPaymentTransactionHandler/Handle";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(message);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processHandle(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHandle(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processHandle(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class NotificationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param state (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getUserNotifications(state: State | null | undefined, maxResultCount: number | null | undefined, skipCount: number | null | undefined): Observable<GetNotificationsOutput> {
        let url_ = this.baseUrl + "/api/services/app/Notification/GetUserNotifications?";
        if (state !== undefined)
            url_ += "State=" + encodeURIComponent("" + state) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetUserNotifications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserNotifications(<any>response_);
                } catch (e) {
                    return <Observable<GetNotificationsOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetNotificationsOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserNotifications(response: HttpResponseBase): Observable<GetNotificationsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetNotificationsOutput.fromJS(resultData200) : new GetNotificationsOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetNotificationsOutput>(<any>null);
    }

    /**
     * @return Success
     */
    setAllNotificationsAsRead(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Notification/SetAllNotificationsAsRead";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSetAllNotificationsAsRead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetAllNotificationsAsRead(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSetAllNotificationsAsRead(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    setNotificationAsRead(input: EntityDtoOfGuid | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Notification/SetNotificationAsRead";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSetNotificationAsRead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetNotificationAsRead(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSetNotificationAsRead(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    getNotificationSettings(): Observable<GetNotificationSettingsOutput> {
        let url_ = this.baseUrl + "/api/services/app/Notification/GetNotificationSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetNotificationSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNotificationSettings(<any>response_);
                } catch (e) {
                    return <Observable<GetNotificationSettingsOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetNotificationSettingsOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetNotificationSettings(response: HttpResponseBase): Observable<GetNotificationSettingsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetNotificationSettingsOutput.fromJS(resultData200) : new GetNotificationSettingsOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetNotificationSettingsOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    updateNotificationSettings(input: UpdateNotificationSettingsInput | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Notification/UpdateNotificationSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateNotificationSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateNotificationSettings(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateNotificationSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class NotificationUsersServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param memberCodeFilter (optional) 
     * @param memberNameFilter (optional) 
     * @param phoneFilter (optional) 
     * @param emailFilter (optional) 
     * @param statusFilter (optional) 
     * @param communicationChannelsFilter (optional) 
     * @param communicationLanguageFilter (optional) 
     * @param memberNameUnsignFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, memberCodeFilter: string | null | undefined, memberNameFilter: string | null | undefined, phoneFilter: string | null | undefined, emailFilter: string | null | undefined, statusFilter: string | null | undefined, communicationChannelsFilter: string | null | undefined, communicationLanguageFilter: string | null | undefined, memberNameUnsignFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetNotificationUserForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/NotificationUsers/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (memberCodeFilter !== undefined)
            url_ += "MemberCodeFilter=" + encodeURIComponent("" + memberCodeFilter) + "&";
        if (memberNameFilter !== undefined)
            url_ += "MemberNameFilter=" + encodeURIComponent("" + memberNameFilter) + "&";
        if (phoneFilter !== undefined)
            url_ += "PhoneFilter=" + encodeURIComponent("" + phoneFilter) + "&";
        if (emailFilter !== undefined)
            url_ += "EmailFilter=" + encodeURIComponent("" + emailFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (communicationChannelsFilter !== undefined)
            url_ += "CommunicationChannelsFilter=" + encodeURIComponent("" + communicationChannelsFilter) + "&";
        if (communicationLanguageFilter !== undefined)
            url_ += "CommunicationLanguageFilter=" + encodeURIComponent("" + communicationLanguageFilter) + "&";
        if (memberNameUnsignFilter !== undefined)
            url_ += "MemberNameUnsignFilter=" + encodeURIComponent("" + memberNameUnsignFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetNotificationUserForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetNotificationUserForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetNotificationUserForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetNotificationUserForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetNotificationUserForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetNotificationUserForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getNotificationUserForEdit(id: number | null | undefined): Observable<GetNotificationUserForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/NotificationUsers/GetNotificationUserForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetNotificationUserForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNotificationUserForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetNotificationUserForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetNotificationUserForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetNotificationUserForEdit(response: HttpResponseBase): Observable<GetNotificationUserForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetNotificationUserForEditOutput.fromJS(resultData200) : new GetNotificationUserForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetNotificationUserForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditNotificationUserDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/NotificationUsers/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/NotificationUsers/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param memberCodeFilter (optional) 
     * @param memberNameFilter (optional) 
     * @param phoneFilter (optional) 
     * @param emailFilter (optional) 
     * @param statusFilter (optional) 
     * @param communicationChannelsFilter (optional) 
     * @param communicationLanguageFilter (optional) 
     * @param memberNameUnsignFilter (optional) 
     * @return Success
     */
    getNotificationUsersToExcel(filter: string | null | undefined, memberCodeFilter: string | null | undefined, memberNameFilter: string | null | undefined, phoneFilter: string | null | undefined, emailFilter: string | null | undefined, statusFilter: string | null | undefined, communicationChannelsFilter: string | null | undefined, communicationLanguageFilter: string | null | undefined, memberNameUnsignFilter: string | null | undefined): Observable<NotificationFileDto> {
        let url_ = this.baseUrl + "/api/services/app/NotificationUsers/GetNotificationUsersToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (memberCodeFilter !== undefined)
            url_ += "MemberCodeFilter=" + encodeURIComponent("" + memberCodeFilter) + "&";
        if (memberNameFilter !== undefined)
            url_ += "MemberNameFilter=" + encodeURIComponent("" + memberNameFilter) + "&";
        if (phoneFilter !== undefined)
            url_ += "PhoneFilter=" + encodeURIComponent("" + phoneFilter) + "&";
        if (emailFilter !== undefined)
            url_ += "EmailFilter=" + encodeURIComponent("" + emailFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (communicationChannelsFilter !== undefined)
            url_ += "CommunicationChannelsFilter=" + encodeURIComponent("" + communicationChannelsFilter) + "&";
        if (communicationLanguageFilter !== undefined)
            url_ += "CommunicationLanguageFilter=" + encodeURIComponent("" + communicationLanguageFilter) + "&";
        if (memberNameUnsignFilter !== undefined)
            url_ += "MemberNameUnsignFilter=" + encodeURIComponent("" + memberNameUnsignFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetNotificationUsersToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNotificationUsersToExcel(<any>response_);
                } catch (e) {
                    return <Observable<NotificationFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<NotificationFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetNotificationUsersToExcel(response: HttpResponseBase): Observable<NotificationFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? NotificationFileDto.fromJS(resultData200) : new NotificationFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NotificationFileDto>(<any>null);
    }
}

@Injectable()
export class NotificationUsersExcelExporterServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param notificationUsers (optional) 
     * @return Success
     */
    exportToFile(notificationUsers: GetNotificationUserForViewDto[] | null | undefined): Observable<NotificationFileDto> {
        let url_ = this.baseUrl + "/api/services/app/NotificationUsersExcelExporter/ExportToFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(notificationUsers);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processExportToFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportToFile(<any>response_);
                } catch (e) {
                    return <Observable<NotificationFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<NotificationFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processExportToFile(response: HttpResponseBase): Observable<NotificationFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? NotificationFileDto.fromJS(resultData200) : new NotificationFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NotificationFileDto>(<any>null);
    }
}

@Injectable()
export class OneTimePasswordServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OneTimePassword/Delete?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param oTP (optional) 
     * @param phoneNumer (optional) 
     * @param type (optional) 
     * @return Success
     */
    getAll(oTP: string | null | undefined, phoneNumer: string | null | undefined, type: string | null | undefined): Observable<PagedResultDtoOfOneTimePasswordDto> {
        let url_ = this.baseUrl + "/api/services/app/OneTimePassword/GetAll?";
        if (oTP !== undefined)
            url_ += "OTP=" + encodeURIComponent("" + oTP) + "&";
        if (phoneNumer !== undefined)
            url_ += "PhoneNumer=" + encodeURIComponent("" + phoneNumer) + "&";
        if (type !== undefined)
            url_ += "Type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfOneTimePasswordDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfOneTimePasswordDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfOneTimePasswordDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfOneTimePasswordDto.fromJS(resultData200) : new PagedResultDtoOfOneTimePasswordDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfOneTimePasswordDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    authenticateOTP(input: GetOneTimePasswordInput | null | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/OneTimePassword/AuthenticateOTP";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processAuthenticateOTP(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuthenticateOTP(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processAuthenticateOTP(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOTP(input: CreateOneTimePasswordDto | null | undefined): Observable<ResponseOTP> {
        let url_ = this.baseUrl + "/api/services/app/OneTimePassword/CreateOTP";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOTP(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOTP(<any>response_);
                } catch (e) {
                    return <Observable<ResponseOTP>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResponseOTP>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOTP(response: HttpResponseBase): Observable<ResponseOTP> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? ResponseOTP.fromJS(resultData200) : new ResponseOTP();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseOTP>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    verifyOTP(input: GetOneTimePasswordInput | null | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/OneTimePassword/VerifyOTP";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processVerifyOTP(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerifyOTP(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processVerifyOTP(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    resetNumberOfOTPSent(input: ResetNumberOfOTPSentDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OneTimePassword/ResetNumberOfOTPSent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processResetNumberOfOTPSent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetNumberOfOTPSent(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processResetNumberOfOTPSent(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class OrderServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param request (optional) 
     * @return Success
     */
    purchase(request: PurchaseTransactionDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Order/Purchase";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processPurchase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPurchase(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processPurchase(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class OrderMappingSMsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetOrderMappingSMForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/OrderMappingSMs/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetOrderMappingSMForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetOrderMappingSMForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetOrderMappingSMForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetOrderMappingSMForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetOrderMappingSMForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetOrderMappingSMForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getOrderMappingSMForEdit(id: number | null | undefined): Observable<GetOrderMappingSMForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/OrderMappingSMs/GetOrderMappingSMForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetOrderMappingSMForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderMappingSMForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetOrderMappingSMForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetOrderMappingSMForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetOrderMappingSMForEdit(response: HttpResponseBase): Observable<GetOrderMappingSMForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetOrderMappingSMForEditOutput.fromJS(resultData200) : new GetOrderMappingSMForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetOrderMappingSMForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditOrderMappingSMDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OrderMappingSMs/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OrderMappingSMs/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class OrdersServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param orderId (optional) 
     * @return Success
     */
    getRedemptionHistory(orderId: number | null | undefined): Observable<OrderResponse> {
        let url_ = this.baseUrl + "/api/services/app/Orders/GetRedemptionHistory?";
        if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetRedemptionHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRedemptionHistory(<any>response_);
                } catch (e) {
                    return <Observable<OrderResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<OrderResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetRedemptionHistory(response: HttpResponseBase): Observable<OrderResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? OrderResponse.fromJS(resultData200) : new OrderResponse();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderResponse>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    submitRedemptionHistory(input: OrderInput | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Orders/SubmitRedemptionHistory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSubmitRedemptionHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubmitRedemptionHistory(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processSubmitRedemptionHistory(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param orderId (optional) 
     * @return Success
     */
    getRedemptionDetail(orderId: number | null | undefined): Observable<PagedResultDtoOfOrderItemDto> {
        let url_ = this.baseUrl + "/api/services/app/Orders/GetRedemptionDetail?";
        if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetRedemptionDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRedemptionDetail(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfOrderItemDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfOrderItemDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetRedemptionDetail(response: HttpResponseBase): Observable<PagedResultDtoOfOrderItemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfOrderItemDto.fromJS(resultData200) : new PagedResultDtoOfOrderItemDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfOrderItemDto>(<any>null);
    }
}

@Injectable()
export class OrganizationUnitServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getOrganizationUnits(): Observable<ListResultDtoOfOrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/GetOrganizationUnits";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetOrganizationUnits(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganizationUnits(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfOrganizationUnitDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfOrganizationUnitDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetOrganizationUnits(response: HttpResponseBase): Observable<ListResultDtoOfOrganizationUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? ListResultDtoOfOrganizationUnitDto.fromJS(resultData200) : new ListResultDtoOfOrganizationUnitDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfOrganizationUnitDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getOrganizationUnitUsers(id: number | null | undefined, sorting: string | null | undefined, maxResultCount: number | null | undefined, skipCount: number | null | undefined): Observable<PagedResultDtoOfOrganizationUnitUserListDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/GetOrganizationUnitUsers?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetOrganizationUnitUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganizationUnitUsers(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfOrganizationUnitUserListDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfOrganizationUnitUserListDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetOrganizationUnitUsers(response: HttpResponseBase): Observable<PagedResultDtoOfOrganizationUnitUserListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfOrganizationUnitUserListDto.fromJS(resultData200) : new PagedResultDtoOfOrganizationUnitUserListDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfOrganizationUnitUserListDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrganizationUnit(input: CreateOrganizationUnitInput | null | undefined): Observable<OrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/CreateOrganizationUnit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrganizationUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrganizationUnit(<any>response_);
                } catch (e) {
                    return <Observable<OrganizationUnitDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<OrganizationUnitDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrganizationUnit(response: HttpResponseBase): Observable<OrganizationUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? OrganizationUnitDto.fromJS(resultData200) : new OrganizationUnitDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrganizationUnitDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    updateOrganizationUnit(input: UpdateOrganizationUnitInput | null | undefined): Observable<OrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/UpdateOrganizationUnit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateOrganizationUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateOrganizationUnit(<any>response_);
                } catch (e) {
                    return <Observable<OrganizationUnitDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<OrganizationUnitDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateOrganizationUnit(response: HttpResponseBase): Observable<OrganizationUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? OrganizationUnitDto.fromJS(resultData200) : new OrganizationUnitDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrganizationUnitDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    moveOrganizationUnit(input: MoveOrganizationUnitInput | null | undefined): Observable<OrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/MoveOrganizationUnit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processMoveOrganizationUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMoveOrganizationUnit(<any>response_);
                } catch (e) {
                    return <Observable<OrganizationUnitDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<OrganizationUnitDto>><any>_observableThrow(response_);
        }));
    }

    protected processMoveOrganizationUnit(response: HttpResponseBase): Observable<OrganizationUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? OrganizationUnitDto.fromJS(resultData200) : new OrganizationUnitDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrganizationUnitDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteOrganizationUnit(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/DeleteOrganizationUnit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteOrganizationUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteOrganizationUnit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteOrganizationUnit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param userId (optional) 
     * @param organizationUnitId (optional) 
     * @return Success
     */
    removeUserFromOrganizationUnit(userId: number | null | undefined, organizationUnitId: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/RemoveUserFromOrganizationUnit?";
        if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (organizationUnitId !== undefined)
            url_ += "OrganizationUnitId=" + encodeURIComponent("" + organizationUnitId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processRemoveUserFromOrganizationUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveUserFromOrganizationUnit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processRemoveUserFromOrganizationUnit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    addUsersToOrganizationUnit(input: UsersToOrganizationUnitInput | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/AddUsersToOrganizationUnit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processAddUsersToOrganizationUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddUsersToOrganizationUnit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processAddUsersToOrganizationUnit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    findUsers(input: FindOrganizationUnitUsersInput | null | undefined): Observable<PagedResultDtoOfNameValueDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/FindUsers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processFindUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFindUsers(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfNameValueDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfNameValueDto>><any>_observableThrow(response_);
        }));
    }

    protected processFindUsers(response: HttpResponseBase): Observable<PagedResultDtoOfNameValueDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfNameValueDto.fromJS(resultData200) : new PagedResultDtoOfNameValueDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfNameValueDto>(<any>null);
    }
}

@Injectable()
export class OutletInfoDetailsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param outletCodeFilter (optional) 
     * @param reasonPhoneFilter (optional) 
     * @param phoneUpdatedFilter (optional) 
     * @param maxPhoneUpdatedDateFilter (optional) 
     * @param minPhoneUpdatedDateFilter (optional) 
     * @param phoneUpdateStatusFilter (optional) 
     * @param oTPFilter (optional) 
     * @param maxGAPDistanceFilter (optional) 
     * @param minGAPDistanceFilter (optional) 
     * @param lATUpdatedFilter (optional) 
     * @param lNGUpdatedFilter (optional) 
     * @param maxAuthenOTPDateFilter (optional) 
     * @param minAuthenOTPDateFilter (optional) 
     * @param isDeleteFilter (optional) 
     * @param salesmanCodeFilter (optional) 
     * @param maxTimeSendOTPFilter (optional) 
     * @param minTimeSendOTPFilter (optional) 
     * @param homePhoneFilter (optional) 
     * @param updateTypeFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, outletCodeFilter: string | null | undefined, reasonPhoneFilter: string | null | undefined, phoneUpdatedFilter: string | null | undefined, maxPhoneUpdatedDateFilter: moment.Moment | null | undefined, minPhoneUpdatedDateFilter: moment.Moment | null | undefined, phoneUpdateStatusFilter: string | null | undefined, oTPFilter: string | null | undefined, maxGAPDistanceFilter: number | null | undefined, minGAPDistanceFilter: number | null | undefined, lATUpdatedFilter: string | null | undefined, lNGUpdatedFilter: string | null | undefined, maxAuthenOTPDateFilter: moment.Moment | null | undefined, minAuthenOTPDateFilter: moment.Moment | null | undefined, isDeleteFilter: number | null | undefined, salesmanCodeFilter: string | null | undefined, maxTimeSendOTPFilter: moment.Moment | null | undefined, minTimeSendOTPFilter: moment.Moment | null | undefined, homePhoneFilter: string | null | undefined, updateTypeFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetOutletInfoDetailForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/OutletInfoDetails/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (outletCodeFilter !== undefined)
            url_ += "OutletCodeFilter=" + encodeURIComponent("" + outletCodeFilter) + "&";
        if (reasonPhoneFilter !== undefined)
            url_ += "ReasonPhoneFilter=" + encodeURIComponent("" + reasonPhoneFilter) + "&";
        if (phoneUpdatedFilter !== undefined)
            url_ += "PhoneUpdatedFilter=" + encodeURIComponent("" + phoneUpdatedFilter) + "&";
        if (maxPhoneUpdatedDateFilter !== undefined)
            url_ += "MaxPhoneUpdatedDateFilter=" + encodeURIComponent(maxPhoneUpdatedDateFilter ? "" + maxPhoneUpdatedDateFilter.toJSON() : "") + "&";
        if (minPhoneUpdatedDateFilter !== undefined)
            url_ += "MinPhoneUpdatedDateFilter=" + encodeURIComponent(minPhoneUpdatedDateFilter ? "" + minPhoneUpdatedDateFilter.toJSON() : "") + "&";
        if (phoneUpdateStatusFilter !== undefined)
            url_ += "PhoneUpdateStatusFilter=" + encodeURIComponent("" + phoneUpdateStatusFilter) + "&";
        if (oTPFilter !== undefined)
            url_ += "OTPFilter=" + encodeURIComponent("" + oTPFilter) + "&";
        if (maxGAPDistanceFilter !== undefined)
            url_ += "MaxGAPDistanceFilter=" + encodeURIComponent("" + maxGAPDistanceFilter) + "&";
        if (minGAPDistanceFilter !== undefined)
            url_ += "MinGAPDistanceFilter=" + encodeURIComponent("" + minGAPDistanceFilter) + "&";
        if (lATUpdatedFilter !== undefined)
            url_ += "LATUpdatedFilter=" + encodeURIComponent("" + lATUpdatedFilter) + "&";
        if (lNGUpdatedFilter !== undefined)
            url_ += "LNGUpdatedFilter=" + encodeURIComponent("" + lNGUpdatedFilter) + "&";
        if (maxAuthenOTPDateFilter !== undefined)
            url_ += "MaxAuthenOTPDateFilter=" + encodeURIComponent(maxAuthenOTPDateFilter ? "" + maxAuthenOTPDateFilter.toJSON() : "") + "&";
        if (minAuthenOTPDateFilter !== undefined)
            url_ += "MinAuthenOTPDateFilter=" + encodeURIComponent(minAuthenOTPDateFilter ? "" + minAuthenOTPDateFilter.toJSON() : "") + "&";
        if (isDeleteFilter !== undefined)
            url_ += "IsDeleteFilter=" + encodeURIComponent("" + isDeleteFilter) + "&";
        if (salesmanCodeFilter !== undefined)
            url_ += "SalesmanCodeFilter=" + encodeURIComponent("" + salesmanCodeFilter) + "&";
        if (maxTimeSendOTPFilter !== undefined)
            url_ += "MaxTimeSendOTPFilter=" + encodeURIComponent(maxTimeSendOTPFilter ? "" + maxTimeSendOTPFilter.toJSON() : "") + "&";
        if (minTimeSendOTPFilter !== undefined)
            url_ += "MinTimeSendOTPFilter=" + encodeURIComponent(minTimeSendOTPFilter ? "" + minTimeSendOTPFilter.toJSON() : "") + "&";
        if (homePhoneFilter !== undefined)
            url_ += "HomePhoneFilter=" + encodeURIComponent("" + homePhoneFilter) + "&";
        if (updateTypeFilter !== undefined)
            url_ += "UpdateTypeFilter=" + encodeURIComponent("" + updateTypeFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetOutletInfoDetailForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetOutletInfoDetailForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetOutletInfoDetailForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetOutletInfoDetailForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetOutletInfoDetailForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetOutletInfoDetailForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getOutletInfoDetailForEdit(id: number | null | undefined): Observable<GetOutletInfoDetailForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/OutletInfoDetails/GetOutletInfoDetailForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetOutletInfoDetailForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOutletInfoDetailForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetOutletInfoDetailForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetOutletInfoDetailForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetOutletInfoDetailForEdit(response: HttpResponseBase): Observable<GetOutletInfoDetailForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetOutletInfoDetailForEditOutput.fromJS(resultData200) : new GetOutletInfoDetailForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetOutletInfoDetailForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditOutletInfoDetailDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OutletInfoDetails/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OutletInfoDetails/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param outletCodeFilter (optional) 
     * @param reasonPhoneFilter (optional) 
     * @param phoneUpdatedFilter (optional) 
     * @param maxPhoneUpdatedDateFilter (optional) 
     * @param minPhoneUpdatedDateFilter (optional) 
     * @param phoneUpdateStatusFilter (optional) 
     * @param oTPFilter (optional) 
     * @param maxGAPDistanceFilter (optional) 
     * @param minGAPDistanceFilter (optional) 
     * @param lATUpdatedFilter (optional) 
     * @param lNGUpdatedFilter (optional) 
     * @param maxAuthenOTPDateFilter (optional) 
     * @param minAuthenOTPDateFilter (optional) 
     * @param isDeleteFilter (optional) 
     * @param salesmanCodeFilter (optional) 
     * @param maxTimeSendOTPFilter (optional) 
     * @param minTimeSendOTPFilter (optional) 
     * @param homePhoneFilter (optional) 
     * @param updateTypeFilter (optional) 
     * @return Success
     */
    getOutletInfoDetailsToExcel(filter: string | null | undefined, outletCodeFilter: string | null | undefined, reasonPhoneFilter: string | null | undefined, phoneUpdatedFilter: string | null | undefined, maxPhoneUpdatedDateFilter: moment.Moment | null | undefined, minPhoneUpdatedDateFilter: moment.Moment | null | undefined, phoneUpdateStatusFilter: string | null | undefined, oTPFilter: string | null | undefined, maxGAPDistanceFilter: number | null | undefined, minGAPDistanceFilter: number | null | undefined, lATUpdatedFilter: string | null | undefined, lNGUpdatedFilter: string | null | undefined, maxAuthenOTPDateFilter: moment.Moment | null | undefined, minAuthenOTPDateFilter: moment.Moment | null | undefined, isDeleteFilter: number | null | undefined, salesmanCodeFilter: string | null | undefined, maxTimeSendOTPFilter: moment.Moment | null | undefined, minTimeSendOTPFilter: moment.Moment | null | undefined, homePhoneFilter: string | null | undefined, updateTypeFilter: string | null | undefined): Observable<SocialRetailerFileDto> {
        let url_ = this.baseUrl + "/api/services/app/OutletInfoDetails/GetOutletInfoDetailsToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (outletCodeFilter !== undefined)
            url_ += "OutletCodeFilter=" + encodeURIComponent("" + outletCodeFilter) + "&";
        if (reasonPhoneFilter !== undefined)
            url_ += "ReasonPhoneFilter=" + encodeURIComponent("" + reasonPhoneFilter) + "&";
        if (phoneUpdatedFilter !== undefined)
            url_ += "PhoneUpdatedFilter=" + encodeURIComponent("" + phoneUpdatedFilter) + "&";
        if (maxPhoneUpdatedDateFilter !== undefined)
            url_ += "MaxPhoneUpdatedDateFilter=" + encodeURIComponent(maxPhoneUpdatedDateFilter ? "" + maxPhoneUpdatedDateFilter.toJSON() : "") + "&";
        if (minPhoneUpdatedDateFilter !== undefined)
            url_ += "MinPhoneUpdatedDateFilter=" + encodeURIComponent(minPhoneUpdatedDateFilter ? "" + minPhoneUpdatedDateFilter.toJSON() : "") + "&";
        if (phoneUpdateStatusFilter !== undefined)
            url_ += "PhoneUpdateStatusFilter=" + encodeURIComponent("" + phoneUpdateStatusFilter) + "&";
        if (oTPFilter !== undefined)
            url_ += "OTPFilter=" + encodeURIComponent("" + oTPFilter) + "&";
        if (maxGAPDistanceFilter !== undefined)
            url_ += "MaxGAPDistanceFilter=" + encodeURIComponent("" + maxGAPDistanceFilter) + "&";
        if (minGAPDistanceFilter !== undefined)
            url_ += "MinGAPDistanceFilter=" + encodeURIComponent("" + minGAPDistanceFilter) + "&";
        if (lATUpdatedFilter !== undefined)
            url_ += "LATUpdatedFilter=" + encodeURIComponent("" + lATUpdatedFilter) + "&";
        if (lNGUpdatedFilter !== undefined)
            url_ += "LNGUpdatedFilter=" + encodeURIComponent("" + lNGUpdatedFilter) + "&";
        if (maxAuthenOTPDateFilter !== undefined)
            url_ += "MaxAuthenOTPDateFilter=" + encodeURIComponent(maxAuthenOTPDateFilter ? "" + maxAuthenOTPDateFilter.toJSON() : "") + "&";
        if (minAuthenOTPDateFilter !== undefined)
            url_ += "MinAuthenOTPDateFilter=" + encodeURIComponent(minAuthenOTPDateFilter ? "" + minAuthenOTPDateFilter.toJSON() : "") + "&";
        if (isDeleteFilter !== undefined)
            url_ += "IsDeleteFilter=" + encodeURIComponent("" + isDeleteFilter) + "&";
        if (salesmanCodeFilter !== undefined)
            url_ += "SalesmanCodeFilter=" + encodeURIComponent("" + salesmanCodeFilter) + "&";
        if (maxTimeSendOTPFilter !== undefined)
            url_ += "MaxTimeSendOTPFilter=" + encodeURIComponent(maxTimeSendOTPFilter ? "" + maxTimeSendOTPFilter.toJSON() : "") + "&";
        if (minTimeSendOTPFilter !== undefined)
            url_ += "MinTimeSendOTPFilter=" + encodeURIComponent(minTimeSendOTPFilter ? "" + minTimeSendOTPFilter.toJSON() : "") + "&";
        if (homePhoneFilter !== undefined)
            url_ += "HomePhoneFilter=" + encodeURIComponent("" + homePhoneFilter) + "&";
        if (updateTypeFilter !== undefined)
            url_ += "UpdateTypeFilter=" + encodeURIComponent("" + updateTypeFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetOutletInfoDetailsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOutletInfoDetailsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<SocialRetailerFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SocialRetailerFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetOutletInfoDetailsToExcel(response: HttpResponseBase): Observable<SocialRetailerFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? SocialRetailerFileDto.fromJS(resultData200) : new SocialRetailerFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SocialRetailerFileDto>(<any>null);
    }
}

@Injectable()
export class OutletInfomationPhoneServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param ids (optional) 
     * @param name (optional) 
     * @param phone (optional) 
     * @param outletType (optional) 
     * @param statusFilter (optional) 
     * @param phoneUpdateStatusFilter (optional) 
     * @param maxPhoneUpdatedDateFilter (optional) 
     * @param minPhoneUpdatedDateFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllRetailerUpdatePhone(filter: string | null | undefined, ids: number[] | null | undefined, name: string | null | undefined, phone: string | null | undefined, outletType: string | null | undefined, statusFilter: string | null | undefined, phoneUpdateStatusFilter: string | null | undefined, maxPhoneUpdatedDateFilter: moment.Moment | null | undefined, minPhoneUpdatedDateFilter: moment.Moment | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetOutletInfoForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/OutletInfomationPhone/GetAllRetailerUpdatePhone?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (ids !== undefined)
            ids && ids.forEach(item => { url_ += "Ids=" + encodeURIComponent("" + item) + "&"; });
        if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (phone !== undefined)
            url_ += "Phone=" + encodeURIComponent("" + phone) + "&";
        if (outletType !== undefined)
            url_ += "OutletType=" + encodeURIComponent("" + outletType) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (phoneUpdateStatusFilter !== undefined)
            url_ += "PhoneUpdateStatusFilter=" + encodeURIComponent("" + phoneUpdateStatusFilter) + "&";
        if (maxPhoneUpdatedDateFilter !== undefined)
            url_ += "MaxPhoneUpdatedDateFilter=" + encodeURIComponent(maxPhoneUpdatedDateFilter ? "" + maxPhoneUpdatedDateFilter.toJSON() : "") + "&";
        if (minPhoneUpdatedDateFilter !== undefined)
            url_ += "MinPhoneUpdatedDateFilter=" + encodeURIComponent(minPhoneUpdatedDateFilter ? "" + minPhoneUpdatedDateFilter.toJSON() : "") + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllRetailerUpdatePhone(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllRetailerUpdatePhone(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetOutletInfoForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetOutletInfoForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllRetailerUpdatePhone(response: HttpResponseBase): Observable<PagedResultDtoOfGetOutletInfoForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetOutletInfoForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetOutletInfoForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetOutletInfoForViewDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param ids (optional) 
     * @param name (optional) 
     * @param phone (optional) 
     * @param outletType (optional) 
     * @param statusFilter (optional) 
     * @param phoneUpdateStatusFilter (optional) 
     * @param maxPhoneUpdatedDateFilter (optional) 
     * @param minPhoneUpdatedDateFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllRetailerUpdatePhone_ByName(filter: string | null | undefined, ids: number[] | null | undefined, name: string | null | undefined, phone: string | null | undefined, outletType: string | null | undefined, statusFilter: string | null | undefined, phoneUpdateStatusFilter: string | null | undefined, maxPhoneUpdatedDateFilter: moment.Moment | null | undefined, minPhoneUpdatedDateFilter: moment.Moment | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetOutletInfoForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/OutletInfomationPhone/GetAllRetailerUpdatePhone_ByName?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (ids !== undefined)
            ids && ids.forEach(item => { url_ += "Ids=" + encodeURIComponent("" + item) + "&"; });
        if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (phone !== undefined)
            url_ += "Phone=" + encodeURIComponent("" + phone) + "&";
        if (outletType !== undefined)
            url_ += "OutletType=" + encodeURIComponent("" + outletType) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (phoneUpdateStatusFilter !== undefined)
            url_ += "PhoneUpdateStatusFilter=" + encodeURIComponent("" + phoneUpdateStatusFilter) + "&";
        if (maxPhoneUpdatedDateFilter !== undefined)
            url_ += "MaxPhoneUpdatedDateFilter=" + encodeURIComponent(maxPhoneUpdatedDateFilter ? "" + maxPhoneUpdatedDateFilter.toJSON() : "") + "&";
        if (minPhoneUpdatedDateFilter !== undefined)
            url_ += "MinPhoneUpdatedDateFilter=" + encodeURIComponent(minPhoneUpdatedDateFilter ? "" + minPhoneUpdatedDateFilter.toJSON() : "") + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllRetailerUpdatePhone_ByName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllRetailerUpdatePhone_ByName(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetOutletInfoForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetOutletInfoForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllRetailerUpdatePhone_ByName(response: HttpResponseBase): Observable<PagedResultDtoOfGetOutletInfoForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetOutletInfoForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetOutletInfoForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetOutletInfoForViewDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param ids (optional) 
     * @param name (optional) 
     * @param phone (optional) 
     * @param outletType (optional) 
     * @param statusFilter (optional) 
     * @param phoneUpdateStatusFilter (optional) 
     * @param maxPhoneUpdatedDateFilter (optional) 
     * @param minPhoneUpdatedDateFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllRetailerUpdatePhone_Simple(filter: string | null | undefined, ids: number[] | null | undefined, name: string | null | undefined, phone: string | null | undefined, outletType: string | null | undefined, statusFilter: string | null | undefined, phoneUpdateStatusFilter: string | null | undefined, maxPhoneUpdatedDateFilter: moment.Moment | null | undefined, minPhoneUpdatedDateFilter: moment.Moment | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<GetAllOutletNoFilterDto[]> {
        let url_ = this.baseUrl + "/api/services/app/OutletInfomationPhone/GetAllRetailerUpdatePhone_Simple?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (ids !== undefined)
            ids && ids.forEach(item => { url_ += "Ids=" + encodeURIComponent("" + item) + "&"; });
        if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (phone !== undefined)
            url_ += "Phone=" + encodeURIComponent("" + phone) + "&";
        if (outletType !== undefined)
            url_ += "OutletType=" + encodeURIComponent("" + outletType) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (phoneUpdateStatusFilter !== undefined)
            url_ += "PhoneUpdateStatusFilter=" + encodeURIComponent("" + phoneUpdateStatusFilter) + "&";
        if (maxPhoneUpdatedDateFilter !== undefined)
            url_ += "MaxPhoneUpdatedDateFilter=" + encodeURIComponent(maxPhoneUpdatedDateFilter ? "" + maxPhoneUpdatedDateFilter.toJSON() : "") + "&";
        if (minPhoneUpdatedDateFilter !== undefined)
            url_ += "MinPhoneUpdatedDateFilter=" + encodeURIComponent(minPhoneUpdatedDateFilter ? "" + minPhoneUpdatedDateFilter.toJSON() : "") + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllRetailerUpdatePhone_Simple(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllRetailerUpdatePhone_Simple(<any>response_);
                } catch (e) {
                    return <Observable<GetAllOutletNoFilterDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetAllOutletNoFilterDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllRetailerUpdatePhone_Simple(response: HttpResponseBase): Observable<GetAllOutletNoFilterDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(GetAllOutletNoFilterDto.fromJS(item));
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAllOutletNoFilterDto[]>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param ids (optional) 
     * @param name (optional) 
     * @param phone (optional) 
     * @param outletType (optional) 
     * @param statusFilter (optional) 
     * @param phoneUpdateStatusFilter (optional) 
     * @param maxPhoneUpdatedDateFilter (optional) 
     * @param minPhoneUpdatedDateFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllRetailerUpdatePhoneNoPaging(filter: string | null | undefined, ids: number[] | null | undefined, name: string | null | undefined, phone: string | null | undefined, outletType: string | null | undefined, statusFilter: string | null | undefined, phoneUpdateStatusFilter: string | null | undefined, maxPhoneUpdatedDateFilter: moment.Moment | null | undefined, minPhoneUpdatedDateFilter: moment.Moment | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetOutletInfoForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/OutletInfomationPhone/GetAllRetailerUpdatePhoneNoPaging?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (ids !== undefined)
            ids && ids.forEach(item => { url_ += "Ids=" + encodeURIComponent("" + item) + "&"; });
        if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (phone !== undefined)
            url_ += "Phone=" + encodeURIComponent("" + phone) + "&";
        if (outletType !== undefined)
            url_ += "OutletType=" + encodeURIComponent("" + outletType) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (phoneUpdateStatusFilter !== undefined)
            url_ += "PhoneUpdateStatusFilter=" + encodeURIComponent("" + phoneUpdateStatusFilter) + "&";
        if (maxPhoneUpdatedDateFilter !== undefined)
            url_ += "MaxPhoneUpdatedDateFilter=" + encodeURIComponent(maxPhoneUpdatedDateFilter ? "" + maxPhoneUpdatedDateFilter.toJSON() : "") + "&";
        if (minPhoneUpdatedDateFilter !== undefined)
            url_ += "MinPhoneUpdatedDateFilter=" + encodeURIComponent(minPhoneUpdatedDateFilter ? "" + minPhoneUpdatedDateFilter.toJSON() : "") + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllRetailerUpdatePhoneNoPaging(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllRetailerUpdatePhoneNoPaging(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetOutletInfoForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetOutletInfoForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllRetailerUpdatePhoneNoPaging(response: HttpResponseBase): Observable<PagedResultDtoOfGetOutletInfoForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetOutletInfoForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetOutletInfoForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetOutletInfoForViewDto>(<any>null);
    }

    /**
     * @param ids (optional) 
     * @return Success
     */
    batchDeleteRetailer(ids: string[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OutletInfomationPhone/BatchDeleteRetailer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ids);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processBatchDeleteRetailer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBatchDeleteRetailer(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processBatchDeleteRetailer(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    exportCustomRetailer(input: GetAllRetailerUpdatePhoneInput | null | undefined): Observable<SocialRetailerFileDto> {
        let url_ = this.baseUrl + "/api/services/app/OutletInfomationPhone/ExportCustomRetailer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processExportCustomRetailer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportCustomRetailer(<any>response_);
                } catch (e) {
                    return <Observable<SocialRetailerFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SocialRetailerFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processExportCustomRetailer(response: HttpResponseBase): Observable<SocialRetailerFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? SocialRetailerFileDto.fromJS(resultData200) : new SocialRetailerFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SocialRetailerFileDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @param memberCode (optional) 
     * @param requestCode (optional) 
     * @param requestType (optional) 
     * @param phone (optional) 
     * @return Success
     */
    getRetailerForEdit(id: number | null | undefined, memberCode: string | null | undefined, requestCode: string | null | undefined, requestType: number | null | undefined, phone: string | null | undefined): Observable<GetOutletInfoForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/OutletInfomationPhone/GetRetailerForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (memberCode !== undefined)
            url_ += "MemberCode=" + encodeURIComponent("" + memberCode) + "&";
        if (requestCode !== undefined)
            url_ += "RequestCode=" + encodeURIComponent("" + requestCode) + "&";
        if (requestType !== undefined)
            url_ += "RequestType=" + encodeURIComponent("" + requestType) + "&";
        if (phone !== undefined)
            url_ += "Phone=" + encodeURIComponent("" + phone) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetRetailerForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRetailerForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetOutletInfoForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetOutletInfoForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetRetailerForEdit(response: HttpResponseBase): Observable<GetOutletInfoForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetOutletInfoForEditOutput.fromJS(resultData200) : new GetOutletInfoForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetOutletInfoForEditOutput>(<any>null);
    }

    /**
     * @param id (optional) 
     * @param memberCode (optional) 
     * @param requestCode (optional) 
     * @param requestType (optional) 
     * @param phone (optional) 
     * @return Success
     */
    getRetailerForView(id: number | null | undefined, memberCode: string | null | undefined, requestCode: string | null | undefined, requestType: number | null | undefined, phone: string | null | undefined): Observable<GetOutletInfoForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/OutletInfomationPhone/GetRetailerForView?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (memberCode !== undefined)
            url_ += "MemberCode=" + encodeURIComponent("" + memberCode) + "&";
        if (requestCode !== undefined)
            url_ += "RequestCode=" + encodeURIComponent("" + requestCode) + "&";
        if (requestType !== undefined)
            url_ += "RequestType=" + encodeURIComponent("" + requestType) + "&";
        if (phone !== undefined)
            url_ += "Phone=" + encodeURIComponent("" + phone) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetRetailerForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRetailerForView(<any>response_);
                } catch (e) {
                    return <Observable<GetOutletInfoForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetOutletInfoForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetRetailerForView(response: HttpResponseBase): Observable<GetOutletInfoForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetOutletInfoForEditOutput.fromJS(resultData200) : new GetOutletInfoForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetOutletInfoForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOutlet(input: CreateOrEditOutletInfoDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OutletInfomationPhone/CreateOutlet";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOutlet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOutlet(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOutlet(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    editOutlet(input: CreateOrEditOutletInfoDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OutletInfomationPhone/EditOutlet";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processEditOutlet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditOutlet(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processEditOutlet(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    editGeoOutlet(input: GeoOutletDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OutletInfomationPhone/EditGeoOutlet";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processEditGeoOutlet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditGeoOutlet(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processEditGeoOutlet(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param arg (optional) 
     * @return Success
     */
    importQueueRetailer(arg: OutletInfosImportAgrs | null | undefined): Observable<CommonImportFileResponse> {
        let url_ = this.baseUrl + "/api/services/app/OutletInfomationPhone/ImportQueueRetailer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(arg);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processImportQueueRetailer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportQueueRetailer(<any>response_);
                } catch (e) {
                    return <Observable<CommonImportFileResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<CommonImportFileResponse>><any>_observableThrow(response_);
        }));
    }

    protected processImportQueueRetailer(response: HttpResponseBase): Observable<CommonImportFileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? CommonImportFileResponse.fromJS(resultData200) : new CommonImportFileResponse();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CommonImportFileResponse>(<any>null);
    }

    /**
     * @param salesmanCode (optional) 
     * @param type (optional) 
     * @return Success
     */
    getOutletToVisit(salesmanCode: string | null | undefined, type: string | null | undefined): Observable<PagedResultDtoOfGetOutletToVisitDto> {
        let url_ = this.baseUrl + "/api/services/app/OutletInfomationPhone/GetOutletToVisit?";
        if (salesmanCode !== undefined)
            url_ += "salesmanCode=" + encodeURIComponent("" + salesmanCode) + "&";
        if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetOutletToVisit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOutletToVisit(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetOutletToVisitDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetOutletToVisitDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetOutletToVisit(response: HttpResponseBase): Observable<PagedResultDtoOfGetOutletToVisitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetOutletToVisitDto.fromJS(resultData200) : new PagedResultDtoOfGetOutletToVisitDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetOutletToVisitDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    checkIn(input: CheckInRequestDto | null | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/OutletInfomationPhone/CheckIn";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCheckIn(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckIn(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processCheckIn(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    checkOutVisit(input: CheckOutVisitDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OutletInfomationPhone/CheckOutVisit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCheckOutVisit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckOutVisit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCheckOutVisit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    checkOutPosm(input: CheckOutPosmDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OutletInfomationPhone/CheckOutPosm";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCheckOutPosm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckOutPosm(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCheckOutPosm(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param memberCode (optional) 
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @return Success
     */
    sendReportToOutlet(memberCode: string | null | undefined, fromDate: moment.Moment | null | undefined, toDate: moment.Moment | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/OutletInfomationPhone/SendReportToOutlet?";
        if (memberCode !== undefined)
            url_ += "memberCode=" + encodeURIComponent("" + memberCode) + "&";
        if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toJSON() : "") + "&";
        if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent(toDate ? "" + toDate.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSendReportToOutlet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendReportToOutlet(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processSendReportToOutlet(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param id (optional) 
     * @param memberCode (optional) 
     * @param requestCode (optional) 
     * @param requestType (optional) 
     * @param phone (optional) 
     * @return Success
     */
    getRetailerForEditForApp(id: number | null | undefined, memberCode: string | null | undefined, requestCode: string | null | undefined, requestType: number | null | undefined, phone: string | null | undefined): Observable<GetOutletInfoForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/OutletInfomationPhone/GetRetailerForEditForApp?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (memberCode !== undefined)
            url_ += "MemberCode=" + encodeURIComponent("" + memberCode) + "&";
        if (requestCode !== undefined)
            url_ += "RequestCode=" + encodeURIComponent("" + requestCode) + "&";
        if (requestType !== undefined)
            url_ += "RequestType=" + encodeURIComponent("" + requestType) + "&";
        if (phone !== undefined)
            url_ += "Phone=" + encodeURIComponent("" + phone) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetRetailerForEditForApp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRetailerForEditForApp(<any>response_);
                } catch (e) {
                    return <Observable<GetOutletInfoForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetOutletInfoForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetRetailerForEditForApp(response: HttpResponseBase): Observable<GetOutletInfoForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetOutletInfoForEditOutput.fromJS(resultData200) : new GetOutletInfoForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetOutletInfoForEditOutput>(<any>null);
    }

    /**
     * @param id (optional) 
     * @param memberCode (optional) 
     * @param requestCode (optional) 
     * @param requestType (optional) 
     * @param phone (optional) 
     * @return Success
     */
    getRetailerForViewForApp(id: number | null | undefined, memberCode: string | null | undefined, requestCode: string | null | undefined, requestType: number | null | undefined, phone: string | null | undefined): Observable<GetOutletInfoForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/OutletInfomationPhone/GetRetailerForViewForApp?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (memberCode !== undefined)
            url_ += "MemberCode=" + encodeURIComponent("" + memberCode) + "&";
        if (requestCode !== undefined)
            url_ += "RequestCode=" + encodeURIComponent("" + requestCode) + "&";
        if (requestType !== undefined)
            url_ += "RequestType=" + encodeURIComponent("" + requestType) + "&";
        if (phone !== undefined)
            url_ += "Phone=" + encodeURIComponent("" + phone) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetRetailerForViewForApp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRetailerForViewForApp(<any>response_);
                } catch (e) {
                    return <Observable<GetOutletInfoForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetOutletInfoForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetRetailerForViewForApp(response: HttpResponseBase): Observable<GetOutletInfoForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetOutletInfoForEditOutput.fromJS(resultData200) : new GetOutletInfoForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetOutletInfoForEditOutput>(<any>null);
    }

    /**
     * @param provinceCode (optional) 
     * @param regionCode (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllDistributorSystem(provinceCode: string | null | undefined, regionCode: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfDistributorInforResource> {
        let url_ = this.baseUrl + "/api/services/app/OutletInfomationPhone/GetAllDistributorSystem?";
        if (provinceCode !== undefined)
            url_ += "ProvinceCode=" + encodeURIComponent("" + provinceCode) + "&";
        if (regionCode !== undefined)
            url_ += "RegionCode=" + encodeURIComponent("" + regionCode) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllDistributorSystem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllDistributorSystem(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfDistributorInforResource>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfDistributorInforResource>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllDistributorSystem(response: HttpResponseBase): Observable<PagedResultDtoOfDistributorInforResource> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfDistributorInforResource.fromJS(resultData200) : new PagedResultDtoOfDistributorInforResource();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfDistributorInforResource>(<any>null);
    }

    /**
     * @return Success
     */
    checkAllowLoginMicrosoft(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/OutletInfomationPhone/CheckAllowLoginMicrosoft";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCheckAllowLoginMicrosoft(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckAllowLoginMicrosoft(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processCheckAllowLoginMicrosoft(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEditDistributorAccount(input: CreateOrEditOutletInfoDto | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/OutletInfomationPhone/CreateOrEditDistributorAccount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEditDistributorAccount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditDistributorAccount(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEditDistributorAccount(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param ids (optional) 
     * @param name (optional) 
     * @param statusFilter (optional) 
     * @param phoneUpdateStatusFilter (optional) 
     * @param maxPhoneUpdatedDateFilter (optional) 
     * @param minPhoneUpdatedDateFilter (optional) 
     * @param isSearch (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllRetailerReportPhoneAsync(filter: string | null | undefined, ids: number[] | null | undefined, name: string | null | undefined, statusFilter: string | null | undefined, phoneUpdateStatusFilter: string | null | undefined, maxPhoneUpdatedDateFilter: moment.Moment | null | undefined, minPhoneUpdatedDateFilter: moment.Moment | null | undefined, isSearch: boolean | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetRetailerReportPhoneForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/OutletInfomationPhone/GetAllRetailerReportPhoneAsync?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (ids !== undefined)
            ids && ids.forEach(item => { url_ += "Ids=" + encodeURIComponent("" + item) + "&"; });
        if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (phoneUpdateStatusFilter !== undefined)
            url_ += "PhoneUpdateStatusFilter=" + encodeURIComponent("" + phoneUpdateStatusFilter) + "&";
        if (maxPhoneUpdatedDateFilter !== undefined)
            url_ += "MaxPhoneUpdatedDateFilter=" + encodeURIComponent(maxPhoneUpdatedDateFilter ? "" + maxPhoneUpdatedDateFilter.toJSON() : "") + "&";
        if (minPhoneUpdatedDateFilter !== undefined)
            url_ += "MinPhoneUpdatedDateFilter=" + encodeURIComponent(minPhoneUpdatedDateFilter ? "" + minPhoneUpdatedDateFilter.toJSON() : "") + "&";
        if (isSearch !== undefined)
            url_ += "isSearch=" + encodeURIComponent("" + isSearch) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllRetailerReportPhoneAsync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllRetailerReportPhoneAsync(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetRetailerReportPhoneForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetRetailerReportPhoneForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllRetailerReportPhoneAsync(response: HttpResponseBase): Observable<PagedResultDtoOfGetRetailerReportPhoneForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetRetailerReportPhoneForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetRetailerReportPhoneForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetRetailerReportPhoneForViewDto>(<any>null);
    }

    /**
     * @param arg (optional) 
     * @return Success
     */
    exportQueueRetailerReportPhoneAsync(arg: RetailerReportPhoneExportEventData | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OutletInfomationPhone/ExportQueueRetailerReportPhoneAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(arg);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processExportQueueRetailerReportPhoneAsync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportQueueRetailerReportPhoneAsync(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processExportQueueRetailerReportPhoneAsync(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param arg (optional) 
     * @return Success
     */
    exportQueueRetailerReportPhoneUpdateAsync(arg: RetailerReportPhoneExportEventData | null | undefined): Observable<SocialRetailerFileDto> {
        let url_ = this.baseUrl + "/api/services/app/OutletInfomationPhone/ExportQueueRetailerReportPhoneUpdateAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(arg);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processExportQueueRetailerReportPhoneUpdateAsync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportQueueRetailerReportPhoneUpdateAsync(<any>response_);
                } catch (e) {
                    return <Observable<SocialRetailerFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SocialRetailerFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processExportQueueRetailerReportPhoneUpdateAsync(response: HttpResponseBase): Observable<SocialRetailerFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? SocialRetailerFileDto.fromJS(resultData200) : new SocialRetailerFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SocialRetailerFileDto>(<any>null);
    }
}

@Injectable()
export class OutletInfosServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param memberCodeFilter (optional) 
     * @param nameFilter (optional) 
     * @param phoneFilter (optional) 
     * @param lNGFilter (optional) 
     * @param lATFilter (optional) 
     * @param emailFilter (optional) 
     * @param genderFilter (optional) 
     * @param maxBirthdayFilter (optional) 
     * @param minBirthdayFilter (optional) 
     * @param maxRegistrationDateFilter (optional) 
     * @param minRegistrationDateFilter (optional) 
     * @param pIDFilter (optional) 
     * @param sourceIDFilter (optional) 
     * @param receiveAdsFilter (optional) 
     * @param rankCodeFilter (optional) 
     * @param maxRankValidDateFilter (optional) 
     * @param minRankValidDateFilter (optional) 
     * @param maxCurrentPointFilter (optional) 
     * @param minCurrentPointFilter (optional) 
     * @param nationalityCodeFilter (optional) 
     * @param occupationCodeFilter (optional) 
     * @param hobbyFilter (optional) 
     * @param addressFilter (optional) 
     * @param wardFilter (optional) 
     * @param districtFilter (optional) 
     * @param provinceFilter (optional) 
     * @param countryFilter (optional) 
     * @param statusFilter (optional) 
     * @param maxLastActivityTimeFilter (optional) 
     * @param minLastActivityTimeFilter (optional) 
     * @param maxLastPurchaseTimeFilter (optional) 
     * @param minLastPurchaseTimeFilter (optional) 
     * @param communicationChannelsFilter (optional) 
     * @param communicationLanguageFilter (optional) 
     * @param notesFilter (optional) 
     * @param rankProposeFilter (optional) 
     * @param pINCodeFilter (optional) 
     * @param nameUnSignFilter (optional) 
     * @param avatarFilter (optional) 
     * @param workingPermitFilter (optional) 
     * @param customerCodeFilter (optional) 
     * @param interestOfFilter (optional) 
     * @param isInterestCobrandFilter (optional) 
     * @param memberCardFilter (optional) 
     * @param isForeignerFilter (optional) 
     * @param isSyncedFilter (optional) 
     * @param referralCodeFilter (optional) 
     * @param maxAccumulationPointFilter (optional) 
     * @param minAccumulationPointFilter (optional) 
     * @param outletCodeFilter (optional) 
     * @param zaloNameFilter (optional) 
     * @param distributorCodeFilter (optional) 
     * @param distributorNameFilter (optional) 
     * @param regionCodeFilter (optional) 
     * @param maxTargetRevenueFilter (optional) 
     * @param minTargetRevenueFilter (optional) 
     * @param maxActualRevenueFilter (optional) 
     * @param minActualRevenueFilter (optional) 
     * @param maxBonusFilter (optional) 
     * @param minBonusFilter (optional) 
     * @param maxMissingRevenueFilter (optional) 
     * @param minMissingRevenueFilter (optional) 
     * @param maxRevenueUpdateDateFilter (optional) 
     * @param minRevenueUpdateDateFilter (optional) 
     * @param note1Filter (optional) 
     * @param note2Filter (optional) 
     * @param note3Filter (optional) 
     * @param note4Filter (optional) 
     * @param note5Filter (optional) 
     * @param salesChannelFilter (optional) 
     * @param supervisorCodeFilter (optional) 
     * @param supervisorNameFilter (optional) 
     * @param maxPhoneFirstDateFilter (optional) 
     * @param minPhoneFirstDateFilter (optional) 
     * @param lockUpdatePhoneFilter (optional) 
     * @param browserCodeFilter (optional) 
     * @param deviceNameCodeFilter (optional) 
     * @param typeOfDeviceCodeFilter (optional) 
     * @param salesmanCodeFilter (optional) 
     * @param maxConsumerIDFilter (optional) 
     * @param minConsumerIDFilter (optional) 
     * @param lockUpdateChatIDFilter (optional) 
     * @param maxCurrentCoinFilter (optional) 
     * @param minCurrentCoinFilter (optional) 
     * @param maxPointToKeepRankFilter (optional) 
     * @param minPointToKeepRankFilter (optional) 
     * @param maxPointToNextRankFilter (optional) 
     * @param minPointToNextRankFilter (optional) 
     * @param maxExpiringCoinFilter (optional) 
     * @param minExpiringCoinFilter (optional) 
     * @param maxExpiringCoinDateFilter (optional) 
     * @param minExpiringCoinDateFilter (optional) 
     * @param lockUpdateProfileFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, memberCodeFilter: string | null | undefined, nameFilter: string | null | undefined, phoneFilter: string | null | undefined, lNGFilter: string | null | undefined, lATFilter: string | null | undefined, emailFilter: string | null | undefined, genderFilter: string | null | undefined, maxBirthdayFilter: number | null | undefined, minBirthdayFilter: number | null | undefined, maxRegistrationDateFilter: number | null | undefined, minRegistrationDateFilter: number | null | undefined, pIDFilter: string | null | undefined, sourceIDFilter: string | null | undefined, receiveAdsFilter: number | null | undefined, rankCodeFilter: string | null | undefined, maxRankValidDateFilter: number | null | undefined, minRankValidDateFilter: number | null | undefined, maxCurrentPointFilter: number | null | undefined, minCurrentPointFilter: number | null | undefined, nationalityCodeFilter: string | null | undefined, occupationCodeFilter: string | null | undefined, hobbyFilter: string | null | undefined, addressFilter: string | null | undefined, wardFilter: string | null | undefined, districtFilter: string | null | undefined, provinceFilter: string | null | undefined, countryFilter: string | null | undefined, statusFilter: string | null | undefined, maxLastActivityTimeFilter: moment.Moment | null | undefined, minLastActivityTimeFilter: moment.Moment | null | undefined, maxLastPurchaseTimeFilter: moment.Moment | null | undefined, minLastPurchaseTimeFilter: moment.Moment | null | undefined, communicationChannelsFilter: string | null | undefined, communicationLanguageFilter: string | null | undefined, notesFilter: string | null | undefined, rankProposeFilter: string | null | undefined, pINCodeFilter: string | null | undefined, nameUnSignFilter: string | null | undefined, avatarFilter: string | null | undefined, workingPermitFilter: number | null | undefined, customerCodeFilter: string | null | undefined, interestOfFilter: string | null | undefined, isInterestCobrandFilter: number | null | undefined, memberCardFilter: string | null | undefined, isForeignerFilter: number | null | undefined, isSyncedFilter: number | null | undefined, referralCodeFilter: string | null | undefined, maxAccumulationPointFilter: number | null | undefined, minAccumulationPointFilter: number | null | undefined, outletCodeFilter: string | null | undefined, zaloNameFilter: string | null | undefined, distributorCodeFilter: string | null | undefined, distributorNameFilter: string | null | undefined, regionCodeFilter: string | null | undefined, maxTargetRevenueFilter: number | null | undefined, minTargetRevenueFilter: number | null | undefined, maxActualRevenueFilter: number | null | undefined, minActualRevenueFilter: number | null | undefined, maxBonusFilter: number | null | undefined, minBonusFilter: number | null | undefined, maxMissingRevenueFilter: number | null | undefined, minMissingRevenueFilter: number | null | undefined, maxRevenueUpdateDateFilter: number | null | undefined, minRevenueUpdateDateFilter: number | null | undefined, note1Filter: string | null | undefined, note2Filter: string | null | undefined, note3Filter: string | null | undefined, note4Filter: string | null | undefined, note5Filter: string | null | undefined, salesChannelFilter: string | null | undefined, supervisorCodeFilter: string | null | undefined, supervisorNameFilter: string | null | undefined, maxPhoneFirstDateFilter: moment.Moment | null | undefined, minPhoneFirstDateFilter: moment.Moment | null | undefined, lockUpdatePhoneFilter: number | null | undefined, browserCodeFilter: string | null | undefined, deviceNameCodeFilter: string | null | undefined, typeOfDeviceCodeFilter: string | null | undefined, salesmanCodeFilter: string | null | undefined, maxConsumerIDFilter: number | null | undefined, minConsumerIDFilter: number | null | undefined, lockUpdateChatIDFilter: number | null | undefined, maxCurrentCoinFilter: number | null | undefined, minCurrentCoinFilter: number | null | undefined, maxPointToKeepRankFilter: number | null | undefined, minPointToKeepRankFilter: number | null | undefined, maxPointToNextRankFilter: number | null | undefined, minPointToNextRankFilter: number | null | undefined, maxExpiringCoinFilter: number | null | undefined, minExpiringCoinFilter: number | null | undefined, maxExpiringCoinDateFilter: moment.Moment | null | undefined, minExpiringCoinDateFilter: moment.Moment | null | undefined, lockUpdateProfileFilter: number | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetOutletInfoForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/OutletInfos/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (memberCodeFilter !== undefined)
            url_ += "MemberCodeFilter=" + encodeURIComponent("" + memberCodeFilter) + "&";
        if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (phoneFilter !== undefined)
            url_ += "PhoneFilter=" + encodeURIComponent("" + phoneFilter) + "&";
        if (lNGFilter !== undefined)
            url_ += "LNGFilter=" + encodeURIComponent("" + lNGFilter) + "&";
        if (lATFilter !== undefined)
            url_ += "LATFilter=" + encodeURIComponent("" + lATFilter) + "&";
        if (emailFilter !== undefined)
            url_ += "EmailFilter=" + encodeURIComponent("" + emailFilter) + "&";
        if (genderFilter !== undefined)
            url_ += "GenderFilter=" + encodeURIComponent("" + genderFilter) + "&";
        if (maxBirthdayFilter !== undefined)
            url_ += "MaxBirthdayFilter=" + encodeURIComponent("" + maxBirthdayFilter) + "&";
        if (minBirthdayFilter !== undefined)
            url_ += "MinBirthdayFilter=" + encodeURIComponent("" + minBirthdayFilter) + "&";
        if (maxRegistrationDateFilter !== undefined)
            url_ += "MaxRegistrationDateFilter=" + encodeURIComponent("" + maxRegistrationDateFilter) + "&";
        if (minRegistrationDateFilter !== undefined)
            url_ += "MinRegistrationDateFilter=" + encodeURIComponent("" + minRegistrationDateFilter) + "&";
        if (pIDFilter !== undefined)
            url_ += "PIDFilter=" + encodeURIComponent("" + pIDFilter) + "&";
        if (sourceIDFilter !== undefined)
            url_ += "SourceIDFilter=" + encodeURIComponent("" + sourceIDFilter) + "&";
        if (receiveAdsFilter !== undefined)
            url_ += "ReceiveAdsFilter=" + encodeURIComponent("" + receiveAdsFilter) + "&";
        if (rankCodeFilter !== undefined)
            url_ += "RankCodeFilter=" + encodeURIComponent("" + rankCodeFilter) + "&";
        if (maxRankValidDateFilter !== undefined)
            url_ += "MaxRankValidDateFilter=" + encodeURIComponent("" + maxRankValidDateFilter) + "&";
        if (minRankValidDateFilter !== undefined)
            url_ += "MinRankValidDateFilter=" + encodeURIComponent("" + minRankValidDateFilter) + "&";
        if (maxCurrentPointFilter !== undefined)
            url_ += "MaxCurrentPointFilter=" + encodeURIComponent("" + maxCurrentPointFilter) + "&";
        if (minCurrentPointFilter !== undefined)
            url_ += "MinCurrentPointFilter=" + encodeURIComponent("" + minCurrentPointFilter) + "&";
        if (nationalityCodeFilter !== undefined)
            url_ += "NationalityCodeFilter=" + encodeURIComponent("" + nationalityCodeFilter) + "&";
        if (occupationCodeFilter !== undefined)
            url_ += "OccupationCodeFilter=" + encodeURIComponent("" + occupationCodeFilter) + "&";
        if (hobbyFilter !== undefined)
            url_ += "HobbyFilter=" + encodeURIComponent("" + hobbyFilter) + "&";
        if (addressFilter !== undefined)
            url_ += "AddressFilter=" + encodeURIComponent("" + addressFilter) + "&";
        if (wardFilter !== undefined)
            url_ += "WardFilter=" + encodeURIComponent("" + wardFilter) + "&";
        if (districtFilter !== undefined)
            url_ += "DistrictFilter=" + encodeURIComponent("" + districtFilter) + "&";
        if (provinceFilter !== undefined)
            url_ += "ProvinceFilter=" + encodeURIComponent("" + provinceFilter) + "&";
        if (countryFilter !== undefined)
            url_ += "CountryFilter=" + encodeURIComponent("" + countryFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (maxLastActivityTimeFilter !== undefined)
            url_ += "MaxLastActivityTimeFilter=" + encodeURIComponent(maxLastActivityTimeFilter ? "" + maxLastActivityTimeFilter.toJSON() : "") + "&";
        if (minLastActivityTimeFilter !== undefined)
            url_ += "MinLastActivityTimeFilter=" + encodeURIComponent(minLastActivityTimeFilter ? "" + minLastActivityTimeFilter.toJSON() : "") + "&";
        if (maxLastPurchaseTimeFilter !== undefined)
            url_ += "MaxLastPurchaseTimeFilter=" + encodeURIComponent(maxLastPurchaseTimeFilter ? "" + maxLastPurchaseTimeFilter.toJSON() : "") + "&";
        if (minLastPurchaseTimeFilter !== undefined)
            url_ += "MinLastPurchaseTimeFilter=" + encodeURIComponent(minLastPurchaseTimeFilter ? "" + minLastPurchaseTimeFilter.toJSON() : "") + "&";
        if (communicationChannelsFilter !== undefined)
            url_ += "CommunicationChannelsFilter=" + encodeURIComponent("" + communicationChannelsFilter) + "&";
        if (communicationLanguageFilter !== undefined)
            url_ += "CommunicationLanguageFilter=" + encodeURIComponent("" + communicationLanguageFilter) + "&";
        if (notesFilter !== undefined)
            url_ += "NotesFilter=" + encodeURIComponent("" + notesFilter) + "&";
        if (rankProposeFilter !== undefined)
            url_ += "RankProposeFilter=" + encodeURIComponent("" + rankProposeFilter) + "&";
        if (pINCodeFilter !== undefined)
            url_ += "PINCodeFilter=" + encodeURIComponent("" + pINCodeFilter) + "&";
        if (nameUnSignFilter !== undefined)
            url_ += "NameUnSignFilter=" + encodeURIComponent("" + nameUnSignFilter) + "&";
        if (avatarFilter !== undefined)
            url_ += "AvatarFilter=" + encodeURIComponent("" + avatarFilter) + "&";
        if (workingPermitFilter !== undefined)
            url_ += "WorkingPermitFilter=" + encodeURIComponent("" + workingPermitFilter) + "&";
        if (customerCodeFilter !== undefined)
            url_ += "CustomerCodeFilter=" + encodeURIComponent("" + customerCodeFilter) + "&";
        if (interestOfFilter !== undefined)
            url_ += "InterestOfFilter=" + encodeURIComponent("" + interestOfFilter) + "&";
        if (isInterestCobrandFilter !== undefined)
            url_ += "isInterestCobrandFilter=" + encodeURIComponent("" + isInterestCobrandFilter) + "&";
        if (memberCardFilter !== undefined)
            url_ += "MemberCardFilter=" + encodeURIComponent("" + memberCardFilter) + "&";
        if (isForeignerFilter !== undefined)
            url_ += "IsForeignerFilter=" + encodeURIComponent("" + isForeignerFilter) + "&";
        if (isSyncedFilter !== undefined)
            url_ += "IsSyncedFilter=" + encodeURIComponent("" + isSyncedFilter) + "&";
        if (referralCodeFilter !== undefined)
            url_ += "ReferralCodeFilter=" + encodeURIComponent("" + referralCodeFilter) + "&";
        if (maxAccumulationPointFilter !== undefined)
            url_ += "MaxAccumulationPointFilter=" + encodeURIComponent("" + maxAccumulationPointFilter) + "&";
        if (minAccumulationPointFilter !== undefined)
            url_ += "MinAccumulationPointFilter=" + encodeURIComponent("" + minAccumulationPointFilter) + "&";
        if (outletCodeFilter !== undefined)
            url_ += "OutletCodeFilter=" + encodeURIComponent("" + outletCodeFilter) + "&";
        if (zaloNameFilter !== undefined)
            url_ += "ZaloNameFilter=" + encodeURIComponent("" + zaloNameFilter) + "&";
        if (distributorCodeFilter !== undefined)
            url_ += "DistributorCodeFilter=" + encodeURIComponent("" + distributorCodeFilter) + "&";
        if (distributorNameFilter !== undefined)
            url_ += "DistributorNameFilter=" + encodeURIComponent("" + distributorNameFilter) + "&";
        if (regionCodeFilter !== undefined)
            url_ += "RegionCodeFilter=" + encodeURIComponent("" + regionCodeFilter) + "&";
        if (maxTargetRevenueFilter !== undefined)
            url_ += "MaxTargetRevenueFilter=" + encodeURIComponent("" + maxTargetRevenueFilter) + "&";
        if (minTargetRevenueFilter !== undefined)
            url_ += "MinTargetRevenueFilter=" + encodeURIComponent("" + minTargetRevenueFilter) + "&";
        if (maxActualRevenueFilter !== undefined)
            url_ += "MaxActualRevenueFilter=" + encodeURIComponent("" + maxActualRevenueFilter) + "&";
        if (minActualRevenueFilter !== undefined)
            url_ += "MinActualRevenueFilter=" + encodeURIComponent("" + minActualRevenueFilter) + "&";
        if (maxBonusFilter !== undefined)
            url_ += "MaxBonusFilter=" + encodeURIComponent("" + maxBonusFilter) + "&";
        if (minBonusFilter !== undefined)
            url_ += "MinBonusFilter=" + encodeURIComponent("" + minBonusFilter) + "&";
        if (maxMissingRevenueFilter !== undefined)
            url_ += "MaxMissingRevenueFilter=" + encodeURIComponent("" + maxMissingRevenueFilter) + "&";
        if (minMissingRevenueFilter !== undefined)
            url_ += "MinMissingRevenueFilter=" + encodeURIComponent("" + minMissingRevenueFilter) + "&";
        if (maxRevenueUpdateDateFilter !== undefined)
            url_ += "MaxRevenueUpdateDateFilter=" + encodeURIComponent("" + maxRevenueUpdateDateFilter) + "&";
        if (minRevenueUpdateDateFilter !== undefined)
            url_ += "MinRevenueUpdateDateFilter=" + encodeURIComponent("" + minRevenueUpdateDateFilter) + "&";
        if (note1Filter !== undefined)
            url_ += "Note1Filter=" + encodeURIComponent("" + note1Filter) + "&";
        if (note2Filter !== undefined)
            url_ += "Note2Filter=" + encodeURIComponent("" + note2Filter) + "&";
        if (note3Filter !== undefined)
            url_ += "Note3Filter=" + encodeURIComponent("" + note3Filter) + "&";
        if (note4Filter !== undefined)
            url_ += "Note4Filter=" + encodeURIComponent("" + note4Filter) + "&";
        if (note5Filter !== undefined)
            url_ += "Note5Filter=" + encodeURIComponent("" + note5Filter) + "&";
        if (salesChannelFilter !== undefined)
            url_ += "SalesChannelFilter=" + encodeURIComponent("" + salesChannelFilter) + "&";
        if (supervisorCodeFilter !== undefined)
            url_ += "SupervisorCodeFilter=" + encodeURIComponent("" + supervisorCodeFilter) + "&";
        if (supervisorNameFilter !== undefined)
            url_ += "SupervisorNameFilter=" + encodeURIComponent("" + supervisorNameFilter) + "&";
        if (maxPhoneFirstDateFilter !== undefined)
            url_ += "MaxPhoneFirstDateFilter=" + encodeURIComponent(maxPhoneFirstDateFilter ? "" + maxPhoneFirstDateFilter.toJSON() : "") + "&";
        if (minPhoneFirstDateFilter !== undefined)
            url_ += "MinPhoneFirstDateFilter=" + encodeURIComponent(minPhoneFirstDateFilter ? "" + minPhoneFirstDateFilter.toJSON() : "") + "&";
        if (lockUpdatePhoneFilter !== undefined)
            url_ += "LockUpdatePhoneFilter=" + encodeURIComponent("" + lockUpdatePhoneFilter) + "&";
        if (browserCodeFilter !== undefined)
            url_ += "BrowserCodeFilter=" + encodeURIComponent("" + browserCodeFilter) + "&";
        if (deviceNameCodeFilter !== undefined)
            url_ += "DeviceNameCodeFilter=" + encodeURIComponent("" + deviceNameCodeFilter) + "&";
        if (typeOfDeviceCodeFilter !== undefined)
            url_ += "TypeOfDeviceCodeFilter=" + encodeURIComponent("" + typeOfDeviceCodeFilter) + "&";
        if (salesmanCodeFilter !== undefined)
            url_ += "SalesmanCodeFilter=" + encodeURIComponent("" + salesmanCodeFilter) + "&";
        if (maxConsumerIDFilter !== undefined)
            url_ += "MaxConsumerIDFilter=" + encodeURIComponent("" + maxConsumerIDFilter) + "&";
        if (minConsumerIDFilter !== undefined)
            url_ += "MinConsumerIDFilter=" + encodeURIComponent("" + minConsumerIDFilter) + "&";
        if (lockUpdateChatIDFilter !== undefined)
            url_ += "LockUpdateChatIDFilter=" + encodeURIComponent("" + lockUpdateChatIDFilter) + "&";
        if (maxCurrentCoinFilter !== undefined)
            url_ += "MaxCurrentCoinFilter=" + encodeURIComponent("" + maxCurrentCoinFilter) + "&";
        if (minCurrentCoinFilter !== undefined)
            url_ += "MinCurrentCoinFilter=" + encodeURIComponent("" + minCurrentCoinFilter) + "&";
        if (maxPointToKeepRankFilter !== undefined)
            url_ += "MaxPointToKeepRankFilter=" + encodeURIComponent("" + maxPointToKeepRankFilter) + "&";
        if (minPointToKeepRankFilter !== undefined)
            url_ += "MinPointToKeepRankFilter=" + encodeURIComponent("" + minPointToKeepRankFilter) + "&";
        if (maxPointToNextRankFilter !== undefined)
            url_ += "MaxPointToNextRankFilter=" + encodeURIComponent("" + maxPointToNextRankFilter) + "&";
        if (minPointToNextRankFilter !== undefined)
            url_ += "MinPointToNextRankFilter=" + encodeURIComponent("" + minPointToNextRankFilter) + "&";
        if (maxExpiringCoinFilter !== undefined)
            url_ += "MaxExpiringCoinFilter=" + encodeURIComponent("" + maxExpiringCoinFilter) + "&";
        if (minExpiringCoinFilter !== undefined)
            url_ += "MinExpiringCoinFilter=" + encodeURIComponent("" + minExpiringCoinFilter) + "&";
        if (maxExpiringCoinDateFilter !== undefined)
            url_ += "MaxExpiringCoinDateFilter=" + encodeURIComponent(maxExpiringCoinDateFilter ? "" + maxExpiringCoinDateFilter.toJSON() : "") + "&";
        if (minExpiringCoinDateFilter !== undefined)
            url_ += "MinExpiringCoinDateFilter=" + encodeURIComponent(minExpiringCoinDateFilter ? "" + minExpiringCoinDateFilter.toJSON() : "") + "&";
        if (lockUpdateProfileFilter !== undefined)
            url_ += "LockUpdateProfileFilter=" + encodeURIComponent("" + lockUpdateProfileFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetOutletInfoForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetOutletInfoForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetOutletInfoForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetOutletInfoForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetOutletInfoForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetOutletInfoForViewDto>(<any>null);
    }

    /**
     * @return Success
     */
    getAllNofilter(): Observable<PagedResultDtoOfGetAllOutletNoFilterDto> {
        let url_ = this.baseUrl + "/api/services/app/OutletInfos/GetAllNofilter";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllNofilter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllNofilter(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetAllOutletNoFilterDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetAllOutletNoFilterDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllNofilter(response: HttpResponseBase): Observable<PagedResultDtoOfGetAllOutletNoFilterDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetAllOutletNoFilterDto.fromJS(resultData200) : new PagedResultDtoOfGetAllOutletNoFilterDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetAllOutletNoFilterDto>(<any>null);
    }

    /**
     * @param outletType (optional) 
     * @return Success
     */
    getAllByType(outletType: string | null | undefined): Observable<PagedResultDtoOfGetAllOutletNoFilterDto> {
        let url_ = this.baseUrl + "/api/services/app/OutletInfos/GetAllByType?";
        if (outletType !== undefined)
            url_ += "outletType=" + encodeURIComponent("" + outletType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllByType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllByType(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetAllOutletNoFilterDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetAllOutletNoFilterDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllByType(response: HttpResponseBase): Observable<PagedResultDtoOfGetAllOutletNoFilterDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetAllOutletNoFilterDto.fromJS(resultData200) : new PagedResultDtoOfGetAllOutletNoFilterDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetAllOutletNoFilterDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getOutletInfoForEdit(id: number | null | undefined): Observable<GetOutletInfoForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/OutletInfos/GetOutletInfoForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetOutletInfoForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOutletInfoForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetOutletInfoForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetOutletInfoForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetOutletInfoForEdit(response: HttpResponseBase): Observable<GetOutletInfoForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetOutletInfoForEditOutput.fromJS(resultData200) : new GetOutletInfoForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetOutletInfoForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditOutletInfoDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OutletInfos/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEditExt(input: CreateOrEditOutletInfoDto | null | undefined): Observable<OutletInfoDto> {
        let url_ = this.baseUrl + "/api/services/app/OutletInfos/CreateOrEditExt";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEditExt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditExt(<any>response_);
                } catch (e) {
                    return <Observable<OutletInfoDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<OutletInfoDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEditExt(response: HttpResponseBase): Observable<OutletInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? OutletInfoDto.fromJS(resultData200) : new OutletInfoDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OutletInfoDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OutletInfos/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param memberCodeFilter (optional) 
     * @param nameFilter (optional) 
     * @param phoneFilter (optional) 
     * @param lNGFilter (optional) 
     * @param lATFilter (optional) 
     * @param emailFilter (optional) 
     * @param genderFilter (optional) 
     * @param maxBirthdayFilter (optional) 
     * @param minBirthdayFilter (optional) 
     * @param maxRegistrationDateFilter (optional) 
     * @param minRegistrationDateFilter (optional) 
     * @param pIDFilter (optional) 
     * @param sourceIDFilter (optional) 
     * @param receiveAdsFilter (optional) 
     * @param rankCodeFilter (optional) 
     * @param maxRankValidDateFilter (optional) 
     * @param minRankValidDateFilter (optional) 
     * @param maxCurrentPointFilter (optional) 
     * @param minCurrentPointFilter (optional) 
     * @param nationalityCodeFilter (optional) 
     * @param occupationCodeFilter (optional) 
     * @param hobbyFilter (optional) 
     * @param addressFilter (optional) 
     * @param wardFilter (optional) 
     * @param districtFilter (optional) 
     * @param provinceFilter (optional) 
     * @param countryFilter (optional) 
     * @param statusFilter (optional) 
     * @param maxLastActivityTimeFilter (optional) 
     * @param minLastActivityTimeFilter (optional) 
     * @param maxLastPurchaseTimeFilter (optional) 
     * @param minLastPurchaseTimeFilter (optional) 
     * @param communicationChannelsFilter (optional) 
     * @param communicationLanguageFilter (optional) 
     * @param notesFilter (optional) 
     * @param rankProposeFilter (optional) 
     * @param pINCodeFilter (optional) 
     * @param nameUnSignFilter (optional) 
     * @param avatarFilter (optional) 
     * @param workingPermitFilter (optional) 
     * @param customerCodeFilter (optional) 
     * @param interestOfFilter (optional) 
     * @param isInterestCobrandFilter (optional) 
     * @param memberCardFilter (optional) 
     * @param isForeignerFilter (optional) 
     * @param isSyncedFilter (optional) 
     * @param referralCodeFilter (optional) 
     * @param maxAccumulationPointFilter (optional) 
     * @param minAccumulationPointFilter (optional) 
     * @param outletCodeFilter (optional) 
     * @param zaloNameFilter (optional) 
     * @param distributorCodeFilter (optional) 
     * @param distributorNameFilter (optional) 
     * @param regionCodeFilter (optional) 
     * @param maxTargetRevenueFilter (optional) 
     * @param minTargetRevenueFilter (optional) 
     * @param maxActualRevenueFilter (optional) 
     * @param minActualRevenueFilter (optional) 
     * @param maxBonusFilter (optional) 
     * @param minBonusFilter (optional) 
     * @param maxMissingRevenueFilter (optional) 
     * @param minMissingRevenueFilter (optional) 
     * @param maxRevenueUpdateDateFilter (optional) 
     * @param minRevenueUpdateDateFilter (optional) 
     * @param note1Filter (optional) 
     * @param note2Filter (optional) 
     * @param note3Filter (optional) 
     * @param note4Filter (optional) 
     * @param note5Filter (optional) 
     * @param salesChannelFilter (optional) 
     * @param supervisorCodeFilter (optional) 
     * @param supervisorNameFilter (optional) 
     * @param maxPhoneFirstDateFilter (optional) 
     * @param minPhoneFirstDateFilter (optional) 
     * @param lockUpdatePhoneFilter (optional) 
     * @param browserCodeFilter (optional) 
     * @param deviceNameCodeFilter (optional) 
     * @param typeOfDeviceCodeFilter (optional) 
     * @param salesmanCodeFilter (optional) 
     * @param maxConsumerIDFilter (optional) 
     * @param minConsumerIDFilter (optional) 
     * @param lockUpdateChatIDFilter (optional) 
     * @param maxCurrentCoinFilter (optional) 
     * @param minCurrentCoinFilter (optional) 
     * @param maxPointToKeepRankFilter (optional) 
     * @param minPointToKeepRankFilter (optional) 
     * @param maxPointToNextRankFilter (optional) 
     * @param minPointToNextRankFilter (optional) 
     * @param maxExpiringCoinFilter (optional) 
     * @param minExpiringCoinFilter (optional) 
     * @param maxExpiringCoinDateFilter (optional) 
     * @param minExpiringCoinDateFilter (optional) 
     * @param lockUpdateProfileFilter (optional) 
     * @return Success
     */
    getOutletInfosToExcel(filter: string | null | undefined, memberCodeFilter: string | null | undefined, nameFilter: string | null | undefined, phoneFilter: string | null | undefined, lNGFilter: string | null | undefined, lATFilter: string | null | undefined, emailFilter: string | null | undefined, genderFilter: string | null | undefined, maxBirthdayFilter: number | null | undefined, minBirthdayFilter: number | null | undefined, maxRegistrationDateFilter: number | null | undefined, minRegistrationDateFilter: number | null | undefined, pIDFilter: string | null | undefined, sourceIDFilter: string | null | undefined, receiveAdsFilter: number | null | undefined, rankCodeFilter: string | null | undefined, maxRankValidDateFilter: number | null | undefined, minRankValidDateFilter: number | null | undefined, maxCurrentPointFilter: number | null | undefined, minCurrentPointFilter: number | null | undefined, nationalityCodeFilter: string | null | undefined, occupationCodeFilter: string | null | undefined, hobbyFilter: string | null | undefined, addressFilter: string | null | undefined, wardFilter: string | null | undefined, districtFilter: string | null | undefined, provinceFilter: string | null | undefined, countryFilter: string | null | undefined, statusFilter: string | null | undefined, maxLastActivityTimeFilter: moment.Moment | null | undefined, minLastActivityTimeFilter: moment.Moment | null | undefined, maxLastPurchaseTimeFilter: moment.Moment | null | undefined, minLastPurchaseTimeFilter: moment.Moment | null | undefined, communicationChannelsFilter: string | null | undefined, communicationLanguageFilter: string | null | undefined, notesFilter: string | null | undefined, rankProposeFilter: string | null | undefined, pINCodeFilter: string | null | undefined, nameUnSignFilter: string | null | undefined, avatarFilter: string | null | undefined, workingPermitFilter: number | null | undefined, customerCodeFilter: string | null | undefined, interestOfFilter: string | null | undefined, isInterestCobrandFilter: number | null | undefined, memberCardFilter: string | null | undefined, isForeignerFilter: number | null | undefined, isSyncedFilter: number | null | undefined, referralCodeFilter: string | null | undefined, maxAccumulationPointFilter: number | null | undefined, minAccumulationPointFilter: number | null | undefined, outletCodeFilter: string | null | undefined, zaloNameFilter: string | null | undefined, distributorCodeFilter: string | null | undefined, distributorNameFilter: string | null | undefined, regionCodeFilter: string | null | undefined, maxTargetRevenueFilter: number | null | undefined, minTargetRevenueFilter: number | null | undefined, maxActualRevenueFilter: number | null | undefined, minActualRevenueFilter: number | null | undefined, maxBonusFilter: number | null | undefined, minBonusFilter: number | null | undefined, maxMissingRevenueFilter: number | null | undefined, minMissingRevenueFilter: number | null | undefined, maxRevenueUpdateDateFilter: number | null | undefined, minRevenueUpdateDateFilter: number | null | undefined, note1Filter: string | null | undefined, note2Filter: string | null | undefined, note3Filter: string | null | undefined, note4Filter: string | null | undefined, note5Filter: string | null | undefined, salesChannelFilter: string | null | undefined, supervisorCodeFilter: string | null | undefined, supervisorNameFilter: string | null | undefined, maxPhoneFirstDateFilter: moment.Moment | null | undefined, minPhoneFirstDateFilter: moment.Moment | null | undefined, lockUpdatePhoneFilter: number | null | undefined, browserCodeFilter: string | null | undefined, deviceNameCodeFilter: string | null | undefined, typeOfDeviceCodeFilter: string | null | undefined, salesmanCodeFilter: string | null | undefined, maxConsumerIDFilter: number | null | undefined, minConsumerIDFilter: number | null | undefined, lockUpdateChatIDFilter: number | null | undefined, maxCurrentCoinFilter: number | null | undefined, minCurrentCoinFilter: number | null | undefined, maxPointToKeepRankFilter: number | null | undefined, minPointToKeepRankFilter: number | null | undefined, maxPointToNextRankFilter: number | null | undefined, minPointToNextRankFilter: number | null | undefined, maxExpiringCoinFilter: number | null | undefined, minExpiringCoinFilter: number | null | undefined, maxExpiringCoinDateFilter: moment.Moment | null | undefined, minExpiringCoinDateFilter: moment.Moment | null | undefined, lockUpdateProfileFilter: number | null | undefined): Observable<SocialRetailerFileDto> {
        let url_ = this.baseUrl + "/api/services/app/OutletInfos/GetOutletInfosToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (memberCodeFilter !== undefined)
            url_ += "MemberCodeFilter=" + encodeURIComponent("" + memberCodeFilter) + "&";
        if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (phoneFilter !== undefined)
            url_ += "PhoneFilter=" + encodeURIComponent("" + phoneFilter) + "&";
        if (lNGFilter !== undefined)
            url_ += "LNGFilter=" + encodeURIComponent("" + lNGFilter) + "&";
        if (lATFilter !== undefined)
            url_ += "LATFilter=" + encodeURIComponent("" + lATFilter) + "&";
        if (emailFilter !== undefined)
            url_ += "EmailFilter=" + encodeURIComponent("" + emailFilter) + "&";
        if (genderFilter !== undefined)
            url_ += "GenderFilter=" + encodeURIComponent("" + genderFilter) + "&";
        if (maxBirthdayFilter !== undefined)
            url_ += "MaxBirthdayFilter=" + encodeURIComponent("" + maxBirthdayFilter) + "&";
        if (minBirthdayFilter !== undefined)
            url_ += "MinBirthdayFilter=" + encodeURIComponent("" + minBirthdayFilter) + "&";
        if (maxRegistrationDateFilter !== undefined)
            url_ += "MaxRegistrationDateFilter=" + encodeURIComponent("" + maxRegistrationDateFilter) + "&";
        if (minRegistrationDateFilter !== undefined)
            url_ += "MinRegistrationDateFilter=" + encodeURIComponent("" + minRegistrationDateFilter) + "&";
        if (pIDFilter !== undefined)
            url_ += "PIDFilter=" + encodeURIComponent("" + pIDFilter) + "&";
        if (sourceIDFilter !== undefined)
            url_ += "SourceIDFilter=" + encodeURIComponent("" + sourceIDFilter) + "&";
        if (receiveAdsFilter !== undefined)
            url_ += "ReceiveAdsFilter=" + encodeURIComponent("" + receiveAdsFilter) + "&";
        if (rankCodeFilter !== undefined)
            url_ += "RankCodeFilter=" + encodeURIComponent("" + rankCodeFilter) + "&";
        if (maxRankValidDateFilter !== undefined)
            url_ += "MaxRankValidDateFilter=" + encodeURIComponent("" + maxRankValidDateFilter) + "&";
        if (minRankValidDateFilter !== undefined)
            url_ += "MinRankValidDateFilter=" + encodeURIComponent("" + minRankValidDateFilter) + "&";
        if (maxCurrentPointFilter !== undefined)
            url_ += "MaxCurrentPointFilter=" + encodeURIComponent("" + maxCurrentPointFilter) + "&";
        if (minCurrentPointFilter !== undefined)
            url_ += "MinCurrentPointFilter=" + encodeURIComponent("" + minCurrentPointFilter) + "&";
        if (nationalityCodeFilter !== undefined)
            url_ += "NationalityCodeFilter=" + encodeURIComponent("" + nationalityCodeFilter) + "&";
        if (occupationCodeFilter !== undefined)
            url_ += "OccupationCodeFilter=" + encodeURIComponent("" + occupationCodeFilter) + "&";
        if (hobbyFilter !== undefined)
            url_ += "HobbyFilter=" + encodeURIComponent("" + hobbyFilter) + "&";
        if (addressFilter !== undefined)
            url_ += "AddressFilter=" + encodeURIComponent("" + addressFilter) + "&";
        if (wardFilter !== undefined)
            url_ += "WardFilter=" + encodeURIComponent("" + wardFilter) + "&";
        if (districtFilter !== undefined)
            url_ += "DistrictFilter=" + encodeURIComponent("" + districtFilter) + "&";
        if (provinceFilter !== undefined)
            url_ += "ProvinceFilter=" + encodeURIComponent("" + provinceFilter) + "&";
        if (countryFilter !== undefined)
            url_ += "CountryFilter=" + encodeURIComponent("" + countryFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (maxLastActivityTimeFilter !== undefined)
            url_ += "MaxLastActivityTimeFilter=" + encodeURIComponent(maxLastActivityTimeFilter ? "" + maxLastActivityTimeFilter.toJSON() : "") + "&";
        if (minLastActivityTimeFilter !== undefined)
            url_ += "MinLastActivityTimeFilter=" + encodeURIComponent(minLastActivityTimeFilter ? "" + minLastActivityTimeFilter.toJSON() : "") + "&";
        if (maxLastPurchaseTimeFilter !== undefined)
            url_ += "MaxLastPurchaseTimeFilter=" + encodeURIComponent(maxLastPurchaseTimeFilter ? "" + maxLastPurchaseTimeFilter.toJSON() : "") + "&";
        if (minLastPurchaseTimeFilter !== undefined)
            url_ += "MinLastPurchaseTimeFilter=" + encodeURIComponent(minLastPurchaseTimeFilter ? "" + minLastPurchaseTimeFilter.toJSON() : "") + "&";
        if (communicationChannelsFilter !== undefined)
            url_ += "CommunicationChannelsFilter=" + encodeURIComponent("" + communicationChannelsFilter) + "&";
        if (communicationLanguageFilter !== undefined)
            url_ += "CommunicationLanguageFilter=" + encodeURIComponent("" + communicationLanguageFilter) + "&";
        if (notesFilter !== undefined)
            url_ += "NotesFilter=" + encodeURIComponent("" + notesFilter) + "&";
        if (rankProposeFilter !== undefined)
            url_ += "RankProposeFilter=" + encodeURIComponent("" + rankProposeFilter) + "&";
        if (pINCodeFilter !== undefined)
            url_ += "PINCodeFilter=" + encodeURIComponent("" + pINCodeFilter) + "&";
        if (nameUnSignFilter !== undefined)
            url_ += "NameUnSignFilter=" + encodeURIComponent("" + nameUnSignFilter) + "&";
        if (avatarFilter !== undefined)
            url_ += "AvatarFilter=" + encodeURIComponent("" + avatarFilter) + "&";
        if (workingPermitFilter !== undefined)
            url_ += "WorkingPermitFilter=" + encodeURIComponent("" + workingPermitFilter) + "&";
        if (customerCodeFilter !== undefined)
            url_ += "CustomerCodeFilter=" + encodeURIComponent("" + customerCodeFilter) + "&";
        if (interestOfFilter !== undefined)
            url_ += "InterestOfFilter=" + encodeURIComponent("" + interestOfFilter) + "&";
        if (isInterestCobrandFilter !== undefined)
            url_ += "isInterestCobrandFilter=" + encodeURIComponent("" + isInterestCobrandFilter) + "&";
        if (memberCardFilter !== undefined)
            url_ += "MemberCardFilter=" + encodeURIComponent("" + memberCardFilter) + "&";
        if (isForeignerFilter !== undefined)
            url_ += "IsForeignerFilter=" + encodeURIComponent("" + isForeignerFilter) + "&";
        if (isSyncedFilter !== undefined)
            url_ += "IsSyncedFilter=" + encodeURIComponent("" + isSyncedFilter) + "&";
        if (referralCodeFilter !== undefined)
            url_ += "ReferralCodeFilter=" + encodeURIComponent("" + referralCodeFilter) + "&";
        if (maxAccumulationPointFilter !== undefined)
            url_ += "MaxAccumulationPointFilter=" + encodeURIComponent("" + maxAccumulationPointFilter) + "&";
        if (minAccumulationPointFilter !== undefined)
            url_ += "MinAccumulationPointFilter=" + encodeURIComponent("" + minAccumulationPointFilter) + "&";
        if (outletCodeFilter !== undefined)
            url_ += "OutletCodeFilter=" + encodeURIComponent("" + outletCodeFilter) + "&";
        if (zaloNameFilter !== undefined)
            url_ += "ZaloNameFilter=" + encodeURIComponent("" + zaloNameFilter) + "&";
        if (distributorCodeFilter !== undefined)
            url_ += "DistributorCodeFilter=" + encodeURIComponent("" + distributorCodeFilter) + "&";
        if (distributorNameFilter !== undefined)
            url_ += "DistributorNameFilter=" + encodeURIComponent("" + distributorNameFilter) + "&";
        if (regionCodeFilter !== undefined)
            url_ += "RegionCodeFilter=" + encodeURIComponent("" + regionCodeFilter) + "&";
        if (maxTargetRevenueFilter !== undefined)
            url_ += "MaxTargetRevenueFilter=" + encodeURIComponent("" + maxTargetRevenueFilter) + "&";
        if (minTargetRevenueFilter !== undefined)
            url_ += "MinTargetRevenueFilter=" + encodeURIComponent("" + minTargetRevenueFilter) + "&";
        if (maxActualRevenueFilter !== undefined)
            url_ += "MaxActualRevenueFilter=" + encodeURIComponent("" + maxActualRevenueFilter) + "&";
        if (minActualRevenueFilter !== undefined)
            url_ += "MinActualRevenueFilter=" + encodeURIComponent("" + minActualRevenueFilter) + "&";
        if (maxBonusFilter !== undefined)
            url_ += "MaxBonusFilter=" + encodeURIComponent("" + maxBonusFilter) + "&";
        if (minBonusFilter !== undefined)
            url_ += "MinBonusFilter=" + encodeURIComponent("" + minBonusFilter) + "&";
        if (maxMissingRevenueFilter !== undefined)
            url_ += "MaxMissingRevenueFilter=" + encodeURIComponent("" + maxMissingRevenueFilter) + "&";
        if (minMissingRevenueFilter !== undefined)
            url_ += "MinMissingRevenueFilter=" + encodeURIComponent("" + minMissingRevenueFilter) + "&";
        if (maxRevenueUpdateDateFilter !== undefined)
            url_ += "MaxRevenueUpdateDateFilter=" + encodeURIComponent("" + maxRevenueUpdateDateFilter) + "&";
        if (minRevenueUpdateDateFilter !== undefined)
            url_ += "MinRevenueUpdateDateFilter=" + encodeURIComponent("" + minRevenueUpdateDateFilter) + "&";
        if (note1Filter !== undefined)
            url_ += "Note1Filter=" + encodeURIComponent("" + note1Filter) + "&";
        if (note2Filter !== undefined)
            url_ += "Note2Filter=" + encodeURIComponent("" + note2Filter) + "&";
        if (note3Filter !== undefined)
            url_ += "Note3Filter=" + encodeURIComponent("" + note3Filter) + "&";
        if (note4Filter !== undefined)
            url_ += "Note4Filter=" + encodeURIComponent("" + note4Filter) + "&";
        if (note5Filter !== undefined)
            url_ += "Note5Filter=" + encodeURIComponent("" + note5Filter) + "&";
        if (salesChannelFilter !== undefined)
            url_ += "SalesChannelFilter=" + encodeURIComponent("" + salesChannelFilter) + "&";
        if (supervisorCodeFilter !== undefined)
            url_ += "SupervisorCodeFilter=" + encodeURIComponent("" + supervisorCodeFilter) + "&";
        if (supervisorNameFilter !== undefined)
            url_ += "SupervisorNameFilter=" + encodeURIComponent("" + supervisorNameFilter) + "&";
        if (maxPhoneFirstDateFilter !== undefined)
            url_ += "MaxPhoneFirstDateFilter=" + encodeURIComponent(maxPhoneFirstDateFilter ? "" + maxPhoneFirstDateFilter.toJSON() : "") + "&";
        if (minPhoneFirstDateFilter !== undefined)
            url_ += "MinPhoneFirstDateFilter=" + encodeURIComponent(minPhoneFirstDateFilter ? "" + minPhoneFirstDateFilter.toJSON() : "") + "&";
        if (lockUpdatePhoneFilter !== undefined)
            url_ += "LockUpdatePhoneFilter=" + encodeURIComponent("" + lockUpdatePhoneFilter) + "&";
        if (browserCodeFilter !== undefined)
            url_ += "BrowserCodeFilter=" + encodeURIComponent("" + browserCodeFilter) + "&";
        if (deviceNameCodeFilter !== undefined)
            url_ += "DeviceNameCodeFilter=" + encodeURIComponent("" + deviceNameCodeFilter) + "&";
        if (typeOfDeviceCodeFilter !== undefined)
            url_ += "TypeOfDeviceCodeFilter=" + encodeURIComponent("" + typeOfDeviceCodeFilter) + "&";
        if (salesmanCodeFilter !== undefined)
            url_ += "SalesmanCodeFilter=" + encodeURIComponent("" + salesmanCodeFilter) + "&";
        if (maxConsumerIDFilter !== undefined)
            url_ += "MaxConsumerIDFilter=" + encodeURIComponent("" + maxConsumerIDFilter) + "&";
        if (minConsumerIDFilter !== undefined)
            url_ += "MinConsumerIDFilter=" + encodeURIComponent("" + minConsumerIDFilter) + "&";
        if (lockUpdateChatIDFilter !== undefined)
            url_ += "LockUpdateChatIDFilter=" + encodeURIComponent("" + lockUpdateChatIDFilter) + "&";
        if (maxCurrentCoinFilter !== undefined)
            url_ += "MaxCurrentCoinFilter=" + encodeURIComponent("" + maxCurrentCoinFilter) + "&";
        if (minCurrentCoinFilter !== undefined)
            url_ += "MinCurrentCoinFilter=" + encodeURIComponent("" + minCurrentCoinFilter) + "&";
        if (maxPointToKeepRankFilter !== undefined)
            url_ += "MaxPointToKeepRankFilter=" + encodeURIComponent("" + maxPointToKeepRankFilter) + "&";
        if (minPointToKeepRankFilter !== undefined)
            url_ += "MinPointToKeepRankFilter=" + encodeURIComponent("" + minPointToKeepRankFilter) + "&";
        if (maxPointToNextRankFilter !== undefined)
            url_ += "MaxPointToNextRankFilter=" + encodeURIComponent("" + maxPointToNextRankFilter) + "&";
        if (minPointToNextRankFilter !== undefined)
            url_ += "MinPointToNextRankFilter=" + encodeURIComponent("" + minPointToNextRankFilter) + "&";
        if (maxExpiringCoinFilter !== undefined)
            url_ += "MaxExpiringCoinFilter=" + encodeURIComponent("" + maxExpiringCoinFilter) + "&";
        if (minExpiringCoinFilter !== undefined)
            url_ += "MinExpiringCoinFilter=" + encodeURIComponent("" + minExpiringCoinFilter) + "&";
        if (maxExpiringCoinDateFilter !== undefined)
            url_ += "MaxExpiringCoinDateFilter=" + encodeURIComponent(maxExpiringCoinDateFilter ? "" + maxExpiringCoinDateFilter.toJSON() : "") + "&";
        if (minExpiringCoinDateFilter !== undefined)
            url_ += "MinExpiringCoinDateFilter=" + encodeURIComponent(minExpiringCoinDateFilter ? "" + minExpiringCoinDateFilter.toJSON() : "") + "&";
        if (lockUpdateProfileFilter !== undefined)
            url_ += "LockUpdateProfileFilter=" + encodeURIComponent("" + lockUpdateProfileFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetOutletInfosToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOutletInfosToExcel(<any>response_);
                } catch (e) {
                    return <Observable<SocialRetailerFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SocialRetailerFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetOutletInfosToExcel(response: HttpResponseBase): Observable<SocialRetailerFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? SocialRetailerFileDto.fromJS(resultData200) : new SocialRetailerFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SocialRetailerFileDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    exportRetailerInfosToExcel(input: GetAllOutletInfosForExcelInput | null | undefined): Observable<SocialRetailerFileDto> {
        let url_ = this.baseUrl + "/api/services/app/OutletInfos/ExportRetailerInfosToExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processExportRetailerInfosToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportRetailerInfosToExcel(<any>response_);
                } catch (e) {
                    return <Observable<SocialRetailerFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SocialRetailerFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processExportRetailerInfosToExcel(response: HttpResponseBase): Observable<SocialRetailerFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? SocialRetailerFileDto.fromJS(resultData200) : new SocialRetailerFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SocialRetailerFileDto>(<any>null);
    }

    /**
     * @return Success
     */
    exportTemplate(): Observable<SocialRetailerFileDto> {
        let url_ = this.baseUrl + "/api/services/app/OutletInfos/ExportTemplate";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processExportTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportTemplate(<any>response_);
                } catch (e) {
                    return <Observable<SocialRetailerFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SocialRetailerFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processExportTemplate(response: HttpResponseBase): Observable<SocialRetailerFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? SocialRetailerFileDto.fromJS(resultData200) : new SocialRetailerFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SocialRetailerFileDto>(<any>null);
    }

    /**
     * @param arg (optional) 
     * @return Success
     */
    importQueueOutlet(arg: OutletInfosImportAgrs | null | undefined): Observable<CommonImportFileResponse> {
        let url_ = this.baseUrl + "/api/services/app/OutletInfos/ImportQueueOutlet";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(arg);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processImportQueueOutlet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportQueueOutlet(<any>response_);
                } catch (e) {
                    return <Observable<CommonImportFileResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<CommonImportFileResponse>><any>_observableThrow(response_);
        }));
    }

    protected processImportQueueOutlet(response: HttpResponseBase): Observable<CommonImportFileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? CommonImportFileResponse.fromJS(resultData200) : new CommonImportFileResponse();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CommonImportFileResponse>(<any>null);
    }

    /**
     * @param arg (optional) 
     * @return Success
     */
    importQueue(arg: OutletInfosImportAgrs | null | undefined): Observable<CommonImportFileResponse> {
        let url_ = this.baseUrl + "/api/services/app/OutletInfos/ImportQueue";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(arg);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processImportQueue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportQueue(<any>response_);
                } catch (e) {
                    return <Observable<CommonImportFileResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<CommonImportFileResponse>><any>_observableThrow(response_);
        }));
    }

    protected processImportQueue(response: HttpResponseBase): Observable<CommonImportFileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? CommonImportFileResponse.fromJS(resultData200) : new CommonImportFileResponse();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CommonImportFileResponse>(<any>null);
    }

    /**
     * @param salesmanCode (optional) 
     * @param outletId (optional) 
     * @param outletCode (optional) 
     * @param outletName (optional) 
     * @param outletType (optional) 
     * @param rankCode (optional) 
     * @param regionCode (optional) 
     * @param productCode (optional) 
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param sortBy (optional) 
     * @param phone (optional) 
     * @param isCal (optional) 
     * @param storeType (optional) 
     * @return Success
     */
    getOutletInfoOfSalesman(salesmanCode: string | null | undefined, outletId: number | null | undefined, outletCode: string | null | undefined, outletName: string | null | undefined, outletType: string | null | undefined, rankCode: string | null | undefined, regionCode: string | null | undefined, productCode: string | null | undefined, fromDate: moment.Moment | null | undefined, toDate: moment.Moment | null | undefined, sortBy: string | null | undefined, phone: string | null | undefined, isCal: boolean | null | undefined, storeType: string | null | undefined): Observable<GetOutletOfSalesmanDto> {
        let url_ = this.baseUrl + "/api/services/app/OutletInfos/GetOutletInfoOfSalesman?";
        if (salesmanCode !== undefined)
            url_ += "SalesmanCode=" + encodeURIComponent("" + salesmanCode) + "&";
        if (outletId !== undefined)
            url_ += "OutletId=" + encodeURIComponent("" + outletId) + "&";
        if (outletCode !== undefined)
            url_ += "OutletCode=" + encodeURIComponent("" + outletCode) + "&";
        if (outletName !== undefined)
            url_ += "OutletName=" + encodeURIComponent("" + outletName) + "&";
        if (outletType !== undefined)
            url_ += "OutletType=" + encodeURIComponent("" + outletType) + "&";
        if (rankCode !== undefined)
            url_ += "RankCode=" + encodeURIComponent("" + rankCode) + "&";
        if (regionCode !== undefined)
            url_ += "RegionCode=" + encodeURIComponent("" + regionCode) + "&";
        if (productCode !== undefined)
            url_ += "ProductCode=" + encodeURIComponent("" + productCode) + "&";
        if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toJSON() : "") + "&";
        if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toJSON() : "") + "&";
        if (sortBy !== undefined)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (phone !== undefined)
            url_ += "Phone=" + encodeURIComponent("" + phone) + "&";
        if (isCal !== undefined)
            url_ += "isCal=" + encodeURIComponent("" + isCal) + "&";
        if (storeType !== undefined)
            url_ += "StoreType=" + encodeURIComponent("" + storeType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetOutletInfoOfSalesman(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOutletInfoOfSalesman(<any>response_);
                } catch (e) {
                    return <Observable<GetOutletOfSalesmanDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetOutletOfSalesmanDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetOutletInfoOfSalesman(response: HttpResponseBase): Observable<GetOutletOfSalesmanDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetOutletOfSalesmanDto.fromJS(resultData200) : new GetOutletOfSalesmanDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetOutletOfSalesmanDto>(<any>null);
    }

    /**
     * @param memberCode (optional) 
     * @return Success
     */
    unlockOutlet(memberCode: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/OutletInfos/UnlockOutlet?";
        if (memberCode !== undefined)
            url_ += "memberCode=" + encodeURIComponent("" + memberCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUnlockOutlet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnlockOutlet(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processUnlockOutlet(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param statusFilter (optional) 
     * @param ids (optional) 
     * @param listGeoPath (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllOutLet(filter: string | null | undefined, statusFilter: string | null | undefined, ids: number[] | null | undefined, listGeoPath: string[] | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetOutletInfoForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/OutletInfos/GetAllOutLet?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (ids !== undefined)
            ids && ids.forEach(item => { url_ += "Ids=" + encodeURIComponent("" + item) + "&"; });
        if (listGeoPath !== undefined)
            listGeoPath && listGeoPath.forEach(item => { url_ += "ListGeoPath=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllOutLet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllOutLet(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetOutletInfoForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetOutletInfoForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllOutLet(response: HttpResponseBase): Observable<PagedResultDtoOfGetOutletInfoForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetOutletInfoForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetOutletInfoForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetOutletInfoForViewDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    searchAllOutlet(input: GetAllOutletInformationInput | null | undefined): Observable<PagedResultDtoOfGetOutletInfoForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/OutletInfos/SearchAllOutlet";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSearchAllOutlet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchAllOutlet(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetOutletInfoForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetOutletInfoForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processSearchAllOutlet(response: HttpResponseBase): Observable<PagedResultDtoOfGetOutletInfoForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetOutletInfoForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetOutletInfoForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetOutletInfoForViewDto>(<any>null);
    }

    /**
     * @param ids (optional) 
     * @return Success
     */
    batchDeleteOutlet(ids: string[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OutletInfos/BatchDeleteOutlet";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ids);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processBatchDeleteOutlet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBatchDeleteOutlet(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processBatchDeleteOutlet(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    exportCustomOutlet(input: GetAllOutletInformationInput | null | undefined): Observable<SocialRetailerFileDto> {
        let url_ = this.baseUrl + "/api/services/app/OutletInfos/ExportCustomOutlet";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processExportCustomOutlet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportCustomOutlet(<any>response_);
                } catch (e) {
                    return <Observable<SocialRetailerFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SocialRetailerFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processExportCustomOutlet(response: HttpResponseBase): Observable<SocialRetailerFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? SocialRetailerFileDto.fromJS(resultData200) : new SocialRetailerFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SocialRetailerFileDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    editOutlet(input: GetOutletInfoForEditOutput | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OutletInfos/EditOutlet";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processEditOutlet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditOutlet(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processEditOutlet(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    updateChatIDAsync(input: InputUpdateChatIdDto | null | undefined): Observable<OutputUpdateChatID> {
        let url_ = this.baseUrl + "/api/services/app/OutletInfos/UpdateChatIDAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateChatIDAsync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateChatIDAsync(<any>response_);
                } catch (e) {
                    return <Observable<OutputUpdateChatID>><any>_observableThrow(e);
                }
            } else
                return <Observable<OutputUpdateChatID>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateChatIDAsync(response: HttpResponseBase): Observable<OutputUpdateChatID> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? OutputUpdateChatID.fromJS(resultData200) : new OutputUpdateChatID();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OutputUpdateChatID>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    updateReasonAsync(input: ReasonInput | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OutletInfos/UpdateReasonAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateReasonAsync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateReasonAsync(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateReasonAsync(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param outletCode (optional) 
     * @return Success
     */
    getOutletInformationAsync(outletCode: string | null | undefined): Observable<OutletInformationDto> {
        let url_ = this.baseUrl + "/api/services/app/OutletInfos/GetOutletInformationAsync?";
        if (outletCode !== undefined)
            url_ += "OutletCode=" + encodeURIComponent("" + outletCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetOutletInformationAsync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOutletInformationAsync(<any>response_);
                } catch (e) {
                    return <Observable<OutletInformationDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<OutletInformationDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetOutletInformationAsync(response: HttpResponseBase): Observable<OutletInformationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? OutletInformationDto.fromJS(resultData200) : new OutletInformationDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OutletInformationDto>(<any>null);
    }

    /**
     * @return Success
     */
    genTokenAsync(): Observable<ResultToken> {
        let url_ = this.baseUrl + "/api/services/app/OutletInfos/GenTokenAsync";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGenTokenAsync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenTokenAsync(<any>response_);
                } catch (e) {
                    return <Observable<ResultToken>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultToken>><any>_observableThrow(response_);
        }));
    }

    protected processGenTokenAsync(response: HttpResponseBase): Observable<ResultToken> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? ResultToken.fromJS(resultData200) : new ResultToken();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultToken>(<any>null);
    }

    /**
     * @return Success
     */
    genTokenForRetailerAsync(): Observable<ResultToken> {
        let url_ = this.baseUrl + "/api/services/app/OutletInfos/GenTokenForRetailerAsync";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGenTokenForRetailerAsync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenTokenForRetailerAsync(<any>response_);
                } catch (e) {
                    return <Observable<ResultToken>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultToken>><any>_observableThrow(response_);
        }));
    }

    protected processGenTokenForRetailerAsync(response: HttpResponseBase): Observable<ResultToken> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? ResultToken.fromJS(resultData200) : new ResultToken();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultToken>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    getBeatplancodeForOutletdetail(input: string | null | undefined): Observable<BeatplanSalesManForView> {
        let url_ = this.baseUrl + "/api/services/app/OutletInfos/GetBeatplancodeForOutletdetail?";
        if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetBeatplancodeForOutletdetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBeatplancodeForOutletdetail(<any>response_);
                } catch (e) {
                    return <Observable<BeatplanSalesManForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<BeatplanSalesManForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetBeatplancodeForOutletdetail(response: HttpResponseBase): Observable<BeatplanSalesManForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? BeatplanSalesManForView.fromJS(resultData200) : new BeatplanSalesManForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BeatplanSalesManForView>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    submitReason(input: SubmitReasonInput | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OutletInfos/SubmitReason";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSubmitReason(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubmitReason(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSubmitReason(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    updatePhone(input: UpdatePhoneInput | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OutletInfos/UpdatePhone";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdatePhone(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePhone(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdatePhone(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    verifyOTP(input: VerifyOTPInput | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OutletInfos/VerifyOTP";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processVerifyOTP(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerifyOTP(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processVerifyOTP(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    sendOTPToPhoneNumber(input: SendOTPToPhoneNumberInput | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OutletInfos/SendOTPToPhoneNumber";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSendOTPToPhoneNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendOTPToPhoneNumber(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSendOTPToPhoneNumber(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    submitSurvey(input: SubmitSurveyInput | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OutletInfos/SubmitSurvey";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSubmitSurvey(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubmitSurvey(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSubmitSurvey(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    updateHomePhoneAsync(input: UpdateHomePhoneInput | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OutletInfos/UpdateHomePhoneAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateHomePhoneAsync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateHomePhoneAsync(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateHomePhoneAsync(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param chatId (optional) 
     * @return Success
     */
    getRetailerInformation(chatId: string | null | undefined): Observable<RetailerInformationDto> {
        let url_ = this.baseUrl + "/api/services/app/OutletInfos/GetRetailerInformation?";
        if (chatId !== undefined)
            url_ += "chatId=" + encodeURIComponent("" + chatId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetRetailerInformation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRetailerInformation(<any>response_);
                } catch (e) {
                    return <Observable<RetailerInformationDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<RetailerInformationDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetRetailerInformation(response: HttpResponseBase): Observable<RetailerInformationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? RetailerInformationDto.fromJS(resultData200) : new RetailerInformationDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RetailerInformationDto>(<any>null);
    }

    /**
     * @param dto (optional) 
     * @return Success
     */
    changeRetailerInformation(dto: UpdateRetailerInformationDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OutletInfos/ChangeRetailerInformation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processChangeRetailerInformation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeRetailerInformation(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processChangeRetailerInformation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    changePasswordAsync(input: ChangePasswordOutletDto | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/OutletInfos/ChangePasswordAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processChangePasswordAsync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangePasswordAsync(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processChangePasswordAsync(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    forceChangePasswordAsync(input: ForceChangePasswordDto | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/OutletInfos/ForceChangePasswordAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processForceChangePasswordAsync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processForceChangePasswordAsync(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processForceChangePasswordAsync(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    resetPasswordAsync(input: ResetPasswordOutletInfoDto | null | undefined): Observable<ResponseOTP> {
        let url_ = this.baseUrl + "/api/services/app/OutletInfos/ResetPasswordAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processResetPasswordAsync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetPasswordAsync(<any>response_);
                } catch (e) {
                    return <Observable<ResponseOTP>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResponseOTP>><any>_observableThrow(response_);
        }));
    }

    protected processResetPasswordAsync(response: HttpResponseBase): Observable<ResponseOTP> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? ResponseOTP.fromJS(resultData200) : new ResponseOTP();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseOTP>(<any>null);
    }

    /**
     * @param outletId (optional) 
     * @param outletCode (optional) 
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @return Success
     */
    getOutletRevenueByDate(outletId: number | null | undefined, outletCode: string | null | undefined, fromDate: moment.Moment | null | undefined, toDate: moment.Moment | null | undefined): Observable<GetOutletRevenueResponse> {
        let url_ = this.baseUrl + "/api/services/app/OutletInfos/GetOutletRevenueByDate?";
        if (outletId !== undefined)
            url_ += "OutletId=" + encodeURIComponent("" + outletId) + "&";
        if (outletCode !== undefined)
            url_ += "OutletCode=" + encodeURIComponent("" + outletCode) + "&";
        if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toJSON() : "") + "&";
        if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetOutletRevenueByDate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOutletRevenueByDate(<any>response_);
                } catch (e) {
                    return <Observable<GetOutletRevenueResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetOutletRevenueResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetOutletRevenueByDate(response: HttpResponseBase): Observable<GetOutletRevenueResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetOutletRevenueResponse.fromJS(resultData200) : new GetOutletRevenueResponse();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetOutletRevenueResponse>(<any>null);
    }

    /**
     * @param salesmanCode (optional) 
     * @param outletId (optional) 
     * @param outletCode (optional) 
     * @param outletName (optional) 
     * @param outletType (optional) 
     * @param rankCode (optional) 
     * @param regionCode (optional) 
     * @param productCode (optional) 
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param sortBy (optional) 
     * @param phone (optional) 
     * @param isCal (optional) 
     * @param storeType (optional) 
     * @return Success
     */
    getListOutlet(salesmanCode: string | null | undefined, outletId: number | null | undefined, outletCode: string | null | undefined, outletName: string | null | undefined, outletType: string | null | undefined, rankCode: string | null | undefined, regionCode: string | null | undefined, productCode: string | null | undefined, fromDate: moment.Moment | null | undefined, toDate: moment.Moment | null | undefined, sortBy: string | null | undefined, phone: string | null | undefined, isCal: boolean | null | undefined, storeType: string | null | undefined): Observable<PagedResultDtoOfGetListOutletResponse> {
        let url_ = this.baseUrl + "/api/services/app/OutletInfos/GetListOutlet?";
        if (salesmanCode !== undefined)
            url_ += "SalesmanCode=" + encodeURIComponent("" + salesmanCode) + "&";
        if (outletId !== undefined)
            url_ += "OutletId=" + encodeURIComponent("" + outletId) + "&";
        if (outletCode !== undefined)
            url_ += "OutletCode=" + encodeURIComponent("" + outletCode) + "&";
        if (outletName !== undefined)
            url_ += "OutletName=" + encodeURIComponent("" + outletName) + "&";
        if (outletType !== undefined)
            url_ += "OutletType=" + encodeURIComponent("" + outletType) + "&";
        if (rankCode !== undefined)
            url_ += "RankCode=" + encodeURIComponent("" + rankCode) + "&";
        if (regionCode !== undefined)
            url_ += "RegionCode=" + encodeURIComponent("" + regionCode) + "&";
        if (productCode !== undefined)
            url_ += "ProductCode=" + encodeURIComponent("" + productCode) + "&";
        if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toJSON() : "") + "&";
        if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toJSON() : "") + "&";
        if (sortBy !== undefined)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (phone !== undefined)
            url_ += "Phone=" + encodeURIComponent("" + phone) + "&";
        if (isCal !== undefined)
            url_ += "isCal=" + encodeURIComponent("" + isCal) + "&";
        if (storeType !== undefined)
            url_ += "StoreType=" + encodeURIComponent("" + storeType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetListOutlet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetListOutlet(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetListOutletResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetListOutletResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetListOutlet(response: HttpResponseBase): Observable<PagedResultDtoOfGetListOutletResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetListOutletResponse.fromJS(resultData200) : new PagedResultDtoOfGetListOutletResponse();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetListOutletResponse>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    approvedUpdateRequest(input: CreateOrEditOutletInfoDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OutletInfos/ApprovedUpdateRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processApprovedUpdateRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApprovedUpdateRequest(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processApprovedUpdateRequest(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param memberCode (optional) 
     * @param note (optional) 
     * @return Success
     */
    deleteOutLet(memberCode: string | null | undefined, note: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/OutletInfos/DeleteOutLet?";
        if (memberCode !== undefined)
            url_ += "memberCode=" + encodeURIComponent("" + memberCode) + "&";
        if (note !== undefined)
            url_ += "note=" + encodeURIComponent("" + note) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteOutLet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteOutLet(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteOutLet(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }
}

@Injectable()
export class OutletInfoUpdateHistoryServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param outletId (optional) 
     * @param outletCode (optional) 
     * @param oldContent (optional) 
     * @param newContent (optional) 
     * @param type (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(outletId: number | null | undefined, outletCode: string | null | undefined, oldContent: string | null | undefined, newContent: string | null | undefined, type: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfOutletInfoUpdateHistoryDto> {
        let url_ = this.baseUrl + "/api/services/app/OutletInfoUpdateHistory/GetAll?";
        if (outletId !== undefined)
            url_ += "OutletId=" + encodeURIComponent("" + outletId) + "&";
        if (outletCode !== undefined)
            url_ += "OutletCode=" + encodeURIComponent("" + outletCode) + "&";
        if (oldContent !== undefined)
            url_ += "OldContent=" + encodeURIComponent("" + oldContent) + "&";
        if (newContent !== undefined)
            url_ += "NewContent=" + encodeURIComponent("" + newContent) + "&";
        if (type !== undefined)
            url_ += "Type=" + encodeURIComponent("" + type) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfOutletInfoUpdateHistoryDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfOutletInfoUpdateHistoryDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfOutletInfoUpdateHistoryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfOutletInfoUpdateHistoryDto.fromJS(resultData200) : new PagedResultDtoOfOutletInfoUpdateHistoryDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfOutletInfoUpdateHistoryDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: CreateOrEditOutletInfoUpdateHistoryDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OutletInfoUpdateHistory/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class OutletRevenueBaselinesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param outletCodeFilter (optional) 
     * @param outletNameFilter (optional) 
     * @param maxTargetFilter (optional) 
     * @param minTargetFilter (optional) 
     * @param maxActualFilter (optional) 
     * @param minActualFilter (optional) 
     * @param maxBonusFilter (optional) 
     * @param minBonusFilter (optional) 
     * @param maxCumulatedMonthFilter (optional) 
     * @param minCumulatedMonthFilter (optional) 
     * @param maxUpdatedDateFilter (optional) 
     * @param minUpdatedDateFilter (optional) 
     * @param cumulatedMonthFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, outletCodeFilter: string | null | undefined, outletNameFilter: string | null | undefined, maxTargetFilter: number | null | undefined, minTargetFilter: number | null | undefined, maxActualFilter: number | null | undefined, minActualFilter: number | null | undefined, maxBonusFilter: number | null | undefined, minBonusFilter: number | null | undefined, maxCumulatedMonthFilter: number | null | undefined, minCumulatedMonthFilter: number | null | undefined, maxUpdatedDateFilter: number | null | undefined, minUpdatedDateFilter: number | null | undefined, cumulatedMonthFilter: number | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetOutletRevenueBaselineForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/OutletRevenueBaselines/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (outletCodeFilter !== undefined)
            url_ += "OutletCodeFilter=" + encodeURIComponent("" + outletCodeFilter) + "&";
        if (outletNameFilter !== undefined)
            url_ += "OutletNameFilter=" + encodeURIComponent("" + outletNameFilter) + "&";
        if (maxTargetFilter !== undefined)
            url_ += "MaxTargetFilter=" + encodeURIComponent("" + maxTargetFilter) + "&";
        if (minTargetFilter !== undefined)
            url_ += "MinTargetFilter=" + encodeURIComponent("" + minTargetFilter) + "&";
        if (maxActualFilter !== undefined)
            url_ += "MaxActualFilter=" + encodeURIComponent("" + maxActualFilter) + "&";
        if (minActualFilter !== undefined)
            url_ += "MinActualFilter=" + encodeURIComponent("" + minActualFilter) + "&";
        if (maxBonusFilter !== undefined)
            url_ += "MaxBonusFilter=" + encodeURIComponent("" + maxBonusFilter) + "&";
        if (minBonusFilter !== undefined)
            url_ += "MinBonusFilter=" + encodeURIComponent("" + minBonusFilter) + "&";
        if (maxCumulatedMonthFilter !== undefined)
            url_ += "MaxCumulatedMonthFilter=" + encodeURIComponent("" + maxCumulatedMonthFilter) + "&";
        if (minCumulatedMonthFilter !== undefined)
            url_ += "MinCumulatedMonthFilter=" + encodeURIComponent("" + minCumulatedMonthFilter) + "&";
        if (maxUpdatedDateFilter !== undefined)
            url_ += "MaxUpdatedDateFilter=" + encodeURIComponent("" + maxUpdatedDateFilter) + "&";
        if (minUpdatedDateFilter !== undefined)
            url_ += "MinUpdatedDateFilter=" + encodeURIComponent("" + minUpdatedDateFilter) + "&";
        if (cumulatedMonthFilter !== undefined)
            url_ += "CumulatedMonthFilter=" + encodeURIComponent("" + cumulatedMonthFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetOutletRevenueBaselineForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetOutletRevenueBaselineForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetOutletRevenueBaselineForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetOutletRevenueBaselineForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetOutletRevenueBaselineForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetOutletRevenueBaselineForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getOutletRevenueBaselineForEdit(id: number | null | undefined): Observable<GetOutletRevenueBaselineForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/OutletRevenueBaselines/GetOutletRevenueBaselineForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetOutletRevenueBaselineForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOutletRevenueBaselineForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetOutletRevenueBaselineForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetOutletRevenueBaselineForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetOutletRevenueBaselineForEdit(response: HttpResponseBase): Observable<GetOutletRevenueBaselineForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetOutletRevenueBaselineForEditOutput.fromJS(resultData200) : new GetOutletRevenueBaselineForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetOutletRevenueBaselineForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditOutletRevenueBaselineDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OutletRevenueBaselines/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OutletRevenueBaselines/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param outletCodeFilter (optional) 
     * @param outletNameFilter (optional) 
     * @param maxTargetFilter (optional) 
     * @param minTargetFilter (optional) 
     * @param maxActualFilter (optional) 
     * @param minActualFilter (optional) 
     * @param maxBonusFilter (optional) 
     * @param minBonusFilter (optional) 
     * @param maxCumulatedMonthFilter (optional) 
     * @param minCumulatedMonthFilter (optional) 
     * @param maxUpdatedDateFilter (optional) 
     * @param minUpdatedDateFilter (optional) 
     * @return Success
     */
    getOutletRevenueBaselinesToExcel(filter: string | null | undefined, outletCodeFilter: string | null | undefined, outletNameFilter: string | null | undefined, maxTargetFilter: number | null | undefined, minTargetFilter: number | null | undefined, maxActualFilter: number | null | undefined, minActualFilter: number | null | undefined, maxBonusFilter: number | null | undefined, minBonusFilter: number | null | undefined, maxCumulatedMonthFilter: number | null | undefined, minCumulatedMonthFilter: number | null | undefined, maxUpdatedDateFilter: number | null | undefined, minUpdatedDateFilter: number | null | undefined): Observable<SocialRetailerFileDto> {
        let url_ = this.baseUrl + "/api/services/app/OutletRevenueBaselines/GetOutletRevenueBaselinesToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (outletCodeFilter !== undefined)
            url_ += "OutletCodeFilter=" + encodeURIComponent("" + outletCodeFilter) + "&";
        if (outletNameFilter !== undefined)
            url_ += "OutletNameFilter=" + encodeURIComponent("" + outletNameFilter) + "&";
        if (maxTargetFilter !== undefined)
            url_ += "MaxTargetFilter=" + encodeURIComponent("" + maxTargetFilter) + "&";
        if (minTargetFilter !== undefined)
            url_ += "MinTargetFilter=" + encodeURIComponent("" + minTargetFilter) + "&";
        if (maxActualFilter !== undefined)
            url_ += "MaxActualFilter=" + encodeURIComponent("" + maxActualFilter) + "&";
        if (minActualFilter !== undefined)
            url_ += "MinActualFilter=" + encodeURIComponent("" + minActualFilter) + "&";
        if (maxBonusFilter !== undefined)
            url_ += "MaxBonusFilter=" + encodeURIComponent("" + maxBonusFilter) + "&";
        if (minBonusFilter !== undefined)
            url_ += "MinBonusFilter=" + encodeURIComponent("" + minBonusFilter) + "&";
        if (maxCumulatedMonthFilter !== undefined)
            url_ += "MaxCumulatedMonthFilter=" + encodeURIComponent("" + maxCumulatedMonthFilter) + "&";
        if (minCumulatedMonthFilter !== undefined)
            url_ += "MinCumulatedMonthFilter=" + encodeURIComponent("" + minCumulatedMonthFilter) + "&";
        if (maxUpdatedDateFilter !== undefined)
            url_ += "MaxUpdatedDateFilter=" + encodeURIComponent("" + maxUpdatedDateFilter) + "&";
        if (minUpdatedDateFilter !== undefined)
            url_ += "MinUpdatedDateFilter=" + encodeURIComponent("" + minUpdatedDateFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetOutletRevenueBaselinesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOutletRevenueBaselinesToExcel(<any>response_);
                } catch (e) {
                    return <Observable<SocialRetailerFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SocialRetailerFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetOutletRevenueBaselinesToExcel(response: HttpResponseBase): Observable<SocialRetailerFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? SocialRetailerFileDto.fromJS(resultData200) : new SocialRetailerFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SocialRetailerFileDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    baselineAll(input: GetAllOutletRevenueBaselinesInput | null | undefined): Observable<PagedResultDtoOfGetOutletRevenueBaselineForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/OutletRevenueBaselines/BaselineAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processBaselineAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBaselineAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetOutletRevenueBaselineForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetOutletRevenueBaselineForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processBaselineAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetOutletRevenueBaselineForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetOutletRevenueBaselineForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetOutletRevenueBaselineForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetOutletRevenueBaselineForViewDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    exportOutletRevenueBaselinesToExcel(input: GetAllOutletRevenueBaselinesInput | null | undefined): Observable<SocialRetailerFileDto> {
        let url_ = this.baseUrl + "/api/services/app/OutletRevenueBaselines/ExportOutletRevenueBaselinesToExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processExportOutletRevenueBaselinesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportOutletRevenueBaselinesToExcel(<any>response_);
                } catch (e) {
                    return <Observable<SocialRetailerFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SocialRetailerFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processExportOutletRevenueBaselinesToExcel(response: HttpResponseBase): Observable<SocialRetailerFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? SocialRetailerFileDto.fromJS(resultData200) : new SocialRetailerFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SocialRetailerFileDto>(<any>null);
    }

    /**
     * @param memberCode (optional) 
     * @return Success
     */
    getRevenue(memberCode: string | null | undefined): Observable<RetailerRevenueHistory[]> {
        let url_ = this.baseUrl + "/api/services/app/OutletRevenueBaselines/GetRevenue?";
        if (memberCode !== undefined)
            url_ += "memberCode=" + encodeURIComponent("" + memberCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetRevenue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRevenue(<any>response_);
                } catch (e) {
                    return <Observable<RetailerRevenueHistory[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<RetailerRevenueHistory[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetRevenue(response: HttpResponseBase): Observable<RetailerRevenueHistory[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(RetailerRevenueHistory.fromJS(item));
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RetailerRevenueHistory[]>(<any>null);
    }
}

@Injectable()
export class OutletUpdateHistorysServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param outletCodeFilter (optional) 
     * @param reasonPhoneFilter (optional) 
     * @param phoneUpdatedFilter (optional) 
     * @param maxPhoneUpdatedDateFilter (optional) 
     * @param minPhoneUpdatedDateFilter (optional) 
     * @param phoneUpdateStatusFilter (optional) 
     * @param oTPFilter (optional) 
     * @param maxGAPDistanceFilter (optional) 
     * @param minGAPDistanceFilter (optional) 
     * @param lATUpdatedFilter (optional) 
     * @param lNGUpdatedFilter (optional) 
     * @param maxAuthenOTPDateFilter (optional) 
     * @param minAuthenOTPDateFilter (optional) 
     * @param isDeleteFilter (optional) 
     * @param salesmanCodeFilter (optional) 
     * @param maxTimeSendOTPFilter (optional) 
     * @param minTimeSendOTPFilter (optional) 
     * @param homePhoneFilter (optional) 
     * @param updateTypeFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, outletCodeFilter: string | null | undefined, reasonPhoneFilter: string | null | undefined, phoneUpdatedFilter: string | null | undefined, maxPhoneUpdatedDateFilter: moment.Moment | null | undefined, minPhoneUpdatedDateFilter: moment.Moment | null | undefined, phoneUpdateStatusFilter: string | null | undefined, oTPFilter: string | null | undefined, maxGAPDistanceFilter: number | null | undefined, minGAPDistanceFilter: number | null | undefined, lATUpdatedFilter: string | null | undefined, lNGUpdatedFilter: string | null | undefined, maxAuthenOTPDateFilter: moment.Moment | null | undefined, minAuthenOTPDateFilter: moment.Moment | null | undefined, isDeleteFilter: number | null | undefined, salesmanCodeFilter: string | null | undefined, maxTimeSendOTPFilter: moment.Moment | null | undefined, minTimeSendOTPFilter: moment.Moment | null | undefined, homePhoneFilter: string | null | undefined, updateTypeFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetOutletUpdateHistoryForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/OutletUpdateHistorys/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (outletCodeFilter !== undefined)
            url_ += "OutletCodeFilter=" + encodeURIComponent("" + outletCodeFilter) + "&";
        if (reasonPhoneFilter !== undefined)
            url_ += "ReasonPhoneFilter=" + encodeURIComponent("" + reasonPhoneFilter) + "&";
        if (phoneUpdatedFilter !== undefined)
            url_ += "PhoneUpdatedFilter=" + encodeURIComponent("" + phoneUpdatedFilter) + "&";
        if (maxPhoneUpdatedDateFilter !== undefined)
            url_ += "MaxPhoneUpdatedDateFilter=" + encodeURIComponent(maxPhoneUpdatedDateFilter ? "" + maxPhoneUpdatedDateFilter.toJSON() : "") + "&";
        if (minPhoneUpdatedDateFilter !== undefined)
            url_ += "MinPhoneUpdatedDateFilter=" + encodeURIComponent(minPhoneUpdatedDateFilter ? "" + minPhoneUpdatedDateFilter.toJSON() : "") + "&";
        if (phoneUpdateStatusFilter !== undefined)
            url_ += "PhoneUpdateStatusFilter=" + encodeURIComponent("" + phoneUpdateStatusFilter) + "&";
        if (oTPFilter !== undefined)
            url_ += "OTPFilter=" + encodeURIComponent("" + oTPFilter) + "&";
        if (maxGAPDistanceFilter !== undefined)
            url_ += "MaxGAPDistanceFilter=" + encodeURIComponent("" + maxGAPDistanceFilter) + "&";
        if (minGAPDistanceFilter !== undefined)
            url_ += "MinGAPDistanceFilter=" + encodeURIComponent("" + minGAPDistanceFilter) + "&";
        if (lATUpdatedFilter !== undefined)
            url_ += "LATUpdatedFilter=" + encodeURIComponent("" + lATUpdatedFilter) + "&";
        if (lNGUpdatedFilter !== undefined)
            url_ += "LNGUpdatedFilter=" + encodeURIComponent("" + lNGUpdatedFilter) + "&";
        if (maxAuthenOTPDateFilter !== undefined)
            url_ += "MaxAuthenOTPDateFilter=" + encodeURIComponent(maxAuthenOTPDateFilter ? "" + maxAuthenOTPDateFilter.toJSON() : "") + "&";
        if (minAuthenOTPDateFilter !== undefined)
            url_ += "MinAuthenOTPDateFilter=" + encodeURIComponent(minAuthenOTPDateFilter ? "" + minAuthenOTPDateFilter.toJSON() : "") + "&";
        if (isDeleteFilter !== undefined)
            url_ += "IsDeleteFilter=" + encodeURIComponent("" + isDeleteFilter) + "&";
        if (salesmanCodeFilter !== undefined)
            url_ += "SalesmanCodeFilter=" + encodeURIComponent("" + salesmanCodeFilter) + "&";
        if (maxTimeSendOTPFilter !== undefined)
            url_ += "MaxTimeSendOTPFilter=" + encodeURIComponent(maxTimeSendOTPFilter ? "" + maxTimeSendOTPFilter.toJSON() : "") + "&";
        if (minTimeSendOTPFilter !== undefined)
            url_ += "MinTimeSendOTPFilter=" + encodeURIComponent(minTimeSendOTPFilter ? "" + minTimeSendOTPFilter.toJSON() : "") + "&";
        if (homePhoneFilter !== undefined)
            url_ += "HomePhoneFilter=" + encodeURIComponent("" + homePhoneFilter) + "&";
        if (updateTypeFilter !== undefined)
            url_ += "UpdateTypeFilter=" + encodeURIComponent("" + updateTypeFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetOutletUpdateHistoryForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetOutletUpdateHistoryForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetOutletUpdateHistoryForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetOutletUpdateHistoryForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetOutletUpdateHistoryForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetOutletUpdateHistoryForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getOutletUpdateHistoryForEdit(id: number | null | undefined): Observable<GetOutletUpdateHistoryForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/OutletUpdateHistorys/GetOutletUpdateHistoryForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetOutletUpdateHistoryForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOutletUpdateHistoryForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetOutletUpdateHistoryForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetOutletUpdateHistoryForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetOutletUpdateHistoryForEdit(response: HttpResponseBase): Observable<GetOutletUpdateHistoryForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetOutletUpdateHistoryForEditOutput.fromJS(resultData200) : new GetOutletUpdateHistoryForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetOutletUpdateHistoryForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditOutletUpdateHistoryDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OutletUpdateHistorys/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OutletUpdateHistorys/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param outletCodeFilter (optional) 
     * @param reasonPhoneFilter (optional) 
     * @param phoneUpdatedFilter (optional) 
     * @param maxPhoneUpdatedDateFilter (optional) 
     * @param minPhoneUpdatedDateFilter (optional) 
     * @param phoneUpdateStatusFilter (optional) 
     * @param oTPFilter (optional) 
     * @param maxGAPDistanceFilter (optional) 
     * @param minGAPDistanceFilter (optional) 
     * @param lATUpdatedFilter (optional) 
     * @param lNGUpdatedFilter (optional) 
     * @param maxAuthenOTPDateFilter (optional) 
     * @param minAuthenOTPDateFilter (optional) 
     * @param isDeleteFilter (optional) 
     * @param salesmanCodeFilter (optional) 
     * @param maxTimeSendOTPFilter (optional) 
     * @param minTimeSendOTPFilter (optional) 
     * @param homePhoneFilter (optional) 
     * @param updateTypeFilter (optional) 
     * @return Success
     */
    getOutletUpdateHistorysToExcel(filter: string | null | undefined, outletCodeFilter: string | null | undefined, reasonPhoneFilter: string | null | undefined, phoneUpdatedFilter: string | null | undefined, maxPhoneUpdatedDateFilter: moment.Moment | null | undefined, minPhoneUpdatedDateFilter: moment.Moment | null | undefined, phoneUpdateStatusFilter: string | null | undefined, oTPFilter: string | null | undefined, maxGAPDistanceFilter: number | null | undefined, minGAPDistanceFilter: number | null | undefined, lATUpdatedFilter: string | null | undefined, lNGUpdatedFilter: string | null | undefined, maxAuthenOTPDateFilter: moment.Moment | null | undefined, minAuthenOTPDateFilter: moment.Moment | null | undefined, isDeleteFilter: number | null | undefined, salesmanCodeFilter: string | null | undefined, maxTimeSendOTPFilter: moment.Moment | null | undefined, minTimeSendOTPFilter: moment.Moment | null | undefined, homePhoneFilter: string | null | undefined, updateTypeFilter: string | null | undefined): Observable<SocialRetailerFileDto> {
        let url_ = this.baseUrl + "/api/services/app/OutletUpdateHistorys/GetOutletUpdateHistorysToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (outletCodeFilter !== undefined)
            url_ += "OutletCodeFilter=" + encodeURIComponent("" + outletCodeFilter) + "&";
        if (reasonPhoneFilter !== undefined)
            url_ += "ReasonPhoneFilter=" + encodeURIComponent("" + reasonPhoneFilter) + "&";
        if (phoneUpdatedFilter !== undefined)
            url_ += "PhoneUpdatedFilter=" + encodeURIComponent("" + phoneUpdatedFilter) + "&";
        if (maxPhoneUpdatedDateFilter !== undefined)
            url_ += "MaxPhoneUpdatedDateFilter=" + encodeURIComponent(maxPhoneUpdatedDateFilter ? "" + maxPhoneUpdatedDateFilter.toJSON() : "") + "&";
        if (minPhoneUpdatedDateFilter !== undefined)
            url_ += "MinPhoneUpdatedDateFilter=" + encodeURIComponent(minPhoneUpdatedDateFilter ? "" + minPhoneUpdatedDateFilter.toJSON() : "") + "&";
        if (phoneUpdateStatusFilter !== undefined)
            url_ += "PhoneUpdateStatusFilter=" + encodeURIComponent("" + phoneUpdateStatusFilter) + "&";
        if (oTPFilter !== undefined)
            url_ += "OTPFilter=" + encodeURIComponent("" + oTPFilter) + "&";
        if (maxGAPDistanceFilter !== undefined)
            url_ += "MaxGAPDistanceFilter=" + encodeURIComponent("" + maxGAPDistanceFilter) + "&";
        if (minGAPDistanceFilter !== undefined)
            url_ += "MinGAPDistanceFilter=" + encodeURIComponent("" + minGAPDistanceFilter) + "&";
        if (lATUpdatedFilter !== undefined)
            url_ += "LATUpdatedFilter=" + encodeURIComponent("" + lATUpdatedFilter) + "&";
        if (lNGUpdatedFilter !== undefined)
            url_ += "LNGUpdatedFilter=" + encodeURIComponent("" + lNGUpdatedFilter) + "&";
        if (maxAuthenOTPDateFilter !== undefined)
            url_ += "MaxAuthenOTPDateFilter=" + encodeURIComponent(maxAuthenOTPDateFilter ? "" + maxAuthenOTPDateFilter.toJSON() : "") + "&";
        if (minAuthenOTPDateFilter !== undefined)
            url_ += "MinAuthenOTPDateFilter=" + encodeURIComponent(minAuthenOTPDateFilter ? "" + minAuthenOTPDateFilter.toJSON() : "") + "&";
        if (isDeleteFilter !== undefined)
            url_ += "IsDeleteFilter=" + encodeURIComponent("" + isDeleteFilter) + "&";
        if (salesmanCodeFilter !== undefined)
            url_ += "SalesmanCodeFilter=" + encodeURIComponent("" + salesmanCodeFilter) + "&";
        if (maxTimeSendOTPFilter !== undefined)
            url_ += "MaxTimeSendOTPFilter=" + encodeURIComponent(maxTimeSendOTPFilter ? "" + maxTimeSendOTPFilter.toJSON() : "") + "&";
        if (minTimeSendOTPFilter !== undefined)
            url_ += "MinTimeSendOTPFilter=" + encodeURIComponent(minTimeSendOTPFilter ? "" + minTimeSendOTPFilter.toJSON() : "") + "&";
        if (homePhoneFilter !== undefined)
            url_ += "HomePhoneFilter=" + encodeURIComponent("" + homePhoneFilter) + "&";
        if (updateTypeFilter !== undefined)
            url_ += "UpdateTypeFilter=" + encodeURIComponent("" + updateTypeFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetOutletUpdateHistorysToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOutletUpdateHistorysToExcel(<any>response_);
                } catch (e) {
                    return <Observable<SocialRetailerFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SocialRetailerFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetOutletUpdateHistorysToExcel(response: HttpResponseBase): Observable<SocialRetailerFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? SocialRetailerFileDto.fromJS(resultData200) : new SocialRetailerFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SocialRetailerFileDto>(<any>null);
    }
}

@Injectable()
export class PayBonussServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param outletCodeFilter (optional) 
     * @param maxRevenueFilter (optional) 
     * @param minRevenueFilter (optional) 
     * @param typeFilter (optional) 
     * @param maxMonthFilter (optional) 
     * @param minMonthFilter (optional) 
     * @param maxYearFilter (optional) 
     * @param minYearFilter (optional) 
     * @param maxCalculatedDateFilter (optional) 
     * @param minCalculatedDateFilter (optional) 
     * @param maxBonusPointFilter (optional) 
     * @param minBonusPointFilter (optional) 
     * @param maxBonusCoinFilter (optional) 
     * @param minBonusCoinFilter (optional) 
     * @param statusFilter (optional) 
     * @param maxBonusAmountFilter (optional) 
     * @param minBonusAmountFilter (optional) 
     * @param calculatedDateFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, outletCodeFilter: string | null | undefined, maxRevenueFilter: number | null | undefined, minRevenueFilter: number | null | undefined, typeFilter: string | null | undefined, maxMonthFilter: number | null | undefined, minMonthFilter: number | null | undefined, maxYearFilter: number | null | undefined, minYearFilter: number | null | undefined, maxCalculatedDateFilter: moment.Moment | null | undefined, minCalculatedDateFilter: moment.Moment | null | undefined, maxBonusPointFilter: number | null | undefined, minBonusPointFilter: number | null | undefined, maxBonusCoinFilter: number | null | undefined, minBonusCoinFilter: number | null | undefined, statusFilter: string | null | undefined, maxBonusAmountFilter: number | null | undefined, minBonusAmountFilter: number | null | undefined, calculatedDateFilter: moment.Moment | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetPayBonusForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/PayBonuss/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (outletCodeFilter !== undefined)
            url_ += "OutletCodeFilter=" + encodeURIComponent("" + outletCodeFilter) + "&";
        if (maxRevenueFilter !== undefined)
            url_ += "MaxRevenueFilter=" + encodeURIComponent("" + maxRevenueFilter) + "&";
        if (minRevenueFilter !== undefined)
            url_ += "MinRevenueFilter=" + encodeURIComponent("" + minRevenueFilter) + "&";
        if (typeFilter !== undefined)
            url_ += "TypeFilter=" + encodeURIComponent("" + typeFilter) + "&";
        if (maxMonthFilter !== undefined)
            url_ += "MaxMonthFilter=" + encodeURIComponent("" + maxMonthFilter) + "&";
        if (minMonthFilter !== undefined)
            url_ += "MinMonthFilter=" + encodeURIComponent("" + minMonthFilter) + "&";
        if (maxYearFilter !== undefined)
            url_ += "MaxYearFilter=" + encodeURIComponent("" + maxYearFilter) + "&";
        if (minYearFilter !== undefined)
            url_ += "MinYearFilter=" + encodeURIComponent("" + minYearFilter) + "&";
        if (maxCalculatedDateFilter !== undefined)
            url_ += "MaxCalculatedDateFilter=" + encodeURIComponent(maxCalculatedDateFilter ? "" + maxCalculatedDateFilter.toJSON() : "") + "&";
        if (minCalculatedDateFilter !== undefined)
            url_ += "MinCalculatedDateFilter=" + encodeURIComponent(minCalculatedDateFilter ? "" + minCalculatedDateFilter.toJSON() : "") + "&";
        if (maxBonusPointFilter !== undefined)
            url_ += "MaxBonusPointFilter=" + encodeURIComponent("" + maxBonusPointFilter) + "&";
        if (minBonusPointFilter !== undefined)
            url_ += "MinBonusPointFilter=" + encodeURIComponent("" + minBonusPointFilter) + "&";
        if (maxBonusCoinFilter !== undefined)
            url_ += "MaxBonusCoinFilter=" + encodeURIComponent("" + maxBonusCoinFilter) + "&";
        if (minBonusCoinFilter !== undefined)
            url_ += "MinBonusCoinFilter=" + encodeURIComponent("" + minBonusCoinFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (maxBonusAmountFilter !== undefined)
            url_ += "MaxBonusAmountFilter=" + encodeURIComponent("" + maxBonusAmountFilter) + "&";
        if (minBonusAmountFilter !== undefined)
            url_ += "MinBonusAmountFilter=" + encodeURIComponent("" + minBonusAmountFilter) + "&";
        if (calculatedDateFilter !== undefined)
            url_ += "CalculatedDateFilter=" + encodeURIComponent(calculatedDateFilter ? "" + calculatedDateFilter.toJSON() : "") + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetPayBonusForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetPayBonusForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetPayBonusForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetPayBonusForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetPayBonusForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetPayBonusForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getPayBonusForEdit(id: number | null | undefined): Observable<GetPayBonusForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/PayBonuss/GetPayBonusForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetPayBonusForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPayBonusForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetPayBonusForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetPayBonusForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetPayBonusForEdit(response: HttpResponseBase): Observable<GetPayBonusForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetPayBonusForEditOutput.fromJS(resultData200) : new GetPayBonusForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPayBonusForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditPayBonusDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PayBonuss/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PayBonuss/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param outletCodeFilter (optional) 
     * @param maxRevenueFilter (optional) 
     * @param minRevenueFilter (optional) 
     * @param typeFilter (optional) 
     * @param maxMonthFilter (optional) 
     * @param minMonthFilter (optional) 
     * @param maxYearFilter (optional) 
     * @param minYearFilter (optional) 
     * @param maxCalculatedDateFilter (optional) 
     * @param minCalculatedDateFilter (optional) 
     * @param maxBonusPointFilter (optional) 
     * @param minBonusPointFilter (optional) 
     * @param maxBonusCoinFilter (optional) 
     * @param minBonusCoinFilter (optional) 
     * @param statusFilter (optional) 
     * @param maxBonusAmountFilter (optional) 
     * @param minBonusAmountFilter (optional) 
     * @return Success
     */
    getPayBonussToExcel(filter: string | null | undefined, outletCodeFilter: string | null | undefined, maxRevenueFilter: number | null | undefined, minRevenueFilter: number | null | undefined, typeFilter: string | null | undefined, maxMonthFilter: number | null | undefined, minMonthFilter: number | null | undefined, maxYearFilter: number | null | undefined, minYearFilter: number | null | undefined, maxCalculatedDateFilter: moment.Moment | null | undefined, minCalculatedDateFilter: moment.Moment | null | undefined, maxBonusPointFilter: number | null | undefined, minBonusPointFilter: number | null | undefined, maxBonusCoinFilter: number | null | undefined, minBonusCoinFilter: number | null | undefined, statusFilter: string | null | undefined, maxBonusAmountFilter: number | null | undefined, minBonusAmountFilter: number | null | undefined): Observable<SocialRetailerFileDto> {
        let url_ = this.baseUrl + "/api/services/app/PayBonuss/GetPayBonussToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (outletCodeFilter !== undefined)
            url_ += "OutletCodeFilter=" + encodeURIComponent("" + outletCodeFilter) + "&";
        if (maxRevenueFilter !== undefined)
            url_ += "MaxRevenueFilter=" + encodeURIComponent("" + maxRevenueFilter) + "&";
        if (minRevenueFilter !== undefined)
            url_ += "MinRevenueFilter=" + encodeURIComponent("" + minRevenueFilter) + "&";
        if (typeFilter !== undefined)
            url_ += "TypeFilter=" + encodeURIComponent("" + typeFilter) + "&";
        if (maxMonthFilter !== undefined)
            url_ += "MaxMonthFilter=" + encodeURIComponent("" + maxMonthFilter) + "&";
        if (minMonthFilter !== undefined)
            url_ += "MinMonthFilter=" + encodeURIComponent("" + minMonthFilter) + "&";
        if (maxYearFilter !== undefined)
            url_ += "MaxYearFilter=" + encodeURIComponent("" + maxYearFilter) + "&";
        if (minYearFilter !== undefined)
            url_ += "MinYearFilter=" + encodeURIComponent("" + minYearFilter) + "&";
        if (maxCalculatedDateFilter !== undefined)
            url_ += "MaxCalculatedDateFilter=" + encodeURIComponent(maxCalculatedDateFilter ? "" + maxCalculatedDateFilter.toJSON() : "") + "&";
        if (minCalculatedDateFilter !== undefined)
            url_ += "MinCalculatedDateFilter=" + encodeURIComponent(minCalculatedDateFilter ? "" + minCalculatedDateFilter.toJSON() : "") + "&";
        if (maxBonusPointFilter !== undefined)
            url_ += "MaxBonusPointFilter=" + encodeURIComponent("" + maxBonusPointFilter) + "&";
        if (minBonusPointFilter !== undefined)
            url_ += "MinBonusPointFilter=" + encodeURIComponent("" + minBonusPointFilter) + "&";
        if (maxBonusCoinFilter !== undefined)
            url_ += "MaxBonusCoinFilter=" + encodeURIComponent("" + maxBonusCoinFilter) + "&";
        if (minBonusCoinFilter !== undefined)
            url_ += "MinBonusCoinFilter=" + encodeURIComponent("" + minBonusCoinFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (maxBonusAmountFilter !== undefined)
            url_ += "MaxBonusAmountFilter=" + encodeURIComponent("" + maxBonusAmountFilter) + "&";
        if (minBonusAmountFilter !== undefined)
            url_ += "MinBonusAmountFilter=" + encodeURIComponent("" + minBonusAmountFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetPayBonussToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPayBonussToExcel(<any>response_);
                } catch (e) {
                    return <Observable<SocialRetailerFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SocialRetailerFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetPayBonussToExcel(response: HttpResponseBase): Observable<SocialRetailerFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? SocialRetailerFileDto.fromJS(resultData200) : new SocialRetailerFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SocialRetailerFileDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    search(input: GetAllPayBonussInput | null | undefined): Observable<PagedResultDtoOfGetPayBonusForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/PayBonuss/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetPayBonusForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetPayBonusForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<PagedResultDtoOfGetPayBonusForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetPayBonusForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetPayBonusForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetPayBonusForViewDto>(<any>null);
    }

    /**
     * @param arg (optional) 
     * @return Success
     */
    importQueue(arg: PayBonusImportAgrs | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PayBonuss/ImportQueue";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(arg);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processImportQueue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportQueue(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processImportQueue(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    exportTemplate(): Observable<SocialRetailerFileDto> {
        let url_ = this.baseUrl + "/api/services/app/PayBonuss/ExportTemplate";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processExportTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportTemplate(<any>response_);
                } catch (e) {
                    return <Observable<SocialRetailerFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SocialRetailerFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processExportTemplate(response: HttpResponseBase): Observable<SocialRetailerFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? SocialRetailerFileDto.fromJS(resultData200) : new SocialRetailerFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SocialRetailerFileDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    payBonusExport(input: PayBonusExportInput | null | undefined): Observable<SocialRetailerFileDto> {
        let url_ = this.baseUrl + "/api/services/app/PayBonuss/PayBonusExport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processPayBonusExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPayBonusExport(<any>response_);
                } catch (e) {
                    return <Observable<SocialRetailerFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SocialRetailerFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processPayBonusExport(response: HttpResponseBase): Observable<SocialRetailerFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? SocialRetailerFileDto.fromJS(resultData200) : new SocialRetailerFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SocialRetailerFileDto>(<any>null);
    }

    /**
     * @param memberCode (optional) 
     * @param typeFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getPayBonus(memberCode: string | null | undefined, typeFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfRetailerPayBonusViewDto> {
        let url_ = this.baseUrl + "/api/services/app/PayBonuss/GetPayBonus?";
        if (memberCode !== undefined)
            url_ += "MemberCode=" + encodeURIComponent("" + memberCode) + "&";
        if (typeFilter !== undefined)
            url_ += "TypeFilter=" + encodeURIComponent("" + typeFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetPayBonus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPayBonus(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfRetailerPayBonusViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfRetailerPayBonusViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetPayBonus(response: HttpResponseBase): Observable<PagedResultDtoOfRetailerPayBonusViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfRetailerPayBonusViewDto.fromJS(resultData200) : new PagedResultDtoOfRetailerPayBonusViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfRetailerPayBonusViewDto>(<any>null);
    }
}

@Injectable()
export class PaymentServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param upgradeEditionId (optional) 
     * @return Success
     */
    getPaymentInfo(upgradeEditionId: number | null | undefined): Observable<PaymentInfoDto> {
        let url_ = this.baseUrl + "/api/services/app/Payment/GetPaymentInfo?";
        if (upgradeEditionId !== undefined)
            url_ += "UpgradeEditionId=" + encodeURIComponent("" + upgradeEditionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetPaymentInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaymentInfo(<any>response_);
                } catch (e) {
                    return <Observable<PaymentInfoDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PaymentInfoDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetPaymentInfo(response: HttpResponseBase): Observable<PaymentInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PaymentInfoDto.fromJS(resultData200) : new PaymentInfoDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaymentInfoDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createPayment(input: CreatePaymentDto | null | undefined): Observable<any> {
        let url_ = this.baseUrl + "/api/services/app/Payment/CreatePayment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreatePayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePayment(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected processCreatePayment(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    cancelPayment(input: CancelPaymentDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Payment/CancelPayment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCancelPayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelPayment(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCancelPayment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    executePayment(input: ExecutePaymentDto | null | undefined): Observable<any> {
        let url_ = this.baseUrl + "/api/services/app/Payment/ExecutePayment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processExecutePayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExecutePayment(<any>response_);
                } catch (e) {
                    return <Observable<any>><any>_observableThrow(e);
                }
            } else
                return <Observable<any>><any>_observableThrow(response_);
        }));
    }

    protected processExecutePayment(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<any>(<any>null);
    }

    /**
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getPaymentHistory(sorting: string | null | undefined, maxResultCount: number | null | undefined, skipCount: number | null | undefined): Observable<PagedResultDtoOfSubscriptionPaymentListDto> {
        let url_ = this.baseUrl + "/api/services/app/Payment/GetPaymentHistory?";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetPaymentHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaymentHistory(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfSubscriptionPaymentListDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfSubscriptionPaymentListDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetPaymentHistory(response: HttpResponseBase): Observable<PagedResultDtoOfSubscriptionPaymentListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfSubscriptionPaymentListDto.fromJS(resultData200) : new PagedResultDtoOfSubscriptionPaymentListDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfSubscriptionPaymentListDto>(<any>null);
    }
}

@Injectable()
export class PaymentTransactionsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param salesInvoiceCodeFilter (optional) 
     * @param paymentMethodFilter (optional) 
     * @param maxAmountFilter (optional) 
     * @param minAmountFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, salesInvoiceCodeFilter: string | null | undefined, paymentMethodFilter: string | null | undefined, maxAmountFilter: number | null | undefined, minAmountFilter: number | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetPaymentTransactionForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/PaymentTransactions/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (salesInvoiceCodeFilter !== undefined)
            url_ += "SalesInvoiceCodeFilter=" + encodeURIComponent("" + salesInvoiceCodeFilter) + "&";
        if (paymentMethodFilter !== undefined)
            url_ += "PaymentMethodFilter=" + encodeURIComponent("" + paymentMethodFilter) + "&";
        if (maxAmountFilter !== undefined)
            url_ += "MaxAmountFilter=" + encodeURIComponent("" + maxAmountFilter) + "&";
        if (minAmountFilter !== undefined)
            url_ += "MinAmountFilter=" + encodeURIComponent("" + minAmountFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetPaymentTransactionForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetPaymentTransactionForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetPaymentTransactionForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetPaymentTransactionForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetPaymentTransactionForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetPaymentTransactionForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getPaymentTransactionForEdit(id: number | null | undefined): Observable<GetPaymentTransactionForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/PaymentTransactions/GetPaymentTransactionForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetPaymentTransactionForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaymentTransactionForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetPaymentTransactionForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetPaymentTransactionForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetPaymentTransactionForEdit(response: HttpResponseBase): Observable<GetPaymentTransactionForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetPaymentTransactionForEditOutput.fromJS(resultData200) : new GetPaymentTransactionForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPaymentTransactionForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditPaymentTransactionDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PaymentTransactions/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PaymentTransactions/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param salesInvoiceCodeFilter (optional) 
     * @param paymentMethodFilter (optional) 
     * @param maxAmountFilter (optional) 
     * @param minAmountFilter (optional) 
     * @return Success
     */
    getPaymentTransactionsToExcel(filter: string | null | undefined, salesInvoiceCodeFilter: string | null | undefined, paymentMethodFilter: string | null | undefined, maxAmountFilter: number | null | undefined, minAmountFilter: number | null | undefined): Observable<ConsumerDBFileDto> {
        let url_ = this.baseUrl + "/api/services/app/PaymentTransactions/GetPaymentTransactionsToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (salesInvoiceCodeFilter !== undefined)
            url_ += "SalesInvoiceCodeFilter=" + encodeURIComponent("" + salesInvoiceCodeFilter) + "&";
        if (paymentMethodFilter !== undefined)
            url_ += "PaymentMethodFilter=" + encodeURIComponent("" + paymentMethodFilter) + "&";
        if (maxAmountFilter !== undefined)
            url_ += "MaxAmountFilter=" + encodeURIComponent("" + maxAmountFilter) + "&";
        if (minAmountFilter !== undefined)
            url_ += "MinAmountFilter=" + encodeURIComponent("" + minAmountFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetPaymentTransactionsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaymentTransactionsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<ConsumerDBFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ConsumerDBFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetPaymentTransactionsToExcel(response: HttpResponseBase): Observable<ConsumerDBFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? ConsumerDBFileDto.fromJS(resultData200) : new ConsumerDBFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ConsumerDBFileDto>(<any>null);
    }
}

@Injectable()
export class PeriodTimeHistoriesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param startPeriodTimeFilter (optional) 
     * @param endPeriodTimeFilter (optional) 
     * @param isActiveFilter (optional) 
     * @param typeFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, startPeriodTimeFilter: string | null | undefined, endPeriodTimeFilter: string | null | undefined, isActiveFilter: number | null | undefined, typeFilter: number | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetPeriodTimeHistoryForView> {
        let url_ = this.baseUrl + "/api/services/app/PeriodTimeHistories/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (startPeriodTimeFilter !== undefined)
            url_ += "StartPeriodTimeFilter=" + encodeURIComponent("" + startPeriodTimeFilter) + "&";
        if (endPeriodTimeFilter !== undefined)
            url_ += "EndPeriodTimeFilter=" + encodeURIComponent("" + endPeriodTimeFilter) + "&";
        if (isActiveFilter !== undefined)
            url_ += "IsActiveFilter=" + encodeURIComponent("" + isActiveFilter) + "&";
        if (typeFilter !== undefined)
            url_ += "TypeFilter=" + encodeURIComponent("" + typeFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetPeriodTimeHistoryForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetPeriodTimeHistoryForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetPeriodTimeHistoryForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetPeriodTimeHistoryForView.fromJS(resultData200) : new PagedResultDtoOfGetPeriodTimeHistoryForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetPeriodTimeHistoryForView>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getPeriodTimeHistoryForEdit(id: number | null | undefined): Observable<GetPeriodTimeHistoryForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/PeriodTimeHistories/GetPeriodTimeHistoryForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetPeriodTimeHistoryForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPeriodTimeHistoryForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetPeriodTimeHistoryForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetPeriodTimeHistoryForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetPeriodTimeHistoryForEdit(response: HttpResponseBase): Observable<GetPeriodTimeHistoryForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetPeriodTimeHistoryForEditOutput.fromJS(resultData200) : new GetPeriodTimeHistoryForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPeriodTimeHistoryForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditPeriodTimeHistoryDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PeriodTimeHistories/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PeriodTimeHistories/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param typeFilter (optional) 
     * @param timeRequest (optional) 
     * @param isTempRank (optional) 
     * @return Success
     */
    getCurrentPeriodHistoryTimeByType(typeFilter: TypeFilter | null | undefined, timeRequest: moment.Moment | null | undefined, isTempRank: boolean | null | undefined): Observable<GetPeriodTimeHistoryByFilter> {
        let url_ = this.baseUrl + "/api/services/app/PeriodTimeHistories/GetCurrentPeriodHistoryTimeByType?";
        if (typeFilter !== undefined)
            url_ += "TypeFilter=" + encodeURIComponent("" + typeFilter) + "&";
        if (timeRequest !== undefined)
            url_ += "TimeRequest=" + encodeURIComponent(timeRequest ? "" + timeRequest.toJSON() : "") + "&";
        if (isTempRank !== undefined)
            url_ += "isTempRank=" + encodeURIComponent("" + isTempRank) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCurrentPeriodHistoryTimeByType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentPeriodHistoryTimeByType(<any>response_);
                } catch (e) {
                    return <Observable<GetPeriodTimeHistoryByFilter>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetPeriodTimeHistoryByFilter>><any>_observableThrow(response_);
        }));
    }

    protected processGetCurrentPeriodHistoryTimeByType(response: HttpResponseBase): Observable<GetPeriodTimeHistoryByFilter> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetPeriodTimeHistoryByFilter.fromJS(resultData200) : new GetPeriodTimeHistoryByFilter();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPeriodTimeHistoryByFilter>(<any>null);
    }
}

@Injectable()
export class PermissionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAllPermissions(): Observable<ListResultDtoOfFlatPermissionWithLevelDto> {
        let url_ = this.baseUrl + "/api/services/app/Permission/GetAllPermissions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllPermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPermissions(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfFlatPermissionWithLevelDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfFlatPermissionWithLevelDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllPermissions(response: HttpResponseBase): Observable<ListResultDtoOfFlatPermissionWithLevelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? ListResultDtoOfFlatPermissionWithLevelDto.fromJS(resultData200) : new ListResultDtoOfFlatPermissionWithLevelDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfFlatPermissionWithLevelDto>(<any>null);
    }
}

@Injectable()
export class PlayerTicketsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param playerCodeFilter (optional) 
     * @param gameCodeFilter (optional) 
     * @param statusFilter (optional) 
     * @param maxUsedDateFilter (optional) 
     * @param minUsedDateFilter (optional) 
     * @param maxExpiredDateTimeFilter (optional) 
     * @param minExpiredDateTimeFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, playerCodeFilter: string | null | undefined, gameCodeFilter: string | null | undefined, statusFilter: string | null | undefined, maxUsedDateFilter: moment.Moment | null | undefined, minUsedDateFilter: moment.Moment | null | undefined, maxExpiredDateTimeFilter: moment.Moment | null | undefined, minExpiredDateTimeFilter: moment.Moment | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetPlayerTicketForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/PlayerTickets/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (playerCodeFilter !== undefined)
            url_ += "PlayerCodeFilter=" + encodeURIComponent("" + playerCodeFilter) + "&";
        if (gameCodeFilter !== undefined)
            url_ += "GameCodeFilter=" + encodeURIComponent("" + gameCodeFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (maxUsedDateFilter !== undefined)
            url_ += "MaxUsedDateFilter=" + encodeURIComponent(maxUsedDateFilter ? "" + maxUsedDateFilter.toJSON() : "") + "&";
        if (minUsedDateFilter !== undefined)
            url_ += "MinUsedDateFilter=" + encodeURIComponent(minUsedDateFilter ? "" + minUsedDateFilter.toJSON() : "") + "&";
        if (maxExpiredDateTimeFilter !== undefined)
            url_ += "MaxExpiredDateTimeFilter=" + encodeURIComponent(maxExpiredDateTimeFilter ? "" + maxExpiredDateTimeFilter.toJSON() : "") + "&";
        if (minExpiredDateTimeFilter !== undefined)
            url_ += "MinExpiredDateTimeFilter=" + encodeURIComponent(minExpiredDateTimeFilter ? "" + minExpiredDateTimeFilter.toJSON() : "") + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetPlayerTicketForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetPlayerTicketForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetPlayerTicketForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetPlayerTicketForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetPlayerTicketForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetPlayerTicketForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getPlayerTicketForEdit(id: number | null | undefined): Observable<GetPlayerTicketForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/PlayerTickets/GetPlayerTicketForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetPlayerTicketForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPlayerTicketForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetPlayerTicketForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetPlayerTicketForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetPlayerTicketForEdit(response: HttpResponseBase): Observable<GetPlayerTicketForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetPlayerTicketForEditOutput.fromJS(resultData200) : new GetPlayerTicketForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPlayerTicketForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditPlayerTicketDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PlayerTickets/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PlayerTickets/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param playerCodeFilter (optional) 
     * @param gameCodeFilter (optional) 
     * @param statusFilter (optional) 
     * @param maxUsedDateFilter (optional) 
     * @param minUsedDateFilter (optional) 
     * @param maxExpiredDateTimeFilter (optional) 
     * @param minExpiredDateTimeFilter (optional) 
     * @return Success
     */
    getPlayerTicketsToExcel(filter: string | null | undefined, playerCodeFilter: string | null | undefined, gameCodeFilter: string | null | undefined, statusFilter: string | null | undefined, maxUsedDateFilter: moment.Moment | null | undefined, minUsedDateFilter: moment.Moment | null | undefined, maxExpiredDateTimeFilter: moment.Moment | null | undefined, minExpiredDateTimeFilter: moment.Moment | null | undefined): Observable<GamificationFileDto> {
        let url_ = this.baseUrl + "/api/services/app/PlayerTickets/GetPlayerTicketsToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (playerCodeFilter !== undefined)
            url_ += "PlayerCodeFilter=" + encodeURIComponent("" + playerCodeFilter) + "&";
        if (gameCodeFilter !== undefined)
            url_ += "GameCodeFilter=" + encodeURIComponent("" + gameCodeFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (maxUsedDateFilter !== undefined)
            url_ += "MaxUsedDateFilter=" + encodeURIComponent(maxUsedDateFilter ? "" + maxUsedDateFilter.toJSON() : "") + "&";
        if (minUsedDateFilter !== undefined)
            url_ += "MinUsedDateFilter=" + encodeURIComponent(minUsedDateFilter ? "" + minUsedDateFilter.toJSON() : "") + "&";
        if (maxExpiredDateTimeFilter !== undefined)
            url_ += "MaxExpiredDateTimeFilter=" + encodeURIComponent(maxExpiredDateTimeFilter ? "" + maxExpiredDateTimeFilter.toJSON() : "") + "&";
        if (minExpiredDateTimeFilter !== undefined)
            url_ += "MinExpiredDateTimeFilter=" + encodeURIComponent(minExpiredDateTimeFilter ? "" + minExpiredDateTimeFilter.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetPlayerTicketsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPlayerTicketsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<GamificationFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GamificationFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetPlayerTicketsToExcel(response: HttpResponseBase): Observable<GamificationFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GamificationFileDto.fromJS(resultData200) : new GamificationFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GamificationFileDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    search(input: GetAllPlayerTicketsInput | null | undefined): Observable<PagedResultDtoOfGetPlayerTicketForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/PlayerTickets/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetPlayerTicketForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetPlayerTicketForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<PagedResultDtoOfGetPlayerTicketForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetPlayerTicketForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetPlayerTicketForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetPlayerTicketForViewDto>(<any>null);
    }

    /**
     * @param gameCode (optional) 
     * @return Success
     */
    getTicketCount(gameCode: string | null | undefined): Observable<GetTicketCountForView> {
        let url_ = this.baseUrl + "/api/services/app/PlayerTickets/GetTicketCount?";
        if (gameCode !== undefined)
            url_ += "gameCode=" + encodeURIComponent("" + gameCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetTicketCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTicketCount(<any>response_);
                } catch (e) {
                    return <Observable<GetTicketCountForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetTicketCountForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetTicketCount(response: HttpResponseBase): Observable<GetTicketCountForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetTicketCountForView.fromJS(resultData200) : new GetTicketCountForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTicketCountForView>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    exportPlayerTicketsToExcel(input: GetAllPlayerTicketsForExcelInput | null | undefined): Observable<GamificationFileDto> {
        let url_ = this.baseUrl + "/api/services/app/PlayerTickets/ExportPlayerTicketsToExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processExportPlayerTicketsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportPlayerTicketsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<GamificationFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GamificationFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processExportPlayerTicketsToExcel(response: HttpResponseBase): Observable<GamificationFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GamificationFileDto.fromJS(resultData200) : new GamificationFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GamificationFileDto>(<any>null);
    }
}

@Injectable()
export class PlayerTicketsExcelExporterServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param playerTickets (optional) 
     * @return Success
     */
    exportToFile(playerTickets: GetPlayerTicketForViewDto[] | null | undefined): Observable<GamificationFileDto> {
        let url_ = this.baseUrl + "/api/services/app/PlayerTicketsExcelExporter/ExportToFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(playerTickets);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processExportToFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportToFile(<any>response_);
                } catch (e) {
                    return <Observable<GamificationFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GamificationFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processExportToFile(response: HttpResponseBase): Observable<GamificationFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GamificationFileDto.fromJS(resultData200) : new GamificationFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GamificationFileDto>(<any>null);
    }

    /**
     * @param playerTickets (optional) 
     * @return Success
     */
    exportToFileExt(playerTickets: GetPlayerTicketForViewDto[] | null | undefined): Observable<GamificationFileDto> {
        let url_ = this.baseUrl + "/api/services/app/PlayerTicketsExcelExporter/ExportToFileExt";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(playerTickets);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processExportToFileExt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportToFileExt(<any>response_);
                } catch (e) {
                    return <Observable<GamificationFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GamificationFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processExportToFileExt(response: HttpResponseBase): Observable<GamificationFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GamificationFileDto.fromJS(resultData200) : new GamificationFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GamificationFileDto>(<any>null);
    }
}

@Injectable()
export class PointOverviewReportServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @return Success
     */
    getData(filter: string | null | undefined): Observable<PointOverviewReportDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PointOverviewReport/GetData?";
        if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetData(<any>response_);
                } catch (e) {
                    return <Observable<PointOverviewReportDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<PointOverviewReportDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetData(response: HttpResponseBase): Observable<PointOverviewReportDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(PointOverviewReportDto.fromJS(item));
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PointOverviewReportDto[]>(<any>null);
    }

    /**
     * @param typeImportData (optional) 
     * @return Success
     */
    exportData(typeImportData: string | null | undefined): Observable<PointOverviewReportDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PointOverviewReport/ExportData?";
        if (typeImportData !== undefined)
            url_ += "typeImportData=" + encodeURIComponent("" + typeImportData) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processExportData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportData(<any>response_);
                } catch (e) {
                    return <Observable<PointOverviewReportDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<PointOverviewReportDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processExportData(response: HttpResponseBase): Observable<PointOverviewReportDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(PointOverviewReportDto.fromJS(item));
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PointOverviewReportDto[]>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @return Success
     */
    exportFile(filter: string | null | undefined): Observable<PointFileDto> {
        let url_ = this.baseUrl + "/api/services/app/PointOverviewReport/ExportFile?";
        if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processExportFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportFile(<any>response_);
                } catch (e) {
                    return <Observable<PointFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PointFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processExportFile(response: HttpResponseBase): Observable<PointFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PointFileDto.fromJS(resultData200) : new PointFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PointFileDto>(<any>null);
    }
}

@Injectable()
export class PosmServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditPosmDto | null | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Posm/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param memberCode (optional) 
     * @param pOSMResultID (optional) 
     * @param creatorUserId (optional) 
     * @param salesmanCode (optional) 
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(memberCode: string | null | undefined, pOSMResultID: number | null | undefined, creatorUserId: number | null | undefined, salesmanCode: string | null | undefined, fromDate: moment.Moment | null | undefined, toDate: moment.Moment | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetListPosmDto> {
        let url_ = this.baseUrl + "/api/services/app/Posm/GetAll?";
        if (memberCode !== undefined)
            url_ += "MemberCode=" + encodeURIComponent("" + memberCode) + "&";
        if (pOSMResultID !== undefined)
            url_ += "POSMResultID=" + encodeURIComponent("" + pOSMResultID) + "&";
        if (creatorUserId !== undefined)
            url_ += "CreatorUserId=" + encodeURIComponent("" + creatorUserId) + "&";
        if (salesmanCode !== undefined)
            url_ += "SalesmanCode=" + encodeURIComponent("" + salesmanCode) + "&";
        if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toJSON() : "") + "&";
        if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toJSON() : "") + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetListPosmDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetListPosmDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetListPosmDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetListPosmDto.fromJS(resultData200) : new PagedResultDtoOfGetListPosmDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetListPosmDto>(<any>null);
    }

    /**
     * @return Success
     */
    getPosmType(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/Posm/GetPosmType";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetPosmType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPosmType(<any>response_);
                } catch (e) {
                    return <Observable<string[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<string[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetPosmType(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(item);
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string[]>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createFileExcel(input: GetPosmInput | null | undefined): Observable<SocialRetailerFileDto> {
        let url_ = this.baseUrl + "/api/services/app/Posm/CreateFileExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateFileExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateFileExcel(<any>response_);
                } catch (e) {
                    return <Observable<SocialRetailerFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SocialRetailerFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreateFileExcel(response: HttpResponseBase): Observable<SocialRetailerFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? SocialRetailerFileDto.fromJS(resultData200) : new SocialRetailerFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SocialRetailerFileDto>(<any>null);
    }
}

@Injectable()
export class ProductCategoriesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param codeFilter (optional) 
     * @param nameFilter (optional) 
     * @param maxEffectiveFromFilter (optional) 
     * @param minEffectiveFromFilter (optional) 
     * @param maxEffectiveToFilter (optional) 
     * @param minEffectiveToFilter (optional) 
     * @param isActiveFilter (optional) 
     * @param targetAudienceFilter (optional) 
     * @param maxCoinValueFilter (optional) 
     * @param minCoinValueFilter (optional) 
     * @param maxPointValueFilter (optional) 
     * @param minPointValueFilter (optional) 
     * @param campaignFilter (optional) 
     * @param campaignId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, codeFilter: string | null | undefined, nameFilter: string | null | undefined, maxEffectiveFromFilter: moment.Moment | null | undefined, minEffectiveFromFilter: moment.Moment | null | undefined, maxEffectiveToFilter: moment.Moment | null | undefined, minEffectiveToFilter: moment.Moment | null | undefined, isActiveFilter: number | null | undefined, targetAudienceFilter: string | null | undefined, maxCoinValueFilter: number | null | undefined, minCoinValueFilter: number | null | undefined, maxPointValueFilter: number | null | undefined, minPointValueFilter: number | null | undefined, campaignFilter: string | null | undefined, campaignId: number | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetProductCategoryForView> {
        let url_ = this.baseUrl + "/api/services/app/ProductCategories/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&";
        if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (maxEffectiveFromFilter !== undefined)
            url_ += "MaxEffectiveFromFilter=" + encodeURIComponent(maxEffectiveFromFilter ? "" + maxEffectiveFromFilter.toJSON() : "") + "&";
        if (minEffectiveFromFilter !== undefined)
            url_ += "MinEffectiveFromFilter=" + encodeURIComponent(minEffectiveFromFilter ? "" + minEffectiveFromFilter.toJSON() : "") + "&";
        if (maxEffectiveToFilter !== undefined)
            url_ += "MaxEffectiveToFilter=" + encodeURIComponent(maxEffectiveToFilter ? "" + maxEffectiveToFilter.toJSON() : "") + "&";
        if (minEffectiveToFilter !== undefined)
            url_ += "MinEffectiveToFilter=" + encodeURIComponent(minEffectiveToFilter ? "" + minEffectiveToFilter.toJSON() : "") + "&";
        if (isActiveFilter !== undefined)
            url_ += "IsActiveFilter=" + encodeURIComponent("" + isActiveFilter) + "&";
        if (targetAudienceFilter !== undefined)
            url_ += "TargetAudienceFilter=" + encodeURIComponent("" + targetAudienceFilter) + "&";
        if (maxCoinValueFilter !== undefined)
            url_ += "MaxCoinValueFilter=" + encodeURIComponent("" + maxCoinValueFilter) + "&";
        if (minCoinValueFilter !== undefined)
            url_ += "MinCoinValueFilter=" + encodeURIComponent("" + minCoinValueFilter) + "&";
        if (maxPointValueFilter !== undefined)
            url_ += "MaxPointValueFilter=" + encodeURIComponent("" + maxPointValueFilter) + "&";
        if (minPointValueFilter !== undefined)
            url_ += "MinPointValueFilter=" + encodeURIComponent("" + minPointValueFilter) + "&";
        if (campaignFilter !== undefined)
            url_ += "CampaignFilter=" + encodeURIComponent("" + campaignFilter) + "&";
        if (campaignId !== undefined)
            url_ += "CampaignId=" + encodeURIComponent("" + campaignId) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetProductCategoryForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetProductCategoryForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetProductCategoryForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetProductCategoryForView.fromJS(resultData200) : new PagedResultDtoOfGetProductCategoryForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetProductCategoryForView>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getProductCategoryForEdit(id: number | null | undefined): Observable<GetProductCategoryForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/ProductCategories/GetProductCategoryForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetProductCategoryForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductCategoryForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetProductCategoryForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetProductCategoryForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetProductCategoryForEdit(response: HttpResponseBase): Observable<GetProductCategoryForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetProductCategoryForEditOutput.fromJS(resultData200) : new GetProductCategoryForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetProductCategoryForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditProductCategoryDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ProductCategories/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param inputValidate (optional) 
     * @return Success
     */
    validateInputAsync(inputValidate: CreateOrEditProductCategoryDto | null | undefined): Observable<ValidationResult[]> {
        let url_ = this.baseUrl + "/api/services/app/ProductCategories/ValidateInputAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inputValidate);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processValidateInputAsync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateInputAsync(<any>response_);
                } catch (e) {
                    return <Observable<ValidationResult[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ValidationResult[]>><any>_observableThrow(response_);
        }));
    }

    protected processValidateInputAsync(response: HttpResponseBase): Observable<ValidationResult[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(ValidationResult.fromJS(item));
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ValidationResult[]>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ProductCategories/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param codeFilter (optional) 
     * @param nameFilter (optional) 
     * @param maxEffectiveFromFilter (optional) 
     * @param minEffectiveFromFilter (optional) 
     * @param maxEffectiveToFilter (optional) 
     * @param minEffectiveToFilter (optional) 
     * @param isActiveFilter (optional) 
     * @param targetAudienceFilter (optional) 
     * @param maxCoinValueFilter (optional) 
     * @param minCoinValueFilter (optional) 
     * @param maxPointValueFilter (optional) 
     * @param minPointValueFilter (optional) 
     * @param campaignFilter (optional) 
     * @param campaignId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllProductCategory(filter: string | null | undefined, codeFilter: string | null | undefined, nameFilter: string | null | undefined, maxEffectiveFromFilter: moment.Moment | null | undefined, minEffectiveFromFilter: moment.Moment | null | undefined, maxEffectiveToFilter: moment.Moment | null | undefined, minEffectiveToFilter: moment.Moment | null | undefined, isActiveFilter: number | null | undefined, targetAudienceFilter: string | null | undefined, maxCoinValueFilter: number | null | undefined, minCoinValueFilter: number | null | undefined, maxPointValueFilter: number | null | undefined, minPointValueFilter: number | null | undefined, campaignFilter: string | null | undefined, campaignId: number | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<ListResultDtoOfProductCategoryDto> {
        let url_ = this.baseUrl + "/api/services/app/ProductCategories/GetAllProductCategory?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&";
        if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (maxEffectiveFromFilter !== undefined)
            url_ += "MaxEffectiveFromFilter=" + encodeURIComponent(maxEffectiveFromFilter ? "" + maxEffectiveFromFilter.toJSON() : "") + "&";
        if (minEffectiveFromFilter !== undefined)
            url_ += "MinEffectiveFromFilter=" + encodeURIComponent(minEffectiveFromFilter ? "" + minEffectiveFromFilter.toJSON() : "") + "&";
        if (maxEffectiveToFilter !== undefined)
            url_ += "MaxEffectiveToFilter=" + encodeURIComponent(maxEffectiveToFilter ? "" + maxEffectiveToFilter.toJSON() : "") + "&";
        if (minEffectiveToFilter !== undefined)
            url_ += "MinEffectiveToFilter=" + encodeURIComponent(minEffectiveToFilter ? "" + minEffectiveToFilter.toJSON() : "") + "&";
        if (isActiveFilter !== undefined)
            url_ += "IsActiveFilter=" + encodeURIComponent("" + isActiveFilter) + "&";
        if (targetAudienceFilter !== undefined)
            url_ += "TargetAudienceFilter=" + encodeURIComponent("" + targetAudienceFilter) + "&";
        if (maxCoinValueFilter !== undefined)
            url_ += "MaxCoinValueFilter=" + encodeURIComponent("" + maxCoinValueFilter) + "&";
        if (minCoinValueFilter !== undefined)
            url_ += "MinCoinValueFilter=" + encodeURIComponent("" + minCoinValueFilter) + "&";
        if (maxPointValueFilter !== undefined)
            url_ += "MaxPointValueFilter=" + encodeURIComponent("" + maxPointValueFilter) + "&";
        if (minPointValueFilter !== undefined)
            url_ += "MinPointValueFilter=" + encodeURIComponent("" + minPointValueFilter) + "&";
        if (campaignFilter !== undefined)
            url_ += "CampaignFilter=" + encodeURIComponent("" + campaignFilter) + "&";
        if (campaignId !== undefined)
            url_ += "CampaignId=" + encodeURIComponent("" + campaignId) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllProductCategory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllProductCategory(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfProductCategoryDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfProductCategoryDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllProductCategory(response: HttpResponseBase): Observable<ListResultDtoOfProductCategoryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? ListResultDtoOfProductCategoryDto.fromJS(resultData200) : new ListResultDtoOfProductCategoryDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfProductCategoryDto>(<any>null);
    }

    /**
     * @param code (optional) 
     * @return Success
     */
    getProductCategoryByCode(code: string | null | undefined): Observable<GetProductCategoryForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/ProductCategories/GetProductCategoryByCode?";
        if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetProductCategoryByCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductCategoryByCode(<any>response_);
                } catch (e) {
                    return <Observable<GetProductCategoryForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetProductCategoryForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetProductCategoryByCode(response: HttpResponseBase): Observable<GetProductCategoryForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetProductCategoryForEditOutput.fromJS(resultData200) : new GetProductCategoryForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetProductCategoryForEditOutput>(<any>null);
    }
}

@Injectable()
export class ProductsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param codeFilter (optional) 
     * @param nameFilter (optional) 
     * @param deptCodeFilter (optional) 
     * @param classCodeFilter (optional) 
     * @param isActiveFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, codeFilter: string | null | undefined, nameFilter: string | null | undefined, deptCodeFilter: string | null | undefined, classCodeFilter: string | null | undefined, isActiveFilter: number | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetProductForView> {
        let url_ = this.baseUrl + "/api/services/app/Products/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&";
        if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (deptCodeFilter !== undefined)
            url_ += "DeptCodeFilter=" + encodeURIComponent("" + deptCodeFilter) + "&";
        if (classCodeFilter !== undefined)
            url_ += "ClassCodeFilter=" + encodeURIComponent("" + classCodeFilter) + "&";
        if (isActiveFilter !== undefined)
            url_ += "IsActiveFilter=" + encodeURIComponent("" + isActiveFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetProductForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetProductForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetProductForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetProductForView.fromJS(resultData200) : new PagedResultDtoOfGetProductForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetProductForView>(<any>null);
    }

    /**
     * @return Success
     */
    getAllDeptCode(): Observable<PagedResultDtoOfGetProductForView> {
        let url_ = this.baseUrl + "/api/services/app/Products/GetAllDeptCode";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllDeptCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllDeptCode(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetProductForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetProductForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllDeptCode(response: HttpResponseBase): Observable<PagedResultDtoOfGetProductForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetProductForView.fromJS(resultData200) : new PagedResultDtoOfGetProductForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetProductForView>(<any>null);
    }

    /**
     * @return Success
     */
    getAllProductCode(): Observable<PagedResultDtoOfGetProductForView> {
        let url_ = this.baseUrl + "/api/services/app/Products/GetAllProductCode";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllProductCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllProductCode(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetProductForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetProductForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllProductCode(response: HttpResponseBase): Observable<PagedResultDtoOfGetProductForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetProductForView.fromJS(resultData200) : new PagedResultDtoOfGetProductForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetProductForView>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getProductForEdit(id: number | null | undefined): Observable<GetProductForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Products/GetProductForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetProductForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetProductForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetProductForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetProductForEdit(response: HttpResponseBase): Observable<GetProductForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetProductForEditOutput.fromJS(resultData200) : new GetProductForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetProductForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditProductDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Products/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Products/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param entities (optional) 
     * @return Success
     */
    sync(entities: CreateOrEditProductDto[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Products/Sync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entities);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSync(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSync(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param codeFilter (optional) 
     * @param nameFilter (optional) 
     * @param deptCodeFilter (optional) 
     * @param classCodeFilter (optional) 
     * @param isActiveFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllExt(filter: string | null | undefined, codeFilter: string | null | undefined, nameFilter: string | null | undefined, deptCodeFilter: string | null | undefined, classCodeFilter: string | null | undefined, isActiveFilter: number | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetProductForView> {
        let url_ = this.baseUrl + "/api/services/app/Products/GetAllExt?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&";
        if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (deptCodeFilter !== undefined)
            url_ += "DeptCodeFilter=" + encodeURIComponent("" + deptCodeFilter) + "&";
        if (classCodeFilter !== undefined)
            url_ += "ClassCodeFilter=" + encodeURIComponent("" + classCodeFilter) + "&";
        if (isActiveFilter !== undefined)
            url_ += "IsActiveFilter=" + encodeURIComponent("" + isActiveFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllExt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllExt(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetProductForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetProductForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllExt(response: HttpResponseBase): Observable<PagedResultDtoOfGetProductForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetProductForView.fromJS(resultData200) : new PagedResultDtoOfGetProductForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetProductForView>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEditExt(input: CreateOrEditProductDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Products/CreateOrEditExt";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEditExt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditExt(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEditExt(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteExt(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Products/DeleteExt?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteExt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteExt(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteExt(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param lstDeptCode (optional) 
     * @param currentComboHeaderCode (optional) 
     * @return Success
     */
    getAllByDeptCode(lstDeptCode: string[] | null | undefined, currentComboHeaderCode: string | null | undefined): Observable<ProductExtDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Products/GetAllByDeptCode?";
        if (lstDeptCode !== undefined)
            lstDeptCode && lstDeptCode.forEach(item => { url_ += "lstDeptCode=" + encodeURIComponent("" + item) + "&"; });
        if (currentComboHeaderCode !== undefined)
            url_ += "currentComboHeaderCode=" + encodeURIComponent("" + currentComboHeaderCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllByDeptCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllByDeptCode(<any>response_);
                } catch (e) {
                    return <Observable<ProductExtDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ProductExtDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllByDeptCode(response: HttpResponseBase): Observable<ProductExtDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(ProductExtDto.fromJS(item));
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductExtDto[]>(<any>null);
    }
}

@Injectable()
export class ProductSettingsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param codeFilter (optional) 
     * @param nameFilter (optional) 
     * @param maxEffectiveFromFilter (optional) 
     * @param minEffectiveFromFilter (optional) 
     * @param maxEffectiveToFilter (optional) 
     * @param minEffectiveToFilter (optional) 
     * @param isActiveFilter (optional) 
     * @param targetAudienceFilter (optional) 
     * @param campaignFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, codeFilter: string | null | undefined, nameFilter: string | null | undefined, maxEffectiveFromFilter: moment.Moment | null | undefined, minEffectiveFromFilter: moment.Moment | null | undefined, maxEffectiveToFilter: moment.Moment | null | undefined, minEffectiveToFilter: moment.Moment | null | undefined, isActiveFilter: number | null | undefined, targetAudienceFilter: string | null | undefined, campaignFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetProductSettingForView> {
        let url_ = this.baseUrl + "/api/services/app/ProductSettings/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&";
        if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (maxEffectiveFromFilter !== undefined)
            url_ += "MaxEffectiveFromFilter=" + encodeURIComponent(maxEffectiveFromFilter ? "" + maxEffectiveFromFilter.toJSON() : "") + "&";
        if (minEffectiveFromFilter !== undefined)
            url_ += "MinEffectiveFromFilter=" + encodeURIComponent(minEffectiveFromFilter ? "" + minEffectiveFromFilter.toJSON() : "") + "&";
        if (maxEffectiveToFilter !== undefined)
            url_ += "MaxEffectiveToFilter=" + encodeURIComponent(maxEffectiveToFilter ? "" + maxEffectiveToFilter.toJSON() : "") + "&";
        if (minEffectiveToFilter !== undefined)
            url_ += "MinEffectiveToFilter=" + encodeURIComponent(minEffectiveToFilter ? "" + minEffectiveToFilter.toJSON() : "") + "&";
        if (isActiveFilter !== undefined)
            url_ += "IsActiveFilter=" + encodeURIComponent("" + isActiveFilter) + "&";
        if (targetAudienceFilter !== undefined)
            url_ += "TargetAudienceFilter=" + encodeURIComponent("" + targetAudienceFilter) + "&";
        if (campaignFilter !== undefined)
            url_ += "CampaignFilter=" + encodeURIComponent("" + campaignFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetProductSettingForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetProductSettingForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetProductSettingForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetProductSettingForView.fromJS(resultData200) : new PagedResultDtoOfGetProductSettingForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetProductSettingForView>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    search(input: GetAllProductSettingsForCampaignInput | null | undefined): Observable<PagedResultDtoOfGetProductSettingForView> {
        let url_ = this.baseUrl + "/api/services/app/ProductSettings/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetProductSettingForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetProductSettingForView>><any>_observableThrow(response_);
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<PagedResultDtoOfGetProductSettingForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetProductSettingForView.fromJS(resultData200) : new PagedResultDtoOfGetProductSettingForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetProductSettingForView>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getProductSettingForEdit(id: number | null | undefined): Observable<GetProductSettingForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/ProductSettings/GetProductSettingForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetProductSettingForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductSettingForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetProductSettingForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetProductSettingForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetProductSettingForEdit(response: HttpResponseBase): Observable<GetProductSettingForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetProductSettingForEditOutput.fromJS(resultData200) : new GetProductSettingForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetProductSettingForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditProductSettingDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ProductSettings/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param inputValidate (optional) 
     * @return Success
     */
    validateInputAsync(inputValidate: CreateOrEditProductSettingDto | null | undefined): Observable<ValidationResult[]> {
        let url_ = this.baseUrl + "/api/services/app/ProductSettings/ValidateInputAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inputValidate);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processValidateInputAsync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateInputAsync(<any>response_);
                } catch (e) {
                    return <Observable<ValidationResult[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ValidationResult[]>><any>_observableThrow(response_);
        }));
    }

    protected processValidateInputAsync(response: HttpResponseBase): Observable<ValidationResult[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(ValidationResult.fromJS(item));
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ValidationResult[]>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ProductSettings/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param code (optional) 
     * @return Success
     */
    getProductSettingByCode(code: string | null | undefined): Observable<GetProductSettingForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/ProductSettings/GetProductSettingByCode?";
        if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetProductSettingByCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductSettingByCode(<any>response_);
                } catch (e) {
                    return <Observable<GetProductSettingForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetProductSettingForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetProductSettingByCode(response: HttpResponseBase): Observable<GetProductSettingForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetProductSettingForEditOutput.fromJS(resultData200) : new GetProductSettingForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetProductSettingForEditOutput>(<any>null);
    }
}

@Injectable()
export class ProductUOMMappingsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param pRD_CDFilter (optional) 
     * @param uOM_CDFilter (optional) 
     * @param bASEUOM_CDFilter (optional) 
     * @param maxUOM_LEVELFilter (optional) 
     * @param minUOM_LEVELFilter (optional) 
     * @param maxCONV_FACTORFilter (optional) 
     * @param minCONV_FACTORFilter (optional) 
     * @param maxCONV_FACTOR_SMLFilter (optional) 
     * @param minCONV_FACTOR_SMLFilter (optional) 
     * @param maxPACK_LENGTHFilter (optional) 
     * @param minPACK_LENGTHFilter (optional) 
     * @param maxPACK_WIDTHFilter (optional) 
     * @param minPACK_WIDTHFilter (optional) 
     * @param maxPACK_HEIGHTFilter (optional) 
     * @param minPACK_HEIGHTFilter (optional) 
     * @param dIMENSION_UNITFilter (optional) 
     * @param maxNET_WEIGHTFilter (optional) 
     * @param minNET_WEIGHTFilter (optional) 
     * @param maxGROSS_WEIGHTFilter (optional) 
     * @param minGROSS_WEIGHTFilter (optional) 
     * @param wEIGHT_UNITFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, pRD_CDFilter: string | null | undefined, uOM_CDFilter: string | null | undefined, bASEUOM_CDFilter: string | null | undefined, maxUOM_LEVELFilter: number | null | undefined, minUOM_LEVELFilter: number | null | undefined, maxCONV_FACTORFilter: number | null | undefined, minCONV_FACTORFilter: number | null | undefined, maxCONV_FACTOR_SMLFilter: number | null | undefined, minCONV_FACTOR_SMLFilter: number | null | undefined, maxPACK_LENGTHFilter: number | null | undefined, minPACK_LENGTHFilter: number | null | undefined, maxPACK_WIDTHFilter: number | null | undefined, minPACK_WIDTHFilter: number | null | undefined, maxPACK_HEIGHTFilter: number | null | undefined, minPACK_HEIGHTFilter: number | null | undefined, dIMENSION_UNITFilter: string | null | undefined, maxNET_WEIGHTFilter: number | null | undefined, minNET_WEIGHTFilter: number | null | undefined, maxGROSS_WEIGHTFilter: number | null | undefined, minGROSS_WEIGHTFilter: number | null | undefined, wEIGHT_UNITFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetProductUOMMappingForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/ProductUOMMappings/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (pRD_CDFilter !== undefined)
            url_ += "PRD_CDFilter=" + encodeURIComponent("" + pRD_CDFilter) + "&";
        if (uOM_CDFilter !== undefined)
            url_ += "UOM_CDFilter=" + encodeURIComponent("" + uOM_CDFilter) + "&";
        if (bASEUOM_CDFilter !== undefined)
            url_ += "BASEUOM_CDFilter=" + encodeURIComponent("" + bASEUOM_CDFilter) + "&";
        if (maxUOM_LEVELFilter !== undefined)
            url_ += "MaxUOM_LEVELFilter=" + encodeURIComponent("" + maxUOM_LEVELFilter) + "&";
        if (minUOM_LEVELFilter !== undefined)
            url_ += "MinUOM_LEVELFilter=" + encodeURIComponent("" + minUOM_LEVELFilter) + "&";
        if (maxCONV_FACTORFilter !== undefined)
            url_ += "MaxCONV_FACTORFilter=" + encodeURIComponent("" + maxCONV_FACTORFilter) + "&";
        if (minCONV_FACTORFilter !== undefined)
            url_ += "MinCONV_FACTORFilter=" + encodeURIComponent("" + minCONV_FACTORFilter) + "&";
        if (maxCONV_FACTOR_SMLFilter !== undefined)
            url_ += "MaxCONV_FACTOR_SMLFilter=" + encodeURIComponent("" + maxCONV_FACTOR_SMLFilter) + "&";
        if (minCONV_FACTOR_SMLFilter !== undefined)
            url_ += "MinCONV_FACTOR_SMLFilter=" + encodeURIComponent("" + minCONV_FACTOR_SMLFilter) + "&";
        if (maxPACK_LENGTHFilter !== undefined)
            url_ += "MaxPACK_LENGTHFilter=" + encodeURIComponent("" + maxPACK_LENGTHFilter) + "&";
        if (minPACK_LENGTHFilter !== undefined)
            url_ += "MinPACK_LENGTHFilter=" + encodeURIComponent("" + minPACK_LENGTHFilter) + "&";
        if (maxPACK_WIDTHFilter !== undefined)
            url_ += "MaxPACK_WIDTHFilter=" + encodeURIComponent("" + maxPACK_WIDTHFilter) + "&";
        if (minPACK_WIDTHFilter !== undefined)
            url_ += "MinPACK_WIDTHFilter=" + encodeURIComponent("" + minPACK_WIDTHFilter) + "&";
        if (maxPACK_HEIGHTFilter !== undefined)
            url_ += "MaxPACK_HEIGHTFilter=" + encodeURIComponent("" + maxPACK_HEIGHTFilter) + "&";
        if (minPACK_HEIGHTFilter !== undefined)
            url_ += "MinPACK_HEIGHTFilter=" + encodeURIComponent("" + minPACK_HEIGHTFilter) + "&";
        if (dIMENSION_UNITFilter !== undefined)
            url_ += "DIMENSION_UNITFilter=" + encodeURIComponent("" + dIMENSION_UNITFilter) + "&";
        if (maxNET_WEIGHTFilter !== undefined)
            url_ += "MaxNET_WEIGHTFilter=" + encodeURIComponent("" + maxNET_WEIGHTFilter) + "&";
        if (minNET_WEIGHTFilter !== undefined)
            url_ += "MinNET_WEIGHTFilter=" + encodeURIComponent("" + minNET_WEIGHTFilter) + "&";
        if (maxGROSS_WEIGHTFilter !== undefined)
            url_ += "MaxGROSS_WEIGHTFilter=" + encodeURIComponent("" + maxGROSS_WEIGHTFilter) + "&";
        if (minGROSS_WEIGHTFilter !== undefined)
            url_ += "MinGROSS_WEIGHTFilter=" + encodeURIComponent("" + minGROSS_WEIGHTFilter) + "&";
        if (wEIGHT_UNITFilter !== undefined)
            url_ += "WEIGHT_UNITFilter=" + encodeURIComponent("" + wEIGHT_UNITFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetProductUOMMappingForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetProductUOMMappingForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetProductUOMMappingForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetProductUOMMappingForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetProductUOMMappingForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetProductUOMMappingForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getProductUOMMappingForEdit(id: number | null | undefined): Observable<GetProductUOMMappingForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/ProductUOMMappings/GetProductUOMMappingForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetProductUOMMappingForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductUOMMappingForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetProductUOMMappingForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetProductUOMMappingForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetProductUOMMappingForEdit(response: HttpResponseBase): Observable<GetProductUOMMappingForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetProductUOMMappingForEditOutput.fromJS(resultData200) : new GetProductUOMMappingForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetProductUOMMappingForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditProductUOMMappingDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ProductUOMMappings/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ProductUOMMappings/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class ProfileServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getCurrentUserProfileForEdit(): Observable<CurrentUserProfileEditDto> {
        let url_ = this.baseUrl + "/api/services/app/Profile/GetCurrentUserProfileForEdit";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCurrentUserProfileForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentUserProfileForEdit(<any>response_);
                } catch (e) {
                    return <Observable<CurrentUserProfileEditDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CurrentUserProfileEditDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetCurrentUserProfileForEdit(response: HttpResponseBase): Observable<CurrentUserProfileEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? CurrentUserProfileEditDto.fromJS(resultData200) : new CurrentUserProfileEditDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CurrentUserProfileEditDto>(<any>null);
    }

    /**
     * @return Success
     */
    updateGoogleAuthenticatorKey(): Observable<UpdateGoogleAuthenticatorKeyOutput> {
        let url_ = this.baseUrl + "/api/services/app/Profile/UpdateGoogleAuthenticatorKey";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateGoogleAuthenticatorKey(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateGoogleAuthenticatorKey(<any>response_);
                } catch (e) {
                    return <Observable<UpdateGoogleAuthenticatorKeyOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<UpdateGoogleAuthenticatorKeyOutput>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateGoogleAuthenticatorKey(response: HttpResponseBase): Observable<UpdateGoogleAuthenticatorKeyOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? UpdateGoogleAuthenticatorKeyOutput.fromJS(resultData200) : new UpdateGoogleAuthenticatorKeyOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateGoogleAuthenticatorKeyOutput>(<any>null);
    }

    /**
     * @return Success
     */
    sendVerificationSms(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/SendVerificationSms";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSendVerificationSms(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendVerificationSms(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSendVerificationSms(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    verifySmsCode(input: VerifySmsCodeInputDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/VerifySmsCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processVerifySmsCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerifySmsCode(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processVerifySmsCode(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    updateCurrentUserProfile(input: CurrentUserProfileEditDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/UpdateCurrentUserProfile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateCurrentUserProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCurrentUserProfile(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateCurrentUserProfile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    changePassword(input: ChangePasswordInput | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/ChangePassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processChangePassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangePassword(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processChangePassword(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    updateProfilePicture(input: UpdateProfilePictureInput | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/UpdateProfilePicture";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateProfilePicture(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateProfilePicture(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateProfilePicture(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    getPasswordComplexitySetting(): Observable<GetPasswordComplexitySettingOutput> {
        let url_ = this.baseUrl + "/api/services/app/Profile/GetPasswordComplexitySetting";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetPasswordComplexitySetting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPasswordComplexitySetting(<any>response_);
                } catch (e) {
                    return <Observable<GetPasswordComplexitySettingOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetPasswordComplexitySettingOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetPasswordComplexitySetting(response: HttpResponseBase): Observable<GetPasswordComplexitySettingOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetPasswordComplexitySettingOutput.fromJS(resultData200) : new GetPasswordComplexitySettingOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPasswordComplexitySettingOutput>(<any>null);
    }

    /**
     * @return Success
     */
    getProfilePicture(): Observable<GetProfilePictureOutput> {
        let url_ = this.baseUrl + "/api/services/app/Profile/GetProfilePicture";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetProfilePicture(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfilePicture(<any>response_);
                } catch (e) {
                    return <Observable<GetProfilePictureOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetProfilePictureOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetProfilePicture(response: HttpResponseBase): Observable<GetProfilePictureOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetProfilePictureOutput.fromJS(resultData200) : new GetProfilePictureOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetProfilePictureOutput>(<any>null);
    }

    /**
     * @param profilePictureId (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getFriendProfilePictureById(profilePictureId: string | null | undefined, userId: number | null | undefined, tenantId: number | null | undefined): Observable<GetProfilePictureOutput> {
        let url_ = this.baseUrl + "/api/services/app/Profile/GetFriendProfilePictureById?";
        if (profilePictureId !== undefined)
            url_ += "ProfilePictureId=" + encodeURIComponent("" + profilePictureId) + "&";
        if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetFriendProfilePictureById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFriendProfilePictureById(<any>response_);
                } catch (e) {
                    return <Observable<GetProfilePictureOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetProfilePictureOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetFriendProfilePictureById(response: HttpResponseBase): Observable<GetProfilePictureOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetProfilePictureOutput.fromJS(resultData200) : new GetProfilePictureOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetProfilePictureOutput>(<any>null);
    }

    /**
     * @param profilePictureId (optional) 
     * @return Success
     */
    getProfilePictureById(profilePictureId: string | null | undefined): Observable<GetProfilePictureOutput> {
        let url_ = this.baseUrl + "/api/services/app/Profile/GetProfilePictureById?";
        if (profilePictureId !== undefined)
            url_ += "profilePictureId=" + encodeURIComponent("" + profilePictureId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetProfilePictureById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfilePictureById(<any>response_);
                } catch (e) {
                    return <Observable<GetProfilePictureOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetProfilePictureOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetProfilePictureById(response: HttpResponseBase): Observable<GetProfilePictureOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetProfilePictureOutput.fromJS(resultData200) : new GetProfilePictureOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetProfilePictureOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    changeLanguage(input: ChangeUserLanguageDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/ChangeLanguage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processChangeLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeLanguage(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processChangeLanguage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class ProgramServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param programCodeFilter (optional) 
     * @param programNameFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param statusFilter (optional) 
     * @param maxStartDateFilter (optional) 
     * @param minStartDateFilter (optional) 
     * @param maxEndDateFilter (optional) 
     * @param minEndDateFilter (optional) 
     * @param maxPointRatioFilter (optional) 
     * @param minPointRatioFilter (optional) 
     * @param programCodeNameFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, programCodeFilter: string | null | undefined, programNameFilter: string | null | undefined, descriptionFilter: string | null | undefined, statusFilter: string | null | undefined, maxStartDateFilter: moment.Moment | null | undefined, minStartDateFilter: moment.Moment | null | undefined, maxEndDateFilter: moment.Moment | null | undefined, minEndDateFilter: moment.Moment | null | undefined, maxPointRatioFilter: number | null | undefined, minPointRatioFilter: number | null | undefined, programCodeNameFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetProgramForView> {
        let url_ = this.baseUrl + "/api/services/app/Program/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (programCodeFilter !== undefined)
            url_ += "ProgramCodeFilter=" + encodeURIComponent("" + programCodeFilter) + "&";
        if (programNameFilter !== undefined)
            url_ += "ProgramNameFilter=" + encodeURIComponent("" + programNameFilter) + "&";
        if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (maxStartDateFilter !== undefined)
            url_ += "MaxStartDateFilter=" + encodeURIComponent(maxStartDateFilter ? "" + maxStartDateFilter.toJSON() : "") + "&";
        if (minStartDateFilter !== undefined)
            url_ += "MinStartDateFilter=" + encodeURIComponent(minStartDateFilter ? "" + minStartDateFilter.toJSON() : "") + "&";
        if (maxEndDateFilter !== undefined)
            url_ += "MaxEndDateFilter=" + encodeURIComponent(maxEndDateFilter ? "" + maxEndDateFilter.toJSON() : "") + "&";
        if (minEndDateFilter !== undefined)
            url_ += "MinEndDateFilter=" + encodeURIComponent(minEndDateFilter ? "" + minEndDateFilter.toJSON() : "") + "&";
        if (maxPointRatioFilter !== undefined)
            url_ += "MaxPointRatioFilter=" + encodeURIComponent("" + maxPointRatioFilter) + "&";
        if (minPointRatioFilter !== undefined)
            url_ += "MinPointRatioFilter=" + encodeURIComponent("" + minPointRatioFilter) + "&";
        if (programCodeNameFilter !== undefined)
            url_ += "ProgramCodeNameFilter=" + encodeURIComponent("" + programCodeNameFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetProgramForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetProgramForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetProgramForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetProgramForView.fromJS(resultData200) : new PagedResultDtoOfGetProgramForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetProgramForView>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getProgramForEdit(id: number | null | undefined): Observable<GetProgramForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Program/GetProgramForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetProgramForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProgramForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetProgramForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetProgramForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetProgramForEdit(response: HttpResponseBase): Observable<GetProgramForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetProgramForEditOutput.fromJS(resultData200) : new GetProgramForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetProgramForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditProgramDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Program/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Program/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param programCode (optional) 
     * @return Success
     */
    getProgramActualByProgramCode(programCode: string | null | undefined): Observable<GetProgramActualForView[]> {
        let url_ = this.baseUrl + "/api/services/app/Program/GetProgramActualByProgramCode?";
        if (programCode !== undefined)
            url_ += "programCode=" + encodeURIComponent("" + programCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetProgramActualByProgramCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProgramActualByProgramCode(<any>response_);
                } catch (e) {
                    return <Observable<GetProgramActualForView[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetProgramActualForView[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetProgramActualByProgramCode(response: HttpResponseBase): Observable<GetProgramActualForView[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(GetProgramActualForView.fromJS(item));
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetProgramActualForView[]>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param programCodeFilter (optional) 
     * @param programNameFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param statusFilter (optional) 
     * @param maxStartDateFilter (optional) 
     * @param minStartDateFilter (optional) 
     * @param maxEndDateFilter (optional) 
     * @param minEndDateFilter (optional) 
     * @param maxPointRatioFilter (optional) 
     * @param minPointRatioFilter (optional) 
     * @param programCodeNameFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getProgramActualByProgramCodeForWeb(filter: string | null | undefined, programCodeFilter: string | null | undefined, programNameFilter: string | null | undefined, descriptionFilter: string | null | undefined, statusFilter: string | null | undefined, maxStartDateFilter: moment.Moment | null | undefined, minStartDateFilter: moment.Moment | null | undefined, maxEndDateFilter: moment.Moment | null | undefined, minEndDateFilter: moment.Moment | null | undefined, maxPointRatioFilter: number | null | undefined, minPointRatioFilter: number | null | undefined, programCodeNameFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetProgramActualForView> {
        let url_ = this.baseUrl + "/api/services/app/Program/GetProgramActualByProgramCodeForWeb?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (programCodeFilter !== undefined)
            url_ += "ProgramCodeFilter=" + encodeURIComponent("" + programCodeFilter) + "&";
        if (programNameFilter !== undefined)
            url_ += "ProgramNameFilter=" + encodeURIComponent("" + programNameFilter) + "&";
        if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (maxStartDateFilter !== undefined)
            url_ += "MaxStartDateFilter=" + encodeURIComponent(maxStartDateFilter ? "" + maxStartDateFilter.toJSON() : "") + "&";
        if (minStartDateFilter !== undefined)
            url_ += "MinStartDateFilter=" + encodeURIComponent(minStartDateFilter ? "" + minStartDateFilter.toJSON() : "") + "&";
        if (maxEndDateFilter !== undefined)
            url_ += "MaxEndDateFilter=" + encodeURIComponent(maxEndDateFilter ? "" + maxEndDateFilter.toJSON() : "") + "&";
        if (minEndDateFilter !== undefined)
            url_ += "MinEndDateFilter=" + encodeURIComponent(minEndDateFilter ? "" + minEndDateFilter.toJSON() : "") + "&";
        if (maxPointRatioFilter !== undefined)
            url_ += "MaxPointRatioFilter=" + encodeURIComponent("" + maxPointRatioFilter) + "&";
        if (minPointRatioFilter !== undefined)
            url_ += "MinPointRatioFilter=" + encodeURIComponent("" + minPointRatioFilter) + "&";
        if (programCodeNameFilter !== undefined)
            url_ += "ProgramCodeNameFilter=" + encodeURIComponent("" + programCodeNameFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetProgramActualByProgramCodeForWeb(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProgramActualByProgramCodeForWeb(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetProgramActualForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetProgramActualForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetProgramActualByProgramCodeForWeb(response: HttpResponseBase): Observable<PagedResultDtoOfGetProgramActualForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetProgramActualForView.fromJS(resultData200) : new PagedResultDtoOfGetProgramActualForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetProgramActualForView>(<any>null);
    }
}

@Injectable()
export class ProgramActualServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param programCodeFilter (optional) 
     * @param productCodeFilter (optional) 
     * @param memberCodeFilter (optional) 
     * @param maxMonthFilter (optional) 
     * @param minMonthFilter (optional) 
     * @param maxYearFilter (optional) 
     * @param minYearFilter (optional) 
     * @param maxQuantityFilter (optional) 
     * @param minQuantityFilter (optional) 
     * @param statusFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, programCodeFilter: string | null | undefined, productCodeFilter: string | null | undefined, memberCodeFilter: string | null | undefined, maxMonthFilter: number | null | undefined, minMonthFilter: number | null | undefined, maxYearFilter: number | null | undefined, minYearFilter: number | null | undefined, maxQuantityFilter: number | null | undefined, minQuantityFilter: number | null | undefined, statusFilter: string | null | undefined, descriptionFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetProgramActualForView> {
        let url_ = this.baseUrl + "/api/services/app/ProgramActual/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (programCodeFilter !== undefined)
            url_ += "ProgramCodeFilter=" + encodeURIComponent("" + programCodeFilter) + "&";
        if (productCodeFilter !== undefined)
            url_ += "ProductCodeFilter=" + encodeURIComponent("" + productCodeFilter) + "&";
        if (memberCodeFilter !== undefined)
            url_ += "MemberCodeFilter=" + encodeURIComponent("" + memberCodeFilter) + "&";
        if (maxMonthFilter !== undefined)
            url_ += "MaxMonthFilter=" + encodeURIComponent("" + maxMonthFilter) + "&";
        if (minMonthFilter !== undefined)
            url_ += "MinMonthFilter=" + encodeURIComponent("" + minMonthFilter) + "&";
        if (maxYearFilter !== undefined)
            url_ += "MaxYearFilter=" + encodeURIComponent("" + maxYearFilter) + "&";
        if (minYearFilter !== undefined)
            url_ += "MinYearFilter=" + encodeURIComponent("" + minYearFilter) + "&";
        if (maxQuantityFilter !== undefined)
            url_ += "MaxQuantityFilter=" + encodeURIComponent("" + maxQuantityFilter) + "&";
        if (minQuantityFilter !== undefined)
            url_ += "MinQuantityFilter=" + encodeURIComponent("" + minQuantityFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetProgramActualForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetProgramActualForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetProgramActualForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetProgramActualForView.fromJS(resultData200) : new PagedResultDtoOfGetProgramActualForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetProgramActualForView>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getProgramActualForEdit(id: number | null | undefined): Observable<GetProgramActualForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/ProgramActual/GetProgramActualForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetProgramActualForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProgramActualForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetProgramActualForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetProgramActualForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetProgramActualForEdit(response: HttpResponseBase): Observable<GetProgramActualForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetProgramActualForEditOutput.fromJS(resultData200) : new GetProgramActualForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetProgramActualForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditProgramActualDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ProgramActual/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ProgramActual/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class ProgramTargetServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param programCodeFilter (optional) 
     * @param productCodeFilter (optional) 
     * @param maxQuantityFilter (optional) 
     * @param minQuantityFilter (optional) 
     * @param statusFilter (optional) 
     * @param productNameFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, programCodeFilter: string | null | undefined, productCodeFilter: string | null | undefined, maxQuantityFilter: number | null | undefined, minQuantityFilter: number | null | undefined, statusFilter: string | null | undefined, productNameFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetProgramTargetForView> {
        let url_ = this.baseUrl + "/api/services/app/ProgramTarget/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (programCodeFilter !== undefined)
            url_ += "ProgramCodeFilter=" + encodeURIComponent("" + programCodeFilter) + "&";
        if (productCodeFilter !== undefined)
            url_ += "ProductCodeFilter=" + encodeURIComponent("" + productCodeFilter) + "&";
        if (maxQuantityFilter !== undefined)
            url_ += "MaxQuantityFilter=" + encodeURIComponent("" + maxQuantityFilter) + "&";
        if (minQuantityFilter !== undefined)
            url_ += "MinQuantityFilter=" + encodeURIComponent("" + minQuantityFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (productNameFilter !== undefined)
            url_ += "ProductNameFilter=" + encodeURIComponent("" + productNameFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetProgramTargetForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetProgramTargetForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetProgramTargetForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetProgramTargetForView.fromJS(resultData200) : new PagedResultDtoOfGetProgramTargetForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetProgramTargetForView>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getProgramTargetForEdit(id: number | null | undefined): Observable<GetProgramTargetForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/ProgramTarget/GetProgramTargetForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetProgramTargetForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProgramTargetForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetProgramTargetForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetProgramTargetForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetProgramTargetForEdit(response: HttpResponseBase): Observable<GetProgramTargetForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetProgramTargetForEditOutput.fromJS(resultData200) : new GetProgramTargetForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetProgramTargetForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditProgramTargetDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ProgramTarget/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ProgramTarget/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class PublisherMastersServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param publisherCodeFilter (optional) 
     * @param publisherNameFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param statusFilter (optional) 
     * @param pulisherNameUnsignFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, publisherCodeFilter: string | null | undefined, publisherNameFilter: string | null | undefined, descriptionFilter: string | null | undefined, statusFilter: string | null | undefined, pulisherNameUnsignFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetPublisherMasterForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/PublisherMasters/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (publisherCodeFilter !== undefined)
            url_ += "PublisherCodeFilter=" + encodeURIComponent("" + publisherCodeFilter) + "&";
        if (publisherNameFilter !== undefined)
            url_ += "PublisherNameFilter=" + encodeURIComponent("" + publisherNameFilter) + "&";
        if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (pulisherNameUnsignFilter !== undefined)
            url_ += "PulisherNameUnsignFilter=" + encodeURIComponent("" + pulisherNameUnsignFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetPublisherMasterForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetPublisherMasterForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetPublisherMasterForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetPublisherMasterForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetPublisherMasterForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetPublisherMasterForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getPublisherMasterForEdit(id: number | null | undefined): Observable<GetPublisherMasterForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/PublisherMasters/GetPublisherMasterForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetPublisherMasterForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPublisherMasterForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetPublisherMasterForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetPublisherMasterForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetPublisherMasterForEdit(response: HttpResponseBase): Observable<GetPublisherMasterForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetPublisherMasterForEditOutput.fromJS(resultData200) : new GetPublisherMasterForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPublisherMasterForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditPublisherMasterDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PublisherMasters/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PublisherMasters/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param publisherCodeFilter (optional) 
     * @param publisherNameFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param statusFilter (optional) 
     * @param pulisherNameUnsignFilter (optional) 
     * @return Success
     */
    getPublisherMastersToExcel(filter: string | null | undefined, publisherCodeFilter: string | null | undefined, publisherNameFilter: string | null | undefined, descriptionFilter: string | null | undefined, statusFilter: string | null | undefined, pulisherNameUnsignFilter: string | null | undefined): Observable<RewardsFileDto> {
        let url_ = this.baseUrl + "/api/services/app/PublisherMasters/GetPublisherMastersToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (publisherCodeFilter !== undefined)
            url_ += "PublisherCodeFilter=" + encodeURIComponent("" + publisherCodeFilter) + "&";
        if (publisherNameFilter !== undefined)
            url_ += "PublisherNameFilter=" + encodeURIComponent("" + publisherNameFilter) + "&";
        if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (pulisherNameUnsignFilter !== undefined)
            url_ += "PulisherNameUnsignFilter=" + encodeURIComponent("" + pulisherNameUnsignFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetPublisherMastersToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPublisherMastersToExcel(<any>response_);
                } catch (e) {
                    return <Observable<RewardsFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<RewardsFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetPublisherMastersToExcel(response: HttpResponseBase): Observable<RewardsFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? RewardsFileDto.fromJS(resultData200) : new RewardsFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RewardsFileDto>(<any>null);
    }
}

@Injectable()
export class PublishersServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param codeFilter (optional) 
     * @param nameFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param aPILinkFilter (optional) 
     * @param tokenKeyFilter (optional) 
     * @param statusFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, codeFilter: string | null | undefined, nameFilter: string | null | undefined, descriptionFilter: string | null | undefined, aPILinkFilter: string | null | undefined, tokenKeyFilter: string | null | undefined, statusFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetPublisherForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Publishers/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&";
        if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&";
        if (aPILinkFilter !== undefined)
            url_ += "APILinkFilter=" + encodeURIComponent("" + aPILinkFilter) + "&";
        if (tokenKeyFilter !== undefined)
            url_ += "TokenKeyFilter=" + encodeURIComponent("" + tokenKeyFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetPublisherForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetPublisherForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetPublisherForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetPublisherForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetPublisherForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetPublisherForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getPublisherForEdit(id: number | null | undefined): Observable<GetPublisherForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Publishers/GetPublisherForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetPublisherForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPublisherForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetPublisherForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetPublisherForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetPublisherForEdit(response: HttpResponseBase): Observable<GetPublisherForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetPublisherForEditOutput.fromJS(resultData200) : new GetPublisherForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPublisherForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditPublisherDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Publishers/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Publishers/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param codeFilter (optional) 
     * @param nameFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param aPILinkFilter (optional) 
     * @param tokenKeyFilter (optional) 
     * @param statusFilter (optional) 
     * @return Success
     */
    getPublishersToExcel(filter: string | null | undefined, codeFilter: string | null | undefined, nameFilter: string | null | undefined, descriptionFilter: string | null | undefined, aPILinkFilter: string | null | undefined, tokenKeyFilter: string | null | undefined, statusFilter: string | null | undefined): Observable<SocialRetailerFileDto> {
        let url_ = this.baseUrl + "/api/services/app/Publishers/GetPublishersToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&";
        if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&";
        if (aPILinkFilter !== undefined)
            url_ += "APILinkFilter=" + encodeURIComponent("" + aPILinkFilter) + "&";
        if (tokenKeyFilter !== undefined)
            url_ += "TokenKeyFilter=" + encodeURIComponent("" + tokenKeyFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetPublishersToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPublishersToExcel(<any>response_);
                } catch (e) {
                    return <Observable<SocialRetailerFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SocialRetailerFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetPublishersToExcel(response: HttpResponseBase): Observable<SocialRetailerFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? SocialRetailerFileDto.fromJS(resultData200) : new SocialRetailerFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SocialRetailerFileDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param codeFilter (optional) 
     * @param nameFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param aPILinkFilter (optional) 
     * @param tokenKeyFilter (optional) 
     * @param statusFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllAsync(filter: string | null | undefined, codeFilter: string | null | undefined, nameFilter: string | null | undefined, descriptionFilter: string | null | undefined, aPILinkFilter: string | null | undefined, tokenKeyFilter: string | null | undefined, statusFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetPublisherForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Publishers/GetAllAsync?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&";
        if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&";
        if (aPILinkFilter !== undefined)
            url_ += "APILinkFilter=" + encodeURIComponent("" + aPILinkFilter) + "&";
        if (tokenKeyFilter !== undefined)
            url_ += "TokenKeyFilter=" + encodeURIComponent("" + tokenKeyFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllAsync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAsync(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetPublisherForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetPublisherForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllAsync(response: HttpResponseBase): Observable<PagedResultDtoOfGetPublisherForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetPublisherForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetPublisherForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetPublisherForViewDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEditUnsignAsync(input: CreateOrEditPublisherDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Publishers/CreateOrEditUnsignAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEditUnsignAsync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditUnsignAsync(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEditUnsignAsync(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param entities (optional) 
     * @return Success
     */
    batchDeleteAsync(entities: PublisherDto[] | null | undefined): Observable<MessageResultSocialRetailer> {
        let url_ = this.baseUrl + "/api/services/app/Publishers/BatchDeleteAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entities);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processBatchDeleteAsync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBatchDeleteAsync(<any>response_);
                } catch (e) {
                    return <Observable<MessageResultSocialRetailer>><any>_observableThrow(e);
                }
            } else
                return <Observable<MessageResultSocialRetailer>><any>_observableThrow(response_);
        }));
    }

    protected processBatchDeleteAsync(response: HttpResponseBase): Observable<MessageResultSocialRetailer> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? MessageResultSocialRetailer.fromJS(resultData200) : new MessageResultSocialRetailer();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MessageResultSocialRetailer>(<any>null);
    }

    /**
     * @return Success
     */
    getPublisherForGiftCampaign(): Observable<GetPublisherGiftCampaignForView[]> {
        let url_ = this.baseUrl + "/api/services/app/Publishers/GetPublisherForGiftCampaign";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetPublisherForGiftCampaign(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPublisherForGiftCampaign(<any>response_);
                } catch (e) {
                    return <Observable<GetPublisherGiftCampaignForView[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetPublisherGiftCampaignForView[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetPublisherForGiftCampaign(response: HttpResponseBase): Observable<GetPublisherGiftCampaignForView[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(GetPublisherGiftCampaignForView.fromJS(item));
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPublisherGiftCampaignForView[]>(<any>null);
    }

    /**
     * @return Success
     */
    getGeneratePublisherCode(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Publishers/GetGeneratePublisherCode";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetGeneratePublisherCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGeneratePublisherCode(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetGeneratePublisherCode(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }
}

@Injectable()
export class PushNotificationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param sender (optional) 
     * @param memberCode (optional) 
     * @param title (optional) 
     * @param content (optional) 
     * @param tenantId (optional) 
     * @param userId (optional) 
     * @param eventTime (optional) 
     * @param eventSource (optional) 
     * @return Success
     */
    pushAsync(sender: string | null | undefined, memberCode: string | null | undefined, title: string | null | undefined, content: string | null | undefined, tenantId: number | null | undefined, userId: number | null | undefined, eventTime: moment.Moment | null | undefined, eventSource: any | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/PushNotification/PushAsync?";
        if (sender !== undefined)
            url_ += "Sender=" + encodeURIComponent("" + sender) + "&";
        if (memberCode !== undefined)
            url_ += "MemberCode=" + encodeURIComponent("" + memberCode) + "&";
        if (title !== undefined)
            url_ += "Title=" + encodeURIComponent("" + title) + "&";
        if (content !== undefined)
            url_ += "Content=" + encodeURIComponent("" + content) + "&";
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (eventTime !== undefined)
            url_ += "EventTime=" + encodeURIComponent(eventTime ? "" + eventTime.toJSON() : "") + "&";
        if (eventSource !== undefined)
            url_ += "EventSource=" + encodeURIComponent("" + eventSource) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processPushAsync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPushAsync(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processPushAsync(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class QATicketsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param ticketCodeFilter (optional) 
     * @param memberCodeFilter (optional) 
     * @param memberNameFilter (optional) 
     * @param maxSubmitDateFilter (optional) 
     * @param minSubmitDateFilter (optional) 
     * @param contentFilter (optional) 
     * @param memberNameUnsignFilter (optional) 
     * @param typeFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, ticketCodeFilter: string | null | undefined, memberCodeFilter: string | null | undefined, memberNameFilter: string | null | undefined, maxSubmitDateFilter: moment.Moment | null | undefined, minSubmitDateFilter: moment.Moment | null | undefined, contentFilter: string | null | undefined, memberNameUnsignFilter: string | null | undefined, typeFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetQATicketForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/QATickets/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (ticketCodeFilter !== undefined)
            url_ += "TicketCodeFilter=" + encodeURIComponent("" + ticketCodeFilter) + "&";
        if (memberCodeFilter !== undefined)
            url_ += "MemberCodeFilter=" + encodeURIComponent("" + memberCodeFilter) + "&";
        if (memberNameFilter !== undefined)
            url_ += "MemberNameFilter=" + encodeURIComponent("" + memberNameFilter) + "&";
        if (maxSubmitDateFilter !== undefined)
            url_ += "MaxSubmitDateFilter=" + encodeURIComponent(maxSubmitDateFilter ? "" + maxSubmitDateFilter.toJSON() : "") + "&";
        if (minSubmitDateFilter !== undefined)
            url_ += "MinSubmitDateFilter=" + encodeURIComponent(minSubmitDateFilter ? "" + minSubmitDateFilter.toJSON() : "") + "&";
        if (contentFilter !== undefined)
            url_ += "ContentFilter=" + encodeURIComponent("" + contentFilter) + "&";
        if (memberNameUnsignFilter !== undefined)
            url_ += "MemberNameUnsignFilter=" + encodeURIComponent("" + memberNameUnsignFilter) + "&";
        if (typeFilter !== undefined)
            url_ += "TypeFilter=" + encodeURIComponent("" + typeFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetQATicketForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetQATicketForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetQATicketForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetQATicketForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetQATicketForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetQATicketForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getQATicketForEdit(id: number | null | undefined): Observable<GetQATicketForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/QATickets/GetQATicketForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetQATicketForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetQATicketForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetQATicketForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetQATicketForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetQATicketForEdit(response: HttpResponseBase): Observable<GetQATicketForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetQATicketForEditOutput.fromJS(resultData200) : new GetQATicketForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetQATicketForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditQATicketDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/QATickets/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/QATickets/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param ticketCodeFilter (optional) 
     * @param memberCodeFilter (optional) 
     * @param memberNameFilter (optional) 
     * @param maxSubmitDateFilter (optional) 
     * @param minSubmitDateFilter (optional) 
     * @param contentFilter (optional) 
     * @param memberNameUnsignFilter (optional) 
     * @param typeFilter (optional) 
     * @return Success
     */
    getQATicketsToExcel(filter: string | null | undefined, ticketCodeFilter: string | null | undefined, memberCodeFilter: string | null | undefined, memberNameFilter: string | null | undefined, maxSubmitDateFilter: moment.Moment | null | undefined, minSubmitDateFilter: moment.Moment | null | undefined, contentFilter: string | null | undefined, memberNameUnsignFilter: string | null | undefined, typeFilter: string | null | undefined): Observable<ConsumerDBFileDto> {
        let url_ = this.baseUrl + "/api/services/app/QATickets/GetQATicketsToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (ticketCodeFilter !== undefined)
            url_ += "TicketCodeFilter=" + encodeURIComponent("" + ticketCodeFilter) + "&";
        if (memberCodeFilter !== undefined)
            url_ += "MemberCodeFilter=" + encodeURIComponent("" + memberCodeFilter) + "&";
        if (memberNameFilter !== undefined)
            url_ += "MemberNameFilter=" + encodeURIComponent("" + memberNameFilter) + "&";
        if (maxSubmitDateFilter !== undefined)
            url_ += "MaxSubmitDateFilter=" + encodeURIComponent(maxSubmitDateFilter ? "" + maxSubmitDateFilter.toJSON() : "") + "&";
        if (minSubmitDateFilter !== undefined)
            url_ += "MinSubmitDateFilter=" + encodeURIComponent(minSubmitDateFilter ? "" + minSubmitDateFilter.toJSON() : "") + "&";
        if (contentFilter !== undefined)
            url_ += "ContentFilter=" + encodeURIComponent("" + contentFilter) + "&";
        if (memberNameUnsignFilter !== undefined)
            url_ += "MemberNameUnsignFilter=" + encodeURIComponent("" + memberNameUnsignFilter) + "&";
        if (typeFilter !== undefined)
            url_ += "TypeFilter=" + encodeURIComponent("" + typeFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetQATicketsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetQATicketsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<ConsumerDBFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ConsumerDBFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetQATicketsToExcel(response: HttpResponseBase): Observable<ConsumerDBFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? ConsumerDBFileDto.fromJS(resultData200) : new ConsumerDBFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ConsumerDBFileDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    search(input: GetAllQATicketsInput | null | undefined): Observable<PagedResultDtoOfGetQATicketForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/QATickets/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetQATicketForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetQATicketForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<PagedResultDtoOfGetQATicketForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetQATicketForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetQATicketForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetQATicketForViewDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    getByTicketCode(input: string | null | undefined): Observable<QATicketDto> {
        let url_ = this.baseUrl + "/api/services/app/QATickets/GetByTicketCode?";
        if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetByTicketCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByTicketCode(<any>response_);
                } catch (e) {
                    return <Observable<QATicketDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<QATicketDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetByTicketCode(response: HttpResponseBase): Observable<QATicketDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? QATicketDto.fromJS(resultData200) : new QATicketDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<QATicketDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    exportQa(input: GetAllQATicketsInput | null | undefined): Observable<ConsumerDBFileDto> {
        let url_ = this.baseUrl + "/api/services/app/QATickets/ExportQa";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processExportQa(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportQa(<any>response_);
                } catch (e) {
                    return <Observable<ConsumerDBFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ConsumerDBFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processExportQa(response: HttpResponseBase): Observable<ConsumerDBFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? ConsumerDBFileDto.fromJS(resultData200) : new ConsumerDBFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ConsumerDBFileDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEditExt(input: CreateOrEditQATicketDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/QATickets/CreateOrEditExt";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEditExt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditExt(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEditExt(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    pushQATicket(input: CreateOrEditQATicketDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/QATickets/PushQATicket";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processPushQATicket(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPushQATicket(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processPushQATicket(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class QaTicktetEventHandlerServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param eventData (optional) 
     * @return Success
     */
    handleEvent(eventData: QaTicketEventData | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/QaTicktetEventHandler/HandleEvent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(eventData);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processHandleEvent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHandleEvent(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processHandleEvent(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class QuartzHistoryServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param jobName (optional) 
     * @param group (optional) 
     * @param dateFrom (optional) 
     * @param dateTo (optional) 
     * @param state (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getAll(jobName: string | null | undefined, group: string | null | undefined, dateFrom: moment.Moment | null | undefined, dateTo: moment.Moment | null | undefined, state: State2 | null | undefined, sorting: string | null | undefined, maxResultCount: number | null | undefined, skipCount: number | null | undefined): Observable<QuartzHistoryGetAllOutput> {
        let url_ = this.baseUrl + "/api/services/app/QuartzHistoryService/GetAll?";
        if (jobName !== undefined)
            url_ += "JobName=" + encodeURIComponent("" + jobName) + "&";
        if (group !== undefined)
            url_ += "Group=" + encodeURIComponent("" + group) + "&";
        if (dateFrom !== undefined)
            url_ += "DateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toJSON() : "") + "&";
        if (dateTo !== undefined)
            url_ += "DateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toJSON() : "") + "&";
        if (state !== undefined)
            url_ += "State=" + encodeURIComponent("" + state) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<QuartzHistoryGetAllOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<QuartzHistoryGetAllOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<QuartzHistoryGetAllOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? QuartzHistoryGetAllOutput.fromJS(resultData200) : new QuartzHistoryGetAllOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<QuartzHistoryGetAllOutput>(<any>null);
    }

    /**
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getAllQuartzJob(sorting: string | null | undefined, maxResultCount: number | null | undefined, skipCount: number | null | undefined): Observable<PagedResultDtoOfQuartzJobDto> {
        let url_ = this.baseUrl + "/api/services/app/QuartzHistoryService/GetAllQuartzJob?";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllQuartzJob(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllQuartzJob(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfQuartzJobDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfQuartzJobDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllQuartzJob(response: HttpResponseBase): Observable<PagedResultDtoOfQuartzJobDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfQuartzJobDto.fromJS(resultData200) : new PagedResultDtoOfQuartzJobDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfQuartzJobDto>(<any>null);
    }
}

@Injectable()
export class QuartzJobConfigServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param jobName (optional) 
     * @param jobGroup (optional) 
     * @return Success
     */
    execute(jobName: string | null | undefined, jobGroup: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/QuartzJobConfig/Execute?";
        if (jobName !== undefined)
            url_ += "jobName=" + encodeURIComponent("" + jobName) + "&";
        if (jobGroup !== undefined)
            url_ += "jobGroup=" + encodeURIComponent("" + jobGroup) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processExecute(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExecute(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processExecute(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class QuestServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param codeFilter (optional) 
     * @param statusFilter (optional) 
     * @param maxFromDateFilter (optional) 
     * @param minFromDateFilter (optional) 
     * @param maxToDateFilter (optional) 
     * @param minToDateFilter (optional) 
     * @param rewardingFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, codeFilter: string | null | undefined, statusFilter: string | null | undefined, maxFromDateFilter: moment.Moment | null | undefined, minFromDateFilter: moment.Moment | null | undefined, maxToDateFilter: moment.Moment | null | undefined, minToDateFilter: moment.Moment | null | undefined, rewardingFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetQuestForView> {
        let url_ = this.baseUrl + "/api/services/app/Quest/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (maxFromDateFilter !== undefined)
            url_ += "MaxFromDateFilter=" + encodeURIComponent(maxFromDateFilter ? "" + maxFromDateFilter.toJSON() : "") + "&";
        if (minFromDateFilter !== undefined)
            url_ += "MinFromDateFilter=" + encodeURIComponent(minFromDateFilter ? "" + minFromDateFilter.toJSON() : "") + "&";
        if (maxToDateFilter !== undefined)
            url_ += "MaxToDateFilter=" + encodeURIComponent(maxToDateFilter ? "" + maxToDateFilter.toJSON() : "") + "&";
        if (minToDateFilter !== undefined)
            url_ += "MinToDateFilter=" + encodeURIComponent(minToDateFilter ? "" + minToDateFilter.toJSON() : "") + "&";
        if (rewardingFilter !== undefined)
            url_ += "RewardingFilter=" + encodeURIComponent("" + rewardingFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetQuestForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetQuestForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetQuestForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetQuestForView.fromJS(resultData200) : new PagedResultDtoOfGetQuestForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetQuestForView>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getQuestForEdit(id: number | null | undefined): Observable<GetQuestForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Quest/GetQuestForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetQuestForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetQuestForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetQuestForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetQuestForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetQuestForEdit(response: HttpResponseBase): Observable<GetQuestForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetQuestForEditOutput.fromJS(resultData200) : new GetQuestForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetQuestForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditQuestDto | null | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Quest/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    clone(input: CloneQuestDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Quest/Clone";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processClone(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClone(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processClone(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param status (optional) 
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param excludedIds (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllForView(filter: string | null | undefined, status: string | null | undefined, fromDate: moment.Moment | null | undefined, toDate: moment.Moment | null | undefined, excludedIds: number[] | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetQuestForView> {
        let url_ = this.baseUrl + "/api/services/app/Quest/GetAllForView?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (status !== undefined)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toJSON() : "") + "&";
        if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toJSON() : "") + "&";
        if (excludedIds !== undefined)
            excludedIds && excludedIds.forEach(item => { url_ += "ExcludedIds=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllForView(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetQuestForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetQuestForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllForView(response: HttpResponseBase): Observable<PagedResultDtoOfGetQuestForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetQuestForView.fromJS(resultData200) : new PagedResultDtoOfGetQuestForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetQuestForView>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param currentDate (optional) 
     * @param excludedIds (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllForGroupList(filter: string | null | undefined, currentDate: moment.Moment | null | undefined, excludedIds: number[] | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfQuestDto> {
        let url_ = this.baseUrl + "/api/services/app/Quest/GetAllForGroupList?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (currentDate !== undefined)
            url_ += "CurrentDate=" + encodeURIComponent(currentDate ? "" + currentDate.toJSON() : "") + "&";
        if (excludedIds !== undefined)
            excludedIds && excludedIds.forEach(item => { url_ += "ExcludedIds=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllForGroupList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllForGroupList(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfQuestDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfQuestDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllForGroupList(response: HttpResponseBase): Observable<PagedResultDtoOfQuestDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfQuestDto.fromJS(resultData200) : new PagedResultDtoOfQuestDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfQuestDto>(<any>null);
    }

    /**
     * @param inputDto (optional) 
     * @return Success
     */
    join(inputDto: JoinQuestInputDto | null | undefined): Observable<JoinQuestOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/Quest/Join";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inputDto);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processJoin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processJoin(<any>response_);
                } catch (e) {
                    return <Observable<JoinQuestOutputDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<JoinQuestOutputDto>><any>_observableThrow(response_);
        }));
    }

    protected processJoin(response: HttpResponseBase): Observable<JoinQuestOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? JoinQuestOutputDto.fromJS(resultData200) : new JoinQuestOutputDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<JoinQuestOutputDto>(<any>null);
    }

    /**
     * @param transactionCode (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getCoinHistory(memberCode: string, transactionCode: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetCoinHistoryOutputItemDto> {
        let url_ = this.baseUrl + "/api/services/app/Quest/GetCoinHistory?";
        if (memberCode === undefined || memberCode === null)
            throw new Error("The parameter 'memberCode' must be defined and cannot be null.");
        else
            url_ += "MemberCode=" + encodeURIComponent("" + memberCode) + "&";
        if (transactionCode !== undefined)
            url_ += "TransactionCode=" + encodeURIComponent("" + transactionCode) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCoinHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCoinHistory(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetCoinHistoryOutputItemDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetCoinHistoryOutputItemDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetCoinHistory(response: HttpResponseBase): Observable<PagedResultDtoOfGetCoinHistoryOutputItemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetCoinHistoryOutputItemDto.fromJS(resultData200) : new PagedResultDtoOfGetCoinHistoryOutputItemDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetCoinHistoryOutputItemDto>(<any>null);
    }

    /**
     * @param memberCode (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getListByGroup(memberCode: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetAllQuestByGroupDto> {
        let url_ = this.baseUrl + "/api/services/app/Quest/GetListByGroup?";
        if (memberCode !== undefined)
            url_ += "MemberCode=" + encodeURIComponent("" + memberCode) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetListByGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetListByGroup(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetAllQuestByGroupDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetAllQuestByGroupDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetListByGroup(response: HttpResponseBase): Observable<PagedResultDtoOfGetAllQuestByGroupDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetAllQuestByGroupDto.fromJS(resultData200) : new PagedResultDtoOfGetAllQuestByGroupDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetAllQuestByGroupDto>(<any>null);
    }

    /**
     * @param questCodeFilter (optional) 
     * @param memberCode (optional) 
     * @param missionCodeFilter (optional) 
     * @param missionStatusFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getDetail(questCodeFilter: string | null | undefined, memberCode: string | null | undefined, missionCodeFilter: string | null | undefined, missionStatusFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfQuestDto> {
        let url_ = this.baseUrl + "/api/services/app/Quest/GetDetail?";
        if (questCodeFilter !== undefined)
            url_ += "QuestCodeFilter=" + encodeURIComponent("" + questCodeFilter) + "&";
        if (memberCode !== undefined)
            url_ += "MemberCode=" + encodeURIComponent("" + memberCode) + "&";
        if (missionCodeFilter !== undefined)
            url_ += "MissionCodeFilter=" + encodeURIComponent("" + missionCodeFilter) + "&";
        if (missionStatusFilter !== undefined)
            url_ += "MissionStatusFilter=" + encodeURIComponent("" + missionStatusFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDetail(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfQuestDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfQuestDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetDetail(response: HttpResponseBase): Observable<PagedResultDtoOfQuestDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfQuestDto.fromJS(resultData200) : new PagedResultDtoOfQuestDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfQuestDto>(<any>null);
    }

    /**
     * @param questCodeFilter (optional) 
     * @param memberCode (optional) 
     * @param missionCodeFilter (optional) 
     * @param missionStatusFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getDetailV2(questCodeFilter: string | null | undefined, memberCode: string | null | undefined, missionCodeFilter: string | null | undefined, missionStatusFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfQuestDto> {
        let url_ = this.baseUrl + "/api/services/app/Quest/GetDetailV2?";
        if (questCodeFilter !== undefined)
            url_ += "QuestCodeFilter=" + encodeURIComponent("" + questCodeFilter) + "&";
        if (memberCode !== undefined)
            url_ += "MemberCode=" + encodeURIComponent("" + memberCode) + "&";
        if (missionCodeFilter !== undefined)
            url_ += "MissionCodeFilter=" + encodeURIComponent("" + missionCodeFilter) + "&";
        if (missionStatusFilter !== undefined)
            url_ += "MissionStatusFilter=" + encodeURIComponent("" + missionStatusFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetDetailV2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDetailV2(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfQuestDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfQuestDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetDetailV2(response: HttpResponseBase): Observable<PagedResultDtoOfQuestDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfQuestDto.fromJS(resultData200) : new PagedResultDtoOfQuestDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfQuestDto>(<any>null);
    }

    /**
     * @param type (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getListQuestByActivity(memberCode: string, type: Type | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfQuestDto> {
        let url_ = this.baseUrl + "/api/services/app/Quest/GetListQuestByActivity?";
        if (memberCode === undefined || memberCode === null)
            throw new Error("The parameter 'memberCode' must be defined and cannot be null.");
        else
            url_ += "MemberCode=" + encodeURIComponent("" + memberCode) + "&";
        if (type !== undefined)
            url_ += "Type=" + encodeURIComponent("" + type) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetListQuestByActivity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetListQuestByActivity(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfQuestDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfQuestDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetListQuestByActivity(response: HttpResponseBase): Observable<PagedResultDtoOfQuestDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfQuestDto.fromJS(resultData200) : new PagedResultDtoOfQuestDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfQuestDto>(<any>null);
    }
}

@Injectable()
export class QuestGroupServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetQuestGroupForView> {
        let url_ = this.baseUrl + "/api/services/app/QuestGroup/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetQuestGroupForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetQuestGroupForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetQuestGroupForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetQuestGroupForView.fromJS(resultData200) : new PagedResultDtoOfGetQuestGroupForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetQuestGroupForView>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditQuestGroupDto | null | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/QuestGroup/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/QuestGroup/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param status (optional) 
     * @param type (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllForView(filter: string | null | undefined, status: string | null | undefined, type: Type2 | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetQuestGroupForView> {
        let url_ = this.baseUrl + "/api/services/app/QuestGroup/GetAllForView?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (status !== undefined)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (type !== undefined)
            url_ += "Type=" + encodeURIComponent("" + type) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllForView(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetQuestGroupForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetQuestGroupForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllForView(response: HttpResponseBase): Observable<PagedResultDtoOfGetQuestGroupForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetQuestGroupForView.fromJS(resultData200) : new PagedResultDtoOfGetQuestGroupForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetQuestGroupForView>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getQuestGroupForEdit(id: number | null | undefined): Observable<GetQuestGroupForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/QuestGroup/GetQuestGroupForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetQuestGroupForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetQuestGroupForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetQuestGroupForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetQuestGroupForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetQuestGroupForEdit(response: HttpResponseBase): Observable<GetQuestGroupForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetQuestGroupForEditOutput.fromJS(resultData200) : new GetQuestGroupForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetQuestGroupForEditOutput>(<any>null);
    }
}

@Injectable()
export class RankCalculationLogicServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    processRankOfCustomer(input: ProcessCalculationRankOfCustomerInput | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/RankCalculationLogic/ProcessRankOfCustomer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processProcessRankOfCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProcessRankOfCustomer(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processProcessRankOfCustomer(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class RankCalculationSettingsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param codeFilter (optional) 
     * @param cronFilter (optional) 
     * @param maxCalculationPeriodDurationFilter (optional) 
     * @param minCalculationPeriodDurationFilter (optional) 
     * @param calculationTypeFilter (optional) 
     * @param maxCalculationMonthsFilter (optional) 
     * @param minCalculationMonthsFilter (optional) 
     * @param validTypeFilter (optional) 
     * @param maxValidPeriodExtendMonthsFilter (optional) 
     * @param minValidPeriodExtendMonthsFilter (optional) 
     * @param maxValidMonthsFilter (optional) 
     * @param minValidMonthsFilter (optional) 
     * @param isActiveFilter (optional) 
     * @param maxValidPeriodStartMonthFilter (optional) 
     * @param minValidPeriodStartMonthFilter (optional) 
     * @param maxCalculationPeriodStartMonthFilter (optional) 
     * @param minCalculationPeriodStartMonthFilter (optional) 
     * @param maxValidPeriodDurationFilter (optional) 
     * @param minValidPeriodDurationFilter (optional) 
     * @param timeZoneFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, codeFilter: string | null | undefined, cronFilter: string | null | undefined, maxCalculationPeriodDurationFilter: number | null | undefined, minCalculationPeriodDurationFilter: number | null | undefined, calculationTypeFilter: string | null | undefined, maxCalculationMonthsFilter: number | null | undefined, minCalculationMonthsFilter: number | null | undefined, validTypeFilter: string | null | undefined, maxValidPeriodExtendMonthsFilter: number | null | undefined, minValidPeriodExtendMonthsFilter: number | null | undefined, maxValidMonthsFilter: number | null | undefined, minValidMonthsFilter: number | null | undefined, isActiveFilter: number | null | undefined, maxValidPeriodStartMonthFilter: moment.Moment | null | undefined, minValidPeriodStartMonthFilter: moment.Moment | null | undefined, maxCalculationPeriodStartMonthFilter: moment.Moment | null | undefined, minCalculationPeriodStartMonthFilter: moment.Moment | null | undefined, maxValidPeriodDurationFilter: number | null | undefined, minValidPeriodDurationFilter: number | null | undefined, timeZoneFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetRankCalculationSettingForView> {
        let url_ = this.baseUrl + "/api/services/app/RankCalculationSettings/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&";
        if (cronFilter !== undefined)
            url_ += "CronFilter=" + encodeURIComponent("" + cronFilter) + "&";
        if (maxCalculationPeriodDurationFilter !== undefined)
            url_ += "MaxCalculationPeriodDurationFilter=" + encodeURIComponent("" + maxCalculationPeriodDurationFilter) + "&";
        if (minCalculationPeriodDurationFilter !== undefined)
            url_ += "MinCalculationPeriodDurationFilter=" + encodeURIComponent("" + minCalculationPeriodDurationFilter) + "&";
        if (calculationTypeFilter !== undefined)
            url_ += "CalculationTypeFilter=" + encodeURIComponent("" + calculationTypeFilter) + "&";
        if (maxCalculationMonthsFilter !== undefined)
            url_ += "MaxCalculationMonthsFilter=" + encodeURIComponent("" + maxCalculationMonthsFilter) + "&";
        if (minCalculationMonthsFilter !== undefined)
            url_ += "MinCalculationMonthsFilter=" + encodeURIComponent("" + minCalculationMonthsFilter) + "&";
        if (validTypeFilter !== undefined)
            url_ += "ValidTypeFilter=" + encodeURIComponent("" + validTypeFilter) + "&";
        if (maxValidPeriodExtendMonthsFilter !== undefined)
            url_ += "MaxValidPeriodExtendMonthsFilter=" + encodeURIComponent("" + maxValidPeriodExtendMonthsFilter) + "&";
        if (minValidPeriodExtendMonthsFilter !== undefined)
            url_ += "MinValidPeriodExtendMonthsFilter=" + encodeURIComponent("" + minValidPeriodExtendMonthsFilter) + "&";
        if (maxValidMonthsFilter !== undefined)
            url_ += "MaxValidMonthsFilter=" + encodeURIComponent("" + maxValidMonthsFilter) + "&";
        if (minValidMonthsFilter !== undefined)
            url_ += "MinValidMonthsFilter=" + encodeURIComponent("" + minValidMonthsFilter) + "&";
        if (isActiveFilter !== undefined)
            url_ += "IsActiveFilter=" + encodeURIComponent("" + isActiveFilter) + "&";
        if (maxValidPeriodStartMonthFilter !== undefined)
            url_ += "MaxValidPeriodStartMonthFilter=" + encodeURIComponent(maxValidPeriodStartMonthFilter ? "" + maxValidPeriodStartMonthFilter.toJSON() : "") + "&";
        if (minValidPeriodStartMonthFilter !== undefined)
            url_ += "MinValidPeriodStartMonthFilter=" + encodeURIComponent(minValidPeriodStartMonthFilter ? "" + minValidPeriodStartMonthFilter.toJSON() : "") + "&";
        if (maxCalculationPeriodStartMonthFilter !== undefined)
            url_ += "MaxCalculationPeriodStartMonthFilter=" + encodeURIComponent(maxCalculationPeriodStartMonthFilter ? "" + maxCalculationPeriodStartMonthFilter.toJSON() : "") + "&";
        if (minCalculationPeriodStartMonthFilter !== undefined)
            url_ += "MinCalculationPeriodStartMonthFilter=" + encodeURIComponent(minCalculationPeriodStartMonthFilter ? "" + minCalculationPeriodStartMonthFilter.toJSON() : "") + "&";
        if (maxValidPeriodDurationFilter !== undefined)
            url_ += "MaxValidPeriodDurationFilter=" + encodeURIComponent("" + maxValidPeriodDurationFilter) + "&";
        if (minValidPeriodDurationFilter !== undefined)
            url_ += "MinValidPeriodDurationFilter=" + encodeURIComponent("" + minValidPeriodDurationFilter) + "&";
        if (timeZoneFilter !== undefined)
            url_ += "TimeZoneFilter=" + encodeURIComponent("" + timeZoneFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetRankCalculationSettingForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetRankCalculationSettingForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetRankCalculationSettingForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetRankCalculationSettingForView.fromJS(resultData200) : new PagedResultDtoOfGetRankCalculationSettingForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetRankCalculationSettingForView>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getRankCalculationSettingForEdit(id: number | null | undefined): Observable<GetRankCalculationSettingForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/RankCalculationSettings/GetRankCalculationSettingForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetRankCalculationSettingForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRankCalculationSettingForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetRankCalculationSettingForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetRankCalculationSettingForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetRankCalculationSettingForEdit(response: HttpResponseBase): Observable<GetRankCalculationSettingForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetRankCalculationSettingForEditOutput.fromJS(resultData200) : new GetRankCalculationSettingForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetRankCalculationSettingForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditRankCalculationSettingDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/RankCalculationSettings/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/RankCalculationSettings/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrentRankCalculationSetting(): Observable<GetRankCalculationSettingForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/RankCalculationSettings/GetCurrentRankCalculationSetting";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCurrentRankCalculationSetting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentRankCalculationSetting(<any>response_);
                } catch (e) {
                    return <Observable<GetRankCalculationSettingForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetRankCalculationSettingForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetCurrentRankCalculationSetting(response: HttpResponseBase): Observable<GetRankCalculationSettingForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetRankCalculationSettingForEditOutput.fromJS(resultData200) : new GetRankCalculationSettingForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetRankCalculationSettingForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEditExt(input: CreateOrEditRankCalculationSettingDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/RankCalculationSettings/CreateOrEditExt";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEditExt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditExt(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEditExt(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class RankHistoriesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param memberCodeFilter (optional) 
     * @param maxPointFilter (optional) 
     * @param minPointFilter (optional) 
     * @param sourceFilter (optional) 
     * @param maxConsumerIDFilter (optional) 
     * @param minConsumerIDFilter (optional) 
     * @param maxLastRankIDFilter (optional) 
     * @param minLastRankIDFilter (optional) 
     * @param maxCurrentRankIDFilter (optional) 
     * @param minCurrentRankIDFilter (optional) 
     * @param reasonFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, memberCodeFilter: string | null | undefined, maxPointFilter: number | null | undefined, minPointFilter: number | null | undefined, sourceFilter: string | null | undefined, maxConsumerIDFilter: number | null | undefined, minConsumerIDFilter: number | null | undefined, maxLastRankIDFilter: number | null | undefined, minLastRankIDFilter: number | null | undefined, maxCurrentRankIDFilter: number | null | undefined, minCurrentRankIDFilter: number | null | undefined, reasonFilter: string | null | undefined, descriptionFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetRankHistoryForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/RankHistories/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (memberCodeFilter !== undefined)
            url_ += "MemberCodeFilter=" + encodeURIComponent("" + memberCodeFilter) + "&";
        if (maxPointFilter !== undefined)
            url_ += "MaxPointFilter=" + encodeURIComponent("" + maxPointFilter) + "&";
        if (minPointFilter !== undefined)
            url_ += "MinPointFilter=" + encodeURIComponent("" + minPointFilter) + "&";
        if (sourceFilter !== undefined)
            url_ += "SourceFilter=" + encodeURIComponent("" + sourceFilter) + "&";
        if (maxConsumerIDFilter !== undefined)
            url_ += "MaxConsumerIDFilter=" + encodeURIComponent("" + maxConsumerIDFilter) + "&";
        if (minConsumerIDFilter !== undefined)
            url_ += "MinConsumerIDFilter=" + encodeURIComponent("" + minConsumerIDFilter) + "&";
        if (maxLastRankIDFilter !== undefined)
            url_ += "MaxLastRankIDFilter=" + encodeURIComponent("" + maxLastRankIDFilter) + "&";
        if (minLastRankIDFilter !== undefined)
            url_ += "MinLastRankIDFilter=" + encodeURIComponent("" + minLastRankIDFilter) + "&";
        if (maxCurrentRankIDFilter !== undefined)
            url_ += "MaxCurrentRankIDFilter=" + encodeURIComponent("" + maxCurrentRankIDFilter) + "&";
        if (minCurrentRankIDFilter !== undefined)
            url_ += "MinCurrentRankIDFilter=" + encodeURIComponent("" + minCurrentRankIDFilter) + "&";
        if (reasonFilter !== undefined)
            url_ += "ReasonFilter=" + encodeURIComponent("" + reasonFilter) + "&";
        if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetRankHistoryForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetRankHistoryForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetRankHistoryForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetRankHistoryForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetRankHistoryForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetRankHistoryForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getRankHistoryForEdit(id: number | null | undefined): Observable<GetRankHistoryForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/RankHistories/GetRankHistoryForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetRankHistoryForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRankHistoryForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetRankHistoryForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetRankHistoryForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetRankHistoryForEdit(response: HttpResponseBase): Observable<GetRankHistoryForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetRankHistoryForEditOutput.fromJS(resultData200) : new GetRankHistoryForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetRankHistoryForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditRankHistoryDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/RankHistories/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/RankHistories/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param memberCodeFilter (optional) 
     * @param maxPointFilter (optional) 
     * @param minPointFilter (optional) 
     * @param sourceFilter (optional) 
     * @param maxConsumerIDFilter (optional) 
     * @param minConsumerIDFilter (optional) 
     * @param maxLastRankIDFilter (optional) 
     * @param minLastRankIDFilter (optional) 
     * @param maxCurrentRankIDFilter (optional) 
     * @param minCurrentRankIDFilter (optional) 
     * @param reasonFilter (optional) 
     * @param descriptionFilter (optional) 
     * @return Success
     */
    getRankHistoriesToExcel(filter: string | null | undefined, memberCodeFilter: string | null | undefined, maxPointFilter: number | null | undefined, minPointFilter: number | null | undefined, sourceFilter: string | null | undefined, maxConsumerIDFilter: number | null | undefined, minConsumerIDFilter: number | null | undefined, maxLastRankIDFilter: number | null | undefined, minLastRankIDFilter: number | null | undefined, maxCurrentRankIDFilter: number | null | undefined, minCurrentRankIDFilter: number | null | undefined, reasonFilter: string | null | undefined, descriptionFilter: string | null | undefined): Observable<PointFileDto> {
        let url_ = this.baseUrl + "/api/services/app/RankHistories/GetRankHistoriesToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (memberCodeFilter !== undefined)
            url_ += "MemberCodeFilter=" + encodeURIComponent("" + memberCodeFilter) + "&";
        if (maxPointFilter !== undefined)
            url_ += "MaxPointFilter=" + encodeURIComponent("" + maxPointFilter) + "&";
        if (minPointFilter !== undefined)
            url_ += "MinPointFilter=" + encodeURIComponent("" + minPointFilter) + "&";
        if (sourceFilter !== undefined)
            url_ += "SourceFilter=" + encodeURIComponent("" + sourceFilter) + "&";
        if (maxConsumerIDFilter !== undefined)
            url_ += "MaxConsumerIDFilter=" + encodeURIComponent("" + maxConsumerIDFilter) + "&";
        if (minConsumerIDFilter !== undefined)
            url_ += "MinConsumerIDFilter=" + encodeURIComponent("" + minConsumerIDFilter) + "&";
        if (maxLastRankIDFilter !== undefined)
            url_ += "MaxLastRankIDFilter=" + encodeURIComponent("" + maxLastRankIDFilter) + "&";
        if (minLastRankIDFilter !== undefined)
            url_ += "MinLastRankIDFilter=" + encodeURIComponent("" + minLastRankIDFilter) + "&";
        if (maxCurrentRankIDFilter !== undefined)
            url_ += "MaxCurrentRankIDFilter=" + encodeURIComponent("" + maxCurrentRankIDFilter) + "&";
        if (minCurrentRankIDFilter !== undefined)
            url_ += "MinCurrentRankIDFilter=" + encodeURIComponent("" + minCurrentRankIDFilter) + "&";
        if (reasonFilter !== undefined)
            url_ += "ReasonFilter=" + encodeURIComponent("" + reasonFilter) + "&";
        if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetRankHistoriesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRankHistoriesToExcel(<any>response_);
                } catch (e) {
                    return <Observable<PointFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PointFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetRankHistoriesToExcel(response: HttpResponseBase): Observable<PointFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PointFileDto.fromJS(resultData200) : new PointFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PointFileDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createExt(input: CreateOrEditRankHistoryDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/RankHistories/CreateExt";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateExt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateExt(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateExt(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param userID (optional) 
     * @return Success
     */
    getNameUser(userID: number | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/RankHistories/GetNameUser?";
        if (userID !== undefined)
            url_ += "userID=" + encodeURIComponent("" + userID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetNameUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNameUser(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetNameUser(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param outletCode (optional) 
     * @return Success
     */
    getRankHistory(outletCode: string | null | undefined): Observable<GetRankHistoryDtoForView> {
        let url_ = this.baseUrl + "/api/services/app/RankHistories/GetRankHistory?";
        if (outletCode !== undefined)
            url_ += "OutletCode=" + encodeURIComponent("" + outletCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetRankHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRankHistory(<any>response_);
                } catch (e) {
                    return <Observable<GetRankHistoryDtoForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetRankHistoryDtoForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetRankHistory(response: HttpResponseBase): Observable<GetRankHistoryDtoForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetRankHistoryDtoForView.fromJS(resultData200) : new GetRankHistoryDtoForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetRankHistoryDtoForView>(<any>null);
    }

    /**
     * @param rankTypeCode (optional) 
     * @return Success
     */
    getAllRankByRankTypeCode(rankTypeCode: string | null | undefined): Observable<PagedResultDtoOfGetRankForView> {
        let url_ = this.baseUrl + "/api/services/app/RankHistories/GetAllRankByRankTypeCode?";
        if (rankTypeCode !== undefined)
            url_ += "rankTypeCode=" + encodeURIComponent("" + rankTypeCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllRankByRankTypeCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllRankByRankTypeCode(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetRankForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetRankForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllRankByRankTypeCode(response: HttpResponseBase): Observable<PagedResultDtoOfGetRankForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetRankForView.fromJS(resultData200) : new PagedResultDtoOfGetRankForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetRankForView>(<any>null);
    }

    /**
     * @param month (optional) 
     * @return Success
     */
    getQuarter(month: number | null | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/RankHistories/GetQuarter?";
        if (month !== undefined)
            url_ += "month=" + encodeURIComponent("" + month) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetQuarter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetQuarter(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processGetQuarter(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }
}

@Injectable()
export class RanksServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param codeFilter (optional) 
     * @param nameFilter (optional) 
     * @param avatarFilter (optional) 
     * @param isActiveFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, codeFilter: string | null | undefined, nameFilter: string | null | undefined, avatarFilter: string | null | undefined, isActiveFilter: number | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetRankForView> {
        let url_ = this.baseUrl + "/api/services/app/Ranks/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&";
        if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (avatarFilter !== undefined)
            url_ += "AvatarFilter=" + encodeURIComponent("" + avatarFilter) + "&";
        if (isActiveFilter !== undefined)
            url_ += "IsActiveFilter=" + encodeURIComponent("" + isActiveFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetRankForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetRankForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetRankForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetRankForView.fromJS(resultData200) : new PagedResultDtoOfGetRankForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetRankForView>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getRankForEdit(id: number | null | undefined): Observable<GetRankForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Ranks/GetRankForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetRankForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRankForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetRankForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetRankForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetRankForEdit(response: HttpResponseBase): Observable<GetRankForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetRankForEditOutput.fromJS(resultData200) : new GetRankForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetRankForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditRankDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Ranks/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Ranks/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    getAllNoPaging(): Observable<PagedResultDtoOfGetRankForView> {
        let url_ = this.baseUrl + "/api/services/app/Ranks/GetAllNoPaging";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllNoPaging(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllNoPaging(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetRankForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetRankForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllNoPaging(response: HttpResponseBase): Observable<PagedResultDtoOfGetRankForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetRankForView.fromJS(resultData200) : new PagedResultDtoOfGetRankForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetRankForView>(<any>null);
    }

    /**
     * @param code (optional) 
     * @return Success
     */
    getRankByCode(code: string | null | undefined): Observable<GetRankForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Ranks/GetRankByCode?";
        if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetRankByCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRankByCode(<any>response_);
                } catch (e) {
                    return <Observable<GetRankForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetRankForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetRankByCode(response: HttpResponseBase): Observable<GetRankForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetRankForEditOutput.fromJS(resultData200) : new GetRankForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetRankForEditOutput>(<any>null);
    }
}

@Injectable()
export class RankSettingsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditRankSettingDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/RankSettings/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/RankSettings/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param codeFilter (optional) 
     * @param nameFilter (optional) 
     * @param maxEffectiveFromFilter (optional) 
     * @param minEffectiveFromFilter (optional) 
     * @param maxEffectiveToFilter (optional) 
     * @param minEffectiveToFilter (optional) 
     * @param isActiveFilter (optional) 
     * @param campaignFilter (optional) 
     * @param campaignIdFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, codeFilter: string | null | undefined, nameFilter: string | null | undefined, maxEffectiveFromFilter: moment.Moment | null | undefined, minEffectiveFromFilter: moment.Moment | null | undefined, maxEffectiveToFilter: moment.Moment | null | undefined, minEffectiveToFilter: moment.Moment | null | undefined, isActiveFilter: number | null | undefined, campaignFilter: string | null | undefined, campaignIdFilter: number | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetRankSettingForView> {
        let url_ = this.baseUrl + "/api/services/app/RankSettings/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&";
        if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (maxEffectiveFromFilter !== undefined)
            url_ += "MaxEffectiveFromFilter=" + encodeURIComponent(maxEffectiveFromFilter ? "" + maxEffectiveFromFilter.toJSON() : "") + "&";
        if (minEffectiveFromFilter !== undefined)
            url_ += "MinEffectiveFromFilter=" + encodeURIComponent(minEffectiveFromFilter ? "" + minEffectiveFromFilter.toJSON() : "") + "&";
        if (maxEffectiveToFilter !== undefined)
            url_ += "MaxEffectiveToFilter=" + encodeURIComponent(maxEffectiveToFilter ? "" + maxEffectiveToFilter.toJSON() : "") + "&";
        if (minEffectiveToFilter !== undefined)
            url_ += "MinEffectiveToFilter=" + encodeURIComponent(minEffectiveToFilter ? "" + minEffectiveToFilter.toJSON() : "") + "&";
        if (isActiveFilter !== undefined)
            url_ += "IsActiveFilter=" + encodeURIComponent("" + isActiveFilter) + "&";
        if (campaignFilter !== undefined)
            url_ += "CampaignFilter=" + encodeURIComponent("" + campaignFilter) + "&";
        if (campaignIdFilter !== undefined)
            url_ += "CampaignIdFilter=" + encodeURIComponent("" + campaignIdFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetRankSettingForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetRankSettingForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetRankSettingForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetRankSettingForView.fromJS(resultData200) : new PagedResultDtoOfGetRankSettingForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetRankSettingForView>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getRankSettingForEdit(id: number | null | undefined): Observable<GetRankSettingForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/RankSettings/GetRankSettingForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetRankSettingForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRankSettingForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetRankSettingForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetRankSettingForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetRankSettingForEdit(response: HttpResponseBase): Observable<GetRankSettingForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetRankSettingForEditOutput.fromJS(resultData200) : new GetRankSettingForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetRankSettingForEditOutput>(<any>null);
    }

    /**
     * @param code (optional) 
     * @return Success
     */
    getRankSettingByCode(code: string | null | undefined): Observable<GetRankSettingForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/RankSettings/GetRankSettingByCode?";
        if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetRankSettingByCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRankSettingByCode(<any>response_);
                } catch (e) {
                    return <Observable<GetRankSettingForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetRankSettingForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetRankSettingByCode(response: HttpResponseBase): Observable<GetRankSettingForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetRankSettingForEditOutput.fromJS(resultData200) : new GetRankSettingForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetRankSettingForEditOutput>(<any>null);
    }
}

@Injectable()
export class RankTargetsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param rankNameFilter (optional) 
     * @param rankTypeNameFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, rankNameFilter: string | null | undefined, rankTypeNameFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetRankTargetForView> {
        let url_ = this.baseUrl + "/api/services/app/RankTargets/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (rankNameFilter !== undefined)
            url_ += "RankNameFilter=" + encodeURIComponent("" + rankNameFilter) + "&";
        if (rankTypeNameFilter !== undefined)
            url_ += "RankTypeNameFilter=" + encodeURIComponent("" + rankTypeNameFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetRankTargetForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetRankTargetForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetRankTargetForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetRankTargetForView.fromJS(resultData200) : new PagedResultDtoOfGetRankTargetForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetRankTargetForView>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getRankTargetForEdit(id: number | null | undefined): Observable<GetRankTargetForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/RankTargets/GetRankTargetForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetRankTargetForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRankTargetForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetRankTargetForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetRankTargetForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetRankTargetForEdit(response: HttpResponseBase): Observable<GetRankTargetForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetRankTargetForEditOutput.fromJS(resultData200) : new GetRankTargetForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetRankTargetForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditRankTargetDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/RankTargets/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/RankTargets/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllRankForLookupTable(filter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfRankLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/RankTargets/GetAllRankForLookupTable?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllRankForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllRankForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfRankLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfRankLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllRankForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfRankLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfRankLookupTableDto.fromJS(resultData200) : new PagedResultDtoOfRankLookupTableDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfRankLookupTableDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllRankTypeForLookupTable(filter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfRankTypeLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/RankTargets/GetAllRankTypeForLookupTable?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllRankTypeForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllRankTypeForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfRankTypeLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfRankTypeLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllRankTypeForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfRankTypeLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfRankTypeLookupTableDto.fromJS(resultData200) : new PagedResultDtoOfRankTypeLookupTableDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfRankTypeLookupTableDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    getRankById(input: number | null | undefined): Observable<RankLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/RankTargets/GetRankById?";
        if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetRankById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRankById(<any>response_);
                } catch (e) {
                    return <Observable<RankLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<RankLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetRankById(response: HttpResponseBase): Observable<RankLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? RankLookupTableDto.fromJS(resultData200) : new RankLookupTableDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RankLookupTableDto>(<any>null);
    }
}

@Injectable()
export class RankTypesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param codeFilter (optional) 
     * @param nameFilter (optional) 
     * @param isActiveFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, codeFilter: string | null | undefined, nameFilter: string | null | undefined, isActiveFilter: number | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetRankTypeForView> {
        let url_ = this.baseUrl + "/api/services/app/RankTypes/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&";
        if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (isActiveFilter !== undefined)
            url_ += "IsActiveFilter=" + encodeURIComponent("" + isActiveFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetRankTypeForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetRankTypeForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetRankTypeForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetRankTypeForView.fromJS(resultData200) : new PagedResultDtoOfGetRankTypeForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetRankTypeForView>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getRankTypeForEdit(id: number | null | undefined): Observable<GetRankTypeForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/RankTypes/GetRankTypeForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetRankTypeForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRankTypeForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetRankTypeForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetRankTypeForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetRankTypeForEdit(response: HttpResponseBase): Observable<GetRankTypeForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetRankTypeForEditOutput.fromJS(resultData200) : new GetRankTypeForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetRankTypeForEditOutput>(<any>null);
    }

    /**
     * @param rankTypeCode (optional) 
     * @return Success
     */
    getRankTargetByRankTypeCode(rankTypeCode: string | null | undefined): Observable<RanksInfoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/RankTypes/GetRankTargetByRankTypeCode?";
        if (rankTypeCode !== undefined)
            url_ += "rankTypeCode=" + encodeURIComponent("" + rankTypeCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetRankTargetByRankTypeCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRankTargetByRankTypeCode(<any>response_);
                } catch (e) {
                    return <Observable<RanksInfoDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<RanksInfoDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetRankTargetByRankTypeCode(response: HttpResponseBase): Observable<RanksInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(RanksInfoDto.fromJS(item));
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RanksInfoDto[]>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditRankTypeDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/RankTypes/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/RankTypes/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param description (optional) 
     * @param isActive (optional) 
     * @param departmentLevel1 (optional) 
     * @param saleType (optional) 
     * @param rankTargets (optional) 
     * @param isDeleted (optional) 
     * @param deleterUserId (optional) 
     * @param deletionTime (optional) 
     * @param lastModificationTime (optional) 
     * @param lastModifierUserId (optional) 
     * @param creationTime (optional) 
     * @param creatorUserId (optional) 
     * @param id (optional) 
     * @return Success
     */
    getFirstOrDefaultByCode(code: string, name: string, description: string | null | undefined, isActive: boolean | null | undefined, departmentLevel1: string | null | undefined, saleType: string | null | undefined, rankTargets: any[] | null | undefined, isDeleted: boolean | null | undefined, deleterUserId: number | null | undefined, deletionTime: moment.Moment | null | undefined, lastModificationTime: moment.Moment | null | undefined, lastModifierUserId: number | null | undefined, creationTime: moment.Moment | null | undefined, creatorUserId: number | null | undefined, id: number | null | undefined): Observable<GetRankTypeForView> {
        let url_ = this.baseUrl + "/api/services/app/RankTypes/GetFirstOrDefaultByCode?";
        if (code === undefined || code === null)
            throw new Error("The parameter 'code' must be defined and cannot be null.");
        else
            url_ += "Code=" + encodeURIComponent("" + code) + "&";
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined and cannot be null.");
        else
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (description !== undefined)
            url_ += "Description=" + encodeURIComponent("" + description) + "&";
        if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (departmentLevel1 !== undefined)
            url_ += "DepartmentLevel1=" + encodeURIComponent("" + departmentLevel1) + "&";
        if (saleType !== undefined)
            url_ += "SaleType=" + encodeURIComponent("" + saleType) + "&";
        if (rankTargets !== undefined)
            rankTargets && rankTargets.forEach((item, index) => {
                for (let attr in item)
                    url_ += "RankTargets[" + index + "]." + attr + "=" + encodeURIComponent("" + item[attr]) + "&";
            });
        if (isDeleted !== undefined)
            url_ += "IsDeleted=" + encodeURIComponent("" + isDeleted) + "&";
        if (deleterUserId !== undefined)
            url_ += "DeleterUserId=" + encodeURIComponent("" + deleterUserId) + "&";
        if (deletionTime !== undefined)
            url_ += "DeletionTime=" + encodeURIComponent(deletionTime ? "" + deletionTime.toJSON() : "") + "&";
        if (lastModificationTime !== undefined)
            url_ += "LastModificationTime=" + encodeURIComponent(lastModificationTime ? "" + lastModificationTime.toJSON() : "") + "&";
        if (lastModifierUserId !== undefined)
            url_ += "LastModifierUserId=" + encodeURIComponent("" + lastModifierUserId) + "&";
        if (creationTime !== undefined)
            url_ += "CreationTime=" + encodeURIComponent(creationTime ? "" + creationTime.toJSON() : "") + "&";
        if (creatorUserId !== undefined)
            url_ += "CreatorUserId=" + encodeURIComponent("" + creatorUserId) + "&";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetFirstOrDefaultByCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFirstOrDefaultByCode(<any>response_);
                } catch (e) {
                    return <Observable<GetRankTypeForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetRankTypeForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetFirstOrDefaultByCode(response: HttpResponseBase): Observable<GetRankTypeForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetRankTypeForView.fromJS(resultData200) : new GetRankTypeForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetRankTypeForView>(<any>null);
    }
}

@Injectable()
export class RatingTicketsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param ticketCodeFilter (optional) 
     * @param memberCodeFilter (optional) 
     * @param memberNameFilter (optional) 
     * @param orderCodeFilter (optional) 
     * @param maxSubmitDateFilter (optional) 
     * @param minSubmitDateFilter (optional) 
     * @param maxRatingFilter (optional) 
     * @param minRatingFilter (optional) 
     * @param commentFilter (optional) 
     * @param maxOrderAmountFilter (optional) 
     * @param minOrderAmountFilter (optional) 
     * @param maxPointFilter (optional) 
     * @param minPointFilter (optional) 
     * @param memberMobileNumberFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, ticketCodeFilter: string | null | undefined, memberCodeFilter: string | null | undefined, memberNameFilter: string | null | undefined, orderCodeFilter: string | null | undefined, maxSubmitDateFilter: moment.Moment | null | undefined, minSubmitDateFilter: moment.Moment | null | undefined, maxRatingFilter: number | null | undefined, minRatingFilter: number | null | undefined, commentFilter: string | null | undefined, maxOrderAmountFilter: number | null | undefined, minOrderAmountFilter: number | null | undefined, maxPointFilter: number | null | undefined, minPointFilter: number | null | undefined, memberMobileNumberFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetRatingTicketForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/RatingTickets/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (ticketCodeFilter !== undefined)
            url_ += "TicketCodeFilter=" + encodeURIComponent("" + ticketCodeFilter) + "&";
        if (memberCodeFilter !== undefined)
            url_ += "MemberCodeFilter=" + encodeURIComponent("" + memberCodeFilter) + "&";
        if (memberNameFilter !== undefined)
            url_ += "MemberNameFilter=" + encodeURIComponent("" + memberNameFilter) + "&";
        if (orderCodeFilter !== undefined)
            url_ += "OrderCodeFilter=" + encodeURIComponent("" + orderCodeFilter) + "&";
        if (maxSubmitDateFilter !== undefined)
            url_ += "MaxSubmitDateFilter=" + encodeURIComponent(maxSubmitDateFilter ? "" + maxSubmitDateFilter.toJSON() : "") + "&";
        if (minSubmitDateFilter !== undefined)
            url_ += "MinSubmitDateFilter=" + encodeURIComponent(minSubmitDateFilter ? "" + minSubmitDateFilter.toJSON() : "") + "&";
        if (maxRatingFilter !== undefined)
            url_ += "MaxRatingFilter=" + encodeURIComponent("" + maxRatingFilter) + "&";
        if (minRatingFilter !== undefined)
            url_ += "MinRatingFilter=" + encodeURIComponent("" + minRatingFilter) + "&";
        if (commentFilter !== undefined)
            url_ += "CommentFilter=" + encodeURIComponent("" + commentFilter) + "&";
        if (maxOrderAmountFilter !== undefined)
            url_ += "MaxOrderAmountFilter=" + encodeURIComponent("" + maxOrderAmountFilter) + "&";
        if (minOrderAmountFilter !== undefined)
            url_ += "MinOrderAmountFilter=" + encodeURIComponent("" + minOrderAmountFilter) + "&";
        if (maxPointFilter !== undefined)
            url_ += "MaxPointFilter=" + encodeURIComponent("" + maxPointFilter) + "&";
        if (minPointFilter !== undefined)
            url_ += "MinPointFilter=" + encodeURIComponent("" + minPointFilter) + "&";
        if (memberMobileNumberFilter !== undefined)
            url_ += "MemberMobileNumberFilter=" + encodeURIComponent("" + memberMobileNumberFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetRatingTicketForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetRatingTicketForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetRatingTicketForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetRatingTicketForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetRatingTicketForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetRatingTicketForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getRatingTicketForEdit(id: number | null | undefined): Observable<GetRatingTicketForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/RatingTickets/GetRatingTicketForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetRatingTicketForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRatingTicketForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetRatingTicketForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetRatingTicketForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetRatingTicketForEdit(response: HttpResponseBase): Observable<GetRatingTicketForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetRatingTicketForEditOutput.fromJS(resultData200) : new GetRatingTicketForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetRatingTicketForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditRatingTicketDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/RatingTickets/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/RatingTickets/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param ticketCodeFilter (optional) 
     * @param memberCodeFilter (optional) 
     * @param memberNameFilter (optional) 
     * @param orderCodeFilter (optional) 
     * @param maxSubmitDateFilter (optional) 
     * @param minSubmitDateFilter (optional) 
     * @param maxRatingFilter (optional) 
     * @param minRatingFilter (optional) 
     * @param commentFilter (optional) 
     * @param maxOrderAmountFilter (optional) 
     * @param minOrderAmountFilter (optional) 
     * @param maxPointFilter (optional) 
     * @param minPointFilter (optional) 
     * @param memberMobileNumberFilter (optional) 
     * @return Success
     */
    getRatingTicketsToExcel(filter: string | null | undefined, ticketCodeFilter: string | null | undefined, memberCodeFilter: string | null | undefined, memberNameFilter: string | null | undefined, orderCodeFilter: string | null | undefined, maxSubmitDateFilter: moment.Moment | null | undefined, minSubmitDateFilter: moment.Moment | null | undefined, maxRatingFilter: number | null | undefined, minRatingFilter: number | null | undefined, commentFilter: string | null | undefined, maxOrderAmountFilter: number | null | undefined, minOrderAmountFilter: number | null | undefined, maxPointFilter: number | null | undefined, minPointFilter: number | null | undefined, memberMobileNumberFilter: string | null | undefined): Observable<ConsumerDBFileDto> {
        let url_ = this.baseUrl + "/api/services/app/RatingTickets/GetRatingTicketsToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (ticketCodeFilter !== undefined)
            url_ += "TicketCodeFilter=" + encodeURIComponent("" + ticketCodeFilter) + "&";
        if (memberCodeFilter !== undefined)
            url_ += "MemberCodeFilter=" + encodeURIComponent("" + memberCodeFilter) + "&";
        if (memberNameFilter !== undefined)
            url_ += "MemberNameFilter=" + encodeURIComponent("" + memberNameFilter) + "&";
        if (orderCodeFilter !== undefined)
            url_ += "OrderCodeFilter=" + encodeURIComponent("" + orderCodeFilter) + "&";
        if (maxSubmitDateFilter !== undefined)
            url_ += "MaxSubmitDateFilter=" + encodeURIComponent(maxSubmitDateFilter ? "" + maxSubmitDateFilter.toJSON() : "") + "&";
        if (minSubmitDateFilter !== undefined)
            url_ += "MinSubmitDateFilter=" + encodeURIComponent(minSubmitDateFilter ? "" + minSubmitDateFilter.toJSON() : "") + "&";
        if (maxRatingFilter !== undefined)
            url_ += "MaxRatingFilter=" + encodeURIComponent("" + maxRatingFilter) + "&";
        if (minRatingFilter !== undefined)
            url_ += "MinRatingFilter=" + encodeURIComponent("" + minRatingFilter) + "&";
        if (commentFilter !== undefined)
            url_ += "CommentFilter=" + encodeURIComponent("" + commentFilter) + "&";
        if (maxOrderAmountFilter !== undefined)
            url_ += "MaxOrderAmountFilter=" + encodeURIComponent("" + maxOrderAmountFilter) + "&";
        if (minOrderAmountFilter !== undefined)
            url_ += "MinOrderAmountFilter=" + encodeURIComponent("" + minOrderAmountFilter) + "&";
        if (maxPointFilter !== undefined)
            url_ += "MaxPointFilter=" + encodeURIComponent("" + maxPointFilter) + "&";
        if (minPointFilter !== undefined)
            url_ += "MinPointFilter=" + encodeURIComponent("" + minPointFilter) + "&";
        if (memberMobileNumberFilter !== undefined)
            url_ += "MemberMobileNumberFilter=" + encodeURIComponent("" + memberMobileNumberFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetRatingTicketsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRatingTicketsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<ConsumerDBFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ConsumerDBFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetRatingTicketsToExcel(response: HttpResponseBase): Observable<ConsumerDBFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? ConsumerDBFileDto.fromJS(resultData200) : new ConsumerDBFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ConsumerDBFileDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    search(input: GetAllRatingTicketsInput | null | undefined): Observable<PagedResultDtoOfGetRatingTicketForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/RatingTickets/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetRatingTicketForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetRatingTicketForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<PagedResultDtoOfGetRatingTicketForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetRatingTicketForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetRatingTicketForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetRatingTicketForViewDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    getByTiketCode(input: string | null | undefined): Observable<RatingTicketDto> {
        let url_ = this.baseUrl + "/api/services/app/RatingTickets/GetByTiketCode?";
        if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetByTiketCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByTiketCode(<any>response_);
                } catch (e) {
                    return <Observable<RatingTicketDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<RatingTicketDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetByTiketCode(response: HttpResponseBase): Observable<RatingTicketDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? RatingTicketDto.fromJS(resultData200) : new RatingTicketDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RatingTicketDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    exportRatingExcel(input: GetAllRatingTicketsInput | null | undefined): Observable<ConsumerDBFileDto> {
        let url_ = this.baseUrl + "/api/services/app/RatingTickets/ExportRatingExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processExportRatingExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportRatingExcel(<any>response_);
                } catch (e) {
                    return <Observable<ConsumerDBFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ConsumerDBFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processExportRatingExcel(response: HttpResponseBase): Observable<ConsumerDBFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? ConsumerDBFileDto.fromJS(resultData200) : new ConsumerDBFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ConsumerDBFileDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createRatingTicketAsync(input: CreateOrEditRatingTicketDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/RatingTickets/CreateRatingTicketAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateRatingTicketAsync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateRatingTicketAsync(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateRatingTicketAsync(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class ReasonSettingsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param codeFilter (optional) 
     * @param nameFilter (optional) 
     * @param isActiveFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, codeFilter: string | null | undefined, nameFilter: string | null | undefined, isActiveFilter: number | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetReasonSettingForView> {
        let url_ = this.baseUrl + "/api/services/app/ReasonSettings/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&";
        if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (isActiveFilter !== undefined)
            url_ += "IsActiveFilter=" + encodeURIComponent("" + isActiveFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetReasonSettingForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetReasonSettingForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetReasonSettingForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetReasonSettingForView.fromJS(resultData200) : new PagedResultDtoOfGetReasonSettingForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetReasonSettingForView>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditReasonSettingDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ReasonSettings/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ReasonSettings/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param codeFilter (optional) 
     * @param nameFilter (optional) 
     * @param isActiveFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllExt(filter: string | null | undefined, codeFilter: string | null | undefined, nameFilter: string | null | undefined, isActiveFilter: number | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetReasonSettingForView> {
        let url_ = this.baseUrl + "/api/services/app/ReasonSettings/GetAllExt?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&";
        if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (isActiveFilter !== undefined)
            url_ += "IsActiveFilter=" + encodeURIComponent("" + isActiveFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllExt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllExt(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetReasonSettingForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetReasonSettingForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllExt(response: HttpResponseBase): Observable<PagedResultDtoOfGetReasonSettingForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetReasonSettingForView.fromJS(resultData200) : new PagedResultDtoOfGetReasonSettingForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetReasonSettingForView>(<any>null);
    }

    /**
     * @return Success
     */
    getAllReasonNoPaging(): Observable<PagedResultDtoOfGetReasonSettingForView> {
        let url_ = this.baseUrl + "/api/services/app/ReasonSettings/GetAllReasonNoPaging";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllReasonNoPaging(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllReasonNoPaging(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetReasonSettingForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetReasonSettingForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllReasonNoPaging(response: HttpResponseBase): Observable<PagedResultDtoOfGetReasonSettingForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetReasonSettingForView.fromJS(resultData200) : new PagedResultDtoOfGetReasonSettingForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetReasonSettingForView>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getReasonSettingForEdit(id: number | null | undefined): Observable<GetReasonSettingForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/ReasonSettings/GetReasonSettingForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetReasonSettingForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReasonSettingForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetReasonSettingForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetReasonSettingForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetReasonSettingForEdit(response: HttpResponseBase): Observable<GetReasonSettingForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetReasonSettingForEditOutput.fromJS(resultData200) : new GetReasonSettingForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetReasonSettingForEditOutput>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteExt(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ReasonSettings/DeleteExt?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteExt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteExt(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteExt(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEditExt(input: CreateOrEditReasonSettingDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ReasonSettings/CreateOrEditExt";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEditExt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditExt(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEditExt(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class RedemptionOverviewReportServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @return Success
     */
    getData(filter: string | null | undefined): Observable<RedemptionOverViewHeaderDto[]> {
        let url_ = this.baseUrl + "/api/services/app/RedemptionOverviewReport/GetData?";
        if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetData(<any>response_);
                } catch (e) {
                    return <Observable<RedemptionOverViewHeaderDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<RedemptionOverViewHeaderDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetData(response: HttpResponseBase): Observable<RedemptionOverViewHeaderDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(RedemptionOverViewHeaderDto.fromJS(item));
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RedemptionOverViewHeaderDto[]>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @return Success
     */
    exportFile(filter: string | null | undefined): Observable<PointFileDto> {
        let url_ = this.baseUrl + "/api/services/app/RedemptionOverviewReport/ExportFile?";
        if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processExportFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportFile(<any>response_);
                } catch (e) {
                    return <Observable<PointFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PointFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processExportFile(response: HttpResponseBase): Observable<PointFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PointFileDto.fromJS(resultData200) : new PointFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PointFileDto>(<any>null);
    }
}

@Injectable()
export class RedemptionRequestManagementServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param keyword (optional) 
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param status (optional) 
     * @param memberCode (optional) 
     * @param rewardType (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getListRequest(keyword: string | null | undefined, fromDate: moment.Moment | null | undefined, toDate: moment.Moment | null | undefined, status: string | null | undefined, memberCode: string | null | undefined, rewardType: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfRedemptionRequestResource> {
        let url_ = this.baseUrl + "/api/services/app/RedemptionRequestManagement/GetListRequest?";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toJSON() : "") + "&";
        if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toJSON() : "") + "&";
        if (status !== undefined)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (memberCode !== undefined)
            url_ += "MemberCode=" + encodeURIComponent("" + memberCode) + "&";
        if (rewardType !== undefined)
            url_ += "RewardType=" + encodeURIComponent("" + rewardType) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetListRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetListRequest(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfRedemptionRequestResource>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfRedemptionRequestResource>><any>_observableThrow(response_);
        }));
    }

    protected processGetListRequest(response: HttpResponseBase): Observable<PagedResultDtoOfRedemptionRequestResource> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfRedemptionRequestResource.fromJS(resultData200) : new PagedResultDtoOfRedemptionRequestResource();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfRedemptionRequestResource>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    updateStatus(input: RedemptionRequestUpdateStatus | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/RedemptionRequestManagement/UpdateStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateStatus(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param requestId (optional) 
     * @return Success
     */
    getListRedemptionItemByRequestId(requestId: number | null | undefined): Observable<RedemptionItemResource[]> {
        let url_ = this.baseUrl + "/api/services/app/RedemptionRequestManagement/GetListRedemptionItemByRequestId?";
        if (requestId !== undefined)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetListRedemptionItemByRequestId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetListRedemptionItemByRequestId(<any>response_);
                } catch (e) {
                    return <Observable<RedemptionItemResource[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<RedemptionItemResource[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetListRedemptionItemByRequestId(response: HttpResponseBase): Observable<RedemptionItemResource[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(RedemptionItemResource.fromJS(item));
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RedemptionItemResource[]>(<any>null);
    }

    /**
     * @param keyword (optional) 
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param status (optional) 
     * @param memberCode (optional) 
     * @param rewardType (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getFileExcelHistory(keyword: string | null | undefined, fromDate: moment.Moment | null | undefined, toDate: moment.Moment | null | undefined, status: string | null | undefined, memberCode: string | null | undefined, rewardType: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<SocialRetailerFileDto> {
        let url_ = this.baseUrl + "/api/services/app/RedemptionRequestManagement/GetFileExcelHistory?";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toJSON() : "") + "&";
        if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toJSON() : "") + "&";
        if (status !== undefined)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (memberCode !== undefined)
            url_ += "MemberCode=" + encodeURIComponent("" + memberCode) + "&";
        if (rewardType !== undefined)
            url_ += "RewardType=" + encodeURIComponent("" + rewardType) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetFileExcelHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFileExcelHistory(<any>response_);
                } catch (e) {
                    return <Observable<SocialRetailerFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SocialRetailerFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetFileExcelHistory(response: HttpResponseBase): Observable<SocialRetailerFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? SocialRetailerFileDto.fromJS(resultData200) : new SocialRetailerFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SocialRetailerFileDto>(<any>null);
    }
}

@Injectable()
export class ReferralBaseLinesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param memberCodeFilter (optional) 
     * @param refMemberCodeFilter (optional) 
     * @param typeFilter (optional) 
     * @param maxTempCoinFilter (optional) 
     * @param minTempCoinFilter (optional) 
     * @param maxTempPointFilter (optional) 
     * @param minTempPointFilter (optional) 
     * @param maxReferralDateFilter (optional) 
     * @param minReferralDateFilter (optional) 
     * @param maxReferralExpiredDateFilter (optional) 
     * @param minReferralExpiredDateFilter (optional) 
     * @param isAvailableFilter (optional) 
     * @param campaignNameFilter (optional) 
     * @param referralReferralNameFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, memberCodeFilter: string | null | undefined, refMemberCodeFilter: string | null | undefined, typeFilter: string | null | undefined, maxTempCoinFilter: number | null | undefined, minTempCoinFilter: number | null | undefined, maxTempPointFilter: number | null | undefined, minTempPointFilter: number | null | undefined, maxReferralDateFilter: moment.Moment | null | undefined, minReferralDateFilter: moment.Moment | null | undefined, maxReferralExpiredDateFilter: moment.Moment | null | undefined, minReferralExpiredDateFilter: moment.Moment | null | undefined, isAvailableFilter: number | null | undefined, campaignNameFilter: string | null | undefined, referralReferralNameFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetReferralBaseLineForView> {
        let url_ = this.baseUrl + "/api/services/app/ReferralBaseLines/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (memberCodeFilter !== undefined)
            url_ += "MemberCodeFilter=" + encodeURIComponent("" + memberCodeFilter) + "&";
        if (refMemberCodeFilter !== undefined)
            url_ += "RefMemberCodeFilter=" + encodeURIComponent("" + refMemberCodeFilter) + "&";
        if (typeFilter !== undefined)
            url_ += "TypeFilter=" + encodeURIComponent("" + typeFilter) + "&";
        if (maxTempCoinFilter !== undefined)
            url_ += "MaxTempCoinFilter=" + encodeURIComponent("" + maxTempCoinFilter) + "&";
        if (minTempCoinFilter !== undefined)
            url_ += "MinTempCoinFilter=" + encodeURIComponent("" + minTempCoinFilter) + "&";
        if (maxTempPointFilter !== undefined)
            url_ += "MaxTempPointFilter=" + encodeURIComponent("" + maxTempPointFilter) + "&";
        if (minTempPointFilter !== undefined)
            url_ += "MinTempPointFilter=" + encodeURIComponent("" + minTempPointFilter) + "&";
        if (maxReferralDateFilter !== undefined)
            url_ += "MaxReferralDateFilter=" + encodeURIComponent(maxReferralDateFilter ? "" + maxReferralDateFilter.toJSON() : "") + "&";
        if (minReferralDateFilter !== undefined)
            url_ += "MinReferralDateFilter=" + encodeURIComponent(minReferralDateFilter ? "" + minReferralDateFilter.toJSON() : "") + "&";
        if (maxReferralExpiredDateFilter !== undefined)
            url_ += "MaxReferralExpiredDateFilter=" + encodeURIComponent(maxReferralExpiredDateFilter ? "" + maxReferralExpiredDateFilter.toJSON() : "") + "&";
        if (minReferralExpiredDateFilter !== undefined)
            url_ += "MinReferralExpiredDateFilter=" + encodeURIComponent(minReferralExpiredDateFilter ? "" + minReferralExpiredDateFilter.toJSON() : "") + "&";
        if (isAvailableFilter !== undefined)
            url_ += "IsAvailableFilter=" + encodeURIComponent("" + isAvailableFilter) + "&";
        if (campaignNameFilter !== undefined)
            url_ += "CampaignNameFilter=" + encodeURIComponent("" + campaignNameFilter) + "&";
        if (referralReferralNameFilter !== undefined)
            url_ += "ReferralReferralNameFilter=" + encodeURIComponent("" + referralReferralNameFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetReferralBaseLineForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetReferralBaseLineForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetReferralBaseLineForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetReferralBaseLineForView.fromJS(resultData200) : new PagedResultDtoOfGetReferralBaseLineForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetReferralBaseLineForView>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getReferralBaseLineForEdit(id: number | null | undefined): Observable<GetReferralBaseLineForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/ReferralBaseLines/GetReferralBaseLineForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetReferralBaseLineForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReferralBaseLineForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetReferralBaseLineForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetReferralBaseLineForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetReferralBaseLineForEdit(response: HttpResponseBase): Observable<GetReferralBaseLineForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetReferralBaseLineForEditOutput.fromJS(resultData200) : new GetReferralBaseLineForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetReferralBaseLineForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditReferralBaseLineDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ReferralBaseLines/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ReferralBaseLines/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllCampaignForLookupTable(filter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfCampaignLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/ReferralBaseLines/GetAllCampaignForLookupTable?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllCampaignForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCampaignForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfCampaignLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfCampaignLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllCampaignForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfCampaignLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfCampaignLookupTableDto.fromJS(resultData200) : new PagedResultDtoOfCampaignLookupTableDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfCampaignLookupTableDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllReferralForLookupTable(filter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfReferralLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/ReferralBaseLines/GetAllReferralForLookupTable?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllReferralForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllReferralForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfReferralLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfReferralLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllReferralForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfReferralLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfReferralLookupTableDto.fromJS(resultData200) : new PagedResultDtoOfReferralLookupTableDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfReferralLookupTableDto>(<any>null);
    }
}

@Injectable()
export class ReferralRewardServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    referralSettingsGetForReferrer(input: GetReferralSettingsForReferrerInputDto | null | undefined): Observable<PagedResultDtoOfGetReferralForReferrer> {
        let url_ = this.baseUrl + "/api/services/app/ReferralReward/ReferralSettingsGetForReferrer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processReferralSettingsGetForReferrer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReferralSettingsGetForReferrer(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetReferralForReferrer>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetReferralForReferrer>><any>_observableThrow(response_);
        }));
    }

    protected processReferralSettingsGetForReferrer(response: HttpResponseBase): Observable<PagedResultDtoOfGetReferralForReferrer> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetReferralForReferrer.fromJS(resultData200) : new PagedResultDtoOfGetReferralForReferrer();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetReferralForReferrer>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    verifyRefferalSettingCode(input: VerifyReferralSettingCodeInput | null | undefined): Observable<GetReferralInfosForView> {
        let url_ = this.baseUrl + "/api/services/app/ReferralReward/VerifyRefferalSettingCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processVerifyRefferalSettingCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerifyRefferalSettingCode(<any>response_);
                } catch (e) {
                    return <Observable<GetReferralInfosForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetReferralInfosForView>><any>_observableThrow(response_);
        }));
    }

    protected processVerifyRefferalSettingCode(response: HttpResponseBase): Observable<GetReferralInfosForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetReferralInfosForView.fromJS(resultData200) : new GetReferralInfosForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetReferralInfosForView>(<any>null);
    }
}

@Injectable()
export class ReferralsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param statusFilter (optional) 
     * @param campaignId (optional) 
     * @param campaignNameFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, nameFilter: string | null | undefined, statusFilter: string | null | undefined, campaignId: number | null | undefined, campaignNameFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetReferralForView> {
        let url_ = this.baseUrl + "/api/services/app/Referrals/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (campaignId !== undefined)
            url_ += "CampaignId=" + encodeURIComponent("" + campaignId) + "&";
        if (campaignNameFilter !== undefined)
            url_ += "CampaignNameFilter=" + encodeURIComponent("" + campaignNameFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetReferralForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetReferralForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetReferralForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetReferralForView.fromJS(resultData200) : new PagedResultDtoOfGetReferralForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetReferralForView>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getReferralForEdit(id: number | null | undefined): Observable<GetReferralForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Referrals/GetReferralForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetReferralForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReferralForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetReferralForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetReferralForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetReferralForEdit(response: HttpResponseBase): Observable<GetReferralForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetReferralForEditOutput.fromJS(resultData200) : new GetReferralForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetReferralForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditReferralDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Referrals/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Referrals/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param maxEffectiveFromFilter (optional) 
     * @param minEffectiveFromFilter (optional) 
     * @param maxEffectiveToFilter (optional) 
     * @param minEffectiveToFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param statusFilter (optional) 
     * @param maxExpiredDaysFilter (optional) 
     * @param minExpiredDaysFilter (optional) 
     * @param maxOrderAmountRequiredFilter (optional) 
     * @param minOrderAmountRequiredFilter (optional) 
     * @param maxMaxSetFilter (optional) 
     * @param minMaxSetFilter (optional) 
     * @param maxReferrerPointFilter (optional) 
     * @param minReferrerPointFilter (optional) 
     * @param maxReferrerCoinFilter (optional) 
     * @param minReferrerCoinFilter (optional) 
     * @param maxRefereePointFilter (optional) 
     * @param minRefereePointFilter (optional) 
     * @param maxRefereeCoinFilter (optional) 
     * @param minRefereeCoinFilter (optional) 
     * @param referrerTargetAudienceCodeFilter (optional) 
     * @param refereeTargetAudienceCodeFilter (optional) 
     * @param campaignNameFilter (optional) 
     * @return Success
     */
    getReferralsToExcel(filter: string | null | undefined, nameFilter: string | null | undefined, maxEffectiveFromFilter: moment.Moment | null | undefined, minEffectiveFromFilter: moment.Moment | null | undefined, maxEffectiveToFilter: moment.Moment | null | undefined, minEffectiveToFilter: moment.Moment | null | undefined, descriptionFilter: string | null | undefined, statusFilter: string | null | undefined, maxExpiredDaysFilter: number | null | undefined, minExpiredDaysFilter: number | null | undefined, maxOrderAmountRequiredFilter: number | null | undefined, minOrderAmountRequiredFilter: number | null | undefined, maxMaxSetFilter: number | null | undefined, minMaxSetFilter: number | null | undefined, maxReferrerPointFilter: number | null | undefined, minReferrerPointFilter: number | null | undefined, maxReferrerCoinFilter: number | null | undefined, minReferrerCoinFilter: number | null | undefined, maxRefereePointFilter: number | null | undefined, minRefereePointFilter: number | null | undefined, maxRefereeCoinFilter: number | null | undefined, minRefereeCoinFilter: number | null | undefined, referrerTargetAudienceCodeFilter: string | null | undefined, refereeTargetAudienceCodeFilter: string | null | undefined, campaignNameFilter: string | null | undefined): Observable<PointFileDto> {
        let url_ = this.baseUrl + "/api/services/app/Referrals/GetReferralsToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (maxEffectiveFromFilter !== undefined)
            url_ += "MaxEffectiveFromFilter=" + encodeURIComponent(maxEffectiveFromFilter ? "" + maxEffectiveFromFilter.toJSON() : "") + "&";
        if (minEffectiveFromFilter !== undefined)
            url_ += "MinEffectiveFromFilter=" + encodeURIComponent(minEffectiveFromFilter ? "" + minEffectiveFromFilter.toJSON() : "") + "&";
        if (maxEffectiveToFilter !== undefined)
            url_ += "MaxEffectiveToFilter=" + encodeURIComponent(maxEffectiveToFilter ? "" + maxEffectiveToFilter.toJSON() : "") + "&";
        if (minEffectiveToFilter !== undefined)
            url_ += "MinEffectiveToFilter=" + encodeURIComponent(minEffectiveToFilter ? "" + minEffectiveToFilter.toJSON() : "") + "&";
        if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (maxExpiredDaysFilter !== undefined)
            url_ += "MaxExpiredDaysFilter=" + encodeURIComponent("" + maxExpiredDaysFilter) + "&";
        if (minExpiredDaysFilter !== undefined)
            url_ += "MinExpiredDaysFilter=" + encodeURIComponent("" + minExpiredDaysFilter) + "&";
        if (maxOrderAmountRequiredFilter !== undefined)
            url_ += "MaxOrderAmountRequiredFilter=" + encodeURIComponent("" + maxOrderAmountRequiredFilter) + "&";
        if (minOrderAmountRequiredFilter !== undefined)
            url_ += "MinOrderAmountRequiredFilter=" + encodeURIComponent("" + minOrderAmountRequiredFilter) + "&";
        if (maxMaxSetFilter !== undefined)
            url_ += "MaxMaxSetFilter=" + encodeURIComponent("" + maxMaxSetFilter) + "&";
        if (minMaxSetFilter !== undefined)
            url_ += "MinMaxSetFilter=" + encodeURIComponent("" + minMaxSetFilter) + "&";
        if (maxReferrerPointFilter !== undefined)
            url_ += "MaxReferrerPointFilter=" + encodeURIComponent("" + maxReferrerPointFilter) + "&";
        if (minReferrerPointFilter !== undefined)
            url_ += "MinReferrerPointFilter=" + encodeURIComponent("" + minReferrerPointFilter) + "&";
        if (maxReferrerCoinFilter !== undefined)
            url_ += "MaxReferrerCoinFilter=" + encodeURIComponent("" + maxReferrerCoinFilter) + "&";
        if (minReferrerCoinFilter !== undefined)
            url_ += "MinReferrerCoinFilter=" + encodeURIComponent("" + minReferrerCoinFilter) + "&";
        if (maxRefereePointFilter !== undefined)
            url_ += "MaxRefereePointFilter=" + encodeURIComponent("" + maxRefereePointFilter) + "&";
        if (minRefereePointFilter !== undefined)
            url_ += "MinRefereePointFilter=" + encodeURIComponent("" + minRefereePointFilter) + "&";
        if (maxRefereeCoinFilter !== undefined)
            url_ += "MaxRefereeCoinFilter=" + encodeURIComponent("" + maxRefereeCoinFilter) + "&";
        if (minRefereeCoinFilter !== undefined)
            url_ += "MinRefereeCoinFilter=" + encodeURIComponent("" + minRefereeCoinFilter) + "&";
        if (referrerTargetAudienceCodeFilter !== undefined)
            url_ += "ReferrerTargetAudienceCodeFilter=" + encodeURIComponent("" + referrerTargetAudienceCodeFilter) + "&";
        if (refereeTargetAudienceCodeFilter !== undefined)
            url_ += "RefereeTargetAudienceCodeFilter=" + encodeURIComponent("" + refereeTargetAudienceCodeFilter) + "&";
        if (campaignNameFilter !== undefined)
            url_ += "CampaignNameFilter=" + encodeURIComponent("" + campaignNameFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetReferralsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReferralsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<PointFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PointFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetReferralsToExcel(response: HttpResponseBase): Observable<PointFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PointFileDto.fromJS(resultData200) : new PointFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PointFileDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllCampaignForLookupTable(filter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfCampaignLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/Referrals/GetAllCampaignForLookupTable?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllCampaignForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCampaignForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfCampaignLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfCampaignLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllCampaignForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfCampaignLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfCampaignLookupTableDto.fromJS(resultData200) : new PagedResultDtoOfCampaignLookupTableDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfCampaignLookupTableDto>(<any>null);
    }
}

@Injectable()
export class ReferralTransactionsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param transactionCodeFilter (optional) 
     * @param referralUserFilter (optional) 
     * @param referalCodeFilter (optional) 
     * @param maxReferalTimeFilter (optional) 
     * @param minReferalTimeFilter (optional) 
     * @param voucherGroupCodeFilter (optional) 
     * @param isGrantedFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, transactionCodeFilter: string | null | undefined, referralUserFilter: string | null | undefined, referalCodeFilter: string | null | undefined, maxReferalTimeFilter: moment.Moment | null | undefined, minReferalTimeFilter: moment.Moment | null | undefined, voucherGroupCodeFilter: string | null | undefined, isGrantedFilter: number | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetReferralTransactionForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/ReferralTransactions/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (transactionCodeFilter !== undefined)
            url_ += "TransactionCodeFilter=" + encodeURIComponent("" + transactionCodeFilter) + "&";
        if (referralUserFilter !== undefined)
            url_ += "ReferralUserFilter=" + encodeURIComponent("" + referralUserFilter) + "&";
        if (referalCodeFilter !== undefined)
            url_ += "ReferalCodeFilter=" + encodeURIComponent("" + referalCodeFilter) + "&";
        if (maxReferalTimeFilter !== undefined)
            url_ += "MaxReferalTimeFilter=" + encodeURIComponent(maxReferalTimeFilter ? "" + maxReferalTimeFilter.toJSON() : "") + "&";
        if (minReferalTimeFilter !== undefined)
            url_ += "MinReferalTimeFilter=" + encodeURIComponent(minReferalTimeFilter ? "" + minReferalTimeFilter.toJSON() : "") + "&";
        if (voucherGroupCodeFilter !== undefined)
            url_ += "VoucherGroupCodeFilter=" + encodeURIComponent("" + voucherGroupCodeFilter) + "&";
        if (isGrantedFilter !== undefined)
            url_ += "IsGrantedFilter=" + encodeURIComponent("" + isGrantedFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetReferralTransactionForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetReferralTransactionForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetReferralTransactionForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetReferralTransactionForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetReferralTransactionForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetReferralTransactionForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getReferralTransactionForEdit(id: number | null | undefined): Observable<GetReferralTransactionForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/ReferralTransactions/GetReferralTransactionForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetReferralTransactionForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReferralTransactionForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetReferralTransactionForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetReferralTransactionForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetReferralTransactionForEdit(response: HttpResponseBase): Observable<GetReferralTransactionForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetReferralTransactionForEditOutput.fromJS(resultData200) : new GetReferralTransactionForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetReferralTransactionForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditReferralTransactionDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ReferralTransactions/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ReferralTransactions/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param transactionCodeFilter (optional) 
     * @param referralUserFilter (optional) 
     * @param referalCodeFilter (optional) 
     * @param maxReferalTimeFilter (optional) 
     * @param minReferalTimeFilter (optional) 
     * @param voucherGroupCodeFilter (optional) 
     * @param isGrantedFilter (optional) 
     * @return Success
     */
    getReferralTransactionsToExcel(filter: string | null | undefined, transactionCodeFilter: string | null | undefined, referralUserFilter: string | null | undefined, referalCodeFilter: string | null | undefined, maxReferalTimeFilter: moment.Moment | null | undefined, minReferalTimeFilter: moment.Moment | null | undefined, voucherGroupCodeFilter: string | null | undefined, isGrantedFilter: number | null | undefined): Observable<RewardsFileDto> {
        let url_ = this.baseUrl + "/api/services/app/ReferralTransactions/GetReferralTransactionsToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (transactionCodeFilter !== undefined)
            url_ += "TransactionCodeFilter=" + encodeURIComponent("" + transactionCodeFilter) + "&";
        if (referralUserFilter !== undefined)
            url_ += "ReferralUserFilter=" + encodeURIComponent("" + referralUserFilter) + "&";
        if (referalCodeFilter !== undefined)
            url_ += "ReferalCodeFilter=" + encodeURIComponent("" + referalCodeFilter) + "&";
        if (maxReferalTimeFilter !== undefined)
            url_ += "MaxReferalTimeFilter=" + encodeURIComponent(maxReferalTimeFilter ? "" + maxReferalTimeFilter.toJSON() : "") + "&";
        if (minReferalTimeFilter !== undefined)
            url_ += "MinReferalTimeFilter=" + encodeURIComponent(minReferalTimeFilter ? "" + minReferalTimeFilter.toJSON() : "") + "&";
        if (voucherGroupCodeFilter !== undefined)
            url_ += "VoucherGroupCodeFilter=" + encodeURIComponent("" + voucherGroupCodeFilter) + "&";
        if (isGrantedFilter !== undefined)
            url_ += "IsGrantedFilter=" + encodeURIComponent("" + isGrantedFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetReferralTransactionsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReferralTransactionsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<RewardsFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<RewardsFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetReferralTransactionsToExcel(response: HttpResponseBase): Observable<RewardsFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? RewardsFileDto.fromJS(resultData200) : new RewardsFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RewardsFileDto>(<any>null);
    }
}

@Injectable()
export class RegionsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param codeFilter (optional) 
     * @param nameFilter (optional) 
     * @param isActiveFilter (optional) 
     * @param levelFilter (optional) 
     * @param parentCode (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, codeFilter: string | null | undefined, nameFilter: string | null | undefined, isActiveFilter: number | null | undefined, levelFilter: number | null | undefined, parentCode: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetRegionForView> {
        let url_ = this.baseUrl + "/api/services/app/Regions/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&";
        if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (isActiveFilter !== undefined)
            url_ += "IsActiveFilter=" + encodeURIComponent("" + isActiveFilter) + "&";
        if (levelFilter !== undefined)
            url_ += "LevelFilter=" + encodeURIComponent("" + levelFilter) + "&";
        if (parentCode !== undefined)
            url_ += "ParentCode=" + encodeURIComponent("" + parentCode) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetRegionForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetRegionForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetRegionForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetRegionForView.fromJS(resultData200) : new PagedResultDtoOfGetRegionForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetRegionForView>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getRegionForEdit(id: number | null | undefined): Observable<GetRegionForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Regions/GetRegionForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetRegionForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRegionForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetRegionForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetRegionForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetRegionForEdit(response: HttpResponseBase): Observable<GetRegionForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetRegionForEditOutput.fromJS(resultData200) : new GetRegionForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetRegionForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditRegionDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Regions/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Regions/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param entities (optional) 
     * @return Success
     */
    sync(entities: CreateOrEditRegionDto[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Regions/Sync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entities);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSync(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSync(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEditExt(input: CreateOrEditRegionDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Regions/CreateOrEditExt";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEditExt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditExt(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEditExt(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param codeFilter (optional) 
     * @param nameFilter (optional) 
     * @param isActiveFilter (optional) 
     * @param levelFilter (optional) 
     * @param parentCode (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllExt(filter: string | null | undefined, codeFilter: string | null | undefined, nameFilter: string | null | undefined, isActiveFilter: number | null | undefined, levelFilter: number | null | undefined, parentCode: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetRegionForView> {
        let url_ = this.baseUrl + "/api/services/app/Regions/GetAllExt?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&";
        if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (isActiveFilter !== undefined)
            url_ += "IsActiveFilter=" + encodeURIComponent("" + isActiveFilter) + "&";
        if (levelFilter !== undefined)
            url_ += "LevelFilter=" + encodeURIComponent("" + levelFilter) + "&";
        if (parentCode !== undefined)
            url_ += "ParentCode=" + encodeURIComponent("" + parentCode) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllExt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllExt(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetRegionForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetRegionForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllExt(response: HttpResponseBase): Observable<PagedResultDtoOfGetRegionForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetRegionForView.fromJS(resultData200) : new PagedResultDtoOfGetRegionForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetRegionForView>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteExt(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Regions/DeleteExt?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteExt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteExt(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteExt(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class RegisterWarrantysServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    searchForWarrantySerial(input: GetAllWarrantySerialsInput | null | undefined): Observable<PagedResultDtoOfGetWarrantySerialForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/RegisterWarrantys/SearchForWarrantySerial";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSearchForWarrantySerial(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchForWarrantySerial(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetWarrantySerialForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetWarrantySerialForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processSearchForWarrantySerial(response: HttpResponseBase): Observable<PagedResultDtoOfGetWarrantySerialForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetWarrantySerialForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetWarrantySerialForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetWarrantySerialForViewDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    warrantySerialsExportToExcel(input: GetAllWarrantySerialsInput | null | undefined): Observable<SocialRetailerFileDto> {
        let url_ = this.baseUrl + "/api/services/app/RegisterWarrantys/WarrantySerialsExportToExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processWarrantySerialsExportToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWarrantySerialsExportToExcel(<any>response_);
                } catch (e) {
                    return <Observable<SocialRetailerFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SocialRetailerFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processWarrantySerialsExportToExcel(response: HttpResponseBase): Observable<SocialRetailerFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? SocialRetailerFileDto.fromJS(resultData200) : new SocialRetailerFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SocialRetailerFileDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    searchComboHeaders(input: GetAllComboHeadersInput | null | undefined): Observable<PagedResultDtoOfGetComboHeaderForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/RegisterWarrantys/SearchComboHeaders";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSearchComboHeaders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchComboHeaders(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetComboHeaderForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetComboHeaderForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processSearchComboHeaders(response: HttpResponseBase): Observable<PagedResultDtoOfGetComboHeaderForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetComboHeaderForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetComboHeaderForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetComboHeaderForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteComboHeader(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/RegisterWarrantys/DeleteComboHeader?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteComboHeader(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteComboHeader(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteComboHeader(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    saveCombo(input: FullComboDto | null | undefined): Observable<SaveComboResponseDto> {
        let url_ = this.baseUrl + "/api/services/app/RegisterWarrantys/SaveCombo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSaveCombo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveCombo(<any>response_);
                } catch (e) {
                    return <Observable<SaveComboResponseDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SaveComboResponseDto>><any>_observableThrow(response_);
        }));
    }

    protected processSaveCombo(response: HttpResponseBase): Observable<SaveComboResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? SaveComboResponseDto.fromJS(resultData200) : new SaveComboResponseDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SaveComboResponseDto>(<any>null);
    }

    /**
     * @param comboHeadercode (optional) 
     * @return Success
     */
    loadCombo(comboHeadercode: string | null | undefined): Observable<LoadComboResponseDto> {
        let url_ = this.baseUrl + "/api/services/app/RegisterWarrantys/LoadCombo?";
        if (comboHeadercode !== undefined)
            url_ += "comboHeadercode=" + encodeURIComponent("" + comboHeadercode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processLoadCombo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLoadCombo(<any>response_);
                } catch (e) {
                    return <Observable<LoadComboResponseDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<LoadComboResponseDto>><any>_observableThrow(response_);
        }));
    }

    protected processLoadCombo(response: HttpResponseBase): Observable<LoadComboResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? LoadComboResponseDto.fromJS(resultData200) : new LoadComboResponseDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LoadComboResponseDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    searchFormulaHeaders(input: GetAllFormulaHeadersInput | null | undefined): Observable<PagedResultDtoOfGetFormulaHeaderForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/RegisterWarrantys/SearchFormulaHeaders";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSearchFormulaHeaders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchFormulaHeaders(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetFormulaHeaderForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetFormulaHeaderForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processSearchFormulaHeaders(response: HttpResponseBase): Observable<PagedResultDtoOfGetFormulaHeaderForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetFormulaHeaderForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetFormulaHeaderForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetFormulaHeaderForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getFormulaHeaderForEdit(id: number | null | undefined): Observable<GetFormulaHeaderForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/RegisterWarrantys/GetFormulaHeaderForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetFormulaHeaderForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFormulaHeaderForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetFormulaHeaderForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetFormulaHeaderForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetFormulaHeaderForEdit(response: HttpResponseBase): Observable<GetFormulaHeaderForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetFormulaHeaderForEditOutput.fromJS(resultData200) : new GetFormulaHeaderForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetFormulaHeaderForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEditFormulaHeader(input: CreateOrEditFormulaHeaderDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/RegisterWarrantys/CreateOrEditFormulaHeader";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEditFormulaHeader(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditFormulaHeader(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEditFormulaHeader(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param comboHeaderCode (optional) 
     * @return Success
     */
    getComboDetail(comboHeaderCode: string | null | undefined): Observable<ComboDetailExtDto> {
        let url_ = this.baseUrl + "/api/services/app/RegisterWarrantys/GetComboDetail?";
        if (comboHeaderCode !== undefined)
            url_ += "comboHeaderCode=" + encodeURIComponent("" + comboHeaderCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetComboDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetComboDetail(<any>response_);
                } catch (e) {
                    return <Observable<ComboDetailExtDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ComboDetailExtDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetComboDetail(response: HttpResponseBase): Observable<ComboDetailExtDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? ComboDetailExtDto.fromJS(resultData200) : new ComboDetailExtDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ComboDetailExtDto>(<any>null);
    }

    /**
     * @param serial (optional) 
     * @return Success
     */
    getWarrantySerial(serial: string | null | undefined): Observable<WarrantySerialDto> {
        let url_ = this.baseUrl + "/api/services/app/RegisterWarrantys/GetWarrantySerial?";
        if (serial !== undefined)
            url_ += "serial=" + encodeURIComponent("" + serial) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetWarrantySerial(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWarrantySerial(<any>response_);
                } catch (e) {
                    return <Observable<WarrantySerialDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<WarrantySerialDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetWarrantySerial(response: HttpResponseBase): Observable<WarrantySerialDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? WarrantySerialDto.fromJS(resultData200) : new WarrantySerialDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WarrantySerialDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    adjustWarrantyDate(input: WarrantyAdjustRequestDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/RegisterWarrantys/AdjustWarrantyDate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processAdjustWarrantyDate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdjustWarrantyDate(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processAdjustWarrantyDate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param codeFilter (optional) 
     * @param fileNameFilter (optional) 
     * @param statusFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllAdjustmentFile(codeFilter: string | null | undefined, fileNameFilter: string | null | undefined, statusFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetWarrantyAdjustmentFileStatusForView> {
        let url_ = this.baseUrl + "/api/services/app/RegisterWarrantys/GetAllAdjustmentFile?";
        if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&";
        if (fileNameFilter !== undefined)
            url_ += "FileNameFilter=" + encodeURIComponent("" + fileNameFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllAdjustmentFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAdjustmentFile(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetWarrantyAdjustmentFileStatusForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetWarrantyAdjustmentFileStatusForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllAdjustmentFile(response: HttpResponseBase): Observable<PagedResultDtoOfGetWarrantyAdjustmentFileStatusForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetWarrantyAdjustmentFileStatusForView.fromJS(resultData200) : new PagedResultDtoOfGetWarrantyAdjustmentFileStatusForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetWarrantyAdjustmentFileStatusForView>(<any>null);
    }

    /**
     * @param arg (optional) 
     * @return Success
     */
    importAdjustment(arg: WarrantyAdjustmentImportJobArgs | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/RegisterWarrantys/ImportAdjustment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(arg);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processImportAdjustment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportAdjustment(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processImportAdjustment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param serialFilter (optional) 
     * @param minUpdatedTimeFilter (optional) 
     * @param maxUpdatedTimeFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllAdjustmentLog(serialFilter: string | null | undefined, minUpdatedTimeFilter: moment.Moment | null | undefined, maxUpdatedTimeFilter: moment.Moment | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetWarrantyAdjustmentLogForView> {
        let url_ = this.baseUrl + "/api/services/app/RegisterWarrantys/GetAllAdjustmentLog?";
        if (serialFilter !== undefined)
            url_ += "SerialFilter=" + encodeURIComponent("" + serialFilter) + "&";
        if (minUpdatedTimeFilter !== undefined)
            url_ += "MinUpdatedTimeFilter=" + encodeURIComponent(minUpdatedTimeFilter ? "" + minUpdatedTimeFilter.toJSON() : "") + "&";
        if (maxUpdatedTimeFilter !== undefined)
            url_ += "MaxUpdatedTimeFilter=" + encodeURIComponent(maxUpdatedTimeFilter ? "" + maxUpdatedTimeFilter.toJSON() : "") + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllAdjustmentLog(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAdjustmentLog(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetWarrantyAdjustmentLogForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetWarrantyAdjustmentLogForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllAdjustmentLog(response: HttpResponseBase): Observable<PagedResultDtoOfGetWarrantyAdjustmentLogForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetWarrantyAdjustmentLogForView.fromJS(resultData200) : new PagedResultDtoOfGetWarrantyAdjustmentLogForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetWarrantyAdjustmentLogForView>(<any>null);
    }

    /**
     * @param arg (optional) 
     * @return Success
     */
    importQueue(arg: CommonImportAgrs | null | undefined): Observable<StatusImportDistributeDto> {
        let url_ = this.baseUrl + "/api/services/app/RegisterWarrantys/ImportQueue";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(arg);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processImportQueue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportQueue(<any>response_);
                } catch (e) {
                    return <Observable<StatusImportDistributeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<StatusImportDistributeDto>><any>_observableThrow(response_);
        }));
    }

    protected processImportQueue(response: HttpResponseBase): Observable<StatusImportDistributeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? StatusImportDistributeDto.fromJS(resultData200) : new StatusImportDistributeDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StatusImportDistributeDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    cancelRegisterWarranty(input: WarrantyCancelRequestDto | null | undefined): Observable<ResponseDataDtoOfString> {
        let url_ = this.baseUrl + "/api/services/app/RegisterWarrantys/CancelRegisterWarranty";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCancelRegisterWarranty(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelRegisterWarranty(<any>response_);
                } catch (e) {
                    return <Observable<ResponseDataDtoOfString>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResponseDataDtoOfString>><any>_observableThrow(response_);
        }));
    }

    protected processCancelRegisterWarranty(response: HttpResponseBase): Observable<ResponseDataDtoOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? ResponseDataDtoOfString.fromJS(resultData200) : new ResponseDataDtoOfString();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseDataDtoOfString>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    unlockActive(input: WarrantyCancelRequestDto | null | undefined): Observable<ResponseDataDtoOfString> {
        let url_ = this.baseUrl + "/api/services/app/RegisterWarrantys/UnlockActive";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUnlockActive(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnlockActive(<any>response_);
                } catch (e) {
                    return <Observable<ResponseDataDtoOfString>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResponseDataDtoOfString>><any>_observableThrow(response_);
        }));
    }

    protected processUnlockActive(response: HttpResponseBase): Observable<ResponseDataDtoOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? ResponseDataDtoOfString.fromJS(resultData200) : new ResponseDataDtoOfString();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseDataDtoOfString>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    editNote(input: WarrantyCancelRequestDto | null | undefined): Observable<ResponseDataDtoOfString> {
        let url_ = this.baseUrl + "/api/services/app/RegisterWarrantys/EditNote";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processEditNote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditNote(<any>response_);
                } catch (e) {
                    return <Observable<ResponseDataDtoOfString>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResponseDataDtoOfString>><any>_observableThrow(response_);
        }));
    }

    protected processEditNote(response: HttpResponseBase): Observable<ResponseDataDtoOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? ResponseDataDtoOfString.fromJS(resultData200) : new ResponseDataDtoOfString();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseDataDtoOfString>(<any>null);
    }

    /**
     * @return Success
     */
    getAllProvince(): Observable<PagedResultDtoOfGetRegionForView> {
        let url_ = this.baseUrl + "/api/services/app/RegisterWarrantys/GetAllProvince";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllProvince(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllProvince(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetRegionForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetRegionForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllProvince(response: HttpResponseBase): Observable<PagedResultDtoOfGetRegionForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetRegionForView.fromJS(resultData200) : new PagedResultDtoOfGetRegionForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetRegionForView>(<any>null);
    }

    /**
     * @return Success
     */
    getAllDistrict(): Observable<PagedResultDtoOfGetRegionForView> {
        let url_ = this.baseUrl + "/api/services/app/RegisterWarrantys/GetAllDistrict";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllDistrict(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllDistrict(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetRegionForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetRegionForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllDistrict(response: HttpResponseBase): Observable<PagedResultDtoOfGetRegionForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetRegionForView.fromJS(resultData200) : new PagedResultDtoOfGetRegionForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetRegionForView>(<any>null);
    }

    /**
     * @return Success
     */
    getAllWard(): Observable<PagedResultDtoOfGetRegionForView> {
        let url_ = this.baseUrl + "/api/services/app/RegisterWarrantys/GetAllWard";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllWard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllWard(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetRegionForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetRegionForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllWard(response: HttpResponseBase): Observable<PagedResultDtoOfGetRegionForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetRegionForView.fromJS(resultData200) : new PagedResultDtoOfGetRegionForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetRegionForView>(<any>null);
    }

    /**
     * @param provinceId (optional) 
     * @return Success
     */
    getDistrictByProvince(provinceId: string | null | undefined): Observable<PagedResultDtoOfGetRegionForView> {
        let url_ = this.baseUrl + "/api/services/app/RegisterWarrantys/GetDistrictByProvince?";
        if (provinceId !== undefined)
            url_ += "provinceId=" + encodeURIComponent("" + provinceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetDistrictByProvince(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDistrictByProvince(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetRegionForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetRegionForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetDistrictByProvince(response: HttpResponseBase): Observable<PagedResultDtoOfGetRegionForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetRegionForView.fromJS(resultData200) : new PagedResultDtoOfGetRegionForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetRegionForView>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    registerNew(input: RegisterWarrantyRequestDto | null | undefined): Observable<RegisterWarrantyResponseDto> {
        let url_ = this.baseUrl + "/api/services/app/RegisterWarrantys/RegisterNew";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processRegisterNew(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegisterNew(<any>response_);
                } catch (e) {
                    return <Observable<RegisterWarrantyResponseDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<RegisterWarrantyResponseDto>><any>_observableThrow(response_);
        }));
    }

    protected processRegisterNew(response: HttpResponseBase): Observable<RegisterWarrantyResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? RegisterWarrantyResponseDto.fromJS(resultData200) : new RegisterWarrantyResponseDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RegisterWarrantyResponseDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    verifySerial(input: VerifySerialRequestDto | null | undefined): Observable<VerifySerialResponseDto> {
        let url_ = this.baseUrl + "/api/services/app/RegisterWarrantys/VerifySerial";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processVerifySerial(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerifySerial(<any>response_);
                } catch (e) {
                    return <Observable<VerifySerialResponseDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<VerifySerialResponseDto>><any>_observableThrow(response_);
        }));
    }

    protected processVerifySerial(response: HttpResponseBase): Observable<VerifySerialResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? VerifySerialResponseDto.fromJS(resultData200) : new VerifySerialResponseDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VerifySerialResponseDto>(<any>null);
    }

    /**
     * @param serial (optional) 
     * @param serialExt (optional) 
     * @param productType (optional) 
     * @return Success
     */
    getSerialWarrantyDetail(serial: string | null | undefined, serialExt: string | null | undefined, productType: string | null | undefined): Observable<GetSerialWarrantyDetailResponseDto> {
        let url_ = this.baseUrl + "/api/services/app/RegisterWarrantys/GetSerialWarrantyDetail?";
        if (serial !== undefined)
            url_ += "Serial=" + encodeURIComponent("" + serial) + "&";
        if (serialExt !== undefined)
            url_ += "SerialExt=" + encodeURIComponent("" + serialExt) + "&";
        if (productType !== undefined)
            url_ += "ProductType=" + encodeURIComponent("" + productType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSerialWarrantyDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSerialWarrantyDetail(<any>response_);
                } catch (e) {
                    return <Observable<GetSerialWarrantyDetailResponseDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetSerialWarrantyDetailResponseDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetSerialWarrantyDetail(response: HttpResponseBase): Observable<GetSerialWarrantyDetailResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetSerialWarrantyDetailResponseDto.fromJS(resultData200) : new GetSerialWarrantyDetailResponseDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSerialWarrantyDetailResponseDto>(<any>null);
    }
}

@Injectable()
export class RelatedProductsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param maxProductIdFilter (optional) 
     * @param minProductIdFilter (optional) 
     * @param maxRelatedProductIdFilter (optional) 
     * @param minRelatedProductIdFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, maxProductIdFilter: number | null | undefined, minProductIdFilter: number | null | undefined, maxRelatedProductIdFilter: number | null | undefined, minRelatedProductIdFilter: number | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetRelatedProductForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/RelatedProducts/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxProductIdFilter !== undefined)
            url_ += "MaxProductIdFilter=" + encodeURIComponent("" + maxProductIdFilter) + "&";
        if (minProductIdFilter !== undefined)
            url_ += "MinProductIdFilter=" + encodeURIComponent("" + minProductIdFilter) + "&";
        if (maxRelatedProductIdFilter !== undefined)
            url_ += "MaxRelatedProductIdFilter=" + encodeURIComponent("" + maxRelatedProductIdFilter) + "&";
        if (minRelatedProductIdFilter !== undefined)
            url_ += "MinRelatedProductIdFilter=" + encodeURIComponent("" + minRelatedProductIdFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetRelatedProductForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetRelatedProductForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetRelatedProductForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetRelatedProductForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetRelatedProductForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetRelatedProductForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getRelatedProductForEdit(id: number | null | undefined): Observable<GetRelatedProductForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/RelatedProducts/GetRelatedProductForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetRelatedProductForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRelatedProductForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetRelatedProductForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetRelatedProductForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetRelatedProductForEdit(response: HttpResponseBase): Observable<GetRelatedProductForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetRelatedProductForEditOutput.fromJS(resultData200) : new GetRelatedProductForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetRelatedProductForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditRelatedProductDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/RelatedProducts/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/RelatedProducts/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param maxProductIdFilter (optional) 
     * @param minProductIdFilter (optional) 
     * @param maxRelatedProductIdFilter (optional) 
     * @param minRelatedProductIdFilter (optional) 
     * @return Success
     */
    getRelatedProductsToExcel(filter: string | null | undefined, maxProductIdFilter: number | null | undefined, minProductIdFilter: number | null | undefined, maxRelatedProductIdFilter: number | null | undefined, minRelatedProductIdFilter: number | null | undefined): Observable<ConsumerDBFileDto> {
        let url_ = this.baseUrl + "/api/services/app/RelatedProducts/GetRelatedProductsToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxProductIdFilter !== undefined)
            url_ += "MaxProductIdFilter=" + encodeURIComponent("" + maxProductIdFilter) + "&";
        if (minProductIdFilter !== undefined)
            url_ += "MinProductIdFilter=" + encodeURIComponent("" + minProductIdFilter) + "&";
        if (maxRelatedProductIdFilter !== undefined)
            url_ += "MaxRelatedProductIdFilter=" + encodeURIComponent("" + maxRelatedProductIdFilter) + "&";
        if (minRelatedProductIdFilter !== undefined)
            url_ += "MinRelatedProductIdFilter=" + encodeURIComponent("" + minRelatedProductIdFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetRelatedProductsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRelatedProductsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<ConsumerDBFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ConsumerDBFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetRelatedProductsToExcel(response: HttpResponseBase): Observable<ConsumerDBFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? ConsumerDBFileDto.fromJS(resultData200) : new ConsumerDBFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ConsumerDBFileDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createList(input: CreateOrEditRelatedProductDto[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/RelatedProducts/CreateList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateList(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateList(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param productId (optional) 
     * @return Success
     */
    deleteAllById(productId: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/RelatedProducts/DeleteAllById?";
        if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteAllById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAllById(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteAllById(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param productId (optional) 
     * @return Success
     */
    getRelatedProductById(productId: number | null | undefined): Observable<number[]> {
        let url_ = this.baseUrl + "/api/services/app/RelatedProducts/GetRelatedProductById?";
        if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetRelatedProductById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRelatedProductById(<any>response_);
                } catch (e) {
                    return <Observable<number[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<number[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetRelatedProductById(response: HttpResponseBase): Observable<number[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(item);
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number[]>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    searchForAddRelatedProduct(input: GetAllRelatedProductForAdd | null | undefined): Observable<PagedResultDtoOfGetProductForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/RelatedProducts/SearchForAddRelatedProduct";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSearchForAddRelatedProduct(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchForAddRelatedProduct(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetProductForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetProductForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processSearchForAddRelatedProduct(response: HttpResponseBase): Observable<PagedResultDtoOfGetProductForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetProductForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetProductForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetProductForViewDto>(<any>null);
    }
}

@Injectable()
export class ReportServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param regionCode (optional) 
     * @return Success
     */
    searchSellInSellOutByDate(fromDate: string | null | undefined, toDate: string | null | undefined, regionCode: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/report/search-sell-in-sell-out-by-date?";
        if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        if (regionCode !== undefined)
            url_ += "regionCode=" + encodeURIComponent("" + regionCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSearchSellInSellOutByDate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchSellInSellOutByDate(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSearchSellInSellOutByDate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param regionCode (optional) 
     * @return Success
     */
    exportSellInSellOutByDate(fromDate: string | null | undefined, toDate: string | null | undefined, regionCode: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/report/export-sell-in-sell-out-by-date?";
        if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        if (regionCode !== undefined)
            url_ += "regionCode=" + encodeURIComponent("" + regionCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processExportSellInSellOutByDate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportSellInSellOutByDate(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processExportSellInSellOutByDate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param channelCode (optional) 
     * @return Success
     */
    searchSellInSellOutByChannel(fromDate: string | null | undefined, toDate: string | null | undefined, channelCode: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/report/search-sell-in-sell-out-by-channel?";
        if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        if (channelCode !== undefined)
            url_ += "channelCode=" + encodeURIComponent("" + channelCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSearchSellInSellOutByChannel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchSellInSellOutByChannel(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSearchSellInSellOutByChannel(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param channelCode (optional) 
     * @return Success
     */
    exportSellInSellOutByChannel(fromDate: string | null | undefined, toDate: string | null | undefined, channelCode: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/report/export-sell-in-sell-out-by-channel?";
        if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        if (channelCode !== undefined)
            url_ += "channelCode=" + encodeURIComponent("" + channelCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processExportSellInSellOutByChannel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportSellInSellOutByChannel(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processExportSellInSellOutByChannel(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param regionCode (optional) 
     * @param areaCode (optional) 
     * @param provinceCode (optional) 
     * @return Success
     */
    searchSellInSellOutByProvince(fromDate: string | null | undefined, toDate: string | null | undefined, regionCode: string | null | undefined, areaCode: string | null | undefined, provinceCode: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/report/search-sell-in-sell-out-by-province?";
        if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        if (regionCode !== undefined)
            url_ += "regionCode=" + encodeURIComponent("" + regionCode) + "&";
        if (areaCode !== undefined)
            url_ += "areaCode=" + encodeURIComponent("" + areaCode) + "&";
        if (provinceCode !== undefined)
            url_ += "provinceCode=" + encodeURIComponent("" + provinceCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSearchSellInSellOutByProvince(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchSellInSellOutByProvince(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSearchSellInSellOutByProvince(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param regionCode (optional) 
     * @param areaCode (optional) 
     * @param provinceCode (optional) 
     * @return Success
     */
    exportSellInSellOutByProvince(fromDate: string | null | undefined, toDate: string | null | undefined, regionCode: string | null | undefined, areaCode: string | null | undefined, provinceCode: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/report/export-sell-in-sell-out-by-province?";
        if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        if (regionCode !== undefined)
            url_ += "regionCode=" + encodeURIComponent("" + regionCode) + "&";
        if (areaCode !== undefined)
            url_ += "areaCode=" + encodeURIComponent("" + areaCode) + "&";
        if (provinceCode !== undefined)
            url_ += "provinceCode=" + encodeURIComponent("" + provinceCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processExportSellInSellOutByProvince(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportSellInSellOutByProvince(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processExportSellInSellOutByProvince(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param areaCode (optional) 
     * @param hierarchyL1 (optional) 
     * @param hierarchyL2 (optional) 
     * @param hierarchyL3 (optional) 
     * @param productCode (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    searchCustomerInventory(areaCode: string | null | undefined, hierarchyL1: string | null | undefined, hierarchyL2: string | null | undefined, hierarchyL3: string | null | undefined, productCode: string | null | undefined, maxResultCount: string | null | undefined, skipCount: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/report/search-customer-inventory?";
        if (areaCode !== undefined)
            url_ += "areaCode=" + encodeURIComponent("" + areaCode) + "&";
        if (hierarchyL1 !== undefined)
            url_ += "hierarchyL1=" + encodeURIComponent("" + hierarchyL1) + "&";
        if (hierarchyL2 !== undefined)
            url_ += "hierarchyL2=" + encodeURIComponent("" + hierarchyL2) + "&";
        if (hierarchyL3 !== undefined)
            url_ += "hierarchyL3=" + encodeURIComponent("" + hierarchyL3) + "&";
        if (productCode !== undefined)
            url_ += "productCode=" + encodeURIComponent("" + productCode) + "&";
        if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSearchCustomerInventory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchCustomerInventory(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSearchCustomerInventory(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param areaCode (optional) 
     * @param hierarchyL1 (optional) 
     * @param hierarchyL2 (optional) 
     * @param hierarchyL3 (optional) 
     * @param productCode (optional) 
     * @return Success
     */
    exportCustomerInventory(areaCode: string | null | undefined, hierarchyL1: string | null | undefined, hierarchyL2: string | null | undefined, hierarchyL3: string | null | undefined, productCode: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/report/export-customer-inventory?";
        if (areaCode !== undefined)
            url_ += "areaCode=" + encodeURIComponent("" + areaCode) + "&";
        if (hierarchyL1 !== undefined)
            url_ += "hierarchyL1=" + encodeURIComponent("" + hierarchyL1) + "&";
        if (hierarchyL2 !== undefined)
            url_ += "hierarchyL2=" + encodeURIComponent("" + hierarchyL2) + "&";
        if (hierarchyL3 !== undefined)
            url_ += "hierarchyL3=" + encodeURIComponent("" + hierarchyL3) + "&";
        if (productCode !== undefined)
            url_ += "productCode=" + encodeURIComponent("" + productCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processExportCustomerInventory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportCustomerInventory(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processExportCustomerInventory(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param regionCode (optional) 
     * @param areaCode (optional) 
     * @param provinceCode (optional) 
     * @param hierarchyL1 (optional) 
     * @param hierarchyL2 (optional) 
     * @param hierarchyL3 (optional) 
     * @param productCode (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param distributorCode (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    searchSalesByDistributor(regionCode: string | null | undefined, areaCode: string | null | undefined, provinceCode: string | null | undefined, hierarchyL1: string | null | undefined, hierarchyL2: string | null | undefined, hierarchyL3: string | null | undefined, productCode: string | null | undefined, startDate: string | null | undefined, endDate: string | null | undefined, distributorCode: string | null | undefined, maxResultCount: string | null | undefined, skipCount: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/report/search-sales-by-distributor?";
        if (regionCode !== undefined)
            url_ += "regionCode=" + encodeURIComponent("" + regionCode) + "&";
        if (areaCode !== undefined)
            url_ += "areaCode=" + encodeURIComponent("" + areaCode) + "&";
        if (provinceCode !== undefined)
            url_ += "provinceCode=" + encodeURIComponent("" + provinceCode) + "&";
        if (hierarchyL1 !== undefined)
            url_ += "hierarchyL1=" + encodeURIComponent("" + hierarchyL1) + "&";
        if (hierarchyL2 !== undefined)
            url_ += "hierarchyL2=" + encodeURIComponent("" + hierarchyL2) + "&";
        if (hierarchyL3 !== undefined)
            url_ += "hierarchyL3=" + encodeURIComponent("" + hierarchyL3) + "&";
        if (productCode !== undefined)
            url_ += "productCode=" + encodeURIComponent("" + productCode) + "&";
        if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent("" + startDate) + "&";
        if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent("" + endDate) + "&";
        if (distributorCode !== undefined)
            url_ += "distributorCode=" + encodeURIComponent("" + distributorCode) + "&";
        if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSearchSalesByDistributor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchSalesByDistributor(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSearchSalesByDistributor(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param regionCode (optional) 
     * @param areaCode (optional) 
     * @param provinceCode (optional) 
     * @param hierarchyL1 (optional) 
     * @param hierarchyL2 (optional) 
     * @param hierarchyL3 (optional) 
     * @param productCode (optional) 
     * @param distributorCode (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return Success
     */
    exportSalesByDistributor(regionCode: string | null | undefined, areaCode: string | null | undefined, provinceCode: string | null | undefined, hierarchyL1: string | null | undefined, hierarchyL2: string | null | undefined, hierarchyL3: string | null | undefined, productCode: string | null | undefined, distributorCode: string | null | undefined, startDate: string | null | undefined, endDate: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/report/export-sales-by-distributor?";
        if (regionCode !== undefined)
            url_ += "regionCode=" + encodeURIComponent("" + regionCode) + "&";
        if (areaCode !== undefined)
            url_ += "areaCode=" + encodeURIComponent("" + areaCode) + "&";
        if (provinceCode !== undefined)
            url_ += "provinceCode=" + encodeURIComponent("" + provinceCode) + "&";
        if (hierarchyL1 !== undefined)
            url_ += "hierarchyL1=" + encodeURIComponent("" + hierarchyL1) + "&";
        if (hierarchyL2 !== undefined)
            url_ += "hierarchyL2=" + encodeURIComponent("" + hierarchyL2) + "&";
        if (hierarchyL3 !== undefined)
            url_ += "hierarchyL3=" + encodeURIComponent("" + hierarchyL3) + "&";
        if (productCode !== undefined)
            url_ += "productCode=" + encodeURIComponent("" + productCode) + "&";
        if (distributorCode !== undefined)
            url_ += "distributorCode=" + encodeURIComponent("" + distributorCode) + "&";
        if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent("" + startDate) + "&";
        if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent("" + endDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processExportSalesByDistributor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportSalesByDistributor(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processExportSalesByDistributor(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param areaCode (optional) 
     * @param hierarchyL1 (optional) 
     * @param hierarchyL2 (optional) 
     * @param hierarchyL3 (optional) 
     * @param productCode (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    searchSalesByMembershop(areaCode: string | null | undefined, hierarchyL1: string | null | undefined, hierarchyL2: string | null | undefined, hierarchyL3: string | null | undefined, productCode: string | null | undefined, maxResultCount: string | null | undefined, skipCount: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/report/search-sales-by-membershop?";
        if (areaCode !== undefined)
            url_ += "areaCode=" + encodeURIComponent("" + areaCode) + "&";
        if (hierarchyL1 !== undefined)
            url_ += "hierarchyL1=" + encodeURIComponent("" + hierarchyL1) + "&";
        if (hierarchyL2 !== undefined)
            url_ += "hierarchyL2=" + encodeURIComponent("" + hierarchyL2) + "&";
        if (hierarchyL3 !== undefined)
            url_ += "hierarchyL3=" + encodeURIComponent("" + hierarchyL3) + "&";
        if (productCode !== undefined)
            url_ += "productCode=" + encodeURIComponent("" + productCode) + "&";
        if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSearchSalesByMembershop(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchSalesByMembershop(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSearchSalesByMembershop(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param areaCode (optional) 
     * @param hierarchyL1 (optional) 
     * @param hierarchyL2 (optional) 
     * @param hierarchyL3 (optional) 
     * @param productCode (optional) 
     * @return Success
     */
    exportSalesByMembershop(areaCode: string | null | undefined, hierarchyL1: string | null | undefined, hierarchyL2: string | null | undefined, hierarchyL3: string | null | undefined, productCode: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/report/export-sales-by-membershop?";
        if (areaCode !== undefined)
            url_ += "areaCode=" + encodeURIComponent("" + areaCode) + "&";
        if (hierarchyL1 !== undefined)
            url_ += "hierarchyL1=" + encodeURIComponent("" + hierarchyL1) + "&";
        if (hierarchyL2 !== undefined)
            url_ += "hierarchyL2=" + encodeURIComponent("" + hierarchyL2) + "&";
        if (hierarchyL3 !== undefined)
            url_ += "hierarchyL3=" + encodeURIComponent("" + hierarchyL3) + "&";
        if (productCode !== undefined)
            url_ += "productCode=" + encodeURIComponent("" + productCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processExportSalesByMembershop(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportSalesByMembershop(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processExportSalesByMembershop(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param regionCode (optional) 
     * @param areaCode (optional) 
     * @param provinceCode (optional) 
     * @param memberCode (optional) 
     * @param hierarchyL1 (optional) 
     * @param hierarchyL2 (optional) 
     * @param hierarchyL3 (optional) 
     * @param hierarchyL4 (optional) 
     * @param hierarchyL5 (optional) 
     * @return Success
     */
    searchSellInSellOutActivationTrendByDate(fromDate: string | null | undefined, toDate: string | null | undefined, regionCode: string | null | undefined, areaCode: string | null | undefined, provinceCode: string | null | undefined, memberCode: string | null | undefined, hierarchyL1: string | null | undefined, hierarchyL2: string | null | undefined, hierarchyL3: string | null | undefined, hierarchyL4: string | null | undefined, hierarchyL5: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/report/search-sell-in-sell-out-activation-trend-by-date?";
        if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        if (regionCode !== undefined)
            url_ += "regionCode=" + encodeURIComponent("" + regionCode) + "&";
        if (areaCode !== undefined)
            url_ += "areaCode=" + encodeURIComponent("" + areaCode) + "&";
        if (provinceCode !== undefined)
            url_ += "provinceCode=" + encodeURIComponent("" + provinceCode) + "&";
        if (memberCode !== undefined)
            url_ += "memberCode=" + encodeURIComponent("" + memberCode) + "&";
        if (hierarchyL1 !== undefined)
            url_ += "hierarchyL1=" + encodeURIComponent("" + hierarchyL1) + "&";
        if (hierarchyL2 !== undefined)
            url_ += "hierarchyL2=" + encodeURIComponent("" + hierarchyL2) + "&";
        if (hierarchyL3 !== undefined)
            url_ += "hierarchyL3=" + encodeURIComponent("" + hierarchyL3) + "&";
        if (hierarchyL4 !== undefined)
            url_ += "hierarchyL4=" + encodeURIComponent("" + hierarchyL4) + "&";
        if (hierarchyL5 !== undefined)
            url_ += "hierarchyL5=" + encodeURIComponent("" + hierarchyL5) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSearchSellInSellOutActivationTrendByDate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchSellInSellOutActivationTrendByDate(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSearchSellInSellOutActivationTrendByDate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param provinceCode (optional) 
     * @param hierarchyL1 (optional) 
     * @return Success
     */
    searchSellInSellOutActivationTrendByDistrict(fromDate: string | null | undefined, toDate: string | null | undefined, provinceCode: string | null | undefined, hierarchyL1: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/report/search-sell-in-sell-out-activation-trend-by-district?";
        if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        if (provinceCode !== undefined)
            url_ += "provinceCode=" + encodeURIComponent("" + provinceCode) + "&";
        if (hierarchyL1 !== undefined)
            url_ += "hierarchyL1=" + encodeURIComponent("" + hierarchyL1) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSearchSellInSellOutActivationTrendByDistrict(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchSellInSellOutActivationTrendByDistrict(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSearchSellInSellOutActivationTrendByDistrict(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param regionCode (optional) 
     * @param areaCode (optional) 
     * @param hierarchyL1 (optional) 
     * @return Success
     */
    searchSellInSellOutActivationTrendByProvince(fromDate: string | null | undefined, toDate: string | null | undefined, regionCode: string | null | undefined, areaCode: string | null | undefined, hierarchyL1: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/report/search-sell-in-sell-out-activation-trend-by-province?";
        if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        if (regionCode !== undefined)
            url_ += "regionCode=" + encodeURIComponent("" + regionCode) + "&";
        if (areaCode !== undefined)
            url_ += "areaCode=" + encodeURIComponent("" + areaCode) + "&";
        if (hierarchyL1 !== undefined)
            url_ += "hierarchyL1=" + encodeURIComponent("" + hierarchyL1) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSearchSellInSellOutActivationTrendByProvince(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchSellInSellOutActivationTrendByProvince(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSearchSellInSellOutActivationTrendByProvince(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param salesChannel (optional) 
     * @return Success
     */
    searchSalesByMonth(fromDate: string | null | undefined, toDate: string | null | undefined, salesChannel: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/report/search-sales-by-month?";
        if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        if (salesChannel !== undefined)
            url_ += "salesChannel=" + encodeURIComponent("" + salesChannel) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSearchSalesByMonth(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchSalesByMonth(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSearchSalesByMonth(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param salesChannel (optional) 
     * @return Success
     */
    exportSalesByMonth(fromDate: string | null | undefined, toDate: string | null | undefined, salesChannel: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/report/export-sales-by-month?";
        if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        if (salesChannel !== undefined)
            url_ += "salesChannel=" + encodeURIComponent("" + salesChannel) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processExportSalesByMonth(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportSalesByMonth(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processExportSalesByMonth(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @return Success
     */
    searchSellOutActivationByActivators(fromDate: string | null | undefined, toDate: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/report/search-sell-out-activation-by-activators?";
        if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSearchSellOutActivationByActivators(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchSellOutActivationByActivators(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSearchSellOutActivationByActivators(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @return Success
     */
    exportSellOutActivationByActivators(fromDate: string | null | undefined, toDate: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/report/export-sell-out-activation-by-activators?";
        if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processExportSellOutActivationByActivators(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportSellOutActivationByActivators(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processExportSellOutActivationByActivators(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @return Success
     */
    searchSellOutSales(fromDate: string | null | undefined, toDate: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/report/search-sell-out-sales?";
        if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSearchSellOutSales(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchSellOutSales(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSearchSellOutSales(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @return Success
     */
    exportSellOutSales(fromDate: string | null | undefined, toDate: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/report/export-sell-out-sales?";
        if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processExportSellOutSales(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportSellOutSales(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processExportSellOutSales(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @return Success
     */
    searchPaymentByActivator(fromDate: string | null | undefined, toDate: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/report/search-payment-by-activator?";
        if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSearchPaymentByActivator(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchPaymentByActivator(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSearchPaymentByActivator(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @return Success
     */
    exportPaymentByActivator(fromDate: string | null | undefined, toDate: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/report/export-payment-by-activator?";
        if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processExportPaymentByActivator(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportPaymentByActivator(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processExportPaymentByActivator(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param regionCode (optional) 
     * @param areaCode (optional) 
     * @param provinceCode (optional) 
     * @param districtCode (optional) 
     * @param memberCode (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    searchSellOutActivationDetails(fromDate: string | null | undefined, toDate: string | null | undefined, regionCode: string | null | undefined, areaCode: string | null | undefined, provinceCode: string | null | undefined, districtCode: string | null | undefined, memberCode: string | null | undefined, maxResultCount: string | null | undefined, skipCount: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/report/search-sell-out-activation-details?";
        if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        if (regionCode !== undefined)
            url_ += "regionCode=" + encodeURIComponent("" + regionCode) + "&";
        if (areaCode !== undefined)
            url_ += "areaCode=" + encodeURIComponent("" + areaCode) + "&";
        if (provinceCode !== undefined)
            url_ += "provinceCode=" + encodeURIComponent("" + provinceCode) + "&";
        if (districtCode !== undefined)
            url_ += "districtCode=" + encodeURIComponent("" + districtCode) + "&";
        if (memberCode !== undefined)
            url_ += "memberCode=" + encodeURIComponent("" + memberCode) + "&";
        if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSearchSellOutActivationDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchSellOutActivationDetails(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSearchSellOutActivationDetails(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param regionCode (optional) 
     * @param areaCode (optional) 
     * @param provinceCode (optional) 
     * @param districtCode (optional) 
     * @param memberCode (optional) 
     * @return Success
     */
    exportSellOutActivationDetails(fromDate: string | null | undefined, toDate: string | null | undefined, regionCode: string | null | undefined, areaCode: string | null | undefined, provinceCode: string | null | undefined, districtCode: string | null | undefined, memberCode: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/report/export-sell-out-activation-details?";
        if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        if (regionCode !== undefined)
            url_ += "regionCode=" + encodeURIComponent("" + regionCode) + "&";
        if (areaCode !== undefined)
            url_ += "areaCode=" + encodeURIComponent("" + areaCode) + "&";
        if (provinceCode !== undefined)
            url_ += "provinceCode=" + encodeURIComponent("" + provinceCode) + "&";
        if (districtCode !== undefined)
            url_ += "districtCode=" + encodeURIComponent("" + districtCode) + "&";
        if (memberCode !== undefined)
            url_ += "memberCode=" + encodeURIComponent("" + memberCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processExportSellOutActivationDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportSellOutActivationDetails(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processExportSellOutActivationDetails(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param regionCode (optional) 
     * @param areaCode (optional) 
     * @param provinceCode (optional) 
     * @param memberCode (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    searchPaymentHistoryForActivator(regionCode: string | null | undefined, areaCode: string | null | undefined, provinceCode: string | null | undefined, memberCode: string | null | undefined, maxResultCount: string | null | undefined, skipCount: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/report/search-payment-history-for-activator?";
        if (regionCode !== undefined)
            url_ += "regionCode=" + encodeURIComponent("" + regionCode) + "&";
        if (areaCode !== undefined)
            url_ += "areaCode=" + encodeURIComponent("" + areaCode) + "&";
        if (provinceCode !== undefined)
            url_ += "provinceCode=" + encodeURIComponent("" + provinceCode) + "&";
        if (memberCode !== undefined)
            url_ += "memberCode=" + encodeURIComponent("" + memberCode) + "&";
        if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSearchPaymentHistoryForActivator(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchPaymentHistoryForActivator(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSearchPaymentHistoryForActivator(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param regionCode (optional) 
     * @param areaCode (optional) 
     * @param provinceCode (optional) 
     * @param memberCode (optional) 
     * @return Success
     */
    exportPaymentHistoryForActivator(regionCode: string | null | undefined, areaCode: string | null | undefined, provinceCode: string | null | undefined, memberCode: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/report/export-payment-history-for-activator?";
        if (regionCode !== undefined)
            url_ += "regionCode=" + encodeURIComponent("" + regionCode) + "&";
        if (areaCode !== undefined)
            url_ += "areaCode=" + encodeURIComponent("" + areaCode) + "&";
        if (provinceCode !== undefined)
            url_ += "provinceCode=" + encodeURIComponent("" + provinceCode) + "&";
        if (memberCode !== undefined)
            url_ += "memberCode=" + encodeURIComponent("" + memberCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processExportPaymentHistoryForActivator(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportPaymentHistoryForActivator(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processExportPaymentHistoryForActivator(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param memberCode (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    searchSellInActivationDetails(fromDate: string | null | undefined, toDate: string | null | undefined, memberCode: string | null | undefined, maxResultCount: string | null | undefined, skipCount: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/report/search-sell-in-activation-details?";
        if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        if (memberCode !== undefined)
            url_ += "memberCode=" + encodeURIComponent("" + memberCode) + "&";
        if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSearchSellInActivationDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchSellInActivationDetails(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSearchSellInActivationDetails(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param memberCode (optional) 
     * @return Success
     */
    exportSellInActivationDetails(fromDate: string | null | undefined, toDate: string | null | undefined, memberCode: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/report/export-sell-in-activation-details?";
        if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        if (memberCode !== undefined)
            url_ += "memberCode=" + encodeURIComponent("" + memberCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processExportSellInActivationDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportSellInActivationDetails(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processExportSellInActivationDetails(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param serial (optional) 
     * @param distributorMemberCode (optional) 
     * @param memberShopMemberCode (optional) 
     * @param retailerMemberCode (optional) 
     * @param distributorProvinceCode (optional) 
     * @param memberShopProvinceCode (optional) 
     * @param retailerProvinceCode (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    searchSerialHistory(serial: string | null | undefined, distributorMemberCode: string | null | undefined, memberShopMemberCode: string | null | undefined, retailerMemberCode: string | null | undefined, distributorProvinceCode: string | null | undefined, memberShopProvinceCode: string | null | undefined, retailerProvinceCode: string | null | undefined, maxResultCount: string | null | undefined, skipCount: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/report/search-serial-history?";
        if (serial !== undefined)
            url_ += "serial=" + encodeURIComponent("" + serial) + "&";
        if (distributorMemberCode !== undefined)
            url_ += "distributorMemberCode=" + encodeURIComponent("" + distributorMemberCode) + "&";
        if (memberShopMemberCode !== undefined)
            url_ += "memberShopMemberCode=" + encodeURIComponent("" + memberShopMemberCode) + "&";
        if (retailerMemberCode !== undefined)
            url_ += "retailerMemberCode=" + encodeURIComponent("" + retailerMemberCode) + "&";
        if (distributorProvinceCode !== undefined)
            url_ += "distributorProvinceCode=" + encodeURIComponent("" + distributorProvinceCode) + "&";
        if (memberShopProvinceCode !== undefined)
            url_ += "memberShopProvinceCode=" + encodeURIComponent("" + memberShopProvinceCode) + "&";
        if (retailerProvinceCode !== undefined)
            url_ += "retailerProvinceCode=" + encodeURIComponent("" + retailerProvinceCode) + "&";
        if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSearchSerialHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchSerialHistory(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSearchSerialHistory(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param serial (optional) 
     * @param distributorMemberCode (optional) 
     * @param memberShopMemberCode (optional) 
     * @param retailerMemberCode (optional) 
     * @param distributorProvinceCode (optional) 
     * @param memberShopProvinceCode (optional) 
     * @param retailerProvinceCode (optional) 
     * @return Success
     */
    exportSerialHistory(serial: string | null | undefined, distributorMemberCode: string | null | undefined, memberShopMemberCode: string | null | undefined, retailerMemberCode: string | null | undefined, distributorProvinceCode: string | null | undefined, memberShopProvinceCode: string | null | undefined, retailerProvinceCode: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/report/export-serial-history?";
        if (serial !== undefined)
            url_ += "serial=" + encodeURIComponent("" + serial) + "&";
        if (distributorMemberCode !== undefined)
            url_ += "distributorMemberCode=" + encodeURIComponent("" + distributorMemberCode) + "&";
        if (memberShopMemberCode !== undefined)
            url_ += "memberShopMemberCode=" + encodeURIComponent("" + memberShopMemberCode) + "&";
        if (retailerMemberCode !== undefined)
            url_ += "retailerMemberCode=" + encodeURIComponent("" + retailerMemberCode) + "&";
        if (distributorProvinceCode !== undefined)
            url_ += "distributorProvinceCode=" + encodeURIComponent("" + distributorProvinceCode) + "&";
        if (memberShopProvinceCode !== undefined)
            url_ += "memberShopProvinceCode=" + encodeURIComponent("" + memberShopProvinceCode) + "&";
        if (retailerProvinceCode !== undefined)
            url_ += "retailerProvinceCode=" + encodeURIComponent("" + retailerProvinceCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processExportSerialHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportSerialHistory(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processExportSerialHistory(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param hierarchyL1 (optional) 
     * @param regionCode (optional) 
     * @param areaCode (optional) 
     * @param provinceCode (optional) 
     * @param memberCode (optional) 
     * @return Success
     */
    searchSellInActivationByActivators(hierarchyL1: string | null | undefined, regionCode: string | null | undefined, areaCode: string | null | undefined, provinceCode: string | null | undefined, memberCode: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/report/search-sell-in-activation-by-activators?";
        if (hierarchyL1 !== undefined)
            url_ += "hierarchyL1=" + encodeURIComponent("" + hierarchyL1) + "&";
        if (regionCode !== undefined)
            url_ += "regionCode=" + encodeURIComponent("" + regionCode) + "&";
        if (areaCode !== undefined)
            url_ += "areaCode=" + encodeURIComponent("" + areaCode) + "&";
        if (provinceCode !== undefined)
            url_ += "provinceCode=" + encodeURIComponent("" + provinceCode) + "&";
        if (memberCode !== undefined)
            url_ += "memberCode=" + encodeURIComponent("" + memberCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSearchSellInActivationByActivators(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchSellInActivationByActivators(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSearchSellInActivationByActivators(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param hierarchyL1 (optional) 
     * @param regionCode (optional) 
     * @param areaCode (optional) 
     * @param provinceCode (optional) 
     * @param memberCode (optional) 
     * @return Success
     */
    exportSellInActivationByActivators(hierarchyL1: string | null | undefined, regionCode: string | null | undefined, areaCode: string | null | undefined, provinceCode: string | null | undefined, memberCode: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/report/export-sell-in-activation-by-activators?";
        if (hierarchyL1 !== undefined)
            url_ += "hierarchyL1=" + encodeURIComponent("" + hierarchyL1) + "&";
        if (regionCode !== undefined)
            url_ += "regionCode=" + encodeURIComponent("" + regionCode) + "&";
        if (areaCode !== undefined)
            url_ += "areaCode=" + encodeURIComponent("" + areaCode) + "&";
        if (provinceCode !== undefined)
            url_ += "provinceCode=" + encodeURIComponent("" + provinceCode) + "&";
        if (memberCode !== undefined)
            url_ += "memberCode=" + encodeURIComponent("" + memberCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processExportSellInActivationByActivators(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportSellInActivationByActivators(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processExportSellInActivationByActivators(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    searchVisits(fromDate: string | null | undefined, toDate: string | null | undefined, maxResultCount: string | null | undefined, skipCount: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/report/search-visits?";
        if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSearchVisits(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchVisits(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSearchVisits(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @return Success
     */
    exportVisits(fromDate: string | null | undefined, toDate: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/report/export-visits?";
        if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processExportVisits(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportVisits(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processExportVisits(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    searchVisitHistory(fromDate: string | null | undefined, toDate: string | null | undefined, maxResultCount: string | null | undefined, skipCount: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/report/search-visit-history?";
        if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSearchVisitHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchVisitHistory(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSearchVisitHistory(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @return Success
     */
    exportVisitHistory(fromDate: string | null | undefined, toDate: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/report/export-visit-history?";
        if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processExportVisitHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportVisitHistory(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processExportVisitHistory(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param provinceCode (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    searchCarePerformance(fromDate: string | null | undefined, toDate: string | null | undefined, provinceCode: string | null | undefined, maxResultCount: string | null | undefined, skipCount: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/report/search-care-performance?";
        if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        if (provinceCode !== undefined)
            url_ += "provinceCode=" + encodeURIComponent("" + provinceCode) + "&";
        if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSearchCarePerformance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchCarePerformance(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSearchCarePerformance(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param provinceCode (optional) 
     * @return Success
     */
    exportCarePerformance(fromDate: string | null | undefined, toDate: string | null | undefined, provinceCode: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/report/export-care-performance?";
        if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        if (provinceCode !== undefined)
            url_ += "provinceCode=" + encodeURIComponent("" + provinceCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processExportCarePerformance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportCarePerformance(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processExportCarePerformance(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param salemanCode (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    searchMonthlyTimesheet(fromDate: string | null | undefined, toDate: string | null | undefined, salemanCode: string | null | undefined, maxResultCount: string | null | undefined, skipCount: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/report/search-monthly-timesheet?";
        if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        if (salemanCode !== undefined)
            url_ += "salemanCode=" + encodeURIComponent("" + salemanCode) + "&";
        if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSearchMonthlyTimesheet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchMonthlyTimesheet(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSearchMonthlyTimesheet(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param salemanCode (optional) 
     * @return Success
     */
    exportMonthlyTimesheet(fromDate: string | null | undefined, toDate: string | null | undefined, salemanCode: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/report/export-monthly-timesheet?";
        if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        if (salemanCode !== undefined)
            url_ += "salemanCode=" + encodeURIComponent("" + salemanCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processExportMonthlyTimesheet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportMonthlyTimesheet(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processExportMonthlyTimesheet(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param regionCode (optional) 
     * @param areaCode (optional) 
     * @param provinceCode (optional) 
     * @param districtCode (optional) 
     * @param isMembershop (optional) 
     * @param memberCode (optional) 
     * @param hierarchyL1 (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    searchGoodsTrackingGt(fromDate: string | null | undefined, toDate: string | null | undefined, regionCode: string | null | undefined, areaCode: string | null | undefined, provinceCode: string | null | undefined, districtCode: string | null | undefined, isMembershop: string | null | undefined, memberCode: string | null | undefined, hierarchyL1: string | null | undefined, maxResultCount: string | null | undefined, skipCount: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/report/search-goods-tracking-gt?";
        if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        if (regionCode !== undefined)
            url_ += "regionCode=" + encodeURIComponent("" + regionCode) + "&";
        if (areaCode !== undefined)
            url_ += "areaCode=" + encodeURIComponent("" + areaCode) + "&";
        if (provinceCode !== undefined)
            url_ += "provinceCode=" + encodeURIComponent("" + provinceCode) + "&";
        if (districtCode !== undefined)
            url_ += "districtCode=" + encodeURIComponent("" + districtCode) + "&";
        if (isMembershop !== undefined)
            url_ += "isMembershop=" + encodeURIComponent("" + isMembershop) + "&";
        if (memberCode !== undefined)
            url_ += "memberCode=" + encodeURIComponent("" + memberCode) + "&";
        if (hierarchyL1 !== undefined)
            url_ += "hierarchyL1=" + encodeURIComponent("" + hierarchyL1) + "&";
        if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSearchGoodsTrackingGt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchGoodsTrackingGt(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSearchGoodsTrackingGt(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param regionCode (optional) 
     * @param areaCode (optional) 
     * @param provinceCode (optional) 
     * @param districtCode (optional) 
     * @param isMembershop (optional) 
     * @param memberCode (optional) 
     * @param hierarchyL1 (optional) 
     * @return Success
     */
    exportGoodsTrackingGt(fromDate: string | null | undefined, toDate: string | null | undefined, regionCode: string | null | undefined, areaCode: string | null | undefined, provinceCode: string | null | undefined, districtCode: string | null | undefined, isMembershop: string | null | undefined, memberCode: string | null | undefined, hierarchyL1: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/report/export-goods-tracking-gt?";
        if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        if (regionCode !== undefined)
            url_ += "regionCode=" + encodeURIComponent("" + regionCode) + "&";
        if (areaCode !== undefined)
            url_ += "areaCode=" + encodeURIComponent("" + areaCode) + "&";
        if (provinceCode !== undefined)
            url_ += "provinceCode=" + encodeURIComponent("" + provinceCode) + "&";
        if (districtCode !== undefined)
            url_ += "districtCode=" + encodeURIComponent("" + districtCode) + "&";
        if (isMembershop !== undefined)
            url_ += "isMembershop=" + encodeURIComponent("" + isMembershop) + "&";
        if (memberCode !== undefined)
            url_ += "memberCode=" + encodeURIComponent("" + memberCode) + "&";
        if (hierarchyL1 !== undefined)
            url_ += "hierarchyL1=" + encodeURIComponent("" + hierarchyL1) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processExportGoodsTrackingGt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportGoodsTrackingGt(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processExportGoodsTrackingGt(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param regionCode (optional) 
     * @param areaCode (optional) 
     * @param provinceCode (optional) 
     * @param districtCode (optional) 
     * @param isMembershop (optional) 
     * @param memberCode (optional) 
     * @param hierarchyL1 (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    searchGoodsTrackingMt(fromDate: string | null | undefined, toDate: string | null | undefined, regionCode: string | null | undefined, areaCode: string | null | undefined, provinceCode: string | null | undefined, districtCode: string | null | undefined, isMembershop: string | null | undefined, memberCode: string | null | undefined, hierarchyL1: string | null | undefined, maxResultCount: string | null | undefined, skipCount: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/report/search-goods-tracking-mt?";
        if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        if (regionCode !== undefined)
            url_ += "regionCode=" + encodeURIComponent("" + regionCode) + "&";
        if (areaCode !== undefined)
            url_ += "areaCode=" + encodeURIComponent("" + areaCode) + "&";
        if (provinceCode !== undefined)
            url_ += "provinceCode=" + encodeURIComponent("" + provinceCode) + "&";
        if (districtCode !== undefined)
            url_ += "districtCode=" + encodeURIComponent("" + districtCode) + "&";
        if (isMembershop !== undefined)
            url_ += "isMembershop=" + encodeURIComponent("" + isMembershop) + "&";
        if (memberCode !== undefined)
            url_ += "memberCode=" + encodeURIComponent("" + memberCode) + "&";
        if (hierarchyL1 !== undefined)
            url_ += "hierarchyL1=" + encodeURIComponent("" + hierarchyL1) + "&";
        if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSearchGoodsTrackingMt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchGoodsTrackingMt(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSearchGoodsTrackingMt(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param regionCode (optional) 
     * @param areaCode (optional) 
     * @param provinceCode (optional) 
     * @param districtCode (optional) 
     * @param isMembershop (optional) 
     * @param memberCode (optional) 
     * @param hierarchyL1 (optional) 
     * @return Success
     */
    exportGoodsTrackingMt(fromDate: string | null | undefined, toDate: string | null | undefined, regionCode: string | null | undefined, areaCode: string | null | undefined, provinceCode: string | null | undefined, districtCode: string | null | undefined, isMembershop: string | null | undefined, memberCode: string | null | undefined, hierarchyL1: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/report/export-goods-tracking-mt?";
        if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        if (regionCode !== undefined)
            url_ += "regionCode=" + encodeURIComponent("" + regionCode) + "&";
        if (areaCode !== undefined)
            url_ += "areaCode=" + encodeURIComponent("" + areaCode) + "&";
        if (provinceCode !== undefined)
            url_ += "provinceCode=" + encodeURIComponent("" + provinceCode) + "&";
        if (districtCode !== undefined)
            url_ += "districtCode=" + encodeURIComponent("" + districtCode) + "&";
        if (isMembershop !== undefined)
            url_ += "isMembershop=" + encodeURIComponent("" + isMembershop) + "&";
        if (memberCode !== undefined)
            url_ += "memberCode=" + encodeURIComponent("" + memberCode) + "&";
        if (hierarchyL1 !== undefined)
            url_ += "hierarchyL1=" + encodeURIComponent("" + hierarchyL1) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processExportGoodsTrackingMt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportGoodsTrackingMt(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processExportGoodsTrackingMt(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param serialYear (optional) 
     * @param sellInYear (optional) 
     * @param sellOutYear (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    searchTotalSellInSellOut(serialYear: string | null | undefined, sellInYear: string | null | undefined, sellOutYear: string | null | undefined, maxResultCount: string | null | undefined, skipCount: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/report/search-total-sell-in-sell-out?";
        if (serialYear !== undefined)
            url_ += "serialYear=" + encodeURIComponent("" + serialYear) + "&";
        if (sellInYear !== undefined)
            url_ += "sellInYear=" + encodeURIComponent("" + sellInYear) + "&";
        if (sellOutYear !== undefined)
            url_ += "sellOutYear=" + encodeURIComponent("" + sellOutYear) + "&";
        if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSearchTotalSellInSellOut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchTotalSellInSellOut(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSearchTotalSellInSellOut(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param serialYear (optional) 
     * @param sellInYear (optional) 
     * @param sellOutYear (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    exportTotalSellInSellOut(serialYear: string | null | undefined, sellInYear: string | null | undefined, sellOutYear: string | null | undefined, maxResultCount: string | null | undefined, skipCount: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/report/export-total-sell-in-sell-out?";
        if (serialYear !== undefined)
            url_ += "serialYear=" + encodeURIComponent("" + serialYear) + "&";
        if (sellInYear !== undefined)
            url_ += "sellInYear=" + encodeURIComponent("" + sellInYear) + "&";
        if (sellOutYear !== undefined)
            url_ += "sellOutYear=" + encodeURIComponent("" + sellOutYear) + "&";
        if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processExportTotalSellInSellOut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportTotalSellInSellOut(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processExportTotalSellInSellOut(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param regionCode (optional) 
     * @param areaCode (optional) 
     * @param provinceCode (optional) 
     * @param districtCode (optional) 
     * @param hierarchyL1 (optional) 
     * @return Success
     */
    searchSalesCasperCoverage(fromDate: string | null | undefined, toDate: string | null | undefined, regionCode: string | null | undefined, areaCode: string | null | undefined, provinceCode: string | null | undefined, districtCode: string | null | undefined, hierarchyL1: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/report/search-sales-casper-coverage?";
        if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        if (regionCode !== undefined)
            url_ += "regionCode=" + encodeURIComponent("" + regionCode) + "&";
        if (areaCode !== undefined)
            url_ += "areaCode=" + encodeURIComponent("" + areaCode) + "&";
        if (provinceCode !== undefined)
            url_ += "provinceCode=" + encodeURIComponent("" + provinceCode) + "&";
        if (districtCode !== undefined)
            url_ += "districtCode=" + encodeURIComponent("" + districtCode) + "&";
        if (hierarchyL1 !== undefined)
            url_ += "hierarchyL1=" + encodeURIComponent("" + hierarchyL1) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSearchSalesCasperCoverage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchSalesCasperCoverage(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSearchSalesCasperCoverage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param regionCode (optional) 
     * @param areaCode (optional) 
     * @param provinceCode (optional) 
     * @param districtCode (optional) 
     * @param memberCode (optional) 
     * @param hierarchyL1 (optional) 
     * @return Success
     */
    searchSalesBrandCoverage(fromDate: string | null | undefined, toDate: string | null | undefined, regionCode: string | null | undefined, areaCode: string | null | undefined, provinceCode: string | null | undefined, districtCode: string | null | undefined, memberCode: string | null | undefined, hierarchyL1: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/report/search-sales-brand-coverage?";
        if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        if (regionCode !== undefined)
            url_ += "regionCode=" + encodeURIComponent("" + regionCode) + "&";
        if (areaCode !== undefined)
            url_ += "areaCode=" + encodeURIComponent("" + areaCode) + "&";
        if (provinceCode !== undefined)
            url_ += "provinceCode=" + encodeURIComponent("" + provinceCode) + "&";
        if (districtCode !== undefined)
            url_ += "districtCode=" + encodeURIComponent("" + districtCode) + "&";
        if (memberCode !== undefined)
            url_ += "memberCode=" + encodeURIComponent("" + memberCode) + "&";
        if (hierarchyL1 !== undefined)
            url_ += "hierarchyL1=" + encodeURIComponent("" + hierarchyL1) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSearchSalesBrandCoverage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchSalesBrandCoverage(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSearchSalesBrandCoverage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param regionCode (optional) 
     * @param areaCode (optional) 
     * @param provinceCode (optional) 
     * @param districtCode (optional) 
     * @param memberCode (optional) 
     * @param saleType (optional) 
     * @return Success
     */
    searchCasperSellInSellOutRatio(fromDate: string | null | undefined, toDate: string | null | undefined, regionCode: string | null | undefined, areaCode: string | null | undefined, provinceCode: string | null | undefined, districtCode: string | null | undefined, memberCode: string | null | undefined, saleType: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/report/search-casper-sell-in-sell-out-ratio?";
        if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        if (regionCode !== undefined)
            url_ += "regionCode=" + encodeURIComponent("" + regionCode) + "&";
        if (areaCode !== undefined)
            url_ += "areaCode=" + encodeURIComponent("" + areaCode) + "&";
        if (provinceCode !== undefined)
            url_ += "provinceCode=" + encodeURIComponent("" + provinceCode) + "&";
        if (districtCode !== undefined)
            url_ += "districtCode=" + encodeURIComponent("" + districtCode) + "&";
        if (memberCode !== undefined)
            url_ += "memberCode=" + encodeURIComponent("" + memberCode) + "&";
        if (saleType !== undefined)
            url_ += "saleType=" + encodeURIComponent("" + saleType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSearchCasperSellInSellOutRatio(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchCasperSellInSellOutRatio(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSearchCasperSellInSellOutRatio(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param regionCode (optional) 
     * @param areaCode (optional) 
     * @param provinceCode (optional) 
     * @param memberCode (optional) 
     * @param hierarchyL1 (optional) 
     * @param saleType (optional) 
     * @return Success
     */
    searchSellInSellOutRatioByProduct(fromDate: string | null | undefined, toDate: string | null | undefined, regionCode: string | null | undefined, areaCode: string | null | undefined, provinceCode: string | null | undefined, memberCode: string | null | undefined, hierarchyL1: string | null | undefined, saleType: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/report/search-sell-in-sell-out-ratio-by-product?";
        if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        if (regionCode !== undefined)
            url_ += "regionCode=" + encodeURIComponent("" + regionCode) + "&";
        if (areaCode !== undefined)
            url_ += "areaCode=" + encodeURIComponent("" + areaCode) + "&";
        if (provinceCode !== undefined)
            url_ += "provinceCode=" + encodeURIComponent("" + provinceCode) + "&";
        if (memberCode !== undefined)
            url_ += "memberCode=" + encodeURIComponent("" + memberCode) + "&";
        if (hierarchyL1 !== undefined)
            url_ += "hierarchyL1=" + encodeURIComponent("" + hierarchyL1) + "&";
        if (saleType !== undefined)
            url_ += "saleType=" + encodeURIComponent("" + saleType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSearchSellInSellOutRatioByProduct(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchSellInSellOutRatioByProduct(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSearchSellInSellOutRatioByProduct(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param regionCode (optional) 
     * @param areaCode (optional) 
     * @param provinceCode (optional) 
     * @param memberCode (optional) 
     * @param hierarchyL1 (optional) 
     * @param hierarchyL2 (optional) 
     * @param hierarchyL3 (optional) 
     * @param hierarchyL4 (optional) 
     * @param productCode (optional) 
     * @param saleType (optional) 
     * @return Success
     */
    sellInSellOutGrowth(fromDate: string | null | undefined, toDate: string | null | undefined, regionCode: string | null | undefined, areaCode: string | null | undefined, provinceCode: string | null | undefined, memberCode: string | null | undefined, hierarchyL1: string | null | undefined, hierarchyL2: string | null | undefined, hierarchyL3: string | null | undefined, hierarchyL4: string | null | undefined, productCode: string | null | undefined, saleType: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/report/sell-in-sell-out-growth?";
        if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        if (regionCode !== undefined)
            url_ += "regionCode=" + encodeURIComponent("" + regionCode) + "&";
        if (areaCode !== undefined)
            url_ += "areaCode=" + encodeURIComponent("" + areaCode) + "&";
        if (provinceCode !== undefined)
            url_ += "provinceCode=" + encodeURIComponent("" + provinceCode) + "&";
        if (memberCode !== undefined)
            url_ += "memberCode=" + encodeURIComponent("" + memberCode) + "&";
        if (hierarchyL1 !== undefined)
            url_ += "hierarchyL1=" + encodeURIComponent("" + hierarchyL1) + "&";
        if (hierarchyL2 !== undefined)
            url_ += "hierarchyL2=" + encodeURIComponent("" + hierarchyL2) + "&";
        if (hierarchyL3 !== undefined)
            url_ += "hierarchyL3=" + encodeURIComponent("" + hierarchyL3) + "&";
        if (hierarchyL4 !== undefined)
            url_ += "hierarchyL4=" + encodeURIComponent("" + hierarchyL4) + "&";
        if (productCode !== undefined)
            url_ += "productCode=" + encodeURIComponent("" + productCode) + "&";
        if (saleType !== undefined)
            url_ += "saleType=" + encodeURIComponent("" + saleType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSellInSellOutGrowth(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSellInSellOutGrowth(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSellInSellOutGrowth(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param memberCode (optional) 
     * @return Success
     */
    searchMembershopLoyalty(memberCode: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/report/search-membershop-loyalty?";
        if (memberCode !== undefined)
            url_ += "memberCode=" + encodeURIComponent("" + memberCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSearchMembershopLoyalty(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchMembershopLoyalty(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSearchMembershopLoyalty(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param regionCode (optional) 
     * @param areaCode (optional) 
     * @param provinceCode (optional) 
     * @param districtCode (optional) 
     * @param memberCode (optional) 
     * @param hierarchyL1 (optional) 
     * @param hierarchyL2 (optional) 
     * @param hierarchyL3 (optional) 
     * @param hierarchyL4 (optional) 
     * @param productCode (optional) 
     * @return Success
     */
    searchSalesInventoryRatio(fromDate: string | null | undefined, toDate: string | null | undefined, regionCode: string | null | undefined, areaCode: string | null | undefined, provinceCode: string | null | undefined, districtCode: string | null | undefined, memberCode: string | null | undefined, hierarchyL1: string | null | undefined, hierarchyL2: string | null | undefined, hierarchyL3: string | null | undefined, hierarchyL4: string | null | undefined, productCode: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/report/search-sales-inventory-ratio?";
        if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        if (regionCode !== undefined)
            url_ += "regionCode=" + encodeURIComponent("" + regionCode) + "&";
        if (areaCode !== undefined)
            url_ += "areaCode=" + encodeURIComponent("" + areaCode) + "&";
        if (provinceCode !== undefined)
            url_ += "provinceCode=" + encodeURIComponent("" + provinceCode) + "&";
        if (districtCode !== undefined)
            url_ += "districtCode=" + encodeURIComponent("" + districtCode) + "&";
        if (memberCode !== undefined)
            url_ += "memberCode=" + encodeURIComponent("" + memberCode) + "&";
        if (hierarchyL1 !== undefined)
            url_ += "hierarchyL1=" + encodeURIComponent("" + hierarchyL1) + "&";
        if (hierarchyL2 !== undefined)
            url_ += "hierarchyL2=" + encodeURIComponent("" + hierarchyL2) + "&";
        if (hierarchyL3 !== undefined)
            url_ += "hierarchyL3=" + encodeURIComponent("" + hierarchyL3) + "&";
        if (hierarchyL4 !== undefined)
            url_ += "hierarchyL4=" + encodeURIComponent("" + hierarchyL4) + "&";
        if (productCode !== undefined)
            url_ += "productCode=" + encodeURIComponent("" + productCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSearchSalesInventoryRatio(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchSalesInventoryRatio(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSearchSalesInventoryRatio(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param fromDate2 (optional) 
     * @param toDate2 (optional) 
     * @param regionCode (optional) 
     * @param areaCode (optional) 
     * @param provinceCode (optional) 
     * @param districtCode (optional) 
     * @param memberCode (optional) 
     * @param hierarchyL1 (optional) 
     * @param hierarchyL2 (optional) 
     * @param hierarchyL3 (optional) 
     * @param hierarchyL4 (optional) 
     * @param productCode (optional) 
     * @param sortOrder (optional) 
     * @param saleType (optional) 
     * @param spName (optional) 
     * @return Success
     */
    searchChartData(fromDate: string | null | undefined, toDate: string | null | undefined, fromDate2: string | null | undefined, toDate2: string | null | undefined, regionCode: string | null | undefined, areaCode: string | null | undefined, provinceCode: string | null | undefined, districtCode: string | null | undefined, memberCode: string | null | undefined, hierarchyL1: string | null | undefined, hierarchyL2: string | null | undefined, hierarchyL3: string | null | undefined, hierarchyL4: string | null | undefined, productCode: string | null | undefined, sortOrder: string | null | undefined, saleType: string | null | undefined, spName: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/report/search-chart-data?";
        if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        if (fromDate2 !== undefined)
            url_ += "fromDate2=" + encodeURIComponent("" + fromDate2) + "&";
        if (toDate2 !== undefined)
            url_ += "toDate2=" + encodeURIComponent("" + toDate2) + "&";
        if (regionCode !== undefined)
            url_ += "regionCode=" + encodeURIComponent("" + regionCode) + "&";
        if (areaCode !== undefined)
            url_ += "areaCode=" + encodeURIComponent("" + areaCode) + "&";
        if (provinceCode !== undefined)
            url_ += "provinceCode=" + encodeURIComponent("" + provinceCode) + "&";
        if (districtCode !== undefined)
            url_ += "districtCode=" + encodeURIComponent("" + districtCode) + "&";
        if (memberCode !== undefined)
            url_ += "memberCode=" + encodeURIComponent("" + memberCode) + "&";
        if (hierarchyL1 !== undefined)
            url_ += "hierarchyL1=" + encodeURIComponent("" + hierarchyL1) + "&";
        if (hierarchyL2 !== undefined)
            url_ += "hierarchyL2=" + encodeURIComponent("" + hierarchyL2) + "&";
        if (hierarchyL3 !== undefined)
            url_ += "hierarchyL3=" + encodeURIComponent("" + hierarchyL3) + "&";
        if (hierarchyL4 !== undefined)
            url_ += "hierarchyL4=" + encodeURIComponent("" + hierarchyL4) + "&";
        if (productCode !== undefined)
            url_ += "productCode=" + encodeURIComponent("" + productCode) + "&";
        if (sortOrder !== undefined)
            url_ += "sortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        if (saleType !== undefined)
            url_ += "saleType=" + encodeURIComponent("" + saleType) + "&";
        if (spName !== undefined)
            url_ += "spName=" + encodeURIComponent("" + spName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSearchChartData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchChartData(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSearchChartData(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class MetaServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param regionCode (optional) 
     * @param areaCode (optional) 
     * @param provinceCode (optional) 
     * @param outletType (optional) 
     * @return Success
     */
    searchOutlet(regionCode: string | null | undefined, areaCode: string | null | undefined, provinceCode: string | null | undefined, outletType: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/report/meta/search-outlet?";
        if (regionCode !== undefined)
            url_ += "regionCode=" + encodeURIComponent("" + regionCode) + "&";
        if (areaCode !== undefined)
            url_ += "areaCode=" + encodeURIComponent("" + areaCode) + "&";
        if (provinceCode !== undefined)
            url_ += "provinceCode=" + encodeURIComponent("" + provinceCode) + "&";
        if (outletType !== undefined)
            url_ += "outletType=" + encodeURIComponent("" + outletType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSearchOutlet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchOutlet(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSearchOutlet(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class ReportSettingServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    get(): Observable<ReportSettingDto> {
        let url_ = this.baseUrl + "/api/services/app/ReportSetting/Get";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<ReportSettingDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ReportSettingDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ReportSettingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? ReportSettingDto.fromJS(resultData200) : new ReportSettingDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReportSettingDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrUpdate(input: ReportSettingDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ReportSetting/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdate(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class RequestServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditRequestInput | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Request/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createComment(input: CreateOrEditRequestInput | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Request/CreateComment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateComment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateComment(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateComment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param requestCode (optional) 
     * @param requestType (optional) 
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param assignerId (optional) 
     * @param assignerName (optional) 
     * @param requestStatus (optional) 
     * @param unsign (optional) 
     * @param phone (optional) 
     * @param memberCode (optional) 
     * @param memberName (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(requestCode: string | null | undefined, requestType: string | null | undefined, fromDate: moment.Moment | null | undefined, toDate: moment.Moment | null | undefined, assignerId: number | null | undefined, assignerName: string | null | undefined, requestStatus: string | null | undefined, unsign: string | null | undefined, phone: string | null | undefined, memberCode: string | null | undefined, memberName: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetListRequestResponse> {
        let url_ = this.baseUrl + "/api/services/app/Request/GetAll?";
        if (requestCode !== undefined)
            url_ += "RequestCode=" + encodeURIComponent("" + requestCode) + "&";
        if (requestType !== undefined)
            url_ += "RequestType=" + encodeURIComponent("" + requestType) + "&";
        if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toJSON() : "") + "&";
        if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toJSON() : "") + "&";
        if (assignerId !== undefined)
            url_ += "AssignerId=" + encodeURIComponent("" + assignerId) + "&";
        if (assignerName !== undefined)
            url_ += "AssignerName=" + encodeURIComponent("" + assignerName) + "&";
        if (requestStatus !== undefined)
            url_ += "RequestStatus=" + encodeURIComponent("" + requestStatus) + "&";
        if (unsign !== undefined)
            url_ += "Unsign=" + encodeURIComponent("" + unsign) + "&";
        if (phone !== undefined)
            url_ += "Phone=" + encodeURIComponent("" + phone) + "&";
        if (memberCode !== undefined)
            url_ += "MemberCode=" + encodeURIComponent("" + memberCode) + "&";
        if (memberName !== undefined)
            url_ += "MemberName=" + encodeURIComponent("" + memberName) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetListRequestResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetListRequestResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetListRequestResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetListRequestResponse.fromJS(resultData200) : new PagedResultDtoOfGetListRequestResponse();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetListRequestResponse>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createFileExcel(input: GetRequestInput | null | undefined): Observable<SocialRetailerFileDto> {
        let url_ = this.baseUrl + "/api/services/app/Request/CreateFileExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateFileExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateFileExcel(<any>response_);
                } catch (e) {
                    return <Observable<SocialRetailerFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SocialRetailerFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreateFileExcel(response: HttpResponseBase): Observable<SocialRetailerFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? SocialRetailerFileDto.fromJS(resultData200) : new SocialRetailerFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SocialRetailerFileDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @param step (optional) 
     * @return Success
     */
    getDetail(id: number | null | undefined, step: number | null | undefined): Observable<GetDetailRequestResponse> {
        let url_ = this.baseUrl + "/api/services/app/Request/GetDetail?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (step !== undefined)
            url_ += "step=" + encodeURIComponent("" + step) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDetail(<any>response_);
                } catch (e) {
                    return <Observable<GetDetailRequestResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetDetailRequestResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetDetail(response: HttpResponseBase): Observable<GetDetailRequestResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetDetailRequestResponse.fromJS(resultData200) : new GetDetailRequestResponse();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetDetailRequestResponse>(<any>null);
    }

    /**
     * @return Success
     */
    getRequestType(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/Request/GetRequestType";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetRequestType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRequestType(<any>response_);
                } catch (e) {
                    return <Observable<string[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<string[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetRequestType(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(item);
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string[]>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createAndGetRequestCode(input: CreateOrEditRequestInput | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Request/CreateAndGetRequestCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateAndGetRequestCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateAndGetRequestCode(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processCreateAndGetRequestCode(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param memberCode (optional) 
     * @return Success
     */
    checkProfileRequest(memberCode: string | null | undefined): Observable<CheckProfileRequestOutput> {
        let url_ = this.baseUrl + "/api/services/app/Request/CheckProfileRequest?";
        if (memberCode !== undefined)
            url_ += "memberCode=" + encodeURIComponent("" + memberCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCheckProfileRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckProfileRequest(<any>response_);
                } catch (e) {
                    return <Observable<CheckProfileRequestOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<CheckProfileRequestOutput>><any>_observableThrow(response_);
        }));
    }

    protected processCheckProfileRequest(response: HttpResponseBase): Observable<CheckProfileRequestOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? CheckProfileRequestOutput.fromJS(resultData200) : new CheckProfileRequestOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CheckProfileRequestOutput>(<any>null);
    }

    /**
     * @param memberCode (optional) 
     * @return Success
     */
    checkProfileRequestForApp(memberCode: string | null | undefined): Observable<CheckProfileRequestOutput> {
        let url_ = this.baseUrl + "/api/services/app/Request/CheckProfileRequestForApp?";
        if (memberCode !== undefined)
            url_ += "memberCode=" + encodeURIComponent("" + memberCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCheckProfileRequestForApp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckProfileRequestForApp(<any>response_);
                } catch (e) {
                    return <Observable<CheckProfileRequestOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<CheckProfileRequestOutput>><any>_observableThrow(response_);
        }));
    }

    protected processCheckProfileRequestForApp(response: HttpResponseBase): Observable<CheckProfileRequestOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? CheckProfileRequestOutput.fromJS(resultData200) : new CheckProfileRequestOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CheckProfileRequestOutput>(<any>null);
    }
}

@Injectable()
export class RewardItemServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param text (optional) 
     * @param isActive (optional) 
     * @param rewardType (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllRewardItem(text: string | null | undefined, isActive: boolean | null | undefined, rewardType: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfRewardItemResourceDTO> {
        let url_ = this.baseUrl + "/api/services/app/RewardItem/GetAllRewardItem?";
        if (text !== undefined)
            url_ += "Text=" + encodeURIComponent("" + text) + "&";
        if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (rewardType !== undefined)
            url_ += "RewardType=" + encodeURIComponent("" + rewardType) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllRewardItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllRewardItem(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfRewardItemResourceDTO>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfRewardItemResourceDTO>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllRewardItem(response: HttpResponseBase): Observable<PagedResultDtoOfRewardItemResourceDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfRewardItemResourceDTO.fromJS(resultData200) : new PagedResultDtoOfRewardItemResourceDTO();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfRewardItemResourceDTO>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getRewardItemDetail(id: number | null | undefined): Observable<RewardItemDetailResource> {
        let url_ = this.baseUrl + "/api/services/app/RewardItem/GetRewardItemDetail?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetRewardItemDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRewardItemDetail(<any>response_);
                } catch (e) {
                    return <Observable<RewardItemDetailResource>><any>_observableThrow(e);
                }
            } else
                return <Observable<RewardItemDetailResource>><any>_observableThrow(response_);
        }));
    }

    protected processGetRewardItemDetail(response: HttpResponseBase): Observable<RewardItemDetailResource> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? RewardItemDetailResource.fromJS(resultData200) : new RewardItemDetailResource();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RewardItemDetailResource>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: RewardItemCreateResource | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/RewardItem/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteRewardItem(id: number | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/RewardItem/DeleteRewardItem?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteRewardItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteRewardItem(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteRewardItem(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }
}

@Injectable()
export class RewardRedemptionRequestServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createRewardRedemptionRequest(input: RewardRedemptionRequestCreateDTO | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/RewardRedemptionRequest/CreateRewardRedemptionRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateRewardRedemptionRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateRewardRedemptionRequest(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processCreateRewardRedemptionRequest(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }
}

@Injectable()
export class RewardRedemptionUsedServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAllRewardRedemptionForApp(memberCode: string): Observable<RewardRedemptionForAppResult> {
        let url_ = this.baseUrl + "/api/services/app/RewardRedemptionUsed/GetAllRewardRedemptionForApp?";
        if (memberCode === undefined || memberCode === null)
            throw new Error("The parameter 'memberCode' must be defined and cannot be null.");
        else
            url_ += "MemberCode=" + encodeURIComponent("" + memberCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllRewardRedemptionForApp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllRewardRedemptionForApp(<any>response_);
                } catch (e) {
                    return <Observable<RewardRedemptionForAppResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<RewardRedemptionForAppResult>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllRewardRedemptionForApp(response: HttpResponseBase): Observable<RewardRedemptionForAppResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? RewardRedemptionForAppResult.fromJS(resultData200) : new RewardRedemptionForAppResult();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RewardRedemptionForAppResult>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    usedRewardItemForApp(input: RewardItemUsedForAppInput | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/RewardRedemptionUsed/UsedRewardItemForApp";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUsedRewardItemForApp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUsedRewardItemForApp(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processUsedRewardItemForApp(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }
}

@Injectable()
export class RewardsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param request (optional) 
     * @return Success
     */
    inputAction(request: InputActionRequestDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Rewards/InputAction";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processInputAction(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInputAction(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processInputAction(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class RewardTargetAudiencesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param targetAudienceNameFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param statusFilter (optional) 
     * @param maxTargetAudienceLinkIDFilter (optional) 
     * @param minTargetAudienceLinkIDFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, targetAudienceNameFilter: string | null | undefined, descriptionFilter: string | null | undefined, statusFilter: string | null | undefined, maxTargetAudienceLinkIDFilter: number | null | undefined, minTargetAudienceLinkIDFilter: number | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetRewardTargetAudienceForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/RewardTargetAudiences/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (targetAudienceNameFilter !== undefined)
            url_ += "TargetAudienceNameFilter=" + encodeURIComponent("" + targetAudienceNameFilter) + "&";
        if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (maxTargetAudienceLinkIDFilter !== undefined)
            url_ += "MaxTargetAudienceLinkIDFilter=" + encodeURIComponent("" + maxTargetAudienceLinkIDFilter) + "&";
        if (minTargetAudienceLinkIDFilter !== undefined)
            url_ += "MinTargetAudienceLinkIDFilter=" + encodeURIComponent("" + minTargetAudienceLinkIDFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetRewardTargetAudienceForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetRewardTargetAudienceForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetRewardTargetAudienceForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetRewardTargetAudienceForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetRewardTargetAudienceForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetRewardTargetAudienceForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getRewardTargetAudienceForEdit(id: number | null | undefined): Observable<GetRewardTargetAudienceForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/RewardTargetAudiences/GetRewardTargetAudienceForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetRewardTargetAudienceForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRewardTargetAudienceForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetRewardTargetAudienceForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetRewardTargetAudienceForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetRewardTargetAudienceForEdit(response: HttpResponseBase): Observable<GetRewardTargetAudienceForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetRewardTargetAudienceForEditOutput.fromJS(resultData200) : new GetRewardTargetAudienceForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetRewardTargetAudienceForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditRewardTargetAudienceDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/RewardTargetAudiences/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/RewardTargetAudiences/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param targetAudienceNameFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param statusFilter (optional) 
     * @param maxTargetAudienceLinkIDFilter (optional) 
     * @param minTargetAudienceLinkIDFilter (optional) 
     * @return Success
     */
    getRewardTargetAudiencesToExcel(filter: string | null | undefined, targetAudienceNameFilter: string | null | undefined, descriptionFilter: string | null | undefined, statusFilter: string | null | undefined, maxTargetAudienceLinkIDFilter: number | null | undefined, minTargetAudienceLinkIDFilter: number | null | undefined): Observable<RewardsFileDto> {
        let url_ = this.baseUrl + "/api/services/app/RewardTargetAudiences/GetRewardTargetAudiencesToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (targetAudienceNameFilter !== undefined)
            url_ += "TargetAudienceNameFilter=" + encodeURIComponent("" + targetAudienceNameFilter) + "&";
        if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (maxTargetAudienceLinkIDFilter !== undefined)
            url_ += "MaxTargetAudienceLinkIDFilter=" + encodeURIComponent("" + maxTargetAudienceLinkIDFilter) + "&";
        if (minTargetAudienceLinkIDFilter !== undefined)
            url_ += "MinTargetAudienceLinkIDFilter=" + encodeURIComponent("" + minTargetAudienceLinkIDFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetRewardTargetAudiencesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRewardTargetAudiencesToExcel(<any>response_);
                } catch (e) {
                    return <Observable<RewardsFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<RewardsFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetRewardTargetAudiencesToExcel(response: HttpResponseBase): Observable<RewardsFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? RewardsFileDto.fromJS(resultData200) : new RewardsFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RewardsFileDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    search(input: GetAllRewardTargetAudiencesInput | null | undefined): Observable<PagedResultDtoOfGetRewardTargetAudienceForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/RewardTargetAudiences/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetRewardTargetAudienceForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetRewardTargetAudienceForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<PagedResultDtoOfGetRewardTargetAudienceForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetRewardTargetAudienceForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetRewardTargetAudienceForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetRewardTargetAudienceForViewDto>(<any>null);
    }
}

@Injectable()
export class RoleServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param permission (optional) 
     * @return Success
     */
    getRoles(permission: string | null | undefined): Observable<ListResultDtoOfRoleListDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetRoles?";
        if (permission !== undefined)
            url_ += "Permission=" + encodeURIComponent("" + permission) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoles(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfRoleListDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfRoleListDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetRoles(response: HttpResponseBase): Observable<ListResultDtoOfRoleListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? ListResultDtoOfRoleListDto.fromJS(resultData200) : new ListResultDtoOfRoleListDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfRoleListDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getRoleForEdit(id: number | null | undefined): Observable<GetRoleForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetRoleForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetRoleForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoleForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetRoleForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetRoleForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetRoleForEdit(response: HttpResponseBase): Observable<GetRoleForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetRoleForEditOutput.fromJS(resultData200) : new GetRoleForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetRoleForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrUpdateRole(input: CreateOrUpdateRoleInput | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Role/CreateOrUpdateRole";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrUpdateRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateRole(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrUpdateRole(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteRole(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Role/DeleteRole?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteRole(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteRole(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class RuleGeneratorServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param productHierarchy (optional) 
     * @param keyFilter (optional) 
     * @param model (optional) 
     * @param status (optional) 
     * @param ruleType (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(productHierarchy: string | null | undefined, keyFilter: string | null | undefined, model: string | null | undefined, status: string | null | undefined, ruleType: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfRuleGeneratorResponseDto> {
        let url_ = this.baseUrl + "/api/services/app/RuleGenerator/GetAll?";
        if (productHierarchy !== undefined)
            url_ += "ProductHierarchy=" + encodeURIComponent("" + productHierarchy) + "&";
        if (keyFilter !== undefined)
            url_ += "KeyFilter=" + encodeURIComponent("" + keyFilter) + "&";
        if (model !== undefined)
            url_ += "Model=" + encodeURIComponent("" + model) + "&";
        if (status !== undefined)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (ruleType !== undefined)
            url_ += "RuleType=" + encodeURIComponent("" + ruleType) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfRuleGeneratorResponseDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfRuleGeneratorResponseDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfRuleGeneratorResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfRuleGeneratorResponseDto.fromJS(resultData200) : new PagedResultDtoOfRuleGeneratorResponseDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfRuleGeneratorResponseDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getById(id: number | null | undefined): Observable<RuleGeneratorDto> {
        let url_ = this.baseUrl + "/api/services/app/RuleGenerator/GetById?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(<any>response_);
                } catch (e) {
                    return <Observable<RuleGeneratorDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<RuleGeneratorDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<RuleGeneratorDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? RuleGeneratorDto.fromJS(resultData200) : new RuleGeneratorDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RuleGeneratorDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    cloneSerialRule(id: number | null | undefined): Observable<ResponseDtoOfBoolean> {
        let url_ = this.baseUrl + "/api/services/app/RuleGenerator/CloneSerialRule?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCloneSerialRule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCloneSerialRule(<any>response_);
                } catch (e) {
                    return <Observable<ResponseDtoOfBoolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResponseDtoOfBoolean>><any>_observableThrow(response_);
        }));
    }

    protected processCloneSerialRule(response: HttpResponseBase): Observable<ResponseDtoOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? ResponseDtoOfBoolean.fromJS(resultData200) : new ResponseDtoOfBoolean();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseDtoOfBoolean>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: RuleGeneratorDto | null | undefined): Observable<ResponseDtoOfBoolean> {
        let url_ = this.baseUrl + "/api/services/app/RuleGenerator/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<ResponseDtoOfBoolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResponseDtoOfBoolean>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<ResponseDtoOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? ResponseDtoOfBoolean.fromJS(resultData200) : new ResponseDtoOfBoolean();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseDtoOfBoolean>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/RuleGenerator/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param productHierarchy (optional) 
     * @param keyFilter (optional) 
     * @param model (optional) 
     * @param status (optional) 
     * @param ruleType (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    exportExcelRuleSerial(productHierarchy: string | null | undefined, keyFilter: string | null | undefined, model: string | null | undefined, status: string | null | undefined, ruleType: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/RuleGenerator/ExportExcelRuleSerial?";
        if (productHierarchy !== undefined)
            url_ += "ProductHierarchy=" + encodeURIComponent("" + productHierarchy) + "&";
        if (keyFilter !== undefined)
            url_ += "KeyFilter=" + encodeURIComponent("" + keyFilter) + "&";
        if (model !== undefined)
            url_ += "Model=" + encodeURIComponent("" + model) + "&";
        if (status !== undefined)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (ruleType !== undefined)
            url_ += "RuleType=" + encodeURIComponent("" + ruleType) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processExportExcelRuleSerial(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportExcelRuleSerial(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processExportExcelRuleSerial(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class SaleHistoriesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param saleId (optional) 
     * @return Success
     */
    getSaleHistory(saleId: number | null | undefined): Observable<PagedResultDtoOfSaleHistoryDto> {
        let url_ = this.baseUrl + "/api/services/app/SaleHistories/GetSaleHistory?";
        if (saleId !== undefined)
            url_ += "saleId=" + encodeURIComponent("" + saleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSaleHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSaleHistory(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfSaleHistoryDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfSaleHistoryDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetSaleHistory(response: HttpResponseBase): Observable<PagedResultDtoOfSaleHistoryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfSaleHistoryDto.fromJS(resultData200) : new PagedResultDtoOfSaleHistoryDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfSaleHistoryDto>(<any>null);
    }

    /**
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @return Success
     */
    getSaleHistoryForExport(fromDate: moment.Moment | null | undefined, toDate: moment.Moment | null | undefined): Observable<SocialRetailerFileDto> {
        let url_ = this.baseUrl + "/api/services/app/SaleHistories/GetSaleHistoryForExport?";
        if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toJSON() : "") + "&";
        if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent(toDate ? "" + toDate.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSaleHistoryForExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSaleHistoryForExport(<any>response_);
                } catch (e) {
                    return <Observable<SocialRetailerFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SocialRetailerFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetSaleHistoryForExport(response: HttpResponseBase): Observable<SocialRetailerFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? SocialRetailerFileDto.fromJS(resultData200) : new SocialRetailerFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SocialRetailerFileDto>(<any>null);
    }
}

@Injectable()
export class SaleOrderServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditSaleOrderInput | null | undefined): Observable<ResponseDtoOfBoolean> {
        let url_ = this.baseUrl + "/api/services/app/SaleOrder/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<ResponseDtoOfBoolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResponseDtoOfBoolean>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<ResponseDtoOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? ResponseDtoOfBoolean.fromJS(resultData200) : new ResponseDtoOfBoolean();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseDtoOfBoolean>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SaleOrder/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param orderGuid (optional) 
     * @param memberCode (optional) 
     * @param orderType (optional) 
     * @param orderStatus (optional) 
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(orderGuid: string | null | undefined, memberCode: string | null | undefined, orderType: number | null | undefined, orderStatus: number | null | undefined, fromDate: moment.Moment | null | undefined, toDate: moment.Moment | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetSaleOrderForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/SaleOrder/GetAll?";
        if (orderGuid !== undefined)
            url_ += "OrderGuid=" + encodeURIComponent("" + orderGuid) + "&";
        if (memberCode !== undefined)
            url_ += "MemberCode=" + encodeURIComponent("" + memberCode) + "&";
        if (orderType !== undefined)
            url_ += "OrderType=" + encodeURIComponent("" + orderType) + "&";
        if (orderStatus !== undefined)
            url_ += "OrderStatus=" + encodeURIComponent("" + orderStatus) + "&";
        if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toJSON() : "") + "&";
        if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toJSON() : "") + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetSaleOrderForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetSaleOrderForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetSaleOrderForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetSaleOrderForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetSaleOrderForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetSaleOrderForViewDto>(<any>null);
    }

    /**
     * @param orderGuid (optional) 
     * @return Success
     */
    getById(orderGuid: string | null | undefined): Observable<GetSaleOrderForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/SaleOrder/GetById?";
        if (orderGuid !== undefined)
            url_ += "OrderGuid=" + encodeURIComponent("" + orderGuid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(<any>response_);
                } catch (e) {
                    return <Observable<GetSaleOrderForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetSaleOrderForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<GetSaleOrderForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetSaleOrderForViewDto.fromJS(resultData200) : new GetSaleOrderForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSaleOrderForViewDto>(<any>null);
    }

    /**
     * @param orderGuid (optional) 
     * @return Success
     */
    cloneSaleOrder(orderGuid: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/SaleOrder/CloneSaleOrder?";
        if (orderGuid !== undefined)
            url_ += "OrderGuid=" + encodeURIComponent("" + orderGuid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCloneSaleOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCloneSaleOrder(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processCloneSaleOrder(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param orderGuid (optional) 
     * @param orderStatus (optional) 
     * @return Success
     */
    updateStatus(orderGuid: string | null | undefined, orderStatus: number | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/SaleOrder/UpdateStatus?";
        if (orderGuid !== undefined)
            url_ += "OrderGuid=" + encodeURIComponent("" + orderGuid) + "&";
        if (orderStatus !== undefined)
            url_ += "orderStatus=" + encodeURIComponent("" + orderStatus) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateStatus(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateStatus(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param orderGuid (optional) 
     * @return Success
     */
    cancelSale(orderGuid: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/SaleOrder/CancelSale?";
        if (orderGuid !== undefined)
            url_ += "OrderGuid=" + encodeURIComponent("" + orderGuid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCancelSale(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelSale(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processCancelSale(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    exportFile(input: GetSaleOrderInput | null | undefined): Observable<SocialRetailerFileDto> {
        let url_ = this.baseUrl + "/api/services/app/SaleOrder/ExportFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processExportFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportFile(<any>response_);
                } catch (e) {
                    return <Observable<SocialRetailerFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SocialRetailerFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processExportFile(response: HttpResponseBase): Observable<SocialRetailerFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? SocialRetailerFileDto.fromJS(resultData200) : new SocialRetailerFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SocialRetailerFileDto>(<any>null);
    }

    /**
     * @param arg (optional) 
     * @return Success
     */
    importFile(arg: CommonImportAgrs | null | undefined): Observable<CommonImportFileResponse> {
        let url_ = this.baseUrl + "/api/services/app/SaleOrder/ImportFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(arg);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processImportFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportFile(<any>response_);
                } catch (e) {
                    return <Observable<CommonImportFileResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<CommonImportFileResponse>><any>_observableThrow(response_);
        }));
    }

    protected processImportFile(response: HttpResponseBase): Observable<CommonImportFileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? CommonImportFileResponse.fromJS(resultData200) : new CommonImportFileResponse();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CommonImportFileResponse>(<any>null);
    }
}

@Injectable()
export class SaleOrderDetailServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditSaleOrderDetailInput | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SaleOrderDetail/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SaleOrderDetail/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param orderGuid (optional) 
     * @param orderDetailGuid (optional) 
     * @param productCode (optional) 
     * @param quantity (optional) 
     * @param discount (optional) 
     * @param price (optional) 
     * @param vAT (optional) 
     * @param lineTotal (optional) 
     * @param discount_Desc (optional) 
     * @param desc (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(orderGuid: string | null | undefined, orderDetailGuid: string | null | undefined, productCode: string | null | undefined, quantity: number | null | undefined, discount: number | null | undefined, price: number | null | undefined, vAT: number | null | undefined, lineTotal: number | null | undefined, discount_Desc: string | null | undefined, desc: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetSaleOrderDetailForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/SaleOrderDetail/GetAll?";
        if (orderGuid !== undefined)
            url_ += "OrderGuid=" + encodeURIComponent("" + orderGuid) + "&";
        if (orderDetailGuid !== undefined)
            url_ += "OrderDetailGuid=" + encodeURIComponent("" + orderDetailGuid) + "&";
        if (productCode !== undefined)
            url_ += "ProductCode=" + encodeURIComponent("" + productCode) + "&";
        if (quantity !== undefined)
            url_ += "Quantity=" + encodeURIComponent("" + quantity) + "&";
        if (discount !== undefined)
            url_ += "Discount=" + encodeURIComponent("" + discount) + "&";
        if (price !== undefined)
            url_ += "Price=" + encodeURIComponent("" + price) + "&";
        if (vAT !== undefined)
            url_ += "VAT=" + encodeURIComponent("" + vAT) + "&";
        if (lineTotal !== undefined)
            url_ += "LineTotal=" + encodeURIComponent("" + lineTotal) + "&";
        if (discount_Desc !== undefined)
            url_ += "Discount_Desc=" + encodeURIComponent("" + discount_Desc) + "&";
        if (desc !== undefined)
            url_ += "Desc=" + encodeURIComponent("" + desc) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetSaleOrderDetailForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetSaleOrderDetailForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetSaleOrderDetailForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetSaleOrderDetailForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetSaleOrderDetailForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetSaleOrderDetailForViewDto>(<any>null);
    }
}

@Injectable()
export class SalesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createSaleDisTransaction(input: CreateOrEditSaleInput | null | undefined): Observable<ResponseDtoOfBoolean> {
        let url_ = this.baseUrl + "/api/services/app/Sales/CreateSaleDisTransaction";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateSaleDisTransaction(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateSaleDisTransaction(<any>response_);
                } catch (e) {
                    return <Observable<ResponseDtoOfBoolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResponseDtoOfBoolean>><any>_observableThrow(response_);
        }));
    }

    protected processCreateSaleDisTransaction(response: HttpResponseBase): Observable<ResponseDtoOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? ResponseDtoOfBoolean.fromJS(resultData200) : new ResponseDtoOfBoolean();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseDtoOfBoolean>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createSaleInTransaction(input: CreateOrEditSaleInput | null | undefined): Observable<ResponseDtoOfBoolean> {
        let url_ = this.baseUrl + "/api/services/app/Sales/CreateSaleInTransaction";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateSaleInTransaction(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateSaleInTransaction(<any>response_);
                } catch (e) {
                    return <Observable<ResponseDtoOfBoolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResponseDtoOfBoolean>><any>_observableThrow(response_);
        }));
    }

    protected processCreateSaleInTransaction(response: HttpResponseBase): Observable<ResponseDtoOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? ResponseDtoOfBoolean.fromJS(resultData200) : new ResponseDtoOfBoolean();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseDtoOfBoolean>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createSaleOutTransaction(input: CreateOrEditSaleInput | null | undefined): Observable<ResponseDtoOfBoolean> {
        let url_ = this.baseUrl + "/api/services/app/Sales/CreateSaleOutTransaction";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateSaleOutTransaction(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateSaleOutTransaction(<any>response_);
                } catch (e) {
                    return <Observable<ResponseDtoOfBoolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResponseDtoOfBoolean>><any>_observableThrow(response_);
        }));
    }

    protected processCreateSaleOutTransaction(response: HttpResponseBase): Observable<ResponseDtoOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? ResponseDtoOfBoolean.fromJS(resultData200) : new ResponseDtoOfBoolean();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseDtoOfBoolean>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createSaleVipShopTransaction(input: CreateOrEditSaleInput | null | undefined): Observable<ResponseDtoOfBoolean> {
        let url_ = this.baseUrl + "/api/services/app/Sales/CreateSaleVipShopTransaction";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateSaleVipShopTransaction(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateSaleVipShopTransaction(<any>response_);
                } catch (e) {
                    return <Observable<ResponseDtoOfBoolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResponseDtoOfBoolean>><any>_observableThrow(response_);
        }));
    }

    protected processCreateSaleVipShopTransaction(response: HttpResponseBase): Observable<ResponseDtoOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? ResponseDtoOfBoolean.fromJS(resultData200) : new ResponseDtoOfBoolean();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseDtoOfBoolean>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditSaleInput | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Sales/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEditExt(input: CreateOrEditSaleInput | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Sales/CreateOrEditExt";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEditExt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditExt(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEditExt(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Sales/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param memberCode (optional) 
     * @param referenceId (optional) 
     * @param serial (optional) 
     * @param saleType (optional) 
     * @param status (optional) 
     * @param description (optional) 
     * @param source (optional) 
     * @param systemPoint (optional) 
     * @param systemCoin (optional) 
     * @param address (optional) 
     * @param activationCode (optional) 
     * @param phoneNumber (optional) 
     * @param customerName (optional) 
     * @param province (optional) 
     * @param district (optional) 
     * @param ward (optional) 
     * @param paymentStatus (optional) 
     * @param paymentDate (optional) 
     * @param reason (optional) 
     * @param productCode (optional) 
     * @param deptCode (optional) 
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, memberCode: string | null | undefined,
        referenceId: string | null | undefined, serial: string | null | undefined,
        saleType: string | null | undefined, status: string | null | undefined,
        description: string | null | undefined, source: string | null | undefined,
        systemPoint: number | null | undefined, systemCoin: number | null | undefined,
        address: string | null | undefined, activationCode: string | null | undefined,
        phoneNumber: string | null | undefined, customerName: string | null | undefined,
        province: string | null | undefined, district: string | null | undefined,
        ward: string | null | undefined, paymentStatus: number | null | undefined,
        paymentDate: moment.Moment | null | undefined, reason: string | null | undefined,
        productCode: string | null | undefined, deptCode: string | null | undefined,
        fromDate: moment.Moment | null | undefined, toDate: moment.Moment | null | undefined,
        sorting: string | null | undefined, skipCount: number | null | undefined,
        maxResultCount: number | null | undefined, saleTypes: string | null | undefined = undefined, brand: string | null | undefined = undefined): Observable<TupleOfPagedResultDtoOfGetSaleForViewDtoAndTotalDashboard> {
        let url_ = this.baseUrl + "/api/services/app/Sales/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (memberCode !== undefined)
            url_ += "MemberCode=" + encodeURIComponent("" + memberCode) + "&";
        if (referenceId !== undefined)
            url_ += "ReferenceId=" + encodeURIComponent("" + referenceId) + "&";
        if (serial !== undefined)
            url_ += "Serial=" + encodeURIComponent("" + serial) + "&";
        if (saleType !== undefined)
            url_ += "SaleType=" + encodeURIComponent("" + saleType) + "&";
        if (saleTypes !== undefined)
            url_ += "SaleTypes=" + encodeURIComponent("" + saleTypes) + "&"
        if (status !== undefined)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (description !== undefined)
            url_ += "Description=" + encodeURIComponent("" + description) + "&";
        if (source !== undefined)
            url_ += "Source=" + encodeURIComponent("" + source) + "&";
        if (systemPoint !== undefined)
            url_ += "SystemPoint=" + encodeURIComponent("" + systemPoint) + "&";
        if (systemCoin !== undefined)
            url_ += "SystemCoin=" + encodeURIComponent("" + systemCoin) + "&";
        if (address !== undefined)
            url_ += "Address=" + encodeURIComponent("" + address) + "&";
        if (activationCode !== undefined)
            url_ += "ActivationCode=" + encodeURIComponent("" + activationCode) + "&";
        if (phoneNumber !== undefined)
            url_ += "PhoneNumber=" + encodeURIComponent("" + phoneNumber) + "&";
        if (customerName !== undefined)
            url_ += "CustomerName=" + encodeURIComponent("" + customerName) + "&";
        if (province !== undefined)
            url_ += "Province=" + encodeURIComponent("" + province) + "&";
        if (district !== undefined)
            url_ += "District=" + encodeURIComponent("" + district) + "&";
        if (ward !== undefined)
            url_ += "Ward=" + encodeURIComponent("" + ward) + "&";
        if (paymentStatus !== undefined)
            url_ += "PaymentStatus=" + encodeURIComponent("" + paymentStatus) + "&";
        if (paymentDate !== undefined)
            url_ += "PaymentDate=" + encodeURIComponent(paymentDate ? "" + paymentDate.toJSON() : "") + "&";
        if (reason !== undefined)
            url_ += "Reason=" + encodeURIComponent("" + reason) + "&";
        if (productCode !== undefined)
            url_ += "ProductCode=" + encodeURIComponent("" + productCode) + "&";
        if (brand !== undefined)
            url_ += "Brand=" + encodeURIComponent("" + brand) + "&";
        if (deptCode !== undefined)
            url_ += "DeptCode=" + encodeURIComponent("" + deptCode) + "&";
        if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toJSON() : "") + "&";
        if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toJSON() : "") + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<TupleOfPagedResultDtoOfGetSaleForViewDtoAndTotalDashboard>><any>_observableThrow(e);
                }
            } else
                return <Observable<TupleOfPagedResultDtoOfGetSaleForViewDtoAndTotalDashboard>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<TupleOfPagedResultDtoOfGetSaleForViewDtoAndTotalDashboard> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? TupleOfPagedResultDtoOfGetSaleForViewDtoAndTotalDashboard.fromJS(resultData200) : new TupleOfPagedResultDtoOfGetSaleForViewDtoAndTotalDashboard();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TupleOfPagedResultDtoOfGetSaleForViewDtoAndTotalDashboard>(<any>null);
    }

    /**
     * @param id (optional) 
     * @param serial (optional) 
     * @param deptCode (optional) 
     * @param model (optional) 
     * @param memberCode (optional) 
     * @param saleType (optional) 
     * @param paymentStatus (optional) 
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    searchReportStatusPayment(id: number | null | undefined, serial: string | null | undefined, deptCode: string | null | undefined, model: string | null | undefined, memberCode: string | null | undefined, saleType: string | null | undefined, paymentStatus: number | null | undefined, fromDate: moment.Moment | null | undefined, toDate: moment.Moment | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetPaymentStatusForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Sales/SearchReportStatusPayment?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (serial !== undefined)
            url_ += "Serial=" + encodeURIComponent("" + serial) + "&";
        if (deptCode !== undefined)
            url_ += "DeptCode=" + encodeURIComponent("" + deptCode) + "&";
        if (model !== undefined)
            url_ += "Model=" + encodeURIComponent("" + model) + "&";
        if (memberCode !== undefined)
            url_ += "MemberCode=" + encodeURIComponent("" + memberCode) + "&";
        if (saleType !== undefined)
            url_ += "SaleType=" + encodeURIComponent("" + saleType) + "&";
        if (paymentStatus !== undefined)
            url_ += "PaymentStatus=" + encodeURIComponent("" + paymentStatus) + "&";
        if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toJSON() : "") + "&";
        if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toJSON() : "") + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSearchReportStatusPayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchReportStatusPayment(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetPaymentStatusForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetPaymentStatusForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processSearchReportStatusPayment(response: HttpResponseBase): Observable<PagedResultDtoOfGetPaymentStatusForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetPaymentStatusForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetPaymentStatusForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetPaymentStatusForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @param serial (optional) 
     * @param deptCode (optional) 
     * @param model (optional) 
     * @param memberCode (optional) 
     * @param saleType (optional) 
     * @param paymentStatus (optional) 
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getFileExcelReportStatusPayment(id: number | null | undefined, serial: string | null | undefined, deptCode: string | null | undefined, model: string | null | undefined, memberCode: string | null | undefined, saleType: string | null | undefined, paymentStatus: number | null | undefined, fromDate: moment.Moment | null | undefined, toDate: moment.Moment | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<SocialRetailerFileDto> {
        let url_ = this.baseUrl + "/api/services/app/Sales/GetFileExcelReportStatusPayment?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (serial !== undefined)
            url_ += "Serial=" + encodeURIComponent("" + serial) + "&";
        if (deptCode !== undefined)
            url_ += "DeptCode=" + encodeURIComponent("" + deptCode) + "&";
        if (model !== undefined)
            url_ += "Model=" + encodeURIComponent("" + model) + "&";
        if (memberCode !== undefined)
            url_ += "MemberCode=" + encodeURIComponent("" + memberCode) + "&";
        if (saleType !== undefined)
            url_ += "SaleType=" + encodeURIComponent("" + saleType) + "&";
        if (paymentStatus !== undefined)
            url_ += "PaymentStatus=" + encodeURIComponent("" + paymentStatus) + "&";
        if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toJSON() : "") + "&";
        if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toJSON() : "") + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetFileExcelReportStatusPayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFileExcelReportStatusPayment(<any>response_);
                } catch (e) {
                    return <Observable<SocialRetailerFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SocialRetailerFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetFileExcelReportStatusPayment(response: HttpResponseBase): Observable<SocialRetailerFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? SocialRetailerFileDto.fromJS(resultData200) : new SocialRetailerFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SocialRetailerFileDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getById(id: number | null | undefined): Observable<GetSaleForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Sales/GetById?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(<any>response_);
                } catch (e) {
                    return <Observable<GetSaleForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetSaleForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<GetSaleForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetSaleForViewDto.fromJS(resultData200) : new GetSaleForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSaleForViewDto>(<any>null);
    }

    /**
     * @param referenceId (optional) 
     * @param salemanCode (optional) 
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param memberCode (optional) 
     * @param serial (optional) 
     * @param model (optional) 
     * @param vehicleNumber (optional) 
     * @param saleType (optional) 
     * @param serialType (optional) 
     * @param isDistributorTemp (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    exportExcelSellOutDistributor(referenceId: string | null | undefined, salemanCode: string | null | undefined, fromDate: moment.Moment | null | undefined, toDate: moment.Moment | null | undefined, memberCode: string | null | undefined, serial: string | null | undefined, model: string | null | undefined, vehicleNumber: string | null | undefined, saleType: string | null | undefined, serialType: string | null | undefined, isDistributorTemp: boolean | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Sales/ExportExcelSellOutDistributor?";
        if (referenceId !== undefined)
            url_ += "ReferenceId=" + encodeURIComponent("" + referenceId) + "&";
        if (salemanCode !== undefined)
            url_ += "SalemanCode=" + encodeURIComponent("" + salemanCode) + "&";
        if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toJSON() : "") + "&";
        if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toJSON() : "") + "&";
        if (memberCode !== undefined)
            url_ += "MemberCode=" + encodeURIComponent("" + memberCode) + "&";
        if (serial !== undefined)
            url_ += "Serial=" + encodeURIComponent("" + serial) + "&";
        if (model !== undefined)
            url_ += "Model=" + encodeURIComponent("" + model) + "&";
        if (vehicleNumber !== undefined)
            url_ += "VehicleNumber=" + encodeURIComponent("" + vehicleNumber) + "&";
        if (saleType !== undefined)
            url_ += "SaleType=" + encodeURIComponent("" + saleType) + "&";
        if (serialType !== undefined)
            url_ += "SerialType=" + encodeURIComponent("" + serialType) + "&";
        if (isDistributorTemp !== undefined)
            url_ += "IsDistributorTemp=" + encodeURIComponent("" + isDistributorTemp) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processExportExcelSellOutDistributor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportExcelSellOutDistributor(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processExportExcelSellOutDistributor(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    isDistributorRole(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Sales/IsDistributorRole";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processIsDistributorRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsDistributorRole(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processIsDistributorRole(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    getAllSellOutDistributor(input: GetSellOutDistributorInput | null | undefined): Observable<PagedResultDtoOfGetSellOutDistributorForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Sales/GetAllSellOutDistributor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllSellOutDistributor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSellOutDistributor(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetSellOutDistributorForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetSellOutDistributorForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllSellOutDistributor(response: HttpResponseBase): Observable<PagedResultDtoOfGetSellOutDistributorForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetSellOutDistributorForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetSellOutDistributorForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetSellOutDistributorForViewDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    checkSerial(input: CheckSerialRequest | null | undefined): Observable<CheckSerialResponse> {
        let url_ = this.baseUrl + "/api/services/app/Sales/CheckSerial";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCheckSerial(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckSerial(<any>response_);
                } catch (e) {
                    return <Observable<CheckSerialResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<CheckSerialResponse>><any>_observableThrow(response_);
        }));
    }

    protected processCheckSerial(response: HttpResponseBase): Observable<CheckSerialResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? CheckSerialResponse.fromJS(resultData200) : new CheckSerialResponse();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CheckSerialResponse>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    insertSaleHistory(input: CheckSerialRequest | null | undefined): Observable<CheckSerialResponse> {
        let url_ = this.baseUrl + "/api/services/app/Sales/InsertSaleHistory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processInsertSaleHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInsertSaleHistory(<any>response_);
                } catch (e) {
                    return <Observable<CheckSerialResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<CheckSerialResponse>><any>_observableThrow(response_);
        }));
    }

    protected processInsertSaleHistory(response: HttpResponseBase): Observable<CheckSerialResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? CheckSerialResponse.fromJS(resultData200) : new CheckSerialResponse();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CheckSerialResponse>(<any>null);
    }

    /**
     * @param serial (optional) 
     * @param modelCode (optional) 
     * @return Success
     */
    insertSerialNotInSystem(serial: string | null | undefined, modelCode: string | null | undefined): Observable<CheckSerialResponse> {
        let url_ = this.baseUrl + "/api/services/app/Sales/InsertSerialNotInSystem?";
        if (serial !== undefined)
            url_ += "serial=" + encodeURIComponent("" + serial) + "&";
        if (modelCode !== undefined)
            url_ += "modelCode=" + encodeURIComponent("" + modelCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processInsertSerialNotInSystem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInsertSerialNotInSystem(<any>response_);
                } catch (e) {
                    return <Observable<CheckSerialResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<CheckSerialResponse>><any>_observableThrow(response_);
        }));
    }

    protected processInsertSerialNotInSystem(response: HttpResponseBase): Observable<CheckSerialResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? CheckSerialResponse.fromJS(resultData200) : new CheckSerialResponse();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CheckSerialResponse>(<any>null);
    }

    /**
     * @param lst_input (optional) 
     * @return Success
     */
    insertSerialAll(lst_input: ScanSerialRequestDto[] | null | undefined): Observable<StatusImportDistributeDto> {
        let url_ = this.baseUrl + "/api/services/app/Sales/InsertSerialAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(lst_input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processInsertSerialAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInsertSerialAll(<any>response_);
                } catch (e) {
                    return <Observable<StatusImportDistributeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<StatusImportDistributeDto>><any>_observableThrow(response_);
        }));
    }

    protected processInsertSerialAll(response: HttpResponseBase): Observable<StatusImportDistributeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? StatusImportDistributeDto.fromJS(resultData200) : new StatusImportDistributeDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StatusImportDistributeDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    updateDONumber(input: UpdateDONumberRequest | null | undefined): Observable<UpdateDONumberResponse> {
        let url_ = this.baseUrl + "/api/services/app/Sales/UpdateDONumber";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateDONumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDONumber(<any>response_);
                } catch (e) {
                    return <Observable<UpdateDONumberResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<UpdateDONumberResponse>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateDONumber(response: HttpResponseBase): Observable<UpdateDONumberResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? UpdateDONumberResponse.fromJS(resultData200) : new UpdateDONumberResponse();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateDONumberResponse>(<any>null);
    }

    /**
     * @param serial (optional) 
     * @param reason (optional) 
     * @param id (optional) 
     * @return Success
     */
    removeSerial(serial: string | null | undefined, reason: string | null | undefined, id: number | null | undefined): Observable<RemoveSerialResponse> {
        let url_ = this.baseUrl + "/api/services/app/Sales/RemoveSerial?";
        if (serial !== undefined)
            url_ += "serial=" + encodeURIComponent("" + serial) + "&";
        if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processRemoveSerial(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveSerial(<any>response_);
                } catch (e) {
                    return <Observable<RemoveSerialResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<RemoveSerialResponse>><any>_observableThrow(response_);
        }));
    }

    protected processRemoveSerial(response: HttpResponseBase): Observable<RemoveSerialResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? RemoveSerialResponse.fromJS(resultData200) : new RemoveSerialResponse();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RemoveSerialResponse>(<any>null);
    }

    /**
     * @param serial (optional) 
     * @return Success
     */
    removeSerialNotInSystem(serial: string | null | undefined): Observable<RemoveSerialResponse> {
        let url_ = this.baseUrl + "/api/services/app/Sales/RemoveSerialNotInSystem?";
        if (serial !== undefined)
            url_ += "serial=" + encodeURIComponent("" + serial) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processRemoveSerialNotInSystem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveSerialNotInSystem(<any>response_);
                } catch (e) {
                    return <Observable<RemoveSerialResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<RemoveSerialResponse>><any>_observableThrow(response_);
        }));
    }

    protected processRemoveSerialNotInSystem(response: HttpResponseBase): Observable<RemoveSerialResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? RemoveSerialResponse.fromJS(resultData200) : new RemoveSerialResponse();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RemoveSerialResponse>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    returnOrExchangeSerial(input: ReturnSerialRequest | null | undefined): Observable<ReturnSerialResponse> {
        let url_ = this.baseUrl + "/api/services/app/Sales/ReturnOrExchangeSerial";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processReturnOrExchangeSerial(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReturnOrExchangeSerial(<any>response_);
                } catch (e) {
                    return <Observable<ReturnSerialResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<ReturnSerialResponse>><any>_observableThrow(response_);
        }));
    }

    protected processReturnOrExchangeSerial(response: HttpResponseBase): Observable<ReturnSerialResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? ReturnSerialResponse.fromJS(resultData200) : new ReturnSerialResponse();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReturnSerialResponse>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param memberCode (optional) 
     * @param referenceId (optional) 
     * @param serial (optional) 
     * @param saleType (optional) 
     * @param status (optional) 
     * @param description (optional) 
     * @param source (optional) 
     * @param systemPoint (optional) 
     * @param systemCoin (optional) 
     * @param address (optional) 
     * @param activationCode (optional) 
     * @param phoneNumber (optional) 
     * @param customerName (optional) 
     * @param province (optional) 
     * @param district (optional) 
     * @param ward (optional) 
     * @param paymentStatus (optional) 
     * @param paymentDate (optional) 
     * @param reason (optional) 
     * @param productCode (optional) 
     * @param deptCode (optional) 
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getFileExcel(filter: string | null | undefined, memberCode: string | null | undefined, referenceId: string | null | undefined,
        serial: string | null | undefined, saleType: string | null | undefined, status: string | null | undefined, description: string | null | undefined,
        source: string | null | undefined, systemPoint: number | null | undefined, systemCoin: number | null | undefined, address: string | null | undefined,
        activationCode: string | null | undefined, phoneNumber: string | null | undefined, customerName: string | null | undefined, province: string | null | undefined,
        district: string | null | undefined, ward: string | null | undefined, paymentStatus: number | null | undefined, paymentDate: moment.Moment | null | undefined,
        reason: string | null | undefined, productCode: string | null | undefined, deptCode: string | null | undefined, fromDate: moment.Moment | null | undefined,
        toDate: moment.Moment | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined,
        maxResultCount: number | null | undefined, saleTypes: string | null | undefined = undefined, brand: string | null | undefined = undefined): Observable<SocialRetailerFileDto> {
        let url_ = this.baseUrl + "/api/services/app/Sales/GetFileExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (memberCode !== undefined)
            url_ += "MemberCode=" + encodeURIComponent("" + memberCode) + "&";
        if (referenceId !== undefined)
            url_ += "ReferenceId=" + encodeURIComponent("" + referenceId) + "&";
        if (serial !== undefined)
            url_ += "Serial=" + encodeURIComponent("" + serial) + "&";
        if (saleType !== undefined)
            url_ += "SaleType=" + encodeURIComponent("" + saleType) + "&";
        if (saleTypes !== undefined)
            url_ += "SaleTypes=" + encodeURIComponent("" + saleTypes) + "&";
        if (status !== undefined)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (description !== undefined)
            url_ += "Description=" + encodeURIComponent("" + description) + "&";
        if (source !== undefined)
            url_ += "Source=" + encodeURIComponent("" + source) + "&";
        if (systemPoint !== undefined)
            url_ += "SystemPoint=" + encodeURIComponent("" + systemPoint) + "&";
        if (systemCoin !== undefined)
            url_ += "SystemCoin=" + encodeURIComponent("" + systemCoin) + "&";
        if (address !== undefined)
            url_ += "Address=" + encodeURIComponent("" + address) + "&";
        if (activationCode !== undefined)
            url_ += "ActivationCode=" + encodeURIComponent("" + activationCode) + "&";
        if (phoneNumber !== undefined)
            url_ += "PhoneNumber=" + encodeURIComponent("" + phoneNumber) + "&";
        if (customerName !== undefined)
            url_ += "CustomerName=" + encodeURIComponent("" + customerName) + "&";
        if (province !== undefined)
            url_ += "Province=" + encodeURIComponent("" + province) + "&";
        if (district !== undefined)
            url_ += "District=" + encodeURIComponent("" + district) + "&";
        if (ward !== undefined)
            url_ += "Ward=" + encodeURIComponent("" + ward) + "&";
        if (paymentStatus !== undefined)
            url_ += "PaymentStatus=" + encodeURIComponent("" + paymentStatus) + "&";
        if (paymentDate !== undefined)
            url_ += "PaymentDate=" + encodeURIComponent(paymentDate ? "" + paymentDate.toJSON() : "") + "&";
        if (reason !== undefined)
            url_ += "Reason=" + encodeURIComponent("" + reason) + "&";
        if (productCode !== undefined)
            url_ += "ProductCode=" + encodeURIComponent("" + productCode) + "&";
        if (brand !== undefined)
            url_ += "Brand=" + encodeURIComponent("" + brand) + "&";
        if (deptCode !== undefined)
            url_ += "DeptCode=" + encodeURIComponent("" + deptCode) + "&";
        if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toJSON() : "") + "&";
        if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toJSON() : "") + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetFileExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFileExcel(<any>response_);
                } catch (e) {
                    return <Observable<SocialRetailerFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SocialRetailerFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetFileExcel(response: HttpResponseBase): Observable<SocialRetailerFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? SocialRetailerFileDto.fromJS(resultData200) : new SocialRetailerFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SocialRetailerFileDto>(<any>null);
    }

    /**
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @return Success
     */
    getFileExcelSAPSync(fromDate: moment.Moment | null | undefined, toDate: moment.Moment | null | undefined): Observable<SocialRetailerFileDto> {
        let url_ = this.baseUrl + "/api/services/app/Sales/GetFileExcelSAPSync?";
        if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toJSON() : "") + "&";
        if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent(toDate ? "" + toDate.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetFileExcelSAPSync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFileExcelSAPSync(<any>response_);
                } catch (e) {
                    return <Observable<SocialRetailerFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SocialRetailerFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetFileExcelSAPSync(response: HttpResponseBase): Observable<SocialRetailerFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? SocialRetailerFileDto.fromJS(resultData200) : new SocialRetailerFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SocialRetailerFileDto>(<any>null);
    }

    /**
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @return Success
     */
    getFileExcelSummaryProduct(fromDate: moment.Moment | null | undefined, toDate: moment.Moment | null | undefined): Observable<SocialRetailerFileDto> {
        let url_ = this.baseUrl + "/api/services/app/Sales/GetFileExcelSummaryProduct?";
        if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toJSON() : "") + "&";
        if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent(toDate ? "" + toDate.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetFileExcelSummaryProduct(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFileExcelSummaryProduct(<any>response_);
                } catch (e) {
                    return <Observable<SocialRetailerFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SocialRetailerFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetFileExcelSummaryProduct(response: HttpResponseBase): Observable<SocialRetailerFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? SocialRetailerFileDto.fromJS(resultData200) : new SocialRetailerFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SocialRetailerFileDto>(<any>null);
    }

    /**
     * @param referenceId (optional) 
     * @param salemanCode (optional) 
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param memberCode (optional) 
     * @param serial (optional) 
     * @param model (optional) 
     * @param vehicleNumber (optional) 
     * @param saleType (optional) 
     * @param serialType (optional) 
     * @param isDistributorTemp (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getFileExcelSummarySerial(referenceId: string | null | undefined, salemanCode: string | null | undefined, fromDate: moment.Moment | null | undefined, toDate: moment.Moment | null | undefined, memberCode: string | null | undefined, serial: string | null | undefined, model: string | null | undefined, vehicleNumber: string | null | undefined, saleType: string | null | undefined, serialType: string | null | undefined, isDistributorTemp: boolean | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<SocialRetailerFileDto> {
        let url_ = this.baseUrl + "/api/services/app/Sales/GetFileExcelSummarySerial?";
        if (referenceId !== undefined)
            url_ += "ReferenceId=" + encodeURIComponent("" + referenceId) + "&";
        if (salemanCode !== undefined)
            url_ += "SalemanCode=" + encodeURIComponent("" + salemanCode) + "&";
        if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toJSON() : "") + "&";
        if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toJSON() : "") + "&";
        if (memberCode !== undefined)
            url_ += "MemberCode=" + encodeURIComponent("" + memberCode) + "&";
        if (serial !== undefined)
            url_ += "Serial=" + encodeURIComponent("" + serial) + "&";
        if (model !== undefined)
            url_ += "Model=" + encodeURIComponent("" + model) + "&";
        if (vehicleNumber !== undefined)
            url_ += "VehicleNumber=" + encodeURIComponent("" + vehicleNumber) + "&";
        if (saleType !== undefined)
            url_ += "SaleType=" + encodeURIComponent("" + saleType) + "&";
        if (serialType !== undefined)
            url_ += "SerialType=" + encodeURIComponent("" + serialType) + "&";
        if (isDistributorTemp !== undefined)
            url_ += "IsDistributorTemp=" + encodeURIComponent("" + isDistributorTemp) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetFileExcelSummarySerial(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFileExcelSummarySerial(<any>response_);
                } catch (e) {
                    return <Observable<SocialRetailerFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SocialRetailerFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetFileExcelSummarySerial(response: HttpResponseBase): Observable<SocialRetailerFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? SocialRetailerFileDto.fromJS(resultData200) : new SocialRetailerFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SocialRetailerFileDto>(<any>null);
    }

    /**
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @return Success
     */
    getFileExcelSerialInput(fromDate: moment.Moment | null | undefined, toDate: moment.Moment | null | undefined): Observable<SocialRetailerFileDto> {
        let url_ = this.baseUrl + "/api/services/app/Sales/GetFileExcelSerialInput?";
        if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toJSON() : "") + "&";
        if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent(toDate ? "" + toDate.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetFileExcelSerialInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFileExcelSerialInput(<any>response_);
                } catch (e) {
                    return <Observable<SocialRetailerFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SocialRetailerFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetFileExcelSerialInput(response: HttpResponseBase): Observable<SocialRetailerFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? SocialRetailerFileDto.fromJS(resultData200) : new SocialRetailerFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SocialRetailerFileDto>(<any>null);
    }

    /**
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @return Success
     */
    getFileExcelSerialInputDetail(fromDate: moment.Moment | null | undefined, toDate: moment.Moment | null | undefined): Observable<SocialRetailerFileDto> {
        let url_ = this.baseUrl + "/api/services/app/Sales/GetFileExcelSerialInputDetail?";
        if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toJSON() : "") + "&";
        if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent(toDate ? "" + toDate.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetFileExcelSerialInputDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFileExcelSerialInputDetail(<any>response_);
                } catch (e) {
                    return <Observable<SocialRetailerFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SocialRetailerFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetFileExcelSerialInputDetail(response: HttpResponseBase): Observable<SocialRetailerFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? SocialRetailerFileDto.fromJS(resultData200) : new SocialRetailerFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SocialRetailerFileDto>(<any>null);
    }

    /**
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @return Success
     */
    getFileExcelHistory(fromDate: moment.Moment | null | undefined, toDate: moment.Moment | null | undefined): Observable<SocialRetailerFileDto> {
        let url_ = this.baseUrl + "/api/services/app/Sales/GetFileExcelHistory?";
        if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toJSON() : "") + "&";
        if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent(toDate ? "" + toDate.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetFileExcelHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFileExcelHistory(<any>response_);
                } catch (e) {
                    return <Observable<SocialRetailerFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SocialRetailerFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetFileExcelHistory(response: HttpResponseBase): Observable<SocialRetailerFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? SocialRetailerFileDto.fromJS(resultData200) : new SocialRetailerFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SocialRetailerFileDto>(<any>null);
    }

    /**
     * @param phoneNumber (optional) 
     * @return Success
     */
    getByPhoneNumber(phoneNumber: string | null | undefined): Observable<GetSaleForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Sales/GetByPhoneNumber?";
        if (phoneNumber !== undefined)
            url_ += "phoneNumber=" + encodeURIComponent("" + phoneNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetByPhoneNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByPhoneNumber(<any>response_);
                } catch (e) {
                    return <Observable<GetSaleForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetSaleForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetByPhoneNumber(response: HttpResponseBase): Observable<GetSaleForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetSaleForViewDto.fromJS(resultData200) : new GetSaleForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSaleForViewDto>(<any>null);
    }

    /**
     * @param arg (optional) 
     * @return Success
     */
    importQueueDistribute(arg: CommonImportAgrs | null | undefined): Observable<StatusImportDistributeDto> {
        let url_ = this.baseUrl + "/api/services/app/Sales/ImportQueueDistribute";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(arg);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processImportQueueDistribute(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportQueueDistribute(<any>response_);
                } catch (e) {
                    return <Observable<StatusImportDistributeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<StatusImportDistributeDto>><any>_observableThrow(response_);
        }));
    }

    protected processImportQueueDistribute(response: HttpResponseBase): Observable<StatusImportDistributeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? StatusImportDistributeDto.fromJS(resultData200) : new StatusImportDistributeDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StatusImportDistributeDto>(<any>null);
    }

    /**
     * @param arg (optional) 
     * @return Success
     */
    importQueueDistributeReturn(arg: CommonImportAgrs | null | undefined): Observable<StatusImportDistributeDto> {
        let url_ = this.baseUrl + "/api/services/app/Sales/ImportQueueDistributeReturn";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(arg);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processImportQueueDistributeReturn(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportQueueDistributeReturn(<any>response_);
                } catch (e) {
                    return <Observable<StatusImportDistributeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<StatusImportDistributeDto>><any>_observableThrow(response_);
        }));
    }

    protected processImportQueueDistributeReturn(response: HttpResponseBase): Observable<StatusImportDistributeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? StatusImportDistributeDto.fromJS(resultData200) : new StatusImportDistributeDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StatusImportDistributeDto>(<any>null);
    }

    /**
     * @param arg (optional) 
     * @return Success
     */
    importQueueSellIn(arg: CommonImportAgrs | null | undefined): Observable<StatusImportDistributeDto> {
        let url_ = this.baseUrl + "/api/services/app/Sales/ImportQueueSellIn";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(arg);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processImportQueueSellIn(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportQueueSellIn(<any>response_);
                } catch (e) {
                    return <Observable<StatusImportDistributeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<StatusImportDistributeDto>><any>_observableThrow(response_);
        }));
    }

    protected processImportQueueSellIn(response: HttpResponseBase): Observable<StatusImportDistributeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? StatusImportDistributeDto.fromJS(resultData200) : new StatusImportDistributeDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StatusImportDistributeDto>(<any>null);
    }

    /**
     * @param arg (optional) 
     * @return Success
     */
    importQueueSellThru(arg: CommonImportAgrs | null | undefined): Observable<StatusImportDistributeDto> {
        let url_ = this.baseUrl + "/api/services/app/Sales/ImportQueueSellThru";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(arg);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processImportQueueSellThru(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportQueueSellThru(<any>response_);
                } catch (e) {
                    return <Observable<StatusImportDistributeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<StatusImportDistributeDto>><any>_observableThrow(response_);
        }));
    }

    protected processImportQueueSellThru(response: HttpResponseBase): Observable<StatusImportDistributeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? StatusImportDistributeDto.fromJS(resultData200) : new StatusImportDistributeDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StatusImportDistributeDto>(<any>null);
    }

    /**
     * @param arg (optional) 
     * @return Success
     */
    importQueueSellVipShop(arg: CommonImportAgrs | null | undefined): Observable<StatusImportDistributeDto> {
        let url_ = this.baseUrl + "/api/services/app/Sales/ImportQueueSellVipShop";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(arg);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processImportQueueSellVipShop(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportQueueSellVipShop(<any>response_);
                } catch (e) {
                    return <Observable<StatusImportDistributeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<StatusImportDistributeDto>><any>_observableThrow(response_);
        }));
    }

    protected processImportQueueSellVipShop(response: HttpResponseBase): Observable<StatusImportDistributeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? StatusImportDistributeDto.fromJS(resultData200) : new StatusImportDistributeDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StatusImportDistributeDto>(<any>null);
    }

    /**
     * @param arg (optional) 
     * @return Success
     */
    importQueue(arg: CommonImportAgrs | null | undefined): Observable<StatusImportDistributeDto> {
        let url_ = this.baseUrl + "/api/services/app/Sales/ImportQueue";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(arg);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processImportQueue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportQueue(<any>response_);
                } catch (e) {
                    return <Observable<StatusImportDistributeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<StatusImportDistributeDto>><any>_observableThrow(response_);
        }));
    }

    protected processImportQueue(response: HttpResponseBase): Observable<StatusImportDistributeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? StatusImportDistributeDto.fromJS(resultData200) : new StatusImportDistributeDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StatusImportDistributeDto>(<any>null);
    }

    /**
     * @param arg (optional) 
     * @return Success
     */
    importQueuePayment(arg: CommonImportAgrs | null | undefined): Observable<StatusImportDistributeDto> {
        let url_ = this.baseUrl + "/api/services/app/Sales/ImportQueuePayment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(arg);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processImportQueuePayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportQueuePayment(<any>response_);
                } catch (e) {
                    return <Observable<StatusImportDistributeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<StatusImportDistributeDto>><any>_observableThrow(response_);
        }));
    }

    protected processImportQueuePayment(response: HttpResponseBase): Observable<StatusImportDistributeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? StatusImportDistributeDto.fromJS(resultData200) : new StatusImportDistributeDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StatusImportDistributeDto>(<any>null);
    }

    /**
     * @return Success
     */
    checkValidImport(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Sales/CheckValidImport";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCheckValidImport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckValidImport(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processCheckValidImport(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @return Success
     */
    checkStatusImport(): Observable<StatusImportDistributeDto> {
        let url_ = this.baseUrl + "/api/services/app/Sales/CheckStatusImport";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCheckStatusImport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckStatusImport(<any>response_);
                } catch (e) {
                    return <Observable<StatusImportDistributeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<StatusImportDistributeDto>><any>_observableThrow(response_);
        }));
    }

    protected processCheckStatusImport(response: HttpResponseBase): Observable<StatusImportDistributeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? StatusImportDistributeDto.fromJS(resultData200) : new StatusImportDistributeDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StatusImportDistributeDto>(<any>null);
    }

    /**
     * @param memberCode (optional) 
     * @return Success
     */
    getNotificationInfoByMember(memberCode: string | null | undefined): Observable<UserNotificationInfoDTO> {
        let url_ = this.baseUrl + "/api/services/app/Sales/GetNotificationInfoByMember?";
        if (memberCode !== undefined)
            url_ += "memberCode=" + encodeURIComponent("" + memberCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetNotificationInfoByMember(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNotificationInfoByMember(<any>response_);
                } catch (e) {
                    return <Observable<UserNotificationInfoDTO>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserNotificationInfoDTO>><any>_observableThrow(response_);
        }));
    }

    protected processGetNotificationInfoByMember(response: HttpResponseBase): Observable<UserNotificationInfoDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? UserNotificationInfoDTO.fromJS(resultData200) : new UserNotificationInfoDTO();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserNotificationInfoDTO>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    checkedWarrSerialUrl(input: SalesUpdateWarrSerialDTO[] | null | undefined): Observable<ResponseDtoOfBoolean> {
        let url_ = this.baseUrl + "/api/services/app/Sales/CheckedWarrSerialUrl";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCheckedWarrSerialUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckedWarrSerialUrl(<any>response_);
                } catch (e) {
                    return <Observable<ResponseDtoOfBoolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResponseDtoOfBoolean>><any>_observableThrow(response_);
        }));
    }

    protected processCheckedWarrSerialUrl(response: HttpResponseBase): Observable<ResponseDtoOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? ResponseDtoOfBoolean.fromJS(resultData200) : new ResponseDtoOfBoolean();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseDtoOfBoolean>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    updateSerialByWarr(input: SalesUpdateWarrSerialDTO[] | null | undefined): Observable<ResponseDtoOfBoolean> {
        let url_ = this.baseUrl + "/api/services/app/Sales/UpdateSerialByWarr";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateSerialByWarr(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSerialByWarr(<any>response_);
                } catch (e) {
                    return <Observable<ResponseDtoOfBoolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResponseDtoOfBoolean>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateSerialByWarr(response: HttpResponseBase): Observable<ResponseDtoOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? ResponseDtoOfBoolean.fromJS(resultData200) : new ResponseDtoOfBoolean();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseDtoOfBoolean>(<any>null);
    }

    /**
     * @param fileName (optional) 
     * @return Success
     */
    exportTemplatePayment(fileName: string | null | undefined): Observable<SocialRetailerFileDto> {
        let url_ = this.baseUrl + "/api/services/app/Sales/ExportTemplatePayment?";
        if (fileName !== undefined)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processExportTemplatePayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportTemplatePayment(<any>response_);
                } catch (e) {
                    return <Observable<SocialRetailerFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SocialRetailerFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processExportTemplatePayment(response: HttpResponseBase): Observable<SocialRetailerFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? SocialRetailerFileDto.fromJS(resultData200) : new SocialRetailerFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SocialRetailerFileDto>(<any>null);
    }

    /**
     * @return Success
     */
    isRoleDistributor(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Sales/IsRoleDistributor";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processIsRoleDistributor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsRoleDistributor(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processIsRoleDistributor(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    callPortal1Doi1SerialLoiAsync(input: SAP1Doi1SerialLoiInputDto | null | undefined): Observable<ResponseDtoOfListOfZif1Doi1SerialLoiResponseItem> {
        let url_ = this.baseUrl + "/api/services/app/Sales/CallPortal1Doi1SerialLoiAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCallPortal1Doi1SerialLoiAsync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCallPortal1Doi1SerialLoiAsync(<any>response_);
                } catch (e) {
                    return <Observable<ResponseDtoOfListOfZif1Doi1SerialLoiResponseItem>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResponseDtoOfListOfZif1Doi1SerialLoiResponseItem>><any>_observableThrow(response_);
        }));
    }

    protected processCallPortal1Doi1SerialLoiAsync(response: HttpResponseBase): Observable<ResponseDtoOfListOfZif1Doi1SerialLoiResponseItem> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? ResponseDtoOfListOfZif1Doi1SerialLoiResponseItem.fromJS(resultData200) : new ResponseDtoOfListOfZif1Doi1SerialLoiResponseItem();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseDtoOfListOfZif1Doi1SerialLoiResponseItem>(<any>null);
    }
}

@Injectable()
export class SalesInvoiceBaselinesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param voucherGroupCodeFilter (optional) 
     * @param memberCodeFilter (optional) 
     * @param maxPostingDateFilter (optional) 
     * @param minPostingDateFilter (optional) 
     * @param salesInvoiceCodeFilter (optional) 
     * @param maxTotalAmountFilter (optional) 
     * @param minTotalAmountFilter (optional) 
     * @param maxIncrementalFilter (optional) 
     * @param minIncrementalFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, voucherGroupCodeFilter: string | null | undefined, memberCodeFilter: string | null | undefined, maxPostingDateFilter: moment.Moment | null | undefined, minPostingDateFilter: moment.Moment | null | undefined, salesInvoiceCodeFilter: string | null | undefined, maxTotalAmountFilter: number | null | undefined, minTotalAmountFilter: number | null | undefined, maxIncrementalFilter: number | null | undefined, minIncrementalFilter: number | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetSalesInvoiceBaselineForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/SalesInvoiceBaselines/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (voucherGroupCodeFilter !== undefined)
            url_ += "VoucherGroupCodeFilter=" + encodeURIComponent("" + voucherGroupCodeFilter) + "&";
        if (memberCodeFilter !== undefined)
            url_ += "MemberCodeFilter=" + encodeURIComponent("" + memberCodeFilter) + "&";
        if (maxPostingDateFilter !== undefined)
            url_ += "MaxPostingDateFilter=" + encodeURIComponent(maxPostingDateFilter ? "" + maxPostingDateFilter.toJSON() : "") + "&";
        if (minPostingDateFilter !== undefined)
            url_ += "MinPostingDateFilter=" + encodeURIComponent(minPostingDateFilter ? "" + minPostingDateFilter.toJSON() : "") + "&";
        if (salesInvoiceCodeFilter !== undefined)
            url_ += "SalesInvoiceCodeFilter=" + encodeURIComponent("" + salesInvoiceCodeFilter) + "&";
        if (maxTotalAmountFilter !== undefined)
            url_ += "MaxTotalAmountFilter=" + encodeURIComponent("" + maxTotalAmountFilter) + "&";
        if (minTotalAmountFilter !== undefined)
            url_ += "MinTotalAmountFilter=" + encodeURIComponent("" + minTotalAmountFilter) + "&";
        if (maxIncrementalFilter !== undefined)
            url_ += "MaxIncrementalFilter=" + encodeURIComponent("" + maxIncrementalFilter) + "&";
        if (minIncrementalFilter !== undefined)
            url_ += "MinIncrementalFilter=" + encodeURIComponent("" + minIncrementalFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetSalesInvoiceBaselineForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetSalesInvoiceBaselineForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetSalesInvoiceBaselineForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetSalesInvoiceBaselineForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetSalesInvoiceBaselineForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetSalesInvoiceBaselineForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getSalesInvoiceBaselineForEdit(id: number | null | undefined): Observable<GetSalesInvoiceBaselineForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/SalesInvoiceBaselines/GetSalesInvoiceBaselineForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSalesInvoiceBaselineForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSalesInvoiceBaselineForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetSalesInvoiceBaselineForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetSalesInvoiceBaselineForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetSalesInvoiceBaselineForEdit(response: HttpResponseBase): Observable<GetSalesInvoiceBaselineForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetSalesInvoiceBaselineForEditOutput.fromJS(resultData200) : new GetSalesInvoiceBaselineForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSalesInvoiceBaselineForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditSalesInvoiceBaselineDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SalesInvoiceBaselines/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SalesInvoiceBaselines/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param voucherGroupCodeFilter (optional) 
     * @param memberCodeFilter (optional) 
     * @param maxPostingDateFilter (optional) 
     * @param minPostingDateFilter (optional) 
     * @param salesInvoiceCodeFilter (optional) 
     * @param maxTotalAmountFilter (optional) 
     * @param minTotalAmountFilter (optional) 
     * @param maxIncrementalFilter (optional) 
     * @param minIncrementalFilter (optional) 
     * @return Success
     */
    getSalesInvoiceBaselinesToExcel(filter: string | null | undefined, voucherGroupCodeFilter: string | null | undefined, memberCodeFilter: string | null | undefined, maxPostingDateFilter: moment.Moment | null | undefined, minPostingDateFilter: moment.Moment | null | undefined, salesInvoiceCodeFilter: string | null | undefined, maxTotalAmountFilter: number | null | undefined, minTotalAmountFilter: number | null | undefined, maxIncrementalFilter: number | null | undefined, minIncrementalFilter: number | null | undefined): Observable<RewardsFileDto> {
        let url_ = this.baseUrl + "/api/services/app/SalesInvoiceBaselines/GetSalesInvoiceBaselinesToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (voucherGroupCodeFilter !== undefined)
            url_ += "VoucherGroupCodeFilter=" + encodeURIComponent("" + voucherGroupCodeFilter) + "&";
        if (memberCodeFilter !== undefined)
            url_ += "MemberCodeFilter=" + encodeURIComponent("" + memberCodeFilter) + "&";
        if (maxPostingDateFilter !== undefined)
            url_ += "MaxPostingDateFilter=" + encodeURIComponent(maxPostingDateFilter ? "" + maxPostingDateFilter.toJSON() : "") + "&";
        if (minPostingDateFilter !== undefined)
            url_ += "MinPostingDateFilter=" + encodeURIComponent(minPostingDateFilter ? "" + minPostingDateFilter.toJSON() : "") + "&";
        if (salesInvoiceCodeFilter !== undefined)
            url_ += "SalesInvoiceCodeFilter=" + encodeURIComponent("" + salesInvoiceCodeFilter) + "&";
        if (maxTotalAmountFilter !== undefined)
            url_ += "MaxTotalAmountFilter=" + encodeURIComponent("" + maxTotalAmountFilter) + "&";
        if (minTotalAmountFilter !== undefined)
            url_ += "MinTotalAmountFilter=" + encodeURIComponent("" + minTotalAmountFilter) + "&";
        if (maxIncrementalFilter !== undefined)
            url_ += "MaxIncrementalFilter=" + encodeURIComponent("" + maxIncrementalFilter) + "&";
        if (minIncrementalFilter !== undefined)
            url_ += "MinIncrementalFilter=" + encodeURIComponent("" + minIncrementalFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSalesInvoiceBaselinesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSalesInvoiceBaselinesToExcel(<any>response_);
                } catch (e) {
                    return <Observable<RewardsFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<RewardsFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetSalesInvoiceBaselinesToExcel(response: HttpResponseBase): Observable<RewardsFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? RewardsFileDto.fromJS(resultData200) : new RewardsFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RewardsFileDto>(<any>null);
    }
}

@Injectable()
export class SalesInvoiceDetailsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param maxPostingDateFilter (optional) 
     * @param minPostingDateFilter (optional) 
     * @param salesInvoiceCodeFilter (optional) 
     * @param terminalNoFilter (optional) 
     * @param maxSeqNoFilter (optional) 
     * @param minSeqNoFilter (optional) 
     * @param memberCodeFilter (optional) 
     * @param deptCodeFilter (optional) 
     * @param divCodeFilter (optional) 
     * @param categoryCodeFilter (optional) 
     * @param itemCodeFilter (optional) 
     * @param brandCodeFilter (optional) 
     * @param maxQuantityFilter (optional) 
     * @param minQuantityFilter (optional) 
     * @param maxSellingpriceFilter (optional) 
     * @param minSellingpriceFilter (optional) 
     * @param maxDiscountFilter (optional) 
     * @param minDiscountFilter (optional) 
     * @param maxAmountFilter (optional) 
     * @param minAmountFilter (optional) 
     * @param customerCodeFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, maxPostingDateFilter: moment.Moment | null | undefined, minPostingDateFilter: moment.Moment | null | undefined, salesInvoiceCodeFilter: string | null | undefined, terminalNoFilter: string | null | undefined, maxSeqNoFilter: number | null | undefined, minSeqNoFilter: number | null | undefined, memberCodeFilter: string | null | undefined, deptCodeFilter: string | null | undefined, divCodeFilter: string | null | undefined, categoryCodeFilter: string | null | undefined, itemCodeFilter: string | null | undefined, brandCodeFilter: string | null | undefined, maxQuantityFilter: number | null | undefined, minQuantityFilter: number | null | undefined, maxSellingpriceFilter: number | null | undefined, minSellingpriceFilter: number | null | undefined, maxDiscountFilter: number | null | undefined, minDiscountFilter: number | null | undefined, maxAmountFilter: number | null | undefined, minAmountFilter: number | null | undefined, customerCodeFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetSalesInvoiceDetailForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/SalesInvoiceDetails/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxPostingDateFilter !== undefined)
            url_ += "MaxPostingDateFilter=" + encodeURIComponent(maxPostingDateFilter ? "" + maxPostingDateFilter.toJSON() : "") + "&";
        if (minPostingDateFilter !== undefined)
            url_ += "MinPostingDateFilter=" + encodeURIComponent(minPostingDateFilter ? "" + minPostingDateFilter.toJSON() : "") + "&";
        if (salesInvoiceCodeFilter !== undefined)
            url_ += "SalesInvoiceCodeFilter=" + encodeURIComponent("" + salesInvoiceCodeFilter) + "&";
        if (terminalNoFilter !== undefined)
            url_ += "TerminalNoFilter=" + encodeURIComponent("" + terminalNoFilter) + "&";
        if (maxSeqNoFilter !== undefined)
            url_ += "MaxSeqNoFilter=" + encodeURIComponent("" + maxSeqNoFilter) + "&";
        if (minSeqNoFilter !== undefined)
            url_ += "MinSeqNoFilter=" + encodeURIComponent("" + minSeqNoFilter) + "&";
        if (memberCodeFilter !== undefined)
            url_ += "MemberCodeFilter=" + encodeURIComponent("" + memberCodeFilter) + "&";
        if (deptCodeFilter !== undefined)
            url_ += "DeptCodeFilter=" + encodeURIComponent("" + deptCodeFilter) + "&";
        if (divCodeFilter !== undefined)
            url_ += "DivCodeFilter=" + encodeURIComponent("" + divCodeFilter) + "&";
        if (categoryCodeFilter !== undefined)
            url_ += "CategoryCodeFilter=" + encodeURIComponent("" + categoryCodeFilter) + "&";
        if (itemCodeFilter !== undefined)
            url_ += "ItemCodeFilter=" + encodeURIComponent("" + itemCodeFilter) + "&";
        if (brandCodeFilter !== undefined)
            url_ += "BrandCodeFilter=" + encodeURIComponent("" + brandCodeFilter) + "&";
        if (maxQuantityFilter !== undefined)
            url_ += "MaxQuantityFilter=" + encodeURIComponent("" + maxQuantityFilter) + "&";
        if (minQuantityFilter !== undefined)
            url_ += "MinQuantityFilter=" + encodeURIComponent("" + minQuantityFilter) + "&";
        if (maxSellingpriceFilter !== undefined)
            url_ += "MaxSellingpriceFilter=" + encodeURIComponent("" + maxSellingpriceFilter) + "&";
        if (minSellingpriceFilter !== undefined)
            url_ += "MinSellingpriceFilter=" + encodeURIComponent("" + minSellingpriceFilter) + "&";
        if (maxDiscountFilter !== undefined)
            url_ += "MaxDiscountFilter=" + encodeURIComponent("" + maxDiscountFilter) + "&";
        if (minDiscountFilter !== undefined)
            url_ += "MinDiscountFilter=" + encodeURIComponent("" + minDiscountFilter) + "&";
        if (maxAmountFilter !== undefined)
            url_ += "MaxAmountFilter=" + encodeURIComponent("" + maxAmountFilter) + "&";
        if (minAmountFilter !== undefined)
            url_ += "MinAmountFilter=" + encodeURIComponent("" + minAmountFilter) + "&";
        if (customerCodeFilter !== undefined)
            url_ += "CustomerCodeFilter=" + encodeURIComponent("" + customerCodeFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetSalesInvoiceDetailForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetSalesInvoiceDetailForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetSalesInvoiceDetailForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetSalesInvoiceDetailForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetSalesInvoiceDetailForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetSalesInvoiceDetailForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getSalesInvoiceDetailForEdit(id: number | null | undefined): Observable<GetSalesInvoiceDetailForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/SalesInvoiceDetails/GetSalesInvoiceDetailForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSalesInvoiceDetailForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSalesInvoiceDetailForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetSalesInvoiceDetailForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetSalesInvoiceDetailForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetSalesInvoiceDetailForEdit(response: HttpResponseBase): Observable<GetSalesInvoiceDetailForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetSalesInvoiceDetailForEditOutput.fromJS(resultData200) : new GetSalesInvoiceDetailForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSalesInvoiceDetailForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditSalesInvoiceDetailDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SalesInvoiceDetails/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SalesInvoiceDetails/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param maxPostingDateFilter (optional) 
     * @param minPostingDateFilter (optional) 
     * @param salesInvoiceCodeFilter (optional) 
     * @param terminalNoFilter (optional) 
     * @param maxSeqNoFilter (optional) 
     * @param minSeqNoFilter (optional) 
     * @param memberCodeFilter (optional) 
     * @param deptCodeFilter (optional) 
     * @param divCodeFilter (optional) 
     * @param categoryCodeFilter (optional) 
     * @param itemCodeFilter (optional) 
     * @param brandCodeFilter (optional) 
     * @param maxQuantityFilter (optional) 
     * @param minQuantityFilter (optional) 
     * @param maxSellingpriceFilter (optional) 
     * @param minSellingpriceFilter (optional) 
     * @param maxDiscountFilter (optional) 
     * @param minDiscountFilter (optional) 
     * @param maxAmountFilter (optional) 
     * @param minAmountFilter (optional) 
     * @param customerCodeFilter (optional) 
     * @return Success
     */
    getSalesInvoiceDetailsToExcel(filter: string | null | undefined, maxPostingDateFilter: moment.Moment | null | undefined, minPostingDateFilter: moment.Moment | null | undefined, salesInvoiceCodeFilter: string | null | undefined, terminalNoFilter: string | null | undefined, maxSeqNoFilter: number | null | undefined, minSeqNoFilter: number | null | undefined, memberCodeFilter: string | null | undefined, deptCodeFilter: string | null | undefined, divCodeFilter: string | null | undefined, categoryCodeFilter: string | null | undefined, itemCodeFilter: string | null | undefined, brandCodeFilter: string | null | undefined, maxQuantityFilter: number | null | undefined, minQuantityFilter: number | null | undefined, maxSellingpriceFilter: number | null | undefined, minSellingpriceFilter: number | null | undefined, maxDiscountFilter: number | null | undefined, minDiscountFilter: number | null | undefined, maxAmountFilter: number | null | undefined, minAmountFilter: number | null | undefined, customerCodeFilter: string | null | undefined): Observable<ConsumerDBFileDto> {
        let url_ = this.baseUrl + "/api/services/app/SalesInvoiceDetails/GetSalesInvoiceDetailsToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxPostingDateFilter !== undefined)
            url_ += "MaxPostingDateFilter=" + encodeURIComponent(maxPostingDateFilter ? "" + maxPostingDateFilter.toJSON() : "") + "&";
        if (minPostingDateFilter !== undefined)
            url_ += "MinPostingDateFilter=" + encodeURIComponent(minPostingDateFilter ? "" + minPostingDateFilter.toJSON() : "") + "&";
        if (salesInvoiceCodeFilter !== undefined)
            url_ += "SalesInvoiceCodeFilter=" + encodeURIComponent("" + salesInvoiceCodeFilter) + "&";
        if (terminalNoFilter !== undefined)
            url_ += "TerminalNoFilter=" + encodeURIComponent("" + terminalNoFilter) + "&";
        if (maxSeqNoFilter !== undefined)
            url_ += "MaxSeqNoFilter=" + encodeURIComponent("" + maxSeqNoFilter) + "&";
        if (minSeqNoFilter !== undefined)
            url_ += "MinSeqNoFilter=" + encodeURIComponent("" + minSeqNoFilter) + "&";
        if (memberCodeFilter !== undefined)
            url_ += "MemberCodeFilter=" + encodeURIComponent("" + memberCodeFilter) + "&";
        if (deptCodeFilter !== undefined)
            url_ += "DeptCodeFilter=" + encodeURIComponent("" + deptCodeFilter) + "&";
        if (divCodeFilter !== undefined)
            url_ += "DivCodeFilter=" + encodeURIComponent("" + divCodeFilter) + "&";
        if (categoryCodeFilter !== undefined)
            url_ += "CategoryCodeFilter=" + encodeURIComponent("" + categoryCodeFilter) + "&";
        if (itemCodeFilter !== undefined)
            url_ += "ItemCodeFilter=" + encodeURIComponent("" + itemCodeFilter) + "&";
        if (brandCodeFilter !== undefined)
            url_ += "BrandCodeFilter=" + encodeURIComponent("" + brandCodeFilter) + "&";
        if (maxQuantityFilter !== undefined)
            url_ += "MaxQuantityFilter=" + encodeURIComponent("" + maxQuantityFilter) + "&";
        if (minQuantityFilter !== undefined)
            url_ += "MinQuantityFilter=" + encodeURIComponent("" + minQuantityFilter) + "&";
        if (maxSellingpriceFilter !== undefined)
            url_ += "MaxSellingpriceFilter=" + encodeURIComponent("" + maxSellingpriceFilter) + "&";
        if (minSellingpriceFilter !== undefined)
            url_ += "MinSellingpriceFilter=" + encodeURIComponent("" + minSellingpriceFilter) + "&";
        if (maxDiscountFilter !== undefined)
            url_ += "MaxDiscountFilter=" + encodeURIComponent("" + maxDiscountFilter) + "&";
        if (minDiscountFilter !== undefined)
            url_ += "MinDiscountFilter=" + encodeURIComponent("" + minDiscountFilter) + "&";
        if (maxAmountFilter !== undefined)
            url_ += "MaxAmountFilter=" + encodeURIComponent("" + maxAmountFilter) + "&";
        if (minAmountFilter !== undefined)
            url_ += "MinAmountFilter=" + encodeURIComponent("" + minAmountFilter) + "&";
        if (customerCodeFilter !== undefined)
            url_ += "CustomerCodeFilter=" + encodeURIComponent("" + customerCodeFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSalesInvoiceDetailsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSalesInvoiceDetailsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<ConsumerDBFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ConsumerDBFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetSalesInvoiceDetailsToExcel(response: HttpResponseBase): Observable<ConsumerDBFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? ConsumerDBFileDto.fromJS(resultData200) : new ConsumerDBFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ConsumerDBFileDto>(<any>null);
    }
}

@Injectable()
export class SalesInvoiceHeadersServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param maxPostingDateFilter (optional) 
     * @param minPostingDateFilter (optional) 
     * @param salesInvoiceCodeFilter (optional) 
     * @param terminalNoFilter (optional) 
     * @param maxTotalAmountFilter (optional) 
     * @param minTotalAmountFilter (optional) 
     * @param memberCodeFilter (optional) 
     * @param maxPointFilter (optional) 
     * @param minPointFilter (optional) 
     * @param transactionTypeFilter (optional) 
     * @param locationFilter (optional) 
     * @param maxAllowanceFilter (optional) 
     * @param minAllowanceFilter (optional) 
     * @param customerCodeFilter (optional) 
     * @param referenceCodeFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, maxPostingDateFilter: moment.Moment | null | undefined, minPostingDateFilter: moment.Moment | null | undefined, salesInvoiceCodeFilter: string | null | undefined, terminalNoFilter: string | null | undefined, maxTotalAmountFilter: number | null | undefined, minTotalAmountFilter: number | null | undefined, memberCodeFilter: string | null | undefined, maxPointFilter: number | null | undefined, minPointFilter: number | null | undefined, transactionTypeFilter: string | null | undefined, locationFilter: string | null | undefined, maxAllowanceFilter: number | null | undefined, minAllowanceFilter: number | null | undefined, customerCodeFilter: string | null | undefined, referenceCodeFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetSalesInvoiceHeaderForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/SalesInvoiceHeaders/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxPostingDateFilter !== undefined)
            url_ += "MaxPostingDateFilter=" + encodeURIComponent(maxPostingDateFilter ? "" + maxPostingDateFilter.toJSON() : "") + "&";
        if (minPostingDateFilter !== undefined)
            url_ += "MinPostingDateFilter=" + encodeURIComponent(minPostingDateFilter ? "" + minPostingDateFilter.toJSON() : "") + "&";
        if (salesInvoiceCodeFilter !== undefined)
            url_ += "SalesInvoiceCodeFilter=" + encodeURIComponent("" + salesInvoiceCodeFilter) + "&";
        if (terminalNoFilter !== undefined)
            url_ += "TerminalNoFilter=" + encodeURIComponent("" + terminalNoFilter) + "&";
        if (maxTotalAmountFilter !== undefined)
            url_ += "MaxTotalAmountFilter=" + encodeURIComponent("" + maxTotalAmountFilter) + "&";
        if (minTotalAmountFilter !== undefined)
            url_ += "MinTotalAmountFilter=" + encodeURIComponent("" + minTotalAmountFilter) + "&";
        if (memberCodeFilter !== undefined)
            url_ += "MemberCodeFilter=" + encodeURIComponent("" + memberCodeFilter) + "&";
        if (maxPointFilter !== undefined)
            url_ += "MaxPointFilter=" + encodeURIComponent("" + maxPointFilter) + "&";
        if (minPointFilter !== undefined)
            url_ += "MinPointFilter=" + encodeURIComponent("" + minPointFilter) + "&";
        if (transactionTypeFilter !== undefined)
            url_ += "TransactionTypeFilter=" + encodeURIComponent("" + transactionTypeFilter) + "&";
        if (locationFilter !== undefined)
            url_ += "LocationFilter=" + encodeURIComponent("" + locationFilter) + "&";
        if (maxAllowanceFilter !== undefined)
            url_ += "MaxAllowanceFilter=" + encodeURIComponent("" + maxAllowanceFilter) + "&";
        if (minAllowanceFilter !== undefined)
            url_ += "MinAllowanceFilter=" + encodeURIComponent("" + minAllowanceFilter) + "&";
        if (customerCodeFilter !== undefined)
            url_ += "CustomerCodeFilter=" + encodeURIComponent("" + customerCodeFilter) + "&";
        if (referenceCodeFilter !== undefined)
            url_ += "ReferenceCodeFilter=" + encodeURIComponent("" + referenceCodeFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetSalesInvoiceHeaderForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetSalesInvoiceHeaderForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetSalesInvoiceHeaderForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetSalesInvoiceHeaderForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetSalesInvoiceHeaderForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetSalesInvoiceHeaderForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getSalesInvoiceHeaderForEdit(id: number | null | undefined): Observable<GetSalesInvoiceHeaderForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/SalesInvoiceHeaders/GetSalesInvoiceHeaderForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSalesInvoiceHeaderForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSalesInvoiceHeaderForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetSalesInvoiceHeaderForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetSalesInvoiceHeaderForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetSalesInvoiceHeaderForEdit(response: HttpResponseBase): Observable<GetSalesInvoiceHeaderForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetSalesInvoiceHeaderForEditOutput.fromJS(resultData200) : new GetSalesInvoiceHeaderForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSalesInvoiceHeaderForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditSalesInvoiceHeaderDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SalesInvoiceHeaders/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SalesInvoiceHeaders/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param maxPostingDateFilter (optional) 
     * @param minPostingDateFilter (optional) 
     * @param salesInvoiceCodeFilter (optional) 
     * @param terminalNoFilter (optional) 
     * @param maxTotalAmountFilter (optional) 
     * @param minTotalAmountFilter (optional) 
     * @param memberCodeFilter (optional) 
     * @param maxPointFilter (optional) 
     * @param minPointFilter (optional) 
     * @param transactionTypeFilter (optional) 
     * @param locationFilter (optional) 
     * @param maxAllowanceFilter (optional) 
     * @param minAllowanceFilter (optional) 
     * @param customerCodeFilter (optional) 
     * @param referenceCodeFilter (optional) 
     * @return Success
     */
    getSalesInvoiceHeadersToExcel(filter: string | null | undefined, maxPostingDateFilter: moment.Moment | null | undefined, minPostingDateFilter: moment.Moment | null | undefined, salesInvoiceCodeFilter: string | null | undefined, terminalNoFilter: string | null | undefined, maxTotalAmountFilter: number | null | undefined, minTotalAmountFilter: number | null | undefined, memberCodeFilter: string | null | undefined, maxPointFilter: number | null | undefined, minPointFilter: number | null | undefined, transactionTypeFilter: string | null | undefined, locationFilter: string | null | undefined, maxAllowanceFilter: number | null | undefined, minAllowanceFilter: number | null | undefined, customerCodeFilter: string | null | undefined, referenceCodeFilter: string | null | undefined): Observable<ConsumerDBFileDto> {
        let url_ = this.baseUrl + "/api/services/app/SalesInvoiceHeaders/GetSalesInvoiceHeadersToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxPostingDateFilter !== undefined)
            url_ += "MaxPostingDateFilter=" + encodeURIComponent(maxPostingDateFilter ? "" + maxPostingDateFilter.toJSON() : "") + "&";
        if (minPostingDateFilter !== undefined)
            url_ += "MinPostingDateFilter=" + encodeURIComponent(minPostingDateFilter ? "" + minPostingDateFilter.toJSON() : "") + "&";
        if (salesInvoiceCodeFilter !== undefined)
            url_ += "SalesInvoiceCodeFilter=" + encodeURIComponent("" + salesInvoiceCodeFilter) + "&";
        if (terminalNoFilter !== undefined)
            url_ += "TerminalNoFilter=" + encodeURIComponent("" + terminalNoFilter) + "&";
        if (maxTotalAmountFilter !== undefined)
            url_ += "MaxTotalAmountFilter=" + encodeURIComponent("" + maxTotalAmountFilter) + "&";
        if (minTotalAmountFilter !== undefined)
            url_ += "MinTotalAmountFilter=" + encodeURIComponent("" + minTotalAmountFilter) + "&";
        if (memberCodeFilter !== undefined)
            url_ += "MemberCodeFilter=" + encodeURIComponent("" + memberCodeFilter) + "&";
        if (maxPointFilter !== undefined)
            url_ += "MaxPointFilter=" + encodeURIComponent("" + maxPointFilter) + "&";
        if (minPointFilter !== undefined)
            url_ += "MinPointFilter=" + encodeURIComponent("" + minPointFilter) + "&";
        if (transactionTypeFilter !== undefined)
            url_ += "TransactionTypeFilter=" + encodeURIComponent("" + transactionTypeFilter) + "&";
        if (locationFilter !== undefined)
            url_ += "LocationFilter=" + encodeURIComponent("" + locationFilter) + "&";
        if (maxAllowanceFilter !== undefined)
            url_ += "MaxAllowanceFilter=" + encodeURIComponent("" + maxAllowanceFilter) + "&";
        if (minAllowanceFilter !== undefined)
            url_ += "MinAllowanceFilter=" + encodeURIComponent("" + minAllowanceFilter) + "&";
        if (customerCodeFilter !== undefined)
            url_ += "CustomerCodeFilter=" + encodeURIComponent("" + customerCodeFilter) + "&";
        if (referenceCodeFilter !== undefined)
            url_ += "ReferenceCodeFilter=" + encodeURIComponent("" + referenceCodeFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSalesInvoiceHeadersToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSalesInvoiceHeadersToExcel(<any>response_);
                } catch (e) {
                    return <Observable<ConsumerDBFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ConsumerDBFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetSalesInvoiceHeadersToExcel(response: HttpResponseBase): Observable<ConsumerDBFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? ConsumerDBFileDto.fromJS(resultData200) : new ConsumerDBFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ConsumerDBFileDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    search(input: GetAllSalesInvoiceHeadersInput | null | undefined): Observable<PagedResultDtoOfGetSalesInvoiceHeaderForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/SalesInvoiceHeaders/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetSalesInvoiceHeaderForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetSalesInvoiceHeaderForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<PagedResultDtoOfGetSalesInvoiceHeaderForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetSalesInvoiceHeaderForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetSalesInvoiceHeaderForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetSalesInvoiceHeaderForViewDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    searchSalesInvoiceDetail(input: GetAllSalesInvoiceDetailsInput | null | undefined): Observable<PagedResultDtoOfGetSalesInvoiceDetailForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/SalesInvoiceHeaders/SearchSalesInvoiceDetail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSearchSalesInvoiceDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchSalesInvoiceDetail(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetSalesInvoiceDetailForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetSalesInvoiceDetailForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processSearchSalesInvoiceDetail(response: HttpResponseBase): Observable<PagedResultDtoOfGetSalesInvoiceDetailForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetSalesInvoiceDetailForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetSalesInvoiceDetailForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetSalesInvoiceDetailForViewDto>(<any>null);
    }
}

@Injectable()
export class SalesmansServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param salesmanCodeFilter (optional) 
     * @param salesmanNameFilter (optional) 
     * @param passwordFilter (optional) 
     * @param statusFilter (optional) 
     * @param masterNameUnSignFilter (optional) 
     * @param phoneFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, salesmanCodeFilter: string | null | undefined, salesmanNameFilter: string | null | undefined, passwordFilter: string | null | undefined, statusFilter: string | null | undefined, masterNameUnSignFilter: string | null | undefined, phoneFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetSalesmanForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Salesmans/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (salesmanCodeFilter !== undefined)
            url_ += "SalesmanCodeFilter=" + encodeURIComponent("" + salesmanCodeFilter) + "&";
        if (salesmanNameFilter !== undefined)
            url_ += "SalesmanNameFilter=" + encodeURIComponent("" + salesmanNameFilter) + "&";
        if (passwordFilter !== undefined)
            url_ += "PasswordFilter=" + encodeURIComponent("" + passwordFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (masterNameUnSignFilter !== undefined)
            url_ += "MasterNameUnSignFilter=" + encodeURIComponent("" + masterNameUnSignFilter) + "&";
        if (phoneFilter !== undefined)
            url_ += "PhoneFilter=" + encodeURIComponent("" + phoneFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetSalesmanForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetSalesmanForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetSalesmanForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetSalesmanForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetSalesmanForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetSalesmanForViewDto>(<any>null);
    }

    /**
     * @return Success
     */
    getAllNofilter(): Observable<PagedResultDtoOfGetAllSalesmanNoFilterDto> {
        let url_ = this.baseUrl + "/api/services/app/Salesmans/GetAllNofilter";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllNofilter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllNofilter(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetAllSalesmanNoFilterDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetAllSalesmanNoFilterDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllNofilter(response: HttpResponseBase): Observable<PagedResultDtoOfGetAllSalesmanNoFilterDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetAllSalesmanNoFilterDto.fromJS(resultData200) : new PagedResultDtoOfGetAllSalesmanNoFilterDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetAllSalesmanNoFilterDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getSalesmanForEdit(id: number | null | undefined): Observable<GetSalesmanForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Salesmans/GetSalesmanForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSalesmanForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSalesmanForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetSalesmanForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetSalesmanForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetSalesmanForEdit(response: HttpResponseBase): Observable<GetSalesmanForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetSalesmanForEditOutput.fromJS(resultData200) : new GetSalesmanForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSalesmanForEditOutput>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     * @deprecated
     */
    getSalesmanForEditExt(id: number | null | undefined): Observable<GetSalesmanForEditExtOutput> {
        let url_ = this.baseUrl + "/api/services/app/Salesmans/GetSalesmanForEditExt?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSalesmanForEditExt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSalesmanForEditExt(<any>response_);
                } catch (e) {
                    return <Observable<GetSalesmanForEditExtOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetSalesmanForEditExtOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetSalesmanForEditExt(response: HttpResponseBase): Observable<GetSalesmanForEditExtOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetSalesmanForEditExtOutput.fromJS(resultData200) : new GetSalesmanForEditExtOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSalesmanForEditExtOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditSalesmanDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Salesmans/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEditExt(input: CreateOrEditSalesmanExtDto | null | undefined): Observable<SalesmanDto> {
        let url_ = this.baseUrl + "/api/services/app/Salesmans/CreateOrEditExt";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEditExt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditExt(<any>response_);
                } catch (e) {
                    return <Observable<SalesmanDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SalesmanDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEditExt(response: HttpResponseBase): Observable<SalesmanDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? SalesmanDto.fromJS(resultData200) : new SalesmanDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SalesmanDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Salesmans/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param salesmanCodeFilter (optional) 
     * @param salesmanNameFilter (optional) 
     * @param passwordFilter (optional) 
     * @param statusFilter (optional) 
     * @param masterNameUnSignFilter (optional) 
     * @param phoneFilter (optional) 
     * @return Success
     */
    getSalesmansToExcel(filter: string | null | undefined, salesmanCodeFilter: string | null | undefined, salesmanNameFilter: string | null | undefined, passwordFilter: string | null | undefined, statusFilter: string | null | undefined, masterNameUnSignFilter: string | null | undefined, phoneFilter: string | null | undefined): Observable<SocialRetailerFileDto> {
        let url_ = this.baseUrl + "/api/services/app/Salesmans/GetSalesmansToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (salesmanCodeFilter !== undefined)
            url_ += "SalesmanCodeFilter=" + encodeURIComponent("" + salesmanCodeFilter) + "&";
        if (salesmanNameFilter !== undefined)
            url_ += "SalesmanNameFilter=" + encodeURIComponent("" + salesmanNameFilter) + "&";
        if (passwordFilter !== undefined)
            url_ += "PasswordFilter=" + encodeURIComponent("" + passwordFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (masterNameUnSignFilter !== undefined)
            url_ += "MasterNameUnSignFilter=" + encodeURIComponent("" + masterNameUnSignFilter) + "&";
        if (phoneFilter !== undefined)
            url_ += "PhoneFilter=" + encodeURIComponent("" + phoneFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSalesmansToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSalesmansToExcel(<any>response_);
                } catch (e) {
                    return <Observable<SocialRetailerFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SocialRetailerFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetSalesmansToExcel(response: HttpResponseBase): Observable<SocialRetailerFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? SocialRetailerFileDto.fromJS(resultData200) : new SocialRetailerFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SocialRetailerFileDto>(<any>null);
    }

    /**
     * @param tenantId (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param filter (optional) 
     * @return Success
     */
    getUsers(tenantId: number | null | undefined, maxResultCount: number | null | undefined, skipCount: number | null | undefined, filter: string | null | undefined): Observable<PagedResultDtoOfNameValueDto> {
        let url_ = this.baseUrl + "/api/services/app/Salesmans/GetUsers?";
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUsers(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfNameValueDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfNameValueDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetUsers(response: HttpResponseBase): Observable<PagedResultDtoOfNameValueDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfNameValueDto.fromJS(resultData200) : new PagedResultDtoOfNameValueDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfNameValueDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    findUsersByOrganizationUnit(input: FindOrganizationUnitUsersInput | null | undefined): Observable<PagedResultDtoOfNameValueDto> {
        let url_ = this.baseUrl + "/api/services/app/Salesmans/FindUsersByOrganizationUnit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processFindUsersByOrganizationUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFindUsersByOrganizationUnit(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfNameValueDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfNameValueDto>><any>_observableThrow(response_);
        }));
    }

    protected processFindUsersByOrganizationUnit(response: HttpResponseBase): Observable<PagedResultDtoOfNameValueDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfNameValueDto.fromJS(resultData200) : new PagedResultDtoOfNameValueDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfNameValueDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param salesmanCodeFilter (optional) 
     * @param salesmanNameFilter (optional) 
     * @param passwordFilter (optional) 
     * @param statusFilter (optional) 
     * @param masterNameUnSignFilter (optional) 
     * @param phoneFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getSearchAsync(filter: string | null | undefined, salesmanCodeFilter: string | null | undefined, salesmanNameFilter: string | null | undefined, passwordFilter: string | null | undefined, statusFilter: string | null | undefined, masterNameUnSignFilter: string | null | undefined, phoneFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetSalesmanForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Salesmans/GetSearchAsync?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (salesmanCodeFilter !== undefined)
            url_ += "SalesmanCodeFilter=" + encodeURIComponent("" + salesmanCodeFilter) + "&";
        if (salesmanNameFilter !== undefined)
            url_ += "SalesmanNameFilter=" + encodeURIComponent("" + salesmanNameFilter) + "&";
        if (passwordFilter !== undefined)
            url_ += "PasswordFilter=" + encodeURIComponent("" + passwordFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (masterNameUnSignFilter !== undefined)
            url_ += "MasterNameUnSignFilter=" + encodeURIComponent("" + masterNameUnSignFilter) + "&";
        if (phoneFilter !== undefined)
            url_ += "PhoneFilter=" + encodeURIComponent("" + phoneFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSearchAsync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSearchAsync(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetSalesmanForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetSalesmanForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetSearchAsync(response: HttpResponseBase): Observable<PagedResultDtoOfGetSalesmanForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetSalesmanForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetSalesmanForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetSalesmanForViewDto>(<any>null);
    }

    /**
     * @param entities (optional) 
     * @return Success
     */
    batchDeleteAsync(entities: SalesmanDto[] | null | undefined): Observable<MessageResultSocialRetailer> {
        let url_ = this.baseUrl + "/api/services/app/Salesmans/BatchDeleteAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entities);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processBatchDeleteAsync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBatchDeleteAsync(<any>response_);
                } catch (e) {
                    return <Observable<MessageResultSocialRetailer>><any>_observableThrow(e);
                }
            } else
                return <Observable<MessageResultSocialRetailer>><any>_observableThrow(response_);
        }));
    }

    protected processBatchDeleteAsync(response: HttpResponseBase): Observable<MessageResultSocialRetailer> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? MessageResultSocialRetailer.fromJS(resultData200) : new MessageResultSocialRetailer();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MessageResultSocialRetailer>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEditUnsignAsync(input: CreateOrEditSalesmanDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Salesmans/CreateOrEditUnsignAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEditUnsignAsync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditUnsignAsync(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEditUnsignAsync(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param salesmanCodeFilter (optional) 
     * @param salesmanNameFilter (optional) 
     * @param passwordFilter (optional) 
     * @param statusFilter (optional) 
     * @param masterNameUnSignFilter (optional) 
     * @param phoneFilter (optional) 
     * @return Success
     */
    getSalesmansExportCustom(filter: string | null | undefined, salesmanCodeFilter: string | null | undefined, salesmanNameFilter: string | null | undefined, passwordFilter: string | null | undefined, statusFilter: string | null | undefined, masterNameUnSignFilter: string | null | undefined, phoneFilter: string | null | undefined): Observable<SocialRetailerFileDto> {
        let url_ = this.baseUrl + "/api/services/app/Salesmans/GetSalesmansExportCustom?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (salesmanCodeFilter !== undefined)
            url_ += "SalesmanCodeFilter=" + encodeURIComponent("" + salesmanCodeFilter) + "&";
        if (salesmanNameFilter !== undefined)
            url_ += "SalesmanNameFilter=" + encodeURIComponent("" + salesmanNameFilter) + "&";
        if (passwordFilter !== undefined)
            url_ += "PasswordFilter=" + encodeURIComponent("" + passwordFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (masterNameUnSignFilter !== undefined)
            url_ += "MasterNameUnSignFilter=" + encodeURIComponent("" + masterNameUnSignFilter) + "&";
        if (phoneFilter !== undefined)
            url_ += "PhoneFilter=" + encodeURIComponent("" + phoneFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSalesmansExportCustom(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSalesmansExportCustom(<any>response_);
                } catch (e) {
                    return <Observable<SocialRetailerFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SocialRetailerFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetSalesmansExportCustom(response: HttpResponseBase): Observable<SocialRetailerFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? SocialRetailerFileDto.fromJS(resultData200) : new SocialRetailerFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SocialRetailerFileDto>(<any>null);
    }

    /**
     * @param arg (optional) 
     * @return Success
     */
    importQueue(arg: SalesmanImportAgrs | null | undefined): Observable<CommonImportFileResponse> {
        let url_ = this.baseUrl + "/api/services/app/Salesmans/ImportQueue";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(arg);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processImportQueue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportQueue(<any>response_);
                } catch (e) {
                    return <Observable<CommonImportFileResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<CommonImportFileResponse>><any>_observableThrow(response_);
        }));
    }

    protected processImportQueue(response: HttpResponseBase): Observable<CommonImportFileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? CommonImportFileResponse.fromJS(resultData200) : new CommonImportFileResponse();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CommonImportFileResponse>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    loginAsync(input: SalesmanLoginDto | null | undefined): Observable<ResultLogin> {
        let url_ = this.baseUrl + "/api/services/app/Salesmans/LoginAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processLoginAsync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLoginAsync(<any>response_);
                } catch (e) {
                    return <Observable<ResultLogin>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultLogin>><any>_observableThrow(response_);
        }));
    }

    protected processLoginAsync(response: HttpResponseBase): Observable<ResultLogin> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? ResultLogin.fromJS(resultData200) : new ResultLogin();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultLogin>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    changePasswordAsync(input: ChangePasswordSalesmanDto | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Salesmans/ChangePasswordAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processChangePasswordAsync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangePasswordAsync(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processChangePasswordAsync(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param moduleName (optional) 
     * @return Success
     */
    getDefaultTenantId(moduleName: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Salesmans/GetDefaultTenantId?";
        if (moduleName !== undefined)
            url_ += "moduleName=" + encodeURIComponent("" + moduleName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetDefaultTenantId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDefaultTenantId(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetDefaultTenantId(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    changeListSalesmanPasswordAsync(input: ChangePasswordSalesmanDto[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Salesmans/ChangeListSalesmanPasswordAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processChangeListSalesmanPasswordAsync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeListSalesmanPasswordAsync(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processChangeListSalesmanPasswordAsync(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    forceChangePasswordAsync(input: ForceChangePasswordDto | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Salesmans/ForceChangePasswordAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processForceChangePasswordAsync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processForceChangePasswordAsync(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processForceChangePasswordAsync(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    resetPasswordAsync(input: ResetPasswordSalesmanDto | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Salesmans/ResetPasswordAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processResetPasswordAsync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetPasswordAsync(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processResetPasswordAsync(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }
}

@Injectable()
export class SalesRegionsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param codeFilter (optional) 
     * @param nameFilter (optional) 
     * @param isActiveFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, codeFilter: string | null | undefined, nameFilter: string | null | undefined, isActiveFilter: number | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetSalesRegionForView> {
        let url_ = this.baseUrl + "/api/services/app/SalesRegions/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&";
        if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (isActiveFilter !== undefined)
            url_ += "IsActiveFilter=" + encodeURIComponent("" + isActiveFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetSalesRegionForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetSalesRegionForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetSalesRegionForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetSalesRegionForView.fromJS(resultData200) : new PagedResultDtoOfGetSalesRegionForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetSalesRegionForView>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getSalesRegionForEdit(id: number | null | undefined): Observable<GetSalesRegionForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/SalesRegions/GetSalesRegionForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSalesRegionForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSalesRegionForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetSalesRegionForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetSalesRegionForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetSalesRegionForEdit(response: HttpResponseBase): Observable<GetSalesRegionForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetSalesRegionForEditOutput.fromJS(resultData200) : new GetSalesRegionForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSalesRegionForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditSalesRegionDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SalesRegions/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SalesRegions/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param codeFilter (optional) 
     * @param nameFilter (optional) 
     * @param isActiveFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllExt(filter: string | null | undefined, codeFilter: string | null | undefined, nameFilter: string | null | undefined, isActiveFilter: number | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetSalesRegionForView> {
        let url_ = this.baseUrl + "/api/services/app/SalesRegions/GetAllExt?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&";
        if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (isActiveFilter !== undefined)
            url_ += "IsActiveFilter=" + encodeURIComponent("" + isActiveFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllExt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllExt(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetSalesRegionForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetSalesRegionForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllExt(response: HttpResponseBase): Observable<PagedResultDtoOfGetSalesRegionForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetSalesRegionForView.fromJS(resultData200) : new PagedResultDtoOfGetSalesRegionForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetSalesRegionForView>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEditExt(input: CreateOrEditSalesRegionDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SalesRegions/CreateOrEditExt";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEditExt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditExt(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEditExt(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteExt(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SalesRegions/DeleteExt?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteExt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteExt(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteExt(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class SalesSummaryReportServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @return Success
     */
    getData(filter: string | null | undefined): Observable<SaleSummaryReportDto[]> {
        let url_ = this.baseUrl + "/api/services/app/SalesSummaryReport/GetData?";
        if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetData(<any>response_);
                } catch (e) {
                    return <Observable<SaleSummaryReportDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<SaleSummaryReportDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetData(response: HttpResponseBase): Observable<SaleSummaryReportDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(SaleSummaryReportDto.fromJS(item));
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SaleSummaryReportDto[]>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @return Success
     */
    exportFile(filter: string | null | undefined): Observable<PointFileDto> {
        let url_ = this.baseUrl + "/api/services/app/SalesSummaryReport/ExportFile?";
        if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processExportFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportFile(<any>response_);
                } catch (e) {
                    return <Observable<PointFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PointFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processExportFile(response: HttpResponseBase): Observable<PointFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PointFileDto.fromJS(resultData200) : new PointFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PointFileDto>(<any>null);
    }
}

@Injectable()
export class SalesTargetActualServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param targetCodeFilter (optional) 
     * @param targetNameFilter (optional) 
     * @param memberCodeFilter (optional) 
     * @param statusFilter (optional) 
     * @param maxTargetValueFilter (optional) 
     * @param minTargetValueFilter (optional) 
     * @param companyCodeFilter (optional) 
     * @param salesOrgCodeFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, targetCodeFilter: string | null | undefined, targetNameFilter: string | null | undefined, memberCodeFilter: string | null | undefined, statusFilter: string | null | undefined, maxTargetValueFilter: number | null | undefined, minTargetValueFilter: number | null | undefined, companyCodeFilter: string | null | undefined, salesOrgCodeFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetSalesTargetActualForView> {
        let url_ = this.baseUrl + "/api/services/app/SalesTargetActual/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (targetCodeFilter !== undefined)
            url_ += "TargetCodeFilter=" + encodeURIComponent("" + targetCodeFilter) + "&";
        if (targetNameFilter !== undefined)
            url_ += "TargetNameFilter=" + encodeURIComponent("" + targetNameFilter) + "&";
        if (memberCodeFilter !== undefined)
            url_ += "MemberCodeFilter=" + encodeURIComponent("" + memberCodeFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (maxTargetValueFilter !== undefined)
            url_ += "MaxTargetValueFilter=" + encodeURIComponent("" + maxTargetValueFilter) + "&";
        if (minTargetValueFilter !== undefined)
            url_ += "MinTargetValueFilter=" + encodeURIComponent("" + minTargetValueFilter) + "&";
        if (companyCodeFilter !== undefined)
            url_ += "CompanyCodeFilter=" + encodeURIComponent("" + companyCodeFilter) + "&";
        if (salesOrgCodeFilter !== undefined)
            url_ += "SalesOrgCodeFilter=" + encodeURIComponent("" + salesOrgCodeFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetSalesTargetActualForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetSalesTargetActualForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetSalesTargetActualForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetSalesTargetActualForView.fromJS(resultData200) : new PagedResultDtoOfGetSalesTargetActualForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetSalesTargetActualForView>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getSalesTargetActualForEdit(id: number | null | undefined): Observable<GetSalesTargetActualForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/SalesTargetActual/GetSalesTargetActualForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSalesTargetActualForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSalesTargetActualForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetSalesTargetActualForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetSalesTargetActualForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetSalesTargetActualForEdit(response: HttpResponseBase): Observable<GetSalesTargetActualForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetSalesTargetActualForEditOutput.fromJS(resultData200) : new GetSalesTargetActualForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSalesTargetActualForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditSalesTargetActualDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SalesTargetActual/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SalesTargetActual/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class SalesTargetHeaderServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param targetCodeFilter (optional) 
     * @param targetNameFilter (optional) 
     * @param parentCodeFilter (optional) 
     * @param statusFilter (optional) 
     * @param maxStartDateFilter (optional) 
     * @param minStartDateFilter (optional) 
     * @param maxEndDateFilter (optional) 
     * @param minEndDateFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param maxOrdinalFilter (optional) 
     * @param minOrdinalFilter (optional) 
     * @param targetTypeFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, targetCodeFilter: string | null | undefined, targetNameFilter: string | null | undefined, parentCodeFilter: string | null | undefined, statusFilter: string | null | undefined, maxStartDateFilter: moment.Moment | null | undefined, minStartDateFilter: moment.Moment | null | undefined, maxEndDateFilter: moment.Moment | null | undefined, minEndDateFilter: moment.Moment | null | undefined, descriptionFilter: string | null | undefined, maxOrdinalFilter: number | null | undefined, minOrdinalFilter: number | null | undefined, targetTypeFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetSalesTargetHeaderForView> {
        let url_ = this.baseUrl + "/api/services/app/SalesTargetHeader/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (targetCodeFilter !== undefined)
            url_ += "TargetCodeFilter=" + encodeURIComponent("" + targetCodeFilter) + "&";
        if (targetNameFilter !== undefined)
            url_ += "TargetNameFilter=" + encodeURIComponent("" + targetNameFilter) + "&";
        if (parentCodeFilter !== undefined)
            url_ += "ParentCodeFilter=" + encodeURIComponent("" + parentCodeFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (maxStartDateFilter !== undefined)
            url_ += "MaxStartDateFilter=" + encodeURIComponent(maxStartDateFilter ? "" + maxStartDateFilter.toJSON() : "") + "&";
        if (minStartDateFilter !== undefined)
            url_ += "MinStartDateFilter=" + encodeURIComponent(minStartDateFilter ? "" + minStartDateFilter.toJSON() : "") + "&";
        if (maxEndDateFilter !== undefined)
            url_ += "MaxEndDateFilter=" + encodeURIComponent(maxEndDateFilter ? "" + maxEndDateFilter.toJSON() : "") + "&";
        if (minEndDateFilter !== undefined)
            url_ += "MinEndDateFilter=" + encodeURIComponent(minEndDateFilter ? "" + minEndDateFilter.toJSON() : "") + "&";
        if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&";
        if (maxOrdinalFilter !== undefined)
            url_ += "MaxOrdinalFilter=" + encodeURIComponent("" + maxOrdinalFilter) + "&";
        if (minOrdinalFilter !== undefined)
            url_ += "MinOrdinalFilter=" + encodeURIComponent("" + minOrdinalFilter) + "&";
        if (targetTypeFilter !== undefined)
            url_ += "TargetTypeFilter=" + encodeURIComponent("" + targetTypeFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetSalesTargetHeaderForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetSalesTargetHeaderForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetSalesTargetHeaderForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetSalesTargetHeaderForView.fromJS(resultData200) : new PagedResultDtoOfGetSalesTargetHeaderForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetSalesTargetHeaderForView>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getSalesTargetHeaderForEdit(id: number | null | undefined): Observable<GetSalesTargetHeaderForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/SalesTargetHeader/GetSalesTargetHeaderForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSalesTargetHeaderForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSalesTargetHeaderForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetSalesTargetHeaderForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetSalesTargetHeaderForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetSalesTargetHeaderForEdit(response: HttpResponseBase): Observable<GetSalesTargetHeaderForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetSalesTargetHeaderForEditOutput.fromJS(resultData200) : new GetSalesTargetHeaderForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSalesTargetHeaderForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditSalesTargetHeaderDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SalesTargetHeader/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SalesTargetHeader/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class SAPProductsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param serial (optional) 
     * @return Success
     */
    getProductBySerial(serial: string | null | undefined): Observable<SAPProductResponse> {
        let url_ = this.baseUrl + "/api/services/app/SAPProducts/GetProductBySerial?";
        if (serial !== undefined)
            url_ += "serial=" + encodeURIComponent("" + serial) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetProductBySerial(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductBySerial(<any>response_);
                } catch (e) {
                    return <Observable<SAPProductResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<SAPProductResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetProductBySerial(response: HttpResponseBase): Observable<SAPProductResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? SAPProductResponse.fromJS(resultData200) : new SAPProductResponse();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SAPProductResponse>(<any>null);
    }
}

@Injectable()
export class SAPSerialsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditSAPSerialInput | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SAPSerials/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SAPSerials/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param productId (optional) 
     * @param serial (optional) 
     * @param itemCode (optional) 
     * @param description (optional) 
     * @param regionLevel1 (optional) 
     * @param deptCode (optional) 
     * @param year (optional) 
     * @param month (optional) 
     * @param createDate (optional) 
     * @param source (optional) 
     * @param isSellInStatus (optional) 
     * @param dateSellIn (optional) 
     * @param isSellOutStatus (optional) 
     * @param dateSellOut (optional) 
     * @param isMT (optional) 
     * @param classify (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(productId: number | null | undefined, serial: string | null | undefined, itemCode: string | null | undefined, description: string | null | undefined, regionLevel1: string | null | undefined, deptCode: string | null | undefined, year: number | null | undefined, month: number | null | undefined, createDate: moment.Moment | null | undefined, source: number | null | undefined, isSellInStatus: string | null | undefined, dateSellIn: moment.Moment | null | undefined, isSellOutStatus: string | null | undefined, dateSellOut: moment.Moment | null | undefined, isMT: boolean | null | undefined, classify: Classify | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetSAPSerialForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/SAPSerials/GetAll?";
        if (productId !== undefined)
            url_ += "ProductId=" + encodeURIComponent("" + productId) + "&";
        if (serial !== undefined)
            url_ += "Serial=" + encodeURIComponent("" + serial) + "&";
        if (itemCode !== undefined)
            url_ += "ItemCode=" + encodeURIComponent("" + itemCode) + "&";
        if (description !== undefined)
            url_ += "Description=" + encodeURIComponent("" + description) + "&";
        if (regionLevel1 !== undefined)
            url_ += "RegionLevel1=" + encodeURIComponent("" + regionLevel1) + "&";
        if (deptCode !== undefined)
            url_ += "DeptCode=" + encodeURIComponent("" + deptCode) + "&";
        if (year !== undefined)
            url_ += "Year=" + encodeURIComponent("" + year) + "&";
        if (month !== undefined)
            url_ += "Month=" + encodeURIComponent("" + month) + "&";
        if (createDate !== undefined)
            url_ += "CreateDate=" + encodeURIComponent(createDate ? "" + createDate.toJSON() : "") + "&";
        if (source !== undefined)
            url_ += "Source=" + encodeURIComponent("" + source) + "&";
        if (isSellInStatus !== undefined)
            url_ += "IsSellInStatus=" + encodeURIComponent("" + isSellInStatus) + "&";
        if (dateSellIn !== undefined)
            url_ += "DateSellIn=" + encodeURIComponent(dateSellIn ? "" + dateSellIn.toJSON() : "") + "&";
        if (isSellOutStatus !== undefined)
            url_ += "IsSellOutStatus=" + encodeURIComponent("" + isSellOutStatus) + "&";
        if (dateSellOut !== undefined)
            url_ += "DateSellOut=" + encodeURIComponent(dateSellOut ? "" + dateSellOut.toJSON() : "") + "&";
        if (isMT !== undefined)
            url_ += "IsMT=" + encodeURIComponent("" + isMT) + "&";
        if (classify !== undefined)
            url_ += "Classify=" + encodeURIComponent("" + classify) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetSAPSerialForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetSAPSerialForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetSAPSerialForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetSAPSerialForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetSAPSerialForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetSAPSerialForViewDto>(<any>null);
    }

    /**
     * @param serial (optional) 
     * @param saleType (optional) 
     * @param memberCode (optional) 
     * @return Success
     */
    checkSerial(serial: string | null | undefined, saleType: string | null | undefined, memberCode: string | null | undefined): Observable<GetCheckSerialForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/SAPSerials/CheckSerial?";
        if (serial !== undefined)
            url_ += "serial=" + encodeURIComponent("" + serial) + "&";
        if (saleType !== undefined)
            url_ += "saleType=" + encodeURIComponent("" + saleType) + "&";
        if (memberCode !== undefined)
            url_ += "memberCode=" + encodeURIComponent("" + memberCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCheckSerial(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckSerial(<any>response_);
                } catch (e) {
                    return <Observable<GetCheckSerialForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetCheckSerialForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processCheckSerial(response: HttpResponseBase): Observable<GetCheckSerialForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetCheckSerialForViewDto.fromJS(resultData200) : new GetCheckSerialForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCheckSerialForViewDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    exportFile(input: GetSAPSerialInput | null | undefined): Observable<SocialRetailerFileDto> {
        let url_ = this.baseUrl + "/api/services/app/SAPSerials/ExportFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processExportFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportFile(<any>response_);
                } catch (e) {
                    return <Observable<SocialRetailerFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SocialRetailerFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processExportFile(response: HttpResponseBase): Observable<SocialRetailerFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? SocialRetailerFileDto.fromJS(resultData200) : new SocialRetailerFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SocialRetailerFileDto>(<any>null);
    }

    /**
     * @param arg (optional) 
     * @return Success
     */
    importQueue(arg: CommonImportAgrs | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SAPSerials/ImportQueue";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(arg);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processImportQueue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportQueue(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processImportQueue(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param arg (optional) 
     * @return Success
     */
    importClassifyQueue(arg: CommonImportAgrs | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SAPSerials/ImportClassifyQueue";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(arg);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processImportClassifyQueue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportClassifyQueue(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processImportClassifyQueue(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class SecondaryCustomersServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditSecondaryCustomerDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SecondaryCustomers/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SecondaryCustomers/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllSecondaryCustomerInfoForLookupTable(filter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfSecondaryCustomerInfoLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/SecondaryCustomers/GetAllSecondaryCustomerInfoForLookupTable?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllSecondaryCustomerInfoForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSecondaryCustomerInfoForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfSecondaryCustomerInfoLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfSecondaryCustomerInfoLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllSecondaryCustomerInfoForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfSecondaryCustomerInfoLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfSecondaryCustomerInfoLookupTableDto.fromJS(resultData200) : new PagedResultDtoOfSecondaryCustomerInfoLookupTableDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfSecondaryCustomerInfoLookupTableDto>(<any>null);
    }

    /**
     * @param code (optional) 
     * @return Success
     */
    getProfileByCode(code: string | null | undefined): Observable<SecondaryCustomerDto> {
        let url_ = this.baseUrl + "/api/services/app/SecondaryCustomers/GetProfileByCode?";
        if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetProfileByCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfileByCode(<any>response_);
                } catch (e) {
                    return <Observable<SecondaryCustomerDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SecondaryCustomerDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetProfileByCode(response: HttpResponseBase): Observable<SecondaryCustomerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? SecondaryCustomerDto.fromJS(resultData200) : new SecondaryCustomerDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SecondaryCustomerDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    updateRank(input: RankAdjustmentDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SecondaryCustomers/UpdateRank";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateRank(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateRank(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateRank(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param codeFilter (optional) 
     * @param firstNameFilter (optional) 
     * @param lastNameFilter (optional) 
     * @param maxBirthdayFilter (optional) 
     * @param minBirthdayFilter (optional) 
     * @param phoneFilter (optional) 
     * @param emailFilter (optional) 
     * @param regionCodeFilter (optional) 
     * @param memberTypeCodeFilter (optional) 
     * @param channelTypeFilter (optional) 
     * @param rankTypeCodeFilter (optional) 
     * @param addressFilter (optional) 
     * @param genderFilter (optional) 
     * @param cardsFilter (optional) 
     * @param isActiveFilter (optional) 
     * @param fullRegionCodeFilter (optional) 
     * @param fullMemberTypeCodeFilter (optional) 
     * @param fullChannelTypeCodeFilter (optional) 
     * @param idCardFilter (optional) 
     * @param day (optional) 
     * @param month (optional) 
     * @param year (optional) 
     * @param memberLoyaltyInfoMemberFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, codeFilter: string | null | undefined, firstNameFilter: string | null | undefined, lastNameFilter: string | null | undefined, maxBirthdayFilter: moment.Moment | null | undefined, minBirthdayFilter: moment.Moment | null | undefined, phoneFilter: string | null | undefined, emailFilter: string | null | undefined, regionCodeFilter: string | null | undefined, memberTypeCodeFilter: string | null | undefined, channelTypeFilter: string | null | undefined, rankTypeCodeFilter: string | null | undefined, addressFilter: string | null | undefined, genderFilter: string | null | undefined, cardsFilter: string | null | undefined, isActiveFilter: number | null | undefined, fullRegionCodeFilter: string | null | undefined, fullMemberTypeCodeFilter: string | null | undefined, fullChannelTypeCodeFilter: string | null | undefined, idCardFilter: string | null | undefined, day: number | null | undefined, month: number | null | undefined, year: number | null | undefined, memberLoyaltyInfoMemberFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetSecondaryCustomerForView> {
        let url_ = this.baseUrl + "/api/services/app/SecondaryCustomers/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&";
        if (firstNameFilter !== undefined)
            url_ += "FirstNameFilter=" + encodeURIComponent("" + firstNameFilter) + "&";
        if (lastNameFilter !== undefined)
            url_ += "LastNameFilter=" + encodeURIComponent("" + lastNameFilter) + "&";
        if (maxBirthdayFilter !== undefined)
            url_ += "MaxBirthdayFilter=" + encodeURIComponent(maxBirthdayFilter ? "" + maxBirthdayFilter.toJSON() : "") + "&";
        if (minBirthdayFilter !== undefined)
            url_ += "MinBirthdayFilter=" + encodeURIComponent(minBirthdayFilter ? "" + minBirthdayFilter.toJSON() : "") + "&";
        if (phoneFilter !== undefined)
            url_ += "PhoneFilter=" + encodeURIComponent("" + phoneFilter) + "&";
        if (emailFilter !== undefined)
            url_ += "EmailFilter=" + encodeURIComponent("" + emailFilter) + "&";
        if (regionCodeFilter !== undefined)
            url_ += "RegionCodeFilter=" + encodeURIComponent("" + regionCodeFilter) + "&";
        if (memberTypeCodeFilter !== undefined)
            url_ += "MemberTypeCodeFilter=" + encodeURIComponent("" + memberTypeCodeFilter) + "&";
        if (channelTypeFilter !== undefined)
            url_ += "ChannelTypeFilter=" + encodeURIComponent("" + channelTypeFilter) + "&";
        if (rankTypeCodeFilter !== undefined)
            url_ += "RankTypeCodeFilter=" + encodeURIComponent("" + rankTypeCodeFilter) + "&";
        if (addressFilter !== undefined)
            url_ += "AddressFilter=" + encodeURIComponent("" + addressFilter) + "&";
        if (genderFilter !== undefined)
            url_ += "GenderFilter=" + encodeURIComponent("" + genderFilter) + "&";
        if (cardsFilter !== undefined)
            url_ += "CardsFilter=" + encodeURIComponent("" + cardsFilter) + "&";
        if (isActiveFilter !== undefined)
            url_ += "IsActiveFilter=" + encodeURIComponent("" + isActiveFilter) + "&";
        if (fullRegionCodeFilter !== undefined)
            url_ += "FullRegionCodeFilter=" + encodeURIComponent("" + fullRegionCodeFilter) + "&";
        if (fullMemberTypeCodeFilter !== undefined)
            url_ += "FullMemberTypeCodeFilter=" + encodeURIComponent("" + fullMemberTypeCodeFilter) + "&";
        if (fullChannelTypeCodeFilter !== undefined)
            url_ += "FullChannelTypeCodeFilter=" + encodeURIComponent("" + fullChannelTypeCodeFilter) + "&";
        if (idCardFilter !== undefined)
            url_ += "IdCardFilter=" + encodeURIComponent("" + idCardFilter) + "&";
        if (day !== undefined)
            url_ += "Day=" + encodeURIComponent("" + day) + "&";
        if (month !== undefined)
            url_ += "Month=" + encodeURIComponent("" + month) + "&";
        if (year !== undefined)
            url_ += "Year=" + encodeURIComponent("" + year) + "&";
        if (memberLoyaltyInfoMemberFilter !== undefined)
            url_ += "MemberLoyaltyInfoMemberFilter=" + encodeURIComponent("" + memberLoyaltyInfoMemberFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetSecondaryCustomerForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetSecondaryCustomerForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetSecondaryCustomerForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetSecondaryCustomerForView.fromJS(resultData200) : new PagedResultDtoOfGetSecondaryCustomerForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetSecondaryCustomerForView>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getSecondaryCustomerForEdit(id: number | null | undefined): Observable<GetSecondaryCustomerForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/SecondaryCustomers/GetSecondaryCustomerForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSecondaryCustomerForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSecondaryCustomerForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetSecondaryCustomerForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetSecondaryCustomerForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetSecondaryCustomerForEdit(response: HttpResponseBase): Observable<GetSecondaryCustomerForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetSecondaryCustomerForEditOutput.fromJS(resultData200) : new GetSecondaryCustomerForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSecondaryCustomerForEditOutput>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param firstNameFilter (optional) 
     * @param codeFilter (optional) 
     * @param phoneFilter (optional) 
     * @param emailFilter (optional) 
     * @param addressFilter (optional) 
     * @param genderFilter (optional) 
     * @param isActiveFilter (optional) 
     * @param idCardFilter (optional) 
     * @param day (optional) 
     * @param month (optional) 
     * @param year (optional) 
     * @param masterCodeFilter (optional) 
     * @param accountType (optional) 
     * @param statusFilter (optional) 
     * @param curentRankFilter (optional) 
     * @param contractFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllServiceAccount(filter: string | null | undefined, firstNameFilter: string | null | undefined, codeFilter: string | null | undefined, phoneFilter: string | null | undefined, emailFilter: string | null | undefined, addressFilter: string | null | undefined, genderFilter: string | null | undefined, isActiveFilter: number | null | undefined, idCardFilter: string | null | undefined, day: number | null | undefined, month: number | null | undefined, year: number | null | undefined, masterCodeFilter: string | null | undefined, accountType: string | null | undefined, statusFilter: string | null | undefined, curentRankFilter: string | null | undefined, contractFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetSecondaryCustomerForView> {
        let url_ = this.baseUrl + "/api/services/app/SecondaryCustomers/GetAllServiceAccount?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (firstNameFilter !== undefined)
            url_ += "FirstNameFilter=" + encodeURIComponent("" + firstNameFilter) + "&";
        if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&";
        if (phoneFilter !== undefined)
            url_ += "PhoneFilter=" + encodeURIComponent("" + phoneFilter) + "&";
        if (emailFilter !== undefined)
            url_ += "EmailFilter=" + encodeURIComponent("" + emailFilter) + "&";
        if (addressFilter !== undefined)
            url_ += "AddressFilter=" + encodeURIComponent("" + addressFilter) + "&";
        if (genderFilter !== undefined)
            url_ += "GenderFilter=" + encodeURIComponent("" + genderFilter) + "&";
        if (isActiveFilter !== undefined)
            url_ += "IsActiveFilter=" + encodeURIComponent("" + isActiveFilter) + "&";
        if (idCardFilter !== undefined)
            url_ += "IdCardFilter=" + encodeURIComponent("" + idCardFilter) + "&";
        if (day !== undefined)
            url_ += "Day=" + encodeURIComponent("" + day) + "&";
        if (month !== undefined)
            url_ += "Month=" + encodeURIComponent("" + month) + "&";
        if (year !== undefined)
            url_ += "Year=" + encodeURIComponent("" + year) + "&";
        if (masterCodeFilter !== undefined)
            url_ += "MasterCodeFilter=" + encodeURIComponent("" + masterCodeFilter) + "&";
        if (accountType !== undefined)
            url_ += "AccountType=" + encodeURIComponent("" + accountType) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (curentRankFilter !== undefined)
            url_ += "CurentRankFilter=" + encodeURIComponent("" + curentRankFilter) + "&";
        if (contractFilter !== undefined)
            url_ += "ContractFilter=" + encodeURIComponent("" + contractFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllServiceAccount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllServiceAccount(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetSecondaryCustomerForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetSecondaryCustomerForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllServiceAccount(response: HttpResponseBase): Observable<PagedResultDtoOfGetSecondaryCustomerForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetSecondaryCustomerForView.fromJS(resultData200) : new PagedResultDtoOfGetSecondaryCustomerForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetSecondaryCustomerForView>(<any>null);
    }

    /**
     * @param code (optional) 
     * @return Success
     */
    getMemberByCodeAsync(code: string | null | undefined): Observable<SecondaryCustomerDto> {
        let url_ = this.baseUrl + "/api/services/app/SecondaryCustomers/GetMemberByCodeAsync?";
        if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetMemberByCodeAsync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMemberByCodeAsync(<any>response_);
                } catch (e) {
                    return <Observable<SecondaryCustomerDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SecondaryCustomerDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetMemberByCodeAsync(response: HttpResponseBase): Observable<SecondaryCustomerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? SecondaryCustomerDto.fromJS(resultData200) : new SecondaryCustomerDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SecondaryCustomerDto>(<any>null);
    }

    /**
     * @param phoneNumber (optional) 
     * @return Success
     */
    sendOTPToPhoneNumber(phoneNumber: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SecondaryCustomers/SendOTPToPhoneNumber?";
        if (phoneNumber !== undefined)
            url_ += "phoneNumber=" + encodeURIComponent("" + phoneNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSendOTPToPhoneNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendOTPToPhoneNumber(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSendOTPToPhoneNumber(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    verifyOTP(input: OTPVerifyDto | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/SecondaryCustomers/VerifyOTP";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processVerifyOTP(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerifyOTP(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processVerifyOTP(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param phone (optional) 
     * @return Success
     */
    getByPhone(phone: string | null | undefined): Observable<SecondaryCustomerDto> {
        let url_ = this.baseUrl + "/api/services/app/SecondaryCustomers/GetByPhone?";
        if (phone !== undefined)
            url_ += "phone=" + encodeURIComponent("" + phone) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetByPhone(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByPhone(<any>response_);
                } catch (e) {
                    return <Observable<SecondaryCustomerDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SecondaryCustomerDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetByPhone(response: HttpResponseBase): Observable<SecondaryCustomerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? SecondaryCustomerDto.fromJS(resultData200) : new SecondaryCustomerDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SecondaryCustomerDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    exportExcel(input: GetAllServiceAccountInput | null | undefined): Observable<PointFileDto> {
        let url_ = this.baseUrl + "/api/services/app/SecondaryCustomers/ExportExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processExportExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportExcel(<any>response_);
                } catch (e) {
                    return <Observable<PointFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PointFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processExportExcel(response: HttpResponseBase): Observable<PointFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PointFileDto.fromJS(resultData200) : new PointFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PointFileDto>(<any>null);
    }

    /**
     * @param memberCode (optional) 
     * @param timeToRun (optional) 
     * @return Success
     */
    calculateRankManualTrigger(memberCode: string | null | undefined, timeToRun: moment.Moment | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SecondaryCustomers/CalculateRankManualTrigger?";
        if (memberCode !== undefined)
            url_ += "memberCode=" + encodeURIComponent("" + memberCode) + "&";
        if (timeToRun !== undefined)
            url_ += "timeToRun=" + encodeURIComponent(timeToRun ? "" + timeToRun.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCalculateRankManualTrigger(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCalculateRankManualTrigger(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCalculateRankManualTrigger(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class SecondaryCustomerTypesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param codeFilter (optional) 
     * @param nameFilter (optional) 
     * @param parentCodeFilter (optional) 
     * @param isActiveFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, codeFilter: string | null | undefined, nameFilter: string | null | undefined, parentCodeFilter: string | null | undefined, isActiveFilter: number | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetSecondaryCustomerTypeForView> {
        let url_ = this.baseUrl + "/api/services/app/SecondaryCustomerTypes/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&";
        if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (parentCodeFilter !== undefined)
            url_ += "ParentCodeFilter=" + encodeURIComponent("" + parentCodeFilter) + "&";
        if (isActiveFilter !== undefined)
            url_ += "IsActiveFilter=" + encodeURIComponent("" + isActiveFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetSecondaryCustomerTypeForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetSecondaryCustomerTypeForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetSecondaryCustomerTypeForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetSecondaryCustomerTypeForView.fromJS(resultData200) : new PagedResultDtoOfGetSecondaryCustomerTypeForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetSecondaryCustomerTypeForView>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getSecondaryCustomerTypeForEdit(id: number | null | undefined): Observable<GetSecondaryCustomerTypeForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/SecondaryCustomerTypes/GetSecondaryCustomerTypeForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSecondaryCustomerTypeForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSecondaryCustomerTypeForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetSecondaryCustomerTypeForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetSecondaryCustomerTypeForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetSecondaryCustomerTypeForEdit(response: HttpResponseBase): Observable<GetSecondaryCustomerTypeForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetSecondaryCustomerTypeForEditOutput.fromJS(resultData200) : new GetSecondaryCustomerTypeForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSecondaryCustomerTypeForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditSecondaryCustomerTypeDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SecondaryCustomerTypes/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SecondaryCustomerTypes/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class SeniorityRewardSettingsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param codeFilter (optional) 
     * @param senioritySettingCodeFilter (optional) 
     * @param maxSeniorityFromFilter (optional) 
     * @param minSeniorityFromFilter (optional) 
     * @param maxCoinValueFilter (optional) 
     * @param minCoinValueFilter (optional) 
     * @param maxPointValueFilter (optional) 
     * @param minPointValueFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, codeFilter: string | null | undefined, senioritySettingCodeFilter: string | null | undefined, maxSeniorityFromFilter: number | null | undefined, minSeniorityFromFilter: number | null | undefined, maxCoinValueFilter: number | null | undefined, minCoinValueFilter: number | null | undefined, maxPointValueFilter: number | null | undefined, minPointValueFilter: number | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetSeniorityRewardSettingForView> {
        let url_ = this.baseUrl + "/api/services/app/SeniorityRewardSettings/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&";
        if (senioritySettingCodeFilter !== undefined)
            url_ += "SenioritySettingCodeFilter=" + encodeURIComponent("" + senioritySettingCodeFilter) + "&";
        if (maxSeniorityFromFilter !== undefined)
            url_ += "MaxSeniorityFromFilter=" + encodeURIComponent("" + maxSeniorityFromFilter) + "&";
        if (minSeniorityFromFilter !== undefined)
            url_ += "MinSeniorityFromFilter=" + encodeURIComponent("" + minSeniorityFromFilter) + "&";
        if (maxCoinValueFilter !== undefined)
            url_ += "MaxCoinValueFilter=" + encodeURIComponent("" + maxCoinValueFilter) + "&";
        if (minCoinValueFilter !== undefined)
            url_ += "MinCoinValueFilter=" + encodeURIComponent("" + minCoinValueFilter) + "&";
        if (maxPointValueFilter !== undefined)
            url_ += "MaxPointValueFilter=" + encodeURIComponent("" + maxPointValueFilter) + "&";
        if (minPointValueFilter !== undefined)
            url_ += "MinPointValueFilter=" + encodeURIComponent("" + minPointValueFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetSeniorityRewardSettingForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetSeniorityRewardSettingForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetSeniorityRewardSettingForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetSeniorityRewardSettingForView.fromJS(resultData200) : new PagedResultDtoOfGetSeniorityRewardSettingForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetSeniorityRewardSettingForView>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getSeniorityRewardSettingForEdit(id: number | null | undefined): Observable<GetSeniorityRewardSettingForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/SeniorityRewardSettings/GetSeniorityRewardSettingForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSeniorityRewardSettingForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSeniorityRewardSettingForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetSeniorityRewardSettingForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetSeniorityRewardSettingForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetSeniorityRewardSettingForEdit(response: HttpResponseBase): Observable<GetSeniorityRewardSettingForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetSeniorityRewardSettingForEditOutput.fromJS(resultData200) : new GetSeniorityRewardSettingForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSeniorityRewardSettingForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditSeniorityRewardSettingDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SeniorityRewardSettings/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SeniorityRewardSettings/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class SenioritySettingHistoryServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param memberCodeFilter (optional) 
     * @param senioritySettingCodeFilter (optional) 
     * @param maxSeniorityFromFilter (optional) 
     * @param minSeniorityFromFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, memberCodeFilter: string | null | undefined, senioritySettingCodeFilter: string | null | undefined, maxSeniorityFromFilter: number | null | undefined, minSeniorityFromFilter: number | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetSenioritySettingHistoryForView> {
        let url_ = this.baseUrl + "/api/services/app/SenioritySettingHistory/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (memberCodeFilter !== undefined)
            url_ += "MemberCodeFilter=" + encodeURIComponent("" + memberCodeFilter) + "&";
        if (senioritySettingCodeFilter !== undefined)
            url_ += "SenioritySettingCodeFilter=" + encodeURIComponent("" + senioritySettingCodeFilter) + "&";
        if (maxSeniorityFromFilter !== undefined)
            url_ += "MaxSeniorityFromFilter=" + encodeURIComponent("" + maxSeniorityFromFilter) + "&";
        if (minSeniorityFromFilter !== undefined)
            url_ += "MinSeniorityFromFilter=" + encodeURIComponent("" + minSeniorityFromFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetSenioritySettingHistoryForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetSenioritySettingHistoryForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetSenioritySettingHistoryForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetSenioritySettingHistoryForView.fromJS(resultData200) : new PagedResultDtoOfGetSenioritySettingHistoryForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetSenioritySettingHistoryForView>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getSenioritySettingHistoryForEdit(id: number | null | undefined): Observable<GetSenioritySettingHistoryForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/SenioritySettingHistory/GetSenioritySettingHistoryForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSenioritySettingHistoryForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSenioritySettingHistoryForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetSenioritySettingHistoryForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetSenioritySettingHistoryForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetSenioritySettingHistoryForEdit(response: HttpResponseBase): Observable<GetSenioritySettingHistoryForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetSenioritySettingHistoryForEditOutput.fromJS(resultData200) : new GetSenioritySettingHistoryForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSenioritySettingHistoryForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditSenioritySettingHistoryDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SenioritySettingHistory/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SenioritySettingHistory/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class SenioritySettingsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param codeFilter (optional) 
     * @param nameFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param maxEffectiveFromFilter (optional) 
     * @param minEffectiveFromFilter (optional) 
     * @param maxEffectiveToFilter (optional) 
     * @param minEffectiveToFilter (optional) 
     * @param maxStartPeriodFilter (optional) 
     * @param minStartPeriodFilter (optional) 
     * @param maxEndPeriodFilter (optional) 
     * @param minEndPeriodFilter (optional) 
     * @param maxMinMonthRequiredFilter (optional) 
     * @param minMinMonthRequiredFilter (optional) 
     * @param cronFilter (optional) 
     * @param timeZoneFilter (optional) 
     * @param isActiveFilter (optional) 
     * @param targetAudienceCodeFilter (optional) 
     * @param campaignCodeFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, codeFilter: string | null | undefined, nameFilter: string | null | undefined, descriptionFilter: string | null | undefined, maxEffectiveFromFilter: moment.Moment | null | undefined, minEffectiveFromFilter: moment.Moment | null | undefined, maxEffectiveToFilter: moment.Moment | null | undefined, minEffectiveToFilter: moment.Moment | null | undefined, maxStartPeriodFilter: moment.Moment | null | undefined, minStartPeriodFilter: moment.Moment | null | undefined, maxEndPeriodFilter: moment.Moment | null | undefined, minEndPeriodFilter: moment.Moment | null | undefined, maxMinMonthRequiredFilter: number | null | undefined, minMinMonthRequiredFilter: number | null | undefined, cronFilter: string | null | undefined, timeZoneFilter: string | null | undefined, isActiveFilter: number | null | undefined, targetAudienceCodeFilter: string | null | undefined, campaignCodeFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetSenioritySettingForView> {
        let url_ = this.baseUrl + "/api/services/app/SenioritySettings/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&";
        if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&";
        if (maxEffectiveFromFilter !== undefined)
            url_ += "MaxEffectiveFromFilter=" + encodeURIComponent(maxEffectiveFromFilter ? "" + maxEffectiveFromFilter.toJSON() : "") + "&";
        if (minEffectiveFromFilter !== undefined)
            url_ += "MinEffectiveFromFilter=" + encodeURIComponent(minEffectiveFromFilter ? "" + minEffectiveFromFilter.toJSON() : "") + "&";
        if (maxEffectiveToFilter !== undefined)
            url_ += "MaxEffectiveToFilter=" + encodeURIComponent(maxEffectiveToFilter ? "" + maxEffectiveToFilter.toJSON() : "") + "&";
        if (minEffectiveToFilter !== undefined)
            url_ += "MinEffectiveToFilter=" + encodeURIComponent(minEffectiveToFilter ? "" + minEffectiveToFilter.toJSON() : "") + "&";
        if (maxStartPeriodFilter !== undefined)
            url_ += "MaxStartPeriodFilter=" + encodeURIComponent(maxStartPeriodFilter ? "" + maxStartPeriodFilter.toJSON() : "") + "&";
        if (minStartPeriodFilter !== undefined)
            url_ += "MinStartPeriodFilter=" + encodeURIComponent(minStartPeriodFilter ? "" + minStartPeriodFilter.toJSON() : "") + "&";
        if (maxEndPeriodFilter !== undefined)
            url_ += "MaxEndPeriodFilter=" + encodeURIComponent(maxEndPeriodFilter ? "" + maxEndPeriodFilter.toJSON() : "") + "&";
        if (minEndPeriodFilter !== undefined)
            url_ += "MinEndPeriodFilter=" + encodeURIComponent(minEndPeriodFilter ? "" + minEndPeriodFilter.toJSON() : "") + "&";
        if (maxMinMonthRequiredFilter !== undefined)
            url_ += "MaxMinMonthRequiredFilter=" + encodeURIComponent("" + maxMinMonthRequiredFilter) + "&";
        if (minMinMonthRequiredFilter !== undefined)
            url_ += "MinMinMonthRequiredFilter=" + encodeURIComponent("" + minMinMonthRequiredFilter) + "&";
        if (cronFilter !== undefined)
            url_ += "CronFilter=" + encodeURIComponent("" + cronFilter) + "&";
        if (timeZoneFilter !== undefined)
            url_ += "TimeZoneFilter=" + encodeURIComponent("" + timeZoneFilter) + "&";
        if (isActiveFilter !== undefined)
            url_ += "IsActiveFilter=" + encodeURIComponent("" + isActiveFilter) + "&";
        if (targetAudienceCodeFilter !== undefined)
            url_ += "TargetAudienceCodeFilter=" + encodeURIComponent("" + targetAudienceCodeFilter) + "&";
        if (campaignCodeFilter !== undefined)
            url_ += "CampaignCodeFilter=" + encodeURIComponent("" + campaignCodeFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetSenioritySettingForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetSenioritySettingForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetSenioritySettingForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetSenioritySettingForView.fromJS(resultData200) : new PagedResultDtoOfGetSenioritySettingForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetSenioritySettingForView>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getSenioritySettingForEdit(id: number | null | undefined): Observable<GetSenioritySettingForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/SenioritySettings/GetSenioritySettingForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSenioritySettingForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSenioritySettingForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetSenioritySettingForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetSenioritySettingForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetSenioritySettingForEdit(response: HttpResponseBase): Observable<GetSenioritySettingForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetSenioritySettingForEditOutput.fromJS(resultData200) : new GetSenioritySettingForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSenioritySettingForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditSenioritySettingDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SenioritySettings/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SenioritySettings/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllSettingParamForLookupTable(filter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfSettingParamLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/SenioritySettings/GetAllSettingParamForLookupTable?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllSettingParamForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSettingParamForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfSettingParamLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfSettingParamLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllSettingParamForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfSettingParamLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfSettingParamLookupTableDto.fromJS(resultData200) : new PagedResultDtoOfSettingParamLookupTableDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfSettingParamLookupTableDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllCampaignForLookupTable(filter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfCampaignLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/SenioritySettings/GetAllCampaignForLookupTable?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllCampaignForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCampaignForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfCampaignLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfCampaignLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllCampaignForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfCampaignLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfCampaignLookupTableDto.fromJS(resultData200) : new PagedResultDtoOfCampaignLookupTableDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfCampaignLookupTableDto>(<any>null);
    }

    /**
     * @param campaignId (optional) 
     * @param isActiveFilter (optional) 
     * @return Success
     */
    getAllForCampaign(campaignId: number | null | undefined, isActiveFilter: number | null | undefined): Observable<ListResultDtoOfSenioritySettingDto> {
        let url_ = this.baseUrl + "/api/services/app/SenioritySettings/GetAllForCampaign?";
        if (campaignId !== undefined)
            url_ += "CampaignId=" + encodeURIComponent("" + campaignId) + "&";
        if (isActiveFilter !== undefined)
            url_ += "IsActiveFilter=" + encodeURIComponent("" + isActiveFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllForCampaign(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllForCampaign(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfSenioritySettingDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfSenioritySettingDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllForCampaign(response: HttpResponseBase): Observable<ListResultDtoOfSenioritySettingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? ListResultDtoOfSenioritySettingDto.fromJS(resultData200) : new ListResultDtoOfSenioritySettingDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfSenioritySettingDto>(<any>null);
    }
}

@Injectable()
export class SerialServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditSerialInput | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Serial/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param serialCode (optional) 
     * @param status (optional) 
     * @param distributor (optional) 
     * @param refCode (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(serialCode: string | null | undefined, status: string | null | undefined, distributor: string | null | undefined, refCode: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetListSerialResponse> {
        let url_ = this.baseUrl + "/api/services/app/Serial/GetAll?";
        if (serialCode !== undefined)
            url_ += "SerialCode=" + encodeURIComponent("" + serialCode) + "&";
        if (status !== undefined)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (distributor !== undefined)
            url_ += "Distributor=" + encodeURIComponent("" + distributor) + "&";
        if (refCode !== undefined)
            url_ += "RefCode=" + encodeURIComponent("" + refCode) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetListSerialResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetListSerialResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetListSerialResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetListSerialResponse.fromJS(resultData200) : new PagedResultDtoOfGetListSerialResponse();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetListSerialResponse>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    exportFile(input: GetSerialInput | null | undefined): Observable<SocialRetailerFileDto> {
        let url_ = this.baseUrl + "/api/services/app/Serial/ExportFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processExportFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportFile(<any>response_);
                } catch (e) {
                    return <Observable<SocialRetailerFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SocialRetailerFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processExportFile(response: HttpResponseBase): Observable<SocialRetailerFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? SocialRetailerFileDto.fromJS(resultData200) : new SocialRetailerFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SocialRetailerFileDto>(<any>null);
    }

    /**
     * @param args (optional) 
     * @return Success
     */
    importFile(args: SerialAgrs | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Serial/ImportFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(args);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processImportFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportFile(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processImportFile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class SerialProducerServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param productHierarchy (optional) 
     * @param massOrder (optional) 
     * @param massOrderPO (optional) 
     * @param cont (optional) 
     * @param serial (optional) 
     * @param activationCode (optional) 
     * @param model (optional) 
     * @param status (optional) 
     * @param toScanDate (optional) 
     * @param fromScanDate (optional) 
     * @param toDate (optional) 
     * @param fromDate (optional) 
     * @param manufacturer (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(productHierarchy: string | null | undefined, massOrder: string | null | undefined, massOrderPO: string | null | undefined, cont: string | null | undefined, serial: string | null | undefined, activationCode: string | null | undefined, model: string | null | undefined, status: string | null | undefined, toScanDate: moment.Moment | null | undefined, fromScanDate: moment.Moment | null | undefined, toDate: moment.Moment | null | undefined, fromDate: moment.Moment | null | undefined, manufacturer: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfSerialProducerResponseDto> {
        let url_ = this.baseUrl + "/api/services/app/SerialProducer/GetAll?";
        if (productHierarchy !== undefined)
            url_ += "ProductHierarchy=" + encodeURIComponent("" + productHierarchy) + "&";
        if (massOrder !== undefined)
            url_ += "MassOrder=" + encodeURIComponent("" + massOrder) + "&";
        if (massOrderPO !== undefined)
            url_ += "MassOrderPO=" + encodeURIComponent("" + massOrderPO) + "&";
        if (cont !== undefined)
            url_ += "Cont=" + encodeURIComponent("" + cont) + "&";
        if (serial !== undefined)
            url_ += "Serial=" + encodeURIComponent("" + serial) + "&";
        if (activationCode !== undefined)
            url_ += "ActivationCode=" + encodeURIComponent("" + activationCode) + "&";
        if (model !== undefined)
            url_ += "Model=" + encodeURIComponent("" + model) + "&";
        if (status !== undefined)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (toScanDate !== undefined)
            url_ += "ToScanDate=" + encodeURIComponent(toScanDate ? "" + toScanDate.toJSON() : "") + "&";
        if (fromScanDate !== undefined)
            url_ += "FromScanDate=" + encodeURIComponent(fromScanDate ? "" + fromScanDate.toJSON() : "") + "&";
        if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toJSON() : "") + "&";
        if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toJSON() : "") + "&";
        if (manufacturer !== undefined)
            url_ += "Manufacturer=" + encodeURIComponent("" + manufacturer) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfSerialProducerResponseDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfSerialProducerResponseDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfSerialProducerResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfSerialProducerResponseDto.fromJS(resultData200) : new PagedResultDtoOfSerialProducerResponseDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfSerialProducerResponseDto>(<any>null);
    }

    /**
     * @param productHierarchy (optional) 
     * @param massOrder (optional) 
     * @param massOrderPO (optional) 
     * @param cont (optional) 
     * @param serial (optional) 
     * @param activationCode (optional) 
     * @param model (optional) 
     * @param status (optional) 
     * @param toScanDate (optional) 
     * @param fromScanDate (optional) 
     * @param toDate (optional) 
     * @param fromDate (optional) 
     * @param manufacturer (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    exportExcelSerialProducer(productHierarchy: string | null | undefined, massOrder: string | null | undefined, massOrderPO: string | null | undefined, cont: string | null | undefined, serial: string | null | undefined, activationCode: string | null | undefined, model: string | null | undefined, status: string | null | undefined, toScanDate: moment.Moment | null | undefined, fromScanDate: moment.Moment | null | undefined, toDate: moment.Moment | null | undefined, fromDate: moment.Moment | null | undefined, manufacturer: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SerialProducer/ExportExcelSerialProducer?";
        if (productHierarchy !== undefined)
            url_ += "ProductHierarchy=" + encodeURIComponent("" + productHierarchy) + "&";
        if (massOrder !== undefined)
            url_ += "MassOrder=" + encodeURIComponent("" + massOrder) + "&";
        if (massOrderPO !== undefined)
            url_ += "MassOrderPO=" + encodeURIComponent("" + massOrderPO) + "&";
        if (cont !== undefined)
            url_ += "Cont=" + encodeURIComponent("" + cont) + "&";
        if (serial !== undefined)
            url_ += "Serial=" + encodeURIComponent("" + serial) + "&";
        if (activationCode !== undefined)
            url_ += "ActivationCode=" + encodeURIComponent("" + activationCode) + "&";
        if (model !== undefined)
            url_ += "Model=" + encodeURIComponent("" + model) + "&";
        if (status !== undefined)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (toScanDate !== undefined)
            url_ += "ToScanDate=" + encodeURIComponent(toScanDate ? "" + toScanDate.toJSON() : "") + "&";
        if (fromScanDate !== undefined)
            url_ += "FromScanDate=" + encodeURIComponent(fromScanDate ? "" + fromScanDate.toJSON() : "") + "&";
        if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toJSON() : "") + "&";
        if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toJSON() : "") + "&";
        if (manufacturer !== undefined)
            url_ += "Manufacturer=" + encodeURIComponent("" + manufacturer) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processExportExcelSerialProducer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportExcelSerialProducer(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processExportExcelSerialProducer(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    scan(input: ScanInput | null | undefined): Observable<ResponseDtoOfBoolean> {
        let url_ = this.baseUrl + "/api/services/app/SerialProducer/Scan";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processScan(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processScan(<any>response_);
                } catch (e) {
                    return <Observable<ResponseDtoOfBoolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResponseDtoOfBoolean>><any>_observableThrow(response_);
        }));
    }

    protected processScan(response: HttpResponseBase): Observable<ResponseDtoOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? ResponseDtoOfBoolean.fromJS(resultData200) : new ResponseDtoOfBoolean();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseDtoOfBoolean>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    countSerialLimitInMonth(input: SerialProducerGenerateInput | null | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/SerialProducer/CountSerialLimitInMonth";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCountSerialLimitInMonth(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCountSerialLimitInMonth(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processCountSerialLimitInMonth(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param inputs (optional) 
     * @return Success
     */
    generateSerial(inputs: SerialProducerGenerateInput[] | null | undefined): Observable<ResponseDtoOfBoolean> {
        let url_ = this.baseUrl + "/api/services/app/SerialProducer/GenerateSerial";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inputs);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGenerateSerial(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateSerial(<any>response_);
                } catch (e) {
                    return <Observable<ResponseDtoOfBoolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResponseDtoOfBoolean>><any>_observableThrow(response_);
        }));
    }

    protected processGenerateSerial(response: HttpResponseBase): Observable<ResponseDtoOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? ResponseDtoOfBoolean.fromJS(resultData200) : new ResponseDtoOfBoolean();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseDtoOfBoolean>(<any>null);
    }

    /**
     * @param inputs (optional) 
     * @return Success
     */
    generateSerialOverview(inputs: SerialProducerGenerateInput[] | null | undefined): Observable<ResponseDtoOfListOfListOfSerialProducer> {
        let url_ = this.baseUrl + "/api/services/app/SerialProducer/GenerateSerialOverview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inputs);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGenerateSerialOverview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateSerialOverview(<any>response_);
                } catch (e) {
                    return <Observable<ResponseDtoOfListOfListOfSerialProducer>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResponseDtoOfListOfListOfSerialProducer>><any>_observableThrow(response_);
        }));
    }

    protected processGenerateSerialOverview(response: HttpResponseBase): Observable<ResponseDtoOfListOfListOfSerialProducer> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? ResponseDtoOfListOfListOfSerialProducer.fromJS(resultData200) : new ResponseDtoOfListOfListOfSerialProducer();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseDtoOfListOfListOfSerialProducer>(<any>null);
    }

    /**
     * @return Success
     */
    isRoleManufacturer(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/SerialProducer/IsRoleManufacturer";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processIsRoleManufacturer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsRoleManufacturer(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processIsRoleManufacturer(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param massOrder (optional) 
     * @return Success
     */
    isDuplicateMasssOrder(massOrder: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/SerialProducer/IsDuplicateMasssOrder?";
        if (massOrder !== undefined)
            url_ += "massOrder=" + encodeURIComponent("" + massOrder) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processIsDuplicateMasssOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsDuplicateMasssOrder(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processIsDuplicateMasssOrder(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    generateActiveCodeOverview(input: ActivationCodeGenerateInput | null | undefined): Observable<ResponseDtoOfListOfListOfSerialProducer> {
        let url_ = this.baseUrl + "/api/services/app/SerialProducer/GenerateActiveCodeOverview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGenerateActiveCodeOverview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateActiveCodeOverview(<any>response_);
                } catch (e) {
                    return <Observable<ResponseDtoOfListOfListOfSerialProducer>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResponseDtoOfListOfListOfSerialProducer>><any>_observableThrow(response_);
        }));
    }

    protected processGenerateActiveCodeOverview(response: HttpResponseBase): Observable<ResponseDtoOfListOfListOfSerialProducer> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? ResponseDtoOfListOfListOfSerialProducer.fromJS(resultData200) : new ResponseDtoOfListOfListOfSerialProducer();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseDtoOfListOfListOfSerialProducer>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    generateActiveCode(input: ActivationCodeGenerateInput | null | undefined): Observable<ResponseDtoOfBoolean> {
        let url_ = this.baseUrl + "/api/services/app/SerialProducer/GenerateActiveCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGenerateActiveCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateActiveCode(<any>response_);
                } catch (e) {
                    return <Observable<ResponseDtoOfBoolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResponseDtoOfBoolean>><any>_observableThrow(response_);
        }));
    }

    protected processGenerateActiveCode(response: HttpResponseBase): Observable<ResponseDtoOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? ResponseDtoOfBoolean.fromJS(resultData200) : new ResponseDtoOfBoolean();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseDtoOfBoolean>(<any>null);
    }

    /**
     * @param fileName (optional) 
     * @return Success
     */
    exportTemplate(fileName: string | null | undefined): Observable<SocialRetailerFileDto> {
        let url_ = this.baseUrl + "/api/services/app/SerialProducer/ExportTemplate?";
        if (fileName !== undefined)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processExportTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportTemplate(<any>response_);
                } catch (e) {
                    return <Observable<SocialRetailerFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SocialRetailerFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processExportTemplate(response: HttpResponseBase): Observable<SocialRetailerFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? SocialRetailerFileDto.fromJS(resultData200) : new SocialRetailerFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SocialRetailerFileDto>(<any>null);
    }

    /**
     * @param arg (optional) 
     * @return Success
     */
    importQueue(arg: CommonImportAgrs | null | undefined): Observable<StatusImportDistributeDto> {
        let url_ = this.baseUrl + "/api/services/app/SerialProducer/ImportQueue";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(arg);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processImportQueue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportQueue(<any>response_);
                } catch (e) {
                    return <Observable<StatusImportDistributeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<StatusImportDistributeDto>><any>_observableThrow(response_);
        }));
    }

    protected processImportQueue(response: HttpResponseBase): Observable<StatusImportDistributeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? StatusImportDistributeDto.fromJS(resultData200) : new StatusImportDistributeDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StatusImportDistributeDto>(<any>null);
    }
}

@Injectable()
export class SerialProducerScanServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param keyword (optional) 
     * @param status (optional) 
     * @param toDate (optional) 
     * @param fromDate (optional) 
     * @param manufacturer (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, status: string | null | undefined, toDate: moment.Moment | null | undefined, fromDate: moment.Moment | null | undefined, manufacturer: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfScanLogResponseDto> {
        let url_ = this.baseUrl + "/api/services/app/SerialProducerScan/GetAll?";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (status !== undefined)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toJSON() : "") + "&";
        if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toJSON() : "") + "&";
        if (manufacturer !== undefined)
            url_ += "Manufacturer=" + encodeURIComponent("" + manufacturer) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfScanLogResponseDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfScanLogResponseDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfScanLogResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfScanLogResponseDto.fromJS(resultData200) : new PagedResultDtoOfScanLogResponseDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfScanLogResponseDto>(<any>null);
    }

    /**
     * @param keyword (optional) 
     * @param status (optional) 
     * @param toDate (optional) 
     * @param fromDate (optional) 
     * @param manufacturer (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    exportExcel(keyword: string | null | undefined, status: string | null | undefined, toDate: moment.Moment | null | undefined, fromDate: moment.Moment | null | undefined, manufacturer: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SerialProducerScan/ExportExcel?";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (status !== undefined)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toJSON() : "") + "&";
        if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toJSON() : "") + "&";
        if (manufacturer !== undefined)
            url_ += "Manufacturer=" + encodeURIComponent("" + manufacturer) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processExportExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportExcel(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processExportExcel(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    scan(input: ScanLogCheckInput | null | undefined): Observable<ResponseDtoOfScanLogScanResponseDto> {
        let url_ = this.baseUrl + "/api/services/app/SerialProducerScan/Scan";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processScan(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processScan(<any>response_);
                } catch (e) {
                    return <Observable<ResponseDtoOfScanLogScanResponseDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResponseDtoOfScanLogScanResponseDto>><any>_observableThrow(response_);
        }));
    }

    protected processScan(response: HttpResponseBase): Observable<ResponseDtoOfScanLogScanResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? ResponseDtoOfScanLogScanResponseDto.fromJS(resultData200) : new ResponseDtoOfScanLogScanResponseDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseDtoOfScanLogScanResponseDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    insert(input: ScanLogInput | null | undefined): Observable<ResponseDtoOfBoolean> {
        let url_ = this.baseUrl + "/api/services/app/SerialProducerScan/Insert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processInsert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInsert(<any>response_);
                } catch (e) {
                    return <Observable<ResponseDtoOfBoolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResponseDtoOfBoolean>><any>_observableThrow(response_);
        }));
    }

    protected processInsert(response: HttpResponseBase): Observable<ResponseDtoOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? ResponseDtoOfBoolean.fromJS(resultData200) : new ResponseDtoOfBoolean();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResponseDtoOfBoolean>(<any>null);
    }
}

@Injectable()
export class SerialTypeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    getListChangeHistory(input: GetChangeHistoryInput | null | undefined): Observable<PagedResultDtoOfGetChangeHistoryForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/SerialType/GetListChangeHistory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetListChangeHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetListChangeHistory(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetChangeHistoryForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetChangeHistoryForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetListChangeHistory(response: HttpResponseBase): Observable<PagedResultDtoOfGetChangeHistoryForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetChangeHistoryForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetChangeHistoryForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetChangeHistoryForViewDto>(<any>null);
    }

    /**
     * @param arg (optional) 
     * @return Success
     */
    importQueue(arg: CommonImportAgrs | null | undefined): Observable<StatusImportDistributeDto> {
        let url_ = this.baseUrl + "/api/services/app/SerialType/ImportQueue";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(arg);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processImportQueue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportQueue(<any>response_);
                } catch (e) {
                    return <Observable<StatusImportDistributeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<StatusImportDistributeDto>><any>_observableThrow(response_);
        }));
    }

    protected processImportQueue(response: HttpResponseBase): Observable<StatusImportDistributeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? StatusImportDistributeDto.fromJS(resultData200) : new StatusImportDistributeDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StatusImportDistributeDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    updateSerialType(input: UpdateSerialTypeRequest | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SerialType/UpdateSerialType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateSerialType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSerialType(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateSerialType(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param docNum (optional) 
     * @param referFrom (optional) 
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param serial (optional) 
     * @param model (optional) 
     * @param serialType (optional) 
     * @param salemanCode (optional) 
     * @param plant (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getFileExcelHistory(docNum: string | null | undefined, referFrom: string | null | undefined, fromDate: moment.Moment | null | undefined, toDate: moment.Moment | null | undefined, serial: string | null | undefined, model: string | null | undefined, serialType: string | null | undefined, salemanCode: string | null | undefined, plant: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<SocialRetailerFileDto> {
        let url_ = this.baseUrl + "/api/services/app/SerialType/GetFileExcelHistory?";
        if (docNum !== undefined)
            url_ += "DocNum=" + encodeURIComponent("" + docNum) + "&";
        if (referFrom !== undefined)
            url_ += "ReferFrom=" + encodeURIComponent("" + referFrom) + "&";
        if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toJSON() : "") + "&";
        if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toJSON() : "") + "&";
        if (serial !== undefined)
            url_ += "Serial=" + encodeURIComponent("" + serial) + "&";
        if (model !== undefined)
            url_ += "Model=" + encodeURIComponent("" + model) + "&";
        if (serialType !== undefined)
            url_ += "SerialType=" + encodeURIComponent("" + serialType) + "&";
        if (salemanCode !== undefined)
            url_ += "SalemanCode=" + encodeURIComponent("" + salemanCode) + "&";
        if (plant !== undefined)
            url_ += "Plant=" + encodeURIComponent("" + plant) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetFileExcelHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFileExcelHistory(<any>response_);
                } catch (e) {
                    return <Observable<SocialRetailerFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SocialRetailerFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetFileExcelHistory(response: HttpResponseBase): Observable<SocialRetailerFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? SocialRetailerFileDto.fromJS(resultData200) : new SocialRetailerFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SocialRetailerFileDto>(<any>null);
    }
}

@Injectable()
export class SessionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getCurrentLoginInformations(): Observable<GetCurrentLoginInformationsOutput> {
        let url_ = this.baseUrl + "/api/services/app/Session/GetCurrentLoginInformations";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCurrentLoginInformations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentLoginInformations(<any>response_);
                } catch (e) {
                    return <Observable<GetCurrentLoginInformationsOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetCurrentLoginInformationsOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetCurrentLoginInformations(response: HttpResponseBase): Observable<GetCurrentLoginInformationsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetCurrentLoginInformationsOutput.fromJS(resultData200) : new GetCurrentLoginInformationsOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCurrentLoginInformationsOutput>(<any>null);
    }

    /**
     * @return Success
     */
    updateUserSignInToken(): Observable<UpdateUserSignInTokenOutput> {
        let url_ = this.baseUrl + "/api/services/app/Session/UpdateUserSignInToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateUserSignInToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUserSignInToken(<any>response_);
                } catch (e) {
                    return <Observable<UpdateUserSignInTokenOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<UpdateUserSignInTokenOutput>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateUserSignInToken(response: HttpResponseBase): Observable<UpdateUserSignInTokenOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? UpdateUserSignInTokenOutput.fromJS(resultData200) : new UpdateUserSignInTokenOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateUserSignInTokenOutput>(<any>null);
    }
}

@Injectable()
export class SettingParamFieldsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetSettingParamFieldForView> {
        let url_ = this.baseUrl + "/api/services/app/SettingParamFields/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetSettingParamFieldForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetSettingParamFieldForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetSettingParamFieldForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetSettingParamFieldForView.fromJS(resultData200) : new PagedResultDtoOfGetSettingParamFieldForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetSettingParamFieldForView>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getSettingParamFieldForEdit(id: number | null | undefined): Observable<GetSettingParamFieldForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/SettingParamFields/GetSettingParamFieldForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSettingParamFieldForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSettingParamFieldForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetSettingParamFieldForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetSettingParamFieldForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetSettingParamFieldForEdit(response: HttpResponseBase): Observable<GetSettingParamFieldForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetSettingParamFieldForEditOutput.fromJS(resultData200) : new GetSettingParamFieldForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSettingParamFieldForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditSettingParamFieldDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SettingParamFields/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SettingParamFields/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param code (optional) 
     * @param targetAudienceId (optional) 
     * @param type (optional) 
     * @param fullValue (optional) 
     * @param value (optional) 
     * @param fullValueName (optional) 
     * @param level (optional) 
     * @param id (optional) 
     * @return Success
     */
    getFullValueNameFromFullValueCode(code: string | null | undefined, targetAudienceId: number | null | undefined, type: string | null | undefined, fullValue: string | null | undefined, value: string | null | undefined, fullValueName: string | null | undefined, level: string | null | undefined, id: number | null | undefined): Observable<SettingParamFieldDto> {
        let url_ = this.baseUrl + "/api/services/app/SettingParamFields/GetFullValueNameFromFullValueCode?";
        if (code !== undefined)
            url_ += "Code=" + encodeURIComponent("" + code) + "&";
        if (targetAudienceId !== undefined)
            url_ += "TargetAudienceId=" + encodeURIComponent("" + targetAudienceId) + "&";
        if (type !== undefined)
            url_ += "Type=" + encodeURIComponent("" + type) + "&";
        if (fullValue !== undefined)
            url_ += "FullValue=" + encodeURIComponent("" + fullValue) + "&";
        if (value !== undefined)
            url_ += "Value=" + encodeURIComponent("" + value) + "&";
        if (fullValueName !== undefined)
            url_ += "FullValueName=" + encodeURIComponent("" + fullValueName) + "&";
        if (level !== undefined)
            url_ += "Level=" + encodeURIComponent("" + level) + "&";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetFullValueNameFromFullValueCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFullValueNameFromFullValueCode(<any>response_);
                } catch (e) {
                    return <Observable<SettingParamFieldDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SettingParamFieldDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetFullValueNameFromFullValueCode(response: HttpResponseBase): Observable<SettingParamFieldDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? SettingParamFieldDto.fromJS(resultData200) : new SettingParamFieldDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SettingParamFieldDto>(<any>null);
    }
}

@Injectable()
export class SettingParamsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param codeFilter (optional) 
     * @param nameFilter (optional) 
     * @param isActiveFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, codeFilter: string | null | undefined, nameFilter: string | null | undefined, isActiveFilter: number | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetSettingParamForView> {
        let url_ = this.baseUrl + "/api/services/app/SettingParams/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&";
        if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (isActiveFilter !== undefined)
            url_ += "IsActiveFilter=" + encodeURIComponent("" + isActiveFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetSettingParamForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetSettingParamForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetSettingParamForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetSettingParamForView.fromJS(resultData200) : new PagedResultDtoOfGetSettingParamForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetSettingParamForView>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getSettingParamForEdit(id: number | null | undefined): Observable<GetSettingParamForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/SettingParams/GetSettingParamForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSettingParamForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSettingParamForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetSettingParamForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetSettingParamForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetSettingParamForEdit(response: HttpResponseBase): Observable<GetSettingParamForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetSettingParamForEditOutput.fromJS(resultData200) : new GetSettingParamForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSettingParamForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditSettingParamDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SettingParams/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SettingParams/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class ShopperInfosServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param memberCodeFilter (optional) 
     * @param nameFilter (optional) 
     * @param phoneFilter (optional) 
     * @param emailFilter (optional) 
     * @param genderFilter (optional) 
     * @param maxBirthdayFilter (optional) 
     * @param minBirthdayFilter (optional) 
     * @param maxRegistrationDateFilter (optional) 
     * @param minRegistrationDateFilter (optional) 
     * @param pIDFilter (optional) 
     * @param receiveAdsFilter (optional) 
     * @param rankCodeFilter (optional) 
     * @param maxRankValidDateFilter (optional) 
     * @param minRankValidDateFilter (optional) 
     * @param maxCurrentPointFilter (optional) 
     * @param minCurrentPointFilter (optional) 
     * @param nationalityCodeFilter (optional) 
     * @param addressFilter (optional) 
     * @param wardFilter (optional) 
     * @param districtFilter (optional) 
     * @param provinceFilter (optional) 
     * @param countryFilter (optional) 
     * @param statusFilter (optional) 
     * @param communicationChannelsFilter (optional) 
     * @param communicationLanguageFilter (optional) 
     * @param notesFilter (optional) 
     * @param rankProposeFilter (optional) 
     * @param pINCodeFilter (optional) 
     * @param nameUnSignFilter (optional) 
     * @param avatarFilter (optional) 
     * @param memberCardFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, memberCodeFilter: string | null | undefined, nameFilter: string | null | undefined, phoneFilter: string | null | undefined, emailFilter: string | null | undefined, genderFilter: string | null | undefined, maxBirthdayFilter: number | null | undefined, minBirthdayFilter: number | null | undefined, maxRegistrationDateFilter: number | null | undefined, minRegistrationDateFilter: number | null | undefined, pIDFilter: string | null | undefined, receiveAdsFilter: number | null | undefined, rankCodeFilter: string | null | undefined, maxRankValidDateFilter: number | null | undefined, minRankValidDateFilter: number | null | undefined, maxCurrentPointFilter: number | null | undefined, minCurrentPointFilter: number | null | undefined, nationalityCodeFilter: string | null | undefined, addressFilter: string | null | undefined, wardFilter: string | null | undefined, districtFilter: string | null | undefined, provinceFilter: string | null | undefined, countryFilter: string | null | undefined, statusFilter: string | null | undefined, communicationChannelsFilter: string | null | undefined, communicationLanguageFilter: string | null | undefined, notesFilter: string | null | undefined, rankProposeFilter: string | null | undefined, pINCodeFilter: string | null | undefined, nameUnSignFilter: string | null | undefined, avatarFilter: string | null | undefined, memberCardFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetShopperInfoForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/ShopperInfos/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (memberCodeFilter !== undefined)
            url_ += "MemberCodeFilter=" + encodeURIComponent("" + memberCodeFilter) + "&";
        if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (phoneFilter !== undefined)
            url_ += "PhoneFilter=" + encodeURIComponent("" + phoneFilter) + "&";
        if (emailFilter !== undefined)
            url_ += "EmailFilter=" + encodeURIComponent("" + emailFilter) + "&";
        if (genderFilter !== undefined)
            url_ += "GenderFilter=" + encodeURIComponent("" + genderFilter) + "&";
        if (maxBirthdayFilter !== undefined)
            url_ += "MaxBirthdayFilter=" + encodeURIComponent("" + maxBirthdayFilter) + "&";
        if (minBirthdayFilter !== undefined)
            url_ += "MinBirthdayFilter=" + encodeURIComponent("" + minBirthdayFilter) + "&";
        if (maxRegistrationDateFilter !== undefined)
            url_ += "MaxRegistrationDateFilter=" + encodeURIComponent("" + maxRegistrationDateFilter) + "&";
        if (minRegistrationDateFilter !== undefined)
            url_ += "MinRegistrationDateFilter=" + encodeURIComponent("" + minRegistrationDateFilter) + "&";
        if (pIDFilter !== undefined)
            url_ += "PIDFilter=" + encodeURIComponent("" + pIDFilter) + "&";
        if (receiveAdsFilter !== undefined)
            url_ += "ReceiveAdsFilter=" + encodeURIComponent("" + receiveAdsFilter) + "&";
        if (rankCodeFilter !== undefined)
            url_ += "RankCodeFilter=" + encodeURIComponent("" + rankCodeFilter) + "&";
        if (maxRankValidDateFilter !== undefined)
            url_ += "MaxRankValidDateFilter=" + encodeURIComponent("" + maxRankValidDateFilter) + "&";
        if (minRankValidDateFilter !== undefined)
            url_ += "MinRankValidDateFilter=" + encodeURIComponent("" + minRankValidDateFilter) + "&";
        if (maxCurrentPointFilter !== undefined)
            url_ += "MaxCurrentPointFilter=" + encodeURIComponent("" + maxCurrentPointFilter) + "&";
        if (minCurrentPointFilter !== undefined)
            url_ += "MinCurrentPointFilter=" + encodeURIComponent("" + minCurrentPointFilter) + "&";
        if (nationalityCodeFilter !== undefined)
            url_ += "NationalityCodeFilter=" + encodeURIComponent("" + nationalityCodeFilter) + "&";
        if (addressFilter !== undefined)
            url_ += "AddressFilter=" + encodeURIComponent("" + addressFilter) + "&";
        if (wardFilter !== undefined)
            url_ += "WardFilter=" + encodeURIComponent("" + wardFilter) + "&";
        if (districtFilter !== undefined)
            url_ += "DistrictFilter=" + encodeURIComponent("" + districtFilter) + "&";
        if (provinceFilter !== undefined)
            url_ += "ProvinceFilter=" + encodeURIComponent("" + provinceFilter) + "&";
        if (countryFilter !== undefined)
            url_ += "CountryFilter=" + encodeURIComponent("" + countryFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (communicationChannelsFilter !== undefined)
            url_ += "CommunicationChannelsFilter=" + encodeURIComponent("" + communicationChannelsFilter) + "&";
        if (communicationLanguageFilter !== undefined)
            url_ += "CommunicationLanguageFilter=" + encodeURIComponent("" + communicationLanguageFilter) + "&";
        if (notesFilter !== undefined)
            url_ += "NotesFilter=" + encodeURIComponent("" + notesFilter) + "&";
        if (rankProposeFilter !== undefined)
            url_ += "RankProposeFilter=" + encodeURIComponent("" + rankProposeFilter) + "&";
        if (pINCodeFilter !== undefined)
            url_ += "PINCodeFilter=" + encodeURIComponent("" + pINCodeFilter) + "&";
        if (nameUnSignFilter !== undefined)
            url_ += "NameUnSignFilter=" + encodeURIComponent("" + nameUnSignFilter) + "&";
        if (avatarFilter !== undefined)
            url_ += "AvatarFilter=" + encodeURIComponent("" + avatarFilter) + "&";
        if (memberCardFilter !== undefined)
            url_ += "MemberCardFilter=" + encodeURIComponent("" + memberCardFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetShopperInfoForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetShopperInfoForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetShopperInfoForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetShopperInfoForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetShopperInfoForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetShopperInfoForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getShopperInfoForEdit(id: number | null | undefined): Observable<GetShopperInfoForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/ShopperInfos/GetShopperInfoForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetShopperInfoForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetShopperInfoForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetShopperInfoForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetShopperInfoForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetShopperInfoForEdit(response: HttpResponseBase): Observable<GetShopperInfoForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetShopperInfoForEditOutput.fromJS(resultData200) : new GetShopperInfoForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetShopperInfoForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditShopperInfoDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ShopperInfos/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ShopperInfos/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param memberCodeFilter (optional) 
     * @param nameFilter (optional) 
     * @param phoneFilter (optional) 
     * @param emailFilter (optional) 
     * @param genderFilter (optional) 
     * @param maxBirthdayFilter (optional) 
     * @param minBirthdayFilter (optional) 
     * @param maxRegistrationDateFilter (optional) 
     * @param minRegistrationDateFilter (optional) 
     * @param pIDFilter (optional) 
     * @param receiveAdsFilter (optional) 
     * @param rankCodeFilter (optional) 
     * @param maxRankValidDateFilter (optional) 
     * @param minRankValidDateFilter (optional) 
     * @param maxCurrentPointFilter (optional) 
     * @param minCurrentPointFilter (optional) 
     * @param nationalityCodeFilter (optional) 
     * @param addressFilter (optional) 
     * @param wardFilter (optional) 
     * @param districtFilter (optional) 
     * @param provinceFilter (optional) 
     * @param countryFilter (optional) 
     * @param statusFilter (optional) 
     * @param communicationChannelsFilter (optional) 
     * @param communicationLanguageFilter (optional) 
     * @param notesFilter (optional) 
     * @param rankProposeFilter (optional) 
     * @param pINCodeFilter (optional) 
     * @param nameUnSignFilter (optional) 
     * @param avatarFilter (optional) 
     * @param memberCardFilter (optional) 
     * @return Success
     */
    getShopperInfosToExcel(filter: string | null | undefined, memberCodeFilter: string | null | undefined, nameFilter: string | null | undefined, phoneFilter: string | null | undefined, emailFilter: string | null | undefined, genderFilter: string | null | undefined, maxBirthdayFilter: number | null | undefined, minBirthdayFilter: number | null | undefined, maxRegistrationDateFilter: number | null | undefined, minRegistrationDateFilter: number | null | undefined, pIDFilter: string | null | undefined, receiveAdsFilter: number | null | undefined, rankCodeFilter: string | null | undefined, maxRankValidDateFilter: number | null | undefined, minRankValidDateFilter: number | null | undefined, maxCurrentPointFilter: number | null | undefined, minCurrentPointFilter: number | null | undefined, nationalityCodeFilter: string | null | undefined, addressFilter: string | null | undefined, wardFilter: string | null | undefined, districtFilter: string | null | undefined, provinceFilter: string | null | undefined, countryFilter: string | null | undefined, statusFilter: string | null | undefined, communicationChannelsFilter: string | null | undefined, communicationLanguageFilter: string | null | undefined, notesFilter: string | null | undefined, rankProposeFilter: string | null | undefined, pINCodeFilter: string | null | undefined, nameUnSignFilter: string | null | undefined, avatarFilter: string | null | undefined, memberCardFilter: string | null | undefined): Observable<SocialShopperFileDto> {
        let url_ = this.baseUrl + "/api/services/app/ShopperInfos/GetShopperInfosToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (memberCodeFilter !== undefined)
            url_ += "MemberCodeFilter=" + encodeURIComponent("" + memberCodeFilter) + "&";
        if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (phoneFilter !== undefined)
            url_ += "PhoneFilter=" + encodeURIComponent("" + phoneFilter) + "&";
        if (emailFilter !== undefined)
            url_ += "EmailFilter=" + encodeURIComponent("" + emailFilter) + "&";
        if (genderFilter !== undefined)
            url_ += "GenderFilter=" + encodeURIComponent("" + genderFilter) + "&";
        if (maxBirthdayFilter !== undefined)
            url_ += "MaxBirthdayFilter=" + encodeURIComponent("" + maxBirthdayFilter) + "&";
        if (minBirthdayFilter !== undefined)
            url_ += "MinBirthdayFilter=" + encodeURIComponent("" + minBirthdayFilter) + "&";
        if (maxRegistrationDateFilter !== undefined)
            url_ += "MaxRegistrationDateFilter=" + encodeURIComponent("" + maxRegistrationDateFilter) + "&";
        if (minRegistrationDateFilter !== undefined)
            url_ += "MinRegistrationDateFilter=" + encodeURIComponent("" + minRegistrationDateFilter) + "&";
        if (pIDFilter !== undefined)
            url_ += "PIDFilter=" + encodeURIComponent("" + pIDFilter) + "&";
        if (receiveAdsFilter !== undefined)
            url_ += "ReceiveAdsFilter=" + encodeURIComponent("" + receiveAdsFilter) + "&";
        if (rankCodeFilter !== undefined)
            url_ += "RankCodeFilter=" + encodeURIComponent("" + rankCodeFilter) + "&";
        if (maxRankValidDateFilter !== undefined)
            url_ += "MaxRankValidDateFilter=" + encodeURIComponent("" + maxRankValidDateFilter) + "&";
        if (minRankValidDateFilter !== undefined)
            url_ += "MinRankValidDateFilter=" + encodeURIComponent("" + minRankValidDateFilter) + "&";
        if (maxCurrentPointFilter !== undefined)
            url_ += "MaxCurrentPointFilter=" + encodeURIComponent("" + maxCurrentPointFilter) + "&";
        if (minCurrentPointFilter !== undefined)
            url_ += "MinCurrentPointFilter=" + encodeURIComponent("" + minCurrentPointFilter) + "&";
        if (nationalityCodeFilter !== undefined)
            url_ += "NationalityCodeFilter=" + encodeURIComponent("" + nationalityCodeFilter) + "&";
        if (addressFilter !== undefined)
            url_ += "AddressFilter=" + encodeURIComponent("" + addressFilter) + "&";
        if (wardFilter !== undefined)
            url_ += "WardFilter=" + encodeURIComponent("" + wardFilter) + "&";
        if (districtFilter !== undefined)
            url_ += "DistrictFilter=" + encodeURIComponent("" + districtFilter) + "&";
        if (provinceFilter !== undefined)
            url_ += "ProvinceFilter=" + encodeURIComponent("" + provinceFilter) + "&";
        if (countryFilter !== undefined)
            url_ += "CountryFilter=" + encodeURIComponent("" + countryFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (communicationChannelsFilter !== undefined)
            url_ += "CommunicationChannelsFilter=" + encodeURIComponent("" + communicationChannelsFilter) + "&";
        if (communicationLanguageFilter !== undefined)
            url_ += "CommunicationLanguageFilter=" + encodeURIComponent("" + communicationLanguageFilter) + "&";
        if (notesFilter !== undefined)
            url_ += "NotesFilter=" + encodeURIComponent("" + notesFilter) + "&";
        if (rankProposeFilter !== undefined)
            url_ += "RankProposeFilter=" + encodeURIComponent("" + rankProposeFilter) + "&";
        if (pINCodeFilter !== undefined)
            url_ += "PINCodeFilter=" + encodeURIComponent("" + pINCodeFilter) + "&";
        if (nameUnSignFilter !== undefined)
            url_ += "NameUnSignFilter=" + encodeURIComponent("" + nameUnSignFilter) + "&";
        if (avatarFilter !== undefined)
            url_ += "AvatarFilter=" + encodeURIComponent("" + avatarFilter) + "&";
        if (memberCardFilter !== undefined)
            url_ += "MemberCardFilter=" + encodeURIComponent("" + memberCardFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetShopperInfosToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetShopperInfosToExcel(<any>response_);
                } catch (e) {
                    return <Observable<SocialShopperFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SocialShopperFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetShopperInfosToExcel(response: HttpResponseBase): Observable<SocialShopperFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? SocialShopperFileDto.fromJS(resultData200) : new SocialShopperFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SocialShopperFileDto>(<any>null);
    }
}

@Injectable()
export class ShopperInfosExcelExporterServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param shopperInfos (optional) 
     * @return Success
     */
    exportToFile(shopperInfos: GetShopperInfoForViewDto[] | null | undefined): Observable<SocialShopperFileDto> {
        let url_ = this.baseUrl + "/api/services/app/ShopperInfosExcelExporter/ExportToFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(shopperInfos);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processExportToFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportToFile(<any>response_);
                } catch (e) {
                    return <Observable<SocialShopperFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SocialShopperFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processExportToFile(response: HttpResponseBase): Observable<SocialShopperFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? SocialShopperFileDto.fromJS(resultData200) : new SocialShopperFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SocialShopperFileDto>(<any>null);
    }
}

@Injectable()
export class SocialMessagesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param retailerCodeFilter (optional) 
     * @param fromUserIDFilter (optional) 
     * @param contentFilter (optional) 
     * @param statusFilter (optional) 
     * @param messageTypeFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, retailerCodeFilter: string | null | undefined, fromUserIDFilter: string | null | undefined, contentFilter: string | null | undefined, statusFilter: string | null | undefined, messageTypeFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetSocialMessageForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/SocialMessages/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (retailerCodeFilter !== undefined)
            url_ += "RetailerCodeFilter=" + encodeURIComponent("" + retailerCodeFilter) + "&";
        if (fromUserIDFilter !== undefined)
            url_ += "FromUserIDFilter=" + encodeURIComponent("" + fromUserIDFilter) + "&";
        if (contentFilter !== undefined)
            url_ += "ContentFilter=" + encodeURIComponent("" + contentFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (messageTypeFilter !== undefined)
            url_ += "MessageTypeFilter=" + encodeURIComponent("" + messageTypeFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetSocialMessageForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetSocialMessageForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetSocialMessageForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetSocialMessageForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetSocialMessageForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetSocialMessageForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getSocialMessageForEdit(id: number | null | undefined): Observable<GetSocialMessageForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/SocialMessages/GetSocialMessageForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSocialMessageForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSocialMessageForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetSocialMessageForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetSocialMessageForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetSocialMessageForEdit(response: HttpResponseBase): Observable<GetSocialMessageForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetSocialMessageForEditOutput.fromJS(resultData200) : new GetSocialMessageForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSocialMessageForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditSocialMessageDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SocialMessages/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SocialMessages/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param retailerCodeFilter (optional) 
     * @param fromUserIDFilter (optional) 
     * @param contentFilter (optional) 
     * @param statusFilter (optional) 
     * @param messageTypeFilter (optional) 
     * @return Success
     */
    getSocialMessagesToExcel(filter: string | null | undefined, retailerCodeFilter: string | null | undefined, fromUserIDFilter: string | null | undefined, contentFilter: string | null | undefined, statusFilter: string | null | undefined, messageTypeFilter: string | null | undefined): Observable<SocialRetailerFileDto> {
        let url_ = this.baseUrl + "/api/services/app/SocialMessages/GetSocialMessagesToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (retailerCodeFilter !== undefined)
            url_ += "RetailerCodeFilter=" + encodeURIComponent("" + retailerCodeFilter) + "&";
        if (fromUserIDFilter !== undefined)
            url_ += "FromUserIDFilter=" + encodeURIComponent("" + fromUserIDFilter) + "&";
        if (contentFilter !== undefined)
            url_ += "ContentFilter=" + encodeURIComponent("" + contentFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (messageTypeFilter !== undefined)
            url_ += "MessageTypeFilter=" + encodeURIComponent("" + messageTypeFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSocialMessagesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSocialMessagesToExcel(<any>response_);
                } catch (e) {
                    return <Observable<SocialRetailerFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SocialRetailerFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetSocialMessagesToExcel(response: HttpResponseBase): Observable<SocialRetailerFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? SocialRetailerFileDto.fromJS(resultData200) : new SocialRetailerFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SocialRetailerFileDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEditMessages(input: CreateOrEditSocialMessageDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SocialMessages/CreateOrEditMessages";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEditMessages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditMessages(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEditMessages(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    search(input: GetAllSocialMessagesInput | null | undefined): Observable<PagedResultDtoOfSocialMessageForView> {
        let url_ = this.baseUrl + "/api/services/app/SocialMessages/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfSocialMessageForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfSocialMessageForView>><any>_observableThrow(response_);
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<PagedResultDtoOfSocialMessageForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfSocialMessageForView.fromJS(resultData200) : new PagedResultDtoOfSocialMessageForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfSocialMessageForView>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    showAllMessageAsync(input: GetMessagesInput | null | undefined): Observable<PagedResultDtoOfMessageDto> {
        let url_ = this.baseUrl + "/api/services/app/SocialMessages/ShowAllMessageAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processShowAllMessageAsync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processShowAllMessageAsync(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfMessageDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfMessageDto>><any>_observableThrow(response_);
        }));
    }

    protected processShowAllMessageAsync(response: HttpResponseBase): Observable<PagedResultDtoOfMessageDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfMessageDto.fromJS(resultData200) : new PagedResultDtoOfMessageDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfMessageDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    showInfoOutlet(input: GetMessagesInput | null | undefined): Observable<CreateOrEditOutletInfoDto> {
        let url_ = this.baseUrl + "/api/services/app/SocialMessages/ShowInfoOutlet";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processShowInfoOutlet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processShowInfoOutlet(<any>response_);
                } catch (e) {
                    return <Observable<CreateOrEditOutletInfoDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CreateOrEditOutletInfoDto>><any>_observableThrow(response_);
        }));
    }

    protected processShowInfoOutlet(response: HttpResponseBase): Observable<CreateOrEditOutletInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? CreateOrEditOutletInfoDto.fromJS(resultData200) : new CreateOrEditOutletInfoDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateOrEditOutletInfoDto>(<any>null);
    }

    /**
     * @param outletcode (optional) 
     * @param id (optional) 
     * @return Success
     */
    updateStatusMessage(outletcode: string | null | undefined, id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SocialMessages/UpdateStatusMessage?";
        if (outletcode !== undefined)
            url_ += "outletcode=" + encodeURIComponent("" + outletcode) + "&";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateStatusMessage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateStatusMessage(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateStatusMessage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class SocialSurveyAnswersServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param questionCodeFilter (optional) 
     * @param contentFilter (optional) 
     * @param imageLinkFilter (optional) 
     * @param surveyCodeFilter (optional) 
     * @param answerCodeFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, questionCodeFilter: string | null | undefined, contentFilter: string | null | undefined, imageLinkFilter: string | null | undefined, surveyCodeFilter: string | null | undefined, answerCodeFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetSocialSurveyAnswerForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/SocialSurveyAnswers/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (questionCodeFilter !== undefined)
            url_ += "QuestionCodeFilter=" + encodeURIComponent("" + questionCodeFilter) + "&";
        if (contentFilter !== undefined)
            url_ += "ContentFilter=" + encodeURIComponent("" + contentFilter) + "&";
        if (imageLinkFilter !== undefined)
            url_ += "ImageLinkFilter=" + encodeURIComponent("" + imageLinkFilter) + "&";
        if (surveyCodeFilter !== undefined)
            url_ += "SurveyCodeFilter=" + encodeURIComponent("" + surveyCodeFilter) + "&";
        if (answerCodeFilter !== undefined)
            url_ += "AnswerCodeFilter=" + encodeURIComponent("" + answerCodeFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetSocialSurveyAnswerForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetSocialSurveyAnswerForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetSocialSurveyAnswerForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetSocialSurveyAnswerForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetSocialSurveyAnswerForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetSocialSurveyAnswerForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getSurveyAnswerForEdit(id: number | null | undefined): Observable<GetSocialSurveyAnswerForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/SocialSurveyAnswers/GetSurveyAnswerForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSurveyAnswerForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSurveyAnswerForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetSocialSurveyAnswerForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetSocialSurveyAnswerForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetSurveyAnswerForEdit(response: HttpResponseBase): Observable<GetSocialSurveyAnswerForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetSocialSurveyAnswerForEditOutput.fromJS(resultData200) : new GetSocialSurveyAnswerForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSocialSurveyAnswerForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditSocialSurveyAnswerDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SocialSurveyAnswers/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SocialSurveyAnswers/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param questionCodeFilter (optional) 
     * @param contentFilter (optional) 
     * @param imageLinkFilter (optional) 
     * @param surveyCodeFilter (optional) 
     * @param answerCodeFilter (optional) 
     * @return Success
     */
    getSurveyAnswersToExcel(filter: string | null | undefined, questionCodeFilter: string | null | undefined, contentFilter: string | null | undefined, imageLinkFilter: string | null | undefined, surveyCodeFilter: string | null | undefined, answerCodeFilter: string | null | undefined): Observable<SocialSurveyFileDto> {
        let url_ = this.baseUrl + "/api/services/app/SocialSurveyAnswers/GetSurveyAnswersToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (questionCodeFilter !== undefined)
            url_ += "QuestionCodeFilter=" + encodeURIComponent("" + questionCodeFilter) + "&";
        if (contentFilter !== undefined)
            url_ += "ContentFilter=" + encodeURIComponent("" + contentFilter) + "&";
        if (imageLinkFilter !== undefined)
            url_ += "ImageLinkFilter=" + encodeURIComponent("" + imageLinkFilter) + "&";
        if (surveyCodeFilter !== undefined)
            url_ += "SurveyCodeFilter=" + encodeURIComponent("" + surveyCodeFilter) + "&";
        if (answerCodeFilter !== undefined)
            url_ += "AnswerCodeFilter=" + encodeURIComponent("" + answerCodeFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSurveyAnswersToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSurveyAnswersToExcel(<any>response_);
                } catch (e) {
                    return <Observable<SocialSurveyFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SocialSurveyFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetSurveyAnswersToExcel(response: HttpResponseBase): Observable<SocialSurveyFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? SocialSurveyFileDto.fromJS(resultData200) : new SocialSurveyFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SocialSurveyFileDto>(<any>null);
    }
}

@Injectable()
export class SocialSurveyInfosServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param codeFilter (optional) 
     * @param nameFilter (optional) 
     * @param statusFilter (optional) 
     * @param maxTargetAudienceIDFilter (optional) 
     * @param minTargetAudienceIDFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param imageLinkFilter (optional) 
     * @param isImmediatelyFilter (optional) 
     * @param maxEffectiveFromFilter (optional) 
     * @param minEffectiveFromFilter (optional) 
     * @param maxEffectiveToFilter (optional) 
     * @param minEffectiveToFilter (optional) 
     * @param occurTypeFilter (optional) 
     * @param cronFilter (optional) 
     * @param maxPublishTimeFilter (optional) 
     * @param minPublishTimeFilter (optional) 
     * @param nameUnSignFilter (optional) 
     * @param targetAudienceTypeFilter (optional) 
     * @param maxReferenceIDFilter (optional) 
     * @param minReferenceIDFilter (optional) 
     * @param maxDelayTimeFilter (optional) 
     * @param minDelayTimeFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, codeFilter: string | null | undefined, nameFilter: string | null | undefined, statusFilter: string | null | undefined, maxTargetAudienceIDFilter: number | null | undefined, minTargetAudienceIDFilter: number | null | undefined, descriptionFilter: string | null | undefined, imageLinkFilter: string | null | undefined, isImmediatelyFilter: number | null | undefined, maxEffectiveFromFilter: moment.Moment | null | undefined, minEffectiveFromFilter: moment.Moment | null | undefined, maxEffectiveToFilter: moment.Moment | null | undefined, minEffectiveToFilter: moment.Moment | null | undefined, occurTypeFilter: string | null | undefined, cronFilter: string | null | undefined, maxPublishTimeFilter: moment.Moment | null | undefined, minPublishTimeFilter: moment.Moment | null | undefined, nameUnSignFilter: string | null | undefined, targetAudienceTypeFilter: string | null | undefined, maxReferenceIDFilter: number | null | undefined, minReferenceIDFilter: number | null | undefined, maxDelayTimeFilter: number | null | undefined, minDelayTimeFilter: number | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetSocialSurveyInfoForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/SocialSurveyInfos/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&";
        if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (maxTargetAudienceIDFilter !== undefined)
            url_ += "MaxTargetAudienceIDFilter=" + encodeURIComponent("" + maxTargetAudienceIDFilter) + "&";
        if (minTargetAudienceIDFilter !== undefined)
            url_ += "MinTargetAudienceIDFilter=" + encodeURIComponent("" + minTargetAudienceIDFilter) + "&";
        if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&";
        if (imageLinkFilter !== undefined)
            url_ += "ImageLinkFilter=" + encodeURIComponent("" + imageLinkFilter) + "&";
        if (isImmediatelyFilter !== undefined)
            url_ += "IsImmediatelyFilter=" + encodeURIComponent("" + isImmediatelyFilter) + "&";
        if (maxEffectiveFromFilter !== undefined)
            url_ += "MaxEffectiveFromFilter=" + encodeURIComponent(maxEffectiveFromFilter ? "" + maxEffectiveFromFilter.toJSON() : "") + "&";
        if (minEffectiveFromFilter !== undefined)
            url_ += "MinEffectiveFromFilter=" + encodeURIComponent(minEffectiveFromFilter ? "" + minEffectiveFromFilter.toJSON() : "") + "&";
        if (maxEffectiveToFilter !== undefined)
            url_ += "MaxEffectiveToFilter=" + encodeURIComponent(maxEffectiveToFilter ? "" + maxEffectiveToFilter.toJSON() : "") + "&";
        if (minEffectiveToFilter !== undefined)
            url_ += "MinEffectiveToFilter=" + encodeURIComponent(minEffectiveToFilter ? "" + minEffectiveToFilter.toJSON() : "") + "&";
        if (occurTypeFilter !== undefined)
            url_ += "OccurTypeFilter=" + encodeURIComponent("" + occurTypeFilter) + "&";
        if (cronFilter !== undefined)
            url_ += "CronFilter=" + encodeURIComponent("" + cronFilter) + "&";
        if (maxPublishTimeFilter !== undefined)
            url_ += "MaxPublishTimeFilter=" + encodeURIComponent(maxPublishTimeFilter ? "" + maxPublishTimeFilter.toJSON() : "") + "&";
        if (minPublishTimeFilter !== undefined)
            url_ += "MinPublishTimeFilter=" + encodeURIComponent(minPublishTimeFilter ? "" + minPublishTimeFilter.toJSON() : "") + "&";
        if (nameUnSignFilter !== undefined)
            url_ += "NameUnSignFilter=" + encodeURIComponent("" + nameUnSignFilter) + "&";
        if (targetAudienceTypeFilter !== undefined)
            url_ += "TargetAudienceTypeFilter=" + encodeURIComponent("" + targetAudienceTypeFilter) + "&";
        if (maxReferenceIDFilter !== undefined)
            url_ += "MaxReferenceIDFilter=" + encodeURIComponent("" + maxReferenceIDFilter) + "&";
        if (minReferenceIDFilter !== undefined)
            url_ += "MinReferenceIDFilter=" + encodeURIComponent("" + minReferenceIDFilter) + "&";
        if (maxDelayTimeFilter !== undefined)
            url_ += "MaxDelayTimeFilter=" + encodeURIComponent("" + maxDelayTimeFilter) + "&";
        if (minDelayTimeFilter !== undefined)
            url_ += "MinDelayTimeFilter=" + encodeURIComponent("" + minDelayTimeFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetSocialSurveyInfoForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetSocialSurveyInfoForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetSocialSurveyInfoForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetSocialSurveyInfoForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetSocialSurveyInfoForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetSocialSurveyInfoForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getSurveyInfoForEdit(id: number | null | undefined): Observable<GetSocialSurveyInfoForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/SocialSurveyInfos/GetSurveyInfoForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSurveyInfoForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSurveyInfoForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetSocialSurveyInfoForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetSocialSurveyInfoForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetSurveyInfoForEdit(response: HttpResponseBase): Observable<GetSocialSurveyInfoForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetSocialSurveyInfoForEditOutput.fromJS(resultData200) : new GetSocialSurveyInfoForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSocialSurveyInfoForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditSocialSurveyInfoDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SocialSurveyInfos/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SocialSurveyInfos/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param codeFilter (optional) 
     * @param nameFilter (optional) 
     * @param statusFilter (optional) 
     * @param maxTargetAudienceIDFilter (optional) 
     * @param minTargetAudienceIDFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param imageLinkFilter (optional) 
     * @param isImmediatelyFilter (optional) 
     * @param maxEffectiveFromFilter (optional) 
     * @param minEffectiveFromFilter (optional) 
     * @param maxEffectiveToFilter (optional) 
     * @param minEffectiveToFilter (optional) 
     * @param occurTypeFilter (optional) 
     * @param cronFilter (optional) 
     * @param maxPublishTimeFilter (optional) 
     * @param minPublishTimeFilter (optional) 
     * @param nameUnSignFilter (optional) 
     * @param targetAudienceTypeFilter (optional) 
     * @return Success
     */
    getSurveyInfosToExcel(filter: string | null | undefined, codeFilter: string | null | undefined, nameFilter: string | null | undefined, statusFilter: string | null | undefined, maxTargetAudienceIDFilter: number | null | undefined, minTargetAudienceIDFilter: number | null | undefined, descriptionFilter: string | null | undefined, imageLinkFilter: string | null | undefined, isImmediatelyFilter: number | null | undefined, maxEffectiveFromFilter: moment.Moment | null | undefined, minEffectiveFromFilter: moment.Moment | null | undefined, maxEffectiveToFilter: moment.Moment | null | undefined, minEffectiveToFilter: moment.Moment | null | undefined, occurTypeFilter: string | null | undefined, cronFilter: string | null | undefined, maxPublishTimeFilter: moment.Moment | null | undefined, minPublishTimeFilter: moment.Moment | null | undefined, nameUnSignFilter: string | null | undefined, targetAudienceTypeFilter: string | null | undefined): Observable<SocialSurveyFileDto> {
        let url_ = this.baseUrl + "/api/services/app/SocialSurveyInfos/GetSurveyInfosToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&";
        if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (maxTargetAudienceIDFilter !== undefined)
            url_ += "MaxTargetAudienceIDFilter=" + encodeURIComponent("" + maxTargetAudienceIDFilter) + "&";
        if (minTargetAudienceIDFilter !== undefined)
            url_ += "MinTargetAudienceIDFilter=" + encodeURIComponent("" + minTargetAudienceIDFilter) + "&";
        if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&";
        if (imageLinkFilter !== undefined)
            url_ += "ImageLinkFilter=" + encodeURIComponent("" + imageLinkFilter) + "&";
        if (isImmediatelyFilter !== undefined)
            url_ += "IsImmediatelyFilter=" + encodeURIComponent("" + isImmediatelyFilter) + "&";
        if (maxEffectiveFromFilter !== undefined)
            url_ += "MaxEffectiveFromFilter=" + encodeURIComponent(maxEffectiveFromFilter ? "" + maxEffectiveFromFilter.toJSON() : "") + "&";
        if (minEffectiveFromFilter !== undefined)
            url_ += "MinEffectiveFromFilter=" + encodeURIComponent(minEffectiveFromFilter ? "" + minEffectiveFromFilter.toJSON() : "") + "&";
        if (maxEffectiveToFilter !== undefined)
            url_ += "MaxEffectiveToFilter=" + encodeURIComponent(maxEffectiveToFilter ? "" + maxEffectiveToFilter.toJSON() : "") + "&";
        if (minEffectiveToFilter !== undefined)
            url_ += "MinEffectiveToFilter=" + encodeURIComponent(minEffectiveToFilter ? "" + minEffectiveToFilter.toJSON() : "") + "&";
        if (occurTypeFilter !== undefined)
            url_ += "OccurTypeFilter=" + encodeURIComponent("" + occurTypeFilter) + "&";
        if (cronFilter !== undefined)
            url_ += "CronFilter=" + encodeURIComponent("" + cronFilter) + "&";
        if (maxPublishTimeFilter !== undefined)
            url_ += "MaxPublishTimeFilter=" + encodeURIComponent(maxPublishTimeFilter ? "" + maxPublishTimeFilter.toJSON() : "") + "&";
        if (minPublishTimeFilter !== undefined)
            url_ += "MinPublishTimeFilter=" + encodeURIComponent(minPublishTimeFilter ? "" + minPublishTimeFilter.toJSON() : "") + "&";
        if (nameUnSignFilter !== undefined)
            url_ += "NameUnSignFilter=" + encodeURIComponent("" + nameUnSignFilter) + "&";
        if (targetAudienceTypeFilter !== undefined)
            url_ += "TargetAudienceTypeFilter=" + encodeURIComponent("" + targetAudienceTypeFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSurveyInfosToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSurveyInfosToExcel(<any>response_);
                } catch (e) {
                    return <Observable<SocialSurveyFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SocialSurveyFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetSurveyInfosToExcel(response: HttpResponseBase): Observable<SocialSurveyFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? SocialSurveyFileDto.fromJS(resultData200) : new SocialSurveyFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SocialSurveyFileDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param codeFilter (optional) 
     * @param nameFilter (optional) 
     * @param statusFilter (optional) 
     * @param maxTargetAudienceIDFilter (optional) 
     * @param minTargetAudienceIDFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param imageLinkFilter (optional) 
     * @param isImmediatelyFilter (optional) 
     * @param maxEffectiveFromFilter (optional) 
     * @param minEffectiveFromFilter (optional) 
     * @param maxEffectiveToFilter (optional) 
     * @param minEffectiveToFilter (optional) 
     * @param occurTypeFilter (optional) 
     * @param cronFilter (optional) 
     * @param maxPublishTimeFilter (optional) 
     * @param minPublishTimeFilter (optional) 
     * @param nameUnSignFilter (optional) 
     * @param targetAudienceTypeFilter (optional) 
     * @param maxReferenceIDFilter (optional) 
     * @param minReferenceIDFilter (optional) 
     * @param maxDelayTimeFilter (optional) 
     * @param minDelayTimeFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllExt(filter: string | null | undefined, codeFilter: string | null | undefined, nameFilter: string | null | undefined, statusFilter: string | null | undefined, maxTargetAudienceIDFilter: number | null | undefined, minTargetAudienceIDFilter: number | null | undefined, descriptionFilter: string | null | undefined, imageLinkFilter: string | null | undefined, isImmediatelyFilter: number | null | undefined, maxEffectiveFromFilter: moment.Moment | null | undefined, minEffectiveFromFilter: moment.Moment | null | undefined, maxEffectiveToFilter: moment.Moment | null | undefined, minEffectiveToFilter: moment.Moment | null | undefined, occurTypeFilter: string | null | undefined, cronFilter: string | null | undefined, maxPublishTimeFilter: moment.Moment | null | undefined, minPublishTimeFilter: moment.Moment | null | undefined, nameUnSignFilter: string | null | undefined, targetAudienceTypeFilter: string | null | undefined, maxReferenceIDFilter: number | null | undefined, minReferenceIDFilter: number | null | undefined, maxDelayTimeFilter: number | null | undefined, minDelayTimeFilter: number | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetSocialSurveyInfoForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/SocialSurveyInfos/GetAllExt?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&";
        if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (maxTargetAudienceIDFilter !== undefined)
            url_ += "MaxTargetAudienceIDFilter=" + encodeURIComponent("" + maxTargetAudienceIDFilter) + "&";
        if (minTargetAudienceIDFilter !== undefined)
            url_ += "MinTargetAudienceIDFilter=" + encodeURIComponent("" + minTargetAudienceIDFilter) + "&";
        if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&";
        if (imageLinkFilter !== undefined)
            url_ += "ImageLinkFilter=" + encodeURIComponent("" + imageLinkFilter) + "&";
        if (isImmediatelyFilter !== undefined)
            url_ += "IsImmediatelyFilter=" + encodeURIComponent("" + isImmediatelyFilter) + "&";
        if (maxEffectiveFromFilter !== undefined)
            url_ += "MaxEffectiveFromFilter=" + encodeURIComponent(maxEffectiveFromFilter ? "" + maxEffectiveFromFilter.toJSON() : "") + "&";
        if (minEffectiveFromFilter !== undefined)
            url_ += "MinEffectiveFromFilter=" + encodeURIComponent(minEffectiveFromFilter ? "" + minEffectiveFromFilter.toJSON() : "") + "&";
        if (maxEffectiveToFilter !== undefined)
            url_ += "MaxEffectiveToFilter=" + encodeURIComponent(maxEffectiveToFilter ? "" + maxEffectiveToFilter.toJSON() : "") + "&";
        if (minEffectiveToFilter !== undefined)
            url_ += "MinEffectiveToFilter=" + encodeURIComponent(minEffectiveToFilter ? "" + minEffectiveToFilter.toJSON() : "") + "&";
        if (occurTypeFilter !== undefined)
            url_ += "OccurTypeFilter=" + encodeURIComponent("" + occurTypeFilter) + "&";
        if (cronFilter !== undefined)
            url_ += "CronFilter=" + encodeURIComponent("" + cronFilter) + "&";
        if (maxPublishTimeFilter !== undefined)
            url_ += "MaxPublishTimeFilter=" + encodeURIComponent(maxPublishTimeFilter ? "" + maxPublishTimeFilter.toJSON() : "") + "&";
        if (minPublishTimeFilter !== undefined)
            url_ += "MinPublishTimeFilter=" + encodeURIComponent(minPublishTimeFilter ? "" + minPublishTimeFilter.toJSON() : "") + "&";
        if (nameUnSignFilter !== undefined)
            url_ += "NameUnSignFilter=" + encodeURIComponent("" + nameUnSignFilter) + "&";
        if (targetAudienceTypeFilter !== undefined)
            url_ += "TargetAudienceTypeFilter=" + encodeURIComponent("" + targetAudienceTypeFilter) + "&";
        if (maxReferenceIDFilter !== undefined)
            url_ += "MaxReferenceIDFilter=" + encodeURIComponent("" + maxReferenceIDFilter) + "&";
        if (minReferenceIDFilter !== undefined)
            url_ += "MinReferenceIDFilter=" + encodeURIComponent("" + minReferenceIDFilter) + "&";
        if (maxDelayTimeFilter !== undefined)
            url_ += "MaxDelayTimeFilter=" + encodeURIComponent("" + maxDelayTimeFilter) + "&";
        if (minDelayTimeFilter !== undefined)
            url_ += "MinDelayTimeFilter=" + encodeURIComponent("" + minDelayTimeFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllExt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllExt(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetSocialSurveyInfoForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetSocialSurveyInfoForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllExt(response: HttpResponseBase): Observable<PagedResultDtoOfGetSocialSurveyInfoForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetSocialSurveyInfoForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetSocialSurveyInfoForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetSocialSurveyInfoForViewDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEditSurvey(input: CreateOrEditSocialSurveyInfoDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SocialSurveyInfos/CreateOrEditSurvey";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEditSurvey(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditSurvey(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEditSurvey(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param args (optional) 
     * @return Success
     */
    importQueue(args: SocialSurveyInfoAgrs | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SocialSurveyInfos/ImportQueue";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(args);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processImportQueue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportQueue(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processImportQueue(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    getTargetAudiences(): Observable<GetSocialSurveyTargetAudienceForViewDto[]> {
        let url_ = this.baseUrl + "/api/services/app/SocialSurveyInfos/GetTargetAudiences";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetTargetAudiences(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTargetAudiences(<any>response_);
                } catch (e) {
                    return <Observable<GetSocialSurveyTargetAudienceForViewDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetSocialSurveyTargetAudienceForViewDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetTargetAudiences(response: HttpResponseBase): Observable<GetSocialSurveyTargetAudienceForViewDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(GetSocialSurveyTargetAudienceForViewDto.fromJS(item));
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSocialSurveyTargetAudienceForViewDto[]>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getSurveyInfoForEditExt(id: number | null | undefined): Observable<GetSocialSurveyInfoForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/SocialSurveyInfos/GetSurveyInfoForEditExt?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSurveyInfoForEditExt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSurveyInfoForEditExt(<any>response_);
                } catch (e) {
                    return <Observable<GetSocialSurveyInfoForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetSocialSurveyInfoForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetSurveyInfoForEditExt(response: HttpResponseBase): Observable<GetSocialSurveyInfoForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetSocialSurveyInfoForEditOutput.fromJS(resultData200) : new GetSocialSurveyInfoForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSocialSurveyInfoForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    exportToExcel(input: GetAllSurveyInfosForExcelInputExt | null | undefined): Observable<SocialSurveyFileDto> {
        let url_ = this.baseUrl + "/api/services/app/SocialSurveyInfos/ExportToExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processExportToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportToExcel(<any>response_);
                } catch (e) {
                    return <Observable<SocialSurveyFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SocialSurveyFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processExportToExcel(response: HttpResponseBase): Observable<SocialSurveyFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? SocialSurveyFileDto.fromJS(resultData200) : new SocialSurveyFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SocialSurveyFileDto>(<any>null);
    }

    /**
     * @param surveyInfoDtos (optional) 
     * @return Success
     */
    batchDelete(surveyInfoDtos: SocialSurveyInfoDto[] | null | undefined): Observable<MessageResultSocialSurvey> {
        let url_ = this.baseUrl + "/api/services/app/SocialSurveyInfos/BatchDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(surveyInfoDtos);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processBatchDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBatchDelete(<any>response_);
                } catch (e) {
                    return <Observable<MessageResultSocialSurvey>><any>_observableThrow(e);
                }
            } else
                return <Observable<MessageResultSocialSurvey>><any>_observableThrow(response_);
        }));
    }

    protected processBatchDelete(response: HttpResponseBase): Observable<MessageResultSocialSurvey> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? MessageResultSocialSurvey.fromJS(resultData200) : new MessageResultSocialSurvey();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MessageResultSocialSurvey>(<any>null);
    }

    /**
     * @param surveyId (optional) 
     * @param keywords (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getSurveyResponseById(surveyId: number | null | undefined, keywords: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetSocialSurveyResponseForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/SocialSurveyInfos/GetSurveyResponseById?";
        if (surveyId !== undefined)
            url_ += "SurveyId=" + encodeURIComponent("" + surveyId) + "&";
        if (keywords !== undefined)
            url_ += "Keywords=" + encodeURIComponent("" + keywords) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSurveyResponseById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSurveyResponseById(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetSocialSurveyResponseForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetSocialSurveyResponseForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetSurveyResponseById(response: HttpResponseBase): Observable<PagedResultDtoOfGetSocialSurveyResponseForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetSocialSurveyResponseForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetSocialSurveyResponseForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetSocialSurveyResponseForViewDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    exportSurveyResponseToExcel(input: GetAllSurveyResponsesForInputExt | null | undefined): Observable<SocialSurveyFileDto> {
        let url_ = this.baseUrl + "/api/services/app/SocialSurveyInfos/ExportSurveyResponseToExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processExportSurveyResponseToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportSurveyResponseToExcel(<any>response_);
                } catch (e) {
                    return <Observable<SocialSurveyFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SocialSurveyFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processExportSurveyResponseToExcel(response: HttpResponseBase): Observable<SocialSurveyFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? SocialSurveyFileDto.fromJS(resultData200) : new SocialSurveyFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SocialSurveyFileDto>(<any>null);
    }
}

@Injectable()
export class SocialSurveyQuestionsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param codeFilter (optional) 
     * @param contentFilter (optional) 
     * @param surveyCodeFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, codeFilter: string | null | undefined, contentFilter: string | null | undefined, surveyCodeFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetSocialSurveyQuestionForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/SocialSurveyQuestions/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&";
        if (contentFilter !== undefined)
            url_ += "ContentFilter=" + encodeURIComponent("" + contentFilter) + "&";
        if (surveyCodeFilter !== undefined)
            url_ += "SurveyCodeFilter=" + encodeURIComponent("" + surveyCodeFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetSocialSurveyQuestionForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetSocialSurveyQuestionForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetSocialSurveyQuestionForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetSocialSurveyQuestionForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetSocialSurveyQuestionForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetSocialSurveyQuestionForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getSurveyQuestionForEdit(id: number | null | undefined): Observable<GetSocialSurveyQuestionForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/SocialSurveyQuestions/GetSurveyQuestionForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSurveyQuestionForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSurveyQuestionForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetSocialSurveyQuestionForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetSocialSurveyQuestionForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetSurveyQuestionForEdit(response: HttpResponseBase): Observable<GetSocialSurveyQuestionForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetSocialSurveyQuestionForEditOutput.fromJS(resultData200) : new GetSocialSurveyQuestionForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSocialSurveyQuestionForEditOutput>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getSurveyQuestionBySurveyId(id: number | null | undefined): Observable<GetSocialSurveyQuestionCustomForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/SocialSurveyQuestions/GetSurveyQuestionBySurveyId?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSurveyQuestionBySurveyId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSurveyQuestionBySurveyId(<any>response_);
                } catch (e) {
                    return <Observable<GetSocialSurveyQuestionCustomForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetSocialSurveyQuestionCustomForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetSurveyQuestionBySurveyId(response: HttpResponseBase): Observable<GetSocialSurveyQuestionCustomForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetSocialSurveyQuestionCustomForViewDto.fromJS(resultData200) : new GetSocialSurveyQuestionCustomForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSocialSurveyQuestionCustomForViewDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditSocialSurveyQuestionDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SocialSurveyQuestions/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SocialSurveyQuestions/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param codeFilter (optional) 
     * @param contentFilter (optional) 
     * @param surveyCodeFilter (optional) 
     * @return Success
     */
    getSurveyQuestionsToExcel(filter: string | null | undefined, codeFilter: string | null | undefined, contentFilter: string | null | undefined, surveyCodeFilter: string | null | undefined): Observable<SocialSurveyFileDto> {
        let url_ = this.baseUrl + "/api/services/app/SocialSurveyQuestions/GetSurveyQuestionsToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&";
        if (contentFilter !== undefined)
            url_ += "ContentFilter=" + encodeURIComponent("" + contentFilter) + "&";
        if (surveyCodeFilter !== undefined)
            url_ += "SurveyCodeFilter=" + encodeURIComponent("" + surveyCodeFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSurveyQuestionsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSurveyQuestionsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<SocialSurveyFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SocialSurveyFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetSurveyQuestionsToExcel(response: HttpResponseBase): Observable<SocialSurveyFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? SocialSurveyFileDto.fromJS(resultData200) : new SocialSurveyFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SocialSurveyFileDto>(<any>null);
    }
}

@Injectable()
export class SocialSurveyResponsesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param surveyCodeFilter (optional) 
     * @param channelFilter (optional) 
     * @param memberNameFilter (optional) 
     * @param phoneFilter (optional) 
     * @param zaloChatIDFilter (optional) 
     * @param emailFilter (optional) 
     * @param facebookIDFilter (optional) 
     * @param memberCodeFilter (optional) 
     * @param contentFilter (optional) 
     * @param subjectFilter (optional) 
     * @param outletCodeFilter (optional) 
     * @param questionCodeFilter (optional) 
     * @param answerCodeFilter (optional) 
     * @param messageIDFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, surveyCodeFilter: string | null | undefined, channelFilter: string | null | undefined, memberNameFilter: string | null | undefined, phoneFilter: string | null | undefined, zaloChatIDFilter: string | null | undefined, emailFilter: string | null | undefined, facebookIDFilter: string | null | undefined, memberCodeFilter: string | null | undefined, contentFilter: string | null | undefined, subjectFilter: string | null | undefined, outletCodeFilter: string | null | undefined, questionCodeFilter: string | null | undefined, answerCodeFilter: string | null | undefined, messageIDFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetSocialSurveyResponseForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/SocialSurveyResponses/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (surveyCodeFilter !== undefined)
            url_ += "SurveyCodeFilter=" + encodeURIComponent("" + surveyCodeFilter) + "&";
        if (channelFilter !== undefined)
            url_ += "ChannelFilter=" + encodeURIComponent("" + channelFilter) + "&";
        if (memberNameFilter !== undefined)
            url_ += "MemberNameFilter=" + encodeURIComponent("" + memberNameFilter) + "&";
        if (phoneFilter !== undefined)
            url_ += "PhoneFilter=" + encodeURIComponent("" + phoneFilter) + "&";
        if (zaloChatIDFilter !== undefined)
            url_ += "ZaloChatIDFilter=" + encodeURIComponent("" + zaloChatIDFilter) + "&";
        if (emailFilter !== undefined)
            url_ += "EmailFilter=" + encodeURIComponent("" + emailFilter) + "&";
        if (facebookIDFilter !== undefined)
            url_ += "FacebookIDFilter=" + encodeURIComponent("" + facebookIDFilter) + "&";
        if (memberCodeFilter !== undefined)
            url_ += "MemberCodeFilter=" + encodeURIComponent("" + memberCodeFilter) + "&";
        if (contentFilter !== undefined)
            url_ += "ContentFilter=" + encodeURIComponent("" + contentFilter) + "&";
        if (subjectFilter !== undefined)
            url_ += "SubjectFilter=" + encodeURIComponent("" + subjectFilter) + "&";
        if (outletCodeFilter !== undefined)
            url_ += "OutletCodeFilter=" + encodeURIComponent("" + outletCodeFilter) + "&";
        if (questionCodeFilter !== undefined)
            url_ += "QuestionCodeFilter=" + encodeURIComponent("" + questionCodeFilter) + "&";
        if (answerCodeFilter !== undefined)
            url_ += "AnswerCodeFilter=" + encodeURIComponent("" + answerCodeFilter) + "&";
        if (messageIDFilter !== undefined)
            url_ += "MessageIDFilter=" + encodeURIComponent("" + messageIDFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetSocialSurveyResponseForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetSocialSurveyResponseForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetSocialSurveyResponseForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetSocialSurveyResponseForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetSocialSurveyResponseForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetSocialSurveyResponseForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getSurveyResponseForEdit(id: number | null | undefined): Observable<GetSocialSurveyResponseForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/SocialSurveyResponses/GetSurveyResponseForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSurveyResponseForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSurveyResponseForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetSocialSurveyResponseForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetSocialSurveyResponseForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetSurveyResponseForEdit(response: HttpResponseBase): Observable<GetSocialSurveyResponseForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetSocialSurveyResponseForEditOutput.fromJS(resultData200) : new GetSocialSurveyResponseForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSocialSurveyResponseForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditSocialSurveyResponseDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SocialSurveyResponses/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SocialSurveyResponses/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param surveyCodeFilter (optional) 
     * @param channelFilter (optional) 
     * @param memberNameFilter (optional) 
     * @param phoneFilter (optional) 
     * @param zaloChatIDFilter (optional) 
     * @param emailFilter (optional) 
     * @param facebookIDFilter (optional) 
     * @param memberCodeFilter (optional) 
     * @param contentFilter (optional) 
     * @param subjectFilter (optional) 
     * @param outletCodeFilter (optional) 
     * @param questionCodeFilter (optional) 
     * @param answerCodeFilter (optional) 
     * @param messageIDFilter (optional) 
     * @return Success
     */
    getSurveyResponsesToExcel(filter: string | null | undefined, surveyCodeFilter: string | null | undefined, channelFilter: string | null | undefined, memberNameFilter: string | null | undefined, phoneFilter: string | null | undefined, zaloChatIDFilter: string | null | undefined, emailFilter: string | null | undefined, facebookIDFilter: string | null | undefined, memberCodeFilter: string | null | undefined, contentFilter: string | null | undefined, subjectFilter: string | null | undefined, outletCodeFilter: string | null | undefined, questionCodeFilter: string | null | undefined, answerCodeFilter: string | null | undefined, messageIDFilter: string | null | undefined): Observable<SocialSurveyFileDto> {
        let url_ = this.baseUrl + "/api/services/app/SocialSurveyResponses/GetSurveyResponsesToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (surveyCodeFilter !== undefined)
            url_ += "SurveyCodeFilter=" + encodeURIComponent("" + surveyCodeFilter) + "&";
        if (channelFilter !== undefined)
            url_ += "ChannelFilter=" + encodeURIComponent("" + channelFilter) + "&";
        if (memberNameFilter !== undefined)
            url_ += "MemberNameFilter=" + encodeURIComponent("" + memberNameFilter) + "&";
        if (phoneFilter !== undefined)
            url_ += "PhoneFilter=" + encodeURIComponent("" + phoneFilter) + "&";
        if (zaloChatIDFilter !== undefined)
            url_ += "ZaloChatIDFilter=" + encodeURIComponent("" + zaloChatIDFilter) + "&";
        if (emailFilter !== undefined)
            url_ += "EmailFilter=" + encodeURIComponent("" + emailFilter) + "&";
        if (facebookIDFilter !== undefined)
            url_ += "FacebookIDFilter=" + encodeURIComponent("" + facebookIDFilter) + "&";
        if (memberCodeFilter !== undefined)
            url_ += "MemberCodeFilter=" + encodeURIComponent("" + memberCodeFilter) + "&";
        if (contentFilter !== undefined)
            url_ += "ContentFilter=" + encodeURIComponent("" + contentFilter) + "&";
        if (subjectFilter !== undefined)
            url_ += "SubjectFilter=" + encodeURIComponent("" + subjectFilter) + "&";
        if (outletCodeFilter !== undefined)
            url_ += "OutletCodeFilter=" + encodeURIComponent("" + outletCodeFilter) + "&";
        if (questionCodeFilter !== undefined)
            url_ += "QuestionCodeFilter=" + encodeURIComponent("" + questionCodeFilter) + "&";
        if (answerCodeFilter !== undefined)
            url_ += "AnswerCodeFilter=" + encodeURIComponent("" + answerCodeFilter) + "&";
        if (messageIDFilter !== undefined)
            url_ += "MessageIDFilter=" + encodeURIComponent("" + messageIDFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSurveyResponsesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSurveyResponsesToExcel(<any>response_);
                } catch (e) {
                    return <Observable<SocialSurveyFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SocialSurveyFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetSurveyResponsesToExcel(response: HttpResponseBase): Observable<SocialSurveyFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? SocialSurveyFileDto.fromJS(resultData200) : new SocialSurveyFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SocialSurveyFileDto>(<any>null);
    }
}

@Injectable()
export class SocialSurveyTargetAudienceDetailsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param maxSurveyTargetAudienceIDFilter (optional) 
     * @param minSurveyTargetAudienceIDFilter (optional) 
     * @param nameFilter (optional) 
     * @param phoneFilter (optional) 
     * @param zaloChatIDFilter (optional) 
     * @param emailFilter (optional) 
     * @param facebookIDFilter (optional) 
     * @param memberCodeFilter (optional) 
     * @param communicationLanguageFilter (optional) 
     * @param communicationChannelFilter (optional) 
     * @param outletCodeFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, maxSurveyTargetAudienceIDFilter: number | null | undefined, minSurveyTargetAudienceIDFilter: number | null | undefined, nameFilter: string | null | undefined, phoneFilter: string | null | undefined, zaloChatIDFilter: string | null | undefined, emailFilter: string | null | undefined, facebookIDFilter: string | null | undefined, memberCodeFilter: string | null | undefined, communicationLanguageFilter: string | null | undefined, communicationChannelFilter: string | null | undefined, outletCodeFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetSocialSurveyTargetAudienceDetailForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/SocialSurveyTargetAudienceDetails/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxSurveyTargetAudienceIDFilter !== undefined)
            url_ += "MaxSurveyTargetAudienceIDFilter=" + encodeURIComponent("" + maxSurveyTargetAudienceIDFilter) + "&";
        if (minSurveyTargetAudienceIDFilter !== undefined)
            url_ += "MinSurveyTargetAudienceIDFilter=" + encodeURIComponent("" + minSurveyTargetAudienceIDFilter) + "&";
        if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (phoneFilter !== undefined)
            url_ += "PhoneFilter=" + encodeURIComponent("" + phoneFilter) + "&";
        if (zaloChatIDFilter !== undefined)
            url_ += "ZaloChatIDFilter=" + encodeURIComponent("" + zaloChatIDFilter) + "&";
        if (emailFilter !== undefined)
            url_ += "EmailFilter=" + encodeURIComponent("" + emailFilter) + "&";
        if (facebookIDFilter !== undefined)
            url_ += "FacebookIDFilter=" + encodeURIComponent("" + facebookIDFilter) + "&";
        if (memberCodeFilter !== undefined)
            url_ += "MemberCodeFilter=" + encodeURIComponent("" + memberCodeFilter) + "&";
        if (communicationLanguageFilter !== undefined)
            url_ += "CommunicationLanguageFilter=" + encodeURIComponent("" + communicationLanguageFilter) + "&";
        if (communicationChannelFilter !== undefined)
            url_ += "CommunicationChannelFilter=" + encodeURIComponent("" + communicationChannelFilter) + "&";
        if (outletCodeFilter !== undefined)
            url_ += "OutletCodeFilter=" + encodeURIComponent("" + outletCodeFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetSocialSurveyTargetAudienceDetailForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetSocialSurveyTargetAudienceDetailForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetSocialSurveyTargetAudienceDetailForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetSocialSurveyTargetAudienceDetailForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetSocialSurveyTargetAudienceDetailForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetSocialSurveyTargetAudienceDetailForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getSurveyTargetAudienceDetailForEdit(id: number | null | undefined): Observable<GetSocialSurveyTargetAudienceDetailForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/SocialSurveyTargetAudienceDetails/GetSurveyTargetAudienceDetailForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSurveyTargetAudienceDetailForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSurveyTargetAudienceDetailForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetSocialSurveyTargetAudienceDetailForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetSocialSurveyTargetAudienceDetailForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetSurveyTargetAudienceDetailForEdit(response: HttpResponseBase): Observable<GetSocialSurveyTargetAudienceDetailForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetSocialSurveyTargetAudienceDetailForEditOutput.fromJS(resultData200) : new GetSocialSurveyTargetAudienceDetailForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSocialSurveyTargetAudienceDetailForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditSocialSurveyTargetAudienceDetailDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SocialSurveyTargetAudienceDetails/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SocialSurveyTargetAudienceDetails/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param maxSurveyTargetAudienceIDFilter (optional) 
     * @param minSurveyTargetAudienceIDFilter (optional) 
     * @param nameFilter (optional) 
     * @param phoneFilter (optional) 
     * @param zaloChatIDFilter (optional) 
     * @param emailFilter (optional) 
     * @param facebookIDFilter (optional) 
     * @param memberCodeFilter (optional) 
     * @param communicationLanguageFilter (optional) 
     * @param communicationChannelFilter (optional) 
     * @param outletCodeFilter (optional) 
     * @return Success
     */
    getSurveyTargetAudienceDetailsToExcel(filter: string | null | undefined, maxSurveyTargetAudienceIDFilter: number | null | undefined, minSurveyTargetAudienceIDFilter: number | null | undefined, nameFilter: string | null | undefined, phoneFilter: string | null | undefined, zaloChatIDFilter: string | null | undefined, emailFilter: string | null | undefined, facebookIDFilter: string | null | undefined, memberCodeFilter: string | null | undefined, communicationLanguageFilter: string | null | undefined, communicationChannelFilter: string | null | undefined, outletCodeFilter: string | null | undefined): Observable<SocialSurveyFileDto> {
        let url_ = this.baseUrl + "/api/services/app/SocialSurveyTargetAudienceDetails/GetSurveyTargetAudienceDetailsToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxSurveyTargetAudienceIDFilter !== undefined)
            url_ += "MaxSurveyTargetAudienceIDFilter=" + encodeURIComponent("" + maxSurveyTargetAudienceIDFilter) + "&";
        if (minSurveyTargetAudienceIDFilter !== undefined)
            url_ += "MinSurveyTargetAudienceIDFilter=" + encodeURIComponent("" + minSurveyTargetAudienceIDFilter) + "&";
        if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (phoneFilter !== undefined)
            url_ += "PhoneFilter=" + encodeURIComponent("" + phoneFilter) + "&";
        if (zaloChatIDFilter !== undefined)
            url_ += "ZaloChatIDFilter=" + encodeURIComponent("" + zaloChatIDFilter) + "&";
        if (emailFilter !== undefined)
            url_ += "EmailFilter=" + encodeURIComponent("" + emailFilter) + "&";
        if (facebookIDFilter !== undefined)
            url_ += "FacebookIDFilter=" + encodeURIComponent("" + facebookIDFilter) + "&";
        if (memberCodeFilter !== undefined)
            url_ += "MemberCodeFilter=" + encodeURIComponent("" + memberCodeFilter) + "&";
        if (communicationLanguageFilter !== undefined)
            url_ += "CommunicationLanguageFilter=" + encodeURIComponent("" + communicationLanguageFilter) + "&";
        if (communicationChannelFilter !== undefined)
            url_ += "CommunicationChannelFilter=" + encodeURIComponent("" + communicationChannelFilter) + "&";
        if (outletCodeFilter !== undefined)
            url_ += "OutletCodeFilter=" + encodeURIComponent("" + outletCodeFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSurveyTargetAudienceDetailsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSurveyTargetAudienceDetailsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<SocialSurveyFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SocialSurveyFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetSurveyTargetAudienceDetailsToExcel(response: HttpResponseBase): Observable<SocialSurveyFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? SocialSurveyFileDto.fromJS(resultData200) : new SocialSurveyFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SocialSurveyFileDto>(<any>null);
    }
}

@Injectable()
export class SocialSurveyTargetAudiencesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param targetAudienceNameFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param statusFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, targetAudienceNameFilter: string | null | undefined, descriptionFilter: string | null | undefined, statusFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetSocialSurveyTargetAudienceForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/SocialSurveyTargetAudiences/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (targetAudienceNameFilter !== undefined)
            url_ += "TargetAudienceNameFilter=" + encodeURIComponent("" + targetAudienceNameFilter) + "&";
        if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetSocialSurveyTargetAudienceForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetSocialSurveyTargetAudienceForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetSocialSurveyTargetAudienceForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetSocialSurveyTargetAudienceForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetSocialSurveyTargetAudienceForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetSocialSurveyTargetAudienceForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getSurveyTargetAudienceForEdit(id: number | null | undefined): Observable<GetSocialSurveyTargetAudienceForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/SocialSurveyTargetAudiences/GetSurveyTargetAudienceForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSurveyTargetAudienceForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSurveyTargetAudienceForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetSocialSurveyTargetAudienceForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetSocialSurveyTargetAudienceForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetSurveyTargetAudienceForEdit(response: HttpResponseBase): Observable<GetSocialSurveyTargetAudienceForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetSocialSurveyTargetAudienceForEditOutput.fromJS(resultData200) : new GetSocialSurveyTargetAudienceForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSocialSurveyTargetAudienceForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditSocialSurveyTargetAudienceDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SocialSurveyTargetAudiences/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SocialSurveyTargetAudiences/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param targetAudienceNameFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param statusFilter (optional) 
     * @return Success
     */
    getSurveyTargetAudiencesToExcel(filter: string | null | undefined, targetAudienceNameFilter: string | null | undefined, descriptionFilter: string | null | undefined, statusFilter: string | null | undefined): Observable<SocialSurveyFileDto> {
        let url_ = this.baseUrl + "/api/services/app/SocialSurveyTargetAudiences/GetSurveyTargetAudiencesToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (targetAudienceNameFilter !== undefined)
            url_ += "TargetAudienceNameFilter=" + encodeURIComponent("" + targetAudienceNameFilter) + "&";
        if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSurveyTargetAudiencesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSurveyTargetAudiencesToExcel(<any>response_);
                } catch (e) {
                    return <Observable<SocialSurveyFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SocialSurveyFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetSurveyTargetAudiencesToExcel(response: HttpResponseBase): Observable<SocialSurveyFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? SocialSurveyFileDto.fromJS(resultData200) : new SocialSurveyFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SocialSurveyFileDto>(<any>null);
    }
}

@Injectable()
export class SpecialSettingsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param codeFilter (optional) 
     * @param nameFilter (optional) 
     * @param maxEffectiveFromFilter (optional) 
     * @param minEffectiveFromFilter (optional) 
     * @param maxEffectiveToFilter (optional) 
     * @param minEffectiveToFilter (optional) 
     * @param isActiveFilter (optional) 
     * @param targetAudienceFilter (optional) 
     * @param targetAudienceFilterId (optional) 
     * @param campaignFilter (optional) 
     * @param campaingFilterId (optional) 
     * @param typeFilterSpecialSetting (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, codeFilter: string | null | undefined, nameFilter: string | null | undefined, maxEffectiveFromFilter: moment.Moment | null | undefined, minEffectiveFromFilter: moment.Moment | null | undefined, maxEffectiveToFilter: moment.Moment | null | undefined, minEffectiveToFilter: moment.Moment | null | undefined, isActiveFilter: number | null | undefined, targetAudienceFilter: string | null | undefined, targetAudienceFilterId: number | null | undefined, campaignFilter: string | null | undefined, campaingFilterId: number | null | undefined, typeFilterSpecialSetting: TypeFilterSpecialSetting | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetSpecialSettingForView> {
        let url_ = this.baseUrl + "/api/services/app/SpecialSettings/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&";
        if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (maxEffectiveFromFilter !== undefined)
            url_ += "MaxEffectiveFromFilter=" + encodeURIComponent(maxEffectiveFromFilter ? "" + maxEffectiveFromFilter.toJSON() : "") + "&";
        if (minEffectiveFromFilter !== undefined)
            url_ += "MinEffectiveFromFilter=" + encodeURIComponent(minEffectiveFromFilter ? "" + minEffectiveFromFilter.toJSON() : "") + "&";
        if (maxEffectiveToFilter !== undefined)
            url_ += "MaxEffectiveToFilter=" + encodeURIComponent(maxEffectiveToFilter ? "" + maxEffectiveToFilter.toJSON() : "") + "&";
        if (minEffectiveToFilter !== undefined)
            url_ += "MinEffectiveToFilter=" + encodeURIComponent(minEffectiveToFilter ? "" + minEffectiveToFilter.toJSON() : "") + "&";
        if (isActiveFilter !== undefined)
            url_ += "IsActiveFilter=" + encodeURIComponent("" + isActiveFilter) + "&";
        if (targetAudienceFilter !== undefined)
            url_ += "TargetAudienceFilter=" + encodeURIComponent("" + targetAudienceFilter) + "&";
        if (targetAudienceFilterId !== undefined)
            url_ += "TargetAudienceFilterId=" + encodeURIComponent("" + targetAudienceFilterId) + "&";
        if (campaignFilter !== undefined)
            url_ += "CampaignFilter=" + encodeURIComponent("" + campaignFilter) + "&";
        if (campaingFilterId !== undefined)
            url_ += "CampaingFilterId=" + encodeURIComponent("" + campaingFilterId) + "&";
        if (typeFilterSpecialSetting !== undefined)
            url_ += "TypeFilterSpecialSetting=" + encodeURIComponent("" + typeFilterSpecialSetting) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetSpecialSettingForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetSpecialSettingForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetSpecialSettingForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetSpecialSettingForView.fromJS(resultData200) : new PagedResultDtoOfGetSpecialSettingForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetSpecialSettingForView>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getSpecialSettingForEdit(id: number | null | undefined): Observable<GetSpecialSettingForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/SpecialSettings/GetSpecialSettingForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSpecialSettingForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSpecialSettingForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetSpecialSettingForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetSpecialSettingForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetSpecialSettingForEdit(response: HttpResponseBase): Observable<GetSpecialSettingForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetSpecialSettingForEditOutput.fromJS(resultData200) : new GetSpecialSettingForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSpecialSettingForEditOutput>(<any>null);
    }

    /**
     * @param inputValidate (optional) 
     * @return Success
     */
    validateInputAsync(inputValidate: CreateOrEditSpecialSettingDto | null | undefined): Observable<ValidationResult[]> {
        let url_ = this.baseUrl + "/api/services/app/SpecialSettings/ValidateInputAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inputValidate);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processValidateInputAsync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateInputAsync(<any>response_);
                } catch (e) {
                    return <Observable<ValidationResult[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ValidationResult[]>><any>_observableThrow(response_);
        }));
    }

    protected processValidateInputAsync(response: HttpResponseBase): Observable<ValidationResult[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(ValidationResult.fromJS(item));
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ValidationResult[]>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditSpecialSettingDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SpecialSettings/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SpecialSettings/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param specialSettingId (optional) 
     * @param isActiveFilter (optional) 
     * @return Success
     */
    getAllSettingParamsFields(specialSettingId: number | null | undefined, isActiveFilter: number | null | undefined): Observable<SpecialSettingDto> {
        let url_ = this.baseUrl + "/api/services/app/SpecialSettings/GetAllSettingParamsFields?";
        if (specialSettingId !== undefined)
            url_ += "SpecialSettingId=" + encodeURIComponent("" + specialSettingId) + "&";
        if (isActiveFilter !== undefined)
            url_ += "IsActiveFilter=" + encodeURIComponent("" + isActiveFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllSettingParamsFields(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSettingParamsFields(<any>response_);
                } catch (e) {
                    return <Observable<SpecialSettingDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SpecialSettingDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllSettingParamsFields(response: HttpResponseBase): Observable<SpecialSettingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? SpecialSettingDto.fromJS(resultData200) : new SpecialSettingDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SpecialSettingDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param codeFilter (optional) 
     * @param nameFilter (optional) 
     * @param maxEffectiveFromFilter (optional) 
     * @param minEffectiveFromFilter (optional) 
     * @param maxEffectiveToFilter (optional) 
     * @param minEffectiveToFilter (optional) 
     * @param isActiveFilter (optional) 
     * @param targetAudienceFilter (optional) 
     * @param targetAudienceFilterId (optional) 
     * @param campaignFilter (optional) 
     * @param campaingFilterId (optional) 
     * @param typeFilterSpecialSetting (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllSpecialSettingInforMationByCampaignID(filter: string | null | undefined, codeFilter: string | null | undefined, nameFilter: string | null | undefined, maxEffectiveFromFilter: moment.Moment | null | undefined, minEffectiveFromFilter: moment.Moment | null | undefined, maxEffectiveToFilter: moment.Moment | null | undefined, minEffectiveToFilter: moment.Moment | null | undefined, isActiveFilter: number | null | undefined, targetAudienceFilter: string | null | undefined, targetAudienceFilterId: number | null | undefined, campaignFilter: string | null | undefined, campaingFilterId: number | null | undefined, typeFilterSpecialSetting: TypeFilterSpecialSetting2 | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetSpecialSettingForView> {
        let url_ = this.baseUrl + "/api/services/app/SpecialSettings/GetAllSpecialSettingInforMationByCampaignID?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&";
        if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (maxEffectiveFromFilter !== undefined)
            url_ += "MaxEffectiveFromFilter=" + encodeURIComponent(maxEffectiveFromFilter ? "" + maxEffectiveFromFilter.toJSON() : "") + "&";
        if (minEffectiveFromFilter !== undefined)
            url_ += "MinEffectiveFromFilter=" + encodeURIComponent(minEffectiveFromFilter ? "" + minEffectiveFromFilter.toJSON() : "") + "&";
        if (maxEffectiveToFilter !== undefined)
            url_ += "MaxEffectiveToFilter=" + encodeURIComponent(maxEffectiveToFilter ? "" + maxEffectiveToFilter.toJSON() : "") + "&";
        if (minEffectiveToFilter !== undefined)
            url_ += "MinEffectiveToFilter=" + encodeURIComponent(minEffectiveToFilter ? "" + minEffectiveToFilter.toJSON() : "") + "&";
        if (isActiveFilter !== undefined)
            url_ += "IsActiveFilter=" + encodeURIComponent("" + isActiveFilter) + "&";
        if (targetAudienceFilter !== undefined)
            url_ += "TargetAudienceFilter=" + encodeURIComponent("" + targetAudienceFilter) + "&";
        if (targetAudienceFilterId !== undefined)
            url_ += "TargetAudienceFilterId=" + encodeURIComponent("" + targetAudienceFilterId) + "&";
        if (campaignFilter !== undefined)
            url_ += "CampaignFilter=" + encodeURIComponent("" + campaignFilter) + "&";
        if (campaingFilterId !== undefined)
            url_ += "CampaingFilterId=" + encodeURIComponent("" + campaingFilterId) + "&";
        if (typeFilterSpecialSetting !== undefined)
            url_ += "TypeFilterSpecialSetting=" + encodeURIComponent("" + typeFilterSpecialSetting) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllSpecialSettingInforMationByCampaignID(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSpecialSettingInforMationByCampaignID(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetSpecialSettingForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetSpecialSettingForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllSpecialSettingInforMationByCampaignID(response: HttpResponseBase): Observable<PagedResultDtoOfGetSpecialSettingForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetSpecialSettingForView.fromJS(resultData200) : new PagedResultDtoOfGetSpecialSettingForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetSpecialSettingForView>(<any>null);
    }
}

@Injectable()
export class SubmittedSOsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param chatIDFilter (optional) 
     * @param memberCodeFilter (optional) 
     * @param phoneFilter (optional) 
     * @param maxPostingDateFilter (optional) 
     * @param minPostingDateFilter (optional) 
     * @param sOCodeFilter (optional) 
     * @param statusFilter (optional) 
     * @param maxTopupAmountFilter (optional) 
     * @param minTopupAmountFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, chatIDFilter: string | null | undefined, memberCodeFilter: string | null | undefined, phoneFilter: string | null | undefined, maxPostingDateFilter: moment.Moment | null | undefined, minPostingDateFilter: moment.Moment | null | undefined, sOCodeFilter: string | null | undefined, statusFilter: string | null | undefined, maxTopupAmountFilter: number | null | undefined, minTopupAmountFilter: number | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetSubmittedSOForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/SubmittedSOs/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (chatIDFilter !== undefined)
            url_ += "ChatIDFilter=" + encodeURIComponent("" + chatIDFilter) + "&";
        if (memberCodeFilter !== undefined)
            url_ += "MemberCodeFilter=" + encodeURIComponent("" + memberCodeFilter) + "&";
        if (phoneFilter !== undefined)
            url_ += "PhoneFilter=" + encodeURIComponent("" + phoneFilter) + "&";
        if (maxPostingDateFilter !== undefined)
            url_ += "MaxPostingDateFilter=" + encodeURIComponent(maxPostingDateFilter ? "" + maxPostingDateFilter.toJSON() : "") + "&";
        if (minPostingDateFilter !== undefined)
            url_ += "MinPostingDateFilter=" + encodeURIComponent(minPostingDateFilter ? "" + minPostingDateFilter.toJSON() : "") + "&";
        if (sOCodeFilter !== undefined)
            url_ += "SOCodeFilter=" + encodeURIComponent("" + sOCodeFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (maxTopupAmountFilter !== undefined)
            url_ += "MaxTopupAmountFilter=" + encodeURIComponent("" + maxTopupAmountFilter) + "&";
        if (minTopupAmountFilter !== undefined)
            url_ += "MinTopupAmountFilter=" + encodeURIComponent("" + minTopupAmountFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetSubmittedSOForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetSubmittedSOForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetSubmittedSOForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetSubmittedSOForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetSubmittedSOForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetSubmittedSOForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getSubmittedSOForEdit(id: number | null | undefined): Observable<GetSubmittedSOForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/SubmittedSOs/GetSubmittedSOForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSubmittedSOForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSubmittedSOForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetSubmittedSOForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetSubmittedSOForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetSubmittedSOForEdit(response: HttpResponseBase): Observable<GetSubmittedSOForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetSubmittedSOForEditOutput.fromJS(resultData200) : new GetSubmittedSOForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSubmittedSOForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditSubmittedSODto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SubmittedSOs/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SubmittedSOs/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param chatIDFilter (optional) 
     * @param memberCodeFilter (optional) 
     * @param phoneFilter (optional) 
     * @param maxPostingDateFilter (optional) 
     * @param minPostingDateFilter (optional) 
     * @param sOCodeFilter (optional) 
     * @param statusFilter (optional) 
     * @param maxTopupAmountFilter (optional) 
     * @param minTopupAmountFilter (optional) 
     * @return Success
     */
    getSubmittedSOsToExcel(filter: string | null | undefined, chatIDFilter: string | null | undefined, memberCodeFilter: string | null | undefined, phoneFilter: string | null | undefined, maxPostingDateFilter: moment.Moment | null | undefined, minPostingDateFilter: moment.Moment | null | undefined, sOCodeFilter: string | null | undefined, statusFilter: string | null | undefined, maxTopupAmountFilter: number | null | undefined, minTopupAmountFilter: number | null | undefined): Observable<SocialShopperFileDto> {
        let url_ = this.baseUrl + "/api/services/app/SubmittedSOs/GetSubmittedSOsToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (chatIDFilter !== undefined)
            url_ += "ChatIDFilter=" + encodeURIComponent("" + chatIDFilter) + "&";
        if (memberCodeFilter !== undefined)
            url_ += "MemberCodeFilter=" + encodeURIComponent("" + memberCodeFilter) + "&";
        if (phoneFilter !== undefined)
            url_ += "PhoneFilter=" + encodeURIComponent("" + phoneFilter) + "&";
        if (maxPostingDateFilter !== undefined)
            url_ += "MaxPostingDateFilter=" + encodeURIComponent(maxPostingDateFilter ? "" + maxPostingDateFilter.toJSON() : "") + "&";
        if (minPostingDateFilter !== undefined)
            url_ += "MinPostingDateFilter=" + encodeURIComponent(minPostingDateFilter ? "" + minPostingDateFilter.toJSON() : "") + "&";
        if (sOCodeFilter !== undefined)
            url_ += "SOCodeFilter=" + encodeURIComponent("" + sOCodeFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (maxTopupAmountFilter !== undefined)
            url_ += "MaxTopupAmountFilter=" + encodeURIComponent("" + maxTopupAmountFilter) + "&";
        if (minTopupAmountFilter !== undefined)
            url_ += "MinTopupAmountFilter=" + encodeURIComponent("" + minTopupAmountFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSubmittedSOsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSubmittedSOsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<SocialShopperFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SocialShopperFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetSubmittedSOsToExcel(response: HttpResponseBase): Observable<SocialShopperFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? SocialShopperFileDto.fromJS(resultData200) : new SocialShopperFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SocialShopperFileDto>(<any>null);
    }

    /**
     * @param purchase (optional) 
     * @return Success
     */
    syncLoyalty(purchase: PurchaseTransactionDtoExt | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/SubmittedSOs/SyncLoyalty";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(purchase);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSyncLoyalty(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSyncLoyalty(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processSyncLoyalty(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }
}

@Injectable()
export class SubmittedSOsExcelExporterServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param submittedSOs (optional) 
     * @return Success
     */
    exportToFile(submittedSOs: GetSubmittedSOForViewDto[] | null | undefined): Observable<SocialShopperFileDto> {
        let url_ = this.baseUrl + "/api/services/app/SubmittedSOsExcelExporter/ExportToFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(submittedSOs);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processExportToFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportToFile(<any>response_);
                } catch (e) {
                    return <Observable<SocialShopperFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SocialShopperFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processExportToFile(response: HttpResponseBase): Observable<SocialShopperFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? SocialShopperFileDto.fromJS(resultData200) : new SocialShopperFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SocialShopperFileDto>(<any>null);
    }
}

@Injectable()
export class SubscriptionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param upgradeEditionId (optional) 
     * @return Success
     */
    upgradeTenantToEquivalentEdition(upgradeEditionId: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Subscription/UpgradeTenantToEquivalentEdition?";
        if (upgradeEditionId !== undefined)
            url_ += "upgradeEditionId=" + encodeURIComponent("" + upgradeEditionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpgradeTenantToEquivalentEdition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpgradeTenantToEquivalentEdition(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpgradeTenantToEquivalentEdition(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class SurveyAnswersServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param questionCodeFilter (optional) 
     * @param contentVNFilter (optional) 
     * @param surveyCodeFilter (optional) 
     * @param answerCodeFilter (optional) 
     * @param contentENFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, questionCodeFilter: string | null | undefined, contentVNFilter: string | null | undefined, surveyCodeFilter: string | null | undefined, answerCodeFilter: string | null | undefined, contentENFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetSurveyAnswerForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/SurveyAnswers/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (questionCodeFilter !== undefined)
            url_ += "QuestionCodeFilter=" + encodeURIComponent("" + questionCodeFilter) + "&";
        if (contentVNFilter !== undefined)
            url_ += "ContentVNFilter=" + encodeURIComponent("" + contentVNFilter) + "&";
        if (surveyCodeFilter !== undefined)
            url_ += "SurveyCodeFilter=" + encodeURIComponent("" + surveyCodeFilter) + "&";
        if (answerCodeFilter !== undefined)
            url_ += "AnswerCodeFilter=" + encodeURIComponent("" + answerCodeFilter) + "&";
        if (contentENFilter !== undefined)
            url_ += "ContentENFilter=" + encodeURIComponent("" + contentENFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetSurveyAnswerForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetSurveyAnswerForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetSurveyAnswerForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetSurveyAnswerForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetSurveyAnswerForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetSurveyAnswerForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getSurveyAnswerForEdit(id: number | null | undefined): Observable<GetSurveyAnswerForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/SurveyAnswers/GetSurveyAnswerForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSurveyAnswerForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSurveyAnswerForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetSurveyAnswerForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetSurveyAnswerForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetSurveyAnswerForEdit(response: HttpResponseBase): Observable<GetSurveyAnswerForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetSurveyAnswerForEditOutput.fromJS(resultData200) : new GetSurveyAnswerForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSurveyAnswerForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditSurveyAnswerDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SurveyAnswers/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SurveyAnswers/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class SurveyInfosServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param codeFilter (optional) 
     * @param nameFilter (optional) 
     * @param statusFilter (optional) 
     * @param maxTargetAudienceIDFilter (optional) 
     * @param minTargetAudienceIDFilter (optional) 
     * @param descriptionVNFilter (optional) 
     * @param imageLinkFilter (optional) 
     * @param isImmediatelyFilter (optional) 
     * @param maxEffectiveFromFilter (optional) 
     * @param minEffectiveFromFilter (optional) 
     * @param maxEffectiveToFilter (optional) 
     * @param minEffectiveToFilter (optional) 
     * @param occurTypeFilter (optional) 
     * @param cronFilter (optional) 
     * @param maxPublishTimeFilter (optional) 
     * @param minPublishTimeFilter (optional) 
     * @param channelFilter (optional) 
     * @param descriptionENFilter (optional) 
     * @param targetAudienceTypeFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, codeFilter: string | null | undefined, nameFilter: string | null | undefined, statusFilter: string | null | undefined, maxTargetAudienceIDFilter: number | null | undefined, minTargetAudienceIDFilter: number | null | undefined, descriptionVNFilter: string | null | undefined, imageLinkFilter: string | null | undefined, isImmediatelyFilter: number | null | undefined, maxEffectiveFromFilter: moment.Moment | null | undefined, minEffectiveFromFilter: moment.Moment | null | undefined, maxEffectiveToFilter: moment.Moment | null | undefined, minEffectiveToFilter: moment.Moment | null | undefined, occurTypeFilter: string | null | undefined, cronFilter: string | null | undefined, maxPublishTimeFilter: moment.Moment | null | undefined, minPublishTimeFilter: moment.Moment | null | undefined, channelFilter: string | null | undefined, descriptionENFilter: string | null | undefined, targetAudienceTypeFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetSurveyInfoForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/SurveyInfos/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&";
        if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (maxTargetAudienceIDFilter !== undefined)
            url_ += "MaxTargetAudienceIDFilter=" + encodeURIComponent("" + maxTargetAudienceIDFilter) + "&";
        if (minTargetAudienceIDFilter !== undefined)
            url_ += "MinTargetAudienceIDFilter=" + encodeURIComponent("" + minTargetAudienceIDFilter) + "&";
        if (descriptionVNFilter !== undefined)
            url_ += "DescriptionVNFilter=" + encodeURIComponent("" + descriptionVNFilter) + "&";
        if (imageLinkFilter !== undefined)
            url_ += "ImageLinkFilter=" + encodeURIComponent("" + imageLinkFilter) + "&";
        if (isImmediatelyFilter !== undefined)
            url_ += "IsImmediatelyFilter=" + encodeURIComponent("" + isImmediatelyFilter) + "&";
        if (maxEffectiveFromFilter !== undefined)
            url_ += "MaxEffectiveFromFilter=" + encodeURIComponent(maxEffectiveFromFilter ? "" + maxEffectiveFromFilter.toJSON() : "") + "&";
        if (minEffectiveFromFilter !== undefined)
            url_ += "MinEffectiveFromFilter=" + encodeURIComponent(minEffectiveFromFilter ? "" + minEffectiveFromFilter.toJSON() : "") + "&";
        if (maxEffectiveToFilter !== undefined)
            url_ += "MaxEffectiveToFilter=" + encodeURIComponent(maxEffectiveToFilter ? "" + maxEffectiveToFilter.toJSON() : "") + "&";
        if (minEffectiveToFilter !== undefined)
            url_ += "MinEffectiveToFilter=" + encodeURIComponent(minEffectiveToFilter ? "" + minEffectiveToFilter.toJSON() : "") + "&";
        if (occurTypeFilter !== undefined)
            url_ += "OccurTypeFilter=" + encodeURIComponent("" + occurTypeFilter) + "&";
        if (cronFilter !== undefined)
            url_ += "CronFilter=" + encodeURIComponent("" + cronFilter) + "&";
        if (maxPublishTimeFilter !== undefined)
            url_ += "MaxPublishTimeFilter=" + encodeURIComponent(maxPublishTimeFilter ? "" + maxPublishTimeFilter.toJSON() : "") + "&";
        if (minPublishTimeFilter !== undefined)
            url_ += "MinPublishTimeFilter=" + encodeURIComponent(minPublishTimeFilter ? "" + minPublishTimeFilter.toJSON() : "") + "&";
        if (channelFilter !== undefined)
            url_ += "ChannelFilter=" + encodeURIComponent("" + channelFilter) + "&";
        if (descriptionENFilter !== undefined)
            url_ += "DescriptionENFilter=" + encodeURIComponent("" + descriptionENFilter) + "&";
        if (targetAudienceTypeFilter !== undefined)
            url_ += "TargetAudienceTypeFilter=" + encodeURIComponent("" + targetAudienceTypeFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetSurveyInfoForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetSurveyInfoForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetSurveyInfoForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetSurveyInfoForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetSurveyInfoForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetSurveyInfoForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getSurveyInfoForEdit(id: number | null | undefined): Observable<GetSurveyInfoForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/SurveyInfos/GetSurveyInfoForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSurveyInfoForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSurveyInfoForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetSurveyInfoForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetSurveyInfoForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetSurveyInfoForEdit(response: HttpResponseBase): Observable<GetSurveyInfoForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetSurveyInfoForEditOutput.fromJS(resultData200) : new GetSurveyInfoForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSurveyInfoForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditSurveyInfoDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SurveyInfos/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SurveyInfos/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    batchDelete(input: EntityDto[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SurveyInfos/BatchDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processBatchDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBatchDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processBatchDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    search(input: GetAllSurveyInfosInput | null | undefined): Observable<PagedResultDtoOfGetSurveyInfoForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/SurveyInfos/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetSurveyInfoForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetSurveyInfoForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<PagedResultDtoOfGetSurveyInfoForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetSurveyInfoForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetSurveyInfoForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetSurveyInfoForViewDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    searchExt(input: GetAllSurveyInfosInput | null | undefined): Observable<PagedResultDtoOfGetSurveyInfoForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/SurveyInfos/SearchExt";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSearchExt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchExt(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetSurveyInfoForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetSurveyInfoForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processSearchExt(response: HttpResponseBase): Observable<PagedResultDtoOfGetSurveyInfoForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetSurveyInfoForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetSurveyInfoForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetSurveyInfoForViewDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createCustom(input: CreateOrEditSurveyInforCustomDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SurveyInfos/CreateCustom";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateCustom(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateCustom(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateCustom(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    editCustom(input: CreateOrEditSurveyInforCustomDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SurveyInfos/EditCustom";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processEditCustom(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditCustom(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processEditCustom(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param surveyId (optional) 
     * @return Success
     */
    getSurvey(surveyId: number | null | undefined): Observable<SurveyForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/SurveyInfos/GetSurvey?";
        if (surveyId !== undefined)
            url_ += "surveyId=" + encodeURIComponent("" + surveyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSurvey(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSurvey(<any>response_);
                } catch (e) {
                    return <Observable<SurveyForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SurveyForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetSurvey(response: HttpResponseBase): Observable<SurveyForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? SurveyForViewDto.fromJS(resultData200) : new SurveyForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SurveyForViewDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    submitSurvey(input: SurveyForSubmit | null | undefined): Observable<SubmitSurveyResponse> {
        let url_ = this.baseUrl + "/api/services/app/SurveyInfos/SubmitSurvey";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSubmitSurvey(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubmitSurvey(<any>response_);
                } catch (e) {
                    return <Observable<SubmitSurveyResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<SubmitSurveyResponse>><any>_observableThrow(response_);
        }));
    }

    protected processSubmitSurvey(response: HttpResponseBase): Observable<SubmitSurveyResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? SubmitSurveyResponse.fromJS(resultData200) : new SubmitSurveyResponse();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SubmitSurveyResponse>(<any>null);
    }

    /**
     * @param surveyId (optional) 
     * @return Success
     */
    cloneSurvey(surveyId: number | null | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/SurveyInfos/CloneSurvey?";
        if (surveyId !== undefined)
            url_ += "surveyId=" + encodeURIComponent("" + surveyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCloneSurvey(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCloneSurvey(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processCloneSurvey(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param memberCodeFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getSurveyByMember(memberCodeFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetSurveyInfoForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/SurveyInfos/GetSurveyByMember?";
        if (memberCodeFilter !== undefined)
            url_ += "MemberCodeFilter=" + encodeURIComponent("" + memberCodeFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSurveyByMember(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSurveyByMember(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetSurveyInfoForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetSurveyInfoForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetSurveyByMember(response: HttpResponseBase): Observable<PagedResultDtoOfGetSurveyInfoForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetSurveyInfoForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetSurveyInfoForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetSurveyInfoForViewDto>(<any>null);
    }
}

@Injectable()
export class SurveyQuestionsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param codeFilter (optional) 
     * @param contentVNFilter (optional) 
     * @param surveyCodeFilter (optional) 
     * @param questionTypeFilter (optional) 
     * @param maxOrderingFilter (optional) 
     * @param minOrderingFilter (optional) 
     * @param contentENFilter (optional) 
     * @param attachImageFilter (optional) 
     * @param imageNone_Link (optional) 
     * @param imageHaft_Link (optional) 
     * @param image_Full_Link (optional) 
     * @param minvalue (optional) 
     * @param maxvalue (optional) 
     * @param stepPass (optional) 
     * @param required (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, codeFilter: string | null | undefined, contentVNFilter: string | null | undefined, surveyCodeFilter: string | null | undefined, questionTypeFilter: string | null | undefined, maxOrderingFilter: number | null | undefined, minOrderingFilter: number | null | undefined, contentENFilter: string | null | undefined, attachImageFilter: number | null | undefined, imageNone_Link: string | null | undefined, imageHaft_Link: string | null | undefined, image_Full_Link: string | null | undefined, minvalue: number | null | undefined, maxvalue: number | null | undefined, stepPass: number | null | undefined, required: boolean | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetSurveyQuestionForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/SurveyQuestions/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&";
        if (contentVNFilter !== undefined)
            url_ += "ContentVNFilter=" + encodeURIComponent("" + contentVNFilter) + "&";
        if (surveyCodeFilter !== undefined)
            url_ += "SurveyCodeFilter=" + encodeURIComponent("" + surveyCodeFilter) + "&";
        if (questionTypeFilter !== undefined)
            url_ += "QuestionTypeFilter=" + encodeURIComponent("" + questionTypeFilter) + "&";
        if (maxOrderingFilter !== undefined)
            url_ += "MaxOrderingFilter=" + encodeURIComponent("" + maxOrderingFilter) + "&";
        if (minOrderingFilter !== undefined)
            url_ += "MinOrderingFilter=" + encodeURIComponent("" + minOrderingFilter) + "&";
        if (contentENFilter !== undefined)
            url_ += "ContentENFilter=" + encodeURIComponent("" + contentENFilter) + "&";
        if (attachImageFilter !== undefined)
            url_ += "AttachImageFilter=" + encodeURIComponent("" + attachImageFilter) + "&";
        if (imageNone_Link !== undefined)
            url_ += "ImageNone_Link=" + encodeURIComponent("" + imageNone_Link) + "&";
        if (imageHaft_Link !== undefined)
            url_ += "ImageHaft_Link=" + encodeURIComponent("" + imageHaft_Link) + "&";
        if (image_Full_Link !== undefined)
            url_ += "Image_Full_Link=" + encodeURIComponent("" + image_Full_Link) + "&";
        if (minvalue !== undefined)
            url_ += "Minvalue=" + encodeURIComponent("" + minvalue) + "&";
        if (maxvalue !== undefined)
            url_ += "Maxvalue=" + encodeURIComponent("" + maxvalue) + "&";
        if (stepPass !== undefined)
            url_ += "StepPass=" + encodeURIComponent("" + stepPass) + "&";
        if (required !== undefined)
            url_ += "Required=" + encodeURIComponent("" + required) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetSurveyQuestionForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetSurveyQuestionForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetSurveyQuestionForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetSurveyQuestionForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetSurveyQuestionForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetSurveyQuestionForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getSurveyQuestionForEdit(id: number | null | undefined): Observable<GetSurveyQuestionForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/SurveyQuestions/GetSurveyQuestionForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSurveyQuestionForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSurveyQuestionForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetSurveyQuestionForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetSurveyQuestionForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetSurveyQuestionForEdit(response: HttpResponseBase): Observable<GetSurveyQuestionForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetSurveyQuestionForEditOutput.fromJS(resultData200) : new GetSurveyQuestionForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSurveyQuestionForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditSurveyQuestionDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SurveyQuestions/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SurveyQuestions/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param surveyCode (optional) 
     * @return Success
     */
    getSurveyQuestions(surveyCode: string | null | undefined): Observable<GetSurveyQuestionForEditOutput[]> {
        let url_ = this.baseUrl + "/api/services/app/SurveyQuestions/GetSurveyQuestions?";
        if (surveyCode !== undefined)
            url_ += "surveyCode=" + encodeURIComponent("" + surveyCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSurveyQuestions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSurveyQuestions(<any>response_);
                } catch (e) {
                    return <Observable<GetSurveyQuestionForEditOutput[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetSurveyQuestionForEditOutput[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetSurveyQuestions(response: HttpResponseBase): Observable<GetSurveyQuestionForEditOutput[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(GetSurveyQuestionForEditOutput.fromJS(item));
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSurveyQuestionForEditOutput[]>(<any>null);
    }
}

@Injectable()
export class SurveyResponseExcelExporterServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param surveyResponses (optional) 
     * @return Success
     */
    exportToFile(surveyResponses: GetSurveyResponseForViewDto[] | null | undefined): Observable<SurveyResponseFileDto> {
        let url_ = this.baseUrl + "/api/services/app/SurveyResponseExcelExporter/ExportToFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(surveyResponses);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processExportToFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportToFile(<any>response_);
                } catch (e) {
                    return <Observable<SurveyResponseFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SurveyResponseFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processExportToFile(response: HttpResponseBase): Observable<SurveyResponseFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? SurveyResponseFileDto.fromJS(resultData200) : new SurveyResponseFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SurveyResponseFileDto>(<any>null);
    }
}

@Injectable()
export class SurveyResponsesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param surveyCodeFilter (optional) 
     * @param channelFilter (optional) 
     * @param memberNameFilter (optional) 
     * @param phoneFilter (optional) 
     * @param zaloChatIDFilter (optional) 
     * @param emailFilter (optional) 
     * @param facebookIDFilter (optional) 
     * @param memberCodeFilter (optional) 
     * @param questionContentFilter (optional) 
     * @param subjectFilter (optional) 
     * @param outletCodeFilter (optional) 
     * @param questionCodeFilter (optional) 
     * @param answerContentFilter (optional) 
     * @param messageIDFilter (optional) 
     * @param questionTypeFilter (optional) 
     * @param maxOrderingFilter (optional) 
     * @param minOrderingFilter (optional) 
     * @param imageLinkFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, surveyCodeFilter: string | null | undefined, channelFilter: string | null | undefined, memberNameFilter: string | null | undefined, phoneFilter: string | null | undefined, zaloChatIDFilter: string | null | undefined, emailFilter: string | null | undefined, facebookIDFilter: string | null | undefined, memberCodeFilter: string | null | undefined, questionContentFilter: string | null | undefined, subjectFilter: string | null | undefined, outletCodeFilter: string | null | undefined, questionCodeFilter: string | null | undefined, answerContentFilter: string | null | undefined, messageIDFilter: string | null | undefined, questionTypeFilter: string | null | undefined, maxOrderingFilter: number | null | undefined, minOrderingFilter: number | null | undefined, imageLinkFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetSurveyResponseForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/SurveyResponses/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (surveyCodeFilter !== undefined)
            url_ += "SurveyCodeFilter=" + encodeURIComponent("" + surveyCodeFilter) + "&";
        if (channelFilter !== undefined)
            url_ += "ChannelFilter=" + encodeURIComponent("" + channelFilter) + "&";
        if (memberNameFilter !== undefined)
            url_ += "MemberNameFilter=" + encodeURIComponent("" + memberNameFilter) + "&";
        if (phoneFilter !== undefined)
            url_ += "PhoneFilter=" + encodeURIComponent("" + phoneFilter) + "&";
        if (zaloChatIDFilter !== undefined)
            url_ += "ZaloChatIDFilter=" + encodeURIComponent("" + zaloChatIDFilter) + "&";
        if (emailFilter !== undefined)
            url_ += "EmailFilter=" + encodeURIComponent("" + emailFilter) + "&";
        if (facebookIDFilter !== undefined)
            url_ += "FacebookIDFilter=" + encodeURIComponent("" + facebookIDFilter) + "&";
        if (memberCodeFilter !== undefined)
            url_ += "MemberCodeFilter=" + encodeURIComponent("" + memberCodeFilter) + "&";
        if (questionContentFilter !== undefined)
            url_ += "QuestionContentFilter=" + encodeURIComponent("" + questionContentFilter) + "&";
        if (subjectFilter !== undefined)
            url_ += "SubjectFilter=" + encodeURIComponent("" + subjectFilter) + "&";
        if (outletCodeFilter !== undefined)
            url_ += "OutletCodeFilter=" + encodeURIComponent("" + outletCodeFilter) + "&";
        if (questionCodeFilter !== undefined)
            url_ += "QuestionCodeFilter=" + encodeURIComponent("" + questionCodeFilter) + "&";
        if (answerContentFilter !== undefined)
            url_ += "AnswerContentFilter=" + encodeURIComponent("" + answerContentFilter) + "&";
        if (messageIDFilter !== undefined)
            url_ += "MessageIDFilter=" + encodeURIComponent("" + messageIDFilter) + "&";
        if (questionTypeFilter !== undefined)
            url_ += "QuestionTypeFilter=" + encodeURIComponent("" + questionTypeFilter) + "&";
        if (maxOrderingFilter !== undefined)
            url_ += "MaxOrderingFilter=" + encodeURIComponent("" + maxOrderingFilter) + "&";
        if (minOrderingFilter !== undefined)
            url_ += "MinOrderingFilter=" + encodeURIComponent("" + minOrderingFilter) + "&";
        if (imageLinkFilter !== undefined)
            url_ += "ImageLinkFilter=" + encodeURIComponent("" + imageLinkFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetSurveyResponseForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetSurveyResponseForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetSurveyResponseForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetSurveyResponseForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetSurveyResponseForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetSurveyResponseForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getSurveyResponseForEdit(id: number | null | undefined): Observable<GetSurveyResponseForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/SurveyResponses/GetSurveyResponseForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSurveyResponseForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSurveyResponseForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetSurveyResponseForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetSurveyResponseForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetSurveyResponseForEdit(response: HttpResponseBase): Observable<GetSurveyResponseForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetSurveyResponseForEditOutput.fromJS(resultData200) : new GetSurveyResponseForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSurveyResponseForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditSurveyResponseDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SurveyResponses/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SurveyResponses/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    listSurveyResponse(input: GetListSurveyResponseInput | null | undefined): Observable<PagedResultDtoOfGetSurveyResponseForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/SurveyResponses/ListSurveyResponse";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processListSurveyResponse(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListSurveyResponse(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetSurveyResponseForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetSurveyResponseForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processListSurveyResponse(response: HttpResponseBase): Observable<PagedResultDtoOfGetSurveyResponseForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetSurveyResponseForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetSurveyResponseForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetSurveyResponseForViewDto>(<any>null);
    }

    /**
     * @param surveyCode (optional) 
     * @param memberCode (optional) 
     * @return Success
     */
    getSurveyResponseDetail(surveyCode: string | null | undefined, memberCode: string | null | undefined): Observable<GetSurveyResponseDetailDto> {
        let url_ = this.baseUrl + "/api/services/app/SurveyResponses/GetSurveyResponseDetail?";
        if (surveyCode !== undefined)
            url_ += "surveyCode=" + encodeURIComponent("" + surveyCode) + "&";
        if (memberCode !== undefined)
            url_ += "memberCode=" + encodeURIComponent("" + memberCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSurveyResponseDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSurveyResponseDetail(<any>response_);
                } catch (e) {
                    return <Observable<GetSurveyResponseDetailDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetSurveyResponseDetailDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetSurveyResponseDetail(response: HttpResponseBase): Observable<GetSurveyResponseDetailDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetSurveyResponseDetailDto.fromJS(resultData200) : new GetSurveyResponseDetailDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSurveyResponseDetailDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    surveyResponseToExcel(input: GetListSurveyResponseInput | null | undefined): Observable<SurveyResponseFileDto> {
        let url_ = this.baseUrl + "/api/services/app/SurveyResponses/SurveyResponseToExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSurveyResponseToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSurveyResponseToExcel(<any>response_);
                } catch (e) {
                    return <Observable<SurveyResponseFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SurveyResponseFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processSurveyResponseToExcel(response: HttpResponseBase): Observable<SurveyResponseFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? SurveyResponseFileDto.fromJS(resultData200) : new SurveyResponseFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SurveyResponseFileDto>(<any>null);
    }
}

@Injectable()
export class SurveysServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditSurveyInput | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Surveys/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Surveys/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param surveyId (optional) 
     * @return Success
     */
    getSurveyDetail(surveyId: number | null | undefined): Observable<PagedResultDtoOfSurveyResultDetailDto> {
        let url_ = this.baseUrl + "/api/services/app/Surveys/GetSurveyDetail?";
        if (surveyId !== undefined)
            url_ += "surveyId=" + encodeURIComponent("" + surveyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSurveyDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSurveyDetail(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfSurveyResultDetailDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfSurveyResultDetailDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetSurveyDetail(response: HttpResponseBase): Observable<PagedResultDtoOfSurveyResultDetailDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfSurveyResultDetailDto.fromJS(resultData200) : new PagedResultDtoOfSurveyResultDetailDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfSurveyResultDetailDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    submitSurvey(input: SurveyInput | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Surveys/SubmitSurvey";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSubmitSurvey(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubmitSurvey(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processSubmitSurvey(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }
}

@Injectable()
export class SurveySettingsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param surveyNameFilter (optional) 
     * @param surveyMonkeyCodeFilter (optional) 
     * @param maxEffectiveFromFilter (optional) 
     * @param minEffectiveFromFilter (optional) 
     * @param maxEffectiveToFilter (optional) 
     * @param minEffectiveToFilter (optional) 
     * @param statusFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param imageLinkFilter (optional) 
     * @param surveyNameUnsignFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, surveyNameFilter: string | null | undefined, surveyMonkeyCodeFilter: string | null | undefined, maxEffectiveFromFilter: moment.Moment | null | undefined, minEffectiveFromFilter: moment.Moment | null | undefined, maxEffectiveToFilter: moment.Moment | null | undefined, minEffectiveToFilter: moment.Moment | null | undefined, statusFilter: string | null | undefined, descriptionFilter: string | null | undefined, imageLinkFilter: string | null | undefined, surveyNameUnsignFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetSurveySettingForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/SurveySettings/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (surveyNameFilter !== undefined)
            url_ += "SurveyNameFilter=" + encodeURIComponent("" + surveyNameFilter) + "&";
        if (surveyMonkeyCodeFilter !== undefined)
            url_ += "SurveyMonkeyCodeFilter=" + encodeURIComponent("" + surveyMonkeyCodeFilter) + "&";
        if (maxEffectiveFromFilter !== undefined)
            url_ += "MaxEffectiveFromFilter=" + encodeURIComponent(maxEffectiveFromFilter ? "" + maxEffectiveFromFilter.toJSON() : "") + "&";
        if (minEffectiveFromFilter !== undefined)
            url_ += "MinEffectiveFromFilter=" + encodeURIComponent(minEffectiveFromFilter ? "" + minEffectiveFromFilter.toJSON() : "") + "&";
        if (maxEffectiveToFilter !== undefined)
            url_ += "MaxEffectiveToFilter=" + encodeURIComponent(maxEffectiveToFilter ? "" + maxEffectiveToFilter.toJSON() : "") + "&";
        if (minEffectiveToFilter !== undefined)
            url_ += "MinEffectiveToFilter=" + encodeURIComponent(minEffectiveToFilter ? "" + minEffectiveToFilter.toJSON() : "") + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&";
        if (imageLinkFilter !== undefined)
            url_ += "ImageLinkFilter=" + encodeURIComponent("" + imageLinkFilter) + "&";
        if (surveyNameUnsignFilter !== undefined)
            url_ += "SurveyNameUnsignFilter=" + encodeURIComponent("" + surveyNameUnsignFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetSurveySettingForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetSurveySettingForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetSurveySettingForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetSurveySettingForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetSurveySettingForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetSurveySettingForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getSurveySettingForEdit(id: number | null | undefined): Observable<GetSurveySettingForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/SurveySettings/GetSurveySettingForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSurveySettingForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSurveySettingForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetSurveySettingForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetSurveySettingForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetSurveySettingForEdit(response: HttpResponseBase): Observable<GetSurveySettingForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetSurveySettingForEditOutput.fromJS(resultData200) : new GetSurveySettingForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSurveySettingForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditSurveySettingDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SurveySettings/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SurveySettings/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param surveyNameFilter (optional) 
     * @param surveyMonkeyCodeFilter (optional) 
     * @param maxEffectiveFromFilter (optional) 
     * @param minEffectiveFromFilter (optional) 
     * @param maxEffectiveToFilter (optional) 
     * @param minEffectiveToFilter (optional) 
     * @param statusFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param imageLinkFilter (optional) 
     * @param surveyNameUnsignFilter (optional) 
     * @return Success
     */
    getSurveySettingsToExcel(filter: string | null | undefined, surveyNameFilter: string | null | undefined, surveyMonkeyCodeFilter: string | null | undefined, maxEffectiveFromFilter: moment.Moment | null | undefined, minEffectiveFromFilter: moment.Moment | null | undefined, maxEffectiveToFilter: moment.Moment | null | undefined, minEffectiveToFilter: moment.Moment | null | undefined, statusFilter: string | null | undefined, descriptionFilter: string | null | undefined, imageLinkFilter: string | null | undefined, surveyNameUnsignFilter: string | null | undefined): Observable<ConsumerDBFileDto> {
        let url_ = this.baseUrl + "/api/services/app/SurveySettings/GetSurveySettingsToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (surveyNameFilter !== undefined)
            url_ += "SurveyNameFilter=" + encodeURIComponent("" + surveyNameFilter) + "&";
        if (surveyMonkeyCodeFilter !== undefined)
            url_ += "SurveyMonkeyCodeFilter=" + encodeURIComponent("" + surveyMonkeyCodeFilter) + "&";
        if (maxEffectiveFromFilter !== undefined)
            url_ += "MaxEffectiveFromFilter=" + encodeURIComponent(maxEffectiveFromFilter ? "" + maxEffectiveFromFilter.toJSON() : "") + "&";
        if (minEffectiveFromFilter !== undefined)
            url_ += "MinEffectiveFromFilter=" + encodeURIComponent(minEffectiveFromFilter ? "" + minEffectiveFromFilter.toJSON() : "") + "&";
        if (maxEffectiveToFilter !== undefined)
            url_ += "MaxEffectiveToFilter=" + encodeURIComponent(maxEffectiveToFilter ? "" + maxEffectiveToFilter.toJSON() : "") + "&";
        if (minEffectiveToFilter !== undefined)
            url_ += "MinEffectiveToFilter=" + encodeURIComponent(minEffectiveToFilter ? "" + minEffectiveToFilter.toJSON() : "") + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&";
        if (imageLinkFilter !== undefined)
            url_ += "ImageLinkFilter=" + encodeURIComponent("" + imageLinkFilter) + "&";
        if (surveyNameUnsignFilter !== undefined)
            url_ += "SurveyNameUnsignFilter=" + encodeURIComponent("" + surveyNameUnsignFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSurveySettingsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSurveySettingsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<ConsumerDBFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ConsumerDBFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetSurveySettingsToExcel(response: HttpResponseBase): Observable<ConsumerDBFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? ConsumerDBFileDto.fromJS(resultData200) : new ConsumerDBFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ConsumerDBFileDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEditUnsign(input: CreateOrEditSurveySettingDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SurveySettings/CreateOrEditUnsign";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEditUnsign(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditUnsign(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEditUnsign(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    batchDelete(input: SurveySettingDto[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SurveySettings/BatchDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processBatchDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBatchDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processBatchDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    search(input: GetAllSurveySettingsInput | null | undefined): Observable<PagedResultDtoOfGetSurveySettingForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/SurveySettings/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetSurveySettingForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetSurveySettingForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<PagedResultDtoOfGetSurveySettingForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetSurveySettingForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetSurveySettingForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetSurveySettingForViewDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    searchDetailSurveyResultByMonkeyCode(input: GetSurveyResultInput | null | undefined): Observable<PagedResultDtoOfGetSurveyResultForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/SurveySettings/SearchDetailSurveyResultByMonkeyCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSearchDetailSurveyResultByMonkeyCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchDetailSurveyResultByMonkeyCode(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetSurveyResultForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetSurveyResultForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processSearchDetailSurveyResultByMonkeyCode(response: HttpResponseBase): Observable<PagedResultDtoOfGetSurveyResultForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetSurveyResultForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetSurveyResultForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetSurveyResultForViewDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param surveyUserFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getSurveyResultToExcel(filter: string | null | undefined, surveyUserFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<ConsumerDBFileDto> {
        let url_ = this.baseUrl + "/api/services/app/SurveySettings/GetSurveyResultToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (surveyUserFilter !== undefined)
            url_ += "SurveyUserFilter=" + encodeURIComponent("" + surveyUserFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSurveyResultToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSurveyResultToExcel(<any>response_);
                } catch (e) {
                    return <Observable<ConsumerDBFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ConsumerDBFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetSurveyResultToExcel(response: HttpResponseBase): Observable<ConsumerDBFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? ConsumerDBFileDto.fromJS(resultData200) : new ConsumerDBFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ConsumerDBFileDto>(<any>null);
    }
}

@Injectable()
export class SurveyTargetAudienceDetailsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param maxSurveyTargetAudienceIDFilter (optional) 
     * @param minSurveyTargetAudienceIDFilter (optional) 
     * @param nameFilter (optional) 
     * @param phoneFilter (optional) 
     * @param zaloChatIDFilter (optional) 
     * @param emailFilter (optional) 
     * @param facebookIDFilter (optional) 
     * @param memberCodeFilter (optional) 
     * @param communicationLanguageFilter (optional) 
     * @param communicationChannelFilter (optional) 
     * @param outletCodeFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, maxSurveyTargetAudienceIDFilter: number | null | undefined, minSurveyTargetAudienceIDFilter: number | null | undefined, nameFilter: string | null | undefined, phoneFilter: string | null | undefined, zaloChatIDFilter: string | null | undefined, emailFilter: string | null | undefined, facebookIDFilter: string | null | undefined, memberCodeFilter: string | null | undefined, communicationLanguageFilter: string | null | undefined, communicationChannelFilter: string | null | undefined, outletCodeFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetSurveyTargetAudienceDetailForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/SurveyTargetAudienceDetails/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxSurveyTargetAudienceIDFilter !== undefined)
            url_ += "MaxSurveyTargetAudienceIDFilter=" + encodeURIComponent("" + maxSurveyTargetAudienceIDFilter) + "&";
        if (minSurveyTargetAudienceIDFilter !== undefined)
            url_ += "MinSurveyTargetAudienceIDFilter=" + encodeURIComponent("" + minSurveyTargetAudienceIDFilter) + "&";
        if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (phoneFilter !== undefined)
            url_ += "PhoneFilter=" + encodeURIComponent("" + phoneFilter) + "&";
        if (zaloChatIDFilter !== undefined)
            url_ += "ZaloChatIDFilter=" + encodeURIComponent("" + zaloChatIDFilter) + "&";
        if (emailFilter !== undefined)
            url_ += "EmailFilter=" + encodeURIComponent("" + emailFilter) + "&";
        if (facebookIDFilter !== undefined)
            url_ += "FacebookIDFilter=" + encodeURIComponent("" + facebookIDFilter) + "&";
        if (memberCodeFilter !== undefined)
            url_ += "MemberCodeFilter=" + encodeURIComponent("" + memberCodeFilter) + "&";
        if (communicationLanguageFilter !== undefined)
            url_ += "CommunicationLanguageFilter=" + encodeURIComponent("" + communicationLanguageFilter) + "&";
        if (communicationChannelFilter !== undefined)
            url_ += "CommunicationChannelFilter=" + encodeURIComponent("" + communicationChannelFilter) + "&";
        if (outletCodeFilter !== undefined)
            url_ += "OutletCodeFilter=" + encodeURIComponent("" + outletCodeFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetSurveyTargetAudienceDetailForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetSurveyTargetAudienceDetailForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetSurveyTargetAudienceDetailForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetSurveyTargetAudienceDetailForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetSurveyTargetAudienceDetailForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetSurveyTargetAudienceDetailForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getSurveyTargetAudienceDetailForEdit(id: number | null | undefined): Observable<GetSurveyTargetAudienceDetailForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/SurveyTargetAudienceDetails/GetSurveyTargetAudienceDetailForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSurveyTargetAudienceDetailForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSurveyTargetAudienceDetailForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetSurveyTargetAudienceDetailForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetSurveyTargetAudienceDetailForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetSurveyTargetAudienceDetailForEdit(response: HttpResponseBase): Observable<GetSurveyTargetAudienceDetailForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetSurveyTargetAudienceDetailForEditOutput.fromJS(resultData200) : new GetSurveyTargetAudienceDetailForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSurveyTargetAudienceDetailForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditSurveyTargetAudienceDetailDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SurveyTargetAudienceDetails/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SurveyTargetAudienceDetails/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class SurveyTargetAudiencesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param targetAudienceNameFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param statusFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, targetAudienceNameFilter: string | null | undefined, descriptionFilter: string | null | undefined, statusFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetSurveyTargetAudienceForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/SurveyTargetAudiences/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (targetAudienceNameFilter !== undefined)
            url_ += "TargetAudienceNameFilter=" + encodeURIComponent("" + targetAudienceNameFilter) + "&";
        if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetSurveyTargetAudienceForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetSurveyTargetAudienceForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetSurveyTargetAudienceForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetSurveyTargetAudienceForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetSurveyTargetAudienceForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetSurveyTargetAudienceForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getSurveyTargetAudienceForEdit(id: number | null | undefined): Observable<GetSurveyTargetAudienceForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/SurveyTargetAudiences/GetSurveyTargetAudienceForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSurveyTargetAudienceForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSurveyTargetAudienceForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetSurveyTargetAudienceForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetSurveyTargetAudienceForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetSurveyTargetAudienceForEdit(response: HttpResponseBase): Observable<GetSurveyTargetAudienceForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetSurveyTargetAudienceForEditOutput.fromJS(resultData200) : new GetSurveyTargetAudienceForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSurveyTargetAudienceForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditSurveyTargetAudienceDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SurveyTargetAudiences/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SurveyTargetAudiences/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class SurveyTicketDetailsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param surveyTransactionCodeFilter (optional) 
     * @param questionCodeFilter (optional) 
     * @param questionDescriptionFilter (optional) 
     * @param answerIDFilter (optional) 
     * @param answerDescriptionFilter (optional) 
     * @param maxTimeSpendFilter (optional) 
     * @param minTimeSpendFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, surveyTransactionCodeFilter: string | null | undefined, questionCodeFilter: string | null | undefined, questionDescriptionFilter: string | null | undefined, answerIDFilter: string | null | undefined, answerDescriptionFilter: string | null | undefined, maxTimeSpendFilter: number | null | undefined, minTimeSpendFilter: number | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetSurveyTicketDetailForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/SurveyTicketDetails/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (surveyTransactionCodeFilter !== undefined)
            url_ += "SurveyTransactionCodeFilter=" + encodeURIComponent("" + surveyTransactionCodeFilter) + "&";
        if (questionCodeFilter !== undefined)
            url_ += "QuestionCodeFilter=" + encodeURIComponent("" + questionCodeFilter) + "&";
        if (questionDescriptionFilter !== undefined)
            url_ += "QuestionDescriptionFilter=" + encodeURIComponent("" + questionDescriptionFilter) + "&";
        if (answerIDFilter !== undefined)
            url_ += "AnswerIDFilter=" + encodeURIComponent("" + answerIDFilter) + "&";
        if (answerDescriptionFilter !== undefined)
            url_ += "AnswerDescriptionFilter=" + encodeURIComponent("" + answerDescriptionFilter) + "&";
        if (maxTimeSpendFilter !== undefined)
            url_ += "MaxTimeSpendFilter=" + encodeURIComponent("" + maxTimeSpendFilter) + "&";
        if (minTimeSpendFilter !== undefined)
            url_ += "MinTimeSpendFilter=" + encodeURIComponent("" + minTimeSpendFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetSurveyTicketDetailForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetSurveyTicketDetailForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetSurveyTicketDetailForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetSurveyTicketDetailForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetSurveyTicketDetailForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetSurveyTicketDetailForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getSurveyTicketDetailForEdit(id: number | null | undefined): Observable<GetSurveyTicketDetailForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/SurveyTicketDetails/GetSurveyTicketDetailForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSurveyTicketDetailForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSurveyTicketDetailForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetSurveyTicketDetailForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetSurveyTicketDetailForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetSurveyTicketDetailForEdit(response: HttpResponseBase): Observable<GetSurveyTicketDetailForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetSurveyTicketDetailForEditOutput.fromJS(resultData200) : new GetSurveyTicketDetailForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSurveyTicketDetailForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditSurveyTicketDetailDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SurveyTicketDetails/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SurveyTicketDetails/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param surveyTransactionCodeFilter (optional) 
     * @param questionCodeFilter (optional) 
     * @param questionDescriptionFilter (optional) 
     * @param answerIDFilter (optional) 
     * @param answerDescriptionFilter (optional) 
     * @param maxTimeSpendFilter (optional) 
     * @param minTimeSpendFilter (optional) 
     * @return Success
     */
    getSurveyTicketDetailsToExcel(filter: string | null | undefined, surveyTransactionCodeFilter: string | null | undefined, questionCodeFilter: string | null | undefined, questionDescriptionFilter: string | null | undefined, answerIDFilter: string | null | undefined, answerDescriptionFilter: string | null | undefined, maxTimeSpendFilter: number | null | undefined, minTimeSpendFilter: number | null | undefined): Observable<ConsumerDBFileDto> {
        let url_ = this.baseUrl + "/api/services/app/SurveyTicketDetails/GetSurveyTicketDetailsToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (surveyTransactionCodeFilter !== undefined)
            url_ += "SurveyTransactionCodeFilter=" + encodeURIComponent("" + surveyTransactionCodeFilter) + "&";
        if (questionCodeFilter !== undefined)
            url_ += "QuestionCodeFilter=" + encodeURIComponent("" + questionCodeFilter) + "&";
        if (questionDescriptionFilter !== undefined)
            url_ += "QuestionDescriptionFilter=" + encodeURIComponent("" + questionDescriptionFilter) + "&";
        if (answerIDFilter !== undefined)
            url_ += "AnswerIDFilter=" + encodeURIComponent("" + answerIDFilter) + "&";
        if (answerDescriptionFilter !== undefined)
            url_ += "AnswerDescriptionFilter=" + encodeURIComponent("" + answerDescriptionFilter) + "&";
        if (maxTimeSpendFilter !== undefined)
            url_ += "MaxTimeSpendFilter=" + encodeURIComponent("" + maxTimeSpendFilter) + "&";
        if (minTimeSpendFilter !== undefined)
            url_ += "MinTimeSpendFilter=" + encodeURIComponent("" + minTimeSpendFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSurveyTicketDetailsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSurveyTicketDetailsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<ConsumerDBFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ConsumerDBFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetSurveyTicketDetailsToExcel(response: HttpResponseBase): Observable<ConsumerDBFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? ConsumerDBFileDto.fromJS(resultData200) : new ConsumerDBFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ConsumerDBFileDto>(<any>null);
    }
}

@Injectable()
export class SurveyTicketHeadersServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param surveyTransactionCodeFilter (optional) 
     * @param surveyMonkeyCodeFilter (optional) 
     * @param surveyUserFilter (optional) 
     * @param maxStartDateFilter (optional) 
     * @param minStartDateFilter (optional) 
     * @param maxSurveyTimeFilter (optional) 
     * @param minSurveyTimeFilter (optional) 
     * @param statusFilter (optional) 
     * @param referenceCodeFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, surveyTransactionCodeFilter: string | null | undefined, surveyMonkeyCodeFilter: string | null | undefined, surveyUserFilter: string | null | undefined, maxStartDateFilter: moment.Moment | null | undefined, minStartDateFilter: moment.Moment | null | undefined, maxSurveyTimeFilter: number | null | undefined, minSurveyTimeFilter: number | null | undefined, statusFilter: string | null | undefined, referenceCodeFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetSurveyTicketHeaderForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/SurveyTicketHeaders/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (surveyTransactionCodeFilter !== undefined)
            url_ += "SurveyTransactionCodeFilter=" + encodeURIComponent("" + surveyTransactionCodeFilter) + "&";
        if (surveyMonkeyCodeFilter !== undefined)
            url_ += "SurveyMonkeyCodeFilter=" + encodeURIComponent("" + surveyMonkeyCodeFilter) + "&";
        if (surveyUserFilter !== undefined)
            url_ += "SurveyUserFilter=" + encodeURIComponent("" + surveyUserFilter) + "&";
        if (maxStartDateFilter !== undefined)
            url_ += "MaxStartDateFilter=" + encodeURIComponent(maxStartDateFilter ? "" + maxStartDateFilter.toJSON() : "") + "&";
        if (minStartDateFilter !== undefined)
            url_ += "MinStartDateFilter=" + encodeURIComponent(minStartDateFilter ? "" + minStartDateFilter.toJSON() : "") + "&";
        if (maxSurveyTimeFilter !== undefined)
            url_ += "MaxSurveyTimeFilter=" + encodeURIComponent("" + maxSurveyTimeFilter) + "&";
        if (minSurveyTimeFilter !== undefined)
            url_ += "MinSurveyTimeFilter=" + encodeURIComponent("" + minSurveyTimeFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (referenceCodeFilter !== undefined)
            url_ += "ReferenceCodeFilter=" + encodeURIComponent("" + referenceCodeFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetSurveyTicketHeaderForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetSurveyTicketHeaderForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetSurveyTicketHeaderForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetSurveyTicketHeaderForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetSurveyTicketHeaderForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetSurveyTicketHeaderForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getSurveyTicketHeaderForEdit(id: number | null | undefined): Observable<GetSurveyTicketHeaderForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/SurveyTicketHeaders/GetSurveyTicketHeaderForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSurveyTicketHeaderForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSurveyTicketHeaderForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetSurveyTicketHeaderForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetSurveyTicketHeaderForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetSurveyTicketHeaderForEdit(response: HttpResponseBase): Observable<GetSurveyTicketHeaderForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetSurveyTicketHeaderForEditOutput.fromJS(resultData200) : new GetSurveyTicketHeaderForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSurveyTicketHeaderForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditSurveyTicketHeaderDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SurveyTicketHeaders/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SurveyTicketHeaders/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param surveyTransactionCodeFilter (optional) 
     * @param surveyMonkeyCodeFilter (optional) 
     * @param surveyUserFilter (optional) 
     * @param maxStartDateFilter (optional) 
     * @param minStartDateFilter (optional) 
     * @param maxSurveyTimeFilter (optional) 
     * @param minSurveyTimeFilter (optional) 
     * @param statusFilter (optional) 
     * @param referenceCodeFilter (optional) 
     * @return Success
     */
    getSurveyTicketHeadersToExcel(filter: string | null | undefined, surveyTransactionCodeFilter: string | null | undefined, surveyMonkeyCodeFilter: string | null | undefined, surveyUserFilter: string | null | undefined, maxStartDateFilter: moment.Moment | null | undefined, minStartDateFilter: moment.Moment | null | undefined, maxSurveyTimeFilter: number | null | undefined, minSurveyTimeFilter: number | null | undefined, statusFilter: string | null | undefined, referenceCodeFilter: string | null | undefined): Observable<ConsumerDBFileDto> {
        let url_ = this.baseUrl + "/api/services/app/SurveyTicketHeaders/GetSurveyTicketHeadersToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (surveyTransactionCodeFilter !== undefined)
            url_ += "SurveyTransactionCodeFilter=" + encodeURIComponent("" + surveyTransactionCodeFilter) + "&";
        if (surveyMonkeyCodeFilter !== undefined)
            url_ += "SurveyMonkeyCodeFilter=" + encodeURIComponent("" + surveyMonkeyCodeFilter) + "&";
        if (surveyUserFilter !== undefined)
            url_ += "SurveyUserFilter=" + encodeURIComponent("" + surveyUserFilter) + "&";
        if (maxStartDateFilter !== undefined)
            url_ += "MaxStartDateFilter=" + encodeURIComponent(maxStartDateFilter ? "" + maxStartDateFilter.toJSON() : "") + "&";
        if (minStartDateFilter !== undefined)
            url_ += "MinStartDateFilter=" + encodeURIComponent(minStartDateFilter ? "" + minStartDateFilter.toJSON() : "") + "&";
        if (maxSurveyTimeFilter !== undefined)
            url_ += "MaxSurveyTimeFilter=" + encodeURIComponent("" + maxSurveyTimeFilter) + "&";
        if (minSurveyTimeFilter !== undefined)
            url_ += "MinSurveyTimeFilter=" + encodeURIComponent("" + minSurveyTimeFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (referenceCodeFilter !== undefined)
            url_ += "ReferenceCodeFilter=" + encodeURIComponent("" + referenceCodeFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSurveyTicketHeadersToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSurveyTicketHeadersToExcel(<any>response_);
                } catch (e) {
                    return <Observable<ConsumerDBFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ConsumerDBFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetSurveyTicketHeadersToExcel(response: HttpResponseBase): Observable<ConsumerDBFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? ConsumerDBFileDto.fromJS(resultData200) : new ConsumerDBFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ConsumerDBFileDto>(<any>null);
    }
}

@Injectable()
export class SurveyTransactionsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param surveyCodeFilter (optional) 
     * @param channelFilter (optional) 
     * @param memberNameFilter (optional) 
     * @param phoneFilter (optional) 
     * @param zaloChatIDFilter (optional) 
     * @param emailFilter (optional) 
     * @param facebookIDFilter (optional) 
     * @param memberCodeFilter (optional) 
     * @param contentFilter (optional) 
     * @param subjectFilter (optional) 
     * @param outletCodeFilter (optional) 
     * @param questionCodeFilter (optional) 
     * @param answerCodeFilter (optional) 
     * @param messageIDFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, surveyCodeFilter: string | null | undefined, channelFilter: string | null | undefined, memberNameFilter: string | null | undefined, phoneFilter: string | null | undefined, zaloChatIDFilter: string | null | undefined, emailFilter: string | null | undefined, facebookIDFilter: string | null | undefined, memberCodeFilter: string | null | undefined, contentFilter: string | null | undefined, subjectFilter: string | null | undefined, outletCodeFilter: string | null | undefined, questionCodeFilter: string | null | undefined, answerCodeFilter: string | null | undefined, messageIDFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetSurveyTransactionForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/SurveyTransactions/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (surveyCodeFilter !== undefined)
            url_ += "SurveyCodeFilter=" + encodeURIComponent("" + surveyCodeFilter) + "&";
        if (channelFilter !== undefined)
            url_ += "ChannelFilter=" + encodeURIComponent("" + channelFilter) + "&";
        if (memberNameFilter !== undefined)
            url_ += "MemberNameFilter=" + encodeURIComponent("" + memberNameFilter) + "&";
        if (phoneFilter !== undefined)
            url_ += "PhoneFilter=" + encodeURIComponent("" + phoneFilter) + "&";
        if (zaloChatIDFilter !== undefined)
            url_ += "ZaloChatIDFilter=" + encodeURIComponent("" + zaloChatIDFilter) + "&";
        if (emailFilter !== undefined)
            url_ += "EmailFilter=" + encodeURIComponent("" + emailFilter) + "&";
        if (facebookIDFilter !== undefined)
            url_ += "FacebookIDFilter=" + encodeURIComponent("" + facebookIDFilter) + "&";
        if (memberCodeFilter !== undefined)
            url_ += "MemberCodeFilter=" + encodeURIComponent("" + memberCodeFilter) + "&";
        if (contentFilter !== undefined)
            url_ += "ContentFilter=" + encodeURIComponent("" + contentFilter) + "&";
        if (subjectFilter !== undefined)
            url_ += "SubjectFilter=" + encodeURIComponent("" + subjectFilter) + "&";
        if (outletCodeFilter !== undefined)
            url_ += "OutletCodeFilter=" + encodeURIComponent("" + outletCodeFilter) + "&";
        if (questionCodeFilter !== undefined)
            url_ += "QuestionCodeFilter=" + encodeURIComponent("" + questionCodeFilter) + "&";
        if (answerCodeFilter !== undefined)
            url_ += "AnswerCodeFilter=" + encodeURIComponent("" + answerCodeFilter) + "&";
        if (messageIDFilter !== undefined)
            url_ += "MessageIDFilter=" + encodeURIComponent("" + messageIDFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetSurveyTransactionForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetSurveyTransactionForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetSurveyTransactionForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetSurveyTransactionForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetSurveyTransactionForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetSurveyTransactionForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getSurveyTransactionForEdit(id: number | null | undefined): Observable<GetSurveyTransactionForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/SurveyTransactions/GetSurveyTransactionForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSurveyTransactionForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSurveyTransactionForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetSurveyTransactionForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetSurveyTransactionForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetSurveyTransactionForEdit(response: HttpResponseBase): Observable<GetSurveyTransactionForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetSurveyTransactionForEditOutput.fromJS(resultData200) : new GetSurveyTransactionForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSurveyTransactionForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditSurveyTransactionDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SurveyTransactions/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SurveyTransactions/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param surveyCodeFilter (optional) 
     * @param channelFilter (optional) 
     * @param memberNameFilter (optional) 
     * @param phoneFilter (optional) 
     * @param zaloChatIDFilter (optional) 
     * @param emailFilter (optional) 
     * @param facebookIDFilter (optional) 
     * @param memberCodeFilter (optional) 
     * @param contentFilter (optional) 
     * @param subjectFilter (optional) 
     * @param outletCodeFilter (optional) 
     * @param questionCodeFilter (optional) 
     * @param answerCodeFilter (optional) 
     * @param messageIDFilter (optional) 
     * @return Success
     */
    getSurveyTransactionsToExcel(filter: string | null | undefined, surveyCodeFilter: string | null | undefined, channelFilter: string | null | undefined, memberNameFilter: string | null | undefined, phoneFilter: string | null | undefined, zaloChatIDFilter: string | null | undefined, emailFilter: string | null | undefined, facebookIDFilter: string | null | undefined, memberCodeFilter: string | null | undefined, contentFilter: string | null | undefined, subjectFilter: string | null | undefined, outletCodeFilter: string | null | undefined, questionCodeFilter: string | null | undefined, answerCodeFilter: string | null | undefined, messageIDFilter: string | null | undefined): Observable<SocialSurveyFileDto> {
        let url_ = this.baseUrl + "/api/services/app/SurveyTransactions/GetSurveyTransactionsToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (surveyCodeFilter !== undefined)
            url_ += "SurveyCodeFilter=" + encodeURIComponent("" + surveyCodeFilter) + "&";
        if (channelFilter !== undefined)
            url_ += "ChannelFilter=" + encodeURIComponent("" + channelFilter) + "&";
        if (memberNameFilter !== undefined)
            url_ += "MemberNameFilter=" + encodeURIComponent("" + memberNameFilter) + "&";
        if (phoneFilter !== undefined)
            url_ += "PhoneFilter=" + encodeURIComponent("" + phoneFilter) + "&";
        if (zaloChatIDFilter !== undefined)
            url_ += "ZaloChatIDFilter=" + encodeURIComponent("" + zaloChatIDFilter) + "&";
        if (emailFilter !== undefined)
            url_ += "EmailFilter=" + encodeURIComponent("" + emailFilter) + "&";
        if (facebookIDFilter !== undefined)
            url_ += "FacebookIDFilter=" + encodeURIComponent("" + facebookIDFilter) + "&";
        if (memberCodeFilter !== undefined)
            url_ += "MemberCodeFilter=" + encodeURIComponent("" + memberCodeFilter) + "&";
        if (contentFilter !== undefined)
            url_ += "ContentFilter=" + encodeURIComponent("" + contentFilter) + "&";
        if (subjectFilter !== undefined)
            url_ += "SubjectFilter=" + encodeURIComponent("" + subjectFilter) + "&";
        if (outletCodeFilter !== undefined)
            url_ += "OutletCodeFilter=" + encodeURIComponent("" + outletCodeFilter) + "&";
        if (questionCodeFilter !== undefined)
            url_ += "QuestionCodeFilter=" + encodeURIComponent("" + questionCodeFilter) + "&";
        if (answerCodeFilter !== undefined)
            url_ += "AnswerCodeFilter=" + encodeURIComponent("" + answerCodeFilter) + "&";
        if (messageIDFilter !== undefined)
            url_ += "MessageIDFilter=" + encodeURIComponent("" + messageIDFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSurveyTransactionsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSurveyTransactionsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<SocialSurveyFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SocialSurveyFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetSurveyTransactionsToExcel(response: HttpResponseBase): Observable<SocialSurveyFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? SocialSurveyFileDto.fromJS(resultData200) : new SocialSurveyFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SocialSurveyFileDto>(<any>null);
    }
}

@Injectable()
export class SuspendTransactionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param memberCodeFilter (optional) 
     * @param maxSuspendedMonthFilter (optional) 
     * @param minSuspendedMonthFilter (optional) 
     * @param isActiveFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, memberCodeFilter: string | null | undefined, maxSuspendedMonthFilter: moment.Moment | null | undefined, minSuspendedMonthFilter: moment.Moment | null | undefined, isActiveFilter: number | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetSuspendTransactionForView> {
        let url_ = this.baseUrl + "/api/services/app/SuspendTransaction/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (memberCodeFilter !== undefined)
            url_ += "MemberCodeFilter=" + encodeURIComponent("" + memberCodeFilter) + "&";
        if (maxSuspendedMonthFilter !== undefined)
            url_ += "MaxSuspendedMonthFilter=" + encodeURIComponent(maxSuspendedMonthFilter ? "" + maxSuspendedMonthFilter.toJSON() : "") + "&";
        if (minSuspendedMonthFilter !== undefined)
            url_ += "MinSuspendedMonthFilter=" + encodeURIComponent(minSuspendedMonthFilter ? "" + minSuspendedMonthFilter.toJSON() : "") + "&";
        if (isActiveFilter !== undefined)
            url_ += "IsActiveFilter=" + encodeURIComponent("" + isActiveFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetSuspendTransactionForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetSuspendTransactionForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetSuspendTransactionForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetSuspendTransactionForView.fromJS(resultData200) : new PagedResultDtoOfGetSuspendTransactionForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetSuspendTransactionForView>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getSuspendTransactionForEdit(id: number | null | undefined): Observable<GetSuspendTransactionForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/SuspendTransaction/GetSuspendTransactionForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSuspendTransactionForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSuspendTransactionForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetSuspendTransactionForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetSuspendTransactionForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetSuspendTransactionForEdit(response: HttpResponseBase): Observable<GetSuspendTransactionForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetSuspendTransactionForEditOutput.fromJS(resultData200) : new GetSuspendTransactionForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSuspendTransactionForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditSuspendTransactionDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SuspendTransaction/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SuspendTransaction/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class SyncSalesTrackingHandlerServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param message (optional) 
     * @return Success
     */
    handle(message: SalesTrackingEventData | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SyncSalesTrackingHandler/Handle";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(message);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processHandle(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHandle(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processHandle(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class SystemSettingsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param codeFilter (optional) 
     * @param isActiveFilter (optional) 
     * @param validCoinTypeFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, codeFilter: string | null | undefined, isActiveFilter: number | null | undefined, validCoinTypeFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetSystemSettingForView> {
        let url_ = this.baseUrl + "/api/services/app/SystemSettings/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&";
        if (isActiveFilter !== undefined)
            url_ += "IsActiveFilter=" + encodeURIComponent("" + isActiveFilter) + "&";
        if (validCoinTypeFilter !== undefined)
            url_ += "ValidCoinTypeFilter=" + encodeURIComponent("" + validCoinTypeFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetSystemSettingForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetSystemSettingForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetSystemSettingForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetSystemSettingForView.fromJS(resultData200) : new PagedResultDtoOfGetSystemSettingForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetSystemSettingForView>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getSystemSettingForEdit(id: number | null | undefined): Observable<GetSystemSettingForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/SystemSettings/GetSystemSettingForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSystemSettingForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSystemSettingForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetSystemSettingForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetSystemSettingForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetSystemSettingForEdit(response: HttpResponseBase): Observable<GetSystemSettingForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetSystemSettingForEditOutput.fromJS(resultData200) : new GetSystemSettingForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSystemSettingForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditSystemSettingDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SystemSettings/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrentSystemSetting(): Observable<GetSystemSettingForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/SystemSettings/GetCurrentSystemSetting";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCurrentSystemSetting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentSystemSetting(<any>response_);
                } catch (e) {
                    return <Observable<GetSystemSettingForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetSystemSettingForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetCurrentSystemSetting(response: HttpResponseBase): Observable<GetSystemSettingForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetSystemSettingForEditOutput.fromJS(resultData200) : new GetSystemSettingForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSystemSettingForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEditExt(input: CreateOrEditSystemSettingDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SystemSettings/CreateOrEditExt";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEditExt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditExt(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEditExt(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class TagServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param valueFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, valueFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetTagForView> {
        let url_ = this.baseUrl + "/api/services/app/Tag/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (valueFilter !== undefined)
            url_ += "ValueFilter=" + encodeURIComponent("" + valueFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetTagForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetTagForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetTagForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetTagForView.fromJS(resultData200) : new PagedResultDtoOfGetTagForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetTagForView>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getTagForEdit(id: number | null | undefined): Observable<GetTagForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Tag/GetTagForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetTagForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTagForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetTagForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetTagForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetTagForEdit(response: HttpResponseBase): Observable<GetTagForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetTagForEditOutput.fromJS(resultData200) : new GetTagForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTagForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditTagDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tag/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tag/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class TargetAudienceDetailsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param conditionTypeFilter (optional) 
     * @param conditionNameFilter (optional) 
     * @param operatorFilter (optional) 
     * @param valueFromFilter (optional) 
     * @param valueToFilter (optional) 
     * @param maxValueFromNumberFilter (optional) 
     * @param minValueFromNumberFilter (optional) 
     * @param maxValueToNumberFilter (optional) 
     * @param minValueToNumberFilter (optional) 
     * @param maxValueFromDateFilter (optional) 
     * @param minValueFromDateFilter (optional) 
     * @param maxValueToDateFilter (optional) 
     * @param minValueToDateFilter (optional) 
     * @param maxTargetAudienceIDFilter (optional) 
     * @param minTargetAudienceIDFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, conditionTypeFilter: string | null | undefined, conditionNameFilter: string | null | undefined, operatorFilter: string | null | undefined, valueFromFilter: string | null | undefined, valueToFilter: string | null | undefined, maxValueFromNumberFilter: number | null | undefined, minValueFromNumberFilter: number | null | undefined, maxValueToNumberFilter: number | null | undefined, minValueToNumberFilter: number | null | undefined, maxValueFromDateFilter: moment.Moment | null | undefined, minValueFromDateFilter: moment.Moment | null | undefined, maxValueToDateFilter: moment.Moment | null | undefined, minValueToDateFilter: moment.Moment | null | undefined, maxTargetAudienceIDFilter: number | null | undefined, minTargetAudienceIDFilter: number | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetTargetAudienceDetailForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/TargetAudienceDetails/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (conditionTypeFilter !== undefined)
            url_ += "ConditionTypeFilter=" + encodeURIComponent("" + conditionTypeFilter) + "&";
        if (conditionNameFilter !== undefined)
            url_ += "ConditionNameFilter=" + encodeURIComponent("" + conditionNameFilter) + "&";
        if (operatorFilter !== undefined)
            url_ += "OperatorFilter=" + encodeURIComponent("" + operatorFilter) + "&";
        if (valueFromFilter !== undefined)
            url_ += "ValueFromFilter=" + encodeURIComponent("" + valueFromFilter) + "&";
        if (valueToFilter !== undefined)
            url_ += "ValueToFilter=" + encodeURIComponent("" + valueToFilter) + "&";
        if (maxValueFromNumberFilter !== undefined)
            url_ += "MaxValueFromNumberFilter=" + encodeURIComponent("" + maxValueFromNumberFilter) + "&";
        if (minValueFromNumberFilter !== undefined)
            url_ += "MinValueFromNumberFilter=" + encodeURIComponent("" + minValueFromNumberFilter) + "&";
        if (maxValueToNumberFilter !== undefined)
            url_ += "MaxValueToNumberFilter=" + encodeURIComponent("" + maxValueToNumberFilter) + "&";
        if (minValueToNumberFilter !== undefined)
            url_ += "MinValueToNumberFilter=" + encodeURIComponent("" + minValueToNumberFilter) + "&";
        if (maxValueFromDateFilter !== undefined)
            url_ += "MaxValueFromDateFilter=" + encodeURIComponent(maxValueFromDateFilter ? "" + maxValueFromDateFilter.toJSON() : "") + "&";
        if (minValueFromDateFilter !== undefined)
            url_ += "MinValueFromDateFilter=" + encodeURIComponent(minValueFromDateFilter ? "" + minValueFromDateFilter.toJSON() : "") + "&";
        if (maxValueToDateFilter !== undefined)
            url_ += "MaxValueToDateFilter=" + encodeURIComponent(maxValueToDateFilter ? "" + maxValueToDateFilter.toJSON() : "") + "&";
        if (minValueToDateFilter !== undefined)
            url_ += "MinValueToDateFilter=" + encodeURIComponent(minValueToDateFilter ? "" + minValueToDateFilter.toJSON() : "") + "&";
        if (maxTargetAudienceIDFilter !== undefined)
            url_ += "MaxTargetAudienceIDFilter=" + encodeURIComponent("" + maxTargetAudienceIDFilter) + "&";
        if (minTargetAudienceIDFilter !== undefined)
            url_ += "MinTargetAudienceIDFilter=" + encodeURIComponent("" + minTargetAudienceIDFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetTargetAudienceDetailForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetTargetAudienceDetailForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetTargetAudienceDetailForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetTargetAudienceDetailForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetTargetAudienceDetailForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetTargetAudienceDetailForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getTargetAudienceDetailForEdit(id: number | null | undefined): Observable<GetTargetAudienceDetailForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/TargetAudienceDetails/GetTargetAudienceDetailForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetTargetAudienceDetailForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTargetAudienceDetailForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetTargetAudienceDetailForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetTargetAudienceDetailForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetTargetAudienceDetailForEdit(response: HttpResponseBase): Observable<GetTargetAudienceDetailForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetTargetAudienceDetailForEditOutput.fromJS(resultData200) : new GetTargetAudienceDetailForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTargetAudienceDetailForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditTargetAudienceDetailDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TargetAudienceDetails/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TargetAudienceDetails/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param conditionTypeFilter (optional) 
     * @param conditionNameFilter (optional) 
     * @param operatorFilter (optional) 
     * @param valueFromFilter (optional) 
     * @param valueToFilter (optional) 
     * @param maxValueFromNumberFilter (optional) 
     * @param minValueFromNumberFilter (optional) 
     * @param maxValueToNumberFilter (optional) 
     * @param minValueToNumberFilter (optional) 
     * @param maxValueFromDateFilter (optional) 
     * @param minValueFromDateFilter (optional) 
     * @param maxValueToDateFilter (optional) 
     * @param minValueToDateFilter (optional) 
     * @param maxTargetAudienceIDFilter (optional) 
     * @param minTargetAudienceIDFilter (optional) 
     * @return Success
     */
    getTargetAudienceDetailsToExcel(filter: string | null | undefined, conditionTypeFilter: string | null | undefined, conditionNameFilter: string | null | undefined, operatorFilter: string | null | undefined, valueFromFilter: string | null | undefined, valueToFilter: string | null | undefined, maxValueFromNumberFilter: number | null | undefined, minValueFromNumberFilter: number | null | undefined, maxValueToNumberFilter: number | null | undefined, minValueToNumberFilter: number | null | undefined, maxValueFromDateFilter: moment.Moment | null | undefined, minValueFromDateFilter: moment.Moment | null | undefined, maxValueToDateFilter: moment.Moment | null | undefined, minValueToDateFilter: moment.Moment | null | undefined, maxTargetAudienceIDFilter: number | null | undefined, minTargetAudienceIDFilter: number | null | undefined): Observable<ConsumerDBFileDto> {
        let url_ = this.baseUrl + "/api/services/app/TargetAudienceDetails/GetTargetAudienceDetailsToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (conditionTypeFilter !== undefined)
            url_ += "ConditionTypeFilter=" + encodeURIComponent("" + conditionTypeFilter) + "&";
        if (conditionNameFilter !== undefined)
            url_ += "ConditionNameFilter=" + encodeURIComponent("" + conditionNameFilter) + "&";
        if (operatorFilter !== undefined)
            url_ += "OperatorFilter=" + encodeURIComponent("" + operatorFilter) + "&";
        if (valueFromFilter !== undefined)
            url_ += "ValueFromFilter=" + encodeURIComponent("" + valueFromFilter) + "&";
        if (valueToFilter !== undefined)
            url_ += "ValueToFilter=" + encodeURIComponent("" + valueToFilter) + "&";
        if (maxValueFromNumberFilter !== undefined)
            url_ += "MaxValueFromNumberFilter=" + encodeURIComponent("" + maxValueFromNumberFilter) + "&";
        if (minValueFromNumberFilter !== undefined)
            url_ += "MinValueFromNumberFilter=" + encodeURIComponent("" + minValueFromNumberFilter) + "&";
        if (maxValueToNumberFilter !== undefined)
            url_ += "MaxValueToNumberFilter=" + encodeURIComponent("" + maxValueToNumberFilter) + "&";
        if (minValueToNumberFilter !== undefined)
            url_ += "MinValueToNumberFilter=" + encodeURIComponent("" + minValueToNumberFilter) + "&";
        if (maxValueFromDateFilter !== undefined)
            url_ += "MaxValueFromDateFilter=" + encodeURIComponent(maxValueFromDateFilter ? "" + maxValueFromDateFilter.toJSON() : "") + "&";
        if (minValueFromDateFilter !== undefined)
            url_ += "MinValueFromDateFilter=" + encodeURIComponent(minValueFromDateFilter ? "" + minValueFromDateFilter.toJSON() : "") + "&";
        if (maxValueToDateFilter !== undefined)
            url_ += "MaxValueToDateFilter=" + encodeURIComponent(maxValueToDateFilter ? "" + maxValueToDateFilter.toJSON() : "") + "&";
        if (minValueToDateFilter !== undefined)
            url_ += "MinValueToDateFilter=" + encodeURIComponent(minValueToDateFilter ? "" + minValueToDateFilter.toJSON() : "") + "&";
        if (maxTargetAudienceIDFilter !== undefined)
            url_ += "MaxTargetAudienceIDFilter=" + encodeURIComponent("" + maxTargetAudienceIDFilter) + "&";
        if (minTargetAudienceIDFilter !== undefined)
            url_ += "MinTargetAudienceIDFilter=" + encodeURIComponent("" + minTargetAudienceIDFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetTargetAudienceDetailsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTargetAudienceDetailsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<ConsumerDBFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ConsumerDBFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetTargetAudienceDetailsToExcel(response: HttpResponseBase): Observable<ConsumerDBFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? ConsumerDBFileDto.fromJS(resultData200) : new ConsumerDBFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ConsumerDBFileDto>(<any>null);
    }
}

@Injectable()
export class TargetAudienceHeadersServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param targetAudienceNameFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param statusFilter (optional) 
     * @param applyForMembershipFilter (optional) 
     * @param selectTOPFilter (optional) 
     * @param conditionTOPSortingFilter (optional) 
     * @param maxQuantityTOPGroupFilter (optional) 
     * @param minQuantityTOPGroupFilter (optional) 
     * @param targetAudienceNameUnsignFilter (optional) 
     * @param isFixedListFilter (optional) 
     * @param maxNumberOfMemberFilter (optional) 
     * @param minNumberOfMemberFilter (optional) 
     * @param maxScheduleTimeFilter (optional) 
     * @param minScheduleTimeFilter (optional) 
     * @param maxLastRunTimeFilter (optional) 
     * @param minLastRunTimeFilter (optional) 
     * @param maxNextRunTimeFilter (optional) 
     * @param minNextRunTimeFilter (optional) 
     * @param runStatusFilter (optional) 
     * @param idFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, targetAudienceNameFilter: string | null | undefined, descriptionFilter: string | null | undefined, statusFilter: string | null | undefined, applyForMembershipFilter: number | null | undefined, selectTOPFilter: number | null | undefined, conditionTOPSortingFilter: string | null | undefined, maxQuantityTOPGroupFilter: number | null | undefined, minQuantityTOPGroupFilter: number | null | undefined, targetAudienceNameUnsignFilter: string | null | undefined, isFixedListFilter: number | null | undefined, maxNumberOfMemberFilter: number | null | undefined, minNumberOfMemberFilter: number | null | undefined, maxScheduleTimeFilter: number | null | undefined, minScheduleTimeFilter: number | null | undefined, maxLastRunTimeFilter: moment.Moment | null | undefined, minLastRunTimeFilter: moment.Moment | null | undefined, maxNextRunTimeFilter: moment.Moment | null | undefined, minNextRunTimeFilter: moment.Moment | null | undefined, runStatusFilter: string | null | undefined, idFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetTargetAudienceHeaderForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/TargetAudienceHeaders/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (targetAudienceNameFilter !== undefined)
            url_ += "TargetAudienceNameFilter=" + encodeURIComponent("" + targetAudienceNameFilter) + "&";
        if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (applyForMembershipFilter !== undefined)
            url_ += "ApplyForMembershipFilter=" + encodeURIComponent("" + applyForMembershipFilter) + "&";
        if (selectTOPFilter !== undefined)
            url_ += "SelectTOPFilter=" + encodeURIComponent("" + selectTOPFilter) + "&";
        if (conditionTOPSortingFilter !== undefined)
            url_ += "ConditionTOPSortingFilter=" + encodeURIComponent("" + conditionTOPSortingFilter) + "&";
        if (maxQuantityTOPGroupFilter !== undefined)
            url_ += "MaxQuantityTOPGroupFilter=" + encodeURIComponent("" + maxQuantityTOPGroupFilter) + "&";
        if (minQuantityTOPGroupFilter !== undefined)
            url_ += "MinQuantityTOPGroupFilter=" + encodeURIComponent("" + minQuantityTOPGroupFilter) + "&";
        if (targetAudienceNameUnsignFilter !== undefined)
            url_ += "TargetAudienceNameUnsignFilter=" + encodeURIComponent("" + targetAudienceNameUnsignFilter) + "&";
        if (isFixedListFilter !== undefined)
            url_ += "IsFixedListFilter=" + encodeURIComponent("" + isFixedListFilter) + "&";
        if (maxNumberOfMemberFilter !== undefined)
            url_ += "MaxNumberOfMemberFilter=" + encodeURIComponent("" + maxNumberOfMemberFilter) + "&";
        if (minNumberOfMemberFilter !== undefined)
            url_ += "MinNumberOfMemberFilter=" + encodeURIComponent("" + minNumberOfMemberFilter) + "&";
        if (maxScheduleTimeFilter !== undefined)
            url_ += "MaxScheduleTimeFilter=" + encodeURIComponent("" + maxScheduleTimeFilter) + "&";
        if (minScheduleTimeFilter !== undefined)
            url_ += "MinScheduleTimeFilter=" + encodeURIComponent("" + minScheduleTimeFilter) + "&";
        if (maxLastRunTimeFilter !== undefined)
            url_ += "MaxLastRunTimeFilter=" + encodeURIComponent(maxLastRunTimeFilter ? "" + maxLastRunTimeFilter.toJSON() : "") + "&";
        if (minLastRunTimeFilter !== undefined)
            url_ += "MinLastRunTimeFilter=" + encodeURIComponent(minLastRunTimeFilter ? "" + minLastRunTimeFilter.toJSON() : "") + "&";
        if (maxNextRunTimeFilter !== undefined)
            url_ += "MaxNextRunTimeFilter=" + encodeURIComponent(maxNextRunTimeFilter ? "" + maxNextRunTimeFilter.toJSON() : "") + "&";
        if (minNextRunTimeFilter !== undefined)
            url_ += "MinNextRunTimeFilter=" + encodeURIComponent(minNextRunTimeFilter ? "" + minNextRunTimeFilter.toJSON() : "") + "&";
        if (runStatusFilter !== undefined)
            url_ += "RunStatusFilter=" + encodeURIComponent("" + runStatusFilter) + "&";
        if (idFilter !== undefined)
            url_ += "IdFilter=" + encodeURIComponent("" + idFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetTargetAudienceHeaderForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetTargetAudienceHeaderForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetTargetAudienceHeaderForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetTargetAudienceHeaderForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetTargetAudienceHeaderForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetTargetAudienceHeaderForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getTargetAudienceHeaderForEdit(id: number | null | undefined): Observable<GetTargetAudienceHeaderForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/TargetAudienceHeaders/GetTargetAudienceHeaderForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetTargetAudienceHeaderForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTargetAudienceHeaderForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetTargetAudienceHeaderForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetTargetAudienceHeaderForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetTargetAudienceHeaderForEdit(response: HttpResponseBase): Observable<GetTargetAudienceHeaderForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetTargetAudienceHeaderForEditOutput.fromJS(resultData200) : new GetTargetAudienceHeaderForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTargetAudienceHeaderForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditTargetAudienceHeaderDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TargetAudienceHeaders/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TargetAudienceHeaders/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param targetAudienceNameFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param statusFilter (optional) 
     * @param applyForMembershipFilter (optional) 
     * @param selectTOPFilter (optional) 
     * @param conditionTOPSortingFilter (optional) 
     * @param maxQuantityTOPGroupFilter (optional) 
     * @param minQuantityTOPGroupFilter (optional) 
     * @param targetAudienceNameUnsignFilter (optional) 
     * @param isFixedListFilter (optional) 
     * @param maxNumberOfMemberFilter (optional) 
     * @param minNumberOfMemberFilter (optional) 
     * @param maxScheduleTimeFilter (optional) 
     * @param minScheduleTimeFilter (optional) 
     * @param maxLastRunTimeFilter (optional) 
     * @param minLastRunTimeFilter (optional) 
     * @param maxNextRunTimeFilter (optional) 
     * @param minNextRunTimeFilter (optional) 
     * @param runStatusFilter (optional) 
     * @return Success
     */
    getTargetAudienceHeadersToExcel(filter: string | null | undefined, targetAudienceNameFilter: string | null | undefined, descriptionFilter: string | null | undefined, statusFilter: string | null | undefined, applyForMembershipFilter: number | null | undefined, selectTOPFilter: number | null | undefined, conditionTOPSortingFilter: string | null | undefined, maxQuantityTOPGroupFilter: number | null | undefined, minQuantityTOPGroupFilter: number | null | undefined, targetAudienceNameUnsignFilter: string | null | undefined, isFixedListFilter: number | null | undefined, maxNumberOfMemberFilter: number | null | undefined, minNumberOfMemberFilter: number | null | undefined, maxScheduleTimeFilter: number | null | undefined, minScheduleTimeFilter: number | null | undefined, maxLastRunTimeFilter: moment.Moment | null | undefined, minLastRunTimeFilter: moment.Moment | null | undefined, maxNextRunTimeFilter: moment.Moment | null | undefined, minNextRunTimeFilter: moment.Moment | null | undefined, runStatusFilter: string | null | undefined): Observable<ConsumerDBFileDto> {
        let url_ = this.baseUrl + "/api/services/app/TargetAudienceHeaders/GetTargetAudienceHeadersToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (targetAudienceNameFilter !== undefined)
            url_ += "TargetAudienceNameFilter=" + encodeURIComponent("" + targetAudienceNameFilter) + "&";
        if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (applyForMembershipFilter !== undefined)
            url_ += "ApplyForMembershipFilter=" + encodeURIComponent("" + applyForMembershipFilter) + "&";
        if (selectTOPFilter !== undefined)
            url_ += "SelectTOPFilter=" + encodeURIComponent("" + selectTOPFilter) + "&";
        if (conditionTOPSortingFilter !== undefined)
            url_ += "ConditionTOPSortingFilter=" + encodeURIComponent("" + conditionTOPSortingFilter) + "&";
        if (maxQuantityTOPGroupFilter !== undefined)
            url_ += "MaxQuantityTOPGroupFilter=" + encodeURIComponent("" + maxQuantityTOPGroupFilter) + "&";
        if (minQuantityTOPGroupFilter !== undefined)
            url_ += "MinQuantityTOPGroupFilter=" + encodeURIComponent("" + minQuantityTOPGroupFilter) + "&";
        if (targetAudienceNameUnsignFilter !== undefined)
            url_ += "TargetAudienceNameUnsignFilter=" + encodeURIComponent("" + targetAudienceNameUnsignFilter) + "&";
        if (isFixedListFilter !== undefined)
            url_ += "IsFixedListFilter=" + encodeURIComponent("" + isFixedListFilter) + "&";
        if (maxNumberOfMemberFilter !== undefined)
            url_ += "MaxNumberOfMemberFilter=" + encodeURIComponent("" + maxNumberOfMemberFilter) + "&";
        if (minNumberOfMemberFilter !== undefined)
            url_ += "MinNumberOfMemberFilter=" + encodeURIComponent("" + minNumberOfMemberFilter) + "&";
        if (maxScheduleTimeFilter !== undefined)
            url_ += "MaxScheduleTimeFilter=" + encodeURIComponent("" + maxScheduleTimeFilter) + "&";
        if (minScheduleTimeFilter !== undefined)
            url_ += "MinScheduleTimeFilter=" + encodeURIComponent("" + minScheduleTimeFilter) + "&";
        if (maxLastRunTimeFilter !== undefined)
            url_ += "MaxLastRunTimeFilter=" + encodeURIComponent(maxLastRunTimeFilter ? "" + maxLastRunTimeFilter.toJSON() : "") + "&";
        if (minLastRunTimeFilter !== undefined)
            url_ += "MinLastRunTimeFilter=" + encodeURIComponent(minLastRunTimeFilter ? "" + minLastRunTimeFilter.toJSON() : "") + "&";
        if (maxNextRunTimeFilter !== undefined)
            url_ += "MaxNextRunTimeFilter=" + encodeURIComponent(maxNextRunTimeFilter ? "" + maxNextRunTimeFilter.toJSON() : "") + "&";
        if (minNextRunTimeFilter !== undefined)
            url_ += "MinNextRunTimeFilter=" + encodeURIComponent(minNextRunTimeFilter ? "" + minNextRunTimeFilter.toJSON() : "") + "&";
        if (runStatusFilter !== undefined)
            url_ += "RunStatusFilter=" + encodeURIComponent("" + runStatusFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetTargetAudienceHeadersToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTargetAudienceHeadersToExcel(<any>response_);
                } catch (e) {
                    return <Observable<ConsumerDBFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ConsumerDBFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetTargetAudienceHeadersToExcel(response: HttpResponseBase): Observable<ConsumerDBFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? ConsumerDBFileDto.fromJS(resultData200) : new ConsumerDBFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ConsumerDBFileDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEditCustom(input: CreateOrEditTargetAudienceDtoCustom | null | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/TargetAudienceHeaders/CreateOrEditCustom";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEditCustom(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditCustom(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEditCustom(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    search(input: GetAllTargetAudienceHeadersInput | null | undefined): Observable<PagedResultDtoOfGetTargetAudienceHeaderForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/TargetAudienceHeaders/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetTargetAudienceHeaderForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetTargetAudienceHeaderForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<PagedResultDtoOfGetTargetAudienceHeaderForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetTargetAudienceHeaderForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetTargetAudienceHeaderForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetTargetAudienceHeaderForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getTargetAudienceHeaderForEditCustom(id: number | null | undefined): Observable<GetTargetAudienceHeaderForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/TargetAudienceHeaders/GetTargetAudienceHeaderForEditCustom?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetTargetAudienceHeaderForEditCustom(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTargetAudienceHeaderForEditCustom(<any>response_);
                } catch (e) {
                    return <Observable<GetTargetAudienceHeaderForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetTargetAudienceHeaderForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetTargetAudienceHeaderForEditCustom(response: HttpResponseBase): Observable<GetTargetAudienceHeaderForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetTargetAudienceHeaderForEditOutput.fromJS(resultData200) : new GetTargetAudienceHeaderForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTargetAudienceHeaderForEditOutput>(<any>null);
    }

    /**
     * @param arg (optional) 
     * @return Success
     */
    businessEnqueue(arg: SegmentationAgrs | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TargetAudienceHeaders/BusinessEnqueue";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(arg);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processBusinessEnqueue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBusinessEnqueue(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processBusinessEnqueue(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class TargetAudiencesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param parentCode (optional) 
     * @param type (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getTree(parentCode: string | null | undefined, type: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<GetTargetAudienceByCodeForView> {
        let url_ = this.baseUrl + "/api/services/app/TargetAudiences/GetTree?";
        if (parentCode !== undefined)
            url_ += "ParentCode=" + encodeURIComponent("" + parentCode) + "&";
        if (type !== undefined)
            url_ += "Type=" + encodeURIComponent("" + type) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetTree(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTree(<any>response_);
                } catch (e) {
                    return <Observable<GetTargetAudienceByCodeForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetTargetAudienceByCodeForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetTree(response: HttpResponseBase): Observable<GetTargetAudienceByCodeForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetTargetAudienceByCodeForView.fromJS(resultData200) : new GetTargetAudienceByCodeForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTargetAudienceByCodeForView>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param type (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getListLevel(filter: string | null | undefined, type: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<GetTargetAudienceLevel[]> {
        let url_ = this.baseUrl + "/api/services/app/TargetAudiences/GetListLevel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (type !== undefined)
            url_ += "Type=" + encodeURIComponent("" + type) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetListLevel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetListLevel(<any>response_);
                } catch (e) {
                    return <Observable<GetTargetAudienceLevel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetTargetAudienceLevel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetListLevel(response: HttpResponseBase): Observable<GetTargetAudienceLevel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(GetTargetAudienceLevel.fromJS(item));
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTargetAudienceLevel[]>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param type (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getListLevelWithCode(filter: string | null | undefined, type: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<GetTargetAudienceLevel[]> {
        let url_ = this.baseUrl + "/api/services/app/TargetAudiences/GetListLevelWithCode?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (type !== undefined)
            url_ += "Type=" + encodeURIComponent("" + type) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetListLevelWithCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetListLevelWithCode(<any>response_);
                } catch (e) {
                    return <Observable<GetTargetAudienceLevel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetTargetAudienceLevel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetListLevelWithCode(response: HttpResponseBase): Observable<GetTargetAudienceLevel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(GetTargetAudienceLevel.fromJS(item));
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTargetAudienceLevel[]>(<any>null);
    }
}

@Injectable()
export class TargetAudienceUsersServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param phoneFilter (optional) 
     * @param zaloChatIDFilter (optional) 
     * @param emailFilter (optional) 
     * @param facebookIDFilter (optional) 
     * @param memberCodeFilter (optional) 
     * @param communicationLanguageFilter (optional) 
     * @param nameUnSignFilter (optional) 
     * @param maxTargetAudienceIDFilter (optional) 
     * @param minTargetAudienceIDFilter (optional) 
     * @param targetAudienceHeaderIdFilter (optional) 
     * @param idFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, nameFilter: string | null | undefined, phoneFilter: string | null | undefined, zaloChatIDFilter: string | null | undefined, emailFilter: string | null | undefined, facebookIDFilter: string | null | undefined, memberCodeFilter: string | null | undefined, communicationLanguageFilter: string | null | undefined, nameUnSignFilter: string | null | undefined, maxTargetAudienceIDFilter: number | null | undefined, minTargetAudienceIDFilter: number | null | undefined, targetAudienceHeaderIdFilter: string | null | undefined, idFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetTargetAudienceUserForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/TargetAudienceUsers/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (phoneFilter !== undefined)
            url_ += "PhoneFilter=" + encodeURIComponent("" + phoneFilter) + "&";
        if (zaloChatIDFilter !== undefined)
            url_ += "ZaloChatIDFilter=" + encodeURIComponent("" + zaloChatIDFilter) + "&";
        if (emailFilter !== undefined)
            url_ += "EmailFilter=" + encodeURIComponent("" + emailFilter) + "&";
        if (facebookIDFilter !== undefined)
            url_ += "FacebookIDFilter=" + encodeURIComponent("" + facebookIDFilter) + "&";
        if (memberCodeFilter !== undefined)
            url_ += "MemberCodeFilter=" + encodeURIComponent("" + memberCodeFilter) + "&";
        if (communicationLanguageFilter !== undefined)
            url_ += "CommunicationLanguageFilter=" + encodeURIComponent("" + communicationLanguageFilter) + "&";
        if (nameUnSignFilter !== undefined)
            url_ += "NameUnSignFilter=" + encodeURIComponent("" + nameUnSignFilter) + "&";
        if (maxTargetAudienceIDFilter !== undefined)
            url_ += "MaxTargetAudienceIDFilter=" + encodeURIComponent("" + maxTargetAudienceIDFilter) + "&";
        if (minTargetAudienceIDFilter !== undefined)
            url_ += "MinTargetAudienceIDFilter=" + encodeURIComponent("" + minTargetAudienceIDFilter) + "&";
        if (targetAudienceHeaderIdFilter !== undefined)
            url_ += "TargetAudienceHeaderIdFilter=" + encodeURIComponent("" + targetAudienceHeaderIdFilter) + "&";
        if (idFilter !== undefined)
            url_ += "IdFilter=" + encodeURIComponent("" + idFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetTargetAudienceUserForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetTargetAudienceUserForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetTargetAudienceUserForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetTargetAudienceUserForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetTargetAudienceUserForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetTargetAudienceUserForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getTargetAudienceUserForEdit(id: number | null | undefined): Observable<GetTargetAudienceUserForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/TargetAudienceUsers/GetTargetAudienceUserForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetTargetAudienceUserForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTargetAudienceUserForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetTargetAudienceUserForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetTargetAudienceUserForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetTargetAudienceUserForEdit(response: HttpResponseBase): Observable<GetTargetAudienceUserForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetTargetAudienceUserForEditOutput.fromJS(resultData200) : new GetTargetAudienceUserForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTargetAudienceUserForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditTargetAudienceUserDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TargetAudienceUsers/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TargetAudienceUsers/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param phoneFilter (optional) 
     * @param zaloChatIDFilter (optional) 
     * @param emailFilter (optional) 
     * @param facebookIDFilter (optional) 
     * @param memberCodeFilter (optional) 
     * @param communicationLanguageFilter (optional) 
     * @param nameUnSignFilter (optional) 
     * @param maxTargetAudienceIDFilter (optional) 
     * @param minTargetAudienceIDFilter (optional) 
     * @return Success
     */
    getTargetAudienceUsersToExcel(filter: string | null | undefined, nameFilter: string | null | undefined, phoneFilter: string | null | undefined, zaloChatIDFilter: string | null | undefined, emailFilter: string | null | undefined, facebookIDFilter: string | null | undefined, memberCodeFilter: string | null | undefined, communicationLanguageFilter: string | null | undefined, nameUnSignFilter: string | null | undefined, maxTargetAudienceIDFilter: number | null | undefined, minTargetAudienceIDFilter: number | null | undefined): Observable<ConsumerDBFileDto> {
        let url_ = this.baseUrl + "/api/services/app/TargetAudienceUsers/GetTargetAudienceUsersToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (phoneFilter !== undefined)
            url_ += "PhoneFilter=" + encodeURIComponent("" + phoneFilter) + "&";
        if (zaloChatIDFilter !== undefined)
            url_ += "ZaloChatIDFilter=" + encodeURIComponent("" + zaloChatIDFilter) + "&";
        if (emailFilter !== undefined)
            url_ += "EmailFilter=" + encodeURIComponent("" + emailFilter) + "&";
        if (facebookIDFilter !== undefined)
            url_ += "FacebookIDFilter=" + encodeURIComponent("" + facebookIDFilter) + "&";
        if (memberCodeFilter !== undefined)
            url_ += "MemberCodeFilter=" + encodeURIComponent("" + memberCodeFilter) + "&";
        if (communicationLanguageFilter !== undefined)
            url_ += "CommunicationLanguageFilter=" + encodeURIComponent("" + communicationLanguageFilter) + "&";
        if (nameUnSignFilter !== undefined)
            url_ += "NameUnSignFilter=" + encodeURIComponent("" + nameUnSignFilter) + "&";
        if (maxTargetAudienceIDFilter !== undefined)
            url_ += "MaxTargetAudienceIDFilter=" + encodeURIComponent("" + maxTargetAudienceIDFilter) + "&";
        if (minTargetAudienceIDFilter !== undefined)
            url_ += "MinTargetAudienceIDFilter=" + encodeURIComponent("" + minTargetAudienceIDFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetTargetAudienceUsersToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTargetAudienceUsersToExcel(<any>response_);
                } catch (e) {
                    return <Observable<ConsumerDBFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ConsumerDBFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetTargetAudienceUsersToExcel(response: HttpResponseBase): Observable<ConsumerDBFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? ConsumerDBFileDto.fromJS(resultData200) : new ConsumerDBFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ConsumerDBFileDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    search(input: GetAllTargetAudienceUsersInput | null | undefined): Observable<PagedResultDtoOfGetTargetAudienceUserForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/TargetAudienceUsers/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetTargetAudienceUserForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetTargetAudienceUserForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<PagedResultDtoOfGetTargetAudienceUserForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetTargetAudienceUserForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetTargetAudienceUserForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetTargetAudienceUserForViewDto>(<any>null);
    }

    /**
     * @param arg (optional) 
     * @return Success
     */
    export(arg: SegmentationExportArgs | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TargetAudienceUsers/Export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(arg);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExport(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processExport(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class TaskAnswersServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param questionCodeFilter (optional) 
     * @param contentVNFilter (optional) 
     * @param taskCodeFilter (optional) 
     * @param answerCodeFilter (optional) 
     * @param contentENFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, questionCodeFilter: string | null | undefined, contentVNFilter: string | null | undefined, taskCodeFilter: string | null | undefined, answerCodeFilter: string | null | undefined, contentENFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetTaskAnswerForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/TaskAnswers/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (questionCodeFilter !== undefined)
            url_ += "QuestionCodeFilter=" + encodeURIComponent("" + questionCodeFilter) + "&";
        if (contentVNFilter !== undefined)
            url_ += "ContentVNFilter=" + encodeURIComponent("" + contentVNFilter) + "&";
        if (taskCodeFilter !== undefined)
            url_ += "TaskCodeFilter=" + encodeURIComponent("" + taskCodeFilter) + "&";
        if (answerCodeFilter !== undefined)
            url_ += "AnswerCodeFilter=" + encodeURIComponent("" + answerCodeFilter) + "&";
        if (contentENFilter !== undefined)
            url_ += "ContentENFilter=" + encodeURIComponent("" + contentENFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetTaskAnswerForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetTaskAnswerForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetTaskAnswerForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetTaskAnswerForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetTaskAnswerForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetTaskAnswerForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getTaskAnswerForEdit(id: number | null | undefined): Observable<GetTaskAnswerForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/TaskAnswers/GetTaskAnswerForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetTaskAnswerForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTaskAnswerForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetTaskAnswerForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetTaskAnswerForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetTaskAnswerForEdit(response: HttpResponseBase): Observable<GetTaskAnswerForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetTaskAnswerForEditOutput.fromJS(resultData200) : new GetTaskAnswerForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTaskAnswerForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditTaskAnswerDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TaskAnswers/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TaskAnswers/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class TaskInfosServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param codeFilter (optional) 
     * @param nameFilter (optional) 
     * @param statusFilter (optional) 
     * @param maxTargetAudienceIDFilter (optional) 
     * @param minTargetAudienceIDFilter (optional) 
     * @param descriptionVNFilter (optional) 
     * @param imageLinkFilter (optional) 
     * @param isImmediatelyFilter (optional) 
     * @param maxEffectiveFromFilter (optional) 
     * @param minEffectiveFromFilter (optional) 
     * @param maxEffectiveToFilter (optional) 
     * @param minEffectiveToFilter (optional) 
     * @param occurTypeFilter (optional) 
     * @param cronFilter (optional) 
     * @param maxPublishTimeFilter (optional) 
     * @param minPublishTimeFilter (optional) 
     * @param channelFilter (optional) 
     * @param descriptionENFilter (optional) 
     * @param targetAudienceTypeFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, codeFilter: string | null | undefined, nameFilter: string | null | undefined, statusFilter: string | null | undefined, maxTargetAudienceIDFilter: number | null | undefined, minTargetAudienceIDFilter: number | null | undefined, descriptionVNFilter: string | null | undefined, imageLinkFilter: string | null | undefined, isImmediatelyFilter: number | null | undefined, maxEffectiveFromFilter: moment.Moment | null | undefined, minEffectiveFromFilter: moment.Moment | null | undefined, maxEffectiveToFilter: moment.Moment | null | undefined, minEffectiveToFilter: moment.Moment | null | undefined, occurTypeFilter: string | null | undefined, cronFilter: string | null | undefined, maxPublishTimeFilter: moment.Moment | null | undefined, minPublishTimeFilter: moment.Moment | null | undefined, channelFilter: string | null | undefined, descriptionENFilter: string | null | undefined, targetAudienceTypeFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetTaskInfoForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/TaskInfos/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&";
        if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (maxTargetAudienceIDFilter !== undefined)
            url_ += "MaxTargetAudienceIDFilter=" + encodeURIComponent("" + maxTargetAudienceIDFilter) + "&";
        if (minTargetAudienceIDFilter !== undefined)
            url_ += "MinTargetAudienceIDFilter=" + encodeURIComponent("" + minTargetAudienceIDFilter) + "&";
        if (descriptionVNFilter !== undefined)
            url_ += "DescriptionVNFilter=" + encodeURIComponent("" + descriptionVNFilter) + "&";
        if (imageLinkFilter !== undefined)
            url_ += "ImageLinkFilter=" + encodeURIComponent("" + imageLinkFilter) + "&";
        if (isImmediatelyFilter !== undefined)
            url_ += "IsImmediatelyFilter=" + encodeURIComponent("" + isImmediatelyFilter) + "&";
        if (maxEffectiveFromFilter !== undefined)
            url_ += "MaxEffectiveFromFilter=" + encodeURIComponent(maxEffectiveFromFilter ? "" + maxEffectiveFromFilter.toJSON() : "") + "&";
        if (minEffectiveFromFilter !== undefined)
            url_ += "MinEffectiveFromFilter=" + encodeURIComponent(minEffectiveFromFilter ? "" + minEffectiveFromFilter.toJSON() : "") + "&";
        if (maxEffectiveToFilter !== undefined)
            url_ += "MaxEffectiveToFilter=" + encodeURIComponent(maxEffectiveToFilter ? "" + maxEffectiveToFilter.toJSON() : "") + "&";
        if (minEffectiveToFilter !== undefined)
            url_ += "MinEffectiveToFilter=" + encodeURIComponent(minEffectiveToFilter ? "" + minEffectiveToFilter.toJSON() : "") + "&";
        if (occurTypeFilter !== undefined)
            url_ += "OccurTypeFilter=" + encodeURIComponent("" + occurTypeFilter) + "&";
        if (cronFilter !== undefined)
            url_ += "CronFilter=" + encodeURIComponent("" + cronFilter) + "&";
        if (maxPublishTimeFilter !== undefined)
            url_ += "MaxPublishTimeFilter=" + encodeURIComponent(maxPublishTimeFilter ? "" + maxPublishTimeFilter.toJSON() : "") + "&";
        if (minPublishTimeFilter !== undefined)
            url_ += "MinPublishTimeFilter=" + encodeURIComponent(minPublishTimeFilter ? "" + minPublishTimeFilter.toJSON() : "") + "&";
        if (channelFilter !== undefined)
            url_ += "ChannelFilter=" + encodeURIComponent("" + channelFilter) + "&";
        if (descriptionENFilter !== undefined)
            url_ += "DescriptionENFilter=" + encodeURIComponent("" + descriptionENFilter) + "&";
        if (targetAudienceTypeFilter !== undefined)
            url_ += "TargetAudienceTypeFilter=" + encodeURIComponent("" + targetAudienceTypeFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetTaskInfoForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetTaskInfoForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetTaskInfoForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetTaskInfoForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetTaskInfoForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetTaskInfoForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getTaskInfoForEdit(id: number | null | undefined): Observable<GetTaskInfoForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/TaskInfos/GetTaskInfoForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetTaskInfoForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTaskInfoForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetTaskInfoForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetTaskInfoForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetTaskInfoForEdit(response: HttpResponseBase): Observable<GetTaskInfoForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetTaskInfoForEditOutput.fromJS(resultData200) : new GetTaskInfoForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTaskInfoForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditTaskInfoDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TaskInfos/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TaskInfos/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param visitPlanResultId (optional) 
     * @return Success
     */
    getTaskList(visitPlanResultId: number | null | undefined): Observable<GetTaskListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TaskInfos/GetTaskList?";
        if (visitPlanResultId !== undefined)
            url_ += "visitPlanResultId=" + encodeURIComponent("" + visitPlanResultId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetTaskList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTaskList(<any>response_);
                } catch (e) {
                    return <Observable<GetTaskListDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetTaskListDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetTaskList(response: HttpResponseBase): Observable<GetTaskListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(GetTaskListDto.fromJS(item));
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTaskListDto[]>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrUpdateTaskDetail(input: UpdateTaskListDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TaskInfos/CreateOrUpdateTaskDetail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrUpdateTaskDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateTaskDetail(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrUpdateTaskDetail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param memberCode (optional) 
     * @param salemanCode (optional) 
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getTaskResult(memberCode: string | null | undefined, salemanCode: string | null | undefined, fromDate: moment.Moment | null | undefined, toDate: moment.Moment | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetTaskResultListDto> {
        let url_ = this.baseUrl + "/api/services/app/TaskInfos/GetTaskResult?";
        if (memberCode !== undefined)
            url_ += "MemberCode=" + encodeURIComponent("" + memberCode) + "&";
        if (salemanCode !== undefined)
            url_ += "SalemanCode=" + encodeURIComponent("" + salemanCode) + "&";
        if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toJSON() : "") + "&";
        if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toJSON() : "") + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetTaskResult(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTaskResult(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetTaskResultListDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetTaskResultListDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetTaskResult(response: HttpResponseBase): Observable<PagedResultDtoOfGetTaskResultListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetTaskResultListDto.fromJS(resultData200) : new PagedResultDtoOfGetTaskResultListDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetTaskResultListDto>(<any>null);
    }

    /**
     * @param beatplanId (optional) 
     * @return Success
     */
    getTaskResultByBeatplanId(beatplanId: number | null | undefined): Observable<GetTaskResultListDto> {
        let url_ = this.baseUrl + "/api/services/app/TaskInfos/GetTaskResultByBeatplanId?";
        if (beatplanId !== undefined)
            url_ += "beatplanId=" + encodeURIComponent("" + beatplanId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetTaskResultByBeatplanId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTaskResultByBeatplanId(<any>response_);
                } catch (e) {
                    return <Observable<GetTaskResultListDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetTaskResultListDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetTaskResultByBeatplanId(response: HttpResponseBase): Observable<GetTaskResultListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetTaskResultListDto.fromJS(resultData200) : new GetTaskResultListDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTaskResultListDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    exportTaskDetail(input: TaskDetailExportDto[] | null | undefined): Observable<SocialRetailerFileDto> {
        let url_ = this.baseUrl + "/api/services/app/TaskInfos/ExportTaskDetail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processExportTaskDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportTaskDetail(<any>response_);
                } catch (e) {
                    return <Observable<SocialRetailerFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SocialRetailerFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processExportTaskDetail(response: HttpResponseBase): Observable<SocialRetailerFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? SocialRetailerFileDto.fromJS(resultData200) : new SocialRetailerFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SocialRetailerFileDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    exportTask(input: GetTaskListDto[] | null | undefined): Observable<SocialRetailerFileDto> {
        let url_ = this.baseUrl + "/api/services/app/TaskInfos/ExportTask";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processExportTask(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportTask(<any>response_);
                } catch (e) {
                    return <Observable<SocialRetailerFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SocialRetailerFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processExportTask(response: HttpResponseBase): Observable<SocialRetailerFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? SocialRetailerFileDto.fromJS(resultData200) : new SocialRetailerFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SocialRetailerFileDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    batchDelete(input: EntityDto[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TaskInfos/BatchDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processBatchDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBatchDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processBatchDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    search(input: GetAllTaskInfosInput | null | undefined): Observable<PagedResultDtoOfGetTaskInfoForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/TaskInfos/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetTaskInfoForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetTaskInfoForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<PagedResultDtoOfGetTaskInfoForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetTaskInfoForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetTaskInfoForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetTaskInfoForViewDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    searchExt(input: GetAllTaskInfosInput | null | undefined): Observable<PagedResultDtoOfGetTaskInfoForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/TaskInfos/SearchExt";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSearchExt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchExt(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetTaskInfoForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetTaskInfoForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processSearchExt(response: HttpResponseBase): Observable<PagedResultDtoOfGetTaskInfoForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetTaskInfoForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetTaskInfoForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetTaskInfoForViewDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createCustom(input: CreateOrEditTaskInforCustomDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TaskInfos/CreateCustom";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateCustom(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateCustom(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateCustom(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    editCustom(input: CreateOrEditTaskInforCustomDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TaskInfos/EditCustom";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processEditCustom(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditCustom(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processEditCustom(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param taskId (optional) 
     * @return Success
     */
    getTask(taskId: number | null | undefined): Observable<TaskForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/TaskInfos/GetTask?";
        if (taskId !== undefined)
            url_ += "taskId=" + encodeURIComponent("" + taskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetTask(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTask(<any>response_);
                } catch (e) {
                    return <Observable<TaskForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TaskForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetTask(response: HttpResponseBase): Observable<TaskForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? TaskForViewDto.fromJS(resultData200) : new TaskForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TaskForViewDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    submitTask(input: TaskForSubmit | null | undefined): Observable<SubmitTaskResponse> {
        let url_ = this.baseUrl + "/api/services/app/TaskInfos/SubmitTask";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSubmitTask(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubmitTask(<any>response_);
                } catch (e) {
                    return <Observable<SubmitTaskResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<SubmitTaskResponse>><any>_observableThrow(response_);
        }));
    }

    protected processSubmitTask(response: HttpResponseBase): Observable<SubmitTaskResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? SubmitTaskResponse.fromJS(resultData200) : new SubmitTaskResponse();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SubmitTaskResponse>(<any>null);
    }

    /**
     * @param taskId (optional) 
     * @return Success
     */
    cloneTask(taskId: number | null | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/TaskInfos/CloneTask?";
        if (taskId !== undefined)
            url_ += "taskId=" + encodeURIComponent("" + taskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCloneTask(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCloneTask(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processCloneTask(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param memberCodeFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getTaskByMember(memberCodeFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetTaskInfoForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/TaskInfos/GetTaskByMember?";
        if (memberCodeFilter !== undefined)
            url_ += "MemberCodeFilter=" + encodeURIComponent("" + memberCodeFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetTaskByMember(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTaskByMember(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetTaskInfoForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetTaskInfoForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetTaskByMember(response: HttpResponseBase): Observable<PagedResultDtoOfGetTaskInfoForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetTaskInfoForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetTaskInfoForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetTaskInfoForViewDto>(<any>null);
    }
}

@Injectable()
export class TaskManagementServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param name (optional) 
     * @param code (optional) 
     * @param effectiveFrom (optional) 
     * @param effectiveTo (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllTaskInfo(name: string | null | undefined, code: string | null | undefined, effectiveFrom: moment.Moment | null | undefined, effectiveTo: moment.Moment | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetTaskInfoForView> {
        let url_ = this.baseUrl + "/api/services/app/TaskManagement/GetAllTaskInfo?";
        if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (code !== undefined)
            url_ += "Code=" + encodeURIComponent("" + code) + "&";
        if (effectiveFrom !== undefined)
            url_ += "EffectiveFrom=" + encodeURIComponent(effectiveFrom ? "" + effectiveFrom.toJSON() : "") + "&";
        if (effectiveTo !== undefined)
            url_ += "EffectiveTo=" + encodeURIComponent(effectiveTo ? "" + effectiveTo.toJSON() : "") + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllTaskInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTaskInfo(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetTaskInfoForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetTaskInfoForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllTaskInfo(response: HttpResponseBase): Observable<PagedResultDtoOfGetTaskInfoForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetTaskInfoForView.fromJS(resultData200) : new PagedResultDtoOfGetTaskInfoForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetTaskInfoForView>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getTaskInfoForEdit(id: number | null | undefined): Observable<GetTaskInfoForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/TaskManagement/GetTaskInfoForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetTaskInfoForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTaskInfoForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetTaskInfoForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetTaskInfoForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetTaskInfoForEdit(response: HttpResponseBase): Observable<GetTaskInfoForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetTaskInfoForEditOutput.fromJS(resultData200) : new GetTaskInfoForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTaskInfoForEditOutput>(<any>null);
    }

    /**
     * @return Success
     */
    getAllTaskTargetaudience(): Observable<PagedResultDtoOfGetTaskTargetaudienceForView> {
        let url_ = this.baseUrl + "/api/services/app/TaskManagement/GetAllTaskTargetaudience";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllTaskTargetaudience(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTaskTargetaudience(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetTaskTargetaudienceForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetTaskTargetaudienceForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllTaskTargetaudience(response: HttpResponseBase): Observable<PagedResultDtoOfGetTaskTargetaudienceForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetTaskTargetaudienceForView.fromJS(resultData200) : new PagedResultDtoOfGetTaskTargetaudienceForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetTaskTargetaudienceForView>(<any>null);
    }
}

@Injectable()
export class TaskQuestionsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param codeFilter (optional) 
     * @param contentVNFilter (optional) 
     * @param taskCodeFilter (optional) 
     * @param questionTypeFilter (optional) 
     * @param maxOrderingFilter (optional) 
     * @param minOrderingFilter (optional) 
     * @param contentENFilter (optional) 
     * @param attachImageFilter (optional) 
     * @param imageNone_Link (optional) 
     * @param imageHaft_Link (optional) 
     * @param image_Full_Link (optional) 
     * @param minvalue (optional) 
     * @param maxvalue (optional) 
     * @param stepPass (optional) 
     * @param required (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, codeFilter: string | null | undefined, contentVNFilter: string | null | undefined, taskCodeFilter: string | null | undefined, questionTypeFilter: string | null | undefined, maxOrderingFilter: number | null | undefined, minOrderingFilter: number | null | undefined, contentENFilter: string | null | undefined, attachImageFilter: number | null | undefined, imageNone_Link: string | null | undefined, imageHaft_Link: string | null | undefined, image_Full_Link: string | null | undefined, minvalue: number | null | undefined, maxvalue: number | null | undefined, stepPass: number | null | undefined, required: boolean | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetTaskQuestionForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/TaskQuestions/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&";
        if (contentVNFilter !== undefined)
            url_ += "ContentVNFilter=" + encodeURIComponent("" + contentVNFilter) + "&";
        if (taskCodeFilter !== undefined)
            url_ += "TaskCodeFilter=" + encodeURIComponent("" + taskCodeFilter) + "&";
        if (questionTypeFilter !== undefined)
            url_ += "QuestionTypeFilter=" + encodeURIComponent("" + questionTypeFilter) + "&";
        if (maxOrderingFilter !== undefined)
            url_ += "MaxOrderingFilter=" + encodeURIComponent("" + maxOrderingFilter) + "&";
        if (minOrderingFilter !== undefined)
            url_ += "MinOrderingFilter=" + encodeURIComponent("" + minOrderingFilter) + "&";
        if (contentENFilter !== undefined)
            url_ += "ContentENFilter=" + encodeURIComponent("" + contentENFilter) + "&";
        if (attachImageFilter !== undefined)
            url_ += "AttachImageFilter=" + encodeURIComponent("" + attachImageFilter) + "&";
        if (imageNone_Link !== undefined)
            url_ += "ImageNone_Link=" + encodeURIComponent("" + imageNone_Link) + "&";
        if (imageHaft_Link !== undefined)
            url_ += "ImageHaft_Link=" + encodeURIComponent("" + imageHaft_Link) + "&";
        if (image_Full_Link !== undefined)
            url_ += "Image_Full_Link=" + encodeURIComponent("" + image_Full_Link) + "&";
        if (minvalue !== undefined)
            url_ += "Minvalue=" + encodeURIComponent("" + minvalue) + "&";
        if (maxvalue !== undefined)
            url_ += "Maxvalue=" + encodeURIComponent("" + maxvalue) + "&";
        if (stepPass !== undefined)
            url_ += "StepPass=" + encodeURIComponent("" + stepPass) + "&";
        if (required !== undefined)
            url_ += "Required=" + encodeURIComponent("" + required) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetTaskQuestionForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetTaskQuestionForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetTaskQuestionForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetTaskQuestionForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetTaskQuestionForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetTaskQuestionForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getTaskQuestionForEdit(id: number | null | undefined): Observable<GetTaskQuestionForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/TaskQuestions/GetTaskQuestionForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetTaskQuestionForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTaskQuestionForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetTaskQuestionForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetTaskQuestionForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetTaskQuestionForEdit(response: HttpResponseBase): Observable<GetTaskQuestionForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetTaskQuestionForEditOutput.fromJS(resultData200) : new GetTaskQuestionForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTaskQuestionForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditTaskQuestionDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TaskQuestions/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TaskQuestions/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param taskCode (optional) 
     * @return Success
     */
    getTaskQuestions(taskCode: string | null | undefined): Observable<GetTaskQuestionForEditOutput[]> {
        let url_ = this.baseUrl + "/api/services/app/TaskQuestions/GetTaskQuestions?";
        if (taskCode !== undefined)
            url_ += "taskCode=" + encodeURIComponent("" + taskCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetTaskQuestions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTaskQuestions(<any>response_);
                } catch (e) {
                    return <Observable<GetTaskQuestionForEditOutput[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetTaskQuestionForEditOutput[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetTaskQuestions(response: HttpResponseBase): Observable<GetTaskQuestionForEditOutput[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(GetTaskQuestionForEditOutput.fromJS(item));
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTaskQuestionForEditOutput[]>(<any>null);
    }
}

@Injectable()
export class TaskResponsesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param taskCodeFilter (optional) 
     * @param channelFilter (optional) 
     * @param memberNameFilter (optional) 
     * @param phoneFilter (optional) 
     * @param zaloChatIDFilter (optional) 
     * @param emailFilter (optional) 
     * @param facebookIDFilter (optional) 
     * @param memberCodeFilter (optional) 
     * @param questionContentFilter (optional) 
     * @param subjectFilter (optional) 
     * @param outletCodeFilter (optional) 
     * @param questionCodeFilter (optional) 
     * @param answerContentFilter (optional) 
     * @param messageIDFilter (optional) 
     * @param questionTypeFilter (optional) 
     * @param maxOrderingFilter (optional) 
     * @param minOrderingFilter (optional) 
     * @param imageLinkFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, taskCodeFilter: string | null | undefined, channelFilter: string | null | undefined, memberNameFilter: string | null | undefined, phoneFilter: string | null | undefined, zaloChatIDFilter: string | null | undefined, emailFilter: string | null | undefined, facebookIDFilter: string | null | undefined, memberCodeFilter: string | null | undefined, questionContentFilter: string | null | undefined, subjectFilter: string | null | undefined, outletCodeFilter: string | null | undefined, questionCodeFilter: string | null | undefined, answerContentFilter: string | null | undefined, messageIDFilter: string | null | undefined, questionTypeFilter: string | null | undefined, maxOrderingFilter: number | null | undefined, minOrderingFilter: number | null | undefined, imageLinkFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetTaskResponseForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/TaskResponses/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (taskCodeFilter !== undefined)
            url_ += "TaskCodeFilter=" + encodeURIComponent("" + taskCodeFilter) + "&";
        if (channelFilter !== undefined)
            url_ += "ChannelFilter=" + encodeURIComponent("" + channelFilter) + "&";
        if (memberNameFilter !== undefined)
            url_ += "MemberNameFilter=" + encodeURIComponent("" + memberNameFilter) + "&";
        if (phoneFilter !== undefined)
            url_ += "PhoneFilter=" + encodeURIComponent("" + phoneFilter) + "&";
        if (zaloChatIDFilter !== undefined)
            url_ += "ZaloChatIDFilter=" + encodeURIComponent("" + zaloChatIDFilter) + "&";
        if (emailFilter !== undefined)
            url_ += "EmailFilter=" + encodeURIComponent("" + emailFilter) + "&";
        if (facebookIDFilter !== undefined)
            url_ += "FacebookIDFilter=" + encodeURIComponent("" + facebookIDFilter) + "&";
        if (memberCodeFilter !== undefined)
            url_ += "MemberCodeFilter=" + encodeURIComponent("" + memberCodeFilter) + "&";
        if (questionContentFilter !== undefined)
            url_ += "QuestionContentFilter=" + encodeURIComponent("" + questionContentFilter) + "&";
        if (subjectFilter !== undefined)
            url_ += "SubjectFilter=" + encodeURIComponent("" + subjectFilter) + "&";
        if (outletCodeFilter !== undefined)
            url_ += "OutletCodeFilter=" + encodeURIComponent("" + outletCodeFilter) + "&";
        if (questionCodeFilter !== undefined)
            url_ += "QuestionCodeFilter=" + encodeURIComponent("" + questionCodeFilter) + "&";
        if (answerContentFilter !== undefined)
            url_ += "AnswerContentFilter=" + encodeURIComponent("" + answerContentFilter) + "&";
        if (messageIDFilter !== undefined)
            url_ += "MessageIDFilter=" + encodeURIComponent("" + messageIDFilter) + "&";
        if (questionTypeFilter !== undefined)
            url_ += "QuestionTypeFilter=" + encodeURIComponent("" + questionTypeFilter) + "&";
        if (maxOrderingFilter !== undefined)
            url_ += "MaxOrderingFilter=" + encodeURIComponent("" + maxOrderingFilter) + "&";
        if (minOrderingFilter !== undefined)
            url_ += "MinOrderingFilter=" + encodeURIComponent("" + minOrderingFilter) + "&";
        if (imageLinkFilter !== undefined)
            url_ += "ImageLinkFilter=" + encodeURIComponent("" + imageLinkFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetTaskResponseForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetTaskResponseForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetTaskResponseForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetTaskResponseForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetTaskResponseForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetTaskResponseForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getTaskResponseForEdit(id: number | null | undefined): Observable<GetTaskResponseForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/TaskResponses/GetTaskResponseForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetTaskResponseForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTaskResponseForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetTaskResponseForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetTaskResponseForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetTaskResponseForEdit(response: HttpResponseBase): Observable<GetTaskResponseForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetTaskResponseForEditOutput.fromJS(resultData200) : new GetTaskResponseForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTaskResponseForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditTaskResponseDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TaskResponses/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TaskResponses/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    listTaskResponse(input: GetListTaskResponseInput | null | undefined): Observable<PagedResultDtoOfGetTaskResponseForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/TaskResponses/ListTaskResponse";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processListTaskResponse(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListTaskResponse(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetTaskResponseForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetTaskResponseForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processListTaskResponse(response: HttpResponseBase): Observable<PagedResultDtoOfGetTaskResponseForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetTaskResponseForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetTaskResponseForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetTaskResponseForViewDto>(<any>null);
    }

    /**
     * @param taskCode (optional) 
     * @param memberCode (optional) 
     * @return Success
     */
    getTaskResponseDetail(taskCode: string | null | undefined, memberCode: string | null | undefined): Observable<GetTaskResponseDetailDto> {
        let url_ = this.baseUrl + "/api/services/app/TaskResponses/GetTaskResponseDetail?";
        if (taskCode !== undefined)
            url_ += "taskCode=" + encodeURIComponent("" + taskCode) + "&";
        if (memberCode !== undefined)
            url_ += "memberCode=" + encodeURIComponent("" + memberCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetTaskResponseDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTaskResponseDetail(<any>response_);
                } catch (e) {
                    return <Observable<GetTaskResponseDetailDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetTaskResponseDetailDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetTaskResponseDetail(response: HttpResponseBase): Observable<GetTaskResponseDetailDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetTaskResponseDetailDto.fromJS(resultData200) : new GetTaskResponseDetailDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTaskResponseDetailDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    taskResponseToExcel(input: GetListTaskResponseInput | null | undefined): Observable<SocialRetailerFileDto> {
        let url_ = this.baseUrl + "/api/services/app/TaskResponses/TaskResponseToExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processTaskResponseToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTaskResponseToExcel(<any>response_);
                } catch (e) {
                    return <Observable<SocialRetailerFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SocialRetailerFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processTaskResponseToExcel(response: HttpResponseBase): Observable<SocialRetailerFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? SocialRetailerFileDto.fromJS(resultData200) : new SocialRetailerFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SocialRetailerFileDto>(<any>null);
    }
}

@Injectable()
export class TaskTargetAudienceDetailsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param maxTaskTargetAudienceIDFilter (optional) 
     * @param minTaskTargetAudienceIDFilter (optional) 
     * @param nameFilter (optional) 
     * @param phoneFilter (optional) 
     * @param zaloChatIDFilter (optional) 
     * @param emailFilter (optional) 
     * @param facebookIDFilter (optional) 
     * @param memberCodeFilter (optional) 
     * @param communicationLanguageFilter (optional) 
     * @param communicationChannelFilter (optional) 
     * @param outletCodeFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, maxTaskTargetAudienceIDFilter: number | null | undefined, minTaskTargetAudienceIDFilter: number | null | undefined, nameFilter: string | null | undefined, phoneFilter: string | null | undefined, zaloChatIDFilter: string | null | undefined, emailFilter: string | null | undefined, facebookIDFilter: string | null | undefined, memberCodeFilter: string | null | undefined, communicationLanguageFilter: string | null | undefined, communicationChannelFilter: string | null | undefined, outletCodeFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetTaskTargetAudienceDetailForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/TaskTargetAudienceDetails/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxTaskTargetAudienceIDFilter !== undefined)
            url_ += "MaxTaskTargetAudienceIDFilter=" + encodeURIComponent("" + maxTaskTargetAudienceIDFilter) + "&";
        if (minTaskTargetAudienceIDFilter !== undefined)
            url_ += "MinTaskTargetAudienceIDFilter=" + encodeURIComponent("" + minTaskTargetAudienceIDFilter) + "&";
        if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (phoneFilter !== undefined)
            url_ += "PhoneFilter=" + encodeURIComponent("" + phoneFilter) + "&";
        if (zaloChatIDFilter !== undefined)
            url_ += "ZaloChatIDFilter=" + encodeURIComponent("" + zaloChatIDFilter) + "&";
        if (emailFilter !== undefined)
            url_ += "EmailFilter=" + encodeURIComponent("" + emailFilter) + "&";
        if (facebookIDFilter !== undefined)
            url_ += "FacebookIDFilter=" + encodeURIComponent("" + facebookIDFilter) + "&";
        if (memberCodeFilter !== undefined)
            url_ += "MemberCodeFilter=" + encodeURIComponent("" + memberCodeFilter) + "&";
        if (communicationLanguageFilter !== undefined)
            url_ += "CommunicationLanguageFilter=" + encodeURIComponent("" + communicationLanguageFilter) + "&";
        if (communicationChannelFilter !== undefined)
            url_ += "CommunicationChannelFilter=" + encodeURIComponent("" + communicationChannelFilter) + "&";
        if (outletCodeFilter !== undefined)
            url_ += "OutletCodeFilter=" + encodeURIComponent("" + outletCodeFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetTaskTargetAudienceDetailForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetTaskTargetAudienceDetailForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetTaskTargetAudienceDetailForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetTaskTargetAudienceDetailForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetTaskTargetAudienceDetailForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetTaskTargetAudienceDetailForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getTaskTargetAudienceDetailForEdit(id: number | null | undefined): Observable<GetTaskTargetAudienceDetailForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/TaskTargetAudienceDetails/GetTaskTargetAudienceDetailForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetTaskTargetAudienceDetailForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTaskTargetAudienceDetailForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetTaskTargetAudienceDetailForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetTaskTargetAudienceDetailForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetTaskTargetAudienceDetailForEdit(response: HttpResponseBase): Observable<GetTaskTargetAudienceDetailForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetTaskTargetAudienceDetailForEditOutput.fromJS(resultData200) : new GetTaskTargetAudienceDetailForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTaskTargetAudienceDetailForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditTaskTargetAudienceDetailDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TaskTargetAudienceDetails/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TaskTargetAudienceDetails/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class TaskTargetAudiencesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param targetAudienceNameFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param statusFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, targetAudienceNameFilter: string | null | undefined, descriptionFilter: string | null | undefined, statusFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetTaskTargetAudienceForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/TaskTargetAudiences/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (targetAudienceNameFilter !== undefined)
            url_ += "TargetAudienceNameFilter=" + encodeURIComponent("" + targetAudienceNameFilter) + "&";
        if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetTaskTargetAudienceForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetTaskTargetAudienceForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetTaskTargetAudienceForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetTaskTargetAudienceForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetTaskTargetAudienceForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetTaskTargetAudienceForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getTaskTargetAudienceForEdit(id: number | null | undefined): Observable<GetTaskTargetAudienceForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/TaskTargetAudiences/GetTaskTargetAudienceForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetTaskTargetAudienceForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTaskTargetAudienceForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetTaskTargetAudienceForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetTaskTargetAudienceForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetTaskTargetAudienceForEdit(response: HttpResponseBase): Observable<GetTaskTargetAudienceForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetTaskTargetAudienceForEditOutput.fromJS(resultData200) : new GetTaskTargetAudienceForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTaskTargetAudienceForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditTaskTargetAudienceDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TaskTargetAudiences/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TaskTargetAudiences/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class TempCoinBaselinesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param maxCoinFilter (optional) 
     * @param minCoinFilter (optional) 
     * @param memberCodeFilter (optional) 
     * @param baselineDataFilter (optional) 
     * @param sourceFilter (optional) 
     * @param maxConsumerIDFilter (optional) 
     * @param minConsumerIDFilter (optional) 
     * @param maxAvailableFromFilter (optional) 
     * @param minAvailableFromFilter (optional) 
     * @param maxAvailableToFilter (optional) 
     * @param minAvailableToFilter (optional) 
     * @param isSyncFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, maxCoinFilter: number | null | undefined, minCoinFilter: number | null | undefined, memberCodeFilter: string | null | undefined, baselineDataFilter: string | null | undefined, sourceFilter: string | null | undefined, maxConsumerIDFilter: number | null | undefined, minConsumerIDFilter: number | null | undefined, maxAvailableFromFilter: moment.Moment | null | undefined, minAvailableFromFilter: moment.Moment | null | undefined, maxAvailableToFilter: moment.Moment | null | undefined, minAvailableToFilter: moment.Moment | null | undefined, isSyncFilter: number | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetTempCoinBaselineForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/TempCoinBaselines/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxCoinFilter !== undefined)
            url_ += "MaxCoinFilter=" + encodeURIComponent("" + maxCoinFilter) + "&";
        if (minCoinFilter !== undefined)
            url_ += "MinCoinFilter=" + encodeURIComponent("" + minCoinFilter) + "&";
        if (memberCodeFilter !== undefined)
            url_ += "MemberCodeFilter=" + encodeURIComponent("" + memberCodeFilter) + "&";
        if (baselineDataFilter !== undefined)
            url_ += "BaselineDataFilter=" + encodeURIComponent("" + baselineDataFilter) + "&";
        if (sourceFilter !== undefined)
            url_ += "SourceFilter=" + encodeURIComponent("" + sourceFilter) + "&";
        if (maxConsumerIDFilter !== undefined)
            url_ += "MaxConsumerIDFilter=" + encodeURIComponent("" + maxConsumerIDFilter) + "&";
        if (minConsumerIDFilter !== undefined)
            url_ += "MinConsumerIDFilter=" + encodeURIComponent("" + minConsumerIDFilter) + "&";
        if (maxAvailableFromFilter !== undefined)
            url_ += "MaxAvailableFromFilter=" + encodeURIComponent(maxAvailableFromFilter ? "" + maxAvailableFromFilter.toJSON() : "") + "&";
        if (minAvailableFromFilter !== undefined)
            url_ += "MinAvailableFromFilter=" + encodeURIComponent(minAvailableFromFilter ? "" + minAvailableFromFilter.toJSON() : "") + "&";
        if (maxAvailableToFilter !== undefined)
            url_ += "MaxAvailableToFilter=" + encodeURIComponent(maxAvailableToFilter ? "" + maxAvailableToFilter.toJSON() : "") + "&";
        if (minAvailableToFilter !== undefined)
            url_ += "MinAvailableToFilter=" + encodeURIComponent(minAvailableToFilter ? "" + minAvailableToFilter.toJSON() : "") + "&";
        if (isSyncFilter !== undefined)
            url_ += "IsSyncFilter=" + encodeURIComponent("" + isSyncFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetTempCoinBaselineForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetTempCoinBaselineForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetTempCoinBaselineForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetTempCoinBaselineForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetTempCoinBaselineForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetTempCoinBaselineForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getTempCoinBaselineForEdit(id: number | null | undefined): Observable<GetTempCoinBaselineForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/TempCoinBaselines/GetTempCoinBaselineForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetTempCoinBaselineForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTempCoinBaselineForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetTempCoinBaselineForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetTempCoinBaselineForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetTempCoinBaselineForEdit(response: HttpResponseBase): Observable<GetTempCoinBaselineForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetTempCoinBaselineForEditOutput.fromJS(resultData200) : new GetTempCoinBaselineForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTempCoinBaselineForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditTempCoinBaselineDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TempCoinBaselines/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TempCoinBaselines/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param maxCoinFilter (optional) 
     * @param minCoinFilter (optional) 
     * @param memberCodeFilter (optional) 
     * @param baselineDataFilter (optional) 
     * @param sourceFilter (optional) 
     * @param maxConsumerIDFilter (optional) 
     * @param minConsumerIDFilter (optional) 
     * @param maxAvailableFromFilter (optional) 
     * @param minAvailableFromFilter (optional) 
     * @param maxAvailableToFilter (optional) 
     * @param minAvailableToFilter (optional) 
     * @param isSyncFilter (optional) 
     * @return Success
     */
    getTempCoinBaselinesToExcel(filter: string | null | undefined, maxCoinFilter: number | null | undefined, minCoinFilter: number | null | undefined, memberCodeFilter: string | null | undefined, baselineDataFilter: string | null | undefined, sourceFilter: string | null | undefined, maxConsumerIDFilter: number | null | undefined, minConsumerIDFilter: number | null | undefined, maxAvailableFromFilter: moment.Moment | null | undefined, minAvailableFromFilter: moment.Moment | null | undefined, maxAvailableToFilter: moment.Moment | null | undefined, minAvailableToFilter: moment.Moment | null | undefined, isSyncFilter: number | null | undefined): Observable<PointFileDto> {
        let url_ = this.baseUrl + "/api/services/app/TempCoinBaselines/GetTempCoinBaselinesToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxCoinFilter !== undefined)
            url_ += "MaxCoinFilter=" + encodeURIComponent("" + maxCoinFilter) + "&";
        if (minCoinFilter !== undefined)
            url_ += "MinCoinFilter=" + encodeURIComponent("" + minCoinFilter) + "&";
        if (memberCodeFilter !== undefined)
            url_ += "MemberCodeFilter=" + encodeURIComponent("" + memberCodeFilter) + "&";
        if (baselineDataFilter !== undefined)
            url_ += "BaselineDataFilter=" + encodeURIComponent("" + baselineDataFilter) + "&";
        if (sourceFilter !== undefined)
            url_ += "SourceFilter=" + encodeURIComponent("" + sourceFilter) + "&";
        if (maxConsumerIDFilter !== undefined)
            url_ += "MaxConsumerIDFilter=" + encodeURIComponent("" + maxConsumerIDFilter) + "&";
        if (minConsumerIDFilter !== undefined)
            url_ += "MinConsumerIDFilter=" + encodeURIComponent("" + minConsumerIDFilter) + "&";
        if (maxAvailableFromFilter !== undefined)
            url_ += "MaxAvailableFromFilter=" + encodeURIComponent(maxAvailableFromFilter ? "" + maxAvailableFromFilter.toJSON() : "") + "&";
        if (minAvailableFromFilter !== undefined)
            url_ += "MinAvailableFromFilter=" + encodeURIComponent(minAvailableFromFilter ? "" + minAvailableFromFilter.toJSON() : "") + "&";
        if (maxAvailableToFilter !== undefined)
            url_ += "MaxAvailableToFilter=" + encodeURIComponent(maxAvailableToFilter ? "" + maxAvailableToFilter.toJSON() : "") + "&";
        if (minAvailableToFilter !== undefined)
            url_ += "MinAvailableToFilter=" + encodeURIComponent(minAvailableToFilter ? "" + minAvailableToFilter.toJSON() : "") + "&";
        if (isSyncFilter !== undefined)
            url_ += "IsSyncFilter=" + encodeURIComponent("" + isSyncFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetTempCoinBaselinesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTempCoinBaselinesToExcel(<any>response_);
                } catch (e) {
                    return <Observable<PointFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PointFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetTempCoinBaselinesToExcel(response: HttpResponseBase): Observable<PointFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PointFileDto.fromJS(resultData200) : new PointFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PointFileDto>(<any>null);
    }

    /**
     * @param timeToRun (optional) 
     * @return Success
     */
    activeTempCoinManualTrigger(timeToRun: moment.Moment | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TempCoinBaselines/ActiveTempCoinManualTrigger?";
        if (timeToRun !== undefined)
            url_ += "timeToRun=" + encodeURIComponent(timeToRun ? "" + timeToRun.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processActiveTempCoinManualTrigger(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActiveTempCoinManualTrigger(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processActiveTempCoinManualTrigger(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class TempInvoiceTransactionsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param dIST_CDFilter (optional) 
     * @param cUST_CDFilter (optional) 
     * @param sLSMAN_CDFilter (optional) 
     * @param iNV_NOFilter (optional) 
     * @param iNV_KEYFilter (optional) 
     * @param sO_NOFilter (optional) 
     * @param sO_KEYFilter (optional) 
     * @param tINV_NOFilter (optional) 
     * @param wHS_CDFilter (optional) 
     * @param iNV_TYPEFilter (optional) 
     * @param iNV_INDFilter (optional) 
     * @param bILLTO_CDFilter (optional) 
     * @param sHIPTO_CDFilter (optional) 
     * @param dIST_TAX_IDFilter (optional) 
     * @param cUST_TAXREGNOFilter (optional) 
     * @param cUST_MUNICIPALNOFilter (optional) 
     * @param sUBDIST_INDFilter (optional) 
     * @param cUST_TYPEFilter (optional) 
     * @param pO_NOFilter (optional) 
     * @param maxSO_DTFilter (optional) 
     * @param minSO_DTFilter (optional) 
     * @param maxINV_DTFilter (optional) 
     * @param minINV_DTFilter (optional) 
     * @param maxCREATE_DTFilter (optional) 
     * @param minCREATE_DTFilter (optional) 
     * @param maxDELIVERY_DTFilter (optional) 
     * @param minDELIVERY_DTFilter (optional) 
     * @param bU_CDFilter (optional) 
     * @param iNVTERM_CDFilter (optional) 
     * @param iNV_STATUSFilter (optional) 
     * @param rEF_NOFilter (optional) 
     * @param tAX_INV_NOFilter (optional) 
     * @param maxGROSS_TTLFilter (optional) 
     * @param minGROSS_TTLFilter (optional) 
     * @param maxNET_TTLFilter (optional) 
     * @param minNET_TTLFilter (optional) 
     * @param maxNET_TTL_TAXFilter (optional) 
     * @param minNET_TTL_TAXFilter (optional) 
     * @param maxADJ_AMTFilter (optional) 
     * @param minADJ_AMTFilter (optional) 
     * @param maxTAXABLE_AMTFilter (optional) 
     * @param minTAXABLE_AMTFilter (optional) 
     * @param maxTAXABLE_AMT_FOCFilter (optional) 
     * @param minTAXABLE_AMT_FOCFilter (optional) 
     * @param maxNONTAXABLE_AMTFilter (optional) 
     * @param minNONTAXABLE_AMTFilter (optional) 
     * @param maxTAX_PERC1Filter (optional) 
     * @param minTAX_PERC1Filter (optional) 
     * @param maxTAX_PERC2Filter (optional) 
     * @param minTAX_PERC2Filter (optional) 
     * @param maxTAX_PERC3Filter (optional) 
     * @param minTAX_PERC3Filter (optional) 
     * @param maxTAX_TTL1Filter (optional) 
     * @param minTAX_TTL1Filter (optional) 
     * @param maxTAX_TTL2Filter (optional) 
     * @param minTAX_TTL2Filter (optional) 
     * @param maxTAX_TTL3Filter (optional) 
     * @param minTAX_TTL3Filter (optional) 
     * @param maxTAX_TTLFilter (optional) 
     * @param minTAX_TTLFilter (optional) 
     * @param maxPRC_TAX_TTL1Filter (optional) 
     * @param minPRC_TAX_TTL1Filter (optional) 
     * @param maxPRC_TAX_TTL2Filter (optional) 
     * @param minPRC_TAX_TTL2Filter (optional) 
     * @param maxPRC_TAX_TTL3Filter (optional) 
     * @param minPRC_TAX_TTL3Filter (optional) 
     * @param maxPRC_TAX_TTLFilter (optional) 
     * @param minPRC_TAX_TTLFilter (optional) 
     * @param maxCUST_DISC_PERCFilter (optional) 
     * @param minCUST_DISC_PERCFilter (optional) 
     * @param maxCUST_DISC_AMTFilter (optional) 
     * @param minCUST_DISC_AMTFilter (optional) 
     * @param maxPRD_DISC_TTLFilter (optional) 
     * @param minPRD_DISC_TTLFilter (optional) 
     * @param maxCLAIM_DISCFilter (optional) 
     * @param minCLAIM_DISCFilter (optional) 
     * @param maxDIST_DISCFilter (optional) 
     * @param minDIST_DISCFilter (optional) 
     * @param maxPROMO_DISCFilter (optional) 
     * @param minPROMO_DISCFilter (optional) 
     * @param maxSLS_DISCFilter (optional) 
     * @param minSLS_DISCFilter (optional) 
     * @param maxCASH_DISCFilter (optional) 
     * @param minCASH_DISCFilter (optional) 
     * @param maxCUST_GRP_DISCFilter (optional) 
     * @param minCUST_GRP_DISCFilter (optional) 
     * @param maxADD_TAX_AMTFilter (optional) 
     * @param minADD_TAX_AMTFilter (optional) 
     * @param rEMARKFilter (optional) 
     * @param uPLDW_STATUSFilter (optional) 
     * @param maxSVR_UPLDW_DTFilter (optional) 
     * @param minSVR_UPLDW_DTFilter (optional) 
     * @param cREATED_BYFilter (optional) 
     * @param sVR_CLIENTFilter (optional) 
     * @param maxHHT_SUBMIT_DTFilter (optional) 
     * @param minHHT_SUBMIT_DTFilter (optional) 
     * @param vISIT_KEYFilter (optional) 
     * @param maxPRN_NOFilter (optional) 
     * @param minPRN_NOFilter (optional) 
     * @param maxPRN_NO_TAXFilter (optional) 
     * @param minPRN_NO_TAXFilter (optional) 
     * @param pICKLIST_INDFilter (optional) 
     * @param nPCLAIM_INDFilter (optional) 
     * @param sPCLAIM_INDFilter (optional) 
     * @param dE_INDFilter (optional) 
     * @param maxDE_DTFilter (optional) 
     * @param minDE_DTFilter (optional) 
     * @param eXT_INDFilter (optional) 
     * @param fULL_REVERSAL_INDFilter (optional) 
     * @param maxVERSIONFilter (optional) 
     * @param minVERSIONFilter (optional) 
     * @param maxSYNCVERSIONFilter (optional) 
     * @param minSYNCVERSIONFilter (optional) 
     * @param iNDFilter (optional) 
     * @param maxPRN_DO_NOFilter (optional) 
     * @param minPRN_DO_NOFilter (optional) 
     * @param eRP_INDFilter (optional) 
     * @param aGENT_CDFilter (optional) 
     * @param maxDW_DTFilter (optional) 
     * @param minDW_DTFilter (optional) 
     * @param maxINV_DISC_TTLFilter (optional) 
     * @param minINV_DISC_TTLFilter (optional) 
     * @param pRD_CDFilter (optional) 
     * @param pRD_SLSTYPEFilter (optional) 
     * @param maxPRD_INDEXFilter (optional) 
     * @param minPRD_INDEXFilter (optional) 
     * @param uOM_CD1Filter (optional) 
     * @param uOM_CD2Filter (optional) 
     * @param uOM_CD3Filter (optional) 
     * @param tAX_INDFilter (optional) 
     * @param pRC_TAX_INDFilter (optional) 
     * @param dEF_UOM_CDFilter (optional) 
     * @param maxPRD_QTY1Filter (optional) 
     * @param minPRD_QTY1Filter (optional) 
     * @param maxPRD_QTY2Filter (optional) 
     * @param minPRD_QTY2Filter (optional) 
     * @param maxPRD_QTY3Filter (optional) 
     * @param minPRD_QTY3Filter (optional) 
     * @param maxMRPFilter (optional) 
     * @param minMRPFilter (optional) 
     * @param maxCPFilter (optional) 
     * @param minCPFilter (optional) 
     * @param maxPRD_LISTPRCFilter (optional) 
     * @param minPRD_LISTPRCFilter (optional) 
     * @param maxUOM_LISTPRC1Filter (optional) 
     * @param minUOM_LISTPRC1Filter (optional) 
     * @param maxUOM_LISTPRC2Filter (optional) 
     * @param minUOM_LISTPRC2Filter (optional) 
     * @param maxUOM_LISTPRC3Filter (optional) 
     * @param minUOM_LISTPRC3Filter (optional) 
     * @param maxPRC_TAX_PERC1Filter (optional) 
     * @param minPRC_TAX_PERC1Filter (optional) 
     * @param maxPRC_TAX_PERC2Filter (optional) 
     * @param minPRC_TAX_PERC2Filter (optional) 
     * @param maxPRC_TAX_PERC3Filter (optional) 
     * @param minPRC_TAX_PERC3Filter (optional) 
     * @param maxPRC_TAX_AMT1Filter (optional) 
     * @param minPRC_TAX_AMT1Filter (optional) 
     * @param maxPRC_TAX_AMT2Filter (optional) 
     * @param minPRC_TAX_AMT2Filter (optional) 
     * @param maxPRC_TAX_AMT3Filter (optional) 
     * @param minPRC_TAX_AMT3Filter (optional) 
     * @param maxPRC_TAX_AMTFilter (optional) 
     * @param minPRC_TAX_AMTFilter (optional) 
     * @param maxPRD_DISCFilter (optional) 
     * @param minPRD_DISCFilter (optional) 
     * @param maxGROSS_AMTFilter (optional) 
     * @param minGROSS_AMTFilter (optional) 
     * @param maxPROMO_DISC_DTLFilter (optional) 
     * @param minPROMO_DISC_DTLFilter (optional) 
     * @param maxDIST_PROMO_DISCFilter (optional) 
     * @param minDIST_PROMO_DISCFilter (optional) 
     * @param maxHQ_PROMO_DISCFilter (optional) 
     * @param minHQ_PROMO_DISCFilter (optional) 
     * @param maxSLS_DISC_DTLFilter (optional) 
     * @param minSLS_DISC_DTLFilter (optional) 
     * @param maxCUST_GRP_DISC_DTLFilter (optional) 
     * @param minCUST_GRP_DISC_DTLFilter (optional) 
     * @param maxCASH_DISC_PERCFilter (optional) 
     * @param minCASH_DISC_PERCFilter (optional) 
     * @param maxCASH_DISC_DTLFilter (optional) 
     * @param minCASH_DISC_DTLFilter (optional) 
     * @param maxUNIT_TAXFilter (optional) 
     * @param minUNIT_TAXFilter (optional) 
     * @param maxNET_AMTFilter (optional) 
     * @param minNET_AMTFilter (optional) 
     * @param maxNET_AMT_TAXFilter (optional) 
     * @param minNET_AMT_TAXFilter (optional) 
     * @param maxNET_AMT_FOCFilter (optional) 
     * @param minNET_AMT_FOCFilter (optional) 
     * @param maxCUST_DISC_DTLFilter (optional) 
     * @param minCUST_DISC_DTLFilter (optional) 
     * @param maxTAX_PERC1_DTLFilter (optional) 
     * @param minTAX_PERC1_DTLFilter (optional) 
     * @param maxTAX_PERC2_DTLFilter (optional) 
     * @param minTAX_PERC2_DTLFilter (optional) 
     * @param maxTAX_PERC3_DTLFilter (optional) 
     * @param minTAX_PERC3_DTLFilter (optional) 
     * @param maxTAX_AMT1Filter (optional) 
     * @param minTAX_AMT1Filter (optional) 
     * @param maxTAX_AMT2Filter (optional) 
     * @param minTAX_AMT2Filter (optional) 
     * @param maxTAX_AMT3Filter (optional) 
     * @param minTAX_AMT3Filter (optional) 
     * @param maxTAX_AMTFilter (optional) 
     * @param minTAX_AMTFilter (optional) 
     * @param maxADD_TAX_PERCFilter (optional) 
     * @param minADD_TAX_PERCFilter (optional) 
     * @param maxADD_TAX_AMT_DTLFilter (optional) 
     * @param minADD_TAX_AMT_DTLFilter (optional) 
     * @param maxPURCHASE_RATEFilter (optional) 
     * @param minPURCHASE_RATEFilter (optional) 
     * @param maxDIST_DISC_DTLFilter (optional) 
     * @param minDIST_DISC_DTLFilter (optional) 
     * @param maxUOM_CONV_FACTOR_SML1Filter (optional) 
     * @param minUOM_CONV_FACTOR_SML1Filter (optional) 
     * @param maxUOM_CONV_FACTOR_SML2Filter (optional) 
     * @param minUOM_CONV_FACTOR_SML2Filter (optional) 
     * @param maxUOM_CONV_FACTOR_SML3Filter (optional) 
     * @param minUOM_CONV_FACTOR_SML3Filter (optional) 
     * @param iND_DTLFilter (optional) 
     * @param pARENT_PRDFilter (optional) 
     * @param pARENT_UOMFilter (optional) 
     * @param mY_TAX_CDFilter (optional) 
     * @param maxPRICE_ERRORFilter (optional) 
     * @param minPRICE_ERRORFilter (optional) 
     * @param mSL_INDFilter (optional) 
     * @param maxINV_DISCFilter (optional) 
     * @param minINV_DISCFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, dIST_CDFilter: string | null | undefined, cUST_CDFilter: string | null | undefined, sLSMAN_CDFilter: string | null | undefined, iNV_NOFilter: string | null | undefined, iNV_KEYFilter: string | null | undefined, sO_NOFilter: string | null | undefined, sO_KEYFilter: string | null | undefined, tINV_NOFilter: string | null | undefined, wHS_CDFilter: string | null | undefined, iNV_TYPEFilter: string | null | undefined, iNV_INDFilter: string | null | undefined, bILLTO_CDFilter: string | null | undefined, sHIPTO_CDFilter: string | null | undefined, dIST_TAX_IDFilter: string | null | undefined, cUST_TAXREGNOFilter: string | null | undefined, cUST_MUNICIPALNOFilter: string | null | undefined, sUBDIST_INDFilter: string | null | undefined, cUST_TYPEFilter: string | null | undefined, pO_NOFilter: string | null | undefined, maxSO_DTFilter: moment.Moment | null | undefined, minSO_DTFilter: moment.Moment | null | undefined, maxINV_DTFilter: moment.Moment | null | undefined, minINV_DTFilter: moment.Moment | null | undefined, maxCREATE_DTFilter: moment.Moment | null | undefined, minCREATE_DTFilter: moment.Moment | null | undefined, maxDELIVERY_DTFilter: moment.Moment | null | undefined, minDELIVERY_DTFilter: moment.Moment | null | undefined, bU_CDFilter: string | null | undefined, iNVTERM_CDFilter: string | null | undefined, iNV_STATUSFilter: string | null | undefined, rEF_NOFilter: string | null | undefined, tAX_INV_NOFilter: string | null | undefined, maxGROSS_TTLFilter: number | null | undefined, minGROSS_TTLFilter: number | null | undefined, maxNET_TTLFilter: number | null | undefined, minNET_TTLFilter: number | null | undefined, maxNET_TTL_TAXFilter: number | null | undefined, minNET_TTL_TAXFilter: number | null | undefined, maxADJ_AMTFilter: number | null | undefined, minADJ_AMTFilter: number | null | undefined, maxTAXABLE_AMTFilter: number | null | undefined, minTAXABLE_AMTFilter: number | null | undefined, maxTAXABLE_AMT_FOCFilter: number | null | undefined, minTAXABLE_AMT_FOCFilter: number | null | undefined, maxNONTAXABLE_AMTFilter: number | null | undefined, minNONTAXABLE_AMTFilter: number | null | undefined, maxTAX_PERC1Filter: number | null | undefined, minTAX_PERC1Filter: number | null | undefined, maxTAX_PERC2Filter: number | null | undefined, minTAX_PERC2Filter: number | null | undefined, maxTAX_PERC3Filter: number | null | undefined, minTAX_PERC3Filter: number | null | undefined, maxTAX_TTL1Filter: number | null | undefined, minTAX_TTL1Filter: number | null | undefined, maxTAX_TTL2Filter: number | null | undefined, minTAX_TTL2Filter: number | null | undefined, maxTAX_TTL3Filter: number | null | undefined, minTAX_TTL3Filter: number | null | undefined, maxTAX_TTLFilter: number | null | undefined, minTAX_TTLFilter: number | null | undefined, maxPRC_TAX_TTL1Filter: number | null | undefined, minPRC_TAX_TTL1Filter: number | null | undefined, maxPRC_TAX_TTL2Filter: number | null | undefined, minPRC_TAX_TTL2Filter: number | null | undefined, maxPRC_TAX_TTL3Filter: number | null | undefined, minPRC_TAX_TTL3Filter: number | null | undefined, maxPRC_TAX_TTLFilter: number | null | undefined, minPRC_TAX_TTLFilter: number | null | undefined, maxCUST_DISC_PERCFilter: number | null | undefined, minCUST_DISC_PERCFilter: number | null | undefined, maxCUST_DISC_AMTFilter: number | null | undefined, minCUST_DISC_AMTFilter: number | null | undefined, maxPRD_DISC_TTLFilter: number | null | undefined, minPRD_DISC_TTLFilter: number | null | undefined, maxCLAIM_DISCFilter: number | null | undefined, minCLAIM_DISCFilter: number | null | undefined, maxDIST_DISCFilter: number | null | undefined, minDIST_DISCFilter: number | null | undefined, maxPROMO_DISCFilter: number | null | undefined, minPROMO_DISCFilter: number | null | undefined, maxSLS_DISCFilter: number | null | undefined, minSLS_DISCFilter: number | null | undefined, maxCASH_DISCFilter: number | null | undefined, minCASH_DISCFilter: number | null | undefined, maxCUST_GRP_DISCFilter: number | null | undefined, minCUST_GRP_DISCFilter: number | null | undefined, maxADD_TAX_AMTFilter: number | null | undefined, minADD_TAX_AMTFilter: number | null | undefined, rEMARKFilter: string | null | undefined, uPLDW_STATUSFilter: string | null | undefined, maxSVR_UPLDW_DTFilter: moment.Moment | null | undefined, minSVR_UPLDW_DTFilter: moment.Moment | null | undefined, cREATED_BYFilter: string | null | undefined, sVR_CLIENTFilter: string | null | undefined, maxHHT_SUBMIT_DTFilter: moment.Moment | null | undefined, minHHT_SUBMIT_DTFilter: moment.Moment | null | undefined, vISIT_KEYFilter: string | null | undefined, maxPRN_NOFilter: number | null | undefined, minPRN_NOFilter: number | null | undefined, maxPRN_NO_TAXFilter: number | null | undefined, minPRN_NO_TAXFilter: number | null | undefined, pICKLIST_INDFilter: number | null | undefined, nPCLAIM_INDFilter: number | null | undefined, sPCLAIM_INDFilter: number | null | undefined, dE_INDFilter: string | null | undefined, maxDE_DTFilter: moment.Moment | null | undefined, minDE_DTFilter: moment.Moment | null | undefined, eXT_INDFilter: string | null | undefined, fULL_REVERSAL_INDFilter: string | null | undefined, maxVERSIONFilter: number | null | undefined, minVERSIONFilter: number | null | undefined, maxSYNCVERSIONFilter: moment.Moment | null | undefined, minSYNCVERSIONFilter: moment.Moment | null | undefined, iNDFilter: string | null | undefined, maxPRN_DO_NOFilter: number | null | undefined, minPRN_DO_NOFilter: number | null | undefined, eRP_INDFilter: number | null | undefined, aGENT_CDFilter: string | null | undefined, maxDW_DTFilter: moment.Moment | null | undefined, minDW_DTFilter: moment.Moment | null | undefined, maxINV_DISC_TTLFilter: number | null | undefined, minINV_DISC_TTLFilter: number | null | undefined, pRD_CDFilter: string | null | undefined, pRD_SLSTYPEFilter: string | null | undefined, maxPRD_INDEXFilter: number | null | undefined, minPRD_INDEXFilter: number | null | undefined, uOM_CD1Filter: string | null | undefined, uOM_CD2Filter: string | null | undefined, uOM_CD3Filter: string | null | undefined, tAX_INDFilter: number | null | undefined, pRC_TAX_INDFilter: string | null | undefined, dEF_UOM_CDFilter: string | null | undefined, maxPRD_QTY1Filter: number | null | undefined, minPRD_QTY1Filter: number | null | undefined, maxPRD_QTY2Filter: number | null | undefined, minPRD_QTY2Filter: number | null | undefined, maxPRD_QTY3Filter: number | null | undefined, minPRD_QTY3Filter: number | null | undefined, maxMRPFilter: number | null | undefined, minMRPFilter: number | null | undefined, maxCPFilter: number | null | undefined, minCPFilter: number | null | undefined, maxPRD_LISTPRCFilter: number | null | undefined, minPRD_LISTPRCFilter: number | null | undefined, maxUOM_LISTPRC1Filter: number | null | undefined, minUOM_LISTPRC1Filter: number | null | undefined, maxUOM_LISTPRC2Filter: number | null | undefined, minUOM_LISTPRC2Filter: number | null | undefined, maxUOM_LISTPRC3Filter: number | null | undefined, minUOM_LISTPRC3Filter: number | null | undefined, maxPRC_TAX_PERC1Filter: number | null | undefined, minPRC_TAX_PERC1Filter: number | null | undefined, maxPRC_TAX_PERC2Filter: number | null | undefined, minPRC_TAX_PERC2Filter: number | null | undefined, maxPRC_TAX_PERC3Filter: number | null | undefined, minPRC_TAX_PERC3Filter: number | null | undefined, maxPRC_TAX_AMT1Filter: number | null | undefined, minPRC_TAX_AMT1Filter: number | null | undefined, maxPRC_TAX_AMT2Filter: number | null | undefined, minPRC_TAX_AMT2Filter: number | null | undefined, maxPRC_TAX_AMT3Filter: number | null | undefined, minPRC_TAX_AMT3Filter: number | null | undefined, maxPRC_TAX_AMTFilter: number | null | undefined, minPRC_TAX_AMTFilter: number | null | undefined, maxPRD_DISCFilter: number | null | undefined, minPRD_DISCFilter: number | null | undefined, maxGROSS_AMTFilter: number | null | undefined, minGROSS_AMTFilter: number | null | undefined, maxPROMO_DISC_DTLFilter: number | null | undefined, minPROMO_DISC_DTLFilter: number | null | undefined, maxDIST_PROMO_DISCFilter: number | null | undefined, minDIST_PROMO_DISCFilter: number | null | undefined, maxHQ_PROMO_DISCFilter: number | null | undefined, minHQ_PROMO_DISCFilter: number | null | undefined, maxSLS_DISC_DTLFilter: number | null | undefined, minSLS_DISC_DTLFilter: number | null | undefined, maxCUST_GRP_DISC_DTLFilter: number | null | undefined, minCUST_GRP_DISC_DTLFilter: number | null | undefined, maxCASH_DISC_PERCFilter: number | null | undefined, minCASH_DISC_PERCFilter: number | null | undefined, maxCASH_DISC_DTLFilter: number | null | undefined, minCASH_DISC_DTLFilter: number | null | undefined, maxUNIT_TAXFilter: number | null | undefined, minUNIT_TAXFilter: number | null | undefined, maxNET_AMTFilter: number | null | undefined, minNET_AMTFilter: number | null | undefined, maxNET_AMT_TAXFilter: number | null | undefined, minNET_AMT_TAXFilter: number | null | undefined, maxNET_AMT_FOCFilter: number | null | undefined, minNET_AMT_FOCFilter: number | null | undefined, maxCUST_DISC_DTLFilter: number | null | undefined, minCUST_DISC_DTLFilter: number | null | undefined, maxTAX_PERC1_DTLFilter: number | null | undefined, minTAX_PERC1_DTLFilter: number | null | undefined, maxTAX_PERC2_DTLFilter: number | null | undefined, minTAX_PERC2_DTLFilter: number | null | undefined, maxTAX_PERC3_DTLFilter: number | null | undefined, minTAX_PERC3_DTLFilter: number | null | undefined, maxTAX_AMT1Filter: number | null | undefined, minTAX_AMT1Filter: number | null | undefined, maxTAX_AMT2Filter: number | null | undefined, minTAX_AMT2Filter: number | null | undefined, maxTAX_AMT3Filter: number | null | undefined, minTAX_AMT3Filter: number | null | undefined, maxTAX_AMTFilter: number | null | undefined, minTAX_AMTFilter: number | null | undefined, maxADD_TAX_PERCFilter: number | null | undefined, minADD_TAX_PERCFilter: number | null | undefined, maxADD_TAX_AMT_DTLFilter: number | null | undefined, minADD_TAX_AMT_DTLFilter: number | null | undefined, maxPURCHASE_RATEFilter: number | null | undefined, minPURCHASE_RATEFilter: number | null | undefined, maxDIST_DISC_DTLFilter: number | null | undefined, minDIST_DISC_DTLFilter: number | null | undefined, maxUOM_CONV_FACTOR_SML1Filter: number | null | undefined, minUOM_CONV_FACTOR_SML1Filter: number | null | undefined, maxUOM_CONV_FACTOR_SML2Filter: number | null | undefined, minUOM_CONV_FACTOR_SML2Filter: number | null | undefined, maxUOM_CONV_FACTOR_SML3Filter: number | null | undefined, minUOM_CONV_FACTOR_SML3Filter: number | null | undefined, iND_DTLFilter: string | null | undefined, pARENT_PRDFilter: string | null | undefined, pARENT_UOMFilter: string | null | undefined, mY_TAX_CDFilter: string | null | undefined, maxPRICE_ERRORFilter: number | null | undefined, minPRICE_ERRORFilter: number | null | undefined, mSL_INDFilter: string | null | undefined, maxINV_DISCFilter: number | null | undefined, minINV_DISCFilter: number | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetTempInvoiceTransactionForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/TempInvoiceTransactions/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (dIST_CDFilter !== undefined)
            url_ += "DIST_CDFilter=" + encodeURIComponent("" + dIST_CDFilter) + "&";
        if (cUST_CDFilter !== undefined)
            url_ += "CUST_CDFilter=" + encodeURIComponent("" + cUST_CDFilter) + "&";
        if (sLSMAN_CDFilter !== undefined)
            url_ += "SLSMAN_CDFilter=" + encodeURIComponent("" + sLSMAN_CDFilter) + "&";
        if (iNV_NOFilter !== undefined)
            url_ += "INV_NOFilter=" + encodeURIComponent("" + iNV_NOFilter) + "&";
        if (iNV_KEYFilter !== undefined)
            url_ += "INV_KEYFilter=" + encodeURIComponent("" + iNV_KEYFilter) + "&";
        if (sO_NOFilter !== undefined)
            url_ += "SO_NOFilter=" + encodeURIComponent("" + sO_NOFilter) + "&";
        if (sO_KEYFilter !== undefined)
            url_ += "SO_KEYFilter=" + encodeURIComponent("" + sO_KEYFilter) + "&";
        if (tINV_NOFilter !== undefined)
            url_ += "TINV_NOFilter=" + encodeURIComponent("" + tINV_NOFilter) + "&";
        if (wHS_CDFilter !== undefined)
            url_ += "WHS_CDFilter=" + encodeURIComponent("" + wHS_CDFilter) + "&";
        if (iNV_TYPEFilter !== undefined)
            url_ += "INV_TYPEFilter=" + encodeURIComponent("" + iNV_TYPEFilter) + "&";
        if (iNV_INDFilter !== undefined)
            url_ += "INV_INDFilter=" + encodeURIComponent("" + iNV_INDFilter) + "&";
        if (bILLTO_CDFilter !== undefined)
            url_ += "BILLTO_CDFilter=" + encodeURIComponent("" + bILLTO_CDFilter) + "&";
        if (sHIPTO_CDFilter !== undefined)
            url_ += "SHIPTO_CDFilter=" + encodeURIComponent("" + sHIPTO_CDFilter) + "&";
        if (dIST_TAX_IDFilter !== undefined)
            url_ += "DIST_TAX_IDFilter=" + encodeURIComponent("" + dIST_TAX_IDFilter) + "&";
        if (cUST_TAXREGNOFilter !== undefined)
            url_ += "CUST_TAXREGNOFilter=" + encodeURIComponent("" + cUST_TAXREGNOFilter) + "&";
        if (cUST_MUNICIPALNOFilter !== undefined)
            url_ += "CUST_MUNICIPALNOFilter=" + encodeURIComponent("" + cUST_MUNICIPALNOFilter) + "&";
        if (sUBDIST_INDFilter !== undefined)
            url_ += "SUBDIST_INDFilter=" + encodeURIComponent("" + sUBDIST_INDFilter) + "&";
        if (cUST_TYPEFilter !== undefined)
            url_ += "CUST_TYPEFilter=" + encodeURIComponent("" + cUST_TYPEFilter) + "&";
        if (pO_NOFilter !== undefined)
            url_ += "PO_NOFilter=" + encodeURIComponent("" + pO_NOFilter) + "&";
        if (maxSO_DTFilter !== undefined)
            url_ += "MaxSO_DTFilter=" + encodeURIComponent(maxSO_DTFilter ? "" + maxSO_DTFilter.toJSON() : "") + "&";
        if (minSO_DTFilter !== undefined)
            url_ += "MinSO_DTFilter=" + encodeURIComponent(minSO_DTFilter ? "" + minSO_DTFilter.toJSON() : "") + "&";
        if (maxINV_DTFilter !== undefined)
            url_ += "MaxINV_DTFilter=" + encodeURIComponent(maxINV_DTFilter ? "" + maxINV_DTFilter.toJSON() : "") + "&";
        if (minINV_DTFilter !== undefined)
            url_ += "MinINV_DTFilter=" + encodeURIComponent(minINV_DTFilter ? "" + minINV_DTFilter.toJSON() : "") + "&";
        if (maxCREATE_DTFilter !== undefined)
            url_ += "MaxCREATE_DTFilter=" + encodeURIComponent(maxCREATE_DTFilter ? "" + maxCREATE_DTFilter.toJSON() : "") + "&";
        if (minCREATE_DTFilter !== undefined)
            url_ += "MinCREATE_DTFilter=" + encodeURIComponent(minCREATE_DTFilter ? "" + minCREATE_DTFilter.toJSON() : "") + "&";
        if (maxDELIVERY_DTFilter !== undefined)
            url_ += "MaxDELIVERY_DTFilter=" + encodeURIComponent(maxDELIVERY_DTFilter ? "" + maxDELIVERY_DTFilter.toJSON() : "") + "&";
        if (minDELIVERY_DTFilter !== undefined)
            url_ += "MinDELIVERY_DTFilter=" + encodeURIComponent(minDELIVERY_DTFilter ? "" + minDELIVERY_DTFilter.toJSON() : "") + "&";
        if (bU_CDFilter !== undefined)
            url_ += "BU_CDFilter=" + encodeURIComponent("" + bU_CDFilter) + "&";
        if (iNVTERM_CDFilter !== undefined)
            url_ += "INVTERM_CDFilter=" + encodeURIComponent("" + iNVTERM_CDFilter) + "&";
        if (iNV_STATUSFilter !== undefined)
            url_ += "INV_STATUSFilter=" + encodeURIComponent("" + iNV_STATUSFilter) + "&";
        if (rEF_NOFilter !== undefined)
            url_ += "REF_NOFilter=" + encodeURIComponent("" + rEF_NOFilter) + "&";
        if (tAX_INV_NOFilter !== undefined)
            url_ += "TAX_INV_NOFilter=" + encodeURIComponent("" + tAX_INV_NOFilter) + "&";
        if (maxGROSS_TTLFilter !== undefined)
            url_ += "MaxGROSS_TTLFilter=" + encodeURIComponent("" + maxGROSS_TTLFilter) + "&";
        if (minGROSS_TTLFilter !== undefined)
            url_ += "MinGROSS_TTLFilter=" + encodeURIComponent("" + minGROSS_TTLFilter) + "&";
        if (maxNET_TTLFilter !== undefined)
            url_ += "MaxNET_TTLFilter=" + encodeURIComponent("" + maxNET_TTLFilter) + "&";
        if (minNET_TTLFilter !== undefined)
            url_ += "MinNET_TTLFilter=" + encodeURIComponent("" + minNET_TTLFilter) + "&";
        if (maxNET_TTL_TAXFilter !== undefined)
            url_ += "MaxNET_TTL_TAXFilter=" + encodeURIComponent("" + maxNET_TTL_TAXFilter) + "&";
        if (minNET_TTL_TAXFilter !== undefined)
            url_ += "MinNET_TTL_TAXFilter=" + encodeURIComponent("" + minNET_TTL_TAXFilter) + "&";
        if (maxADJ_AMTFilter !== undefined)
            url_ += "MaxADJ_AMTFilter=" + encodeURIComponent("" + maxADJ_AMTFilter) + "&";
        if (minADJ_AMTFilter !== undefined)
            url_ += "MinADJ_AMTFilter=" + encodeURIComponent("" + minADJ_AMTFilter) + "&";
        if (maxTAXABLE_AMTFilter !== undefined)
            url_ += "MaxTAXABLE_AMTFilter=" + encodeURIComponent("" + maxTAXABLE_AMTFilter) + "&";
        if (minTAXABLE_AMTFilter !== undefined)
            url_ += "MinTAXABLE_AMTFilter=" + encodeURIComponent("" + minTAXABLE_AMTFilter) + "&";
        if (maxTAXABLE_AMT_FOCFilter !== undefined)
            url_ += "MaxTAXABLE_AMT_FOCFilter=" + encodeURIComponent("" + maxTAXABLE_AMT_FOCFilter) + "&";
        if (minTAXABLE_AMT_FOCFilter !== undefined)
            url_ += "MinTAXABLE_AMT_FOCFilter=" + encodeURIComponent("" + minTAXABLE_AMT_FOCFilter) + "&";
        if (maxNONTAXABLE_AMTFilter !== undefined)
            url_ += "MaxNONTAXABLE_AMTFilter=" + encodeURIComponent("" + maxNONTAXABLE_AMTFilter) + "&";
        if (minNONTAXABLE_AMTFilter !== undefined)
            url_ += "MinNONTAXABLE_AMTFilter=" + encodeURIComponent("" + minNONTAXABLE_AMTFilter) + "&";
        if (maxTAX_PERC1Filter !== undefined)
            url_ += "MaxTAX_PERC1Filter=" + encodeURIComponent("" + maxTAX_PERC1Filter) + "&";
        if (minTAX_PERC1Filter !== undefined)
            url_ += "MinTAX_PERC1Filter=" + encodeURIComponent("" + minTAX_PERC1Filter) + "&";
        if (maxTAX_PERC2Filter !== undefined)
            url_ += "MaxTAX_PERC2Filter=" + encodeURIComponent("" + maxTAX_PERC2Filter) + "&";
        if (minTAX_PERC2Filter !== undefined)
            url_ += "MinTAX_PERC2Filter=" + encodeURIComponent("" + minTAX_PERC2Filter) + "&";
        if (maxTAX_PERC3Filter !== undefined)
            url_ += "MaxTAX_PERC3Filter=" + encodeURIComponent("" + maxTAX_PERC3Filter) + "&";
        if (minTAX_PERC3Filter !== undefined)
            url_ += "MinTAX_PERC3Filter=" + encodeURIComponent("" + minTAX_PERC3Filter) + "&";
        if (maxTAX_TTL1Filter !== undefined)
            url_ += "MaxTAX_TTL1Filter=" + encodeURIComponent("" + maxTAX_TTL1Filter) + "&";
        if (minTAX_TTL1Filter !== undefined)
            url_ += "MinTAX_TTL1Filter=" + encodeURIComponent("" + minTAX_TTL1Filter) + "&";
        if (maxTAX_TTL2Filter !== undefined)
            url_ += "MaxTAX_TTL2Filter=" + encodeURIComponent("" + maxTAX_TTL2Filter) + "&";
        if (minTAX_TTL2Filter !== undefined)
            url_ += "MinTAX_TTL2Filter=" + encodeURIComponent("" + minTAX_TTL2Filter) + "&";
        if (maxTAX_TTL3Filter !== undefined)
            url_ += "MaxTAX_TTL3Filter=" + encodeURIComponent("" + maxTAX_TTL3Filter) + "&";
        if (minTAX_TTL3Filter !== undefined)
            url_ += "MinTAX_TTL3Filter=" + encodeURIComponent("" + minTAX_TTL3Filter) + "&";
        if (maxTAX_TTLFilter !== undefined)
            url_ += "MaxTAX_TTLFilter=" + encodeURIComponent("" + maxTAX_TTLFilter) + "&";
        if (minTAX_TTLFilter !== undefined)
            url_ += "MinTAX_TTLFilter=" + encodeURIComponent("" + minTAX_TTLFilter) + "&";
        if (maxPRC_TAX_TTL1Filter !== undefined)
            url_ += "MaxPRC_TAX_TTL1Filter=" + encodeURIComponent("" + maxPRC_TAX_TTL1Filter) + "&";
        if (minPRC_TAX_TTL1Filter !== undefined)
            url_ += "MinPRC_TAX_TTL1Filter=" + encodeURIComponent("" + minPRC_TAX_TTL1Filter) + "&";
        if (maxPRC_TAX_TTL2Filter !== undefined)
            url_ += "MaxPRC_TAX_TTL2Filter=" + encodeURIComponent("" + maxPRC_TAX_TTL2Filter) + "&";
        if (minPRC_TAX_TTL2Filter !== undefined)
            url_ += "MinPRC_TAX_TTL2Filter=" + encodeURIComponent("" + minPRC_TAX_TTL2Filter) + "&";
        if (maxPRC_TAX_TTL3Filter !== undefined)
            url_ += "MaxPRC_TAX_TTL3Filter=" + encodeURIComponent("" + maxPRC_TAX_TTL3Filter) + "&";
        if (minPRC_TAX_TTL3Filter !== undefined)
            url_ += "MinPRC_TAX_TTL3Filter=" + encodeURIComponent("" + minPRC_TAX_TTL3Filter) + "&";
        if (maxPRC_TAX_TTLFilter !== undefined)
            url_ += "MaxPRC_TAX_TTLFilter=" + encodeURIComponent("" + maxPRC_TAX_TTLFilter) + "&";
        if (minPRC_TAX_TTLFilter !== undefined)
            url_ += "MinPRC_TAX_TTLFilter=" + encodeURIComponent("" + minPRC_TAX_TTLFilter) + "&";
        if (maxCUST_DISC_PERCFilter !== undefined)
            url_ += "MaxCUST_DISC_PERCFilter=" + encodeURIComponent("" + maxCUST_DISC_PERCFilter) + "&";
        if (minCUST_DISC_PERCFilter !== undefined)
            url_ += "MinCUST_DISC_PERCFilter=" + encodeURIComponent("" + minCUST_DISC_PERCFilter) + "&";
        if (maxCUST_DISC_AMTFilter !== undefined)
            url_ += "MaxCUST_DISC_AMTFilter=" + encodeURIComponent("" + maxCUST_DISC_AMTFilter) + "&";
        if (minCUST_DISC_AMTFilter !== undefined)
            url_ += "MinCUST_DISC_AMTFilter=" + encodeURIComponent("" + minCUST_DISC_AMTFilter) + "&";
        if (maxPRD_DISC_TTLFilter !== undefined)
            url_ += "MaxPRD_DISC_TTLFilter=" + encodeURIComponent("" + maxPRD_DISC_TTLFilter) + "&";
        if (minPRD_DISC_TTLFilter !== undefined)
            url_ += "MinPRD_DISC_TTLFilter=" + encodeURIComponent("" + minPRD_DISC_TTLFilter) + "&";
        if (maxCLAIM_DISCFilter !== undefined)
            url_ += "MaxCLAIM_DISCFilter=" + encodeURIComponent("" + maxCLAIM_DISCFilter) + "&";
        if (minCLAIM_DISCFilter !== undefined)
            url_ += "MinCLAIM_DISCFilter=" + encodeURIComponent("" + minCLAIM_DISCFilter) + "&";
        if (maxDIST_DISCFilter !== undefined)
            url_ += "MaxDIST_DISCFilter=" + encodeURIComponent("" + maxDIST_DISCFilter) + "&";
        if (minDIST_DISCFilter !== undefined)
            url_ += "MinDIST_DISCFilter=" + encodeURIComponent("" + minDIST_DISCFilter) + "&";
        if (maxPROMO_DISCFilter !== undefined)
            url_ += "MaxPROMO_DISCFilter=" + encodeURIComponent("" + maxPROMO_DISCFilter) + "&";
        if (minPROMO_DISCFilter !== undefined)
            url_ += "MinPROMO_DISCFilter=" + encodeURIComponent("" + minPROMO_DISCFilter) + "&";
        if (maxSLS_DISCFilter !== undefined)
            url_ += "MaxSLS_DISCFilter=" + encodeURIComponent("" + maxSLS_DISCFilter) + "&";
        if (minSLS_DISCFilter !== undefined)
            url_ += "MinSLS_DISCFilter=" + encodeURIComponent("" + minSLS_DISCFilter) + "&";
        if (maxCASH_DISCFilter !== undefined)
            url_ += "MaxCASH_DISCFilter=" + encodeURIComponent("" + maxCASH_DISCFilter) + "&";
        if (minCASH_DISCFilter !== undefined)
            url_ += "MinCASH_DISCFilter=" + encodeURIComponent("" + minCASH_DISCFilter) + "&";
        if (maxCUST_GRP_DISCFilter !== undefined)
            url_ += "MaxCUST_GRP_DISCFilter=" + encodeURIComponent("" + maxCUST_GRP_DISCFilter) + "&";
        if (minCUST_GRP_DISCFilter !== undefined)
            url_ += "MinCUST_GRP_DISCFilter=" + encodeURIComponent("" + minCUST_GRP_DISCFilter) + "&";
        if (maxADD_TAX_AMTFilter !== undefined)
            url_ += "MaxADD_TAX_AMTFilter=" + encodeURIComponent("" + maxADD_TAX_AMTFilter) + "&";
        if (minADD_TAX_AMTFilter !== undefined)
            url_ += "MinADD_TAX_AMTFilter=" + encodeURIComponent("" + minADD_TAX_AMTFilter) + "&";
        if (rEMARKFilter !== undefined)
            url_ += "REMARKFilter=" + encodeURIComponent("" + rEMARKFilter) + "&";
        if (uPLDW_STATUSFilter !== undefined)
            url_ += "UPLDW_STATUSFilter=" + encodeURIComponent("" + uPLDW_STATUSFilter) + "&";
        if (maxSVR_UPLDW_DTFilter !== undefined)
            url_ += "MaxSVR_UPLDW_DTFilter=" + encodeURIComponent(maxSVR_UPLDW_DTFilter ? "" + maxSVR_UPLDW_DTFilter.toJSON() : "") + "&";
        if (minSVR_UPLDW_DTFilter !== undefined)
            url_ += "MinSVR_UPLDW_DTFilter=" + encodeURIComponent(minSVR_UPLDW_DTFilter ? "" + minSVR_UPLDW_DTFilter.toJSON() : "") + "&";
        if (cREATED_BYFilter !== undefined)
            url_ += "CREATED_BYFilter=" + encodeURIComponent("" + cREATED_BYFilter) + "&";
        if (sVR_CLIENTFilter !== undefined)
            url_ += "SVR_CLIENTFilter=" + encodeURIComponent("" + sVR_CLIENTFilter) + "&";
        if (maxHHT_SUBMIT_DTFilter !== undefined)
            url_ += "MaxHHT_SUBMIT_DTFilter=" + encodeURIComponent(maxHHT_SUBMIT_DTFilter ? "" + maxHHT_SUBMIT_DTFilter.toJSON() : "") + "&";
        if (minHHT_SUBMIT_DTFilter !== undefined)
            url_ += "MinHHT_SUBMIT_DTFilter=" + encodeURIComponent(minHHT_SUBMIT_DTFilter ? "" + minHHT_SUBMIT_DTFilter.toJSON() : "") + "&";
        if (vISIT_KEYFilter !== undefined)
            url_ += "VISIT_KEYFilter=" + encodeURIComponent("" + vISIT_KEYFilter) + "&";
        if (maxPRN_NOFilter !== undefined)
            url_ += "MaxPRN_NOFilter=" + encodeURIComponent("" + maxPRN_NOFilter) + "&";
        if (minPRN_NOFilter !== undefined)
            url_ += "MinPRN_NOFilter=" + encodeURIComponent("" + minPRN_NOFilter) + "&";
        if (maxPRN_NO_TAXFilter !== undefined)
            url_ += "MaxPRN_NO_TAXFilter=" + encodeURIComponent("" + maxPRN_NO_TAXFilter) + "&";
        if (minPRN_NO_TAXFilter !== undefined)
            url_ += "MinPRN_NO_TAXFilter=" + encodeURIComponent("" + minPRN_NO_TAXFilter) + "&";
        if (pICKLIST_INDFilter !== undefined)
            url_ += "PICKLIST_INDFilter=" + encodeURIComponent("" + pICKLIST_INDFilter) + "&";
        if (nPCLAIM_INDFilter !== undefined)
            url_ += "NPCLAIM_INDFilter=" + encodeURIComponent("" + nPCLAIM_INDFilter) + "&";
        if (sPCLAIM_INDFilter !== undefined)
            url_ += "SPCLAIM_INDFilter=" + encodeURIComponent("" + sPCLAIM_INDFilter) + "&";
        if (dE_INDFilter !== undefined)
            url_ += "DE_INDFilter=" + encodeURIComponent("" + dE_INDFilter) + "&";
        if (maxDE_DTFilter !== undefined)
            url_ += "MaxDE_DTFilter=" + encodeURIComponent(maxDE_DTFilter ? "" + maxDE_DTFilter.toJSON() : "") + "&";
        if (minDE_DTFilter !== undefined)
            url_ += "MinDE_DTFilter=" + encodeURIComponent(minDE_DTFilter ? "" + minDE_DTFilter.toJSON() : "") + "&";
        if (eXT_INDFilter !== undefined)
            url_ += "EXT_INDFilter=" + encodeURIComponent("" + eXT_INDFilter) + "&";
        if (fULL_REVERSAL_INDFilter !== undefined)
            url_ += "FULL_REVERSAL_INDFilter=" + encodeURIComponent("" + fULL_REVERSAL_INDFilter) + "&";
        if (maxVERSIONFilter !== undefined)
            url_ += "MaxVERSIONFilter=" + encodeURIComponent("" + maxVERSIONFilter) + "&";
        if (minVERSIONFilter !== undefined)
            url_ += "MinVERSIONFilter=" + encodeURIComponent("" + minVERSIONFilter) + "&";
        if (maxSYNCVERSIONFilter !== undefined)
            url_ += "MaxSYNCVERSIONFilter=" + encodeURIComponent(maxSYNCVERSIONFilter ? "" + maxSYNCVERSIONFilter.toJSON() : "") + "&";
        if (minSYNCVERSIONFilter !== undefined)
            url_ += "MinSYNCVERSIONFilter=" + encodeURIComponent(minSYNCVERSIONFilter ? "" + minSYNCVERSIONFilter.toJSON() : "") + "&";
        if (iNDFilter !== undefined)
            url_ += "INDFilter=" + encodeURIComponent("" + iNDFilter) + "&";
        if (maxPRN_DO_NOFilter !== undefined)
            url_ += "MaxPRN_DO_NOFilter=" + encodeURIComponent("" + maxPRN_DO_NOFilter) + "&";
        if (minPRN_DO_NOFilter !== undefined)
            url_ += "MinPRN_DO_NOFilter=" + encodeURIComponent("" + minPRN_DO_NOFilter) + "&";
        if (eRP_INDFilter !== undefined)
            url_ += "ERP_INDFilter=" + encodeURIComponent("" + eRP_INDFilter) + "&";
        if (aGENT_CDFilter !== undefined)
            url_ += "AGENT_CDFilter=" + encodeURIComponent("" + aGENT_CDFilter) + "&";
        if (maxDW_DTFilter !== undefined)
            url_ += "MaxDW_DTFilter=" + encodeURIComponent(maxDW_DTFilter ? "" + maxDW_DTFilter.toJSON() : "") + "&";
        if (minDW_DTFilter !== undefined)
            url_ += "MinDW_DTFilter=" + encodeURIComponent(minDW_DTFilter ? "" + minDW_DTFilter.toJSON() : "") + "&";
        if (maxINV_DISC_TTLFilter !== undefined)
            url_ += "MaxINV_DISC_TTLFilter=" + encodeURIComponent("" + maxINV_DISC_TTLFilter) + "&";
        if (minINV_DISC_TTLFilter !== undefined)
            url_ += "MinINV_DISC_TTLFilter=" + encodeURIComponent("" + minINV_DISC_TTLFilter) + "&";
        if (pRD_CDFilter !== undefined)
            url_ += "PRD_CDFilter=" + encodeURIComponent("" + pRD_CDFilter) + "&";
        if (pRD_SLSTYPEFilter !== undefined)
            url_ += "PRD_SLSTYPEFilter=" + encodeURIComponent("" + pRD_SLSTYPEFilter) + "&";
        if (maxPRD_INDEXFilter !== undefined)
            url_ += "MaxPRD_INDEXFilter=" + encodeURIComponent("" + maxPRD_INDEXFilter) + "&";
        if (minPRD_INDEXFilter !== undefined)
            url_ += "MinPRD_INDEXFilter=" + encodeURIComponent("" + minPRD_INDEXFilter) + "&";
        if (uOM_CD1Filter !== undefined)
            url_ += "UOM_CD1Filter=" + encodeURIComponent("" + uOM_CD1Filter) + "&";
        if (uOM_CD2Filter !== undefined)
            url_ += "UOM_CD2Filter=" + encodeURIComponent("" + uOM_CD2Filter) + "&";
        if (uOM_CD3Filter !== undefined)
            url_ += "UOM_CD3Filter=" + encodeURIComponent("" + uOM_CD3Filter) + "&";
        if (tAX_INDFilter !== undefined)
            url_ += "TAX_INDFilter=" + encodeURIComponent("" + tAX_INDFilter) + "&";
        if (pRC_TAX_INDFilter !== undefined)
            url_ += "PRC_TAX_INDFilter=" + encodeURIComponent("" + pRC_TAX_INDFilter) + "&";
        if (dEF_UOM_CDFilter !== undefined)
            url_ += "DEF_UOM_CDFilter=" + encodeURIComponent("" + dEF_UOM_CDFilter) + "&";
        if (maxPRD_QTY1Filter !== undefined)
            url_ += "MaxPRD_QTY1Filter=" + encodeURIComponent("" + maxPRD_QTY1Filter) + "&";
        if (minPRD_QTY1Filter !== undefined)
            url_ += "MinPRD_QTY1Filter=" + encodeURIComponent("" + minPRD_QTY1Filter) + "&";
        if (maxPRD_QTY2Filter !== undefined)
            url_ += "MaxPRD_QTY2Filter=" + encodeURIComponent("" + maxPRD_QTY2Filter) + "&";
        if (minPRD_QTY2Filter !== undefined)
            url_ += "MinPRD_QTY2Filter=" + encodeURIComponent("" + minPRD_QTY2Filter) + "&";
        if (maxPRD_QTY3Filter !== undefined)
            url_ += "MaxPRD_QTY3Filter=" + encodeURIComponent("" + maxPRD_QTY3Filter) + "&";
        if (minPRD_QTY3Filter !== undefined)
            url_ += "MinPRD_QTY3Filter=" + encodeURIComponent("" + minPRD_QTY3Filter) + "&";
        if (maxMRPFilter !== undefined)
            url_ += "MaxMRPFilter=" + encodeURIComponent("" + maxMRPFilter) + "&";
        if (minMRPFilter !== undefined)
            url_ += "MinMRPFilter=" + encodeURIComponent("" + minMRPFilter) + "&";
        if (maxCPFilter !== undefined)
            url_ += "MaxCPFilter=" + encodeURIComponent("" + maxCPFilter) + "&";
        if (minCPFilter !== undefined)
            url_ += "MinCPFilter=" + encodeURIComponent("" + minCPFilter) + "&";
        if (maxPRD_LISTPRCFilter !== undefined)
            url_ += "MaxPRD_LISTPRCFilter=" + encodeURIComponent("" + maxPRD_LISTPRCFilter) + "&";
        if (minPRD_LISTPRCFilter !== undefined)
            url_ += "MinPRD_LISTPRCFilter=" + encodeURIComponent("" + minPRD_LISTPRCFilter) + "&";
        if (maxUOM_LISTPRC1Filter !== undefined)
            url_ += "MaxUOM_LISTPRC1Filter=" + encodeURIComponent("" + maxUOM_LISTPRC1Filter) + "&";
        if (minUOM_LISTPRC1Filter !== undefined)
            url_ += "MinUOM_LISTPRC1Filter=" + encodeURIComponent("" + minUOM_LISTPRC1Filter) + "&";
        if (maxUOM_LISTPRC2Filter !== undefined)
            url_ += "MaxUOM_LISTPRC2Filter=" + encodeURIComponent("" + maxUOM_LISTPRC2Filter) + "&";
        if (minUOM_LISTPRC2Filter !== undefined)
            url_ += "MinUOM_LISTPRC2Filter=" + encodeURIComponent("" + minUOM_LISTPRC2Filter) + "&";
        if (maxUOM_LISTPRC3Filter !== undefined)
            url_ += "MaxUOM_LISTPRC3Filter=" + encodeURIComponent("" + maxUOM_LISTPRC3Filter) + "&";
        if (minUOM_LISTPRC3Filter !== undefined)
            url_ += "MinUOM_LISTPRC3Filter=" + encodeURIComponent("" + minUOM_LISTPRC3Filter) + "&";
        if (maxPRC_TAX_PERC1Filter !== undefined)
            url_ += "MaxPRC_TAX_PERC1Filter=" + encodeURIComponent("" + maxPRC_TAX_PERC1Filter) + "&";
        if (minPRC_TAX_PERC1Filter !== undefined)
            url_ += "MinPRC_TAX_PERC1Filter=" + encodeURIComponent("" + minPRC_TAX_PERC1Filter) + "&";
        if (maxPRC_TAX_PERC2Filter !== undefined)
            url_ += "MaxPRC_TAX_PERC2Filter=" + encodeURIComponent("" + maxPRC_TAX_PERC2Filter) + "&";
        if (minPRC_TAX_PERC2Filter !== undefined)
            url_ += "MinPRC_TAX_PERC2Filter=" + encodeURIComponent("" + minPRC_TAX_PERC2Filter) + "&";
        if (maxPRC_TAX_PERC3Filter !== undefined)
            url_ += "MaxPRC_TAX_PERC3Filter=" + encodeURIComponent("" + maxPRC_TAX_PERC3Filter) + "&";
        if (minPRC_TAX_PERC3Filter !== undefined)
            url_ += "MinPRC_TAX_PERC3Filter=" + encodeURIComponent("" + minPRC_TAX_PERC3Filter) + "&";
        if (maxPRC_TAX_AMT1Filter !== undefined)
            url_ += "MaxPRC_TAX_AMT1Filter=" + encodeURIComponent("" + maxPRC_TAX_AMT1Filter) + "&";
        if (minPRC_TAX_AMT1Filter !== undefined)
            url_ += "MinPRC_TAX_AMT1Filter=" + encodeURIComponent("" + minPRC_TAX_AMT1Filter) + "&";
        if (maxPRC_TAX_AMT2Filter !== undefined)
            url_ += "MaxPRC_TAX_AMT2Filter=" + encodeURIComponent("" + maxPRC_TAX_AMT2Filter) + "&";
        if (minPRC_TAX_AMT2Filter !== undefined)
            url_ += "MinPRC_TAX_AMT2Filter=" + encodeURIComponent("" + minPRC_TAX_AMT2Filter) + "&";
        if (maxPRC_TAX_AMT3Filter !== undefined)
            url_ += "MaxPRC_TAX_AMT3Filter=" + encodeURIComponent("" + maxPRC_TAX_AMT3Filter) + "&";
        if (minPRC_TAX_AMT3Filter !== undefined)
            url_ += "MinPRC_TAX_AMT3Filter=" + encodeURIComponent("" + minPRC_TAX_AMT3Filter) + "&";
        if (maxPRC_TAX_AMTFilter !== undefined)
            url_ += "MaxPRC_TAX_AMTFilter=" + encodeURIComponent("" + maxPRC_TAX_AMTFilter) + "&";
        if (minPRC_TAX_AMTFilter !== undefined)
            url_ += "MinPRC_TAX_AMTFilter=" + encodeURIComponent("" + minPRC_TAX_AMTFilter) + "&";
        if (maxPRD_DISCFilter !== undefined)
            url_ += "MaxPRD_DISCFilter=" + encodeURIComponent("" + maxPRD_DISCFilter) + "&";
        if (minPRD_DISCFilter !== undefined)
            url_ += "MinPRD_DISCFilter=" + encodeURIComponent("" + minPRD_DISCFilter) + "&";
        if (maxGROSS_AMTFilter !== undefined)
            url_ += "MaxGROSS_AMTFilter=" + encodeURIComponent("" + maxGROSS_AMTFilter) + "&";
        if (minGROSS_AMTFilter !== undefined)
            url_ += "MinGROSS_AMTFilter=" + encodeURIComponent("" + minGROSS_AMTFilter) + "&";
        if (maxPROMO_DISC_DTLFilter !== undefined)
            url_ += "MaxPROMO_DISC_DTLFilter=" + encodeURIComponent("" + maxPROMO_DISC_DTLFilter) + "&";
        if (minPROMO_DISC_DTLFilter !== undefined)
            url_ += "MinPROMO_DISC_DTLFilter=" + encodeURIComponent("" + minPROMO_DISC_DTLFilter) + "&";
        if (maxDIST_PROMO_DISCFilter !== undefined)
            url_ += "MaxDIST_PROMO_DISCFilter=" + encodeURIComponent("" + maxDIST_PROMO_DISCFilter) + "&";
        if (minDIST_PROMO_DISCFilter !== undefined)
            url_ += "MinDIST_PROMO_DISCFilter=" + encodeURIComponent("" + minDIST_PROMO_DISCFilter) + "&";
        if (maxHQ_PROMO_DISCFilter !== undefined)
            url_ += "MaxHQ_PROMO_DISCFilter=" + encodeURIComponent("" + maxHQ_PROMO_DISCFilter) + "&";
        if (minHQ_PROMO_DISCFilter !== undefined)
            url_ += "MinHQ_PROMO_DISCFilter=" + encodeURIComponent("" + minHQ_PROMO_DISCFilter) + "&";
        if (maxSLS_DISC_DTLFilter !== undefined)
            url_ += "MaxSLS_DISC_DTLFilter=" + encodeURIComponent("" + maxSLS_DISC_DTLFilter) + "&";
        if (minSLS_DISC_DTLFilter !== undefined)
            url_ += "MinSLS_DISC_DTLFilter=" + encodeURIComponent("" + minSLS_DISC_DTLFilter) + "&";
        if (maxCUST_GRP_DISC_DTLFilter !== undefined)
            url_ += "MaxCUST_GRP_DISC_DTLFilter=" + encodeURIComponent("" + maxCUST_GRP_DISC_DTLFilter) + "&";
        if (minCUST_GRP_DISC_DTLFilter !== undefined)
            url_ += "MinCUST_GRP_DISC_DTLFilter=" + encodeURIComponent("" + minCUST_GRP_DISC_DTLFilter) + "&";
        if (maxCASH_DISC_PERCFilter !== undefined)
            url_ += "MaxCASH_DISC_PERCFilter=" + encodeURIComponent("" + maxCASH_DISC_PERCFilter) + "&";
        if (minCASH_DISC_PERCFilter !== undefined)
            url_ += "MinCASH_DISC_PERCFilter=" + encodeURIComponent("" + minCASH_DISC_PERCFilter) + "&";
        if (maxCASH_DISC_DTLFilter !== undefined)
            url_ += "MaxCASH_DISC_DTLFilter=" + encodeURIComponent("" + maxCASH_DISC_DTLFilter) + "&";
        if (minCASH_DISC_DTLFilter !== undefined)
            url_ += "MinCASH_DISC_DTLFilter=" + encodeURIComponent("" + minCASH_DISC_DTLFilter) + "&";
        if (maxUNIT_TAXFilter !== undefined)
            url_ += "MaxUNIT_TAXFilter=" + encodeURIComponent("" + maxUNIT_TAXFilter) + "&";
        if (minUNIT_TAXFilter !== undefined)
            url_ += "MinUNIT_TAXFilter=" + encodeURIComponent("" + minUNIT_TAXFilter) + "&";
        if (maxNET_AMTFilter !== undefined)
            url_ += "MaxNET_AMTFilter=" + encodeURIComponent("" + maxNET_AMTFilter) + "&";
        if (minNET_AMTFilter !== undefined)
            url_ += "MinNET_AMTFilter=" + encodeURIComponent("" + minNET_AMTFilter) + "&";
        if (maxNET_AMT_TAXFilter !== undefined)
            url_ += "MaxNET_AMT_TAXFilter=" + encodeURIComponent("" + maxNET_AMT_TAXFilter) + "&";
        if (minNET_AMT_TAXFilter !== undefined)
            url_ += "MinNET_AMT_TAXFilter=" + encodeURIComponent("" + minNET_AMT_TAXFilter) + "&";
        if (maxNET_AMT_FOCFilter !== undefined)
            url_ += "MaxNET_AMT_FOCFilter=" + encodeURIComponent("" + maxNET_AMT_FOCFilter) + "&";
        if (minNET_AMT_FOCFilter !== undefined)
            url_ += "MinNET_AMT_FOCFilter=" + encodeURIComponent("" + minNET_AMT_FOCFilter) + "&";
        if (maxCUST_DISC_DTLFilter !== undefined)
            url_ += "MaxCUST_DISC_DTLFilter=" + encodeURIComponent("" + maxCUST_DISC_DTLFilter) + "&";
        if (minCUST_DISC_DTLFilter !== undefined)
            url_ += "MinCUST_DISC_DTLFilter=" + encodeURIComponent("" + minCUST_DISC_DTLFilter) + "&";
        if (maxTAX_PERC1_DTLFilter !== undefined)
            url_ += "MaxTAX_PERC1_DTLFilter=" + encodeURIComponent("" + maxTAX_PERC1_DTLFilter) + "&";
        if (minTAX_PERC1_DTLFilter !== undefined)
            url_ += "MinTAX_PERC1_DTLFilter=" + encodeURIComponent("" + minTAX_PERC1_DTLFilter) + "&";
        if (maxTAX_PERC2_DTLFilter !== undefined)
            url_ += "MaxTAX_PERC2_DTLFilter=" + encodeURIComponent("" + maxTAX_PERC2_DTLFilter) + "&";
        if (minTAX_PERC2_DTLFilter !== undefined)
            url_ += "MinTAX_PERC2_DTLFilter=" + encodeURIComponent("" + minTAX_PERC2_DTLFilter) + "&";
        if (maxTAX_PERC3_DTLFilter !== undefined)
            url_ += "MaxTAX_PERC3_DTLFilter=" + encodeURIComponent("" + maxTAX_PERC3_DTLFilter) + "&";
        if (minTAX_PERC3_DTLFilter !== undefined)
            url_ += "MinTAX_PERC3_DTLFilter=" + encodeURIComponent("" + minTAX_PERC3_DTLFilter) + "&";
        if (maxTAX_AMT1Filter !== undefined)
            url_ += "MaxTAX_AMT1Filter=" + encodeURIComponent("" + maxTAX_AMT1Filter) + "&";
        if (minTAX_AMT1Filter !== undefined)
            url_ += "MinTAX_AMT1Filter=" + encodeURIComponent("" + minTAX_AMT1Filter) + "&";
        if (maxTAX_AMT2Filter !== undefined)
            url_ += "MaxTAX_AMT2Filter=" + encodeURIComponent("" + maxTAX_AMT2Filter) + "&";
        if (minTAX_AMT2Filter !== undefined)
            url_ += "MinTAX_AMT2Filter=" + encodeURIComponent("" + minTAX_AMT2Filter) + "&";
        if (maxTAX_AMT3Filter !== undefined)
            url_ += "MaxTAX_AMT3Filter=" + encodeURIComponent("" + maxTAX_AMT3Filter) + "&";
        if (minTAX_AMT3Filter !== undefined)
            url_ += "MinTAX_AMT3Filter=" + encodeURIComponent("" + minTAX_AMT3Filter) + "&";
        if (maxTAX_AMTFilter !== undefined)
            url_ += "MaxTAX_AMTFilter=" + encodeURIComponent("" + maxTAX_AMTFilter) + "&";
        if (minTAX_AMTFilter !== undefined)
            url_ += "MinTAX_AMTFilter=" + encodeURIComponent("" + minTAX_AMTFilter) + "&";
        if (maxADD_TAX_PERCFilter !== undefined)
            url_ += "MaxADD_TAX_PERCFilter=" + encodeURIComponent("" + maxADD_TAX_PERCFilter) + "&";
        if (minADD_TAX_PERCFilter !== undefined)
            url_ += "MinADD_TAX_PERCFilter=" + encodeURIComponent("" + minADD_TAX_PERCFilter) + "&";
        if (maxADD_TAX_AMT_DTLFilter !== undefined)
            url_ += "MaxADD_TAX_AMT_DTLFilter=" + encodeURIComponent("" + maxADD_TAX_AMT_DTLFilter) + "&";
        if (minADD_TAX_AMT_DTLFilter !== undefined)
            url_ += "MinADD_TAX_AMT_DTLFilter=" + encodeURIComponent("" + minADD_TAX_AMT_DTLFilter) + "&";
        if (maxPURCHASE_RATEFilter !== undefined)
            url_ += "MaxPURCHASE_RATEFilter=" + encodeURIComponent("" + maxPURCHASE_RATEFilter) + "&";
        if (minPURCHASE_RATEFilter !== undefined)
            url_ += "MinPURCHASE_RATEFilter=" + encodeURIComponent("" + minPURCHASE_RATEFilter) + "&";
        if (maxDIST_DISC_DTLFilter !== undefined)
            url_ += "MaxDIST_DISC_DTLFilter=" + encodeURIComponent("" + maxDIST_DISC_DTLFilter) + "&";
        if (minDIST_DISC_DTLFilter !== undefined)
            url_ += "MinDIST_DISC_DTLFilter=" + encodeURIComponent("" + minDIST_DISC_DTLFilter) + "&";
        if (maxUOM_CONV_FACTOR_SML1Filter !== undefined)
            url_ += "MaxUOM_CONV_FACTOR_SML1Filter=" + encodeURIComponent("" + maxUOM_CONV_FACTOR_SML1Filter) + "&";
        if (minUOM_CONV_FACTOR_SML1Filter !== undefined)
            url_ += "MinUOM_CONV_FACTOR_SML1Filter=" + encodeURIComponent("" + minUOM_CONV_FACTOR_SML1Filter) + "&";
        if (maxUOM_CONV_FACTOR_SML2Filter !== undefined)
            url_ += "MaxUOM_CONV_FACTOR_SML2Filter=" + encodeURIComponent("" + maxUOM_CONV_FACTOR_SML2Filter) + "&";
        if (minUOM_CONV_FACTOR_SML2Filter !== undefined)
            url_ += "MinUOM_CONV_FACTOR_SML2Filter=" + encodeURIComponent("" + minUOM_CONV_FACTOR_SML2Filter) + "&";
        if (maxUOM_CONV_FACTOR_SML3Filter !== undefined)
            url_ += "MaxUOM_CONV_FACTOR_SML3Filter=" + encodeURIComponent("" + maxUOM_CONV_FACTOR_SML3Filter) + "&";
        if (minUOM_CONV_FACTOR_SML3Filter !== undefined)
            url_ += "MinUOM_CONV_FACTOR_SML3Filter=" + encodeURIComponent("" + minUOM_CONV_FACTOR_SML3Filter) + "&";
        if (iND_DTLFilter !== undefined)
            url_ += "IND_DTLFilter=" + encodeURIComponent("" + iND_DTLFilter) + "&";
        if (pARENT_PRDFilter !== undefined)
            url_ += "PARENT_PRDFilter=" + encodeURIComponent("" + pARENT_PRDFilter) + "&";
        if (pARENT_UOMFilter !== undefined)
            url_ += "PARENT_UOMFilter=" + encodeURIComponent("" + pARENT_UOMFilter) + "&";
        if (mY_TAX_CDFilter !== undefined)
            url_ += "MY_TAX_CDFilter=" + encodeURIComponent("" + mY_TAX_CDFilter) + "&";
        if (maxPRICE_ERRORFilter !== undefined)
            url_ += "MaxPRICE_ERRORFilter=" + encodeURIComponent("" + maxPRICE_ERRORFilter) + "&";
        if (minPRICE_ERRORFilter !== undefined)
            url_ += "MinPRICE_ERRORFilter=" + encodeURIComponent("" + minPRICE_ERRORFilter) + "&";
        if (mSL_INDFilter !== undefined)
            url_ += "MSL_INDFilter=" + encodeURIComponent("" + mSL_INDFilter) + "&";
        if (maxINV_DISCFilter !== undefined)
            url_ += "MaxINV_DISCFilter=" + encodeURIComponent("" + maxINV_DISCFilter) + "&";
        if (minINV_DISCFilter !== undefined)
            url_ += "MinINV_DISCFilter=" + encodeURIComponent("" + minINV_DISCFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetTempInvoiceTransactionForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetTempInvoiceTransactionForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetTempInvoiceTransactionForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetTempInvoiceTransactionForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetTempInvoiceTransactionForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetTempInvoiceTransactionForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getTempInvoiceTransactionForEdit(id: number | null | undefined): Observable<GetTempInvoiceTransactionForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/TempInvoiceTransactions/GetTempInvoiceTransactionForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetTempInvoiceTransactionForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTempInvoiceTransactionForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetTempInvoiceTransactionForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetTempInvoiceTransactionForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetTempInvoiceTransactionForEdit(response: HttpResponseBase): Observable<GetTempInvoiceTransactionForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetTempInvoiceTransactionForEditOutput.fromJS(resultData200) : new GetTempInvoiceTransactionForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTempInvoiceTransactionForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditTempInvoiceTransactionDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TempInvoiceTransactions/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TempInvoiceTransactions/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param dIST_CDFilter (optional) 
     * @param cUST_CDFilter (optional) 
     * @param sLSMAN_CDFilter (optional) 
     * @param iNV_NOFilter (optional) 
     * @param iNV_KEYFilter (optional) 
     * @param sO_NOFilter (optional) 
     * @param sO_KEYFilter (optional) 
     * @param tINV_NOFilter (optional) 
     * @param wHS_CDFilter (optional) 
     * @param iNV_TYPEFilter (optional) 
     * @param iNV_INDFilter (optional) 
     * @param bILLTO_CDFilter (optional) 
     * @param sHIPTO_CDFilter (optional) 
     * @param dIST_TAX_IDFilter (optional) 
     * @param cUST_TAXREGNOFilter (optional) 
     * @param cUST_MUNICIPALNOFilter (optional) 
     * @param sUBDIST_INDFilter (optional) 
     * @param cUST_TYPEFilter (optional) 
     * @param pO_NOFilter (optional) 
     * @param maxSO_DTFilter (optional) 
     * @param minSO_DTFilter (optional) 
     * @param maxINV_DTFilter (optional) 
     * @param minINV_DTFilter (optional) 
     * @param maxCREATE_DTFilter (optional) 
     * @param minCREATE_DTFilter (optional) 
     * @param maxDELIVERY_DTFilter (optional) 
     * @param minDELIVERY_DTFilter (optional) 
     * @param bU_CDFilter (optional) 
     * @param iNVTERM_CDFilter (optional) 
     * @param iNV_STATUSFilter (optional) 
     * @param rEF_NOFilter (optional) 
     * @param tAX_INV_NOFilter (optional) 
     * @param maxGROSS_TTLFilter (optional) 
     * @param minGROSS_TTLFilter (optional) 
     * @param maxNET_TTLFilter (optional) 
     * @param minNET_TTLFilter (optional) 
     * @param maxNET_TTL_TAXFilter (optional) 
     * @param minNET_TTL_TAXFilter (optional) 
     * @param maxADJ_AMTFilter (optional) 
     * @param minADJ_AMTFilter (optional) 
     * @param maxTAXABLE_AMTFilter (optional) 
     * @param minTAXABLE_AMTFilter (optional) 
     * @param maxTAXABLE_AMT_FOCFilter (optional) 
     * @param minTAXABLE_AMT_FOCFilter (optional) 
     * @param maxNONTAXABLE_AMTFilter (optional) 
     * @param minNONTAXABLE_AMTFilter (optional) 
     * @param maxTAX_PERC1Filter (optional) 
     * @param minTAX_PERC1Filter (optional) 
     * @param maxTAX_PERC2Filter (optional) 
     * @param minTAX_PERC2Filter (optional) 
     * @param maxTAX_PERC3Filter (optional) 
     * @param minTAX_PERC3Filter (optional) 
     * @param maxTAX_TTL1Filter (optional) 
     * @param minTAX_TTL1Filter (optional) 
     * @param maxTAX_TTL2Filter (optional) 
     * @param minTAX_TTL2Filter (optional) 
     * @param maxTAX_TTL3Filter (optional) 
     * @param minTAX_TTL3Filter (optional) 
     * @param maxTAX_TTLFilter (optional) 
     * @param minTAX_TTLFilter (optional) 
     * @param maxPRC_TAX_TTL1Filter (optional) 
     * @param minPRC_TAX_TTL1Filter (optional) 
     * @param maxPRC_TAX_TTL2Filter (optional) 
     * @param minPRC_TAX_TTL2Filter (optional) 
     * @param maxPRC_TAX_TTL3Filter (optional) 
     * @param minPRC_TAX_TTL3Filter (optional) 
     * @param maxPRC_TAX_TTLFilter (optional) 
     * @param minPRC_TAX_TTLFilter (optional) 
     * @param maxCUST_DISC_PERCFilter (optional) 
     * @param minCUST_DISC_PERCFilter (optional) 
     * @param maxCUST_DISC_AMTFilter (optional) 
     * @param minCUST_DISC_AMTFilter (optional) 
     * @param maxPRD_DISC_TTLFilter (optional) 
     * @param minPRD_DISC_TTLFilter (optional) 
     * @param maxCLAIM_DISCFilter (optional) 
     * @param minCLAIM_DISCFilter (optional) 
     * @param maxDIST_DISCFilter (optional) 
     * @param minDIST_DISCFilter (optional) 
     * @param maxPROMO_DISCFilter (optional) 
     * @param minPROMO_DISCFilter (optional) 
     * @param maxSLS_DISCFilter (optional) 
     * @param minSLS_DISCFilter (optional) 
     * @param maxCASH_DISCFilter (optional) 
     * @param minCASH_DISCFilter (optional) 
     * @param maxCUST_GRP_DISCFilter (optional) 
     * @param minCUST_GRP_DISCFilter (optional) 
     * @param maxADD_TAX_AMTFilter (optional) 
     * @param minADD_TAX_AMTFilter (optional) 
     * @param rEMARKFilter (optional) 
     * @param uPLDW_STATUSFilter (optional) 
     * @param maxSVR_UPLDW_DTFilter (optional) 
     * @param minSVR_UPLDW_DTFilter (optional) 
     * @param cREATED_BYFilter (optional) 
     * @param sVR_CLIENTFilter (optional) 
     * @param maxHHT_SUBMIT_DTFilter (optional) 
     * @param minHHT_SUBMIT_DTFilter (optional) 
     * @param vISIT_KEYFilter (optional) 
     * @param maxPRN_NOFilter (optional) 
     * @param minPRN_NOFilter (optional) 
     * @param maxPRN_NO_TAXFilter (optional) 
     * @param minPRN_NO_TAXFilter (optional) 
     * @param pICKLIST_INDFilter (optional) 
     * @param nPCLAIM_INDFilter (optional) 
     * @param sPCLAIM_INDFilter (optional) 
     * @param dE_INDFilter (optional) 
     * @param maxDE_DTFilter (optional) 
     * @param minDE_DTFilter (optional) 
     * @param eXT_INDFilter (optional) 
     * @param fULL_REVERSAL_INDFilter (optional) 
     * @param maxVERSIONFilter (optional) 
     * @param minVERSIONFilter (optional) 
     * @param maxSYNCVERSIONFilter (optional) 
     * @param minSYNCVERSIONFilter (optional) 
     * @param iNDFilter (optional) 
     * @param maxPRN_DO_NOFilter (optional) 
     * @param minPRN_DO_NOFilter (optional) 
     * @param eRP_INDFilter (optional) 
     * @param aGENT_CDFilter (optional) 
     * @param maxDW_DTFilter (optional) 
     * @param minDW_DTFilter (optional) 
     * @param maxINV_DISC_TTLFilter (optional) 
     * @param minINV_DISC_TTLFilter (optional) 
     * @param pRD_CDFilter (optional) 
     * @param pRD_SLSTYPEFilter (optional) 
     * @param maxPRD_INDEXFilter (optional) 
     * @param minPRD_INDEXFilter (optional) 
     * @param uOM_CD1Filter (optional) 
     * @param uOM_CD2Filter (optional) 
     * @param uOM_CD3Filter (optional) 
     * @param tAX_INDFilter (optional) 
     * @param pRC_TAX_INDFilter (optional) 
     * @param dEF_UOM_CDFilter (optional) 
     * @param maxPRD_QTY1Filter (optional) 
     * @param minPRD_QTY1Filter (optional) 
     * @param maxPRD_QTY2Filter (optional) 
     * @param minPRD_QTY2Filter (optional) 
     * @param maxPRD_QTY3Filter (optional) 
     * @param minPRD_QTY3Filter (optional) 
     * @param maxMRPFilter (optional) 
     * @param minMRPFilter (optional) 
     * @param maxCPFilter (optional) 
     * @param minCPFilter (optional) 
     * @param maxPRD_LISTPRCFilter (optional) 
     * @param minPRD_LISTPRCFilter (optional) 
     * @param maxUOM_LISTPRC1Filter (optional) 
     * @param minUOM_LISTPRC1Filter (optional) 
     * @param maxUOM_LISTPRC2Filter (optional) 
     * @param minUOM_LISTPRC2Filter (optional) 
     * @param maxUOM_LISTPRC3Filter (optional) 
     * @param minUOM_LISTPRC3Filter (optional) 
     * @param maxPRC_TAX_PERC1Filter (optional) 
     * @param minPRC_TAX_PERC1Filter (optional) 
     * @param maxPRC_TAX_PERC2Filter (optional) 
     * @param minPRC_TAX_PERC2Filter (optional) 
     * @param maxPRC_TAX_PERC3Filter (optional) 
     * @param minPRC_TAX_PERC3Filter (optional) 
     * @param maxPRC_TAX_AMT1Filter (optional) 
     * @param minPRC_TAX_AMT1Filter (optional) 
     * @param maxPRC_TAX_AMT2Filter (optional) 
     * @param minPRC_TAX_AMT2Filter (optional) 
     * @param maxPRC_TAX_AMT3Filter (optional) 
     * @param minPRC_TAX_AMT3Filter (optional) 
     * @param maxPRC_TAX_AMTFilter (optional) 
     * @param minPRC_TAX_AMTFilter (optional) 
     * @param maxPRD_DISCFilter (optional) 
     * @param minPRD_DISCFilter (optional) 
     * @param maxGROSS_AMTFilter (optional) 
     * @param minGROSS_AMTFilter (optional) 
     * @param maxPROMO_DISC_DTLFilter (optional) 
     * @param minPROMO_DISC_DTLFilter (optional) 
     * @param maxDIST_PROMO_DISCFilter (optional) 
     * @param minDIST_PROMO_DISCFilter (optional) 
     * @param maxHQ_PROMO_DISCFilter (optional) 
     * @param minHQ_PROMO_DISCFilter (optional) 
     * @param maxSLS_DISC_DTLFilter (optional) 
     * @param minSLS_DISC_DTLFilter (optional) 
     * @param maxCUST_GRP_DISC_DTLFilter (optional) 
     * @param minCUST_GRP_DISC_DTLFilter (optional) 
     * @param maxCASH_DISC_PERCFilter (optional) 
     * @param minCASH_DISC_PERCFilter (optional) 
     * @param maxCASH_DISC_DTLFilter (optional) 
     * @param minCASH_DISC_DTLFilter (optional) 
     * @param maxUNIT_TAXFilter (optional) 
     * @param minUNIT_TAXFilter (optional) 
     * @param maxNET_AMTFilter (optional) 
     * @param minNET_AMTFilter (optional) 
     * @param maxNET_AMT_TAXFilter (optional) 
     * @param minNET_AMT_TAXFilter (optional) 
     * @param maxNET_AMT_FOCFilter (optional) 
     * @param minNET_AMT_FOCFilter (optional) 
     * @param maxCUST_DISC_DTLFilter (optional) 
     * @param minCUST_DISC_DTLFilter (optional) 
     * @param maxTAX_PERC1_DTLFilter (optional) 
     * @param minTAX_PERC1_DTLFilter (optional) 
     * @param maxTAX_PERC2_DTLFilter (optional) 
     * @param minTAX_PERC2_DTLFilter (optional) 
     * @param maxTAX_PERC3_DTLFilter (optional) 
     * @param minTAX_PERC3_DTLFilter (optional) 
     * @param maxTAX_AMT1Filter (optional) 
     * @param minTAX_AMT1Filter (optional) 
     * @param maxTAX_AMT2Filter (optional) 
     * @param minTAX_AMT2Filter (optional) 
     * @param maxTAX_AMT3Filter (optional) 
     * @param minTAX_AMT3Filter (optional) 
     * @param maxTAX_AMTFilter (optional) 
     * @param minTAX_AMTFilter (optional) 
     * @param maxADD_TAX_PERCFilter (optional) 
     * @param minADD_TAX_PERCFilter (optional) 
     * @param maxADD_TAX_AMT_DTLFilter (optional) 
     * @param minADD_TAX_AMT_DTLFilter (optional) 
     * @param maxPURCHASE_RATEFilter (optional) 
     * @param minPURCHASE_RATEFilter (optional) 
     * @param maxDIST_DISC_DTLFilter (optional) 
     * @param minDIST_DISC_DTLFilter (optional) 
     * @param maxUOM_CONV_FACTOR_SML1Filter (optional) 
     * @param minUOM_CONV_FACTOR_SML1Filter (optional) 
     * @param maxUOM_CONV_FACTOR_SML2Filter (optional) 
     * @param minUOM_CONV_FACTOR_SML2Filter (optional) 
     * @param maxUOM_CONV_FACTOR_SML3Filter (optional) 
     * @param minUOM_CONV_FACTOR_SML3Filter (optional) 
     * @param iND_DTLFilter (optional) 
     * @param pARENT_PRDFilter (optional) 
     * @param pARENT_UOMFilter (optional) 
     * @param mY_TAX_CDFilter (optional) 
     * @param maxPRICE_ERRORFilter (optional) 
     * @param minPRICE_ERRORFilter (optional) 
     * @param mSL_INDFilter (optional) 
     * @param maxINV_DISCFilter (optional) 
     * @param minINV_DISCFilter (optional) 
     * @return Success
     */
    getTempInvoiceTransactionsToExcel(filter: string | null | undefined, dIST_CDFilter: string | null | undefined, cUST_CDFilter: string | null | undefined, sLSMAN_CDFilter: string | null | undefined, iNV_NOFilter: string | null | undefined, iNV_KEYFilter: string | null | undefined, sO_NOFilter: string | null | undefined, sO_KEYFilter: string | null | undefined, tINV_NOFilter: string | null | undefined, wHS_CDFilter: string | null | undefined, iNV_TYPEFilter: string | null | undefined, iNV_INDFilter: string | null | undefined, bILLTO_CDFilter: string | null | undefined, sHIPTO_CDFilter: string | null | undefined, dIST_TAX_IDFilter: string | null | undefined, cUST_TAXREGNOFilter: string | null | undefined, cUST_MUNICIPALNOFilter: string | null | undefined, sUBDIST_INDFilter: string | null | undefined, cUST_TYPEFilter: string | null | undefined, pO_NOFilter: string | null | undefined, maxSO_DTFilter: moment.Moment | null | undefined, minSO_DTFilter: moment.Moment | null | undefined, maxINV_DTFilter: moment.Moment | null | undefined, minINV_DTFilter: moment.Moment | null | undefined, maxCREATE_DTFilter: moment.Moment | null | undefined, minCREATE_DTFilter: moment.Moment | null | undefined, maxDELIVERY_DTFilter: moment.Moment | null | undefined, minDELIVERY_DTFilter: moment.Moment | null | undefined, bU_CDFilter: string | null | undefined, iNVTERM_CDFilter: string | null | undefined, iNV_STATUSFilter: string | null | undefined, rEF_NOFilter: string | null | undefined, tAX_INV_NOFilter: string | null | undefined, maxGROSS_TTLFilter: number | null | undefined, minGROSS_TTLFilter: number | null | undefined, maxNET_TTLFilter: number | null | undefined, minNET_TTLFilter: number | null | undefined, maxNET_TTL_TAXFilter: number | null | undefined, minNET_TTL_TAXFilter: number | null | undefined, maxADJ_AMTFilter: number | null | undefined, minADJ_AMTFilter: number | null | undefined, maxTAXABLE_AMTFilter: number | null | undefined, minTAXABLE_AMTFilter: number | null | undefined, maxTAXABLE_AMT_FOCFilter: number | null | undefined, minTAXABLE_AMT_FOCFilter: number | null | undefined, maxNONTAXABLE_AMTFilter: number | null | undefined, minNONTAXABLE_AMTFilter: number | null | undefined, maxTAX_PERC1Filter: number | null | undefined, minTAX_PERC1Filter: number | null | undefined, maxTAX_PERC2Filter: number | null | undefined, minTAX_PERC2Filter: number | null | undefined, maxTAX_PERC3Filter: number | null | undefined, minTAX_PERC3Filter: number | null | undefined, maxTAX_TTL1Filter: number | null | undefined, minTAX_TTL1Filter: number | null | undefined, maxTAX_TTL2Filter: number | null | undefined, minTAX_TTL2Filter: number | null | undefined, maxTAX_TTL3Filter: number | null | undefined, minTAX_TTL3Filter: number | null | undefined, maxTAX_TTLFilter: number | null | undefined, minTAX_TTLFilter: number | null | undefined, maxPRC_TAX_TTL1Filter: number | null | undefined, minPRC_TAX_TTL1Filter: number | null | undefined, maxPRC_TAX_TTL2Filter: number | null | undefined, minPRC_TAX_TTL2Filter: number | null | undefined, maxPRC_TAX_TTL3Filter: number | null | undefined, minPRC_TAX_TTL3Filter: number | null | undefined, maxPRC_TAX_TTLFilter: number | null | undefined, minPRC_TAX_TTLFilter: number | null | undefined, maxCUST_DISC_PERCFilter: number | null | undefined, minCUST_DISC_PERCFilter: number | null | undefined, maxCUST_DISC_AMTFilter: number | null | undefined, minCUST_DISC_AMTFilter: number | null | undefined, maxPRD_DISC_TTLFilter: number | null | undefined, minPRD_DISC_TTLFilter: number | null | undefined, maxCLAIM_DISCFilter: number | null | undefined, minCLAIM_DISCFilter: number | null | undefined, maxDIST_DISCFilter: number | null | undefined, minDIST_DISCFilter: number | null | undefined, maxPROMO_DISCFilter: number | null | undefined, minPROMO_DISCFilter: number | null | undefined, maxSLS_DISCFilter: number | null | undefined, minSLS_DISCFilter: number | null | undefined, maxCASH_DISCFilter: number | null | undefined, minCASH_DISCFilter: number | null | undefined, maxCUST_GRP_DISCFilter: number | null | undefined, minCUST_GRP_DISCFilter: number | null | undefined, maxADD_TAX_AMTFilter: number | null | undefined, minADD_TAX_AMTFilter: number | null | undefined, rEMARKFilter: string | null | undefined, uPLDW_STATUSFilter: string | null | undefined, maxSVR_UPLDW_DTFilter: moment.Moment | null | undefined, minSVR_UPLDW_DTFilter: moment.Moment | null | undefined, cREATED_BYFilter: string | null | undefined, sVR_CLIENTFilter: string | null | undefined, maxHHT_SUBMIT_DTFilter: moment.Moment | null | undefined, minHHT_SUBMIT_DTFilter: moment.Moment | null | undefined, vISIT_KEYFilter: string | null | undefined, maxPRN_NOFilter: number | null | undefined, minPRN_NOFilter: number | null | undefined, maxPRN_NO_TAXFilter: number | null | undefined, minPRN_NO_TAXFilter: number | null | undefined, pICKLIST_INDFilter: number | null | undefined, nPCLAIM_INDFilter: number | null | undefined, sPCLAIM_INDFilter: number | null | undefined, dE_INDFilter: string | null | undefined, maxDE_DTFilter: moment.Moment | null | undefined, minDE_DTFilter: moment.Moment | null | undefined, eXT_INDFilter: string | null | undefined, fULL_REVERSAL_INDFilter: string | null | undefined, maxVERSIONFilter: number | null | undefined, minVERSIONFilter: number | null | undefined, maxSYNCVERSIONFilter: moment.Moment | null | undefined, minSYNCVERSIONFilter: moment.Moment | null | undefined, iNDFilter: string | null | undefined, maxPRN_DO_NOFilter: number | null | undefined, minPRN_DO_NOFilter: number | null | undefined, eRP_INDFilter: number | null | undefined, aGENT_CDFilter: string | null | undefined, maxDW_DTFilter: moment.Moment | null | undefined, minDW_DTFilter: moment.Moment | null | undefined, maxINV_DISC_TTLFilter: number | null | undefined, minINV_DISC_TTLFilter: number | null | undefined, pRD_CDFilter: string | null | undefined, pRD_SLSTYPEFilter: string | null | undefined, maxPRD_INDEXFilter: number | null | undefined, minPRD_INDEXFilter: number | null | undefined, uOM_CD1Filter: string | null | undefined, uOM_CD2Filter: string | null | undefined, uOM_CD3Filter: string | null | undefined, tAX_INDFilter: number | null | undefined, pRC_TAX_INDFilter: string | null | undefined, dEF_UOM_CDFilter: string | null | undefined, maxPRD_QTY1Filter: number | null | undefined, minPRD_QTY1Filter: number | null | undefined, maxPRD_QTY2Filter: number | null | undefined, minPRD_QTY2Filter: number | null | undefined, maxPRD_QTY3Filter: number | null | undefined, minPRD_QTY3Filter: number | null | undefined, maxMRPFilter: number | null | undefined, minMRPFilter: number | null | undefined, maxCPFilter: number | null | undefined, minCPFilter: number | null | undefined, maxPRD_LISTPRCFilter: number | null | undefined, minPRD_LISTPRCFilter: number | null | undefined, maxUOM_LISTPRC1Filter: number | null | undefined, minUOM_LISTPRC1Filter: number | null | undefined, maxUOM_LISTPRC2Filter: number | null | undefined, minUOM_LISTPRC2Filter: number | null | undefined, maxUOM_LISTPRC3Filter: number | null | undefined, minUOM_LISTPRC3Filter: number | null | undefined, maxPRC_TAX_PERC1Filter: number | null | undefined, minPRC_TAX_PERC1Filter: number | null | undefined, maxPRC_TAX_PERC2Filter: number | null | undefined, minPRC_TAX_PERC2Filter: number | null | undefined, maxPRC_TAX_PERC3Filter: number | null | undefined, minPRC_TAX_PERC3Filter: number | null | undefined, maxPRC_TAX_AMT1Filter: number | null | undefined, minPRC_TAX_AMT1Filter: number | null | undefined, maxPRC_TAX_AMT2Filter: number | null | undefined, minPRC_TAX_AMT2Filter: number | null | undefined, maxPRC_TAX_AMT3Filter: number | null | undefined, minPRC_TAX_AMT3Filter: number | null | undefined, maxPRC_TAX_AMTFilter: number | null | undefined, minPRC_TAX_AMTFilter: number | null | undefined, maxPRD_DISCFilter: number | null | undefined, minPRD_DISCFilter: number | null | undefined, maxGROSS_AMTFilter: number | null | undefined, minGROSS_AMTFilter: number | null | undefined, maxPROMO_DISC_DTLFilter: number | null | undefined, minPROMO_DISC_DTLFilter: number | null | undefined, maxDIST_PROMO_DISCFilter: number | null | undefined, minDIST_PROMO_DISCFilter: number | null | undefined, maxHQ_PROMO_DISCFilter: number | null | undefined, minHQ_PROMO_DISCFilter: number | null | undefined, maxSLS_DISC_DTLFilter: number | null | undefined, minSLS_DISC_DTLFilter: number | null | undefined, maxCUST_GRP_DISC_DTLFilter: number | null | undefined, minCUST_GRP_DISC_DTLFilter: number | null | undefined, maxCASH_DISC_PERCFilter: number | null | undefined, minCASH_DISC_PERCFilter: number | null | undefined, maxCASH_DISC_DTLFilter: number | null | undefined, minCASH_DISC_DTLFilter: number | null | undefined, maxUNIT_TAXFilter: number | null | undefined, minUNIT_TAXFilter: number | null | undefined, maxNET_AMTFilter: number | null | undefined, minNET_AMTFilter: number | null | undefined, maxNET_AMT_TAXFilter: number | null | undefined, minNET_AMT_TAXFilter: number | null | undefined, maxNET_AMT_FOCFilter: number | null | undefined, minNET_AMT_FOCFilter: number | null | undefined, maxCUST_DISC_DTLFilter: number | null | undefined, minCUST_DISC_DTLFilter: number | null | undefined, maxTAX_PERC1_DTLFilter: number | null | undefined, minTAX_PERC1_DTLFilter: number | null | undefined, maxTAX_PERC2_DTLFilter: number | null | undefined, minTAX_PERC2_DTLFilter: number | null | undefined, maxTAX_PERC3_DTLFilter: number | null | undefined, minTAX_PERC3_DTLFilter: number | null | undefined, maxTAX_AMT1Filter: number | null | undefined, minTAX_AMT1Filter: number | null | undefined, maxTAX_AMT2Filter: number | null | undefined, minTAX_AMT2Filter: number | null | undefined, maxTAX_AMT3Filter: number | null | undefined, minTAX_AMT3Filter: number | null | undefined, maxTAX_AMTFilter: number | null | undefined, minTAX_AMTFilter: number | null | undefined, maxADD_TAX_PERCFilter: number | null | undefined, minADD_TAX_PERCFilter: number | null | undefined, maxADD_TAX_AMT_DTLFilter: number | null | undefined, minADD_TAX_AMT_DTLFilter: number | null | undefined, maxPURCHASE_RATEFilter: number | null | undefined, minPURCHASE_RATEFilter: number | null | undefined, maxDIST_DISC_DTLFilter: number | null | undefined, minDIST_DISC_DTLFilter: number | null | undefined, maxUOM_CONV_FACTOR_SML1Filter: number | null | undefined, minUOM_CONV_FACTOR_SML1Filter: number | null | undefined, maxUOM_CONV_FACTOR_SML2Filter: number | null | undefined, minUOM_CONV_FACTOR_SML2Filter: number | null | undefined, maxUOM_CONV_FACTOR_SML3Filter: number | null | undefined, minUOM_CONV_FACTOR_SML3Filter: number | null | undefined, iND_DTLFilter: string | null | undefined, pARENT_PRDFilter: string | null | undefined, pARENT_UOMFilter: string | null | undefined, mY_TAX_CDFilter: string | null | undefined, maxPRICE_ERRORFilter: number | null | undefined, minPRICE_ERRORFilter: number | null | undefined, mSL_INDFilter: string | null | undefined, maxINV_DISCFilter: number | null | undefined, minINV_DISCFilter: number | null | undefined): Observable<PointFileDto> {
        let url_ = this.baseUrl + "/api/services/app/TempInvoiceTransactions/GetTempInvoiceTransactionsToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (dIST_CDFilter !== undefined)
            url_ += "DIST_CDFilter=" + encodeURIComponent("" + dIST_CDFilter) + "&";
        if (cUST_CDFilter !== undefined)
            url_ += "CUST_CDFilter=" + encodeURIComponent("" + cUST_CDFilter) + "&";
        if (sLSMAN_CDFilter !== undefined)
            url_ += "SLSMAN_CDFilter=" + encodeURIComponent("" + sLSMAN_CDFilter) + "&";
        if (iNV_NOFilter !== undefined)
            url_ += "INV_NOFilter=" + encodeURIComponent("" + iNV_NOFilter) + "&";
        if (iNV_KEYFilter !== undefined)
            url_ += "INV_KEYFilter=" + encodeURIComponent("" + iNV_KEYFilter) + "&";
        if (sO_NOFilter !== undefined)
            url_ += "SO_NOFilter=" + encodeURIComponent("" + sO_NOFilter) + "&";
        if (sO_KEYFilter !== undefined)
            url_ += "SO_KEYFilter=" + encodeURIComponent("" + sO_KEYFilter) + "&";
        if (tINV_NOFilter !== undefined)
            url_ += "TINV_NOFilter=" + encodeURIComponent("" + tINV_NOFilter) + "&";
        if (wHS_CDFilter !== undefined)
            url_ += "WHS_CDFilter=" + encodeURIComponent("" + wHS_CDFilter) + "&";
        if (iNV_TYPEFilter !== undefined)
            url_ += "INV_TYPEFilter=" + encodeURIComponent("" + iNV_TYPEFilter) + "&";
        if (iNV_INDFilter !== undefined)
            url_ += "INV_INDFilter=" + encodeURIComponent("" + iNV_INDFilter) + "&";
        if (bILLTO_CDFilter !== undefined)
            url_ += "BILLTO_CDFilter=" + encodeURIComponent("" + bILLTO_CDFilter) + "&";
        if (sHIPTO_CDFilter !== undefined)
            url_ += "SHIPTO_CDFilter=" + encodeURIComponent("" + sHIPTO_CDFilter) + "&";
        if (dIST_TAX_IDFilter !== undefined)
            url_ += "DIST_TAX_IDFilter=" + encodeURIComponent("" + dIST_TAX_IDFilter) + "&";
        if (cUST_TAXREGNOFilter !== undefined)
            url_ += "CUST_TAXREGNOFilter=" + encodeURIComponent("" + cUST_TAXREGNOFilter) + "&";
        if (cUST_MUNICIPALNOFilter !== undefined)
            url_ += "CUST_MUNICIPALNOFilter=" + encodeURIComponent("" + cUST_MUNICIPALNOFilter) + "&";
        if (sUBDIST_INDFilter !== undefined)
            url_ += "SUBDIST_INDFilter=" + encodeURIComponent("" + sUBDIST_INDFilter) + "&";
        if (cUST_TYPEFilter !== undefined)
            url_ += "CUST_TYPEFilter=" + encodeURIComponent("" + cUST_TYPEFilter) + "&";
        if (pO_NOFilter !== undefined)
            url_ += "PO_NOFilter=" + encodeURIComponent("" + pO_NOFilter) + "&";
        if (maxSO_DTFilter !== undefined)
            url_ += "MaxSO_DTFilter=" + encodeURIComponent(maxSO_DTFilter ? "" + maxSO_DTFilter.toJSON() : "") + "&";
        if (minSO_DTFilter !== undefined)
            url_ += "MinSO_DTFilter=" + encodeURIComponent(minSO_DTFilter ? "" + minSO_DTFilter.toJSON() : "") + "&";
        if (maxINV_DTFilter !== undefined)
            url_ += "MaxINV_DTFilter=" + encodeURIComponent(maxINV_DTFilter ? "" + maxINV_DTFilter.toJSON() : "") + "&";
        if (minINV_DTFilter !== undefined)
            url_ += "MinINV_DTFilter=" + encodeURIComponent(minINV_DTFilter ? "" + minINV_DTFilter.toJSON() : "") + "&";
        if (maxCREATE_DTFilter !== undefined)
            url_ += "MaxCREATE_DTFilter=" + encodeURIComponent(maxCREATE_DTFilter ? "" + maxCREATE_DTFilter.toJSON() : "") + "&";
        if (minCREATE_DTFilter !== undefined)
            url_ += "MinCREATE_DTFilter=" + encodeURIComponent(minCREATE_DTFilter ? "" + minCREATE_DTFilter.toJSON() : "") + "&";
        if (maxDELIVERY_DTFilter !== undefined)
            url_ += "MaxDELIVERY_DTFilter=" + encodeURIComponent(maxDELIVERY_DTFilter ? "" + maxDELIVERY_DTFilter.toJSON() : "") + "&";
        if (minDELIVERY_DTFilter !== undefined)
            url_ += "MinDELIVERY_DTFilter=" + encodeURIComponent(minDELIVERY_DTFilter ? "" + minDELIVERY_DTFilter.toJSON() : "") + "&";
        if (bU_CDFilter !== undefined)
            url_ += "BU_CDFilter=" + encodeURIComponent("" + bU_CDFilter) + "&";
        if (iNVTERM_CDFilter !== undefined)
            url_ += "INVTERM_CDFilter=" + encodeURIComponent("" + iNVTERM_CDFilter) + "&";
        if (iNV_STATUSFilter !== undefined)
            url_ += "INV_STATUSFilter=" + encodeURIComponent("" + iNV_STATUSFilter) + "&";
        if (rEF_NOFilter !== undefined)
            url_ += "REF_NOFilter=" + encodeURIComponent("" + rEF_NOFilter) + "&";
        if (tAX_INV_NOFilter !== undefined)
            url_ += "TAX_INV_NOFilter=" + encodeURIComponent("" + tAX_INV_NOFilter) + "&";
        if (maxGROSS_TTLFilter !== undefined)
            url_ += "MaxGROSS_TTLFilter=" + encodeURIComponent("" + maxGROSS_TTLFilter) + "&";
        if (minGROSS_TTLFilter !== undefined)
            url_ += "MinGROSS_TTLFilter=" + encodeURIComponent("" + minGROSS_TTLFilter) + "&";
        if (maxNET_TTLFilter !== undefined)
            url_ += "MaxNET_TTLFilter=" + encodeURIComponent("" + maxNET_TTLFilter) + "&";
        if (minNET_TTLFilter !== undefined)
            url_ += "MinNET_TTLFilter=" + encodeURIComponent("" + minNET_TTLFilter) + "&";
        if (maxNET_TTL_TAXFilter !== undefined)
            url_ += "MaxNET_TTL_TAXFilter=" + encodeURIComponent("" + maxNET_TTL_TAXFilter) + "&";
        if (minNET_TTL_TAXFilter !== undefined)
            url_ += "MinNET_TTL_TAXFilter=" + encodeURIComponent("" + minNET_TTL_TAXFilter) + "&";
        if (maxADJ_AMTFilter !== undefined)
            url_ += "MaxADJ_AMTFilter=" + encodeURIComponent("" + maxADJ_AMTFilter) + "&";
        if (minADJ_AMTFilter !== undefined)
            url_ += "MinADJ_AMTFilter=" + encodeURIComponent("" + minADJ_AMTFilter) + "&";
        if (maxTAXABLE_AMTFilter !== undefined)
            url_ += "MaxTAXABLE_AMTFilter=" + encodeURIComponent("" + maxTAXABLE_AMTFilter) + "&";
        if (minTAXABLE_AMTFilter !== undefined)
            url_ += "MinTAXABLE_AMTFilter=" + encodeURIComponent("" + minTAXABLE_AMTFilter) + "&";
        if (maxTAXABLE_AMT_FOCFilter !== undefined)
            url_ += "MaxTAXABLE_AMT_FOCFilter=" + encodeURIComponent("" + maxTAXABLE_AMT_FOCFilter) + "&";
        if (minTAXABLE_AMT_FOCFilter !== undefined)
            url_ += "MinTAXABLE_AMT_FOCFilter=" + encodeURIComponent("" + minTAXABLE_AMT_FOCFilter) + "&";
        if (maxNONTAXABLE_AMTFilter !== undefined)
            url_ += "MaxNONTAXABLE_AMTFilter=" + encodeURIComponent("" + maxNONTAXABLE_AMTFilter) + "&";
        if (minNONTAXABLE_AMTFilter !== undefined)
            url_ += "MinNONTAXABLE_AMTFilter=" + encodeURIComponent("" + minNONTAXABLE_AMTFilter) + "&";
        if (maxTAX_PERC1Filter !== undefined)
            url_ += "MaxTAX_PERC1Filter=" + encodeURIComponent("" + maxTAX_PERC1Filter) + "&";
        if (minTAX_PERC1Filter !== undefined)
            url_ += "MinTAX_PERC1Filter=" + encodeURIComponent("" + minTAX_PERC1Filter) + "&";
        if (maxTAX_PERC2Filter !== undefined)
            url_ += "MaxTAX_PERC2Filter=" + encodeURIComponent("" + maxTAX_PERC2Filter) + "&";
        if (minTAX_PERC2Filter !== undefined)
            url_ += "MinTAX_PERC2Filter=" + encodeURIComponent("" + minTAX_PERC2Filter) + "&";
        if (maxTAX_PERC3Filter !== undefined)
            url_ += "MaxTAX_PERC3Filter=" + encodeURIComponent("" + maxTAX_PERC3Filter) + "&";
        if (minTAX_PERC3Filter !== undefined)
            url_ += "MinTAX_PERC3Filter=" + encodeURIComponent("" + minTAX_PERC3Filter) + "&";
        if (maxTAX_TTL1Filter !== undefined)
            url_ += "MaxTAX_TTL1Filter=" + encodeURIComponent("" + maxTAX_TTL1Filter) + "&";
        if (minTAX_TTL1Filter !== undefined)
            url_ += "MinTAX_TTL1Filter=" + encodeURIComponent("" + minTAX_TTL1Filter) + "&";
        if (maxTAX_TTL2Filter !== undefined)
            url_ += "MaxTAX_TTL2Filter=" + encodeURIComponent("" + maxTAX_TTL2Filter) + "&";
        if (minTAX_TTL2Filter !== undefined)
            url_ += "MinTAX_TTL2Filter=" + encodeURIComponent("" + minTAX_TTL2Filter) + "&";
        if (maxTAX_TTL3Filter !== undefined)
            url_ += "MaxTAX_TTL3Filter=" + encodeURIComponent("" + maxTAX_TTL3Filter) + "&";
        if (minTAX_TTL3Filter !== undefined)
            url_ += "MinTAX_TTL3Filter=" + encodeURIComponent("" + minTAX_TTL3Filter) + "&";
        if (maxTAX_TTLFilter !== undefined)
            url_ += "MaxTAX_TTLFilter=" + encodeURIComponent("" + maxTAX_TTLFilter) + "&";
        if (minTAX_TTLFilter !== undefined)
            url_ += "MinTAX_TTLFilter=" + encodeURIComponent("" + minTAX_TTLFilter) + "&";
        if (maxPRC_TAX_TTL1Filter !== undefined)
            url_ += "MaxPRC_TAX_TTL1Filter=" + encodeURIComponent("" + maxPRC_TAX_TTL1Filter) + "&";
        if (minPRC_TAX_TTL1Filter !== undefined)
            url_ += "MinPRC_TAX_TTL1Filter=" + encodeURIComponent("" + minPRC_TAX_TTL1Filter) + "&";
        if (maxPRC_TAX_TTL2Filter !== undefined)
            url_ += "MaxPRC_TAX_TTL2Filter=" + encodeURIComponent("" + maxPRC_TAX_TTL2Filter) + "&";
        if (minPRC_TAX_TTL2Filter !== undefined)
            url_ += "MinPRC_TAX_TTL2Filter=" + encodeURIComponent("" + minPRC_TAX_TTL2Filter) + "&";
        if (maxPRC_TAX_TTL3Filter !== undefined)
            url_ += "MaxPRC_TAX_TTL3Filter=" + encodeURIComponent("" + maxPRC_TAX_TTL3Filter) + "&";
        if (minPRC_TAX_TTL3Filter !== undefined)
            url_ += "MinPRC_TAX_TTL3Filter=" + encodeURIComponent("" + minPRC_TAX_TTL3Filter) + "&";
        if (maxPRC_TAX_TTLFilter !== undefined)
            url_ += "MaxPRC_TAX_TTLFilter=" + encodeURIComponent("" + maxPRC_TAX_TTLFilter) + "&";
        if (minPRC_TAX_TTLFilter !== undefined)
            url_ += "MinPRC_TAX_TTLFilter=" + encodeURIComponent("" + minPRC_TAX_TTLFilter) + "&";
        if (maxCUST_DISC_PERCFilter !== undefined)
            url_ += "MaxCUST_DISC_PERCFilter=" + encodeURIComponent("" + maxCUST_DISC_PERCFilter) + "&";
        if (minCUST_DISC_PERCFilter !== undefined)
            url_ += "MinCUST_DISC_PERCFilter=" + encodeURIComponent("" + minCUST_DISC_PERCFilter) + "&";
        if (maxCUST_DISC_AMTFilter !== undefined)
            url_ += "MaxCUST_DISC_AMTFilter=" + encodeURIComponent("" + maxCUST_DISC_AMTFilter) + "&";
        if (minCUST_DISC_AMTFilter !== undefined)
            url_ += "MinCUST_DISC_AMTFilter=" + encodeURIComponent("" + minCUST_DISC_AMTFilter) + "&";
        if (maxPRD_DISC_TTLFilter !== undefined)
            url_ += "MaxPRD_DISC_TTLFilter=" + encodeURIComponent("" + maxPRD_DISC_TTLFilter) + "&";
        if (minPRD_DISC_TTLFilter !== undefined)
            url_ += "MinPRD_DISC_TTLFilter=" + encodeURIComponent("" + minPRD_DISC_TTLFilter) + "&";
        if (maxCLAIM_DISCFilter !== undefined)
            url_ += "MaxCLAIM_DISCFilter=" + encodeURIComponent("" + maxCLAIM_DISCFilter) + "&";
        if (minCLAIM_DISCFilter !== undefined)
            url_ += "MinCLAIM_DISCFilter=" + encodeURIComponent("" + minCLAIM_DISCFilter) + "&";
        if (maxDIST_DISCFilter !== undefined)
            url_ += "MaxDIST_DISCFilter=" + encodeURIComponent("" + maxDIST_DISCFilter) + "&";
        if (minDIST_DISCFilter !== undefined)
            url_ += "MinDIST_DISCFilter=" + encodeURIComponent("" + minDIST_DISCFilter) + "&";
        if (maxPROMO_DISCFilter !== undefined)
            url_ += "MaxPROMO_DISCFilter=" + encodeURIComponent("" + maxPROMO_DISCFilter) + "&";
        if (minPROMO_DISCFilter !== undefined)
            url_ += "MinPROMO_DISCFilter=" + encodeURIComponent("" + minPROMO_DISCFilter) + "&";
        if (maxSLS_DISCFilter !== undefined)
            url_ += "MaxSLS_DISCFilter=" + encodeURIComponent("" + maxSLS_DISCFilter) + "&";
        if (minSLS_DISCFilter !== undefined)
            url_ += "MinSLS_DISCFilter=" + encodeURIComponent("" + minSLS_DISCFilter) + "&";
        if (maxCASH_DISCFilter !== undefined)
            url_ += "MaxCASH_DISCFilter=" + encodeURIComponent("" + maxCASH_DISCFilter) + "&";
        if (minCASH_DISCFilter !== undefined)
            url_ += "MinCASH_DISCFilter=" + encodeURIComponent("" + minCASH_DISCFilter) + "&";
        if (maxCUST_GRP_DISCFilter !== undefined)
            url_ += "MaxCUST_GRP_DISCFilter=" + encodeURIComponent("" + maxCUST_GRP_DISCFilter) + "&";
        if (minCUST_GRP_DISCFilter !== undefined)
            url_ += "MinCUST_GRP_DISCFilter=" + encodeURIComponent("" + minCUST_GRP_DISCFilter) + "&";
        if (maxADD_TAX_AMTFilter !== undefined)
            url_ += "MaxADD_TAX_AMTFilter=" + encodeURIComponent("" + maxADD_TAX_AMTFilter) + "&";
        if (minADD_TAX_AMTFilter !== undefined)
            url_ += "MinADD_TAX_AMTFilter=" + encodeURIComponent("" + minADD_TAX_AMTFilter) + "&";
        if (rEMARKFilter !== undefined)
            url_ += "REMARKFilter=" + encodeURIComponent("" + rEMARKFilter) + "&";
        if (uPLDW_STATUSFilter !== undefined)
            url_ += "UPLDW_STATUSFilter=" + encodeURIComponent("" + uPLDW_STATUSFilter) + "&";
        if (maxSVR_UPLDW_DTFilter !== undefined)
            url_ += "MaxSVR_UPLDW_DTFilter=" + encodeURIComponent(maxSVR_UPLDW_DTFilter ? "" + maxSVR_UPLDW_DTFilter.toJSON() : "") + "&";
        if (minSVR_UPLDW_DTFilter !== undefined)
            url_ += "MinSVR_UPLDW_DTFilter=" + encodeURIComponent(minSVR_UPLDW_DTFilter ? "" + minSVR_UPLDW_DTFilter.toJSON() : "") + "&";
        if (cREATED_BYFilter !== undefined)
            url_ += "CREATED_BYFilter=" + encodeURIComponent("" + cREATED_BYFilter) + "&";
        if (sVR_CLIENTFilter !== undefined)
            url_ += "SVR_CLIENTFilter=" + encodeURIComponent("" + sVR_CLIENTFilter) + "&";
        if (maxHHT_SUBMIT_DTFilter !== undefined)
            url_ += "MaxHHT_SUBMIT_DTFilter=" + encodeURIComponent(maxHHT_SUBMIT_DTFilter ? "" + maxHHT_SUBMIT_DTFilter.toJSON() : "") + "&";
        if (minHHT_SUBMIT_DTFilter !== undefined)
            url_ += "MinHHT_SUBMIT_DTFilter=" + encodeURIComponent(minHHT_SUBMIT_DTFilter ? "" + minHHT_SUBMIT_DTFilter.toJSON() : "") + "&";
        if (vISIT_KEYFilter !== undefined)
            url_ += "VISIT_KEYFilter=" + encodeURIComponent("" + vISIT_KEYFilter) + "&";
        if (maxPRN_NOFilter !== undefined)
            url_ += "MaxPRN_NOFilter=" + encodeURIComponent("" + maxPRN_NOFilter) + "&";
        if (minPRN_NOFilter !== undefined)
            url_ += "MinPRN_NOFilter=" + encodeURIComponent("" + minPRN_NOFilter) + "&";
        if (maxPRN_NO_TAXFilter !== undefined)
            url_ += "MaxPRN_NO_TAXFilter=" + encodeURIComponent("" + maxPRN_NO_TAXFilter) + "&";
        if (minPRN_NO_TAXFilter !== undefined)
            url_ += "MinPRN_NO_TAXFilter=" + encodeURIComponent("" + minPRN_NO_TAXFilter) + "&";
        if (pICKLIST_INDFilter !== undefined)
            url_ += "PICKLIST_INDFilter=" + encodeURIComponent("" + pICKLIST_INDFilter) + "&";
        if (nPCLAIM_INDFilter !== undefined)
            url_ += "NPCLAIM_INDFilter=" + encodeURIComponent("" + nPCLAIM_INDFilter) + "&";
        if (sPCLAIM_INDFilter !== undefined)
            url_ += "SPCLAIM_INDFilter=" + encodeURIComponent("" + sPCLAIM_INDFilter) + "&";
        if (dE_INDFilter !== undefined)
            url_ += "DE_INDFilter=" + encodeURIComponent("" + dE_INDFilter) + "&";
        if (maxDE_DTFilter !== undefined)
            url_ += "MaxDE_DTFilter=" + encodeURIComponent(maxDE_DTFilter ? "" + maxDE_DTFilter.toJSON() : "") + "&";
        if (minDE_DTFilter !== undefined)
            url_ += "MinDE_DTFilter=" + encodeURIComponent(minDE_DTFilter ? "" + minDE_DTFilter.toJSON() : "") + "&";
        if (eXT_INDFilter !== undefined)
            url_ += "EXT_INDFilter=" + encodeURIComponent("" + eXT_INDFilter) + "&";
        if (fULL_REVERSAL_INDFilter !== undefined)
            url_ += "FULL_REVERSAL_INDFilter=" + encodeURIComponent("" + fULL_REVERSAL_INDFilter) + "&";
        if (maxVERSIONFilter !== undefined)
            url_ += "MaxVERSIONFilter=" + encodeURIComponent("" + maxVERSIONFilter) + "&";
        if (minVERSIONFilter !== undefined)
            url_ += "MinVERSIONFilter=" + encodeURIComponent("" + minVERSIONFilter) + "&";
        if (maxSYNCVERSIONFilter !== undefined)
            url_ += "MaxSYNCVERSIONFilter=" + encodeURIComponent(maxSYNCVERSIONFilter ? "" + maxSYNCVERSIONFilter.toJSON() : "") + "&";
        if (minSYNCVERSIONFilter !== undefined)
            url_ += "MinSYNCVERSIONFilter=" + encodeURIComponent(minSYNCVERSIONFilter ? "" + minSYNCVERSIONFilter.toJSON() : "") + "&";
        if (iNDFilter !== undefined)
            url_ += "INDFilter=" + encodeURIComponent("" + iNDFilter) + "&";
        if (maxPRN_DO_NOFilter !== undefined)
            url_ += "MaxPRN_DO_NOFilter=" + encodeURIComponent("" + maxPRN_DO_NOFilter) + "&";
        if (minPRN_DO_NOFilter !== undefined)
            url_ += "MinPRN_DO_NOFilter=" + encodeURIComponent("" + minPRN_DO_NOFilter) + "&";
        if (eRP_INDFilter !== undefined)
            url_ += "ERP_INDFilter=" + encodeURIComponent("" + eRP_INDFilter) + "&";
        if (aGENT_CDFilter !== undefined)
            url_ += "AGENT_CDFilter=" + encodeURIComponent("" + aGENT_CDFilter) + "&";
        if (maxDW_DTFilter !== undefined)
            url_ += "MaxDW_DTFilter=" + encodeURIComponent(maxDW_DTFilter ? "" + maxDW_DTFilter.toJSON() : "") + "&";
        if (minDW_DTFilter !== undefined)
            url_ += "MinDW_DTFilter=" + encodeURIComponent(minDW_DTFilter ? "" + minDW_DTFilter.toJSON() : "") + "&";
        if (maxINV_DISC_TTLFilter !== undefined)
            url_ += "MaxINV_DISC_TTLFilter=" + encodeURIComponent("" + maxINV_DISC_TTLFilter) + "&";
        if (minINV_DISC_TTLFilter !== undefined)
            url_ += "MinINV_DISC_TTLFilter=" + encodeURIComponent("" + minINV_DISC_TTLFilter) + "&";
        if (pRD_CDFilter !== undefined)
            url_ += "PRD_CDFilter=" + encodeURIComponent("" + pRD_CDFilter) + "&";
        if (pRD_SLSTYPEFilter !== undefined)
            url_ += "PRD_SLSTYPEFilter=" + encodeURIComponent("" + pRD_SLSTYPEFilter) + "&";
        if (maxPRD_INDEXFilter !== undefined)
            url_ += "MaxPRD_INDEXFilter=" + encodeURIComponent("" + maxPRD_INDEXFilter) + "&";
        if (minPRD_INDEXFilter !== undefined)
            url_ += "MinPRD_INDEXFilter=" + encodeURIComponent("" + minPRD_INDEXFilter) + "&";
        if (uOM_CD1Filter !== undefined)
            url_ += "UOM_CD1Filter=" + encodeURIComponent("" + uOM_CD1Filter) + "&";
        if (uOM_CD2Filter !== undefined)
            url_ += "UOM_CD2Filter=" + encodeURIComponent("" + uOM_CD2Filter) + "&";
        if (uOM_CD3Filter !== undefined)
            url_ += "UOM_CD3Filter=" + encodeURIComponent("" + uOM_CD3Filter) + "&";
        if (tAX_INDFilter !== undefined)
            url_ += "TAX_INDFilter=" + encodeURIComponent("" + tAX_INDFilter) + "&";
        if (pRC_TAX_INDFilter !== undefined)
            url_ += "PRC_TAX_INDFilter=" + encodeURIComponent("" + pRC_TAX_INDFilter) + "&";
        if (dEF_UOM_CDFilter !== undefined)
            url_ += "DEF_UOM_CDFilter=" + encodeURIComponent("" + dEF_UOM_CDFilter) + "&";
        if (maxPRD_QTY1Filter !== undefined)
            url_ += "MaxPRD_QTY1Filter=" + encodeURIComponent("" + maxPRD_QTY1Filter) + "&";
        if (minPRD_QTY1Filter !== undefined)
            url_ += "MinPRD_QTY1Filter=" + encodeURIComponent("" + minPRD_QTY1Filter) + "&";
        if (maxPRD_QTY2Filter !== undefined)
            url_ += "MaxPRD_QTY2Filter=" + encodeURIComponent("" + maxPRD_QTY2Filter) + "&";
        if (minPRD_QTY2Filter !== undefined)
            url_ += "MinPRD_QTY2Filter=" + encodeURIComponent("" + minPRD_QTY2Filter) + "&";
        if (maxPRD_QTY3Filter !== undefined)
            url_ += "MaxPRD_QTY3Filter=" + encodeURIComponent("" + maxPRD_QTY3Filter) + "&";
        if (minPRD_QTY3Filter !== undefined)
            url_ += "MinPRD_QTY3Filter=" + encodeURIComponent("" + minPRD_QTY3Filter) + "&";
        if (maxMRPFilter !== undefined)
            url_ += "MaxMRPFilter=" + encodeURIComponent("" + maxMRPFilter) + "&";
        if (minMRPFilter !== undefined)
            url_ += "MinMRPFilter=" + encodeURIComponent("" + minMRPFilter) + "&";
        if (maxCPFilter !== undefined)
            url_ += "MaxCPFilter=" + encodeURIComponent("" + maxCPFilter) + "&";
        if (minCPFilter !== undefined)
            url_ += "MinCPFilter=" + encodeURIComponent("" + minCPFilter) + "&";
        if (maxPRD_LISTPRCFilter !== undefined)
            url_ += "MaxPRD_LISTPRCFilter=" + encodeURIComponent("" + maxPRD_LISTPRCFilter) + "&";
        if (minPRD_LISTPRCFilter !== undefined)
            url_ += "MinPRD_LISTPRCFilter=" + encodeURIComponent("" + minPRD_LISTPRCFilter) + "&";
        if (maxUOM_LISTPRC1Filter !== undefined)
            url_ += "MaxUOM_LISTPRC1Filter=" + encodeURIComponent("" + maxUOM_LISTPRC1Filter) + "&";
        if (minUOM_LISTPRC1Filter !== undefined)
            url_ += "MinUOM_LISTPRC1Filter=" + encodeURIComponent("" + minUOM_LISTPRC1Filter) + "&";
        if (maxUOM_LISTPRC2Filter !== undefined)
            url_ += "MaxUOM_LISTPRC2Filter=" + encodeURIComponent("" + maxUOM_LISTPRC2Filter) + "&";
        if (minUOM_LISTPRC2Filter !== undefined)
            url_ += "MinUOM_LISTPRC2Filter=" + encodeURIComponent("" + minUOM_LISTPRC2Filter) + "&";
        if (maxUOM_LISTPRC3Filter !== undefined)
            url_ += "MaxUOM_LISTPRC3Filter=" + encodeURIComponent("" + maxUOM_LISTPRC3Filter) + "&";
        if (minUOM_LISTPRC3Filter !== undefined)
            url_ += "MinUOM_LISTPRC3Filter=" + encodeURIComponent("" + minUOM_LISTPRC3Filter) + "&";
        if (maxPRC_TAX_PERC1Filter !== undefined)
            url_ += "MaxPRC_TAX_PERC1Filter=" + encodeURIComponent("" + maxPRC_TAX_PERC1Filter) + "&";
        if (minPRC_TAX_PERC1Filter !== undefined)
            url_ += "MinPRC_TAX_PERC1Filter=" + encodeURIComponent("" + minPRC_TAX_PERC1Filter) + "&";
        if (maxPRC_TAX_PERC2Filter !== undefined)
            url_ += "MaxPRC_TAX_PERC2Filter=" + encodeURIComponent("" + maxPRC_TAX_PERC2Filter) + "&";
        if (minPRC_TAX_PERC2Filter !== undefined)
            url_ += "MinPRC_TAX_PERC2Filter=" + encodeURIComponent("" + minPRC_TAX_PERC2Filter) + "&";
        if (maxPRC_TAX_PERC3Filter !== undefined)
            url_ += "MaxPRC_TAX_PERC3Filter=" + encodeURIComponent("" + maxPRC_TAX_PERC3Filter) + "&";
        if (minPRC_TAX_PERC3Filter !== undefined)
            url_ += "MinPRC_TAX_PERC3Filter=" + encodeURIComponent("" + minPRC_TAX_PERC3Filter) + "&";
        if (maxPRC_TAX_AMT1Filter !== undefined)
            url_ += "MaxPRC_TAX_AMT1Filter=" + encodeURIComponent("" + maxPRC_TAX_AMT1Filter) + "&";
        if (minPRC_TAX_AMT1Filter !== undefined)
            url_ += "MinPRC_TAX_AMT1Filter=" + encodeURIComponent("" + minPRC_TAX_AMT1Filter) + "&";
        if (maxPRC_TAX_AMT2Filter !== undefined)
            url_ += "MaxPRC_TAX_AMT2Filter=" + encodeURIComponent("" + maxPRC_TAX_AMT2Filter) + "&";
        if (minPRC_TAX_AMT2Filter !== undefined)
            url_ += "MinPRC_TAX_AMT2Filter=" + encodeURIComponent("" + minPRC_TAX_AMT2Filter) + "&";
        if (maxPRC_TAX_AMT3Filter !== undefined)
            url_ += "MaxPRC_TAX_AMT3Filter=" + encodeURIComponent("" + maxPRC_TAX_AMT3Filter) + "&";
        if (minPRC_TAX_AMT3Filter !== undefined)
            url_ += "MinPRC_TAX_AMT3Filter=" + encodeURIComponent("" + minPRC_TAX_AMT3Filter) + "&";
        if (maxPRC_TAX_AMTFilter !== undefined)
            url_ += "MaxPRC_TAX_AMTFilter=" + encodeURIComponent("" + maxPRC_TAX_AMTFilter) + "&";
        if (minPRC_TAX_AMTFilter !== undefined)
            url_ += "MinPRC_TAX_AMTFilter=" + encodeURIComponent("" + minPRC_TAX_AMTFilter) + "&";
        if (maxPRD_DISCFilter !== undefined)
            url_ += "MaxPRD_DISCFilter=" + encodeURIComponent("" + maxPRD_DISCFilter) + "&";
        if (minPRD_DISCFilter !== undefined)
            url_ += "MinPRD_DISCFilter=" + encodeURIComponent("" + minPRD_DISCFilter) + "&";
        if (maxGROSS_AMTFilter !== undefined)
            url_ += "MaxGROSS_AMTFilter=" + encodeURIComponent("" + maxGROSS_AMTFilter) + "&";
        if (minGROSS_AMTFilter !== undefined)
            url_ += "MinGROSS_AMTFilter=" + encodeURIComponent("" + minGROSS_AMTFilter) + "&";
        if (maxPROMO_DISC_DTLFilter !== undefined)
            url_ += "MaxPROMO_DISC_DTLFilter=" + encodeURIComponent("" + maxPROMO_DISC_DTLFilter) + "&";
        if (minPROMO_DISC_DTLFilter !== undefined)
            url_ += "MinPROMO_DISC_DTLFilter=" + encodeURIComponent("" + minPROMO_DISC_DTLFilter) + "&";
        if (maxDIST_PROMO_DISCFilter !== undefined)
            url_ += "MaxDIST_PROMO_DISCFilter=" + encodeURIComponent("" + maxDIST_PROMO_DISCFilter) + "&";
        if (minDIST_PROMO_DISCFilter !== undefined)
            url_ += "MinDIST_PROMO_DISCFilter=" + encodeURIComponent("" + minDIST_PROMO_DISCFilter) + "&";
        if (maxHQ_PROMO_DISCFilter !== undefined)
            url_ += "MaxHQ_PROMO_DISCFilter=" + encodeURIComponent("" + maxHQ_PROMO_DISCFilter) + "&";
        if (minHQ_PROMO_DISCFilter !== undefined)
            url_ += "MinHQ_PROMO_DISCFilter=" + encodeURIComponent("" + minHQ_PROMO_DISCFilter) + "&";
        if (maxSLS_DISC_DTLFilter !== undefined)
            url_ += "MaxSLS_DISC_DTLFilter=" + encodeURIComponent("" + maxSLS_DISC_DTLFilter) + "&";
        if (minSLS_DISC_DTLFilter !== undefined)
            url_ += "MinSLS_DISC_DTLFilter=" + encodeURIComponent("" + minSLS_DISC_DTLFilter) + "&";
        if (maxCUST_GRP_DISC_DTLFilter !== undefined)
            url_ += "MaxCUST_GRP_DISC_DTLFilter=" + encodeURIComponent("" + maxCUST_GRP_DISC_DTLFilter) + "&";
        if (minCUST_GRP_DISC_DTLFilter !== undefined)
            url_ += "MinCUST_GRP_DISC_DTLFilter=" + encodeURIComponent("" + minCUST_GRP_DISC_DTLFilter) + "&";
        if (maxCASH_DISC_PERCFilter !== undefined)
            url_ += "MaxCASH_DISC_PERCFilter=" + encodeURIComponent("" + maxCASH_DISC_PERCFilter) + "&";
        if (minCASH_DISC_PERCFilter !== undefined)
            url_ += "MinCASH_DISC_PERCFilter=" + encodeURIComponent("" + minCASH_DISC_PERCFilter) + "&";
        if (maxCASH_DISC_DTLFilter !== undefined)
            url_ += "MaxCASH_DISC_DTLFilter=" + encodeURIComponent("" + maxCASH_DISC_DTLFilter) + "&";
        if (minCASH_DISC_DTLFilter !== undefined)
            url_ += "MinCASH_DISC_DTLFilter=" + encodeURIComponent("" + minCASH_DISC_DTLFilter) + "&";
        if (maxUNIT_TAXFilter !== undefined)
            url_ += "MaxUNIT_TAXFilter=" + encodeURIComponent("" + maxUNIT_TAXFilter) + "&";
        if (minUNIT_TAXFilter !== undefined)
            url_ += "MinUNIT_TAXFilter=" + encodeURIComponent("" + minUNIT_TAXFilter) + "&";
        if (maxNET_AMTFilter !== undefined)
            url_ += "MaxNET_AMTFilter=" + encodeURIComponent("" + maxNET_AMTFilter) + "&";
        if (minNET_AMTFilter !== undefined)
            url_ += "MinNET_AMTFilter=" + encodeURIComponent("" + minNET_AMTFilter) + "&";
        if (maxNET_AMT_TAXFilter !== undefined)
            url_ += "MaxNET_AMT_TAXFilter=" + encodeURIComponent("" + maxNET_AMT_TAXFilter) + "&";
        if (minNET_AMT_TAXFilter !== undefined)
            url_ += "MinNET_AMT_TAXFilter=" + encodeURIComponent("" + minNET_AMT_TAXFilter) + "&";
        if (maxNET_AMT_FOCFilter !== undefined)
            url_ += "MaxNET_AMT_FOCFilter=" + encodeURIComponent("" + maxNET_AMT_FOCFilter) + "&";
        if (minNET_AMT_FOCFilter !== undefined)
            url_ += "MinNET_AMT_FOCFilter=" + encodeURIComponent("" + minNET_AMT_FOCFilter) + "&";
        if (maxCUST_DISC_DTLFilter !== undefined)
            url_ += "MaxCUST_DISC_DTLFilter=" + encodeURIComponent("" + maxCUST_DISC_DTLFilter) + "&";
        if (minCUST_DISC_DTLFilter !== undefined)
            url_ += "MinCUST_DISC_DTLFilter=" + encodeURIComponent("" + minCUST_DISC_DTLFilter) + "&";
        if (maxTAX_PERC1_DTLFilter !== undefined)
            url_ += "MaxTAX_PERC1_DTLFilter=" + encodeURIComponent("" + maxTAX_PERC1_DTLFilter) + "&";
        if (minTAX_PERC1_DTLFilter !== undefined)
            url_ += "MinTAX_PERC1_DTLFilter=" + encodeURIComponent("" + minTAX_PERC1_DTLFilter) + "&";
        if (maxTAX_PERC2_DTLFilter !== undefined)
            url_ += "MaxTAX_PERC2_DTLFilter=" + encodeURIComponent("" + maxTAX_PERC2_DTLFilter) + "&";
        if (minTAX_PERC2_DTLFilter !== undefined)
            url_ += "MinTAX_PERC2_DTLFilter=" + encodeURIComponent("" + minTAX_PERC2_DTLFilter) + "&";
        if (maxTAX_PERC3_DTLFilter !== undefined)
            url_ += "MaxTAX_PERC3_DTLFilter=" + encodeURIComponent("" + maxTAX_PERC3_DTLFilter) + "&";
        if (minTAX_PERC3_DTLFilter !== undefined)
            url_ += "MinTAX_PERC3_DTLFilter=" + encodeURIComponent("" + minTAX_PERC3_DTLFilter) + "&";
        if (maxTAX_AMT1Filter !== undefined)
            url_ += "MaxTAX_AMT1Filter=" + encodeURIComponent("" + maxTAX_AMT1Filter) + "&";
        if (minTAX_AMT1Filter !== undefined)
            url_ += "MinTAX_AMT1Filter=" + encodeURIComponent("" + minTAX_AMT1Filter) + "&";
        if (maxTAX_AMT2Filter !== undefined)
            url_ += "MaxTAX_AMT2Filter=" + encodeURIComponent("" + maxTAX_AMT2Filter) + "&";
        if (minTAX_AMT2Filter !== undefined)
            url_ += "MinTAX_AMT2Filter=" + encodeURIComponent("" + minTAX_AMT2Filter) + "&";
        if (maxTAX_AMT3Filter !== undefined)
            url_ += "MaxTAX_AMT3Filter=" + encodeURIComponent("" + maxTAX_AMT3Filter) + "&";
        if (minTAX_AMT3Filter !== undefined)
            url_ += "MinTAX_AMT3Filter=" + encodeURIComponent("" + minTAX_AMT3Filter) + "&";
        if (maxTAX_AMTFilter !== undefined)
            url_ += "MaxTAX_AMTFilter=" + encodeURIComponent("" + maxTAX_AMTFilter) + "&";
        if (minTAX_AMTFilter !== undefined)
            url_ += "MinTAX_AMTFilter=" + encodeURIComponent("" + minTAX_AMTFilter) + "&";
        if (maxADD_TAX_PERCFilter !== undefined)
            url_ += "MaxADD_TAX_PERCFilter=" + encodeURIComponent("" + maxADD_TAX_PERCFilter) + "&";
        if (minADD_TAX_PERCFilter !== undefined)
            url_ += "MinADD_TAX_PERCFilter=" + encodeURIComponent("" + minADD_TAX_PERCFilter) + "&";
        if (maxADD_TAX_AMT_DTLFilter !== undefined)
            url_ += "MaxADD_TAX_AMT_DTLFilter=" + encodeURIComponent("" + maxADD_TAX_AMT_DTLFilter) + "&";
        if (minADD_TAX_AMT_DTLFilter !== undefined)
            url_ += "MinADD_TAX_AMT_DTLFilter=" + encodeURIComponent("" + minADD_TAX_AMT_DTLFilter) + "&";
        if (maxPURCHASE_RATEFilter !== undefined)
            url_ += "MaxPURCHASE_RATEFilter=" + encodeURIComponent("" + maxPURCHASE_RATEFilter) + "&";
        if (minPURCHASE_RATEFilter !== undefined)
            url_ += "MinPURCHASE_RATEFilter=" + encodeURIComponent("" + minPURCHASE_RATEFilter) + "&";
        if (maxDIST_DISC_DTLFilter !== undefined)
            url_ += "MaxDIST_DISC_DTLFilter=" + encodeURIComponent("" + maxDIST_DISC_DTLFilter) + "&";
        if (minDIST_DISC_DTLFilter !== undefined)
            url_ += "MinDIST_DISC_DTLFilter=" + encodeURIComponent("" + minDIST_DISC_DTLFilter) + "&";
        if (maxUOM_CONV_FACTOR_SML1Filter !== undefined)
            url_ += "MaxUOM_CONV_FACTOR_SML1Filter=" + encodeURIComponent("" + maxUOM_CONV_FACTOR_SML1Filter) + "&";
        if (minUOM_CONV_FACTOR_SML1Filter !== undefined)
            url_ += "MinUOM_CONV_FACTOR_SML1Filter=" + encodeURIComponent("" + minUOM_CONV_FACTOR_SML1Filter) + "&";
        if (maxUOM_CONV_FACTOR_SML2Filter !== undefined)
            url_ += "MaxUOM_CONV_FACTOR_SML2Filter=" + encodeURIComponent("" + maxUOM_CONV_FACTOR_SML2Filter) + "&";
        if (minUOM_CONV_FACTOR_SML2Filter !== undefined)
            url_ += "MinUOM_CONV_FACTOR_SML2Filter=" + encodeURIComponent("" + minUOM_CONV_FACTOR_SML2Filter) + "&";
        if (maxUOM_CONV_FACTOR_SML3Filter !== undefined)
            url_ += "MaxUOM_CONV_FACTOR_SML3Filter=" + encodeURIComponent("" + maxUOM_CONV_FACTOR_SML3Filter) + "&";
        if (minUOM_CONV_FACTOR_SML3Filter !== undefined)
            url_ += "MinUOM_CONV_FACTOR_SML3Filter=" + encodeURIComponent("" + minUOM_CONV_FACTOR_SML3Filter) + "&";
        if (iND_DTLFilter !== undefined)
            url_ += "IND_DTLFilter=" + encodeURIComponent("" + iND_DTLFilter) + "&";
        if (pARENT_PRDFilter !== undefined)
            url_ += "PARENT_PRDFilter=" + encodeURIComponent("" + pARENT_PRDFilter) + "&";
        if (pARENT_UOMFilter !== undefined)
            url_ += "PARENT_UOMFilter=" + encodeURIComponent("" + pARENT_UOMFilter) + "&";
        if (mY_TAX_CDFilter !== undefined)
            url_ += "MY_TAX_CDFilter=" + encodeURIComponent("" + mY_TAX_CDFilter) + "&";
        if (maxPRICE_ERRORFilter !== undefined)
            url_ += "MaxPRICE_ERRORFilter=" + encodeURIComponent("" + maxPRICE_ERRORFilter) + "&";
        if (minPRICE_ERRORFilter !== undefined)
            url_ += "MinPRICE_ERRORFilter=" + encodeURIComponent("" + minPRICE_ERRORFilter) + "&";
        if (mSL_INDFilter !== undefined)
            url_ += "MSL_INDFilter=" + encodeURIComponent("" + mSL_INDFilter) + "&";
        if (maxINV_DISCFilter !== undefined)
            url_ += "MaxINV_DISCFilter=" + encodeURIComponent("" + maxINV_DISCFilter) + "&";
        if (minINV_DISCFilter !== undefined)
            url_ += "MinINV_DISCFilter=" + encodeURIComponent("" + minINV_DISCFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetTempInvoiceTransactionsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTempInvoiceTransactionsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<PointFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PointFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetTempInvoiceTransactionsToExcel(response: HttpResponseBase): Observable<PointFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PointFileDto.fromJS(resultData200) : new PointFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PointFileDto>(<any>null);
    }
}

@Injectable()
export class TemplatesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param templateNameFilter (optional) 
     * @param typeFilter (optional) 
     * @param senderFilter (optional) 
     * @param channelCodeFilter (optional) 
     * @param contentVNFilter (optional) 
     * @param contentENFilter (optional) 
     * @param titleVNFilter (optional) 
     * @param titleENFilter (optional) 
     * @param actionsFilter (optional) 
     * @param itemsFilter (optional) 
     * @param statusFilter (optional) 
     * @param templateNameUnSignFilter (optional) 
     * @param titleVN (optional) 
     * @param titleEN (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, templateNameFilter: string | null | undefined, typeFilter: string | null | undefined, senderFilter: string | null | undefined, channelCodeFilter: string | null | undefined, contentVNFilter: string | null | undefined, contentENFilter: string | null | undefined, titleVNFilter: string | null | undefined, titleENFilter: string | null | undefined, actionsFilter: string | null | undefined, itemsFilter: string | null | undefined, statusFilter: string | null | undefined, templateNameUnSignFilter: string | null | undefined, titleVN: string | null | undefined, titleEN: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetTemplateForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Templates/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (templateNameFilter !== undefined)
            url_ += "TemplateNameFilter=" + encodeURIComponent("" + templateNameFilter) + "&";
        if (typeFilter !== undefined)
            url_ += "TypeFilter=" + encodeURIComponent("" + typeFilter) + "&";
        if (senderFilter !== undefined)
            url_ += "SenderFilter=" + encodeURIComponent("" + senderFilter) + "&";
        if (channelCodeFilter !== undefined)
            url_ += "ChannelCodeFilter=" + encodeURIComponent("" + channelCodeFilter) + "&";
        if (contentVNFilter !== undefined)
            url_ += "ContentVNFilter=" + encodeURIComponent("" + contentVNFilter) + "&";
        if (contentENFilter !== undefined)
            url_ += "ContentENFilter=" + encodeURIComponent("" + contentENFilter) + "&";
        if (titleVNFilter !== undefined)
            url_ += "TitleVNFilter=" + encodeURIComponent("" + titleVNFilter) + "&";
        if (titleENFilter !== undefined)
            url_ += "TitleENFilter=" + encodeURIComponent("" + titleENFilter) + "&";
        if (actionsFilter !== undefined)
            url_ += "ActionsFilter=" + encodeURIComponent("" + actionsFilter) + "&";
        if (itemsFilter !== undefined)
            url_ += "ItemsFilter=" + encodeURIComponent("" + itemsFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (templateNameUnSignFilter !== undefined)
            url_ += "TemplateNameUnSignFilter=" + encodeURIComponent("" + templateNameUnSignFilter) + "&";
        if (titleVN !== undefined)
            url_ += "TitleVN=" + encodeURIComponent("" + titleVN) + "&";
        if (titleEN !== undefined)
            url_ += "TitleEN=" + encodeURIComponent("" + titleEN) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetTemplateForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetTemplateForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetTemplateForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetTemplateForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetTemplateForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetTemplateForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getTemplateForEdit(id: number | null | undefined): Observable<GetTemplateForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Templates/GetTemplateForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetTemplateForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTemplateForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetTemplateForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetTemplateForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetTemplateForEdit(response: HttpResponseBase): Observable<GetTemplateForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetTemplateForEditOutput.fromJS(resultData200) : new GetTemplateForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTemplateForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditTemplateDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Templates/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Templates/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param templateNameFilter (optional) 
     * @param typeFilter (optional) 
     * @param senderFilter (optional) 
     * @param channelCodeFilter (optional) 
     * @param contentVNFilter (optional) 
     * @param contentENFilter (optional) 
     * @param titleVNFilter (optional) 
     * @param titleENFilter (optional) 
     * @param actionsFilter (optional) 
     * @param itemsFilter (optional) 
     * @param statusFilter (optional) 
     * @param templateNameUnSignFilter (optional) 
     * @return Success
     */
    getTemplatesToExcel(filter: string | null | undefined, templateNameFilter: string | null | undefined, typeFilter: string | null | undefined, senderFilter: string | null | undefined, channelCodeFilter: string | null | undefined, contentVNFilter: string | null | undefined, contentENFilter: string | null | undefined, titleVNFilter: string | null | undefined, titleENFilter: string | null | undefined, actionsFilter: string | null | undefined, itemsFilter: string | null | undefined, statusFilter: string | null | undefined, templateNameUnSignFilter: string | null | undefined): Observable<NotificationFileDto> {
        let url_ = this.baseUrl + "/api/services/app/Templates/GetTemplatesToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (templateNameFilter !== undefined)
            url_ += "TemplateNameFilter=" + encodeURIComponent("" + templateNameFilter) + "&";
        if (typeFilter !== undefined)
            url_ += "TypeFilter=" + encodeURIComponent("" + typeFilter) + "&";
        if (senderFilter !== undefined)
            url_ += "SenderFilter=" + encodeURIComponent("" + senderFilter) + "&";
        if (channelCodeFilter !== undefined)
            url_ += "ChannelCodeFilter=" + encodeURIComponent("" + channelCodeFilter) + "&";
        if (contentVNFilter !== undefined)
            url_ += "ContentVNFilter=" + encodeURIComponent("" + contentVNFilter) + "&";
        if (contentENFilter !== undefined)
            url_ += "ContentENFilter=" + encodeURIComponent("" + contentENFilter) + "&";
        if (titleVNFilter !== undefined)
            url_ += "TitleVNFilter=" + encodeURIComponent("" + titleVNFilter) + "&";
        if (titleENFilter !== undefined)
            url_ += "TitleENFilter=" + encodeURIComponent("" + titleENFilter) + "&";
        if (actionsFilter !== undefined)
            url_ += "ActionsFilter=" + encodeURIComponent("" + actionsFilter) + "&";
        if (itemsFilter !== undefined)
            url_ += "ItemsFilter=" + encodeURIComponent("" + itemsFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (templateNameUnSignFilter !== undefined)
            url_ += "TemplateNameUnSignFilter=" + encodeURIComponent("" + templateNameUnSignFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetTemplatesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTemplatesToExcel(<any>response_);
                } catch (e) {
                    return <Observable<NotificationFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<NotificationFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetTemplatesToExcel(response: HttpResponseBase): Observable<NotificationFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? NotificationFileDto.fromJS(resultData200) : new NotificationFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NotificationFileDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    batchDelete(input: TemplateDto[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Templates/BatchDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processBatchDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBatchDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processBatchDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    batchUpdate(input: CreateOrEditTemplateDto[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Templates/BatchUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processBatchUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBatchUpdate(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processBatchUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEditUnsign(input: CreateOrEditTemplateDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Templates/CreateOrEditUnsign";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEditUnsign(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditUnsign(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEditUnsign(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    search(input: GetAllTemplatesInput | null | undefined): Observable<PagedResultDtoOfGetTemplateForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Templates/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetTemplateForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetTemplateForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<PagedResultDtoOfGetTemplateForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetTemplateForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetTemplateForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetTemplateForViewDto>(<any>null);
    }
}

@Injectable()
export class TemplatesExcelExporterServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param templates (optional) 
     * @return Success
     */
    exportToFile(templates: GetTemplateForViewDto[] | null | undefined): Observable<NotificationFileDto> {
        let url_ = this.baseUrl + "/api/services/app/TemplatesExcelExporter/ExportToFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(templates);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processExportToFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportToFile(<any>response_);
                } catch (e) {
                    return <Observable<NotificationFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<NotificationFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processExportToFile(response: HttpResponseBase): Observable<NotificationFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? NotificationFileDto.fromJS(resultData200) : new NotificationFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NotificationFileDto>(<any>null);
    }
}

@Injectable()
export class TempMappingGEOsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param pOS_IDFilter (optional) 
     * @param nODE_IDFilter (optional) 
     * @param maxStartDateFilter (optional) 
     * @param minStartDateFilter (optional) 
     * @param maxEndDateFilter (optional) 
     * @param minEndDateFilter (optional) 
     * @param note1Filter (optional) 
     * @param note2Filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, pOS_IDFilter: string | null | undefined, nODE_IDFilter: string | null | undefined, maxStartDateFilter: moment.Moment | null | undefined, minStartDateFilter: moment.Moment | null | undefined, maxEndDateFilter: moment.Moment | null | undefined, minEndDateFilter: moment.Moment | null | undefined, note1Filter: string | null | undefined, note2Filter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetTempMappingGEOForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/TempMappingGEOs/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (pOS_IDFilter !== undefined)
            url_ += "POS_IDFilter=" + encodeURIComponent("" + pOS_IDFilter) + "&";
        if (nODE_IDFilter !== undefined)
            url_ += "NODE_IDFilter=" + encodeURIComponent("" + nODE_IDFilter) + "&";
        if (maxStartDateFilter !== undefined)
            url_ += "MaxStartDateFilter=" + encodeURIComponent(maxStartDateFilter ? "" + maxStartDateFilter.toJSON() : "") + "&";
        if (minStartDateFilter !== undefined)
            url_ += "MinStartDateFilter=" + encodeURIComponent(minStartDateFilter ? "" + minStartDateFilter.toJSON() : "") + "&";
        if (maxEndDateFilter !== undefined)
            url_ += "MaxEndDateFilter=" + encodeURIComponent(maxEndDateFilter ? "" + maxEndDateFilter.toJSON() : "") + "&";
        if (minEndDateFilter !== undefined)
            url_ += "MinEndDateFilter=" + encodeURIComponent(minEndDateFilter ? "" + minEndDateFilter.toJSON() : "") + "&";
        if (note1Filter !== undefined)
            url_ += "Note1Filter=" + encodeURIComponent("" + note1Filter) + "&";
        if (note2Filter !== undefined)
            url_ += "Note2Filter=" + encodeURIComponent("" + note2Filter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetTempMappingGEOForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetTempMappingGEOForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetTempMappingGEOForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetTempMappingGEOForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetTempMappingGEOForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetTempMappingGEOForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getTempMappingGEOForEdit(id: number | null | undefined): Observable<GetTempMappingGEOForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/TempMappingGEOs/GetTempMappingGEOForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetTempMappingGEOForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTempMappingGEOForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetTempMappingGEOForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetTempMappingGEOForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetTempMappingGEOForEdit(response: HttpResponseBase): Observable<GetTempMappingGEOForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetTempMappingGEOForEditOutput.fromJS(resultData200) : new GetTempMappingGEOForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTempMappingGEOForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditTempMappingGEODto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TempMappingGEOs/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TempMappingGEOs/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param pOS_IDFilter (optional) 
     * @param nODE_IDFilter (optional) 
     * @param maxStartDateFilter (optional) 
     * @param minStartDateFilter (optional) 
     * @param maxEndDateFilter (optional) 
     * @param minEndDateFilter (optional) 
     * @param note1Filter (optional) 
     * @param note2Filter (optional) 
     * @return Success
     */
    getTempMappingGEOsToExcel(filter: string | null | undefined, pOS_IDFilter: string | null | undefined, nODE_IDFilter: string | null | undefined, maxStartDateFilter: moment.Moment | null | undefined, minStartDateFilter: moment.Moment | null | undefined, maxEndDateFilter: moment.Moment | null | undefined, minEndDateFilter: moment.Moment | null | undefined, note1Filter: string | null | undefined, note2Filter: string | null | undefined): Observable<PointFileDto> {
        let url_ = this.baseUrl + "/api/services/app/TempMappingGEOs/GetTempMappingGEOsToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (pOS_IDFilter !== undefined)
            url_ += "POS_IDFilter=" + encodeURIComponent("" + pOS_IDFilter) + "&";
        if (nODE_IDFilter !== undefined)
            url_ += "NODE_IDFilter=" + encodeURIComponent("" + nODE_IDFilter) + "&";
        if (maxStartDateFilter !== undefined)
            url_ += "MaxStartDateFilter=" + encodeURIComponent(maxStartDateFilter ? "" + maxStartDateFilter.toJSON() : "") + "&";
        if (minStartDateFilter !== undefined)
            url_ += "MinStartDateFilter=" + encodeURIComponent(minStartDateFilter ? "" + minStartDateFilter.toJSON() : "") + "&";
        if (maxEndDateFilter !== undefined)
            url_ += "MaxEndDateFilter=" + encodeURIComponent(maxEndDateFilter ? "" + maxEndDateFilter.toJSON() : "") + "&";
        if (minEndDateFilter !== undefined)
            url_ += "MinEndDateFilter=" + encodeURIComponent(minEndDateFilter ? "" + minEndDateFilter.toJSON() : "") + "&";
        if (note1Filter !== undefined)
            url_ += "Note1Filter=" + encodeURIComponent("" + note1Filter) + "&";
        if (note2Filter !== undefined)
            url_ += "Note2Filter=" + encodeURIComponent("" + note2Filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetTempMappingGEOsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTempMappingGEOsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<PointFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PointFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetTempMappingGEOsToExcel(response: HttpResponseBase): Observable<PointFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PointFileDto.fromJS(resultData200) : new PointFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PointFileDto>(<any>null);
    }
}

@Injectable()
export class TenantServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param subscriptionEndDateStart (optional) 
     * @param subscriptionEndDateEnd (optional) 
     * @param creationDateStart (optional) 
     * @param creationDateEnd (optional) 
     * @param editionId (optional) 
     * @param editionIdSpecified (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getTenants(filter: string | null | undefined, subscriptionEndDateStart: moment.Moment | null | undefined, subscriptionEndDateEnd: moment.Moment | null | undefined, creationDateStart: moment.Moment | null | undefined, creationDateEnd: moment.Moment | null | undefined, editionId: number | null | undefined, editionIdSpecified: boolean | null | undefined, sorting: string | null | undefined, maxResultCount: number | null | undefined, skipCount: number | null | undefined): Observable<PagedResultDtoOfTenantListDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetTenants?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (subscriptionEndDateStart !== undefined)
            url_ += "SubscriptionEndDateStart=" + encodeURIComponent(subscriptionEndDateStart ? "" + subscriptionEndDateStart.toJSON() : "") + "&";
        if (subscriptionEndDateEnd !== undefined)
            url_ += "SubscriptionEndDateEnd=" + encodeURIComponent(subscriptionEndDateEnd ? "" + subscriptionEndDateEnd.toJSON() : "") + "&";
        if (creationDateStart !== undefined)
            url_ += "CreationDateStart=" + encodeURIComponent(creationDateStart ? "" + creationDateStart.toJSON() : "") + "&";
        if (creationDateEnd !== undefined)
            url_ += "CreationDateEnd=" + encodeURIComponent(creationDateEnd ? "" + creationDateEnd.toJSON() : "") + "&";
        if (editionId !== undefined)
            url_ += "EditionId=" + encodeURIComponent("" + editionId) + "&";
        if (editionIdSpecified !== undefined)
            url_ += "EditionIdSpecified=" + encodeURIComponent("" + editionIdSpecified) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetTenants(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenants(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfTenantListDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfTenantListDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetTenants(response: HttpResponseBase): Observable<PagedResultDtoOfTenantListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfTenantListDto.fromJS(resultData200) : new PagedResultDtoOfTenantListDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfTenantListDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createTenant(input: CreateTenantInput | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/CreateTenant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateTenant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateTenant(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateTenant(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getTenantForEdit(id: number | null | undefined): Observable<TenantEditDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetTenantForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetTenantForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenantForEdit(<any>response_);
                } catch (e) {
                    return <Observable<TenantEditDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TenantEditDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetTenantForEdit(response: HttpResponseBase): Observable<TenantEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? TenantEditDto.fromJS(resultData200) : new TenantEditDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantEditDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    updateTenant(input: TenantEditDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/UpdateTenant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateTenant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTenant(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateTenant(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteTenant(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/DeleteTenant?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteTenant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteTenant(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteTenant(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getTenantFeaturesForEdit(id: number | null | undefined): Observable<GetTenantFeaturesEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetTenantFeaturesForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetTenantFeaturesForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenantFeaturesForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetTenantFeaturesEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetTenantFeaturesEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetTenantFeaturesForEdit(response: HttpResponseBase): Observable<GetTenantFeaturesEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetTenantFeaturesEditOutput.fromJS(resultData200) : new GetTenantFeaturesEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTenantFeaturesEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    updateTenantFeatures(input: UpdateTenantFeaturesInput | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/UpdateTenantFeatures";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateTenantFeatures(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTenantFeatures(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateTenantFeatures(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    resetTenantSpecificFeatures(input: EntityDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/ResetTenantSpecificFeatures";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processResetTenantSpecificFeatures(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetTenantSpecificFeatures(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processResetTenantSpecificFeatures(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    unlockTenantAdmin(input: EntityDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/UnlockTenantAdmin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUnlockTenantAdmin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnlockTenantAdmin(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUnlockTenantAdmin(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class TenantDashboardServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getMemberActivity(): Observable<GetMemberActivityOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetMemberActivity";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetMemberActivity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMemberActivity(<any>response_);
                } catch (e) {
                    return <Observable<GetMemberActivityOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetMemberActivityOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetMemberActivity(response: HttpResponseBase): Observable<GetMemberActivityOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetMemberActivityOutput.fromJS(resultData200) : new GetMemberActivityOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetMemberActivityOutput>(<any>null);
    }

    /**
     * @param salesSummaryDatePeriod (optional) 
     * @return Success
     */
    getDashboardData(salesSummaryDatePeriod: SalesSummaryDatePeriod | null | undefined): Observable<GetDashboardDataOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetDashboardData?";
        if (salesSummaryDatePeriod !== undefined)
            url_ += "SalesSummaryDatePeriod=" + encodeURIComponent("" + salesSummaryDatePeriod) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetDashboardData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDashboardData(<any>response_);
                } catch (e) {
                    return <Observable<GetDashboardDataOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetDashboardDataOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetDashboardData(response: HttpResponseBase): Observable<GetDashboardDataOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetDashboardDataOutput.fromJS(resultData200) : new GetDashboardDataOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetDashboardDataOutput>(<any>null);
    }

    /**
     * @param salesSummaryDatePeriod (optional) 
     * @return Success
     */
    getSalesSummary(salesSummaryDatePeriod: SalesSummaryDatePeriod2 | null | undefined): Observable<GetSalesSummaryOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetSalesSummary?";
        if (salesSummaryDatePeriod !== undefined)
            url_ += "SalesSummaryDatePeriod=" + encodeURIComponent("" + salesSummaryDatePeriod) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSalesSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSalesSummary(<any>response_);
                } catch (e) {
                    return <Observable<GetSalesSummaryOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetSalesSummaryOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetSalesSummary(response: HttpResponseBase): Observable<GetSalesSummaryOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetSalesSummaryOutput.fromJS(resultData200) : new GetSalesSummaryOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSalesSummaryOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    getRegionalStats(input: any | null | undefined): Observable<GetRegionalStatsOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetRegionalStats?";
        if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetRegionalStats(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRegionalStats(<any>response_);
                } catch (e) {
                    return <Observable<GetRegionalStatsOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetRegionalStatsOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetRegionalStats(response: HttpResponseBase): Observable<GetRegionalStatsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetRegionalStatsOutput.fromJS(resultData200) : new GetRegionalStatsOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetRegionalStatsOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    getGeneralStats(input: any | null | undefined): Observable<GetGeneralStatsOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetGeneralStats?";
        if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetGeneralStats(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGeneralStats(<any>response_);
                } catch (e) {
                    return <Observable<GetGeneralStatsOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetGeneralStatsOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetGeneralStats(response: HttpResponseBase): Observable<GetGeneralStatsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetGeneralStatsOutput.fromJS(resultData200) : new GetGeneralStatsOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetGeneralStatsOutput>(<any>null);
    }
}

@Injectable()
export class TenantRegistrationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    registerTenant(input: RegisterTenantInput | null | undefined): Observable<RegisterTenantOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantRegistration/RegisterTenant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processRegisterTenant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegisterTenant(<any>response_);
                } catch (e) {
                    return <Observable<RegisterTenantOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<RegisterTenantOutput>><any>_observableThrow(response_);
        }));
    }

    protected processRegisterTenant(response: HttpResponseBase): Observable<RegisterTenantOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? RegisterTenantOutput.fromJS(resultData200) : new RegisterTenantOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RegisterTenantOutput>(<any>null);
    }

    /**
     * @return Success
     */
    getEditionsForSelect(): Observable<EditionsSelectOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantRegistration/GetEditionsForSelect";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetEditionsForSelect(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEditionsForSelect(<any>response_);
                } catch (e) {
                    return <Observable<EditionsSelectOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<EditionsSelectOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetEditionsForSelect(response: HttpResponseBase): Observable<EditionsSelectOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? EditionsSelectOutput.fromJS(resultData200) : new EditionsSelectOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EditionsSelectOutput>(<any>null);
    }

    /**
     * @param editionId (optional) 
     * @return Success
     */
    getEdition(editionId: number | null | undefined): Observable<EditionSelectDto> {
        let url_ = this.baseUrl + "/api/services/app/TenantRegistration/GetEdition?";
        if (editionId !== undefined)
            url_ += "editionId=" + encodeURIComponent("" + editionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetEdition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEdition(<any>response_);
                } catch (e) {
                    return <Observable<EditionSelectDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<EditionSelectDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetEdition(response: HttpResponseBase): Observable<EditionSelectDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? EditionSelectDto.fromJS(resultData200) : new EditionSelectDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EditionSelectDto>(<any>null);
    }
}

@Injectable()
export class TenantSettingsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAllSettings(): Observable<TenantSettingsEditDto> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/GetAllSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSettings(<any>response_);
                } catch (e) {
                    return <Observable<TenantSettingsEditDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TenantSettingsEditDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllSettings(response: HttpResponseBase): Observable<TenantSettingsEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? TenantSettingsEditDto.fromJS(resultData200) : new TenantSettingsEditDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantSettingsEditDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    updateAllSettings(input: TenantSettingsEditDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/UpdateAllSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateAllSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAllSettings(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateAllSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    clearLogo(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/ClearLogo";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processClearLogo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClearLogo(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processClearLogo(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    clearCustomCss(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/ClearCustomCss";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processClearCustomCss(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClearCustomCss(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processClearCustomCss(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    sendTestEmail(input: SendTestEmailInput | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/SendTestEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSendTestEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendTestEmail(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSendTestEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class TerminalMastersServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    search(input: GetAllTerminalMastersInput | null | undefined): Observable<PagedResultDtoOfGetTerminalMasterForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/TerminalMasters/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetTerminalMasterForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetTerminalMasterForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<PagedResultDtoOfGetTerminalMasterForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetTerminalMasterForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetTerminalMasterForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetTerminalMasterForViewDto>(<any>null);
    }

    /**
     * @param terminalCode (optional) 
     * @return Success
     */
    getTerminalMasterByEdit(terminalCode: string | null | undefined): Observable<PagedResultDtoOfGetTerminalMasterForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/TerminalMasters/GetTerminalMasterByEdit?";
        if (terminalCode !== undefined)
            url_ += "TerminalCode=" + encodeURIComponent("" + terminalCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetTerminalMasterByEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTerminalMasterByEdit(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetTerminalMasterForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetTerminalMasterForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetTerminalMasterByEdit(response: HttpResponseBase): Observable<PagedResultDtoOfGetTerminalMasterForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetTerminalMasterForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetTerminalMasterForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetTerminalMasterForViewDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEditUnsign(input: CreateOrEditTerminalMasterDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TerminalMasters/CreateOrEditUnsign";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEditUnsign(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditUnsign(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEditUnsign(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param entities (optional) 
     * @return Success
     */
    batchDelete(entities: TerminalMasterDto[] | null | undefined): Observable<MessageResult> {
        let url_ = this.baseUrl + "/api/services/app/TerminalMasters/BatchDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entities);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processBatchDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBatchDelete(<any>response_);
                } catch (e) {
                    return <Observable<MessageResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<MessageResult>><any>_observableThrow(response_);
        }));
    }

    protected processBatchDelete(response: HttpResponseBase): Observable<MessageResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? MessageResult.fromJS(resultData200) : new MessageResult();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MessageResult>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    searchTerminalMastersToExcel(input: GetAllTerminalMastersForExcelInput | null | undefined): Observable<RewardsFileDto> {
        let url_ = this.baseUrl + "/api/services/app/TerminalMasters/SearchTerminalMastersToExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSearchTerminalMastersToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchTerminalMastersToExcel(<any>response_);
                } catch (e) {
                    return <Observable<RewardsFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<RewardsFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processSearchTerminalMastersToExcel(response: HttpResponseBase): Observable<RewardsFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? RewardsFileDto.fromJS(resultData200) : new RewardsFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RewardsFileDto>(<any>null);
    }

    /**
     * @return Success
     */
    getConditionSearchProduct(): Observable<GetValueComboboxTerminalMaster> {
        let url_ = this.baseUrl + "/api/services/app/TerminalMasters/GetConditionSearchProduct";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetConditionSearchProduct(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConditionSearchProduct(<any>response_);
                } catch (e) {
                    return <Observable<GetValueComboboxTerminalMaster>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetValueComboboxTerminalMaster>><any>_observableThrow(response_);
        }));
    }

    protected processGetConditionSearchProduct(response: HttpResponseBase): Observable<GetValueComboboxTerminalMaster> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetValueComboboxTerminalMaster.fromJS(resultData200) : new GetValueComboboxTerminalMaster();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetValueComboboxTerminalMaster>(<any>null);
    }

    /**
     * @param masterHeaderCode (optional) 
     * @param level (optional) 
     * @param parentCode (optional) 
     * @return Success
     */
    getAllMasterDetail(masterHeaderCode: string | null | undefined, level: number | null | undefined, parentCode: string[] | null | undefined): Observable<MasterDetailForSelectDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TerminalMasters/GetAllMasterDetail?";
        if (masterHeaderCode !== undefined)
            url_ += "masterHeaderCode=" + encodeURIComponent("" + masterHeaderCode) + "&";
        if (level !== undefined)
            url_ += "level=" + encodeURIComponent("" + level) + "&";
        if (parentCode !== undefined)
            parentCode && parentCode.forEach(item => { url_ += "parentCode=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllMasterDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllMasterDetail(<any>response_);
                } catch (e) {
                    return <Observable<MasterDetailForSelectDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<MasterDetailForSelectDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllMasterDetail(response: HttpResponseBase): Observable<MasterDetailForSelectDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(MasterDetailForSelectDto.fromJS(item));
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MasterDetailForSelectDto[]>(<any>null);
    }

    /**
     * @param arg (optional) 
     * @return Success
     */
    importQueue(arg: TerminalMasterImportAgrs | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TerminalMasters/ImportQueue";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(arg);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processImportQueue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportQueue(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processImportQueue(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param userNameFilter (optional) 
     * @param passwordFilter (optional) 
     * @param statusFilter (optional) 
     * @param referenceCodeFilter (optional) 
     * @param terminalCodeFilter (optional) 
     * @param terminalNameFilter (optional) 
     * @param terminalNameUnsignFilter (optional) 
     * @param fullSalesRegionFilter (optional) 
     * @param productHierarchyLV1Filter (optional) 
     * @param productHierarchyLV2Filter (optional) 
     * @param productHierarchyLV3Filter (optional) 
     * @param productHierarchyLV4Filter (optional) 
     * @param productHierarchyLV5Filter (optional) 
     * @param idFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, userNameFilter: string | null | undefined, passwordFilter: string | null | undefined, statusFilter: string | null | undefined, referenceCodeFilter: string | null | undefined, terminalCodeFilter: string | null | undefined, terminalNameFilter: string | null | undefined, terminalNameUnsignFilter: string | null | undefined, fullSalesRegionFilter: string | null | undefined, productHierarchyLV1Filter: string | null | undefined, productHierarchyLV2Filter: string | null | undefined, productHierarchyLV3Filter: string | null | undefined, productHierarchyLV4Filter: string | null | undefined, productHierarchyLV5Filter: string | null | undefined, idFilter: number | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetTerminalMasterForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/TerminalMasters/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (userNameFilter !== undefined)
            url_ += "UserNameFilter=" + encodeURIComponent("" + userNameFilter) + "&";
        if (passwordFilter !== undefined)
            url_ += "PasswordFilter=" + encodeURIComponent("" + passwordFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (referenceCodeFilter !== undefined)
            url_ += "ReferenceCodeFilter=" + encodeURIComponent("" + referenceCodeFilter) + "&";
        if (terminalCodeFilter !== undefined)
            url_ += "TerminalCodeFilter=" + encodeURIComponent("" + terminalCodeFilter) + "&";
        if (terminalNameFilter !== undefined)
            url_ += "TerminalNameFilter=" + encodeURIComponent("" + terminalNameFilter) + "&";
        if (terminalNameUnsignFilter !== undefined)
            url_ += "TerminalNameUnsignFilter=" + encodeURIComponent("" + terminalNameUnsignFilter) + "&";
        if (fullSalesRegionFilter !== undefined)
            url_ += "FullSalesRegionFilter=" + encodeURIComponent("" + fullSalesRegionFilter) + "&";
        if (productHierarchyLV1Filter !== undefined)
            url_ += "ProductHierarchyLV1Filter=" + encodeURIComponent("" + productHierarchyLV1Filter) + "&";
        if (productHierarchyLV2Filter !== undefined)
            url_ += "ProductHierarchyLV2Filter=" + encodeURIComponent("" + productHierarchyLV2Filter) + "&";
        if (productHierarchyLV3Filter !== undefined)
            url_ += "ProductHierarchyLV3Filter=" + encodeURIComponent("" + productHierarchyLV3Filter) + "&";
        if (productHierarchyLV4Filter !== undefined)
            url_ += "ProductHierarchyLV4Filter=" + encodeURIComponent("" + productHierarchyLV4Filter) + "&";
        if (productHierarchyLV5Filter !== undefined)
            url_ += "ProductHierarchyLV5Filter=" + encodeURIComponent("" + productHierarchyLV5Filter) + "&";
        if (idFilter !== undefined)
            url_ += "IdFilter=" + encodeURIComponent("" + idFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetTerminalMasterForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetTerminalMasterForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetTerminalMasterForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetTerminalMasterForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetTerminalMasterForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetTerminalMasterForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getTerminalMasterForEdit(id: number | null | undefined): Observable<GetTerminalMasterForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/TerminalMasters/GetTerminalMasterForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetTerminalMasterForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTerminalMasterForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetTerminalMasterForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetTerminalMasterForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetTerminalMasterForEdit(response: HttpResponseBase): Observable<GetTerminalMasterForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetTerminalMasterForEditOutput.fromJS(resultData200) : new GetTerminalMasterForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTerminalMasterForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditTerminalMasterDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TerminalMasters/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TerminalMasters/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param userNameFilter (optional) 
     * @param passwordFilter (optional) 
     * @param statusFilter (optional) 
     * @param referenceCodeFilter (optional) 
     * @param terminalCodeFilter (optional) 
     * @param terminalNameFilter (optional) 
     * @param terminalNameUnsignFilter (optional) 
     * @param fullSalesRegionFilter (optional) 
     * @param productHierarchyLV1Filter (optional) 
     * @param productHierarchyLV2Filter (optional) 
     * @param productHierarchyLV3Filter (optional) 
     * @param productHierarchyLV4Filter (optional) 
     * @param productHierarchyLV5Filter (optional) 
     * @param idFilter (optional) 
     * @return Success
     */
    getTerminalMastersToExcel(filter: string | null | undefined, userNameFilter: string | null | undefined, passwordFilter: string | null | undefined, statusFilter: string | null | undefined, referenceCodeFilter: string | null | undefined, terminalCodeFilter: string | null | undefined, terminalNameFilter: string | null | undefined, terminalNameUnsignFilter: string | null | undefined, fullSalesRegionFilter: string | null | undefined, productHierarchyLV1Filter: string | null | undefined, productHierarchyLV2Filter: string | null | undefined, productHierarchyLV3Filter: string | null | undefined, productHierarchyLV4Filter: string | null | undefined, productHierarchyLV5Filter: string | null | undefined, idFilter: number | null | undefined): Observable<RewardsFileDto> {
        let url_ = this.baseUrl + "/api/services/app/TerminalMasters/GetTerminalMastersToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (userNameFilter !== undefined)
            url_ += "UserNameFilter=" + encodeURIComponent("" + userNameFilter) + "&";
        if (passwordFilter !== undefined)
            url_ += "PasswordFilter=" + encodeURIComponent("" + passwordFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (referenceCodeFilter !== undefined)
            url_ += "ReferenceCodeFilter=" + encodeURIComponent("" + referenceCodeFilter) + "&";
        if (terminalCodeFilter !== undefined)
            url_ += "TerminalCodeFilter=" + encodeURIComponent("" + terminalCodeFilter) + "&";
        if (terminalNameFilter !== undefined)
            url_ += "TerminalNameFilter=" + encodeURIComponent("" + terminalNameFilter) + "&";
        if (terminalNameUnsignFilter !== undefined)
            url_ += "TerminalNameUnsignFilter=" + encodeURIComponent("" + terminalNameUnsignFilter) + "&";
        if (fullSalesRegionFilter !== undefined)
            url_ += "FullSalesRegionFilter=" + encodeURIComponent("" + fullSalesRegionFilter) + "&";
        if (productHierarchyLV1Filter !== undefined)
            url_ += "ProductHierarchyLV1Filter=" + encodeURIComponent("" + productHierarchyLV1Filter) + "&";
        if (productHierarchyLV2Filter !== undefined)
            url_ += "ProductHierarchyLV2Filter=" + encodeURIComponent("" + productHierarchyLV2Filter) + "&";
        if (productHierarchyLV3Filter !== undefined)
            url_ += "ProductHierarchyLV3Filter=" + encodeURIComponent("" + productHierarchyLV3Filter) + "&";
        if (productHierarchyLV4Filter !== undefined)
            url_ += "ProductHierarchyLV4Filter=" + encodeURIComponent("" + productHierarchyLV4Filter) + "&";
        if (productHierarchyLV5Filter !== undefined)
            url_ += "ProductHierarchyLV5Filter=" + encodeURIComponent("" + productHierarchyLV5Filter) + "&";
        if (idFilter !== undefined)
            url_ += "IdFilter=" + encodeURIComponent("" + idFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetTerminalMastersToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTerminalMastersToExcel(<any>response_);
                } catch (e) {
                    return <Observable<RewardsFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<RewardsFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetTerminalMastersToExcel(response: HttpResponseBase): Observable<RewardsFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? RewardsFileDto.fromJS(resultData200) : new RewardsFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RewardsFileDto>(<any>null);
    }
}

@Injectable()
export class TimingServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param defaultTimezoneScope (optional) 
     * @return Success
     */
    getTimezones(defaultTimezoneScope: DefaultTimezoneScope | null | undefined): Observable<ListResultDtoOfNameValueDto> {
        let url_ = this.baseUrl + "/api/services/app/Timing/GetTimezones?";
        if (defaultTimezoneScope !== undefined)
            url_ += "DefaultTimezoneScope=" + encodeURIComponent("" + defaultTimezoneScope) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetTimezones(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTimezones(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfNameValueDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfNameValueDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetTimezones(response: HttpResponseBase): Observable<ListResultDtoOfNameValueDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? ListResultDtoOfNameValueDto.fromJS(resultData200) : new ListResultDtoOfNameValueDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfNameValueDto>(<any>null);
    }

    /**
     * @param selectedTimezoneId (optional) 
     * @return Success
     */
    getTimezoneComboboxItems(selectedTimezoneId: string | null | undefined): Observable<ComboboxItemDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Timing/GetTimezoneComboboxItems?";
        if (selectedTimezoneId !== undefined)
            url_ += "SelectedTimezoneId=" + encodeURIComponent("" + selectedTimezoneId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetTimezoneComboboxItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTimezoneComboboxItems(<any>response_);
                } catch (e) {
                    return <Observable<ComboboxItemDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ComboboxItemDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetTimezoneComboboxItems(response: HttpResponseBase): Observable<ComboboxItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(ComboboxItemDto.fromJS(item));
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ComboboxItemDto[]>(<any>null);
    }
}

@Injectable()
export class TokenAuthServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param model (optional) 
     * @return Success
     */
    authenticate(model: AuthenticateModel | null | undefined): Observable<AuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/Authenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuthenticate(<any>response_);
                } catch (e) {
                    return <Observable<AuthenticateResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<AuthenticateResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processAuthenticate(response: HttpResponseBase): Observable<AuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? AuthenticateResultModel.fromJS(resultData200) : new AuthenticateResultModel();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AuthenticateResultModel>(<any>null);
    }

    /**
     * @param exModel (optional) 
     * @return Success
     */
    resetPassword(exModel: AuthenticateExtModel | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/TokenAuth/ResetPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(exModel);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processResetPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetPassword(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processResetPassword(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param exModel (optional) 
     * @return Success
     */
    authenticateExt(exModel: AuthenticateExtModel | null | undefined): Observable<AuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/AuthenticateExt";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(exModel);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processAuthenticateExt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuthenticateExt(<any>response_);
                } catch (e) {
                    return <Observable<AuthenticateResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<AuthenticateResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processAuthenticateExt(response: HttpResponseBase): Observable<AuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? AuthenticateResultModel.fromJS(resultData200) : new AuthenticateResultModel();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AuthenticateResultModel>(<any>null);
    }

    /**
     * @param userName (optional) 
     * @param deviceId1 (optional) 
     * @param deviceId2 (optional) 
     * @return Success
     */
    registDeviceId(userName: string | null | undefined, deviceId1: string | null | undefined, deviceId2: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/TokenAuth/RegistDeviceId?";
        if (userName !== undefined)
            url_ += "userName=" + encodeURIComponent("" + userName) + "&";
        if (deviceId1 !== undefined)
            url_ += "deviceId1=" + encodeURIComponent("" + deviceId1) + "&";
        if (deviceId2 !== undefined)
            url_ += "deviceId2=" + encodeURIComponent("" + deviceId2) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processRegistDeviceId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegistDeviceId(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processRegistDeviceId(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param phoneNumber (optional) 
     * @param pattern (optional) 
     * @return Success
     */
    verifyUserPhone(phoneNumber: string | null | undefined, pattern: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/TokenAuth/VerifyUserPhone?";
        if (phoneNumber !== undefined)
            url_ += "phoneNumber=" + encodeURIComponent("" + phoneNumber) + "&";
        if (pattern !== undefined)
            url_ += "pattern=" + encodeURIComponent("" + pattern) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processVerifyUserPhone(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerifyUserPhone(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processVerifyUserPhone(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param phoneNumber (optional) 
     * @param pattern (optional) 
     * @return Success
     */
    verifyUserPhoneForCreating(phoneNumber: string | null | undefined, pattern: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/TokenAuth/VerifyUserPhoneForCreating?";
        if (phoneNumber !== undefined)
            url_ += "phoneNumber=" + encodeURIComponent("" + phoneNumber) + "&";
        if (pattern !== undefined)
            url_ += "pattern=" + encodeURIComponent("" + pattern) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processVerifyUserPhoneForCreating(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerifyUserPhoneForCreating(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processVerifyUserPhoneForCreating(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    emergencyAccountLock(input: EmergencyAccountLockModel | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/TokenAuth/EmergencyAccountLock";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processEmergencyAccountLock(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEmergencyAccountLock(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processEmergencyAccountLock(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    logOut(): Observable<void> {
        let url_ = this.baseUrl + "/api/TokenAuth/LogOut";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processLogOut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogOut(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processLogOut(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param model (optional) 
     * @return Success
     */
    sendTwoFactorAuthCode(model: SendTwoFactorAuthCodeModel | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/TokenAuth/SendTwoFactorAuthCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSendTwoFactorAuthCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendTwoFactorAuthCode(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSendTwoFactorAuthCode(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param impersonationToken (optional) 
     * @return Success
     */
    impersonatedAuthenticate(impersonationToken: string | null | undefined): Observable<ImpersonatedAuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/ImpersonatedAuthenticate?";
        if (impersonationToken !== undefined)
            url_ += "impersonationToken=" + encodeURIComponent("" + impersonationToken) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processImpersonatedAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImpersonatedAuthenticate(<any>response_);
                } catch (e) {
                    return <Observable<ImpersonatedAuthenticateResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ImpersonatedAuthenticateResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processImpersonatedAuthenticate(response: HttpResponseBase): Observable<ImpersonatedAuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? ImpersonatedAuthenticateResultModel.fromJS(resultData200) : new ImpersonatedAuthenticateResultModel();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ImpersonatedAuthenticateResultModel>(<any>null);
    }

    /**
     * @param switchAccountToken (optional) 
     * @return Success
     */
    linkedAccountAuthenticate(switchAccountToken: string | null | undefined): Observable<SwitchedAccountAuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/LinkedAccountAuthenticate?";
        if (switchAccountToken !== undefined)
            url_ += "switchAccountToken=" + encodeURIComponent("" + switchAccountToken) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processLinkedAccountAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLinkedAccountAuthenticate(<any>response_);
                } catch (e) {
                    return <Observable<SwitchedAccountAuthenticateResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<SwitchedAccountAuthenticateResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processLinkedAccountAuthenticate(response: HttpResponseBase): Observable<SwitchedAccountAuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? SwitchedAccountAuthenticateResultModel.fromJS(resultData200) : new SwitchedAccountAuthenticateResultModel();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwitchedAccountAuthenticateResultModel>(<any>null);
    }

    /**
     * @return Success
     */
    getExternalAuthenticationProviders(): Observable<ExternalLoginProviderInfoModel[]> {
        let url_ = this.baseUrl + "/api/TokenAuth/GetExternalAuthenticationProviders";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetExternalAuthenticationProviders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExternalAuthenticationProviders(<any>response_);
                } catch (e) {
                    return <Observable<ExternalLoginProviderInfoModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ExternalLoginProviderInfoModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetExternalAuthenticationProviders(response: HttpResponseBase): Observable<ExternalLoginProviderInfoModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(ExternalLoginProviderInfoModel.fromJS(item));
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExternalLoginProviderInfoModel[]>(<any>null);
    }

    /**
     * @param model (optional) 
     * @return Success
     */
    externalAuthenticate(model: ExternalAuthenticateModel | null | undefined): Observable<ExternalAuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/ExternalAuthenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processExternalAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExternalAuthenticate(<any>response_);
                } catch (e) {
                    return <Observable<ExternalAuthenticateResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ExternalAuthenticateResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processExternalAuthenticate(response: HttpResponseBase): Observable<ExternalAuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? ExternalAuthenticateResultModel.fromJS(resultData200) : new ExternalAuthenticateResultModel();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExternalAuthenticateResultModel>(<any>null);
    }

    /**
     * @param message (optional) 
     * @param severity (optional) 
     * @return Success
     */
    testNotification(message: string | null | undefined, severity: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/TokenAuth/TestNotification?";
        if (message !== undefined)
            url_ += "message=" + encodeURIComponent("" + message) + "&";
        if (severity !== undefined)
            url_ += "severity=" + encodeURIComponent("" + severity) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processTestNotification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTestNotification(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processTestNotification(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    testRequest(): Observable<void> {
        let url_ = this.baseUrl + "/api/TokenAuth/TestRequest";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processTestRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTestRequest(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processTestRequest(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param exModel (optional) 
     * @return Success
     */
    authenticateExtForApp(exModel: AuthenticateExtModel | null | undefined): Observable<AuthenticateResponeDTO> {
        let url_ = this.baseUrl + "/api/TokenAuth/AuthenticateExtForApp";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(exModel);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processAuthenticateExtForApp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuthenticateExtForApp(<any>response_);
                } catch (e) {
                    return <Observable<AuthenticateResponeDTO>><any>_observableThrow(e);
                }
            } else
                return <Observable<AuthenticateResponeDTO>><any>_observableThrow(response_);
        }));
    }

    protected processAuthenticateExtForApp(response: HttpResponseBase): Observable<AuthenticateResponeDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? AuthenticateResponeDTO.fromJS(resultData200) : new AuthenticateResponeDTO();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AuthenticateResponeDTO>(<any>null);
    }
}

@Injectable()
export class TransactionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    transfer(input: TransferDtoInput | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Transaction/Transfer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processTransfer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTransfer(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processTransfer(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    transferV2(input: TransferDtoInput | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Transaction/TransferV2";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processTransferV2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTransferV2(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processTransferV2(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class TransactionCoinBaseLinesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetTransactionCoinBaseLineForView> {
        let url_ = this.baseUrl + "/api/services/app/TransactionCoinBaseLines/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetTransactionCoinBaseLineForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetTransactionCoinBaseLineForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetTransactionCoinBaseLineForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetTransactionCoinBaseLineForView.fromJS(resultData200) : new PagedResultDtoOfGetTransactionCoinBaseLineForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetTransactionCoinBaseLineForView>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getTransactionCoinBaseLineForEdit(id: number | null | undefined): Observable<GetTransactionCoinBaseLineForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/TransactionCoinBaseLines/GetTransactionCoinBaseLineForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetTransactionCoinBaseLineForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTransactionCoinBaseLineForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetTransactionCoinBaseLineForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetTransactionCoinBaseLineForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetTransactionCoinBaseLineForEdit(response: HttpResponseBase): Observable<GetTransactionCoinBaseLineForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetTransactionCoinBaseLineForEditOutput.fromJS(resultData200) : new GetTransactionCoinBaseLineForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTransactionCoinBaseLineForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditTransactionCoinBaseLineDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TransactionCoinBaseLines/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TransactionCoinBaseLines/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class TransactionDetailsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetTransactionDetailForView> {
        let url_ = this.baseUrl + "/api/services/app/TransactionDetails/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetTransactionDetailForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetTransactionDetailForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetTransactionDetailForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetTransactionDetailForView.fromJS(resultData200) : new PagedResultDtoOfGetTransactionDetailForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetTransactionDetailForView>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getTransactionDetailForEdit(id: number | null | undefined): Observable<GetTransactionDetailForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/TransactionDetails/GetTransactionDetailForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetTransactionDetailForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTransactionDetailForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetTransactionDetailForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetTransactionDetailForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetTransactionDetailForEdit(response: HttpResponseBase): Observable<GetTransactionDetailForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetTransactionDetailForEditOutput.fromJS(resultData200) : new GetTransactionDetailForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTransactionDetailForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditTransactionDetailDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TransactionDetails/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TransactionDetails/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param transactionCode (optional) 
     * @return Success
     */
    getOrderDetailAsync(transactionCode: string | null | undefined): Observable<GetOrderDetailAsyncDto> {
        let url_ = this.baseUrl + "/api/services/app/TransactionDetails/GetOrderDetailAsync?";
        if (transactionCode !== undefined)
            url_ += "transactionCode=" + encodeURIComponent("" + transactionCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetOrderDetailAsync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderDetailAsync(<any>response_);
                } catch (e) {
                    return <Observable<GetOrderDetailAsyncDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetOrderDetailAsyncDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetOrderDetailAsync(response: HttpResponseBase): Observable<GetOrderDetailAsyncDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetOrderDetailAsyncDto.fromJS(resultData200) : new GetOrderDetailAsyncDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetOrderDetailAsyncDto>(<any>null);
    }
}

@Injectable()
export class TransactionPointBaseLinesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetTransactionPointBaseLineForView> {
        let url_ = this.baseUrl + "/api/services/app/TransactionPointBaseLines/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetTransactionPointBaseLineForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetTransactionPointBaseLineForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetTransactionPointBaseLineForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetTransactionPointBaseLineForView.fromJS(resultData200) : new PagedResultDtoOfGetTransactionPointBaseLineForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetTransactionPointBaseLineForView>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getTransactionPointBaseLineForEdit(id: number | null | undefined): Observable<GetTransactionPointBaseLineForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/TransactionPointBaseLines/GetTransactionPointBaseLineForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetTransactionPointBaseLineForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTransactionPointBaseLineForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetTransactionPointBaseLineForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetTransactionPointBaseLineForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetTransactionPointBaseLineForEdit(response: HttpResponseBase): Observable<GetTransactionPointBaseLineForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetTransactionPointBaseLineForEditOutput.fromJS(resultData200) : new GetTransactionPointBaseLineForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTransactionPointBaseLineForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditTransactionPointBaseLineDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TransactionPointBaseLines/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TransactionPointBaseLines/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class TransactionsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param maxActionRuleCoinFilter (optional) 
     * @param minActionRuleCoinFilter (optional) 
     * @param maxActionRulePointFilter (optional) 
     * @param minActionRulePointFilter (optional) 
     * @param actionRuleSettingCodeFilter (optional) 
     * @param approverFilter (optional) 
     * @param maxBaseCoinRatioFilter (optional) 
     * @param minBaseCoinRatioFilter (optional) 
     * @param maxBasePointRatioFilter (optional) 
     * @param minBasePointRatioFilter (optional) 
     * @param baseSettingCodeFilter (optional) 
     * @param maxBusinessTimeFilter (optional) 
     * @param minBusinessTimeFilter (optional) 
     * @param codeFilter (optional) 
     * @param maxCoinFilter (optional) 
     * @param minCoinFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param distributorCodeFilter (optional) 
     * @param maxEventCoinRatioFilter (optional) 
     * @param minEventCoinRatioFilter (optional) 
     * @param maxEventPointRatioFilter (optional) 
     * @param minEventPointRatioFilter (optional) 
     * @param eventSettingCodeFilter (optional) 
     * @param fullChannelTypeCodeFilter (optional) 
     * @param fullMemberTypeCodeFilter (optional) 
     * @param fullRegionCodeFilter (optional) 
     * @param fullSalesRegionCodeFilter (optional) 
     * @param memberCodeFilter (optional) 
     * @param originalOrdersFilter (optional) 
     * @param maxOriginalOrdersTimeFilter (optional) 
     * @param minOriginalOrdersTimeFilter (optional) 
     * @param maxPlusCoinFilter (optional) 
     * @param minPlusCoinFilter (optional) 
     * @param maxPlusPointFilter (optional) 
     * @param minPlusPointFilter (optional) 
     * @param maxPointFilter (optional) 
     * @param minPointFilter (optional) 
     * @param rankCodeFilter (optional) 
     * @param maxRankCoinRatioFilter (optional) 
     * @param minRankCoinRatioFilter (optional) 
     * @param maxRankPointRatioFilter (optional) 
     * @param minRankPointRatioFilter (optional) 
     * @param rankSettingCodeFilter (optional) 
     * @param rankTypeCodeFilter (optional) 
     * @param maxRatioCoinFilter (optional) 
     * @param minRatioCoinFilter (optional) 
     * @param maxRatioPointFilter (optional) 
     * @param minRatioPointFilter (optional) 
     * @param reasonFilter (optional) 
     * @param referralSettingCodeFilter (optional) 
     * @param maxRequestDateFilter (optional) 
     * @param minRequestDateFilter (optional) 
     * @param senioritySettingCodeFilter (optional) 
     * @param sourceFilter (optional) 
     * @param specialSettingCodeFilter (optional) 
     * @param standardMemberCodeFilter (optional) 
     * @param terminalNoFilter (optional) 
     * @param maxTotalAmountBeforeTaxFilter (optional) 
     * @param minTotalAmountBeforeTaxFilter (optional) 
     * @param maxTotalAmountIncludeTaxFilter (optional) 
     * @param minTotalAmountIncludeTaxFilter (optional) 
     * @param maxTotalCalcAmountFilter (optional) 
     * @param minTotalCalcAmountFilter (optional) 
     * @param maxTotalDetailLineFilter (optional) 
     * @param minTotalDetailLineFilter (optional) 
     * @param maxTotalTaxAmountFilter (optional) 
     * @param minTotalTaxAmountFilter (optional) 
     * @param maxUsedCoinFilter (optional) 
     * @param minUsedCoinFilter (optional) 
     * @param maxTotalAmountIssuePointFilter (optional) 
     * @param minTotalAmountIssuePointFilter (optional) 
     * @param maxTotalAmountIssueCoinFilter (optional) 
     * @param minTotalAmountIssueCoinFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, maxActionRuleCoinFilter: number | null | undefined, minActionRuleCoinFilter: number | null | undefined, maxActionRulePointFilter: number | null | undefined, minActionRulePointFilter: number | null | undefined, actionRuleSettingCodeFilter: string | null | undefined, approverFilter: string | null | undefined, maxBaseCoinRatioFilter: number | null | undefined, minBaseCoinRatioFilter: number | null | undefined, maxBasePointRatioFilter: number | null | undefined, minBasePointRatioFilter: number | null | undefined, baseSettingCodeFilter: string | null | undefined, maxBusinessTimeFilter: moment.Moment | null | undefined, minBusinessTimeFilter: moment.Moment | null | undefined, codeFilter: string | null | undefined, maxCoinFilter: number | null | undefined, minCoinFilter: number | null | undefined, descriptionFilter: string | null | undefined, distributorCodeFilter: string | null | undefined, maxEventCoinRatioFilter: number | null | undefined, minEventCoinRatioFilter: number | null | undefined, maxEventPointRatioFilter: number | null | undefined, minEventPointRatioFilter: number | null | undefined, eventSettingCodeFilter: string | null | undefined, fullChannelTypeCodeFilter: string | null | undefined, fullMemberTypeCodeFilter: string | null | undefined, fullRegionCodeFilter: string | null | undefined, fullSalesRegionCodeFilter: string | null | undefined, memberCodeFilter: string | null | undefined, originalOrdersFilter: string | null | undefined, maxOriginalOrdersTimeFilter: moment.Moment | null | undefined, minOriginalOrdersTimeFilter: moment.Moment | null | undefined, maxPlusCoinFilter: number | null | undefined, minPlusCoinFilter: number | null | undefined, maxPlusPointFilter: number | null | undefined, minPlusPointFilter: number | null | undefined, maxPointFilter: number | null | undefined, minPointFilter: number | null | undefined, rankCodeFilter: string | null | undefined, maxRankCoinRatioFilter: number | null | undefined, minRankCoinRatioFilter: number | null | undefined, maxRankPointRatioFilter: number | null | undefined, minRankPointRatioFilter: number | null | undefined, rankSettingCodeFilter: string | null | undefined, rankTypeCodeFilter: string | null | undefined, maxRatioCoinFilter: number | null | undefined, minRatioCoinFilter: number | null | undefined, maxRatioPointFilter: number | null | undefined, minRatioPointFilter: number | null | undefined, reasonFilter: string | null | undefined, referralSettingCodeFilter: string | null | undefined, maxRequestDateFilter: moment.Moment | null | undefined, minRequestDateFilter: moment.Moment | null | undefined, senioritySettingCodeFilter: string | null | undefined, sourceFilter: string | null | undefined, specialSettingCodeFilter: string | null | undefined, standardMemberCodeFilter: string | null | undefined, terminalNoFilter: string | null | undefined, maxTotalAmountBeforeTaxFilter: number | null | undefined, minTotalAmountBeforeTaxFilter: number | null | undefined, maxTotalAmountIncludeTaxFilter: number | null | undefined, minTotalAmountIncludeTaxFilter: number | null | undefined, maxTotalCalcAmountFilter: number | null | undefined, minTotalCalcAmountFilter: number | null | undefined, maxTotalDetailLineFilter: number | null | undefined, minTotalDetailLineFilter: number | null | undefined, maxTotalTaxAmountFilter: number | null | undefined, minTotalTaxAmountFilter: number | null | undefined, maxUsedCoinFilter: number | null | undefined, minUsedCoinFilter: number | null | undefined, maxTotalAmountIssuePointFilter: number | null | undefined, minTotalAmountIssuePointFilter: number | null | undefined, maxTotalAmountIssueCoinFilter: number | null | undefined, minTotalAmountIssueCoinFilter: number | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetTransactionForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Transactions/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxActionRuleCoinFilter !== undefined)
            url_ += "MaxActionRuleCoinFilter=" + encodeURIComponent("" + maxActionRuleCoinFilter) + "&";
        if (minActionRuleCoinFilter !== undefined)
            url_ += "MinActionRuleCoinFilter=" + encodeURIComponent("" + minActionRuleCoinFilter) + "&";
        if (maxActionRulePointFilter !== undefined)
            url_ += "MaxActionRulePointFilter=" + encodeURIComponent("" + maxActionRulePointFilter) + "&";
        if (minActionRulePointFilter !== undefined)
            url_ += "MinActionRulePointFilter=" + encodeURIComponent("" + minActionRulePointFilter) + "&";
        if (actionRuleSettingCodeFilter !== undefined)
            url_ += "ActionRuleSettingCodeFilter=" + encodeURIComponent("" + actionRuleSettingCodeFilter) + "&";
        if (approverFilter !== undefined)
            url_ += "ApproverFilter=" + encodeURIComponent("" + approverFilter) + "&";
        if (maxBaseCoinRatioFilter !== undefined)
            url_ += "MaxBaseCoinRatioFilter=" + encodeURIComponent("" + maxBaseCoinRatioFilter) + "&";
        if (minBaseCoinRatioFilter !== undefined)
            url_ += "MinBaseCoinRatioFilter=" + encodeURIComponent("" + minBaseCoinRatioFilter) + "&";
        if (maxBasePointRatioFilter !== undefined)
            url_ += "MaxBasePointRatioFilter=" + encodeURIComponent("" + maxBasePointRatioFilter) + "&";
        if (minBasePointRatioFilter !== undefined)
            url_ += "MinBasePointRatioFilter=" + encodeURIComponent("" + minBasePointRatioFilter) + "&";
        if (baseSettingCodeFilter !== undefined)
            url_ += "BaseSettingCodeFilter=" + encodeURIComponent("" + baseSettingCodeFilter) + "&";
        if (maxBusinessTimeFilter !== undefined)
            url_ += "MaxBusinessTimeFilter=" + encodeURIComponent(maxBusinessTimeFilter ? "" + maxBusinessTimeFilter.toJSON() : "") + "&";
        if (minBusinessTimeFilter !== undefined)
            url_ += "MinBusinessTimeFilter=" + encodeURIComponent(minBusinessTimeFilter ? "" + minBusinessTimeFilter.toJSON() : "") + "&";
        if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&";
        if (maxCoinFilter !== undefined)
            url_ += "MaxCoinFilter=" + encodeURIComponent("" + maxCoinFilter) + "&";
        if (minCoinFilter !== undefined)
            url_ += "MinCoinFilter=" + encodeURIComponent("" + minCoinFilter) + "&";
        if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&";
        if (distributorCodeFilter !== undefined)
            url_ += "DistributorCodeFilter=" + encodeURIComponent("" + distributorCodeFilter) + "&";
        if (maxEventCoinRatioFilter !== undefined)
            url_ += "MaxEventCoinRatioFilter=" + encodeURIComponent("" + maxEventCoinRatioFilter) + "&";
        if (minEventCoinRatioFilter !== undefined)
            url_ += "MinEventCoinRatioFilter=" + encodeURIComponent("" + minEventCoinRatioFilter) + "&";
        if (maxEventPointRatioFilter !== undefined)
            url_ += "MaxEventPointRatioFilter=" + encodeURIComponent("" + maxEventPointRatioFilter) + "&";
        if (minEventPointRatioFilter !== undefined)
            url_ += "MinEventPointRatioFilter=" + encodeURIComponent("" + minEventPointRatioFilter) + "&";
        if (eventSettingCodeFilter !== undefined)
            url_ += "EventSettingCodeFilter=" + encodeURIComponent("" + eventSettingCodeFilter) + "&";
        if (fullChannelTypeCodeFilter !== undefined)
            url_ += "FullChannelTypeCodeFilter=" + encodeURIComponent("" + fullChannelTypeCodeFilter) + "&";
        if (fullMemberTypeCodeFilter !== undefined)
            url_ += "FullMemberTypeCodeFilter=" + encodeURIComponent("" + fullMemberTypeCodeFilter) + "&";
        if (fullRegionCodeFilter !== undefined)
            url_ += "FullRegionCodeFilter=" + encodeURIComponent("" + fullRegionCodeFilter) + "&";
        if (fullSalesRegionCodeFilter !== undefined)
            url_ += "FullSalesRegionCodeFilter=" + encodeURIComponent("" + fullSalesRegionCodeFilter) + "&";
        if (memberCodeFilter !== undefined)
            url_ += "MemberCodeFilter=" + encodeURIComponent("" + memberCodeFilter) + "&";
        if (originalOrdersFilter !== undefined)
            url_ += "OriginalOrdersFilter=" + encodeURIComponent("" + originalOrdersFilter) + "&";
        if (maxOriginalOrdersTimeFilter !== undefined)
            url_ += "MaxOriginalOrdersTimeFilter=" + encodeURIComponent(maxOriginalOrdersTimeFilter ? "" + maxOriginalOrdersTimeFilter.toJSON() : "") + "&";
        if (minOriginalOrdersTimeFilter !== undefined)
            url_ += "MinOriginalOrdersTimeFilter=" + encodeURIComponent(minOriginalOrdersTimeFilter ? "" + minOriginalOrdersTimeFilter.toJSON() : "") + "&";
        if (maxPlusCoinFilter !== undefined)
            url_ += "MaxPlusCoinFilter=" + encodeURIComponent("" + maxPlusCoinFilter) + "&";
        if (minPlusCoinFilter !== undefined)
            url_ += "MinPlusCoinFilter=" + encodeURIComponent("" + minPlusCoinFilter) + "&";
        if (maxPlusPointFilter !== undefined)
            url_ += "MaxPlusPointFilter=" + encodeURIComponent("" + maxPlusPointFilter) + "&";
        if (minPlusPointFilter !== undefined)
            url_ += "MinPlusPointFilter=" + encodeURIComponent("" + minPlusPointFilter) + "&";
        if (maxPointFilter !== undefined)
            url_ += "MaxPointFilter=" + encodeURIComponent("" + maxPointFilter) + "&";
        if (minPointFilter !== undefined)
            url_ += "MinPointFilter=" + encodeURIComponent("" + minPointFilter) + "&";
        if (rankCodeFilter !== undefined)
            url_ += "RankCodeFilter=" + encodeURIComponent("" + rankCodeFilter) + "&";
        if (maxRankCoinRatioFilter !== undefined)
            url_ += "MaxRankCoinRatioFilter=" + encodeURIComponent("" + maxRankCoinRatioFilter) + "&";
        if (minRankCoinRatioFilter !== undefined)
            url_ += "MinRankCoinRatioFilter=" + encodeURIComponent("" + minRankCoinRatioFilter) + "&";
        if (maxRankPointRatioFilter !== undefined)
            url_ += "MaxRankPointRatioFilter=" + encodeURIComponent("" + maxRankPointRatioFilter) + "&";
        if (minRankPointRatioFilter !== undefined)
            url_ += "MinRankPointRatioFilter=" + encodeURIComponent("" + minRankPointRatioFilter) + "&";
        if (rankSettingCodeFilter !== undefined)
            url_ += "RankSettingCodeFilter=" + encodeURIComponent("" + rankSettingCodeFilter) + "&";
        if (rankTypeCodeFilter !== undefined)
            url_ += "RankTypeCodeFilter=" + encodeURIComponent("" + rankTypeCodeFilter) + "&";
        if (maxRatioCoinFilter !== undefined)
            url_ += "MaxRatioCoinFilter=" + encodeURIComponent("" + maxRatioCoinFilter) + "&";
        if (minRatioCoinFilter !== undefined)
            url_ += "MinRatioCoinFilter=" + encodeURIComponent("" + minRatioCoinFilter) + "&";
        if (maxRatioPointFilter !== undefined)
            url_ += "MaxRatioPointFilter=" + encodeURIComponent("" + maxRatioPointFilter) + "&";
        if (minRatioPointFilter !== undefined)
            url_ += "MinRatioPointFilter=" + encodeURIComponent("" + minRatioPointFilter) + "&";
        if (reasonFilter !== undefined)
            url_ += "ReasonFilter=" + encodeURIComponent("" + reasonFilter) + "&";
        if (referralSettingCodeFilter !== undefined)
            url_ += "ReferralSettingCodeFilter=" + encodeURIComponent("" + referralSettingCodeFilter) + "&";
        if (maxRequestDateFilter !== undefined)
            url_ += "MaxRequestDateFilter=" + encodeURIComponent(maxRequestDateFilter ? "" + maxRequestDateFilter.toJSON() : "") + "&";
        if (minRequestDateFilter !== undefined)
            url_ += "MinRequestDateFilter=" + encodeURIComponent(minRequestDateFilter ? "" + minRequestDateFilter.toJSON() : "") + "&";
        if (senioritySettingCodeFilter !== undefined)
            url_ += "SenioritySettingCodeFilter=" + encodeURIComponent("" + senioritySettingCodeFilter) + "&";
        if (sourceFilter !== undefined)
            url_ += "SourceFilter=" + encodeURIComponent("" + sourceFilter) + "&";
        if (specialSettingCodeFilter !== undefined)
            url_ += "SpecialSettingCodeFilter=" + encodeURIComponent("" + specialSettingCodeFilter) + "&";
        if (standardMemberCodeFilter !== undefined)
            url_ += "StandardMemberCodeFilter=" + encodeURIComponent("" + standardMemberCodeFilter) + "&";
        if (terminalNoFilter !== undefined)
            url_ += "TerminalNoFilter=" + encodeURIComponent("" + terminalNoFilter) + "&";
        if (maxTotalAmountBeforeTaxFilter !== undefined)
            url_ += "MaxTotalAmountBeforeTaxFilter=" + encodeURIComponent("" + maxTotalAmountBeforeTaxFilter) + "&";
        if (minTotalAmountBeforeTaxFilter !== undefined)
            url_ += "MinTotalAmountBeforeTaxFilter=" + encodeURIComponent("" + minTotalAmountBeforeTaxFilter) + "&";
        if (maxTotalAmountIncludeTaxFilter !== undefined)
            url_ += "MaxTotalAmountIncludeTaxFilter=" + encodeURIComponent("" + maxTotalAmountIncludeTaxFilter) + "&";
        if (minTotalAmountIncludeTaxFilter !== undefined)
            url_ += "MinTotalAmountIncludeTaxFilter=" + encodeURIComponent("" + minTotalAmountIncludeTaxFilter) + "&";
        if (maxTotalCalcAmountFilter !== undefined)
            url_ += "MaxTotalCalcAmountFilter=" + encodeURIComponent("" + maxTotalCalcAmountFilter) + "&";
        if (minTotalCalcAmountFilter !== undefined)
            url_ += "MinTotalCalcAmountFilter=" + encodeURIComponent("" + minTotalCalcAmountFilter) + "&";
        if (maxTotalDetailLineFilter !== undefined)
            url_ += "MaxTotalDetailLineFilter=" + encodeURIComponent("" + maxTotalDetailLineFilter) + "&";
        if (minTotalDetailLineFilter !== undefined)
            url_ += "MinTotalDetailLineFilter=" + encodeURIComponent("" + minTotalDetailLineFilter) + "&";
        if (maxTotalTaxAmountFilter !== undefined)
            url_ += "MaxTotalTaxAmountFilter=" + encodeURIComponent("" + maxTotalTaxAmountFilter) + "&";
        if (minTotalTaxAmountFilter !== undefined)
            url_ += "MinTotalTaxAmountFilter=" + encodeURIComponent("" + minTotalTaxAmountFilter) + "&";
        if (maxUsedCoinFilter !== undefined)
            url_ += "MaxUsedCoinFilter=" + encodeURIComponent("" + maxUsedCoinFilter) + "&";
        if (minUsedCoinFilter !== undefined)
            url_ += "MinUsedCoinFilter=" + encodeURIComponent("" + minUsedCoinFilter) + "&";
        if (maxTotalAmountIssuePointFilter !== undefined)
            url_ += "MaxTotalAmountIssuePointFilter=" + encodeURIComponent("" + maxTotalAmountIssuePointFilter) + "&";
        if (minTotalAmountIssuePointFilter !== undefined)
            url_ += "MinTotalAmountIssuePointFilter=" + encodeURIComponent("" + minTotalAmountIssuePointFilter) + "&";
        if (maxTotalAmountIssueCoinFilter !== undefined)
            url_ += "MaxTotalAmountIssueCoinFilter=" + encodeURIComponent("" + maxTotalAmountIssueCoinFilter) + "&";
        if (minTotalAmountIssueCoinFilter !== undefined)
            url_ += "MinTotalAmountIssueCoinFilter=" + encodeURIComponent("" + minTotalAmountIssueCoinFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetTransactionForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetTransactionForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetTransactionForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetTransactionForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetTransactionForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetTransactionForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getTransactionForEdit(id: number | null | undefined): Observable<GetTransactionForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Transactions/GetTransactionForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetTransactionForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTransactionForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetTransactionForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetTransactionForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetTransactionForEdit(response: HttpResponseBase): Observable<GetTransactionForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetTransactionForEditOutput.fromJS(resultData200) : new GetTransactionForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTransactionForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditTransactionDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Transactions/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Transactions/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param maxActionRuleCoinFilter (optional) 
     * @param minActionRuleCoinFilter (optional) 
     * @param maxActionRulePointFilter (optional) 
     * @param minActionRulePointFilter (optional) 
     * @param actionRuleSettingCodeFilter (optional) 
     * @param approverFilter (optional) 
     * @param maxBaseCoinRatioFilter (optional) 
     * @param minBaseCoinRatioFilter (optional) 
     * @param maxBasePointRatioFilter (optional) 
     * @param minBasePointRatioFilter (optional) 
     * @param baseSettingCodeFilter (optional) 
     * @param maxBusinessTimeFilter (optional) 
     * @param minBusinessTimeFilter (optional) 
     * @param codeFilter (optional) 
     * @param maxCoinFilter (optional) 
     * @param minCoinFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param distributorCodeFilter (optional) 
     * @param maxEventCoinRatioFilter (optional) 
     * @param minEventCoinRatioFilter (optional) 
     * @param maxEventPointRatioFilter (optional) 
     * @param minEventPointRatioFilter (optional) 
     * @param eventSettingCodeFilter (optional) 
     * @param fullChannelTypeCodeFilter (optional) 
     * @param fullMemberTypeCodeFilter (optional) 
     * @param fullRegionCodeFilter (optional) 
     * @param fullSalesRegionCodeFilter (optional) 
     * @param memberCodeFilter (optional) 
     * @param originalOrdersFilter (optional) 
     * @param maxOriginalOrdersTimeFilter (optional) 
     * @param minOriginalOrdersTimeFilter (optional) 
     * @param maxPlusCoinFilter (optional) 
     * @param minPlusCoinFilter (optional) 
     * @param maxPlusPointFilter (optional) 
     * @param minPlusPointFilter (optional) 
     * @param maxPointFilter (optional) 
     * @param minPointFilter (optional) 
     * @param rankCodeFilter (optional) 
     * @param maxRankCoinRatioFilter (optional) 
     * @param minRankCoinRatioFilter (optional) 
     * @param maxRankPointRatioFilter (optional) 
     * @param minRankPointRatioFilter (optional) 
     * @param rankSettingCodeFilter (optional) 
     * @param rankTypeCodeFilter (optional) 
     * @param maxRatioCoinFilter (optional) 
     * @param minRatioCoinFilter (optional) 
     * @param maxRatioPointFilter (optional) 
     * @param minRatioPointFilter (optional) 
     * @param reasonFilter (optional) 
     * @param referralSettingCodeFilter (optional) 
     * @param maxRequestDateFilter (optional) 
     * @param minRequestDateFilter (optional) 
     * @param senioritySettingCodeFilter (optional) 
     * @param sourceFilter (optional) 
     * @param specialSettingCodeFilter (optional) 
     * @param standardMemberCodeFilter (optional) 
     * @param terminalNoFilter (optional) 
     * @param maxTotalAmountBeforeTaxFilter (optional) 
     * @param minTotalAmountBeforeTaxFilter (optional) 
     * @param maxTotalAmountIncludeTaxFilter (optional) 
     * @param minTotalAmountIncludeTaxFilter (optional) 
     * @param maxTotalCalcAmountFilter (optional) 
     * @param minTotalCalcAmountFilter (optional) 
     * @param maxTotalDetailLineFilter (optional) 
     * @param minTotalDetailLineFilter (optional) 
     * @param maxTotalTaxAmountFilter (optional) 
     * @param minTotalTaxAmountFilter (optional) 
     * @param maxUsedCoinFilter (optional) 
     * @param minUsedCoinFilter (optional) 
     * @param maxTotalAmountIssuePointFilter (optional) 
     * @param minTotalAmountIssuePointFilter (optional) 
     * @param maxTotalAmountIssueCoinFilter (optional) 
     * @param minTotalAmountIssueCoinFilter (optional) 
     * @return Success
     */
    getTransactionsToExcel(filter: string | null | undefined, maxActionRuleCoinFilter: number | null | undefined, minActionRuleCoinFilter: number | null | undefined, maxActionRulePointFilter: number | null | undefined, minActionRulePointFilter: number | null | undefined, actionRuleSettingCodeFilter: string | null | undefined, approverFilter: string | null | undefined, maxBaseCoinRatioFilter: number | null | undefined, minBaseCoinRatioFilter: number | null | undefined, maxBasePointRatioFilter: number | null | undefined, minBasePointRatioFilter: number | null | undefined, baseSettingCodeFilter: string | null | undefined, maxBusinessTimeFilter: moment.Moment | null | undefined, minBusinessTimeFilter: moment.Moment | null | undefined, codeFilter: string | null | undefined, maxCoinFilter: number | null | undefined, minCoinFilter: number | null | undefined, descriptionFilter: string | null | undefined, distributorCodeFilter: string | null | undefined, maxEventCoinRatioFilter: number | null | undefined, minEventCoinRatioFilter: number | null | undefined, maxEventPointRatioFilter: number | null | undefined, minEventPointRatioFilter: number | null | undefined, eventSettingCodeFilter: string | null | undefined, fullChannelTypeCodeFilter: string | null | undefined, fullMemberTypeCodeFilter: string | null | undefined, fullRegionCodeFilter: string | null | undefined, fullSalesRegionCodeFilter: string | null | undefined, memberCodeFilter: string | null | undefined, originalOrdersFilter: string | null | undefined, maxOriginalOrdersTimeFilter: moment.Moment | null | undefined, minOriginalOrdersTimeFilter: moment.Moment | null | undefined, maxPlusCoinFilter: number | null | undefined, minPlusCoinFilter: number | null | undefined, maxPlusPointFilter: number | null | undefined, minPlusPointFilter: number | null | undefined, maxPointFilter: number | null | undefined, minPointFilter: number | null | undefined, rankCodeFilter: string | null | undefined, maxRankCoinRatioFilter: number | null | undefined, minRankCoinRatioFilter: number | null | undefined, maxRankPointRatioFilter: number | null | undefined, minRankPointRatioFilter: number | null | undefined, rankSettingCodeFilter: string | null | undefined, rankTypeCodeFilter: string | null | undefined, maxRatioCoinFilter: number | null | undefined, minRatioCoinFilter: number | null | undefined, maxRatioPointFilter: number | null | undefined, minRatioPointFilter: number | null | undefined, reasonFilter: string | null | undefined, referralSettingCodeFilter: string | null | undefined, maxRequestDateFilter: moment.Moment | null | undefined, minRequestDateFilter: moment.Moment | null | undefined, senioritySettingCodeFilter: string | null | undefined, sourceFilter: string | null | undefined, specialSettingCodeFilter: string | null | undefined, standardMemberCodeFilter: string | null | undefined, terminalNoFilter: string | null | undefined, maxTotalAmountBeforeTaxFilter: number | null | undefined, minTotalAmountBeforeTaxFilter: number | null | undefined, maxTotalAmountIncludeTaxFilter: number | null | undefined, minTotalAmountIncludeTaxFilter: number | null | undefined, maxTotalCalcAmountFilter: number | null | undefined, minTotalCalcAmountFilter: number | null | undefined, maxTotalDetailLineFilter: number | null | undefined, minTotalDetailLineFilter: number | null | undefined, maxTotalTaxAmountFilter: number | null | undefined, minTotalTaxAmountFilter: number | null | undefined, maxUsedCoinFilter: number | null | undefined, minUsedCoinFilter: number | null | undefined, maxTotalAmountIssuePointFilter: number | null | undefined, minTotalAmountIssuePointFilter: number | null | undefined, maxTotalAmountIssueCoinFilter: number | null | undefined, minTotalAmountIssueCoinFilter: number | null | undefined): Observable<PointFileDto> {
        let url_ = this.baseUrl + "/api/services/app/Transactions/GetTransactionsToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxActionRuleCoinFilter !== undefined)
            url_ += "MaxActionRuleCoinFilter=" + encodeURIComponent("" + maxActionRuleCoinFilter) + "&";
        if (minActionRuleCoinFilter !== undefined)
            url_ += "MinActionRuleCoinFilter=" + encodeURIComponent("" + minActionRuleCoinFilter) + "&";
        if (maxActionRulePointFilter !== undefined)
            url_ += "MaxActionRulePointFilter=" + encodeURIComponent("" + maxActionRulePointFilter) + "&";
        if (minActionRulePointFilter !== undefined)
            url_ += "MinActionRulePointFilter=" + encodeURIComponent("" + minActionRulePointFilter) + "&";
        if (actionRuleSettingCodeFilter !== undefined)
            url_ += "ActionRuleSettingCodeFilter=" + encodeURIComponent("" + actionRuleSettingCodeFilter) + "&";
        if (approverFilter !== undefined)
            url_ += "ApproverFilter=" + encodeURIComponent("" + approverFilter) + "&";
        if (maxBaseCoinRatioFilter !== undefined)
            url_ += "MaxBaseCoinRatioFilter=" + encodeURIComponent("" + maxBaseCoinRatioFilter) + "&";
        if (minBaseCoinRatioFilter !== undefined)
            url_ += "MinBaseCoinRatioFilter=" + encodeURIComponent("" + minBaseCoinRatioFilter) + "&";
        if (maxBasePointRatioFilter !== undefined)
            url_ += "MaxBasePointRatioFilter=" + encodeURIComponent("" + maxBasePointRatioFilter) + "&";
        if (minBasePointRatioFilter !== undefined)
            url_ += "MinBasePointRatioFilter=" + encodeURIComponent("" + minBasePointRatioFilter) + "&";
        if (baseSettingCodeFilter !== undefined)
            url_ += "BaseSettingCodeFilter=" + encodeURIComponent("" + baseSettingCodeFilter) + "&";
        if (maxBusinessTimeFilter !== undefined)
            url_ += "MaxBusinessTimeFilter=" + encodeURIComponent(maxBusinessTimeFilter ? "" + maxBusinessTimeFilter.toJSON() : "") + "&";
        if (minBusinessTimeFilter !== undefined)
            url_ += "MinBusinessTimeFilter=" + encodeURIComponent(minBusinessTimeFilter ? "" + minBusinessTimeFilter.toJSON() : "") + "&";
        if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&";
        if (maxCoinFilter !== undefined)
            url_ += "MaxCoinFilter=" + encodeURIComponent("" + maxCoinFilter) + "&";
        if (minCoinFilter !== undefined)
            url_ += "MinCoinFilter=" + encodeURIComponent("" + minCoinFilter) + "&";
        if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&";
        if (distributorCodeFilter !== undefined)
            url_ += "DistributorCodeFilter=" + encodeURIComponent("" + distributorCodeFilter) + "&";
        if (maxEventCoinRatioFilter !== undefined)
            url_ += "MaxEventCoinRatioFilter=" + encodeURIComponent("" + maxEventCoinRatioFilter) + "&";
        if (minEventCoinRatioFilter !== undefined)
            url_ += "MinEventCoinRatioFilter=" + encodeURIComponent("" + minEventCoinRatioFilter) + "&";
        if (maxEventPointRatioFilter !== undefined)
            url_ += "MaxEventPointRatioFilter=" + encodeURIComponent("" + maxEventPointRatioFilter) + "&";
        if (minEventPointRatioFilter !== undefined)
            url_ += "MinEventPointRatioFilter=" + encodeURIComponent("" + minEventPointRatioFilter) + "&";
        if (eventSettingCodeFilter !== undefined)
            url_ += "EventSettingCodeFilter=" + encodeURIComponent("" + eventSettingCodeFilter) + "&";
        if (fullChannelTypeCodeFilter !== undefined)
            url_ += "FullChannelTypeCodeFilter=" + encodeURIComponent("" + fullChannelTypeCodeFilter) + "&";
        if (fullMemberTypeCodeFilter !== undefined)
            url_ += "FullMemberTypeCodeFilter=" + encodeURIComponent("" + fullMemberTypeCodeFilter) + "&";
        if (fullRegionCodeFilter !== undefined)
            url_ += "FullRegionCodeFilter=" + encodeURIComponent("" + fullRegionCodeFilter) + "&";
        if (fullSalesRegionCodeFilter !== undefined)
            url_ += "FullSalesRegionCodeFilter=" + encodeURIComponent("" + fullSalesRegionCodeFilter) + "&";
        if (memberCodeFilter !== undefined)
            url_ += "MemberCodeFilter=" + encodeURIComponent("" + memberCodeFilter) + "&";
        if (originalOrdersFilter !== undefined)
            url_ += "OriginalOrdersFilter=" + encodeURIComponent("" + originalOrdersFilter) + "&";
        if (maxOriginalOrdersTimeFilter !== undefined)
            url_ += "MaxOriginalOrdersTimeFilter=" + encodeURIComponent(maxOriginalOrdersTimeFilter ? "" + maxOriginalOrdersTimeFilter.toJSON() : "") + "&";
        if (minOriginalOrdersTimeFilter !== undefined)
            url_ += "MinOriginalOrdersTimeFilter=" + encodeURIComponent(minOriginalOrdersTimeFilter ? "" + minOriginalOrdersTimeFilter.toJSON() : "") + "&";
        if (maxPlusCoinFilter !== undefined)
            url_ += "MaxPlusCoinFilter=" + encodeURIComponent("" + maxPlusCoinFilter) + "&";
        if (minPlusCoinFilter !== undefined)
            url_ += "MinPlusCoinFilter=" + encodeURIComponent("" + minPlusCoinFilter) + "&";
        if (maxPlusPointFilter !== undefined)
            url_ += "MaxPlusPointFilter=" + encodeURIComponent("" + maxPlusPointFilter) + "&";
        if (minPlusPointFilter !== undefined)
            url_ += "MinPlusPointFilter=" + encodeURIComponent("" + minPlusPointFilter) + "&";
        if (maxPointFilter !== undefined)
            url_ += "MaxPointFilter=" + encodeURIComponent("" + maxPointFilter) + "&";
        if (minPointFilter !== undefined)
            url_ += "MinPointFilter=" + encodeURIComponent("" + minPointFilter) + "&";
        if (rankCodeFilter !== undefined)
            url_ += "RankCodeFilter=" + encodeURIComponent("" + rankCodeFilter) + "&";
        if (maxRankCoinRatioFilter !== undefined)
            url_ += "MaxRankCoinRatioFilter=" + encodeURIComponent("" + maxRankCoinRatioFilter) + "&";
        if (minRankCoinRatioFilter !== undefined)
            url_ += "MinRankCoinRatioFilter=" + encodeURIComponent("" + minRankCoinRatioFilter) + "&";
        if (maxRankPointRatioFilter !== undefined)
            url_ += "MaxRankPointRatioFilter=" + encodeURIComponent("" + maxRankPointRatioFilter) + "&";
        if (minRankPointRatioFilter !== undefined)
            url_ += "MinRankPointRatioFilter=" + encodeURIComponent("" + minRankPointRatioFilter) + "&";
        if (rankSettingCodeFilter !== undefined)
            url_ += "RankSettingCodeFilter=" + encodeURIComponent("" + rankSettingCodeFilter) + "&";
        if (rankTypeCodeFilter !== undefined)
            url_ += "RankTypeCodeFilter=" + encodeURIComponent("" + rankTypeCodeFilter) + "&";
        if (maxRatioCoinFilter !== undefined)
            url_ += "MaxRatioCoinFilter=" + encodeURIComponent("" + maxRatioCoinFilter) + "&";
        if (minRatioCoinFilter !== undefined)
            url_ += "MinRatioCoinFilter=" + encodeURIComponent("" + minRatioCoinFilter) + "&";
        if (maxRatioPointFilter !== undefined)
            url_ += "MaxRatioPointFilter=" + encodeURIComponent("" + maxRatioPointFilter) + "&";
        if (minRatioPointFilter !== undefined)
            url_ += "MinRatioPointFilter=" + encodeURIComponent("" + minRatioPointFilter) + "&";
        if (reasonFilter !== undefined)
            url_ += "ReasonFilter=" + encodeURIComponent("" + reasonFilter) + "&";
        if (referralSettingCodeFilter !== undefined)
            url_ += "ReferralSettingCodeFilter=" + encodeURIComponent("" + referralSettingCodeFilter) + "&";
        if (maxRequestDateFilter !== undefined)
            url_ += "MaxRequestDateFilter=" + encodeURIComponent(maxRequestDateFilter ? "" + maxRequestDateFilter.toJSON() : "") + "&";
        if (minRequestDateFilter !== undefined)
            url_ += "MinRequestDateFilter=" + encodeURIComponent(minRequestDateFilter ? "" + minRequestDateFilter.toJSON() : "") + "&";
        if (senioritySettingCodeFilter !== undefined)
            url_ += "SenioritySettingCodeFilter=" + encodeURIComponent("" + senioritySettingCodeFilter) + "&";
        if (sourceFilter !== undefined)
            url_ += "SourceFilter=" + encodeURIComponent("" + sourceFilter) + "&";
        if (specialSettingCodeFilter !== undefined)
            url_ += "SpecialSettingCodeFilter=" + encodeURIComponent("" + specialSettingCodeFilter) + "&";
        if (standardMemberCodeFilter !== undefined)
            url_ += "StandardMemberCodeFilter=" + encodeURIComponent("" + standardMemberCodeFilter) + "&";
        if (terminalNoFilter !== undefined)
            url_ += "TerminalNoFilter=" + encodeURIComponent("" + terminalNoFilter) + "&";
        if (maxTotalAmountBeforeTaxFilter !== undefined)
            url_ += "MaxTotalAmountBeforeTaxFilter=" + encodeURIComponent("" + maxTotalAmountBeforeTaxFilter) + "&";
        if (minTotalAmountBeforeTaxFilter !== undefined)
            url_ += "MinTotalAmountBeforeTaxFilter=" + encodeURIComponent("" + minTotalAmountBeforeTaxFilter) + "&";
        if (maxTotalAmountIncludeTaxFilter !== undefined)
            url_ += "MaxTotalAmountIncludeTaxFilter=" + encodeURIComponent("" + maxTotalAmountIncludeTaxFilter) + "&";
        if (minTotalAmountIncludeTaxFilter !== undefined)
            url_ += "MinTotalAmountIncludeTaxFilter=" + encodeURIComponent("" + minTotalAmountIncludeTaxFilter) + "&";
        if (maxTotalCalcAmountFilter !== undefined)
            url_ += "MaxTotalCalcAmountFilter=" + encodeURIComponent("" + maxTotalCalcAmountFilter) + "&";
        if (minTotalCalcAmountFilter !== undefined)
            url_ += "MinTotalCalcAmountFilter=" + encodeURIComponent("" + minTotalCalcAmountFilter) + "&";
        if (maxTotalDetailLineFilter !== undefined)
            url_ += "MaxTotalDetailLineFilter=" + encodeURIComponent("" + maxTotalDetailLineFilter) + "&";
        if (minTotalDetailLineFilter !== undefined)
            url_ += "MinTotalDetailLineFilter=" + encodeURIComponent("" + minTotalDetailLineFilter) + "&";
        if (maxTotalTaxAmountFilter !== undefined)
            url_ += "MaxTotalTaxAmountFilter=" + encodeURIComponent("" + maxTotalTaxAmountFilter) + "&";
        if (minTotalTaxAmountFilter !== undefined)
            url_ += "MinTotalTaxAmountFilter=" + encodeURIComponent("" + minTotalTaxAmountFilter) + "&";
        if (maxUsedCoinFilter !== undefined)
            url_ += "MaxUsedCoinFilter=" + encodeURIComponent("" + maxUsedCoinFilter) + "&";
        if (minUsedCoinFilter !== undefined)
            url_ += "MinUsedCoinFilter=" + encodeURIComponent("" + minUsedCoinFilter) + "&";
        if (maxTotalAmountIssuePointFilter !== undefined)
            url_ += "MaxTotalAmountIssuePointFilter=" + encodeURIComponent("" + maxTotalAmountIssuePointFilter) + "&";
        if (minTotalAmountIssuePointFilter !== undefined)
            url_ += "MinTotalAmountIssuePointFilter=" + encodeURIComponent("" + minTotalAmountIssuePointFilter) + "&";
        if (maxTotalAmountIssueCoinFilter !== undefined)
            url_ += "MaxTotalAmountIssueCoinFilter=" + encodeURIComponent("" + maxTotalAmountIssueCoinFilter) + "&";
        if (minTotalAmountIssueCoinFilter !== undefined)
            url_ += "MinTotalAmountIssueCoinFilter=" + encodeURIComponent("" + minTotalAmountIssueCoinFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetTransactionsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTransactionsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<PointFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PointFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetTransactionsToExcel(response: HttpResponseBase): Observable<PointFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PointFileDto.fromJS(resultData200) : new PointFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PointFileDto>(<any>null);
    }

    /**
     * @param code (optional) 
     * @return Success
     */
    geTransactionByCodeAsync(code: string | null | undefined): Observable<TransactionDto> {
        let url_ = this.baseUrl + "/api/services/app/Transactions/GeTransactionByCodeAsync?";
        if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGeTransactionByCodeAsync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGeTransactionByCodeAsync(<any>response_);
                } catch (e) {
                    return <Observable<TransactionDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TransactionDto>><any>_observableThrow(response_);
        }));
    }

    protected processGeTransactionByCodeAsync(response: HttpResponseBase): Observable<TransactionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? TransactionDto.fromJS(resultData200) : new TransactionDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TransactionDto>(<any>null);
    }

    /**
     * @param from (optional) 
     * @param to (optional) 
     * @param reasonCode (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getPointHistory(memberCode: string, from: string | null | undefined, to: string | null | undefined, reasonCode: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetPointHistoryForView> {
        let url_ = this.baseUrl + "/api/services/app/Transactions/GetPointHistory?";
        if (memberCode === undefined || memberCode === null)
            throw new Error("The parameter 'memberCode' must be defined and cannot be null.");
        else
            url_ += "MemberCode=" + encodeURIComponent("" + memberCode) + "&";
        if (from !== undefined)
            url_ += "From=" + encodeURIComponent("" + from) + "&";
        if (to !== undefined)
            url_ += "To=" + encodeURIComponent("" + to) + "&";
        if (reasonCode !== undefined)
            url_ += "ReasonCode=" + encodeURIComponent("" + reasonCode) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetPointHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPointHistory(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetPointHistoryForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetPointHistoryForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetPointHistory(response: HttpResponseBase): Observable<PagedResultDtoOfGetPointHistoryForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetPointHistoryForView.fromJS(resultData200) : new PagedResultDtoOfGetPointHistoryForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetPointHistoryForView>(<any>null);
    }

    /**
     * @param profileCode (optional) 
     * @param from (optional) 
     * @param to (optional) 
     * @param reasonCode (optional) 
     * @param memberCode (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getTransactionsHistoryToExcel(profileCode: string | null | undefined, from: moment.Moment | null | undefined, to: moment.Moment | null | undefined, reasonCode: string[] | null | undefined, memberCode: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PointFileDto> {
        let url_ = this.baseUrl + "/api/services/app/Transactions/GetTransactionsHistoryToExcel?";
        if (profileCode !== undefined)
            url_ += "ProfileCode=" + encodeURIComponent("" + profileCode) + "&";
        if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&";
        if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&";
        if (reasonCode !== undefined)
            reasonCode && reasonCode.forEach(item => { url_ += "ReasonCode=" + encodeURIComponent("" + item) + "&"; });
        if (memberCode !== undefined)
            url_ += "MemberCode=" + encodeURIComponent("" + memberCode) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetTransactionsHistoryToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTransactionsHistoryToExcel(<any>response_);
                } catch (e) {
                    return <Observable<PointFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PointFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetTransactionsHistoryToExcel(response: HttpResponseBase): Observable<PointFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PointFileDto.fromJS(resultData200) : new PointFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PointFileDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    transferCoin(input: GetTransactionsTransferCoinInput | null | undefined): Observable<GetTransactionsTransferCoinOutput[]> {
        let url_ = this.baseUrl + "/api/services/app/Transactions/TransferCoin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processTransferCoin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTransferCoin(<any>response_);
                } catch (e) {
                    return <Observable<GetTransactionsTransferCoinOutput[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetTransactionsTransferCoinOutput[]>><any>_observableThrow(response_);
        }));
    }

    protected processTransferCoin(response: HttpResponseBase): Observable<GetTransactionsTransferCoinOutput[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(GetTransactionsTransferCoinOutput.fromJS(item));
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTransactionsTransferCoinOutput[]>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    revokeCoin(input: GetTransactionsRevokeCoinInput | null | undefined): Observable<GetTransactionsRevokeCoinOutput> {
        let url_ = this.baseUrl + "/api/services/app/Transactions/RevokeCoin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processRevokeCoin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRevokeCoin(<any>response_);
                } catch (e) {
                    return <Observable<GetTransactionsRevokeCoinOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetTransactionsRevokeCoinOutput>><any>_observableThrow(response_);
        }));
    }

    protected processRevokeCoin(response: HttpResponseBase): Observable<GetTransactionsRevokeCoinOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetTransactionsRevokeCoinOutput.fromJS(resultData200) : new GetTransactionsRevokeCoinOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTransactionsRevokeCoinOutput>(<any>null);
    }

    /**
     * @param profileCode (optional) 
     * @param from (optional) 
     * @param to (optional) 
     * @param reasonCode (optional) 
     * @param memberCode (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getTransactionPointHistory(profileCode: string | null | undefined, from: moment.Moment | null | undefined, to: moment.Moment | null | undefined, reasonCode: string[] | null | undefined, memberCode: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetTransactionForView> {
        let url_ = this.baseUrl + "/api/services/app/Transactions/GetTransactionPointHistory?";
        if (profileCode !== undefined)
            url_ += "ProfileCode=" + encodeURIComponent("" + profileCode) + "&";
        if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&";
        if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&";
        if (reasonCode !== undefined)
            reasonCode && reasonCode.forEach(item => { url_ += "ReasonCode=" + encodeURIComponent("" + item) + "&"; });
        if (memberCode !== undefined)
            url_ += "MemberCode=" + encodeURIComponent("" + memberCode) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetTransactionPointHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTransactionPointHistory(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetTransactionForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetTransactionForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetTransactionPointHistory(response: HttpResponseBase): Observable<PagedResultDtoOfGetTransactionForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetTransactionForView.fromJS(resultData200) : new PagedResultDtoOfGetTransactionForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetTransactionForView>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEditWithGenCode(input: CreateOrEditTransactionDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Transactions/CreateOrEditWithGenCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEditWithGenCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditWithGenCode(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEditWithGenCode(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param memberCode (optional) 
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param brandCodeFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getTransactionDetailByDay(memberCode: string | null | undefined, fromDate: moment.Moment | null | undefined, toDate: moment.Moment | null | undefined, brandCodeFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfTransactionDetailByDayView> {
        let url_ = this.baseUrl + "/api/services/app/Transactions/GetTransactionDetailByDay?";
        if (memberCode !== undefined)
            url_ += "MemberCode=" + encodeURIComponent("" + memberCode) + "&";
        if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toJSON() : "") + "&";
        if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toJSON() : "") + "&";
        if (brandCodeFilter !== undefined)
            url_ += "BrandCodeFilter=" + encodeURIComponent("" + brandCodeFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetTransactionDetailByDay(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTransactionDetailByDay(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfTransactionDetailByDayView>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfTransactionDetailByDayView>><any>_observableThrow(response_);
        }));
    }

    protected processGetTransactionDetailByDay(response: HttpResponseBase): Observable<PagedResultDtoOfTransactionDetailByDayView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfTransactionDetailByDayView.fromJS(resultData200) : new PagedResultDtoOfTransactionDetailByDayView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfTransactionDetailByDayView>(<any>null);
    }

    /**
     * @param memberCode (optional) 
     * @return Success
     */
    recalculateMemberCoinManual(memberCode: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Transactions/RecalculateMemberCoinManual?";
        if (memberCode !== undefined)
            url_ += "memberCode=" + encodeURIComponent("" + memberCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processRecalculateMemberCoinManual(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRecalculateMemberCoinManual(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processRecalculateMemberCoinManual(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class UiCustomizationSettingsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getUiManagementSettings(): Observable<UiCustomizationSettingsEditDto> {
        let url_ = this.baseUrl + "/api/services/app/UiCustomizationSettings/GetUiManagementSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetUiManagementSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUiManagementSettings(<any>response_);
                } catch (e) {
                    return <Observable<UiCustomizationSettingsEditDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UiCustomizationSettingsEditDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetUiManagementSettings(response: HttpResponseBase): Observable<UiCustomizationSettingsEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? UiCustomizationSettingsEditDto.fromJS(resultData200) : new UiCustomizationSettingsEditDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UiCustomizationSettingsEditDto>(<any>null);
    }

    /**
     * @param settings (optional) 
     * @return Success
     */
    updateUiManagementSettings(settings: UiCustomizationSettingsEditDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UiCustomizationSettings/UpdateUiManagementSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(settings);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateUiManagementSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUiManagementSettings(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateUiManagementSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param settings (optional) 
     * @return Success
     */
    updateDefaultUiManagementSettings(settings: UiCustomizationSettingsEditDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UiCustomizationSettings/UpdateDefaultUiManagementSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(settings);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateDefaultUiManagementSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDefaultUiManagementSettings(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateDefaultUiManagementSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    useSystemDefaultSettings(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UiCustomizationSettings/UseSystemDefaultSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUseSystemDefaultSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUseSystemDefaultSettings(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUseSystemDefaultSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class UnavailableGiftsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param giftCampaignCodeFilter (optional) 
     * @param outletCodeFilter (optional) 
     * @param outletNameFilter (optional) 
     * @param zaloChatIDFilter (optional) 
     * @param maxPublishDateFilter (optional) 
     * @param minPublishDateFilter (optional) 
     * @param maxRequestDateFilter (optional) 
     * @param minRequestDateFilter (optional) 
     * @param giftMasterCodeFilter (optional) 
     * @param giftCodeFilter (optional) 
     * @param statusFilter (optional) 
     * @param transactionIDFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, giftCampaignCodeFilter: string | null | undefined, outletCodeFilter: string | null | undefined, outletNameFilter: string | null | undefined, zaloChatIDFilter: string | null | undefined, maxPublishDateFilter: moment.Moment | null | undefined, minPublishDateFilter: moment.Moment | null | undefined, maxRequestDateFilter: moment.Moment | null | undefined, minRequestDateFilter: moment.Moment | null | undefined, giftMasterCodeFilter: string | null | undefined, giftCodeFilter: string | null | undefined, statusFilter: string | null | undefined, transactionIDFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetUnavailableGiftForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/UnavailableGifts/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (giftCampaignCodeFilter !== undefined)
            url_ += "GiftCampaignCodeFilter=" + encodeURIComponent("" + giftCampaignCodeFilter) + "&";
        if (outletCodeFilter !== undefined)
            url_ += "OutletCodeFilter=" + encodeURIComponent("" + outletCodeFilter) + "&";
        if (outletNameFilter !== undefined)
            url_ += "OutletNameFilter=" + encodeURIComponent("" + outletNameFilter) + "&";
        if (zaloChatIDFilter !== undefined)
            url_ += "ZaloChatIDFilter=" + encodeURIComponent("" + zaloChatIDFilter) + "&";
        if (maxPublishDateFilter !== undefined)
            url_ += "MaxPublishDateFilter=" + encodeURIComponent(maxPublishDateFilter ? "" + maxPublishDateFilter.toJSON() : "") + "&";
        if (minPublishDateFilter !== undefined)
            url_ += "MinPublishDateFilter=" + encodeURIComponent(minPublishDateFilter ? "" + minPublishDateFilter.toJSON() : "") + "&";
        if (maxRequestDateFilter !== undefined)
            url_ += "MaxRequestDateFilter=" + encodeURIComponent(maxRequestDateFilter ? "" + maxRequestDateFilter.toJSON() : "") + "&";
        if (minRequestDateFilter !== undefined)
            url_ += "MinRequestDateFilter=" + encodeURIComponent(minRequestDateFilter ? "" + minRequestDateFilter.toJSON() : "") + "&";
        if (giftMasterCodeFilter !== undefined)
            url_ += "GiftMasterCodeFilter=" + encodeURIComponent("" + giftMasterCodeFilter) + "&";
        if (giftCodeFilter !== undefined)
            url_ += "GiftCodeFilter=" + encodeURIComponent("" + giftCodeFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (transactionIDFilter !== undefined)
            url_ += "TransactionIDFilter=" + encodeURIComponent("" + transactionIDFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetUnavailableGiftForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetUnavailableGiftForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetUnavailableGiftForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetUnavailableGiftForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetUnavailableGiftForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetUnavailableGiftForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getUnavailableGiftForEdit(id: number | null | undefined): Observable<GetUnavailableGiftForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/UnavailableGifts/GetUnavailableGiftForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetUnavailableGiftForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUnavailableGiftForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetUnavailableGiftForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetUnavailableGiftForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetUnavailableGiftForEdit(response: HttpResponseBase): Observable<GetUnavailableGiftForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetUnavailableGiftForEditOutput.fromJS(resultData200) : new GetUnavailableGiftForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetUnavailableGiftForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditUnavailableGiftDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UnavailableGifts/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UnavailableGifts/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param giftCampaignCodeFilter (optional) 
     * @param outletCodeFilter (optional) 
     * @param outletNameFilter (optional) 
     * @param zaloChatIDFilter (optional) 
     * @param maxPublishDateFilter (optional) 
     * @param minPublishDateFilter (optional) 
     * @param maxRequestDateFilter (optional) 
     * @param minRequestDateFilter (optional) 
     * @param giftMasterCodeFilter (optional) 
     * @param giftCodeFilter (optional) 
     * @param statusFilter (optional) 
     * @param transactionIDFilter (optional) 
     * @return Success
     */
    getUnavailableGiftsToExcel(filter: string | null | undefined, giftCampaignCodeFilter: string | null | undefined, outletCodeFilter: string | null | undefined, outletNameFilter: string | null | undefined, zaloChatIDFilter: string | null | undefined, maxPublishDateFilter: moment.Moment | null | undefined, minPublishDateFilter: moment.Moment | null | undefined, maxRequestDateFilter: moment.Moment | null | undefined, minRequestDateFilter: moment.Moment | null | undefined, giftMasterCodeFilter: string | null | undefined, giftCodeFilter: string | null | undefined, statusFilter: string | null | undefined, transactionIDFilter: string | null | undefined): Observable<GiftFileDto> {
        let url_ = this.baseUrl + "/api/services/app/UnavailableGifts/GetUnavailableGiftsToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (giftCampaignCodeFilter !== undefined)
            url_ += "GiftCampaignCodeFilter=" + encodeURIComponent("" + giftCampaignCodeFilter) + "&";
        if (outletCodeFilter !== undefined)
            url_ += "OutletCodeFilter=" + encodeURIComponent("" + outletCodeFilter) + "&";
        if (outletNameFilter !== undefined)
            url_ += "OutletNameFilter=" + encodeURIComponent("" + outletNameFilter) + "&";
        if (zaloChatIDFilter !== undefined)
            url_ += "ZaloChatIDFilter=" + encodeURIComponent("" + zaloChatIDFilter) + "&";
        if (maxPublishDateFilter !== undefined)
            url_ += "MaxPublishDateFilter=" + encodeURIComponent(maxPublishDateFilter ? "" + maxPublishDateFilter.toJSON() : "") + "&";
        if (minPublishDateFilter !== undefined)
            url_ += "MinPublishDateFilter=" + encodeURIComponent(minPublishDateFilter ? "" + minPublishDateFilter.toJSON() : "") + "&";
        if (maxRequestDateFilter !== undefined)
            url_ += "MaxRequestDateFilter=" + encodeURIComponent(maxRequestDateFilter ? "" + maxRequestDateFilter.toJSON() : "") + "&";
        if (minRequestDateFilter !== undefined)
            url_ += "MinRequestDateFilter=" + encodeURIComponent(minRequestDateFilter ? "" + minRequestDateFilter.toJSON() : "") + "&";
        if (giftMasterCodeFilter !== undefined)
            url_ += "GiftMasterCodeFilter=" + encodeURIComponent("" + giftMasterCodeFilter) + "&";
        if (giftCodeFilter !== undefined)
            url_ += "GiftCodeFilter=" + encodeURIComponent("" + giftCodeFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (transactionIDFilter !== undefined)
            url_ += "TransactionIDFilter=" + encodeURIComponent("" + transactionIDFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetUnavailableGiftsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUnavailableGiftsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<GiftFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GiftFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetUnavailableGiftsToExcel(response: HttpResponseBase): Observable<GiftFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GiftFileDto.fromJS(resultData200) : new GiftFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GiftFileDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    sendGotitAsync(input: SendGiftGotitInput | null | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/UnavailableGifts/SendGotitAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSendGotitAsync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendGotitAsync(<any>response_);
                } catch (e) {
                    return <Observable<string[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<string[]>><any>_observableThrow(response_);
        }));
    }

    protected processSendGotitAsync(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(item);
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string[]>(<any>null);
    }
}

@Injectable()
export class UnavailableVouchersServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param voucherCodeFilter (optional) 
     * @param redemptionUserFilter (optional) 
     * @param voucherGroupCodeFilter (optional) 
     * @param maxTerminalIDFilter (optional) 
     * @param minTerminalIDFilter (optional) 
     * @param maxTerminalTimeFilter (optional) 
     * @param minTerminalTimeFilter (optional) 
     * @param maxRedemptionTimeFilter (optional) 
     * @param minRedemptionTimeFilter (optional) 
     * @param maxIssuedTimeFilter (optional) 
     * @param minIssuedTimeFilter (optional) 
     * @param statusFilter (optional) 
     * @param triggerEventFilter (optional) 
     * @param eventFilterFilter (optional) 
     * @param referenceCodeFilter (optional) 
     * @param maxMaxSlipPrintFilter (optional) 
     * @param minMaxSlipPrintFilter (optional) 
     * @param maxCurrentSlipPrintFilter (optional) 
     * @param minCurrentSlipPrintFilter (optional) 
     * @param voucherUserFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, voucherCodeFilter: string | null | undefined, redemptionUserFilter: string | null | undefined, voucherGroupCodeFilter: string | null | undefined, maxTerminalIDFilter: number | null | undefined, minTerminalIDFilter: number | null | undefined, maxTerminalTimeFilter: moment.Moment | null | undefined, minTerminalTimeFilter: moment.Moment | null | undefined, maxRedemptionTimeFilter: moment.Moment | null | undefined, minRedemptionTimeFilter: moment.Moment | null | undefined, maxIssuedTimeFilter: moment.Moment | null | undefined, minIssuedTimeFilter: moment.Moment | null | undefined, statusFilter: string | null | undefined, triggerEventFilter: string | null | undefined, eventFilterFilter: string | null | undefined, referenceCodeFilter: string | null | undefined, maxMaxSlipPrintFilter: number | null | undefined, minMaxSlipPrintFilter: number | null | undefined, maxCurrentSlipPrintFilter: number | null | undefined, minCurrentSlipPrintFilter: number | null | undefined, voucherUserFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetUnavailableVoucherForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/UnavailableVouchers/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (voucherCodeFilter !== undefined)
            url_ += "VoucherCodeFilter=" + encodeURIComponent("" + voucherCodeFilter) + "&";
        if (redemptionUserFilter !== undefined)
            url_ += "RedemptionUserFilter=" + encodeURIComponent("" + redemptionUserFilter) + "&";
        if (voucherGroupCodeFilter !== undefined)
            url_ += "VoucherGroupCodeFilter=" + encodeURIComponent("" + voucherGroupCodeFilter) + "&";
        if (maxTerminalIDFilter !== undefined)
            url_ += "MaxTerminalIDFilter=" + encodeURIComponent("" + maxTerminalIDFilter) + "&";
        if (minTerminalIDFilter !== undefined)
            url_ += "MinTerminalIDFilter=" + encodeURIComponent("" + minTerminalIDFilter) + "&";
        if (maxTerminalTimeFilter !== undefined)
            url_ += "MaxTerminalTimeFilter=" + encodeURIComponent(maxTerminalTimeFilter ? "" + maxTerminalTimeFilter.toJSON() : "") + "&";
        if (minTerminalTimeFilter !== undefined)
            url_ += "MinTerminalTimeFilter=" + encodeURIComponent(minTerminalTimeFilter ? "" + minTerminalTimeFilter.toJSON() : "") + "&";
        if (maxRedemptionTimeFilter !== undefined)
            url_ += "MaxRedemptionTimeFilter=" + encodeURIComponent(maxRedemptionTimeFilter ? "" + maxRedemptionTimeFilter.toJSON() : "") + "&";
        if (minRedemptionTimeFilter !== undefined)
            url_ += "MinRedemptionTimeFilter=" + encodeURIComponent(minRedemptionTimeFilter ? "" + minRedemptionTimeFilter.toJSON() : "") + "&";
        if (maxIssuedTimeFilter !== undefined)
            url_ += "MaxIssuedTimeFilter=" + encodeURIComponent(maxIssuedTimeFilter ? "" + maxIssuedTimeFilter.toJSON() : "") + "&";
        if (minIssuedTimeFilter !== undefined)
            url_ += "MinIssuedTimeFilter=" + encodeURIComponent(minIssuedTimeFilter ? "" + minIssuedTimeFilter.toJSON() : "") + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (triggerEventFilter !== undefined)
            url_ += "TriggerEventFilter=" + encodeURIComponent("" + triggerEventFilter) + "&";
        if (eventFilterFilter !== undefined)
            url_ += "EventFilterFilter=" + encodeURIComponent("" + eventFilterFilter) + "&";
        if (referenceCodeFilter !== undefined)
            url_ += "ReferenceCodeFilter=" + encodeURIComponent("" + referenceCodeFilter) + "&";
        if (maxMaxSlipPrintFilter !== undefined)
            url_ += "MaxMaxSlipPrintFilter=" + encodeURIComponent("" + maxMaxSlipPrintFilter) + "&";
        if (minMaxSlipPrintFilter !== undefined)
            url_ += "MinMaxSlipPrintFilter=" + encodeURIComponent("" + minMaxSlipPrintFilter) + "&";
        if (maxCurrentSlipPrintFilter !== undefined)
            url_ += "MaxCurrentSlipPrintFilter=" + encodeURIComponent("" + maxCurrentSlipPrintFilter) + "&";
        if (minCurrentSlipPrintFilter !== undefined)
            url_ += "MinCurrentSlipPrintFilter=" + encodeURIComponent("" + minCurrentSlipPrintFilter) + "&";
        if (voucherUserFilter !== undefined)
            url_ += "VoucherUserFilter=" + encodeURIComponent("" + voucherUserFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetUnavailableVoucherForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetUnavailableVoucherForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetUnavailableVoucherForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetUnavailableVoucherForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetUnavailableVoucherForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetUnavailableVoucherForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getUnavailableVoucherForEdit(id: number | null | undefined): Observable<GetUnavailableVoucherForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/UnavailableVouchers/GetUnavailableVoucherForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetUnavailableVoucherForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUnavailableVoucherForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetUnavailableVoucherForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetUnavailableVoucherForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetUnavailableVoucherForEdit(response: HttpResponseBase): Observable<GetUnavailableVoucherForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetUnavailableVoucherForEditOutput.fromJS(resultData200) : new GetUnavailableVoucherForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetUnavailableVoucherForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditUnavailableVoucherDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UnavailableVouchers/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UnavailableVouchers/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param voucherCodeFilter (optional) 
     * @param redemptionUserFilter (optional) 
     * @param voucherGroupCodeFilter (optional) 
     * @param maxTerminalIDFilter (optional) 
     * @param minTerminalIDFilter (optional) 
     * @param maxTerminalTimeFilter (optional) 
     * @param minTerminalTimeFilter (optional) 
     * @param maxRedemptionTimeFilter (optional) 
     * @param minRedemptionTimeFilter (optional) 
     * @param maxIssuedTimeFilter (optional) 
     * @param minIssuedTimeFilter (optional) 
     * @param statusFilter (optional) 
     * @param triggerEventFilter (optional) 
     * @param eventFilterFilter (optional) 
     * @param referenceCodeFilter (optional) 
     * @param maxMaxSlipPrintFilter (optional) 
     * @param minMaxSlipPrintFilter (optional) 
     * @param maxCurrentSlipPrintFilter (optional) 
     * @param minCurrentSlipPrintFilter (optional) 
     * @param voucherUserFilter (optional) 
     * @return Success
     */
    getUnavailableVouchersToExcel(filter: string | null | undefined, voucherCodeFilter: string | null | undefined, redemptionUserFilter: string | null | undefined, voucherGroupCodeFilter: string | null | undefined, maxTerminalIDFilter: number | null | undefined, minTerminalIDFilter: number | null | undefined, maxTerminalTimeFilter: moment.Moment | null | undefined, minTerminalTimeFilter: moment.Moment | null | undefined, maxRedemptionTimeFilter: moment.Moment | null | undefined, minRedemptionTimeFilter: moment.Moment | null | undefined, maxIssuedTimeFilter: moment.Moment | null | undefined, minIssuedTimeFilter: moment.Moment | null | undefined, statusFilter: string | null | undefined, triggerEventFilter: string | null | undefined, eventFilterFilter: string | null | undefined, referenceCodeFilter: string | null | undefined, maxMaxSlipPrintFilter: number | null | undefined, minMaxSlipPrintFilter: number | null | undefined, maxCurrentSlipPrintFilter: number | null | undefined, minCurrentSlipPrintFilter: number | null | undefined, voucherUserFilter: string | null | undefined): Observable<RewardsFileDto> {
        let url_ = this.baseUrl + "/api/services/app/UnavailableVouchers/GetUnavailableVouchersToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (voucherCodeFilter !== undefined)
            url_ += "VoucherCodeFilter=" + encodeURIComponent("" + voucherCodeFilter) + "&";
        if (redemptionUserFilter !== undefined)
            url_ += "RedemptionUserFilter=" + encodeURIComponent("" + redemptionUserFilter) + "&";
        if (voucherGroupCodeFilter !== undefined)
            url_ += "VoucherGroupCodeFilter=" + encodeURIComponent("" + voucherGroupCodeFilter) + "&";
        if (maxTerminalIDFilter !== undefined)
            url_ += "MaxTerminalIDFilter=" + encodeURIComponent("" + maxTerminalIDFilter) + "&";
        if (minTerminalIDFilter !== undefined)
            url_ += "MinTerminalIDFilter=" + encodeURIComponent("" + minTerminalIDFilter) + "&";
        if (maxTerminalTimeFilter !== undefined)
            url_ += "MaxTerminalTimeFilter=" + encodeURIComponent(maxTerminalTimeFilter ? "" + maxTerminalTimeFilter.toJSON() : "") + "&";
        if (minTerminalTimeFilter !== undefined)
            url_ += "MinTerminalTimeFilter=" + encodeURIComponent(minTerminalTimeFilter ? "" + minTerminalTimeFilter.toJSON() : "") + "&";
        if (maxRedemptionTimeFilter !== undefined)
            url_ += "MaxRedemptionTimeFilter=" + encodeURIComponent(maxRedemptionTimeFilter ? "" + maxRedemptionTimeFilter.toJSON() : "") + "&";
        if (minRedemptionTimeFilter !== undefined)
            url_ += "MinRedemptionTimeFilter=" + encodeURIComponent(minRedemptionTimeFilter ? "" + minRedemptionTimeFilter.toJSON() : "") + "&";
        if (maxIssuedTimeFilter !== undefined)
            url_ += "MaxIssuedTimeFilter=" + encodeURIComponent(maxIssuedTimeFilter ? "" + maxIssuedTimeFilter.toJSON() : "") + "&";
        if (minIssuedTimeFilter !== undefined)
            url_ += "MinIssuedTimeFilter=" + encodeURIComponent(minIssuedTimeFilter ? "" + minIssuedTimeFilter.toJSON() : "") + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (triggerEventFilter !== undefined)
            url_ += "TriggerEventFilter=" + encodeURIComponent("" + triggerEventFilter) + "&";
        if (eventFilterFilter !== undefined)
            url_ += "EventFilterFilter=" + encodeURIComponent("" + eventFilterFilter) + "&";
        if (referenceCodeFilter !== undefined)
            url_ += "ReferenceCodeFilter=" + encodeURIComponent("" + referenceCodeFilter) + "&";
        if (maxMaxSlipPrintFilter !== undefined)
            url_ += "MaxMaxSlipPrintFilter=" + encodeURIComponent("" + maxMaxSlipPrintFilter) + "&";
        if (minMaxSlipPrintFilter !== undefined)
            url_ += "MinMaxSlipPrintFilter=" + encodeURIComponent("" + minMaxSlipPrintFilter) + "&";
        if (maxCurrentSlipPrintFilter !== undefined)
            url_ += "MaxCurrentSlipPrintFilter=" + encodeURIComponent("" + maxCurrentSlipPrintFilter) + "&";
        if (minCurrentSlipPrintFilter !== undefined)
            url_ += "MinCurrentSlipPrintFilter=" + encodeURIComponent("" + minCurrentSlipPrintFilter) + "&";
        if (voucherUserFilter !== undefined)
            url_ += "VoucherUserFilter=" + encodeURIComponent("" + voucherUserFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetUnavailableVouchersToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUnavailableVouchersToExcel(<any>response_);
                } catch (e) {
                    return <Observable<RewardsFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<RewardsFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetUnavailableVouchersToExcel(response: HttpResponseBase): Observable<RewardsFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? RewardsFileDto.fromJS(resultData200) : new RewardsFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RewardsFileDto>(<any>null);
    }
}

@Injectable()
export class UpdateProfileRequestHistoryServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param memberCodeFilter (optional) 
     * @param nameFilter (optional) 
     * @param phoneFilter (optional) 
     * @param lNGFilter (optional) 
     * @param lATFilter (optional) 
     * @param emailFilter (optional) 
     * @param genderFilter (optional) 
     * @param maxBirthdayFilter (optional) 
     * @param minBirthdayFilter (optional) 
     * @param maxRegistrationDateFilter (optional) 
     * @param minRegistrationDateFilter (optional) 
     * @param pIDFilter (optional) 
     * @param sourceIDFilter (optional) 
     * @param receiveAdsFilter (optional) 
     * @param rankCodeFilter (optional) 
     * @param maxRankValidDateFilter (optional) 
     * @param minRankValidDateFilter (optional) 
     * @param maxCurrentPointFilter (optional) 
     * @param minCurrentPointFilter (optional) 
     * @param nationalityCodeFilter (optional) 
     * @param occupationCodeFilter (optional) 
     * @param hobbyFilter (optional) 
     * @param addressFilter (optional) 
     * @param wardFilter (optional) 
     * @param districtFilter (optional) 
     * @param provinceFilter (optional) 
     * @param countryFilter (optional) 
     * @param statusFilter (optional) 
     * @param maxLastActivityTimeFilter (optional) 
     * @param minLastActivityTimeFilter (optional) 
     * @param maxLastPurchaseTimeFilter (optional) 
     * @param minLastPurchaseTimeFilter (optional) 
     * @param communicationChannelsFilter (optional) 
     * @param communicationLanguageFilter (optional) 
     * @param notesFilter (optional) 
     * @param rankProposeFilter (optional) 
     * @param pINCodeFilter (optional) 
     * @param nameUnSignFilter (optional) 
     * @param avatarFilter (optional) 
     * @param workingPermitFilter (optional) 
     * @param customerCodeFilter (optional) 
     * @param interestOfFilter (optional) 
     * @param isInterestCobrandFilter (optional) 
     * @param memberCardFilter (optional) 
     * @param isForeignerFilter (optional) 
     * @param isSyncedFilter (optional) 
     * @param referralCodeFilter (optional) 
     * @param maxAccumulationPointFilter (optional) 
     * @param minAccumulationPointFilter (optional) 
     * @param outletCodeFilter (optional) 
     * @param zaloNameFilter (optional) 
     * @param distributorCodeFilter (optional) 
     * @param distributorNameFilter (optional) 
     * @param regionCodeFilter (optional) 
     * @param maxTargetRevenueFilter (optional) 
     * @param minTargetRevenueFilter (optional) 
     * @param maxActualRevenueFilter (optional) 
     * @param minActualRevenueFilter (optional) 
     * @param maxBonusFilter (optional) 
     * @param minBonusFilter (optional) 
     * @param maxMissingRevenueFilter (optional) 
     * @param minMissingRevenueFilter (optional) 
     * @param maxRevenueUpdateDateFilter (optional) 
     * @param minRevenueUpdateDateFilter (optional) 
     * @param note1Filter (optional) 
     * @param note2Filter (optional) 
     * @param note3Filter (optional) 
     * @param note4Filter (optional) 
     * @param note5Filter (optional) 
     * @param salesChannelFilter (optional) 
     * @param supervisorCodeFilter (optional) 
     * @param supervisorNameFilter (optional) 
     * @param maxPhoneFirstDateFilter (optional) 
     * @param minPhoneFirstDateFilter (optional) 
     * @param lockUpdatePhoneFilter (optional) 
     * @param browserCodeFilter (optional) 
     * @param deviceNameCodeFilter (optional) 
     * @param typeOfDeviceCodeFilter (optional) 
     * @param salesmanCodeFilter (optional) 
     * @param maxConsumerIDFilter (optional) 
     * @param minConsumerIDFilter (optional) 
     * @param lockUpdateChatIDFilter (optional) 
     * @param maxCurrentCoinFilter (optional) 
     * @param minCurrentCoinFilter (optional) 
     * @param maxPointToKeepRankFilter (optional) 
     * @param minPointToKeepRankFilter (optional) 
     * @param maxPointToNextRankFilter (optional) 
     * @param minPointToNextRankFilter (optional) 
     * @param maxExpiringCoinFilter (optional) 
     * @param minExpiringCoinFilter (optional) 
     * @param maxExpiringCoinDateFilter (optional) 
     * @param minExpiringCoinDateFilter (optional) 
     * @param lockUpdateProfileFilter (optional) 
     * @param requestCode (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, memberCodeFilter: string | null | undefined, nameFilter: string | null | undefined, phoneFilter: string | null | undefined, lNGFilter: string | null | undefined, lATFilter: string | null | undefined, emailFilter: string | null | undefined, genderFilter: string | null | undefined, maxBirthdayFilter: number | null | undefined, minBirthdayFilter: number | null | undefined, maxRegistrationDateFilter: number | null | undefined, minRegistrationDateFilter: number | null | undefined, pIDFilter: string | null | undefined, sourceIDFilter: string | null | undefined, receiveAdsFilter: number | null | undefined, rankCodeFilter: string | null | undefined, maxRankValidDateFilter: number | null | undefined, minRankValidDateFilter: number | null | undefined, maxCurrentPointFilter: number | null | undefined, minCurrentPointFilter: number | null | undefined, nationalityCodeFilter: string | null | undefined, occupationCodeFilter: string | null | undefined, hobbyFilter: string | null | undefined, addressFilter: string | null | undefined, wardFilter: string | null | undefined, districtFilter: string | null | undefined, provinceFilter: string | null | undefined, countryFilter: string | null | undefined, statusFilter: string | null | undefined, maxLastActivityTimeFilter: moment.Moment | null | undefined, minLastActivityTimeFilter: moment.Moment | null | undefined, maxLastPurchaseTimeFilter: moment.Moment | null | undefined, minLastPurchaseTimeFilter: moment.Moment | null | undefined, communicationChannelsFilter: string | null | undefined, communicationLanguageFilter: string | null | undefined, notesFilter: string | null | undefined, rankProposeFilter: string | null | undefined, pINCodeFilter: string | null | undefined, nameUnSignFilter: string | null | undefined, avatarFilter: string | null | undefined, workingPermitFilter: number | null | undefined, customerCodeFilter: string | null | undefined, interestOfFilter: string | null | undefined, isInterestCobrandFilter: number | null | undefined, memberCardFilter: string | null | undefined, isForeignerFilter: number | null | undefined, isSyncedFilter: number | null | undefined, referralCodeFilter: string | null | undefined, maxAccumulationPointFilter: number | null | undefined, minAccumulationPointFilter: number | null | undefined, outletCodeFilter: string | null | undefined, zaloNameFilter: string | null | undefined, distributorCodeFilter: string | null | undefined, distributorNameFilter: string | null | undefined, regionCodeFilter: string | null | undefined, maxTargetRevenueFilter: number | null | undefined, minTargetRevenueFilter: number | null | undefined, maxActualRevenueFilter: number | null | undefined, minActualRevenueFilter: number | null | undefined, maxBonusFilter: number | null | undefined, minBonusFilter: number | null | undefined, maxMissingRevenueFilter: number | null | undefined, minMissingRevenueFilter: number | null | undefined, maxRevenueUpdateDateFilter: number | null | undefined, minRevenueUpdateDateFilter: number | null | undefined, note1Filter: string | null | undefined, note2Filter: string | null | undefined, note3Filter: string | null | undefined, note4Filter: string | null | undefined, note5Filter: string | null | undefined, salesChannelFilter: string | null | undefined, supervisorCodeFilter: string | null | undefined, supervisorNameFilter: string | null | undefined, maxPhoneFirstDateFilter: moment.Moment | null | undefined, minPhoneFirstDateFilter: moment.Moment | null | undefined, lockUpdatePhoneFilter: number | null | undefined, browserCodeFilter: string | null | undefined, deviceNameCodeFilter: string | null | undefined, typeOfDeviceCodeFilter: string | null | undefined, salesmanCodeFilter: string | null | undefined, maxConsumerIDFilter: number | null | undefined, minConsumerIDFilter: number | null | undefined, lockUpdateChatIDFilter: number | null | undefined, maxCurrentCoinFilter: number | null | undefined, minCurrentCoinFilter: number | null | undefined, maxPointToKeepRankFilter: number | null | undefined, minPointToKeepRankFilter: number | null | undefined, maxPointToNextRankFilter: number | null | undefined, minPointToNextRankFilter: number | null | undefined, maxExpiringCoinFilter: number | null | undefined, minExpiringCoinFilter: number | null | undefined, maxExpiringCoinDateFilter: moment.Moment | null | undefined, minExpiringCoinDateFilter: moment.Moment | null | undefined, lockUpdateProfileFilter: number | null | undefined, requestCode: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetUpdateProfileRequestHistoryForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/UpdateProfileRequestHistory/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (memberCodeFilter !== undefined)
            url_ += "MemberCodeFilter=" + encodeURIComponent("" + memberCodeFilter) + "&";
        if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (phoneFilter !== undefined)
            url_ += "PhoneFilter=" + encodeURIComponent("" + phoneFilter) + "&";
        if (lNGFilter !== undefined)
            url_ += "LNGFilter=" + encodeURIComponent("" + lNGFilter) + "&";
        if (lATFilter !== undefined)
            url_ += "LATFilter=" + encodeURIComponent("" + lATFilter) + "&";
        if (emailFilter !== undefined)
            url_ += "EmailFilter=" + encodeURIComponent("" + emailFilter) + "&";
        if (genderFilter !== undefined)
            url_ += "GenderFilter=" + encodeURIComponent("" + genderFilter) + "&";
        if (maxBirthdayFilter !== undefined)
            url_ += "MaxBirthdayFilter=" + encodeURIComponent("" + maxBirthdayFilter) + "&";
        if (minBirthdayFilter !== undefined)
            url_ += "MinBirthdayFilter=" + encodeURIComponent("" + minBirthdayFilter) + "&";
        if (maxRegistrationDateFilter !== undefined)
            url_ += "MaxRegistrationDateFilter=" + encodeURIComponent("" + maxRegistrationDateFilter) + "&";
        if (minRegistrationDateFilter !== undefined)
            url_ += "MinRegistrationDateFilter=" + encodeURIComponent("" + minRegistrationDateFilter) + "&";
        if (pIDFilter !== undefined)
            url_ += "PIDFilter=" + encodeURIComponent("" + pIDFilter) + "&";
        if (sourceIDFilter !== undefined)
            url_ += "SourceIDFilter=" + encodeURIComponent("" + sourceIDFilter) + "&";
        if (receiveAdsFilter !== undefined)
            url_ += "ReceiveAdsFilter=" + encodeURIComponent("" + receiveAdsFilter) + "&";
        if (rankCodeFilter !== undefined)
            url_ += "RankCodeFilter=" + encodeURIComponent("" + rankCodeFilter) + "&";
        if (maxRankValidDateFilter !== undefined)
            url_ += "MaxRankValidDateFilter=" + encodeURIComponent("" + maxRankValidDateFilter) + "&";
        if (minRankValidDateFilter !== undefined)
            url_ += "MinRankValidDateFilter=" + encodeURIComponent("" + minRankValidDateFilter) + "&";
        if (maxCurrentPointFilter !== undefined)
            url_ += "MaxCurrentPointFilter=" + encodeURIComponent("" + maxCurrentPointFilter) + "&";
        if (minCurrentPointFilter !== undefined)
            url_ += "MinCurrentPointFilter=" + encodeURIComponent("" + minCurrentPointFilter) + "&";
        if (nationalityCodeFilter !== undefined)
            url_ += "NationalityCodeFilter=" + encodeURIComponent("" + nationalityCodeFilter) + "&";
        if (occupationCodeFilter !== undefined)
            url_ += "OccupationCodeFilter=" + encodeURIComponent("" + occupationCodeFilter) + "&";
        if (hobbyFilter !== undefined)
            url_ += "HobbyFilter=" + encodeURIComponent("" + hobbyFilter) + "&";
        if (addressFilter !== undefined)
            url_ += "AddressFilter=" + encodeURIComponent("" + addressFilter) + "&";
        if (wardFilter !== undefined)
            url_ += "WardFilter=" + encodeURIComponent("" + wardFilter) + "&";
        if (districtFilter !== undefined)
            url_ += "DistrictFilter=" + encodeURIComponent("" + districtFilter) + "&";
        if (provinceFilter !== undefined)
            url_ += "ProvinceFilter=" + encodeURIComponent("" + provinceFilter) + "&";
        if (countryFilter !== undefined)
            url_ += "CountryFilter=" + encodeURIComponent("" + countryFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (maxLastActivityTimeFilter !== undefined)
            url_ += "MaxLastActivityTimeFilter=" + encodeURIComponent(maxLastActivityTimeFilter ? "" + maxLastActivityTimeFilter.toJSON() : "") + "&";
        if (minLastActivityTimeFilter !== undefined)
            url_ += "MinLastActivityTimeFilter=" + encodeURIComponent(minLastActivityTimeFilter ? "" + minLastActivityTimeFilter.toJSON() : "") + "&";
        if (maxLastPurchaseTimeFilter !== undefined)
            url_ += "MaxLastPurchaseTimeFilter=" + encodeURIComponent(maxLastPurchaseTimeFilter ? "" + maxLastPurchaseTimeFilter.toJSON() : "") + "&";
        if (minLastPurchaseTimeFilter !== undefined)
            url_ += "MinLastPurchaseTimeFilter=" + encodeURIComponent(minLastPurchaseTimeFilter ? "" + minLastPurchaseTimeFilter.toJSON() : "") + "&";
        if (communicationChannelsFilter !== undefined)
            url_ += "CommunicationChannelsFilter=" + encodeURIComponent("" + communicationChannelsFilter) + "&";
        if (communicationLanguageFilter !== undefined)
            url_ += "CommunicationLanguageFilter=" + encodeURIComponent("" + communicationLanguageFilter) + "&";
        if (notesFilter !== undefined)
            url_ += "NotesFilter=" + encodeURIComponent("" + notesFilter) + "&";
        if (rankProposeFilter !== undefined)
            url_ += "RankProposeFilter=" + encodeURIComponent("" + rankProposeFilter) + "&";
        if (pINCodeFilter !== undefined)
            url_ += "PINCodeFilter=" + encodeURIComponent("" + pINCodeFilter) + "&";
        if (nameUnSignFilter !== undefined)
            url_ += "NameUnSignFilter=" + encodeURIComponent("" + nameUnSignFilter) + "&";
        if (avatarFilter !== undefined)
            url_ += "AvatarFilter=" + encodeURIComponent("" + avatarFilter) + "&";
        if (workingPermitFilter !== undefined)
            url_ += "WorkingPermitFilter=" + encodeURIComponent("" + workingPermitFilter) + "&";
        if (customerCodeFilter !== undefined)
            url_ += "CustomerCodeFilter=" + encodeURIComponent("" + customerCodeFilter) + "&";
        if (interestOfFilter !== undefined)
            url_ += "InterestOfFilter=" + encodeURIComponent("" + interestOfFilter) + "&";
        if (isInterestCobrandFilter !== undefined)
            url_ += "isInterestCobrandFilter=" + encodeURIComponent("" + isInterestCobrandFilter) + "&";
        if (memberCardFilter !== undefined)
            url_ += "MemberCardFilter=" + encodeURIComponent("" + memberCardFilter) + "&";
        if (isForeignerFilter !== undefined)
            url_ += "IsForeignerFilter=" + encodeURIComponent("" + isForeignerFilter) + "&";
        if (isSyncedFilter !== undefined)
            url_ += "IsSyncedFilter=" + encodeURIComponent("" + isSyncedFilter) + "&";
        if (referralCodeFilter !== undefined)
            url_ += "ReferralCodeFilter=" + encodeURIComponent("" + referralCodeFilter) + "&";
        if (maxAccumulationPointFilter !== undefined)
            url_ += "MaxAccumulationPointFilter=" + encodeURIComponent("" + maxAccumulationPointFilter) + "&";
        if (minAccumulationPointFilter !== undefined)
            url_ += "MinAccumulationPointFilter=" + encodeURIComponent("" + minAccumulationPointFilter) + "&";
        if (outletCodeFilter !== undefined)
            url_ += "OutletCodeFilter=" + encodeURIComponent("" + outletCodeFilter) + "&";
        if (zaloNameFilter !== undefined)
            url_ += "ZaloNameFilter=" + encodeURIComponent("" + zaloNameFilter) + "&";
        if (distributorCodeFilter !== undefined)
            url_ += "DistributorCodeFilter=" + encodeURIComponent("" + distributorCodeFilter) + "&";
        if (distributorNameFilter !== undefined)
            url_ += "DistributorNameFilter=" + encodeURIComponent("" + distributorNameFilter) + "&";
        if (regionCodeFilter !== undefined)
            url_ += "RegionCodeFilter=" + encodeURIComponent("" + regionCodeFilter) + "&";
        if (maxTargetRevenueFilter !== undefined)
            url_ += "MaxTargetRevenueFilter=" + encodeURIComponent("" + maxTargetRevenueFilter) + "&";
        if (minTargetRevenueFilter !== undefined)
            url_ += "MinTargetRevenueFilter=" + encodeURIComponent("" + minTargetRevenueFilter) + "&";
        if (maxActualRevenueFilter !== undefined)
            url_ += "MaxActualRevenueFilter=" + encodeURIComponent("" + maxActualRevenueFilter) + "&";
        if (minActualRevenueFilter !== undefined)
            url_ += "MinActualRevenueFilter=" + encodeURIComponent("" + minActualRevenueFilter) + "&";
        if (maxBonusFilter !== undefined)
            url_ += "MaxBonusFilter=" + encodeURIComponent("" + maxBonusFilter) + "&";
        if (minBonusFilter !== undefined)
            url_ += "MinBonusFilter=" + encodeURIComponent("" + minBonusFilter) + "&";
        if (maxMissingRevenueFilter !== undefined)
            url_ += "MaxMissingRevenueFilter=" + encodeURIComponent("" + maxMissingRevenueFilter) + "&";
        if (minMissingRevenueFilter !== undefined)
            url_ += "MinMissingRevenueFilter=" + encodeURIComponent("" + minMissingRevenueFilter) + "&";
        if (maxRevenueUpdateDateFilter !== undefined)
            url_ += "MaxRevenueUpdateDateFilter=" + encodeURIComponent("" + maxRevenueUpdateDateFilter) + "&";
        if (minRevenueUpdateDateFilter !== undefined)
            url_ += "MinRevenueUpdateDateFilter=" + encodeURIComponent("" + minRevenueUpdateDateFilter) + "&";
        if (note1Filter !== undefined)
            url_ += "Note1Filter=" + encodeURIComponent("" + note1Filter) + "&";
        if (note2Filter !== undefined)
            url_ += "Note2Filter=" + encodeURIComponent("" + note2Filter) + "&";
        if (note3Filter !== undefined)
            url_ += "Note3Filter=" + encodeURIComponent("" + note3Filter) + "&";
        if (note4Filter !== undefined)
            url_ += "Note4Filter=" + encodeURIComponent("" + note4Filter) + "&";
        if (note5Filter !== undefined)
            url_ += "Note5Filter=" + encodeURIComponent("" + note5Filter) + "&";
        if (salesChannelFilter !== undefined)
            url_ += "SalesChannelFilter=" + encodeURIComponent("" + salesChannelFilter) + "&";
        if (supervisorCodeFilter !== undefined)
            url_ += "SupervisorCodeFilter=" + encodeURIComponent("" + supervisorCodeFilter) + "&";
        if (supervisorNameFilter !== undefined)
            url_ += "SupervisorNameFilter=" + encodeURIComponent("" + supervisorNameFilter) + "&";
        if (maxPhoneFirstDateFilter !== undefined)
            url_ += "MaxPhoneFirstDateFilter=" + encodeURIComponent(maxPhoneFirstDateFilter ? "" + maxPhoneFirstDateFilter.toJSON() : "") + "&";
        if (minPhoneFirstDateFilter !== undefined)
            url_ += "MinPhoneFirstDateFilter=" + encodeURIComponent(minPhoneFirstDateFilter ? "" + minPhoneFirstDateFilter.toJSON() : "") + "&";
        if (lockUpdatePhoneFilter !== undefined)
            url_ += "LockUpdatePhoneFilter=" + encodeURIComponent("" + lockUpdatePhoneFilter) + "&";
        if (browserCodeFilter !== undefined)
            url_ += "BrowserCodeFilter=" + encodeURIComponent("" + browserCodeFilter) + "&";
        if (deviceNameCodeFilter !== undefined)
            url_ += "DeviceNameCodeFilter=" + encodeURIComponent("" + deviceNameCodeFilter) + "&";
        if (typeOfDeviceCodeFilter !== undefined)
            url_ += "TypeOfDeviceCodeFilter=" + encodeURIComponent("" + typeOfDeviceCodeFilter) + "&";
        if (salesmanCodeFilter !== undefined)
            url_ += "SalesmanCodeFilter=" + encodeURIComponent("" + salesmanCodeFilter) + "&";
        if (maxConsumerIDFilter !== undefined)
            url_ += "MaxConsumerIDFilter=" + encodeURIComponent("" + maxConsumerIDFilter) + "&";
        if (minConsumerIDFilter !== undefined)
            url_ += "MinConsumerIDFilter=" + encodeURIComponent("" + minConsumerIDFilter) + "&";
        if (lockUpdateChatIDFilter !== undefined)
            url_ += "LockUpdateChatIDFilter=" + encodeURIComponent("" + lockUpdateChatIDFilter) + "&";
        if (maxCurrentCoinFilter !== undefined)
            url_ += "MaxCurrentCoinFilter=" + encodeURIComponent("" + maxCurrentCoinFilter) + "&";
        if (minCurrentCoinFilter !== undefined)
            url_ += "MinCurrentCoinFilter=" + encodeURIComponent("" + minCurrentCoinFilter) + "&";
        if (maxPointToKeepRankFilter !== undefined)
            url_ += "MaxPointToKeepRankFilter=" + encodeURIComponent("" + maxPointToKeepRankFilter) + "&";
        if (minPointToKeepRankFilter !== undefined)
            url_ += "MinPointToKeepRankFilter=" + encodeURIComponent("" + minPointToKeepRankFilter) + "&";
        if (maxPointToNextRankFilter !== undefined)
            url_ += "MaxPointToNextRankFilter=" + encodeURIComponent("" + maxPointToNextRankFilter) + "&";
        if (minPointToNextRankFilter !== undefined)
            url_ += "MinPointToNextRankFilter=" + encodeURIComponent("" + minPointToNextRankFilter) + "&";
        if (maxExpiringCoinFilter !== undefined)
            url_ += "MaxExpiringCoinFilter=" + encodeURIComponent("" + maxExpiringCoinFilter) + "&";
        if (minExpiringCoinFilter !== undefined)
            url_ += "MinExpiringCoinFilter=" + encodeURIComponent("" + minExpiringCoinFilter) + "&";
        if (maxExpiringCoinDateFilter !== undefined)
            url_ += "MaxExpiringCoinDateFilter=" + encodeURIComponent(maxExpiringCoinDateFilter ? "" + maxExpiringCoinDateFilter.toJSON() : "") + "&";
        if (minExpiringCoinDateFilter !== undefined)
            url_ += "MinExpiringCoinDateFilter=" + encodeURIComponent(minExpiringCoinDateFilter ? "" + minExpiringCoinDateFilter.toJSON() : "") + "&";
        if (lockUpdateProfileFilter !== undefined)
            url_ += "LockUpdateProfileFilter=" + encodeURIComponent("" + lockUpdateProfileFilter) + "&";
        if (requestCode !== undefined)
            url_ += "RequestCode=" + encodeURIComponent("" + requestCode) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetUpdateProfileRequestHistoryForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetUpdateProfileRequestHistoryForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetUpdateProfileRequestHistoryForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetUpdateProfileRequestHistoryForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetUpdateProfileRequestHistoryForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetUpdateProfileRequestHistoryForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getUpdateProfileRequestHistoryForEdit(id: number | null | undefined): Observable<GetUpdateProfileRequestHistoryForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/UpdateProfileRequestHistory/GetUpdateProfileRequestHistoryForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetUpdateProfileRequestHistoryForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUpdateProfileRequestHistoryForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetUpdateProfileRequestHistoryForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetUpdateProfileRequestHistoryForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetUpdateProfileRequestHistoryForEdit(response: HttpResponseBase): Observable<GetUpdateProfileRequestHistoryForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetUpdateProfileRequestHistoryForEditOutput.fromJS(resultData200) : new GetUpdateProfileRequestHistoryForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetUpdateProfileRequestHistoryForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditUpdateProfileRequestHistoryDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UpdateProfileRequestHistory/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UpdateProfileRequestHistory/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param requestCode (optional) 
     * @return Success
     */
    getUpdateProfileForView(requestCode: string | null | undefined): Observable<GetUpdateProfileRequestHistoryForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/UpdateProfileRequestHistory/GetUpdateProfileForView?";
        if (requestCode !== undefined)
            url_ += "requestCode=" + encodeURIComponent("" + requestCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetUpdateProfileForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUpdateProfileForView(<any>response_);
                } catch (e) {
                    return <Observable<GetUpdateProfileRequestHistoryForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetUpdateProfileRequestHistoryForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetUpdateProfileForView(response: HttpResponseBase): Observable<GetUpdateProfileRequestHistoryForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetUpdateProfileRequestHistoryForEditOutput.fromJS(resultData200) : new GetUpdateProfileRequestHistoryForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetUpdateProfileRequestHistoryForEditOutput>(<any>null);
    }
}

@Injectable()
export class UploadedInvoicesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param chatIDFilter (optional) 
     * @param memberCodeFilter (optional) 
     * @param phoneFilter (optional) 
     * @param maxPostingDateFilter (optional) 
     * @param minPostingDateFilter (optional) 
     * @param referenceIDFilter (optional) 
     * @param imageLinkFilter (optional) 
     * @param imageThumbnailLinkFilter (optional) 
     * @param oCRDataFilter (optional) 
     * @param statusFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, chatIDFilter: string | null | undefined, memberCodeFilter: string | null | undefined, phoneFilter: string | null | undefined, maxPostingDateFilter: moment.Moment | null | undefined, minPostingDateFilter: moment.Moment | null | undefined, referenceIDFilter: string | null | undefined, imageLinkFilter: string | null | undefined, imageThumbnailLinkFilter: string | null | undefined, oCRDataFilter: string | null | undefined, statusFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetUploadedInvoiceForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/UploadedInvoices/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (chatIDFilter !== undefined)
            url_ += "ChatIDFilter=" + encodeURIComponent("" + chatIDFilter) + "&";
        if (memberCodeFilter !== undefined)
            url_ += "MemberCodeFilter=" + encodeURIComponent("" + memberCodeFilter) + "&";
        if (phoneFilter !== undefined)
            url_ += "PhoneFilter=" + encodeURIComponent("" + phoneFilter) + "&";
        if (maxPostingDateFilter !== undefined)
            url_ += "MaxPostingDateFilter=" + encodeURIComponent(maxPostingDateFilter ? "" + maxPostingDateFilter.toJSON() : "") + "&";
        if (minPostingDateFilter !== undefined)
            url_ += "MinPostingDateFilter=" + encodeURIComponent(minPostingDateFilter ? "" + minPostingDateFilter.toJSON() : "") + "&";
        if (referenceIDFilter !== undefined)
            url_ += "ReferenceIDFilter=" + encodeURIComponent("" + referenceIDFilter) + "&";
        if (imageLinkFilter !== undefined)
            url_ += "ImageLinkFilter=" + encodeURIComponent("" + imageLinkFilter) + "&";
        if (imageThumbnailLinkFilter !== undefined)
            url_ += "ImageThumbnailLinkFilter=" + encodeURIComponent("" + imageThumbnailLinkFilter) + "&";
        if (oCRDataFilter !== undefined)
            url_ += "OCRDataFilter=" + encodeURIComponent("" + oCRDataFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetUploadedInvoiceForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetUploadedInvoiceForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetUploadedInvoiceForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetUploadedInvoiceForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetUploadedInvoiceForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetUploadedInvoiceForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getUploadedInvoiceForEdit(id: number | null | undefined): Observable<GetUploadedInvoiceForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/UploadedInvoices/GetUploadedInvoiceForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetUploadedInvoiceForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUploadedInvoiceForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetUploadedInvoiceForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetUploadedInvoiceForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetUploadedInvoiceForEdit(response: HttpResponseBase): Observable<GetUploadedInvoiceForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetUploadedInvoiceForEditOutput.fromJS(resultData200) : new GetUploadedInvoiceForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetUploadedInvoiceForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditUploadedInvoiceDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UploadedInvoices/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UploadedInvoices/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param chatIDFilter (optional) 
     * @param memberCodeFilter (optional) 
     * @param phoneFilter (optional) 
     * @param maxPostingDateFilter (optional) 
     * @param minPostingDateFilter (optional) 
     * @param referenceIDFilter (optional) 
     * @param imageLinkFilter (optional) 
     * @param imageThumbnailLinkFilter (optional) 
     * @param oCRDataFilter (optional) 
     * @param statusFilter (optional) 
     * @return Success
     */
    getUploadedInvoicesToExcel(filter: string | null | undefined, chatIDFilter: string | null | undefined, memberCodeFilter: string | null | undefined, phoneFilter: string | null | undefined, maxPostingDateFilter: moment.Moment | null | undefined, minPostingDateFilter: moment.Moment | null | undefined, referenceIDFilter: string | null | undefined, imageLinkFilter: string | null | undefined, imageThumbnailLinkFilter: string | null | undefined, oCRDataFilter: string | null | undefined, statusFilter: string | null | undefined): Observable<SocialShopperFileDto> {
        let url_ = this.baseUrl + "/api/services/app/UploadedInvoices/GetUploadedInvoicesToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (chatIDFilter !== undefined)
            url_ += "ChatIDFilter=" + encodeURIComponent("" + chatIDFilter) + "&";
        if (memberCodeFilter !== undefined)
            url_ += "MemberCodeFilter=" + encodeURIComponent("" + memberCodeFilter) + "&";
        if (phoneFilter !== undefined)
            url_ += "PhoneFilter=" + encodeURIComponent("" + phoneFilter) + "&";
        if (maxPostingDateFilter !== undefined)
            url_ += "MaxPostingDateFilter=" + encodeURIComponent(maxPostingDateFilter ? "" + maxPostingDateFilter.toJSON() : "") + "&";
        if (minPostingDateFilter !== undefined)
            url_ += "MinPostingDateFilter=" + encodeURIComponent(minPostingDateFilter ? "" + minPostingDateFilter.toJSON() : "") + "&";
        if (referenceIDFilter !== undefined)
            url_ += "ReferenceIDFilter=" + encodeURIComponent("" + referenceIDFilter) + "&";
        if (imageLinkFilter !== undefined)
            url_ += "ImageLinkFilter=" + encodeURIComponent("" + imageLinkFilter) + "&";
        if (imageThumbnailLinkFilter !== undefined)
            url_ += "ImageThumbnailLinkFilter=" + encodeURIComponent("" + imageThumbnailLinkFilter) + "&";
        if (oCRDataFilter !== undefined)
            url_ += "OCRDataFilter=" + encodeURIComponent("" + oCRDataFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetUploadedInvoicesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUploadedInvoicesToExcel(<any>response_);
                } catch (e) {
                    return <Observable<SocialShopperFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SocialShopperFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetUploadedInvoicesToExcel(response: HttpResponseBase): Observable<SocialShopperFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? SocialShopperFileDto.fromJS(resultData200) : new SocialShopperFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SocialShopperFileDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    checkStatusGMOService(input: GMODataForEdit | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UploadedInvoices/CheckStatusGMOService";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCheckStatusGMOService(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckStatusGMOService(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCheckStatusGMOService(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    handleEventUserSendSOCode(input: HandleEventUserSendSOCodeDto | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/UploadedInvoices/HandleEventUserSendSOCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processHandleEventUserSendSOCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHandleEventUserSendSOCode(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processHandleEventUserSendSOCode(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }
}

@Injectable()
export class UploadedInvoicesExcelExporterServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param uploadedInvoices (optional) 
     * @return Success
     */
    exportToFile(uploadedInvoices: GetUploadedInvoiceForViewDto[] | null | undefined): Observable<SocialShopperFileDto> {
        let url_ = this.baseUrl + "/api/services/app/UploadedInvoicesExcelExporter/ExportToFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(uploadedInvoices);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processExportToFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportToFile(<any>response_);
                } catch (e) {
                    return <Observable<SocialShopperFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SocialShopperFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processExportToFile(response: HttpResponseBase): Observable<SocialShopperFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? SocialShopperFileDto.fromJS(resultData200) : new SocialShopperFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SocialShopperFileDto>(<any>null);
    }
}

@Injectable()
export class UserServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param permission (optional) 
     * @param role (optional) 
     * @param onlyLockedUsers (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getUsers(filter: string | null | undefined, permission: string | null | undefined, role: number | null | undefined, onlyLockedUsers: boolean | null | undefined, sorting: string | null | undefined, maxResultCount: number | null | undefined, skipCount: number | null | undefined): Observable<PagedResultDtoOfUserListDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUsers?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (permission !== undefined)
            url_ += "Permission=" + encodeURIComponent("" + permission) + "&";
        if (role !== undefined)
            url_ += "Role=" + encodeURIComponent("" + role) + "&";
        if (onlyLockedUsers !== undefined)
            url_ += "OnlyLockedUsers=" + encodeURIComponent("" + onlyLockedUsers) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUsers(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfUserListDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfUserListDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetUsers(response: HttpResponseBase): Observable<PagedResultDtoOfUserListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfUserListDto.fromJS(resultData200) : new PagedResultDtoOfUserListDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfUserListDto>(<any>null);
    }

    /**
     * @return Success
     */
    getUsersToExcel(): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUsersToExcel";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetUsersToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUsersToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetUsersToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getUserForEdit(id: number | null | undefined): Observable<GetUserForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUserForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetUserForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetUserForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetUserForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserForEdit(response: HttpResponseBase): Observable<GetUserForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetUserForEditOutput.fromJS(resultData200) : new GetUserForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetUserForEditOutput>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getUserPermissionsForEdit(id: number | null | undefined): Observable<GetUserPermissionsForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUserPermissionsForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetUserPermissionsForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserPermissionsForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetUserPermissionsForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetUserPermissionsForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserPermissionsForEdit(response: HttpResponseBase): Observable<GetUserPermissionsForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetUserPermissionsForEditOutput.fromJS(resultData200) : new GetUserPermissionsForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetUserPermissionsForEditOutput>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getUserPermissionsViewOnly(id: number | null | undefined): Observable<GetUserPermissionsViewOnlyOutput> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUserPermissionsViewOnly?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetUserPermissionsViewOnly(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserPermissionsViewOnly(<any>response_);
                } catch (e) {
                    return <Observable<GetUserPermissionsViewOnlyOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetUserPermissionsViewOnlyOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserPermissionsViewOnly(response: HttpResponseBase): Observable<GetUserPermissionsViewOnlyOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetUserPermissionsViewOnlyOutput.fromJS(resultData200) : new GetUserPermissionsViewOnlyOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetUserPermissionsViewOnlyOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    resetUserSpecificPermissions(input: EntityDtoOfInt64 | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/ResetUserSpecificPermissions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processResetUserSpecificPermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetUserSpecificPermissions(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processResetUserSpecificPermissions(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    updateUserPermissions(input: UpdateUserPermissionsInput | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/UpdateUserPermissions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateUserPermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUserPermissions(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateUserPermissions(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrUpdateUser(input: CreateOrUpdateUserInput | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/CreateOrUpdateUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrUpdateUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateUser(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrUpdateUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteUser(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/DeleteUser?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteUser(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    unlockUser(input: EntityDtoOfInt64 | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/UnlockUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUnlockUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnlockUser(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUnlockUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param phone (optional) 
     * @param name (optional) 
     * @param surname (optional) 
     * @param userName (optional) 
     * @param password (optional) 
     * @return Success
     */
    createDemoUser(phone: string | null | undefined, name: string | null | undefined, surname: string | null | undefined, userName: string | null | undefined, password: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/CreateDemoUser?";
        if (phone !== undefined)
            url_ += "phone=" + encodeURIComponent("" + phone) + "&";
        if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        if (surname !== undefined)
            url_ += "surname=" + encodeURIComponent("" + surname) + "&";
        if (userName !== undefined)
            url_ += "userName=" + encodeURIComponent("" + userName) + "&";
        if (password !== undefined)
            url_ += "password=" + encodeURIComponent("" + password) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateDemoUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateDemoUser(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateDemoUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class UserLinkServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    linkToUser(input: LinkToUserInput | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UserLink/LinkToUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processLinkToUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLinkToUser(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processLinkToUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getLinkedUsers(maxResultCount: number | null | undefined, skipCount: number | null | undefined, sorting: string | null | undefined): Observable<PagedResultDtoOfLinkedUserDto> {
        let url_ = this.baseUrl + "/api/services/app/UserLink/GetLinkedUsers?";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetLinkedUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLinkedUsers(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfLinkedUserDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfLinkedUserDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetLinkedUsers(response: HttpResponseBase): Observable<PagedResultDtoOfLinkedUserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfLinkedUserDto.fromJS(resultData200) : new PagedResultDtoOfLinkedUserDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfLinkedUserDto>(<any>null);
    }

    /**
     * @return Success
     */
    getRecentlyUsedLinkedUsers(): Observable<ListResultDtoOfLinkedUserDto> {
        let url_ = this.baseUrl + "/api/services/app/UserLink/GetRecentlyUsedLinkedUsers";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetRecentlyUsedLinkedUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRecentlyUsedLinkedUsers(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfLinkedUserDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfLinkedUserDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetRecentlyUsedLinkedUsers(response: HttpResponseBase): Observable<ListResultDtoOfLinkedUserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? ListResultDtoOfLinkedUserDto.fromJS(resultData200) : new ListResultDtoOfLinkedUserDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfLinkedUserDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    unlinkUser(input: UnlinkUserInput | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UserLink/UnlinkUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUnlinkUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnlinkUser(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUnlinkUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class UserLoginServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getRecentUserLoginAttempts(): Observable<ListResultDtoOfUserLoginAttemptDto> {
        let url_ = this.baseUrl + "/api/services/app/UserLogin/GetRecentUserLoginAttempts";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetRecentUserLoginAttempts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRecentUserLoginAttempts(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfUserLoginAttemptDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfUserLoginAttemptDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetRecentUserLoginAttempts(response: HttpResponseBase): Observable<ListResultDtoOfUserLoginAttemptDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? ListResultDtoOfUserLoginAttemptDto.fromJS(resultData200) : new ListResultDtoOfUserLoginAttemptDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfUserLoginAttemptDto>(<any>null);
    }
}

@Injectable()
export class UserLoginsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param memberCodeFilter (optional) 
     * @param nameFilter (optional) 
     * @param phoneFilter (optional) 
     * @param emailFilter (optional) 
     * @param facebookIDFilter (optional) 
     * @param googleIDFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, memberCodeFilter: string | null | undefined, nameFilter: string | null | undefined, phoneFilter: string | null | undefined, emailFilter: string | null | undefined, facebookIDFilter: string | null | undefined, googleIDFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetUserLoginForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/UserLogins/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (memberCodeFilter !== undefined)
            url_ += "MemberCodeFilter=" + encodeURIComponent("" + memberCodeFilter) + "&";
        if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (phoneFilter !== undefined)
            url_ += "PhoneFilter=" + encodeURIComponent("" + phoneFilter) + "&";
        if (emailFilter !== undefined)
            url_ += "EmailFilter=" + encodeURIComponent("" + emailFilter) + "&";
        if (facebookIDFilter !== undefined)
            url_ += "FacebookIDFilter=" + encodeURIComponent("" + facebookIDFilter) + "&";
        if (googleIDFilter !== undefined)
            url_ += "GoogleIDFilter=" + encodeURIComponent("" + googleIDFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetUserLoginForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetUserLoginForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetUserLoginForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetUserLoginForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetUserLoginForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetUserLoginForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getUserLoginForEdit(id: number | null | undefined): Observable<GetUserLoginForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/UserLogins/GetUserLoginForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetUserLoginForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserLoginForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetUserLoginForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetUserLoginForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserLoginForEdit(response: HttpResponseBase): Observable<GetUserLoginForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetUserLoginForEditOutput.fromJS(resultData200) : new GetUserLoginForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetUserLoginForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditUserLoginDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UserLogins/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UserLogins/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param memberCodeFilter (optional) 
     * @param nameFilter (optional) 
     * @param phoneFilter (optional) 
     * @param emailFilter (optional) 
     * @param facebookIDFilter (optional) 
     * @param googleIDFilter (optional) 
     * @return Success
     */
    getUserLoginsToExcel(filter: string | null | undefined, memberCodeFilter: string | null | undefined, nameFilter: string | null | undefined, phoneFilter: string | null | undefined, emailFilter: string | null | undefined, facebookIDFilter: string | null | undefined, googleIDFilter: string | null | undefined): Observable<ConsumerDBFileDto> {
        let url_ = this.baseUrl + "/api/services/app/UserLogins/GetUserLoginsToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (memberCodeFilter !== undefined)
            url_ += "MemberCodeFilter=" + encodeURIComponent("" + memberCodeFilter) + "&";
        if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (phoneFilter !== undefined)
            url_ += "PhoneFilter=" + encodeURIComponent("" + phoneFilter) + "&";
        if (emailFilter !== undefined)
            url_ += "EmailFilter=" + encodeURIComponent("" + emailFilter) + "&";
        if (facebookIDFilter !== undefined)
            url_ += "FacebookIDFilter=" + encodeURIComponent("" + facebookIDFilter) + "&";
        if (googleIDFilter !== undefined)
            url_ += "GoogleIDFilter=" + encodeURIComponent("" + googleIDFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetUserLoginsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserLoginsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<ConsumerDBFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ConsumerDBFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserLoginsToExcel(response: HttpResponseBase): Observable<ConsumerDBFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? ConsumerDBFileDto.fromJS(resultData200) : new ConsumerDBFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ConsumerDBFileDto>(<any>null);
    }
}

@Injectable()
export class UserSessionTrackingsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param userNameFilter (optional) 
     * @param maxStartTimeFilter (optional) 
     * @param minStartTimeFilter (optional) 
     * @param maxEndTimeFilter (optional) 
     * @param minEndTimeFilter (optional) 
     * @param terminalCodeFilter (optional) 
     * @param terminalNameFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, userNameFilter: string | null | undefined, maxStartTimeFilter: moment.Moment | null | undefined, minStartTimeFilter: moment.Moment | null | undefined, maxEndTimeFilter: moment.Moment | null | undefined, minEndTimeFilter: moment.Moment | null | undefined, terminalCodeFilter: string | null | undefined, terminalNameFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetUserSessionTrackingForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/UserSessionTrackings/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (userNameFilter !== undefined)
            url_ += "UserNameFilter=" + encodeURIComponent("" + userNameFilter) + "&";
        if (maxStartTimeFilter !== undefined)
            url_ += "MaxStartTimeFilter=" + encodeURIComponent(maxStartTimeFilter ? "" + maxStartTimeFilter.toJSON() : "") + "&";
        if (minStartTimeFilter !== undefined)
            url_ += "MinStartTimeFilter=" + encodeURIComponent(minStartTimeFilter ? "" + minStartTimeFilter.toJSON() : "") + "&";
        if (maxEndTimeFilter !== undefined)
            url_ += "MaxEndTimeFilter=" + encodeURIComponent(maxEndTimeFilter ? "" + maxEndTimeFilter.toJSON() : "") + "&";
        if (minEndTimeFilter !== undefined)
            url_ += "MinEndTimeFilter=" + encodeURIComponent(minEndTimeFilter ? "" + minEndTimeFilter.toJSON() : "") + "&";
        if (terminalCodeFilter !== undefined)
            url_ += "TerminalCodeFilter=" + encodeURIComponent("" + terminalCodeFilter) + "&";
        if (terminalNameFilter !== undefined)
            url_ += "TerminalNameFilter=" + encodeURIComponent("" + terminalNameFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetUserSessionTrackingForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetUserSessionTrackingForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetUserSessionTrackingForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetUserSessionTrackingForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetUserSessionTrackingForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetUserSessionTrackingForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getUserSessionTrackingForEdit(id: number | null | undefined): Observable<GetUserSessionTrackingForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/UserSessionTrackings/GetUserSessionTrackingForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetUserSessionTrackingForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserSessionTrackingForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetUserSessionTrackingForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetUserSessionTrackingForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserSessionTrackingForEdit(response: HttpResponseBase): Observable<GetUserSessionTrackingForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetUserSessionTrackingForEditOutput.fromJS(resultData200) : new GetUserSessionTrackingForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetUserSessionTrackingForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditUserSessionTrackingDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UserSessionTrackings/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UserSessionTrackings/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param userNameFilter (optional) 
     * @param maxStartTimeFilter (optional) 
     * @param minStartTimeFilter (optional) 
     * @param maxEndTimeFilter (optional) 
     * @param minEndTimeFilter (optional) 
     * @param terminalCodeFilter (optional) 
     * @param terminalNameFilter (optional) 
     * @return Success
     */
    getUserSessionTrackingsToExcel(filter: string | null | undefined, userNameFilter: string | null | undefined, maxStartTimeFilter: moment.Moment | null | undefined, minStartTimeFilter: moment.Moment | null | undefined, maxEndTimeFilter: moment.Moment | null | undefined, minEndTimeFilter: moment.Moment | null | undefined, terminalCodeFilter: string | null | undefined, terminalNameFilter: string | null | undefined): Observable<RewardsFileDto> {
        let url_ = this.baseUrl + "/api/services/app/UserSessionTrackings/GetUserSessionTrackingsToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (userNameFilter !== undefined)
            url_ += "UserNameFilter=" + encodeURIComponent("" + userNameFilter) + "&";
        if (maxStartTimeFilter !== undefined)
            url_ += "MaxStartTimeFilter=" + encodeURIComponent(maxStartTimeFilter ? "" + maxStartTimeFilter.toJSON() : "") + "&";
        if (minStartTimeFilter !== undefined)
            url_ += "MinStartTimeFilter=" + encodeURIComponent(minStartTimeFilter ? "" + minStartTimeFilter.toJSON() : "") + "&";
        if (maxEndTimeFilter !== undefined)
            url_ += "MaxEndTimeFilter=" + encodeURIComponent(maxEndTimeFilter ? "" + maxEndTimeFilter.toJSON() : "") + "&";
        if (minEndTimeFilter !== undefined)
            url_ += "MinEndTimeFilter=" + encodeURIComponent(minEndTimeFilter ? "" + minEndTimeFilter.toJSON() : "") + "&";
        if (terminalCodeFilter !== undefined)
            url_ += "TerminalCodeFilter=" + encodeURIComponent("" + terminalCodeFilter) + "&";
        if (terminalNameFilter !== undefined)
            url_ += "TerminalNameFilter=" + encodeURIComponent("" + terminalNameFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetUserSessionTrackingsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserSessionTrackingsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<RewardsFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<RewardsFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserSessionTrackingsToExcel(response: HttpResponseBase): Observable<RewardsFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? RewardsFileDto.fromJS(resultData200) : new RewardsFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RewardsFileDto>(<any>null);
    }
}

@Injectable()
export class VendorSettingsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param codeFilter (optional) 
     * @param nameFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param aPILinkFilter (optional) 
     * @param tokenKeyFilter (optional) 
     * @param statusFilter (optional) 
     * @param vendorTypeFilter (optional) 
     * @param apiVersionFilter (optional) 
     * @param extraDataFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, codeFilter: string | null | undefined, nameFilter: string | null | undefined, descriptionFilter: string | null | undefined, aPILinkFilter: string | null | undefined, tokenKeyFilter: string | null | undefined, statusFilter: string | null | undefined, vendorTypeFilter: string | null | undefined, apiVersionFilter: string | null | undefined, extraDataFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetVendorSettingForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/VendorSettings/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&";
        if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&";
        if (aPILinkFilter !== undefined)
            url_ += "APILinkFilter=" + encodeURIComponent("" + aPILinkFilter) + "&";
        if (tokenKeyFilter !== undefined)
            url_ += "TokenKeyFilter=" + encodeURIComponent("" + tokenKeyFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (vendorTypeFilter !== undefined)
            url_ += "VendorTypeFilter=" + encodeURIComponent("" + vendorTypeFilter) + "&";
        if (apiVersionFilter !== undefined)
            url_ += "ApiVersionFilter=" + encodeURIComponent("" + apiVersionFilter) + "&";
        if (extraDataFilter !== undefined)
            url_ += "ExtraDataFilter=" + encodeURIComponent("" + extraDataFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetVendorSettingForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetVendorSettingForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetVendorSettingForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetVendorSettingForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetVendorSettingForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetVendorSettingForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getVendorSettingForEdit(id: number | null | undefined): Observable<GetVendorSettingForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/VendorSettings/GetVendorSettingForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetVendorSettingForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVendorSettingForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetVendorSettingForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetVendorSettingForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetVendorSettingForEdit(response: HttpResponseBase): Observable<GetVendorSettingForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetVendorSettingForEditOutput.fromJS(resultData200) : new GetVendorSettingForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetVendorSettingForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditVendorSettingDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/VendorSettings/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/VendorSettings/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param codeFilter (optional) 
     * @param nameFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param aPILinkFilter (optional) 
     * @param tokenKeyFilter (optional) 
     * @param statusFilter (optional) 
     * @param vendorTypeFilter (optional) 
     * @param apiVersionFilter (optional) 
     * @param extraDataFilter (optional) 
     * @return Success
     */
    getVendorSettingsToExcel(filter: string | null | undefined, codeFilter: string | null | undefined, nameFilter: string | null | undefined, descriptionFilter: string | null | undefined, aPILinkFilter: string | null | undefined, tokenKeyFilter: string | null | undefined, statusFilter: string | null | undefined, vendorTypeFilter: string | null | undefined, apiVersionFilter: string | null | undefined, extraDataFilter: string | null | undefined): Observable<PointFileDto> {
        let url_ = this.baseUrl + "/api/services/app/VendorSettings/GetVendorSettingsToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&";
        if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&";
        if (aPILinkFilter !== undefined)
            url_ += "APILinkFilter=" + encodeURIComponent("" + aPILinkFilter) + "&";
        if (tokenKeyFilter !== undefined)
            url_ += "TokenKeyFilter=" + encodeURIComponent("" + tokenKeyFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (vendorTypeFilter !== undefined)
            url_ += "VendorTypeFilter=" + encodeURIComponent("" + vendorTypeFilter) + "&";
        if (apiVersionFilter !== undefined)
            url_ += "ApiVersionFilter=" + encodeURIComponent("" + apiVersionFilter) + "&";
        if (extraDataFilter !== undefined)
            url_ += "ExtraDataFilter=" + encodeURIComponent("" + extraDataFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetVendorSettingsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVendorSettingsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<PointFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PointFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetVendorSettingsToExcel(response: HttpResponseBase): Observable<PointFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PointFileDto.fromJS(resultData200) : new PointFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PointFileDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param codeFilter (optional) 
     * @param nameFilter (optional) 
     * @param descriptionFilter (optional) 
     * @param aPILinkFilter (optional) 
     * @param tokenKeyFilter (optional) 
     * @param statusFilter (optional) 
     * @param vendorTypeFilter (optional) 
     * @param apiVersionFilter (optional) 
     * @param extraDataFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllAsync(filter: string | null | undefined, codeFilter: string | null | undefined, nameFilter: string | null | undefined, descriptionFilter: string | null | undefined, aPILinkFilter: string | null | undefined, tokenKeyFilter: string | null | undefined, statusFilter: string | null | undefined, vendorTypeFilter: string | null | undefined, apiVersionFilter: string | null | undefined, extraDataFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetVendorSettingForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/VendorSettings/GetAllAsync?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&";
        if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (descriptionFilter !== undefined)
            url_ += "DescriptionFilter=" + encodeURIComponent("" + descriptionFilter) + "&";
        if (aPILinkFilter !== undefined)
            url_ += "APILinkFilter=" + encodeURIComponent("" + aPILinkFilter) + "&";
        if (tokenKeyFilter !== undefined)
            url_ += "TokenKeyFilter=" + encodeURIComponent("" + tokenKeyFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (vendorTypeFilter !== undefined)
            url_ += "VendorTypeFilter=" + encodeURIComponent("" + vendorTypeFilter) + "&";
        if (apiVersionFilter !== undefined)
            url_ += "ApiVersionFilter=" + encodeURIComponent("" + apiVersionFilter) + "&";
        if (extraDataFilter !== undefined)
            url_ += "ExtraDataFilter=" + encodeURIComponent("" + extraDataFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllAsync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAsync(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetVendorSettingForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetVendorSettingForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllAsync(response: HttpResponseBase): Observable<PagedResultDtoOfGetVendorSettingForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetVendorSettingForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetVendorSettingForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetVendorSettingForViewDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEditUnsignAsync(input: CreateOrEditVendorSettingDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/VendorSettings/CreateOrEditUnsignAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEditUnsignAsync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditUnsignAsync(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEditUnsignAsync(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param entities (optional) 
     * @return Success
     */
    batchDeleteAsync(entities: VendorSettingDto[] | null | undefined): Observable<MessageResultVendorSetting> {
        let url_ = this.baseUrl + "/api/services/app/VendorSettings/BatchDeleteAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entities);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processBatchDeleteAsync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBatchDeleteAsync(<any>response_);
                } catch (e) {
                    return <Observable<MessageResultVendorSetting>><any>_observableThrow(e);
                }
            } else
                return <Observable<MessageResultVendorSetting>><any>_observableThrow(response_);
        }));
    }

    protected processBatchDeleteAsync(response: HttpResponseBase): Observable<MessageResultVendorSetting> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? MessageResultVendorSetting.fromJS(resultData200) : new MessageResultVendorSetting();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MessageResultVendorSetting>(<any>null);
    }

    /**
     * @return Success
     */
    getGeneratePublisherCode(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/VendorSettings/GetGeneratePublisherCode";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetGeneratePublisherCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGeneratePublisherCode(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetGeneratePublisherCode(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }
}

@Injectable()
export class VideosServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param codeFilter (optional) 
     * @param nameVNFilter (optional) 
     * @param nameENFilter (optional) 
     * @param descriptionVNFilter (optional) 
     * @param descriptionENFilter (optional) 
     * @param videoLinkFilter (optional) 
     * @param avatarFilter (optional) 
     * @param linkAvatarFilter (optional) 
     * @param statusFilter (optional) 
     * @param maxFromDateFilter (optional) 
     * @param minFromDateFilter (optional) 
     * @param maxToDateFilter (optional) 
     * @param minToDateFilter (optional) 
     * @param tagsFilter (optional) 
     * @param isOnAppFilter (optional) 
     * @param maxOrdinalFilter (optional) 
     * @param minOrdinalFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, codeFilter: string | null | undefined, nameVNFilter: string | null | undefined, nameENFilter: string | null | undefined, descriptionVNFilter: string | null | undefined, descriptionENFilter: string | null | undefined, videoLinkFilter: string | null | undefined, avatarFilter: string | null | undefined, linkAvatarFilter: string | null | undefined, statusFilter: string | null | undefined, maxFromDateFilter: moment.Moment | null | undefined, minFromDateFilter: moment.Moment | null | undefined, maxToDateFilter: moment.Moment | null | undefined, minToDateFilter: moment.Moment | null | undefined, tagsFilter: string | null | undefined, isOnAppFilter: number | null | undefined, maxOrdinalFilter: number | null | undefined, minOrdinalFilter: number | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetVideoForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Videos/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&";
        if (nameVNFilter !== undefined)
            url_ += "NameVNFilter=" + encodeURIComponent("" + nameVNFilter) + "&";
        if (nameENFilter !== undefined)
            url_ += "NameENFilter=" + encodeURIComponent("" + nameENFilter) + "&";
        if (descriptionVNFilter !== undefined)
            url_ += "DescriptionVNFilter=" + encodeURIComponent("" + descriptionVNFilter) + "&";
        if (descriptionENFilter !== undefined)
            url_ += "DescriptionENFilter=" + encodeURIComponent("" + descriptionENFilter) + "&";
        if (videoLinkFilter !== undefined)
            url_ += "VideoLinkFilter=" + encodeURIComponent("" + videoLinkFilter) + "&";
        if (avatarFilter !== undefined)
            url_ += "AvatarFilter=" + encodeURIComponent("" + avatarFilter) + "&";
        if (linkAvatarFilter !== undefined)
            url_ += "LinkAvatarFilter=" + encodeURIComponent("" + linkAvatarFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (maxFromDateFilter !== undefined)
            url_ += "MaxFromDateFilter=" + encodeURIComponent(maxFromDateFilter ? "" + maxFromDateFilter.toJSON() : "") + "&";
        if (minFromDateFilter !== undefined)
            url_ += "MinFromDateFilter=" + encodeURIComponent(minFromDateFilter ? "" + minFromDateFilter.toJSON() : "") + "&";
        if (maxToDateFilter !== undefined)
            url_ += "MaxToDateFilter=" + encodeURIComponent(maxToDateFilter ? "" + maxToDateFilter.toJSON() : "") + "&";
        if (minToDateFilter !== undefined)
            url_ += "MinToDateFilter=" + encodeURIComponent(minToDateFilter ? "" + minToDateFilter.toJSON() : "") + "&";
        if (tagsFilter !== undefined)
            url_ += "TagsFilter=" + encodeURIComponent("" + tagsFilter) + "&";
        if (isOnAppFilter !== undefined)
            url_ += "IsOnAppFilter=" + encodeURIComponent("" + isOnAppFilter) + "&";
        if (maxOrdinalFilter !== undefined)
            url_ += "MaxOrdinalFilter=" + encodeURIComponent("" + maxOrdinalFilter) + "&";
        if (minOrdinalFilter !== undefined)
            url_ += "MinOrdinalFilter=" + encodeURIComponent("" + minOrdinalFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetVideoForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetVideoForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetVideoForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetVideoForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetVideoForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetVideoForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getVideoForEdit(id: number | null | undefined): Observable<GetVideoForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Videos/GetVideoForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetVideoForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVideoForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetVideoForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetVideoForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetVideoForEdit(response: HttpResponseBase): Observable<GetVideoForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetVideoForEditOutput.fromJS(resultData200) : new GetVideoForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetVideoForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditVideoDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Videos/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Videos/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param codeFilter (optional) 
     * @param nameVNFilter (optional) 
     * @param nameENFilter (optional) 
     * @param descriptionVNFilter (optional) 
     * @param descriptionENFilter (optional) 
     * @param videoLinkFilter (optional) 
     * @param avatarFilter (optional) 
     * @param linkAvatarFilter (optional) 
     * @param statusFilter (optional) 
     * @param maxFromDateFilter (optional) 
     * @param minFromDateFilter (optional) 
     * @param maxToDateFilter (optional) 
     * @param minToDateFilter (optional) 
     * @param tagsFilter (optional) 
     * @param isOnAppFilter (optional) 
     * @param maxOrdinalFilter (optional) 
     * @param minOrdinalFilter (optional) 
     * @return Success
     */
    getVideosToExcel(filter: string | null | undefined, codeFilter: string | null | undefined, nameVNFilter: string | null | undefined, nameENFilter: string | null | undefined, descriptionVNFilter: string | null | undefined, descriptionENFilter: string | null | undefined, videoLinkFilter: string | null | undefined, avatarFilter: string | null | undefined, linkAvatarFilter: string | null | undefined, statusFilter: string | null | undefined, maxFromDateFilter: moment.Moment | null | undefined, minFromDateFilter: moment.Moment | null | undefined, maxToDateFilter: moment.Moment | null | undefined, minToDateFilter: moment.Moment | null | undefined, tagsFilter: string | null | undefined, isOnAppFilter: number | null | undefined, maxOrdinalFilter: number | null | undefined, minOrdinalFilter: number | null | undefined): Observable<CMSFileDto> {
        let url_ = this.baseUrl + "/api/services/app/Videos/GetVideosToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&";
        if (nameVNFilter !== undefined)
            url_ += "NameVNFilter=" + encodeURIComponent("" + nameVNFilter) + "&";
        if (nameENFilter !== undefined)
            url_ += "NameENFilter=" + encodeURIComponent("" + nameENFilter) + "&";
        if (descriptionVNFilter !== undefined)
            url_ += "DescriptionVNFilter=" + encodeURIComponent("" + descriptionVNFilter) + "&";
        if (descriptionENFilter !== undefined)
            url_ += "DescriptionENFilter=" + encodeURIComponent("" + descriptionENFilter) + "&";
        if (videoLinkFilter !== undefined)
            url_ += "VideoLinkFilter=" + encodeURIComponent("" + videoLinkFilter) + "&";
        if (avatarFilter !== undefined)
            url_ += "AvatarFilter=" + encodeURIComponent("" + avatarFilter) + "&";
        if (linkAvatarFilter !== undefined)
            url_ += "LinkAvatarFilter=" + encodeURIComponent("" + linkAvatarFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (maxFromDateFilter !== undefined)
            url_ += "MaxFromDateFilter=" + encodeURIComponent(maxFromDateFilter ? "" + maxFromDateFilter.toJSON() : "") + "&";
        if (minFromDateFilter !== undefined)
            url_ += "MinFromDateFilter=" + encodeURIComponent(minFromDateFilter ? "" + minFromDateFilter.toJSON() : "") + "&";
        if (maxToDateFilter !== undefined)
            url_ += "MaxToDateFilter=" + encodeURIComponent(maxToDateFilter ? "" + maxToDateFilter.toJSON() : "") + "&";
        if (minToDateFilter !== undefined)
            url_ += "MinToDateFilter=" + encodeURIComponent(minToDateFilter ? "" + minToDateFilter.toJSON() : "") + "&";
        if (tagsFilter !== undefined)
            url_ += "TagsFilter=" + encodeURIComponent("" + tagsFilter) + "&";
        if (isOnAppFilter !== undefined)
            url_ += "IsOnAppFilter=" + encodeURIComponent("" + isOnAppFilter) + "&";
        if (maxOrdinalFilter !== undefined)
            url_ += "MaxOrdinalFilter=" + encodeURIComponent("" + maxOrdinalFilter) + "&";
        if (minOrdinalFilter !== undefined)
            url_ += "MinOrdinalFilter=" + encodeURIComponent("" + minOrdinalFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetVideosToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVideosToExcel(<any>response_);
                } catch (e) {
                    return <Observable<CMSFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CMSFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetVideosToExcel(response: HttpResponseBase): Observable<CMSFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? CMSFileDto.fromJS(resultData200) : new CMSFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CMSFileDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param codeFilter (optional) 
     * @param nameVNFilter (optional) 
     * @param nameENFilter (optional) 
     * @param descriptionVNFilter (optional) 
     * @param descriptionENFilter (optional) 
     * @param videoLinkFilter (optional) 
     * @param avatarFilter (optional) 
     * @param linkAvatarFilter (optional) 
     * @param statusFilter (optional) 
     * @param maxFromDateFilter (optional) 
     * @param minFromDateFilter (optional) 
     * @param maxToDateFilter (optional) 
     * @param minToDateFilter (optional) 
     * @param tagsFilter (optional) 
     * @param isOnAppFilter (optional) 
     * @param maxOrdinalFilter (optional) 
     * @param minOrdinalFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllExtAsync(filter: string | null | undefined, codeFilter: string | null | undefined, nameVNFilter: string | null | undefined, nameENFilter: string | null | undefined, descriptionVNFilter: string | null | undefined, descriptionENFilter: string | null | undefined, videoLinkFilter: string | null | undefined, avatarFilter: string | null | undefined, linkAvatarFilter: string | null | undefined, statusFilter: string | null | undefined, maxFromDateFilter: moment.Moment | null | undefined, minFromDateFilter: moment.Moment | null | undefined, maxToDateFilter: moment.Moment | null | undefined, minToDateFilter: moment.Moment | null | undefined, tagsFilter: string | null | undefined, isOnAppFilter: number | null | undefined, maxOrdinalFilter: number | null | undefined, minOrdinalFilter: number | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetVideoForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Videos/GetAllExtAsync?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (codeFilter !== undefined)
            url_ += "CodeFilter=" + encodeURIComponent("" + codeFilter) + "&";
        if (nameVNFilter !== undefined)
            url_ += "NameVNFilter=" + encodeURIComponent("" + nameVNFilter) + "&";
        if (nameENFilter !== undefined)
            url_ += "NameENFilter=" + encodeURIComponent("" + nameENFilter) + "&";
        if (descriptionVNFilter !== undefined)
            url_ += "DescriptionVNFilter=" + encodeURIComponent("" + descriptionVNFilter) + "&";
        if (descriptionENFilter !== undefined)
            url_ += "DescriptionENFilter=" + encodeURIComponent("" + descriptionENFilter) + "&";
        if (videoLinkFilter !== undefined)
            url_ += "VideoLinkFilter=" + encodeURIComponent("" + videoLinkFilter) + "&";
        if (avatarFilter !== undefined)
            url_ += "AvatarFilter=" + encodeURIComponent("" + avatarFilter) + "&";
        if (linkAvatarFilter !== undefined)
            url_ += "LinkAvatarFilter=" + encodeURIComponent("" + linkAvatarFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (maxFromDateFilter !== undefined)
            url_ += "MaxFromDateFilter=" + encodeURIComponent(maxFromDateFilter ? "" + maxFromDateFilter.toJSON() : "") + "&";
        if (minFromDateFilter !== undefined)
            url_ += "MinFromDateFilter=" + encodeURIComponent(minFromDateFilter ? "" + minFromDateFilter.toJSON() : "") + "&";
        if (maxToDateFilter !== undefined)
            url_ += "MaxToDateFilter=" + encodeURIComponent(maxToDateFilter ? "" + maxToDateFilter.toJSON() : "") + "&";
        if (minToDateFilter !== undefined)
            url_ += "MinToDateFilter=" + encodeURIComponent(minToDateFilter ? "" + minToDateFilter.toJSON() : "") + "&";
        if (tagsFilter !== undefined)
            url_ += "TagsFilter=" + encodeURIComponent("" + tagsFilter) + "&";
        if (isOnAppFilter !== undefined)
            url_ += "IsOnAppFilter=" + encodeURIComponent("" + isOnAppFilter) + "&";
        if (maxOrdinalFilter !== undefined)
            url_ += "MaxOrdinalFilter=" + encodeURIComponent("" + maxOrdinalFilter) + "&";
        if (minOrdinalFilter !== undefined)
            url_ += "MinOrdinalFilter=" + encodeURIComponent("" + minOrdinalFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllExtAsync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllExtAsync(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetVideoForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetVideoForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllExtAsync(response: HttpResponseBase): Observable<PagedResultDtoOfGetVideoForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetVideoForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetVideoForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetVideoForViewDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEditAsync(input: CreateOrEditVideoDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Videos/CreateOrEditAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEditAsync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditAsync(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEditAsync(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param listId (optional) 
     * @return Success
     */
    batchDeleteAsync(listId: DeleteVideoDto | null | undefined): Observable<MessageResultCMS> {
        let url_ = this.baseUrl + "/api/services/app/Videos/BatchDeleteAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listId);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processBatchDeleteAsync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBatchDeleteAsync(<any>response_);
                } catch (e) {
                    return <Observable<MessageResultCMS>><any>_observableThrow(e);
                }
            } else
                return <Observable<MessageResultCMS>><any>_observableThrow(response_);
        }));
    }

    protected processBatchDeleteAsync(response: HttpResponseBase): Observable<MessageResultCMS> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? MessageResultCMS.fromJS(resultData200) : new MessageResultCMS();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MessageResultCMS>(<any>null);
    }

    /**
     * @param memberCodeFilter (optional) 
     * @param isOnAppFilter (optional) 
     * @param statusFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllVideo(memberCodeFilter: string | null | undefined, isOnAppFilter: boolean | null | undefined, statusFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetAllVideosViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Videos/GetAllVideo?";
        if (memberCodeFilter !== undefined)
            url_ += "MemberCodeFilter=" + encodeURIComponent("" + memberCodeFilter) + "&";
        if (isOnAppFilter !== undefined)
            url_ += "IsOnAppFilter=" + encodeURIComponent("" + isOnAppFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllVideo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllVideo(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetAllVideosViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetAllVideosViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllVideo(response: HttpResponseBase): Observable<PagedResultDtoOfGetAllVideosViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetAllVideosViewDto.fromJS(resultData200) : new PagedResultDtoOfGetAllVideosViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetAllVideosViewDto>(<any>null);
    }
}

@Injectable()
export class VisitPlanDetailsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param dIST_CDFilter (optional) 
     * @param sLSMAN_CDFilter (optional) 
     * @param cYCLE_CDFilter (optional) 
     * @param maxVISIT_DTFilter (optional) 
     * @param minVISIT_DTFilter (optional) 
     * @param cUST_CDFilter (optional) 
     * @param maxVISIT_WEEKFilter (optional) 
     * @param minVISIT_WEEKFilter (optional) 
     * @param dUPLICATE_INDFilter (optional) 
     * @param uPLDW_STATUSFilter (optional) 
     * @param maxSVR_UPLDW_DTFilter (optional) 
     * @param minSVR_UPLDW_DTFilter (optional) 
     * @param maxVERSIONFilter (optional) 
     * @param minVERSIONFilter (optional) 
     * @param sYNCOPERATIONFilter (optional) 
     * @param maxSYNCVERSIONFilter (optional) 
     * @param minSYNCVERSIONFilter (optional) 
     * @param sYNCFLAGFilter (optional) 
     * @param maxROUTE_CUST_SEQFilter (optional) 
     * @param minROUTE_CUST_SEQFilter (optional) 
     * @param maxACTUAL_SEQFilter (optional) 
     * @param minACTUAL_SEQFilter (optional) 
     * @param rS_INDFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, dIST_CDFilter: string | null | undefined, sLSMAN_CDFilter: string | null | undefined, cYCLE_CDFilter: string | null | undefined, maxVISIT_DTFilter: moment.Moment | null | undefined, minVISIT_DTFilter: moment.Moment | null | undefined, cUST_CDFilter: string | null | undefined, maxVISIT_WEEKFilter: number | null | undefined, minVISIT_WEEKFilter: number | null | undefined, dUPLICATE_INDFilter: string | null | undefined, uPLDW_STATUSFilter: string | null | undefined, maxSVR_UPLDW_DTFilter: moment.Moment | null | undefined, minSVR_UPLDW_DTFilter: moment.Moment | null | undefined, maxVERSIONFilter: number | null | undefined, minVERSIONFilter: number | null | undefined, sYNCOPERATIONFilter: string | null | undefined, maxSYNCVERSIONFilter: moment.Moment | null | undefined, minSYNCVERSIONFilter: moment.Moment | null | undefined, sYNCFLAGFilter: string | null | undefined, maxROUTE_CUST_SEQFilter: number | null | undefined, minROUTE_CUST_SEQFilter: number | null | undefined, maxACTUAL_SEQFilter: number | null | undefined, minACTUAL_SEQFilter: number | null | undefined, rS_INDFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetVisitPlanDetailForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/VisitPlanDetails/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (dIST_CDFilter !== undefined)
            url_ += "DIST_CDFilter=" + encodeURIComponent("" + dIST_CDFilter) + "&";
        if (sLSMAN_CDFilter !== undefined)
            url_ += "SLSMAN_CDFilter=" + encodeURIComponent("" + sLSMAN_CDFilter) + "&";
        if (cYCLE_CDFilter !== undefined)
            url_ += "CYCLE_CDFilter=" + encodeURIComponent("" + cYCLE_CDFilter) + "&";
        if (maxVISIT_DTFilter !== undefined)
            url_ += "MaxVISIT_DTFilter=" + encodeURIComponent(maxVISIT_DTFilter ? "" + maxVISIT_DTFilter.toJSON() : "") + "&";
        if (minVISIT_DTFilter !== undefined)
            url_ += "MinVISIT_DTFilter=" + encodeURIComponent(minVISIT_DTFilter ? "" + minVISIT_DTFilter.toJSON() : "") + "&";
        if (cUST_CDFilter !== undefined)
            url_ += "CUST_CDFilter=" + encodeURIComponent("" + cUST_CDFilter) + "&";
        if (maxVISIT_WEEKFilter !== undefined)
            url_ += "MaxVISIT_WEEKFilter=" + encodeURIComponent("" + maxVISIT_WEEKFilter) + "&";
        if (minVISIT_WEEKFilter !== undefined)
            url_ += "MinVISIT_WEEKFilter=" + encodeURIComponent("" + minVISIT_WEEKFilter) + "&";
        if (dUPLICATE_INDFilter !== undefined)
            url_ += "DUPLICATE_INDFilter=" + encodeURIComponent("" + dUPLICATE_INDFilter) + "&";
        if (uPLDW_STATUSFilter !== undefined)
            url_ += "UPLDW_STATUSFilter=" + encodeURIComponent("" + uPLDW_STATUSFilter) + "&";
        if (maxSVR_UPLDW_DTFilter !== undefined)
            url_ += "MaxSVR_UPLDW_DTFilter=" + encodeURIComponent(maxSVR_UPLDW_DTFilter ? "" + maxSVR_UPLDW_DTFilter.toJSON() : "") + "&";
        if (minSVR_UPLDW_DTFilter !== undefined)
            url_ += "MinSVR_UPLDW_DTFilter=" + encodeURIComponent(minSVR_UPLDW_DTFilter ? "" + minSVR_UPLDW_DTFilter.toJSON() : "") + "&";
        if (maxVERSIONFilter !== undefined)
            url_ += "MaxVERSIONFilter=" + encodeURIComponent("" + maxVERSIONFilter) + "&";
        if (minVERSIONFilter !== undefined)
            url_ += "MinVERSIONFilter=" + encodeURIComponent("" + minVERSIONFilter) + "&";
        if (sYNCOPERATIONFilter !== undefined)
            url_ += "SYNCOPERATIONFilter=" + encodeURIComponent("" + sYNCOPERATIONFilter) + "&";
        if (maxSYNCVERSIONFilter !== undefined)
            url_ += "MaxSYNCVERSIONFilter=" + encodeURIComponent(maxSYNCVERSIONFilter ? "" + maxSYNCVERSIONFilter.toJSON() : "") + "&";
        if (minSYNCVERSIONFilter !== undefined)
            url_ += "MinSYNCVERSIONFilter=" + encodeURIComponent(minSYNCVERSIONFilter ? "" + minSYNCVERSIONFilter.toJSON() : "") + "&";
        if (sYNCFLAGFilter !== undefined)
            url_ += "SYNCFLAGFilter=" + encodeURIComponent("" + sYNCFLAGFilter) + "&";
        if (maxROUTE_CUST_SEQFilter !== undefined)
            url_ += "MaxROUTE_CUST_SEQFilter=" + encodeURIComponent("" + maxROUTE_CUST_SEQFilter) + "&";
        if (minROUTE_CUST_SEQFilter !== undefined)
            url_ += "MinROUTE_CUST_SEQFilter=" + encodeURIComponent("" + minROUTE_CUST_SEQFilter) + "&";
        if (maxACTUAL_SEQFilter !== undefined)
            url_ += "MaxACTUAL_SEQFilter=" + encodeURIComponent("" + maxACTUAL_SEQFilter) + "&";
        if (minACTUAL_SEQFilter !== undefined)
            url_ += "MinACTUAL_SEQFilter=" + encodeURIComponent("" + minACTUAL_SEQFilter) + "&";
        if (rS_INDFilter !== undefined)
            url_ += "RS_INDFilter=" + encodeURIComponent("" + rS_INDFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetVisitPlanDetailForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetVisitPlanDetailForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetVisitPlanDetailForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetVisitPlanDetailForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetVisitPlanDetailForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetVisitPlanDetailForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getVisitPlanDetailForEdit(id: number | null | undefined): Observable<GetVisitPlanDetailForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/VisitPlanDetails/GetVisitPlanDetailForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetVisitPlanDetailForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVisitPlanDetailForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetVisitPlanDetailForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetVisitPlanDetailForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetVisitPlanDetailForEdit(response: HttpResponseBase): Observable<GetVisitPlanDetailForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetVisitPlanDetailForEditOutput.fromJS(resultData200) : new GetVisitPlanDetailForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetVisitPlanDetailForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditVisitPlanDetailDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/VisitPlanDetails/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/VisitPlanDetails/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class VoucherBudgetsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param voucherGroupCodeFilter (optional) 
     * @param voucherGroupNameFilter (optional) 
     * @param maxMaxRedeemQuantityFilter (optional) 
     * @param minMaxRedeemQuantityFilter (optional) 
     * @param maxMaxGrantQuantityFilter (optional) 
     * @param minMaxGrantQuantityFilter (optional) 
     * @param maxGrantedQuantityFilter (optional) 
     * @param minGrantedQuantityFilter (optional) 
     * @param maxRemainGrantQuantityFilter (optional) 
     * @param minRemainGrantQuantityFilter (optional) 
     * @param maxRedeemedQuantityFilter (optional) 
     * @param minRedeemedQuantityFilter (optional) 
     * @param maxRemainRedeemQuantityFilter (optional) 
     * @param minRemainRedeemQuantityFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, voucherGroupCodeFilter: string | null | undefined, voucherGroupNameFilter: string | null | undefined, maxMaxRedeemQuantityFilter: number | null | undefined, minMaxRedeemQuantityFilter: number | null | undefined, maxMaxGrantQuantityFilter: number | null | undefined, minMaxGrantQuantityFilter: number | null | undefined, maxGrantedQuantityFilter: number | null | undefined, minGrantedQuantityFilter: number | null | undefined, maxRemainGrantQuantityFilter: number | null | undefined, minRemainGrantQuantityFilter: number | null | undefined, maxRedeemedQuantityFilter: number | null | undefined, minRedeemedQuantityFilter: number | null | undefined, maxRemainRedeemQuantityFilter: number | null | undefined, minRemainRedeemQuantityFilter: number | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetVoucherBudgetForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/VoucherBudgets/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (voucherGroupCodeFilter !== undefined)
            url_ += "VoucherGroupCodeFilter=" + encodeURIComponent("" + voucherGroupCodeFilter) + "&";
        if (voucherGroupNameFilter !== undefined)
            url_ += "VoucherGroupNameFilter=" + encodeURIComponent("" + voucherGroupNameFilter) + "&";
        if (maxMaxRedeemQuantityFilter !== undefined)
            url_ += "MaxMaxRedeemQuantityFilter=" + encodeURIComponent("" + maxMaxRedeemQuantityFilter) + "&";
        if (minMaxRedeemQuantityFilter !== undefined)
            url_ += "MinMaxRedeemQuantityFilter=" + encodeURIComponent("" + minMaxRedeemQuantityFilter) + "&";
        if (maxMaxGrantQuantityFilter !== undefined)
            url_ += "MaxMaxGrantQuantityFilter=" + encodeURIComponent("" + maxMaxGrantQuantityFilter) + "&";
        if (minMaxGrantQuantityFilter !== undefined)
            url_ += "MinMaxGrantQuantityFilter=" + encodeURIComponent("" + minMaxGrantQuantityFilter) + "&";
        if (maxGrantedQuantityFilter !== undefined)
            url_ += "MaxGrantedQuantityFilter=" + encodeURIComponent("" + maxGrantedQuantityFilter) + "&";
        if (minGrantedQuantityFilter !== undefined)
            url_ += "MinGrantedQuantityFilter=" + encodeURIComponent("" + minGrantedQuantityFilter) + "&";
        if (maxRemainGrantQuantityFilter !== undefined)
            url_ += "MaxRemainGrantQuantityFilter=" + encodeURIComponent("" + maxRemainGrantQuantityFilter) + "&";
        if (minRemainGrantQuantityFilter !== undefined)
            url_ += "MinRemainGrantQuantityFilter=" + encodeURIComponent("" + minRemainGrantQuantityFilter) + "&";
        if (maxRedeemedQuantityFilter !== undefined)
            url_ += "MaxRedeemedQuantityFilter=" + encodeURIComponent("" + maxRedeemedQuantityFilter) + "&";
        if (minRedeemedQuantityFilter !== undefined)
            url_ += "MinRedeemedQuantityFilter=" + encodeURIComponent("" + minRedeemedQuantityFilter) + "&";
        if (maxRemainRedeemQuantityFilter !== undefined)
            url_ += "MaxRemainRedeemQuantityFilter=" + encodeURIComponent("" + maxRemainRedeemQuantityFilter) + "&";
        if (minRemainRedeemQuantityFilter !== undefined)
            url_ += "MinRemainRedeemQuantityFilter=" + encodeURIComponent("" + minRemainRedeemQuantityFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetVoucherBudgetForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetVoucherBudgetForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetVoucherBudgetForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetVoucherBudgetForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetVoucherBudgetForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetVoucherBudgetForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getVoucherBudgetForEdit(id: number | null | undefined): Observable<GetVoucherBudgetForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/VoucherBudgets/GetVoucherBudgetForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetVoucherBudgetForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVoucherBudgetForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetVoucherBudgetForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetVoucherBudgetForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetVoucherBudgetForEdit(response: HttpResponseBase): Observable<GetVoucherBudgetForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetVoucherBudgetForEditOutput.fromJS(resultData200) : new GetVoucherBudgetForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetVoucherBudgetForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditVoucherBudgetDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/VoucherBudgets/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/VoucherBudgets/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param voucherGroupCodeFilter (optional) 
     * @param voucherGroupNameFilter (optional) 
     * @param maxMaxRedeemQuantityFilter (optional) 
     * @param minMaxRedeemQuantityFilter (optional) 
     * @param maxMaxGrantQuantityFilter (optional) 
     * @param minMaxGrantQuantityFilter (optional) 
     * @param maxGrantedQuantityFilter (optional) 
     * @param minGrantedQuantityFilter (optional) 
     * @param maxRemainGrantQuantityFilter (optional) 
     * @param minRemainGrantQuantityFilter (optional) 
     * @param maxRedeemedQuantityFilter (optional) 
     * @param minRedeemedQuantityFilter (optional) 
     * @param maxRemainRedeemQuantityFilter (optional) 
     * @param minRemainRedeemQuantityFilter (optional) 
     * @return Success
     */
    getVoucherBudgetsToExcel(filter: string | null | undefined, voucherGroupCodeFilter: string | null | undefined, voucherGroupNameFilter: string | null | undefined, maxMaxRedeemQuantityFilter: number | null | undefined, minMaxRedeemQuantityFilter: number | null | undefined, maxMaxGrantQuantityFilter: number | null | undefined, minMaxGrantQuantityFilter: number | null | undefined, maxGrantedQuantityFilter: number | null | undefined, minGrantedQuantityFilter: number | null | undefined, maxRemainGrantQuantityFilter: number | null | undefined, minRemainGrantQuantityFilter: number | null | undefined, maxRedeemedQuantityFilter: number | null | undefined, minRedeemedQuantityFilter: number | null | undefined, maxRemainRedeemQuantityFilter: number | null | undefined, minRemainRedeemQuantityFilter: number | null | undefined): Observable<RewardsFileDto> {
        let url_ = this.baseUrl + "/api/services/app/VoucherBudgets/GetVoucherBudgetsToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (voucherGroupCodeFilter !== undefined)
            url_ += "VoucherGroupCodeFilter=" + encodeURIComponent("" + voucherGroupCodeFilter) + "&";
        if (voucherGroupNameFilter !== undefined)
            url_ += "VoucherGroupNameFilter=" + encodeURIComponent("" + voucherGroupNameFilter) + "&";
        if (maxMaxRedeemQuantityFilter !== undefined)
            url_ += "MaxMaxRedeemQuantityFilter=" + encodeURIComponent("" + maxMaxRedeemQuantityFilter) + "&";
        if (minMaxRedeemQuantityFilter !== undefined)
            url_ += "MinMaxRedeemQuantityFilter=" + encodeURIComponent("" + minMaxRedeemQuantityFilter) + "&";
        if (maxMaxGrantQuantityFilter !== undefined)
            url_ += "MaxMaxGrantQuantityFilter=" + encodeURIComponent("" + maxMaxGrantQuantityFilter) + "&";
        if (minMaxGrantQuantityFilter !== undefined)
            url_ += "MinMaxGrantQuantityFilter=" + encodeURIComponent("" + minMaxGrantQuantityFilter) + "&";
        if (maxGrantedQuantityFilter !== undefined)
            url_ += "MaxGrantedQuantityFilter=" + encodeURIComponent("" + maxGrantedQuantityFilter) + "&";
        if (minGrantedQuantityFilter !== undefined)
            url_ += "MinGrantedQuantityFilter=" + encodeURIComponent("" + minGrantedQuantityFilter) + "&";
        if (maxRemainGrantQuantityFilter !== undefined)
            url_ += "MaxRemainGrantQuantityFilter=" + encodeURIComponent("" + maxRemainGrantQuantityFilter) + "&";
        if (minRemainGrantQuantityFilter !== undefined)
            url_ += "MinRemainGrantQuantityFilter=" + encodeURIComponent("" + minRemainGrantQuantityFilter) + "&";
        if (maxRedeemedQuantityFilter !== undefined)
            url_ += "MaxRedeemedQuantityFilter=" + encodeURIComponent("" + maxRedeemedQuantityFilter) + "&";
        if (minRedeemedQuantityFilter !== undefined)
            url_ += "MinRedeemedQuantityFilter=" + encodeURIComponent("" + minRedeemedQuantityFilter) + "&";
        if (maxRemainRedeemQuantityFilter !== undefined)
            url_ += "MaxRemainRedeemQuantityFilter=" + encodeURIComponent("" + maxRemainRedeemQuantityFilter) + "&";
        if (minRemainRedeemQuantityFilter !== undefined)
            url_ += "MinRemainRedeemQuantityFilter=" + encodeURIComponent("" + minRemainRedeemQuantityFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetVoucherBudgetsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVoucherBudgetsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<RewardsFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<RewardsFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetVoucherBudgetsToExcel(response: HttpResponseBase): Observable<RewardsFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? RewardsFileDto.fromJS(resultData200) : new RewardsFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RewardsFileDto>(<any>null);
    }
}

@Injectable()
export class VoucherGroupsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param voucherGroupCodeFilter (optional) 
     * @param voucherGroupNameFilter (optional) 
     * @param publisherCodeFilter (optional) 
     * @param maxPointPriceFilter (optional) 
     * @param minPointPriceFilter (optional) 
     * @param maxCurrencyPriceFilter (optional) 
     * @param minCurrencyPriceFilter (optional) 
     * @param applyForFilter (optional) 
     * @param titleVNFilter (optional) 
     * @param titleENFilter (optional) 
     * @param descriptionVNFilter (optional) 
     * @param descriptionENFilter (optional) 
     * @param imageLinkFilter (optional) 
     * @param templateFilter (optional) 
     * @param maxGrantStartTimeFilter (optional) 
     * @param minGrantStartTimeFilter (optional) 
     * @param maxGrantEndTimeFilter (optional) 
     * @param minGrantEndTimeFilter (optional) 
     * @param billCalculationTypeFilter (optional) 
     * @param maxBillTotalFilter (optional) 
     * @param minBillTotalFilter (optional) 
     * @param grantApplyTypeFilter (optional) 
     * @param grantAppliedLocationFilter (optional) 
     * @param grantAppliedStoreFilter (optional) 
     * @param grantAppliedProdLV1Filter (optional) 
     * @param grantAppliedProdLV2Filter (optional) 
     * @param grantAppliedProdLV3Filter (optional) 
     * @param grantAppliedProdLV4Filter (optional) 
     * @param grantAppliedProdLV5Filter (optional) 
     * @param grantAppliedProductFilter (optional) 
     * @param redemptionApplyTypeFilter (optional) 
     * @param redemptionApplyLocationFilter (optional) 
     * @param redemptionApplyStoreFilter (optional) 
     * @param redemptionAppliedProdLV1Filter (optional) 
     * @param redemptionAppliedProdLV2Filter (optional) 
     * @param redemptionAppliedProdLV3Filter (optional) 
     * @param redemptionAppliedProdLV4Filter (optional) 
     * @param redemptionAppliedProdLV5Filter (optional) 
     * @param redemptionAppliedProductFilter (optional) 
     * @param maxRedemptionStartTimeFilter (optional) 
     * @param minRedemptionStartTimeFilter (optional) 
     * @param maxRedemptionEndTImeFilter (optional) 
     * @param minRedemptionEndTImeFilter (optional) 
     * @param redemptionTypeFilter (optional) 
     * @param maxDiscountAmountFilter (optional) 
     * @param minDiscountAmountFilter (optional) 
     * @param maxDiscountRateFilter (optional) 
     * @param minDiscountRateFilter (optional) 
     * @param giftCodeFilter (optional) 
     * @param maxMinPurchaseAmountFilter (optional) 
     * @param minMinPurchaseAmountFilter (optional) 
     * @param maxMaxDiscountAmountFilter (optional) 
     * @param minMaxDiscountAmountFilter (optional) 
     * @param maxQtyGrantPerPersonFilter (optional) 
     * @param minQtyGrantPerPersonFilter (optional) 
     * @param acceptedEventFilter (optional) 
     * @param grantMsgTemplateTypeFilter (optional) 
     * @param grantMsgTemplateIDFilter (optional) 
     * @param grantMsgTemplateContentVNFilter (optional) 
     * @param grantMsgTemplateContentENFilter (optional) 
     * @param redemptionMsgTemplateTypeFilter (optional) 
     * @param redemptionMsgTemplateIDFilter (optional) 
     * @param redemptionMsgTemplateContentVNFilter (optional) 
     * @param redemptionMsgTemplateContentENFilter (optional) 
     * @param statusFilter (optional) 
     * @param voucherGroupNameUnsignFilter (optional) 
     * @param grantNotificationChannelFilter (optional) 
     * @param redemptionNotificationChannelFilter (optional) 
     * @param triggerEventFilter (optional) 
     * @param eventFilterFilter (optional) 
     * @param isDailyFilter (optional) 
     * @param cronFilter (optional) 
     * @param triggerTypeFilter (optional) 
     * @param maxTriggerDateFilter (optional) 
     * @param minTriggerDateFilter (optional) 
     * @param maxMinBillAmountFilter (optional) 
     * @param minMinBillAmountFilter (optional) 
     * @param maxQtyRedeemPerPersonFilter (optional) 
     * @param minQtyRedeemPerPersonFilter (optional) 
     * @param maxRewardTargetAudienceIDFilter (optional) 
     * @param minRewardTargetAudienceIDFilter (optional) 
     * @param targetAudienceTypeFilter (optional) 
     * @param isEditableFilter (optional) 
     * @param maxMaxDayForPOFilter (optional) 
     * @param minMaxDayForPOFilter (optional) 
     * @param referralRewardReceiverFilter (optional) 
     * @param isGrantedFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, voucherGroupCodeFilter: string | null | undefined, voucherGroupNameFilter: string | null | undefined, publisherCodeFilter: string | null | undefined, maxPointPriceFilter: number | null | undefined, minPointPriceFilter: number | null | undefined, maxCurrencyPriceFilter: number | null | undefined, minCurrencyPriceFilter: number | null | undefined, applyForFilter: string | null | undefined, titleVNFilter: string | null | undefined, titleENFilter: string | null | undefined, descriptionVNFilter: string | null | undefined, descriptionENFilter: string | null | undefined, imageLinkFilter: string | null | undefined, templateFilter: string | null | undefined, maxGrantStartTimeFilter: moment.Moment | null | undefined, minGrantStartTimeFilter: moment.Moment | null | undefined, maxGrantEndTimeFilter: moment.Moment | null | undefined, minGrantEndTimeFilter: moment.Moment | null | undefined, billCalculationTypeFilter: string | null | undefined, maxBillTotalFilter: number | null | undefined, minBillTotalFilter: number | null | undefined, grantApplyTypeFilter: string | null | undefined, grantAppliedLocationFilter: string | null | undefined, grantAppliedStoreFilter: string | null | undefined, grantAppliedProdLV1Filter: string | null | undefined, grantAppliedProdLV2Filter: string | null | undefined, grantAppliedProdLV3Filter: string | null | undefined, grantAppliedProdLV4Filter: string | null | undefined, grantAppliedProdLV5Filter: string | null | undefined, grantAppliedProductFilter: string | null | undefined, redemptionApplyTypeFilter: string | null | undefined, redemptionApplyLocationFilter: string | null | undefined, redemptionApplyStoreFilter: string | null | undefined, redemptionAppliedProdLV1Filter: string | null | undefined, redemptionAppliedProdLV2Filter: string | null | undefined, redemptionAppliedProdLV3Filter: string | null | undefined, redemptionAppliedProdLV4Filter: string | null | undefined, redemptionAppliedProdLV5Filter: string | null | undefined, redemptionAppliedProductFilter: string | null | undefined, maxRedemptionStartTimeFilter: moment.Moment | null | undefined, minRedemptionStartTimeFilter: moment.Moment | null | undefined, maxRedemptionEndTImeFilter: moment.Moment | null | undefined, minRedemptionEndTImeFilter: moment.Moment | null | undefined, redemptionTypeFilter: string | null | undefined, maxDiscountAmountFilter: number | null | undefined, minDiscountAmountFilter: number | null | undefined, maxDiscountRateFilter: number | null | undefined, minDiscountRateFilter: number | null | undefined, giftCodeFilter: string | null | undefined, maxMinPurchaseAmountFilter: number | null | undefined, minMinPurchaseAmountFilter: number | null | undefined, maxMaxDiscountAmountFilter: number | null | undefined, minMaxDiscountAmountFilter: number | null | undefined, maxQtyGrantPerPersonFilter: number | null | undefined, minQtyGrantPerPersonFilter: number | null | undefined, acceptedEventFilter: string | null | undefined, grantMsgTemplateTypeFilter: string | null | undefined, grantMsgTemplateIDFilter: string | null | undefined, grantMsgTemplateContentVNFilter: string | null | undefined, grantMsgTemplateContentENFilter: string | null | undefined, redemptionMsgTemplateTypeFilter: string | null | undefined, redemptionMsgTemplateIDFilter: string | null | undefined, redemptionMsgTemplateContentVNFilter: string | null | undefined, redemptionMsgTemplateContentENFilter: string | null | undefined, statusFilter: string | null | undefined, voucherGroupNameUnsignFilter: string | null | undefined, grantNotificationChannelFilter: string | null | undefined, redemptionNotificationChannelFilter: string | null | undefined, triggerEventFilter: string | null | undefined, eventFilterFilter: string | null | undefined, isDailyFilter: number | null | undefined, cronFilter: string | null | undefined, triggerTypeFilter: string | null | undefined, maxTriggerDateFilter: moment.Moment | null | undefined, minTriggerDateFilter: moment.Moment | null | undefined, maxMinBillAmountFilter: number | null | undefined, minMinBillAmountFilter: number | null | undefined, maxQtyRedeemPerPersonFilter: number | null | undefined, minQtyRedeemPerPersonFilter: number | null | undefined, maxRewardTargetAudienceIDFilter: number | null | undefined, minRewardTargetAudienceIDFilter: number | null | undefined, targetAudienceTypeFilter: string | null | undefined, isEditableFilter: number | null | undefined, maxMaxDayForPOFilter: number | null | undefined, minMaxDayForPOFilter: number | null | undefined, referralRewardReceiverFilter: string | null | undefined, isGrantedFilter: number | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetVoucherGroupForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/VoucherGroups/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (voucherGroupCodeFilter !== undefined)
            url_ += "VoucherGroupCodeFilter=" + encodeURIComponent("" + voucherGroupCodeFilter) + "&";
        if (voucherGroupNameFilter !== undefined)
            url_ += "VoucherGroupNameFilter=" + encodeURIComponent("" + voucherGroupNameFilter) + "&";
        if (publisherCodeFilter !== undefined)
            url_ += "PublisherCodeFilter=" + encodeURIComponent("" + publisherCodeFilter) + "&";
        if (maxPointPriceFilter !== undefined)
            url_ += "MaxPointPriceFilter=" + encodeURIComponent("" + maxPointPriceFilter) + "&";
        if (minPointPriceFilter !== undefined)
            url_ += "MinPointPriceFilter=" + encodeURIComponent("" + minPointPriceFilter) + "&";
        if (maxCurrencyPriceFilter !== undefined)
            url_ += "MaxCurrencyPriceFilter=" + encodeURIComponent("" + maxCurrencyPriceFilter) + "&";
        if (minCurrencyPriceFilter !== undefined)
            url_ += "MinCurrencyPriceFilter=" + encodeURIComponent("" + minCurrencyPriceFilter) + "&";
        if (applyForFilter !== undefined)
            url_ += "ApplyForFilter=" + encodeURIComponent("" + applyForFilter) + "&";
        if (titleVNFilter !== undefined)
            url_ += "TitleVNFilter=" + encodeURIComponent("" + titleVNFilter) + "&";
        if (titleENFilter !== undefined)
            url_ += "TitleENFilter=" + encodeURIComponent("" + titleENFilter) + "&";
        if (descriptionVNFilter !== undefined)
            url_ += "DescriptionVNFilter=" + encodeURIComponent("" + descriptionVNFilter) + "&";
        if (descriptionENFilter !== undefined)
            url_ += "DescriptionENFilter=" + encodeURIComponent("" + descriptionENFilter) + "&";
        if (imageLinkFilter !== undefined)
            url_ += "ImageLinkFilter=" + encodeURIComponent("" + imageLinkFilter) + "&";
        if (templateFilter !== undefined)
            url_ += "TemplateFilter=" + encodeURIComponent("" + templateFilter) + "&";
        if (maxGrantStartTimeFilter !== undefined)
            url_ += "MaxGrantStartTimeFilter=" + encodeURIComponent(maxGrantStartTimeFilter ? "" + maxGrantStartTimeFilter.toJSON() : "") + "&";
        if (minGrantStartTimeFilter !== undefined)
            url_ += "MinGrantStartTimeFilter=" + encodeURIComponent(minGrantStartTimeFilter ? "" + minGrantStartTimeFilter.toJSON() : "") + "&";
        if (maxGrantEndTimeFilter !== undefined)
            url_ += "MaxGrantEndTimeFilter=" + encodeURIComponent(maxGrantEndTimeFilter ? "" + maxGrantEndTimeFilter.toJSON() : "") + "&";
        if (minGrantEndTimeFilter !== undefined)
            url_ += "MinGrantEndTimeFilter=" + encodeURIComponent(minGrantEndTimeFilter ? "" + minGrantEndTimeFilter.toJSON() : "") + "&";
        if (billCalculationTypeFilter !== undefined)
            url_ += "BillCalculationTypeFilter=" + encodeURIComponent("" + billCalculationTypeFilter) + "&";
        if (maxBillTotalFilter !== undefined)
            url_ += "MaxBillTotalFilter=" + encodeURIComponent("" + maxBillTotalFilter) + "&";
        if (minBillTotalFilter !== undefined)
            url_ += "MinBillTotalFilter=" + encodeURIComponent("" + minBillTotalFilter) + "&";
        if (grantApplyTypeFilter !== undefined)
            url_ += "GrantApplyTypeFilter=" + encodeURIComponent("" + grantApplyTypeFilter) + "&";
        if (grantAppliedLocationFilter !== undefined)
            url_ += "GrantAppliedLocationFilter=" + encodeURIComponent("" + grantAppliedLocationFilter) + "&";
        if (grantAppliedStoreFilter !== undefined)
            url_ += "GrantAppliedStoreFilter=" + encodeURIComponent("" + grantAppliedStoreFilter) + "&";
        if (grantAppliedProdLV1Filter !== undefined)
            url_ += "GrantAppliedProdLV1Filter=" + encodeURIComponent("" + grantAppliedProdLV1Filter) + "&";
        if (grantAppliedProdLV2Filter !== undefined)
            url_ += "GrantAppliedProdLV2Filter=" + encodeURIComponent("" + grantAppliedProdLV2Filter) + "&";
        if (grantAppliedProdLV3Filter !== undefined)
            url_ += "GrantAppliedProdLV3Filter=" + encodeURIComponent("" + grantAppliedProdLV3Filter) + "&";
        if (grantAppliedProdLV4Filter !== undefined)
            url_ += "GrantAppliedProdLV4Filter=" + encodeURIComponent("" + grantAppliedProdLV4Filter) + "&";
        if (grantAppliedProdLV5Filter !== undefined)
            url_ += "GrantAppliedProdLV5Filter=" + encodeURIComponent("" + grantAppliedProdLV5Filter) + "&";
        if (grantAppliedProductFilter !== undefined)
            url_ += "GrantAppliedProductFilter=" + encodeURIComponent("" + grantAppliedProductFilter) + "&";
        if (redemptionApplyTypeFilter !== undefined)
            url_ += "RedemptionApplyTypeFilter=" + encodeURIComponent("" + redemptionApplyTypeFilter) + "&";
        if (redemptionApplyLocationFilter !== undefined)
            url_ += "RedemptionApplyLocationFilter=" + encodeURIComponent("" + redemptionApplyLocationFilter) + "&";
        if (redemptionApplyStoreFilter !== undefined)
            url_ += "RedemptionApplyStoreFilter=" + encodeURIComponent("" + redemptionApplyStoreFilter) + "&";
        if (redemptionAppliedProdLV1Filter !== undefined)
            url_ += "RedemptionAppliedProdLV1Filter=" + encodeURIComponent("" + redemptionAppliedProdLV1Filter) + "&";
        if (redemptionAppliedProdLV2Filter !== undefined)
            url_ += "RedemptionAppliedProdLV2Filter=" + encodeURIComponent("" + redemptionAppliedProdLV2Filter) + "&";
        if (redemptionAppliedProdLV3Filter !== undefined)
            url_ += "RedemptionAppliedProdLV3Filter=" + encodeURIComponent("" + redemptionAppliedProdLV3Filter) + "&";
        if (redemptionAppliedProdLV4Filter !== undefined)
            url_ += "RedemptionAppliedProdLV4Filter=" + encodeURIComponent("" + redemptionAppliedProdLV4Filter) + "&";
        if (redemptionAppliedProdLV5Filter !== undefined)
            url_ += "RedemptionAppliedProdLV5Filter=" + encodeURIComponent("" + redemptionAppliedProdLV5Filter) + "&";
        if (redemptionAppliedProductFilter !== undefined)
            url_ += "RedemptionAppliedProductFilter=" + encodeURIComponent("" + redemptionAppliedProductFilter) + "&";
        if (maxRedemptionStartTimeFilter !== undefined)
            url_ += "MaxRedemptionStartTimeFilter=" + encodeURIComponent(maxRedemptionStartTimeFilter ? "" + maxRedemptionStartTimeFilter.toJSON() : "") + "&";
        if (minRedemptionStartTimeFilter !== undefined)
            url_ += "MinRedemptionStartTimeFilter=" + encodeURIComponent(minRedemptionStartTimeFilter ? "" + minRedemptionStartTimeFilter.toJSON() : "") + "&";
        if (maxRedemptionEndTImeFilter !== undefined)
            url_ += "MaxRedemptionEndTImeFilter=" + encodeURIComponent(maxRedemptionEndTImeFilter ? "" + maxRedemptionEndTImeFilter.toJSON() : "") + "&";
        if (minRedemptionEndTImeFilter !== undefined)
            url_ += "MinRedemptionEndTImeFilter=" + encodeURIComponent(minRedemptionEndTImeFilter ? "" + minRedemptionEndTImeFilter.toJSON() : "") + "&";
        if (redemptionTypeFilter !== undefined)
            url_ += "RedemptionTypeFilter=" + encodeURIComponent("" + redemptionTypeFilter) + "&";
        if (maxDiscountAmountFilter !== undefined)
            url_ += "MaxDiscountAmountFilter=" + encodeURIComponent("" + maxDiscountAmountFilter) + "&";
        if (minDiscountAmountFilter !== undefined)
            url_ += "MinDiscountAmountFilter=" + encodeURIComponent("" + minDiscountAmountFilter) + "&";
        if (maxDiscountRateFilter !== undefined)
            url_ += "MaxDiscountRateFilter=" + encodeURIComponent("" + maxDiscountRateFilter) + "&";
        if (minDiscountRateFilter !== undefined)
            url_ += "MinDiscountRateFilter=" + encodeURIComponent("" + minDiscountRateFilter) + "&";
        if (giftCodeFilter !== undefined)
            url_ += "GiftCodeFilter=" + encodeURIComponent("" + giftCodeFilter) + "&";
        if (maxMinPurchaseAmountFilter !== undefined)
            url_ += "MaxMinPurchaseAmountFilter=" + encodeURIComponent("" + maxMinPurchaseAmountFilter) + "&";
        if (minMinPurchaseAmountFilter !== undefined)
            url_ += "MinMinPurchaseAmountFilter=" + encodeURIComponent("" + minMinPurchaseAmountFilter) + "&";
        if (maxMaxDiscountAmountFilter !== undefined)
            url_ += "MaxMaxDiscountAmountFilter=" + encodeURIComponent("" + maxMaxDiscountAmountFilter) + "&";
        if (minMaxDiscountAmountFilter !== undefined)
            url_ += "MinMaxDiscountAmountFilter=" + encodeURIComponent("" + minMaxDiscountAmountFilter) + "&";
        if (maxQtyGrantPerPersonFilter !== undefined)
            url_ += "MaxQtyGrantPerPersonFilter=" + encodeURIComponent("" + maxQtyGrantPerPersonFilter) + "&";
        if (minQtyGrantPerPersonFilter !== undefined)
            url_ += "MinQtyGrantPerPersonFilter=" + encodeURIComponent("" + minQtyGrantPerPersonFilter) + "&";
        if (acceptedEventFilter !== undefined)
            url_ += "AcceptedEventFilter=" + encodeURIComponent("" + acceptedEventFilter) + "&";
        if (grantMsgTemplateTypeFilter !== undefined)
            url_ += "GrantMsgTemplateTypeFilter=" + encodeURIComponent("" + grantMsgTemplateTypeFilter) + "&";
        if (grantMsgTemplateIDFilter !== undefined)
            url_ += "GrantMsgTemplateIDFilter=" + encodeURIComponent("" + grantMsgTemplateIDFilter) + "&";
        if (grantMsgTemplateContentVNFilter !== undefined)
            url_ += "GrantMsgTemplateContentVNFilter=" + encodeURIComponent("" + grantMsgTemplateContentVNFilter) + "&";
        if (grantMsgTemplateContentENFilter !== undefined)
            url_ += "GrantMsgTemplateContentENFilter=" + encodeURIComponent("" + grantMsgTemplateContentENFilter) + "&";
        if (redemptionMsgTemplateTypeFilter !== undefined)
            url_ += "RedemptionMsgTemplateTypeFilter=" + encodeURIComponent("" + redemptionMsgTemplateTypeFilter) + "&";
        if (redemptionMsgTemplateIDFilter !== undefined)
            url_ += "RedemptionMsgTemplateIDFilter=" + encodeURIComponent("" + redemptionMsgTemplateIDFilter) + "&";
        if (redemptionMsgTemplateContentVNFilter !== undefined)
            url_ += "RedemptionMsgTemplateContentVNFilter=" + encodeURIComponent("" + redemptionMsgTemplateContentVNFilter) + "&";
        if (redemptionMsgTemplateContentENFilter !== undefined)
            url_ += "RedemptionMsgTemplateContentENFilter=" + encodeURIComponent("" + redemptionMsgTemplateContentENFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (voucherGroupNameUnsignFilter !== undefined)
            url_ += "VoucherGroupNameUnsignFilter=" + encodeURIComponent("" + voucherGroupNameUnsignFilter) + "&";
        if (grantNotificationChannelFilter !== undefined)
            url_ += "GrantNotificationChannelFilter=" + encodeURIComponent("" + grantNotificationChannelFilter) + "&";
        if (redemptionNotificationChannelFilter !== undefined)
            url_ += "RedemptionNotificationChannelFilter=" + encodeURIComponent("" + redemptionNotificationChannelFilter) + "&";
        if (triggerEventFilter !== undefined)
            url_ += "TriggerEventFilter=" + encodeURIComponent("" + triggerEventFilter) + "&";
        if (eventFilterFilter !== undefined)
            url_ += "EventFilterFilter=" + encodeURIComponent("" + eventFilterFilter) + "&";
        if (isDailyFilter !== undefined)
            url_ += "IsDailyFilter=" + encodeURIComponent("" + isDailyFilter) + "&";
        if (cronFilter !== undefined)
            url_ += "CronFilter=" + encodeURIComponent("" + cronFilter) + "&";
        if (triggerTypeFilter !== undefined)
            url_ += "TriggerTypeFilter=" + encodeURIComponent("" + triggerTypeFilter) + "&";
        if (maxTriggerDateFilter !== undefined)
            url_ += "MaxTriggerDateFilter=" + encodeURIComponent(maxTriggerDateFilter ? "" + maxTriggerDateFilter.toJSON() : "") + "&";
        if (minTriggerDateFilter !== undefined)
            url_ += "MinTriggerDateFilter=" + encodeURIComponent(minTriggerDateFilter ? "" + minTriggerDateFilter.toJSON() : "") + "&";
        if (maxMinBillAmountFilter !== undefined)
            url_ += "MaxMinBillAmountFilter=" + encodeURIComponent("" + maxMinBillAmountFilter) + "&";
        if (minMinBillAmountFilter !== undefined)
            url_ += "MinMinBillAmountFilter=" + encodeURIComponent("" + minMinBillAmountFilter) + "&";
        if (maxQtyRedeemPerPersonFilter !== undefined)
            url_ += "MaxQtyRedeemPerPersonFilter=" + encodeURIComponent("" + maxQtyRedeemPerPersonFilter) + "&";
        if (minQtyRedeemPerPersonFilter !== undefined)
            url_ += "MinQtyRedeemPerPersonFilter=" + encodeURIComponent("" + minQtyRedeemPerPersonFilter) + "&";
        if (maxRewardTargetAudienceIDFilter !== undefined)
            url_ += "MaxRewardTargetAudienceIDFilter=" + encodeURIComponent("" + maxRewardTargetAudienceIDFilter) + "&";
        if (minRewardTargetAudienceIDFilter !== undefined)
            url_ += "MinRewardTargetAudienceIDFilter=" + encodeURIComponent("" + minRewardTargetAudienceIDFilter) + "&";
        if (targetAudienceTypeFilter !== undefined)
            url_ += "TargetAudienceTypeFilter=" + encodeURIComponent("" + targetAudienceTypeFilter) + "&";
        if (isEditableFilter !== undefined)
            url_ += "IsEditableFilter=" + encodeURIComponent("" + isEditableFilter) + "&";
        if (maxMaxDayForPOFilter !== undefined)
            url_ += "MaxMaxDayForPOFilter=" + encodeURIComponent("" + maxMaxDayForPOFilter) + "&";
        if (minMaxDayForPOFilter !== undefined)
            url_ += "MinMaxDayForPOFilter=" + encodeURIComponent("" + minMaxDayForPOFilter) + "&";
        if (referralRewardReceiverFilter !== undefined)
            url_ += "ReferralRewardReceiverFilter=" + encodeURIComponent("" + referralRewardReceiverFilter) + "&";
        if (isGrantedFilter !== undefined)
            url_ += "IsGrantedFilter=" + encodeURIComponent("" + isGrantedFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetVoucherGroupForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetVoucherGroupForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetVoucherGroupForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetVoucherGroupForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetVoucherGroupForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetVoucherGroupForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getVoucherGroupForEdit(id: number | null | undefined): Observable<GetVoucherGroupForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/VoucherGroups/GetVoucherGroupForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetVoucherGroupForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVoucherGroupForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetVoucherGroupForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetVoucherGroupForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetVoucherGroupForEdit(response: HttpResponseBase): Observable<GetVoucherGroupForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetVoucherGroupForEditOutput.fromJS(resultData200) : new GetVoucherGroupForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetVoucherGroupForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditVoucherGroupDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/VoucherGroups/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/VoucherGroups/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param voucherGroupCodeFilter (optional) 
     * @param voucherGroupNameFilter (optional) 
     * @param publisherCodeFilter (optional) 
     * @param maxPointPriceFilter (optional) 
     * @param minPointPriceFilter (optional) 
     * @param maxCurrencyPriceFilter (optional) 
     * @param minCurrencyPriceFilter (optional) 
     * @param applyForFilter (optional) 
     * @param titleVNFilter (optional) 
     * @param titleENFilter (optional) 
     * @param descriptionVNFilter (optional) 
     * @param descriptionENFilter (optional) 
     * @param imageLinkFilter (optional) 
     * @param templateFilter (optional) 
     * @param maxGrantStartTimeFilter (optional) 
     * @param minGrantStartTimeFilter (optional) 
     * @param maxGrantEndTimeFilter (optional) 
     * @param minGrantEndTimeFilter (optional) 
     * @param billCalculationTypeFilter (optional) 
     * @param maxBillTotalFilter (optional) 
     * @param minBillTotalFilter (optional) 
     * @param grantApplyTypeFilter (optional) 
     * @param grantAppliedLocationFilter (optional) 
     * @param grantAppliedStoreFilter (optional) 
     * @param grantAppliedProdLV1Filter (optional) 
     * @param grantAppliedProdLV2Filter (optional) 
     * @param grantAppliedProdLV3Filter (optional) 
     * @param grantAppliedProdLV4Filter (optional) 
     * @param grantAppliedProdLV5Filter (optional) 
     * @param grantAppliedProductFilter (optional) 
     * @param redemptionApplyTypeFilter (optional) 
     * @param redemptionApplyLocationFilter (optional) 
     * @param redemptionApplyStoreFilter (optional) 
     * @param redemptionAppliedProdLV1Filter (optional) 
     * @param redemptionAppliedProdLV2Filter (optional) 
     * @param redemptionAppliedProdLV3Filter (optional) 
     * @param redemptionAppliedProdLV4Filter (optional) 
     * @param redemptionAppliedProdLV5Filter (optional) 
     * @param redemptionAppliedProductFilter (optional) 
     * @param maxRedemptionStartTimeFilter (optional) 
     * @param minRedemptionStartTimeFilter (optional) 
     * @param maxRedemptionEndTImeFilter (optional) 
     * @param minRedemptionEndTImeFilter (optional) 
     * @param redemptionTypeFilter (optional) 
     * @param maxDiscountAmountFilter (optional) 
     * @param minDiscountAmountFilter (optional) 
     * @param maxDiscountRateFilter (optional) 
     * @param minDiscountRateFilter (optional) 
     * @param giftCodeFilter (optional) 
     * @param maxMinPurchaseAmountFilter (optional) 
     * @param minMinPurchaseAmountFilter (optional) 
     * @param maxMaxDiscountAmountFilter (optional) 
     * @param minMaxDiscountAmountFilter (optional) 
     * @param maxQtyGrantPerPersonFilter (optional) 
     * @param minQtyGrantPerPersonFilter (optional) 
     * @param acceptedEventFilter (optional) 
     * @param grantMsgTemplateTypeFilter (optional) 
     * @param grantMsgTemplateIDFilter (optional) 
     * @param grantMsgTemplateContentVNFilter (optional) 
     * @param grantMsgTemplateContentENFilter (optional) 
     * @param redemptionMsgTemplateTypeFilter (optional) 
     * @param redemptionMsgTemplateIDFilter (optional) 
     * @param redemptionMsgTemplateContentVNFilter (optional) 
     * @param redemptionMsgTemplateContentENFilter (optional) 
     * @param statusFilter (optional) 
     * @param voucherGroupNameUnsignFilter (optional) 
     * @param grantNotificationChannelFilter (optional) 
     * @param redemptionNotificationChannelFilter (optional) 
     * @param triggerEventFilter (optional) 
     * @param eventFilterFilter (optional) 
     * @param isDailyFilter (optional) 
     * @param cronFilter (optional) 
     * @param triggerTypeFilter (optional) 
     * @param maxTriggerDateFilter (optional) 
     * @param minTriggerDateFilter (optional) 
     * @param maxMinBillAmountFilter (optional) 
     * @param minMinBillAmountFilter (optional) 
     * @param maxQtyRedeemPerPersonFilter (optional) 
     * @param minQtyRedeemPerPersonFilter (optional) 
     * @param maxRewardTargetAudienceIDFilter (optional) 
     * @param minRewardTargetAudienceIDFilter (optional) 
     * @param targetAudienceTypeFilter (optional) 
     * @param isEditableFilter (optional) 
     * @param maxMaxDayForPOFilter (optional) 
     * @param minMaxDayForPOFilter (optional) 
     * @param referralRewardReceiverFilter (optional) 
     * @param isGrantedFilter (optional) 
     * @return Success
     */
    getVoucherGroupsToExcel(filter: string | null | undefined, voucherGroupCodeFilter: string | null | undefined, voucherGroupNameFilter: string | null | undefined, publisherCodeFilter: string | null | undefined, maxPointPriceFilter: number | null | undefined, minPointPriceFilter: number | null | undefined, maxCurrencyPriceFilter: number | null | undefined, minCurrencyPriceFilter: number | null | undefined, applyForFilter: string | null | undefined, titleVNFilter: string | null | undefined, titleENFilter: string | null | undefined, descriptionVNFilter: string | null | undefined, descriptionENFilter: string | null | undefined, imageLinkFilter: string | null | undefined, templateFilter: string | null | undefined, maxGrantStartTimeFilter: moment.Moment | null | undefined, minGrantStartTimeFilter: moment.Moment | null | undefined, maxGrantEndTimeFilter: moment.Moment | null | undefined, minGrantEndTimeFilter: moment.Moment | null | undefined, billCalculationTypeFilter: string | null | undefined, maxBillTotalFilter: number | null | undefined, minBillTotalFilter: number | null | undefined, grantApplyTypeFilter: string | null | undefined, grantAppliedLocationFilter: string | null | undefined, grantAppliedStoreFilter: string | null | undefined, grantAppliedProdLV1Filter: string | null | undefined, grantAppliedProdLV2Filter: string | null | undefined, grantAppliedProdLV3Filter: string | null | undefined, grantAppliedProdLV4Filter: string | null | undefined, grantAppliedProdLV5Filter: string | null | undefined, grantAppliedProductFilter: string | null | undefined, redemptionApplyTypeFilter: string | null | undefined, redemptionApplyLocationFilter: string | null | undefined, redemptionApplyStoreFilter: string | null | undefined, redemptionAppliedProdLV1Filter: string | null | undefined, redemptionAppliedProdLV2Filter: string | null | undefined, redemptionAppliedProdLV3Filter: string | null | undefined, redemptionAppliedProdLV4Filter: string | null | undefined, redemptionAppliedProdLV5Filter: string | null | undefined, redemptionAppliedProductFilter: string | null | undefined, maxRedemptionStartTimeFilter: moment.Moment | null | undefined, minRedemptionStartTimeFilter: moment.Moment | null | undefined, maxRedemptionEndTImeFilter: moment.Moment | null | undefined, minRedemptionEndTImeFilter: moment.Moment | null | undefined, redemptionTypeFilter: string | null | undefined, maxDiscountAmountFilter: number | null | undefined, minDiscountAmountFilter: number | null | undefined, maxDiscountRateFilter: number | null | undefined, minDiscountRateFilter: number | null | undefined, giftCodeFilter: string | null | undefined, maxMinPurchaseAmountFilter: number | null | undefined, minMinPurchaseAmountFilter: number | null | undefined, maxMaxDiscountAmountFilter: number | null | undefined, minMaxDiscountAmountFilter: number | null | undefined, maxQtyGrantPerPersonFilter: number | null | undefined, minQtyGrantPerPersonFilter: number | null | undefined, acceptedEventFilter: string | null | undefined, grantMsgTemplateTypeFilter: string | null | undefined, grantMsgTemplateIDFilter: string | null | undefined, grantMsgTemplateContentVNFilter: string | null | undefined, grantMsgTemplateContentENFilter: string | null | undefined, redemptionMsgTemplateTypeFilter: string | null | undefined, redemptionMsgTemplateIDFilter: string | null | undefined, redemptionMsgTemplateContentVNFilter: string | null | undefined, redemptionMsgTemplateContentENFilter: string | null | undefined, statusFilter: string | null | undefined, voucherGroupNameUnsignFilter: string | null | undefined, grantNotificationChannelFilter: string | null | undefined, redemptionNotificationChannelFilter: string | null | undefined, triggerEventFilter: string | null | undefined, eventFilterFilter: string | null | undefined, isDailyFilter: number | null | undefined, cronFilter: string | null | undefined, triggerTypeFilter: string | null | undefined, maxTriggerDateFilter: moment.Moment | null | undefined, minTriggerDateFilter: moment.Moment | null | undefined, maxMinBillAmountFilter: number | null | undefined, minMinBillAmountFilter: number | null | undefined, maxQtyRedeemPerPersonFilter: number | null | undefined, minQtyRedeemPerPersonFilter: number | null | undefined, maxRewardTargetAudienceIDFilter: number | null | undefined, minRewardTargetAudienceIDFilter: number | null | undefined, targetAudienceTypeFilter: string | null | undefined, isEditableFilter: number | null | undefined, maxMaxDayForPOFilter: number | null | undefined, minMaxDayForPOFilter: number | null | undefined, referralRewardReceiverFilter: string | null | undefined, isGrantedFilter: number | null | undefined): Observable<RewardsFileDto> {
        let url_ = this.baseUrl + "/api/services/app/VoucherGroups/GetVoucherGroupsToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (voucherGroupCodeFilter !== undefined)
            url_ += "VoucherGroupCodeFilter=" + encodeURIComponent("" + voucherGroupCodeFilter) + "&";
        if (voucherGroupNameFilter !== undefined)
            url_ += "VoucherGroupNameFilter=" + encodeURIComponent("" + voucherGroupNameFilter) + "&";
        if (publisherCodeFilter !== undefined)
            url_ += "PublisherCodeFilter=" + encodeURIComponent("" + publisherCodeFilter) + "&";
        if (maxPointPriceFilter !== undefined)
            url_ += "MaxPointPriceFilter=" + encodeURIComponent("" + maxPointPriceFilter) + "&";
        if (minPointPriceFilter !== undefined)
            url_ += "MinPointPriceFilter=" + encodeURIComponent("" + minPointPriceFilter) + "&";
        if (maxCurrencyPriceFilter !== undefined)
            url_ += "MaxCurrencyPriceFilter=" + encodeURIComponent("" + maxCurrencyPriceFilter) + "&";
        if (minCurrencyPriceFilter !== undefined)
            url_ += "MinCurrencyPriceFilter=" + encodeURIComponent("" + minCurrencyPriceFilter) + "&";
        if (applyForFilter !== undefined)
            url_ += "ApplyForFilter=" + encodeURIComponent("" + applyForFilter) + "&";
        if (titleVNFilter !== undefined)
            url_ += "TitleVNFilter=" + encodeURIComponent("" + titleVNFilter) + "&";
        if (titleENFilter !== undefined)
            url_ += "TitleENFilter=" + encodeURIComponent("" + titleENFilter) + "&";
        if (descriptionVNFilter !== undefined)
            url_ += "DescriptionVNFilter=" + encodeURIComponent("" + descriptionVNFilter) + "&";
        if (descriptionENFilter !== undefined)
            url_ += "DescriptionENFilter=" + encodeURIComponent("" + descriptionENFilter) + "&";
        if (imageLinkFilter !== undefined)
            url_ += "ImageLinkFilter=" + encodeURIComponent("" + imageLinkFilter) + "&";
        if (templateFilter !== undefined)
            url_ += "TemplateFilter=" + encodeURIComponent("" + templateFilter) + "&";
        if (maxGrantStartTimeFilter !== undefined)
            url_ += "MaxGrantStartTimeFilter=" + encodeURIComponent(maxGrantStartTimeFilter ? "" + maxGrantStartTimeFilter.toJSON() : "") + "&";
        if (minGrantStartTimeFilter !== undefined)
            url_ += "MinGrantStartTimeFilter=" + encodeURIComponent(minGrantStartTimeFilter ? "" + minGrantStartTimeFilter.toJSON() : "") + "&";
        if (maxGrantEndTimeFilter !== undefined)
            url_ += "MaxGrantEndTimeFilter=" + encodeURIComponent(maxGrantEndTimeFilter ? "" + maxGrantEndTimeFilter.toJSON() : "") + "&";
        if (minGrantEndTimeFilter !== undefined)
            url_ += "MinGrantEndTimeFilter=" + encodeURIComponent(minGrantEndTimeFilter ? "" + minGrantEndTimeFilter.toJSON() : "") + "&";
        if (billCalculationTypeFilter !== undefined)
            url_ += "BillCalculationTypeFilter=" + encodeURIComponent("" + billCalculationTypeFilter) + "&";
        if (maxBillTotalFilter !== undefined)
            url_ += "MaxBillTotalFilter=" + encodeURIComponent("" + maxBillTotalFilter) + "&";
        if (minBillTotalFilter !== undefined)
            url_ += "MinBillTotalFilter=" + encodeURIComponent("" + minBillTotalFilter) + "&";
        if (grantApplyTypeFilter !== undefined)
            url_ += "GrantApplyTypeFilter=" + encodeURIComponent("" + grantApplyTypeFilter) + "&";
        if (grantAppliedLocationFilter !== undefined)
            url_ += "GrantAppliedLocationFilter=" + encodeURIComponent("" + grantAppliedLocationFilter) + "&";
        if (grantAppliedStoreFilter !== undefined)
            url_ += "GrantAppliedStoreFilter=" + encodeURIComponent("" + grantAppliedStoreFilter) + "&";
        if (grantAppliedProdLV1Filter !== undefined)
            url_ += "GrantAppliedProdLV1Filter=" + encodeURIComponent("" + grantAppliedProdLV1Filter) + "&";
        if (grantAppliedProdLV2Filter !== undefined)
            url_ += "GrantAppliedProdLV2Filter=" + encodeURIComponent("" + grantAppliedProdLV2Filter) + "&";
        if (grantAppliedProdLV3Filter !== undefined)
            url_ += "GrantAppliedProdLV3Filter=" + encodeURIComponent("" + grantAppliedProdLV3Filter) + "&";
        if (grantAppliedProdLV4Filter !== undefined)
            url_ += "GrantAppliedProdLV4Filter=" + encodeURIComponent("" + grantAppliedProdLV4Filter) + "&";
        if (grantAppliedProdLV5Filter !== undefined)
            url_ += "GrantAppliedProdLV5Filter=" + encodeURIComponent("" + grantAppliedProdLV5Filter) + "&";
        if (grantAppliedProductFilter !== undefined)
            url_ += "GrantAppliedProductFilter=" + encodeURIComponent("" + grantAppliedProductFilter) + "&";
        if (redemptionApplyTypeFilter !== undefined)
            url_ += "RedemptionApplyTypeFilter=" + encodeURIComponent("" + redemptionApplyTypeFilter) + "&";
        if (redemptionApplyLocationFilter !== undefined)
            url_ += "RedemptionApplyLocationFilter=" + encodeURIComponent("" + redemptionApplyLocationFilter) + "&";
        if (redemptionApplyStoreFilter !== undefined)
            url_ += "RedemptionApplyStoreFilter=" + encodeURIComponent("" + redemptionApplyStoreFilter) + "&";
        if (redemptionAppliedProdLV1Filter !== undefined)
            url_ += "RedemptionAppliedProdLV1Filter=" + encodeURIComponent("" + redemptionAppliedProdLV1Filter) + "&";
        if (redemptionAppliedProdLV2Filter !== undefined)
            url_ += "RedemptionAppliedProdLV2Filter=" + encodeURIComponent("" + redemptionAppliedProdLV2Filter) + "&";
        if (redemptionAppliedProdLV3Filter !== undefined)
            url_ += "RedemptionAppliedProdLV3Filter=" + encodeURIComponent("" + redemptionAppliedProdLV3Filter) + "&";
        if (redemptionAppliedProdLV4Filter !== undefined)
            url_ += "RedemptionAppliedProdLV4Filter=" + encodeURIComponent("" + redemptionAppliedProdLV4Filter) + "&";
        if (redemptionAppliedProdLV5Filter !== undefined)
            url_ += "RedemptionAppliedProdLV5Filter=" + encodeURIComponent("" + redemptionAppliedProdLV5Filter) + "&";
        if (redemptionAppliedProductFilter !== undefined)
            url_ += "RedemptionAppliedProductFilter=" + encodeURIComponent("" + redemptionAppliedProductFilter) + "&";
        if (maxRedemptionStartTimeFilter !== undefined)
            url_ += "MaxRedemptionStartTimeFilter=" + encodeURIComponent(maxRedemptionStartTimeFilter ? "" + maxRedemptionStartTimeFilter.toJSON() : "") + "&";
        if (minRedemptionStartTimeFilter !== undefined)
            url_ += "MinRedemptionStartTimeFilter=" + encodeURIComponent(minRedemptionStartTimeFilter ? "" + minRedemptionStartTimeFilter.toJSON() : "") + "&";
        if (maxRedemptionEndTImeFilter !== undefined)
            url_ += "MaxRedemptionEndTImeFilter=" + encodeURIComponent(maxRedemptionEndTImeFilter ? "" + maxRedemptionEndTImeFilter.toJSON() : "") + "&";
        if (minRedemptionEndTImeFilter !== undefined)
            url_ += "MinRedemptionEndTImeFilter=" + encodeURIComponent(minRedemptionEndTImeFilter ? "" + minRedemptionEndTImeFilter.toJSON() : "") + "&";
        if (redemptionTypeFilter !== undefined)
            url_ += "RedemptionTypeFilter=" + encodeURIComponent("" + redemptionTypeFilter) + "&";
        if (maxDiscountAmountFilter !== undefined)
            url_ += "MaxDiscountAmountFilter=" + encodeURIComponent("" + maxDiscountAmountFilter) + "&";
        if (minDiscountAmountFilter !== undefined)
            url_ += "MinDiscountAmountFilter=" + encodeURIComponent("" + minDiscountAmountFilter) + "&";
        if (maxDiscountRateFilter !== undefined)
            url_ += "MaxDiscountRateFilter=" + encodeURIComponent("" + maxDiscountRateFilter) + "&";
        if (minDiscountRateFilter !== undefined)
            url_ += "MinDiscountRateFilter=" + encodeURIComponent("" + minDiscountRateFilter) + "&";
        if (giftCodeFilter !== undefined)
            url_ += "GiftCodeFilter=" + encodeURIComponent("" + giftCodeFilter) + "&";
        if (maxMinPurchaseAmountFilter !== undefined)
            url_ += "MaxMinPurchaseAmountFilter=" + encodeURIComponent("" + maxMinPurchaseAmountFilter) + "&";
        if (minMinPurchaseAmountFilter !== undefined)
            url_ += "MinMinPurchaseAmountFilter=" + encodeURIComponent("" + minMinPurchaseAmountFilter) + "&";
        if (maxMaxDiscountAmountFilter !== undefined)
            url_ += "MaxMaxDiscountAmountFilter=" + encodeURIComponent("" + maxMaxDiscountAmountFilter) + "&";
        if (minMaxDiscountAmountFilter !== undefined)
            url_ += "MinMaxDiscountAmountFilter=" + encodeURIComponent("" + minMaxDiscountAmountFilter) + "&";
        if (maxQtyGrantPerPersonFilter !== undefined)
            url_ += "MaxQtyGrantPerPersonFilter=" + encodeURIComponent("" + maxQtyGrantPerPersonFilter) + "&";
        if (minQtyGrantPerPersonFilter !== undefined)
            url_ += "MinQtyGrantPerPersonFilter=" + encodeURIComponent("" + minQtyGrantPerPersonFilter) + "&";
        if (acceptedEventFilter !== undefined)
            url_ += "AcceptedEventFilter=" + encodeURIComponent("" + acceptedEventFilter) + "&";
        if (grantMsgTemplateTypeFilter !== undefined)
            url_ += "GrantMsgTemplateTypeFilter=" + encodeURIComponent("" + grantMsgTemplateTypeFilter) + "&";
        if (grantMsgTemplateIDFilter !== undefined)
            url_ += "GrantMsgTemplateIDFilter=" + encodeURIComponent("" + grantMsgTemplateIDFilter) + "&";
        if (grantMsgTemplateContentVNFilter !== undefined)
            url_ += "GrantMsgTemplateContentVNFilter=" + encodeURIComponent("" + grantMsgTemplateContentVNFilter) + "&";
        if (grantMsgTemplateContentENFilter !== undefined)
            url_ += "GrantMsgTemplateContentENFilter=" + encodeURIComponent("" + grantMsgTemplateContentENFilter) + "&";
        if (redemptionMsgTemplateTypeFilter !== undefined)
            url_ += "RedemptionMsgTemplateTypeFilter=" + encodeURIComponent("" + redemptionMsgTemplateTypeFilter) + "&";
        if (redemptionMsgTemplateIDFilter !== undefined)
            url_ += "RedemptionMsgTemplateIDFilter=" + encodeURIComponent("" + redemptionMsgTemplateIDFilter) + "&";
        if (redemptionMsgTemplateContentVNFilter !== undefined)
            url_ += "RedemptionMsgTemplateContentVNFilter=" + encodeURIComponent("" + redemptionMsgTemplateContentVNFilter) + "&";
        if (redemptionMsgTemplateContentENFilter !== undefined)
            url_ += "RedemptionMsgTemplateContentENFilter=" + encodeURIComponent("" + redemptionMsgTemplateContentENFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (voucherGroupNameUnsignFilter !== undefined)
            url_ += "VoucherGroupNameUnsignFilter=" + encodeURIComponent("" + voucherGroupNameUnsignFilter) + "&";
        if (grantNotificationChannelFilter !== undefined)
            url_ += "GrantNotificationChannelFilter=" + encodeURIComponent("" + grantNotificationChannelFilter) + "&";
        if (redemptionNotificationChannelFilter !== undefined)
            url_ += "RedemptionNotificationChannelFilter=" + encodeURIComponent("" + redemptionNotificationChannelFilter) + "&";
        if (triggerEventFilter !== undefined)
            url_ += "TriggerEventFilter=" + encodeURIComponent("" + triggerEventFilter) + "&";
        if (eventFilterFilter !== undefined)
            url_ += "EventFilterFilter=" + encodeURIComponent("" + eventFilterFilter) + "&";
        if (isDailyFilter !== undefined)
            url_ += "IsDailyFilter=" + encodeURIComponent("" + isDailyFilter) + "&";
        if (cronFilter !== undefined)
            url_ += "CronFilter=" + encodeURIComponent("" + cronFilter) + "&";
        if (triggerTypeFilter !== undefined)
            url_ += "TriggerTypeFilter=" + encodeURIComponent("" + triggerTypeFilter) + "&";
        if (maxTriggerDateFilter !== undefined)
            url_ += "MaxTriggerDateFilter=" + encodeURIComponent(maxTriggerDateFilter ? "" + maxTriggerDateFilter.toJSON() : "") + "&";
        if (minTriggerDateFilter !== undefined)
            url_ += "MinTriggerDateFilter=" + encodeURIComponent(minTriggerDateFilter ? "" + minTriggerDateFilter.toJSON() : "") + "&";
        if (maxMinBillAmountFilter !== undefined)
            url_ += "MaxMinBillAmountFilter=" + encodeURIComponent("" + maxMinBillAmountFilter) + "&";
        if (minMinBillAmountFilter !== undefined)
            url_ += "MinMinBillAmountFilter=" + encodeURIComponent("" + minMinBillAmountFilter) + "&";
        if (maxQtyRedeemPerPersonFilter !== undefined)
            url_ += "MaxQtyRedeemPerPersonFilter=" + encodeURIComponent("" + maxQtyRedeemPerPersonFilter) + "&";
        if (minQtyRedeemPerPersonFilter !== undefined)
            url_ += "MinQtyRedeemPerPersonFilter=" + encodeURIComponent("" + minQtyRedeemPerPersonFilter) + "&";
        if (maxRewardTargetAudienceIDFilter !== undefined)
            url_ += "MaxRewardTargetAudienceIDFilter=" + encodeURIComponent("" + maxRewardTargetAudienceIDFilter) + "&";
        if (minRewardTargetAudienceIDFilter !== undefined)
            url_ += "MinRewardTargetAudienceIDFilter=" + encodeURIComponent("" + minRewardTargetAudienceIDFilter) + "&";
        if (targetAudienceTypeFilter !== undefined)
            url_ += "TargetAudienceTypeFilter=" + encodeURIComponent("" + targetAudienceTypeFilter) + "&";
        if (isEditableFilter !== undefined)
            url_ += "IsEditableFilter=" + encodeURIComponent("" + isEditableFilter) + "&";
        if (maxMaxDayForPOFilter !== undefined)
            url_ += "MaxMaxDayForPOFilter=" + encodeURIComponent("" + maxMaxDayForPOFilter) + "&";
        if (minMaxDayForPOFilter !== undefined)
            url_ += "MinMaxDayForPOFilter=" + encodeURIComponent("" + minMaxDayForPOFilter) + "&";
        if (referralRewardReceiverFilter !== undefined)
            url_ += "ReferralRewardReceiverFilter=" + encodeURIComponent("" + referralRewardReceiverFilter) + "&";
        if (isGrantedFilter !== undefined)
            url_ += "IsGrantedFilter=" + encodeURIComponent("" + isGrantedFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetVoucherGroupsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVoucherGroupsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<RewardsFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<RewardsFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetVoucherGroupsToExcel(response: HttpResponseBase): Observable<RewardsFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? RewardsFileDto.fromJS(resultData200) : new RewardsFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RewardsFileDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    searchVoucher(input: SearchVoucherGroupInput | null | undefined): Observable<PagedResultDtoOfGetVoucherGroupForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/VoucherGroups/SearchVoucher";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSearchVoucher(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchVoucher(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetVoucherGroupForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetVoucherGroupForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processSearchVoucher(response: HttpResponseBase): Observable<PagedResultDtoOfGetVoucherGroupForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetVoucherGroupForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetVoucherGroupForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetVoucherGroupForViewDto>(<any>null);
    }

    /**
     * @return Success
     */
    getAdvanceSearchData(): Observable<VoucherSettingAdvanceSearchModel> {
        let url_ = this.baseUrl + "/api/services/app/VoucherGroups/GetAdvanceSearchData";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAdvanceSearchData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAdvanceSearchData(<any>response_);
                } catch (e) {
                    return <Observable<VoucherSettingAdvanceSearchModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<VoucherSettingAdvanceSearchModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetAdvanceSearchData(response: HttpResponseBase): Observable<VoucherSettingAdvanceSearchModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? VoucherSettingAdvanceSearchModel.fromJS(resultData200) : new VoucherSettingAdvanceSearchModel();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VoucherSettingAdvanceSearchModel>(<any>null);
    }

    /**
     * @param ids (optional) 
     * @return Success
     */
    batchDelete(ids: number[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/VoucherGroups/BatchDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ids);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processBatchDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBatchDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processBatchDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEditCustom(input: GetVoucherGroupForEditOutput | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/VoucherGroups/CreateOrEditCustom";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEditCustom(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditCustom(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEditCustom(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getVoucherGroupForEditCustom(id: number | null | undefined): Observable<GetVoucherGroupForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/VoucherGroups/GetVoucherGroupForEditCustom?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetVoucherGroupForEditCustom(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVoucherGroupForEditCustom(<any>response_);
                } catch (e) {
                    return <Observable<GetVoucherGroupForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetVoucherGroupForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetVoucherGroupForEditCustom(response: HttpResponseBase): Observable<GetVoucherGroupForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetVoucherGroupForEditOutput.fromJS(resultData200) : new GetVoucherGroupForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetVoucherGroupForEditOutput>(<any>null);
    }

    /**
     * @return Success
     */
    getAllRewardTrigger(): Observable<EventDefinition[]> {
        let url_ = this.baseUrl + "/api/services/app/VoucherGroups/GetAllRewardTrigger";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllRewardTrigger(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllRewardTrigger(<any>response_);
                } catch (e) {
                    return <Observable<EventDefinition[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<EventDefinition[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllRewardTrigger(response: HttpResponseBase): Observable<EventDefinition[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(EventDefinition.fromJS(item));
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EventDefinition[]>(<any>null);
    }

    /**
     * @param voucherGroupCode (optional) 
     * @return Success
     */
    manualGrantVoucher(voucherGroupCode: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/VoucherGroups/ManualGrantVoucher?";
        if (voucherGroupCode !== undefined)
            url_ += "voucherGroupCode=" + encodeURIComponent("" + voucherGroupCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processManualGrantVoucher(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processManualGrantVoucher(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processManualGrantVoucher(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class VoucherPatternsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param patternCodeFilter (optional) 
     * @param patternNameFilter (optional) 
     * @param prefixFilter (optional) 
     * @param charSetFilter (optional) 
     * @param lengthAutoGenStringFilter (optional) 
     * @param postfixFilter (optional) 
     * @param voucherGroupCodeFilter (optional) 
     * @param notesFilter (optional) 
     * @param statusFilter (optional) 
     * @param patternNameUnsignFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, patternCodeFilter: string | null | undefined, patternNameFilter: string | null | undefined, prefixFilter: string | null | undefined, charSetFilter: string | null | undefined, lengthAutoGenStringFilter: string | null | undefined, postfixFilter: string | null | undefined, voucherGroupCodeFilter: string | null | undefined, notesFilter: string | null | undefined, statusFilter: string | null | undefined, patternNameUnsignFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetVoucherPatternForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/VoucherPatterns/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (patternCodeFilter !== undefined)
            url_ += "PatternCodeFilter=" + encodeURIComponent("" + patternCodeFilter) + "&";
        if (patternNameFilter !== undefined)
            url_ += "PatternNameFilter=" + encodeURIComponent("" + patternNameFilter) + "&";
        if (prefixFilter !== undefined)
            url_ += "PrefixFilter=" + encodeURIComponent("" + prefixFilter) + "&";
        if (charSetFilter !== undefined)
            url_ += "CharSetFilter=" + encodeURIComponent("" + charSetFilter) + "&";
        if (lengthAutoGenStringFilter !== undefined)
            url_ += "LengthAutoGenStringFilter=" + encodeURIComponent("" + lengthAutoGenStringFilter) + "&";
        if (postfixFilter !== undefined)
            url_ += "PostfixFilter=" + encodeURIComponent("" + postfixFilter) + "&";
        if (voucherGroupCodeFilter !== undefined)
            url_ += "VoucherGroupCodeFilter=" + encodeURIComponent("" + voucherGroupCodeFilter) + "&";
        if (notesFilter !== undefined)
            url_ += "NotesFilter=" + encodeURIComponent("" + notesFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (patternNameUnsignFilter !== undefined)
            url_ += "PatternNameUnsignFilter=" + encodeURIComponent("" + patternNameUnsignFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetVoucherPatternForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetVoucherPatternForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetVoucherPatternForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetVoucherPatternForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetVoucherPatternForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetVoucherPatternForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getVoucherPatternForEdit(id: number | null | undefined): Observable<GetVoucherPatternForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/VoucherPatterns/GetVoucherPatternForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetVoucherPatternForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVoucherPatternForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetVoucherPatternForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetVoucherPatternForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetVoucherPatternForEdit(response: HttpResponseBase): Observable<GetVoucherPatternForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetVoucherPatternForEditOutput.fromJS(resultData200) : new GetVoucherPatternForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetVoucherPatternForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditVoucherPatternDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/VoucherPatterns/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/VoucherPatterns/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param patternCodeFilter (optional) 
     * @param patternNameFilter (optional) 
     * @param prefixFilter (optional) 
     * @param charSetFilter (optional) 
     * @param lengthAutoGenStringFilter (optional) 
     * @param postfixFilter (optional) 
     * @param voucherGroupCodeFilter (optional) 
     * @param notesFilter (optional) 
     * @param statusFilter (optional) 
     * @param patternNameUnsignFilter (optional) 
     * @return Success
     */
    getVoucherPatternsToExcel(filter: string | null | undefined, patternCodeFilter: string | null | undefined, patternNameFilter: string | null | undefined, prefixFilter: string | null | undefined, charSetFilter: string | null | undefined, lengthAutoGenStringFilter: string | null | undefined, postfixFilter: string | null | undefined, voucherGroupCodeFilter: string | null | undefined, notesFilter: string | null | undefined, statusFilter: string | null | undefined, patternNameUnsignFilter: string | null | undefined): Observable<RewardsFileDto> {
        let url_ = this.baseUrl + "/api/services/app/VoucherPatterns/GetVoucherPatternsToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (patternCodeFilter !== undefined)
            url_ += "PatternCodeFilter=" + encodeURIComponent("" + patternCodeFilter) + "&";
        if (patternNameFilter !== undefined)
            url_ += "PatternNameFilter=" + encodeURIComponent("" + patternNameFilter) + "&";
        if (prefixFilter !== undefined)
            url_ += "PrefixFilter=" + encodeURIComponent("" + prefixFilter) + "&";
        if (charSetFilter !== undefined)
            url_ += "CharSetFilter=" + encodeURIComponent("" + charSetFilter) + "&";
        if (lengthAutoGenStringFilter !== undefined)
            url_ += "LengthAutoGenStringFilter=" + encodeURIComponent("" + lengthAutoGenStringFilter) + "&";
        if (postfixFilter !== undefined)
            url_ += "PostfixFilter=" + encodeURIComponent("" + postfixFilter) + "&";
        if (voucherGroupCodeFilter !== undefined)
            url_ += "VoucherGroupCodeFilter=" + encodeURIComponent("" + voucherGroupCodeFilter) + "&";
        if (notesFilter !== undefined)
            url_ += "NotesFilter=" + encodeURIComponent("" + notesFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (patternNameUnsignFilter !== undefined)
            url_ += "PatternNameUnsignFilter=" + encodeURIComponent("" + patternNameUnsignFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetVoucherPatternsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVoucherPatternsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<RewardsFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<RewardsFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetVoucherPatternsToExcel(response: HttpResponseBase): Observable<RewardsFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? RewardsFileDto.fromJS(resultData200) : new RewardsFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RewardsFileDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param patternCodeFilter (optional) 
     * @param patternNameFilter (optional) 
     * @param prefixFilter (optional) 
     * @param charSetFilter (optional) 
     * @param lengthAutoGenStringFilter (optional) 
     * @param postfixFilter (optional) 
     * @param voucherGroupCodeFilter (optional) 
     * @param notesFilter (optional) 
     * @param statusFilter (optional) 
     * @param patternNameUnsignFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllExt(filter: string | null | undefined, patternCodeFilter: string | null | undefined, patternNameFilter: string | null | undefined, prefixFilter: string | null | undefined, charSetFilter: string | null | undefined, lengthAutoGenStringFilter: string | null | undefined, postfixFilter: string | null | undefined, voucherGroupCodeFilter: string | null | undefined, notesFilter: string | null | undefined, statusFilter: string | null | undefined, patternNameUnsignFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetVoucherPatternForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/VoucherPatterns/GetAllExt?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (patternCodeFilter !== undefined)
            url_ += "PatternCodeFilter=" + encodeURIComponent("" + patternCodeFilter) + "&";
        if (patternNameFilter !== undefined)
            url_ += "PatternNameFilter=" + encodeURIComponent("" + patternNameFilter) + "&";
        if (prefixFilter !== undefined)
            url_ += "PrefixFilter=" + encodeURIComponent("" + prefixFilter) + "&";
        if (charSetFilter !== undefined)
            url_ += "CharSetFilter=" + encodeURIComponent("" + charSetFilter) + "&";
        if (lengthAutoGenStringFilter !== undefined)
            url_ += "LengthAutoGenStringFilter=" + encodeURIComponent("" + lengthAutoGenStringFilter) + "&";
        if (postfixFilter !== undefined)
            url_ += "PostfixFilter=" + encodeURIComponent("" + postfixFilter) + "&";
        if (voucherGroupCodeFilter !== undefined)
            url_ += "VoucherGroupCodeFilter=" + encodeURIComponent("" + voucherGroupCodeFilter) + "&";
        if (notesFilter !== undefined)
            url_ += "NotesFilter=" + encodeURIComponent("" + notesFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (patternNameUnsignFilter !== undefined)
            url_ += "PatternNameUnsignFilter=" + encodeURIComponent("" + patternNameUnsignFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllExt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllExt(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetVoucherPatternForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetVoucherPatternForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllExt(response: HttpResponseBase): Observable<PagedResultDtoOfGetVoucherPatternForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetVoucherPatternForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetVoucherPatternForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetVoucherPatternForViewDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    batchDelete(input: EntityDto[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/VoucherPatterns/BatchDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processBatchDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBatchDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processBatchDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param voucherGroupCode (optional) 
     * @return Success
     */
    getVoucherGroup(voucherGroupCode: string | null | undefined): Observable<GetVoucherGroupForPatternDto[]> {
        let url_ = this.baseUrl + "/api/services/app/VoucherPatterns/GetVoucherGroup?";
        if (voucherGroupCode !== undefined)
            url_ += "voucherGroupCode=" + encodeURIComponent("" + voucherGroupCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetVoucherGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVoucherGroup(<any>response_);
                } catch (e) {
                    return <Observable<GetVoucherGroupForPatternDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetVoucherGroupForPatternDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetVoucherGroup(response: HttpResponseBase): Observable<GetVoucherGroupForPatternDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(GetVoucherGroupForPatternDto.fromJS(item));
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetVoucherGroupForPatternDto[]>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEditExt(input: CreateOrEditVoucherPatternDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/VoucherPatterns/CreateOrEditExt";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEditExt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditExt(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEditExt(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    isExistPrefix(input: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/VoucherPatterns/IsExistPrefix?";
        if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processIsExistPrefix(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsExistPrefix(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processIsExistPrefix(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    isExistPostfix(input: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/VoucherPatterns/IsExistPostfix?";
        if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processIsExistPostfix(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsExistPostfix(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processIsExistPostfix(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }
}

@Injectable()
export class VoucherReportServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    loadConditionSearch(): Observable<ConditionFilterVoucherReport> {
        let url_ = this.baseUrl + "/api/services/app/VoucherReport/LoadConditionSearch";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processLoadConditionSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLoadConditionSearch(<any>response_);
                } catch (e) {
                    return <Observable<ConditionFilterVoucherReport>><any>_observableThrow(e);
                }
            } else
                return <Observable<ConditionFilterVoucherReport>><any>_observableThrow(response_);
        }));
    }

    protected processLoadConditionSearch(response: HttpResponseBase): Observable<ConditionFilterVoucherReport> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? ConditionFilterVoucherReport.fromJS(resultData200) : new ConditionFilterVoucherReport();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ConditionFilterVoucherReport>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    searchVoucherReport(input: VoucherReportInput | null | undefined): Observable<PagedResultDtoOfVoucherReportForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/VoucherReport/SearchVoucherReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSearchVoucherReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchVoucherReport(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfVoucherReportForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfVoucherReportForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processSearchVoucherReport(response: HttpResponseBase): Observable<PagedResultDtoOfVoucherReportForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfVoucherReportForViewDto.fromJS(resultData200) : new PagedResultDtoOfVoucherReportForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfVoucherReportForViewDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    loadVoucherReportDetail(input: VoucherReportDetailInput | null | undefined): Observable<PagedResultDtoOfVoucherReportDetailForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/VoucherReport/LoadVoucherReportDetail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processLoadVoucherReportDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLoadVoucherReportDetail(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfVoucherReportDetailForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfVoucherReportDetailForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processLoadVoucherReportDetail(response: HttpResponseBase): Observable<PagedResultDtoOfVoucherReportDetailForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfVoucherReportDetailForViewDto.fromJS(resultData200) : new PagedResultDtoOfVoucherReportDetailForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfVoucherReportDetailForViewDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    exportVoucherReportExcel(input: VoucherReportInput | null | undefined): Observable<RewardsFileDto> {
        let url_ = this.baseUrl + "/api/services/app/VoucherReport/exportVoucherReportExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processExportVoucherReportExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportVoucherReportExcel(<any>response_);
                } catch (e) {
                    return <Observable<RewardsFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<RewardsFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processExportVoucherReportExcel(response: HttpResponseBase): Observable<RewardsFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? RewardsFileDto.fromJS(resultData200) : new RewardsFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RewardsFileDto>(<any>null);
    }
}

@Injectable()
export class VoucherTransactionLogsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param voucherCodeFilter (optional) 
     * @param voucherUserFilter (optional) 
     * @param voucherGroupCodeFilter (optional) 
     * @param patternCodeFilter (optional) 
     * @param publisherCodeFilter (optional) 
     * @param maxTerminalIDFilter (optional) 
     * @param minTerminalIDFilter (optional) 
     * @param maxTerminalTimeFilter (optional) 
     * @param minTerminalTimeFilter (optional) 
     * @param maxRedemptionTimeFilter (optional) 
     * @param minRedemptionTimeFilter (optional) 
     * @param maxIssuedTimeFilter (optional) 
     * @param minIssuedTimeFilter (optional) 
     * @param maxRedemptionStartTimeFilter (optional) 
     * @param minRedemptionStartTimeFilter (optional) 
     * @param maxRedemptionEndTimeFilter (optional) 
     * @param minRedemptionEndTimeFilter (optional) 
     * @param notesFilter (optional) 
     * @param statusFilter (optional) 
     * @param referenceCodeFilter (optional) 
     * @param maxMaxPaperPrintFilter (optional) 
     * @param minMaxPaperPrintFilter (optional) 
     * @param maxMaxSlipPrintFilter (optional) 
     * @param minMaxSlipPrintFilter (optional) 
     * @param maxCurrentPaperPrintFilter (optional) 
     * @param minCurrentPaperPrintFilter (optional) 
     * @param maxCurrentSlipPrintFilter (optional) 
     * @param minCurrentSlipPrintFilter (optional) 
     * @param triggerEventFilter (optional) 
     * @param eventFilterFilter (optional) 
     * @param transactionStatusFilter (optional) 
     * @param transactionTypeFilter (optional) 
     * @param messageFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, voucherCodeFilter: string | null | undefined, voucherUserFilter: string | null | undefined, voucherGroupCodeFilter: string | null | undefined, patternCodeFilter: string | null | undefined, publisherCodeFilter: string | null | undefined, maxTerminalIDFilter: number | null | undefined, minTerminalIDFilter: number | null | undefined, maxTerminalTimeFilter: moment.Moment | null | undefined, minTerminalTimeFilter: moment.Moment | null | undefined, maxRedemptionTimeFilter: moment.Moment | null | undefined, minRedemptionTimeFilter: moment.Moment | null | undefined, maxIssuedTimeFilter: moment.Moment | null | undefined, minIssuedTimeFilter: moment.Moment | null | undefined, maxRedemptionStartTimeFilter: moment.Moment | null | undefined, minRedemptionStartTimeFilter: moment.Moment | null | undefined, maxRedemptionEndTimeFilter: moment.Moment | null | undefined, minRedemptionEndTimeFilter: moment.Moment | null | undefined, notesFilter: string | null | undefined, statusFilter: string | null | undefined, referenceCodeFilter: string | null | undefined, maxMaxPaperPrintFilter: number | null | undefined, minMaxPaperPrintFilter: number | null | undefined, maxMaxSlipPrintFilter: number | null | undefined, minMaxSlipPrintFilter: number | null | undefined, maxCurrentPaperPrintFilter: number | null | undefined, minCurrentPaperPrintFilter: number | null | undefined, maxCurrentSlipPrintFilter: number | null | undefined, minCurrentSlipPrintFilter: number | null | undefined, triggerEventFilter: string | null | undefined, eventFilterFilter: string | null | undefined, transactionStatusFilter: string | null | undefined, transactionTypeFilter: string | null | undefined, messageFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetVoucherTransactionLogForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/VoucherTransactionLogs/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (voucherCodeFilter !== undefined)
            url_ += "VoucherCodeFilter=" + encodeURIComponent("" + voucherCodeFilter) + "&";
        if (voucherUserFilter !== undefined)
            url_ += "VoucherUserFilter=" + encodeURIComponent("" + voucherUserFilter) + "&";
        if (voucherGroupCodeFilter !== undefined)
            url_ += "VoucherGroupCodeFilter=" + encodeURIComponent("" + voucherGroupCodeFilter) + "&";
        if (patternCodeFilter !== undefined)
            url_ += "PatternCodeFilter=" + encodeURIComponent("" + patternCodeFilter) + "&";
        if (publisherCodeFilter !== undefined)
            url_ += "PublisherCodeFilter=" + encodeURIComponent("" + publisherCodeFilter) + "&";
        if (maxTerminalIDFilter !== undefined)
            url_ += "MaxTerminalIDFilter=" + encodeURIComponent("" + maxTerminalIDFilter) + "&";
        if (minTerminalIDFilter !== undefined)
            url_ += "MinTerminalIDFilter=" + encodeURIComponent("" + minTerminalIDFilter) + "&";
        if (maxTerminalTimeFilter !== undefined)
            url_ += "MaxTerminalTimeFilter=" + encodeURIComponent(maxTerminalTimeFilter ? "" + maxTerminalTimeFilter.toJSON() : "") + "&";
        if (minTerminalTimeFilter !== undefined)
            url_ += "MinTerminalTimeFilter=" + encodeURIComponent(minTerminalTimeFilter ? "" + minTerminalTimeFilter.toJSON() : "") + "&";
        if (maxRedemptionTimeFilter !== undefined)
            url_ += "MaxRedemptionTimeFilter=" + encodeURIComponent(maxRedemptionTimeFilter ? "" + maxRedemptionTimeFilter.toJSON() : "") + "&";
        if (minRedemptionTimeFilter !== undefined)
            url_ += "MinRedemptionTimeFilter=" + encodeURIComponent(minRedemptionTimeFilter ? "" + minRedemptionTimeFilter.toJSON() : "") + "&";
        if (maxIssuedTimeFilter !== undefined)
            url_ += "MaxIssuedTimeFilter=" + encodeURIComponent(maxIssuedTimeFilter ? "" + maxIssuedTimeFilter.toJSON() : "") + "&";
        if (minIssuedTimeFilter !== undefined)
            url_ += "MinIssuedTimeFilter=" + encodeURIComponent(minIssuedTimeFilter ? "" + minIssuedTimeFilter.toJSON() : "") + "&";
        if (maxRedemptionStartTimeFilter !== undefined)
            url_ += "MaxRedemptionStartTimeFilter=" + encodeURIComponent(maxRedemptionStartTimeFilter ? "" + maxRedemptionStartTimeFilter.toJSON() : "") + "&";
        if (minRedemptionStartTimeFilter !== undefined)
            url_ += "MinRedemptionStartTimeFilter=" + encodeURIComponent(minRedemptionStartTimeFilter ? "" + minRedemptionStartTimeFilter.toJSON() : "") + "&";
        if (maxRedemptionEndTimeFilter !== undefined)
            url_ += "MaxRedemptionEndTimeFilter=" + encodeURIComponent(maxRedemptionEndTimeFilter ? "" + maxRedemptionEndTimeFilter.toJSON() : "") + "&";
        if (minRedemptionEndTimeFilter !== undefined)
            url_ += "MinRedemptionEndTimeFilter=" + encodeURIComponent(minRedemptionEndTimeFilter ? "" + minRedemptionEndTimeFilter.toJSON() : "") + "&";
        if (notesFilter !== undefined)
            url_ += "NotesFilter=" + encodeURIComponent("" + notesFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (referenceCodeFilter !== undefined)
            url_ += "ReferenceCodeFilter=" + encodeURIComponent("" + referenceCodeFilter) + "&";
        if (maxMaxPaperPrintFilter !== undefined)
            url_ += "MaxMaxPaperPrintFilter=" + encodeURIComponent("" + maxMaxPaperPrintFilter) + "&";
        if (minMaxPaperPrintFilter !== undefined)
            url_ += "MinMaxPaperPrintFilter=" + encodeURIComponent("" + minMaxPaperPrintFilter) + "&";
        if (maxMaxSlipPrintFilter !== undefined)
            url_ += "MaxMaxSlipPrintFilter=" + encodeURIComponent("" + maxMaxSlipPrintFilter) + "&";
        if (minMaxSlipPrintFilter !== undefined)
            url_ += "MinMaxSlipPrintFilter=" + encodeURIComponent("" + minMaxSlipPrintFilter) + "&";
        if (maxCurrentPaperPrintFilter !== undefined)
            url_ += "MaxCurrentPaperPrintFilter=" + encodeURIComponent("" + maxCurrentPaperPrintFilter) + "&";
        if (minCurrentPaperPrintFilter !== undefined)
            url_ += "MinCurrentPaperPrintFilter=" + encodeURIComponent("" + minCurrentPaperPrintFilter) + "&";
        if (maxCurrentSlipPrintFilter !== undefined)
            url_ += "MaxCurrentSlipPrintFilter=" + encodeURIComponent("" + maxCurrentSlipPrintFilter) + "&";
        if (minCurrentSlipPrintFilter !== undefined)
            url_ += "MinCurrentSlipPrintFilter=" + encodeURIComponent("" + minCurrentSlipPrintFilter) + "&";
        if (triggerEventFilter !== undefined)
            url_ += "TriggerEventFilter=" + encodeURIComponent("" + triggerEventFilter) + "&";
        if (eventFilterFilter !== undefined)
            url_ += "EventFilterFilter=" + encodeURIComponent("" + eventFilterFilter) + "&";
        if (transactionStatusFilter !== undefined)
            url_ += "TransactionStatusFilter=" + encodeURIComponent("" + transactionStatusFilter) + "&";
        if (transactionTypeFilter !== undefined)
            url_ += "TransactionTypeFilter=" + encodeURIComponent("" + transactionTypeFilter) + "&";
        if (messageFilter !== undefined)
            url_ += "MessageFilter=" + encodeURIComponent("" + messageFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetVoucherTransactionLogForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetVoucherTransactionLogForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetVoucherTransactionLogForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetVoucherTransactionLogForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetVoucherTransactionLogForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetVoucherTransactionLogForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getVoucherTransactionLogForEdit(id: number | null | undefined): Observable<GetVoucherTransactionLogForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/VoucherTransactionLogs/GetVoucherTransactionLogForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetVoucherTransactionLogForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVoucherTransactionLogForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetVoucherTransactionLogForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetVoucherTransactionLogForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetVoucherTransactionLogForEdit(response: HttpResponseBase): Observable<GetVoucherTransactionLogForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetVoucherTransactionLogForEditOutput.fromJS(resultData200) : new GetVoucherTransactionLogForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetVoucherTransactionLogForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditVoucherTransactionLogDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/VoucherTransactionLogs/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/VoucherTransactionLogs/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param voucherCodeFilter (optional) 
     * @param voucherUserFilter (optional) 
     * @param voucherGroupCodeFilter (optional) 
     * @param patternCodeFilter (optional) 
     * @param publisherCodeFilter (optional) 
     * @param maxTerminalIDFilter (optional) 
     * @param minTerminalIDFilter (optional) 
     * @param maxTerminalTimeFilter (optional) 
     * @param minTerminalTimeFilter (optional) 
     * @param maxRedemptionTimeFilter (optional) 
     * @param minRedemptionTimeFilter (optional) 
     * @param maxIssuedTimeFilter (optional) 
     * @param minIssuedTimeFilter (optional) 
     * @param maxRedemptionStartTimeFilter (optional) 
     * @param minRedemptionStartTimeFilter (optional) 
     * @param maxRedemptionEndTimeFilter (optional) 
     * @param minRedemptionEndTimeFilter (optional) 
     * @param notesFilter (optional) 
     * @param statusFilter (optional) 
     * @param referenceCodeFilter (optional) 
     * @param maxMaxPaperPrintFilter (optional) 
     * @param minMaxPaperPrintFilter (optional) 
     * @param maxMaxSlipPrintFilter (optional) 
     * @param minMaxSlipPrintFilter (optional) 
     * @param maxCurrentPaperPrintFilter (optional) 
     * @param minCurrentPaperPrintFilter (optional) 
     * @param maxCurrentSlipPrintFilter (optional) 
     * @param minCurrentSlipPrintFilter (optional) 
     * @param triggerEventFilter (optional) 
     * @param eventFilterFilter (optional) 
     * @param transactionStatusFilter (optional) 
     * @param transactionTypeFilter (optional) 
     * @param messageFilter (optional) 
     * @return Success
     */
    getVoucherTransactionLogsToExcel(filter: string | null | undefined, voucherCodeFilter: string | null | undefined, voucherUserFilter: string | null | undefined, voucherGroupCodeFilter: string | null | undefined, patternCodeFilter: string | null | undefined, publisherCodeFilter: string | null | undefined, maxTerminalIDFilter: number | null | undefined, minTerminalIDFilter: number | null | undefined, maxTerminalTimeFilter: moment.Moment | null | undefined, minTerminalTimeFilter: moment.Moment | null | undefined, maxRedemptionTimeFilter: moment.Moment | null | undefined, minRedemptionTimeFilter: moment.Moment | null | undefined, maxIssuedTimeFilter: moment.Moment | null | undefined, minIssuedTimeFilter: moment.Moment | null | undefined, maxRedemptionStartTimeFilter: moment.Moment | null | undefined, minRedemptionStartTimeFilter: moment.Moment | null | undefined, maxRedemptionEndTimeFilter: moment.Moment | null | undefined, minRedemptionEndTimeFilter: moment.Moment | null | undefined, notesFilter: string | null | undefined, statusFilter: string | null | undefined, referenceCodeFilter: string | null | undefined, maxMaxPaperPrintFilter: number | null | undefined, minMaxPaperPrintFilter: number | null | undefined, maxMaxSlipPrintFilter: number | null | undefined, minMaxSlipPrintFilter: number | null | undefined, maxCurrentPaperPrintFilter: number | null | undefined, minCurrentPaperPrintFilter: number | null | undefined, maxCurrentSlipPrintFilter: number | null | undefined, minCurrentSlipPrintFilter: number | null | undefined, triggerEventFilter: string | null | undefined, eventFilterFilter: string | null | undefined, transactionStatusFilter: string | null | undefined, transactionTypeFilter: string | null | undefined, messageFilter: string | null | undefined): Observable<RewardsFileDto> {
        let url_ = this.baseUrl + "/api/services/app/VoucherTransactionLogs/GetVoucherTransactionLogsToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (voucherCodeFilter !== undefined)
            url_ += "VoucherCodeFilter=" + encodeURIComponent("" + voucherCodeFilter) + "&";
        if (voucherUserFilter !== undefined)
            url_ += "VoucherUserFilter=" + encodeURIComponent("" + voucherUserFilter) + "&";
        if (voucherGroupCodeFilter !== undefined)
            url_ += "VoucherGroupCodeFilter=" + encodeURIComponent("" + voucherGroupCodeFilter) + "&";
        if (patternCodeFilter !== undefined)
            url_ += "PatternCodeFilter=" + encodeURIComponent("" + patternCodeFilter) + "&";
        if (publisherCodeFilter !== undefined)
            url_ += "PublisherCodeFilter=" + encodeURIComponent("" + publisherCodeFilter) + "&";
        if (maxTerminalIDFilter !== undefined)
            url_ += "MaxTerminalIDFilter=" + encodeURIComponent("" + maxTerminalIDFilter) + "&";
        if (minTerminalIDFilter !== undefined)
            url_ += "MinTerminalIDFilter=" + encodeURIComponent("" + minTerminalIDFilter) + "&";
        if (maxTerminalTimeFilter !== undefined)
            url_ += "MaxTerminalTimeFilter=" + encodeURIComponent(maxTerminalTimeFilter ? "" + maxTerminalTimeFilter.toJSON() : "") + "&";
        if (minTerminalTimeFilter !== undefined)
            url_ += "MinTerminalTimeFilter=" + encodeURIComponent(minTerminalTimeFilter ? "" + minTerminalTimeFilter.toJSON() : "") + "&";
        if (maxRedemptionTimeFilter !== undefined)
            url_ += "MaxRedemptionTimeFilter=" + encodeURIComponent(maxRedemptionTimeFilter ? "" + maxRedemptionTimeFilter.toJSON() : "") + "&";
        if (minRedemptionTimeFilter !== undefined)
            url_ += "MinRedemptionTimeFilter=" + encodeURIComponent(minRedemptionTimeFilter ? "" + minRedemptionTimeFilter.toJSON() : "") + "&";
        if (maxIssuedTimeFilter !== undefined)
            url_ += "MaxIssuedTimeFilter=" + encodeURIComponent(maxIssuedTimeFilter ? "" + maxIssuedTimeFilter.toJSON() : "") + "&";
        if (minIssuedTimeFilter !== undefined)
            url_ += "MinIssuedTimeFilter=" + encodeURIComponent(minIssuedTimeFilter ? "" + minIssuedTimeFilter.toJSON() : "") + "&";
        if (maxRedemptionStartTimeFilter !== undefined)
            url_ += "MaxRedemptionStartTimeFilter=" + encodeURIComponent(maxRedemptionStartTimeFilter ? "" + maxRedemptionStartTimeFilter.toJSON() : "") + "&";
        if (minRedemptionStartTimeFilter !== undefined)
            url_ += "MinRedemptionStartTimeFilter=" + encodeURIComponent(minRedemptionStartTimeFilter ? "" + minRedemptionStartTimeFilter.toJSON() : "") + "&";
        if (maxRedemptionEndTimeFilter !== undefined)
            url_ += "MaxRedemptionEndTimeFilter=" + encodeURIComponent(maxRedemptionEndTimeFilter ? "" + maxRedemptionEndTimeFilter.toJSON() : "") + "&";
        if (minRedemptionEndTimeFilter !== undefined)
            url_ += "MinRedemptionEndTimeFilter=" + encodeURIComponent(minRedemptionEndTimeFilter ? "" + minRedemptionEndTimeFilter.toJSON() : "") + "&";
        if (notesFilter !== undefined)
            url_ += "NotesFilter=" + encodeURIComponent("" + notesFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (referenceCodeFilter !== undefined)
            url_ += "ReferenceCodeFilter=" + encodeURIComponent("" + referenceCodeFilter) + "&";
        if (maxMaxPaperPrintFilter !== undefined)
            url_ += "MaxMaxPaperPrintFilter=" + encodeURIComponent("" + maxMaxPaperPrintFilter) + "&";
        if (minMaxPaperPrintFilter !== undefined)
            url_ += "MinMaxPaperPrintFilter=" + encodeURIComponent("" + minMaxPaperPrintFilter) + "&";
        if (maxMaxSlipPrintFilter !== undefined)
            url_ += "MaxMaxSlipPrintFilter=" + encodeURIComponent("" + maxMaxSlipPrintFilter) + "&";
        if (minMaxSlipPrintFilter !== undefined)
            url_ += "MinMaxSlipPrintFilter=" + encodeURIComponent("" + minMaxSlipPrintFilter) + "&";
        if (maxCurrentPaperPrintFilter !== undefined)
            url_ += "MaxCurrentPaperPrintFilter=" + encodeURIComponent("" + maxCurrentPaperPrintFilter) + "&";
        if (minCurrentPaperPrintFilter !== undefined)
            url_ += "MinCurrentPaperPrintFilter=" + encodeURIComponent("" + minCurrentPaperPrintFilter) + "&";
        if (maxCurrentSlipPrintFilter !== undefined)
            url_ += "MaxCurrentSlipPrintFilter=" + encodeURIComponent("" + maxCurrentSlipPrintFilter) + "&";
        if (minCurrentSlipPrintFilter !== undefined)
            url_ += "MinCurrentSlipPrintFilter=" + encodeURIComponent("" + minCurrentSlipPrintFilter) + "&";
        if (triggerEventFilter !== undefined)
            url_ += "TriggerEventFilter=" + encodeURIComponent("" + triggerEventFilter) + "&";
        if (eventFilterFilter !== undefined)
            url_ += "EventFilterFilter=" + encodeURIComponent("" + eventFilterFilter) + "&";
        if (transactionStatusFilter !== undefined)
            url_ += "TransactionStatusFilter=" + encodeURIComponent("" + transactionStatusFilter) + "&";
        if (transactionTypeFilter !== undefined)
            url_ += "TransactionTypeFilter=" + encodeURIComponent("" + transactionTypeFilter) + "&";
        if (messageFilter !== undefined)
            url_ += "MessageFilter=" + encodeURIComponent("" + messageFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetVoucherTransactionLogsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVoucherTransactionLogsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<RewardsFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<RewardsFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetVoucherTransactionLogsToExcel(response: HttpResponseBase): Observable<RewardsFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? RewardsFileDto.fromJS(resultData200) : new RewardsFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RewardsFileDto>(<any>null);
    }
}

@Injectable()
export class VoucherTransactionsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param voucherCodeFilter (optional) 
     * @param voucherUserFilter (optional) 
     * @param voucherGroupCodeFilter (optional) 
     * @param patternCodeFilter (optional) 
     * @param publisherCodeFilter (optional) 
     * @param maxIssuedTimeFilter (optional) 
     * @param minIssuedTimeFilter (optional) 
     * @param maxRedemptionStartTimeFilter (optional) 
     * @param minRedemptionStartTimeFilter (optional) 
     * @param maxRedemptionEndTimeFilter (optional) 
     * @param minRedemptionEndTimeFilter (optional) 
     * @param notesFilter (optional) 
     * @param statusFilter (optional) 
     * @param referenceCodeFilter (optional) 
     * @param maxMaxPaperPrintFilter (optional) 
     * @param minMaxPaperPrintFilter (optional) 
     * @param maxCurrentPaperPrintFilter (optional) 
     * @param minCurrentPaperPrintFilter (optional) 
     * @param triggerEventFilter (optional) 
     * @param eventFilterFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, voucherCodeFilter: string | null | undefined, voucherUserFilter: string | null | undefined, voucherGroupCodeFilter: string | null | undefined, patternCodeFilter: string | null | undefined, publisherCodeFilter: string | null | undefined, maxIssuedTimeFilter: moment.Moment | null | undefined, minIssuedTimeFilter: moment.Moment | null | undefined, maxRedemptionStartTimeFilter: moment.Moment | null | undefined, minRedemptionStartTimeFilter: moment.Moment | null | undefined, maxRedemptionEndTimeFilter: moment.Moment | null | undefined, minRedemptionEndTimeFilter: moment.Moment | null | undefined, notesFilter: string | null | undefined, statusFilter: string | null | undefined, referenceCodeFilter: string | null | undefined, maxMaxPaperPrintFilter: number | null | undefined, minMaxPaperPrintFilter: number | null | undefined, maxCurrentPaperPrintFilter: number | null | undefined, minCurrentPaperPrintFilter: number | null | undefined, triggerEventFilter: string | null | undefined, eventFilterFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetVoucherTransactionForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/VoucherTransactions/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (voucherCodeFilter !== undefined)
            url_ += "VoucherCodeFilter=" + encodeURIComponent("" + voucherCodeFilter) + "&";
        if (voucherUserFilter !== undefined)
            url_ += "VoucherUserFilter=" + encodeURIComponent("" + voucherUserFilter) + "&";
        if (voucherGroupCodeFilter !== undefined)
            url_ += "VoucherGroupCodeFilter=" + encodeURIComponent("" + voucherGroupCodeFilter) + "&";
        if (patternCodeFilter !== undefined)
            url_ += "PatternCodeFilter=" + encodeURIComponent("" + patternCodeFilter) + "&";
        if (publisherCodeFilter !== undefined)
            url_ += "PublisherCodeFilter=" + encodeURIComponent("" + publisherCodeFilter) + "&";
        if (maxIssuedTimeFilter !== undefined)
            url_ += "MaxIssuedTimeFilter=" + encodeURIComponent(maxIssuedTimeFilter ? "" + maxIssuedTimeFilter.toJSON() : "") + "&";
        if (minIssuedTimeFilter !== undefined)
            url_ += "MinIssuedTimeFilter=" + encodeURIComponent(minIssuedTimeFilter ? "" + minIssuedTimeFilter.toJSON() : "") + "&";
        if (maxRedemptionStartTimeFilter !== undefined)
            url_ += "MaxRedemptionStartTimeFilter=" + encodeURIComponent(maxRedemptionStartTimeFilter ? "" + maxRedemptionStartTimeFilter.toJSON() : "") + "&";
        if (minRedemptionStartTimeFilter !== undefined)
            url_ += "MinRedemptionStartTimeFilter=" + encodeURIComponent(minRedemptionStartTimeFilter ? "" + minRedemptionStartTimeFilter.toJSON() : "") + "&";
        if (maxRedemptionEndTimeFilter !== undefined)
            url_ += "MaxRedemptionEndTimeFilter=" + encodeURIComponent(maxRedemptionEndTimeFilter ? "" + maxRedemptionEndTimeFilter.toJSON() : "") + "&";
        if (minRedemptionEndTimeFilter !== undefined)
            url_ += "MinRedemptionEndTimeFilter=" + encodeURIComponent(minRedemptionEndTimeFilter ? "" + minRedemptionEndTimeFilter.toJSON() : "") + "&";
        if (notesFilter !== undefined)
            url_ += "NotesFilter=" + encodeURIComponent("" + notesFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (referenceCodeFilter !== undefined)
            url_ += "ReferenceCodeFilter=" + encodeURIComponent("" + referenceCodeFilter) + "&";
        if (maxMaxPaperPrintFilter !== undefined)
            url_ += "MaxMaxPaperPrintFilter=" + encodeURIComponent("" + maxMaxPaperPrintFilter) + "&";
        if (minMaxPaperPrintFilter !== undefined)
            url_ += "MinMaxPaperPrintFilter=" + encodeURIComponent("" + minMaxPaperPrintFilter) + "&";
        if (maxCurrentPaperPrintFilter !== undefined)
            url_ += "MaxCurrentPaperPrintFilter=" + encodeURIComponent("" + maxCurrentPaperPrintFilter) + "&";
        if (minCurrentPaperPrintFilter !== undefined)
            url_ += "MinCurrentPaperPrintFilter=" + encodeURIComponent("" + minCurrentPaperPrintFilter) + "&";
        if (triggerEventFilter !== undefined)
            url_ += "TriggerEventFilter=" + encodeURIComponent("" + triggerEventFilter) + "&";
        if (eventFilterFilter !== undefined)
            url_ += "EventFilterFilter=" + encodeURIComponent("" + eventFilterFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetVoucherTransactionForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetVoucherTransactionForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetVoucherTransactionForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetVoucherTransactionForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetVoucherTransactionForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetVoucherTransactionForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getVoucherTransactionForEdit(id: number | null | undefined): Observable<GetVoucherTransactionForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/VoucherTransactions/GetVoucherTransactionForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetVoucherTransactionForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVoucherTransactionForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetVoucherTransactionForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetVoucherTransactionForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetVoucherTransactionForEdit(response: HttpResponseBase): Observable<GetVoucherTransactionForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetVoucherTransactionForEditOutput.fromJS(resultData200) : new GetVoucherTransactionForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetVoucherTransactionForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditVoucherTransactionDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/VoucherTransactions/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/VoucherTransactions/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param voucherCodeFilter (optional) 
     * @param voucherUserFilter (optional) 
     * @param voucherGroupCodeFilter (optional) 
     * @param patternCodeFilter (optional) 
     * @param publisherCodeFilter (optional) 
     * @param maxIssuedTimeFilter (optional) 
     * @param minIssuedTimeFilter (optional) 
     * @param maxRedemptionStartTimeFilter (optional) 
     * @param minRedemptionStartTimeFilter (optional) 
     * @param maxRedemptionEndTimeFilter (optional) 
     * @param minRedemptionEndTimeFilter (optional) 
     * @param notesFilter (optional) 
     * @param statusFilter (optional) 
     * @param referenceCodeFilter (optional) 
     * @param maxMaxPaperPrintFilter (optional) 
     * @param minMaxPaperPrintFilter (optional) 
     * @param maxCurrentPaperPrintFilter (optional) 
     * @param minCurrentPaperPrintFilter (optional) 
     * @param triggerEventFilter (optional) 
     * @param eventFilterFilter (optional) 
     * @return Success
     */
    getVoucherTransactionsToExcel(filter: string | null | undefined, voucherCodeFilter: string | null | undefined, voucherUserFilter: string | null | undefined, voucherGroupCodeFilter: string | null | undefined, patternCodeFilter: string | null | undefined, publisherCodeFilter: string | null | undefined, maxIssuedTimeFilter: moment.Moment | null | undefined, minIssuedTimeFilter: moment.Moment | null | undefined, maxRedemptionStartTimeFilter: moment.Moment | null | undefined, minRedemptionStartTimeFilter: moment.Moment | null | undefined, maxRedemptionEndTimeFilter: moment.Moment | null | undefined, minRedemptionEndTimeFilter: moment.Moment | null | undefined, notesFilter: string | null | undefined, statusFilter: string | null | undefined, referenceCodeFilter: string | null | undefined, maxMaxPaperPrintFilter: number | null | undefined, minMaxPaperPrintFilter: number | null | undefined, maxCurrentPaperPrintFilter: number | null | undefined, minCurrentPaperPrintFilter: number | null | undefined, triggerEventFilter: string | null | undefined, eventFilterFilter: string | null | undefined): Observable<RewardsFileDto> {
        let url_ = this.baseUrl + "/api/services/app/VoucherTransactions/GetVoucherTransactionsToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (voucherCodeFilter !== undefined)
            url_ += "VoucherCodeFilter=" + encodeURIComponent("" + voucherCodeFilter) + "&";
        if (voucherUserFilter !== undefined)
            url_ += "VoucherUserFilter=" + encodeURIComponent("" + voucherUserFilter) + "&";
        if (voucherGroupCodeFilter !== undefined)
            url_ += "VoucherGroupCodeFilter=" + encodeURIComponent("" + voucherGroupCodeFilter) + "&";
        if (patternCodeFilter !== undefined)
            url_ += "PatternCodeFilter=" + encodeURIComponent("" + patternCodeFilter) + "&";
        if (publisherCodeFilter !== undefined)
            url_ += "PublisherCodeFilter=" + encodeURIComponent("" + publisherCodeFilter) + "&";
        if (maxIssuedTimeFilter !== undefined)
            url_ += "MaxIssuedTimeFilter=" + encodeURIComponent(maxIssuedTimeFilter ? "" + maxIssuedTimeFilter.toJSON() : "") + "&";
        if (minIssuedTimeFilter !== undefined)
            url_ += "MinIssuedTimeFilter=" + encodeURIComponent(minIssuedTimeFilter ? "" + minIssuedTimeFilter.toJSON() : "") + "&";
        if (maxRedemptionStartTimeFilter !== undefined)
            url_ += "MaxRedemptionStartTimeFilter=" + encodeURIComponent(maxRedemptionStartTimeFilter ? "" + maxRedemptionStartTimeFilter.toJSON() : "") + "&";
        if (minRedemptionStartTimeFilter !== undefined)
            url_ += "MinRedemptionStartTimeFilter=" + encodeURIComponent(minRedemptionStartTimeFilter ? "" + minRedemptionStartTimeFilter.toJSON() : "") + "&";
        if (maxRedemptionEndTimeFilter !== undefined)
            url_ += "MaxRedemptionEndTimeFilter=" + encodeURIComponent(maxRedemptionEndTimeFilter ? "" + maxRedemptionEndTimeFilter.toJSON() : "") + "&";
        if (minRedemptionEndTimeFilter !== undefined)
            url_ += "MinRedemptionEndTimeFilter=" + encodeURIComponent(minRedemptionEndTimeFilter ? "" + minRedemptionEndTimeFilter.toJSON() : "") + "&";
        if (notesFilter !== undefined)
            url_ += "NotesFilter=" + encodeURIComponent("" + notesFilter) + "&";
        if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&";
        if (referenceCodeFilter !== undefined)
            url_ += "ReferenceCodeFilter=" + encodeURIComponent("" + referenceCodeFilter) + "&";
        if (maxMaxPaperPrintFilter !== undefined)
            url_ += "MaxMaxPaperPrintFilter=" + encodeURIComponent("" + maxMaxPaperPrintFilter) + "&";
        if (minMaxPaperPrintFilter !== undefined)
            url_ += "MinMaxPaperPrintFilter=" + encodeURIComponent("" + minMaxPaperPrintFilter) + "&";
        if (maxCurrentPaperPrintFilter !== undefined)
            url_ += "MaxCurrentPaperPrintFilter=" + encodeURIComponent("" + maxCurrentPaperPrintFilter) + "&";
        if (minCurrentPaperPrintFilter !== undefined)
            url_ += "MinCurrentPaperPrintFilter=" + encodeURIComponent("" + minCurrentPaperPrintFilter) + "&";
        if (triggerEventFilter !== undefined)
            url_ += "TriggerEventFilter=" + encodeURIComponent("" + triggerEventFilter) + "&";
        if (eventFilterFilter !== undefined)
            url_ += "EventFilterFilter=" + encodeURIComponent("" + eventFilterFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetVoucherTransactionsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVoucherTransactionsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<RewardsFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<RewardsFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetVoucherTransactionsToExcel(response: HttpResponseBase): Observable<RewardsFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? RewardsFileDto.fromJS(resultData200) : new RewardsFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RewardsFileDto>(<any>null);
    }

    /**
     * @param voucherCode (optional) 
     * @return Success
     */
    getVoucherDetail(voucherCode: string | null | undefined): Observable<GetVoucherDetailForAppDto> {
        let url_ = this.baseUrl + "/api/services/app/VoucherTransactions/GetVoucherDetail?";
        if (voucherCode !== undefined)
            url_ += "voucherCode=" + encodeURIComponent("" + voucherCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetVoucherDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVoucherDetail(<any>response_);
                } catch (e) {
                    return <Observable<GetVoucherDetailForAppDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetVoucherDetailForAppDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetVoucherDetail(response: HttpResponseBase): Observable<GetVoucherDetailForAppDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetVoucherDetailForAppDto.fromJS(resultData200) : new GetVoucherDetailForAppDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetVoucherDetailForAppDto>(<any>null);
    }

    /**
     * @param deviceId (optional) 
     * @param userName (optional) 
     * @param voucherUserFilter (optional) 
     * @param membershipCardId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAvailableVoucher(deviceId: string | null | undefined, userName: string | null | undefined, voucherUserFilter: string | null | undefined, membershipCardId: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfVoucherAppListModel> {
        let url_ = this.baseUrl + "/api/services/app/VoucherTransactions/GetAvailableVoucher?";
        if (deviceId !== undefined)
            url_ += "DeviceId=" + encodeURIComponent("" + deviceId) + "&";
        if (userName !== undefined)
            url_ += "UserName=" + encodeURIComponent("" + userName) + "&";
        if (voucherUserFilter !== undefined)
            url_ += "VoucherUserFilter=" + encodeURIComponent("" + voucherUserFilter) + "&";
        if (membershipCardId !== undefined)
            url_ += "MembershipCardId=" + encodeURIComponent("" + membershipCardId) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAvailableVoucher(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAvailableVoucher(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfVoucherAppListModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfVoucherAppListModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetAvailableVoucher(response: HttpResponseBase): Observable<PagedResultDtoOfVoucherAppListModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfVoucherAppListModel.fromJS(resultData200) : new PagedResultDtoOfVoucherAppListModel();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfVoucherAppListModel>(<any>null);
    }

    /**
     * @param deviceId (optional) 
     * @param userName (optional) 
     * @param voucherUserFilter (optional) 
     * @param membershipCardId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getRedeemedVoucher(deviceId: string | null | undefined, userName: string | null | undefined, voucherUserFilter: string | null | undefined, membershipCardId: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfVoucherAppListModel> {
        let url_ = this.baseUrl + "/api/services/app/VoucherTransactions/GetRedeemedVoucher?";
        if (deviceId !== undefined)
            url_ += "DeviceId=" + encodeURIComponent("" + deviceId) + "&";
        if (userName !== undefined)
            url_ += "UserName=" + encodeURIComponent("" + userName) + "&";
        if (voucherUserFilter !== undefined)
            url_ += "VoucherUserFilter=" + encodeURIComponent("" + voucherUserFilter) + "&";
        if (membershipCardId !== undefined)
            url_ += "MembershipCardId=" + encodeURIComponent("" + membershipCardId) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetRedeemedVoucher(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRedeemedVoucher(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfVoucherAppListModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfVoucherAppListModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetRedeemedVoucher(response: HttpResponseBase): Observable<PagedResultDtoOfVoucherAppListModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfVoucherAppListModel.fromJS(resultData200) : new PagedResultDtoOfVoucherAppListModel();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfVoucherAppListModel>(<any>null);
    }

    /**
     * @param deviceId (optional) 
     * @param userName (optional) 
     * @param voucherUserFilter (optional) 
     * @param membershipCardId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getExpiredVoucher(deviceId: string | null | undefined, userName: string | null | undefined, voucherUserFilter: string | null | undefined, membershipCardId: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfVoucherAppListModel> {
        let url_ = this.baseUrl + "/api/services/app/VoucherTransactions/GetExpiredVoucher?";
        if (deviceId !== undefined)
            url_ += "DeviceId=" + encodeURIComponent("" + deviceId) + "&";
        if (userName !== undefined)
            url_ += "UserName=" + encodeURIComponent("" + userName) + "&";
        if (voucherUserFilter !== undefined)
            url_ += "VoucherUserFilter=" + encodeURIComponent("" + voucherUserFilter) + "&";
        if (membershipCardId !== undefined)
            url_ += "MembershipCardId=" + encodeURIComponent("" + membershipCardId) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetExpiredVoucher(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExpiredVoucher(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfVoucherAppListModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfVoucherAppListModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetExpiredVoucher(response: HttpResponseBase): Observable<PagedResultDtoOfVoucherAppListModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfVoucherAppListModel.fromJS(resultData200) : new PagedResultDtoOfVoucherAppListModel();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfVoucherAppListModel>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    redeemVoucher(input: VoucherRedemptionInput | null | undefined): Observable<RedeemVoucherOutput> {
        let url_ = this.baseUrl + "/api/services/app/VoucherTransactions/RedeemVoucher";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processRedeemVoucher(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRedeemVoucher(<any>response_);
                } catch (e) {
                    return <Observable<RedeemVoucherOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<RedeemVoucherOutput>><any>_observableThrow(response_);
        }));
    }

    protected processRedeemVoucher(response: HttpResponseBase): Observable<RedeemVoucherOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? RedeemVoucherOutput.fromJS(resultData200) : new RedeemVoucherOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RedeemVoucherOutput>(<any>null);
    }

    /**
     * @param voucherCode (optional) 
     * @return Success
     */
    printVoucherPaper(voucherCode: string | null | undefined): Observable<VoucherPrintInformationDto> {
        let url_ = this.baseUrl + "/api/services/app/VoucherTransactions/PrintVoucherPaper?";
        if (voucherCode !== undefined)
            url_ += "voucherCode=" + encodeURIComponent("" + voucherCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processPrintVoucherPaper(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPrintVoucherPaper(<any>response_);
                } catch (e) {
                    return <Observable<VoucherPrintInformationDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<VoucherPrintInformationDto>><any>_observableThrow(response_);
        }));
    }

    protected processPrintVoucherPaper(response: HttpResponseBase): Observable<VoucherPrintInformationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? VoucherPrintInformationDto.fromJS(resultData200) : new VoucherPrintInformationDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VoucherPrintInformationDto>(<any>null);
    }

    /**
     * @param voucherCode (optional) 
     * @return Success
     */
    printVoucherSlip(voucherCode: string | null | undefined): Observable<VoucherPrintInformationDto> {
        let url_ = this.baseUrl + "/api/services/app/VoucherTransactions/PrintVoucherSlip?";
        if (voucherCode !== undefined)
            url_ += "voucherCode=" + encodeURIComponent("" + voucherCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processPrintVoucherSlip(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPrintVoucherSlip(<any>response_);
                } catch (e) {
                    return <Observable<VoucherPrintInformationDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<VoucherPrintInformationDto>><any>_observableThrow(response_);
        }));
    }

    protected processPrintVoucherSlip(response: HttpResponseBase): Observable<VoucherPrintInformationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? VoucherPrintInformationDto.fromJS(resultData200) : new VoucherPrintInformationDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VoucherPrintInformationDto>(<any>null);
    }
}

@Injectable()
export class VoucherUsersServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param phoneFilter (optional) 
     * @param zaloChatIDFilter (optional) 
     * @param emailFilter (optional) 
     * @param facebookIDFilter (optional) 
     * @param memberCodeFilter (optional) 
     * @param communicationLanguageFilter (optional) 
     * @param communicationChannelsFilter (optional) 
     * @param maxTargetAudienceLinkIDFilter (optional) 
     * @param minTargetAudienceLinkIDFilter (optional) 
     * @param rewardTargetAudienceTargetAudienceNameFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, nameFilter: string | null | undefined, phoneFilter: string | null | undefined, zaloChatIDFilter: string | null | undefined, emailFilter: string | null | undefined, facebookIDFilter: string | null | undefined, memberCodeFilter: string | null | undefined, communicationLanguageFilter: string | null | undefined, communicationChannelsFilter: string | null | undefined, maxTargetAudienceLinkIDFilter: number | null | undefined, minTargetAudienceLinkIDFilter: number | null | undefined, rewardTargetAudienceTargetAudienceNameFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetVoucherUserForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/VoucherUsers/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (phoneFilter !== undefined)
            url_ += "PhoneFilter=" + encodeURIComponent("" + phoneFilter) + "&";
        if (zaloChatIDFilter !== undefined)
            url_ += "ZaloChatIDFilter=" + encodeURIComponent("" + zaloChatIDFilter) + "&";
        if (emailFilter !== undefined)
            url_ += "EmailFilter=" + encodeURIComponent("" + emailFilter) + "&";
        if (facebookIDFilter !== undefined)
            url_ += "FacebookIDFilter=" + encodeURIComponent("" + facebookIDFilter) + "&";
        if (memberCodeFilter !== undefined)
            url_ += "MemberCodeFilter=" + encodeURIComponent("" + memberCodeFilter) + "&";
        if (communicationLanguageFilter !== undefined)
            url_ += "CommunicationLanguageFilter=" + encodeURIComponent("" + communicationLanguageFilter) + "&";
        if (communicationChannelsFilter !== undefined)
            url_ += "CommunicationChannelsFilter=" + encodeURIComponent("" + communicationChannelsFilter) + "&";
        if (maxTargetAudienceLinkIDFilter !== undefined)
            url_ += "MaxTargetAudienceLinkIDFilter=" + encodeURIComponent("" + maxTargetAudienceLinkIDFilter) + "&";
        if (minTargetAudienceLinkIDFilter !== undefined)
            url_ += "MinTargetAudienceLinkIDFilter=" + encodeURIComponent("" + minTargetAudienceLinkIDFilter) + "&";
        if (rewardTargetAudienceTargetAudienceNameFilter !== undefined)
            url_ += "RewardTargetAudienceTargetAudienceNameFilter=" + encodeURIComponent("" + rewardTargetAudienceTargetAudienceNameFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetVoucherUserForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetVoucherUserForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetVoucherUserForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetVoucherUserForViewDto.fromJS(resultData200) : new PagedResultDtoOfGetVoucherUserForViewDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetVoucherUserForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getVoucherUserForEdit(id: number | null | undefined): Observable<GetVoucherUserForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/VoucherUsers/GetVoucherUserForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetVoucherUserForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVoucherUserForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetVoucherUserForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetVoucherUserForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetVoucherUserForEdit(response: HttpResponseBase): Observable<GetVoucherUserForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetVoucherUserForEditOutput.fromJS(resultData200) : new GetVoucherUserForEditOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetVoucherUserForEditOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrEditVoucherUserDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/VoucherUsers/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/VoucherUsers/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param phoneFilter (optional) 
     * @param zaloChatIDFilter (optional) 
     * @param emailFilter (optional) 
     * @param facebookIDFilter (optional) 
     * @param memberCodeFilter (optional) 
     * @param communicationLanguageFilter (optional) 
     * @param communicationChannelsFilter (optional) 
     * @param maxTargetAudienceLinkIDFilter (optional) 
     * @param minTargetAudienceLinkIDFilter (optional) 
     * @param rewardTargetAudienceTargetAudienceNameFilter (optional) 
     * @return Success
     */
    getVoucherUsersToExcel(filter: string | null | undefined, nameFilter: string | null | undefined, phoneFilter: string | null | undefined, zaloChatIDFilter: string | null | undefined, emailFilter: string | null | undefined, facebookIDFilter: string | null | undefined, memberCodeFilter: string | null | undefined, communicationLanguageFilter: string | null | undefined, communicationChannelsFilter: string | null | undefined, maxTargetAudienceLinkIDFilter: number | null | undefined, minTargetAudienceLinkIDFilter: number | null | undefined, rewardTargetAudienceTargetAudienceNameFilter: string | null | undefined): Observable<RewardsFileDto> {
        let url_ = this.baseUrl + "/api/services/app/VoucherUsers/GetVoucherUsersToExcel?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (phoneFilter !== undefined)
            url_ += "PhoneFilter=" + encodeURIComponent("" + phoneFilter) + "&";
        if (zaloChatIDFilter !== undefined)
            url_ += "ZaloChatIDFilter=" + encodeURIComponent("" + zaloChatIDFilter) + "&";
        if (emailFilter !== undefined)
            url_ += "EmailFilter=" + encodeURIComponent("" + emailFilter) + "&";
        if (facebookIDFilter !== undefined)
            url_ += "FacebookIDFilter=" + encodeURIComponent("" + facebookIDFilter) + "&";
        if (memberCodeFilter !== undefined)
            url_ += "MemberCodeFilter=" + encodeURIComponent("" + memberCodeFilter) + "&";
        if (communicationLanguageFilter !== undefined)
            url_ += "CommunicationLanguageFilter=" + encodeURIComponent("" + communicationLanguageFilter) + "&";
        if (communicationChannelsFilter !== undefined)
            url_ += "CommunicationChannelsFilter=" + encodeURIComponent("" + communicationChannelsFilter) + "&";
        if (maxTargetAudienceLinkIDFilter !== undefined)
            url_ += "MaxTargetAudienceLinkIDFilter=" + encodeURIComponent("" + maxTargetAudienceLinkIDFilter) + "&";
        if (minTargetAudienceLinkIDFilter !== undefined)
            url_ += "MinTargetAudienceLinkIDFilter=" + encodeURIComponent("" + minTargetAudienceLinkIDFilter) + "&";
        if (rewardTargetAudienceTargetAudienceNameFilter !== undefined)
            url_ += "RewardTargetAudienceTargetAudienceNameFilter=" + encodeURIComponent("" + rewardTargetAudienceTargetAudienceNameFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetVoucherUsersToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVoucherUsersToExcel(<any>response_);
                } catch (e) {
                    return <Observable<RewardsFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<RewardsFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetVoucherUsersToExcel(response: HttpResponseBase): Observable<RewardsFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? RewardsFileDto.fromJS(resultData200) : new RewardsFileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RewardsFileDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllRewardTargetAudienceForLookupTable(filter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfRewardTargetAudienceLookupTableDto> {
        let url_ = this.baseUrl + "/api/services/app/VoucherUsers/GetAllRewardTargetAudienceForLookupTable?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllRewardTargetAudienceForLookupTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllRewardTargetAudienceForLookupTable(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfRewardTargetAudienceLookupTableDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfRewardTargetAudienceLookupTableDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllRewardTargetAudienceForLookupTable(response: HttpResponseBase): Observable<PagedResultDtoOfRewardTargetAudienceLookupTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfRewardTargetAudienceLookupTableDto.fromJS(resultData200) : new PagedResultDtoOfRewardTargetAudienceLookupTableDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfRewardTargetAudienceLookupTableDto>(<any>null);
    }
}

@Injectable()
export class WebAppServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    stop(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/WebApp/Stop";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processStop(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStop(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processStop(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class WebHookServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    subscribe(input: WebHookDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/WebHookService/Subscribe";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSubscribe(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubscribe(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSubscribe(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    testPublish(input: PublishWebHookDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/WebHookService/TestPublish";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processTestPublish(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTestPublish(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processTestPublish(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class WebHookSubscriptionInfoServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getSubscribeInfoAsync(): Observable<WebHookDataItem> {
        let url_ = this.baseUrl + "/api/services/app/WebHookSubscriptionInfo/GetSubscribeInfoAsync";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSubscribeInfoAsync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSubscribeInfoAsync(<any>response_);
                } catch (e) {
                    return <Observable<WebHookDataItem>><any>_observableThrow(e);
                }
            } else
                return <Observable<WebHookDataItem>><any>_observableThrow(response_);
        }));
    }

    protected processGetSubscribeInfoAsync(response: HttpResponseBase): Observable<WebHookDataItem> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? WebHookDataItem.fromJS(resultData200) : new WebHookDataItem();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WebHookDataItem>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param maxEventTemplateIDFilter (optional) 
     * @param minEventTemplateIDFilter (optional) 
     * @param eventTemplateGroupFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllWebHook(filter: string | null | undefined, maxEventTemplateIDFilter: number | null | undefined, minEventTemplateIDFilter: number | null | undefined, eventTemplateGroupFilter: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetEventSubscriptionDetailForView> {
        let url_ = this.baseUrl + "/api/services/app/WebHookSubscriptionInfo/GetAllWebHook?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (maxEventTemplateIDFilter !== undefined)
            url_ += "MaxEventTemplateIDFilter=" + encodeURIComponent("" + maxEventTemplateIDFilter) + "&";
        if (minEventTemplateIDFilter !== undefined)
            url_ += "MinEventTemplateIDFilter=" + encodeURIComponent("" + minEventTemplateIDFilter) + "&";
        if (eventTemplateGroupFilter !== undefined)
            url_ += "EventTemplateGroupFilter=" + encodeURIComponent("" + eventTemplateGroupFilter) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllWebHook(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllWebHook(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetEventSubscriptionDetailForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetEventSubscriptionDetailForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllWebHook(response: HttpResponseBase): Observable<PagedResultDtoOfGetEventSubscriptionDetailForView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfGetEventSubscriptionDetailForView.fromJS(resultData200) : new PagedResultDtoOfGetEventSubscriptionDetailForView();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetEventSubscriptionDetailForView>(<any>null);
    }
}

@Injectable()
export class WebLogServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getLatestWebLogs(): Observable<GetLatestWebLogsOutput> {
        let url_ = this.baseUrl + "/api/services/app/WebLog/GetLatestWebLogs";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetLatestWebLogs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLatestWebLogs(<any>response_);
                } catch (e) {
                    return <Observable<GetLatestWebLogsOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetLatestWebLogsOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetLatestWebLogs(response: HttpResponseBase): Observable<GetLatestWebLogsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? GetLatestWebLogsOutput.fromJS(resultData200) : new GetLatestWebLogsOutput();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLatestWebLogsOutput>(<any>null);
    }

    /**
     * @return Success
     */
    downloadWebLogs(): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/WebLog/DownloadWebLogs";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDownloadWebLogs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadWebLogs(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processDownloadWebLogs(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }
}

export class IsTenantAvailableInput implements IIsTenantAvailableInput {
    tenancyName!: string;

    constructor(data?: IIsTenantAvailableInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenancyName = data["tenancyName"];
        }
    }

    static fromJS(data: any): IsTenantAvailableInput {
        data = typeof data === 'object' ? data : {};
        let result = new IsTenantAvailableInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        return data;
    }
}

export interface IIsTenantAvailableInput {
    tenancyName: string;
}

export class IsTenantAvailableOutput implements IIsTenantAvailableOutput {
    state!: IsTenantAvailableOutputState | undefined;
    tenantId!: number | undefined;
    serverRootAddress!: string | undefined;

    constructor(data?: IIsTenantAvailableOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.state = data["state"];
            this.tenantId = data["tenantId"];
            this.serverRootAddress = data["serverRootAddress"];
        }
    }

    static fromJS(data: any): IsTenantAvailableOutput {
        data = typeof data === 'object' ? data : {};
        let result = new IsTenantAvailableOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state;
        data["tenantId"] = this.tenantId;
        data["serverRootAddress"] = this.serverRootAddress;
        return data;
    }
}

export interface IIsTenantAvailableOutput {
    state: IsTenantAvailableOutputState | undefined;
    tenantId: number | undefined;
    serverRootAddress: string | undefined;
}

export class ResolveTenantIdInput implements IResolveTenantIdInput {
    c!: string | undefined;

    constructor(data?: IResolveTenantIdInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.c = data["c"];
        }
    }

    static fromJS(data: any): ResolveTenantIdInput {
        data = typeof data === 'object' ? data : {};
        let result = new ResolveTenantIdInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["c"] = this.c;
        return data;
    }
}

export interface IResolveTenantIdInput {
    c: string | undefined;
}

export class RegisterInput implements IRegisterInput {
    name!: string;
    surname!: string;
    userName!: string;
    emailAddress!: string;
    password!: string;
    captchaResponse!: string | undefined;

    constructor(data?: IRegisterInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.surname = data["surname"];
            this.userName = data["userName"];
            this.emailAddress = data["emailAddress"];
            this.password = data["password"];
            this.captchaResponse = data["captchaResponse"];
        }
    }

    static fromJS(data: any): RegisterInput {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["password"] = this.password;
        data["captchaResponse"] = this.captchaResponse;
        return data;
    }
}

export interface IRegisterInput {
    name: string;
    surname: string;
    userName: string;
    emailAddress: string;
    password: string;
    captchaResponse: string | undefined;
}

export class RegisterOutput implements IRegisterOutput {
    canLogin!: boolean | undefined;

    constructor(data?: IRegisterOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.canLogin = data["canLogin"];
        }
    }

    static fromJS(data: any): RegisterOutput {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canLogin"] = this.canLogin;
        return data;
    }
}

export interface IRegisterOutput {
    canLogin: boolean | undefined;
}

export class ResetPasswordInput implements IResetPasswordInput {
    userId!: number | undefined;
    resetCode!: string | undefined;
    password!: string | undefined;
    returnUrl!: string | undefined;
    singleSignIn!: string | undefined;
    c!: string | undefined;

    constructor(data?: IResetPasswordInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userId = data["userId"];
            this.resetCode = data["resetCode"];
            this.password = data["password"];
            this.returnUrl = data["returnUrl"];
            this.singleSignIn = data["singleSignIn"];
            this.c = data["c"];
        }
    }

    static fromJS(data: any): ResetPasswordInput {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["resetCode"] = this.resetCode;
        data["password"] = this.password;
        data["returnUrl"] = this.returnUrl;
        data["singleSignIn"] = this.singleSignIn;
        data["c"] = this.c;
        return data;
    }
}

export interface IResetPasswordInput {
    userId: number | undefined;
    resetCode: string | undefined;
    password: string | undefined;
    returnUrl: string | undefined;
    singleSignIn: string | undefined;
    c: string | undefined;
}

export class ResetPasswordOutput implements IResetPasswordOutput {
    canLogin!: boolean | undefined;
    userName!: string | undefined;

    constructor(data?: IResetPasswordOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.canLogin = data["canLogin"];
            this.userName = data["userName"];
        }
    }

    static fromJS(data: any): ResetPasswordOutput {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canLogin"] = this.canLogin;
        data["userName"] = this.userName;
        return data;
    }
}

export interface IResetPasswordOutput {
    canLogin: boolean | undefined;
    userName: string | undefined;
}

export class SendEmailActivationLinkInput implements ISendEmailActivationLinkInput {
    emailAddress!: string;

    constructor(data?: ISendEmailActivationLinkInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.emailAddress = data["emailAddress"];
        }
    }

    static fromJS(data: any): SendEmailActivationLinkInput {
        data = typeof data === 'object' ? data : {};
        let result = new SendEmailActivationLinkInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        return data;
    }
}

export interface ISendEmailActivationLinkInput {
    emailAddress: string;
}

export class ActivateEmailInput implements IActivateEmailInput {
    userId!: number | undefined;
    confirmationCode!: string | undefined;
    c!: string | undefined;

    constructor(data?: IActivateEmailInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userId = data["userId"];
            this.confirmationCode = data["confirmationCode"];
            this.c = data["c"];
        }
    }

    static fromJS(data: any): ActivateEmailInput {
        data = typeof data === 'object' ? data : {};
        let result = new ActivateEmailInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["confirmationCode"] = this.confirmationCode;
        data["c"] = this.c;
        return data;
    }
}

export interface IActivateEmailInput {
    userId: number | undefined;
    confirmationCode: string | undefined;
    c: string | undefined;
}

export class ImpersonateInput implements IImpersonateInput {
    tenantId!: number | undefined;
    userId!: number | undefined;

    constructor(data?: IImpersonateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.userId = data["userId"];
        }
    }

    static fromJS(data: any): ImpersonateInput {
        data = typeof data === 'object' ? data : {};
        let result = new ImpersonateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        return data;
    }
}

export interface IImpersonateInput {
    tenantId: number | undefined;
    userId: number | undefined;
}

export class ImpersonateOutput implements IImpersonateOutput {
    impersonationToken!: string | undefined;
    tenancyName!: string | undefined;

    constructor(data?: IImpersonateOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.impersonationToken = data["impersonationToken"];
            this.tenancyName = data["tenancyName"];
        }
    }

    static fromJS(data: any): ImpersonateOutput {
        data = typeof data === 'object' ? data : {};
        let result = new ImpersonateOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["impersonationToken"] = this.impersonationToken;
        data["tenancyName"] = this.tenancyName;
        return data;
    }
}

export interface IImpersonateOutput {
    impersonationToken: string | undefined;
    tenancyName: string | undefined;
}

export class SwitchToLinkedAccountInput implements ISwitchToLinkedAccountInput {
    targetTenantId!: number | undefined;
    targetUserId!: number | undefined;

    constructor(data?: ISwitchToLinkedAccountInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.targetTenantId = data["targetTenantId"];
            this.targetUserId = data["targetUserId"];
        }
    }

    static fromJS(data: any): SwitchToLinkedAccountInput {
        data = typeof data === 'object' ? data : {};
        let result = new SwitchToLinkedAccountInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["targetTenantId"] = this.targetTenantId;
        data["targetUserId"] = this.targetUserId;
        return data;
    }
}

export interface ISwitchToLinkedAccountInput {
    targetTenantId: number | undefined;
    targetUserId: number | undefined;
}

export class SwitchToLinkedAccountOutput implements ISwitchToLinkedAccountOutput {
    switchAccountToken!: string | undefined;
    tenancyName!: string | undefined;

    constructor(data?: ISwitchToLinkedAccountOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.switchAccountToken = data["switchAccountToken"];
            this.tenancyName = data["tenancyName"];
        }
    }

    static fromJS(data: any): SwitchToLinkedAccountOutput {
        data = typeof data === 'object' ? data : {};
        let result = new SwitchToLinkedAccountOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["switchAccountToken"] = this.switchAccountToken;
        data["tenancyName"] = this.tenancyName;
        return data;
    }
}

export interface ISwitchToLinkedAccountOutput {
    switchAccountToken: string | undefined;
    tenancyName: string | undefined;
}

export class PagedResultDtoOfGetActionRuleForView implements IPagedResultDtoOfGetActionRuleForView {
    totalCount!: number | undefined;
    items!: GetActionRuleForView[] | undefined;

    constructor(data?: IPagedResultDtoOfGetActionRuleForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetActionRuleForView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetActionRuleForView {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetActionRuleForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetActionRuleForView {
    totalCount: number | undefined;
    items: GetActionRuleForView[] | undefined;
}

export class GetActionRuleForView implements IGetActionRuleForView {
    actionRule!: ActionRuleDto | undefined;
    actionCode!: string | undefined;
    targetAudienceCode!: string | undefined;
    campaignCode!: string | undefined;

    constructor(data?: IGetActionRuleForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.actionRule = data["actionRule"] ? ActionRuleDto.fromJS(data["actionRule"]) : <any>undefined;
            this.actionCode = data["actionCode"];
            this.targetAudienceCode = data["targetAudienceCode"];
            this.campaignCode = data["campaignCode"];
        }
    }

    static fromJS(data: any): GetActionRuleForView {
        data = typeof data === 'object' ? data : {};
        let result = new GetActionRuleForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["actionRule"] = this.actionRule ? this.actionRule.toJSON() : <any>undefined;
        data["actionCode"] = this.actionCode;
        data["targetAudienceCode"] = this.targetAudienceCode;
        data["campaignCode"] = this.campaignCode;
        return data;
    }
}

export interface IGetActionRuleForView {
    actionRule: ActionRuleDto | undefined;
    actionCode: string | undefined;
    targetAudienceCode: string | undefined;
    campaignCode: string | undefined;
}

export class ActionRuleDto implements IActionRuleDto {
    code!: string | undefined;
    name!: string | undefined;
    description!: string | undefined;
    effectiveFrom!: moment.Moment | undefined;
    effectiveTo!: moment.Moment | undefined;
    cron!: string | undefined;
    startDateTime!: moment.Moment | undefined;
    endDateTime!: moment.Moment | undefined;
    startTime!: string | undefined;
    endTime!: string | undefined;
    actionFilter!: string | undefined;
    value!: number | undefined;
    pointValue!: number | undefined;
    coinValue!: number | undefined;
    maxSet!: number | undefined;
    type!: ActionRuleDtoType | undefined;
    maxSetPerAction!: number | undefined;
    timeZone!: string | undefined;
    isActive!: boolean | undefined;
    actionId!: number | undefined;
    targetAudienceId!: number | undefined;
    campaignId!: number | undefined;
    targetAudienceCode!: string | undefined;
    targetAudience!: SettingParamDto | undefined;
    id!: number | undefined;

    constructor(data?: IActionRuleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.name = data["name"];
            this.description = data["description"];
            this.effectiveFrom = data["effectiveFrom"] ? moment(data["effectiveFrom"].toString()) : <any>undefined;
            this.effectiveTo = data["effectiveTo"] ? moment(data["effectiveTo"].toString()) : <any>undefined;
            this.cron = data["cron"];
            this.startDateTime = data["startDateTime"] ? moment(data["startDateTime"].toString()) : <any>undefined;
            this.endDateTime = data["endDateTime"] ? moment(data["endDateTime"].toString()) : <any>undefined;
            this.startTime = data["startTime"];
            this.endTime = data["endTime"];
            this.actionFilter = data["actionFilter"];
            this.value = data["value"];
            this.pointValue = data["pointValue"];
            this.coinValue = data["coinValue"];
            this.maxSet = data["maxSet"];
            this.type = data["type"];
            this.maxSetPerAction = data["maxSetPerAction"];
            this.timeZone = data["timeZone"];
            this.isActive = data["isActive"];
            this.actionId = data["actionId"];
            this.targetAudienceId = data["targetAudienceId"];
            this.campaignId = data["campaignId"];
            this.targetAudienceCode = data["targetAudienceCode"];
            this.targetAudience = data["targetAudience"] ? SettingParamDto.fromJS(data["targetAudience"]) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ActionRuleDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActionRuleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["description"] = this.description;
        data["effectiveFrom"] = this.effectiveFrom ? this.effectiveFrom.toISOString() : <any>undefined;
        data["effectiveTo"] = this.effectiveTo ? this.effectiveTo.toISOString() : <any>undefined;
        data["cron"] = this.cron;
        data["startDateTime"] = this.startDateTime ? this.startDateTime.toISOString() : <any>undefined;
        data["endDateTime"] = this.endDateTime ? this.endDateTime.toISOString() : <any>undefined;
        data["startTime"] = this.startTime;
        data["endTime"] = this.endTime;
        data["actionFilter"] = this.actionFilter;
        data["value"] = this.value;
        data["pointValue"] = this.pointValue;
        data["coinValue"] = this.coinValue;
        data["maxSet"] = this.maxSet;
        data["type"] = this.type;
        data["maxSetPerAction"] = this.maxSetPerAction;
        data["timeZone"] = this.timeZone;
        data["isActive"] = this.isActive;
        data["actionId"] = this.actionId;
        data["targetAudienceId"] = this.targetAudienceId;
        data["campaignId"] = this.campaignId;
        data["targetAudienceCode"] = this.targetAudienceCode;
        data["targetAudience"] = this.targetAudience ? this.targetAudience.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IActionRuleDto {
    code: string | undefined;
    name: string | undefined;
    description: string | undefined;
    effectiveFrom: moment.Moment | undefined;
    effectiveTo: moment.Moment | undefined;
    cron: string | undefined;
    startDateTime: moment.Moment | undefined;
    endDateTime: moment.Moment | undefined;
    startTime: string | undefined;
    endTime: string | undefined;
    actionFilter: string | undefined;
    value: number | undefined;
    pointValue: number | undefined;
    coinValue: number | undefined;
    maxSet: number | undefined;
    type: ActionRuleDtoType | undefined;
    maxSetPerAction: number | undefined;
    timeZone: string | undefined;
    isActive: boolean | undefined;
    actionId: number | undefined;
    targetAudienceId: number | undefined;
    campaignId: number | undefined;
    targetAudienceCode: string | undefined;
    targetAudience: SettingParamDto | undefined;
    id: number | undefined;
}

export class SettingParamDto implements ISettingParamDto {
    code!: string | undefined;
    name!: string | undefined;
    isActive!: boolean | undefined;
    type!: string | undefined;
    count!: number | undefined;
    isFilterProfile!: boolean | undefined;
    targetAudienceDetail!: SettingParamFieldDto[] | undefined;
    id!: number | undefined;

    constructor(data?: ISettingParamDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.name = data["name"];
            this.isActive = data["isActive"];
            this.type = data["type"];
            this.count = data["count"];
            this.isFilterProfile = data["isFilterProfile"];
            if (data["targetAudienceDetail"] && data["targetAudienceDetail"].constructor === Array) {
                this.targetAudienceDetail = [];
                for (let item of data["targetAudienceDetail"])
                    this.targetAudienceDetail.push(SettingParamFieldDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SettingParamDto {
        data = typeof data === 'object' ? data : {};
        let result = new SettingParamDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        data["type"] = this.type;
        data["count"] = this.count;
        data["isFilterProfile"] = this.isFilterProfile;
        if (this.targetAudienceDetail && this.targetAudienceDetail.constructor === Array) {
            data["targetAudienceDetail"] = [];
            for (let item of this.targetAudienceDetail)
                data["targetAudienceDetail"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }
}

export interface ISettingParamDto {
    code: string | undefined;
    name: string | undefined;
    isActive: boolean | undefined;
    type: string | undefined;
    count: number | undefined;
    isFilterProfile: boolean | undefined;
    targetAudienceDetail: SettingParamFieldDto[] | undefined;
    id: number | undefined;
}

export class SettingParamFieldDto implements ISettingParamFieldDto {
    code!: string | undefined;
    targetAudienceId!: number | undefined;
    type!: string | undefined;
    fullValue!: string | undefined;
    value!: string | undefined;
    fullValueName!: string | undefined;
    level!: string | undefined;
    id!: number | undefined;

    constructor(data?: ISettingParamFieldDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.targetAudienceId = data["targetAudienceId"];
            this.type = data["type"];
            this.fullValue = data["fullValue"];
            this.value = data["value"];
            this.fullValueName = data["fullValueName"];
            this.level = data["level"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SettingParamFieldDto {
        data = typeof data === 'object' ? data : {};
        let result = new SettingParamFieldDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["targetAudienceId"] = this.targetAudienceId;
        data["type"] = this.type;
        data["fullValue"] = this.fullValue;
        data["value"] = this.value;
        data["fullValueName"] = this.fullValueName;
        data["level"] = this.level;
        data["id"] = this.id;
        return data;
    }
}

export interface ISettingParamFieldDto {
    code: string | undefined;
    targetAudienceId: number | undefined;
    type: string | undefined;
    fullValue: string | undefined;
    value: string | undefined;
    fullValueName: string | undefined;
    level: string | undefined;
    id: number | undefined;
}

export class GetActionRuleForEditOutput implements IGetActionRuleForEditOutput {
    actionRule!: CreateOrEditActionRuleDto | undefined;
    actionCode!: string | undefined;
    targetAudienceCode!: string | undefined;
    campaignCode!: string | undefined;

    constructor(data?: IGetActionRuleForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.actionRule = data["actionRule"] ? CreateOrEditActionRuleDto.fromJS(data["actionRule"]) : <any>undefined;
            this.actionCode = data["actionCode"];
            this.targetAudienceCode = data["targetAudienceCode"];
            this.campaignCode = data["campaignCode"];
        }
    }

    static fromJS(data: any): GetActionRuleForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetActionRuleForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["actionRule"] = this.actionRule ? this.actionRule.toJSON() : <any>undefined;
        data["actionCode"] = this.actionCode;
        data["targetAudienceCode"] = this.targetAudienceCode;
        data["campaignCode"] = this.campaignCode;
        return data;
    }
}

export interface IGetActionRuleForEditOutput {
    actionRule: CreateOrEditActionRuleDto | undefined;
    actionCode: string | undefined;
    targetAudienceCode: string | undefined;
    campaignCode: string | undefined;
}

export class CreateOrEditActionRuleDto implements ICreateOrEditActionRuleDto {
    code!: string;
    name!: string | undefined;
    description!: string | undefined;
    effectiveFrom!: moment.Moment | undefined;
    effectiveTo!: moment.Moment | undefined;
    cron!: string | undefined;
    startDateTime!: moment.Moment | undefined;
    endDateTime!: moment.Moment | undefined;
    startTime!: string | undefined;
    endTime!: string | undefined;
    actionFilter!: string | undefined;
    value!: number | undefined;
    pointValue!: number | undefined;
    coinValue!: number | undefined;
    maxSet!: number | undefined;
    type!: CreateOrEditActionRuleDtoType | undefined;
    maxSetPerAction!: number | undefined;
    timeZone!: string | undefined;
    isActive!: boolean | undefined;
    actionId!: number | undefined;
    targetAudienceId!: number | undefined;
    campaignId!: number | undefined;
    targetAudience!: CreateOrEditSettingParamDto | undefined;
    action!: CreateOrEditActionDto | undefined;
    targetAudienceCode!: string | undefined;
    isDeleted!: boolean | undefined;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: moment.Moment | undefined;
    creatorUserId!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditActionRuleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.name = data["name"];
            this.description = data["description"];
            this.effectiveFrom = data["effectiveFrom"] ? moment(data["effectiveFrom"].toString()) : <any>undefined;
            this.effectiveTo = data["effectiveTo"] ? moment(data["effectiveTo"].toString()) : <any>undefined;
            this.cron = data["cron"];
            this.startDateTime = data["startDateTime"] ? moment(data["startDateTime"].toString()) : <any>undefined;
            this.endDateTime = data["endDateTime"] ? moment(data["endDateTime"].toString()) : <any>undefined;
            this.startTime = data["startTime"];
            this.endTime = data["endTime"];
            this.actionFilter = data["actionFilter"];
            this.value = data["value"];
            this.pointValue = data["pointValue"];
            this.coinValue = data["coinValue"];
            this.maxSet = data["maxSet"];
            this.type = data["type"];
            this.maxSetPerAction = data["maxSetPerAction"];
            this.timeZone = data["timeZone"];
            this.isActive = data["isActive"];
            this.actionId = data["actionId"];
            this.targetAudienceId = data["targetAudienceId"];
            this.campaignId = data["campaignId"];
            this.targetAudience = data["targetAudience"] ? CreateOrEditSettingParamDto.fromJS(data["targetAudience"]) : <any>undefined;
            this.action = data["action"] ? CreateOrEditActionDto.fromJS(data["action"]) : <any>undefined;
            this.targetAudienceCode = data["targetAudienceCode"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditActionRuleDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditActionRuleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["description"] = this.description;
        data["effectiveFrom"] = this.effectiveFrom ? this.effectiveFrom.toISOString() : <any>undefined;
        data["effectiveTo"] = this.effectiveTo ? this.effectiveTo.toISOString() : <any>undefined;
        data["cron"] = this.cron;
        data["startDateTime"] = this.startDateTime ? this.startDateTime.toISOString() : <any>undefined;
        data["endDateTime"] = this.endDateTime ? this.endDateTime.toISOString() : <any>undefined;
        data["startTime"] = this.startTime;
        data["endTime"] = this.endTime;
        data["actionFilter"] = this.actionFilter;
        data["value"] = this.value;
        data["pointValue"] = this.pointValue;
        data["coinValue"] = this.coinValue;
        data["maxSet"] = this.maxSet;
        data["type"] = this.type;
        data["maxSetPerAction"] = this.maxSetPerAction;
        data["timeZone"] = this.timeZone;
        data["isActive"] = this.isActive;
        data["actionId"] = this.actionId;
        data["targetAudienceId"] = this.targetAudienceId;
        data["campaignId"] = this.campaignId;
        data["targetAudience"] = this.targetAudience ? this.targetAudience.toJSON() : <any>undefined;
        data["action"] = this.action ? this.action.toJSON() : <any>undefined;
        data["targetAudienceCode"] = this.targetAudienceCode;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditActionRuleDto {
    code: string;
    name: string | undefined;
    description: string | undefined;
    effectiveFrom: moment.Moment | undefined;
    effectiveTo: moment.Moment | undefined;
    cron: string | undefined;
    startDateTime: moment.Moment | undefined;
    endDateTime: moment.Moment | undefined;
    startTime: string | undefined;
    endTime: string | undefined;
    actionFilter: string | undefined;
    value: number | undefined;
    pointValue: number | undefined;
    coinValue: number | undefined;
    maxSet: number | undefined;
    type: CreateOrEditActionRuleDtoType | undefined;
    maxSetPerAction: number | undefined;
    timeZone: string | undefined;
    isActive: boolean | undefined;
    actionId: number | undefined;
    targetAudienceId: number | undefined;
    campaignId: number | undefined;
    targetAudience: CreateOrEditSettingParamDto | undefined;
    action: CreateOrEditActionDto | undefined;
    targetAudienceCode: string | undefined;
    isDeleted: boolean | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class CreateOrEditSettingParamDto implements ICreateOrEditSettingParamDto {
    code!: string;
    name!: string;
    isActive!: boolean | undefined;
    type!: string | undefined;
    description!: string | undefined;
    targetAudienceDetailDtos!: CreateOrEditSettingParamFieldDto[] | undefined;
    isDeleted!: boolean | undefined;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: moment.Moment | undefined;
    creatorUserId!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditSettingParamDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.name = data["name"];
            this.isActive = data["isActive"];
            this.type = data["type"];
            this.description = data["description"];
            if (data["targetAudienceDetailDtos"] && data["targetAudienceDetailDtos"].constructor === Array) {
                this.targetAudienceDetailDtos = [];
                for (let item of data["targetAudienceDetailDtos"])
                    this.targetAudienceDetailDtos.push(CreateOrEditSettingParamFieldDto.fromJS(item));
            }
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditSettingParamDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditSettingParamDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        data["type"] = this.type;
        data["description"] = this.description;
        if (this.targetAudienceDetailDtos && this.targetAudienceDetailDtos.constructor === Array) {
            data["targetAudienceDetailDtos"] = [];
            for (let item of this.targetAudienceDetailDtos)
                data["targetAudienceDetailDtos"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditSettingParamDto {
    code: string;
    name: string;
    isActive: boolean | undefined;
    type: string | undefined;
    description: string | undefined;
    targetAudienceDetailDtos: CreateOrEditSettingParamFieldDto[] | undefined;
    isDeleted: boolean | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class CreateOrEditActionDto implements ICreateOrEditActionDto {
    code!: string;
    name!: string | undefined;
    isActive!: boolean | undefined;
    isDeleted!: boolean | undefined;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: moment.Moment | undefined;
    creatorUserId!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditActionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.name = data["name"];
            this.isActive = data["isActive"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditActionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditActionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditActionDto {
    code: string;
    name: string | undefined;
    isActive: boolean | undefined;
    isDeleted: boolean | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class CreateOrEditSettingParamFieldDto implements ICreateOrEditSettingParamFieldDto {
    code!: string | undefined;
    type!: string | undefined;
    value!: string | undefined;
    level!: string | undefined;
    fullValue!: string | undefined;
    isActive!: boolean | undefined;
    isDeleted!: boolean | undefined;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: moment.Moment | undefined;
    creatorUserId!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditSettingParamFieldDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.type = data["type"];
            this.value = data["value"];
            this.level = data["level"];
            this.fullValue = data["fullValue"];
            this.isActive = data["isActive"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditSettingParamFieldDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditSettingParamFieldDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["type"] = this.type;
        data["value"] = this.value;
        data["level"] = this.level;
        data["fullValue"] = this.fullValue;
        data["isActive"] = this.isActive;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditSettingParamFieldDto {
    code: string | undefined;
    type: string | undefined;
    value: string | undefined;
    level: string | undefined;
    fullValue: string | undefined;
    isActive: boolean | undefined;
    isDeleted: boolean | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfActionLookupTableDto implements IPagedResultDtoOfActionLookupTableDto {
    totalCount!: number | undefined;
    items!: ActionLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfActionLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(ActionLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfActionLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfActionLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfActionLookupTableDto {
    totalCount: number | undefined;
    items: ActionLookupTableDto[] | undefined;
}

export class ActionLookupTableDto implements IActionLookupTableDto {
    id!: number | undefined;
    displayName!: string | undefined;

    constructor(data?: IActionLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): ActionLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActionLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IActionLookupTableDto {
    id: number | undefined;
    displayName: string | undefined;
}

export class PagedResultDtoOfSettingParamLookupTableDto implements IPagedResultDtoOfSettingParamLookupTableDto {
    totalCount!: number | undefined;
    items!: SettingParamLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfSettingParamLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(SettingParamLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfSettingParamLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfSettingParamLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfSettingParamLookupTableDto {
    totalCount: number | undefined;
    items: SettingParamLookupTableDto[] | undefined;
}

export class SettingParamLookupTableDto implements ISettingParamLookupTableDto {
    id!: number | undefined;
    displayName!: string | undefined;

    constructor(data?: ISettingParamLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): SettingParamLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new SettingParamLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface ISettingParamLookupTableDto {
    id: number | undefined;
    displayName: string | undefined;
}

export class PagedResultDtoOfCampaignLookupTableDto implements IPagedResultDtoOfCampaignLookupTableDto {
    totalCount!: number | undefined;
    items!: CampaignLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfCampaignLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(CampaignLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfCampaignLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfCampaignLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfCampaignLookupTableDto {
    totalCount: number | undefined;
    items: CampaignLookupTableDto[] | undefined;
}

export class CampaignLookupTableDto implements ICampaignLookupTableDto {
    id!: number | undefined;
    displayName!: string | undefined;

    constructor(data?: ICampaignLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): CampaignLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new CampaignLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface ICampaignLookupTableDto {
    id: number | undefined;
    displayName: string | undefined;
}

export class GetAllActionRulesInput implements IGetAllActionRulesInput {
    filter!: string | undefined;
    codeFilter!: string | undefined;
    nameFilter!: string | undefined;
    descriptionFilter!: string | undefined;
    maxEffectiveFromFilter!: moment.Moment | undefined;
    minEffectiveFromFilter!: moment.Moment | undefined;
    maxEffectiveToFilter!: moment.Moment | undefined;
    minEffectiveToFilter!: moment.Moment | undefined;
    cronFilter!: string | undefined;
    maxStartTimeFilter!: moment.Moment | undefined;
    minStartTimeFilter!: moment.Moment | undefined;
    maxEndTimeFilter!: moment.Moment | undefined;
    minEndTimeFilter!: moment.Moment | undefined;
    actionFilterFilter!: string | undefined;
    maxValueFilter!: number | undefined;
    minValueFilter!: number | undefined;
    maxPointValueFilter!: number | undefined;
    minPointValueFilter!: number | undefined;
    maxCoinValueFilter!: number | undefined;
    minCoinValueFilter!: number | undefined;
    maxMaxSetFilter!: number | undefined;
    minMaxSetFilter!: number | undefined;
    typeFilter!: number | undefined;
    maxMaxSetPerActionFilter!: number | undefined;
    minMaxSetPerActionFilter!: number | undefined;
    timeZoneFilter!: string | undefined;
    isActiveFilter!: number | undefined;
    actionCodeFilter!: string | undefined;
    targetAudienceCodeFilter!: string | undefined;
    campaignCodeFilter!: string | undefined;
    campaignIdFilter!: number | undefined;
    sorting!: string | undefined;
    skipCount!: number | undefined;
    maxResultCount!: number | undefined;

    constructor(data?: IGetAllActionRulesInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.filter = data["filter"];
            this.codeFilter = data["codeFilter"];
            this.nameFilter = data["nameFilter"];
            this.descriptionFilter = data["descriptionFilter"];
            this.maxEffectiveFromFilter = data["maxEffectiveFromFilter"] ? moment(data["maxEffectiveFromFilter"].toString()) : <any>undefined;
            this.minEffectiveFromFilter = data["minEffectiveFromFilter"] ? moment(data["minEffectiveFromFilter"].toString()) : <any>undefined;
            this.maxEffectiveToFilter = data["maxEffectiveToFilter"] ? moment(data["maxEffectiveToFilter"].toString()) : <any>undefined;
            this.minEffectiveToFilter = data["minEffectiveToFilter"] ? moment(data["minEffectiveToFilter"].toString()) : <any>undefined;
            this.cronFilter = data["cronFilter"];
            this.maxStartTimeFilter = data["maxStartTimeFilter"] ? moment(data["maxStartTimeFilter"].toString()) : <any>undefined;
            this.minStartTimeFilter = data["minStartTimeFilter"] ? moment(data["minStartTimeFilter"].toString()) : <any>undefined;
            this.maxEndTimeFilter = data["maxEndTimeFilter"] ? moment(data["maxEndTimeFilter"].toString()) : <any>undefined;
            this.minEndTimeFilter = data["minEndTimeFilter"] ? moment(data["minEndTimeFilter"].toString()) : <any>undefined;
            this.actionFilterFilter = data["actionFilterFilter"];
            this.maxValueFilter = data["maxValueFilter"];
            this.minValueFilter = data["minValueFilter"];
            this.maxPointValueFilter = data["maxPointValueFilter"];
            this.minPointValueFilter = data["minPointValueFilter"];
            this.maxCoinValueFilter = data["maxCoinValueFilter"];
            this.minCoinValueFilter = data["minCoinValueFilter"];
            this.maxMaxSetFilter = data["maxMaxSetFilter"];
            this.minMaxSetFilter = data["minMaxSetFilter"];
            this.typeFilter = data["typeFilter"];
            this.maxMaxSetPerActionFilter = data["maxMaxSetPerActionFilter"];
            this.minMaxSetPerActionFilter = data["minMaxSetPerActionFilter"];
            this.timeZoneFilter = data["timeZoneFilter"];
            this.isActiveFilter = data["isActiveFilter"];
            this.actionCodeFilter = data["actionCodeFilter"];
            this.targetAudienceCodeFilter = data["targetAudienceCodeFilter"];
            this.campaignCodeFilter = data["campaignCodeFilter"];
            this.campaignIdFilter = data["campaignIdFilter"];
            this.sorting = data["sorting"];
            this.skipCount = data["skipCount"];
            this.maxResultCount = data["maxResultCount"];
        }
    }

    static fromJS(data: any): GetAllActionRulesInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllActionRulesInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        data["codeFilter"] = this.codeFilter;
        data["nameFilter"] = this.nameFilter;
        data["descriptionFilter"] = this.descriptionFilter;
        data["maxEffectiveFromFilter"] = this.maxEffectiveFromFilter ? this.maxEffectiveFromFilter.toISOString() : <any>undefined;
        data["minEffectiveFromFilter"] = this.minEffectiveFromFilter ? this.minEffectiveFromFilter.toISOString() : <any>undefined;
        data["maxEffectiveToFilter"] = this.maxEffectiveToFilter ? this.maxEffectiveToFilter.toISOString() : <any>undefined;
        data["minEffectiveToFilter"] = this.minEffectiveToFilter ? this.minEffectiveToFilter.toISOString() : <any>undefined;
        data["cronFilter"] = this.cronFilter;
        data["maxStartTimeFilter"] = this.maxStartTimeFilter ? this.maxStartTimeFilter.toISOString() : <any>undefined;
        data["minStartTimeFilter"] = this.minStartTimeFilter ? this.minStartTimeFilter.toISOString() : <any>undefined;
        data["maxEndTimeFilter"] = this.maxEndTimeFilter ? this.maxEndTimeFilter.toISOString() : <any>undefined;
        data["minEndTimeFilter"] = this.minEndTimeFilter ? this.minEndTimeFilter.toISOString() : <any>undefined;
        data["actionFilterFilter"] = this.actionFilterFilter;
        data["maxValueFilter"] = this.maxValueFilter;
        data["minValueFilter"] = this.minValueFilter;
        data["maxPointValueFilter"] = this.maxPointValueFilter;
        data["minPointValueFilter"] = this.minPointValueFilter;
        data["maxCoinValueFilter"] = this.maxCoinValueFilter;
        data["minCoinValueFilter"] = this.minCoinValueFilter;
        data["maxMaxSetFilter"] = this.maxMaxSetFilter;
        data["minMaxSetFilter"] = this.minMaxSetFilter;
        data["typeFilter"] = this.typeFilter;
        data["maxMaxSetPerActionFilter"] = this.maxMaxSetPerActionFilter;
        data["minMaxSetPerActionFilter"] = this.minMaxSetPerActionFilter;
        data["timeZoneFilter"] = this.timeZoneFilter;
        data["isActiveFilter"] = this.isActiveFilter;
        data["actionCodeFilter"] = this.actionCodeFilter;
        data["targetAudienceCodeFilter"] = this.targetAudienceCodeFilter;
        data["campaignCodeFilter"] = this.campaignCodeFilter;
        data["campaignIdFilter"] = this.campaignIdFilter;
        data["sorting"] = this.sorting;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data;
    }
}

export interface IGetAllActionRulesInput {
    filter: string | undefined;
    codeFilter: string | undefined;
    nameFilter: string | undefined;
    descriptionFilter: string | undefined;
    maxEffectiveFromFilter: moment.Moment | undefined;
    minEffectiveFromFilter: moment.Moment | undefined;
    maxEffectiveToFilter: moment.Moment | undefined;
    minEffectiveToFilter: moment.Moment | undefined;
    cronFilter: string | undefined;
    maxStartTimeFilter: moment.Moment | undefined;
    minStartTimeFilter: moment.Moment | undefined;
    maxEndTimeFilter: moment.Moment | undefined;
    minEndTimeFilter: moment.Moment | undefined;
    actionFilterFilter: string | undefined;
    maxValueFilter: number | undefined;
    minValueFilter: number | undefined;
    maxPointValueFilter: number | undefined;
    minPointValueFilter: number | undefined;
    maxCoinValueFilter: number | undefined;
    minCoinValueFilter: number | undefined;
    maxMaxSetFilter: number | undefined;
    minMaxSetFilter: number | undefined;
    typeFilter: number | undefined;
    maxMaxSetPerActionFilter: number | undefined;
    minMaxSetPerActionFilter: number | undefined;
    timeZoneFilter: string | undefined;
    isActiveFilter: number | undefined;
    actionCodeFilter: string | undefined;
    targetAudienceCodeFilter: string | undefined;
    campaignCodeFilter: string | undefined;
    campaignIdFilter: number | undefined;
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;
}

export class PagedResultDtoOfGetActionForView implements IPagedResultDtoOfGetActionForView {
    totalCount!: number | undefined;
    items!: GetActionForView[] | undefined;

    constructor(data?: IPagedResultDtoOfGetActionForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetActionForView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetActionForView {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetActionForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetActionForView {
    totalCount: number | undefined;
    items: GetActionForView[] | undefined;
}

export class GetActionForView implements IGetActionForView {
    action!: ActionDto | undefined;

    constructor(data?: IGetActionForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.action = data["action"] ? ActionDto.fromJS(data["action"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetActionForView {
        data = typeof data === 'object' ? data : {};
        let result = new GetActionForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["action"] = this.action ? this.action.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetActionForView {
    action: ActionDto | undefined;
}

export class ActionDto implements IActionDto {
    code!: string | undefined;
    name!: string | undefined;
    isActive!: boolean | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    lastModifierUserName!: string | undefined;
    id!: number | undefined;

    constructor(data?: IActionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.name = data["name"];
            this.isActive = data["isActive"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.lastModifierUserName = data["lastModifierUserName"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ActionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModifierUserName"] = this.lastModifierUserName;
        data["id"] = this.id;
        return data;
    }
}

export interface IActionDto {
    code: string | undefined;
    name: string | undefined;
    isActive: boolean | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    lastModifierUserName: string | undefined;
    id: number | undefined;
}

export class GetActionForEditOutput implements IGetActionForEditOutput {
    action!: CreateOrEditActionDto | undefined;
    lastModifierUserName!: string | undefined;
    id!: number | undefined;

    constructor(data?: IGetActionForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.action = data["action"] ? CreateOrEditActionDto.fromJS(data["action"]) : <any>undefined;
            this.lastModifierUserName = data["lastModifierUserName"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): GetActionForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetActionForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["action"] = this.action ? this.action.toJSON() : <any>undefined;
        data["lastModifierUserName"] = this.lastModifierUserName;
        data["id"] = this.id;
        return data;
    }
}

export interface IGetActionForEditOutput {
    action: CreateOrEditActionDto | undefined;
    lastModifierUserName: string | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfGetActionTransactionForView implements IPagedResultDtoOfGetActionTransactionForView {
    totalCount!: number | undefined;
    items!: GetActionTransactionForView[] | undefined;

    constructor(data?: IPagedResultDtoOfGetActionTransactionForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetActionTransactionForView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetActionTransactionForView {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetActionTransactionForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetActionTransactionForView {
    totalCount: number | undefined;
    items: GetActionTransactionForView[] | undefined;
}

export class GetActionTransactionForView implements IGetActionTransactionForView {
    actionTransaction!: ActionTransactionDto | undefined;
    actionCode!: string | undefined;
    transactionCode!: string | undefined;

    constructor(data?: IGetActionTransactionForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.actionTransaction = data["actionTransaction"] ? ActionTransactionDto.fromJS(data["actionTransaction"]) : <any>undefined;
            this.actionCode = data["actionCode"];
            this.transactionCode = data["transactionCode"];
        }
    }

    static fromJS(data: any): GetActionTransactionForView {
        data = typeof data === 'object' ? data : {};
        let result = new GetActionTransactionForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["actionTransaction"] = this.actionTransaction ? this.actionTransaction.toJSON() : <any>undefined;
        data["actionCode"] = this.actionCode;
        data["transactionCode"] = this.transactionCode;
        return data;
    }
}

export interface IGetActionTransactionForView {
    actionTransaction: ActionTransactionDto | undefined;
    actionCode: string | undefined;
    transactionCode: string | undefined;
}

export class ActionTransactionDto implements IActionTransactionDto {
    actionCode!: string | undefined;
    memberCode!: string | undefined;
    transactionTime!: moment.Moment | undefined;
    value!: number | undefined;
    actionRuleSettingId!: string | undefined;
    transactionCode!: string | undefined;
    tags!: string | undefined;
    actionFilter!: string | undefined;
    set!: number | undefined;
    actionId!: number | undefined;
    transactionId!: number | undefined;
    id!: number | undefined;

    constructor(data?: IActionTransactionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.actionCode = data["actionCode"];
            this.memberCode = data["memberCode"];
            this.transactionTime = data["transactionTime"] ? moment(data["transactionTime"].toString()) : <any>undefined;
            this.value = data["value"];
            this.actionRuleSettingId = data["actionRuleSettingId"];
            this.transactionCode = data["transactionCode"];
            this.tags = data["tags"];
            this.actionFilter = data["actionFilter"];
            this.set = data["set"];
            this.actionId = data["actionId"];
            this.transactionId = data["transactionId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ActionTransactionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActionTransactionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["actionCode"] = this.actionCode;
        data["memberCode"] = this.memberCode;
        data["transactionTime"] = this.transactionTime ? this.transactionTime.toISOString() : <any>undefined;
        data["value"] = this.value;
        data["actionRuleSettingId"] = this.actionRuleSettingId;
        data["transactionCode"] = this.transactionCode;
        data["tags"] = this.tags;
        data["actionFilter"] = this.actionFilter;
        data["set"] = this.set;
        data["actionId"] = this.actionId;
        data["transactionId"] = this.transactionId;
        data["id"] = this.id;
        return data;
    }
}

export interface IActionTransactionDto {
    actionCode: string | undefined;
    memberCode: string | undefined;
    transactionTime: moment.Moment | undefined;
    value: number | undefined;
    actionRuleSettingId: string | undefined;
    transactionCode: string | undefined;
    tags: string | undefined;
    actionFilter: string | undefined;
    set: number | undefined;
    actionId: number | undefined;
    transactionId: number | undefined;
    id: number | undefined;
}

export class GetActionTransactionForEditOutput implements IGetActionTransactionForEditOutput {
    actionTransaction!: CreateOrEditActionTransactionDto | undefined;
    actionCode!: string | undefined;
    transactionCode!: string | undefined;

    constructor(data?: IGetActionTransactionForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.actionTransaction = data["actionTransaction"] ? CreateOrEditActionTransactionDto.fromJS(data["actionTransaction"]) : <any>undefined;
            this.actionCode = data["actionCode"];
            this.transactionCode = data["transactionCode"];
        }
    }

    static fromJS(data: any): GetActionTransactionForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetActionTransactionForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["actionTransaction"] = this.actionTransaction ? this.actionTransaction.toJSON() : <any>undefined;
        data["actionCode"] = this.actionCode;
        data["transactionCode"] = this.transactionCode;
        return data;
    }
}

export interface IGetActionTransactionForEditOutput {
    actionTransaction: CreateOrEditActionTransactionDto | undefined;
    actionCode: string | undefined;
    transactionCode: string | undefined;
}

export class CreateOrEditActionTransactionDto implements ICreateOrEditActionTransactionDto {
    actionCode!: string | undefined;
    memberCode!: string | undefined;
    transactionTime!: moment.Moment | undefined;
    value!: number | undefined;
    actionRuleSettingId!: string | undefined;
    transactionCode!: string | undefined;
    tags!: string | undefined;
    actionFilter!: string | undefined;
    set!: number | undefined;
    actionId!: number | undefined;
    transactionId!: number | undefined;
    isDeleted!: boolean | undefined;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: moment.Moment | undefined;
    creatorUserId!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditActionTransactionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.actionCode = data["actionCode"];
            this.memberCode = data["memberCode"];
            this.transactionTime = data["transactionTime"] ? moment(data["transactionTime"].toString()) : <any>undefined;
            this.value = data["value"];
            this.actionRuleSettingId = data["actionRuleSettingId"];
            this.transactionCode = data["transactionCode"];
            this.tags = data["tags"];
            this.actionFilter = data["actionFilter"];
            this.set = data["set"];
            this.actionId = data["actionId"];
            this.transactionId = data["transactionId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditActionTransactionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditActionTransactionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["actionCode"] = this.actionCode;
        data["memberCode"] = this.memberCode;
        data["transactionTime"] = this.transactionTime ? this.transactionTime.toISOString() : <any>undefined;
        data["value"] = this.value;
        data["actionRuleSettingId"] = this.actionRuleSettingId;
        data["transactionCode"] = this.transactionCode;
        data["tags"] = this.tags;
        data["actionFilter"] = this.actionFilter;
        data["set"] = this.set;
        data["actionId"] = this.actionId;
        data["transactionId"] = this.transactionId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditActionTransactionDto {
    actionCode: string | undefined;
    memberCode: string | undefined;
    transactionTime: moment.Moment | undefined;
    value: number | undefined;
    actionRuleSettingId: string | undefined;
    transactionCode: string | undefined;
    tags: string | undefined;
    actionFilter: string | undefined;
    set: number | undefined;
    actionId: number | undefined;
    transactionId: number | undefined;
    isDeleted: boolean | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfTransactionLookupTableDto implements IPagedResultDtoOfTransactionLookupTableDto {
    totalCount!: number | undefined;
    items!: TransactionLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfTransactionLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(TransactionLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfTransactionLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfTransactionLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfTransactionLookupTableDto {
    totalCount: number | undefined;
    items: TransactionLookupTableDto[] | undefined;
}

export class TransactionLookupTableDto implements ITransactionLookupTableDto {
    id!: number | undefined;
    displayName!: string | undefined;

    constructor(data?: ITransactionLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): TransactionLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface ITransactionLookupTableDto {
    id: number | undefined;
    displayName: string | undefined;
}

export class CreateOrEditActivationCodeInput implements ICreateOrEditActivationCodeInput {
    code!: string | undefined;
    serial!: string | undefined;
    status!: string | undefined;
    massOrder!: string | undefined;
    activeDate!: moment.Moment | undefined;
    createdDate!: moment.Moment | undefined;
    createdBy!: string | undefined;
    isCancel!: boolean | undefined;
    note!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditActivationCodeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.serial = data["serial"];
            this.status = data["status"];
            this.massOrder = data["massOrder"];
            this.activeDate = data["activeDate"] ? moment(data["activeDate"].toString()) : <any>undefined;
            this.createdDate = data["createdDate"] ? moment(data["createdDate"].toString()) : <any>undefined;
            this.createdBy = data["createdBy"];
            this.isCancel = data["isCancel"];
            this.note = data["note"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditActivationCodeInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditActivationCodeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["serial"] = this.serial;
        data["status"] = this.status;
        data["massOrder"] = this.massOrder;
        data["activeDate"] = this.activeDate ? this.activeDate.toISOString() : <any>undefined;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["isCancel"] = this.isCancel;
        data["note"] = this.note;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditActivationCodeInput {
    code: string | undefined;
    serial: string | undefined;
    status: string | undefined;
    massOrder: string | undefined;
    activeDate: moment.Moment | undefined;
    createdDate: moment.Moment | undefined;
    createdBy: string | undefined;
    isCancel: boolean | undefined;
    note: string | undefined;
    id: number | undefined;
}

export class ResponseStatusDtoOfBoolean implements IResponseStatusDtoOfBoolean {
    message!: string | undefined;
    status!: boolean | undefined;

    constructor(data?: IResponseStatusDtoOfBoolean) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.message = data["message"];
            this.status = data["status"];
        }
    }

    static fromJS(data: any): ResponseStatusDtoOfBoolean {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseStatusDtoOfBoolean();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["status"] = this.status;
        return data;
    }
}

export interface IResponseStatusDtoOfBoolean {
    message: string | undefined;
    status: boolean | undefined;
}

export class ResponseDataDtoOfString implements IResponseDataDtoOfString {
    message!: string | undefined;
    status!: boolean | undefined;
    data!: string | undefined;

    constructor(data?: IResponseDataDtoOfString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.message = data["message"];
            this.status = data["status"];
            this.data = data["data"];
        }
    }

    static fromJS(data: any): ResponseDataDtoOfString {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseDataDtoOfString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["status"] = this.status;
        data["data"] = this.data;
        return data;
    }
}

export interface IResponseDataDtoOfString {
    message: string | undefined;
    status: boolean | undefined;
    data: string | undefined;
}

export class PagedResultDtoOfGetActivationCodeForViewDto implements IPagedResultDtoOfGetActivationCodeForViewDto {
    totalCount!: number | undefined;
    items!: GetActivationCodeForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetActivationCodeForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetActivationCodeForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetActivationCodeForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetActivationCodeForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetActivationCodeForViewDto {
    totalCount: number | undefined;
    items: GetActivationCodeForViewDto[] | undefined;
}

export class GetActivationCodeForViewDto implements IGetActivationCodeForViewDto {
    activationCode!: GetListActivationCodeResponse | undefined;

    constructor(data?: IGetActivationCodeForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.activationCode = data["activationCode"] ? GetListActivationCodeResponse.fromJS(data["activationCode"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetActivationCodeForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetActivationCodeForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activationCode"] = this.activationCode ? this.activationCode.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetActivationCodeForViewDto {
    activationCode: GetListActivationCodeResponse | undefined;
}

export class GetListActivationCodeResponse implements IGetListActivationCodeResponse {
    code!: string | undefined;
    serial!: string | undefined;
    status!: string | undefined;
    massOrder!: string | undefined;
    activeDate!: moment.Moment | undefined;
    createdDate!: moment.Moment | undefined;
    createdBy!: string | undefined;
    isCancel!: boolean | undefined;
    note!: string | undefined;
    isDeleted!: boolean | undefined;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: moment.Moment | undefined;
    creatorUserId!: number | undefined;
    id!: number | undefined;

    constructor(data?: IGetListActivationCodeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.serial = data["serial"];
            this.status = data["status"];
            this.massOrder = data["massOrder"];
            this.activeDate = data["activeDate"] ? moment(data["activeDate"].toString()) : <any>undefined;
            this.createdDate = data["createdDate"] ? moment(data["createdDate"].toString()) : <any>undefined;
            this.createdBy = data["createdBy"];
            this.isCancel = data["isCancel"];
            this.note = data["note"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): GetListActivationCodeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetListActivationCodeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["serial"] = this.serial;
        data["status"] = this.status;
        data["massOrder"] = this.massOrder;
        data["activeDate"] = this.activeDate ? this.activeDate.toISOString() : <any>undefined;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["isCancel"] = this.isCancel;
        data["note"] = this.note;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IGetListActivationCodeResponse {
    code: string | undefined;
    serial: string | undefined;
    status: string | undefined;
    massOrder: string | undefined;
    activeDate: moment.Moment | undefined;
    createdDate: moment.Moment | undefined;
    createdBy: string | undefined;
    isCancel: boolean | undefined;
    note: string | undefined;
    isDeleted: boolean | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class GetActivationCodeInput implements IGetActivationCodeInput {
    code!: string | undefined;
    serial!: string | undefined;
    status!: string | undefined;
    massOrder!: string | undefined;
    importDate!: moment.Moment | undefined;
    activeDate!: moment.Moment | undefined;
    isCancel!: boolean | undefined;
    note!: string | undefined;
    salemanCode!: string | undefined;
    fromDate!: moment.Moment | undefined;
    toDate!: moment.Moment | undefined;
    sorting!: string | undefined;
    skipCount!: number | undefined;
    maxResultCount!: number | undefined;

    constructor(data?: IGetActivationCodeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.serial = data["serial"];
            this.status = data["status"];
            this.massOrder = data["massOrder"];
            this.importDate = data["importDate"] ? moment(data["importDate"].toString()) : <any>undefined;
            this.activeDate = data["activeDate"] ? moment(data["activeDate"].toString()) : <any>undefined;
            this.isCancel = data["isCancel"];
            this.note = data["note"];
            this.salemanCode = data["salemanCode"];
            this.fromDate = data["fromDate"] ? moment(data["fromDate"].toString()) : <any>undefined;
            this.toDate = data["toDate"] ? moment(data["toDate"].toString()) : <any>undefined;
            this.sorting = data["sorting"];
            this.skipCount = data["skipCount"];
            this.maxResultCount = data["maxResultCount"];
        }
    }

    static fromJS(data: any): GetActivationCodeInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetActivationCodeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["serial"] = this.serial;
        data["status"] = this.status;
        data["massOrder"] = this.massOrder;
        data["importDate"] = this.importDate ? this.importDate.toISOString() : <any>undefined;
        data["activeDate"] = this.activeDate ? this.activeDate.toISOString() : <any>undefined;
        data["isCancel"] = this.isCancel;
        data["note"] = this.note;
        data["salemanCode"] = this.salemanCode;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data["sorting"] = this.sorting;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data;
    }
}

export interface IGetActivationCodeInput {
    code: string | undefined;
    serial: string | undefined;
    status: string | undefined;
    massOrder: string | undefined;
    importDate: moment.Moment | undefined;
    activeDate: moment.Moment | undefined;
    isCancel: boolean | undefined;
    note: string | undefined;
    salemanCode: string | undefined;
    fromDate: moment.Moment | undefined;
    toDate: moment.Moment | undefined;
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;
}

export class SocialRetailerFileDto implements ISocialRetailerFileDto {
    fileName!: string;
    fileType!: string;
    fileToken!: string;
    fileBytes: string;
    fileContent: string;

    constructor(data?: ISocialRetailerFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.fileName = data["fileName"];
            this.fileType = data["fileType"];
            this.fileToken = data["fileToken"];
        }
    }

    static fromJS(data: any): SocialRetailerFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new SocialRetailerFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["fileType"] = this.fileType;
        data["fileToken"] = this.fileToken;
        return data;
    }
}

export interface ISocialRetailerFileDto {
    fileName: string;
    fileType: string;
    fileToken: string;
}

export class CommonImportAgrs implements ICommonImportAgrs {
    timeZoneOffset!: number | undefined;
    currentDate!: moment.Moment | undefined;
    isSuccess!: boolean | undefined;
    errorFilePath!: string | undefined;
    successCount!: number | undefined;
    failCount!: number | undefined;
    type!: string | undefined;
    totalRow!: number | undefined;
    lst_input!: ScanSerialRequestDto[] | undefined;
    tableName!: string | undefined;
    filePath!: string | undefined;
    fileName!: string | undefined;
    userId!: number | undefined;
    userName!: string | undefined;
    name!: string | undefined;
    tenantId!: number | undefined;
    currentLanguage!: string | undefined;
    apiUrl!: string | undefined;

    constructor(data?: ICommonImportAgrs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.timeZoneOffset = data["timeZoneOffset"];
            this.currentDate = data["currentDate"] ? moment(data["currentDate"].toString()) : <any>undefined;
            this.isSuccess = data["isSuccess"];
            this.errorFilePath = data["errorFilePath"];
            this.successCount = data["successCount"];
            this.failCount = data["failCount"];
            this.type = data["type"];
            this.totalRow = data["totalRow"];
            if (data["lst_input"] && data["lst_input"].constructor === Array) {
                this.lst_input = [];
                for (let item of data["lst_input"])
                    this.lst_input.push(ScanSerialRequestDto.fromJS(item));
            }
            this.tableName = data["tableName"];
            this.filePath = data["filePath"];
            this.fileName = data["fileName"];
            this.userId = data["userId"];
            this.userName = data["userName"];
            this.name = data["name"];
            this.tenantId = data["tenantId"];
            this.currentLanguage = data["currentLanguage"];
            this.apiUrl = data["apiUrl"];
        }
    }

    static fromJS(data: any): CommonImportAgrs {
        data = typeof data === 'object' ? data : {};
        let result = new CommonImportAgrs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timeZoneOffset"] = this.timeZoneOffset;
        data["currentDate"] = this.currentDate ? this.currentDate.toISOString() : <any>undefined;
        data["isSuccess"] = this.isSuccess;
        data["errorFilePath"] = this.errorFilePath;
        data["successCount"] = this.successCount;
        data["failCount"] = this.failCount;
        data["type"] = this.type;
        data["totalRow"] = this.totalRow;
        if (this.lst_input && this.lst_input.constructor === Array) {
            data["lst_input"] = [];
            for (let item of this.lst_input)
                data["lst_input"].push(item.toJSON());
        }
        data["tableName"] = this.tableName;
        data["filePath"] = this.filePath;
        data["fileName"] = this.fileName;
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["name"] = this.name;
        data["tenantId"] = this.tenantId;
        data["currentLanguage"] = this.currentLanguage;
        data["apiUrl"] = this.apiUrl;
        return data;
    }
}

export interface ICommonImportAgrs {
    timeZoneOffset: number | undefined;
    currentDate: moment.Moment | undefined;
    isSuccess: boolean | undefined;
    errorFilePath: string | undefined;
    successCount: number | undefined;
    failCount: number | undefined;
    type: string | undefined;
    totalRow: number | undefined;
    lst_input: ScanSerialRequestDto[] | undefined;
    tableName: string | undefined;
    filePath: string | undefined;
    fileName: string | undefined;
    userId: number | undefined;
    userName: string | undefined;
    name: string | undefined;
    tenantId: number | undefined;
    currentLanguage: string | undefined;
    apiUrl: string | undefined;
}

export class ScanSerialRequestDto implements IScanSerialRequestDto {
    serial!: string | undefined;
    referenceId!: string | undefined;
    memberCode!: string | undefined;
    memberName!: string | undefined;
    vehicleNumber!: string | undefined;
    modelCode!: string | undefined;
    message!: string | undefined;
    isDistributorTemp!: string | undefined;
    doType!: string | undefined;

    constructor(data?: IScanSerialRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.serial = data["serial"];
            this.referenceId = data["referenceId"];
            this.memberCode = data["memberCode"];
            this.memberName = data["memberName"];
            this.vehicleNumber = data["vehicleNumber"];
            this.modelCode = data["modelCode"];
            this.message = data["message"];
            this.isDistributorTemp = data["isDistributorTemp"];
            this.doType = data["doType"];
        }
    }

    static fromJS(data: any): ScanSerialRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ScanSerialRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serial"] = this.serial;
        data["referenceId"] = this.referenceId;
        data["memberCode"] = this.memberCode;
        data["memberName"] = this.memberName;
        data["vehicleNumber"] = this.vehicleNumber;
        data["modelCode"] = this.modelCode;
        data["message"] = this.message;
        data["isDistributorTemp"] = this.isDistributorTemp;
        data["doType"] = this.doType;
        return data;
    }
}

export interface IScanSerialRequestDto {
    serial: string | undefined;
    referenceId: string | undefined;
    memberCode: string | undefined;
    memberName: string | undefined;
    vehicleNumber: string | undefined;
    modelCode: string | undefined;
    message: string | undefined;
    isDistributorTemp: string | undefined;
    doType: string | undefined;
}

export class StatusImportDistributeDto implements IStatusImportDistributeDto {
    totalRow!: number | undefined;
    currentRow!: number | undefined;
    importing!: boolean | undefined;
    isSuccess!: boolean | undefined;
    successCount!: number | undefined;
    errorCount!: number | undefined;
    linkFileImport!: string | undefined;
    isImportImmediately!: boolean | undefined;
    errorMessage!: string | undefined;

    constructor(data?: IStatusImportDistributeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalRow = data["totalRow"];
            this.currentRow = data["currentRow"];
            this.importing = data["importing"];
            this.isSuccess = data["isSuccess"];
            this.successCount = data["successCount"];
            this.errorCount = data["errorCount"];
            this.linkFileImport = data["linkFileImport"];
            this.isImportImmediately = data["isImportImmediately"];
            this.errorMessage = data["errorMessage"];
        }
    }

    static fromJS(data: any): StatusImportDistributeDto {
        data = typeof data === 'object' ? data : {};
        let result = new StatusImportDistributeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRow"] = this.totalRow;
        data["currentRow"] = this.currentRow;
        data["importing"] = this.importing;
        data["isSuccess"] = this.isSuccess;
        data["successCount"] = this.successCount;
        data["errorCount"] = this.errorCount;
        data["linkFileImport"] = this.linkFileImport;
        data["isImportImmediately"] = this.isImportImmediately;
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface IStatusImportDistributeDto {
    totalRow: number | undefined;
    currentRow: number | undefined;
    importing: boolean | undefined;
    isSuccess: boolean | undefined;
    successCount: number | undefined;
    errorCount: number | undefined;
    linkFileImport: string | undefined;
    isImportImmediately: boolean | undefined;
    errorMessage: string | undefined;
}

export class PagedResultDtoOfGetAdjustmentFileStatusForView implements IPagedResultDtoOfGetAdjustmentFileStatusForView {
    totalCount!: number | undefined;
    items!: GetAdjustmentFileStatusForView[] | undefined;

    constructor(data?: IPagedResultDtoOfGetAdjustmentFileStatusForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetAdjustmentFileStatusForView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetAdjustmentFileStatusForView {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetAdjustmentFileStatusForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetAdjustmentFileStatusForView {
    totalCount: number | undefined;
    items: GetAdjustmentFileStatusForView[] | undefined;
}

export class GetAdjustmentFileStatusForView implements IGetAdjustmentFileStatusForView {
    adjustmentFileStatus!: AdjustmentFileStatusDto | undefined;

    constructor(data?: IGetAdjustmentFileStatusForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.adjustmentFileStatus = data["adjustmentFileStatus"] ? AdjustmentFileStatusDto.fromJS(data["adjustmentFileStatus"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetAdjustmentFileStatusForView {
        data = typeof data === 'object' ? data : {};
        let result = new GetAdjustmentFileStatusForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["adjustmentFileStatus"] = this.adjustmentFileStatus ? this.adjustmentFileStatus.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetAdjustmentFileStatusForView {
    adjustmentFileStatus: AdjustmentFileStatusDto | undefined;
}

export class AdjustmentFileStatusDto implements IAdjustmentFileStatusDto {
    code!: string | undefined;
    fileName!: string | undefined;
    status!: string | undefined;
    processTime!: moment.Moment | undefined;
    creatorUserId!: string | undefined;
    type!: string | undefined;
    id!: number | undefined;

    constructor(data?: IAdjustmentFileStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.fileName = data["fileName"];
            this.status = data["status"];
            this.processTime = data["processTime"] ? moment(data["processTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.type = data["type"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): AdjustmentFileStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdjustmentFileStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["fileName"] = this.fileName;
        data["status"] = this.status;
        data["processTime"] = this.processTime ? this.processTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["type"] = this.type;
        data["id"] = this.id;
        return data;
    }
}

export interface IAdjustmentFileStatusDto {
    code: string | undefined;
    fileName: string | undefined;
    status: string | undefined;
    processTime: moment.Moment | undefined;
    creatorUserId: string | undefined;
    type: string | undefined;
    id: number | undefined;
}

export class GetAdjustmentFileStatusForEditOutput implements IGetAdjustmentFileStatusForEditOutput {
    adjustmentFileStatus!: CreateOrEditAdjustmentFileStatusDto | undefined;

    constructor(data?: IGetAdjustmentFileStatusForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.adjustmentFileStatus = data["adjustmentFileStatus"] ? CreateOrEditAdjustmentFileStatusDto.fromJS(data["adjustmentFileStatus"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetAdjustmentFileStatusForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAdjustmentFileStatusForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["adjustmentFileStatus"] = this.adjustmentFileStatus ? this.adjustmentFileStatus.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetAdjustmentFileStatusForEditOutput {
    adjustmentFileStatus: CreateOrEditAdjustmentFileStatusDto | undefined;
}

export class CreateOrEditAdjustmentFileStatusDto implements ICreateOrEditAdjustmentFileStatusDto {
    code!: string | undefined;
    fileName!: string | undefined;
    status!: string | undefined;
    processTime!: moment.Moment | undefined;
    type!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditAdjustmentFileStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.fileName = data["fileName"];
            this.status = data["status"];
            this.processTime = data["processTime"] ? moment(data["processTime"].toString()) : <any>undefined;
            this.type = data["type"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditAdjustmentFileStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditAdjustmentFileStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["fileName"] = this.fileName;
        data["status"] = this.status;
        data["processTime"] = this.processTime ? this.processTime.toISOString() : <any>undefined;
        data["type"] = this.type;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditAdjustmentFileStatusDto {
    code: string | undefined;
    fileName: string | undefined;
    status: string | undefined;
    processTime: moment.Moment | undefined;
    type: string | undefined;
    id: number | undefined;
}

export class AdjustmentImportJobArgs implements IAdjustmentImportJobArgs {
    codePrefix!: string | undefined;
    approver!: string | undefined;
    reason!: string | undefined;
    type!: string | undefined;
    tableName!: string | undefined;
    filePath!: string | undefined;
    fileName!: string | undefined;
    userId!: number | undefined;
    tenantId!: number | undefined;
    currentLanguage!: string | undefined;
    apiUrl!: string | undefined;

    constructor(data?: IAdjustmentImportJobArgs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.codePrefix = data["codePrefix"];
            this.approver = data["approver"];
            this.reason = data["reason"];
            this.type = data["type"];
            this.tableName = data["tableName"];
            this.filePath = data["filePath"];
            this.fileName = data["fileName"];
            this.userId = data["userId"];
            this.tenantId = data["tenantId"];
            this.currentLanguage = data["currentLanguage"];
            this.apiUrl = data["apiUrl"];
        }
    }

    static fromJS(data: any): AdjustmentImportJobArgs {
        data = typeof data === 'object' ? data : {};
        let result = new AdjustmentImportJobArgs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codePrefix"] = this.codePrefix;
        data["approver"] = this.approver;
        data["reason"] = this.reason;
        data["type"] = this.type;
        data["tableName"] = this.tableName;
        data["filePath"] = this.filePath;
        data["fileName"] = this.fileName;
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["currentLanguage"] = this.currentLanguage;
        data["apiUrl"] = this.apiUrl;
        return data;
    }
}

export interface IAdjustmentImportJobArgs {
    codePrefix: string | undefined;
    approver: string | undefined;
    reason: string | undefined;
    type: string | undefined;
    tableName: string | undefined;
    filePath: string | undefined;
    fileName: string | undefined;
    userId: number | undefined;
    tenantId: number | undefined;
    currentLanguage: string | undefined;
    apiUrl: string | undefined;
}

export class RankAdjustmentImportJobArgs implements IRankAdjustmentImportJobArgs {
    type!: string | undefined;
    tableName!: string | undefined;
    filePath!: string | undefined;
    fileName!: string | undefined;
    userId!: number | undefined;
    tenantId!: number | undefined;
    currentLanguage!: string | undefined;
    apiUrl!: string | undefined;

    constructor(data?: IRankAdjustmentImportJobArgs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.type = data["type"];
            this.tableName = data["tableName"];
            this.filePath = data["filePath"];
            this.fileName = data["fileName"];
            this.userId = data["userId"];
            this.tenantId = data["tenantId"];
            this.currentLanguage = data["currentLanguage"];
            this.apiUrl = data["apiUrl"];
        }
    }

    static fromJS(data: any): RankAdjustmentImportJobArgs {
        data = typeof data === 'object' ? data : {};
        let result = new RankAdjustmentImportJobArgs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["tableName"] = this.tableName;
        data["filePath"] = this.filePath;
        data["fileName"] = this.fileName;
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["currentLanguage"] = this.currentLanguage;
        data["apiUrl"] = this.apiUrl;
        return data;
    }
}

export interface IRankAdjustmentImportJobArgs {
    type: string | undefined;
    tableName: string | undefined;
    filePath: string | undefined;
    fileName: string | undefined;
    userId: number | undefined;
    tenantId: number | undefined;
    currentLanguage: string | undefined;
    apiUrl: string | undefined;
}

export class ExportRankAdjustmentInput implements IExportRankAdjustmentInput {
    type!: string | undefined;

    constructor(data?: IExportRankAdjustmentInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.type = data["type"];
        }
    }

    static fromJS(data: any): ExportRankAdjustmentInput {
        data = typeof data === 'object' ? data : {};
        let result = new ExportRankAdjustmentInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        return data;
    }
}

export interface IExportRankAdjustmentInput {
    type: string | undefined;
}

export class PointFileDto implements IPointFileDto {
    fileName!: string;
    fileType!: string;
    fileToken!: string;

    constructor(data?: IPointFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.fileName = data["fileName"];
            this.fileType = data["fileType"];
            this.fileToken = data["fileToken"];
        }
    }

    static fromJS(data: any): PointFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new PointFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["fileType"] = this.fileType;
        data["fileToken"] = this.fileToken;
        return data;
    }
}

export interface IPointFileDto {
    fileName: string;
    fileType: string;
    fileToken: string;
}

export class PagedResultDtoOfGetAlbumForApp implements IPagedResultDtoOfGetAlbumForApp {
    totalCount!: number | undefined;
    items!: GetAlbumForApp[] | undefined;

    constructor(data?: IPagedResultDtoOfGetAlbumForApp) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetAlbumForApp.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetAlbumForApp {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetAlbumForApp();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetAlbumForApp {
    totalCount: number | undefined;
    items: GetAlbumForApp[] | undefined;
}

export class GetAlbumForApp implements IGetAlbumForApp {
    album!: AlbumForAppDto | undefined;

    constructor(data?: IGetAlbumForApp) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.album = data["album"] ? AlbumForAppDto.fromJS(data["album"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetAlbumForApp {
        data = typeof data === 'object' ? data : {};
        let result = new GetAlbumForApp();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["album"] = this.album ? this.album.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetAlbumForApp {
    album: AlbumForAppDto | undefined;
}

export class AlbumForAppDto implements IAlbumForAppDto {
    code!: string | undefined;
    name!: string | undefined;
    description!: string | undefined;
    avatar!: string | undefined;
    status!: string | undefined;
    ordinal!: number | undefined;
    fromDate!: moment.Moment | undefined;
    toDate!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;
    imageLink!: ImageForAppDto[] | undefined;
    id!: number | undefined;

    constructor(data?: IAlbumForAppDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.name = data["name"];
            this.description = data["description"];
            this.avatar = data["avatar"];
            this.status = data["status"];
            this.ordinal = data["ordinal"];
            this.fromDate = data["fromDate"] ? moment(data["fromDate"].toString()) : <any>undefined;
            this.toDate = data["toDate"] ? moment(data["toDate"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            if (data["imageLink"] && data["imageLink"].constructor === Array) {
                this.imageLink = [];
                for (let item of data["imageLink"])
                    this.imageLink.push(ImageForAppDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): AlbumForAppDto {
        data = typeof data === 'object' ? data : {};
        let result = new AlbumForAppDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["description"] = this.description;
        data["avatar"] = this.avatar;
        data["status"] = this.status;
        data["ordinal"] = this.ordinal;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        if (this.imageLink && this.imageLink.constructor === Array) {
            data["imageLink"] = [];
            for (let item of this.imageLink)
                data["imageLink"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IAlbumForAppDto {
    code: string | undefined;
    name: string | undefined;
    description: string | undefined;
    avatar: string | undefined;
    status: string | undefined;
    ordinal: number | undefined;
    fromDate: moment.Moment | undefined;
    toDate: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    imageLink: ImageForAppDto[] | undefined;
    id: number | undefined;
}

export class ImageForAppDto implements IImageForAppDto {
    code!: string | undefined;
    link!: string | undefined;
    ordinal!: number | undefined;
    description!: string | undefined;

    constructor(data?: IImageForAppDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.link = data["link"];
            this.ordinal = data["ordinal"];
            this.description = data["description"];
        }
    }

    static fromJS(data: any): ImageForAppDto {
        data = typeof data === 'object' ? data : {};
        let result = new ImageForAppDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["link"] = this.link;
        data["ordinal"] = this.ordinal;
        data["description"] = this.description;
        return data;
    }
}

export interface IImageForAppDto {
    code: string | undefined;
    link: string | undefined;
    ordinal: number | undefined;
    description: string | undefined;
}

export class GetAlbumForEditOutput implements IGetAlbumForEditOutput {
    album!: CreateOrEditAlbumDto | undefined;
    galleryImages!: CreateOrEditImageModel[] | undefined;
    lastModifierUserName!: string | undefined;
    avatarLink!: string | undefined;
    avatarLinkId!: number | undefined;

    constructor(data?: IGetAlbumForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.album = data["album"] ? CreateOrEditAlbumDto.fromJS(data["album"]) : <any>undefined;
            if (data["galleryImages"] && data["galleryImages"].constructor === Array) {
                this.galleryImages = [];
                for (let item of data["galleryImages"])
                    this.galleryImages.push(CreateOrEditImageModel.fromJS(item));
            }
            this.lastModifierUserName = data["lastModifierUserName"];
            this.avatarLink = data["avatarLink"];
            this.avatarLinkId = data["avatarLinkId"];
        }
    }

    static fromJS(data: any): GetAlbumForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAlbumForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["album"] = this.album ? this.album.toJSON() : <any>undefined;
        if (this.galleryImages && this.galleryImages.constructor === Array) {
            data["galleryImages"] = [];
            for (let item of this.galleryImages)
                data["galleryImages"].push(item.toJSON());
        }
        data["lastModifierUserName"] = this.lastModifierUserName;
        data["avatarLink"] = this.avatarLink;
        data["avatarLinkId"] = this.avatarLinkId;
        return data;
    }
}

export interface IGetAlbumForEditOutput {
    album: CreateOrEditAlbumDto | undefined;
    galleryImages: CreateOrEditImageModel[] | undefined;
    lastModifierUserName: string | undefined;
    avatarLink: string | undefined;
    avatarLinkId: number | undefined;
}

export class CreateOrEditAlbumDto implements ICreateOrEditAlbumDto {
    code!: string | undefined;
    name!: string | undefined;
    description!: string | undefined;
    status!: string | undefined;
    ordinal!: number | undefined;
    fromDate!: moment.Moment | undefined;
    toDate!: moment.Moment | undefined;
    tenantId!: number | undefined;
    isDeleted!: boolean | undefined;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: moment.Moment | undefined;
    creatorUserId!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditAlbumDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.name = data["name"];
            this.description = data["description"];
            this.status = data["status"];
            this.ordinal = data["ordinal"];
            this.fromDate = data["fromDate"] ? moment(data["fromDate"].toString()) : <any>undefined;
            this.toDate = data["toDate"] ? moment(data["toDate"].toString()) : <any>undefined;
            this.tenantId = data["tenantId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditAlbumDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditAlbumDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["description"] = this.description;
        data["status"] = this.status;
        data["ordinal"] = this.ordinal;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditAlbumDto {
    code: string | undefined;
    name: string | undefined;
    description: string | undefined;
    status: string | undefined;
    ordinal: number | undefined;
    fromDate: moment.Moment | undefined;
    toDate: moment.Moment | undefined;
    tenantId: number | undefined;
    isDeleted: boolean | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class CreateOrEditImageModel implements ICreateOrEditImageModel {
    id!: number | undefined;
    link!: string | undefined;

    constructor(data?: ICreateOrEditImageModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.link = data["link"];
        }
    }

    static fromJS(data: any): CreateOrEditImageModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditImageModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["link"] = this.link;
        return data;
    }
}

export interface ICreateOrEditImageModel {
    id: number | undefined;
    link: string | undefined;
}

export class CreateOrEditAlbumInput implements ICreateOrEditAlbumInput {
    album!: CreateOrEditAlbumDto | undefined;
    galleryImages!: CreateOrEditImageModel[] | undefined;
    avatarLink!: string | undefined;
    avatarLinkId!: number | undefined;

    constructor(data?: ICreateOrEditAlbumInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.album = data["album"] ? CreateOrEditAlbumDto.fromJS(data["album"]) : <any>undefined;
            if (data["galleryImages"] && data["galleryImages"].constructor === Array) {
                this.galleryImages = [];
                for (let item of data["galleryImages"])
                    this.galleryImages.push(CreateOrEditImageModel.fromJS(item));
            }
            this.avatarLink = data["avatarLink"];
            this.avatarLinkId = data["avatarLinkId"];
        }
    }

    static fromJS(data: any): CreateOrEditAlbumInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditAlbumInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["album"] = this.album ? this.album.toJSON() : <any>undefined;
        if (this.galleryImages && this.galleryImages.constructor === Array) {
            data["galleryImages"] = [];
            for (let item of this.galleryImages)
                data["galleryImages"].push(item.toJSON());
        }
        data["avatarLink"] = this.avatarLink;
        data["avatarLinkId"] = this.avatarLinkId;
        return data;
    }
}

export interface ICreateOrEditAlbumInput {
    album: CreateOrEditAlbumDto | undefined;
    galleryImages: CreateOrEditImageModel[] | undefined;
    avatarLink: string | undefined;
    avatarLinkId: number | undefined;
}

export class PagedResultDtoOfGetAlbumForView implements IPagedResultDtoOfGetAlbumForView {
    totalCount!: number | undefined;
    items!: GetAlbumForView[] | undefined;

    constructor(data?: IPagedResultDtoOfGetAlbumForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetAlbumForView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetAlbumForView {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetAlbumForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetAlbumForView {
    totalCount: number | undefined;
    items: GetAlbumForView[] | undefined;
}

export class GetAlbumForView implements IGetAlbumForView {
    album!: AlbumDto | undefined;
    lastModifierUserName!: string | undefined;

    constructor(data?: IGetAlbumForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.album = data["album"] ? AlbumDto.fromJS(data["album"]) : <any>undefined;
            this.lastModifierUserName = data["lastModifierUserName"];
        }
    }

    static fromJS(data: any): GetAlbumForView {
        data = typeof data === 'object' ? data : {};
        let result = new GetAlbumForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["album"] = this.album ? this.album.toJSON() : <any>undefined;
        data["lastModifierUserName"] = this.lastModifierUserName;
        return data;
    }
}

export interface IGetAlbumForView {
    album: AlbumDto | undefined;
    lastModifierUserName: string | undefined;
}

export class AlbumDto implements IAlbumDto {
    code!: string | undefined;
    name!: string | undefined;
    description!: string | undefined;
    status!: string | undefined;
    ordinal!: number | undefined;
    fromDate!: moment.Moment | undefined;
    toDate!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    id!: number | undefined;

    constructor(data?: IAlbumDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.name = data["name"];
            this.description = data["description"];
            this.status = data["status"];
            this.ordinal = data["ordinal"];
            this.fromDate = data["fromDate"] ? moment(data["fromDate"].toString()) : <any>undefined;
            this.toDate = data["toDate"] ? moment(data["toDate"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): AlbumDto {
        data = typeof data === 'object' ? data : {};
        let result = new AlbumDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["description"] = this.description;
        data["status"] = this.status;
        data["ordinal"] = this.ordinal;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IAlbumDto {
    code: string | undefined;
    name: string | undefined;
    description: string | undefined;
    status: string | undefined;
    ordinal: number | undefined;
    fromDate: moment.Moment | undefined;
    toDate: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    id: number | undefined;
}

export class LogInputSalesTrackingDto implements ILogInputSalesTrackingDto {
    userId!: string | undefined;
    appName!: string | undefined;
    appVersion!: string | undefined;
    appArea!: string | undefined;
    actionName!: string | undefined;
    actionInfo!: string | undefined;
    actionTime!: moment.Moment | undefined;
    deviceName!: string | undefined;
    deviceSerial!: string | undefined;
    deviceImei!: string | undefined;
    deviceManufacturer!: string | undefined;
    deviceOS!: string | undefined;
    deviceOSVersion!: string | undefined;

    constructor(data?: ILogInputSalesTrackingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userId = data["userId"];
            this.appName = data["appName"];
            this.appVersion = data["appVersion"];
            this.appArea = data["appArea"];
            this.actionName = data["actionName"];
            this.actionInfo = data["actionInfo"];
            this.actionTime = data["actionTime"] ? moment(data["actionTime"].toString()) : <any>undefined;
            this.deviceName = data["deviceName"];
            this.deviceSerial = data["deviceSerial"];
            this.deviceImei = data["deviceImei"];
            this.deviceManufacturer = data["deviceManufacturer"];
            this.deviceOS = data["deviceOS"];
            this.deviceOSVersion = data["deviceOSVersion"];
        }
    }

    static fromJS(data: any): LogInputSalesTrackingDto {
        data = typeof data === 'object' ? data : {};
        let result = new LogInputSalesTrackingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["appName"] = this.appName;
        data["appVersion"] = this.appVersion;
        data["appArea"] = this.appArea;
        data["actionName"] = this.actionName;
        data["actionInfo"] = this.actionInfo;
        data["actionTime"] = this.actionTime ? this.actionTime.toISOString() : <any>undefined;
        data["deviceName"] = this.deviceName;
        data["deviceSerial"] = this.deviceSerial;
        data["deviceImei"] = this.deviceImei;
        data["deviceManufacturer"] = this.deviceManufacturer;
        data["deviceOS"] = this.deviceOS;
        data["deviceOSVersion"] = this.deviceOSVersion;
        return data;
    }
}

export interface ILogInputSalesTrackingDto {
    userId: string | undefined;
    appName: string | undefined;
    appVersion: string | undefined;
    appArea: string | undefined;
    actionName: string | undefined;
    actionInfo: string | undefined;
    actionTime: moment.Moment | undefined;
    deviceName: string | undefined;
    deviceSerial: string | undefined;
    deviceImei: string | undefined;
    deviceManufacturer: string | undefined;
    deviceOS: string | undefined;
    deviceOSVersion: string | undefined;
}

export class PagedResultDtoOfGetAppBehaviorLogForViewDto implements IPagedResultDtoOfGetAppBehaviorLogForViewDto {
    totalCount!: number | undefined;
    items!: GetAppBehaviorLogForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetAppBehaviorLogForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetAppBehaviorLogForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetAppBehaviorLogForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetAppBehaviorLogForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetAppBehaviorLogForViewDto {
    totalCount: number | undefined;
    items: GetAppBehaviorLogForViewDto[] | undefined;
}

export class GetAppBehaviorLogForViewDto implements IGetAppBehaviorLogForViewDto {
    appBehaviorLog!: AppBehaviorLogDto | undefined;

    constructor(data?: IGetAppBehaviorLogForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.appBehaviorLog = data["appBehaviorLog"] ? AppBehaviorLogDto.fromJS(data["appBehaviorLog"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetAppBehaviorLogForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAppBehaviorLogForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appBehaviorLog"] = this.appBehaviorLog ? this.appBehaviorLog.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetAppBehaviorLogForViewDto {
    appBehaviorLog: AppBehaviorLogDto | undefined;
}

export class AppBehaviorLogDto implements IAppBehaviorLogDto {
    memberCode!: string | undefined;
    deviceImei!: string | undefined;
    deviceSerial!: string | undefined;
    deviceName!: string | undefined;
    deviceManufacturer!: string | undefined;
    deviceOS!: string | undefined;
    deviceOSVersion!: string | undefined;
    appName!: string | undefined;
    appVersion!: string | undefined;
    appArea!: string | undefined;
    actionInfo!: string | undefined;
    actionName!: string | undefined;
    actionStartTime!: moment.Moment | undefined;
    actionEndTime!: moment.Moment | undefined;
    description!: string | undefined;
    id!: number | undefined;

    constructor(data?: IAppBehaviorLogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberCode = data["memberCode"];
            this.deviceImei = data["deviceImei"];
            this.deviceSerial = data["deviceSerial"];
            this.deviceName = data["deviceName"];
            this.deviceManufacturer = data["deviceManufacturer"];
            this.deviceOS = data["deviceOS"];
            this.deviceOSVersion = data["deviceOSVersion"];
            this.appName = data["appName"];
            this.appVersion = data["appVersion"];
            this.appArea = data["appArea"];
            this.actionInfo = data["actionInfo"];
            this.actionName = data["actionName"];
            this.actionStartTime = data["actionStartTime"] ? moment(data["actionStartTime"].toString()) : <any>undefined;
            this.actionEndTime = data["actionEndTime"] ? moment(data["actionEndTime"].toString()) : <any>undefined;
            this.description = data["description"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): AppBehaviorLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppBehaviorLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberCode"] = this.memberCode;
        data["deviceImei"] = this.deviceImei;
        data["deviceSerial"] = this.deviceSerial;
        data["deviceName"] = this.deviceName;
        data["deviceManufacturer"] = this.deviceManufacturer;
        data["deviceOS"] = this.deviceOS;
        data["deviceOSVersion"] = this.deviceOSVersion;
        data["appName"] = this.appName;
        data["appVersion"] = this.appVersion;
        data["appArea"] = this.appArea;
        data["actionInfo"] = this.actionInfo;
        data["actionName"] = this.actionName;
        data["actionStartTime"] = this.actionStartTime ? this.actionStartTime.toISOString() : <any>undefined;
        data["actionEndTime"] = this.actionEndTime ? this.actionEndTime.toISOString() : <any>undefined;
        data["description"] = this.description;
        data["id"] = this.id;
        return data;
    }
}

export interface IAppBehaviorLogDto {
    memberCode: string | undefined;
    deviceImei: string | undefined;
    deviceSerial: string | undefined;
    deviceName: string | undefined;
    deviceManufacturer: string | undefined;
    deviceOS: string | undefined;
    deviceOSVersion: string | undefined;
    appName: string | undefined;
    appVersion: string | undefined;
    appArea: string | undefined;
    actionInfo: string | undefined;
    actionName: string | undefined;
    actionStartTime: moment.Moment | undefined;
    actionEndTime: moment.Moment | undefined;
    description: string | undefined;
    id: number | undefined;
}

export class GetAppBehaviorLogForEditOutput implements IGetAppBehaviorLogForEditOutput {
    appBehaviorLog!: CreateOrEditAppBehaviorLogDto | undefined;

    constructor(data?: IGetAppBehaviorLogForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.appBehaviorLog = data["appBehaviorLog"] ? CreateOrEditAppBehaviorLogDto.fromJS(data["appBehaviorLog"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetAppBehaviorLogForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAppBehaviorLogForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appBehaviorLog"] = this.appBehaviorLog ? this.appBehaviorLog.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetAppBehaviorLogForEditOutput {
    appBehaviorLog: CreateOrEditAppBehaviorLogDto | undefined;
}

export class CreateOrEditAppBehaviorLogDto implements ICreateOrEditAppBehaviorLogDto {
    memberCode!: string | undefined;
    deviceImei!: string | undefined;
    deviceSerial!: string | undefined;
    deviceName!: string | undefined;
    deviceManufacturer!: string | undefined;
    deviceOS!: string | undefined;
    deviceOSVersion!: string | undefined;
    appName!: string | undefined;
    appVersion!: string | undefined;
    appArea!: string | undefined;
    actionInfo!: string | undefined;
    actionName!: string | undefined;
    actionStartTime!: moment.Moment | undefined;
    actionEndTime!: moment.Moment | undefined;
    description!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditAppBehaviorLogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberCode = data["memberCode"];
            this.deviceImei = data["deviceImei"];
            this.deviceSerial = data["deviceSerial"];
            this.deviceName = data["deviceName"];
            this.deviceManufacturer = data["deviceManufacturer"];
            this.deviceOS = data["deviceOS"];
            this.deviceOSVersion = data["deviceOSVersion"];
            this.appName = data["appName"];
            this.appVersion = data["appVersion"];
            this.appArea = data["appArea"];
            this.actionInfo = data["actionInfo"];
            this.actionName = data["actionName"];
            this.actionStartTime = data["actionStartTime"] ? moment(data["actionStartTime"].toString()) : <any>undefined;
            this.actionEndTime = data["actionEndTime"] ? moment(data["actionEndTime"].toString()) : <any>undefined;
            this.description = data["description"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditAppBehaviorLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditAppBehaviorLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberCode"] = this.memberCode;
        data["deviceImei"] = this.deviceImei;
        data["deviceSerial"] = this.deviceSerial;
        data["deviceName"] = this.deviceName;
        data["deviceManufacturer"] = this.deviceManufacturer;
        data["deviceOS"] = this.deviceOS;
        data["deviceOSVersion"] = this.deviceOSVersion;
        data["appName"] = this.appName;
        data["appVersion"] = this.appVersion;
        data["appArea"] = this.appArea;
        data["actionInfo"] = this.actionInfo;
        data["actionName"] = this.actionName;
        data["actionStartTime"] = this.actionStartTime ? this.actionStartTime.toISOString() : <any>undefined;
        data["actionEndTime"] = this.actionEndTime ? this.actionEndTime.toISOString() : <any>undefined;
        data["description"] = this.description;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditAppBehaviorLogDto {
    memberCode: string | undefined;
    deviceImei: string | undefined;
    deviceSerial: string | undefined;
    deviceName: string | undefined;
    deviceManufacturer: string | undefined;
    deviceOS: string | undefined;
    deviceOSVersion: string | undefined;
    appName: string | undefined;
    appVersion: string | undefined;
    appArea: string | undefined;
    actionInfo: string | undefined;
    actionName: string | undefined;
    actionStartTime: moment.Moment | undefined;
    actionEndTime: moment.Moment | undefined;
    description: string | undefined;
    id: number | undefined;
}

export class ConsumerDBFileDto implements IConsumerDBFileDto {
    fileName!: string;
    fileType!: string;
    fileToken!: string;

    constructor(data?: IConsumerDBFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.fileName = data["fileName"];
            this.fileType = data["fileType"];
            this.fileToken = data["fileToken"];
        }
    }

    static fromJS(data: any): ConsumerDBFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConsumerDBFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["fileType"] = this.fileType;
        data["fileToken"] = this.fileToken;
        return data;
    }
}

export interface IConsumerDBFileDto {
    fileName: string;
    fileType: string;
    fileToken: string;
}

export class LogInputDto implements ILogInputDto {
    memberCode!: string | undefined;
    appName!: string | undefined;
    appVersion!: string | undefined;
    appArea!: string | undefined;
    actionName!: string | undefined;
    actionInfo!: string | undefined;
    actionStartTime!: moment.Moment | undefined;
    actionEndTime!: moment.Moment | undefined;
    deviceName!: string | undefined;
    deviceSerial!: string | undefined;
    deviceImei!: string | undefined;
    deviceManufacturer!: string | undefined;
    deviceOS!: string | undefined;
    deviceOSVersion!: string | undefined;

    constructor(data?: ILogInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberCode = data["memberCode"];
            this.appName = data["appName"];
            this.appVersion = data["appVersion"];
            this.appArea = data["appArea"];
            this.actionName = data["actionName"];
            this.actionInfo = data["actionInfo"];
            this.actionStartTime = data["actionStartTime"] ? moment(data["actionStartTime"].toString()) : <any>undefined;
            this.actionEndTime = data["actionEndTime"] ? moment(data["actionEndTime"].toString()) : <any>undefined;
            this.deviceName = data["deviceName"];
            this.deviceSerial = data["deviceSerial"];
            this.deviceImei = data["deviceImei"];
            this.deviceManufacturer = data["deviceManufacturer"];
            this.deviceOS = data["deviceOS"];
            this.deviceOSVersion = data["deviceOSVersion"];
        }
    }

    static fromJS(data: any): LogInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new LogInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberCode"] = this.memberCode;
        data["appName"] = this.appName;
        data["appVersion"] = this.appVersion;
        data["appArea"] = this.appArea;
        data["actionName"] = this.actionName;
        data["actionInfo"] = this.actionInfo;
        data["actionStartTime"] = this.actionStartTime ? this.actionStartTime.toISOString() : <any>undefined;
        data["actionEndTime"] = this.actionEndTime ? this.actionEndTime.toISOString() : <any>undefined;
        data["deviceName"] = this.deviceName;
        data["deviceSerial"] = this.deviceSerial;
        data["deviceImei"] = this.deviceImei;
        data["deviceManufacturer"] = this.deviceManufacturer;
        data["deviceOS"] = this.deviceOS;
        data["deviceOSVersion"] = this.deviceOSVersion;
        return data;
    }
}

export interface ILogInputDto {
    memberCode: string | undefined;
    appName: string | undefined;
    appVersion: string | undefined;
    appArea: string | undefined;
    actionName: string | undefined;
    actionInfo: string | undefined;
    actionStartTime: moment.Moment | undefined;
    actionEndTime: moment.Moment | undefined;
    deviceName: string | undefined;
    deviceSerial: string | undefined;
    deviceImei: string | undefined;
    deviceManufacturer: string | undefined;
    deviceOS: string | undefined;
    deviceOSVersion: string | undefined;
}

export class PagedResultDtoOfGetAppPushTransactionForViewDto implements IPagedResultDtoOfGetAppPushTransactionForViewDto {
    totalCount!: number | undefined;
    items!: GetAppPushTransactionForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetAppPushTransactionForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetAppPushTransactionForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetAppPushTransactionForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetAppPushTransactionForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetAppPushTransactionForViewDto {
    totalCount: number | undefined;
    items: GetAppPushTransactionForViewDto[] | undefined;
}

export class GetAppPushTransactionForViewDto implements IGetAppPushTransactionForViewDto {
    appPushTransaction!: AppPushTransactionDto | undefined;

    constructor(data?: IGetAppPushTransactionForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.appPushTransaction = data["appPushTransaction"] ? AppPushTransactionDto.fromJS(data["appPushTransaction"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetAppPushTransactionForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAppPushTransactionForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appPushTransaction"] = this.appPushTransaction ? this.appPushTransaction.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetAppPushTransactionForViewDto {
    appPushTransaction: AppPushTransactionDto | undefined;
}

export class AppPushTransactionDto implements IAppPushTransactionDto {
    sender!: string | undefined;
    receiver!: string | undefined;
    referenceCode!: string | undefined;
    content!: string | undefined;
    title!: string | undefined;
    status!: string | undefined;
    id!: number | undefined;

    constructor(data?: IAppPushTransactionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.sender = data["sender"];
            this.receiver = data["receiver"];
            this.referenceCode = data["referenceCode"];
            this.content = data["content"];
            this.title = data["title"];
            this.status = data["status"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): AppPushTransactionDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppPushTransactionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sender"] = this.sender;
        data["receiver"] = this.receiver;
        data["referenceCode"] = this.referenceCode;
        data["content"] = this.content;
        data["title"] = this.title;
        data["status"] = this.status;
        data["id"] = this.id;
        return data;
    }
}

export interface IAppPushTransactionDto {
    sender: string | undefined;
    receiver: string | undefined;
    referenceCode: string | undefined;
    content: string | undefined;
    title: string | undefined;
    status: string | undefined;
    id: number | undefined;
}

export class GetAppPushTransactionForEditOutput implements IGetAppPushTransactionForEditOutput {
    appPushTransaction!: CreateOrEditAppPushTransactionDto | undefined;

    constructor(data?: IGetAppPushTransactionForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.appPushTransaction = data["appPushTransaction"] ? CreateOrEditAppPushTransactionDto.fromJS(data["appPushTransaction"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetAppPushTransactionForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAppPushTransactionForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appPushTransaction"] = this.appPushTransaction ? this.appPushTransaction.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetAppPushTransactionForEditOutput {
    appPushTransaction: CreateOrEditAppPushTransactionDto | undefined;
}

export class CreateOrEditAppPushTransactionDto implements ICreateOrEditAppPushTransactionDto {
    sender!: string | undefined;
    receiver!: string | undefined;
    referenceCode!: string | undefined;
    content!: string | undefined;
    title!: string | undefined;
    status!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditAppPushTransactionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.sender = data["sender"];
            this.receiver = data["receiver"];
            this.referenceCode = data["referenceCode"];
            this.content = data["content"];
            this.title = data["title"];
            this.status = data["status"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditAppPushTransactionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditAppPushTransactionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sender"] = this.sender;
        data["receiver"] = this.receiver;
        data["referenceCode"] = this.referenceCode;
        data["content"] = this.content;
        data["title"] = this.title;
        data["status"] = this.status;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditAppPushTransactionDto {
    sender: string | undefined;
    receiver: string | undefined;
    referenceCode: string | undefined;
    content: string | undefined;
    title: string | undefined;
    status: string | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfGetListNotificationForViewDto implements IPagedResultDtoOfGetListNotificationForViewDto {
    totalCount!: number | undefined;
    items!: GetListNotificationForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetListNotificationForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetListNotificationForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetListNotificationForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetListNotificationForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetListNotificationForViewDto {
    totalCount: number | undefined;
    items: GetListNotificationForViewDto[] | undefined;
}

export class GetListNotificationForViewDto implements IGetListNotificationForViewDto {
    appPushTransaction!: GetListNotificationDto | undefined;

    constructor(data?: IGetListNotificationForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.appPushTransaction = data["appPushTransaction"] ? GetListNotificationDto.fromJS(data["appPushTransaction"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetListNotificationForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetListNotificationForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appPushTransaction"] = this.appPushTransaction ? this.appPushTransaction.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetListNotificationForViewDto {
    appPushTransaction: GetListNotificationDto | undefined;
}

export class GetListNotificationDto implements IGetListNotificationDto {
    title!: string | undefined;
    content!: string | undefined;
    status!: string | undefined;
    creationTime!: moment.Moment | undefined;
    data!: { [key: string]: string; } | undefined;
    id!: number | undefined;

    constructor(data?: IGetListNotificationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.title = data["title"];
            this.content = data["content"];
            this.status = data["status"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            if (data["data"]) {
                this.data = {};
                for (let key in data["data"]) {
                    if (data["data"].hasOwnProperty(key))
                        this.data[key] = data["data"][key];
                }
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): GetListNotificationDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetListNotificationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["content"] = this.content;
        data["status"] = this.status;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        if (this.data) {
            data["data"] = {};
            for (let key in this.data) {
                if (this.data.hasOwnProperty(key))
                    data["data"][key] = this.data[key];
            }
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IGetListNotificationDto {
    title: string | undefined;
    content: string | undefined;
    status: string | undefined;
    creationTime: moment.Moment | undefined;
    data: { [key: string]: string; } | undefined;
    id: number | undefined;
}

export class UpdateReadStatus implements IUpdateReadStatus {
    id!: number | undefined;
    status!: string | undefined;

    constructor(data?: IUpdateReadStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.status = data["status"];
        }
    }

    static fromJS(data: any): UpdateReadStatus {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateReadStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        return data;
    }
}

export interface IUpdateReadStatus {
    id: number | undefined;
    status: string | undefined;
}

export class UserNotificationUnseenCountDto implements IUserNotificationUnseenCountDto {
    totalCount!: number | undefined;

    constructor(data?: IUserNotificationUnseenCountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
        }
    }

    static fromJS(data: any): UserNotificationUnseenCountDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserNotificationUnseenCountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IUserNotificationUnseenCountDto {
    totalCount: number | undefined;
}

export class MarkAsSeenUserNotificationInput implements IMarkAsSeenUserNotificationInput {
    notificationIds!: number[] | undefined;
    isUpdateToAll!: boolean | undefined;
    memberCode!: string | undefined;

    constructor(data?: IMarkAsSeenUserNotificationInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["notificationIds"] && data["notificationIds"].constructor === Array) {
                this.notificationIds = [];
                for (let item of data["notificationIds"])
                    this.notificationIds.push(item);
            }
            this.isUpdateToAll = data["isUpdateToAll"];
            this.memberCode = data["memberCode"];
        }
    }

    static fromJS(data: any): MarkAsSeenUserNotificationInput {
        data = typeof data === 'object' ? data : {};
        let result = new MarkAsSeenUserNotificationInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.notificationIds && this.notificationIds.constructor === Array) {
            data["notificationIds"] = [];
            for (let item of this.notificationIds)
                data["notificationIds"].push(item);
        }
        data["isUpdateToAll"] = this.isUpdateToAll;
        data["memberCode"] = this.memberCode;
        return data;
    }
}

export interface IMarkAsSeenUserNotificationInput {
    notificationIds: number[] | undefined;
    isUpdateToAll: boolean | undefined;
    memberCode: string | undefined;
}

export class PagedResultDtoOfUserNotificationDto implements IPagedResultDtoOfUserNotificationDto {
    totalCount!: number | undefined;
    items!: UserNotificationDto[] | undefined;

    constructor(data?: IPagedResultDtoOfUserNotificationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(UserNotificationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfUserNotificationDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfUserNotificationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfUserNotificationDto {
    totalCount: number | undefined;
    items: UserNotificationDto[] | undefined;
}

export class UserNotificationDto implements IUserNotificationDto {
    title!: string | undefined;
    textContent!: string | undefined;
    receiver!: string | undefined;
    status!: string | undefined;
    extraData!: string | undefined;
    id!: number | undefined;
    creationTime!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;

    constructor(data?: IUserNotificationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.title = data["title"];
            this.textContent = data["textContent"];
            this.receiver = data["receiver"];
            this.status = data["status"];
            this.extraData = data["extraData"];
            this.id = data["id"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UserNotificationDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserNotificationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["textContent"] = this.textContent;
        data["receiver"] = this.receiver;
        data["status"] = this.status;
        data["extraData"] = this.extraData;
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IUserNotificationDto {
    title: string | undefined;
    textContent: string | undefined;
    receiver: string | undefined;
    status: string | undefined;
    extraData: string | undefined;
    id: number | undefined;
    creationTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
}

export class PagedResultDtoOfGetArticleForView implements IPagedResultDtoOfGetArticleForView {
    totalCount!: number | undefined;
    items!: GetArticleForView[] | undefined;

    constructor(data?: IPagedResultDtoOfGetArticleForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetArticleForView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetArticleForView {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetArticleForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetArticleForView {
    totalCount: number | undefined;
    items: GetArticleForView[] | undefined;
}

export class GetArticleForView implements IGetArticleForView {
    article!: ArticleDto | undefined;
    lastModificationTimeDetail!: moment.Moment | undefined;

    constructor(data?: IGetArticleForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.article = data["article"] ? ArticleDto.fromJS(data["article"]) : <any>undefined;
            this.lastModificationTimeDetail = data["lastModificationTimeDetail"] ? moment(data["lastModificationTimeDetail"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetArticleForView {
        data = typeof data === 'object' ? data : {};
        let result = new GetArticleForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["article"] = this.article ? this.article.toJSON() : <any>undefined;
        data["lastModificationTimeDetail"] = this.lastModificationTimeDetail ? this.lastModificationTimeDetail.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGetArticleForView {
    article: ArticleDto | undefined;
    lastModificationTimeDetail: moment.Moment | undefined;
}

export class ArticleDto implements IArticleDto {
    tenantId!: number | undefined;
    code!: string | undefined;
    avatar!: string | undefined;
    linkAvatar!: string | undefined;
    status!: string | undefined;
    category!: string[] | undefined;
    fromDate!: moment.Moment | undefined;
    toDate!: moment.Moment | undefined;
    tags!: string | undefined;
    lastUpdateByName!: string | undefined;
    targetAudienceID!: number | undefined;
    targetAudienceType!: string | undefined;
    isPined!: boolean | undefined;
    translations!: ArticleTranslationDto[] | undefined;
    articleUserStatus!: string | undefined;
    articleTargetAudience!: ArticleTargetAudienceDto | undefined;
    targetAudienceName!: string | undefined;
    typeCategoryFilter!: string | undefined;
    isDeleted!: boolean | undefined;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: moment.Moment | undefined;
    creatorUserId!: number | undefined;
    id!: number | undefined;
    brand!: string | undefined;

    constructor(data?: IArticleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.code = data["code"];
            this.avatar = data["avatar"];
            this.linkAvatar = data["linkAvatar"];
            this.status = data["status"];
            if (data["category"] && data["category"].constructor === Array) {
                this.category = [];
                for (let item of data["category"])
                    this.category.push(item);
            }
            this.fromDate = data["fromDate"] ? moment(data["fromDate"].toString()) : <any>undefined;
            this.toDate = data["toDate"] ? moment(data["toDate"].toString()) : <any>undefined;
            this.tags = data["tags"];
            this.lastUpdateByName = data["lastUpdateByName"];
            this.targetAudienceID = data["targetAudienceID"];
            this.targetAudienceType = data["targetAudienceType"];
            this.isPined = data["isPined"];
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(ArticleTranslationDto.fromJS(item));
            }
            this.articleUserStatus = data["articleUserStatus"];
            this.articleTargetAudience = data["articleTargetAudience"] ? ArticleTargetAudienceDto.fromJS(data["articleTargetAudience"]) : <any>undefined;
            this.targetAudienceName = data["targetAudienceName"];
            this.typeCategoryFilter = data["typeCategoryFilter"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
            this.brand = data["brand"];
        }
    }

    static fromJS(data: any): ArticleDto {
        data = typeof data === 'object' ? data : {};
        let result = new ArticleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["code"] = this.code;
        data["avatar"] = this.avatar;
        data["linkAvatar"] = this.linkAvatar;
        data["status"] = this.status;
        if (this.category && this.category.constructor === Array) {
            data["category"] = [];
            for (let item of this.category)
                data["category"].push(item);
        }
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data["tags"] = this.tags;
        data["lastUpdateByName"] = this.lastUpdateByName;
        data["targetAudienceID"] = this.targetAudienceID;
        data["targetAudienceType"] = this.targetAudienceType;
        data["isPined"] = this.isPined;
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        data["articleUserStatus"] = this.articleUserStatus;
        data["articleTargetAudience"] = this.articleTargetAudience ? this.articleTargetAudience.toJSON() : <any>undefined;
        data["targetAudienceName"] = this.targetAudienceName;
        data["typeCategoryFilter"] = this.typeCategoryFilter;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        data["brand"] = this.brand;
        return data;
    }
}

export interface IArticleDto {
    tenantId: number | undefined;
    code: string | undefined;
    avatar: string | undefined;
    linkAvatar: string | undefined;
    status: string | undefined;
    category: string[] | undefined;
    fromDate: moment.Moment | undefined;
    toDate: moment.Moment | undefined;
    tags: string | undefined;
    lastUpdateByName: string | undefined;
    targetAudienceID: number | undefined;
    targetAudienceType: string | undefined;
    isPined: boolean | undefined;
    translations: ArticleTranslationDto[] | undefined;
    articleUserStatus: string | undefined;
    articleTargetAudience: ArticleTargetAudienceDto | undefined;
    targetAudienceName: string | undefined;
    typeCategoryFilter: string | undefined;
    isDeleted: boolean | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;
    brand: string | undefined;
}

export class ArticleTranslationDto implements IArticleTranslationDto {
    tenantId!: number | undefined;
    name!: string | undefined;
    description!: string | undefined;
    content!: string | undefined;
    language!: string | undefined;
    nameUnSign!: string | undefined;
    id!: number | undefined;

    constructor(data?: IArticleTranslationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.name = data["name"];
            this.description = data["description"];
            this.content = data["content"];
            this.language = data["language"];
            this.nameUnSign = data["nameUnSign"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ArticleTranslationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ArticleTranslationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["content"] = this.content;
        data["language"] = this.language;
        data["nameUnSign"] = this.nameUnSign;
        data["id"] = this.id;
        return data;
    }
}

export interface IArticleTranslationDto {
    tenantId: number | undefined;
    name: string | undefined;
    description: string | undefined;
    content: string | undefined;
    language: string | undefined;
    nameUnSign: string | undefined;
    id: number | undefined;
}

export class ArticleTargetAudienceDto implements IArticleTargetAudienceDto {
    targetAudienceName!: string | undefined;
    description!: string | undefined;
    status!: string | undefined;
    articleTargetAudienceDetailDtos!: ArticleTargetAudienceDetailDto[] | undefined;
    id!: number | undefined;

    constructor(data?: IArticleTargetAudienceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.targetAudienceName = data["targetAudienceName"];
            this.description = data["description"];
            this.status = data["status"];
            if (data["articleTargetAudienceDetailDtos"] && data["articleTargetAudienceDetailDtos"].constructor === Array) {
                this.articleTargetAudienceDetailDtos = [];
                for (let item of data["articleTargetAudienceDetailDtos"])
                    this.articleTargetAudienceDetailDtos.push(ArticleTargetAudienceDetailDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ArticleTargetAudienceDto {
        data = typeof data === 'object' ? data : {};
        let result = new ArticleTargetAudienceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["targetAudienceName"] = this.targetAudienceName;
        data["description"] = this.description;
        data["status"] = this.status;
        if (this.articleTargetAudienceDetailDtos && this.articleTargetAudienceDetailDtos.constructor === Array) {
            data["articleTargetAudienceDetailDtos"] = [];
            for (let item of this.articleTargetAudienceDetailDtos)
                data["articleTargetAudienceDetailDtos"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IArticleTargetAudienceDto {
    targetAudienceName: string | undefined;
    description: string | undefined;
    status: string | undefined;
    articleTargetAudienceDetailDtos: ArticleTargetAudienceDetailDto[] | undefined;
    id: number | undefined;
}

export class ArticleTargetAudienceDetailDto implements IArticleTargetAudienceDetailDto {
    articleTargetAudienceID!: number | undefined;
    name!: string | undefined;
    phone!: string | undefined;
    zaloChatID!: string | undefined;
    email!: string | undefined;
    facebookID!: string | undefined;
    memberCode!: string | undefined;
    communicationLanguage!: string | undefined;
    communicationChannel!: string | undefined;
    outletCode!: string | undefined;
    id!: number | undefined;

    constructor(data?: IArticleTargetAudienceDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.articleTargetAudienceID = data["articleTargetAudienceID"];
            this.name = data["name"];
            this.phone = data["phone"];
            this.zaloChatID = data["zaloChatID"];
            this.email = data["email"];
            this.facebookID = data["facebookID"];
            this.memberCode = data["memberCode"];
            this.communicationLanguage = data["communicationLanguage"];
            this.communicationChannel = data["communicationChannel"];
            this.outletCode = data["outletCode"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ArticleTargetAudienceDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new ArticleTargetAudienceDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articleTargetAudienceID"] = this.articleTargetAudienceID;
        data["name"] = this.name;
        data["phone"] = this.phone;
        data["zaloChatID"] = this.zaloChatID;
        data["email"] = this.email;
        data["facebookID"] = this.facebookID;
        data["memberCode"] = this.memberCode;
        data["communicationLanguage"] = this.communicationLanguage;
        data["communicationChannel"] = this.communicationChannel;
        data["outletCode"] = this.outletCode;
        data["id"] = this.id;
        return data;
    }
}

export interface IArticleTargetAudienceDetailDto {
    articleTargetAudienceID: number | undefined;
    name: string | undefined;
    phone: string | undefined;
    zaloChatID: string | undefined;
    email: string | undefined;
    facebookID: string | undefined;
    memberCode: string | undefined;
    communicationLanguage: string | undefined;
    communicationChannel: string | undefined;
    outletCode: string | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfGetListArticleForView implements IPagedResultDtoOfGetListArticleForView {
    totalCount!: number | undefined;
    items!: GetListArticleForView[] | undefined;

    constructor(data?: IPagedResultDtoOfGetListArticleForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetListArticleForView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetListArticleForView {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetListArticleForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetListArticleForView {
    totalCount: number | undefined;
    items: GetListArticleForView[] | undefined;
}

export class GetListArticleForView implements IGetListArticleForView {
    article!: GetListArticleForViewDto | undefined;
    lastModificationTimeDetail!: moment.Moment | undefined;

    constructor(data?: IGetListArticleForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.article = data["article"] ? GetListArticleForViewDto.fromJS(data["article"]) : <any>undefined;
            this.lastModificationTimeDetail = data["lastModificationTimeDetail"] ? moment(data["lastModificationTimeDetail"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetListArticleForView {
        data = typeof data === 'object' ? data : {};
        let result = new GetListArticleForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["article"] = this.article ? this.article.toJSON() : <any>undefined;
        data["lastModificationTimeDetail"] = this.lastModificationTimeDetail ? this.lastModificationTimeDetail.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGetListArticleForView {
    article: GetListArticleForViewDto | undefined;
    lastModificationTimeDetail: moment.Moment | undefined;
}

export class GetListArticleForViewDto implements IGetListArticleForViewDto {
    id!: number | undefined;
    tenantId!: number | undefined;
    code!: string | undefined;
    avatar!: string | undefined;
    linkAvatar!: string | undefined;
    status!: string | undefined;
    fromDate!: moment.Moment | undefined;
    toDate!: moment.Moment | undefined;
    tags!: string | undefined;
    translations!: ArticleTranslationDto[] | undefined;
    typeCategoryFilter!: string | undefined;
    isPined!: boolean | undefined;

    constructor(data?: IGetListArticleForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.tenantId = data["tenantId"];
            this.code = data["code"];
            this.avatar = data["avatar"];
            this.linkAvatar = data["linkAvatar"];
            this.status = data["status"];
            this.fromDate = data["fromDate"] ? moment(data["fromDate"].toString()) : <any>undefined;
            this.toDate = data["toDate"] ? moment(data["toDate"].toString()) : <any>undefined;
            this.tags = data["tags"];
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(ArticleTranslationDto.fromJS(item));
            }
            this.typeCategoryFilter = data["typeCategoryFilter"];
            this.isPined = data["isPined"];
        }
    }

    static fromJS(data: any): GetListArticleForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetListArticleForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["code"] = this.code;
        data["avatar"] = this.avatar;
        data["linkAvatar"] = this.linkAvatar;
        data["status"] = this.status;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data["tags"] = this.tags;
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        data["typeCategoryFilter"] = this.typeCategoryFilter;
        data["isPined"] = this.isPined;
        return data;
    }
}

export interface IGetListArticleForViewDto {
    id: number | undefined;
    tenantId: number | undefined;
    code: string | undefined;
    avatar: string | undefined;
    linkAvatar: string | undefined;
    status: string | undefined;
    fromDate: moment.Moment | undefined;
    toDate: moment.Moment | undefined;
    tags: string | undefined;
    translations: ArticleTranslationDto[] | undefined;
    typeCategoryFilter: string | undefined;
    isPined: boolean | undefined;
}

export class GetArticleForEditOutput implements IGetArticleForEditOutput {
    article!: CreateOrEditArticleDto | undefined;
    createdByUser!: string | undefined;
    avatarLink!: string | undefined;
    avatarLinkId!: number | undefined;

    constructor(data?: IGetArticleForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.article = data["article"] ? CreateOrEditArticleDto.fromJS(data["article"]) : <any>undefined;
            this.createdByUser = data["createdByUser"];
            this.avatarLink = data["avatarLink"];
            this.avatarLinkId = data["avatarLinkId"];
        }
    }

    static fromJS(data: any): GetArticleForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetArticleForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["article"] = this.article ? this.article.toJSON() : <any>undefined;
        data["createdByUser"] = this.createdByUser;
        data["avatarLink"] = this.avatarLink;
        data["avatarLinkId"] = this.avatarLinkId;
        return data;
    }
}

export interface IGetArticleForEditOutput {
    article: CreateOrEditArticleDto | undefined;
    createdByUser: string | undefined;
    avatarLink: string | undefined;
    avatarLinkId: number | undefined;
}

export class CreateOrEditArticleDto implements ICreateOrEditArticleDto {
    code!: string | undefined;
    name!: string | undefined;
    nameVN!: string | undefined;
    description!: string | undefined;
    descriptionVN!: string | undefined;
    content!: string | undefined;
    contentVN!: string | undefined;
    avatar!: string | undefined;
    linkAvatar!: string | undefined;
    status!: string | undefined;
    fromDate!: moment.Moment | undefined;
    toDate!: moment.Moment | undefined;
    tags!: string | undefined;
    updatedByUser!: string | undefined;
    tenantId!: number | undefined;
    targetAudienceID!: number | undefined;
    targetAudienceType!: string | undefined;
    translations!: ArticleTranslationDto[] | undefined;
    targetAudience!: CreateOrEditTargetaudienceDto | undefined;
    isDeleted!: boolean | undefined;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: moment.Moment | undefined;
    creatorUserId!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditArticleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.name = data["name"];
            this.nameVN = data["nameVN"];
            this.description = data["description"];
            this.descriptionVN = data["descriptionVN"];
            this.content = data["content"];
            this.contentVN = data["contentVN"];
            this.avatar = data["avatar"];
            this.linkAvatar = data["linkAvatar"];
            this.status = data["status"];
            this.fromDate = data["fromDate"] ? moment(data["fromDate"].toString()) : <any>undefined;
            this.toDate = data["toDate"] ? moment(data["toDate"].toString()) : <any>undefined;
            this.tags = data["tags"];
            this.updatedByUser = data["updatedByUser"];
            this.tenantId = data["tenantId"];
            this.targetAudienceID = data["targetAudienceID"];
            this.targetAudienceType = data["targetAudienceType"];
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(ArticleTranslationDto.fromJS(item));
            }
            this.targetAudience = data["targetAudience"] ? CreateOrEditTargetaudienceDto.fromJS(data["targetAudience"]) : <any>undefined;
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditArticleDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditArticleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["nameVN"] = this.nameVN;
        data["description"] = this.description;
        data["descriptionVN"] = this.descriptionVN;
        data["content"] = this.content;
        data["contentVN"] = this.contentVN;
        data["avatar"] = this.avatar;
        data["linkAvatar"] = this.linkAvatar;
        data["status"] = this.status;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data["tags"] = this.tags;
        data["updatedByUser"] = this.updatedByUser;
        data["tenantId"] = this.tenantId;
        data["targetAudienceID"] = this.targetAudienceID;
        data["targetAudienceType"] = this.targetAudienceType;
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        data["targetAudience"] = this.targetAudience ? this.targetAudience.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditArticleDto {
    code: string | undefined;
    name: string | undefined;
    nameVN: string | undefined;
    description: string | undefined;
    descriptionVN: string | undefined;
    content: string | undefined;
    contentVN: string | undefined;
    avatar: string | undefined;
    linkAvatar: string | undefined;
    status: string | undefined;
    fromDate: moment.Moment | undefined;
    toDate: moment.Moment | undefined;
    tags: string | undefined;
    updatedByUser: string | undefined;
    tenantId: number | undefined;
    targetAudienceID: number | undefined;
    targetAudienceType: string | undefined;
    translations: ArticleTranslationDto[] | undefined;
    targetAudience: CreateOrEditTargetaudienceDto | undefined;
    isDeleted: boolean | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class CreateOrEditTargetaudienceDto implements ICreateOrEditTargetaudienceDto {
    code!: string | undefined;
    name!: string | undefined;
    isActive!: boolean | undefined;
    type!: string | undefined;
    description!: string | undefined;
    count!: number | undefined;
    isFilterProfile!: boolean | undefined;
    source!: string | undefined;
    targetAudienceDetailDtos!: CreateOrEditTargetaudiencedetailDto[] | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditTargetaudienceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.name = data["name"];
            this.isActive = data["isActive"];
            this.type = data["type"];
            this.description = data["description"];
            this.count = data["count"];
            this.isFilterProfile = data["isFilterProfile"];
            this.source = data["source"];
            if (data["targetAudienceDetailDtos"] && data["targetAudienceDetailDtos"].constructor === Array) {
                this.targetAudienceDetailDtos = [];
                for (let item of data["targetAudienceDetailDtos"])
                    this.targetAudienceDetailDtos.push(CreateOrEditTargetaudiencedetailDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditTargetaudienceDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditTargetaudienceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        data["type"] = this.type;
        data["description"] = this.description;
        data["count"] = this.count;
        data["isFilterProfile"] = this.isFilterProfile;
        data["source"] = this.source;
        if (this.targetAudienceDetailDtos && this.targetAudienceDetailDtos.constructor === Array) {
            data["targetAudienceDetailDtos"] = [];
            for (let item of this.targetAudienceDetailDtos)
                data["targetAudienceDetailDtos"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditTargetaudienceDto {
    code: string | undefined;
    name: string | undefined;
    isActive: boolean | undefined;
    type: string | undefined;
    description: string | undefined;
    count: number | undefined;
    isFilterProfile: boolean | undefined;
    source: string | undefined;
    targetAudienceDetailDtos: CreateOrEditTargetaudiencedetailDto[] | undefined;
    id: number | undefined;
}

export class CreateOrEditTargetaudiencedetailDto implements ICreateOrEditTargetaudiencedetailDto {
    code!: string | undefined;
    targetAudienceId!: number | undefined;
    type!: string | undefined;
    value!: string | undefined;
    level!: string | undefined;
    fullValue!: string | undefined;
    isActive!: boolean | undefined;
    source!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditTargetaudiencedetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.targetAudienceId = data["targetAudienceId"];
            this.type = data["type"];
            this.value = data["value"];
            this.level = data["level"];
            this.fullValue = data["fullValue"];
            this.isActive = data["isActive"];
            this.source = data["source"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditTargetaudiencedetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditTargetaudiencedetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["targetAudienceId"] = this.targetAudienceId;
        data["type"] = this.type;
        data["value"] = this.value;
        data["level"] = this.level;
        data["fullValue"] = this.fullValue;
        data["isActive"] = this.isActive;
        data["source"] = this.source;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditTargetaudiencedetailDto {
    code: string | undefined;
    targetAudienceId: number | undefined;
    type: string | undefined;
    value: string | undefined;
    level: string | undefined;
    fullValue: string | undefined;
    isActive: boolean | undefined;
    source: string | undefined;
    id: number | undefined;
}

export class CloneArticleDto implements ICloneArticleDto {
    ids!: number[] | undefined;

    constructor(data?: ICloneArticleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["ids"] && data["ids"].constructor === Array) {
                this.ids = [];
                for (let item of data["ids"])
                    this.ids.push(item);
            }
        }
    }

    static fromJS(data: any): CloneArticleDto {
        data = typeof data === 'object' ? data : {};
        let result = new CloneArticleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.ids && this.ids.constructor === Array) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        return data;
    }
}

export interface ICloneArticleDto {
    ids: number[] | undefined;
}

export class GetAllArticleInput implements IGetAllArticleInput {
    filter!: string | undefined;
    statusFilter!: string | undefined;
    fromDate!: moment.Moment | undefined;
    toDate!: moment.Moment | undefined;
    tagsFilter!: string | undefined;
    sorting!: string | undefined;
    skipCount!: number | undefined;
    maxResultCount!: number | undefined;

    constructor(data?: IGetAllArticleInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.filter = data["filter"];
            this.statusFilter = data["statusFilter"];
            this.fromDate = data["fromDate"] ? moment(data["fromDate"].toString()) : <any>undefined;
            this.toDate = data["toDate"] ? moment(data["toDate"].toString()) : <any>undefined;
            this.tagsFilter = data["tagsFilter"];
            this.sorting = data["sorting"];
            this.skipCount = data["skipCount"];
            this.maxResultCount = data["maxResultCount"];
        }
    }

    static fromJS(data: any): GetAllArticleInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllArticleInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        data["statusFilter"] = this.statusFilter;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data["tagsFilter"] = this.tagsFilter;
        data["sorting"] = this.sorting;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data;
    }
}

export interface IGetAllArticleInput {
    filter: string | undefined;
    statusFilter: string | undefined;
    fromDate: moment.Moment | undefined;
    toDate: moment.Moment | undefined;
    tagsFilter: string | undefined;
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;
}

export class ArticleForViewDto implements IArticleForViewDto {
    code!: string | undefined;
    avatar!: string | undefined;
    linkAvatar!: string | undefined;
    status!: string | undefined;
    fromDate!: moment.Moment | undefined;
    toDate!: moment.Moment | undefined;
    tags!: string | undefined;
    translations!: ArticleTranslationDto[] | undefined;
    tenantId!: number | undefined;
    relatedArticles!: RelatedArticleDto[] | undefined;
    isDeleted!: boolean | undefined;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: moment.Moment | undefined;
    creatorUserId!: number | undefined;
    id!: number | undefined;

    constructor(data?: IArticleForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.avatar = data["avatar"];
            this.linkAvatar = data["linkAvatar"];
            this.status = data["status"];
            this.fromDate = data["fromDate"] ? moment(data["fromDate"].toString()) : <any>undefined;
            this.toDate = data["toDate"] ? moment(data["toDate"].toString()) : <any>undefined;
            this.tags = data["tags"];
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(ArticleTranslationDto.fromJS(item));
            }
            this.tenantId = data["tenantId"];
            if (data["relatedArticles"] && data["relatedArticles"].constructor === Array) {
                this.relatedArticles = [];
                for (let item of data["relatedArticles"])
                    this.relatedArticles.push(RelatedArticleDto.fromJS(item));
            }
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ArticleForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new ArticleForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["avatar"] = this.avatar;
        data["linkAvatar"] = this.linkAvatar;
        data["status"] = this.status;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data["tags"] = this.tags;
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        data["tenantId"] = this.tenantId;
        if (this.relatedArticles && this.relatedArticles.constructor === Array) {
            data["relatedArticles"] = [];
            for (let item of this.relatedArticles)
                data["relatedArticles"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IArticleForViewDto {
    code: string | undefined;
    avatar: string | undefined;
    linkAvatar: string | undefined;
    status: string | undefined;
    fromDate: moment.Moment | undefined;
    toDate: moment.Moment | undefined;
    tags: string | undefined;
    translations: ArticleTranslationDto[] | undefined;
    tenantId: number | undefined;
    relatedArticles: RelatedArticleDto[] | undefined;
    isDeleted: boolean | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class RelatedArticleDto implements IRelatedArticleDto {
    code!: string | undefined;
    avatar!: string | undefined;
    linkAvatar!: string | undefined;
    status!: string | undefined;
    fromDate!: moment.Moment | undefined;
    toDate!: moment.Moment | undefined;
    tags!: string | undefined;
    translations!: ArticleTranslationDto[] | undefined;
    id!: number | undefined;
    typeCategoryFilter!: string | undefined;

    constructor(data?: IRelatedArticleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.avatar = data["avatar"];
            this.linkAvatar = data["linkAvatar"];
            this.status = data["status"];
            this.fromDate = data["fromDate"] ? moment(data["fromDate"].toString()) : <any>undefined;
            this.toDate = data["toDate"] ? moment(data["toDate"].toString()) : <any>undefined;
            this.tags = data["tags"];
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(ArticleTranslationDto.fromJS(item));
            }
            this.id = data["id"];
            this.typeCategoryFilter = data["typeCategoryFilter"];
        }
    }

    static fromJS(data: any): RelatedArticleDto {
        data = typeof data === 'object' ? data : {};
        let result = new RelatedArticleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["avatar"] = this.avatar;
        data["linkAvatar"] = this.linkAvatar;
        data["status"] = this.status;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data["tags"] = this.tags;
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["typeCategoryFilter"] = this.typeCategoryFilter;
        return data;
    }
}

export interface IRelatedArticleDto {
    code: string | undefined;
    avatar: string | undefined;
    linkAvatar: string | undefined;
    status: string | undefined;
    fromDate: moment.Moment | undefined;
    toDate: moment.Moment | undefined;
    tags: string | undefined;
    translations: ArticleTranslationDto[] | undefined;
    id: number | undefined;
    typeCategoryFilter: string | undefined;
}

export class GetTargetAudienceForViewArticleDto implements IGetTargetAudienceForViewArticleDto {
    id!: number | undefined;
    targetAudienceName!: string | undefined;

    constructor(data?: IGetTargetAudienceForViewArticleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.targetAudienceName = data["targetAudienceName"];
        }
    }

    static fromJS(data: any): GetTargetAudienceForViewArticleDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetTargetAudienceForViewArticleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["targetAudienceName"] = this.targetAudienceName;
        return data;
    }
}

export interface IGetTargetAudienceForViewArticleDto {
    id: number | undefined;
    targetAudienceName: string | undefined;
}

export class ArticleInfoAgrs implements IArticleInfoAgrs {
    articleID!: number | undefined;
    code!: string | undefined;
    name!: string | undefined;
    nameVN!: string | undefined;
    description!: string | undefined;
    descriptionVN!: string | undefined;
    content!: string | undefined;
    contentVN!: string | undefined;
    avatar!: string | undefined;
    linkAvatar!: string | undefined;
    status!: string | undefined;
    fromDate!: moment.Moment | undefined;
    toDate!: moment.Moment | undefined;
    tags!: string | undefined;
    updatedByUser!: string | undefined;
    targetAudienceID!: number | undefined;
    targetAudienceName!: string | undefined;
    targetAudienceType!: string | undefined;
    translations!: ArticleTranslationDto[] | undefined;
    tableName!: string | undefined;
    filePath!: string | undefined;
    fileName!: string | undefined;
    userId!: number | undefined;
    tenantId!: number | undefined;
    currentLanguage!: string | undefined;
    apiUrl!: string | undefined;

    constructor(data?: IArticleInfoAgrs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.articleID = data["articleID"];
            this.code = data["code"];
            this.name = data["name"];
            this.nameVN = data["nameVN"];
            this.description = data["description"];
            this.descriptionVN = data["descriptionVN"];
            this.content = data["content"];
            this.contentVN = data["contentVN"];
            this.avatar = data["avatar"];
            this.linkAvatar = data["linkAvatar"];
            this.status = data["status"];
            this.fromDate = data["fromDate"] ? moment(data["fromDate"].toString()) : <any>undefined;
            this.toDate = data["toDate"] ? moment(data["toDate"].toString()) : <any>undefined;
            this.tags = data["tags"];
            this.updatedByUser = data["updatedByUser"];
            this.targetAudienceID = data["targetAudienceID"];
            this.targetAudienceName = data["targetAudienceName"];
            this.targetAudienceType = data["targetAudienceType"];
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(ArticleTranslationDto.fromJS(item));
            }
            this.tableName = data["tableName"];
            this.filePath = data["filePath"];
            this.fileName = data["fileName"];
            this.userId = data["userId"];
            this.tenantId = data["tenantId"];
            this.currentLanguage = data["currentLanguage"];
            this.apiUrl = data["apiUrl"];
        }
    }

    static fromJS(data: any): ArticleInfoAgrs {
        data = typeof data === 'object' ? data : {};
        let result = new ArticleInfoAgrs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articleID"] = this.articleID;
        data["code"] = this.code;
        data["name"] = this.name;
        data["nameVN"] = this.nameVN;
        data["description"] = this.description;
        data["descriptionVN"] = this.descriptionVN;
        data["content"] = this.content;
        data["contentVN"] = this.contentVN;
        data["avatar"] = this.avatar;
        data["linkAvatar"] = this.linkAvatar;
        data["status"] = this.status;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data["tags"] = this.tags;
        data["updatedByUser"] = this.updatedByUser;
        data["targetAudienceID"] = this.targetAudienceID;
        data["targetAudienceName"] = this.targetAudienceName;
        data["targetAudienceType"] = this.targetAudienceType;
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        data["tableName"] = this.tableName;
        data["filePath"] = this.filePath;
        data["fileName"] = this.fileName;
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["currentLanguage"] = this.currentLanguage;
        data["apiUrl"] = this.apiUrl;
        return data;
    }
}

export interface IArticleInfoAgrs {
    articleID: number | undefined;
    code: string | undefined;
    name: string | undefined;
    nameVN: string | undefined;
    description: string | undefined;
    descriptionVN: string | undefined;
    content: string | undefined;
    contentVN: string | undefined;
    avatar: string | undefined;
    linkAvatar: string | undefined;
    status: string | undefined;
    fromDate: moment.Moment | undefined;
    toDate: moment.Moment | undefined;
    tags: string | undefined;
    updatedByUser: string | undefined;
    targetAudienceID: number | undefined;
    targetAudienceName: string | undefined;
    targetAudienceType: string | undefined;
    translations: ArticleTranslationDto[] | undefined;
    tableName: string | undefined;
    filePath: string | undefined;
    fileName: string | undefined;
    userId: number | undefined;
    tenantId: number | undefined;
    currentLanguage: string | undefined;
    apiUrl: string | undefined;
}

export class DeleteArticleDto implements IDeleteArticleDto {
    ids!: number[] | undefined;

    constructor(data?: IDeleteArticleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["ids"] && data["ids"].constructor === Array) {
                this.ids = [];
                for (let item of data["ids"])
                    this.ids.push(item);
            }
        }
    }

    static fromJS(data: any): DeleteArticleDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteArticleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.ids && this.ids.constructor === Array) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        return data;
    }
}

export interface IDeleteArticleDto {
    ids: number[] | undefined;
}

export class MessageResultCMS implements IMessageResultCMS {
    isSuccess!: boolean | undefined;
    errors!: MessageErrorCMS[] | undefined;

    constructor(data?: IMessageResultCMS) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isSuccess = data["isSuccess"];
            if (data["errors"] && data["errors"].constructor === Array) {
                this.errors = [];
                for (let item of data["errors"])
                    this.errors.push(MessageErrorCMS.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MessageResultCMS {
        data = typeof data === 'object' ? data : {};
        let result = new MessageResultCMS();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        if (this.errors && this.errors.constructor === Array) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMessageResultCMS {
    isSuccess: boolean | undefined;
    errors: MessageErrorCMS[] | undefined;
}

export class MessageErrorCMS implements IMessageErrorCMS {
    message!: string | undefined;
    propertyName!: string | undefined;
    count!: number | undefined;

    constructor(data?: IMessageErrorCMS) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.message = data["message"];
            this.propertyName = data["propertyName"];
            this.count = data["count"];
        }
    }

    static fromJS(data: any): MessageErrorCMS {
        data = typeof data === 'object' ? data : {};
        let result = new MessageErrorCMS();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["propertyName"] = this.propertyName;
        data["count"] = this.count;
        return data;
    }
}

export interface IMessageErrorCMS {
    message: string | undefined;
    propertyName: string | undefined;
    count: number | undefined;
}

export class PagedResultDtoOfGetArticleTargetAudienceDetailForViewDto implements IPagedResultDtoOfGetArticleTargetAudienceDetailForViewDto {
    totalCount!: number | undefined;
    items!: GetArticleTargetAudienceDetailForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetArticleTargetAudienceDetailForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetArticleTargetAudienceDetailForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetArticleTargetAudienceDetailForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetArticleTargetAudienceDetailForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetArticleTargetAudienceDetailForViewDto {
    totalCount: number | undefined;
    items: GetArticleTargetAudienceDetailForViewDto[] | undefined;
}

export class GetArticleTargetAudienceDetailForViewDto implements IGetArticleTargetAudienceDetailForViewDto {
    articleTargetAudienceDetail!: ArticleTargetAudienceDetailDto | undefined;

    constructor(data?: IGetArticleTargetAudienceDetailForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.articleTargetAudienceDetail = data["articleTargetAudienceDetail"] ? ArticleTargetAudienceDetailDto.fromJS(data["articleTargetAudienceDetail"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetArticleTargetAudienceDetailForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetArticleTargetAudienceDetailForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articleTargetAudienceDetail"] = this.articleTargetAudienceDetail ? this.articleTargetAudienceDetail.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetArticleTargetAudienceDetailForViewDto {
    articleTargetAudienceDetail: ArticleTargetAudienceDetailDto | undefined;
}

export class GetArticleTargetAudienceDetailForEditOutput implements IGetArticleTargetAudienceDetailForEditOutput {
    articleTargetAudienceDetail!: CreateOrEditArticleTargetAudienceDetailDto | undefined;

    constructor(data?: IGetArticleTargetAudienceDetailForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.articleTargetAudienceDetail = data["articleTargetAudienceDetail"] ? CreateOrEditArticleTargetAudienceDetailDto.fromJS(data["articleTargetAudienceDetail"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetArticleTargetAudienceDetailForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetArticleTargetAudienceDetailForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articleTargetAudienceDetail"] = this.articleTargetAudienceDetail ? this.articleTargetAudienceDetail.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetArticleTargetAudienceDetailForEditOutput {
    articleTargetAudienceDetail: CreateOrEditArticleTargetAudienceDetailDto | undefined;
}

export class CreateOrEditArticleTargetAudienceDetailDto implements ICreateOrEditArticleTargetAudienceDetailDto {
    articleTargetAudienceID!: number | undefined;
    name!: string | undefined;
    phone!: string | undefined;
    zaloChatID!: string | undefined;
    email!: string | undefined;
    facebookID!: string | undefined;
    memberCode!: string | undefined;
    communicationLanguage!: string | undefined;
    communicationChannel!: string | undefined;
    outletCode!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditArticleTargetAudienceDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.articleTargetAudienceID = data["articleTargetAudienceID"];
            this.name = data["name"];
            this.phone = data["phone"];
            this.zaloChatID = data["zaloChatID"];
            this.email = data["email"];
            this.facebookID = data["facebookID"];
            this.memberCode = data["memberCode"];
            this.communicationLanguage = data["communicationLanguage"];
            this.communicationChannel = data["communicationChannel"];
            this.outletCode = data["outletCode"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditArticleTargetAudienceDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditArticleTargetAudienceDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articleTargetAudienceID"] = this.articleTargetAudienceID;
        data["name"] = this.name;
        data["phone"] = this.phone;
        data["zaloChatID"] = this.zaloChatID;
        data["email"] = this.email;
        data["facebookID"] = this.facebookID;
        data["memberCode"] = this.memberCode;
        data["communicationLanguage"] = this.communicationLanguage;
        data["communicationChannel"] = this.communicationChannel;
        data["outletCode"] = this.outletCode;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditArticleTargetAudienceDetailDto {
    articleTargetAudienceID: number | undefined;
    name: string | undefined;
    phone: string | undefined;
    zaloChatID: string | undefined;
    email: string | undefined;
    facebookID: string | undefined;
    memberCode: string | undefined;
    communicationLanguage: string | undefined;
    communicationChannel: string | undefined;
    outletCode: string | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfGetArticleTargetAudienceForViewDto implements IPagedResultDtoOfGetArticleTargetAudienceForViewDto {
    totalCount!: number | undefined;
    items!: GetArticleTargetAudienceForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetArticleTargetAudienceForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetArticleTargetAudienceForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetArticleTargetAudienceForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetArticleTargetAudienceForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetArticleTargetAudienceForViewDto {
    totalCount: number | undefined;
    items: GetArticleTargetAudienceForViewDto[] | undefined;
}

export class GetArticleTargetAudienceForViewDto implements IGetArticleTargetAudienceForViewDto {
    articleTargetAudience!: ArticleTargetAudienceDto | undefined;

    constructor(data?: IGetArticleTargetAudienceForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.articleTargetAudience = data["articleTargetAudience"] ? ArticleTargetAudienceDto.fromJS(data["articleTargetAudience"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetArticleTargetAudienceForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetArticleTargetAudienceForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articleTargetAudience"] = this.articleTargetAudience ? this.articleTargetAudience.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetArticleTargetAudienceForViewDto {
    articleTargetAudience: ArticleTargetAudienceDto | undefined;
}

export class GetArticleTargetAudienceForEditOutput implements IGetArticleTargetAudienceForEditOutput {
    articleTargetAudience!: CreateOrEditArticleTargetAudienceDto | undefined;

    constructor(data?: IGetArticleTargetAudienceForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.articleTargetAudience = data["articleTargetAudience"] ? CreateOrEditArticleTargetAudienceDto.fromJS(data["articleTargetAudience"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetArticleTargetAudienceForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetArticleTargetAudienceForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articleTargetAudience"] = this.articleTargetAudience ? this.articleTargetAudience.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetArticleTargetAudienceForEditOutput {
    articleTargetAudience: CreateOrEditArticleTargetAudienceDto | undefined;
}

export class CreateOrEditArticleTargetAudienceDto implements ICreateOrEditArticleTargetAudienceDto {
    targetAudienceName!: string | undefined;
    description!: string | undefined;
    status!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditArticleTargetAudienceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.targetAudienceName = data["targetAudienceName"];
            this.description = data["description"];
            this.status = data["status"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditArticleTargetAudienceDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditArticleTargetAudienceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["targetAudienceName"] = this.targetAudienceName;
        data["description"] = this.description;
        data["status"] = this.status;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditArticleTargetAudienceDto {
    targetAudienceName: string | undefined;
    description: string | undefined;
    status: string | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfGetArticleUserForViewDto implements IPagedResultDtoOfGetArticleUserForViewDto {
    totalCount!: number | undefined;
    items!: GetArticleUserForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetArticleUserForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetArticleUserForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetArticleUserForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetArticleUserForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetArticleUserForViewDto {
    totalCount: number | undefined;
    items: GetArticleUserForViewDto[] | undefined;
}

export class GetArticleUserForViewDto implements IGetArticleUserForViewDto {
    articleUser!: ArticleUserDto | undefined;

    constructor(data?: IGetArticleUserForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.articleUser = data["articleUser"] ? ArticleUserDto.fromJS(data["articleUser"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetArticleUserForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetArticleUserForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articleUser"] = this.articleUser ? this.articleUser.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetArticleUserForViewDto {
    articleUser: ArticleUserDto | undefined;
}

export class ArticleUserDto implements IArticleUserDto {
    memberCode!: string | undefined;
    articleCode!: string | undefined;
    categoryCode!: string | undefined;
    categoryType!: number | undefined;
    status!: string | undefined;
    article!: ArticleDto | undefined;
    id!: number | undefined;

    constructor(data?: IArticleUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberCode = data["memberCode"];
            this.articleCode = data["articleCode"];
            this.categoryCode = data["categoryCode"];
            this.categoryType = data["categoryType"];
            this.status = data["status"];
            this.article = data["article"] ? ArticleDto.fromJS(data["article"]) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ArticleUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new ArticleUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberCode"] = this.memberCode;
        data["articleCode"] = this.articleCode;
        data["categoryCode"] = this.categoryCode;
        data["categoryType"] = this.categoryType;
        data["status"] = this.status;
        data["article"] = this.article ? this.article.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IArticleUserDto {
    memberCode: string | undefined;
    articleCode: string | undefined;
    categoryCode: string | undefined;
    categoryType: number | undefined;
    status: string | undefined;
    article: ArticleDto | undefined;
    id: number | undefined;
}

export class GetArticleUserForEditOutput implements IGetArticleUserForEditOutput {
    articleUser!: CreateOrEditArticleUserDto | undefined;

    constructor(data?: IGetArticleUserForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.articleUser = data["articleUser"] ? CreateOrEditArticleUserDto.fromJS(data["articleUser"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetArticleUserForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetArticleUserForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articleUser"] = this.articleUser ? this.articleUser.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetArticleUserForEditOutput {
    articleUser: CreateOrEditArticleUserDto | undefined;
}

export class CreateOrEditArticleUserDto implements ICreateOrEditArticleUserDto {
    memberCode!: string | undefined;
    articleCode!: string | undefined;
    categoryCode!: string | undefined;
    categoryType!: number | undefined;
    status!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditArticleUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberCode = data["memberCode"];
            this.articleCode = data["articleCode"];
            this.categoryCode = data["categoryCode"];
            this.categoryType = data["categoryType"];
            this.status = data["status"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditArticleUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditArticleUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberCode"] = this.memberCode;
        data["articleCode"] = this.articleCode;
        data["categoryCode"] = this.categoryCode;
        data["categoryType"] = this.categoryType;
        data["status"] = this.status;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditArticleUserDto {
    memberCode: string | undefined;
    articleCode: string | undefined;
    categoryCode: string | undefined;
    categoryType: number | undefined;
    status: string | undefined;
    id: number | undefined;
}

export class CMSFileDto implements ICMSFileDto {
    fileName!: string;
    fileType!: string;
    fileToken!: string;

    constructor(data?: ICMSFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.fileName = data["fileName"];
            this.fileType = data["fileType"];
            this.fileToken = data["fileToken"];
        }
    }

    static fromJS(data: any): CMSFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new CMSFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["fileType"] = this.fileType;
        data["fileToken"] = this.fileToken;
        return data;
    }
}

export interface ICMSFileDto {
    fileName: string;
    fileType: string;
    fileToken: string;
}

export class GetAllArticleUsersForBookmarkInput implements IGetAllArticleUsersForBookmarkInput {
    filter!: string | undefined;
    memberCodeFilter!: string | undefined;
    language!: string | undefined;
    sorting!: string | undefined;
    skipCount!: number | undefined;
    maxResultCount!: number | undefined;

    constructor(data?: IGetAllArticleUsersForBookmarkInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.filter = data["filter"];
            this.memberCodeFilter = data["memberCodeFilter"];
            this.language = data["language"];
            this.sorting = data["sorting"];
            this.skipCount = data["skipCount"];
            this.maxResultCount = data["maxResultCount"];
        }
    }

    static fromJS(data: any): GetAllArticleUsersForBookmarkInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllArticleUsersForBookmarkInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        data["memberCodeFilter"] = this.memberCodeFilter;
        data["language"] = this.language;
        data["sorting"] = this.sorting;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data;
    }
}

export interface IGetAllArticleUsersForBookmarkInput {
    filter: string | undefined;
    memberCodeFilter: string | undefined;
    language: string | undefined;
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;
}

export class UpdateStatusBookmarkInput implements IUpdateStatusBookmarkInput {
    memberCode!: string | undefined;
    articleCode!: string | undefined;
    status!: string | undefined;

    constructor(data?: IUpdateStatusBookmarkInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberCode = data["memberCode"];
            this.articleCode = data["articleCode"];
            this.status = data["status"];
        }
    }

    static fromJS(data: any): UpdateStatusBookmarkInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateStatusBookmarkInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberCode"] = this.memberCode;
        data["articleCode"] = this.articleCode;
        data["status"] = this.status;
        return data;
    }
}

export interface IUpdateStatusBookmarkInput {
    memberCode: string | undefined;
    articleCode: string | undefined;
    status: string | undefined;
}

export class PagedResultDtoOfAuditLogListDto implements IPagedResultDtoOfAuditLogListDto {
    totalCount!: number | undefined;
    items!: AuditLogListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfAuditLogListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(AuditLogListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfAuditLogListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfAuditLogListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfAuditLogListDto {
    totalCount: number | undefined;
    items: AuditLogListDto[] | undefined;
}

export class AuditLogListDto implements IAuditLogListDto {
    userId!: number | undefined;
    userName!: string | undefined;
    impersonatorTenantId!: number | undefined;
    impersonatorUserId!: number | undefined;
    serviceName!: string | undefined;
    methodName!: string | undefined;
    parameters!: string | undefined;
    executionTime!: moment.Moment | undefined;
    executionDuration!: number | undefined;
    clientIpAddress!: string | undefined;
    clientName!: string | undefined;
    browserInfo!: string | undefined;
    exception!: string | undefined;
    customData!: string | undefined;
    id!: number | undefined;

    constructor(data?: IAuditLogListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userId = data["userId"];
            this.userName = data["userName"];
            this.impersonatorTenantId = data["impersonatorTenantId"];
            this.impersonatorUserId = data["impersonatorUserId"];
            this.serviceName = data["serviceName"];
            this.methodName = data["methodName"];
            this.parameters = data["parameters"];
            this.executionTime = data["executionTime"] ? moment(data["executionTime"].toString()) : <any>undefined;
            this.executionDuration = data["executionDuration"];
            this.clientIpAddress = data["clientIpAddress"];
            this.clientName = data["clientName"];
            this.browserInfo = data["browserInfo"];
            this.exception = data["exception"];
            this.customData = data["customData"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): AuditLogListDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuditLogListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["impersonatorTenantId"] = this.impersonatorTenantId;
        data["impersonatorUserId"] = this.impersonatorUserId;
        data["serviceName"] = this.serviceName;
        data["methodName"] = this.methodName;
        data["parameters"] = this.parameters;
        data["executionTime"] = this.executionTime ? this.executionTime.toISOString() : <any>undefined;
        data["executionDuration"] = this.executionDuration;
        data["clientIpAddress"] = this.clientIpAddress;
        data["clientName"] = this.clientName;
        data["browserInfo"] = this.browserInfo;
        data["exception"] = this.exception;
        data["customData"] = this.customData;
        data["id"] = this.id;
        return data;
    }
}

export interface IAuditLogListDto {
    userId: number | undefined;
    userName: string | undefined;
    impersonatorTenantId: number | undefined;
    impersonatorUserId: number | undefined;
    serviceName: string | undefined;
    methodName: string | undefined;
    parameters: string | undefined;
    executionTime: moment.Moment | undefined;
    executionDuration: number | undefined;
    clientIpAddress: string | undefined;
    clientName: string | undefined;
    browserInfo: string | undefined;
    exception: string | undefined;
    customData: string | undefined;
    id: number | undefined;
}

export class FileDto implements IFileDto {
    fileName!: string;
    fileType!: string;
    fileToken!: string;

    constructor(data?: IFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.fileName = data["fileName"];
            this.fileType = data["fileType"];
            this.fileToken = data["fileToken"];
        }
    }

    static fromJS(data: any): FileDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["fileType"] = this.fileType;
        data["fileToken"] = this.fileToken;
        return data;
    }
}

export interface IFileDto {
    fileName: string;
    fileType: string;
    fileToken: string;
}

export class NameValueDto implements INameValueDto {
    name!: string | undefined;
    value!: string | undefined;

    constructor(data?: INameValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.value = data["value"];
        }
    }

    static fromJS(data: any): NameValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new NameValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }
}

export interface INameValueDto {
    name: string | undefined;
    value: string | undefined;
}

export class PagedResultDtoOfEntityChangeListDto implements IPagedResultDtoOfEntityChangeListDto {
    totalCount!: number | undefined;
    items!: EntityChangeListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfEntityChangeListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(EntityChangeListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfEntityChangeListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfEntityChangeListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfEntityChangeListDto {
    totalCount: number | undefined;
    items: EntityChangeListDto[] | undefined;
}

export class EntityChangeListDto implements IEntityChangeListDto {
    entityId!: number | undefined;
    userId!: number | undefined;
    userName!: string | undefined;
    changeTime!: moment.Moment | undefined;
    entityTypeFullName!: string | undefined;
    changeType!: EntityChangeListDtoChangeType | undefined;
    changeTypeName!: string | undefined;
    entityChangeSetId!: number | undefined;
    entityPropertyChangeDto!: EntityPropertyChangeDto[] | undefined;
    id!: number | undefined;

    constructor(data?: IEntityChangeListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.entityId = data["entityId"];
            this.userId = data["userId"];
            this.userName = data["userName"];
            this.changeTime = data["changeTime"] ? moment(data["changeTime"].toString()) : <any>undefined;
            this.entityTypeFullName = data["entityTypeFullName"];
            this.changeType = data["changeType"];
            this.changeTypeName = data["changeTypeName"];
            this.entityChangeSetId = data["entityChangeSetId"];
            if (data["entityPropertyChangeDto"] && data["entityPropertyChangeDto"].constructor === Array) {
                this.entityPropertyChangeDto = [];
                for (let item of data["entityPropertyChangeDto"])
                    this.entityPropertyChangeDto.push(EntityPropertyChangeDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EntityChangeListDto {
        data = typeof data === 'object' ? data : {};
        let result = new EntityChangeListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityId"] = this.entityId;
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["changeTime"] = this.changeTime ? this.changeTime.toISOString() : <any>undefined;
        data["entityTypeFullName"] = this.entityTypeFullName;
        data["changeType"] = this.changeType;
        data["changeTypeName"] = this.changeTypeName;
        data["entityChangeSetId"] = this.entityChangeSetId;
        if (this.entityPropertyChangeDto && this.entityPropertyChangeDto.constructor === Array) {
            data["entityPropertyChangeDto"] = [];
            for (let item of this.entityPropertyChangeDto)
                data["entityPropertyChangeDto"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IEntityChangeListDto {
    entityId: number | undefined;
    userId: number | undefined;
    userName: string | undefined;
    changeTime: moment.Moment | undefined;
    entityTypeFullName: string | undefined;
    changeType: EntityChangeListDtoChangeType | undefined;
    changeTypeName: string | undefined;
    entityChangeSetId: number | undefined;
    entityPropertyChangeDto: EntityPropertyChangeDto[] | undefined;
    id: number | undefined;
}

export class EntityPropertyChangeDto implements IEntityPropertyChangeDto {
    entityChangeId!: number | undefined;
    newValue!: string | undefined;
    originalValue!: string | undefined;
    propertyName!: string | undefined;
    propertyTypeFullName!: string | undefined;
    tenantId!: number | undefined;
    id!: number | undefined;

    constructor(data?: IEntityPropertyChangeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.entityChangeId = data["entityChangeId"];
            this.newValue = data["newValue"];
            this.originalValue = data["originalValue"];
            this.propertyName = data["propertyName"];
            this.propertyTypeFullName = data["propertyTypeFullName"];
            this.tenantId = data["tenantId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EntityPropertyChangeDto {
        data = typeof data === 'object' ? data : {};
        let result = new EntityPropertyChangeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityChangeId"] = this.entityChangeId;
        data["newValue"] = this.newValue;
        data["originalValue"] = this.originalValue;
        data["propertyName"] = this.propertyName;
        data["propertyTypeFullName"] = this.propertyTypeFullName;
        data["tenantId"] = this.tenantId;
        data["id"] = this.id;
        return data;
    }
}

export interface IEntityPropertyChangeDto {
    entityChangeId: number | undefined;
    newValue: string | undefined;
    originalValue: string | undefined;
    propertyName: string | undefined;
    propertyTypeFullName: string | undefined;
    tenantId: number | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfGetAutoReplySettingForViewDto implements IPagedResultDtoOfGetAutoReplySettingForViewDto {
    totalCount!: number | undefined;
    items!: GetAutoReplySettingForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetAutoReplySettingForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetAutoReplySettingForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetAutoReplySettingForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetAutoReplySettingForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetAutoReplySettingForViewDto {
    totalCount: number | undefined;
    items: GetAutoReplySettingForViewDto[] | undefined;
}

export class GetAutoReplySettingForViewDto implements IGetAutoReplySettingForViewDto {
    autoReplySetting!: AutoReplySettingDto | undefined;

    constructor(data?: IGetAutoReplySettingForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.autoReplySetting = data["autoReplySetting"] ? AutoReplySettingDto.fromJS(data["autoReplySetting"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetAutoReplySettingForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAutoReplySettingForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["autoReplySetting"] = this.autoReplySetting ? this.autoReplySetting.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetAutoReplySettingForViewDto {
    autoReplySetting: AutoReplySettingDto | undefined;
}

export class AutoReplySettingDto implements IAutoReplySettingDto {
    name!: string | undefined;
    keywords!: string | undefined;
    content!: string | undefined;
    status!: string | undefined;
    creationTime!: moment.Moment | undefined;
    id!: number | undefined;

    constructor(data?: IAutoReplySettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.keywords = data["keywords"];
            this.content = data["content"];
            this.status = data["status"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): AutoReplySettingDto {
        data = typeof data === 'object' ? data : {};
        let result = new AutoReplySettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["keywords"] = this.keywords;
        data["content"] = this.content;
        data["status"] = this.status;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IAutoReplySettingDto {
    name: string | undefined;
    keywords: string | undefined;
    content: string | undefined;
    status: string | undefined;
    creationTime: moment.Moment | undefined;
    id: number | undefined;
}

export class GetAutoReplySettingForEditOutput implements IGetAutoReplySettingForEditOutput {
    autoReplySetting!: CreateOrEditAutoReplySettingDto | undefined;

    constructor(data?: IGetAutoReplySettingForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.autoReplySetting = data["autoReplySetting"] ? CreateOrEditAutoReplySettingDto.fromJS(data["autoReplySetting"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetAutoReplySettingForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAutoReplySettingForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["autoReplySetting"] = this.autoReplySetting ? this.autoReplySetting.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetAutoReplySettingForEditOutput {
    autoReplySetting: CreateOrEditAutoReplySettingDto | undefined;
}

export class CreateOrEditAutoReplySettingDto implements ICreateOrEditAutoReplySettingDto {
    name!: string | undefined;
    keywords!: string | undefined;
    content!: string | undefined;
    status!: string | undefined;
    creationTime!: moment.Moment | undefined;
    creatorUserId!: number | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    lastModifierUser!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditAutoReplySettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.keywords = data["keywords"];
            this.content = data["content"];
            this.status = data["status"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.lastModifierUser = data["lastModifierUser"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditAutoReplySettingDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditAutoReplySettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["keywords"] = this.keywords;
        data["content"] = this.content;
        data["status"] = this.status;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModifierUser"] = this.lastModifierUser;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditAutoReplySettingDto {
    name: string | undefined;
    keywords: string | undefined;
    content: string | undefined;
    status: string | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    lastModifierUser: string | undefined;
    id: number | undefined;
}

export class AutoReplySettingImportAgrs implements IAutoReplySettingImportAgrs {
    tableName!: string | undefined;
    filePath!: string | undefined;
    fileName!: string | undefined;
    userId!: number | undefined;
    userName!: string | undefined;
    name!: string | undefined;
    tenantId!: number | undefined;
    currentLanguage!: string | undefined;
    apiUrl!: string | undefined;

    constructor(data?: IAutoReplySettingImportAgrs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tableName = data["tableName"];
            this.filePath = data["filePath"];
            this.fileName = data["fileName"];
            this.userId = data["userId"];
            this.userName = data["userName"];
            this.name = data["name"];
            this.tenantId = data["tenantId"];
            this.currentLanguage = data["currentLanguage"];
            this.apiUrl = data["apiUrl"];
        }
    }

    static fromJS(data: any): AutoReplySettingImportAgrs {
        data = typeof data === 'object' ? data : {};
        let result = new AutoReplySettingImportAgrs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tableName"] = this.tableName;
        data["filePath"] = this.filePath;
        data["fileName"] = this.fileName;
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["name"] = this.name;
        data["tenantId"] = this.tenantId;
        data["currentLanguage"] = this.currentLanguage;
        data["apiUrl"] = this.apiUrl;
        return data;
    }
}

export interface IAutoReplySettingImportAgrs {
    tableName: string | undefined;
    filePath: string | undefined;
    fileName: string | undefined;
    userId: number | undefined;
    userName: string | undefined;
    name: string | undefined;
    tenantId: number | undefined;
    currentLanguage: string | undefined;
    apiUrl: string | undefined;
}

export class BaseLineInput implements IBaseLineInput {
    startTime!: moment.Moment | undefined;
    endTime!: moment.Moment | undefined;
    point!: number | undefined;
    coin!: number | undefined;
    memberCode!: string | undefined;

    constructor(data?: IBaseLineInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.startTime = data["startTime"] ? moment(data["startTime"].toString()) : <any>undefined;
            this.endTime = data["endTime"] ? moment(data["endTime"].toString()) : <any>undefined;
            this.point = data["point"];
            this.coin = data["coin"];
            this.memberCode = data["memberCode"];
        }
    }

    static fromJS(data: any): BaseLineInput {
        data = typeof data === 'object' ? data : {};
        let result = new BaseLineInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["point"] = this.point;
        data["coin"] = this.coin;
        data["memberCode"] = this.memberCode;
        return data;
    }
}

export interface IBaseLineInput {
    startTime: moment.Moment | undefined;
    endTime: moment.Moment | undefined;
    point: number | undefined;
    coin: number | undefined;
    memberCode: string | undefined;
}

export class RevokeBaseLineOutput implements IRevokeBaseLineOutput {
    totalCoin!: number | undefined;
    revokeCoin!: number | undefined;

    constructor(data?: IRevokeBaseLineOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCoin = data["totalCoin"];
            this.revokeCoin = data["revokeCoin"];
        }
    }

    static fromJS(data: any): RevokeBaseLineOutput {
        data = typeof data === 'object' ? data : {};
        let result = new RevokeBaseLineOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCoin"] = this.totalCoin;
        data["revokeCoin"] = this.revokeCoin;
        return data;
    }
}

export interface IRevokeBaseLineOutput {
    totalCoin: number | undefined;
    revokeCoin: number | undefined;
}

export class PagedResultDtoOfGetBaseSettingForView implements IPagedResultDtoOfGetBaseSettingForView {
    totalCount!: number | undefined;
    items!: GetBaseSettingForView[] | undefined;

    constructor(data?: IPagedResultDtoOfGetBaseSettingForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetBaseSettingForView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetBaseSettingForView {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetBaseSettingForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetBaseSettingForView {
    totalCount: number | undefined;
    items: GetBaseSettingForView[] | undefined;
}

export class GetBaseSettingForView implements IGetBaseSettingForView {
    baseSetting!: BaseSettingDto | undefined;
    targetAudienceName!: string | undefined;
    campaignName!: string | undefined;

    constructor(data?: IGetBaseSettingForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.baseSetting = data["baseSetting"] ? BaseSettingDto.fromJS(data["baseSetting"]) : <any>undefined;
            this.targetAudienceName = data["targetAudienceName"];
            this.campaignName = data["campaignName"];
        }
    }

    static fromJS(data: any): GetBaseSettingForView {
        data = typeof data === 'object' ? data : {};
        let result = new GetBaseSettingForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["baseSetting"] = this.baseSetting ? this.baseSetting.toJSON() : <any>undefined;
        data["targetAudienceName"] = this.targetAudienceName;
        data["campaignName"] = this.campaignName;
        return data;
    }
}

export interface IGetBaseSettingForView {
    baseSetting: BaseSettingDto | undefined;
    targetAudienceName: string | undefined;
    campaignName: string | undefined;
}

export class BaseSettingDto implements IBaseSettingDto {
    code!: string | undefined;
    name!: string | undefined;
    description!: string | undefined;
    coinValue!: number | undefined;
    pointValue!: number | undefined;
    effectiveFrom!: moment.Moment | undefined;
    effectiveTo!: moment.Moment | undefined;
    isActive!: boolean | undefined;
    targetAudienceId!: number | undefined;
    targetAudience!: SettingParamDto | undefined;
    campaignId!: number | undefined;
    type!: string | undefined;
    targetAudienceCode!: string | undefined;
    id!: number | undefined;

    constructor(data?: IBaseSettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.name = data["name"];
            this.description = data["description"];
            this.coinValue = data["coinValue"];
            this.pointValue = data["pointValue"];
            this.effectiveFrom = data["effectiveFrom"] ? moment(data["effectiveFrom"].toString()) : <any>undefined;
            this.effectiveTo = data["effectiveTo"] ? moment(data["effectiveTo"].toString()) : <any>undefined;
            this.isActive = data["isActive"];
            this.targetAudienceId = data["targetAudienceId"];
            this.targetAudience = data["targetAudience"] ? SettingParamDto.fromJS(data["targetAudience"]) : <any>undefined;
            this.campaignId = data["campaignId"];
            this.type = data["type"];
            this.targetAudienceCode = data["targetAudienceCode"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): BaseSettingDto {
        data = typeof data === 'object' ? data : {};
        let result = new BaseSettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["description"] = this.description;
        data["coinValue"] = this.coinValue;
        data["pointValue"] = this.pointValue;
        data["effectiveFrom"] = this.effectiveFrom ? this.effectiveFrom.toISOString() : <any>undefined;
        data["effectiveTo"] = this.effectiveTo ? this.effectiveTo.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        data["targetAudienceId"] = this.targetAudienceId;
        data["targetAudience"] = this.targetAudience ? this.targetAudience.toJSON() : <any>undefined;
        data["campaignId"] = this.campaignId;
        data["type"] = this.type;
        data["targetAudienceCode"] = this.targetAudienceCode;
        data["id"] = this.id;
        return data;
    }
}

export interface IBaseSettingDto {
    code: string | undefined;
    name: string | undefined;
    description: string | undefined;
    coinValue: number | undefined;
    pointValue: number | undefined;
    effectiveFrom: moment.Moment | undefined;
    effectiveTo: moment.Moment | undefined;
    isActive: boolean | undefined;
    targetAudienceId: number | undefined;
    targetAudience: SettingParamDto | undefined;
    campaignId: number | undefined;
    type: string | undefined;
    targetAudienceCode: string | undefined;
    id: number | undefined;
}

export class ListResultDtoOfBaseSettingDto implements IListResultDtoOfBaseSettingDto {
    items!: BaseSettingDto[] | undefined;

    constructor(data?: IListResultDtoOfBaseSettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(BaseSettingDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfBaseSettingDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfBaseSettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListResultDtoOfBaseSettingDto {
    items: BaseSettingDto[] | undefined;
}

export class GetBaseSettingForEditOutput implements IGetBaseSettingForEditOutput {
    baseSetting!: CreateOrEditBaseSettingDto | undefined;
    targetAudienceName!: string | undefined;
    campaignName!: string | undefined;

    constructor(data?: IGetBaseSettingForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.baseSetting = data["baseSetting"] ? CreateOrEditBaseSettingDto.fromJS(data["baseSetting"]) : <any>undefined;
            this.targetAudienceName = data["targetAudienceName"];
            this.campaignName = data["campaignName"];
        }
    }

    static fromJS(data: any): GetBaseSettingForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetBaseSettingForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["baseSetting"] = this.baseSetting ? this.baseSetting.toJSON() : <any>undefined;
        data["targetAudienceName"] = this.targetAudienceName;
        data["campaignName"] = this.campaignName;
        return data;
    }
}

export interface IGetBaseSettingForEditOutput {
    baseSetting: CreateOrEditBaseSettingDto | undefined;
    targetAudienceName: string | undefined;
    campaignName: string | undefined;
}

export class CreateOrEditBaseSettingDto implements ICreateOrEditBaseSettingDto {
    code!: string;
    type!: string;
    name!: string;
    description!: string | undefined;
    coinValue!: number | undefined;
    pointValue!: number | undefined;
    effectiveFrom!: moment.Moment | undefined;
    effectiveTo!: moment.Moment | undefined;
    isActive!: boolean | undefined;
    targetAudienceId!: number | undefined;
    campaignId!: number | undefined;
    targetAudience!: CreateOrEditSettingParamDto | undefined;
    targetAudienceCode!: string | undefined;
    isDeleted!: boolean | undefined;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: moment.Moment | undefined;
    creatorUserId!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditBaseSettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.type = data["type"];
            this.name = data["name"];
            this.description = data["description"];
            this.coinValue = data["coinValue"];
            this.pointValue = data["pointValue"];
            this.effectiveFrom = data["effectiveFrom"] ? moment(data["effectiveFrom"].toString()) : <any>undefined;
            this.effectiveTo = data["effectiveTo"] ? moment(data["effectiveTo"].toString()) : <any>undefined;
            this.isActive = data["isActive"];
            this.targetAudienceId = data["targetAudienceId"];
            this.campaignId = data["campaignId"];
            this.targetAudience = data["targetAudience"] ? CreateOrEditSettingParamDto.fromJS(data["targetAudience"]) : <any>undefined;
            this.targetAudienceCode = data["targetAudienceCode"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditBaseSettingDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditBaseSettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["type"] = this.type;
        data["name"] = this.name;
        data["description"] = this.description;
        data["coinValue"] = this.coinValue;
        data["pointValue"] = this.pointValue;
        data["effectiveFrom"] = this.effectiveFrom ? this.effectiveFrom.toISOString() : <any>undefined;
        data["effectiveTo"] = this.effectiveTo ? this.effectiveTo.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        data["targetAudienceId"] = this.targetAudienceId;
        data["campaignId"] = this.campaignId;
        data["targetAudience"] = this.targetAudience ? this.targetAudience.toJSON() : <any>undefined;
        data["targetAudienceCode"] = this.targetAudienceCode;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditBaseSettingDto {
    code: string;
    type: string;
    name: string;
    description: string | undefined;
    coinValue: number | undefined;
    pointValue: number | undefined;
    effectiveFrom: moment.Moment | undefined;
    effectiveTo: moment.Moment | undefined;
    isActive: boolean | undefined;
    targetAudienceId: number | undefined;
    campaignId: number | undefined;
    targetAudience: CreateOrEditSettingParamDto | undefined;
    targetAudienceCode: string | undefined;
    isDeleted: boolean | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfGetBeatPlanDetailForViewDto implements IPagedResultDtoOfGetBeatPlanDetailForViewDto {
    totalCount!: number | undefined;
    items!: GetBeatPlanDetailForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetBeatPlanDetailForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetBeatPlanDetailForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetBeatPlanDetailForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetBeatPlanDetailForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetBeatPlanDetailForViewDto {
    totalCount: number | undefined;
    items: GetBeatPlanDetailForViewDto[] | undefined;
}

export class GetBeatPlanDetailForViewDto implements IGetBeatPlanDetailForViewDto {
    beatPlanDetail!: BeatPlanDetailDto | undefined;

    constructor(data?: IGetBeatPlanDetailForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.beatPlanDetail = data["beatPlanDetail"] ? BeatPlanDetailDto.fromJS(data["beatPlanDetail"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetBeatPlanDetailForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetBeatPlanDetailForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["beatPlanDetail"] = this.beatPlanDetail ? this.beatPlanDetail.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetBeatPlanDetailForViewDto {
    beatPlanDetail: BeatPlanDetailDto | undefined;
}

export class BeatPlanDetailDto implements IBeatPlanDetailDto {
    beatPlanCode!: string | undefined;
    outletCode!: string | undefined;
    status!: string | undefined;
    masterNameUnSign!: string | undefined;
    salesmanCode!: string | undefined;
    frequency!: string | undefined;
    priority!: number | undefined;
    fromDate!: moment.Moment | undefined;
    toDate!: moment.Moment | undefined;
    id!: number | undefined;

    constructor(data?: IBeatPlanDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.beatPlanCode = data["beatPlanCode"];
            this.outletCode = data["outletCode"];
            this.status = data["status"];
            this.masterNameUnSign = data["masterNameUnSign"];
            this.salesmanCode = data["salesmanCode"];
            this.frequency = data["frequency"];
            this.priority = data["priority"];
            this.fromDate = data["fromDate"] ? moment(data["fromDate"].toString()) : <any>undefined;
            this.toDate = data["toDate"] ? moment(data["toDate"].toString()) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): BeatPlanDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new BeatPlanDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["beatPlanCode"] = this.beatPlanCode;
        data["outletCode"] = this.outletCode;
        data["status"] = this.status;
        data["masterNameUnSign"] = this.masterNameUnSign;
        data["salesmanCode"] = this.salesmanCode;
        data["frequency"] = this.frequency;
        data["priority"] = this.priority;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IBeatPlanDetailDto {
    beatPlanCode: string | undefined;
    outletCode: string | undefined;
    status: string | undefined;
    masterNameUnSign: string | undefined;
    salesmanCode: string | undefined;
    frequency: string | undefined;
    priority: number | undefined;
    fromDate: moment.Moment | undefined;
    toDate: moment.Moment | undefined;
    id: number | undefined;
}

export class GetBeatPlanDetailForEditOutput implements IGetBeatPlanDetailForEditOutput {
    beatPlanDetail!: CreateOrEditBeatPlanDetailDto | undefined;

    constructor(data?: IGetBeatPlanDetailForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.beatPlanDetail = data["beatPlanDetail"] ? CreateOrEditBeatPlanDetailDto.fromJS(data["beatPlanDetail"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetBeatPlanDetailForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetBeatPlanDetailForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["beatPlanDetail"] = this.beatPlanDetail ? this.beatPlanDetail.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetBeatPlanDetailForEditOutput {
    beatPlanDetail: CreateOrEditBeatPlanDetailDto | undefined;
}

export class CreateOrEditBeatPlanDetailDto implements ICreateOrEditBeatPlanDetailDto {
    beatPlanCode!: string | undefined;
    outletCode!: string | undefined;
    status!: string | undefined;
    masterNameUnSign!: string | undefined;
    salesmanCode!: string | undefined;
    fromDate!: moment.Moment | undefined;
    toDate!: moment.Moment | undefined;
    frequency!: string | undefined;
    priority!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditBeatPlanDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.beatPlanCode = data["beatPlanCode"];
            this.outletCode = data["outletCode"];
            this.status = data["status"];
            this.masterNameUnSign = data["masterNameUnSign"];
            this.salesmanCode = data["salesmanCode"];
            this.fromDate = data["fromDate"] ? moment(data["fromDate"].toString()) : <any>undefined;
            this.toDate = data["toDate"] ? moment(data["toDate"].toString()) : <any>undefined;
            this.frequency = data["frequency"];
            this.priority = data["priority"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditBeatPlanDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditBeatPlanDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["beatPlanCode"] = this.beatPlanCode;
        data["outletCode"] = this.outletCode;
        data["status"] = this.status;
        data["masterNameUnSign"] = this.masterNameUnSign;
        data["salesmanCode"] = this.salesmanCode;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data["frequency"] = this.frequency;
        data["priority"] = this.priority;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditBeatPlanDetailDto {
    beatPlanCode: string | undefined;
    outletCode: string | undefined;
    status: string | undefined;
    masterNameUnSign: string | undefined;
    salesmanCode: string | undefined;
    fromDate: moment.Moment | undefined;
    toDate: moment.Moment | undefined;
    frequency: string | undefined;
    priority: number | undefined;
    id: number | undefined;
}

export class OutletForBeatPlanDetailDto implements IOutletForBeatPlanDetailDto {
    outletCode!: string | undefined;
    name!: string | undefined;
    address!: string | undefined;
    status!: string | undefined;
    id!: number | undefined;

    constructor(data?: IOutletForBeatPlanDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.outletCode = data["outletCode"];
            this.name = data["name"];
            this.address = data["address"];
            this.status = data["status"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): OutletForBeatPlanDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new OutletForBeatPlanDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["outletCode"] = this.outletCode;
        data["name"] = this.name;
        data["address"] = this.address;
        data["status"] = this.status;
        data["id"] = this.id;
        return data;
    }
}

export interface IOutletForBeatPlanDetailDto {
    outletCode: string | undefined;
    name: string | undefined;
    address: string | undefined;
    status: string | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfGetBeatPlanDetailsResultForViewDto implements IPagedResultDtoOfGetBeatPlanDetailsResultForViewDto {
    totalCount!: number | undefined;
    items!: GetBeatPlanDetailsResultForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetBeatPlanDetailsResultForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetBeatPlanDetailsResultForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetBeatPlanDetailsResultForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetBeatPlanDetailsResultForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetBeatPlanDetailsResultForViewDto {
    totalCount: number | undefined;
    items: GetBeatPlanDetailsResultForViewDto[] | undefined;
}

export class GetBeatPlanDetailsResultForViewDto implements IGetBeatPlanDetailsResultForViewDto {
    beatPlanDetails!: BeatPlanDetailsResultDto | undefined;

    constructor(data?: IGetBeatPlanDetailsResultForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.beatPlanDetails = data["beatPlanDetails"] ? BeatPlanDetailsResultDto.fromJS(data["beatPlanDetails"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetBeatPlanDetailsResultForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetBeatPlanDetailsResultForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["beatPlanDetails"] = this.beatPlanDetails ? this.beatPlanDetails.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetBeatPlanDetailsResultForViewDto {
    beatPlanDetails: BeatPlanDetailsResultDto | undefined;
}

export class BeatPlanDetailsResultDto implements IBeatPlanDetailsResultDto {
    outletCode!: string | undefined;
    name!: string | undefined;
    address!: string | undefined;
    status!: string | undefined;
    salesmanName!: string | undefined;
    frequency!: string | undefined;
    priority!: number | undefined;
    id!: number | undefined;

    constructor(data?: IBeatPlanDetailsResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.outletCode = data["outletCode"];
            this.name = data["name"];
            this.address = data["address"];
            this.status = data["status"];
            this.salesmanName = data["salesmanName"];
            this.frequency = data["frequency"];
            this.priority = data["priority"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): BeatPlanDetailsResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new BeatPlanDetailsResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["outletCode"] = this.outletCode;
        data["name"] = this.name;
        data["address"] = this.address;
        data["status"] = this.status;
        data["salesmanName"] = this.salesmanName;
        data["frequency"] = this.frequency;
        data["priority"] = this.priority;
        data["id"] = this.id;
        return data;
    }
}

export interface IBeatPlanDetailsResultDto {
    outletCode: string | undefined;
    name: string | undefined;
    address: string | undefined;
    status: string | undefined;
    salesmanName: string | undefined;
    frequency: string | undefined;
    priority: number | undefined;
    id: number | undefined;
}

export class MessageResultSocialRetailer implements IMessageResultSocialRetailer {
    isSuccess!: boolean | undefined;
    errors!: MessageErrorSocialRetailer[] | undefined;

    constructor(data?: IMessageResultSocialRetailer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isSuccess = data["isSuccess"];
            if (data["errors"] && data["errors"].constructor === Array) {
                this.errors = [];
                for (let item of data["errors"])
                    this.errors.push(MessageErrorSocialRetailer.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MessageResultSocialRetailer {
        data = typeof data === 'object' ? data : {};
        let result = new MessageResultSocialRetailer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        if (this.errors && this.errors.constructor === Array) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMessageResultSocialRetailer {
    isSuccess: boolean | undefined;
    errors: MessageErrorSocialRetailer[] | undefined;
}

export class MessageErrorSocialRetailer implements IMessageErrorSocialRetailer {
    message!: string | undefined;
    propertyName!: string | undefined;
    count!: number | undefined;

    constructor(data?: IMessageErrorSocialRetailer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.message = data["message"];
            this.propertyName = data["propertyName"];
            this.count = data["count"];
        }
    }

    static fromJS(data: any): MessageErrorSocialRetailer {
        data = typeof data === 'object' ? data : {};
        let result = new MessageErrorSocialRetailer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["propertyName"] = this.propertyName;
        data["count"] = this.count;
        return data;
    }
}

export interface IMessageErrorSocialRetailer {
    message: string | undefined;
    propertyName: string | undefined;
    count: number | undefined;
}

export class BeatPlanDetailImportAgrs implements IBeatPlanDetailImportAgrs {
    beatPlanImportDto!: BeatPlanDetailImportDto[] | undefined;
    isSuccess!: boolean | undefined;
    errorFilePath!: string | undefined;
    tableName!: string | undefined;
    filePath!: string | undefined;
    fileName!: string | undefined;
    userId!: number | undefined;
    userName!: string | undefined;
    name!: string | undefined;
    tenantId!: number | undefined;
    currentLanguage!: string | undefined;
    apiUrl!: string | undefined;

    constructor(data?: IBeatPlanDetailImportAgrs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["beatPlanImportDto"] && data["beatPlanImportDto"].constructor === Array) {
                this.beatPlanImportDto = [];
                for (let item of data["beatPlanImportDto"])
                    this.beatPlanImportDto.push(BeatPlanDetailImportDto.fromJS(item));
            }
            this.isSuccess = data["isSuccess"];
            this.errorFilePath = data["errorFilePath"];
            this.tableName = data["tableName"];
            this.filePath = data["filePath"];
            this.fileName = data["fileName"];
            this.userId = data["userId"];
            this.userName = data["userName"];
            this.name = data["name"];
            this.tenantId = data["tenantId"];
            this.currentLanguage = data["currentLanguage"];
            this.apiUrl = data["apiUrl"];
        }
    }

    static fromJS(data: any): BeatPlanDetailImportAgrs {
        data = typeof data === 'object' ? data : {};
        let result = new BeatPlanDetailImportAgrs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.beatPlanImportDto && this.beatPlanImportDto.constructor === Array) {
            data["beatPlanImportDto"] = [];
            for (let item of this.beatPlanImportDto)
                data["beatPlanImportDto"].push(item.toJSON());
        }
        data["isSuccess"] = this.isSuccess;
        data["errorFilePath"] = this.errorFilePath;
        data["tableName"] = this.tableName;
        data["filePath"] = this.filePath;
        data["fileName"] = this.fileName;
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["name"] = this.name;
        data["tenantId"] = this.tenantId;
        data["currentLanguage"] = this.currentLanguage;
        data["apiUrl"] = this.apiUrl;
        return data;
    }
}

export interface IBeatPlanDetailImportAgrs {
    beatPlanImportDto: BeatPlanDetailImportDto[] | undefined;
    isSuccess: boolean | undefined;
    errorFilePath: string | undefined;
    tableName: string | undefined;
    filePath: string | undefined;
    fileName: string | undefined;
    userId: number | undefined;
    userName: string | undefined;
    name: string | undefined;
    tenantId: number | undefined;
    currentLanguage: string | undefined;
    apiUrl: string | undefined;
}

export class BeatPlanDetailImportDto implements IBeatPlanDetailImportDto {
    indexRow!: number | undefined;
    tenantId!: number | undefined;
    beatPlanCode!: string | undefined;
    outletCode!: string | undefined;
    status!: string | undefined;
    masterNameUnSign!: string | undefined;
    salesmanCode!: string | undefined;
    frequency!: string | undefined;
    priority!: number | undefined;
    isDeleted!: boolean | undefined;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: moment.Moment | undefined;
    creatorUserId!: number | undefined;
    id!: number | undefined;

    constructor(data?: IBeatPlanDetailImportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.indexRow = data["indexRow"];
            this.tenantId = data["tenantId"];
            this.beatPlanCode = data["beatPlanCode"];
            this.outletCode = data["outletCode"];
            this.status = data["status"];
            this.masterNameUnSign = data["masterNameUnSign"];
            this.salesmanCode = data["salesmanCode"];
            this.frequency = data["frequency"];
            this.priority = data["priority"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): BeatPlanDetailImportDto {
        data = typeof data === 'object' ? data : {};
        let result = new BeatPlanDetailImportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["indexRow"] = this.indexRow;
        data["tenantId"] = this.tenantId;
        data["beatPlanCode"] = this.beatPlanCode;
        data["outletCode"] = this.outletCode;
        data["status"] = this.status;
        data["masterNameUnSign"] = this.masterNameUnSign;
        data["salesmanCode"] = this.salesmanCode;
        data["frequency"] = this.frequency;
        data["priority"] = this.priority;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IBeatPlanDetailImportDto {
    indexRow: number | undefined;
    tenantId: number | undefined;
    beatPlanCode: string | undefined;
    outletCode: string | undefined;
    status: string | undefined;
    masterNameUnSign: string | undefined;
    salesmanCode: string | undefined;
    frequency: string | undefined;
    priority: number | undefined;
    isDeleted: boolean | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class CommonImportFileResponse implements ICommonImportFileResponse {
    isSuccess!: boolean | undefined;
    errorFilePath!: string | undefined;
    isImportImmediately!: boolean | undefined;
    successCount!: number | undefined;
    failCount!: number | undefined;
    totalRowCount!: number | undefined;

    constructor(data?: ICommonImportFileResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isSuccess = data["isSuccess"];
            this.errorFilePath = data["errorFilePath"];
            this.isImportImmediately = data["isImportImmediately"];
            this.successCount = data["successCount"];
            this.failCount = data["failCount"];
            this.totalRowCount = data["totalRowCount"];
        }
    }

    static fromJS(data: any): CommonImportFileResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CommonImportFileResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["errorFilePath"] = this.errorFilePath;
        data["isImportImmediately"] = this.isImportImmediately;
        data["successCount"] = this.successCount;
        data["failCount"] = this.failCount;
        data["totalRowCount"] = this.totalRowCount;
        return data;
    }
}

export interface ICommonImportFileResponse {
    isSuccess: boolean | undefined;
    errorFilePath: string | undefined;
    isImportImmediately: boolean | undefined;
    successCount: number | undefined;
    failCount: number | undefined;
    totalRowCount: number | undefined;
}

export class CreateOrEditOutletForBeatPlanDetailDto implements ICreateOrEditOutletForBeatPlanDetailDto {
    tenantId!: number | undefined;
    beatPlanCode!: string | undefined;
    salesmanCode!: string | undefined;
    outletCode!: string | undefined;
    address!: string | undefined;
    status!: string | undefined;
    frequency!: string | undefined;
    priority!: number | undefined;
    isDeleted!: boolean | undefined;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: moment.Moment | undefined;
    creatorUserId!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditOutletForBeatPlanDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.beatPlanCode = data["beatPlanCode"];
            this.salesmanCode = data["salesmanCode"];
            this.outletCode = data["outletCode"];
            this.address = data["address"];
            this.status = data["status"];
            this.frequency = data["frequency"];
            this.priority = data["priority"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditOutletForBeatPlanDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditOutletForBeatPlanDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["beatPlanCode"] = this.beatPlanCode;
        data["salesmanCode"] = this.salesmanCode;
        data["outletCode"] = this.outletCode;
        data["address"] = this.address;
        data["status"] = this.status;
        data["frequency"] = this.frequency;
        data["priority"] = this.priority;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditOutletForBeatPlanDetailDto {
    tenantId: number | undefined;
    beatPlanCode: string | undefined;
    salesmanCode: string | undefined;
    outletCode: string | undefined;
    address: string | undefined;
    status: string | undefined;
    frequency: string | undefined;
    priority: number | undefined;
    isDeleted: boolean | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfGetBeatPlanOutletDto implements IPagedResultDtoOfGetBeatPlanOutletDto {
    totalCount!: number | undefined;
    items!: GetBeatPlanOutletDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetBeatPlanOutletDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetBeatPlanOutletDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetBeatPlanOutletDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetBeatPlanOutletDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetBeatPlanOutletDto {
    totalCount: number | undefined;
    items: GetBeatPlanOutletDto[] | undefined;
}

export class GetBeatPlanOutletDto implements IGetBeatPlanOutletDto {
    salesmanCode!: string | undefined;
    beatPlanCode!: string | undefined;
    outletCode!: string | undefined;
    outletName!: string | undefined;
    address!: string | undefined;
    phoneUpdated!: string | undefined;
    phoneUpdateStatus!: string | undefined;
    lockUpdatePhone!: boolean | undefined;
    lat!: string | undefined;
    lng!: string | undefined;
    status!: string | undefined;
    chatID!: string | undefined;
    salesChannel!: string | undefined;

    constructor(data?: IGetBeatPlanOutletDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.salesmanCode = data["salesmanCode"];
            this.beatPlanCode = data["beatPlanCode"];
            this.outletCode = data["outletCode"];
            this.outletName = data["outletName"];
            this.address = data["address"];
            this.phoneUpdated = data["phoneUpdated"];
            this.phoneUpdateStatus = data["phoneUpdateStatus"];
            this.lockUpdatePhone = data["lockUpdatePhone"];
            this.lat = data["lat"];
            this.lng = data["lng"];
            this.status = data["status"];
            this.chatID = data["chatID"];
            this.salesChannel = data["salesChannel"];
        }
    }

    static fromJS(data: any): GetBeatPlanOutletDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetBeatPlanOutletDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["salesmanCode"] = this.salesmanCode;
        data["beatPlanCode"] = this.beatPlanCode;
        data["outletCode"] = this.outletCode;
        data["outletName"] = this.outletName;
        data["address"] = this.address;
        data["phoneUpdated"] = this.phoneUpdated;
        data["phoneUpdateStatus"] = this.phoneUpdateStatus;
        data["lockUpdatePhone"] = this.lockUpdatePhone;
        data["lat"] = this.lat;
        data["lng"] = this.lng;
        data["status"] = this.status;
        data["chatID"] = this.chatID;
        data["salesChannel"] = this.salesChannel;
        return data;
    }
}

export interface IGetBeatPlanOutletDto {
    salesmanCode: string | undefined;
    beatPlanCode: string | undefined;
    outletCode: string | undefined;
    outletName: string | undefined;
    address: string | undefined;
    phoneUpdated: string | undefined;
    phoneUpdateStatus: string | undefined;
    lockUpdatePhone: boolean | undefined;
    lat: string | undefined;
    lng: string | undefined;
    status: string | undefined;
    chatID: string | undefined;
    salesChannel: string | undefined;
}

export class PagedResultDtoOfGetOutletActiveForView implements IPagedResultDtoOfGetOutletActiveForView {
    totalCount!: number | undefined;
    items!: GetOutletActiveForView[] | undefined;

    constructor(data?: IPagedResultDtoOfGetOutletActiveForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetOutletActiveForView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetOutletActiveForView {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetOutletActiveForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetOutletActiveForView {
    totalCount: number | undefined;
    items: GetOutletActiveForView[] | undefined;
}

export class GetOutletActiveForView implements IGetOutletActiveForView {
    outletActive!: OutletActiveForBeatPlanDetailDto | undefined;

    constructor(data?: IGetOutletActiveForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.outletActive = data["outletActive"] ? OutletActiveForBeatPlanDetailDto.fromJS(data["outletActive"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetOutletActiveForView {
        data = typeof data === 'object' ? data : {};
        let result = new GetOutletActiveForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["outletActive"] = this.outletActive ? this.outletActive.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetOutletActiveForView {
    outletActive: OutletActiveForBeatPlanDetailDto | undefined;
}

export class OutletActiveForBeatPlanDetailDto implements IOutletActiveForBeatPlanDetailDto {
    outletCode!: string | undefined;
    name!: string | undefined;
    address!: string | undefined;
    status!: string | undefined;
    frequency!: string | undefined;
    priority!: number | undefined;
    lastModificationTime!: moment.Moment | undefined;
    id!: number | undefined;

    constructor(data?: IOutletActiveForBeatPlanDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.outletCode = data["outletCode"];
            this.name = data["name"];
            this.address = data["address"];
            this.status = data["status"];
            this.frequency = data["frequency"];
            this.priority = data["priority"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): OutletActiveForBeatPlanDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new OutletActiveForBeatPlanDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["outletCode"] = this.outletCode;
        data["name"] = this.name;
        data["address"] = this.address;
        data["status"] = this.status;
        data["frequency"] = this.frequency;
        data["priority"] = this.priority;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IOutletActiveForBeatPlanDetailDto {
    outletCode: string | undefined;
    name: string | undefined;
    address: string | undefined;
    status: string | undefined;
    frequency: string | undefined;
    priority: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfGetBeatPlanHeaderForViewDto implements IPagedResultDtoOfGetBeatPlanHeaderForViewDto {
    totalCount!: number | undefined;
    items!: GetBeatPlanHeaderForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetBeatPlanHeaderForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetBeatPlanHeaderForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetBeatPlanHeaderForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetBeatPlanHeaderForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetBeatPlanHeaderForViewDto {
    totalCount: number | undefined;
    items: GetBeatPlanHeaderForViewDto[] | undefined;
}

export class GetBeatPlanHeaderForViewDto implements IGetBeatPlanHeaderForViewDto {
    beatPlanHeader!: BeatPlanHeaderDto | undefined;

    constructor(data?: IGetBeatPlanHeaderForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.beatPlanHeader = data["beatPlanHeader"] ? BeatPlanHeaderDto.fromJS(data["beatPlanHeader"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetBeatPlanHeaderForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetBeatPlanHeaderForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["beatPlanHeader"] = this.beatPlanHeader ? this.beatPlanHeader.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetBeatPlanHeaderForViewDto {
    beatPlanHeader: BeatPlanHeaderDto | undefined;
}

export class BeatPlanHeaderDto implements IBeatPlanHeaderDto {
    beatPlanCode!: string | undefined;
    beatPlanName!: string | undefined;
    salesmanCode!: string | undefined;
    status!: string | undefined;
    masterNameUnSign!: string | undefined;
    fromDate!: moment.Moment | undefined;
    toDate!: moment.Moment | undefined;
    creationTime!: moment.Moment | undefined;
    creatorUserId!: number | undefined;
    creatorUserName!: string | undefined;
    salesmanName!: string | undefined;
    id!: number | undefined;

    constructor(data?: IBeatPlanHeaderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.beatPlanCode = data["beatPlanCode"];
            this.beatPlanName = data["beatPlanName"];
            this.salesmanCode = data["salesmanCode"];
            this.status = data["status"];
            this.masterNameUnSign = data["masterNameUnSign"];
            this.fromDate = data["fromDate"] ? moment(data["fromDate"].toString()) : <any>undefined;
            this.toDate = data["toDate"] ? moment(data["toDate"].toString()) : <any>undefined;
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.creatorUserName = data["creatorUserName"];
            this.salesmanName = data["salesmanName"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): BeatPlanHeaderDto {
        data = typeof data === 'object' ? data : {};
        let result = new BeatPlanHeaderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["beatPlanCode"] = this.beatPlanCode;
        data["beatPlanName"] = this.beatPlanName;
        data["salesmanCode"] = this.salesmanCode;
        data["status"] = this.status;
        data["masterNameUnSign"] = this.masterNameUnSign;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["creatorUserName"] = this.creatorUserName;
        data["salesmanName"] = this.salesmanName;
        data["id"] = this.id;
        return data;
    }
}

export interface IBeatPlanHeaderDto {
    beatPlanCode: string | undefined;
    beatPlanName: string | undefined;
    salesmanCode: string | undefined;
    status: string | undefined;
    masterNameUnSign: string | undefined;
    fromDate: moment.Moment | undefined;
    toDate: moment.Moment | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    creatorUserName: string | undefined;
    salesmanName: string | undefined;
    id: number | undefined;
}

export class GetBeatPlanHeaderForEditOutput implements IGetBeatPlanHeaderForEditOutput {
    beatPlanHeader!: CreateOrEditBeatPlanHeaderDto | undefined;

    constructor(data?: IGetBeatPlanHeaderForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.beatPlanHeader = data["beatPlanHeader"] ? CreateOrEditBeatPlanHeaderDto.fromJS(data["beatPlanHeader"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetBeatPlanHeaderForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetBeatPlanHeaderForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["beatPlanHeader"] = this.beatPlanHeader ? this.beatPlanHeader.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetBeatPlanHeaderForEditOutput {
    beatPlanHeader: CreateOrEditBeatPlanHeaderDto | undefined;
}

export class CreateOrEditBeatPlanHeaderDto implements ICreateOrEditBeatPlanHeaderDto {
    beatPlanCode!: string | undefined;
    beatPlanName!: string | undefined;
    salesmanCode!: string | undefined;
    status!: string | undefined;
    masterNameUnSign!: string | undefined;
    fromDate!: moment.Moment | undefined;
    toDate!: moment.Moment | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditBeatPlanHeaderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.beatPlanCode = data["beatPlanCode"];
            this.beatPlanName = data["beatPlanName"];
            this.salesmanCode = data["salesmanCode"];
            this.status = data["status"];
            this.masterNameUnSign = data["masterNameUnSign"];
            this.fromDate = data["fromDate"] ? moment(data["fromDate"].toString()) : <any>undefined;
            this.toDate = data["toDate"] ? moment(data["toDate"].toString()) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditBeatPlanHeaderDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditBeatPlanHeaderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["beatPlanCode"] = this.beatPlanCode;
        data["beatPlanName"] = this.beatPlanName;
        data["salesmanCode"] = this.salesmanCode;
        data["status"] = this.status;
        data["masterNameUnSign"] = this.masterNameUnSign;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditBeatPlanHeaderDto {
    beatPlanCode: string | undefined;
    beatPlanName: string | undefined;
    salesmanCode: string | undefined;
    status: string | undefined;
    masterNameUnSign: string | undefined;
    fromDate: moment.Moment | undefined;
    toDate: moment.Moment | undefined;
    id: number | undefined;
}

export class CreateOrEditBeatPlanHeaderForAppDto implements ICreateOrEditBeatPlanHeaderForAppDto {
    salesmanCode!: string;
    beatPlanName!: string;
    fromDate!: moment.Moment;
    toDate!: moment.Moment;
    totalOutlet!: number | undefined;
    listOutlet!: OutletDto[] | undefined;

    constructor(data?: ICreateOrEditBeatPlanHeaderForAppDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.salesmanCode = data["salesmanCode"];
            this.beatPlanName = data["beatPlanName"];
            this.fromDate = data["fromDate"] ? moment(data["fromDate"].toString()) : <any>undefined;
            this.toDate = data["toDate"] ? moment(data["toDate"].toString()) : <any>undefined;
            this.totalOutlet = data["totalOutlet"];
            if (data["listOutlet"] && data["listOutlet"].constructor === Array) {
                this.listOutlet = [];
                for (let item of data["listOutlet"])
                    this.listOutlet.push(OutletDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOrEditBeatPlanHeaderForAppDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditBeatPlanHeaderForAppDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["salesmanCode"] = this.salesmanCode;
        data["beatPlanName"] = this.beatPlanName;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data["totalOutlet"] = this.totalOutlet;
        if (this.listOutlet && this.listOutlet.constructor === Array) {
            data["listOutlet"] = [];
            for (let item of this.listOutlet)
                data["listOutlet"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateOrEditBeatPlanHeaderForAppDto {
    salesmanCode: string;
    beatPlanName: string;
    fromDate: moment.Moment;
    toDate: moment.Moment;
    totalOutlet: number | undefined;
    listOutlet: OutletDto[] | undefined;
}

export class OutletDto implements IOutletDto {
    outletCode!: string | undefined;
    status!: string | undefined;

    constructor(data?: IOutletDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.outletCode = data["outletCode"];
            this.status = data["status"];
        }
    }

    static fromJS(data: any): OutletDto {
        data = typeof data === 'object' ? data : {};
        let result = new OutletDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["outletCode"] = this.outletCode;
        data["status"] = this.status;
        return data;
    }
}

export interface IOutletDto {
    outletCode: string | undefined;
    status: string | undefined;
}

export class BeatPlanHeaderForAppResponse implements IBeatPlanHeaderForAppResponse {
    success!: boolean | undefined;
    exception!: any | undefined;
    message!: string | undefined;

    constructor(data?: IBeatPlanHeaderForAppResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.success = data["success"];
            this.exception = data["exception"];
            this.message = data["message"];
        }
    }

    static fromJS(data: any): BeatPlanHeaderForAppResponse {
        data = typeof data === 'object' ? data : {};
        let result = new BeatPlanHeaderForAppResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["exception"] = this.exception;
        data["message"] = this.message;
        return data;
    }
}

export interface IBeatPlanHeaderForAppResponse {
    success: boolean | undefined;
    exception: any | undefined;
    message: string | undefined;
}

export class BeatPlanImportAgrs implements IBeatPlanImportAgrs {
    beatPlanImportDto!: BeatPlanImportDto[] | undefined;
    isSuccess!: boolean | undefined;
    errorFilePath!: string | undefined;
    tableName!: string | undefined;
    filePath!: string | undefined;
    fileName!: string | undefined;
    userId!: number | undefined;
    userName!: string | undefined;
    name!: string | undefined;
    tenantId!: number | undefined;
    currentLanguage!: string | undefined;
    apiUrl!: string | undefined;

    constructor(data?: IBeatPlanImportAgrs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["beatPlanImportDto"] && data["beatPlanImportDto"].constructor === Array) {
                this.beatPlanImportDto = [];
                for (let item of data["beatPlanImportDto"])
                    this.beatPlanImportDto.push(BeatPlanImportDto.fromJS(item));
            }
            this.isSuccess = data["isSuccess"];
            this.errorFilePath = data["errorFilePath"];
            this.tableName = data["tableName"];
            this.filePath = data["filePath"];
            this.fileName = data["fileName"];
            this.userId = data["userId"];
            this.userName = data["userName"];
            this.name = data["name"];
            this.tenantId = data["tenantId"];
            this.currentLanguage = data["currentLanguage"];
            this.apiUrl = data["apiUrl"];
        }
    }

    static fromJS(data: any): BeatPlanImportAgrs {
        data = typeof data === 'object' ? data : {};
        let result = new BeatPlanImportAgrs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.beatPlanImportDto && this.beatPlanImportDto.constructor === Array) {
            data["beatPlanImportDto"] = [];
            for (let item of this.beatPlanImportDto)
                data["beatPlanImportDto"].push(item.toJSON());
        }
        data["isSuccess"] = this.isSuccess;
        data["errorFilePath"] = this.errorFilePath;
        data["tableName"] = this.tableName;
        data["filePath"] = this.filePath;
        data["fileName"] = this.fileName;
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["name"] = this.name;
        data["tenantId"] = this.tenantId;
        data["currentLanguage"] = this.currentLanguage;
        data["apiUrl"] = this.apiUrl;
        return data;
    }
}

export interface IBeatPlanImportAgrs {
    beatPlanImportDto: BeatPlanImportDto[] | undefined;
    isSuccess: boolean | undefined;
    errorFilePath: string | undefined;
    tableName: string | undefined;
    filePath: string | undefined;
    fileName: string | undefined;
    userId: number | undefined;
    userName: string | undefined;
    name: string | undefined;
    tenantId: number | undefined;
    currentLanguage: string | undefined;
    apiUrl: string | undefined;
}

export class BeatPlanImportDto implements IBeatPlanImportDto {
    tenantId!: number | undefined;
    detailId!: number | undefined;
    groupId!: number | undefined;
    beatPlanCode!: string | undefined;
    beatPlanName!: string | undefined;
    salesmanCode!: string | undefined;
    status!: string | undefined;
    masterNameUnSign!: string | undefined;
    fromDate!: moment.Moment | undefined;
    toDate!: moment.Moment | undefined;
    outletCode!: string | undefined;
    frequency!: string | undefined;
    priority!: number | undefined;
    isDeleted!: boolean | undefined;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: moment.Moment | undefined;
    creatorUserId!: number | undefined;
    id!: number | undefined;

    constructor(data?: IBeatPlanImportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.detailId = data["detailId"];
            this.groupId = data["groupId"];
            this.beatPlanCode = data["beatPlanCode"];
            this.beatPlanName = data["beatPlanName"];
            this.salesmanCode = data["salesmanCode"];
            this.status = data["status"];
            this.masterNameUnSign = data["masterNameUnSign"];
            this.fromDate = data["fromDate"] ? moment(data["fromDate"].toString()) : <any>undefined;
            this.toDate = data["toDate"] ? moment(data["toDate"].toString()) : <any>undefined;
            this.outletCode = data["outletCode"];
            this.frequency = data["frequency"];
            this.priority = data["priority"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): BeatPlanImportDto {
        data = typeof data === 'object' ? data : {};
        let result = new BeatPlanImportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["detailId"] = this.detailId;
        data["groupId"] = this.groupId;
        data["beatPlanCode"] = this.beatPlanCode;
        data["beatPlanName"] = this.beatPlanName;
        data["salesmanCode"] = this.salesmanCode;
        data["status"] = this.status;
        data["masterNameUnSign"] = this.masterNameUnSign;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data["outletCode"] = this.outletCode;
        data["frequency"] = this.frequency;
        data["priority"] = this.priority;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IBeatPlanImportDto {
    tenantId: number | undefined;
    detailId: number | undefined;
    groupId: number | undefined;
    beatPlanCode: string | undefined;
    beatPlanName: string | undefined;
    salesmanCode: string | undefined;
    status: string | undefined;
    masterNameUnSign: string | undefined;
    fromDate: moment.Moment | undefined;
    toDate: moment.Moment | undefined;
    outletCode: string | undefined;
    frequency: string | undefined;
    priority: number | undefined;
    isDeleted: boolean | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfGetBeatPlanForViewMobileDto implements IPagedResultDtoOfGetBeatPlanForViewMobileDto {
    totalCount!: number | undefined;
    items!: GetBeatPlanForViewMobileDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetBeatPlanForViewMobileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetBeatPlanForViewMobileDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetBeatPlanForViewMobileDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetBeatPlanForViewMobileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetBeatPlanForViewMobileDto {
    totalCount: number | undefined;
    items: GetBeatPlanForViewMobileDto[] | undefined;
}

export class GetBeatPlanForViewMobileDto implements IGetBeatPlanForViewMobileDto {
    beatPlanHeader!: GetBeatPlanDto | undefined;

    constructor(data?: IGetBeatPlanForViewMobileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.beatPlanHeader = data["beatPlanHeader"] ? GetBeatPlanDto.fromJS(data["beatPlanHeader"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetBeatPlanForViewMobileDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetBeatPlanForViewMobileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["beatPlanHeader"] = this.beatPlanHeader ? this.beatPlanHeader.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetBeatPlanForViewMobileDto {
    beatPlanHeader: GetBeatPlanDto | undefined;
}

export class GetBeatPlanDto implements IGetBeatPlanDto {
    salesmanCode!: string | undefined;
    beatPlanCode!: string | undefined;
    beatPlanName!: string | undefined;
    status!: string | undefined;
    id!: number | undefined;

    constructor(data?: IGetBeatPlanDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.salesmanCode = data["salesmanCode"];
            this.beatPlanCode = data["beatPlanCode"];
            this.beatPlanName = data["beatPlanName"];
            this.status = data["status"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): GetBeatPlanDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetBeatPlanDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["salesmanCode"] = this.salesmanCode;
        data["beatPlanCode"] = this.beatPlanCode;
        data["beatPlanName"] = this.beatPlanName;
        data["status"] = this.status;
        data["id"] = this.id;
        return data;
    }
}

export interface IGetBeatPlanDto {
    salesmanCode: string | undefined;
    beatPlanCode: string | undefined;
    beatPlanName: string | undefined;
    status: string | undefined;
    id: number | undefined;
}

export class CreateOrEditBeatPlanResultInput implements ICreateOrEditBeatPlanResultInput {
    beatPlanCode!: string | undefined;
    beatPlanName!: string | undefined;
    salemanCode!: string | undefined;
    outletCode!: string | undefined;
    checkInLongitude!: string | undefined;
    checkInLastitude!: string | undefined;
    checkInDistant!: string | undefined;
    checkInImageLink!: string | undefined;
    checkInTime!: moment.Moment | undefined;
    checkOutLongitude!: string | undefined;
    checkOutLastitude!: string | undefined;
    checkOutDistant!: string | undefined;
    checkOutImageLink!: string | undefined;
    checkOutTime!: moment.Moment | undefined;
    checkListResultId!: string | undefined;
    rate!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditBeatPlanResultInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.beatPlanCode = data["beatPlanCode"];
            this.beatPlanName = data["beatPlanName"];
            this.salemanCode = data["salemanCode"];
            this.outletCode = data["outletCode"];
            this.checkInLongitude = data["checkInLongitude"];
            this.checkInLastitude = data["checkInLastitude"];
            this.checkInDistant = data["checkInDistant"];
            this.checkInImageLink = data["checkInImageLink"];
            this.checkInTime = data["checkInTime"] ? moment(data["checkInTime"].toString()) : <any>undefined;
            this.checkOutLongitude = data["checkOutLongitude"];
            this.checkOutLastitude = data["checkOutLastitude"];
            this.checkOutDistant = data["checkOutDistant"];
            this.checkOutImageLink = data["checkOutImageLink"];
            this.checkOutTime = data["checkOutTime"] ? moment(data["checkOutTime"].toString()) : <any>undefined;
            this.checkListResultId = data["checkListResultId"];
            this.rate = data["rate"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditBeatPlanResultInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditBeatPlanResultInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["beatPlanCode"] = this.beatPlanCode;
        data["beatPlanName"] = this.beatPlanName;
        data["salemanCode"] = this.salemanCode;
        data["outletCode"] = this.outletCode;
        data["checkInLongitude"] = this.checkInLongitude;
        data["checkInLastitude"] = this.checkInLastitude;
        data["checkInDistant"] = this.checkInDistant;
        data["checkInImageLink"] = this.checkInImageLink;
        data["checkInTime"] = this.checkInTime ? this.checkInTime.toISOString() : <any>undefined;
        data["checkOutLongitude"] = this.checkOutLongitude;
        data["checkOutLastitude"] = this.checkOutLastitude;
        data["checkOutDistant"] = this.checkOutDistant;
        data["checkOutImageLink"] = this.checkOutImageLink;
        data["checkOutTime"] = this.checkOutTime ? this.checkOutTime.toISOString() : <any>undefined;
        data["checkListResultId"] = this.checkListResultId;
        data["rate"] = this.rate;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditBeatPlanResultInput {
    beatPlanCode: string | undefined;
    beatPlanName: string | undefined;
    salemanCode: string | undefined;
    outletCode: string | undefined;
    checkInLongitude: string | undefined;
    checkInLastitude: string | undefined;
    checkInDistant: string | undefined;
    checkInImageLink: string | undefined;
    checkInTime: moment.Moment | undefined;
    checkOutLongitude: string | undefined;
    checkOutLastitude: string | undefined;
    checkOutDistant: string | undefined;
    checkOutImageLink: string | undefined;
    checkOutTime: moment.Moment | undefined;
    checkListResultId: string | undefined;
    rate: number | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfGetBeatPlanResultForView implements IPagedResultDtoOfGetBeatPlanResultForView {
    totalCount!: number | undefined;
    items!: GetBeatPlanResultForView[] | undefined;

    constructor(data?: IPagedResultDtoOfGetBeatPlanResultForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetBeatPlanResultForView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetBeatPlanResultForView {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetBeatPlanResultForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetBeatPlanResultForView {
    totalCount: number | undefined;
    items: GetBeatPlanResultForView[] | undefined;
}

export class GetBeatPlanResultForView implements IGetBeatPlanResultForView {
    beatPlanResult!: BeatPlanResultDto | undefined;

    constructor(data?: IGetBeatPlanResultForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.beatPlanResult = data["beatPlanResult"] ? BeatPlanResultDto.fromJS(data["beatPlanResult"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetBeatPlanResultForView {
        data = typeof data === 'object' ? data : {};
        let result = new GetBeatPlanResultForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["beatPlanResult"] = this.beatPlanResult ? this.beatPlanResult.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetBeatPlanResultForView {
    beatPlanResult: BeatPlanResultDto | undefined;
}

export class BeatPlanResultDto implements IBeatPlanResultDto {
    beatPlanCode!: string | undefined;
    beatPlanName!: string | undefined;
    salemanCode!: string | undefined;
    salemanName!: string | undefined;
    outletCode!: string | undefined;
    checkInLongitude!: string | undefined;
    checkInLastitude!: string | undefined;
    checkInDistant!: string | undefined;
    checkInImageLink!: string | undefined;
    checkInTime!: moment.Moment | undefined;
    checkOutLongitude!: string | undefined;
    checkOutLastitude!: string | undefined;
    checkOutDistant!: string | undefined;
    checkOutImageLink!: string | undefined;
    checkOutTime!: moment.Moment | undefined;
    checkListResultId!: string | undefined;
    rate!: number | undefined;
    outletName!: string | undefined;
    outletType!: string | undefined;
    lng!: string | undefined;
    lat!: string | undefined;
    isDeleted!: boolean | undefined;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: moment.Moment | undefined;
    creatorUserId!: number | undefined;
    id!: number | undefined;

    constructor(data?: IBeatPlanResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.beatPlanCode = data["beatPlanCode"];
            this.beatPlanName = data["beatPlanName"];
            this.salemanCode = data["salemanCode"];
            this.salemanName = data["salemanName"];
            this.outletCode = data["outletCode"];
            this.checkInLongitude = data["checkInLongitude"];
            this.checkInLastitude = data["checkInLastitude"];
            this.checkInDistant = data["checkInDistant"];
            this.checkInImageLink = data["checkInImageLink"];
            this.checkInTime = data["checkInTime"] ? moment(data["checkInTime"].toString()) : <any>undefined;
            this.checkOutLongitude = data["checkOutLongitude"];
            this.checkOutLastitude = data["checkOutLastitude"];
            this.checkOutDistant = data["checkOutDistant"];
            this.checkOutImageLink = data["checkOutImageLink"];
            this.checkOutTime = data["checkOutTime"] ? moment(data["checkOutTime"].toString()) : <any>undefined;
            this.checkListResultId = data["checkListResultId"];
            this.rate = data["rate"];
            this.outletName = data["outletName"];
            this.outletType = data["outletType"];
            this.lng = data["lng"];
            this.lat = data["lat"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): BeatPlanResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new BeatPlanResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["beatPlanCode"] = this.beatPlanCode;
        data["beatPlanName"] = this.beatPlanName;
        data["salemanCode"] = this.salemanCode;
        data["salemanName"] = this.salemanName;
        data["outletCode"] = this.outletCode;
        data["checkInLongitude"] = this.checkInLongitude;
        data["checkInLastitude"] = this.checkInLastitude;
        data["checkInDistant"] = this.checkInDistant;
        data["checkInImageLink"] = this.checkInImageLink;
        data["checkInTime"] = this.checkInTime ? this.checkInTime.toISOString() : <any>undefined;
        data["checkOutLongitude"] = this.checkOutLongitude;
        data["checkOutLastitude"] = this.checkOutLastitude;
        data["checkOutDistant"] = this.checkOutDistant;
        data["checkOutImageLink"] = this.checkOutImageLink;
        data["checkOutTime"] = this.checkOutTime ? this.checkOutTime.toISOString() : <any>undefined;
        data["checkListResultId"] = this.checkListResultId;
        data["rate"] = this.rate;
        data["outletName"] = this.outletName;
        data["outletType"] = this.outletType;
        data["lng"] = this.lng;
        data["lat"] = this.lat;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IBeatPlanResultDto {
    beatPlanCode: string | undefined;
    beatPlanName: string | undefined;
    salemanCode: string | undefined;
    salemanName: string | undefined;
    outletCode: string | undefined;
    checkInLongitude: string | undefined;
    checkInLastitude: string | undefined;
    checkInDistant: string | undefined;
    checkInImageLink: string | undefined;
    checkInTime: moment.Moment | undefined;
    checkOutLongitude: string | undefined;
    checkOutLastitude: string | undefined;
    checkOutDistant: string | undefined;
    checkOutImageLink: string | undefined;
    checkOutTime: moment.Moment | undefined;
    checkListResultId: string | undefined;
    rate: number | undefined;
    outletName: string | undefined;
    outletType: string | undefined;
    lng: string | undefined;
    lat: string | undefined;
    isDeleted: boolean | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfGetBrandForView implements IPagedResultDtoOfGetBrandForView {
    totalCount!: number | undefined;
    items!: GetBrandForView[] | undefined;

    constructor(data?: IPagedResultDtoOfGetBrandForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetBrandForView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetBrandForView {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetBrandForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetBrandForView {
    totalCount: number | undefined;
    items: GetBrandForView[] | undefined;
}

export class GetBrandForView implements IGetBrandForView {
    brand!: BrandDto | undefined;

    constructor(data?: IGetBrandForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.brand = data["brand"] ? BrandDto.fromJS(data["brand"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetBrandForView {
        data = typeof data === 'object' ? data : {};
        let result = new GetBrandForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["brand"] = this.brand ? this.brand.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetBrandForView {
    brand: BrandDto | undefined;
}

export class BrandDto implements IBrandDto {
    brandCode!: string | undefined;
    brandName!: string | undefined;
    description!: string | undefined;
    status!: string | undefined;
    ordinal!: number | undefined;
    lastModificationTime!: moment.Moment | undefined;
    level!: number | undefined;
    id!: number | undefined;

    constructor(data?: IBrandDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.brandCode = data["brandCode"];
            this.brandName = data["brandName"];
            this.description = data["description"];
            this.status = data["status"];
            this.ordinal = data["ordinal"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.level = data["level"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): BrandDto {
        data = typeof data === 'object' ? data : {};
        let result = new BrandDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["brandCode"] = this.brandCode;
        data["brandName"] = this.brandName;
        data["description"] = this.description;
        data["status"] = this.status;
        data["ordinal"] = this.ordinal;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["level"] = this.level;
        data["id"] = this.id;
        return data;
    }
}

export interface IBrandDto {
    brandCode: string | undefined;
    brandName: string | undefined;
    description: string | undefined;
    status: string | undefined;
    ordinal: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    level: number | undefined;
    id: number | undefined;
}

export class GetBrandForEditOutput implements IGetBrandForEditOutput {
    brand!: CreateOrEditBrandDto | undefined;

    constructor(data?: IGetBrandForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.brand = data["brand"] ? CreateOrEditBrandDto.fromJS(data["brand"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetBrandForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetBrandForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["brand"] = this.brand ? this.brand.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetBrandForEditOutput {
    brand: CreateOrEditBrandDto | undefined;
}

export class CreateOrEditBrandDto implements ICreateOrEditBrandDto {
    brandCode!: string | undefined;
    brandName!: string | undefined;
    description!: string | undefined;
    status!: string | undefined;
    ordinal!: number | undefined;
    level!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditBrandDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.brandCode = data["brandCode"];
            this.brandName = data["brandName"];
            this.description = data["description"];
            this.status = data["status"];
            this.ordinal = data["ordinal"];
            this.level = data["level"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditBrandDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditBrandDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["brandCode"] = this.brandCode;
        data["brandName"] = this.brandName;
        data["description"] = this.description;
        data["status"] = this.status;
        data["ordinal"] = this.ordinal;
        data["level"] = this.level;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditBrandDto {
    brandCode: string | undefined;
    brandName: string | undefined;
    description: string | undefined;
    status: string | undefined;
    ordinal: number | undefined;
    level: number | undefined;
    id: number | undefined;
}

export class RevenueHistoryDtoForView implements IRevenueHistoryDtoForView {
    listRevenueHistories!: RevenueHistoryDto[] | undefined;

    constructor(data?: IRevenueHistoryDtoForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["listRevenueHistories"] && data["listRevenueHistories"].constructor === Array) {
                this.listRevenueHistories = [];
                for (let item of data["listRevenueHistories"])
                    this.listRevenueHistories.push(RevenueHistoryDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RevenueHistoryDtoForView {
        data = typeof data === 'object' ? data : {};
        let result = new RevenueHistoryDtoForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.listRevenueHistories && this.listRevenueHistories.constructor === Array) {
            data["listRevenueHistories"] = [];
            for (let item of this.listRevenueHistories)
                data["listRevenueHistories"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRevenueHistoryDtoForView {
    listRevenueHistories: RevenueHistoryDto[] | undefined;
}

export class RevenueHistoryDto implements IRevenueHistoryDto {
    brandCode!: string | undefined;
    brandName!: string | undefined;
    revenues!: ItemRevenue[] | undefined;

    constructor(data?: IRevenueHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.brandCode = data["brandCode"];
            this.brandName = data["brandName"];
            if (data["revenues"] && data["revenues"].constructor === Array) {
                this.revenues = [];
                for (let item of data["revenues"])
                    this.revenues.push(ItemRevenue.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RevenueHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new RevenueHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["brandCode"] = this.brandCode;
        data["brandName"] = this.brandName;
        if (this.revenues && this.revenues.constructor === Array) {
            data["revenues"] = [];
            for (let item of this.revenues)
                data["revenues"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRevenueHistoryDto {
    brandCode: string | undefined;
    brandName: string | undefined;
    revenues: ItemRevenue[] | undefined;
}

export class ItemRevenue implements IItemRevenue {
    ordinal!: number | undefined;
    target!: number | undefined;
    actual!: number | undefined;

    constructor(data?: IItemRevenue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.ordinal = data["ordinal"];
            this.target = data["target"];
            this.actual = data["actual"];
        }
    }

    static fromJS(data: any): ItemRevenue {
        data = typeof data === 'object' ? data : {};
        let result = new ItemRevenue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ordinal"] = this.ordinal;
        data["target"] = this.target;
        data["actual"] = this.actual;
        return data;
    }
}

export interface IItemRevenue {
    ordinal: number | undefined;
    target: number | undefined;
    actual: number | undefined;
}

export class PagedResultDtoOfGetBrandActualForView implements IPagedResultDtoOfGetBrandActualForView {
    totalCount!: number | undefined;
    items!: GetBrandActualForView[] | undefined;

    constructor(data?: IPagedResultDtoOfGetBrandActualForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetBrandActualForView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetBrandActualForView {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetBrandActualForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetBrandActualForView {
    totalCount: number | undefined;
    items: GetBrandActualForView[] | undefined;
}

export class GetBrandActualForView implements IGetBrandActualForView {
    brandActual!: BrandActualDto | undefined;
    brand!: BrandDto | undefined;

    constructor(data?: IGetBrandActualForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.brandActual = data["brandActual"] ? BrandActualDto.fromJS(data["brandActual"]) : <any>undefined;
            this.brand = data["brand"] ? BrandDto.fromJS(data["brand"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetBrandActualForView {
        data = typeof data === 'object' ? data : {};
        let result = new GetBrandActualForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["brandActual"] = this.brandActual ? this.brandActual.toJSON() : <any>undefined;
        data["brand"] = this.brand ? this.brand.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetBrandActualForView {
    brandActual: BrandActualDto | undefined;
    brand: BrandDto | undefined;
}

export class BrandActualDto implements IBrandActualDto {
    memberCode!: string | undefined;
    year!: number | undefined;
    month!: number | undefined;
    salesAmount!: number | undefined;
    brandCode!: string | undefined;
    name!: string | undefined;
    lastModificationTime!: moment.Moment | undefined;
    salesTarget!: number | undefined;
    id!: number | undefined;

    constructor(data?: IBrandActualDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberCode = data["memberCode"];
            this.year = data["year"];
            this.month = data["month"];
            this.salesAmount = data["salesAmount"];
            this.brandCode = data["brandCode"];
            this.name = data["name"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.salesTarget = data["salesTarget"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): BrandActualDto {
        data = typeof data === 'object' ? data : {};
        let result = new BrandActualDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberCode"] = this.memberCode;
        data["year"] = this.year;
        data["month"] = this.month;
        data["salesAmount"] = this.salesAmount;
        data["brandCode"] = this.brandCode;
        data["name"] = this.name;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["salesTarget"] = this.salesTarget;
        data["id"] = this.id;
        return data;
    }
}

export interface IBrandActualDto {
    memberCode: string | undefined;
    year: number | undefined;
    month: number | undefined;
    salesAmount: number | undefined;
    brandCode: string | undefined;
    name: string | undefined;
    lastModificationTime: moment.Moment | undefined;
    salesTarget: number | undefined;
    id: number | undefined;
}

export class GetBrandActualForEditOutput implements IGetBrandActualForEditOutput {
    brandActual!: CreateOrEditBrandActualDto | undefined;

    constructor(data?: IGetBrandActualForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.brandActual = data["brandActual"] ? CreateOrEditBrandActualDto.fromJS(data["brandActual"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetBrandActualForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetBrandActualForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["brandActual"] = this.brandActual ? this.brandActual.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetBrandActualForEditOutput {
    brandActual: CreateOrEditBrandActualDto | undefined;
}

export class CreateOrEditBrandActualDto implements ICreateOrEditBrandActualDto {
    memberCode!: string | undefined;
    year!: number | undefined;
    month!: number | undefined;
    salesAmount!: number | undefined;
    brandCode!: string | undefined;
    salesTarget!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditBrandActualDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberCode = data["memberCode"];
            this.year = data["year"];
            this.month = data["month"];
            this.salesAmount = data["salesAmount"];
            this.brandCode = data["brandCode"];
            this.salesTarget = data["salesTarget"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditBrandActualDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditBrandActualDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberCode"] = this.memberCode;
        data["year"] = this.year;
        data["month"] = this.month;
        data["salesAmount"] = this.salesAmount;
        data["brandCode"] = this.brandCode;
        data["salesTarget"] = this.salesTarget;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditBrandActualDto {
    memberCode: string | undefined;
    year: number | undefined;
    month: number | undefined;
    salesAmount: number | undefined;
    brandCode: string | undefined;
    salesTarget: number | undefined;
    id: number | undefined;
}

export class SalesTrackingBrandActualInterfaceEventData implements ISalesTrackingBrandActualInterfaceEventData {
    memberCode!: string | undefined;
    brandCode!: string | undefined;
    month!: number | undefined;
    year!: number | undefined;
    salesAmount!: number | undefined;
    tenantId!: number | undefined;
    userId!: number | undefined;
    maxParallelism!: number | undefined;
    numberOfWorkers!: number | undefined;
    eventTime!: moment.Moment | undefined;
    eventSource!: any | undefined;

    constructor(data?: ISalesTrackingBrandActualInterfaceEventData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberCode = data["memberCode"];
            this.brandCode = data["brandCode"];
            this.month = data["month"];
            this.year = data["year"];
            this.salesAmount = data["salesAmount"];
            this.tenantId = data["tenantId"];
            this.userId = data["userId"];
            this.maxParallelism = data["maxParallelism"];
            this.numberOfWorkers = data["numberOfWorkers"];
            this.eventTime = data["eventTime"] ? moment(data["eventTime"].toString()) : <any>undefined;
            this.eventSource = data["eventSource"];
        }
    }

    static fromJS(data: any): SalesTrackingBrandActualInterfaceEventData {
        data = typeof data === 'object' ? data : {};
        let result = new SalesTrackingBrandActualInterfaceEventData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberCode"] = this.memberCode;
        data["brandCode"] = this.brandCode;
        data["month"] = this.month;
        data["year"] = this.year;
        data["salesAmount"] = this.salesAmount;
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["maxParallelism"] = this.maxParallelism;
        data["numberOfWorkers"] = this.numberOfWorkers;
        data["eventTime"] = this.eventTime ? this.eventTime.toISOString() : <any>undefined;
        data["eventSource"] = this.eventSource;
        return data;
    }
}

export interface ISalesTrackingBrandActualInterfaceEventData {
    memberCode: string | undefined;
    brandCode: string | undefined;
    month: number | undefined;
    year: number | undefined;
    salesAmount: number | undefined;
    tenantId: number | undefined;
    userId: number | undefined;
    maxParallelism: number | undefined;
    numberOfWorkers: number | undefined;
    eventTime: moment.Moment | undefined;
    eventSource: any | undefined;
}

export class PagedResultDtoOfGetBrandActualLogForViewDto implements IPagedResultDtoOfGetBrandActualLogForViewDto {
    totalCount!: number | undefined;
    items!: GetBrandActualLogForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetBrandActualLogForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetBrandActualLogForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetBrandActualLogForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetBrandActualLogForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetBrandActualLogForViewDto {
    totalCount: number | undefined;
    items: GetBrandActualLogForViewDto[] | undefined;
}

export class GetBrandActualLogForViewDto implements IGetBrandActualLogForViewDto {
    brandActualLog!: BrandActualLogDto | undefined;

    constructor(data?: IGetBrandActualLogForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.brandActualLog = data["brandActualLog"] ? BrandActualLogDto.fromJS(data["brandActualLog"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetBrandActualLogForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetBrandActualLogForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["brandActualLog"] = this.brandActualLog ? this.brandActualLog.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetBrandActualLogForViewDto {
    brandActualLog: BrandActualLogDto | undefined;
}

export class BrandActualLogDto implements IBrandActualLogDto {
    baselineDate!: moment.Moment | undefined;
    invoiceCode!: string | undefined;
    memberCode!: string | undefined;
    id!: number | undefined;

    constructor(data?: IBrandActualLogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.baselineDate = data["baselineDate"] ? moment(data["baselineDate"].toString()) : <any>undefined;
            this.invoiceCode = data["invoiceCode"];
            this.memberCode = data["memberCode"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): BrandActualLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new BrandActualLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["baselineDate"] = this.baselineDate ? this.baselineDate.toISOString() : <any>undefined;
        data["invoiceCode"] = this.invoiceCode;
        data["memberCode"] = this.memberCode;
        data["id"] = this.id;
        return data;
    }
}

export interface IBrandActualLogDto {
    baselineDate: moment.Moment | undefined;
    invoiceCode: string | undefined;
    memberCode: string | undefined;
    id: number | undefined;
}

export class GetBrandActualLogForEditOutput implements IGetBrandActualLogForEditOutput {
    brandActualLog!: CreateOrEditBrandActualLogDto | undefined;

    constructor(data?: IGetBrandActualLogForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.brandActualLog = data["brandActualLog"] ? CreateOrEditBrandActualLogDto.fromJS(data["brandActualLog"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetBrandActualLogForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetBrandActualLogForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["brandActualLog"] = this.brandActualLog ? this.brandActualLog.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetBrandActualLogForEditOutput {
    brandActualLog: CreateOrEditBrandActualLogDto | undefined;
}

export class CreateOrEditBrandActualLogDto implements ICreateOrEditBrandActualLogDto {
    baselineDate!: moment.Moment | undefined;
    invoiceCode!: string | undefined;
    memberCode!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditBrandActualLogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.baselineDate = data["baselineDate"] ? moment(data["baselineDate"].toString()) : <any>undefined;
            this.invoiceCode = data["invoiceCode"];
            this.memberCode = data["memberCode"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditBrandActualLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditBrandActualLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["baselineDate"] = this.baselineDate ? this.baselineDate.toISOString() : <any>undefined;
        data["invoiceCode"] = this.invoiceCode;
        data["memberCode"] = this.memberCode;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditBrandActualLogDto {
    baselineDate: moment.Moment | undefined;
    invoiceCode: string | undefined;
    memberCode: string | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfGetMasterDetailForViewDto implements IPagedResultDtoOfGetMasterDetailForViewDto {
    totalCount!: number | undefined;
    items!: GetMasterDetailForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetMasterDetailForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetMasterDetailForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetMasterDetailForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetMasterDetailForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetMasterDetailForViewDto {
    totalCount: number | undefined;
    items: GetMasterDetailForViewDto[] | undefined;
}

export class GetMasterDetailForViewDto implements IGetMasterDetailForViewDto {
    masterDetail!: MasterDetailDto | undefined;

    constructor(data?: IGetMasterDetailForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.masterDetail = data["masterDetail"] ? MasterDetailDto.fromJS(data["masterDetail"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetMasterDetailForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetMasterDetailForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["masterDetail"] = this.masterDetail ? this.masterDetail.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetMasterDetailForViewDto {
    masterDetail: MasterDetailDto | undefined;
}

export class MasterDetailDto implements IMasterDetailDto {
    masterCode!: string | undefined;
    detailCode!: string | undefined;
    parentCode!: string | undefined;
    nodePath!: string | undefined;
    ordinal!: number | undefined;
    status!: string | undefined;
    detailValueNumber!: number | undefined;
    level!: number | undefined;
    detailValue!: string | undefined;
    detailValueUnSign!: string | undefined;
    detailImage!: string | undefined;
    creationTime!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;
    id!: number | undefined;
    brand!: string | undefined;

    constructor(data?: IMasterDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.masterCode = data["masterCode"];
            this.detailCode = data["detailCode"];
            this.parentCode = data["parentCode"];
            this.nodePath = data["nodePath"];
            this.ordinal = data["ordinal"];
            this.status = data["status"];
            this.detailValueNumber = data["detailValueNumber"];
            this.level = data["level"];
            this.detailValue = data["detailValue"];
            this.detailValueUnSign = data["detailValueUnSign"];
            this.detailImage = data["detailImage"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.id = data["id"];
            this.brand = data["brand"];
        }
    }

    static fromJS(data: any): MasterDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new MasterDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["masterCode"] = this.masterCode;
        data["detailCode"] = this.detailCode;
        data["parentCode"] = this.parentCode;
        data["nodePath"] = this.nodePath;
        data["ordinal"] = this.ordinal;
        data["status"] = this.status;
        data["detailValueNumber"] = this.detailValueNumber;
        data["level"] = this.level;
        data["detailValue"] = this.detailValue;
        data["detailValueUnSign"] = this.detailValueUnSign;
        data["detailImage"] = this.detailImage;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        data["brand"] = this.brand;
        return data;
    }
}

export interface IMasterDetailDto {
    masterCode: string | undefined;
    detailCode: string | undefined;
    parentCode: string | undefined;
    nodePath: string | undefined;
    ordinal: number | undefined;
    status: string | undefined;
    detailValueNumber: number | undefined;
    level: number | undefined;
    detailValue: string | undefined;
    detailValueUnSign: string | undefined;
    detailImage: string | undefined;
    creationTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    id: number | undefined;
    brand: string | undefined;
}

export class CreateOrEditMasterDetailDto implements ICreateOrEditMasterDetailDto {
    masterCode!: string | undefined;
    detailCode!: string | undefined;
    parentCode!: string | undefined;
    nodePath!: string | undefined;
    ordinal!: number | undefined;
    status!: string | undefined;
    detailValueNumber!: number | undefined;
    level!: number | undefined;
    detailValue!: string | undefined;
    detailValueUnSign!: string | undefined;
    lastModificationTime!: moment.Moment | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditMasterDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.masterCode = data["masterCode"];
            this.detailCode = data["detailCode"];
            this.parentCode = data["parentCode"];
            this.nodePath = data["nodePath"];
            this.ordinal = data["ordinal"];
            this.status = data["status"];
            this.detailValueNumber = data["detailValueNumber"];
            this.level = data["level"];
            this.detailValue = data["detailValue"];
            this.detailValueUnSign = data["detailValueUnSign"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditMasterDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditMasterDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["masterCode"] = this.masterCode;
        data["detailCode"] = this.detailCode;
        data["parentCode"] = this.parentCode;
        data["nodePath"] = this.nodePath;
        data["ordinal"] = this.ordinal;
        data["status"] = this.status;
        data["detailValueNumber"] = this.detailValueNumber;
        data["level"] = this.level;
        data["detailValue"] = this.detailValue;
        data["detailValueUnSign"] = this.detailValueUnSign;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditMasterDetailDto {
    masterCode: string | undefined;
    detailCode: string | undefined;
    parentCode: string | undefined;
    nodePath: string | undefined;
    ordinal: number | undefined;
    status: string | undefined;
    detailValueNumber: number | undefined;
    level: number | undefined;
    detailValue: string | undefined;
    detailValueUnSign: string | undefined;
    lastModificationTime: moment.Moment | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfGetButtonInteractionOverviewForViewDto implements IPagedResultDtoOfGetButtonInteractionOverviewForViewDto {
    totalCount!: number | undefined;
    items!: GetButtonInteractionOverviewForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetButtonInteractionOverviewForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetButtonInteractionOverviewForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetButtonInteractionOverviewForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetButtonInteractionOverviewForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetButtonInteractionOverviewForViewDto {
    totalCount: number | undefined;
    items: GetButtonInteractionOverviewForViewDto[] | undefined;
}

export class GetButtonInteractionOverviewForViewDto implements IGetButtonInteractionOverviewForViewDto {
    buttonInteractionOverview!: ButtonInteractionOverviewDto | undefined;

    constructor(data?: IGetButtonInteractionOverviewForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.buttonInteractionOverview = data["buttonInteractionOverview"] ? ButtonInteractionOverviewDto.fromJS(data["buttonInteractionOverview"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetButtonInteractionOverviewForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetButtonInteractionOverviewForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["buttonInteractionOverview"] = this.buttonInteractionOverview ? this.buttonInteractionOverview.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetButtonInteractionOverviewForViewDto {
    buttonInteractionOverview: ButtonInteractionOverviewDto | undefined;
}

export class ButtonInteractionOverviewDto implements IButtonInteractionOverviewDto {
    year!: number | undefined;
    buttonEvent!: string | undefined;
    totalCountInteraction!: number | undefined;
    calculateDate!: moment.Moment | undefined;
    month!: number | undefined;
    id!: number | undefined;

    constructor(data?: IButtonInteractionOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.year = data["year"];
            this.buttonEvent = data["buttonEvent"];
            this.totalCountInteraction = data["totalCountInteraction"];
            this.calculateDate = data["calculateDate"] ? moment(data["calculateDate"].toString()) : <any>undefined;
            this.month = data["month"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ButtonInteractionOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new ButtonInteractionOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        data["buttonEvent"] = this.buttonEvent;
        data["totalCountInteraction"] = this.totalCountInteraction;
        data["calculateDate"] = this.calculateDate ? this.calculateDate.toISOString() : <any>undefined;
        data["month"] = this.month;
        data["id"] = this.id;
        return data;
    }
}

export interface IButtonInteractionOverviewDto {
    year: number | undefined;
    buttonEvent: string | undefined;
    totalCountInteraction: number | undefined;
    calculateDate: moment.Moment | undefined;
    month: number | undefined;
    id: number | undefined;
}

export class GetButtonInteractionOverviewForEditOutput implements IGetButtonInteractionOverviewForEditOutput {
    buttonInteractionOverview!: CreateOrEditButtonInteractionOverviewDto | undefined;

    constructor(data?: IGetButtonInteractionOverviewForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.buttonInteractionOverview = data["buttonInteractionOverview"] ? CreateOrEditButtonInteractionOverviewDto.fromJS(data["buttonInteractionOverview"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetButtonInteractionOverviewForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetButtonInteractionOverviewForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["buttonInteractionOverview"] = this.buttonInteractionOverview ? this.buttonInteractionOverview.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetButtonInteractionOverviewForEditOutput {
    buttonInteractionOverview: CreateOrEditButtonInteractionOverviewDto | undefined;
}

export class CreateOrEditButtonInteractionOverviewDto implements ICreateOrEditButtonInteractionOverviewDto {
    year!: number | undefined;
    buttonEvent!: string | undefined;
    totalCountInteraction!: number | undefined;
    calculateDate!: moment.Moment | undefined;
    month!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditButtonInteractionOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.year = data["year"];
            this.buttonEvent = data["buttonEvent"];
            this.totalCountInteraction = data["totalCountInteraction"];
            this.calculateDate = data["calculateDate"] ? moment(data["calculateDate"].toString()) : <any>undefined;
            this.month = data["month"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditButtonInteractionOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditButtonInteractionOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        data["buttonEvent"] = this.buttonEvent;
        data["totalCountInteraction"] = this.totalCountInteraction;
        data["calculateDate"] = this.calculateDate ? this.calculateDate.toISOString() : <any>undefined;
        data["month"] = this.month;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditButtonInteractionOverviewDto {
    year: number | undefined;
    buttonEvent: string | undefined;
    totalCountInteraction: number | undefined;
    calculateDate: moment.Moment | undefined;
    month: number | undefined;
    id: number | undefined;
}

export class ListResultDtoOfCacheDto implements IListResultDtoOfCacheDto {
    items!: CacheDto[] | undefined;

    constructor(data?: IListResultDtoOfCacheDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(CacheDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfCacheDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfCacheDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListResultDtoOfCacheDto {
    items: CacheDto[] | undefined;
}

export class CacheDto implements ICacheDto {
    name!: string | undefined;

    constructor(data?: ICacheDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
        }
    }

    static fromJS(data: any): CacheDto {
        data = typeof data === 'object' ? data : {};
        let result = new CacheDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface ICacheDto {
    name: string | undefined;
}

export class EntityDtoOfString implements IEntityDtoOfString {
    id!: string | undefined;

    constructor(data?: IEntityDtoOfString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EntityDtoOfString {
        data = typeof data === 'object' ? data : {};
        let result = new EntityDtoOfString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IEntityDtoOfString {
    id: string | undefined;
}

export class PagedResultDtoOfCampaignResource implements IPagedResultDtoOfCampaignResource {
    totalCount!: number | undefined;
    items!: CampaignResource[] | undefined;

    constructor(data?: IPagedResultDtoOfCampaignResource) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(CampaignResource.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfCampaignResource {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfCampaignResource();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfCampaignResource {
    totalCount: number | undefined;
    items: CampaignResource[] | undefined;
}

export class CampaignResource implements ICampaignResource {
    campaign!: CampaignDTO | undefined;

    constructor(data?: ICampaignResource) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.campaign = data["campaign"] ? CampaignDTO.fromJS(data["campaign"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CampaignResource {
        data = typeof data === 'object' ? data : {};
        let result = new CampaignResource();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["campaign"] = this.campaign ? this.campaign.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICampaignResource {
    campaign: CampaignDTO | undefined;
}

export class CampaignDTO implements ICampaignDTO {
    id!: number | undefined;
    code!: string | undefined;
    name!: string | undefined;
    fromDate!: moment.Moment | undefined;
    toDate!: moment.Moment | undefined;
    description!: string | undefined;
    memberSegment!: string | undefined;
    banner!: string | undefined;
    isActive!: boolean | undefined;
    redemptionFrom!: moment.Moment | undefined;
    redemptionTo!: moment.Moment | undefined;
    isExpired!: boolean | undefined;

    constructor(data?: ICampaignDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.code = data["code"];
            this.name = data["name"];
            this.fromDate = data["fromDate"] ? moment(data["fromDate"].toString()) : <any>undefined;
            this.toDate = data["toDate"] ? moment(data["toDate"].toString()) : <any>undefined;
            this.description = data["description"];
            this.memberSegment = data["memberSegment"];
            this.banner = data["banner"];
            this.isActive = data["isActive"];
            this.redemptionFrom = data["redemptionFrom"] ? moment(data["redemptionFrom"].toString()) : <any>undefined;
            this.redemptionTo = data["redemptionTo"] ? moment(data["redemptionTo"].toString()) : <any>undefined;
            this.isExpired = data["isExpired"];
        }
    }

    static fromJS(data: any): CampaignDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CampaignDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data["description"] = this.description;
        data["memberSegment"] = this.memberSegment;
        data["banner"] = this.banner;
        data["isActive"] = this.isActive;
        data["redemptionFrom"] = this.redemptionFrom ? this.redemptionFrom.toISOString() : <any>undefined;
        data["redemptionTo"] = this.redemptionTo ? this.redemptionTo.toISOString() : <any>undefined;
        data["isExpired"] = this.isExpired;
        return data;
    }
}

export interface ICampaignDTO {
    id: number | undefined;
    code: string | undefined;
    name: string | undefined;
    fromDate: moment.Moment | undefined;
    toDate: moment.Moment | undefined;
    description: string | undefined;
    memberSegment: string | undefined;
    banner: string | undefined;
    isActive: boolean | undefined;
    redemptionFrom: moment.Moment | undefined;
    redemptionTo: moment.Moment | undefined;
    isExpired: boolean | undefined;
}

export class GetCampaignViewForApp implements IGetCampaignViewForApp {
    campaignDTO!: CampaignDTO | undefined;
    totalPoint!: number | undefined;

    constructor(data?: IGetCampaignViewForApp) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.campaignDTO = data["campaignDTO"] ? CampaignDTO.fromJS(data["campaignDTO"]) : <any>undefined;
            this.totalPoint = data["totalPoint"];
        }
    }

    static fromJS(data: any): GetCampaignViewForApp {
        data = typeof data === 'object' ? data : {};
        let result = new GetCampaignViewForApp();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["campaignDTO"] = this.campaignDTO ? this.campaignDTO.toJSON() : <any>undefined;
        data["totalPoint"] = this.totalPoint;
        return data;
    }
}

export interface IGetCampaignViewForApp {
    campaignDTO: CampaignDTO | undefined;
    totalPoint: number | undefined;
}

export class GetCampaignViewForAppDetail implements IGetCampaignViewForAppDetail {
    campaignDTO!: CampaignDTO | undefined;
    rewardItems!: RewardItemDTO[] | undefined;
    totalPoint!: number | undefined;

    constructor(data?: IGetCampaignViewForAppDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.campaignDTO = data["campaignDTO"] ? CampaignDTO.fromJS(data["campaignDTO"]) : <any>undefined;
            if (data["rewardItems"] && data["rewardItems"].constructor === Array) {
                this.rewardItems = [];
                for (let item of data["rewardItems"])
                    this.rewardItems.push(RewardItemDTO.fromJS(item));
            }
            this.totalPoint = data["totalPoint"];
        }
    }

    static fromJS(data: any): GetCampaignViewForAppDetail {
        data = typeof data === 'object' ? data : {};
        let result = new GetCampaignViewForAppDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["campaignDTO"] = this.campaignDTO ? this.campaignDTO.toJSON() : <any>undefined;
        if (this.rewardItems && this.rewardItems.constructor === Array) {
            data["rewardItems"] = [];
            for (let item of this.rewardItems)
                data["rewardItems"].push(item.toJSON());
        }
        data["totalPoint"] = this.totalPoint;
        return data;
    }
}

export interface IGetCampaignViewForAppDetail {
    campaignDTO: CampaignDTO | undefined;
    rewardItems: RewardItemDTO[] | undefined;
    totalPoint: number | undefined;
}

export class RewardItemDTO implements IRewardItemDTO {
    id!: number | undefined;
    code!: string | undefined;
    name!: string | undefined;
    imageUrl!: string | undefined;
    pointCost!: number | undefined;
    quantity!: number | undefined;

    constructor(data?: IRewardItemDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.code = data["code"];
            this.name = data["name"];
            this.imageUrl = data["imageUrl"];
            this.pointCost = data["pointCost"];
            this.quantity = data["quantity"];
        }
    }

    static fromJS(data: any): RewardItemDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RewardItemDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        data["imageUrl"] = this.imageUrl;
        data["pointCost"] = this.pointCost;
        data["quantity"] = this.quantity;
        return data;
    }
}

export interface IRewardItemDTO {
    id: number | undefined;
    code: string | undefined;
    name: string | undefined;
    imageUrl: string | undefined;
    pointCost: number | undefined;
    quantity: number | undefined;
}

export class PagedResultDtoOfGetCampaignConditionForViewDto implements IPagedResultDtoOfGetCampaignConditionForViewDto {
    totalCount!: number | undefined;
    items!: GetCampaignConditionForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetCampaignConditionForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetCampaignConditionForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetCampaignConditionForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetCampaignConditionForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetCampaignConditionForViewDto {
    totalCount: number | undefined;
    items: GetCampaignConditionForViewDto[] | undefined;
}

export class GetCampaignConditionForViewDto implements IGetCampaignConditionForViewDto {
    campaignCondition!: CampaignConditionDto | undefined;
    productName!: string | undefined;

    constructor(data?: IGetCampaignConditionForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.campaignCondition = data["campaignCondition"] ? CampaignConditionDto.fromJS(data["campaignCondition"]) : <any>undefined;
            this.productName = data["productName"];
        }
    }

    static fromJS(data: any): GetCampaignConditionForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCampaignConditionForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["campaignCondition"] = this.campaignCondition ? this.campaignCondition.toJSON() : <any>undefined;
        data["productName"] = this.productName;
        return data;
    }
}

export interface IGetCampaignConditionForViewDto {
    campaignCondition: CampaignConditionDto | undefined;
    productName: string | undefined;
}

export class CampaignConditionDto implements ICampaignConditionDto {
    campaignID!: number | undefined;
    productID!: number | undefined;
    requireQty!: number | undefined;
    requireAmo!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICampaignConditionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.campaignID = data["campaignID"];
            this.productID = data["productID"];
            this.requireQty = data["requireQty"];
            this.requireAmo = data["requireAmo"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CampaignConditionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CampaignConditionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["campaignID"] = this.campaignID;
        data["productID"] = this.productID;
        data["requireQty"] = this.requireQty;
        data["requireAmo"] = this.requireAmo;
        data["id"] = this.id;
        return data;
    }
}

export interface ICampaignConditionDto {
    campaignID: number | undefined;
    productID: number | undefined;
    requireQty: number | undefined;
    requireAmo: number | undefined;
    id: number | undefined;
}

export class GetCampaignConditionForEditOutput implements IGetCampaignConditionForEditOutput {
    campaignCondition!: CreateOrEditCampaignConditionDto | undefined;

    constructor(data?: IGetCampaignConditionForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.campaignCondition = data["campaignCondition"] ? CreateOrEditCampaignConditionDto.fromJS(data["campaignCondition"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCampaignConditionForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetCampaignConditionForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["campaignCondition"] = this.campaignCondition ? this.campaignCondition.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetCampaignConditionForEditOutput {
    campaignCondition: CreateOrEditCampaignConditionDto | undefined;
}

export class CreateOrEditCampaignConditionDto implements ICreateOrEditCampaignConditionDto {
    campaignID!: number | undefined;
    productID!: number | undefined;
    requireQty!: number | undefined;
    requireAmo!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditCampaignConditionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.campaignID = data["campaignID"];
            this.productID = data["productID"];
            this.requireQty = data["requireQty"];
            this.requireAmo = data["requireAmo"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditCampaignConditionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditCampaignConditionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["campaignID"] = this.campaignID;
        data["productID"] = this.productID;
        data["requireQty"] = this.requireQty;
        data["requireAmo"] = this.requireAmo;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditCampaignConditionDto {
    campaignID: number | undefined;
    productID: number | undefined;
    requireQty: number | undefined;
    requireAmo: number | undefined;
    id: number | undefined;
}

export class CampaignManagementFileDto implements ICampaignManagementFileDto {
    fileName!: string;
    fileType!: string;
    fileToken!: string;

    constructor(data?: ICampaignManagementFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.fileName = data["fileName"];
            this.fileType = data["fileType"];
            this.fileToken = data["fileToken"];
        }
    }

    static fromJS(data: any): CampaignManagementFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new CampaignManagementFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["fileType"] = this.fileType;
        data["fileToken"] = this.fileToken;
        return data;
    }
}

export interface ICampaignManagementFileDto {
    fileName: string;
    fileType: string;
    fileToken: string;
}

export class PagedResultDtoOfGetCampaignInfoForViewDto implements IPagedResultDtoOfGetCampaignInfoForViewDto {
    totalCount!: number | undefined;
    items!: GetCampaignInfoForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetCampaignInfoForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetCampaignInfoForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetCampaignInfoForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetCampaignInfoForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetCampaignInfoForViewDto {
    totalCount: number | undefined;
    items: GetCampaignInfoForViewDto[] | undefined;
}

export class GetCampaignInfoForViewDto implements IGetCampaignInfoForViewDto {
    campaignInfo!: CampaignInfoDto | undefined;

    constructor(data?: IGetCampaignInfoForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.campaignInfo = data["campaignInfo"] ? CampaignInfoDto.fromJS(data["campaignInfo"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCampaignInfoForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCampaignInfoForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["campaignInfo"] = this.campaignInfo ? this.campaignInfo.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetCampaignInfoForViewDto {
    campaignInfo: CampaignInfoDto | undefined;
}

export class CampaignInfoDto implements ICampaignInfoDto {
    campaignName!: string | undefined;
    fromDate!: moment.Moment | undefined;
    toDate!: moment.Moment | undefined;
    status!: string | undefined;
    description!: string | undefined;
    address!: string | undefined;
    lng!: string | undefined;
    lat!: string | undefined;
    campaignType!: string | undefined;
    budget!: number | undefined;
    numberOfLead!: number | undefined;
    campaignCode!: string | undefined;
    campaignNameUnSign!: string | undefined;
    creationTime!: moment.Moment | undefined;
    id!: number | undefined;

    constructor(data?: ICampaignInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.campaignName = data["campaignName"];
            this.fromDate = data["fromDate"] ? moment(data["fromDate"].toString()) : <any>undefined;
            this.toDate = data["toDate"] ? moment(data["toDate"].toString()) : <any>undefined;
            this.status = data["status"];
            this.description = data["description"];
            this.address = data["address"];
            this.lng = data["lng"];
            this.lat = data["lat"];
            this.campaignType = data["campaignType"];
            this.budget = data["budget"];
            this.numberOfLead = data["numberOfLead"];
            this.campaignCode = data["campaignCode"];
            this.campaignNameUnSign = data["campaignNameUnSign"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CampaignInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new CampaignInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["campaignName"] = this.campaignName;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["description"] = this.description;
        data["address"] = this.address;
        data["lng"] = this.lng;
        data["lat"] = this.lat;
        data["campaignType"] = this.campaignType;
        data["budget"] = this.budget;
        data["numberOfLead"] = this.numberOfLead;
        data["campaignCode"] = this.campaignCode;
        data["campaignNameUnSign"] = this.campaignNameUnSign;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface ICampaignInfoDto {
    campaignName: string | undefined;
    fromDate: moment.Moment | undefined;
    toDate: moment.Moment | undefined;
    status: string | undefined;
    description: string | undefined;
    address: string | undefined;
    lng: string | undefined;
    lat: string | undefined;
    campaignType: string | undefined;
    budget: number | undefined;
    numberOfLead: number | undefined;
    campaignCode: string | undefined;
    campaignNameUnSign: string | undefined;
    creationTime: moment.Moment | undefined;
    id: number | undefined;
}

export class GetCampaignInfoForEditOutput implements IGetCampaignInfoForEditOutput {
    campaignInfo!: CreateOrEditCampaignInfoDto | undefined;

    constructor(data?: IGetCampaignInfoForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.campaignInfo = data["campaignInfo"] ? CreateOrEditCampaignInfoDto.fromJS(data["campaignInfo"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCampaignInfoForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetCampaignInfoForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["campaignInfo"] = this.campaignInfo ? this.campaignInfo.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetCampaignInfoForEditOutput {
    campaignInfo: CreateOrEditCampaignInfoDto | undefined;
}

export class CreateOrEditCampaignInfoDto implements ICreateOrEditCampaignInfoDto {
    campaignName!: string | undefined;
    fromDate!: moment.Moment | undefined;
    toDate!: moment.Moment | undefined;
    status!: string | undefined;
    description!: string | undefined;
    address!: string | undefined;
    lng!: string | undefined;
    lat!: string | undefined;
    campaignType!: string | undefined;
    budget!: number | undefined;
    numberOfLead!: number | undefined;
    campaignCode!: string | undefined;
    campaignNameUnSign!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditCampaignInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.campaignName = data["campaignName"];
            this.fromDate = data["fromDate"] ? moment(data["fromDate"].toString()) : <any>undefined;
            this.toDate = data["toDate"] ? moment(data["toDate"].toString()) : <any>undefined;
            this.status = data["status"];
            this.description = data["description"];
            this.address = data["address"];
            this.lng = data["lng"];
            this.lat = data["lat"];
            this.campaignType = data["campaignType"];
            this.budget = data["budget"];
            this.numberOfLead = data["numberOfLead"];
            this.campaignCode = data["campaignCode"];
            this.campaignNameUnSign = data["campaignNameUnSign"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditCampaignInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditCampaignInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["campaignName"] = this.campaignName;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["description"] = this.description;
        data["address"] = this.address;
        data["lng"] = this.lng;
        data["lat"] = this.lat;
        data["campaignType"] = this.campaignType;
        data["budget"] = this.budget;
        data["numberOfLead"] = this.numberOfLead;
        data["campaignCode"] = this.campaignCode;
        data["campaignNameUnSign"] = this.campaignNameUnSign;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditCampaignInfoDto {
    campaignName: string | undefined;
    fromDate: moment.Moment | undefined;
    toDate: moment.Moment | undefined;
    status: string | undefined;
    description: string | undefined;
    address: string | undefined;
    lng: string | undefined;
    lat: string | undefined;
    campaignType: string | undefined;
    budget: number | undefined;
    numberOfLead: number | undefined;
    campaignCode: string | undefined;
    campaignNameUnSign: string | undefined;
    id: number | undefined;
}

export class MessageResultCampaignManagement implements IMessageResultCampaignManagement {
    isSuccess!: boolean | undefined;
    errors!: MessageErrorCampaignManagement[] | undefined;

    constructor(data?: IMessageResultCampaignManagement) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isSuccess = data["isSuccess"];
            if (data["errors"] && data["errors"].constructor === Array) {
                this.errors = [];
                for (let item of data["errors"])
                    this.errors.push(MessageErrorCampaignManagement.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MessageResultCampaignManagement {
        data = typeof data === 'object' ? data : {};
        let result = new MessageResultCampaignManagement();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        if (this.errors && this.errors.constructor === Array) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMessageResultCampaignManagement {
    isSuccess: boolean | undefined;
    errors: MessageErrorCampaignManagement[] | undefined;
}

export class MessageErrorCampaignManagement implements IMessageErrorCampaignManagement {
    message!: string | undefined;
    propertyName!: string | undefined;
    count!: number | undefined;

    constructor(data?: IMessageErrorCampaignManagement) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.message = data["message"];
            this.propertyName = data["propertyName"];
            this.count = data["count"];
        }
    }

    static fromJS(data: any): MessageErrorCampaignManagement {
        data = typeof data === 'object' ? data : {};
        let result = new MessageErrorCampaignManagement();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["propertyName"] = this.propertyName;
        data["count"] = this.count;
        return data;
    }
}

export interface IMessageErrorCampaignManagement {
    message: string | undefined;
    propertyName: string | undefined;
    count: number | undefined;
}

export class PagedResultDtoOfCampaignManagementDTO implements IPagedResultDtoOfCampaignManagementDTO {
    totalCount!: number | undefined;
    items!: CampaignManagementDTO[] | undefined;

    constructor(data?: IPagedResultDtoOfCampaignManagementDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(CampaignManagementDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfCampaignManagementDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfCampaignManagementDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfCampaignManagementDTO {
    totalCount: number | undefined;
    items: CampaignManagementDTO[] | undefined;
}

export class CampaignManagementDTO implements ICampaignManagementDTO {
    id!: number | undefined;
    code!: string | undefined;
    name!: string | undefined;
    fromDate!: moment.Moment | undefined;
    toDate!: moment.Moment | undefined;
    description!: string | undefined;
    memberSegment!: string | undefined;
    banner!: string | undefined;
    isActive!: boolean | undefined;
    redemptionFrom!: moment.Moment | undefined;
    redemptionTo!: moment.Moment | undefined;
    termsCondition!: string | undefined;
    isShowDelete!: boolean | undefined;
    allowChangeReward!: boolean | undefined;

    constructor(data?: ICampaignManagementDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.code = data["code"];
            this.name = data["name"];
            this.fromDate = data["fromDate"] ? moment(data["fromDate"].toString()) : <any>undefined;
            this.toDate = data["toDate"] ? moment(data["toDate"].toString()) : <any>undefined;
            this.description = data["description"];
            this.memberSegment = data["memberSegment"];
            this.banner = data["banner"];
            this.isActive = data["isActive"];
            this.redemptionFrom = data["redemptionFrom"] ? moment(data["redemptionFrom"].toString()) : <any>undefined;
            this.redemptionTo = data["redemptionTo"] ? moment(data["redemptionTo"].toString()) : <any>undefined;
            this.termsCondition = data["termsCondition"];
            this.isShowDelete = data["isShowDelete"];
            this.allowChangeReward = data["allowChangeReward"];
        }
    }

    static fromJS(data: any): CampaignManagementDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CampaignManagementDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data["description"] = this.description;
        data["memberSegment"] = this.memberSegment;
        data["banner"] = this.banner;
        data["isActive"] = this.isActive;
        data["redemptionFrom"] = this.redemptionFrom ? this.redemptionFrom.toISOString() : <any>undefined;
        data["redemptionTo"] = this.redemptionTo ? this.redemptionTo.toISOString() : <any>undefined;
        data["termsCondition"] = this.termsCondition;
        data["isShowDelete"] = this.isShowDelete;
        data["allowChangeReward"] = this.allowChangeReward;
        return data;
    }
}

export interface ICampaignManagementDTO {
    id: number | undefined;
    code: string | undefined;
    name: string | undefined;
    fromDate: moment.Moment | undefined;
    toDate: moment.Moment | undefined;
    description: string | undefined;
    memberSegment: string | undefined;
    banner: string | undefined;
    isActive: boolean | undefined;
    redemptionFrom: moment.Moment | undefined;
    redemptionTo: moment.Moment | undefined;
    termsCondition: string | undefined;
    isShowDelete: boolean | undefined;
    allowChangeReward: boolean | undefined;
}

export class CreateOrEditCampaignManagementDto implements ICreateOrEditCampaignManagementDto {
    code!: string;
    name!: string;
    fromDate!: moment.Moment;
    toDate!: moment.Moment;
    description!: string;
    memberSegment!: string;
    banner!: string | undefined;
    isActive!: boolean | undefined;
    redemptionFrom!: moment.Moment;
    redemptionTo!: moment.Moment;
    termsCondition!: string;
    rewardList!: CampaignRewardItemForListDto[];
    fromDateNumber!: number | undefined;
    toDateNumber!: number | undefined;
    redemptionFromNumber!: number | undefined;
    redemptionToNumber!: number | undefined;
    id!: number | undefined;
    allowChangeReward!: boolean | undefined;

    constructor(data?: ICreateOrEditCampaignManagementDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.rewardList = [];
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.name = data["name"];
            this.fromDate = data["fromDate"] ? moment(data["fromDate"].toString()) : <any>undefined;
            this.toDate = data["toDate"] ? moment(data["toDate"].toString()) : <any>undefined;
            this.description = data["description"];
            this.memberSegment = data["memberSegment"];
            this.banner = data["banner"];
            this.isActive = data["isActive"];
            this.redemptionFrom = data["redemptionFrom"] ? moment(data["redemptionFrom"].toString()) : <any>undefined;
            this.redemptionTo = data["redemptionTo"] ? moment(data["redemptionTo"].toString()) : <any>undefined;
            this.termsCondition = data["termsCondition"];
            if (data["rewardList"] && data["rewardList"].constructor === Array) {
                this.rewardList = [];
                for (let item of data["rewardList"])
                    this.rewardList.push(CampaignRewardItemForListDto.fromJS(item));
            }
            this.fromDateNumber = data["fromDateNumber"];
            this.toDateNumber = data["toDateNumber"];
            this.redemptionFromNumber = data["redemptionFromNumber"];
            this.redemptionToNumber = data["redemptionToNumber"];
            this.id = data["id"];
            this.allowChangeReward = data["allowChangeReward"];
        }
    }

    static fromJS(data: any): CreateOrEditCampaignManagementDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditCampaignManagementDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data["description"] = this.description;
        data["memberSegment"] = this.memberSegment;
        data["banner"] = this.banner;
        data["isActive"] = this.isActive;
        data["redemptionFrom"] = this.redemptionFrom ? this.redemptionFrom.toISOString() : <any>undefined;
        data["redemptionTo"] = this.redemptionTo ? this.redemptionTo.toISOString() : <any>undefined;
        data["termsCondition"] = this.termsCondition;
        if (this.rewardList && this.rewardList.constructor === Array) {
            data["rewardList"] = [];
            for (let item of this.rewardList)
                data["rewardList"].push(item.toJSON());
        }
        data["fromDateNumber"] = this.fromDateNumber;
        data["toDateNumber"] = this.toDateNumber;
        data["redemptionFromNumber"] = this.redemptionFromNumber;
        data["redemptionToNumber"] = this.redemptionToNumber;
        data["id"] = this.id;
        data["allowChangeReward"] = this.allowChangeReward;
        return data;
    }
}

export interface ICreateOrEditCampaignManagementDto {
    code: string;
    name: string;
    fromDate: moment.Moment;
    toDate: moment.Moment;
    description: string;
    memberSegment: string;
    banner: string | undefined;
    isActive: boolean | undefined;
    redemptionFrom: moment.Moment;
    redemptionTo: moment.Moment;
    termsCondition: string;
    rewardList: CampaignRewardItemForListDto[];
    fromDateNumber: number | undefined;
    toDateNumber: number | undefined;
    redemptionFromNumber: number | undefined;
    redemptionToNumber: number | undefined;
    id: number | undefined;
    allowChangeReward: boolean | undefined;
}

export class CampaignRewardItemForListDto implements ICampaignRewardItemForListDto {
    id!: number | undefined;
    name!: string | undefined;
    pointCost!: number | undefined;
    description!: string | undefined;
    rewardId!: number | undefined;
    campaignId!: number | undefined;
    effectFrom!: moment.Moment | undefined;
    effectTo!: moment.Moment | undefined;
    limitQuantity!: number | undefined;
    isDeleted!: boolean | undefined;
    effectFromNumber!: number | undefined;
    effectToNumber!: number | undefined;

    constructor(data?: ICampaignRewardItemForListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.pointCost = data["pointCost"];
            this.description = data["description"];
            this.rewardId = data["rewardId"];
            this.campaignId = data["campaignId"];
            this.effectFrom = data["effectFrom"] ? moment(data["effectFrom"].toString()) : <any>undefined;
            this.effectTo = data["effectTo"] ? moment(data["effectTo"].toString()) : <any>undefined;
            this.limitQuantity = data["limitQuantity"];
            this.isDeleted = data["isDeleted"];
            this.effectFromNumber = data["effectFromNumber"];
            this.effectToNumber = data["effectToNumber"];
        }
    }

    static fromJS(data: any): CampaignRewardItemForListDto {
        data = typeof data === 'object' ? data : {};
        let result = new CampaignRewardItemForListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["pointCost"] = this.pointCost;
        data["description"] = this.description;
        data["rewardId"] = this.rewardId;
        data["campaignId"] = this.campaignId;
        data["effectFrom"] = this.effectFrom ? this.effectFrom.toISOString() : <any>undefined;
        data["effectTo"] = this.effectTo ? this.effectTo.toISOString() : <any>undefined;
        data["limitQuantity"] = this.limitQuantity;
        data["isDeleted"] = this.isDeleted;
        data["effectFromNumber"] = this.effectFromNumber;
        data["effectToNumber"] = this.effectToNumber;
        return data;
    }
}

export interface ICampaignRewardItemForListDto {
    id: number | undefined;
    name: string | undefined;
    pointCost: number | undefined;
    description: string | undefined;
    rewardId: number | undefined;
    campaignId: number | undefined;
    effectFrom: moment.Moment | undefined;
    effectTo: moment.Moment | undefined;
    limitQuantity: number | undefined;
    isDeleted: boolean | undefined;
    effectFromNumber: number | undefined;
    effectToNumber: number | undefined;
}

export class UpdateActiveDto implements IUpdateActiveDto {
    isActive!: boolean | undefined;
    id!: number | undefined;

    constructor(data?: IUpdateActiveDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isActive = data["isActive"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): UpdateActiveDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateActiveDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isActive"] = this.isActive;
        data["id"] = this.id;
        return data;
    }
}

export interface IUpdateActiveDto {
    isActive: boolean | undefined;
    id: number | undefined;
}

export class RewardItemForListDto implements IRewardItemForListDto {
    id!: number | undefined;
    code!: string | undefined;
    name!: string | undefined;
    description!: string | undefined;
    rewardType!: string | undefined;
    pointCost!: number | undefined;
    monetaryValue!: number | undefined;
    availableQuantity!: number | undefined;
    imageUrl!: string | undefined;
    isActive!: boolean | undefined;

    constructor(data?: IRewardItemForListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.code = data["code"];
            this.name = data["name"];
            this.description = data["description"];
            this.rewardType = data["rewardType"];
            this.pointCost = data["pointCost"];
            this.monetaryValue = data["monetaryValue"];
            this.availableQuantity = data["availableQuantity"];
            this.imageUrl = data["imageUrl"];
            this.isActive = data["isActive"];
        }
    }

    static fromJS(data: any): RewardItemForListDto {
        data = typeof data === 'object' ? data : {};
        let result = new RewardItemForListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        data["description"] = this.description;
        data["rewardType"] = this.rewardType;
        data["pointCost"] = this.pointCost;
        data["monetaryValue"] = this.monetaryValue;
        data["availableQuantity"] = this.availableQuantity;
        data["imageUrl"] = this.imageUrl;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IRewardItemForListDto {
    id: number | undefined;
    code: string | undefined;
    name: string | undefined;
    description: string | undefined;
    rewardType: string | undefined;
    pointCost: number | undefined;
    monetaryValue: number | undefined;
    availableQuantity: number | undefined;
    imageUrl: string | undefined;
    isActive: boolean | undefined;
}

export class CampaignOverviewDto implements ICampaignOverviewDto {
    name!: string | undefined;
    revenuePerformance!: number | undefined;
    memberPerformance!: number | undefined;
    timespent!: number | undefined;
    totalMember!: number | undefined;
    estimatedMembers!: number | undefined;
    revenue!: number | undefined;
    estimatedRevenue!: number | undefined;

    constructor(data?: ICampaignOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.revenuePerformance = data["revenuePerformance"];
            this.memberPerformance = data["memberPerformance"];
            this.timespent = data["timespent"];
            this.totalMember = data["totalMember"];
            this.estimatedMembers = data["estimatedMembers"];
            this.revenue = data["revenue"];
            this.estimatedRevenue = data["estimatedRevenue"];
        }
    }

    static fromJS(data: any): CampaignOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new CampaignOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["revenuePerformance"] = this.revenuePerformance;
        data["memberPerformance"] = this.memberPerformance;
        data["timespent"] = this.timespent;
        data["totalMember"] = this.totalMember;
        data["estimatedMembers"] = this.estimatedMembers;
        data["revenue"] = this.revenue;
        data["estimatedRevenue"] = this.estimatedRevenue;
        return data;
    }
}

export interface ICampaignOverviewDto {
    name: string | undefined;
    revenuePerformance: number | undefined;
    memberPerformance: number | undefined;
    timespent: number | undefined;
    totalMember: number | undefined;
    estimatedMembers: number | undefined;
    revenue: number | undefined;
    estimatedRevenue: number | undefined;
}

export class PagedResultDtoOfGetCampaignPerformanceOverviewForViewDto implements IPagedResultDtoOfGetCampaignPerformanceOverviewForViewDto {
    totalCount!: number | undefined;
    items!: GetCampaignPerformanceOverviewForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetCampaignPerformanceOverviewForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetCampaignPerformanceOverviewForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetCampaignPerformanceOverviewForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetCampaignPerformanceOverviewForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetCampaignPerformanceOverviewForViewDto {
    totalCount: number | undefined;
    items: GetCampaignPerformanceOverviewForViewDto[] | undefined;
}

export class GetCampaignPerformanceOverviewForViewDto implements IGetCampaignPerformanceOverviewForViewDto {
    campaignPerformanceOverview!: CampaignPerformanceOverviewDto | undefined;

    constructor(data?: IGetCampaignPerformanceOverviewForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.campaignPerformanceOverview = data["campaignPerformanceOverview"] ? CampaignPerformanceOverviewDto.fromJS(data["campaignPerformanceOverview"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCampaignPerformanceOverviewForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCampaignPerformanceOverviewForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["campaignPerformanceOverview"] = this.campaignPerformanceOverview ? this.campaignPerformanceOverview.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetCampaignPerformanceOverviewForViewDto {
    campaignPerformanceOverview: CampaignPerformanceOverviewDto | undefined;
}

export class CampaignPerformanceOverviewDto implements ICampaignPerformanceOverviewDto {
    campaignName!: string | undefined;
    numberOfSent!: number | undefined;
    numberOfReceived!: number | undefined;
    numberOfSeen!: number | undefined;
    numberOfFail!: number | undefined;
    month!: number | undefined;
    year!: number | undefined;
    campaignId!: number | undefined;
    calculateDate!: moment.Moment | undefined;
    id!: number | undefined;

    constructor(data?: ICampaignPerformanceOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.campaignName = data["campaignName"];
            this.numberOfSent = data["numberOfSent"];
            this.numberOfReceived = data["numberOfReceived"];
            this.numberOfSeen = data["numberOfSeen"];
            this.numberOfFail = data["numberOfFail"];
            this.month = data["month"];
            this.year = data["year"];
            this.campaignId = data["campaignId"];
            this.calculateDate = data["calculateDate"] ? moment(data["calculateDate"].toString()) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CampaignPerformanceOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new CampaignPerformanceOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["campaignName"] = this.campaignName;
        data["numberOfSent"] = this.numberOfSent;
        data["numberOfReceived"] = this.numberOfReceived;
        data["numberOfSeen"] = this.numberOfSeen;
        data["numberOfFail"] = this.numberOfFail;
        data["month"] = this.month;
        data["year"] = this.year;
        data["campaignId"] = this.campaignId;
        data["calculateDate"] = this.calculateDate ? this.calculateDate.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface ICampaignPerformanceOverviewDto {
    campaignName: string | undefined;
    numberOfSent: number | undefined;
    numberOfReceived: number | undefined;
    numberOfSeen: number | undefined;
    numberOfFail: number | undefined;
    month: number | undefined;
    year: number | undefined;
    campaignId: number | undefined;
    calculateDate: moment.Moment | undefined;
    id: number | undefined;
}

export class GetCampaignPerformanceOverviewForEditOutput implements IGetCampaignPerformanceOverviewForEditOutput {
    campaignPerformanceOverview!: CreateOrEditCampaignPerformanceOverviewDto | undefined;

    constructor(data?: IGetCampaignPerformanceOverviewForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.campaignPerformanceOverview = data["campaignPerformanceOverview"] ? CreateOrEditCampaignPerformanceOverviewDto.fromJS(data["campaignPerformanceOverview"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCampaignPerformanceOverviewForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetCampaignPerformanceOverviewForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["campaignPerformanceOverview"] = this.campaignPerformanceOverview ? this.campaignPerformanceOverview.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetCampaignPerformanceOverviewForEditOutput {
    campaignPerformanceOverview: CreateOrEditCampaignPerformanceOverviewDto | undefined;
}

export class CreateOrEditCampaignPerformanceOverviewDto implements ICreateOrEditCampaignPerformanceOverviewDto {
    campaignName!: string | undefined;
    numberOfSent!: number | undefined;
    numberOfReceived!: number | undefined;
    numberOfSeen!: number | undefined;
    numberOfFail!: number | undefined;
    month!: number | undefined;
    year!: number | undefined;
    campaignId!: number | undefined;
    calculateDate!: moment.Moment | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditCampaignPerformanceOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.campaignName = data["campaignName"];
            this.numberOfSent = data["numberOfSent"];
            this.numberOfReceived = data["numberOfReceived"];
            this.numberOfSeen = data["numberOfSeen"];
            this.numberOfFail = data["numberOfFail"];
            this.month = data["month"];
            this.year = data["year"];
            this.campaignId = data["campaignId"];
            this.calculateDate = data["calculateDate"] ? moment(data["calculateDate"].toString()) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditCampaignPerformanceOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditCampaignPerformanceOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["campaignName"] = this.campaignName;
        data["numberOfSent"] = this.numberOfSent;
        data["numberOfReceived"] = this.numberOfReceived;
        data["numberOfSeen"] = this.numberOfSeen;
        data["numberOfFail"] = this.numberOfFail;
        data["month"] = this.month;
        data["year"] = this.year;
        data["campaignId"] = this.campaignId;
        data["calculateDate"] = this.calculateDate ? this.calculateDate.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditCampaignPerformanceOverviewDto {
    campaignName: string | undefined;
    numberOfSent: number | undefined;
    numberOfReceived: number | undefined;
    numberOfSeen: number | undefined;
    numberOfFail: number | undefined;
    month: number | undefined;
    year: number | undefined;
    campaignId: number | undefined;
    calculateDate: moment.Moment | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfGetCampaignForView implements IPagedResultDtoOfGetCampaignForView {
    totalCount!: number | undefined;
    items!: GetCampaignForView[] | undefined;

    constructor(data?: IPagedResultDtoOfGetCampaignForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetCampaignForView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetCampaignForView {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetCampaignForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetCampaignForView {
    totalCount: number | undefined;
    items: GetCampaignForView[] | undefined;
}

export class GetCampaignForView implements IGetCampaignForView {
    campaign!: CampaignDto | undefined;
    userName!: string | undefined;

    constructor(data?: IGetCampaignForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.campaign = data["campaign"] ? CampaignDto.fromJS(data["campaign"]) : <any>undefined;
            this.userName = data["userName"];
        }
    }

    static fromJS(data: any): GetCampaignForView {
        data = typeof data === 'object' ? data : {};
        let result = new GetCampaignForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["campaign"] = this.campaign ? this.campaign.toJSON() : <any>undefined;
        data["userName"] = this.userName;
        return data;
    }
}

export interface IGetCampaignForView {
    campaign: CampaignDto | undefined;
    userName: string | undefined;
}

export class CampaignDto implements ICampaignDto {
    code!: string | undefined;
    name!: string | undefined;
    description!: string | undefined;
    isActive!: boolean | undefined;
    effectiveFrom!: moment.Moment | undefined;
    effectiveTo!: moment.Moment | undefined;
    estimatedMembers!: number | undefined;
    estimatedBudget!: number | undefined;
    estimatedRevenue!: number | undefined;
    approver!: string | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICampaignDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.name = data["name"];
            this.description = data["description"];
            this.isActive = data["isActive"];
            this.effectiveFrom = data["effectiveFrom"] ? moment(data["effectiveFrom"].toString()) : <any>undefined;
            this.effectiveTo = data["effectiveTo"] ? moment(data["effectiveTo"].toString()) : <any>undefined;
            this.estimatedMembers = data["estimatedMembers"];
            this.estimatedBudget = data["estimatedBudget"];
            this.estimatedRevenue = data["estimatedRevenue"];
            this.approver = data["approver"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CampaignDto {
        data = typeof data === 'object' ? data : {};
        let result = new CampaignDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["effectiveFrom"] = this.effectiveFrom ? this.effectiveFrom.toISOString() : <any>undefined;
        data["effectiveTo"] = this.effectiveTo ? this.effectiveTo.toISOString() : <any>undefined;
        data["estimatedMembers"] = this.estimatedMembers;
        data["estimatedBudget"] = this.estimatedBudget;
        data["estimatedRevenue"] = this.estimatedRevenue;
        data["approver"] = this.approver;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICampaignDto {
    code: string | undefined;
    name: string | undefined;
    description: string | undefined;
    isActive: boolean | undefined;
    effectiveFrom: moment.Moment | undefined;
    effectiveTo: moment.Moment | undefined;
    estimatedMembers: number | undefined;
    estimatedBudget: number | undefined;
    estimatedRevenue: number | undefined;
    approver: string | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    id: number | undefined;
}

export class GetCampaignForEditOutput implements IGetCampaignForEditOutput {
    campaign!: CreateOrEditCampaignDto | undefined;
    createByUserName!: string | undefined;
    lastUpdateByUserName!: string | undefined;

    constructor(data?: IGetCampaignForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.campaign = data["campaign"] ? CreateOrEditCampaignDto.fromJS(data["campaign"]) : <any>undefined;
            this.createByUserName = data["createByUserName"];
            this.lastUpdateByUserName = data["lastUpdateByUserName"];
        }
    }

    static fromJS(data: any): GetCampaignForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetCampaignForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["campaign"] = this.campaign ? this.campaign.toJSON() : <any>undefined;
        data["createByUserName"] = this.createByUserName;
        data["lastUpdateByUserName"] = this.lastUpdateByUserName;
        return data;
    }
}

export interface IGetCampaignForEditOutput {
    campaign: CreateOrEditCampaignDto | undefined;
    createByUserName: string | undefined;
    lastUpdateByUserName: string | undefined;
}

export class CreateOrEditCampaignDto implements ICreateOrEditCampaignDto {
    code!: string;
    name!: string;
    description!: string | undefined;
    isActive!: boolean | undefined;
    effectiveFrom!: moment.Moment | undefined;
    effectiveTo!: moment.Moment | undefined;
    estimatedMembers!: number | undefined;
    estimatedBudget!: number | undefined;
    estimatedRevenue!: number | undefined;
    approver!: string | undefined;
    approveDate!: moment.Moment | undefined;
    approveUserId!: number | undefined;
    campaignType!: string | undefined;
    isDeleted!: boolean | undefined;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: moment.Moment | undefined;
    creatorUserId!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditCampaignDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.name = data["name"];
            this.description = data["description"];
            this.isActive = data["isActive"];
            this.effectiveFrom = data["effectiveFrom"] ? moment(data["effectiveFrom"].toString()) : <any>undefined;
            this.effectiveTo = data["effectiveTo"] ? moment(data["effectiveTo"].toString()) : <any>undefined;
            this.estimatedMembers = data["estimatedMembers"];
            this.estimatedBudget = data["estimatedBudget"];
            this.estimatedRevenue = data["estimatedRevenue"];
            this.approver = data["approver"];
            this.approveDate = data["approveDate"] ? moment(data["approveDate"].toString()) : <any>undefined;
            this.approveUserId = data["approveUserId"];
            this.campaignType = data["campaignType"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditCampaignDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditCampaignDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["effectiveFrom"] = this.effectiveFrom ? this.effectiveFrom.toISOString() : <any>undefined;
        data["effectiveTo"] = this.effectiveTo ? this.effectiveTo.toISOString() : <any>undefined;
        data["estimatedMembers"] = this.estimatedMembers;
        data["estimatedBudget"] = this.estimatedBudget;
        data["estimatedRevenue"] = this.estimatedRevenue;
        data["approver"] = this.approver;
        data["approveDate"] = this.approveDate ? this.approveDate.toISOString() : <any>undefined;
        data["approveUserId"] = this.approveUserId;
        data["campaignType"] = this.campaignType;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditCampaignDto {
    code: string;
    name: string;
    description: string | undefined;
    isActive: boolean | undefined;
    effectiveFrom: moment.Moment | undefined;
    effectiveTo: moment.Moment | undefined;
    estimatedMembers: number | undefined;
    estimatedBudget: number | undefined;
    estimatedRevenue: number | undefined;
    approver: string | undefined;
    approveDate: moment.Moment | undefined;
    approveUserId: number | undefined;
    campaignType: string | undefined;
    isDeleted: boolean | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class CheckOrAdjustmentPointInput implements ICheckOrAdjustmentPointInput {
    itemCode!: string | undefined;
    saleType!: string | undefined;
    memberCode!: string | undefined;
    actionType!: string | undefined;
    departmentLevel1!: string | undefined;
    pointImport!: number | undefined;
    activationDate!: moment.Moment | undefined;

    constructor(data?: ICheckOrAdjustmentPointInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.itemCode = data["itemCode"];
            this.saleType = data["saleType"];
            this.memberCode = data["memberCode"];
            this.actionType = data["actionType"];
            this.departmentLevel1 = data["departmentLevel1"];
            this.pointImport = data["pointImport"];
            this.activationDate = data["activationDate"] ? moment(data["activationDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CheckOrAdjustmentPointInput {
        data = typeof data === 'object' ? data : {};
        let result = new CheckOrAdjustmentPointInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itemCode"] = this.itemCode;
        data["saleType"] = this.saleType;
        data["memberCode"] = this.memberCode;
        data["actionType"] = this.actionType;
        data["departmentLevel1"] = this.departmentLevel1;
        data["pointImport"] = this.pointImport;
        data["activationDate"] = this.activationDate ? this.activationDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICheckOrAdjustmentPointInput {
    itemCode: string | undefined;
    saleType: string | undefined;
    memberCode: string | undefined;
    actionType: string | undefined;
    departmentLevel1: string | undefined;
    pointImport: number | undefined;
    activationDate: moment.Moment | undefined;
}

export class CheckOrAdjustmentPointResponse implements ICheckOrAdjustmentPointResponse {
    message!: string | undefined;
    pointAdd!: number | undefined;
    coinAdd!: number | undefined;
    code!: string | undefined;
    name!: string | undefined;

    constructor(data?: ICheckOrAdjustmentPointResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.message = data["message"];
            this.pointAdd = data["pointAdd"];
            this.coinAdd = data["coinAdd"];
            this.code = data["code"];
            this.name = data["name"];
        }
    }

    static fromJS(data: any): CheckOrAdjustmentPointResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CheckOrAdjustmentPointResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["pointAdd"] = this.pointAdd;
        data["coinAdd"] = this.coinAdd;
        data["code"] = this.code;
        data["name"] = this.name;
        return data;
    }
}

export interface ICheckOrAdjustmentPointResponse {
    message: string | undefined;
    pointAdd: number | undefined;
    coinAdd: number | undefined;
    code: string | undefined;
    name: string | undefined;
}

export class CreateOrEditCampaignSettingDto implements ICreateOrEditCampaignSettingDto {
    campaign!: CreateOrEditCampaignDto | undefined;
    baseSettings!: CreateOrEditBaseSettingDto[] | undefined;
    eventSettings!: CreateOrEditEventSettingDto[] | undefined;
    productCategorySettings!: CreateOrEditProductCategoryDto[] | undefined;
    productSettings!: CreateOrEditProductSettingDto[] | undefined;
    specialSettings!: CreateOrEditSpecialSettingDto[] | undefined;
    rankSettings!: CreateOrEditRankSettingDto[] | undefined;
    actionRules!: CreateOrEditActionRuleDto[] | undefined;
    senioritySettings!: CreateOrEditSenioritySettingDto[] | undefined;
    referrals!: CreateOrEditReferralDto[] | undefined;

    constructor(data?: ICreateOrEditCampaignSettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.campaign = data["campaign"] ? CreateOrEditCampaignDto.fromJS(data["campaign"]) : <any>undefined;
            if (data["baseSettings"] && data["baseSettings"].constructor === Array) {
                this.baseSettings = [];
                for (let item of data["baseSettings"])
                    this.baseSettings.push(CreateOrEditBaseSettingDto.fromJS(item));
            }
            if (data["eventSettings"] && data["eventSettings"].constructor === Array) {
                this.eventSettings = [];
                for (let item of data["eventSettings"])
                    this.eventSettings.push(CreateOrEditEventSettingDto.fromJS(item));
            }
            if (data["productCategorySettings"] && data["productCategorySettings"].constructor === Array) {
                this.productCategorySettings = [];
                for (let item of data["productCategorySettings"])
                    this.productCategorySettings.push(CreateOrEditProductCategoryDto.fromJS(item));
            }
            if (data["productSettings"] && data["productSettings"].constructor === Array) {
                this.productSettings = [];
                for (let item of data["productSettings"])
                    this.productSettings.push(CreateOrEditProductSettingDto.fromJS(item));
            }
            if (data["specialSettings"] && data["specialSettings"].constructor === Array) {
                this.specialSettings = [];
                for (let item of data["specialSettings"])
                    this.specialSettings.push(CreateOrEditSpecialSettingDto.fromJS(item));
            }
            if (data["rankSettings"] && data["rankSettings"].constructor === Array) {
                this.rankSettings = [];
                for (let item of data["rankSettings"])
                    this.rankSettings.push(CreateOrEditRankSettingDto.fromJS(item));
            }
            if (data["actionRules"] && data["actionRules"].constructor === Array) {
                this.actionRules = [];
                for (let item of data["actionRules"])
                    this.actionRules.push(CreateOrEditActionRuleDto.fromJS(item));
            }
            if (data["senioritySettings"] && data["senioritySettings"].constructor === Array) {
                this.senioritySettings = [];
                for (let item of data["senioritySettings"])
                    this.senioritySettings.push(CreateOrEditSenioritySettingDto.fromJS(item));
            }
            if (data["referrals"] && data["referrals"].constructor === Array) {
                this.referrals = [];
                for (let item of data["referrals"])
                    this.referrals.push(CreateOrEditReferralDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOrEditCampaignSettingDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditCampaignSettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["campaign"] = this.campaign ? this.campaign.toJSON() : <any>undefined;
        if (this.baseSettings && this.baseSettings.constructor === Array) {
            data["baseSettings"] = [];
            for (let item of this.baseSettings)
                data["baseSettings"].push(item.toJSON());
        }
        if (this.eventSettings && this.eventSettings.constructor === Array) {
            data["eventSettings"] = [];
            for (let item of this.eventSettings)
                data["eventSettings"].push(item.toJSON());
        }
        if (this.productCategorySettings && this.productCategorySettings.constructor === Array) {
            data["productCategorySettings"] = [];
            for (let item of this.productCategorySettings)
                data["productCategorySettings"].push(item.toJSON());
        }
        if (this.productSettings && this.productSettings.constructor === Array) {
            data["productSettings"] = [];
            for (let item of this.productSettings)
                data["productSettings"].push(item.toJSON());
        }
        if (this.specialSettings && this.specialSettings.constructor === Array) {
            data["specialSettings"] = [];
            for (let item of this.specialSettings)
                data["specialSettings"].push(item.toJSON());
        }
        if (this.rankSettings && this.rankSettings.constructor === Array) {
            data["rankSettings"] = [];
            for (let item of this.rankSettings)
                data["rankSettings"].push(item.toJSON());
        }
        if (this.actionRules && this.actionRules.constructor === Array) {
            data["actionRules"] = [];
            for (let item of this.actionRules)
                data["actionRules"].push(item.toJSON());
        }
        if (this.senioritySettings && this.senioritySettings.constructor === Array) {
            data["senioritySettings"] = [];
            for (let item of this.senioritySettings)
                data["senioritySettings"].push(item.toJSON());
        }
        if (this.referrals && this.referrals.constructor === Array) {
            data["referrals"] = [];
            for (let item of this.referrals)
                data["referrals"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateOrEditCampaignSettingDto {
    campaign: CreateOrEditCampaignDto | undefined;
    baseSettings: CreateOrEditBaseSettingDto[] | undefined;
    eventSettings: CreateOrEditEventSettingDto[] | undefined;
    productCategorySettings: CreateOrEditProductCategoryDto[] | undefined;
    productSettings: CreateOrEditProductSettingDto[] | undefined;
    specialSettings: CreateOrEditSpecialSettingDto[] | undefined;
    rankSettings: CreateOrEditRankSettingDto[] | undefined;
    actionRules: CreateOrEditActionRuleDto[] | undefined;
    senioritySettings: CreateOrEditSenioritySettingDto[] | undefined;
    referrals: CreateOrEditReferralDto[] | undefined;
}

export class CreateOrEditEventSettingDto implements ICreateOrEditEventSettingDto {
    code!: string;
    name!: string;
    description!: string | undefined;
    effectiveFrom!: moment.Moment | undefined;
    effectiveTo!: moment.Moment | undefined;
    startTime!: string | undefined;
    endTime!: string | undefined;
    cron!: string | undefined;
    isActive!: boolean | undefined;
    timeZone!: string | undefined;
    targetAudienceId!: number | undefined;
    campaignId!: number;
    amounts!: CreateOrEditEventAmountSettingDto[] | undefined;
    targetAudience!: CreateOrEditSettingParamDto | undefined;
    targetAudienceCode!: string | undefined;
    isDeleted!: boolean | undefined;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: moment.Moment | undefined;
    creatorUserId!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditEventSettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.name = data["name"];
            this.description = data["description"];
            this.effectiveFrom = data["effectiveFrom"] ? moment(data["effectiveFrom"].toString()) : <any>undefined;
            this.effectiveTo = data["effectiveTo"] ? moment(data["effectiveTo"].toString()) : <any>undefined;
            this.startTime = data["startTime"];
            this.endTime = data["endTime"];
            this.cron = data["cron"];
            this.isActive = data["isActive"];
            this.timeZone = data["timeZone"];
            this.targetAudienceId = data["targetAudienceId"];
            this.campaignId = data["campaignId"];
            if (data["amounts"] && data["amounts"].constructor === Array) {
                this.amounts = [];
                for (let item of data["amounts"])
                    this.amounts.push(CreateOrEditEventAmountSettingDto.fromJS(item));
            }
            this.targetAudience = data["targetAudience"] ? CreateOrEditSettingParamDto.fromJS(data["targetAudience"]) : <any>undefined;
            this.targetAudienceCode = data["targetAudienceCode"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditEventSettingDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditEventSettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["description"] = this.description;
        data["effectiveFrom"] = this.effectiveFrom ? this.effectiveFrom.toISOString() : <any>undefined;
        data["effectiveTo"] = this.effectiveTo ? this.effectiveTo.toISOString() : <any>undefined;
        data["startTime"] = this.startTime;
        data["endTime"] = this.endTime;
        data["cron"] = this.cron;
        data["isActive"] = this.isActive;
        data["timeZone"] = this.timeZone;
        data["targetAudienceId"] = this.targetAudienceId;
        data["campaignId"] = this.campaignId;
        if (this.amounts && this.amounts.constructor === Array) {
            data["amounts"] = [];
            for (let item of this.amounts)
                data["amounts"].push(item.toJSON());
        }
        data["targetAudience"] = this.targetAudience ? this.targetAudience.toJSON() : <any>undefined;
        data["targetAudienceCode"] = this.targetAudienceCode;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditEventSettingDto {
    code: string;
    name: string;
    description: string | undefined;
    effectiveFrom: moment.Moment | undefined;
    effectiveTo: moment.Moment | undefined;
    startTime: string | undefined;
    endTime: string | undefined;
    cron: string | undefined;
    isActive: boolean | undefined;
    timeZone: string | undefined;
    targetAudienceId: number | undefined;
    campaignId: number;
    amounts: CreateOrEditEventAmountSettingDto[] | undefined;
    targetAudience: CreateOrEditSettingParamDto | undefined;
    targetAudienceCode: string | undefined;
    isDeleted: boolean | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class CreateOrEditProductCategoryDto implements ICreateOrEditProductCategoryDto {
    code!: string | undefined;
    name!: string;
    description!: string | undefined;
    effectiveFrom!: moment.Moment | undefined;
    effectiveTo!: moment.Moment | undefined;
    isActive!: boolean | undefined;
    targetAudienceId!: number | undefined;
    coinValue!: number | undefined;
    pointValue!: number | undefined;
    campaignId!: number;
    details!: CreateOrEditProductCategoryDetailSettingDto[] | undefined;
    targetAudience!: CreateOrEditSettingParamDto | undefined;
    targetAudienceCode!: string | undefined;
    isDeleted!: boolean | undefined;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: moment.Moment | undefined;
    creatorUserId!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditProductCategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.name = data["name"];
            this.description = data["description"];
            this.effectiveFrom = data["effectiveFrom"] ? moment(data["effectiveFrom"].toString()) : <any>undefined;
            this.effectiveTo = data["effectiveTo"] ? moment(data["effectiveTo"].toString()) : <any>undefined;
            this.isActive = data["isActive"];
            this.targetAudienceId = data["targetAudienceId"];
            this.coinValue = data["coinValue"];
            this.pointValue = data["pointValue"];
            this.campaignId = data["campaignId"];
            if (data["details"] && data["details"].constructor === Array) {
                this.details = [];
                for (let item of data["details"])
                    this.details.push(CreateOrEditProductCategoryDetailSettingDto.fromJS(item));
            }
            this.targetAudience = data["targetAudience"] ? CreateOrEditSettingParamDto.fromJS(data["targetAudience"]) : <any>undefined;
            this.targetAudienceCode = data["targetAudienceCode"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditProductCategoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditProductCategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["description"] = this.description;
        data["effectiveFrom"] = this.effectiveFrom ? this.effectiveFrom.toISOString() : <any>undefined;
        data["effectiveTo"] = this.effectiveTo ? this.effectiveTo.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        data["targetAudienceId"] = this.targetAudienceId;
        data["coinValue"] = this.coinValue;
        data["pointValue"] = this.pointValue;
        data["campaignId"] = this.campaignId;
        if (this.details && this.details.constructor === Array) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item.toJSON());
        }
        data["targetAudience"] = this.targetAudience ? this.targetAudience.toJSON() : <any>undefined;
        data["targetAudienceCode"] = this.targetAudienceCode;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditProductCategoryDto {
    code: string | undefined;
    name: string;
    description: string | undefined;
    effectiveFrom: moment.Moment | undefined;
    effectiveTo: moment.Moment | undefined;
    isActive: boolean | undefined;
    targetAudienceId: number | undefined;
    coinValue: number | undefined;
    pointValue: number | undefined;
    campaignId: number;
    details: CreateOrEditProductCategoryDetailSettingDto[] | undefined;
    targetAudience: CreateOrEditSettingParamDto | undefined;
    targetAudienceCode: string | undefined;
    isDeleted: boolean | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class CreateOrEditProductSettingDto implements ICreateOrEditProductSettingDto {
    code!: string | undefined;
    name!: string;
    description!: string | undefined;
    effectiveFrom!: moment.Moment | undefined;
    effectiveTo!: moment.Moment | undefined;
    cron!: string | undefined;
    isActive!: boolean | undefined;
    targetAudienceId!: number | undefined;
    timeZone!: string | undefined;
    campaignId!: number;
    details!: CreateOrEditProductDetailSettingDto[] | undefined;
    targetAudience!: CreateOrEditSettingParamDto | undefined;
    targetAudienceCode!: string | undefined;
    startTime!: string | undefined;
    endTime!: string | undefined;
    isDeleted!: boolean | undefined;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: moment.Moment | undefined;
    creatorUserId!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditProductSettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.name = data["name"];
            this.description = data["description"];
            this.effectiveFrom = data["effectiveFrom"] ? moment(data["effectiveFrom"].toString()) : <any>undefined;
            this.effectiveTo = data["effectiveTo"] ? moment(data["effectiveTo"].toString()) : <any>undefined;
            this.cron = data["cron"];
            this.isActive = data["isActive"];
            this.targetAudienceId = data["targetAudienceId"];
            this.timeZone = data["timeZone"];
            this.campaignId = data["campaignId"];
            if (data["details"] && data["details"].constructor === Array) {
                this.details = [];
                for (let item of data["details"])
                    this.details.push(CreateOrEditProductDetailSettingDto.fromJS(item));
            }
            this.targetAudience = data["targetAudience"] ? CreateOrEditSettingParamDto.fromJS(data["targetAudience"]) : <any>undefined;
            this.targetAudienceCode = data["targetAudienceCode"];
            this.startTime = data["startTime"];
            this.endTime = data["endTime"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditProductSettingDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditProductSettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["description"] = this.description;
        data["effectiveFrom"] = this.effectiveFrom ? this.effectiveFrom.toISOString() : <any>undefined;
        data["effectiveTo"] = this.effectiveTo ? this.effectiveTo.toISOString() : <any>undefined;
        data["cron"] = this.cron;
        data["isActive"] = this.isActive;
        data["targetAudienceId"] = this.targetAudienceId;
        data["timeZone"] = this.timeZone;
        data["campaignId"] = this.campaignId;
        if (this.details && this.details.constructor === Array) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item.toJSON());
        }
        data["targetAudience"] = this.targetAudience ? this.targetAudience.toJSON() : <any>undefined;
        data["targetAudienceCode"] = this.targetAudienceCode;
        data["startTime"] = this.startTime;
        data["endTime"] = this.endTime;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditProductSettingDto {
    code: string | undefined;
    name: string;
    description: string | undefined;
    effectiveFrom: moment.Moment | undefined;
    effectiveTo: moment.Moment | undefined;
    cron: string | undefined;
    isActive: boolean | undefined;
    targetAudienceId: number | undefined;
    timeZone: string | undefined;
    campaignId: number;
    details: CreateOrEditProductDetailSettingDto[] | undefined;
    targetAudience: CreateOrEditSettingParamDto | undefined;
    targetAudienceCode: string | undefined;
    startTime: string | undefined;
    endTime: string | undefined;
    isDeleted: boolean | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class CreateOrEditSpecialSettingDto implements ICreateOrEditSpecialSettingDto {
    code!: string;
    name!: string;
    type!: CreateOrEditSpecialSettingDtoType | undefined;
    description!: string | undefined;
    coinValue!: number | undefined;
    pointValue!: number | undefined;
    effectiveFrom!: moment.Moment | undefined;
    effectiveTo!: moment.Moment | undefined;
    date!: moment.Moment | undefined;
    cron!: string | undefined;
    occurType!: CreateOrEditSpecialSettingDtoOccurType | undefined;
    isActive!: boolean | undefined;
    settingParamString!: string | undefined;
    timeZone!: string | undefined;
    campaignId!: number;
    targetAudienceId!: number | undefined;
    targetAudience!: CreateOrEditSettingParamDto | undefined;
    targetAudienceCode!: string | undefined;
    isDeleted!: boolean | undefined;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: moment.Moment | undefined;
    creatorUserId!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditSpecialSettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.name = data["name"];
            this.type = data["type"];
            this.description = data["description"];
            this.coinValue = data["coinValue"];
            this.pointValue = data["pointValue"];
            this.effectiveFrom = data["effectiveFrom"] ? moment(data["effectiveFrom"].toString()) : <any>undefined;
            this.effectiveTo = data["effectiveTo"] ? moment(data["effectiveTo"].toString()) : <any>undefined;
            this.date = data["date"] ? moment(data["date"].toString()) : <any>undefined;
            this.cron = data["cron"];
            this.occurType = data["occurType"];
            this.isActive = data["isActive"];
            this.settingParamString = data["settingParamString"];
            this.timeZone = data["timeZone"];
            this.campaignId = data["campaignId"];
            this.targetAudienceId = data["targetAudienceId"];
            this.targetAudience = data["targetAudience"] ? CreateOrEditSettingParamDto.fromJS(data["targetAudience"]) : <any>undefined;
            this.targetAudienceCode = data["targetAudienceCode"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditSpecialSettingDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditSpecialSettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["type"] = this.type;
        data["description"] = this.description;
        data["coinValue"] = this.coinValue;
        data["pointValue"] = this.pointValue;
        data["effectiveFrom"] = this.effectiveFrom ? this.effectiveFrom.toISOString() : <any>undefined;
        data["effectiveTo"] = this.effectiveTo ? this.effectiveTo.toISOString() : <any>undefined;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["cron"] = this.cron;
        data["occurType"] = this.occurType;
        data["isActive"] = this.isActive;
        data["settingParamString"] = this.settingParamString;
        data["timeZone"] = this.timeZone;
        data["campaignId"] = this.campaignId;
        data["targetAudienceId"] = this.targetAudienceId;
        data["targetAudience"] = this.targetAudience ? this.targetAudience.toJSON() : <any>undefined;
        data["targetAudienceCode"] = this.targetAudienceCode;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditSpecialSettingDto {
    code: string;
    name: string;
    type: CreateOrEditSpecialSettingDtoType | undefined;
    description: string | undefined;
    coinValue: number | undefined;
    pointValue: number | undefined;
    effectiveFrom: moment.Moment | undefined;
    effectiveTo: moment.Moment | undefined;
    date: moment.Moment | undefined;
    cron: string | undefined;
    occurType: CreateOrEditSpecialSettingDtoOccurType | undefined;
    isActive: boolean | undefined;
    settingParamString: string | undefined;
    timeZone: string | undefined;
    campaignId: number;
    targetAudienceId: number | undefined;
    targetAudience: CreateOrEditSettingParamDto | undefined;
    targetAudienceCode: string | undefined;
    isDeleted: boolean | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class CreateOrEditRankSettingDto implements ICreateOrEditRankSettingDto {
    code!: string;
    name!: string;
    rankId!: number | undefined;
    pointValue!: number | undefined;
    coinValue!: number | undefined;
    effectiveFrom!: moment.Moment | undefined;
    effectiveTo!: moment.Moment | undefined;
    isActive!: boolean | undefined;
    description!: string | undefined;
    campaignId!: number | undefined;
    lastUpdateByName!: string | undefined;
    isDeleted!: boolean | undefined;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: moment.Moment | undefined;
    creatorUserId!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditRankSettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.name = data["name"];
            this.rankId = data["rankId"];
            this.pointValue = data["pointValue"];
            this.coinValue = data["coinValue"];
            this.effectiveFrom = data["effectiveFrom"] ? moment(data["effectiveFrom"].toString()) : <any>undefined;
            this.effectiveTo = data["effectiveTo"] ? moment(data["effectiveTo"].toString()) : <any>undefined;
            this.isActive = data["isActive"];
            this.description = data["description"];
            this.campaignId = data["campaignId"];
            this.lastUpdateByName = data["lastUpdateByName"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditRankSettingDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditRankSettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["rankId"] = this.rankId;
        data["pointValue"] = this.pointValue;
        data["coinValue"] = this.coinValue;
        data["effectiveFrom"] = this.effectiveFrom ? this.effectiveFrom.toISOString() : <any>undefined;
        data["effectiveTo"] = this.effectiveTo ? this.effectiveTo.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        data["description"] = this.description;
        data["campaignId"] = this.campaignId;
        data["lastUpdateByName"] = this.lastUpdateByName;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditRankSettingDto {
    code: string;
    name: string;
    rankId: number | undefined;
    pointValue: number | undefined;
    coinValue: number | undefined;
    effectiveFrom: moment.Moment | undefined;
    effectiveTo: moment.Moment | undefined;
    isActive: boolean | undefined;
    description: string | undefined;
    campaignId: number | undefined;
    lastUpdateByName: string | undefined;
    isDeleted: boolean | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class CreateOrEditSenioritySettingDto implements ICreateOrEditSenioritySettingDto {
    code!: string;
    name!: string | undefined;
    description!: string | undefined;
    effectiveFrom!: moment.Moment | undefined;
    effectiveTo!: moment.Moment | undefined;
    startPeriod!: moment.Moment | undefined;
    endPeriod!: moment.Moment | undefined;
    minMonthRequired!: number | undefined;
    cron!: string | undefined;
    timeZone!: string | undefined;
    isActive!: boolean | undefined;
    targetAudienceCode!: string | undefined;
    targetAudienceId!: number | undefined;
    targetAudience!: CreateOrEditSettingParamDto | undefined;
    campaignId!: number | undefined;
    seniorityRewardSettings!: CreateOrEditSeniorityRewardSettingDto[] | undefined;
    isDeleted!: boolean | undefined;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: moment.Moment | undefined;
    creatorUserId!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditSenioritySettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.name = data["name"];
            this.description = data["description"];
            this.effectiveFrom = data["effectiveFrom"] ? moment(data["effectiveFrom"].toString()) : <any>undefined;
            this.effectiveTo = data["effectiveTo"] ? moment(data["effectiveTo"].toString()) : <any>undefined;
            this.startPeriod = data["startPeriod"] ? moment(data["startPeriod"].toString()) : <any>undefined;
            this.endPeriod = data["endPeriod"] ? moment(data["endPeriod"].toString()) : <any>undefined;
            this.minMonthRequired = data["minMonthRequired"];
            this.cron = data["cron"];
            this.timeZone = data["timeZone"];
            this.isActive = data["isActive"];
            this.targetAudienceCode = data["targetAudienceCode"];
            this.targetAudienceId = data["targetAudienceId"];
            this.targetAudience = data["targetAudience"] ? CreateOrEditSettingParamDto.fromJS(data["targetAudience"]) : <any>undefined;
            this.campaignId = data["campaignId"];
            if (data["seniorityRewardSettings"] && data["seniorityRewardSettings"].constructor === Array) {
                this.seniorityRewardSettings = [];
                for (let item of data["seniorityRewardSettings"])
                    this.seniorityRewardSettings.push(CreateOrEditSeniorityRewardSettingDto.fromJS(item));
            }
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditSenioritySettingDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditSenioritySettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["description"] = this.description;
        data["effectiveFrom"] = this.effectiveFrom ? this.effectiveFrom.toISOString() : <any>undefined;
        data["effectiveTo"] = this.effectiveTo ? this.effectiveTo.toISOString() : <any>undefined;
        data["startPeriod"] = this.startPeriod ? this.startPeriod.toISOString() : <any>undefined;
        data["endPeriod"] = this.endPeriod ? this.endPeriod.toISOString() : <any>undefined;
        data["minMonthRequired"] = this.minMonthRequired;
        data["cron"] = this.cron;
        data["timeZone"] = this.timeZone;
        data["isActive"] = this.isActive;
        data["targetAudienceCode"] = this.targetAudienceCode;
        data["targetAudienceId"] = this.targetAudienceId;
        data["targetAudience"] = this.targetAudience ? this.targetAudience.toJSON() : <any>undefined;
        data["campaignId"] = this.campaignId;
        if (this.seniorityRewardSettings && this.seniorityRewardSettings.constructor === Array) {
            data["seniorityRewardSettings"] = [];
            for (let item of this.seniorityRewardSettings)
                data["seniorityRewardSettings"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditSenioritySettingDto {
    code: string;
    name: string | undefined;
    description: string | undefined;
    effectiveFrom: moment.Moment | undefined;
    effectiveTo: moment.Moment | undefined;
    startPeriod: moment.Moment | undefined;
    endPeriod: moment.Moment | undefined;
    minMonthRequired: number | undefined;
    cron: string | undefined;
    timeZone: string | undefined;
    isActive: boolean | undefined;
    targetAudienceCode: string | undefined;
    targetAudienceId: number | undefined;
    targetAudience: CreateOrEditSettingParamDto | undefined;
    campaignId: number | undefined;
    seniorityRewardSettings: CreateOrEditSeniorityRewardSettingDto[] | undefined;
    isDeleted: boolean | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class CreateOrEditReferralDto implements ICreateOrEditReferralDto {
    name!: string;
    code!: string | undefined;
    effectiveFrom!: moment.Moment | undefined;
    effectiveTo!: moment.Moment | undefined;
    description!: string | undefined;
    status!: string | undefined;
    expiredDays!: number | undefined;
    orderAmountRequired!: number | undefined;
    maxSet!: number | undefined;
    referrerPoint!: number | undefined;
    referrerCoin!: number | undefined;
    refereePoint!: number | undefined;
    refereeCoin!: number | undefined;
    referrerTargetAudienceId!: number | undefined;
    refereeTargetAudienceId!: number | undefined;
    campaignId!: number | undefined;
    referrerTargetAudience!: CreateOrEditSettingParamDto | undefined;
    refereeTargetAudience!: CreateOrEditSettingParamDto | undefined;
    referrerTargetAudienceCode!: string | undefined;
    refereeTargetAudienceCode!: string | undefined;
    isDeleted!: boolean | undefined;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: moment.Moment | undefined;
    creatorUserId!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditReferralDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.code = data["code"];
            this.effectiveFrom = data["effectiveFrom"] ? moment(data["effectiveFrom"].toString()) : <any>undefined;
            this.effectiveTo = data["effectiveTo"] ? moment(data["effectiveTo"].toString()) : <any>undefined;
            this.description = data["description"];
            this.status = data["status"];
            this.expiredDays = data["expiredDays"];
            this.orderAmountRequired = data["orderAmountRequired"];
            this.maxSet = data["maxSet"];
            this.referrerPoint = data["referrerPoint"];
            this.referrerCoin = data["referrerCoin"];
            this.refereePoint = data["refereePoint"];
            this.refereeCoin = data["refereeCoin"];
            this.referrerTargetAudienceId = data["referrerTargetAudienceId"];
            this.refereeTargetAudienceId = data["refereeTargetAudienceId"];
            this.campaignId = data["campaignId"];
            this.referrerTargetAudience = data["referrerTargetAudience"] ? CreateOrEditSettingParamDto.fromJS(data["referrerTargetAudience"]) : <any>undefined;
            this.refereeTargetAudience = data["refereeTargetAudience"] ? CreateOrEditSettingParamDto.fromJS(data["refereeTargetAudience"]) : <any>undefined;
            this.referrerTargetAudienceCode = data["referrerTargetAudienceCode"];
            this.refereeTargetAudienceCode = data["refereeTargetAudienceCode"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditReferralDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditReferralDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["code"] = this.code;
        data["effectiveFrom"] = this.effectiveFrom ? this.effectiveFrom.toISOString() : <any>undefined;
        data["effectiveTo"] = this.effectiveTo ? this.effectiveTo.toISOString() : <any>undefined;
        data["description"] = this.description;
        data["status"] = this.status;
        data["expiredDays"] = this.expiredDays;
        data["orderAmountRequired"] = this.orderAmountRequired;
        data["maxSet"] = this.maxSet;
        data["referrerPoint"] = this.referrerPoint;
        data["referrerCoin"] = this.referrerCoin;
        data["refereePoint"] = this.refereePoint;
        data["refereeCoin"] = this.refereeCoin;
        data["referrerTargetAudienceId"] = this.referrerTargetAudienceId;
        data["refereeTargetAudienceId"] = this.refereeTargetAudienceId;
        data["campaignId"] = this.campaignId;
        data["referrerTargetAudience"] = this.referrerTargetAudience ? this.referrerTargetAudience.toJSON() : <any>undefined;
        data["refereeTargetAudience"] = this.refereeTargetAudience ? this.refereeTargetAudience.toJSON() : <any>undefined;
        data["referrerTargetAudienceCode"] = this.referrerTargetAudienceCode;
        data["refereeTargetAudienceCode"] = this.refereeTargetAudienceCode;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditReferralDto {
    name: string;
    code: string | undefined;
    effectiveFrom: moment.Moment | undefined;
    effectiveTo: moment.Moment | undefined;
    description: string | undefined;
    status: string | undefined;
    expiredDays: number | undefined;
    orderAmountRequired: number | undefined;
    maxSet: number | undefined;
    referrerPoint: number | undefined;
    referrerCoin: number | undefined;
    refereePoint: number | undefined;
    refereeCoin: number | undefined;
    referrerTargetAudienceId: number | undefined;
    refereeTargetAudienceId: number | undefined;
    campaignId: number | undefined;
    referrerTargetAudience: CreateOrEditSettingParamDto | undefined;
    refereeTargetAudience: CreateOrEditSettingParamDto | undefined;
    referrerTargetAudienceCode: string | undefined;
    refereeTargetAudienceCode: string | undefined;
    isDeleted: boolean | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class CreateOrEditEventAmountSettingDto implements ICreateOrEditEventAmountSettingDto {
    code!: string;
    setting!: string;
    amount!: number | undefined;
    coinValue!: number | undefined;
    pointValue!: number | undefined;
    isActive!: boolean | undefined;
    isDeleted!: boolean | undefined;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: moment.Moment | undefined;
    creatorUserId!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditEventAmountSettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.setting = data["setting"];
            this.amount = data["amount"];
            this.coinValue = data["coinValue"];
            this.pointValue = data["pointValue"];
            this.isActive = data["isActive"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditEventAmountSettingDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditEventAmountSettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["setting"] = this.setting;
        data["amount"] = this.amount;
        data["coinValue"] = this.coinValue;
        data["pointValue"] = this.pointValue;
        data["isActive"] = this.isActive;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditEventAmountSettingDto {
    code: string;
    setting: string;
    amount: number | undefined;
    coinValue: number | undefined;
    pointValue: number | undefined;
    isActive: boolean | undefined;
    isDeleted: boolean | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class CreateOrEditProductCategoryDetailSettingDto implements ICreateOrEditProductCategoryDetailSettingDto {
    code!: string | undefined;
    settingCode!: string | undefined;
    type!: CreateOrEditProductCategoryDetailSettingDtoType | undefined;
    value!: string | undefined;
    fullValue!: string | undefined;
    isActive!: boolean | undefined;
    isDeleted!: boolean | undefined;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: moment.Moment | undefined;
    creatorUserId!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditProductCategoryDetailSettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.settingCode = data["settingCode"];
            this.type = data["type"];
            this.value = data["value"];
            this.fullValue = data["fullValue"];
            this.isActive = data["isActive"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditProductCategoryDetailSettingDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditProductCategoryDetailSettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["settingCode"] = this.settingCode;
        data["type"] = this.type;
        data["value"] = this.value;
        data["fullValue"] = this.fullValue;
        data["isActive"] = this.isActive;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditProductCategoryDetailSettingDto {
    code: string | undefined;
    settingCode: string | undefined;
    type: CreateOrEditProductCategoryDetailSettingDtoType | undefined;
    value: string | undefined;
    fullValue: string | undefined;
    isActive: boolean | undefined;
    isDeleted: boolean | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class CreateOrEditProductDetailSettingDto implements ICreateOrEditProductDetailSettingDto {
    settingCode!: string | undefined;
    productId!: number | undefined;
    code!: string | undefined;
    value!: number | undefined;
    pointValue!: number | undefined;
    coinValue!: number | undefined;
    maxSet!: number | undefined;
    isActive!: boolean | undefined;
    effectiveFrom!: moment.Moment | undefined;
    effectiveTo!: moment.Moment | undefined;
    detailType!: string | undefined;
    departmentCode!: string | undefined;
    detailRanks!: CreateOrEditProductDetailRankSettingDto[] | undefined;
    isDeleted!: boolean | undefined;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: moment.Moment | undefined;
    creatorUserId!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditProductDetailSettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.settingCode = data["settingCode"];
            this.productId = data["productId"];
            this.code = data["code"];
            this.value = data["value"];
            this.pointValue = data["pointValue"];
            this.coinValue = data["coinValue"];
            this.maxSet = data["maxSet"];
            this.isActive = data["isActive"];
            this.effectiveFrom = data["effectiveFrom"] ? moment(data["effectiveFrom"].toString()) : <any>undefined;
            this.effectiveTo = data["effectiveTo"] ? moment(data["effectiveTo"].toString()) : <any>undefined;
            this.detailType = data["detailType"];
            this.departmentCode = data["departmentCode"];
            if (data["detailRanks"] && data["detailRanks"].constructor === Array) {
                this.detailRanks = [];
                for (let item of data["detailRanks"])
                    this.detailRanks.push(CreateOrEditProductDetailRankSettingDto.fromJS(item));
            }
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditProductDetailSettingDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditProductDetailSettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["settingCode"] = this.settingCode;
        data["productId"] = this.productId;
        data["code"] = this.code;
        data["value"] = this.value;
        data["pointValue"] = this.pointValue;
        data["coinValue"] = this.coinValue;
        data["maxSet"] = this.maxSet;
        data["isActive"] = this.isActive;
        data["effectiveFrom"] = this.effectiveFrom ? this.effectiveFrom.toISOString() : <any>undefined;
        data["effectiveTo"] = this.effectiveTo ? this.effectiveTo.toISOString() : <any>undefined;
        data["detailType"] = this.detailType;
        data["departmentCode"] = this.departmentCode;
        if (this.detailRanks && this.detailRanks.constructor === Array) {
            data["detailRanks"] = [];
            for (let item of this.detailRanks)
                data["detailRanks"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditProductDetailSettingDto {
    settingCode: string | undefined;
    productId: number | undefined;
    code: string | undefined;
    value: number | undefined;
    pointValue: number | undefined;
    coinValue: number | undefined;
    maxSet: number | undefined;
    isActive: boolean | undefined;
    effectiveFrom: moment.Moment | undefined;
    effectiveTo: moment.Moment | undefined;
    detailType: string | undefined;
    departmentCode: string | undefined;
    detailRanks: CreateOrEditProductDetailRankSettingDto[] | undefined;
    isDeleted: boolean | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class CreateOrEditSeniorityRewardSettingDto implements ICreateOrEditSeniorityRewardSettingDto {
    code!: string;
    senioritySettingCode!: string | undefined;
    seniorityFrom!: number | undefined;
    coinValue!: number | undefined;
    pointValue!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditSeniorityRewardSettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.senioritySettingCode = data["senioritySettingCode"];
            this.seniorityFrom = data["seniorityFrom"];
            this.coinValue = data["coinValue"];
            this.pointValue = data["pointValue"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditSeniorityRewardSettingDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditSeniorityRewardSettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["senioritySettingCode"] = this.senioritySettingCode;
        data["seniorityFrom"] = this.seniorityFrom;
        data["coinValue"] = this.coinValue;
        data["pointValue"] = this.pointValue;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditSeniorityRewardSettingDto {
    code: string;
    senioritySettingCode: string | undefined;
    seniorityFrom: number | undefined;
    coinValue: number | undefined;
    pointValue: number | undefined;
    id: number | undefined;
}

export class CreateOrEditProductDetailRankSettingDto implements ICreateOrEditProductDetailRankSettingDto {
    productSettingDetailId!: number | undefined;
    rankId!: number | undefined;
    pointValue!: number | undefined;
    coinValue!: number | undefined;
    isActive!: boolean | undefined;
    fromQuantity!: number | undefined;
    toQuantity!: number | undefined;
    isDeleted!: boolean | undefined;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: moment.Moment | undefined;
    creatorUserId!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditProductDetailRankSettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.productSettingDetailId = data["productSettingDetailId"];
            this.rankId = data["rankId"];
            this.pointValue = data["pointValue"];
            this.coinValue = data["coinValue"];
            this.isActive = data["isActive"];
            this.fromQuantity = data["fromQuantity"];
            this.toQuantity = data["toQuantity"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditProductDetailRankSettingDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditProductDetailRankSettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productSettingDetailId"] = this.productSettingDetailId;
        data["rankId"] = this.rankId;
        data["pointValue"] = this.pointValue;
        data["coinValue"] = this.coinValue;
        data["isActive"] = this.isActive;
        data["fromQuantity"] = this.fromQuantity;
        data["toQuantity"] = this.toQuantity;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditProductDetailRankSettingDto {
    productSettingDetailId: number | undefined;
    rankId: number | undefined;
    pointValue: number | undefined;
    coinValue: number | undefined;
    isActive: boolean | undefined;
    fromQuantity: number | undefined;
    toQuantity: number | undefined;
    isDeleted: boolean | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfGetCampaignWorkshiftInfoForViewDto implements IPagedResultDtoOfGetCampaignWorkshiftInfoForViewDto {
    totalCount!: number | undefined;
    items!: GetCampaignWorkshiftInfoForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetCampaignWorkshiftInfoForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetCampaignWorkshiftInfoForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetCampaignWorkshiftInfoForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetCampaignWorkshiftInfoForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetCampaignWorkshiftInfoForViewDto {
    totalCount: number | undefined;
    items: GetCampaignWorkshiftInfoForViewDto[] | undefined;
}

export class GetCampaignWorkshiftInfoForViewDto implements IGetCampaignWorkshiftInfoForViewDto {
    campaignWorkshiftInfo!: CampaignWorkshiftInfoDto | undefined;

    constructor(data?: IGetCampaignWorkshiftInfoForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.campaignWorkshiftInfo = data["campaignWorkshiftInfo"] ? CampaignWorkshiftInfoDto.fromJS(data["campaignWorkshiftInfo"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCampaignWorkshiftInfoForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCampaignWorkshiftInfoForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["campaignWorkshiftInfo"] = this.campaignWorkshiftInfo ? this.campaignWorkshiftInfo.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetCampaignWorkshiftInfoForViewDto {
    campaignWorkshiftInfo: CampaignWorkshiftInfoDto | undefined;
}

export class CampaignWorkshiftInfoDto implements ICampaignWorkshiftInfoDto {
    campaignID!: number | undefined;
    workshiftName!: string | undefined;
    fromdate!: moment.Moment | undefined;
    todate!: moment.Moment | undefined;
    status!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICampaignWorkshiftInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.campaignID = data["campaignID"];
            this.workshiftName = data["workshiftName"];
            this.fromdate = data["fromdate"] ? moment(data["fromdate"].toString()) : <any>undefined;
            this.todate = data["todate"] ? moment(data["todate"].toString()) : <any>undefined;
            this.status = data["status"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CampaignWorkshiftInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new CampaignWorkshiftInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["campaignID"] = this.campaignID;
        data["workshiftName"] = this.workshiftName;
        data["fromdate"] = this.fromdate ? this.fromdate.toISOString() : <any>undefined;
        data["todate"] = this.todate ? this.todate.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["id"] = this.id;
        return data;
    }
}

export interface ICampaignWorkshiftInfoDto {
    campaignID: number | undefined;
    workshiftName: string | undefined;
    fromdate: moment.Moment | undefined;
    todate: moment.Moment | undefined;
    status: string | undefined;
    id: number | undefined;
}

export class GetCampaignWorkshiftInfoForEditOutput implements IGetCampaignWorkshiftInfoForEditOutput {
    campaignWorkshiftInfo!: CreateOrEditCampaignWorkshiftInfoDto | undefined;

    constructor(data?: IGetCampaignWorkshiftInfoForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.campaignWorkshiftInfo = data["campaignWorkshiftInfo"] ? CreateOrEditCampaignWorkshiftInfoDto.fromJS(data["campaignWorkshiftInfo"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCampaignWorkshiftInfoForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetCampaignWorkshiftInfoForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["campaignWorkshiftInfo"] = this.campaignWorkshiftInfo ? this.campaignWorkshiftInfo.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetCampaignWorkshiftInfoForEditOutput {
    campaignWorkshiftInfo: CreateOrEditCampaignWorkshiftInfoDto | undefined;
}

export class CreateOrEditCampaignWorkshiftInfoDto implements ICreateOrEditCampaignWorkshiftInfoDto {
    campaignID!: number | undefined;
    workshiftName!: string | undefined;
    fromdate!: moment.Moment | undefined;
    todate!: moment.Moment | undefined;
    status!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditCampaignWorkshiftInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.campaignID = data["campaignID"];
            this.workshiftName = data["workshiftName"];
            this.fromdate = data["fromdate"] ? moment(data["fromdate"].toString()) : <any>undefined;
            this.todate = data["todate"] ? moment(data["todate"].toString()) : <any>undefined;
            this.status = data["status"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditCampaignWorkshiftInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditCampaignWorkshiftInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["campaignID"] = this.campaignID;
        data["workshiftName"] = this.workshiftName;
        data["fromdate"] = this.fromdate ? this.fromdate.toISOString() : <any>undefined;
        data["todate"] = this.todate ? this.todate.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditCampaignWorkshiftInfoDto {
    campaignID: number | undefined;
    workshiftName: string | undefined;
    fromdate: moment.Moment | undefined;
    todate: moment.Moment | undefined;
    status: string | undefined;
    id: number | undefined;
}

export class CasherInfoInput implements ICasherInfoInput {
    userName!: string;
    password!: string;
    deviceID!: string | undefined;

    constructor(data?: ICasherInfoInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userName = data["userName"];
            this.password = data["password"];
            this.deviceID = data["deviceID"];
        }
    }

    static fromJS(data: any): CasherInfoInput {
        data = typeof data === 'object' ? data : {};
        let result = new CasherInfoInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["password"] = this.password;
        data["deviceID"] = this.deviceID;
        return data;
    }
}

export interface ICasherInfoInput {
    userName: string;
    password: string;
    deviceID: string | undefined;
}

export class CasherInfoDto implements ICasherInfoDto {
    casherCode!: string | undefined;
    cashierID!: number | undefined;
    accessToken!: string | undefined;
    encryptedAccessToken!: string | undefined;
    expireInSeconds!: number | undefined;
    currentDatetime!: moment.Moment | undefined;

    constructor(data?: ICasherInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.casherCode = data["casherCode"];
            this.cashierID = data["cashierID"];
            this.accessToken = data["accessToken"];
            this.encryptedAccessToken = data["encryptedAccessToken"];
            this.expireInSeconds = data["expireInSeconds"];
            this.currentDatetime = data["currentDatetime"] ? moment(data["currentDatetime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CasherInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new CasherInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["casherCode"] = this.casherCode;
        data["cashierID"] = this.cashierID;
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        data["currentDatetime"] = this.currentDatetime ? this.currentDatetime.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICasherInfoDto {
    casherCode: string | undefined;
    cashierID: number | undefined;
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number | undefined;
    currentDatetime: moment.Moment | undefined;
}

export class PagedResultDtoOfGetCategoryForView implements IPagedResultDtoOfGetCategoryForView {
    totalCount!: number | undefined;
    items!: GetCategoryForView[] | undefined;

    constructor(data?: IPagedResultDtoOfGetCategoryForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetCategoryForView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetCategoryForView {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetCategoryForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetCategoryForView {
    totalCount: number | undefined;
    items: GetCategoryForView[] | undefined;
}

export class GetCategoryForView implements IGetCategoryForView {
    category!: CategoryDto | undefined;
    userName!: string | undefined;

    constructor(data?: IGetCategoryForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.category = data["category"] ? CategoryDto.fromJS(data["category"]) : <any>undefined;
            this.userName = data["userName"];
        }
    }

    static fromJS(data: any): GetCategoryForView {
        data = typeof data === 'object' ? data : {};
        let result = new GetCategoryForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["category"] = this.category ? this.category.toJSON() : <any>undefined;
        data["userName"] = this.userName;
        return data;
    }
}

export interface IGetCategoryForView {
    category: CategoryDto | undefined;
    userName: string | undefined;
}

export class CategoryDto implements ICategoryDto {
    code!: string | undefined;
    name!: string | undefined;
    ordinal!: number | undefined;
    status!: string | undefined;
    tenantId!: number | undefined;
    type!: number | undefined;
    isDeleted!: boolean | undefined;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: moment.Moment | undefined;
    creatorUserId!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.name = data["name"];
            this.ordinal = data["ordinal"];
            this.status = data["status"];
            this.tenantId = data["tenantId"];
            this.type = data["type"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CategoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["ordinal"] = this.ordinal;
        data["status"] = this.status;
        data["tenantId"] = this.tenantId;
        data["type"] = this.type;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICategoryDto {
    code: string | undefined;
    name: string | undefined;
    ordinal: number | undefined;
    status: string | undefined;
    tenantId: number | undefined;
    type: number | undefined;
    isDeleted: boolean | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class GetCategoryForEditOutput implements IGetCategoryForEditOutput {
    category!: CreateOrEditCategoryDto | undefined;
    categoryDetail!: CreateOrEditCategoryDetailDto[] | undefined;
    userName!: string | undefined;

    constructor(data?: IGetCategoryForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.category = data["category"] ? CreateOrEditCategoryDto.fromJS(data["category"]) : <any>undefined;
            if (data["categoryDetail"] && data["categoryDetail"].constructor === Array) {
                this.categoryDetail = [];
                for (let item of data["categoryDetail"])
                    this.categoryDetail.push(CreateOrEditCategoryDetailDto.fromJS(item));
            }
            this.userName = data["userName"];
        }
    }

    static fromJS(data: any): GetCategoryForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetCategoryForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["category"] = this.category ? this.category.toJSON() : <any>undefined;
        if (this.categoryDetail && this.categoryDetail.constructor === Array) {
            data["categoryDetail"] = [];
            for (let item of this.categoryDetail)
                data["categoryDetail"].push(item.toJSON());
        }
        data["userName"] = this.userName;
        return data;
    }
}

export interface IGetCategoryForEditOutput {
    category: CreateOrEditCategoryDto | undefined;
    categoryDetail: CreateOrEditCategoryDetailDto[] | undefined;
    userName: string | undefined;
}

export class CreateOrEditCategoryDto implements ICreateOrEditCategoryDto {
    code!: string;
    name!: string | undefined;
    ordinal!: number | undefined;
    status!: string | undefined;
    type!: string | undefined;
    tenantId!: number | undefined;
    categoryDetail!: CreateOrEditCategoryDetailDto[] | undefined;
    deletedCategoryDetail!: number[] | undefined;
    isDeleted!: boolean | undefined;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: moment.Moment | undefined;
    creatorUserId!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditCategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.name = data["name"];
            this.ordinal = data["ordinal"];
            this.status = data["status"];
            this.type = data["type"];
            this.tenantId = data["tenantId"];
            if (data["categoryDetail"] && data["categoryDetail"].constructor === Array) {
                this.categoryDetail = [];
                for (let item of data["categoryDetail"])
                    this.categoryDetail.push(CreateOrEditCategoryDetailDto.fromJS(item));
            }
            if (data["deletedCategoryDetail"] && data["deletedCategoryDetail"].constructor === Array) {
                this.deletedCategoryDetail = [];
                for (let item of data["deletedCategoryDetail"])
                    this.deletedCategoryDetail.push(item);
            }
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditCategoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditCategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["ordinal"] = this.ordinal;
        data["status"] = this.status;
        data["type"] = this.type;
        data["tenantId"] = this.tenantId;
        if (this.categoryDetail && this.categoryDetail.constructor === Array) {
            data["categoryDetail"] = [];
            for (let item of this.categoryDetail)
                data["categoryDetail"].push(item.toJSON());
        }
        if (this.deletedCategoryDetail && this.deletedCategoryDetail.constructor === Array) {
            data["deletedCategoryDetail"] = [];
            for (let item of this.deletedCategoryDetail)
                data["deletedCategoryDetail"].push(item);
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditCategoryDto {
    code: string;
    name: string | undefined;
    ordinal: number | undefined;
    status: string | undefined;
    type: string | undefined;
    tenantId: number | undefined;
    categoryDetail: CreateOrEditCategoryDetailDto[] | undefined;
    deletedCategoryDetail: number[] | undefined;
    isDeleted: boolean | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class CreateOrEditCategoryDetailDto implements ICreateOrEditCategoryDetailDto {
    categoryCode!: string | undefined;
    articleCode!: string | undefined;
    ordinal!: number | undefined;
    tenantId!: number | undefined;
    isDeleted!: boolean | undefined;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: moment.Moment | undefined;
    creatorUserId!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditCategoryDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.categoryCode = data["categoryCode"];
            this.articleCode = data["articleCode"];
            this.ordinal = data["ordinal"];
            this.tenantId = data["tenantId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditCategoryDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditCategoryDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["categoryCode"] = this.categoryCode;
        data["articleCode"] = this.articleCode;
        data["ordinal"] = this.ordinal;
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditCategoryDetailDto {
    categoryCode: string | undefined;
    articleCode: string | undefined;
    ordinal: number | undefined;
    tenantId: number | undefined;
    isDeleted: boolean | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class HomePageCategoryForView implements IHomePageCategoryForView {
    categories!: HomePageCategory[] | undefined;

    constructor(data?: IHomePageCategoryForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["categories"] && data["categories"].constructor === Array) {
                this.categories = [];
                for (let item of data["categories"])
                    this.categories.push(HomePageCategory.fromJS(item));
            }
        }
    }

    static fromJS(data: any): HomePageCategoryForView {
        data = typeof data === 'object' ? data : {};
        let result = new HomePageCategoryForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.categories && this.categories.constructor === Array) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item.toJSON());
        }
        return data;
    }
}

export interface IHomePageCategoryForView {
    categories: HomePageCategory[] | undefined;
}

export class HomePageCategory implements IHomePageCategory {
    type!: number | undefined;
    typeName!: string | undefined;
    articles!: ArticleDto[] | undefined;

    constructor(data?: IHomePageCategory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.type = data["type"];
            this.typeName = data["typeName"];
            if (data["articles"] && data["articles"].constructor === Array) {
                this.articles = [];
                for (let item of data["articles"])
                    this.articles.push(ArticleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): HomePageCategory {
        data = typeof data === 'object' ? data : {};
        let result = new HomePageCategory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["typeName"] = this.typeName;
        if (this.articles && this.articles.constructor === Array) {
            data["articles"] = [];
            for (let item of this.articles)
                data["articles"].push(item.toJSON());
        }
        return data;
    }
}

export interface IHomePageCategory {
    type: number | undefined;
    typeName: string | undefined;
    articles: ArticleDto[] | undefined;
}

export class DeleteCategoryDto implements IDeleteCategoryDto {
    ids!: number[] | undefined;

    constructor(data?: IDeleteCategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["ids"] && data["ids"].constructor === Array) {
                this.ids = [];
                for (let item of data["ids"])
                    this.ids.push(item);
            }
        }
    }

    static fromJS(data: any): DeleteCategoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteCategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.ids && this.ids.constructor === Array) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        return data;
    }
}

export interface IDeleteCategoryDto {
    ids: number[] | undefined;
}

export class PagedResultDtoOfGetCoinBaselineForViewDto implements IPagedResultDtoOfGetCoinBaselineForViewDto {
    totalCount!: number | undefined;
    items!: GetCoinBaselineForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetCoinBaselineForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetCoinBaselineForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetCoinBaselineForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetCoinBaselineForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetCoinBaselineForViewDto {
    totalCount: number | undefined;
    items: GetCoinBaselineForViewDto[] | undefined;
}

export class GetCoinBaselineForViewDto implements IGetCoinBaselineForViewDto {
    coinBaseline!: CoinBaselineDto | undefined;

    constructor(data?: IGetCoinBaselineForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.coinBaseline = data["coinBaseline"] ? CoinBaselineDto.fromJS(data["coinBaseline"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCoinBaselineForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCoinBaselineForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["coinBaseline"] = this.coinBaseline ? this.coinBaseline.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetCoinBaselineForViewDto {
    coinBaseline: CoinBaselineDto | undefined;
}

export class CoinBaselineDto implements ICoinBaselineDto {
    memberCode!: string | undefined;
    month!: number | undefined;
    coinGranted!: number | undefined;
    coinRedeemed!: number | undefined;
    coinAvailable!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICoinBaselineDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberCode = data["memberCode"];
            this.month = data["month"];
            this.coinGranted = data["coinGranted"];
            this.coinRedeemed = data["coinRedeemed"];
            this.coinAvailable = data["coinAvailable"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CoinBaselineDto {
        data = typeof data === 'object' ? data : {};
        let result = new CoinBaselineDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberCode"] = this.memberCode;
        data["month"] = this.month;
        data["coinGranted"] = this.coinGranted;
        data["coinRedeemed"] = this.coinRedeemed;
        data["coinAvailable"] = this.coinAvailable;
        data["id"] = this.id;
        return data;
    }
}

export interface ICoinBaselineDto {
    memberCode: string | undefined;
    month: number | undefined;
    coinGranted: number | undefined;
    coinRedeemed: number | undefined;
    coinAvailable: number | undefined;
    id: number | undefined;
}

export class GetCoinBaselineForEditOutput implements IGetCoinBaselineForEditOutput {
    coinBaseline!: CreateOrEditCoinBaselineDto | undefined;

    constructor(data?: IGetCoinBaselineForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.coinBaseline = data["coinBaseline"] ? CreateOrEditCoinBaselineDto.fromJS(data["coinBaseline"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCoinBaselineForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetCoinBaselineForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["coinBaseline"] = this.coinBaseline ? this.coinBaseline.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetCoinBaselineForEditOutput {
    coinBaseline: CreateOrEditCoinBaselineDto | undefined;
}

export class CreateOrEditCoinBaselineDto implements ICreateOrEditCoinBaselineDto {
    memberCode!: string | undefined;
    month!: number | undefined;
    coinGranted!: number | undefined;
    coinRedeemed!: number | undefined;
    coinAvailable!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditCoinBaselineDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberCode = data["memberCode"];
            this.month = data["month"];
            this.coinGranted = data["coinGranted"];
            this.coinRedeemed = data["coinRedeemed"];
            this.coinAvailable = data["coinAvailable"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditCoinBaselineDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditCoinBaselineDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberCode"] = this.memberCode;
        data["month"] = this.month;
        data["coinGranted"] = this.coinGranted;
        data["coinRedeemed"] = this.coinRedeemed;
        data["coinAvailable"] = this.coinAvailable;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditCoinBaselineDto {
    memberCode: string | undefined;
    month: number | undefined;
    coinGranted: number | undefined;
    coinRedeemed: number | undefined;
    coinAvailable: number | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfGetCoinExpirationSettingForView implements IPagedResultDtoOfGetCoinExpirationSettingForView {
    totalCount!: number | undefined;
    items!: GetCoinExpirationSettingForView[] | undefined;

    constructor(data?: IPagedResultDtoOfGetCoinExpirationSettingForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetCoinExpirationSettingForView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetCoinExpirationSettingForView {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetCoinExpirationSettingForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetCoinExpirationSettingForView {
    totalCount: number | undefined;
    items: GetCoinExpirationSettingForView[] | undefined;
}

export class GetCoinExpirationSettingForView implements IGetCoinExpirationSettingForView {
    coinExpirationSetting!: CoinExpirationSettingDto | undefined;

    constructor(data?: IGetCoinExpirationSettingForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.coinExpirationSetting = data["coinExpirationSetting"] ? CoinExpirationSettingDto.fromJS(data["coinExpirationSetting"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCoinExpirationSettingForView {
        data = typeof data === 'object' ? data : {};
        let result = new GetCoinExpirationSettingForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["coinExpirationSetting"] = this.coinExpirationSetting ? this.coinExpirationSetting.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetCoinExpirationSettingForView {
    coinExpirationSetting: CoinExpirationSettingDto | undefined;
}

export class CoinExpirationSettingDto implements ICoinExpirationSettingDto {
    code!: string | undefined;
    isActive!: boolean | undefined;
    validCoinType!: string | undefined;
    validCoinMonths!: number | undefined;
    validCoinPeriodDuration!: number | undefined;
    validCoinPeriodExtendMonths!: number | undefined;
    validCoinPeriodStartMonth!: moment.Moment | undefined;
    source!: string | undefined;
    validCoinDays!: number | undefined;
    cron!: string | undefined;
    timezone!: string | undefined;
    calculationPeriodDuration!: number | undefined;
    calculationPeriodStartMonth!: moment.Moment | undefined;
    calculationType!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICoinExpirationSettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.isActive = data["isActive"];
            this.validCoinType = data["validCoinType"];
            this.validCoinMonths = data["validCoinMonths"];
            this.validCoinPeriodDuration = data["validCoinPeriodDuration"];
            this.validCoinPeriodExtendMonths = data["validCoinPeriodExtendMonths"];
            this.validCoinPeriodStartMonth = data["validCoinPeriodStartMonth"] ? moment(data["validCoinPeriodStartMonth"].toString()) : <any>undefined;
            this.source = data["source"];
            this.validCoinDays = data["validCoinDays"];
            this.cron = data["cron"];
            this.timezone = data["timezone"];
            this.calculationPeriodDuration = data["calculationPeriodDuration"];
            this.calculationPeriodStartMonth = data["calculationPeriodStartMonth"] ? moment(data["calculationPeriodStartMonth"].toString()) : <any>undefined;
            this.calculationType = data["calculationType"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CoinExpirationSettingDto {
        data = typeof data === 'object' ? data : {};
        let result = new CoinExpirationSettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["isActive"] = this.isActive;
        data["validCoinType"] = this.validCoinType;
        data["validCoinMonths"] = this.validCoinMonths;
        data["validCoinPeriodDuration"] = this.validCoinPeriodDuration;
        data["validCoinPeriodExtendMonths"] = this.validCoinPeriodExtendMonths;
        data["validCoinPeriodStartMonth"] = this.validCoinPeriodStartMonth ? this.validCoinPeriodStartMonth.toISOString() : <any>undefined;
        data["source"] = this.source;
        data["validCoinDays"] = this.validCoinDays;
        data["cron"] = this.cron;
        data["timezone"] = this.timezone;
        data["calculationPeriodDuration"] = this.calculationPeriodDuration;
        data["calculationPeriodStartMonth"] = this.calculationPeriodStartMonth ? this.calculationPeriodStartMonth.toISOString() : <any>undefined;
        data["calculationType"] = this.calculationType;
        data["id"] = this.id;
        return data;
    }
}

export interface ICoinExpirationSettingDto {
    code: string | undefined;
    isActive: boolean | undefined;
    validCoinType: string | undefined;
    validCoinMonths: number | undefined;
    validCoinPeriodDuration: number | undefined;
    validCoinPeriodExtendMonths: number | undefined;
    validCoinPeriodStartMonth: moment.Moment | undefined;
    source: string | undefined;
    validCoinDays: number | undefined;
    cron: string | undefined;
    timezone: string | undefined;
    calculationPeriodDuration: number | undefined;
    calculationPeriodStartMonth: moment.Moment | undefined;
    calculationType: string | undefined;
    id: number | undefined;
}

export class GetCoinExpirationSettingForEditOutput implements IGetCoinExpirationSettingForEditOutput {
    coinExpirationSetting!: CreateOrEditCoinExpirationSettingDto | undefined;

    constructor(data?: IGetCoinExpirationSettingForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.coinExpirationSetting = data["coinExpirationSetting"] ? CreateOrEditCoinExpirationSettingDto.fromJS(data["coinExpirationSetting"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCoinExpirationSettingForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetCoinExpirationSettingForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["coinExpirationSetting"] = this.coinExpirationSetting ? this.coinExpirationSetting.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetCoinExpirationSettingForEditOutput {
    coinExpirationSetting: CreateOrEditCoinExpirationSettingDto | undefined;
}

export class CreateOrEditCoinExpirationSettingDto implements ICreateOrEditCoinExpirationSettingDto {
    code!: string | undefined;
    isActive!: boolean | undefined;
    validCoinType!: string | undefined;
    validCoinMonths!: number | undefined;
    validCoinPeriodDuration!: number | undefined;
    validCoinPeriodExtendMonths!: number | undefined;
    validCoinPeriodStartMonth!: moment.Moment | undefined;
    source!: string | undefined;
    validCoinDays!: number | undefined;
    cron!: string | undefined;
    timezone!: string | undefined;
    calculationPeriodDuration!: number | undefined;
    calculationPeriodStartMonth!: moment.Moment | undefined;
    calculationType!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditCoinExpirationSettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.isActive = data["isActive"];
            this.validCoinType = data["validCoinType"];
            this.validCoinMonths = data["validCoinMonths"];
            this.validCoinPeriodDuration = data["validCoinPeriodDuration"];
            this.validCoinPeriodExtendMonths = data["validCoinPeriodExtendMonths"];
            this.validCoinPeriodStartMonth = data["validCoinPeriodStartMonth"] ? moment(data["validCoinPeriodStartMonth"].toString()) : <any>undefined;
            this.source = data["source"];
            this.validCoinDays = data["validCoinDays"];
            this.cron = data["cron"];
            this.timezone = data["timezone"];
            this.calculationPeriodDuration = data["calculationPeriodDuration"];
            this.calculationPeriodStartMonth = data["calculationPeriodStartMonth"] ? moment(data["calculationPeriodStartMonth"].toString()) : <any>undefined;
            this.calculationType = data["calculationType"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditCoinExpirationSettingDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditCoinExpirationSettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["isActive"] = this.isActive;
        data["validCoinType"] = this.validCoinType;
        data["validCoinMonths"] = this.validCoinMonths;
        data["validCoinPeriodDuration"] = this.validCoinPeriodDuration;
        data["validCoinPeriodExtendMonths"] = this.validCoinPeriodExtendMonths;
        data["validCoinPeriodStartMonth"] = this.validCoinPeriodStartMonth ? this.validCoinPeriodStartMonth.toISOString() : <any>undefined;
        data["source"] = this.source;
        data["validCoinDays"] = this.validCoinDays;
        data["cron"] = this.cron;
        data["timezone"] = this.timezone;
        data["calculationPeriodDuration"] = this.calculationPeriodDuration;
        data["calculationPeriodStartMonth"] = this.calculationPeriodStartMonth ? this.calculationPeriodStartMonth.toISOString() : <any>undefined;
        data["calculationType"] = this.calculationType;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditCoinExpirationSettingDto {
    code: string | undefined;
    isActive: boolean | undefined;
    validCoinType: string | undefined;
    validCoinMonths: number | undefined;
    validCoinPeriodDuration: number | undefined;
    validCoinPeriodExtendMonths: number | undefined;
    validCoinPeriodStartMonth: moment.Moment | undefined;
    source: string | undefined;
    validCoinDays: number | undefined;
    cron: string | undefined;
    timezone: string | undefined;
    calculationPeriodDuration: number | undefined;
    calculationPeriodStartMonth: moment.Moment | undefined;
    calculationType: string | undefined;
    id: number | undefined;
}

export class ReponseTimeCalBaseLine implements IReponseTimeCalBaseLine {
    startTime!: moment.Moment | undefined;
    endTime!: moment.Moment | undefined;

    constructor(data?: IReponseTimeCalBaseLine) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.startTime = data["startTime"] ? moment(data["startTime"].toString()) : <any>undefined;
            this.endTime = data["endTime"] ? moment(data["endTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ReponseTimeCalBaseLine {
        data = typeof data === 'object' ? data : {};
        let result = new ReponseTimeCalBaseLine();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IReponseTimeCalBaseLine {
    startTime: moment.Moment | undefined;
    endTime: moment.Moment | undefined;
}

export class PagedResultDtoOfGetCoinUsageHistoryForViewDto implements IPagedResultDtoOfGetCoinUsageHistoryForViewDto {
    totalCount!: number | undefined;
    items!: GetCoinUsageHistoryForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetCoinUsageHistoryForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetCoinUsageHistoryForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetCoinUsageHistoryForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetCoinUsageHistoryForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetCoinUsageHistoryForViewDto {
    totalCount: number | undefined;
    items: GetCoinUsageHistoryForViewDto[] | undefined;
}

export class GetCoinUsageHistoryForViewDto implements IGetCoinUsageHistoryForViewDto {
    coinUsageHistory!: CoinUsageHistoryDto | undefined;

    constructor(data?: IGetCoinUsageHistoryForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.coinUsageHistory = data["coinUsageHistory"] ? CoinUsageHistoryDto.fromJS(data["coinUsageHistory"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCoinUsageHistoryForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCoinUsageHistoryForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["coinUsageHistory"] = this.coinUsageHistory ? this.coinUsageHistory.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetCoinUsageHistoryForViewDto {
    coinUsageHistory: CoinUsageHistoryDto | undefined;
}

export class CoinUsageHistoryDto implements ICoinUsageHistoryDto {
    consumerID!: number | undefined;
    memberCode!: string | undefined;
    transactionCode!: string | undefined;
    businessTime!: moment.Moment | undefined;
    transactionCoinBaselineID!: number | undefined;
    coinUsed!: number | undefined;
    lastCoin!: number | undefined;
    reason!: string | undefined;
    source!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICoinUsageHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.consumerID = data["consumerID"];
            this.memberCode = data["memberCode"];
            this.transactionCode = data["transactionCode"];
            this.businessTime = data["businessTime"] ? moment(data["businessTime"].toString()) : <any>undefined;
            this.transactionCoinBaselineID = data["transactionCoinBaselineID"];
            this.coinUsed = data["coinUsed"];
            this.lastCoin = data["lastCoin"];
            this.reason = data["reason"];
            this.source = data["source"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CoinUsageHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CoinUsageHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["consumerID"] = this.consumerID;
        data["memberCode"] = this.memberCode;
        data["transactionCode"] = this.transactionCode;
        data["businessTime"] = this.businessTime ? this.businessTime.toISOString() : <any>undefined;
        data["transactionCoinBaselineID"] = this.transactionCoinBaselineID;
        data["coinUsed"] = this.coinUsed;
        data["lastCoin"] = this.lastCoin;
        data["reason"] = this.reason;
        data["source"] = this.source;
        data["id"] = this.id;
        return data;
    }
}

export interface ICoinUsageHistoryDto {
    consumerID: number | undefined;
    memberCode: string | undefined;
    transactionCode: string | undefined;
    businessTime: moment.Moment | undefined;
    transactionCoinBaselineID: number | undefined;
    coinUsed: number | undefined;
    lastCoin: number | undefined;
    reason: string | undefined;
    source: string | undefined;
    id: number | undefined;
}

export class GetCoinUsageHistoryForEditOutput implements IGetCoinUsageHistoryForEditOutput {
    coinUsageHistory!: CreateOrEditCoinUsageHistoryDto | undefined;

    constructor(data?: IGetCoinUsageHistoryForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.coinUsageHistory = data["coinUsageHistory"] ? CreateOrEditCoinUsageHistoryDto.fromJS(data["coinUsageHistory"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCoinUsageHistoryForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetCoinUsageHistoryForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["coinUsageHistory"] = this.coinUsageHistory ? this.coinUsageHistory.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetCoinUsageHistoryForEditOutput {
    coinUsageHistory: CreateOrEditCoinUsageHistoryDto | undefined;
}

export class CreateOrEditCoinUsageHistoryDto implements ICreateOrEditCoinUsageHistoryDto {
    consumerID!: number | undefined;
    memberCode!: string | undefined;
    transactionCode!: string | undefined;
    businessTime!: moment.Moment | undefined;
    transactionCoinBaselineID!: number | undefined;
    coinUsed!: number | undefined;
    lastCoin!: number | undefined;
    reason!: string | undefined;
    source!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditCoinUsageHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.consumerID = data["consumerID"];
            this.memberCode = data["memberCode"];
            this.transactionCode = data["transactionCode"];
            this.businessTime = data["businessTime"] ? moment(data["businessTime"].toString()) : <any>undefined;
            this.transactionCoinBaselineID = data["transactionCoinBaselineID"];
            this.coinUsed = data["coinUsed"];
            this.lastCoin = data["lastCoin"];
            this.reason = data["reason"];
            this.source = data["source"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditCoinUsageHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditCoinUsageHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["consumerID"] = this.consumerID;
        data["memberCode"] = this.memberCode;
        data["transactionCode"] = this.transactionCode;
        data["businessTime"] = this.businessTime ? this.businessTime.toISOString() : <any>undefined;
        data["transactionCoinBaselineID"] = this.transactionCoinBaselineID;
        data["coinUsed"] = this.coinUsed;
        data["lastCoin"] = this.lastCoin;
        data["reason"] = this.reason;
        data["source"] = this.source;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditCoinUsageHistoryDto {
    consumerID: number | undefined;
    memberCode: string | undefined;
    transactionCode: string | undefined;
    businessTime: moment.Moment | undefined;
    transactionCoinBaselineID: number | undefined;
    coinUsed: number | undefined;
    lastCoin: number | undefined;
    reason: string | undefined;
    source: string | undefined;
    id: number | undefined;
}

export class ListResultDtoOfSubscribableEditionComboboxItemDto implements IListResultDtoOfSubscribableEditionComboboxItemDto {
    items!: SubscribableEditionComboboxItemDto[] | undefined;

    constructor(data?: IListResultDtoOfSubscribableEditionComboboxItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(SubscribableEditionComboboxItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfSubscribableEditionComboboxItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfSubscribableEditionComboboxItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListResultDtoOfSubscribableEditionComboboxItemDto {
    items: SubscribableEditionComboboxItemDto[] | undefined;
}

export class SubscribableEditionComboboxItemDto implements ISubscribableEditionComboboxItemDto {
    isFree!: boolean | undefined;
    value!: string | undefined;
    displayText!: string | undefined;
    isSelected!: boolean | undefined;

    constructor(data?: ISubscribableEditionComboboxItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isFree = data["isFree"];
            this.value = data["value"];
            this.displayText = data["displayText"];
            this.isSelected = data["isSelected"];
        }
    }

    static fromJS(data: any): SubscribableEditionComboboxItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubscribableEditionComboboxItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isFree"] = this.isFree;
        data["value"] = this.value;
        data["displayText"] = this.displayText;
        data["isSelected"] = this.isSelected;
        return data;
    }
}

export interface ISubscribableEditionComboboxItemDto {
    isFree: boolean | undefined;
    value: string | undefined;
    displayText: string | undefined;
    isSelected: boolean | undefined;
}

export class FindUsersInput implements IFindUsersInput {
    tenantId!: number | undefined;
    maxResultCount!: number | undefined;
    skipCount!: number | undefined;
    filter!: string | undefined;

    constructor(data?: IFindUsersInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.maxResultCount = data["maxResultCount"];
            this.skipCount = data["skipCount"];
            this.filter = data["filter"];
        }
    }

    static fromJS(data: any): FindUsersInput {
        data = typeof data === 'object' ? data : {};
        let result = new FindUsersInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["filter"] = this.filter;
        return data;
    }
}

export interface IFindUsersInput {
    tenantId: number | undefined;
    maxResultCount: number | undefined;
    skipCount: number | undefined;
    filter: string | undefined;
}

export class PagedResultDtoOfNameValueDto implements IPagedResultDtoOfNameValueDto {
    totalCount!: number | undefined;
    items!: NameValueDto[] | undefined;

    constructor(data?: IPagedResultDtoOfNameValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(NameValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfNameValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfNameValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfNameValueDto {
    totalCount: number | undefined;
    items: NameValueDto[] | undefined;
}

export class GetDefaultEditionNameOutput implements IGetDefaultEditionNameOutput {
    name!: string | undefined;

    constructor(data?: IGetDefaultEditionNameOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
        }
    }

    static fromJS(data: any): GetDefaultEditionNameOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetDefaultEditionNameOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface IGetDefaultEditionNameOutput {
    name: string | undefined;
}

export class PagedResultDtoOfGetCommunicationForViewDto implements IPagedResultDtoOfGetCommunicationForViewDto {
    totalCount!: number | undefined;
    items!: GetCommunicationForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetCommunicationForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetCommunicationForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetCommunicationForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetCommunicationForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetCommunicationForViewDto {
    totalCount: number | undefined;
    items: GetCommunicationForViewDto[] | undefined;
}

export class GetCommunicationForViewDto implements IGetCommunicationForViewDto {
    communication!: CommunicationDto | undefined;
    communicationTargetAudienceTargetAudienceName!: string | undefined;
    targetAudience!: GetTargetAudienceForViewDto | undefined;

    constructor(data?: IGetCommunicationForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.communication = data["communication"] ? CommunicationDto.fromJS(data["communication"]) : <any>undefined;
            this.communicationTargetAudienceTargetAudienceName = data["communicationTargetAudienceTargetAudienceName"];
            this.targetAudience = data["targetAudience"] ? GetTargetAudienceForViewDto.fromJS(data["targetAudience"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCommunicationForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCommunicationForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["communication"] = this.communication ? this.communication.toJSON() : <any>undefined;
        data["communicationTargetAudienceTargetAudienceName"] = this.communicationTargetAudienceTargetAudienceName;
        data["targetAudience"] = this.targetAudience ? this.targetAudience.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetCommunicationForViewDto {
    communication: CommunicationDto | undefined;
    communicationTargetAudienceTargetAudienceName: string | undefined;
    targetAudience: GetTargetAudienceForViewDto | undefined;
}

export class CommunicationDto implements ICommunicationDto {
    channel!: string | undefined;
    languageDefault!: string | undefined;
    name!: string | undefined;
    status!: string | undefined;
    communicationTargetAudienceID!: number | undefined;
    cron!: string | undefined;
    fromDate!: moment.Moment | undefined;
    toDate!: moment.Moment | undefined;
    description!: string | undefined;
    messageType!: string | undefined;
    messageAction!: string | undefined;
    contentType!: string | undefined;
    contentVN!: string | undefined;
    contentEN!: string | undefined;
    subjectVN!: string | undefined;
    subjectEN!: string | undefined;
    imageURL!: string | undefined;
    extraURL!: string | undefined;
    nameUnsign!: string | undefined;
    extraParam!: string | undefined;
    targetAudienceType!: string | undefined;
    immediatelyOnEvent!: boolean | undefined;
    eventType!: string | undefined;
    broadcastCategory!: string | undefined;
    targetScreen!: string | undefined;
    lastModificationTime!: moment.Moment | undefined;
    nameUnSign!: string | undefined;
    creationTime!: moment.Moment | undefined;
    actions!: ActionsInfo[] | undefined;
    actionsString!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICommunicationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.channel = data["channel"];
            this.languageDefault = data["languageDefault"];
            this.name = data["name"];
            this.status = data["status"];
            this.communicationTargetAudienceID = data["communicationTargetAudienceID"];
            this.cron = data["cron"];
            this.fromDate = data["fromDate"] ? moment(data["fromDate"].toString()) : <any>undefined;
            this.toDate = data["toDate"] ? moment(data["toDate"].toString()) : <any>undefined;
            this.description = data["description"];
            this.messageType = data["messageType"];
            this.messageAction = data["messageAction"];
            this.contentType = data["contentType"];
            this.contentVN = data["contentVN"];
            this.contentEN = data["contentEN"];
            this.subjectVN = data["subjectVN"];
            this.subjectEN = data["subjectEN"];
            this.imageURL = data["imageURL"];
            this.extraURL = data["extraURL"];
            this.nameUnsign = data["nameUnsign"];
            this.extraParam = data["extraParam"];
            this.targetAudienceType = data["targetAudienceType"];
            this.immediatelyOnEvent = data["immediatelyOnEvent"];
            this.eventType = data["eventType"];
            this.broadcastCategory = data["broadcastCategory"];
            this.targetScreen = data["targetScreen"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.nameUnSign = data["nameUnSign"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            if (data["actions"] && data["actions"].constructor === Array) {
                this.actions = [];
                for (let item of data["actions"])
                    this.actions.push(ActionsInfo.fromJS(item));
            }
            this.actionsString = data["actionsString"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CommunicationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CommunicationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["channel"] = this.channel;
        data["languageDefault"] = this.languageDefault;
        data["name"] = this.name;
        data["status"] = this.status;
        data["communicationTargetAudienceID"] = this.communicationTargetAudienceID;
        data["cron"] = this.cron;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data["description"] = this.description;
        data["messageType"] = this.messageType;
        data["messageAction"] = this.messageAction;
        data["contentType"] = this.contentType;
        data["contentVN"] = this.contentVN;
        data["contentEN"] = this.contentEN;
        data["subjectVN"] = this.subjectVN;
        data["subjectEN"] = this.subjectEN;
        data["imageURL"] = this.imageURL;
        data["extraURL"] = this.extraURL;
        data["nameUnsign"] = this.nameUnsign;
        data["extraParam"] = this.extraParam;
        data["targetAudienceType"] = this.targetAudienceType;
        data["immediatelyOnEvent"] = this.immediatelyOnEvent;
        data["eventType"] = this.eventType;
        data["broadcastCategory"] = this.broadcastCategory;
        data["targetScreen"] = this.targetScreen;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["nameUnSign"] = this.nameUnSign;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        if (this.actions && this.actions.constructor === Array) {
            data["actions"] = [];
            for (let item of this.actions)
                data["actions"].push(item.toJSON());
        }
        data["actionsString"] = this.actionsString;
        data["id"] = this.id;
        return data;
    }
}

export interface ICommunicationDto {
    channel: string | undefined;
    languageDefault: string | undefined;
    name: string | undefined;
    status: string | undefined;
    communicationTargetAudienceID: number | undefined;
    cron: string | undefined;
    fromDate: moment.Moment | undefined;
    toDate: moment.Moment | undefined;
    description: string | undefined;
    messageType: string | undefined;
    messageAction: string | undefined;
    contentType: string | undefined;
    contentVN: string | undefined;
    contentEN: string | undefined;
    subjectVN: string | undefined;
    subjectEN: string | undefined;
    imageURL: string | undefined;
    extraURL: string | undefined;
    nameUnsign: string | undefined;
    extraParam: string | undefined;
    targetAudienceType: string | undefined;
    immediatelyOnEvent: boolean | undefined;
    eventType: string | undefined;
    broadcastCategory: string | undefined;
    targetScreen: string | undefined;
    lastModificationTime: moment.Moment | undefined;
    nameUnSign: string | undefined;
    creationTime: moment.Moment | undefined;
    actions: ActionsInfo[] | undefined;
    actionsString: string | undefined;
    id: number | undefined;
}

export class GetTargetAudienceForViewDto implements IGetTargetAudienceForViewDto {
    id!: number | undefined;
    targetAudienceName!: string | undefined;

    constructor(data?: IGetTargetAudienceForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.targetAudienceName = data["targetAudienceName"];
        }
    }

    static fromJS(data: any): GetTargetAudienceForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetTargetAudienceForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["targetAudienceName"] = this.targetAudienceName;
        return data;
    }
}

export interface IGetTargetAudienceForViewDto {
    id: number | undefined;
    targetAudienceName: string | undefined;
}

export class ActionsInfo implements IActionsInfo {
    extraParams!: { [key: string]: string; } | undefined;

    constructor(data?: IActionsInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["extraParams"]) {
                this.extraParams = {};
                for (let key in data["extraParams"]) {
                    if (data["extraParams"].hasOwnProperty(key))
                        this.extraParams[key] = data["extraParams"][key];
                }
            }
        }
    }

    static fromJS(data: any): ActionsInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ActionsInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.extraParams) {
            data["extraParams"] = {};
            for (let key in this.extraParams) {
                if (this.extraParams.hasOwnProperty(key))
                    data["extraParams"][key] = this.extraParams[key];
            }
        }
        return data;
    }
}

export interface IActionsInfo {
    extraParams: { [key: string]: string; } | undefined;
}

export class GetCommunicationForEditOutput implements IGetCommunicationForEditOutput {
    communication!: CreateOrEditCommunicationDto | undefined;

    constructor(data?: IGetCommunicationForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.communication = data["communication"] ? CreateOrEditCommunicationDto.fromJS(data["communication"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCommunicationForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetCommunicationForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["communication"] = this.communication ? this.communication.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetCommunicationForEditOutput {
    communication: CreateOrEditCommunicationDto | undefined;
}

export class CreateOrEditCommunicationDto implements ICreateOrEditCommunicationDto {
    channel!: string | undefined;
    languageDefault!: string | undefined;
    name!: string | undefined;
    status!: string | undefined;
    communicationTargetAudienceID!: number | undefined;
    cron!: string | undefined;
    fromDate!: moment.Moment | undefined;
    toDate!: moment.Moment | undefined;
    description!: string | undefined;
    messageType!: string | undefined;
    messageAction!: string | undefined;
    contentType!: string | undefined;
    contentVN!: string | undefined;
    contentEN!: string | undefined;
    subjectVN!: string | undefined;
    subjectEN!: string | undefined;
    imageURL!: string | undefined;
    extraURL!: string | undefined;
    nameUnsign!: string | undefined;
    extraParam!: string | undefined;
    targetAudienceType!: string | undefined;
    immediatelyOnEvent!: boolean | undefined;
    eventType!: string | undefined;
    broadcastCategory!: string | undefined;
    targetScreen!: string | undefined;
    actions!: string | undefined;
    actionDto!: CommunicationActionDto | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditCommunicationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.channel = data["channel"];
            this.languageDefault = data["languageDefault"];
            this.name = data["name"];
            this.status = data["status"];
            this.communicationTargetAudienceID = data["communicationTargetAudienceID"];
            this.cron = data["cron"];
            this.fromDate = data["fromDate"] ? moment(data["fromDate"].toString()) : <any>undefined;
            this.toDate = data["toDate"] ? moment(data["toDate"].toString()) : <any>undefined;
            this.description = data["description"];
            this.messageType = data["messageType"];
            this.messageAction = data["messageAction"];
            this.contentType = data["contentType"];
            this.contentVN = data["contentVN"];
            this.contentEN = data["contentEN"];
            this.subjectVN = data["subjectVN"];
            this.subjectEN = data["subjectEN"];
            this.imageURL = data["imageURL"];
            this.extraURL = data["extraURL"];
            this.nameUnsign = data["nameUnsign"];
            this.extraParam = data["extraParam"];
            this.targetAudienceType = data["targetAudienceType"];
            this.immediatelyOnEvent = data["immediatelyOnEvent"];
            this.eventType = data["eventType"];
            this.broadcastCategory = data["broadcastCategory"];
            this.targetScreen = data["targetScreen"];
            this.actions = data["actions"];
            this.actionDto = data["actionDto"] ? CommunicationActionDto.fromJS(data["actionDto"]) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditCommunicationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditCommunicationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["channel"] = this.channel;
        data["languageDefault"] = this.languageDefault;
        data["name"] = this.name;
        data["status"] = this.status;
        data["communicationTargetAudienceID"] = this.communicationTargetAudienceID;
        data["cron"] = this.cron;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data["description"] = this.description;
        data["messageType"] = this.messageType;
        data["messageAction"] = this.messageAction;
        data["contentType"] = this.contentType;
        data["contentVN"] = this.contentVN;
        data["contentEN"] = this.contentEN;
        data["subjectVN"] = this.subjectVN;
        data["subjectEN"] = this.subjectEN;
        data["imageURL"] = this.imageURL;
        data["extraURL"] = this.extraURL;
        data["nameUnsign"] = this.nameUnsign;
        data["extraParam"] = this.extraParam;
        data["targetAudienceType"] = this.targetAudienceType;
        data["immediatelyOnEvent"] = this.immediatelyOnEvent;
        data["eventType"] = this.eventType;
        data["broadcastCategory"] = this.broadcastCategory;
        data["targetScreen"] = this.targetScreen;
        data["actions"] = this.actions;
        data["actionDto"] = this.actionDto ? this.actionDto.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditCommunicationDto {
    channel: string | undefined;
    languageDefault: string | undefined;
    name: string | undefined;
    status: string | undefined;
    communicationTargetAudienceID: number | undefined;
    cron: string | undefined;
    fromDate: moment.Moment | undefined;
    toDate: moment.Moment | undefined;
    description: string | undefined;
    messageType: string | undefined;
    messageAction: string | undefined;
    contentType: string | undefined;
    contentVN: string | undefined;
    contentEN: string | undefined;
    subjectVN: string | undefined;
    subjectEN: string | undefined;
    imageURL: string | undefined;
    extraURL: string | undefined;
    nameUnsign: string | undefined;
    extraParam: string | undefined;
    targetAudienceType: string | undefined;
    immediatelyOnEvent: boolean | undefined;
    eventType: string | undefined;
    broadcastCategory: string | undefined;
    targetScreen: string | undefined;
    actions: string | undefined;
    actionDto: CommunicationActionDto | undefined;
    id: number | undefined;
}

export class CommunicationActionDto implements ICommunicationActionDto {
    cover!: Cover | undefined;
    buttons!: Button[] | undefined;

    constructor(data?: ICommunicationActionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.cover = data["cover"] ? Cover.fromJS(data["cover"]) : <any>undefined;
            if (data["buttons"] && data["buttons"].constructor === Array) {
                this.buttons = [];
                for (let item of data["buttons"])
                    this.buttons.push(Button.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CommunicationActionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CommunicationActionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cover"] = this.cover ? this.cover.toJSON() : <any>undefined;
        if (this.buttons && this.buttons.constructor === Array) {
            data["buttons"] = [];
            for (let item of this.buttons)
                data["buttons"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICommunicationActionDto {
    cover: Cover | undefined;
    buttons: Button[] | undefined;
}

export class Cover implements ICover {
    useAvatar!: boolean | undefined;
    action!: string | undefined;
    contentAction!: string | undefined;
    useImageButton!: boolean | undefined;

    constructor(data?: ICover) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.useAvatar = data["useAvatar"];
            this.action = data["action"];
            this.contentAction = data["contentAction"];
            this.useImageButton = data["useImageButton"];
        }
    }

    static fromJS(data: any): Cover {
        data = typeof data === 'object' ? data : {};
        let result = new Cover();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["useAvatar"] = this.useAvatar;
        data["action"] = this.action;
        data["contentAction"] = this.contentAction;
        data["useImageButton"] = this.useImageButton;
        return data;
    }
}

export interface ICover {
    useAvatar: boolean | undefined;
    action: string | undefined;
    contentAction: string | undefined;
    useImageButton: boolean | undefined;
}

export class Button implements IButton {
    type!: string | undefined;
    title!: string | undefined;
    content!: string | undefined;
    imageURL!: string | undefined;

    constructor(data?: IButton) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.type = data["type"];
            this.title = data["title"];
            this.content = data["content"];
            this.imageURL = data["imageURL"];
        }
    }

    static fromJS(data: any): Button {
        data = typeof data === 'object' ? data : {};
        let result = new Button();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["title"] = this.title;
        data["content"] = this.content;
        data["imageURL"] = this.imageURL;
        return data;
    }
}

export interface IButton {
    type: string | undefined;
    title: string | undefined;
    content: string | undefined;
    imageURL: string | undefined;
}

export class PagedResultDtoOfNotificationByUserResponse implements IPagedResultDtoOfNotificationByUserResponse {
    totalCount!: number | undefined;
    items!: NotificationByUserResponse[] | undefined;

    constructor(data?: IPagedResultDtoOfNotificationByUserResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(NotificationByUserResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfNotificationByUserResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfNotificationByUserResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfNotificationByUserResponse {
    totalCount: number | undefined;
    items: NotificationByUserResponse[] | undefined;
}

export class NotificationByUserResponse implements INotificationByUserResponse {
    notifyID!: number | undefined;
    notifyType!: string | undefined;
    topicID!: number | undefined;
    title!: string | undefined;
    content!: string | undefined;
    date!: moment.Moment | undefined;
    data!: string | undefined;
    status!: string | undefined;

    constructor(data?: INotificationByUserResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.notifyID = data["notifyID"];
            this.notifyType = data["notifyType"];
            this.topicID = data["topicID"];
            this.title = data["title"];
            this.content = data["content"];
            this.date = data["date"] ? moment(data["date"].toString()) : <any>undefined;
            this.data = data["data"];
            this.status = data["status"];
        }
    }

    static fromJS(data: any): NotificationByUserResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationByUserResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["notifyID"] = this.notifyID;
        data["notifyType"] = this.notifyType;
        data["topicID"] = this.topicID;
        data["title"] = this.title;
        data["content"] = this.content;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["data"] = this.data;
        data["status"] = this.status;
        return data;
    }
}

export interface INotificationByUserResponse {
    notifyID: number | undefined;
    notifyType: string | undefined;
    topicID: number | undefined;
    title: string | undefined;
    content: string | undefined;
    date: moment.Moment | undefined;
    data: string | undefined;
    status: string | undefined;
}

export class CommunicationsFileDto implements ICommunicationsFileDto {
    fileName!: string;
    fileType!: string;
    fileToken!: string;

    constructor(data?: ICommunicationsFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.fileName = data["fileName"];
            this.fileType = data["fileType"];
            this.fileToken = data["fileToken"];
        }
    }

    static fromJS(data: any): CommunicationsFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new CommunicationsFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["fileType"] = this.fileType;
        data["fileToken"] = this.fileToken;
        return data;
    }
}

export interface ICommunicationsFileDto {
    fileName: string;
    fileType: string;
    fileToken: string;
}

export class MessageResultCommunication implements IMessageResultCommunication {
    errors!: MessageErrorCommunication[] | undefined;
    successes!: MessageSuccessCommunication[] | undefined;

    constructor(data?: IMessageResultCommunication) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["errors"] && data["errors"].constructor === Array) {
                this.errors = [];
                for (let item of data["errors"])
                    this.errors.push(MessageErrorCommunication.fromJS(item));
            }
            if (data["successes"] && data["successes"].constructor === Array) {
                this.successes = [];
                for (let item of data["successes"])
                    this.successes.push(MessageSuccessCommunication.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MessageResultCommunication {
        data = typeof data === 'object' ? data : {};
        let result = new MessageResultCommunication();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.errors && this.errors.constructor === Array) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        if (this.successes && this.successes.constructor === Array) {
            data["successes"] = [];
            for (let item of this.successes)
                data["successes"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMessageResultCommunication {
    errors: MessageErrorCommunication[] | undefined;
    successes: MessageSuccessCommunication[] | undefined;
}

export class MessageErrorCommunication implements IMessageErrorCommunication {
    id!: string | undefined;
    message!: string | undefined;

    constructor(data?: IMessageErrorCommunication) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.message = data["message"];
        }
    }

    static fromJS(data: any): MessageErrorCommunication {
        data = typeof data === 'object' ? data : {};
        let result = new MessageErrorCommunication();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["message"] = this.message;
        return data;
    }
}

export interface IMessageErrorCommunication {
    id: string | undefined;
    message: string | undefined;
}

export class MessageSuccessCommunication implements IMessageSuccessCommunication {
    id!: string | undefined;
    message!: string | undefined;

    constructor(data?: IMessageSuccessCommunication) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.message = data["message"];
        }
    }

    static fromJS(data: any): MessageSuccessCommunication {
        data = typeof data === 'object' ? data : {};
        let result = new MessageSuccessCommunication();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["message"] = this.message;
        return data;
    }
}

export interface IMessageSuccessCommunication {
    id: string | undefined;
    message: string | undefined;
}

export class CommunicationInfoAgrs implements ICommunicationInfoAgrs {
    communicationID!: number | undefined;
    channelCode!: string | undefined;
    targetAudienceId!: number | undefined;
    targetAudienceName!: string | undefined;
    targetAudienceType!: string | undefined;
    immediatelyOnEvent!: boolean | undefined;
    eventType!: string | undefined;
    name!: string | undefined;
    fromDate!: moment.Moment | undefined;
    toDate!: moment.Moment | undefined;
    cron!: string | undefined;
    description!: string | undefined;
    languageDefault!: string | undefined;
    status!: string | undefined;
    subjectEN!: string | undefined;
    subjectVN!: string | undefined;
    contentEN!: string | undefined;
    contentVN!: string | undefined;
    messageType!: string | undefined;
    messageAction!: string | undefined;
    extraURL!: string | undefined;
    imageURL!: string | undefined;
    nameUnSign!: string | undefined;
    broadcastCategory!: string | undefined;
    contentType!: string | undefined;
    actions!: string | undefined;
    actionDto!: CommunicationActionDto | undefined;
    tableName!: string | undefined;
    filePath!: string | undefined;
    fileName!: string | undefined;
    userId!: number | undefined;
    tenantId!: number | undefined;
    currentLanguage!: string | undefined;
    apiUrl!: string | undefined;

    constructor(data?: ICommunicationInfoAgrs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.communicationID = data["communicationID"];
            this.channelCode = data["channelCode"];
            this.targetAudienceId = data["targetAudienceId"];
            this.targetAudienceName = data["targetAudienceName"];
            this.targetAudienceType = data["targetAudienceType"];
            this.immediatelyOnEvent = data["immediatelyOnEvent"];
            this.eventType = data["eventType"];
            this.name = data["name"];
            this.fromDate = data["fromDate"] ? moment(data["fromDate"].toString()) : <any>undefined;
            this.toDate = data["toDate"] ? moment(data["toDate"].toString()) : <any>undefined;
            this.cron = data["cron"];
            this.description = data["description"];
            this.languageDefault = data["languageDefault"];
            this.status = data["status"];
            this.subjectEN = data["subjectEN"];
            this.subjectVN = data["subjectVN"];
            this.contentEN = data["contentEN"];
            this.contentVN = data["contentVN"];
            this.messageType = data["messageType"];
            this.messageAction = data["messageAction"];
            this.extraURL = data["extraURL"];
            this.imageURL = data["imageURL"];
            this.nameUnSign = data["nameUnSign"];
            this.broadcastCategory = data["broadcastCategory"];
            this.contentType = data["contentType"];
            this.actions = data["actions"];
            this.actionDto = data["actionDto"] ? CommunicationActionDto.fromJS(data["actionDto"]) : <any>undefined;
            this.tableName = data["tableName"];
            this.filePath = data["filePath"];
            this.fileName = data["fileName"];
            this.userId = data["userId"];
            this.tenantId = data["tenantId"];
            this.currentLanguage = data["currentLanguage"];
            this.apiUrl = data["apiUrl"];
        }
    }

    static fromJS(data: any): CommunicationInfoAgrs {
        data = typeof data === 'object' ? data : {};
        let result = new CommunicationInfoAgrs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["communicationID"] = this.communicationID;
        data["channelCode"] = this.channelCode;
        data["targetAudienceId"] = this.targetAudienceId;
        data["targetAudienceName"] = this.targetAudienceName;
        data["targetAudienceType"] = this.targetAudienceType;
        data["immediatelyOnEvent"] = this.immediatelyOnEvent;
        data["eventType"] = this.eventType;
        data["name"] = this.name;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data["cron"] = this.cron;
        data["description"] = this.description;
        data["languageDefault"] = this.languageDefault;
        data["status"] = this.status;
        data["subjectEN"] = this.subjectEN;
        data["subjectVN"] = this.subjectVN;
        data["contentEN"] = this.contentEN;
        data["contentVN"] = this.contentVN;
        data["messageType"] = this.messageType;
        data["messageAction"] = this.messageAction;
        data["extraURL"] = this.extraURL;
        data["imageURL"] = this.imageURL;
        data["nameUnSign"] = this.nameUnSign;
        data["broadcastCategory"] = this.broadcastCategory;
        data["contentType"] = this.contentType;
        data["actions"] = this.actions;
        data["actionDto"] = this.actionDto ? this.actionDto.toJSON() : <any>undefined;
        data["tableName"] = this.tableName;
        data["filePath"] = this.filePath;
        data["fileName"] = this.fileName;
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["currentLanguage"] = this.currentLanguage;
        data["apiUrl"] = this.apiUrl;
        return data;
    }
}

export interface ICommunicationInfoAgrs {
    communicationID: number | undefined;
    channelCode: string | undefined;
    targetAudienceId: number | undefined;
    targetAudienceName: string | undefined;
    targetAudienceType: string | undefined;
    immediatelyOnEvent: boolean | undefined;
    eventType: string | undefined;
    name: string | undefined;
    fromDate: moment.Moment | undefined;
    toDate: moment.Moment | undefined;
    cron: string | undefined;
    description: string | undefined;
    languageDefault: string | undefined;
    status: string | undefined;
    subjectEN: string | undefined;
    subjectVN: string | undefined;
    contentEN: string | undefined;
    contentVN: string | undefined;
    messageType: string | undefined;
    messageAction: string | undefined;
    extraURL: string | undefined;
    imageURL: string | undefined;
    nameUnSign: string | undefined;
    broadcastCategory: string | undefined;
    contentType: string | undefined;
    actions: string | undefined;
    actionDto: CommunicationActionDto | undefined;
    tableName: string | undefined;
    filePath: string | undefined;
    fileName: string | undefined;
    userId: number | undefined;
    tenantId: number | undefined;
    currentLanguage: string | undefined;
    apiUrl: string | undefined;
}

export class Token implements IToken {
    tableName!: string | undefined;
    tokens!: string[] | undefined;

    constructor(data?: IToken) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tableName = data["tableName"];
            if (data["tokens"] && data["tokens"].constructor === Array) {
                this.tokens = [];
                for (let item of data["tokens"])
                    this.tokens.push(item);
            }
        }
    }

    static fromJS(data: any): Token {
        data = typeof data === 'object' ? data : {};
        let result = new Token();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tableName"] = this.tableName;
        if (this.tokens && this.tokens.constructor === Array) {
            data["tokens"] = [];
            for (let item of this.tokens)
                data["tokens"].push(item);
        }
        return data;
    }
}

export interface IToken {
    tableName: string | undefined;
    tokens: string[] | undefined;
}

export class PagedResultDtoOfGetCommunicationReportsForView implements IPagedResultDtoOfGetCommunicationReportsForView {
    totalCount!: number | undefined;
    items!: GetCommunicationReportsForView[] | undefined;

    constructor(data?: IPagedResultDtoOfGetCommunicationReportsForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetCommunicationReportsForView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetCommunicationReportsForView {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetCommunicationReportsForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetCommunicationReportsForView {
    totalCount: number | undefined;
    items: GetCommunicationReportsForView[] | undefined;
}

export class GetCommunicationReportsForView implements IGetCommunicationReportsForView {
    name!: string | undefined;
    content!: string | undefined;
    lastUpdatedTime!: moment.Moment | undefined;
    status!: string | undefined;
    memberCode!: string | undefined;
    message!: string | undefined;

    constructor(data?: IGetCommunicationReportsForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.content = data["content"];
            this.lastUpdatedTime = data["lastUpdatedTime"] ? moment(data["lastUpdatedTime"].toString()) : <any>undefined;
            this.status = data["status"];
            this.memberCode = data["memberCode"];
            this.message = data["message"];
        }
    }

    static fromJS(data: any): GetCommunicationReportsForView {
        data = typeof data === 'object' ? data : {};
        let result = new GetCommunicationReportsForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["content"] = this.content;
        data["lastUpdatedTime"] = this.lastUpdatedTime ? this.lastUpdatedTime.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["memberCode"] = this.memberCode;
        data["message"] = this.message;
        return data;
    }
}

export interface IGetCommunicationReportsForView {
    name: string | undefined;
    content: string | undefined;
    lastUpdatedTime: moment.Moment | undefined;
    status: string | undefined;
    memberCode: string | undefined;
    message: string | undefined;
}

export class GetAllForCommunicationReportsInput implements IGetAllForCommunicationReportsInput {
    filter!: string | undefined;
    statusFilter!: string | undefined;
    communicationId!: number | undefined;
    sorting!: string | undefined;
    skipCount!: number | undefined;
    maxResultCount!: number | undefined;

    constructor(data?: IGetAllForCommunicationReportsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.filter = data["filter"];
            this.statusFilter = data["statusFilter"];
            this.communicationId = data["communicationId"];
            this.sorting = data["sorting"];
            this.skipCount = data["skipCount"];
            this.maxResultCount = data["maxResultCount"];
        }
    }

    static fromJS(data: any): GetAllForCommunicationReportsInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllForCommunicationReportsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        data["statusFilter"] = this.statusFilter;
        data["communicationId"] = this.communicationId;
        data["sorting"] = this.sorting;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data;
    }
}

export interface IGetAllForCommunicationReportsInput {
    filter: string | undefined;
    statusFilter: string | undefined;
    communicationId: number | undefined;
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;
}

export class CloneCommunicationDto implements ICloneCommunicationDto {
    ids!: number[] | undefined;

    constructor(data?: ICloneCommunicationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["ids"] && data["ids"].constructor === Array) {
                this.ids = [];
                for (let item of data["ids"])
                    this.ids.push(item);
            }
        }
    }

    static fromJS(data: any): CloneCommunicationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CloneCommunicationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.ids && this.ids.constructor === Array) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        return data;
    }
}

export interface ICloneCommunicationDto {
    ids: number[] | undefined;
}

export class CommunicationSurveyDto implements ICommunicationSurveyDto {
    name!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICommunicationSurveyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CommunicationSurveyDto {
        data = typeof data === 'object' ? data : {};
        let result = new CommunicationSurveyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        return data;
    }
}

export interface ICommunicationSurveyDto {
    name: string | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfGetCommunicationTargetAudienceForViewDto implements IPagedResultDtoOfGetCommunicationTargetAudienceForViewDto {
    totalCount!: number | undefined;
    items!: GetCommunicationTargetAudienceForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetCommunicationTargetAudienceForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetCommunicationTargetAudienceForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetCommunicationTargetAudienceForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetCommunicationTargetAudienceForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetCommunicationTargetAudienceForViewDto {
    totalCount: number | undefined;
    items: GetCommunicationTargetAudienceForViewDto[] | undefined;
}

export class GetCommunicationTargetAudienceForViewDto implements IGetCommunicationTargetAudienceForViewDto {
    communicationTargetAudience!: CommunicationTargetAudienceDto | undefined;

    constructor(data?: IGetCommunicationTargetAudienceForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.communicationTargetAudience = data["communicationTargetAudience"] ? CommunicationTargetAudienceDto.fromJS(data["communicationTargetAudience"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCommunicationTargetAudienceForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCommunicationTargetAudienceForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["communicationTargetAudience"] = this.communicationTargetAudience ? this.communicationTargetAudience.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetCommunicationTargetAudienceForViewDto {
    communicationTargetAudience: CommunicationTargetAudienceDto | undefined;
}

export class CommunicationTargetAudienceDto implements ICommunicationTargetAudienceDto {
    targetAudienceName!: string | undefined;
    description!: string | undefined;
    status!: string | undefined;
    targetAudienceLinkID!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICommunicationTargetAudienceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.targetAudienceName = data["targetAudienceName"];
            this.description = data["description"];
            this.status = data["status"];
            this.targetAudienceLinkID = data["targetAudienceLinkID"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CommunicationTargetAudienceDto {
        data = typeof data === 'object' ? data : {};
        let result = new CommunicationTargetAudienceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["targetAudienceName"] = this.targetAudienceName;
        data["description"] = this.description;
        data["status"] = this.status;
        data["targetAudienceLinkID"] = this.targetAudienceLinkID;
        data["id"] = this.id;
        return data;
    }
}

export interface ICommunicationTargetAudienceDto {
    targetAudienceName: string | undefined;
    description: string | undefined;
    status: string | undefined;
    targetAudienceLinkID: number | undefined;
    id: number | undefined;
}

export class GetCommunicationTargetAudienceForEditOutput implements IGetCommunicationTargetAudienceForEditOutput {
    communicationTargetAudience!: CreateOrEditCommunicationTargetAudienceDto | undefined;

    constructor(data?: IGetCommunicationTargetAudienceForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.communicationTargetAudience = data["communicationTargetAudience"] ? CreateOrEditCommunicationTargetAudienceDto.fromJS(data["communicationTargetAudience"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCommunicationTargetAudienceForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetCommunicationTargetAudienceForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["communicationTargetAudience"] = this.communicationTargetAudience ? this.communicationTargetAudience.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetCommunicationTargetAudienceForEditOutput {
    communicationTargetAudience: CreateOrEditCommunicationTargetAudienceDto | undefined;
}

export class CreateOrEditCommunicationTargetAudienceDto implements ICreateOrEditCommunicationTargetAudienceDto {
    targetAudienceName!: string | undefined;
    description!: string | undefined;
    status!: string | undefined;
    targetAudienceLinkID!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditCommunicationTargetAudienceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.targetAudienceName = data["targetAudienceName"];
            this.description = data["description"];
            this.status = data["status"];
            this.targetAudienceLinkID = data["targetAudienceLinkID"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditCommunicationTargetAudienceDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditCommunicationTargetAudienceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["targetAudienceName"] = this.targetAudienceName;
        data["description"] = this.description;
        data["status"] = this.status;
        data["targetAudienceLinkID"] = this.targetAudienceLinkID;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditCommunicationTargetAudienceDto {
    targetAudienceName: string | undefined;
    description: string | undefined;
    status: string | undefined;
    targetAudienceLinkID: number | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfGetCommunicationTransactionForViewDto implements IPagedResultDtoOfGetCommunicationTransactionForViewDto {
    totalCount!: number | undefined;
    items!: GetCommunicationTransactionForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetCommunicationTransactionForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetCommunicationTransactionForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetCommunicationTransactionForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetCommunicationTransactionForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetCommunicationTransactionForViewDto {
    totalCount: number | undefined;
    items: GetCommunicationTransactionForViewDto[] | undefined;
}

export class GetCommunicationTransactionForViewDto implements IGetCommunicationTransactionForViewDto {
    communicationTransaction!: CommunicationTransactionDto | undefined;

    constructor(data?: IGetCommunicationTransactionForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.communicationTransaction = data["communicationTransaction"] ? CommunicationTransactionDto.fromJS(data["communicationTransaction"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCommunicationTransactionForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCommunicationTransactionForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["communicationTransaction"] = this.communicationTransaction ? this.communicationTransaction.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetCommunicationTransactionForViewDto {
    communicationTransaction: CommunicationTransactionDto | undefined;
}

export class CommunicationTransactionDto implements ICommunicationTransactionDto {
    communicationID!: string | undefined;
    channel!: string | undefined;
    memberName!: string | undefined;
    phone!: string | undefined;
    zaloChatID!: string | undefined;
    email!: string | undefined;
    facebookID!: string | undefined;
    memberCode!: string | undefined;
    content!: string | undefined;
    subject!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICommunicationTransactionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.communicationID = data["communicationID"];
            this.channel = data["channel"];
            this.memberName = data["memberName"];
            this.phone = data["phone"];
            this.zaloChatID = data["zaloChatID"];
            this.email = data["email"];
            this.facebookID = data["facebookID"];
            this.memberCode = data["memberCode"];
            this.content = data["content"];
            this.subject = data["subject"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CommunicationTransactionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CommunicationTransactionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["communicationID"] = this.communicationID;
        data["channel"] = this.channel;
        data["memberName"] = this.memberName;
        data["phone"] = this.phone;
        data["zaloChatID"] = this.zaloChatID;
        data["email"] = this.email;
        data["facebookID"] = this.facebookID;
        data["memberCode"] = this.memberCode;
        data["content"] = this.content;
        data["subject"] = this.subject;
        data["id"] = this.id;
        return data;
    }
}

export interface ICommunicationTransactionDto {
    communicationID: string | undefined;
    channel: string | undefined;
    memberName: string | undefined;
    phone: string | undefined;
    zaloChatID: string | undefined;
    email: string | undefined;
    facebookID: string | undefined;
    memberCode: string | undefined;
    content: string | undefined;
    subject: string | undefined;
    id: number | undefined;
}

export class GetCommunicationTransactionForEditOutput implements IGetCommunicationTransactionForEditOutput {
    communicationTransaction!: CreateOrEditCommunicationTransactionDto | undefined;

    constructor(data?: IGetCommunicationTransactionForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.communicationTransaction = data["communicationTransaction"] ? CreateOrEditCommunicationTransactionDto.fromJS(data["communicationTransaction"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCommunicationTransactionForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetCommunicationTransactionForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["communicationTransaction"] = this.communicationTransaction ? this.communicationTransaction.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetCommunicationTransactionForEditOutput {
    communicationTransaction: CreateOrEditCommunicationTransactionDto | undefined;
}

export class CreateOrEditCommunicationTransactionDto implements ICreateOrEditCommunicationTransactionDto {
    communicationID!: string | undefined;
    channel!: string | undefined;
    memberName!: string | undefined;
    phone!: string | undefined;
    zaloChatID!: string | undefined;
    email!: string | undefined;
    facebookID!: string | undefined;
    memberCode!: string | undefined;
    content!: string | undefined;
    subject!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditCommunicationTransactionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.communicationID = data["communicationID"];
            this.channel = data["channel"];
            this.memberName = data["memberName"];
            this.phone = data["phone"];
            this.zaloChatID = data["zaloChatID"];
            this.email = data["email"];
            this.facebookID = data["facebookID"];
            this.memberCode = data["memberCode"];
            this.content = data["content"];
            this.subject = data["subject"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditCommunicationTransactionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditCommunicationTransactionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["communicationID"] = this.communicationID;
        data["channel"] = this.channel;
        data["memberName"] = this.memberName;
        data["phone"] = this.phone;
        data["zaloChatID"] = this.zaloChatID;
        data["email"] = this.email;
        data["facebookID"] = this.facebookID;
        data["memberCode"] = this.memberCode;
        data["content"] = this.content;
        data["subject"] = this.subject;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditCommunicationTransactionDto {
    communicationID: string | undefined;
    channel: string | undefined;
    memberName: string | undefined;
    phone: string | undefined;
    zaloChatID: string | undefined;
    email: string | undefined;
    facebookID: string | undefined;
    memberCode: string | undefined;
    content: string | undefined;
    subject: string | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfGetCommunicationUserForViewDto implements IPagedResultDtoOfGetCommunicationUserForViewDto {
    totalCount!: number | undefined;
    items!: GetCommunicationUserForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetCommunicationUserForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetCommunicationUserForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetCommunicationUserForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetCommunicationUserForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetCommunicationUserForViewDto {
    totalCount: number | undefined;
    items: GetCommunicationUserForViewDto[] | undefined;
}

export class GetCommunicationUserForViewDto implements IGetCommunicationUserForViewDto {
    communicationUser!: CommunicationUserDto | undefined;

    constructor(data?: IGetCommunicationUserForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.communicationUser = data["communicationUser"] ? CommunicationUserDto.fromJS(data["communicationUser"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCommunicationUserForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCommunicationUserForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["communicationUser"] = this.communicationUser ? this.communicationUser.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetCommunicationUserForViewDto {
    communicationUser: CommunicationUserDto | undefined;
}

export class CommunicationUserDto implements ICommunicationUserDto {
    name!: string | undefined;
    phone!: string | undefined;
    zaloChatID!: string | undefined;
    email!: string | undefined;
    facebookID!: string | undefined;
    memberCode!: string | undefined;
    communicationLanguage!: string | undefined;
    targetAudienceLinkID!: number | undefined;
    communicationTargetAudienceID!: number | undefined;
    communicationChannel!: string | undefined;
    outletCode!: string | undefined;
    param1!: string | undefined;
    param2!: string | undefined;
    param3!: string | undefined;
    param4!: string | undefined;
    param5!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICommunicationUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.phone = data["phone"];
            this.zaloChatID = data["zaloChatID"];
            this.email = data["email"];
            this.facebookID = data["facebookID"];
            this.memberCode = data["memberCode"];
            this.communicationLanguage = data["communicationLanguage"];
            this.targetAudienceLinkID = data["targetAudienceLinkID"];
            this.communicationTargetAudienceID = data["communicationTargetAudienceID"];
            this.communicationChannel = data["communicationChannel"];
            this.outletCode = data["outletCode"];
            this.param1 = data["param1"];
            this.param2 = data["param2"];
            this.param3 = data["param3"];
            this.param4 = data["param4"];
            this.param5 = data["param5"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CommunicationUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new CommunicationUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["phone"] = this.phone;
        data["zaloChatID"] = this.zaloChatID;
        data["email"] = this.email;
        data["facebookID"] = this.facebookID;
        data["memberCode"] = this.memberCode;
        data["communicationLanguage"] = this.communicationLanguage;
        data["targetAudienceLinkID"] = this.targetAudienceLinkID;
        data["communicationTargetAudienceID"] = this.communicationTargetAudienceID;
        data["communicationChannel"] = this.communicationChannel;
        data["outletCode"] = this.outletCode;
        data["param1"] = this.param1;
        data["param2"] = this.param2;
        data["param3"] = this.param3;
        data["param4"] = this.param4;
        data["param5"] = this.param5;
        data["id"] = this.id;
        return data;
    }
}

export interface ICommunicationUserDto {
    name: string | undefined;
    phone: string | undefined;
    zaloChatID: string | undefined;
    email: string | undefined;
    facebookID: string | undefined;
    memberCode: string | undefined;
    communicationLanguage: string | undefined;
    targetAudienceLinkID: number | undefined;
    communicationTargetAudienceID: number | undefined;
    communicationChannel: string | undefined;
    outletCode: string | undefined;
    param1: string | undefined;
    param2: string | undefined;
    param3: string | undefined;
    param4: string | undefined;
    param5: string | undefined;
    id: number | undefined;
}

export class GetCommunicationUserForEditOutput implements IGetCommunicationUserForEditOutput {
    communicationUser!: CreateOrEditCommunicationUserDto | undefined;

    constructor(data?: IGetCommunicationUserForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.communicationUser = data["communicationUser"] ? CreateOrEditCommunicationUserDto.fromJS(data["communicationUser"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCommunicationUserForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetCommunicationUserForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["communicationUser"] = this.communicationUser ? this.communicationUser.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetCommunicationUserForEditOutput {
    communicationUser: CreateOrEditCommunicationUserDto | undefined;
}

export class CreateOrEditCommunicationUserDto implements ICreateOrEditCommunicationUserDto {
    name!: string | undefined;
    phone!: string | undefined;
    zaloChatID!: string | undefined;
    email!: string | undefined;
    facebookID!: string | undefined;
    memberCode!: string | undefined;
    communicationLanguage!: string | undefined;
    targetAudienceLinkID!: number | undefined;
    communicationTargetAudienceID!: number | undefined;
    communicationChannel!: string | undefined;
    outletCode!: string | undefined;
    param1!: string | undefined;
    param2!: string | undefined;
    param3!: string | undefined;
    param4!: string | undefined;
    param5!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditCommunicationUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.phone = data["phone"];
            this.zaloChatID = data["zaloChatID"];
            this.email = data["email"];
            this.facebookID = data["facebookID"];
            this.memberCode = data["memberCode"];
            this.communicationLanguage = data["communicationLanguage"];
            this.targetAudienceLinkID = data["targetAudienceLinkID"];
            this.communicationTargetAudienceID = data["communicationTargetAudienceID"];
            this.communicationChannel = data["communicationChannel"];
            this.outletCode = data["outletCode"];
            this.param1 = data["param1"];
            this.param2 = data["param2"];
            this.param3 = data["param3"];
            this.param4 = data["param4"];
            this.param5 = data["param5"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditCommunicationUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditCommunicationUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["phone"] = this.phone;
        data["zaloChatID"] = this.zaloChatID;
        data["email"] = this.email;
        data["facebookID"] = this.facebookID;
        data["memberCode"] = this.memberCode;
        data["communicationLanguage"] = this.communicationLanguage;
        data["targetAudienceLinkID"] = this.targetAudienceLinkID;
        data["communicationTargetAudienceID"] = this.communicationTargetAudienceID;
        data["communicationChannel"] = this.communicationChannel;
        data["outletCode"] = this.outletCode;
        data["param1"] = this.param1;
        data["param2"] = this.param2;
        data["param3"] = this.param3;
        data["param4"] = this.param4;
        data["param5"] = this.param5;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditCommunicationUserDto {
    name: string | undefined;
    phone: string | undefined;
    zaloChatID: string | undefined;
    email: string | undefined;
    facebookID: string | undefined;
    memberCode: string | undefined;
    communicationLanguage: string | undefined;
    targetAudienceLinkID: number | undefined;
    communicationTargetAudienceID: number | undefined;
    communicationChannel: string | undefined;
    outletCode: string | undefined;
    param1: string | undefined;
    param2: string | undefined;
    param3: string | undefined;
    param4: string | undefined;
    param5: string | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfGetCompanyInfoForViewDto implements IPagedResultDtoOfGetCompanyInfoForViewDto {
    totalCount!: number | undefined;
    items!: GetCompanyInfoForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetCompanyInfoForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetCompanyInfoForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetCompanyInfoForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetCompanyInfoForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetCompanyInfoForViewDto {
    totalCount: number | undefined;
    items: GetCompanyInfoForViewDto[] | undefined;
}

export class GetCompanyInfoForViewDto implements IGetCompanyInfoForViewDto {
    companyInfo!: CompanyInfoDto | undefined;

    constructor(data?: IGetCompanyInfoForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.companyInfo = data["companyInfo"] ? CompanyInfoDto.fromJS(data["companyInfo"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCompanyInfoForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyInfoForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyInfo"] = this.companyInfo ? this.companyInfo.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetCompanyInfoForViewDto {
    companyInfo: CompanyInfoDto | undefined;
}

export class CompanyInfoDto implements ICompanyInfoDto {
    type!: string | undefined;
    data!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICompanyInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.type = data["type"];
            this.data = data["data"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CompanyInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["data"] = this.data;
        data["id"] = this.id;
        return data;
    }
}

export interface ICompanyInfoDto {
    type: string | undefined;
    data: string | undefined;
    id: number | undefined;
}

export class GetCompanyInfoForEditOutput implements IGetCompanyInfoForEditOutput {
    companyInfo!: CreateOrEditCompanyInfoDto | undefined;

    constructor(data?: IGetCompanyInfoForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.companyInfo = data["companyInfo"] ? CreateOrEditCompanyInfoDto.fromJS(data["companyInfo"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCompanyInfoForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyInfoForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyInfo"] = this.companyInfo ? this.companyInfo.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetCompanyInfoForEditOutput {
    companyInfo: CreateOrEditCompanyInfoDto | undefined;
}

export class CreateOrEditCompanyInfoDto implements ICreateOrEditCompanyInfoDto {
    type!: string | undefined;
    data!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditCompanyInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.type = data["type"];
            this.data = data["data"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditCompanyInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditCompanyInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["data"] = this.data;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditCompanyInfoDto {
    type: string | undefined;
    data: string | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfGetConsentReportForViewDto implements IPagedResultDtoOfGetConsentReportForViewDto {
    totalCount!: number | undefined;
    items!: GetConsentReportForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetConsentReportForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetConsentReportForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetConsentReportForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetConsentReportForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetConsentReportForViewDto {
    totalCount: number | undefined;
    items: GetConsentReportForViewDto[] | undefined;
}

export class GetConsentReportForViewDto implements IGetConsentReportForViewDto {
    consentReport!: ConsentReportDto | undefined;

    constructor(data?: IGetConsentReportForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.consentReport = data["consentReport"] ? ConsentReportDto.fromJS(data["consentReport"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetConsentReportForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetConsentReportForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["consentReport"] = this.consentReport ? this.consentReport.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetConsentReportForViewDto {
    consentReport: ConsentReportDto | undefined;
}

export class ConsentReportDto implements IConsentReportDto {
    memberCode!: string | undefined;
    sentDate!: moment.Moment | undefined;
    content!: string | undefined;
    phoneNumber!: string | undefined;
    otp!: string | undefined;
    isAccept!: boolean | undefined;
    memberName!: string | undefined;
    id!: number | undefined;

    constructor(data?: IConsentReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberCode = data["memberCode"];
            this.sentDate = data["sentDate"] ? moment(data["sentDate"].toString()) : <any>undefined;
            this.content = data["content"];
            this.phoneNumber = data["phoneNumber"];
            this.otp = data["otp"];
            this.isAccept = data["isAccept"];
            this.memberName = data["memberName"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ConsentReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConsentReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberCode"] = this.memberCode;
        data["sentDate"] = this.sentDate ? this.sentDate.toISOString() : <any>undefined;
        data["content"] = this.content;
        data["phoneNumber"] = this.phoneNumber;
        data["otp"] = this.otp;
        data["isAccept"] = this.isAccept;
        data["memberName"] = this.memberName;
        data["id"] = this.id;
        return data;
    }
}

export interface IConsentReportDto {
    memberCode: string | undefined;
    sentDate: moment.Moment | undefined;
    content: string | undefined;
    phoneNumber: string | undefined;
    otp: string | undefined;
    isAccept: boolean | undefined;
    memberName: string | undefined;
    id: number | undefined;
}

export class GetConsentReportForEditOutput implements IGetConsentReportForEditOutput {
    consentReport!: CreateOrEditConsentReportDto | undefined;

    constructor(data?: IGetConsentReportForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.consentReport = data["consentReport"] ? CreateOrEditConsentReportDto.fromJS(data["consentReport"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetConsentReportForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetConsentReportForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["consentReport"] = this.consentReport ? this.consentReport.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetConsentReportForEditOutput {
    consentReport: CreateOrEditConsentReportDto | undefined;
}

export class CreateOrEditConsentReportDto implements ICreateOrEditConsentReportDto {
    memberCode!: string | undefined;
    sentDate!: moment.Moment | undefined;
    content!: string | undefined;
    phoneNumber!: string | undefined;
    otp!: string | undefined;
    isAccept!: boolean | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditConsentReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberCode = data["memberCode"];
            this.sentDate = data["sentDate"] ? moment(data["sentDate"].toString()) : <any>undefined;
            this.content = data["content"];
            this.phoneNumber = data["phoneNumber"];
            this.otp = data["otp"];
            this.isAccept = data["isAccept"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditConsentReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditConsentReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberCode"] = this.memberCode;
        data["sentDate"] = this.sentDate ? this.sentDate.toISOString() : <any>undefined;
        data["content"] = this.content;
        data["phoneNumber"] = this.phoneNumber;
        data["otp"] = this.otp;
        data["isAccept"] = this.isAccept;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditConsentReportDto {
    memberCode: string | undefined;
    sentDate: moment.Moment | undefined;
    content: string | undefined;
    phoneNumber: string | undefined;
    otp: string | undefined;
    isAccept: boolean | undefined;
    id: number | undefined;
}

export class GetAllConsentReportsInput implements IGetAllConsentReportsInput {
    filter!: string | undefined;
    memberCodeFilter!: string | undefined;
    maxSentDateFilter!: moment.Moment | undefined;
    minSentDateFilter!: moment.Moment | undefined;
    contentFilter!: string | undefined;
    phoneNumberFilter!: string | undefined;
    otpFilter!: string | undefined;
    isAcceptFilter!: number | undefined;
    sorting!: string | undefined;
    skipCount!: number | undefined;
    maxResultCount!: number | undefined;

    constructor(data?: IGetAllConsentReportsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.filter = data["filter"];
            this.memberCodeFilter = data["memberCodeFilter"];
            this.maxSentDateFilter = data["maxSentDateFilter"] ? moment(data["maxSentDateFilter"].toString()) : <any>undefined;
            this.minSentDateFilter = data["minSentDateFilter"] ? moment(data["minSentDateFilter"].toString()) : <any>undefined;
            this.contentFilter = data["contentFilter"];
            this.phoneNumberFilter = data["phoneNumberFilter"];
            this.otpFilter = data["otpFilter"];
            this.isAcceptFilter = data["isAcceptFilter"];
            this.sorting = data["sorting"];
            this.skipCount = data["skipCount"];
            this.maxResultCount = data["maxResultCount"];
        }
    }

    static fromJS(data: any): GetAllConsentReportsInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllConsentReportsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        data["memberCodeFilter"] = this.memberCodeFilter;
        data["maxSentDateFilter"] = this.maxSentDateFilter ? this.maxSentDateFilter.toISOString() : <any>undefined;
        data["minSentDateFilter"] = this.minSentDateFilter ? this.minSentDateFilter.toISOString() : <any>undefined;
        data["contentFilter"] = this.contentFilter;
        data["phoneNumberFilter"] = this.phoneNumberFilter;
        data["otpFilter"] = this.otpFilter;
        data["isAcceptFilter"] = this.isAcceptFilter;
        data["sorting"] = this.sorting;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data;
    }
}

export interface IGetAllConsentReportsInput {
    filter: string | undefined;
    memberCodeFilter: string | undefined;
    maxSentDateFilter: moment.Moment | undefined;
    minSentDateFilter: moment.Moment | undefined;
    contentFilter: string | undefined;
    phoneNumberFilter: string | undefined;
    otpFilter: string | undefined;
    isAcceptFilter: number | undefined;
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;
}

export class PagedResultDtoOfGetConsumerActivityForViewDto implements IPagedResultDtoOfGetConsumerActivityForViewDto {
    totalCount!: number | undefined;
    items!: GetConsumerActivityForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetConsumerActivityForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetConsumerActivityForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetConsumerActivityForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetConsumerActivityForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetConsumerActivityForViewDto {
    totalCount: number | undefined;
    items: GetConsumerActivityForViewDto[] | undefined;
}

export class GetConsumerActivityForViewDto implements IGetConsumerActivityForViewDto {
    consumerActivity!: ConsumerActivityDto | undefined;

    constructor(data?: IGetConsumerActivityForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.consumerActivity = data["consumerActivity"] ? ConsumerActivityDto.fromJS(data["consumerActivity"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetConsumerActivityForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetConsumerActivityForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["consumerActivity"] = this.consumerActivity ? this.consumerActivity.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetConsumerActivityForViewDto {
    consumerActivity: ConsumerActivityDto | undefined;
}

export class ConsumerActivityDto implements IConsumerActivityDto {
    memberCode!: string | undefined;
    activityType!: string | undefined;
    activityTime!: moment.Moment | undefined;
    referrenceCode!: string | undefined;
    customerCode!: string | undefined;
    id!: number | undefined;

    constructor(data?: IConsumerActivityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberCode = data["memberCode"];
            this.activityType = data["activityType"];
            this.activityTime = data["activityTime"] ? moment(data["activityTime"].toString()) : <any>undefined;
            this.referrenceCode = data["referrenceCode"];
            this.customerCode = data["customerCode"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ConsumerActivityDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConsumerActivityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberCode"] = this.memberCode;
        data["activityType"] = this.activityType;
        data["activityTime"] = this.activityTime ? this.activityTime.toISOString() : <any>undefined;
        data["referrenceCode"] = this.referrenceCode;
        data["customerCode"] = this.customerCode;
        data["id"] = this.id;
        return data;
    }
}

export interface IConsumerActivityDto {
    memberCode: string | undefined;
    activityType: string | undefined;
    activityTime: moment.Moment | undefined;
    referrenceCode: string | undefined;
    customerCode: string | undefined;
    id: number | undefined;
}

export class GetConsumerActivityForEditOutput implements IGetConsumerActivityForEditOutput {
    consumerActivity!: CreateOrEditConsumerActivityDto | undefined;

    constructor(data?: IGetConsumerActivityForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.consumerActivity = data["consumerActivity"] ? CreateOrEditConsumerActivityDto.fromJS(data["consumerActivity"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetConsumerActivityForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetConsumerActivityForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["consumerActivity"] = this.consumerActivity ? this.consumerActivity.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetConsumerActivityForEditOutput {
    consumerActivity: CreateOrEditConsumerActivityDto | undefined;
}

export class CreateOrEditConsumerActivityDto implements ICreateOrEditConsumerActivityDto {
    memberCode!: string | undefined;
    activityType!: string | undefined;
    activityTime!: moment.Moment | undefined;
    referrenceCode!: string | undefined;
    customerCode!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditConsumerActivityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberCode = data["memberCode"];
            this.activityType = data["activityType"];
            this.activityTime = data["activityTime"] ? moment(data["activityTime"].toString()) : <any>undefined;
            this.referrenceCode = data["referrenceCode"];
            this.customerCode = data["customerCode"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditConsumerActivityDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditConsumerActivityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberCode"] = this.memberCode;
        data["activityType"] = this.activityType;
        data["activityTime"] = this.activityTime ? this.activityTime.toISOString() : <any>undefined;
        data["referrenceCode"] = this.referrenceCode;
        data["customerCode"] = this.customerCode;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditConsumerActivityDto {
    memberCode: string | undefined;
    activityType: string | undefined;
    activityTime: moment.Moment | undefined;
    referrenceCode: string | undefined;
    customerCode: string | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfGetProductForViewDto implements IPagedResultDtoOfGetProductForViewDto {
    totalCount!: number | undefined;
    items!: GetProductForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetProductForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetProductForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetProductForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetProductForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetProductForViewDto {
    totalCount: number | undefined;
    items: GetProductForViewDto[] | undefined;
}

export class GetProductForViewDto implements IGetProductForViewDto {
    product!: ConsumerDbProductDto | undefined;

    constructor(data?: IGetProductForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.product = data["product"] ? ConsumerDbProductDto.fromJS(data["product"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetProductForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetProductForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetProductForViewDto {
    product: ConsumerDbProductDto | undefined;
}

export class ConsumerDbProductDto implements IConsumerDbProductDto {
    productCode!: string | undefined;
    productName1!: string | undefined;
    productName2!: string | undefined;
    hierarchyL1!: string | undefined;
    hierarchyL2!: string | undefined;
    hierarchyL3!: string | undefined;
    hierarchyL4!: string | undefined;
    hierarchyL5!: string | undefined;
    status!: string | undefined;
    productName2UnSign!: string | undefined;
    productName1UnSign!: string | undefined;
    imageLink!: string | undefined;
    referenceCode!: string | undefined;
    uomCode!: string | undefined;
    oldPrice!: number | undefined;
    newPrice!: number | undefined;
    description!: string | undefined;
    isNew!: boolean | undefined;
    tag!: string | undefined;
    contentVN!: string | undefined;
    contentEN!: string | undefined;
    linkDirect!: string | undefined;
    isFeature!: boolean | undefined;
    hierarchyFullLevel!: string | undefined;
    isOnApp!: boolean | undefined;
    lastModificationTime!: moment.Moment | undefined;
    id!: number | undefined;

    constructor(data?: IConsumerDbProductDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.productCode = data["productCode"];
            this.productName1 = data["productName1"];
            this.productName2 = data["productName2"];
            this.hierarchyL1 = data["hierarchyL1"];
            this.hierarchyL2 = data["hierarchyL2"];
            this.hierarchyL3 = data["hierarchyL3"];
            this.hierarchyL4 = data["hierarchyL4"];
            this.hierarchyL5 = data["hierarchyL5"];
            this.status = data["status"];
            this.productName2UnSign = data["productName2UnSign"];
            this.productName1UnSign = data["productName1UnSign"];
            this.imageLink = data["imageLink"];
            this.referenceCode = data["referenceCode"];
            this.uomCode = data["uomCode"];
            this.oldPrice = data["oldPrice"];
            this.newPrice = data["newPrice"];
            this.description = data["description"];
            this.isNew = data["isNew"];
            this.tag = data["tag"];
            this.contentVN = data["contentVN"];
            this.contentEN = data["contentEN"];
            this.linkDirect = data["linkDirect"];
            this.isFeature = data["isFeature"];
            this.hierarchyFullLevel = data["hierarchyFullLevel"];
            this.isOnApp = data["isOnApp"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ConsumerDbProductDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConsumerDbProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productCode"] = this.productCode;
        data["productName1"] = this.productName1;
        data["productName2"] = this.productName2;
        data["hierarchyL1"] = this.hierarchyL1;
        data["hierarchyL2"] = this.hierarchyL2;
        data["hierarchyL3"] = this.hierarchyL3;
        data["hierarchyL4"] = this.hierarchyL4;
        data["hierarchyL5"] = this.hierarchyL5;
        data["status"] = this.status;
        data["productName2UnSign"] = this.productName2UnSign;
        data["productName1UnSign"] = this.productName1UnSign;
        data["imageLink"] = this.imageLink;
        data["referenceCode"] = this.referenceCode;
        data["uomCode"] = this.uomCode;
        data["oldPrice"] = this.oldPrice;
        data["newPrice"] = this.newPrice;
        data["description"] = this.description;
        data["isNew"] = this.isNew;
        data["tag"] = this.tag;
        data["contentVN"] = this.contentVN;
        data["contentEN"] = this.contentEN;
        data["linkDirect"] = this.linkDirect;
        data["isFeature"] = this.isFeature;
        data["hierarchyFullLevel"] = this.hierarchyFullLevel;
        data["isOnApp"] = this.isOnApp;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IConsumerDbProductDto {
    productCode: string | undefined;
    productName1: string | undefined;
    productName2: string | undefined;
    hierarchyL1: string | undefined;
    hierarchyL2: string | undefined;
    hierarchyL3: string | undefined;
    hierarchyL4: string | undefined;
    hierarchyL5: string | undefined;
    status: string | undefined;
    productName2UnSign: string | undefined;
    productName1UnSign: string | undefined;
    imageLink: string | undefined;
    referenceCode: string | undefined;
    uomCode: string | undefined;
    oldPrice: number | undefined;
    newPrice: number | undefined;
    description: string | undefined;
    isNew: boolean | undefined;
    tag: string | undefined;
    contentVN: string | undefined;
    contentEN: string | undefined;
    linkDirect: string | undefined;
    isFeature: boolean | undefined;
    hierarchyFullLevel: string | undefined;
    isOnApp: boolean | undefined;
    lastModificationTime: moment.Moment | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfGetProductExchangedForViewDto implements IPagedResultDtoOfGetProductExchangedForViewDto {
    totalCount!: number | undefined;
    items!: GetProductExchangedForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetProductExchangedForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetProductExchangedForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetProductExchangedForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetProductExchangedForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetProductExchangedForViewDto {
    totalCount: number | undefined;
    items: GetProductExchangedForViewDto[] | undefined;
}

export class GetProductExchangedForViewDto implements IGetProductExchangedForViewDto {
    productExchanged!: ProductExchangedDto | undefined;

    constructor(data?: IGetProductExchangedForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.productExchanged = data["productExchanged"] ? ProductExchangedDto.fromJS(data["productExchanged"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetProductExchangedForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetProductExchangedForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productExchanged"] = this.productExchanged ? this.productExchanged.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetProductExchangedForViewDto {
    productExchanged: ProductExchangedDto | undefined;
}

export class ProductExchangedDto implements IProductExchangedDto {
    productCode!: string | undefined;
    productName1!: string | undefined;
    hierarchyL1!: string | undefined;

    constructor(data?: IProductExchangedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.productCode = data["productCode"];
            this.productName1 = data["productName1"];
            this.hierarchyL1 = data["hierarchyL1"];
        }
    }

    static fromJS(data: any): ProductExchangedDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductExchangedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productCode"] = this.productCode;
        data["productName1"] = this.productName1;
        data["hierarchyL1"] = this.hierarchyL1;
        return data;
    }
}

export interface IProductExchangedDto {
    productCode: string | undefined;
    productName1: string | undefined;
    hierarchyL1: string | undefined;
}

export class GetConsumerDbProductForEditOutput implements IGetConsumerDbProductForEditOutput {
    product!: CreateOrEditConsumerDbProductDto | undefined;

    constructor(data?: IGetConsumerDbProductForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.product = data["product"] ? CreateOrEditConsumerDbProductDto.fromJS(data["product"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetConsumerDbProductForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetConsumerDbProductForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetConsumerDbProductForEditOutput {
    product: CreateOrEditConsumerDbProductDto | undefined;
}

export class CreateOrEditConsumerDbProductDto implements ICreateOrEditConsumerDbProductDto {
    productCode!: string | undefined;
    productName1!: string | undefined;
    productName2!: string | undefined;
    hierarchyL1!: string | undefined;
    hierarchyL2!: string | undefined;
    hierarchyL3!: string | undefined;
    hierarchyL4!: string | undefined;
    hierarchyL5!: string | undefined;
    status!: string | undefined;
    productName2UnSign!: string | undefined;
    productName1UnSign!: string | undefined;
    imageLink!: string | undefined;
    referenceCode!: string | undefined;
    uomCode!: string | undefined;
    oldPrice!: number | undefined;
    newPrice!: number | undefined;
    description!: string | undefined;
    isNew!: boolean | undefined;
    tag!: string | undefined;
    contentVN!: string | undefined;
    contentEN!: string | undefined;
    linkDirect!: string | undefined;
    isFeature!: boolean | undefined;
    hierarchyFullLevel!: string | undefined;
    isOnApp!: boolean | undefined;
    relatedProduct!: RelatedConsumerProduct[] | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditConsumerDbProductDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.productCode = data["productCode"];
            this.productName1 = data["productName1"];
            this.productName2 = data["productName2"];
            this.hierarchyL1 = data["hierarchyL1"];
            this.hierarchyL2 = data["hierarchyL2"];
            this.hierarchyL3 = data["hierarchyL3"];
            this.hierarchyL4 = data["hierarchyL4"];
            this.hierarchyL5 = data["hierarchyL5"];
            this.status = data["status"];
            this.productName2UnSign = data["productName2UnSign"];
            this.productName1UnSign = data["productName1UnSign"];
            this.imageLink = data["imageLink"];
            this.referenceCode = data["referenceCode"];
            this.uomCode = data["uomCode"];
            this.oldPrice = data["oldPrice"];
            this.newPrice = data["newPrice"];
            this.description = data["description"];
            this.isNew = data["isNew"];
            this.tag = data["tag"];
            this.contentVN = data["contentVN"];
            this.contentEN = data["contentEN"];
            this.linkDirect = data["linkDirect"];
            this.isFeature = data["isFeature"];
            this.hierarchyFullLevel = data["hierarchyFullLevel"];
            this.isOnApp = data["isOnApp"];
            if (data["relatedProduct"] && data["relatedProduct"].constructor === Array) {
                this.relatedProduct = [];
                for (let item of data["relatedProduct"])
                    this.relatedProduct.push(RelatedConsumerProduct.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditConsumerDbProductDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditConsumerDbProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productCode"] = this.productCode;
        data["productName1"] = this.productName1;
        data["productName2"] = this.productName2;
        data["hierarchyL1"] = this.hierarchyL1;
        data["hierarchyL2"] = this.hierarchyL2;
        data["hierarchyL3"] = this.hierarchyL3;
        data["hierarchyL4"] = this.hierarchyL4;
        data["hierarchyL5"] = this.hierarchyL5;
        data["status"] = this.status;
        data["productName2UnSign"] = this.productName2UnSign;
        data["productName1UnSign"] = this.productName1UnSign;
        data["imageLink"] = this.imageLink;
        data["referenceCode"] = this.referenceCode;
        data["uomCode"] = this.uomCode;
        data["oldPrice"] = this.oldPrice;
        data["newPrice"] = this.newPrice;
        data["description"] = this.description;
        data["isNew"] = this.isNew;
        data["tag"] = this.tag;
        data["contentVN"] = this.contentVN;
        data["contentEN"] = this.contentEN;
        data["linkDirect"] = this.linkDirect;
        data["isFeature"] = this.isFeature;
        data["hierarchyFullLevel"] = this.hierarchyFullLevel;
        data["isOnApp"] = this.isOnApp;
        if (this.relatedProduct && this.relatedProduct.constructor === Array) {
            data["relatedProduct"] = [];
            for (let item of this.relatedProduct)
                data["relatedProduct"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditConsumerDbProductDto {
    productCode: string | undefined;
    productName1: string | undefined;
    productName2: string | undefined;
    hierarchyL1: string | undefined;
    hierarchyL2: string | undefined;
    hierarchyL3: string | undefined;
    hierarchyL4: string | undefined;
    hierarchyL5: string | undefined;
    status: string | undefined;
    productName2UnSign: string | undefined;
    productName1UnSign: string | undefined;
    imageLink: string | undefined;
    referenceCode: string | undefined;
    uomCode: string | undefined;
    oldPrice: number | undefined;
    newPrice: number | undefined;
    description: string | undefined;
    isNew: boolean | undefined;
    tag: string | undefined;
    contentVN: string | undefined;
    contentEN: string | undefined;
    linkDirect: string | undefined;
    isFeature: boolean | undefined;
    hierarchyFullLevel: string | undefined;
    isOnApp: boolean | undefined;
    relatedProduct: RelatedConsumerProduct[] | undefined;
    id: number | undefined;
}

export class RelatedConsumerProduct implements IRelatedConsumerProduct {
    productCode!: string | undefined;
    nameVn!: string | undefined;
    nameEn!: string | undefined;
    description!: string | undefined;
    contentVn!: string | undefined;
    contentEn!: string | undefined;
    id!: number | undefined;
    image!: string | undefined;
    status!: string | undefined;
    uom!: string | undefined;
    oldPrice!: number | undefined;
    newPrice!: number | undefined;

    constructor(data?: IRelatedConsumerProduct) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.productCode = data["productCode"];
            this.nameVn = data["nameVn"];
            this.nameEn = data["nameEn"];
            this.description = data["description"];
            this.contentVn = data["contentVn"];
            this.contentEn = data["contentEn"];
            this.id = data["id"];
            this.image = data["image"];
            this.status = data["status"];
            this.uom = data["uom"];
            this.oldPrice = data["oldPrice"];
            this.newPrice = data["newPrice"];
        }
    }

    static fromJS(data: any): RelatedConsumerProduct {
        data = typeof data === 'object' ? data : {};
        let result = new RelatedConsumerProduct();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productCode"] = this.productCode;
        data["nameVn"] = this.nameVn;
        data["nameEn"] = this.nameEn;
        data["description"] = this.description;
        data["contentVn"] = this.contentVn;
        data["contentEn"] = this.contentEn;
        data["id"] = this.id;
        data["image"] = this.image;
        data["status"] = this.status;
        data["uom"] = this.uom;
        data["oldPrice"] = this.oldPrice;
        data["newPrice"] = this.newPrice;
        return data;
    }
}

export interface IRelatedConsumerProduct {
    productCode: string | undefined;
    nameVn: string | undefined;
    nameEn: string | undefined;
    description: string | undefined;
    contentVn: string | undefined;
    contentEn: string | undefined;
    id: number | undefined;
    image: string | undefined;
    status: string | undefined;
    uom: string | undefined;
    oldPrice: number | undefined;
    newPrice: number | undefined;
}

export class GetAllConsumerDbProductsInput implements IGetAllConsumerDbProductsInput {
    filter!: string | undefined;
    productCodeFilter!: string | undefined;
    productName1Filter!: string | undefined;
    productName2Filter!: string | undefined;
    hierarchyL1Filter!: string | undefined;
    hierarchyL2Filter!: string | undefined;
    hierarchyL3Filter!: string | undefined;
    hierarchyL4Filter!: string | undefined;
    hierarchyL5Filter!: string | undefined;
    statusFilter!: string | undefined;
    productName2UnSignFilter!: string | undefined;
    productName1UnSignFilter!: string | undefined;
    imageLinkFilter!: string | undefined;
    referenceCodeFilter!: string | undefined;
    uomCodeFilter!: string | undefined;
    maxOldPriceFilter!: number | undefined;
    minOldPriceFilter!: number | undefined;
    maxNewPriceFilter!: number | undefined;
    minNewPriceFilter!: number | undefined;
    descriptionFilter!: string | undefined;
    isNewFilter!: number | undefined;
    tagFilter!: string | undefined;
    contentVNFilter!: string | undefined;
    contentENFilter!: string | undefined;
    linkDirectFilter!: string | undefined;
    isFeatureFilter!: number | undefined;
    hierarchyFullLevelFilter!: string | undefined;
    isOnApp!: boolean | undefined;
    sorting!: string | undefined;
    skipCount!: number | undefined;
    maxResultCount!: number | undefined;

    constructor(data?: IGetAllConsumerDbProductsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.filter = data["filter"];
            this.productCodeFilter = data["productCodeFilter"];
            this.productName1Filter = data["productName1Filter"];
            this.productName2Filter = data["productName2Filter"];
            this.hierarchyL1Filter = data["hierarchyL1Filter"];
            this.hierarchyL2Filter = data["hierarchyL2Filter"];
            this.hierarchyL3Filter = data["hierarchyL3Filter"];
            this.hierarchyL4Filter = data["hierarchyL4Filter"];
            this.hierarchyL5Filter = data["hierarchyL5Filter"];
            this.statusFilter = data["statusFilter"];
            this.productName2UnSignFilter = data["productName2UnSignFilter"];
            this.productName1UnSignFilter = data["productName1UnSignFilter"];
            this.imageLinkFilter = data["imageLinkFilter"];
            this.referenceCodeFilter = data["referenceCodeFilter"];
            this.uomCodeFilter = data["uomCodeFilter"];
            this.maxOldPriceFilter = data["maxOldPriceFilter"];
            this.minOldPriceFilter = data["minOldPriceFilter"];
            this.maxNewPriceFilter = data["maxNewPriceFilter"];
            this.minNewPriceFilter = data["minNewPriceFilter"];
            this.descriptionFilter = data["descriptionFilter"];
            this.isNewFilter = data["isNewFilter"];
            this.tagFilter = data["tagFilter"];
            this.contentVNFilter = data["contentVNFilter"];
            this.contentENFilter = data["contentENFilter"];
            this.linkDirectFilter = data["linkDirectFilter"];
            this.isFeatureFilter = data["isFeatureFilter"];
            this.hierarchyFullLevelFilter = data["hierarchyFullLevelFilter"];
            this.isOnApp = data["isOnApp"];
            this.sorting = data["sorting"];
            this.skipCount = data["skipCount"];
            this.maxResultCount = data["maxResultCount"];
        }
    }

    static fromJS(data: any): GetAllConsumerDbProductsInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllConsumerDbProductsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        data["productCodeFilter"] = this.productCodeFilter;
        data["productName1Filter"] = this.productName1Filter;
        data["productName2Filter"] = this.productName2Filter;
        data["hierarchyL1Filter"] = this.hierarchyL1Filter;
        data["hierarchyL2Filter"] = this.hierarchyL2Filter;
        data["hierarchyL3Filter"] = this.hierarchyL3Filter;
        data["hierarchyL4Filter"] = this.hierarchyL4Filter;
        data["hierarchyL5Filter"] = this.hierarchyL5Filter;
        data["statusFilter"] = this.statusFilter;
        data["productName2UnSignFilter"] = this.productName2UnSignFilter;
        data["productName1UnSignFilter"] = this.productName1UnSignFilter;
        data["imageLinkFilter"] = this.imageLinkFilter;
        data["referenceCodeFilter"] = this.referenceCodeFilter;
        data["uomCodeFilter"] = this.uomCodeFilter;
        data["maxOldPriceFilter"] = this.maxOldPriceFilter;
        data["minOldPriceFilter"] = this.minOldPriceFilter;
        data["maxNewPriceFilter"] = this.maxNewPriceFilter;
        data["minNewPriceFilter"] = this.minNewPriceFilter;
        data["descriptionFilter"] = this.descriptionFilter;
        data["isNewFilter"] = this.isNewFilter;
        data["tagFilter"] = this.tagFilter;
        data["contentVNFilter"] = this.contentVNFilter;
        data["contentENFilter"] = this.contentENFilter;
        data["linkDirectFilter"] = this.linkDirectFilter;
        data["isFeatureFilter"] = this.isFeatureFilter;
        data["hierarchyFullLevelFilter"] = this.hierarchyFullLevelFilter;
        data["isOnApp"] = this.isOnApp;
        data["sorting"] = this.sorting;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data;
    }
}

export interface IGetAllConsumerDbProductsInput {
    filter: string | undefined;
    productCodeFilter: string | undefined;
    productName1Filter: string | undefined;
    productName2Filter: string | undefined;
    hierarchyL1Filter: string | undefined;
    hierarchyL2Filter: string | undefined;
    hierarchyL3Filter: string | undefined;
    hierarchyL4Filter: string | undefined;
    hierarchyL5Filter: string | undefined;
    statusFilter: string | undefined;
    productName2UnSignFilter: string | undefined;
    productName1UnSignFilter: string | undefined;
    imageLinkFilter: string | undefined;
    referenceCodeFilter: string | undefined;
    uomCodeFilter: string | undefined;
    maxOldPriceFilter: number | undefined;
    minOldPriceFilter: number | undefined;
    maxNewPriceFilter: number | undefined;
    minNewPriceFilter: number | undefined;
    descriptionFilter: string | undefined;
    isNewFilter: number | undefined;
    tagFilter: string | undefined;
    contentVNFilter: string | undefined;
    contentENFilter: string | undefined;
    linkDirectFilter: string | undefined;
    isFeatureFilter: number | undefined;
    hierarchyFullLevelFilter: string | undefined;
    isOnApp: boolean | undefined;
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;
}

export class ConditionSearchProduct implements IConditionSearchProduct {
    hierarchyL1!: string[] | undefined;
    hierarchyL2!: string[] | undefined;
    hierarchyL3!: string[] | undefined;
    hierarchyL4!: string[] | undefined;

    constructor(data?: IConditionSearchProduct) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["hierarchyL1"] && data["hierarchyL1"].constructor === Array) {
                this.hierarchyL1 = [];
                for (let item of data["hierarchyL1"])
                    this.hierarchyL1.push(item);
            }
            if (data["hierarchyL2"] && data["hierarchyL2"].constructor === Array) {
                this.hierarchyL2 = [];
                for (let item of data["hierarchyL2"])
                    this.hierarchyL2.push(item);
            }
            if (data["hierarchyL3"] && data["hierarchyL3"].constructor === Array) {
                this.hierarchyL3 = [];
                for (let item of data["hierarchyL3"])
                    this.hierarchyL3.push(item);
            }
            if (data["hierarchyL4"] && data["hierarchyL4"].constructor === Array) {
                this.hierarchyL4 = [];
                for (let item of data["hierarchyL4"])
                    this.hierarchyL4.push(item);
            }
        }
    }

    static fromJS(data: any): ConditionSearchProduct {
        data = typeof data === 'object' ? data : {};
        let result = new ConditionSearchProduct();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.hierarchyL1 && this.hierarchyL1.constructor === Array) {
            data["hierarchyL1"] = [];
            for (let item of this.hierarchyL1)
                data["hierarchyL1"].push(item);
        }
        if (this.hierarchyL2 && this.hierarchyL2.constructor === Array) {
            data["hierarchyL2"] = [];
            for (let item of this.hierarchyL2)
                data["hierarchyL2"].push(item);
        }
        if (this.hierarchyL3 && this.hierarchyL3.constructor === Array) {
            data["hierarchyL3"] = [];
            for (let item of this.hierarchyL3)
                data["hierarchyL3"].push(item);
        }
        if (this.hierarchyL4 && this.hierarchyL4.constructor === Array) {
            data["hierarchyL4"] = [];
            for (let item of this.hierarchyL4)
                data["hierarchyL4"].push(item);
        }
        return data;
    }
}

export interface IConditionSearchProduct {
    hierarchyL1: string[] | undefined;
    hierarchyL2: string[] | undefined;
    hierarchyL3: string[] | undefined;
    hierarchyL4: string[] | undefined;
}

export class ProductInfoAgrs implements IProductInfoAgrs {
    tableName!: string | undefined;
    filePath!: string | undefined;
    fileName!: string | undefined;
    userId!: number | undefined;
    tenantId!: number | undefined;
    currentLanguage!: string | undefined;
    apiUrl!: string | undefined;

    constructor(data?: IProductInfoAgrs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tableName = data["tableName"];
            this.filePath = data["filePath"];
            this.fileName = data["fileName"];
            this.userId = data["userId"];
            this.tenantId = data["tenantId"];
            this.currentLanguage = data["currentLanguage"];
            this.apiUrl = data["apiUrl"];
        }
    }

    static fromJS(data: any): ProductInfoAgrs {
        data = typeof data === 'object' ? data : {};
        let result = new ProductInfoAgrs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tableName"] = this.tableName;
        data["filePath"] = this.filePath;
        data["fileName"] = this.fileName;
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["currentLanguage"] = this.currentLanguage;
        data["apiUrl"] = this.apiUrl;
        return data;
    }
}

export interface IProductInfoAgrs {
    tableName: string | undefined;
    filePath: string | undefined;
    fileName: string | undefined;
    userId: number | undefined;
    tenantId: number | undefined;
    currentLanguage: string | undefined;
    apiUrl: string | undefined;
}

export class PagedResultDtoOfGetConsumerLoginForViewDto implements IPagedResultDtoOfGetConsumerLoginForViewDto {
    totalCount!: number | undefined;
    items!: GetConsumerLoginForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetConsumerLoginForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetConsumerLoginForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetConsumerLoginForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetConsumerLoginForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetConsumerLoginForViewDto {
    totalCount: number | undefined;
    items: GetConsumerLoginForViewDto[] | undefined;
}

export class GetConsumerLoginForViewDto implements IGetConsumerLoginForViewDto {
    consumerLogin!: ConsumerLoginDto | undefined;

    constructor(data?: IGetConsumerLoginForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.consumerLogin = data["consumerLogin"] ? ConsumerLoginDto.fromJS(data["consumerLogin"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetConsumerLoginForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetConsumerLoginForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["consumerLogin"] = this.consumerLogin ? this.consumerLogin.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetConsumerLoginForViewDto {
    consumerLogin: ConsumerLoginDto | undefined;
}

export class ConsumerLoginDto implements IConsumerLoginDto {
    memberCode!: string | undefined;
    name!: string | undefined;
    phone!: string | undefined;
    email!: string | undefined;
    facebookID!: string | undefined;
    googleID!: string | undefined;
    isLogOut!: boolean | undefined;
    deviceID!: string | undefined;
    lastLogin!: moment.Moment | undefined;
    id!: number | undefined;

    constructor(data?: IConsumerLoginDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberCode = data["memberCode"];
            this.name = data["name"];
            this.phone = data["phone"];
            this.email = data["email"];
            this.facebookID = data["facebookID"];
            this.googleID = data["googleID"];
            this.isLogOut = data["isLogOut"];
            this.deviceID = data["deviceID"];
            this.lastLogin = data["lastLogin"] ? moment(data["lastLogin"].toString()) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ConsumerLoginDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConsumerLoginDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberCode"] = this.memberCode;
        data["name"] = this.name;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["facebookID"] = this.facebookID;
        data["googleID"] = this.googleID;
        data["isLogOut"] = this.isLogOut;
        data["deviceID"] = this.deviceID;
        data["lastLogin"] = this.lastLogin ? this.lastLogin.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IConsumerLoginDto {
    memberCode: string | undefined;
    name: string | undefined;
    phone: string | undefined;
    email: string | undefined;
    facebookID: string | undefined;
    googleID: string | undefined;
    isLogOut: boolean | undefined;
    deviceID: string | undefined;
    lastLogin: moment.Moment | undefined;
    id: number | undefined;
}

export class GetConsumerLoginForEditOutput implements IGetConsumerLoginForEditOutput {
    consumerLogin!: CreateOrEditConsumerLoginDto | undefined;

    constructor(data?: IGetConsumerLoginForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.consumerLogin = data["consumerLogin"] ? CreateOrEditConsumerLoginDto.fromJS(data["consumerLogin"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetConsumerLoginForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetConsumerLoginForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["consumerLogin"] = this.consumerLogin ? this.consumerLogin.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetConsumerLoginForEditOutput {
    consumerLogin: CreateOrEditConsumerLoginDto | undefined;
}

export class CreateOrEditConsumerLoginDto implements ICreateOrEditConsumerLoginDto {
    memberCode!: string | undefined;
    name!: string | undefined;
    phone!: string | undefined;
    email!: string | undefined;
    facebookID!: string | undefined;
    googleID!: string | undefined;
    isLogOut!: boolean | undefined;
    deviceID!: string | undefined;
    lastLogin!: moment.Moment | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditConsumerLoginDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberCode = data["memberCode"];
            this.name = data["name"];
            this.phone = data["phone"];
            this.email = data["email"];
            this.facebookID = data["facebookID"];
            this.googleID = data["googleID"];
            this.isLogOut = data["isLogOut"];
            this.deviceID = data["deviceID"];
            this.lastLogin = data["lastLogin"] ? moment(data["lastLogin"].toString()) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditConsumerLoginDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditConsumerLoginDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberCode"] = this.memberCode;
        data["name"] = this.name;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["facebookID"] = this.facebookID;
        data["googleID"] = this.googleID;
        data["isLogOut"] = this.isLogOut;
        data["deviceID"] = this.deviceID;
        data["lastLogin"] = this.lastLogin ? this.lastLogin.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditConsumerLoginDto {
    memberCode: string | undefined;
    name: string | undefined;
    phone: string | undefined;
    email: string | undefined;
    facebookID: string | undefined;
    googleID: string | undefined;
    isLogOut: boolean | undefined;
    deviceID: string | undefined;
    lastLogin: moment.Moment | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfGetConsumerProfileForViewDto implements IPagedResultDtoOfGetConsumerProfileForViewDto {
    totalCount!: number | undefined;
    items!: GetConsumerProfileForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetConsumerProfileForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetConsumerProfileForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetConsumerProfileForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetConsumerProfileForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetConsumerProfileForViewDto {
    totalCount: number | undefined;
    items: GetConsumerProfileForViewDto[] | undefined;
}

export class GetConsumerProfileForViewDto implements IGetConsumerProfileForViewDto {
    consumerProfile!: ConsumerProfileDto | undefined;
    rankName!: string | undefined;
    countryName!: string | undefined;
    provinceName!: string | undefined;
    districtName!: string | undefined;
    wardName!: string | undefined;
    chatId!: string | undefined;

    constructor(data?: IGetConsumerProfileForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.consumerProfile = data["consumerProfile"] ? ConsumerProfileDto.fromJS(data["consumerProfile"]) : <any>undefined;
            this.rankName = data["rankName"];
            this.countryName = data["countryName"];
            this.provinceName = data["provinceName"];
            this.districtName = data["districtName"];
            this.wardName = data["wardName"];
            this.chatId = data["chatId"];
        }
    }

    static fromJS(data: any): GetConsumerProfileForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetConsumerProfileForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["consumerProfile"] = this.consumerProfile ? this.consumerProfile.toJSON() : <any>undefined;
        data["rankName"] = this.rankName;
        data["countryName"] = this.countryName;
        data["provinceName"] = this.provinceName;
        data["districtName"] = this.districtName;
        data["wardName"] = this.wardName;
        data["chatId"] = this.chatId;
        return data;
    }
}

export interface IGetConsumerProfileForViewDto {
    consumerProfile: ConsumerProfileDto | undefined;
    rankName: string | undefined;
    countryName: string | undefined;
    provinceName: string | undefined;
    districtName: string | undefined;
    wardName: string | undefined;
    chatId: string | undefined;
}

export class ConsumerProfileDto implements IConsumerProfileDto {
    memberCode!: string | undefined;
    name!: string | undefined;
    phone!: string | undefined;
    email!: string | undefined;
    gender!: string | undefined;
    birthday!: number | undefined;
    registrationDate!: number | undefined;
    pid!: string | undefined;
    sourceID!: string | undefined;
    receiveAds!: boolean | undefined;
    rankCode!: string | undefined;
    rankValidDate!: number | undefined;
    currentPoint!: number | undefined;
    nationalityCode!: string | undefined;
    occupationCode!: string | undefined;
    hobby!: string | undefined;
    address!: string | undefined;
    ward!: string | undefined;
    district!: string | undefined;
    province!: string | undefined;
    country!: string | undefined;
    status!: string | undefined;
    lastActivityTime!: moment.Moment | undefined;
    lastPurchaseTime!: moment.Moment | undefined;
    communicationLanguage!: string | undefined;
    notes!: string | undefined;
    rankPropose!: string | undefined;
    pinCode!: string | undefined;
    nameUnSign!: string | undefined;
    avatar!: string | undefined;
    workingPermit!: boolean | undefined;
    customerCode!: string | undefined;
    interestOf!: string | undefined;
    isInterestCobrand!: boolean | undefined;
    memberCard!: string | undefined;
    isForeigner!: boolean | undefined;
    isSynced!: boolean | undefined;
    referralCode!: string | undefined;
    accumulationPoint!: number | undefined;
    outletCode!: string | undefined;
    zaloName!: string | undefined;
    distributorCode!: string | undefined;
    distributorName!: string | undefined;
    regionCode!: string | undefined;
    targetRevenue!: number | undefined;
    actualRevenue!: number | undefined;
    bonus!: number | undefined;
    missingRevenue!: number | undefined;
    revenueUpdateDate!: number | undefined;
    note1!: string | undefined;
    note2!: string | undefined;
    note3!: string | undefined;
    note4!: string | undefined;
    note5!: string | undefined;
    consumerType!: string | undefined;
    creationTime!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;
    communicationChannels!: MemberChannelInfo[] | undefined;
    communicationChannelsString!: string | undefined;
    metaDataString!: string | undefined;
    rankName!: string | undefined;
    nationalityName!: string | undefined;
    chatId!: string | undefined;
    metaData!: string | undefined;
    id!: number | undefined;

    constructor(data?: IConsumerProfileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberCode = data["memberCode"];
            this.name = data["name"];
            this.phone = data["phone"];
            this.email = data["email"];
            this.gender = data["gender"];
            this.birthday = data["birthday"];
            this.registrationDate = data["registrationDate"];
            this.pid = data["pid"];
            this.sourceID = data["sourceID"];
            this.receiveAds = data["receiveAds"];
            this.rankCode = data["rankCode"];
            this.rankValidDate = data["rankValidDate"];
            this.currentPoint = data["currentPoint"];
            this.nationalityCode = data["nationalityCode"];
            this.occupationCode = data["occupationCode"];
            this.hobby = data["hobby"];
            this.address = data["address"];
            this.ward = data["ward"];
            this.district = data["district"];
            this.province = data["province"];
            this.country = data["country"];
            this.status = data["status"];
            this.lastActivityTime = data["lastActivityTime"] ? moment(data["lastActivityTime"].toString()) : <any>undefined;
            this.lastPurchaseTime = data["lastPurchaseTime"] ? moment(data["lastPurchaseTime"].toString()) : <any>undefined;
            this.communicationLanguage = data["communicationLanguage"];
            this.notes = data["notes"];
            this.rankPropose = data["rankPropose"];
            this.pinCode = data["pinCode"];
            this.nameUnSign = data["nameUnSign"];
            this.avatar = data["avatar"];
            this.workingPermit = data["workingPermit"];
            this.customerCode = data["customerCode"];
            this.interestOf = data["interestOf"];
            this.isInterestCobrand = data["isInterestCobrand"];
            this.memberCard = data["memberCard"];
            this.isForeigner = data["isForeigner"];
            this.isSynced = data["isSynced"];
            this.referralCode = data["referralCode"];
            this.accumulationPoint = data["accumulationPoint"];
            this.outletCode = data["outletCode"];
            this.zaloName = data["zaloName"];
            this.distributorCode = data["distributorCode"];
            this.distributorName = data["distributorName"];
            this.regionCode = data["regionCode"];
            this.targetRevenue = data["targetRevenue"];
            this.actualRevenue = data["actualRevenue"];
            this.bonus = data["bonus"];
            this.missingRevenue = data["missingRevenue"];
            this.revenueUpdateDate = data["revenueUpdateDate"];
            this.note1 = data["note1"];
            this.note2 = data["note2"];
            this.note3 = data["note3"];
            this.note4 = data["note4"];
            this.note5 = data["note5"];
            this.consumerType = data["consumerType"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            if (data["communicationChannels"] && data["communicationChannels"].constructor === Array) {
                this.communicationChannels = [];
                for (let item of data["communicationChannels"])
                    this.communicationChannels.push(MemberChannelInfo.fromJS(item));
            }
            this.communicationChannelsString = data["communicationChannelsString"];
            this.metaDataString = data["metaDataString"];
            this.rankName = data["rankName"];
            this.nationalityName = data["nationalityName"];
            this.chatId = data["chatId"];
            this.metaData = data["metaData"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ConsumerProfileDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConsumerProfileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberCode"] = this.memberCode;
        data["name"] = this.name;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["gender"] = this.gender;
        data["birthday"] = this.birthday;
        data["registrationDate"] = this.registrationDate;
        data["pid"] = this.pid;
        data["sourceID"] = this.sourceID;
        data["receiveAds"] = this.receiveAds;
        data["rankCode"] = this.rankCode;
        data["rankValidDate"] = this.rankValidDate;
        data["currentPoint"] = this.currentPoint;
        data["nationalityCode"] = this.nationalityCode;
        data["occupationCode"] = this.occupationCode;
        data["hobby"] = this.hobby;
        data["address"] = this.address;
        data["ward"] = this.ward;
        data["district"] = this.district;
        data["province"] = this.province;
        data["country"] = this.country;
        data["status"] = this.status;
        data["lastActivityTime"] = this.lastActivityTime ? this.lastActivityTime.toISOString() : <any>undefined;
        data["lastPurchaseTime"] = this.lastPurchaseTime ? this.lastPurchaseTime.toISOString() : <any>undefined;
        data["communicationLanguage"] = this.communicationLanguage;
        data["notes"] = this.notes;
        data["rankPropose"] = this.rankPropose;
        data["pinCode"] = this.pinCode;
        data["nameUnSign"] = this.nameUnSign;
        data["avatar"] = this.avatar;
        data["workingPermit"] = this.workingPermit;
        data["customerCode"] = this.customerCode;
        data["interestOf"] = this.interestOf;
        data["isInterestCobrand"] = this.isInterestCobrand;
        data["memberCard"] = this.memberCard;
        data["isForeigner"] = this.isForeigner;
        data["isSynced"] = this.isSynced;
        data["referralCode"] = this.referralCode;
        data["accumulationPoint"] = this.accumulationPoint;
        data["outletCode"] = this.outletCode;
        data["zaloName"] = this.zaloName;
        data["distributorCode"] = this.distributorCode;
        data["distributorName"] = this.distributorName;
        data["regionCode"] = this.regionCode;
        data["targetRevenue"] = this.targetRevenue;
        data["actualRevenue"] = this.actualRevenue;
        data["bonus"] = this.bonus;
        data["missingRevenue"] = this.missingRevenue;
        data["revenueUpdateDate"] = this.revenueUpdateDate;
        data["note1"] = this.note1;
        data["note2"] = this.note2;
        data["note3"] = this.note3;
        data["note4"] = this.note4;
        data["note5"] = this.note5;
        data["consumerType"] = this.consumerType;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        if (this.communicationChannels && this.communicationChannels.constructor === Array) {
            data["communicationChannels"] = [];
            for (let item of this.communicationChannels)
                data["communicationChannels"].push(item.toJSON());
        }
        data["communicationChannelsString"] = this.communicationChannelsString;
        data["metaDataString"] = this.metaDataString;
        data["rankName"] = this.rankName;
        data["nationalityName"] = this.nationalityName;
        data["chatId"] = this.chatId;
        data["metaData"] = this.metaData;
        data["id"] = this.id;
        return data;
    }
}

export interface IConsumerProfileDto {
    memberCode: string | undefined;
    name: string | undefined;
    phone: string | undefined;
    email: string | undefined;
    gender: string | undefined;
    birthday: number | undefined;
    registrationDate: number | undefined;
    pid: string | undefined;
    sourceID: string | undefined;
    receiveAds: boolean | undefined;
    rankCode: string | undefined;
    rankValidDate: number | undefined;
    currentPoint: number | undefined;
    nationalityCode: string | undefined;
    occupationCode: string | undefined;
    hobby: string | undefined;
    address: string | undefined;
    ward: string | undefined;
    district: string | undefined;
    province: string | undefined;
    country: string | undefined;
    status: string | undefined;
    lastActivityTime: moment.Moment | undefined;
    lastPurchaseTime: moment.Moment | undefined;
    communicationLanguage: string | undefined;
    notes: string | undefined;
    rankPropose: string | undefined;
    pinCode: string | undefined;
    nameUnSign: string | undefined;
    avatar: string | undefined;
    workingPermit: boolean | undefined;
    customerCode: string | undefined;
    interestOf: string | undefined;
    isInterestCobrand: boolean | undefined;
    memberCard: string | undefined;
    isForeigner: boolean | undefined;
    isSynced: boolean | undefined;
    referralCode: string | undefined;
    accumulationPoint: number | undefined;
    outletCode: string | undefined;
    zaloName: string | undefined;
    distributorCode: string | undefined;
    distributorName: string | undefined;
    regionCode: string | undefined;
    targetRevenue: number | undefined;
    actualRevenue: number | undefined;
    bonus: number | undefined;
    missingRevenue: number | undefined;
    revenueUpdateDate: number | undefined;
    note1: string | undefined;
    note2: string | undefined;
    note3: string | undefined;
    note4: string | undefined;
    note5: string | undefined;
    consumerType: string | undefined;
    creationTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    communicationChannels: MemberChannelInfo[] | undefined;
    communicationChannelsString: string | undefined;
    metaDataString: string | undefined;
    rankName: string | undefined;
    nationalityName: string | undefined;
    chatId: string | undefined;
    metaData: string | undefined;
    id: number | undefined;
}

export class MemberChannelInfo implements IMemberChannelInfo {
    channelCode!: string | undefined;
    memberChannelId!: string | undefined;
    extraParams!: { [key: string]: string; } | undefined;

    constructor(data?: IMemberChannelInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.channelCode = data["channelCode"];
            this.memberChannelId = data["memberChannelId"];
            if (data["extraParams"]) {
                this.extraParams = {};
                for (let key in data["extraParams"]) {
                    if (data["extraParams"].hasOwnProperty(key))
                        this.extraParams[key] = data["extraParams"][key];
                }
            }
        }
    }

    static fromJS(data: any): MemberChannelInfo {
        data = typeof data === 'object' ? data : {};
        let result = new MemberChannelInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["channelCode"] = this.channelCode;
        data["memberChannelId"] = this.memberChannelId;
        if (this.extraParams) {
            data["extraParams"] = {};
            for (let key in this.extraParams) {
                if (this.extraParams.hasOwnProperty(key))
                    data["extraParams"][key] = this.extraParams[key];
            }
        }
        return data;
    }
}

export interface IMemberChannelInfo {
    channelCode: string | undefined;
    memberChannelId: string | undefined;
    extraParams: { [key: string]: string; } | undefined;
}

export class GetConsumerProfileDtoForViewDto implements IGetConsumerProfileDtoForViewDto {
    consumerProfile!: ConsumerProfileDto | undefined;

    constructor(data?: IGetConsumerProfileDtoForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.consumerProfile = data["consumerProfile"] ? ConsumerProfileDto.fromJS(data["consumerProfile"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetConsumerProfileDtoForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetConsumerProfileDtoForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["consumerProfile"] = this.consumerProfile ? this.consumerProfile.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetConsumerProfileDtoForViewDto {
    consumerProfile: ConsumerProfileDto | undefined;
}

export class GetConsumerProfileForEditOutput implements IGetConsumerProfileForEditOutput {
    consumerProfile!: CreateOrEditConsumerProfileDto | undefined;
    channelsCode!: string[] | undefined;

    constructor(data?: IGetConsumerProfileForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.consumerProfile = data["consumerProfile"] ? CreateOrEditConsumerProfileDto.fromJS(data["consumerProfile"]) : <any>undefined;
            if (data["channelsCode"] && data["channelsCode"].constructor === Array) {
                this.channelsCode = [];
                for (let item of data["channelsCode"])
                    this.channelsCode.push(item);
            }
        }
    }

    static fromJS(data: any): GetConsumerProfileForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetConsumerProfileForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["consumerProfile"] = this.consumerProfile ? this.consumerProfile.toJSON() : <any>undefined;
        if (this.channelsCode && this.channelsCode.constructor === Array) {
            data["channelsCode"] = [];
            for (let item of this.channelsCode)
                data["channelsCode"].push(item);
        }
        return data;
    }
}

export interface IGetConsumerProfileForEditOutput {
    consumerProfile: CreateOrEditConsumerProfileDto | undefined;
    channelsCode: string[] | undefined;
}

export class CreateOrEditConsumerProfileDto implements ICreateOrEditConsumerProfileDto {
    memberCode!: string | undefined;
    name!: string | undefined;
    phone!: string | undefined;
    email!: string | undefined;
    gender!: string | undefined;
    birthday!: number | undefined;
    registrationDate!: number | undefined;
    pid!: string | undefined;
    sourceID!: string | undefined;
    receiveAds!: boolean | undefined;
    rankCode!: string | undefined;
    rankValidDate!: number | undefined;
    currentPoint!: number | undefined;
    nationalityCode!: string | undefined;
    occupationCode!: string | undefined;
    hobby!: string | undefined;
    address!: string | undefined;
    ward!: string | undefined;
    district!: string | undefined;
    province!: string | undefined;
    country!: string | undefined;
    status!: string | undefined;
    lastActivityTime!: moment.Moment | undefined;
    lastPurchaseTime!: moment.Moment | undefined;
    communicationLanguage!: string | undefined;
    notes!: string | undefined;
    rankPropose!: string | undefined;
    pinCode!: string | undefined;
    nameUnSign!: string | undefined;
    avatar!: string | undefined;
    workingPermit!: boolean | undefined;
    customerCode!: string | undefined;
    interestOf!: string | undefined;
    isInterestCobrand!: boolean | undefined;
    memberCard!: string | undefined;
    isForeigner!: boolean | undefined;
    isSynced!: boolean | undefined;
    referralCode!: string | undefined;
    accumulationPoint!: number | undefined;
    outletCode!: string | undefined;
    zaloName!: string | undefined;
    distributorCode!: string | undefined;
    distributorName!: string | undefined;
    regionCode!: string | undefined;
    targetRevenue!: number | undefined;
    actualRevenue!: number | undefined;
    bonus!: number | undefined;
    missingRevenue!: number | undefined;
    revenueUpdateDate!: number | undefined;
    note1!: string | undefined;
    note2!: string | undefined;
    note3!: string | undefined;
    note4!: string | undefined;
    note5!: string | undefined;
    salesManCode!: string | undefined;
    consumerType!: string | undefined;
    referrerCode!: string | undefined;
    communicationChannels!: MemberChannelInfo[] | undefined;
    communicationChannelsString!: string | undefined;
    chatId!: string | undefined;
    lastModificationTime!: moment.Moment | undefined;
    metaData!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditConsumerProfileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberCode = data["memberCode"];
            this.name = data["name"];
            this.phone = data["phone"];
            this.email = data["email"];
            this.gender = data["gender"];
            this.birthday = data["birthday"];
            this.registrationDate = data["registrationDate"];
            this.pid = data["pid"];
            this.sourceID = data["sourceID"];
            this.receiveAds = data["receiveAds"];
            this.rankCode = data["rankCode"];
            this.rankValidDate = data["rankValidDate"];
            this.currentPoint = data["currentPoint"];
            this.nationalityCode = data["nationalityCode"];
            this.occupationCode = data["occupationCode"];
            this.hobby = data["hobby"];
            this.address = data["address"];
            this.ward = data["ward"];
            this.district = data["district"];
            this.province = data["province"];
            this.country = data["country"];
            this.status = data["status"];
            this.lastActivityTime = data["lastActivityTime"] ? moment(data["lastActivityTime"].toString()) : <any>undefined;
            this.lastPurchaseTime = data["lastPurchaseTime"] ? moment(data["lastPurchaseTime"].toString()) : <any>undefined;
            this.communicationLanguage = data["communicationLanguage"];
            this.notes = data["notes"];
            this.rankPropose = data["rankPropose"];
            this.pinCode = data["pinCode"];
            this.nameUnSign = data["nameUnSign"];
            this.avatar = data["avatar"];
            this.workingPermit = data["workingPermit"];
            this.customerCode = data["customerCode"];
            this.interestOf = data["interestOf"];
            this.isInterestCobrand = data["isInterestCobrand"];
            this.memberCard = data["memberCard"];
            this.isForeigner = data["isForeigner"];
            this.isSynced = data["isSynced"];
            this.referralCode = data["referralCode"];
            this.accumulationPoint = data["accumulationPoint"];
            this.outletCode = data["outletCode"];
            this.zaloName = data["zaloName"];
            this.distributorCode = data["distributorCode"];
            this.distributorName = data["distributorName"];
            this.regionCode = data["regionCode"];
            this.targetRevenue = data["targetRevenue"];
            this.actualRevenue = data["actualRevenue"];
            this.bonus = data["bonus"];
            this.missingRevenue = data["missingRevenue"];
            this.revenueUpdateDate = data["revenueUpdateDate"];
            this.note1 = data["note1"];
            this.note2 = data["note2"];
            this.note3 = data["note3"];
            this.note4 = data["note4"];
            this.note5 = data["note5"];
            this.salesManCode = data["salesManCode"];
            this.consumerType = data["consumerType"];
            this.referrerCode = data["referrerCode"];
            if (data["communicationChannels"] && data["communicationChannels"].constructor === Array) {
                this.communicationChannels = [];
                for (let item of data["communicationChannels"])
                    this.communicationChannels.push(MemberChannelInfo.fromJS(item));
            }
            this.communicationChannelsString = data["communicationChannelsString"];
            this.chatId = data["chatId"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.metaData = data["metaData"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditConsumerProfileDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditConsumerProfileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberCode"] = this.memberCode;
        data["name"] = this.name;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["gender"] = this.gender;
        data["birthday"] = this.birthday;
        data["registrationDate"] = this.registrationDate;
        data["pid"] = this.pid;
        data["sourceID"] = this.sourceID;
        data["receiveAds"] = this.receiveAds;
        data["rankCode"] = this.rankCode;
        data["rankValidDate"] = this.rankValidDate;
        data["currentPoint"] = this.currentPoint;
        data["nationalityCode"] = this.nationalityCode;
        data["occupationCode"] = this.occupationCode;
        data["hobby"] = this.hobby;
        data["address"] = this.address;
        data["ward"] = this.ward;
        data["district"] = this.district;
        data["province"] = this.province;
        data["country"] = this.country;
        data["status"] = this.status;
        data["lastActivityTime"] = this.lastActivityTime ? this.lastActivityTime.toISOString() : <any>undefined;
        data["lastPurchaseTime"] = this.lastPurchaseTime ? this.lastPurchaseTime.toISOString() : <any>undefined;
        data["communicationLanguage"] = this.communicationLanguage;
        data["notes"] = this.notes;
        data["rankPropose"] = this.rankPropose;
        data["pinCode"] = this.pinCode;
        data["nameUnSign"] = this.nameUnSign;
        data["avatar"] = this.avatar;
        data["workingPermit"] = this.workingPermit;
        data["customerCode"] = this.customerCode;
        data["interestOf"] = this.interestOf;
        data["isInterestCobrand"] = this.isInterestCobrand;
        data["memberCard"] = this.memberCard;
        data["isForeigner"] = this.isForeigner;
        data["isSynced"] = this.isSynced;
        data["referralCode"] = this.referralCode;
        data["accumulationPoint"] = this.accumulationPoint;
        data["outletCode"] = this.outletCode;
        data["zaloName"] = this.zaloName;
        data["distributorCode"] = this.distributorCode;
        data["distributorName"] = this.distributorName;
        data["regionCode"] = this.regionCode;
        data["targetRevenue"] = this.targetRevenue;
        data["actualRevenue"] = this.actualRevenue;
        data["bonus"] = this.bonus;
        data["missingRevenue"] = this.missingRevenue;
        data["revenueUpdateDate"] = this.revenueUpdateDate;
        data["note1"] = this.note1;
        data["note2"] = this.note2;
        data["note3"] = this.note3;
        data["note4"] = this.note4;
        data["note5"] = this.note5;
        data["salesManCode"] = this.salesManCode;
        data["consumerType"] = this.consumerType;
        data["referrerCode"] = this.referrerCode;
        if (this.communicationChannels && this.communicationChannels.constructor === Array) {
            data["communicationChannels"] = [];
            for (let item of this.communicationChannels)
                data["communicationChannels"].push(item.toJSON());
        }
        data["communicationChannelsString"] = this.communicationChannelsString;
        data["chatId"] = this.chatId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["metaData"] = this.metaData;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditConsumerProfileDto {
    memberCode: string | undefined;
    name: string | undefined;
    phone: string | undefined;
    email: string | undefined;
    gender: string | undefined;
    birthday: number | undefined;
    registrationDate: number | undefined;
    pid: string | undefined;
    sourceID: string | undefined;
    receiveAds: boolean | undefined;
    rankCode: string | undefined;
    rankValidDate: number | undefined;
    currentPoint: number | undefined;
    nationalityCode: string | undefined;
    occupationCode: string | undefined;
    hobby: string | undefined;
    address: string | undefined;
    ward: string | undefined;
    district: string | undefined;
    province: string | undefined;
    country: string | undefined;
    status: string | undefined;
    lastActivityTime: moment.Moment | undefined;
    lastPurchaseTime: moment.Moment | undefined;
    communicationLanguage: string | undefined;
    notes: string | undefined;
    rankPropose: string | undefined;
    pinCode: string | undefined;
    nameUnSign: string | undefined;
    avatar: string | undefined;
    workingPermit: boolean | undefined;
    customerCode: string | undefined;
    interestOf: string | undefined;
    isInterestCobrand: boolean | undefined;
    memberCard: string | undefined;
    isForeigner: boolean | undefined;
    isSynced: boolean | undefined;
    referralCode: string | undefined;
    accumulationPoint: number | undefined;
    outletCode: string | undefined;
    zaloName: string | undefined;
    distributorCode: string | undefined;
    distributorName: string | undefined;
    regionCode: string | undefined;
    targetRevenue: number | undefined;
    actualRevenue: number | undefined;
    bonus: number | undefined;
    missingRevenue: number | undefined;
    revenueUpdateDate: number | undefined;
    note1: string | undefined;
    note2: string | undefined;
    note3: string | undefined;
    note4: string | undefined;
    note5: string | undefined;
    salesManCode: string | undefined;
    consumerType: string | undefined;
    referrerCode: string | undefined;
    communicationChannels: MemberChannelInfo[] | undefined;
    communicationChannelsString: string | undefined;
    chatId: string | undefined;
    lastModificationTime: moment.Moment | undefined;
    metaData: string | undefined;
    id: number | undefined;
}

export class GetOutletForEdit implements IGetOutletForEdit {
    consumerProfile!: CreateOrEditConsumerProfileDto | undefined;
    salesmanCode!: string | undefined;
    beatPlanCode!: string | undefined;

    constructor(data?: IGetOutletForEdit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.consumerProfile = data["consumerProfile"] ? CreateOrEditConsumerProfileDto.fromJS(data["consumerProfile"]) : <any>undefined;
            this.salesmanCode = data["salesmanCode"];
            this.beatPlanCode = data["beatPlanCode"];
        }
    }

    static fromJS(data: any): GetOutletForEdit {
        data = typeof data === 'object' ? data : {};
        let result = new GetOutletForEdit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["consumerProfile"] = this.consumerProfile ? this.consumerProfile.toJSON() : <any>undefined;
        data["salesmanCode"] = this.salesmanCode;
        data["beatPlanCode"] = this.beatPlanCode;
        return data;
    }
}

export interface IGetOutletForEdit {
    consumerProfile: CreateOrEditConsumerProfileDto | undefined;
    salesmanCode: string | undefined;
    beatPlanCode: string | undefined;
}

export class GetAllOutletInput implements IGetAllOutletInput {
    filter!: string | undefined;
    statusFilter!: string | undefined;
    sorting!: string | undefined;
    skipCount!: number | undefined;
    maxResultCount!: number | undefined;

    constructor(data?: IGetAllOutletInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.filter = data["filter"];
            this.statusFilter = data["statusFilter"];
            this.sorting = data["sorting"];
            this.skipCount = data["skipCount"];
            this.maxResultCount = data["maxResultCount"];
        }
    }

    static fromJS(data: any): GetAllOutletInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllOutletInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        data["statusFilter"] = this.statusFilter;
        data["sorting"] = this.sorting;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data;
    }
}

export interface IGetAllOutletInput {
    filter: string | undefined;
    statusFilter: string | undefined;
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;
}

export class ConsumerProfileAgrs implements IConsumerProfileAgrs {
    timeZoneOffset!: number | undefined;
    currentDate!: moment.Moment | undefined;
    tableName!: string | undefined;
    filePath!: string | undefined;
    fileName!: string | undefined;
    userId!: number | undefined;
    tenantId!: number | undefined;
    currentLanguage!: string | undefined;
    apiUrl!: string | undefined;

    constructor(data?: IConsumerProfileAgrs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.timeZoneOffset = data["timeZoneOffset"];
            this.currentDate = data["currentDate"] ? moment(data["currentDate"].toString()) : <any>undefined;
            this.tableName = data["tableName"];
            this.filePath = data["filePath"];
            this.fileName = data["fileName"];
            this.userId = data["userId"];
            this.tenantId = data["tenantId"];
            this.currentLanguage = data["currentLanguage"];
            this.apiUrl = data["apiUrl"];
        }
    }

    static fromJS(data: any): ConsumerProfileAgrs {
        data = typeof data === 'object' ? data : {};
        let result = new ConsumerProfileAgrs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timeZoneOffset"] = this.timeZoneOffset;
        data["currentDate"] = this.currentDate ? this.currentDate.toISOString() : <any>undefined;
        data["tableName"] = this.tableName;
        data["filePath"] = this.filePath;
        data["fileName"] = this.fileName;
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["currentLanguage"] = this.currentLanguage;
        data["apiUrl"] = this.apiUrl;
        return data;
    }
}

export interface IConsumerProfileAgrs {
    timeZoneOffset: number | undefined;
    currentDate: moment.Moment | undefined;
    tableName: string | undefined;
    filePath: string | undefined;
    fileName: string | undefined;
    userId: number | undefined;
    tenantId: number | undefined;
    currentLanguage: string | undefined;
    apiUrl: string | undefined;
}

export class GetAllConsumerProfilesInput implements IGetAllConsumerProfilesInput {
    filter!: string | undefined;
    memberCodeFilter!: string | undefined;
    nameFilter!: string | undefined;
    phoneFilter!: string | undefined;
    emailFilter!: string | undefined;
    genderFilter!: string | undefined;
    maxBirthdayFilter!: number | undefined;
    minBirthdayFilter!: number | undefined;
    maxRegistrationDateFilter!: number | undefined;
    minRegistrationDateFilter!: number | undefined;
    pidFilter!: string | undefined;
    sourceIDFilter!: string | undefined;
    receiveAdsFilter!: number | undefined;
    rankCodeFilter!: string | undefined;
    maxRankValidDateFilter!: number | undefined;
    minRankValidDateFilter!: number | undefined;
    maxCurrentPointFilter!: number | undefined;
    minCurrentPointFilter!: number | undefined;
    nationalityCodeFilter!: string | undefined;
    occupationCodeFilter!: string | undefined;
    hobbyFilter!: string | undefined;
    addressFilter!: string | undefined;
    wardFilter!: string | undefined;
    districtFilter!: string | undefined;
    provinceFilter!: string | undefined;
    countryFilter!: string | undefined;
    statusFilter!: string | undefined;
    maxLastActivityTimeFilter!: moment.Moment | undefined;
    minLastActivityTimeFilter!: moment.Moment | undefined;
    maxLastPurchaseTimeFilter!: moment.Moment | undefined;
    minLastPurchaseTimeFilter!: moment.Moment | undefined;
    communicationChannelsFilter!: string | undefined;
    communicationLanguageFilter!: string | undefined;
    notesFilter!: string | undefined;
    rankProposeFilter!: string | undefined;
    pinCodeFilter!: string | undefined;
    nameUnSignFilter!: string | undefined;
    avatarFilter!: string | undefined;
    workingPermitFilter!: number | undefined;
    customerCodeFilter!: string | undefined;
    interestOfFilter!: string | undefined;
    isInterestCobrandFilter!: number | undefined;
    memberCardFilter!: string | undefined;
    isForeignerFilter!: number | undefined;
    isSyncedFilter!: number | undefined;
    referralCodeFilter!: string | undefined;
    maxAccumulationPointFilter!: number | undefined;
    minAccumulationPointFilter!: number | undefined;
    outletCodeFilter!: string | undefined;
    zaloNameFilter!: string | undefined;
    distributorCodeFilter!: string | undefined;
    distributorNameFilter!: string | undefined;
    regionCodeFilter!: string | undefined;
    maxTargetRevenueFilter!: number | undefined;
    minTargetRevenueFilter!: number | undefined;
    maxActualRevenueFilter!: number | undefined;
    minActualRevenueFilter!: number | undefined;
    maxBonusFilter!: number | undefined;
    minBonusFilter!: number | undefined;
    maxMissingRevenueFilter!: number | undefined;
    minMissingRevenueFilter!: number | undefined;
    maxRevenueUpdateDateFilter!: number | undefined;
    minRevenueUpdateDateFilter!: number | undefined;
    note1Filter!: string | undefined;
    note2Filter!: string | undefined;
    note3Filter!: string | undefined;
    note4Filter!: string | undefined;
    note5Filter!: string | undefined;
    metaDataFilter!: string | undefined;
    sorting!: string | undefined;
    skipCount!: number | undefined;
    maxResultCount!: number | undefined;

    constructor(data?: IGetAllConsumerProfilesInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.filter = data["filter"];
            this.memberCodeFilter = data["memberCodeFilter"];
            this.nameFilter = data["nameFilter"];
            this.phoneFilter = data["phoneFilter"];
            this.emailFilter = data["emailFilter"];
            this.genderFilter = data["genderFilter"];
            this.maxBirthdayFilter = data["maxBirthdayFilter"];
            this.minBirthdayFilter = data["minBirthdayFilter"];
            this.maxRegistrationDateFilter = data["maxRegistrationDateFilter"];
            this.minRegistrationDateFilter = data["minRegistrationDateFilter"];
            this.pidFilter = data["pidFilter"];
            this.sourceIDFilter = data["sourceIDFilter"];
            this.receiveAdsFilter = data["receiveAdsFilter"];
            this.rankCodeFilter = data["rankCodeFilter"];
            this.maxRankValidDateFilter = data["maxRankValidDateFilter"];
            this.minRankValidDateFilter = data["minRankValidDateFilter"];
            this.maxCurrentPointFilter = data["maxCurrentPointFilter"];
            this.minCurrentPointFilter = data["minCurrentPointFilter"];
            this.nationalityCodeFilter = data["nationalityCodeFilter"];
            this.occupationCodeFilter = data["occupationCodeFilter"];
            this.hobbyFilter = data["hobbyFilter"];
            this.addressFilter = data["addressFilter"];
            this.wardFilter = data["wardFilter"];
            this.districtFilter = data["districtFilter"];
            this.provinceFilter = data["provinceFilter"];
            this.countryFilter = data["countryFilter"];
            this.statusFilter = data["statusFilter"];
            this.maxLastActivityTimeFilter = data["maxLastActivityTimeFilter"] ? moment(data["maxLastActivityTimeFilter"].toString()) : <any>undefined;
            this.minLastActivityTimeFilter = data["minLastActivityTimeFilter"] ? moment(data["minLastActivityTimeFilter"].toString()) : <any>undefined;
            this.maxLastPurchaseTimeFilter = data["maxLastPurchaseTimeFilter"] ? moment(data["maxLastPurchaseTimeFilter"].toString()) : <any>undefined;
            this.minLastPurchaseTimeFilter = data["minLastPurchaseTimeFilter"] ? moment(data["minLastPurchaseTimeFilter"].toString()) : <any>undefined;
            this.communicationChannelsFilter = data["communicationChannelsFilter"];
            this.communicationLanguageFilter = data["communicationLanguageFilter"];
            this.notesFilter = data["notesFilter"];
            this.rankProposeFilter = data["rankProposeFilter"];
            this.pinCodeFilter = data["pinCodeFilter"];
            this.nameUnSignFilter = data["nameUnSignFilter"];
            this.avatarFilter = data["avatarFilter"];
            this.workingPermitFilter = data["workingPermitFilter"];
            this.customerCodeFilter = data["customerCodeFilter"];
            this.interestOfFilter = data["interestOfFilter"];
            this.isInterestCobrandFilter = data["isInterestCobrandFilter"];
            this.memberCardFilter = data["memberCardFilter"];
            this.isForeignerFilter = data["isForeignerFilter"];
            this.isSyncedFilter = data["isSyncedFilter"];
            this.referralCodeFilter = data["referralCodeFilter"];
            this.maxAccumulationPointFilter = data["maxAccumulationPointFilter"];
            this.minAccumulationPointFilter = data["minAccumulationPointFilter"];
            this.outletCodeFilter = data["outletCodeFilter"];
            this.zaloNameFilter = data["zaloNameFilter"];
            this.distributorCodeFilter = data["distributorCodeFilter"];
            this.distributorNameFilter = data["distributorNameFilter"];
            this.regionCodeFilter = data["regionCodeFilter"];
            this.maxTargetRevenueFilter = data["maxTargetRevenueFilter"];
            this.minTargetRevenueFilter = data["minTargetRevenueFilter"];
            this.maxActualRevenueFilter = data["maxActualRevenueFilter"];
            this.minActualRevenueFilter = data["minActualRevenueFilter"];
            this.maxBonusFilter = data["maxBonusFilter"];
            this.minBonusFilter = data["minBonusFilter"];
            this.maxMissingRevenueFilter = data["maxMissingRevenueFilter"];
            this.minMissingRevenueFilter = data["minMissingRevenueFilter"];
            this.maxRevenueUpdateDateFilter = data["maxRevenueUpdateDateFilter"];
            this.minRevenueUpdateDateFilter = data["minRevenueUpdateDateFilter"];
            this.note1Filter = data["note1Filter"];
            this.note2Filter = data["note2Filter"];
            this.note3Filter = data["note3Filter"];
            this.note4Filter = data["note4Filter"];
            this.note5Filter = data["note5Filter"];
            this.metaDataFilter = data["metaDataFilter"];
            this.sorting = data["sorting"];
            this.skipCount = data["skipCount"];
            this.maxResultCount = data["maxResultCount"];
        }
    }

    static fromJS(data: any): GetAllConsumerProfilesInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllConsumerProfilesInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        data["memberCodeFilter"] = this.memberCodeFilter;
        data["nameFilter"] = this.nameFilter;
        data["phoneFilter"] = this.phoneFilter;
        data["emailFilter"] = this.emailFilter;
        data["genderFilter"] = this.genderFilter;
        data["maxBirthdayFilter"] = this.maxBirthdayFilter;
        data["minBirthdayFilter"] = this.minBirthdayFilter;
        data["maxRegistrationDateFilter"] = this.maxRegistrationDateFilter;
        data["minRegistrationDateFilter"] = this.minRegistrationDateFilter;
        data["pidFilter"] = this.pidFilter;
        data["sourceIDFilter"] = this.sourceIDFilter;
        data["receiveAdsFilter"] = this.receiveAdsFilter;
        data["rankCodeFilter"] = this.rankCodeFilter;
        data["maxRankValidDateFilter"] = this.maxRankValidDateFilter;
        data["minRankValidDateFilter"] = this.minRankValidDateFilter;
        data["maxCurrentPointFilter"] = this.maxCurrentPointFilter;
        data["minCurrentPointFilter"] = this.minCurrentPointFilter;
        data["nationalityCodeFilter"] = this.nationalityCodeFilter;
        data["occupationCodeFilter"] = this.occupationCodeFilter;
        data["hobbyFilter"] = this.hobbyFilter;
        data["addressFilter"] = this.addressFilter;
        data["wardFilter"] = this.wardFilter;
        data["districtFilter"] = this.districtFilter;
        data["provinceFilter"] = this.provinceFilter;
        data["countryFilter"] = this.countryFilter;
        data["statusFilter"] = this.statusFilter;
        data["maxLastActivityTimeFilter"] = this.maxLastActivityTimeFilter ? this.maxLastActivityTimeFilter.toISOString() : <any>undefined;
        data["minLastActivityTimeFilter"] = this.minLastActivityTimeFilter ? this.minLastActivityTimeFilter.toISOString() : <any>undefined;
        data["maxLastPurchaseTimeFilter"] = this.maxLastPurchaseTimeFilter ? this.maxLastPurchaseTimeFilter.toISOString() : <any>undefined;
        data["minLastPurchaseTimeFilter"] = this.minLastPurchaseTimeFilter ? this.minLastPurchaseTimeFilter.toISOString() : <any>undefined;
        data["communicationChannelsFilter"] = this.communicationChannelsFilter;
        data["communicationLanguageFilter"] = this.communicationLanguageFilter;
        data["notesFilter"] = this.notesFilter;
        data["rankProposeFilter"] = this.rankProposeFilter;
        data["pinCodeFilter"] = this.pinCodeFilter;
        data["nameUnSignFilter"] = this.nameUnSignFilter;
        data["avatarFilter"] = this.avatarFilter;
        data["workingPermitFilter"] = this.workingPermitFilter;
        data["customerCodeFilter"] = this.customerCodeFilter;
        data["interestOfFilter"] = this.interestOfFilter;
        data["isInterestCobrandFilter"] = this.isInterestCobrandFilter;
        data["memberCardFilter"] = this.memberCardFilter;
        data["isForeignerFilter"] = this.isForeignerFilter;
        data["isSyncedFilter"] = this.isSyncedFilter;
        data["referralCodeFilter"] = this.referralCodeFilter;
        data["maxAccumulationPointFilter"] = this.maxAccumulationPointFilter;
        data["minAccumulationPointFilter"] = this.minAccumulationPointFilter;
        data["outletCodeFilter"] = this.outletCodeFilter;
        data["zaloNameFilter"] = this.zaloNameFilter;
        data["distributorCodeFilter"] = this.distributorCodeFilter;
        data["distributorNameFilter"] = this.distributorNameFilter;
        data["regionCodeFilter"] = this.regionCodeFilter;
        data["maxTargetRevenueFilter"] = this.maxTargetRevenueFilter;
        data["minTargetRevenueFilter"] = this.minTargetRevenueFilter;
        data["maxActualRevenueFilter"] = this.maxActualRevenueFilter;
        data["minActualRevenueFilter"] = this.minActualRevenueFilter;
        data["maxBonusFilter"] = this.maxBonusFilter;
        data["minBonusFilter"] = this.minBonusFilter;
        data["maxMissingRevenueFilter"] = this.maxMissingRevenueFilter;
        data["minMissingRevenueFilter"] = this.minMissingRevenueFilter;
        data["maxRevenueUpdateDateFilter"] = this.maxRevenueUpdateDateFilter;
        data["minRevenueUpdateDateFilter"] = this.minRevenueUpdateDateFilter;
        data["note1Filter"] = this.note1Filter;
        data["note2Filter"] = this.note2Filter;
        data["note3Filter"] = this.note3Filter;
        data["note4Filter"] = this.note4Filter;
        data["note5Filter"] = this.note5Filter;
        data["metaDataFilter"] = this.metaDataFilter;
        data["sorting"] = this.sorting;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data;
    }
}

export interface IGetAllConsumerProfilesInput {
    filter: string | undefined;
    memberCodeFilter: string | undefined;
    nameFilter: string | undefined;
    phoneFilter: string | undefined;
    emailFilter: string | undefined;
    genderFilter: string | undefined;
    maxBirthdayFilter: number | undefined;
    minBirthdayFilter: number | undefined;
    maxRegistrationDateFilter: number | undefined;
    minRegistrationDateFilter: number | undefined;
    pidFilter: string | undefined;
    sourceIDFilter: string | undefined;
    receiveAdsFilter: number | undefined;
    rankCodeFilter: string | undefined;
    maxRankValidDateFilter: number | undefined;
    minRankValidDateFilter: number | undefined;
    maxCurrentPointFilter: number | undefined;
    minCurrentPointFilter: number | undefined;
    nationalityCodeFilter: string | undefined;
    occupationCodeFilter: string | undefined;
    hobbyFilter: string | undefined;
    addressFilter: string | undefined;
    wardFilter: string | undefined;
    districtFilter: string | undefined;
    provinceFilter: string | undefined;
    countryFilter: string | undefined;
    statusFilter: string | undefined;
    maxLastActivityTimeFilter: moment.Moment | undefined;
    minLastActivityTimeFilter: moment.Moment | undefined;
    maxLastPurchaseTimeFilter: moment.Moment | undefined;
    minLastPurchaseTimeFilter: moment.Moment | undefined;
    communicationChannelsFilter: string | undefined;
    communicationLanguageFilter: string | undefined;
    notesFilter: string | undefined;
    rankProposeFilter: string | undefined;
    pinCodeFilter: string | undefined;
    nameUnSignFilter: string | undefined;
    avatarFilter: string | undefined;
    workingPermitFilter: number | undefined;
    customerCodeFilter: string | undefined;
    interestOfFilter: string | undefined;
    isInterestCobrandFilter: number | undefined;
    memberCardFilter: string | undefined;
    isForeignerFilter: number | undefined;
    isSyncedFilter: number | undefined;
    referralCodeFilter: string | undefined;
    maxAccumulationPointFilter: number | undefined;
    minAccumulationPointFilter: number | undefined;
    outletCodeFilter: string | undefined;
    zaloNameFilter: string | undefined;
    distributorCodeFilter: string | undefined;
    distributorNameFilter: string | undefined;
    regionCodeFilter: string | undefined;
    maxTargetRevenueFilter: number | undefined;
    minTargetRevenueFilter: number | undefined;
    maxActualRevenueFilter: number | undefined;
    minActualRevenueFilter: number | undefined;
    maxBonusFilter: number | undefined;
    minBonusFilter: number | undefined;
    maxMissingRevenueFilter: number | undefined;
    minMissingRevenueFilter: number | undefined;
    maxRevenueUpdateDateFilter: number | undefined;
    minRevenueUpdateDateFilter: number | undefined;
    note1Filter: string | undefined;
    note2Filter: string | undefined;
    note3Filter: string | undefined;
    note4Filter: string | undefined;
    note5Filter: string | undefined;
    metaDataFilter: string | undefined;
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;
}

export class GetPointHistoryRequest implements IGetPointHistoryRequest {
    memberCode!: string | undefined;
    sorting!: string | undefined;
    skipCount!: number | undefined;
    maxResultCount!: number | undefined;

    constructor(data?: IGetPointHistoryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberCode = data["memberCode"];
            this.sorting = data["sorting"];
            this.skipCount = data["skipCount"];
            this.maxResultCount = data["maxResultCount"];
        }
    }

    static fromJS(data: any): GetPointHistoryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetPointHistoryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberCode"] = this.memberCode;
        data["sorting"] = this.sorting;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data;
    }
}

export interface IGetPointHistoryRequest {
    memberCode: string | undefined;
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;
}

export class GetPointHistoryResponse implements IGetPointHistoryResponse {
    currentPoints!: number | undefined;
    expiredDate!: moment.Moment | undefined;
    totalCount!: number | undefined;
    transactions!: PointHistoryTransaction[] | undefined;
    responseStatus!: number | undefined;
    responseMessage!: string | undefined;

    constructor(data?: IGetPointHistoryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.currentPoints = data["currentPoints"];
            this.expiredDate = data["expiredDate"] ? moment(data["expiredDate"].toString()) : <any>undefined;
            this.totalCount = data["totalCount"];
            if (data["transactions"] && data["transactions"].constructor === Array) {
                this.transactions = [];
                for (let item of data["transactions"])
                    this.transactions.push(PointHistoryTransaction.fromJS(item));
            }
            this.responseStatus = data["responseStatus"];
            this.responseMessage = data["responseMessage"];
        }
    }

    static fromJS(data: any): GetPointHistoryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPointHistoryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPoints"] = this.currentPoints;
        data["expiredDate"] = this.expiredDate ? this.expiredDate.toISOString() : <any>undefined;
        data["totalCount"] = this.totalCount;
        if (this.transactions && this.transactions.constructor === Array) {
            data["transactions"] = [];
            for (let item of this.transactions)
                data["transactions"].push(item.toJSON());
        }
        data["responseStatus"] = this.responseStatus;
        data["responseMessage"] = this.responseMessage;
        return data;
    }
}

export interface IGetPointHistoryResponse {
    currentPoints: number | undefined;
    expiredDate: moment.Moment | undefined;
    totalCount: number | undefined;
    transactions: PointHistoryTransaction[] | undefined;
    responseStatus: number | undefined;
    responseMessage: string | undefined;
}

export class PointHistoryTransaction implements IPointHistoryTransaction {
    transactionDateTime!: moment.Moment | undefined;
    terminalNo!: string | undefined;
    rating!: string | undefined;
    purchaseAmount!: number | undefined;
    grantPoint!: number | undefined;
    salesInvoiceCode!: string | undefined;
    transactionType!: string | undefined;
    location!: string | undefined;
    branchNames!: string | undefined;

    constructor(data?: IPointHistoryTransaction) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.transactionDateTime = data["transactionDateTime"] ? moment(data["transactionDateTime"].toString()) : <any>undefined;
            this.terminalNo = data["terminalNo"];
            this.rating = data["rating"];
            this.purchaseAmount = data["purchaseAmount"];
            this.grantPoint = data["grantPoint"];
            this.salesInvoiceCode = data["salesInvoiceCode"];
            this.transactionType = data["transactionType"];
            this.location = data["location"];
            this.branchNames = data["branchNames"];
        }
    }

    static fromJS(data: any): PointHistoryTransaction {
        data = typeof data === 'object' ? data : {};
        let result = new PointHistoryTransaction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionDateTime"] = this.transactionDateTime ? this.transactionDateTime.toISOString() : <any>undefined;
        data["terminalNo"] = this.terminalNo;
        data["rating"] = this.rating;
        data["purchaseAmount"] = this.purchaseAmount;
        data["grantPoint"] = this.grantPoint;
        data["salesInvoiceCode"] = this.salesInvoiceCode;
        data["transactionType"] = this.transactionType;
        data["location"] = this.location;
        data["branchNames"] = this.branchNames;
        return data;
    }
}

export interface IPointHistoryTransaction {
    transactionDateTime: moment.Moment | undefined;
    terminalNo: string | undefined;
    rating: string | undefined;
    purchaseAmount: number | undefined;
    grantPoint: number | undefined;
    salesInvoiceCode: string | undefined;
    transactionType: string | undefined;
    location: string | undefined;
    branchNames: string | undefined;
}

export class MemberInfoValidationDto implements IMemberInfoValidationDto {
    memberCode!: string | undefined;
    memberName!: string | undefined;
    validationStatus!: string | undefined;

    constructor(data?: IMemberInfoValidationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberCode = data["memberCode"];
            this.memberName = data["memberName"];
            this.validationStatus = data["validationStatus"];
        }
    }

    static fromJS(data: any): MemberInfoValidationDto {
        data = typeof data === 'object' ? data : {};
        let result = new MemberInfoValidationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberCode"] = this.memberCode;
        data["memberName"] = this.memberName;
        data["validationStatus"] = this.validationStatus;
        return data;
    }
}

export interface IMemberInfoValidationDto {
    memberCode: string | undefined;
    memberName: string | undefined;
    validationStatus: string | undefined;
}

export class PagedResultDtoOfGetConversationStatusForViewDto implements IPagedResultDtoOfGetConversationStatusForViewDto {
    totalCount!: number | undefined;
    items!: GetConversationStatusForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetConversationStatusForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetConversationStatusForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetConversationStatusForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetConversationStatusForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetConversationStatusForViewDto {
    totalCount: number | undefined;
    items: GetConversationStatusForViewDto[] | undefined;
}

export class GetConversationStatusForViewDto implements IGetConversationStatusForViewDto {
    conversationStatus!: ConversationStatusDto | undefined;

    constructor(data?: IGetConversationStatusForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.conversationStatus = data["conversationStatus"] ? ConversationStatusDto.fromJS(data["conversationStatus"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetConversationStatusForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetConversationStatusForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["conversationStatus"] = this.conversationStatus ? this.conversationStatus.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetConversationStatusForViewDto {
    conversationStatus: ConversationStatusDto | undefined;
}

export class ConversationStatusDto implements IConversationStatusDto {
    retailerCode!: string | undefined;
    userID!: string | undefined;
    id!: number | undefined;

    constructor(data?: IConversationStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.retailerCode = data["retailerCode"];
            this.userID = data["userID"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ConversationStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConversationStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["retailerCode"] = this.retailerCode;
        data["userID"] = this.userID;
        data["id"] = this.id;
        return data;
    }
}

export interface IConversationStatusDto {
    retailerCode: string | undefined;
    userID: string | undefined;
    id: number | undefined;
}

export class GetConversationStatusForEditOutput implements IGetConversationStatusForEditOutput {
    conversationStatus!: CreateOrEditConversationStatusDto | undefined;

    constructor(data?: IGetConversationStatusForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.conversationStatus = data["conversationStatus"] ? CreateOrEditConversationStatusDto.fromJS(data["conversationStatus"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetConversationStatusForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetConversationStatusForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["conversationStatus"] = this.conversationStatus ? this.conversationStatus.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetConversationStatusForEditOutput {
    conversationStatus: CreateOrEditConversationStatusDto | undefined;
}

export class CreateOrEditConversationStatusDto implements ICreateOrEditConversationStatusDto {
    retailerCode!: string | undefined;
    userID!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditConversationStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.retailerCode = data["retailerCode"];
            this.userID = data["userID"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditConversationStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditConversationStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["retailerCode"] = this.retailerCode;
        data["userID"] = this.userID;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditConversationStatusDto {
    retailerCode: string | undefined;
    userID: string | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfGetCusLevelGEOForViewDto implements IPagedResultDtoOfGetCusLevelGEOForViewDto {
    totalCount!: number | undefined;
    items!: GetCusLevelGEOForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetCusLevelGEOForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetCusLevelGEOForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetCusLevelGEOForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetCusLevelGEOForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetCusLevelGEOForViewDto {
    totalCount: number | undefined;
    items: GetCusLevelGEOForViewDto[] | undefined;
}

export class GetCusLevelGEOForViewDto implements IGetCusLevelGEOForViewDto {
    cusLevelGEO!: CusLevelGEODto | undefined;

    constructor(data?: IGetCusLevelGEOForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.cusLevelGEO = data["cusLevelGEO"] ? CusLevelGEODto.fromJS(data["cusLevelGEO"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCusLevelGEOForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCusLevelGEOForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cusLevelGEO"] = this.cusLevelGEO ? this.cusLevelGEO.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetCusLevelGEOForViewDto {
    cusLevelGEO: CusLevelGEODto | undefined;
}

export class CusLevelGEODto implements ICusLevelGEODto {
    slsRegion_Level_8!: string | undefined;
    slsRegion_Level_7!: string | undefined;
    slsRegion_Level_6!: string | undefined;
    slsRegion_Level_5!: string | undefined;
    slsRegion_Level_4!: string | undefined;
    slsRegion_Level_3!: string | undefined;
    slsRegion_Level_2!: string | undefined;
    slsRegion_Level_1!: string | undefined;
    name_Level_8!: string | undefined;
    name_Level_7!: string | undefined;
    name_Level_6!: string | undefined;
    name_Level_5!: string | undefined;
    name_Level_4!: string | undefined;
    name_Level_3!: string | undefined;
    name_Level_2!: string | undefined;
    name_Level_1!: string | undefined;
    cusT_CD!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICusLevelGEODto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.slsRegion_Level_8 = data["slsRegion_Level_8"];
            this.slsRegion_Level_7 = data["slsRegion_Level_7"];
            this.slsRegion_Level_6 = data["slsRegion_Level_6"];
            this.slsRegion_Level_5 = data["slsRegion_Level_5"];
            this.slsRegion_Level_4 = data["slsRegion_Level_4"];
            this.slsRegion_Level_3 = data["slsRegion_Level_3"];
            this.slsRegion_Level_2 = data["slsRegion_Level_2"];
            this.slsRegion_Level_1 = data["slsRegion_Level_1"];
            this.name_Level_8 = data["name_Level_8"];
            this.name_Level_7 = data["name_Level_7"];
            this.name_Level_6 = data["name_Level_6"];
            this.name_Level_5 = data["name_Level_5"];
            this.name_Level_4 = data["name_Level_4"];
            this.name_Level_3 = data["name_Level_3"];
            this.name_Level_2 = data["name_Level_2"];
            this.name_Level_1 = data["name_Level_1"];
            this.cusT_CD = data["cusT_CD"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CusLevelGEODto {
        data = typeof data === 'object' ? data : {};
        let result = new CusLevelGEODto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["slsRegion_Level_8"] = this.slsRegion_Level_8;
        data["slsRegion_Level_7"] = this.slsRegion_Level_7;
        data["slsRegion_Level_6"] = this.slsRegion_Level_6;
        data["slsRegion_Level_5"] = this.slsRegion_Level_5;
        data["slsRegion_Level_4"] = this.slsRegion_Level_4;
        data["slsRegion_Level_3"] = this.slsRegion_Level_3;
        data["slsRegion_Level_2"] = this.slsRegion_Level_2;
        data["slsRegion_Level_1"] = this.slsRegion_Level_1;
        data["name_Level_8"] = this.name_Level_8;
        data["name_Level_7"] = this.name_Level_7;
        data["name_Level_6"] = this.name_Level_6;
        data["name_Level_5"] = this.name_Level_5;
        data["name_Level_4"] = this.name_Level_4;
        data["name_Level_3"] = this.name_Level_3;
        data["name_Level_2"] = this.name_Level_2;
        data["name_Level_1"] = this.name_Level_1;
        data["cusT_CD"] = this.cusT_CD;
        data["id"] = this.id;
        return data;
    }
}

export interface ICusLevelGEODto {
    slsRegion_Level_8: string | undefined;
    slsRegion_Level_7: string | undefined;
    slsRegion_Level_6: string | undefined;
    slsRegion_Level_5: string | undefined;
    slsRegion_Level_4: string | undefined;
    slsRegion_Level_3: string | undefined;
    slsRegion_Level_2: string | undefined;
    slsRegion_Level_1: string | undefined;
    name_Level_8: string | undefined;
    name_Level_7: string | undefined;
    name_Level_6: string | undefined;
    name_Level_5: string | undefined;
    name_Level_4: string | undefined;
    name_Level_3: string | undefined;
    name_Level_2: string | undefined;
    name_Level_1: string | undefined;
    cusT_CD: string | undefined;
    id: number | undefined;
}

export class GetCusLevelGEOForEditOutput implements IGetCusLevelGEOForEditOutput {
    cusLevelGEO!: CreateOrEditCusLevelGEODto | undefined;

    constructor(data?: IGetCusLevelGEOForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.cusLevelGEO = data["cusLevelGEO"] ? CreateOrEditCusLevelGEODto.fromJS(data["cusLevelGEO"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCusLevelGEOForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetCusLevelGEOForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cusLevelGEO"] = this.cusLevelGEO ? this.cusLevelGEO.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetCusLevelGEOForEditOutput {
    cusLevelGEO: CreateOrEditCusLevelGEODto | undefined;
}

export class CreateOrEditCusLevelGEODto implements ICreateOrEditCusLevelGEODto {
    slsRegion_Level_8!: string | undefined;
    slsRegion_Level_7!: string | undefined;
    slsRegion_Level_6!: string | undefined;
    slsRegion_Level_5!: string | undefined;
    slsRegion_Level_4!: string | undefined;
    slsRegion_Level_3!: string | undefined;
    slsRegion_Level_2!: string | undefined;
    slsRegion_Level_1!: string | undefined;
    name_Level_8!: string | undefined;
    name_Level_7!: string | undefined;
    name_Level_6!: string | undefined;
    name_Level_5!: string | undefined;
    name_Level_4!: string | undefined;
    name_Level_3!: string | undefined;
    name_Level_2!: string | undefined;
    name_Level_1!: string | undefined;
    cusT_CD!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditCusLevelGEODto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.slsRegion_Level_8 = data["slsRegion_Level_8"];
            this.slsRegion_Level_7 = data["slsRegion_Level_7"];
            this.slsRegion_Level_6 = data["slsRegion_Level_6"];
            this.slsRegion_Level_5 = data["slsRegion_Level_5"];
            this.slsRegion_Level_4 = data["slsRegion_Level_4"];
            this.slsRegion_Level_3 = data["slsRegion_Level_3"];
            this.slsRegion_Level_2 = data["slsRegion_Level_2"];
            this.slsRegion_Level_1 = data["slsRegion_Level_1"];
            this.name_Level_8 = data["name_Level_8"];
            this.name_Level_7 = data["name_Level_7"];
            this.name_Level_6 = data["name_Level_6"];
            this.name_Level_5 = data["name_Level_5"];
            this.name_Level_4 = data["name_Level_4"];
            this.name_Level_3 = data["name_Level_3"];
            this.name_Level_2 = data["name_Level_2"];
            this.name_Level_1 = data["name_Level_1"];
            this.cusT_CD = data["cusT_CD"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditCusLevelGEODto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditCusLevelGEODto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["slsRegion_Level_8"] = this.slsRegion_Level_8;
        data["slsRegion_Level_7"] = this.slsRegion_Level_7;
        data["slsRegion_Level_6"] = this.slsRegion_Level_6;
        data["slsRegion_Level_5"] = this.slsRegion_Level_5;
        data["slsRegion_Level_4"] = this.slsRegion_Level_4;
        data["slsRegion_Level_3"] = this.slsRegion_Level_3;
        data["slsRegion_Level_2"] = this.slsRegion_Level_2;
        data["slsRegion_Level_1"] = this.slsRegion_Level_1;
        data["name_Level_8"] = this.name_Level_8;
        data["name_Level_7"] = this.name_Level_7;
        data["name_Level_6"] = this.name_Level_6;
        data["name_Level_5"] = this.name_Level_5;
        data["name_Level_4"] = this.name_Level_4;
        data["name_Level_3"] = this.name_Level_3;
        data["name_Level_2"] = this.name_Level_2;
        data["name_Level_1"] = this.name_Level_1;
        data["cusT_CD"] = this.cusT_CD;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditCusLevelGEODto {
    slsRegion_Level_8: string | undefined;
    slsRegion_Level_7: string | undefined;
    slsRegion_Level_6: string | undefined;
    slsRegion_Level_5: string | undefined;
    slsRegion_Level_4: string | undefined;
    slsRegion_Level_3: string | undefined;
    slsRegion_Level_2: string | undefined;
    slsRegion_Level_1: string | undefined;
    name_Level_8: string | undefined;
    name_Level_7: string | undefined;
    name_Level_6: string | undefined;
    name_Level_5: string | undefined;
    name_Level_4: string | undefined;
    name_Level_3: string | undefined;
    name_Level_2: string | undefined;
    name_Level_1: string | undefined;
    cusT_CD: string | undefined;
    id: number | undefined;
}

export class CustomerPerformanceRankDto implements ICustomerPerformanceRankDto {
    rankName!: string | undefined;
    details!: CustomerPerformanceRankDetailDto[] | undefined;

    constructor(data?: ICustomerPerformanceRankDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.rankName = data["rankName"];
            if (data["details"] && data["details"].constructor === Array) {
                this.details = [];
                for (let item of data["details"])
                    this.details.push(CustomerPerformanceRankDetailDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CustomerPerformanceRankDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerPerformanceRankDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rankName"] = this.rankName;
        if (this.details && this.details.constructor === Array) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICustomerPerformanceRankDto {
    rankName: string | undefined;
    details: CustomerPerformanceRankDetailDto[] | undefined;
}

export class CustomerPerformanceRankDetailDto implements ICustomerPerformanceRankDetailDto {
    labelColX!: string | undefined;
    totalMember!: number | undefined;

    constructor(data?: ICustomerPerformanceRankDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.labelColX = data["labelColX"];
            this.totalMember = data["totalMember"];
        }
    }

    static fromJS(data: any): CustomerPerformanceRankDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerPerformanceRankDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["labelColX"] = this.labelColX;
        data["totalMember"] = this.totalMember;
        return data;
    }
}

export interface ICustomerPerformanceRankDetailDto {
    labelColX: string | undefined;
    totalMember: number | undefined;
}

export class CustomerPerformanceStatusDto implements ICustomerPerformanceStatusDto {
    labelColX!: string | undefined;
    memberActive!: number | undefined;
    memberInActive!: number | undefined;

    constructor(data?: ICustomerPerformanceStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.labelColX = data["labelColX"];
            this.memberActive = data["memberActive"];
            this.memberInActive = data["memberInActive"];
        }
    }

    static fromJS(data: any): CustomerPerformanceStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerPerformanceStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["labelColX"] = this.labelColX;
        data["memberActive"] = this.memberActive;
        data["memberInActive"] = this.memberInActive;
        return data;
    }
}

export interface ICustomerPerformanceStatusDto {
    labelColX: string | undefined;
    memberActive: number | undefined;
    memberInActive: number | undefined;
}

export class PagedResultDtoOfGetCustomerForView implements IPagedResultDtoOfGetCustomerForView {
    totalCount!: number | undefined;
    items!: GetCustomerForView[] | undefined;

    constructor(data?: IPagedResultDtoOfGetCustomerForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetCustomerForView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetCustomerForView {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetCustomerForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetCustomerForView {
    totalCount: number | undefined;
    items: GetCustomerForView[] | undefined;
}

export class GetCustomerForView implements IGetCustomerForView {
    customer!: CustomerDto | undefined;

    constructor(data?: IGetCustomerForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.customer = data["customer"] ? CustomerDto.fromJS(data["customer"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCustomerForView {
        data = typeof data === 'object' ? data : {};
        let result = new GetCustomerForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetCustomerForView {
    customer: CustomerDto | undefined;
}

export class CustomerDto implements ICustomerDto {
    code!: string | undefined;
    name!: string | undefined;
    description!: string | undefined;
    isActive!: boolean | undefined;
    id!: number | undefined;

    constructor(data?: ICustomerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.name = data["name"];
            this.description = data["description"];
            this.isActive = data["isActive"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CustomerDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["id"] = this.id;
        return data;
    }
}

export interface ICustomerDto {
    code: string | undefined;
    name: string | undefined;
    description: string | undefined;
    isActive: boolean | undefined;
    id: number | undefined;
}

export class GetCustomerForEditOutput implements IGetCustomerForEditOutput {
    customer!: CreateOrEditCustomerDto | undefined;

    constructor(data?: IGetCustomerForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.customer = data["customer"] ? CreateOrEditCustomerDto.fromJS(data["customer"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCustomerForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetCustomerForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetCustomerForEditOutput {
    customer: CreateOrEditCustomerDto | undefined;
}

export class CreateOrEditCustomerDto implements ICreateOrEditCustomerDto {
    code!: string;
    name!: string;
    description!: string | undefined;
    isActive!: boolean | undefined;
    isDeleted!: boolean | undefined;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: moment.Moment | undefined;
    creatorUserId!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditCustomerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.name = data["name"];
            this.description = data["description"];
            this.isActive = data["isActive"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditCustomerDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditCustomerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditCustomerDto {
    code: string;
    name: string;
    description: string | undefined;
    isActive: boolean | undefined;
    isDeleted: boolean | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class GetListChallengeResponse implements IGetListChallengeResponse {
    challenge!: ChallengeDto[] | undefined;

    constructor(data?: IGetListChallengeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["challenge"] && data["challenge"].constructor === Array) {
                this.challenge = [];
                for (let item of data["challenge"])
                    this.challenge.push(ChallengeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetListChallengeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetListChallengeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.challenge && this.challenge.constructor === Array) {
            data["challenge"] = [];
            for (let item of this.challenge)
                data["challenge"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetListChallengeResponse {
    challenge: ChallengeDto[] | undefined;
}

export class ChallengeDto implements IChallengeDto {
    id!: number | undefined;
    status!: string | undefined;
    code!: string | undefined;
    type!: string | undefined;
    name!: string | undefined;
    effectFrom!: moment.Moment | undefined;
    effectTo!: moment.Moment | undefined;
    description!: string | undefined;
    imageUrl!: string | undefined;
    statusOfMember!: string | undefined;
    challengeNumbers!: NumberOfChallenge[] | undefined;
    isAllowReg!: boolean | undefined;
    isReadyWork!: boolean | undefined;
    isAllowRegister!: boolean | undefined;

    constructor(data?: IChallengeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.status = data["status"];
            this.code = data["code"];
            this.type = data["type"];
            this.name = data["name"];
            this.effectFrom = data["effectFrom"] ? moment(data["effectFrom"].toString()) : <any>undefined;
            this.effectTo = data["effectTo"] ? moment(data["effectTo"].toString()) : <any>undefined;
            this.description = data["description"];
            this.imageUrl = data["imageUrl"];
            this.statusOfMember = data["statusOfMember"];
            if (data["challengeNumbers"] && data["challengeNumbers"].constructor === Array) {
                this.challengeNumbers = [];
                for (let item of data["challengeNumbers"])
                    this.challengeNumbers.push(NumberOfChallenge.fromJS(item));
            }
            this.isAllowReg = data["isAllowReg"];
            this.isReadyWork = data["isReadyWork"];
            this.isAllowRegister = data["isAllowRegister"];
        }
    }

    static fromJS(data: any): ChallengeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChallengeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        data["code"] = this.code;
        data["type"] = this.type;
        data["name"] = this.name;
        data["effectFrom"] = this.effectFrom ? this.effectFrom.toISOString() : <any>undefined;
        data["effectTo"] = this.effectTo ? this.effectTo.toISOString() : <any>undefined;
        data["description"] = this.description;
        data["imageUrl"] = this.imageUrl;
        data["statusOfMember"] = this.statusOfMember;
        if (this.challengeNumbers && this.challengeNumbers.constructor === Array) {
            data["challengeNumbers"] = [];
            for (let item of this.challengeNumbers)
                data["challengeNumbers"].push(item.toJSON());
        }
        data["isAllowReg"] = this.isAllowReg;
        data["isReadyWork"] = this.isReadyWork;
        data["isAllowRegister"] = this.isAllowRegister;
        return data;
    }
}

export interface IChallengeDto {
    id: number | undefined;
    status: string | undefined;
    code: string | undefined;
    type: string | undefined;
    name: string | undefined;
    effectFrom: moment.Moment | undefined;
    effectTo: moment.Moment | undefined;
    description: string | undefined;
    imageUrl: string | undefined;
    statusOfMember: string | undefined;
    challengeNumbers: NumberOfChallenge[] | undefined;
    isAllowReg: boolean | undefined;
    isReadyWork: boolean | undefined;
    isAllowRegister: boolean | undefined;
}

export class NumberOfChallenge implements INumberOfChallenge {
    numberName!: string | undefined;
    imgQuantity!: number | undefined;
    workFromDate!: moment.Moment | undefined;
    workToDate!: moment.Moment | undefined;
    challengeResults!: ChallengeResultDto[] | undefined;

    constructor(data?: INumberOfChallenge) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.numberName = data["numberName"];
            this.imgQuantity = data["imgQuantity"];
            this.workFromDate = data["workFromDate"] ? moment(data["workFromDate"].toString()) : <any>undefined;
            this.workToDate = data["workToDate"] ? moment(data["workToDate"].toString()) : <any>undefined;
            if (data["challengeResults"] && data["challengeResults"].constructor === Array) {
                this.challengeResults = [];
                for (let item of data["challengeResults"])
                    this.challengeResults.push(ChallengeResultDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): NumberOfChallenge {
        data = typeof data === 'object' ? data : {};
        let result = new NumberOfChallenge();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numberName"] = this.numberName;
        data["imgQuantity"] = this.imgQuantity;
        data["workFromDate"] = this.workFromDate ? this.workFromDate.toISOString() : <any>undefined;
        data["workToDate"] = this.workToDate ? this.workToDate.toISOString() : <any>undefined;
        if (this.challengeResults && this.challengeResults.constructor === Array) {
            data["challengeResults"] = [];
            for (let item of this.challengeResults)
                data["challengeResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface INumberOfChallenge {
    numberName: string | undefined;
    imgQuantity: number | undefined;
    workFromDate: moment.Moment | undefined;
    workToDate: moment.Moment | undefined;
    challengeResults: ChallengeResultDto[] | undefined;
}

export class ChallengeResultDto implements IChallengeResultDto {
    challengeResultId!: number | undefined;
    challengePhotoDetailId!: number | undefined;
    challengeName!: string | undefined;
    memberCode!: string | undefined;
    memberName!: string | undefined;
    memberId!: number | undefined;
    challengeId!: number | undefined;
    imageDemoUrl!: string | undefined;
    imageUrl!: string | undefined;
    imageUrls!: string[] | undefined;
    imageName!: string | undefined;
    status!: number | undefined;
    isLibrary!: boolean | undefined;
    creationTime!: moment.Moment | undefined;
    approvedDate!: moment.Moment | undefined;
    approvedTime!: string | undefined;
    approvedBy!: string | undefined;
    rejectDetail!: string | undefined;
    isWork!: boolean | undefined;

    constructor(data?: IChallengeResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.challengeResultId = data["challengeResultId"];
            this.challengePhotoDetailId = data["challengePhotoDetailId"];
            this.challengeName = data["challengeName"];
            this.memberCode = data["memberCode"];
            this.memberName = data["memberName"];
            this.memberId = data["memberId"];
            this.challengeId = data["challengeId"];
            this.imageDemoUrl = data["imageDemoUrl"];
            this.imageUrl = data["imageUrl"];
            if (data["imageUrls"] && data["imageUrls"].constructor === Array) {
                this.imageUrls = [];
                for (let item of data["imageUrls"])
                    this.imageUrls.push(item);
            }
            this.imageName = data["imageName"];
            this.status = data["status"];
            this.isLibrary = data["isLibrary"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.approvedDate = data["approvedDate"] ? moment(data["approvedDate"].toString()) : <any>undefined;
            this.approvedTime = data["approvedTime"];
            this.approvedBy = data["approvedBy"];
            this.rejectDetail = data["rejectDetail"];
            this.isWork = data["isWork"];
        }
    }

    static fromJS(data: any): ChallengeResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChallengeResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["challengeResultId"] = this.challengeResultId;
        data["challengePhotoDetailId"] = this.challengePhotoDetailId;
        data["challengeName"] = this.challengeName;
        data["memberCode"] = this.memberCode;
        data["memberName"] = this.memberName;
        data["memberId"] = this.memberId;
        data["challengeId"] = this.challengeId;
        data["imageDemoUrl"] = this.imageDemoUrl;
        data["imageUrl"] = this.imageUrl;
        if (this.imageUrls && this.imageUrls.constructor === Array) {
            data["imageUrls"] = [];
            for (let item of this.imageUrls)
                data["imageUrls"].push(item);
        }
        data["imageName"] = this.imageName;
        data["status"] = this.status;
        data["isLibrary"] = this.isLibrary;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["approvedDate"] = this.approvedDate ? this.approvedDate.toISOString() : <any>undefined;
        data["approvedTime"] = this.approvedTime;
        data["approvedBy"] = this.approvedBy;
        data["rejectDetail"] = this.rejectDetail;
        data["isWork"] = this.isWork;
        return data;
    }
}

export interface IChallengeResultDto {
    challengeResultId: number | undefined;
    challengePhotoDetailId: number | undefined;
    challengeName: string | undefined;
    memberCode: string | undefined;
    memberName: string | undefined;
    memberId: number | undefined;
    challengeId: number | undefined;
    imageDemoUrl: string | undefined;
    imageUrl: string | undefined;
    imageUrls: string[] | undefined;
    imageName: string | undefined;
    status: number | undefined;
    isLibrary: boolean | undefined;
    creationTime: moment.Moment | undefined;
    approvedDate: moment.Moment | undefined;
    approvedTime: string | undefined;
    approvedBy: string | undefined;
    rejectDetail: string | undefined;
    isWork: boolean | undefined;
}

export class ChallengeResultSubmitInput implements IChallengeResultSubmitInput {
    challengeResults!: ChallengeResultDto[] | undefined;

    constructor(data?: IChallengeResultSubmitInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["challengeResults"] && data["challengeResults"].constructor === Array) {
                this.challengeResults = [];
                for (let item of data["challengeResults"])
                    this.challengeResults.push(ChallengeResultDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ChallengeResultSubmitInput {
        data = typeof data === 'object' ? data : {};
        let result = new ChallengeResultSubmitInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.challengeResults && this.challengeResults.constructor === Array) {
            data["challengeResults"] = [];
            for (let item of this.challengeResults)
                data["challengeResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IChallengeResultSubmitInput {
    challengeResults: ChallengeResultDto[] | undefined;
}

export class SubmitChallengeResponse implements ISubmitChallengeResponse {
    isSuccess!: boolean | undefined;

    constructor(data?: ISubmitChallengeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isSuccess = data["isSuccess"];
        }
    }

    static fromJS(data: any): SubmitChallengeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SubmitChallengeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        return data;
    }
}

export interface ISubmitChallengeResponse {
    isSuccess: boolean | undefined;
}

export class SubmitActionInput implements ISubmitActionInput {
    ids!: number[] | undefined;
    challengePhotoIds!: number[] | undefined;
    type!: number | undefined;
    rejectCode!: string | undefined;
    rejectDetail!: string | undefined;

    constructor(data?: ISubmitActionInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["ids"] && data["ids"].constructor === Array) {
                this.ids = [];
                for (let item of data["ids"])
                    this.ids.push(item);
            }
            if (data["challengePhotoIds"] && data["challengePhotoIds"].constructor === Array) {
                this.challengePhotoIds = [];
                for (let item of data["challengePhotoIds"])
                    this.challengePhotoIds.push(item);
            }
            this.type = data["type"];
            this.rejectCode = data["rejectCode"];
            this.rejectDetail = data["rejectDetail"];
        }
    }

    static fromJS(data: any): SubmitActionInput {
        data = typeof data === 'object' ? data : {};
        let result = new SubmitActionInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.ids && this.ids.constructor === Array) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        if (this.challengePhotoIds && this.challengePhotoIds.constructor === Array) {
            data["challengePhotoIds"] = [];
            for (let item of this.challengePhotoIds)
                data["challengePhotoIds"].push(item);
        }
        data["type"] = this.type;
        data["rejectCode"] = this.rejectCode;
        data["rejectDetail"] = this.rejectDetail;
        return data;
    }
}

export interface ISubmitActionInput {
    ids: number[] | undefined;
    challengePhotoIds: number[] | undefined;
    type: number | undefined;
    rejectCode: string | undefined;
    rejectDetail: string | undefined;
}

export class ChallengeResultImportAgrs implements IChallengeResultImportAgrs {
    challengeResultImportDto!: ChallengeResultImportDto[] | undefined;
    isSuccess!: boolean | undefined;
    errorFilePath!: string | undefined;
    tableName!: string | undefined;
    filePath!: string | undefined;
    fileName!: string | undefined;
    userId!: number | undefined;
    userName!: string | undefined;
    name!: string | undefined;
    tenantId!: number | undefined;
    currentLanguage!: string | undefined;
    apiUrl!: string | undefined;

    constructor(data?: IChallengeResultImportAgrs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["challengeResultImportDto"] && data["challengeResultImportDto"].constructor === Array) {
                this.challengeResultImportDto = [];
                for (let item of data["challengeResultImportDto"])
                    this.challengeResultImportDto.push(ChallengeResultImportDto.fromJS(item));
            }
            this.isSuccess = data["isSuccess"];
            this.errorFilePath = data["errorFilePath"];
            this.tableName = data["tableName"];
            this.filePath = data["filePath"];
            this.fileName = data["fileName"];
            this.userId = data["userId"];
            this.userName = data["userName"];
            this.name = data["name"];
            this.tenantId = data["tenantId"];
            this.currentLanguage = data["currentLanguage"];
            this.apiUrl = data["apiUrl"];
        }
    }

    static fromJS(data: any): ChallengeResultImportAgrs {
        data = typeof data === 'object' ? data : {};
        let result = new ChallengeResultImportAgrs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.challengeResultImportDto && this.challengeResultImportDto.constructor === Array) {
            data["challengeResultImportDto"] = [];
            for (let item of this.challengeResultImportDto)
                data["challengeResultImportDto"].push(item.toJSON());
        }
        data["isSuccess"] = this.isSuccess;
        data["errorFilePath"] = this.errorFilePath;
        data["tableName"] = this.tableName;
        data["filePath"] = this.filePath;
        data["fileName"] = this.fileName;
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["name"] = this.name;
        data["tenantId"] = this.tenantId;
        data["currentLanguage"] = this.currentLanguage;
        data["apiUrl"] = this.apiUrl;
        return data;
    }
}

export interface IChallengeResultImportAgrs {
    challengeResultImportDto: ChallengeResultImportDto[] | undefined;
    isSuccess: boolean | undefined;
    errorFilePath: string | undefined;
    tableName: string | undefined;
    filePath: string | undefined;
    fileName: string | undefined;
    userId: number | undefined;
    userName: string | undefined;
    name: string | undefined;
    tenantId: number | undefined;
    currentLanguage: string | undefined;
    apiUrl: string | undefined;
}

export class ChallengeResultImportDto implements IChallengeResultImportDto {
    tenantId!: number | undefined;
    challengeId!: number | undefined;
    challengePhotoDetailId!: number | undefined;
    status!: number | undefined;
    memberCode!: string | undefined;
    isDeleted!: boolean | undefined;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: moment.Moment | undefined;
    creatorUserId!: number | undefined;
    id!: number | undefined;

    constructor(data?: IChallengeResultImportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.challengeId = data["challengeId"];
            this.challengePhotoDetailId = data["challengePhotoDetailId"];
            this.status = data["status"];
            this.memberCode = data["memberCode"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ChallengeResultImportDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChallengeResultImportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["challengeId"] = this.challengeId;
        data["challengePhotoDetailId"] = this.challengePhotoDetailId;
        data["status"] = this.status;
        data["memberCode"] = this.memberCode;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IChallengeResultImportDto {
    tenantId: number | undefined;
    challengeId: number | undefined;
    challengePhotoDetailId: number | undefined;
    status: number | undefined;
    memberCode: string | undefined;
    isDeleted: boolean | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfGetListChallengeResultResponse implements IPagedResultDtoOfGetListChallengeResultResponse {
    totalCount!: number | undefined;
    items!: GetListChallengeResultResponse[] | undefined;

    constructor(data?: IPagedResultDtoOfGetListChallengeResultResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetListChallengeResultResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetListChallengeResultResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetListChallengeResultResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetListChallengeResultResponse {
    totalCount: number | undefined;
    items: GetListChallengeResultResponse[] | undefined;
}

export class GetListChallengeResultResponse implements IGetListChallengeResultResponse {
    challengeResult!: ChallengeResultDto | undefined;
    number!: number | undefined;
    challengePhotoDetailIds!: number[] | undefined;
    challengeResultIds!: number[] | undefined;
    phone!: string | undefined;
    countImage!: number | undefined;

    constructor(data?: IGetListChallengeResultResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.challengeResult = data["challengeResult"] ? ChallengeResultDto.fromJS(data["challengeResult"]) : <any>undefined;
            this.number = data["number"];
            if (data["challengePhotoDetailIds"] && data["challengePhotoDetailIds"].constructor === Array) {
                this.challengePhotoDetailIds = [];
                for (let item of data["challengePhotoDetailIds"])
                    this.challengePhotoDetailIds.push(item);
            }
            if (data["challengeResultIds"] && data["challengeResultIds"].constructor === Array) {
                this.challengeResultIds = [];
                for (let item of data["challengeResultIds"])
                    this.challengeResultIds.push(item);
            }
            this.phone = data["phone"];
            this.countImage = data["countImage"];
        }
    }

    static fromJS(data: any): GetListChallengeResultResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetListChallengeResultResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["challengeResult"] = this.challengeResult ? this.challengeResult.toJSON() : <any>undefined;
        data["number"] = this.number;
        if (this.challengePhotoDetailIds && this.challengePhotoDetailIds.constructor === Array) {
            data["challengePhotoDetailIds"] = [];
            for (let item of this.challengePhotoDetailIds)
                data["challengePhotoDetailIds"].push(item);
        }
        if (this.challengeResultIds && this.challengeResultIds.constructor === Array) {
            data["challengeResultIds"] = [];
            for (let item of this.challengeResultIds)
                data["challengeResultIds"].push(item);
        }
        data["phone"] = this.phone;
        data["countImage"] = this.countImage;
        return data;
    }
}

export interface IGetListChallengeResultResponse {
    challengeResult: ChallengeResultDto | undefined;
    number: number | undefined;
    challengePhotoDetailIds: number[] | undefined;
    challengeResultIds: number[] | undefined;
    phone: string | undefined;
    countImage: number | undefined;
}

export class PagedResultDtoOfString implements IPagedResultDtoOfString {
    totalCount!: number | undefined;
    items!: string[] | undefined;

    constructor(data?: IPagedResultDtoOfString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(item);
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfString {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item);
        }
        return data;
    }
}

export interface IPagedResultDtoOfString {
    totalCount: number | undefined;
    items: string[] | undefined;
}

export class PagedResultDtoOfGetListChallengeHeaderResponse implements IPagedResultDtoOfGetListChallengeHeaderResponse {
    totalCount!: number | undefined;
    items!: GetListChallengeHeaderResponse[] | undefined;

    constructor(data?: IPagedResultDtoOfGetListChallengeHeaderResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetListChallengeHeaderResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetListChallengeHeaderResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetListChallengeHeaderResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetListChallengeHeaderResponse {
    totalCount: number | undefined;
    items: GetListChallengeHeaderResponse[] | undefined;
}

export class GetListChallengeHeaderResponse implements IGetListChallengeHeaderResponse {
    challenges!: ChallengeHeaderDto | undefined;

    constructor(data?: IGetListChallengeHeaderResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.challenges = data["challenges"] ? ChallengeHeaderDto.fromJS(data["challenges"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetListChallengeHeaderResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetListChallengeHeaderResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["challenges"] = this.challenges ? this.challenges.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetListChallengeHeaderResponse {
    challenges: ChallengeHeaderDto | undefined;
}

export class ChallengeHeaderDto implements IChallengeHeaderDto {
    id!: number | undefined;
    code!: string | undefined;
    type!: string | undefined;
    name!: string | undefined;
    status!: string | undefined;
    effectFrom!: moment.Moment | undefined;
    effectTo!: moment.Moment | undefined;
    seenQty!: number | undefined;
    joinedQty!: number | undefined;

    constructor(data?: IChallengeHeaderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.code = data["code"];
            this.type = data["type"];
            this.name = data["name"];
            this.status = data["status"];
            this.effectFrom = data["effectFrom"] ? moment(data["effectFrom"].toString()) : <any>undefined;
            this.effectTo = data["effectTo"] ? moment(data["effectTo"].toString()) : <any>undefined;
            this.seenQty = data["seenQty"];
            this.joinedQty = data["joinedQty"];
        }
    }

    static fromJS(data: any): ChallengeHeaderDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChallengeHeaderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["type"] = this.type;
        data["name"] = this.name;
        data["status"] = this.status;
        data["effectFrom"] = this.effectFrom ? this.effectFrom.toISOString() : <any>undefined;
        data["effectTo"] = this.effectTo ? this.effectTo.toISOString() : <any>undefined;
        data["seenQty"] = this.seenQty;
        data["joinedQty"] = this.joinedQty;
        return data;
    }
}

export interface IChallengeHeaderDto {
    id: number | undefined;
    code: string | undefined;
    type: string | undefined;
    name: string | undefined;
    status: string | undefined;
    effectFrom: moment.Moment | undefined;
    effectTo: moment.Moment | undefined;
    seenQty: number | undefined;
    joinedQty: number | undefined;
}

export class PagedResultDtoOfChallengeTargetAudienceResponse implements IPagedResultDtoOfChallengeTargetAudienceResponse {
    totalCount!: number | undefined;
    items!: ChallengeTargetAudienceResponse[] | undefined;

    constructor(data?: IPagedResultDtoOfChallengeTargetAudienceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(ChallengeTargetAudienceResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfChallengeTargetAudienceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfChallengeTargetAudienceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfChallengeTargetAudienceResponse {
    totalCount: number | undefined;
    items: ChallengeTargetAudienceResponse[] | undefined;
}

export class ChallengeTargetAudienceResponse implements IChallengeTargetAudienceResponse {
    targetAudienceName!: string | undefined;
    description!: string | undefined;
    status!: string | undefined;
    id!: number | undefined;

    constructor(data?: IChallengeTargetAudienceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.targetAudienceName = data["targetAudienceName"];
            this.description = data["description"];
            this.status = data["status"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ChallengeTargetAudienceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ChallengeTargetAudienceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["targetAudienceName"] = this.targetAudienceName;
        data["description"] = this.description;
        data["status"] = this.status;
        data["id"] = this.id;
        return data;
    }
}

export interface IChallengeTargetAudienceResponse {
    targetAudienceName: string | undefined;
    description: string | undefined;
    status: string | undefined;
    id: number | undefined;
}

export class CreateOrEditChallengeInput implements ICreateOrEditChallengeInput {
    id!: number | undefined;
    code!: string | undefined;
    type!: string | undefined;
    name!: string | undefined;
    status!: string | undefined;
    effectFrom!: moment.Moment | undefined;
    effectTo!: moment.Moment | undefined;
    description!: string | undefined;
    targetAudienceId!: number | undefined;
    targetAudienceType!: string | undefined;
    targetAudienceName!: string | undefined;
    fileImportUrl!: string | undefined;
    fileImportName!: string | undefined;
    registerFromDate!: moment.Moment | undefined;
    registerToDate!: moment.Moment | undefined;
    challengePhotoDetails!: ChallengePhotoDetailDto[] | undefined;

    constructor(data?: ICreateOrEditChallengeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.code = data["code"];
            this.type = data["type"];
            this.name = data["name"];
            this.status = data["status"];
            this.effectFrom = data["effectFrom"] ? moment(data["effectFrom"].toString()) : <any>undefined;
            this.effectTo = data["effectTo"] ? moment(data["effectTo"].toString()) : <any>undefined;
            this.description = data["description"];
            this.targetAudienceId = data["targetAudienceId"];
            this.targetAudienceType = data["targetAudienceType"];
            this.targetAudienceName = data["targetAudienceName"];
            this.fileImportUrl = data["fileImportUrl"];
            this.fileImportName = data["fileImportName"];
            this.registerFromDate = data["registerFromDate"] ? moment(data["registerFromDate"].toString()) : <any>undefined;
            this.registerToDate = data["registerToDate"] ? moment(data["registerToDate"].toString()) : <any>undefined;
            if (data["challengePhotoDetails"] && data["challengePhotoDetails"].constructor === Array) {
                this.challengePhotoDetails = [];
                for (let item of data["challengePhotoDetails"])
                    this.challengePhotoDetails.push(ChallengePhotoDetailDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOrEditChallengeInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditChallengeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["type"] = this.type;
        data["name"] = this.name;
        data["status"] = this.status;
        data["effectFrom"] = this.effectFrom ? this.effectFrom.toISOString() : <any>undefined;
        data["effectTo"] = this.effectTo ? this.effectTo.toISOString() : <any>undefined;
        data["description"] = this.description;
        data["targetAudienceId"] = this.targetAudienceId;
        data["targetAudienceType"] = this.targetAudienceType;
        data["targetAudienceName"] = this.targetAudienceName;
        data["fileImportUrl"] = this.fileImportUrl;
        data["fileImportName"] = this.fileImportName;
        data["registerFromDate"] = this.registerFromDate ? this.registerFromDate.toISOString() : <any>undefined;
        data["registerToDate"] = this.registerToDate ? this.registerToDate.toISOString() : <any>undefined;
        if (this.challengePhotoDetails && this.challengePhotoDetails.constructor === Array) {
            data["challengePhotoDetails"] = [];
            for (let item of this.challengePhotoDetails)
                data["challengePhotoDetails"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateOrEditChallengeInput {
    id: number | undefined;
    code: string | undefined;
    type: string | undefined;
    name: string | undefined;
    status: string | undefined;
    effectFrom: moment.Moment | undefined;
    effectTo: moment.Moment | undefined;
    description: string | undefined;
    targetAudienceId: number | undefined;
    targetAudienceType: string | undefined;
    targetAudienceName: string | undefined;
    fileImportUrl: string | undefined;
    fileImportName: string | undefined;
    registerFromDate: moment.Moment | undefined;
    registerToDate: moment.Moment | undefined;
    challengePhotoDetails: ChallengePhotoDetailDto[] | undefined;
}

export class ChallengePhotoDetailDto implements IChallengePhotoDetailDto {
    id!: number | undefined;
    nameOfPhoto!: string | undefined;
    imageDemo!: string | undefined;
    isLibrary!: boolean | undefined;
    number!: number | undefined;
    workFromDate!: moment.Moment | undefined;
    workToDate!: moment.Moment | undefined;

    constructor(data?: IChallengePhotoDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.nameOfPhoto = data["nameOfPhoto"];
            this.imageDemo = data["imageDemo"];
            this.isLibrary = data["isLibrary"];
            this.number = data["number"];
            this.workFromDate = data["workFromDate"] ? moment(data["workFromDate"].toString()) : <any>undefined;
            this.workToDate = data["workToDate"] ? moment(data["workToDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ChallengePhotoDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChallengePhotoDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["nameOfPhoto"] = this.nameOfPhoto;
        data["imageDemo"] = this.imageDemo;
        data["isLibrary"] = this.isLibrary;
        data["number"] = this.number;
        data["workFromDate"] = this.workFromDate ? this.workFromDate.toISOString() : <any>undefined;
        data["workToDate"] = this.workToDate ? this.workToDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IChallengePhotoDetailDto {
    id: number | undefined;
    nameOfPhoto: string | undefined;
    imageDemo: string | undefined;
    isLibrary: boolean | undefined;
    number: number | undefined;
    workFromDate: moment.Moment | undefined;
    workToDate: moment.Moment | undefined;
}

export class CreateOrEditChallengeResponse implements ICreateOrEditChallengeResponse {
    isSuccess!: boolean | undefined;
    id!: number | undefined;
    code!: string | undefined;
    targetAudienceId!: number | undefined;

    constructor(data?: ICreateOrEditChallengeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isSuccess = data["isSuccess"];
            this.id = data["id"];
            this.code = data["code"];
            this.targetAudienceId = data["targetAudienceId"];
        }
    }

    static fromJS(data: any): CreateOrEditChallengeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditChallengeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["id"] = this.id;
        data["code"] = this.code;
        data["targetAudienceId"] = this.targetAudienceId;
        return data;
    }
}

export interface ICreateOrEditChallengeResponse {
    isSuccess: boolean | undefined;
    id: number | undefined;
    code: string | undefined;
    targetAudienceId: number | undefined;
}

export class GetChallengeHeaderForEditResponse implements IGetChallengeHeaderForEditResponse {
    id!: number | undefined;
    code!: string | undefined;
    type!: string | undefined;
    name!: string | undefined;
    status!: string | undefined;
    description!: string | undefined;
    effectFrom!: moment.Moment | undefined;
    effectTo!: moment.Moment | undefined;
    targetAudienceId!: number | undefined;
    targetAudienceType!: string | undefined;
    targetAudienceName!: string | undefined;
    registerFromDate!: moment.Moment | undefined;
    registerToDate!: moment.Moment | undefined;
    challengePhotoDetails!: ChallengePhotoDetailDto[] | undefined;

    constructor(data?: IGetChallengeHeaderForEditResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.code = data["code"];
            this.type = data["type"];
            this.name = data["name"];
            this.status = data["status"];
            this.description = data["description"];
            this.effectFrom = data["effectFrom"] ? moment(data["effectFrom"].toString()) : <any>undefined;
            this.effectTo = data["effectTo"] ? moment(data["effectTo"].toString()) : <any>undefined;
            this.targetAudienceId = data["targetAudienceId"];
            this.targetAudienceType = data["targetAudienceType"];
            this.targetAudienceName = data["targetAudienceName"];
            this.registerFromDate = data["registerFromDate"] ? moment(data["registerFromDate"].toString()) : <any>undefined;
            this.registerToDate = data["registerToDate"] ? moment(data["registerToDate"].toString()) : <any>undefined;
            if (data["challengePhotoDetails"] && data["challengePhotoDetails"].constructor === Array) {
                this.challengePhotoDetails = [];
                for (let item of data["challengePhotoDetails"])
                    this.challengePhotoDetails.push(ChallengePhotoDetailDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetChallengeHeaderForEditResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetChallengeHeaderForEditResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["type"] = this.type;
        data["name"] = this.name;
        data["status"] = this.status;
        data["description"] = this.description;
        data["effectFrom"] = this.effectFrom ? this.effectFrom.toISOString() : <any>undefined;
        data["effectTo"] = this.effectTo ? this.effectTo.toISOString() : <any>undefined;
        data["targetAudienceId"] = this.targetAudienceId;
        data["targetAudienceType"] = this.targetAudienceType;
        data["targetAudienceName"] = this.targetAudienceName;
        data["registerFromDate"] = this.registerFromDate ? this.registerFromDate.toISOString() : <any>undefined;
        data["registerToDate"] = this.registerToDate ? this.registerToDate.toISOString() : <any>undefined;
        if (this.challengePhotoDetails && this.challengePhotoDetails.constructor === Array) {
            data["challengePhotoDetails"] = [];
            for (let item of this.challengePhotoDetails)
                data["challengePhotoDetails"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetChallengeHeaderForEditResponse {
    id: number | undefined;
    code: string | undefined;
    type: string | undefined;
    name: string | undefined;
    status: string | undefined;
    description: string | undefined;
    effectFrom: moment.Moment | undefined;
    effectTo: moment.Moment | undefined;
    targetAudienceId: number | undefined;
    targetAudienceType: string | undefined;
    targetAudienceName: string | undefined;
    registerFromDate: moment.Moment | undefined;
    registerToDate: moment.Moment | undefined;
    challengePhotoDetails: ChallengePhotoDetailDto[] | undefined;
}

export class PagedResultDtoOfGetListChallengeFollowForEditResponse implements IPagedResultDtoOfGetListChallengeFollowForEditResponse {
    totalCount!: number | undefined;
    items!: GetListChallengeFollowForEditResponse[] | undefined;

    constructor(data?: IPagedResultDtoOfGetListChallengeFollowForEditResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetListChallengeFollowForEditResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetListChallengeFollowForEditResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetListChallengeFollowForEditResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetListChallengeFollowForEditResponse {
    totalCount: number | undefined;
    items: GetListChallengeFollowForEditResponse[] | undefined;
}

export class GetListChallengeFollowForEditResponse implements IGetListChallengeFollowForEditResponse {
    challenges!: ChallengeFollowDto | undefined;

    constructor(data?: IGetListChallengeFollowForEditResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.challenges = data["challenges"] ? ChallengeFollowDto.fromJS(data["challenges"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetListChallengeFollowForEditResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetListChallengeFollowForEditResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["challenges"] = this.challenges ? this.challenges.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetListChallengeFollowForEditResponse {
    challenges: ChallengeFollowDto | undefined;
}

export class ChallengeFollowDto implements IChallengeFollowDto {
    memberCode!: string | undefined;
    challengeId!: number | undefined;
    status!: number | undefined;
    memberName!: string | undefined;
    phone!: string | undefined;
    province!: string | undefined;
    creationTime!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;

    constructor(data?: IChallengeFollowDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberCode = data["memberCode"];
            this.challengeId = data["challengeId"];
            this.status = data["status"];
            this.memberName = data["memberName"];
            this.phone = data["phone"];
            this.province = data["province"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ChallengeFollowDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChallengeFollowDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberCode"] = this.memberCode;
        data["challengeId"] = this.challengeId;
        data["status"] = this.status;
        data["memberName"] = this.memberName;
        data["phone"] = this.phone;
        data["province"] = this.province;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IChallengeFollowDto {
    memberCode: string | undefined;
    challengeId: number | undefined;
    status: number | undefined;
    memberName: string | undefined;
    phone: string | undefined;
    province: string | undefined;
    creationTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
}

export class PagedResultDtoOfGetListChallengeResultForEditResponse implements IPagedResultDtoOfGetListChallengeResultForEditResponse {
    totalCount!: number | undefined;
    items!: GetListChallengeResultForEditResponse[] | undefined;

    constructor(data?: IPagedResultDtoOfGetListChallengeResultForEditResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetListChallengeResultForEditResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetListChallengeResultForEditResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetListChallengeResultForEditResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetListChallengeResultForEditResponse {
    totalCount: number | undefined;
    items: GetListChallengeResultForEditResponse[] | undefined;
}

export class GetListChallengeResultForEditResponse implements IGetListChallengeResultForEditResponse {
    challenges!: ChallengeResultForEditDto | undefined;

    constructor(data?: IGetListChallengeResultForEditResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.challenges = data["challenges"] ? ChallengeResultForEditDto.fromJS(data["challenges"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetListChallengeResultForEditResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetListChallengeResultForEditResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["challenges"] = this.challenges ? this.challenges.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetListChallengeResultForEditResponse {
    challenges: ChallengeResultForEditDto | undefined;
}

export class ChallengeResultForEditDto implements IChallengeResultForEditDto {
    memberCode!: string | undefined;
    challengeId!: number | undefined;
    status!: number | undefined;
    imageName!: string | undefined;
    image!: string | undefined;
    challengePhotoDetailId!: number | undefined;
    isLibrary!: boolean | undefined;
    memberName!: string | undefined;
    phone!: string | undefined;
    province!: string | undefined;
    creationTime!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;

    constructor(data?: IChallengeResultForEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberCode = data["memberCode"];
            this.challengeId = data["challengeId"];
            this.status = data["status"];
            this.imageName = data["imageName"];
            this.image = data["image"];
            this.challengePhotoDetailId = data["challengePhotoDetailId"];
            this.isLibrary = data["isLibrary"];
            this.memberName = data["memberName"];
            this.phone = data["phone"];
            this.province = data["province"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ChallengeResultForEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChallengeResultForEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberCode"] = this.memberCode;
        data["challengeId"] = this.challengeId;
        data["status"] = this.status;
        data["imageName"] = this.imageName;
        data["image"] = this.image;
        data["challengePhotoDetailId"] = this.challengePhotoDetailId;
        data["isLibrary"] = this.isLibrary;
        data["memberName"] = this.memberName;
        data["phone"] = this.phone;
        data["province"] = this.province;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IChallengeResultForEditDto {
    memberCode: string | undefined;
    challengeId: number | undefined;
    status: number | undefined;
    imageName: string | undefined;
    image: string | undefined;
    challengePhotoDetailId: number | undefined;
    isLibrary: boolean | undefined;
    memberName: string | undefined;
    phone: string | undefined;
    province: string | undefined;
    creationTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
}

export class CreateOrEditChallengeFollowInput implements ICreateOrEditChallengeFollowInput {
    id!: number | undefined;
    status!: number | undefined;
    memberCode!: string | undefined;
    challengeId!: number | undefined;

    constructor(data?: ICreateOrEditChallengeFollowInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.status = data["status"];
            this.memberCode = data["memberCode"];
            this.challengeId = data["challengeId"];
        }
    }

    static fromJS(data: any): CreateOrEditChallengeFollowInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditChallengeFollowInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        data["memberCode"] = this.memberCode;
        data["challengeId"] = this.challengeId;
        return data;
    }
}

export interface ICreateOrEditChallengeFollowInput {
    id: number | undefined;
    status: number | undefined;
    memberCode: string | undefined;
    challengeId: number | undefined;
}

export class CreateOrEditChallengeFollowResponse implements ICreateOrEditChallengeFollowResponse {
    isSuccess!: boolean | undefined;
    id!: number | undefined;
    code!: string | undefined;

    constructor(data?: ICreateOrEditChallengeFollowResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isSuccess = data["isSuccess"];
            this.id = data["id"];
            this.code = data["code"];
        }
    }

    static fromJS(data: any): CreateOrEditChallengeFollowResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditChallengeFollowResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["id"] = this.id;
        data["code"] = this.code;
        return data;
    }
}

export interface ICreateOrEditChallengeFollowResponse {
    isSuccess: boolean | undefined;
    id: number | undefined;
    code: string | undefined;
}

export class PagedResultDtoOfGetChannelConfigForViewDto implements IPagedResultDtoOfGetChannelConfigForViewDto {
    totalCount!: number | undefined;
    items!: GetChannelConfigForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetChannelConfigForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetChannelConfigForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetChannelConfigForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetChannelConfigForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetChannelConfigForViewDto {
    totalCount: number | undefined;
    items: GetChannelConfigForViewDto[] | undefined;
}

export class GetChannelConfigForViewDto implements IGetChannelConfigForViewDto {
    channelConfig!: ChannelConfigDto | undefined;
    channelChannelCode!: string | undefined;

    constructor(data?: IGetChannelConfigForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.channelConfig = data["channelConfig"] ? ChannelConfigDto.fromJS(data["channelConfig"]) : <any>undefined;
            this.channelChannelCode = data["channelChannelCode"];
        }
    }

    static fromJS(data: any): GetChannelConfigForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetChannelConfigForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["channelConfig"] = this.channelConfig ? this.channelConfig.toJSON() : <any>undefined;
        data["channelChannelCode"] = this.channelChannelCode;
        return data;
    }
}

export interface IGetChannelConfigForViewDto {
    channelConfig: ChannelConfigDto | undefined;
    channelChannelCode: string | undefined;
}

export class ChannelConfigDto implements IChannelConfigDto {
    channelCode!: string | undefined;
    channelType!: string | undefined;
    channelConfigurations!: string | undefined;
    channelDescription!: string | undefined;
    status!: string | undefined;
    channelId!: number | undefined;
    id!: number | undefined;

    constructor(data?: IChannelConfigDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.channelCode = data["channelCode"];
            this.channelType = data["channelType"];
            this.channelConfigurations = data["channelConfigurations"];
            this.channelDescription = data["channelDescription"];
            this.status = data["status"];
            this.channelId = data["channelId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ChannelConfigDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChannelConfigDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["channelCode"] = this.channelCode;
        data["channelType"] = this.channelType;
        data["channelConfigurations"] = this.channelConfigurations;
        data["channelDescription"] = this.channelDescription;
        data["status"] = this.status;
        data["channelId"] = this.channelId;
        data["id"] = this.id;
        return data;
    }
}

export interface IChannelConfigDto {
    channelCode: string | undefined;
    channelType: string | undefined;
    channelConfigurations: string | undefined;
    channelDescription: string | undefined;
    status: string | undefined;
    channelId: number | undefined;
    id: number | undefined;
}

export class GetChannelConfigForEditOutput implements IGetChannelConfigForEditOutput {
    channelConfig!: CreateOrEditChannelConfigDto | undefined;
    channelChannelCode!: string | undefined;

    constructor(data?: IGetChannelConfigForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.channelConfig = data["channelConfig"] ? CreateOrEditChannelConfigDto.fromJS(data["channelConfig"]) : <any>undefined;
            this.channelChannelCode = data["channelChannelCode"];
        }
    }

    static fromJS(data: any): GetChannelConfigForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetChannelConfigForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["channelConfig"] = this.channelConfig ? this.channelConfig.toJSON() : <any>undefined;
        data["channelChannelCode"] = this.channelChannelCode;
        return data;
    }
}

export interface IGetChannelConfigForEditOutput {
    channelConfig: CreateOrEditChannelConfigDto | undefined;
    channelChannelCode: string | undefined;
}

export class CreateOrEditChannelConfigDto implements ICreateOrEditChannelConfigDto {
    channelCode!: string | undefined;
    channelType!: string | undefined;
    channelConfigurations!: string | undefined;
    channelDescription!: string | undefined;
    status!: string | undefined;
    channelId!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditChannelConfigDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.channelCode = data["channelCode"];
            this.channelType = data["channelType"];
            this.channelConfigurations = data["channelConfigurations"];
            this.channelDescription = data["channelDescription"];
            this.status = data["status"];
            this.channelId = data["channelId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditChannelConfigDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditChannelConfigDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["channelCode"] = this.channelCode;
        data["channelType"] = this.channelType;
        data["channelConfigurations"] = this.channelConfigurations;
        data["channelDescription"] = this.channelDescription;
        data["status"] = this.status;
        data["channelId"] = this.channelId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditChannelConfigDto {
    channelCode: string | undefined;
    channelType: string | undefined;
    channelConfigurations: string | undefined;
    channelDescription: string | undefined;
    status: string | undefined;
    channelId: number | undefined;
    id: number | undefined;
}

export class NotificationFileDto implements INotificationFileDto {
    fileName!: string;
    fileType!: string;
    fileToken!: string;

    constructor(data?: INotificationFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.fileName = data["fileName"];
            this.fileType = data["fileType"];
            this.fileToken = data["fileToken"];
        }
    }

    static fromJS(data: any): NotificationFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["fileType"] = this.fileType;
        data["fileToken"] = this.fileToken;
        return data;
    }
}

export interface INotificationFileDto {
    fileName: string;
    fileType: string;
    fileToken: string;
}

export class PagedResultDtoOfChannelLookupTableDto implements IPagedResultDtoOfChannelLookupTableDto {
    totalCount!: number | undefined;
    items!: ChannelLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfChannelLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(ChannelLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfChannelLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfChannelLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfChannelLookupTableDto {
    totalCount: number | undefined;
    items: ChannelLookupTableDto[] | undefined;
}

export class ChannelLookupTableDto implements IChannelLookupTableDto {
    id!: number | undefined;
    displayName!: string | undefined;
    descriptionChannel!: string | undefined;
    channelType!: string | undefined;

    constructor(data?: IChannelLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
            this.descriptionChannel = data["descriptionChannel"];
            this.channelType = data["channelType"];
        }
    }

    static fromJS(data: any): ChannelLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChannelLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["descriptionChannel"] = this.descriptionChannel;
        data["channelType"] = this.channelType;
        return data;
    }
}

export interface IChannelLookupTableDto {
    id: number | undefined;
    displayName: string | undefined;
    descriptionChannel: string | undefined;
    channelType: string | undefined;
}

export class EntityDto implements IEntityDto {
    id!: number | undefined;

    constructor(data?: IEntityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EntityDto {
        data = typeof data === 'object' ? data : {};
        let result = new EntityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IEntityDto {
    id: number | undefined;
}

export class PagedResultDtoOfGetChannelForViewDto implements IPagedResultDtoOfGetChannelForViewDto {
    totalCount!: number | undefined;
    items!: GetChannelForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetChannelForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetChannelForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetChannelForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetChannelForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetChannelForViewDto {
    totalCount: number | undefined;
    items: GetChannelForViewDto[] | undefined;
}

export class GetChannelForViewDto implements IGetChannelForViewDto {
    channel!: ChannelDto | undefined;

    constructor(data?: IGetChannelForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.channel = data["channel"] ? ChannelDto.fromJS(data["channel"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetChannelForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetChannelForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["channel"] = this.channel ? this.channel.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetChannelForViewDto {
    channel: ChannelDto | undefined;
}

export class ChannelDto implements IChannelDto {
    channelCode!: string | undefined;
    channelDescription!: string | undefined;
    channelType!: string | undefined;
    status!: string | undefined;
    id!: number | undefined;

    constructor(data?: IChannelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.channelCode = data["channelCode"];
            this.channelDescription = data["channelDescription"];
            this.channelType = data["channelType"];
            this.status = data["status"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ChannelDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChannelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["channelCode"] = this.channelCode;
        data["channelDescription"] = this.channelDescription;
        data["channelType"] = this.channelType;
        data["status"] = this.status;
        data["id"] = this.id;
        return data;
    }
}

export interface IChannelDto {
    channelCode: string | undefined;
    channelDescription: string | undefined;
    channelType: string | undefined;
    status: string | undefined;
    id: number | undefined;
}

export class GetChannelForEditOutput implements IGetChannelForEditOutput {
    channel!: CreateOrEditChannelDto | undefined;

    constructor(data?: IGetChannelForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.channel = data["channel"] ? CreateOrEditChannelDto.fromJS(data["channel"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetChannelForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetChannelForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["channel"] = this.channel ? this.channel.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetChannelForEditOutput {
    channel: CreateOrEditChannelDto | undefined;
}

export class CreateOrEditChannelDto implements ICreateOrEditChannelDto {
    channelCode!: string;
    channelDescription!: string | undefined;
    channelType!: string | undefined;
    status!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditChannelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.channelCode = data["channelCode"];
            this.channelDescription = data["channelDescription"];
            this.channelType = data["channelType"];
            this.status = data["status"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditChannelDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditChannelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["channelCode"] = this.channelCode;
        data["channelDescription"] = this.channelDescription;
        data["channelType"] = this.channelType;
        data["status"] = this.status;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditChannelDto {
    channelCode: string;
    channelDescription: string | undefined;
    channelType: string | undefined;
    status: string | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfGetChannelTypeForView implements IPagedResultDtoOfGetChannelTypeForView {
    totalCount!: number | undefined;
    items!: GetChannelTypeForView[] | undefined;

    constructor(data?: IPagedResultDtoOfGetChannelTypeForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetChannelTypeForView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetChannelTypeForView {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetChannelTypeForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetChannelTypeForView {
    totalCount: number | undefined;
    items: GetChannelTypeForView[] | undefined;
}

export class GetChannelTypeForView implements IGetChannelTypeForView {
    channelType!: ChannelTypeDto | undefined;

    constructor(data?: IGetChannelTypeForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.channelType = data["channelType"] ? ChannelTypeDto.fromJS(data["channelType"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetChannelTypeForView {
        data = typeof data === 'object' ? data : {};
        let result = new GetChannelTypeForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["channelType"] = this.channelType ? this.channelType.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetChannelTypeForView {
    channelType: ChannelTypeDto | undefined;
}

export class ChannelTypeDto implements IChannelTypeDto {
    code!: string | undefined;
    name!: string | undefined;
    description!: string | undefined;
    parentCode!: string | undefined;
    isActive!: boolean | undefined;
    level!: number | undefined;
    id!: number | undefined;

    constructor(data?: IChannelTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.name = data["name"];
            this.description = data["description"];
            this.parentCode = data["parentCode"];
            this.isActive = data["isActive"];
            this.level = data["level"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ChannelTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChannelTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["description"] = this.description;
        data["parentCode"] = this.parentCode;
        data["isActive"] = this.isActive;
        data["level"] = this.level;
        data["id"] = this.id;
        return data;
    }
}

export interface IChannelTypeDto {
    code: string | undefined;
    name: string | undefined;
    description: string | undefined;
    parentCode: string | undefined;
    isActive: boolean | undefined;
    level: number | undefined;
    id: number | undefined;
}

export class GetChannelTypeForEditOutput implements IGetChannelTypeForEditOutput {
    channelType!: CreateOrEditChannelTypeDto | undefined;

    constructor(data?: IGetChannelTypeForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.channelType = data["channelType"] ? CreateOrEditChannelTypeDto.fromJS(data["channelType"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetChannelTypeForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetChannelTypeForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["channelType"] = this.channelType ? this.channelType.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetChannelTypeForEditOutput {
    channelType: CreateOrEditChannelTypeDto | undefined;
}

export class CreateOrEditChannelTypeDto implements ICreateOrEditChannelTypeDto {
    code!: string;
    name!: string;
    description!: string | undefined;
    parentCode!: string | undefined;
    isActive!: boolean | undefined;
    level!: number | undefined;
    isDeleted!: boolean | undefined;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: moment.Moment | undefined;
    creatorUserId!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditChannelTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.name = data["name"];
            this.description = data["description"];
            this.parentCode = data["parentCode"];
            this.isActive = data["isActive"];
            this.level = data["level"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditChannelTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditChannelTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["description"] = this.description;
        data["parentCode"] = this.parentCode;
        data["isActive"] = this.isActive;
        data["level"] = this.level;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditChannelTypeDto {
    code: string;
    name: string;
    description: string | undefined;
    parentCode: string | undefined;
    isActive: boolean | undefined;
    level: number | undefined;
    isDeleted: boolean | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class GetUserChatFriendsWithSettingsOutput implements IGetUserChatFriendsWithSettingsOutput {
    serverTime!: moment.Moment | undefined;
    friends!: FriendDto[] | undefined;

    constructor(data?: IGetUserChatFriendsWithSettingsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.serverTime = data["serverTime"] ? moment(data["serverTime"].toString()) : <any>undefined;
            if (data["friends"] && data["friends"].constructor === Array) {
                this.friends = [];
                for (let item of data["friends"])
                    this.friends.push(FriendDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetUserChatFriendsWithSettingsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserChatFriendsWithSettingsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serverTime"] = this.serverTime ? this.serverTime.toISOString() : <any>undefined;
        if (this.friends && this.friends.constructor === Array) {
            data["friends"] = [];
            for (let item of this.friends)
                data["friends"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetUserChatFriendsWithSettingsOutput {
    serverTime: moment.Moment | undefined;
    friends: FriendDto[] | undefined;
}

export class FriendDto implements IFriendDto {
    friendUserId!: number | undefined;
    friendTenantId!: number | undefined;
    friendUserName!: string | undefined;
    friendTenancyName!: string | undefined;
    friendProfilePictureId!: string | undefined;
    unreadMessageCount!: number | undefined;
    isOnline!: boolean | undefined;
    state!: FriendDtoState | undefined;

    constructor(data?: IFriendDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.friendUserId = data["friendUserId"];
            this.friendTenantId = data["friendTenantId"];
            this.friendUserName = data["friendUserName"];
            this.friendTenancyName = data["friendTenancyName"];
            this.friendProfilePictureId = data["friendProfilePictureId"];
            this.unreadMessageCount = data["unreadMessageCount"];
            this.isOnline = data["isOnline"];
            this.state = data["state"];
        }
    }

    static fromJS(data: any): FriendDto {
        data = typeof data === 'object' ? data : {};
        let result = new FriendDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["friendUserId"] = this.friendUserId;
        data["friendTenantId"] = this.friendTenantId;
        data["friendUserName"] = this.friendUserName;
        data["friendTenancyName"] = this.friendTenancyName;
        data["friendProfilePictureId"] = this.friendProfilePictureId;
        data["unreadMessageCount"] = this.unreadMessageCount;
        data["isOnline"] = this.isOnline;
        data["state"] = this.state;
        return data;
    }
}

export interface IFriendDto {
    friendUserId: number | undefined;
    friendTenantId: number | undefined;
    friendUserName: string | undefined;
    friendTenancyName: string | undefined;
    friendProfilePictureId: string | undefined;
    unreadMessageCount: number | undefined;
    isOnline: boolean | undefined;
    state: FriendDtoState | undefined;
}

export class ListResultDtoOfChatMessageDto implements IListResultDtoOfChatMessageDto {
    items!: ChatMessageDto[] | undefined;

    constructor(data?: IListResultDtoOfChatMessageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(ChatMessageDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfChatMessageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfChatMessageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListResultDtoOfChatMessageDto {
    items: ChatMessageDto[] | undefined;
}

export class ChatMessageDto implements IChatMessageDto {
    userId!: number | undefined;
    tenantId!: number | undefined;
    targetUserId!: number | undefined;
    targetTenantId!: number | undefined;
    side!: ChatMessageDtoSide | undefined;
    readState!: ChatMessageDtoReadState | undefined;
    receiverReadState!: ChatMessageDtoReceiverReadState | undefined;
    message!: string | undefined;
    creationTime!: moment.Moment | undefined;
    sharedMessageId!: string | undefined;
    id!: number | undefined;

    constructor(data?: IChatMessageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userId = data["userId"];
            this.tenantId = data["tenantId"];
            this.targetUserId = data["targetUserId"];
            this.targetTenantId = data["targetTenantId"];
            this.side = data["side"];
            this.readState = data["readState"];
            this.receiverReadState = data["receiverReadState"];
            this.message = data["message"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.sharedMessageId = data["sharedMessageId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ChatMessageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChatMessageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["targetUserId"] = this.targetUserId;
        data["targetTenantId"] = this.targetTenantId;
        data["side"] = this.side;
        data["readState"] = this.readState;
        data["receiverReadState"] = this.receiverReadState;
        data["message"] = this.message;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["sharedMessageId"] = this.sharedMessageId;
        data["id"] = this.id;
        return data;
    }
}

export interface IChatMessageDto {
    userId: number | undefined;
    tenantId: number | undefined;
    targetUserId: number | undefined;
    targetTenantId: number | undefined;
    side: ChatMessageDtoSide | undefined;
    readState: ChatMessageDtoReadState | undefined;
    receiverReadState: ChatMessageDtoReceiverReadState | undefined;
    message: string | undefined;
    creationTime: moment.Moment | undefined;
    sharedMessageId: string | undefined;
    id: number | undefined;
}

export class MarkAllUnreadMessagesOfUserAsReadInput implements IMarkAllUnreadMessagesOfUserAsReadInput {
    tenantId!: number | undefined;
    userId!: number | undefined;

    constructor(data?: IMarkAllUnreadMessagesOfUserAsReadInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.userId = data["userId"];
        }
    }

    static fromJS(data: any): MarkAllUnreadMessagesOfUserAsReadInput {
        data = typeof data === 'object' ? data : {};
        let result = new MarkAllUnreadMessagesOfUserAsReadInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        return data;
    }
}

export interface IMarkAllUnreadMessagesOfUserAsReadInput {
    tenantId: number | undefined;
    userId: number | undefined;
}

export class DashboardDto implements IDashboardDto {
    userID!: number | undefined;
    userName!: string | undefined;
    email!: string | undefined;
    needToVist!: number | undefined;
    totalOrder!: number | undefined;
    totalStore!: number | undefined;
    totalVisitInMonth!: number | undefined;
    totalKM!: number | undefined;
    newNotify!: number | undefined;
    bestSaller!: BestSallerDto | undefined;
    totalQuantity!: TotalQuantityDto | undefined;
    coverLevel!: CoverLevelDto[] | undefined;
    moreInfomation!: MoreInfomationDto[] | undefined;
    id!: number | undefined;

    constructor(data?: IDashboardDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userID = data["userID"];
            this.userName = data["userName"];
            this.email = data["email"];
            this.needToVist = data["needToVist"];
            this.totalOrder = data["totalOrder"];
            this.totalStore = data["totalStore"];
            this.totalVisitInMonth = data["totalVisitInMonth"];
            this.totalKM = data["totalKM"];
            this.newNotify = data["newNotify"];
            this.bestSaller = data["bestSaller"] ? BestSallerDto.fromJS(data["bestSaller"]) : <any>undefined;
            this.totalQuantity = data["totalQuantity"] ? TotalQuantityDto.fromJS(data["totalQuantity"]) : <any>undefined;
            if (data["coverLevel"] && data["coverLevel"].constructor === Array) {
                this.coverLevel = [];
                for (let item of data["coverLevel"])
                    this.coverLevel.push(CoverLevelDto.fromJS(item));
            }
            if (data["moreInfomation"] && data["moreInfomation"].constructor === Array) {
                this.moreInfomation = [];
                for (let item of data["moreInfomation"])
                    this.moreInfomation.push(MoreInfomationDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): DashboardDto {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userID"] = this.userID;
        data["userName"] = this.userName;
        data["email"] = this.email;
        data["needToVist"] = this.needToVist;
        data["totalOrder"] = this.totalOrder;
        data["totalStore"] = this.totalStore;
        data["totalVisitInMonth"] = this.totalVisitInMonth;
        data["totalKM"] = this.totalKM;
        data["newNotify"] = this.newNotify;
        data["bestSaller"] = this.bestSaller ? this.bestSaller.toJSON() : <any>undefined;
        data["totalQuantity"] = this.totalQuantity ? this.totalQuantity.toJSON() : <any>undefined;
        if (this.coverLevel && this.coverLevel.constructor === Array) {
            data["coverLevel"] = [];
            for (let item of this.coverLevel)
                data["coverLevel"].push(item.toJSON());
        }
        if (this.moreInfomation && this.moreInfomation.constructor === Array) {
            data["moreInfomation"] = [];
            for (let item of this.moreInfomation)
                data["moreInfomation"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IDashboardDto {
    userID: number | undefined;
    userName: string | undefined;
    email: string | undefined;
    needToVist: number | undefined;
    totalOrder: number | undefined;
    totalStore: number | undefined;
    totalVisitInMonth: number | undefined;
    totalKM: number | undefined;
    newNotify: number | undefined;
    bestSaller: BestSallerDto | undefined;
    totalQuantity: TotalQuantityDto | undefined;
    coverLevel: CoverLevelDto[] | undefined;
    moreInfomation: MoreInfomationDto[] | undefined;
    id: number | undefined;
}

export class BestSallerDto implements IBestSallerDto {
    category!: string[] | undefined;
    saleIn!: string[] | undefined;
    saleOut!: string[] | undefined;

    constructor(data?: IBestSallerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["category"] && data["category"].constructor === Array) {
                this.category = [];
                for (let item of data["category"])
                    this.category.push(item);
            }
            if (data["saleIn"] && data["saleIn"].constructor === Array) {
                this.saleIn = [];
                for (let item of data["saleIn"])
                    this.saleIn.push(item);
            }
            if (data["saleOut"] && data["saleOut"].constructor === Array) {
                this.saleOut = [];
                for (let item of data["saleOut"])
                    this.saleOut.push(item);
            }
        }
    }

    static fromJS(data: any): BestSallerDto {
        data = typeof data === 'object' ? data : {};
        let result = new BestSallerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.category && this.category.constructor === Array) {
            data["category"] = [];
            for (let item of this.category)
                data["category"].push(item);
        }
        if (this.saleIn && this.saleIn.constructor === Array) {
            data["saleIn"] = [];
            for (let item of this.saleIn)
                data["saleIn"].push(item);
        }
        if (this.saleOut && this.saleOut.constructor === Array) {
            data["saleOut"] = [];
            for (let item of this.saleOut)
                data["saleOut"].push(item);
        }
        return data;
    }
}

export interface IBestSallerDto {
    category: string[] | undefined;
    saleIn: string[] | undefined;
    saleOut: string[] | undefined;
}

export class TotalQuantityDto implements ITotalQuantityDto {
    saleIn!: string | undefined;
    saleOut!: string | undefined;

    constructor(data?: ITotalQuantityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.saleIn = data["saleIn"];
            this.saleOut = data["saleOut"];
        }
    }

    static fromJS(data: any): TotalQuantityDto {
        data = typeof data === 'object' ? data : {};
        let result = new TotalQuantityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["saleIn"] = this.saleIn;
        data["saleOut"] = this.saleOut;
        return data;
    }
}

export interface ITotalQuantityDto {
    saleIn: string | undefined;
    saleOut: string | undefined;
}

export class CoverLevelDto implements ICoverLevelDto {
    category!: string | undefined;
    level!: string | undefined;
    quantity!: number | undefined;

    constructor(data?: ICoverLevelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.category = data["category"];
            this.level = data["level"];
            this.quantity = data["quantity"];
        }
    }

    static fromJS(data: any): CoverLevelDto {
        data = typeof data === 'object' ? data : {};
        let result = new CoverLevelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["category"] = this.category;
        data["level"] = this.level;
        data["quantity"] = this.quantity;
        return data;
    }
}

export interface ICoverLevelDto {
    category: string | undefined;
    level: string | undefined;
    quantity: number | undefined;
}

export class MoreInfomationDto implements IMoreInfomationDto {
    topicId!: number | undefined;
    imageUrl!: string | undefined;
    title!: string | undefined;

    constructor(data?: IMoreInfomationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.topicId = data["topicId"];
            this.imageUrl = data["imageUrl"];
            this.title = data["title"];
        }
    }

    static fromJS(data: any): MoreInfomationDto {
        data = typeof data === 'object' ? data : {};
        let result = new MoreInfomationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["topicId"] = this.topicId;
        data["imageUrl"] = this.imageUrl;
        data["title"] = this.title;
        return data;
    }
}

export interface IMoreInfomationDto {
    topicId: number | undefined;
    imageUrl: string | undefined;
    title: string | undefined;
}

export class DashboardManagerDto implements IDashboardManagerDto {
    needToVist!: number | undefined;
    totalOrder!: number | undefined;
    totalStore!: number | undefined;
    newNotify!: number | undefined;
    chartTrend!: DashboardChartTrendDto | undefined;
    chartVisit!: DashboardChartPieDto[] | undefined;
    chartSellIn!: DashboardChartPieDto[] | undefined;
    chartSellOut!: DashboardChartPieDto[] | undefined;

    constructor(data?: IDashboardManagerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.needToVist = data["needToVist"];
            this.totalOrder = data["totalOrder"];
            this.totalStore = data["totalStore"];
            this.newNotify = data["newNotify"];
            this.chartTrend = data["chartTrend"] ? DashboardChartTrendDto.fromJS(data["chartTrend"]) : <any>undefined;
            if (data["chartVisit"] && data["chartVisit"].constructor === Array) {
                this.chartVisit = [];
                for (let item of data["chartVisit"])
                    this.chartVisit.push(DashboardChartPieDto.fromJS(item));
            }
            if (data["chartSellIn"] && data["chartSellIn"].constructor === Array) {
                this.chartSellIn = [];
                for (let item of data["chartSellIn"])
                    this.chartSellIn.push(DashboardChartPieDto.fromJS(item));
            }
            if (data["chartSellOut"] && data["chartSellOut"].constructor === Array) {
                this.chartSellOut = [];
                for (let item of data["chartSellOut"])
                    this.chartSellOut.push(DashboardChartPieDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DashboardManagerDto {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardManagerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["needToVist"] = this.needToVist;
        data["totalOrder"] = this.totalOrder;
        data["totalStore"] = this.totalStore;
        data["newNotify"] = this.newNotify;
        data["chartTrend"] = this.chartTrend ? this.chartTrend.toJSON() : <any>undefined;
        if (this.chartVisit && this.chartVisit.constructor === Array) {
            data["chartVisit"] = [];
            for (let item of this.chartVisit)
                data["chartVisit"].push(item.toJSON());
        }
        if (this.chartSellIn && this.chartSellIn.constructor === Array) {
            data["chartSellIn"] = [];
            for (let item of this.chartSellIn)
                data["chartSellIn"].push(item.toJSON());
        }
        if (this.chartSellOut && this.chartSellOut.constructor === Array) {
            data["chartSellOut"] = [];
            for (let item of this.chartSellOut)
                data["chartSellOut"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDashboardManagerDto {
    needToVist: number | undefined;
    totalOrder: number | undefined;
    totalStore: number | undefined;
    newNotify: number | undefined;
    chartTrend: DashboardChartTrendDto | undefined;
    chartVisit: DashboardChartPieDto[] | undefined;
    chartSellIn: DashboardChartPieDto[] | undefined;
    chartSellOut: DashboardChartPieDto[] | undefined;
}

export class DashboardChartTrendDto implements IDashboardChartTrendDto {
    name!: DashboardListSaleNameDto | undefined;
    sellIn!: DashboardListSaleDto[] | undefined;
    sellOut!: DashboardListSaleDto[] | undefined;

    constructor(data?: IDashboardChartTrendDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"] ? DashboardListSaleNameDto.fromJS(data["name"]) : <any>undefined;
            if (data["sellIn"] && data["sellIn"].constructor === Array) {
                this.sellIn = [];
                for (let item of data["sellIn"])
                    this.sellIn.push(DashboardListSaleDto.fromJS(item));
            }
            if (data["sellOut"] && data["sellOut"].constructor === Array) {
                this.sellOut = [];
                for (let item of data["sellOut"])
                    this.sellOut.push(DashboardListSaleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DashboardChartTrendDto {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardChartTrendDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name ? this.name.toJSON() : <any>undefined;
        if (this.sellIn && this.sellIn.constructor === Array) {
            data["sellIn"] = [];
            for (let item of this.sellIn)
                data["sellIn"].push(item.toJSON());
        }
        if (this.sellOut && this.sellOut.constructor === Array) {
            data["sellOut"] = [];
            for (let item of this.sellOut)
                data["sellOut"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDashboardChartTrendDto {
    name: DashboardListSaleNameDto | undefined;
    sellIn: DashboardListSaleDto[] | undefined;
    sellOut: DashboardListSaleDto[] | undefined;
}

export class DashboardChartPieDto implements IDashboardChartPieDto {
    name!: string | undefined;
    quantity!: number | undefined;
    color!: string | undefined;

    constructor(data?: IDashboardChartPieDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.quantity = data["quantity"];
            this.color = data["color"];
        }
    }

    static fromJS(data: any): DashboardChartPieDto {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardChartPieDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["quantity"] = this.quantity;
        data["color"] = this.color;
        return data;
    }
}

export interface IDashboardChartPieDto {
    name: string | undefined;
    quantity: number | undefined;
    color: string | undefined;
}

export class DashboardListSaleNameDto implements IDashboardListSaleNameDto {
    sellInType!: string | undefined;
    sellOutType!: string | undefined;
    colorSellInType!: string | undefined;
    colorSellOutType!: string | undefined;

    constructor(data?: IDashboardListSaleNameDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.sellInType = data["sellInType"];
            this.sellOutType = data["sellOutType"];
            this.colorSellInType = data["colorSellInType"];
            this.colorSellOutType = data["colorSellOutType"];
        }
    }

    static fromJS(data: any): DashboardListSaleNameDto {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardListSaleNameDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sellInType"] = this.sellInType;
        data["sellOutType"] = this.sellOutType;
        data["colorSellInType"] = this.colorSellInType;
        data["colorSellOutType"] = this.colorSellOutType;
        return data;
    }
}

export interface IDashboardListSaleNameDto {
    sellInType: string | undefined;
    sellOutType: string | undefined;
    colorSellInType: string | undefined;
    colorSellOutType: string | undefined;
}

export class DashboardListSaleDto implements IDashboardListSaleDto {
    date!: number | undefined;
    quantity!: number | undefined;

    constructor(data?: IDashboardListSaleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.date = data["date"];
            this.quantity = data["quantity"];
        }
    }

    static fromJS(data: any): DashboardListSaleDto {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardListSaleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date;
        data["quantity"] = this.quantity;
        return data;
    }
}

export interface IDashboardListSaleDto {
    date: number | undefined;
    quantity: number | undefined;
}

export class GetAllBrandReponse implements IGetAllBrandReponse {
    listItem!: BrandItemOutput[] | undefined;

    constructor(data?: IGetAllBrandReponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["listItem"] && data["listItem"].constructor === Array) {
                this.listItem = [];
                for (let item of data["listItem"])
                    this.listItem.push(BrandItemOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAllBrandReponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllBrandReponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.listItem && this.listItem.constructor === Array) {
            data["listItem"] = [];
            for (let item of this.listItem)
                data["listItem"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetAllBrandReponse {
    listItem: BrandItemOutput[] | undefined;
}

export class BrandItemOutput implements IBrandItemOutput {
    brandCode!: string | undefined;
    brandName!: string | undefined;

    constructor(data?: IBrandItemOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.brandCode = data["brandCode"];
            this.brandName = data["brandName"];
        }
    }

    static fromJS(data: any): BrandItemOutput {
        data = typeof data === 'object' ? data : {};
        let result = new BrandItemOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["brandCode"] = this.brandCode;
        data["brandName"] = this.brandName;
        return data;
    }
}

export interface IBrandItemOutput {
    brandCode: string | undefined;
    brandName: string | undefined;
}

export class GetPointEarningHistoryReponse implements IGetPointEarningHistoryReponse {
    listItem!: PointEarningHistoryOutput[] | undefined;
    lastModification!: moment.Moment | undefined;

    constructor(data?: IGetPointEarningHistoryReponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["listItem"] && data["listItem"].constructor === Array) {
                this.listItem = [];
                for (let item of data["listItem"])
                    this.listItem.push(PointEarningHistoryOutput.fromJS(item));
            }
            this.lastModification = data["lastModification"] ? moment(data["lastModification"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetPointEarningHistoryReponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPointEarningHistoryReponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.listItem && this.listItem.constructor === Array) {
            data["listItem"] = [];
            for (let item of this.listItem)
                data["listItem"].push(item.toJSON());
        }
        data["lastModification"] = this.lastModification ? this.lastModification.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGetPointEarningHistoryReponse {
    listItem: PointEarningHistoryOutput[] | undefined;
    lastModification: moment.Moment | undefined;
}

export class PointEarningHistoryOutput implements IPointEarningHistoryOutput {
    month!: number | undefined;
    year!: number | undefined;
    coin!: number | undefined;
    lastModificationTime!: moment.Moment | undefined;

    constructor(data?: IPointEarningHistoryOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.month = data["month"];
            this.year = data["year"];
            this.coin = data["coin"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PointEarningHistoryOutput {
        data = typeof data === 'object' ? data : {};
        let result = new PointEarningHistoryOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["month"] = this.month;
        data["year"] = this.year;
        data["coin"] = this.coin;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IPointEarningHistoryOutput {
    month: number | undefined;
    year: number | undefined;
    coin: number | undefined;
    lastModificationTime: moment.Moment | undefined;
}

export class GetSalesByBrandOutput implements IGetSalesByBrandOutput {
    listItem!: SaleByBrandItemOutput[] | undefined;
    maxLastModificationTime!: moment.Moment | undefined;

    constructor(data?: IGetSalesByBrandOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["listItem"] && data["listItem"].constructor === Array) {
                this.listItem = [];
                for (let item of data["listItem"])
                    this.listItem.push(SaleByBrandItemOutput.fromJS(item));
            }
            this.maxLastModificationTime = data["maxLastModificationTime"] ? moment(data["maxLastModificationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSalesByBrandOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetSalesByBrandOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.listItem && this.listItem.constructor === Array) {
            data["listItem"] = [];
            for (let item of this.listItem)
                data["listItem"].push(item.toJSON());
        }
        data["maxLastModificationTime"] = this.maxLastModificationTime ? this.maxLastModificationTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGetSalesByBrandOutput {
    listItem: SaleByBrandItemOutput[] | undefined;
    maxLastModificationTime: moment.Moment | undefined;
}

export class SaleByBrandItemOutput implements ISaleByBrandItemOutput {
    lastModificationTime!: moment.Moment | undefined;
    salesAmount!: number | undefined;
    month!: number | undefined;
    year!: number | undefined;

    constructor(data?: ISaleByBrandItemOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.salesAmount = data["salesAmount"];
            this.month = data["month"];
            this.year = data["year"];
        }
    }

    static fromJS(data: any): SaleByBrandItemOutput {
        data = typeof data === 'object' ? data : {};
        let result = new SaleByBrandItemOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["salesAmount"] = this.salesAmount;
        data["month"] = this.month;
        data["year"] = this.year;
        return data;
    }
}

export interface ISaleByBrandItemOutput {
    lastModificationTime: moment.Moment | undefined;
    salesAmount: number | undefined;
    month: number | undefined;
    year: number | undefined;
}

export class GetSaleObjectOutput implements IGetSaleObjectOutput {
    coin!: number | undefined;
    lastModificationTime!: moment.Moment | undefined;
    salesAmount!: number | undefined;
    targetValue!: number | undefined;
    underTarget!: number | undefined;
    underTargetDisplay!: number | undefined;
    remainDay!: number | undefined;
    remainDayDisplay!: number | undefined;

    constructor(data?: IGetSaleObjectOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.coin = data["coin"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.salesAmount = data["salesAmount"];
            this.targetValue = data["targetValue"];
            this.underTarget = data["underTarget"];
            this.underTargetDisplay = data["underTargetDisplay"];
            this.remainDay = data["remainDay"];
            this.remainDayDisplay = data["remainDayDisplay"];
        }
    }

    static fromJS(data: any): GetSaleObjectOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetSaleObjectOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["coin"] = this.coin;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["salesAmount"] = this.salesAmount;
        data["targetValue"] = this.targetValue;
        data["underTarget"] = this.underTarget;
        data["underTargetDisplay"] = this.underTargetDisplay;
        data["remainDay"] = this.remainDay;
        data["remainDayDisplay"] = this.remainDayDisplay;
        return data;
    }
}

export interface IGetSaleObjectOutput {
    coin: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    salesAmount: number | undefined;
    targetValue: number | undefined;
    underTarget: number | undefined;
    underTargetDisplay: number | undefined;
    remainDay: number | undefined;
    remainDayDisplay: number | undefined;
}

export class GetPSKUProgramReponse implements IGetPSKUProgramReponse {
    programCode!: string | undefined;
    programName!: string | undefined;
    description!: string | undefined;
    startDate!: moment.Moment | undefined;
    endDate!: moment.Moment | undefined;
    coinRatio!: number | undefined;
    status!: string | undefined;
    product!: GetPSKUProgramOutputItem[] | undefined;

    constructor(data?: IGetPSKUProgramReponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.programCode = data["programCode"];
            this.programName = data["programName"];
            this.description = data["description"];
            this.startDate = data["startDate"] ? moment(data["startDate"].toString()) : <any>undefined;
            this.endDate = data["endDate"] ? moment(data["endDate"].toString()) : <any>undefined;
            this.coinRatio = data["coinRatio"];
            this.status = data["status"];
            if (data["product"] && data["product"].constructor === Array) {
                this.product = [];
                for (let item of data["product"])
                    this.product.push(GetPSKUProgramOutputItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetPSKUProgramReponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPSKUProgramReponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["programCode"] = this.programCode;
        data["programName"] = this.programName;
        data["description"] = this.description;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["coinRatio"] = this.coinRatio;
        data["status"] = this.status;
        if (this.product && this.product.constructor === Array) {
            data["product"] = [];
            for (let item of this.product)
                data["product"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetPSKUProgramReponse {
    programCode: string | undefined;
    programName: string | undefined;
    description: string | undefined;
    startDate: moment.Moment | undefined;
    endDate: moment.Moment | undefined;
    coinRatio: number | undefined;
    status: string | undefined;
    product: GetPSKUProgramOutputItem[] | undefined;
}

export class GetPSKUProgramOutputItem implements IGetPSKUProgramOutputItem {
    productCode!: string | undefined;
    productName!: string | undefined;
    target!: number | undefined;
    actual!: number | undefined;

    constructor(data?: IGetPSKUProgramOutputItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.productCode = data["productCode"];
            this.productName = data["productName"];
            this.target = data["target"];
            this.actual = data["actual"];
        }
    }

    static fromJS(data: any): GetPSKUProgramOutputItem {
        data = typeof data === 'object' ? data : {};
        let result = new GetPSKUProgramOutputItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productCode"] = this.productCode;
        data["productName"] = this.productName;
        data["target"] = this.target;
        data["actual"] = this.actual;
        return data;
    }
}

export interface IGetPSKUProgramOutputItem {
    productCode: string | undefined;
    productName: string | undefined;
    target: number | undefined;
    actual: number | undefined;
}

export class PagedResultDtoOfGetDeleteProfileRequestForViewDto implements IPagedResultDtoOfGetDeleteProfileRequestForViewDto {
    totalCount!: number | undefined;
    items!: GetDeleteProfileRequestForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetDeleteProfileRequestForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetDeleteProfileRequestForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetDeleteProfileRequestForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetDeleteProfileRequestForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetDeleteProfileRequestForViewDto {
    totalCount: number | undefined;
    items: GetDeleteProfileRequestForViewDto[] | undefined;
}

export class GetDeleteProfileRequestForViewDto implements IGetDeleteProfileRequestForViewDto {
    deleteProfileRequest!: DeleteProfileRequestDto | undefined;

    constructor(data?: IGetDeleteProfileRequestForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.deleteProfileRequest = data["deleteProfileRequest"] ? DeleteProfileRequestDto.fromJS(data["deleteProfileRequest"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetDeleteProfileRequestForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetDeleteProfileRequestForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deleteProfileRequest"] = this.deleteProfileRequest ? this.deleteProfileRequest.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetDeleteProfileRequestForViewDto {
    deleteProfileRequest: DeleteProfileRequestDto | undefined;
}

export class DeleteProfileRequestDto implements IDeleteProfileRequestDto {
    memberCode!: string | undefined;
    memberName!: string | undefined;
    phone!: string | undefined;
    typeOfRequest!: string | undefined;
    requestDate!: moment.Moment | undefined;
    requestBy!: string | undefined;
    credentials!: string | undefined;
    status!: string | undefined;
    approveDate!: moment.Moment | undefined;
    approveBy!: string | undefined;
    reason!: string | undefined;
    reasonCode!: string | undefined;
    isDeleted!: boolean | undefined;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: moment.Moment | undefined;
    creatorUserId!: number | undefined;
    id!: number | undefined;

    constructor(data?: IDeleteProfileRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberCode = data["memberCode"];
            this.memberName = data["memberName"];
            this.phone = data["phone"];
            this.typeOfRequest = data["typeOfRequest"];
            this.requestDate = data["requestDate"] ? moment(data["requestDate"].toString()) : <any>undefined;
            this.requestBy = data["requestBy"];
            this.credentials = data["credentials"];
            this.status = data["status"];
            this.approveDate = data["approveDate"] ? moment(data["approveDate"].toString()) : <any>undefined;
            this.approveBy = data["approveBy"];
            this.reason = data["reason"];
            this.reasonCode = data["reasonCode"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): DeleteProfileRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteProfileRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberCode"] = this.memberCode;
        data["memberName"] = this.memberName;
        data["phone"] = this.phone;
        data["typeOfRequest"] = this.typeOfRequest;
        data["requestDate"] = this.requestDate ? this.requestDate.toISOString() : <any>undefined;
        data["requestBy"] = this.requestBy;
        data["credentials"] = this.credentials;
        data["status"] = this.status;
        data["approveDate"] = this.approveDate ? this.approveDate.toISOString() : <any>undefined;
        data["approveBy"] = this.approveBy;
        data["reason"] = this.reason;
        data["reasonCode"] = this.reasonCode;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IDeleteProfileRequestDto {
    memberCode: string | undefined;
    memberName: string | undefined;
    phone: string | undefined;
    typeOfRequest: string | undefined;
    requestDate: moment.Moment | undefined;
    requestBy: string | undefined;
    credentials: string | undefined;
    status: string | undefined;
    approveDate: moment.Moment | undefined;
    approveBy: string | undefined;
    reason: string | undefined;
    reasonCode: string | undefined;
    isDeleted: boolean | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class GetDeleteProfileRequestForEditOutput implements IGetDeleteProfileRequestForEditOutput {
    deleteProfileRequest!: CreateOrEditDeleteProfileRequestDto | undefined;

    constructor(data?: IGetDeleteProfileRequestForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.deleteProfileRequest = data["deleteProfileRequest"] ? CreateOrEditDeleteProfileRequestDto.fromJS(data["deleteProfileRequest"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetDeleteProfileRequestForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetDeleteProfileRequestForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deleteProfileRequest"] = this.deleteProfileRequest ? this.deleteProfileRequest.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetDeleteProfileRequestForEditOutput {
    deleteProfileRequest: CreateOrEditDeleteProfileRequestDto | undefined;
}

export class CreateOrEditDeleteProfileRequestDto implements ICreateOrEditDeleteProfileRequestDto {
    memberCode!: string | undefined;
    memberName!: string | undefined;
    phone!: string | undefined;
    typeOfRequest!: string | undefined;
    requestDate!: moment.Moment | undefined;
    requestBy!: string | undefined;
    credentials!: string | undefined;
    status!: string | undefined;
    approveDate!: moment.Moment | undefined;
    approveBy!: string | undefined;
    reason!: string | undefined;
    reasonCode!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditDeleteProfileRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberCode = data["memberCode"];
            this.memberName = data["memberName"];
            this.phone = data["phone"];
            this.typeOfRequest = data["typeOfRequest"];
            this.requestDate = data["requestDate"] ? moment(data["requestDate"].toString()) : <any>undefined;
            this.requestBy = data["requestBy"];
            this.credentials = data["credentials"];
            this.status = data["status"];
            this.approveDate = data["approveDate"] ? moment(data["approveDate"].toString()) : <any>undefined;
            this.approveBy = data["approveBy"];
            this.reason = data["reason"];
            this.reasonCode = data["reasonCode"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditDeleteProfileRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditDeleteProfileRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberCode"] = this.memberCode;
        data["memberName"] = this.memberName;
        data["phone"] = this.phone;
        data["typeOfRequest"] = this.typeOfRequest;
        data["requestDate"] = this.requestDate ? this.requestDate.toISOString() : <any>undefined;
        data["requestBy"] = this.requestBy;
        data["credentials"] = this.credentials;
        data["status"] = this.status;
        data["approveDate"] = this.approveDate ? this.approveDate.toISOString() : <any>undefined;
        data["approveBy"] = this.approveBy;
        data["reason"] = this.reason;
        data["reasonCode"] = this.reasonCode;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditDeleteProfileRequestDto {
    memberCode: string | undefined;
    memberName: string | undefined;
    phone: string | undefined;
    typeOfRequest: string | undefined;
    requestDate: moment.Moment | undefined;
    requestBy: string | undefined;
    credentials: string | undefined;
    status: string | undefined;
    approveDate: moment.Moment | undefined;
    approveBy: string | undefined;
    reason: string | undefined;
    reasonCode: string | undefined;
    id: number | undefined;
}

export class GetAllDeleteProfileRequestsForExcelInput implements IGetAllDeleteProfileRequestsForExcelInput {
    filter!: string | undefined;
    memberCodeFilter!: string | undefined;
    memberNameFilter!: string | undefined;
    phoneFilter!: string | undefined;
    typeOfRequestFilter!: string | undefined;
    maxRequestDateFilter!: moment.Moment | undefined;
    minRequestDateFilter!: moment.Moment | undefined;
    requestByFilter!: string | undefined;
    credentialsFilter!: string | undefined;
    statusFilter!: string | undefined;
    maxApproveDateFilter!: moment.Moment | undefined;
    minApproveDateFilter!: moment.Moment | undefined;
    approveByFilter!: string | undefined;
    reasonFilter!: string | undefined;
    reasonCodeFilter!: string | undefined;

    constructor(data?: IGetAllDeleteProfileRequestsForExcelInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.filter = data["filter"];
            this.memberCodeFilter = data["memberCodeFilter"];
            this.memberNameFilter = data["memberNameFilter"];
            this.phoneFilter = data["phoneFilter"];
            this.typeOfRequestFilter = data["typeOfRequestFilter"];
            this.maxRequestDateFilter = data["maxRequestDateFilter"] ? moment(data["maxRequestDateFilter"].toString()) : <any>undefined;
            this.minRequestDateFilter = data["minRequestDateFilter"] ? moment(data["minRequestDateFilter"].toString()) : <any>undefined;
            this.requestByFilter = data["requestByFilter"];
            this.credentialsFilter = data["credentialsFilter"];
            this.statusFilter = data["statusFilter"];
            this.maxApproveDateFilter = data["maxApproveDateFilter"] ? moment(data["maxApproveDateFilter"].toString()) : <any>undefined;
            this.minApproveDateFilter = data["minApproveDateFilter"] ? moment(data["minApproveDateFilter"].toString()) : <any>undefined;
            this.approveByFilter = data["approveByFilter"];
            this.reasonFilter = data["reasonFilter"];
            this.reasonCodeFilter = data["reasonCodeFilter"];
        }
    }

    static fromJS(data: any): GetAllDeleteProfileRequestsForExcelInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllDeleteProfileRequestsForExcelInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        data["memberCodeFilter"] = this.memberCodeFilter;
        data["memberNameFilter"] = this.memberNameFilter;
        data["phoneFilter"] = this.phoneFilter;
        data["typeOfRequestFilter"] = this.typeOfRequestFilter;
        data["maxRequestDateFilter"] = this.maxRequestDateFilter ? this.maxRequestDateFilter.toISOString() : <any>undefined;
        data["minRequestDateFilter"] = this.minRequestDateFilter ? this.minRequestDateFilter.toISOString() : <any>undefined;
        data["requestByFilter"] = this.requestByFilter;
        data["credentialsFilter"] = this.credentialsFilter;
        data["statusFilter"] = this.statusFilter;
        data["maxApproveDateFilter"] = this.maxApproveDateFilter ? this.maxApproveDateFilter.toISOString() : <any>undefined;
        data["minApproveDateFilter"] = this.minApproveDateFilter ? this.minApproveDateFilter.toISOString() : <any>undefined;
        data["approveByFilter"] = this.approveByFilter;
        data["reasonFilter"] = this.reasonFilter;
        data["reasonCodeFilter"] = this.reasonCodeFilter;
        return data;
    }
}

export interface IGetAllDeleteProfileRequestsForExcelInput {
    filter: string | undefined;
    memberCodeFilter: string | undefined;
    memberNameFilter: string | undefined;
    phoneFilter: string | undefined;
    typeOfRequestFilter: string | undefined;
    maxRequestDateFilter: moment.Moment | undefined;
    minRequestDateFilter: moment.Moment | undefined;
    requestByFilter: string | undefined;
    credentialsFilter: string | undefined;
    statusFilter: string | undefined;
    maxApproveDateFilter: moment.Moment | undefined;
    minApproveDateFilter: moment.Moment | undefined;
    approveByFilter: string | undefined;
    reasonFilter: string | undefined;
    reasonCodeFilter: string | undefined;
}

export class GetAllDeleteProfileRequestsInput implements IGetAllDeleteProfileRequestsInput {
    filter!: string | undefined;
    memberCodeFilter!: string | undefined;
    memberNameFilter!: string | undefined;
    phoneFilter!: string | undefined;
    typeOfRequestFilter!: string | undefined;
    maxRequestDateFilter!: moment.Moment | undefined;
    minRequestDateFilter!: moment.Moment | undefined;
    requestByFilter!: string | undefined;
    credentialsFilter!: string | undefined;
    statusFilter!: string | undefined;
    maxApproveDateFilter!: moment.Moment | undefined;
    minApproveDateFilter!: moment.Moment | undefined;
    approveByFilter!: string | undefined;
    reasonFilter!: string | undefined;
    reasonCodeFilter!: string | undefined;
    sorting!: string | undefined;
    skipCount!: number | undefined;
    maxResultCount!: number | undefined;

    constructor(data?: IGetAllDeleteProfileRequestsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.filter = data["filter"];
            this.memberCodeFilter = data["memberCodeFilter"];
            this.memberNameFilter = data["memberNameFilter"];
            this.phoneFilter = data["phoneFilter"];
            this.typeOfRequestFilter = data["typeOfRequestFilter"];
            this.maxRequestDateFilter = data["maxRequestDateFilter"] ? moment(data["maxRequestDateFilter"].toString()) : <any>undefined;
            this.minRequestDateFilter = data["minRequestDateFilter"] ? moment(data["minRequestDateFilter"].toString()) : <any>undefined;
            this.requestByFilter = data["requestByFilter"];
            this.credentialsFilter = data["credentialsFilter"];
            this.statusFilter = data["statusFilter"];
            this.maxApproveDateFilter = data["maxApproveDateFilter"] ? moment(data["maxApproveDateFilter"].toString()) : <any>undefined;
            this.minApproveDateFilter = data["minApproveDateFilter"] ? moment(data["minApproveDateFilter"].toString()) : <any>undefined;
            this.approveByFilter = data["approveByFilter"];
            this.reasonFilter = data["reasonFilter"];
            this.reasonCodeFilter = data["reasonCodeFilter"];
            this.sorting = data["sorting"];
            this.skipCount = data["skipCount"];
            this.maxResultCount = data["maxResultCount"];
        }
    }

    static fromJS(data: any): GetAllDeleteProfileRequestsInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllDeleteProfileRequestsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        data["memberCodeFilter"] = this.memberCodeFilter;
        data["memberNameFilter"] = this.memberNameFilter;
        data["phoneFilter"] = this.phoneFilter;
        data["typeOfRequestFilter"] = this.typeOfRequestFilter;
        data["maxRequestDateFilter"] = this.maxRequestDateFilter ? this.maxRequestDateFilter.toISOString() : <any>undefined;
        data["minRequestDateFilter"] = this.minRequestDateFilter ? this.minRequestDateFilter.toISOString() : <any>undefined;
        data["requestByFilter"] = this.requestByFilter;
        data["credentialsFilter"] = this.credentialsFilter;
        data["statusFilter"] = this.statusFilter;
        data["maxApproveDateFilter"] = this.maxApproveDateFilter ? this.maxApproveDateFilter.toISOString() : <any>undefined;
        data["minApproveDateFilter"] = this.minApproveDateFilter ? this.minApproveDateFilter.toISOString() : <any>undefined;
        data["approveByFilter"] = this.approveByFilter;
        data["reasonFilter"] = this.reasonFilter;
        data["reasonCodeFilter"] = this.reasonCodeFilter;
        data["sorting"] = this.sorting;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data;
    }
}

export interface IGetAllDeleteProfileRequestsInput {
    filter: string | undefined;
    memberCodeFilter: string | undefined;
    memberNameFilter: string | undefined;
    phoneFilter: string | undefined;
    typeOfRequestFilter: string | undefined;
    maxRequestDateFilter: moment.Moment | undefined;
    minRequestDateFilter: moment.Moment | undefined;
    requestByFilter: string | undefined;
    credentialsFilter: string | undefined;
    statusFilter: string | undefined;
    maxApproveDateFilter: moment.Moment | undefined;
    minApproveDateFilter: moment.Moment | undefined;
    approveByFilter: string | undefined;
    reasonFilter: string | undefined;
    reasonCodeFilter: string | undefined;
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;
}

export class InactiveDeleteUserRequestDto implements IInactiveDeleteUserRequestDto {
    memberCode!: string | undefined;
    reason!: string | undefined;
    reasonCode!: string | undefined;
    otpToken!: string | undefined;

    constructor(data?: IInactiveDeleteUserRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberCode = data["memberCode"];
            this.reason = data["reason"];
            this.reasonCode = data["reasonCode"];
            this.otpToken = data["otpToken"];
        }
    }

    static fromJS(data: any): InactiveDeleteUserRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new InactiveDeleteUserRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberCode"] = this.memberCode;
        data["reason"] = this.reason;
        data["reasonCode"] = this.reasonCode;
        data["otpToken"] = this.otpToken;
        return data;
    }
}

export interface IInactiveDeleteUserRequestDto {
    memberCode: string | undefined;
    reason: string | undefined;
    reasonCode: string | undefined;
    otpToken: string | undefined;
}

export class DeleteUserRequestResponse implements IDeleteUserRequestResponse {
    result!: boolean | undefined;
    error!: ErrorResponse | undefined;

    constructor(data?: IDeleteUserRequestResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.result = data["result"];
            this.error = data["error"] ? ErrorResponse.fromJS(data["error"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DeleteUserRequestResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteUserRequestResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDeleteUserRequestResponse {
    result: boolean | undefined;
    error: ErrorResponse | undefined;
}

export class ErrorResponse implements IErrorResponse {
    message!: string | undefined;
    details!: string | undefined;
    code!: number | undefined;

    constructor(data?: IErrorResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.message = data["message"];
            this.details = data["details"];
            this.code = data["code"];
        }
    }

    static fromJS(data: any): ErrorResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["details"] = this.details;
        data["code"] = this.code;
        return data;
    }
}

export interface IErrorResponse {
    message: string | undefined;
    details: string | undefined;
    code: number | undefined;
}

export class DateToStringOutput implements IDateToStringOutput {
    dateString!: string | undefined;

    constructor(data?: IDateToStringOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.dateString = data["dateString"];
        }
    }

    static fromJS(data: any): DateToStringOutput {
        data = typeof data === 'object' ? data : {};
        let result = new DateToStringOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateString"] = this.dateString;
        return data;
    }
}

export interface IDateToStringOutput {
    dateString: string | undefined;
}

export class NameValueOfString implements INameValueOfString {
    name!: string | undefined;
    value!: string | undefined;

    constructor(data?: INameValueOfString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.value = data["value"];
        }
    }

    static fromJS(data: any): NameValueOfString {
        data = typeof data === 'object' ? data : {};
        let result = new NameValueOfString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }
}

export interface INameValueOfString {
    name: string | undefined;
    value: string | undefined;
}

export class StringOutput implements IStringOutput {
    output!: string | undefined;

    constructor(data?: IStringOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.output = data["output"];
        }
    }

    static fromJS(data: any): StringOutput {
        data = typeof data === 'object' ? data : {};
        let result = new StringOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["output"] = this.output;
        return data;
    }
}

export interface IStringOutput {
    output: string | undefined;
}

export class PagedResultDtoOfGetDeparmentForView implements IPagedResultDtoOfGetDeparmentForView {
    totalCount!: number | undefined;
    items!: GetDeparmentForView[] | undefined;

    constructor(data?: IPagedResultDtoOfGetDeparmentForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetDeparmentForView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetDeparmentForView {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetDeparmentForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetDeparmentForView {
    totalCount: number | undefined;
    items: GetDeparmentForView[] | undefined;
}

export class GetDeparmentForView implements IGetDeparmentForView {
    deparment!: DeparmentDto | undefined;

    constructor(data?: IGetDeparmentForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.deparment = data["deparment"] ? DeparmentDto.fromJS(data["deparment"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetDeparmentForView {
        data = typeof data === 'object' ? data : {};
        let result = new GetDeparmentForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deparment"] = this.deparment ? this.deparment.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetDeparmentForView {
    deparment: DeparmentDto | undefined;
}

export class DeparmentDto implements IDeparmentDto {
    code!: string | undefined;
    name!: string | undefined;
    description!: string | undefined;
    level!: number | undefined;
    parentCode!: string | undefined;
    isActive!: boolean | undefined;
    id!: number | undefined;

    constructor(data?: IDeparmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.name = data["name"];
            this.description = data["description"];
            this.level = data["level"];
            this.parentCode = data["parentCode"];
            this.isActive = data["isActive"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): DeparmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeparmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["description"] = this.description;
        data["level"] = this.level;
        data["parentCode"] = this.parentCode;
        data["isActive"] = this.isActive;
        data["id"] = this.id;
        return data;
    }
}

export interface IDeparmentDto {
    code: string | undefined;
    name: string | undefined;
    description: string | undefined;
    level: number | undefined;
    parentCode: string | undefined;
    isActive: boolean | undefined;
    id: number | undefined;
}

export class GetDeparmentForEditOutput implements IGetDeparmentForEditOutput {
    deparment!: CreateOrEditDeparmentDto | undefined;

    constructor(data?: IGetDeparmentForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.deparment = data["deparment"] ? CreateOrEditDeparmentDto.fromJS(data["deparment"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetDeparmentForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetDeparmentForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deparment"] = this.deparment ? this.deparment.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetDeparmentForEditOutput {
    deparment: CreateOrEditDeparmentDto | undefined;
}

export class CreateOrEditDeparmentDto implements ICreateOrEditDeparmentDto {
    code!: string;
    name!: string;
    description!: string | undefined;
    level!: number | undefined;
    parentCode!: string | undefined;
    isActive!: boolean | undefined;
    isDeleted!: boolean | undefined;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: moment.Moment | undefined;
    creatorUserId!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditDeparmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.name = data["name"];
            this.description = data["description"];
            this.level = data["level"];
            this.parentCode = data["parentCode"];
            this.isActive = data["isActive"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditDeparmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditDeparmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["description"] = this.description;
        data["level"] = this.level;
        data["parentCode"] = this.parentCode;
        data["isActive"] = this.isActive;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditDeparmentDto {
    code: string;
    name: string;
    description: string | undefined;
    level: number | undefined;
    parentCode: string | undefined;
    isActive: boolean | undefined;
    isDeleted: boolean | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class ListResultDtoOfEditionListDto implements IListResultDtoOfEditionListDto {
    items!: EditionListDto[] | undefined;

    constructor(data?: IListResultDtoOfEditionListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(EditionListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfEditionListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfEditionListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListResultDtoOfEditionListDto {
    items: EditionListDto[] | undefined;
}

export class EditionListDto implements IEditionListDto {
    name!: string | undefined;
    displayName!: string | undefined;
    creationTime!: moment.Moment | undefined;
    id!: number | undefined;

    constructor(data?: IEditionListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.displayName = data["displayName"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EditionListDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditionListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IEditionListDto {
    name: string | undefined;
    displayName: string | undefined;
    creationTime: moment.Moment | undefined;
    id: number | undefined;
}

export class GetEditionEditOutput implements IGetEditionEditOutput {
    edition!: EditionEditDto | undefined;
    featureValues!: NameValueDto[] | undefined;
    features!: FlatFeatureDto[] | undefined;

    constructor(data?: IGetEditionEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.edition = data["edition"] ? EditionEditDto.fromJS(data["edition"]) : <any>undefined;
            if (data["featureValues"] && data["featureValues"].constructor === Array) {
                this.featureValues = [];
                for (let item of data["featureValues"])
                    this.featureValues.push(NameValueDto.fromJS(item));
            }
            if (data["features"] && data["features"].constructor === Array) {
                this.features = [];
                for (let item of data["features"])
                    this.features.push(FlatFeatureDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetEditionEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetEditionEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["edition"] = this.edition ? this.edition.toJSON() : <any>undefined;
        if (this.featureValues && this.featureValues.constructor === Array) {
            data["featureValues"] = [];
            for (let item of this.featureValues)
                data["featureValues"].push(item.toJSON());
        }
        if (this.features && this.features.constructor === Array) {
            data["features"] = [];
            for (let item of this.features)
                data["features"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetEditionEditOutput {
    edition: EditionEditDto | undefined;
    featureValues: NameValueDto[] | undefined;
    features: FlatFeatureDto[] | undefined;
}

export class EditionEditDto implements IEditionEditDto {
    id!: number | undefined;
    displayName!: string;
    monthlyPrice!: number | undefined;
    annualPrice!: number | undefined;
    trialDayCount!: number | undefined;
    waitingDayAfterExpire!: number | undefined;
    expiringEditionId!: number | undefined;

    constructor(data?: IEditionEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
            this.monthlyPrice = data["monthlyPrice"];
            this.annualPrice = data["annualPrice"];
            this.trialDayCount = data["trialDayCount"];
            this.waitingDayAfterExpire = data["waitingDayAfterExpire"];
            this.expiringEditionId = data["expiringEditionId"];
        }
    }

    static fromJS(data: any): EditionEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditionEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["monthlyPrice"] = this.monthlyPrice;
        data["annualPrice"] = this.annualPrice;
        data["trialDayCount"] = this.trialDayCount;
        data["waitingDayAfterExpire"] = this.waitingDayAfterExpire;
        data["expiringEditionId"] = this.expiringEditionId;
        return data;
    }
}

export interface IEditionEditDto {
    id: number | undefined;
    displayName: string;
    monthlyPrice: number | undefined;
    annualPrice: number | undefined;
    trialDayCount: number | undefined;
    waitingDayAfterExpire: number | undefined;
    expiringEditionId: number | undefined;
}

export class FlatFeatureDto implements IFlatFeatureDto {
    parentName!: string | undefined;
    name!: string | undefined;
    displayName!: string | undefined;
    description!: string | undefined;
    defaultValue!: string | undefined;
    inputType!: FeatureInputTypeDto | undefined;

    constructor(data?: IFlatFeatureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.parentName = data["parentName"];
            this.name = data["name"];
            this.displayName = data["displayName"];
            this.description = data["description"];
            this.defaultValue = data["defaultValue"];
            this.inputType = data["inputType"] ? FeatureInputTypeDto.fromJS(data["inputType"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FlatFeatureDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlatFeatureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentName"] = this.parentName;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["defaultValue"] = this.defaultValue;
        data["inputType"] = this.inputType ? this.inputType.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFlatFeatureDto {
    parentName: string | undefined;
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    defaultValue: string | undefined;
    inputType: FeatureInputTypeDto | undefined;
}

export class FeatureInputTypeDto implements IFeatureInputTypeDto {
    name!: string | undefined;
    attributes!: { [key: string]: any; } | undefined;
    validator!: IValueValidator | undefined;
    itemSource!: LocalizableComboboxItemSourceDto | undefined;

    constructor(data?: IFeatureInputTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            if (data["attributes"]) {
                this.attributes = {};
                for (let key in data["attributes"]) {
                    if (data["attributes"].hasOwnProperty(key))
                        this.attributes[key] = data["attributes"][key];
                }
            }
            this.validator = data["validator"] ? IValueValidator.fromJS(data["validator"]) : <any>undefined;
            this.itemSource = data["itemSource"] ? LocalizableComboboxItemSourceDto.fromJS(data["itemSource"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FeatureInputTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new FeatureInputTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (this.attributes) {
            data["attributes"] = {};
            for (let key in this.attributes) {
                if (this.attributes.hasOwnProperty(key))
                    data["attributes"][key] = this.attributes[key];
            }
        }
        data["validator"] = this.validator ? this.validator.toJSON() : <any>undefined;
        data["itemSource"] = this.itemSource ? this.itemSource.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFeatureInputTypeDto {
    name: string | undefined;
    attributes: { [key: string]: any; } | undefined;
    validator: IValueValidator | undefined;
    itemSource: LocalizableComboboxItemSourceDto | undefined;
}

export class IValueValidator implements IIValueValidator {
    name!: string | undefined;
    attributes!: { [key: string]: any; } | undefined;

    constructor(data?: IIValueValidator) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            if (data["attributes"]) {
                this.attributes = {};
                for (let key in data["attributes"]) {
                    if (data["attributes"].hasOwnProperty(key))
                        this.attributes[key] = data["attributes"][key];
                }
            }
        }
    }

    static fromJS(data: any): IValueValidator {
        data = typeof data === 'object' ? data : {};
        let result = new IValueValidator();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (this.attributes) {
            data["attributes"] = {};
            for (let key in this.attributes) {
                if (this.attributes.hasOwnProperty(key))
                    data["attributes"][key] = this.attributes[key];
            }
        }
        return data;
    }
}

export interface IIValueValidator {
    name: string | undefined;
    attributes: { [key: string]: any; } | undefined;
}

export class LocalizableComboboxItemSourceDto implements ILocalizableComboboxItemSourceDto {
    items!: LocalizableComboboxItemDto[] | undefined;

    constructor(data?: ILocalizableComboboxItemSourceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(LocalizableComboboxItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LocalizableComboboxItemSourceDto {
        data = typeof data === 'object' ? data : {};
        let result = new LocalizableComboboxItemSourceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILocalizableComboboxItemSourceDto {
    items: LocalizableComboboxItemDto[] | undefined;
}

export class LocalizableComboboxItemDto implements ILocalizableComboboxItemDto {
    value!: string | undefined;
    displayText!: string | undefined;

    constructor(data?: ILocalizableComboboxItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.value = data["value"];
            this.displayText = data["displayText"];
        }
    }

    static fromJS(data: any): LocalizableComboboxItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new LocalizableComboboxItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["displayText"] = this.displayText;
        return data;
    }
}

export interface ILocalizableComboboxItemDto {
    value: string | undefined;
    displayText: string | undefined;
}

export class CreateOrUpdateEditionDto implements ICreateOrUpdateEditionDto {
    edition!: EditionEditDto;
    featureValues!: NameValueDto[];

    constructor(data?: ICreateOrUpdateEditionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.edition = new EditionEditDto();
            this.featureValues = [];
        }
    }

    init(data?: any) {
        if (data) {
            this.edition = data["edition"] ? EditionEditDto.fromJS(data["edition"]) : new EditionEditDto();
            if (data["featureValues"] && data["featureValues"].constructor === Array) {
                this.featureValues = [];
                for (let item of data["featureValues"])
                    this.featureValues.push(NameValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateEditionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateEditionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["edition"] = this.edition ? this.edition.toJSON() : <any>undefined;
        if (this.featureValues && this.featureValues.constructor === Array) {
            data["featureValues"] = [];
            for (let item of this.featureValues)
                data["featureValues"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateOrUpdateEditionDto {
    edition: EditionEditDto;
    featureValues: NameValueDto[];
}

export class PagedResultDtoOfGetEgiftGameForViewDto implements IPagedResultDtoOfGetEgiftGameForViewDto {
    totalCount!: number | undefined;
    items!: GetEgiftGameForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetEgiftGameForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetEgiftGameForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetEgiftGameForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetEgiftGameForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetEgiftGameForViewDto {
    totalCount: number | undefined;
    items: GetEgiftGameForViewDto[] | undefined;
}

export class GetEgiftGameForViewDto implements IGetEgiftGameForViewDto {
    egiftGame!: EgiftGameDto | undefined;

    constructor(data?: IGetEgiftGameForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.egiftGame = data["egiftGame"] ? EgiftGameDto.fromJS(data["egiftGame"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetEgiftGameForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetEgiftGameForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["egiftGame"] = this.egiftGame ? this.egiftGame.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetEgiftGameForViewDto {
    egiftGame: EgiftGameDto | undefined;
}

export class EgiftGameDto implements IEgiftGameDto {
    code!: string | undefined;
    expiredDate!: moment.Moment | undefined;
    rewardCode!: string | undefined;
    status!: string | undefined;
    usedStatus!: string | undefined;
    serialCode!: string | undefined;
    historyId!: number | undefined;
    extraData!: string | undefined;
    id!: number | undefined;

    constructor(data?: IEgiftGameDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.expiredDate = data["expiredDate"] ? moment(data["expiredDate"].toString()) : <any>undefined;
            this.rewardCode = data["rewardCode"];
            this.status = data["status"];
            this.usedStatus = data["usedStatus"];
            this.serialCode = data["serialCode"];
            this.historyId = data["historyId"];
            this.extraData = data["extraData"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EgiftGameDto {
        data = typeof data === 'object' ? data : {};
        let result = new EgiftGameDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["expiredDate"] = this.expiredDate ? this.expiredDate.toISOString() : <any>undefined;
        data["rewardCode"] = this.rewardCode;
        data["status"] = this.status;
        data["usedStatus"] = this.usedStatus;
        data["serialCode"] = this.serialCode;
        data["historyId"] = this.historyId;
        data["extraData"] = this.extraData;
        data["id"] = this.id;
        return data;
    }
}

export interface IEgiftGameDto {
    code: string | undefined;
    expiredDate: moment.Moment | undefined;
    rewardCode: string | undefined;
    status: string | undefined;
    usedStatus: string | undefined;
    serialCode: string | undefined;
    historyId: number | undefined;
    extraData: string | undefined;
    id: number | undefined;
}

export class GetEgiftGameForEditOutput implements IGetEgiftGameForEditOutput {
    egiftGame!: CreateOrEditEgiftGameDto | undefined;

    constructor(data?: IGetEgiftGameForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.egiftGame = data["egiftGame"] ? CreateOrEditEgiftGameDto.fromJS(data["egiftGame"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetEgiftGameForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetEgiftGameForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["egiftGame"] = this.egiftGame ? this.egiftGame.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetEgiftGameForEditOutput {
    egiftGame: CreateOrEditEgiftGameDto | undefined;
}

export class CreateOrEditEgiftGameDto implements ICreateOrEditEgiftGameDto {
    code!: string | undefined;
    expiredDate!: moment.Moment | undefined;
    rewardCode!: string | undefined;
    status!: string | undefined;
    usedStatus!: string | undefined;
    serialCode!: string | undefined;
    historyId!: number | undefined;
    extraData!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditEgiftGameDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.expiredDate = data["expiredDate"] ? moment(data["expiredDate"].toString()) : <any>undefined;
            this.rewardCode = data["rewardCode"];
            this.status = data["status"];
            this.usedStatus = data["usedStatus"];
            this.serialCode = data["serialCode"];
            this.historyId = data["historyId"];
            this.extraData = data["extraData"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditEgiftGameDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditEgiftGameDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["expiredDate"] = this.expiredDate ? this.expiredDate.toISOString() : <any>undefined;
        data["rewardCode"] = this.rewardCode;
        data["status"] = this.status;
        data["usedStatus"] = this.usedStatus;
        data["serialCode"] = this.serialCode;
        data["historyId"] = this.historyId;
        data["extraData"] = this.extraData;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditEgiftGameDto {
    code: string | undefined;
    expiredDate: moment.Moment | undefined;
    rewardCode: string | undefined;
    status: string | undefined;
    usedStatus: string | undefined;
    serialCode: string | undefined;
    historyId: number | undefined;
    extraData: string | undefined;
    id: number | undefined;
}

export class GamificationFileDto implements IGamificationFileDto {
    fileName!: string;
    fileType!: string;
    fileToken!: string;

    constructor(data?: IGamificationFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.fileName = data["fileName"];
            this.fileType = data["fileType"];
            this.fileToken = data["fileToken"];
        }
    }

    static fromJS(data: any): GamificationFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new GamificationFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["fileType"] = this.fileType;
        data["fileToken"] = this.fileToken;
        return data;
    }
}

export interface IGamificationFileDto {
    fileName: string;
    fileType: string;
    fileToken: string;
}

export class ERewardDetailDto implements IERewardDetailDto {
    code!: string | undefined;
    expiredDate!: moment.Moment | undefined;
    serialCode!: string | undefined;
    usedStatus!: string | undefined;
    name!: string | undefined;
    description!: string | undefined;
    image!: string | undefined;

    constructor(data?: IERewardDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.expiredDate = data["expiredDate"] ? moment(data["expiredDate"].toString()) : <any>undefined;
            this.serialCode = data["serialCode"];
            this.usedStatus = data["usedStatus"];
            this.name = data["name"];
            this.description = data["description"];
            this.image = data["image"];
        }
    }

    static fromJS(data: any): ERewardDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new ERewardDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["expiredDate"] = this.expiredDate ? this.expiredDate.toISOString() : <any>undefined;
        data["serialCode"] = this.serialCode;
        data["usedStatus"] = this.usedStatus;
        data["name"] = this.name;
        data["description"] = this.description;
        data["image"] = this.image;
        return data;
    }
}

export interface IERewardDetailDto {
    code: string | undefined;
    expiredDate: moment.Moment | undefined;
    serialCode: string | undefined;
    usedStatus: string | undefined;
    name: string | undefined;
    description: string | undefined;
    image: string | undefined;
}

export class PagedResultDtoOfGetEGiftInforForView implements IPagedResultDtoOfGetEGiftInforForView {
    totalCount!: number | undefined;
    items!: GetEGiftInforForView[] | undefined;

    constructor(data?: IPagedResultDtoOfGetEGiftInforForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetEGiftInforForView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetEGiftInforForView {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetEGiftInforForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetEGiftInforForView {
    totalCount: number | undefined;
    items: GetEGiftInforForView[] | undefined;
}

export class GetEGiftInforForView implements IGetEGiftInforForView {
    eGiftInfor!: EGiftInforDto | undefined;
    giftInforGiftCode!: string | undefined;

    constructor(data?: IGetEGiftInforForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.eGiftInfor = data["eGiftInfor"] ? EGiftInforDto.fromJS(data["eGiftInfor"]) : <any>undefined;
            this.giftInforGiftCode = data["giftInforGiftCode"];
        }
    }

    static fromJS(data: any): GetEGiftInforForView {
        data = typeof data === 'object' ? data : {};
        let result = new GetEGiftInforForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eGiftInfor"] = this.eGiftInfor ? this.eGiftInfor.toJSON() : <any>undefined;
        data["giftInforGiftCode"] = this.giftInforGiftCode;
        return data;
    }
}

export interface IGetEGiftInforForView {
    eGiftInfor: EGiftInforDto | undefined;
    giftInforGiftCode: string | undefined;
}

export class EGiftInforDto implements IEGiftInforDto {
    type!: string | undefined;
    code!: string | undefined;
    description!: string | undefined;
    status!: string | undefined;
    usedStatus!: string | undefined;
    expiredDate!: moment.Moment | undefined;
    giftCode!: string | undefined;
    giftId!: number | undefined;
    lastModificationTime!: moment.Moment | undefined;
    creationTime!: moment.Moment | undefined;
    serialCode!: string | undefined;
    id!: number | undefined;

    constructor(data?: IEGiftInforDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.type = data["type"];
            this.code = data["code"];
            this.description = data["description"];
            this.status = data["status"];
            this.usedStatus = data["usedStatus"];
            this.expiredDate = data["expiredDate"] ? moment(data["expiredDate"].toString()) : <any>undefined;
            this.giftCode = data["giftCode"];
            this.giftId = data["giftId"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.serialCode = data["serialCode"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EGiftInforDto {
        data = typeof data === 'object' ? data : {};
        let result = new EGiftInforDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["code"] = this.code;
        data["description"] = this.description;
        data["status"] = this.status;
        data["usedStatus"] = this.usedStatus;
        data["expiredDate"] = this.expiredDate ? this.expiredDate.toISOString() : <any>undefined;
        data["giftCode"] = this.giftCode;
        data["giftId"] = this.giftId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["serialCode"] = this.serialCode;
        data["id"] = this.id;
        return data;
    }
}

export interface IEGiftInforDto {
    type: string | undefined;
    code: string | undefined;
    description: string | undefined;
    status: string | undefined;
    usedStatus: string | undefined;
    expiredDate: moment.Moment | undefined;
    giftCode: string | undefined;
    giftId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    creationTime: moment.Moment | undefined;
    serialCode: string | undefined;
    id: number | undefined;
}

export class GetEGiftInforForEditOutput implements IGetEGiftInforForEditOutput {
    eGiftInfor!: CreateOrEditEGiftInforDto | undefined;
    giftInforGiftCode!: string | undefined;

    constructor(data?: IGetEGiftInforForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.eGiftInfor = data["eGiftInfor"] ? CreateOrEditEGiftInforDto.fromJS(data["eGiftInfor"]) : <any>undefined;
            this.giftInforGiftCode = data["giftInforGiftCode"];
        }
    }

    static fromJS(data: any): GetEGiftInforForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetEGiftInforForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eGiftInfor"] = this.eGiftInfor ? this.eGiftInfor.toJSON() : <any>undefined;
        data["giftInforGiftCode"] = this.giftInforGiftCode;
        return data;
    }
}

export interface IGetEGiftInforForEditOutput {
    eGiftInfor: CreateOrEditEGiftInforDto | undefined;
    giftInforGiftCode: string | undefined;
}

export class CreateOrEditEGiftInforDto implements ICreateOrEditEGiftInforDto {
    type!: string | undefined;
    code!: string;
    description!: string | undefined;
    status!: string | undefined;
    usedStatus!: string | undefined;
    expiredDate!: moment.Moment | undefined;
    giftCode!: string | undefined;
    giftId!: number | undefined;
    referenceCode!: string | undefined;
    serialCode!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditEGiftInforDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.type = data["type"];
            this.code = data["code"];
            this.description = data["description"];
            this.status = data["status"];
            this.usedStatus = data["usedStatus"];
            this.expiredDate = data["expiredDate"] ? moment(data["expiredDate"].toString()) : <any>undefined;
            this.giftCode = data["giftCode"];
            this.giftId = data["giftId"];
            this.referenceCode = data["referenceCode"];
            this.serialCode = data["serialCode"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditEGiftInforDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditEGiftInforDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["code"] = this.code;
        data["description"] = this.description;
        data["status"] = this.status;
        data["usedStatus"] = this.usedStatus;
        data["expiredDate"] = this.expiredDate ? this.expiredDate.toISOString() : <any>undefined;
        data["giftCode"] = this.giftCode;
        data["giftId"] = this.giftId;
        data["referenceCode"] = this.referenceCode;
        data["serialCode"] = this.serialCode;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditEGiftInforDto {
    type: string | undefined;
    code: string;
    description: string | undefined;
    status: string | undefined;
    usedStatus: string | undefined;
    expiredDate: moment.Moment | undefined;
    giftCode: string | undefined;
    giftId: number | undefined;
    referenceCode: string | undefined;
    serialCode: string | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfGiftInforLookupTableDto implements IPagedResultDtoOfGiftInforLookupTableDto {
    totalCount!: number | undefined;
    items!: GiftInforLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGiftInforLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GiftInforLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGiftInforLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGiftInforLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGiftInforLookupTableDto {
    totalCount: number | undefined;
    items: GiftInforLookupTableDto[] | undefined;
}

export class GiftInforLookupTableDto implements IGiftInforLookupTableDto {
    id!: number | undefined;
    displayName!: string | undefined;

    constructor(data?: IGiftInforLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): GiftInforLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new GiftInforLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IGiftInforLookupTableDto {
    id: number | undefined;
    displayName: string | undefined;
}

export class PagedResultDtoOfGetEmailTemplateForViewDto implements IPagedResultDtoOfGetEmailTemplateForViewDto {
    totalCount!: number | undefined;
    items!: GetEmailTemplateForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetEmailTemplateForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetEmailTemplateForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetEmailTemplateForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetEmailTemplateForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetEmailTemplateForViewDto {
    totalCount: number | undefined;
    items: GetEmailTemplateForViewDto[] | undefined;
}

export class GetEmailTemplateForViewDto implements IGetEmailTemplateForViewDto {
    emailTemplate!: EmailTemplateDto | undefined;
    communicationName!: string | undefined;

    constructor(data?: IGetEmailTemplateForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.emailTemplate = data["emailTemplate"] ? EmailTemplateDto.fromJS(data["emailTemplate"]) : <any>undefined;
            this.communicationName = data["communicationName"];
        }
    }

    static fromJS(data: any): GetEmailTemplateForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetEmailTemplateForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailTemplate"] = this.emailTemplate ? this.emailTemplate.toJSON() : <any>undefined;
        data["communicationName"] = this.communicationName;
        return data;
    }
}

export interface IGetEmailTemplateForViewDto {
    emailTemplate: EmailTemplateDto | undefined;
    communicationName: string | undefined;
}

export class EmailTemplateDto implements IEmailTemplateDto {
    title!: string | undefined;
    body!: string | undefined;
    preview!: string | undefined;
    communicationID!: number | undefined;
    id!: number | undefined;

    constructor(data?: IEmailTemplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.title = data["title"];
            this.body = data["body"];
            this.preview = data["preview"];
            this.communicationID = data["communicationID"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EmailTemplateDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmailTemplateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["body"] = this.body;
        data["preview"] = this.preview;
        data["communicationID"] = this.communicationID;
        data["id"] = this.id;
        return data;
    }
}

export interface IEmailTemplateDto {
    title: string | undefined;
    body: string | undefined;
    preview: string | undefined;
    communicationID: number | undefined;
    id: number | undefined;
}

export class GetEmailTemplateForEditOutput implements IGetEmailTemplateForEditOutput {
    emailTemplate!: CreateOrEditEmailTemplateDto | undefined;
    communicationName!: string | undefined;

    constructor(data?: IGetEmailTemplateForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.emailTemplate = data["emailTemplate"] ? CreateOrEditEmailTemplateDto.fromJS(data["emailTemplate"]) : <any>undefined;
            this.communicationName = data["communicationName"];
        }
    }

    static fromJS(data: any): GetEmailTemplateForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetEmailTemplateForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailTemplate"] = this.emailTemplate ? this.emailTemplate.toJSON() : <any>undefined;
        data["communicationName"] = this.communicationName;
        return data;
    }
}

export interface IGetEmailTemplateForEditOutput {
    emailTemplate: CreateOrEditEmailTemplateDto | undefined;
    communicationName: string | undefined;
}

export class CreateOrEditEmailTemplateDto implements ICreateOrEditEmailTemplateDto {
    title!: string | undefined;
    body!: string | undefined;
    preview!: string | undefined;
    communicationID!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditEmailTemplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.title = data["title"];
            this.body = data["body"];
            this.preview = data["preview"];
            this.communicationID = data["communicationID"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditEmailTemplateDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditEmailTemplateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["body"] = this.body;
        data["preview"] = this.preview;
        data["communicationID"] = this.communicationID;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditEmailTemplateDto {
    title: string | undefined;
    body: string | undefined;
    preview: string | undefined;
    communicationID: number | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfCommunicationLookupTableDto implements IPagedResultDtoOfCommunicationLookupTableDto {
    totalCount!: number | undefined;
    items!: CommunicationLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfCommunicationLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(CommunicationLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfCommunicationLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfCommunicationLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfCommunicationLookupTableDto {
    totalCount: number | undefined;
    items: CommunicationLookupTableDto[] | undefined;
}

export class CommunicationLookupTableDto implements ICommunicationLookupTableDto {
    id!: number | undefined;
    displayName!: string | undefined;

    constructor(data?: ICommunicationLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): CommunicationLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new CommunicationLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface ICommunicationLookupTableDto {
    id: number | undefined;
    displayName: string | undefined;
}

export class PagedResultDtoOfGetEventAmountSettingForView implements IPagedResultDtoOfGetEventAmountSettingForView {
    totalCount!: number | undefined;
    items!: GetEventAmountSettingForView[] | undefined;

    constructor(data?: IPagedResultDtoOfGetEventAmountSettingForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetEventAmountSettingForView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetEventAmountSettingForView {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetEventAmountSettingForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetEventAmountSettingForView {
    totalCount: number | undefined;
    items: GetEventAmountSettingForView[] | undefined;
}

export class GetEventAmountSettingForView implements IGetEventAmountSettingForView {
    eventAmountSetting!: EventAmountSettingDto | undefined;

    constructor(data?: IGetEventAmountSettingForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.eventAmountSetting = data["eventAmountSetting"] ? EventAmountSettingDto.fromJS(data["eventAmountSetting"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetEventAmountSettingForView {
        data = typeof data === 'object' ? data : {};
        let result = new GetEventAmountSettingForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eventAmountSetting"] = this.eventAmountSetting ? this.eventAmountSetting.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetEventAmountSettingForView {
    eventAmountSetting: EventAmountSettingDto | undefined;
}

export class EventAmountSettingDto implements IEventAmountSettingDto {
    eventSettingCode!: string | undefined;
    amount!: number | undefined;
    coinValue!: number | undefined;
    pointValue!: number | undefined;
    id!: number | undefined;

    constructor(data?: IEventAmountSettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.eventSettingCode = data["eventSettingCode"];
            this.amount = data["amount"];
            this.coinValue = data["coinValue"];
            this.pointValue = data["pointValue"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EventAmountSettingDto {
        data = typeof data === 'object' ? data : {};
        let result = new EventAmountSettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eventSettingCode"] = this.eventSettingCode;
        data["amount"] = this.amount;
        data["coinValue"] = this.coinValue;
        data["pointValue"] = this.pointValue;
        data["id"] = this.id;
        return data;
    }
}

export interface IEventAmountSettingDto {
    eventSettingCode: string | undefined;
    amount: number | undefined;
    coinValue: number | undefined;
    pointValue: number | undefined;
    id: number | undefined;
}

export class GetEventAmountSettingForEditOutput implements IGetEventAmountSettingForEditOutput {
    eventAmountSetting!: CreateOrEditEventAmountSettingDto | undefined;

    constructor(data?: IGetEventAmountSettingForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.eventAmountSetting = data["eventAmountSetting"] ? CreateOrEditEventAmountSettingDto.fromJS(data["eventAmountSetting"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetEventAmountSettingForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetEventAmountSettingForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eventAmountSetting"] = this.eventAmountSetting ? this.eventAmountSetting.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetEventAmountSettingForEditOutput {
    eventAmountSetting: CreateOrEditEventAmountSettingDto | undefined;
}

export class PagedResultDtoOfGetEventSettingForView implements IPagedResultDtoOfGetEventSettingForView {
    totalCount!: number | undefined;
    items!: GetEventSettingForView[] | undefined;

    constructor(data?: IPagedResultDtoOfGetEventSettingForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetEventSettingForView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetEventSettingForView {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetEventSettingForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetEventSettingForView {
    totalCount: number | undefined;
    items: GetEventSettingForView[] | undefined;
}

export class GetEventSettingForView implements IGetEventSettingForView {
    eventSetting!: EventSettingDto | undefined;

    constructor(data?: IGetEventSettingForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.eventSetting = data["eventSetting"] ? EventSettingDto.fromJS(data["eventSetting"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetEventSettingForView {
        data = typeof data === 'object' ? data : {};
        let result = new GetEventSettingForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eventSetting"] = this.eventSetting ? this.eventSetting.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetEventSettingForView {
    eventSetting: EventSettingDto | undefined;
}

export class EventSettingDto implements IEventSettingDto {
    code!: string | undefined;
    name!: string | undefined;
    description!: string | undefined;
    effectiveFrom!: moment.Moment | undefined;
    effectiveTo!: moment.Moment | undefined;
    startTime!: string | undefined;
    endTime!: string | undefined;
    cron!: string | undefined;
    isActive!: boolean | undefined;
    targetAudience!: SettingParamDto | undefined;
    timeZone!: string | undefined;
    campaign!: string | undefined;
    amounts!: EventAmountSettingDto[] | undefined;
    targetAudienceCode!: string | undefined;
    id!: number | undefined;

    constructor(data?: IEventSettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.name = data["name"];
            this.description = data["description"];
            this.effectiveFrom = data["effectiveFrom"] ? moment(data["effectiveFrom"].toString()) : <any>undefined;
            this.effectiveTo = data["effectiveTo"] ? moment(data["effectiveTo"].toString()) : <any>undefined;
            this.startTime = data["startTime"];
            this.endTime = data["endTime"];
            this.cron = data["cron"];
            this.isActive = data["isActive"];
            this.targetAudience = data["targetAudience"] ? SettingParamDto.fromJS(data["targetAudience"]) : <any>undefined;
            this.timeZone = data["timeZone"];
            this.campaign = data["campaign"];
            if (data["amounts"] && data["amounts"].constructor === Array) {
                this.amounts = [];
                for (let item of data["amounts"])
                    this.amounts.push(EventAmountSettingDto.fromJS(item));
            }
            this.targetAudienceCode = data["targetAudienceCode"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EventSettingDto {
        data = typeof data === 'object' ? data : {};
        let result = new EventSettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["description"] = this.description;
        data["effectiveFrom"] = this.effectiveFrom ? this.effectiveFrom.toISOString() : <any>undefined;
        data["effectiveTo"] = this.effectiveTo ? this.effectiveTo.toISOString() : <any>undefined;
        data["startTime"] = this.startTime;
        data["endTime"] = this.endTime;
        data["cron"] = this.cron;
        data["isActive"] = this.isActive;
        data["targetAudience"] = this.targetAudience ? this.targetAudience.toJSON() : <any>undefined;
        data["timeZone"] = this.timeZone;
        data["campaign"] = this.campaign;
        if (this.amounts && this.amounts.constructor === Array) {
            data["amounts"] = [];
            for (let item of this.amounts)
                data["amounts"].push(item.toJSON());
        }
        data["targetAudienceCode"] = this.targetAudienceCode;
        data["id"] = this.id;
        return data;
    }
}

export interface IEventSettingDto {
    code: string | undefined;
    name: string | undefined;
    description: string | undefined;
    effectiveFrom: moment.Moment | undefined;
    effectiveTo: moment.Moment | undefined;
    startTime: string | undefined;
    endTime: string | undefined;
    cron: string | undefined;
    isActive: boolean | undefined;
    targetAudience: SettingParamDto | undefined;
    timeZone: string | undefined;
    campaign: string | undefined;
    amounts: EventAmountSettingDto[] | undefined;
    targetAudienceCode: string | undefined;
    id: number | undefined;
}

export class GetEventSettingForEditOutput implements IGetEventSettingForEditOutput {
    eventSetting!: CreateOrEditEventSettingDto | undefined;

    constructor(data?: IGetEventSettingForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.eventSetting = data["eventSetting"] ? CreateOrEditEventSettingDto.fromJS(data["eventSetting"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetEventSettingForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetEventSettingForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eventSetting"] = this.eventSetting ? this.eventSetting.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetEventSettingForEditOutput {
    eventSetting: CreateOrEditEventSettingDto | undefined;
}

export class ListResultDtoOfEventSettingDto implements IListResultDtoOfEventSettingDto {
    items!: EventSettingDto[] | undefined;

    constructor(data?: IListResultDtoOfEventSettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(EventSettingDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfEventSettingDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfEventSettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListResultDtoOfEventSettingDto {
    items: EventSettingDto[] | undefined;
}

export class PagedResultDtoOfGetEventSubscriptionDetailForView implements IPagedResultDtoOfGetEventSubscriptionDetailForView {
    totalCount!: number | undefined;
    items!: GetEventSubscriptionDetailForView[] | undefined;

    constructor(data?: IPagedResultDtoOfGetEventSubscriptionDetailForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetEventSubscriptionDetailForView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetEventSubscriptionDetailForView {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetEventSubscriptionDetailForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetEventSubscriptionDetailForView {
    totalCount: number | undefined;
    items: GetEventSubscriptionDetailForView[] | undefined;
}

export class GetEventSubscriptionDetailForView implements IGetEventSubscriptionDetailForView {
    eventSubscriptionDetail!: EventSubscriptionDetailDto | undefined;

    constructor(data?: IGetEventSubscriptionDetailForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.eventSubscriptionDetail = data["eventSubscriptionDetail"] ? EventSubscriptionDetailDto.fromJS(data["eventSubscriptionDetail"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetEventSubscriptionDetailForView {
        data = typeof data === 'object' ? data : {};
        let result = new GetEventSubscriptionDetailForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eventSubscriptionDetail"] = this.eventSubscriptionDetail ? this.eventSubscriptionDetail.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetEventSubscriptionDetailForView {
    eventSubscriptionDetail: EventSubscriptionDetailDto | undefined;
}

export class EventSubscriptionDetailDto implements IEventSubscriptionDetailDto {
    eventTemplateID!: string | undefined;
    eventTemplateGroup!: string | undefined;
    id!: number | undefined;

    constructor(data?: IEventSubscriptionDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.eventTemplateID = data["eventTemplateID"];
            this.eventTemplateGroup = data["eventTemplateGroup"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EventSubscriptionDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new EventSubscriptionDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eventTemplateID"] = this.eventTemplateID;
        data["eventTemplateGroup"] = this.eventTemplateGroup;
        data["id"] = this.id;
        return data;
    }
}

export interface IEventSubscriptionDetailDto {
    eventTemplateID: string | undefined;
    eventTemplateGroup: string | undefined;
    id: number | undefined;
}

export class GetEventSubscriptionDetailForEditOutput implements IGetEventSubscriptionDetailForEditOutput {
    eventSubscriptionDetail!: CreateOrEditEventSubscriptionDetailDto | undefined;

    constructor(data?: IGetEventSubscriptionDetailForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.eventSubscriptionDetail = data["eventSubscriptionDetail"] ? CreateOrEditEventSubscriptionDetailDto.fromJS(data["eventSubscriptionDetail"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetEventSubscriptionDetailForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetEventSubscriptionDetailForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eventSubscriptionDetail"] = this.eventSubscriptionDetail ? this.eventSubscriptionDetail.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetEventSubscriptionDetailForEditOutput {
    eventSubscriptionDetail: CreateOrEditEventSubscriptionDetailDto | undefined;
}

export class CreateOrEditEventSubscriptionDetailDto implements ICreateOrEditEventSubscriptionDetailDto {
    eventTemplateID!: string | undefined;
    eventTemplateGroup!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditEventSubscriptionDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.eventTemplateID = data["eventTemplateID"];
            this.eventTemplateGroup = data["eventTemplateGroup"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditEventSubscriptionDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditEventSubscriptionDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eventTemplateID"] = this.eventTemplateID;
        data["eventTemplateGroup"] = this.eventTemplateGroup;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditEventSubscriptionDetailDto {
    eventTemplateID: string | undefined;
    eventTemplateGroup: string | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfGetEventSubscriptionHeaderForView implements IPagedResultDtoOfGetEventSubscriptionHeaderForView {
    totalCount!: number | undefined;
    items!: GetEventSubscriptionHeaderForView[] | undefined;

    constructor(data?: IPagedResultDtoOfGetEventSubscriptionHeaderForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetEventSubscriptionHeaderForView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetEventSubscriptionHeaderForView {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetEventSubscriptionHeaderForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetEventSubscriptionHeaderForView {
    totalCount: number | undefined;
    items: GetEventSubscriptionHeaderForView[] | undefined;
}

export class GetEventSubscriptionHeaderForView implements IGetEventSubscriptionHeaderForView {
    eventSubscriptionHeader!: EventSubscriptionHeaderDto | undefined;
    settingParamCode!: string | undefined;

    constructor(data?: IGetEventSubscriptionHeaderForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.eventSubscriptionHeader = data["eventSubscriptionHeader"] ? EventSubscriptionHeaderDto.fromJS(data["eventSubscriptionHeader"]) : <any>undefined;
            this.settingParamCode = data["settingParamCode"];
        }
    }

    static fromJS(data: any): GetEventSubscriptionHeaderForView {
        data = typeof data === 'object' ? data : {};
        let result = new GetEventSubscriptionHeaderForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eventSubscriptionHeader"] = this.eventSubscriptionHeader ? this.eventSubscriptionHeader.toJSON() : <any>undefined;
        data["settingParamCode"] = this.settingParamCode;
        return data;
    }
}

export interface IGetEventSubscriptionHeaderForView {
    eventSubscriptionHeader: EventSubscriptionHeaderDto | undefined;
    settingParamCode: string | undefined;
}

export class EventSubscriptionHeaderDto implements IEventSubscriptionHeaderDto {
    isActive!: boolean | undefined;
    secretKey!: string | undefined;
    url!: string | undefined;
    description!: string | undefined;
    settingParam!: SettingParamDto | undefined;
    settingParamId!: number | undefined;
    id!: number | undefined;

    constructor(data?: IEventSubscriptionHeaderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isActive = data["isActive"];
            this.secretKey = data["secretKey"];
            this.url = data["url"];
            this.description = data["description"];
            this.settingParam = data["settingParam"] ? SettingParamDto.fromJS(data["settingParam"]) : <any>undefined;
            this.settingParamId = data["settingParamId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EventSubscriptionHeaderDto {
        data = typeof data === 'object' ? data : {};
        let result = new EventSubscriptionHeaderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isActive"] = this.isActive;
        data["secretKey"] = this.secretKey;
        data["url"] = this.url;
        data["description"] = this.description;
        data["settingParam"] = this.settingParam ? this.settingParam.toJSON() : <any>undefined;
        data["settingParamId"] = this.settingParamId;
        data["id"] = this.id;
        return data;
    }
}

export interface IEventSubscriptionHeaderDto {
    isActive: boolean | undefined;
    secretKey: string | undefined;
    url: string | undefined;
    description: string | undefined;
    settingParam: SettingParamDto | undefined;
    settingParamId: number | undefined;
    id: number | undefined;
}

export class GetEventSubscriptionHeaderForEditOutput implements IGetEventSubscriptionHeaderForEditOutput {
    eventSubscriptionHeader!: CreateOrEditEventSubscriptionHeaderDto | undefined;
    settingParamCode!: string | undefined;

    constructor(data?: IGetEventSubscriptionHeaderForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.eventSubscriptionHeader = data["eventSubscriptionHeader"] ? CreateOrEditEventSubscriptionHeaderDto.fromJS(data["eventSubscriptionHeader"]) : <any>undefined;
            this.settingParamCode = data["settingParamCode"];
        }
    }

    static fromJS(data: any): GetEventSubscriptionHeaderForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetEventSubscriptionHeaderForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eventSubscriptionHeader"] = this.eventSubscriptionHeader ? this.eventSubscriptionHeader.toJSON() : <any>undefined;
        data["settingParamCode"] = this.settingParamCode;
        return data;
    }
}

export interface IGetEventSubscriptionHeaderForEditOutput {
    eventSubscriptionHeader: CreateOrEditEventSubscriptionHeaderDto | undefined;
    settingParamCode: string | undefined;
}

export class CreateOrEditEventSubscriptionHeaderDto implements ICreateOrEditEventSubscriptionHeaderDto {
    isActive!: boolean | undefined;
    secretKey!: string;
    url!: string | undefined;
    description!: string | undefined;
    settingParamId!: number | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastUpdateByName!: string | undefined;
    lastModifierUserId!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditEventSubscriptionHeaderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isActive = data["isActive"];
            this.secretKey = data["secretKey"];
            this.url = data["url"];
            this.description = data["description"];
            this.settingParamId = data["settingParamId"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastUpdateByName = data["lastUpdateByName"];
            this.lastModifierUserId = data["lastModifierUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditEventSubscriptionHeaderDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditEventSubscriptionHeaderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isActive"] = this.isActive;
        data["secretKey"] = this.secretKey;
        data["url"] = this.url;
        data["description"] = this.description;
        data["settingParamId"] = this.settingParamId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastUpdateByName"] = this.lastUpdateByName;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditEventSubscriptionHeaderDto {
    isActive: boolean | undefined;
    secretKey: string;
    url: string | undefined;
    description: string | undefined;
    settingParamId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastUpdateByName: string | undefined;
    lastModifierUserId: number | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfExtendActiveSerialDto implements IPagedResultDtoOfExtendActiveSerialDto {
    totalCount!: number | undefined;
    items!: ExtendActiveSerialDto[] | undefined;

    constructor(data?: IPagedResultDtoOfExtendActiveSerialDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(ExtendActiveSerialDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfExtendActiveSerialDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfExtendActiveSerialDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfExtendActiveSerialDto {
    totalCount: number | undefined;
    items: ExtendActiveSerialDto[] | undefined;
}

export class ExtendActiveSerialDto implements IExtendActiveSerialDto {
    serial!: string | undefined;
    effectSellNPP!: moment.Moment | undefined;
    effectSellVipShop!: moment.Moment | undefined;
    effectSellMBS!: moment.Moment | undefined;
    effectSellSellout!: moment.Moment | undefined;
    proposalNo!: string | undefined;
    submitter!: string | undefined;
    approver!: string | undefined;
    approvalDate!: moment.Moment | undefined;
    creationTime!: moment.Moment | undefined;
    id!: number | undefined;

    constructor(data?: IExtendActiveSerialDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.serial = data["serial"];
            this.effectSellNPP = data["effectSellNPP"] ? moment(data["effectSellNPP"].toString()) : <any>undefined;
            this.effectSellVipShop = data["effectSellVipShop"] ? moment(data["effectSellVipShop"].toString()) : <any>undefined;
            this.effectSellMBS = data["effectSellMBS"] ? moment(data["effectSellMBS"].toString()) : <any>undefined;
            this.effectSellSellout = data["effectSellSellout"] ? moment(data["effectSellSellout"].toString()) : <any>undefined;
            this.proposalNo = data["proposalNo"];
            this.submitter = data["submitter"];
            this.approver = data["approver"];
            this.approvalDate = data["approvalDate"] ? moment(data["approvalDate"].toString()) : <any>undefined;
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ExtendActiveSerialDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExtendActiveSerialDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serial"] = this.serial;
        data["effectSellNPP"] = this.effectSellNPP ? this.effectSellNPP.toISOString() : <any>undefined;
        data["effectSellVipShop"] = this.effectSellVipShop ? this.effectSellVipShop.toISOString() : <any>undefined;
        data["effectSellMBS"] = this.effectSellMBS ? this.effectSellMBS.toISOString() : <any>undefined;
        data["effectSellSellout"] = this.effectSellSellout ? this.effectSellSellout.toISOString() : <any>undefined;
        data["proposalNo"] = this.proposalNo;
        data["submitter"] = this.submitter;
        data["approver"] = this.approver;
        data["approvalDate"] = this.approvalDate ? this.approvalDate.toISOString() : <any>undefined;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IExtendActiveSerialDto {
    serial: string | undefined;
    effectSellNPP: moment.Moment | undefined;
    effectSellVipShop: moment.Moment | undefined;
    effectSellMBS: moment.Moment | undefined;
    effectSellSellout: moment.Moment | undefined;
    proposalNo: string | undefined;
    submitter: string | undefined;
    approver: string | undefined;
    approvalDate: moment.Moment | undefined;
    creationTime: moment.Moment | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfGetFAQForView implements IPagedResultDtoOfGetFAQForView {
    totalCount!: number | undefined;
    items!: GetFAQForView[] | undefined;

    constructor(data?: IPagedResultDtoOfGetFAQForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetFAQForView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetFAQForView {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetFAQForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetFAQForView {
    totalCount: number | undefined;
    items: GetFAQForView[] | undefined;
}

export class GetFAQForView implements IGetFAQForView {
    faq!: FAQDto | undefined;
    lastModifierUserName!: string | undefined;

    constructor(data?: IGetFAQForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.faq = data["faq"] ? FAQDto.fromJS(data["faq"]) : <any>undefined;
            this.lastModifierUserName = data["lastModifierUserName"];
        }
    }

    static fromJS(data: any): GetFAQForView {
        data = typeof data === 'object' ? data : {};
        let result = new GetFAQForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["faq"] = this.faq ? this.faq.toJSON() : <any>undefined;
        data["lastModifierUserName"] = this.lastModifierUserName;
        return data;
    }
}

export interface IGetFAQForView {
    faq: FAQDto | undefined;
    lastModifierUserName: string | undefined;
}

export class FAQDto implements IFAQDto {
    code!: string | undefined;
    ordinal!: number | undefined;
    translations!: FAQTranslationDto[] | undefined;
    isDeleted!: boolean | undefined;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: moment.Moment | undefined;
    creatorUserId!: number | undefined;
    id!: number | undefined;

    constructor(data?: IFAQDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.ordinal = data["ordinal"];
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(FAQTranslationDto.fromJS(item));
            }
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): FAQDto {
        data = typeof data === 'object' ? data : {};
        let result = new FAQDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["ordinal"] = this.ordinal;
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IFAQDto {
    code: string | undefined;
    ordinal: number | undefined;
    translations: FAQTranslationDto[] | undefined;
    isDeleted: boolean | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class FAQTranslationDto implements IFAQTranslationDto {
    tenantId!: number | undefined;
    question!: string | undefined;
    answer!: string | undefined;
    language!: string | undefined;
    id!: number | undefined;

    constructor(data?: IFAQTranslationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.question = data["question"];
            this.answer = data["answer"];
            this.language = data["language"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): FAQTranslationDto {
        data = typeof data === 'object' ? data : {};
        let result = new FAQTranslationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["question"] = this.question;
        data["answer"] = this.answer;
        data["language"] = this.language;
        data["id"] = this.id;
        return data;
    }
}

export interface IFAQTranslationDto {
    tenantId: number | undefined;
    question: string | undefined;
    answer: string | undefined;
    language: string | undefined;
    id: number | undefined;
}

export class GetFAQForEditOutput implements IGetFAQForEditOutput {
    faq!: CreateOrEditFAQDto | undefined;
    lastModifierUserName!: string | undefined;

    constructor(data?: IGetFAQForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.faq = data["faq"] ? CreateOrEditFAQDto.fromJS(data["faq"]) : <any>undefined;
            this.lastModifierUserName = data["lastModifierUserName"];
        }
    }

    static fromJS(data: any): GetFAQForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetFAQForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["faq"] = this.faq ? this.faq.toJSON() : <any>undefined;
        data["lastModifierUserName"] = this.lastModifierUserName;
        return data;
    }
}

export interface IGetFAQForEditOutput {
    faq: CreateOrEditFAQDto | undefined;
    lastModifierUserName: string | undefined;
}

export class CreateOrEditFAQDto implements ICreateOrEditFAQDto {
    tenantId!: number | undefined;
    code!: string | undefined;
    ordinal!: number | undefined;
    translations!: FAQTranslationDto[] | undefined;
    isDeleted!: boolean | undefined;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: moment.Moment | undefined;
    creatorUserId!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditFAQDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.code = data["code"];
            this.ordinal = data["ordinal"];
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(FAQTranslationDto.fromJS(item));
            }
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditFAQDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditFAQDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["code"] = this.code;
        data["ordinal"] = this.ordinal;
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditFAQDto {
    tenantId: number | undefined;
    code: string | undefined;
    ordinal: number | undefined;
    translations: FAQTranslationDto[] | undefined;
    isDeleted: boolean | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class IFormFile implements IIFormFile {
    contentType!: string | undefined;
    contentDisposition!: string | undefined;
    headers!: { [key: string]: string[]; } | undefined;
    length!: number | undefined;
    name!: string | undefined;
    fileName!: string | undefined;

    constructor(data?: IIFormFile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.contentType = data["contentType"];
            this.contentDisposition = data["contentDisposition"];
            if (data["headers"]) {
                this.headers = {};
                for (let key in data["headers"]) {
                    if (data["headers"].hasOwnProperty(key))
                        this.headers[key] = data["headers"][key] !== undefined ? data["headers"][key] : [];
                }
            }
            this.length = data["length"];
            this.name = data["name"];
            this.fileName = data["fileName"];
        }
    }

    static fromJS(data: any): IFormFile {
        data = typeof data === 'object' ? data : {};
        let result = new IFormFile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contentType"] = this.contentType;
        data["contentDisposition"] = this.contentDisposition;
        if (this.headers) {
            data["headers"] = {};
            for (let key in this.headers) {
                if (this.headers.hasOwnProperty(key))
                    data["headers"][key] = this.headers[key];
            }
        }
        data["length"] = this.length;
        data["name"] = this.name;
        data["fileName"] = this.fileName;
        return data;
    }
}

export interface IIFormFile {
    contentType: string | undefined;
    contentDisposition: string | undefined;
    headers: { [key: string]: string[]; } | undefined;
    length: number | undefined;
    name: string | undefined;
    fileName: string | undefined;
}

export class PagedResultDtoOfGetFormulaSettingForView implements IPagedResultDtoOfGetFormulaSettingForView {
    totalCount!: number | undefined;
    items!: GetFormulaSettingForView[] | undefined;

    constructor(data?: IPagedResultDtoOfGetFormulaSettingForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetFormulaSettingForView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetFormulaSettingForView {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetFormulaSettingForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetFormulaSettingForView {
    totalCount: number | undefined;
    items: GetFormulaSettingForView[] | undefined;
}

export class GetFormulaSettingForView implements IGetFormulaSettingForView {
    formulaSetting!: FormulaSettingDto | undefined;

    constructor(data?: IGetFormulaSettingForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.formulaSetting = data["formulaSetting"] ? FormulaSettingDto.fromJS(data["formulaSetting"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetFormulaSettingForView {
        data = typeof data === 'object' ? data : {};
        let result = new GetFormulaSettingForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formulaSetting"] = this.formulaSetting ? this.formulaSetting.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetFormulaSettingForView {
    formulaSetting: FormulaSettingDto | undefined;
}

export class FormulaSettingDto implements IFormulaSettingDto {
    code!: string | undefined;
    defaultBasePoint!: number | undefined;
    defaultBaseCoin!: number | undefined;
    defaultEventPoint!: number | undefined;
    defaultEventCoin!: number | undefined;
    defaultProductCategoryPoint!: number | undefined;
    defaultProductCategoryCoin!: number | undefined;
    defaultSpecialPoint!: number | undefined;
    defaultSpecialCoin!: number | undefined;
    defaultProductPoint!: number | undefined;
    defaultProductCoin!: number | undefined;
    defaultRankPoint!: number | undefined;
    defaultRankCoin!: number | undefined;
    fomula!: string | undefined;
    defaultReturnBasePoint!: number | undefined;
    defaultReturnBaseCoin!: number | undefined;
    id!: number | undefined;

    constructor(data?: IFormulaSettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.defaultBasePoint = data["defaultBasePoint"];
            this.defaultBaseCoin = data["defaultBaseCoin"];
            this.defaultEventPoint = data["defaultEventPoint"];
            this.defaultEventCoin = data["defaultEventCoin"];
            this.defaultProductCategoryPoint = data["defaultProductCategoryPoint"];
            this.defaultProductCategoryCoin = data["defaultProductCategoryCoin"];
            this.defaultSpecialPoint = data["defaultSpecialPoint"];
            this.defaultSpecialCoin = data["defaultSpecialCoin"];
            this.defaultProductPoint = data["defaultProductPoint"];
            this.defaultProductCoin = data["defaultProductCoin"];
            this.defaultRankPoint = data["defaultRankPoint"];
            this.defaultRankCoin = data["defaultRankCoin"];
            this.fomula = data["fomula"];
            this.defaultReturnBasePoint = data["defaultReturnBasePoint"];
            this.defaultReturnBaseCoin = data["defaultReturnBaseCoin"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): FormulaSettingDto {
        data = typeof data === 'object' ? data : {};
        let result = new FormulaSettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["defaultBasePoint"] = this.defaultBasePoint;
        data["defaultBaseCoin"] = this.defaultBaseCoin;
        data["defaultEventPoint"] = this.defaultEventPoint;
        data["defaultEventCoin"] = this.defaultEventCoin;
        data["defaultProductCategoryPoint"] = this.defaultProductCategoryPoint;
        data["defaultProductCategoryCoin"] = this.defaultProductCategoryCoin;
        data["defaultSpecialPoint"] = this.defaultSpecialPoint;
        data["defaultSpecialCoin"] = this.defaultSpecialCoin;
        data["defaultProductPoint"] = this.defaultProductPoint;
        data["defaultProductCoin"] = this.defaultProductCoin;
        data["defaultRankPoint"] = this.defaultRankPoint;
        data["defaultRankCoin"] = this.defaultRankCoin;
        data["fomula"] = this.fomula;
        data["defaultReturnBasePoint"] = this.defaultReturnBasePoint;
        data["defaultReturnBaseCoin"] = this.defaultReturnBaseCoin;
        data["id"] = this.id;
        return data;
    }
}

export interface IFormulaSettingDto {
    code: string | undefined;
    defaultBasePoint: number | undefined;
    defaultBaseCoin: number | undefined;
    defaultEventPoint: number | undefined;
    defaultEventCoin: number | undefined;
    defaultProductCategoryPoint: number | undefined;
    defaultProductCategoryCoin: number | undefined;
    defaultSpecialPoint: number | undefined;
    defaultSpecialCoin: number | undefined;
    defaultProductPoint: number | undefined;
    defaultProductCoin: number | undefined;
    defaultRankPoint: number | undefined;
    defaultRankCoin: number | undefined;
    fomula: string | undefined;
    defaultReturnBasePoint: number | undefined;
    defaultReturnBaseCoin: number | undefined;
    id: number | undefined;
}

export class GetFormulaSettingForEditOutput implements IGetFormulaSettingForEditOutput {
    formulaSetting!: CreateOrEditFormulaSettingDto | undefined;

    constructor(data?: IGetFormulaSettingForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.formulaSetting = data["formulaSetting"] ? CreateOrEditFormulaSettingDto.fromJS(data["formulaSetting"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetFormulaSettingForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetFormulaSettingForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formulaSetting"] = this.formulaSetting ? this.formulaSetting.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetFormulaSettingForEditOutput {
    formulaSetting: CreateOrEditFormulaSettingDto | undefined;
}

export class CreateOrEditFormulaSettingDto implements ICreateOrEditFormulaSettingDto {
    code!: string | undefined;
    defaultBasePoint!: number | undefined;
    defaultBaseCoin!: number | undefined;
    defaultEventPoint!: number | undefined;
    defaultEventCoin!: number | undefined;
    defaultProductCategoryPoint!: number | undefined;
    defaultProductCategoryCoin!: number | undefined;
    defaultSpecialPoint!: number | undefined;
    defaultSpecialCoin!: number | undefined;
    defaultProductPoint!: number | undefined;
    defaultProductCoin!: number | undefined;
    defaultRankPoint!: number | undefined;
    defaultRankCoin!: number | undefined;
    fomula!: string | undefined;
    isActive!: boolean | undefined;
    defaultReturnBasePoint!: number | undefined;
    defaultReturnBaseCoin!: number | undefined;
    lastUpdateByName!: string | undefined;
    isDeleted!: boolean | undefined;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: moment.Moment | undefined;
    creatorUserId!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditFormulaSettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.defaultBasePoint = data["defaultBasePoint"];
            this.defaultBaseCoin = data["defaultBaseCoin"];
            this.defaultEventPoint = data["defaultEventPoint"];
            this.defaultEventCoin = data["defaultEventCoin"];
            this.defaultProductCategoryPoint = data["defaultProductCategoryPoint"];
            this.defaultProductCategoryCoin = data["defaultProductCategoryCoin"];
            this.defaultSpecialPoint = data["defaultSpecialPoint"];
            this.defaultSpecialCoin = data["defaultSpecialCoin"];
            this.defaultProductPoint = data["defaultProductPoint"];
            this.defaultProductCoin = data["defaultProductCoin"];
            this.defaultRankPoint = data["defaultRankPoint"];
            this.defaultRankCoin = data["defaultRankCoin"];
            this.fomula = data["fomula"];
            this.isActive = data["isActive"];
            this.defaultReturnBasePoint = data["defaultReturnBasePoint"];
            this.defaultReturnBaseCoin = data["defaultReturnBaseCoin"];
            this.lastUpdateByName = data["lastUpdateByName"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditFormulaSettingDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditFormulaSettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["defaultBasePoint"] = this.defaultBasePoint;
        data["defaultBaseCoin"] = this.defaultBaseCoin;
        data["defaultEventPoint"] = this.defaultEventPoint;
        data["defaultEventCoin"] = this.defaultEventCoin;
        data["defaultProductCategoryPoint"] = this.defaultProductCategoryPoint;
        data["defaultProductCategoryCoin"] = this.defaultProductCategoryCoin;
        data["defaultSpecialPoint"] = this.defaultSpecialPoint;
        data["defaultSpecialCoin"] = this.defaultSpecialCoin;
        data["defaultProductPoint"] = this.defaultProductPoint;
        data["defaultProductCoin"] = this.defaultProductCoin;
        data["defaultRankPoint"] = this.defaultRankPoint;
        data["defaultRankCoin"] = this.defaultRankCoin;
        data["fomula"] = this.fomula;
        data["isActive"] = this.isActive;
        data["defaultReturnBasePoint"] = this.defaultReturnBasePoint;
        data["defaultReturnBaseCoin"] = this.defaultReturnBaseCoin;
        data["lastUpdateByName"] = this.lastUpdateByName;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditFormulaSettingDto {
    code: string | undefined;
    defaultBasePoint: number | undefined;
    defaultBaseCoin: number | undefined;
    defaultEventPoint: number | undefined;
    defaultEventCoin: number | undefined;
    defaultProductCategoryPoint: number | undefined;
    defaultProductCategoryCoin: number | undefined;
    defaultSpecialPoint: number | undefined;
    defaultSpecialCoin: number | undefined;
    defaultProductPoint: number | undefined;
    defaultProductCoin: number | undefined;
    defaultRankPoint: number | undefined;
    defaultRankCoin: number | undefined;
    fomula: string | undefined;
    isActive: boolean | undefined;
    defaultReturnBasePoint: number | undefined;
    defaultReturnBaseCoin: number | undefined;
    lastUpdateByName: string | undefined;
    isDeleted: boolean | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class CreateFriendshipRequestInput implements ICreateFriendshipRequestInput {
    userId!: number | undefined;
    tenantId!: number | undefined;

    constructor(data?: ICreateFriendshipRequestInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userId = data["userId"];
            this.tenantId = data["tenantId"];
        }
    }

    static fromJS(data: any): CreateFriendshipRequestInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFriendshipRequestInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        return data;
    }
}

export interface ICreateFriendshipRequestInput {
    userId: number | undefined;
    tenantId: number | undefined;
}

export class CreateFriendshipRequestByUserNameInput implements ICreateFriendshipRequestByUserNameInput {
    tenancyName!: string;
    userName!: string | undefined;

    constructor(data?: ICreateFriendshipRequestByUserNameInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenancyName = data["tenancyName"];
            this.userName = data["userName"];
        }
    }

    static fromJS(data: any): CreateFriendshipRequestByUserNameInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFriendshipRequestByUserNameInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["userName"] = this.userName;
        return data;
    }
}

export interface ICreateFriendshipRequestByUserNameInput {
    tenancyName: string;
    userName: string | undefined;
}

export class BlockUserInput implements IBlockUserInput {
    userId!: number | undefined;
    tenantId!: number | undefined;

    constructor(data?: IBlockUserInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userId = data["userId"];
            this.tenantId = data["tenantId"];
        }
    }

    static fromJS(data: any): BlockUserInput {
        data = typeof data === 'object' ? data : {};
        let result = new BlockUserInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        return data;
    }
}

export interface IBlockUserInput {
    userId: number | undefined;
    tenantId: number | undefined;
}

export class UnblockUserInput implements IUnblockUserInput {
    userId!: number | undefined;
    tenantId!: number | undefined;

    constructor(data?: IUnblockUserInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userId = data["userId"];
            this.tenantId = data["tenantId"];
        }
    }

    static fromJS(data: any): UnblockUserInput {
        data = typeof data === 'object' ? data : {};
        let result = new UnblockUserInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        return data;
    }
}

export interface IUnblockUserInput {
    userId: number | undefined;
    tenantId: number | undefined;
}

export class AcceptFriendshipRequestInput implements IAcceptFriendshipRequestInput {
    userId!: number | undefined;
    tenantId!: number | undefined;

    constructor(data?: IAcceptFriendshipRequestInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userId = data["userId"];
            this.tenantId = data["tenantId"];
        }
    }

    static fromJS(data: any): AcceptFriendshipRequestInput {
        data = typeof data === 'object' ? data : {};
        let result = new AcceptFriendshipRequestInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        return data;
    }
}

export interface IAcceptFriendshipRequestInput {
    userId: number | undefined;
    tenantId: number | undefined;
}

export class GameGotItArgs implements IGameGotItArgs {
    gameGotItIssueOutput!: GameGotItIssueOutput | undefined;
    promotionInfo!: PromotionInfo | undefined;
    key!: string | undefined;

    constructor(data?: IGameGotItArgs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.gameGotItIssueOutput = data["gameGotItIssueOutput"] ? GameGotItIssueOutput.fromJS(data["gameGotItIssueOutput"]) : <any>undefined;
            this.promotionInfo = data["promotionInfo"] ? PromotionInfo.fromJS(data["promotionInfo"]) : <any>undefined;
            this.key = data["key"];
        }
    }

    static fromJS(data: any): GameGotItArgs {
        data = typeof data === 'object' ? data : {};
        let result = new GameGotItArgs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gameGotItIssueOutput"] = this.gameGotItIssueOutput ? this.gameGotItIssueOutput.toJSON() : <any>undefined;
        data["promotionInfo"] = this.promotionInfo ? this.promotionInfo.toJSON() : <any>undefined;
        data["key"] = this.key;
        return data;
    }
}

export interface IGameGotItArgs {
    gameGotItIssueOutput: GameGotItIssueOutput | undefined;
    promotionInfo: PromotionInfo | undefined;
    key: string | undefined;
}

export class GameGotItIssueOutput implements IGameGotItIssueOutput {
    status!: number | undefined;
    phone!: string | undefined;
    url!: string | undefined;
    spin_num!: number | undefined;
    action!: string | undefined;
    timestamp!: string | undefined;
    check_sum!: string | undefined;

    constructor(data?: IGameGotItIssueOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.status = data["status"];
            this.phone = data["phone"];
            this.url = data["url"];
            this.spin_num = data["spin_num"];
            this.action = data["action"];
            this.timestamp = data["timestamp"];
            this.check_sum = data["check_sum"];
        }
    }

    static fromJS(data: any): GameGotItIssueOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GameGotItIssueOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["phone"] = this.phone;
        data["url"] = this.url;
        data["spin_num"] = this.spin_num;
        data["action"] = this.action;
        data["timestamp"] = this.timestamp;
        data["check_sum"] = this.check_sum;
        return data;
    }
}

export interface IGameGotItIssueOutput {
    status: number | undefined;
    phone: string | undefined;
    url: string | undefined;
    spin_num: number | undefined;
    action: string | undefined;
    timestamp: string | undefined;
    check_sum: string | undefined;
}

export class PromotionInfo implements IPromotionInfo {
    productCode!: string | undefined;
    campaignId!: string | undefined;
    quantity!: number | undefined;
    campaignName!: string | undefined;
    description!: string | undefined;
    fromDate!: moment.Moment | undefined;
    toDate!: moment.Moment | undefined;
    promotionMasterCode!: string | undefined;
    promotionCode!: string | undefined;
    status!: string | undefined;

    constructor(data?: IPromotionInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.productCode = data["productCode"];
            this.campaignId = data["campaignId"];
            this.quantity = data["quantity"];
            this.campaignName = data["campaignName"];
            this.description = data["description"];
            this.fromDate = data["fromDate"] ? moment(data["fromDate"].toString()) : <any>undefined;
            this.toDate = data["toDate"] ? moment(data["toDate"].toString()) : <any>undefined;
            this.promotionMasterCode = data["promotionMasterCode"];
            this.promotionCode = data["promotionCode"];
            this.status = data["status"];
        }
    }

    static fromJS(data: any): PromotionInfo {
        data = typeof data === 'object' ? data : {};
        let result = new PromotionInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productCode"] = this.productCode;
        data["campaignId"] = this.campaignId;
        data["quantity"] = this.quantity;
        data["campaignName"] = this.campaignName;
        data["description"] = this.description;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data["promotionMasterCode"] = this.promotionMasterCode;
        data["promotionCode"] = this.promotionCode;
        data["status"] = this.status;
        return data;
    }
}

export interface IPromotionInfo {
    productCode: string | undefined;
    campaignId: string | undefined;
    quantity: number | undefined;
    campaignName: string | undefined;
    description: string | undefined;
    fromDate: moment.Moment | undefined;
    toDate: moment.Moment | undefined;
    promotionMasterCode: string | undefined;
    promotionCode: string | undefined;
    status: string | undefined;
}

export class GameInfor implements IGameInfor {
    tenantId!: number | undefined;
    campaignID!: string | undefined;
    campaignName!: string | undefined;
    description!: string | undefined;
    outletCode!: string | undefined;
    zaloChatID!: string | undefined;
    memberCode!: string | undefined;
    phone!: string | undefined;
    quantity!: number | undefined;
    used!: number | undefined;
    remain!: number | undefined;
    link!: string | undefined;
    fromDate!: moment.Moment | undefined;
    toDate!: moment.Moment | undefined;
    promotionMasterCode!: string | undefined;
    promotionCode!: string | undefined;
    status!: string | undefined;
    isDeleted!: boolean | undefined;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: moment.Moment | undefined;
    creatorUserId!: number | undefined;
    id!: number | undefined;

    constructor(data?: IGameInfor) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.campaignID = data["campaignID"];
            this.campaignName = data["campaignName"];
            this.description = data["description"];
            this.outletCode = data["outletCode"];
            this.zaloChatID = data["zaloChatID"];
            this.memberCode = data["memberCode"];
            this.phone = data["phone"];
            this.quantity = data["quantity"];
            this.used = data["used"];
            this.remain = data["remain"];
            this.link = data["link"];
            this.fromDate = data["fromDate"] ? moment(data["fromDate"].toString()) : <any>undefined;
            this.toDate = data["toDate"] ? moment(data["toDate"].toString()) : <any>undefined;
            this.promotionMasterCode = data["promotionMasterCode"];
            this.promotionCode = data["promotionCode"];
            this.status = data["status"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): GameInfor {
        data = typeof data === 'object' ? data : {};
        let result = new GameInfor();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["campaignID"] = this.campaignID;
        data["campaignName"] = this.campaignName;
        data["description"] = this.description;
        data["outletCode"] = this.outletCode;
        data["zaloChatID"] = this.zaloChatID;
        data["memberCode"] = this.memberCode;
        data["phone"] = this.phone;
        data["quantity"] = this.quantity;
        data["used"] = this.used;
        data["remain"] = this.remain;
        data["link"] = this.link;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data["promotionMasterCode"] = this.promotionMasterCode;
        data["promotionCode"] = this.promotionCode;
        data["status"] = this.status;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IGameInfor {
    tenantId: number | undefined;
    campaignID: string | undefined;
    campaignName: string | undefined;
    description: string | undefined;
    outletCode: string | undefined;
    zaloChatID: string | undefined;
    memberCode: string | undefined;
    phone: string | undefined;
    quantity: number | undefined;
    used: number | undefined;
    remain: number | undefined;
    link: string | undefined;
    fromDate: moment.Moment | undefined;
    toDate: moment.Moment | undefined;
    promotionMasterCode: string | undefined;
    promotionCode: string | undefined;
    status: string | undefined;
    isDeleted: boolean | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class InitGameDto implements IInitGameDto {
    phone!: string | undefined;
    campaignId!: string | undefined;
    isRegister!: boolean | undefined;
    numSpin!: number | undefined;

    constructor(data?: IInitGameDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.phone = data["phone"];
            this.campaignId = data["campaignId"];
            this.isRegister = data["isRegister"];
            this.numSpin = data["numSpin"];
        }
    }

    static fromJS(data: any): InitGameDto {
        data = typeof data === 'object' ? data : {};
        let result = new InitGameDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phone"] = this.phone;
        data["campaignId"] = this.campaignId;
        data["isRegister"] = this.isRegister;
        data["numSpin"] = this.numSpin;
        return data;
    }
}

export interface IInitGameDto {
    phone: string | undefined;
    campaignId: string | undefined;
    isRegister: boolean | undefined;
    numSpin: number | undefined;
}

export class GameGotItCheckOutput implements IGameGotItCheckOutput {
    status!: number | undefined;
    phone!: string | undefined;
    url!: string | undefined;
    total!: number | undefined;
    un_spin!: number | undefined;
    timestamp!: string | undefined;
    check_sum!: string | undefined;

    constructor(data?: IGameGotItCheckOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.status = data["status"];
            this.phone = data["phone"];
            this.url = data["url"];
            this.total = data["total"];
            this.un_spin = data["un_spin"];
            this.timestamp = data["timestamp"];
            this.check_sum = data["check_sum"];
        }
    }

    static fromJS(data: any): GameGotItCheckOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GameGotItCheckOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["phone"] = this.phone;
        data["url"] = this.url;
        data["total"] = this.total;
        data["un_spin"] = this.un_spin;
        data["timestamp"] = this.timestamp;
        data["check_sum"] = this.check_sum;
        return data;
    }
}

export interface IGameGotItCheckOutput {
    status: number | undefined;
    phone: string | undefined;
    url: string | undefined;
    total: number | undefined;
    un_spin: number | undefined;
    timestamp: string | undefined;
    check_sum: string | undefined;
}

export class PagedResultDtoOfGetGameInforForViewDto implements IPagedResultDtoOfGetGameInforForViewDto {
    totalCount!: number | undefined;
    items!: GetGameInforForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetGameInforForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetGameInforForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetGameInforForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetGameInforForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetGameInforForViewDto {
    totalCount: number | undefined;
    items: GetGameInforForViewDto[] | undefined;
}

export class GetGameInforForViewDto implements IGetGameInforForViewDto {
    gameInfor!: GameInforDto | undefined;

    constructor(data?: IGetGameInforForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.gameInfor = data["gameInfor"] ? GameInforDto.fromJS(data["gameInfor"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetGameInforForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGameInforForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gameInfor"] = this.gameInfor ? this.gameInfor.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetGameInforForViewDto {
    gameInfor: GameInforDto | undefined;
}

export class GameInforDto implements IGameInforDto {
    campaignID!: string | undefined;
    campaignName!: string | undefined;
    description!: string | undefined;
    outletCode!: string | undefined;
    zaloChatID!: string | undefined;
    memberCode!: string | undefined;
    phone!: string | undefined;
    quantity!: number | undefined;
    used!: number | undefined;
    remain!: number | undefined;
    link!: string | undefined;
    fromDate!: moment.Moment | undefined;
    toDate!: moment.Moment | undefined;
    promotionMasterCode!: string | undefined;
    promotionCode!: string | undefined;
    status!: string | undefined;
    id!: number | undefined;

    constructor(data?: IGameInforDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.campaignID = data["campaignID"];
            this.campaignName = data["campaignName"];
            this.description = data["description"];
            this.outletCode = data["outletCode"];
            this.zaloChatID = data["zaloChatID"];
            this.memberCode = data["memberCode"];
            this.phone = data["phone"];
            this.quantity = data["quantity"];
            this.used = data["used"];
            this.remain = data["remain"];
            this.link = data["link"];
            this.fromDate = data["fromDate"] ? moment(data["fromDate"].toString()) : <any>undefined;
            this.toDate = data["toDate"] ? moment(data["toDate"].toString()) : <any>undefined;
            this.promotionMasterCode = data["promotionMasterCode"];
            this.promotionCode = data["promotionCode"];
            this.status = data["status"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): GameInforDto {
        data = typeof data === 'object' ? data : {};
        let result = new GameInforDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["campaignID"] = this.campaignID;
        data["campaignName"] = this.campaignName;
        data["description"] = this.description;
        data["outletCode"] = this.outletCode;
        data["zaloChatID"] = this.zaloChatID;
        data["memberCode"] = this.memberCode;
        data["phone"] = this.phone;
        data["quantity"] = this.quantity;
        data["used"] = this.used;
        data["remain"] = this.remain;
        data["link"] = this.link;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data["promotionMasterCode"] = this.promotionMasterCode;
        data["promotionCode"] = this.promotionCode;
        data["status"] = this.status;
        data["id"] = this.id;
        return data;
    }
}

export interface IGameInforDto {
    campaignID: string | undefined;
    campaignName: string | undefined;
    description: string | undefined;
    outletCode: string | undefined;
    zaloChatID: string | undefined;
    memberCode: string | undefined;
    phone: string | undefined;
    quantity: number | undefined;
    used: number | undefined;
    remain: number | undefined;
    link: string | undefined;
    fromDate: moment.Moment | undefined;
    toDate: moment.Moment | undefined;
    promotionMasterCode: string | undefined;
    promotionCode: string | undefined;
    status: string | undefined;
    id: number | undefined;
}

export class GetGameInforForEditOutput implements IGetGameInforForEditOutput {
    gameInfor!: CreateOrEditGameInforDto | undefined;

    constructor(data?: IGetGameInforForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.gameInfor = data["gameInfor"] ? CreateOrEditGameInforDto.fromJS(data["gameInfor"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetGameInforForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetGameInforForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gameInfor"] = this.gameInfor ? this.gameInfor.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetGameInforForEditOutput {
    gameInfor: CreateOrEditGameInforDto | undefined;
}

export class CreateOrEditGameInforDto implements ICreateOrEditGameInforDto {
    campaignID!: string | undefined;
    campaignName!: string | undefined;
    description!: string | undefined;
    outletCode!: string | undefined;
    zaloChatID!: string | undefined;
    memberCode!: string | undefined;
    phone!: string | undefined;
    quantity!: number | undefined;
    used!: number | undefined;
    remain!: number | undefined;
    link!: string | undefined;
    fromDate!: moment.Moment | undefined;
    toDate!: moment.Moment | undefined;
    promotionMasterCode!: string | undefined;
    promotionCode!: string | undefined;
    status!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditGameInforDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.campaignID = data["campaignID"];
            this.campaignName = data["campaignName"];
            this.description = data["description"];
            this.outletCode = data["outletCode"];
            this.zaloChatID = data["zaloChatID"];
            this.memberCode = data["memberCode"];
            this.phone = data["phone"];
            this.quantity = data["quantity"];
            this.used = data["used"];
            this.remain = data["remain"];
            this.link = data["link"];
            this.fromDate = data["fromDate"] ? moment(data["fromDate"].toString()) : <any>undefined;
            this.toDate = data["toDate"] ? moment(data["toDate"].toString()) : <any>undefined;
            this.promotionMasterCode = data["promotionMasterCode"];
            this.promotionCode = data["promotionCode"];
            this.status = data["status"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditGameInforDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditGameInforDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["campaignID"] = this.campaignID;
        data["campaignName"] = this.campaignName;
        data["description"] = this.description;
        data["outletCode"] = this.outletCode;
        data["zaloChatID"] = this.zaloChatID;
        data["memberCode"] = this.memberCode;
        data["phone"] = this.phone;
        data["quantity"] = this.quantity;
        data["used"] = this.used;
        data["remain"] = this.remain;
        data["link"] = this.link;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data["promotionMasterCode"] = this.promotionMasterCode;
        data["promotionCode"] = this.promotionCode;
        data["status"] = this.status;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditGameInforDto {
    campaignID: string | undefined;
    campaignName: string | undefined;
    description: string | undefined;
    outletCode: string | undefined;
    zaloChatID: string | undefined;
    memberCode: string | undefined;
    phone: string | undefined;
    quantity: number | undefined;
    used: number | undefined;
    remain: number | undefined;
    link: string | undefined;
    fromDate: moment.Moment | undefined;
    toDate: moment.Moment | undefined;
    promotionMasterCode: string | undefined;
    promotionCode: string | undefined;
    status: string | undefined;
    id: number | undefined;
}

export class RewardsFileDto implements IRewardsFileDto {
    fileName!: string;
    fileType!: string;
    fileToken!: string;

    constructor(data?: IRewardsFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.fileName = data["fileName"];
            this.fileType = data["fileType"];
            this.fileToken = data["fileToken"];
        }
    }

    static fromJS(data: any): RewardsFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new RewardsFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["fileType"] = this.fileType;
        data["fileToken"] = this.fileToken;
        return data;
    }
}

export interface IRewardsFileDto {
    fileName: string;
    fileType: string;
    fileToken: string;
}

export class GetAllGameTicketHerderInput implements IGetAllGameTicketHerderInput {
    filter!: string | undefined;
    statusFilter!: string | undefined;
    sorting!: string | undefined;
    skipCount!: number | undefined;
    maxResultCount!: number | undefined;

    constructor(data?: IGetAllGameTicketHerderInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.filter = data["filter"];
            this.statusFilter = data["statusFilter"];
            this.sorting = data["sorting"];
            this.skipCount = data["skipCount"];
            this.maxResultCount = data["maxResultCount"];
        }
    }

    static fromJS(data: any): GetAllGameTicketHerderInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllGameTicketHerderInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        data["statusFilter"] = this.statusFilter;
        data["sorting"] = this.sorting;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data;
    }
}

export interface IGetAllGameTicketHerderInput {
    filter: string | undefined;
    statusFilter: string | undefined;
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;
}

export class GetAllGameTicketDetailInput implements IGetAllGameTicketDetailInput {
    filter!: string | undefined;
    campaignID!: string | undefined;
    memberCode!: string | undefined;
    memberName!: string | undefined;
    phone!: string | undefined;
    remainQuantity!: number | undefined;
    sorting!: string | undefined;
    skipCount!: number | undefined;
    maxResultCount!: number | undefined;

    constructor(data?: IGetAllGameTicketDetailInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.filter = data["filter"];
            this.campaignID = data["campaignID"];
            this.memberCode = data["memberCode"];
            this.memberName = data["memberName"];
            this.phone = data["phone"];
            this.remainQuantity = data["remainQuantity"];
            this.sorting = data["sorting"];
            this.skipCount = data["skipCount"];
            this.maxResultCount = data["maxResultCount"];
        }
    }

    static fromJS(data: any): GetAllGameTicketDetailInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllGameTicketDetailInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        data["campaignID"] = this.campaignID;
        data["memberCode"] = this.memberCode;
        data["memberName"] = this.memberName;
        data["phone"] = this.phone;
        data["remainQuantity"] = this.remainQuantity;
        data["sorting"] = this.sorting;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data;
    }
}

export interface IGetAllGameTicketDetailInput {
    filter: string | undefined;
    campaignID: string | undefined;
    memberCode: string | undefined;
    memberName: string | undefined;
    phone: string | undefined;
    remainQuantity: number | undefined;
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;
}

export class PagedResultDtoOfGameDetailDto implements IPagedResultDtoOfGameDetailDto {
    totalCount!: number | undefined;
    items!: GameDetailDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGameDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GameDetailDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGameDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGameDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGameDetailDto {
    totalCount: number | undefined;
    items: GameDetailDto[] | undefined;
}

export class GameDetailDto implements IGameDetailDto {
    memberName!: string | undefined;
    memberCode!: string | undefined;
    nameUnsign!: string | undefined;
    phone!: string | undefined;
    quantity!: number | undefined;
    used!: number | undefined;
    remain!: number | undefined;
    lastModificationTime!: moment.Moment | undefined;
    campaignID!: string | undefined;
    id!: number | undefined;

    constructor(data?: IGameDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberName = data["memberName"];
            this.memberCode = data["memberCode"];
            this.nameUnsign = data["nameUnsign"];
            this.phone = data["phone"];
            this.quantity = data["quantity"];
            this.used = data["used"];
            this.remain = data["remain"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.campaignID = data["campaignID"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): GameDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new GameDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberName"] = this.memberName;
        data["memberCode"] = this.memberCode;
        data["nameUnsign"] = this.nameUnsign;
        data["phone"] = this.phone;
        data["quantity"] = this.quantity;
        data["used"] = this.used;
        data["remain"] = this.remain;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["campaignID"] = this.campaignID;
        data["id"] = this.id;
        return data;
    }
}

export interface IGameDetailDto {
    memberName: string | undefined;
    memberCode: string | undefined;
    nameUnsign: string | undefined;
    phone: string | undefined;
    quantity: number | undefined;
    used: number | undefined;
    remain: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    campaignID: string | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfGetGameInfoForViewDto implements IPagedResultDtoOfGetGameInfoForViewDto {
    totalCount!: number | undefined;
    items!: GetGameInfoForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetGameInfoForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetGameInfoForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetGameInfoForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetGameInfoForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetGameInfoForViewDto {
    totalCount: number | undefined;
    items: GetGameInfoForViewDto[] | undefined;
}

export class GetGameInfoForViewDto implements IGetGameInfoForViewDto {
    gameInfo!: GameInfoDto | undefined;

    constructor(data?: IGetGameInfoForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.gameInfo = data["gameInfo"] ? GameInfoDto.fromJS(data["gameInfo"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetGameInfoForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGameInfoForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gameInfo"] = this.gameInfo ? this.gameInfo.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetGameInfoForViewDto {
    gameInfo: GameInfoDto | undefined;
}

export class GameInfoDto implements IGameInfoDto {
    gameCode!: string | undefined;
    gameNameEN!: string | undefined;
    gameNameVN!: string | undefined;
    startTime!: moment.Moment | undefined;
    endTime!: moment.Moment | undefined;
    status!: string | undefined;
    gameType!: string | undefined;
    targetAudienceType!: string | undefined;
    targetAudienceID!: number | undefined;
    event!: string | undefined;
    actionFilter!: string | undefined;
    description!: string | undefined;
    backgroundImage!: string | undefined;
    gameRuleImage!: string | undefined;
    maxRewardPerPlayer!: number | undefined;
    descriptionOutOfReward!: string | undefined;
    timeToExpiredTicket!: number | undefined;
    id!: number | undefined;

    constructor(data?: IGameInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.gameCode = data["gameCode"];
            this.gameNameEN = data["gameNameEN"];
            this.gameNameVN = data["gameNameVN"];
            this.startTime = data["startTime"] ? moment(data["startTime"].toString()) : <any>undefined;
            this.endTime = data["endTime"] ? moment(data["endTime"].toString()) : <any>undefined;
            this.status = data["status"];
            this.gameType = data["gameType"];
            this.targetAudienceType = data["targetAudienceType"];
            this.targetAudienceID = data["targetAudienceID"];
            this.event = data["event"];
            this.actionFilter = data["actionFilter"];
            this.description = data["description"];
            this.backgroundImage = data["backgroundImage"];
            this.gameRuleImage = data["gameRuleImage"];
            this.maxRewardPerPlayer = data["maxRewardPerPlayer"];
            this.descriptionOutOfReward = data["descriptionOutOfReward"];
            this.timeToExpiredTicket = data["timeToExpiredTicket"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): GameInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new GameInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gameCode"] = this.gameCode;
        data["gameNameEN"] = this.gameNameEN;
        data["gameNameVN"] = this.gameNameVN;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["gameType"] = this.gameType;
        data["targetAudienceType"] = this.targetAudienceType;
        data["targetAudienceID"] = this.targetAudienceID;
        data["event"] = this.event;
        data["actionFilter"] = this.actionFilter;
        data["description"] = this.description;
        data["backgroundImage"] = this.backgroundImage;
        data["gameRuleImage"] = this.gameRuleImage;
        data["maxRewardPerPlayer"] = this.maxRewardPerPlayer;
        data["descriptionOutOfReward"] = this.descriptionOutOfReward;
        data["timeToExpiredTicket"] = this.timeToExpiredTicket;
        data["id"] = this.id;
        return data;
    }
}

export interface IGameInfoDto {
    gameCode: string | undefined;
    gameNameEN: string | undefined;
    gameNameVN: string | undefined;
    startTime: moment.Moment | undefined;
    endTime: moment.Moment | undefined;
    status: string | undefined;
    gameType: string | undefined;
    targetAudienceType: string | undefined;
    targetAudienceID: number | undefined;
    event: string | undefined;
    actionFilter: string | undefined;
    description: string | undefined;
    backgroundImage: string | undefined;
    gameRuleImage: string | undefined;
    maxRewardPerPlayer: number | undefined;
    descriptionOutOfReward: string | undefined;
    timeToExpiredTicket: number | undefined;
    id: number | undefined;
}

export class GetGameInfoForEditOutput implements IGetGameInfoForEditOutput {
    gameInfo!: CreateOrEditGameInfoDto | undefined;

    constructor(data?: IGetGameInfoForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.gameInfo = data["gameInfo"] ? CreateOrEditGameInfoDto.fromJS(data["gameInfo"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetGameInfoForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetGameInfoForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gameInfo"] = this.gameInfo ? this.gameInfo.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetGameInfoForEditOutput {
    gameInfo: CreateOrEditGameInfoDto | undefined;
}

export class CreateOrEditGameInfoDto implements ICreateOrEditGameInfoDto {
    gameCode!: string | undefined;
    gameNameEN!: string | undefined;
    gameNameVN!: string | undefined;
    startTime!: moment.Moment | undefined;
    endTime!: moment.Moment | undefined;
    status!: string | undefined;
    gameType!: string | undefined;
    targetAudienceType!: string | undefined;
    targetAudienceID!: number | undefined;
    event!: string | undefined;
    actionFilter!: string | undefined;
    description!: string | undefined;
    backgroundImage!: string | undefined;
    gameRuleImage!: string | undefined;
    maxRewardPerPlayer!: number | undefined;
    descriptionOutOfReward!: string | undefined;
    timeToExpiredTicket!: number | undefined;
    lastModificationTime!: moment.Moment | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditGameInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.gameCode = data["gameCode"];
            this.gameNameEN = data["gameNameEN"];
            this.gameNameVN = data["gameNameVN"];
            this.startTime = data["startTime"] ? moment(data["startTime"].toString()) : <any>undefined;
            this.endTime = data["endTime"] ? moment(data["endTime"].toString()) : <any>undefined;
            this.status = data["status"];
            this.gameType = data["gameType"];
            this.targetAudienceType = data["targetAudienceType"];
            this.targetAudienceID = data["targetAudienceID"];
            this.event = data["event"];
            this.actionFilter = data["actionFilter"];
            this.description = data["description"];
            this.backgroundImage = data["backgroundImage"];
            this.gameRuleImage = data["gameRuleImage"];
            this.maxRewardPerPlayer = data["maxRewardPerPlayer"];
            this.descriptionOutOfReward = data["descriptionOutOfReward"];
            this.timeToExpiredTicket = data["timeToExpiredTicket"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditGameInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditGameInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gameCode"] = this.gameCode;
        data["gameNameEN"] = this.gameNameEN;
        data["gameNameVN"] = this.gameNameVN;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["gameType"] = this.gameType;
        data["targetAudienceType"] = this.targetAudienceType;
        data["targetAudienceID"] = this.targetAudienceID;
        data["event"] = this.event;
        data["actionFilter"] = this.actionFilter;
        data["description"] = this.description;
        data["backgroundImage"] = this.backgroundImage;
        data["gameRuleImage"] = this.gameRuleImage;
        data["maxRewardPerPlayer"] = this.maxRewardPerPlayer;
        data["descriptionOutOfReward"] = this.descriptionOutOfReward;
        data["timeToExpiredTicket"] = this.timeToExpiredTicket;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditGameInfoDto {
    gameCode: string | undefined;
    gameNameEN: string | undefined;
    gameNameVN: string | undefined;
    startTime: moment.Moment | undefined;
    endTime: moment.Moment | undefined;
    status: string | undefined;
    gameType: string | undefined;
    targetAudienceType: string | undefined;
    targetAudienceID: number | undefined;
    event: string | undefined;
    actionFilter: string | undefined;
    description: string | undefined;
    backgroundImage: string | undefined;
    gameRuleImage: string | undefined;
    maxRewardPerPlayer: number | undefined;
    descriptionOutOfReward: string | undefined;
    timeToExpiredTicket: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    id: number | undefined;
}

export class GetAllGameInfosInput implements IGetAllGameInfosInput {
    filter!: string | undefined;
    gameCodeFilter!: string | undefined;
    gameNameENFilter!: string | undefined;
    gameNameVNFilter!: string | undefined;
    maxStartTimeFilter!: moment.Moment | undefined;
    minStartTimeFilter!: moment.Moment | undefined;
    maxEndTimeFilter!: moment.Moment | undefined;
    minEndTimeFilter!: moment.Moment | undefined;
    statusFilter!: string | undefined;
    gameTypeFilter!: string | undefined;
    targetAudienceTypeFilter!: string | undefined;
    maxTargetAudienceIDFilter!: number | undefined;
    minTargetAudienceIDFilter!: number | undefined;
    eventFilter!: string | undefined;
    actionFilterFilter!: string | undefined;
    descriptionFilter!: string | undefined;
    backgroundImageFilter!: string | undefined;
    gameRuleImageFilter!: string | undefined;
    maxMaxRewardPerPlayerFilter!: number | undefined;
    minMaxRewardPerPlayerFilter!: number | undefined;
    descriptionOutOfRewardFilter!: string | undefined;
    maxTimeToExpiredTicketFilter!: number | undefined;
    minTimeToExpiredTicketFilter!: number | undefined;
    sorting!: string | undefined;
    skipCount!: number | undefined;
    maxResultCount!: number | undefined;

    constructor(data?: IGetAllGameInfosInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.filter = data["filter"];
            this.gameCodeFilter = data["gameCodeFilter"];
            this.gameNameENFilter = data["gameNameENFilter"];
            this.gameNameVNFilter = data["gameNameVNFilter"];
            this.maxStartTimeFilter = data["maxStartTimeFilter"] ? moment(data["maxStartTimeFilter"].toString()) : <any>undefined;
            this.minStartTimeFilter = data["minStartTimeFilter"] ? moment(data["minStartTimeFilter"].toString()) : <any>undefined;
            this.maxEndTimeFilter = data["maxEndTimeFilter"] ? moment(data["maxEndTimeFilter"].toString()) : <any>undefined;
            this.minEndTimeFilter = data["minEndTimeFilter"] ? moment(data["minEndTimeFilter"].toString()) : <any>undefined;
            this.statusFilter = data["statusFilter"];
            this.gameTypeFilter = data["gameTypeFilter"];
            this.targetAudienceTypeFilter = data["targetAudienceTypeFilter"];
            this.maxTargetAudienceIDFilter = data["maxTargetAudienceIDFilter"];
            this.minTargetAudienceIDFilter = data["minTargetAudienceIDFilter"];
            this.eventFilter = data["eventFilter"];
            this.actionFilterFilter = data["actionFilterFilter"];
            this.descriptionFilter = data["descriptionFilter"];
            this.backgroundImageFilter = data["backgroundImageFilter"];
            this.gameRuleImageFilter = data["gameRuleImageFilter"];
            this.maxMaxRewardPerPlayerFilter = data["maxMaxRewardPerPlayerFilter"];
            this.minMaxRewardPerPlayerFilter = data["minMaxRewardPerPlayerFilter"];
            this.descriptionOutOfRewardFilter = data["descriptionOutOfRewardFilter"];
            this.maxTimeToExpiredTicketFilter = data["maxTimeToExpiredTicketFilter"];
            this.minTimeToExpiredTicketFilter = data["minTimeToExpiredTicketFilter"];
            this.sorting = data["sorting"];
            this.skipCount = data["skipCount"];
            this.maxResultCount = data["maxResultCount"];
        }
    }

    static fromJS(data: any): GetAllGameInfosInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllGameInfosInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        data["gameCodeFilter"] = this.gameCodeFilter;
        data["gameNameENFilter"] = this.gameNameENFilter;
        data["gameNameVNFilter"] = this.gameNameVNFilter;
        data["maxStartTimeFilter"] = this.maxStartTimeFilter ? this.maxStartTimeFilter.toISOString() : <any>undefined;
        data["minStartTimeFilter"] = this.minStartTimeFilter ? this.minStartTimeFilter.toISOString() : <any>undefined;
        data["maxEndTimeFilter"] = this.maxEndTimeFilter ? this.maxEndTimeFilter.toISOString() : <any>undefined;
        data["minEndTimeFilter"] = this.minEndTimeFilter ? this.minEndTimeFilter.toISOString() : <any>undefined;
        data["statusFilter"] = this.statusFilter;
        data["gameTypeFilter"] = this.gameTypeFilter;
        data["targetAudienceTypeFilter"] = this.targetAudienceTypeFilter;
        data["maxTargetAudienceIDFilter"] = this.maxTargetAudienceIDFilter;
        data["minTargetAudienceIDFilter"] = this.minTargetAudienceIDFilter;
        data["eventFilter"] = this.eventFilter;
        data["actionFilterFilter"] = this.actionFilterFilter;
        data["descriptionFilter"] = this.descriptionFilter;
        data["backgroundImageFilter"] = this.backgroundImageFilter;
        data["gameRuleImageFilter"] = this.gameRuleImageFilter;
        data["maxMaxRewardPerPlayerFilter"] = this.maxMaxRewardPerPlayerFilter;
        data["minMaxRewardPerPlayerFilter"] = this.minMaxRewardPerPlayerFilter;
        data["descriptionOutOfRewardFilter"] = this.descriptionOutOfRewardFilter;
        data["maxTimeToExpiredTicketFilter"] = this.maxTimeToExpiredTicketFilter;
        data["minTimeToExpiredTicketFilter"] = this.minTimeToExpiredTicketFilter;
        data["sorting"] = this.sorting;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data;
    }
}

export interface IGetAllGameInfosInput {
    filter: string | undefined;
    gameCodeFilter: string | undefined;
    gameNameENFilter: string | undefined;
    gameNameVNFilter: string | undefined;
    maxStartTimeFilter: moment.Moment | undefined;
    minStartTimeFilter: moment.Moment | undefined;
    maxEndTimeFilter: moment.Moment | undefined;
    minEndTimeFilter: moment.Moment | undefined;
    statusFilter: string | undefined;
    gameTypeFilter: string | undefined;
    targetAudienceTypeFilter: string | undefined;
    maxTargetAudienceIDFilter: number | undefined;
    minTargetAudienceIDFilter: number | undefined;
    eventFilter: string | undefined;
    actionFilterFilter: string | undefined;
    descriptionFilter: string | undefined;
    backgroundImageFilter: string | undefined;
    gameRuleImageFilter: string | undefined;
    maxMaxRewardPerPlayerFilter: number | undefined;
    minMaxRewardPerPlayerFilter: number | undefined;
    descriptionOutOfRewardFilter: string | undefined;
    maxTimeToExpiredTicketFilter: number | undefined;
    minTimeToExpiredTicketFilter: number | undefined;
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;
}

export class CreateOrEditGameCampaignCustomDto implements ICreateOrEditGameCampaignCustomDto {
    gameInfo!: CreateOrEditGameInfoDto | undefined;
    gameRewards!: CreateOrEditGameRewardDto[] | undefined;
    deletedGameRewardIds!: number[] | undefined;
    gameTargetAudienceImportInformation!: GameTargetAudienceImportInformation | undefined;
    extraInformation!: GameCampaignExtraInformation | undefined;

    constructor(data?: ICreateOrEditGameCampaignCustomDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.gameInfo = data["gameInfo"] ? CreateOrEditGameInfoDto.fromJS(data["gameInfo"]) : <any>undefined;
            if (data["gameRewards"] && data["gameRewards"].constructor === Array) {
                this.gameRewards = [];
                for (let item of data["gameRewards"])
                    this.gameRewards.push(CreateOrEditGameRewardDto.fromJS(item));
            }
            if (data["deletedGameRewardIds"] && data["deletedGameRewardIds"].constructor === Array) {
                this.deletedGameRewardIds = [];
                for (let item of data["deletedGameRewardIds"])
                    this.deletedGameRewardIds.push(item);
            }
            this.gameTargetAudienceImportInformation = data["gameTargetAudienceImportInformation"] ? GameTargetAudienceImportInformation.fromJS(data["gameTargetAudienceImportInformation"]) : <any>undefined;
            this.extraInformation = data["extraInformation"] ? GameCampaignExtraInformation.fromJS(data["extraInformation"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateOrEditGameCampaignCustomDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditGameCampaignCustomDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gameInfo"] = this.gameInfo ? this.gameInfo.toJSON() : <any>undefined;
        if (this.gameRewards && this.gameRewards.constructor === Array) {
            data["gameRewards"] = [];
            for (let item of this.gameRewards)
                data["gameRewards"].push(item.toJSON());
        }
        if (this.deletedGameRewardIds && this.deletedGameRewardIds.constructor === Array) {
            data["deletedGameRewardIds"] = [];
            for (let item of this.deletedGameRewardIds)
                data["deletedGameRewardIds"].push(item);
        }
        data["gameTargetAudienceImportInformation"] = this.gameTargetAudienceImportInformation ? this.gameTargetAudienceImportInformation.toJSON() : <any>undefined;
        data["extraInformation"] = this.extraInformation ? this.extraInformation.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrEditGameCampaignCustomDto {
    gameInfo: CreateOrEditGameInfoDto | undefined;
    gameRewards: CreateOrEditGameRewardDto[] | undefined;
    deletedGameRewardIds: number[] | undefined;
    gameTargetAudienceImportInformation: GameTargetAudienceImportInformation | undefined;
    extraInformation: GameCampaignExtraInformation | undefined;
}

export class CreateOrEditGameRewardDto implements ICreateOrEditGameRewardDto {
    gameCode!: string | undefined;
    rewardCode!: string | undefined;
    rewardNameEN!: string | undefined;
    rewardNameVN!: string | undefined;
    startTime!: moment.Moment | undefined;
    endTime!: moment.Moment | undefined;
    status!: string | undefined;
    imageLink!: string | undefined;
    description!: string | undefined;
    order!: number | undefined;
    weightRatio!: number | undefined;
    budget!: number | undefined;
    usedBudget!: number | undefined;
    maxPerPlayer!: number | undefined;
    itemCode!: string | undefined;
    rewardType!: string | undefined;
    rewardPartner!: string | undefined;
    vendorCode!: string | undefined;
    amount!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditGameRewardDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.gameCode = data["gameCode"];
            this.rewardCode = data["rewardCode"];
            this.rewardNameEN = data["rewardNameEN"];
            this.rewardNameVN = data["rewardNameVN"];
            this.startTime = data["startTime"] ? moment(data["startTime"].toString()) : <any>undefined;
            this.endTime = data["endTime"] ? moment(data["endTime"].toString()) : <any>undefined;
            this.status = data["status"];
            this.imageLink = data["imageLink"];
            this.description = data["description"];
            this.order = data["order"];
            this.weightRatio = data["weightRatio"];
            this.budget = data["budget"];
            this.usedBudget = data["usedBudget"];
            this.maxPerPlayer = data["maxPerPlayer"];
            this.itemCode = data["itemCode"];
            this.rewardType = data["rewardType"];
            this.rewardPartner = data["rewardPartner"];
            this.vendorCode = data["vendorCode"];
            this.amount = data["amount"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditGameRewardDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditGameRewardDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gameCode"] = this.gameCode;
        data["rewardCode"] = this.rewardCode;
        data["rewardNameEN"] = this.rewardNameEN;
        data["rewardNameVN"] = this.rewardNameVN;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["imageLink"] = this.imageLink;
        data["description"] = this.description;
        data["order"] = this.order;
        data["weightRatio"] = this.weightRatio;
        data["budget"] = this.budget;
        data["usedBudget"] = this.usedBudget;
        data["maxPerPlayer"] = this.maxPerPlayer;
        data["itemCode"] = this.itemCode;
        data["rewardType"] = this.rewardType;
        data["rewardPartner"] = this.rewardPartner;
        data["vendorCode"] = this.vendorCode;
        data["amount"] = this.amount;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditGameRewardDto {
    gameCode: string | undefined;
    rewardCode: string | undefined;
    rewardNameEN: string | undefined;
    rewardNameVN: string | undefined;
    startTime: moment.Moment | undefined;
    endTime: moment.Moment | undefined;
    status: string | undefined;
    imageLink: string | undefined;
    description: string | undefined;
    order: number | undefined;
    weightRatio: number | undefined;
    budget: number | undefined;
    usedBudget: number | undefined;
    maxPerPlayer: number | undefined;
    itemCode: string | undefined;
    rewardType: string | undefined;
    rewardPartner: string | undefined;
    vendorCode: string | undefined;
    amount: number | undefined;
    id: number | undefined;
}

export class GameTargetAudienceImportInformation implements IGameTargetAudienceImportInformation {
    fileName!: string | undefined;
    targetAudienceName!: string | undefined;
    isUpdate!: boolean | undefined;

    constructor(data?: IGameTargetAudienceImportInformation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.fileName = data["fileName"];
            this.targetAudienceName = data["targetAudienceName"];
            this.isUpdate = data["isUpdate"];
        }
    }

    static fromJS(data: any): GameTargetAudienceImportInformation {
        data = typeof data === 'object' ? data : {};
        let result = new GameTargetAudienceImportInformation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["targetAudienceName"] = this.targetAudienceName;
        data["isUpdate"] = this.isUpdate;
        return data;
    }
}

export interface IGameTargetAudienceImportInformation {
    fileName: string | undefined;
    targetAudienceName: string | undefined;
    isUpdate: boolean | undefined;
}

export class GameCampaignExtraInformation implements IGameCampaignExtraInformation {
    isEditable!: boolean | undefined;

    constructor(data?: IGameCampaignExtraInformation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isEditable = data["isEditable"];
        }
    }

    static fromJS(data: any): GameCampaignExtraInformation {
        data = typeof data === 'object' ? data : {};
        let result = new GameCampaignExtraInformation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isEditable"] = this.isEditable;
        return data;
    }
}

export interface IGameCampaignExtraInformation {
    isEditable: boolean | undefined;
}

export class GameCampaignMasterData implements IGameCampaignMasterData {
    gameTypes!: string[] | undefined;
    gameTriggerEvents!: string[] | undefined;
    gameCampaignStatus!: string[] | undefined;

    constructor(data?: IGameCampaignMasterData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["gameTypes"] && data["gameTypes"].constructor === Array) {
                this.gameTypes = [];
                for (let item of data["gameTypes"])
                    this.gameTypes.push(item);
            }
            if (data["gameTriggerEvents"] && data["gameTriggerEvents"].constructor === Array) {
                this.gameTriggerEvents = [];
                for (let item of data["gameTriggerEvents"])
                    this.gameTriggerEvents.push(item);
            }
            if (data["gameCampaignStatus"] && data["gameCampaignStatus"].constructor === Array) {
                this.gameCampaignStatus = [];
                for (let item of data["gameCampaignStatus"])
                    this.gameCampaignStatus.push(item);
            }
        }
    }

    static fromJS(data: any): GameCampaignMasterData {
        data = typeof data === 'object' ? data : {};
        let result = new GameCampaignMasterData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.gameTypes && this.gameTypes.constructor === Array) {
            data["gameTypes"] = [];
            for (let item of this.gameTypes)
                data["gameTypes"].push(item);
        }
        if (this.gameTriggerEvents && this.gameTriggerEvents.constructor === Array) {
            data["gameTriggerEvents"] = [];
            for (let item of this.gameTriggerEvents)
                data["gameTriggerEvents"].push(item);
        }
        if (this.gameCampaignStatus && this.gameCampaignStatus.constructor === Array) {
            data["gameCampaignStatus"] = [];
            for (let item of this.gameCampaignStatus)
                data["gameCampaignStatus"].push(item);
        }
        return data;
    }
}

export interface IGameCampaignMasterData {
    gameTypes: string[] | undefined;
    gameTriggerEvents: string[] | undefined;
    gameCampaignStatus: string[] | undefined;
}

export class GameInforationDto implements IGameInforationDto {
    gameCode!: string | undefined;
    gameNameVN!: string | undefined;
    gameNameEN!: string | undefined;
    startTime!: moment.Moment | undefined;
    endTime!: moment.Moment | undefined;
    status!: string | undefined;
    playStatus!: string | undefined;
    imageLink!: string | undefined;
    numberOfTicket!: number | undefined;

    constructor(data?: IGameInforationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.gameCode = data["gameCode"];
            this.gameNameVN = data["gameNameVN"];
            this.gameNameEN = data["gameNameEN"];
            this.startTime = data["startTime"] ? moment(data["startTime"].toString()) : <any>undefined;
            this.endTime = data["endTime"] ? moment(data["endTime"].toString()) : <any>undefined;
            this.status = data["status"];
            this.playStatus = data["playStatus"];
            this.imageLink = data["imageLink"];
            this.numberOfTicket = data["numberOfTicket"];
        }
    }

    static fromJS(data: any): GameInforationDto {
        data = typeof data === 'object' ? data : {};
        let result = new GameInforationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gameCode"] = this.gameCode;
        data["gameNameVN"] = this.gameNameVN;
        data["gameNameEN"] = this.gameNameEN;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["playStatus"] = this.playStatus;
        data["imageLink"] = this.imageLink;
        data["numberOfTicket"] = this.numberOfTicket;
        return data;
    }
}

export interface IGameInforationDto {
    gameCode: string | undefined;
    gameNameVN: string | undefined;
    gameNameEN: string | undefined;
    startTime: moment.Moment | undefined;
    endTime: moment.Moment | undefined;
    status: string | undefined;
    playStatus: string | undefined;
    imageLink: string | undefined;
    numberOfTicket: number | undefined;
}

export class GameInformationDetailDto implements IGameInformationDetailDto {
    memberCode!: string | undefined;
    memberName!: string | undefined;
    backgroundImage!: string | undefined;
    gameNameEN!: string | undefined;
    gameNameVN!: string | undefined;
    gameType!: string | undefined;
    description!: string | undefined;
    gameRuleImage!: string | undefined;
    descriptionOutOfReward!: string | undefined;
    numberOfTicket!: number | undefined;
    totalTicketCount!: number | undefined;
    rewardList!: GameRewardInformationDto[] | undefined;

    constructor(data?: IGameInformationDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberCode = data["memberCode"];
            this.memberName = data["memberName"];
            this.backgroundImage = data["backgroundImage"];
            this.gameNameEN = data["gameNameEN"];
            this.gameNameVN = data["gameNameVN"];
            this.gameType = data["gameType"];
            this.description = data["description"];
            this.gameRuleImage = data["gameRuleImage"];
            this.descriptionOutOfReward = data["descriptionOutOfReward"];
            this.numberOfTicket = data["numberOfTicket"];
            this.totalTicketCount = data["totalTicketCount"];
            if (data["rewardList"] && data["rewardList"].constructor === Array) {
                this.rewardList = [];
                for (let item of data["rewardList"])
                    this.rewardList.push(GameRewardInformationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GameInformationDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new GameInformationDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberCode"] = this.memberCode;
        data["memberName"] = this.memberName;
        data["backgroundImage"] = this.backgroundImage;
        data["gameNameEN"] = this.gameNameEN;
        data["gameNameVN"] = this.gameNameVN;
        data["gameType"] = this.gameType;
        data["description"] = this.description;
        data["gameRuleImage"] = this.gameRuleImage;
        data["descriptionOutOfReward"] = this.descriptionOutOfReward;
        data["numberOfTicket"] = this.numberOfTicket;
        data["totalTicketCount"] = this.totalTicketCount;
        if (this.rewardList && this.rewardList.constructor === Array) {
            data["rewardList"] = [];
            for (let item of this.rewardList)
                data["rewardList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGameInformationDetailDto {
    memberCode: string | undefined;
    memberName: string | undefined;
    backgroundImage: string | undefined;
    gameNameEN: string | undefined;
    gameNameVN: string | undefined;
    gameType: string | undefined;
    description: string | undefined;
    gameRuleImage: string | undefined;
    descriptionOutOfReward: string | undefined;
    numberOfTicket: number | undefined;
    totalTicketCount: number | undefined;
    rewardList: GameRewardInformationDto[] | undefined;
}

export class GameRewardInformationDto implements IGameRewardInformationDto {
    order!: number | undefined;
    status!: string | undefined;
    rewardNameEN!: string | undefined;
    rewardNameVN!: string | undefined;
    imageLink!: string | undefined;
    rewardCode!: string | undefined;

    constructor(data?: IGameRewardInformationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.order = data["order"];
            this.status = data["status"];
            this.rewardNameEN = data["rewardNameEN"];
            this.rewardNameVN = data["rewardNameVN"];
            this.imageLink = data["imageLink"];
            this.rewardCode = data["rewardCode"];
        }
    }

    static fromJS(data: any): GameRewardInformationDto {
        data = typeof data === 'object' ? data : {};
        let result = new GameRewardInformationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["order"] = this.order;
        data["status"] = this.status;
        data["rewardNameEN"] = this.rewardNameEN;
        data["rewardNameVN"] = this.rewardNameVN;
        data["imageLink"] = this.imageLink;
        data["rewardCode"] = this.rewardCode;
        return data;
    }
}

export interface IGameRewardInformationDto {
    order: number | undefined;
    status: string | undefined;
    rewardNameEN: string | undefined;
    rewardNameVN: string | undefined;
    imageLink: string | undefined;
    rewardCode: string | undefined;
}

export class SpinGameResult implements ISpinGameResult {
    rewardCode!: string | undefined;
    rewardNameVN!: string | undefined;
    rewardNameEN!: string | undefined;
    imageLink!: string | undefined;
    memberName!: string | undefined;
    memberCode!: string | undefined;
    description!: string | undefined;
    gameCode!: string | undefined;
    creationTime!: moment.Moment | undefined;
    isSuccess!: boolean | undefined;
    errorMessage!: string | undefined;
    errorCode!: number | undefined;

    constructor(data?: ISpinGameResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.rewardCode = data["rewardCode"];
            this.rewardNameVN = data["rewardNameVN"];
            this.rewardNameEN = data["rewardNameEN"];
            this.imageLink = data["imageLink"];
            this.memberName = data["memberName"];
            this.memberCode = data["memberCode"];
            this.description = data["description"];
            this.gameCode = data["gameCode"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.isSuccess = data["isSuccess"];
            this.errorMessage = data["errorMessage"];
            this.errorCode = data["errorCode"];
        }
    }

    static fromJS(data: any): SpinGameResult {
        data = typeof data === 'object' ? data : {};
        let result = new SpinGameResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rewardCode"] = this.rewardCode;
        data["rewardNameVN"] = this.rewardNameVN;
        data["rewardNameEN"] = this.rewardNameEN;
        data["imageLink"] = this.imageLink;
        data["memberName"] = this.memberName;
        data["memberCode"] = this.memberCode;
        data["description"] = this.description;
        data["gameCode"] = this.gameCode;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["isSuccess"] = this.isSuccess;
        data["errorMessage"] = this.errorMessage;
        data["errorCode"] = this.errorCode;
        return data;
    }
}

export interface ISpinGameResult {
    rewardCode: string | undefined;
    rewardNameVN: string | undefined;
    rewardNameEN: string | undefined;
    imageLink: string | undefined;
    memberName: string | undefined;
    memberCode: string | undefined;
    description: string | undefined;
    gameCode: string | undefined;
    creationTime: moment.Moment | undefined;
    isSuccess: boolean | undefined;
    errorMessage: string | undefined;
    errorCode: number | undefined;
}

export class PagedResultDtoOfGetGamePlayHistoryForViewDto implements IPagedResultDtoOfGetGamePlayHistoryForViewDto {
    totalCount!: number | undefined;
    items!: GetGamePlayHistoryForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetGamePlayHistoryForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetGamePlayHistoryForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetGamePlayHistoryForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetGamePlayHistoryForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetGamePlayHistoryForViewDto {
    totalCount: number | undefined;
    items: GetGamePlayHistoryForViewDto[] | undefined;
}

export class GetGamePlayHistoryForViewDto implements IGetGamePlayHistoryForViewDto {
    gamePlayHistory!: GamePlayHistoryDto | undefined;

    constructor(data?: IGetGamePlayHistoryForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.gamePlayHistory = data["gamePlayHistory"] ? GamePlayHistoryDto.fromJS(data["gamePlayHistory"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetGamePlayHistoryForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGamePlayHistoryForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gamePlayHistory"] = this.gamePlayHistory ? this.gamePlayHistory.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetGamePlayHistoryForViewDto {
    gamePlayHistory: GamePlayHistoryDto | undefined;
}

export class GamePlayHistoryDto implements IGamePlayHistoryDto {
    gameCode!: string | undefined;
    playerCode!: string | undefined;
    ticketCode!: string | undefined;
    rewardCode!: string | undefined;
    rewardQuantity!: number | undefined;
    isRedeemed!: boolean | undefined;
    playerName!: string | undefined;
    rewardNameEn!: string | undefined;
    rewardNameVn!: string | undefined;
    createDate!: moment.Moment | undefined;
    id!: number | undefined;

    constructor(data?: IGamePlayHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.gameCode = data["gameCode"];
            this.playerCode = data["playerCode"];
            this.ticketCode = data["ticketCode"];
            this.rewardCode = data["rewardCode"];
            this.rewardQuantity = data["rewardQuantity"];
            this.isRedeemed = data["isRedeemed"];
            this.playerName = data["playerName"];
            this.rewardNameEn = data["rewardNameEn"];
            this.rewardNameVn = data["rewardNameVn"];
            this.createDate = data["createDate"] ? moment(data["createDate"].toString()) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): GamePlayHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new GamePlayHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gameCode"] = this.gameCode;
        data["playerCode"] = this.playerCode;
        data["ticketCode"] = this.ticketCode;
        data["rewardCode"] = this.rewardCode;
        data["rewardQuantity"] = this.rewardQuantity;
        data["isRedeemed"] = this.isRedeemed;
        data["playerName"] = this.playerName;
        data["rewardNameEn"] = this.rewardNameEn;
        data["rewardNameVn"] = this.rewardNameVn;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IGamePlayHistoryDto {
    gameCode: string | undefined;
    playerCode: string | undefined;
    ticketCode: string | undefined;
    rewardCode: string | undefined;
    rewardQuantity: number | undefined;
    isRedeemed: boolean | undefined;
    playerName: string | undefined;
    rewardNameEn: string | undefined;
    rewardNameVn: string | undefined;
    createDate: moment.Moment | undefined;
    id: number | undefined;
}

export class GetGamePlayHistoryForEditOutput implements IGetGamePlayHistoryForEditOutput {
    gamePlayHistory!: CreateOrEditGamePlayHistoryDto | undefined;

    constructor(data?: IGetGamePlayHistoryForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.gamePlayHistory = data["gamePlayHistory"] ? CreateOrEditGamePlayHistoryDto.fromJS(data["gamePlayHistory"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetGamePlayHistoryForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetGamePlayHistoryForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gamePlayHistory"] = this.gamePlayHistory ? this.gamePlayHistory.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetGamePlayHistoryForEditOutput {
    gamePlayHistory: CreateOrEditGamePlayHistoryDto | undefined;
}

export class CreateOrEditGamePlayHistoryDto implements ICreateOrEditGamePlayHistoryDto {
    gameCode!: string | undefined;
    playerCode!: string | undefined;
    ticketCode!: string | undefined;
    rewardCode!: string | undefined;
    rewardQuantity!: number | undefined;
    isRedeemed!: boolean | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditGamePlayHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.gameCode = data["gameCode"];
            this.playerCode = data["playerCode"];
            this.ticketCode = data["ticketCode"];
            this.rewardCode = data["rewardCode"];
            this.rewardQuantity = data["rewardQuantity"];
            this.isRedeemed = data["isRedeemed"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditGamePlayHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditGamePlayHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gameCode"] = this.gameCode;
        data["playerCode"] = this.playerCode;
        data["ticketCode"] = this.ticketCode;
        data["rewardCode"] = this.rewardCode;
        data["rewardQuantity"] = this.rewardQuantity;
        data["isRedeemed"] = this.isRedeemed;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditGamePlayHistoryDto {
    gameCode: string | undefined;
    playerCode: string | undefined;
    ticketCode: string | undefined;
    rewardCode: string | undefined;
    rewardQuantity: number | undefined;
    isRedeemed: boolean | undefined;
    id: number | undefined;
}

export class GiftBoxDto implements IGiftBoxDto {
    id!: number | undefined;
    rewardCode!: string | undefined;
    rewardNameEN!: string | undefined;
    rewardNameVN!: string | undefined;
    quantity!: number | undefined;
    imageLink!: string | undefined;
    creationTime!: moment.Moment | undefined;
    redeemed!: boolean | undefined;
    description!: string | undefined;

    constructor(data?: IGiftBoxDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.rewardCode = data["rewardCode"];
            this.rewardNameEN = data["rewardNameEN"];
            this.rewardNameVN = data["rewardNameVN"];
            this.quantity = data["quantity"];
            this.imageLink = data["imageLink"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.redeemed = data["redeemed"];
            this.description = data["description"];
        }
    }

    static fromJS(data: any): GiftBoxDto {
        data = typeof data === 'object' ? data : {};
        let result = new GiftBoxDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["rewardCode"] = this.rewardCode;
        data["rewardNameEN"] = this.rewardNameEN;
        data["rewardNameVN"] = this.rewardNameVN;
        data["quantity"] = this.quantity;
        data["imageLink"] = this.imageLink;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["redeemed"] = this.redeemed;
        data["description"] = this.description;
        return data;
    }
}

export interface IGiftBoxDto {
    id: number | undefined;
    rewardCode: string | undefined;
    rewardNameEN: string | undefined;
    rewardNameVN: string | undefined;
    quantity: number | undefined;
    imageLink: string | undefined;
    creationTime: moment.Moment | undefined;
    redeemed: boolean | undefined;
    description: string | undefined;
}

export class GetAllGamePlayHistorysInput implements IGetAllGamePlayHistorysInput {
    filter!: string | undefined;
    gameCodeFilter!: string | undefined;
    playerCodeFilter!: string | undefined;
    ticketCodeFilter!: string | undefined;
    rewardCodeFilter!: string | undefined;
    maxRewardQuantityFilter!: number | undefined;
    minRewardQuantityFilter!: number | undefined;
    isRedeemedFilter!: number | undefined;
    sorting!: string | undefined;
    skipCount!: number | undefined;
    maxResultCount!: number | undefined;

    constructor(data?: IGetAllGamePlayHistorysInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.filter = data["filter"];
            this.gameCodeFilter = data["gameCodeFilter"];
            this.playerCodeFilter = data["playerCodeFilter"];
            this.ticketCodeFilter = data["ticketCodeFilter"];
            this.rewardCodeFilter = data["rewardCodeFilter"];
            this.maxRewardQuantityFilter = data["maxRewardQuantityFilter"];
            this.minRewardQuantityFilter = data["minRewardQuantityFilter"];
            this.isRedeemedFilter = data["isRedeemedFilter"];
            this.sorting = data["sorting"];
            this.skipCount = data["skipCount"];
            this.maxResultCount = data["maxResultCount"];
        }
    }

    static fromJS(data: any): GetAllGamePlayHistorysInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllGamePlayHistorysInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        data["gameCodeFilter"] = this.gameCodeFilter;
        data["playerCodeFilter"] = this.playerCodeFilter;
        data["ticketCodeFilter"] = this.ticketCodeFilter;
        data["rewardCodeFilter"] = this.rewardCodeFilter;
        data["maxRewardQuantityFilter"] = this.maxRewardQuantityFilter;
        data["minRewardQuantityFilter"] = this.minRewardQuantityFilter;
        data["isRedeemedFilter"] = this.isRedeemedFilter;
        data["sorting"] = this.sorting;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data;
    }
}

export interface IGetAllGamePlayHistorysInput {
    filter: string | undefined;
    gameCodeFilter: string | undefined;
    playerCodeFilter: string | undefined;
    ticketCodeFilter: string | undefined;
    rewardCodeFilter: string | undefined;
    maxRewardQuantityFilter: number | undefined;
    minRewardQuantityFilter: number | undefined;
    isRedeemedFilter: number | undefined;
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;
}

export class GetAllGamePlayHistorysForExcelInput implements IGetAllGamePlayHistorysForExcelInput {
    filter!: string | undefined;
    gameCodeFilter!: string | undefined;
    playerCodeFilter!: string | undefined;
    ticketCodeFilter!: string | undefined;
    rewardCodeFilter!: string | undefined;
    maxRewardQuantityFilter!: number | undefined;
    minRewardQuantityFilter!: number | undefined;
    isRedeemedFilter!: number | undefined;

    constructor(data?: IGetAllGamePlayHistorysForExcelInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.filter = data["filter"];
            this.gameCodeFilter = data["gameCodeFilter"];
            this.playerCodeFilter = data["playerCodeFilter"];
            this.ticketCodeFilter = data["ticketCodeFilter"];
            this.rewardCodeFilter = data["rewardCodeFilter"];
            this.maxRewardQuantityFilter = data["maxRewardQuantityFilter"];
            this.minRewardQuantityFilter = data["minRewardQuantityFilter"];
            this.isRedeemedFilter = data["isRedeemedFilter"];
        }
    }

    static fromJS(data: any): GetAllGamePlayHistorysForExcelInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllGamePlayHistorysForExcelInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        data["gameCodeFilter"] = this.gameCodeFilter;
        data["playerCodeFilter"] = this.playerCodeFilter;
        data["ticketCodeFilter"] = this.ticketCodeFilter;
        data["rewardCodeFilter"] = this.rewardCodeFilter;
        data["maxRewardQuantityFilter"] = this.maxRewardQuantityFilter;
        data["minRewardQuantityFilter"] = this.minRewardQuantityFilter;
        data["isRedeemedFilter"] = this.isRedeemedFilter;
        return data;
    }
}

export interface IGetAllGamePlayHistorysForExcelInput {
    filter: string | undefined;
    gameCodeFilter: string | undefined;
    playerCodeFilter: string | undefined;
    ticketCodeFilter: string | undefined;
    rewardCodeFilter: string | undefined;
    maxRewardQuantityFilter: number | undefined;
    minRewardQuantityFilter: number | undefined;
    isRedeemedFilter: number | undefined;
}

export class PagedResultDtoOfGetGameRewardForViewDto implements IPagedResultDtoOfGetGameRewardForViewDto {
    totalCount!: number | undefined;
    items!: GetGameRewardForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetGameRewardForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetGameRewardForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetGameRewardForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetGameRewardForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetGameRewardForViewDto {
    totalCount: number | undefined;
    items: GetGameRewardForViewDto[] | undefined;
}

export class GetGameRewardForViewDto implements IGetGameRewardForViewDto {
    gameReward!: GameRewardDto | undefined;
    budgetString!: string | undefined;
    remainString!: string | undefined;

    constructor(data?: IGetGameRewardForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.gameReward = data["gameReward"] ? GameRewardDto.fromJS(data["gameReward"]) : <any>undefined;
            this.budgetString = data["budgetString"];
            this.remainString = data["remainString"];
        }
    }

    static fromJS(data: any): GetGameRewardForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGameRewardForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gameReward"] = this.gameReward ? this.gameReward.toJSON() : <any>undefined;
        data["budgetString"] = this.budgetString;
        data["remainString"] = this.remainString;
        return data;
    }
}

export interface IGetGameRewardForViewDto {
    gameReward: GameRewardDto | undefined;
    budgetString: string | undefined;
    remainString: string | undefined;
}

export class GameRewardDto implements IGameRewardDto {
    gameCode!: string | undefined;
    rewardCode!: string | undefined;
    rewardNameEN!: string | undefined;
    rewardNameVN!: string | undefined;
    startTime!: moment.Moment | undefined;
    endTime!: moment.Moment | undefined;
    status!: string | undefined;
    imageLink!: string | undefined;
    description!: string | undefined;
    order!: number | undefined;
    weightRatio!: number | undefined;
    budget!: number | undefined;
    usedBudget!: number | undefined;
    maxPerPlayer!: number | undefined;
    itemCode!: string | undefined;
    rewardType!: string | undefined;
    rewardPartner!: string | undefined;
    vendorCode!: string | undefined;
    amount!: number | undefined;
    id!: number | undefined;

    constructor(data?: IGameRewardDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.gameCode = data["gameCode"];
            this.rewardCode = data["rewardCode"];
            this.rewardNameEN = data["rewardNameEN"];
            this.rewardNameVN = data["rewardNameVN"];
            this.startTime = data["startTime"] ? moment(data["startTime"].toString()) : <any>undefined;
            this.endTime = data["endTime"] ? moment(data["endTime"].toString()) : <any>undefined;
            this.status = data["status"];
            this.imageLink = data["imageLink"];
            this.description = data["description"];
            this.order = data["order"];
            this.weightRatio = data["weightRatio"];
            this.budget = data["budget"];
            this.usedBudget = data["usedBudget"];
            this.maxPerPlayer = data["maxPerPlayer"];
            this.itemCode = data["itemCode"];
            this.rewardType = data["rewardType"];
            this.rewardPartner = data["rewardPartner"];
            this.vendorCode = data["vendorCode"];
            this.amount = data["amount"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): GameRewardDto {
        data = typeof data === 'object' ? data : {};
        let result = new GameRewardDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gameCode"] = this.gameCode;
        data["rewardCode"] = this.rewardCode;
        data["rewardNameEN"] = this.rewardNameEN;
        data["rewardNameVN"] = this.rewardNameVN;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["imageLink"] = this.imageLink;
        data["description"] = this.description;
        data["order"] = this.order;
        data["weightRatio"] = this.weightRatio;
        data["budget"] = this.budget;
        data["usedBudget"] = this.usedBudget;
        data["maxPerPlayer"] = this.maxPerPlayer;
        data["itemCode"] = this.itemCode;
        data["rewardType"] = this.rewardType;
        data["rewardPartner"] = this.rewardPartner;
        data["vendorCode"] = this.vendorCode;
        data["amount"] = this.amount;
        data["id"] = this.id;
        return data;
    }
}

export interface IGameRewardDto {
    gameCode: string | undefined;
    rewardCode: string | undefined;
    rewardNameEN: string | undefined;
    rewardNameVN: string | undefined;
    startTime: moment.Moment | undefined;
    endTime: moment.Moment | undefined;
    status: string | undefined;
    imageLink: string | undefined;
    description: string | undefined;
    order: number | undefined;
    weightRatio: number | undefined;
    budget: number | undefined;
    usedBudget: number | undefined;
    maxPerPlayer: number | undefined;
    itemCode: string | undefined;
    rewardType: string | undefined;
    rewardPartner: string | undefined;
    vendorCode: string | undefined;
    amount: number | undefined;
    id: number | undefined;
}

export class GetGameRewardForEditOutput implements IGetGameRewardForEditOutput {
    gameReward!: CreateOrEditGameRewardDto | undefined;

    constructor(data?: IGetGameRewardForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.gameReward = data["gameReward"] ? CreateOrEditGameRewardDto.fromJS(data["gameReward"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetGameRewardForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetGameRewardForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gameReward"] = this.gameReward ? this.gameReward.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetGameRewardForEditOutput {
    gameReward: CreateOrEditGameRewardDto | undefined;
}

export class GetAllGameRewardsInput implements IGetAllGameRewardsInput {
    filter!: string | undefined;
    gameCodeFilter!: string | undefined;
    rewardCodeFilter!: string | undefined;
    rewardNameENFilter!: string | undefined;
    rewardNameVNFilter!: string | undefined;
    maxStartTimeFilter!: moment.Moment | undefined;
    minStartTimeFilter!: moment.Moment | undefined;
    maxEndTimeFilter!: moment.Moment | undefined;
    minEndTimeFilter!: moment.Moment | undefined;
    statusFilter!: string | undefined;
    imageLinkFilter!: string | undefined;
    descriptionFilter!: string | undefined;
    maxOrderFilter!: number | undefined;
    minOrderFilter!: number | undefined;
    maxWeightRatioFilter!: number | undefined;
    minWeightRatioFilter!: number | undefined;
    maxBudgetFilter!: number | undefined;
    minBudgetFilter!: number | undefined;
    maxUsedBudgetFilter!: number | undefined;
    minUsedBudgetFilter!: number | undefined;
    maxMaxPerPlayerFilter!: number | undefined;
    minMaxPerPlayerFilter!: number | undefined;
    itemCodeFilter!: string | undefined;
    rewardTypeFilter!: string | undefined;
    rewardPartnerFilter!: string | undefined;
    vendorCodeFilter!: string | undefined;
    maxAmountFilter!: number | undefined;
    minAmountFilter!: number | undefined;
    sorting!: string | undefined;
    skipCount!: number | undefined;
    maxResultCount!: number | undefined;

    constructor(data?: IGetAllGameRewardsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.filter = data["filter"];
            this.gameCodeFilter = data["gameCodeFilter"];
            this.rewardCodeFilter = data["rewardCodeFilter"];
            this.rewardNameENFilter = data["rewardNameENFilter"];
            this.rewardNameVNFilter = data["rewardNameVNFilter"];
            this.maxStartTimeFilter = data["maxStartTimeFilter"] ? moment(data["maxStartTimeFilter"].toString()) : <any>undefined;
            this.minStartTimeFilter = data["minStartTimeFilter"] ? moment(data["minStartTimeFilter"].toString()) : <any>undefined;
            this.maxEndTimeFilter = data["maxEndTimeFilter"] ? moment(data["maxEndTimeFilter"].toString()) : <any>undefined;
            this.minEndTimeFilter = data["minEndTimeFilter"] ? moment(data["minEndTimeFilter"].toString()) : <any>undefined;
            this.statusFilter = data["statusFilter"];
            this.imageLinkFilter = data["imageLinkFilter"];
            this.descriptionFilter = data["descriptionFilter"];
            this.maxOrderFilter = data["maxOrderFilter"];
            this.minOrderFilter = data["minOrderFilter"];
            this.maxWeightRatioFilter = data["maxWeightRatioFilter"];
            this.minWeightRatioFilter = data["minWeightRatioFilter"];
            this.maxBudgetFilter = data["maxBudgetFilter"];
            this.minBudgetFilter = data["minBudgetFilter"];
            this.maxUsedBudgetFilter = data["maxUsedBudgetFilter"];
            this.minUsedBudgetFilter = data["minUsedBudgetFilter"];
            this.maxMaxPerPlayerFilter = data["maxMaxPerPlayerFilter"];
            this.minMaxPerPlayerFilter = data["minMaxPerPlayerFilter"];
            this.itemCodeFilter = data["itemCodeFilter"];
            this.rewardTypeFilter = data["rewardTypeFilter"];
            this.rewardPartnerFilter = data["rewardPartnerFilter"];
            this.vendorCodeFilter = data["vendorCodeFilter"];
            this.maxAmountFilter = data["maxAmountFilter"];
            this.minAmountFilter = data["minAmountFilter"];
            this.sorting = data["sorting"];
            this.skipCount = data["skipCount"];
            this.maxResultCount = data["maxResultCount"];
        }
    }

    static fromJS(data: any): GetAllGameRewardsInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllGameRewardsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        data["gameCodeFilter"] = this.gameCodeFilter;
        data["rewardCodeFilter"] = this.rewardCodeFilter;
        data["rewardNameENFilter"] = this.rewardNameENFilter;
        data["rewardNameVNFilter"] = this.rewardNameVNFilter;
        data["maxStartTimeFilter"] = this.maxStartTimeFilter ? this.maxStartTimeFilter.toISOString() : <any>undefined;
        data["minStartTimeFilter"] = this.minStartTimeFilter ? this.minStartTimeFilter.toISOString() : <any>undefined;
        data["maxEndTimeFilter"] = this.maxEndTimeFilter ? this.maxEndTimeFilter.toISOString() : <any>undefined;
        data["minEndTimeFilter"] = this.minEndTimeFilter ? this.minEndTimeFilter.toISOString() : <any>undefined;
        data["statusFilter"] = this.statusFilter;
        data["imageLinkFilter"] = this.imageLinkFilter;
        data["descriptionFilter"] = this.descriptionFilter;
        data["maxOrderFilter"] = this.maxOrderFilter;
        data["minOrderFilter"] = this.minOrderFilter;
        data["maxWeightRatioFilter"] = this.maxWeightRatioFilter;
        data["minWeightRatioFilter"] = this.minWeightRatioFilter;
        data["maxBudgetFilter"] = this.maxBudgetFilter;
        data["minBudgetFilter"] = this.minBudgetFilter;
        data["maxUsedBudgetFilter"] = this.maxUsedBudgetFilter;
        data["minUsedBudgetFilter"] = this.minUsedBudgetFilter;
        data["maxMaxPerPlayerFilter"] = this.maxMaxPerPlayerFilter;
        data["minMaxPerPlayerFilter"] = this.minMaxPerPlayerFilter;
        data["itemCodeFilter"] = this.itemCodeFilter;
        data["rewardTypeFilter"] = this.rewardTypeFilter;
        data["rewardPartnerFilter"] = this.rewardPartnerFilter;
        data["vendorCodeFilter"] = this.vendorCodeFilter;
        data["maxAmountFilter"] = this.maxAmountFilter;
        data["minAmountFilter"] = this.minAmountFilter;
        data["sorting"] = this.sorting;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data;
    }
}

export interface IGetAllGameRewardsInput {
    filter: string | undefined;
    gameCodeFilter: string | undefined;
    rewardCodeFilter: string | undefined;
    rewardNameENFilter: string | undefined;
    rewardNameVNFilter: string | undefined;
    maxStartTimeFilter: moment.Moment | undefined;
    minStartTimeFilter: moment.Moment | undefined;
    maxEndTimeFilter: moment.Moment | undefined;
    minEndTimeFilter: moment.Moment | undefined;
    statusFilter: string | undefined;
    imageLinkFilter: string | undefined;
    descriptionFilter: string | undefined;
    maxOrderFilter: number | undefined;
    minOrderFilter: number | undefined;
    maxWeightRatioFilter: number | undefined;
    minWeightRatioFilter: number | undefined;
    maxBudgetFilter: number | undefined;
    minBudgetFilter: number | undefined;
    maxUsedBudgetFilter: number | undefined;
    minUsedBudgetFilter: number | undefined;
    maxMaxPerPlayerFilter: number | undefined;
    minMaxPerPlayerFilter: number | undefined;
    itemCodeFilter: string | undefined;
    rewardTypeFilter: string | undefined;
    rewardPartnerFilter: string | undefined;
    vendorCodeFilter: string | undefined;
    maxAmountFilter: number | undefined;
    minAmountFilter: number | undefined;
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;
}

export class GetAllGameRewardsForExcelInput implements IGetAllGameRewardsForExcelInput {
    filter!: string | undefined;
    gameCodeFilter!: string | undefined;
    rewardCodeFilter!: string | undefined;
    rewardNameENFilter!: string | undefined;
    rewardNameVNFilter!: string | undefined;
    maxStartTimeFilter!: moment.Moment | undefined;
    minStartTimeFilter!: moment.Moment | undefined;
    maxEndTimeFilter!: moment.Moment | undefined;
    minEndTimeFilter!: moment.Moment | undefined;
    statusFilter!: string | undefined;
    imageLinkFilter!: string | undefined;
    descriptionFilter!: string | undefined;
    maxOrderFilter!: number | undefined;
    minOrderFilter!: number | undefined;
    maxWeightRatioFilter!: number | undefined;
    minWeightRatioFilter!: number | undefined;
    maxBudgetFilter!: number | undefined;
    minBudgetFilter!: number | undefined;
    maxUsedBudgetFilter!: number | undefined;
    minUsedBudgetFilter!: number | undefined;
    maxMaxPerPlayerFilter!: number | undefined;
    minMaxPerPlayerFilter!: number | undefined;
    itemCodeFilter!: string | undefined;
    rewardTypeFilter!: string | undefined;
    rewardPartnerFilter!: string | undefined;
    vendorCodeFilter!: string | undefined;
    maxAmountFilter!: number | undefined;
    minAmountFilter!: number | undefined;

    constructor(data?: IGetAllGameRewardsForExcelInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.filter = data["filter"];
            this.gameCodeFilter = data["gameCodeFilter"];
            this.rewardCodeFilter = data["rewardCodeFilter"];
            this.rewardNameENFilter = data["rewardNameENFilter"];
            this.rewardNameVNFilter = data["rewardNameVNFilter"];
            this.maxStartTimeFilter = data["maxStartTimeFilter"] ? moment(data["maxStartTimeFilter"].toString()) : <any>undefined;
            this.minStartTimeFilter = data["minStartTimeFilter"] ? moment(data["minStartTimeFilter"].toString()) : <any>undefined;
            this.maxEndTimeFilter = data["maxEndTimeFilter"] ? moment(data["maxEndTimeFilter"].toString()) : <any>undefined;
            this.minEndTimeFilter = data["minEndTimeFilter"] ? moment(data["minEndTimeFilter"].toString()) : <any>undefined;
            this.statusFilter = data["statusFilter"];
            this.imageLinkFilter = data["imageLinkFilter"];
            this.descriptionFilter = data["descriptionFilter"];
            this.maxOrderFilter = data["maxOrderFilter"];
            this.minOrderFilter = data["minOrderFilter"];
            this.maxWeightRatioFilter = data["maxWeightRatioFilter"];
            this.minWeightRatioFilter = data["minWeightRatioFilter"];
            this.maxBudgetFilter = data["maxBudgetFilter"];
            this.minBudgetFilter = data["minBudgetFilter"];
            this.maxUsedBudgetFilter = data["maxUsedBudgetFilter"];
            this.minUsedBudgetFilter = data["minUsedBudgetFilter"];
            this.maxMaxPerPlayerFilter = data["maxMaxPerPlayerFilter"];
            this.minMaxPerPlayerFilter = data["minMaxPerPlayerFilter"];
            this.itemCodeFilter = data["itemCodeFilter"];
            this.rewardTypeFilter = data["rewardTypeFilter"];
            this.rewardPartnerFilter = data["rewardPartnerFilter"];
            this.vendorCodeFilter = data["vendorCodeFilter"];
            this.maxAmountFilter = data["maxAmountFilter"];
            this.minAmountFilter = data["minAmountFilter"];
        }
    }

    static fromJS(data: any): GetAllGameRewardsForExcelInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllGameRewardsForExcelInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        data["gameCodeFilter"] = this.gameCodeFilter;
        data["rewardCodeFilter"] = this.rewardCodeFilter;
        data["rewardNameENFilter"] = this.rewardNameENFilter;
        data["rewardNameVNFilter"] = this.rewardNameVNFilter;
        data["maxStartTimeFilter"] = this.maxStartTimeFilter ? this.maxStartTimeFilter.toISOString() : <any>undefined;
        data["minStartTimeFilter"] = this.minStartTimeFilter ? this.minStartTimeFilter.toISOString() : <any>undefined;
        data["maxEndTimeFilter"] = this.maxEndTimeFilter ? this.maxEndTimeFilter.toISOString() : <any>undefined;
        data["minEndTimeFilter"] = this.minEndTimeFilter ? this.minEndTimeFilter.toISOString() : <any>undefined;
        data["statusFilter"] = this.statusFilter;
        data["imageLinkFilter"] = this.imageLinkFilter;
        data["descriptionFilter"] = this.descriptionFilter;
        data["maxOrderFilter"] = this.maxOrderFilter;
        data["minOrderFilter"] = this.minOrderFilter;
        data["maxWeightRatioFilter"] = this.maxWeightRatioFilter;
        data["minWeightRatioFilter"] = this.minWeightRatioFilter;
        data["maxBudgetFilter"] = this.maxBudgetFilter;
        data["minBudgetFilter"] = this.minBudgetFilter;
        data["maxUsedBudgetFilter"] = this.maxUsedBudgetFilter;
        data["minUsedBudgetFilter"] = this.minUsedBudgetFilter;
        data["maxMaxPerPlayerFilter"] = this.maxMaxPerPlayerFilter;
        data["minMaxPerPlayerFilter"] = this.minMaxPerPlayerFilter;
        data["itemCodeFilter"] = this.itemCodeFilter;
        data["rewardTypeFilter"] = this.rewardTypeFilter;
        data["rewardPartnerFilter"] = this.rewardPartnerFilter;
        data["vendorCodeFilter"] = this.vendorCodeFilter;
        data["maxAmountFilter"] = this.maxAmountFilter;
        data["minAmountFilter"] = this.minAmountFilter;
        return data;
    }
}

export interface IGetAllGameRewardsForExcelInput {
    filter: string | undefined;
    gameCodeFilter: string | undefined;
    rewardCodeFilter: string | undefined;
    rewardNameENFilter: string | undefined;
    rewardNameVNFilter: string | undefined;
    maxStartTimeFilter: moment.Moment | undefined;
    minStartTimeFilter: moment.Moment | undefined;
    maxEndTimeFilter: moment.Moment | undefined;
    minEndTimeFilter: moment.Moment | undefined;
    statusFilter: string | undefined;
    imageLinkFilter: string | undefined;
    descriptionFilter: string | undefined;
    maxOrderFilter: number | undefined;
    minOrderFilter: number | undefined;
    maxWeightRatioFilter: number | undefined;
    minWeightRatioFilter: number | undefined;
    maxBudgetFilter: number | undefined;
    minBudgetFilter: number | undefined;
    maxUsedBudgetFilter: number | undefined;
    minUsedBudgetFilter: number | undefined;
    maxMaxPerPlayerFilter: number | undefined;
    minMaxPerPlayerFilter: number | undefined;
    itemCodeFilter: string | undefined;
    rewardTypeFilter: string | undefined;
    rewardPartnerFilter: string | undefined;
    vendorCodeFilter: string | undefined;
    maxAmountFilter: number | undefined;
    minAmountFilter: number | undefined;
}

export class PagedResultDtoOfGetGameSettingForViewDto implements IPagedResultDtoOfGetGameSettingForViewDto {
    totalCount!: number | undefined;
    items!: GetGameSettingForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetGameSettingForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetGameSettingForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetGameSettingForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetGameSettingForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetGameSettingForViewDto {
    totalCount: number | undefined;
    items: GetGameSettingForViewDto[] | undefined;
}

export class GetGameSettingForViewDto implements IGetGameSettingForViewDto {
    gameSetting!: GameSettingDto | undefined;

    constructor(data?: IGetGameSettingForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.gameSetting = data["gameSetting"] ? GameSettingDto.fromJS(data["gameSetting"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetGameSettingForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGameSettingForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gameSetting"] = this.gameSetting ? this.gameSetting.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetGameSettingForViewDto {
    gameSetting: GameSettingDto | undefined;
}

export class GameSettingDto implements IGameSettingDto {
    code!: string | undefined;
    name!: string | undefined;
    effectiveFrom!: moment.Moment | undefined;
    effectiveTo!: moment.Moment | undefined;
    fullLink!: string | undefined;
    status!: string | undefined;
    imageLink!: string | undefined;
    description!: string | undefined;
    lotteryCode!: string | undefined;
    id!: number | undefined;

    constructor(data?: IGameSettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.name = data["name"];
            this.effectiveFrom = data["effectiveFrom"] ? moment(data["effectiveFrom"].toString()) : <any>undefined;
            this.effectiveTo = data["effectiveTo"] ? moment(data["effectiveTo"].toString()) : <any>undefined;
            this.fullLink = data["fullLink"];
            this.status = data["status"];
            this.imageLink = data["imageLink"];
            this.description = data["description"];
            this.lotteryCode = data["lotteryCode"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): GameSettingDto {
        data = typeof data === 'object' ? data : {};
        let result = new GameSettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["effectiveFrom"] = this.effectiveFrom ? this.effectiveFrom.toISOString() : <any>undefined;
        data["effectiveTo"] = this.effectiveTo ? this.effectiveTo.toISOString() : <any>undefined;
        data["fullLink"] = this.fullLink;
        data["status"] = this.status;
        data["imageLink"] = this.imageLink;
        data["description"] = this.description;
        data["lotteryCode"] = this.lotteryCode;
        data["id"] = this.id;
        return data;
    }
}

export interface IGameSettingDto {
    code: string | undefined;
    name: string | undefined;
    effectiveFrom: moment.Moment | undefined;
    effectiveTo: moment.Moment | undefined;
    fullLink: string | undefined;
    status: string | undefined;
    imageLink: string | undefined;
    description: string | undefined;
    lotteryCode: string | undefined;
    id: number | undefined;
}

export class GetGameSettingForEditOutput implements IGetGameSettingForEditOutput {
    gameSetting!: CreateOrEditGameSettingDto | undefined;

    constructor(data?: IGetGameSettingForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.gameSetting = data["gameSetting"] ? CreateOrEditGameSettingDto.fromJS(data["gameSetting"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetGameSettingForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetGameSettingForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gameSetting"] = this.gameSetting ? this.gameSetting.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetGameSettingForEditOutput {
    gameSetting: CreateOrEditGameSettingDto | undefined;
}

export class CreateOrEditGameSettingDto implements ICreateOrEditGameSettingDto {
    code!: string | undefined;
    name!: string | undefined;
    effectiveFrom!: moment.Moment | undefined;
    effectiveTo!: moment.Moment | undefined;
    fullLink!: string | undefined;
    status!: string | undefined;
    imageLink!: string | undefined;
    description!: string | undefined;
    lotteryCode!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditGameSettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.name = data["name"];
            this.effectiveFrom = data["effectiveFrom"] ? moment(data["effectiveFrom"].toString()) : <any>undefined;
            this.effectiveTo = data["effectiveTo"] ? moment(data["effectiveTo"].toString()) : <any>undefined;
            this.fullLink = data["fullLink"];
            this.status = data["status"];
            this.imageLink = data["imageLink"];
            this.description = data["description"];
            this.lotteryCode = data["lotteryCode"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditGameSettingDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditGameSettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["effectiveFrom"] = this.effectiveFrom ? this.effectiveFrom.toISOString() : <any>undefined;
        data["effectiveTo"] = this.effectiveTo ? this.effectiveTo.toISOString() : <any>undefined;
        data["fullLink"] = this.fullLink;
        data["status"] = this.status;
        data["imageLink"] = this.imageLink;
        data["description"] = this.description;
        data["lotteryCode"] = this.lotteryCode;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditGameSettingDto {
    code: string | undefined;
    name: string | undefined;
    effectiveFrom: moment.Moment | undefined;
    effectiveTo: moment.Moment | undefined;
    fullLink: string | undefined;
    status: string | undefined;
    imageLink: string | undefined;
    description: string | undefined;
    lotteryCode: string | undefined;
    id: number | undefined;
}

export class GetAllGameSettingsInput implements IGetAllGameSettingsInput {
    filter!: string | undefined;
    codeFilter!: string | undefined;
    nameFilter!: string | undefined;
    maxEffectiveFromFilter!: moment.Moment | undefined;
    minEffectiveFromFilter!: moment.Moment | undefined;
    maxEffectiveToFilter!: moment.Moment | undefined;
    minEffectiveToFilter!: moment.Moment | undefined;
    fullLinkFilter!: string | undefined;
    statusFilter!: string | undefined;
    imageLinkFilter!: string | undefined;
    descriptionFilter!: string | undefined;
    lotteryCodeFilter!: string | undefined;
    sorting!: string | undefined;
    skipCount!: number | undefined;
    maxResultCount!: number | undefined;

    constructor(data?: IGetAllGameSettingsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.filter = data["filter"];
            this.codeFilter = data["codeFilter"];
            this.nameFilter = data["nameFilter"];
            this.maxEffectiveFromFilter = data["maxEffectiveFromFilter"] ? moment(data["maxEffectiveFromFilter"].toString()) : <any>undefined;
            this.minEffectiveFromFilter = data["minEffectiveFromFilter"] ? moment(data["minEffectiveFromFilter"].toString()) : <any>undefined;
            this.maxEffectiveToFilter = data["maxEffectiveToFilter"] ? moment(data["maxEffectiveToFilter"].toString()) : <any>undefined;
            this.minEffectiveToFilter = data["minEffectiveToFilter"] ? moment(data["minEffectiveToFilter"].toString()) : <any>undefined;
            this.fullLinkFilter = data["fullLinkFilter"];
            this.statusFilter = data["statusFilter"];
            this.imageLinkFilter = data["imageLinkFilter"];
            this.descriptionFilter = data["descriptionFilter"];
            this.lotteryCodeFilter = data["lotteryCodeFilter"];
            this.sorting = data["sorting"];
            this.skipCount = data["skipCount"];
            this.maxResultCount = data["maxResultCount"];
        }
    }

    static fromJS(data: any): GetAllGameSettingsInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllGameSettingsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        data["codeFilter"] = this.codeFilter;
        data["nameFilter"] = this.nameFilter;
        data["maxEffectiveFromFilter"] = this.maxEffectiveFromFilter ? this.maxEffectiveFromFilter.toISOString() : <any>undefined;
        data["minEffectiveFromFilter"] = this.minEffectiveFromFilter ? this.minEffectiveFromFilter.toISOString() : <any>undefined;
        data["maxEffectiveToFilter"] = this.maxEffectiveToFilter ? this.maxEffectiveToFilter.toISOString() : <any>undefined;
        data["minEffectiveToFilter"] = this.minEffectiveToFilter ? this.minEffectiveToFilter.toISOString() : <any>undefined;
        data["fullLinkFilter"] = this.fullLinkFilter;
        data["statusFilter"] = this.statusFilter;
        data["imageLinkFilter"] = this.imageLinkFilter;
        data["descriptionFilter"] = this.descriptionFilter;
        data["lotteryCodeFilter"] = this.lotteryCodeFilter;
        data["sorting"] = this.sorting;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data;
    }
}

export interface IGetAllGameSettingsInput {
    filter: string | undefined;
    codeFilter: string | undefined;
    nameFilter: string | undefined;
    maxEffectiveFromFilter: moment.Moment | undefined;
    minEffectiveFromFilter: moment.Moment | undefined;
    maxEffectiveToFilter: moment.Moment | undefined;
    minEffectiveToFilter: moment.Moment | undefined;
    fullLinkFilter: string | undefined;
    statusFilter: string | undefined;
    imageLinkFilter: string | undefined;
    descriptionFilter: string | undefined;
    lotteryCodeFilter: string | undefined;
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;
}

export class PagedResultDtoOfGetGameTargetAudienceDetailForViewDto implements IPagedResultDtoOfGetGameTargetAudienceDetailForViewDto {
    totalCount!: number | undefined;
    items!: GetGameTargetAudienceDetailForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetGameTargetAudienceDetailForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetGameTargetAudienceDetailForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetGameTargetAudienceDetailForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetGameTargetAudienceDetailForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetGameTargetAudienceDetailForViewDto {
    totalCount: number | undefined;
    items: GetGameTargetAudienceDetailForViewDto[] | undefined;
}

export class GetGameTargetAudienceDetailForViewDto implements IGetGameTargetAudienceDetailForViewDto {
    gameTargetAudienceDetail!: GameTargetAudienceDetailDto | undefined;

    constructor(data?: IGetGameTargetAudienceDetailForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.gameTargetAudienceDetail = data["gameTargetAudienceDetail"] ? GameTargetAudienceDetailDto.fromJS(data["gameTargetAudienceDetail"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetGameTargetAudienceDetailForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGameTargetAudienceDetailForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gameTargetAudienceDetail"] = this.gameTargetAudienceDetail ? this.gameTargetAudienceDetail.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetGameTargetAudienceDetailForViewDto {
    gameTargetAudienceDetail: GameTargetAudienceDetailDto | undefined;
}

export class GameTargetAudienceDetailDto implements IGameTargetAudienceDetailDto {
    gameTargetAudienceID!: number | undefined;
    name!: string | undefined;
    phone!: string | undefined;
    zaloChatID!: string | undefined;
    email!: string | undefined;
    facebookID!: string | undefined;
    memberCode!: string | undefined;
    communicationLanguage!: string | undefined;
    communicationChannel!: string | undefined;
    outletCode!: string | undefined;
    id!: number | undefined;

    constructor(data?: IGameTargetAudienceDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.gameTargetAudienceID = data["gameTargetAudienceID"];
            this.name = data["name"];
            this.phone = data["phone"];
            this.zaloChatID = data["zaloChatID"];
            this.email = data["email"];
            this.facebookID = data["facebookID"];
            this.memberCode = data["memberCode"];
            this.communicationLanguage = data["communicationLanguage"];
            this.communicationChannel = data["communicationChannel"];
            this.outletCode = data["outletCode"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): GameTargetAudienceDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new GameTargetAudienceDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gameTargetAudienceID"] = this.gameTargetAudienceID;
        data["name"] = this.name;
        data["phone"] = this.phone;
        data["zaloChatID"] = this.zaloChatID;
        data["email"] = this.email;
        data["facebookID"] = this.facebookID;
        data["memberCode"] = this.memberCode;
        data["communicationLanguage"] = this.communicationLanguage;
        data["communicationChannel"] = this.communicationChannel;
        data["outletCode"] = this.outletCode;
        data["id"] = this.id;
        return data;
    }
}

export interface IGameTargetAudienceDetailDto {
    gameTargetAudienceID: number | undefined;
    name: string | undefined;
    phone: string | undefined;
    zaloChatID: string | undefined;
    email: string | undefined;
    facebookID: string | undefined;
    memberCode: string | undefined;
    communicationLanguage: string | undefined;
    communicationChannel: string | undefined;
    outletCode: string | undefined;
    id: number | undefined;
}

export class GetGameTargetAudienceDetailForEditOutput implements IGetGameTargetAudienceDetailForEditOutput {
    gameTargetAudienceDetail!: CreateOrEditGameTargetAudienceDetailDto | undefined;

    constructor(data?: IGetGameTargetAudienceDetailForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.gameTargetAudienceDetail = data["gameTargetAudienceDetail"] ? CreateOrEditGameTargetAudienceDetailDto.fromJS(data["gameTargetAudienceDetail"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetGameTargetAudienceDetailForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetGameTargetAudienceDetailForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gameTargetAudienceDetail"] = this.gameTargetAudienceDetail ? this.gameTargetAudienceDetail.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetGameTargetAudienceDetailForEditOutput {
    gameTargetAudienceDetail: CreateOrEditGameTargetAudienceDetailDto | undefined;
}

export class CreateOrEditGameTargetAudienceDetailDto implements ICreateOrEditGameTargetAudienceDetailDto {
    gameTargetAudienceID!: number | undefined;
    name!: string | undefined;
    phone!: string | undefined;
    zaloChatID!: string | undefined;
    email!: string | undefined;
    facebookID!: string | undefined;
    memberCode!: string | undefined;
    communicationLanguage!: string | undefined;
    communicationChannel!: string | undefined;
    outletCode!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditGameTargetAudienceDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.gameTargetAudienceID = data["gameTargetAudienceID"];
            this.name = data["name"];
            this.phone = data["phone"];
            this.zaloChatID = data["zaloChatID"];
            this.email = data["email"];
            this.facebookID = data["facebookID"];
            this.memberCode = data["memberCode"];
            this.communicationLanguage = data["communicationLanguage"];
            this.communicationChannel = data["communicationChannel"];
            this.outletCode = data["outletCode"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditGameTargetAudienceDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditGameTargetAudienceDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gameTargetAudienceID"] = this.gameTargetAudienceID;
        data["name"] = this.name;
        data["phone"] = this.phone;
        data["zaloChatID"] = this.zaloChatID;
        data["email"] = this.email;
        data["facebookID"] = this.facebookID;
        data["memberCode"] = this.memberCode;
        data["communicationLanguage"] = this.communicationLanguage;
        data["communicationChannel"] = this.communicationChannel;
        data["outletCode"] = this.outletCode;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditGameTargetAudienceDetailDto {
    gameTargetAudienceID: number | undefined;
    name: string | undefined;
    phone: string | undefined;
    zaloChatID: string | undefined;
    email: string | undefined;
    facebookID: string | undefined;
    memberCode: string | undefined;
    communicationLanguage: string | undefined;
    communicationChannel: string | undefined;
    outletCode: string | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfGetGameTargetAudienceForViewDto implements IPagedResultDtoOfGetGameTargetAudienceForViewDto {
    totalCount!: number | undefined;
    items!: GetGameTargetAudienceForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetGameTargetAudienceForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetGameTargetAudienceForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetGameTargetAudienceForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetGameTargetAudienceForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetGameTargetAudienceForViewDto {
    totalCount: number | undefined;
    items: GetGameTargetAudienceForViewDto[] | undefined;
}

export class GetGameTargetAudienceForViewDto implements IGetGameTargetAudienceForViewDto {
    gameTargetAudience!: GameTargetAudienceDto | undefined;

    constructor(data?: IGetGameTargetAudienceForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.gameTargetAudience = data["gameTargetAudience"] ? GameTargetAudienceDto.fromJS(data["gameTargetAudience"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetGameTargetAudienceForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGameTargetAudienceForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gameTargetAudience"] = this.gameTargetAudience ? this.gameTargetAudience.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetGameTargetAudienceForViewDto {
    gameTargetAudience: GameTargetAudienceDto | undefined;
}

export class GameTargetAudienceDto implements IGameTargetAudienceDto {
    targetAudienceName!: string | undefined;
    description!: string | undefined;
    status!: string | undefined;
    id!: number | undefined;

    constructor(data?: IGameTargetAudienceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.targetAudienceName = data["targetAudienceName"];
            this.description = data["description"];
            this.status = data["status"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): GameTargetAudienceDto {
        data = typeof data === 'object' ? data : {};
        let result = new GameTargetAudienceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["targetAudienceName"] = this.targetAudienceName;
        data["description"] = this.description;
        data["status"] = this.status;
        data["id"] = this.id;
        return data;
    }
}

export interface IGameTargetAudienceDto {
    targetAudienceName: string | undefined;
    description: string | undefined;
    status: string | undefined;
    id: number | undefined;
}

export class GetGameTargetAudienceForEditOutput implements IGetGameTargetAudienceForEditOutput {
    gameTargetAudience!: CreateOrEditGameTargetAudienceDto | undefined;

    constructor(data?: IGetGameTargetAudienceForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.gameTargetAudience = data["gameTargetAudience"] ? CreateOrEditGameTargetAudienceDto.fromJS(data["gameTargetAudience"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetGameTargetAudienceForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetGameTargetAudienceForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gameTargetAudience"] = this.gameTargetAudience ? this.gameTargetAudience.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetGameTargetAudienceForEditOutput {
    gameTargetAudience: CreateOrEditGameTargetAudienceDto | undefined;
}

export class CreateOrEditGameTargetAudienceDto implements ICreateOrEditGameTargetAudienceDto {
    targetAudienceName!: string | undefined;
    description!: string | undefined;
    status!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditGameTargetAudienceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.targetAudienceName = data["targetAudienceName"];
            this.description = data["description"];
            this.status = data["status"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditGameTargetAudienceDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditGameTargetAudienceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["targetAudienceName"] = this.targetAudienceName;
        data["description"] = this.description;
        data["status"] = this.status;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditGameTargetAudienceDto {
    targetAudienceName: string | undefined;
    description: string | undefined;
    status: string | undefined;
    id: number | undefined;
}

export class GetAllGameTargetAudiencesInput implements IGetAllGameTargetAudiencesInput {
    filter!: string | undefined;
    targetAudienceNameFilter!: string | undefined;
    descriptionFilter!: string | undefined;
    statusFilter!: string | undefined;
    sorting!: string | undefined;
    skipCount!: number | undefined;
    maxResultCount!: number | undefined;

    constructor(data?: IGetAllGameTargetAudiencesInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.filter = data["filter"];
            this.targetAudienceNameFilter = data["targetAudienceNameFilter"];
            this.descriptionFilter = data["descriptionFilter"];
            this.statusFilter = data["statusFilter"];
            this.sorting = data["sorting"];
            this.skipCount = data["skipCount"];
            this.maxResultCount = data["maxResultCount"];
        }
    }

    static fromJS(data: any): GetAllGameTargetAudiencesInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllGameTargetAudiencesInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        data["targetAudienceNameFilter"] = this.targetAudienceNameFilter;
        data["descriptionFilter"] = this.descriptionFilter;
        data["statusFilter"] = this.statusFilter;
        data["sorting"] = this.sorting;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data;
    }
}

export interface IGetAllGameTargetAudiencesInput {
    filter: string | undefined;
    targetAudienceNameFilter: string | undefined;
    descriptionFilter: string | undefined;
    statusFilter: string | undefined;
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;
}

export class PagedResultDtoOfGetGeneratedVoucherForViewDto implements IPagedResultDtoOfGetGeneratedVoucherForViewDto {
    totalCount!: number | undefined;
    items!: GetGeneratedVoucherForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetGeneratedVoucherForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetGeneratedVoucherForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetGeneratedVoucherForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetGeneratedVoucherForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetGeneratedVoucherForViewDto {
    totalCount: number | undefined;
    items: GetGeneratedVoucherForViewDto[] | undefined;
}

export class GetGeneratedVoucherForViewDto implements IGetGeneratedVoucherForViewDto {
    generatedVoucher!: GeneratedVoucherDto | undefined;

    constructor(data?: IGetGeneratedVoucherForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.generatedVoucher = data["generatedVoucher"] ? GeneratedVoucherDto.fromJS(data["generatedVoucher"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetGeneratedVoucherForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeneratedVoucherForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["generatedVoucher"] = this.generatedVoucher ? this.generatedVoucher.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetGeneratedVoucherForViewDto {
    generatedVoucher: GeneratedVoucherDto | undefined;
}

export class GeneratedVoucherDto implements IGeneratedVoucherDto {
    voucherGroupCode!: string | undefined;
    patternCode!: string | undefined;
    voucherCode!: string | undefined;
    id!: number | undefined;

    constructor(data?: IGeneratedVoucherDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.voucherGroupCode = data["voucherGroupCode"];
            this.patternCode = data["patternCode"];
            this.voucherCode = data["voucherCode"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): GeneratedVoucherDto {
        data = typeof data === 'object' ? data : {};
        let result = new GeneratedVoucherDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["voucherGroupCode"] = this.voucherGroupCode;
        data["patternCode"] = this.patternCode;
        data["voucherCode"] = this.voucherCode;
        data["id"] = this.id;
        return data;
    }
}

export interface IGeneratedVoucherDto {
    voucherGroupCode: string | undefined;
    patternCode: string | undefined;
    voucherCode: string | undefined;
    id: number | undefined;
}

export class GetGeneratedVoucherForEditOutput implements IGetGeneratedVoucherForEditOutput {
    generatedVoucher!: CreateOrEditGeneratedVoucherDto | undefined;

    constructor(data?: IGetGeneratedVoucherForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.generatedVoucher = data["generatedVoucher"] ? CreateOrEditGeneratedVoucherDto.fromJS(data["generatedVoucher"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetGeneratedVoucherForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeneratedVoucherForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["generatedVoucher"] = this.generatedVoucher ? this.generatedVoucher.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetGeneratedVoucherForEditOutput {
    generatedVoucher: CreateOrEditGeneratedVoucherDto | undefined;
}

export class CreateOrEditGeneratedVoucherDto implements ICreateOrEditGeneratedVoucherDto {
    voucherGroupCode!: string | undefined;
    patternCode!: string | undefined;
    voucherCode!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditGeneratedVoucherDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.voucherGroupCode = data["voucherGroupCode"];
            this.patternCode = data["patternCode"];
            this.voucherCode = data["voucherCode"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditGeneratedVoucherDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditGeneratedVoucherDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["voucherGroupCode"] = this.voucherGroupCode;
        data["patternCode"] = this.patternCode;
        data["voucherCode"] = this.voucherCode;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditGeneratedVoucherDto {
    voucherGroupCode: string | undefined;
    patternCode: string | undefined;
    voucherCode: string | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfGetGeneratorDetailForViewDto implements IPagedResultDtoOfGetGeneratorDetailForViewDto {
    totalCount!: number | undefined;
    items!: GetGeneratorDetailForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetGeneratorDetailForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetGeneratorDetailForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetGeneratorDetailForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetGeneratorDetailForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetGeneratorDetailForViewDto {
    totalCount: number | undefined;
    items: GetGeneratorDetailForViewDto[] | undefined;
}

export class GetGeneratorDetailForViewDto implements IGetGeneratorDetailForViewDto {
    generatorDetail!: GeneratorDetailDto | undefined;

    constructor(data?: IGetGeneratorDetailForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.generatorDetail = data["generatorDetail"] ? GeneratorDetailDto.fromJS(data["generatorDetail"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetGeneratorDetailForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeneratorDetailForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["generatorDetail"] = this.generatorDetail ? this.generatorDetail.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetGeneratorDetailForViewDto {
    generatorDetail: GeneratorDetailDto | undefined;
}

export class GeneratorDetailDto implements IGeneratorDetailDto {
    generatorCode!: string | undefined;
    ordinal!: number | undefined;
    syntaxCode!: string | undefined;
    parameterValue1!: string | undefined;
    parameterValue2!: string | undefined;
    generatorDetailID!: string | undefined;
    lastValue!: string | undefined;
    id!: number | undefined;

    constructor(data?: IGeneratorDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.generatorCode = data["generatorCode"];
            this.ordinal = data["ordinal"];
            this.syntaxCode = data["syntaxCode"];
            this.parameterValue1 = data["parameterValue1"];
            this.parameterValue2 = data["parameterValue2"];
            this.generatorDetailID = data["generatorDetailID"];
            this.lastValue = data["lastValue"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): GeneratorDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new GeneratorDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["generatorCode"] = this.generatorCode;
        data["ordinal"] = this.ordinal;
        data["syntaxCode"] = this.syntaxCode;
        data["parameterValue1"] = this.parameterValue1;
        data["parameterValue2"] = this.parameterValue2;
        data["generatorDetailID"] = this.generatorDetailID;
        data["lastValue"] = this.lastValue;
        data["id"] = this.id;
        return data;
    }
}

export interface IGeneratorDetailDto {
    generatorCode: string | undefined;
    ordinal: number | undefined;
    syntaxCode: string | undefined;
    parameterValue1: string | undefined;
    parameterValue2: string | undefined;
    generatorDetailID: string | undefined;
    lastValue: string | undefined;
    id: number | undefined;
}

export class GetGeneratorDetailForEditOutput implements IGetGeneratorDetailForEditOutput {
    generatorDetail!: CreateOrEditGeneratorDetailDto | undefined;

    constructor(data?: IGetGeneratorDetailForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.generatorDetail = data["generatorDetail"] ? CreateOrEditGeneratorDetailDto.fromJS(data["generatorDetail"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetGeneratorDetailForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeneratorDetailForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["generatorDetail"] = this.generatorDetail ? this.generatorDetail.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetGeneratorDetailForEditOutput {
    generatorDetail: CreateOrEditGeneratorDetailDto | undefined;
}

export class CreateOrEditGeneratorDetailDto implements ICreateOrEditGeneratorDetailDto {
    generatorCode!: string | undefined;
    ordinal!: number | undefined;
    syntaxCode!: string | undefined;
    parameterValue1!: string | undefined;
    parameterValue2!: string | undefined;
    generatorDetailID!: string | undefined;
    lastValue!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditGeneratorDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.generatorCode = data["generatorCode"];
            this.ordinal = data["ordinal"];
            this.syntaxCode = data["syntaxCode"];
            this.parameterValue1 = data["parameterValue1"];
            this.parameterValue2 = data["parameterValue2"];
            this.generatorDetailID = data["generatorDetailID"];
            this.lastValue = data["lastValue"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditGeneratorDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditGeneratorDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["generatorCode"] = this.generatorCode;
        data["ordinal"] = this.ordinal;
        data["syntaxCode"] = this.syntaxCode;
        data["parameterValue1"] = this.parameterValue1;
        data["parameterValue2"] = this.parameterValue2;
        data["generatorDetailID"] = this.generatorDetailID;
        data["lastValue"] = this.lastValue;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditGeneratorDetailDto {
    generatorCode: string | undefined;
    ordinal: number | undefined;
    syntaxCode: string | undefined;
    parameterValue1: string | undefined;
    parameterValue2: string | undefined;
    generatorDetailID: string | undefined;
    lastValue: string | undefined;
    id: number | undefined;
}

export class CodeGeneratorFileDto implements ICodeGeneratorFileDto {
    fileName!: string;
    fileType!: string;
    fileToken!: string;

    constructor(data?: ICodeGeneratorFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.fileName = data["fileName"];
            this.fileType = data["fileType"];
            this.fileToken = data["fileToken"];
        }
    }

    static fromJS(data: any): CodeGeneratorFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new CodeGeneratorFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["fileType"] = this.fileType;
        data["fileToken"] = this.fileToken;
        return data;
    }
}

export interface ICodeGeneratorFileDto {
    fileName: string;
    fileType: string;
    fileToken: string;
}

export class PagedResultDtoOfGetGeneratorHeaderForViewDto implements IPagedResultDtoOfGetGeneratorHeaderForViewDto {
    totalCount!: number | undefined;
    items!: GetGeneratorHeaderForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetGeneratorHeaderForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetGeneratorHeaderForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetGeneratorHeaderForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetGeneratorHeaderForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetGeneratorHeaderForViewDto {
    totalCount: number | undefined;
    items: GetGeneratorHeaderForViewDto[] | undefined;
}

export class GetGeneratorHeaderForViewDto implements IGetGeneratorHeaderForViewDto {
    generatorHeader!: GeneratorHeaderDto | undefined;

    constructor(data?: IGetGeneratorHeaderForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.generatorHeader = data["generatorHeader"] ? GeneratorHeaderDto.fromJS(data["generatorHeader"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetGeneratorHeaderForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeneratorHeaderForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["generatorHeader"] = this.generatorHeader ? this.generatorHeader.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetGeneratorHeaderForViewDto {
    generatorHeader: GeneratorHeaderDto | undefined;
}

export class GeneratorHeaderDto implements IGeneratorHeaderDto {
    generatorCode!: string | undefined;
    generatorName!: string | undefined;
    description!: string | undefined;
    delimiter!: string | undefined;
    id!: number | undefined;

    constructor(data?: IGeneratorHeaderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.generatorCode = data["generatorCode"];
            this.generatorName = data["generatorName"];
            this.description = data["description"];
            this.delimiter = data["delimiter"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): GeneratorHeaderDto {
        data = typeof data === 'object' ? data : {};
        let result = new GeneratorHeaderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["generatorCode"] = this.generatorCode;
        data["generatorName"] = this.generatorName;
        data["description"] = this.description;
        data["delimiter"] = this.delimiter;
        data["id"] = this.id;
        return data;
    }
}

export interface IGeneratorHeaderDto {
    generatorCode: string | undefined;
    generatorName: string | undefined;
    description: string | undefined;
    delimiter: string | undefined;
    id: number | undefined;
}

export class GetGeneratorHeaderForEditOutput implements IGetGeneratorHeaderForEditOutput {
    generatorHeader!: CreateOrEditGeneratorHeaderDto | undefined;

    constructor(data?: IGetGeneratorHeaderForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.generatorHeader = data["generatorHeader"] ? CreateOrEditGeneratorHeaderDto.fromJS(data["generatorHeader"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetGeneratorHeaderForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeneratorHeaderForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["generatorHeader"] = this.generatorHeader ? this.generatorHeader.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetGeneratorHeaderForEditOutput {
    generatorHeader: CreateOrEditGeneratorHeaderDto | undefined;
}

export class CreateOrEditGeneratorHeaderDto implements ICreateOrEditGeneratorHeaderDto {
    generatorCode!: string | undefined;
    generatorName!: string | undefined;
    description!: string | undefined;
    delimiter!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditGeneratorHeaderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.generatorCode = data["generatorCode"];
            this.generatorName = data["generatorName"];
            this.description = data["description"];
            this.delimiter = data["delimiter"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditGeneratorHeaderDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditGeneratorHeaderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["generatorCode"] = this.generatorCode;
        data["generatorName"] = this.generatorName;
        data["description"] = this.description;
        data["delimiter"] = this.delimiter;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditGeneratorHeaderDto {
    generatorCode: string | undefined;
    generatorName: string | undefined;
    description: string | undefined;
    delimiter: string | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfGetGiftCampaignForViewDto implements IPagedResultDtoOfGetGiftCampaignForViewDto {
    totalCount!: number | undefined;
    items!: GetGiftCampaignForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetGiftCampaignForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetGiftCampaignForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetGiftCampaignForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetGiftCampaignForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetGiftCampaignForViewDto {
    totalCount: number | undefined;
    items: GetGiftCampaignForViewDto[] | undefined;
}

export class GetGiftCampaignForViewDto implements IGetGiftCampaignForViewDto {
    giftCampaign!: GiftCampaignDto | undefined;

    constructor(data?: IGetGiftCampaignForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.giftCampaign = data["giftCampaign"] ? GiftCampaignDto.fromJS(data["giftCampaign"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetGiftCampaignForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGiftCampaignForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["giftCampaign"] = this.giftCampaign ? this.giftCampaign.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetGiftCampaignForViewDto {
    giftCampaign: GiftCampaignDto | undefined;
}

export class GiftCampaignDto implements IGiftCampaignDto {
    code!: string | undefined;
    name!: string | undefined;
    nameUnsign!: string | undefined;
    targetAudienceType!: string | undefined;
    targetAudienceID!: number | undefined;
    publisherCode!: string | undefined;
    description!: string | undefined;
    imageLink!: string | undefined;
    status!: string | undefined;
    cron!: string | undefined;
    giftMasterCode!: string | undefined;
    giftMasterName!: string | undefined;
    giftMasterValue!: number | undefined;
    quantity!: number | undefined;
    quantityAllocated!: number | undefined;
    remainingQuantity!: number | undefined;
    effectiveFrom!: moment.Moment | undefined;
    effectiveTo!: moment.Moment | undefined;
    expireDate!: moment.Moment | undefined;
    isGranted!: boolean | undefined;
    id!: number | undefined;

    constructor(data?: IGiftCampaignDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.name = data["name"];
            this.nameUnsign = data["nameUnsign"];
            this.targetAudienceType = data["targetAudienceType"];
            this.targetAudienceID = data["targetAudienceID"];
            this.publisherCode = data["publisherCode"];
            this.description = data["description"];
            this.imageLink = data["imageLink"];
            this.status = data["status"];
            this.cron = data["cron"];
            this.giftMasterCode = data["giftMasterCode"];
            this.giftMasterName = data["giftMasterName"];
            this.giftMasterValue = data["giftMasterValue"];
            this.quantity = data["quantity"];
            this.quantityAllocated = data["quantityAllocated"];
            this.remainingQuantity = data["remainingQuantity"];
            this.effectiveFrom = data["effectiveFrom"] ? moment(data["effectiveFrom"].toString()) : <any>undefined;
            this.effectiveTo = data["effectiveTo"] ? moment(data["effectiveTo"].toString()) : <any>undefined;
            this.expireDate = data["expireDate"] ? moment(data["expireDate"].toString()) : <any>undefined;
            this.isGranted = data["isGranted"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): GiftCampaignDto {
        data = typeof data === 'object' ? data : {};
        let result = new GiftCampaignDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["nameUnsign"] = this.nameUnsign;
        data["targetAudienceType"] = this.targetAudienceType;
        data["targetAudienceID"] = this.targetAudienceID;
        data["publisherCode"] = this.publisherCode;
        data["description"] = this.description;
        data["imageLink"] = this.imageLink;
        data["status"] = this.status;
        data["cron"] = this.cron;
        data["giftMasterCode"] = this.giftMasterCode;
        data["giftMasterName"] = this.giftMasterName;
        data["giftMasterValue"] = this.giftMasterValue;
        data["quantity"] = this.quantity;
        data["quantityAllocated"] = this.quantityAllocated;
        data["remainingQuantity"] = this.remainingQuantity;
        data["effectiveFrom"] = this.effectiveFrom ? this.effectiveFrom.toISOString() : <any>undefined;
        data["effectiveTo"] = this.effectiveTo ? this.effectiveTo.toISOString() : <any>undefined;
        data["expireDate"] = this.expireDate ? this.expireDate.toISOString() : <any>undefined;
        data["isGranted"] = this.isGranted;
        data["id"] = this.id;
        return data;
    }
}

export interface IGiftCampaignDto {
    code: string | undefined;
    name: string | undefined;
    nameUnsign: string | undefined;
    targetAudienceType: string | undefined;
    targetAudienceID: number | undefined;
    publisherCode: string | undefined;
    description: string | undefined;
    imageLink: string | undefined;
    status: string | undefined;
    cron: string | undefined;
    giftMasterCode: string | undefined;
    giftMasterName: string | undefined;
    giftMasterValue: number | undefined;
    quantity: number | undefined;
    quantityAllocated: number | undefined;
    remainingQuantity: number | undefined;
    effectiveFrom: moment.Moment | undefined;
    effectiveTo: moment.Moment | undefined;
    expireDate: moment.Moment | undefined;
    isGranted: boolean | undefined;
    id: number | undefined;
}

export class GetGiftCampaignForEditOutput implements IGetGiftCampaignForEditOutput {
    giftCampaign!: CreateOrEditGiftCampaignDto | undefined;

    constructor(data?: IGetGiftCampaignForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.giftCampaign = data["giftCampaign"] ? CreateOrEditGiftCampaignDto.fromJS(data["giftCampaign"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetGiftCampaignForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetGiftCampaignForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["giftCampaign"] = this.giftCampaign ? this.giftCampaign.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetGiftCampaignForEditOutput {
    giftCampaign: CreateOrEditGiftCampaignDto | undefined;
}

export class CreateOrEditGiftCampaignDto implements ICreateOrEditGiftCampaignDto {
    code!: string | undefined;
    name!: string | undefined;
    nameUnsign!: string | undefined;
    targetAudienceType!: string | undefined;
    targetAudienceID!: number | undefined;
    publisherCode!: string | undefined;
    description!: string | undefined;
    imageLink!: string | undefined;
    status!: string | undefined;
    cron!: string | undefined;
    giftMasterCode!: string | undefined;
    giftMasterName!: string | undefined;
    giftMasterValue!: number | undefined;
    quantity!: number | undefined;
    quantityAllocated!: number | undefined;
    remainingQuantity!: number | undefined;
    effectiveFrom!: moment.Moment | undefined;
    effectiveTo!: moment.Moment | undefined;
    expireDate!: moment.Moment | undefined;
    isGranted!: boolean | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditGiftCampaignDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.name = data["name"];
            this.nameUnsign = data["nameUnsign"];
            this.targetAudienceType = data["targetAudienceType"];
            this.targetAudienceID = data["targetAudienceID"];
            this.publisherCode = data["publisherCode"];
            this.description = data["description"];
            this.imageLink = data["imageLink"];
            this.status = data["status"];
            this.cron = data["cron"];
            this.giftMasterCode = data["giftMasterCode"];
            this.giftMasterName = data["giftMasterName"];
            this.giftMasterValue = data["giftMasterValue"];
            this.quantity = data["quantity"];
            this.quantityAllocated = data["quantityAllocated"];
            this.remainingQuantity = data["remainingQuantity"];
            this.effectiveFrom = data["effectiveFrom"] ? moment(data["effectiveFrom"].toString()) : <any>undefined;
            this.effectiveTo = data["effectiveTo"] ? moment(data["effectiveTo"].toString()) : <any>undefined;
            this.expireDate = data["expireDate"] ? moment(data["expireDate"].toString()) : <any>undefined;
            this.isGranted = data["isGranted"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditGiftCampaignDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditGiftCampaignDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["nameUnsign"] = this.nameUnsign;
        data["targetAudienceType"] = this.targetAudienceType;
        data["targetAudienceID"] = this.targetAudienceID;
        data["publisherCode"] = this.publisherCode;
        data["description"] = this.description;
        data["imageLink"] = this.imageLink;
        data["status"] = this.status;
        data["cron"] = this.cron;
        data["giftMasterCode"] = this.giftMasterCode;
        data["giftMasterName"] = this.giftMasterName;
        data["giftMasterValue"] = this.giftMasterValue;
        data["quantity"] = this.quantity;
        data["quantityAllocated"] = this.quantityAllocated;
        data["remainingQuantity"] = this.remainingQuantity;
        data["effectiveFrom"] = this.effectiveFrom ? this.effectiveFrom.toISOString() : <any>undefined;
        data["effectiveTo"] = this.effectiveTo ? this.effectiveTo.toISOString() : <any>undefined;
        data["expireDate"] = this.expireDate ? this.expireDate.toISOString() : <any>undefined;
        data["isGranted"] = this.isGranted;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditGiftCampaignDto {
    code: string | undefined;
    name: string | undefined;
    nameUnsign: string | undefined;
    targetAudienceType: string | undefined;
    targetAudienceID: number | undefined;
    publisherCode: string | undefined;
    description: string | undefined;
    imageLink: string | undefined;
    status: string | undefined;
    cron: string | undefined;
    giftMasterCode: string | undefined;
    giftMasterName: string | undefined;
    giftMasterValue: number | undefined;
    quantity: number | undefined;
    quantityAllocated: number | undefined;
    remainingQuantity: number | undefined;
    effectiveFrom: moment.Moment | undefined;
    effectiveTo: moment.Moment | undefined;
    expireDate: moment.Moment | undefined;
    isGranted: boolean | undefined;
    id: number | undefined;
}

export class GiftFileDto implements IGiftFileDto {
    fileName!: string;
    fileType!: string;
    fileToken!: string;

    constructor(data?: IGiftFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.fileName = data["fileName"];
            this.fileType = data["fileType"];
            this.fileToken = data["fileToken"];
        }
    }

    static fromJS(data: any): GiftFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new GiftFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["fileType"] = this.fileType;
        data["fileToken"] = this.fileToken;
        return data;
    }
}

export interface IGiftFileDto {
    fileName: string;
    fileType: string;
    fileToken: string;
}

export class GiftCampaignsImportAgrs implements IGiftCampaignsImportAgrs {
    giftCampaignsImportDto!: CreateOrEditGiftCampaignDto | undefined;
    targetAudienceName!: string | undefined;
    tableName!: string | undefined;
    filePath!: string | undefined;
    fileName!: string | undefined;
    userId!: number | undefined;
    tenantId!: number | undefined;
    currentLanguage!: string | undefined;
    apiUrl!: string | undefined;

    constructor(data?: IGiftCampaignsImportAgrs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.giftCampaignsImportDto = data["giftCampaignsImportDto"] ? CreateOrEditGiftCampaignDto.fromJS(data["giftCampaignsImportDto"]) : <any>undefined;
            this.targetAudienceName = data["targetAudienceName"];
            this.tableName = data["tableName"];
            this.filePath = data["filePath"];
            this.fileName = data["fileName"];
            this.userId = data["userId"];
            this.tenantId = data["tenantId"];
            this.currentLanguage = data["currentLanguage"];
            this.apiUrl = data["apiUrl"];
        }
    }

    static fromJS(data: any): GiftCampaignsImportAgrs {
        data = typeof data === 'object' ? data : {};
        let result = new GiftCampaignsImportAgrs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["giftCampaignsImportDto"] = this.giftCampaignsImportDto ? this.giftCampaignsImportDto.toJSON() : <any>undefined;
        data["targetAudienceName"] = this.targetAudienceName;
        data["tableName"] = this.tableName;
        data["filePath"] = this.filePath;
        data["fileName"] = this.fileName;
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["currentLanguage"] = this.currentLanguage;
        data["apiUrl"] = this.apiUrl;
        return data;
    }
}

export interface IGiftCampaignsImportAgrs {
    giftCampaignsImportDto: CreateOrEditGiftCampaignDto | undefined;
    targetAudienceName: string | undefined;
    tableName: string | undefined;
    filePath: string | undefined;
    fileName: string | undefined;
    userId: number | undefined;
    tenantId: number | undefined;
    currentLanguage: string | undefined;
    apiUrl: string | undefined;
}

export class GetAllGiftCampaignsInput implements IGetAllGiftCampaignsInput {
    filter!: string | undefined;
    codeFilter!: string | undefined;
    nameFilter!: string | undefined;
    nameUnsignFilter!: string | undefined;
    targetAudienceTypeFilter!: string | undefined;
    maxTargetAudienceIDFilter!: number | undefined;
    minTargetAudienceIDFilter!: number | undefined;
    publisherCodeFilter!: string | undefined;
    descriptionFilter!: string | undefined;
    imageLinkFilter!: string | undefined;
    statusFilter!: string | undefined;
    cronFilter!: string | undefined;
    giftMasterCodeFilter!: string | undefined;
    giftMasterNameFilter!: string | undefined;
    maxGiftMasterValueFilter!: number | undefined;
    minGiftMasterValueFilter!: number | undefined;
    maxQuantityFilter!: number | undefined;
    minQuantityFilter!: number | undefined;
    maxQuantityAllocatedFilter!: number | undefined;
    minQuantityAllocatedFilter!: number | undefined;
    maxRemainingQuantityFilter!: number | undefined;
    minRemainingQuantityFilter!: number | undefined;
    maxEffectiveFromFilter!: moment.Moment | undefined;
    minEffectiveFromFilter!: moment.Moment | undefined;
    maxEffectiveToFilter!: moment.Moment | undefined;
    minEffectiveToFilter!: moment.Moment | undefined;
    maxExpireDateFilter!: moment.Moment | undefined;
    minExpireDateFilter!: moment.Moment | undefined;
    isGrantedFilter!: number | undefined;
    sorting!: string | undefined;
    skipCount!: number | undefined;
    maxResultCount!: number | undefined;

    constructor(data?: IGetAllGiftCampaignsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.filter = data["filter"];
            this.codeFilter = data["codeFilter"];
            this.nameFilter = data["nameFilter"];
            this.nameUnsignFilter = data["nameUnsignFilter"];
            this.targetAudienceTypeFilter = data["targetAudienceTypeFilter"];
            this.maxTargetAudienceIDFilter = data["maxTargetAudienceIDFilter"];
            this.minTargetAudienceIDFilter = data["minTargetAudienceIDFilter"];
            this.publisherCodeFilter = data["publisherCodeFilter"];
            this.descriptionFilter = data["descriptionFilter"];
            this.imageLinkFilter = data["imageLinkFilter"];
            this.statusFilter = data["statusFilter"];
            this.cronFilter = data["cronFilter"];
            this.giftMasterCodeFilter = data["giftMasterCodeFilter"];
            this.giftMasterNameFilter = data["giftMasterNameFilter"];
            this.maxGiftMasterValueFilter = data["maxGiftMasterValueFilter"];
            this.minGiftMasterValueFilter = data["minGiftMasterValueFilter"];
            this.maxQuantityFilter = data["maxQuantityFilter"];
            this.minQuantityFilter = data["minQuantityFilter"];
            this.maxQuantityAllocatedFilter = data["maxQuantityAllocatedFilter"];
            this.minQuantityAllocatedFilter = data["minQuantityAllocatedFilter"];
            this.maxRemainingQuantityFilter = data["maxRemainingQuantityFilter"];
            this.minRemainingQuantityFilter = data["minRemainingQuantityFilter"];
            this.maxEffectiveFromFilter = data["maxEffectiveFromFilter"] ? moment(data["maxEffectiveFromFilter"].toString()) : <any>undefined;
            this.minEffectiveFromFilter = data["minEffectiveFromFilter"] ? moment(data["minEffectiveFromFilter"].toString()) : <any>undefined;
            this.maxEffectiveToFilter = data["maxEffectiveToFilter"] ? moment(data["maxEffectiveToFilter"].toString()) : <any>undefined;
            this.minEffectiveToFilter = data["minEffectiveToFilter"] ? moment(data["minEffectiveToFilter"].toString()) : <any>undefined;
            this.maxExpireDateFilter = data["maxExpireDateFilter"] ? moment(data["maxExpireDateFilter"].toString()) : <any>undefined;
            this.minExpireDateFilter = data["minExpireDateFilter"] ? moment(data["minExpireDateFilter"].toString()) : <any>undefined;
            this.isGrantedFilter = data["isGrantedFilter"];
            this.sorting = data["sorting"];
            this.skipCount = data["skipCount"];
            this.maxResultCount = data["maxResultCount"];
        }
    }

    static fromJS(data: any): GetAllGiftCampaignsInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllGiftCampaignsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        data["codeFilter"] = this.codeFilter;
        data["nameFilter"] = this.nameFilter;
        data["nameUnsignFilter"] = this.nameUnsignFilter;
        data["targetAudienceTypeFilter"] = this.targetAudienceTypeFilter;
        data["maxTargetAudienceIDFilter"] = this.maxTargetAudienceIDFilter;
        data["minTargetAudienceIDFilter"] = this.minTargetAudienceIDFilter;
        data["publisherCodeFilter"] = this.publisherCodeFilter;
        data["descriptionFilter"] = this.descriptionFilter;
        data["imageLinkFilter"] = this.imageLinkFilter;
        data["statusFilter"] = this.statusFilter;
        data["cronFilter"] = this.cronFilter;
        data["giftMasterCodeFilter"] = this.giftMasterCodeFilter;
        data["giftMasterNameFilter"] = this.giftMasterNameFilter;
        data["maxGiftMasterValueFilter"] = this.maxGiftMasterValueFilter;
        data["minGiftMasterValueFilter"] = this.minGiftMasterValueFilter;
        data["maxQuantityFilter"] = this.maxQuantityFilter;
        data["minQuantityFilter"] = this.minQuantityFilter;
        data["maxQuantityAllocatedFilter"] = this.maxQuantityAllocatedFilter;
        data["minQuantityAllocatedFilter"] = this.minQuantityAllocatedFilter;
        data["maxRemainingQuantityFilter"] = this.maxRemainingQuantityFilter;
        data["minRemainingQuantityFilter"] = this.minRemainingQuantityFilter;
        data["maxEffectiveFromFilter"] = this.maxEffectiveFromFilter ? this.maxEffectiveFromFilter.toISOString() : <any>undefined;
        data["minEffectiveFromFilter"] = this.minEffectiveFromFilter ? this.minEffectiveFromFilter.toISOString() : <any>undefined;
        data["maxEffectiveToFilter"] = this.maxEffectiveToFilter ? this.maxEffectiveToFilter.toISOString() : <any>undefined;
        data["minEffectiveToFilter"] = this.minEffectiveToFilter ? this.minEffectiveToFilter.toISOString() : <any>undefined;
        data["maxExpireDateFilter"] = this.maxExpireDateFilter ? this.maxExpireDateFilter.toISOString() : <any>undefined;
        data["minExpireDateFilter"] = this.minExpireDateFilter ? this.minExpireDateFilter.toISOString() : <any>undefined;
        data["isGrantedFilter"] = this.isGrantedFilter;
        data["sorting"] = this.sorting;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data;
    }
}

export interface IGetAllGiftCampaignsInput {
    filter: string | undefined;
    codeFilter: string | undefined;
    nameFilter: string | undefined;
    nameUnsignFilter: string | undefined;
    targetAudienceTypeFilter: string | undefined;
    maxTargetAudienceIDFilter: number | undefined;
    minTargetAudienceIDFilter: number | undefined;
    publisherCodeFilter: string | undefined;
    descriptionFilter: string | undefined;
    imageLinkFilter: string | undefined;
    statusFilter: string | undefined;
    cronFilter: string | undefined;
    giftMasterCodeFilter: string | undefined;
    giftMasterNameFilter: string | undefined;
    maxGiftMasterValueFilter: number | undefined;
    minGiftMasterValueFilter: number | undefined;
    maxQuantityFilter: number | undefined;
    minQuantityFilter: number | undefined;
    maxQuantityAllocatedFilter: number | undefined;
    minQuantityAllocatedFilter: number | undefined;
    maxRemainingQuantityFilter: number | undefined;
    minRemainingQuantityFilter: number | undefined;
    maxEffectiveFromFilter: moment.Moment | undefined;
    minEffectiveFromFilter: moment.Moment | undefined;
    maxEffectiveToFilter: moment.Moment | undefined;
    minEffectiveToFilter: moment.Moment | undefined;
    maxExpireDateFilter: moment.Moment | undefined;
    minExpireDateFilter: moment.Moment | undefined;
    isGrantedFilter: number | undefined;
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;
}

export class GetAllGiftCampaignsReportInput implements IGetAllGiftCampaignsReportInput {
    filter!: string | undefined;
    codeFilter!: string | undefined;
    giftCampaignCode!: string | undefined;
    nameFilter!: string | undefined;
    nameUnsignFilter!: string | undefined;
    targetAudienceId!: string | undefined;
    statusFilter!: string | undefined;
    giftFilter!: string | undefined;
    sorting!: string | undefined;
    skipCount!: number | undefined;
    maxResultCount!: number | undefined;

    constructor(data?: IGetAllGiftCampaignsReportInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.filter = data["filter"];
            this.codeFilter = data["codeFilter"];
            this.giftCampaignCode = data["giftCampaignCode"];
            this.nameFilter = data["nameFilter"];
            this.nameUnsignFilter = data["nameUnsignFilter"];
            this.targetAudienceId = data["targetAudienceId"];
            this.statusFilter = data["statusFilter"];
            this.giftFilter = data["giftFilter"];
            this.sorting = data["sorting"];
            this.skipCount = data["skipCount"];
            this.maxResultCount = data["maxResultCount"];
        }
    }

    static fromJS(data: any): GetAllGiftCampaignsReportInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllGiftCampaignsReportInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        data["codeFilter"] = this.codeFilter;
        data["giftCampaignCode"] = this.giftCampaignCode;
        data["nameFilter"] = this.nameFilter;
        data["nameUnsignFilter"] = this.nameUnsignFilter;
        data["targetAudienceId"] = this.targetAudienceId;
        data["statusFilter"] = this.statusFilter;
        data["giftFilter"] = this.giftFilter;
        data["sorting"] = this.sorting;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data;
    }
}

export interface IGetAllGiftCampaignsReportInput {
    filter: string | undefined;
    codeFilter: string | undefined;
    giftCampaignCode: string | undefined;
    nameFilter: string | undefined;
    nameUnsignFilter: string | undefined;
    targetAudienceId: string | undefined;
    statusFilter: string | undefined;
    giftFilter: string | undefined;
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;
}

export class PagedResultDtoOfGetGiftCampaignReportDetailDto implements IPagedResultDtoOfGetGiftCampaignReportDetailDto {
    totalCount!: number | undefined;
    items!: GetGiftCampaignReportDetailDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetGiftCampaignReportDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetGiftCampaignReportDetailDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetGiftCampaignReportDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetGiftCampaignReportDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetGiftCampaignReportDetailDto {
    totalCount: number | undefined;
    items: GetGiftCampaignReportDetailDto[] | undefined;
}

export class GetGiftCampaignReportDetailDto implements IGetGiftCampaignReportDetailDto {
    giftCampaignDetail!: GiftCampaignReportDetailDto | undefined;

    constructor(data?: IGetGiftCampaignReportDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.giftCampaignDetail = data["giftCampaignDetail"] ? GiftCampaignReportDetailDto.fromJS(data["giftCampaignDetail"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetGiftCampaignReportDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGiftCampaignReportDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["giftCampaignDetail"] = this.giftCampaignDetail ? this.giftCampaignDetail.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetGiftCampaignReportDetailDto {
    giftCampaignDetail: GiftCampaignReportDetailDto | undefined;
}

export class GiftCampaignReportDetailDto implements IGiftCampaignReportDetailDto {
    outletCode!: string | undefined;
    outletName!: string | undefined;
    chatID!: string | undefined;
    giftMasterCode!: string | undefined;
    giftMasterName!: string | undefined;
    giftMasterValue!: number | undefined;
    status!: string | undefined;
    id!: number | undefined;

    constructor(data?: IGiftCampaignReportDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.outletCode = data["outletCode"];
            this.outletName = data["outletName"];
            this.chatID = data["chatID"];
            this.giftMasterCode = data["giftMasterCode"];
            this.giftMasterName = data["giftMasterName"];
            this.giftMasterValue = data["giftMasterValue"];
            this.status = data["status"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): GiftCampaignReportDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new GiftCampaignReportDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["outletCode"] = this.outletCode;
        data["outletName"] = this.outletName;
        data["chatID"] = this.chatID;
        data["giftMasterCode"] = this.giftMasterCode;
        data["giftMasterName"] = this.giftMasterName;
        data["giftMasterValue"] = this.giftMasterValue;
        data["status"] = this.status;
        data["id"] = this.id;
        return data;
    }
}

export interface IGiftCampaignReportDetailDto {
    outletCode: string | undefined;
    outletName: string | undefined;
    chatID: string | undefined;
    giftMasterCode: string | undefined;
    giftMasterName: string | undefined;
    giftMasterValue: number | undefined;
    status: string | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfGetGiftCampaignTargetAudienceDetailForViewDto implements IPagedResultDtoOfGetGiftCampaignTargetAudienceDetailForViewDto {
    totalCount!: number | undefined;
    items!: GetGiftCampaignTargetAudienceDetailForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetGiftCampaignTargetAudienceDetailForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetGiftCampaignTargetAudienceDetailForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetGiftCampaignTargetAudienceDetailForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetGiftCampaignTargetAudienceDetailForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetGiftCampaignTargetAudienceDetailForViewDto {
    totalCount: number | undefined;
    items: GetGiftCampaignTargetAudienceDetailForViewDto[] | undefined;
}

export class GetGiftCampaignTargetAudienceDetailForViewDto implements IGetGiftCampaignTargetAudienceDetailForViewDto {
    giftCampaignTargetAudienceDetail!: GiftCampaignTargetAudienceDetailDto | undefined;

    constructor(data?: IGetGiftCampaignTargetAudienceDetailForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.giftCampaignTargetAudienceDetail = data["giftCampaignTargetAudienceDetail"] ? GiftCampaignTargetAudienceDetailDto.fromJS(data["giftCampaignTargetAudienceDetail"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetGiftCampaignTargetAudienceDetailForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGiftCampaignTargetAudienceDetailForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["giftCampaignTargetAudienceDetail"] = this.giftCampaignTargetAudienceDetail ? this.giftCampaignTargetAudienceDetail.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetGiftCampaignTargetAudienceDetailForViewDto {
    giftCampaignTargetAudienceDetail: GiftCampaignTargetAudienceDetailDto | undefined;
}

export class GiftCampaignTargetAudienceDetailDto implements IGiftCampaignTargetAudienceDetailDto {
    giftTargetAudienceID!: number | undefined;
    name!: string | undefined;
    phone!: string | undefined;
    zaloChatID!: string | undefined;
    email!: string | undefined;
    facebookID!: string | undefined;
    memberCode!: string | undefined;
    communicationLanguage!: string | undefined;
    communicationChannel!: string | undefined;
    outletCode!: string | undefined;
    id!: number | undefined;

    constructor(data?: IGiftCampaignTargetAudienceDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.giftTargetAudienceID = data["giftTargetAudienceID"];
            this.name = data["name"];
            this.phone = data["phone"];
            this.zaloChatID = data["zaloChatID"];
            this.email = data["email"];
            this.facebookID = data["facebookID"];
            this.memberCode = data["memberCode"];
            this.communicationLanguage = data["communicationLanguage"];
            this.communicationChannel = data["communicationChannel"];
            this.outletCode = data["outletCode"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): GiftCampaignTargetAudienceDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new GiftCampaignTargetAudienceDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["giftTargetAudienceID"] = this.giftTargetAudienceID;
        data["name"] = this.name;
        data["phone"] = this.phone;
        data["zaloChatID"] = this.zaloChatID;
        data["email"] = this.email;
        data["facebookID"] = this.facebookID;
        data["memberCode"] = this.memberCode;
        data["communicationLanguage"] = this.communicationLanguage;
        data["communicationChannel"] = this.communicationChannel;
        data["outletCode"] = this.outletCode;
        data["id"] = this.id;
        return data;
    }
}

export interface IGiftCampaignTargetAudienceDetailDto {
    giftTargetAudienceID: number | undefined;
    name: string | undefined;
    phone: string | undefined;
    zaloChatID: string | undefined;
    email: string | undefined;
    facebookID: string | undefined;
    memberCode: string | undefined;
    communicationLanguage: string | undefined;
    communicationChannel: string | undefined;
    outletCode: string | undefined;
    id: number | undefined;
}

export class GetGiftCampaignTargetAudienceDetailForEditOutput implements IGetGiftCampaignTargetAudienceDetailForEditOutput {
    giftCampaignTargetAudienceDetail!: CreateOrEditGiftCampaignTargetAudienceDetailDto | undefined;

    constructor(data?: IGetGiftCampaignTargetAudienceDetailForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.giftCampaignTargetAudienceDetail = data["giftCampaignTargetAudienceDetail"] ? CreateOrEditGiftCampaignTargetAudienceDetailDto.fromJS(data["giftCampaignTargetAudienceDetail"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetGiftCampaignTargetAudienceDetailForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetGiftCampaignTargetAudienceDetailForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["giftCampaignTargetAudienceDetail"] = this.giftCampaignTargetAudienceDetail ? this.giftCampaignTargetAudienceDetail.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetGiftCampaignTargetAudienceDetailForEditOutput {
    giftCampaignTargetAudienceDetail: CreateOrEditGiftCampaignTargetAudienceDetailDto | undefined;
}

export class CreateOrEditGiftCampaignTargetAudienceDetailDto implements ICreateOrEditGiftCampaignTargetAudienceDetailDto {
    giftTargetAudienceID!: number | undefined;
    name!: string | undefined;
    phone!: string | undefined;
    zaloChatID!: string | undefined;
    email!: string | undefined;
    facebookID!: string | undefined;
    memberCode!: string | undefined;
    communicationLanguage!: string | undefined;
    communicationChannel!: string | undefined;
    outletCode!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditGiftCampaignTargetAudienceDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.giftTargetAudienceID = data["giftTargetAudienceID"];
            this.name = data["name"];
            this.phone = data["phone"];
            this.zaloChatID = data["zaloChatID"];
            this.email = data["email"];
            this.facebookID = data["facebookID"];
            this.memberCode = data["memberCode"];
            this.communicationLanguage = data["communicationLanguage"];
            this.communicationChannel = data["communicationChannel"];
            this.outletCode = data["outletCode"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditGiftCampaignTargetAudienceDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditGiftCampaignTargetAudienceDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["giftTargetAudienceID"] = this.giftTargetAudienceID;
        data["name"] = this.name;
        data["phone"] = this.phone;
        data["zaloChatID"] = this.zaloChatID;
        data["email"] = this.email;
        data["facebookID"] = this.facebookID;
        data["memberCode"] = this.memberCode;
        data["communicationLanguage"] = this.communicationLanguage;
        data["communicationChannel"] = this.communicationChannel;
        data["outletCode"] = this.outletCode;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditGiftCampaignTargetAudienceDetailDto {
    giftTargetAudienceID: number | undefined;
    name: string | undefined;
    phone: string | undefined;
    zaloChatID: string | undefined;
    email: string | undefined;
    facebookID: string | undefined;
    memberCode: string | undefined;
    communicationLanguage: string | undefined;
    communicationChannel: string | undefined;
    outletCode: string | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfGetGiftCampaignTargetAudienceForViewDto implements IPagedResultDtoOfGetGiftCampaignTargetAudienceForViewDto {
    totalCount!: number | undefined;
    items!: GetGiftCampaignTargetAudienceForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetGiftCampaignTargetAudienceForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetGiftCampaignTargetAudienceForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetGiftCampaignTargetAudienceForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetGiftCampaignTargetAudienceForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetGiftCampaignTargetAudienceForViewDto {
    totalCount: number | undefined;
    items: GetGiftCampaignTargetAudienceForViewDto[] | undefined;
}

export class GetGiftCampaignTargetAudienceForViewDto implements IGetGiftCampaignTargetAudienceForViewDto {
    giftCampaignTargetAudience!: GiftCampaignTargetAudienceDto | undefined;

    constructor(data?: IGetGiftCampaignTargetAudienceForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.giftCampaignTargetAudience = data["giftCampaignTargetAudience"] ? GiftCampaignTargetAudienceDto.fromJS(data["giftCampaignTargetAudience"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetGiftCampaignTargetAudienceForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGiftCampaignTargetAudienceForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["giftCampaignTargetAudience"] = this.giftCampaignTargetAudience ? this.giftCampaignTargetAudience.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetGiftCampaignTargetAudienceForViewDto {
    giftCampaignTargetAudience: GiftCampaignTargetAudienceDto | undefined;
}

export class GiftCampaignTargetAudienceDto implements IGiftCampaignTargetAudienceDto {
    targetAudienceName!: string | undefined;
    description!: string | undefined;
    status!: string | undefined;
    id!: number | undefined;

    constructor(data?: IGiftCampaignTargetAudienceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.targetAudienceName = data["targetAudienceName"];
            this.description = data["description"];
            this.status = data["status"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): GiftCampaignTargetAudienceDto {
        data = typeof data === 'object' ? data : {};
        let result = new GiftCampaignTargetAudienceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["targetAudienceName"] = this.targetAudienceName;
        data["description"] = this.description;
        data["status"] = this.status;
        data["id"] = this.id;
        return data;
    }
}

export interface IGiftCampaignTargetAudienceDto {
    targetAudienceName: string | undefined;
    description: string | undefined;
    status: string | undefined;
    id: number | undefined;
}

export class GetGiftCampaignTargetAudienceForEditOutput implements IGetGiftCampaignTargetAudienceForEditOutput {
    giftCampaignTargetAudience!: CreateOrEditGiftCampaignTargetAudienceDto | undefined;

    constructor(data?: IGetGiftCampaignTargetAudienceForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.giftCampaignTargetAudience = data["giftCampaignTargetAudience"] ? CreateOrEditGiftCampaignTargetAudienceDto.fromJS(data["giftCampaignTargetAudience"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetGiftCampaignTargetAudienceForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetGiftCampaignTargetAudienceForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["giftCampaignTargetAudience"] = this.giftCampaignTargetAudience ? this.giftCampaignTargetAudience.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetGiftCampaignTargetAudienceForEditOutput {
    giftCampaignTargetAudience: CreateOrEditGiftCampaignTargetAudienceDto | undefined;
}

export class CreateOrEditGiftCampaignTargetAudienceDto implements ICreateOrEditGiftCampaignTargetAudienceDto {
    targetAudienceName!: string | undefined;
    description!: string | undefined;
    status!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditGiftCampaignTargetAudienceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.targetAudienceName = data["targetAudienceName"];
            this.description = data["description"];
            this.status = data["status"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditGiftCampaignTargetAudienceDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditGiftCampaignTargetAudienceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["targetAudienceName"] = this.targetAudienceName;
        data["description"] = this.description;
        data["status"] = this.status;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditGiftCampaignTargetAudienceDto {
    targetAudienceName: string | undefined;
    description: string | undefined;
    status: string | undefined;
    id: number | undefined;
}

export class GetTargetGiftCampaignForView implements IGetTargetGiftCampaignForView {
    id!: number | undefined;
    targetAudienceName!: string | undefined;

    constructor(data?: IGetTargetGiftCampaignForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.targetAudienceName = data["targetAudienceName"];
        }
    }

    static fromJS(data: any): GetTargetGiftCampaignForView {
        data = typeof data === 'object' ? data : {};
        let result = new GetTargetGiftCampaignForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["targetAudienceName"] = this.targetAudienceName;
        return data;
    }
}

export interface IGetTargetGiftCampaignForView {
    id: number | undefined;
    targetAudienceName: string | undefined;
}

export class PagedResultDtoOfGetGiftCategoryForView implements IPagedResultDtoOfGetGiftCategoryForView {
    totalCount!: number | undefined;
    items!: GetGiftCategoryForView[] | undefined;

    constructor(data?: IPagedResultDtoOfGetGiftCategoryForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetGiftCategoryForView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetGiftCategoryForView {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetGiftCategoryForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetGiftCategoryForView {
    totalCount: number | undefined;
    items: GetGiftCategoryForView[] | undefined;
}

export class GetGiftCategoryForView implements IGetGiftCategoryForView {
    giftCategory!: GiftCategoryDto | undefined;
    giftCategoryGiftCategoryName!: string | undefined;

    constructor(data?: IGetGiftCategoryForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.giftCategory = data["giftCategory"] ? GiftCategoryDto.fromJS(data["giftCategory"]) : <any>undefined;
            this.giftCategoryGiftCategoryName = data["giftCategoryGiftCategoryName"];
        }
    }

    static fromJS(data: any): GetGiftCategoryForView {
        data = typeof data === 'object' ? data : {};
        let result = new GetGiftCategoryForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["giftCategory"] = this.giftCategory ? this.giftCategory.toJSON() : <any>undefined;
        data["giftCategoryGiftCategoryName"] = this.giftCategoryGiftCategoryName;
        return data;
    }
}

export interface IGetGiftCategoryForView {
    giftCategory: GiftCategoryDto | undefined;
    giftCategoryGiftCategoryName: string | undefined;
}

export class GiftCategoryDto implements IGiftCategoryDto {
    code!: string | undefined;
    name!: string | undefined;
    description!: string | undefined;
    status!: string | undefined;
    level!: number | undefined;
    parentCode!: string | undefined;
    parentId!: number | undefined;
    imageLink!: ImageLinkDto | undefined;
    id!: number | undefined;

    constructor(data?: IGiftCategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.name = data["name"];
            this.description = data["description"];
            this.status = data["status"];
            this.level = data["level"];
            this.parentCode = data["parentCode"];
            this.parentId = data["parentId"];
            this.imageLink = data["imageLink"] ? ImageLinkDto.fromJS(data["imageLink"]) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): GiftCategoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new GiftCategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["description"] = this.description;
        data["status"] = this.status;
        data["level"] = this.level;
        data["parentCode"] = this.parentCode;
        data["parentId"] = this.parentId;
        data["imageLink"] = this.imageLink ? this.imageLink.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IGiftCategoryDto {
    code: string | undefined;
    name: string | undefined;
    description: string | undefined;
    status: string | undefined;
    level: number | undefined;
    parentCode: string | undefined;
    parentId: number | undefined;
    imageLink: ImageLinkDto | undefined;
    id: number | undefined;
}

export class ImageLinkDto implements IImageLinkDto {
    code!: string | undefined;
    type!: string | undefined;
    link!: string | undefined;
    isActive!: boolean | undefined;
    ordinal!: number | undefined;
    fullLink!: string | undefined;
    id!: number | undefined;

    constructor(data?: IImageLinkDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.type = data["type"];
            this.link = data["link"];
            this.isActive = data["isActive"];
            this.ordinal = data["ordinal"];
            this.fullLink = data["fullLink"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ImageLinkDto {
        data = typeof data === 'object' ? data : {};
        let result = new ImageLinkDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["type"] = this.type;
        data["link"] = this.link;
        data["isActive"] = this.isActive;
        data["ordinal"] = this.ordinal;
        data["fullLink"] = this.fullLink;
        data["id"] = this.id;
        return data;
    }
}

export interface IImageLinkDto {
    code: string | undefined;
    type: string | undefined;
    link: string | undefined;
    isActive: boolean | undefined;
    ordinal: number | undefined;
    fullLink: string | undefined;
    id: number | undefined;
}

export class CreateOrEditGiftCategoryDto implements ICreateOrEditGiftCategoryDto {
    code!: string | undefined;
    name!: string | undefined;
    description!: string | undefined;
    status!: string | undefined;
    level!: number | undefined;
    parentCode!: string | undefined;
    parentId!: number | undefined;
    imageLink!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditGiftCategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.name = data["name"];
            this.description = data["description"];
            this.status = data["status"];
            this.level = data["level"];
            this.parentCode = data["parentCode"];
            this.parentId = data["parentId"];
            this.imageLink = data["imageLink"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditGiftCategoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditGiftCategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["description"] = this.description;
        data["status"] = this.status;
        data["level"] = this.level;
        data["parentCode"] = this.parentCode;
        data["parentId"] = this.parentId;
        data["imageLink"] = this.imageLink;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditGiftCategoryDto {
    code: string | undefined;
    name: string | undefined;
    description: string | undefined;
    status: string | undefined;
    level: number | undefined;
    parentCode: string | undefined;
    parentId: number | undefined;
    imageLink: string | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfGiftCategoryLookupTableDto implements IPagedResultDtoOfGiftCategoryLookupTableDto {
    totalCount!: number | undefined;
    items!: GiftCategoryLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGiftCategoryLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GiftCategoryLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGiftCategoryLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGiftCategoryLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGiftCategoryLookupTableDto {
    totalCount: number | undefined;
    items: GiftCategoryLookupTableDto[] | undefined;
}

export class GiftCategoryLookupTableDto implements IGiftCategoryLookupTableDto {
    id!: number | undefined;
    displayName!: string | undefined;

    constructor(data?: IGiftCategoryLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): GiftCategoryLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new GiftCategoryLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IGiftCategoryLookupTableDto {
    id: number | undefined;
    displayName: string | undefined;
}

export class GiftCategoryForSearchDto implements IGiftCategoryForSearchDto {
    name!: string | undefined;
    code!: string | undefined;
    giftCategoryFullName!: string | undefined;
    giftCategoryFullCode!: string | undefined;
    rootCategoryId!: number | undefined;

    constructor(data?: IGiftCategoryForSearchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.code = data["code"];
            this.giftCategoryFullName = data["giftCategoryFullName"];
            this.giftCategoryFullCode = data["giftCategoryFullCode"];
            this.rootCategoryId = data["rootCategoryId"];
        }
    }

    static fromJS(data: any): GiftCategoryForSearchDto {
        data = typeof data === 'object' ? data : {};
        let result = new GiftCategoryForSearchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["code"] = this.code;
        data["giftCategoryFullName"] = this.giftCategoryFullName;
        data["giftCategoryFullCode"] = this.giftCategoryFullCode;
        data["rootCategoryId"] = this.rootCategoryId;
        return data;
    }
}

export interface IGiftCategoryForSearchDto {
    name: string | undefined;
    code: string | undefined;
    giftCategoryFullName: string | undefined;
    giftCategoryFullCode: string | undefined;
    rootCategoryId: number | undefined;
}

export class GetGiftCategoryForEditOutput implements IGetGiftCategoryForEditOutput {
    giftCategory!: CreateOrEditGiftCategoryDto | undefined;
    giftCategoryGiftCategoryName!: string | undefined;

    constructor(data?: IGetGiftCategoryForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.giftCategory = data["giftCategory"] ? CreateOrEditGiftCategoryDto.fromJS(data["giftCategory"]) : <any>undefined;
            this.giftCategoryGiftCategoryName = data["giftCategoryGiftCategoryName"];
        }
    }

    static fromJS(data: any): GetGiftCategoryForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetGiftCategoryForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["giftCategory"] = this.giftCategory ? this.giftCategory.toJSON() : <any>undefined;
        data["giftCategoryGiftCategoryName"] = this.giftCategoryGiftCategoryName;
        return data;
    }
}

export interface IGetGiftCategoryForEditOutput {
    giftCategory: CreateOrEditGiftCategoryDto | undefined;
    giftCategoryGiftCategoryName: string | undefined;
}

export class PagedResultDtoOfGetGiftGroupDetailForView implements IPagedResultDtoOfGetGiftGroupDetailForView {
    totalCount!: number | undefined;
    items!: GetGiftGroupDetailForView[] | undefined;

    constructor(data?: IPagedResultDtoOfGetGiftGroupDetailForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetGiftGroupDetailForView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetGiftGroupDetailForView {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetGiftGroupDetailForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetGiftGroupDetailForView {
    totalCount: number | undefined;
    items: GetGiftGroupDetailForView[] | undefined;
}

export class GetGiftGroupDetailForView implements IGetGiftGroupDetailForView {
    giftGroupDetail!: GiftGroupDetailDto | undefined;
    giftInfor!: GiftInforDto | undefined;
    giftGroupGiftGroupName!: string | undefined;
    giftInforGiftName!: string | undefined;

    constructor(data?: IGetGiftGroupDetailForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.giftGroupDetail = data["giftGroupDetail"] ? GiftGroupDetailDto.fromJS(data["giftGroupDetail"]) : <any>undefined;
            this.giftInfor = data["giftInfor"] ? GiftInforDto.fromJS(data["giftInfor"]) : <any>undefined;
            this.giftGroupGiftGroupName = data["giftGroupGiftGroupName"];
            this.giftInforGiftName = data["giftInforGiftName"];
        }
    }

    static fromJS(data: any): GetGiftGroupDetailForView {
        data = typeof data === 'object' ? data : {};
        let result = new GetGiftGroupDetailForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["giftGroupDetail"] = this.giftGroupDetail ? this.giftGroupDetail.toJSON() : <any>undefined;
        data["giftInfor"] = this.giftInfor ? this.giftInfor.toJSON() : <any>undefined;
        data["giftGroupGiftGroupName"] = this.giftGroupGiftGroupName;
        data["giftInforGiftName"] = this.giftInforGiftName;
        return data;
    }
}

export interface IGetGiftGroupDetailForView {
    giftGroupDetail: GiftGroupDetailDto | undefined;
    giftInfor: GiftInforDto | undefined;
    giftGroupGiftGroupName: string | undefined;
    giftInforGiftName: string | undefined;
}

export class GiftGroupDetailDto implements IGiftGroupDetailDto {
    giftGroupCode!: string | undefined;
    giftCode!: string | undefined;
    status!: string | undefined;
    giftGroupId!: number | undefined;
    giftId!: number | undefined;
    id!: number | undefined;

    constructor(data?: IGiftGroupDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.giftGroupCode = data["giftGroupCode"];
            this.giftCode = data["giftCode"];
            this.status = data["status"];
            this.giftGroupId = data["giftGroupId"];
            this.giftId = data["giftId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): GiftGroupDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new GiftGroupDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["giftGroupCode"] = this.giftGroupCode;
        data["giftCode"] = this.giftCode;
        data["status"] = this.status;
        data["giftGroupId"] = this.giftGroupId;
        data["giftId"] = this.giftId;
        data["id"] = this.id;
        return data;
    }
}

export interface IGiftGroupDetailDto {
    giftGroupCode: string | undefined;
    giftCode: string | undefined;
    status: string | undefined;
    giftGroupId: number | undefined;
    giftId: number | undefined;
    id: number | undefined;
}

export class GiftInforDto implements IGiftInforDto {
    code!: string | undefined;
    name!: string | undefined;
    description!: string | undefined;
    introduce!: string | undefined;
    fullGiftCategoryCode!: string | undefined;
    producer!: string | undefined;
    vendor!: string | undefined;
    effectiveFrom!: moment.Moment | undefined;
    effectiveTo!: moment.Moment | undefined;
    requiredCoin!: number | undefined;
    status!: string | undefined;
    totalQuantity!: number | undefined;
    usedQuantity!: number | undefined;
    remainingQuantity!: number | undefined;
    isEGift!: boolean | undefined;
    targetAudience!: SettingParamDto | undefined;
    targetAudienceId!: number | undefined;
    giftGroupId!: number | undefined;
    lastModificationTime!: moment.Moment | undefined;
    creationTime!: moment.Moment | undefined;
    createdByUser!: string | undefined;
    updatedByUser!: string | undefined;
    tag!: string | undefined;
    referenceCode!: string | undefined;
    amount!: number | undefined;
    giftType!: string | undefined;
    targetAudienceType!: string | undefined;
    giftTargetAudienceID!: number | undefined;
    id!: number | undefined;

    constructor(data?: IGiftInforDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.name = data["name"];
            this.description = data["description"];
            this.introduce = data["introduce"];
            this.fullGiftCategoryCode = data["fullGiftCategoryCode"];
            this.producer = data["producer"];
            this.vendor = data["vendor"];
            this.effectiveFrom = data["effectiveFrom"] ? moment(data["effectiveFrom"].toString()) : <any>undefined;
            this.effectiveTo = data["effectiveTo"] ? moment(data["effectiveTo"].toString()) : <any>undefined;
            this.requiredCoin = data["requiredCoin"];
            this.status = data["status"];
            this.totalQuantity = data["totalQuantity"];
            this.usedQuantity = data["usedQuantity"];
            this.remainingQuantity = data["remainingQuantity"];
            this.isEGift = data["isEGift"];
            this.targetAudience = data["targetAudience"] ? SettingParamDto.fromJS(data["targetAudience"]) : <any>undefined;
            this.targetAudienceId = data["targetAudienceId"];
            this.giftGroupId = data["giftGroupId"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.createdByUser = data["createdByUser"];
            this.updatedByUser = data["updatedByUser"];
            this.tag = data["tag"];
            this.referenceCode = data["referenceCode"];
            this.amount = data["amount"];
            this.giftType = data["giftType"];
            this.targetAudienceType = data["targetAudienceType"];
            this.giftTargetAudienceID = data["giftTargetAudienceID"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): GiftInforDto {
        data = typeof data === 'object' ? data : {};
        let result = new GiftInforDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["description"] = this.description;
        data["introduce"] = this.introduce;
        data["fullGiftCategoryCode"] = this.fullGiftCategoryCode;
        data["producer"] = this.producer;
        data["vendor"] = this.vendor;
        data["effectiveFrom"] = this.effectiveFrom ? this.effectiveFrom.toISOString() : <any>undefined;
        data["effectiveTo"] = this.effectiveTo ? this.effectiveTo.toISOString() : <any>undefined;
        data["requiredCoin"] = this.requiredCoin;
        data["status"] = this.status;
        data["totalQuantity"] = this.totalQuantity;
        data["usedQuantity"] = this.usedQuantity;
        data["remainingQuantity"] = this.remainingQuantity;
        data["isEGift"] = this.isEGift;
        data["targetAudience"] = this.targetAudience ? this.targetAudience.toJSON() : <any>undefined;
        data["targetAudienceId"] = this.targetAudienceId;
        data["giftGroupId"] = this.giftGroupId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["createdByUser"] = this.createdByUser;
        data["updatedByUser"] = this.updatedByUser;
        data["tag"] = this.tag;
        data["referenceCode"] = this.referenceCode;
        data["amount"] = this.amount;
        data["giftType"] = this.giftType;
        data["targetAudienceType"] = this.targetAudienceType;
        data["giftTargetAudienceID"] = this.giftTargetAudienceID;
        data["id"] = this.id;
        return data;
    }
}

export interface IGiftInforDto {
    code: string | undefined;
    name: string | undefined;
    description: string | undefined;
    introduce: string | undefined;
    fullGiftCategoryCode: string | undefined;
    producer: string | undefined;
    vendor: string | undefined;
    effectiveFrom: moment.Moment | undefined;
    effectiveTo: moment.Moment | undefined;
    requiredCoin: number | undefined;
    status: string | undefined;
    totalQuantity: number | undefined;
    usedQuantity: number | undefined;
    remainingQuantity: number | undefined;
    isEGift: boolean | undefined;
    targetAudience: SettingParamDto | undefined;
    targetAudienceId: number | undefined;
    giftGroupId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    creationTime: moment.Moment | undefined;
    createdByUser: string | undefined;
    updatedByUser: string | undefined;
    tag: string | undefined;
    referenceCode: string | undefined;
    amount: number | undefined;
    giftType: string | undefined;
    targetAudienceType: string | undefined;
    giftTargetAudienceID: number | undefined;
    id: number | undefined;
}

export class GetGiftGroupDetailForEditOutput implements IGetGiftGroupDetailForEditOutput {
    giftGroupDetail!: CreateOrEditGiftGroupDetailDto | undefined;
    giftGroupGiftGroupName!: string | undefined;
    giftInforGiftName!: string | undefined;

    constructor(data?: IGetGiftGroupDetailForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.giftGroupDetail = data["giftGroupDetail"] ? CreateOrEditGiftGroupDetailDto.fromJS(data["giftGroupDetail"]) : <any>undefined;
            this.giftGroupGiftGroupName = data["giftGroupGiftGroupName"];
            this.giftInforGiftName = data["giftInforGiftName"];
        }
    }

    static fromJS(data: any): GetGiftGroupDetailForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetGiftGroupDetailForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["giftGroupDetail"] = this.giftGroupDetail ? this.giftGroupDetail.toJSON() : <any>undefined;
        data["giftGroupGiftGroupName"] = this.giftGroupGiftGroupName;
        data["giftInforGiftName"] = this.giftInforGiftName;
        return data;
    }
}

export interface IGetGiftGroupDetailForEditOutput {
    giftGroupDetail: CreateOrEditGiftGroupDetailDto | undefined;
    giftGroupGiftGroupName: string | undefined;
    giftInforGiftName: string | undefined;
}

export class CreateOrEditGiftGroupDetailDto implements ICreateOrEditGiftGroupDetailDto {
    giftGroupCode!: string | undefined;
    giftCode!: string | undefined;
    status!: string | undefined;
    giftGroupId!: number | undefined;
    giftId!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditGiftGroupDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.giftGroupCode = data["giftGroupCode"];
            this.giftCode = data["giftCode"];
            this.status = data["status"];
            this.giftGroupId = data["giftGroupId"];
            this.giftId = data["giftId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditGiftGroupDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditGiftGroupDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["giftGroupCode"] = this.giftGroupCode;
        data["giftCode"] = this.giftCode;
        data["status"] = this.status;
        data["giftGroupId"] = this.giftGroupId;
        data["giftId"] = this.giftId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditGiftGroupDetailDto {
    giftGroupCode: string | undefined;
    giftCode: string | undefined;
    status: string | undefined;
    giftGroupId: number | undefined;
    giftId: number | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfGiftGroupLookupTableDto implements IPagedResultDtoOfGiftGroupLookupTableDto {
    totalCount!: number | undefined;
    items!: GiftGroupLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGiftGroupLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GiftGroupLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGiftGroupLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGiftGroupLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGiftGroupLookupTableDto {
    totalCount: number | undefined;
    items: GiftGroupLookupTableDto[] | undefined;
}

export class GiftGroupLookupTableDto implements IGiftGroupLookupTableDto {
    id!: number | undefined;
    displayName!: string | undefined;

    constructor(data?: IGiftGroupLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): GiftGroupLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new GiftGroupLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IGiftGroupLookupTableDto {
    id: number | undefined;
    displayName: string | undefined;
}

export class PagedResultDtoOfGetGiftGroupForView implements IPagedResultDtoOfGetGiftGroupForView {
    totalCount!: number | undefined;
    items!: GetGiftGroupForView[] | undefined;

    constructor(data?: IPagedResultDtoOfGetGiftGroupForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetGiftGroupForView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetGiftGroupForView {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetGiftGroupForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetGiftGroupForView {
    totalCount: number | undefined;
    items: GetGiftGroupForView[] | undefined;
}

export class GetGiftGroupForView implements IGetGiftGroupForView {
    giftGroup!: GiftGroupDto | undefined;
    imageLink!: ImageLinkDto | undefined;

    constructor(data?: IGetGiftGroupForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.giftGroup = data["giftGroup"] ? GiftGroupDto.fromJS(data["giftGroup"]) : <any>undefined;
            this.imageLink = data["imageLink"] ? ImageLinkDto.fromJS(data["imageLink"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetGiftGroupForView {
        data = typeof data === 'object' ? data : {};
        let result = new GetGiftGroupForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["giftGroup"] = this.giftGroup ? this.giftGroup.toJSON() : <any>undefined;
        data["imageLink"] = this.imageLink ? this.imageLink.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetGiftGroupForView {
    giftGroup: GiftGroupDto | undefined;
    imageLink: ImageLinkDto | undefined;
}

export class GiftGroupDto implements IGiftGroupDto {
    code!: string | undefined;
    name!: string | undefined;
    description!: string | undefined;
    status!: string | undefined;
    id!: number | undefined;

    constructor(data?: IGiftGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.name = data["name"];
            this.description = data["description"];
            this.status = data["status"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): GiftGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new GiftGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["description"] = this.description;
        data["status"] = this.status;
        data["id"] = this.id;
        return data;
    }
}

export interface IGiftGroupDto {
    code: string | undefined;
    name: string | undefined;
    description: string | undefined;
    status: string | undefined;
    id: number | undefined;
}

export class GetGiftGroupForEditOutput implements IGetGiftGroupForEditOutput {
    giftGroup!: CreateOrEditGiftGroupDto | undefined;
    imageLink!: CreateOrEditImageLinkDto | undefined;

    constructor(data?: IGetGiftGroupForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.giftGroup = data["giftGroup"] ? CreateOrEditGiftGroupDto.fromJS(data["giftGroup"]) : <any>undefined;
            this.imageLink = data["imageLink"] ? CreateOrEditImageLinkDto.fromJS(data["imageLink"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetGiftGroupForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetGiftGroupForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["giftGroup"] = this.giftGroup ? this.giftGroup.toJSON() : <any>undefined;
        data["imageLink"] = this.imageLink ? this.imageLink.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetGiftGroupForEditOutput {
    giftGroup: CreateOrEditGiftGroupDto | undefined;
    imageLink: CreateOrEditImageLinkDto | undefined;
}

export class CreateOrEditGiftGroupDto implements ICreateOrEditGiftGroupDto {
    code!: string;
    name!: string | undefined;
    description!: string | undefined;
    status!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditGiftGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.name = data["name"];
            this.description = data["description"];
            this.status = data["status"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditGiftGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditGiftGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["description"] = this.description;
        data["status"] = this.status;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditGiftGroupDto {
    code: string;
    name: string | undefined;
    description: string | undefined;
    status: string | undefined;
    id: number | undefined;
}

export class CreateOrEditImageLinkDto implements ICreateOrEditImageLinkDto {
    code!: string;
    type!: string | undefined;
    link!: string | undefined;
    fullLink!: string | undefined;
    isActive!: boolean | undefined;
    ordinal!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditImageLinkDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.type = data["type"];
            this.link = data["link"];
            this.fullLink = data["fullLink"];
            this.isActive = data["isActive"];
            this.ordinal = data["ordinal"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditImageLinkDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditImageLinkDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["type"] = this.type;
        data["link"] = this.link;
        data["fullLink"] = this.fullLink;
        data["isActive"] = this.isActive;
        data["ordinal"] = this.ordinal;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditImageLinkDto {
    code: string;
    type: string | undefined;
    link: string | undefined;
    fullLink: string | undefined;
    isActive: boolean | undefined;
    ordinal: number | undefined;
    id: number | undefined;
}

export class CreateOrEditGiftGroupWithAvatarDto implements ICreateOrEditGiftGroupWithAvatarDto {
    imageLink!: CreateOrEditImageLinkDto | undefined;
    code!: string;
    name!: string | undefined;
    description!: string | undefined;
    status!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditGiftGroupWithAvatarDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.imageLink = data["imageLink"] ? CreateOrEditImageLinkDto.fromJS(data["imageLink"]) : <any>undefined;
            this.code = data["code"];
            this.name = data["name"];
            this.description = data["description"];
            this.status = data["status"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditGiftGroupWithAvatarDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditGiftGroupWithAvatarDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["imageLink"] = this.imageLink ? this.imageLink.toJSON() : <any>undefined;
        data["code"] = this.code;
        data["name"] = this.name;
        data["description"] = this.description;
        data["status"] = this.status;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditGiftGroupWithAvatarDto {
    imageLink: CreateOrEditImageLinkDto | undefined;
    code: string;
    name: string | undefined;
    description: string | undefined;
    status: string | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfGetGiftInforForView implements IPagedResultDtoOfGetGiftInforForView {
    totalCount!: number | undefined;
    items!: GetGiftInforForView[] | undefined;

    constructor(data?: IPagedResultDtoOfGetGiftInforForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetGiftInforForView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetGiftInforForView {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetGiftInforForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetGiftInforForView {
    totalCount: number | undefined;
    items: GetGiftInforForView[] | undefined;
}

export class GetGiftInforForView implements IGetGiftInforForView {
    giftInfor!: GiftInforDto | undefined;
    targetAudienceName!: string | undefined;
    imageLink!: ImageLinkDto[] | undefined;

    constructor(data?: IGetGiftInforForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.giftInfor = data["giftInfor"] ? GiftInforDto.fromJS(data["giftInfor"]) : <any>undefined;
            this.targetAudienceName = data["targetAudienceName"];
            if (data["imageLink"] && data["imageLink"].constructor === Array) {
                this.imageLink = [];
                for (let item of data["imageLink"])
                    this.imageLink.push(ImageLinkDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetGiftInforForView {
        data = typeof data === 'object' ? data : {};
        let result = new GetGiftInforForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["giftInfor"] = this.giftInfor ? this.giftInfor.toJSON() : <any>undefined;
        data["targetAudienceName"] = this.targetAudienceName;
        if (this.imageLink && this.imageLink.constructor === Array) {
            data["imageLink"] = [];
            for (let item of this.imageLink)
                data["imageLink"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetGiftInforForView {
    giftInfor: GiftInforDto | undefined;
    targetAudienceName: string | undefined;
    imageLink: ImageLinkDto[] | undefined;
}

export class GetGiftInforForEditOutput implements IGetGiftInforForEditOutput {
    giftInfor!: CreateOrEditGiftInforDto | undefined;
    targetAudienceName!: string | undefined;
    giftGroupCode!: string | undefined;

    constructor(data?: IGetGiftInforForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.giftInfor = data["giftInfor"] ? CreateOrEditGiftInforDto.fromJS(data["giftInfor"]) : <any>undefined;
            this.targetAudienceName = data["targetAudienceName"];
            this.giftGroupCode = data["giftGroupCode"];
        }
    }

    static fromJS(data: any): GetGiftInforForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetGiftInforForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["giftInfor"] = this.giftInfor ? this.giftInfor.toJSON() : <any>undefined;
        data["targetAudienceName"] = this.targetAudienceName;
        data["giftGroupCode"] = this.giftGroupCode;
        return data;
    }
}

export interface IGetGiftInforForEditOutput {
    giftInfor: CreateOrEditGiftInforDto | undefined;
    targetAudienceName: string | undefined;
    giftGroupCode: string | undefined;
}

export class CreateOrEditGiftInforDto implements ICreateOrEditGiftInforDto {
    code!: string | undefined;
    name!: string | undefined;
    description!: string | undefined;
    introduce!: string | undefined;
    fullGiftCategoryCode!: string | undefined;
    producer!: string | undefined;
    vendor!: string | undefined;
    effectiveFrom!: moment.Moment | undefined;
    effectiveTo!: moment.Moment | undefined;
    requiredCoin!: number | undefined;
    status!: string | undefined;
    totalQuantity!: number | undefined;
    usedQuantity!: number | undefined;
    remainingQuantity!: number | undefined;
    isEGift!: boolean | undefined;
    targetAudience!: CreateOrEditSettingParamDto | undefined;
    giftGroup!: GiftGroupDto[] | undefined;
    imageLinks!: CreateOrEditImageLinkDto[] | undefined;
    amount!: number | undefined;
    targetAudienceId!: number | undefined;
    giftGroupId!: number | undefined;
    tag!: string | undefined;
    giftType!: string | undefined;
    targetAudienceType!: string | undefined;
    giftTargetAudienceID!: number | undefined;
    referenceCode!: string | undefined;
    giftInfoAgrs!: GiftInfoAgrs | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditGiftInforDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.name = data["name"];
            this.description = data["description"];
            this.introduce = data["introduce"];
            this.fullGiftCategoryCode = data["fullGiftCategoryCode"];
            this.producer = data["producer"];
            this.vendor = data["vendor"];
            this.effectiveFrom = data["effectiveFrom"] ? moment(data["effectiveFrom"].toString()) : <any>undefined;
            this.effectiveTo = data["effectiveTo"] ? moment(data["effectiveTo"].toString()) : <any>undefined;
            this.requiredCoin = data["requiredCoin"];
            this.status = data["status"];
            this.totalQuantity = data["totalQuantity"];
            this.usedQuantity = data["usedQuantity"];
            this.remainingQuantity = data["remainingQuantity"];
            this.isEGift = data["isEGift"];
            this.targetAudience = data["targetAudience"] ? CreateOrEditSettingParamDto.fromJS(data["targetAudience"]) : <any>undefined;
            if (data["giftGroup"] && data["giftGroup"].constructor === Array) {
                this.giftGroup = [];
                for (let item of data["giftGroup"])
                    this.giftGroup.push(GiftGroupDto.fromJS(item));
            }
            if (data["imageLinks"] && data["imageLinks"].constructor === Array) {
                this.imageLinks = [];
                for (let item of data["imageLinks"])
                    this.imageLinks.push(CreateOrEditImageLinkDto.fromJS(item));
            }
            this.amount = data["amount"];
            this.targetAudienceId = data["targetAudienceId"];
            this.giftGroupId = data["giftGroupId"];
            this.tag = data["tag"];
            this.giftType = data["giftType"];
            this.targetAudienceType = data["targetAudienceType"];
            this.giftTargetAudienceID = data["giftTargetAudienceID"];
            this.referenceCode = data["referenceCode"];
            this.giftInfoAgrs = data["giftInfoAgrs"] ? GiftInfoAgrs.fromJS(data["giftInfoAgrs"]) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditGiftInforDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditGiftInforDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["description"] = this.description;
        data["introduce"] = this.introduce;
        data["fullGiftCategoryCode"] = this.fullGiftCategoryCode;
        data["producer"] = this.producer;
        data["vendor"] = this.vendor;
        data["effectiveFrom"] = this.effectiveFrom ? this.effectiveFrom.toISOString() : <any>undefined;
        data["effectiveTo"] = this.effectiveTo ? this.effectiveTo.toISOString() : <any>undefined;
        data["requiredCoin"] = this.requiredCoin;
        data["status"] = this.status;
        data["totalQuantity"] = this.totalQuantity;
        data["usedQuantity"] = this.usedQuantity;
        data["remainingQuantity"] = this.remainingQuantity;
        data["isEGift"] = this.isEGift;
        data["targetAudience"] = this.targetAudience ? this.targetAudience.toJSON() : <any>undefined;
        if (this.giftGroup && this.giftGroup.constructor === Array) {
            data["giftGroup"] = [];
            for (let item of this.giftGroup)
                data["giftGroup"].push(item.toJSON());
        }
        if (this.imageLinks && this.imageLinks.constructor === Array) {
            data["imageLinks"] = [];
            for (let item of this.imageLinks)
                data["imageLinks"].push(item.toJSON());
        }
        data["amount"] = this.amount;
        data["targetAudienceId"] = this.targetAudienceId;
        data["giftGroupId"] = this.giftGroupId;
        data["tag"] = this.tag;
        data["giftType"] = this.giftType;
        data["targetAudienceType"] = this.targetAudienceType;
        data["giftTargetAudienceID"] = this.giftTargetAudienceID;
        data["referenceCode"] = this.referenceCode;
        data["giftInfoAgrs"] = this.giftInfoAgrs ? this.giftInfoAgrs.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditGiftInforDto {
    code: string | undefined;
    name: string | undefined;
    description: string | undefined;
    introduce: string | undefined;
    fullGiftCategoryCode: string | undefined;
    producer: string | undefined;
    vendor: string | undefined;
    effectiveFrom: moment.Moment | undefined;
    effectiveTo: moment.Moment | undefined;
    requiredCoin: number | undefined;
    status: string | undefined;
    totalQuantity: number | undefined;
    usedQuantity: number | undefined;
    remainingQuantity: number | undefined;
    isEGift: boolean | undefined;
    targetAudience: CreateOrEditSettingParamDto | undefined;
    giftGroup: GiftGroupDto[] | undefined;
    imageLinks: CreateOrEditImageLinkDto[] | undefined;
    amount: number | undefined;
    targetAudienceId: number | undefined;
    giftGroupId: number | undefined;
    tag: string | undefined;
    giftType: string | undefined;
    targetAudienceType: string | undefined;
    giftTargetAudienceID: number | undefined;
    referenceCode: string | undefined;
    giftInfoAgrs: GiftInfoAgrs | undefined;
    id: number | undefined;
}

export class GiftInfoAgrs implements IGiftInfoAgrs {
    targetAudienceId!: number | undefined;
    targetAudienceName!: string | undefined;
    targetAudienceType!: string | undefined;
    giftId!: number | undefined;
    tableName!: string | undefined;
    filePath!: string | undefined;
    fileName!: string | undefined;
    userId!: number | undefined;
    tenantId!: number | undefined;
    currentLanguage!: string | undefined;
    apiUrl!: string | undefined;

    constructor(data?: IGiftInfoAgrs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.targetAudienceId = data["targetAudienceId"];
            this.targetAudienceName = data["targetAudienceName"];
            this.targetAudienceType = data["targetAudienceType"];
            this.giftId = data["giftId"];
            this.tableName = data["tableName"];
            this.filePath = data["filePath"];
            this.fileName = data["fileName"];
            this.userId = data["userId"];
            this.tenantId = data["tenantId"];
            this.currentLanguage = data["currentLanguage"];
            this.apiUrl = data["apiUrl"];
        }
    }

    static fromJS(data: any): GiftInfoAgrs {
        data = typeof data === 'object' ? data : {};
        let result = new GiftInfoAgrs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["targetAudienceId"] = this.targetAudienceId;
        data["targetAudienceName"] = this.targetAudienceName;
        data["targetAudienceType"] = this.targetAudienceType;
        data["giftId"] = this.giftId;
        data["tableName"] = this.tableName;
        data["filePath"] = this.filePath;
        data["fileName"] = this.fileName;
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["currentLanguage"] = this.currentLanguage;
        data["apiUrl"] = this.apiUrl;
        return data;
    }
}

export interface IGiftInfoAgrs {
    targetAudienceId: number | undefined;
    targetAudienceName: string | undefined;
    targetAudienceType: string | undefined;
    giftId: number | undefined;
    tableName: string | undefined;
    filePath: string | undefined;
    fileName: string | undefined;
    userId: number | undefined;
    tenantId: number | undefined;
    currentLanguage: string | undefined;
    apiUrl: string | undefined;
}

export class GetGiftInforForViewOrEditDto implements IGetGiftInforForViewOrEditDto {
    giftInfor!: GiftInforDto | undefined;
    giftCategory!: GiftCategoryForSearchDto | undefined;
    giftGroup!: GiftGroupDto[] | undefined;
    imageLink!: ImageLinkDto[] | undefined;
    relatedGiftByCategory!: RelatedGiftByCategoryDto[] | undefined;

    constructor(data?: IGetGiftInforForViewOrEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.giftInfor = data["giftInfor"] ? GiftInforDto.fromJS(data["giftInfor"]) : <any>undefined;
            this.giftCategory = data["giftCategory"] ? GiftCategoryForSearchDto.fromJS(data["giftCategory"]) : <any>undefined;
            if (data["giftGroup"] && data["giftGroup"].constructor === Array) {
                this.giftGroup = [];
                for (let item of data["giftGroup"])
                    this.giftGroup.push(GiftGroupDto.fromJS(item));
            }
            if (data["imageLink"] && data["imageLink"].constructor === Array) {
                this.imageLink = [];
                for (let item of data["imageLink"])
                    this.imageLink.push(ImageLinkDto.fromJS(item));
            }
            if (data["relatedGiftByCategory"] && data["relatedGiftByCategory"].constructor === Array) {
                this.relatedGiftByCategory = [];
                for (let item of data["relatedGiftByCategory"])
                    this.relatedGiftByCategory.push(RelatedGiftByCategoryDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetGiftInforForViewOrEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGiftInforForViewOrEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["giftInfor"] = this.giftInfor ? this.giftInfor.toJSON() : <any>undefined;
        data["giftCategory"] = this.giftCategory ? this.giftCategory.toJSON() : <any>undefined;
        if (this.giftGroup && this.giftGroup.constructor === Array) {
            data["giftGroup"] = [];
            for (let item of this.giftGroup)
                data["giftGroup"].push(item.toJSON());
        }
        if (this.imageLink && this.imageLink.constructor === Array) {
            data["imageLink"] = [];
            for (let item of this.imageLink)
                data["imageLink"].push(item.toJSON());
        }
        if (this.relatedGiftByCategory && this.relatedGiftByCategory.constructor === Array) {
            data["relatedGiftByCategory"] = [];
            for (let item of this.relatedGiftByCategory)
                data["relatedGiftByCategory"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetGiftInforForViewOrEditDto {
    giftInfor: GiftInforDto | undefined;
    giftCategory: GiftCategoryForSearchDto | undefined;
    giftGroup: GiftGroupDto[] | undefined;
    imageLink: ImageLinkDto[] | undefined;
    relatedGiftByCategory: RelatedGiftByCategoryDto[] | undefined;
}

export class RelatedGiftByCategoryDto implements IRelatedGiftByCategoryDto {
    code!: string | undefined;
    name!: string | undefined;
    description!: string | undefined;
    introduce!: string | undefined;
    effectiveFrom!: moment.Moment | undefined;
    effectiveTo!: moment.Moment | undefined;
    requiredCoin!: number | undefined;
    status!: string | undefined;
    isEGift!: boolean | undefined;
    lastModificationTime!: moment.Moment | undefined;
    creationTime!: moment.Moment | undefined;
    tag!: string | undefined;
    referenceCode!: string | undefined;
    amount!: number | undefined;
    giftType!: string | undefined;
    imageLink!: ImageLinkDto[] | undefined;
    id!: number | undefined;

    constructor(data?: IRelatedGiftByCategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.name = data["name"];
            this.description = data["description"];
            this.introduce = data["introduce"];
            this.effectiveFrom = data["effectiveFrom"] ? moment(data["effectiveFrom"].toString()) : <any>undefined;
            this.effectiveTo = data["effectiveTo"] ? moment(data["effectiveTo"].toString()) : <any>undefined;
            this.requiredCoin = data["requiredCoin"];
            this.status = data["status"];
            this.isEGift = data["isEGift"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.tag = data["tag"];
            this.referenceCode = data["referenceCode"];
            this.amount = data["amount"];
            this.giftType = data["giftType"];
            if (data["imageLink"] && data["imageLink"].constructor === Array) {
                this.imageLink = [];
                for (let item of data["imageLink"])
                    this.imageLink.push(ImageLinkDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): RelatedGiftByCategoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new RelatedGiftByCategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["description"] = this.description;
        data["introduce"] = this.introduce;
        data["effectiveFrom"] = this.effectiveFrom ? this.effectiveFrom.toISOString() : <any>undefined;
        data["effectiveTo"] = this.effectiveTo ? this.effectiveTo.toISOString() : <any>undefined;
        data["requiredCoin"] = this.requiredCoin;
        data["status"] = this.status;
        data["isEGift"] = this.isEGift;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["tag"] = this.tag;
        data["referenceCode"] = this.referenceCode;
        data["amount"] = this.amount;
        data["giftType"] = this.giftType;
        if (this.imageLink && this.imageLink.constructor === Array) {
            data["imageLink"] = [];
            for (let item of this.imageLink)
                data["imageLink"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IRelatedGiftByCategoryDto {
    code: string | undefined;
    name: string | undefined;
    description: string | undefined;
    introduce: string | undefined;
    effectiveFrom: moment.Moment | undefined;
    effectiveTo: moment.Moment | undefined;
    requiredCoin: number | undefined;
    status: string | undefined;
    isEGift: boolean | undefined;
    lastModificationTime: moment.Moment | undefined;
    creationTime: moment.Moment | undefined;
    tag: string | undefined;
    referenceCode: string | undefined;
    amount: number | undefined;
    giftType: string | undefined;
    imageLink: ImageLinkDto[] | undefined;
    id: number | undefined;
}

export class GetAllGiftInforsInput implements IGetAllGiftInforsInput {
    filter!: string | undefined;
    codeFilter!: string | undefined;
    nameFilter!: string | undefined;
    introduceFilter!: string | undefined;
    fullGiftCategoryCodeFilter!: string | undefined;
    producerFilter!: string | undefined;
    vendorFilter!: string | undefined;
    statusFilter!: string | undefined;
    isEGiftFilter!: number | undefined;
    targetAudienceNameFilter!: string | undefined;
    giftGroupIdFilter!: number | undefined;
    maxAmountFilter!: number | undefined;
    minAmountFilter!: number | undefined;
    giftTypeFilter!: string | undefined;
    targetAudienceTypeFilter!: string | undefined;
    memberCodeFilter!: string | undefined;
    sorting!: string | undefined;
    skipCount!: number | undefined;
    maxResultCount!: number | undefined;

    constructor(data?: IGetAllGiftInforsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.filter = data["filter"];
            this.codeFilter = data["codeFilter"];
            this.nameFilter = data["nameFilter"];
            this.introduceFilter = data["introduceFilter"];
            this.fullGiftCategoryCodeFilter = data["fullGiftCategoryCodeFilter"];
            this.producerFilter = data["producerFilter"];
            this.vendorFilter = data["vendorFilter"];
            this.statusFilter = data["statusFilter"];
            this.isEGiftFilter = data["isEGiftFilter"];
            this.targetAudienceNameFilter = data["targetAudienceNameFilter"];
            this.giftGroupIdFilter = data["giftGroupIdFilter"];
            this.maxAmountFilter = data["maxAmountFilter"];
            this.minAmountFilter = data["minAmountFilter"];
            this.giftTypeFilter = data["giftTypeFilter"];
            this.targetAudienceTypeFilter = data["targetAudienceTypeFilter"];
            this.memberCodeFilter = data["memberCodeFilter"];
            this.sorting = data["sorting"];
            this.skipCount = data["skipCount"];
            this.maxResultCount = data["maxResultCount"];
        }
    }

    static fromJS(data: any): GetAllGiftInforsInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllGiftInforsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        data["codeFilter"] = this.codeFilter;
        data["nameFilter"] = this.nameFilter;
        data["introduceFilter"] = this.introduceFilter;
        data["fullGiftCategoryCodeFilter"] = this.fullGiftCategoryCodeFilter;
        data["producerFilter"] = this.producerFilter;
        data["vendorFilter"] = this.vendorFilter;
        data["statusFilter"] = this.statusFilter;
        data["isEGiftFilter"] = this.isEGiftFilter;
        data["targetAudienceNameFilter"] = this.targetAudienceNameFilter;
        data["giftGroupIdFilter"] = this.giftGroupIdFilter;
        data["maxAmountFilter"] = this.maxAmountFilter;
        data["minAmountFilter"] = this.minAmountFilter;
        data["giftTypeFilter"] = this.giftTypeFilter;
        data["targetAudienceTypeFilter"] = this.targetAudienceTypeFilter;
        data["memberCodeFilter"] = this.memberCodeFilter;
        data["sorting"] = this.sorting;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data;
    }
}

export interface IGetAllGiftInforsInput {
    filter: string | undefined;
    codeFilter: string | undefined;
    nameFilter: string | undefined;
    introduceFilter: string | undefined;
    fullGiftCategoryCodeFilter: string | undefined;
    producerFilter: string | undefined;
    vendorFilter: string | undefined;
    statusFilter: string | undefined;
    isEGiftFilter: number | undefined;
    targetAudienceNameFilter: string | undefined;
    giftGroupIdFilter: number | undefined;
    maxAmountFilter: number | undefined;
    minAmountFilter: number | undefined;
    giftTypeFilter: string | undefined;
    targetAudienceTypeFilter: string | undefined;
    memberCodeFilter: string | undefined;
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;
}

export class GetByCodeInput implements IGetByCodeInput {
    code!: string | undefined;

    constructor(data?: IGetByCodeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
        }
    }

    static fromJS(data: any): GetByCodeInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetByCodeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        return data;
    }
}

export interface IGetByCodeInput {
    code: string | undefined;
}

export class GetGiftInforForViewPG implements IGetGiftInforForViewPG {
    giftInfor!: GiftInforDto | undefined;
    cover!: string | undefined;
    price!: number | undefined;
    ordinal!: number | undefined;
    photos!: string[] | undefined;

    constructor(data?: IGetGiftInforForViewPG) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.giftInfor = data["giftInfor"] ? GiftInforDto.fromJS(data["giftInfor"]) : <any>undefined;
            this.cover = data["cover"];
            this.price = data["price"];
            this.ordinal = data["ordinal"];
            if (data["photos"] && data["photos"].constructor === Array) {
                this.photos = [];
                for (let item of data["photos"])
                    this.photos.push(item);
            }
        }
    }

    static fromJS(data: any): GetGiftInforForViewPG {
        data = typeof data === 'object' ? data : {};
        let result = new GetGiftInforForViewPG();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["giftInfor"] = this.giftInfor ? this.giftInfor.toJSON() : <any>undefined;
        data["cover"] = this.cover;
        data["price"] = this.price;
        data["ordinal"] = this.ordinal;
        if (this.photos && this.photos.constructor === Array) {
            data["photos"] = [];
            for (let item of this.photos)
                data["photos"].push(item);
        }
        return data;
    }
}

export interface IGetGiftInforForViewPG {
    giftInfor: GiftInforDto | undefined;
    cover: string | undefined;
    price: number | undefined;
    ordinal: number | undefined;
    photos: string[] | undefined;
}

export class GetAllGiftInforsPGInput implements IGetAllGiftInforsPGInput {
    filter!: string | undefined;
    codeFilter!: string | undefined;
    nameFilter!: string | undefined;
    introduceFilter!: string | undefined;
    giftCategoryCodeFilter!: string[] | undefined;
    producerFilter!: string | undefined;
    vendorFilter!: string | undefined;
    statusFilter!: string | undefined;
    isEGiftFilter!: number | undefined;
    giftGroupFilter!: string[] | undefined;
    sorting!: string | undefined;
    skipCount!: number | undefined;
    maxResultCount!: number | undefined;

    constructor(data?: IGetAllGiftInforsPGInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.filter = data["filter"];
            this.codeFilter = data["codeFilter"];
            this.nameFilter = data["nameFilter"];
            this.introduceFilter = data["introduceFilter"];
            if (data["giftCategoryCodeFilter"] && data["giftCategoryCodeFilter"].constructor === Array) {
                this.giftCategoryCodeFilter = [];
                for (let item of data["giftCategoryCodeFilter"])
                    this.giftCategoryCodeFilter.push(item);
            }
            this.producerFilter = data["producerFilter"];
            this.vendorFilter = data["vendorFilter"];
            this.statusFilter = data["statusFilter"];
            this.isEGiftFilter = data["isEGiftFilter"];
            if (data["giftGroupFilter"] && data["giftGroupFilter"].constructor === Array) {
                this.giftGroupFilter = [];
                for (let item of data["giftGroupFilter"])
                    this.giftGroupFilter.push(item);
            }
            this.sorting = data["sorting"];
            this.skipCount = data["skipCount"];
            this.maxResultCount = data["maxResultCount"];
        }
    }

    static fromJS(data: any): GetAllGiftInforsPGInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllGiftInforsPGInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        data["codeFilter"] = this.codeFilter;
        data["nameFilter"] = this.nameFilter;
        data["introduceFilter"] = this.introduceFilter;
        if (this.giftCategoryCodeFilter && this.giftCategoryCodeFilter.constructor === Array) {
            data["giftCategoryCodeFilter"] = [];
            for (let item of this.giftCategoryCodeFilter)
                data["giftCategoryCodeFilter"].push(item);
        }
        data["producerFilter"] = this.producerFilter;
        data["vendorFilter"] = this.vendorFilter;
        data["statusFilter"] = this.statusFilter;
        data["isEGiftFilter"] = this.isEGiftFilter;
        if (this.giftGroupFilter && this.giftGroupFilter.constructor === Array) {
            data["giftGroupFilter"] = [];
            for (let item of this.giftGroupFilter)
                data["giftGroupFilter"].push(item);
        }
        data["sorting"] = this.sorting;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data;
    }
}

export interface IGetAllGiftInforsPGInput {
    filter: string | undefined;
    codeFilter: string | undefined;
    nameFilter: string | undefined;
    introduceFilter: string | undefined;
    giftCategoryCodeFilter: string[] | undefined;
    producerFilter: string | undefined;
    vendorFilter: string | undefined;
    statusFilter: string | undefined;
    isEGiftFilter: number | undefined;
    giftGroupFilter: string[] | undefined;
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;
}

export class PagedResultDtoOfGetGiftInforGiftCategoryForViewPG implements IPagedResultDtoOfGetGiftInforGiftCategoryForViewPG {
    totalCount!: number | undefined;
    items!: GetGiftInforGiftCategoryForViewPG[] | undefined;

    constructor(data?: IPagedResultDtoOfGetGiftInforGiftCategoryForViewPG) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetGiftInforGiftCategoryForViewPG.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetGiftInforGiftCategoryForViewPG {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetGiftInforGiftCategoryForViewPG();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetGiftInforGiftCategoryForViewPG {
    totalCount: number | undefined;
    items: GetGiftInforGiftCategoryForViewPG[] | undefined;
}

export class GetGiftInforGiftCategoryForViewPG implements IGetGiftInforGiftCategoryForViewPG {
    listGiftInforForViewPG!: GetGiftInforForViewPG[] | undefined;
    listGiftCategoryForViewPG!: GetGiftCategoryForViewPG[] | undefined;

    constructor(data?: IGetGiftInforGiftCategoryForViewPG) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["listGiftInforForViewPG"] && data["listGiftInforForViewPG"].constructor === Array) {
                this.listGiftInforForViewPG = [];
                for (let item of data["listGiftInforForViewPG"])
                    this.listGiftInforForViewPG.push(GetGiftInforForViewPG.fromJS(item));
            }
            if (data["listGiftCategoryForViewPG"] && data["listGiftCategoryForViewPG"].constructor === Array) {
                this.listGiftCategoryForViewPG = [];
                for (let item of data["listGiftCategoryForViewPG"])
                    this.listGiftCategoryForViewPG.push(GetGiftCategoryForViewPG.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetGiftInforGiftCategoryForViewPG {
        data = typeof data === 'object' ? data : {};
        let result = new GetGiftInforGiftCategoryForViewPG();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.listGiftInforForViewPG && this.listGiftInforForViewPG.constructor === Array) {
            data["listGiftInforForViewPG"] = [];
            for (let item of this.listGiftInforForViewPG)
                data["listGiftInforForViewPG"].push(item.toJSON());
        }
        if (this.listGiftCategoryForViewPG && this.listGiftCategoryForViewPG.constructor === Array) {
            data["listGiftCategoryForViewPG"] = [];
            for (let item of this.listGiftCategoryForViewPG)
                data["listGiftCategoryForViewPG"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetGiftInforGiftCategoryForViewPG {
    listGiftInforForViewPG: GetGiftInforForViewPG[] | undefined;
    listGiftCategoryForViewPG: GetGiftCategoryForViewPG[] | undefined;
}

export class GetGiftCategoryForViewPG implements IGetGiftCategoryForViewPG {
    giftCategory!: GiftCategoryDto | undefined;
    cover!: string | undefined;

    constructor(data?: IGetGiftCategoryForViewPG) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.giftCategory = data["giftCategory"] ? GiftCategoryDto.fromJS(data["giftCategory"]) : <any>undefined;
            this.cover = data["cover"];
        }
    }

    static fromJS(data: any): GetGiftCategoryForViewPG {
        data = typeof data === 'object' ? data : {};
        let result = new GetGiftCategoryForViewPG();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["giftCategory"] = this.giftCategory ? this.giftCategory.toJSON() : <any>undefined;
        data["cover"] = this.cover;
        return data;
    }
}

export interface IGetGiftCategoryForViewPG {
    giftCategory: GiftCategoryDto | undefined;
    cover: string | undefined;
}

export class EGiftImportJobArgs implements IEGiftImportJobArgs {
    giftInfoId!: number | undefined;
    expiredDate!: moment.Moment | undefined;
    type!: string | undefined;
    tableName!: string | undefined;
    filePath!: string | undefined;
    fileName!: string | undefined;
    userId!: number | undefined;
    tenantId!: number | undefined;
    currentLanguage!: string | undefined;
    apiUrl!: string | undefined;

    constructor(data?: IEGiftImportJobArgs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.giftInfoId = data["giftInfoId"];
            this.expiredDate = data["expiredDate"] ? moment(data["expiredDate"].toString()) : <any>undefined;
            this.type = data["type"];
            this.tableName = data["tableName"];
            this.filePath = data["filePath"];
            this.fileName = data["fileName"];
            this.userId = data["userId"];
            this.tenantId = data["tenantId"];
            this.currentLanguage = data["currentLanguage"];
            this.apiUrl = data["apiUrl"];
        }
    }

    static fromJS(data: any): EGiftImportJobArgs {
        data = typeof data === 'object' ? data : {};
        let result = new EGiftImportJobArgs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["giftInfoId"] = this.giftInfoId;
        data["expiredDate"] = this.expiredDate ? this.expiredDate.toISOString() : <any>undefined;
        data["type"] = this.type;
        data["tableName"] = this.tableName;
        data["filePath"] = this.filePath;
        data["fileName"] = this.fileName;
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["currentLanguage"] = this.currentLanguage;
        data["apiUrl"] = this.apiUrl;
        return data;
    }
}

export interface IEGiftImportJobArgs {
    giftInfoId: number | undefined;
    expiredDate: moment.Moment | undefined;
    type: string | undefined;
    tableName: string | undefined;
    filePath: string | undefined;
    fileName: string | undefined;
    userId: number | undefined;
    tenantId: number | undefined;
    currentLanguage: string | undefined;
    apiUrl: string | undefined;
}

export class GetGiftInforForViewOrEditExtDto implements IGetGiftInforForViewOrEditExtDto {
    gift!: GiftInforDto | undefined;
    giftCategory!: GiftCategoryForSearchDto | undefined;
    giftGroup!: GiftGroupDto[] | undefined;
    imageLinks!: ImageLinkDto[] | undefined;

    constructor(data?: IGetGiftInforForViewOrEditExtDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.gift = data["gift"] ? GiftInforDto.fromJS(data["gift"]) : <any>undefined;
            this.giftCategory = data["giftCategory"] ? GiftCategoryForSearchDto.fromJS(data["giftCategory"]) : <any>undefined;
            if (data["giftGroup"] && data["giftGroup"].constructor === Array) {
                this.giftGroup = [];
                for (let item of data["giftGroup"])
                    this.giftGroup.push(GiftGroupDto.fromJS(item));
            }
            if (data["imageLinks"] && data["imageLinks"].constructor === Array) {
                this.imageLinks = [];
                for (let item of data["imageLinks"])
                    this.imageLinks.push(ImageLinkDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetGiftInforForViewOrEditExtDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGiftInforForViewOrEditExtDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gift"] = this.gift ? this.gift.toJSON() : <any>undefined;
        data["giftCategory"] = this.giftCategory ? this.giftCategory.toJSON() : <any>undefined;
        if (this.giftGroup && this.giftGroup.constructor === Array) {
            data["giftGroup"] = [];
            for (let item of this.giftGroup)
                data["giftGroup"].push(item.toJSON());
        }
        if (this.imageLinks && this.imageLinks.constructor === Array) {
            data["imageLinks"] = [];
            for (let item of this.imageLinks)
                data["imageLinks"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetGiftInforForViewOrEditExtDto {
    gift: GiftInforDto | undefined;
    giftCategory: GiftCategoryForSearchDto | undefined;
    giftGroup: GiftGroupDto[] | undefined;
    imageLinks: ImageLinkDto[] | undefined;
}

export class GiftInformationAgrs implements IGiftInformationAgrs {
    tableName!: string | undefined;
    filePath!: string | undefined;
    fileName!: string | undefined;
    userId!: number | undefined;
    tenantId!: number | undefined;
    currentLanguage!: string | undefined;
    apiUrl!: string | undefined;

    constructor(data?: IGiftInformationAgrs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tableName = data["tableName"];
            this.filePath = data["filePath"];
            this.fileName = data["fileName"];
            this.userId = data["userId"];
            this.tenantId = data["tenantId"];
            this.currentLanguage = data["currentLanguage"];
            this.apiUrl = data["apiUrl"];
        }
    }

    static fromJS(data: any): GiftInformationAgrs {
        data = typeof data === 'object' ? data : {};
        let result = new GiftInformationAgrs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tableName"] = this.tableName;
        data["filePath"] = this.filePath;
        data["fileName"] = this.fileName;
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["currentLanguage"] = this.currentLanguage;
        data["apiUrl"] = this.apiUrl;
        return data;
    }
}

export interface IGiftInformationAgrs {
    tableName: string | undefined;
    filePath: string | undefined;
    fileName: string | undefined;
    userId: number | undefined;
    tenantId: number | undefined;
    currentLanguage: string | undefined;
    apiUrl: string | undefined;
}

export class PagedResultDtoOfGetGiftMasterForViewDto implements IPagedResultDtoOfGetGiftMasterForViewDto {
    totalCount!: number | undefined;
    items!: GetGiftMasterForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetGiftMasterForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetGiftMasterForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetGiftMasterForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetGiftMasterForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetGiftMasterForViewDto {
    totalCount: number | undefined;
    items: GetGiftMasterForViewDto[] | undefined;
}

export class GetGiftMasterForViewDto implements IGetGiftMasterForViewDto {
    giftMaster!: GiftMasterDto | undefined;

    constructor(data?: IGetGiftMasterForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.giftMaster = data["giftMaster"] ? GiftMasterDto.fromJS(data["giftMaster"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetGiftMasterForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGiftMasterForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["giftMaster"] = this.giftMaster ? this.giftMaster.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetGiftMasterForViewDto {
    giftMaster: GiftMasterDto | undefined;
}

export class GiftMasterDto implements IGiftMasterDto {
    code!: string | undefined;
    name!: string | undefined;
    quantity!: number | undefined;
    price!: number | undefined;
    description!: string | undefined;
    effectiveFrom!: moment.Moment | undefined;
    effectiveTo!: moment.Moment | undefined;
    expireDate!: moment.Moment | undefined;
    status!: string | undefined;
    imageLink!: string | undefined;
    nameUnsign!: string | undefined;
    productType!: string | undefined;
    publisher!: string | undefined;
    publisherName!: string | undefined;
    id!: number | undefined;

    constructor(data?: IGiftMasterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.name = data["name"];
            this.quantity = data["quantity"];
            this.price = data["price"];
            this.description = data["description"];
            this.effectiveFrom = data["effectiveFrom"] ? moment(data["effectiveFrom"].toString()) : <any>undefined;
            this.effectiveTo = data["effectiveTo"] ? moment(data["effectiveTo"].toString()) : <any>undefined;
            this.expireDate = data["expireDate"] ? moment(data["expireDate"].toString()) : <any>undefined;
            this.status = data["status"];
            this.imageLink = data["imageLink"];
            this.nameUnsign = data["nameUnsign"];
            this.productType = data["productType"];
            this.publisher = data["publisher"];
            this.publisherName = data["publisherName"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): GiftMasterDto {
        data = typeof data === 'object' ? data : {};
        let result = new GiftMasterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["quantity"] = this.quantity;
        data["price"] = this.price;
        data["description"] = this.description;
        data["effectiveFrom"] = this.effectiveFrom ? this.effectiveFrom.toISOString() : <any>undefined;
        data["effectiveTo"] = this.effectiveTo ? this.effectiveTo.toISOString() : <any>undefined;
        data["expireDate"] = this.expireDate ? this.expireDate.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["imageLink"] = this.imageLink;
        data["nameUnsign"] = this.nameUnsign;
        data["productType"] = this.productType;
        data["publisher"] = this.publisher;
        data["publisherName"] = this.publisherName;
        data["id"] = this.id;
        return data;
    }
}

export interface IGiftMasterDto {
    code: string | undefined;
    name: string | undefined;
    quantity: number | undefined;
    price: number | undefined;
    description: string | undefined;
    effectiveFrom: moment.Moment | undefined;
    effectiveTo: moment.Moment | undefined;
    expireDate: moment.Moment | undefined;
    status: string | undefined;
    imageLink: string | undefined;
    nameUnsign: string | undefined;
    productType: string | undefined;
    publisher: string | undefined;
    publisherName: string | undefined;
    id: number | undefined;
}

export class GetGiftMasterForEditOutput implements IGetGiftMasterForEditOutput {
    giftMaster!: CreateOrEditGiftMasterDto | undefined;

    constructor(data?: IGetGiftMasterForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.giftMaster = data["giftMaster"] ? CreateOrEditGiftMasterDto.fromJS(data["giftMaster"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetGiftMasterForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetGiftMasterForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["giftMaster"] = this.giftMaster ? this.giftMaster.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetGiftMasterForEditOutput {
    giftMaster: CreateOrEditGiftMasterDto | undefined;
}

export class CreateOrEditGiftMasterDto implements ICreateOrEditGiftMasterDto {
    code!: string;
    name!: string | undefined;
    quantity!: number | undefined;
    price!: number | undefined;
    description!: string | undefined;
    effectiveFrom!: moment.Moment | undefined;
    effectiveTo!: moment.Moment | undefined;
    expireDate!: moment.Moment | undefined;
    status!: string | undefined;
    imageLink!: string | undefined;
    nameUnsign!: string | undefined;
    productType!: string | undefined;
    publisher!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditGiftMasterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.name = data["name"];
            this.quantity = data["quantity"];
            this.price = data["price"];
            this.description = data["description"];
            this.effectiveFrom = data["effectiveFrom"] ? moment(data["effectiveFrom"].toString()) : <any>undefined;
            this.effectiveTo = data["effectiveTo"] ? moment(data["effectiveTo"].toString()) : <any>undefined;
            this.expireDate = data["expireDate"] ? moment(data["expireDate"].toString()) : <any>undefined;
            this.status = data["status"];
            this.imageLink = data["imageLink"];
            this.nameUnsign = data["nameUnsign"];
            this.productType = data["productType"];
            this.publisher = data["publisher"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditGiftMasterDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditGiftMasterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["quantity"] = this.quantity;
        data["price"] = this.price;
        data["description"] = this.description;
        data["effectiveFrom"] = this.effectiveFrom ? this.effectiveFrom.toISOString() : <any>undefined;
        data["effectiveTo"] = this.effectiveTo ? this.effectiveTo.toISOString() : <any>undefined;
        data["expireDate"] = this.expireDate ? this.expireDate.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["imageLink"] = this.imageLink;
        data["nameUnsign"] = this.nameUnsign;
        data["productType"] = this.productType;
        data["publisher"] = this.publisher;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditGiftMasterDto {
    code: string;
    name: string | undefined;
    quantity: number | undefined;
    price: number | undefined;
    description: string | undefined;
    effectiveFrom: moment.Moment | undefined;
    effectiveTo: moment.Moment | undefined;
    expireDate: moment.Moment | undefined;
    status: string | undefined;
    imageLink: string | undefined;
    nameUnsign: string | undefined;
    productType: string | undefined;
    publisher: string | undefined;
    id: number | undefined;
}

export class MessageResultForDeleteGift implements IMessageResultForDeleteGift {
    isError!: boolean | undefined;
    isDeleted!: boolean | undefined;
    errors!: MessageErrorForDeleteGift[] | undefined;

    constructor(data?: IMessageResultForDeleteGift) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isError = data["isError"];
            this.isDeleted = data["isDeleted"];
            if (data["errors"] && data["errors"].constructor === Array) {
                this.errors = [];
                for (let item of data["errors"])
                    this.errors.push(MessageErrorForDeleteGift.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MessageResultForDeleteGift {
        data = typeof data === 'object' ? data : {};
        let result = new MessageResultForDeleteGift();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isError"] = this.isError;
        data["isDeleted"] = this.isDeleted;
        if (this.errors && this.errors.constructor === Array) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMessageResultForDeleteGift {
    isError: boolean | undefined;
    isDeleted: boolean | undefined;
    errors: MessageErrorForDeleteGift[] | undefined;
}

export class MessageErrorForDeleteGift implements IMessageErrorForDeleteGift {
    message!: string | undefined;
    propertyName!: string | undefined;
    count!: number | undefined;

    constructor(data?: IMessageErrorForDeleteGift) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.message = data["message"];
            this.propertyName = data["propertyName"];
            this.count = data["count"];
        }
    }

    static fromJS(data: any): MessageErrorForDeleteGift {
        data = typeof data === 'object' ? data : {};
        let result = new MessageErrorForDeleteGift();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["propertyName"] = this.propertyName;
        data["count"] = this.count;
        return data;
    }
}

export interface IMessageErrorForDeleteGift {
    message: string | undefined;
    propertyName: string | undefined;
    count: number | undefined;
}

export class PublisherForGiftMasterDto implements IPublisherForGiftMasterDto {
    code!: string | undefined;
    name!: string | undefined;

    constructor(data?: IPublisherForGiftMasterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.name = data["name"];
        }
    }

    static fromJS(data: any): PublisherForGiftMasterDto {
        data = typeof data === 'object' ? data : {};
        let result = new PublisherForGiftMasterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        return data;
    }
}

export interface IPublisherForGiftMasterDto {
    code: string | undefined;
    name: string | undefined;
}

export class MessageResultGift implements IMessageResultGift {
    isSuccess!: boolean | undefined;
    voucherImageLink!: string[] | undefined;
    errors!: MessageErrorGift[] | undefined;

    constructor(data?: IMessageResultGift) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isSuccess = data["isSuccess"];
            if (data["voucherImageLink"] && data["voucherImageLink"].constructor === Array) {
                this.voucherImageLink = [];
                for (let item of data["voucherImageLink"])
                    this.voucherImageLink.push(item);
            }
            if (data["errors"] && data["errors"].constructor === Array) {
                this.errors = [];
                for (let item of data["errors"])
                    this.errors.push(MessageErrorGift.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MessageResultGift {
        data = typeof data === 'object' ? data : {};
        let result = new MessageResultGift();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        if (this.voucherImageLink && this.voucherImageLink.constructor === Array) {
            data["voucherImageLink"] = [];
            for (let item of this.voucherImageLink)
                data["voucherImageLink"].push(item);
        }
        if (this.errors && this.errors.constructor === Array) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMessageResultGift {
    isSuccess: boolean | undefined;
    voucherImageLink: string[] | undefined;
    errors: MessageErrorGift[] | undefined;
}

export class MessageErrorGift implements IMessageErrorGift {
    message!: string | undefined;
    propertyName!: string | undefined;
    count!: number | undefined;

    constructor(data?: IMessageErrorGift) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.message = data["message"];
            this.propertyName = data["propertyName"];
            this.count = data["count"];
        }
    }

    static fromJS(data: any): MessageErrorGift {
        data = typeof data === 'object' ? data : {};
        let result = new MessageErrorGift();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["propertyName"] = this.propertyName;
        data["count"] = this.count;
        return data;
    }
}

export interface IMessageErrorGift {
    message: string | undefined;
    propertyName: string | undefined;
    count: number | undefined;
}

export class GiftMasterImportAgrs implements IGiftMasterImportAgrs {
    giftMasterImportDto!: GiftMasterImportDto[] | undefined;
    tableName!: string | undefined;
    filePath!: string | undefined;
    fileName!: string | undefined;
    userId!: number | undefined;
    tenantId!: number | undefined;
    currentLanguage!: string | undefined;
    apiUrl!: string | undefined;

    constructor(data?: IGiftMasterImportAgrs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["giftMasterImportDto"] && data["giftMasterImportDto"].constructor === Array) {
                this.giftMasterImportDto = [];
                for (let item of data["giftMasterImportDto"])
                    this.giftMasterImportDto.push(GiftMasterImportDto.fromJS(item));
            }
            this.tableName = data["tableName"];
            this.filePath = data["filePath"];
            this.fileName = data["fileName"];
            this.userId = data["userId"];
            this.tenantId = data["tenantId"];
            this.currentLanguage = data["currentLanguage"];
            this.apiUrl = data["apiUrl"];
        }
    }

    static fromJS(data: any): GiftMasterImportAgrs {
        data = typeof data === 'object' ? data : {};
        let result = new GiftMasterImportAgrs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.giftMasterImportDto && this.giftMasterImportDto.constructor === Array) {
            data["giftMasterImportDto"] = [];
            for (let item of this.giftMasterImportDto)
                data["giftMasterImportDto"].push(item.toJSON());
        }
        data["tableName"] = this.tableName;
        data["filePath"] = this.filePath;
        data["fileName"] = this.fileName;
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["currentLanguage"] = this.currentLanguage;
        data["apiUrl"] = this.apiUrl;
        return data;
    }
}

export interface IGiftMasterImportAgrs {
    giftMasterImportDto: GiftMasterImportDto[] | undefined;
    tableName: string | undefined;
    filePath: string | undefined;
    fileName: string | undefined;
    userId: number | undefined;
    tenantId: number | undefined;
    currentLanguage: string | undefined;
    apiUrl: string | undefined;
}

export class GiftMasterImportDto implements IGiftMasterImportDto {
    tenantId!: number | undefined;
    code!: string | undefined;
    name!: string | undefined;
    price!: string | undefined;
    productType!: string | undefined;
    publisher!: string | undefined;
    status!: string | undefined;
    description!: string | undefined;
    nameUnSign!: string | undefined;
    isDeleted!: boolean | undefined;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: moment.Moment | undefined;
    creatorUserId!: number | undefined;
    id!: number | undefined;

    constructor(data?: IGiftMasterImportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.code = data["code"];
            this.name = data["name"];
            this.price = data["price"];
            this.productType = data["productType"];
            this.publisher = data["publisher"];
            this.status = data["status"];
            this.description = data["description"];
            this.nameUnSign = data["nameUnSign"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): GiftMasterImportDto {
        data = typeof data === 'object' ? data : {};
        let result = new GiftMasterImportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["code"] = this.code;
        data["name"] = this.name;
        data["price"] = this.price;
        data["productType"] = this.productType;
        data["publisher"] = this.publisher;
        data["status"] = this.status;
        data["description"] = this.description;
        data["nameUnSign"] = this.nameUnSign;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IGiftMasterImportDto {
    tenantId: number | undefined;
    code: string | undefined;
    name: string | undefined;
    price: string | undefined;
    productType: string | undefined;
    publisher: string | undefined;
    status: string | undefined;
    description: string | undefined;
    nameUnSign: string | undefined;
    isDeleted: boolean | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfGetGiftRedeemLogForViewDto implements IPagedResultDtoOfGetGiftRedeemLogForViewDto {
    totalCount!: number | undefined;
    items!: GetGiftRedeemLogForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetGiftRedeemLogForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetGiftRedeemLogForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetGiftRedeemLogForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetGiftRedeemLogForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetGiftRedeemLogForViewDto {
    totalCount: number | undefined;
    items: GetGiftRedeemLogForViewDto[] | undefined;
}

export class GetGiftRedeemLogForViewDto implements IGetGiftRedeemLogForViewDto {
    giftRedeemLog!: GiftRedeemLogDto | undefined;

    constructor(data?: IGetGiftRedeemLogForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.giftRedeemLog = data["giftRedeemLog"] ? GiftRedeemLogDto.fromJS(data["giftRedeemLog"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetGiftRedeemLogForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGiftRedeemLogForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["giftRedeemLog"] = this.giftRedeemLog ? this.giftRedeemLog.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetGiftRedeemLogForViewDto {
    giftRedeemLog: GiftRedeemLogDto | undefined;
}

export class GiftRedeemLogDto implements IGiftRedeemLogDto {
    memberCode!: string | undefined;
    giftCode!: string | undefined;
    transactionCode!: string | undefined;
    referenceCode!: string | undefined;
    type!: string | undefined;
    data!: string | undefined;
    status!: string | undefined;
    id!: number | undefined;

    constructor(data?: IGiftRedeemLogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberCode = data["memberCode"];
            this.giftCode = data["giftCode"];
            this.transactionCode = data["transactionCode"];
            this.referenceCode = data["referenceCode"];
            this.type = data["type"];
            this.data = data["data"];
            this.status = data["status"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): GiftRedeemLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new GiftRedeemLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberCode"] = this.memberCode;
        data["giftCode"] = this.giftCode;
        data["transactionCode"] = this.transactionCode;
        data["referenceCode"] = this.referenceCode;
        data["type"] = this.type;
        data["data"] = this.data;
        data["status"] = this.status;
        data["id"] = this.id;
        return data;
    }
}

export interface IGiftRedeemLogDto {
    memberCode: string | undefined;
    giftCode: string | undefined;
    transactionCode: string | undefined;
    referenceCode: string | undefined;
    type: string | undefined;
    data: string | undefined;
    status: string | undefined;
    id: number | undefined;
}

export class GetGiftRedeemLogForEditOutput implements IGetGiftRedeemLogForEditOutput {
    giftRedeemLog!: CreateOrEditGiftRedeemLogDto | undefined;

    constructor(data?: IGetGiftRedeemLogForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.giftRedeemLog = data["giftRedeemLog"] ? CreateOrEditGiftRedeemLogDto.fromJS(data["giftRedeemLog"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetGiftRedeemLogForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetGiftRedeemLogForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["giftRedeemLog"] = this.giftRedeemLog ? this.giftRedeemLog.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetGiftRedeemLogForEditOutput {
    giftRedeemLog: CreateOrEditGiftRedeemLogDto | undefined;
}

export class CreateOrEditGiftRedeemLogDto implements ICreateOrEditGiftRedeemLogDto {
    memberCode!: string | undefined;
    giftCode!: string | undefined;
    transactionCode!: string | undefined;
    referenceCode!: string | undefined;
    type!: string | undefined;
    data!: string | undefined;
    status!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditGiftRedeemLogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberCode = data["memberCode"];
            this.giftCode = data["giftCode"];
            this.transactionCode = data["transactionCode"];
            this.referenceCode = data["referenceCode"];
            this.type = data["type"];
            this.data = data["data"];
            this.status = data["status"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditGiftRedeemLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditGiftRedeemLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberCode"] = this.memberCode;
        data["giftCode"] = this.giftCode;
        data["transactionCode"] = this.transactionCode;
        data["referenceCode"] = this.referenceCode;
        data["type"] = this.type;
        data["data"] = this.data;
        data["status"] = this.status;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditGiftRedeemLogDto {
    memberCode: string | undefined;
    giftCode: string | undefined;
    transactionCode: string | undefined;
    referenceCode: string | undefined;
    type: string | undefined;
    data: string | undefined;
    status: string | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfGetGiftRedeemTransactionForView implements IPagedResultDtoOfGetGiftRedeemTransactionForView {
    totalCount!: number | undefined;
    items!: GetGiftRedeemTransactionForView[] | undefined;

    constructor(data?: IPagedResultDtoOfGetGiftRedeemTransactionForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetGiftRedeemTransactionForView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetGiftRedeemTransactionForView {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetGiftRedeemTransactionForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetGiftRedeemTransactionForView {
    totalCount: number | undefined;
    items: GetGiftRedeemTransactionForView[] | undefined;
}

export class GetGiftRedeemTransactionForView implements IGetGiftRedeemTransactionForView {
    giftTransaction!: GiftRedeemTransactionDto | undefined;
    email!: string | undefined;
    note!: string | undefined;

    constructor(data?: IGetGiftRedeemTransactionForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.giftTransaction = data["giftTransaction"] ? GiftRedeemTransactionDto.fromJS(data["giftTransaction"]) : <any>undefined;
            this.email = data["email"];
            this.note = data["note"];
        }
    }

    static fromJS(data: any): GetGiftRedeemTransactionForView {
        data = typeof data === 'object' ? data : {};
        let result = new GetGiftRedeemTransactionForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["giftTransaction"] = this.giftTransaction ? this.giftTransaction.toJSON() : <any>undefined;
        data["email"] = this.email;
        data["note"] = this.note;
        return data;
    }
}

export interface IGetGiftRedeemTransactionForView {
    giftTransaction: GiftRedeemTransactionDto | undefined;
    email: string | undefined;
    note: string | undefined;
}

export class GiftRedeemTransactionDto implements IGiftRedeemTransactionDto {
    code!: string | undefined;
    memberCode!: string | undefined;
    memberName!: string | undefined;
    phone!: string | undefined;
    address!: string | undefined;
    giftCode!: string | undefined;
    giftName!: string | undefined;
    name!: string | undefined;
    quantity!: number | undefined;
    coin!: number | undefined;
    date!: moment.Moment | undefined;
    status!: string | undefined;
    memberId!: number | undefined;
    giftId!: number | undefined;
    reason!: string | undefined;
    totalCoin!: number | undefined;
    description!: string | undefined;
    introduce!: string | undefined;
    id!: number | undefined;

    constructor(data?: IGiftRedeemTransactionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.memberCode = data["memberCode"];
            this.memberName = data["memberName"];
            this.phone = data["phone"];
            this.address = data["address"];
            this.giftCode = data["giftCode"];
            this.giftName = data["giftName"];
            this.name = data["name"];
            this.quantity = data["quantity"];
            this.coin = data["coin"];
            this.date = data["date"] ? moment(data["date"].toString()) : <any>undefined;
            this.status = data["status"];
            this.memberId = data["memberId"];
            this.giftId = data["giftId"];
            this.reason = data["reason"];
            this.totalCoin = data["totalCoin"];
            this.description = data["description"];
            this.introduce = data["introduce"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): GiftRedeemTransactionDto {
        data = typeof data === 'object' ? data : {};
        let result = new GiftRedeemTransactionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["memberCode"] = this.memberCode;
        data["memberName"] = this.memberName;
        data["phone"] = this.phone;
        data["address"] = this.address;
        data["giftCode"] = this.giftCode;
        data["giftName"] = this.giftName;
        data["name"] = this.name;
        data["quantity"] = this.quantity;
        data["coin"] = this.coin;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["memberId"] = this.memberId;
        data["giftId"] = this.giftId;
        data["reason"] = this.reason;
        data["totalCoin"] = this.totalCoin;
        data["description"] = this.description;
        data["introduce"] = this.introduce;
        data["id"] = this.id;
        return data;
    }
}

export interface IGiftRedeemTransactionDto {
    code: string | undefined;
    memberCode: string | undefined;
    memberName: string | undefined;
    phone: string | undefined;
    address: string | undefined;
    giftCode: string | undefined;
    giftName: string | undefined;
    name: string | undefined;
    quantity: number | undefined;
    coin: number | undefined;
    date: moment.Moment | undefined;
    status: string | undefined;
    memberId: number | undefined;
    giftId: number | undefined;
    reason: string | undefined;
    totalCoin: number | undefined;
    description: string | undefined;
    introduce: string | undefined;
    id: number | undefined;
}

export class GetGiftRedeemTransactionForEditOutput implements IGetGiftRedeemTransactionForEditOutput {
    giftTransaction!: CreateOrEditGiftRedeemTransactionDto | undefined;
    memberFirstName!: string | undefined;
    giftTenantId!: string | undefined;

    constructor(data?: IGetGiftRedeemTransactionForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.giftTransaction = data["giftTransaction"] ? CreateOrEditGiftRedeemTransactionDto.fromJS(data["giftTransaction"]) : <any>undefined;
            this.memberFirstName = data["memberFirstName"];
            this.giftTenantId = data["giftTenantId"];
        }
    }

    static fromJS(data: any): GetGiftRedeemTransactionForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetGiftRedeemTransactionForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["giftTransaction"] = this.giftTransaction ? this.giftTransaction.toJSON() : <any>undefined;
        data["memberFirstName"] = this.memberFirstName;
        data["giftTenantId"] = this.giftTenantId;
        return data;
    }
}

export interface IGetGiftRedeemTransactionForEditOutput {
    giftTransaction: CreateOrEditGiftRedeemTransactionDto | undefined;
    memberFirstName: string | undefined;
    giftTenantId: string | undefined;
}

export class CreateOrEditGiftRedeemTransactionDto implements ICreateOrEditGiftRedeemTransactionDto {
    code!: string;
    memberCode!: string | undefined;
    giftCode!: string | undefined;
    eGiftCode!: string | undefined;
    quantity!: number | undefined;
    status!: string | undefined;
    memberId!: number | undefined;
    giftId!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditGiftRedeemTransactionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.memberCode = data["memberCode"];
            this.giftCode = data["giftCode"];
            this.eGiftCode = data["eGiftCode"];
            this.quantity = data["quantity"];
            this.status = data["status"];
            this.memberId = data["memberId"];
            this.giftId = data["giftId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditGiftRedeemTransactionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditGiftRedeemTransactionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["memberCode"] = this.memberCode;
        data["giftCode"] = this.giftCode;
        data["eGiftCode"] = this.eGiftCode;
        data["quantity"] = this.quantity;
        data["status"] = this.status;
        data["memberId"] = this.memberId;
        data["giftId"] = this.giftId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditGiftRedeemTransactionDto {
    code: string;
    memberCode: string | undefined;
    giftCode: string | undefined;
    eGiftCode: string | undefined;
    quantity: number | undefined;
    status: string | undefined;
    memberId: number | undefined;
    giftId: number | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfSecondaryCustomerLookupTableDto implements IPagedResultDtoOfSecondaryCustomerLookupTableDto {
    totalCount!: number | undefined;
    items!: SecondaryCustomerLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfSecondaryCustomerLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(SecondaryCustomerLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfSecondaryCustomerLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfSecondaryCustomerLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfSecondaryCustomerLookupTableDto {
    totalCount: number | undefined;
    items: SecondaryCustomerLookupTableDto[] | undefined;
}

export class SecondaryCustomerLookupTableDto implements ISecondaryCustomerLookupTableDto {
    id!: number | undefined;
    displayName!: string | undefined;

    constructor(data?: ISecondaryCustomerLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): SecondaryCustomerLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new SecondaryCustomerLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface ISecondaryCustomerLookupTableDto {
    id: number | undefined;
    displayName: string | undefined;
}

export class PagedResultDtoOfGetGiftTransactionWithEGiftForView implements IPagedResultDtoOfGetGiftTransactionWithEGiftForView {
    totalCount!: number | undefined;
    items!: GetGiftTransactionWithEGiftForView[] | undefined;

    constructor(data?: IPagedResultDtoOfGetGiftTransactionWithEGiftForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetGiftTransactionWithEGiftForView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetGiftTransactionWithEGiftForView {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetGiftTransactionWithEGiftForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetGiftTransactionWithEGiftForView {
    totalCount: number | undefined;
    items: GetGiftTransactionWithEGiftForView[] | undefined;
}

export class GetGiftTransactionWithEGiftForView implements IGetGiftTransactionWithEGiftForView {
    giftTransaction!: GiftRedeemTransactionDto | undefined;
    eGift!: EGiftInforDto | undefined;
    imageLinks!: ImageLinkDto[] | undefined;

    constructor(data?: IGetGiftTransactionWithEGiftForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.giftTransaction = data["giftTransaction"] ? GiftRedeemTransactionDto.fromJS(data["giftTransaction"]) : <any>undefined;
            this.eGift = data["eGift"] ? EGiftInforDto.fromJS(data["eGift"]) : <any>undefined;
            if (data["imageLinks"] && data["imageLinks"].constructor === Array) {
                this.imageLinks = [];
                for (let item of data["imageLinks"])
                    this.imageLinks.push(ImageLinkDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetGiftTransactionWithEGiftForView {
        data = typeof data === 'object' ? data : {};
        let result = new GetGiftTransactionWithEGiftForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["giftTransaction"] = this.giftTransaction ? this.giftTransaction.toJSON() : <any>undefined;
        data["eGift"] = this.eGift ? this.eGift.toJSON() : <any>undefined;
        if (this.imageLinks && this.imageLinks.constructor === Array) {
            data["imageLinks"] = [];
            for (let item of this.imageLinks)
                data["imageLinks"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetGiftTransactionWithEGiftForView {
    giftTransaction: GiftRedeemTransactionDto | undefined;
    eGift: EGiftInforDto | undefined;
    imageLinks: ImageLinkDto[] | undefined;
}

export class RequestDataCheckRedeemTransaction implements IRequestDataCheckRedeemTransaction {
    memberCode!: string | undefined;
    from!: moment.Moment | undefined;
    to!: moment.Moment | undefined;
    status!: string | undefined;
    sorting!: string | undefined;
    skipCount!: number | undefined;
    maxResultCount!: number | undefined;

    constructor(data?: IRequestDataCheckRedeemTransaction) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberCode = data["memberCode"];
            this.from = data["from"] ? moment(data["from"].toString()) : <any>undefined;
            this.to = data["to"] ? moment(data["to"].toString()) : <any>undefined;
            this.status = data["status"];
            this.sorting = data["sorting"];
            this.skipCount = data["skipCount"];
            this.maxResultCount = data["maxResultCount"];
        }
    }

    static fromJS(data: any): RequestDataCheckRedeemTransaction {
        data = typeof data === 'object' ? data : {};
        let result = new RequestDataCheckRedeemTransaction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberCode"] = this.memberCode;
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["to"] = this.to ? this.to.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["sorting"] = this.sorting;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data;
    }
}

export interface IRequestDataCheckRedeemTransaction {
    memberCode: string | undefined;
    from: moment.Moment | undefined;
    to: moment.Moment | undefined;
    status: string | undefined;
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;
}

export class ReponseCheckDataRedeemTransaction implements IReponseCheckDataRedeemTransaction {
    items!: ReponseDataCheckRedeemTransaction[] | undefined;
    totalCount!: number | undefined;
    exception!: string | undefined;
    messages!: string | undefined;

    constructor(data?: IReponseCheckDataRedeemTransaction) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(ReponseDataCheckRedeemTransaction.fromJS(item));
            }
            this.totalCount = data["totalCount"];
            this.exception = data["exception"];
            this.messages = data["messages"];
        }
    }

    static fromJS(data: any): ReponseCheckDataRedeemTransaction {
        data = typeof data === 'object' ? data : {};
        let result = new ReponseCheckDataRedeemTransaction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["exception"] = this.exception;
        data["messages"] = this.messages;
        return data;
    }
}

export interface IReponseCheckDataRedeemTransaction {
    items: ReponseDataCheckRedeemTransaction[] | undefined;
    totalCount: number | undefined;
    exception: string | undefined;
    messages: string | undefined;
}

export class ReponseDataCheckRedeemTransaction implements IReponseDataCheckRedeemTransaction {
    code!: string | undefined;
    creationTime!: moment.Moment | undefined;
    memberCode!: string | undefined;
    reason!: string | undefined;
    quantity!: number | undefined;
    coin!: number | undefined;
    totalCoin!: number | undefined;
    status!: string | undefined;
    giftCode!: string | undefined;
    eGift!: EGiftData[] | undefined;
    totalCount!: number | undefined;
    exception!: string | undefined;
    messages!: string | undefined;

    constructor(data?: IReponseDataCheckRedeemTransaction) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.memberCode = data["memberCode"];
            this.reason = data["reason"];
            this.quantity = data["quantity"];
            this.coin = data["coin"];
            this.totalCoin = data["totalCoin"];
            this.status = data["status"];
            this.giftCode = data["giftCode"];
            if (data["eGift"] && data["eGift"].constructor === Array) {
                this.eGift = [];
                for (let item of data["eGift"])
                    this.eGift.push(EGiftData.fromJS(item));
            }
            this.totalCount = data["totalCount"];
            this.exception = data["exception"];
            this.messages = data["messages"];
        }
    }

    static fromJS(data: any): ReponseDataCheckRedeemTransaction {
        data = typeof data === 'object' ? data : {};
        let result = new ReponseDataCheckRedeemTransaction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["memberCode"] = this.memberCode;
        data["reason"] = this.reason;
        data["quantity"] = this.quantity;
        data["coin"] = this.coin;
        data["totalCoin"] = this.totalCoin;
        data["status"] = this.status;
        data["giftCode"] = this.giftCode;
        if (this.eGift && this.eGift.constructor === Array) {
            data["eGift"] = [];
            for (let item of this.eGift)
                data["eGift"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["exception"] = this.exception;
        data["messages"] = this.messages;
        return data;
    }
}

export interface IReponseDataCheckRedeemTransaction {
    code: string | undefined;
    creationTime: moment.Moment | undefined;
    memberCode: string | undefined;
    reason: string | undefined;
    quantity: number | undefined;
    coin: number | undefined;
    totalCoin: number | undefined;
    status: string | undefined;
    giftCode: string | undefined;
    eGift: EGiftData[] | undefined;
    totalCount: number | undefined;
    exception: string | undefined;
    messages: string | undefined;
}

export class EGiftData implements IEGiftData {
    code!: string | undefined;
    name!: string | undefined;
    type!: string | undefined;
    description!: string | undefined;
    status!: string | undefined;
    usedStatus!: string | undefined;
    expiredDate!: moment.Moment | undefined;

    constructor(data?: IEGiftData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.name = data["name"];
            this.type = data["type"];
            this.description = data["description"];
            this.status = data["status"];
            this.usedStatus = data["usedStatus"];
            this.expiredDate = data["expiredDate"] ? moment(data["expiredDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): EGiftData {
        data = typeof data === 'object' ? data : {};
        let result = new EGiftData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["type"] = this.type;
        data["description"] = this.description;
        data["status"] = this.status;
        data["usedStatus"] = this.usedStatus;
        data["expiredDate"] = this.expiredDate ? this.expiredDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IEGiftData {
    code: string | undefined;
    name: string | undefined;
    type: string | undefined;
    description: string | undefined;
    status: string | undefined;
    usedStatus: string | undefined;
    expiredDate: moment.Moment | undefined;
}

export class RequestCreateRedeemTransaction implements IRequestCreateRedeemTransaction {
    memberCode!: string;
    giftCode!: string;
    quantity!: number;
    date!: string;
    description!: string | undefined;

    constructor(data?: IRequestCreateRedeemTransaction) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberCode = data["memberCode"];
            this.giftCode = data["giftCode"];
            this.quantity = data["quantity"];
            this.date = data["date"];
            this.description = data["description"];
        }
    }

    static fromJS(data: any): RequestCreateRedeemTransaction {
        data = typeof data === 'object' ? data : {};
        let result = new RequestCreateRedeemTransaction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberCode"] = this.memberCode;
        data["giftCode"] = this.giftCode;
        data["quantity"] = this.quantity;
        data["date"] = this.date;
        data["description"] = this.description;
        return data;
    }
}

export interface IRequestCreateRedeemTransaction {
    memberCode: string;
    giftCode: string;
    quantity: number;
    date: string;
    description: string | undefined;
}

export class ReponseDataRedeemTransaction implements IReponseDataRedeemTransaction {
    items!: DataRedeemTransaction[] | undefined;
    totalCount!: number | undefined;
    exception!: string | undefined;
    messages!: string | undefined;

    constructor(data?: IReponseDataRedeemTransaction) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(DataRedeemTransaction.fromJS(item));
            }
            this.totalCount = data["totalCount"];
            this.exception = data["exception"];
            this.messages = data["messages"];
        }
    }

    static fromJS(data: any): ReponseDataRedeemTransaction {
        data = typeof data === 'object' ? data : {};
        let result = new ReponseDataRedeemTransaction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["exception"] = this.exception;
        data["messages"] = this.messages;
        return data;
    }
}

export interface IReponseDataRedeemTransaction {
    items: DataRedeemTransaction[] | undefined;
    totalCount: number | undefined;
    exception: string | undefined;
    messages: string | undefined;
}

export class DataRedeemTransaction implements IDataRedeemTransaction {
    code!: string | undefined;
    totalCoin!: number | undefined;
    status!: string | undefined;
    date!: moment.Moment | undefined;
    description!: string | undefined;
    eGift!: EGiftData | undefined;

    constructor(data?: IDataRedeemTransaction) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.totalCoin = data["totalCoin"];
            this.status = data["status"];
            this.date = data["date"] ? moment(data["date"].toString()) : <any>undefined;
            this.description = data["description"];
            this.eGift = data["eGift"] ? EGiftData.fromJS(data["eGift"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DataRedeemTransaction {
        data = typeof data === 'object' ? data : {};
        let result = new DataRedeemTransaction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["totalCoin"] = this.totalCoin;
        data["status"] = this.status;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["description"] = this.description;
        data["eGift"] = this.eGift ? this.eGift.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDataRedeemTransaction {
    code: string | undefined;
    totalCoin: number | undefined;
    status: string | undefined;
    date: moment.Moment | undefined;
    description: string | undefined;
    eGift: EGiftData | undefined;
}

export class PagedResultDtoOfGetGiftTargetAudienceDetailForViewDto implements IPagedResultDtoOfGetGiftTargetAudienceDetailForViewDto {
    totalCount!: number | undefined;
    items!: GetGiftTargetAudienceDetailForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetGiftTargetAudienceDetailForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetGiftTargetAudienceDetailForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetGiftTargetAudienceDetailForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetGiftTargetAudienceDetailForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetGiftTargetAudienceDetailForViewDto {
    totalCount: number | undefined;
    items: GetGiftTargetAudienceDetailForViewDto[] | undefined;
}

export class GetGiftTargetAudienceDetailForViewDto implements IGetGiftTargetAudienceDetailForViewDto {
    giftTargetAudienceDetail!: GiftTargetAudienceDetailDto | undefined;

    constructor(data?: IGetGiftTargetAudienceDetailForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.giftTargetAudienceDetail = data["giftTargetAudienceDetail"] ? GiftTargetAudienceDetailDto.fromJS(data["giftTargetAudienceDetail"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetGiftTargetAudienceDetailForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGiftTargetAudienceDetailForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["giftTargetAudienceDetail"] = this.giftTargetAudienceDetail ? this.giftTargetAudienceDetail.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetGiftTargetAudienceDetailForViewDto {
    giftTargetAudienceDetail: GiftTargetAudienceDetailDto | undefined;
}

export class GiftTargetAudienceDetailDto implements IGiftTargetAudienceDetailDto {
    giftTargetAudienceID!: number | undefined;
    name!: string | undefined;
    phone!: string | undefined;
    zaloChatID!: string | undefined;
    email!: string | undefined;
    facebookID!: string | undefined;
    memberCode!: string | undefined;
    communicationLanguage!: string | undefined;
    communicationChannel!: string | undefined;
    outletCode!: string | undefined;
    id!: number | undefined;

    constructor(data?: IGiftTargetAudienceDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.giftTargetAudienceID = data["giftTargetAudienceID"];
            this.name = data["name"];
            this.phone = data["phone"];
            this.zaloChatID = data["zaloChatID"];
            this.email = data["email"];
            this.facebookID = data["facebookID"];
            this.memberCode = data["memberCode"];
            this.communicationLanguage = data["communicationLanguage"];
            this.communicationChannel = data["communicationChannel"];
            this.outletCode = data["outletCode"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): GiftTargetAudienceDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new GiftTargetAudienceDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["giftTargetAudienceID"] = this.giftTargetAudienceID;
        data["name"] = this.name;
        data["phone"] = this.phone;
        data["zaloChatID"] = this.zaloChatID;
        data["email"] = this.email;
        data["facebookID"] = this.facebookID;
        data["memberCode"] = this.memberCode;
        data["communicationLanguage"] = this.communicationLanguage;
        data["communicationChannel"] = this.communicationChannel;
        data["outletCode"] = this.outletCode;
        data["id"] = this.id;
        return data;
    }
}

export interface IGiftTargetAudienceDetailDto {
    giftTargetAudienceID: number | undefined;
    name: string | undefined;
    phone: string | undefined;
    zaloChatID: string | undefined;
    email: string | undefined;
    facebookID: string | undefined;
    memberCode: string | undefined;
    communicationLanguage: string | undefined;
    communicationChannel: string | undefined;
    outletCode: string | undefined;
    id: number | undefined;
}

export class GetGiftTargetAudienceDetailForEditOutput implements IGetGiftTargetAudienceDetailForEditOutput {
    giftTargetAudienceDetail!: CreateOrEditGiftTargetAudienceDetailDto | undefined;

    constructor(data?: IGetGiftTargetAudienceDetailForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.giftTargetAudienceDetail = data["giftTargetAudienceDetail"] ? CreateOrEditGiftTargetAudienceDetailDto.fromJS(data["giftTargetAudienceDetail"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetGiftTargetAudienceDetailForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetGiftTargetAudienceDetailForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["giftTargetAudienceDetail"] = this.giftTargetAudienceDetail ? this.giftTargetAudienceDetail.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetGiftTargetAudienceDetailForEditOutput {
    giftTargetAudienceDetail: CreateOrEditGiftTargetAudienceDetailDto | undefined;
}

export class CreateOrEditGiftTargetAudienceDetailDto implements ICreateOrEditGiftTargetAudienceDetailDto {
    giftTargetAudienceID!: number | undefined;
    name!: string | undefined;
    phone!: string | undefined;
    zaloChatID!: string | undefined;
    email!: string | undefined;
    facebookID!: string | undefined;
    memberCode!: string | undefined;
    communicationLanguage!: string | undefined;
    communicationChannel!: string | undefined;
    outletCode!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditGiftTargetAudienceDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.giftTargetAudienceID = data["giftTargetAudienceID"];
            this.name = data["name"];
            this.phone = data["phone"];
            this.zaloChatID = data["zaloChatID"];
            this.email = data["email"];
            this.facebookID = data["facebookID"];
            this.memberCode = data["memberCode"];
            this.communicationLanguage = data["communicationLanguage"];
            this.communicationChannel = data["communicationChannel"];
            this.outletCode = data["outletCode"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditGiftTargetAudienceDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditGiftTargetAudienceDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["giftTargetAudienceID"] = this.giftTargetAudienceID;
        data["name"] = this.name;
        data["phone"] = this.phone;
        data["zaloChatID"] = this.zaloChatID;
        data["email"] = this.email;
        data["facebookID"] = this.facebookID;
        data["memberCode"] = this.memberCode;
        data["communicationLanguage"] = this.communicationLanguage;
        data["communicationChannel"] = this.communicationChannel;
        data["outletCode"] = this.outletCode;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditGiftTargetAudienceDetailDto {
    giftTargetAudienceID: number | undefined;
    name: string | undefined;
    phone: string | undefined;
    zaloChatID: string | undefined;
    email: string | undefined;
    facebookID: string | undefined;
    memberCode: string | undefined;
    communicationLanguage: string | undefined;
    communicationChannel: string | undefined;
    outletCode: string | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfGetGiftTargetAudienceForViewDto implements IPagedResultDtoOfGetGiftTargetAudienceForViewDto {
    totalCount!: number | undefined;
    items!: GetGiftTargetAudienceForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetGiftTargetAudienceForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetGiftTargetAudienceForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetGiftTargetAudienceForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetGiftTargetAudienceForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetGiftTargetAudienceForViewDto {
    totalCount: number | undefined;
    items: GetGiftTargetAudienceForViewDto[] | undefined;
}

export class GetGiftTargetAudienceForViewDto implements IGetGiftTargetAudienceForViewDto {
    giftTargetAudience!: GiftTargetAudienceDto | undefined;

    constructor(data?: IGetGiftTargetAudienceForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.giftTargetAudience = data["giftTargetAudience"] ? GiftTargetAudienceDto.fromJS(data["giftTargetAudience"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetGiftTargetAudienceForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGiftTargetAudienceForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["giftTargetAudience"] = this.giftTargetAudience ? this.giftTargetAudience.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetGiftTargetAudienceForViewDto {
    giftTargetAudience: GiftTargetAudienceDto | undefined;
}

export class GiftTargetAudienceDto implements IGiftTargetAudienceDto {
    targetAudienceName!: string | undefined;
    description!: string | undefined;
    status!: string | undefined;
    id!: number | undefined;

    constructor(data?: IGiftTargetAudienceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.targetAudienceName = data["targetAudienceName"];
            this.description = data["description"];
            this.status = data["status"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): GiftTargetAudienceDto {
        data = typeof data === 'object' ? data : {};
        let result = new GiftTargetAudienceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["targetAudienceName"] = this.targetAudienceName;
        data["description"] = this.description;
        data["status"] = this.status;
        data["id"] = this.id;
        return data;
    }
}

export interface IGiftTargetAudienceDto {
    targetAudienceName: string | undefined;
    description: string | undefined;
    status: string | undefined;
    id: number | undefined;
}

export class GetGiftTargetAudienceForEditOutput implements IGetGiftTargetAudienceForEditOutput {
    giftTargetAudience!: CreateOrEditGiftTargetAudienceDto | undefined;

    constructor(data?: IGetGiftTargetAudienceForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.giftTargetAudience = data["giftTargetAudience"] ? CreateOrEditGiftTargetAudienceDto.fromJS(data["giftTargetAudience"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetGiftTargetAudienceForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetGiftTargetAudienceForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["giftTargetAudience"] = this.giftTargetAudience ? this.giftTargetAudience.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetGiftTargetAudienceForEditOutput {
    giftTargetAudience: CreateOrEditGiftTargetAudienceDto | undefined;
}

export class CreateOrEditGiftTargetAudienceDto implements ICreateOrEditGiftTargetAudienceDto {
    targetAudienceName!: string | undefined;
    description!: string | undefined;
    status!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditGiftTargetAudienceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.targetAudienceName = data["targetAudienceName"];
            this.description = data["description"];
            this.status = data["status"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditGiftTargetAudienceDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditGiftTargetAudienceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["targetAudienceName"] = this.targetAudienceName;
        data["description"] = this.description;
        data["status"] = this.status;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditGiftTargetAudienceDto {
    targetAudienceName: string | undefined;
    description: string | undefined;
    status: string | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfGetGiftTransactionForViewDto implements IPagedResultDtoOfGetGiftTransactionForViewDto {
    totalCount!: number | undefined;
    items!: GetGiftTransactionForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetGiftTransactionForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetGiftTransactionForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetGiftTransactionForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetGiftTransactionForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetGiftTransactionForViewDto {
    totalCount: number | undefined;
    items: GetGiftTransactionForViewDto[] | undefined;
}

export class GetGiftTransactionForViewDto implements IGetGiftTransactionForViewDto {
    giftTransaction!: GiftTransactionDto | undefined;

    constructor(data?: IGetGiftTransactionForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.giftTransaction = data["giftTransaction"] ? GiftTransactionDto.fromJS(data["giftTransaction"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetGiftTransactionForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGiftTransactionForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["giftTransaction"] = this.giftTransaction ? this.giftTransaction.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetGiftTransactionForViewDto {
    giftTransaction: GiftTransactionDto | undefined;
}

export class GiftTransactionDto implements IGiftTransactionDto {
    giftCampaignCode!: string | undefined;
    outletCode!: string | undefined;
    outletName!: string | undefined;
    zaloChatID!: string | undefined;
    publishDate!: moment.Moment | undefined;
    requestDate!: moment.Moment | undefined;
    giftMasterCode!: string | undefined;
    giftCode!: string | undefined;
    status!: string | undefined;
    transactionID!: string | undefined;
    id!: number | undefined;

    constructor(data?: IGiftTransactionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.giftCampaignCode = data["giftCampaignCode"];
            this.outletCode = data["outletCode"];
            this.outletName = data["outletName"];
            this.zaloChatID = data["zaloChatID"];
            this.publishDate = data["publishDate"] ? moment(data["publishDate"].toString()) : <any>undefined;
            this.requestDate = data["requestDate"] ? moment(data["requestDate"].toString()) : <any>undefined;
            this.giftMasterCode = data["giftMasterCode"];
            this.giftCode = data["giftCode"];
            this.status = data["status"];
            this.transactionID = data["transactionID"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): GiftTransactionDto {
        data = typeof data === 'object' ? data : {};
        let result = new GiftTransactionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["giftCampaignCode"] = this.giftCampaignCode;
        data["outletCode"] = this.outletCode;
        data["outletName"] = this.outletName;
        data["zaloChatID"] = this.zaloChatID;
        data["publishDate"] = this.publishDate ? this.publishDate.toISOString() : <any>undefined;
        data["requestDate"] = this.requestDate ? this.requestDate.toISOString() : <any>undefined;
        data["giftMasterCode"] = this.giftMasterCode;
        data["giftCode"] = this.giftCode;
        data["status"] = this.status;
        data["transactionID"] = this.transactionID;
        data["id"] = this.id;
        return data;
    }
}

export interface IGiftTransactionDto {
    giftCampaignCode: string | undefined;
    outletCode: string | undefined;
    outletName: string | undefined;
    zaloChatID: string | undefined;
    publishDate: moment.Moment | undefined;
    requestDate: moment.Moment | undefined;
    giftMasterCode: string | undefined;
    giftCode: string | undefined;
    status: string | undefined;
    transactionID: string | undefined;
    id: number | undefined;
}

export class GetGiftTransactionForEditOutput implements IGetGiftTransactionForEditOutput {
    giftTransaction!: CreateOrEditGiftTransactionDto | undefined;

    constructor(data?: IGetGiftTransactionForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.giftTransaction = data["giftTransaction"] ? CreateOrEditGiftTransactionDto.fromJS(data["giftTransaction"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetGiftTransactionForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetGiftTransactionForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["giftTransaction"] = this.giftTransaction ? this.giftTransaction.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetGiftTransactionForEditOutput {
    giftTransaction: CreateOrEditGiftTransactionDto | undefined;
}

export class CreateOrEditGiftTransactionDto implements ICreateOrEditGiftTransactionDto {
    giftCampaignCode!: string | undefined;
    outletCode!: string | undefined;
    outletName!: string | undefined;
    zaloChatID!: string | undefined;
    publishDate!: moment.Moment | undefined;
    requestDate!: moment.Moment | undefined;
    giftMasterCode!: string | undefined;
    giftCode!: string | undefined;
    status!: string | undefined;
    transactionID!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditGiftTransactionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.giftCampaignCode = data["giftCampaignCode"];
            this.outletCode = data["outletCode"];
            this.outletName = data["outletName"];
            this.zaloChatID = data["zaloChatID"];
            this.publishDate = data["publishDate"] ? moment(data["publishDate"].toString()) : <any>undefined;
            this.requestDate = data["requestDate"] ? moment(data["requestDate"].toString()) : <any>undefined;
            this.giftMasterCode = data["giftMasterCode"];
            this.giftCode = data["giftCode"];
            this.status = data["status"];
            this.transactionID = data["transactionID"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditGiftTransactionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditGiftTransactionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["giftCampaignCode"] = this.giftCampaignCode;
        data["outletCode"] = this.outletCode;
        data["outletName"] = this.outletName;
        data["zaloChatID"] = this.zaloChatID;
        data["publishDate"] = this.publishDate ? this.publishDate.toISOString() : <any>undefined;
        data["requestDate"] = this.requestDate ? this.requestDate.toISOString() : <any>undefined;
        data["giftMasterCode"] = this.giftMasterCode;
        data["giftCode"] = this.giftCode;
        data["status"] = this.status;
        data["transactionID"] = this.transactionID;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditGiftTransactionDto {
    giftCampaignCode: string | undefined;
    outletCode: string | undefined;
    outletName: string | undefined;
    zaloChatID: string | undefined;
    publishDate: moment.Moment | undefined;
    requestDate: moment.Moment | undefined;
    giftMasterCode: string | undefined;
    giftCode: string | undefined;
    status: string | undefined;
    transactionID: string | undefined;
    id: number | undefined;
}

export class GiftListDto implements IGiftListDto {
    giftCampaignCode!: string | undefined;
    targetAudienceID!: number | undefined;
    giftMasterCode!: string | undefined;
    giftMasterName!: string | undefined;
    giftCampaignName!: string | undefined;
    giftMasterValue!: number | undefined;
    expriteDate!: moment.Moment | undefined;
    publisherName!: string | undefined;
    imageLink!: string | undefined;
    voucherLink!: string | undefined;
    chatID!: string | undefined;
    outletCode!: string | undefined;
    transactionID!: string | undefined;
    status!: string | undefined;
    effectiveFrom!: moment.Moment | undefined;
    effectiveTo!: moment.Moment | undefined;

    constructor(data?: IGiftListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.giftCampaignCode = data["giftCampaignCode"];
            this.targetAudienceID = data["targetAudienceID"];
            this.giftMasterCode = data["giftMasterCode"];
            this.giftMasterName = data["giftMasterName"];
            this.giftCampaignName = data["giftCampaignName"];
            this.giftMasterValue = data["giftMasterValue"];
            this.expriteDate = data["expriteDate"] ? moment(data["expriteDate"].toString()) : <any>undefined;
            this.publisherName = data["publisherName"];
            this.imageLink = data["imageLink"];
            this.voucherLink = data["voucherLink"];
            this.chatID = data["chatID"];
            this.outletCode = data["outletCode"];
            this.transactionID = data["transactionID"];
            this.status = data["status"];
            this.effectiveFrom = data["effectiveFrom"] ? moment(data["effectiveFrom"].toString()) : <any>undefined;
            this.effectiveTo = data["effectiveTo"] ? moment(data["effectiveTo"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GiftListDto {
        data = typeof data === 'object' ? data : {};
        let result = new GiftListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["giftCampaignCode"] = this.giftCampaignCode;
        data["targetAudienceID"] = this.targetAudienceID;
        data["giftMasterCode"] = this.giftMasterCode;
        data["giftMasterName"] = this.giftMasterName;
        data["giftCampaignName"] = this.giftCampaignName;
        data["giftMasterValue"] = this.giftMasterValue;
        data["expriteDate"] = this.expriteDate ? this.expriteDate.toISOString() : <any>undefined;
        data["publisherName"] = this.publisherName;
        data["imageLink"] = this.imageLink;
        data["voucherLink"] = this.voucherLink;
        data["chatID"] = this.chatID;
        data["outletCode"] = this.outletCode;
        data["transactionID"] = this.transactionID;
        data["status"] = this.status;
        data["effectiveFrom"] = this.effectiveFrom ? this.effectiveFrom.toISOString() : <any>undefined;
        data["effectiveTo"] = this.effectiveTo ? this.effectiveTo.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGiftListDto {
    giftCampaignCode: string | undefined;
    targetAudienceID: number | undefined;
    giftMasterCode: string | undefined;
    giftMasterName: string | undefined;
    giftCampaignName: string | undefined;
    giftMasterValue: number | undefined;
    expriteDate: moment.Moment | undefined;
    publisherName: string | undefined;
    imageLink: string | undefined;
    voucherLink: string | undefined;
    chatID: string | undefined;
    outletCode: string | undefined;
    transactionID: string | undefined;
    status: string | undefined;
    effectiveFrom: moment.Moment | undefined;
    effectiveTo: moment.Moment | undefined;
}

export class GetResponseGotitIntegrationDtoCheck implements IGetResponseGotitIntegrationDtoCheck {
    refId!: string | undefined;
    invoiceNo!: string | undefined;
    voucher!: VoucherCheckTransaction | undefined;

    constructor(data?: IGetResponseGotitIntegrationDtoCheck) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.refId = data["refId"];
            this.invoiceNo = data["invoiceNo"];
            this.voucher = data["voucher"] ? VoucherCheckTransaction.fromJS(data["voucher"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetResponseGotitIntegrationDtoCheck {
        data = typeof data === 'object' ? data : {};
        let result = new GetResponseGotitIntegrationDtoCheck();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["refId"] = this.refId;
        data["invoiceNo"] = this.invoiceNo;
        data["voucher"] = this.voucher ? this.voucher.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetResponseGotitIntegrationDtoCheck {
    refId: string | undefined;
    invoiceNo: string | undefined;
    voucher: VoucherCheckTransaction | undefined;
}

export class VoucherCheckTransaction implements IVoucherCheckTransaction {
    voucherCode!: string | undefined;
    voucherLink!: string | undefined;
    voucherImageLink!: string | undefined;
    voucherRefId!: string | undefined;
    stateCode!: string | undefined;
    stateText!: string | undefined;

    constructor(data?: IVoucherCheckTransaction) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.voucherCode = data["voucherCode"];
            this.voucherLink = data["voucherLink"];
            this.voucherImageLink = data["voucherImageLink"];
            this.voucherRefId = data["voucherRefId"];
            this.stateCode = data["stateCode"];
            this.stateText = data["stateText"];
        }
    }

    static fromJS(data: any): VoucherCheckTransaction {
        data = typeof data === 'object' ? data : {};
        let result = new VoucherCheckTransaction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["voucherCode"] = this.voucherCode;
        data["voucherLink"] = this.voucherLink;
        data["voucherImageLink"] = this.voucherImageLink;
        data["voucherRefId"] = this.voucherRefId;
        data["stateCode"] = this.stateCode;
        data["stateText"] = this.stateText;
        return data;
    }
}

export interface IVoucherCheckTransaction {
    voucherCode: string | undefined;
    voucherLink: string | undefined;
    voucherImageLink: string | undefined;
    voucherRefId: string | undefined;
    stateCode: string | undefined;
    stateText: string | undefined;
}

export class HostDashboardData implements IHostDashboardData {
    newTenantsCount!: number | undefined;
    newSubscriptionAmount!: number | undefined;
    dashboardPlaceholder1!: number | undefined;
    dashboardPlaceholder2!: number | undefined;
    incomeStatistics!: IncomeStastistic[] | undefined;
    editionStatistics!: TenantEdition[] | undefined;
    expiringTenants!: ExpiringTenant[] | undefined;
    recentTenants!: RecentTenant[] | undefined;
    maxExpiringTenantsShownCount!: number | undefined;
    maxRecentTenantsShownCount!: number | undefined;
    subscriptionEndAlertDayCount!: number | undefined;
    recentTenantsDayCount!: number | undefined;
    subscriptionEndDateStart!: moment.Moment | undefined;
    subscriptionEndDateEnd!: moment.Moment | undefined;
    tenantCreationStartDate!: moment.Moment | undefined;

    constructor(data?: IHostDashboardData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.newTenantsCount = data["newTenantsCount"];
            this.newSubscriptionAmount = data["newSubscriptionAmount"];
            this.dashboardPlaceholder1 = data["dashboardPlaceholder1"];
            this.dashboardPlaceholder2 = data["dashboardPlaceholder2"];
            if (data["incomeStatistics"] && data["incomeStatistics"].constructor === Array) {
                this.incomeStatistics = [];
                for (let item of data["incomeStatistics"])
                    this.incomeStatistics.push(IncomeStastistic.fromJS(item));
            }
            if (data["editionStatistics"] && data["editionStatistics"].constructor === Array) {
                this.editionStatistics = [];
                for (let item of data["editionStatistics"])
                    this.editionStatistics.push(TenantEdition.fromJS(item));
            }
            if (data["expiringTenants"] && data["expiringTenants"].constructor === Array) {
                this.expiringTenants = [];
                for (let item of data["expiringTenants"])
                    this.expiringTenants.push(ExpiringTenant.fromJS(item));
            }
            if (data["recentTenants"] && data["recentTenants"].constructor === Array) {
                this.recentTenants = [];
                for (let item of data["recentTenants"])
                    this.recentTenants.push(RecentTenant.fromJS(item));
            }
            this.maxExpiringTenantsShownCount = data["maxExpiringTenantsShownCount"];
            this.maxRecentTenantsShownCount = data["maxRecentTenantsShownCount"];
            this.subscriptionEndAlertDayCount = data["subscriptionEndAlertDayCount"];
            this.recentTenantsDayCount = data["recentTenantsDayCount"];
            this.subscriptionEndDateStart = data["subscriptionEndDateStart"] ? moment(data["subscriptionEndDateStart"].toString()) : <any>undefined;
            this.subscriptionEndDateEnd = data["subscriptionEndDateEnd"] ? moment(data["subscriptionEndDateEnd"].toString()) : <any>undefined;
            this.tenantCreationStartDate = data["tenantCreationStartDate"] ? moment(data["tenantCreationStartDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): HostDashboardData {
        data = typeof data === 'object' ? data : {};
        let result = new HostDashboardData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newTenantsCount"] = this.newTenantsCount;
        data["newSubscriptionAmount"] = this.newSubscriptionAmount;
        data["dashboardPlaceholder1"] = this.dashboardPlaceholder1;
        data["dashboardPlaceholder2"] = this.dashboardPlaceholder2;
        if (this.incomeStatistics && this.incomeStatistics.constructor === Array) {
            data["incomeStatistics"] = [];
            for (let item of this.incomeStatistics)
                data["incomeStatistics"].push(item.toJSON());
        }
        if (this.editionStatistics && this.editionStatistics.constructor === Array) {
            data["editionStatistics"] = [];
            for (let item of this.editionStatistics)
                data["editionStatistics"].push(item.toJSON());
        }
        if (this.expiringTenants && this.expiringTenants.constructor === Array) {
            data["expiringTenants"] = [];
            for (let item of this.expiringTenants)
                data["expiringTenants"].push(item.toJSON());
        }
        if (this.recentTenants && this.recentTenants.constructor === Array) {
            data["recentTenants"] = [];
            for (let item of this.recentTenants)
                data["recentTenants"].push(item.toJSON());
        }
        data["maxExpiringTenantsShownCount"] = this.maxExpiringTenantsShownCount;
        data["maxRecentTenantsShownCount"] = this.maxRecentTenantsShownCount;
        data["subscriptionEndAlertDayCount"] = this.subscriptionEndAlertDayCount;
        data["recentTenantsDayCount"] = this.recentTenantsDayCount;
        data["subscriptionEndDateStart"] = this.subscriptionEndDateStart ? this.subscriptionEndDateStart.toISOString() : <any>undefined;
        data["subscriptionEndDateEnd"] = this.subscriptionEndDateEnd ? this.subscriptionEndDateEnd.toISOString() : <any>undefined;
        data["tenantCreationStartDate"] = this.tenantCreationStartDate ? this.tenantCreationStartDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IHostDashboardData {
    newTenantsCount: number | undefined;
    newSubscriptionAmount: number | undefined;
    dashboardPlaceholder1: number | undefined;
    dashboardPlaceholder2: number | undefined;
    incomeStatistics: IncomeStastistic[] | undefined;
    editionStatistics: TenantEdition[] | undefined;
    expiringTenants: ExpiringTenant[] | undefined;
    recentTenants: RecentTenant[] | undefined;
    maxExpiringTenantsShownCount: number | undefined;
    maxRecentTenantsShownCount: number | undefined;
    subscriptionEndAlertDayCount: number | undefined;
    recentTenantsDayCount: number | undefined;
    subscriptionEndDateStart: moment.Moment | undefined;
    subscriptionEndDateEnd: moment.Moment | undefined;
    tenantCreationStartDate: moment.Moment | undefined;
}

export class IncomeStastistic implements IIncomeStastistic {
    label!: string | undefined;
    date!: moment.Moment | undefined;
    amount!: number | undefined;

    constructor(data?: IIncomeStastistic) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.label = data["label"];
            this.date = data["date"] ? moment(data["date"].toString()) : <any>undefined;
            this.amount = data["amount"];
        }
    }

    static fromJS(data: any): IncomeStastistic {
        data = typeof data === 'object' ? data : {};
        let result = new IncomeStastistic();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["amount"] = this.amount;
        return data;
    }
}

export interface IIncomeStastistic {
    label: string | undefined;
    date: moment.Moment | undefined;
    amount: number | undefined;
}

export class TenantEdition implements ITenantEdition {
    label!: string | undefined;
    value!: number | undefined;

    constructor(data?: ITenantEdition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.label = data["label"];
            this.value = data["value"];
        }
    }

    static fromJS(data: any): TenantEdition {
        data = typeof data === 'object' ? data : {};
        let result = new TenantEdition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["value"] = this.value;
        return data;
    }
}

export interface ITenantEdition {
    label: string | undefined;
    value: number | undefined;
}

export class ExpiringTenant implements IExpiringTenant {
    tenantName!: string | undefined;
    remainingDayCount!: number | undefined;

    constructor(data?: IExpiringTenant) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantName = data["tenantName"];
            this.remainingDayCount = data["remainingDayCount"];
        }
    }

    static fromJS(data: any): ExpiringTenant {
        data = typeof data === 'object' ? data : {};
        let result = new ExpiringTenant();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantName"] = this.tenantName;
        data["remainingDayCount"] = this.remainingDayCount;
        return data;
    }
}

export interface IExpiringTenant {
    tenantName: string | undefined;
    remainingDayCount: number | undefined;
}

export class RecentTenant implements IRecentTenant {
    id!: number | undefined;
    name!: string | undefined;
    creationTime!: moment.Moment | undefined;

    constructor(data?: IRecentTenant) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): RecentTenant {
        data = typeof data === 'object' ? data : {};
        let result = new RecentTenant();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IRecentTenant {
    id: number | undefined;
    name: string | undefined;
    creationTime: moment.Moment | undefined;
}

export class GetIncomeStatisticsDataOutput implements IGetIncomeStatisticsDataOutput {
    incomeStatistics!: IncomeStastistic[] | undefined;

    constructor(data?: IGetIncomeStatisticsDataOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["incomeStatistics"] && data["incomeStatistics"].constructor === Array) {
                this.incomeStatistics = [];
                for (let item of data["incomeStatistics"])
                    this.incomeStatistics.push(IncomeStastistic.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetIncomeStatisticsDataOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetIncomeStatisticsDataOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.incomeStatistics && this.incomeStatistics.constructor === Array) {
            data["incomeStatistics"] = [];
            for (let item of this.incomeStatistics)
                data["incomeStatistics"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetIncomeStatisticsDataOutput {
    incomeStatistics: IncomeStastistic[] | undefined;
}

export class GetEditionTenantStatisticsOutput implements IGetEditionTenantStatisticsOutput {
    editionStatistics!: TenantEdition[] | undefined;

    constructor(data?: IGetEditionTenantStatisticsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["editionStatistics"] && data["editionStatistics"].constructor === Array) {
                this.editionStatistics = [];
                for (let item of data["editionStatistics"])
                    this.editionStatistics.push(TenantEdition.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetEditionTenantStatisticsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetEditionTenantStatisticsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.editionStatistics && this.editionStatistics.constructor === Array) {
            data["editionStatistics"] = [];
            for (let item of this.editionStatistics)
                data["editionStatistics"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetEditionTenantStatisticsOutput {
    editionStatistics: TenantEdition[] | undefined;
}

export class PagedResultDtoOfGetSettingForViewDto implements IPagedResultDtoOfGetSettingForViewDto {
    totalCount!: number | undefined;
    items!: GetSettingForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetSettingForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetSettingForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetSettingForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetSettingForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetSettingForViewDto {
    totalCount: number | undefined;
    items: GetSettingForViewDto[] | undefined;
}

export class GetSettingForViewDto implements IGetSettingForViewDto {
    setting!: SettingDto | undefined;

    constructor(data?: IGetSettingForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.setting = data["setting"] ? SettingDto.fromJS(data["setting"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSettingForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetSettingForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["setting"] = this.setting ? this.setting.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetSettingForViewDto {
    setting: SettingDto | undefined;
}

export class SettingDto implements ISettingDto {
    id!: number | undefined;
    tenantId!: number | undefined;
    userId!: number | undefined;
    name!: string | undefined;
    value!: string | undefined;

    constructor(data?: ISettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.tenantId = data["tenantId"];
            this.userId = data["userId"];
            this.name = data["name"];
            this.value = data["value"];
        }
    }

    static fromJS(data: any): SettingDto {
        data = typeof data === 'object' ? data : {};
        let result = new SettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }
}

export interface ISettingDto {
    id: number | undefined;
    tenantId: number | undefined;
    userId: number | undefined;
    name: string | undefined;
    value: string | undefined;
}

export class HostSettingsEditDto implements IHostSettingsEditDto {
    general!: GeneralSettingsEditDto;
    userManagement!: HostUserManagementSettingsEditDto;
    email!: EmailSettingsEditDto;
    tenantManagement!: TenantManagementSettingsEditDto;
    security!: SecuritySettingsEditDto;
    billing!: HostBillingSettingsEditDto | undefined;

    constructor(data?: IHostSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.general = new GeneralSettingsEditDto();
            this.userManagement = new HostUserManagementSettingsEditDto();
            this.email = new EmailSettingsEditDto();
            this.tenantManagement = new TenantManagementSettingsEditDto();
            this.security = new SecuritySettingsEditDto();
        }
    }

    init(data?: any) {
        if (data) {
            this.general = data["general"] ? GeneralSettingsEditDto.fromJS(data["general"]) : new GeneralSettingsEditDto();
            this.userManagement = data["userManagement"] ? HostUserManagementSettingsEditDto.fromJS(data["userManagement"]) : new HostUserManagementSettingsEditDto();
            this.email = data["email"] ? EmailSettingsEditDto.fromJS(data["email"]) : new EmailSettingsEditDto();
            this.tenantManagement = data["tenantManagement"] ? TenantManagementSettingsEditDto.fromJS(data["tenantManagement"]) : new TenantManagementSettingsEditDto();
            this.security = data["security"] ? SecuritySettingsEditDto.fromJS(data["security"]) : new SecuritySettingsEditDto();
            this.billing = data["billing"] ? HostBillingSettingsEditDto.fromJS(data["billing"]) : <any>undefined;
        }
    }

    static fromJS(data: any): HostSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new HostSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["general"] = this.general ? this.general.toJSON() : <any>undefined;
        data["userManagement"] = this.userManagement ? this.userManagement.toJSON() : <any>undefined;
        data["email"] = this.email ? this.email.toJSON() : <any>undefined;
        data["tenantManagement"] = this.tenantManagement ? this.tenantManagement.toJSON() : <any>undefined;
        data["security"] = this.security ? this.security.toJSON() : <any>undefined;
        data["billing"] = this.billing ? this.billing.toJSON() : <any>undefined;
        return data;
    }
}

export interface IHostSettingsEditDto {
    general: GeneralSettingsEditDto;
    userManagement: HostUserManagementSettingsEditDto;
    email: EmailSettingsEditDto;
    tenantManagement: TenantManagementSettingsEditDto;
    security: SecuritySettingsEditDto;
    billing: HostBillingSettingsEditDto | undefined;
}

export class GeneralSettingsEditDto implements IGeneralSettingsEditDto {
    timezone!: string | undefined;
    timezoneForComparison!: string | undefined;

    constructor(data?: IGeneralSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.timezone = data["timezone"];
            this.timezoneForComparison = data["timezoneForComparison"];
        }
    }

    static fromJS(data: any): GeneralSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new GeneralSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timezone"] = this.timezone;
        data["timezoneForComparison"] = this.timezoneForComparison;
        return data;
    }
}

export interface IGeneralSettingsEditDto {
    timezone: string | undefined;
    timezoneForComparison: string | undefined;
}

export class HostUserManagementSettingsEditDto implements IHostUserManagementSettingsEditDto {
    isEmailConfirmationRequiredForLogin!: boolean | undefined;
    smsVerificationEnabled!: boolean | undefined;

    constructor(data?: IHostUserManagementSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isEmailConfirmationRequiredForLogin = data["isEmailConfirmationRequiredForLogin"];
            this.smsVerificationEnabled = data["smsVerificationEnabled"];
        }
    }

    static fromJS(data: any): HostUserManagementSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new HostUserManagementSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isEmailConfirmationRequiredForLogin"] = this.isEmailConfirmationRequiredForLogin;
        data["smsVerificationEnabled"] = this.smsVerificationEnabled;
        return data;
    }
}

export interface IHostUserManagementSettingsEditDto {
    isEmailConfirmationRequiredForLogin: boolean | undefined;
    smsVerificationEnabled: boolean | undefined;
}

export class EmailSettingsEditDto implements IEmailSettingsEditDto {
    defaultFromAddress!: string | undefined;
    defaultFromDisplayName!: string | undefined;
    smtpHost!: string | undefined;
    smtpPort!: number | undefined;
    smtpUserName!: string | undefined;
    smtpPassword!: string | undefined;
    smtpDomain!: string | undefined;
    smtpEnableSsl!: boolean | undefined;
    smtpUseDefaultCredentials!: boolean | undefined;

    constructor(data?: IEmailSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.defaultFromAddress = data["defaultFromAddress"];
            this.defaultFromDisplayName = data["defaultFromDisplayName"];
            this.smtpHost = data["smtpHost"];
            this.smtpPort = data["smtpPort"];
            this.smtpUserName = data["smtpUserName"];
            this.smtpPassword = data["smtpPassword"];
            this.smtpDomain = data["smtpDomain"];
            this.smtpEnableSsl = data["smtpEnableSsl"];
            this.smtpUseDefaultCredentials = data["smtpUseDefaultCredentials"];
        }
    }

    static fromJS(data: any): EmailSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmailSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["defaultFromAddress"] = this.defaultFromAddress;
        data["defaultFromDisplayName"] = this.defaultFromDisplayName;
        data["smtpHost"] = this.smtpHost;
        data["smtpPort"] = this.smtpPort;
        data["smtpUserName"] = this.smtpUserName;
        data["smtpPassword"] = this.smtpPassword;
        data["smtpDomain"] = this.smtpDomain;
        data["smtpEnableSsl"] = this.smtpEnableSsl;
        data["smtpUseDefaultCredentials"] = this.smtpUseDefaultCredentials;
        return data;
    }
}

export interface IEmailSettingsEditDto {
    defaultFromAddress: string | undefined;
    defaultFromDisplayName: string | undefined;
    smtpHost: string | undefined;
    smtpPort: number | undefined;
    smtpUserName: string | undefined;
    smtpPassword: string | undefined;
    smtpDomain: string | undefined;
    smtpEnableSsl: boolean | undefined;
    smtpUseDefaultCredentials: boolean | undefined;
}

export class TenantManagementSettingsEditDto implements ITenantManagementSettingsEditDto {
    allowSelfRegistration!: boolean | undefined;
    isNewRegisteredTenantActiveByDefault!: boolean | undefined;
    useCaptchaOnRegistration!: boolean | undefined;
    defaultEditionId!: number | undefined;

    constructor(data?: ITenantManagementSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.allowSelfRegistration = data["allowSelfRegistration"];
            this.isNewRegisteredTenantActiveByDefault = data["isNewRegisteredTenantActiveByDefault"];
            this.useCaptchaOnRegistration = data["useCaptchaOnRegistration"];
            this.defaultEditionId = data["defaultEditionId"];
        }
    }

    static fromJS(data: any): TenantManagementSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantManagementSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allowSelfRegistration"] = this.allowSelfRegistration;
        data["isNewRegisteredTenantActiveByDefault"] = this.isNewRegisteredTenantActiveByDefault;
        data["useCaptchaOnRegistration"] = this.useCaptchaOnRegistration;
        data["defaultEditionId"] = this.defaultEditionId;
        return data;
    }
}

export interface ITenantManagementSettingsEditDto {
    allowSelfRegistration: boolean | undefined;
    isNewRegisteredTenantActiveByDefault: boolean | undefined;
    useCaptchaOnRegistration: boolean | undefined;
    defaultEditionId: number | undefined;
}

export class SecuritySettingsEditDto implements ISecuritySettingsEditDto {
    useDefaultPasswordComplexitySettings!: boolean | undefined;
    passwordComplexity!: PasswordComplexitySetting | undefined;
    defaultPasswordComplexity!: PasswordComplexitySetting | undefined;
    userLockOut!: UserLockOutSettingsEditDto | undefined;
    twoFactorLogin!: TwoFactorLoginSettingsEditDto | undefined;

    constructor(data?: ISecuritySettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.useDefaultPasswordComplexitySettings = data["useDefaultPasswordComplexitySettings"];
            this.passwordComplexity = data["passwordComplexity"] ? PasswordComplexitySetting.fromJS(data["passwordComplexity"]) : <any>undefined;
            this.defaultPasswordComplexity = data["defaultPasswordComplexity"] ? PasswordComplexitySetting.fromJS(data["defaultPasswordComplexity"]) : <any>undefined;
            this.userLockOut = data["userLockOut"] ? UserLockOutSettingsEditDto.fromJS(data["userLockOut"]) : <any>undefined;
            this.twoFactorLogin = data["twoFactorLogin"] ? TwoFactorLoginSettingsEditDto.fromJS(data["twoFactorLogin"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SecuritySettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new SecuritySettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["useDefaultPasswordComplexitySettings"] = this.useDefaultPasswordComplexitySettings;
        data["passwordComplexity"] = this.passwordComplexity ? this.passwordComplexity.toJSON() : <any>undefined;
        data["defaultPasswordComplexity"] = this.defaultPasswordComplexity ? this.defaultPasswordComplexity.toJSON() : <any>undefined;
        data["userLockOut"] = this.userLockOut ? this.userLockOut.toJSON() : <any>undefined;
        data["twoFactorLogin"] = this.twoFactorLogin ? this.twoFactorLogin.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISecuritySettingsEditDto {
    useDefaultPasswordComplexitySettings: boolean | undefined;
    passwordComplexity: PasswordComplexitySetting | undefined;
    defaultPasswordComplexity: PasswordComplexitySetting | undefined;
    userLockOut: UserLockOutSettingsEditDto | undefined;
    twoFactorLogin: TwoFactorLoginSettingsEditDto | undefined;
}

export class HostBillingSettingsEditDto implements IHostBillingSettingsEditDto {
    legalName!: string | undefined;
    address!: string | undefined;

    constructor(data?: IHostBillingSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.legalName = data["legalName"];
            this.address = data["address"];
        }
    }

    static fromJS(data: any): HostBillingSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new HostBillingSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["legalName"] = this.legalName;
        data["address"] = this.address;
        return data;
    }
}

export interface IHostBillingSettingsEditDto {
    legalName: string | undefined;
    address: string | undefined;
}

export class PasswordComplexitySetting implements IPasswordComplexitySetting {
    requireDigit!: boolean | undefined;
    requireLowercase!: boolean | undefined;
    requireNonAlphanumeric!: boolean | undefined;
    requireUppercase!: boolean | undefined;
    requiredLength!: number | undefined;

    constructor(data?: IPasswordComplexitySetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.requireDigit = data["requireDigit"];
            this.requireLowercase = data["requireLowercase"];
            this.requireNonAlphanumeric = data["requireNonAlphanumeric"];
            this.requireUppercase = data["requireUppercase"];
            this.requiredLength = data["requiredLength"];
        }
    }

    static fromJS(data: any): PasswordComplexitySetting {
        data = typeof data === 'object' ? data : {};
        let result = new PasswordComplexitySetting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requireDigit"] = this.requireDigit;
        data["requireLowercase"] = this.requireLowercase;
        data["requireNonAlphanumeric"] = this.requireNonAlphanumeric;
        data["requireUppercase"] = this.requireUppercase;
        data["requiredLength"] = this.requiredLength;
        return data;
    }
}

export interface IPasswordComplexitySetting {
    requireDigit: boolean | undefined;
    requireLowercase: boolean | undefined;
    requireNonAlphanumeric: boolean | undefined;
    requireUppercase: boolean | undefined;
    requiredLength: number | undefined;
}

export class UserLockOutSettingsEditDto implements IUserLockOutSettingsEditDto {
    isEnabled!: boolean | undefined;
    maxFailedAccessAttemptsBeforeLockout!: number | undefined;
    defaultAccountLockoutSeconds!: number | undefined;

    constructor(data?: IUserLockOutSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isEnabled = data["isEnabled"];
            this.maxFailedAccessAttemptsBeforeLockout = data["maxFailedAccessAttemptsBeforeLockout"];
            this.defaultAccountLockoutSeconds = data["defaultAccountLockoutSeconds"];
        }
    }

    static fromJS(data: any): UserLockOutSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserLockOutSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isEnabled"] = this.isEnabled;
        data["maxFailedAccessAttemptsBeforeLockout"] = this.maxFailedAccessAttemptsBeforeLockout;
        data["defaultAccountLockoutSeconds"] = this.defaultAccountLockoutSeconds;
        return data;
    }
}

export interface IUserLockOutSettingsEditDto {
    isEnabled: boolean | undefined;
    maxFailedAccessAttemptsBeforeLockout: number | undefined;
    defaultAccountLockoutSeconds: number | undefined;
}

export class TwoFactorLoginSettingsEditDto implements ITwoFactorLoginSettingsEditDto {
    isEnabledForApplication!: boolean | undefined;
    isEnabled!: boolean | undefined;
    isEmailProviderEnabled!: boolean | undefined;
    isSmsProviderEnabled!: boolean | undefined;
    isRememberBrowserEnabled!: boolean | undefined;
    isGoogleAuthenticatorEnabled!: boolean | undefined;

    constructor(data?: ITwoFactorLoginSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isEnabledForApplication = data["isEnabledForApplication"];
            this.isEnabled = data["isEnabled"];
            this.isEmailProviderEnabled = data["isEmailProviderEnabled"];
            this.isSmsProviderEnabled = data["isSmsProviderEnabled"];
            this.isRememberBrowserEnabled = data["isRememberBrowserEnabled"];
            this.isGoogleAuthenticatorEnabled = data["isGoogleAuthenticatorEnabled"];
        }
    }

    static fromJS(data: any): TwoFactorLoginSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TwoFactorLoginSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isEnabledForApplication"] = this.isEnabledForApplication;
        data["isEnabled"] = this.isEnabled;
        data["isEmailProviderEnabled"] = this.isEmailProviderEnabled;
        data["isSmsProviderEnabled"] = this.isSmsProviderEnabled;
        data["isRememberBrowserEnabled"] = this.isRememberBrowserEnabled;
        data["isGoogleAuthenticatorEnabled"] = this.isGoogleAuthenticatorEnabled;
        return data;
    }
}

export interface ITwoFactorLoginSettingsEditDto {
    isEnabledForApplication: boolean | undefined;
    isEnabled: boolean | undefined;
    isEmailProviderEnabled: boolean | undefined;
    isSmsProviderEnabled: boolean | undefined;
    isRememberBrowserEnabled: boolean | undefined;
    isGoogleAuthenticatorEnabled: boolean | undefined;
}

export class SendTestEmailInput implements ISendTestEmailInput {
    emailAddress!: string;

    constructor(data?: ISendTestEmailInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.emailAddress = data["emailAddress"];
        }
    }

    static fromJS(data: any): SendTestEmailInput {
        data = typeof data === 'object' ? data : {};
        let result = new SendTestEmailInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        return data;
    }
}

export interface ISendTestEmailInput {
    emailAddress: string;
}

export class UploadImageOutputDto implements IUploadImageOutputDto {
    fileName!: string | undefined;
    link!: string | undefined;
    folder!: string | undefined;
    id!: number | undefined;

    constructor(data?: IUploadImageOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.fileName = data["fileName"];
            this.link = data["link"];
            this.folder = data["folder"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): UploadImageOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new UploadImageOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["link"] = this.link;
        data["folder"] = this.folder;
        data["id"] = this.id;
        return data;
    }
}

export interface IUploadImageOutputDto {
    fileName: string | undefined;
    link: string | undefined;
    folder: string | undefined;
    id: number | undefined;
}

export class EditorImageResponse implements IEditorImageResponse {
    url!: string | undefined;

    constructor(data?: IEditorImageResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.url = data["url"];
        }
    }

    static fromJS(data: any): EditorImageResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EditorImageResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        return data;
    }
}

export interface IEditorImageResponse {
    url: string | undefined;
}

export class GetImageForEditOutput implements IGetImageForEditOutput {
    imageLink!: CreateOrEditImageDto | undefined;

    constructor(data?: IGetImageForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.imageLink = data["imageLink"] ? CreateOrEditImageDto.fromJS(data["imageLink"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetImageForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetImageForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["imageLink"] = this.imageLink ? this.imageLink.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetImageForEditOutput {
    imageLink: CreateOrEditImageDto | undefined;
}

export class CreateOrEditImageDto implements ICreateOrEditImageDto {
    description!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditImageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditImageDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditImageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditImageDto {
    description: string | undefined;
    id: number | undefined;
}

export class EditImageInput implements IEditImageInput {
    imageLink!: CreateOrEditImageDto | undefined;

    constructor(data?: IEditImageInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.imageLink = data["imageLink"] ? CreateOrEditImageDto.fromJS(data["imageLink"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EditImageInput {
        data = typeof data === 'object' ? data : {};
        let result = new EditImageInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["imageLink"] = this.imageLink ? this.imageLink.toJSON() : <any>undefined;
        return data;
    }
}

export interface IEditImageInput {
    imageLink: CreateOrEditImageDto | undefined;
}

export class PagedResultDtoOfGetImageLinkForView implements IPagedResultDtoOfGetImageLinkForView {
    totalCount!: number | undefined;
    items!: GetImageLinkForView[] | undefined;

    constructor(data?: IPagedResultDtoOfGetImageLinkForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetImageLinkForView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetImageLinkForView {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetImageLinkForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetImageLinkForView {
    totalCount: number | undefined;
    items: GetImageLinkForView[] | undefined;
}

export class GetImageLinkForView implements IGetImageLinkForView {
    imageLink!: ImageLinkDto | undefined;

    constructor(data?: IGetImageLinkForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.imageLink = data["imageLink"] ? ImageLinkDto.fromJS(data["imageLink"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetImageLinkForView {
        data = typeof data === 'object' ? data : {};
        let result = new GetImageLinkForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["imageLink"] = this.imageLink ? this.imageLink.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetImageLinkForView {
    imageLink: ImageLinkDto | undefined;
}

export class GetImageLinkForEditOutput implements IGetImageLinkForEditOutput {
    imageLink!: CreateOrEditImageLinkDto | undefined;

    constructor(data?: IGetImageLinkForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.imageLink = data["imageLink"] ? CreateOrEditImageLinkDto.fromJS(data["imageLink"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetImageLinkForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetImageLinkForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["imageLink"] = this.imageLink ? this.imageLink.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetImageLinkForEditOutput {
    imageLink: CreateOrEditImageLinkDto | undefined;
}

export class ImportOutputDto implements IImportOutputDto {
    fileName!: string;
    filePath!: string;
    code!: number | undefined;
    message!: string | undefined;
    details!: string | undefined;
    validationErrors!: ValidationErrorInfo[] | undefined;

    constructor(data?: IImportOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.fileName = data["fileName"];
            this.filePath = data["filePath"];
            this.code = data["code"];
            this.message = data["message"];
            this.details = data["details"];
            if (data["validationErrors"] && data["validationErrors"].constructor === Array) {
                this.validationErrors = [];
                for (let item of data["validationErrors"])
                    this.validationErrors.push(ValidationErrorInfo.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ImportOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new ImportOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["filePath"] = this.filePath;
        data["code"] = this.code;
        data["message"] = this.message;
        data["details"] = this.details;
        if (this.validationErrors && this.validationErrors.constructor === Array) {
            data["validationErrors"] = [];
            for (let item of this.validationErrors)
                data["validationErrors"].push(item.toJSON());
        }
        return data;
    }
}

export interface IImportOutputDto {
    fileName: string;
    filePath: string;
    code: number | undefined;
    message: string | undefined;
    details: string | undefined;
    validationErrors: ValidationErrorInfo[] | undefined;
}

export class ValidationErrorInfo implements IValidationErrorInfo {
    message!: string | undefined;
    members!: string[] | undefined;

    constructor(data?: IValidationErrorInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.message = data["message"];
            if (data["members"] && data["members"].constructor === Array) {
                this.members = [];
                for (let item of data["members"])
                    this.members.push(item);
            }
        }
    }

    static fromJS(data: any): ValidationErrorInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationErrorInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        if (this.members && this.members.constructor === Array) {
            data["members"] = [];
            for (let item of this.members)
                data["members"].push(item);
        }
        return data;
    }
}

export interface IValidationErrorInfo {
    message: string | undefined;
    members: string[] | undefined;
}

export class ExtraParam implements IExtraParam {
    key!: string | undefined;
    value!: string | undefined;

    constructor(data?: IExtraParam) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.key = data["key"];
            this.value = data["value"];
        }
    }

    static fromJS(data: any): ExtraParam {
        data = typeof data === 'object' ? data : {};
        let result = new ExtraParam();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value;
        return data;
    }
}

export interface IExtraParam {
    key: string | undefined;
    value: string | undefined;
}

export class InstallDto implements IInstallDto {
    connectionString!: string;
    adminPassword!: string;
    webSiteUrl!: string;
    serverUrl!: string | undefined;
    defaultLanguage!: string;
    smtpSettings!: EmailSettingsEditDto | undefined;
    billInfo!: HostBillingSettingsEditDto | undefined;

    constructor(data?: IInstallDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.connectionString = data["connectionString"];
            this.adminPassword = data["adminPassword"];
            this.webSiteUrl = data["webSiteUrl"];
            this.serverUrl = data["serverUrl"];
            this.defaultLanguage = data["defaultLanguage"];
            this.smtpSettings = data["smtpSettings"] ? EmailSettingsEditDto.fromJS(data["smtpSettings"]) : <any>undefined;
            this.billInfo = data["billInfo"] ? HostBillingSettingsEditDto.fromJS(data["billInfo"]) : <any>undefined;
        }
    }

    static fromJS(data: any): InstallDto {
        data = typeof data === 'object' ? data : {};
        let result = new InstallDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["connectionString"] = this.connectionString;
        data["adminPassword"] = this.adminPassword;
        data["webSiteUrl"] = this.webSiteUrl;
        data["serverUrl"] = this.serverUrl;
        data["defaultLanguage"] = this.defaultLanguage;
        data["smtpSettings"] = this.smtpSettings ? this.smtpSettings.toJSON() : <any>undefined;
        data["billInfo"] = this.billInfo ? this.billInfo.toJSON() : <any>undefined;
        return data;
    }
}

export interface IInstallDto {
    connectionString: string;
    adminPassword: string;
    webSiteUrl: string;
    serverUrl: string | undefined;
    defaultLanguage: string;
    smtpSettings: EmailSettingsEditDto | undefined;
    billInfo: HostBillingSettingsEditDto | undefined;
}

export class AppSettingsJsonDto implements IAppSettingsJsonDto {
    webSiteUrl!: string | undefined;
    serverSiteUrl!: string | undefined;
    languages!: NameValue[] | undefined;

    constructor(data?: IAppSettingsJsonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.webSiteUrl = data["webSiteUrl"];
            this.serverSiteUrl = data["serverSiteUrl"];
            if (data["languages"] && data["languages"].constructor === Array) {
                this.languages = [];
                for (let item of data["languages"])
                    this.languages.push(NameValue.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AppSettingsJsonDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppSettingsJsonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["webSiteUrl"] = this.webSiteUrl;
        data["serverSiteUrl"] = this.serverSiteUrl;
        if (this.languages && this.languages.constructor === Array) {
            data["languages"] = [];
            for (let item of this.languages)
                data["languages"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAppSettingsJsonDto {
    webSiteUrl: string | undefined;
    serverSiteUrl: string | undefined;
    languages: NameValue[] | undefined;
}

export class NameValue implements INameValue {
    name!: string | undefined;
    value!: string | undefined;

    constructor(data?: INameValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.value = data["value"];
        }
    }

    static fromJS(data: any): NameValue {
        data = typeof data === 'object' ? data : {};
        let result = new NameValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }
}

export interface INameValue {
    name: string | undefined;
    value: string | undefined;
}

export class CheckDatabaseOutput implements ICheckDatabaseOutput {
    isDatabaseExist!: boolean | undefined;

    constructor(data?: ICheckDatabaseOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isDatabaseExist = data["isDatabaseExist"];
        }
    }

    static fromJS(data: any): CheckDatabaseOutput {
        data = typeof data === 'object' ? data : {};
        let result = new CheckDatabaseOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isDatabaseExist"] = this.isDatabaseExist;
        return data;
    }
}

export interface ICheckDatabaseOutput {
    isDatabaseExist: boolean | undefined;
}

export class PagedResultDtoOfGetInteractiveTimeRangeForViewDto implements IPagedResultDtoOfGetInteractiveTimeRangeForViewDto {
    totalCount!: number | undefined;
    items!: GetInteractiveTimeRangeForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetInteractiveTimeRangeForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetInteractiveTimeRangeForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetInteractiveTimeRangeForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetInteractiveTimeRangeForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetInteractiveTimeRangeForViewDto {
    totalCount: number | undefined;
    items: GetInteractiveTimeRangeForViewDto[] | undefined;
}

export class GetInteractiveTimeRangeForViewDto implements IGetInteractiveTimeRangeForViewDto {
    interactiveTimeRange!: InteractiveTimeRangeDto | undefined;

    constructor(data?: IGetInteractiveTimeRangeForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.interactiveTimeRange = data["interactiveTimeRange"] ? InteractiveTimeRangeDto.fromJS(data["interactiveTimeRange"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetInteractiveTimeRangeForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetInteractiveTimeRangeForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["interactiveTimeRange"] = this.interactiveTimeRange ? this.interactiveTimeRange.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetInteractiveTimeRangeForViewDto {
    interactiveTimeRange: InteractiveTimeRangeDto | undefined;
}

export class InteractiveTimeRangeDto implements IInteractiveTimeRangeDto {
    year!: number | undefined;
    timeRange!: string | undefined;
    totalCountInteraction!: number | undefined;
    month!: number | undefined;
    calculateDate!: moment.Moment | undefined;
    id!: number | undefined;

    constructor(data?: IInteractiveTimeRangeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.year = data["year"];
            this.timeRange = data["timeRange"];
            this.totalCountInteraction = data["totalCountInteraction"];
            this.month = data["month"];
            this.calculateDate = data["calculateDate"] ? moment(data["calculateDate"].toString()) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): InteractiveTimeRangeDto {
        data = typeof data === 'object' ? data : {};
        let result = new InteractiveTimeRangeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        data["timeRange"] = this.timeRange;
        data["totalCountInteraction"] = this.totalCountInteraction;
        data["month"] = this.month;
        data["calculateDate"] = this.calculateDate ? this.calculateDate.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IInteractiveTimeRangeDto {
    year: number | undefined;
    timeRange: string | undefined;
    totalCountInteraction: number | undefined;
    month: number | undefined;
    calculateDate: moment.Moment | undefined;
    id: number | undefined;
}

export class GetInteractiveTimeRangeForEditOutput implements IGetInteractiveTimeRangeForEditOutput {
    interactiveTimeRange!: CreateOrEditInteractiveTimeRangeDto | undefined;

    constructor(data?: IGetInteractiveTimeRangeForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.interactiveTimeRange = data["interactiveTimeRange"] ? CreateOrEditInteractiveTimeRangeDto.fromJS(data["interactiveTimeRange"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetInteractiveTimeRangeForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetInteractiveTimeRangeForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["interactiveTimeRange"] = this.interactiveTimeRange ? this.interactiveTimeRange.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetInteractiveTimeRangeForEditOutput {
    interactiveTimeRange: CreateOrEditInteractiveTimeRangeDto | undefined;
}

export class CreateOrEditInteractiveTimeRangeDto implements ICreateOrEditInteractiveTimeRangeDto {
    year!: number | undefined;
    timeRange!: string | undefined;
    totalCountInteraction!: number | undefined;
    month!: number | undefined;
    calculateDate!: moment.Moment | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditInteractiveTimeRangeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.year = data["year"];
            this.timeRange = data["timeRange"];
            this.totalCountInteraction = data["totalCountInteraction"];
            this.month = data["month"];
            this.calculateDate = data["calculateDate"] ? moment(data["calculateDate"].toString()) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditInteractiveTimeRangeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditInteractiveTimeRangeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        data["timeRange"] = this.timeRange;
        data["totalCountInteraction"] = this.totalCountInteraction;
        data["month"] = this.month;
        data["calculateDate"] = this.calculateDate ? this.calculateDate.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditInteractiveTimeRangeDto {
    year: number | undefined;
    timeRange: string | undefined;
    totalCountInteraction: number | undefined;
    month: number | undefined;
    calculateDate: moment.Moment | undefined;
    id: number | undefined;
}

export class InvoiceDto implements IInvoiceDto {
    amount!: number | undefined;
    editionDisplayName!: string | undefined;
    invoiceNo!: string | undefined;
    invoiceDate!: moment.Moment | undefined;
    tenantLegalName!: string | undefined;
    tenantAddress!: string[] | undefined;
    tenantTaxNo!: string | undefined;
    hostLegalName!: string | undefined;
    hostAddress!: string[] | undefined;

    constructor(data?: IInvoiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.amount = data["amount"];
            this.editionDisplayName = data["editionDisplayName"];
            this.invoiceNo = data["invoiceNo"];
            this.invoiceDate = data["invoiceDate"] ? moment(data["invoiceDate"].toString()) : <any>undefined;
            this.tenantLegalName = data["tenantLegalName"];
            if (data["tenantAddress"] && data["tenantAddress"].constructor === Array) {
                this.tenantAddress = [];
                for (let item of data["tenantAddress"])
                    this.tenantAddress.push(item);
            }
            this.tenantTaxNo = data["tenantTaxNo"];
            this.hostLegalName = data["hostLegalName"];
            if (data["hostAddress"] && data["hostAddress"].constructor === Array) {
                this.hostAddress = [];
                for (let item of data["hostAddress"])
                    this.hostAddress.push(item);
            }
        }
    }

    static fromJS(data: any): InvoiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["editionDisplayName"] = this.editionDisplayName;
        data["invoiceNo"] = this.invoiceNo;
        data["invoiceDate"] = this.invoiceDate ? this.invoiceDate.toISOString() : <any>undefined;
        data["tenantLegalName"] = this.tenantLegalName;
        if (this.tenantAddress && this.tenantAddress.constructor === Array) {
            data["tenantAddress"] = [];
            for (let item of this.tenantAddress)
                data["tenantAddress"].push(item);
        }
        data["tenantTaxNo"] = this.tenantTaxNo;
        data["hostLegalName"] = this.hostLegalName;
        if (this.hostAddress && this.hostAddress.constructor === Array) {
            data["hostAddress"] = [];
            for (let item of this.hostAddress)
                data["hostAddress"].push(item);
        }
        return data;
    }
}

export interface IInvoiceDto {
    amount: number | undefined;
    editionDisplayName: string | undefined;
    invoiceNo: string | undefined;
    invoiceDate: moment.Moment | undefined;
    tenantLegalName: string | undefined;
    tenantAddress: string[] | undefined;
    tenantTaxNo: string | undefined;
    hostLegalName: string | undefined;
    hostAddress: string[] | undefined;
}

export class CreateInvoiceDto implements ICreateInvoiceDto {
    subscriptionPaymentId!: number | undefined;

    constructor(data?: ICreateInvoiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.subscriptionPaymentId = data["subscriptionPaymentId"];
        }
    }

    static fromJS(data: any): CreateInvoiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateInvoiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subscriptionPaymentId"] = this.subscriptionPaymentId;
        return data;
    }
}

export interface ICreateInvoiceDto {
    subscriptionPaymentId: number | undefined;
}

export class PagedResultDtoOfGetKindForView implements IPagedResultDtoOfGetKindForView {
    totalCount!: number | undefined;
    items!: GetKindForView[] | undefined;

    constructor(data?: IPagedResultDtoOfGetKindForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetKindForView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetKindForView {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetKindForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetKindForView {
    totalCount: number | undefined;
    items: GetKindForView[] | undefined;
}

export class GetKindForView implements IGetKindForView {
    kind!: KindDto | undefined;

    constructor(data?: IGetKindForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.kind = data["kind"] ? KindDto.fromJS(data["kind"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetKindForView {
        data = typeof data === 'object' ? data : {};
        let result = new GetKindForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kind"] = this.kind ? this.kind.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetKindForView {
    kind: KindDto | undefined;
}

export class KindDto implements IKindDto {
    code!: string | undefined;
    name!: string | undefined;
    description!: string | undefined;
    level!: number | undefined;
    parentCode!: string | undefined;
    isActive!: boolean | undefined;
    id!: number | undefined;

    constructor(data?: IKindDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.name = data["name"];
            this.description = data["description"];
            this.level = data["level"];
            this.parentCode = data["parentCode"];
            this.isActive = data["isActive"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): KindDto {
        data = typeof data === 'object' ? data : {};
        let result = new KindDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["description"] = this.description;
        data["level"] = this.level;
        data["parentCode"] = this.parentCode;
        data["isActive"] = this.isActive;
        data["id"] = this.id;
        return data;
    }
}

export interface IKindDto {
    code: string | undefined;
    name: string | undefined;
    description: string | undefined;
    level: number | undefined;
    parentCode: string | undefined;
    isActive: boolean | undefined;
    id: number | undefined;
}

export class GetKindForEditOutput implements IGetKindForEditOutput {
    kind!: CreateOrEditKindDto | undefined;

    constructor(data?: IGetKindForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.kind = data["kind"] ? CreateOrEditKindDto.fromJS(data["kind"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetKindForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetKindForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kind"] = this.kind ? this.kind.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetKindForEditOutput {
    kind: CreateOrEditKindDto | undefined;
}

export class CreateOrEditKindDto implements ICreateOrEditKindDto {
    code!: string;
    name!: string;
    description!: string | undefined;
    level!: number | undefined;
    parentCode!: string | undefined;
    isActive!: boolean | undefined;
    isDeleted!: boolean | undefined;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: moment.Moment | undefined;
    creatorUserId!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditKindDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.name = data["name"];
            this.description = data["description"];
            this.level = data["level"];
            this.parentCode = data["parentCode"];
            this.isActive = data["isActive"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditKindDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditKindDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["description"] = this.description;
        data["level"] = this.level;
        data["parentCode"] = this.parentCode;
        data["isActive"] = this.isActive;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditKindDto {
    code: string;
    name: string;
    description: string | undefined;
    level: number | undefined;
    parentCode: string | undefined;
    isActive: boolean | undefined;
    isDeleted: boolean | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class GetLanguagesOutput implements IGetLanguagesOutput {
    defaultLanguageName!: string | undefined;
    items!: ApplicationLanguageListDto[] | undefined;

    constructor(data?: IGetLanguagesOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.defaultLanguageName = data["defaultLanguageName"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(ApplicationLanguageListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetLanguagesOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetLanguagesOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["defaultLanguageName"] = this.defaultLanguageName;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetLanguagesOutput {
    defaultLanguageName: string | undefined;
    items: ApplicationLanguageListDto[] | undefined;
}

export class ApplicationLanguageListDto implements IApplicationLanguageListDto {
    tenantId!: number | undefined;
    name!: string | undefined;
    displayName!: string | undefined;
    icon!: string | undefined;
    isDisabled!: boolean | undefined;
    isDeleted!: boolean | undefined;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: moment.Moment | undefined;
    creatorUserId!: number | undefined;
    id!: number | undefined;

    constructor(data?: IApplicationLanguageListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.name = data["name"];
            this.displayName = data["displayName"];
            this.icon = data["icon"];
            this.isDisabled = data["isDisabled"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ApplicationLanguageListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationLanguageListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["icon"] = this.icon;
        data["isDisabled"] = this.isDisabled;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IApplicationLanguageListDto {
    tenantId: number | undefined;
    name: string | undefined;
    displayName: string | undefined;
    icon: string | undefined;
    isDisabled: boolean | undefined;
    isDeleted: boolean | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class GetLanguageForEditOutput implements IGetLanguageForEditOutput {
    language!: ApplicationLanguageEditDto | undefined;
    languageNames!: ComboboxItemDto[] | undefined;
    flags!: ComboboxItemDto[] | undefined;

    constructor(data?: IGetLanguageForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.language = data["language"] ? ApplicationLanguageEditDto.fromJS(data["language"]) : <any>undefined;
            if (data["languageNames"] && data["languageNames"].constructor === Array) {
                this.languageNames = [];
                for (let item of data["languageNames"])
                    this.languageNames.push(ComboboxItemDto.fromJS(item));
            }
            if (data["flags"] && data["flags"].constructor === Array) {
                this.flags = [];
                for (let item of data["flags"])
                    this.flags.push(ComboboxItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetLanguageForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetLanguageForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        if (this.languageNames && this.languageNames.constructor === Array) {
            data["languageNames"] = [];
            for (let item of this.languageNames)
                data["languageNames"].push(item.toJSON());
        }
        if (this.flags && this.flags.constructor === Array) {
            data["flags"] = [];
            for (let item of this.flags)
                data["flags"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetLanguageForEditOutput {
    language: ApplicationLanguageEditDto | undefined;
    languageNames: ComboboxItemDto[] | undefined;
    flags: ComboboxItemDto[] | undefined;
}

export class ApplicationLanguageEditDto implements IApplicationLanguageEditDto {
    id!: number | undefined;
    name!: string;
    icon!: string | undefined;
    isEnabled!: boolean | undefined;

    constructor(data?: IApplicationLanguageEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.icon = data["icon"];
            this.isEnabled = data["isEnabled"];
        }
    }

    static fromJS(data: any): ApplicationLanguageEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationLanguageEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["icon"] = this.icon;
        data["isEnabled"] = this.isEnabled;
        return data;
    }
}

export interface IApplicationLanguageEditDto {
    id: number | undefined;
    name: string;
    icon: string | undefined;
    isEnabled: boolean | undefined;
}

export class ComboboxItemDto implements IComboboxItemDto {
    value!: string | undefined;
    displayText!: string | undefined;
    isSelected!: boolean | undefined;

    constructor(data?: IComboboxItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.value = data["value"];
            this.displayText = data["displayText"];
            this.isSelected = data["isSelected"];
        }
    }

    static fromJS(data: any): ComboboxItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ComboboxItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["displayText"] = this.displayText;
        data["isSelected"] = this.isSelected;
        return data;
    }
}

export interface IComboboxItemDto {
    value: string | undefined;
    displayText: string | undefined;
    isSelected: boolean | undefined;
}

export class CreateOrUpdateLanguageInput implements ICreateOrUpdateLanguageInput {
    language!: ApplicationLanguageEditDto;

    constructor(data?: ICreateOrUpdateLanguageInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.language = new ApplicationLanguageEditDto();
        }
    }

    init(data?: any) {
        if (data) {
            this.language = data["language"] ? ApplicationLanguageEditDto.fromJS(data["language"]) : new ApplicationLanguageEditDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateLanguageInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateLanguageInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrUpdateLanguageInput {
    language: ApplicationLanguageEditDto;
}

export class SetDefaultLanguageInput implements ISetDefaultLanguageInput {
    name!: string;

    constructor(data?: ISetDefaultLanguageInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
        }
    }

    static fromJS(data: any): SetDefaultLanguageInput {
        data = typeof data === 'object' ? data : {};
        let result = new SetDefaultLanguageInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface ISetDefaultLanguageInput {
    name: string;
}

export class PagedResultDtoOfLanguageTextListDto implements IPagedResultDtoOfLanguageTextListDto {
    totalCount!: number | undefined;
    items!: LanguageTextListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfLanguageTextListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(LanguageTextListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfLanguageTextListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfLanguageTextListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfLanguageTextListDto {
    totalCount: number | undefined;
    items: LanguageTextListDto[] | undefined;
}

export class LanguageTextListDto implements ILanguageTextListDto {
    key!: string | undefined;
    baseValue!: string | undefined;
    targetValue!: string | undefined;

    constructor(data?: ILanguageTextListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.key = data["key"];
            this.baseValue = data["baseValue"];
            this.targetValue = data["targetValue"];
        }
    }

    static fromJS(data: any): LanguageTextListDto {
        data = typeof data === 'object' ? data : {};
        let result = new LanguageTextListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["baseValue"] = this.baseValue;
        data["targetValue"] = this.targetValue;
        return data;
    }
}

export interface ILanguageTextListDto {
    key: string | undefined;
    baseValue: string | undefined;
    targetValue: string | undefined;
}

export class UpdateLanguageTextInput implements IUpdateLanguageTextInput {
    languageName!: string;
    sourceName!: string;
    key!: string;
    value!: string;

    constructor(data?: IUpdateLanguageTextInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.languageName = data["languageName"];
            this.sourceName = data["sourceName"];
            this.key = data["key"];
            this.value = data["value"];
        }
    }

    static fromJS(data: any): UpdateLanguageTextInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateLanguageTextInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageName"] = this.languageName;
        data["sourceName"] = this.sourceName;
        data["key"] = this.key;
        data["value"] = this.value;
        return data;
    }
}

export interface IUpdateLanguageTextInput {
    languageName: string;
    sourceName: string;
    key: string;
    value: string;
}

export class PagedResultDtoOfGetLogForViewDto implements IPagedResultDtoOfGetLogForViewDto {
    totalCount!: number | undefined;
    items!: GetLogForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetLogForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetLogForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetLogForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetLogForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetLogForViewDto {
    totalCount: number | undefined;
    items: GetLogForViewDto[] | undefined;
}

export class GetLogForViewDto implements IGetLogForViewDto {
    log!: LogDto | undefined;

    constructor(data?: IGetLogForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.log = data["log"] ? LogDto.fromJS(data["log"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetLogForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetLogForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["log"] = this.log ? this.log.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetLogForViewDto {
    log: LogDto | undefined;
}

export class LogDto implements ILogDto {
    triggerBy!: string | undefined;
    sender!: string | undefined;
    receiver!: string | undefined;
    channelCode!: string | undefined;
    referenceCode!: string | undefined;
    type!: string | undefined;
    content!: string | undefined;
    title!: string | undefined;
    actions!: string | undefined;
    items!: string | undefined;
    status!: string | undefined;
    message!: string | undefined;
    triggerName!: string | undefined;
    channelMemberID!: string | undefined;
    channelTransactionID!: string | undefined;
    id!: number | undefined;

    constructor(data?: ILogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.triggerBy = data["triggerBy"];
            this.sender = data["sender"];
            this.receiver = data["receiver"];
            this.channelCode = data["channelCode"];
            this.referenceCode = data["referenceCode"];
            this.type = data["type"];
            this.content = data["content"];
            this.title = data["title"];
            this.actions = data["actions"];
            this.items = data["items"];
            this.status = data["status"];
            this.message = data["message"];
            this.triggerName = data["triggerName"];
            this.channelMemberID = data["channelMemberID"];
            this.channelTransactionID = data["channelTransactionID"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): LogDto {
        data = typeof data === 'object' ? data : {};
        let result = new LogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["triggerBy"] = this.triggerBy;
        data["sender"] = this.sender;
        data["receiver"] = this.receiver;
        data["channelCode"] = this.channelCode;
        data["referenceCode"] = this.referenceCode;
        data["type"] = this.type;
        data["content"] = this.content;
        data["title"] = this.title;
        data["actions"] = this.actions;
        data["items"] = this.items;
        data["status"] = this.status;
        data["message"] = this.message;
        data["triggerName"] = this.triggerName;
        data["channelMemberID"] = this.channelMemberID;
        data["channelTransactionID"] = this.channelTransactionID;
        data["id"] = this.id;
        return data;
    }
}

export interface ILogDto {
    triggerBy: string | undefined;
    sender: string | undefined;
    receiver: string | undefined;
    channelCode: string | undefined;
    referenceCode: string | undefined;
    type: string | undefined;
    content: string | undefined;
    title: string | undefined;
    actions: string | undefined;
    items: string | undefined;
    status: string | undefined;
    message: string | undefined;
    triggerName: string | undefined;
    channelMemberID: string | undefined;
    channelTransactionID: string | undefined;
    id: number | undefined;
}

export class GetLogForEditOutput implements IGetLogForEditOutput {
    log!: CreateOrEditLogDto | undefined;

    constructor(data?: IGetLogForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.log = data["log"] ? CreateOrEditLogDto.fromJS(data["log"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetLogForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetLogForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["log"] = this.log ? this.log.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetLogForEditOutput {
    log: CreateOrEditLogDto | undefined;
}

export class CreateOrEditLogDto implements ICreateOrEditLogDto {
    triggerBy!: string | undefined;
    sender!: string | undefined;
    receiver!: string | undefined;
    channelCode!: string | undefined;
    referenceCode!: string | undefined;
    type!: string | undefined;
    content!: string | undefined;
    title!: string | undefined;
    actions!: string | undefined;
    items!: string | undefined;
    status!: string | undefined;
    message!: string | undefined;
    triggerName!: string | undefined;
    channelMemberID!: string | undefined;
    channelTransactionID!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditLogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.triggerBy = data["triggerBy"];
            this.sender = data["sender"];
            this.receiver = data["receiver"];
            this.channelCode = data["channelCode"];
            this.referenceCode = data["referenceCode"];
            this.type = data["type"];
            this.content = data["content"];
            this.title = data["title"];
            this.actions = data["actions"];
            this.items = data["items"];
            this.status = data["status"];
            this.message = data["message"];
            this.triggerName = data["triggerName"];
            this.channelMemberID = data["channelMemberID"];
            this.channelTransactionID = data["channelTransactionID"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["triggerBy"] = this.triggerBy;
        data["sender"] = this.sender;
        data["receiver"] = this.receiver;
        data["channelCode"] = this.channelCode;
        data["referenceCode"] = this.referenceCode;
        data["type"] = this.type;
        data["content"] = this.content;
        data["title"] = this.title;
        data["actions"] = this.actions;
        data["items"] = this.items;
        data["status"] = this.status;
        data["message"] = this.message;
        data["triggerName"] = this.triggerName;
        data["channelMemberID"] = this.channelMemberID;
        data["channelTransactionID"] = this.channelTransactionID;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditLogDto {
    triggerBy: string | undefined;
    sender: string | undefined;
    receiver: string | undefined;
    channelCode: string | undefined;
    referenceCode: string | undefined;
    type: string | undefined;
    content: string | undefined;
    title: string | undefined;
    actions: string | undefined;
    items: string | undefined;
    status: string | undefined;
    message: string | undefined;
    triggerName: string | undefined;
    channelMemberID: string | undefined;
    channelTransactionID: string | undefined;
    id: number | undefined;
}

export class LoyaltySummaryDto implements ILoyaltySummaryDto {
    revenue!: number | undefined;
    revenueByMember!: number | undefined;
    revenuePeriodLast!: number | undefined;
    cost!: number | undefined;
    costByMember!: number | undefined;
    costPeriodLast!: number | undefined;
    invoice!: number | undefined;
    invoicePeriodLast!: number | undefined;
    activeMember!: number | undefined;
    activeMemberPeriodLast!: number | undefined;
    timeLeft!: number | undefined;

    constructor(data?: ILoyaltySummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.revenue = data["revenue"];
            this.revenueByMember = data["revenueByMember"];
            this.revenuePeriodLast = data["revenuePeriodLast"];
            this.cost = data["cost"];
            this.costByMember = data["costByMember"];
            this.costPeriodLast = data["costPeriodLast"];
            this.invoice = data["invoice"];
            this.invoicePeriodLast = data["invoicePeriodLast"];
            this.activeMember = data["activeMember"];
            this.activeMemberPeriodLast = data["activeMemberPeriodLast"];
            this.timeLeft = data["timeLeft"];
        }
    }

    static fromJS(data: any): LoyaltySummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new LoyaltySummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["revenue"] = this.revenue;
        data["revenueByMember"] = this.revenueByMember;
        data["revenuePeriodLast"] = this.revenuePeriodLast;
        data["cost"] = this.cost;
        data["costByMember"] = this.costByMember;
        data["costPeriodLast"] = this.costPeriodLast;
        data["invoice"] = this.invoice;
        data["invoicePeriodLast"] = this.invoicePeriodLast;
        data["activeMember"] = this.activeMember;
        data["activeMemberPeriodLast"] = this.activeMemberPeriodLast;
        data["timeLeft"] = this.timeLeft;
        return data;
    }
}

export interface ILoyaltySummaryDto {
    revenue: number | undefined;
    revenueByMember: number | undefined;
    revenuePeriodLast: number | undefined;
    cost: number | undefined;
    costByMember: number | undefined;
    costPeriodLast: number | undefined;
    invoice: number | undefined;
    invoicePeriodLast: number | undefined;
    activeMember: number | undefined;
    activeMemberPeriodLast: number | undefined;
    timeLeft: number | undefined;
}

export class CreateSerialRequestDto implements ICreateSerialRequestDto {
    serialRequestDto!: SerialRequestDto | undefined;

    constructor(data?: ICreateSerialRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.serialRequestDto = data["serialRequestDto"] ? SerialRequestDto.fromJS(data["serialRequestDto"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateSerialRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSerialRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serialRequestDto"] = this.serialRequestDto ? this.serialRequestDto.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateSerialRequestDto {
    serialRequestDto: SerialRequestDto | undefined;
}

export class SerialRequestDto implements ISerialRequestDto {
    materialNum!: string;
    serial!: string;
    materialDes!: string;
    dataExport!: string;
    status!: string;

    constructor(data?: ISerialRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.materialNum = data["materialNum"];
            this.serial = data["serial"];
            this.materialDes = data["materialDes"];
            this.dataExport = data["dataExport"];
            this.status = data["status"];
        }
    }

    static fromJS(data: any): SerialRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new SerialRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["materialNum"] = this.materialNum;
        data["serial"] = this.serial;
        data["materialDes"] = this.materialDes;
        data["dataExport"] = this.dataExport;
        data["status"] = this.status;
        return data;
    }
}

export interface ISerialRequestDto {
    materialNum: string;
    serial: string;
    materialDes: string;
    dataExport: string;
    status: string;
}

export class CreateSerialResponseDto implements ICreateSerialResponseDto {
    createSerialDataResponse!: SerialDataResponse | undefined;

    constructor(data?: ICreateSerialResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.createSerialDataResponse = data["createSerialDataResponse"] ? SerialDataResponse.fromJS(data["createSerialDataResponse"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateSerialResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSerialResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createSerialDataResponse"] = this.createSerialDataResponse ? this.createSerialDataResponse.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateSerialResponseDto {
    createSerialDataResponse: SerialDataResponse | undefined;
}

export class SerialDataResponse implements ISerialDataResponse {
    status!: string | undefined;
    message!: string | undefined;

    constructor(data?: ISerialDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.status = data["status"];
            this.message = data["message"];
        }
    }

    static fromJS(data: any): SerialDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SerialDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["message"] = this.message;
        return data;
    }
}

export interface ISerialDataResponse {
    status: string | undefined;
    message: string | undefined;
}

export class MasterDataGlcRequestReceiveDto implements IMasterDataGlcRequestReceiveDto {
    serialRequest!: MasterDataGlcReceiveDto[] | undefined;

    constructor(data?: IMasterDataGlcRequestReceiveDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["serialRequest"] && data["serialRequest"].constructor === Array) {
                this.serialRequest = [];
                for (let item of data["serialRequest"])
                    this.serialRequest.push(MasterDataGlcReceiveDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MasterDataGlcRequestReceiveDto {
        data = typeof data === 'object' ? data : {};
        let result = new MasterDataGlcRequestReceiveDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.serialRequest && this.serialRequest.constructor === Array) {
            data["serialRequest"] = [];
            for (let item of this.serialRequest)
                data["serialRequest"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMasterDataGlcRequestReceiveDto {
    serialRequest: MasterDataGlcReceiveDto[] | undefined;
}

export class MasterDataGlcReceiveDto implements IMasterDataGlcReceiveDto {
    serial!: string | undefined;
    doType!: string | undefined;
    moveType!: string | undefined;
    createDate!: moment.Moment | undefined;
    yourReference!: string | undefined;
    plantName!: string | undefined;
    doNumber!: string | undefined;
    materialNum!: string | undefined;
    vehicleNumber!: string | undefined;
    materialType!: string;

    constructor(data?: IMasterDataGlcReceiveDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.serial = data["serial"];
            this.doType = data["doType"];
            this.moveType = data["moveType"];
            this.createDate = data["createDate"] ? moment(data["createDate"].toString()) : <any>undefined;
            this.yourReference = data["yourReference"];
            this.plantName = data["plantName"];
            this.doNumber = data["doNumber"];
            this.materialNum = data["materialNum"];
            this.vehicleNumber = data["vehicleNumber"];
            this.materialType = data["materialType"];
        }
    }

    static fromJS(data: any): MasterDataGlcReceiveDto {
        data = typeof data === 'object' ? data : {};
        let result = new MasterDataGlcReceiveDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serial"] = this.serial;
        data["doType"] = this.doType;
        data["moveType"] = this.moveType;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : <any>undefined;
        data["yourReference"] = this.yourReference;
        data["plantName"] = this.plantName;
        data["doNumber"] = this.doNumber;
        data["materialNum"] = this.materialNum;
        data["vehicleNumber"] = this.vehicleNumber;
        data["materialType"] = this.materialType;
        return data;
    }
}

export interface IMasterDataGlcReceiveDto {
    serial: string | undefined;
    doType: string | undefined;
    moveType: string | undefined;
    createDate: moment.Moment | undefined;
    yourReference: string | undefined;
    plantName: string | undefined;
    doNumber: string | undefined;
    materialNum: string | undefined;
    vehicleNumber: string | undefined;
    materialType: string;
}

export class MasterDataGlcResponseDto implements IMasterDataGlcResponseDto {
    status!: string | undefined;
    message!: string | undefined;
    toTalError!: number | undefined;
    totalSuccess!: number | undefined;
    data!: MasterDataGlcReceiveValidate[] | undefined;

    constructor(data?: IMasterDataGlcResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.status = data["status"];
            this.message = data["message"];
            this.toTalError = data["toTalError"];
            this.totalSuccess = data["totalSuccess"];
            if (data["data"] && data["data"].constructor === Array) {
                this.data = [];
                for (let item of data["data"])
                    this.data.push(MasterDataGlcReceiveValidate.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MasterDataGlcResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new MasterDataGlcResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["message"] = this.message;
        data["toTalError"] = this.toTalError;
        data["totalSuccess"] = this.totalSuccess;
        if (this.data && this.data.constructor === Array) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMasterDataGlcResponseDto {
    status: string | undefined;
    message: string | undefined;
    toTalError: number | undefined;
    totalSuccess: number | undefined;
    data: MasterDataGlcReceiveValidate[] | undefined;
}

export class MasterDataGlcReceiveValidate implements IMasterDataGlcReceiveValidate {
    serial!: string | undefined;
    status!: string | undefined;
    errors!: string | undefined;

    constructor(data?: IMasterDataGlcReceiveValidate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.serial = data["serial"];
            this.status = data["status"];
            this.errors = data["errors"];
        }
    }

    static fromJS(data: any): MasterDataGlcReceiveValidate {
        data = typeof data === 'object' ? data : {};
        let result = new MasterDataGlcReceiveValidate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serial"] = this.serial;
        data["status"] = this.status;
        data["errors"] = this.errors;
        return data;
    }
}

export interface IMasterDataGlcReceiveValidate {
    serial: string | undefined;
    status: string | undefined;
    errors: string | undefined;
}

export class MasterDataGlcRequestExportDto implements IMasterDataGlcRequestExportDto {
    serialRequest!: MasterDataGlcExportDto[] | undefined;

    constructor(data?: IMasterDataGlcRequestExportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["serialRequest"] && data["serialRequest"].constructor === Array) {
                this.serialRequest = [];
                for (let item of data["serialRequest"])
                    this.serialRequest.push(MasterDataGlcExportDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MasterDataGlcRequestExportDto {
        data = typeof data === 'object' ? data : {};
        let result = new MasterDataGlcRequestExportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.serialRequest && this.serialRequest.constructor === Array) {
            data["serialRequest"] = [];
            for (let item of this.serialRequest)
                data["serialRequest"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMasterDataGlcRequestExportDto {
    serialRequest: MasterDataGlcExportDto[] | undefined;
}

export class MasterDataGlcExportDto implements IMasterDataGlcExportDto {
    createDate!: moment.Moment | undefined;
    doNumber!: string | undefined;
    materialNum!: string | undefined;
    memberCode!: string | undefined;
    vehicleNumber!: string | undefined;
    distributionChannel!: string | undefined;
    materialType!: string | undefined;
    source!: string | undefined;
    serial!: string | undefined;
    type!: string | undefined;
    doType!: string | undefined;
    soType!: string | undefined;
    moveType!: string | undefined;

    constructor(data?: IMasterDataGlcExportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.createDate = data["createDate"] ? moment(data["createDate"].toString()) : <any>undefined;
            this.doNumber = data["doNumber"];
            this.materialNum = data["materialNum"];
            this.memberCode = data["memberCode"];
            this.vehicleNumber = data["vehicleNumber"];
            this.distributionChannel = data["distributionChannel"];
            this.materialType = data["materialType"];
            this.source = data["source"];
            this.serial = data["serial"];
            this.type = data["type"];
            this.doType = data["doType"];
            this.soType = data["soType"];
            this.moveType = data["moveType"];
        }
    }

    static fromJS(data: any): MasterDataGlcExportDto {
        data = typeof data === 'object' ? data : {};
        let result = new MasterDataGlcExportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createDate"] = this.createDate ? this.createDate.toISOString() : <any>undefined;
        data["doNumber"] = this.doNumber;
        data["materialNum"] = this.materialNum;
        data["memberCode"] = this.memberCode;
        data["vehicleNumber"] = this.vehicleNumber;
        data["distributionChannel"] = this.distributionChannel;
        data["materialType"] = this.materialType;
        data["source"] = this.source;
        data["serial"] = this.serial;
        data["type"] = this.type;
        data["doType"] = this.doType;
        data["soType"] = this.soType;
        data["moveType"] = this.moveType;
        return data;
    }
}

export interface IMasterDataGlcExportDto {
    createDate: moment.Moment | undefined;
    doNumber: string | undefined;
    materialNum: string | undefined;
    memberCode: string | undefined;
    vehicleNumber: string | undefined;
    distributionChannel: string | undefined;
    materialType: string | undefined;
    source: string | undefined;
    serial: string | undefined;
    type: string | undefined;
    doType: string | undefined;
    soType: string | undefined;
    moveType: string | undefined;
}

export class GLCResponseCheckSerial implements IGLCResponseCheckSerial {
    status!: string | undefined;
    message!: string | undefined;
    totalError!: number | undefined;
    totalSuccess!: number | undefined;
    data!: GLCCheckSerial[] | undefined;

    constructor(data?: IGLCResponseCheckSerial) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.status = data["status"];
            this.message = data["message"];
            this.totalError = data["totalError"];
            this.totalSuccess = data["totalSuccess"];
            if (data["data"] && data["data"].constructor === Array) {
                this.data = [];
                for (let item of data["data"])
                    this.data.push(GLCCheckSerial.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GLCResponseCheckSerial {
        data = typeof data === 'object' ? data : {};
        let result = new GLCResponseCheckSerial();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["message"] = this.message;
        data["totalError"] = this.totalError;
        data["totalSuccess"] = this.totalSuccess;
        if (this.data && this.data.constructor === Array) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGLCResponseCheckSerial {
    status: string | undefined;
    message: string | undefined;
    totalError: number | undefined;
    totalSuccess: number | undefined;
    data: GLCCheckSerial[] | undefined;
}

export class GLCCheckSerial implements IGLCCheckSerial {
    serial!: string | undefined;
    status!: string | undefined;
    errors!: string | undefined;

    constructor(data?: IGLCCheckSerial) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.serial = data["serial"];
            this.status = data["status"];
            this.errors = data["errors"];
        }
    }

    static fromJS(data: any): GLCCheckSerial {
        data = typeof data === 'object' ? data : {};
        let result = new GLCCheckSerial();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serial"] = this.serial;
        data["status"] = this.status;
        data["errors"] = this.errors;
        return data;
    }
}

export interface IGLCCheckSerial {
    serial: string | undefined;
    status: string | undefined;
    errors: string | undefined;
}

export class PagedResultDtoOfWarehouseSerialResponse implements IPagedResultDtoOfWarehouseSerialResponse {
    totalCount!: number | undefined;
    items!: WarehouseSerialResponse[] | undefined;

    constructor(data?: IPagedResultDtoOfWarehouseSerialResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(WarehouseSerialResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfWarehouseSerialResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfWarehouseSerialResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfWarehouseSerialResponse {
    totalCount: number | undefined;
    items: WarehouseSerialResponse[] | undefined;
}

export class WarehouseSerialResponse implements IWarehouseSerialResponse {
    masterData!: WarehouseSerialReceived | undefined;

    constructor(data?: IWarehouseSerialResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.masterData = data["masterData"] ? WarehouseSerialReceived.fromJS(data["masterData"]) : <any>undefined;
        }
    }

    static fromJS(data: any): WarehouseSerialResponse {
        data = typeof data === 'object' ? data : {};
        let result = new WarehouseSerialResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["masterData"] = this.masterData ? this.masterData.toJSON() : <any>undefined;
        return data;
    }
}

export interface IWarehouseSerialResponse {
    masterData: WarehouseSerialReceived | undefined;
}

export class WarehouseSerialReceived implements IWarehouseSerialReceived {
    serial!: string | undefined;
    yourReference!: string | undefined;
    doNumber!: string | undefined;
    moveType!: string | undefined;
    doType!: string | undefined;
    materialNumber!: string | undefined;
    vehicleNumber!: string | undefined;
    plantName!: string | undefined;
    inboundType!: string | undefined;
    creationDate!: moment.Moment | undefined;
    createDate!: moment.Moment | undefined;

    constructor(data?: IWarehouseSerialReceived) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.serial = data["serial"];
            this.yourReference = data["yourReference"];
            this.doNumber = data["doNumber"];
            this.moveType = data["moveType"];
            this.doType = data["doType"];
            this.materialNumber = data["materialNumber"];
            this.vehicleNumber = data["vehicleNumber"];
            this.plantName = data["plantName"];
            this.inboundType = data["inboundType"];
            this.creationDate = data["creationDate"] ? moment(data["creationDate"].toString()) : <any>undefined;
            this.createDate = data["createDate"] ? moment(data["createDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): WarehouseSerialReceived {
        data = typeof data === 'object' ? data : {};
        let result = new WarehouseSerialReceived();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serial"] = this.serial;
        data["yourReference"] = this.yourReference;
        data["doNumber"] = this.doNumber;
        data["moveType"] = this.moveType;
        data["doType"] = this.doType;
        data["materialNumber"] = this.materialNumber;
        data["vehicleNumber"] = this.vehicleNumber;
        data["plantName"] = this.plantName;
        data["inboundType"] = this.inboundType;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : <any>undefined;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IWarehouseSerialReceived {
    serial: string | undefined;
    yourReference: string | undefined;
    doNumber: string | undefined;
    moveType: string | undefined;
    doType: string | undefined;
    materialNumber: string | undefined;
    vehicleNumber: string | undefined;
    plantName: string | undefined;
    inboundType: string | undefined;
    creationDate: moment.Moment | undefined;
    createDate: moment.Moment | undefined;
}

export class GetMasterDetailForEditOutput implements IGetMasterDetailForEditOutput {
    masterDetail!: CreateOrEditMasterDetailDto | undefined;

    constructor(data?: IGetMasterDetailForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.masterDetail = data["masterDetail"] ? CreateOrEditMasterDetailDto.fromJS(data["masterDetail"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetMasterDetailForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetMasterDetailForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["masterDetail"] = this.masterDetail ? this.masterDetail.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetMasterDetailForEditOutput {
    masterDetail: CreateOrEditMasterDetailDto | undefined;
}

export class MessageResultConsumerDB implements IMessageResultConsumerDB {
    isSuccess!: boolean | undefined;
    errors!: MessageErrorConsumerDB[] | undefined;

    constructor(data?: IMessageResultConsumerDB) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isSuccess = data["isSuccess"];
            if (data["errors"] && data["errors"].constructor === Array) {
                this.errors = [];
                for (let item of data["errors"])
                    this.errors.push(MessageErrorConsumerDB.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MessageResultConsumerDB {
        data = typeof data === 'object' ? data : {};
        let result = new MessageResultConsumerDB();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        if (this.errors && this.errors.constructor === Array) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMessageResultConsumerDB {
    isSuccess: boolean | undefined;
    errors: MessageErrorConsumerDB[] | undefined;
}

export class MessageErrorConsumerDB implements IMessageErrorConsumerDB {
    message!: string | undefined;
    propertyName!: string | undefined;
    count!: number | undefined;

    constructor(data?: IMessageErrorConsumerDB) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.message = data["message"];
            this.propertyName = data["propertyName"];
            this.count = data["count"];
        }
    }

    static fromJS(data: any): MessageErrorConsumerDB {
        data = typeof data === 'object' ? data : {};
        let result = new MessageErrorConsumerDB();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["propertyName"] = this.propertyName;
        data["count"] = this.count;
        return data;
    }
}

export interface IMessageErrorConsumerDB {
    message: string | undefined;
    propertyName: string | undefined;
    count: number | undefined;
}

export class GetMasterDetailCustom implements IGetMasterDetailCustom {
    ranks!: MasterDetailDto[] | undefined;
    regions!: MasterDetailDto[] | undefined;
    occupations!: MasterDetailDto[] | undefined;
    nationalities!: MasterDetailDto[] | undefined;
    hobbies!: MasterDetailDto[] | undefined;
    paymentMethods!: MasterDetailDto[] | undefined;

    constructor(data?: IGetMasterDetailCustom) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["ranks"] && data["ranks"].constructor === Array) {
                this.ranks = [];
                for (let item of data["ranks"])
                    this.ranks.push(MasterDetailDto.fromJS(item));
            }
            if (data["regions"] && data["regions"].constructor === Array) {
                this.regions = [];
                for (let item of data["regions"])
                    this.regions.push(MasterDetailDto.fromJS(item));
            }
            if (data["occupations"] && data["occupations"].constructor === Array) {
                this.occupations = [];
                for (let item of data["occupations"])
                    this.occupations.push(MasterDetailDto.fromJS(item));
            }
            if (data["nationalities"] && data["nationalities"].constructor === Array) {
                this.nationalities = [];
                for (let item of data["nationalities"])
                    this.nationalities.push(MasterDetailDto.fromJS(item));
            }
            if (data["hobbies"] && data["hobbies"].constructor === Array) {
                this.hobbies = [];
                for (let item of data["hobbies"])
                    this.hobbies.push(MasterDetailDto.fromJS(item));
            }
            if (data["paymentMethods"] && data["paymentMethods"].constructor === Array) {
                this.paymentMethods = [];
                for (let item of data["paymentMethods"])
                    this.paymentMethods.push(MasterDetailDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMasterDetailCustom {
        data = typeof data === 'object' ? data : {};
        let result = new GetMasterDetailCustom();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.ranks && this.ranks.constructor === Array) {
            data["ranks"] = [];
            for (let item of this.ranks)
                data["ranks"].push(item.toJSON());
        }
        if (this.regions && this.regions.constructor === Array) {
            data["regions"] = [];
            for (let item of this.regions)
                data["regions"].push(item.toJSON());
        }
        if (this.occupations && this.occupations.constructor === Array) {
            data["occupations"] = [];
            for (let item of this.occupations)
                data["occupations"].push(item.toJSON());
        }
        if (this.nationalities && this.nationalities.constructor === Array) {
            data["nationalities"] = [];
            for (let item of this.nationalities)
                data["nationalities"].push(item.toJSON());
        }
        if (this.hobbies && this.hobbies.constructor === Array) {
            data["hobbies"] = [];
            for (let item of this.hobbies)
                data["hobbies"].push(item.toJSON());
        }
        if (this.paymentMethods && this.paymentMethods.constructor === Array) {
            data["paymentMethods"] = [];
            for (let item of this.paymentMethods)
                data["paymentMethods"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetMasterDetailCustom {
    ranks: MasterDetailDto[] | undefined;
    regions: MasterDetailDto[] | undefined;
    occupations: MasterDetailDto[] | undefined;
    nationalities: MasterDetailDto[] | undefined;
    hobbies: MasterDetailDto[] | undefined;
    paymentMethods: MasterDetailDto[] | undefined;
}

export class GetAllMasterDetailsInput implements IGetAllMasterDetailsInput {
    filter!: string | undefined;
    masterCodeFilter!: string | undefined;
    detailCodeFilter!: string | undefined;
    parentCodeFilter!: string | undefined;
    nodePathFilter!: string | undefined;
    maxOrdinalFilter!: number | undefined;
    minOrdinalFilter!: number | undefined;
    statusFilter!: string | undefined;
    maxDetailValueNumberFilter!: number | undefined;
    minDetailValueNumberFilter!: number | undefined;
    maxLevelFilter!: number | undefined;
    minLevelFilter!: number | undefined;
    detailValueFilter!: string | undefined;
    detailValueUnSignFilter!: string | undefined;
    metaDataType!: string | undefined;
    sorting!: string | undefined;
    skipCount!: number | undefined;
    maxResultCount!: number | undefined;

    constructor(data?: IGetAllMasterDetailsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.filter = data["filter"];
            this.masterCodeFilter = data["masterCodeFilter"];
            this.detailCodeFilter = data["detailCodeFilter"];
            this.parentCodeFilter = data["parentCodeFilter"];
            this.nodePathFilter = data["nodePathFilter"];
            this.maxOrdinalFilter = data["maxOrdinalFilter"];
            this.minOrdinalFilter = data["minOrdinalFilter"];
            this.statusFilter = data["statusFilter"];
            this.maxDetailValueNumberFilter = data["maxDetailValueNumberFilter"];
            this.minDetailValueNumberFilter = data["minDetailValueNumberFilter"];
            this.maxLevelFilter = data["maxLevelFilter"];
            this.minLevelFilter = data["minLevelFilter"];
            this.detailValueFilter = data["detailValueFilter"];
            this.detailValueUnSignFilter = data["detailValueUnSignFilter"];
            this.metaDataType = data["metaDataType"];
            this.sorting = data["sorting"];
            this.skipCount = data["skipCount"];
            this.maxResultCount = data["maxResultCount"];
        }
    }

    static fromJS(data: any): GetAllMasterDetailsInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllMasterDetailsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        data["masterCodeFilter"] = this.masterCodeFilter;
        data["detailCodeFilter"] = this.detailCodeFilter;
        data["parentCodeFilter"] = this.parentCodeFilter;
        data["nodePathFilter"] = this.nodePathFilter;
        data["maxOrdinalFilter"] = this.maxOrdinalFilter;
        data["minOrdinalFilter"] = this.minOrdinalFilter;
        data["statusFilter"] = this.statusFilter;
        data["maxDetailValueNumberFilter"] = this.maxDetailValueNumberFilter;
        data["minDetailValueNumberFilter"] = this.minDetailValueNumberFilter;
        data["maxLevelFilter"] = this.maxLevelFilter;
        data["minLevelFilter"] = this.minLevelFilter;
        data["detailValueFilter"] = this.detailValueFilter;
        data["detailValueUnSignFilter"] = this.detailValueUnSignFilter;
        data["metaDataType"] = this.metaDataType;
        data["sorting"] = this.sorting;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data;
    }
}

export interface IGetAllMasterDetailsInput {
    filter: string | undefined;
    masterCodeFilter: string | undefined;
    detailCodeFilter: string | undefined;
    parentCodeFilter: string | undefined;
    nodePathFilter: string | undefined;
    maxOrdinalFilter: number | undefined;
    minOrdinalFilter: number | undefined;
    statusFilter: string | undefined;
    maxDetailValueNumberFilter: number | undefined;
    minDetailValueNumberFilter: number | undefined;
    maxLevelFilter: number | undefined;
    minLevelFilter: number | undefined;
    detailValueFilter: string | undefined;
    detailValueUnSignFilter: string | undefined;
    metaDataType: string | undefined;
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;
}

export class MetaDataAgrs implements IMetaDataAgrs {
    tableName!: string | undefined;
    filePath!: string | undefined;
    fileName!: string | undefined;
    userId!: number | undefined;
    tenantId!: number | undefined;
    currentLanguage!: string | undefined;
    apiUrl!: string | undefined;

    constructor(data?: IMetaDataAgrs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tableName = data["tableName"];
            this.filePath = data["filePath"];
            this.fileName = data["fileName"];
            this.userId = data["userId"];
            this.tenantId = data["tenantId"];
            this.currentLanguage = data["currentLanguage"];
            this.apiUrl = data["apiUrl"];
        }
    }

    static fromJS(data: any): MetaDataAgrs {
        data = typeof data === 'object' ? data : {};
        let result = new MetaDataAgrs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tableName"] = this.tableName;
        data["filePath"] = this.filePath;
        data["fileName"] = this.fileName;
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["currentLanguage"] = this.currentLanguage;
        data["apiUrl"] = this.apiUrl;
        return data;
    }
}

export interface IMetaDataAgrs {
    tableName: string | undefined;
    filePath: string | undefined;
    fileName: string | undefined;
    userId: number | undefined;
    tenantId: number | undefined;
    currentLanguage: string | undefined;
    apiUrl: string | undefined;
}

export class MasterDetail implements IMasterDetail {
    tenantId!: number | undefined;
    masterCode!: string | undefined;
    detailCode!: string | undefined;
    parentCode!: string | undefined;
    nodePath!: string | undefined;
    ordinal!: number | undefined;
    status!: string | undefined;
    detailValueNumber!: number | undefined;
    level!: number | undefined;
    detailValue!: string | undefined;
    detailValueUnSign!: string | undefined;
    detailImage!: string | undefined;
    isDeleted!: boolean | undefined;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: moment.Moment | undefined;
    creatorUserId!: number | undefined;
    id!: number | undefined;

    constructor(data?: IMasterDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.masterCode = data["masterCode"];
            this.detailCode = data["detailCode"];
            this.parentCode = data["parentCode"];
            this.nodePath = data["nodePath"];
            this.ordinal = data["ordinal"];
            this.status = data["status"];
            this.detailValueNumber = data["detailValueNumber"];
            this.level = data["level"];
            this.detailValue = data["detailValue"];
            this.detailValueUnSign = data["detailValueUnSign"];
            this.detailImage = data["detailImage"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): MasterDetail {
        data = typeof data === 'object' ? data : {};
        let result = new MasterDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["masterCode"] = this.masterCode;
        data["detailCode"] = this.detailCode;
        data["parentCode"] = this.parentCode;
        data["nodePath"] = this.nodePath;
        data["ordinal"] = this.ordinal;
        data["status"] = this.status;
        data["detailValueNumber"] = this.detailValueNumber;
        data["level"] = this.level;
        data["detailValue"] = this.detailValue;
        data["detailValueUnSign"] = this.detailValueUnSign;
        data["detailImage"] = this.detailImage;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IMasterDetail {
    tenantId: number | undefined;
    masterCode: string | undefined;
    detailCode: string | undefined;
    parentCode: string | undefined;
    nodePath: string | undefined;
    ordinal: number | undefined;
    status: string | undefined;
    detailValueNumber: number | undefined;
    level: number | undefined;
    detailValue: string | undefined;
    detailValueUnSign: string | undefined;
    detailImage: string | undefined;
    isDeleted: boolean | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfRegionViewDto implements IPagedResultDtoOfRegionViewDto {
    totalCount!: number | undefined;
    items!: RegionViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfRegionViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(RegionViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfRegionViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfRegionViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfRegionViewDto {
    totalCount: number | undefined;
    items: RegionViewDto[] | undefined;
}

export class RegionViewDto implements IRegionViewDto {
    region!: RegionsDto | undefined;

    constructor(data?: IRegionViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.region = data["region"] ? RegionsDto.fromJS(data["region"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RegionViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new RegionViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["region"] = this.region ? this.region.toJSON() : <any>undefined;
        return data;
    }
}

export interface IRegionViewDto {
    region: RegionsDto | undefined;
}

export class RegionsDto implements IRegionsDto {
    code!: string | undefined;
    name!: string | undefined;

    constructor(data?: IRegionsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.name = data["name"];
        }
    }

    static fromJS(data: any): RegionsDto {
        data = typeof data === 'object' ? data : {};
        let result = new RegionsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        return data;
    }
}

export interface IRegionsDto {
    code: string | undefined;
    name: string | undefined;
}

export class RegionsForViewDto implements IRegionsForViewDto {
    detailCode!: string | undefined;
    detailValue!: string | undefined;

    constructor(data?: IRegionsForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.detailCode = data["detailCode"];
            this.detailValue = data["detailValue"];
        }
    }

    static fromJS(data: any): RegionsForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new RegionsForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["detailCode"] = this.detailCode;
        data["detailValue"] = this.detailValue;
        return data;
    }
}

export interface IRegionsForViewDto {
    detailCode: string | undefined;
    detailValue: string | undefined;
}

export class PagedResultDtoOfGetMasterHeaderForViewDto implements IPagedResultDtoOfGetMasterHeaderForViewDto {
    totalCount!: number | undefined;
    items!: GetMasterHeaderForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetMasterHeaderForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetMasterHeaderForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetMasterHeaderForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetMasterHeaderForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetMasterHeaderForViewDto {
    totalCount: number | undefined;
    items: GetMasterHeaderForViewDto[] | undefined;
}

export class GetMasterHeaderForViewDto implements IGetMasterHeaderForViewDto {
    masterHeader!: MasterHeaderDto | undefined;

    constructor(data?: IGetMasterHeaderForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.masterHeader = data["masterHeader"] ? MasterHeaderDto.fromJS(data["masterHeader"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetMasterHeaderForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetMasterHeaderForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["masterHeader"] = this.masterHeader ? this.masterHeader.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetMasterHeaderForViewDto {
    masterHeader: MasterHeaderDto | undefined;
}

export class MasterHeaderDto implements IMasterHeaderDto {
    masterCode!: string | undefined;
    masterName!: string | undefined;
    status!: string | undefined;
    type!: string | undefined;
    isSystem!: boolean | undefined;
    creationTime!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;
    id!: number | undefined;

    constructor(data?: IMasterHeaderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.masterCode = data["masterCode"];
            this.masterName = data["masterName"];
            this.status = data["status"];
            this.type = data["type"];
            this.isSystem = data["isSystem"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): MasterHeaderDto {
        data = typeof data === 'object' ? data : {};
        let result = new MasterHeaderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["masterCode"] = this.masterCode;
        data["masterName"] = this.masterName;
        data["status"] = this.status;
        data["type"] = this.type;
        data["isSystem"] = this.isSystem;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IMasterHeaderDto {
    masterCode: string | undefined;
    masterName: string | undefined;
    status: string | undefined;
    type: string | undefined;
    isSystem: boolean | undefined;
    creationTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    id: number | undefined;
}

export class GetMasterHeaderForEditOutput implements IGetMasterHeaderForEditOutput {
    masterHeader!: CreateOrEditMasterHeaderDto | undefined;

    constructor(data?: IGetMasterHeaderForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.masterHeader = data["masterHeader"] ? CreateOrEditMasterHeaderDto.fromJS(data["masterHeader"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetMasterHeaderForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetMasterHeaderForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["masterHeader"] = this.masterHeader ? this.masterHeader.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetMasterHeaderForEditOutput {
    masterHeader: CreateOrEditMasterHeaderDto | undefined;
}

export class CreateOrEditMasterHeaderDto implements ICreateOrEditMasterHeaderDto {
    masterCode!: string | undefined;
    masterName!: string | undefined;
    status!: string | undefined;
    type!: string | undefined;
    isSystem!: boolean | undefined;
    masterNameUnSign!: string | undefined;
    lastModificationTime!: moment.Moment | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditMasterHeaderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.masterCode = data["masterCode"];
            this.masterName = data["masterName"];
            this.status = data["status"];
            this.type = data["type"];
            this.isSystem = data["isSystem"];
            this.masterNameUnSign = data["masterNameUnSign"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditMasterHeaderDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditMasterHeaderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["masterCode"] = this.masterCode;
        data["masterName"] = this.masterName;
        data["status"] = this.status;
        data["type"] = this.type;
        data["isSystem"] = this.isSystem;
        data["masterNameUnSign"] = this.masterNameUnSign;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditMasterHeaderDto {
    masterCode: string | undefined;
    masterName: string | undefined;
    status: string | undefined;
    type: string | undefined;
    isSystem: boolean | undefined;
    masterNameUnSign: string | undefined;
    lastModificationTime: moment.Moment | undefined;
    id: number | undefined;
}

export class GetAllMasterHeadersInput implements IGetAllMasterHeadersInput {
    filter!: string | undefined;
    masterCodeFilter!: string | undefined;
    masterNameFilter!: string | undefined;
    statusFilter!: string | undefined;
    typeFilter!: string | undefined;
    isSystemFilter!: number | undefined;
    sorting!: string | undefined;
    skipCount!: number | undefined;
    maxResultCount!: number | undefined;

    constructor(data?: IGetAllMasterHeadersInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.filter = data["filter"];
            this.masterCodeFilter = data["masterCodeFilter"];
            this.masterNameFilter = data["masterNameFilter"];
            this.statusFilter = data["statusFilter"];
            this.typeFilter = data["typeFilter"];
            this.isSystemFilter = data["isSystemFilter"];
            this.sorting = data["sorting"];
            this.skipCount = data["skipCount"];
            this.maxResultCount = data["maxResultCount"];
        }
    }

    static fromJS(data: any): GetAllMasterHeadersInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllMasterHeadersInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        data["masterCodeFilter"] = this.masterCodeFilter;
        data["masterNameFilter"] = this.masterNameFilter;
        data["statusFilter"] = this.statusFilter;
        data["typeFilter"] = this.typeFilter;
        data["isSystemFilter"] = this.isSystemFilter;
        data["sorting"] = this.sorting;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data;
    }
}

export interface IGetAllMasterHeadersInput {
    filter: string | undefined;
    masterCodeFilter: string | undefined;
    masterNameFilter: string | undefined;
    statusFilter: string | undefined;
    typeFilter: string | undefined;
    isSystemFilter: number | undefined;
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;
}

export class MemberLoginFbInput implements IMemberLoginFbInput {
    facebookId!: string;
    hashKey!: string;

    constructor(data?: IMemberLoginFbInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.facebookId = data["facebookId"];
            this.hashKey = data["hashKey"];
        }
    }

    static fromJS(data: any): MemberLoginFbInput {
        data = typeof data === 'object' ? data : {};
        let result = new MemberLoginFbInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["facebookId"] = this.facebookId;
        data["hashKey"] = this.hashKey;
        return data;
    }
}

export interface IMemberLoginFbInput {
    facebookId: string;
    hashKey: string;
}

export class MemberLoginResult implements IMemberLoginResult {
    memberCode!: string | undefined;
    memberShipCard!: string | undefined;
    accessToken!: string | undefined;
    encryptedAccessToken!: string | undefined;
    expireInSeconds!: number | undefined;
    id!: number | undefined;
    currentDatetime!: moment.Moment | undefined;

    constructor(data?: IMemberLoginResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberCode = data["memberCode"];
            this.memberShipCard = data["memberShipCard"];
            this.accessToken = data["accessToken"];
            this.encryptedAccessToken = data["encryptedAccessToken"];
            this.expireInSeconds = data["expireInSeconds"];
            this.id = data["id"];
            this.currentDatetime = data["currentDatetime"] ? moment(data["currentDatetime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): MemberLoginResult {
        data = typeof data === 'object' ? data : {};
        let result = new MemberLoginResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberCode"] = this.memberCode;
        data["memberShipCard"] = this.memberShipCard;
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        data["id"] = this.id;
        data["currentDatetime"] = this.currentDatetime ? this.currentDatetime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IMemberLoginResult {
    memberCode: string | undefined;
    memberShipCard: string | undefined;
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number | undefined;
    id: number | undefined;
    currentDatetime: moment.Moment | undefined;
}

export class MemberLoginByGoogleInput implements IMemberLoginByGoogleInput {
    googleId!: string;
    hashKey!: string;

    constructor(data?: IMemberLoginByGoogleInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.googleId = data["googleId"];
            this.hashKey = data["hashKey"];
        }
    }

    static fromJS(data: any): MemberLoginByGoogleInput {
        data = typeof data === 'object' ? data : {};
        let result = new MemberLoginByGoogleInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["googleId"] = this.googleId;
        data["hashKey"] = this.hashKey;
        return data;
    }
}

export interface IMemberLoginByGoogleInput {
    googleId: string;
    hashKey: string;
}

export class MemberSendOTPViaEmailInput implements IMemberSendOTPViaEmailInput {
    email!: string | undefined;

    constructor(data?: IMemberSendOTPViaEmailInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.email = data["email"];
        }
    }

    static fromJS(data: any): MemberSendOTPViaEmailInput {
        data = typeof data === 'object' ? data : {};
        let result = new MemberSendOTPViaEmailInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        return data;
    }
}

export interface IMemberSendOTPViaEmailInput {
    email: string | undefined;
}

export class MemberSendOTPViaPhoneNumberInput implements IMemberSendOTPViaPhoneNumberInput {
    phoneNumber!: string | undefined;

    constructor(data?: IMemberSendOTPViaPhoneNumberInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.phoneNumber = data["phoneNumber"];
        }
    }

    static fromJS(data: any): MemberSendOTPViaPhoneNumberInput {
        data = typeof data === 'object' ? data : {};
        let result = new MemberSendOTPViaPhoneNumberInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phoneNumber"] = this.phoneNumber;
        return data;
    }
}

export interface IMemberSendOTPViaPhoneNumberInput {
    phoneNumber: string | undefined;
}

export class MemberLoginOTPViaPhoneNumberInput implements IMemberLoginOTPViaPhoneNumberInput {
    phoneNumber!: string | undefined;
    otpToken!: string | undefined;

    constructor(data?: IMemberLoginOTPViaPhoneNumberInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.phoneNumber = data["phoneNumber"];
            this.otpToken = data["otpToken"];
        }
    }

    static fromJS(data: any): MemberLoginOTPViaPhoneNumberInput {
        data = typeof data === 'object' ? data : {};
        let result = new MemberLoginOTPViaPhoneNumberInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phoneNumber"] = this.phoneNumber;
        data["otpToken"] = this.otpToken;
        return data;
    }
}

export interface IMemberLoginOTPViaPhoneNumberInput {
    phoneNumber: string | undefined;
    otpToken: string | undefined;
}

export class MemberLoginOTPViaPhoneNumberInputDto implements IMemberLoginOTPViaPhoneNumberInputDto {
    password!: string | undefined;
    memberShipCard!: string | undefined;
    phoneNumber!: string | undefined;
    otpToken!: string | undefined;

    constructor(data?: IMemberLoginOTPViaPhoneNumberInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.password = data["password"];
            this.memberShipCard = data["memberShipCard"];
            this.phoneNumber = data["phoneNumber"];
            this.otpToken = data["otpToken"];
        }
    }

    static fromJS(data: any): MemberLoginOTPViaPhoneNumberInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new MemberLoginOTPViaPhoneNumberInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["password"] = this.password;
        data["memberShipCard"] = this.memberShipCard;
        data["phoneNumber"] = this.phoneNumber;
        data["otpToken"] = this.otpToken;
        return data;
    }
}

export interface IMemberLoginOTPViaPhoneNumberInputDto {
    password: string | undefined;
    memberShipCard: string | undefined;
    phoneNumber: string | undefined;
    otpToken: string | undefined;
}

export class MemberLoginOTPViaEmailInput implements IMemberLoginOTPViaEmailInput {
    email!: string | undefined;
    otpToken!: string | undefined;

    constructor(data?: IMemberLoginOTPViaEmailInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.email = data["email"];
            this.otpToken = data["otpToken"];
        }
    }

    static fromJS(data: any): MemberLoginOTPViaEmailInput {
        data = typeof data === 'object' ? data : {};
        let result = new MemberLoginOTPViaEmailInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["otpToken"] = this.otpToken;
        return data;
    }
}

export interface IMemberLoginOTPViaEmailInput {
    email: string | undefined;
    otpToken: string | undefined;
}

export class MapingMembershipDto implements IMapingMembershipDto {
    memberCode!: string | undefined;
    accountType!: string | undefined;
    accountInfomation!: string | undefined;

    constructor(data?: IMapingMembershipDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberCode = data["memberCode"];
            this.accountType = data["accountType"];
            this.accountInfomation = data["accountInfomation"];
        }
    }

    static fromJS(data: any): MapingMembershipDto {
        data = typeof data === 'object' ? data : {};
        let result = new MapingMembershipDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberCode"] = this.memberCode;
        data["accountType"] = this.accountType;
        data["accountInfomation"] = this.accountInfomation;
        return data;
    }
}

export interface IMapingMembershipDto {
    memberCode: string | undefined;
    accountType: string | undefined;
    accountInfomation: string | undefined;
}

export class LinkMemberInput implements ILinkMemberInput {
    memberShipCard!: string | undefined;

    constructor(data?: ILinkMemberInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberShipCard = data["memberShipCard"];
        }
    }

    static fromJS(data: any): LinkMemberInput {
        data = typeof data === 'object' ? data : {};
        let result = new LinkMemberInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberShipCard"] = this.memberShipCard;
        return data;
    }
}

export interface ILinkMemberInput {
    memberShipCard: string | undefined;
}

export class LinkMemberConfirmDto implements ILinkMemberConfirmDto {
    phoneNumber!: string | undefined;

    constructor(data?: ILinkMemberConfirmDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.phoneNumber = data["phoneNumber"];
        }
    }

    static fromJS(data: any): LinkMemberConfirmDto {
        data = typeof data === 'object' ? data : {};
        let result = new LinkMemberConfirmDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phoneNumber"] = this.phoneNumber;
        return data;
    }
}

export interface ILinkMemberConfirmDto {
    phoneNumber: string | undefined;
}

export class LinkMemberConfirmInput implements ILinkMemberConfirmInput {
    loginProvider!: string | undefined;
    accountInfomation!: string | undefined;
    otpToken!: string | undefined;
    phoneNumber!: string | undefined;
    memberShipCard!: string | undefined;

    constructor(data?: ILinkMemberConfirmInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.loginProvider = data["loginProvider"];
            this.accountInfomation = data["accountInfomation"];
            this.otpToken = data["otpToken"];
            this.phoneNumber = data["phoneNumber"];
            this.memberShipCard = data["memberShipCard"];
        }
    }

    static fromJS(data: any): LinkMemberConfirmInput {
        data = typeof data === 'object' ? data : {};
        let result = new LinkMemberConfirmInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["loginProvider"] = this.loginProvider;
        data["accountInfomation"] = this.accountInfomation;
        data["otpToken"] = this.otpToken;
        data["phoneNumber"] = this.phoneNumber;
        data["memberShipCard"] = this.memberShipCard;
        return data;
    }
}

export interface ILinkMemberConfirmInput {
    loginProvider: string | undefined;
    accountInfomation: string | undefined;
    otpToken: string | undefined;
    phoneNumber: string | undefined;
    memberShipCard: string | undefined;
}

export class MemberChannelInformationDto implements IMemberChannelInformationDto {
    memberCode!: string | undefined;
    channelCode!: string | undefined;
    memberChannelId!: string | undefined;
    appId!: string | undefined;
    appVersion!: string | undefined;
    systemOS!: string | undefined;

    constructor(data?: IMemberChannelInformationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberCode = data["memberCode"];
            this.channelCode = data["channelCode"];
            this.memberChannelId = data["memberChannelId"];
            this.appId = data["appId"];
            this.appVersion = data["appVersion"];
            this.systemOS = data["systemOS"];
        }
    }

    static fromJS(data: any): MemberChannelInformationDto {
        data = typeof data === 'object' ? data : {};
        let result = new MemberChannelInformationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberCode"] = this.memberCode;
        data["channelCode"] = this.channelCode;
        data["memberChannelId"] = this.memberChannelId;
        data["appId"] = this.appId;
        data["appVersion"] = this.appVersion;
        data["systemOS"] = this.systemOS;
        return data;
    }
}

export interface IMemberChannelInformationDto {
    memberCode: string | undefined;
    channelCode: string | undefined;
    memberChannelId: string | undefined;
    appId: string | undefined;
    appVersion: string | undefined;
    systemOS: string | undefined;
}

export class ValidateMemberInformation implements IValidateMemberInformation {
    phoneNumber!: string | undefined;
    memberShipCard!: string | undefined;
    password!: string | undefined;
    confirmPassword!: string | undefined;

    constructor(data?: IValidateMemberInformation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.phoneNumber = data["phoneNumber"];
            this.memberShipCard = data["memberShipCard"];
            this.password = data["password"];
            this.confirmPassword = data["confirmPassword"];
        }
    }

    static fromJS(data: any): ValidateMemberInformation {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateMemberInformation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phoneNumber"] = this.phoneNumber;
        data["memberShipCard"] = this.memberShipCard;
        data["password"] = this.password;
        data["confirmPassword"] = this.confirmPassword;
        return data;
    }
}

export interface IValidateMemberInformation {
    phoneNumber: string | undefined;
    memberShipCard: string | undefined;
    password: string | undefined;
    confirmPassword: string | undefined;
}

export class MemberLoginDto implements IMemberLoginDto {
    phoneNumber!: string | undefined;
    password!: string | undefined;

    constructor(data?: IMemberLoginDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.phoneNumber = data["phoneNumber"];
            this.password = data["password"];
        }
    }

    static fromJS(data: any): MemberLoginDto {
        data = typeof data === 'object' ? data : {};
        let result = new MemberLoginDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phoneNumber"] = this.phoneNumber;
        data["password"] = this.password;
        return data;
    }
}

export interface IMemberLoginDto {
    phoneNumber: string | undefined;
    password: string | undefined;
}

export class LinkMemberOTP implements ILinkMemberOTP {
    phoneNumber!: string | undefined;
    memberShipCard!: string | undefined;
    password!: string | undefined;
    confirmPassword!: string | undefined;
    otpToken!: string | undefined;

    constructor(data?: ILinkMemberOTP) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.phoneNumber = data["phoneNumber"];
            this.memberShipCard = data["memberShipCard"];
            this.password = data["password"];
            this.confirmPassword = data["confirmPassword"];
            this.otpToken = data["otpToken"];
        }
    }

    static fromJS(data: any): LinkMemberOTP {
        data = typeof data === 'object' ? data : {};
        let result = new LinkMemberOTP();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phoneNumber"] = this.phoneNumber;
        data["memberShipCard"] = this.memberShipCard;
        data["password"] = this.password;
        data["confirmPassword"] = this.confirmPassword;
        data["otpToken"] = this.otpToken;
        return data;
    }
}

export interface ILinkMemberOTP {
    phoneNumber: string | undefined;
    memberShipCard: string | undefined;
    password: string | undefined;
    confirmPassword: string | undefined;
    otpToken: string | undefined;
}

export class ChangePasswordDto implements IChangePasswordDto {
    phoneNumber!: string | undefined;
    password!: string | undefined;
    confirmPassword!: string | undefined;

    constructor(data?: IChangePasswordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.phoneNumber = data["phoneNumber"];
            this.password = data["password"];
            this.confirmPassword = data["confirmPassword"];
        }
    }

    static fromJS(data: any): ChangePasswordDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phoneNumber"] = this.phoneNumber;
        data["password"] = this.password;
        data["confirmPassword"] = this.confirmPassword;
        return data;
    }
}

export interface IChangePasswordDto {
    phoneNumber: string | undefined;
    password: string | undefined;
    confirmPassword: string | undefined;
}

export class VerifyPasswordForViewProfileDto implements IVerifyPasswordForViewProfileDto {
    memberShipCard!: string | undefined;
    password!: string | undefined;

    constructor(data?: IVerifyPasswordForViewProfileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberShipCard = data["memberShipCard"];
            this.password = data["password"];
        }
    }

    static fromJS(data: any): VerifyPasswordForViewProfileDto {
        data = typeof data === 'object' ? data : {};
        let result = new VerifyPasswordForViewProfileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberShipCard"] = this.memberShipCard;
        data["password"] = this.password;
        return data;
    }
}

export interface IVerifyPasswordForViewProfileDto {
    memberShipCard: string | undefined;
    password: string | undefined;
}

export class ChangePasswordForViewProfileDto implements IChangePasswordForViewProfileDto {
    memberShipCard!: string | undefined;
    confirmPassword!: string | undefined;
    password!: string | undefined;

    constructor(data?: IChangePasswordForViewProfileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberShipCard = data["memberShipCard"];
            this.confirmPassword = data["confirmPassword"];
            this.password = data["password"];
        }
    }

    static fromJS(data: any): ChangePasswordForViewProfileDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordForViewProfileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberShipCard"] = this.memberShipCard;
        data["confirmPassword"] = this.confirmPassword;
        data["password"] = this.password;
        return data;
    }
}

export interface IChangePasswordForViewProfileDto {
    memberShipCard: string | undefined;
    confirmPassword: string | undefined;
    password: string | undefined;
}

export class PagedResultDtoOfGetMemberActivityRuleForView implements IPagedResultDtoOfGetMemberActivityRuleForView {
    totalCount!: number | undefined;
    items!: GetMemberActivityRuleForView[] | undefined;

    constructor(data?: IPagedResultDtoOfGetMemberActivityRuleForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetMemberActivityRuleForView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetMemberActivityRuleForView {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetMemberActivityRuleForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetMemberActivityRuleForView {
    totalCount: number | undefined;
    items: GetMemberActivityRuleForView[] | undefined;
}

export class GetMemberActivityRuleForView implements IGetMemberActivityRuleForView {
    memberActivityRule!: MemberActivityRuleDto | undefined;

    constructor(data?: IGetMemberActivityRuleForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberActivityRule = data["memberActivityRule"] ? MemberActivityRuleDto.fromJS(data["memberActivityRule"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetMemberActivityRuleForView {
        data = typeof data === 'object' ? data : {};
        let result = new GetMemberActivityRuleForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberActivityRule"] = this.memberActivityRule ? this.memberActivityRule.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetMemberActivityRuleForView {
    memberActivityRule: MemberActivityRuleDto | undefined;
}

export class MemberActivityRuleDto implements IMemberActivityRuleDto {
    isActive!: boolean | undefined;
    source!: string | undefined;
    memberStatus!: string | undefined;
    type!: string | undefined;
    value!: boolean | undefined;
    id!: number | undefined;

    constructor(data?: IMemberActivityRuleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isActive = data["isActive"];
            this.source = data["source"];
            this.memberStatus = data["memberStatus"];
            this.type = data["type"];
            this.value = data["value"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): MemberActivityRuleDto {
        data = typeof data === 'object' ? data : {};
        let result = new MemberActivityRuleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isActive"] = this.isActive;
        data["source"] = this.source;
        data["memberStatus"] = this.memberStatus;
        data["type"] = this.type;
        data["value"] = this.value;
        data["id"] = this.id;
        return data;
    }
}

export interface IMemberActivityRuleDto {
    isActive: boolean | undefined;
    source: string | undefined;
    memberStatus: string | undefined;
    type: string | undefined;
    value: boolean | undefined;
    id: number | undefined;
}

export class GetMemberActivityRuleForEditOutput implements IGetMemberActivityRuleForEditOutput {
    memberActivityRule!: CreateOrEditMemberActivityRuleDto | undefined;

    constructor(data?: IGetMemberActivityRuleForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberActivityRule = data["memberActivityRule"] ? CreateOrEditMemberActivityRuleDto.fromJS(data["memberActivityRule"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetMemberActivityRuleForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetMemberActivityRuleForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberActivityRule"] = this.memberActivityRule ? this.memberActivityRule.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetMemberActivityRuleForEditOutput {
    memberActivityRule: CreateOrEditMemberActivityRuleDto | undefined;
}

export class CreateOrEditMemberActivityRuleDto implements ICreateOrEditMemberActivityRuleDto {
    isActive!: boolean | undefined;
    source!: string | undefined;
    memberStatus!: string | undefined;
    type!: string | undefined;
    value!: boolean | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditMemberActivityRuleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isActive = data["isActive"];
            this.source = data["source"];
            this.memberStatus = data["memberStatus"];
            this.type = data["type"];
            this.value = data["value"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditMemberActivityRuleDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditMemberActivityRuleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isActive"] = this.isActive;
        data["source"] = this.source;
        data["memberStatus"] = this.memberStatus;
        data["type"] = this.type;
        data["value"] = this.value;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditMemberActivityRuleDto {
    isActive: boolean | undefined;
    source: string | undefined;
    memberStatus: string | undefined;
    type: string | undefined;
    value: boolean | undefined;
    id: number | undefined;
}

export class CheckActivityOfMemberDto implements ICheckActivityOfMemberDto {
    memberStatus!: string | undefined;
    type!: string | undefined;

    constructor(data?: ICheckActivityOfMemberDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberStatus = data["memberStatus"];
            this.type = data["type"];
        }
    }

    static fromJS(data: any): CheckActivityOfMemberDto {
        data = typeof data === 'object' ? data : {};
        let result = new CheckActivityOfMemberDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberStatus"] = this.memberStatus;
        data["type"] = this.type;
        return data;
    }
}

export interface ICheckActivityOfMemberDto {
    memberStatus: string | undefined;
    type: string | undefined;
}

export class PagedResultDtoOfGetSecondaryCustomerInfoForView implements IPagedResultDtoOfGetSecondaryCustomerInfoForView {
    totalCount!: number | undefined;
    items!: GetSecondaryCustomerInfoForView[] | undefined;

    constructor(data?: IPagedResultDtoOfGetSecondaryCustomerInfoForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetSecondaryCustomerInfoForView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetSecondaryCustomerInfoForView {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetSecondaryCustomerInfoForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetSecondaryCustomerInfoForView {
    totalCount: number | undefined;
    items: GetSecondaryCustomerInfoForView[] | undefined;
}

export class GetSecondaryCustomerInfoForView implements IGetSecondaryCustomerInfoForView {
    secondaryCustomerInfo!: SecondaryCustomerInfoDto | undefined;

    constructor(data?: IGetSecondaryCustomerInfoForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.secondaryCustomerInfo = data["secondaryCustomerInfo"] ? SecondaryCustomerInfoDto.fromJS(data["secondaryCustomerInfo"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSecondaryCustomerInfoForView {
        data = typeof data === 'object' ? data : {};
        let result = new GetSecondaryCustomerInfoForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["secondaryCustomerInfo"] = this.secondaryCustomerInfo ? this.secondaryCustomerInfo.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetSecondaryCustomerInfoForView {
    secondaryCustomerInfo: SecondaryCustomerInfoDto | undefined;
}

export class SecondaryCustomerInfoDto implements ISecondaryCustomerInfoDto {
    memberCode!: string | undefined;
    point!: number | undefined;
    coin!: number | undefined;
    rankId!: number | undefined;
    rank!: RankDto | undefined;
    tempRankId!: number | undefined;
    tempRank!: RankDto | undefined;
    expiringCoin!: number | undefined;
    pointToNextTempRank!: number | undefined;
    pointToKeepRank!: number | undefined;
    tempPoint!: number | undefined;
    departmentLevel1!: string | undefined;
    id!: number | undefined;

    constructor(data?: ISecondaryCustomerInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberCode = data["memberCode"];
            this.point = data["point"];
            this.coin = data["coin"];
            this.rankId = data["rankId"];
            this.rank = data["rank"] ? RankDto.fromJS(data["rank"]) : <any>undefined;
            this.tempRankId = data["tempRankId"];
            this.tempRank = data["tempRank"] ? RankDto.fromJS(data["tempRank"]) : <any>undefined;
            this.expiringCoin = data["expiringCoin"];
            this.pointToNextTempRank = data["pointToNextTempRank"];
            this.pointToKeepRank = data["pointToKeepRank"];
            this.tempPoint = data["tempPoint"];
            this.departmentLevel1 = data["departmentLevel1"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SecondaryCustomerInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new SecondaryCustomerInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberCode"] = this.memberCode;
        data["point"] = this.point;
        data["coin"] = this.coin;
        data["rankId"] = this.rankId;
        data["rank"] = this.rank ? this.rank.toJSON() : <any>undefined;
        data["tempRankId"] = this.tempRankId;
        data["tempRank"] = this.tempRank ? this.tempRank.toJSON() : <any>undefined;
        data["expiringCoin"] = this.expiringCoin;
        data["pointToNextTempRank"] = this.pointToNextTempRank;
        data["pointToKeepRank"] = this.pointToKeepRank;
        data["tempPoint"] = this.tempPoint;
        data["departmentLevel1"] = this.departmentLevel1;
        data["id"] = this.id;
        return data;
    }
}

export interface ISecondaryCustomerInfoDto {
    memberCode: string | undefined;
    point: number | undefined;
    coin: number | undefined;
    rankId: number | undefined;
    rank: RankDto | undefined;
    tempRankId: number | undefined;
    tempRank: RankDto | undefined;
    expiringCoin: number | undefined;
    pointToNextTempRank: number | undefined;
    pointToKeepRank: number | undefined;
    tempPoint: number | undefined;
    departmentLevel1: string | undefined;
    id: number | undefined;
}

export class RankDto implements IRankDto {
    code!: string | undefined;
    name!: string | undefined;
    description!: string | undefined;
    avatar!: string | undefined;
    isActive!: boolean | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    lastModifierUserName!: string | undefined;
    id!: number | undefined;

    constructor(data?: IRankDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.name = data["name"];
            this.description = data["description"];
            this.avatar = data["avatar"];
            this.isActive = data["isActive"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.lastModifierUserName = data["lastModifierUserName"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): RankDto {
        data = typeof data === 'object' ? data : {};
        let result = new RankDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["description"] = this.description;
        data["avatar"] = this.avatar;
        data["isActive"] = this.isActive;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModifierUserName"] = this.lastModifierUserName;
        data["id"] = this.id;
        return data;
    }
}

export interface IRankDto {
    code: string | undefined;
    name: string | undefined;
    description: string | undefined;
    avatar: string | undefined;
    isActive: boolean | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    lastModifierUserName: string | undefined;
    id: number | undefined;
}

export class GetSecondaryCustomerInfoForEditOutput implements IGetSecondaryCustomerInfoForEditOutput {
    secondaryCustomerInfo!: CreateOrEditSecondaryCustomerInfoDto | undefined;

    constructor(data?: IGetSecondaryCustomerInfoForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.secondaryCustomerInfo = data["secondaryCustomerInfo"] ? CreateOrEditSecondaryCustomerInfoDto.fromJS(data["secondaryCustomerInfo"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSecondaryCustomerInfoForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetSecondaryCustomerInfoForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["secondaryCustomerInfo"] = this.secondaryCustomerInfo ? this.secondaryCustomerInfo.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetSecondaryCustomerInfoForEditOutput {
    secondaryCustomerInfo: CreateOrEditSecondaryCustomerInfoDto | undefined;
}

export class CreateOrEditSecondaryCustomerInfoDto implements ICreateOrEditSecondaryCustomerInfoDto {
    memberCode!: string;
    point!: number;
    coin!: number;
    rankId!: number;
    tempRankId!: number;
    rankValidTo!: moment.Moment;
    tempPoint!: number | undefined;
    departmentLevel1!: string;
    isDeleted!: boolean | undefined;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: moment.Moment | undefined;
    creatorUserId!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditSecondaryCustomerInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberCode = data["memberCode"];
            this.point = data["point"];
            this.coin = data["coin"];
            this.rankId = data["rankId"];
            this.tempRankId = data["tempRankId"];
            this.rankValidTo = data["rankValidTo"] ? moment(data["rankValidTo"].toString()) : <any>undefined;
            this.tempPoint = data["tempPoint"];
            this.departmentLevel1 = data["departmentLevel1"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditSecondaryCustomerInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditSecondaryCustomerInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberCode"] = this.memberCode;
        data["point"] = this.point;
        data["coin"] = this.coin;
        data["rankId"] = this.rankId;
        data["tempRankId"] = this.tempRankId;
        data["rankValidTo"] = this.rankValidTo ? this.rankValidTo.toISOString() : <any>undefined;
        data["tempPoint"] = this.tempPoint;
        data["departmentLevel1"] = this.departmentLevel1;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditSecondaryCustomerInfoDto {
    memberCode: string;
    point: number;
    coin: number;
    rankId: number;
    tempRankId: number;
    rankValidTo: moment.Moment;
    tempPoint: number | undefined;
    departmentLevel1: string;
    isDeleted: boolean | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class RegisterMemberDto implements IRegisterMemberDto {
    phone!: string | undefined;
    zaloChatID!: string | undefined;
    firstName!: string | undefined;
    lastName!: string | undefined;
    email!: string | undefined;
    birthday!: number | undefined;
    gender!: string | undefined;
    fullRegionCode!: string | undefined;
    address!: string | undefined;
    rankCode!: string | undefined;
    interestOf!: string | undefined;

    constructor(data?: IRegisterMemberDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.phone = data["phone"];
            this.zaloChatID = data["zaloChatID"];
            this.firstName = data["firstName"];
            this.lastName = data["lastName"];
            this.email = data["email"];
            this.birthday = data["birthday"];
            this.gender = data["gender"];
            this.fullRegionCode = data["fullRegionCode"];
            this.address = data["address"];
            this.rankCode = data["rankCode"];
            this.interestOf = data["interestOf"];
        }
    }

    static fromJS(data: any): RegisterMemberDto {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterMemberDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phone"] = this.phone;
        data["zaloChatID"] = this.zaloChatID;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["birthday"] = this.birthday;
        data["gender"] = this.gender;
        data["fullRegionCode"] = this.fullRegionCode;
        data["address"] = this.address;
        data["rankCode"] = this.rankCode;
        data["interestOf"] = this.interestOf;
        return data;
    }
}

export interface IRegisterMemberDto {
    phone: string | undefined;
    zaloChatID: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    email: string | undefined;
    birthday: number | undefined;
    gender: string | undefined;
    fullRegionCode: string | undefined;
    address: string | undefined;
    rankCode: string | undefined;
    interestOf: string | undefined;
}

export class SecondaryCustomerMemberDto implements ISecondaryCustomerMemberDto {
    firstName!: string | undefined;
    lastName!: string | undefined;
    birthday!: moment.Moment | undefined;
    phone!: string | undefined;
    email!: string | undefined;
    regionCode!: string | undefined;
    memberTypeCode!: string | undefined;
    channelType!: string | undefined;
    rankTypeCode!: string | undefined;
    address!: string | undefined;
    gender!: string | undefined;
    cards!: string | undefined;
    isActive!: boolean | undefined;
    status!: string | undefined;
    fullRegionCode!: string | undefined;
    fullMemberTypeCode!: string | undefined;
    fullChannelTypeCode!: string | undefined;
    idCard!: string | undefined;
    memberLoyaltyInfoId!: number | undefined;
    memberLoyaltyInfo!: SecondaryCustomerMemberInfoDto | undefined;
    standardMemberCode!: string | undefined;
    accountType!: string | undefined;
    joiningDate!: moment.Moment | undefined;
    withdrawnDate!: moment.Moment | undefined;
    referenceInfo!: string | undefined;
    source!: string | undefined;
    extraInfo!: string | undefined;
    referralCode!: string | undefined;
    contractCode!: string | undefined;
    isDeleted!: boolean | undefined;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: moment.Moment | undefined;
    creatorUserId!: number | undefined;
    id!: number | undefined;

    constructor(data?: ISecondaryCustomerMemberDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.firstName = data["firstName"];
            this.lastName = data["lastName"];
            this.birthday = data["birthday"] ? moment(data["birthday"].toString()) : <any>undefined;
            this.phone = data["phone"];
            this.email = data["email"];
            this.regionCode = data["regionCode"];
            this.memberTypeCode = data["memberTypeCode"];
            this.channelType = data["channelType"];
            this.rankTypeCode = data["rankTypeCode"];
            this.address = data["address"];
            this.gender = data["gender"];
            this.cards = data["cards"];
            this.isActive = data["isActive"];
            this.status = data["status"];
            this.fullRegionCode = data["fullRegionCode"];
            this.fullMemberTypeCode = data["fullMemberTypeCode"];
            this.fullChannelTypeCode = data["fullChannelTypeCode"];
            this.idCard = data["idCard"];
            this.memberLoyaltyInfoId = data["memberLoyaltyInfoId"];
            this.memberLoyaltyInfo = data["memberLoyaltyInfo"] ? SecondaryCustomerMemberInfoDto.fromJS(data["memberLoyaltyInfo"]) : <any>undefined;
            this.standardMemberCode = data["standardMemberCode"];
            this.accountType = data["accountType"];
            this.joiningDate = data["joiningDate"] ? moment(data["joiningDate"].toString()) : <any>undefined;
            this.withdrawnDate = data["withdrawnDate"] ? moment(data["withdrawnDate"].toString()) : <any>undefined;
            this.referenceInfo = data["referenceInfo"];
            this.source = data["source"];
            this.extraInfo = data["extraInfo"];
            this.referralCode = data["referralCode"];
            this.contractCode = data["contractCode"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SecondaryCustomerMemberDto {
        data = typeof data === 'object' ? data : {};
        let result = new SecondaryCustomerMemberDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["birthday"] = this.birthday ? this.birthday.toISOString() : <any>undefined;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["regionCode"] = this.regionCode;
        data["memberTypeCode"] = this.memberTypeCode;
        data["channelType"] = this.channelType;
        data["rankTypeCode"] = this.rankTypeCode;
        data["address"] = this.address;
        data["gender"] = this.gender;
        data["cards"] = this.cards;
        data["isActive"] = this.isActive;
        data["status"] = this.status;
        data["fullRegionCode"] = this.fullRegionCode;
        data["fullMemberTypeCode"] = this.fullMemberTypeCode;
        data["fullChannelTypeCode"] = this.fullChannelTypeCode;
        data["idCard"] = this.idCard;
        data["memberLoyaltyInfoId"] = this.memberLoyaltyInfoId;
        data["memberLoyaltyInfo"] = this.memberLoyaltyInfo ? this.memberLoyaltyInfo.toJSON() : <any>undefined;
        data["standardMemberCode"] = this.standardMemberCode;
        data["accountType"] = this.accountType;
        data["joiningDate"] = this.joiningDate ? this.joiningDate.toISOString() : <any>undefined;
        data["withdrawnDate"] = this.withdrawnDate ? this.withdrawnDate.toISOString() : <any>undefined;
        data["referenceInfo"] = this.referenceInfo;
        data["source"] = this.source;
        data["extraInfo"] = this.extraInfo;
        data["referralCode"] = this.referralCode;
        data["contractCode"] = this.contractCode;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ISecondaryCustomerMemberDto {
    firstName: string | undefined;
    lastName: string | undefined;
    birthday: moment.Moment | undefined;
    phone: string | undefined;
    email: string | undefined;
    regionCode: string | undefined;
    memberTypeCode: string | undefined;
    channelType: string | undefined;
    rankTypeCode: string | undefined;
    address: string | undefined;
    gender: string | undefined;
    cards: string | undefined;
    isActive: boolean | undefined;
    status: string | undefined;
    fullRegionCode: string | undefined;
    fullMemberTypeCode: string | undefined;
    fullChannelTypeCode: string | undefined;
    idCard: string | undefined;
    memberLoyaltyInfoId: number | undefined;
    memberLoyaltyInfo: SecondaryCustomerMemberInfoDto | undefined;
    standardMemberCode: string | undefined;
    accountType: string | undefined;
    joiningDate: moment.Moment | undefined;
    withdrawnDate: moment.Moment | undefined;
    referenceInfo: string | undefined;
    source: string | undefined;
    extraInfo: string | undefined;
    referralCode: string | undefined;
    contractCode: string | undefined;
    isDeleted: boolean | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class SecondaryCustomerMemberInfoDto implements ISecondaryCustomerMemberInfoDto {
    memberCode!: string | undefined;
    point!: number | undefined;
    coin!: number | undefined;
    tempRankId!: number | undefined;
    tempRank!: RankMemberDto | undefined;
    rankId!: number | undefined;
    rank!: RankMemberDto | undefined;
    rankValidTo!: moment.Moment | undefined;
    source!: string | undefined;
    expiringCoin!: number | undefined;
    pointToNextTempRank!: number | undefined;
    pointToKeepRank!: number | undefined;
    lastRank!: number | undefined;
    isDeleted!: boolean | undefined;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: moment.Moment | undefined;
    creatorUserId!: number | undefined;
    id!: number | undefined;

    constructor(data?: ISecondaryCustomerMemberInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberCode = data["memberCode"];
            this.point = data["point"];
            this.coin = data["coin"];
            this.tempRankId = data["tempRankId"];
            this.tempRank = data["tempRank"] ? RankMemberDto.fromJS(data["tempRank"]) : <any>undefined;
            this.rankId = data["rankId"];
            this.rank = data["rank"] ? RankMemberDto.fromJS(data["rank"]) : <any>undefined;
            this.rankValidTo = data["rankValidTo"] ? moment(data["rankValidTo"].toString()) : <any>undefined;
            this.source = data["source"];
            this.expiringCoin = data["expiringCoin"];
            this.pointToNextTempRank = data["pointToNextTempRank"];
            this.pointToKeepRank = data["pointToKeepRank"];
            this.lastRank = data["lastRank"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SecondaryCustomerMemberInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new SecondaryCustomerMemberInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberCode"] = this.memberCode;
        data["point"] = this.point;
        data["coin"] = this.coin;
        data["tempRankId"] = this.tempRankId;
        data["tempRank"] = this.tempRank ? this.tempRank.toJSON() : <any>undefined;
        data["rankId"] = this.rankId;
        data["rank"] = this.rank ? this.rank.toJSON() : <any>undefined;
        data["rankValidTo"] = this.rankValidTo ? this.rankValidTo.toISOString() : <any>undefined;
        data["source"] = this.source;
        data["expiringCoin"] = this.expiringCoin;
        data["pointToNextTempRank"] = this.pointToNextTempRank;
        data["pointToKeepRank"] = this.pointToKeepRank;
        data["lastRank"] = this.lastRank;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ISecondaryCustomerMemberInfoDto {
    memberCode: string | undefined;
    point: number | undefined;
    coin: number | undefined;
    tempRankId: number | undefined;
    tempRank: RankMemberDto | undefined;
    rankId: number | undefined;
    rank: RankMemberDto | undefined;
    rankValidTo: moment.Moment | undefined;
    source: string | undefined;
    expiringCoin: number | undefined;
    pointToNextTempRank: number | undefined;
    pointToKeepRank: number | undefined;
    lastRank: number | undefined;
    isDeleted: boolean | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class RankMemberDto implements IRankMemberDto {
    code!: string | undefined;
    name!: string | undefined;
    description!: string | undefined;
    avatar!: string | undefined;
    isActive!: boolean | undefined;
    source!: string | undefined;
    isDeleted!: boolean | undefined;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: moment.Moment | undefined;
    creatorUserId!: number | undefined;
    id!: number | undefined;

    constructor(data?: IRankMemberDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.name = data["name"];
            this.description = data["description"];
            this.avatar = data["avatar"];
            this.isActive = data["isActive"];
            this.source = data["source"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): RankMemberDto {
        data = typeof data === 'object' ? data : {};
        let result = new RankMemberDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["description"] = this.description;
        data["avatar"] = this.avatar;
        data["isActive"] = this.isActive;
        data["source"] = this.source;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IRankMemberDto {
    code: string | undefined;
    name: string | undefined;
    description: string | undefined;
    avatar: string | undefined;
    isActive: boolean | undefined;
    source: string | undefined;
    isDeleted: boolean | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class MemberInfoDto implements IMemberInfoDto {
    phoneNumber!: string | undefined;
    password!: string | undefined;

    constructor(data?: IMemberInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.phoneNumber = data["phoneNumber"];
            this.password = data["password"];
        }
    }

    static fromJS(data: any): MemberInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new MemberInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phoneNumber"] = this.phoneNumber;
        data["password"] = this.password;
        return data;
    }
}

export interface IMemberInfoDto {
    phoneNumber: string | undefined;
    password: string | undefined;
}

export class MemberInfoResult implements IMemberInfoResult {
    memberCode!: string | undefined;
    accessToken!: string | undefined;
    encryptedAccessToken!: string | undefined;

    constructor(data?: IMemberInfoResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberCode = data["memberCode"];
            this.accessToken = data["accessToken"];
            this.encryptedAccessToken = data["encryptedAccessToken"];
        }
    }

    static fromJS(data: any): MemberInfoResult {
        data = typeof data === 'object' ? data : {};
        let result = new MemberInfoResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberCode"] = this.memberCode;
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        return data;
    }
}

export interface IMemberInfoResult {
    memberCode: string | undefined;
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
}

export class MemberChangePasswordDto implements IMemberChangePasswordDto {
    phoneNumber!: string | undefined;
    password!: string | undefined;
    confirmPassword!: string | undefined;

    constructor(data?: IMemberChangePasswordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.phoneNumber = data["phoneNumber"];
            this.password = data["password"];
            this.confirmPassword = data["confirmPassword"];
        }
    }

    static fromJS(data: any): MemberChangePasswordDto {
        data = typeof data === 'object' ? data : {};
        let result = new MemberChangePasswordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phoneNumber"] = this.phoneNumber;
        data["password"] = this.password;
        data["confirmPassword"] = this.confirmPassword;
        return data;
    }
}

export interface IMemberChangePasswordDto {
    phoneNumber: string | undefined;
    password: string | undefined;
    confirmPassword: string | undefined;
}

export class MemberRankOverviewReportOutput implements IMemberRankOverviewReportOutput {
    data!: MemberRankOverviewReportDto[] | undefined;

    constructor(data?: IMemberRankOverviewReportOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["data"] && data["data"].constructor === Array) {
                this.data = [];
                for (let item of data["data"])
                    this.data.push(MemberRankOverviewReportDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MemberRankOverviewReportOutput {
        data = typeof data === 'object' ? data : {};
        let result = new MemberRankOverviewReportOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.data && this.data.constructor === Array) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMemberRankOverviewReportOutput {
    data: MemberRankOverviewReportDto[] | undefined;
}

export class MemberRankOverviewReportDto implements IMemberRankOverviewReportDto {
    rankName!: string | undefined;
    rankID!: number | undefined;
    expiringCoin!: number | undefined;
    calculateDate!: moment.Moment | undefined;

    constructor(data?: IMemberRankOverviewReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.rankName = data["rankName"];
            this.rankID = data["rankID"];
            this.expiringCoin = data["expiringCoin"];
            this.calculateDate = data["calculateDate"] ? moment(data["calculateDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): MemberRankOverviewReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new MemberRankOverviewReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rankName"] = this.rankName;
        data["rankID"] = this.rankID;
        data["expiringCoin"] = this.expiringCoin;
        data["calculateDate"] = this.calculateDate ? this.calculateDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IMemberRankOverviewReportDto {
    rankName: string | undefined;
    rankID: number | undefined;
    expiringCoin: number | undefined;
    calculateDate: moment.Moment | undefined;
}

export class PagedResultDtoOfGetReasonDto implements IPagedResultDtoOfGetReasonDto {
    totalCount!: number | undefined;
    items!: GetReasonDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetReasonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetReasonDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetReasonDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetReasonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetReasonDto {
    totalCount: number | undefined;
    items: GetReasonDto[] | undefined;
}

export class GetReasonDto implements IGetReasonDto {
    reasonCode!: string | undefined;
    reasonName!: string | undefined;

    constructor(data?: IGetReasonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.reasonCode = data["reasonCode"];
            this.reasonName = data["reasonName"];
        }
    }

    static fromJS(data: any): GetReasonDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetReasonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reasonCode"] = this.reasonCode;
        data["reasonName"] = this.reasonName;
        return data;
    }
}

export interface IGetReasonDto {
    reasonCode: string | undefined;
    reasonName: string | undefined;
}

export class PagedResultDtoOfGetMissionForView implements IPagedResultDtoOfGetMissionForView {
    totalCount!: number | undefined;
    items!: GetMissionForView[] | undefined;

    constructor(data?: IPagedResultDtoOfGetMissionForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetMissionForView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetMissionForView {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetMissionForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetMissionForView {
    totalCount: number | undefined;
    items: GetMissionForView[] | undefined;
}

export class GetMissionForView implements IGetMissionForView {
    mission!: MissionDto | undefined;

    constructor(data?: IGetMissionForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.mission = data["mission"] ? MissionDto.fromJS(data["mission"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetMissionForView {
        data = typeof data === 'object' ? data : {};
        let result = new GetMissionForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mission"] = this.mission ? this.mission.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetMissionForView {
    mission: MissionDto | undefined;
}

export class MissionDto implements IMissionDto {
    code!: string | undefined;
    name!: string | undefined;
    ordinal!: number | undefined;
    description!: string | undefined;
    avatar!: string | undefined;
    linkAvatar!: string | undefined;
    target!: number | undefined;
    coin!: number | undefined;
    point!: number | undefined;
    status!: string | undefined;
    state!: string | undefined;
    date!: moment.Moment | undefined;
    difference!: number | undefined;
    progress!: string | undefined;
    isClaimable!: boolean | undefined;
    id!: number | undefined;

    constructor(data?: IMissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.name = data["name"];
            this.ordinal = data["ordinal"];
            this.description = data["description"];
            this.avatar = data["avatar"];
            this.linkAvatar = data["linkAvatar"];
            this.target = data["target"];
            this.coin = data["coin"];
            this.point = data["point"];
            this.status = data["status"];
            this.state = data["state"];
            this.date = data["date"] ? moment(data["date"].toString()) : <any>undefined;
            this.difference = data["difference"];
            this.progress = data["progress"];
            this.isClaimable = data["isClaimable"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): MissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new MissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["ordinal"] = this.ordinal;
        data["description"] = this.description;
        data["avatar"] = this.avatar;
        data["linkAvatar"] = this.linkAvatar;
        data["target"] = this.target;
        data["coin"] = this.coin;
        data["point"] = this.point;
        data["status"] = this.status;
        data["state"] = this.state;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["difference"] = this.difference;
        data["progress"] = this.progress;
        data["isClaimable"] = this.isClaimable;
        data["id"] = this.id;
        return data;
    }
}

export interface IMissionDto {
    code: string | undefined;
    name: string | undefined;
    ordinal: number | undefined;
    description: string | undefined;
    avatar: string | undefined;
    linkAvatar: string | undefined;
    target: number | undefined;
    coin: number | undefined;
    point: number | undefined;
    status: string | undefined;
    state: string | undefined;
    date: moment.Moment | undefined;
    difference: number | undefined;
    progress: string | undefined;
    isClaimable: boolean | undefined;
    id: number | undefined;
}

export class ClaimMissionInputDto implements IClaimMissionInputDto {
    memberCode!: string;
    questCode!: string;
    missionCode!: string;
    state!: string | undefined;

    constructor(data?: IClaimMissionInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberCode = data["memberCode"];
            this.questCode = data["questCode"];
            this.missionCode = data["missionCode"];
            this.state = data["state"];
        }
    }

    static fromJS(data: any): ClaimMissionInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClaimMissionInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberCode"] = this.memberCode;
        data["questCode"] = this.questCode;
        data["missionCode"] = this.missionCode;
        data["state"] = this.state;
        return data;
    }
}

export interface IClaimMissionInputDto {
    memberCode: string;
    questCode: string;
    missionCode: string;
    state: string | undefined;
}

export class ClaimMissionOutputDto implements IClaimMissionOutputDto {
    memberCode!: string | undefined;
    questCode!: string | undefined;
    missionCode!: string | undefined;
    date!: moment.Moment | undefined;
    state!: string | undefined;
    id!: string | undefined;

    constructor(data?: IClaimMissionOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberCode = data["memberCode"];
            this.questCode = data["questCode"];
            this.missionCode = data["missionCode"];
            this.date = data["date"] ? moment(data["date"].toString()) : <any>undefined;
            this.state = data["state"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ClaimMissionOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClaimMissionOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberCode"] = this.memberCode;
        data["questCode"] = this.questCode;
        data["missionCode"] = this.missionCode;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["state"] = this.state;
        data["id"] = this.id;
        return data;
    }
}

export interface IClaimMissionOutputDto {
    memberCode: string | undefined;
    questCode: string | undefined;
    missionCode: string | undefined;
    date: moment.Moment | undefined;
    state: string | undefined;
    id: string | undefined;
}

export class MobileInitialData implements IMobileInitialData {
    tenantId!: number | undefined;
    tenantName!: string | undefined;

    constructor(data?: IMobileInitialData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.tenantName = data["tenantName"];
        }
    }

    static fromJS(data: any): MobileInitialData {
        data = typeof data === 'object' ? data : {};
        let result = new MobileInitialData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["tenantName"] = this.tenantName;
        return data;
    }
}

export interface IMobileInitialData {
    tenantId: number | undefined;
    tenantName: string | undefined;
}

export class NewPaymentTransactionMessageEventData implements INewPaymentTransactionMessageEventData {
    paymentTransaction!: PurchaseTransactionDto | undefined;
    tenantId!: number | undefined;
    userId!: number | undefined;
    maxParallelism!: number | undefined;
    numberOfWorkers!: number | undefined;
    eventTime!: moment.Moment | undefined;
    eventSource!: any | undefined;

    constructor(data?: INewPaymentTransactionMessageEventData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.paymentTransaction = data["paymentTransaction"] ? PurchaseTransactionDto.fromJS(data["paymentTransaction"]) : <any>undefined;
            this.tenantId = data["tenantId"];
            this.userId = data["userId"];
            this.maxParallelism = data["maxParallelism"];
            this.numberOfWorkers = data["numberOfWorkers"];
            this.eventTime = data["eventTime"] ? moment(data["eventTime"].toString()) : <any>undefined;
            this.eventSource = data["eventSource"];
        }
    }

    static fromJS(data: any): NewPaymentTransactionMessageEventData {
        data = typeof data === 'object' ? data : {};
        let result = new NewPaymentTransactionMessageEventData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentTransaction"] = this.paymentTransaction ? this.paymentTransaction.toJSON() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["maxParallelism"] = this.maxParallelism;
        data["numberOfWorkers"] = this.numberOfWorkers;
        data["eventTime"] = this.eventTime ? this.eventTime.toISOString() : <any>undefined;
        data["eventSource"] = this.eventSource;
        return data;
    }
}

export interface INewPaymentTransactionMessageEventData {
    paymentTransaction: PurchaseTransactionDto | undefined;
    tenantId: number | undefined;
    userId: number | undefined;
    maxParallelism: number | undefined;
    numberOfWorkers: number | undefined;
    eventTime: moment.Moment | undefined;
    eventSource: any | undefined;
}

export class PurchaseTransactionDto implements IPurchaseTransactionDto {
    memberCode!: string | undefined;
    standardMemberCode!: string | undefined;
    rankTypeCode!: string | undefined;
    fullMemberTypeCode!: string | undefined;
    fullRegionCode!: string | undefined;
    fullSalesRegionCode!: string | undefined;
    source!: string | undefined;
    reason!: string | undefined;
    salesManCode!: string | undefined;
    businessTime!: moment.Moment;
    originalOrders!: string | undefined;
    ordersCode!: string | undefined;
    totalAmountIncludeTax!: number | undefined;
    totalAmountBeforeTax!: number | undefined;
    totalCalcAmount!: number | undefined;
    totalTaxAmount!: number | undefined;
    totalDetailLine!: number | undefined;
    ordersDetail!: PaymentTransactionDetailDto[] | undefined;

    constructor(data?: IPurchaseTransactionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberCode = data["memberCode"];
            this.standardMemberCode = data["standardMemberCode"];
            this.rankTypeCode = data["rankTypeCode"];
            this.fullMemberTypeCode = data["fullMemberTypeCode"];
            this.fullRegionCode = data["fullRegionCode"];
            this.fullSalesRegionCode = data["fullSalesRegionCode"];
            this.source = data["source"];
            this.reason = data["reason"];
            this.salesManCode = data["salesManCode"];
            this.businessTime = data["businessTime"] ? moment(data["businessTime"].toString()) : <any>undefined;
            this.originalOrders = data["originalOrders"];
            this.ordersCode = data["ordersCode"];
            this.totalAmountIncludeTax = data["totalAmountIncludeTax"];
            this.totalAmountBeforeTax = data["totalAmountBeforeTax"];
            this.totalCalcAmount = data["totalCalcAmount"];
            this.totalTaxAmount = data["totalTaxAmount"];
            this.totalDetailLine = data["totalDetailLine"];
            if (data["ordersDetail"] && data["ordersDetail"].constructor === Array) {
                this.ordersDetail = [];
                for (let item of data["ordersDetail"])
                    this.ordersDetail.push(PaymentTransactionDetailDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PurchaseTransactionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PurchaseTransactionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberCode"] = this.memberCode;
        data["standardMemberCode"] = this.standardMemberCode;
        data["rankTypeCode"] = this.rankTypeCode;
        data["fullMemberTypeCode"] = this.fullMemberTypeCode;
        data["fullRegionCode"] = this.fullRegionCode;
        data["fullSalesRegionCode"] = this.fullSalesRegionCode;
        data["source"] = this.source;
        data["reason"] = this.reason;
        data["salesManCode"] = this.salesManCode;
        data["businessTime"] = this.businessTime ? this.businessTime.toISOString() : <any>undefined;
        data["originalOrders"] = this.originalOrders;
        data["ordersCode"] = this.ordersCode;
        data["totalAmountIncludeTax"] = this.totalAmountIncludeTax;
        data["totalAmountBeforeTax"] = this.totalAmountBeforeTax;
        data["totalCalcAmount"] = this.totalCalcAmount;
        data["totalTaxAmount"] = this.totalTaxAmount;
        data["totalDetailLine"] = this.totalDetailLine;
        if (this.ordersDetail && this.ordersDetail.constructor === Array) {
            data["ordersDetail"] = [];
            for (let item of this.ordersDetail)
                data["ordersDetail"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPurchaseTransactionDto {
    memberCode: string | undefined;
    standardMemberCode: string | undefined;
    rankTypeCode: string | undefined;
    fullMemberTypeCode: string | undefined;
    fullRegionCode: string | undefined;
    fullSalesRegionCode: string | undefined;
    source: string | undefined;
    reason: string | undefined;
    salesManCode: string | undefined;
    businessTime: moment.Moment;
    originalOrders: string | undefined;
    ordersCode: string | undefined;
    totalAmountIncludeTax: number | undefined;
    totalAmountBeforeTax: number | undefined;
    totalCalcAmount: number | undefined;
    totalTaxAmount: number | undefined;
    totalDetailLine: number | undefined;
    ordersDetail: PaymentTransactionDetailDto[] | undefined;
}

export class PaymentTransactionDetailDto implements IPaymentTransactionDetailDto {
    seqNo!: number | undefined;
    fullDeptCode!: string | undefined;
    fullClassCode!: string | undefined;
    productCode!: string | undefined;
    quantity!: number | undefined;
    unitPrice!: number | undefined;
    amountBeforeTax!: number | undefined;
    amountIncludeTax!: number | undefined;
    calcAmount!: number | undefined;
    taxAmount!: number | undefined;

    constructor(data?: IPaymentTransactionDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.seqNo = data["seqNo"];
            this.fullDeptCode = data["fullDeptCode"];
            this.fullClassCode = data["fullClassCode"];
            this.productCode = data["productCode"];
            this.quantity = data["quantity"];
            this.unitPrice = data["unitPrice"];
            this.amountBeforeTax = data["amountBeforeTax"];
            this.amountIncludeTax = data["amountIncludeTax"];
            this.calcAmount = data["calcAmount"];
            this.taxAmount = data["taxAmount"];
        }
    }

    static fromJS(data: any): PaymentTransactionDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentTransactionDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["seqNo"] = this.seqNo;
        data["fullDeptCode"] = this.fullDeptCode;
        data["fullClassCode"] = this.fullClassCode;
        data["productCode"] = this.productCode;
        data["quantity"] = this.quantity;
        data["unitPrice"] = this.unitPrice;
        data["amountBeforeTax"] = this.amountBeforeTax;
        data["amountIncludeTax"] = this.amountIncludeTax;
        data["calcAmount"] = this.calcAmount;
        data["taxAmount"] = this.taxAmount;
        return data;
    }
}

export interface IPaymentTransactionDetailDto {
    seqNo: number | undefined;
    fullDeptCode: string | undefined;
    fullClassCode: string | undefined;
    productCode: string | undefined;
    quantity: number | undefined;
    unitPrice: number | undefined;
    amountBeforeTax: number | undefined;
    amountIncludeTax: number | undefined;
    calcAmount: number | undefined;
    taxAmount: number | undefined;
}

export class GetNotificationsOutput implements IGetNotificationsOutput {
    unreadCount!: number | undefined;
    totalCount!: number | undefined;
    items!: UserNotification[] | undefined;

    constructor(data?: IGetNotificationsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unreadCount = data["unreadCount"];
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(UserNotification.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetNotificationsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetNotificationsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unreadCount"] = this.unreadCount;
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetNotificationsOutput {
    unreadCount: number | undefined;
    totalCount: number | undefined;
    items: UserNotification[] | undefined;
}

export class UserNotification implements IUserNotification {
    tenantId!: number | undefined;
    userId!: number | undefined;
    state!: UserNotificationState | undefined;
    notification!: TenantNotification | undefined;
    id!: string | undefined;

    constructor(data?: IUserNotification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.userId = data["userId"];
            this.state = data["state"];
            this.notification = data["notification"] ? TenantNotification.fromJS(data["notification"]) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): UserNotification {
        data = typeof data === 'object' ? data : {};
        let result = new UserNotification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["state"] = this.state;
        data["notification"] = this.notification ? this.notification.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IUserNotification {
    tenantId: number | undefined;
    userId: number | undefined;
    state: UserNotificationState | undefined;
    notification: TenantNotification | undefined;
    id: string | undefined;
}

export class TenantNotification implements ITenantNotification {
    tenantId!: number | undefined;
    notificationName!: string | undefined;
    data!: NotificationData | undefined;
    entityType!: string | undefined;
    entityTypeName!: string | undefined;
    entityId!: any | undefined;
    severity!: TenantNotificationSeverity | undefined;
    creationTime!: moment.Moment | undefined;
    id!: string | undefined;

    constructor(data?: ITenantNotification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.notificationName = data["notificationName"];
            this.data = data["data"] ? NotificationData.fromJS(data["data"]) : <any>undefined;
            this.entityType = data["entityType"];
            this.entityTypeName = data["entityTypeName"];
            this.entityId = data["entityId"];
            this.severity = data["severity"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): TenantNotification {
        data = typeof data === 'object' ? data : {};
        let result = new TenantNotification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["notificationName"] = this.notificationName;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["entityType"] = this.entityType;
        data["entityTypeName"] = this.entityTypeName;
        data["entityId"] = this.entityId;
        data["severity"] = this.severity;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface ITenantNotification {
    tenantId: number | undefined;
    notificationName: string | undefined;
    data: NotificationData | undefined;
    entityType: string | undefined;
    entityTypeName: string | undefined;
    entityId: any | undefined;
    severity: TenantNotificationSeverity | undefined;
    creationTime: moment.Moment | undefined;
    id: string | undefined;
}

export class NotificationData implements INotificationData {
    type!: string | undefined;
    properties!: { [key: string]: any; } | undefined;

    constructor(data?: INotificationData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.type = data["type"];
            if (data["properties"]) {
                this.properties = {};
                for (let key in data["properties"]) {
                    if (data["properties"].hasOwnProperty(key))
                        this.properties[key] = data["properties"][key];
                }
            }
        }
    }

    static fromJS(data: any): NotificationData {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        if (this.properties) {
            data["properties"] = {};
            for (let key in this.properties) {
                if (this.properties.hasOwnProperty(key))
                    data["properties"][key] = this.properties[key];
            }
        }
        return data;
    }
}

export interface INotificationData {
    type: string | undefined;
    properties: { [key: string]: any; } | undefined;
}

export class EntityDtoOfGuid implements IEntityDtoOfGuid {
    id!: string | undefined;

    constructor(data?: IEntityDtoOfGuid) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EntityDtoOfGuid {
        data = typeof data === 'object' ? data : {};
        let result = new EntityDtoOfGuid();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IEntityDtoOfGuid {
    id: string | undefined;
}

export class GetNotificationSettingsOutput implements IGetNotificationSettingsOutput {
    receiveNotifications!: boolean | undefined;
    notifications!: NotificationSubscriptionWithDisplayNameDto[] | undefined;

    constructor(data?: IGetNotificationSettingsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.receiveNotifications = data["receiveNotifications"];
            if (data["notifications"] && data["notifications"].constructor === Array) {
                this.notifications = [];
                for (let item of data["notifications"])
                    this.notifications.push(NotificationSubscriptionWithDisplayNameDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetNotificationSettingsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetNotificationSettingsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["receiveNotifications"] = this.receiveNotifications;
        if (this.notifications && this.notifications.constructor === Array) {
            data["notifications"] = [];
            for (let item of this.notifications)
                data["notifications"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetNotificationSettingsOutput {
    receiveNotifications: boolean | undefined;
    notifications: NotificationSubscriptionWithDisplayNameDto[] | undefined;
}

export class NotificationSubscriptionWithDisplayNameDto implements INotificationSubscriptionWithDisplayNameDto {
    displayName!: string | undefined;
    description!: string | undefined;
    name!: string;
    isSubscribed!: boolean | undefined;

    constructor(data?: INotificationSubscriptionWithDisplayNameDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.displayName = data["displayName"];
            this.description = data["description"];
            this.name = data["name"];
            this.isSubscribed = data["isSubscribed"];
        }
    }

    static fromJS(data: any): NotificationSubscriptionWithDisplayNameDto {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationSubscriptionWithDisplayNameDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["name"] = this.name;
        data["isSubscribed"] = this.isSubscribed;
        return data;
    }
}

export interface INotificationSubscriptionWithDisplayNameDto {
    displayName: string | undefined;
    description: string | undefined;
    name: string;
    isSubscribed: boolean | undefined;
}

export class UpdateNotificationSettingsInput implements IUpdateNotificationSettingsInput {
    receiveNotifications!: boolean | undefined;
    notifications!: NotificationSubscriptionDto[] | undefined;

    constructor(data?: IUpdateNotificationSettingsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.receiveNotifications = data["receiveNotifications"];
            if (data["notifications"] && data["notifications"].constructor === Array) {
                this.notifications = [];
                for (let item of data["notifications"])
                    this.notifications.push(NotificationSubscriptionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateNotificationSettingsInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateNotificationSettingsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["receiveNotifications"] = this.receiveNotifications;
        if (this.notifications && this.notifications.constructor === Array) {
            data["notifications"] = [];
            for (let item of this.notifications)
                data["notifications"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateNotificationSettingsInput {
    receiveNotifications: boolean | undefined;
    notifications: NotificationSubscriptionDto[] | undefined;
}

export class NotificationSubscriptionDto implements INotificationSubscriptionDto {
    name!: string;
    isSubscribed!: boolean | undefined;

    constructor(data?: INotificationSubscriptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.isSubscribed = data["isSubscribed"];
        }
    }

    static fromJS(data: any): NotificationSubscriptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationSubscriptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["isSubscribed"] = this.isSubscribed;
        return data;
    }
}

export interface INotificationSubscriptionDto {
    name: string;
    isSubscribed: boolean | undefined;
}

export class PagedResultDtoOfGetNotificationUserForViewDto implements IPagedResultDtoOfGetNotificationUserForViewDto {
    totalCount!: number | undefined;
    items!: GetNotificationUserForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetNotificationUserForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetNotificationUserForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetNotificationUserForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetNotificationUserForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetNotificationUserForViewDto {
    totalCount: number | undefined;
    items: GetNotificationUserForViewDto[] | undefined;
}

export class GetNotificationUserForViewDto implements IGetNotificationUserForViewDto {
    notificationUser!: NotificationUserDto | undefined;

    constructor(data?: IGetNotificationUserForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.notificationUser = data["notificationUser"] ? NotificationUserDto.fromJS(data["notificationUser"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetNotificationUserForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetNotificationUserForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["notificationUser"] = this.notificationUser ? this.notificationUser.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetNotificationUserForViewDto {
    notificationUser: NotificationUserDto | undefined;
}

export class NotificationUserDto implements INotificationUserDto {
    memberCode!: string | undefined;
    memberName!: string | undefined;
    phone!: string | undefined;
    email!: string | undefined;
    status!: string | undefined;
    communicationChannels!: string | undefined;
    communicationLanguage!: string | undefined;
    memberNameUnsign!: string | undefined;
    id!: number | undefined;

    constructor(data?: INotificationUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberCode = data["memberCode"];
            this.memberName = data["memberName"];
            this.phone = data["phone"];
            this.email = data["email"];
            this.status = data["status"];
            this.communicationChannels = data["communicationChannels"];
            this.communicationLanguage = data["communicationLanguage"];
            this.memberNameUnsign = data["memberNameUnsign"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): NotificationUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberCode"] = this.memberCode;
        data["memberName"] = this.memberName;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["status"] = this.status;
        data["communicationChannels"] = this.communicationChannels;
        data["communicationLanguage"] = this.communicationLanguage;
        data["memberNameUnsign"] = this.memberNameUnsign;
        data["id"] = this.id;
        return data;
    }
}

export interface INotificationUserDto {
    memberCode: string | undefined;
    memberName: string | undefined;
    phone: string | undefined;
    email: string | undefined;
    status: string | undefined;
    communicationChannels: string | undefined;
    communicationLanguage: string | undefined;
    memberNameUnsign: string | undefined;
    id: number | undefined;
}

export class GetNotificationUserForEditOutput implements IGetNotificationUserForEditOutput {
    notificationUser!: CreateOrEditNotificationUserDto | undefined;

    constructor(data?: IGetNotificationUserForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.notificationUser = data["notificationUser"] ? CreateOrEditNotificationUserDto.fromJS(data["notificationUser"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetNotificationUserForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetNotificationUserForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["notificationUser"] = this.notificationUser ? this.notificationUser.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetNotificationUserForEditOutput {
    notificationUser: CreateOrEditNotificationUserDto | undefined;
}

export class CreateOrEditNotificationUserDto implements ICreateOrEditNotificationUserDto {
    memberCode!: string | undefined;
    memberName!: string | undefined;
    phone!: string | undefined;
    email!: string | undefined;
    status!: string | undefined;
    communicationChannels!: string | undefined;
    communicationLanguage!: string | undefined;
    memberNameUnsign!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditNotificationUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberCode = data["memberCode"];
            this.memberName = data["memberName"];
            this.phone = data["phone"];
            this.email = data["email"];
            this.status = data["status"];
            this.communicationChannels = data["communicationChannels"];
            this.communicationLanguage = data["communicationLanguage"];
            this.memberNameUnsign = data["memberNameUnsign"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditNotificationUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditNotificationUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberCode"] = this.memberCode;
        data["memberName"] = this.memberName;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["status"] = this.status;
        data["communicationChannels"] = this.communicationChannels;
        data["communicationLanguage"] = this.communicationLanguage;
        data["memberNameUnsign"] = this.memberNameUnsign;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditNotificationUserDto {
    memberCode: string | undefined;
    memberName: string | undefined;
    phone: string | undefined;
    email: string | undefined;
    status: string | undefined;
    communicationChannels: string | undefined;
    communicationLanguage: string | undefined;
    memberNameUnsign: string | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfOneTimePasswordDto implements IPagedResultDtoOfOneTimePasswordDto {
    totalCount!: number | undefined;
    items!: OneTimePasswordDto[] | undefined;

    constructor(data?: IPagedResultDtoOfOneTimePasswordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(OneTimePasswordDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfOneTimePasswordDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfOneTimePasswordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfOneTimePasswordDto {
    totalCount: number | undefined;
    items: OneTimePasswordDto[] | undefined;
}

export class OneTimePasswordDto implements IOneTimePasswordDto {
    id!: number | undefined;
    tenantId!: number | undefined;
    creationTime!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;
    phoneNumer!: string | undefined;
    otp!: string | undefined;
    type!: string | undefined;
    utcExpiredTime!: moment.Moment | undefined;
    authenOTPDateTime!: moment.Moment | undefined;
    smsContent!: string | undefined;
    countDownSecond!: number | undefined;
    isNew!: boolean | undefined;

    constructor(data?: IOneTimePasswordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.tenantId = data["tenantId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.phoneNumer = data["phoneNumer"];
            this.otp = data["otp"];
            this.type = data["type"];
            this.utcExpiredTime = data["utcExpiredTime"] ? moment(data["utcExpiredTime"].toString()) : <any>undefined;
            this.authenOTPDateTime = data["authenOTPDateTime"] ? moment(data["authenOTPDateTime"].toString()) : <any>undefined;
            this.smsContent = data["smsContent"];
            this.countDownSecond = data["countDownSecond"];
            this.isNew = data["isNew"];
        }
    }

    static fromJS(data: any): OneTimePasswordDto {
        data = typeof data === 'object' ? data : {};
        let result = new OneTimePasswordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["phoneNumer"] = this.phoneNumer;
        data["otp"] = this.otp;
        data["type"] = this.type;
        data["utcExpiredTime"] = this.utcExpiredTime ? this.utcExpiredTime.toISOString() : <any>undefined;
        data["authenOTPDateTime"] = this.authenOTPDateTime ? this.authenOTPDateTime.toISOString() : <any>undefined;
        data["smsContent"] = this.smsContent;
        data["countDownSecond"] = this.countDownSecond;
        data["isNew"] = this.isNew;
        return data;
    }
}

export interface IOneTimePasswordDto {
    id: number | undefined;
    tenantId: number | undefined;
    creationTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    phoneNumer: string | undefined;
    otp: string | undefined;
    type: string | undefined;
    utcExpiredTime: moment.Moment | undefined;
    authenOTPDateTime: moment.Moment | undefined;
    smsContent: string | undefined;
    countDownSecond: number | undefined;
    isNew: boolean | undefined;
}

export class GetOneTimePasswordInput implements IGetOneTimePasswordInput {
    otp!: string | undefined;
    phoneNumer!: string | undefined;
    type!: string | undefined;

    constructor(data?: IGetOneTimePasswordInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.otp = data["otp"];
            this.phoneNumer = data["phoneNumer"];
            this.type = data["type"];
        }
    }

    static fromJS(data: any): GetOneTimePasswordInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetOneTimePasswordInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["otp"] = this.otp;
        data["phoneNumer"] = this.phoneNumer;
        data["type"] = this.type;
        return data;
    }
}

export interface IGetOneTimePasswordInput {
    otp: string | undefined;
    phoneNumer: string | undefined;
    type: string | undefined;
}

export class CreateOneTimePasswordDto implements ICreateOneTimePasswordDto {
    phoneNumer!: string | undefined;
    type!: string | undefined;

    constructor(data?: ICreateOneTimePasswordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.phoneNumer = data["phoneNumer"];
            this.type = data["type"];
        }
    }

    static fromJS(data: any): CreateOneTimePasswordDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOneTimePasswordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phoneNumer"] = this.phoneNumer;
        data["type"] = this.type;
        return data;
    }
}

export interface ICreateOneTimePasswordDto {
    phoneNumer: string | undefined;
    type: string | undefined;
}

export class ResponseOTP implements IResponseOTP {
    isSuccess!: boolean | undefined;
    senderSend!: string | undefined;
    countDownSecond!: number | undefined;
    isNew!: boolean | undefined;
    authenOTPDateTime!: moment.Moment | undefined;
    tenantId!: number | undefined;
    utcExpiredTime!: moment.Moment | undefined;

    constructor(data?: IResponseOTP) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isSuccess = data["isSuccess"];
            this.senderSend = data["senderSend"];
            this.countDownSecond = data["countDownSecond"];
            this.isNew = data["isNew"];
            this.authenOTPDateTime = data["authenOTPDateTime"] ? moment(data["authenOTPDateTime"].toString()) : <any>undefined;
            this.tenantId = data["tenantId"];
            this.utcExpiredTime = data["utcExpiredTime"] ? moment(data["utcExpiredTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ResponseOTP {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseOTP();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["senderSend"] = this.senderSend;
        data["countDownSecond"] = this.countDownSecond;
        data["isNew"] = this.isNew;
        data["authenOTPDateTime"] = this.authenOTPDateTime ? this.authenOTPDateTime.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["utcExpiredTime"] = this.utcExpiredTime ? this.utcExpiredTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IResponseOTP {
    isSuccess: boolean | undefined;
    senderSend: string | undefined;
    countDownSecond: number | undefined;
    isNew: boolean | undefined;
    authenOTPDateTime: moment.Moment | undefined;
    tenantId: number | undefined;
    utcExpiredTime: moment.Moment | undefined;
}

export class ResetNumberOfOTPSentDto implements IResetNumberOfOTPSentDto {
    phoneNumber!: string | undefined;
    serectKey!: string | undefined;

    constructor(data?: IResetNumberOfOTPSentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.phoneNumber = data["phoneNumber"];
            this.serectKey = data["serectKey"];
        }
    }

    static fromJS(data: any): ResetNumberOfOTPSentDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResetNumberOfOTPSentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phoneNumber"] = this.phoneNumber;
        data["serectKey"] = this.serectKey;
        return data;
    }
}

export interface IResetNumberOfOTPSentDto {
    phoneNumber: string | undefined;
    serectKey: string | undefined;
}

export class PagedResultDtoOfGetOrderMappingSMForViewDto implements IPagedResultDtoOfGetOrderMappingSMForViewDto {
    totalCount!: number | undefined;
    items!: GetOrderMappingSMForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetOrderMappingSMForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetOrderMappingSMForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetOrderMappingSMForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetOrderMappingSMForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetOrderMappingSMForViewDto {
    totalCount: number | undefined;
    items: GetOrderMappingSMForViewDto[] | undefined;
}

export class GetOrderMappingSMForViewDto implements IGetOrderMappingSMForViewDto {
    orderMappingSM!: OrderMappingSMDto | undefined;

    constructor(data?: IGetOrderMappingSMForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.orderMappingSM = data["orderMappingSM"] ? OrderMappingSMDto.fromJS(data["orderMappingSM"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetOrderMappingSMForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetOrderMappingSMForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderMappingSM"] = this.orderMappingSM ? this.orderMappingSM.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetOrderMappingSMForViewDto {
    orderMappingSM: OrderMappingSMDto | undefined;
}

export class OrderMappingSMDto implements IOrderMappingSMDto {
    id!: number | undefined;

    constructor(data?: IOrderMappingSMDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
        }
    }

    static fromJS(data: any): OrderMappingSMDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderMappingSMDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IOrderMappingSMDto {
    id: number | undefined;
}

export class GetOrderMappingSMForEditOutput implements IGetOrderMappingSMForEditOutput {
    orderMappingSM!: CreateOrEditOrderMappingSMDto | undefined;

    constructor(data?: IGetOrderMappingSMForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.orderMappingSM = data["orderMappingSM"] ? CreateOrEditOrderMappingSMDto.fromJS(data["orderMappingSM"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetOrderMappingSMForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetOrderMappingSMForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderMappingSM"] = this.orderMappingSM ? this.orderMappingSM.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetOrderMappingSMForEditOutput {
    orderMappingSM: CreateOrEditOrderMappingSMDto | undefined;
}

export class CreateOrEditOrderMappingSMDto implements ICreateOrEditOrderMappingSMDto {
    id!: number | undefined;

    constructor(data?: ICreateOrEditOrderMappingSMDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditOrderMappingSMDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditOrderMappingSMDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditOrderMappingSMDto {
    id: number | undefined;
}

export class OrderResponse implements IOrderResponse {
    orderItems!: OrderItemDto[] | undefined;
    orderStatus!: string | undefined;
    partnerId!: number | undefined;
    appointmentDate!: moment.Moment | undefined;
    description!: string | undefined;
    creatorName!: string | undefined;
    lastModifierName!: string | undefined;
    orderCode!: string | undefined;
    partnerName!: string | undefined;
    id!: number | undefined;

    constructor(data?: IOrderResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["orderItems"] && data["orderItems"].constructor === Array) {
                this.orderItems = [];
                for (let item of data["orderItems"])
                    this.orderItems.push(OrderItemDto.fromJS(item));
            }
            this.orderStatus = data["orderStatus"];
            this.partnerId = data["partnerId"];
            this.appointmentDate = data["appointmentDate"] ? moment(data["appointmentDate"].toString()) : <any>undefined;
            this.description = data["description"];
            this.creatorName = data["creatorName"];
            this.lastModifierName = data["lastModifierName"];
            this.orderCode = data["orderCode"];
            this.partnerName = data["partnerName"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): OrderResponse {
        data = typeof data === 'object' ? data : {};
        let result = new OrderResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.orderItems && this.orderItems.constructor === Array) {
            data["orderItems"] = [];
            for (let item of this.orderItems)
                data["orderItems"].push(item.toJSON());
        }
        data["orderStatus"] = this.orderStatus;
        data["partnerId"] = this.partnerId;
        data["appointmentDate"] = this.appointmentDate ? this.appointmentDate.toISOString() : <any>undefined;
        data["description"] = this.description;
        data["creatorName"] = this.creatorName;
        data["lastModifierName"] = this.lastModifierName;
        data["orderCode"] = this.orderCode;
        data["partnerName"] = this.partnerName;
        data["id"] = this.id;
        return data;
    }
}

export interface IOrderResponse {
    orderItems: OrderItemDto[] | undefined;
    orderStatus: string | undefined;
    partnerId: number | undefined;
    appointmentDate: moment.Moment | undefined;
    description: string | undefined;
    creatorName: string | undefined;
    lastModifierName: string | undefined;
    orderCode: string | undefined;
    partnerName: string | undefined;
    id: number | undefined;
}

export class OrderItemDto implements IOrderItemDto {
    orderId!: number | undefined;
    productId!: number | undefined;
    quantity!: number | undefined;
    price!: number | undefined;
    discountNote!: string | undefined;
    description!: string | undefined;
    itemCode!: string | undefined;
    productName!: string | undefined;
    id!: number | undefined;

    constructor(data?: IOrderItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.orderId = data["orderId"];
            this.productId = data["productId"];
            this.quantity = data["quantity"];
            this.price = data["price"];
            this.discountNote = data["discountNote"];
            this.description = data["description"];
            this.itemCode = data["itemCode"];
            this.productName = data["productName"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): OrderItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        data["productId"] = this.productId;
        data["quantity"] = this.quantity;
        data["price"] = this.price;
        data["discountNote"] = this.discountNote;
        data["description"] = this.description;
        data["itemCode"] = this.itemCode;
        data["productName"] = this.productName;
        data["id"] = this.id;
        return data;
    }
}

export interface IOrderItemDto {
    orderId: number | undefined;
    productId: number | undefined;
    quantity: number | undefined;
    price: number | undefined;
    discountNote: string | undefined;
    description: string | undefined;
    itemCode: string | undefined;
    productName: string | undefined;
    id: number | undefined;
}

export class OrderInput implements IOrderInput {
    orderItems!: OrderItemDto[] | undefined;
    orderStatus!: string | undefined;
    partnerId!: number | undefined;
    appointmentDate!: moment.Moment | undefined;
    description!: string | undefined;
    creatorName!: string | undefined;
    lastModifierName!: string | undefined;
    orderCode!: string | undefined;
    partnerName!: string | undefined;
    id!: number | undefined;

    constructor(data?: IOrderInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["orderItems"] && data["orderItems"].constructor === Array) {
                this.orderItems = [];
                for (let item of data["orderItems"])
                    this.orderItems.push(OrderItemDto.fromJS(item));
            }
            this.orderStatus = data["orderStatus"];
            this.partnerId = data["partnerId"];
            this.appointmentDate = data["appointmentDate"] ? moment(data["appointmentDate"].toString()) : <any>undefined;
            this.description = data["description"];
            this.creatorName = data["creatorName"];
            this.lastModifierName = data["lastModifierName"];
            this.orderCode = data["orderCode"];
            this.partnerName = data["partnerName"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): OrderInput {
        data = typeof data === 'object' ? data : {};
        let result = new OrderInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.orderItems && this.orderItems.constructor === Array) {
            data["orderItems"] = [];
            for (let item of this.orderItems)
                data["orderItems"].push(item.toJSON());
        }
        data["orderStatus"] = this.orderStatus;
        data["partnerId"] = this.partnerId;
        data["appointmentDate"] = this.appointmentDate ? this.appointmentDate.toISOString() : <any>undefined;
        data["description"] = this.description;
        data["creatorName"] = this.creatorName;
        data["lastModifierName"] = this.lastModifierName;
        data["orderCode"] = this.orderCode;
        data["partnerName"] = this.partnerName;
        data["id"] = this.id;
        return data;
    }
}

export interface IOrderInput {
    orderItems: OrderItemDto[] | undefined;
    orderStatus: string | undefined;
    partnerId: number | undefined;
    appointmentDate: moment.Moment | undefined;
    description: string | undefined;
    creatorName: string | undefined;
    lastModifierName: string | undefined;
    orderCode: string | undefined;
    partnerName: string | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfOrderItemDto implements IPagedResultDtoOfOrderItemDto {
    totalCount!: number | undefined;
    items!: OrderItemDto[] | undefined;

    constructor(data?: IPagedResultDtoOfOrderItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(OrderItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfOrderItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfOrderItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfOrderItemDto {
    totalCount: number | undefined;
    items: OrderItemDto[] | undefined;
}

export class ListResultDtoOfOrganizationUnitDto implements IListResultDtoOfOrganizationUnitDto {
    items!: OrganizationUnitDto[] | undefined;

    constructor(data?: IListResultDtoOfOrganizationUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(OrganizationUnitDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfOrganizationUnitDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfOrganizationUnitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListResultDtoOfOrganizationUnitDto {
    items: OrganizationUnitDto[] | undefined;
}

export class OrganizationUnitDto implements IOrganizationUnitDto {
    parentId!: number | undefined;
    code!: string | undefined;
    displayName!: string | undefined;
    memberCount!: number | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: moment.Moment | undefined;
    creatorUserId!: number | undefined;
    id!: number | undefined;

    constructor(data?: IOrganizationUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.parentId = data["parentId"];
            this.code = data["code"];
            this.displayName = data["displayName"];
            this.memberCount = data["memberCount"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): OrganizationUnitDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationUnitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentId"] = this.parentId;
        data["code"] = this.code;
        data["displayName"] = this.displayName;
        data["memberCount"] = this.memberCount;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IOrganizationUnitDto {
    parentId: number | undefined;
    code: string | undefined;
    displayName: string | undefined;
    memberCount: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfOrganizationUnitUserListDto implements IPagedResultDtoOfOrganizationUnitUserListDto {
    totalCount!: number | undefined;
    items!: OrganizationUnitUserListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfOrganizationUnitUserListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(OrganizationUnitUserListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfOrganizationUnitUserListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfOrganizationUnitUserListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfOrganizationUnitUserListDto {
    totalCount: number | undefined;
    items: OrganizationUnitUserListDto[] | undefined;
}

export class OrganizationUnitUserListDto implements IOrganizationUnitUserListDto {
    name!: string | undefined;
    surname!: string | undefined;
    userName!: string | undefined;
    emailAddress!: string | undefined;
    profilePictureId!: string | undefined;
    addedTime!: moment.Moment | undefined;
    id!: number | undefined;

    constructor(data?: IOrganizationUnitUserListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.surname = data["surname"];
            this.userName = data["userName"];
            this.emailAddress = data["emailAddress"];
            this.profilePictureId = data["profilePictureId"];
            this.addedTime = data["addedTime"] ? moment(data["addedTime"].toString()) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): OrganizationUnitUserListDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationUnitUserListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["profilePictureId"] = this.profilePictureId;
        data["addedTime"] = this.addedTime ? this.addedTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IOrganizationUnitUserListDto {
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    profilePictureId: string | undefined;
    addedTime: moment.Moment | undefined;
    id: number | undefined;
}

export class CreateOrganizationUnitInput implements ICreateOrganizationUnitInput {
    parentId!: number | undefined;
    displayName!: string;

    constructor(data?: ICreateOrganizationUnitInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.parentId = data["parentId"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): CreateOrganizationUnitInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrganizationUnitInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentId"] = this.parentId;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface ICreateOrganizationUnitInput {
    parentId: number | undefined;
    displayName: string;
}

export class UpdateOrganizationUnitInput implements IUpdateOrganizationUnitInput {
    id!: number | undefined;
    displayName!: string;

    constructor(data?: IUpdateOrganizationUnitInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): UpdateOrganizationUnitInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateOrganizationUnitInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IUpdateOrganizationUnitInput {
    id: number | undefined;
    displayName: string;
}

export class MoveOrganizationUnitInput implements IMoveOrganizationUnitInput {
    id!: number | undefined;
    newParentId!: number | undefined;

    constructor(data?: IMoveOrganizationUnitInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.newParentId = data["newParentId"];
        }
    }

    static fromJS(data: any): MoveOrganizationUnitInput {
        data = typeof data === 'object' ? data : {};
        let result = new MoveOrganizationUnitInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["newParentId"] = this.newParentId;
        return data;
    }
}

export interface IMoveOrganizationUnitInput {
    id: number | undefined;
    newParentId: number | undefined;
}

export class UsersToOrganizationUnitInput implements IUsersToOrganizationUnitInput {
    userIds!: number[] | undefined;
    organizationUnitId!: number | undefined;

    constructor(data?: IUsersToOrganizationUnitInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["userIds"] && data["userIds"].constructor === Array) {
                this.userIds = [];
                for (let item of data["userIds"])
                    this.userIds.push(item);
            }
            this.organizationUnitId = data["organizationUnitId"];
        }
    }

    static fromJS(data: any): UsersToOrganizationUnitInput {
        data = typeof data === 'object' ? data : {};
        let result = new UsersToOrganizationUnitInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.userIds && this.userIds.constructor === Array) {
            data["userIds"] = [];
            for (let item of this.userIds)
                data["userIds"].push(item);
        }
        data["organizationUnitId"] = this.organizationUnitId;
        return data;
    }
}

export interface IUsersToOrganizationUnitInput {
    userIds: number[] | undefined;
    organizationUnitId: number | undefined;
}

export class FindOrganizationUnitUsersInput implements IFindOrganizationUnitUsersInput {
    organizationUnitId!: number | undefined;
    maxResultCount!: number | undefined;
    skipCount!: number | undefined;
    filter!: string | undefined;

    constructor(data?: IFindOrganizationUnitUsersInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.organizationUnitId = data["organizationUnitId"];
            this.maxResultCount = data["maxResultCount"];
            this.skipCount = data["skipCount"];
            this.filter = data["filter"];
        }
    }

    static fromJS(data: any): FindOrganizationUnitUsersInput {
        data = typeof data === 'object' ? data : {};
        let result = new FindOrganizationUnitUsersInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationUnitId"] = this.organizationUnitId;
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["filter"] = this.filter;
        return data;
    }
}

export interface IFindOrganizationUnitUsersInput {
    organizationUnitId: number | undefined;
    maxResultCount: number | undefined;
    skipCount: number | undefined;
    filter: string | undefined;
}

export class PagedResultDtoOfGetOutletInfoDetailForViewDto implements IPagedResultDtoOfGetOutletInfoDetailForViewDto {
    totalCount!: number | undefined;
    items!: GetOutletInfoDetailForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetOutletInfoDetailForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetOutletInfoDetailForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetOutletInfoDetailForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetOutletInfoDetailForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetOutletInfoDetailForViewDto {
    totalCount: number | undefined;
    items: GetOutletInfoDetailForViewDto[] | undefined;
}

export class GetOutletInfoDetailForViewDto implements IGetOutletInfoDetailForViewDto {
    outletInfoDetail!: OutletInfoDetailDto | undefined;

    constructor(data?: IGetOutletInfoDetailForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.outletInfoDetail = data["outletInfoDetail"] ? OutletInfoDetailDto.fromJS(data["outletInfoDetail"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetOutletInfoDetailForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetOutletInfoDetailForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["outletInfoDetail"] = this.outletInfoDetail ? this.outletInfoDetail.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetOutletInfoDetailForViewDto {
    outletInfoDetail: OutletInfoDetailDto | undefined;
}

export class OutletInfoDetailDto implements IOutletInfoDetailDto {
    outletCode!: string | undefined;
    reasonPhone!: string | undefined;
    phoneUpdated!: string | undefined;
    phoneUpdatedDate!: moment.Moment | undefined;
    phoneUpdateStatus!: string | undefined;
    otp!: string | undefined;
    gapDistance!: number | undefined;
    latUpdated!: string | undefined;
    lngUpdated!: string | undefined;
    authenOTPDate!: moment.Moment | undefined;
    isDelete!: boolean | undefined;
    salesmanCode!: string | undefined;
    timeSendOTP!: moment.Moment | undefined;
    homePhone!: string | undefined;
    updateType!: string | undefined;
    id!: number | undefined;

    constructor(data?: IOutletInfoDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.outletCode = data["outletCode"];
            this.reasonPhone = data["reasonPhone"];
            this.phoneUpdated = data["phoneUpdated"];
            this.phoneUpdatedDate = data["phoneUpdatedDate"] ? moment(data["phoneUpdatedDate"].toString()) : <any>undefined;
            this.phoneUpdateStatus = data["phoneUpdateStatus"];
            this.otp = data["otp"];
            this.gapDistance = data["gapDistance"];
            this.latUpdated = data["latUpdated"];
            this.lngUpdated = data["lngUpdated"];
            this.authenOTPDate = data["authenOTPDate"] ? moment(data["authenOTPDate"].toString()) : <any>undefined;
            this.isDelete = data["isDelete"];
            this.salesmanCode = data["salesmanCode"];
            this.timeSendOTP = data["timeSendOTP"] ? moment(data["timeSendOTP"].toString()) : <any>undefined;
            this.homePhone = data["homePhone"];
            this.updateType = data["updateType"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): OutletInfoDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new OutletInfoDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["outletCode"] = this.outletCode;
        data["reasonPhone"] = this.reasonPhone;
        data["phoneUpdated"] = this.phoneUpdated;
        data["phoneUpdatedDate"] = this.phoneUpdatedDate ? this.phoneUpdatedDate.toISOString() : <any>undefined;
        data["phoneUpdateStatus"] = this.phoneUpdateStatus;
        data["otp"] = this.otp;
        data["gapDistance"] = this.gapDistance;
        data["latUpdated"] = this.latUpdated;
        data["lngUpdated"] = this.lngUpdated;
        data["authenOTPDate"] = this.authenOTPDate ? this.authenOTPDate.toISOString() : <any>undefined;
        data["isDelete"] = this.isDelete;
        data["salesmanCode"] = this.salesmanCode;
        data["timeSendOTP"] = this.timeSendOTP ? this.timeSendOTP.toISOString() : <any>undefined;
        data["homePhone"] = this.homePhone;
        data["updateType"] = this.updateType;
        data["id"] = this.id;
        return data;
    }
}

export interface IOutletInfoDetailDto {
    outletCode: string | undefined;
    reasonPhone: string | undefined;
    phoneUpdated: string | undefined;
    phoneUpdatedDate: moment.Moment | undefined;
    phoneUpdateStatus: string | undefined;
    otp: string | undefined;
    gapDistance: number | undefined;
    latUpdated: string | undefined;
    lngUpdated: string | undefined;
    authenOTPDate: moment.Moment | undefined;
    isDelete: boolean | undefined;
    salesmanCode: string | undefined;
    timeSendOTP: moment.Moment | undefined;
    homePhone: string | undefined;
    updateType: string | undefined;
    id: number | undefined;
}

export class GetOutletInfoDetailForEditOutput implements IGetOutletInfoDetailForEditOutput {
    outletInfoDetail!: CreateOrEditOutletInfoDetailDto | undefined;

    constructor(data?: IGetOutletInfoDetailForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.outletInfoDetail = data["outletInfoDetail"] ? CreateOrEditOutletInfoDetailDto.fromJS(data["outletInfoDetail"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetOutletInfoDetailForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetOutletInfoDetailForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["outletInfoDetail"] = this.outletInfoDetail ? this.outletInfoDetail.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetOutletInfoDetailForEditOutput {
    outletInfoDetail: CreateOrEditOutletInfoDetailDto | undefined;
}

export class CreateOrEditOutletInfoDetailDto implements ICreateOrEditOutletInfoDetailDto {
    outletCode!: string | undefined;
    reasonPhone!: string | undefined;
    phoneUpdated!: string | undefined;
    phoneUpdatedDate!: moment.Moment | undefined;
    phoneUpdateStatus!: string | undefined;
    otp!: string | undefined;
    gapDistance!: number | undefined;
    latUpdated!: string | undefined;
    lngUpdated!: string | undefined;
    authenOTPDate!: moment.Moment | undefined;
    isDelete!: boolean | undefined;
    salesmanCode!: string | undefined;
    timeSendOTP!: moment.Moment | undefined;
    homePhone!: string | undefined;
    updateType!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditOutletInfoDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.outletCode = data["outletCode"];
            this.reasonPhone = data["reasonPhone"];
            this.phoneUpdated = data["phoneUpdated"];
            this.phoneUpdatedDate = data["phoneUpdatedDate"] ? moment(data["phoneUpdatedDate"].toString()) : <any>undefined;
            this.phoneUpdateStatus = data["phoneUpdateStatus"];
            this.otp = data["otp"];
            this.gapDistance = data["gapDistance"];
            this.latUpdated = data["latUpdated"];
            this.lngUpdated = data["lngUpdated"];
            this.authenOTPDate = data["authenOTPDate"] ? moment(data["authenOTPDate"].toString()) : <any>undefined;
            this.isDelete = data["isDelete"];
            this.salesmanCode = data["salesmanCode"];
            this.timeSendOTP = data["timeSendOTP"] ? moment(data["timeSendOTP"].toString()) : <any>undefined;
            this.homePhone = data["homePhone"];
            this.updateType = data["updateType"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditOutletInfoDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditOutletInfoDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["outletCode"] = this.outletCode;
        data["reasonPhone"] = this.reasonPhone;
        data["phoneUpdated"] = this.phoneUpdated;
        data["phoneUpdatedDate"] = this.phoneUpdatedDate ? this.phoneUpdatedDate.toISOString() : <any>undefined;
        data["phoneUpdateStatus"] = this.phoneUpdateStatus;
        data["otp"] = this.otp;
        data["gapDistance"] = this.gapDistance;
        data["latUpdated"] = this.latUpdated;
        data["lngUpdated"] = this.lngUpdated;
        data["authenOTPDate"] = this.authenOTPDate ? this.authenOTPDate.toISOString() : <any>undefined;
        data["isDelete"] = this.isDelete;
        data["salesmanCode"] = this.salesmanCode;
        data["timeSendOTP"] = this.timeSendOTP ? this.timeSendOTP.toISOString() : <any>undefined;
        data["homePhone"] = this.homePhone;
        data["updateType"] = this.updateType;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditOutletInfoDetailDto {
    outletCode: string | undefined;
    reasonPhone: string | undefined;
    phoneUpdated: string | undefined;
    phoneUpdatedDate: moment.Moment | undefined;
    phoneUpdateStatus: string | undefined;
    otp: string | undefined;
    gapDistance: number | undefined;
    latUpdated: string | undefined;
    lngUpdated: string | undefined;
    authenOTPDate: moment.Moment | undefined;
    isDelete: boolean | undefined;
    salesmanCode: string | undefined;
    timeSendOTP: moment.Moment | undefined;
    homePhone: string | undefined;
    updateType: string | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfGetOutletInfoForViewDto implements IPagedResultDtoOfGetOutletInfoForViewDto {
    totalCount!: number | undefined;
    items!: GetOutletInfoForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetOutletInfoForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetOutletInfoForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetOutletInfoForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetOutletInfoForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetOutletInfoForViewDto {
    totalCount: number | undefined;
    items: GetOutletInfoForViewDto[] | undefined;
}

export class GetOutletInfoForViewDto implements IGetOutletInfoForViewDto {
    outletInfo!: OutletInfoDto | undefined;

    constructor(data?: IGetOutletInfoForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.outletInfo = data["outletInfo"] ? OutletInfoDto.fromJS(data["outletInfo"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetOutletInfoForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetOutletInfoForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["outletInfo"] = this.outletInfo ? this.outletInfo.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetOutletInfoForViewDto {
    outletInfo: OutletInfoDto | undefined;
}

export class OutletInfoDto implements IOutletInfoDto {
    memberCode!: string | undefined;
    name!: string | undefined;
    phone!: string | undefined;
    lng!: string | undefined;
    lat!: string | undefined;
    email!: string | undefined;
    gender!: string | undefined;
    birthday!: number | undefined;
    registrationDate!: number | undefined;
    pid!: string | undefined;
    sourceID!: string | undefined;
    receiveAds!: boolean | undefined;
    rankCode!: string | undefined;
    rankValidDate!: number | undefined;
    currentPoint!: number | undefined;
    nationalityCode!: string | undefined;
    occupationCode!: string | undefined;
    hobby!: string | undefined;
    address!: string | undefined;
    ward!: string | undefined;
    district!: string | undefined;
    province!: string | undefined;
    domain!: string | undefined;
    country!: string | undefined;
    status!: string | undefined;
    lastActivityTime!: moment.Moment | undefined;
    lastPurchaseTime!: moment.Moment | undefined;
    communicationLanguage!: string | undefined;
    notes!: string | undefined;
    rankPropose!: string | undefined;
    pinCode!: string | undefined;
    nameUnSign!: string | undefined;
    avatar!: string | undefined;
    workingPermit!: boolean | undefined;
    customerCode!: string | undefined;
    interestOf!: string | undefined;
    isInterestCobrand!: boolean | undefined;
    memberCard!: string | undefined;
    isForeigner!: boolean | undefined;
    isSynced!: boolean | undefined;
    referralCode!: string | undefined;
    accumulationPoint!: number | undefined;
    outletCode!: string | undefined;
    zaloName!: string | undefined;
    distributorCode!: string | undefined;
    distributorName!: string | undefined;
    regionCode!: string | undefined;
    targetRevenue!: number | undefined;
    actualRevenue!: number | undefined;
    bonus!: number | undefined;
    missingRevenue!: number | undefined;
    revenueUpdateDate!: number | undefined;
    note1!: string | undefined;
    note2!: string | undefined;
    note3!: string | undefined;
    note4!: string | undefined;
    note5!: string | undefined;
    salesChannel!: string | undefined;
    supervisorCode!: string | undefined;
    supervisorName!: string | undefined;
    phoneFirstDate!: moment.Moment | undefined;
    lockUpdatePhone!: boolean | undefined;
    browserCode!: string | undefined;
    deviceNameCode!: string | undefined;
    typeOfDeviceCode!: string | undefined;
    salesmanCode!: string | undefined;
    consumerID!: number | undefined;
    lockUpdateChatID!: boolean | undefined;
    currentCoin!: number | undefined;
    pointToKeepRank!: number | undefined;
    pointToNextRank!: number | undefined;
    expiringCoin!: number | undefined;
    expiringCoinDate!: moment.Moment | undefined;
    lockUpdateProfile!: boolean | undefined;
    outletType!: string | undefined;
    password!: string | undefined;
    accumulationPointSellIn!: number | undefined;
    accumulationPointSellOut!: number | undefined;
    businessType!: string | undefined;
    warehouseAddress!: string | undefined;
    bossName!: string | undefined;
    anniversaryDate!: moment.Moment | undefined;
    taxCode!: string | undefined;
    identificationCardNumber!: string | undefined;
    bankAccountNumber!: string | undefined;
    bankBranchName!: string | undefined;
    bankAccountName!: string | undefined;
    bankName!: string | undefined;
    legalPersonalName!: string | undefined;
    legalPersonal!: string | undefined;
    taxAddress!: string | undefined;
    storeType!: string | undefined;
    deptCode!: string | undefined;
    creationTime!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;
    communicationChannels!: SocialMemberChannelInfo[] | undefined;
    communicationChannelsString!: string | undefined;
    rankName!: string | undefined;
    outletTypeName!: string | undefined;
    nationalityName!: string | undefined;
    chatId!: string | undefined;
    businessCertification!: string | undefined;
    businessCertificationback!: string | undefined;
    userId!: number | undefined;
    userName!: string | undefined;
    identificationCardFrontImage!: string | undefined;
    identificationCardBackImage!: string | undefined;
    storeArea!: number | undefined;
    employeeQuantity!: number | undefined;
    verifyStatus!: string | undefined;
    id!: number | undefined;
    subLayer!: string | undefined;
    brand!: string | undefined;

    constructor(data?: IOutletInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberCode = data["memberCode"];
            this.name = data["name"];
            this.phone = data["phone"];
            this.lng = data["lng"];
            this.lat = data["lat"];
            this.email = data["email"];
            this.gender = data["gender"];
            this.birthday = data["birthday"];
            this.registrationDate = data["registrationDate"];
            this.pid = data["pid"];
            this.sourceID = data["sourceID"];
            this.receiveAds = data["receiveAds"];
            this.rankCode = data["rankCode"];
            this.rankValidDate = data["rankValidDate"];
            this.currentPoint = data["currentPoint"];
            this.nationalityCode = data["nationalityCode"];
            this.occupationCode = data["occupationCode"];
            this.hobby = data["hobby"];
            this.address = data["address"];
            this.ward = data["ward"];
            this.district = data["district"];
            this.province = data["province"];
            this.domain = data["domain"];
            this.country = data["country"];
            this.status = data["status"];
            this.lastActivityTime = data["lastActivityTime"] ? moment(data["lastActivityTime"].toString()) : <any>undefined;
            this.lastPurchaseTime = data["lastPurchaseTime"] ? moment(data["lastPurchaseTime"].toString()) : <any>undefined;
            this.communicationLanguage = data["communicationLanguage"];
            this.notes = data["notes"];
            this.rankPropose = data["rankPropose"];
            this.pinCode = data["pinCode"];
            this.nameUnSign = data["nameUnSign"];
            this.avatar = data["avatar"];
            this.workingPermit = data["workingPermit"];
            this.customerCode = data["customerCode"];
            this.interestOf = data["interestOf"];
            this.isInterestCobrand = data["isInterestCobrand"];
            this.memberCard = data["memberCard"];
            this.isForeigner = data["isForeigner"];
            this.isSynced = data["isSynced"];
            this.referralCode = data["referralCode"];
            this.accumulationPoint = data["accumulationPoint"];
            this.outletCode = data["outletCode"];
            this.zaloName = data["zaloName"];
            this.distributorCode = data["distributorCode"];
            this.distributorName = data["distributorName"];
            this.regionCode = data["regionCode"];
            this.targetRevenue = data["targetRevenue"];
            this.actualRevenue = data["actualRevenue"];
            this.bonus = data["bonus"];
            this.missingRevenue = data["missingRevenue"];
            this.revenueUpdateDate = data["revenueUpdateDate"];
            this.note1 = data["note1"];
            this.note2 = data["note2"];
            this.note3 = data["note3"];
            this.note4 = data["note4"];
            this.note5 = data["note5"];
            this.salesChannel = data["salesChannel"];
            this.supervisorCode = data["supervisorCode"];
            this.supervisorName = data["supervisorName"];
            this.phoneFirstDate = data["phoneFirstDate"] ? moment(data["phoneFirstDate"].toString()) : <any>undefined;
            this.lockUpdatePhone = data["lockUpdatePhone"];
            this.browserCode = data["browserCode"];
            this.deviceNameCode = data["deviceNameCode"];
            this.typeOfDeviceCode = data["typeOfDeviceCode"];
            this.salesmanCode = data["salesmanCode"];
            this.consumerID = data["consumerID"];
            this.lockUpdateChatID = data["lockUpdateChatID"];
            this.currentCoin = data["currentCoin"];
            this.pointToKeepRank = data["pointToKeepRank"];
            this.pointToNextRank = data["pointToNextRank"];
            this.expiringCoin = data["expiringCoin"];
            this.expiringCoinDate = data["expiringCoinDate"] ? moment(data["expiringCoinDate"].toString()) : <any>undefined;
            this.lockUpdateProfile = data["lockUpdateProfile"];
            this.outletType = data["outletType"];
            this.password = data["password"];
            this.accumulationPointSellIn = data["accumulationPointSellIn"];
            this.accumulationPointSellOut = data["accumulationPointSellOut"];
            this.businessType = data["businessType"];
            this.warehouseAddress = data["warehouseAddress"];
            this.bossName = data["bossName"];
            this.anniversaryDate = data["anniversaryDate"] ? moment(data["anniversaryDate"].toString()) : <any>undefined;
            this.taxCode = data["taxCode"];
            this.identificationCardNumber = data["identificationCardNumber"];
            this.bankAccountNumber = data["bankAccountNumber"];
            this.bankBranchName = data["bankBranchName"];
            this.bankAccountName = data["bankAccountName"];
            this.bankName = data["bankName"];
            this.legalPersonalName = data["legalPersonalName"];
            this.legalPersonal = data["legalPersonal"];
            this.taxAddress = data["taxAddress"];
            this.storeType = data["storeType"];
            this.deptCode = data["deptCode"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            if (data["communicationChannels"] && data["communicationChannels"].constructor === Array) {
                this.communicationChannels = [];
                for (let item of data["communicationChannels"])
                    this.communicationChannels.push(SocialMemberChannelInfo.fromJS(item));
            }
            this.communicationChannelsString = data["communicationChannelsString"];
            this.rankName = data["rankName"];
            this.outletTypeName = data["outletTypeName"];
            this.nationalityName = data["nationalityName"];
            this.chatId = data["chatId"];
            this.businessCertification = data["businessCertification"];
            this.businessCertificationback = data["businessCertificationback"];
            this.userId = data["userId"];
            this.userName = data["userName"];
            this.identificationCardFrontImage = data["identificationCardFrontImage"];
            this.identificationCardBackImage = data["identificationCardBackImage"];
            this.storeArea = data["storeArea"];
            this.employeeQuantity = data["employeeQuantity"];
            this.verifyStatus = data["verifyStatus"];
            this.id = data["id"];
            this.subLayer = data["subLayer"];
            this.brand = data["brand"];
        }
    }

    static fromJS(data: any): OutletInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new OutletInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberCode"] = this.memberCode;
        data["name"] = this.name;
        data["phone"] = this.phone;
        data["lng"] = this.lng;
        data["lat"] = this.lat;
        data["email"] = this.email;
        data["gender"] = this.gender;
        data["birthday"] = this.birthday;
        data["registrationDate"] = this.registrationDate;
        data["pid"] = this.pid;
        data["sourceID"] = this.sourceID;
        data["receiveAds"] = this.receiveAds;
        data["rankCode"] = this.rankCode;
        data["rankValidDate"] = this.rankValidDate;
        data["currentPoint"] = this.currentPoint;
        data["nationalityCode"] = this.nationalityCode;
        data["occupationCode"] = this.occupationCode;
        data["hobby"] = this.hobby;
        data["address"] = this.address;
        data["ward"] = this.ward;
        data["district"] = this.district;
        data["province"] = this.province;
        data["domain"] = this.domain;
        data["country"] = this.country;
        data["status"] = this.status;
        data["lastActivityTime"] = this.lastActivityTime ? this.lastActivityTime.toISOString() : <any>undefined;
        data["lastPurchaseTime"] = this.lastPurchaseTime ? this.lastPurchaseTime.toISOString() : <any>undefined;
        data["communicationLanguage"] = this.communicationLanguage;
        data["notes"] = this.notes;
        data["rankPropose"] = this.rankPropose;
        data["pinCode"] = this.pinCode;
        data["nameUnSign"] = this.nameUnSign;
        data["avatar"] = this.avatar;
        data["workingPermit"] = this.workingPermit;
        data["customerCode"] = this.customerCode;
        data["interestOf"] = this.interestOf;
        data["isInterestCobrand"] = this.isInterestCobrand;
        data["memberCard"] = this.memberCard;
        data["isForeigner"] = this.isForeigner;
        data["isSynced"] = this.isSynced;
        data["referralCode"] = this.referralCode;
        data["accumulationPoint"] = this.accumulationPoint;
        data["outletCode"] = this.outletCode;
        data["zaloName"] = this.zaloName;
        data["distributorCode"] = this.distributorCode;
        data["distributorName"] = this.distributorName;
        data["regionCode"] = this.regionCode;
        data["targetRevenue"] = this.targetRevenue;
        data["actualRevenue"] = this.actualRevenue;
        data["bonus"] = this.bonus;
        data["missingRevenue"] = this.missingRevenue;
        data["revenueUpdateDate"] = this.revenueUpdateDate;
        data["note1"] = this.note1;
        data["note2"] = this.note2;
        data["note3"] = this.note3;
        data["note4"] = this.note4;
        data["note5"] = this.note5;
        data["salesChannel"] = this.salesChannel;
        data["supervisorCode"] = this.supervisorCode;
        data["supervisorName"] = this.supervisorName;
        data["phoneFirstDate"] = this.phoneFirstDate ? this.phoneFirstDate.toISOString() : <any>undefined;
        data["lockUpdatePhone"] = this.lockUpdatePhone;
        data["browserCode"] = this.browserCode;
        data["deviceNameCode"] = this.deviceNameCode;
        data["typeOfDeviceCode"] = this.typeOfDeviceCode;
        data["salesmanCode"] = this.salesmanCode;
        data["consumerID"] = this.consumerID;
        data["lockUpdateChatID"] = this.lockUpdateChatID;
        data["currentCoin"] = this.currentCoin;
        data["pointToKeepRank"] = this.pointToKeepRank;
        data["pointToNextRank"] = this.pointToNextRank;
        data["expiringCoin"] = this.expiringCoin;
        data["expiringCoinDate"] = this.expiringCoinDate ? this.expiringCoinDate.toISOString() : <any>undefined;
        data["lockUpdateProfile"] = this.lockUpdateProfile;
        data["outletType"] = this.outletType;
        data["password"] = this.password;
        data["accumulationPointSellIn"] = this.accumulationPointSellIn;
        data["accumulationPointSellOut"] = this.accumulationPointSellOut;
        data["businessType"] = this.businessType;
        data["warehouseAddress"] = this.warehouseAddress;
        data["bossName"] = this.bossName;
        data["anniversaryDate"] = this.anniversaryDate ? this.anniversaryDate.toISOString() : <any>undefined;
        data["taxCode"] = this.taxCode;
        data["identificationCardNumber"] = this.identificationCardNumber;
        data["bankAccountNumber"] = this.bankAccountNumber;
        data["bankBranchName"] = this.bankBranchName;
        data["bankAccountName"] = this.bankAccountName;
        data["bankName"] = this.bankName;
        data["legalPersonalName"] = this.legalPersonalName;
        data["legalPersonal"] = this.legalPersonal;
        data["taxAddress"] = this.taxAddress;
        data["storeType"] = this.storeType;
        data["deptCode"] = this.deptCode;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        if (this.communicationChannels && this.communicationChannels.constructor === Array) {
            data["communicationChannels"] = [];
            for (let item of this.communicationChannels)
                data["communicationChannels"].push(item.toJSON());
        }
        data["communicationChannelsString"] = this.communicationChannelsString;
        data["rankName"] = this.rankName;
        data["outletTypeName"] = this.outletTypeName;
        data["nationalityName"] = this.nationalityName;
        data["chatId"] = this.chatId;
        data["businessCertification"] = this.businessCertification;
        data["businessCertificationback"] = this.businessCertificationback;
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["identificationCardFrontImage"] = this.identificationCardFrontImage;
        data["identificationCardBackImage"] = this.identificationCardBackImage;
        data["storeArea"] = this.storeArea;
        data["employeeQuantity"] = this.employeeQuantity;
        data["verifyStatus"] = this.verifyStatus;
        data["id"] = this.id;
        data["subLayer"] = this.subLayer;
        data["brand"] = this.brand;
        return data;
    }
}

export interface IOutletInfoDto {
    memberCode: string | undefined;
    name: string | undefined;
    phone: string | undefined;
    lng: string | undefined;
    lat: string | undefined;
    email: string | undefined;
    gender: string | undefined;
    birthday: number | undefined;
    registrationDate: number | undefined;
    pid: string | undefined;
    sourceID: string | undefined;
    receiveAds: boolean | undefined;
    rankCode: string | undefined;
    rankValidDate: number | undefined;
    currentPoint: number | undefined;
    nationalityCode: string | undefined;
    occupationCode: string | undefined;
    hobby: string | undefined;
    address: string | undefined;
    ward: string | undefined;
    district: string | undefined;
    province: string | undefined;
    domain: string | undefined;
    country: string | undefined;
    status: string | undefined;
    lastActivityTime: moment.Moment | undefined;
    lastPurchaseTime: moment.Moment | undefined;
    communicationLanguage: string | undefined;
    notes: string | undefined;
    rankPropose: string | undefined;
    pinCode: string | undefined;
    nameUnSign: string | undefined;
    avatar: string | undefined;
    workingPermit: boolean | undefined;
    customerCode: string | undefined;
    interestOf: string | undefined;
    isInterestCobrand: boolean | undefined;
    memberCard: string | undefined;
    isForeigner: boolean | undefined;
    isSynced: boolean | undefined;
    referralCode: string | undefined;
    accumulationPoint: number | undefined;
    outletCode: string | undefined;
    zaloName: string | undefined;
    distributorCode: string | undefined;
    distributorName: string | undefined;
    regionCode: string | undefined;
    targetRevenue: number | undefined;
    actualRevenue: number | undefined;
    bonus: number | undefined;
    missingRevenue: number | undefined;
    revenueUpdateDate: number | undefined;
    note1: string | undefined;
    note2: string | undefined;
    note3: string | undefined;
    note4: string | undefined;
    note5: string | undefined;
    salesChannel: string | undefined;
    supervisorCode: string | undefined;
    supervisorName: string | undefined;
    phoneFirstDate: moment.Moment | undefined;
    lockUpdatePhone: boolean | undefined;
    browserCode: string | undefined;
    deviceNameCode: string | undefined;
    typeOfDeviceCode: string | undefined;
    salesmanCode: string | undefined;
    consumerID: number | undefined;
    lockUpdateChatID: boolean | undefined;
    currentCoin: number | undefined;
    pointToKeepRank: number | undefined;
    pointToNextRank: number | undefined;
    expiringCoin: number | undefined;
    expiringCoinDate: moment.Moment | undefined;
    lockUpdateProfile: boolean | undefined;
    outletType: string | undefined;
    password: string | undefined;
    accumulationPointSellIn: number | undefined;
    accumulationPointSellOut: number | undefined;
    businessType: string | undefined;
    warehouseAddress: string | undefined;
    bossName: string | undefined;
    anniversaryDate: moment.Moment | undefined;
    taxCode: string | undefined;
    identificationCardNumber: string | undefined;
    bankAccountNumber: string | undefined;
    bankBranchName: string | undefined;
    bankAccountName: string | undefined;
    bankName: string | undefined;
    legalPersonalName: string | undefined;
    legalPersonal: string | undefined;
    taxAddress: string | undefined;
    storeType: string | undefined;
    deptCode: string | undefined;
    creationTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    communicationChannels: SocialMemberChannelInfo[] | undefined;
    communicationChannelsString: string | undefined;
    rankName: string | undefined;
    outletTypeName: string | undefined;
    nationalityName: string | undefined;
    chatId: string | undefined;
    businessCertification: string | undefined;
    businessCertificationback: string | undefined;
    userId: number | undefined;
    userName: string | undefined;
    identificationCardFrontImage: string | undefined;
    identificationCardBackImage: string | undefined;
    storeArea: number | undefined;
    employeeQuantity: number | undefined;
    verifyStatus: string | undefined;
    id: number | undefined;
    subLayer: string | undefined;
    brand: string | undefined;

}

export class SocialMemberChannelInfo implements ISocialMemberChannelInfo {
    channelCode!: string | undefined;
    memberChannelId!: string | undefined;
    extraParams!: { [key: string]: string; } | undefined;

    constructor(data?: ISocialMemberChannelInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.channelCode = data["channelCode"];
            this.memberChannelId = data["memberChannelId"];
            if (data["extraParams"]) {
                this.extraParams = {};
                for (let key in data["extraParams"]) {
                    if (data["extraParams"].hasOwnProperty(key))
                        this.extraParams[key] = data["extraParams"][key];
                }
            }
        }
    }

    static fromJS(data: any): SocialMemberChannelInfo {
        data = typeof data === 'object' ? data : {};
        let result = new SocialMemberChannelInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["channelCode"] = this.channelCode;
        data["memberChannelId"] = this.memberChannelId;
        if (this.extraParams) {
            data["extraParams"] = {};
            for (let key in this.extraParams) {
                if (this.extraParams.hasOwnProperty(key))
                    data["extraParams"][key] = this.extraParams[key];
            }
        }
        return data;
    }
}

export interface ISocialMemberChannelInfo {
    channelCode: string | undefined;
    memberChannelId: string | undefined;
    extraParams: { [key: string]: string; } | undefined;
}

export class GetAllOutletNoFilterDto implements IGetAllOutletNoFilterDto {
    id!: number | undefined;
    memberCode!: string | undefined;
    name!: string | undefined;
    outletType!: string | undefined;

    constructor(data?: IGetAllOutletNoFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.memberCode = data["memberCode"];
            this.name = data["name"];
            this.outletType = data["outletType"];
        }
    }

    static fromJS(data: any): GetAllOutletNoFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllOutletNoFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["memberCode"] = this.memberCode;
        data["name"] = this.name;
        data["outletType"] = this.outletType;
        return data;
    }
}

export interface IGetAllOutletNoFilterDto {
    id: number | undefined;
    memberCode: string | undefined;
    name: string | undefined;
    outletType: string | undefined;
}

export class GetAllRetailerUpdatePhoneInput implements IGetAllRetailerUpdatePhoneInput {
    filter!: string | undefined;
    ids!: number[] | undefined;
    name!: string | undefined;
    phone!: string | undefined;
    outletType!: string | undefined;
    statusFilter!: string | undefined;
    phoneUpdateStatusFilter!: string | undefined;
    maxPhoneUpdatedDateFilter!: moment.Moment | undefined;
    minPhoneUpdatedDateFilter!: moment.Moment | undefined;
    sorting!: string | undefined;
    skipCount!: number | undefined;
    maxResultCount!: number | undefined;
    brand!: string | undefined;

    constructor(data?: IGetAllRetailerUpdatePhoneInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.filter = data["filter"];
            if (data["ids"] && data["ids"].constructor === Array) {
                this.ids = [];
                for (let item of data["ids"])
                    this.ids.push(item);
            }
            this.name = data["name"];
            this.phone = data["phone"];
            this.outletType = data["outletType"];
            this.statusFilter = data["statusFilter"];
            this.phoneUpdateStatusFilter = data["phoneUpdateStatusFilter"];
            this.maxPhoneUpdatedDateFilter = data["maxPhoneUpdatedDateFilter"] ? moment(data["maxPhoneUpdatedDateFilter"].toString()) : <any>undefined;
            this.minPhoneUpdatedDateFilter = data["minPhoneUpdatedDateFilter"] ? moment(data["minPhoneUpdatedDateFilter"].toString()) : <any>undefined;
            this.sorting = data["sorting"];
            this.skipCount = data["skipCount"];
            this.maxResultCount = data["maxResultCount"];
            this.brand = data["brand"];
        }
    }

    static fromJS(data: any): GetAllRetailerUpdatePhoneInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllRetailerUpdatePhoneInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        if (this.ids && this.ids.constructor === Array) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        data["name"] = this.name;
        data["phone"] = this.phone;
        data["outletType"] = this.outletType;
        data["statusFilter"] = this.statusFilter;
        data["phoneUpdateStatusFilter"] = this.phoneUpdateStatusFilter;
        data["maxPhoneUpdatedDateFilter"] = this.maxPhoneUpdatedDateFilter ? this.maxPhoneUpdatedDateFilter.toISOString() : <any>undefined;
        data["minPhoneUpdatedDateFilter"] = this.minPhoneUpdatedDateFilter ? this.minPhoneUpdatedDateFilter.toISOString() : <any>undefined;
        data["sorting"] = this.sorting;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        data["brand"] = this.brand;
        return data;
    }
}

export interface IGetAllRetailerUpdatePhoneInput {
    filter: string | undefined;
    ids: number[] | undefined;
    name: string | undefined;
    phone: string | undefined;
    outletType: string | undefined;
    statusFilter: string | undefined;
    phoneUpdateStatusFilter: string | undefined;
    maxPhoneUpdatedDateFilter: moment.Moment | undefined;
    minPhoneUpdatedDateFilter: moment.Moment | undefined;
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;
    brand: string | undefined;
}

export class GetOutletInfoForEditOutput implements IGetOutletInfoForEditOutput {
    outletInfo!: CreateOrEditOutletInfoDto | undefined;
    itemChange!: string[] | undefined;
    isExitRequestUpdate!: boolean | undefined;
    allowDistance!: number | undefined;
    challengeDistanceGPS!: number | undefined;
    fieldNeedUpdate!: string[] | undefined;
    isDisUser!: boolean | undefined;
    isConfirmedPolicy!: boolean | undefined;
    channelsCode!: string[] | undefined;
    salesmanCode!: string | undefined;
    beatPlanCode!: string | undefined;
    homePhone!: string | undefined;
    rewardResult!: RewardResult[] | undefined;
    points!: GetOutletInfoPoints[] | undefined;
    ranks!: GetOutletInfoRanks[] | undefined;
    sales!: GetOutletInfoTotalSales | undefined;
    isNeedUpdateInfor!: boolean | undefined;
    isNeedUpdateBank!: boolean | undefined;
    newNotify!: number | undefined;
    businessCertification!: string | undefined;
    businessCertificationback!: string | undefined;
    verifyStatus!: string | undefined;
    storeArea!: number | undefined;
    employeeQuantity!: number | undefined;
    isExitsUser!: boolean | undefined;
    subLayer!: string | undefined;
    brand!: string | undefined;

    constructor(data?: IGetOutletInfoForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.outletInfo = data["outletInfo"] ? CreateOrEditOutletInfoDto.fromJS(data["outletInfo"]) : <any>undefined;
            if (data["itemChange"] && data["itemChange"].constructor === Array) {
                this.itemChange = [];
                for (let item of data["itemChange"])
                    this.itemChange.push(item);
            }
            this.isExitRequestUpdate = data["isExitRequestUpdate"];
            this.allowDistance = data["allowDistance"];
            this.challengeDistanceGPS = data["challengeDistanceGPS"];
            if (data["fieldNeedUpdate"] && data["fieldNeedUpdate"].constructor === Array) {
                this.fieldNeedUpdate = [];
                for (let item of data["fieldNeedUpdate"])
                    this.fieldNeedUpdate.push(item);
            }
            this.isDisUser = data["isDisUser"];
            this.isConfirmedPolicy = data["isConfirmedPolicy"];
            if (data["channelsCode"] && data["channelsCode"].constructor === Array) {
                this.channelsCode = [];
                for (let item of data["channelsCode"])
                    this.channelsCode.push(item);
            }
            this.salesmanCode = data["salesmanCode"];
            this.beatPlanCode = data["beatPlanCode"];
            this.homePhone = data["homePhone"];
            if (data["rewardResult"] && data["rewardResult"].constructor === Array) {
                this.rewardResult = [];
                for (let item of data["rewardResult"])
                    this.rewardResult.push(RewardResult.fromJS(item));
            }
            if (data["points"] && data["points"].constructor === Array) {
                this.points = [];
                for (let item of data["points"])
                    this.points.push(GetOutletInfoPoints.fromJS(item));
            }
            if (data["ranks"] && data["ranks"].constructor === Array) {
                this.ranks = [];
                for (let item of data["ranks"])
                    this.ranks.push(GetOutletInfoRanks.fromJS(item));
            }
            this.sales = data["sales"] ? GetOutletInfoTotalSales.fromJS(data["sales"]) : <any>undefined;
            this.isNeedUpdateInfor = data["isNeedUpdateInfor"];
            this.isNeedUpdateBank = data["isNeedUpdateBank"];
            this.newNotify = data["newNotify"];
            this.businessCertification = data["businessCertification"];
            this.businessCertificationback = data["businessCertificationback"];
            this.verifyStatus = data["verifyStatus"];
            this.storeArea = data["storeArea"];
            this.employeeQuantity = data["employeeQuantity"];
            this.isExitsUser = data["isExitsUser"];
            this.subLayer = data["subLayer"];
            this.brand = data["brand"];
        }
    }

    static fromJS(data: any): GetOutletInfoForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetOutletInfoForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["outletInfo"] = this.outletInfo ? this.outletInfo.toJSON() : <any>undefined;
        if (this.itemChange && this.itemChange.constructor === Array) {
            data["itemChange"] = [];
            for (let item of this.itemChange)
                data["itemChange"].push(item);
        }
        data["isExitRequestUpdate"] = this.isExitRequestUpdate;
        data["allowDistance"] = this.allowDistance;
        data["challengeDistanceGPS"] = this.challengeDistanceGPS;
        if (this.fieldNeedUpdate && this.fieldNeedUpdate.constructor === Array) {
            data["fieldNeedUpdate"] = [];
            for (let item of this.fieldNeedUpdate)
                data["fieldNeedUpdate"].push(item);
        }
        data["isDisUser"] = this.isDisUser;
        data["isConfirmedPolicy"] = this.isConfirmedPolicy;
        if (this.channelsCode && this.channelsCode.constructor === Array) {
            data["channelsCode"] = [];
            for (let item of this.channelsCode)
                data["channelsCode"].push(item);
        }
        data["salesmanCode"] = this.salesmanCode;
        data["beatPlanCode"] = this.beatPlanCode;
        data["homePhone"] = this.homePhone;
        if (this.rewardResult && this.rewardResult.constructor === Array) {
            data["rewardResult"] = [];
            for (let item of this.rewardResult)
                data["rewardResult"].push(item.toJSON());
        }
        if (this.points && this.points.constructor === Array) {
            data["points"] = [];
            for (let item of this.points)
                data["points"].push(item.toJSON());
        }
        if (this.ranks && this.ranks.constructor === Array) {
            data["ranks"] = [];
            for (let item of this.ranks)
                data["ranks"].push(item.toJSON());
        }
        data["sales"] = this.sales ? this.sales.toJSON() : <any>undefined;
        data["isNeedUpdateInfor"] = this.isNeedUpdateInfor;
        data["isNeedUpdateBank"] = this.isNeedUpdateBank;
        data["newNotify"] = this.newNotify;
        data["businessCertification"] = this.businessCertification;
        data["businessCertificationback"] = this.businessCertificationback;
        data["verifyStatus"] = this.verifyStatus;
        data["storeArea"] = this.storeArea;
        data["employeeQuantity"] = this.employeeQuantity;
        data["isExitsUser"] = this.isExitsUser;
        data["brand"] = this.brand;
        return data;
    }
}

export interface IGetOutletInfoForEditOutput {
    outletInfo: CreateOrEditOutletInfoDto | undefined;
    itemChange: string[] | undefined;
    isExitRequestUpdate: boolean | undefined;
    allowDistance: number | undefined;
    challengeDistanceGPS: number | undefined;
    fieldNeedUpdate: string[] | undefined;
    isDisUser: boolean | undefined;
    isConfirmedPolicy: boolean | undefined;
    channelsCode: string[] | undefined;
    salesmanCode: string | undefined;
    beatPlanCode: string | undefined;
    homePhone: string | undefined;
    rewardResult: RewardResult[] | undefined;
    points: GetOutletInfoPoints[] | undefined;
    ranks: GetOutletInfoRanks[] | undefined;
    sales: GetOutletInfoTotalSales | undefined;
    isNeedUpdateInfor: boolean | undefined;
    isNeedUpdateBank: boolean | undefined;
    newNotify: number | undefined;
    businessCertification: string | undefined;
    businessCertificationback: string | undefined;
    verifyStatus: string | undefined;
    storeArea: number | undefined;
    employeeQuantity: number | undefined;
    isExitsUser: boolean | undefined;
    subLayer: string | undefined;
    brand: string | undefined;
}

export class CreateOrEditOutletInfoDto implements ICreateOrEditOutletInfoDto {
    memberCode!: string | undefined;
    name!: string | undefined;
    phone!: string | undefined;
    lng!: string | undefined;
    lat!: string | undefined;
    email!: string | undefined;
    gender!: string | undefined;
    birthday!: number | undefined;
    registrationDate!: number | undefined;
    pid!: string | undefined;
    sourceID!: string | undefined;
    receiveAds!: boolean | undefined;
    rankCode!: string | undefined;
    rankValidDate!: number | undefined;
    currentPoint!: number | undefined;
    nationalityCode!: string | undefined;
    occupationCode!: string | undefined;
    hobby!: string | undefined;
    address!: string | undefined;
    ward!: string | undefined;
    district!: string | undefined;
    province!: string | undefined;
    country!: string | undefined;
    status!: string | undefined;
    lastActivityTime!: moment.Moment | undefined;
    lastPurchaseTime!: moment.Moment | undefined;
    communicationLanguage!: string | undefined;
    notes!: string | undefined;
    rankPropose!: string | undefined;
    pinCode!: string | undefined;
    nameUnSign!: string | undefined;
    avatar!: string | undefined;
    workingPermit!: boolean | undefined;
    customerCode!: string | undefined;
    interestOf!: string | undefined;
    isInterestCobrand!: boolean | undefined;
    memberCard!: string | undefined;
    isForeigner!: boolean | undefined;
    isSynced!: boolean | undefined;
    referralCode!: string | undefined;
    accumulationPoint!: number | undefined;
    outletCode!: string | undefined;
    zaloName!: string | undefined;
    distributorCode!: string | undefined;
    distributorName!: string | undefined;
    regionCode!: string | undefined;
    targetRevenue!: number | undefined;
    actualRevenue!: number | undefined;
    bonus!: number | undefined;
    missingRevenue!: number | undefined;
    revenueUpdateDate!: number | undefined;
    note1!: string | undefined;
    note2!: string | undefined;
    note3!: string | undefined;
    note4!: string | undefined;
    note5!: string | undefined;
    salesChannel!: string | undefined;
    supervisorCode!: string | undefined;
    supervisorName!: string | undefined;
    phoneFirstDate!: moment.Moment | undefined;
    lockUpdatePhone!: boolean | undefined;
    browserCode!: string | undefined;
    deviceNameCode!: string | undefined;
    typeOfDeviceCode!: string | undefined;
    salesmanCode!: string | undefined;
    consumerID!: number | undefined;
    lockUpdateChatID!: boolean | undefined;
    currentCoin!: number | undefined;
    pointToKeepRank!: number | undefined;
    pointToNextRank!: number | undefined;
    expiringCoin!: number | undefined;
    expiringCoinDate!: moment.Moment | undefined;
    lockUpdateProfile!: boolean | undefined;
    outletType!: string | undefined;
    password!: string | undefined;
    userNameOrEmailAddress!: string | undefined;
    warehouseAddress!: string | undefined;
    businessType!: string | undefined;
    accumulationPointSellIn!: number | undefined;
    accumulationPointSellOut!: number | undefined;
    sapCode!: string | undefined;
    bankAccountNumber!: string | undefined;
    bankAccountName!: string | undefined;
    bankName!: string | undefined;
    bankBranchName!: string | undefined;
    bossName!: string | undefined;
    anniversaryDate!: moment.Moment | undefined;
    taxCode!: string | undefined;
    identificationCardNumber!: string | undefined;
    identificationCardFrontImage!: string | undefined;
    identificationCardBackImage!: string | undefined;
    accountCode!: string | undefined;
    legalPersonalName!: string | undefined;
    legalPersonal!: string | undefined;
    taxAddress!: string | undefined;
    storeType!: string | undefined;
    referrerCode!: string | undefined;
    communicationChannels!: SocialMemberChannelInfo[] | undefined;
    chatId!: string | undefined;
    salesmanName!: string | undefined;
    salesmanPhone!: string | undefined;
    lastModificationTime!: moment.Moment | undefined;
    rankName!: string | undefined;
    organizationUnits!: number[] | undefined;
    businessCertification!: string | undefined;
    businessCertificationback!: string | undefined;
    provinceName!: string | undefined;
    districtName!: string | undefined;
    createdFrom!: string | undefined;
    verifyStatus!: string | undefined;
    storeArea!: number | undefined;
    employeeQuantity!: number | undefined;
    wardName!: string | undefined;
    deptCode!: string | undefined;
    deptName!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditOutletInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberCode = data["memberCode"];
            this.name = data["name"];
            this.phone = data["phone"];
            this.lng = data["lng"];
            this.lat = data["lat"];
            this.email = data["email"];
            this.gender = data["gender"];
            this.birthday = data["birthday"];
            this.registrationDate = data["registrationDate"];
            this.pid = data["pid"];
            this.sourceID = data["sourceID"];
            this.receiveAds = data["receiveAds"];
            this.rankCode = data["rankCode"];
            this.rankValidDate = data["rankValidDate"];
            this.currentPoint = data["currentPoint"];
            this.nationalityCode = data["nationalityCode"];
            this.occupationCode = data["occupationCode"];
            this.hobby = data["hobby"];
            this.address = data["address"];
            this.ward = data["ward"];
            this.district = data["district"];
            this.province = data["province"];
            this.country = data["country"];
            this.status = data["status"];
            this.lastActivityTime = data["lastActivityTime"] ? moment(data["lastActivityTime"].toString()) : <any>undefined;
            this.lastPurchaseTime = data["lastPurchaseTime"] ? moment(data["lastPurchaseTime"].toString()) : <any>undefined;
            this.communicationLanguage = data["communicationLanguage"];
            this.notes = data["notes"];
            this.rankPropose = data["rankPropose"];
            this.pinCode = data["pinCode"];
            this.nameUnSign = data["nameUnSign"];
            this.avatar = data["avatar"];
            this.workingPermit = data["workingPermit"];
            this.customerCode = data["customerCode"];
            this.interestOf = data["interestOf"];
            this.isInterestCobrand = data["isInterestCobrand"];
            this.memberCard = data["memberCard"];
            this.isForeigner = data["isForeigner"];
            this.isSynced = data["isSynced"];
            this.referralCode = data["referralCode"];
            this.accumulationPoint = data["accumulationPoint"];
            this.outletCode = data["outletCode"];
            this.zaloName = data["zaloName"];
            this.distributorCode = data["distributorCode"];
            this.distributorName = data["distributorName"];
            this.regionCode = data["regionCode"];
            this.targetRevenue = data["targetRevenue"];
            this.actualRevenue = data["actualRevenue"];
            this.bonus = data["bonus"];
            this.missingRevenue = data["missingRevenue"];
            this.revenueUpdateDate = data["revenueUpdateDate"];
            this.note1 = data["note1"];
            this.note2 = data["note2"];
            this.note3 = data["note3"];
            this.note4 = data["note4"];
            this.note5 = data["note5"];
            this.salesChannel = data["salesChannel"];
            this.supervisorCode = data["supervisorCode"];
            this.supervisorName = data["supervisorName"];
            this.phoneFirstDate = data["phoneFirstDate"] ? moment(data["phoneFirstDate"].toString()) : <any>undefined;
            this.lockUpdatePhone = data["lockUpdatePhone"];
            this.browserCode = data["browserCode"];
            this.deviceNameCode = data["deviceNameCode"];
            this.typeOfDeviceCode = data["typeOfDeviceCode"];
            this.salesmanCode = data["salesmanCode"];
            this.consumerID = data["consumerID"];
            this.lockUpdateChatID = data["lockUpdateChatID"];
            this.currentCoin = data["currentCoin"];
            this.pointToKeepRank = data["pointToKeepRank"];
            this.pointToNextRank = data["pointToNextRank"];
            this.expiringCoin = data["expiringCoin"];
            this.expiringCoinDate = data["expiringCoinDate"] ? moment(data["expiringCoinDate"].toString()) : <any>undefined;
            this.lockUpdateProfile = data["lockUpdateProfile"];
            this.outletType = data["outletType"];
            this.password = data["password"];
            this.userNameOrEmailAddress = data["userNameOrEmailAddress"];
            this.warehouseAddress = data["warehouseAddress"];
            this.businessType = data["businessType"];
            this.accumulationPointSellIn = data["accumulationPointSellIn"];
            this.accumulationPointSellOut = data["accumulationPointSellOut"];
            this.sapCode = data["sapCode"];
            this.bankAccountNumber = data["bankAccountNumber"];
            this.bankAccountName = data["bankAccountName"];
            this.bankName = data["bankName"];
            this.bankBranchName = data["bankBranchName"];
            this.bossName = data["bossName"];
            this.anniversaryDate = data["anniversaryDate"] ? moment(data["anniversaryDate"].toString()) : <any>undefined;
            this.taxCode = data["taxCode"];
            this.identificationCardNumber = data["identificationCardNumber"];
            this.identificationCardFrontImage = data["identificationCardFrontImage"];
            this.identificationCardBackImage = data["identificationCardBackImage"];
            this.accountCode = data["accountCode"];
            this.legalPersonalName = data["legalPersonalName"];
            this.legalPersonal = data["legalPersonal"];
            this.taxAddress = data["taxAddress"];
            this.storeType = data["storeType"];
            this.referrerCode = data["referrerCode"];
            if (data["communicationChannels"] && data["communicationChannels"].constructor === Array) {
                this.communicationChannels = [];
                for (let item of data["communicationChannels"])
                    this.communicationChannels.push(SocialMemberChannelInfo.fromJS(item));
            }
            this.chatId = data["chatId"];
            this.salesmanName = data["salesmanName"];
            this.salesmanPhone = data["salesmanPhone"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.rankName = data["rankName"];
            if (data["organizationUnits"] && data["organizationUnits"].constructor === Array) {
                this.organizationUnits = [];
                for (let item of data["organizationUnits"])
                    this.organizationUnits.push(item);
            }
            this.businessCertification = data["businessCertification"];
            this.businessCertificationback = data["businessCertificationback"];
            this.provinceName = data["provinceName"];
            this.districtName = data["districtName"];
            this.createdFrom = data["createdFrom"];
            this.verifyStatus = data["verifyStatus"];
            this.storeArea = data["storeArea"];
            this.employeeQuantity = data["employeeQuantity"];
            this.wardName = data["wardName"];
            this.deptCode = data["deptCode"];
            this.deptName = data["deptName"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditOutletInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditOutletInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberCode"] = this.memberCode;
        data["name"] = this.name;
        data["phone"] = this.phone;
        data["lng"] = this.lng;
        data["lat"] = this.lat;
        data["email"] = this.email;
        data["gender"] = this.gender;
        data["birthday"] = this.birthday;
        data["registrationDate"] = this.registrationDate;
        data["pid"] = this.pid;
        data["sourceID"] = this.sourceID;
        data["receiveAds"] = this.receiveAds;
        data["rankCode"] = this.rankCode;
        data["rankValidDate"] = this.rankValidDate;
        data["currentPoint"] = this.currentPoint;
        data["nationalityCode"] = this.nationalityCode;
        data["occupationCode"] = this.occupationCode;
        data["hobby"] = this.hobby;
        data["address"] = this.address;
        data["ward"] = this.ward;
        data["district"] = this.district;
        data["province"] = this.province;
        data["country"] = this.country;
        data["status"] = this.status;
        data["lastActivityTime"] = this.lastActivityTime ? this.lastActivityTime.toISOString() : <any>undefined;
        data["lastPurchaseTime"] = this.lastPurchaseTime ? this.lastPurchaseTime.toISOString() : <any>undefined;
        data["communicationLanguage"] = this.communicationLanguage;
        data["notes"] = this.notes;
        data["rankPropose"] = this.rankPropose;
        data["pinCode"] = this.pinCode;
        data["nameUnSign"] = this.nameUnSign;
        data["avatar"] = this.avatar;
        data["workingPermit"] = this.workingPermit;
        data["customerCode"] = this.customerCode;
        data["interestOf"] = this.interestOf;
        data["isInterestCobrand"] = this.isInterestCobrand;
        data["memberCard"] = this.memberCard;
        data["isForeigner"] = this.isForeigner;
        data["isSynced"] = this.isSynced;
        data["referralCode"] = this.referralCode;
        data["accumulationPoint"] = this.accumulationPoint;
        data["outletCode"] = this.outletCode;
        data["zaloName"] = this.zaloName;
        data["distributorCode"] = this.distributorCode;
        data["distributorName"] = this.distributorName;
        data["regionCode"] = this.regionCode;
        data["targetRevenue"] = this.targetRevenue;
        data["actualRevenue"] = this.actualRevenue;
        data["bonus"] = this.bonus;
        data["missingRevenue"] = this.missingRevenue;
        data["revenueUpdateDate"] = this.revenueUpdateDate;
        data["note1"] = this.note1;
        data["note2"] = this.note2;
        data["note3"] = this.note3;
        data["note4"] = this.note4;
        data["note5"] = this.note5;
        data["salesChannel"] = this.salesChannel;
        data["supervisorCode"] = this.supervisorCode;
        data["supervisorName"] = this.supervisorName;
        data["phoneFirstDate"] = this.phoneFirstDate ? this.phoneFirstDate.toISOString() : <any>undefined;
        data["lockUpdatePhone"] = this.lockUpdatePhone;
        data["browserCode"] = this.browserCode;
        data["deviceNameCode"] = this.deviceNameCode;
        data["typeOfDeviceCode"] = this.typeOfDeviceCode;
        data["salesmanCode"] = this.salesmanCode;
        data["consumerID"] = this.consumerID;
        data["lockUpdateChatID"] = this.lockUpdateChatID;
        data["currentCoin"] = this.currentCoin;
        data["pointToKeepRank"] = this.pointToKeepRank;
        data["pointToNextRank"] = this.pointToNextRank;
        data["expiringCoin"] = this.expiringCoin;
        data["expiringCoinDate"] = this.expiringCoinDate ? this.expiringCoinDate.toISOString() : <any>undefined;
        data["lockUpdateProfile"] = this.lockUpdateProfile;
        data["outletType"] = this.outletType;
        data["password"] = this.password;
        data["userNameOrEmailAddress"] = this.userNameOrEmailAddress;
        data["warehouseAddress"] = this.warehouseAddress;
        data["businessType"] = this.businessType;
        data["accumulationPointSellIn"] = this.accumulationPointSellIn;
        data["accumulationPointSellOut"] = this.accumulationPointSellOut;
        data["sapCode"] = this.sapCode;
        data["bankAccountNumber"] = this.bankAccountNumber;
        data["bankAccountName"] = this.bankAccountName;
        data["bankName"] = this.bankName;
        data["bankBranchName"] = this.bankBranchName;
        data["bossName"] = this.bossName;
        data["anniversaryDate"] = this.anniversaryDate ? this.anniversaryDate.toISOString() : <any>undefined;
        data["taxCode"] = this.taxCode;
        data["identificationCardNumber"] = this.identificationCardNumber;
        data["identificationCardFrontImage"] = this.identificationCardFrontImage;
        data["identificationCardBackImage"] = this.identificationCardBackImage;
        data["accountCode"] = this.accountCode;
        data["legalPersonalName"] = this.legalPersonalName;
        data["legalPersonal"] = this.legalPersonal;
        data["taxAddress"] = this.taxAddress;
        data["storeType"] = this.storeType;
        data["referrerCode"] = this.referrerCode;
        if (this.communicationChannels && this.communicationChannels.constructor === Array) {
            data["communicationChannels"] = [];
            for (let item of this.communicationChannels)
                data["communicationChannels"].push(item.toJSON());
        }
        data["chatId"] = this.chatId;
        data["salesmanName"] = this.salesmanName;
        data["salesmanPhone"] = this.salesmanPhone;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["rankName"] = this.rankName;
        if (this.organizationUnits && this.organizationUnits.constructor === Array) {
            data["organizationUnits"] = [];
            for (let item of this.organizationUnits)
                data["organizationUnits"].push(item);
        }
        data["businessCertification"] = this.businessCertification;
        data["businessCertificationback"] = this.businessCertificationback;
        data["provinceName"] = this.provinceName;
        data["districtName"] = this.districtName;
        data["createdFrom"] = this.createdFrom;
        data["verifyStatus"] = this.verifyStatus;
        data["storeArea"] = this.storeArea;
        data["employeeQuantity"] = this.employeeQuantity;
        data["wardName"] = this.wardName;
        data["deptCode"] = this.deptCode;
        data["deptName"] = this.deptName;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditOutletInfoDto {
    memberCode: string | undefined;
    name: string | undefined;
    phone: string | undefined;
    lng: string | undefined;
    lat: string | undefined;
    email: string | undefined;
    gender: string | undefined;
    birthday: number | undefined;
    registrationDate: number | undefined;
    pid: string | undefined;
    sourceID: string | undefined;
    receiveAds: boolean | undefined;
    rankCode: string | undefined;
    rankValidDate: number | undefined;
    currentPoint: number | undefined;
    nationalityCode: string | undefined;
    occupationCode: string | undefined;
    hobby: string | undefined;
    address: string | undefined;
    ward: string | undefined;
    district: string | undefined;
    province: string | undefined;
    country: string | undefined;
    status: string | undefined;
    lastActivityTime: moment.Moment | undefined;
    lastPurchaseTime: moment.Moment | undefined;
    communicationLanguage: string | undefined;
    notes: string | undefined;
    rankPropose: string | undefined;
    pinCode: string | undefined;
    nameUnSign: string | undefined;
    avatar: string | undefined;
    workingPermit: boolean | undefined;
    customerCode: string | undefined;
    interestOf: string | undefined;
    isInterestCobrand: boolean | undefined;
    memberCard: string | undefined;
    isForeigner: boolean | undefined;
    isSynced: boolean | undefined;
    referralCode: string | undefined;
    accumulationPoint: number | undefined;
    outletCode: string | undefined;
    zaloName: string | undefined;
    distributorCode: string | undefined;
    distributorName: string | undefined;
    regionCode: string | undefined;
    targetRevenue: number | undefined;
    actualRevenue: number | undefined;
    bonus: number | undefined;
    missingRevenue: number | undefined;
    revenueUpdateDate: number | undefined;
    note1: string | undefined;
    note2: string | undefined;
    note3: string | undefined;
    note4: string | undefined;
    note5: string | undefined;
    salesChannel: string | undefined;
    supervisorCode: string | undefined;
    supervisorName: string | undefined;
    phoneFirstDate: moment.Moment | undefined;
    lockUpdatePhone: boolean | undefined;
    browserCode: string | undefined;
    deviceNameCode: string | undefined;
    typeOfDeviceCode: string | undefined;
    salesmanCode: string | undefined;
    consumerID: number | undefined;
    lockUpdateChatID: boolean | undefined;
    currentCoin: number | undefined;
    pointToKeepRank: number | undefined;
    pointToNextRank: number | undefined;
    expiringCoin: number | undefined;
    expiringCoinDate: moment.Moment | undefined;
    lockUpdateProfile: boolean | undefined;
    outletType: string | undefined;
    password: string | undefined;
    userNameOrEmailAddress: string | undefined;
    warehouseAddress: string | undefined;
    businessType: string | undefined;
    accumulationPointSellIn: number | undefined;
    accumulationPointSellOut: number | undefined;
    sapCode: string | undefined;
    bankAccountNumber: string | undefined;
    bankAccountName: string | undefined;
    bankName: string | undefined;
    bankBranchName: string | undefined;
    bossName: string | undefined;
    anniversaryDate: moment.Moment | undefined;
    taxCode: string | undefined;
    identificationCardNumber: string | undefined;
    identificationCardFrontImage: string | undefined;
    identificationCardBackImage: string | undefined;
    accountCode: string | undefined;
    legalPersonalName: string | undefined;
    legalPersonal: string | undefined;
    taxAddress: string | undefined;
    storeType: string | undefined;
    referrerCode: string | undefined;
    communicationChannels: SocialMemberChannelInfo[] | undefined;
    chatId: string | undefined;
    salesmanName: string | undefined;
    salesmanPhone: string | undefined;
    lastModificationTime: moment.Moment | undefined;
    rankName: string | undefined;
    organizationUnits: number[] | undefined;
    businessCertification: string | undefined;
    businessCertificationback: string | undefined;
    provinceName: string | undefined;
    districtName: string | undefined;
    createdFrom: string | undefined;
    verifyStatus: string | undefined;
    storeArea: number | undefined;
    employeeQuantity: number | undefined;
    wardName: string | undefined;
    deptCode: string | undefined;
    deptName: string | undefined;
    id: number | undefined;
}

export class RewardResult implements IRewardResult {
    quarter!: string | undefined;
    quantityNumber!: number | undefined;
    quantity!: string | undefined;
    totalAmount!: number | undefined;
    paymentStatus!: string | undefined;

    constructor(data?: IRewardResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.quarter = data["quarter"];
            this.quantityNumber = data["quantityNumber"];
            this.quantity = data["quantity"];
            this.totalAmount = data["totalAmount"];
            this.paymentStatus = data["paymentStatus"];
        }
    }

    static fromJS(data: any): RewardResult {
        data = typeof data === 'object' ? data : {};
        let result = new RewardResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["quarter"] = this.quarter;
        data["quantityNumber"] = this.quantityNumber;
        data["quantity"] = this.quantity;
        data["totalAmount"] = this.totalAmount;
        data["paymentStatus"] = this.paymentStatus;
        return data;
    }
}

export interface IRewardResult {
    quarter: string | undefined;
    quantityNumber: number | undefined;
    quantity: string | undefined;
    totalAmount: number | undefined;
    paymentStatus: string | undefined;
}

export class GetOutletInfoPoints implements IGetOutletInfoPoints {
    name!: string | undefined;
    curentcoin!: number | undefined;
    curentpoint!: number | undefined;
    paymentcoin!: number | undefined;
    remaincoin!: number | undefined;
    type!: string | undefined;
    departmentCode!: string | undefined;
    departmentImage!: string | undefined;
    departmentName!: string | undefined;

    constructor(data?: IGetOutletInfoPoints) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.curentcoin = data["curentcoin"];
            this.curentpoint = data["curentpoint"];
            this.paymentcoin = data["paymentcoin"];
            this.remaincoin = data["remaincoin"];
            this.type = data["type"];
            this.departmentCode = data["departmentCode"];
            this.departmentImage = data["departmentImage"];
            this.departmentName = data["departmentName"];
        }
    }

    static fromJS(data: any): GetOutletInfoPoints {
        data = typeof data === 'object' ? data : {};
        let result = new GetOutletInfoPoints();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["curentcoin"] = this.curentcoin;
        data["curentpoint"] = this.curentpoint;
        data["paymentcoin"] = this.paymentcoin;
        data["remaincoin"] = this.remaincoin;
        data["type"] = this.type;
        data["departmentCode"] = this.departmentCode;
        data["departmentImage"] = this.departmentImage;
        data["departmentName"] = this.departmentName;
        return data;
    }
}

export interface IGetOutletInfoPoints {
    name: string | undefined;
    curentcoin: number | undefined;
    curentpoint: number | undefined;
    paymentcoin: number | undefined;
    remaincoin: number | undefined;
    type: string | undefined;
    departmentCode: string | undefined;
    departmentImage: string | undefined;
    departmentName: string | undefined;
}

export class GetOutletInfoRanks implements IGetOutletInfoRanks {
    name!: string | undefined;
    rankimage!: string | undefined;
    rankname!: string | undefined;
    curentpoint!: number | undefined;
    curentcoin!: number | undefined;
    pointToTempRank!: number | undefined;
    tempRank!: string | undefined;
    type!: string | undefined;
    departmentCode!: string | undefined;
    departmentImage!: string | undefined;
    departmentName!: string | undefined;

    constructor(data?: IGetOutletInfoRanks) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.rankimage = data["rankimage"];
            this.rankname = data["rankname"];
            this.curentpoint = data["curentpoint"];
            this.curentcoin = data["curentcoin"];
            this.pointToTempRank = data["pointToTempRank"];
            this.tempRank = data["tempRank"];
            this.type = data["type"];
            this.departmentCode = data["departmentCode"];
            this.departmentImage = data["departmentImage"];
            this.departmentName = data["departmentName"];
        }
    }

    static fromJS(data: any): GetOutletInfoRanks {
        data = typeof data === 'object' ? data : {};
        let result = new GetOutletInfoRanks();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["rankimage"] = this.rankimage;
        data["rankname"] = this.rankname;
        data["curentpoint"] = this.curentpoint;
        data["curentcoin"] = this.curentcoin;
        data["pointToTempRank"] = this.pointToTempRank;
        data["tempRank"] = this.tempRank;
        data["type"] = this.type;
        data["departmentCode"] = this.departmentCode;
        data["departmentImage"] = this.departmentImage;
        data["departmentName"] = this.departmentName;
        return data;
    }
}

export interface IGetOutletInfoRanks {
    name: string | undefined;
    rankimage: string | undefined;
    rankname: string | undefined;
    curentpoint: number | undefined;
    curentcoin: number | undefined;
    pointToTempRank: number | undefined;
    tempRank: string | undefined;
    type: string | undefined;
    departmentCode: string | undefined;
    departmentImage: string | undefined;
    departmentName: string | undefined;
}

export class GetOutletInfoTotalSales implements IGetOutletInfoTotalSales {
    listSales!: GetOutletInfoSales[] | undefined;
    totalQuantitySellIn!: number | undefined;
    totalQuantitySellOut!: number | undefined;
    totalQuantitySellVS!: number | undefined;
    totalQuantitySellDis!: number | undefined;

    constructor(data?: IGetOutletInfoTotalSales) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["listSales"] && data["listSales"].constructor === Array) {
                this.listSales = [];
                for (let item of data["listSales"])
                    this.listSales.push(GetOutletInfoSales.fromJS(item));
            }
            this.totalQuantitySellIn = data["totalQuantitySellIn"];
            this.totalQuantitySellOut = data["totalQuantitySellOut"];
            this.totalQuantitySellVS = data["totalQuantitySellVS"];
            this.totalQuantitySellDis = data["totalQuantitySellDis"];
        }
    }

    static fromJS(data: any): GetOutletInfoTotalSales {
        data = typeof data === 'object' ? data : {};
        let result = new GetOutletInfoTotalSales();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.listSales && this.listSales.constructor === Array) {
            data["listSales"] = [];
            for (let item of this.listSales)
                data["listSales"].push(item.toJSON());
        }
        data["totalQuantitySellIn"] = this.totalQuantitySellIn;
        data["totalQuantitySellOut"] = this.totalQuantitySellOut;
        data["totalQuantitySellVS"] = this.totalQuantitySellVS;
        data["totalQuantitySellDis"] = this.totalQuantitySellDis;
        return data;
    }
}

export interface IGetOutletInfoTotalSales {
    listSales: GetOutletInfoSales[] | undefined;
    totalQuantitySellIn: number | undefined;
    totalQuantitySellOut: number | undefined;
    totalQuantitySellVS: number | undefined;
    totalQuantitySellDis: number | undefined;
}

export class GetOutletInfoSales implements IGetOutletInfoSales {
    type!: string | undefined;
    quantity!: number | undefined;
    departmentImage!: string | undefined;
    departmentName!: string | undefined;

    constructor(data?: IGetOutletInfoSales) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.type = data["type"];
            this.quantity = data["quantity"];
            this.departmentImage = data["departmentImage"];
            this.departmentName = data["departmentName"];
        }
    }

    static fromJS(data: any): GetOutletInfoSales {
        data = typeof data === 'object' ? data : {};
        let result = new GetOutletInfoSales();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["quantity"] = this.quantity;
        data["departmentImage"] = this.departmentImage;
        data["departmentName"] = this.departmentName;
        return data;
    }
}

export interface IGetOutletInfoSales {
    type: string | undefined;
    quantity: number | undefined;
    departmentImage: string | undefined;
    departmentName: string | undefined;
}

export class GeoOutletDto implements IGeoOutletDto {
    outletCode!: string | undefined;
    long!: string | undefined;
    lat!: string | undefined;

    constructor(data?: IGeoOutletDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.outletCode = data["outletCode"];
            this.long = data["long"];
            this.lat = data["lat"];
        }
    }

    static fromJS(data: any): GeoOutletDto {
        data = typeof data === 'object' ? data : {};
        let result = new GeoOutletDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["outletCode"] = this.outletCode;
        data["long"] = this.long;
        data["lat"] = this.lat;
        return data;
    }
}

export interface IGeoOutletDto {
    outletCode: string | undefined;
    long: string | undefined;
    lat: string | undefined;
}

export class OutletInfosImportAgrs implements IOutletInfosImportAgrs {
    timeZoneOffset!: number | undefined;
    currentDate!: moment.Moment | undefined;
    isSuccess!: boolean | undefined;
    errorFilePath!: string | undefined;
    type!: string | undefined;
    tableName!: string | undefined;
    filePath!: string | undefined;
    fileName!: string | undefined;
    userId!: number | undefined;
    userName!: string | undefined;
    name!: string | undefined;
    tenantId!: number | undefined;
    currentLanguage!: string | undefined;
    apiUrl!: string | undefined;

    constructor(data?: IOutletInfosImportAgrs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.timeZoneOffset = data["timeZoneOffset"];
            this.currentDate = data["currentDate"] ? moment(data["currentDate"].toString()) : <any>undefined;
            this.isSuccess = data["isSuccess"];
            this.errorFilePath = data["errorFilePath"];
            this.type = data["type"];
            this.tableName = data["tableName"];
            this.filePath = data["filePath"];
            this.fileName = data["fileName"];
            this.userId = data["userId"];
            this.userName = data["userName"];
            this.name = data["name"];
            this.tenantId = data["tenantId"];
            this.currentLanguage = data["currentLanguage"];
            this.apiUrl = data["apiUrl"];
        }
    }

    static fromJS(data: any): OutletInfosImportAgrs {
        data = typeof data === 'object' ? data : {};
        let result = new OutletInfosImportAgrs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timeZoneOffset"] = this.timeZoneOffset;
        data["currentDate"] = this.currentDate ? this.currentDate.toISOString() : <any>undefined;
        data["isSuccess"] = this.isSuccess;
        data["errorFilePath"] = this.errorFilePath;
        data["type"] = this.type;
        data["tableName"] = this.tableName;
        data["filePath"] = this.filePath;
        data["fileName"] = this.fileName;
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["name"] = this.name;
        data["tenantId"] = this.tenantId;
        data["currentLanguage"] = this.currentLanguage;
        data["apiUrl"] = this.apiUrl;
        return data;
    }
}

export interface IOutletInfosImportAgrs {
    timeZoneOffset: number | undefined;
    currentDate: moment.Moment | undefined;
    isSuccess: boolean | undefined;
    errorFilePath: string | undefined;
    type: string | undefined;
    tableName: string | undefined;
    filePath: string | undefined;
    fileName: string | undefined;
    userId: number | undefined;
    userName: string | undefined;
    name: string | undefined;
    tenantId: number | undefined;
    currentLanguage: string | undefined;
    apiUrl: string | undefined;
}

export class PagedResultDtoOfGetOutletToVisitDto implements IPagedResultDtoOfGetOutletToVisitDto {
    totalCount!: number | undefined;
    items!: GetOutletToVisitDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetOutletToVisitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetOutletToVisitDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetOutletToVisitDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetOutletToVisitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetOutletToVisitDto {
    totalCount: number | undefined;
    items: GetOutletToVisitDto[] | undefined;
}

export class GetOutletToVisitDto implements IGetOutletToVisitDto {
    visitPlanDetailId!: number | undefined;
    visitPlanResultId!: number | undefined;
    posmResultID!: number | undefined;
    outletID!: number | undefined;
    outletCode!: string | undefined;
    outletName!: string | undefined;
    memberCode!: string | undefined;
    outletBossName!: string | undefined;
    address!: string | undefined;
    phone!: string | undefined;
    visitDate!: moment.Moment | undefined;
    rankName!: string | undefined;
    regionCode!: string | undefined;
    regionName!: string | undefined;
    statusCheckIn!: boolean | undefined;
    requestUpTypeCode!: string | undefined;
    statusUpType!: string | undefined;
    partnerType!: string | undefined;
    longitude!: string | undefined;
    lattitude!: string | undefined;
    messageRequestUpType!: string | undefined;
    isVisit!: boolean | undefined;

    constructor(data?: IGetOutletToVisitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.visitPlanDetailId = data["visitPlanDetailId"];
            this.visitPlanResultId = data["visitPlanResultId"];
            this.posmResultID = data["posmResultID"];
            this.outletID = data["outletID"];
            this.outletCode = data["outletCode"];
            this.outletName = data["outletName"];
            this.memberCode = data["memberCode"];
            this.outletBossName = data["outletBossName"];
            this.address = data["address"];
            this.phone = data["phone"];
            this.visitDate = data["visitDate"] ? moment(data["visitDate"].toString()) : <any>undefined;
            this.rankName = data["rankName"];
            this.regionCode = data["regionCode"];
            this.regionName = data["regionName"];
            this.statusCheckIn = data["statusCheckIn"];
            this.requestUpTypeCode = data["requestUpTypeCode"];
            this.statusUpType = data["statusUpType"];
            this.partnerType = data["partnerType"];
            this.longitude = data["longitude"];
            this.lattitude = data["lattitude"];
            this.messageRequestUpType = data["messageRequestUpType"];
            this.isVisit = data["isVisit"];
        }
    }

    static fromJS(data: any): GetOutletToVisitDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetOutletToVisitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["visitPlanDetailId"] = this.visitPlanDetailId;
        data["visitPlanResultId"] = this.visitPlanResultId;
        data["posmResultID"] = this.posmResultID;
        data["outletID"] = this.outletID;
        data["outletCode"] = this.outletCode;
        data["outletName"] = this.outletName;
        data["memberCode"] = this.memberCode;
        data["outletBossName"] = this.outletBossName;
        data["address"] = this.address;
        data["phone"] = this.phone;
        data["visitDate"] = this.visitDate ? this.visitDate.toISOString() : <any>undefined;
        data["rankName"] = this.rankName;
        data["regionCode"] = this.regionCode;
        data["regionName"] = this.regionName;
        data["statusCheckIn"] = this.statusCheckIn;
        data["requestUpTypeCode"] = this.requestUpTypeCode;
        data["statusUpType"] = this.statusUpType;
        data["partnerType"] = this.partnerType;
        data["longitude"] = this.longitude;
        data["lattitude"] = this.lattitude;
        data["messageRequestUpType"] = this.messageRequestUpType;
        data["isVisit"] = this.isVisit;
        return data;
    }
}

export interface IGetOutletToVisitDto {
    visitPlanDetailId: number | undefined;
    visitPlanResultId: number | undefined;
    posmResultID: number | undefined;
    outletID: number | undefined;
    outletCode: string | undefined;
    outletName: string | undefined;
    memberCode: string | undefined;
    outletBossName: string | undefined;
    address: string | undefined;
    phone: string | undefined;
    visitDate: moment.Moment | undefined;
    rankName: string | undefined;
    regionCode: string | undefined;
    regionName: string | undefined;
    statusCheckIn: boolean | undefined;
    requestUpTypeCode: string | undefined;
    statusUpType: string | undefined;
    partnerType: string | undefined;
    longitude: string | undefined;
    lattitude: string | undefined;
    messageRequestUpType: string | undefined;
    isVisit: boolean | undefined;
}

export class CheckInRequestDto implements ICheckInRequestDto {
    visitPlanDetailId!: number | undefined;
    memberCode!: string | undefined;
    salesmanCode!: string | undefined;
    checkInDateTime!: moment.Moment | undefined;
    imagePath!: string | undefined;
    longititude!: string | undefined;
    latititude!: string | undefined;
    type!: string | undefined;
    checkInDistant!: number | undefined;

    constructor(data?: ICheckInRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.visitPlanDetailId = data["visitPlanDetailId"];
            this.memberCode = data["memberCode"];
            this.salesmanCode = data["salesmanCode"];
            this.checkInDateTime = data["checkInDateTime"] ? moment(data["checkInDateTime"].toString()) : <any>undefined;
            this.imagePath = data["imagePath"];
            this.longititude = data["longititude"];
            this.latititude = data["latititude"];
            this.type = data["type"];
            this.checkInDistant = data["checkInDistant"];
        }
    }

    static fromJS(data: any): CheckInRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CheckInRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["visitPlanDetailId"] = this.visitPlanDetailId;
        data["memberCode"] = this.memberCode;
        data["salesmanCode"] = this.salesmanCode;
        data["checkInDateTime"] = this.checkInDateTime ? this.checkInDateTime.toISOString() : <any>undefined;
        data["imagePath"] = this.imagePath;
        data["longititude"] = this.longititude;
        data["latititude"] = this.latititude;
        data["type"] = this.type;
        data["checkInDistant"] = this.checkInDistant;
        return data;
    }
}

export interface ICheckInRequestDto {
    visitPlanDetailId: number | undefined;
    memberCode: string | undefined;
    salesmanCode: string | undefined;
    checkInDateTime: moment.Moment | undefined;
    imagePath: string | undefined;
    longititude: string | undefined;
    latititude: string | undefined;
    type: string | undefined;
    checkInDistant: number | undefined;
}

export class CheckOutVisitDto implements ICheckOutVisitDto {
    visitPlanResultId!: number | undefined;
    outletId!: number | undefined;
    checkOutDateTime!: moment.Moment | undefined;
    imagePath!: string | undefined;
    longititude!: string | undefined;
    latititude!: string | undefined;
    checkOutDistant!: number | undefined;
    taskList!: CheckOutTaskListDto[] | undefined;

    constructor(data?: ICheckOutVisitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.visitPlanResultId = data["visitPlanResultId"];
            this.outletId = data["outletId"];
            this.checkOutDateTime = data["checkOutDateTime"] ? moment(data["checkOutDateTime"].toString()) : <any>undefined;
            this.imagePath = data["imagePath"];
            this.longititude = data["longititude"];
            this.latititude = data["latititude"];
            this.checkOutDistant = data["checkOutDistant"];
            if (data["taskList"] && data["taskList"].constructor === Array) {
                this.taskList = [];
                for (let item of data["taskList"])
                    this.taskList.push(CheckOutTaskListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CheckOutVisitDto {
        data = typeof data === 'object' ? data : {};
        let result = new CheckOutVisitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["visitPlanResultId"] = this.visitPlanResultId;
        data["outletId"] = this.outletId;
        data["checkOutDateTime"] = this.checkOutDateTime ? this.checkOutDateTime.toISOString() : <any>undefined;
        data["imagePath"] = this.imagePath;
        data["longititude"] = this.longititude;
        data["latititude"] = this.latititude;
        data["checkOutDistant"] = this.checkOutDistant;
        if (this.taskList && this.taskList.constructor === Array) {
            data["taskList"] = [];
            for (let item of this.taskList)
                data["taskList"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICheckOutVisitDto {
    visitPlanResultId: number | undefined;
    outletId: number | undefined;
    checkOutDateTime: moment.Moment | undefined;
    imagePath: string | undefined;
    longititude: string | undefined;
    latititude: string | undefined;
    checkOutDistant: number | undefined;
    taskList: CheckOutTaskListDto[] | undefined;
}

export class CheckOutTaskListDto implements ICheckOutTaskListDto {
    taskId!: number | undefined;
    taskDetailId!: number | undefined;
    value!: string | undefined;

    constructor(data?: ICheckOutTaskListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.taskId = data["taskId"];
            this.taskDetailId = data["taskDetailId"];
            this.value = data["value"];
        }
    }

    static fromJS(data: any): CheckOutTaskListDto {
        data = typeof data === 'object' ? data : {};
        let result = new CheckOutTaskListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskId"] = this.taskId;
        data["taskDetailId"] = this.taskDetailId;
        data["value"] = this.value;
        return data;
    }
}

export interface ICheckOutTaskListDto {
    taskId: number | undefined;
    taskDetailId: number | undefined;
    value: string | undefined;
}

export class CheckOutPosmDto implements ICheckOutPosmDto {
    visitPlanResultId!: number | undefined;
    posmResultID!: number | undefined;
    checkOutDateTime!: moment.Moment | undefined;
    imagePath!: string | undefined;
    longititude!: string | undefined;
    latititude!: string | undefined;
    checkOutDistant!: number | undefined;

    constructor(data?: ICheckOutPosmDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.visitPlanResultId = data["visitPlanResultId"];
            this.posmResultID = data["posmResultID"];
            this.checkOutDateTime = data["checkOutDateTime"] ? moment(data["checkOutDateTime"].toString()) : <any>undefined;
            this.imagePath = data["imagePath"];
            this.longititude = data["longititude"];
            this.latititude = data["latititude"];
            this.checkOutDistant = data["checkOutDistant"];
        }
    }

    static fromJS(data: any): CheckOutPosmDto {
        data = typeof data === 'object' ? data : {};
        let result = new CheckOutPosmDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["visitPlanResultId"] = this.visitPlanResultId;
        data["posmResultID"] = this.posmResultID;
        data["checkOutDateTime"] = this.checkOutDateTime ? this.checkOutDateTime.toISOString() : <any>undefined;
        data["imagePath"] = this.imagePath;
        data["longititude"] = this.longititude;
        data["latititude"] = this.latititude;
        data["checkOutDistant"] = this.checkOutDistant;
        return data;
    }
}

export interface ICheckOutPosmDto {
    visitPlanResultId: number | undefined;
    posmResultID: number | undefined;
    checkOutDateTime: moment.Moment | undefined;
    imagePath: string | undefined;
    longititude: string | undefined;
    latititude: string | undefined;
    checkOutDistant: number | undefined;
}

export class PagedResultDtoOfDistributorInforResource implements IPagedResultDtoOfDistributorInforResource {
    totalCount!: number | undefined;
    items!: DistributorInforResource[] | undefined;

    constructor(data?: IPagedResultDtoOfDistributorInforResource) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(DistributorInforResource.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfDistributorInforResource {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfDistributorInforResource();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfDistributorInforResource {
    totalCount: number | undefined;
    items: DistributorInforResource[] | undefined;
}

export class DistributorInforResource implements IDistributorInforResource {
    id!: number | undefined;
    memberName!: string | undefined;
    email!: string | undefined;
    address!: string | undefined;
    phoneNumber!: string | undefined;

    constructor(data?: IDistributorInforResource) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.memberName = data["memberName"];
            this.email = data["email"];
            this.address = data["address"];
            this.phoneNumber = data["phoneNumber"];
        }
    }

    static fromJS(data: any): DistributorInforResource {
        data = typeof data === 'object' ? data : {};
        let result = new DistributorInforResource();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["memberName"] = this.memberName;
        data["email"] = this.email;
        data["address"] = this.address;
        data["phoneNumber"] = this.phoneNumber;
        return data;
    }
}

export interface IDistributorInforResource {
    id: number | undefined;
    memberName: string | undefined;
    email: string | undefined;
    address: string | undefined;
    phoneNumber: string | undefined;
}

export class PagedResultDtoOfGetRetailerReportPhoneForViewDto implements IPagedResultDtoOfGetRetailerReportPhoneForViewDto {
    totalCount!: number | undefined;
    items!: GetRetailerReportPhoneForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetRetailerReportPhoneForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetRetailerReportPhoneForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetRetailerReportPhoneForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetRetailerReportPhoneForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetRetailerReportPhoneForViewDto {
    totalCount: number | undefined;
    items: GetRetailerReportPhoneForViewDto[] | undefined;
}

export class GetRetailerReportPhoneForViewDto implements IGetRetailerReportPhoneForViewDto {
    retailerReportPhone!: RetailerReportPhoneDto | undefined;

    constructor(data?: IGetRetailerReportPhoneForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.retailerReportPhone = data["retailerReportPhone"] ? RetailerReportPhoneDto.fromJS(data["retailerReportPhone"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetRetailerReportPhoneForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetRetailerReportPhoneForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["retailerReportPhone"] = this.retailerReportPhone ? this.retailerReportPhone.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetRetailerReportPhoneForViewDto {
    retailerReportPhone: RetailerReportPhoneDto | undefined;
}

export class RetailerReportPhoneDto implements IRetailerReportPhoneDto {
    outletCode!: string | undefined;
    name!: string | undefined;
    phoneFirstDate!: moment.Moment | undefined;
    phoneUpdated!: string | undefined;
    phoneUpdatedDate!: moment.Moment | undefined;
    phoneUpdateStatus!: string | undefined;
    lastModificationTime!: moment.Moment | undefined;
    status!: string | undefined;
    lockUpdatePhone!: boolean | undefined;
    gapDistance!: number | undefined;
    reasonPhone!: string | undefined;
    phone!: string | undefined;
    otp!: string | undefined;
    creationTime!: moment.Moment | undefined;
    browser!: string | undefined;
    deviceName!: string | undefined;
    typeOfDevice!: string | undefined;
    reason!: string | undefined;
    browserCode!: string | undefined;
    deviceNameCode!: string | undefined;
    typeOfDeviceCode!: string | undefined;
    homePhone!: string | undefined;
    id!: number | undefined;

    constructor(data?: IRetailerReportPhoneDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.outletCode = data["outletCode"];
            this.name = data["name"];
            this.phoneFirstDate = data["phoneFirstDate"] ? moment(data["phoneFirstDate"].toString()) : <any>undefined;
            this.phoneUpdated = data["phoneUpdated"];
            this.phoneUpdatedDate = data["phoneUpdatedDate"] ? moment(data["phoneUpdatedDate"].toString()) : <any>undefined;
            this.phoneUpdateStatus = data["phoneUpdateStatus"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.status = data["status"];
            this.lockUpdatePhone = data["lockUpdatePhone"];
            this.gapDistance = data["gapDistance"];
            this.reasonPhone = data["reasonPhone"];
            this.phone = data["phone"];
            this.otp = data["otp"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.browser = data["browser"];
            this.deviceName = data["deviceName"];
            this.typeOfDevice = data["typeOfDevice"];
            this.reason = data["reason"];
            this.browserCode = data["browserCode"];
            this.deviceNameCode = data["deviceNameCode"];
            this.typeOfDeviceCode = data["typeOfDeviceCode"];
            this.homePhone = data["homePhone"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): RetailerReportPhoneDto {
        data = typeof data === 'object' ? data : {};
        let result = new RetailerReportPhoneDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["outletCode"] = this.outletCode;
        data["name"] = this.name;
        data["phoneFirstDate"] = this.phoneFirstDate ? this.phoneFirstDate.toISOString() : <any>undefined;
        data["phoneUpdated"] = this.phoneUpdated;
        data["phoneUpdatedDate"] = this.phoneUpdatedDate ? this.phoneUpdatedDate.toISOString() : <any>undefined;
        data["phoneUpdateStatus"] = this.phoneUpdateStatus;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["lockUpdatePhone"] = this.lockUpdatePhone;
        data["gapDistance"] = this.gapDistance;
        data["reasonPhone"] = this.reasonPhone;
        data["phone"] = this.phone;
        data["otp"] = this.otp;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["browser"] = this.browser;
        data["deviceName"] = this.deviceName;
        data["typeOfDevice"] = this.typeOfDevice;
        data["reason"] = this.reason;
        data["browserCode"] = this.browserCode;
        data["deviceNameCode"] = this.deviceNameCode;
        data["typeOfDeviceCode"] = this.typeOfDeviceCode;
        data["homePhone"] = this.homePhone;
        data["id"] = this.id;
        return data;
    }
}

export interface IRetailerReportPhoneDto {
    outletCode: string | undefined;
    name: string | undefined;
    phoneFirstDate: moment.Moment | undefined;
    phoneUpdated: string | undefined;
    phoneUpdatedDate: moment.Moment | undefined;
    phoneUpdateStatus: string | undefined;
    lastModificationTime: moment.Moment | undefined;
    status: string | undefined;
    lockUpdatePhone: boolean | undefined;
    gapDistance: number | undefined;
    reasonPhone: string | undefined;
    phone: string | undefined;
    otp: string | undefined;
    creationTime: moment.Moment | undefined;
    browser: string | undefined;
    deviceName: string | undefined;
    typeOfDevice: string | undefined;
    reason: string | undefined;
    browserCode: string | undefined;
    deviceNameCode: string | undefined;
    typeOfDeviceCode: string | undefined;
    homePhone: string | undefined;
    id: number | undefined;
}

export class RetailerReportPhoneExportEventData implements IRetailerReportPhoneExportEventData {
    filter!: string | undefined;
    name!: string | undefined;
    statusFilter!: string | undefined;
    phoneUpdateStatusFilter!: string | undefined;
    maxPhoneUpdatedDateFilter!: moment.Moment | undefined;
    minPhoneUpdatedDateFilter!: moment.Moment | undefined;
    tableName!: string | undefined;
    filePath!: string | undefined;
    fileName!: string | undefined;
    currentLanguage!: string | undefined;
    apiUrl!: string | undefined;
    isSearch!: boolean | undefined;
    tenantId!: number | undefined;
    userId!: number | undefined;
    maxParallelism!: number | undefined;
    numberOfWorkers!: number | undefined;
    eventTime!: moment.Moment | undefined;
    eventSource!: any | undefined;

    constructor(data?: IRetailerReportPhoneExportEventData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.filter = data["filter"];
            this.name = data["name"];
            this.statusFilter = data["statusFilter"];
            this.phoneUpdateStatusFilter = data["phoneUpdateStatusFilter"];
            this.maxPhoneUpdatedDateFilter = data["maxPhoneUpdatedDateFilter"] ? moment(data["maxPhoneUpdatedDateFilter"].toString()) : <any>undefined;
            this.minPhoneUpdatedDateFilter = data["minPhoneUpdatedDateFilter"] ? moment(data["minPhoneUpdatedDateFilter"].toString()) : <any>undefined;
            this.tableName = data["tableName"];
            this.filePath = data["filePath"];
            this.fileName = data["fileName"];
            this.currentLanguage = data["currentLanguage"];
            this.apiUrl = data["apiUrl"];
            this.isSearch = data["isSearch"];
            this.tenantId = data["tenantId"];
            this.userId = data["userId"];
            this.maxParallelism = data["maxParallelism"];
            this.numberOfWorkers = data["numberOfWorkers"];
            this.eventTime = data["eventTime"] ? moment(data["eventTime"].toString()) : <any>undefined;
            this.eventSource = data["eventSource"];
        }
    }

    static fromJS(data: any): RetailerReportPhoneExportEventData {
        data = typeof data === 'object' ? data : {};
        let result = new RetailerReportPhoneExportEventData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        data["name"] = this.name;
        data["statusFilter"] = this.statusFilter;
        data["phoneUpdateStatusFilter"] = this.phoneUpdateStatusFilter;
        data["maxPhoneUpdatedDateFilter"] = this.maxPhoneUpdatedDateFilter ? this.maxPhoneUpdatedDateFilter.toISOString() : <any>undefined;
        data["minPhoneUpdatedDateFilter"] = this.minPhoneUpdatedDateFilter ? this.minPhoneUpdatedDateFilter.toISOString() : <any>undefined;
        data["tableName"] = this.tableName;
        data["filePath"] = this.filePath;
        data["fileName"] = this.fileName;
        data["currentLanguage"] = this.currentLanguage;
        data["apiUrl"] = this.apiUrl;
        data["isSearch"] = this.isSearch;
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["maxParallelism"] = this.maxParallelism;
        data["numberOfWorkers"] = this.numberOfWorkers;
        data["eventTime"] = this.eventTime ? this.eventTime.toISOString() : <any>undefined;
        data["eventSource"] = this.eventSource;
        return data;
    }
}

export interface IRetailerReportPhoneExportEventData {
    filter: string | undefined;
    name: string | undefined;
    statusFilter: string | undefined;
    phoneUpdateStatusFilter: string | undefined;
    maxPhoneUpdatedDateFilter: moment.Moment | undefined;
    minPhoneUpdatedDateFilter: moment.Moment | undefined;
    tableName: string | undefined;
    filePath: string | undefined;
    fileName: string | undefined;
    currentLanguage: string | undefined;
    apiUrl: string | undefined;
    isSearch: boolean | undefined;
    tenantId: number | undefined;
    userId: number | undefined;
    maxParallelism: number | undefined;
    numberOfWorkers: number | undefined;
    eventTime: moment.Moment | undefined;
    eventSource: any | undefined;
}

export class PagedResultDtoOfGetAllOutletNoFilterDto implements IPagedResultDtoOfGetAllOutletNoFilterDto {
    totalCount!: number | undefined;
    items!: GetAllOutletNoFilterDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetAllOutletNoFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetAllOutletNoFilterDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetAllOutletNoFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetAllOutletNoFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetAllOutletNoFilterDto {
    totalCount: number | undefined;
    items: GetAllOutletNoFilterDto[] | undefined;
}

export class GetAllOutletInfosForExcelInput implements IGetAllOutletInfosForExcelInput {
    filter!: string | undefined;
    memberCodeFilter!: string | undefined;
    nameFilter!: string | undefined;
    phoneFilter!: string | undefined;
    lngFilter!: string | undefined;
    latFilter!: string | undefined;
    emailFilter!: string | undefined;
    genderFilter!: string | undefined;
    maxBirthdayFilter!: number | undefined;
    minBirthdayFilter!: number | undefined;
    maxRegistrationDateFilter!: number | undefined;
    minRegistrationDateFilter!: number | undefined;
    pidFilter!: string | undefined;
    sourceIDFilter!: string | undefined;
    receiveAdsFilter!: number | undefined;
    rankCodeFilter!: string | undefined;
    maxRankValidDateFilter!: number | undefined;
    minRankValidDateFilter!: number | undefined;
    maxCurrentPointFilter!: number | undefined;
    minCurrentPointFilter!: number | undefined;
    nationalityCodeFilter!: string | undefined;
    occupationCodeFilter!: string | undefined;
    hobbyFilter!: string | undefined;
    addressFilter!: string | undefined;
    wardFilter!: string | undefined;
    districtFilter!: string | undefined;
    provinceFilter!: string | undefined;
    countryFilter!: string | undefined;
    statusFilter!: string | undefined;
    maxLastActivityTimeFilter!: moment.Moment | undefined;
    minLastActivityTimeFilter!: moment.Moment | undefined;
    maxLastPurchaseTimeFilter!: moment.Moment | undefined;
    minLastPurchaseTimeFilter!: moment.Moment | undefined;
    communicationChannelsFilter!: string | undefined;
    communicationLanguageFilter!: string | undefined;
    notesFilter!: string | undefined;
    rankProposeFilter!: string | undefined;
    pinCodeFilter!: string | undefined;
    nameUnSignFilter!: string | undefined;
    avatarFilter!: string | undefined;
    workingPermitFilter!: number | undefined;
    customerCodeFilter!: string | undefined;
    interestOfFilter!: string | undefined;
    isInterestCobrandFilter!: number | undefined;
    memberCardFilter!: string | undefined;
    isForeignerFilter!: number | undefined;
    isSyncedFilter!: number | undefined;
    referralCodeFilter!: string | undefined;
    maxAccumulationPointFilter!: number | undefined;
    minAccumulationPointFilter!: number | undefined;
    outletCodeFilter!: string | undefined;
    zaloNameFilter!: string | undefined;
    distributorCodeFilter!: string | undefined;
    distributorNameFilter!: string | undefined;
    regionCodeFilter!: string | undefined;
    maxTargetRevenueFilter!: number | undefined;
    minTargetRevenueFilter!: number | undefined;
    maxActualRevenueFilter!: number | undefined;
    minActualRevenueFilter!: number | undefined;
    maxBonusFilter!: number | undefined;
    minBonusFilter!: number | undefined;
    maxMissingRevenueFilter!: number | undefined;
    minMissingRevenueFilter!: number | undefined;
    maxRevenueUpdateDateFilter!: number | undefined;
    minRevenueUpdateDateFilter!: number | undefined;
    note1Filter!: string | undefined;
    note2Filter!: string | undefined;
    note3Filter!: string | undefined;
    note4Filter!: string | undefined;
    note5Filter!: string | undefined;
    salesChannelFilter!: string | undefined;
    supervisorCodeFilter!: string | undefined;
    supervisorNameFilter!: string | undefined;
    maxPhoneFirstDateFilter!: moment.Moment | undefined;
    minPhoneFirstDateFilter!: moment.Moment | undefined;
    lockUpdatePhoneFilter!: number | undefined;
    browserCodeFilter!: string | undefined;
    deviceNameCodeFilter!: string | undefined;
    typeOfDeviceCodeFilter!: string | undefined;
    salesmanCodeFilter!: string | undefined;
    maxConsumerIDFilter!: number | undefined;
    minConsumerIDFilter!: number | undefined;
    lockUpdateChatIDFilter!: number | undefined;
    maxCurrentCoinFilter!: number | undefined;
    minCurrentCoinFilter!: number | undefined;
    maxPointToKeepRankFilter!: number | undefined;
    minPointToKeepRankFilter!: number | undefined;
    maxPointToNextRankFilter!: number | undefined;
    minPointToNextRankFilter!: number | undefined;
    maxExpiringCoinFilter!: number | undefined;
    minExpiringCoinFilter!: number | undefined;
    maxExpiringCoinDateFilter!: moment.Moment | undefined;
    minExpiringCoinDateFilter!: moment.Moment | undefined;
    lockUpdateProfileFilter!: number | undefined;

    constructor(data?: IGetAllOutletInfosForExcelInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.filter = data["filter"];
            this.memberCodeFilter = data["memberCodeFilter"];
            this.nameFilter = data["nameFilter"];
            this.phoneFilter = data["phoneFilter"];
            this.lngFilter = data["lngFilter"];
            this.latFilter = data["latFilter"];
            this.emailFilter = data["emailFilter"];
            this.genderFilter = data["genderFilter"];
            this.maxBirthdayFilter = data["maxBirthdayFilter"];
            this.minBirthdayFilter = data["minBirthdayFilter"];
            this.maxRegistrationDateFilter = data["maxRegistrationDateFilter"];
            this.minRegistrationDateFilter = data["minRegistrationDateFilter"];
            this.pidFilter = data["pidFilter"];
            this.sourceIDFilter = data["sourceIDFilter"];
            this.receiveAdsFilter = data["receiveAdsFilter"];
            this.rankCodeFilter = data["rankCodeFilter"];
            this.maxRankValidDateFilter = data["maxRankValidDateFilter"];
            this.minRankValidDateFilter = data["minRankValidDateFilter"];
            this.maxCurrentPointFilter = data["maxCurrentPointFilter"];
            this.minCurrentPointFilter = data["minCurrentPointFilter"];
            this.nationalityCodeFilter = data["nationalityCodeFilter"];
            this.occupationCodeFilter = data["occupationCodeFilter"];
            this.hobbyFilter = data["hobbyFilter"];
            this.addressFilter = data["addressFilter"];
            this.wardFilter = data["wardFilter"];
            this.districtFilter = data["districtFilter"];
            this.provinceFilter = data["provinceFilter"];
            this.countryFilter = data["countryFilter"];
            this.statusFilter = data["statusFilter"];
            this.maxLastActivityTimeFilter = data["maxLastActivityTimeFilter"] ? moment(data["maxLastActivityTimeFilter"].toString()) : <any>undefined;
            this.minLastActivityTimeFilter = data["minLastActivityTimeFilter"] ? moment(data["minLastActivityTimeFilter"].toString()) : <any>undefined;
            this.maxLastPurchaseTimeFilter = data["maxLastPurchaseTimeFilter"] ? moment(data["maxLastPurchaseTimeFilter"].toString()) : <any>undefined;
            this.minLastPurchaseTimeFilter = data["minLastPurchaseTimeFilter"] ? moment(data["minLastPurchaseTimeFilter"].toString()) : <any>undefined;
            this.communicationChannelsFilter = data["communicationChannelsFilter"];
            this.communicationLanguageFilter = data["communicationLanguageFilter"];
            this.notesFilter = data["notesFilter"];
            this.rankProposeFilter = data["rankProposeFilter"];
            this.pinCodeFilter = data["pinCodeFilter"];
            this.nameUnSignFilter = data["nameUnSignFilter"];
            this.avatarFilter = data["avatarFilter"];
            this.workingPermitFilter = data["workingPermitFilter"];
            this.customerCodeFilter = data["customerCodeFilter"];
            this.interestOfFilter = data["interestOfFilter"];
            this.isInterestCobrandFilter = data["isInterestCobrandFilter"];
            this.memberCardFilter = data["memberCardFilter"];
            this.isForeignerFilter = data["isForeignerFilter"];
            this.isSyncedFilter = data["isSyncedFilter"];
            this.referralCodeFilter = data["referralCodeFilter"];
            this.maxAccumulationPointFilter = data["maxAccumulationPointFilter"];
            this.minAccumulationPointFilter = data["minAccumulationPointFilter"];
            this.outletCodeFilter = data["outletCodeFilter"];
            this.zaloNameFilter = data["zaloNameFilter"];
            this.distributorCodeFilter = data["distributorCodeFilter"];
            this.distributorNameFilter = data["distributorNameFilter"];
            this.regionCodeFilter = data["regionCodeFilter"];
            this.maxTargetRevenueFilter = data["maxTargetRevenueFilter"];
            this.minTargetRevenueFilter = data["minTargetRevenueFilter"];
            this.maxActualRevenueFilter = data["maxActualRevenueFilter"];
            this.minActualRevenueFilter = data["minActualRevenueFilter"];
            this.maxBonusFilter = data["maxBonusFilter"];
            this.minBonusFilter = data["minBonusFilter"];
            this.maxMissingRevenueFilter = data["maxMissingRevenueFilter"];
            this.minMissingRevenueFilter = data["minMissingRevenueFilter"];
            this.maxRevenueUpdateDateFilter = data["maxRevenueUpdateDateFilter"];
            this.minRevenueUpdateDateFilter = data["minRevenueUpdateDateFilter"];
            this.note1Filter = data["note1Filter"];
            this.note2Filter = data["note2Filter"];
            this.note3Filter = data["note3Filter"];
            this.note4Filter = data["note4Filter"];
            this.note5Filter = data["note5Filter"];
            this.salesChannelFilter = data["salesChannelFilter"];
            this.supervisorCodeFilter = data["supervisorCodeFilter"];
            this.supervisorNameFilter = data["supervisorNameFilter"];
            this.maxPhoneFirstDateFilter = data["maxPhoneFirstDateFilter"] ? moment(data["maxPhoneFirstDateFilter"].toString()) : <any>undefined;
            this.minPhoneFirstDateFilter = data["minPhoneFirstDateFilter"] ? moment(data["minPhoneFirstDateFilter"].toString()) : <any>undefined;
            this.lockUpdatePhoneFilter = data["lockUpdatePhoneFilter"];
            this.browserCodeFilter = data["browserCodeFilter"];
            this.deviceNameCodeFilter = data["deviceNameCodeFilter"];
            this.typeOfDeviceCodeFilter = data["typeOfDeviceCodeFilter"];
            this.salesmanCodeFilter = data["salesmanCodeFilter"];
            this.maxConsumerIDFilter = data["maxConsumerIDFilter"];
            this.minConsumerIDFilter = data["minConsumerIDFilter"];
            this.lockUpdateChatIDFilter = data["lockUpdateChatIDFilter"];
            this.maxCurrentCoinFilter = data["maxCurrentCoinFilter"];
            this.minCurrentCoinFilter = data["minCurrentCoinFilter"];
            this.maxPointToKeepRankFilter = data["maxPointToKeepRankFilter"];
            this.minPointToKeepRankFilter = data["minPointToKeepRankFilter"];
            this.maxPointToNextRankFilter = data["maxPointToNextRankFilter"];
            this.minPointToNextRankFilter = data["minPointToNextRankFilter"];
            this.maxExpiringCoinFilter = data["maxExpiringCoinFilter"];
            this.minExpiringCoinFilter = data["minExpiringCoinFilter"];
            this.maxExpiringCoinDateFilter = data["maxExpiringCoinDateFilter"] ? moment(data["maxExpiringCoinDateFilter"].toString()) : <any>undefined;
            this.minExpiringCoinDateFilter = data["minExpiringCoinDateFilter"] ? moment(data["minExpiringCoinDateFilter"].toString()) : <any>undefined;
            this.lockUpdateProfileFilter = data["lockUpdateProfileFilter"];
        }
    }

    static fromJS(data: any): GetAllOutletInfosForExcelInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllOutletInfosForExcelInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        data["memberCodeFilter"] = this.memberCodeFilter;
        data["nameFilter"] = this.nameFilter;
        data["phoneFilter"] = this.phoneFilter;
        data["lngFilter"] = this.lngFilter;
        data["latFilter"] = this.latFilter;
        data["emailFilter"] = this.emailFilter;
        data["genderFilter"] = this.genderFilter;
        data["maxBirthdayFilter"] = this.maxBirthdayFilter;
        data["minBirthdayFilter"] = this.minBirthdayFilter;
        data["maxRegistrationDateFilter"] = this.maxRegistrationDateFilter;
        data["minRegistrationDateFilter"] = this.minRegistrationDateFilter;
        data["pidFilter"] = this.pidFilter;
        data["sourceIDFilter"] = this.sourceIDFilter;
        data["receiveAdsFilter"] = this.receiveAdsFilter;
        data["rankCodeFilter"] = this.rankCodeFilter;
        data["maxRankValidDateFilter"] = this.maxRankValidDateFilter;
        data["minRankValidDateFilter"] = this.minRankValidDateFilter;
        data["maxCurrentPointFilter"] = this.maxCurrentPointFilter;
        data["minCurrentPointFilter"] = this.minCurrentPointFilter;
        data["nationalityCodeFilter"] = this.nationalityCodeFilter;
        data["occupationCodeFilter"] = this.occupationCodeFilter;
        data["hobbyFilter"] = this.hobbyFilter;
        data["addressFilter"] = this.addressFilter;
        data["wardFilter"] = this.wardFilter;
        data["districtFilter"] = this.districtFilter;
        data["provinceFilter"] = this.provinceFilter;
        data["countryFilter"] = this.countryFilter;
        data["statusFilter"] = this.statusFilter;
        data["maxLastActivityTimeFilter"] = this.maxLastActivityTimeFilter ? this.maxLastActivityTimeFilter.toISOString() : <any>undefined;
        data["minLastActivityTimeFilter"] = this.minLastActivityTimeFilter ? this.minLastActivityTimeFilter.toISOString() : <any>undefined;
        data["maxLastPurchaseTimeFilter"] = this.maxLastPurchaseTimeFilter ? this.maxLastPurchaseTimeFilter.toISOString() : <any>undefined;
        data["minLastPurchaseTimeFilter"] = this.minLastPurchaseTimeFilter ? this.minLastPurchaseTimeFilter.toISOString() : <any>undefined;
        data["communicationChannelsFilter"] = this.communicationChannelsFilter;
        data["communicationLanguageFilter"] = this.communicationLanguageFilter;
        data["notesFilter"] = this.notesFilter;
        data["rankProposeFilter"] = this.rankProposeFilter;
        data["pinCodeFilter"] = this.pinCodeFilter;
        data["nameUnSignFilter"] = this.nameUnSignFilter;
        data["avatarFilter"] = this.avatarFilter;
        data["workingPermitFilter"] = this.workingPermitFilter;
        data["customerCodeFilter"] = this.customerCodeFilter;
        data["interestOfFilter"] = this.interestOfFilter;
        data["isInterestCobrandFilter"] = this.isInterestCobrandFilter;
        data["memberCardFilter"] = this.memberCardFilter;
        data["isForeignerFilter"] = this.isForeignerFilter;
        data["isSyncedFilter"] = this.isSyncedFilter;
        data["referralCodeFilter"] = this.referralCodeFilter;
        data["maxAccumulationPointFilter"] = this.maxAccumulationPointFilter;
        data["minAccumulationPointFilter"] = this.minAccumulationPointFilter;
        data["outletCodeFilter"] = this.outletCodeFilter;
        data["zaloNameFilter"] = this.zaloNameFilter;
        data["distributorCodeFilter"] = this.distributorCodeFilter;
        data["distributorNameFilter"] = this.distributorNameFilter;
        data["regionCodeFilter"] = this.regionCodeFilter;
        data["maxTargetRevenueFilter"] = this.maxTargetRevenueFilter;
        data["minTargetRevenueFilter"] = this.minTargetRevenueFilter;
        data["maxActualRevenueFilter"] = this.maxActualRevenueFilter;
        data["minActualRevenueFilter"] = this.minActualRevenueFilter;
        data["maxBonusFilter"] = this.maxBonusFilter;
        data["minBonusFilter"] = this.minBonusFilter;
        data["maxMissingRevenueFilter"] = this.maxMissingRevenueFilter;
        data["minMissingRevenueFilter"] = this.minMissingRevenueFilter;
        data["maxRevenueUpdateDateFilter"] = this.maxRevenueUpdateDateFilter;
        data["minRevenueUpdateDateFilter"] = this.minRevenueUpdateDateFilter;
        data["note1Filter"] = this.note1Filter;
        data["note2Filter"] = this.note2Filter;
        data["note3Filter"] = this.note3Filter;
        data["note4Filter"] = this.note4Filter;
        data["note5Filter"] = this.note5Filter;
        data["salesChannelFilter"] = this.salesChannelFilter;
        data["supervisorCodeFilter"] = this.supervisorCodeFilter;
        data["supervisorNameFilter"] = this.supervisorNameFilter;
        data["maxPhoneFirstDateFilter"] = this.maxPhoneFirstDateFilter ? this.maxPhoneFirstDateFilter.toISOString() : <any>undefined;
        data["minPhoneFirstDateFilter"] = this.minPhoneFirstDateFilter ? this.minPhoneFirstDateFilter.toISOString() : <any>undefined;
        data["lockUpdatePhoneFilter"] = this.lockUpdatePhoneFilter;
        data["browserCodeFilter"] = this.browserCodeFilter;
        data["deviceNameCodeFilter"] = this.deviceNameCodeFilter;
        data["typeOfDeviceCodeFilter"] = this.typeOfDeviceCodeFilter;
        data["salesmanCodeFilter"] = this.salesmanCodeFilter;
        data["maxConsumerIDFilter"] = this.maxConsumerIDFilter;
        data["minConsumerIDFilter"] = this.minConsumerIDFilter;
        data["lockUpdateChatIDFilter"] = this.lockUpdateChatIDFilter;
        data["maxCurrentCoinFilter"] = this.maxCurrentCoinFilter;
        data["minCurrentCoinFilter"] = this.minCurrentCoinFilter;
        data["maxPointToKeepRankFilter"] = this.maxPointToKeepRankFilter;
        data["minPointToKeepRankFilter"] = this.minPointToKeepRankFilter;
        data["maxPointToNextRankFilter"] = this.maxPointToNextRankFilter;
        data["minPointToNextRankFilter"] = this.minPointToNextRankFilter;
        data["maxExpiringCoinFilter"] = this.maxExpiringCoinFilter;
        data["minExpiringCoinFilter"] = this.minExpiringCoinFilter;
        data["maxExpiringCoinDateFilter"] = this.maxExpiringCoinDateFilter ? this.maxExpiringCoinDateFilter.toISOString() : <any>undefined;
        data["minExpiringCoinDateFilter"] = this.minExpiringCoinDateFilter ? this.minExpiringCoinDateFilter.toISOString() : <any>undefined;
        data["lockUpdateProfileFilter"] = this.lockUpdateProfileFilter;
        return data;
    }
}

export interface IGetAllOutletInfosForExcelInput {
    filter: string | undefined;
    memberCodeFilter: string | undefined;
    nameFilter: string | undefined;
    phoneFilter: string | undefined;
    lngFilter: string | undefined;
    latFilter: string | undefined;
    emailFilter: string | undefined;
    genderFilter: string | undefined;
    maxBirthdayFilter: number | undefined;
    minBirthdayFilter: number | undefined;
    maxRegistrationDateFilter: number | undefined;
    minRegistrationDateFilter: number | undefined;
    pidFilter: string | undefined;
    sourceIDFilter: string | undefined;
    receiveAdsFilter: number | undefined;
    rankCodeFilter: string | undefined;
    maxRankValidDateFilter: number | undefined;
    minRankValidDateFilter: number | undefined;
    maxCurrentPointFilter: number | undefined;
    minCurrentPointFilter: number | undefined;
    nationalityCodeFilter: string | undefined;
    occupationCodeFilter: string | undefined;
    hobbyFilter: string | undefined;
    addressFilter: string | undefined;
    wardFilter: string | undefined;
    districtFilter: string | undefined;
    provinceFilter: string | undefined;
    countryFilter: string | undefined;
    statusFilter: string | undefined;
    maxLastActivityTimeFilter: moment.Moment | undefined;
    minLastActivityTimeFilter: moment.Moment | undefined;
    maxLastPurchaseTimeFilter: moment.Moment | undefined;
    minLastPurchaseTimeFilter: moment.Moment | undefined;
    communicationChannelsFilter: string | undefined;
    communicationLanguageFilter: string | undefined;
    notesFilter: string | undefined;
    rankProposeFilter: string | undefined;
    pinCodeFilter: string | undefined;
    nameUnSignFilter: string | undefined;
    avatarFilter: string | undefined;
    workingPermitFilter: number | undefined;
    customerCodeFilter: string | undefined;
    interestOfFilter: string | undefined;
    isInterestCobrandFilter: number | undefined;
    memberCardFilter: string | undefined;
    isForeignerFilter: number | undefined;
    isSyncedFilter: number | undefined;
    referralCodeFilter: string | undefined;
    maxAccumulationPointFilter: number | undefined;
    minAccumulationPointFilter: number | undefined;
    outletCodeFilter: string | undefined;
    zaloNameFilter: string | undefined;
    distributorCodeFilter: string | undefined;
    distributorNameFilter: string | undefined;
    regionCodeFilter: string | undefined;
    maxTargetRevenueFilter: number | undefined;
    minTargetRevenueFilter: number | undefined;
    maxActualRevenueFilter: number | undefined;
    minActualRevenueFilter: number | undefined;
    maxBonusFilter: number | undefined;
    minBonusFilter: number | undefined;
    maxMissingRevenueFilter: number | undefined;
    minMissingRevenueFilter: number | undefined;
    maxRevenueUpdateDateFilter: number | undefined;
    minRevenueUpdateDateFilter: number | undefined;
    note1Filter: string | undefined;
    note2Filter: string | undefined;
    note3Filter: string | undefined;
    note4Filter: string | undefined;
    note5Filter: string | undefined;
    salesChannelFilter: string | undefined;
    supervisorCodeFilter: string | undefined;
    supervisorNameFilter: string | undefined;
    maxPhoneFirstDateFilter: moment.Moment | undefined;
    minPhoneFirstDateFilter: moment.Moment | undefined;
    lockUpdatePhoneFilter: number | undefined;
    browserCodeFilter: string | undefined;
    deviceNameCodeFilter: string | undefined;
    typeOfDeviceCodeFilter: string | undefined;
    salesmanCodeFilter: string | undefined;
    maxConsumerIDFilter: number | undefined;
    minConsumerIDFilter: number | undefined;
    lockUpdateChatIDFilter: number | undefined;
    maxCurrentCoinFilter: number | undefined;
    minCurrentCoinFilter: number | undefined;
    maxPointToKeepRankFilter: number | undefined;
    minPointToKeepRankFilter: number | undefined;
    maxPointToNextRankFilter: number | undefined;
    minPointToNextRankFilter: number | undefined;
    maxExpiringCoinFilter: number | undefined;
    minExpiringCoinFilter: number | undefined;
    maxExpiringCoinDateFilter: moment.Moment | undefined;
    minExpiringCoinDateFilter: moment.Moment | undefined;
    lockUpdateProfileFilter: number | undefined;
}

export class GetOutletOfSalesmanDto implements IGetOutletOfSalesmanDto {
    regionCodes!: ListRegionDto[] | undefined;
    memberCodes!: ListMemberDto[] | undefined;

    constructor(data?: IGetOutletOfSalesmanDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["regionCodes"] && data["regionCodes"].constructor === Array) {
                this.regionCodes = [];
                for (let item of data["regionCodes"])
                    this.regionCodes.push(ListRegionDto.fromJS(item));
            }
            if (data["memberCodes"] && data["memberCodes"].constructor === Array) {
                this.memberCodes = [];
                for (let item of data["memberCodes"])
                    this.memberCodes.push(ListMemberDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetOutletOfSalesmanDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetOutletOfSalesmanDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.regionCodes && this.regionCodes.constructor === Array) {
            data["regionCodes"] = [];
            for (let item of this.regionCodes)
                data["regionCodes"].push(item.toJSON());
        }
        if (this.memberCodes && this.memberCodes.constructor === Array) {
            data["memberCodes"] = [];
            for (let item of this.memberCodes)
                data["memberCodes"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetOutletOfSalesmanDto {
    regionCodes: ListRegionDto[] | undefined;
    memberCodes: ListMemberDto[] | undefined;
}

export class ListRegionDto implements IListRegionDto {
    detailCode!: string | undefined;
    detailValue!: string | undefined;
    parentCode!: string | undefined;
    level!: number | undefined;

    constructor(data?: IListRegionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.detailCode = data["detailCode"];
            this.detailValue = data["detailValue"];
            this.parentCode = data["parentCode"];
            this.level = data["level"];
        }
    }

    static fromJS(data: any): ListRegionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListRegionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["detailCode"] = this.detailCode;
        data["detailValue"] = this.detailValue;
        data["parentCode"] = this.parentCode;
        data["level"] = this.level;
        return data;
    }
}

export interface IListRegionDto {
    detailCode: string | undefined;
    detailValue: string | undefined;
    parentCode: string | undefined;
    level: number | undefined;
}

export class ListMemberDto implements IListMemberDto {
    memberCode!: string | undefined;
    name!: string | undefined;
    outletType!: string | undefined;
    storeType!: string | undefined;
    outletTypeName!: string | undefined;
    province!: string | undefined;
    district!: string | undefined;
    ward!: string | undefined;
    phone!: string | undefined;
    sellIn!: number | undefined;
    sellOut!: number | undefined;
    revenue!: RevenueDto[] | undefined;
    totalRevenue!: TotalRevenueDto | undefined;

    constructor(data?: IListMemberDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberCode = data["memberCode"];
            this.name = data["name"];
            this.outletType = data["outletType"];
            this.storeType = data["storeType"];
            this.outletTypeName = data["outletTypeName"];
            this.province = data["province"];
            this.district = data["district"];
            this.ward = data["ward"];
            this.phone = data["phone"];
            this.sellIn = data["sellIn"];
            this.sellOut = data["sellOut"];
            if (data["revenue"] && data["revenue"].constructor === Array) {
                this.revenue = [];
                for (let item of data["revenue"])
                    this.revenue.push(RevenueDto.fromJS(item));
            }
            this.totalRevenue = data["totalRevenue"] ? TotalRevenueDto.fromJS(data["totalRevenue"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ListMemberDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListMemberDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberCode"] = this.memberCode;
        data["name"] = this.name;
        data["outletType"] = this.outletType;
        data["storeType"] = this.storeType;
        data["outletTypeName"] = this.outletTypeName;
        data["province"] = this.province;
        data["district"] = this.district;
        data["ward"] = this.ward;
        data["phone"] = this.phone;
        data["sellIn"] = this.sellIn;
        data["sellOut"] = this.sellOut;
        if (this.revenue && this.revenue.constructor === Array) {
            data["revenue"] = [];
            for (let item of this.revenue)
                data["revenue"].push(item.toJSON());
        }
        data["totalRevenue"] = this.totalRevenue ? this.totalRevenue.toJSON() : <any>undefined;
        return data;
    }
}

export interface IListMemberDto {
    memberCode: string | undefined;
    name: string | undefined;
    outletType: string | undefined;
    storeType: string | undefined;
    outletTypeName: string | undefined;
    province: string | undefined;
    district: string | undefined;
    ward: string | undefined;
    phone: string | undefined;
    sellIn: number | undefined;
    sellOut: number | undefined;
    revenue: RevenueDto[] | undefined;
    totalRevenue: TotalRevenueDto | undefined;
}

export class RevenueDto implements IRevenueDto {
    product!: string | undefined;
    saleIn!: number | undefined;
    saleOut!: number | undefined;

    constructor(data?: IRevenueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.product = data["product"];
            this.saleIn = data["saleIn"];
            this.saleOut = data["saleOut"];
        }
    }

    static fromJS(data: any): RevenueDto {
        data = typeof data === 'object' ? data : {};
        let result = new RevenueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["product"] = this.product;
        data["saleIn"] = this.saleIn;
        data["saleOut"] = this.saleOut;
        return data;
    }
}

export interface IRevenueDto {
    product: string | undefined;
    saleIn: number | undefined;
    saleOut: number | undefined;
}

export class TotalRevenueDto implements ITotalRevenueDto {
    saleIn!: number | undefined;
    saleOut!: number | undefined;

    constructor(data?: ITotalRevenueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.saleIn = data["saleIn"];
            this.saleOut = data["saleOut"];
        }
    }

    static fromJS(data: any): TotalRevenueDto {
        data = typeof data === 'object' ? data : {};
        let result = new TotalRevenueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["saleIn"] = this.saleIn;
        data["saleOut"] = this.saleOut;
        return data;
    }
}

export interface ITotalRevenueDto {
    saleIn: number | undefined;
    saleOut: number | undefined;
}

export class GetAllOutletInformationInput implements IGetAllOutletInformationInput {
    filter!: string | undefined;
    statusFilter!: string | undefined;
    ids!: number[] | undefined;
    listGeoPath!: string[] | undefined;
    sorting!: string | undefined;
    skipCount!: number | undefined;
    maxResultCount!: number | undefined;

    constructor(data?: IGetAllOutletInformationInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.filter = data["filter"];
            this.statusFilter = data["statusFilter"];
            if (data["ids"] && data["ids"].constructor === Array) {
                this.ids = [];
                for (let item of data["ids"])
                    this.ids.push(item);
            }
            if (data["listGeoPath"] && data["listGeoPath"].constructor === Array) {
                this.listGeoPath = [];
                for (let item of data["listGeoPath"])
                    this.listGeoPath.push(item);
            }
            this.sorting = data["sorting"];
            this.skipCount = data["skipCount"];
            this.maxResultCount = data["maxResultCount"];
        }
    }

    static fromJS(data: any): GetAllOutletInformationInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllOutletInformationInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        data["statusFilter"] = this.statusFilter;
        if (this.ids && this.ids.constructor === Array) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        if (this.listGeoPath && this.listGeoPath.constructor === Array) {
            data["listGeoPath"] = [];
            for (let item of this.listGeoPath)
                data["listGeoPath"].push(item);
        }
        data["sorting"] = this.sorting;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data;
    }
}

export interface IGetAllOutletInformationInput {
    filter: string | undefined;
    statusFilter: string | undefined;
    ids: number[] | undefined;
    listGeoPath: string[] | undefined;
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;
}

export class InputUpdateChatIdDto implements IInputUpdateChatIdDto {
    outletCode!: string | undefined;
    oldChatID!: string | undefined;
    newChatID!: string | undefined;
    salesmanCode!: string | undefined;
    lat!: string | undefined;
    lng!: string | undefined;
    gapDistance!: number | undefined;

    constructor(data?: IInputUpdateChatIdDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.outletCode = data["outletCode"];
            this.oldChatID = data["oldChatID"];
            this.newChatID = data["newChatID"];
            this.salesmanCode = data["salesmanCode"];
            this.lat = data["lat"];
            this.lng = data["lng"];
            this.gapDistance = data["gapDistance"];
        }
    }

    static fromJS(data: any): InputUpdateChatIdDto {
        data = typeof data === 'object' ? data : {};
        let result = new InputUpdateChatIdDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["outletCode"] = this.outletCode;
        data["oldChatID"] = this.oldChatID;
        data["newChatID"] = this.newChatID;
        data["salesmanCode"] = this.salesmanCode;
        data["lat"] = this.lat;
        data["lng"] = this.lng;
        data["gapDistance"] = this.gapDistance;
        return data;
    }
}

export interface IInputUpdateChatIdDto {
    outletCode: string | undefined;
    oldChatID: string | undefined;
    newChatID: string | undefined;
    salesmanCode: string | undefined;
    lat: string | undefined;
    lng: string | undefined;
    gapDistance: number | undefined;
}

export class OutputUpdateChatID implements IOutputUpdateChatID {
    lockUpdateChatID!: boolean | undefined;

    constructor(data?: IOutputUpdateChatID) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.lockUpdateChatID = data["lockUpdateChatID"];
        }
    }

    static fromJS(data: any): OutputUpdateChatID {
        data = typeof data === 'object' ? data : {};
        let result = new OutputUpdateChatID();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lockUpdateChatID"] = this.lockUpdateChatID;
        return data;
    }
}

export interface IOutputUpdateChatID {
    lockUpdateChatID: boolean | undefined;
}

export class ReasonInput implements IReasonInput {
    outletCode!: string | undefined;
    reason!: string | undefined;

    constructor(data?: IReasonInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.outletCode = data["outletCode"];
            this.reason = data["reason"];
        }
    }

    static fromJS(data: any): ReasonInput {
        data = typeof data === 'object' ? data : {};
        let result = new ReasonInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["outletCode"] = this.outletCode;
        data["reason"] = this.reason;
        return data;
    }
}

export interface IReasonInput {
    outletCode: string | undefined;
    reason: string | undefined;
}

export class OutletInformationDto implements IOutletInformationDto {
    outletCode!: string | undefined;
    outletName!: string | undefined;
    chatID!: string | undefined;
    address!: string | undefined;
    phone!: string | undefined;
    lockUpdatePhone!: boolean | undefined;
    lockUpdateChatID!: boolean | undefined;
    phoneUpdated!: string | undefined;
    lat!: string | undefined;
    lng!: string | undefined;
    salesChannel!: string | undefined;

    constructor(data?: IOutletInformationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.outletCode = data["outletCode"];
            this.outletName = data["outletName"];
            this.chatID = data["chatID"];
            this.address = data["address"];
            this.phone = data["phone"];
            this.lockUpdatePhone = data["lockUpdatePhone"];
            this.lockUpdateChatID = data["lockUpdateChatID"];
            this.phoneUpdated = data["phoneUpdated"];
            this.lat = data["lat"];
            this.lng = data["lng"];
            this.salesChannel = data["salesChannel"];
        }
    }

    static fromJS(data: any): OutletInformationDto {
        data = typeof data === 'object' ? data : {};
        let result = new OutletInformationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["outletCode"] = this.outletCode;
        data["outletName"] = this.outletName;
        data["chatID"] = this.chatID;
        data["address"] = this.address;
        data["phone"] = this.phone;
        data["lockUpdatePhone"] = this.lockUpdatePhone;
        data["lockUpdateChatID"] = this.lockUpdateChatID;
        data["phoneUpdated"] = this.phoneUpdated;
        data["lat"] = this.lat;
        data["lng"] = this.lng;
        data["salesChannel"] = this.salesChannel;
        return data;
    }
}

export interface IOutletInformationDto {
    outletCode: string | undefined;
    outletName: string | undefined;
    chatID: string | undefined;
    address: string | undefined;
    phone: string | undefined;
    lockUpdatePhone: boolean | undefined;
    lockUpdateChatID: boolean | undefined;
    phoneUpdated: string | undefined;
    lat: string | undefined;
    lng: string | undefined;
    salesChannel: string | undefined;
}

export class ResultToken implements IResultToken {
    accessToken!: string | undefined;
    expiredTime!: number | undefined;
    currentDatetime!: moment.Moment | undefined;

    constructor(data?: IResultToken) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.accessToken = data["accessToken"];
            this.expiredTime = data["expiredTime"];
            this.currentDatetime = data["currentDatetime"] ? moment(data["currentDatetime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultToken {
        data = typeof data === 'object' ? data : {};
        let result = new ResultToken();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["expiredTime"] = this.expiredTime;
        data["currentDatetime"] = this.currentDatetime ? this.currentDatetime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IResultToken {
    accessToken: string | undefined;
    expiredTime: number | undefined;
    currentDatetime: moment.Moment | undefined;
}

export class BeatplanSalesManForView implements IBeatplanSalesManForView {
    salesmanCode!: string | undefined;
    beatPlanCode!: string | undefined;

    constructor(data?: IBeatplanSalesManForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.salesmanCode = data["salesmanCode"];
            this.beatPlanCode = data["beatPlanCode"];
        }
    }

    static fromJS(data: any): BeatplanSalesManForView {
        data = typeof data === 'object' ? data : {};
        let result = new BeatplanSalesManForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["salesmanCode"] = this.salesmanCode;
        data["beatPlanCode"] = this.beatPlanCode;
        return data;
    }
}

export interface IBeatplanSalesManForView {
    salesmanCode: string | undefined;
    beatPlanCode: string | undefined;
}

export class SubmitReasonInput implements ISubmitReasonInput {
    outletCode!: string;
    reasonCode!: string;
    salesmancode!: string;
    latUpdated!: string;
    lngUpdated!: string;
    gapDistance!: number;

    constructor(data?: ISubmitReasonInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.outletCode = data["outletCode"];
            this.reasonCode = data["reasonCode"];
            this.salesmancode = data["salesmancode"];
            this.latUpdated = data["latUpdated"];
            this.lngUpdated = data["lngUpdated"];
            this.gapDistance = data["gapDistance"];
        }
    }

    static fromJS(data: any): SubmitReasonInput {
        data = typeof data === 'object' ? data : {};
        let result = new SubmitReasonInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["outletCode"] = this.outletCode;
        data["reasonCode"] = this.reasonCode;
        data["salesmancode"] = this.salesmancode;
        data["latUpdated"] = this.latUpdated;
        data["lngUpdated"] = this.lngUpdated;
        data["gapDistance"] = this.gapDistance;
        return data;
    }
}

export interface ISubmitReasonInput {
    outletCode: string;
    reasonCode: string;
    salesmancode: string;
    latUpdated: string;
    lngUpdated: string;
    gapDistance: number;
}

export class UpdatePhoneInput implements IUpdatePhoneInput {
    outletCode!: string;
    phone!: string;
    salesChannel!: string | undefined;

    constructor(data?: IUpdatePhoneInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.outletCode = data["outletCode"];
            this.phone = data["phone"];
            this.salesChannel = data["salesChannel"];
        }
    }

    static fromJS(data: any): UpdatePhoneInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePhoneInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["outletCode"] = this.outletCode;
        data["phone"] = this.phone;
        data["salesChannel"] = this.salesChannel;
        return data;
    }
}

export interface IUpdatePhoneInput {
    outletCode: string;
    phone: string;
    salesChannel: string | undefined;
}

export class VerifyOTPInput implements IVerifyOTPInput {
    outletCode!: string;
    phone!: string;
    otpToken!: string;
    latUpdated!: string;
    lngUpdated!: string;
    gapDistance!: number;
    salesmanCode!: string;

    constructor(data?: IVerifyOTPInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.outletCode = data["outletCode"];
            this.phone = data["phone"];
            this.otpToken = data["otpToken"];
            this.latUpdated = data["latUpdated"];
            this.lngUpdated = data["lngUpdated"];
            this.gapDistance = data["gapDistance"];
            this.salesmanCode = data["salesmanCode"];
        }
    }

    static fromJS(data: any): VerifyOTPInput {
        data = typeof data === 'object' ? data : {};
        let result = new VerifyOTPInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["outletCode"] = this.outletCode;
        data["phone"] = this.phone;
        data["otpToken"] = this.otpToken;
        data["latUpdated"] = this.latUpdated;
        data["lngUpdated"] = this.lngUpdated;
        data["gapDistance"] = this.gapDistance;
        data["salesmanCode"] = this.salesmanCode;
        return data;
    }
}

export interface IVerifyOTPInput {
    outletCode: string;
    phone: string;
    otpToken: string;
    latUpdated: string;
    lngUpdated: string;
    gapDistance: number;
    salesmanCode: string;
}

export class SendOTPToPhoneNumberInput implements ISendOTPToPhoneNumberInput {
    phone!: string;
    outletCode!: string;
    salesmanCode!: string | undefined;

    constructor(data?: ISendOTPToPhoneNumberInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.phone = data["phone"];
            this.outletCode = data["outletCode"];
            this.salesmanCode = data["salesmanCode"];
        }
    }

    static fromJS(data: any): SendOTPToPhoneNumberInput {
        data = typeof data === 'object' ? data : {};
        let result = new SendOTPToPhoneNumberInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phone"] = this.phone;
        data["outletCode"] = this.outletCode;
        data["salesmanCode"] = this.salesmanCode;
        return data;
    }
}

export interface ISendOTPToPhoneNumberInput {
    phone: string;
    outletCode: string;
    salesmanCode: string | undefined;
}

export class SubmitSurveyInput implements ISubmitSurveyInput {
    outletCode!: string | undefined;
    typeOfDeviceCode!: string | undefined;
    deviceNameCode!: string | undefined;
    browserCode!: string | undefined;
    salesmanCode!: string | undefined;

    constructor(data?: ISubmitSurveyInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.outletCode = data["outletCode"];
            this.typeOfDeviceCode = data["typeOfDeviceCode"];
            this.deviceNameCode = data["deviceNameCode"];
            this.browserCode = data["browserCode"];
            this.salesmanCode = data["salesmanCode"];
        }
    }

    static fromJS(data: any): SubmitSurveyInput {
        data = typeof data === 'object' ? data : {};
        let result = new SubmitSurveyInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["outletCode"] = this.outletCode;
        data["typeOfDeviceCode"] = this.typeOfDeviceCode;
        data["deviceNameCode"] = this.deviceNameCode;
        data["browserCode"] = this.browserCode;
        data["salesmanCode"] = this.salesmanCode;
        return data;
    }
}

export interface ISubmitSurveyInput {
    outletCode: string | undefined;
    typeOfDeviceCode: string | undefined;
    deviceNameCode: string | undefined;
    browserCode: string | undefined;
    salesmanCode: string | undefined;
}

export class UpdateHomePhoneInput implements IUpdateHomePhoneInput {
    outletCode!: string;
    homePhone!: string;
    latUpdated!: string;
    lngUpdated!: string;
    gapDistance!: number;
    salesmanCode!: string;
    salesChannel!: string;
    reasonPhone!: string | undefined;

    constructor(data?: IUpdateHomePhoneInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.outletCode = data["outletCode"];
            this.homePhone = data["homePhone"];
            this.latUpdated = data["latUpdated"];
            this.lngUpdated = data["lngUpdated"];
            this.gapDistance = data["gapDistance"];
            this.salesmanCode = data["salesmanCode"];
            this.salesChannel = data["salesChannel"];
            this.reasonPhone = data["reasonPhone"];
        }
    }

    static fromJS(data: any): UpdateHomePhoneInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateHomePhoneInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["outletCode"] = this.outletCode;
        data["homePhone"] = this.homePhone;
        data["latUpdated"] = this.latUpdated;
        data["lngUpdated"] = this.lngUpdated;
        data["gapDistance"] = this.gapDistance;
        data["salesmanCode"] = this.salesmanCode;
        data["salesChannel"] = this.salesChannel;
        data["reasonPhone"] = this.reasonPhone;
        return data;
    }
}

export interface IUpdateHomePhoneInput {
    outletCode: string;
    homePhone: string;
    latUpdated: string;
    lngUpdated: string;
    gapDistance: number;
    salesmanCode: string;
    salesChannel: string;
    reasonPhone: string | undefined;
}

export class RetailerInformationDto implements IRetailerInformationDto {
    name!: string | undefined;
    birthDay!: number | undefined;
    phone!: string | undefined;
    email!: string | undefined;
    regionCode!: string | undefined;
    address!: string | undefined;
    province!: RegionsIntegrationDto | undefined;
    district!: RegionsIntegrationDto | undefined;
    ward!: RegionsIntegrationDto | undefined;
    gender!: string | undefined;
    status!: string | undefined;
    rankCode!: string | undefined;
    rank!: RetailerRankDto | undefined;
    rankValidTo!: number | undefined;
    expiringCoin!: number | undefined;
    targetRevenue!: number | undefined;
    actualRevenue!: number | undefined;
    distributorCode!: string | undefined;
    distributorName!: string | undefined;
    outletCode!: string | undefined;
    nextRank!: RetailerRankDto | undefined;
    expiringCoinDate!: moment.Moment | undefined;
    registrationDate!: number | undefined;
    lastPurchaseTime!: moment.Moment | undefined;
    point!: number | undefined;
    coin!: number | undefined;
    usedCoin!: number | undefined;
    pointToKeepRank!: number | undefined;
    pointToNextRank!: number | undefined;
    revenue!: MemberRevenueDto | undefined;
    pid!: string | undefined;
    avatar!: string | undefined;
    payBonus!: RetailerPayBonusDto[] | undefined;

    constructor(data?: IRetailerInformationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.birthDay = data["birthDay"];
            this.phone = data["phone"];
            this.email = data["email"];
            this.regionCode = data["regionCode"];
            this.address = data["address"];
            this.province = data["province"] ? RegionsIntegrationDto.fromJS(data["province"]) : <any>undefined;
            this.district = data["district"] ? RegionsIntegrationDto.fromJS(data["district"]) : <any>undefined;
            this.ward = data["ward"] ? RegionsIntegrationDto.fromJS(data["ward"]) : <any>undefined;
            this.gender = data["gender"];
            this.status = data["status"];
            this.rankCode = data["rankCode"];
            this.rank = data["rank"] ? RetailerRankDto.fromJS(data["rank"]) : <any>undefined;
            this.rankValidTo = data["rankValidTo"];
            this.expiringCoin = data["expiringCoin"];
            this.targetRevenue = data["targetRevenue"];
            this.actualRevenue = data["actualRevenue"];
            this.distributorCode = data["distributorCode"];
            this.distributorName = data["distributorName"];
            this.outletCode = data["outletCode"];
            this.nextRank = data["nextRank"] ? RetailerRankDto.fromJS(data["nextRank"]) : <any>undefined;
            this.expiringCoinDate = data["expiringCoinDate"] ? moment(data["expiringCoinDate"].toString()) : <any>undefined;
            this.registrationDate = data["registrationDate"];
            this.lastPurchaseTime = data["lastPurchaseTime"] ? moment(data["lastPurchaseTime"].toString()) : <any>undefined;
            this.point = data["point"];
            this.coin = data["coin"];
            this.usedCoin = data["usedCoin"];
            this.pointToKeepRank = data["pointToKeepRank"];
            this.pointToNextRank = data["pointToNextRank"];
            this.revenue = data["revenue"] ? MemberRevenueDto.fromJS(data["revenue"]) : <any>undefined;
            this.pid = data["pid"];
            this.avatar = data["avatar"];
            if (data["payBonus"] && data["payBonus"].constructor === Array) {
                this.payBonus = [];
                for (let item of data["payBonus"])
                    this.payBonus.push(RetailerPayBonusDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RetailerInformationDto {
        data = typeof data === 'object' ? data : {};
        let result = new RetailerInformationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["birthDay"] = this.birthDay;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["regionCode"] = this.regionCode;
        data["address"] = this.address;
        data["province"] = this.province ? this.province.toJSON() : <any>undefined;
        data["district"] = this.district ? this.district.toJSON() : <any>undefined;
        data["ward"] = this.ward ? this.ward.toJSON() : <any>undefined;
        data["gender"] = this.gender;
        data["status"] = this.status;
        data["rankCode"] = this.rankCode;
        data["rank"] = this.rank ? this.rank.toJSON() : <any>undefined;
        data["rankValidTo"] = this.rankValidTo;
        data["expiringCoin"] = this.expiringCoin;
        data["targetRevenue"] = this.targetRevenue;
        data["actualRevenue"] = this.actualRevenue;
        data["distributorCode"] = this.distributorCode;
        data["distributorName"] = this.distributorName;
        data["outletCode"] = this.outletCode;
        data["nextRank"] = this.nextRank ? this.nextRank.toJSON() : <any>undefined;
        data["expiringCoinDate"] = this.expiringCoinDate ? this.expiringCoinDate.toISOString() : <any>undefined;
        data["registrationDate"] = this.registrationDate;
        data["lastPurchaseTime"] = this.lastPurchaseTime ? this.lastPurchaseTime.toISOString() : <any>undefined;
        data["point"] = this.point;
        data["coin"] = this.coin;
        data["usedCoin"] = this.usedCoin;
        data["pointToKeepRank"] = this.pointToKeepRank;
        data["pointToNextRank"] = this.pointToNextRank;
        data["revenue"] = this.revenue ? this.revenue.toJSON() : <any>undefined;
        data["pid"] = this.pid;
        data["avatar"] = this.avatar;
        if (this.payBonus && this.payBonus.constructor === Array) {
            data["payBonus"] = [];
            for (let item of this.payBonus)
                data["payBonus"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRetailerInformationDto {
    name: string | undefined;
    birthDay: number | undefined;
    phone: string | undefined;
    email: string | undefined;
    regionCode: string | undefined;
    address: string | undefined;
    province: RegionsIntegrationDto | undefined;
    district: RegionsIntegrationDto | undefined;
    ward: RegionsIntegrationDto | undefined;
    gender: string | undefined;
    status: string | undefined;
    rankCode: string | undefined;
    rank: RetailerRankDto | undefined;
    rankValidTo: number | undefined;
    expiringCoin: number | undefined;
    targetRevenue: number | undefined;
    actualRevenue: number | undefined;
    distributorCode: string | undefined;
    distributorName: string | undefined;
    outletCode: string | undefined;
    nextRank: RetailerRankDto | undefined;
    expiringCoinDate: moment.Moment | undefined;
    registrationDate: number | undefined;
    lastPurchaseTime: moment.Moment | undefined;
    point: number | undefined;
    coin: number | undefined;
    usedCoin: number | undefined;
    pointToKeepRank: number | undefined;
    pointToNextRank: number | undefined;
    revenue: MemberRevenueDto | undefined;
    pid: string | undefined;
    avatar: string | undefined;
    payBonus: RetailerPayBonusDto[] | undefined;
}

export class RegionsIntegrationDto implements IRegionsIntegrationDto {
    code!: string | undefined;
    name!: string | undefined;

    constructor(data?: IRegionsIntegrationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.name = data["name"];
        }
    }

    static fromJS(data: any): RegionsIntegrationDto {
        data = typeof data === 'object' ? data : {};
        let result = new RegionsIntegrationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        return data;
    }
}

export interface IRegionsIntegrationDto {
    code: string | undefined;
    name: string | undefined;
}

export class RetailerRankDto implements IRetailerRankDto {
    code!: string | undefined;
    name!: string | undefined;
    description!: string | undefined;
    avatar!: string | undefined;
    requiredPoint!: number | undefined;

    constructor(data?: IRetailerRankDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.name = data["name"];
            this.description = data["description"];
            this.avatar = data["avatar"];
            this.requiredPoint = data["requiredPoint"];
        }
    }

    static fromJS(data: any): RetailerRankDto {
        data = typeof data === 'object' ? data : {};
        let result = new RetailerRankDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["description"] = this.description;
        data["avatar"] = this.avatar;
        data["requiredPoint"] = this.requiredPoint;
        return data;
    }
}

export interface IRetailerRankDto {
    code: string | undefined;
    name: string | undefined;
    description: string | undefined;
    avatar: string | undefined;
    requiredPoint: number | undefined;
}

export class MemberRevenueDto implements IMemberRevenueDto {
    month!: MemberRevenueDetailMonthDto[] | undefined;
    quarter!: MemberRevenueDetailQuarterDto[] | undefined;

    constructor(data?: IMemberRevenueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["month"] && data["month"].constructor === Array) {
                this.month = [];
                for (let item of data["month"])
                    this.month.push(MemberRevenueDetailMonthDto.fromJS(item));
            }
            if (data["quarter"] && data["quarter"].constructor === Array) {
                this.quarter = [];
                for (let item of data["quarter"])
                    this.quarter.push(MemberRevenueDetailQuarterDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MemberRevenueDto {
        data = typeof data === 'object' ? data : {};
        let result = new MemberRevenueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.month && this.month.constructor === Array) {
            data["month"] = [];
            for (let item of this.month)
                data["month"].push(item.toJSON());
        }
        if (this.quarter && this.quarter.constructor === Array) {
            data["quarter"] = [];
            for (let item of this.quarter)
                data["quarter"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMemberRevenueDto {
    month: MemberRevenueDetailMonthDto[] | undefined;
    quarter: MemberRevenueDetailQuarterDto[] | undefined;
}

export class RetailerPayBonusDto implements IRetailerPayBonusDto {
    revenue!: number | undefined;
    type!: string | undefined;
    calculatedDate!: moment.Moment | undefined;
    bonusPoint!: number | undefined;
    bonusCoin!: number | undefined;
    status!: string | undefined;
    bonusAmount!: number | undefined;

    constructor(data?: IRetailerPayBonusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.revenue = data["revenue"];
            this.type = data["type"];
            this.calculatedDate = data["calculatedDate"] ? moment(data["calculatedDate"].toString()) : <any>undefined;
            this.bonusPoint = data["bonusPoint"];
            this.bonusCoin = data["bonusCoin"];
            this.status = data["status"];
            this.bonusAmount = data["bonusAmount"];
        }
    }

    static fromJS(data: any): RetailerPayBonusDto {
        data = typeof data === 'object' ? data : {};
        let result = new RetailerPayBonusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["revenue"] = this.revenue;
        data["type"] = this.type;
        data["calculatedDate"] = this.calculatedDate ? this.calculatedDate.toISOString() : <any>undefined;
        data["bonusPoint"] = this.bonusPoint;
        data["bonusCoin"] = this.bonusCoin;
        data["status"] = this.status;
        data["bonusAmount"] = this.bonusAmount;
        return data;
    }
}

export interface IRetailerPayBonusDto {
    revenue: number | undefined;
    type: string | undefined;
    calculatedDate: moment.Moment | undefined;
    bonusPoint: number | undefined;
    bonusCoin: number | undefined;
    status: string | undefined;
    bonusAmount: number | undefined;
}

export class MemberRevenueDetailMonthDto implements IMemberRevenueDetailMonthDto {
    target!: number | undefined;
    actual!: number | undefined;
    code!: string | undefined;

    constructor(data?: IMemberRevenueDetailMonthDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.target = data["target"];
            this.actual = data["actual"];
            this.code = data["code"];
        }
    }

    static fromJS(data: any): MemberRevenueDetailMonthDto {
        data = typeof data === 'object' ? data : {};
        let result = new MemberRevenueDetailMonthDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["target"] = this.target;
        data["actual"] = this.actual;
        data["code"] = this.code;
        return data;
    }
}

export interface IMemberRevenueDetailMonthDto {
    target: number | undefined;
    actual: number | undefined;
    code: string | undefined;
}

export class MemberRevenueDetailQuarterDto implements IMemberRevenueDetailQuarterDto {
    target!: number | undefined;
    actual!: number | undefined;
    code!: string | undefined;

    constructor(data?: IMemberRevenueDetailQuarterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.target = data["target"];
            this.actual = data["actual"];
            this.code = data["code"];
        }
    }

    static fromJS(data: any): MemberRevenueDetailQuarterDto {
        data = typeof data === 'object' ? data : {};
        let result = new MemberRevenueDetailQuarterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["target"] = this.target;
        data["actual"] = this.actual;
        data["code"] = this.code;
        return data;
    }
}

export interface IMemberRevenueDetailQuarterDto {
    target: number | undefined;
    actual: number | undefined;
    code: string | undefined;
}

export class UpdateRetailerInformationDto implements IUpdateRetailerInformationDto {
    memberCode!: string | undefined;
    phone!: string | undefined;
    address!: string | undefined;
    name!: string | undefined;
    email!: string | undefined;
    birthday!: number | undefined;
    province!: string | undefined;
    ward!: string | undefined;
    district!: string | undefined;
    avatar!: string | undefined;
    pid!: string | undefined;

    constructor(data?: IUpdateRetailerInformationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberCode = data["memberCode"];
            this.phone = data["phone"];
            this.address = data["address"];
            this.name = data["name"];
            this.email = data["email"];
            this.birthday = data["birthday"];
            this.province = data["province"];
            this.ward = data["ward"];
            this.district = data["district"];
            this.avatar = data["avatar"];
            this.pid = data["pid"];
        }
    }

    static fromJS(data: any): UpdateRetailerInformationDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRetailerInformationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberCode"] = this.memberCode;
        data["phone"] = this.phone;
        data["address"] = this.address;
        data["name"] = this.name;
        data["email"] = this.email;
        data["birthday"] = this.birthday;
        data["province"] = this.province;
        data["ward"] = this.ward;
        data["district"] = this.district;
        data["avatar"] = this.avatar;
        data["pid"] = this.pid;
        return data;
    }
}

export interface IUpdateRetailerInformationDto {
    memberCode: string | undefined;
    phone: string | undefined;
    address: string | undefined;
    name: string | undefined;
    email: string | undefined;
    birthday: number | undefined;
    province: string | undefined;
    ward: string | undefined;
    district: string | undefined;
    avatar: string | undefined;
    pid: string | undefined;
}

export class ChangePasswordOutletDto implements IChangePasswordOutletDto {
    outletCode!: string | undefined;
    newPassword!: string | undefined;
    confirmPassword!: string | undefined;
    oldPassword!: string | undefined;

    constructor(data?: IChangePasswordOutletDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.outletCode = data["outletCode"];
            this.newPassword = data["newPassword"];
            this.confirmPassword = data["confirmPassword"];
            this.oldPassword = data["oldPassword"];
        }
    }

    static fromJS(data: any): ChangePasswordOutletDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordOutletDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["outletCode"] = this.outletCode;
        data["newPassword"] = this.newPassword;
        data["confirmPassword"] = this.confirmPassword;
        data["oldPassword"] = this.oldPassword;
        return data;
    }
}

export interface IChangePasswordOutletDto {
    outletCode: string | undefined;
    newPassword: string | undefined;
    confirmPassword: string | undefined;
    oldPassword: string | undefined;
}

export class ForceChangePasswordDto implements IForceChangePasswordDto {
    memberCode!: string | undefined;
    newPassword!: string | undefined;
    secretKey!: string | undefined;

    constructor(data?: IForceChangePasswordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberCode = data["memberCode"];
            this.newPassword = data["newPassword"];
            this.secretKey = data["secretKey"];
        }
    }

    static fromJS(data: any): ForceChangePasswordDto {
        data = typeof data === 'object' ? data : {};
        let result = new ForceChangePasswordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberCode"] = this.memberCode;
        data["newPassword"] = this.newPassword;
        data["secretKey"] = this.secretKey;
        return data;
    }
}

export interface IForceChangePasswordDto {
    memberCode: string | undefined;
    newPassword: string | undefined;
    secretKey: string | undefined;
}

export class ResetPasswordOutletInfoDto implements IResetPasswordOutletInfoDto {
    memberCode!: string | undefined;
    secretKey!: string | undefined;

    constructor(data?: IResetPasswordOutletInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberCode = data["memberCode"];
            this.secretKey = data["secretKey"];
        }
    }

    static fromJS(data: any): ResetPasswordOutletInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordOutletInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberCode"] = this.memberCode;
        data["secretKey"] = this.secretKey;
        return data;
    }
}

export interface IResetPasswordOutletInfoDto {
    memberCode: string | undefined;
    secretKey: string | undefined;
}

export class GetOutletRevenueResponse implements IGetOutletRevenueResponse {
    revenue!: RevenueDto[] | undefined;
    totalRevenue!: TotalRevenueDto | undefined;

    constructor(data?: IGetOutletRevenueResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["revenue"] && data["revenue"].constructor === Array) {
                this.revenue = [];
                for (let item of data["revenue"])
                    this.revenue.push(RevenueDto.fromJS(item));
            }
            this.totalRevenue = data["totalRevenue"] ? TotalRevenueDto.fromJS(data["totalRevenue"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetOutletRevenueResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetOutletRevenueResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.revenue && this.revenue.constructor === Array) {
            data["revenue"] = [];
            for (let item of this.revenue)
                data["revenue"].push(item.toJSON());
        }
        data["totalRevenue"] = this.totalRevenue ? this.totalRevenue.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetOutletRevenueResponse {
    revenue: RevenueDto[] | undefined;
    totalRevenue: TotalRevenueDto | undefined;
}

export class PagedResultDtoOfGetListOutletResponse implements IPagedResultDtoOfGetListOutletResponse {
    totalCount!: number | undefined;
    items!: GetListOutletResponse[] | undefined;

    constructor(data?: IPagedResultDtoOfGetListOutletResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetListOutletResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetListOutletResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetListOutletResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetListOutletResponse {
    totalCount: number | undefined;
    items: GetListOutletResponse[] | undefined;
}

export class GetListOutletResponse implements IGetListOutletResponse {
    outletId!: number | undefined;
    outletCode!: string | undefined;
    outletName!: string | undefined;
    outletType!: string | undefined;
    outletTypeName!: string | undefined;
    phone!: string | undefined;
    revenue!: RevenueDto[] | undefined;
    totalRevenue!: TotalRevenueDto | undefined;

    constructor(data?: IGetListOutletResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.outletId = data["outletId"];
            this.outletCode = data["outletCode"];
            this.outletName = data["outletName"];
            this.outletType = data["outletType"];
            this.outletTypeName = data["outletTypeName"];
            this.phone = data["phone"];
            if (data["revenue"] && data["revenue"].constructor === Array) {
                this.revenue = [];
                for (let item of data["revenue"])
                    this.revenue.push(RevenueDto.fromJS(item));
            }
            this.totalRevenue = data["totalRevenue"] ? TotalRevenueDto.fromJS(data["totalRevenue"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetListOutletResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetListOutletResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["outletId"] = this.outletId;
        data["outletCode"] = this.outletCode;
        data["outletName"] = this.outletName;
        data["outletType"] = this.outletType;
        data["outletTypeName"] = this.outletTypeName;
        data["phone"] = this.phone;
        if (this.revenue && this.revenue.constructor === Array) {
            data["revenue"] = [];
            for (let item of this.revenue)
                data["revenue"].push(item.toJSON());
        }
        data["totalRevenue"] = this.totalRevenue ? this.totalRevenue.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetListOutletResponse {
    outletId: number | undefined;
    outletCode: string | undefined;
    outletName: string | undefined;
    outletType: string | undefined;
    outletTypeName: string | undefined;
    phone: string | undefined;
    revenue: RevenueDto[] | undefined;
    totalRevenue: TotalRevenueDto | undefined;
}

export class PagedResultDtoOfOutletInfoUpdateHistoryDto implements IPagedResultDtoOfOutletInfoUpdateHistoryDto {
    totalCount!: number | undefined;
    items!: OutletInfoUpdateHistoryDto[] | undefined;

    constructor(data?: IPagedResultDtoOfOutletInfoUpdateHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(OutletInfoUpdateHistoryDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfOutletInfoUpdateHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfOutletInfoUpdateHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfOutletInfoUpdateHistoryDto {
    totalCount: number | undefined;
    items: OutletInfoUpdateHistoryDto[] | undefined;
}

export class OutletInfoUpdateHistoryDto implements IOutletInfoUpdateHistoryDto {
    outletId!: number | undefined;
    outletCode!: string | undefined;
    oldContent!: string | undefined;
    newContent!: string | undefined;
    type!: string | undefined;
    typeDescription!: string | undefined;
    creatorName!: string | undefined;
    isDeleted!: boolean | undefined;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: moment.Moment | undefined;
    creatorUserId!: number | undefined;
    id!: number | undefined;

    constructor(data?: IOutletInfoUpdateHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.outletId = data["outletId"];
            this.outletCode = data["outletCode"];
            this.oldContent = data["oldContent"];
            this.newContent = data["newContent"];
            this.type = data["type"];
            this.typeDescription = data["typeDescription"];
            this.creatorName = data["creatorName"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): OutletInfoUpdateHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new OutletInfoUpdateHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["outletId"] = this.outletId;
        data["outletCode"] = this.outletCode;
        data["oldContent"] = this.oldContent;
        data["newContent"] = this.newContent;
        data["type"] = this.type;
        data["typeDescription"] = this.typeDescription;
        data["creatorName"] = this.creatorName;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IOutletInfoUpdateHistoryDto {
    outletId: number | undefined;
    outletCode: string | undefined;
    oldContent: string | undefined;
    newContent: string | undefined;
    type: string | undefined;
    typeDescription: string | undefined;
    creatorName: string | undefined;
    isDeleted: boolean | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class CreateOrEditOutletInfoUpdateHistoryDto implements ICreateOrEditOutletInfoUpdateHistoryDto {
    outletId!: number | undefined;
    outletCode!: string | undefined;
    oldContent!: string | undefined;
    newContent!: string | undefined;
    type!: string | undefined;
    typeDescription!: string | undefined;

    constructor(data?: ICreateOrEditOutletInfoUpdateHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.outletId = data["outletId"];
            this.outletCode = data["outletCode"];
            this.oldContent = data["oldContent"];
            this.newContent = data["newContent"];
            this.type = data["type"];
            this.typeDescription = data["typeDescription"];
        }
    }

    static fromJS(data: any): CreateOrEditOutletInfoUpdateHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditOutletInfoUpdateHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["outletId"] = this.outletId;
        data["outletCode"] = this.outletCode;
        data["oldContent"] = this.oldContent;
        data["newContent"] = this.newContent;
        data["type"] = this.type;
        data["typeDescription"] = this.typeDescription;
        return data;
    }
}

export interface ICreateOrEditOutletInfoUpdateHistoryDto {
    outletId: number | undefined;
    outletCode: string | undefined;
    oldContent: string | undefined;
    newContent: string | undefined;
    type: string | undefined;
    typeDescription: string | undefined;
}

export class PagedResultDtoOfGetOutletRevenueBaselineForViewDto implements IPagedResultDtoOfGetOutletRevenueBaselineForViewDto {
    totalCount!: number | undefined;
    items!: GetOutletRevenueBaselineForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetOutletRevenueBaselineForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetOutletRevenueBaselineForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetOutletRevenueBaselineForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetOutletRevenueBaselineForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetOutletRevenueBaselineForViewDto {
    totalCount: number | undefined;
    items: GetOutletRevenueBaselineForViewDto[] | undefined;
}

export class GetOutletRevenueBaselineForViewDto implements IGetOutletRevenueBaselineForViewDto {
    outletRevenueBaseline!: OutletRevenueBaselineDto | undefined;

    constructor(data?: IGetOutletRevenueBaselineForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.outletRevenueBaseline = data["outletRevenueBaseline"] ? OutletRevenueBaselineDto.fromJS(data["outletRevenueBaseline"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetOutletRevenueBaselineForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetOutletRevenueBaselineForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["outletRevenueBaseline"] = this.outletRevenueBaseline ? this.outletRevenueBaseline.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetOutletRevenueBaselineForViewDto {
    outletRevenueBaseline: OutletRevenueBaselineDto | undefined;
}

export class OutletRevenueBaselineDto implements IOutletRevenueBaselineDto {
    outletCode!: string | undefined;
    outletName!: string | undefined;
    target!: number | undefined;
    actual!: number | undefined;
    bonus!: number | undefined;
    cumulatedMonth!: number | undefined;
    updatedDate!: number | undefined;
    id!: number | undefined;

    constructor(data?: IOutletRevenueBaselineDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.outletCode = data["outletCode"];
            this.outletName = data["outletName"];
            this.target = data["target"];
            this.actual = data["actual"];
            this.bonus = data["bonus"];
            this.cumulatedMonth = data["cumulatedMonth"];
            this.updatedDate = data["updatedDate"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): OutletRevenueBaselineDto {
        data = typeof data === 'object' ? data : {};
        let result = new OutletRevenueBaselineDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["outletCode"] = this.outletCode;
        data["outletName"] = this.outletName;
        data["target"] = this.target;
        data["actual"] = this.actual;
        data["bonus"] = this.bonus;
        data["cumulatedMonth"] = this.cumulatedMonth;
        data["updatedDate"] = this.updatedDate;
        data["id"] = this.id;
        return data;
    }
}

export interface IOutletRevenueBaselineDto {
    outletCode: string | undefined;
    outletName: string | undefined;
    target: number | undefined;
    actual: number | undefined;
    bonus: number | undefined;
    cumulatedMonth: number | undefined;
    updatedDate: number | undefined;
    id: number | undefined;
}

export class GetOutletRevenueBaselineForEditOutput implements IGetOutletRevenueBaselineForEditOutput {
    outletRevenueBaseline!: CreateOrEditOutletRevenueBaselineDto | undefined;

    constructor(data?: IGetOutletRevenueBaselineForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.outletRevenueBaseline = data["outletRevenueBaseline"] ? CreateOrEditOutletRevenueBaselineDto.fromJS(data["outletRevenueBaseline"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetOutletRevenueBaselineForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetOutletRevenueBaselineForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["outletRevenueBaseline"] = this.outletRevenueBaseline ? this.outletRevenueBaseline.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetOutletRevenueBaselineForEditOutput {
    outletRevenueBaseline: CreateOrEditOutletRevenueBaselineDto | undefined;
}

export class CreateOrEditOutletRevenueBaselineDto implements ICreateOrEditOutletRevenueBaselineDto {
    outletCode!: string | undefined;
    outletName!: string | undefined;
    target!: number | undefined;
    actual!: number | undefined;
    bonus!: number | undefined;
    cumulatedMonth!: number | undefined;
    updatedDate!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditOutletRevenueBaselineDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.outletCode = data["outletCode"];
            this.outletName = data["outletName"];
            this.target = data["target"];
            this.actual = data["actual"];
            this.bonus = data["bonus"];
            this.cumulatedMonth = data["cumulatedMonth"];
            this.updatedDate = data["updatedDate"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditOutletRevenueBaselineDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditOutletRevenueBaselineDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["outletCode"] = this.outletCode;
        data["outletName"] = this.outletName;
        data["target"] = this.target;
        data["actual"] = this.actual;
        data["bonus"] = this.bonus;
        data["cumulatedMonth"] = this.cumulatedMonth;
        data["updatedDate"] = this.updatedDate;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditOutletRevenueBaselineDto {
    outletCode: string | undefined;
    outletName: string | undefined;
    target: number | undefined;
    actual: number | undefined;
    bonus: number | undefined;
    cumulatedMonth: number | undefined;
    updatedDate: number | undefined;
    id: number | undefined;
}

export class GetAllOutletRevenueBaselinesInput implements IGetAllOutletRevenueBaselinesInput {
    filter!: string | undefined;
    outletCodeFilter!: string | undefined;
    outletNameFilter!: string | undefined;
    maxTargetFilter!: number | undefined;
    minTargetFilter!: number | undefined;
    maxActualFilter!: number | undefined;
    minActualFilter!: number | undefined;
    maxBonusFilter!: number | undefined;
    minBonusFilter!: number | undefined;
    maxCumulatedMonthFilter!: number | undefined;
    minCumulatedMonthFilter!: number | undefined;
    maxUpdatedDateFilter!: number | undefined;
    minUpdatedDateFilter!: number | undefined;
    cumulatedMonthFilter!: number | undefined;
    sorting!: string | undefined;
    skipCount!: number | undefined;
    maxResultCount!: number | undefined;

    constructor(data?: IGetAllOutletRevenueBaselinesInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.filter = data["filter"];
            this.outletCodeFilter = data["outletCodeFilter"];
            this.outletNameFilter = data["outletNameFilter"];
            this.maxTargetFilter = data["maxTargetFilter"];
            this.minTargetFilter = data["minTargetFilter"];
            this.maxActualFilter = data["maxActualFilter"];
            this.minActualFilter = data["minActualFilter"];
            this.maxBonusFilter = data["maxBonusFilter"];
            this.minBonusFilter = data["minBonusFilter"];
            this.maxCumulatedMonthFilter = data["maxCumulatedMonthFilter"];
            this.minCumulatedMonthFilter = data["minCumulatedMonthFilter"];
            this.maxUpdatedDateFilter = data["maxUpdatedDateFilter"];
            this.minUpdatedDateFilter = data["minUpdatedDateFilter"];
            this.cumulatedMonthFilter = data["cumulatedMonthFilter"];
            this.sorting = data["sorting"];
            this.skipCount = data["skipCount"];
            this.maxResultCount = data["maxResultCount"];
        }
    }

    static fromJS(data: any): GetAllOutletRevenueBaselinesInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllOutletRevenueBaselinesInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        data["outletCodeFilter"] = this.outletCodeFilter;
        data["outletNameFilter"] = this.outletNameFilter;
        data["maxTargetFilter"] = this.maxTargetFilter;
        data["minTargetFilter"] = this.minTargetFilter;
        data["maxActualFilter"] = this.maxActualFilter;
        data["minActualFilter"] = this.minActualFilter;
        data["maxBonusFilter"] = this.maxBonusFilter;
        data["minBonusFilter"] = this.minBonusFilter;
        data["maxCumulatedMonthFilter"] = this.maxCumulatedMonthFilter;
        data["minCumulatedMonthFilter"] = this.minCumulatedMonthFilter;
        data["maxUpdatedDateFilter"] = this.maxUpdatedDateFilter;
        data["minUpdatedDateFilter"] = this.minUpdatedDateFilter;
        data["cumulatedMonthFilter"] = this.cumulatedMonthFilter;
        data["sorting"] = this.sorting;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data;
    }
}

export interface IGetAllOutletRevenueBaselinesInput {
    filter: string | undefined;
    outletCodeFilter: string | undefined;
    outletNameFilter: string | undefined;
    maxTargetFilter: number | undefined;
    minTargetFilter: number | undefined;
    maxActualFilter: number | undefined;
    minActualFilter: number | undefined;
    maxBonusFilter: number | undefined;
    minBonusFilter: number | undefined;
    maxCumulatedMonthFilter: number | undefined;
    minCumulatedMonthFilter: number | undefined;
    maxUpdatedDateFilter: number | undefined;
    minUpdatedDateFilter: number | undefined;
    cumulatedMonthFilter: number | undefined;
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;
}

export class RetailerRevenueHistory implements IRetailerRevenueHistory {
    month!: number | undefined;
    updateDate!: number | undefined;
    target!: number | undefined;
    actual!: number | undefined;
    bonus!: number | undefined;

    constructor(data?: IRetailerRevenueHistory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.month = data["month"];
            this.updateDate = data["updateDate"];
            this.target = data["target"];
            this.actual = data["actual"];
            this.bonus = data["bonus"];
        }
    }

    static fromJS(data: any): RetailerRevenueHistory {
        data = typeof data === 'object' ? data : {};
        let result = new RetailerRevenueHistory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["month"] = this.month;
        data["updateDate"] = this.updateDate;
        data["target"] = this.target;
        data["actual"] = this.actual;
        data["bonus"] = this.bonus;
        return data;
    }
}

export interface IRetailerRevenueHistory {
    month: number | undefined;
    updateDate: number | undefined;
    target: number | undefined;
    actual: number | undefined;
    bonus: number | undefined;
}

export class PagedResultDtoOfGetOutletUpdateHistoryForViewDto implements IPagedResultDtoOfGetOutletUpdateHistoryForViewDto {
    totalCount!: number | undefined;
    items!: GetOutletUpdateHistoryForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetOutletUpdateHistoryForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetOutletUpdateHistoryForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetOutletUpdateHistoryForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetOutletUpdateHistoryForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetOutletUpdateHistoryForViewDto {
    totalCount: number | undefined;
    items: GetOutletUpdateHistoryForViewDto[] | undefined;
}

export class GetOutletUpdateHistoryForViewDto implements IGetOutletUpdateHistoryForViewDto {
    outletUpdateHistory!: OutletUpdateHistoryDto | undefined;

    constructor(data?: IGetOutletUpdateHistoryForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.outletUpdateHistory = data["outletUpdateHistory"] ? OutletUpdateHistoryDto.fromJS(data["outletUpdateHistory"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetOutletUpdateHistoryForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetOutletUpdateHistoryForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["outletUpdateHistory"] = this.outletUpdateHistory ? this.outletUpdateHistory.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetOutletUpdateHistoryForViewDto {
    outletUpdateHistory: OutletUpdateHistoryDto | undefined;
}

export class OutletUpdateHistoryDto implements IOutletUpdateHistoryDto {
    outletCode!: string | undefined;
    reasonPhone!: string | undefined;
    phoneUpdated!: string | undefined;
    phoneUpdatedDate!: moment.Moment | undefined;
    phoneUpdateStatus!: string | undefined;
    otp!: string | undefined;
    gapDistance!: number | undefined;
    latUpdated!: string | undefined;
    lngUpdated!: string | undefined;
    authenOTPDate!: moment.Moment | undefined;
    isDelete!: boolean | undefined;
    salesmanCode!: string | undefined;
    timeSendOTP!: moment.Moment | undefined;
    homePhone!: string | undefined;
    updateType!: string | undefined;
    id!: number | undefined;

    constructor(data?: IOutletUpdateHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.outletCode = data["outletCode"];
            this.reasonPhone = data["reasonPhone"];
            this.phoneUpdated = data["phoneUpdated"];
            this.phoneUpdatedDate = data["phoneUpdatedDate"] ? moment(data["phoneUpdatedDate"].toString()) : <any>undefined;
            this.phoneUpdateStatus = data["phoneUpdateStatus"];
            this.otp = data["otp"];
            this.gapDistance = data["gapDistance"];
            this.latUpdated = data["latUpdated"];
            this.lngUpdated = data["lngUpdated"];
            this.authenOTPDate = data["authenOTPDate"] ? moment(data["authenOTPDate"].toString()) : <any>undefined;
            this.isDelete = data["isDelete"];
            this.salesmanCode = data["salesmanCode"];
            this.timeSendOTP = data["timeSendOTP"] ? moment(data["timeSendOTP"].toString()) : <any>undefined;
            this.homePhone = data["homePhone"];
            this.updateType = data["updateType"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): OutletUpdateHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new OutletUpdateHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["outletCode"] = this.outletCode;
        data["reasonPhone"] = this.reasonPhone;
        data["phoneUpdated"] = this.phoneUpdated;
        data["phoneUpdatedDate"] = this.phoneUpdatedDate ? this.phoneUpdatedDate.toISOString() : <any>undefined;
        data["phoneUpdateStatus"] = this.phoneUpdateStatus;
        data["otp"] = this.otp;
        data["gapDistance"] = this.gapDistance;
        data["latUpdated"] = this.latUpdated;
        data["lngUpdated"] = this.lngUpdated;
        data["authenOTPDate"] = this.authenOTPDate ? this.authenOTPDate.toISOString() : <any>undefined;
        data["isDelete"] = this.isDelete;
        data["salesmanCode"] = this.salesmanCode;
        data["timeSendOTP"] = this.timeSendOTP ? this.timeSendOTP.toISOString() : <any>undefined;
        data["homePhone"] = this.homePhone;
        data["updateType"] = this.updateType;
        data["id"] = this.id;
        return data;
    }
}

export interface IOutletUpdateHistoryDto {
    outletCode: string | undefined;
    reasonPhone: string | undefined;
    phoneUpdated: string | undefined;
    phoneUpdatedDate: moment.Moment | undefined;
    phoneUpdateStatus: string | undefined;
    otp: string | undefined;
    gapDistance: number | undefined;
    latUpdated: string | undefined;
    lngUpdated: string | undefined;
    authenOTPDate: moment.Moment | undefined;
    isDelete: boolean | undefined;
    salesmanCode: string | undefined;
    timeSendOTP: moment.Moment | undefined;
    homePhone: string | undefined;
    updateType: string | undefined;
    id: number | undefined;
}

export class GetOutletUpdateHistoryForEditOutput implements IGetOutletUpdateHistoryForEditOutput {
    outletUpdateHistory!: CreateOrEditOutletUpdateHistoryDto | undefined;

    constructor(data?: IGetOutletUpdateHistoryForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.outletUpdateHistory = data["outletUpdateHistory"] ? CreateOrEditOutletUpdateHistoryDto.fromJS(data["outletUpdateHistory"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetOutletUpdateHistoryForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetOutletUpdateHistoryForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["outletUpdateHistory"] = this.outletUpdateHistory ? this.outletUpdateHistory.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetOutletUpdateHistoryForEditOutput {
    outletUpdateHistory: CreateOrEditOutletUpdateHistoryDto | undefined;
}

export class CreateOrEditOutletUpdateHistoryDto implements ICreateOrEditOutletUpdateHistoryDto {
    outletCode!: string | undefined;
    reasonPhone!: string | undefined;
    phoneUpdated!: string | undefined;
    phoneUpdatedDate!: moment.Moment | undefined;
    phoneUpdateStatus!: string | undefined;
    otp!: string | undefined;
    gapDistance!: number | undefined;
    latUpdated!: string | undefined;
    lngUpdated!: string | undefined;
    authenOTPDate!: moment.Moment | undefined;
    isDelete!: boolean | undefined;
    salesmanCode!: string | undefined;
    timeSendOTP!: moment.Moment | undefined;
    homePhone!: string | undefined;
    updateType!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditOutletUpdateHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.outletCode = data["outletCode"];
            this.reasonPhone = data["reasonPhone"];
            this.phoneUpdated = data["phoneUpdated"];
            this.phoneUpdatedDate = data["phoneUpdatedDate"] ? moment(data["phoneUpdatedDate"].toString()) : <any>undefined;
            this.phoneUpdateStatus = data["phoneUpdateStatus"];
            this.otp = data["otp"];
            this.gapDistance = data["gapDistance"];
            this.latUpdated = data["latUpdated"];
            this.lngUpdated = data["lngUpdated"];
            this.authenOTPDate = data["authenOTPDate"] ? moment(data["authenOTPDate"].toString()) : <any>undefined;
            this.isDelete = data["isDelete"];
            this.salesmanCode = data["salesmanCode"];
            this.timeSendOTP = data["timeSendOTP"] ? moment(data["timeSendOTP"].toString()) : <any>undefined;
            this.homePhone = data["homePhone"];
            this.updateType = data["updateType"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditOutletUpdateHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditOutletUpdateHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["outletCode"] = this.outletCode;
        data["reasonPhone"] = this.reasonPhone;
        data["phoneUpdated"] = this.phoneUpdated;
        data["phoneUpdatedDate"] = this.phoneUpdatedDate ? this.phoneUpdatedDate.toISOString() : <any>undefined;
        data["phoneUpdateStatus"] = this.phoneUpdateStatus;
        data["otp"] = this.otp;
        data["gapDistance"] = this.gapDistance;
        data["latUpdated"] = this.latUpdated;
        data["lngUpdated"] = this.lngUpdated;
        data["authenOTPDate"] = this.authenOTPDate ? this.authenOTPDate.toISOString() : <any>undefined;
        data["isDelete"] = this.isDelete;
        data["salesmanCode"] = this.salesmanCode;
        data["timeSendOTP"] = this.timeSendOTP ? this.timeSendOTP.toISOString() : <any>undefined;
        data["homePhone"] = this.homePhone;
        data["updateType"] = this.updateType;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditOutletUpdateHistoryDto {
    outletCode: string | undefined;
    reasonPhone: string | undefined;
    phoneUpdated: string | undefined;
    phoneUpdatedDate: moment.Moment | undefined;
    phoneUpdateStatus: string | undefined;
    otp: string | undefined;
    gapDistance: number | undefined;
    latUpdated: string | undefined;
    lngUpdated: string | undefined;
    authenOTPDate: moment.Moment | undefined;
    isDelete: boolean | undefined;
    salesmanCode: string | undefined;
    timeSendOTP: moment.Moment | undefined;
    homePhone: string | undefined;
    updateType: string | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfGetPayBonusForViewDto implements IPagedResultDtoOfGetPayBonusForViewDto {
    totalCount!: number | undefined;
    items!: GetPayBonusForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetPayBonusForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetPayBonusForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetPayBonusForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetPayBonusForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetPayBonusForViewDto {
    totalCount: number | undefined;
    items: GetPayBonusForViewDto[] | undefined;
}

export class GetPayBonusForViewDto implements IGetPayBonusForViewDto {
    payBonus!: PayBonusDto | undefined;

    constructor(data?: IGetPayBonusForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.payBonus = data["payBonus"] ? PayBonusDto.fromJS(data["payBonus"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetPayBonusForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPayBonusForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["payBonus"] = this.payBonus ? this.payBonus.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetPayBonusForViewDto {
    payBonus: PayBonusDto | undefined;
}

export class PayBonusDto implements IPayBonusDto {
    outletCode!: string | undefined;
    revenue!: number | undefined;
    type!: string | undefined;
    month!: number | undefined;
    year!: number | undefined;
    calculatedDate!: moment.Moment | undefined;
    bonusPoint!: number | undefined;
    bonusCoin!: number | undefined;
    status!: string | undefined;
    bonusAmount!: number | undefined;
    outletName!: string | undefined;
    lastModificationTime!: moment.Moment | undefined;
    creationTime!: moment.Moment | undefined;
    id!: number | undefined;

    constructor(data?: IPayBonusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.outletCode = data["outletCode"];
            this.revenue = data["revenue"];
            this.type = data["type"];
            this.month = data["month"];
            this.year = data["year"];
            this.calculatedDate = data["calculatedDate"] ? moment(data["calculatedDate"].toString()) : <any>undefined;
            this.bonusPoint = data["bonusPoint"];
            this.bonusCoin = data["bonusCoin"];
            this.status = data["status"];
            this.bonusAmount = data["bonusAmount"];
            this.outletName = data["outletName"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): PayBonusDto {
        data = typeof data === 'object' ? data : {};
        let result = new PayBonusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["outletCode"] = this.outletCode;
        data["revenue"] = this.revenue;
        data["type"] = this.type;
        data["month"] = this.month;
        data["year"] = this.year;
        data["calculatedDate"] = this.calculatedDate ? this.calculatedDate.toISOString() : <any>undefined;
        data["bonusPoint"] = this.bonusPoint;
        data["bonusCoin"] = this.bonusCoin;
        data["status"] = this.status;
        data["bonusAmount"] = this.bonusAmount;
        data["outletName"] = this.outletName;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IPayBonusDto {
    outletCode: string | undefined;
    revenue: number | undefined;
    type: string | undefined;
    month: number | undefined;
    year: number | undefined;
    calculatedDate: moment.Moment | undefined;
    bonusPoint: number | undefined;
    bonusCoin: number | undefined;
    status: string | undefined;
    bonusAmount: number | undefined;
    outletName: string | undefined;
    lastModificationTime: moment.Moment | undefined;
    creationTime: moment.Moment | undefined;
    id: number | undefined;
}

export class GetPayBonusForEditOutput implements IGetPayBonusForEditOutput {
    payBonus!: CreateOrEditPayBonusDto | undefined;

    constructor(data?: IGetPayBonusForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.payBonus = data["payBonus"] ? CreateOrEditPayBonusDto.fromJS(data["payBonus"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetPayBonusForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetPayBonusForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["payBonus"] = this.payBonus ? this.payBonus.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetPayBonusForEditOutput {
    payBonus: CreateOrEditPayBonusDto | undefined;
}

export class CreateOrEditPayBonusDto implements ICreateOrEditPayBonusDto {
    outletCode!: string | undefined;
    revenue!: number | undefined;
    type!: string | undefined;
    month!: number | undefined;
    year!: number | undefined;
    calculatedDate!: moment.Moment | undefined;
    bonusPoint!: number | undefined;
    bonusCoin!: number | undefined;
    status!: string | undefined;
    bonusAmount!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditPayBonusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.outletCode = data["outletCode"];
            this.revenue = data["revenue"];
            this.type = data["type"];
            this.month = data["month"];
            this.year = data["year"];
            this.calculatedDate = data["calculatedDate"] ? moment(data["calculatedDate"].toString()) : <any>undefined;
            this.bonusPoint = data["bonusPoint"];
            this.bonusCoin = data["bonusCoin"];
            this.status = data["status"];
            this.bonusAmount = data["bonusAmount"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditPayBonusDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditPayBonusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["outletCode"] = this.outletCode;
        data["revenue"] = this.revenue;
        data["type"] = this.type;
        data["month"] = this.month;
        data["year"] = this.year;
        data["calculatedDate"] = this.calculatedDate ? this.calculatedDate.toISOString() : <any>undefined;
        data["bonusPoint"] = this.bonusPoint;
        data["bonusCoin"] = this.bonusCoin;
        data["status"] = this.status;
        data["bonusAmount"] = this.bonusAmount;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditPayBonusDto {
    outletCode: string | undefined;
    revenue: number | undefined;
    type: string | undefined;
    month: number | undefined;
    year: number | undefined;
    calculatedDate: moment.Moment | undefined;
    bonusPoint: number | undefined;
    bonusCoin: number | undefined;
    status: string | undefined;
    bonusAmount: number | undefined;
    id: number | undefined;
}

export class GetAllPayBonussInput implements IGetAllPayBonussInput {
    filter!: string | undefined;
    outletCodeFilter!: string | undefined;
    maxRevenueFilter!: number | undefined;
    minRevenueFilter!: number | undefined;
    typeFilter!: string | undefined;
    maxMonthFilter!: number | undefined;
    minMonthFilter!: number | undefined;
    maxYearFilter!: number | undefined;
    minYearFilter!: number | undefined;
    maxCalculatedDateFilter!: moment.Moment | undefined;
    minCalculatedDateFilter!: moment.Moment | undefined;
    maxBonusPointFilter!: number | undefined;
    minBonusPointFilter!: number | undefined;
    maxBonusCoinFilter!: number | undefined;
    minBonusCoinFilter!: number | undefined;
    statusFilter!: string | undefined;
    maxBonusAmountFilter!: number | undefined;
    minBonusAmountFilter!: number | undefined;
    calculatedDateFilter!: moment.Moment | undefined;
    sorting!: string | undefined;
    skipCount!: number | undefined;
    maxResultCount!: number | undefined;

    constructor(data?: IGetAllPayBonussInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.filter = data["filter"];
            this.outletCodeFilter = data["outletCodeFilter"];
            this.maxRevenueFilter = data["maxRevenueFilter"];
            this.minRevenueFilter = data["minRevenueFilter"];
            this.typeFilter = data["typeFilter"];
            this.maxMonthFilter = data["maxMonthFilter"];
            this.minMonthFilter = data["minMonthFilter"];
            this.maxYearFilter = data["maxYearFilter"];
            this.minYearFilter = data["minYearFilter"];
            this.maxCalculatedDateFilter = data["maxCalculatedDateFilter"] ? moment(data["maxCalculatedDateFilter"].toString()) : <any>undefined;
            this.minCalculatedDateFilter = data["minCalculatedDateFilter"] ? moment(data["minCalculatedDateFilter"].toString()) : <any>undefined;
            this.maxBonusPointFilter = data["maxBonusPointFilter"];
            this.minBonusPointFilter = data["minBonusPointFilter"];
            this.maxBonusCoinFilter = data["maxBonusCoinFilter"];
            this.minBonusCoinFilter = data["minBonusCoinFilter"];
            this.statusFilter = data["statusFilter"];
            this.maxBonusAmountFilter = data["maxBonusAmountFilter"];
            this.minBonusAmountFilter = data["minBonusAmountFilter"];
            this.calculatedDateFilter = data["calculatedDateFilter"] ? moment(data["calculatedDateFilter"].toString()) : <any>undefined;
            this.sorting = data["sorting"];
            this.skipCount = data["skipCount"];
            this.maxResultCount = data["maxResultCount"];
        }
    }

    static fromJS(data: any): GetAllPayBonussInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllPayBonussInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        data["outletCodeFilter"] = this.outletCodeFilter;
        data["maxRevenueFilter"] = this.maxRevenueFilter;
        data["minRevenueFilter"] = this.minRevenueFilter;
        data["typeFilter"] = this.typeFilter;
        data["maxMonthFilter"] = this.maxMonthFilter;
        data["minMonthFilter"] = this.minMonthFilter;
        data["maxYearFilter"] = this.maxYearFilter;
        data["minYearFilter"] = this.minYearFilter;
        data["maxCalculatedDateFilter"] = this.maxCalculatedDateFilter ? this.maxCalculatedDateFilter.toISOString() : <any>undefined;
        data["minCalculatedDateFilter"] = this.minCalculatedDateFilter ? this.minCalculatedDateFilter.toISOString() : <any>undefined;
        data["maxBonusPointFilter"] = this.maxBonusPointFilter;
        data["minBonusPointFilter"] = this.minBonusPointFilter;
        data["maxBonusCoinFilter"] = this.maxBonusCoinFilter;
        data["minBonusCoinFilter"] = this.minBonusCoinFilter;
        data["statusFilter"] = this.statusFilter;
        data["maxBonusAmountFilter"] = this.maxBonusAmountFilter;
        data["minBonusAmountFilter"] = this.minBonusAmountFilter;
        data["calculatedDateFilter"] = this.calculatedDateFilter ? this.calculatedDateFilter.toISOString() : <any>undefined;
        data["sorting"] = this.sorting;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data;
    }
}

export interface IGetAllPayBonussInput {
    filter: string | undefined;
    outletCodeFilter: string | undefined;
    maxRevenueFilter: number | undefined;
    minRevenueFilter: number | undefined;
    typeFilter: string | undefined;
    maxMonthFilter: number | undefined;
    minMonthFilter: number | undefined;
    maxYearFilter: number | undefined;
    minYearFilter: number | undefined;
    maxCalculatedDateFilter: moment.Moment | undefined;
    minCalculatedDateFilter: moment.Moment | undefined;
    maxBonusPointFilter: number | undefined;
    minBonusPointFilter: number | undefined;
    maxBonusCoinFilter: number | undefined;
    minBonusCoinFilter: number | undefined;
    statusFilter: string | undefined;
    maxBonusAmountFilter: number | undefined;
    minBonusAmountFilter: number | undefined;
    calculatedDateFilter: moment.Moment | undefined;
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;
}

export class PayBonusImportAgrs implements IPayBonusImportAgrs {
    timeZoneOffset!: number | undefined;
    currentDate!: moment.Moment | undefined;
    tableName!: string | undefined;
    filePath!: string | undefined;
    fileName!: string | undefined;
    userId!: number | undefined;
    userName!: string | undefined;
    name!: string | undefined;
    tenantId!: number | undefined;
    currentLanguage!: string | undefined;
    apiUrl!: string | undefined;

    constructor(data?: IPayBonusImportAgrs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.timeZoneOffset = data["timeZoneOffset"];
            this.currentDate = data["currentDate"] ? moment(data["currentDate"].toString()) : <any>undefined;
            this.tableName = data["tableName"];
            this.filePath = data["filePath"];
            this.fileName = data["fileName"];
            this.userId = data["userId"];
            this.userName = data["userName"];
            this.name = data["name"];
            this.tenantId = data["tenantId"];
            this.currentLanguage = data["currentLanguage"];
            this.apiUrl = data["apiUrl"];
        }
    }

    static fromJS(data: any): PayBonusImportAgrs {
        data = typeof data === 'object' ? data : {};
        let result = new PayBonusImportAgrs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timeZoneOffset"] = this.timeZoneOffset;
        data["currentDate"] = this.currentDate ? this.currentDate.toISOString() : <any>undefined;
        data["tableName"] = this.tableName;
        data["filePath"] = this.filePath;
        data["fileName"] = this.fileName;
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["name"] = this.name;
        data["tenantId"] = this.tenantId;
        data["currentLanguage"] = this.currentLanguage;
        data["apiUrl"] = this.apiUrl;
        return data;
    }
}

export interface IPayBonusImportAgrs {
    timeZoneOffset: number | undefined;
    currentDate: moment.Moment | undefined;
    tableName: string | undefined;
    filePath: string | undefined;
    fileName: string | undefined;
    userId: number | undefined;
    userName: string | undefined;
    name: string | undefined;
    tenantId: number | undefined;
    currentLanguage: string | undefined;
    apiUrl: string | undefined;
}

export class PayBonusExportInput implements IPayBonusExportInput {
    filter!: string | undefined;
    outletCodeFilter!: string | undefined;
    maxRevenueFilter!: number | undefined;
    minRevenueFilter!: number | undefined;
    typeFilter!: string | undefined;
    maxMonthFilter!: number | undefined;
    minMonthFilter!: number | undefined;
    maxYearFilter!: number | undefined;
    minYearFilter!: number | undefined;
    maxCalculatedDateFilter!: moment.Moment | undefined;
    minCalculatedDateFilter!: moment.Moment | undefined;
    maxBonusPointFilter!: number | undefined;
    minBonusPointFilter!: number | undefined;
    maxBonusCoinFilter!: number | undefined;
    minBonusCoinFilter!: number | undefined;
    statusFilter!: string | undefined;
    maxBonusAmountFilter!: number | undefined;
    minBonusAmountFilter!: number | undefined;
    ids!: number[] | undefined;
    calculatedDateFilter!: moment.Moment | undefined;
    sorting!: string | undefined;
    skipCount!: number | undefined;
    maxResultCount!: number | undefined;

    constructor(data?: IPayBonusExportInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.filter = data["filter"];
            this.outletCodeFilter = data["outletCodeFilter"];
            this.maxRevenueFilter = data["maxRevenueFilter"];
            this.minRevenueFilter = data["minRevenueFilter"];
            this.typeFilter = data["typeFilter"];
            this.maxMonthFilter = data["maxMonthFilter"];
            this.minMonthFilter = data["minMonthFilter"];
            this.maxYearFilter = data["maxYearFilter"];
            this.minYearFilter = data["minYearFilter"];
            this.maxCalculatedDateFilter = data["maxCalculatedDateFilter"] ? moment(data["maxCalculatedDateFilter"].toString()) : <any>undefined;
            this.minCalculatedDateFilter = data["minCalculatedDateFilter"] ? moment(data["minCalculatedDateFilter"].toString()) : <any>undefined;
            this.maxBonusPointFilter = data["maxBonusPointFilter"];
            this.minBonusPointFilter = data["minBonusPointFilter"];
            this.maxBonusCoinFilter = data["maxBonusCoinFilter"];
            this.minBonusCoinFilter = data["minBonusCoinFilter"];
            this.statusFilter = data["statusFilter"];
            this.maxBonusAmountFilter = data["maxBonusAmountFilter"];
            this.minBonusAmountFilter = data["minBonusAmountFilter"];
            if (data["ids"] && data["ids"].constructor === Array) {
                this.ids = [];
                for (let item of data["ids"])
                    this.ids.push(item);
            }
            this.calculatedDateFilter = data["calculatedDateFilter"] ? moment(data["calculatedDateFilter"].toString()) : <any>undefined;
            this.sorting = data["sorting"];
            this.skipCount = data["skipCount"];
            this.maxResultCount = data["maxResultCount"];
        }
    }

    static fromJS(data: any): PayBonusExportInput {
        data = typeof data === 'object' ? data : {};
        let result = new PayBonusExportInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        data["outletCodeFilter"] = this.outletCodeFilter;
        data["maxRevenueFilter"] = this.maxRevenueFilter;
        data["minRevenueFilter"] = this.minRevenueFilter;
        data["typeFilter"] = this.typeFilter;
        data["maxMonthFilter"] = this.maxMonthFilter;
        data["minMonthFilter"] = this.minMonthFilter;
        data["maxYearFilter"] = this.maxYearFilter;
        data["minYearFilter"] = this.minYearFilter;
        data["maxCalculatedDateFilter"] = this.maxCalculatedDateFilter ? this.maxCalculatedDateFilter.toISOString() : <any>undefined;
        data["minCalculatedDateFilter"] = this.minCalculatedDateFilter ? this.minCalculatedDateFilter.toISOString() : <any>undefined;
        data["maxBonusPointFilter"] = this.maxBonusPointFilter;
        data["minBonusPointFilter"] = this.minBonusPointFilter;
        data["maxBonusCoinFilter"] = this.maxBonusCoinFilter;
        data["minBonusCoinFilter"] = this.minBonusCoinFilter;
        data["statusFilter"] = this.statusFilter;
        data["maxBonusAmountFilter"] = this.maxBonusAmountFilter;
        data["minBonusAmountFilter"] = this.minBonusAmountFilter;
        if (this.ids && this.ids.constructor === Array) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        data["calculatedDateFilter"] = this.calculatedDateFilter ? this.calculatedDateFilter.toISOString() : <any>undefined;
        data["sorting"] = this.sorting;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data;
    }
}

export interface IPayBonusExportInput {
    filter: string | undefined;
    outletCodeFilter: string | undefined;
    maxRevenueFilter: number | undefined;
    minRevenueFilter: number | undefined;
    typeFilter: string | undefined;
    maxMonthFilter: number | undefined;
    minMonthFilter: number | undefined;
    maxYearFilter: number | undefined;
    minYearFilter: number | undefined;
    maxCalculatedDateFilter: moment.Moment | undefined;
    minCalculatedDateFilter: moment.Moment | undefined;
    maxBonusPointFilter: number | undefined;
    minBonusPointFilter: number | undefined;
    maxBonusCoinFilter: number | undefined;
    minBonusCoinFilter: number | undefined;
    statusFilter: string | undefined;
    maxBonusAmountFilter: number | undefined;
    minBonusAmountFilter: number | undefined;
    ids: number[] | undefined;
    calculatedDateFilter: moment.Moment | undefined;
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;
}

export class PagedResultDtoOfRetailerPayBonusViewDto implements IPagedResultDtoOfRetailerPayBonusViewDto {
    totalCount!: number | undefined;
    items!: RetailerPayBonusViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfRetailerPayBonusViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(RetailerPayBonusViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfRetailerPayBonusViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfRetailerPayBonusViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfRetailerPayBonusViewDto {
    totalCount: number | undefined;
    items: RetailerPayBonusViewDto[] | undefined;
}

export class RetailerPayBonusViewDto implements IRetailerPayBonusViewDto {
    month!: number | undefined;
    year!: number | undefined;
    bonus!: RetailerPayBonusDto[] | undefined;

    constructor(data?: IRetailerPayBonusViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.month = data["month"];
            this.year = data["year"];
            if (data["bonus"] && data["bonus"].constructor === Array) {
                this.bonus = [];
                for (let item of data["bonus"])
                    this.bonus.push(RetailerPayBonusDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RetailerPayBonusViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new RetailerPayBonusViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["month"] = this.month;
        data["year"] = this.year;
        if (this.bonus && this.bonus.constructor === Array) {
            data["bonus"] = [];
            for (let item of this.bonus)
                data["bonus"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRetailerPayBonusViewDto {
    month: number | undefined;
    year: number | undefined;
    bonus: RetailerPayBonusDto[] | undefined;
}

export class PaymentInfoDto implements IPaymentInfoDto {
    edition!: EditionSelectDto | undefined;
    additionalPrice!: number | undefined;

    constructor(data?: IPaymentInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.edition = data["edition"] ? EditionSelectDto.fromJS(data["edition"]) : <any>undefined;
            this.additionalPrice = data["additionalPrice"];
        }
    }

    static fromJS(data: any): PaymentInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["edition"] = this.edition ? this.edition.toJSON() : <any>undefined;
        data["additionalPrice"] = this.additionalPrice;
        return data;
    }
}

export interface IPaymentInfoDto {
    edition: EditionSelectDto | undefined;
    additionalPrice: number | undefined;
}

export class EditionSelectDto implements IEditionSelectDto {
    id!: number | undefined;
    name!: string | undefined;
    displayName!: string | undefined;
    expiringEditionId!: number | undefined;
    monthlyPrice!: number | undefined;
    annualPrice!: number | undefined;
    trialDayCount!: number | undefined;
    waitingDayAfterExpire!: number | undefined;
    isFree!: boolean | undefined;
    additionalData!: AdditionalData | undefined;

    constructor(data?: IEditionSelectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.displayName = data["displayName"];
            this.expiringEditionId = data["expiringEditionId"];
            this.monthlyPrice = data["monthlyPrice"];
            this.annualPrice = data["annualPrice"];
            this.trialDayCount = data["trialDayCount"];
            this.waitingDayAfterExpire = data["waitingDayAfterExpire"];
            this.isFree = data["isFree"];
            this.additionalData = data["additionalData"] ? AdditionalData.fromJS(data["additionalData"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EditionSelectDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditionSelectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["expiringEditionId"] = this.expiringEditionId;
        data["monthlyPrice"] = this.monthlyPrice;
        data["annualPrice"] = this.annualPrice;
        data["trialDayCount"] = this.trialDayCount;
        data["waitingDayAfterExpire"] = this.waitingDayAfterExpire;
        data["isFree"] = this.isFree;
        data["additionalData"] = this.additionalData ? this.additionalData.toJSON() : <any>undefined;
        return data;
    }
}

export interface IEditionSelectDto {
    id: number | undefined;
    name: string | undefined;
    displayName: string | undefined;
    expiringEditionId: number | undefined;
    monthlyPrice: number | undefined;
    annualPrice: number | undefined;
    trialDayCount: number | undefined;
    waitingDayAfterExpire: number | undefined;
    isFree: boolean | undefined;
    additionalData: AdditionalData | undefined;
}

export class CreatePaymentDto implements ICreatePaymentDto {
    editionId!: number | undefined;
    editionPaymentType!: CreatePaymentDtoEditionPaymentType | undefined;
    paymentPeriodType!: CreatePaymentDtoPaymentPeriodType | undefined;
    subscriptionPaymentGatewayType!: CreatePaymentDtoSubscriptionPaymentGatewayType | undefined;

    constructor(data?: ICreatePaymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.editionId = data["editionId"];
            this.editionPaymentType = data["editionPaymentType"];
            this.paymentPeriodType = data["paymentPeriodType"];
            this.subscriptionPaymentGatewayType = data["subscriptionPaymentGatewayType"];
        }
    }

    static fromJS(data: any): CreatePaymentDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePaymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["editionId"] = this.editionId;
        data["editionPaymentType"] = this.editionPaymentType;
        data["paymentPeriodType"] = this.paymentPeriodType;
        data["subscriptionPaymentGatewayType"] = this.subscriptionPaymentGatewayType;
        return data;
    }
}

export interface ICreatePaymentDto {
    editionId: number | undefined;
    editionPaymentType: CreatePaymentDtoEditionPaymentType | undefined;
    paymentPeriodType: CreatePaymentDtoPaymentPeriodType | undefined;
    subscriptionPaymentGatewayType: CreatePaymentDtoSubscriptionPaymentGatewayType | undefined;
}

export class CancelPaymentDto implements ICancelPaymentDto {
    paymentId!: string | undefined;
    gateway!: CancelPaymentDtoGateway | undefined;

    constructor(data?: ICancelPaymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.paymentId = data["paymentId"];
            this.gateway = data["gateway"];
        }
    }

    static fromJS(data: any): CancelPaymentDto {
        data = typeof data === 'object' ? data : {};
        let result = new CancelPaymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentId"] = this.paymentId;
        data["gateway"] = this.gateway;
        return data;
    }
}

export interface ICancelPaymentDto {
    paymentId: string | undefined;
    gateway: CancelPaymentDtoGateway | undefined;
}

export class ExecutePaymentDto implements IExecutePaymentDto {
    gateway!: ExecutePaymentDtoGateway | undefined;
    editionPaymentType!: ExecutePaymentDtoEditionPaymentType | undefined;
    editionId!: number | undefined;
    paymentPeriodType!: ExecutePaymentDtoPaymentPeriodType | undefined;
    additionalData!: { [key: string]: string; } | undefined;

    constructor(data?: IExecutePaymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.gateway = data["gateway"];
            this.editionPaymentType = data["editionPaymentType"];
            this.editionId = data["editionId"];
            this.paymentPeriodType = data["paymentPeriodType"];
            if (data["additionalData"]) {
                this.additionalData = {};
                for (let key in data["additionalData"]) {
                    if (data["additionalData"].hasOwnProperty(key))
                        this.additionalData[key] = data["additionalData"][key];
                }
            }
        }
    }

    static fromJS(data: any): ExecutePaymentDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExecutePaymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gateway"] = this.gateway;
        data["editionPaymentType"] = this.editionPaymentType;
        data["editionId"] = this.editionId;
        data["paymentPeriodType"] = this.paymentPeriodType;
        if (this.additionalData) {
            data["additionalData"] = {};
            for (let key in this.additionalData) {
                if (this.additionalData.hasOwnProperty(key))
                    data["additionalData"][key] = this.additionalData[key];
            }
        }
        return data;
    }
}

export interface IExecutePaymentDto {
    gateway: ExecutePaymentDtoGateway | undefined;
    editionPaymentType: ExecutePaymentDtoEditionPaymentType | undefined;
    editionId: number | undefined;
    paymentPeriodType: ExecutePaymentDtoPaymentPeriodType | undefined;
    additionalData: { [key: string]: string; } | undefined;
}

export class PagedResultDtoOfSubscriptionPaymentListDto implements IPagedResultDtoOfSubscriptionPaymentListDto {
    totalCount!: number | undefined;
    items!: SubscriptionPaymentListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfSubscriptionPaymentListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(SubscriptionPaymentListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfSubscriptionPaymentListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfSubscriptionPaymentListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfSubscriptionPaymentListDto {
    totalCount: number | undefined;
    items: SubscriptionPaymentListDto[] | undefined;
}

export class SubscriptionPaymentListDto implements ISubscriptionPaymentListDto {
    gateway!: string | undefined;
    amount!: number | undefined;
    editionId!: number | undefined;
    dayCount!: number | undefined;
    paymentPeriodType!: string | undefined;
    paymentId!: string | undefined;
    payerId!: string | undefined;
    status!: string | undefined;
    editionDisplayName!: string | undefined;
    tenantId!: number | undefined;
    invoiceNo!: string | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: moment.Moment | undefined;
    creatorUserId!: number | undefined;
    id!: number | undefined;

    constructor(data?: ISubscriptionPaymentListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.gateway = data["gateway"];
            this.amount = data["amount"];
            this.editionId = data["editionId"];
            this.dayCount = data["dayCount"];
            this.paymentPeriodType = data["paymentPeriodType"];
            this.paymentId = data["paymentId"];
            this.payerId = data["payerId"];
            this.status = data["status"];
            this.editionDisplayName = data["editionDisplayName"];
            this.tenantId = data["tenantId"];
            this.invoiceNo = data["invoiceNo"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SubscriptionPaymentListDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionPaymentListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gateway"] = this.gateway;
        data["amount"] = this.amount;
        data["editionId"] = this.editionId;
        data["dayCount"] = this.dayCount;
        data["paymentPeriodType"] = this.paymentPeriodType;
        data["paymentId"] = this.paymentId;
        data["payerId"] = this.payerId;
        data["status"] = this.status;
        data["editionDisplayName"] = this.editionDisplayName;
        data["tenantId"] = this.tenantId;
        data["invoiceNo"] = this.invoiceNo;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ISubscriptionPaymentListDto {
    gateway: string | undefined;
    amount: number | undefined;
    editionId: number | undefined;
    dayCount: number | undefined;
    paymentPeriodType: string | undefined;
    paymentId: string | undefined;
    payerId: string | undefined;
    status: string | undefined;
    editionDisplayName: string | undefined;
    tenantId: number | undefined;
    invoiceNo: string | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfGetPaymentTransactionForViewDto implements IPagedResultDtoOfGetPaymentTransactionForViewDto {
    totalCount!: number | undefined;
    items!: GetPaymentTransactionForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetPaymentTransactionForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetPaymentTransactionForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetPaymentTransactionForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetPaymentTransactionForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetPaymentTransactionForViewDto {
    totalCount: number | undefined;
    items: GetPaymentTransactionForViewDto[] | undefined;
}

export class GetPaymentTransactionForViewDto implements IGetPaymentTransactionForViewDto {
    paymentTransaction!: PaymentTransactionDto | undefined;

    constructor(data?: IGetPaymentTransactionForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.paymentTransaction = data["paymentTransaction"] ? PaymentTransactionDto.fromJS(data["paymentTransaction"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetPaymentTransactionForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPaymentTransactionForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentTransaction"] = this.paymentTransaction ? this.paymentTransaction.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetPaymentTransactionForViewDto {
    paymentTransaction: PaymentTransactionDto | undefined;
}

export class PaymentTransactionDto implements IPaymentTransactionDto {
    salesInvoiceCode!: string | undefined;
    paymentMethod!: string | undefined;
    amount!: number | undefined;
    id!: number | undefined;

    constructor(data?: IPaymentTransactionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.salesInvoiceCode = data["salesInvoiceCode"];
            this.paymentMethod = data["paymentMethod"];
            this.amount = data["amount"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): PaymentTransactionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentTransactionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["salesInvoiceCode"] = this.salesInvoiceCode;
        data["paymentMethod"] = this.paymentMethod;
        data["amount"] = this.amount;
        data["id"] = this.id;
        return data;
    }
}

export interface IPaymentTransactionDto {
    salesInvoiceCode: string | undefined;
    paymentMethod: string | undefined;
    amount: number | undefined;
    id: number | undefined;
}

export class GetPaymentTransactionForEditOutput implements IGetPaymentTransactionForEditOutput {
    paymentTransaction!: CreateOrEditPaymentTransactionDto | undefined;

    constructor(data?: IGetPaymentTransactionForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.paymentTransaction = data["paymentTransaction"] ? CreateOrEditPaymentTransactionDto.fromJS(data["paymentTransaction"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetPaymentTransactionForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetPaymentTransactionForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentTransaction"] = this.paymentTransaction ? this.paymentTransaction.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetPaymentTransactionForEditOutput {
    paymentTransaction: CreateOrEditPaymentTransactionDto | undefined;
}

export class CreateOrEditPaymentTransactionDto implements ICreateOrEditPaymentTransactionDto {
    salesInvoiceCode!: string | undefined;
    paymentMethod!: string | undefined;
    amount!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditPaymentTransactionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.salesInvoiceCode = data["salesInvoiceCode"];
            this.paymentMethod = data["paymentMethod"];
            this.amount = data["amount"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditPaymentTransactionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditPaymentTransactionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["salesInvoiceCode"] = this.salesInvoiceCode;
        data["paymentMethod"] = this.paymentMethod;
        data["amount"] = this.amount;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditPaymentTransactionDto {
    salesInvoiceCode: string | undefined;
    paymentMethod: string | undefined;
    amount: number | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfGetPeriodTimeHistoryForView implements IPagedResultDtoOfGetPeriodTimeHistoryForView {
    totalCount!: number | undefined;
    items!: GetPeriodTimeHistoryForView[] | undefined;

    constructor(data?: IPagedResultDtoOfGetPeriodTimeHistoryForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetPeriodTimeHistoryForView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetPeriodTimeHistoryForView {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetPeriodTimeHistoryForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetPeriodTimeHistoryForView {
    totalCount: number | undefined;
    items: GetPeriodTimeHistoryForView[] | undefined;
}

export class GetPeriodTimeHistoryForView implements IGetPeriodTimeHistoryForView {
    periodTimeHistory!: PeriodTimeHistoryDto | undefined;

    constructor(data?: IGetPeriodTimeHistoryForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.periodTimeHistory = data["periodTimeHistory"] ? PeriodTimeHistoryDto.fromJS(data["periodTimeHistory"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetPeriodTimeHistoryForView {
        data = typeof data === 'object' ? data : {};
        let result = new GetPeriodTimeHistoryForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["periodTimeHistory"] = this.periodTimeHistory ? this.periodTimeHistory.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetPeriodTimeHistoryForView {
    periodTimeHistory: PeriodTimeHistoryDto | undefined;
}

export class PeriodTimeHistoryDto implements IPeriodTimeHistoryDto {
    startPeriod!: string | undefined;
    endPeriod!: string | undefined;
    isActive!: boolean | undefined;
    type!: PeriodTimeHistoryDtoType | undefined;
    id!: number | undefined;

    constructor(data?: IPeriodTimeHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.startPeriod = data["startPeriod"];
            this.endPeriod = data["endPeriod"];
            this.isActive = data["isActive"];
            this.type = data["type"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): PeriodTimeHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new PeriodTimeHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startPeriod"] = this.startPeriod;
        data["endPeriod"] = this.endPeriod;
        data["isActive"] = this.isActive;
        data["type"] = this.type;
        data["id"] = this.id;
        return data;
    }
}

export interface IPeriodTimeHistoryDto {
    startPeriod: string | undefined;
    endPeriod: string | undefined;
    isActive: boolean | undefined;
    type: PeriodTimeHistoryDtoType | undefined;
    id: number | undefined;
}

export class GetPeriodTimeHistoryForEditOutput implements IGetPeriodTimeHistoryForEditOutput {
    periodTimeHistory!: CreateOrEditPeriodTimeHistoryDto | undefined;

    constructor(data?: IGetPeriodTimeHistoryForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.periodTimeHistory = data["periodTimeHistory"] ? CreateOrEditPeriodTimeHistoryDto.fromJS(data["periodTimeHistory"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetPeriodTimeHistoryForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetPeriodTimeHistoryForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["periodTimeHistory"] = this.periodTimeHistory ? this.periodTimeHistory.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetPeriodTimeHistoryForEditOutput {
    periodTimeHistory: CreateOrEditPeriodTimeHistoryDto | undefined;
}

export class CreateOrEditPeriodTimeHistoryDto implements ICreateOrEditPeriodTimeHistoryDto {
    startPeriod!: string | undefined;
    endPeriod!: string | undefined;
    isActive!: boolean | undefined;
    type!: CreateOrEditPeriodTimeHistoryDtoType | undefined;
    isDeleted!: boolean | undefined;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: moment.Moment | undefined;
    creatorUserId!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditPeriodTimeHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.startPeriod = data["startPeriod"];
            this.endPeriod = data["endPeriod"];
            this.isActive = data["isActive"];
            this.type = data["type"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditPeriodTimeHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditPeriodTimeHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startPeriod"] = this.startPeriod;
        data["endPeriod"] = this.endPeriod;
        data["isActive"] = this.isActive;
        data["type"] = this.type;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditPeriodTimeHistoryDto {
    startPeriod: string | undefined;
    endPeriod: string | undefined;
    isActive: boolean | undefined;
    type: CreateOrEditPeriodTimeHistoryDtoType | undefined;
    isDeleted: boolean | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class GetPeriodTimeHistoryByFilter implements IGetPeriodTimeHistoryByFilter {
    startTime!: moment.Moment | undefined;
    endTime!: moment.Moment | undefined;
    type!: GetPeriodTimeHistoryByFilterType | undefined;
    isByMonth!: boolean | undefined;

    constructor(data?: IGetPeriodTimeHistoryByFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.startTime = data["startTime"] ? moment(data["startTime"].toString()) : <any>undefined;
            this.endTime = data["endTime"] ? moment(data["endTime"].toString()) : <any>undefined;
            this.type = data["type"];
            this.isByMonth = data["isByMonth"];
        }
    }

    static fromJS(data: any): GetPeriodTimeHistoryByFilter {
        data = typeof data === 'object' ? data : {};
        let result = new GetPeriodTimeHistoryByFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["type"] = this.type;
        data["isByMonth"] = this.isByMonth;
        return data;
    }
}

export interface IGetPeriodTimeHistoryByFilter {
    startTime: moment.Moment | undefined;
    endTime: moment.Moment | undefined;
    type: GetPeriodTimeHistoryByFilterType | undefined;
    isByMonth: boolean | undefined;
}

export class ListResultDtoOfFlatPermissionWithLevelDto implements IListResultDtoOfFlatPermissionWithLevelDto {
    items!: FlatPermissionWithLevelDto[] | undefined;

    constructor(data?: IListResultDtoOfFlatPermissionWithLevelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(FlatPermissionWithLevelDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfFlatPermissionWithLevelDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfFlatPermissionWithLevelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListResultDtoOfFlatPermissionWithLevelDto {
    items: FlatPermissionWithLevelDto[] | undefined;
}

export class FlatPermissionWithLevelDto implements IFlatPermissionWithLevelDto {
    level!: number | undefined;
    parentName!: string | undefined;
    name!: string | undefined;
    displayName!: string | undefined;
    description!: string | undefined;
    isGrantedByDefault!: boolean | undefined;

    constructor(data?: IFlatPermissionWithLevelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.level = data["level"];
            this.parentName = data["parentName"];
            this.name = data["name"];
            this.displayName = data["displayName"];
            this.description = data["description"];
            this.isGrantedByDefault = data["isGrantedByDefault"];
        }
    }

    static fromJS(data: any): FlatPermissionWithLevelDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlatPermissionWithLevelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["level"] = this.level;
        data["parentName"] = this.parentName;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["isGrantedByDefault"] = this.isGrantedByDefault;
        return data;
    }
}

export interface IFlatPermissionWithLevelDto {
    level: number | undefined;
    parentName: string | undefined;
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    isGrantedByDefault: boolean | undefined;
}

export class PagedResultDtoOfGetPlayerTicketForViewDto implements IPagedResultDtoOfGetPlayerTicketForViewDto {
    totalCount!: number | undefined;
    items!: GetPlayerTicketForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetPlayerTicketForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetPlayerTicketForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetPlayerTicketForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetPlayerTicketForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetPlayerTicketForViewDto {
    totalCount: number | undefined;
    items: GetPlayerTicketForViewDto[] | undefined;
}

export class GetPlayerTicketForViewDto implements IGetPlayerTicketForViewDto {
    playerTicket!: PlayerTicketDto | undefined;

    constructor(data?: IGetPlayerTicketForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.playerTicket = data["playerTicket"] ? PlayerTicketDto.fromJS(data["playerTicket"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetPlayerTicketForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPlayerTicketForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["playerTicket"] = this.playerTicket ? this.playerTicket.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetPlayerTicketForViewDto {
    playerTicket: PlayerTicketDto | undefined;
}

export class PlayerTicketDto implements IPlayerTicketDto {
    playerCode!: string | undefined;
    gameCode!: string | undefined;
    status!: string | undefined;
    usedDate!: moment.Moment | undefined;
    expiredDateTime!: moment.Moment | undefined;
    memberName!: string | undefined;
    createDate!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;
    id!: number | undefined;

    constructor(data?: IPlayerTicketDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.playerCode = data["playerCode"];
            this.gameCode = data["gameCode"];
            this.status = data["status"];
            this.usedDate = data["usedDate"] ? moment(data["usedDate"].toString()) : <any>undefined;
            this.expiredDateTime = data["expiredDateTime"] ? moment(data["expiredDateTime"].toString()) : <any>undefined;
            this.memberName = data["memberName"];
            this.createDate = data["createDate"] ? moment(data["createDate"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): PlayerTicketDto {
        data = typeof data === 'object' ? data : {};
        let result = new PlayerTicketDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["playerCode"] = this.playerCode;
        data["gameCode"] = this.gameCode;
        data["status"] = this.status;
        data["usedDate"] = this.usedDate ? this.usedDate.toISOString() : <any>undefined;
        data["expiredDateTime"] = this.expiredDateTime ? this.expiredDateTime.toISOString() : <any>undefined;
        data["memberName"] = this.memberName;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IPlayerTicketDto {
    playerCode: string | undefined;
    gameCode: string | undefined;
    status: string | undefined;
    usedDate: moment.Moment | undefined;
    expiredDateTime: moment.Moment | undefined;
    memberName: string | undefined;
    createDate: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    id: number | undefined;
}

export class GetPlayerTicketForEditOutput implements IGetPlayerTicketForEditOutput {
    playerTicket!: CreateOrEditPlayerTicketDto | undefined;

    constructor(data?: IGetPlayerTicketForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.playerTicket = data["playerTicket"] ? CreateOrEditPlayerTicketDto.fromJS(data["playerTicket"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetPlayerTicketForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetPlayerTicketForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["playerTicket"] = this.playerTicket ? this.playerTicket.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetPlayerTicketForEditOutput {
    playerTicket: CreateOrEditPlayerTicketDto | undefined;
}

export class CreateOrEditPlayerTicketDto implements ICreateOrEditPlayerTicketDto {
    playerCode!: string | undefined;
    gameCode!: string | undefined;
    status!: string | undefined;
    usedDate!: moment.Moment | undefined;
    expiredDateTime!: moment.Moment | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditPlayerTicketDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.playerCode = data["playerCode"];
            this.gameCode = data["gameCode"];
            this.status = data["status"];
            this.usedDate = data["usedDate"] ? moment(data["usedDate"].toString()) : <any>undefined;
            this.expiredDateTime = data["expiredDateTime"] ? moment(data["expiredDateTime"].toString()) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditPlayerTicketDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditPlayerTicketDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["playerCode"] = this.playerCode;
        data["gameCode"] = this.gameCode;
        data["status"] = this.status;
        data["usedDate"] = this.usedDate ? this.usedDate.toISOString() : <any>undefined;
        data["expiredDateTime"] = this.expiredDateTime ? this.expiredDateTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditPlayerTicketDto {
    playerCode: string | undefined;
    gameCode: string | undefined;
    status: string | undefined;
    usedDate: moment.Moment | undefined;
    expiredDateTime: moment.Moment | undefined;
    id: number | undefined;
}

export class GetAllPlayerTicketsInput implements IGetAllPlayerTicketsInput {
    filter!: string | undefined;
    playerCodeFilter!: string | undefined;
    gameCodeFilter!: string | undefined;
    statusFilter!: string | undefined;
    maxUsedDateFilter!: moment.Moment | undefined;
    minUsedDateFilter!: moment.Moment | undefined;
    maxExpiredDateTimeFilter!: moment.Moment | undefined;
    minExpiredDateTimeFilter!: moment.Moment | undefined;
    sorting!: string | undefined;
    skipCount!: number | undefined;
    maxResultCount!: number | undefined;

    constructor(data?: IGetAllPlayerTicketsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.filter = data["filter"];
            this.playerCodeFilter = data["playerCodeFilter"];
            this.gameCodeFilter = data["gameCodeFilter"];
            this.statusFilter = data["statusFilter"];
            this.maxUsedDateFilter = data["maxUsedDateFilter"] ? moment(data["maxUsedDateFilter"].toString()) : <any>undefined;
            this.minUsedDateFilter = data["minUsedDateFilter"] ? moment(data["minUsedDateFilter"].toString()) : <any>undefined;
            this.maxExpiredDateTimeFilter = data["maxExpiredDateTimeFilter"] ? moment(data["maxExpiredDateTimeFilter"].toString()) : <any>undefined;
            this.minExpiredDateTimeFilter = data["minExpiredDateTimeFilter"] ? moment(data["minExpiredDateTimeFilter"].toString()) : <any>undefined;
            this.sorting = data["sorting"];
            this.skipCount = data["skipCount"];
            this.maxResultCount = data["maxResultCount"];
        }
    }

    static fromJS(data: any): GetAllPlayerTicketsInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllPlayerTicketsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        data["playerCodeFilter"] = this.playerCodeFilter;
        data["gameCodeFilter"] = this.gameCodeFilter;
        data["statusFilter"] = this.statusFilter;
        data["maxUsedDateFilter"] = this.maxUsedDateFilter ? this.maxUsedDateFilter.toISOString() : <any>undefined;
        data["minUsedDateFilter"] = this.minUsedDateFilter ? this.minUsedDateFilter.toISOString() : <any>undefined;
        data["maxExpiredDateTimeFilter"] = this.maxExpiredDateTimeFilter ? this.maxExpiredDateTimeFilter.toISOString() : <any>undefined;
        data["minExpiredDateTimeFilter"] = this.minExpiredDateTimeFilter ? this.minExpiredDateTimeFilter.toISOString() : <any>undefined;
        data["sorting"] = this.sorting;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data;
    }
}

export interface IGetAllPlayerTicketsInput {
    filter: string | undefined;
    playerCodeFilter: string | undefined;
    gameCodeFilter: string | undefined;
    statusFilter: string | undefined;
    maxUsedDateFilter: moment.Moment | undefined;
    minUsedDateFilter: moment.Moment | undefined;
    maxExpiredDateTimeFilter: moment.Moment | undefined;
    minExpiredDateTimeFilter: moment.Moment | undefined;
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;
}

export class GetTicketCountForView implements IGetTicketCountForView {
    newTicket!: number | undefined;
    usedTicket!: number | undefined;
    expiredTicket!: number | undefined;

    constructor(data?: IGetTicketCountForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.newTicket = data["newTicket"];
            this.usedTicket = data["usedTicket"];
            this.expiredTicket = data["expiredTicket"];
        }
    }

    static fromJS(data: any): GetTicketCountForView {
        data = typeof data === 'object' ? data : {};
        let result = new GetTicketCountForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newTicket"] = this.newTicket;
        data["usedTicket"] = this.usedTicket;
        data["expiredTicket"] = this.expiredTicket;
        return data;
    }
}

export interface IGetTicketCountForView {
    newTicket: number | undefined;
    usedTicket: number | undefined;
    expiredTicket: number | undefined;
}

export class GetAllPlayerTicketsForExcelInput implements IGetAllPlayerTicketsForExcelInput {
    filter!: string | undefined;
    playerCodeFilter!: string | undefined;
    gameCodeFilter!: string | undefined;
    statusFilter!: string | undefined;
    maxUsedDateFilter!: moment.Moment | undefined;
    minUsedDateFilter!: moment.Moment | undefined;
    maxExpiredDateTimeFilter!: moment.Moment | undefined;
    minExpiredDateTimeFilter!: moment.Moment | undefined;

    constructor(data?: IGetAllPlayerTicketsForExcelInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.filter = data["filter"];
            this.playerCodeFilter = data["playerCodeFilter"];
            this.gameCodeFilter = data["gameCodeFilter"];
            this.statusFilter = data["statusFilter"];
            this.maxUsedDateFilter = data["maxUsedDateFilter"] ? moment(data["maxUsedDateFilter"].toString()) : <any>undefined;
            this.minUsedDateFilter = data["minUsedDateFilter"] ? moment(data["minUsedDateFilter"].toString()) : <any>undefined;
            this.maxExpiredDateTimeFilter = data["maxExpiredDateTimeFilter"] ? moment(data["maxExpiredDateTimeFilter"].toString()) : <any>undefined;
            this.minExpiredDateTimeFilter = data["minExpiredDateTimeFilter"] ? moment(data["minExpiredDateTimeFilter"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetAllPlayerTicketsForExcelInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllPlayerTicketsForExcelInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        data["playerCodeFilter"] = this.playerCodeFilter;
        data["gameCodeFilter"] = this.gameCodeFilter;
        data["statusFilter"] = this.statusFilter;
        data["maxUsedDateFilter"] = this.maxUsedDateFilter ? this.maxUsedDateFilter.toISOString() : <any>undefined;
        data["minUsedDateFilter"] = this.minUsedDateFilter ? this.minUsedDateFilter.toISOString() : <any>undefined;
        data["maxExpiredDateTimeFilter"] = this.maxExpiredDateTimeFilter ? this.maxExpiredDateTimeFilter.toISOString() : <any>undefined;
        data["minExpiredDateTimeFilter"] = this.minExpiredDateTimeFilter ? this.minExpiredDateTimeFilter.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGetAllPlayerTicketsForExcelInput {
    filter: string | undefined;
    playerCodeFilter: string | undefined;
    gameCodeFilter: string | undefined;
    statusFilter: string | undefined;
    maxUsedDateFilter: moment.Moment | undefined;
    minUsedDateFilter: moment.Moment | undefined;
    maxExpiredDateTimeFilter: moment.Moment | undefined;
    minExpiredDateTimeFilter: moment.Moment | undefined;
}

export class PointOverviewReportDto implements IPointOverviewReportDto {
    labelColX!: string | undefined;
    coinGrant!: number | undefined;
    coinRedeem!: number | undefined;
    expiredCoin!: number | undefined;

    constructor(data?: IPointOverviewReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.labelColX = data["labelColX"];
            this.coinGrant = data["coinGrant"];
            this.coinRedeem = data["coinRedeem"];
            this.expiredCoin = data["expiredCoin"];
        }
    }

    static fromJS(data: any): PointOverviewReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new PointOverviewReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["labelColX"] = this.labelColX;
        data["coinGrant"] = this.coinGrant;
        data["coinRedeem"] = this.coinRedeem;
        data["expiredCoin"] = this.expiredCoin;
        return data;
    }
}

export interface IPointOverviewReportDto {
    labelColX: string | undefined;
    coinGrant: number | undefined;
    coinRedeem: number | undefined;
    expiredCoin: number | undefined;
}

export class CreateOrEditPosmDto implements ICreateOrEditPosmDto {
    memberCode!: string | undefined;
    posmResultID!: number | undefined;
    imagePath!: string | undefined;
    detailCode!: string | undefined;
    description!: string | undefined;
    quantity!: number | undefined;
    posmType!: string | undefined;
    visitPlanResultId!: number | undefined;
    creatorName!: string | undefined;
    lastModifierName!: string | undefined;
    brand!: string | undefined;
    productType!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditPosmDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberCode = data["memberCode"];
            this.posmResultID = data["posmResultID"];
            this.imagePath = data["imagePath"];
            this.detailCode = data["detailCode"];
            this.description = data["description"];
            this.quantity = data["quantity"];
            this.posmType = data["posmType"];
            this.visitPlanResultId = data["visitPlanResultId"];
            this.creatorName = data["creatorName"];
            this.lastModifierName = data["lastModifierName"];
            this.brand = data["brand"];
            this.productType = data["productType"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditPosmDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditPosmDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberCode"] = this.memberCode;
        data["posmResultID"] = this.posmResultID;
        data["imagePath"] = this.imagePath;
        data["detailCode"] = this.detailCode;
        data["description"] = this.description;
        data["quantity"] = this.quantity;
        data["posmType"] = this.posmType;
        data["visitPlanResultId"] = this.visitPlanResultId;
        data["creatorName"] = this.creatorName;
        data["lastModifierName"] = this.lastModifierName;
        data["brand"] = this.brand;
        data["productType"] = this.productType;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditPosmDto {
    memberCode: string | undefined;
    posmResultID: number | undefined;
    imagePath: string | undefined;
    detailCode: string | undefined;
    description: string | undefined;
    quantity: number | undefined;
    posmType: string | undefined;
    visitPlanResultId: number | undefined;
    creatorName: string | undefined;
    lastModifierName: string | undefined;
    brand: string | undefined;
    productType: string | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfGetListPosmDto implements IPagedResultDtoOfGetListPosmDto {
    totalCount!: number | undefined;
    items!: GetListPosmDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetListPosmDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetListPosmDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetListPosmDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetListPosmDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetListPosmDto {
    totalCount: number | undefined;
    items: GetListPosmDto[] | undefined;
}

export class GetListPosmDto implements IGetListPosmDto {
    memberCode!: string | undefined;
    partnerName!: string | undefined;
    creationTime!: moment.Moment | undefined;
    imagePath!: string | undefined;
    detailCode!: string | undefined;
    description!: string | undefined;
    quantity!: number | undefined;
    posmType!: string | undefined;
    productType!: string | undefined;
    productTypeName!: string | undefined;
    brandName!: string | undefined;
    visitPlanResultId!: number | undefined;
    creatorUserId!: number | undefined;
    creatorName!: string | undefined;
    lastModifierName!: string | undefined;
    regionCode!: string | undefined;
    regionName!: string | undefined;
    statusCheckIn!: boolean | undefined;
    longitude!: string | undefined;
    lattitude!: string | undefined;
    outletID!: number | undefined;
    outletCode!: string | undefined;
    outletName!: string | undefined;
    id!: number | undefined;

    constructor(data?: IGetListPosmDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberCode = data["memberCode"];
            this.partnerName = data["partnerName"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.imagePath = data["imagePath"];
            this.detailCode = data["detailCode"];
            this.description = data["description"];
            this.quantity = data["quantity"];
            this.posmType = data["posmType"];
            this.productType = data["productType"];
            this.productTypeName = data["productTypeName"];
            this.brandName = data["brandName"];
            this.visitPlanResultId = data["visitPlanResultId"];
            this.creatorUserId = data["creatorUserId"];
            this.creatorName = data["creatorName"];
            this.lastModifierName = data["lastModifierName"];
            this.regionCode = data["regionCode"];
            this.regionName = data["regionName"];
            this.statusCheckIn = data["statusCheckIn"];
            this.longitude = data["longitude"];
            this.lattitude = data["lattitude"];
            this.outletID = data["outletID"];
            this.outletCode = data["outletCode"];
            this.outletName = data["outletName"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): GetListPosmDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetListPosmDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberCode"] = this.memberCode;
        data["partnerName"] = this.partnerName;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["imagePath"] = this.imagePath;
        data["detailCode"] = this.detailCode;
        data["description"] = this.description;
        data["quantity"] = this.quantity;
        data["posmType"] = this.posmType;
        data["productType"] = this.productType;
        data["productTypeName"] = this.productTypeName;
        data["brandName"] = this.brandName;
        data["visitPlanResultId"] = this.visitPlanResultId;
        data["creatorUserId"] = this.creatorUserId;
        data["creatorName"] = this.creatorName;
        data["lastModifierName"] = this.lastModifierName;
        data["regionCode"] = this.regionCode;
        data["regionName"] = this.regionName;
        data["statusCheckIn"] = this.statusCheckIn;
        data["longitude"] = this.longitude;
        data["lattitude"] = this.lattitude;
        data["outletID"] = this.outletID;
        data["outletCode"] = this.outletCode;
        data["outletName"] = this.outletName;
        data["id"] = this.id;
        return data;
    }
}

export interface IGetListPosmDto {
    memberCode: string | undefined;
    partnerName: string | undefined;
    creationTime: moment.Moment | undefined;
    imagePath: string | undefined;
    detailCode: string | undefined;
    description: string | undefined;
    quantity: number | undefined;
    posmType: string | undefined;
    productType: string | undefined;
    productTypeName: string | undefined;
    brandName: string | undefined;
    visitPlanResultId: number | undefined;
    creatorUserId: number | undefined;
    creatorName: string | undefined;
    lastModifierName: string | undefined;
    regionCode: string | undefined;
    regionName: string | undefined;
    statusCheckIn: boolean | undefined;
    longitude: string | undefined;
    lattitude: string | undefined;
    outletID: number | undefined;
    outletCode: string | undefined;
    outletName: string | undefined;
    id: number | undefined;
}

export class GetPosmInput implements IGetPosmInput {
    memberCode!: string | undefined;
    posmResultID!: number | undefined;
    creatorUserId!: number | undefined;
    salesmanCode!: string | undefined;
    fromDate!: moment.Moment | undefined;
    toDate!: moment.Moment | undefined;
    sorting!: string | undefined;
    skipCount!: number | undefined;
    maxResultCount!: number | undefined;

    constructor(data?: IGetPosmInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberCode = data["memberCode"];
            this.posmResultID = data["posmResultID"];
            this.creatorUserId = data["creatorUserId"];
            this.salesmanCode = data["salesmanCode"];
            this.fromDate = data["fromDate"] ? moment(data["fromDate"].toString()) : <any>undefined;
            this.toDate = data["toDate"] ? moment(data["toDate"].toString()) : <any>undefined;
            this.sorting = data["sorting"];
            this.skipCount = data["skipCount"];
            this.maxResultCount = data["maxResultCount"];
        }
    }

    static fromJS(data: any): GetPosmInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetPosmInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberCode"] = this.memberCode;
        data["posmResultID"] = this.posmResultID;
        data["creatorUserId"] = this.creatorUserId;
        data["salesmanCode"] = this.salesmanCode;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data["sorting"] = this.sorting;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data;
    }
}

export interface IGetPosmInput {
    memberCode: string | undefined;
    posmResultID: number | undefined;
    creatorUserId: number | undefined;
    salesmanCode: string | undefined;
    fromDate: moment.Moment | undefined;
    toDate: moment.Moment | undefined;
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;
}

export class PagedResultDtoOfGetProductCategoryForView implements IPagedResultDtoOfGetProductCategoryForView {
    totalCount!: number | undefined;
    items!: GetProductCategoryForView[] | undefined;

    constructor(data?: IPagedResultDtoOfGetProductCategoryForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetProductCategoryForView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetProductCategoryForView {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetProductCategoryForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetProductCategoryForView {
    totalCount: number | undefined;
    items: GetProductCategoryForView[] | undefined;
}

export class GetProductCategoryForView implements IGetProductCategoryForView {
    productCategory!: ProductCategoryDto | undefined;

    constructor(data?: IGetProductCategoryForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.productCategory = data["productCategory"] ? ProductCategoryDto.fromJS(data["productCategory"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetProductCategoryForView {
        data = typeof data === 'object' ? data : {};
        let result = new GetProductCategoryForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productCategory"] = this.productCategory ? this.productCategory.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetProductCategoryForView {
    productCategory: ProductCategoryDto | undefined;
}

export class ProductCategoryDto implements IProductCategoryDto {
    code!: string | undefined;
    name!: string | undefined;
    description!: string | undefined;
    effectiveFrom!: moment.Moment | undefined;
    effectiveTo!: moment.Moment | undefined;
    isActive!: boolean | undefined;
    targetAudience!: SettingParamDto | undefined;
    coinValue!: number | undefined;
    pointValue!: number | undefined;
    campaign!: string | undefined;
    details!: ProductCategoryDetailDto[] | undefined;
    targetAudienceCode!: string | undefined;
    id!: number | undefined;

    constructor(data?: IProductCategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.name = data["name"];
            this.description = data["description"];
            this.effectiveFrom = data["effectiveFrom"] ? moment(data["effectiveFrom"].toString()) : <any>undefined;
            this.effectiveTo = data["effectiveTo"] ? moment(data["effectiveTo"].toString()) : <any>undefined;
            this.isActive = data["isActive"];
            this.targetAudience = data["targetAudience"] ? SettingParamDto.fromJS(data["targetAudience"]) : <any>undefined;
            this.coinValue = data["coinValue"];
            this.pointValue = data["pointValue"];
            this.campaign = data["campaign"];
            if (data["details"] && data["details"].constructor === Array) {
                this.details = [];
                for (let item of data["details"])
                    this.details.push(ProductCategoryDetailDto.fromJS(item));
            }
            this.targetAudienceCode = data["targetAudienceCode"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ProductCategoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductCategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["description"] = this.description;
        data["effectiveFrom"] = this.effectiveFrom ? this.effectiveFrom.toISOString() : <any>undefined;
        data["effectiveTo"] = this.effectiveTo ? this.effectiveTo.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        data["targetAudience"] = this.targetAudience ? this.targetAudience.toJSON() : <any>undefined;
        data["coinValue"] = this.coinValue;
        data["pointValue"] = this.pointValue;
        data["campaign"] = this.campaign;
        if (this.details && this.details.constructor === Array) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item.toJSON());
        }
        data["targetAudienceCode"] = this.targetAudienceCode;
        data["id"] = this.id;
        return data;
    }
}

export interface IProductCategoryDto {
    code: string | undefined;
    name: string | undefined;
    description: string | undefined;
    effectiveFrom: moment.Moment | undefined;
    effectiveTo: moment.Moment | undefined;
    isActive: boolean | undefined;
    targetAudience: SettingParamDto | undefined;
    coinValue: number | undefined;
    pointValue: number | undefined;
    campaign: string | undefined;
    details: ProductCategoryDetailDto[] | undefined;
    targetAudienceCode: string | undefined;
    id: number | undefined;
}

export class ProductCategoryDetailDto implements IProductCategoryDetailDto {
    type!: ProductCategoryDetailDtoType | undefined;
    fullValue!: string | undefined;
    value!: string | undefined;
    fullValueName!: string | undefined;
    id!: number | undefined;

    constructor(data?: IProductCategoryDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.type = data["type"];
            this.fullValue = data["fullValue"];
            this.value = data["value"];
            this.fullValueName = data["fullValueName"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ProductCategoryDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductCategoryDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["fullValue"] = this.fullValue;
        data["value"] = this.value;
        data["fullValueName"] = this.fullValueName;
        data["id"] = this.id;
        return data;
    }
}

export interface IProductCategoryDetailDto {
    type: ProductCategoryDetailDtoType | undefined;
    fullValue: string | undefined;
    value: string | undefined;
    fullValueName: string | undefined;
    id: number | undefined;
}

export class GetProductCategoryForEditOutput implements IGetProductCategoryForEditOutput {
    productCategory!: CreateOrEditProductCategoryDto | undefined;

    constructor(data?: IGetProductCategoryForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.productCategory = data["productCategory"] ? CreateOrEditProductCategoryDto.fromJS(data["productCategory"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetProductCategoryForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetProductCategoryForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productCategory"] = this.productCategory ? this.productCategory.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetProductCategoryForEditOutput {
    productCategory: CreateOrEditProductCategoryDto | undefined;
}

export class ValidationResult implements IValidationResult {
    memberNames!: string[] | undefined;
    errorMessage!: string | undefined;

    constructor(data?: IValidationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["memberNames"] && data["memberNames"].constructor === Array) {
                this.memberNames = [];
                for (let item of data["memberNames"])
                    this.memberNames.push(item);
            }
            this.errorMessage = data["errorMessage"];
        }
    }

    static fromJS(data: any): ValidationResult {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.memberNames && this.memberNames.constructor === Array) {
            data["memberNames"] = [];
            for (let item of this.memberNames)
                data["memberNames"].push(item);
        }
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface IValidationResult {
    memberNames: string[] | undefined;
    errorMessage: string | undefined;
}

export class ListResultDtoOfProductCategoryDto implements IListResultDtoOfProductCategoryDto {
    items!: ProductCategoryDto[] | undefined;

    constructor(data?: IListResultDtoOfProductCategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(ProductCategoryDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfProductCategoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfProductCategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListResultDtoOfProductCategoryDto {
    items: ProductCategoryDto[] | undefined;
}

export class PagedResultDtoOfGetProductForView implements IPagedResultDtoOfGetProductForView {
    totalCount!: number | undefined;
    items!: GetProductForView[] | undefined;

    constructor(data?: IPagedResultDtoOfGetProductForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetProductForView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetProductForView {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetProductForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetProductForView {
    totalCount: number | undefined;
    items: GetProductForView[] | undefined;
}

export class GetProductForView implements IGetProductForView {
    product!: ProductDto | undefined;

    constructor(data?: IGetProductForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.product = data["product"] ? ProductDto.fromJS(data["product"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetProductForView {
        data = typeof data === 'object' ? data : {};
        let result = new GetProductForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetProductForView {
    product: ProductDto | undefined;
}

export class ProductDto implements IProductDto {
    code!: string | undefined;
    name!: string | undefined;
    description!: string | undefined;
    deptCode!: string | undefined;
    classCode!: string | undefined;
    fullDeptCode!: string | undefined;
    fullClassCode!: string | undefined;
    isActive!: boolean | undefined;
    id!: number | undefined;

    constructor(data?: IProductDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.name = data["name"];
            this.description = data["description"];
            this.deptCode = data["deptCode"];
            this.classCode = data["classCode"];
            this.fullDeptCode = data["fullDeptCode"];
            this.fullClassCode = data["fullClassCode"];
            this.isActive = data["isActive"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ProductDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["description"] = this.description;
        data["deptCode"] = this.deptCode;
        data["classCode"] = this.classCode;
        data["fullDeptCode"] = this.fullDeptCode;
        data["fullClassCode"] = this.fullClassCode;
        data["isActive"] = this.isActive;
        data["id"] = this.id;
        return data;
    }
}

export interface IProductDto {
    code: string | undefined;
    name: string | undefined;
    description: string | undefined;
    deptCode: string | undefined;
    classCode: string | undefined;
    fullDeptCode: string | undefined;
    fullClassCode: string | undefined;
    isActive: boolean | undefined;
    id: number | undefined;
}

export class GetProductForEditOutput implements IGetProductForEditOutput {
    product!: CreateOrEditProductDto | undefined;

    constructor(data?: IGetProductForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.product = data["product"] ? CreateOrEditProductDto.fromJS(data["product"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetProductForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetProductForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetProductForEditOutput {
    product: CreateOrEditProductDto | undefined;
}

export class CreateOrEditProductDto implements ICreateOrEditProductDto {
    code!: string;
    name!: string | undefined;
    description!: string | undefined;
    deptCode!: string | undefined;
    classCode!: string | undefined;
    fullDeptCode!: string | undefined;
    fullClassCode!: string | undefined;
    isActive!: boolean | undefined;
    isDeleted!: boolean | undefined;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: moment.Moment | undefined;
    creatorUserId!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditProductDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.name = data["name"];
            this.description = data["description"];
            this.deptCode = data["deptCode"];
            this.classCode = data["classCode"];
            this.fullDeptCode = data["fullDeptCode"];
            this.fullClassCode = data["fullClassCode"];
            this.isActive = data["isActive"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditProductDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["description"] = this.description;
        data["deptCode"] = this.deptCode;
        data["classCode"] = this.classCode;
        data["fullDeptCode"] = this.fullDeptCode;
        data["fullClassCode"] = this.fullClassCode;
        data["isActive"] = this.isActive;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditProductDto {
    code: string;
    name: string | undefined;
    description: string | undefined;
    deptCode: string | undefined;
    classCode: string | undefined;
    fullDeptCode: string | undefined;
    fullClassCode: string | undefined;
    isActive: boolean | undefined;
    isDeleted: boolean | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class ProductExtDto implements IProductExtDto {
    code!: string | undefined;
    name!: string | undefined;
    fullDeptCode!: string | undefined;

    constructor(data?: IProductExtDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.name = data["name"];
            this.fullDeptCode = data["fullDeptCode"];
        }
    }

    static fromJS(data: any): ProductExtDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductExtDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["fullDeptCode"] = this.fullDeptCode;
        return data;
    }
}

export interface IProductExtDto {
    code: string | undefined;
    name: string | undefined;
    fullDeptCode: string | undefined;
}

export class PagedResultDtoOfGetProductSettingForView implements IPagedResultDtoOfGetProductSettingForView {
    totalCount!: number | undefined;
    items!: GetProductSettingForView[] | undefined;

    constructor(data?: IPagedResultDtoOfGetProductSettingForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetProductSettingForView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetProductSettingForView {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetProductSettingForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetProductSettingForView {
    totalCount: number | undefined;
    items: GetProductSettingForView[] | undefined;
}

export class GetProductSettingForView implements IGetProductSettingForView {
    productSetting!: ProductSettingDto | undefined;

    constructor(data?: IGetProductSettingForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.productSetting = data["productSetting"] ? ProductSettingDto.fromJS(data["productSetting"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetProductSettingForView {
        data = typeof data === 'object' ? data : {};
        let result = new GetProductSettingForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productSetting"] = this.productSetting ? this.productSetting.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetProductSettingForView {
    productSetting: ProductSettingDto | undefined;
}

export class ProductSettingDto implements IProductSettingDto {
    code!: string | undefined;
    name!: string | undefined;
    description!: string | undefined;
    effectiveFrom!: moment.Moment | undefined;
    effectiveTo!: moment.Moment | undefined;
    cron!: string | undefined;
    isActive!: boolean | undefined;
    targetAudience!: SettingParamDto | undefined;
    timeZone!: string | undefined;
    campaign!: string | undefined;
    details!: ProductDetailSettingDto[] | undefined;
    targetAudienceCode!: string | undefined;
    startTime!: string | undefined;
    endTime!: string | undefined;
    id!: number | undefined;

    constructor(data?: IProductSettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.name = data["name"];
            this.description = data["description"];
            this.effectiveFrom = data["effectiveFrom"] ? moment(data["effectiveFrom"].toString()) : <any>undefined;
            this.effectiveTo = data["effectiveTo"] ? moment(data["effectiveTo"].toString()) : <any>undefined;
            this.cron = data["cron"];
            this.isActive = data["isActive"];
            this.targetAudience = data["targetAudience"] ? SettingParamDto.fromJS(data["targetAudience"]) : <any>undefined;
            this.timeZone = data["timeZone"];
            this.campaign = data["campaign"];
            if (data["details"] && data["details"].constructor === Array) {
                this.details = [];
                for (let item of data["details"])
                    this.details.push(ProductDetailSettingDto.fromJS(item));
            }
            this.targetAudienceCode = data["targetAudienceCode"];
            this.startTime = data["startTime"];
            this.endTime = data["endTime"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ProductSettingDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductSettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["description"] = this.description;
        data["effectiveFrom"] = this.effectiveFrom ? this.effectiveFrom.toISOString() : <any>undefined;
        data["effectiveTo"] = this.effectiveTo ? this.effectiveTo.toISOString() : <any>undefined;
        data["cron"] = this.cron;
        data["isActive"] = this.isActive;
        data["targetAudience"] = this.targetAudience ? this.targetAudience.toJSON() : <any>undefined;
        data["timeZone"] = this.timeZone;
        data["campaign"] = this.campaign;
        if (this.details && this.details.constructor === Array) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item.toJSON());
        }
        data["targetAudienceCode"] = this.targetAudienceCode;
        data["startTime"] = this.startTime;
        data["endTime"] = this.endTime;
        data["id"] = this.id;
        return data;
    }
}

export interface IProductSettingDto {
    code: string | undefined;
    name: string | undefined;
    description: string | undefined;
    effectiveFrom: moment.Moment | undefined;
    effectiveTo: moment.Moment | undefined;
    cron: string | undefined;
    isActive: boolean | undefined;
    targetAudience: SettingParamDto | undefined;
    timeZone: string | undefined;
    campaign: string | undefined;
    details: ProductDetailSettingDto[] | undefined;
    targetAudienceCode: string | undefined;
    startTime: string | undefined;
    endTime: string | undefined;
    id: number | undefined;
}

export class ProductDetailSettingDto implements IProductDetailSettingDto {
    pointValue!: number | undefined;
    coinValue!: number | undefined;
    fromQuantity!: number | undefined;
    toQuantity!: number | undefined;
    maxSet!: number | undefined;
    value!: number | undefined;
    productId!: number | undefined;
    product!: ProductDto | undefined;
    settingCode!: string | undefined;
    detailType!: string | undefined;
    departmentCode!: string | undefined;
    detailRanks!: ProductDetailRankSettingDto[] | undefined;

    constructor(data?: IProductDetailSettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.pointValue = data["pointValue"];
            this.coinValue = data["coinValue"];
            this.fromQuantity = data["fromQuantity"];
            this.toQuantity = data["toQuantity"];
            this.maxSet = data["maxSet"];
            this.value = data["value"];
            this.productId = data["productId"];
            this.product = data["product"] ? ProductDto.fromJS(data["product"]) : <any>undefined;
            this.settingCode = data["settingCode"];
            this.detailType = data["detailType"];
            this.departmentCode = data["departmentCode"];
            if (data["detailRanks"] && data["detailRanks"].constructor === Array) {
                this.detailRanks = [];
                for (let item of data["detailRanks"])
                    this.detailRanks.push(ProductDetailRankSettingDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProductDetailSettingDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductDetailSettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pointValue"] = this.pointValue;
        data["coinValue"] = this.coinValue;
        data["fromQuantity"] = this.fromQuantity;
        data["toQuantity"] = this.toQuantity;
        data["maxSet"] = this.maxSet;
        data["value"] = this.value;
        data["productId"] = this.productId;
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["settingCode"] = this.settingCode;
        data["detailType"] = this.detailType;
        data["departmentCode"] = this.departmentCode;
        if (this.detailRanks && this.detailRanks.constructor === Array) {
            data["detailRanks"] = [];
            for (let item of this.detailRanks)
                data["detailRanks"].push(item.toJSON());
        }
        return data;
    }
}

export interface IProductDetailSettingDto {
    pointValue: number | undefined;
    coinValue: number | undefined;
    fromQuantity: number | undefined;
    toQuantity: number | undefined;
    maxSet: number | undefined;
    value: number | undefined;
    productId: number | undefined;
    product: ProductDto | undefined;
    settingCode: string | undefined;
    detailType: string | undefined;
    departmentCode: string | undefined;
    detailRanks: ProductDetailRankSettingDto[] | undefined;
}

export class ProductDetailRankSettingDto implements IProductDetailRankSettingDto {
    rankId!: number | undefined;
    pointValue!: number | undefined;
    coinValue!: number | undefined;
    fromQuantity!: number | undefined;
    toQuantity!: number | undefined;

    constructor(data?: IProductDetailRankSettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.rankId = data["rankId"];
            this.pointValue = data["pointValue"];
            this.coinValue = data["coinValue"];
            this.fromQuantity = data["fromQuantity"];
            this.toQuantity = data["toQuantity"];
        }
    }

    static fromJS(data: any): ProductDetailRankSettingDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductDetailRankSettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rankId"] = this.rankId;
        data["pointValue"] = this.pointValue;
        data["coinValue"] = this.coinValue;
        data["fromQuantity"] = this.fromQuantity;
        data["toQuantity"] = this.toQuantity;
        return data;
    }
}

export interface IProductDetailRankSettingDto {
    rankId: number | undefined;
    pointValue: number | undefined;
    coinValue: number | undefined;
    fromQuantity: number | undefined;
    toQuantity: number | undefined;
}

export class GetAllProductSettingsForCampaignInput implements IGetAllProductSettingsForCampaignInput {
    campaignId!: number | undefined;
    isActiveFilter!: number | undefined;
    sorting!: string | undefined;
    skipCount!: number | undefined;
    maxResultCount!: number | undefined;

    constructor(data?: IGetAllProductSettingsForCampaignInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.campaignId = data["campaignId"];
            this.isActiveFilter = data["isActiveFilter"];
            this.sorting = data["sorting"];
            this.skipCount = data["skipCount"];
            this.maxResultCount = data["maxResultCount"];
        }
    }

    static fromJS(data: any): GetAllProductSettingsForCampaignInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllProductSettingsForCampaignInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["campaignId"] = this.campaignId;
        data["isActiveFilter"] = this.isActiveFilter;
        data["sorting"] = this.sorting;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data;
    }
}

export interface IGetAllProductSettingsForCampaignInput {
    campaignId: number | undefined;
    isActiveFilter: number | undefined;
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;
}

export class GetProductSettingForEditOutput implements IGetProductSettingForEditOutput {
    productSetting!: CreateOrEditProductSettingDto | undefined;

    constructor(data?: IGetProductSettingForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.productSetting = data["productSetting"] ? CreateOrEditProductSettingDto.fromJS(data["productSetting"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetProductSettingForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetProductSettingForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productSetting"] = this.productSetting ? this.productSetting.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetProductSettingForEditOutput {
    productSetting: CreateOrEditProductSettingDto | undefined;
}

export class PagedResultDtoOfGetProductUOMMappingForViewDto implements IPagedResultDtoOfGetProductUOMMappingForViewDto {
    totalCount!: number | undefined;
    items!: GetProductUOMMappingForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetProductUOMMappingForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetProductUOMMappingForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetProductUOMMappingForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetProductUOMMappingForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetProductUOMMappingForViewDto {
    totalCount: number | undefined;
    items: GetProductUOMMappingForViewDto[] | undefined;
}

export class GetProductUOMMappingForViewDto implements IGetProductUOMMappingForViewDto {
    productUOMMapping!: ProductUOMMappingDto | undefined;

    constructor(data?: IGetProductUOMMappingForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.productUOMMapping = data["productUOMMapping"] ? ProductUOMMappingDto.fromJS(data["productUOMMapping"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetProductUOMMappingForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetProductUOMMappingForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productUOMMapping"] = this.productUOMMapping ? this.productUOMMapping.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetProductUOMMappingForViewDto {
    productUOMMapping: ProductUOMMappingDto | undefined;
}

export class ProductUOMMappingDto implements IProductUOMMappingDto {
    prD_CD!: string | undefined;
    uoM_CD!: string | undefined;
    baseuoM_CD!: string | undefined;
    uoM_LEVEL!: number | undefined;
    conV_FACTOR!: number | undefined;
    conV_FACTOR_SML!: number | undefined;
    pacK_LENGTH!: number | undefined;
    pacK_WIDTH!: number | undefined;
    pacK_HEIGHT!: number | undefined;
    dimensioN_UNIT!: string | undefined;
    neT_WEIGHT!: number | undefined;
    grosS_WEIGHT!: number | undefined;
    weighT_UNIT!: string | undefined;
    id!: number | undefined;

    constructor(data?: IProductUOMMappingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.prD_CD = data["prD_CD"];
            this.uoM_CD = data["uoM_CD"];
            this.baseuoM_CD = data["baseuoM_CD"];
            this.uoM_LEVEL = data["uoM_LEVEL"];
            this.conV_FACTOR = data["conV_FACTOR"];
            this.conV_FACTOR_SML = data["conV_FACTOR_SML"];
            this.pacK_LENGTH = data["pacK_LENGTH"];
            this.pacK_WIDTH = data["pacK_WIDTH"];
            this.pacK_HEIGHT = data["pacK_HEIGHT"];
            this.dimensioN_UNIT = data["dimensioN_UNIT"];
            this.neT_WEIGHT = data["neT_WEIGHT"];
            this.grosS_WEIGHT = data["grosS_WEIGHT"];
            this.weighT_UNIT = data["weighT_UNIT"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ProductUOMMappingDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductUOMMappingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prD_CD"] = this.prD_CD;
        data["uoM_CD"] = this.uoM_CD;
        data["baseuoM_CD"] = this.baseuoM_CD;
        data["uoM_LEVEL"] = this.uoM_LEVEL;
        data["conV_FACTOR"] = this.conV_FACTOR;
        data["conV_FACTOR_SML"] = this.conV_FACTOR_SML;
        data["pacK_LENGTH"] = this.pacK_LENGTH;
        data["pacK_WIDTH"] = this.pacK_WIDTH;
        data["pacK_HEIGHT"] = this.pacK_HEIGHT;
        data["dimensioN_UNIT"] = this.dimensioN_UNIT;
        data["neT_WEIGHT"] = this.neT_WEIGHT;
        data["grosS_WEIGHT"] = this.grosS_WEIGHT;
        data["weighT_UNIT"] = this.weighT_UNIT;
        data["id"] = this.id;
        return data;
    }
}

export interface IProductUOMMappingDto {
    prD_CD: string | undefined;
    uoM_CD: string | undefined;
    baseuoM_CD: string | undefined;
    uoM_LEVEL: number | undefined;
    conV_FACTOR: number | undefined;
    conV_FACTOR_SML: number | undefined;
    pacK_LENGTH: number | undefined;
    pacK_WIDTH: number | undefined;
    pacK_HEIGHT: number | undefined;
    dimensioN_UNIT: string | undefined;
    neT_WEIGHT: number | undefined;
    grosS_WEIGHT: number | undefined;
    weighT_UNIT: string | undefined;
    id: number | undefined;
}

export class GetProductUOMMappingForEditOutput implements IGetProductUOMMappingForEditOutput {
    productUOMMapping!: CreateOrEditProductUOMMappingDto | undefined;

    constructor(data?: IGetProductUOMMappingForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.productUOMMapping = data["productUOMMapping"] ? CreateOrEditProductUOMMappingDto.fromJS(data["productUOMMapping"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetProductUOMMappingForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetProductUOMMappingForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productUOMMapping"] = this.productUOMMapping ? this.productUOMMapping.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetProductUOMMappingForEditOutput {
    productUOMMapping: CreateOrEditProductUOMMappingDto | undefined;
}

export class CreateOrEditProductUOMMappingDto implements ICreateOrEditProductUOMMappingDto {
    prD_CD!: string | undefined;
    uoM_CD!: string | undefined;
    baseuoM_CD!: string | undefined;
    uoM_LEVEL!: number | undefined;
    conV_FACTOR!: number | undefined;
    conV_FACTOR_SML!: number | undefined;
    pacK_LENGTH!: number | undefined;
    pacK_WIDTH!: number | undefined;
    pacK_HEIGHT!: number | undefined;
    dimensioN_UNIT!: string | undefined;
    neT_WEIGHT!: number | undefined;
    grosS_WEIGHT!: number | undefined;
    weighT_UNIT!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditProductUOMMappingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.prD_CD = data["prD_CD"];
            this.uoM_CD = data["uoM_CD"];
            this.baseuoM_CD = data["baseuoM_CD"];
            this.uoM_LEVEL = data["uoM_LEVEL"];
            this.conV_FACTOR = data["conV_FACTOR"];
            this.conV_FACTOR_SML = data["conV_FACTOR_SML"];
            this.pacK_LENGTH = data["pacK_LENGTH"];
            this.pacK_WIDTH = data["pacK_WIDTH"];
            this.pacK_HEIGHT = data["pacK_HEIGHT"];
            this.dimensioN_UNIT = data["dimensioN_UNIT"];
            this.neT_WEIGHT = data["neT_WEIGHT"];
            this.grosS_WEIGHT = data["grosS_WEIGHT"];
            this.weighT_UNIT = data["weighT_UNIT"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditProductUOMMappingDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditProductUOMMappingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prD_CD"] = this.prD_CD;
        data["uoM_CD"] = this.uoM_CD;
        data["baseuoM_CD"] = this.baseuoM_CD;
        data["uoM_LEVEL"] = this.uoM_LEVEL;
        data["conV_FACTOR"] = this.conV_FACTOR;
        data["conV_FACTOR_SML"] = this.conV_FACTOR_SML;
        data["pacK_LENGTH"] = this.pacK_LENGTH;
        data["pacK_WIDTH"] = this.pacK_WIDTH;
        data["pacK_HEIGHT"] = this.pacK_HEIGHT;
        data["dimensioN_UNIT"] = this.dimensioN_UNIT;
        data["neT_WEIGHT"] = this.neT_WEIGHT;
        data["grosS_WEIGHT"] = this.grosS_WEIGHT;
        data["weighT_UNIT"] = this.weighT_UNIT;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditProductUOMMappingDto {
    prD_CD: string | undefined;
    uoM_CD: string | undefined;
    baseuoM_CD: string | undefined;
    uoM_LEVEL: number | undefined;
    conV_FACTOR: number | undefined;
    conV_FACTOR_SML: number | undefined;
    pacK_LENGTH: number | undefined;
    pacK_WIDTH: number | undefined;
    pacK_HEIGHT: number | undefined;
    dimensioN_UNIT: string | undefined;
    neT_WEIGHT: number | undefined;
    grosS_WEIGHT: number | undefined;
    weighT_UNIT: string | undefined;
    id: number | undefined;
}

export class CurrentUserProfileEditDto implements ICurrentUserProfileEditDto {
    name!: string;
    surname!: string;
    userName!: string;
    emailAddress!: string;
    phoneNumber!: string | undefined;
    isPhoneNumberConfirmed!: boolean | undefined;
    timezone!: string | undefined;
    qrCodeSetupImageUrl!: string | undefined;
    isGoogleAuthenticatorEnabled!: boolean | undefined;
    manageUser!: number | undefined;
    regionCode!: string | undefined;
    authorizationMicrosoft!: boolean | undefined;

    constructor(data?: ICurrentUserProfileEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.surname = data["surname"];
            this.userName = data["userName"];
            this.emailAddress = data["emailAddress"];
            this.phoneNumber = data["phoneNumber"];
            this.isPhoneNumberConfirmed = data["isPhoneNumberConfirmed"];
            this.timezone = data["timezone"];
            this.qrCodeSetupImageUrl = data["qrCodeSetupImageUrl"];
            this.isGoogleAuthenticatorEnabled = data["isGoogleAuthenticatorEnabled"];
            this.manageUser = data["manageUser"];
            this.regionCode = data["regionCode"];
            this.authorizationMicrosoft = data["authorizationMicrosoft"];
        }
    }

    static fromJS(data: any): CurrentUserProfileEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new CurrentUserProfileEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        data["isPhoneNumberConfirmed"] = this.isPhoneNumberConfirmed;
        data["timezone"] = this.timezone;
        data["qrCodeSetupImageUrl"] = this.qrCodeSetupImageUrl;
        data["isGoogleAuthenticatorEnabled"] = this.isGoogleAuthenticatorEnabled;
        data["manageUser"] = this.manageUser;
        data["regionCode"] = this.regionCode;
        data["authorizationMicrosoft"] = this.authorizationMicrosoft;
        return data;
    }
}

export interface ICurrentUserProfileEditDto {
    name: string;
    surname: string;
    userName: string;
    emailAddress: string;
    phoneNumber: string | undefined;
    isPhoneNumberConfirmed: boolean | undefined;
    timezone: string | undefined;
    qrCodeSetupImageUrl: string | undefined;
    isGoogleAuthenticatorEnabled: boolean | undefined;
    manageUser: number | undefined;
    regionCode: string | undefined;
    authorizationMicrosoft: boolean | undefined;
}

export class UpdateGoogleAuthenticatorKeyOutput implements IUpdateGoogleAuthenticatorKeyOutput {
    qrCodeSetupImageUrl!: string | undefined;

    constructor(data?: IUpdateGoogleAuthenticatorKeyOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.qrCodeSetupImageUrl = data["qrCodeSetupImageUrl"];
        }
    }

    static fromJS(data: any): UpdateGoogleAuthenticatorKeyOutput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateGoogleAuthenticatorKeyOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["qrCodeSetupImageUrl"] = this.qrCodeSetupImageUrl;
        return data;
    }
}

export interface IUpdateGoogleAuthenticatorKeyOutput {
    qrCodeSetupImageUrl: string | undefined;
}

export class VerifySmsCodeInputDto implements IVerifySmsCodeInputDto {
    code!: string | undefined;

    constructor(data?: IVerifySmsCodeInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
        }
    }

    static fromJS(data: any): VerifySmsCodeInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new VerifySmsCodeInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        return data;
    }
}

export interface IVerifySmsCodeInputDto {
    code: string | undefined;
}

export class ChangePasswordInput implements IChangePasswordInput {
    currentPassword!: string;
    newPassword!: string;

    constructor(data?: IChangePasswordInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.currentPassword = data["currentPassword"];
            this.newPassword = data["newPassword"];
        }
    }

    static fromJS(data: any): ChangePasswordInput {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPassword"] = this.currentPassword;
        data["newPassword"] = this.newPassword;
        return data;
    }
}

export interface IChangePasswordInput {
    currentPassword: string;
    newPassword: string;
}

export class UpdateProfilePictureInput implements IUpdateProfilePictureInput {
    fileName!: string;
    x!: number | undefined;
    y!: number | undefined;
    width!: number | undefined;
    height!: number | undefined;

    constructor(data?: IUpdateProfilePictureInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.fileName = data["fileName"];
            this.x = data["x"];
            this.y = data["y"];
            this.width = data["width"];
            this.height = data["height"];
        }
    }

    static fromJS(data: any): UpdateProfilePictureInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProfilePictureInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["x"] = this.x;
        data["y"] = this.y;
        data["width"] = this.width;
        data["height"] = this.height;
        return data;
    }
}

export interface IUpdateProfilePictureInput {
    fileName: string;
    x: number | undefined;
    y: number | undefined;
    width: number | undefined;
    height: number | undefined;
}

export class GetPasswordComplexitySettingOutput implements IGetPasswordComplexitySettingOutput {
    setting!: PasswordComplexitySetting | undefined;

    constructor(data?: IGetPasswordComplexitySettingOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.setting = data["setting"] ? PasswordComplexitySetting.fromJS(data["setting"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetPasswordComplexitySettingOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetPasswordComplexitySettingOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["setting"] = this.setting ? this.setting.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetPasswordComplexitySettingOutput {
    setting: PasswordComplexitySetting | undefined;
}

export class GetProfilePictureOutput implements IGetProfilePictureOutput {
    profilePicture!: string | undefined;

    constructor(data?: IGetProfilePictureOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.profilePicture = data["profilePicture"];
        }
    }

    static fromJS(data: any): GetProfilePictureOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetProfilePictureOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profilePicture"] = this.profilePicture;
        return data;
    }
}

export interface IGetProfilePictureOutput {
    profilePicture: string | undefined;
}

export class ChangeUserLanguageDto implements IChangeUserLanguageDto {
    languageName!: string;

    constructor(data?: IChangeUserLanguageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.languageName = data["languageName"];
        }
    }

    static fromJS(data: any): ChangeUserLanguageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeUserLanguageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageName"] = this.languageName;
        return data;
    }
}

export interface IChangeUserLanguageDto {
    languageName: string;
}

export class PagedResultDtoOfGetProgramForView implements IPagedResultDtoOfGetProgramForView {
    totalCount!: number | undefined;
    items!: GetProgramForView[] | undefined;

    constructor(data?: IPagedResultDtoOfGetProgramForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetProgramForView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetProgramForView {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetProgramForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetProgramForView {
    totalCount: number | undefined;
    items: GetProgramForView[] | undefined;
}

export class GetProgramForView implements IGetProgramForView {
    program!: ProgramDto | undefined;

    constructor(data?: IGetProgramForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.program = data["program"] ? ProgramDto.fromJS(data["program"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetProgramForView {
        data = typeof data === 'object' ? data : {};
        let result = new GetProgramForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["program"] = this.program ? this.program.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetProgramForView {
    program: ProgramDto | undefined;
}

export class ProgramDto implements IProgramDto {
    programCode!: string | undefined;
    programName!: string | undefined;
    description!: string | undefined;
    status!: string | undefined;
    startDate!: moment.Moment | undefined;
    endDate!: moment.Moment | undefined;
    pointRatio!: number | undefined;
    id!: number | undefined;

    constructor(data?: IProgramDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.programCode = data["programCode"];
            this.programName = data["programName"];
            this.description = data["description"];
            this.status = data["status"];
            this.startDate = data["startDate"] ? moment(data["startDate"].toString()) : <any>undefined;
            this.endDate = data["endDate"] ? moment(data["endDate"].toString()) : <any>undefined;
            this.pointRatio = data["pointRatio"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ProgramDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProgramDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["programCode"] = this.programCode;
        data["programName"] = this.programName;
        data["description"] = this.description;
        data["status"] = this.status;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["pointRatio"] = this.pointRatio;
        data["id"] = this.id;
        return data;
    }
}

export interface IProgramDto {
    programCode: string | undefined;
    programName: string | undefined;
    description: string | undefined;
    status: string | undefined;
    startDate: moment.Moment | undefined;
    endDate: moment.Moment | undefined;
    pointRatio: number | undefined;
    id: number | undefined;
}

export class GetProgramForEditOutput implements IGetProgramForEditOutput {
    program!: CreateOrEditProgramDto | undefined;

    constructor(data?: IGetProgramForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.program = data["program"] ? CreateOrEditProgramDto.fromJS(data["program"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetProgramForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetProgramForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["program"] = this.program ? this.program.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetProgramForEditOutput {
    program: CreateOrEditProgramDto | undefined;
}

export class CreateOrEditProgramDto implements ICreateOrEditProgramDto {
    programCode!: string | undefined;
    programName!: string | undefined;
    description!: string | undefined;
    status!: string | undefined;
    startDate!: moment.Moment | undefined;
    endDate!: moment.Moment | undefined;
    pointRatio!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditProgramDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.programCode = data["programCode"];
            this.programName = data["programName"];
            this.description = data["description"];
            this.status = data["status"];
            this.startDate = data["startDate"] ? moment(data["startDate"].toString()) : <any>undefined;
            this.endDate = data["endDate"] ? moment(data["endDate"].toString()) : <any>undefined;
            this.pointRatio = data["pointRatio"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditProgramDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditProgramDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["programCode"] = this.programCode;
        data["programName"] = this.programName;
        data["description"] = this.description;
        data["status"] = this.status;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["pointRatio"] = this.pointRatio;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditProgramDto {
    programCode: string | undefined;
    programName: string | undefined;
    description: string | undefined;
    status: string | undefined;
    startDate: moment.Moment | undefined;
    endDate: moment.Moment | undefined;
    pointRatio: number | undefined;
    id: number | undefined;
}

export class GetProgramActualForView implements IGetProgramActualForView {
    programActual!: ProgramActualDto | undefined;

    constructor(data?: IGetProgramActualForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.programActual = data["programActual"] ? ProgramActualDto.fromJS(data["programActual"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetProgramActualForView {
        data = typeof data === 'object' ? data : {};
        let result = new GetProgramActualForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["programActual"] = this.programActual ? this.programActual.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetProgramActualForView {
    programActual: ProgramActualDto | undefined;
}

export class ProgramActualDto implements IProgramActualDto {
    programCode!: string | undefined;
    productCode!: string | undefined;
    memberCode!: string | undefined;
    month!: number | undefined;
    year!: number | undefined;
    quantity!: number | undefined;
    status!: string | undefined;
    description!: string | undefined;
    productName!: string | undefined;
    id!: number | undefined;

    constructor(data?: IProgramActualDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.programCode = data["programCode"];
            this.productCode = data["productCode"];
            this.memberCode = data["memberCode"];
            this.month = data["month"];
            this.year = data["year"];
            this.quantity = data["quantity"];
            this.status = data["status"];
            this.description = data["description"];
            this.productName = data["productName"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ProgramActualDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProgramActualDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["programCode"] = this.programCode;
        data["productCode"] = this.productCode;
        data["memberCode"] = this.memberCode;
        data["month"] = this.month;
        data["year"] = this.year;
        data["quantity"] = this.quantity;
        data["status"] = this.status;
        data["description"] = this.description;
        data["productName"] = this.productName;
        data["id"] = this.id;
        return data;
    }
}

export interface IProgramActualDto {
    programCode: string | undefined;
    productCode: string | undefined;
    memberCode: string | undefined;
    month: number | undefined;
    year: number | undefined;
    quantity: number | undefined;
    status: string | undefined;
    description: string | undefined;
    productName: string | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfGetProgramActualForView implements IPagedResultDtoOfGetProgramActualForView {
    totalCount!: number | undefined;
    items!: GetProgramActualForView[] | undefined;

    constructor(data?: IPagedResultDtoOfGetProgramActualForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetProgramActualForView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetProgramActualForView {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetProgramActualForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetProgramActualForView {
    totalCount: number | undefined;
    items: GetProgramActualForView[] | undefined;
}

export class GetProgramActualForEditOutput implements IGetProgramActualForEditOutput {
    programActual!: CreateOrEditProgramActualDto | undefined;

    constructor(data?: IGetProgramActualForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.programActual = data["programActual"] ? CreateOrEditProgramActualDto.fromJS(data["programActual"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetProgramActualForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetProgramActualForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["programActual"] = this.programActual ? this.programActual.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetProgramActualForEditOutput {
    programActual: CreateOrEditProgramActualDto | undefined;
}

export class CreateOrEditProgramActualDto implements ICreateOrEditProgramActualDto {
    programCode!: string | undefined;
    productCode!: string | undefined;
    memberCode!: string | undefined;
    month!: number | undefined;
    year!: number | undefined;
    quantity!: number | undefined;
    status!: string | undefined;
    description!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditProgramActualDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.programCode = data["programCode"];
            this.productCode = data["productCode"];
            this.memberCode = data["memberCode"];
            this.month = data["month"];
            this.year = data["year"];
            this.quantity = data["quantity"];
            this.status = data["status"];
            this.description = data["description"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditProgramActualDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditProgramActualDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["programCode"] = this.programCode;
        data["productCode"] = this.productCode;
        data["memberCode"] = this.memberCode;
        data["month"] = this.month;
        data["year"] = this.year;
        data["quantity"] = this.quantity;
        data["status"] = this.status;
        data["description"] = this.description;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditProgramActualDto {
    programCode: string | undefined;
    productCode: string | undefined;
    memberCode: string | undefined;
    month: number | undefined;
    year: number | undefined;
    quantity: number | undefined;
    status: string | undefined;
    description: string | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfGetProgramTargetForView implements IPagedResultDtoOfGetProgramTargetForView {
    totalCount!: number | undefined;
    items!: GetProgramTargetForView[] | undefined;

    constructor(data?: IPagedResultDtoOfGetProgramTargetForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetProgramTargetForView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetProgramTargetForView {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetProgramTargetForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetProgramTargetForView {
    totalCount: number | undefined;
    items: GetProgramTargetForView[] | undefined;
}

export class GetProgramTargetForView implements IGetProgramTargetForView {
    programTarget!: ProgramTargetDto | undefined;

    constructor(data?: IGetProgramTargetForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.programTarget = data["programTarget"] ? ProgramTargetDto.fromJS(data["programTarget"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetProgramTargetForView {
        data = typeof data === 'object' ? data : {};
        let result = new GetProgramTargetForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["programTarget"] = this.programTarget ? this.programTarget.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetProgramTargetForView {
    programTarget: ProgramTargetDto | undefined;
}

export class ProgramTargetDto implements IProgramTargetDto {
    programCode!: string | undefined;
    productCode!: string | undefined;
    quantity!: number | undefined;
    status!: string | undefined;
    productName!: string | undefined;
    id!: number | undefined;

    constructor(data?: IProgramTargetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.programCode = data["programCode"];
            this.productCode = data["productCode"];
            this.quantity = data["quantity"];
            this.status = data["status"];
            this.productName = data["productName"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ProgramTargetDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProgramTargetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["programCode"] = this.programCode;
        data["productCode"] = this.productCode;
        data["quantity"] = this.quantity;
        data["status"] = this.status;
        data["productName"] = this.productName;
        data["id"] = this.id;
        return data;
    }
}

export interface IProgramTargetDto {
    programCode: string | undefined;
    productCode: string | undefined;
    quantity: number | undefined;
    status: string | undefined;
    productName: string | undefined;
    id: number | undefined;
}

export class GetProgramTargetForEditOutput implements IGetProgramTargetForEditOutput {
    programTarget!: CreateOrEditProgramTargetDto | undefined;

    constructor(data?: IGetProgramTargetForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.programTarget = data["programTarget"] ? CreateOrEditProgramTargetDto.fromJS(data["programTarget"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetProgramTargetForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetProgramTargetForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["programTarget"] = this.programTarget ? this.programTarget.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetProgramTargetForEditOutput {
    programTarget: CreateOrEditProgramTargetDto | undefined;
}

export class CreateOrEditProgramTargetDto implements ICreateOrEditProgramTargetDto {
    programCode!: string | undefined;
    productCode!: string | undefined;
    quantity!: number | undefined;
    status!: string | undefined;
    productName!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditProgramTargetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.programCode = data["programCode"];
            this.productCode = data["productCode"];
            this.quantity = data["quantity"];
            this.status = data["status"];
            this.productName = data["productName"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditProgramTargetDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditProgramTargetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["programCode"] = this.programCode;
        data["productCode"] = this.productCode;
        data["quantity"] = this.quantity;
        data["status"] = this.status;
        data["productName"] = this.productName;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditProgramTargetDto {
    programCode: string | undefined;
    productCode: string | undefined;
    quantity: number | undefined;
    status: string | undefined;
    productName: string | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfGetPublisherMasterForViewDto implements IPagedResultDtoOfGetPublisherMasterForViewDto {
    totalCount!: number | undefined;
    items!: GetPublisherMasterForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetPublisherMasterForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetPublisherMasterForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetPublisherMasterForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetPublisherMasterForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetPublisherMasterForViewDto {
    totalCount: number | undefined;
    items: GetPublisherMasterForViewDto[] | undefined;
}

export class GetPublisherMasterForViewDto implements IGetPublisherMasterForViewDto {
    publisherMaster!: PublisherMasterDto | undefined;

    constructor(data?: IGetPublisherMasterForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.publisherMaster = data["publisherMaster"] ? PublisherMasterDto.fromJS(data["publisherMaster"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetPublisherMasterForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPublisherMasterForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["publisherMaster"] = this.publisherMaster ? this.publisherMaster.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetPublisherMasterForViewDto {
    publisherMaster: PublisherMasterDto | undefined;
}

export class PublisherMasterDto implements IPublisherMasterDto {
    publisherCode!: string | undefined;
    publisherName!: string | undefined;
    description!: string | undefined;
    status!: string | undefined;
    pulisherNameUnsign!: string | undefined;
    id!: number | undefined;

    constructor(data?: IPublisherMasterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.publisherCode = data["publisherCode"];
            this.publisherName = data["publisherName"];
            this.description = data["description"];
            this.status = data["status"];
            this.pulisherNameUnsign = data["pulisherNameUnsign"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): PublisherMasterDto {
        data = typeof data === 'object' ? data : {};
        let result = new PublisherMasterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["publisherCode"] = this.publisherCode;
        data["publisherName"] = this.publisherName;
        data["description"] = this.description;
        data["status"] = this.status;
        data["pulisherNameUnsign"] = this.pulisherNameUnsign;
        data["id"] = this.id;
        return data;
    }
}

export interface IPublisherMasterDto {
    publisherCode: string | undefined;
    publisherName: string | undefined;
    description: string | undefined;
    status: string | undefined;
    pulisherNameUnsign: string | undefined;
    id: number | undefined;
}

export class GetPublisherMasterForEditOutput implements IGetPublisherMasterForEditOutput {
    publisherMaster!: CreateOrEditPublisherMasterDto | undefined;

    constructor(data?: IGetPublisherMasterForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.publisherMaster = data["publisherMaster"] ? CreateOrEditPublisherMasterDto.fromJS(data["publisherMaster"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetPublisherMasterForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetPublisherMasterForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["publisherMaster"] = this.publisherMaster ? this.publisherMaster.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetPublisherMasterForEditOutput {
    publisherMaster: CreateOrEditPublisherMasterDto | undefined;
}

export class CreateOrEditPublisherMasterDto implements ICreateOrEditPublisherMasterDto {
    publisherCode!: string | undefined;
    publisherName!: string | undefined;
    description!: string | undefined;
    status!: string | undefined;
    pulisherNameUnsign!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditPublisherMasterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.publisherCode = data["publisherCode"];
            this.publisherName = data["publisherName"];
            this.description = data["description"];
            this.status = data["status"];
            this.pulisherNameUnsign = data["pulisherNameUnsign"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditPublisherMasterDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditPublisherMasterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["publisherCode"] = this.publisherCode;
        data["publisherName"] = this.publisherName;
        data["description"] = this.description;
        data["status"] = this.status;
        data["pulisherNameUnsign"] = this.pulisherNameUnsign;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditPublisherMasterDto {
    publisherCode: string | undefined;
    publisherName: string | undefined;
    description: string | undefined;
    status: string | undefined;
    pulisherNameUnsign: string | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfGetPublisherForViewDto implements IPagedResultDtoOfGetPublisherForViewDto {
    totalCount!: number | undefined;
    items!: GetPublisherForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetPublisherForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetPublisherForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetPublisherForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetPublisherForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetPublisherForViewDto {
    totalCount: number | undefined;
    items: GetPublisherForViewDto[] | undefined;
}

export class GetPublisherForViewDto implements IGetPublisherForViewDto {
    publisher!: PublisherDto | undefined;

    constructor(data?: IGetPublisherForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.publisher = data["publisher"] ? PublisherDto.fromJS(data["publisher"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetPublisherForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPublisherForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["publisher"] = this.publisher ? this.publisher.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetPublisherForViewDto {
    publisher: PublisherDto | undefined;
}

export class PublisherDto implements IPublisherDto {
    code!: string | undefined;
    name!: string | undefined;
    description!: string | undefined;
    apiLink!: string | undefined;
    tokenKey!: string | undefined;
    status!: string | undefined;
    id!: number | undefined;

    constructor(data?: IPublisherDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.name = data["name"];
            this.description = data["description"];
            this.apiLink = data["apiLink"];
            this.tokenKey = data["tokenKey"];
            this.status = data["status"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): PublisherDto {
        data = typeof data === 'object' ? data : {};
        let result = new PublisherDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["description"] = this.description;
        data["apiLink"] = this.apiLink;
        data["tokenKey"] = this.tokenKey;
        data["status"] = this.status;
        data["id"] = this.id;
        return data;
    }
}

export interface IPublisherDto {
    code: string | undefined;
    name: string | undefined;
    description: string | undefined;
    apiLink: string | undefined;
    tokenKey: string | undefined;
    status: string | undefined;
    id: number | undefined;
}

export class GetPublisherForEditOutput implements IGetPublisherForEditOutput {
    publisher!: CreateOrEditPublisherDto | undefined;

    constructor(data?: IGetPublisherForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.publisher = data["publisher"] ? CreateOrEditPublisherDto.fromJS(data["publisher"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetPublisherForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetPublisherForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["publisher"] = this.publisher ? this.publisher.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetPublisherForEditOutput {
    publisher: CreateOrEditPublisherDto | undefined;
}

export class CreateOrEditPublisherDto implements ICreateOrEditPublisherDto {
    code!: string;
    name!: string | undefined;
    description!: string | undefined;
    apiLink!: string | undefined;
    tokenKey!: string | undefined;
    status!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditPublisherDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.name = data["name"];
            this.description = data["description"];
            this.apiLink = data["apiLink"];
            this.tokenKey = data["tokenKey"];
            this.status = data["status"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditPublisherDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditPublisherDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["description"] = this.description;
        data["apiLink"] = this.apiLink;
        data["tokenKey"] = this.tokenKey;
        data["status"] = this.status;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditPublisherDto {
    code: string;
    name: string | undefined;
    description: string | undefined;
    apiLink: string | undefined;
    tokenKey: string | undefined;
    status: string | undefined;
    id: number | undefined;
}

export class GetPublisherGiftCampaignForView implements IGetPublisherGiftCampaignForView {
    code!: string | undefined;
    name!: string | undefined;

    constructor(data?: IGetPublisherGiftCampaignForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.name = data["name"];
        }
    }

    static fromJS(data: any): GetPublisherGiftCampaignForView {
        data = typeof data === 'object' ? data : {};
        let result = new GetPublisherGiftCampaignForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetPublisherGiftCampaignForView {
    code: string | undefined;
    name: string | undefined;
}

export class PagedResultDtoOfGetQATicketForViewDto implements IPagedResultDtoOfGetQATicketForViewDto {
    totalCount!: number | undefined;
    items!: GetQATicketForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetQATicketForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetQATicketForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetQATicketForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetQATicketForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetQATicketForViewDto {
    totalCount: number | undefined;
    items: GetQATicketForViewDto[] | undefined;
}

export class GetQATicketForViewDto implements IGetQATicketForViewDto {
    qaTicket!: QATicketDto | undefined;

    constructor(data?: IGetQATicketForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.qaTicket = data["qaTicket"] ? QATicketDto.fromJS(data["qaTicket"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetQATicketForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetQATicketForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["qaTicket"] = this.qaTicket ? this.qaTicket.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetQATicketForViewDto {
    qaTicket: QATicketDto | undefined;
}

export class QATicketDto implements IQATicketDto {
    ticketCode!: string | undefined;
    memberCode!: string | undefined;
    memberName!: string | undefined;
    submitDate!: moment.Moment | undefined;
    content!: string | undefined;
    memberNameUnsign!: string | undefined;
    type!: string | undefined;
    id!: number | undefined;

    constructor(data?: IQATicketDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.ticketCode = data["ticketCode"];
            this.memberCode = data["memberCode"];
            this.memberName = data["memberName"];
            this.submitDate = data["submitDate"] ? moment(data["submitDate"].toString()) : <any>undefined;
            this.content = data["content"];
            this.memberNameUnsign = data["memberNameUnsign"];
            this.type = data["type"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): QATicketDto {
        data = typeof data === 'object' ? data : {};
        let result = new QATicketDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ticketCode"] = this.ticketCode;
        data["memberCode"] = this.memberCode;
        data["memberName"] = this.memberName;
        data["submitDate"] = this.submitDate ? this.submitDate.toISOString() : <any>undefined;
        data["content"] = this.content;
        data["memberNameUnsign"] = this.memberNameUnsign;
        data["type"] = this.type;
        data["id"] = this.id;
        return data;
    }
}

export interface IQATicketDto {
    ticketCode: string | undefined;
    memberCode: string | undefined;
    memberName: string | undefined;
    submitDate: moment.Moment | undefined;
    content: string | undefined;
    memberNameUnsign: string | undefined;
    type: string | undefined;
    id: number | undefined;
}

export class GetQATicketForEditOutput implements IGetQATicketForEditOutput {
    qaTicket!: CreateOrEditQATicketDto | undefined;

    constructor(data?: IGetQATicketForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.qaTicket = data["qaTicket"] ? CreateOrEditQATicketDto.fromJS(data["qaTicket"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetQATicketForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetQATicketForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["qaTicket"] = this.qaTicket ? this.qaTicket.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetQATicketForEditOutput {
    qaTicket: CreateOrEditQATicketDto | undefined;
}

export class CreateOrEditQATicketDto implements ICreateOrEditQATicketDto {
    ticketCode!: string | undefined;
    memberCode!: string | undefined;
    memberName!: string | undefined;
    submitDate!: moment.Moment | undefined;
    content!: string | undefined;
    memberNameUnsign!: string | undefined;
    type!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditQATicketDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.ticketCode = data["ticketCode"];
            this.memberCode = data["memberCode"];
            this.memberName = data["memberName"];
            this.submitDate = data["submitDate"] ? moment(data["submitDate"].toString()) : <any>undefined;
            this.content = data["content"];
            this.memberNameUnsign = data["memberNameUnsign"];
            this.type = data["type"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditQATicketDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditQATicketDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ticketCode"] = this.ticketCode;
        data["memberCode"] = this.memberCode;
        data["memberName"] = this.memberName;
        data["submitDate"] = this.submitDate ? this.submitDate.toISOString() : <any>undefined;
        data["content"] = this.content;
        data["memberNameUnsign"] = this.memberNameUnsign;
        data["type"] = this.type;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditQATicketDto {
    ticketCode: string | undefined;
    memberCode: string | undefined;
    memberName: string | undefined;
    submitDate: moment.Moment | undefined;
    content: string | undefined;
    memberNameUnsign: string | undefined;
    type: string | undefined;
    id: number | undefined;
}

export class GetAllQATicketsInput implements IGetAllQATicketsInput {
    filter!: string | undefined;
    ticketCodeFilter!: string | undefined;
    memberCodeFilter!: string | undefined;
    memberNameFilter!: string | undefined;
    maxSubmitDateFilter!: moment.Moment | undefined;
    minSubmitDateFilter!: moment.Moment | undefined;
    contentFilter!: string | undefined;
    memberNameUnsignFilter!: string | undefined;
    typeFilter!: string | undefined;
    sorting!: string | undefined;
    skipCount!: number | undefined;
    maxResultCount!: number | undefined;

    constructor(data?: IGetAllQATicketsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.filter = data["filter"];
            this.ticketCodeFilter = data["ticketCodeFilter"];
            this.memberCodeFilter = data["memberCodeFilter"];
            this.memberNameFilter = data["memberNameFilter"];
            this.maxSubmitDateFilter = data["maxSubmitDateFilter"] ? moment(data["maxSubmitDateFilter"].toString()) : <any>undefined;
            this.minSubmitDateFilter = data["minSubmitDateFilter"] ? moment(data["minSubmitDateFilter"].toString()) : <any>undefined;
            this.contentFilter = data["contentFilter"];
            this.memberNameUnsignFilter = data["memberNameUnsignFilter"];
            this.typeFilter = data["typeFilter"];
            this.sorting = data["sorting"];
            this.skipCount = data["skipCount"];
            this.maxResultCount = data["maxResultCount"];
        }
    }

    static fromJS(data: any): GetAllQATicketsInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllQATicketsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        data["ticketCodeFilter"] = this.ticketCodeFilter;
        data["memberCodeFilter"] = this.memberCodeFilter;
        data["memberNameFilter"] = this.memberNameFilter;
        data["maxSubmitDateFilter"] = this.maxSubmitDateFilter ? this.maxSubmitDateFilter.toISOString() : <any>undefined;
        data["minSubmitDateFilter"] = this.minSubmitDateFilter ? this.minSubmitDateFilter.toISOString() : <any>undefined;
        data["contentFilter"] = this.contentFilter;
        data["memberNameUnsignFilter"] = this.memberNameUnsignFilter;
        data["typeFilter"] = this.typeFilter;
        data["sorting"] = this.sorting;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data;
    }
}

export interface IGetAllQATicketsInput {
    filter: string | undefined;
    ticketCodeFilter: string | undefined;
    memberCodeFilter: string | undefined;
    memberNameFilter: string | undefined;
    maxSubmitDateFilter: moment.Moment | undefined;
    minSubmitDateFilter: moment.Moment | undefined;
    contentFilter: string | undefined;
    memberNameUnsignFilter: string | undefined;
    typeFilter: string | undefined;
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;
}

export class QaTicketEventData implements IQaTicketEventData {
    ticketCode!: string | undefined;
    type!: string | undefined;
    memberID!: string | undefined;
    memberName!: string | undefined;
    qaContent!: string | undefined;
    submitDate!: moment.Moment | undefined;
    userID!: number | undefined;
    tenantId!: number | undefined;
    eventCode!: string | undefined;
    eventName!: string | undefined;
    eventTime!: moment.Moment | undefined;
    eventSource!: any | undefined;

    constructor(data?: IQaTicketEventData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.ticketCode = data["ticketCode"];
            this.type = data["type"];
            this.memberID = data["memberID"];
            this.memberName = data["memberName"];
            this.qaContent = data["qaContent"];
            this.submitDate = data["submitDate"] ? moment(data["submitDate"].toString()) : <any>undefined;
            this.userID = data["userID"];
            this.tenantId = data["tenantId"];
            this.eventCode = data["eventCode"];
            this.eventName = data["eventName"];
            this.eventTime = data["eventTime"] ? moment(data["eventTime"].toString()) : <any>undefined;
            this.eventSource = data["eventSource"];
        }
    }

    static fromJS(data: any): QaTicketEventData {
        data = typeof data === 'object' ? data : {};
        let result = new QaTicketEventData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ticketCode"] = this.ticketCode;
        data["type"] = this.type;
        data["memberID"] = this.memberID;
        data["memberName"] = this.memberName;
        data["qaContent"] = this.qaContent;
        data["submitDate"] = this.submitDate ? this.submitDate.toISOString() : <any>undefined;
        data["userID"] = this.userID;
        data["tenantId"] = this.tenantId;
        data["eventCode"] = this.eventCode;
        data["eventName"] = this.eventName;
        data["eventTime"] = this.eventTime ? this.eventTime.toISOString() : <any>undefined;
        data["eventSource"] = this.eventSource;
        return data;
    }
}

export interface IQaTicketEventData {
    ticketCode: string | undefined;
    type: string | undefined;
    memberID: string | undefined;
    memberName: string | undefined;
    qaContent: string | undefined;
    submitDate: moment.Moment | undefined;
    userID: number | undefined;
    tenantId: number | undefined;
    eventCode: string | undefined;
    eventName: string | undefined;
    eventTime: moment.Moment | undefined;
    eventSource: any | undefined;
}

export class QuartzHistoryGetAllOutput implements IQuartzHistoryGetAllOutput {
    quartzJob!: QuartzJobDto | undefined;
    totalCount!: number | undefined;
    items!: QuartzHistoryDto[] | undefined;

    constructor(data?: IQuartzHistoryGetAllOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.quartzJob = data["quartzJob"] ? QuartzJobDto.fromJS(data["quartzJob"]) : <any>undefined;
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(QuartzHistoryDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QuartzHistoryGetAllOutput {
        data = typeof data === 'object' ? data : {};
        let result = new QuartzHistoryGetAllOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["quartzJob"] = this.quartzJob ? this.quartzJob.toJSON() : <any>undefined;
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQuartzHistoryGetAllOutput {
    quartzJob: QuartzJobDto | undefined;
    totalCount: number | undefined;
    items: QuartzHistoryDto[] | undefined;
}

export class QuartzJobDto implements IQuartzJobDto {
    jobName!: string | undefined;
    group!: string | undefined;
    status!: QuartzJobDtoStatus | undefined;
    description!: string | undefined;
    jobInfo!: string | undefined;
    lastRunTime!: moment.Moment | undefined;
    lastRunState!: QuartzJobDtoLastRunState | undefined;
    jobRunTime!: string | undefined;
    nextRunTime!: moment.Moment | undefined;
    id!: number | undefined;

    constructor(data?: IQuartzJobDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.jobName = data["jobName"];
            this.group = data["group"];
            this.status = data["status"];
            this.description = data["description"];
            this.jobInfo = data["jobInfo"];
            this.lastRunTime = data["lastRunTime"] ? moment(data["lastRunTime"].toString()) : <any>undefined;
            this.lastRunState = data["lastRunState"];
            this.jobRunTime = data["jobRunTime"];
            this.nextRunTime = data["nextRunTime"] ? moment(data["nextRunTime"].toString()) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): QuartzJobDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuartzJobDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobName"] = this.jobName;
        data["group"] = this.group;
        data["status"] = this.status;
        data["description"] = this.description;
        data["jobInfo"] = this.jobInfo;
        data["lastRunTime"] = this.lastRunTime ? this.lastRunTime.toISOString() : <any>undefined;
        data["lastRunState"] = this.lastRunState;
        data["jobRunTime"] = this.jobRunTime;
        data["nextRunTime"] = this.nextRunTime ? this.nextRunTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IQuartzJobDto {
    jobName: string | undefined;
    group: string | undefined;
    status: QuartzJobDtoStatus | undefined;
    description: string | undefined;
    jobInfo: string | undefined;
    lastRunTime: moment.Moment | undefined;
    lastRunState: QuartzJobDtoLastRunState | undefined;
    jobRunTime: string | undefined;
    nextRunTime: moment.Moment | undefined;
    id: number | undefined;
}

export class QuartzHistoryDto implements IQuartzHistoryDto {
    creationTime!: moment.Moment | undefined;
    state!: QuartzHistoryDtoState | undefined;
    jobName!: string | undefined;
    group!: string | undefined;
    exception!: string | undefined;
    fireInstanceId!: string | undefined;
    fireTimeUtc!: moment.Moment | undefined;
    description!: string | undefined;
    id!: number | undefined;

    constructor(data?: IQuartzHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.state = data["state"];
            this.jobName = data["jobName"];
            this.group = data["group"];
            this.exception = data["exception"];
            this.fireInstanceId = data["fireInstanceId"];
            this.fireTimeUtc = data["fireTimeUtc"] ? moment(data["fireTimeUtc"].toString()) : <any>undefined;
            this.description = data["description"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): QuartzHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuartzHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["state"] = this.state;
        data["jobName"] = this.jobName;
        data["group"] = this.group;
        data["exception"] = this.exception;
        data["fireInstanceId"] = this.fireInstanceId;
        data["fireTimeUtc"] = this.fireTimeUtc ? this.fireTimeUtc.toISOString() : <any>undefined;
        data["description"] = this.description;
        data["id"] = this.id;
        return data;
    }
}

export interface IQuartzHistoryDto {
    creationTime: moment.Moment | undefined;
    state: QuartzHistoryDtoState | undefined;
    jobName: string | undefined;
    group: string | undefined;
    exception: string | undefined;
    fireInstanceId: string | undefined;
    fireTimeUtc: moment.Moment | undefined;
    description: string | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfQuartzJobDto implements IPagedResultDtoOfQuartzJobDto {
    totalCount!: number | undefined;
    items!: QuartzJobDto[] | undefined;

    constructor(data?: IPagedResultDtoOfQuartzJobDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(QuartzJobDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfQuartzJobDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfQuartzJobDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfQuartzJobDto {
    totalCount: number | undefined;
    items: QuartzJobDto[] | undefined;
}

export class PagedResultDtoOfGetQuestForView implements IPagedResultDtoOfGetQuestForView {
    totalCount!: number | undefined;
    items!: GetQuestForView[] | undefined;

    constructor(data?: IPagedResultDtoOfGetQuestForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetQuestForView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetQuestForView {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetQuestForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetQuestForView {
    totalCount: number | undefined;
    items: GetQuestForView[] | undefined;
}

export class GetQuestForView implements IGetQuestForView {
    quest!: QuestDto | undefined;

    constructor(data?: IGetQuestForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.quest = data["quest"] ? QuestDto.fromJS(data["quest"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetQuestForView {
        data = typeof data === 'object' ? data : {};
        let result = new GetQuestForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["quest"] = this.quest ? this.quest.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetQuestForView {
    quest: QuestDto | undefined;
}

export class QuestDto implements IQuestDto {
    code!: string | undefined;
    name!: string | undefined;
    description!: string | undefined;
    avatar!: string | undefined;
    linkAvatar!: string | undefined;
    ordinal!: number | undefined;
    status!: string | undefined;
    fromDate!: moment.Moment | undefined;
    toDate!: moment.Moment | undefined;
    tag!: string | undefined;
    state!: string | undefined;
    missions!: MissionDto[] | undefined;
    missionCount!: number | undefined;
    date!: moment.Moment | undefined;
    id!: number | undefined;

    constructor(data?: IQuestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.name = data["name"];
            this.description = data["description"];
            this.avatar = data["avatar"];
            this.linkAvatar = data["linkAvatar"];
            this.ordinal = data["ordinal"];
            this.status = data["status"];
            this.fromDate = data["fromDate"] ? moment(data["fromDate"].toString()) : <any>undefined;
            this.toDate = data["toDate"] ? moment(data["toDate"].toString()) : <any>undefined;
            this.tag = data["tag"];
            this.state = data["state"];
            if (data["missions"] && data["missions"].constructor === Array) {
                this.missions = [];
                for (let item of data["missions"])
                    this.missions.push(MissionDto.fromJS(item));
            }
            this.missionCount = data["missionCount"];
            this.date = data["date"] ? moment(data["date"].toString()) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): QuestDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["description"] = this.description;
        data["avatar"] = this.avatar;
        data["linkAvatar"] = this.linkAvatar;
        data["ordinal"] = this.ordinal;
        data["status"] = this.status;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data["tag"] = this.tag;
        data["state"] = this.state;
        if (this.missions && this.missions.constructor === Array) {
            data["missions"] = [];
            for (let item of this.missions)
                data["missions"].push(item.toJSON());
        }
        data["missionCount"] = this.missionCount;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IQuestDto {
    code: string | undefined;
    name: string | undefined;
    description: string | undefined;
    avatar: string | undefined;
    linkAvatar: string | undefined;
    ordinal: number | undefined;
    status: string | undefined;
    fromDate: moment.Moment | undefined;
    toDate: moment.Moment | undefined;
    tag: string | undefined;
    state: string | undefined;
    missions: MissionDto[] | undefined;
    missionCount: number | undefined;
    date: moment.Moment | undefined;
    id: number | undefined;
}

export class GetQuestForEditOutput implements IGetQuestForEditOutput {
    quest!: CreateOrEditQuestDto | undefined;
    lastModifierUserName!: string | undefined;

    constructor(data?: IGetQuestForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.quest = data["quest"] ? CreateOrEditQuestDto.fromJS(data["quest"]) : <any>undefined;
            this.lastModifierUserName = data["lastModifierUserName"];
        }
    }

    static fromJS(data: any): GetQuestForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetQuestForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["quest"] = this.quest ? this.quest.toJSON() : <any>undefined;
        data["lastModifierUserName"] = this.lastModifierUserName;
        return data;
    }
}

export interface IGetQuestForEditOutput {
    quest: CreateOrEditQuestDto | undefined;
    lastModifierUserName: string | undefined;
}

export class CreateOrEditQuestDto implements ICreateOrEditQuestDto {
    code!: string | undefined;
    name!: string;
    description!: string | undefined;
    status!: string;
    fromDate!: moment.Moment | undefined;
    toDate!: moment.Moment | undefined;
    tag!: string | undefined;
    linkAvatar!: string | undefined;
    missions!: CreateOrEditMissionDto[] | undefined;
    isDeleted!: boolean | undefined;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: moment.Moment | undefined;
    creatorUserId!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditQuestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.name = data["name"];
            this.description = data["description"];
            this.status = data["status"];
            this.fromDate = data["fromDate"] ? moment(data["fromDate"].toString()) : <any>undefined;
            this.toDate = data["toDate"] ? moment(data["toDate"].toString()) : <any>undefined;
            this.tag = data["tag"];
            this.linkAvatar = data["linkAvatar"];
            if (data["missions"] && data["missions"].constructor === Array) {
                this.missions = [];
                for (let item of data["missions"])
                    this.missions.push(CreateOrEditMissionDto.fromJS(item));
            }
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditQuestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditQuestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["description"] = this.description;
        data["status"] = this.status;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data["tag"] = this.tag;
        data["linkAvatar"] = this.linkAvatar;
        if (this.missions && this.missions.constructor === Array) {
            data["missions"] = [];
            for (let item of this.missions)
                data["missions"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditQuestDto {
    code: string | undefined;
    name: string;
    description: string | undefined;
    status: string;
    fromDate: moment.Moment | undefined;
    toDate: moment.Moment | undefined;
    tag: string | undefined;
    linkAvatar: string | undefined;
    missions: CreateOrEditMissionDto[] | undefined;
    isDeleted: boolean | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class CreateOrEditMissionDto implements ICreateOrEditMissionDto {
    code!: string | undefined;
    name!: string | undefined;
    description!: string | undefined;
    ordinal!: number | undefined;
    status!: string | undefined;
    coin!: number | undefined;
    point!: number | undefined;
    target!: number | undefined;
    linkAvatar!: string | undefined;
    questCode!: string | undefined;
    isDeleted!: boolean | undefined;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: moment.Moment | undefined;
    creatorUserId!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditMissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.name = data["name"];
            this.description = data["description"];
            this.ordinal = data["ordinal"];
            this.status = data["status"];
            this.coin = data["coin"];
            this.point = data["point"];
            this.target = data["target"];
            this.linkAvatar = data["linkAvatar"];
            this.questCode = data["questCode"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditMissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditMissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["description"] = this.description;
        data["ordinal"] = this.ordinal;
        data["status"] = this.status;
        data["coin"] = this.coin;
        data["point"] = this.point;
        data["target"] = this.target;
        data["linkAvatar"] = this.linkAvatar;
        data["questCode"] = this.questCode;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditMissionDto {
    code: string | undefined;
    name: string | undefined;
    description: string | undefined;
    ordinal: number | undefined;
    status: string | undefined;
    coin: number | undefined;
    point: number | undefined;
    target: number | undefined;
    linkAvatar: string | undefined;
    questCode: string | undefined;
    isDeleted: boolean | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class CloneQuestDto implements ICloneQuestDto {
    questIds!: number[] | undefined;

    constructor(data?: ICloneQuestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["questIds"] && data["questIds"].constructor === Array) {
                this.questIds = [];
                for (let item of data["questIds"])
                    this.questIds.push(item);
            }
        }
    }

    static fromJS(data: any): CloneQuestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CloneQuestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.questIds && this.questIds.constructor === Array) {
            data["questIds"] = [];
            for (let item of this.questIds)
                data["questIds"].push(item);
        }
        return data;
    }
}

export interface ICloneQuestDto {
    questIds: number[] | undefined;
}

export class PagedResultDtoOfQuestDto implements IPagedResultDtoOfQuestDto {
    totalCount!: number | undefined;
    items!: QuestDto[] | undefined;

    constructor(data?: IPagedResultDtoOfQuestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(QuestDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfQuestDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfQuestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfQuestDto {
    totalCount: number | undefined;
    items: QuestDto[] | undefined;
}

export class JoinQuestInputDto implements IJoinQuestInputDto {
    memberCode!: string | undefined;
    questCode!: string | undefined;
    state!: string | undefined;

    constructor(data?: IJoinQuestInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberCode = data["memberCode"];
            this.questCode = data["questCode"];
            this.state = data["state"];
        }
    }

    static fromJS(data: any): JoinQuestInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new JoinQuestInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberCode"] = this.memberCode;
        data["questCode"] = this.questCode;
        data["state"] = this.state;
        return data;
    }
}

export interface IJoinQuestInputDto {
    memberCode: string | undefined;
    questCode: string | undefined;
    state: string | undefined;
}

export class JoinQuestOutputDto implements IJoinQuestOutputDto {
    id!: string | undefined;
    memberCode!: string | undefined;
    questCode!: string | undefined;
    date!: moment.Moment | undefined;
    state!: string | undefined;

    constructor(data?: IJoinQuestOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.memberCode = data["memberCode"];
            this.questCode = data["questCode"];
            this.date = data["date"] ? moment(data["date"].toString()) : <any>undefined;
            this.state = data["state"];
        }
    }

    static fromJS(data: any): JoinQuestOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new JoinQuestOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["memberCode"] = this.memberCode;
        data["questCode"] = this.questCode;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["state"] = this.state;
        return data;
    }
}

export interface IJoinQuestOutputDto {
    id: string | undefined;
    memberCode: string | undefined;
    questCode: string | undefined;
    date: moment.Moment | undefined;
    state: string | undefined;
}

export class PagedResultDtoOfGetCoinHistoryOutputItemDto implements IPagedResultDtoOfGetCoinHistoryOutputItemDto {
    totalCount!: number | undefined;
    items!: GetCoinHistoryOutputItemDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetCoinHistoryOutputItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetCoinHistoryOutputItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetCoinHistoryOutputItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetCoinHistoryOutputItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetCoinHistoryOutputItemDto {
    totalCount: number | undefined;
    items: GetCoinHistoryOutputItemDto[] | undefined;
}

export class GetCoinHistoryOutputItemDto implements IGetCoinHistoryOutputItemDto {
    code!: string | undefined;
    reason!: string | undefined;
    name!: string | undefined;
    coin!: number | undefined;
    businesstime!: moment.Moment | undefined;
    description!: string | undefined;

    constructor(data?: IGetCoinHistoryOutputItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.reason = data["reason"];
            this.name = data["name"];
            this.coin = data["coin"];
            this.businesstime = data["businesstime"] ? moment(data["businesstime"].toString()) : <any>undefined;
            this.description = data["description"];
        }
    }

    static fromJS(data: any): GetCoinHistoryOutputItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCoinHistoryOutputItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["reason"] = this.reason;
        data["name"] = this.name;
        data["coin"] = this.coin;
        data["businesstime"] = this.businesstime ? this.businesstime.toISOString() : <any>undefined;
        data["description"] = this.description;
        return data;
    }
}

export interface IGetCoinHistoryOutputItemDto {
    code: string | undefined;
    reason: string | undefined;
    name: string | undefined;
    coin: number | undefined;
    businesstime: moment.Moment | undefined;
    description: string | undefined;
}

export class PagedResultDtoOfGetAllQuestByGroupDto implements IPagedResultDtoOfGetAllQuestByGroupDto {
    totalCount!: number | undefined;
    items!: GetAllQuestByGroupDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetAllQuestByGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetAllQuestByGroupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetAllQuestByGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetAllQuestByGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetAllQuestByGroupDto {
    totalCount: number | undefined;
    items: GetAllQuestByGroupDto[] | undefined;
}

export class GetAllQuestByGroupDto implements IGetAllQuestByGroupDto {
    questGroupType!: GetAllQuestByGroupDtoQuestGroupType | undefined;
    questGroup!: QuestListByGroupDto[] | undefined;

    constructor(data?: IGetAllQuestByGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.questGroupType = data["questGroupType"];
            if (data["questGroup"] && data["questGroup"].constructor === Array) {
                this.questGroup = [];
                for (let item of data["questGroup"])
                    this.questGroup.push(QuestListByGroupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAllQuestByGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllQuestByGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["questGroupType"] = this.questGroupType;
        if (this.questGroup && this.questGroup.constructor === Array) {
            data["questGroup"] = [];
            for (let item of this.questGroup)
                data["questGroup"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetAllQuestByGroupDto {
    questGroupType: GetAllQuestByGroupDtoQuestGroupType | undefined;
    questGroup: QuestListByGroupDto[] | undefined;
}

export class QuestListByGroupDto implements IQuestListByGroupDto {
    questGroupCode!: string | undefined;
    quests!: QuestDto[] | undefined;
    questGroupInfor!: QuestGroupDto | undefined;

    constructor(data?: IQuestListByGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.questGroupCode = data["questGroupCode"];
            if (data["quests"] && data["quests"].constructor === Array) {
                this.quests = [];
                for (let item of data["quests"])
                    this.quests.push(QuestDto.fromJS(item));
            }
            this.questGroupInfor = data["questGroupInfor"] ? QuestGroupDto.fromJS(data["questGroupInfor"]) : <any>undefined;
        }
    }

    static fromJS(data: any): QuestListByGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuestListByGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["questGroupCode"] = this.questGroupCode;
        if (this.quests && this.quests.constructor === Array) {
            data["quests"] = [];
            for (let item of this.quests)
                data["quests"].push(item.toJSON());
        }
        data["questGroupInfor"] = this.questGroupInfor ? this.questGroupInfor.toJSON() : <any>undefined;
        return data;
    }
}

export interface IQuestListByGroupDto {
    questGroupCode: string | undefined;
    quests: QuestDto[] | undefined;
    questGroupInfor: QuestGroupDto | undefined;
}

export class QuestGroupDto implements IQuestGroupDto {
    tenantId!: number | undefined;
    code!: string | undefined;
    name!: string | undefined;
    ordinal!: number | undefined;
    status!: string | undefined;
    type!: QuestGroupDtoType | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: moment.Moment | undefined;
    creatorUserId!: number | undefined;
    id!: number | undefined;

    constructor(data?: IQuestGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.code = data["code"];
            this.name = data["name"];
            this.ordinal = data["ordinal"];
            this.status = data["status"];
            this.type = data["type"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): QuestGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuestGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["code"] = this.code;
        data["name"] = this.name;
        data["ordinal"] = this.ordinal;
        data["status"] = this.status;
        data["type"] = this.type;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IQuestGroupDto {
    tenantId: number | undefined;
    code: string | undefined;
    name: string | undefined;
    ordinal: number | undefined;
    status: string | undefined;
    type: QuestGroupDtoType | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfGetQuestGroupForView implements IPagedResultDtoOfGetQuestGroupForView {
    totalCount!: number | undefined;
    items!: GetQuestGroupForView[] | undefined;

    constructor(data?: IPagedResultDtoOfGetQuestGroupForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetQuestGroupForView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetQuestGroupForView {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetQuestGroupForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetQuestGroupForView {
    totalCount: number | undefined;
    items: GetQuestGroupForView[] | undefined;
}

export class GetQuestGroupForView implements IGetQuestGroupForView {
    questGroup!: QuestGroupDto | undefined;
    lastUpdateBy!: string | undefined;

    constructor(data?: IGetQuestGroupForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.questGroup = data["questGroup"] ? QuestGroupDto.fromJS(data["questGroup"]) : <any>undefined;
            this.lastUpdateBy = data["lastUpdateBy"];
        }
    }

    static fromJS(data: any): GetQuestGroupForView {
        data = typeof data === 'object' ? data : {};
        let result = new GetQuestGroupForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["questGroup"] = this.questGroup ? this.questGroup.toJSON() : <any>undefined;
        data["lastUpdateBy"] = this.lastUpdateBy;
        return data;
    }
}

export interface IGetQuestGroupForView {
    questGroup: QuestGroupDto | undefined;
    lastUpdateBy: string | undefined;
}

export class CreateOrEditQuestGroupDto implements ICreateOrEditQuestGroupDto {
    code!: string | undefined;
    name!: string | undefined;
    ordinal!: number | undefined;
    status!: string | undefined;
    type!: CreateOrEditQuestGroupDtoType | undefined;
    details!: CreateOrEditQuestGroupDetailDto[] | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: moment.Moment | undefined;
    creatorUserId!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditQuestGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.name = data["name"];
            this.ordinal = data["ordinal"];
            this.status = data["status"];
            this.type = data["type"];
            if (data["details"] && data["details"].constructor === Array) {
                this.details = [];
                for (let item of data["details"])
                    this.details.push(CreateOrEditQuestGroupDetailDto.fromJS(item));
            }
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditQuestGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditQuestGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["ordinal"] = this.ordinal;
        data["status"] = this.status;
        data["type"] = this.type;
        if (this.details && this.details.constructor === Array) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item.toJSON());
        }
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditQuestGroupDto {
    code: string | undefined;
    name: string | undefined;
    ordinal: number | undefined;
    status: string | undefined;
    type: CreateOrEditQuestGroupDtoType | undefined;
    details: CreateOrEditQuestGroupDetailDto[] | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class CreateOrEditQuestGroupDetailDto implements ICreateOrEditQuestGroupDetailDto {
    quest!: QuestDto | undefined;
    ordinal!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditQuestGroupDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.quest = data["quest"] ? QuestDto.fromJS(data["quest"]) : <any>undefined;
            this.ordinal = data["ordinal"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditQuestGroupDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditQuestGroupDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["quest"] = this.quest ? this.quest.toJSON() : <any>undefined;
        data["ordinal"] = this.ordinal;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditQuestGroupDetailDto {
    quest: QuestDto | undefined;
    ordinal: number | undefined;
    id: number | undefined;
}

export class GetQuestGroupForEditOutput implements IGetQuestGroupForEditOutput {
    questGroup!: CreateOrEditQuestGroupDto | undefined;
    lastModifierUserName!: string | undefined;

    constructor(data?: IGetQuestGroupForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.questGroup = data["questGroup"] ? CreateOrEditQuestGroupDto.fromJS(data["questGroup"]) : <any>undefined;
            this.lastModifierUserName = data["lastModifierUserName"];
        }
    }

    static fromJS(data: any): GetQuestGroupForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetQuestGroupForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["questGroup"] = this.questGroup ? this.questGroup.toJSON() : <any>undefined;
        data["lastModifierUserName"] = this.lastModifierUserName;
        return data;
    }
}

export interface IGetQuestGroupForEditOutput {
    questGroup: CreateOrEditQuestGroupDto | undefined;
    lastModifierUserName: string | undefined;
}

export class ProcessCalculationRankOfCustomerInput implements IProcessCalculationRankOfCustomerInput {
    timeRun!: moment.Moment | undefined;
    customerId!: number | undefined;
    istempRank!: boolean | undefined;

    constructor(data?: IProcessCalculationRankOfCustomerInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.timeRun = data["timeRun"] ? moment(data["timeRun"].toString()) : <any>undefined;
            this.customerId = data["customerId"];
            this.istempRank = data["istempRank"];
        }
    }

    static fromJS(data: any): ProcessCalculationRankOfCustomerInput {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessCalculationRankOfCustomerInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timeRun"] = this.timeRun ? this.timeRun.toISOString() : <any>undefined;
        data["customerId"] = this.customerId;
        data["istempRank"] = this.istempRank;
        return data;
    }
}

export interface IProcessCalculationRankOfCustomerInput {
    timeRun: moment.Moment | undefined;
    customerId: number | undefined;
    istempRank: boolean | undefined;
}

export class PagedResultDtoOfGetRankCalculationSettingForView implements IPagedResultDtoOfGetRankCalculationSettingForView {
    totalCount!: number | undefined;
    items!: GetRankCalculationSettingForView[] | undefined;

    constructor(data?: IPagedResultDtoOfGetRankCalculationSettingForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetRankCalculationSettingForView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetRankCalculationSettingForView {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetRankCalculationSettingForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetRankCalculationSettingForView {
    totalCount: number | undefined;
    items: GetRankCalculationSettingForView[] | undefined;
}

export class GetRankCalculationSettingForView implements IGetRankCalculationSettingForView {
    rankCalculationSetting!: RankCalculationSettingDto | undefined;

    constructor(data?: IGetRankCalculationSettingForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.rankCalculationSetting = data["rankCalculationSetting"] ? RankCalculationSettingDto.fromJS(data["rankCalculationSetting"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetRankCalculationSettingForView {
        data = typeof data === 'object' ? data : {};
        let result = new GetRankCalculationSettingForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rankCalculationSetting"] = this.rankCalculationSetting ? this.rankCalculationSetting.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetRankCalculationSettingForView {
    rankCalculationSetting: RankCalculationSettingDto | undefined;
}

export class RankCalculationSettingDto implements IRankCalculationSettingDto {
    code!: string | undefined;
    cron!: string | undefined;
    calculationPeriodDuration!: number | undefined;
    calculationType!: any | undefined;
    calculationMonths!: number | undefined;
    validType!: any | undefined;
    validPeriodExtendMonths!: number | undefined;
    validMonths!: number | undefined;
    isActive!: boolean | undefined;
    validPeriodStartMonth!: moment.Moment | undefined;
    calculationPeriodStartMonth!: moment.Moment | undefined;
    validPeriodDuration!: number | undefined;
    timeZone!: string | undefined;
    id!: number | undefined;

    constructor(data?: IRankCalculationSettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.cron = data["cron"];
            this.calculationPeriodDuration = data["calculationPeriodDuration"];
            this.calculationType = data["calculationType"];
            this.calculationMonths = data["calculationMonths"];
            this.validType = data["validType"];
            this.validPeriodExtendMonths = data["validPeriodExtendMonths"];
            this.validMonths = data["validMonths"];
            this.isActive = data["isActive"];
            this.validPeriodStartMonth = data["validPeriodStartMonth"] ? moment(data["validPeriodStartMonth"].toString()) : <any>undefined;
            this.calculationPeriodStartMonth = data["calculationPeriodStartMonth"] ? moment(data["calculationPeriodStartMonth"].toString()) : <any>undefined;
            this.validPeriodDuration = data["validPeriodDuration"];
            this.timeZone = data["timeZone"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): RankCalculationSettingDto {
        data = typeof data === 'object' ? data : {};
        let result = new RankCalculationSettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["cron"] = this.cron;
        data["calculationPeriodDuration"] = this.calculationPeriodDuration;
        data["calculationType"] = this.calculationType;
        data["calculationMonths"] = this.calculationMonths;
        data["validType"] = this.validType;
        data["validPeriodExtendMonths"] = this.validPeriodExtendMonths;
        data["validMonths"] = this.validMonths;
        data["isActive"] = this.isActive;
        data["validPeriodStartMonth"] = this.validPeriodStartMonth ? this.validPeriodStartMonth.toISOString() : <any>undefined;
        data["calculationPeriodStartMonth"] = this.calculationPeriodStartMonth ? this.calculationPeriodStartMonth.toISOString() : <any>undefined;
        data["validPeriodDuration"] = this.validPeriodDuration;
        data["timeZone"] = this.timeZone;
        data["id"] = this.id;
        return data;
    }
}

export interface IRankCalculationSettingDto {
    code: string | undefined;
    cron: string | undefined;
    calculationPeriodDuration: number | undefined;
    calculationType: any | undefined;
    calculationMonths: number | undefined;
    validType: any | undefined;
    validPeriodExtendMonths: number | undefined;
    validMonths: number | undefined;
    isActive: boolean | undefined;
    validPeriodStartMonth: moment.Moment | undefined;
    calculationPeriodStartMonth: moment.Moment | undefined;
    validPeriodDuration: number | undefined;
    timeZone: string | undefined;
    id: number | undefined;
}

export class GetRankCalculationSettingForEditOutput implements IGetRankCalculationSettingForEditOutput {
    rankCalculationSetting!: CreateOrEditRankCalculationSettingDto | undefined;

    constructor(data?: IGetRankCalculationSettingForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.rankCalculationSetting = data["rankCalculationSetting"] ? CreateOrEditRankCalculationSettingDto.fromJS(data["rankCalculationSetting"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetRankCalculationSettingForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetRankCalculationSettingForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rankCalculationSetting"] = this.rankCalculationSetting ? this.rankCalculationSetting.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetRankCalculationSettingForEditOutput {
    rankCalculationSetting: CreateOrEditRankCalculationSettingDto | undefined;
}

export class CreateOrEditRankCalculationSettingDto implements ICreateOrEditRankCalculationSettingDto {
    code!: string;
    cron!: string | undefined;
    calculationPeriodDuration!: number | undefined;
    calculationType!: string | undefined;
    calculationMonths!: number | undefined;
    validType!: string | undefined;
    validPeriodExtendMonths!: number | undefined;
    validMonths!: number | undefined;
    isActive!: boolean | undefined;
    validPeriodStartMonth!: moment.Moment | undefined;
    calculationPeriodStartMonth!: moment.Moment | undefined;
    validPeriodDuration!: number | undefined;
    timeZone!: string | undefined;
    lastUpdateByName!: string | undefined;
    isDeleted!: boolean | undefined;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: moment.Moment | undefined;
    creatorUserId!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditRankCalculationSettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.cron = data["cron"];
            this.calculationPeriodDuration = data["calculationPeriodDuration"];
            this.calculationType = data["calculationType"];
            this.calculationMonths = data["calculationMonths"];
            this.validType = data["validType"];
            this.validPeriodExtendMonths = data["validPeriodExtendMonths"];
            this.validMonths = data["validMonths"];
            this.isActive = data["isActive"];
            this.validPeriodStartMonth = data["validPeriodStartMonth"] ? moment(data["validPeriodStartMonth"].toString()) : <any>undefined;
            this.calculationPeriodStartMonth = data["calculationPeriodStartMonth"] ? moment(data["calculationPeriodStartMonth"].toString()) : <any>undefined;
            this.validPeriodDuration = data["validPeriodDuration"];
            this.timeZone = data["timeZone"];
            this.lastUpdateByName = data["lastUpdateByName"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditRankCalculationSettingDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditRankCalculationSettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["cron"] = this.cron;
        data["calculationPeriodDuration"] = this.calculationPeriodDuration;
        data["calculationType"] = this.calculationType;
        data["calculationMonths"] = this.calculationMonths;
        data["validType"] = this.validType;
        data["validPeriodExtendMonths"] = this.validPeriodExtendMonths;
        data["validMonths"] = this.validMonths;
        data["isActive"] = this.isActive;
        data["validPeriodStartMonth"] = this.validPeriodStartMonth ? this.validPeriodStartMonth.toISOString() : <any>undefined;
        data["calculationPeriodStartMonth"] = this.calculationPeriodStartMonth ? this.calculationPeriodStartMonth.toISOString() : <any>undefined;
        data["validPeriodDuration"] = this.validPeriodDuration;
        data["timeZone"] = this.timeZone;
        data["lastUpdateByName"] = this.lastUpdateByName;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditRankCalculationSettingDto {
    code: string;
    cron: string | undefined;
    calculationPeriodDuration: number | undefined;
    calculationType: string | undefined;
    calculationMonths: number | undefined;
    validType: string | undefined;
    validPeriodExtendMonths: number | undefined;
    validMonths: number | undefined;
    isActive: boolean | undefined;
    validPeriodStartMonth: moment.Moment | undefined;
    calculationPeriodStartMonth: moment.Moment | undefined;
    validPeriodDuration: number | undefined;
    timeZone: string | undefined;
    lastUpdateByName: string | undefined;
    isDeleted: boolean | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfGetRankHistoryForViewDto implements IPagedResultDtoOfGetRankHistoryForViewDto {
    totalCount!: number | undefined;
    items!: GetRankHistoryForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetRankHistoryForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetRankHistoryForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetRankHistoryForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetRankHistoryForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetRankHistoryForViewDto {
    totalCount: number | undefined;
    items: GetRankHistoryForViewDto[] | undefined;
}

export class GetRankHistoryForViewDto implements IGetRankHistoryForViewDto {
    rankHistory!: RankHistoryDto | undefined;

    constructor(data?: IGetRankHistoryForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.rankHistory = data["rankHistory"] ? RankHistoryDto.fromJS(data["rankHistory"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetRankHistoryForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetRankHistoryForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rankHistory"] = this.rankHistory ? this.rankHistory.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetRankHistoryForViewDto {
    rankHistory: RankHistoryDto | undefined;
}

export class RankHistoryDto implements IRankHistoryDto {
    memberCode!: string | undefined;
    point!: number | undefined;
    source!: string | undefined;
    consumerID!: number | undefined;
    lastRankID!: number | undefined;
    currentRankID!: number | undefined;
    reason!: string | undefined;
    description!: string | undefined;
    id!: number | undefined;

    constructor(data?: IRankHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberCode = data["memberCode"];
            this.point = data["point"];
            this.source = data["source"];
            this.consumerID = data["consumerID"];
            this.lastRankID = data["lastRankID"];
            this.currentRankID = data["currentRankID"];
            this.reason = data["reason"];
            this.description = data["description"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): RankHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new RankHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberCode"] = this.memberCode;
        data["point"] = this.point;
        data["source"] = this.source;
        data["consumerID"] = this.consumerID;
        data["lastRankID"] = this.lastRankID;
        data["currentRankID"] = this.currentRankID;
        data["reason"] = this.reason;
        data["description"] = this.description;
        data["id"] = this.id;
        return data;
    }
}

export interface IRankHistoryDto {
    memberCode: string | undefined;
    point: number | undefined;
    source: string | undefined;
    consumerID: number | undefined;
    lastRankID: number | undefined;
    currentRankID: number | undefined;
    reason: string | undefined;
    description: string | undefined;
    id: number | undefined;
}

export class GetRankHistoryForEditOutput implements IGetRankHistoryForEditOutput {
    rankHistory!: CreateOrEditRankHistoryDto | undefined;

    constructor(data?: IGetRankHistoryForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.rankHistory = data["rankHistory"] ? CreateOrEditRankHistoryDto.fromJS(data["rankHistory"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetRankHistoryForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetRankHistoryForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rankHistory"] = this.rankHistory ? this.rankHistory.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetRankHistoryForEditOutput {
    rankHistory: CreateOrEditRankHistoryDto | undefined;
}

export class CreateOrEditRankHistoryDto implements ICreateOrEditRankHistoryDto {
    memberCode!: string | undefined;
    point!: number | undefined;
    source!: string | undefined;
    consumerID!: number | undefined;
    lastRankID!: number | undefined;
    currentRankID!: number | undefined;
    reason!: string | undefined;
    description!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditRankHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberCode = data["memberCode"];
            this.point = data["point"];
            this.source = data["source"];
            this.consumerID = data["consumerID"];
            this.lastRankID = data["lastRankID"];
            this.currentRankID = data["currentRankID"];
            this.reason = data["reason"];
            this.description = data["description"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditRankHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditRankHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberCode"] = this.memberCode;
        data["point"] = this.point;
        data["source"] = this.source;
        data["consumerID"] = this.consumerID;
        data["lastRankID"] = this.lastRankID;
        data["currentRankID"] = this.currentRankID;
        data["reason"] = this.reason;
        data["description"] = this.description;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditRankHistoryDto {
    memberCode: string | undefined;
    point: number | undefined;
    source: string | undefined;
    consumerID: number | undefined;
    lastRankID: number | undefined;
    currentRankID: number | undefined;
    reason: string | undefined;
    description: string | undefined;
    id: number | undefined;
}

export class GetRankHistoryDtoForView implements IGetRankHistoryDtoForView {
    rankHistory!: RankHistoryQuarter[] | undefined;

    constructor(data?: IGetRankHistoryDtoForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["rankHistory"] && data["rankHistory"].constructor === Array) {
                this.rankHistory = [];
                for (let item of data["rankHistory"])
                    this.rankHistory.push(RankHistoryQuarter.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetRankHistoryDtoForView {
        data = typeof data === 'object' ? data : {};
        let result = new GetRankHistoryDtoForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.rankHistory && this.rankHistory.constructor === Array) {
            data["rankHistory"] = [];
            for (let item of this.rankHistory)
                data["rankHistory"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetRankHistoryDtoForView {
    rankHistory: RankHistoryQuarter[] | undefined;
}

export class RankHistoryQuarter implements IRankHistoryQuarter {
    year!: number | undefined;
    quarter!: number | undefined;
    rankId!: number | undefined;
    rankName!: string | undefined;

    constructor(data?: IRankHistoryQuarter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.year = data["year"];
            this.quarter = data["quarter"];
            this.rankId = data["rankId"];
            this.rankName = data["rankName"];
        }
    }

    static fromJS(data: any): RankHistoryQuarter {
        data = typeof data === 'object' ? data : {};
        let result = new RankHistoryQuarter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        data["quarter"] = this.quarter;
        data["rankId"] = this.rankId;
        data["rankName"] = this.rankName;
        return data;
    }
}

export interface IRankHistoryQuarter {
    year: number | undefined;
    quarter: number | undefined;
    rankId: number | undefined;
    rankName: string | undefined;
}

export class PagedResultDtoOfGetRankForView implements IPagedResultDtoOfGetRankForView {
    totalCount!: number | undefined;
    items!: GetRankForView[] | undefined;

    constructor(data?: IPagedResultDtoOfGetRankForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetRankForView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetRankForView {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetRankForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetRankForView {
    totalCount: number | undefined;
    items: GetRankForView[] | undefined;
}

export class GetRankForView implements IGetRankForView {
    rank!: RankDto | undefined;

    constructor(data?: IGetRankForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.rank = data["rank"] ? RankDto.fromJS(data["rank"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetRankForView {
        data = typeof data === 'object' ? data : {};
        let result = new GetRankForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rank"] = this.rank ? this.rank.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetRankForView {
    rank: RankDto | undefined;
}

export class GetRankForEditOutput implements IGetRankForEditOutput {
    rank!: CreateOrEditRankDto | undefined;
    lastModifierUserName!: string | undefined;

    constructor(data?: IGetRankForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.rank = data["rank"] ? CreateOrEditRankDto.fromJS(data["rank"]) : <any>undefined;
            this.lastModifierUserName = data["lastModifierUserName"];
        }
    }

    static fromJS(data: any): GetRankForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetRankForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rank"] = this.rank ? this.rank.toJSON() : <any>undefined;
        data["lastModifierUserName"] = this.lastModifierUserName;
        return data;
    }
}

export interface IGetRankForEditOutput {
    rank: CreateOrEditRankDto | undefined;
    lastModifierUserName: string | undefined;
}

export class CreateOrEditRankDto implements ICreateOrEditRankDto {
    code!: string;
    name!: string;
    description!: string | undefined;
    avatar!: string | undefined;
    isActive!: boolean | undefined;
    nameUnSign!: string | undefined;
    isDeleted!: boolean | undefined;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: moment.Moment | undefined;
    creatorUserId!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditRankDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.name = data["name"];
            this.description = data["description"];
            this.avatar = data["avatar"];
            this.isActive = data["isActive"];
            this.nameUnSign = data["nameUnSign"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditRankDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditRankDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["description"] = this.description;
        data["avatar"] = this.avatar;
        data["isActive"] = this.isActive;
        data["nameUnSign"] = this.nameUnSign;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditRankDto {
    code: string;
    name: string;
    description: string | undefined;
    avatar: string | undefined;
    isActive: boolean | undefined;
    nameUnSign: string | undefined;
    isDeleted: boolean | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfGetRankSettingForView implements IPagedResultDtoOfGetRankSettingForView {
    totalCount!: number | undefined;
    items!: GetRankSettingForView[] | undefined;

    constructor(data?: IPagedResultDtoOfGetRankSettingForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetRankSettingForView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetRankSettingForView {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetRankSettingForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetRankSettingForView {
    totalCount: number | undefined;
    items: GetRankSettingForView[] | undefined;
}

export class GetRankSettingForView implements IGetRankSettingForView {
    rankSetting!: RankSettingDto | undefined;

    constructor(data?: IGetRankSettingForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.rankSetting = data["rankSetting"] ? RankSettingDto.fromJS(data["rankSetting"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetRankSettingForView {
        data = typeof data === 'object' ? data : {};
        let result = new GetRankSettingForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rankSetting"] = this.rankSetting ? this.rankSetting.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetRankSettingForView {
    rankSetting: RankSettingDto | undefined;
}

export class RankSettingDto implements IRankSettingDto {
    code!: string | undefined;
    name!: string | undefined;
    rankId!: number | undefined;
    rankName!: string | undefined;
    description!: string | undefined;
    pointValue!: number | undefined;
    coinValue!: number | undefined;
    effectiveFrom!: moment.Moment | undefined;
    effectiveTo!: moment.Moment | undefined;
    isActive!: boolean | undefined;
    campaignId!: number | undefined;
    campaignName!: string | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastUpdateByName!: string | undefined;
    lastModifierUserId!: number | undefined;
    id!: number | undefined;

    constructor(data?: IRankSettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.name = data["name"];
            this.rankId = data["rankId"];
            this.rankName = data["rankName"];
            this.description = data["description"];
            this.pointValue = data["pointValue"];
            this.coinValue = data["coinValue"];
            this.effectiveFrom = data["effectiveFrom"] ? moment(data["effectiveFrom"].toString()) : <any>undefined;
            this.effectiveTo = data["effectiveTo"] ? moment(data["effectiveTo"].toString()) : <any>undefined;
            this.isActive = data["isActive"];
            this.campaignId = data["campaignId"];
            this.campaignName = data["campaignName"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastUpdateByName = data["lastUpdateByName"];
            this.lastModifierUserId = data["lastModifierUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): RankSettingDto {
        data = typeof data === 'object' ? data : {};
        let result = new RankSettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["rankId"] = this.rankId;
        data["rankName"] = this.rankName;
        data["description"] = this.description;
        data["pointValue"] = this.pointValue;
        data["coinValue"] = this.coinValue;
        data["effectiveFrom"] = this.effectiveFrom ? this.effectiveFrom.toISOString() : <any>undefined;
        data["effectiveTo"] = this.effectiveTo ? this.effectiveTo.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        data["campaignId"] = this.campaignId;
        data["campaignName"] = this.campaignName;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastUpdateByName"] = this.lastUpdateByName;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IRankSettingDto {
    code: string | undefined;
    name: string | undefined;
    rankId: number | undefined;
    rankName: string | undefined;
    description: string | undefined;
    pointValue: number | undefined;
    coinValue: number | undefined;
    effectiveFrom: moment.Moment | undefined;
    effectiveTo: moment.Moment | undefined;
    isActive: boolean | undefined;
    campaignId: number | undefined;
    campaignName: string | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastUpdateByName: string | undefined;
    lastModifierUserId: number | undefined;
    id: number | undefined;
}

export class GetRankSettingForEditOutput implements IGetRankSettingForEditOutput {
    rankSetting!: CreateOrEditRankSettingDto | undefined;

    constructor(data?: IGetRankSettingForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.rankSetting = data["rankSetting"] ? CreateOrEditRankSettingDto.fromJS(data["rankSetting"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetRankSettingForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetRankSettingForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rankSetting"] = this.rankSetting ? this.rankSetting.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetRankSettingForEditOutput {
    rankSetting: CreateOrEditRankSettingDto | undefined;
}

export class PagedResultDtoOfGetRankTargetForView implements IPagedResultDtoOfGetRankTargetForView {
    totalCount!: number | undefined;
    items!: GetRankTargetForView[] | undefined;

    constructor(data?: IPagedResultDtoOfGetRankTargetForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetRankTargetForView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetRankTargetForView {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetRankTargetForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetRankTargetForView {
    totalCount: number | undefined;
    items: GetRankTargetForView[] | undefined;
}

export class GetRankTargetForView implements IGetRankTargetForView {
    rankTarget!: RankTargetDto | undefined;
    rankName!: string | undefined;
    rankTypeName!: string | undefined;

    constructor(data?: IGetRankTargetForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.rankTarget = data["rankTarget"] ? RankTargetDto.fromJS(data["rankTarget"]) : <any>undefined;
            this.rankName = data["rankName"];
            this.rankTypeName = data["rankTypeName"];
        }
    }

    static fromJS(data: any): GetRankTargetForView {
        data = typeof data === 'object' ? data : {};
        let result = new GetRankTargetForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rankTarget"] = this.rankTarget ? this.rankTarget.toJSON() : <any>undefined;
        data["rankName"] = this.rankName;
        data["rankTypeName"] = this.rankTypeName;
        return data;
    }
}

export interface IGetRankTargetForView {
    rankTarget: RankTargetDto | undefined;
    rankName: string | undefined;
    rankTypeName: string | undefined;
}

export class RankTargetDto implements IRankTargetDto {
    rankId!: number | undefined;
    rankTypeId!: number | undefined;
    target!: number | undefined;
    isActive!: boolean | undefined;
    id!: number | undefined;

    constructor(data?: IRankTargetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.rankId = data["rankId"];
            this.rankTypeId = data["rankTypeId"];
            this.target = data["target"];
            this.isActive = data["isActive"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): RankTargetDto {
        data = typeof data === 'object' ? data : {};
        let result = new RankTargetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rankId"] = this.rankId;
        data["rankTypeId"] = this.rankTypeId;
        data["target"] = this.target;
        data["isActive"] = this.isActive;
        data["id"] = this.id;
        return data;
    }
}

export interface IRankTargetDto {
    rankId: number | undefined;
    rankTypeId: number | undefined;
    target: number | undefined;
    isActive: boolean | undefined;
    id: number | undefined;
}

export class GetRankTargetForEditOutput implements IGetRankTargetForEditOutput {
    rankTarget!: CreateOrEditRankTargetDto | undefined;
    rankName!: string | undefined;
    rankTypeName!: string | undefined;

    constructor(data?: IGetRankTargetForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.rankTarget = data["rankTarget"] ? CreateOrEditRankTargetDto.fromJS(data["rankTarget"]) : <any>undefined;
            this.rankName = data["rankName"];
            this.rankTypeName = data["rankTypeName"];
        }
    }

    static fromJS(data: any): GetRankTargetForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetRankTargetForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rankTarget"] = this.rankTarget ? this.rankTarget.toJSON() : <any>undefined;
        data["rankName"] = this.rankName;
        data["rankTypeName"] = this.rankTypeName;
        return data;
    }
}

export interface IGetRankTargetForEditOutput {
    rankTarget: CreateOrEditRankTargetDto | undefined;
    rankName: string | undefined;
    rankTypeName: string | undefined;
}

export class CreateOrEditRankTargetDto implements ICreateOrEditRankTargetDto {
    target!: number | undefined;
    isActive!: boolean | undefined;
    rankId!: number | undefined;
    rankTypeId!: number | undefined;
    tenantId!: number | undefined;
    isDeleted!: boolean | undefined;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: moment.Moment | undefined;
    creatorUserId!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditRankTargetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.target = data["target"];
            this.isActive = data["isActive"];
            this.rankId = data["rankId"];
            this.rankTypeId = data["rankTypeId"];
            this.tenantId = data["tenantId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditRankTargetDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditRankTargetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["target"] = this.target;
        data["isActive"] = this.isActive;
        data["rankId"] = this.rankId;
        data["rankTypeId"] = this.rankTypeId;
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditRankTargetDto {
    target: number | undefined;
    isActive: boolean | undefined;
    rankId: number | undefined;
    rankTypeId: number | undefined;
    tenantId: number | undefined;
    isDeleted: boolean | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfRankLookupTableDto implements IPagedResultDtoOfRankLookupTableDto {
    totalCount!: number | undefined;
    items!: RankLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfRankLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(RankLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfRankLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfRankLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfRankLookupTableDto {
    totalCount: number | undefined;
    items: RankLookupTableDto[] | undefined;
}

export class RankLookupTableDto implements IRankLookupTableDto {
    id!: number | undefined;
    displayName!: string | undefined;

    constructor(data?: IRankLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): RankLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new RankLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IRankLookupTableDto {
    id: number | undefined;
    displayName: string | undefined;
}

export class PagedResultDtoOfRankTypeLookupTableDto implements IPagedResultDtoOfRankTypeLookupTableDto {
    totalCount!: number | undefined;
    items!: RankTypeLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfRankTypeLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(RankTypeLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfRankTypeLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfRankTypeLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfRankTypeLookupTableDto {
    totalCount: number | undefined;
    items: RankTypeLookupTableDto[] | undefined;
}

export class RankTypeLookupTableDto implements IRankTypeLookupTableDto {
    id!: number | undefined;
    displayName!: string | undefined;

    constructor(data?: IRankTypeLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): RankTypeLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new RankTypeLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IRankTypeLookupTableDto {
    id: number | undefined;
    displayName: string | undefined;
}

export class PagedResultDtoOfGetRankTypeForView implements IPagedResultDtoOfGetRankTypeForView {
    totalCount!: number | undefined;
    items!: GetRankTypeForView[] | undefined;

    constructor(data?: IPagedResultDtoOfGetRankTypeForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetRankTypeForView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetRankTypeForView {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetRankTypeForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetRankTypeForView {
    totalCount: number | undefined;
    items: GetRankTypeForView[] | undefined;
}

export class GetRankTypeForView implements IGetRankTypeForView {
    rankType!: RankTypeDto | undefined;

    constructor(data?: IGetRankTypeForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.rankType = data["rankType"] ? RankTypeDto.fromJS(data["rankType"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetRankTypeForView {
        data = typeof data === 'object' ? data : {};
        let result = new GetRankTypeForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rankType"] = this.rankType ? this.rankType.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetRankTypeForView {
    rankType: RankTypeDto | undefined;
}

export class RankTypeDto implements IRankTypeDto {
    code!: string | undefined;
    name!: string | undefined;
    description!: string | undefined;
    isActive!: boolean | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    lastModifierUserName!: string | undefined;
    departmentLevel1!: string | undefined;
    departmentLevel1Name!: string | undefined;
    saleType!: string | undefined;
    saleTypeName!: string | undefined;
    id!: number | undefined;

    constructor(data?: IRankTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.name = data["name"];
            this.description = data["description"];
            this.isActive = data["isActive"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.lastModifierUserName = data["lastModifierUserName"];
            this.departmentLevel1 = data["departmentLevel1"];
            this.departmentLevel1Name = data["departmentLevel1Name"];
            this.saleType = data["saleType"];
            this.saleTypeName = data["saleTypeName"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): RankTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new RankTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModifierUserName"] = this.lastModifierUserName;
        data["departmentLevel1"] = this.departmentLevel1;
        data["departmentLevel1Name"] = this.departmentLevel1Name;
        data["saleType"] = this.saleType;
        data["saleTypeName"] = this.saleTypeName;
        data["id"] = this.id;
        return data;
    }
}

export interface IRankTypeDto {
    code: string | undefined;
    name: string | undefined;
    description: string | undefined;
    isActive: boolean | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    lastModifierUserName: string | undefined;
    departmentLevel1: string | undefined;
    departmentLevel1Name: string | undefined;
    saleType: string | undefined;
    saleTypeName: string | undefined;
    id: number | undefined;
}

export class GetRankTypeForEditOutput implements IGetRankTypeForEditOutput {
    rankType!: CreateOrEditRankTypeDto | undefined;
    lastModifierUserName!: string | undefined;

    constructor(data?: IGetRankTypeForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.rankType = data["rankType"] ? CreateOrEditRankTypeDto.fromJS(data["rankType"]) : <any>undefined;
            this.lastModifierUserName = data["lastModifierUserName"];
        }
    }

    static fromJS(data: any): GetRankTypeForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetRankTypeForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rankType"] = this.rankType ? this.rankType.toJSON() : <any>undefined;
        data["lastModifierUserName"] = this.lastModifierUserName;
        return data;
    }
}

export interface IGetRankTypeForEditOutput {
    rankType: CreateOrEditRankTypeDto | undefined;
    lastModifierUserName: string | undefined;
}

export class CreateOrEditRankTypeDto implements ICreateOrEditRankTypeDto {
    code!: string;
    name!: string;
    description!: string | undefined;
    isActive!: boolean | undefined;
    departmentLevel1!: string | undefined;
    saleType!: string | undefined;
    rankTargets!: CreateOrEditRankTargetDto[] | undefined;
    isDeleted!: boolean | undefined;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: moment.Moment | undefined;
    creatorUserId!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditRankTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.name = data["name"];
            this.description = data["description"];
            this.isActive = data["isActive"];
            this.departmentLevel1 = data["departmentLevel1"];
            this.saleType = data["saleType"];
            if (data["rankTargets"] && data["rankTargets"].constructor === Array) {
                this.rankTargets = [];
                for (let item of data["rankTargets"])
                    this.rankTargets.push(CreateOrEditRankTargetDto.fromJS(item));
            }
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditRankTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditRankTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["departmentLevel1"] = this.departmentLevel1;
        data["saleType"] = this.saleType;
        if (this.rankTargets && this.rankTargets.constructor === Array) {
            data["rankTargets"] = [];
            for (let item of this.rankTargets)
                data["rankTargets"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditRankTypeDto {
    code: string;
    name: string;
    description: string | undefined;
    isActive: boolean | undefined;
    departmentLevel1: string | undefined;
    saleType: string | undefined;
    rankTargets: CreateOrEditRankTargetDto[] | undefined;
    isDeleted: boolean | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class RanksInfoDto implements IRanksInfoDto {
    rankID!: number | undefined;
    rankName!: string | undefined;
    target!: number | undefined;

    constructor(data?: IRanksInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.rankID = data["rankID"];
            this.rankName = data["rankName"];
            this.target = data["target"];
        }
    }

    static fromJS(data: any): RanksInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new RanksInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rankID"] = this.rankID;
        data["rankName"] = this.rankName;
        data["target"] = this.target;
        return data;
    }
}

export interface IRanksInfoDto {
    rankID: number | undefined;
    rankName: string | undefined;
    target: number | undefined;
}

export class PagedResultDtoOfGetRatingTicketForViewDto implements IPagedResultDtoOfGetRatingTicketForViewDto {
    totalCount!: number | undefined;
    items!: GetRatingTicketForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetRatingTicketForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetRatingTicketForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetRatingTicketForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetRatingTicketForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetRatingTicketForViewDto {
    totalCount: number | undefined;
    items: GetRatingTicketForViewDto[] | undefined;
}

export class GetRatingTicketForViewDto implements IGetRatingTicketForViewDto {
    ratingTicket!: RatingTicketDto | undefined;

    constructor(data?: IGetRatingTicketForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.ratingTicket = data["ratingTicket"] ? RatingTicketDto.fromJS(data["ratingTicket"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetRatingTicketForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetRatingTicketForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ratingTicket"] = this.ratingTicket ? this.ratingTicket.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetRatingTicketForViewDto {
    ratingTicket: RatingTicketDto | undefined;
}

export class RatingTicketDto implements IRatingTicketDto {
    ticketCode!: string | undefined;
    memberCode!: string | undefined;
    memberName!: string | undefined;
    orderCode!: string | undefined;
    submitDate!: moment.Moment | undefined;
    rating!: number | undefined;
    comment!: string | undefined;
    orderAmount!: number | undefined;
    point!: number | undefined;
    memberMobileNumber!: string | undefined;
    id!: number | undefined;

    constructor(data?: IRatingTicketDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.ticketCode = data["ticketCode"];
            this.memberCode = data["memberCode"];
            this.memberName = data["memberName"];
            this.orderCode = data["orderCode"];
            this.submitDate = data["submitDate"] ? moment(data["submitDate"].toString()) : <any>undefined;
            this.rating = data["rating"];
            this.comment = data["comment"];
            this.orderAmount = data["orderAmount"];
            this.point = data["point"];
            this.memberMobileNumber = data["memberMobileNumber"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): RatingTicketDto {
        data = typeof data === 'object' ? data : {};
        let result = new RatingTicketDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ticketCode"] = this.ticketCode;
        data["memberCode"] = this.memberCode;
        data["memberName"] = this.memberName;
        data["orderCode"] = this.orderCode;
        data["submitDate"] = this.submitDate ? this.submitDate.toISOString() : <any>undefined;
        data["rating"] = this.rating;
        data["comment"] = this.comment;
        data["orderAmount"] = this.orderAmount;
        data["point"] = this.point;
        data["memberMobileNumber"] = this.memberMobileNumber;
        data["id"] = this.id;
        return data;
    }
}

export interface IRatingTicketDto {
    ticketCode: string | undefined;
    memberCode: string | undefined;
    memberName: string | undefined;
    orderCode: string | undefined;
    submitDate: moment.Moment | undefined;
    rating: number | undefined;
    comment: string | undefined;
    orderAmount: number | undefined;
    point: number | undefined;
    memberMobileNumber: string | undefined;
    id: number | undefined;
}

export class GetRatingTicketForEditOutput implements IGetRatingTicketForEditOutput {
    ratingTicket!: CreateOrEditRatingTicketDto | undefined;

    constructor(data?: IGetRatingTicketForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.ratingTicket = data["ratingTicket"] ? CreateOrEditRatingTicketDto.fromJS(data["ratingTicket"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetRatingTicketForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetRatingTicketForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ratingTicket"] = this.ratingTicket ? this.ratingTicket.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetRatingTicketForEditOutput {
    ratingTicket: CreateOrEditRatingTicketDto | undefined;
}

export class CreateOrEditRatingTicketDto implements ICreateOrEditRatingTicketDto {
    ticketCode!: string | undefined;
    memberCode!: string | undefined;
    memberName!: string | undefined;
    orderCode!: string | undefined;
    submitDate!: moment.Moment | undefined;
    rating!: number | undefined;
    comment!: string | undefined;
    orderAmount!: number | undefined;
    point!: number | undefined;
    memberMobileNumber!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditRatingTicketDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.ticketCode = data["ticketCode"];
            this.memberCode = data["memberCode"];
            this.memberName = data["memberName"];
            this.orderCode = data["orderCode"];
            this.submitDate = data["submitDate"] ? moment(data["submitDate"].toString()) : <any>undefined;
            this.rating = data["rating"];
            this.comment = data["comment"];
            this.orderAmount = data["orderAmount"];
            this.point = data["point"];
            this.memberMobileNumber = data["memberMobileNumber"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditRatingTicketDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditRatingTicketDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ticketCode"] = this.ticketCode;
        data["memberCode"] = this.memberCode;
        data["memberName"] = this.memberName;
        data["orderCode"] = this.orderCode;
        data["submitDate"] = this.submitDate ? this.submitDate.toISOString() : <any>undefined;
        data["rating"] = this.rating;
        data["comment"] = this.comment;
        data["orderAmount"] = this.orderAmount;
        data["point"] = this.point;
        data["memberMobileNumber"] = this.memberMobileNumber;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditRatingTicketDto {
    ticketCode: string | undefined;
    memberCode: string | undefined;
    memberName: string | undefined;
    orderCode: string | undefined;
    submitDate: moment.Moment | undefined;
    rating: number | undefined;
    comment: string | undefined;
    orderAmount: number | undefined;
    point: number | undefined;
    memberMobileNumber: string | undefined;
    id: number | undefined;
}

export class GetAllRatingTicketsInput implements IGetAllRatingTicketsInput {
    filter!: string | undefined;
    ticketCodeFilter!: string | undefined;
    memberCodeFilter!: string | undefined;
    memberNameFilter!: string | undefined;
    orderCodeFilter!: string | undefined;
    maxSubmitDateFilter!: moment.Moment | undefined;
    minSubmitDateFilter!: moment.Moment | undefined;
    maxRatingFilter!: number | undefined;
    minRatingFilter!: number | undefined;
    commentFilter!: string | undefined;
    maxOrderAmountFilter!: number | undefined;
    minOrderAmountFilter!: number | undefined;
    maxPointFilter!: number | undefined;
    minPointFilter!: number | undefined;
    memberMobileNumberFilter!: string | undefined;
    sorting!: string | undefined;
    skipCount!: number | undefined;
    maxResultCount!: number | undefined;

    constructor(data?: IGetAllRatingTicketsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.filter = data["filter"];
            this.ticketCodeFilter = data["ticketCodeFilter"];
            this.memberCodeFilter = data["memberCodeFilter"];
            this.memberNameFilter = data["memberNameFilter"];
            this.orderCodeFilter = data["orderCodeFilter"];
            this.maxSubmitDateFilter = data["maxSubmitDateFilter"] ? moment(data["maxSubmitDateFilter"].toString()) : <any>undefined;
            this.minSubmitDateFilter = data["minSubmitDateFilter"] ? moment(data["minSubmitDateFilter"].toString()) : <any>undefined;
            this.maxRatingFilter = data["maxRatingFilter"];
            this.minRatingFilter = data["minRatingFilter"];
            this.commentFilter = data["commentFilter"];
            this.maxOrderAmountFilter = data["maxOrderAmountFilter"];
            this.minOrderAmountFilter = data["minOrderAmountFilter"];
            this.maxPointFilter = data["maxPointFilter"];
            this.minPointFilter = data["minPointFilter"];
            this.memberMobileNumberFilter = data["memberMobileNumberFilter"];
            this.sorting = data["sorting"];
            this.skipCount = data["skipCount"];
            this.maxResultCount = data["maxResultCount"];
        }
    }

    static fromJS(data: any): GetAllRatingTicketsInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllRatingTicketsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        data["ticketCodeFilter"] = this.ticketCodeFilter;
        data["memberCodeFilter"] = this.memberCodeFilter;
        data["memberNameFilter"] = this.memberNameFilter;
        data["orderCodeFilter"] = this.orderCodeFilter;
        data["maxSubmitDateFilter"] = this.maxSubmitDateFilter ? this.maxSubmitDateFilter.toISOString() : <any>undefined;
        data["minSubmitDateFilter"] = this.minSubmitDateFilter ? this.minSubmitDateFilter.toISOString() : <any>undefined;
        data["maxRatingFilter"] = this.maxRatingFilter;
        data["minRatingFilter"] = this.minRatingFilter;
        data["commentFilter"] = this.commentFilter;
        data["maxOrderAmountFilter"] = this.maxOrderAmountFilter;
        data["minOrderAmountFilter"] = this.minOrderAmountFilter;
        data["maxPointFilter"] = this.maxPointFilter;
        data["minPointFilter"] = this.minPointFilter;
        data["memberMobileNumberFilter"] = this.memberMobileNumberFilter;
        data["sorting"] = this.sorting;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data;
    }
}

export interface IGetAllRatingTicketsInput {
    filter: string | undefined;
    ticketCodeFilter: string | undefined;
    memberCodeFilter: string | undefined;
    memberNameFilter: string | undefined;
    orderCodeFilter: string | undefined;
    maxSubmitDateFilter: moment.Moment | undefined;
    minSubmitDateFilter: moment.Moment | undefined;
    maxRatingFilter: number | undefined;
    minRatingFilter: number | undefined;
    commentFilter: string | undefined;
    maxOrderAmountFilter: number | undefined;
    minOrderAmountFilter: number | undefined;
    maxPointFilter: number | undefined;
    minPointFilter: number | undefined;
    memberMobileNumberFilter: string | undefined;
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;
}

export class PagedResultDtoOfGetReasonSettingForView implements IPagedResultDtoOfGetReasonSettingForView {
    totalCount!: number | undefined;
    items!: GetReasonSettingForView[] | undefined;

    constructor(data?: IPagedResultDtoOfGetReasonSettingForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetReasonSettingForView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetReasonSettingForView {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetReasonSettingForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetReasonSettingForView {
    totalCount: number | undefined;
    items: GetReasonSettingForView[] | undefined;
}

export class GetReasonSettingForView implements IGetReasonSettingForView {
    reasonSetting!: ReasonSettingDto | undefined;

    constructor(data?: IGetReasonSettingForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.reasonSetting = data["reasonSetting"] ? ReasonSettingDto.fromJS(data["reasonSetting"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetReasonSettingForView {
        data = typeof data === 'object' ? data : {};
        let result = new GetReasonSettingForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reasonSetting"] = this.reasonSetting ? this.reasonSetting.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetReasonSettingForView {
    reasonSetting: ReasonSettingDto | undefined;
}

export class ReasonSettingDto implements IReasonSettingDto {
    code!: string | undefined;
    name!: string | undefined;
    description!: string | undefined;
    isActive!: boolean | undefined;
    defaultPoint!: number | undefined;
    defaultCoin!: number | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastUpdateByName!: string | undefined;
    lastModifierUserId!: number | undefined;
    id!: number | undefined;

    constructor(data?: IReasonSettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.name = data["name"];
            this.description = data["description"];
            this.isActive = data["isActive"];
            this.defaultPoint = data["defaultPoint"];
            this.defaultCoin = data["defaultCoin"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastUpdateByName = data["lastUpdateByName"];
            this.lastModifierUserId = data["lastModifierUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ReasonSettingDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReasonSettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["defaultPoint"] = this.defaultPoint;
        data["defaultCoin"] = this.defaultCoin;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastUpdateByName"] = this.lastUpdateByName;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IReasonSettingDto {
    code: string | undefined;
    name: string | undefined;
    description: string | undefined;
    isActive: boolean | undefined;
    defaultPoint: number | undefined;
    defaultCoin: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastUpdateByName: string | undefined;
    lastModifierUserId: number | undefined;
    id: number | undefined;
}

export class CreateOrEditReasonSettingDto implements ICreateOrEditReasonSettingDto {
    code!: string;
    name!: string;
    description!: string | undefined;
    isActive!: boolean | undefined;
    defaultPoint!: number | undefined;
    defaultCoin!: number | undefined;
    lastUpdateByName!: string | undefined;
    isSystemReason!: boolean | undefined;
    isDeleted!: boolean | undefined;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: moment.Moment | undefined;
    creatorUserId!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditReasonSettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.name = data["name"];
            this.description = data["description"];
            this.isActive = data["isActive"];
            this.defaultPoint = data["defaultPoint"];
            this.defaultCoin = data["defaultCoin"];
            this.lastUpdateByName = data["lastUpdateByName"];
            this.isSystemReason = data["isSystemReason"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditReasonSettingDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditReasonSettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["defaultPoint"] = this.defaultPoint;
        data["defaultCoin"] = this.defaultCoin;
        data["lastUpdateByName"] = this.lastUpdateByName;
        data["isSystemReason"] = this.isSystemReason;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditReasonSettingDto {
    code: string;
    name: string;
    description: string | undefined;
    isActive: boolean | undefined;
    defaultPoint: number | undefined;
    defaultCoin: number | undefined;
    lastUpdateByName: string | undefined;
    isSystemReason: boolean | undefined;
    isDeleted: boolean | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class GetReasonSettingForEditOutput implements IGetReasonSettingForEditOutput {
    reasonSetting!: CreateOrEditReasonSettingDto | undefined;

    constructor(data?: IGetReasonSettingForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.reasonSetting = data["reasonSetting"] ? CreateOrEditReasonSettingDto.fromJS(data["reasonSetting"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetReasonSettingForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetReasonSettingForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reasonSetting"] = this.reasonSetting ? this.reasonSetting.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetReasonSettingForEditOutput {
    reasonSetting: CreateOrEditReasonSettingDto | undefined;
}

export class RedemptionOverViewHeaderDto implements IRedemptionOverViewHeaderDto {
    reasonName!: string | undefined;
    details!: RedemptionOverviewDetailDto[] | undefined;

    constructor(data?: IRedemptionOverViewHeaderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.reasonName = data["reasonName"];
            if (data["details"] && data["details"].constructor === Array) {
                this.details = [];
                for (let item of data["details"])
                    this.details.push(RedemptionOverviewDetailDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RedemptionOverViewHeaderDto {
        data = typeof data === 'object' ? data : {};
        let result = new RedemptionOverViewHeaderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reasonName"] = this.reasonName;
        if (this.details && this.details.constructor === Array) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRedemptionOverViewHeaderDto {
    reasonName: string | undefined;
    details: RedemptionOverviewDetailDto[] | undefined;
}

export class RedemptionOverviewDetailDto implements IRedemptionOverviewDetailDto {
    labelColX!: string | undefined;
    coin!: number | undefined;

    constructor(data?: IRedemptionOverviewDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.labelColX = data["labelColX"];
            this.coin = data["coin"];
        }
    }

    static fromJS(data: any): RedemptionOverviewDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new RedemptionOverviewDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["labelColX"] = this.labelColX;
        data["coin"] = this.coin;
        return data;
    }
}

export interface IRedemptionOverviewDetailDto {
    labelColX: string | undefined;
    coin: number | undefined;
}

export class PagedResultDtoOfRedemptionRequestResource implements IPagedResultDtoOfRedemptionRequestResource {
    totalCount!: number | undefined;
    items!: RedemptionRequestResource[] | undefined;

    constructor(data?: IPagedResultDtoOfRedemptionRequestResource) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(RedemptionRequestResource.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfRedemptionRequestResource {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfRedemptionRequestResource();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfRedemptionRequestResource {
    totalCount: number | undefined;
    items: RedemptionRequestResource[] | undefined;
}

export class RedemptionRequestResource implements IRedemptionRequestResource {
    id!: number | undefined;
    campaignId!: number | undefined;
    campaignName!: string | undefined;
    campaignCode!: string | undefined;
    memberCode!: string | undefined;
    status!: string | undefined;
    requestDate!: moment.Moment | undefined;
    approvedBy!: number | undefined;
    approvedDate!: moment.Moment | undefined;
    note!: string | undefined;
    outletName!: string | undefined;

    constructor(data?: IRedemptionRequestResource) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.campaignId = data["campaignId"];
            this.campaignName = data["campaignName"];
            this.campaignCode = data["campaignCode"];
            this.memberCode = data["memberCode"];
            this.status = data["status"];
            this.requestDate = data["requestDate"] ? moment(data["requestDate"].toString()) : <any>undefined;
            this.approvedBy = data["approvedBy"];
            this.approvedDate = data["approvedDate"] ? moment(data["approvedDate"].toString()) : <any>undefined;
            this.note = data["note"];
            this.outletName = data["outletName"];
        }
    }

    static fromJS(data: any): RedemptionRequestResource {
        data = typeof data === 'object' ? data : {};
        let result = new RedemptionRequestResource();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["campaignId"] = this.campaignId;
        data["campaignName"] = this.campaignName;
        data["campaignCode"] = this.campaignCode;
        data["memberCode"] = this.memberCode;
        data["status"] = this.status;
        data["requestDate"] = this.requestDate ? this.requestDate.toISOString() : <any>undefined;
        data["approvedBy"] = this.approvedBy;
        data["approvedDate"] = this.approvedDate ? this.approvedDate.toISOString() : <any>undefined;
        data["note"] = this.note;
        data["outletName"] = this.outletName;
        return data;
    }
}

export interface IRedemptionRequestResource {
    id: number | undefined;
    campaignId: number | undefined;
    campaignName: string | undefined;
    campaignCode: string | undefined;
    memberCode: string | undefined;
    status: string | undefined;
    requestDate: moment.Moment | undefined;
    approvedBy: number | undefined;
    approvedDate: moment.Moment | undefined;
    note: string | undefined;
    outletName: string | undefined;
}

export class RedemptionRequestUpdateStatus implements IRedemptionRequestUpdateStatus {
    id!: number | undefined;
    status!: string | undefined;

    constructor(data?: IRedemptionRequestUpdateStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.status = data["status"];
        }
    }

    static fromJS(data: any): RedemptionRequestUpdateStatus {
        data = typeof data === 'object' ? data : {};
        let result = new RedemptionRequestUpdateStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        return data;
    }
}

export interface IRedemptionRequestUpdateStatus {
    id: number | undefined;
    status: string | undefined;
}

export class RedemptionItemResource implements IRedemptionItemResource {
    id!: number | undefined;
    requestId!: number | undefined;
    rewardId!: number | undefined;
    rewardCode!: string | undefined;
    rewardName!: string | undefined;
    quantity!: number | undefined;
    toTalQuantityUsed!: number | undefined;
    uom!: string | undefined;
    status!: string | undefined;
    usedDate!: moment.Moment | undefined;
    rewardType!: string | undefined;
    pointCost!: number | undefined;
    imageUrl!: string | undefined;
    monetaryValue!: number | undefined;

    constructor(data?: IRedemptionItemResource) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.requestId = data["requestId"];
            this.rewardId = data["rewardId"];
            this.rewardCode = data["rewardCode"];
            this.rewardName = data["rewardName"];
            this.quantity = data["quantity"];
            this.toTalQuantityUsed = data["toTalQuantityUsed"];
            this.uom = data["uom"];
            this.status = data["status"];
            this.usedDate = data["usedDate"] ? moment(data["usedDate"].toString()) : <any>undefined;
            this.rewardType = data["rewardType"];
            this.pointCost = data["pointCost"];
            this.imageUrl = data["imageUrl"];
            this.monetaryValue = data["monetaryValue"];
        }
    }

    static fromJS(data: any): RedemptionItemResource {
        data = typeof data === 'object' ? data : {};
        let result = new RedemptionItemResource();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["requestId"] = this.requestId;
        data["rewardId"] = this.rewardId;
        data["rewardCode"] = this.rewardCode;
        data["rewardName"] = this.rewardName;
        data["quantity"] = this.quantity;
        data["toTalQuantityUsed"] = this.toTalQuantityUsed;
        data["uom"] = this.uom;
        data["status"] = this.status;
        data["usedDate"] = this.usedDate ? this.usedDate.toISOString() : <any>undefined;
        data["rewardType"] = this.rewardType;
        data["pointCost"] = this.pointCost;
        data["imageUrl"] = this.imageUrl;
        data["monetaryValue"] = this.monetaryValue;
        return data;
    }
}

export interface IRedemptionItemResource {
    id: number | undefined;
    requestId: number | undefined;
    rewardId: number | undefined;
    rewardCode: string | undefined;
    rewardName: string | undefined;
    quantity: number | undefined;
    toTalQuantityUsed: number | undefined;
    uom: string | undefined;
    status: string | undefined;
    usedDate: moment.Moment | undefined;
    rewardType: string | undefined;
    pointCost: number | undefined;
    imageUrl: string | undefined;
    monetaryValue: number | undefined;
}

export class PagedResultDtoOfGetReferralBaseLineForView implements IPagedResultDtoOfGetReferralBaseLineForView {
    totalCount!: number | undefined;
    items!: GetReferralBaseLineForView[] | undefined;

    constructor(data?: IPagedResultDtoOfGetReferralBaseLineForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetReferralBaseLineForView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetReferralBaseLineForView {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetReferralBaseLineForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetReferralBaseLineForView {
    totalCount: number | undefined;
    items: GetReferralBaseLineForView[] | undefined;
}

export class GetReferralBaseLineForView implements IGetReferralBaseLineForView {
    referralBaseLine!: ReferralBaseLineDto | undefined;
    campaignName!: string | undefined;
    referralReferralName!: string | undefined;

    constructor(data?: IGetReferralBaseLineForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.referralBaseLine = data["referralBaseLine"] ? ReferralBaseLineDto.fromJS(data["referralBaseLine"]) : <any>undefined;
            this.campaignName = data["campaignName"];
            this.referralReferralName = data["referralReferralName"];
        }
    }

    static fromJS(data: any): GetReferralBaseLineForView {
        data = typeof data === 'object' ? data : {};
        let result = new GetReferralBaseLineForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["referralBaseLine"] = this.referralBaseLine ? this.referralBaseLine.toJSON() : <any>undefined;
        data["campaignName"] = this.campaignName;
        data["referralReferralName"] = this.referralReferralName;
        return data;
    }
}

export interface IGetReferralBaseLineForView {
    referralBaseLine: ReferralBaseLineDto | undefined;
    campaignName: string | undefined;
    referralReferralName: string | undefined;
}

export class ReferralBaseLineDto implements IReferralBaseLineDto {
    memberCode!: string | undefined;
    referralSettingCode!: string | undefined;
    refMemberCode!: string | undefined;
    type!: string | undefined;
    tempCoin!: number | undefined;
    tempPoint!: number | undefined;
    referralDate!: moment.Moment | undefined;
    referralExpiredDate!: moment.Moment | undefined;
    isAvailable!: boolean | undefined;
    campaignId!: number | undefined;
    id!: number | undefined;

    constructor(data?: IReferralBaseLineDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberCode = data["memberCode"];
            this.referralSettingCode = data["referralSettingCode"];
            this.refMemberCode = data["refMemberCode"];
            this.type = data["type"];
            this.tempCoin = data["tempCoin"];
            this.tempPoint = data["tempPoint"];
            this.referralDate = data["referralDate"] ? moment(data["referralDate"].toString()) : <any>undefined;
            this.referralExpiredDate = data["referralExpiredDate"] ? moment(data["referralExpiredDate"].toString()) : <any>undefined;
            this.isAvailable = data["isAvailable"];
            this.campaignId = data["campaignId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ReferralBaseLineDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReferralBaseLineDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberCode"] = this.memberCode;
        data["referralSettingCode"] = this.referralSettingCode;
        data["refMemberCode"] = this.refMemberCode;
        data["type"] = this.type;
        data["tempCoin"] = this.tempCoin;
        data["tempPoint"] = this.tempPoint;
        data["referralDate"] = this.referralDate ? this.referralDate.toISOString() : <any>undefined;
        data["referralExpiredDate"] = this.referralExpiredDate ? this.referralExpiredDate.toISOString() : <any>undefined;
        data["isAvailable"] = this.isAvailable;
        data["campaignId"] = this.campaignId;
        data["id"] = this.id;
        return data;
    }
}

export interface IReferralBaseLineDto {
    memberCode: string | undefined;
    referralSettingCode: string | undefined;
    refMemberCode: string | undefined;
    type: string | undefined;
    tempCoin: number | undefined;
    tempPoint: number | undefined;
    referralDate: moment.Moment | undefined;
    referralExpiredDate: moment.Moment | undefined;
    isAvailable: boolean | undefined;
    campaignId: number | undefined;
    id: number | undefined;
}

export class GetReferralBaseLineForEditOutput implements IGetReferralBaseLineForEditOutput {
    referralBaseLine!: CreateOrEditReferralBaseLineDto | undefined;
    campaignName!: string | undefined;
    referralReferralName!: string | undefined;

    constructor(data?: IGetReferralBaseLineForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.referralBaseLine = data["referralBaseLine"] ? CreateOrEditReferralBaseLineDto.fromJS(data["referralBaseLine"]) : <any>undefined;
            this.campaignName = data["campaignName"];
            this.referralReferralName = data["referralReferralName"];
        }
    }

    static fromJS(data: any): GetReferralBaseLineForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetReferralBaseLineForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["referralBaseLine"] = this.referralBaseLine ? this.referralBaseLine.toJSON() : <any>undefined;
        data["campaignName"] = this.campaignName;
        data["referralReferralName"] = this.referralReferralName;
        return data;
    }
}

export interface IGetReferralBaseLineForEditOutput {
    referralBaseLine: CreateOrEditReferralBaseLineDto | undefined;
    campaignName: string | undefined;
    referralReferralName: string | undefined;
}

export class CreateOrEditReferralBaseLineDto implements ICreateOrEditReferralBaseLineDto {
    memberCode!: string | undefined;
    code!: string | undefined;
    refMemberCode!: string | undefined;
    referralSettingCode!: string | undefined;
    type!: string | undefined;
    tempCoin!: number | undefined;
    tempPoint!: number | undefined;
    referralDate!: moment.Moment | undefined;
    referralExpiredDate!: moment.Moment | undefined;
    isAvailable!: boolean | undefined;
    campaignId!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditReferralBaseLineDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberCode = data["memberCode"];
            this.code = data["code"];
            this.refMemberCode = data["refMemberCode"];
            this.referralSettingCode = data["referralSettingCode"];
            this.type = data["type"];
            this.tempCoin = data["tempCoin"];
            this.tempPoint = data["tempPoint"];
            this.referralDate = data["referralDate"] ? moment(data["referralDate"].toString()) : <any>undefined;
            this.referralExpiredDate = data["referralExpiredDate"] ? moment(data["referralExpiredDate"].toString()) : <any>undefined;
            this.isAvailable = data["isAvailable"];
            this.campaignId = data["campaignId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditReferralBaseLineDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditReferralBaseLineDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberCode"] = this.memberCode;
        data["code"] = this.code;
        data["refMemberCode"] = this.refMemberCode;
        data["referralSettingCode"] = this.referralSettingCode;
        data["type"] = this.type;
        data["tempCoin"] = this.tempCoin;
        data["tempPoint"] = this.tempPoint;
        data["referralDate"] = this.referralDate ? this.referralDate.toISOString() : <any>undefined;
        data["referralExpiredDate"] = this.referralExpiredDate ? this.referralExpiredDate.toISOString() : <any>undefined;
        data["isAvailable"] = this.isAvailable;
        data["campaignId"] = this.campaignId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditReferralBaseLineDto {
    memberCode: string | undefined;
    code: string | undefined;
    refMemberCode: string | undefined;
    referralSettingCode: string | undefined;
    type: string | undefined;
    tempCoin: number | undefined;
    tempPoint: number | undefined;
    referralDate: moment.Moment | undefined;
    referralExpiredDate: moment.Moment | undefined;
    isAvailable: boolean | undefined;
    campaignId: number | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfReferralLookupTableDto implements IPagedResultDtoOfReferralLookupTableDto {
    totalCount!: number | undefined;
    items!: ReferralLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfReferralLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(ReferralLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfReferralLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfReferralLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfReferralLookupTableDto {
    totalCount: number | undefined;
    items: ReferralLookupTableDto[] | undefined;
}

export class ReferralLookupTableDto implements IReferralLookupTableDto {
    id!: number | undefined;
    displayName!: string | undefined;

    constructor(data?: IReferralLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): ReferralLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReferralLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IReferralLookupTableDto {
    id: number | undefined;
    displayName: string | undefined;
}

export class GetReferralSettingsForReferrerInputDto implements IGetReferralSettingsForReferrerInputDto {
    memberCode!: string | undefined;
    currentDate!: string | undefined;

    constructor(data?: IGetReferralSettingsForReferrerInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberCode = data["memberCode"];
            this.currentDate = data["currentDate"];
        }
    }

    static fromJS(data: any): GetReferralSettingsForReferrerInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetReferralSettingsForReferrerInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberCode"] = this.memberCode;
        data["currentDate"] = this.currentDate;
        return data;
    }
}

export interface IGetReferralSettingsForReferrerInputDto {
    memberCode: string | undefined;
    currentDate: string | undefined;
}

export class PagedResultDtoOfGetReferralForReferrer implements IPagedResultDtoOfGetReferralForReferrer {
    totalCount!: number | undefined;
    items!: GetReferralForReferrer[] | undefined;

    constructor(data?: IPagedResultDtoOfGetReferralForReferrer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetReferralForReferrer.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetReferralForReferrer {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetReferralForReferrer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetReferralForReferrer {
    totalCount: number | undefined;
    items: GetReferralForReferrer[] | undefined;
}

export class GetReferralForReferrer implements IGetReferralForReferrer {
    code!: string | undefined;
    name!: string | undefined;
    effectiveFrom!: moment.Moment | undefined;
    effectiveTo!: moment.Moment | undefined;
    description!: string | undefined;
    expiredDays!: number | undefined;
    orderAmountRequired!: number | undefined;

    constructor(data?: IGetReferralForReferrer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.name = data["name"];
            this.effectiveFrom = data["effectiveFrom"] ? moment(data["effectiveFrom"].toString()) : <any>undefined;
            this.effectiveTo = data["effectiveTo"] ? moment(data["effectiveTo"].toString()) : <any>undefined;
            this.description = data["description"];
            this.expiredDays = data["expiredDays"];
            this.orderAmountRequired = data["orderAmountRequired"];
        }
    }

    static fromJS(data: any): GetReferralForReferrer {
        data = typeof data === 'object' ? data : {};
        let result = new GetReferralForReferrer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["effectiveFrom"] = this.effectiveFrom ? this.effectiveFrom.toISOString() : <any>undefined;
        data["effectiveTo"] = this.effectiveTo ? this.effectiveTo.toISOString() : <any>undefined;
        data["description"] = this.description;
        data["expiredDays"] = this.expiredDays;
        data["orderAmountRequired"] = this.orderAmountRequired;
        return data;
    }
}

export interface IGetReferralForReferrer {
    code: string | undefined;
    name: string | undefined;
    effectiveFrom: moment.Moment | undefined;
    effectiveTo: moment.Moment | undefined;
    description: string | undefined;
    expiredDays: number | undefined;
    orderAmountRequired: number | undefined;
}

export class VerifyReferralSettingCodeInput implements IVerifyReferralSettingCodeInput {
    memberCode!: string | undefined;
    referralCode!: string | undefined;
    referralDate!: string | undefined;
    referralSettingCode!: string | undefined;

    constructor(data?: IVerifyReferralSettingCodeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberCode = data["memberCode"];
            this.referralCode = data["referralCode"];
            this.referralDate = data["referralDate"];
            this.referralSettingCode = data["referralSettingCode"];
        }
    }

    static fromJS(data: any): VerifyReferralSettingCodeInput {
        data = typeof data === 'object' ? data : {};
        let result = new VerifyReferralSettingCodeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberCode"] = this.memberCode;
        data["referralCode"] = this.referralCode;
        data["referralDate"] = this.referralDate;
        data["referralSettingCode"] = this.referralSettingCode;
        return data;
    }
}

export interface IVerifyReferralSettingCodeInput {
    memberCode: string | undefined;
    referralCode: string | undefined;
    referralDate: string | undefined;
    referralSettingCode: string | undefined;
}

export class GetReferralInfosForView implements IGetReferralInfosForView {
    referree!: VerifyRefer | undefined;
    referrer!: VerifyRefer | undefined;

    constructor(data?: IGetReferralInfosForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.referree = data["referree"] ? VerifyRefer.fromJS(data["referree"]) : <any>undefined;
            this.referrer = data["referrer"] ? VerifyRefer.fromJS(data["referrer"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetReferralInfosForView {
        data = typeof data === 'object' ? data : {};
        let result = new GetReferralInfosForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["referree"] = this.referree ? this.referree.toJSON() : <any>undefined;
        data["referrer"] = this.referrer ? this.referrer.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetReferralInfosForView {
    referree: VerifyRefer | undefined;
    referrer: VerifyRefer | undefined;
}

export class VerifyRefer implements IVerifyRefer {
    memberCode!: string | undefined;
    tempPoint!: number | undefined;
    tempCoin!: number | undefined;

    constructor(data?: IVerifyRefer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberCode = data["memberCode"];
            this.tempPoint = data["tempPoint"];
            this.tempCoin = data["tempCoin"];
        }
    }

    static fromJS(data: any): VerifyRefer {
        data = typeof data === 'object' ? data : {};
        let result = new VerifyRefer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberCode"] = this.memberCode;
        data["tempPoint"] = this.tempPoint;
        data["tempCoin"] = this.tempCoin;
        return data;
    }
}

export interface IVerifyRefer {
    memberCode: string | undefined;
    tempPoint: number | undefined;
    tempCoin: number | undefined;
}

export class PagedResultDtoOfGetReferralForView implements IPagedResultDtoOfGetReferralForView {
    totalCount!: number | undefined;
    items!: GetReferralForView[] | undefined;

    constructor(data?: IPagedResultDtoOfGetReferralForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetReferralForView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetReferralForView {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetReferralForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetReferralForView {
    totalCount: number | undefined;
    items: GetReferralForView[] | undefined;
}

export class GetReferralForView implements IGetReferralForView {
    referral!: ReferralDto | undefined;
    campaignName!: string | undefined;

    constructor(data?: IGetReferralForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.referral = data["referral"] ? ReferralDto.fromJS(data["referral"]) : <any>undefined;
            this.campaignName = data["campaignName"];
        }
    }

    static fromJS(data: any): GetReferralForView {
        data = typeof data === 'object' ? data : {};
        let result = new GetReferralForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["referral"] = this.referral ? this.referral.toJSON() : <any>undefined;
        data["campaignName"] = this.campaignName;
        return data;
    }
}

export interface IGetReferralForView {
    referral: ReferralDto | undefined;
    campaignName: string | undefined;
}

export class ReferralDto implements IReferralDto {
    name!: string | undefined;
    code!: string | undefined;
    effectiveFrom!: moment.Moment | undefined;
    effectiveTo!: moment.Moment | undefined;
    description!: string | undefined;
    status!: string | undefined;
    expiredDays!: number | undefined;
    orderAmountRequired!: number | undefined;
    maxSet!: number | undefined;
    referrerPoint!: number | undefined;
    referrerCoin!: number | undefined;
    refereePoint!: number | undefined;
    refereeCoin!: number | undefined;
    referrerTargetAudienceId!: string | undefined;
    refereeTargetAudienceId!: string | undefined;
    campaignId!: number | undefined;
    referrerTargetAudience!: SettingParamDto | undefined;
    refereeTargetAudience!: SettingParamDto | undefined;
    id!: number | undefined;

    constructor(data?: IReferralDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.code = data["code"];
            this.effectiveFrom = data["effectiveFrom"] ? moment(data["effectiveFrom"].toString()) : <any>undefined;
            this.effectiveTo = data["effectiveTo"] ? moment(data["effectiveTo"].toString()) : <any>undefined;
            this.description = data["description"];
            this.status = data["status"];
            this.expiredDays = data["expiredDays"];
            this.orderAmountRequired = data["orderAmountRequired"];
            this.maxSet = data["maxSet"];
            this.referrerPoint = data["referrerPoint"];
            this.referrerCoin = data["referrerCoin"];
            this.refereePoint = data["refereePoint"];
            this.refereeCoin = data["refereeCoin"];
            this.referrerTargetAudienceId = data["referrerTargetAudienceId"];
            this.refereeTargetAudienceId = data["refereeTargetAudienceId"];
            this.campaignId = data["campaignId"];
            this.referrerTargetAudience = data["referrerTargetAudience"] ? SettingParamDto.fromJS(data["referrerTargetAudience"]) : <any>undefined;
            this.refereeTargetAudience = data["refereeTargetAudience"] ? SettingParamDto.fromJS(data["refereeTargetAudience"]) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ReferralDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReferralDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["code"] = this.code;
        data["effectiveFrom"] = this.effectiveFrom ? this.effectiveFrom.toISOString() : <any>undefined;
        data["effectiveTo"] = this.effectiveTo ? this.effectiveTo.toISOString() : <any>undefined;
        data["description"] = this.description;
        data["status"] = this.status;
        data["expiredDays"] = this.expiredDays;
        data["orderAmountRequired"] = this.orderAmountRequired;
        data["maxSet"] = this.maxSet;
        data["referrerPoint"] = this.referrerPoint;
        data["referrerCoin"] = this.referrerCoin;
        data["refereePoint"] = this.refereePoint;
        data["refereeCoin"] = this.refereeCoin;
        data["referrerTargetAudienceId"] = this.referrerTargetAudienceId;
        data["refereeTargetAudienceId"] = this.refereeTargetAudienceId;
        data["campaignId"] = this.campaignId;
        data["referrerTargetAudience"] = this.referrerTargetAudience ? this.referrerTargetAudience.toJSON() : <any>undefined;
        data["refereeTargetAudience"] = this.refereeTargetAudience ? this.refereeTargetAudience.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IReferralDto {
    name: string | undefined;
    code: string | undefined;
    effectiveFrom: moment.Moment | undefined;
    effectiveTo: moment.Moment | undefined;
    description: string | undefined;
    status: string | undefined;
    expiredDays: number | undefined;
    orderAmountRequired: number | undefined;
    maxSet: number | undefined;
    referrerPoint: number | undefined;
    referrerCoin: number | undefined;
    refereePoint: number | undefined;
    refereeCoin: number | undefined;
    referrerTargetAudienceId: string | undefined;
    refereeTargetAudienceId: string | undefined;
    campaignId: number | undefined;
    referrerTargetAudience: SettingParamDto | undefined;
    refereeTargetAudience: SettingParamDto | undefined;
    id: number | undefined;
}

export class GetReferralForEditOutput implements IGetReferralForEditOutput {
    referral!: CreateOrEditReferralDto | undefined;
    campaignName!: string | undefined;

    constructor(data?: IGetReferralForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.referral = data["referral"] ? CreateOrEditReferralDto.fromJS(data["referral"]) : <any>undefined;
            this.campaignName = data["campaignName"];
        }
    }

    static fromJS(data: any): GetReferralForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetReferralForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["referral"] = this.referral ? this.referral.toJSON() : <any>undefined;
        data["campaignName"] = this.campaignName;
        return data;
    }
}

export interface IGetReferralForEditOutput {
    referral: CreateOrEditReferralDto | undefined;
    campaignName: string | undefined;
}

export class PagedResultDtoOfGetReferralTransactionForViewDto implements IPagedResultDtoOfGetReferralTransactionForViewDto {
    totalCount!: number | undefined;
    items!: GetReferralTransactionForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetReferralTransactionForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetReferralTransactionForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetReferralTransactionForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetReferralTransactionForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetReferralTransactionForViewDto {
    totalCount: number | undefined;
    items: GetReferralTransactionForViewDto[] | undefined;
}

export class GetReferralTransactionForViewDto implements IGetReferralTransactionForViewDto {
    referralTransaction!: ReferralTransactionDto | undefined;

    constructor(data?: IGetReferralTransactionForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.referralTransaction = data["referralTransaction"] ? ReferralTransactionDto.fromJS(data["referralTransaction"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetReferralTransactionForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetReferralTransactionForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["referralTransaction"] = this.referralTransaction ? this.referralTransaction.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetReferralTransactionForViewDto {
    referralTransaction: ReferralTransactionDto | undefined;
}

export class ReferralTransactionDto implements IReferralTransactionDto {
    transactionCode!: string | undefined;
    referralUser!: string | undefined;
    referalCode!: string | undefined;
    referalTime!: moment.Moment | undefined;
    voucherGroupCode!: string | undefined;
    isGranted!: boolean | undefined;
    id!: number | undefined;

    constructor(data?: IReferralTransactionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.transactionCode = data["transactionCode"];
            this.referralUser = data["referralUser"];
            this.referalCode = data["referalCode"];
            this.referalTime = data["referalTime"] ? moment(data["referalTime"].toString()) : <any>undefined;
            this.voucherGroupCode = data["voucherGroupCode"];
            this.isGranted = data["isGranted"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ReferralTransactionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReferralTransactionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionCode"] = this.transactionCode;
        data["referralUser"] = this.referralUser;
        data["referalCode"] = this.referalCode;
        data["referalTime"] = this.referalTime ? this.referalTime.toISOString() : <any>undefined;
        data["voucherGroupCode"] = this.voucherGroupCode;
        data["isGranted"] = this.isGranted;
        data["id"] = this.id;
        return data;
    }
}

export interface IReferralTransactionDto {
    transactionCode: string | undefined;
    referralUser: string | undefined;
    referalCode: string | undefined;
    referalTime: moment.Moment | undefined;
    voucherGroupCode: string | undefined;
    isGranted: boolean | undefined;
    id: number | undefined;
}

export class GetReferralTransactionForEditOutput implements IGetReferralTransactionForEditOutput {
    referralTransaction!: CreateOrEditReferralTransactionDto | undefined;

    constructor(data?: IGetReferralTransactionForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.referralTransaction = data["referralTransaction"] ? CreateOrEditReferralTransactionDto.fromJS(data["referralTransaction"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetReferralTransactionForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetReferralTransactionForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["referralTransaction"] = this.referralTransaction ? this.referralTransaction.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetReferralTransactionForEditOutput {
    referralTransaction: CreateOrEditReferralTransactionDto | undefined;
}

export class CreateOrEditReferralTransactionDto implements ICreateOrEditReferralTransactionDto {
    transactionCode!: string | undefined;
    referralUser!: string | undefined;
    referalCode!: string | undefined;
    referalTime!: moment.Moment | undefined;
    voucherGroupCode!: string | undefined;
    isGranted!: boolean | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditReferralTransactionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.transactionCode = data["transactionCode"];
            this.referralUser = data["referralUser"];
            this.referalCode = data["referalCode"];
            this.referalTime = data["referalTime"] ? moment(data["referalTime"].toString()) : <any>undefined;
            this.voucherGroupCode = data["voucherGroupCode"];
            this.isGranted = data["isGranted"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditReferralTransactionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditReferralTransactionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionCode"] = this.transactionCode;
        data["referralUser"] = this.referralUser;
        data["referalCode"] = this.referalCode;
        data["referalTime"] = this.referalTime ? this.referalTime.toISOString() : <any>undefined;
        data["voucherGroupCode"] = this.voucherGroupCode;
        data["isGranted"] = this.isGranted;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditReferralTransactionDto {
    transactionCode: string | undefined;
    referralUser: string | undefined;
    referalCode: string | undefined;
    referalTime: moment.Moment | undefined;
    voucherGroupCode: string | undefined;
    isGranted: boolean | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfGetRegionForView implements IPagedResultDtoOfGetRegionForView {
    totalCount!: number | undefined;
    items!: GetRegionForView[] | undefined;

    constructor(data?: IPagedResultDtoOfGetRegionForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetRegionForView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetRegionForView {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetRegionForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetRegionForView {
    totalCount: number | undefined;
    items: GetRegionForView[] | undefined;
}

export class GetRegionForView implements IGetRegionForView {
    region!: RegionDto | undefined;

    constructor(data?: IGetRegionForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.region = data["region"] ? RegionDto.fromJS(data["region"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetRegionForView {
        data = typeof data === 'object' ? data : {};
        let result = new GetRegionForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["region"] = this.region ? this.region.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetRegionForView {
    region: RegionDto | undefined;
}

export class RegionDto implements IRegionDto {
    code!: string | undefined;
    name!: string | undefined;
    description!: string | undefined;
    isActive!: boolean | undefined;
    parentCode!: string | undefined;
    level!: number | undefined;
    id!: number | undefined;

    constructor(data?: IRegionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.name = data["name"];
            this.description = data["description"];
            this.isActive = data["isActive"];
            this.parentCode = data["parentCode"];
            this.level = data["level"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): RegionDto {
        data = typeof data === 'object' ? data : {};
        let result = new RegionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["parentCode"] = this.parentCode;
        data["level"] = this.level;
        data["id"] = this.id;
        return data;
    }
}

export interface IRegionDto {
    code: string | undefined;
    name: string | undefined;
    description: string | undefined;
    isActive: boolean | undefined;
    parentCode: string | undefined;
    level: number | undefined;
    id: number | undefined;
}

export class GetRegionForEditOutput implements IGetRegionForEditOutput {
    region!: CreateOrEditRegionDto | undefined;

    constructor(data?: IGetRegionForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.region = data["region"] ? CreateOrEditRegionDto.fromJS(data["region"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetRegionForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetRegionForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["region"] = this.region ? this.region.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetRegionForEditOutput {
    region: CreateOrEditRegionDto | undefined;
}

export class CreateOrEditRegionDto implements ICreateOrEditRegionDto {
    code!: string;
    name!: string;
    description!: string | undefined;
    isActive!: boolean | undefined;
    parentCode!: string | undefined;
    level!: number | undefined;
    isDeleted!: boolean | undefined;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: moment.Moment | undefined;
    creatorUserId!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditRegionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.name = data["name"];
            this.description = data["description"];
            this.isActive = data["isActive"];
            this.parentCode = data["parentCode"];
            this.level = data["level"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditRegionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditRegionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["parentCode"] = this.parentCode;
        data["level"] = this.level;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditRegionDto {
    code: string;
    name: string;
    description: string | undefined;
    isActive: boolean | undefined;
    parentCode: string | undefined;
    level: number | undefined;
    isDeleted: boolean | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class GetAllWarrantySerialsInput implements IGetAllWarrantySerialsInput {
    filter!: string | undefined;
    serialFilter!: string | undefined;
    serialRefCode!: string | undefined;
    isReplacementProduct!: boolean | undefined;
    minSellInDateFilter!: moment.Moment | undefined;
    maxSellInDateFilter!: moment.Moment | undefined;
    minSellOutDateFilter!: moment.Moment | undefined;
    maxSellOutDateFilter!: moment.Moment | undefined;
    minManufactureDateFilter!: moment.Moment | undefined;
    maxManufactureDateFilter!: moment.Moment | undefined;
    minRegisterDateFilter!: moment.Moment | undefined;
    maxRegisterDateFilter!: moment.Moment | undefined;
    minInternalExpiredDate_MainDeviceFilter!: moment.Moment | undefined;
    maxInternalExpiredDate_MainDeviceFilter!: moment.Moment | undefined;
    minPublicExpiredDate_MainDeviceFilter!: moment.Moment | undefined;
    maxPublicExpiredDate_MainDeviceFilter!: moment.Moment | undefined;
    minInternalExpiredDate_AccessoryFilter!: moment.Moment | undefined;
    maxInternalExpiredDate_AccessoryFilter!: moment.Moment | undefined;
    minPublicExpiredDate_AccessoryFilter!: moment.Moment | undefined;
    maxPublicExpiredDate_AccessoryFilter!: moment.Moment | undefined;
    customerNameFilter!: string | undefined;
    phoneFilter!: string | undefined;
    provinceCodeFilter!: string | undefined;
    districtCodeFilter!: string | undefined;
    wardCodeFilter!: string | undefined;
    provinceNameFilter!: string | undefined;
    districtNameFilter!: string | undefined;
    wardNameFilter!: string | undefined;
    addressFilter!: string | undefined;
    emailFilter!: string | undefined;
    comboHeaderCodeFilter!: string | undefined;
    formulaHeaderCodeFilter!: string | undefined;
    productCodeFilter!: string | undefined;
    fullDeptCodeFilter!: string | undefined;
    sorting!: string | undefined;
    skipCount!: number | undefined;
    maxResultCount!: number | undefined;

    constructor(data?: IGetAllWarrantySerialsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.filter = data["filter"];
            this.serialFilter = data["serialFilter"];
            this.serialRefCode = data["serialRefCode"];
            this.isReplacementProduct = data["isReplacementProduct"];
            this.minSellInDateFilter = data["minSellInDateFilter"] ? moment(data["minSellInDateFilter"].toString()) : <any>undefined;
            this.maxSellInDateFilter = data["maxSellInDateFilter"] ? moment(data["maxSellInDateFilter"].toString()) : <any>undefined;
            this.minSellOutDateFilter = data["minSellOutDateFilter"] ? moment(data["minSellOutDateFilter"].toString()) : <any>undefined;
            this.maxSellOutDateFilter = data["maxSellOutDateFilter"] ? moment(data["maxSellOutDateFilter"].toString()) : <any>undefined;
            this.minManufactureDateFilter = data["minManufactureDateFilter"] ? moment(data["minManufactureDateFilter"].toString()) : <any>undefined;
            this.maxManufactureDateFilter = data["maxManufactureDateFilter"] ? moment(data["maxManufactureDateFilter"].toString()) : <any>undefined;
            this.minRegisterDateFilter = data["minRegisterDateFilter"] ? moment(data["minRegisterDateFilter"].toString()) : <any>undefined;
            this.maxRegisterDateFilter = data["maxRegisterDateFilter"] ? moment(data["maxRegisterDateFilter"].toString()) : <any>undefined;
            this.minInternalExpiredDate_MainDeviceFilter = data["minInternalExpiredDate_MainDeviceFilter"] ? moment(data["minInternalExpiredDate_MainDeviceFilter"].toString()) : <any>undefined;
            this.maxInternalExpiredDate_MainDeviceFilter = data["maxInternalExpiredDate_MainDeviceFilter"] ? moment(data["maxInternalExpiredDate_MainDeviceFilter"].toString()) : <any>undefined;
            this.minPublicExpiredDate_MainDeviceFilter = data["minPublicExpiredDate_MainDeviceFilter"] ? moment(data["minPublicExpiredDate_MainDeviceFilter"].toString()) : <any>undefined;
            this.maxPublicExpiredDate_MainDeviceFilter = data["maxPublicExpiredDate_MainDeviceFilter"] ? moment(data["maxPublicExpiredDate_MainDeviceFilter"].toString()) : <any>undefined;
            this.minInternalExpiredDate_AccessoryFilter = data["minInternalExpiredDate_AccessoryFilter"] ? moment(data["minInternalExpiredDate_AccessoryFilter"].toString()) : <any>undefined;
            this.maxInternalExpiredDate_AccessoryFilter = data["maxInternalExpiredDate_AccessoryFilter"] ? moment(data["maxInternalExpiredDate_AccessoryFilter"].toString()) : <any>undefined;
            this.minPublicExpiredDate_AccessoryFilter = data["minPublicExpiredDate_AccessoryFilter"] ? moment(data["minPublicExpiredDate_AccessoryFilter"].toString()) : <any>undefined;
            this.maxPublicExpiredDate_AccessoryFilter = data["maxPublicExpiredDate_AccessoryFilter"] ? moment(data["maxPublicExpiredDate_AccessoryFilter"].toString()) : <any>undefined;
            this.customerNameFilter = data["customerNameFilter"];
            this.phoneFilter = data["phoneFilter"];
            this.provinceCodeFilter = data["provinceCodeFilter"];
            this.districtCodeFilter = data["districtCodeFilter"];
            this.wardCodeFilter = data["wardCodeFilter"];
            this.provinceNameFilter = data["provinceNameFilter"];
            this.districtNameFilter = data["districtNameFilter"];
            this.wardNameFilter = data["wardNameFilter"];
            this.addressFilter = data["addressFilter"];
            this.emailFilter = data["emailFilter"];
            this.comboHeaderCodeFilter = data["comboHeaderCodeFilter"];
            this.formulaHeaderCodeFilter = data["formulaHeaderCodeFilter"];
            this.productCodeFilter = data["productCodeFilter"];
            this.fullDeptCodeFilter = data["fullDeptCodeFilter"];
            this.sorting = data["sorting"];
            this.skipCount = data["skipCount"];
            this.maxResultCount = data["maxResultCount"];
        }
    }

    static fromJS(data: any): GetAllWarrantySerialsInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllWarrantySerialsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        data["serialFilter"] = this.serialFilter;
        data["serialRefCode"] = this.serialRefCode;
        data["isReplacementProduct"] = this.isReplacementProduct;
        data["minSellInDateFilter"] = this.minSellInDateFilter ? this.minSellInDateFilter.toISOString() : <any>undefined;
        data["maxSellInDateFilter"] = this.maxSellInDateFilter ? this.maxSellInDateFilter.toISOString() : <any>undefined;
        data["minSellOutDateFilter"] = this.minSellOutDateFilter ? this.minSellOutDateFilter.toISOString() : <any>undefined;
        data["maxSellOutDateFilter"] = this.maxSellOutDateFilter ? this.maxSellOutDateFilter.toISOString() : <any>undefined;
        data["minManufactureDateFilter"] = this.minManufactureDateFilter ? this.minManufactureDateFilter.toISOString() : <any>undefined;
        data["maxManufactureDateFilter"] = this.maxManufactureDateFilter ? this.maxManufactureDateFilter.toISOString() : <any>undefined;
        data["minRegisterDateFilter"] = this.minRegisterDateFilter ? this.minRegisterDateFilter.toISOString() : <any>undefined;
        data["maxRegisterDateFilter"] = this.maxRegisterDateFilter ? this.maxRegisterDateFilter.toISOString() : <any>undefined;
        data["minInternalExpiredDate_MainDeviceFilter"] = this.minInternalExpiredDate_MainDeviceFilter ? this.minInternalExpiredDate_MainDeviceFilter.toISOString() : <any>undefined;
        data["maxInternalExpiredDate_MainDeviceFilter"] = this.maxInternalExpiredDate_MainDeviceFilter ? this.maxInternalExpiredDate_MainDeviceFilter.toISOString() : <any>undefined;
        data["minPublicExpiredDate_MainDeviceFilter"] = this.minPublicExpiredDate_MainDeviceFilter ? this.minPublicExpiredDate_MainDeviceFilter.toISOString() : <any>undefined;
        data["maxPublicExpiredDate_MainDeviceFilter"] = this.maxPublicExpiredDate_MainDeviceFilter ? this.maxPublicExpiredDate_MainDeviceFilter.toISOString() : <any>undefined;
        data["minInternalExpiredDate_AccessoryFilter"] = this.minInternalExpiredDate_AccessoryFilter ? this.minInternalExpiredDate_AccessoryFilter.toISOString() : <any>undefined;
        data["maxInternalExpiredDate_AccessoryFilter"] = this.maxInternalExpiredDate_AccessoryFilter ? this.maxInternalExpiredDate_AccessoryFilter.toISOString() : <any>undefined;
        data["minPublicExpiredDate_AccessoryFilter"] = this.minPublicExpiredDate_AccessoryFilter ? this.minPublicExpiredDate_AccessoryFilter.toISOString() : <any>undefined;
        data["maxPublicExpiredDate_AccessoryFilter"] = this.maxPublicExpiredDate_AccessoryFilter ? this.maxPublicExpiredDate_AccessoryFilter.toISOString() : <any>undefined;
        data["customerNameFilter"] = this.customerNameFilter;
        data["phoneFilter"] = this.phoneFilter;
        data["provinceCodeFilter"] = this.provinceCodeFilter;
        data["districtCodeFilter"] = this.districtCodeFilter;
        data["wardCodeFilter"] = this.wardCodeFilter;
        data["provinceNameFilter"] = this.provinceNameFilter;
        data["districtNameFilter"] = this.districtNameFilter;
        data["wardNameFilter"] = this.wardNameFilter;
        data["addressFilter"] = this.addressFilter;
        data["emailFilter"] = this.emailFilter;
        data["comboHeaderCodeFilter"] = this.comboHeaderCodeFilter;
        data["formulaHeaderCodeFilter"] = this.formulaHeaderCodeFilter;
        data["productCodeFilter"] = this.productCodeFilter;
        data["fullDeptCodeFilter"] = this.fullDeptCodeFilter;
        data["sorting"] = this.sorting;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data;
    }
}

export interface IGetAllWarrantySerialsInput {
    filter: string | undefined;
    serialFilter: string | undefined;
    serialRefCode: string | undefined;
    isReplacementProduct: boolean | undefined;
    minSellInDateFilter: moment.Moment | undefined;
    maxSellInDateFilter: moment.Moment | undefined;
    minSellOutDateFilter: moment.Moment | undefined;
    maxSellOutDateFilter: moment.Moment | undefined;
    minManufactureDateFilter: moment.Moment | undefined;
    maxManufactureDateFilter: moment.Moment | undefined;
    minRegisterDateFilter: moment.Moment | undefined;
    maxRegisterDateFilter: moment.Moment | undefined;
    minInternalExpiredDate_MainDeviceFilter: moment.Moment | undefined;
    maxInternalExpiredDate_MainDeviceFilter: moment.Moment | undefined;
    minPublicExpiredDate_MainDeviceFilter: moment.Moment | undefined;
    maxPublicExpiredDate_MainDeviceFilter: moment.Moment | undefined;
    minInternalExpiredDate_AccessoryFilter: moment.Moment | undefined;
    maxInternalExpiredDate_AccessoryFilter: moment.Moment | undefined;
    minPublicExpiredDate_AccessoryFilter: moment.Moment | undefined;
    maxPublicExpiredDate_AccessoryFilter: moment.Moment | undefined;
    customerNameFilter: string | undefined;
    phoneFilter: string | undefined;
    provinceCodeFilter: string | undefined;
    districtCodeFilter: string | undefined;
    wardCodeFilter: string | undefined;
    provinceNameFilter: string | undefined;
    districtNameFilter: string | undefined;
    wardNameFilter: string | undefined;
    addressFilter: string | undefined;
    emailFilter: string | undefined;
    comboHeaderCodeFilter: string | undefined;
    formulaHeaderCodeFilter: string | undefined;
    productCodeFilter: string | undefined;
    fullDeptCodeFilter: string | undefined;
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;
}

export class PagedResultDtoOfGetWarrantySerialForViewDto implements IPagedResultDtoOfGetWarrantySerialForViewDto {
    totalCount!: number | undefined;
    items!: GetWarrantySerialForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetWarrantySerialForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetWarrantySerialForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetWarrantySerialForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetWarrantySerialForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetWarrantySerialForViewDto {
    totalCount: number | undefined;
    items: GetWarrantySerialForViewDto[] | undefined;
}

export class GetWarrantySerialForViewDto implements IGetWarrantySerialForViewDto {
    warrantySerial!: WarrantySerialDto | undefined;

    constructor(data?: IGetWarrantySerialForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.warrantySerial = data["warrantySerial"] ? WarrantySerialDto.fromJS(data["warrantySerial"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetWarrantySerialForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetWarrantySerialForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["warrantySerial"] = this.warrantySerial ? this.warrantySerial.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetWarrantySerialForViewDto {
    warrantySerial: WarrantySerialDto | undefined;
}

export class WarrantySerialDto implements IWarrantySerialDto {
    serial!: string | undefined;
    serialRefCode!: string | undefined;
    sellInDate!: moment.Moment | undefined;
    sellOutDate!: moment.Moment | undefined;
    sellVipShopDate!: moment.Moment | undefined;
    sellDisDate!: moment.Moment | undefined;
    soldToDistributorDate!: moment.Moment | undefined;
    manufactureDate!: moment.Moment | undefined;
    registerDate!: moment.Moment | undefined;
    internalExpiredDate_MainDevice!: moment.Moment | undefined;
    publicExpiredDate_MainDevice!: moment.Moment | undefined;
    internalExpiredDate_Accessory!: moment.Moment | undefined;
    publicExpiredDate_Accessory!: moment.Moment | undefined;
    customerName!: string | undefined;
    phone!: string | undefined;
    provinceCode!: string | undefined;
    districtCode!: string | undefined;
    wardCode!: string | undefined;
    provinceName!: string | undefined;
    districtName!: string | undefined;
    wardName!: string | undefined;
    address!: string | undefined;
    email!: string | undefined;
    comboHeaderCode!: string | undefined;
    formulaHeaderCode!: string | undefined;
    productCode!: string | undefined;
    fullDeptCode!: string | undefined;
    fullDeptName!: string | undefined;
    currentDate!: moment.Moment | undefined;
    memberName!: string | undefined;
    effectRegistration!: number | undefined;
    serialType!: string | undefined;
    warrantyCode!: string | undefined;
    baseSerial!: string | undefined;
    exchangedDate!: moment.Moment | undefined;
    notes!: string | undefined;
    id!: number | undefined;

    constructor(data?: IWarrantySerialDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.serial = data["serial"];
            this.serialRefCode = data["serialRefCode"];
            this.sellInDate = data["sellInDate"] ? moment(data["sellInDate"].toString()) : <any>undefined;
            this.sellOutDate = data["sellOutDate"] ? moment(data["sellOutDate"].toString()) : <any>undefined;
            this.sellVipShopDate = data["sellVipShopDate"] ? moment(data["sellVipShopDate"].toString()) : <any>undefined;
            this.sellDisDate = data["sellDisDate"] ? moment(data["sellDisDate"].toString()) : <any>undefined;
            this.soldToDistributorDate = data["soldToDistributorDate"] ? moment(data["soldToDistributorDate"].toString()) : <any>undefined;
            this.manufactureDate = data["manufactureDate"] ? moment(data["manufactureDate"].toString()) : <any>undefined;
            this.registerDate = data["registerDate"] ? moment(data["registerDate"].toString()) : <any>undefined;
            this.internalExpiredDate_MainDevice = data["internalExpiredDate_MainDevice"] ? moment(data["internalExpiredDate_MainDevice"].toString()) : <any>undefined;
            this.publicExpiredDate_MainDevice = data["publicExpiredDate_MainDevice"] ? moment(data["publicExpiredDate_MainDevice"].toString()) : <any>undefined;
            this.internalExpiredDate_Accessory = data["internalExpiredDate_Accessory"] ? moment(data["internalExpiredDate_Accessory"].toString()) : <any>undefined;
            this.publicExpiredDate_Accessory = data["publicExpiredDate_Accessory"] ? moment(data["publicExpiredDate_Accessory"].toString()) : <any>undefined;
            this.customerName = data["customerName"];
            this.phone = data["phone"];
            this.provinceCode = data["provinceCode"];
            this.districtCode = data["districtCode"];
            this.wardCode = data["wardCode"];
            this.provinceName = data["provinceName"];
            this.districtName = data["districtName"];
            this.wardName = data["wardName"];
            this.address = data["address"];
            this.email = data["email"];
            this.comboHeaderCode = data["comboHeaderCode"];
            this.formulaHeaderCode = data["formulaHeaderCode"];
            this.productCode = data["productCode"];
            this.fullDeptCode = data["fullDeptCode"];
            this.fullDeptName = data["fullDeptName"];
            this.currentDate = data["currentDate"] ? moment(data["currentDate"].toString()) : <any>undefined;
            this.memberName = data["memberName"];
            this.effectRegistration = data["effectRegistration"];
            this.serialType = data["serialType"];
            this.warrantyCode = data["warrantyCode"];
            this.baseSerial = data["baseSerial"];
            this.exchangedDate = data["exchangedDate"] ? moment(data["exchangedDate"].toString()) : <any>undefined;
            this.notes = data["notes"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): WarrantySerialDto {
        data = typeof data === 'object' ? data : {};
        let result = new WarrantySerialDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serial"] = this.serial;
        data["serialRefCode"] = this.serialRefCode;
        data["sellInDate"] = this.sellInDate ? this.sellInDate.toISOString() : <any>undefined;
        data["sellOutDate"] = this.sellOutDate ? this.sellOutDate.toISOString() : <any>undefined;
        data["sellVipShopDate"] = this.sellVipShopDate ? this.sellVipShopDate.toISOString() : <any>undefined;
        data["sellDisDate"] = this.sellDisDate ? this.sellDisDate.toISOString() : <any>undefined;
        data["soldToDistributorDate"] = this.soldToDistributorDate ? this.soldToDistributorDate.toISOString() : <any>undefined;
        data["manufactureDate"] = this.manufactureDate ? this.manufactureDate.toISOString() : <any>undefined;
        data["registerDate"] = this.registerDate ? this.registerDate.toISOString() : <any>undefined;
        data["internalExpiredDate_MainDevice"] = this.internalExpiredDate_MainDevice ? this.internalExpiredDate_MainDevice.toISOString() : <any>undefined;
        data["publicExpiredDate_MainDevice"] = this.publicExpiredDate_MainDevice ? this.publicExpiredDate_MainDevice.toISOString() : <any>undefined;
        data["internalExpiredDate_Accessory"] = this.internalExpiredDate_Accessory ? this.internalExpiredDate_Accessory.toISOString() : <any>undefined;
        data["publicExpiredDate_Accessory"] = this.publicExpiredDate_Accessory ? this.publicExpiredDate_Accessory.toISOString() : <any>undefined;
        data["customerName"] = this.customerName;
        data["phone"] = this.phone;
        data["provinceCode"] = this.provinceCode;
        data["districtCode"] = this.districtCode;
        data["wardCode"] = this.wardCode;
        data["provinceName"] = this.provinceName;
        data["districtName"] = this.districtName;
        data["wardName"] = this.wardName;
        data["address"] = this.address;
        data["email"] = this.email;
        data["comboHeaderCode"] = this.comboHeaderCode;
        data["formulaHeaderCode"] = this.formulaHeaderCode;
        data["productCode"] = this.productCode;
        data["fullDeptCode"] = this.fullDeptCode;
        data["fullDeptName"] = this.fullDeptName;
        data["currentDate"] = this.currentDate ? this.currentDate.toISOString() : <any>undefined;
        data["memberName"] = this.memberName;
        data["effectRegistration"] = this.effectRegistration;
        data["serialType"] = this.serialType;
        data["warrantyCode"] = this.warrantyCode;
        data["baseSerial"] = this.baseSerial;
        data["exchangedDate"] = this.exchangedDate ? this.exchangedDate.toISOString() : <any>undefined;
        data["notes"] = this.notes;
        data["id"] = this.id;
        return data;
    }
}

export interface IWarrantySerialDto {
    serial: string | undefined;
    serialRefCode: string | undefined;
    sellInDate: moment.Moment | undefined;
    sellOutDate: moment.Moment | undefined;
    sellVipShopDate: moment.Moment | undefined;
    sellDisDate: moment.Moment | undefined;
    soldToDistributorDate: moment.Moment | undefined;
    manufactureDate: moment.Moment | undefined;
    registerDate: moment.Moment | undefined;
    internalExpiredDate_MainDevice: moment.Moment | undefined;
    publicExpiredDate_MainDevice: moment.Moment | undefined;
    internalExpiredDate_Accessory: moment.Moment | undefined;
    publicExpiredDate_Accessory: moment.Moment | undefined;
    customerName: string | undefined;
    phone: string | undefined;
    provinceCode: string | undefined;
    districtCode: string | undefined;
    wardCode: string | undefined;
    provinceName: string | undefined;
    districtName: string | undefined;
    wardName: string | undefined;
    address: string | undefined;
    email: string | undefined;
    comboHeaderCode: string | undefined;
    formulaHeaderCode: string | undefined;
    productCode: string | undefined;
    fullDeptCode: string | undefined;
    fullDeptName: string | undefined;
    currentDate: moment.Moment | undefined;
    memberName: string | undefined;
    effectRegistration: number | undefined;
    serialType: string | undefined;
    warrantyCode: string | undefined;
    baseSerial: string | undefined;
    exchangedDate: moment.Moment | undefined;
    notes: string | undefined;
    id: number | undefined;
}

export class GetAllComboHeadersInput implements IGetAllComboHeadersInput {
    filter!: string | undefined;
    comboHeaderCodeFilter!: string | undefined;
    comboHeaderNameFilter!: string | undefined;
    isActiveFilter!: boolean | undefined;
    isMappingFormulaFilter!: boolean | undefined;
    formulaHeaderCodeFilter!: string | undefined;
    sorting!: string | undefined;
    skipCount!: number | undefined;
    maxResultCount!: number | undefined;

    constructor(data?: IGetAllComboHeadersInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.filter = data["filter"];
            this.comboHeaderCodeFilter = data["comboHeaderCodeFilter"];
            this.comboHeaderNameFilter = data["comboHeaderNameFilter"];
            this.isActiveFilter = data["isActiveFilter"];
            this.isMappingFormulaFilter = data["isMappingFormulaFilter"];
            this.formulaHeaderCodeFilter = data["formulaHeaderCodeFilter"];
            this.sorting = data["sorting"];
            this.skipCount = data["skipCount"];
            this.maxResultCount = data["maxResultCount"];
        }
    }

    static fromJS(data: any): GetAllComboHeadersInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllComboHeadersInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        data["comboHeaderCodeFilter"] = this.comboHeaderCodeFilter;
        data["comboHeaderNameFilter"] = this.comboHeaderNameFilter;
        data["isActiveFilter"] = this.isActiveFilter;
        data["isMappingFormulaFilter"] = this.isMappingFormulaFilter;
        data["formulaHeaderCodeFilter"] = this.formulaHeaderCodeFilter;
        data["sorting"] = this.sorting;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data;
    }
}

export interface IGetAllComboHeadersInput {
    filter: string | undefined;
    comboHeaderCodeFilter: string | undefined;
    comboHeaderNameFilter: string | undefined;
    isActiveFilter: boolean | undefined;
    isMappingFormulaFilter: boolean | undefined;
    formulaHeaderCodeFilter: string | undefined;
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;
}

export class PagedResultDtoOfGetComboHeaderForViewDto implements IPagedResultDtoOfGetComboHeaderForViewDto {
    totalCount!: number | undefined;
    items!: GetComboHeaderForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetComboHeaderForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetComboHeaderForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetComboHeaderForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetComboHeaderForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetComboHeaderForViewDto {
    totalCount: number | undefined;
    items: GetComboHeaderForViewDto[] | undefined;
}

export class GetComboHeaderForViewDto implements IGetComboHeaderForViewDto {
    comboHeader!: ComboHeaderDto | undefined;
    creationTime!: moment.Moment | undefined;
    userName!: string | undefined;

    constructor(data?: IGetComboHeaderForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.comboHeader = data["comboHeader"] ? ComboHeaderDto.fromJS(data["comboHeader"]) : <any>undefined;
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.userName = data["userName"];
        }
    }

    static fromJS(data: any): GetComboHeaderForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetComboHeaderForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["comboHeader"] = this.comboHeader ? this.comboHeader.toJSON() : <any>undefined;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["userName"] = this.userName;
        return data;
    }
}

export interface IGetComboHeaderForViewDto {
    comboHeader: ComboHeaderDto | undefined;
    creationTime: moment.Moment | undefined;
    userName: string | undefined;
}

export class ComboHeaderDto implements IComboHeaderDto {
    comboHeaderCode!: string | undefined;
    comboHeaderName!: string | undefined;
    isActive!: boolean | undefined;
    isMappingFormula!: boolean | undefined;
    formulaHeaderCode!: string | undefined;
    id!: number | undefined;

    constructor(data?: IComboHeaderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.comboHeaderCode = data["comboHeaderCode"];
            this.comboHeaderName = data["comboHeaderName"];
            this.isActive = data["isActive"];
            this.isMappingFormula = data["isMappingFormula"];
            this.formulaHeaderCode = data["formulaHeaderCode"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ComboHeaderDto {
        data = typeof data === 'object' ? data : {};
        let result = new ComboHeaderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["comboHeaderCode"] = this.comboHeaderCode;
        data["comboHeaderName"] = this.comboHeaderName;
        data["isActive"] = this.isActive;
        data["isMappingFormula"] = this.isMappingFormula;
        data["formulaHeaderCode"] = this.formulaHeaderCode;
        data["id"] = this.id;
        return data;
    }
}

export interface IComboHeaderDto {
    comboHeaderCode: string | undefined;
    comboHeaderName: string | undefined;
    isActive: boolean | undefined;
    isMappingFormula: boolean | undefined;
    formulaHeaderCode: string | undefined;
    id: number | undefined;
}

export class FullComboDto implements IFullComboDto {
    comboHeader!: ComboHeaderExtDto | undefined;
    comboDetail!: ComboDetailExtDto | undefined;
    comboDepartments!: string[] | undefined;
    comboProducts!: string[] | undefined;

    constructor(data?: IFullComboDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.comboHeader = data["comboHeader"] ? ComboHeaderExtDto.fromJS(data["comboHeader"]) : <any>undefined;
            this.comboDetail = data["comboDetail"] ? ComboDetailExtDto.fromJS(data["comboDetail"]) : <any>undefined;
            if (data["comboDepartments"] && data["comboDepartments"].constructor === Array) {
                this.comboDepartments = [];
                for (let item of data["comboDepartments"])
                    this.comboDepartments.push(item);
            }
            if (data["comboProducts"] && data["comboProducts"].constructor === Array) {
                this.comboProducts = [];
                for (let item of data["comboProducts"])
                    this.comboProducts.push(item);
            }
        }
    }

    static fromJS(data: any): FullComboDto {
        data = typeof data === 'object' ? data : {};
        let result = new FullComboDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["comboHeader"] = this.comboHeader ? this.comboHeader.toJSON() : <any>undefined;
        data["comboDetail"] = this.comboDetail ? this.comboDetail.toJSON() : <any>undefined;
        if (this.comboDepartments && this.comboDepartments.constructor === Array) {
            data["comboDepartments"] = [];
            for (let item of this.comboDepartments)
                data["comboDepartments"].push(item);
        }
        if (this.comboProducts && this.comboProducts.constructor === Array) {
            data["comboProducts"] = [];
            for (let item of this.comboProducts)
                data["comboProducts"].push(item);
        }
        return data;
    }
}

export interface IFullComboDto {
    comboHeader: ComboHeaderExtDto | undefined;
    comboDetail: ComboDetailExtDto | undefined;
    comboDepartments: string[] | undefined;
    comboProducts: string[] | undefined;
}

export class ComboHeaderExtDto implements IComboHeaderExtDto {
    comboHeaderCode!: string | undefined;
    comboHeaderName!: string | undefined;
    isActive!: boolean | undefined;
    isMappingFormula!: boolean | undefined;
    formulaHeaderCode!: string | undefined;

    constructor(data?: IComboHeaderExtDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.comboHeaderCode = data["comboHeaderCode"];
            this.comboHeaderName = data["comboHeaderName"];
            this.isActive = data["isActive"];
            this.isMappingFormula = data["isMappingFormula"];
            this.formulaHeaderCode = data["formulaHeaderCode"];
        }
    }

    static fromJS(data: any): ComboHeaderExtDto {
        data = typeof data === 'object' ? data : {};
        let result = new ComboHeaderExtDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["comboHeaderCode"] = this.comboHeaderCode;
        data["comboHeaderName"] = this.comboHeaderName;
        data["isActive"] = this.isActive;
        data["isMappingFormula"] = this.isMappingFormula;
        data["formulaHeaderCode"] = this.formulaHeaderCode;
        return data;
    }
}

export interface IComboHeaderExtDto {
    comboHeaderCode: string | undefined;
    comboHeaderName: string | undefined;
    isActive: boolean | undefined;
    isMappingFormula: boolean | undefined;
    formulaHeaderCode: string | undefined;
}

export class ComboDetailExtDto implements IComboDetailExtDto {
    comboType!: string | undefined;
    mainDeviceName!: string | undefined;
    hotDeviceName!: string | undefined;
    coldDeviceName!: string | undefined;
    accessoryName!: string | undefined;

    constructor(data?: IComboDetailExtDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.comboType = data["comboType"];
            this.mainDeviceName = data["mainDeviceName"];
            this.hotDeviceName = data["hotDeviceName"];
            this.coldDeviceName = data["coldDeviceName"];
            this.accessoryName = data["accessoryName"];
        }
    }

    static fromJS(data: any): ComboDetailExtDto {
        data = typeof data === 'object' ? data : {};
        let result = new ComboDetailExtDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["comboType"] = this.comboType;
        data["mainDeviceName"] = this.mainDeviceName;
        data["hotDeviceName"] = this.hotDeviceName;
        data["coldDeviceName"] = this.coldDeviceName;
        data["accessoryName"] = this.accessoryName;
        return data;
    }
}

export interface IComboDetailExtDto {
    comboType: string | undefined;
    mainDeviceName: string | undefined;
    hotDeviceName: string | undefined;
    coldDeviceName: string | undefined;
    accessoryName: string | undefined;
}

export class SaveComboResponseDto implements ISaveComboResponseDto {
    success!: boolean | undefined;
    errorMsg!: string | undefined;
    comboHeaderCode!: string | undefined;

    constructor(data?: ISaveComboResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.success = data["success"];
            this.errorMsg = data["errorMsg"];
            this.comboHeaderCode = data["comboHeaderCode"];
        }
    }

    static fromJS(data: any): SaveComboResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new SaveComboResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorMsg"] = this.errorMsg;
        data["comboHeaderCode"] = this.comboHeaderCode;
        return data;
    }
}

export interface ISaveComboResponseDto {
    success: boolean | undefined;
    errorMsg: string | undefined;
    comboHeaderCode: string | undefined;
}

export class LoadComboResponseDto implements ILoadComboResponseDto {
    success!: boolean | undefined;
    errorMsg!: string | undefined;
    result!: FullComboDto | undefined;

    constructor(data?: ILoadComboResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.success = data["success"];
            this.errorMsg = data["errorMsg"];
            this.result = data["result"] ? FullComboDto.fromJS(data["result"]) : <any>undefined;
        }
    }

    static fromJS(data: any): LoadComboResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new LoadComboResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorMsg"] = this.errorMsg;
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        return data;
    }
}

export interface ILoadComboResponseDto {
    success: boolean | undefined;
    errorMsg: string | undefined;
    result: FullComboDto | undefined;
}

export class GetAllFormulaHeadersInput implements IGetAllFormulaHeadersInput {
    filter!: string | undefined;
    formulaHeaderCodeFilter!: string | undefined;
    formulaHeaderNameFilter!: string | undefined;
    comboHeaderCodeFilter!: string | undefined;
    descriptionFilter!: string | undefined;
    minEffectiveFromFilter!: moment.Moment | undefined;
    maxEffectiveFromFilter!: moment.Moment | undefined;
    minEffectiveToFilter!: moment.Moment | undefined;
    maxEffectiveToFilter!: moment.Moment | undefined;
    isActiveFilter!: boolean | undefined;
    sorting!: string | undefined;
    skipCount!: number | undefined;
    maxResultCount!: number | undefined;

    constructor(data?: IGetAllFormulaHeadersInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.filter = data["filter"];
            this.formulaHeaderCodeFilter = data["formulaHeaderCodeFilter"];
            this.formulaHeaderNameFilter = data["formulaHeaderNameFilter"];
            this.comboHeaderCodeFilter = data["comboHeaderCodeFilter"];
            this.descriptionFilter = data["descriptionFilter"];
            this.minEffectiveFromFilter = data["minEffectiveFromFilter"] ? moment(data["minEffectiveFromFilter"].toString()) : <any>undefined;
            this.maxEffectiveFromFilter = data["maxEffectiveFromFilter"] ? moment(data["maxEffectiveFromFilter"].toString()) : <any>undefined;
            this.minEffectiveToFilter = data["minEffectiveToFilter"] ? moment(data["minEffectiveToFilter"].toString()) : <any>undefined;
            this.maxEffectiveToFilter = data["maxEffectiveToFilter"] ? moment(data["maxEffectiveToFilter"].toString()) : <any>undefined;
            this.isActiveFilter = data["isActiveFilter"];
            this.sorting = data["sorting"];
            this.skipCount = data["skipCount"];
            this.maxResultCount = data["maxResultCount"];
        }
    }

    static fromJS(data: any): GetAllFormulaHeadersInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllFormulaHeadersInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        data["formulaHeaderCodeFilter"] = this.formulaHeaderCodeFilter;
        data["formulaHeaderNameFilter"] = this.formulaHeaderNameFilter;
        data["comboHeaderCodeFilter"] = this.comboHeaderCodeFilter;
        data["descriptionFilter"] = this.descriptionFilter;
        data["minEffectiveFromFilter"] = this.minEffectiveFromFilter ? this.minEffectiveFromFilter.toISOString() : <any>undefined;
        data["maxEffectiveFromFilter"] = this.maxEffectiveFromFilter ? this.maxEffectiveFromFilter.toISOString() : <any>undefined;
        data["minEffectiveToFilter"] = this.minEffectiveToFilter ? this.minEffectiveToFilter.toISOString() : <any>undefined;
        data["maxEffectiveToFilter"] = this.maxEffectiveToFilter ? this.maxEffectiveToFilter.toISOString() : <any>undefined;
        data["isActiveFilter"] = this.isActiveFilter;
        data["sorting"] = this.sorting;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data;
    }
}

export interface IGetAllFormulaHeadersInput {
    filter: string | undefined;
    formulaHeaderCodeFilter: string | undefined;
    formulaHeaderNameFilter: string | undefined;
    comboHeaderCodeFilter: string | undefined;
    descriptionFilter: string | undefined;
    minEffectiveFromFilter: moment.Moment | undefined;
    maxEffectiveFromFilter: moment.Moment | undefined;
    minEffectiveToFilter: moment.Moment | undefined;
    maxEffectiveToFilter: moment.Moment | undefined;
    isActiveFilter: boolean | undefined;
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;
}

export class PagedResultDtoOfGetFormulaHeaderForViewDto implements IPagedResultDtoOfGetFormulaHeaderForViewDto {
    totalCount!: number | undefined;
    items!: GetFormulaHeaderForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetFormulaHeaderForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetFormulaHeaderForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetFormulaHeaderForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetFormulaHeaderForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetFormulaHeaderForViewDto {
    totalCount: number | undefined;
    items: GetFormulaHeaderForViewDto[] | undefined;
}

export class GetFormulaHeaderForViewDto implements IGetFormulaHeaderForViewDto {
    formulaHeader!: FormulaHeaderDto | undefined;
    userName!: string | undefined;

    constructor(data?: IGetFormulaHeaderForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.formulaHeader = data["formulaHeader"] ? FormulaHeaderDto.fromJS(data["formulaHeader"]) : <any>undefined;
            this.userName = data["userName"];
        }
    }

    static fromJS(data: any): GetFormulaHeaderForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetFormulaHeaderForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formulaHeader"] = this.formulaHeader ? this.formulaHeader.toJSON() : <any>undefined;
        data["userName"] = this.userName;
        return data;
    }
}

export interface IGetFormulaHeaderForViewDto {
    formulaHeader: FormulaHeaderDto | undefined;
    userName: string | undefined;
}

export class FormulaHeaderDto implements IFormulaHeaderDto {
    formulaHeaderCode!: string | undefined;
    formulaHeaderName!: string | undefined;
    comboHeaderCode!: string | undefined;
    description!: string | undefined;
    effectiveFrom!: moment.Moment | undefined;
    effectiveTo!: moment.Moment | undefined;
    isActive!: boolean | undefined;
    id!: number | undefined;

    constructor(data?: IFormulaHeaderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.formulaHeaderCode = data["formulaHeaderCode"];
            this.formulaHeaderName = data["formulaHeaderName"];
            this.comboHeaderCode = data["comboHeaderCode"];
            this.description = data["description"];
            this.effectiveFrom = data["effectiveFrom"] ? moment(data["effectiveFrom"].toString()) : <any>undefined;
            this.effectiveTo = data["effectiveTo"] ? moment(data["effectiveTo"].toString()) : <any>undefined;
            this.isActive = data["isActive"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): FormulaHeaderDto {
        data = typeof data === 'object' ? data : {};
        let result = new FormulaHeaderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formulaHeaderCode"] = this.formulaHeaderCode;
        data["formulaHeaderName"] = this.formulaHeaderName;
        data["comboHeaderCode"] = this.comboHeaderCode;
        data["description"] = this.description;
        data["effectiveFrom"] = this.effectiveFrom ? this.effectiveFrom.toISOString() : <any>undefined;
        data["effectiveTo"] = this.effectiveTo ? this.effectiveTo.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        data["id"] = this.id;
        return data;
    }
}

export interface IFormulaHeaderDto {
    formulaHeaderCode: string | undefined;
    formulaHeaderName: string | undefined;
    comboHeaderCode: string | undefined;
    description: string | undefined;
    effectiveFrom: moment.Moment | undefined;
    effectiveTo: moment.Moment | undefined;
    isActive: boolean | undefined;
    id: number | undefined;
}

export class GetFormulaHeaderForEditOutput implements IGetFormulaHeaderForEditOutput {
    formulaHeader!: CreateOrEditFormulaHeaderDto | undefined;

    constructor(data?: IGetFormulaHeaderForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.formulaHeader = data["formulaHeader"] ? CreateOrEditFormulaHeaderDto.fromJS(data["formulaHeader"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetFormulaHeaderForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetFormulaHeaderForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formulaHeader"] = this.formulaHeader ? this.formulaHeader.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetFormulaHeaderForEditOutput {
    formulaHeader: CreateOrEditFormulaHeaderDto | undefined;
}

export class CreateOrEditFormulaHeaderDto implements ICreateOrEditFormulaHeaderDto {
    formulaHeaderCode!: string | undefined;
    formulaHeaderName!: string | undefined;
    comboHeaderCode!: string | undefined;
    description!: string | undefined;
    effectiveFrom!: moment.Moment | undefined;
    effectiveTo!: moment.Moment | undefined;
    isActive!: boolean | undefined;
    effectRegistration!: number | undefined;
    formulaDetails!: CreateOrEditFormulaDetailDto[] | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditFormulaHeaderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.formulaHeaderCode = data["formulaHeaderCode"];
            this.formulaHeaderName = data["formulaHeaderName"];
            this.comboHeaderCode = data["comboHeaderCode"];
            this.description = data["description"];
            this.effectiveFrom = data["effectiveFrom"] ? moment(data["effectiveFrom"].toString()) : <any>undefined;
            this.effectiveTo = data["effectiveTo"] ? moment(data["effectiveTo"].toString()) : <any>undefined;
            this.isActive = data["isActive"];
            this.effectRegistration = data["effectRegistration"];
            if (data["formulaDetails"] && data["formulaDetails"].constructor === Array) {
                this.formulaDetails = [];
                for (let item of data["formulaDetails"])
                    this.formulaDetails.push(CreateOrEditFormulaDetailDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditFormulaHeaderDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditFormulaHeaderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formulaHeaderCode"] = this.formulaHeaderCode;
        data["formulaHeaderName"] = this.formulaHeaderName;
        data["comboHeaderCode"] = this.comboHeaderCode;
        data["description"] = this.description;
        data["effectiveFrom"] = this.effectiveFrom ? this.effectiveFrom.toISOString() : <any>undefined;
        data["effectiveTo"] = this.effectiveTo ? this.effectiveTo.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        data["effectRegistration"] = this.effectRegistration;
        if (this.formulaDetails && this.formulaDetails.constructor === Array) {
            data["formulaDetails"] = [];
            for (let item of this.formulaDetails)
                data["formulaDetails"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditFormulaHeaderDto {
    formulaHeaderCode: string | undefined;
    formulaHeaderName: string | undefined;
    comboHeaderCode: string | undefined;
    description: string | undefined;
    effectiveFrom: moment.Moment | undefined;
    effectiveTo: moment.Moment | undefined;
    isActive: boolean | undefined;
    effectRegistration: number | undefined;
    formulaDetails: CreateOrEditFormulaDetailDto[] | undefined;
    id: number | undefined;
}

export class CreateOrEditFormulaDetailDto implements ICreateOrEditFormulaDetailDto {
    formulaHeaderCode!: string | undefined;
    formulaDetailCode!: string | undefined;
    formulaDetailName!: string | undefined;
    warrantyByRegistrationDate!: number | undefined;
    warrantyByProduceDate!: number | undefined;
    limitWarrantyFromProduceDate!: number | undefined;
    isMainDevice!: boolean | undefined;
    effectRegistration!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditFormulaDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.formulaHeaderCode = data["formulaHeaderCode"];
            this.formulaDetailCode = data["formulaDetailCode"];
            this.formulaDetailName = data["formulaDetailName"];
            this.warrantyByRegistrationDate = data["warrantyByRegistrationDate"];
            this.warrantyByProduceDate = data["warrantyByProduceDate"];
            this.limitWarrantyFromProduceDate = data["limitWarrantyFromProduceDate"];
            this.isMainDevice = data["isMainDevice"];
            this.effectRegistration = data["effectRegistration"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditFormulaDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditFormulaDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formulaHeaderCode"] = this.formulaHeaderCode;
        data["formulaDetailCode"] = this.formulaDetailCode;
        data["formulaDetailName"] = this.formulaDetailName;
        data["warrantyByRegistrationDate"] = this.warrantyByRegistrationDate;
        data["warrantyByProduceDate"] = this.warrantyByProduceDate;
        data["limitWarrantyFromProduceDate"] = this.limitWarrantyFromProduceDate;
        data["isMainDevice"] = this.isMainDevice;
        data["effectRegistration"] = this.effectRegistration;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditFormulaDetailDto {
    formulaHeaderCode: string | undefined;
    formulaDetailCode: string | undefined;
    formulaDetailName: string | undefined;
    warrantyByRegistrationDate: number | undefined;
    warrantyByProduceDate: number | undefined;
    limitWarrantyFromProduceDate: number | undefined;
    isMainDevice: boolean | undefined;
    effectRegistration: number | undefined;
    id: number | undefined;
}

export class WarrantyAdjustRequestDto implements IWarrantyAdjustRequestDto {
    warrantyAdjusts!: CreateOrEditWarrantyAdjustmentLogDto[] | undefined;

    constructor(data?: IWarrantyAdjustRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["warrantyAdjusts"] && data["warrantyAdjusts"].constructor === Array) {
                this.warrantyAdjusts = [];
                for (let item of data["warrantyAdjusts"])
                    this.warrantyAdjusts.push(CreateOrEditWarrantyAdjustmentLogDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WarrantyAdjustRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new WarrantyAdjustRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.warrantyAdjusts && this.warrantyAdjusts.constructor === Array) {
            data["warrantyAdjusts"] = [];
            for (let item of this.warrantyAdjusts)
                data["warrantyAdjusts"].push(item.toJSON());
        }
        return data;
    }
}

export interface IWarrantyAdjustRequestDto {
    warrantyAdjusts: CreateOrEditWarrantyAdjustmentLogDto[] | undefined;
}

export class CreateOrEditWarrantyAdjustmentLogDto implements ICreateOrEditWarrantyAdjustmentLogDto {
    approver!: string | undefined;
    serial!: string | undefined;
    old_InternalExpiredDate_MainDevice!: moment.Moment | undefined;
    old_PublicExpiredDate_MainDevice!: moment.Moment | undefined;
    old_InternalExpiredDate_Accessory!: moment.Moment | undefined;
    old_PublicExpiredDate_Accessory!: moment.Moment | undefined;
    new_InternalExpiredDate_MainDevice!: moment.Moment | undefined;
    new_PublicExpiredDate_MainDevice!: moment.Moment | undefined;
    new_InternalExpiredDate_Accessory!: moment.Moment | undefined;
    new_PublicExpiredDate_Accessory!: moment.Moment | undefined;
    businessDate!: moment.Moment | undefined;
    description!: string | undefined;
    source!: string | undefined;
    old_CustomerName!: string | undefined;
    new_CustomerName!: string | undefined;
    old_Phone!: string | undefined;
    new_Phone!: string | undefined;
    old_ProvinceCode!: string | undefined;
    old_ProvinceName!: string | undefined;
    new_ProvinceCode!: string | undefined;
    new_ProvinceName!: string | undefined;
    old_DistrictCode!: string | undefined;
    old_DistrictName!: string | undefined;
    new_DistrictCode!: string | undefined;
    new_DistrictName!: string | undefined;
    old_Address!: string | undefined;
    new_Address!: string | undefined;
    old_Email!: string | undefined;
    new_Email!: string | undefined;
    effectRegistration!: number | undefined;
    new_EffectRegistration!: number | undefined;
    old_EffectRegistration!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditWarrantyAdjustmentLogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.approver = data["approver"];
            this.serial = data["serial"];
            this.old_InternalExpiredDate_MainDevice = data["old_InternalExpiredDate_MainDevice"] ? moment(data["old_InternalExpiredDate_MainDevice"].toString()) : <any>undefined;
            this.old_PublicExpiredDate_MainDevice = data["old_PublicExpiredDate_MainDevice"] ? moment(data["old_PublicExpiredDate_MainDevice"].toString()) : <any>undefined;
            this.old_InternalExpiredDate_Accessory = data["old_InternalExpiredDate_Accessory"] ? moment(data["old_InternalExpiredDate_Accessory"].toString()) : <any>undefined;
            this.old_PublicExpiredDate_Accessory = data["old_PublicExpiredDate_Accessory"] ? moment(data["old_PublicExpiredDate_Accessory"].toString()) : <any>undefined;
            this.new_InternalExpiredDate_MainDevice = data["new_InternalExpiredDate_MainDevice"] ? moment(data["new_InternalExpiredDate_MainDevice"].toString()) : <any>undefined;
            this.new_PublicExpiredDate_MainDevice = data["new_PublicExpiredDate_MainDevice"] ? moment(data["new_PublicExpiredDate_MainDevice"].toString()) : <any>undefined;
            this.new_InternalExpiredDate_Accessory = data["new_InternalExpiredDate_Accessory"] ? moment(data["new_InternalExpiredDate_Accessory"].toString()) : <any>undefined;
            this.new_PublicExpiredDate_Accessory = data["new_PublicExpiredDate_Accessory"] ? moment(data["new_PublicExpiredDate_Accessory"].toString()) : <any>undefined;
            this.businessDate = data["businessDate"] ? moment(data["businessDate"].toString()) : <any>undefined;
            this.description = data["description"];
            this.source = data["source"];
            this.old_CustomerName = data["old_CustomerName"];
            this.new_CustomerName = data["new_CustomerName"];
            this.old_Phone = data["old_Phone"];
            this.new_Phone = data["new_Phone"];
            this.old_ProvinceCode = data["old_ProvinceCode"];
            this.old_ProvinceName = data["old_ProvinceName"];
            this.new_ProvinceCode = data["new_ProvinceCode"];
            this.new_ProvinceName = data["new_ProvinceName"];
            this.old_DistrictCode = data["old_DistrictCode"];
            this.old_DistrictName = data["old_DistrictName"];
            this.new_DistrictCode = data["new_DistrictCode"];
            this.new_DistrictName = data["new_DistrictName"];
            this.old_Address = data["old_Address"];
            this.new_Address = data["new_Address"];
            this.old_Email = data["old_Email"];
            this.new_Email = data["new_Email"];
            this.effectRegistration = data["effectRegistration"];
            this.new_EffectRegistration = data["new_EffectRegistration"];
            this.old_EffectRegistration = data["old_EffectRegistration"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditWarrantyAdjustmentLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditWarrantyAdjustmentLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["approver"] = this.approver;
        data["serial"] = this.serial;
        data["old_InternalExpiredDate_MainDevice"] = this.old_InternalExpiredDate_MainDevice ? moment(this.old_InternalExpiredDate_MainDevice).add(7, 'hours').toISOString() : <any>undefined;
        data["old_PublicExpiredDate_MainDevice"] = this.old_PublicExpiredDate_MainDevice ? moment(this.old_PublicExpiredDate_MainDevice).add(7, 'hours').toISOString() : <any>undefined;
        data["old_InternalExpiredDate_Accessory"] = this.old_InternalExpiredDate_Accessory ? moment(this.old_InternalExpiredDate_Accessory).add(7, 'hours').toISOString() : <any>undefined;
        data["old_PublicExpiredDate_Accessory"] = this.old_PublicExpiredDate_Accessory ? moment(this.old_PublicExpiredDate_Accessory).add(7, 'hours').toISOString() : <any>undefined;
        data["new_InternalExpiredDate_MainDevice"] = this.new_InternalExpiredDate_MainDevice ? moment(this.new_InternalExpiredDate_MainDevice).add(7, 'hours').toISOString() : <any>undefined;
        data["new_PublicExpiredDate_MainDevice"] = this.new_PublicExpiredDate_MainDevice ? moment(this.new_PublicExpiredDate_MainDevice).add(7, 'hours').toISOString() : <any>undefined;
        data["new_InternalExpiredDate_Accessory"] = this.new_InternalExpiredDate_Accessory ? moment(this.new_InternalExpiredDate_Accessory).add(7, 'hours').toISOString() : <any>undefined;
        data["new_PublicExpiredDate_Accessory"] = this.new_PublicExpiredDate_Accessory ? moment(this.new_PublicExpiredDate_Accessory).add(7, 'hours').toISOString() : <any>undefined;
        data["businessDate"] = this.businessDate ? moment(this.businessDate).add(7, 'hours').toISOString() : <any>undefined;
        data["description"] = this.description;
        data["source"] = this.source;
        data["old_CustomerName"] = this.old_CustomerName;
        data["new_CustomerName"] = this.new_CustomerName;
        data["old_Phone"] = this.old_Phone;
        data["new_Phone"] = this.new_Phone;
        data["old_ProvinceCode"] = this.old_ProvinceCode;
        data["old_ProvinceName"] = this.old_ProvinceName;
        data["new_ProvinceCode"] = this.new_ProvinceCode;
        data["new_ProvinceName"] = this.new_ProvinceName;
        data["old_DistrictCode"] = this.old_DistrictCode;
        data["old_DistrictName"] = this.old_DistrictName;
        data["new_DistrictCode"] = this.new_DistrictCode;
        data["new_DistrictName"] = this.new_DistrictName;
        data["old_Address"] = this.old_Address;
        data["new_Address"] = this.new_Address;
        data["old_Email"] = this.old_Email;
        data["new_Email"] = this.new_Email;
        data["effectRegistration"] = this.effectRegistration;
        data["new_EffectRegistration"] = this.new_EffectRegistration;
        data["old_EffectRegistration"] = this.old_EffectRegistration;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditWarrantyAdjustmentLogDto {
    approver: string | undefined;
    serial: string | undefined;
    old_InternalExpiredDate_MainDevice: moment.Moment | undefined;
    old_PublicExpiredDate_MainDevice: moment.Moment | undefined;
    old_InternalExpiredDate_Accessory: moment.Moment | undefined;
    old_PublicExpiredDate_Accessory: moment.Moment | undefined;
    new_InternalExpiredDate_MainDevice: moment.Moment | undefined;
    new_PublicExpiredDate_MainDevice: moment.Moment | undefined;
    new_InternalExpiredDate_Accessory: moment.Moment | undefined;
    new_PublicExpiredDate_Accessory: moment.Moment | undefined;
    businessDate: moment.Moment | undefined;
    description: string | undefined;
    source: string | undefined;
    old_CustomerName: string | undefined;
    new_CustomerName: string | undefined;
    old_Phone: string | undefined;
    new_Phone: string | undefined;
    old_ProvinceCode: string | undefined;
    old_ProvinceName: string | undefined;
    new_ProvinceCode: string | undefined;
    new_ProvinceName: string | undefined;
    old_DistrictCode: string | undefined;
    old_DistrictName: string | undefined;
    new_DistrictCode: string | undefined;
    new_DistrictName: string | undefined;
    old_Address: string | undefined;
    new_Address: string | undefined;
    old_Email: string | undefined;
    new_Email: string | undefined;
    effectRegistration: number | undefined;
    new_EffectRegistration: number | undefined;
    old_EffectRegistration: number | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfGetWarrantyAdjustmentFileStatusForView implements IPagedResultDtoOfGetWarrantyAdjustmentFileStatusForView {
    totalCount!: number | undefined;
    items!: GetWarrantyAdjustmentFileStatusForView[] | undefined;

    constructor(data?: IPagedResultDtoOfGetWarrantyAdjustmentFileStatusForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetWarrantyAdjustmentFileStatusForView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetWarrantyAdjustmentFileStatusForView {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetWarrantyAdjustmentFileStatusForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetWarrantyAdjustmentFileStatusForView {
    totalCount: number | undefined;
    items: GetWarrantyAdjustmentFileStatusForView[] | undefined;
}

export class GetWarrantyAdjustmentFileStatusForView implements IGetWarrantyAdjustmentFileStatusForView {
    warrantyAdjustmentFileStatus!: WarrantyAdjustmentFileStatusDto | undefined;
    performedBy!: string | undefined;

    constructor(data?: IGetWarrantyAdjustmentFileStatusForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.warrantyAdjustmentFileStatus = data["warrantyAdjustmentFileStatus"] ? WarrantyAdjustmentFileStatusDto.fromJS(data["warrantyAdjustmentFileStatus"]) : <any>undefined;
            this.performedBy = data["performedBy"];
        }
    }

    static fromJS(data: any): GetWarrantyAdjustmentFileStatusForView {
        data = typeof data === 'object' ? data : {};
        let result = new GetWarrantyAdjustmentFileStatusForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["warrantyAdjustmentFileStatus"] = this.warrantyAdjustmentFileStatus ? this.warrantyAdjustmentFileStatus.toJSON() : <any>undefined;
        data["performedBy"] = this.performedBy;
        return data;
    }
}

export interface IGetWarrantyAdjustmentFileStatusForView {
    warrantyAdjustmentFileStatus: WarrantyAdjustmentFileStatusDto | undefined;
    performedBy: string | undefined;
}

export class WarrantyAdjustmentFileStatusDto implements IWarrantyAdjustmentFileStatusDto {
    code!: string | undefined;
    fileName!: string | undefined;
    status!: string | undefined;
    processTime!: moment.Moment | undefined;
    reason!: string | undefined;
    isDeleted!: boolean | undefined;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: moment.Moment | undefined;
    creatorUserId!: number | undefined;
    id!: number | undefined;

    constructor(data?: IWarrantyAdjustmentFileStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.fileName = data["fileName"];
            this.status = data["status"];
            this.processTime = data["processTime"] ? moment(data["processTime"].toString()) : <any>undefined;
            this.reason = data["reason"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): WarrantyAdjustmentFileStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new WarrantyAdjustmentFileStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["fileName"] = this.fileName;
        data["status"] = this.status;
        data["processTime"] = this.processTime ? this.processTime.toISOString() : <any>undefined;
        data["reason"] = this.reason;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IWarrantyAdjustmentFileStatusDto {
    code: string | undefined;
    fileName: string | undefined;
    status: string | undefined;
    processTime: moment.Moment | undefined;
    reason: string | undefined;
    isDeleted: boolean | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class WarrantyAdjustmentImportJobArgs implements IWarrantyAdjustmentImportJobArgs {
    codePrefix!: string | undefined;
    approver!: string | undefined;
    reason!: string | undefined;
    type!: string | undefined;
    tableName!: string | undefined;
    filePath!: string | undefined;
    fileName!: string | undefined;
    userId!: number | undefined;
    tenantId!: number | undefined;
    currentLanguage!: string | undefined;
    apiUrl!: string | undefined;

    constructor(data?: IWarrantyAdjustmentImportJobArgs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.codePrefix = data["codePrefix"];
            this.approver = data["approver"];
            this.reason = data["reason"];
            this.type = data["type"];
            this.tableName = data["tableName"];
            this.filePath = data["filePath"];
            this.fileName = data["fileName"];
            this.userId = data["userId"];
            this.tenantId = data["tenantId"];
            this.currentLanguage = data["currentLanguage"];
            this.apiUrl = data["apiUrl"];
        }
    }

    static fromJS(data: any): WarrantyAdjustmentImportJobArgs {
        data = typeof data === 'object' ? data : {};
        let result = new WarrantyAdjustmentImportJobArgs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codePrefix"] = this.codePrefix;
        data["approver"] = this.approver;
        data["reason"] = this.reason;
        data["type"] = this.type;
        data["tableName"] = this.tableName;
        data["filePath"] = this.filePath;
        data["fileName"] = this.fileName;
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["currentLanguage"] = this.currentLanguage;
        data["apiUrl"] = this.apiUrl;
        return data;
    }
}

export interface IWarrantyAdjustmentImportJobArgs {
    codePrefix: string | undefined;
    approver: string | undefined;
    reason: string | undefined;
    type: string | undefined;
    tableName: string | undefined;
    filePath: string | undefined;
    fileName: string | undefined;
    userId: number | undefined;
    tenantId: number | undefined;
    currentLanguage: string | undefined;
    apiUrl: string | undefined;
}

export class PagedResultDtoOfGetWarrantyAdjustmentLogForView implements IPagedResultDtoOfGetWarrantyAdjustmentLogForView {
    totalCount!: number | undefined;
    items!: GetWarrantyAdjustmentLogForView[] | undefined;

    constructor(data?: IPagedResultDtoOfGetWarrantyAdjustmentLogForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetWarrantyAdjustmentLogForView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetWarrantyAdjustmentLogForView {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetWarrantyAdjustmentLogForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetWarrantyAdjustmentLogForView {
    totalCount: number | undefined;
    items: GetWarrantyAdjustmentLogForView[] | undefined;
}

export class GetWarrantyAdjustmentLogForView implements IGetWarrantyAdjustmentLogForView {
    warrantyAdjustmentLog!: WarrantyAdjustmentLogDto | undefined;
    updatedBy!: string | undefined;

    constructor(data?: IGetWarrantyAdjustmentLogForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.warrantyAdjustmentLog = data["warrantyAdjustmentLog"] ? WarrantyAdjustmentLogDto.fromJS(data["warrantyAdjustmentLog"]) : <any>undefined;
            this.updatedBy = data["updatedBy"];
        }
    }

    static fromJS(data: any): GetWarrantyAdjustmentLogForView {
        data = typeof data === 'object' ? data : {};
        let result = new GetWarrantyAdjustmentLogForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["warrantyAdjustmentLog"] = this.warrantyAdjustmentLog ? this.warrantyAdjustmentLog.toJSON() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IGetWarrantyAdjustmentLogForView {
    warrantyAdjustmentLog: WarrantyAdjustmentLogDto | undefined;
    updatedBy: string | undefined;
}

export class WarrantyAdjustmentLogDto implements IWarrantyAdjustmentLogDto {
    approver!: string | undefined;
    serial!: string | undefined;
    old_InternalExpiredDate_MainDevice!: moment.Moment | undefined;
    old_PublicExpiredDate_MainDevice!: moment.Moment | undefined;
    old_InternalExpiredDate_Accessory!: moment.Moment | undefined;
    old_PublicExpiredDate_Accessory!: moment.Moment | undefined;
    old_EffectRegistration!: number | undefined;
    new_InternalExpiredDate_MainDevice!: moment.Moment | undefined;
    new_PublicExpiredDate_MainDevice!: moment.Moment | undefined;
    new_InternalExpiredDate_Accessory!: moment.Moment | undefined;
    new_PublicExpiredDate_Accessory!: moment.Moment | undefined;
    new_EffectRegistration!: number | undefined;
    old_CustomerName!: string | undefined;
    new_CustomerName!: string | undefined;
    old_Phone!: string | undefined;
    new_Phone!: string | undefined;
    old_ProvinceCode!: string | undefined;
    old_ProvinceName!: string | undefined;
    new_ProvinceCode!: string | undefined;
    new_ProvinceName!: string | undefined;
    old_DistrictCode!: string | undefined;
    old_DistrictName!: string | undefined;
    new_DistrictCode!: string | undefined;
    new_DistrictName!: string | undefined;
    old_Address!: string | undefined;
    new_Address!: string | undefined;
    old_Email!: string | undefined;
    new_Email!: string | undefined;
    businessDate!: moment.Moment | undefined;
    description!: string | undefined;
    source!: string | undefined;
    notes!: string | undefined;
    isDeleted!: boolean | undefined;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: moment.Moment | undefined;
    creatorUserId!: number | undefined;
    id!: number | undefined;

    constructor(data?: IWarrantyAdjustmentLogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.approver = data["approver"];
            this.serial = data["serial"];
            this.old_InternalExpiredDate_MainDevice = data["old_InternalExpiredDate_MainDevice"] ? moment(data["old_InternalExpiredDate_MainDevice"].toString()) : <any>undefined;
            this.old_PublicExpiredDate_MainDevice = data["old_PublicExpiredDate_MainDevice"] ? moment(data["old_PublicExpiredDate_MainDevice"].toString()) : <any>undefined;
            this.old_InternalExpiredDate_Accessory = data["old_InternalExpiredDate_Accessory"] ? moment(data["old_InternalExpiredDate_Accessory"].toString()) : <any>undefined;
            this.old_PublicExpiredDate_Accessory = data["old_PublicExpiredDate_Accessory"] ? moment(data["old_PublicExpiredDate_Accessory"].toString()) : <any>undefined;
            this.old_EffectRegistration = data["old_EffectRegistration"];
            this.new_InternalExpiredDate_MainDevice = data["new_InternalExpiredDate_MainDevice"] ? moment(data["new_InternalExpiredDate_MainDevice"].toString()) : <any>undefined;
            this.new_PublicExpiredDate_MainDevice = data["new_PublicExpiredDate_MainDevice"] ? moment(data["new_PublicExpiredDate_MainDevice"].toString()) : <any>undefined;
            this.new_InternalExpiredDate_Accessory = data["new_InternalExpiredDate_Accessory"] ? moment(data["new_InternalExpiredDate_Accessory"].toString()) : <any>undefined;
            this.new_PublicExpiredDate_Accessory = data["new_PublicExpiredDate_Accessory"] ? moment(data["new_PublicExpiredDate_Accessory"].toString()) : <any>undefined;
            this.new_EffectRegistration = data["new_EffectRegistration"];
            this.old_CustomerName = data["old_CustomerName"];
            this.new_CustomerName = data["new_CustomerName"];
            this.old_Phone = data["old_Phone"];
            this.new_Phone = data["new_Phone"];
            this.old_ProvinceCode = data["old_ProvinceCode"];
            this.old_ProvinceName = data["old_ProvinceName"];
            this.new_ProvinceCode = data["new_ProvinceCode"];
            this.new_ProvinceName = data["new_ProvinceName"];
            this.old_DistrictCode = data["old_DistrictCode"];
            this.old_DistrictName = data["old_DistrictName"];
            this.new_DistrictCode = data["new_DistrictCode"];
            this.new_DistrictName = data["new_DistrictName"];
            this.old_Address = data["old_Address"];
            this.new_Address = data["new_Address"];
            this.old_Email = data["old_Email"];
            this.new_Email = data["new_Email"];
            this.businessDate = data["businessDate"] ? moment(data["businessDate"].toString()) : <any>undefined;
            this.description = data["description"];
            this.source = data["source"];
            this.notes = data["notes"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): WarrantyAdjustmentLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new WarrantyAdjustmentLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["approver"] = this.approver;
        data["serial"] = this.serial;
        data["old_InternalExpiredDate_MainDevice"] = this.old_InternalExpiredDate_MainDevice ? moment(this.old_InternalExpiredDate_MainDevice).add(7, 'hours').toISOString() : <any>undefined;
        data["old_PublicExpiredDate_MainDevice"] = this.old_PublicExpiredDate_MainDevice ? moment(this.old_PublicExpiredDate_MainDevice).add(7, 'hours').toISOString() : <any>undefined;
        data["old_InternalExpiredDate_Accessory"] = this.old_InternalExpiredDate_Accessory ? moment(this.old_InternalExpiredDate_Accessory).add(7, 'hours').toISOString() : <any>undefined;
        data["old_PublicExpiredDate_Accessory"] = this.old_PublicExpiredDate_Accessory ? moment(this.old_PublicExpiredDate_Accessory).add(7, 'hours').toISOString() : <any>undefined;
        data["old_EffectRegistration"] = this.old_EffectRegistration;
        data["new_InternalExpiredDate_MainDevice"] = this.new_InternalExpiredDate_MainDevice ? moment(this.new_InternalExpiredDate_MainDevice).add(7, 'hours').toISOString() : <any>undefined;
        data["new_PublicExpiredDate_MainDevice"] = this.new_PublicExpiredDate_MainDevice ? moment(this.new_PublicExpiredDate_MainDevice).add(7, 'hours').toISOString() : <any>undefined;
        data["new_InternalExpiredDate_Accessory"] = this.new_InternalExpiredDate_Accessory ? moment(this.new_InternalExpiredDate_Accessory).add(7, 'hours').toISOString() : <any>undefined;
        data["new_PublicExpiredDate_Accessory"] = this.new_PublicExpiredDate_Accessory ? moment(this.new_PublicExpiredDate_Accessory).add(7, 'hours').toISOString() : <any>undefined;
        data["new_EffectRegistration"] = this.new_EffectRegistration;
        data["old_CustomerName"] = this.old_CustomerName;
        data["new_CustomerName"] = this.new_CustomerName;
        data["old_Phone"] = this.old_Phone;
        data["new_Phone"] = this.new_Phone;
        data["old_ProvinceCode"] = this.old_ProvinceCode;
        data["old_ProvinceName"] = this.old_ProvinceName;
        data["new_ProvinceCode"] = this.new_ProvinceCode;
        data["new_ProvinceName"] = this.new_ProvinceName;
        data["old_DistrictCode"] = this.old_DistrictCode;
        data["old_DistrictName"] = this.old_DistrictName;
        data["new_DistrictCode"] = this.new_DistrictCode;
        data["new_DistrictName"] = this.new_DistrictName;
        data["old_Address"] = this.old_Address;
        data["new_Address"] = this.new_Address;
        data["old_Email"] = this.old_Email;
        data["new_Email"] = this.new_Email;
        data["businessDate"] = this.businessDate ? moment(this.businessDate).add(7, 'hours').toISOString() : <any>undefined;
        data["description"] = this.description;
        data["source"] = this.source;
        data["notes"] = this.notes;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? moment(this.deletionTime).add(7, 'hours').toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? moment(this.lastModificationTime).add(7, 'hours').toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? moment(this.creationTime).add(7, 'hours').toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IWarrantyAdjustmentLogDto {
    approver: string | undefined;
    serial: string | undefined;
    old_InternalExpiredDate_MainDevice: moment.Moment | undefined;
    old_PublicExpiredDate_MainDevice: moment.Moment | undefined;
    old_InternalExpiredDate_Accessory: moment.Moment | undefined;
    old_PublicExpiredDate_Accessory: moment.Moment | undefined;
    old_EffectRegistration: number | undefined;
    new_InternalExpiredDate_MainDevice: moment.Moment | undefined;
    new_PublicExpiredDate_MainDevice: moment.Moment | undefined;
    new_InternalExpiredDate_Accessory: moment.Moment | undefined;
    new_PublicExpiredDate_Accessory: moment.Moment | undefined;
    new_EffectRegistration: number | undefined;
    old_CustomerName: string | undefined;
    new_CustomerName: string | undefined;
    old_Phone: string | undefined;
    new_Phone: string | undefined;
    old_ProvinceCode: string | undefined;
    old_ProvinceName: string | undefined;
    new_ProvinceCode: string | undefined;
    new_ProvinceName: string | undefined;
    old_DistrictCode: string | undefined;
    old_DistrictName: string | undefined;
    new_DistrictCode: string | undefined;
    new_DistrictName: string | undefined;
    old_Address: string | undefined;
    new_Address: string | undefined;
    old_Email: string | undefined;
    new_Email: string | undefined;
    businessDate: moment.Moment | undefined;
    description: string | undefined;
    source: string | undefined;
    notes: string | undefined;
    isDeleted: boolean | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class WarrantyCancelRequestDto implements IWarrantyCancelRequestDto {
    serial!: string | undefined;
    description!: string | undefined;

    constructor(data?: IWarrantyCancelRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.serial = data["serial"];
            this.description = data["description"];
        }
    }

    static fromJS(data: any): WarrantyCancelRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new WarrantyCancelRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serial"] = this.serial;
        data["description"] = this.description;
        return data;
    }
}

export interface IWarrantyCancelRequestDto {
    serial: string | undefined;
    description: string | undefined;
}

export class RegisterWarrantyRequestDto implements IRegisterWarrantyRequestDto {
    serial!: string | undefined;
    serialExt!: string | undefined;
    customerName!: string | undefined;
    phone!: string | undefined;
    provinceCode!: string | undefined;
    provinceName!: string | undefined;
    districtCode!: string | undefined;
    districtName!: string | undefined;
    productType!: string | undefined;
    notActive!: boolean | undefined;
    saleType!: string | undefined;

    constructor(data?: IRegisterWarrantyRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.serial = data["serial"];
            this.serialExt = data["serialExt"];
            this.customerName = data["customerName"];
            this.phone = data["phone"];
            this.provinceCode = data["provinceCode"];
            this.provinceName = data["provinceName"];
            this.districtCode = data["districtCode"];
            this.districtName = data["districtName"];
            this.productType = data["productType"];
            this.notActive = data["notActive"];
            this.saleType = data["saleType"];
        }
    }

    static fromJS(data: any): RegisterWarrantyRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterWarrantyRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serial"] = this.serial;
        data["serialExt"] = this.serialExt;
        data["customerName"] = this.customerName;
        data["phone"] = this.phone;
        data["provinceCode"] = this.provinceCode;
        data["provinceName"] = this.provinceName;
        data["districtCode"] = this.districtCode;
        data["districtName"] = this.districtName;
        data["productType"] = this.productType;
        data["notActive"] = this.notActive;
        data["saleType"] = this.saleType;
        return data;
    }
}

export interface IRegisterWarrantyRequestDto {
    serial: string | undefined;
    serialExt: string | undefined;
    customerName: string | undefined;
    phone: string | undefined;
    provinceCode: string | undefined;
    provinceName: string | undefined;
    districtCode: string | undefined;
    districtName: string | undefined;
    productType: string | undefined;
    notActive: boolean | undefined;
    saleType: string | undefined;
}

export class RegisterWarrantyResponseDto implements IRegisterWarrantyResponseDto {
    success!: boolean | undefined;
    errorMsg!: string | undefined;

    constructor(data?: IRegisterWarrantyResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.success = data["success"];
            this.errorMsg = data["errorMsg"];
        }
    }

    static fromJS(data: any): RegisterWarrantyResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterWarrantyResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorMsg"] = this.errorMsg;
        return data;
    }
}

export interface IRegisterWarrantyResponseDto {
    success: boolean | undefined;
    errorMsg: string | undefined;
}

export class VerifySerialRequestDto implements IVerifySerialRequestDto {
    serial!: string | undefined;
    serialExt!: string | undefined;
    productType!: string | undefined;

    constructor(data?: IVerifySerialRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.serial = data["serial"];
            this.serialExt = data["serialExt"];
            this.productType = data["productType"];
        }
    }

    static fromJS(data: any): VerifySerialRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new VerifySerialRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serial"] = this.serial;
        data["serialExt"] = this.serialExt;
        data["productType"] = this.productType;
        return data;
    }
}

export interface IVerifySerialRequestDto {
    serial: string | undefined;
    serialExt: string | undefined;
    productType: string | undefined;
}

export class VerifySerialResponseDto implements IVerifySerialResponseDto {
    success!: boolean | undefined;
    errorMsg!: string | undefined;
    productCode!: string | undefined;
    productCodeExt!: string | undefined;
    expiredDate!: string | undefined;
    expiredDateExt!: string | undefined;

    constructor(data?: IVerifySerialResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.success = data["success"];
            this.errorMsg = data["errorMsg"];
            this.productCode = data["productCode"];
            this.productCodeExt = data["productCodeExt"];
            this.expiredDate = data["expiredDate"];
            this.expiredDateExt = data["expiredDateExt"];
        }
    }

    static fromJS(data: any): VerifySerialResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new VerifySerialResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["errorMsg"] = this.errorMsg;
        data["productCode"] = this.productCode;
        data["productCodeExt"] = this.productCodeExt;
        data["expiredDate"] = this.expiredDate;
        data["expiredDateExt"] = this.expiredDateExt;
        return data;
    }
}

export interface IVerifySerialResponseDto {
    success: boolean | undefined;
    errorMsg: string | undefined;
    productCode: string | undefined;
    productCodeExt: string | undefined;
    expiredDate: string | undefined;
    expiredDateExt: string | undefined;
}

export class GetSerialWarrantyDetailResponseDto implements IGetSerialWarrantyDetailResponseDto {
    success!: boolean | undefined;
    isRegisterCSKH!: boolean | undefined;
    isRegisted!: boolean | undefined;
    errorMsg!: string | undefined;
    modelName!: string | undefined;
    warrantyInfos!: GetSerialWarrantyDetail_Device_Dto[] | undefined;

    constructor(data?: IGetSerialWarrantyDetailResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.success = data["success"];
            this.isRegisterCSKH = data["isRegisterCSKH"];
            this.isRegisted = data["isRegisted"];
            this.errorMsg = data["errorMsg"];
            this.modelName = data["modelName"];
            if (data["warrantyInfos"] && data["warrantyInfos"].constructor === Array) {
                this.warrantyInfos = [];
                for (let item of data["warrantyInfos"])
                    this.warrantyInfos.push(GetSerialWarrantyDetail_Device_Dto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetSerialWarrantyDetailResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetSerialWarrantyDetailResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["isRegisterCSKH"] = this.isRegisterCSKH;
        data["isRegisted"] = this.isRegisted;
        data["errorMsg"] = this.errorMsg;
        data["modelName"] = this.modelName;
        if (this.warrantyInfos && this.warrantyInfos.constructor === Array) {
            data["warrantyInfos"] = [];
            for (let item of this.warrantyInfos)
                data["warrantyInfos"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetSerialWarrantyDetailResponseDto {
    success: boolean | undefined;
    isRegisterCSKH: boolean | undefined;
    isRegisted: boolean | undefined;
    errorMsg: string | undefined;
    modelName: string | undefined;
    warrantyInfos: GetSerialWarrantyDetail_Device_Dto[] | undefined;
}

export class GetSerialWarrantyDetail_Device_Dto implements IGetSerialWarrantyDetail_Device_Dto {
    deviceName!: string | undefined;
    expiredDate!: moment.Moment | undefined;
    productCode!: string | undefined;

    constructor(data?: IGetSerialWarrantyDetail_Device_Dto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.deviceName = data["deviceName"];
            this.expiredDate = data["expiredDate"] ? moment(data["expiredDate"].toString()) : <any>undefined;
            this.productCode = data["productCode"];
        }
    }

    static fromJS(data: any): GetSerialWarrantyDetail_Device_Dto {
        data = typeof data === 'object' ? data : {};
        let result = new GetSerialWarrantyDetail_Device_Dto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceName"] = this.deviceName;
        data["expiredDate"] = this.expiredDate ? this.expiredDate.toISOString() : <any>undefined;
        data["productCode"] = this.productCode;
        return data;
    }
}

export interface IGetSerialWarrantyDetail_Device_Dto {
    deviceName: string | undefined;
    expiredDate: moment.Moment | undefined;
    productCode: string | undefined;
}

export class PagedResultDtoOfGetRelatedProductForViewDto implements IPagedResultDtoOfGetRelatedProductForViewDto {
    totalCount!: number | undefined;
    items!: GetRelatedProductForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetRelatedProductForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetRelatedProductForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetRelatedProductForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetRelatedProductForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetRelatedProductForViewDto {
    totalCount: number | undefined;
    items: GetRelatedProductForViewDto[] | undefined;
}

export class GetRelatedProductForViewDto implements IGetRelatedProductForViewDto {
    relatedProduct!: RelatedProductDto | undefined;

    constructor(data?: IGetRelatedProductForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.relatedProduct = data["relatedProduct"] ? RelatedProductDto.fromJS(data["relatedProduct"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetRelatedProductForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetRelatedProductForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["relatedProduct"] = this.relatedProduct ? this.relatedProduct.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetRelatedProductForViewDto {
    relatedProduct: RelatedProductDto | undefined;
}

export class RelatedProductDto implements IRelatedProductDto {
    productId!: number | undefined;
    relatedProductId!: number | undefined;
    id!: number | undefined;

    constructor(data?: IRelatedProductDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.productId = data["productId"];
            this.relatedProductId = data["relatedProductId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): RelatedProductDto {
        data = typeof data === 'object' ? data : {};
        let result = new RelatedProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["relatedProductId"] = this.relatedProductId;
        data["id"] = this.id;
        return data;
    }
}

export interface IRelatedProductDto {
    productId: number | undefined;
    relatedProductId: number | undefined;
    id: number | undefined;
}

export class GetRelatedProductForEditOutput implements IGetRelatedProductForEditOutput {
    relatedProduct!: CreateOrEditRelatedProductDto | undefined;

    constructor(data?: IGetRelatedProductForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.relatedProduct = data["relatedProduct"] ? CreateOrEditRelatedProductDto.fromJS(data["relatedProduct"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetRelatedProductForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetRelatedProductForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["relatedProduct"] = this.relatedProduct ? this.relatedProduct.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetRelatedProductForEditOutput {
    relatedProduct: CreateOrEditRelatedProductDto | undefined;
}

export class CreateOrEditRelatedProductDto implements ICreateOrEditRelatedProductDto {
    productId!: number | undefined;
    relatedProductId!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditRelatedProductDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.productId = data["productId"];
            this.relatedProductId = data["relatedProductId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditRelatedProductDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditRelatedProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["relatedProductId"] = this.relatedProductId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditRelatedProductDto {
    productId: number | undefined;
    relatedProductId: number | undefined;
    id: number | undefined;
}

export class GetAllRelatedProductForAdd implements IGetAllRelatedProductForAdd {
    filter!: string | undefined;
    productCodeFilter!: string | undefined;
    productName1Filter!: string | undefined;
    productName2Filter!: string | undefined;
    statusFilter!: string | undefined;
    productName2UnSignFilter!: string | undefined;
    productName1UnSignFilter!: string | undefined;
    imageLinkFilter!: string | undefined;
    isNewFilter!: number | undefined;
    tagFilter!: string | undefined;
    contentVNFilter!: string | undefined;
    contentENFilter!: string | undefined;
    isFeatureFilter!: number | undefined;
    listIdExist!: number[] | undefined;
    sorting!: string | undefined;
    skipCount!: number | undefined;
    maxResultCount!: number | undefined;

    constructor(data?: IGetAllRelatedProductForAdd) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.filter = data["filter"];
            this.productCodeFilter = data["productCodeFilter"];
            this.productName1Filter = data["productName1Filter"];
            this.productName2Filter = data["productName2Filter"];
            this.statusFilter = data["statusFilter"];
            this.productName2UnSignFilter = data["productName2UnSignFilter"];
            this.productName1UnSignFilter = data["productName1UnSignFilter"];
            this.imageLinkFilter = data["imageLinkFilter"];
            this.isNewFilter = data["isNewFilter"];
            this.tagFilter = data["tagFilter"];
            this.contentVNFilter = data["contentVNFilter"];
            this.contentENFilter = data["contentENFilter"];
            this.isFeatureFilter = data["isFeatureFilter"];
            if (data["listIdExist"] && data["listIdExist"].constructor === Array) {
                this.listIdExist = [];
                for (let item of data["listIdExist"])
                    this.listIdExist.push(item);
            }
            this.sorting = data["sorting"];
            this.skipCount = data["skipCount"];
            this.maxResultCount = data["maxResultCount"];
        }
    }

    static fromJS(data: any): GetAllRelatedProductForAdd {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllRelatedProductForAdd();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        data["productCodeFilter"] = this.productCodeFilter;
        data["productName1Filter"] = this.productName1Filter;
        data["productName2Filter"] = this.productName2Filter;
        data["statusFilter"] = this.statusFilter;
        data["productName2UnSignFilter"] = this.productName2UnSignFilter;
        data["productName1UnSignFilter"] = this.productName1UnSignFilter;
        data["imageLinkFilter"] = this.imageLinkFilter;
        data["isNewFilter"] = this.isNewFilter;
        data["tagFilter"] = this.tagFilter;
        data["contentVNFilter"] = this.contentVNFilter;
        data["contentENFilter"] = this.contentENFilter;
        data["isFeatureFilter"] = this.isFeatureFilter;
        if (this.listIdExist && this.listIdExist.constructor === Array) {
            data["listIdExist"] = [];
            for (let item of this.listIdExist)
                data["listIdExist"].push(item);
        }
        data["sorting"] = this.sorting;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data;
    }
}

export interface IGetAllRelatedProductForAdd {
    filter: string | undefined;
    productCodeFilter: string | undefined;
    productName1Filter: string | undefined;
    productName2Filter: string | undefined;
    statusFilter: string | undefined;
    productName2UnSignFilter: string | undefined;
    productName1UnSignFilter: string | undefined;
    imageLinkFilter: string | undefined;
    isNewFilter: number | undefined;
    tagFilter: string | undefined;
    contentVNFilter: string | undefined;
    contentENFilter: string | undefined;
    isFeatureFilter: number | undefined;
    listIdExist: number[] | undefined;
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;
}

export class ReportSettingDto implements IReportSettingDto {
    tenantId!: number | undefined;
    totalEstimateCost!: number | undefined;
    coinValue!: number | undefined;
    activeDayRequired!: number | undefined;
    lastModifierUserName!: string | undefined;
    isDeleted!: boolean | undefined;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: moment.Moment | undefined;
    creatorUserId!: number | undefined;
    id!: number | undefined;

    constructor(data?: IReportSettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.totalEstimateCost = data["totalEstimateCost"];
            this.coinValue = data["coinValue"];
            this.activeDayRequired = data["activeDayRequired"];
            this.lastModifierUserName = data["lastModifierUserName"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ReportSettingDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReportSettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["totalEstimateCost"] = this.totalEstimateCost;
        data["coinValue"] = this.coinValue;
        data["activeDayRequired"] = this.activeDayRequired;
        data["lastModifierUserName"] = this.lastModifierUserName;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IReportSettingDto {
    tenantId: number | undefined;
    totalEstimateCost: number | undefined;
    coinValue: number | undefined;
    activeDayRequired: number | undefined;
    lastModifierUserName: string | undefined;
    isDeleted: boolean | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class CreateOrEditRequestInput implements ICreateOrEditRequestInput {
    requestType!: string | undefined;
    requestStatus!: string | undefined;
    step!: number | undefined;
    description!: string | undefined;
    creatorName!: string | undefined;
    lastModifierName!: string | undefined;
    memberCode!: string | undefined;
    memberName!: string | undefined;
    content!: string | undefined;
    filePath!: string | undefined;
    beatPlanCode!: string | undefined;
    province!: string | undefined;
    rejectMessage!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditRequestInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.requestType = data["requestType"];
            this.requestStatus = data["requestStatus"];
            this.step = data["step"];
            this.description = data["description"];
            this.creatorName = data["creatorName"];
            this.lastModifierName = data["lastModifierName"];
            this.memberCode = data["memberCode"];
            this.memberName = data["memberName"];
            this.content = data["content"];
            this.filePath = data["filePath"];
            this.beatPlanCode = data["beatPlanCode"];
            this.province = data["province"];
            this.rejectMessage = data["rejectMessage"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditRequestInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditRequestInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestType"] = this.requestType;
        data["requestStatus"] = this.requestStatus;
        data["step"] = this.step;
        data["description"] = this.description;
        data["creatorName"] = this.creatorName;
        data["lastModifierName"] = this.lastModifierName;
        data["memberCode"] = this.memberCode;
        data["memberName"] = this.memberName;
        data["content"] = this.content;
        data["filePath"] = this.filePath;
        data["beatPlanCode"] = this.beatPlanCode;
        data["province"] = this.province;
        data["rejectMessage"] = this.rejectMessage;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditRequestInput {
    requestType: string | undefined;
    requestStatus: string | undefined;
    step: number | undefined;
    description: string | undefined;
    creatorName: string | undefined;
    lastModifierName: string | undefined;
    memberCode: string | undefined;
    memberName: string | undefined;
    content: string | undefined;
    filePath: string | undefined;
    beatPlanCode: string | undefined;
    province: string | undefined;
    rejectMessage: string | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfGetListRequestResponse implements IPagedResultDtoOfGetListRequestResponse {
    totalCount!: number | undefined;
    items!: GetListRequestResponse[] | undefined;

    constructor(data?: IPagedResultDtoOfGetListRequestResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetListRequestResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetListRequestResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetListRequestResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetListRequestResponse {
    totalCount: number | undefined;
    items: GetListRequestResponse[] | undefined;
}

export class GetListRequestResponse implements IGetListRequestResponse {
    requestCode!: string | undefined;
    requestType!: string | undefined;
    requestStatus!: string | undefined;
    step!: number | undefined;
    description!: string | undefined;
    creatorName!: string | undefined;
    lastModifierName!: string | undefined;
    partnerId!: number | undefined;
    partnerName!: string | undefined;
    assignerId!: number | undefined;
    assignerName!: string | undefined;
    totalStep!: number | undefined;
    titleName!: string | undefined;
    memberName!: string | undefined;
    memberCode!: string | undefined;
    phone!: string | undefined;
    rejectMessage!: string | undefined;
    infoId!: number | undefined;
    regionName!: string | undefined;
    province!: string | undefined;
    isDeleted!: boolean | undefined;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: moment.Moment | undefined;
    creatorUserId!: number | undefined;
    id!: number | undefined;
    outletType!: string | undefined;

    constructor(data?: IGetListRequestResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.requestCode = data["requestCode"];
            this.requestType = data["requestType"];
            this.requestStatus = data["requestStatus"];
            this.step = data["step"];
            this.description = data["description"];
            this.creatorName = data["creatorName"];
            this.lastModifierName = data["lastModifierName"];
            this.partnerId = data["partnerId"];
            this.partnerName = data["partnerName"];
            this.assignerId = data["assignerId"];
            this.assignerName = data["assignerName"];
            this.totalStep = data["totalStep"];
            this.titleName = data["titleName"];
            this.memberName = data["memberName"];
            this.memberCode = data["memberCode"];
            this.phone = data["phone"];
            this.rejectMessage = data["rejectMessage"];
            this.infoId = data["infoId"];
            this.regionName = data["regionName"];
            this.province = data["province"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
            this.outletType = data["outletType"];
        }
    }

    static fromJS(data: any): GetListRequestResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetListRequestResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestCode"] = this.requestCode;
        data["requestType"] = this.requestType;
        data["requestStatus"] = this.requestStatus;
        data["step"] = this.step;
        data["description"] = this.description;
        data["creatorName"] = this.creatorName;
        data["lastModifierName"] = this.lastModifierName;
        data["partnerId"] = this.partnerId;
        data["partnerName"] = this.partnerName;
        data["assignerId"] = this.assignerId;
        data["assignerName"] = this.assignerName;
        data["totalStep"] = this.totalStep;
        data["titleName"] = this.titleName;
        data["memberName"] = this.memberName;
        data["memberCode"] = this.memberCode;
        data["phone"] = this.phone;
        data["rejectMessage"] = this.rejectMessage;
        data["infoId"] = this.infoId;
        data["regionName"] = this.regionName;
        data["province"] = this.province;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IGetListRequestResponse {
    requestCode: string | undefined;
    requestType: string | undefined;
    requestStatus: string | undefined;
    step: number | undefined;
    description: string | undefined;
    creatorName: string | undefined;
    lastModifierName: string | undefined;
    partnerId: number | undefined;
    partnerName: string | undefined;
    assignerId: number | undefined;
    assignerName: string | undefined;
    totalStep: number | undefined;
    titleName: string | undefined;
    memberName: string | undefined;
    memberCode: string | undefined;
    phone: string | undefined;
    rejectMessage: string | undefined;
    infoId: number | undefined;
    regionName: string | undefined;
    province: string | undefined;
    isDeleted: boolean | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class GetRequestInput implements IGetRequestInput {
    requestCode!: string | undefined;
    requestType!: string | undefined;
    fromDate!: moment.Moment | undefined;
    toDate!: moment.Moment | undefined;
    assignerId!: number | undefined;
    assignerName!: string | undefined;
    requestStatus!: string | undefined;
    unsign!: string | undefined;
    phone!: string | undefined;
    memberCode!: string | undefined;
    memberName!: string | undefined;
    outletTypeFilter!: string[] | undefined;
    sorting!: string | undefined;
    skipCount!: number | undefined;
    maxResultCount!: number | undefined;

    constructor(data?: IGetRequestInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.requestCode = data["requestCode"];
            this.requestType = data["requestType"];
            this.fromDate = data["fromDate"] ? moment(data["fromDate"].toString()) : <any>undefined;
            this.toDate = data["toDate"] ? moment(data["toDate"].toString()) : <any>undefined;
            this.assignerId = data["assignerId"];
            this.assignerName = data["assignerName"];
            this.requestStatus = data["requestStatus"];
            this.unsign = data["unsign"];
            this.phone = data["phone"];
            this.memberCode = data["memberCode"];
            this.memberName = data["memberName"];
            if (Array.isArray(data["outletTypeFilter"])) {
                this.outletTypeFilter = [] as any;
                for (let item of data["outletTypeFilter"])
                    this.outletTypeFilter!.push(item);
            }
            this.sorting = data["sorting"];
            this.skipCount = data["skipCount"];
            this.maxResultCount = data["maxResultCount"];
        }
    }

    static fromJS(data: any): GetRequestInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetRequestInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestCode"] = this.requestCode;
        data["requestType"] = this.requestType;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data["assignerId"] = this.assignerId;
        data["assignerName"] = this.assignerName;
        data["requestStatus"] = this.requestStatus;
        data["unsign"] = this.unsign;
        data["phone"] = this.phone;
        data["memberCode"] = this.memberCode;
        data["memberName"] = this.memberName;
        if (Array.isArray(this.outletTypeFilter)) {
            data["outletTypeFilter"] = [];
            for (let item of this.outletTypeFilter)
                data["outletTypeFilter"].push(item);
        }
        data["sorting"] = this.sorting;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data;
    }
}

export interface IGetRequestInput {
    requestCode: string | undefined;
    requestType: string | undefined;
    fromDate: moment.Moment | undefined;
    toDate: moment.Moment | undefined;
    assignerId: number | undefined;
    assignerName: string | undefined;
    requestStatus: string | undefined;
    unsign: string | undefined;
    phone: string | undefined;
    memberCode: string | undefined;
    memberName: string | undefined;
    outletTypeFilter: string[] | undefined;
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;
}

export class GetDetailRequestResponse implements IGetDetailRequestResponse {
    listAssignerId!: number[] | undefined;
    listComment!: RequestCommentDto[] | undefined;
    id!: number | undefined;

    constructor(data?: IGetDetailRequestResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["listAssignerId"] && data["listAssignerId"].constructor === Array) {
                this.listAssignerId = [];
                for (let item of data["listAssignerId"])
                    this.listAssignerId.push(item);
            }
            if (data["listComment"] && data["listComment"].constructor === Array) {
                this.listComment = [];
                for (let item of data["listComment"])
                    this.listComment.push(RequestCommentDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): GetDetailRequestResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDetailRequestResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.listAssignerId && this.listAssignerId.constructor === Array) {
            data["listAssignerId"] = [];
            for (let item of this.listAssignerId)
                data["listAssignerId"].push(item);
        }
        if (this.listComment && this.listComment.constructor === Array) {
            data["listComment"] = [];
            for (let item of this.listComment)
                data["listComment"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IGetDetailRequestResponse {
    listAssignerId: number[] | undefined;
    listComment: RequestCommentDto[] | undefined;
    id: number | undefined;
}

export class RequestCommentDto implements IRequestCommentDto {
    tenantId!: number | undefined;
    requestId!: number | undefined;
    userId!: number | undefined;
    content!: string | undefined;
    filePath!: string | undefined;
    step!: number | undefined;
    creatorName!: string | undefined;
    createdDate!: moment.Moment | undefined;
    isDeleted!: boolean | undefined;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: moment.Moment | undefined;
    creatorUserId!: number | undefined;
    id!: number | undefined;

    constructor(data?: IRequestCommentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.requestId = data["requestId"];
            this.userId = data["userId"];
            this.content = data["content"];
            this.filePath = data["filePath"];
            this.step = data["step"];
            this.creatorName = data["creatorName"];
            this.createdDate = data["createdDate"] ? moment(data["createdDate"].toString()) : <any>undefined;
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): RequestCommentDto {
        data = typeof data === 'object' ? data : {};
        let result = new RequestCommentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["requestId"] = this.requestId;
        data["userId"] = this.userId;
        data["content"] = this.content;
        data["filePath"] = this.filePath;
        data["step"] = this.step;
        data["creatorName"] = this.creatorName;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IRequestCommentDto {
    tenantId: number | undefined;
    requestId: number | undefined;
    userId: number | undefined;
    content: string | undefined;
    filePath: string | undefined;
    step: number | undefined;
    creatorName: string | undefined;
    createdDate: moment.Moment | undefined;
    isDeleted: boolean | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class CheckProfileRequestOutput implements ICheckProfileRequestOutput {
    status!: number | undefined;

    constructor(data?: ICheckProfileRequestOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.status = data["status"];
        }
    }

    static fromJS(data: any): CheckProfileRequestOutput {
        data = typeof data === 'object' ? data : {};
        let result = new CheckProfileRequestOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        return data;
    }
}

export interface ICheckProfileRequestOutput {
    status: number | undefined;
}

export class PagedResultDtoOfRewardItemResourceDTO implements IPagedResultDtoOfRewardItemResourceDTO {
    totalCount!: number | undefined;
    items!: RewardItemResourceDTO[] | undefined;

    constructor(data?: IPagedResultDtoOfRewardItemResourceDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(RewardItemResourceDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfRewardItemResourceDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfRewardItemResourceDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfRewardItemResourceDTO {
    totalCount: number | undefined;
    items: RewardItemResourceDTO[] | undefined;
}

export class RewardItemResourceDTO implements IRewardItemResourceDTO {
    id!: number | undefined;
    code!: string | undefined;
    name!: string | undefined;
    rewardType!: string | undefined;
    imageUrl!: string | undefined;
    isActive!: boolean | undefined;
    isExitCampaign!: boolean | undefined;
    pointCost!: number | undefined;
    monetaryValue!: number | undefined;
    creationTime!: moment.Moment | undefined;
    creationName!: string | undefined;
    creatorUserId!: number | undefined;

    constructor(data?: IRewardItemResourceDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.code = data["code"];
            this.name = data["name"];
            this.rewardType = data["rewardType"];
            this.imageUrl = data["imageUrl"];
            this.isActive = data["isActive"];
            this.isExitCampaign = data["isExitCampaign"];
            this.pointCost = data["pointCost"];
            this.monetaryValue = data["monetaryValue"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creationName = data["creationName"];
            this.creatorUserId = data["creatorUserId"];
        }
    }

    static fromJS(data: any): RewardItemResourceDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RewardItemResourceDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        data["rewardType"] = this.rewardType;
        data["imageUrl"] = this.imageUrl;
        data["isActive"] = this.isActive;
        data["isExitCampaign"] = this.isExitCampaign;
        data["pointCost"] = this.pointCost;
        data["monetaryValue"] = this.monetaryValue;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creationName"] = this.creationName;
        data["creatorUserId"] = this.creatorUserId;
        return data;
    }
}

export interface IRewardItemResourceDTO {
    id: number | undefined;
    code: string | undefined;
    name: string | undefined;
    rewardType: string | undefined;
    imageUrl: string | undefined;
    isActive: boolean | undefined;
    isExitCampaign: boolean | undefined;
    pointCost: number | undefined;
    monetaryValue: number | undefined;
    creationTime: moment.Moment | undefined;
    creationName: string | undefined;
    creatorUserId: number | undefined;
}

export class RewardItemDetailResource implements IRewardItemDetailResource {
    id!: number | undefined;
    code!: string | undefined;
    name!: string | undefined;
    description!: string | undefined;
    rewardType!: string | undefined;
    imageUrl!: string | undefined;
    isActive!: boolean | undefined;
    pointCost!: number | undefined;
    monetaryValue!: number | undefined;

    constructor(data?: IRewardItemDetailResource) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.code = data["code"];
            this.name = data["name"];
            this.description = data["description"];
            this.rewardType = data["rewardType"];
            this.imageUrl = data["imageUrl"];
            this.isActive = data["isActive"];
            this.pointCost = data["pointCost"];
            this.monetaryValue = data["monetaryValue"];
        }
    }

    static fromJS(data: any): RewardItemDetailResource {
        data = typeof data === 'object' ? data : {};
        let result = new RewardItemDetailResource();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        data["description"] = this.description;
        data["rewardType"] = this.rewardType;
        data["imageUrl"] = this.imageUrl;
        data["isActive"] = this.isActive;
        data["pointCost"] = this.pointCost;
        data["monetaryValue"] = this.monetaryValue;
        return data;
    }
}

export interface IRewardItemDetailResource {
    id: number | undefined;
    code: string | undefined;
    name: string | undefined;
    description: string | undefined;
    rewardType: string | undefined;
    imageUrl: string | undefined;
    isActive: boolean | undefined;
    pointCost: number | undefined;
    monetaryValue: number | undefined;
}

export class RewardItemCreateResource implements IRewardItemCreateResource {
    id!: number | undefined;
    code!: string | undefined;
    name!: string | undefined;
    description!: string | undefined;
    rewardType!: string | undefined;
    imageUrl!: string | undefined;
    pointCost!: number | undefined;
    monetaryValue!: number | undefined;
    isActive!: boolean | undefined;

    constructor(data?: IRewardItemCreateResource) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.code = data["code"];
            this.name = data["name"];
            this.description = data["description"];
            this.rewardType = data["rewardType"];
            this.imageUrl = data["imageUrl"];
            this.pointCost = data["pointCost"];
            this.monetaryValue = data["monetaryValue"];
            this.isActive = data["isActive"];
        }
    }

    static fromJS(data: any): RewardItemCreateResource {
        data = typeof data === 'object' ? data : {};
        let result = new RewardItemCreateResource();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        data["description"] = this.description;
        data["rewardType"] = this.rewardType;
        data["imageUrl"] = this.imageUrl;
        data["pointCost"] = this.pointCost;
        data["monetaryValue"] = this.monetaryValue;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IRewardItemCreateResource {
    id: number | undefined;
    code: string | undefined;
    name: string | undefined;
    description: string | undefined;
    rewardType: string | undefined;
    imageUrl: string | undefined;
    pointCost: number | undefined;
    monetaryValue: number | undefined;
    isActive: boolean | undefined;
}

export class RewardRedemptionRequestCreateDTO implements IRewardRedemptionRequestCreateDTO {
    campaignId!: number | undefined;
    memberCode!: string | undefined;
    rewardItems!: RewardRedemptionItemCreateDTO[] | undefined;

    constructor(data?: IRewardRedemptionRequestCreateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.campaignId = data["campaignId"];
            this.memberCode = data["memberCode"];
            if (data["rewardItems"] && data["rewardItems"].constructor === Array) {
                this.rewardItems = [];
                for (let item of data["rewardItems"])
                    this.rewardItems.push(RewardRedemptionItemCreateDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RewardRedemptionRequestCreateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RewardRedemptionRequestCreateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["campaignId"] = this.campaignId;
        data["memberCode"] = this.memberCode;
        if (this.rewardItems && this.rewardItems.constructor === Array) {
            data["rewardItems"] = [];
            for (let item of this.rewardItems)
                data["rewardItems"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRewardRedemptionRequestCreateDTO {
    campaignId: number | undefined;
    memberCode: string | undefined;
    rewardItems: RewardRedemptionItemCreateDTO[] | undefined;
}

export class RewardRedemptionItemCreateDTO implements IRewardRedemptionItemCreateDTO {
    rewardItemId!: number | undefined;
    quantity!: number | undefined;

    constructor(data?: IRewardRedemptionItemCreateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.rewardItemId = data["rewardItemId"];
            this.quantity = data["quantity"];
        }
    }

    static fromJS(data: any): RewardRedemptionItemCreateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RewardRedemptionItemCreateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rewardItemId"] = this.rewardItemId;
        data["quantity"] = this.quantity;
        return data;
    }
}

export interface IRewardRedemptionItemCreateDTO {
    rewardItemId: number | undefined;
    quantity: number | undefined;
}

export class RewardRedemptionForAppResult implements IRewardRedemptionForAppResult {
    redemptionItems!: RewardRedemptionItemForApp[] | undefined;
    redemptionItemsUsed!: RewardRedemptionItemForApp[] | undefined;
    redemptionItemsExpired!: RewardRedemptionItemForApp[] | undefined;

    constructor(data?: IRewardRedemptionForAppResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["redemptionItems"] && data["redemptionItems"].constructor === Array) {
                this.redemptionItems = [];
                for (let item of data["redemptionItems"])
                    this.redemptionItems.push(RewardRedemptionItemForApp.fromJS(item));
            }
            if (data["redemptionItemsUsed"] && data["redemptionItemsUsed"].constructor === Array) {
                this.redemptionItemsUsed = [];
                for (let item of data["redemptionItemsUsed"])
                    this.redemptionItemsUsed.push(RewardRedemptionItemForApp.fromJS(item));
            }
            if (data["redemptionItemsExpired"] && data["redemptionItemsExpired"].constructor === Array) {
                this.redemptionItemsExpired = [];
                for (let item of data["redemptionItemsExpired"])
                    this.redemptionItemsExpired.push(RewardRedemptionItemForApp.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RewardRedemptionForAppResult {
        data = typeof data === 'object' ? data : {};
        let result = new RewardRedemptionForAppResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.redemptionItems && this.redemptionItems.constructor === Array) {
            data["redemptionItems"] = [];
            for (let item of this.redemptionItems)
                data["redemptionItems"].push(item.toJSON());
        }
        if (this.redemptionItemsUsed && this.redemptionItemsUsed.constructor === Array) {
            data["redemptionItemsUsed"] = [];
            for (let item of this.redemptionItemsUsed)
                data["redemptionItemsUsed"].push(item.toJSON());
        }
        if (this.redemptionItemsExpired && this.redemptionItemsExpired.constructor === Array) {
            data["redemptionItemsExpired"] = [];
            for (let item of this.redemptionItemsExpired)
                data["redemptionItemsExpired"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRewardRedemptionForAppResult {
    redemptionItems: RewardRedemptionItemForApp[] | undefined;
    redemptionItemsUsed: RewardRedemptionItemForApp[] | undefined;
    redemptionItemsExpired: RewardRedemptionItemForApp[] | undefined;
}

export class RewardRedemptionItemForApp implements IRewardRedemptionItemForApp {
    imageUrl!: string | undefined;
    rewardItemName!: string | undefined;
    effectFrom!: moment.Moment | undefined;
    effectTo!: moment.Moment | undefined;
    rewardType!: string | undefined;
    id!: number | undefined;
    redemptionRequestId!: number | undefined;
    rewardItemId!: number | undefined;
    rewardItemCode!: string | undefined;
    quantity!: number | undefined;
    toTalQuantityUsed!: number | undefined;
    status!: string | undefined;
    uom!: string | undefined;
    usedDate!: moment.Moment | undefined;

    constructor(data?: IRewardRedemptionItemForApp) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.imageUrl = data["imageUrl"];
            this.rewardItemName = data["rewardItemName"];
            this.effectFrom = data["effectFrom"] ? moment(data["effectFrom"].toString()) : <any>undefined;
            this.effectTo = data["effectTo"] ? moment(data["effectTo"].toString()) : <any>undefined;
            this.rewardType = data["rewardType"];
            this.id = data["id"];
            this.redemptionRequestId = data["redemptionRequestId"];
            this.rewardItemId = data["rewardItemId"];
            this.rewardItemCode = data["rewardItemCode"];
            this.quantity = data["quantity"];
            this.toTalQuantityUsed = data["toTalQuantityUsed"];
            this.status = data["status"];
            this.uom = data["uom"];
            this.usedDate = data["usedDate"] ? moment(data["usedDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): RewardRedemptionItemForApp {
        data = typeof data === 'object' ? data : {};
        let result = new RewardRedemptionItemForApp();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["imageUrl"] = this.imageUrl;
        data["rewardItemName"] = this.rewardItemName;
        data["effectFrom"] = this.effectFrom ? this.effectFrom.toISOString() : <any>undefined;
        data["effectTo"] = this.effectTo ? this.effectTo.toISOString() : <any>undefined;
        data["rewardType"] = this.rewardType;
        data["id"] = this.id;
        data["redemptionRequestId"] = this.redemptionRequestId;
        data["rewardItemId"] = this.rewardItemId;
        data["rewardItemCode"] = this.rewardItemCode;
        data["quantity"] = this.quantity;
        data["toTalQuantityUsed"] = this.toTalQuantityUsed;
        data["status"] = this.status;
        data["uom"] = this.uom;
        data["usedDate"] = this.usedDate ? this.usedDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IRewardRedemptionItemForApp {
    imageUrl: string | undefined;
    rewardItemName: string | undefined;
    effectFrom: moment.Moment | undefined;
    effectTo: moment.Moment | undefined;
    rewardType: string | undefined;
    id: number | undefined;
    redemptionRequestId: number | undefined;
    rewardItemId: number | undefined;
    rewardItemCode: string | undefined;
    quantity: number | undefined;
    toTalQuantityUsed: number | undefined;
    status: string | undefined;
    uom: string | undefined;
    usedDate: moment.Moment | undefined;
}

export class RewardItemUsedForAppInput implements IRewardItemUsedForAppInput {
    memberCode!: string;
    redemptionItemId!: number;
    quantity!: number;

    constructor(data?: IRewardItemUsedForAppInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberCode = data["memberCode"];
            this.redemptionItemId = data["redemptionItemId"];
            this.quantity = data["quantity"];
        }
    }

    static fromJS(data: any): RewardItemUsedForAppInput {
        data = typeof data === 'object' ? data : {};
        let result = new RewardItemUsedForAppInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberCode"] = this.memberCode;
        data["redemptionItemId"] = this.redemptionItemId;
        data["quantity"] = this.quantity;
        return data;
    }
}

export interface IRewardItemUsedForAppInput {
    memberCode: string;
    redemptionItemId: number;
    quantity: number;
}

export class InputActionRequestDto implements IInputActionRequestDto {
    actions!: ActionRequestDto[] | undefined;

    constructor(data?: IInputActionRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["actions"] && data["actions"].constructor === Array) {
                this.actions = [];
                for (let item of data["actions"])
                    this.actions.push(ActionRequestDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InputActionRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new InputActionRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.actions && this.actions.constructor === Array) {
            data["actions"] = [];
            for (let item of this.actions)
                data["actions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IInputActionRequestDto {
    actions: ActionRequestDto[] | undefined;
}

export class ActionRequestDto implements IActionRequestDto {
    transactionCode!: string;
    type!: number;
    originalTransactionCode!: string | undefined;
    actionCode!: string | undefined;
    actionFilter!: string | undefined;
    memberCode!: string;
    value!: number;
    actionTime!: moment.Moment;
    tag!: string | undefined;

    constructor(data?: IActionRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.transactionCode = data["transactionCode"];
            this.type = data["type"];
            this.originalTransactionCode = data["originalTransactionCode"];
            this.actionCode = data["actionCode"];
            this.actionFilter = data["actionFilter"];
            this.memberCode = data["memberCode"];
            this.value = data["value"];
            this.actionTime = data["actionTime"] ? moment(data["actionTime"].toString()) : <any>undefined;
            this.tag = data["tag"];
        }
    }

    static fromJS(data: any): ActionRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActionRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionCode"] = this.transactionCode;
        data["type"] = this.type;
        data["originalTransactionCode"] = this.originalTransactionCode;
        data["actionCode"] = this.actionCode;
        data["actionFilter"] = this.actionFilter;
        data["memberCode"] = this.memberCode;
        data["value"] = this.value;
        data["actionTime"] = this.actionTime ? this.actionTime.toISOString() : <any>undefined;
        data["tag"] = this.tag;
        return data;
    }
}

export interface IActionRequestDto {
    transactionCode: string;
    type: number;
    originalTransactionCode: string | undefined;
    actionCode: string | undefined;
    actionFilter: string | undefined;
    memberCode: string;
    value: number;
    actionTime: moment.Moment;
    tag: string | undefined;
}

export class PagedResultDtoOfGetRewardTargetAudienceForViewDto implements IPagedResultDtoOfGetRewardTargetAudienceForViewDto {
    totalCount!: number | undefined;
    items!: GetRewardTargetAudienceForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetRewardTargetAudienceForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetRewardTargetAudienceForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetRewardTargetAudienceForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetRewardTargetAudienceForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetRewardTargetAudienceForViewDto {
    totalCount: number | undefined;
    items: GetRewardTargetAudienceForViewDto[] | undefined;
}

export class GetRewardTargetAudienceForViewDto implements IGetRewardTargetAudienceForViewDto {
    rewardTargetAudience!: RewardTargetAudienceDto | undefined;

    constructor(data?: IGetRewardTargetAudienceForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.rewardTargetAudience = data["rewardTargetAudience"] ? RewardTargetAudienceDto.fromJS(data["rewardTargetAudience"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetRewardTargetAudienceForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetRewardTargetAudienceForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rewardTargetAudience"] = this.rewardTargetAudience ? this.rewardTargetAudience.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetRewardTargetAudienceForViewDto {
    rewardTargetAudience: RewardTargetAudienceDto | undefined;
}

export class RewardTargetAudienceDto implements IRewardTargetAudienceDto {
    targetAudienceName!: string | undefined;
    description!: string | undefined;
    status!: string | undefined;
    targetAudienceLinkID!: number | undefined;
    id!: number | undefined;

    constructor(data?: IRewardTargetAudienceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.targetAudienceName = data["targetAudienceName"];
            this.description = data["description"];
            this.status = data["status"];
            this.targetAudienceLinkID = data["targetAudienceLinkID"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): RewardTargetAudienceDto {
        data = typeof data === 'object' ? data : {};
        let result = new RewardTargetAudienceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["targetAudienceName"] = this.targetAudienceName;
        data["description"] = this.description;
        data["status"] = this.status;
        data["targetAudienceLinkID"] = this.targetAudienceLinkID;
        data["id"] = this.id;
        return data;
    }
}

export interface IRewardTargetAudienceDto {
    targetAudienceName: string | undefined;
    description: string | undefined;
    status: string | undefined;
    targetAudienceLinkID: number | undefined;
    id: number | undefined;
}

export class GetRewardTargetAudienceForEditOutput implements IGetRewardTargetAudienceForEditOutput {
    rewardTargetAudience!: CreateOrEditRewardTargetAudienceDto | undefined;

    constructor(data?: IGetRewardTargetAudienceForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.rewardTargetAudience = data["rewardTargetAudience"] ? CreateOrEditRewardTargetAudienceDto.fromJS(data["rewardTargetAudience"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetRewardTargetAudienceForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetRewardTargetAudienceForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rewardTargetAudience"] = this.rewardTargetAudience ? this.rewardTargetAudience.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetRewardTargetAudienceForEditOutput {
    rewardTargetAudience: CreateOrEditRewardTargetAudienceDto | undefined;
}

export class CreateOrEditRewardTargetAudienceDto implements ICreateOrEditRewardTargetAudienceDto {
    targetAudienceName!: string | undefined;
    description!: string | undefined;
    status!: string | undefined;
    targetAudienceLinkID!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditRewardTargetAudienceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.targetAudienceName = data["targetAudienceName"];
            this.description = data["description"];
            this.status = data["status"];
            this.targetAudienceLinkID = data["targetAudienceLinkID"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditRewardTargetAudienceDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditRewardTargetAudienceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["targetAudienceName"] = this.targetAudienceName;
        data["description"] = this.description;
        data["status"] = this.status;
        data["targetAudienceLinkID"] = this.targetAudienceLinkID;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditRewardTargetAudienceDto {
    targetAudienceName: string | undefined;
    description: string | undefined;
    status: string | undefined;
    targetAudienceLinkID: number | undefined;
    id: number | undefined;
}

export class GetAllRewardTargetAudiencesInput implements IGetAllRewardTargetAudiencesInput {
    filter!: string | undefined;
    targetAudienceNameFilter!: string | undefined;
    descriptionFilter!: string | undefined;
    statusFilter!: string | undefined;
    maxTargetAudienceLinkIDFilter!: number | undefined;
    minTargetAudienceLinkIDFilter!: number | undefined;
    sorting!: string | undefined;
    skipCount!: number | undefined;
    maxResultCount!: number | undefined;

    constructor(data?: IGetAllRewardTargetAudiencesInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.filter = data["filter"];
            this.targetAudienceNameFilter = data["targetAudienceNameFilter"];
            this.descriptionFilter = data["descriptionFilter"];
            this.statusFilter = data["statusFilter"];
            this.maxTargetAudienceLinkIDFilter = data["maxTargetAudienceLinkIDFilter"];
            this.minTargetAudienceLinkIDFilter = data["minTargetAudienceLinkIDFilter"];
            this.sorting = data["sorting"];
            this.skipCount = data["skipCount"];
            this.maxResultCount = data["maxResultCount"];
        }
    }

    static fromJS(data: any): GetAllRewardTargetAudiencesInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllRewardTargetAudiencesInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        data["targetAudienceNameFilter"] = this.targetAudienceNameFilter;
        data["descriptionFilter"] = this.descriptionFilter;
        data["statusFilter"] = this.statusFilter;
        data["maxTargetAudienceLinkIDFilter"] = this.maxTargetAudienceLinkIDFilter;
        data["minTargetAudienceLinkIDFilter"] = this.minTargetAudienceLinkIDFilter;
        data["sorting"] = this.sorting;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data;
    }
}

export interface IGetAllRewardTargetAudiencesInput {
    filter: string | undefined;
    targetAudienceNameFilter: string | undefined;
    descriptionFilter: string | undefined;
    statusFilter: string | undefined;
    maxTargetAudienceLinkIDFilter: number | undefined;
    minTargetAudienceLinkIDFilter: number | undefined;
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;
}

export class ListResultDtoOfRoleListDto implements IListResultDtoOfRoleListDto {
    items!: RoleListDto[] | undefined;

    constructor(data?: IListResultDtoOfRoleListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(RoleListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfRoleListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfRoleListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListResultDtoOfRoleListDto {
    items: RoleListDto[] | undefined;
}

export class RoleListDto implements IRoleListDto {
    name!: string | undefined;
    displayName!: string | undefined;
    isStatic!: boolean | undefined;
    isDefault!: boolean | undefined;
    creationTime!: moment.Moment | undefined;
    organazationUnitDefault!: string | undefined;
    id!: number | undefined;

    constructor(data?: IRoleListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.displayName = data["displayName"];
            this.isStatic = data["isStatic"];
            this.isDefault = data["isDefault"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.organazationUnitDefault = data["organazationUnitDefault"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): RoleListDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["isStatic"] = this.isStatic;
        data["isDefault"] = this.isDefault;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["organazationUnitDefault"] = this.organazationUnitDefault;
        data["id"] = this.id;
        return data;
    }
}

export interface IRoleListDto {
    name: string | undefined;
    displayName: string | undefined;
    isStatic: boolean | undefined;
    isDefault: boolean | undefined;
    creationTime: moment.Moment | undefined;
    organazationUnitDefault: string | undefined;
    id: number | undefined;
}

export class GetRoleForEditOutput implements IGetRoleForEditOutput {
    role!: RoleEditDto | undefined;
    permissions!: FlatPermissionDto[] | undefined;
    grantedPermissionNames!: string[] | undefined;

    constructor(data?: IGetRoleForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.role = data["role"] ? RoleEditDto.fromJS(data["role"]) : <any>undefined;
            if (data["permissions"] && data["permissions"].constructor === Array) {
                this.permissions = [];
                for (let item of data["permissions"])
                    this.permissions.push(FlatPermissionDto.fromJS(item));
            }
            if (data["grantedPermissionNames"] && data["grantedPermissionNames"].constructor === Array) {
                this.grantedPermissionNames = [];
                for (let item of data["grantedPermissionNames"])
                    this.grantedPermissionNames.push(item);
            }
        }
    }

    static fromJS(data: any): GetRoleForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetRoleForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["role"] = this.role ? this.role.toJSON() : <any>undefined;
        if (this.permissions && this.permissions.constructor === Array) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item.toJSON());
        }
        if (this.grantedPermissionNames && this.grantedPermissionNames.constructor === Array) {
            data["grantedPermissionNames"] = [];
            for (let item of this.grantedPermissionNames)
                data["grantedPermissionNames"].push(item);
        }
        return data;
    }
}

export interface IGetRoleForEditOutput {
    role: RoleEditDto | undefined;
    permissions: FlatPermissionDto[] | undefined;
    grantedPermissionNames: string[] | undefined;
}

export class RoleEditDto implements IRoleEditDto {
    id!: number | undefined;
    displayName!: string;
    isDefault!: boolean | undefined;
    organazationUnitDefault!: string | undefined;

    constructor(data?: IRoleEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
            this.isDefault = data["isDefault"];
            this.organazationUnitDefault = data["organazationUnitDefault"];
        }
    }

    static fromJS(data: any): RoleEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["isDefault"] = this.isDefault;
        data["organazationUnitDefault"] = this.organazationUnitDefault;
        return data;
    }
}

export interface IRoleEditDto {
    id: number | undefined;
    displayName: string;
    isDefault: boolean | undefined;
    organazationUnitDefault: string | undefined;
}

export class FlatPermissionDto implements IFlatPermissionDto {
    parentName!: string | undefined;
    name!: string | undefined;
    displayName!: string | undefined;
    description!: string | undefined;
    isGrantedByDefault!: boolean | undefined;

    constructor(data?: IFlatPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.parentName = data["parentName"];
            this.name = data["name"];
            this.displayName = data["displayName"];
            this.description = data["description"];
            this.isGrantedByDefault = data["isGrantedByDefault"];
        }
    }

    static fromJS(data: any): FlatPermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlatPermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentName"] = this.parentName;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["isGrantedByDefault"] = this.isGrantedByDefault;
        return data;
    }
}

export interface IFlatPermissionDto {
    parentName: string | undefined;
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    isGrantedByDefault: boolean | undefined;
}

export class CreateOrUpdateRoleInput implements ICreateOrUpdateRoleInput {
    role!: RoleEditDto;
    grantedPermissionNames!: string[];

    constructor(data?: ICreateOrUpdateRoleInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.role = new RoleEditDto();
            this.grantedPermissionNames = [];
        }
    }

    init(data?: any) {
        if (data) {
            this.role = data["role"] ? RoleEditDto.fromJS(data["role"]) : new RoleEditDto();
            if (data["grantedPermissionNames"] && data["grantedPermissionNames"].constructor === Array) {
                this.grantedPermissionNames = [];
                for (let item of data["grantedPermissionNames"])
                    this.grantedPermissionNames.push(item);
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateRoleInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateRoleInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["role"] = this.role ? this.role.toJSON() : <any>undefined;
        if (this.grantedPermissionNames && this.grantedPermissionNames.constructor === Array) {
            data["grantedPermissionNames"] = [];
            for (let item of this.grantedPermissionNames)
                data["grantedPermissionNames"].push(item);
        }
        return data;
    }
}

export interface ICreateOrUpdateRoleInput {
    role: RoleEditDto;
    grantedPermissionNames: string[];
}

export class PagedResultDtoOfRuleGeneratorResponseDto implements IPagedResultDtoOfRuleGeneratorResponseDto {
    totalCount!: number | undefined;
    items!: RuleGeneratorResponseDto[] | undefined;

    constructor(data?: IPagedResultDtoOfRuleGeneratorResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(RuleGeneratorResponseDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfRuleGeneratorResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfRuleGeneratorResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfRuleGeneratorResponseDto {
    totalCount: number | undefined;
    items: RuleGeneratorResponseDto[] | undefined;
}

export class RuleGeneratorResponseDto implements IRuleGeneratorResponseDto {
    name!: string | undefined;
    ruleType!: string | undefined;
    description!: string | undefined;
    model!: string | undefined;
    isGenerateActivationCode!: boolean | undefined;
    status!: string | undefined;
    creationName!: string | undefined;
    componentRulers!: ComponentRulerDto[] | undefined;
    isDeleted!: boolean | undefined;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: moment.Moment | undefined;
    creatorUserId!: number | undefined;
    id!: number | undefined;

    constructor(data?: IRuleGeneratorResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.ruleType = data["ruleType"];
            this.description = data["description"];
            this.model = data["model"];
            this.isGenerateActivationCode = data["isGenerateActivationCode"];
            this.status = data["status"];
            this.creationName = data["creationName"];
            if (data["componentRulers"] && data["componentRulers"].constructor === Array) {
                this.componentRulers = [];
                for (let item of data["componentRulers"])
                    this.componentRulers.push(ComponentRulerDto.fromJS(item));
            }
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): RuleGeneratorResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new RuleGeneratorResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["ruleType"] = this.ruleType;
        data["description"] = this.description;
        data["model"] = this.model;
        data["isGenerateActivationCode"] = this.isGenerateActivationCode;
        data["status"] = this.status;
        data["creationName"] = this.creationName;
        if (this.componentRulers && this.componentRulers.constructor === Array) {
            data["componentRulers"] = [];
            for (let item of this.componentRulers)
                data["componentRulers"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IRuleGeneratorResponseDto {
    name: string | undefined;
    ruleType: string | undefined;
    description: string | undefined;
    model: string | undefined;
    isGenerateActivationCode: boolean | undefined;
    status: string | undefined;
    creationName: string | undefined;
    componentRulers: ComponentRulerDto[] | undefined;
    isDeleted: boolean | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class ComponentRulerDto implements IComponentRulerDto {
    id!: number | undefined;
    name!: string | undefined;
    limitLength!: number | undefined;
    type!: ComponentRulerDtoType | undefined;
    value!: string | undefined;
    isActive!: boolean | undefined;
    order!: number | undefined;
    ruleGeneratorId!: number | undefined;

    constructor(data?: IComponentRulerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.isActive = true;
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.limitLength = data["limitLength"];
            this.type = data["type"];
            this.value = data["value"];
            this.isActive = data["isActive"] !== undefined ? data["isActive"] : true;
            this.order = data["order"];
            this.ruleGeneratorId = data["ruleGeneratorId"];
        }
    }

    static fromJS(data: any): ComponentRulerDto {
        data = typeof data === 'object' ? data : {};
        let result = new ComponentRulerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["limitLength"] = this.limitLength;
        data["type"] = this.type;
        data["value"] = this.value;
        data["isActive"] = this.isActive;
        data["order"] = this.order;
        data["ruleGeneratorId"] = this.ruleGeneratorId;
        return data;
    }
}

export interface IComponentRulerDto {
    id: number | undefined;
    name: string | undefined;
    limitLength: number | undefined;
    type: ComponentRulerDtoType | undefined;
    value: string | undefined;
    isActive: boolean | undefined;
    order: number | undefined;
    ruleGeneratorId: number | undefined;
}

export class RuleGeneratorDto implements IRuleGeneratorDto {
    name!: string | undefined;
    ruleType!: string | undefined;
    description!: string | undefined;
    model!: string | undefined;
    isGenerateActivationCode!: boolean | undefined;
    status!: string | undefined;
    componentRulers!: ComponentRulerDto[] | undefined;
    id!: number | undefined;

    constructor(data?: IRuleGeneratorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.ruleType = data["ruleType"];
            this.description = data["description"];
            this.model = data["model"];
            this.isGenerateActivationCode = data["isGenerateActivationCode"];
            this.status = data["status"];
            if (data["componentRulers"] && data["componentRulers"].constructor === Array) {
                this.componentRulers = [];
                for (let item of data["componentRulers"])
                    this.componentRulers.push(ComponentRulerDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): RuleGeneratorDto {
        data = typeof data === 'object' ? data : {};
        let result = new RuleGeneratorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["ruleType"] = this.ruleType;
        data["description"] = this.description;
        data["model"] = this.model;
        data["isGenerateActivationCode"] = this.isGenerateActivationCode;
        data["status"] = this.status;
        if (this.componentRulers && this.componentRulers.constructor === Array) {
            data["componentRulers"] = [];
            for (let item of this.componentRulers)
                data["componentRulers"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IRuleGeneratorDto {
    name: string | undefined;
    ruleType: string | undefined;
    description: string | undefined;
    model: string | undefined;
    isGenerateActivationCode: boolean | undefined;
    status: string | undefined;
    componentRulers: ComponentRulerDto[] | undefined;
    id: number | undefined;
}

export class ResponseDtoOfBoolean implements IResponseDtoOfBoolean {
    message!: string | undefined;
    data!: boolean | undefined;

    constructor(data?: IResponseDtoOfBoolean) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.message = data["message"];
            this.data = data["data"];
        }
    }

    static fromJS(data: any): ResponseDtoOfBoolean {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseDtoOfBoolean();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["data"] = this.data;
        return data;
    }
}

export interface IResponseDtoOfBoolean {
    message: string | undefined;
    data: boolean | undefined;
}

export class PagedResultDtoOfSaleHistoryDto implements IPagedResultDtoOfSaleHistoryDto {
    totalCount!: number | undefined;
    items!: SaleHistoryDto[] | undefined;

    constructor(data?: IPagedResultDtoOfSaleHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(SaleHistoryDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfSaleHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfSaleHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfSaleHistoryDto {
    totalCount: number | undefined;
    items: SaleHistoryDto[] | undefined;
}

export class SaleHistoryDto implements ISaleHistoryDto {
    saleId!: string | undefined;
    activeSaleStatus!: string | undefined;
    saleType!: string | undefined;
    creatorName!: string | undefined;
    lastModifierName!: string | undefined;
    id!: number | undefined;

    constructor(data?: ISaleHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.saleId = data["saleId"];
            this.activeSaleStatus = data["activeSaleStatus"];
            this.saleType = data["saleType"];
            this.creatorName = data["creatorName"];
            this.lastModifierName = data["lastModifierName"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SaleHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new SaleHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["saleId"] = this.saleId;
        data["activeSaleStatus"] = this.activeSaleStatus;
        data["saleType"] = this.saleType;
        data["creatorName"] = this.creatorName;
        data["lastModifierName"] = this.lastModifierName;
        data["id"] = this.id;
        return data;
    }
}

export interface ISaleHistoryDto {
    saleId: string | undefined;
    activeSaleStatus: string | undefined;
    saleType: string | undefined;
    creatorName: string | undefined;
    lastModifierName: string | undefined;
    id: number | undefined;
}

export class CreateOrEditSaleOrderInput implements ICreateOrEditSaleOrderInput {
    memberCode!: string | undefined;
    appointmentDate!: moment.Moment | undefined;
    orderType!: number | undefined;
    note!: string | undefined;
    phoneReceiver!: string | undefined;
    nameReceiver!: string | undefined;
    addressReceiver!: string | undefined;
    subTotal!: number | undefined;
    discount!: number | undefined;
    vat!: number | undefined;
    orderTotal!: number | undefined;
    desc!: string | undefined;
    orderStatus!: number | undefined;
    saleOrderDetails!: CreateOrEditSaleOrderDetailInput[] | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditSaleOrderInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberCode = data["memberCode"];
            this.appointmentDate = data["appointmentDate"] ? moment(data["appointmentDate"].toString()) : <any>undefined;
            this.orderType = data["orderType"];
            this.note = data["note"];
            this.phoneReceiver = data["phoneReceiver"];
            this.nameReceiver = data["nameReceiver"];
            this.addressReceiver = data["addressReceiver"];
            this.subTotal = data["subTotal"];
            this.discount = data["discount"];
            this.vat = data["vat"];
            this.orderTotal = data["orderTotal"];
            this.desc = data["desc"];
            this.orderStatus = data["orderStatus"];
            if (data["saleOrderDetails"] && data["saleOrderDetails"].constructor === Array) {
                this.saleOrderDetails = [];
                for (let item of data["saleOrderDetails"])
                    this.saleOrderDetails.push(CreateOrEditSaleOrderDetailInput.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditSaleOrderInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditSaleOrderInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberCode"] = this.memberCode;
        data["appointmentDate"] = this.appointmentDate ? this.appointmentDate.toISOString() : <any>undefined;
        data["orderType"] = this.orderType;
        data["note"] = this.note;
        data["phoneReceiver"] = this.phoneReceiver;
        data["nameReceiver"] = this.nameReceiver;
        data["addressReceiver"] = this.addressReceiver;
        data["subTotal"] = this.subTotal;
        data["discount"] = this.discount;
        data["vat"] = this.vat;
        data["orderTotal"] = this.orderTotal;
        data["desc"] = this.desc;
        data["orderStatus"] = this.orderStatus;
        if (this.saleOrderDetails && this.saleOrderDetails.constructor === Array) {
            data["saleOrderDetails"] = [];
            for (let item of this.saleOrderDetails)
                data["saleOrderDetails"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditSaleOrderInput {
    memberCode: string | undefined;
    appointmentDate: moment.Moment | undefined;
    orderType: number | undefined;
    note: string | undefined;
    phoneReceiver: string | undefined;
    nameReceiver: string | undefined;
    addressReceiver: string | undefined;
    subTotal: number | undefined;
    discount: number | undefined;
    vat: number | undefined;
    orderTotal: number | undefined;
    desc: string | undefined;
    orderStatus: number | undefined;
    saleOrderDetails: CreateOrEditSaleOrderDetailInput[] | undefined;
    id: number | undefined;
}

export class CreateOrEditSaleOrderDetailInput implements ICreateOrEditSaleOrderDetailInput {
    productCode!: string | undefined;
    quantity!: number | undefined;
    discount!: number | undefined;
    price!: number | undefined;
    vat!: number | undefined;
    lineTotal!: number | undefined;
    discount_Desc!: string | undefined;
    desc!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditSaleOrderDetailInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.productCode = data["productCode"];
            this.quantity = data["quantity"];
            this.discount = data["discount"];
            this.price = data["price"];
            this.vat = data["vat"];
            this.lineTotal = data["lineTotal"];
            this.discount_Desc = data["discount_Desc"];
            this.desc = data["desc"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditSaleOrderDetailInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditSaleOrderDetailInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productCode"] = this.productCode;
        data["quantity"] = this.quantity;
        data["discount"] = this.discount;
        data["price"] = this.price;
        data["vat"] = this.vat;
        data["lineTotal"] = this.lineTotal;
        data["discount_Desc"] = this.discount_Desc;
        data["desc"] = this.desc;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditSaleOrderDetailInput {
    productCode: string | undefined;
    quantity: number | undefined;
    discount: number | undefined;
    price: number | undefined;
    vat: number | undefined;
    lineTotal: number | undefined;
    discount_Desc: string | undefined;
    desc: string | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfGetSaleOrderForViewDto implements IPagedResultDtoOfGetSaleOrderForViewDto {
    totalCount!: number | undefined;
    items!: GetSaleOrderForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetSaleOrderForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetSaleOrderForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetSaleOrderForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetSaleOrderForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetSaleOrderForViewDto {
    totalCount: number | undefined;
    items: GetSaleOrderForViewDto[] | undefined;
}

export class GetSaleOrderForViewDto implements IGetSaleOrderForViewDto {
    saleOrder!: GetListSaleOrderResponse | undefined;

    constructor(data?: IGetSaleOrderForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.saleOrder = data["saleOrder"] ? GetListSaleOrderResponse.fromJS(data["saleOrder"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSaleOrderForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetSaleOrderForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["saleOrder"] = this.saleOrder ? this.saleOrder.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetSaleOrderForViewDto {
    saleOrder: GetListSaleOrderResponse | undefined;
}

export class GetListSaleOrderResponse implements IGetListSaleOrderResponse {
    orderGuid!: string | undefined;
    memberCode!: string | undefined;
    regionCode!: string | undefined;
    regionName!: string | undefined;
    outletCode!: string | undefined;
    outletName!: string | undefined;
    appointmentDate!: moment.Moment | undefined;
    orderType!: number | undefined;
    orderTypeName!: string | undefined;
    note!: string | undefined;
    phoneReceiver!: string | undefined;
    nameReceiver!: string | undefined;
    addressReceiver!: string | undefined;
    subTotal!: number | undefined;
    discount!: number | undefined;
    vat!: number | undefined;
    orderTotal!: number | undefined;
    desc!: string | undefined;
    orderStatus!: number | undefined;
    orderStatusName!: string | undefined;
    saleOrderDetails!: GetListSaleOrderDetailResponse[] | undefined;
    isDeleted!: boolean | undefined;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: moment.Moment | undefined;
    creatorUserId!: number | undefined;
    id!: number | undefined;

    constructor(data?: IGetListSaleOrderResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.orderGuid = data["orderGuid"];
            this.memberCode = data["memberCode"];
            this.regionCode = data["regionCode"];
            this.regionName = data["regionName"];
            this.outletCode = data["outletCode"];
            this.outletName = data["outletName"];
            this.appointmentDate = data["appointmentDate"] ? moment(data["appointmentDate"].toString()) : <any>undefined;
            this.orderType = data["orderType"];
            this.orderTypeName = data["orderTypeName"];
            this.note = data["note"];
            this.phoneReceiver = data["phoneReceiver"];
            this.nameReceiver = data["nameReceiver"];
            this.addressReceiver = data["addressReceiver"];
            this.subTotal = data["subTotal"];
            this.discount = data["discount"];
            this.vat = data["vat"];
            this.orderTotal = data["orderTotal"];
            this.desc = data["desc"];
            this.orderStatus = data["orderStatus"];
            this.orderStatusName = data["orderStatusName"];
            if (data["saleOrderDetails"] && data["saleOrderDetails"].constructor === Array) {
                this.saleOrderDetails = [];
                for (let item of data["saleOrderDetails"])
                    this.saleOrderDetails.push(GetListSaleOrderDetailResponse.fromJS(item));
            }
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): GetListSaleOrderResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetListSaleOrderResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderGuid"] = this.orderGuid;
        data["memberCode"] = this.memberCode;
        data["regionCode"] = this.regionCode;
        data["regionName"] = this.regionName;
        data["outletCode"] = this.outletCode;
        data["outletName"] = this.outletName;
        data["appointmentDate"] = this.appointmentDate ? this.appointmentDate.toISOString() : <any>undefined;
        data["orderType"] = this.orderType;
        data["orderTypeName"] = this.orderTypeName;
        data["note"] = this.note;
        data["phoneReceiver"] = this.phoneReceiver;
        data["nameReceiver"] = this.nameReceiver;
        data["addressReceiver"] = this.addressReceiver;
        data["subTotal"] = this.subTotal;
        data["discount"] = this.discount;
        data["vat"] = this.vat;
        data["orderTotal"] = this.orderTotal;
        data["desc"] = this.desc;
        data["orderStatus"] = this.orderStatus;
        data["orderStatusName"] = this.orderStatusName;
        if (this.saleOrderDetails && this.saleOrderDetails.constructor === Array) {
            data["saleOrderDetails"] = [];
            for (let item of this.saleOrderDetails)
                data["saleOrderDetails"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IGetListSaleOrderResponse {
    orderGuid: string | undefined;
    memberCode: string | undefined;
    regionCode: string | undefined;
    regionName: string | undefined;
    outletCode: string | undefined;
    outletName: string | undefined;
    appointmentDate: moment.Moment | undefined;
    orderType: number | undefined;
    orderTypeName: string | undefined;
    note: string | undefined;
    phoneReceiver: string | undefined;
    nameReceiver: string | undefined;
    addressReceiver: string | undefined;
    subTotal: number | undefined;
    discount: number | undefined;
    vat: number | undefined;
    orderTotal: number | undefined;
    desc: string | undefined;
    orderStatus: number | undefined;
    orderStatusName: string | undefined;
    saleOrderDetails: GetListSaleOrderDetailResponse[] | undefined;
    isDeleted: boolean | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class GetListSaleOrderDetailResponse implements IGetListSaleOrderDetailResponse {
    orderGuid!: string | undefined;
    orderDetailGuid!: string | undefined;
    productCode!: string | undefined;
    productName!: string | undefined;
    quantity!: number | undefined;
    discount!: number | undefined;
    price!: number | undefined;
    vat!: number | undefined;
    lineTotal!: number | undefined;
    discount_Desc!: string | undefined;
    desc!: string | undefined;
    isDeleted!: boolean | undefined;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: moment.Moment | undefined;
    creatorUserId!: number | undefined;
    id!: number | undefined;

    constructor(data?: IGetListSaleOrderDetailResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.orderGuid = data["orderGuid"];
            this.orderDetailGuid = data["orderDetailGuid"];
            this.productCode = data["productCode"];
            this.productName = data["productName"];
            this.quantity = data["quantity"];
            this.discount = data["discount"];
            this.price = data["price"];
            this.vat = data["vat"];
            this.lineTotal = data["lineTotal"];
            this.discount_Desc = data["discount_Desc"];
            this.desc = data["desc"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): GetListSaleOrderDetailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetListSaleOrderDetailResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderGuid"] = this.orderGuid;
        data["orderDetailGuid"] = this.orderDetailGuid;
        data["productCode"] = this.productCode;
        data["productName"] = this.productName;
        data["quantity"] = this.quantity;
        data["discount"] = this.discount;
        data["price"] = this.price;
        data["vat"] = this.vat;
        data["lineTotal"] = this.lineTotal;
        data["discount_Desc"] = this.discount_Desc;
        data["desc"] = this.desc;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IGetListSaleOrderDetailResponse {
    orderGuid: string | undefined;
    orderDetailGuid: string | undefined;
    productCode: string | undefined;
    productName: string | undefined;
    quantity: number | undefined;
    discount: number | undefined;
    price: number | undefined;
    vat: number | undefined;
    lineTotal: number | undefined;
    discount_Desc: string | undefined;
    desc: string | undefined;
    isDeleted: boolean | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class GetSaleOrderInput implements IGetSaleOrderInput {
    orderGuid!: string | undefined;
    memberCode!: string | undefined;
    orderType!: number | undefined;
    orderStatus!: number | undefined;
    fromDate!: moment.Moment | undefined;
    toDate!: moment.Moment | undefined;
    sorting!: string | undefined;
    skipCount!: number | undefined;
    maxResultCount!: number | undefined;

    constructor(data?: IGetSaleOrderInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.orderGuid = data["orderGuid"];
            this.memberCode = data["memberCode"];
            this.orderType = data["orderType"];
            this.orderStatus = data["orderStatus"];
            this.fromDate = data["fromDate"] ? moment(data["fromDate"].toString()) : <any>undefined;
            this.toDate = data["toDate"] ? moment(data["toDate"].toString()) : <any>undefined;
            this.sorting = data["sorting"];
            this.skipCount = data["skipCount"];
            this.maxResultCount = data["maxResultCount"];
        }
    }

    static fromJS(data: any): GetSaleOrderInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetSaleOrderInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderGuid"] = this.orderGuid;
        data["memberCode"] = this.memberCode;
        data["orderType"] = this.orderType;
        data["orderStatus"] = this.orderStatus;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data["sorting"] = this.sorting;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data;
    }
}

export interface IGetSaleOrderInput {
    orderGuid: string | undefined;
    memberCode: string | undefined;
    orderType: number | undefined;
    orderStatus: number | undefined;
    fromDate: moment.Moment | undefined;
    toDate: moment.Moment | undefined;
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;
}

export class PagedResultDtoOfGetSaleOrderDetailForViewDto implements IPagedResultDtoOfGetSaleOrderDetailForViewDto {
    totalCount!: number | undefined;
    items!: GetSaleOrderDetailForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetSaleOrderDetailForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetSaleOrderDetailForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetSaleOrderDetailForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetSaleOrderDetailForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetSaleOrderDetailForViewDto {
    totalCount: number | undefined;
    items: GetSaleOrderDetailForViewDto[] | undefined;
}

export class GetSaleOrderDetailForViewDto implements IGetSaleOrderDetailForViewDto {
    saleOrderDetail!: GetListSaleOrderDetailResponse | undefined;

    constructor(data?: IGetSaleOrderDetailForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.saleOrderDetail = data["saleOrderDetail"] ? GetListSaleOrderDetailResponse.fromJS(data["saleOrderDetail"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSaleOrderDetailForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetSaleOrderDetailForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["saleOrderDetail"] = this.saleOrderDetail ? this.saleOrderDetail.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetSaleOrderDetailForViewDto {
    saleOrderDetail: GetListSaleOrderDetailResponse | undefined;
}

export class CreateOrEditSaleInput implements ICreateOrEditSaleInput {
    memberCode!: string | undefined;
    referenceId!: string | undefined;
    serial!: string | undefined;
    saleType!: string | undefined;
    status!: string | undefined;
    description!: string | undefined;
    source!: string | undefined;
    systemPoint!: number | undefined;
    systemCoin!: number | undefined;
    address!: string | undefined;
    activationCode!: string | undefined;
    phoneNumber!: string | undefined;
    customerName!: string | undefined;
    province!: string | undefined;
    district!: string | undefined;
    ward!: string | undefined;
    paymentStatus!: number | undefined;
    paymentDate!: moment.Moment | undefined;
    reason!: string | undefined;
    productCode!: string | undefined;
    nameUnsign!: string | undefined;
    campaignNames!: string | undefined;
    campaignCodes!: string | undefined;
    year!: number | undefined;
    month!: number | undefined;
    newIdSale!: number | undefined;
    currentLAT!: number | undefined;
    currentLNG!: number | undefined;
    distance!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditSaleInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberCode = data["memberCode"];
            this.referenceId = data["referenceId"];
            this.serial = data["serial"];
            this.saleType = data["saleType"];
            this.status = data["status"];
            this.description = data["description"];
            this.source = data["source"];
            this.systemPoint = data["systemPoint"];
            this.systemCoin = data["systemCoin"];
            this.address = data["address"];
            this.activationCode = data["activationCode"];
            this.phoneNumber = data["phoneNumber"];
            this.customerName = data["customerName"];
            this.province = data["province"];
            this.district = data["district"];
            this.ward = data["ward"];
            this.paymentStatus = data["paymentStatus"];
            this.paymentDate = data["paymentDate"] ? moment(data["paymentDate"].toString()) : <any>undefined;
            this.reason = data["reason"];
            this.productCode = data["productCode"];
            this.nameUnsign = data["nameUnsign"];
            this.campaignNames = data["campaignNames"];
            this.campaignCodes = data["campaignCodes"];
            this.year = data["year"];
            this.month = data["month"];
            this.newIdSale = data["newIdSale"];
            this.currentLAT = data["currentLAT"];
            this.currentLNG = data["currentLNG"];
            this.distance = data["distance"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditSaleInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditSaleInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberCode"] = this.memberCode;
        data["referenceId"] = this.referenceId;
        data["serial"] = this.serial;
        data["saleType"] = this.saleType;
        data["status"] = this.status;
        data["description"] = this.description;
        data["source"] = this.source;
        data["systemPoint"] = this.systemPoint;
        data["systemCoin"] = this.systemCoin;
        data["address"] = this.address;
        data["activationCode"] = this.activationCode;
        data["phoneNumber"] = this.phoneNumber;
        data["customerName"] = this.customerName;
        data["province"] = this.province;
        data["district"] = this.district;
        data["ward"] = this.ward;
        data["paymentStatus"] = this.paymentStatus;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : <any>undefined;
        data["reason"] = this.reason;
        data["productCode"] = this.productCode;
        data["nameUnsign"] = this.nameUnsign;
        data["campaignNames"] = this.campaignNames;
        data["campaignCodes"] = this.campaignCodes;
        data["year"] = this.year;
        data["month"] = this.month;
        data["newIdSale"] = this.newIdSale;
        data["currentLAT"] = this.currentLAT;
        data["currentLNG"] = this.currentLNG;
        data["distance"] = this.distance;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditSaleInput {
    memberCode: string | undefined;
    referenceId: string | undefined;
    serial: string | undefined;
    saleType: string | undefined;
    status: string | undefined;
    description: string | undefined;
    source: string | undefined;
    systemPoint: number | undefined;
    systemCoin: number | undefined;
    address: string | undefined;
    activationCode: string | undefined;
    phoneNumber: string | undefined;
    customerName: string | undefined;
    province: string | undefined;
    district: string | undefined;
    ward: string | undefined;
    paymentStatus: number | undefined;
    paymentDate: moment.Moment | undefined;
    reason: string | undefined;
    productCode: string | undefined;
    nameUnsign: string | undefined;
    campaignNames: string | undefined;
    campaignCodes: string | undefined;
    year: number | undefined;
    month: number | undefined;
    newIdSale: number | undefined;
    currentLAT: number | undefined;
    currentLNG: number | undefined;
    distance: number | undefined;
    id: number | undefined;
}

export class TupleOfPagedResultDtoOfGetSaleForViewDtoAndTotalDashboard implements ITupleOfPagedResultDtoOfGetSaleForViewDtoAndTotalDashboard {
    item1!: PagedResultDtoOfGetSaleForViewDto | undefined;
    item2!: TotalDashboard | undefined;

    constructor(data?: ITupleOfPagedResultDtoOfGetSaleForViewDtoAndTotalDashboard) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.item1 = data["item1"] ? PagedResultDtoOfGetSaleForViewDto.fromJS(data["item1"]) : <any>undefined;
            this.item2 = data["item2"] ? TotalDashboard.fromJS(data["item2"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TupleOfPagedResultDtoOfGetSaleForViewDtoAndTotalDashboard {
        data = typeof data === 'object' ? data : {};
        let result = new TupleOfPagedResultDtoOfGetSaleForViewDtoAndTotalDashboard();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["item1"] = this.item1 ? this.item1.toJSON() : <any>undefined;
        data["item2"] = this.item2 ? this.item2.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITupleOfPagedResultDtoOfGetSaleForViewDtoAndTotalDashboard {
    item1: PagedResultDtoOfGetSaleForViewDto | undefined;
    item2: TotalDashboard | undefined;
}

export class PagedResultDtoOfGetSaleForViewDto implements IPagedResultDtoOfGetSaleForViewDto {
    totalCount!: number | undefined;
    items!: GetSaleForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetSaleForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetSaleForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetSaleForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetSaleForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetSaleForViewDto {
    totalCount: number | undefined;
    items: GetSaleForViewDto[] | undefined;
}

export class TotalDashboard implements ITotalDashboard {
    sellInTotalCoin!: number | undefined;
    sellOutTotalCoin!: number | undefined;
    sellVSTotalCoin!: number | undefined;
    sellDisTotalCoin!: number | undefined;
    items!: ItemDashBoard[] | undefined;
    sellIn!: ItemDashBoardGetAllSale[] | undefined;
    sellOut!: ItemDashBoardGetAllSale[] | undefined;
    sellVS!: ItemDashBoardGetAllSale[] | undefined;
    sellDis!: ItemDashBoardGetAllSale[] | undefined;

    constructor(data?: ITotalDashboard) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.sellInTotalCoin = data["sellInTotalCoin"];
            this.sellOutTotalCoin = data["sellOutTotalCoin"];
            this.sellVSTotalCoin = data["sellVSTotalCoin"];
            this.sellDisTotalCoin = data["sellDisTotalCoin"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(ItemDashBoard.fromJS(item));
            }
            if (data["sellIn"] && data["sellIn"].constructor === Array) {
                this.sellIn = [];
                for (let item of data["sellIn"])
                    this.sellIn.push(ItemDashBoardGetAllSale.fromJS(item));
            }
            if (data["sellOut"] && data["sellOut"].constructor === Array) {
                this.sellOut = [];
                for (let item of data["sellOut"])
                    this.sellOut.push(ItemDashBoardGetAllSale.fromJS(item));
            }
            if (data["sellVS"] && data["sellVS"].constructor === Array) {
                this.sellVS = [];
                for (let item of data["sellVS"])
                    this.sellVS.push(ItemDashBoardGetAllSale.fromJS(item));
            }
            if (data["sellDis"] && data["sellDis"].constructor === Array) {
                this.sellDis = [];
                for (let item of data["sellDis"])
                    this.sellDis.push(ItemDashBoardGetAllSale.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TotalDashboard {
        data = typeof data === 'object' ? data : {};
        let result = new TotalDashboard();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sellInTotalCoin"] = this.sellInTotalCoin;
        data["sellOutTotalCoin"] = this.sellOutTotalCoin;
        data["sellVSTotalCoin"] = this.sellVSTotalCoin;
        data["sellDisTotalCoin"] = this.sellDisTotalCoin;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        if (this.sellIn && this.sellIn.constructor === Array) {
            data["sellIn"] = [];
            for (let item of this.sellIn)
                data["sellIn"].push(item.toJSON());
        }
        if (this.sellOut && this.sellOut.constructor === Array) {
            data["sellOut"] = [];
            for (let item of this.sellOut)
                data["sellOut"].push(item.toJSON());
        }
        if (this.sellVS && this.sellVS.constructor === Array) {
            data["sellVS"] = [];
            for (let item of this.sellVS)
                data["sellVS"].push(item.toJSON());
        }
        if (this.sellDis && this.sellDis.constructor === Array) {
            data["sellDis"] = [];
            for (let item of this.sellDis)
                data["sellDis"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITotalDashboard {
    sellInTotalCoin: number | undefined;
    sellOutTotalCoin: number | undefined;
    sellVSTotalCoin: number | undefined;
    sellDisTotalCoin: number | undefined;
    items: ItemDashBoard[] | undefined;
    sellIn: ItemDashBoardGetAllSale[] | undefined;
    sellOut: ItemDashBoardGetAllSale[] | undefined;
    sellVS: ItemDashBoardGetAllSale[] | undefined;
    sellDis: ItemDashBoardGetAllSale[] | undefined;
}

export class GetSaleForViewDto implements IGetSaleForViewDto {
    sale!: GetListSaleResponse | undefined;

    constructor(data?: IGetSaleForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.sale = data["sale"] ? GetListSaleResponse.fromJS(data["sale"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSaleForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetSaleForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sale"] = this.sale ? this.sale.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetSaleForViewDto {
    sale: GetListSaleResponse | undefined;
}

export class ItemDashBoard implements IItemDashBoard {
    departmentLevel1!: string | undefined;
    systemPointTotal!: number | undefined;
    systemCoinTotal!: number | undefined;

    constructor(data?: IItemDashBoard) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.departmentLevel1 = data["departmentLevel1"];
            this.systemPointTotal = data["systemPointTotal"];
            this.systemCoinTotal = data["systemCoinTotal"];
        }
    }

    static fromJS(data: any): ItemDashBoard {
        data = typeof data === 'object' ? data : {};
        let result = new ItemDashBoard();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["departmentLevel1"] = this.departmentLevel1;
        data["systemPointTotal"] = this.systemPointTotal;
        data["systemCoinTotal"] = this.systemCoinTotal;
        return data;
    }
}

export interface IItemDashBoard {
    departmentLevel1: string | undefined;
    systemPointTotal: number | undefined;
    systemCoinTotal: number | undefined;
}

export class ItemDashBoardGetAllSale implements IItemDashBoardGetAllSale {
    department!: string | undefined;
    saleType!: string | undefined;
    quantity!: number | undefined;
    coin!: number | undefined;
    point!: number | undefined;
    paid!: number | undefined;
    remain!: number | undefined;

    constructor(data?: IItemDashBoardGetAllSale) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.department = data["department"];
            this.saleType = data["saleType"];
            this.quantity = data["quantity"];
            this.coin = data["coin"];
            this.point = data["point"];
            this.paid = data["paid"];
            this.remain = data["remain"];
        }
    }

    static fromJS(data: any): ItemDashBoardGetAllSale {
        data = typeof data === 'object' ? data : {};
        let result = new ItemDashBoardGetAllSale();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["department"] = this.department;
        data["saleType"] = this.saleType;
        data["quantity"] = this.quantity;
        data["coin"] = this.coin;
        data["point"] = this.point;
        data["paid"] = this.paid;
        data["remain"] = this.remain;
        return data;
    }
}

export interface IItemDashBoardGetAllSale {
    department: string | undefined;
    saleType: string | undefined;
    quantity: number | undefined;
    coin: number | undefined;
    point: number | undefined;
    paid: number | undefined;
    remain: number | undefined;
}

export class GetListSaleResponse implements IGetListSaleResponse {
    totalCount!: number | undefined;
    outletId!: number | undefined;
    outletName!: string | undefined;
    memberCode!: string | undefined;
    referenceId!: string | undefined;
    serial!: string | undefined;
    saleType!: string | undefined;
    status!: string | undefined;
    description!: string | undefined;
    source!: string | undefined;
    systemPoint!: number | undefined;
    systemCoin!: number | undefined;
    address!: string | undefined;
    activationCode!: string | undefined;
    phoneNumber!: string | undefined;
    customerName!: string | undefined;
    province!: string | undefined;
    district!: string | undefined;
    ward!: string | undefined;
    provinceName!: string | undefined;
    wardName!: string | undefined;
    districtName!: string | undefined;
    paymentStatus!: number | undefined;
    paymentDate!: moment.Moment | undefined;
    reason!: string | undefined;
    productCode!: string | undefined;
    deptName!: string | undefined;
    location!: string | undefined;
    returnType!: string | undefined;
    wrongRegion!: boolean | undefined;
    isExpiredUpdate!: boolean | undefined;
    isAllowRollback!: boolean | undefined;
    isRollbacked!: boolean | undefined;
    rollBackFrom!: number | undefined;
    paymentStatusText!: string | undefined;
    paymentNotes!: string | undefined;
    isDeleted!: boolean | undefined;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: moment.Moment | undefined;
    creatorUserId!: number | undefined;
    id!: number | undefined;
    detailValue!: string | undefined;
    brand!: string | undefined;

    constructor(data?: IGetListSaleResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            this.outletId = data["outletId"];
            this.outletName = data["outletName"];
            this.memberCode = data["memberCode"];
            this.referenceId = data["referenceId"];
            this.serial = data["serial"];
            this.saleType = data["saleType"];
            this.status = data["status"];
            this.description = data["description"];
            this.source = data["source"];
            this.systemPoint = data["systemPoint"];
            this.systemCoin = data["systemCoin"];
            this.address = data["address"];
            this.activationCode = data["activationCode"];
            this.phoneNumber = data["phoneNumber"];
            this.customerName = data["customerName"];
            this.province = data["province"];
            this.district = data["district"];
            this.ward = data["ward"];
            this.provinceName = data["provinceName"];
            this.wardName = data["wardName"];
            this.districtName = data["districtName"];
            this.paymentStatus = data["paymentStatus"];
            this.paymentDate = data["paymentDate"] ? moment(data["paymentDate"].toString()) : <any>undefined;
            this.reason = data["reason"];
            this.productCode = data["productCode"];
            this.deptName = data["deptName"];
            this.location = data["location"];
            this.returnType = data["returnType"];
            this.wrongRegion = data["wrongRegion"];
            this.isExpiredUpdate = data["isExpiredUpdate"];
            this.isAllowRollback = data["isAllowRollback"];
            this.isRollbacked = data["isRollbacked"];
            this.rollBackFrom = data["rollBackFrom"];
            this.paymentStatusText = data["paymentStatusText"];
            this.paymentNotes = data["paymentNotes"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
            this.detailValue = data["detailValue"];
            this.brand = data["brand"];
        }
    }

    static fromJS(data: any): GetListSaleResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetListSaleResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        data["outletId"] = this.outletId;
        data["outletName"] = this.outletName;
        data["memberCode"] = this.memberCode;
        data["referenceId"] = this.referenceId;
        data["serial"] = this.serial;
        data["saleType"] = this.saleType;
        data["status"] = this.status;
        data["description"] = this.description;
        data["source"] = this.source;
        data["systemPoint"] = this.systemPoint;
        data["systemCoin"] = this.systemCoin;
        data["address"] = this.address;
        data["activationCode"] = this.activationCode;
        data["phoneNumber"] = this.phoneNumber;
        data["customerName"] = this.customerName;
        data["province"] = this.province;
        data["district"] = this.district;
        data["ward"] = this.ward;
        data["provinceName"] = this.provinceName;
        data["wardName"] = this.wardName;
        data["districtName"] = this.districtName;
        data["paymentStatus"] = this.paymentStatus;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : <any>undefined;
        data["reason"] = this.reason;
        data["productCode"] = this.productCode;
        data["deptName"] = this.deptName;
        data["location"] = this.location;
        data["returnType"] = this.returnType;
        data["wrongRegion"] = this.wrongRegion;
        data["isExpiredUpdate"] = this.isExpiredUpdate;
        data["isAllowRollback"] = this.isAllowRollback;
        data["isRollbacked"] = this.isRollbacked;
        data["rollBackFrom"] = this.rollBackFrom;
        data["paymentStatusText"] = this.paymentStatusText;
        data["paymentNotes"] = this.paymentNotes;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        data["detailValue"] = this.detailValue;
        return data;
    }
}

export interface IGetListSaleResponse {
    totalCount: number | undefined;
    outletId: number | undefined;
    outletName: string | undefined;
    memberCode: string | undefined;
    referenceId: string | undefined;
    serial: string | undefined;
    saleType: string | undefined;
    status: string | undefined;
    description: string | undefined;
    source: string | undefined;
    systemPoint: number | undefined;
    systemCoin: number | undefined;
    address: string | undefined;
    activationCode: string | undefined;
    phoneNumber: string | undefined;
    customerName: string | undefined;
    province: string | undefined;
    district: string | undefined;
    ward: string | undefined;
    provinceName: string | undefined;
    wardName: string | undefined;
    districtName: string | undefined;
    paymentStatus: number | undefined;
    paymentDate: moment.Moment | undefined;
    reason: string | undefined;
    productCode: string | undefined;
    deptName: string | undefined;
    location: string | undefined;
    returnType: string | undefined;
    wrongRegion: boolean | undefined;
    isExpiredUpdate: boolean | undefined;
    isAllowRollback: boolean | undefined;
    isRollbacked: boolean | undefined;
    rollBackFrom: number | undefined;
    paymentStatusText: string | undefined;
    paymentNotes: string | undefined;
    isDeleted: boolean | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;
    detailValue: string | undefined;
    brand: string | undefined;
}

export class PagedResultDtoOfGetPaymentStatusForViewDto implements IPagedResultDtoOfGetPaymentStatusForViewDto {
    totalCount!: number | undefined;
    items!: GetPaymentStatusForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetPaymentStatusForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetPaymentStatusForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetPaymentStatusForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetPaymentStatusForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetPaymentStatusForViewDto {
    totalCount: number | undefined;
    items: GetPaymentStatusForViewDto[] | undefined;
}

export class GetPaymentStatusForViewDto implements IGetPaymentStatusForViewDto {
    paymentStatus!: GetListPaymentStatusResponse | undefined;

    constructor(data?: IGetPaymentStatusForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.paymentStatus = data["paymentStatus"] ? GetListPaymentStatusResponse.fromJS(data["paymentStatus"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetPaymentStatusForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPaymentStatusForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentStatus"] = this.paymentStatus ? this.paymentStatus.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetPaymentStatusForViewDto {
    paymentStatus: GetListPaymentStatusResponse | undefined;
}

export class GetListPaymentStatusResponse implements IGetListPaymentStatusResponse {
    totalCount!: number | undefined;
    serial!: string | undefined;
    memberCode!: string | undefined;
    memberName!: string | undefined;
    paymentStatus!: number | undefined;
    paymentStatusText!: string | undefined;
    paymentDate!: moment.Moment | undefined;
    paymentNotes!: string | undefined;
    productCode!: string | undefined;
    department!: string | undefined;
    systemCoin!: number | undefined;
    saleType!: string | undefined;
    isDeleted!: boolean | undefined;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: moment.Moment | undefined;
    creatorUserId!: number | undefined;
    id!: number | undefined;

    constructor(data?: IGetListPaymentStatusResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            this.serial = data["serial"];
            this.memberCode = data["memberCode"];
            this.memberName = data["memberName"];
            this.paymentStatus = data["paymentStatus"];
            this.paymentStatusText = data["paymentStatusText"];
            this.paymentDate = data["paymentDate"] ? moment(data["paymentDate"].toString()) : <any>undefined;
            this.paymentNotes = data["paymentNotes"];
            this.productCode = data["productCode"];
            this.department = data["department"];
            this.systemCoin = data["systemCoin"];
            this.saleType = data["saleType"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): GetListPaymentStatusResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetListPaymentStatusResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        data["serial"] = this.serial;
        data["memberCode"] = this.memberCode;
        data["memberName"] = this.memberName;
        data["paymentStatus"] = this.paymentStatus;
        data["paymentStatusText"] = this.paymentStatusText;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : <any>undefined;
        data["paymentNotes"] = this.paymentNotes;
        data["productCode"] = this.productCode;
        data["department"] = this.department;
        data["systemCoin"] = this.systemCoin;
        data["saleType"] = this.saleType;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IGetListPaymentStatusResponse {
    totalCount: number | undefined;
    serial: string | undefined;
    memberCode: string | undefined;
    memberName: string | undefined;
    paymentStatus: number | undefined;
    paymentStatusText: string | undefined;
    paymentDate: moment.Moment | undefined;
    paymentNotes: string | undefined;
    productCode: string | undefined;
    department: string | undefined;
    systemCoin: number | undefined;
    saleType: string | undefined;
    isDeleted: boolean | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class GetSellOutDistributorInput implements IGetSellOutDistributorInput {
    referenceId!: string | undefined;
    salemanCode!: string | undefined;
    fromDate!: moment.Moment | undefined;
    toDate!: moment.Moment | undefined;
    memberCode!: string | undefined;
    serial!: string | undefined;
    model!: string | undefined;
    vehicleNumber!: string | undefined;
    saleType!: string | undefined;
    serialType!: string | undefined;
    isDistributorTemp!: boolean | undefined;
    sorting!: string | undefined;
    skipCount!: number | undefined;
    maxResultCount!: number | undefined;

    constructor(data?: IGetSellOutDistributorInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.referenceId = data["referenceId"];
            this.salemanCode = data["salemanCode"];
            this.fromDate = data["fromDate"] ? moment(data["fromDate"].toString()) : <any>undefined;
            this.toDate = data["toDate"] ? moment(data["toDate"].toString()) : <any>undefined;
            this.memberCode = data["memberCode"];
            this.serial = data["serial"];
            this.model = data["model"];
            this.vehicleNumber = data["vehicleNumber"];
            this.saleType = data["saleType"];
            this.serialType = data["serialType"];
            this.isDistributorTemp = data["isDistributorTemp"];
            this.sorting = data["sorting"];
            this.skipCount = data["skipCount"];
            this.maxResultCount = data["maxResultCount"];
        }
    }

    static fromJS(data: any): GetSellOutDistributorInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetSellOutDistributorInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["referenceId"] = this.referenceId;
        data["salemanCode"] = this.salemanCode;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data["memberCode"] = this.memberCode;
        data["serial"] = this.serial;
        data["model"] = this.model;
        data["vehicleNumber"] = this.vehicleNumber;
        data["saleType"] = this.saleType;
        data["serialType"] = this.serialType;
        data["isDistributorTemp"] = this.isDistributorTemp;
        data["sorting"] = this.sorting;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data;
    }
}

export interface IGetSellOutDistributorInput {
    referenceId: string | undefined;
    salemanCode: string | undefined;
    fromDate: moment.Moment | undefined;
    toDate: moment.Moment | undefined;
    memberCode: string | undefined;
    serial: string | undefined;
    model: string | undefined;
    vehicleNumber: string | undefined;
    saleType: string | undefined;
    serialType: string | undefined;
    isDistributorTemp: boolean | undefined;
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;
}

export class PagedResultDtoOfGetSellOutDistributorForViewDto implements IPagedResultDtoOfGetSellOutDistributorForViewDto {
    totalCount!: number | undefined;
    items!: GetSellOutDistributorForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetSellOutDistributorForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetSellOutDistributorForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetSellOutDistributorForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetSellOutDistributorForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetSellOutDistributorForViewDto {
    totalCount: number | undefined;
    items: GetSellOutDistributorForViewDto[] | undefined;
}

export class GetSellOutDistributorForViewDto implements IGetSellOutDistributorForViewDto {
    sale!: GetListSellOutDistributorResponse | undefined;

    constructor(data?: IGetSellOutDistributorForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.sale = data["sale"] ? GetListSellOutDistributorResponse.fromJS(data["sale"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSellOutDistributorForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetSellOutDistributorForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sale"] = this.sale ? this.sale.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetSellOutDistributorForViewDto {
    sale: GetListSellOutDistributorResponse | undefined;
}

export class GetListSellOutDistributorResponse implements IGetListSellOutDistributorResponse {
    referenceId!: string | undefined;
    memberCode!: string | undefined;
    memberName!: string | undefined;
    creatorName!: string | undefined;
    serial!: string | undefined;
    productCode!: string | undefined;
    productName!: string | undefined;
    syncSAP!: boolean | undefined;
    allowDelete!: boolean | undefined;
    vehicleNumber!: string | undefined;
    isReturn!: boolean | undefined;
    returnType!: string | undefined;
    isDeleted!: boolean | undefined;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: moment.Moment | undefined;
    creatorUserId!: number | undefined;
    databaseCreationTime!: moment.Moment | undefined;
    id!: number | undefined;

    constructor(data?: IGetListSellOutDistributorResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.referenceId = data["referenceId"];
            this.memberCode = data["memberCode"];
            this.memberName = data["memberName"];
            this.creatorName = data["creatorName"];
            this.serial = data["serial"];
            this.productCode = data["productCode"];
            this.productName = data["productName"];
            this.syncSAP = data["syncSAP"];
            this.allowDelete = data["allowDelete"];
            this.vehicleNumber = data["vehicleNumber"];
            this.isReturn = data["isReturn"];
            this.returnType = data["returnType"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.databaseCreationTime = data["databaseCreationTime"] ? moment(data["databaseCreationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): GetListSellOutDistributorResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetListSellOutDistributorResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["referenceId"] = this.referenceId;
        data["memberCode"] = this.memberCode;
        data["memberName"] = this.memberName;
        data["creatorName"] = this.creatorName;
        data["serial"] = this.serial;
        data["productCode"] = this.productCode;
        data["productName"] = this.productName;
        data["syncSAP"] = this.syncSAP;
        data["allowDelete"] = this.allowDelete;
        data["vehicleNumber"] = this.vehicleNumber;
        data["isReturn"] = this.isReturn;
        data["returnType"] = this.returnType;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["databaseCreationTime"] = this.databaseCreationTime ? this.databaseCreationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IGetListSellOutDistributorResponse {
    referenceId: string | undefined;
    memberCode: string | undefined;
    memberName: string | undefined;
    creatorName: string | undefined;
    serial: string | undefined;
    productCode: string | undefined;
    productName: string | undefined;
    syncSAP: boolean | undefined;
    allowDelete: boolean | undefined;
    vehicleNumber: string | undefined;
    isReturn: boolean | undefined;
    returnType: string | undefined;
    isDeleted: boolean | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class CheckSerialRequest implements ICheckSerialRequest {
    serial!: string | undefined;
    referenceId!: string | undefined;
    memberCode!: string | undefined;
    memberName!: string | undefined;
    vehicleNumber!: string | undefined;
    modelCode!: string | undefined;
    message!: string | undefined;
    isDistributorTemp!: string | undefined;

    constructor(data?: ICheckSerialRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.serial = data["serial"];
            this.referenceId = data["referenceId"];
            this.memberCode = data["memberCode"];
            this.memberName = data["memberName"];
            this.vehicleNumber = data["vehicleNumber"];
            this.modelCode = data["modelCode"];
            this.message = data["message"];
            this.isDistributorTemp = data["isDistributorTemp"];
        }
    }

    static fromJS(data: any): CheckSerialRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CheckSerialRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serial"] = this.serial;
        data["referenceId"] = this.referenceId;
        data["memberCode"] = this.memberCode;
        data["memberName"] = this.memberName;
        data["vehicleNumber"] = this.vehicleNumber;
        data["modelCode"] = this.modelCode;
        data["message"] = this.message;
        data["isDistributorTemp"] = this.isDistributorTemp;
        return data;
    }
}

export interface ICheckSerialRequest {
    serial: string | undefined;
    referenceId: string | undefined;
    memberCode: string | undefined;
    memberName: string | undefined;
    vehicleNumber: string | undefined;
    modelCode: string | undefined;
    message: string | undefined;
    isDistributorTemp: string | undefined;
}

export class CheckSerialResponse implements ICheckSerialResponse {
    isSuccess!: boolean | undefined;
    modelCode!: string | undefined;
    modelName!: string | undefined;
    message!: string | undefined;
    serialType!: string | undefined;

    constructor(data?: ICheckSerialResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isSuccess = data["isSuccess"];
            this.modelCode = data["modelCode"];
            this.modelName = data["modelName"];
            this.message = data["message"];
            this.serialType = data["serialType"];
        }
    }

    static fromJS(data: any): CheckSerialResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CheckSerialResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["modelCode"] = this.modelCode;
        data["modelName"] = this.modelName;
        data["message"] = this.message;
        data["serialType"] = this.serialType;
        return data;
    }
}

export interface ICheckSerialResponse {
    isSuccess: boolean | undefined;
    modelCode: string | undefined;
    modelName: string | undefined;
    message: string | undefined;
    serialType: string | undefined;
}

export class UpdateDONumberRequest implements IUpdateDONumberRequest {
    oldReferenceId!: string | undefined;
    newReferenceId!: string | undefined;
    oldDistributor!: string | undefined;
    newDistributor!: string | undefined;
    newDistributorName!: string | undefined;
    oldVehicle!: string | undefined;
    newVehicle!: string | undefined;

    constructor(data?: IUpdateDONumberRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.oldReferenceId = data["oldReferenceId"];
            this.newReferenceId = data["newReferenceId"];
            this.oldDistributor = data["oldDistributor"];
            this.newDistributor = data["newDistributor"];
            this.newDistributorName = data["newDistributorName"];
            this.oldVehicle = data["oldVehicle"];
            this.newVehicle = data["newVehicle"];
        }
    }

    static fromJS(data: any): UpdateDONumberRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDONumberRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["oldReferenceId"] = this.oldReferenceId;
        data["newReferenceId"] = this.newReferenceId;
        data["oldDistributor"] = this.oldDistributor;
        data["newDistributor"] = this.newDistributor;
        data["newDistributorName"] = this.newDistributorName;
        data["oldVehicle"] = this.oldVehicle;
        data["newVehicle"] = this.newVehicle;
        return data;
    }
}

export interface IUpdateDONumberRequest {
    oldReferenceId: string | undefined;
    newReferenceId: string | undefined;
    oldDistributor: string | undefined;
    newDistributor: string | undefined;
    newDistributorName: string | undefined;
    oldVehicle: string | undefined;
    newVehicle: string | undefined;
}

export class UpdateDONumberResponse implements IUpdateDONumberResponse {
    isSuccess!: boolean | undefined;
    message!: string | undefined;

    constructor(data?: IUpdateDONumberResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isSuccess = data["isSuccess"];
            this.message = data["message"];
        }
    }

    static fromJS(data: any): UpdateDONumberResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDONumberResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["message"] = this.message;
        return data;
    }
}

export interface IUpdateDONumberResponse {
    isSuccess: boolean | undefined;
    message: string | undefined;
}

export class RemoveSerialResponse implements IRemoveSerialResponse {
    isSuccess!: boolean | undefined;
    message!: string | undefined;

    constructor(data?: IRemoveSerialResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isSuccess = data["isSuccess"];
            this.message = data["message"];
        }
    }

    static fromJS(data: any): RemoveSerialResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RemoveSerialResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["message"] = this.message;
        return data;
    }
}

export interface IRemoveSerialResponse {
    isSuccess: boolean | undefined;
    message: string | undefined;
}

export class ReturnSerialRequest implements IReturnSerialRequest {
    type!: string | undefined;
    serial!: string | undefined;
    serialChange!: string | undefined;
    invoiceIn!: string | undefined;
    invoiceOut!: string | undefined;

    constructor(data?: IReturnSerialRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.type = data["type"];
            this.serial = data["serial"];
            this.serialChange = data["serialChange"];
            this.invoiceIn = data["invoiceIn"];
            this.invoiceOut = data["invoiceOut"];
        }
    }

    static fromJS(data: any): ReturnSerialRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ReturnSerialRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["serial"] = this.serial;
        data["serialChange"] = this.serialChange;
        data["invoiceIn"] = this.invoiceIn;
        data["invoiceOut"] = this.invoiceOut;
        return data;
    }
}

export interface IReturnSerialRequest {
    type: string | undefined;
    serial: string | undefined;
    serialChange: string | undefined;
    invoiceIn: string | undefined;
    invoiceOut: string | undefined;
}

export class ReturnSerialResponse implements IReturnSerialResponse {
    isSuccess!: boolean | undefined;
    message!: string | undefined;

    constructor(data?: IReturnSerialResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isSuccess = data["isSuccess"];
            this.message = data["message"];
        }
    }

    static fromJS(data: any): ReturnSerialResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ReturnSerialResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["message"] = this.message;
        return data;
    }
}

export interface IReturnSerialResponse {
    isSuccess: boolean | undefined;
    message: string | undefined;
}

export class UserNotificationInfoDTO implements IUserNotificationInfoDTO {
    seenAll!: boolean | undefined;
    totalSeen!: number | undefined;
    totalSent!: number | undefined;

    constructor(data?: IUserNotificationInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.seenAll = data["seenAll"];
            this.totalSeen = data["totalSeen"];
            this.totalSent = data["totalSent"];
        }
    }

    static fromJS(data: any): UserNotificationInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UserNotificationInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["seenAll"] = this.seenAll;
        data["totalSeen"] = this.totalSeen;
        data["totalSent"] = this.totalSent;
        return data;
    }
}

export interface IUserNotificationInfoDTO {
    seenAll: boolean | undefined;
    totalSeen: number | undefined;
    totalSent: number | undefined;
}

export class SalesUpdateWarrSerialDTO implements ISalesUpdateWarrSerialDTO {
    productSerialCode!: string | undefined;
    warrantyCode!: string | undefined;
    inWareHouse!: boolean | undefined;

    constructor(data?: ISalesUpdateWarrSerialDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.productSerialCode = data["productSerialCode"];
            this.warrantyCode = data["warrantyCode"];
            this.inWareHouse = data["inWareHouse"];
        }
    }

    static fromJS(data: any): SalesUpdateWarrSerialDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SalesUpdateWarrSerialDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productSerialCode"] = this.productSerialCode;
        data["warrantyCode"] = this.warrantyCode;
        data["inWareHouse"] = this.inWareHouse;
        return data;
    }
}

export interface ISalesUpdateWarrSerialDTO {
    productSerialCode: string | undefined;
    warrantyCode: string | undefined;
    inWareHouse: boolean | undefined;
}

export class SAP1Doi1SerialLoiInputDto implements ISAP1Doi1SerialLoiInputDto {
    items!: SAP1Doi1SerialLoiResource[] | undefined;

    constructor(data?: ISAP1Doi1SerialLoiInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(SAP1Doi1SerialLoiResource.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SAP1Doi1SerialLoiInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new SAP1Doi1SerialLoiInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISAP1Doi1SerialLoiInputDto {
    items: SAP1Doi1SerialLoiResource[] | undefined;
}

export class SAP1Doi1SerialLoiResource implements ISAP1Doi1SerialLoiResource {
    doNum!: string | undefined;
    material!: string | undefined;

    constructor(data?: ISAP1Doi1SerialLoiResource) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.doNum = data["doNum"];
            this.material = data["material"];
        }
    }

    static fromJS(data: any): SAP1Doi1SerialLoiResource {
        data = typeof data === 'object' ? data : {};
        let result = new SAP1Doi1SerialLoiResource();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["doNum"] = this.doNum;
        data["material"] = this.material;
        return data;
    }
}

export interface ISAP1Doi1SerialLoiResource {
    doNum: string | undefined;
    material: string | undefined;
}

export class ResponseDtoOfListOfZif1Doi1SerialLoiResponseItem implements IResponseDtoOfListOfZif1Doi1SerialLoiResponseItem {
    message!: string | undefined;
    data!: Zif1Doi1SerialLoiResponseItem[] | undefined;

    constructor(data?: IResponseDtoOfListOfZif1Doi1SerialLoiResponseItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.message = data["message"];
            if (data["data"] && data["data"].constructor === Array) {
                this.data = [];
                for (let item of data["data"])
                    this.data.push(Zif1Doi1SerialLoiResponseItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResponseDtoOfListOfZif1Doi1SerialLoiResponseItem {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseDtoOfListOfZif1Doi1SerialLoiResponseItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        if (this.data && this.data.constructor === Array) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IResponseDtoOfListOfZif1Doi1SerialLoiResponseItem {
    message: string | undefined;
    data: Zif1Doi1SerialLoiResponseItem[] | undefined;
}

export class Zif1Doi1SerialLoiResponseItem implements IZif1Doi1SerialLoiResponseItem {
    serial!: string | undefined;
    deliveryType!: string | undefined;
    materialGroup!: string | undefined;
    deliveryQuantity!: string | undefined;
    itemDescription!: string | undefined;
    soldToParty!: string | undefined;
    ind!: string | undefined;
    message!: string | undefined;
    doNum!: string | undefined;
    material!: string | undefined;

    constructor(data?: IZif1Doi1SerialLoiResponseItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.serial = data["serial"];
            this.deliveryType = data["deliveryType"];
            this.materialGroup = data["materialGroup"];
            this.deliveryQuantity = data["deliveryQuantity"];
            this.itemDescription = data["itemDescription"];
            this.soldToParty = data["soldToParty"];
            this.ind = data["ind"];
            this.message = data["message"];
            this.doNum = data["doNum"];
            this.material = data["material"];
        }
    }

    static fromJS(data: any): Zif1Doi1SerialLoiResponseItem {
        data = typeof data === 'object' ? data : {};
        let result = new Zif1Doi1SerialLoiResponseItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serial"] = this.serial;
        data["deliveryType"] = this.deliveryType;
        data["materialGroup"] = this.materialGroup;
        data["deliveryQuantity"] = this.deliveryQuantity;
        data["itemDescription"] = this.itemDescription;
        data["soldToParty"] = this.soldToParty;
        data["ind"] = this.ind;
        data["message"] = this.message;
        data["doNum"] = this.doNum;
        data["material"] = this.material;
        return data;
    }
}

export interface IZif1Doi1SerialLoiResponseItem {
    serial: string | undefined;
    deliveryType: string | undefined;
    materialGroup: string | undefined;
    deliveryQuantity: string | undefined;
    itemDescription: string | undefined;
    soldToParty: string | undefined;
    ind: string | undefined;
    message: string | undefined;
    doNum: string | undefined;
    material: string | undefined;
}

export class PagedResultDtoOfGetSalesInvoiceBaselineForViewDto implements IPagedResultDtoOfGetSalesInvoiceBaselineForViewDto {
    totalCount!: number | undefined;
    items!: GetSalesInvoiceBaselineForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetSalesInvoiceBaselineForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetSalesInvoiceBaselineForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetSalesInvoiceBaselineForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetSalesInvoiceBaselineForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetSalesInvoiceBaselineForViewDto {
    totalCount: number | undefined;
    items: GetSalesInvoiceBaselineForViewDto[] | undefined;
}

export class GetSalesInvoiceBaselineForViewDto implements IGetSalesInvoiceBaselineForViewDto {
    salesInvoiceBaseline!: SalesInvoiceBaselineDto | undefined;

    constructor(data?: IGetSalesInvoiceBaselineForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.salesInvoiceBaseline = data["salesInvoiceBaseline"] ? SalesInvoiceBaselineDto.fromJS(data["salesInvoiceBaseline"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSalesInvoiceBaselineForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetSalesInvoiceBaselineForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["salesInvoiceBaseline"] = this.salesInvoiceBaseline ? this.salesInvoiceBaseline.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetSalesInvoiceBaselineForViewDto {
    salesInvoiceBaseline: SalesInvoiceBaselineDto | undefined;
}

export class SalesInvoiceBaselineDto implements ISalesInvoiceBaselineDto {
    voucherGroupCode!: string | undefined;
    memberCode!: string | undefined;
    postingDate!: moment.Moment | undefined;
    salesInvoiceCode!: string | undefined;
    totalAmount!: number | undefined;
    incremental!: number | undefined;
    id!: number | undefined;

    constructor(data?: ISalesInvoiceBaselineDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.voucherGroupCode = data["voucherGroupCode"];
            this.memberCode = data["memberCode"];
            this.postingDate = data["postingDate"] ? moment(data["postingDate"].toString()) : <any>undefined;
            this.salesInvoiceCode = data["salesInvoiceCode"];
            this.totalAmount = data["totalAmount"];
            this.incremental = data["incremental"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SalesInvoiceBaselineDto {
        data = typeof data === 'object' ? data : {};
        let result = new SalesInvoiceBaselineDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["voucherGroupCode"] = this.voucherGroupCode;
        data["memberCode"] = this.memberCode;
        data["postingDate"] = this.postingDate ? this.postingDate.toISOString() : <any>undefined;
        data["salesInvoiceCode"] = this.salesInvoiceCode;
        data["totalAmount"] = this.totalAmount;
        data["incremental"] = this.incremental;
        data["id"] = this.id;
        return data;
    }
}

export interface ISalesInvoiceBaselineDto {
    voucherGroupCode: string | undefined;
    memberCode: string | undefined;
    postingDate: moment.Moment | undefined;
    salesInvoiceCode: string | undefined;
    totalAmount: number | undefined;
    incremental: number | undefined;
    id: number | undefined;
}

export class GetSalesInvoiceBaselineForEditOutput implements IGetSalesInvoiceBaselineForEditOutput {
    salesInvoiceBaseline!: CreateOrEditSalesInvoiceBaselineDto | undefined;

    constructor(data?: IGetSalesInvoiceBaselineForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.salesInvoiceBaseline = data["salesInvoiceBaseline"] ? CreateOrEditSalesInvoiceBaselineDto.fromJS(data["salesInvoiceBaseline"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSalesInvoiceBaselineForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetSalesInvoiceBaselineForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["salesInvoiceBaseline"] = this.salesInvoiceBaseline ? this.salesInvoiceBaseline.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetSalesInvoiceBaselineForEditOutput {
    salesInvoiceBaseline: CreateOrEditSalesInvoiceBaselineDto | undefined;
}

export class CreateOrEditSalesInvoiceBaselineDto implements ICreateOrEditSalesInvoiceBaselineDto {
    voucherGroupCode!: string | undefined;
    memberCode!: string | undefined;
    postingDate!: moment.Moment | undefined;
    salesInvoiceCode!: string | undefined;
    totalAmount!: number | undefined;
    incremental!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditSalesInvoiceBaselineDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.voucherGroupCode = data["voucherGroupCode"];
            this.memberCode = data["memberCode"];
            this.postingDate = data["postingDate"] ? moment(data["postingDate"].toString()) : <any>undefined;
            this.salesInvoiceCode = data["salesInvoiceCode"];
            this.totalAmount = data["totalAmount"];
            this.incremental = data["incremental"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditSalesInvoiceBaselineDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditSalesInvoiceBaselineDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["voucherGroupCode"] = this.voucherGroupCode;
        data["memberCode"] = this.memberCode;
        data["postingDate"] = this.postingDate ? this.postingDate.toISOString() : <any>undefined;
        data["salesInvoiceCode"] = this.salesInvoiceCode;
        data["totalAmount"] = this.totalAmount;
        data["incremental"] = this.incremental;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditSalesInvoiceBaselineDto {
    voucherGroupCode: string | undefined;
    memberCode: string | undefined;
    postingDate: moment.Moment | undefined;
    salesInvoiceCode: string | undefined;
    totalAmount: number | undefined;
    incremental: number | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfGetSalesInvoiceDetailForViewDto implements IPagedResultDtoOfGetSalesInvoiceDetailForViewDto {
    totalCount!: number | undefined;
    items!: GetSalesInvoiceDetailForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetSalesInvoiceDetailForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetSalesInvoiceDetailForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetSalesInvoiceDetailForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetSalesInvoiceDetailForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetSalesInvoiceDetailForViewDto {
    totalCount: number | undefined;
    items: GetSalesInvoiceDetailForViewDto[] | undefined;
}

export class GetSalesInvoiceDetailForViewDto implements IGetSalesInvoiceDetailForViewDto {
    salesInvoiceDetail!: SalesInvoiceDetailDto | undefined;

    constructor(data?: IGetSalesInvoiceDetailForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.salesInvoiceDetail = data["salesInvoiceDetail"] ? SalesInvoiceDetailDto.fromJS(data["salesInvoiceDetail"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSalesInvoiceDetailForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetSalesInvoiceDetailForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["salesInvoiceDetail"] = this.salesInvoiceDetail ? this.salesInvoiceDetail.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetSalesInvoiceDetailForViewDto {
    salesInvoiceDetail: SalesInvoiceDetailDto | undefined;
}

export class SalesInvoiceDetailDto implements ISalesInvoiceDetailDto {
    postingDate!: moment.Moment | undefined;
    salesInvoiceCode!: string | undefined;
    terminalNo!: string | undefined;
    seqNo!: number | undefined;
    memberCode!: string | undefined;
    deptCode!: string | undefined;
    divCode!: string | undefined;
    categoryCode!: string | undefined;
    itemCode!: string | undefined;
    brandCode!: string | undefined;
    quantity!: number | undefined;
    sellingprice!: number | undefined;
    discount!: number | undefined;
    amount!: number | undefined;
    customerCode!: string | undefined;
    id!: number | undefined;

    constructor(data?: ISalesInvoiceDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.postingDate = data["postingDate"] ? moment(data["postingDate"].toString()) : <any>undefined;
            this.salesInvoiceCode = data["salesInvoiceCode"];
            this.terminalNo = data["terminalNo"];
            this.seqNo = data["seqNo"];
            this.memberCode = data["memberCode"];
            this.deptCode = data["deptCode"];
            this.divCode = data["divCode"];
            this.categoryCode = data["categoryCode"];
            this.itemCode = data["itemCode"];
            this.brandCode = data["brandCode"];
            this.quantity = data["quantity"];
            this.sellingprice = data["sellingprice"];
            this.discount = data["discount"];
            this.amount = data["amount"];
            this.customerCode = data["customerCode"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SalesInvoiceDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new SalesInvoiceDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["postingDate"] = this.postingDate ? this.postingDate.toISOString() : <any>undefined;
        data["salesInvoiceCode"] = this.salesInvoiceCode;
        data["terminalNo"] = this.terminalNo;
        data["seqNo"] = this.seqNo;
        data["memberCode"] = this.memberCode;
        data["deptCode"] = this.deptCode;
        data["divCode"] = this.divCode;
        data["categoryCode"] = this.categoryCode;
        data["itemCode"] = this.itemCode;
        data["brandCode"] = this.brandCode;
        data["quantity"] = this.quantity;
        data["sellingprice"] = this.sellingprice;
        data["discount"] = this.discount;
        data["amount"] = this.amount;
        data["customerCode"] = this.customerCode;
        data["id"] = this.id;
        return data;
    }
}

export interface ISalesInvoiceDetailDto {
    postingDate: moment.Moment | undefined;
    salesInvoiceCode: string | undefined;
    terminalNo: string | undefined;
    seqNo: number | undefined;
    memberCode: string | undefined;
    deptCode: string | undefined;
    divCode: string | undefined;
    categoryCode: string | undefined;
    itemCode: string | undefined;
    brandCode: string | undefined;
    quantity: number | undefined;
    sellingprice: number | undefined;
    discount: number | undefined;
    amount: number | undefined;
    customerCode: string | undefined;
    id: number | undefined;
}

export class GetSalesInvoiceDetailForEditOutput implements IGetSalesInvoiceDetailForEditOutput {
    salesInvoiceDetail!: CreateOrEditSalesInvoiceDetailDto | undefined;

    constructor(data?: IGetSalesInvoiceDetailForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.salesInvoiceDetail = data["salesInvoiceDetail"] ? CreateOrEditSalesInvoiceDetailDto.fromJS(data["salesInvoiceDetail"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSalesInvoiceDetailForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetSalesInvoiceDetailForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["salesInvoiceDetail"] = this.salesInvoiceDetail ? this.salesInvoiceDetail.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetSalesInvoiceDetailForEditOutput {
    salesInvoiceDetail: CreateOrEditSalesInvoiceDetailDto | undefined;
}

export class CreateOrEditSalesInvoiceDetailDto implements ICreateOrEditSalesInvoiceDetailDto {
    postingDate!: moment.Moment | undefined;
    salesInvoiceCode!: string | undefined;
    terminalNo!: string | undefined;
    seqNo!: number | undefined;
    memberCode!: string | undefined;
    deptCode!: string | undefined;
    divCode!: string | undefined;
    categoryCode!: string | undefined;
    itemCode!: string | undefined;
    brandCode!: string | undefined;
    quantity!: number | undefined;
    sellingprice!: number | undefined;
    discount!: number | undefined;
    amount!: number | undefined;
    customerCode!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditSalesInvoiceDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.postingDate = data["postingDate"] ? moment(data["postingDate"].toString()) : <any>undefined;
            this.salesInvoiceCode = data["salesInvoiceCode"];
            this.terminalNo = data["terminalNo"];
            this.seqNo = data["seqNo"];
            this.memberCode = data["memberCode"];
            this.deptCode = data["deptCode"];
            this.divCode = data["divCode"];
            this.categoryCode = data["categoryCode"];
            this.itemCode = data["itemCode"];
            this.brandCode = data["brandCode"];
            this.quantity = data["quantity"];
            this.sellingprice = data["sellingprice"];
            this.discount = data["discount"];
            this.amount = data["amount"];
            this.customerCode = data["customerCode"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditSalesInvoiceDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditSalesInvoiceDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["postingDate"] = this.postingDate ? this.postingDate.toISOString() : <any>undefined;
        data["salesInvoiceCode"] = this.salesInvoiceCode;
        data["terminalNo"] = this.terminalNo;
        data["seqNo"] = this.seqNo;
        data["memberCode"] = this.memberCode;
        data["deptCode"] = this.deptCode;
        data["divCode"] = this.divCode;
        data["categoryCode"] = this.categoryCode;
        data["itemCode"] = this.itemCode;
        data["brandCode"] = this.brandCode;
        data["quantity"] = this.quantity;
        data["sellingprice"] = this.sellingprice;
        data["discount"] = this.discount;
        data["amount"] = this.amount;
        data["customerCode"] = this.customerCode;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditSalesInvoiceDetailDto {
    postingDate: moment.Moment | undefined;
    salesInvoiceCode: string | undefined;
    terminalNo: string | undefined;
    seqNo: number | undefined;
    memberCode: string | undefined;
    deptCode: string | undefined;
    divCode: string | undefined;
    categoryCode: string | undefined;
    itemCode: string | undefined;
    brandCode: string | undefined;
    quantity: number | undefined;
    sellingprice: number | undefined;
    discount: number | undefined;
    amount: number | undefined;
    customerCode: string | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfGetSalesInvoiceHeaderForViewDto implements IPagedResultDtoOfGetSalesInvoiceHeaderForViewDto {
    totalCount!: number | undefined;
    items!: GetSalesInvoiceHeaderForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetSalesInvoiceHeaderForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetSalesInvoiceHeaderForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetSalesInvoiceHeaderForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetSalesInvoiceHeaderForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetSalesInvoiceHeaderForViewDto {
    totalCount: number | undefined;
    items: GetSalesInvoiceHeaderForViewDto[] | undefined;
}

export class GetSalesInvoiceHeaderForViewDto implements IGetSalesInvoiceHeaderForViewDto {
    salesInvoiceHeader!: SalesInvoiceHeaderDto | undefined;
    rating!: number | undefined;

    constructor(data?: IGetSalesInvoiceHeaderForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.salesInvoiceHeader = data["salesInvoiceHeader"] ? SalesInvoiceHeaderDto.fromJS(data["salesInvoiceHeader"]) : <any>undefined;
            this.rating = data["rating"];
        }
    }

    static fromJS(data: any): GetSalesInvoiceHeaderForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetSalesInvoiceHeaderForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["salesInvoiceHeader"] = this.salesInvoiceHeader ? this.salesInvoiceHeader.toJSON() : <any>undefined;
        data["rating"] = this.rating;
        return data;
    }
}

export interface IGetSalesInvoiceHeaderForViewDto {
    salesInvoiceHeader: SalesInvoiceHeaderDto | undefined;
    rating: number | undefined;
}

export class SalesInvoiceHeaderDto implements ISalesInvoiceHeaderDto {
    postingDate!: moment.Moment | undefined;
    salesInvoiceCode!: string | undefined;
    terminalNo!: string | undefined;
    totalAmount!: number | undefined;
    memberCode!: string | undefined;
    point!: number | undefined;
    transactionType!: string | undefined;
    location!: string | undefined;
    allowance!: number | undefined;
    customerCode!: string | undefined;
    referenceCode!: string | undefined;
    id!: number | undefined;

    constructor(data?: ISalesInvoiceHeaderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.postingDate = data["postingDate"] ? moment(data["postingDate"].toString()) : <any>undefined;
            this.salesInvoiceCode = data["salesInvoiceCode"];
            this.terminalNo = data["terminalNo"];
            this.totalAmount = data["totalAmount"];
            this.memberCode = data["memberCode"];
            this.point = data["point"];
            this.transactionType = data["transactionType"];
            this.location = data["location"];
            this.allowance = data["allowance"];
            this.customerCode = data["customerCode"];
            this.referenceCode = data["referenceCode"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SalesInvoiceHeaderDto {
        data = typeof data === 'object' ? data : {};
        let result = new SalesInvoiceHeaderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["postingDate"] = this.postingDate ? this.postingDate.toISOString() : <any>undefined;
        data["salesInvoiceCode"] = this.salesInvoiceCode;
        data["terminalNo"] = this.terminalNo;
        data["totalAmount"] = this.totalAmount;
        data["memberCode"] = this.memberCode;
        data["point"] = this.point;
        data["transactionType"] = this.transactionType;
        data["location"] = this.location;
        data["allowance"] = this.allowance;
        data["customerCode"] = this.customerCode;
        data["referenceCode"] = this.referenceCode;
        data["id"] = this.id;
        return data;
    }
}

export interface ISalesInvoiceHeaderDto {
    postingDate: moment.Moment | undefined;
    salesInvoiceCode: string | undefined;
    terminalNo: string | undefined;
    totalAmount: number | undefined;
    memberCode: string | undefined;
    point: number | undefined;
    transactionType: string | undefined;
    location: string | undefined;
    allowance: number | undefined;
    customerCode: string | undefined;
    referenceCode: string | undefined;
    id: number | undefined;
}

export class GetSalesInvoiceHeaderForEditOutput implements IGetSalesInvoiceHeaderForEditOutput {
    salesInvoiceHeader!: CreateOrEditSalesInvoiceHeaderDto | undefined;

    constructor(data?: IGetSalesInvoiceHeaderForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.salesInvoiceHeader = data["salesInvoiceHeader"] ? CreateOrEditSalesInvoiceHeaderDto.fromJS(data["salesInvoiceHeader"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSalesInvoiceHeaderForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetSalesInvoiceHeaderForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["salesInvoiceHeader"] = this.salesInvoiceHeader ? this.salesInvoiceHeader.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetSalesInvoiceHeaderForEditOutput {
    salesInvoiceHeader: CreateOrEditSalesInvoiceHeaderDto | undefined;
}

export class CreateOrEditSalesInvoiceHeaderDto implements ICreateOrEditSalesInvoiceHeaderDto {
    postingDate!: moment.Moment | undefined;
    salesInvoiceCode!: string | undefined;
    terminalNo!: string | undefined;
    totalAmount!: number | undefined;
    memberCode!: string | undefined;
    point!: number | undefined;
    transactionType!: string | undefined;
    location!: string | undefined;
    allowance!: number | undefined;
    customerCode!: string | undefined;
    referenceCode!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditSalesInvoiceHeaderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.postingDate = data["postingDate"] ? moment(data["postingDate"].toString()) : <any>undefined;
            this.salesInvoiceCode = data["salesInvoiceCode"];
            this.terminalNo = data["terminalNo"];
            this.totalAmount = data["totalAmount"];
            this.memberCode = data["memberCode"];
            this.point = data["point"];
            this.transactionType = data["transactionType"];
            this.location = data["location"];
            this.allowance = data["allowance"];
            this.customerCode = data["customerCode"];
            this.referenceCode = data["referenceCode"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditSalesInvoiceHeaderDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditSalesInvoiceHeaderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["postingDate"] = this.postingDate ? this.postingDate.toISOString() : <any>undefined;
        data["salesInvoiceCode"] = this.salesInvoiceCode;
        data["terminalNo"] = this.terminalNo;
        data["totalAmount"] = this.totalAmount;
        data["memberCode"] = this.memberCode;
        data["point"] = this.point;
        data["transactionType"] = this.transactionType;
        data["location"] = this.location;
        data["allowance"] = this.allowance;
        data["customerCode"] = this.customerCode;
        data["referenceCode"] = this.referenceCode;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditSalesInvoiceHeaderDto {
    postingDate: moment.Moment | undefined;
    salesInvoiceCode: string | undefined;
    terminalNo: string | undefined;
    totalAmount: number | undefined;
    memberCode: string | undefined;
    point: number | undefined;
    transactionType: string | undefined;
    location: string | undefined;
    allowance: number | undefined;
    customerCode: string | undefined;
    referenceCode: string | undefined;
    id: number | undefined;
}

export class GetAllSalesInvoiceHeadersInput implements IGetAllSalesInvoiceHeadersInput {
    filter!: string | undefined;
    maxPostingDateFilter!: moment.Moment | undefined;
    minPostingDateFilter!: moment.Moment | undefined;
    salesInvoiceCodeFilter!: string | undefined;
    terminalNoFilter!: string | undefined;
    maxTotalAmountFilter!: number | undefined;
    minTotalAmountFilter!: number | undefined;
    memberCodeFilter!: string | undefined;
    maxPointFilter!: number | undefined;
    minPointFilter!: number | undefined;
    transactionTypeFilter!: string | undefined;
    locationFilter!: string | undefined;
    maxAllowanceFilter!: number | undefined;
    minAllowanceFilter!: number | undefined;
    customerCodeFilter!: string | undefined;
    referenceCodeFilter!: string | undefined;
    sorting!: string | undefined;
    skipCount!: number | undefined;
    maxResultCount!: number | undefined;

    constructor(data?: IGetAllSalesInvoiceHeadersInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.filter = data["filter"];
            this.maxPostingDateFilter = data["maxPostingDateFilter"] ? moment(data["maxPostingDateFilter"].toString()) : <any>undefined;
            this.minPostingDateFilter = data["minPostingDateFilter"] ? moment(data["minPostingDateFilter"].toString()) : <any>undefined;
            this.salesInvoiceCodeFilter = data["salesInvoiceCodeFilter"];
            this.terminalNoFilter = data["terminalNoFilter"];
            this.maxTotalAmountFilter = data["maxTotalAmountFilter"];
            this.minTotalAmountFilter = data["minTotalAmountFilter"];
            this.memberCodeFilter = data["memberCodeFilter"];
            this.maxPointFilter = data["maxPointFilter"];
            this.minPointFilter = data["minPointFilter"];
            this.transactionTypeFilter = data["transactionTypeFilter"];
            this.locationFilter = data["locationFilter"];
            this.maxAllowanceFilter = data["maxAllowanceFilter"];
            this.minAllowanceFilter = data["minAllowanceFilter"];
            this.customerCodeFilter = data["customerCodeFilter"];
            this.referenceCodeFilter = data["referenceCodeFilter"];
            this.sorting = data["sorting"];
            this.skipCount = data["skipCount"];
            this.maxResultCount = data["maxResultCount"];
        }
    }

    static fromJS(data: any): GetAllSalesInvoiceHeadersInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllSalesInvoiceHeadersInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        data["maxPostingDateFilter"] = this.maxPostingDateFilter ? this.maxPostingDateFilter.toISOString() : <any>undefined;
        data["minPostingDateFilter"] = this.minPostingDateFilter ? this.minPostingDateFilter.toISOString() : <any>undefined;
        data["salesInvoiceCodeFilter"] = this.salesInvoiceCodeFilter;
        data["terminalNoFilter"] = this.terminalNoFilter;
        data["maxTotalAmountFilter"] = this.maxTotalAmountFilter;
        data["minTotalAmountFilter"] = this.minTotalAmountFilter;
        data["memberCodeFilter"] = this.memberCodeFilter;
        data["maxPointFilter"] = this.maxPointFilter;
        data["minPointFilter"] = this.minPointFilter;
        data["transactionTypeFilter"] = this.transactionTypeFilter;
        data["locationFilter"] = this.locationFilter;
        data["maxAllowanceFilter"] = this.maxAllowanceFilter;
        data["minAllowanceFilter"] = this.minAllowanceFilter;
        data["customerCodeFilter"] = this.customerCodeFilter;
        data["referenceCodeFilter"] = this.referenceCodeFilter;
        data["sorting"] = this.sorting;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data;
    }
}

export interface IGetAllSalesInvoiceHeadersInput {
    filter: string | undefined;
    maxPostingDateFilter: moment.Moment | undefined;
    minPostingDateFilter: moment.Moment | undefined;
    salesInvoiceCodeFilter: string | undefined;
    terminalNoFilter: string | undefined;
    maxTotalAmountFilter: number | undefined;
    minTotalAmountFilter: number | undefined;
    memberCodeFilter: string | undefined;
    maxPointFilter: number | undefined;
    minPointFilter: number | undefined;
    transactionTypeFilter: string | undefined;
    locationFilter: string | undefined;
    maxAllowanceFilter: number | undefined;
    minAllowanceFilter: number | undefined;
    customerCodeFilter: string | undefined;
    referenceCodeFilter: string | undefined;
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;
}

export class GetAllSalesInvoiceDetailsInput implements IGetAllSalesInvoiceDetailsInput {
    filter!: string | undefined;
    maxPostingDateFilter!: moment.Moment | undefined;
    minPostingDateFilter!: moment.Moment | undefined;
    salesInvoiceCodeFilter!: string | undefined;
    terminalNoFilter!: string | undefined;
    maxSeqNoFilter!: number | undefined;
    minSeqNoFilter!: number | undefined;
    memberCodeFilter!: string | undefined;
    deptCodeFilter!: string | undefined;
    divCodeFilter!: string | undefined;
    categoryCodeFilter!: string | undefined;
    itemCodeFilter!: string | undefined;
    brandCodeFilter!: string | undefined;
    maxQuantityFilter!: number | undefined;
    minQuantityFilter!: number | undefined;
    maxSellingpriceFilter!: number | undefined;
    minSellingpriceFilter!: number | undefined;
    maxDiscountFilter!: number | undefined;
    minDiscountFilter!: number | undefined;
    maxAmountFilter!: number | undefined;
    minAmountFilter!: number | undefined;
    customerCodeFilter!: string | undefined;
    sorting!: string | undefined;
    skipCount!: number | undefined;
    maxResultCount!: number | undefined;

    constructor(data?: IGetAllSalesInvoiceDetailsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.filter = data["filter"];
            this.maxPostingDateFilter = data["maxPostingDateFilter"] ? moment(data["maxPostingDateFilter"].toString()) : <any>undefined;
            this.minPostingDateFilter = data["minPostingDateFilter"] ? moment(data["minPostingDateFilter"].toString()) : <any>undefined;
            this.salesInvoiceCodeFilter = data["salesInvoiceCodeFilter"];
            this.terminalNoFilter = data["terminalNoFilter"];
            this.maxSeqNoFilter = data["maxSeqNoFilter"];
            this.minSeqNoFilter = data["minSeqNoFilter"];
            this.memberCodeFilter = data["memberCodeFilter"];
            this.deptCodeFilter = data["deptCodeFilter"];
            this.divCodeFilter = data["divCodeFilter"];
            this.categoryCodeFilter = data["categoryCodeFilter"];
            this.itemCodeFilter = data["itemCodeFilter"];
            this.brandCodeFilter = data["brandCodeFilter"];
            this.maxQuantityFilter = data["maxQuantityFilter"];
            this.minQuantityFilter = data["minQuantityFilter"];
            this.maxSellingpriceFilter = data["maxSellingpriceFilter"];
            this.minSellingpriceFilter = data["minSellingpriceFilter"];
            this.maxDiscountFilter = data["maxDiscountFilter"];
            this.minDiscountFilter = data["minDiscountFilter"];
            this.maxAmountFilter = data["maxAmountFilter"];
            this.minAmountFilter = data["minAmountFilter"];
            this.customerCodeFilter = data["customerCodeFilter"];
            this.sorting = data["sorting"];
            this.skipCount = data["skipCount"];
            this.maxResultCount = data["maxResultCount"];
        }
    }

    static fromJS(data: any): GetAllSalesInvoiceDetailsInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllSalesInvoiceDetailsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        data["maxPostingDateFilter"] = this.maxPostingDateFilter ? this.maxPostingDateFilter.toISOString() : <any>undefined;
        data["minPostingDateFilter"] = this.minPostingDateFilter ? this.minPostingDateFilter.toISOString() : <any>undefined;
        data["salesInvoiceCodeFilter"] = this.salesInvoiceCodeFilter;
        data["terminalNoFilter"] = this.terminalNoFilter;
        data["maxSeqNoFilter"] = this.maxSeqNoFilter;
        data["minSeqNoFilter"] = this.minSeqNoFilter;
        data["memberCodeFilter"] = this.memberCodeFilter;
        data["deptCodeFilter"] = this.deptCodeFilter;
        data["divCodeFilter"] = this.divCodeFilter;
        data["categoryCodeFilter"] = this.categoryCodeFilter;
        data["itemCodeFilter"] = this.itemCodeFilter;
        data["brandCodeFilter"] = this.brandCodeFilter;
        data["maxQuantityFilter"] = this.maxQuantityFilter;
        data["minQuantityFilter"] = this.minQuantityFilter;
        data["maxSellingpriceFilter"] = this.maxSellingpriceFilter;
        data["minSellingpriceFilter"] = this.minSellingpriceFilter;
        data["maxDiscountFilter"] = this.maxDiscountFilter;
        data["minDiscountFilter"] = this.minDiscountFilter;
        data["maxAmountFilter"] = this.maxAmountFilter;
        data["minAmountFilter"] = this.minAmountFilter;
        data["customerCodeFilter"] = this.customerCodeFilter;
        data["sorting"] = this.sorting;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data;
    }
}

export interface IGetAllSalesInvoiceDetailsInput {
    filter: string | undefined;
    maxPostingDateFilter: moment.Moment | undefined;
    minPostingDateFilter: moment.Moment | undefined;
    salesInvoiceCodeFilter: string | undefined;
    terminalNoFilter: string | undefined;
    maxSeqNoFilter: number | undefined;
    minSeqNoFilter: number | undefined;
    memberCodeFilter: string | undefined;
    deptCodeFilter: string | undefined;
    divCodeFilter: string | undefined;
    categoryCodeFilter: string | undefined;
    itemCodeFilter: string | undefined;
    brandCodeFilter: string | undefined;
    maxQuantityFilter: number | undefined;
    minQuantityFilter: number | undefined;
    maxSellingpriceFilter: number | undefined;
    minSellingpriceFilter: number | undefined;
    maxDiscountFilter: number | undefined;
    minDiscountFilter: number | undefined;
    maxAmountFilter: number | undefined;
    minAmountFilter: number | undefined;
    customerCodeFilter: string | undefined;
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;
}

export class PagedResultDtoOfGetSalesmanForViewDto implements IPagedResultDtoOfGetSalesmanForViewDto {
    totalCount!: number | undefined;
    items!: GetSalesmanForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetSalesmanForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetSalesmanForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetSalesmanForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetSalesmanForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetSalesmanForViewDto {
    totalCount: number | undefined;
    items: GetSalesmanForViewDto[] | undefined;
}

export class GetSalesmanForViewDto implements IGetSalesmanForViewDto {
    salesman!: SalesmanDto | undefined;

    constructor(data?: IGetSalesmanForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.salesman = data["salesman"] ? SalesmanDto.fromJS(data["salesman"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSalesmanForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetSalesmanForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["salesman"] = this.salesman ? this.salesman.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetSalesmanForViewDto {
    salesman: SalesmanDto | undefined;
}

export class SalesmanDto implements ISalesmanDto {
    salesmanCode!: string | undefined;
    salesmanName!: string | undefined;
    password!: string | undefined;
    status!: string | undefined;
    masterNameUnSign!: string | undefined;
    phone!: string | undefined;
    email!: string | undefined;
    memberCode!: string | undefined;
    consumerID!: number | undefined;
    managerId!: number | undefined;
    regionCode!: string[] | undefined;
    userId!: number | undefined;
    organizationUnits!: number[] | undefined;
    id!: number | undefined;

    constructor(data?: ISalesmanDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.salesmanCode = data["salesmanCode"];
            this.salesmanName = data["salesmanName"];
            this.password = data["password"];
            this.status = data["status"];
            this.masterNameUnSign = data["masterNameUnSign"];
            this.phone = data["phone"];
            this.email = data["email"];
            this.memberCode = data["memberCode"];
            this.consumerID = data["consumerID"];
            this.managerId = data["managerId"];
            if (data["regionCode"] && data["regionCode"].constructor === Array) {
                this.regionCode = [];
                for (let item of data["regionCode"])
                    this.regionCode.push(item);
            }
            this.userId = data["userId"];
            if (data["organizationUnits"] && data["organizationUnits"].constructor === Array) {
                this.organizationUnits = [];
                for (let item of data["organizationUnits"])
                    this.organizationUnits.push(item);
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SalesmanDto {
        data = typeof data === 'object' ? data : {};
        let result = new SalesmanDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["salesmanCode"] = this.salesmanCode;
        data["salesmanName"] = this.salesmanName;
        data["password"] = this.password;
        data["status"] = this.status;
        data["masterNameUnSign"] = this.masterNameUnSign;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["memberCode"] = this.memberCode;
        data["consumerID"] = this.consumerID;
        data["managerId"] = this.managerId;
        if (this.regionCode && this.regionCode.constructor === Array) {
            data["regionCode"] = [];
            for (let item of this.regionCode)
                data["regionCode"].push(item);
        }
        data["userId"] = this.userId;
        if (this.organizationUnits && this.organizationUnits.constructor === Array) {
            data["organizationUnits"] = [];
            for (let item of this.organizationUnits)
                data["organizationUnits"].push(item);
        }
        data["id"] = this.id;
        return data;
    }
}

export interface ISalesmanDto {
    salesmanCode: string | undefined;
    salesmanName: string | undefined;
    password: string | undefined;
    status: string | undefined;
    masterNameUnSign: string | undefined;
    phone: string | undefined;
    email: string | undefined;
    memberCode: string | undefined;
    consumerID: number | undefined;
    managerId: number | undefined;
    regionCode: string[] | undefined;
    userId: number | undefined;
    organizationUnits: number[] | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfGetAllSalesmanNoFilterDto implements IPagedResultDtoOfGetAllSalesmanNoFilterDto {
    totalCount!: number | undefined;
    items!: GetAllSalesmanNoFilterDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetAllSalesmanNoFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetAllSalesmanNoFilterDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetAllSalesmanNoFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetAllSalesmanNoFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetAllSalesmanNoFilterDto {
    totalCount: number | undefined;
    items: GetAllSalesmanNoFilterDto[] | undefined;
}

export class GetAllSalesmanNoFilterDto implements IGetAllSalesmanNoFilterDto {
    id!: number | undefined;
    salesmanCode!: string | undefined;
    salesmanName!: string | undefined;

    constructor(data?: IGetAllSalesmanNoFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.salesmanCode = data["salesmanCode"];
            this.salesmanName = data["salesmanName"];
        }
    }

    static fromJS(data: any): GetAllSalesmanNoFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllSalesmanNoFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["salesmanCode"] = this.salesmanCode;
        data["salesmanName"] = this.salesmanName;
        return data;
    }
}

export interface IGetAllSalesmanNoFilterDto {
    id: number | undefined;
    salesmanCode: string | undefined;
    salesmanName: string | undefined;
}

export class GetSalesmanForEditOutput implements IGetSalesmanForEditOutput {
    salesman!: CreateOrEditSalesmanDto | undefined;

    constructor(data?: IGetSalesmanForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.salesman = data["salesman"] ? CreateOrEditSalesmanDto.fromJS(data["salesman"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSalesmanForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetSalesmanForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["salesman"] = this.salesman ? this.salesman.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetSalesmanForEditOutput {
    salesman: CreateOrEditSalesmanDto | undefined;
}

export class CreateOrEditSalesmanDto implements ICreateOrEditSalesmanDto {
    salesmanCode!: string | undefined;
    salesmanName!: string | undefined;
    password!: string | undefined;
    status!: string | undefined;
    masterNameUnSign!: string | undefined;
    phone!: string | undefined;
    email!: string | undefined;
    managerId!: number | undefined;
    regionCode!: string[] | undefined;
    organizationUnits!: number[] | undefined;
    userType!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditSalesmanDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.salesmanCode = data["salesmanCode"];
            this.salesmanName = data["salesmanName"];
            this.password = data["password"];
            this.status = data["status"];
            this.masterNameUnSign = data["masterNameUnSign"];
            this.phone = data["phone"];
            this.email = data["email"];
            this.managerId = data["managerId"];
            if (data["regionCode"] && data["regionCode"].constructor === Array) {
                this.regionCode = [];
                for (let item of data["regionCode"])
                    this.regionCode.push(item);
            }
            if (data["organizationUnits"] && data["organizationUnits"].constructor === Array) {
                this.organizationUnits = [];
                for (let item of data["organizationUnits"])
                    this.organizationUnits.push(item);
            }
            this.userType = data["userType"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditSalesmanDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditSalesmanDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["salesmanCode"] = this.salesmanCode;
        data["salesmanName"] = this.salesmanName;
        data["password"] = this.password;
        data["status"] = this.status;
        data["masterNameUnSign"] = this.masterNameUnSign;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["managerId"] = this.managerId;
        if (this.regionCode && this.regionCode.constructor === Array) {
            data["regionCode"] = [];
            for (let item of this.regionCode)
                data["regionCode"].push(item);
        }
        if (this.organizationUnits && this.organizationUnits.constructor === Array) {
            data["organizationUnits"] = [];
            for (let item of this.organizationUnits)
                data["organizationUnits"].push(item);
        }
        data["userType"] = this.userType;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditSalesmanDto {
    salesmanCode: string | undefined;
    salesmanName: string | undefined;
    password: string | undefined;
    status: string | undefined;
    masterNameUnSign: string | undefined;
    phone: string | undefined;
    email: string | undefined;
    managerId: number | undefined;
    regionCode: string[] | undefined;
    organizationUnits: number[] | undefined;
    userType: string | undefined;
    id: number | undefined;
}

export class GetSalesmanForEditExtOutput implements IGetSalesmanForEditExtOutput {
    salesman!: CreateOrEditSalesmanExtDto | undefined;

    constructor(data?: IGetSalesmanForEditExtOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.salesman = data["salesman"] ? CreateOrEditSalesmanExtDto.fromJS(data["salesman"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSalesmanForEditExtOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetSalesmanForEditExtOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["salesman"] = this.salesman ? this.salesman.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetSalesmanForEditExtOutput {
    salesman: CreateOrEditSalesmanExtDto | undefined;
}

export class CreateOrEditSalesmanExtDto implements ICreateOrEditSalesmanExtDto {
    salesmanCode!: string | undefined;
    name!: string | undefined;
    surName!: string | undefined;
    password!: string | undefined;
    status!: string | undefined;
    masterNameUnSign!: string | undefined;
    phone!: string | undefined;
    distributorCode!: string | undefined;
    email!: string | undefined;
    userNameOrEmailAddress!: string;
    userType!: string | undefined;
    organizationUnits!: number[] | undefined;
    managerId!: number | undefined;
    regionCode!: string[] | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditSalesmanExtDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.salesmanCode = data["salesmanCode"];
            this.name = data["name"];
            this.surName = data["surName"];
            this.password = data["password"];
            this.status = data["status"];
            this.masterNameUnSign = data["masterNameUnSign"];
            this.phone = data["phone"];
            this.distributorCode = data["distributorCode"];
            this.email = data["email"];
            this.userNameOrEmailAddress = data["userNameOrEmailAddress"];
            this.userType = data["userType"];
            if (data["organizationUnits"] && data["organizationUnits"].constructor === Array) {
                this.organizationUnits = [];
                for (let item of data["organizationUnits"])
                    this.organizationUnits.push(item);
            }
            this.managerId = data["managerId"];
            if (data["regionCode"] && data["regionCode"].constructor === Array) {
                this.regionCode = [];
                for (let item of data["regionCode"])
                    this.regionCode.push(item);
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditSalesmanExtDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditSalesmanExtDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["salesmanCode"] = this.salesmanCode;
        data["name"] = this.name;
        data["surName"] = this.surName;
        data["password"] = this.password;
        data["status"] = this.status;
        data["masterNameUnSign"] = this.masterNameUnSign;
        data["phone"] = this.phone;
        data["distributorCode"] = this.distributorCode;
        data["email"] = this.email;
        data["userNameOrEmailAddress"] = this.userNameOrEmailAddress;
        data["userType"] = this.userType;
        if (this.organizationUnits && this.organizationUnits.constructor === Array) {
            data["organizationUnits"] = [];
            for (let item of this.organizationUnits)
                data["organizationUnits"].push(item);
        }
        data["managerId"] = this.managerId;
        if (this.regionCode && this.regionCode.constructor === Array) {
            data["regionCode"] = [];
            for (let item of this.regionCode)
                data["regionCode"].push(item);
        }
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditSalesmanExtDto {
    salesmanCode: string | undefined;
    name: string | undefined;
    surName: string | undefined;
    password: string | undefined;
    status: string | undefined;
    masterNameUnSign: string | undefined;
    phone: string | undefined;
    distributorCode: string | undefined;
    email: string | undefined;
    userNameOrEmailAddress: string;
    userType: string | undefined;
    organizationUnits: number[] | undefined;
    managerId: number | undefined;
    regionCode: string[] | undefined;
    id: number | undefined;
}

export class SalesmanImportAgrs implements ISalesmanImportAgrs {
    importSalesmanDtos!: ImportSalesmanDto[] | undefined;
    organizationUnitsToAssginAll!: SalesmanAllOrganizationDto[] | undefined;
    isSuccess!: boolean | undefined;
    errorFilePath!: string | undefined;
    tableName!: string | undefined;
    filePath!: string | undefined;
    fileName!: string | undefined;
    userId!: number | undefined;
    userName!: string | undefined;
    name!: string | undefined;
    tenantId!: number | undefined;
    currentLanguage!: string | undefined;
    apiUrl!: string | undefined;

    constructor(data?: ISalesmanImportAgrs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["importSalesmanDtos"] && data["importSalesmanDtos"].constructor === Array) {
                this.importSalesmanDtos = [];
                for (let item of data["importSalesmanDtos"])
                    this.importSalesmanDtos.push(ImportSalesmanDto.fromJS(item));
            }
            if (data["organizationUnitsToAssginAll"] && data["organizationUnitsToAssginAll"].constructor === Array) {
                this.organizationUnitsToAssginAll = [];
                for (let item of data["organizationUnitsToAssginAll"])
                    this.organizationUnitsToAssginAll.push(SalesmanAllOrganizationDto.fromJS(item));
            }
            this.isSuccess = data["isSuccess"];
            this.errorFilePath = data["errorFilePath"];
            this.tableName = data["tableName"];
            this.filePath = data["filePath"];
            this.fileName = data["fileName"];
            this.userId = data["userId"];
            this.userName = data["userName"];
            this.name = data["name"];
            this.tenantId = data["tenantId"];
            this.currentLanguage = data["currentLanguage"];
            this.apiUrl = data["apiUrl"];
        }
    }

    static fromJS(data: any): SalesmanImportAgrs {
        data = typeof data === 'object' ? data : {};
        let result = new SalesmanImportAgrs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.importSalesmanDtos && this.importSalesmanDtos.constructor === Array) {
            data["importSalesmanDtos"] = [];
            for (let item of this.importSalesmanDtos)
                data["importSalesmanDtos"].push(item.toJSON());
        }
        if (this.organizationUnitsToAssginAll && this.organizationUnitsToAssginAll.constructor === Array) {
            data["organizationUnitsToAssginAll"] = [];
            for (let item of this.organizationUnitsToAssginAll)
                data["organizationUnitsToAssginAll"].push(item.toJSON());
        }
        data["isSuccess"] = this.isSuccess;
        data["errorFilePath"] = this.errorFilePath;
        data["tableName"] = this.tableName;
        data["filePath"] = this.filePath;
        data["fileName"] = this.fileName;
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["name"] = this.name;
        data["tenantId"] = this.tenantId;
        data["currentLanguage"] = this.currentLanguage;
        data["apiUrl"] = this.apiUrl;
        return data;
    }
}

export interface ISalesmanImportAgrs {
    importSalesmanDtos: ImportSalesmanDto[] | undefined;
    organizationUnitsToAssginAll: SalesmanAllOrganizationDto[] | undefined;
    isSuccess: boolean | undefined;
    errorFilePath: string | undefined;
    tableName: string | undefined;
    filePath: string | undefined;
    fileName: string | undefined;
    userId: number | undefined;
    userName: string | undefined;
    name: string | undefined;
    tenantId: number | undefined;
    currentLanguage: string | undefined;
    apiUrl: string | undefined;
}

export class ImportSalesmanDto implements IImportSalesmanDto {
    tenantId!: number | undefined;
    numberOrder!: string | undefined;
    email!: string | undefined;
    salesmanCode!: string | undefined;
    salesmanSurName!: string | undefined;
    salesmanName!: string | undefined;
    password!: string | undefined;
    microsoft365Authentication!: string | undefined;
    organizationUnits!: string | undefined;
    organizationUnitsToAssgin!: number[] | undefined;
    managerEmail!: string | undefined;
    managerId!: number | undefined;
    regions!: string | undefined;
    status!: string | undefined;
    masterNameUnSign!: string | undefined;
    phone!: string | undefined;
    userType!: string | undefined;
    isDeleted!: boolean | undefined;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: moment.Moment | undefined;
    creatorUserId!: number | undefined;
    id!: number | undefined;

    constructor(data?: IImportSalesmanDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.numberOrder = data["numberOrder"];
            this.email = data["email"];
            this.salesmanCode = data["salesmanCode"];
            this.salesmanSurName = data["salesmanSurName"];
            this.salesmanName = data["salesmanName"];
            this.password = data["password"];
            this.microsoft365Authentication = data["microsoft365Authentication"];
            this.organizationUnits = data["organizationUnits"];
            if (data["organizationUnitsToAssgin"] && data["organizationUnitsToAssgin"].constructor === Array) {
                this.organizationUnitsToAssgin = [];
                for (let item of data["organizationUnitsToAssgin"])
                    this.organizationUnitsToAssgin.push(item);
            }
            this.managerEmail = data["managerEmail"];
            this.managerId = data["managerId"];
            this.regions = data["regions"];
            this.status = data["status"];
            this.masterNameUnSign = data["masterNameUnSign"];
            this.phone = data["phone"];
            this.userType = data["userType"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ImportSalesmanDto {
        data = typeof data === 'object' ? data : {};
        let result = new ImportSalesmanDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["numberOrder"] = this.numberOrder;
        data["email"] = this.email;
        data["salesmanCode"] = this.salesmanCode;
        data["salesmanSurName"] = this.salesmanSurName;
        data["salesmanName"] = this.salesmanName;
        data["password"] = this.password;
        data["microsoft365Authentication"] = this.microsoft365Authentication;
        data["organizationUnits"] = this.organizationUnits;
        if (this.organizationUnitsToAssgin && this.organizationUnitsToAssgin.constructor === Array) {
            data["organizationUnitsToAssgin"] = [];
            for (let item of this.organizationUnitsToAssgin)
                data["organizationUnitsToAssgin"].push(item);
        }
        data["managerEmail"] = this.managerEmail;
        data["managerId"] = this.managerId;
        data["regions"] = this.regions;
        data["status"] = this.status;
        data["masterNameUnSign"] = this.masterNameUnSign;
        data["phone"] = this.phone;
        data["userType"] = this.userType;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IImportSalesmanDto {
    tenantId: number | undefined;
    numberOrder: string | undefined;
    email: string | undefined;
    salesmanCode: string | undefined;
    salesmanSurName: string | undefined;
    salesmanName: string | undefined;
    password: string | undefined;
    microsoft365Authentication: string | undefined;
    organizationUnits: string | undefined;
    organizationUnitsToAssgin: number[] | undefined;
    managerEmail: string | undefined;
    managerId: number | undefined;
    regions: string | undefined;
    status: string | undefined;
    masterNameUnSign: string | undefined;
    phone: string | undefined;
    userType: string | undefined;
    isDeleted: boolean | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class SalesmanAllOrganizationDto implements ISalesmanAllOrganizationDto {
    id!: number | undefined;
    code!: string | undefined;

    constructor(data?: ISalesmanAllOrganizationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.code = data["code"];
        }
    }

    static fromJS(data: any): SalesmanAllOrganizationDto {
        data = typeof data === 'object' ? data : {};
        let result = new SalesmanAllOrganizationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        return data;
    }
}

export interface ISalesmanAllOrganizationDto {
    id: number | undefined;
    code: string | undefined;
}

export class SalesmanLoginDto implements ISalesmanLoginDto {
    salesmanCode!: string | undefined;
    password!: string | undefined;
    moduleName!: string | undefined;

    constructor(data?: ISalesmanLoginDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.salesmanCode = data["salesmanCode"];
            this.password = data["password"];
            this.moduleName = data["moduleName"];
        }
    }

    static fromJS(data: any): SalesmanLoginDto {
        data = typeof data === 'object' ? data : {};
        let result = new SalesmanLoginDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["salesmanCode"] = this.salesmanCode;
        data["password"] = this.password;
        data["moduleName"] = this.moduleName;
        return data;
    }
}

export interface ISalesmanLoginDto {
    salesmanCode: string | undefined;
    password: string | undefined;
    moduleName: string | undefined;
}

export class ResultLogin implements IResultLogin {
    salesmanCode!: string | undefined;
    salesmanName!: string | undefined;
    accessToken!: string | undefined;
    expireInSeconds!: number | undefined;
    id!: number | undefined;
    currentDatetime!: moment.Moment | undefined;
    allowDistance!: number | undefined;

    constructor(data?: IResultLogin) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.salesmanCode = data["salesmanCode"];
            this.salesmanName = data["salesmanName"];
            this.accessToken = data["accessToken"];
            this.expireInSeconds = data["expireInSeconds"];
            this.id = data["id"];
            this.currentDatetime = data["currentDatetime"] ? moment(data["currentDatetime"].toString()) : <any>undefined;
            this.allowDistance = data["allowDistance"];
        }
    }

    static fromJS(data: any): ResultLogin {
        data = typeof data === 'object' ? data : {};
        let result = new ResultLogin();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["salesmanCode"] = this.salesmanCode;
        data["salesmanName"] = this.salesmanName;
        data["accessToken"] = this.accessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        data["id"] = this.id;
        data["currentDatetime"] = this.currentDatetime ? this.currentDatetime.toISOString() : <any>undefined;
        data["allowDistance"] = this.allowDistance;
        return data;
    }
}

export interface IResultLogin {
    salesmanCode: string | undefined;
    salesmanName: string | undefined;
    accessToken: string | undefined;
    expireInSeconds: number | undefined;
    id: number | undefined;
    currentDatetime: moment.Moment | undefined;
    allowDistance: number | undefined;
}

export class ChangePasswordSalesmanDto implements IChangePasswordSalesmanDto {
    salesmanCode!: string | undefined;
    newPassword!: string | undefined;
    confirmPassword!: string | undefined;
    oldPassword!: string | undefined;

    constructor(data?: IChangePasswordSalesmanDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.salesmanCode = data["salesmanCode"];
            this.newPassword = data["newPassword"];
            this.confirmPassword = data["confirmPassword"];
            this.oldPassword = data["oldPassword"];
        }
    }

    static fromJS(data: any): ChangePasswordSalesmanDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordSalesmanDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["salesmanCode"] = this.salesmanCode;
        data["newPassword"] = this.newPassword;
        data["confirmPassword"] = this.confirmPassword;
        data["oldPassword"] = this.oldPassword;
        return data;
    }
}

export interface IChangePasswordSalesmanDto {
    salesmanCode: string | undefined;
    newPassword: string | undefined;
    confirmPassword: string | undefined;
    oldPassword: string | undefined;
}

export class ResetPasswordSalesmanDto implements IResetPasswordSalesmanDto {
    memberCode!: string | undefined;
    secretKey!: string | undefined;

    constructor(data?: IResetPasswordSalesmanDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberCode = data["memberCode"];
            this.secretKey = data["secretKey"];
        }
    }

    static fromJS(data: any): ResetPasswordSalesmanDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordSalesmanDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberCode"] = this.memberCode;
        data["secretKey"] = this.secretKey;
        return data;
    }
}

export interface IResetPasswordSalesmanDto {
    memberCode: string | undefined;
    secretKey: string | undefined;
}

export class PagedResultDtoOfGetSalesRegionForView implements IPagedResultDtoOfGetSalesRegionForView {
    totalCount!: number | undefined;
    items!: GetSalesRegionForView[] | undefined;

    constructor(data?: IPagedResultDtoOfGetSalesRegionForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetSalesRegionForView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetSalesRegionForView {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetSalesRegionForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetSalesRegionForView {
    totalCount: number | undefined;
    items: GetSalesRegionForView[] | undefined;
}

export class GetSalesRegionForView implements IGetSalesRegionForView {
    salesRegion!: SalesRegionDto | undefined;

    constructor(data?: IGetSalesRegionForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.salesRegion = data["salesRegion"] ? SalesRegionDto.fromJS(data["salesRegion"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSalesRegionForView {
        data = typeof data === 'object' ? data : {};
        let result = new GetSalesRegionForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["salesRegion"] = this.salesRegion ? this.salesRegion.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetSalesRegionForView {
    salesRegion: SalesRegionDto | undefined;
}

export class SalesRegionDto implements ISalesRegionDto {
    code!: string | undefined;
    name!: string | undefined;
    description!: string | undefined;
    parentCode!: string | undefined;
    isActive!: boolean | undefined;
    level!: number | undefined;
    id!: number | undefined;

    constructor(data?: ISalesRegionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.name = data["name"];
            this.description = data["description"];
            this.parentCode = data["parentCode"];
            this.isActive = data["isActive"];
            this.level = data["level"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SalesRegionDto {
        data = typeof data === 'object' ? data : {};
        let result = new SalesRegionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["description"] = this.description;
        data["parentCode"] = this.parentCode;
        data["isActive"] = this.isActive;
        data["level"] = this.level;
        data["id"] = this.id;
        return data;
    }
}

export interface ISalesRegionDto {
    code: string | undefined;
    name: string | undefined;
    description: string | undefined;
    parentCode: string | undefined;
    isActive: boolean | undefined;
    level: number | undefined;
    id: number | undefined;
}

export class GetSalesRegionForEditOutput implements IGetSalesRegionForEditOutput {
    salesRegion!: CreateOrEditSalesRegionDto | undefined;

    constructor(data?: IGetSalesRegionForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.salesRegion = data["salesRegion"] ? CreateOrEditSalesRegionDto.fromJS(data["salesRegion"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSalesRegionForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetSalesRegionForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["salesRegion"] = this.salesRegion ? this.salesRegion.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetSalesRegionForEditOutput {
    salesRegion: CreateOrEditSalesRegionDto | undefined;
}

export class CreateOrEditSalesRegionDto implements ICreateOrEditSalesRegionDto {
    code!: string;
    name!: string;
    description!: string | undefined;
    parentCode!: string | undefined;
    level!: number | undefined;
    isActive!: boolean | undefined;
    isDeleted!: boolean | undefined;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: moment.Moment | undefined;
    creatorUserId!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditSalesRegionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.name = data["name"];
            this.description = data["description"];
            this.parentCode = data["parentCode"];
            this.level = data["level"];
            this.isActive = data["isActive"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditSalesRegionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditSalesRegionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["description"] = this.description;
        data["parentCode"] = this.parentCode;
        data["level"] = this.level;
        data["isActive"] = this.isActive;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditSalesRegionDto {
    code: string;
    name: string;
    description: string | undefined;
    parentCode: string | undefined;
    level: number | undefined;
    isActive: boolean | undefined;
    isDeleted: boolean | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class SaleSummaryReportDto implements ISaleSummaryReportDto {
    labelColX!: string | undefined;
    totalAmount!: number | undefined;
    cost!: number | undefined;
    totalInvoice!: number | undefined;

    constructor(data?: ISaleSummaryReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.labelColX = data["labelColX"];
            this.totalAmount = data["totalAmount"];
            this.cost = data["cost"];
            this.totalInvoice = data["totalInvoice"];
        }
    }

    static fromJS(data: any): SaleSummaryReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new SaleSummaryReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["labelColX"] = this.labelColX;
        data["totalAmount"] = this.totalAmount;
        data["cost"] = this.cost;
        data["totalInvoice"] = this.totalInvoice;
        return data;
    }
}

export interface ISaleSummaryReportDto {
    labelColX: string | undefined;
    totalAmount: number | undefined;
    cost: number | undefined;
    totalInvoice: number | undefined;
}

export class PagedResultDtoOfGetSalesTargetActualForView implements IPagedResultDtoOfGetSalesTargetActualForView {
    totalCount!: number | undefined;
    items!: GetSalesTargetActualForView[] | undefined;

    constructor(data?: IPagedResultDtoOfGetSalesTargetActualForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetSalesTargetActualForView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetSalesTargetActualForView {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetSalesTargetActualForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetSalesTargetActualForView {
    totalCount: number | undefined;
    items: GetSalesTargetActualForView[] | undefined;
}

export class GetSalesTargetActualForView implements IGetSalesTargetActualForView {
    salesTargetActual!: SalesTargetActualDto | undefined;

    constructor(data?: IGetSalesTargetActualForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.salesTargetActual = data["salesTargetActual"] ? SalesTargetActualDto.fromJS(data["salesTargetActual"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSalesTargetActualForView {
        data = typeof data === 'object' ? data : {};
        let result = new GetSalesTargetActualForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["salesTargetActual"] = this.salesTargetActual ? this.salesTargetActual.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetSalesTargetActualForView {
    salesTargetActual: SalesTargetActualDto | undefined;
}

export class SalesTargetActualDto implements ISalesTargetActualDto {
    targetCode!: string | undefined;
    memberCode!: string | undefined;
    status!: string | undefined;
    targetValue!: number | undefined;
    companyCode!: string | undefined;
    salesOrgCode!: string | undefined;
    targetName!: string | undefined;
    lastModificationTime!: moment.Moment | undefined;
    id!: number | undefined;

    constructor(data?: ISalesTargetActualDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.targetCode = data["targetCode"];
            this.memberCode = data["memberCode"];
            this.status = data["status"];
            this.targetValue = data["targetValue"];
            this.companyCode = data["companyCode"];
            this.salesOrgCode = data["salesOrgCode"];
            this.targetName = data["targetName"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SalesTargetActualDto {
        data = typeof data === 'object' ? data : {};
        let result = new SalesTargetActualDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["targetCode"] = this.targetCode;
        data["memberCode"] = this.memberCode;
        data["status"] = this.status;
        data["targetValue"] = this.targetValue;
        data["companyCode"] = this.companyCode;
        data["salesOrgCode"] = this.salesOrgCode;
        data["targetName"] = this.targetName;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface ISalesTargetActualDto {
    targetCode: string | undefined;
    memberCode: string | undefined;
    status: string | undefined;
    targetValue: number | undefined;
    companyCode: string | undefined;
    salesOrgCode: string | undefined;
    targetName: string | undefined;
    lastModificationTime: moment.Moment | undefined;
    id: number | undefined;
}

export class GetSalesTargetActualForEditOutput implements IGetSalesTargetActualForEditOutput {
    salesTargetActual!: CreateOrEditSalesTargetActualDto | undefined;

    constructor(data?: IGetSalesTargetActualForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.salesTargetActual = data["salesTargetActual"] ? CreateOrEditSalesTargetActualDto.fromJS(data["salesTargetActual"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSalesTargetActualForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetSalesTargetActualForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["salesTargetActual"] = this.salesTargetActual ? this.salesTargetActual.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetSalesTargetActualForEditOutput {
    salesTargetActual: CreateOrEditSalesTargetActualDto | undefined;
}

export class CreateOrEditSalesTargetActualDto implements ICreateOrEditSalesTargetActualDto {
    targetCode!: string | undefined;
    memberCode!: string | undefined;
    status!: string | undefined;
    targetValue!: number | undefined;
    companyCode!: string | undefined;
    salesOrgCode!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditSalesTargetActualDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.targetCode = data["targetCode"];
            this.memberCode = data["memberCode"];
            this.status = data["status"];
            this.targetValue = data["targetValue"];
            this.companyCode = data["companyCode"];
            this.salesOrgCode = data["salesOrgCode"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditSalesTargetActualDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditSalesTargetActualDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["targetCode"] = this.targetCode;
        data["memberCode"] = this.memberCode;
        data["status"] = this.status;
        data["targetValue"] = this.targetValue;
        data["companyCode"] = this.companyCode;
        data["salesOrgCode"] = this.salesOrgCode;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditSalesTargetActualDto {
    targetCode: string | undefined;
    memberCode: string | undefined;
    status: string | undefined;
    targetValue: number | undefined;
    companyCode: string | undefined;
    salesOrgCode: string | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfGetSalesTargetHeaderForView implements IPagedResultDtoOfGetSalesTargetHeaderForView {
    totalCount!: number | undefined;
    items!: GetSalesTargetHeaderForView[] | undefined;

    constructor(data?: IPagedResultDtoOfGetSalesTargetHeaderForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetSalesTargetHeaderForView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetSalesTargetHeaderForView {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetSalesTargetHeaderForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetSalesTargetHeaderForView {
    totalCount: number | undefined;
    items: GetSalesTargetHeaderForView[] | undefined;
}

export class GetSalesTargetHeaderForView implements IGetSalesTargetHeaderForView {
    salesTargetHeader!: SalesTargetHeaderDto | undefined;

    constructor(data?: IGetSalesTargetHeaderForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.salesTargetHeader = data["salesTargetHeader"] ? SalesTargetHeaderDto.fromJS(data["salesTargetHeader"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSalesTargetHeaderForView {
        data = typeof data === 'object' ? data : {};
        let result = new GetSalesTargetHeaderForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["salesTargetHeader"] = this.salesTargetHeader ? this.salesTargetHeader.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetSalesTargetHeaderForView {
    salesTargetHeader: SalesTargetHeaderDto | undefined;
}

export class SalesTargetHeaderDto implements ISalesTargetHeaderDto {
    targetCode!: string | undefined;
    targetName!: string | undefined;
    parentCode!: string | undefined;
    status!: string | undefined;
    startDate!: moment.Moment | undefined;
    endDate!: moment.Moment | undefined;
    description!: string | undefined;
    ordinal!: number | undefined;
    targetType!: string | undefined;
    lastModificationTime!: moment.Moment | undefined;
    id!: number | undefined;

    constructor(data?: ISalesTargetHeaderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.targetCode = data["targetCode"];
            this.targetName = data["targetName"];
            this.parentCode = data["parentCode"];
            this.status = data["status"];
            this.startDate = data["startDate"] ? moment(data["startDate"].toString()) : <any>undefined;
            this.endDate = data["endDate"] ? moment(data["endDate"].toString()) : <any>undefined;
            this.description = data["description"];
            this.ordinal = data["ordinal"];
            this.targetType = data["targetType"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SalesTargetHeaderDto {
        data = typeof data === 'object' ? data : {};
        let result = new SalesTargetHeaderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["targetCode"] = this.targetCode;
        data["targetName"] = this.targetName;
        data["parentCode"] = this.parentCode;
        data["status"] = this.status;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["description"] = this.description;
        data["ordinal"] = this.ordinal;
        data["targetType"] = this.targetType;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface ISalesTargetHeaderDto {
    targetCode: string | undefined;
    targetName: string | undefined;
    parentCode: string | undefined;
    status: string | undefined;
    startDate: moment.Moment | undefined;
    endDate: moment.Moment | undefined;
    description: string | undefined;
    ordinal: number | undefined;
    targetType: string | undefined;
    lastModificationTime: moment.Moment | undefined;
    id: number | undefined;
}

export class GetSalesTargetHeaderForEditOutput implements IGetSalesTargetHeaderForEditOutput {
    salesTargetHeader!: CreateOrEditSalesTargetHeaderDto | undefined;

    constructor(data?: IGetSalesTargetHeaderForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.salesTargetHeader = data["salesTargetHeader"] ? CreateOrEditSalesTargetHeaderDto.fromJS(data["salesTargetHeader"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSalesTargetHeaderForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetSalesTargetHeaderForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["salesTargetHeader"] = this.salesTargetHeader ? this.salesTargetHeader.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetSalesTargetHeaderForEditOutput {
    salesTargetHeader: CreateOrEditSalesTargetHeaderDto | undefined;
}

export class CreateOrEditSalesTargetHeaderDto implements ICreateOrEditSalesTargetHeaderDto {
    targetCode!: string | undefined;
    targetName!: string | undefined;
    parentCode!: string | undefined;
    status!: string | undefined;
    startDate!: moment.Moment | undefined;
    endDate!: moment.Moment | undefined;
    description!: string | undefined;
    ordinal!: number | undefined;
    targetType!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditSalesTargetHeaderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.targetCode = data["targetCode"];
            this.targetName = data["targetName"];
            this.parentCode = data["parentCode"];
            this.status = data["status"];
            this.startDate = data["startDate"] ? moment(data["startDate"].toString()) : <any>undefined;
            this.endDate = data["endDate"] ? moment(data["endDate"].toString()) : <any>undefined;
            this.description = data["description"];
            this.ordinal = data["ordinal"];
            this.targetType = data["targetType"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditSalesTargetHeaderDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditSalesTargetHeaderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["targetCode"] = this.targetCode;
        data["targetName"] = this.targetName;
        data["parentCode"] = this.parentCode;
        data["status"] = this.status;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["description"] = this.description;
        data["ordinal"] = this.ordinal;
        data["targetType"] = this.targetType;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditSalesTargetHeaderDto {
    targetCode: string | undefined;
    targetName: string | undefined;
    parentCode: string | undefined;
    status: string | undefined;
    startDate: moment.Moment | undefined;
    endDate: moment.Moment | undefined;
    description: string | undefined;
    ordinal: number | undefined;
    targetType: string | undefined;
    id: number | undefined;
}

export class SAPProductResponse implements ISAPProductResponse {
    serial!: string | undefined;
    itemCode!: string | undefined;
    name!: string | undefined;
    id!: number | undefined;

    constructor(data?: ISAPProductResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.serial = data["serial"];
            this.itemCode = data["itemCode"];
            this.name = data["name"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SAPProductResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SAPProductResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serial"] = this.serial;
        data["itemCode"] = this.itemCode;
        data["name"] = this.name;
        data["id"] = this.id;
        return data;
    }
}

export interface ISAPProductResponse {
    serial: string | undefined;
    itemCode: string | undefined;
    name: string | undefined;
    id: number | undefined;
}

export class CreateOrEditSAPSerialInput implements ICreateOrEditSAPSerialInput {
    productId!: number | undefined;
    serial!: string | undefined;
    itemCode!: string | undefined;
    description!: string | undefined;
    regionLevel1!: string | undefined;
    year!: number | undefined;
    month!: number | undefined;
    createDate!: moment.Moment | undefined;
    source!: number | undefined;
    isSellInStatus!: string | undefined;
    dateSellIn!: moment.Moment | undefined;
    isSellOutStatus!: string | undefined;
    dateSellOut!: moment.Moment | undefined;
    isMT!: boolean | undefined;
    classify!: CreateOrEditSAPSerialInputClassify | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditSAPSerialInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.productId = data["productId"];
            this.serial = data["serial"];
            this.itemCode = data["itemCode"];
            this.description = data["description"];
            this.regionLevel1 = data["regionLevel1"];
            this.year = data["year"];
            this.month = data["month"];
            this.createDate = data["createDate"] ? moment(data["createDate"].toString()) : <any>undefined;
            this.source = data["source"];
            this.isSellInStatus = data["isSellInStatus"];
            this.dateSellIn = data["dateSellIn"] ? moment(data["dateSellIn"].toString()) : <any>undefined;
            this.isSellOutStatus = data["isSellOutStatus"];
            this.dateSellOut = data["dateSellOut"] ? moment(data["dateSellOut"].toString()) : <any>undefined;
            this.isMT = data["isMT"];
            this.classify = data["classify"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditSAPSerialInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditSAPSerialInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["serial"] = this.serial;
        data["itemCode"] = this.itemCode;
        data["description"] = this.description;
        data["regionLevel1"] = this.regionLevel1;
        data["year"] = this.year;
        data["month"] = this.month;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : <any>undefined;
        data["source"] = this.source;
        data["isSellInStatus"] = this.isSellInStatus;
        data["dateSellIn"] = this.dateSellIn ? this.dateSellIn.toISOString() : <any>undefined;
        data["isSellOutStatus"] = this.isSellOutStatus;
        data["dateSellOut"] = this.dateSellOut ? this.dateSellOut.toISOString() : <any>undefined;
        data["isMT"] = this.isMT;
        data["classify"] = this.classify;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditSAPSerialInput {
    productId: number | undefined;
    serial: string | undefined;
    itemCode: string | undefined;
    description: string | undefined;
    regionLevel1: string | undefined;
    year: number | undefined;
    month: number | undefined;
    createDate: moment.Moment | undefined;
    source: number | undefined;
    isSellInStatus: string | undefined;
    dateSellIn: moment.Moment | undefined;
    isSellOutStatus: string | undefined;
    dateSellOut: moment.Moment | undefined;
    isMT: boolean | undefined;
    classify: CreateOrEditSAPSerialInputClassify | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfGetSAPSerialForViewDto implements IPagedResultDtoOfGetSAPSerialForViewDto {
    totalCount!: number | undefined;
    items!: GetSAPSerialForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetSAPSerialForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetSAPSerialForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetSAPSerialForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetSAPSerialForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetSAPSerialForViewDto {
    totalCount: number | undefined;
    items: GetSAPSerialForViewDto[] | undefined;
}

export class GetSAPSerialForViewDto implements IGetSAPSerialForViewDto {
    sapSerial!: GetListSAPSerialResponse | undefined;

    constructor(data?: IGetSAPSerialForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.sapSerial = data["sapSerial"] ? GetListSAPSerialResponse.fromJS(data["sapSerial"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSAPSerialForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetSAPSerialForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sapSerial"] = this.sapSerial ? this.sapSerial.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetSAPSerialForViewDto {
    sapSerial: GetListSAPSerialResponse | undefined;
}

export class GetListSAPSerialResponse implements IGetListSAPSerialResponse {
    productId!: number | undefined;
    serial!: string | undefined;
    itemCode!: string | undefined;
    description!: string | undefined;
    regionLevel1!: string | undefined;
    deptName!: string | undefined;
    year!: number | undefined;
    month!: number | undefined;
    createDate!: moment.Moment | undefined;
    source!: number | undefined;
    isSellInStatus!: string | undefined;
    dateSellIn!: moment.Moment | undefined;
    isSellOutStatus!: string | undefined;
    dateSellOut!: moment.Moment | undefined;
    isMT!: boolean | undefined;
    classify!: GetListSAPSerialResponseClassify | undefined;
    isDisSellThru!: boolean | undefined;
    isVSSellThru!: boolean | undefined;
    cLassifyDisplay!: string | undefined;
    isDeleted!: boolean | undefined;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: moment.Moment | undefined;
    creatorUserId!: number | undefined;
    id!: number | undefined;

    constructor(data?: IGetListSAPSerialResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.productId = data["productId"];
            this.serial = data["serial"];
            this.itemCode = data["itemCode"];
            this.description = data["description"];
            this.regionLevel1 = data["regionLevel1"];
            this.deptName = data["deptName"];
            this.year = data["year"];
            this.month = data["month"];
            this.createDate = data["createDate"] ? moment(data["createDate"].toString()) : <any>undefined;
            this.source = data["source"];
            this.isSellInStatus = data["isSellInStatus"];
            this.dateSellIn = data["dateSellIn"] ? moment(data["dateSellIn"].toString()) : <any>undefined;
            this.isSellOutStatus = data["isSellOutStatus"];
            this.dateSellOut = data["dateSellOut"] ? moment(data["dateSellOut"].toString()) : <any>undefined;
            this.isMT = data["isMT"];
            this.classify = data["classify"];
            this.isDisSellThru = data["isDisSellThru"];
            this.isVSSellThru = data["isVSSellThru"];
            this.cLassifyDisplay = data["cLassifyDisplay"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): GetListSAPSerialResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetListSAPSerialResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["serial"] = this.serial;
        data["itemCode"] = this.itemCode;
        data["description"] = this.description;
        data["regionLevel1"] = this.regionLevel1;
        data["deptName"] = this.deptName;
        data["year"] = this.year;
        data["month"] = this.month;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : <any>undefined;
        data["source"] = this.source;
        data["isSellInStatus"] = this.isSellInStatus;
        data["dateSellIn"] = this.dateSellIn ? this.dateSellIn.toISOString() : <any>undefined;
        data["isSellOutStatus"] = this.isSellOutStatus;
        data["dateSellOut"] = this.dateSellOut ? this.dateSellOut.toISOString() : <any>undefined;
        data["isMT"] = this.isMT;
        data["classify"] = this.classify;
        data["isDisSellThru"] = this.isDisSellThru;
        data["isVSSellThru"] = this.isVSSellThru;
        data["cLassifyDisplay"] = this.cLassifyDisplay;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IGetListSAPSerialResponse {
    productId: number | undefined;
    serial: string | undefined;
    itemCode: string | undefined;
    description: string | undefined;
    regionLevel1: string | undefined;
    deptName: string | undefined;
    year: number | undefined;
    month: number | undefined;
    createDate: moment.Moment | undefined;
    source: number | undefined;
    isSellInStatus: string | undefined;
    dateSellIn: moment.Moment | undefined;
    isSellOutStatus: string | undefined;
    dateSellOut: moment.Moment | undefined;
    isMT: boolean | undefined;
    classify: GetListSAPSerialResponseClassify | undefined;
    isDisSellThru: boolean | undefined;
    isVSSellThru: boolean | undefined;
    cLassifyDisplay: string | undefined;
    isDeleted: boolean | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class GetCheckSerialForViewDto implements IGetCheckSerialForViewDto {
    itemCode!: string | undefined;
    productCode!: string | undefined;
    memberCode!: string | undefined;
    productName!: string | undefined;
    serial!: string | undefined;
    regionLevel1!: string | undefined;
    point!: number | undefined;
    description!: string | undefined;
    message!: string | undefined;
    status!: boolean | undefined;
    wrongRegion!: boolean | undefined;
    isNeedActivecode!: number | undefined;

    constructor(data?: IGetCheckSerialForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.itemCode = data["itemCode"];
            this.productCode = data["productCode"];
            this.memberCode = data["memberCode"];
            this.productName = data["productName"];
            this.serial = data["serial"];
            this.regionLevel1 = data["regionLevel1"];
            this.point = data["point"];
            this.description = data["description"];
            this.message = data["message"];
            this.status = data["status"];
            this.wrongRegion = data["wrongRegion"];
            this.isNeedActivecode = data["isNeedActivecode"];
        }
    }

    static fromJS(data: any): GetCheckSerialForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCheckSerialForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itemCode"] = this.itemCode;
        data["productCode"] = this.productCode;
        data["memberCode"] = this.memberCode;
        data["productName"] = this.productName;
        data["serial"] = this.serial;
        data["regionLevel1"] = this.regionLevel1;
        data["point"] = this.point;
        data["description"] = this.description;
        data["message"] = this.message;
        data["status"] = this.status;
        data["wrongRegion"] = this.wrongRegion;
        data["isNeedActivecode"] = this.isNeedActivecode;
        return data;
    }
}

export interface IGetCheckSerialForViewDto {
    itemCode: string | undefined;
    productCode: string | undefined;
    memberCode: string | undefined;
    productName: string | undefined;
    serial: string | undefined;
    regionLevel1: string | undefined;
    point: number | undefined;
    description: string | undefined;
    message: string | undefined;
    status: boolean | undefined;
    wrongRegion: boolean | undefined;
    isNeedActivecode: number | undefined;
}

export class GetSAPSerialInput implements IGetSAPSerialInput {
    productId!: number | undefined;
    serial!: string | undefined;
    itemCode!: string | undefined;
    description!: string | undefined;
    regionLevel1!: string | undefined;
    deptCode!: string | undefined;
    year!: number | undefined;
    month!: number | undefined;
    createDate!: moment.Moment | undefined;
    source!: number | undefined;
    isSellInStatus!: string | undefined;
    dateSellIn!: moment.Moment | undefined;
    isSellOutStatus!: string | undefined;
    dateSellOut!: moment.Moment | undefined;
    isMT!: boolean | undefined;
    classify!: GetSAPSerialInputClassify | undefined;
    sorting!: string | undefined;
    skipCount!: number | undefined;
    maxResultCount!: number | undefined;

    constructor(data?: IGetSAPSerialInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.productId = data["productId"];
            this.serial = data["serial"];
            this.itemCode = data["itemCode"];
            this.description = data["description"];
            this.regionLevel1 = data["regionLevel1"];
            this.deptCode = data["deptCode"];
            this.year = data["year"];
            this.month = data["month"];
            this.createDate = data["createDate"] ? moment(data["createDate"].toString()) : <any>undefined;
            this.source = data["source"];
            this.isSellInStatus = data["isSellInStatus"];
            this.dateSellIn = data["dateSellIn"] ? moment(data["dateSellIn"].toString()) : <any>undefined;
            this.isSellOutStatus = data["isSellOutStatus"];
            this.dateSellOut = data["dateSellOut"] ? moment(data["dateSellOut"].toString()) : <any>undefined;
            this.isMT = data["isMT"];
            this.classify = data["classify"];
            this.sorting = data["sorting"];
            this.skipCount = data["skipCount"];
            this.maxResultCount = data["maxResultCount"];
        }
    }

    static fromJS(data: any): GetSAPSerialInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetSAPSerialInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["serial"] = this.serial;
        data["itemCode"] = this.itemCode;
        data["description"] = this.description;
        data["regionLevel1"] = this.regionLevel1;
        data["deptCode"] = this.deptCode;
        data["year"] = this.year;
        data["month"] = this.month;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : <any>undefined;
        data["source"] = this.source;
        data["isSellInStatus"] = this.isSellInStatus;
        data["dateSellIn"] = this.dateSellIn ? this.dateSellIn.toISOString() : <any>undefined;
        data["isSellOutStatus"] = this.isSellOutStatus;
        data["dateSellOut"] = this.dateSellOut ? this.dateSellOut.toISOString() : <any>undefined;
        data["isMT"] = this.isMT;
        data["classify"] = this.classify;
        data["sorting"] = this.sorting;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data;
    }
}

export interface IGetSAPSerialInput {
    productId: number | undefined;
    serial: string | undefined;
    itemCode: string | undefined;
    description: string | undefined;
    regionLevel1: string | undefined;
    deptCode: string | undefined;
    year: number | undefined;
    month: number | undefined;
    createDate: moment.Moment | undefined;
    source: number | undefined;
    isSellInStatus: string | undefined;
    dateSellIn: moment.Moment | undefined;
    isSellOutStatus: string | undefined;
    dateSellOut: moment.Moment | undefined;
    isMT: boolean | undefined;
    classify: GetSAPSerialInputClassify | undefined;
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;
}

export class CreateOrEditSecondaryCustomerDto implements ICreateOrEditSecondaryCustomerDto {
    memberCode!: string;
    firstName!: string | undefined;
    lastName!: string | undefined;
    birthday!: moment.Moment | undefined;
    phone!: string | undefined;
    email!: string | undefined;
    regionCode!: string | undefined;
    memberTypeCode!: string | undefined;
    channelType!: string | undefined;
    rankTypeCode!: string | undefined;
    address!: string | undefined;
    gender!: string | undefined;
    cards!: string | undefined;
    isActive!: boolean | undefined;
    fullRegionCode!: string | undefined;
    fullMemberTypeCode!: string | undefined;
    fullChannelTypeCode!: string | undefined;
    idCard!: string | undefined;
    memberLoyaltyInfoId!: number | undefined;
    curentRank!: string | undefined;
    currentPoint!: number | undefined;
    currentCoin!: number | undefined;
    rankValidTo!: moment.Moment | undefined;
    expiringCoin!: number | undefined;
    standardMemberCode!: string | undefined;
    accountType!: string | undefined;
    joiningDate!: moment.Moment | undefined;
    withdrawnDate!: moment.Moment | undefined;
    status!: string | undefined;
    referenceInfo!: string | undefined;
    rankType!: string | undefined;
    contractCode!: string | undefined;
    source!: string | undefined;
    pointToNextTempRank!: number | undefined;
    regionCustom!: RegionCustomDto | undefined;
    isDeleted!: boolean | undefined;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: moment.Moment | undefined;
    creatorUserId!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditSecondaryCustomerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberCode = data["memberCode"];
            this.firstName = data["firstName"];
            this.lastName = data["lastName"];
            this.birthday = data["birthday"] ? moment(data["birthday"].toString()) : <any>undefined;
            this.phone = data["phone"];
            this.email = data["email"];
            this.regionCode = data["regionCode"];
            this.memberTypeCode = data["memberTypeCode"];
            this.channelType = data["channelType"];
            this.rankTypeCode = data["rankTypeCode"];
            this.address = data["address"];
            this.gender = data["gender"];
            this.cards = data["cards"];
            this.isActive = data["isActive"];
            this.fullRegionCode = data["fullRegionCode"];
            this.fullMemberTypeCode = data["fullMemberTypeCode"];
            this.fullChannelTypeCode = data["fullChannelTypeCode"];
            this.idCard = data["idCard"];
            this.memberLoyaltyInfoId = data["memberLoyaltyInfoId"];
            this.curentRank = data["curentRank"];
            this.currentPoint = data["currentPoint"];
            this.currentCoin = data["currentCoin"];
            this.rankValidTo = data["rankValidTo"] ? moment(data["rankValidTo"].toString()) : <any>undefined;
            this.expiringCoin = data["expiringCoin"];
            this.standardMemberCode = data["standardMemberCode"];
            this.accountType = data["accountType"];
            this.joiningDate = data["joiningDate"] ? moment(data["joiningDate"].toString()) : <any>undefined;
            this.withdrawnDate = data["withdrawnDate"] ? moment(data["withdrawnDate"].toString()) : <any>undefined;
            this.status = data["status"];
            this.referenceInfo = data["referenceInfo"];
            this.rankType = data["rankType"];
            this.contractCode = data["contractCode"];
            this.source = data["source"];
            this.pointToNextTempRank = data["pointToNextTempRank"];
            this.regionCustom = data["regionCustom"] ? RegionCustomDto.fromJS(data["regionCustom"]) : <any>undefined;
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditSecondaryCustomerDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditSecondaryCustomerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberCode"] = this.memberCode;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["birthday"] = this.birthday ? this.birthday.toISOString() : <any>undefined;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["regionCode"] = this.regionCode;
        data["memberTypeCode"] = this.memberTypeCode;
        data["channelType"] = this.channelType;
        data["rankTypeCode"] = this.rankTypeCode;
        data["address"] = this.address;
        data["gender"] = this.gender;
        data["cards"] = this.cards;
        data["isActive"] = this.isActive;
        data["fullRegionCode"] = this.fullRegionCode;
        data["fullMemberTypeCode"] = this.fullMemberTypeCode;
        data["fullChannelTypeCode"] = this.fullChannelTypeCode;
        data["idCard"] = this.idCard;
        data["memberLoyaltyInfoId"] = this.memberLoyaltyInfoId;
        data["curentRank"] = this.curentRank;
        data["currentPoint"] = this.currentPoint;
        data["currentCoin"] = this.currentCoin;
        data["rankValidTo"] = this.rankValidTo ? this.rankValidTo.toISOString() : <any>undefined;
        data["expiringCoin"] = this.expiringCoin;
        data["standardMemberCode"] = this.standardMemberCode;
        data["accountType"] = this.accountType;
        data["joiningDate"] = this.joiningDate ? this.joiningDate.toISOString() : <any>undefined;
        data["withdrawnDate"] = this.withdrawnDate ? this.withdrawnDate.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["referenceInfo"] = this.referenceInfo;
        data["rankType"] = this.rankType;
        data["contractCode"] = this.contractCode;
        data["source"] = this.source;
        data["pointToNextTempRank"] = this.pointToNextTempRank;
        data["regionCustom"] = this.regionCustom ? this.regionCustom.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditSecondaryCustomerDto {
    memberCode: string;
    firstName: string | undefined;
    lastName: string | undefined;
    birthday: moment.Moment | undefined;
    phone: string | undefined;
    email: string | undefined;
    regionCode: string | undefined;
    memberTypeCode: string | undefined;
    channelType: string | undefined;
    rankTypeCode: string | undefined;
    address: string | undefined;
    gender: string | undefined;
    cards: string | undefined;
    isActive: boolean | undefined;
    fullRegionCode: string | undefined;
    fullMemberTypeCode: string | undefined;
    fullChannelTypeCode: string | undefined;
    idCard: string | undefined;
    memberLoyaltyInfoId: number | undefined;
    curentRank: string | undefined;
    currentPoint: number | undefined;
    currentCoin: number | undefined;
    rankValidTo: moment.Moment | undefined;
    expiringCoin: number | undefined;
    standardMemberCode: string | undefined;
    accountType: string | undefined;
    joiningDate: moment.Moment | undefined;
    withdrawnDate: moment.Moment | undefined;
    status: string | undefined;
    referenceInfo: string | undefined;
    rankType: string | undefined;
    contractCode: string | undefined;
    source: string | undefined;
    pointToNextTempRank: number | undefined;
    regionCustom: RegionCustomDto | undefined;
    isDeleted: boolean | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class RegionCustomDto implements IRegionCustomDto {
    country!: string | undefined;
    province!: string | undefined;
    district!: string | undefined;
    ward!: string | undefined;

    constructor(data?: IRegionCustomDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.country = data["country"];
            this.province = data["province"];
            this.district = data["district"];
            this.ward = data["ward"];
        }
    }

    static fromJS(data: any): RegionCustomDto {
        data = typeof data === 'object' ? data : {};
        let result = new RegionCustomDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["country"] = this.country;
        data["province"] = this.province;
        data["district"] = this.district;
        data["ward"] = this.ward;
        return data;
    }
}

export interface IRegionCustomDto {
    country: string | undefined;
    province: string | undefined;
    district: string | undefined;
    ward: string | undefined;
}

export class PagedResultDtoOfSecondaryCustomerInfoLookupTableDto implements IPagedResultDtoOfSecondaryCustomerInfoLookupTableDto {
    totalCount!: number | undefined;
    items!: SecondaryCustomerInfoLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfSecondaryCustomerInfoLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(SecondaryCustomerInfoLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfSecondaryCustomerInfoLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfSecondaryCustomerInfoLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfSecondaryCustomerInfoLookupTableDto {
    totalCount: number | undefined;
    items: SecondaryCustomerInfoLookupTableDto[] | undefined;
}

export class SecondaryCustomerInfoLookupTableDto implements ISecondaryCustomerInfoLookupTableDto {
    id!: number | undefined;
    displayName!: string | undefined;

    constructor(data?: ISecondaryCustomerInfoLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): SecondaryCustomerInfoLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new SecondaryCustomerInfoLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface ISecondaryCustomerInfoLookupTableDto {
    id: number | undefined;
    displayName: string | undefined;
}

export class SecondaryCustomerDto implements ISecondaryCustomerDto {
    memberCode!: string | undefined;
    firstName!: string | undefined;
    lastName!: string | undefined;
    birthday!: moment.Moment | undefined;
    phone!: string | undefined;
    email!: string | undefined;
    regionCode!: string | undefined;
    memberTypeCode!: string | undefined;
    channelType!: string | undefined;
    rankTypeCode!: string | undefined;
    address!: string | undefined;
    gender!: string | undefined;
    cards!: string | undefined;
    isActive!: boolean | undefined;
    status!: string | undefined;
    fullRegionCode!: string | undefined;
    fullMemberTypeCode!: string | undefined;
    fullChannelTypeCode!: string | undefined;
    idCard!: string | undefined;
    memberLoyaltyInfoId!: number | undefined;
    standardMemberCode!: string | undefined;
    accountType!: string | undefined;
    joiningDate!: moment.Moment | undefined;
    withdrawnDate!: moment.Moment | undefined;
    referenceInfo!: string | undefined;
    source!: string | undefined;
    extraInfo!: string | undefined;
    contractCode!: string | undefined;
    memberLoyaltyInfo!: SecondaryCustomerInfoDto | undefined;
    id!: number | undefined;

    constructor(data?: ISecondaryCustomerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberCode = data["memberCode"];
            this.firstName = data["firstName"];
            this.lastName = data["lastName"];
            this.birthday = data["birthday"] ? moment(data["birthday"].toString()) : <any>undefined;
            this.phone = data["phone"];
            this.email = data["email"];
            this.regionCode = data["regionCode"];
            this.memberTypeCode = data["memberTypeCode"];
            this.channelType = data["channelType"];
            this.rankTypeCode = data["rankTypeCode"];
            this.address = data["address"];
            this.gender = data["gender"];
            this.cards = data["cards"];
            this.isActive = data["isActive"];
            this.status = data["status"];
            this.fullRegionCode = data["fullRegionCode"];
            this.fullMemberTypeCode = data["fullMemberTypeCode"];
            this.fullChannelTypeCode = data["fullChannelTypeCode"];
            this.idCard = data["idCard"];
            this.memberLoyaltyInfoId = data["memberLoyaltyInfoId"];
            this.standardMemberCode = data["standardMemberCode"];
            this.accountType = data["accountType"];
            this.joiningDate = data["joiningDate"] ? moment(data["joiningDate"].toString()) : <any>undefined;
            this.withdrawnDate = data["withdrawnDate"] ? moment(data["withdrawnDate"].toString()) : <any>undefined;
            this.referenceInfo = data["referenceInfo"];
            this.source = data["source"];
            this.extraInfo = data["extraInfo"];
            this.contractCode = data["contractCode"];
            this.memberLoyaltyInfo = data["memberLoyaltyInfo"] ? SecondaryCustomerInfoDto.fromJS(data["memberLoyaltyInfo"]) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SecondaryCustomerDto {
        data = typeof data === 'object' ? data : {};
        let result = new SecondaryCustomerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberCode"] = this.memberCode;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["birthday"] = this.birthday ? this.birthday.toISOString() : <any>undefined;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["regionCode"] = this.regionCode;
        data["memberTypeCode"] = this.memberTypeCode;
        data["channelType"] = this.channelType;
        data["rankTypeCode"] = this.rankTypeCode;
        data["address"] = this.address;
        data["gender"] = this.gender;
        data["cards"] = this.cards;
        data["isActive"] = this.isActive;
        data["status"] = this.status;
        data["fullRegionCode"] = this.fullRegionCode;
        data["fullMemberTypeCode"] = this.fullMemberTypeCode;
        data["fullChannelTypeCode"] = this.fullChannelTypeCode;
        data["idCard"] = this.idCard;
        data["memberLoyaltyInfoId"] = this.memberLoyaltyInfoId;
        data["standardMemberCode"] = this.standardMemberCode;
        data["accountType"] = this.accountType;
        data["joiningDate"] = this.joiningDate ? this.joiningDate.toISOString() : <any>undefined;
        data["withdrawnDate"] = this.withdrawnDate ? this.withdrawnDate.toISOString() : <any>undefined;
        data["referenceInfo"] = this.referenceInfo;
        data["source"] = this.source;
        data["extraInfo"] = this.extraInfo;
        data["contractCode"] = this.contractCode;
        data["memberLoyaltyInfo"] = this.memberLoyaltyInfo ? this.memberLoyaltyInfo.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface ISecondaryCustomerDto {
    memberCode: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    birthday: moment.Moment | undefined;
    phone: string | undefined;
    email: string | undefined;
    regionCode: string | undefined;
    memberTypeCode: string | undefined;
    channelType: string | undefined;
    rankTypeCode: string | undefined;
    address: string | undefined;
    gender: string | undefined;
    cards: string | undefined;
    isActive: boolean | undefined;
    status: string | undefined;
    fullRegionCode: string | undefined;
    fullMemberTypeCode: string | undefined;
    fullChannelTypeCode: string | undefined;
    idCard: string | undefined;
    memberLoyaltyInfoId: number | undefined;
    standardMemberCode: string | undefined;
    accountType: string | undefined;
    joiningDate: moment.Moment | undefined;
    withdrawnDate: moment.Moment | undefined;
    referenceInfo: string | undefined;
    source: string | undefined;
    extraInfo: string | undefined;
    contractCode: string | undefined;
    memberLoyaltyInfo: SecondaryCustomerInfoDto | undefined;
    id: number | undefined;
}

export class RankAdjustmentDto implements IRankAdjustmentDto {
    memberCode!: string | undefined;
    rankId!: number | undefined;

    constructor(data?: IRankAdjustmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberCode = data["memberCode"];
            this.rankId = data["rankId"];
        }
    }

    static fromJS(data: any): RankAdjustmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new RankAdjustmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberCode"] = this.memberCode;
        data["rankId"] = this.rankId;
        return data;
    }
}

export interface IRankAdjustmentDto {
    memberCode: string | undefined;
    rankId: number | undefined;
}

export class PagedResultDtoOfGetSecondaryCustomerForView implements IPagedResultDtoOfGetSecondaryCustomerForView {
    totalCount!: number | undefined;
    items!: GetSecondaryCustomerForView[] | undefined;

    constructor(data?: IPagedResultDtoOfGetSecondaryCustomerForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetSecondaryCustomerForView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetSecondaryCustomerForView {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetSecondaryCustomerForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetSecondaryCustomerForView {
    totalCount: number | undefined;
    items: GetSecondaryCustomerForView[] | undefined;
}

export class GetSecondaryCustomerForView implements IGetSecondaryCustomerForView {
    secondaryCustomer!: SecondaryCustomerDto | undefined;
    memberLoyaltyInfoMember!: string | undefined;

    constructor(data?: IGetSecondaryCustomerForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.secondaryCustomer = data["secondaryCustomer"] ? SecondaryCustomerDto.fromJS(data["secondaryCustomer"]) : <any>undefined;
            this.memberLoyaltyInfoMember = data["memberLoyaltyInfoMember"];
        }
    }

    static fromJS(data: any): GetSecondaryCustomerForView {
        data = typeof data === 'object' ? data : {};
        let result = new GetSecondaryCustomerForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["secondaryCustomer"] = this.secondaryCustomer ? this.secondaryCustomer.toJSON() : <any>undefined;
        data["memberLoyaltyInfoMember"] = this.memberLoyaltyInfoMember;
        return data;
    }
}

export interface IGetSecondaryCustomerForView {
    secondaryCustomer: SecondaryCustomerDto | undefined;
    memberLoyaltyInfoMember: string | undefined;
}

export class GetSecondaryCustomerForEditOutput implements IGetSecondaryCustomerForEditOutput {
    secondaryCustomer!: CreateOrEditSecondaryCustomerDto | undefined;
    memberLoyaltyInfoMember!: string | undefined;

    constructor(data?: IGetSecondaryCustomerForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.secondaryCustomer = data["secondaryCustomer"] ? CreateOrEditSecondaryCustomerDto.fromJS(data["secondaryCustomer"]) : <any>undefined;
            this.memberLoyaltyInfoMember = data["memberLoyaltyInfoMember"];
        }
    }

    static fromJS(data: any): GetSecondaryCustomerForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetSecondaryCustomerForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["secondaryCustomer"] = this.secondaryCustomer ? this.secondaryCustomer.toJSON() : <any>undefined;
        data["memberLoyaltyInfoMember"] = this.memberLoyaltyInfoMember;
        return data;
    }
}

export interface IGetSecondaryCustomerForEditOutput {
    secondaryCustomer: CreateOrEditSecondaryCustomerDto | undefined;
    memberLoyaltyInfoMember: string | undefined;
}

export class OTPVerifyDto implements IOTPVerifyDto {
    otpToken!: string | undefined;
    phoneNumber!: string | undefined;

    constructor(data?: IOTPVerifyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.otpToken = data["otpToken"];
            this.phoneNumber = data["phoneNumber"];
        }
    }

    static fromJS(data: any): OTPVerifyDto {
        data = typeof data === 'object' ? data : {};
        let result = new OTPVerifyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["otpToken"] = this.otpToken;
        data["phoneNumber"] = this.phoneNumber;
        return data;
    }
}

export interface IOTPVerifyDto {
    otpToken: string | undefined;
    phoneNumber: string | undefined;
}

export class GetAllServiceAccountInput implements IGetAllServiceAccountInput {
    filter!: string | undefined;
    firstNameFilter!: string | undefined;
    codeFilter!: string | undefined;
    phoneFilter!: string | undefined;
    emailFilter!: string | undefined;
    addressFilter!: string | undefined;
    genderFilter!: string | undefined;
    isActiveFilter!: number | undefined;
    idCardFilter!: string | undefined;
    day!: number | undefined;
    month!: number | undefined;
    year!: number | undefined;
    masterCodeFilter!: string | undefined;
    accountType!: string | undefined;
    statusFilter!: string | undefined;
    curentRankFilter!: string | undefined;
    contractFilter!: string | undefined;
    sorting!: string | undefined;
    skipCount!: number | undefined;
    maxResultCount!: number | undefined;

    constructor(data?: IGetAllServiceAccountInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.filter = data["filter"];
            this.firstNameFilter = data["firstNameFilter"];
            this.codeFilter = data["codeFilter"];
            this.phoneFilter = data["phoneFilter"];
            this.emailFilter = data["emailFilter"];
            this.addressFilter = data["addressFilter"];
            this.genderFilter = data["genderFilter"];
            this.isActiveFilter = data["isActiveFilter"];
            this.idCardFilter = data["idCardFilter"];
            this.day = data["day"];
            this.month = data["month"];
            this.year = data["year"];
            this.masterCodeFilter = data["masterCodeFilter"];
            this.accountType = data["accountType"];
            this.statusFilter = data["statusFilter"];
            this.curentRankFilter = data["curentRankFilter"];
            this.contractFilter = data["contractFilter"];
            this.sorting = data["sorting"];
            this.skipCount = data["skipCount"];
            this.maxResultCount = data["maxResultCount"];
        }
    }

    static fromJS(data: any): GetAllServiceAccountInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllServiceAccountInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        data["firstNameFilter"] = this.firstNameFilter;
        data["codeFilter"] = this.codeFilter;
        data["phoneFilter"] = this.phoneFilter;
        data["emailFilter"] = this.emailFilter;
        data["addressFilter"] = this.addressFilter;
        data["genderFilter"] = this.genderFilter;
        data["isActiveFilter"] = this.isActiveFilter;
        data["idCardFilter"] = this.idCardFilter;
        data["day"] = this.day;
        data["month"] = this.month;
        data["year"] = this.year;
        data["masterCodeFilter"] = this.masterCodeFilter;
        data["accountType"] = this.accountType;
        data["statusFilter"] = this.statusFilter;
        data["curentRankFilter"] = this.curentRankFilter;
        data["contractFilter"] = this.contractFilter;
        data["sorting"] = this.sorting;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data;
    }
}

export interface IGetAllServiceAccountInput {
    filter: string | undefined;
    firstNameFilter: string | undefined;
    codeFilter: string | undefined;
    phoneFilter: string | undefined;
    emailFilter: string | undefined;
    addressFilter: string | undefined;
    genderFilter: string | undefined;
    isActiveFilter: number | undefined;
    idCardFilter: string | undefined;
    day: number | undefined;
    month: number | undefined;
    year: number | undefined;
    masterCodeFilter: string | undefined;
    accountType: string | undefined;
    statusFilter: string | undefined;
    curentRankFilter: string | undefined;
    contractFilter: string | undefined;
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;
}

export class PagedResultDtoOfGetSecondaryCustomerTypeForView implements IPagedResultDtoOfGetSecondaryCustomerTypeForView {
    totalCount!: number | undefined;
    items!: GetSecondaryCustomerTypeForView[] | undefined;

    constructor(data?: IPagedResultDtoOfGetSecondaryCustomerTypeForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetSecondaryCustomerTypeForView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetSecondaryCustomerTypeForView {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetSecondaryCustomerTypeForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetSecondaryCustomerTypeForView {
    totalCount: number | undefined;
    items: GetSecondaryCustomerTypeForView[] | undefined;
}

export class GetSecondaryCustomerTypeForView implements IGetSecondaryCustomerTypeForView {
    secondaryCustomerType!: SecondaryCustomerTypeDto | undefined;

    constructor(data?: IGetSecondaryCustomerTypeForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.secondaryCustomerType = data["secondaryCustomerType"] ? SecondaryCustomerTypeDto.fromJS(data["secondaryCustomerType"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSecondaryCustomerTypeForView {
        data = typeof data === 'object' ? data : {};
        let result = new GetSecondaryCustomerTypeForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["secondaryCustomerType"] = this.secondaryCustomerType ? this.secondaryCustomerType.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetSecondaryCustomerTypeForView {
    secondaryCustomerType: SecondaryCustomerTypeDto | undefined;
}

export class SecondaryCustomerTypeDto implements ISecondaryCustomerTypeDto {
    code!: string | undefined;
    name!: string | undefined;
    description!: string | undefined;
    parentCode!: string | undefined;
    isActive!: boolean | undefined;
    level!: number | undefined;
    id!: number | undefined;

    constructor(data?: ISecondaryCustomerTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.name = data["name"];
            this.description = data["description"];
            this.parentCode = data["parentCode"];
            this.isActive = data["isActive"];
            this.level = data["level"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SecondaryCustomerTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new SecondaryCustomerTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["description"] = this.description;
        data["parentCode"] = this.parentCode;
        data["isActive"] = this.isActive;
        data["level"] = this.level;
        data["id"] = this.id;
        return data;
    }
}

export interface ISecondaryCustomerTypeDto {
    code: string | undefined;
    name: string | undefined;
    description: string | undefined;
    parentCode: string | undefined;
    isActive: boolean | undefined;
    level: number | undefined;
    id: number | undefined;
}

export class GetSecondaryCustomerTypeForEditOutput implements IGetSecondaryCustomerTypeForEditOutput {
    secondaryCustomerType!: CreateOrEditSecondaryCustomerTypeDto | undefined;

    constructor(data?: IGetSecondaryCustomerTypeForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.secondaryCustomerType = data["secondaryCustomerType"] ? CreateOrEditSecondaryCustomerTypeDto.fromJS(data["secondaryCustomerType"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSecondaryCustomerTypeForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetSecondaryCustomerTypeForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["secondaryCustomerType"] = this.secondaryCustomerType ? this.secondaryCustomerType.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetSecondaryCustomerTypeForEditOutput {
    secondaryCustomerType: CreateOrEditSecondaryCustomerTypeDto | undefined;
}

export class CreateOrEditSecondaryCustomerTypeDto implements ICreateOrEditSecondaryCustomerTypeDto {
    code!: string;
    name!: string;
    description!: string | undefined;
    parentCode!: string | undefined;
    isActive!: boolean | undefined;
    level!: number | undefined;
    isDeleted!: boolean | undefined;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: moment.Moment | undefined;
    creatorUserId!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditSecondaryCustomerTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.name = data["name"];
            this.description = data["description"];
            this.parentCode = data["parentCode"];
            this.isActive = data["isActive"];
            this.level = data["level"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditSecondaryCustomerTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditSecondaryCustomerTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["description"] = this.description;
        data["parentCode"] = this.parentCode;
        data["isActive"] = this.isActive;
        data["level"] = this.level;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditSecondaryCustomerTypeDto {
    code: string;
    name: string;
    description: string | undefined;
    parentCode: string | undefined;
    isActive: boolean | undefined;
    level: number | undefined;
    isDeleted: boolean | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfGetSeniorityRewardSettingForView implements IPagedResultDtoOfGetSeniorityRewardSettingForView {
    totalCount!: number | undefined;
    items!: GetSeniorityRewardSettingForView[] | undefined;

    constructor(data?: IPagedResultDtoOfGetSeniorityRewardSettingForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetSeniorityRewardSettingForView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetSeniorityRewardSettingForView {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetSeniorityRewardSettingForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetSeniorityRewardSettingForView {
    totalCount: number | undefined;
    items: GetSeniorityRewardSettingForView[] | undefined;
}

export class GetSeniorityRewardSettingForView implements IGetSeniorityRewardSettingForView {
    seniorityRewardSetting!: SeniorityRewardSettingDto | undefined;

    constructor(data?: IGetSeniorityRewardSettingForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.seniorityRewardSetting = data["seniorityRewardSetting"] ? SeniorityRewardSettingDto.fromJS(data["seniorityRewardSetting"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSeniorityRewardSettingForView {
        data = typeof data === 'object' ? data : {};
        let result = new GetSeniorityRewardSettingForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["seniorityRewardSetting"] = this.seniorityRewardSetting ? this.seniorityRewardSetting.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetSeniorityRewardSettingForView {
    seniorityRewardSetting: SeniorityRewardSettingDto | undefined;
}

export class SeniorityRewardSettingDto implements ISeniorityRewardSettingDto {
    code!: string | undefined;
    senioritySettingCode!: string | undefined;
    seniorityFrom!: number | undefined;
    coinValue!: number | undefined;
    pointValue!: number | undefined;
    id!: number | undefined;

    constructor(data?: ISeniorityRewardSettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.senioritySettingCode = data["senioritySettingCode"];
            this.seniorityFrom = data["seniorityFrom"];
            this.coinValue = data["coinValue"];
            this.pointValue = data["pointValue"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SeniorityRewardSettingDto {
        data = typeof data === 'object' ? data : {};
        let result = new SeniorityRewardSettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["senioritySettingCode"] = this.senioritySettingCode;
        data["seniorityFrom"] = this.seniorityFrom;
        data["coinValue"] = this.coinValue;
        data["pointValue"] = this.pointValue;
        data["id"] = this.id;
        return data;
    }
}

export interface ISeniorityRewardSettingDto {
    code: string | undefined;
    senioritySettingCode: string | undefined;
    seniorityFrom: number | undefined;
    coinValue: number | undefined;
    pointValue: number | undefined;
    id: number | undefined;
}

export class GetSeniorityRewardSettingForEditOutput implements IGetSeniorityRewardSettingForEditOutput {
    seniorityRewardSetting!: CreateOrEditSeniorityRewardSettingDto | undefined;

    constructor(data?: IGetSeniorityRewardSettingForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.seniorityRewardSetting = data["seniorityRewardSetting"] ? CreateOrEditSeniorityRewardSettingDto.fromJS(data["seniorityRewardSetting"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSeniorityRewardSettingForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetSeniorityRewardSettingForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["seniorityRewardSetting"] = this.seniorityRewardSetting ? this.seniorityRewardSetting.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetSeniorityRewardSettingForEditOutput {
    seniorityRewardSetting: CreateOrEditSeniorityRewardSettingDto | undefined;
}

export class PagedResultDtoOfGetSenioritySettingHistoryForView implements IPagedResultDtoOfGetSenioritySettingHistoryForView {
    totalCount!: number | undefined;
    items!: GetSenioritySettingHistoryForView[] | undefined;

    constructor(data?: IPagedResultDtoOfGetSenioritySettingHistoryForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetSenioritySettingHistoryForView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetSenioritySettingHistoryForView {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetSenioritySettingHistoryForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetSenioritySettingHistoryForView {
    totalCount: number | undefined;
    items: GetSenioritySettingHistoryForView[] | undefined;
}

export class GetSenioritySettingHistoryForView implements IGetSenioritySettingHistoryForView {
    senioritySettingHistory!: SenioritySettingHistoryDto | undefined;

    constructor(data?: IGetSenioritySettingHistoryForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.senioritySettingHistory = data["senioritySettingHistory"] ? SenioritySettingHistoryDto.fromJS(data["senioritySettingHistory"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSenioritySettingHistoryForView {
        data = typeof data === 'object' ? data : {};
        let result = new GetSenioritySettingHistoryForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["senioritySettingHistory"] = this.senioritySettingHistory ? this.senioritySettingHistory.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetSenioritySettingHistoryForView {
    senioritySettingHistory: SenioritySettingHistoryDto | undefined;
}

export class SenioritySettingHistoryDto implements ISenioritySettingHistoryDto {
    memberCode!: string | undefined;
    senioritySettingCode!: string | undefined;
    seniorityFrom!: number | undefined;
    id!: number | undefined;

    constructor(data?: ISenioritySettingHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberCode = data["memberCode"];
            this.senioritySettingCode = data["senioritySettingCode"];
            this.seniorityFrom = data["seniorityFrom"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SenioritySettingHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new SenioritySettingHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberCode"] = this.memberCode;
        data["senioritySettingCode"] = this.senioritySettingCode;
        data["seniorityFrom"] = this.seniorityFrom;
        data["id"] = this.id;
        return data;
    }
}

export interface ISenioritySettingHistoryDto {
    memberCode: string | undefined;
    senioritySettingCode: string | undefined;
    seniorityFrom: number | undefined;
    id: number | undefined;
}

export class GetSenioritySettingHistoryForEditOutput implements IGetSenioritySettingHistoryForEditOutput {
    senioritySettingHistory!: CreateOrEditSenioritySettingHistoryDto | undefined;

    constructor(data?: IGetSenioritySettingHistoryForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.senioritySettingHistory = data["senioritySettingHistory"] ? CreateOrEditSenioritySettingHistoryDto.fromJS(data["senioritySettingHistory"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSenioritySettingHistoryForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetSenioritySettingHistoryForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["senioritySettingHistory"] = this.senioritySettingHistory ? this.senioritySettingHistory.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetSenioritySettingHistoryForEditOutput {
    senioritySettingHistory: CreateOrEditSenioritySettingHistoryDto | undefined;
}

export class CreateOrEditSenioritySettingHistoryDto implements ICreateOrEditSenioritySettingHistoryDto {
    memberCode!: string | undefined;
    senioritySettingCode!: string | undefined;
    seniorityFrom!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditSenioritySettingHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberCode = data["memberCode"];
            this.senioritySettingCode = data["senioritySettingCode"];
            this.seniorityFrom = data["seniorityFrom"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditSenioritySettingHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditSenioritySettingHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberCode"] = this.memberCode;
        data["senioritySettingCode"] = this.senioritySettingCode;
        data["seniorityFrom"] = this.seniorityFrom;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditSenioritySettingHistoryDto {
    memberCode: string | undefined;
    senioritySettingCode: string | undefined;
    seniorityFrom: number | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfGetSenioritySettingForView implements IPagedResultDtoOfGetSenioritySettingForView {
    totalCount!: number | undefined;
    items!: GetSenioritySettingForView[] | undefined;

    constructor(data?: IPagedResultDtoOfGetSenioritySettingForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetSenioritySettingForView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetSenioritySettingForView {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetSenioritySettingForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetSenioritySettingForView {
    totalCount: number | undefined;
    items: GetSenioritySettingForView[] | undefined;
}

export class GetSenioritySettingForView implements IGetSenioritySettingForView {
    senioritySetting!: SenioritySettingDto | undefined;
    targetAudienceCode!: string | undefined;
    campaignCode!: string | undefined;

    constructor(data?: IGetSenioritySettingForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.senioritySetting = data["senioritySetting"] ? SenioritySettingDto.fromJS(data["senioritySetting"]) : <any>undefined;
            this.targetAudienceCode = data["targetAudienceCode"];
            this.campaignCode = data["campaignCode"];
        }
    }

    static fromJS(data: any): GetSenioritySettingForView {
        data = typeof data === 'object' ? data : {};
        let result = new GetSenioritySettingForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["senioritySetting"] = this.senioritySetting ? this.senioritySetting.toJSON() : <any>undefined;
        data["targetAudienceCode"] = this.targetAudienceCode;
        data["campaignCode"] = this.campaignCode;
        return data;
    }
}

export interface IGetSenioritySettingForView {
    senioritySetting: SenioritySettingDto | undefined;
    targetAudienceCode: string | undefined;
    campaignCode: string | undefined;
}

export class SenioritySettingDto implements ISenioritySettingDto {
    code!: string | undefined;
    name!: string | undefined;
    description!: string | undefined;
    effectiveFrom!: moment.Moment | undefined;
    effectiveTo!: moment.Moment | undefined;
    startPeriod!: moment.Moment | undefined;
    endPeriod!: moment.Moment | undefined;
    minMonthRequired!: number | undefined;
    cron!: string | undefined;
    timeZone!: string | undefined;
    isActive!: boolean | undefined;
    targetAudienceId!: number | undefined;
    campaignId!: number | undefined;
    seniorityRewardSettings!: SeniorityRewardSettingDto[] | undefined;
    targetAudience!: SettingParamDto | undefined;
    targetAudienceCode!: string | undefined;
    id!: number | undefined;

    constructor(data?: ISenioritySettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.name = data["name"];
            this.description = data["description"];
            this.effectiveFrom = data["effectiveFrom"] ? moment(data["effectiveFrom"].toString()) : <any>undefined;
            this.effectiveTo = data["effectiveTo"] ? moment(data["effectiveTo"].toString()) : <any>undefined;
            this.startPeriod = data["startPeriod"] ? moment(data["startPeriod"].toString()) : <any>undefined;
            this.endPeriod = data["endPeriod"] ? moment(data["endPeriod"].toString()) : <any>undefined;
            this.minMonthRequired = data["minMonthRequired"];
            this.cron = data["cron"];
            this.timeZone = data["timeZone"];
            this.isActive = data["isActive"];
            this.targetAudienceId = data["targetAudienceId"];
            this.campaignId = data["campaignId"];
            if (data["seniorityRewardSettings"] && data["seniorityRewardSettings"].constructor === Array) {
                this.seniorityRewardSettings = [];
                for (let item of data["seniorityRewardSettings"])
                    this.seniorityRewardSettings.push(SeniorityRewardSettingDto.fromJS(item));
            }
            this.targetAudience = data["targetAudience"] ? SettingParamDto.fromJS(data["targetAudience"]) : <any>undefined;
            this.targetAudienceCode = data["targetAudienceCode"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SenioritySettingDto {
        data = typeof data === 'object' ? data : {};
        let result = new SenioritySettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["description"] = this.description;
        data["effectiveFrom"] = this.effectiveFrom ? this.effectiveFrom.toISOString() : <any>undefined;
        data["effectiveTo"] = this.effectiveTo ? this.effectiveTo.toISOString() : <any>undefined;
        data["startPeriod"] = this.startPeriod ? this.startPeriod.toISOString() : <any>undefined;
        data["endPeriod"] = this.endPeriod ? this.endPeriod.toISOString() : <any>undefined;
        data["minMonthRequired"] = this.minMonthRequired;
        data["cron"] = this.cron;
        data["timeZone"] = this.timeZone;
        data["isActive"] = this.isActive;
        data["targetAudienceId"] = this.targetAudienceId;
        data["campaignId"] = this.campaignId;
        if (this.seniorityRewardSettings && this.seniorityRewardSettings.constructor === Array) {
            data["seniorityRewardSettings"] = [];
            for (let item of this.seniorityRewardSettings)
                data["seniorityRewardSettings"].push(item.toJSON());
        }
        data["targetAudience"] = this.targetAudience ? this.targetAudience.toJSON() : <any>undefined;
        data["targetAudienceCode"] = this.targetAudienceCode;
        data["id"] = this.id;
        return data;
    }
}

export interface ISenioritySettingDto {
    code: string | undefined;
    name: string | undefined;
    description: string | undefined;
    effectiveFrom: moment.Moment | undefined;
    effectiveTo: moment.Moment | undefined;
    startPeriod: moment.Moment | undefined;
    endPeriod: moment.Moment | undefined;
    minMonthRequired: number | undefined;
    cron: string | undefined;
    timeZone: string | undefined;
    isActive: boolean | undefined;
    targetAudienceId: number | undefined;
    campaignId: number | undefined;
    seniorityRewardSettings: SeniorityRewardSettingDto[] | undefined;
    targetAudience: SettingParamDto | undefined;
    targetAudienceCode: string | undefined;
    id: number | undefined;
}

export class GetSenioritySettingForEditOutput implements IGetSenioritySettingForEditOutput {
    senioritySetting!: CreateOrEditSenioritySettingDto | undefined;
    targetAudienceCode!: string | undefined;
    campaignCode!: string | undefined;

    constructor(data?: IGetSenioritySettingForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.senioritySetting = data["senioritySetting"] ? CreateOrEditSenioritySettingDto.fromJS(data["senioritySetting"]) : <any>undefined;
            this.targetAudienceCode = data["targetAudienceCode"];
            this.campaignCode = data["campaignCode"];
        }
    }

    static fromJS(data: any): GetSenioritySettingForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetSenioritySettingForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["senioritySetting"] = this.senioritySetting ? this.senioritySetting.toJSON() : <any>undefined;
        data["targetAudienceCode"] = this.targetAudienceCode;
        data["campaignCode"] = this.campaignCode;
        return data;
    }
}

export interface IGetSenioritySettingForEditOutput {
    senioritySetting: CreateOrEditSenioritySettingDto | undefined;
    targetAudienceCode: string | undefined;
    campaignCode: string | undefined;
}

export class ListResultDtoOfSenioritySettingDto implements IListResultDtoOfSenioritySettingDto {
    items!: SenioritySettingDto[] | undefined;

    constructor(data?: IListResultDtoOfSenioritySettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(SenioritySettingDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfSenioritySettingDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfSenioritySettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListResultDtoOfSenioritySettingDto {
    items: SenioritySettingDto[] | undefined;
}

export class CreateOrEditSerialInput implements ICreateOrEditSerialInput {
    id!: number | undefined;

    constructor(data?: ICreateOrEditSerialInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditSerialInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditSerialInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditSerialInput {
    id: number | undefined;
}

export class PagedResultDtoOfGetListSerialResponse implements IPagedResultDtoOfGetListSerialResponse {
    totalCount!: number | undefined;
    items!: GetListSerialResponse[] | undefined;

    constructor(data?: IPagedResultDtoOfGetListSerialResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetListSerialResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetListSerialResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetListSerialResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetListSerialResponse {
    totalCount: number | undefined;
    items: GetListSerialResponse[] | undefined;
}

export class GetListSerialResponse implements IGetListSerialResponse {
    serialCode!: string | undefined;
    activeSaleIn!: boolean | undefined;
    activeSaleOut!: boolean | undefined;
    refCode!: string | undefined;
    distributor!: string | undefined;
    year!: string | undefined;
    model!: string | undefined;
    productName!: string | undefined;
    productType!: string | undefined;
    isDeleted!: boolean | undefined;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: moment.Moment | undefined;
    creatorUserId!: number | undefined;
    id!: number | undefined;

    constructor(data?: IGetListSerialResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.serialCode = data["serialCode"];
            this.activeSaleIn = data["activeSaleIn"];
            this.activeSaleOut = data["activeSaleOut"];
            this.refCode = data["refCode"];
            this.distributor = data["distributor"];
            this.year = data["year"];
            this.model = data["model"];
            this.productName = data["productName"];
            this.productType = data["productType"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): GetListSerialResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetListSerialResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serialCode"] = this.serialCode;
        data["activeSaleIn"] = this.activeSaleIn;
        data["activeSaleOut"] = this.activeSaleOut;
        data["refCode"] = this.refCode;
        data["distributor"] = this.distributor;
        data["year"] = this.year;
        data["model"] = this.model;
        data["productName"] = this.productName;
        data["productType"] = this.productType;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IGetListSerialResponse {
    serialCode: string | undefined;
    activeSaleIn: boolean | undefined;
    activeSaleOut: boolean | undefined;
    refCode: string | undefined;
    distributor: string | undefined;
    year: string | undefined;
    model: string | undefined;
    productName: string | undefined;
    productType: string | undefined;
    isDeleted: boolean | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class GetSerialInput implements IGetSerialInput {
    serialCode!: string | undefined;
    status!: string | undefined;
    distributor!: string | undefined;
    refCode!: string | undefined;
    sorting!: string | undefined;
    skipCount!: number | undefined;
    maxResultCount!: number | undefined;

    constructor(data?: IGetSerialInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.serialCode = data["serialCode"];
            this.status = data["status"];
            this.distributor = data["distributor"];
            this.refCode = data["refCode"];
            this.sorting = data["sorting"];
            this.skipCount = data["skipCount"];
            this.maxResultCount = data["maxResultCount"];
        }
    }

    static fromJS(data: any): GetSerialInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetSerialInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serialCode"] = this.serialCode;
        data["status"] = this.status;
        data["distributor"] = this.distributor;
        data["refCode"] = this.refCode;
        data["sorting"] = this.sorting;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data;
    }
}

export interface IGetSerialInput {
    serialCode: string | undefined;
    status: string | undefined;
    distributor: string | undefined;
    refCode: string | undefined;
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;
}

export class SerialAgrs implements ISerialAgrs {
    tableName!: string | undefined;
    filePath!: string | undefined;
    fileName!: string | undefined;
    userId!: number | undefined;
    userName!: string | undefined;
    name!: string | undefined;
    tenantId!: number | undefined;
    currentLanguage!: string | undefined;
    apiUrl!: string | undefined;

    constructor(data?: ISerialAgrs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tableName = data["tableName"];
            this.filePath = data["filePath"];
            this.fileName = data["fileName"];
            this.userId = data["userId"];
            this.userName = data["userName"];
            this.name = data["name"];
            this.tenantId = data["tenantId"];
            this.currentLanguage = data["currentLanguage"];
            this.apiUrl = data["apiUrl"];
        }
    }

    static fromJS(data: any): SerialAgrs {
        data = typeof data === 'object' ? data : {};
        let result = new SerialAgrs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tableName"] = this.tableName;
        data["filePath"] = this.filePath;
        data["fileName"] = this.fileName;
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["name"] = this.name;
        data["tenantId"] = this.tenantId;
        data["currentLanguage"] = this.currentLanguage;
        data["apiUrl"] = this.apiUrl;
        return data;
    }
}

export interface ISerialAgrs {
    tableName: string | undefined;
    filePath: string | undefined;
    fileName: string | undefined;
    userId: number | undefined;
    userName: string | undefined;
    name: string | undefined;
    tenantId: number | undefined;
    currentLanguage: string | undefined;
    apiUrl: string | undefined;
}

export class PagedResultDtoOfSerialProducerResponseDto implements IPagedResultDtoOfSerialProducerResponseDto {
    totalCount!: number | undefined;
    items!: SerialProducerResponseDto[] | undefined;

    constructor(data?: IPagedResultDtoOfSerialProducerResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(SerialProducerResponseDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfSerialProducerResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfSerialProducerResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfSerialProducerResponseDto {
    totalCount: number | undefined;
    items: SerialProducerResponseDto[] | undefined;
}

export class SerialProducerResponseDto implements ISerialProducerResponseDto {
    serial!: string | undefined;
    month!: number | undefined;
    year!: number | undefined;
    model!: string | undefined;
    activationCode!: string | undefined;
    status!: string | undefined;
    cont!: string | undefined;
    reference!: string | undefined;
    vehicleNumber!: string | undefined;
    plant!: number | undefined;
    scanDate!: moment.Moment | undefined;
    massOrder!: string | undefined;
    massOrderPO!: string | undefined;
    manufacturer!: string | undefined;
    importedDate!: moment.Moment | undefined;
    isActive!: boolean | undefined;
    ruleId!: number | undefined;
    isDeleted!: boolean | undefined;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: moment.Moment | undefined;
    creatorUserId!: number | undefined;
    id!: number | undefined;

    constructor(data?: ISerialProducerResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.isActive = true;
        }
    }

    init(data?: any) {
        if (data) {
            this.serial = data["serial"];
            this.month = data["month"];
            this.year = data["year"];
            this.model = data["model"];
            this.activationCode = data["activationCode"];
            this.status = data["status"];
            this.cont = data["cont"];
            this.reference = data["reference"];
            this.vehicleNumber = data["vehicleNumber"];
            this.plant = data["plant"];
            this.scanDate = data["scanDate"] ? moment(data["scanDate"].toString()) : <any>undefined;
            this.massOrder = data["massOrder"];
            this.massOrderPO = data["massOrderPO"];
            this.manufacturer = data["manufacturer"];
            this.importedDate = data["importedDate"] ? moment(data["importedDate"].toString()) : <any>undefined;
            this.isActive = data["isActive"] !== undefined ? data["isActive"] : true;
            this.ruleId = data["ruleId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SerialProducerResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new SerialProducerResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serial"] = this.serial;
        data["month"] = this.month;
        data["year"] = this.year;
        data["model"] = this.model;
        data["activationCode"] = this.activationCode;
        data["status"] = this.status;
        data["cont"] = this.cont;
        data["reference"] = this.reference;
        data["vehicleNumber"] = this.vehicleNumber;
        data["plant"] = this.plant;
        data["scanDate"] = this.scanDate ? this.scanDate.toISOString() : <any>undefined;
        data["massOrder"] = this.massOrder;
        data["massOrderPO"] = this.massOrderPO;
        data["manufacturer"] = this.manufacturer;
        data["importedDate"] = this.importedDate ? this.importedDate.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        data["ruleId"] = this.ruleId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ISerialProducerResponseDto {
    serial: string | undefined;
    month: number | undefined;
    year: number | undefined;
    model: string | undefined;
    activationCode: string | undefined;
    status: string | undefined;
    cont: string | undefined;
    reference: string | undefined;
    vehicleNumber: string | undefined;
    plant: number | undefined;
    scanDate: moment.Moment | undefined;
    massOrder: string | undefined;
    massOrderPO: string | undefined;
    manufacturer: string | undefined;
    importedDate: moment.Moment | undefined;
    isActive: boolean | undefined;
    ruleId: number | undefined;
    isDeleted: boolean | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class ScanInput implements IScanInput {
    serial!: string | undefined;
    massOrderPO!: string | undefined;
    cont!: string | undefined;
    manufacturer!: string | undefined;

    constructor(data?: IScanInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.serial = data["serial"];
            this.massOrderPO = data["massOrderPO"];
            this.cont = data["cont"];
            this.manufacturer = data["manufacturer"];
        }
    }

    static fromJS(data: any): ScanInput {
        data = typeof data === 'object' ? data : {};
        let result = new ScanInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serial"] = this.serial;
        data["massOrderPO"] = this.massOrderPO;
        data["cont"] = this.cont;
        data["manufacturer"] = this.manufacturer;
        return data;
    }
}

export interface IScanInput {
    serial: string | undefined;
    massOrderPO: string | undefined;
    cont: string | undefined;
    manufacturer: string | undefined;
}

export class SerialProducerGenerateInput implements ISerialProducerGenerateInput {
    model!: string;
    massOrder!: string | undefined;
    manufacturer!: string | undefined;
    ruleId!: number;
    amount!: number | undefined;
    month!: number;
    year!: number;

    constructor(data?: ISerialProducerGenerateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.model = data["model"];
            this.massOrder = data["massOrder"];
            this.manufacturer = data["manufacturer"];
            this.ruleId = data["ruleId"];
            this.amount = data["amount"];
            this.month = data["month"];
            this.year = data["year"];
        }
    }

    static fromJS(data: any): SerialProducerGenerateInput {
        data = typeof data === 'object' ? data : {};
        let result = new SerialProducerGenerateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["model"] = this.model;
        data["massOrder"] = this.massOrder;
        data["manufacturer"] = this.manufacturer;
        data["ruleId"] = this.ruleId;
        data["amount"] = this.amount;
        data["month"] = this.month;
        data["year"] = this.year;
        return data;
    }
}

export interface ISerialProducerGenerateInput {
    model: string;
    massOrder: string | undefined;
    manufacturer: string | undefined;
    ruleId: number;
    amount: number | undefined;
    month: number;
    year: number;
}

export class ResponseDtoOfListOfListOfSerialProducer implements IResponseDtoOfListOfListOfSerialProducer {
    message!: string | undefined;
    data!: SerialProducer[][] | undefined;

    constructor(data?: IResponseDtoOfListOfListOfSerialProducer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.message = data["message"];
            if (data["data"] && data["data"].constructor === Array) {
                this.data = [];
                for (let item of data["data"])
                    this.data.push(item);
            }
        }
    }

    static fromJS(data: any): ResponseDtoOfListOfListOfSerialProducer {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseDtoOfListOfListOfSerialProducer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        if (this.data && this.data.constructor === Array) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item);
        }
        return data;
    }
}

export interface IResponseDtoOfListOfListOfSerialProducer {
    message: string | undefined;
    data: SerialProducer[][] | undefined;
}

export class SerialProducer implements ISerialProducer {
    serial!: string | undefined;
    month!: number | undefined;
    year!: number | undefined;
    model!: string | undefined;
    activationCode!: string | undefined;
    status!: string | undefined;
    reference!: string | undefined;
    vehicleNumber!: string | undefined;
    plant!: number | undefined;
    scanDate!: moment.Moment | undefined;
    manufacturer!: string | undefined;
    importedDate!: moment.Moment | undefined;
    isActive!: boolean | undefined;
    ruleId!: number | undefined;
    massOrder!: string | undefined;
    massOrderPO!: string | undefined;
    cont!: string | undefined;
    isDeleted!: boolean | undefined;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: moment.Moment | undefined;
    creatorUserId!: number | undefined;
    id!: number | undefined;

    constructor(data?: ISerialProducer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.isActive = true;
        }
    }

    init(data?: any) {
        if (data) {
            this.serial = data["serial"];
            this.month = data["month"];
            this.year = data["year"];
            this.model = data["model"];
            this.activationCode = data["activationCode"];
            this.status = data["status"];
            this.reference = data["reference"];
            this.vehicleNumber = data["vehicleNumber"];
            this.plant = data["plant"];
            this.scanDate = data["scanDate"] ? moment(data["scanDate"].toString()) : <any>undefined;
            this.manufacturer = data["manufacturer"];
            this.importedDate = data["importedDate"] ? moment(data["importedDate"].toString()) : <any>undefined;
            this.isActive = data["isActive"] !== undefined ? data["isActive"] : true;
            this.ruleId = data["ruleId"];
            this.massOrder = data["massOrder"];
            this.massOrderPO = data["massOrderPO"];
            this.cont = data["cont"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SerialProducer {
        data = typeof data === 'object' ? data : {};
        let result = new SerialProducer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serial"] = this.serial;
        data["month"] = this.month;
        data["year"] = this.year;
        data["model"] = this.model;
        data["activationCode"] = this.activationCode;
        data["status"] = this.status;
        data["reference"] = this.reference;
        data["vehicleNumber"] = this.vehicleNumber;
        data["plant"] = this.plant;
        data["scanDate"] = this.scanDate ? this.scanDate.toISOString() : <any>undefined;
        data["manufacturer"] = this.manufacturer;
        data["importedDate"] = this.importedDate ? this.importedDate.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        data["ruleId"] = this.ruleId;
        data["massOrder"] = this.massOrder;
        data["massOrderPO"] = this.massOrderPO;
        data["cont"] = this.cont;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ISerialProducer {
    serial: string | undefined;
    month: number | undefined;
    year: number | undefined;
    model: string | undefined;
    activationCode: string | undefined;
    status: string | undefined;
    reference: string | undefined;
    vehicleNumber: string | undefined;
    plant: number | undefined;
    scanDate: moment.Moment | undefined;
    manufacturer: string | undefined;
    importedDate: moment.Moment | undefined;
    isActive: boolean | undefined;
    ruleId: number | undefined;
    massOrder: string | undefined;
    massOrderPO: string | undefined;
    cont: string | undefined;
    isDeleted: boolean | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class ActivationCodeGenerateInput implements IActivationCodeGenerateInput {
    ruleId!: number | undefined;
    amount!: number | undefined;

    constructor(data?: IActivationCodeGenerateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.ruleId = data["ruleId"];
            this.amount = data["amount"];
        }
    }

    static fromJS(data: any): ActivationCodeGenerateInput {
        data = typeof data === 'object' ? data : {};
        let result = new ActivationCodeGenerateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ruleId"] = this.ruleId;
        data["amount"] = this.amount;
        return data;
    }
}

export interface IActivationCodeGenerateInput {
    ruleId: number | undefined;
    amount: number | undefined;
}

export class PagedResultDtoOfScanLogResponseDto implements IPagedResultDtoOfScanLogResponseDto {
    totalCount!: number | undefined;
    items!: ScanLogResponseDto[] | undefined;

    constructor(data?: IPagedResultDtoOfScanLogResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(ScanLogResponseDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfScanLogResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfScanLogResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfScanLogResponseDto {
    totalCount: number | undefined;
    items: ScanLogResponseDto[] | undefined;
}

export class ScanLogResponseDto implements IScanLogResponseDto {
    serial!: string | undefined;
    manufacturer!: string | undefined;
    serial2!: string | undefined;
    activationCode!: string | undefined;
    message!: string | undefined;
    status!: string | undefined;
    isDeleted!: boolean | undefined;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: moment.Moment | undefined;
    creatorUserId!: number | undefined;
    id!: number | undefined;

    constructor(data?: IScanLogResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.serial = data["serial"];
            this.manufacturer = data["manufacturer"];
            this.serial2 = data["serial2"];
            this.activationCode = data["activationCode"];
            this.message = data["message"];
            this.status = data["status"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ScanLogResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ScanLogResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serial"] = this.serial;
        data["manufacturer"] = this.manufacturer;
        data["serial2"] = this.serial2;
        data["activationCode"] = this.activationCode;
        data["message"] = this.message;
        data["status"] = this.status;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IScanLogResponseDto {
    serial: string | undefined;
    manufacturer: string | undefined;
    serial2: string | undefined;
    activationCode: string | undefined;
    message: string | undefined;
    status: string | undefined;
    isDeleted: boolean | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class ScanLogCheckInput implements IScanLogCheckInput {
    code!: string;
    manufacturer!: string | undefined;

    constructor(data?: IScanLogCheckInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.manufacturer = data["manufacturer"];
        }
    }

    static fromJS(data: any): ScanLogCheckInput {
        data = typeof data === 'object' ? data : {};
        let result = new ScanLogCheckInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["manufacturer"] = this.manufacturer;
        return data;
    }
}

export interface IScanLogCheckInput {
    code: string;
    manufacturer: string | undefined;
}

export class ResponseDtoOfScanLogScanResponseDto implements IResponseDtoOfScanLogScanResponseDto {
    message!: string | undefined;
    data!: ScanLogScanResponseDto | undefined;

    constructor(data?: IResponseDtoOfScanLogScanResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.message = data["message"];
            this.data = data["data"] ? ScanLogScanResponseDto.fromJS(data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResponseDtoOfScanLogScanResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseDtoOfScanLogScanResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IResponseDtoOfScanLogScanResponseDto {
    message: string | undefined;
    data: ScanLogScanResponseDto | undefined;
}

export class ScanLogScanResponseDto implements IScanLogScanResponseDto {
    serialProducer!: SerialProducerResponseDto | undefined;
    type!: string | undefined;

    constructor(data?: IScanLogScanResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.serialProducer = data["serialProducer"] ? SerialProducerResponseDto.fromJS(data["serialProducer"]) : <any>undefined;
            this.type = data["type"];
        }
    }

    static fromJS(data: any): ScanLogScanResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ScanLogScanResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serialProducer"] = this.serialProducer ? this.serialProducer.toJSON() : <any>undefined;
        data["type"] = this.type;
        return data;
    }
}

export interface IScanLogScanResponseDto {
    serialProducer: SerialProducerResponseDto | undefined;
    type: string | undefined;
}

export class ScanLogInput implements IScanLogInput {
    serial!: string | undefined;
    serial2!: string | undefined;
    activationCode!: string | undefined;
    manufacturer!: string | undefined;
    message!: string | undefined;
    status!: string;

    constructor(data?: IScanLogInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.serial = data["serial"];
            this.serial2 = data["serial2"];
            this.activationCode = data["activationCode"];
            this.manufacturer = data["manufacturer"];
            this.message = data["message"];
            this.status = data["status"];
        }
    }

    static fromJS(data: any): ScanLogInput {
        data = typeof data === 'object' ? data : {};
        let result = new ScanLogInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serial"] = this.serial;
        data["serial2"] = this.serial2;
        data["activationCode"] = this.activationCode;
        data["manufacturer"] = this.manufacturer;
        data["message"] = this.message;
        data["status"] = this.status;
        return data;
    }
}

export interface IScanLogInput {
    serial: string | undefined;
    serial2: string | undefined;
    activationCode: string | undefined;
    manufacturer: string | undefined;
    message: string | undefined;
    status: string;
}

export class GetChangeHistoryInput implements IGetChangeHistoryInput {
    docNum!: string | undefined;
    referFrom!: string | undefined;
    fromDate!: moment.Moment | undefined;
    toDate!: moment.Moment | undefined;
    serial!: string | undefined;
    model!: string | undefined;
    serialType!: string | undefined;
    salemanCode!: string | undefined;
    plant!: string | undefined;
    sorting!: string | undefined;
    skipCount!: number | undefined;
    maxResultCount!: number | undefined;

    constructor(data?: IGetChangeHistoryInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.docNum = data["docNum"];
            this.referFrom = data["referFrom"];
            this.fromDate = data["fromDate"] ? moment(data["fromDate"].toString()) : <any>undefined;
            this.toDate = data["toDate"] ? moment(data["toDate"].toString()) : <any>undefined;
            this.serial = data["serial"];
            this.model = data["model"];
            this.serialType = data["serialType"];
            this.salemanCode = data["salemanCode"];
            this.plant = data["plant"];
            this.sorting = data["sorting"];
            this.skipCount = data["skipCount"];
            this.maxResultCount = data["maxResultCount"];
        }
    }

    static fromJS(data: any): GetChangeHistoryInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetChangeHistoryInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["docNum"] = this.docNum;
        data["referFrom"] = this.referFrom;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data["serial"] = this.serial;
        data["model"] = this.model;
        data["serialType"] = this.serialType;
        data["salemanCode"] = this.salemanCode;
        data["plant"] = this.plant;
        data["sorting"] = this.sorting;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data;
    }
}

export interface IGetChangeHistoryInput {
    docNum: string | undefined;
    referFrom: string | undefined;
    fromDate: moment.Moment | undefined;
    toDate: moment.Moment | undefined;
    serial: string | undefined;
    model: string | undefined;
    serialType: string | undefined;
    salemanCode: string | undefined;
    plant: string | undefined;
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;
}

export class PagedResultDtoOfGetChangeHistoryForViewDto implements IPagedResultDtoOfGetChangeHistoryForViewDto {
    totalCount!: number | undefined;
    items!: GetChangeHistoryForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetChangeHistoryForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetChangeHistoryForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetChangeHistoryForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetChangeHistoryForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetChangeHistoryForViewDto {
    totalCount: number | undefined;
    items: GetChangeHistoryForViewDto[] | undefined;
}

export class GetChangeHistoryForViewDto implements IGetChangeHistoryForViewDto {
    listHistory!: GetListChangeHistoryResponse | undefined;

    constructor(data?: IGetChangeHistoryForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.listHistory = data["listHistory"] ? GetListChangeHistoryResponse.fromJS(data["listHistory"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetChangeHistoryForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetChangeHistoryForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["listHistory"] = this.listHistory ? this.listHistory.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetChangeHistoryForViewDto {
    listHistory: GetListChangeHistoryResponse | undefined;
}

export class GetListChangeHistoryResponse implements IGetListChangeHistoryResponse {
    docNum!: string | undefined;
    serial!: string | undefined;
    productCode!: string | undefined;
    syncStatus!: boolean | undefined;
    creationTime!: moment.Moment | undefined;
    serialType!: string | undefined;
    serialTypeName!: string | undefined;
    referFrom!: string | undefined;
    reason!: string | undefined;
    creatorName!: string | undefined;
    plant!: string | undefined;
    isDeleted!: boolean | undefined;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    creatorUserId!: number | undefined;
    id!: number | undefined;

    constructor(data?: IGetListChangeHistoryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.docNum = data["docNum"];
            this.serial = data["serial"];
            this.productCode = data["productCode"];
            this.syncStatus = data["syncStatus"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.serialType = data["serialType"];
            this.serialTypeName = data["serialTypeName"];
            this.referFrom = data["referFrom"];
            this.reason = data["reason"];
            this.creatorName = data["creatorName"];
            this.plant = data["plant"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): GetListChangeHistoryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetListChangeHistoryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["docNum"] = this.docNum;
        data["serial"] = this.serial;
        data["productCode"] = this.productCode;
        data["syncStatus"] = this.syncStatus;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["serialType"] = this.serialType;
        data["serialTypeName"] = this.serialTypeName;
        data["referFrom"] = this.referFrom;
        data["reason"] = this.reason;
        data["creatorName"] = this.creatorName;
        data["plant"] = this.plant;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IGetListChangeHistoryResponse {
    docNum: string | undefined;
    serial: string | undefined;
    productCode: string | undefined;
    syncStatus: boolean | undefined;
    creationTime: moment.Moment | undefined;
    serialType: string | undefined;
    serialTypeName: string | undefined;
    referFrom: string | undefined;
    reason: string | undefined;
    creatorName: string | undefined;
    plant: string | undefined;
    isDeleted: boolean | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class UpdateSerialTypeRequest implements IUpdateSerialTypeRequest {
    docNum!: string;
    serial!: string;
    serialType!: string;
    referFrom!: string;
    reason!: string;
    plant!: string;
    id!: number | undefined;

    constructor(data?: IUpdateSerialTypeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.docNum = data["docNum"];
            this.serial = data["serial"];
            this.serialType = data["serialType"];
            this.referFrom = data["referFrom"];
            this.reason = data["reason"];
            this.plant = data["plant"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): UpdateSerialTypeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSerialTypeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["docNum"] = this.docNum;
        data["serial"] = this.serial;
        data["serialType"] = this.serialType;
        data["referFrom"] = this.referFrom;
        data["reason"] = this.reason;
        data["plant"] = this.plant;
        data["id"] = this.id;
        return data;
    }
}

export interface IUpdateSerialTypeRequest {
    docNum: string;
    serial: string;
    serialType: string;
    referFrom: string;
    reason: string;
    plant: string;
    id: number | undefined;
}

export class GetCurrentLoginInformationsOutput implements IGetCurrentLoginInformationsOutput {
    user!: UserLoginInfoDto | undefined;
    tenant!: TenantLoginInfoDto | undefined;
    application!: ApplicationInfoDto | undefined;

    constructor(data?: IGetCurrentLoginInformationsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.user = data["user"] ? UserLoginInfoDto.fromJS(data["user"]) : <any>undefined;
            this.tenant = data["tenant"] ? TenantLoginInfoDto.fromJS(data["tenant"]) : <any>undefined;
            this.application = data["application"] ? ApplicationInfoDto.fromJS(data["application"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCurrentLoginInformationsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetCurrentLoginInformationsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["tenant"] = this.tenant ? this.tenant.toJSON() : <any>undefined;
        data["application"] = this.application ? this.application.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetCurrentLoginInformationsOutput {
    user: UserLoginInfoDto | undefined;
    tenant: TenantLoginInfoDto | undefined;
    application: ApplicationInfoDto | undefined;
}

export class UserLoginInfoDto implements IUserLoginInfoDto {
    name!: string | undefined;
    surname!: string | undefined;
    userName!: string | undefined;
    emailAddress!: string | undefined;
    profilePictureId!: string | undefined;
    id!: number | undefined;

    constructor(data?: IUserLoginInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.surname = data["surname"];
            this.userName = data["userName"];
            this.emailAddress = data["emailAddress"];
            this.profilePictureId = data["profilePictureId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): UserLoginInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserLoginInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["profilePictureId"] = this.profilePictureId;
        data["id"] = this.id;
        return data;
    }
}

export interface IUserLoginInfoDto {
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    profilePictureId: string | undefined;
    id: number | undefined;
}

export class TenantLoginInfoDto implements ITenantLoginInfoDto {
    tenancyName!: string | undefined;
    name!: string | undefined;
    logoId!: string | undefined;
    logoFileType!: string | undefined;
    customCssId!: string | undefined;
    subscriptionEndDateUtc!: moment.Moment | undefined;
    isInTrialPeriod!: boolean | undefined;
    edition!: EditionInfoDto | undefined;
    creationTime!: moment.Moment | undefined;
    paymentPeriodType!: TenantLoginInfoDtoPaymentPeriodType | undefined;
    subscriptionDateString!: string | undefined;
    creationTimeString!: string | undefined;
    id!: number | undefined;

    constructor(data?: ITenantLoginInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenancyName = data["tenancyName"];
            this.name = data["name"];
            this.logoId = data["logoId"];
            this.logoFileType = data["logoFileType"];
            this.customCssId = data["customCssId"];
            this.subscriptionEndDateUtc = data["subscriptionEndDateUtc"] ? moment(data["subscriptionEndDateUtc"].toString()) : <any>undefined;
            this.isInTrialPeriod = data["isInTrialPeriod"];
            this.edition = data["edition"] ? EditionInfoDto.fromJS(data["edition"]) : <any>undefined;
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.paymentPeriodType = data["paymentPeriodType"];
            this.subscriptionDateString = data["subscriptionDateString"];
            this.creationTimeString = data["creationTimeString"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): TenantLoginInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantLoginInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["logoId"] = this.logoId;
        data["logoFileType"] = this.logoFileType;
        data["customCssId"] = this.customCssId;
        data["subscriptionEndDateUtc"] = this.subscriptionEndDateUtc ? this.subscriptionEndDateUtc.toISOString() : <any>undefined;
        data["isInTrialPeriod"] = this.isInTrialPeriod;
        data["edition"] = this.edition ? this.edition.toJSON() : <any>undefined;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["paymentPeriodType"] = this.paymentPeriodType;
        data["subscriptionDateString"] = this.subscriptionDateString;
        data["creationTimeString"] = this.creationTimeString;
        data["id"] = this.id;
        return data;
    }
}

export interface ITenantLoginInfoDto {
    tenancyName: string | undefined;
    name: string | undefined;
    logoId: string | undefined;
    logoFileType: string | undefined;
    customCssId: string | undefined;
    subscriptionEndDateUtc: moment.Moment | undefined;
    isInTrialPeriod: boolean | undefined;
    edition: EditionInfoDto | undefined;
    creationTime: moment.Moment | undefined;
    paymentPeriodType: TenantLoginInfoDtoPaymentPeriodType | undefined;
    subscriptionDateString: string | undefined;
    creationTimeString: string | undefined;
    id: number | undefined;
}

export class ApplicationInfoDto implements IApplicationInfoDto {
    version!: string | undefined;
    releaseDate!: moment.Moment | undefined;
    features!: { [key: string]: boolean; } | undefined;

    constructor(data?: IApplicationInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.version = data["version"];
            this.releaseDate = data["releaseDate"] ? moment(data["releaseDate"].toString()) : <any>undefined;
            if (data["features"]) {
                this.features = {};
                for (let key in data["features"]) {
                    if (data["features"].hasOwnProperty(key))
                        this.features[key] = data["features"][key];
                }
            }
        }
    }

    static fromJS(data: any): ApplicationInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version;
        data["releaseDate"] = this.releaseDate ? this.releaseDate.toISOString() : <any>undefined;
        if (this.features) {
            data["features"] = {};
            for (let key in this.features) {
                if (this.features.hasOwnProperty(key))
                    data["features"][key] = this.features[key];
            }
        }
        return data;
    }
}

export interface IApplicationInfoDto {
    version: string | undefined;
    releaseDate: moment.Moment | undefined;
    features: { [key: string]: boolean; } | undefined;
}

export class EditionInfoDto implements IEditionInfoDto {
    displayName!: string | undefined;
    trialDayCount!: number | undefined;
    monthlyPrice!: number | undefined;
    annualPrice!: number | undefined;
    isHighestEdition!: boolean | undefined;
    isFree!: boolean | undefined;
    id!: number | undefined;

    constructor(data?: IEditionInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.displayName = data["displayName"];
            this.trialDayCount = data["trialDayCount"];
            this.monthlyPrice = data["monthlyPrice"];
            this.annualPrice = data["annualPrice"];
            this.isHighestEdition = data["isHighestEdition"];
            this.isFree = data["isFree"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EditionInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditionInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["trialDayCount"] = this.trialDayCount;
        data["monthlyPrice"] = this.monthlyPrice;
        data["annualPrice"] = this.annualPrice;
        data["isHighestEdition"] = this.isHighestEdition;
        data["isFree"] = this.isFree;
        data["id"] = this.id;
        return data;
    }
}

export interface IEditionInfoDto {
    displayName: string | undefined;
    trialDayCount: number | undefined;
    monthlyPrice: number | undefined;
    annualPrice: number | undefined;
    isHighestEdition: boolean | undefined;
    isFree: boolean | undefined;
    id: number | undefined;
}

export class UpdateUserSignInTokenOutput implements IUpdateUserSignInTokenOutput {
    signInToken!: string | undefined;
    encodedUserId!: string | undefined;
    encodedTenantId!: string | undefined;

    constructor(data?: IUpdateUserSignInTokenOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.signInToken = data["signInToken"];
            this.encodedUserId = data["encodedUserId"];
            this.encodedTenantId = data["encodedTenantId"];
        }
    }

    static fromJS(data: any): UpdateUserSignInTokenOutput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserSignInTokenOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["signInToken"] = this.signInToken;
        data["encodedUserId"] = this.encodedUserId;
        data["encodedTenantId"] = this.encodedTenantId;
        return data;
    }
}

export interface IUpdateUserSignInTokenOutput {
    signInToken: string | undefined;
    encodedUserId: string | undefined;
    encodedTenantId: string | undefined;
}

export class PagedResultDtoOfGetSettingParamFieldForView implements IPagedResultDtoOfGetSettingParamFieldForView {
    totalCount!: number | undefined;
    items!: GetSettingParamFieldForView[] | undefined;

    constructor(data?: IPagedResultDtoOfGetSettingParamFieldForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetSettingParamFieldForView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetSettingParamFieldForView {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetSettingParamFieldForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetSettingParamFieldForView {
    totalCount: number | undefined;
    items: GetSettingParamFieldForView[] | undefined;
}

export class GetSettingParamFieldForView implements IGetSettingParamFieldForView {
    settingParamField!: SettingParamFieldDto | undefined;

    constructor(data?: IGetSettingParamFieldForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.settingParamField = data["settingParamField"] ? SettingParamFieldDto.fromJS(data["settingParamField"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSettingParamFieldForView {
        data = typeof data === 'object' ? data : {};
        let result = new GetSettingParamFieldForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["settingParamField"] = this.settingParamField ? this.settingParamField.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetSettingParamFieldForView {
    settingParamField: SettingParamFieldDto | undefined;
}

export class GetSettingParamFieldForEditOutput implements IGetSettingParamFieldForEditOutput {
    settingParamField!: CreateOrEditSettingParamFieldDto | undefined;

    constructor(data?: IGetSettingParamFieldForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.settingParamField = data["settingParamField"] ? CreateOrEditSettingParamFieldDto.fromJS(data["settingParamField"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSettingParamFieldForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetSettingParamFieldForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["settingParamField"] = this.settingParamField ? this.settingParamField.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetSettingParamFieldForEditOutput {
    settingParamField: CreateOrEditSettingParamFieldDto | undefined;
}

export class PagedResultDtoOfGetSettingParamForView implements IPagedResultDtoOfGetSettingParamForView {
    totalCount!: number | undefined;
    items!: GetSettingParamForView[] | undefined;

    constructor(data?: IPagedResultDtoOfGetSettingParamForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetSettingParamForView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetSettingParamForView {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetSettingParamForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetSettingParamForView {
    totalCount: number | undefined;
    items: GetSettingParamForView[] | undefined;
}

export class GetSettingParamForView implements IGetSettingParamForView {
    settingParam!: SettingParamDto | undefined;

    constructor(data?: IGetSettingParamForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.settingParam = data["settingParam"] ? SettingParamDto.fromJS(data["settingParam"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSettingParamForView {
        data = typeof data === 'object' ? data : {};
        let result = new GetSettingParamForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["settingParam"] = this.settingParam ? this.settingParam.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetSettingParamForView {
    settingParam: SettingParamDto | undefined;
}

export class GetSettingParamForEditOutput implements IGetSettingParamForEditOutput {
    settingParam!: CreateOrEditSettingParamDto | undefined;

    constructor(data?: IGetSettingParamForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.settingParam = data["settingParam"] ? CreateOrEditSettingParamDto.fromJS(data["settingParam"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSettingParamForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetSettingParamForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["settingParam"] = this.settingParam ? this.settingParam.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetSettingParamForEditOutput {
    settingParam: CreateOrEditSettingParamDto | undefined;
}

export class PagedResultDtoOfGetShopperInfoForViewDto implements IPagedResultDtoOfGetShopperInfoForViewDto {
    totalCount!: number | undefined;
    items!: GetShopperInfoForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetShopperInfoForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetShopperInfoForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetShopperInfoForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetShopperInfoForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetShopperInfoForViewDto {
    totalCount: number | undefined;
    items: GetShopperInfoForViewDto[] | undefined;
}

export class GetShopperInfoForViewDto implements IGetShopperInfoForViewDto {
    shopperInfo!: ShopperInfoDto | undefined;

    constructor(data?: IGetShopperInfoForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.shopperInfo = data["shopperInfo"] ? ShopperInfoDto.fromJS(data["shopperInfo"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetShopperInfoForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetShopperInfoForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shopperInfo"] = this.shopperInfo ? this.shopperInfo.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetShopperInfoForViewDto {
    shopperInfo: ShopperInfoDto | undefined;
}

export class ShopperInfoDto implements IShopperInfoDto {
    memberCode!: string | undefined;
    name!: string | undefined;
    phone!: string | undefined;
    email!: string | undefined;
    gender!: string | undefined;
    birthday!: number | undefined;
    registrationDate!: number | undefined;
    pid!: string | undefined;
    receiveAds!: boolean | undefined;
    rankCode!: string | undefined;
    rankValidDate!: number | undefined;
    currentPoint!: number | undefined;
    nationalityCode!: string | undefined;
    address!: string | undefined;
    ward!: string | undefined;
    district!: string | undefined;
    province!: string | undefined;
    country!: string | undefined;
    status!: string | undefined;
    communicationLanguage!: string | undefined;
    notes!: string | undefined;
    rankPropose!: string | undefined;
    pinCode!: string | undefined;
    nameUnSign!: string | undefined;
    avatar!: string | undefined;
    memberCard!: string | undefined;
    creationTime!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;
    communicationChannels!: SocialShopperMemberChannelInfo[] | undefined;
    rankName!: string | undefined;
    nationalityName!: string | undefined;
    chatId!: string | undefined;
    id!: number | undefined;

    constructor(data?: IShopperInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberCode = data["memberCode"];
            this.name = data["name"];
            this.phone = data["phone"];
            this.email = data["email"];
            this.gender = data["gender"];
            this.birthday = data["birthday"];
            this.registrationDate = data["registrationDate"];
            this.pid = data["pid"];
            this.receiveAds = data["receiveAds"];
            this.rankCode = data["rankCode"];
            this.rankValidDate = data["rankValidDate"];
            this.currentPoint = data["currentPoint"];
            this.nationalityCode = data["nationalityCode"];
            this.address = data["address"];
            this.ward = data["ward"];
            this.district = data["district"];
            this.province = data["province"];
            this.country = data["country"];
            this.status = data["status"];
            this.communicationLanguage = data["communicationLanguage"];
            this.notes = data["notes"];
            this.rankPropose = data["rankPropose"];
            this.pinCode = data["pinCode"];
            this.nameUnSign = data["nameUnSign"];
            this.avatar = data["avatar"];
            this.memberCard = data["memberCard"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            if (data["communicationChannels"] && data["communicationChannels"].constructor === Array) {
                this.communicationChannels = [];
                for (let item of data["communicationChannels"])
                    this.communicationChannels.push(SocialShopperMemberChannelInfo.fromJS(item));
            }
            this.rankName = data["rankName"];
            this.nationalityName = data["nationalityName"];
            this.chatId = data["chatId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ShopperInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ShopperInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberCode"] = this.memberCode;
        data["name"] = this.name;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["gender"] = this.gender;
        data["birthday"] = this.birthday;
        data["registrationDate"] = this.registrationDate;
        data["pid"] = this.pid;
        data["receiveAds"] = this.receiveAds;
        data["rankCode"] = this.rankCode;
        data["rankValidDate"] = this.rankValidDate;
        data["currentPoint"] = this.currentPoint;
        data["nationalityCode"] = this.nationalityCode;
        data["address"] = this.address;
        data["ward"] = this.ward;
        data["district"] = this.district;
        data["province"] = this.province;
        data["country"] = this.country;
        data["status"] = this.status;
        data["communicationLanguage"] = this.communicationLanguage;
        data["notes"] = this.notes;
        data["rankPropose"] = this.rankPropose;
        data["pinCode"] = this.pinCode;
        data["nameUnSign"] = this.nameUnSign;
        data["avatar"] = this.avatar;
        data["memberCard"] = this.memberCard;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        if (this.communicationChannels && this.communicationChannels.constructor === Array) {
            data["communicationChannels"] = [];
            for (let item of this.communicationChannels)
                data["communicationChannels"].push(item.toJSON());
        }
        data["rankName"] = this.rankName;
        data["nationalityName"] = this.nationalityName;
        data["chatId"] = this.chatId;
        data["id"] = this.id;
        return data;
    }
}

export interface IShopperInfoDto {
    memberCode: string | undefined;
    name: string | undefined;
    phone: string | undefined;
    email: string | undefined;
    gender: string | undefined;
    birthday: number | undefined;
    registrationDate: number | undefined;
    pid: string | undefined;
    receiveAds: boolean | undefined;
    rankCode: string | undefined;
    rankValidDate: number | undefined;
    currentPoint: number | undefined;
    nationalityCode: string | undefined;
    address: string | undefined;
    ward: string | undefined;
    district: string | undefined;
    province: string | undefined;
    country: string | undefined;
    status: string | undefined;
    communicationLanguage: string | undefined;
    notes: string | undefined;
    rankPropose: string | undefined;
    pinCode: string | undefined;
    nameUnSign: string | undefined;
    avatar: string | undefined;
    memberCard: string | undefined;
    creationTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    communicationChannels: SocialShopperMemberChannelInfo[] | undefined;
    rankName: string | undefined;
    nationalityName: string | undefined;
    chatId: string | undefined;
    id: number | undefined;
}

export class SocialShopperMemberChannelInfo implements ISocialShopperMemberChannelInfo {
    channelCode!: string | undefined;
    memberChannelId!: string | undefined;
    extraParams!: { [key: string]: string; } | undefined;

    constructor(data?: ISocialShopperMemberChannelInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.channelCode = data["channelCode"];
            this.memberChannelId = data["memberChannelId"];
            if (data["extraParams"]) {
                this.extraParams = {};
                for (let key in data["extraParams"]) {
                    if (data["extraParams"].hasOwnProperty(key))
                        this.extraParams[key] = data["extraParams"][key];
                }
            }
        }
    }

    static fromJS(data: any): SocialShopperMemberChannelInfo {
        data = typeof data === 'object' ? data : {};
        let result = new SocialShopperMemberChannelInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["channelCode"] = this.channelCode;
        data["memberChannelId"] = this.memberChannelId;
        if (this.extraParams) {
            data["extraParams"] = {};
            for (let key in this.extraParams) {
                if (this.extraParams.hasOwnProperty(key))
                    data["extraParams"][key] = this.extraParams[key];
            }
        }
        return data;
    }
}

export interface ISocialShopperMemberChannelInfo {
    channelCode: string | undefined;
    memberChannelId: string | undefined;
    extraParams: { [key: string]: string; } | undefined;
}

export class GetShopperInfoForEditOutput implements IGetShopperInfoForEditOutput {
    shopperInfo!: CreateOrEditShopperInfoDto | undefined;

    constructor(data?: IGetShopperInfoForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.shopperInfo = data["shopperInfo"] ? CreateOrEditShopperInfoDto.fromJS(data["shopperInfo"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetShopperInfoForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetShopperInfoForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shopperInfo"] = this.shopperInfo ? this.shopperInfo.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetShopperInfoForEditOutput {
    shopperInfo: CreateOrEditShopperInfoDto | undefined;
}

export class CreateOrEditShopperInfoDto implements ICreateOrEditShopperInfoDto {
    memberCode!: string | undefined;
    name!: string | undefined;
    phone!: string | undefined;
    email!: string | undefined;
    gender!: string | undefined;
    birthday!: number | undefined;
    registrationDate!: number | undefined;
    pid!: string | undefined;
    receiveAds!: boolean | undefined;
    rankCode!: string | undefined;
    rankValidDate!: number | undefined;
    currentPoint!: number | undefined;
    nationalityCode!: string | undefined;
    address!: string | undefined;
    ward!: string | undefined;
    district!: string | undefined;
    province!: string | undefined;
    country!: string | undefined;
    status!: string | undefined;
    communicationLanguage!: string | undefined;
    notes!: string | undefined;
    rankPropose!: string | undefined;
    pinCode!: string | undefined;
    nameUnSign!: string | undefined;
    avatar!: string | undefined;
    memberCard!: string | undefined;
    referrerCode!: string | undefined;
    communicationChannels!: SocialShopperMemberChannelInfo[] | undefined;
    chatId!: string | undefined;
    lastModificationTime!: moment.Moment | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditShopperInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberCode = data["memberCode"];
            this.name = data["name"];
            this.phone = data["phone"];
            this.email = data["email"];
            this.gender = data["gender"];
            this.birthday = data["birthday"];
            this.registrationDate = data["registrationDate"];
            this.pid = data["pid"];
            this.receiveAds = data["receiveAds"];
            this.rankCode = data["rankCode"];
            this.rankValidDate = data["rankValidDate"];
            this.currentPoint = data["currentPoint"];
            this.nationalityCode = data["nationalityCode"];
            this.address = data["address"];
            this.ward = data["ward"];
            this.district = data["district"];
            this.province = data["province"];
            this.country = data["country"];
            this.status = data["status"];
            this.communicationLanguage = data["communicationLanguage"];
            this.notes = data["notes"];
            this.rankPropose = data["rankPropose"];
            this.pinCode = data["pinCode"];
            this.nameUnSign = data["nameUnSign"];
            this.avatar = data["avatar"];
            this.memberCard = data["memberCard"];
            this.referrerCode = data["referrerCode"];
            if (data["communicationChannels"] && data["communicationChannels"].constructor === Array) {
                this.communicationChannels = [];
                for (let item of data["communicationChannels"])
                    this.communicationChannels.push(SocialShopperMemberChannelInfo.fromJS(item));
            }
            this.chatId = data["chatId"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditShopperInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditShopperInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberCode"] = this.memberCode;
        data["name"] = this.name;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["gender"] = this.gender;
        data["birthday"] = this.birthday;
        data["registrationDate"] = this.registrationDate;
        data["pid"] = this.pid;
        data["receiveAds"] = this.receiveAds;
        data["rankCode"] = this.rankCode;
        data["rankValidDate"] = this.rankValidDate;
        data["currentPoint"] = this.currentPoint;
        data["nationalityCode"] = this.nationalityCode;
        data["address"] = this.address;
        data["ward"] = this.ward;
        data["district"] = this.district;
        data["province"] = this.province;
        data["country"] = this.country;
        data["status"] = this.status;
        data["communicationLanguage"] = this.communicationLanguage;
        data["notes"] = this.notes;
        data["rankPropose"] = this.rankPropose;
        data["pinCode"] = this.pinCode;
        data["nameUnSign"] = this.nameUnSign;
        data["avatar"] = this.avatar;
        data["memberCard"] = this.memberCard;
        data["referrerCode"] = this.referrerCode;
        if (this.communicationChannels && this.communicationChannels.constructor === Array) {
            data["communicationChannels"] = [];
            for (let item of this.communicationChannels)
                data["communicationChannels"].push(item.toJSON());
        }
        data["chatId"] = this.chatId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditShopperInfoDto {
    memberCode: string | undefined;
    name: string | undefined;
    phone: string | undefined;
    email: string | undefined;
    gender: string | undefined;
    birthday: number | undefined;
    registrationDate: number | undefined;
    pid: string | undefined;
    receiveAds: boolean | undefined;
    rankCode: string | undefined;
    rankValidDate: number | undefined;
    currentPoint: number | undefined;
    nationalityCode: string | undefined;
    address: string | undefined;
    ward: string | undefined;
    district: string | undefined;
    province: string | undefined;
    country: string | undefined;
    status: string | undefined;
    communicationLanguage: string | undefined;
    notes: string | undefined;
    rankPropose: string | undefined;
    pinCode: string | undefined;
    nameUnSign: string | undefined;
    avatar: string | undefined;
    memberCard: string | undefined;
    referrerCode: string | undefined;
    communicationChannels: SocialShopperMemberChannelInfo[] | undefined;
    chatId: string | undefined;
    lastModificationTime: moment.Moment | undefined;
    id: number | undefined;
}

export class SocialShopperFileDto implements ISocialShopperFileDto {
    fileName!: string;
    fileType!: string;
    fileToken!: string;

    constructor(data?: ISocialShopperFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.fileName = data["fileName"];
            this.fileType = data["fileType"];
            this.fileToken = data["fileToken"];
        }
    }

    static fromJS(data: any): SocialShopperFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new SocialShopperFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["fileType"] = this.fileType;
        data["fileToken"] = this.fileToken;
        return data;
    }
}

export interface ISocialShopperFileDto {
    fileName: string;
    fileType: string;
    fileToken: string;
}

export class PagedResultDtoOfGetSocialMessageForViewDto implements IPagedResultDtoOfGetSocialMessageForViewDto {
    totalCount!: number | undefined;
    items!: GetSocialMessageForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetSocialMessageForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetSocialMessageForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetSocialMessageForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetSocialMessageForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetSocialMessageForViewDto {
    totalCount: number | undefined;
    items: GetSocialMessageForViewDto[] | undefined;
}

export class GetSocialMessageForViewDto implements IGetSocialMessageForViewDto {
    socialMessage!: SocialMessageDto | undefined;

    constructor(data?: IGetSocialMessageForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.socialMessage = data["socialMessage"] ? SocialMessageDto.fromJS(data["socialMessage"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSocialMessageForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetSocialMessageForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["socialMessage"] = this.socialMessage ? this.socialMessage.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetSocialMessageForViewDto {
    socialMessage: SocialMessageDto | undefined;
}

export class SocialMessageDto implements ISocialMessageDto {
    retailerCode!: string | undefined;
    fromUserID!: string | undefined;
    content!: string | undefined;
    status!: string | undefined;
    messageType!: string | undefined;
    id!: number | undefined;

    constructor(data?: ISocialMessageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.retailerCode = data["retailerCode"];
            this.fromUserID = data["fromUserID"];
            this.content = data["content"];
            this.status = data["status"];
            this.messageType = data["messageType"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SocialMessageDto {
        data = typeof data === 'object' ? data : {};
        let result = new SocialMessageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["retailerCode"] = this.retailerCode;
        data["fromUserID"] = this.fromUserID;
        data["content"] = this.content;
        data["status"] = this.status;
        data["messageType"] = this.messageType;
        data["id"] = this.id;
        return data;
    }
}

export interface ISocialMessageDto {
    retailerCode: string | undefined;
    fromUserID: string | undefined;
    content: string | undefined;
    status: string | undefined;
    messageType: string | undefined;
    id: number | undefined;
}

export class GetSocialMessageForEditOutput implements IGetSocialMessageForEditOutput {
    socialMessage!: CreateOrEditSocialMessageDto | undefined;

    constructor(data?: IGetSocialMessageForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.socialMessage = data["socialMessage"] ? CreateOrEditSocialMessageDto.fromJS(data["socialMessage"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSocialMessageForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetSocialMessageForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["socialMessage"] = this.socialMessage ? this.socialMessage.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetSocialMessageForEditOutput {
    socialMessage: CreateOrEditSocialMessageDto | undefined;
}

export class CreateOrEditSocialMessageDto implements ICreateOrEditSocialMessageDto {
    retailerCode!: string | undefined;
    fromUserID!: string | undefined;
    content!: string | undefined;
    status!: string | undefined;
    messageType!: string | undefined;
    chatID!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditSocialMessageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.retailerCode = data["retailerCode"];
            this.fromUserID = data["fromUserID"];
            this.content = data["content"];
            this.status = data["status"];
            this.messageType = data["messageType"];
            this.chatID = data["chatID"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditSocialMessageDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditSocialMessageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["retailerCode"] = this.retailerCode;
        data["fromUserID"] = this.fromUserID;
        data["content"] = this.content;
        data["status"] = this.status;
        data["messageType"] = this.messageType;
        data["chatID"] = this.chatID;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditSocialMessageDto {
    retailerCode: string | undefined;
    fromUserID: string | undefined;
    content: string | undefined;
    status: string | undefined;
    messageType: string | undefined;
    chatID: string | undefined;
    id: number | undefined;
}

export class GetAllSocialMessagesInput implements IGetAllSocialMessagesInput {
    filter!: string | undefined;
    retailerCodeFilter!: string | undefined;
    fromUserIDFilter!: string | undefined;
    contentFilter!: string | undefined;
    statusFilter!: string | undefined;
    messageTypeFilter!: string | undefined;
    sorting!: string | undefined;
    skipCount!: number | undefined;
    maxResultCount!: number | undefined;

    constructor(data?: IGetAllSocialMessagesInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.filter = data["filter"];
            this.retailerCodeFilter = data["retailerCodeFilter"];
            this.fromUserIDFilter = data["fromUserIDFilter"];
            this.contentFilter = data["contentFilter"];
            this.statusFilter = data["statusFilter"];
            this.messageTypeFilter = data["messageTypeFilter"];
            this.sorting = data["sorting"];
            this.skipCount = data["skipCount"];
            this.maxResultCount = data["maxResultCount"];
        }
    }

    static fromJS(data: any): GetAllSocialMessagesInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllSocialMessagesInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        data["retailerCodeFilter"] = this.retailerCodeFilter;
        data["fromUserIDFilter"] = this.fromUserIDFilter;
        data["contentFilter"] = this.contentFilter;
        data["statusFilter"] = this.statusFilter;
        data["messageTypeFilter"] = this.messageTypeFilter;
        data["sorting"] = this.sorting;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data;
    }
}

export interface IGetAllSocialMessagesInput {
    filter: string | undefined;
    retailerCodeFilter: string | undefined;
    fromUserIDFilter: string | undefined;
    contentFilter: string | undefined;
    statusFilter: string | undefined;
    messageTypeFilter: string | undefined;
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;
}

export class PagedResultDtoOfSocialMessageForView implements IPagedResultDtoOfSocialMessageForView {
    totalCount!: number | undefined;
    items!: SocialMessageForView[] | undefined;

    constructor(data?: IPagedResultDtoOfSocialMessageForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(SocialMessageForView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfSocialMessageForView {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfSocialMessageForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfSocialMessageForView {
    totalCount: number | undefined;
    items: SocialMessageForView[] | undefined;
}

export class SocialMessageForView implements ISocialMessageForView {
    socialMessage!: SocialMessageViewDto | undefined;

    constructor(data?: ISocialMessageForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.socialMessage = data["socialMessage"] ? SocialMessageViewDto.fromJS(data["socialMessage"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SocialMessageForView {
        data = typeof data === 'object' ? data : {};
        let result = new SocialMessageForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["socialMessage"] = this.socialMessage ? this.socialMessage.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISocialMessageForView {
    socialMessage: SocialMessageViewDto | undefined;
}

export class SocialMessageViewDto implements ISocialMessageViewDto {
    retailerCode!: string | undefined;
    name!: string | undefined;
    nameUnsign!: string | undefined;
    fromUserID!: string | undefined;
    content!: string | undefined;
    status!: string | undefined;
    messageType!: string | undefined;
    creationTime!: moment.Moment | undefined;
    unSeen!: number | undefined;
    totalRows!: number | undefined;
    createName!: string | undefined;
    avatar!: string | undefined;
    userID!: string | undefined;
    id!: number | undefined;

    constructor(data?: ISocialMessageViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.retailerCode = data["retailerCode"];
            this.name = data["name"];
            this.nameUnsign = data["nameUnsign"];
            this.fromUserID = data["fromUserID"];
            this.content = data["content"];
            this.status = data["status"];
            this.messageType = data["messageType"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.unSeen = data["unSeen"];
            this.totalRows = data["totalRows"];
            this.createName = data["createName"];
            this.avatar = data["avatar"];
            this.userID = data["userID"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SocialMessageViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new SocialMessageViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["retailerCode"] = this.retailerCode;
        data["name"] = this.name;
        data["nameUnsign"] = this.nameUnsign;
        data["fromUserID"] = this.fromUserID;
        data["content"] = this.content;
        data["status"] = this.status;
        data["messageType"] = this.messageType;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["unSeen"] = this.unSeen;
        data["totalRows"] = this.totalRows;
        data["createName"] = this.createName;
        data["avatar"] = this.avatar;
        data["userID"] = this.userID;
        data["id"] = this.id;
        return data;
    }
}

export interface ISocialMessageViewDto {
    retailerCode: string | undefined;
    name: string | undefined;
    nameUnsign: string | undefined;
    fromUserID: string | undefined;
    content: string | undefined;
    status: string | undefined;
    messageType: string | undefined;
    creationTime: moment.Moment | undefined;
    unSeen: number | undefined;
    totalRows: number | undefined;
    createName: string | undefined;
    avatar: string | undefined;
    userID: string | undefined;
    id: number | undefined;
}

export class GetMessagesInput implements IGetMessagesInput {
    retailerCode!: string | undefined;
    sorting!: string | undefined;
    skipCount!: number | undefined;
    maxResultCount!: number | undefined;

    constructor(data?: IGetMessagesInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.retailerCode = data["retailerCode"];
            this.sorting = data["sorting"];
            this.skipCount = data["skipCount"];
            this.maxResultCount = data["maxResultCount"];
        }
    }

    static fromJS(data: any): GetMessagesInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetMessagesInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["retailerCode"] = this.retailerCode;
        data["sorting"] = this.sorting;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data;
    }
}

export interface IGetMessagesInput {
    retailerCode: string | undefined;
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;
}

export class PagedResultDtoOfMessageDto implements IPagedResultDtoOfMessageDto {
    totalCount!: number | undefined;
    items!: MessageDto[] | undefined;

    constructor(data?: IPagedResultDtoOfMessageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(MessageDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfMessageDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfMessageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfMessageDto {
    totalCount: number | undefined;
    items: MessageDto[] | undefined;
}

export class MessageDto implements IMessageDto {
    retailerCode!: string | undefined;
    fromUserID!: string | undefined;
    content!: string | undefined;
    status!: string | undefined;
    messageType!: string | undefined;
    creationTime!: moment.Moment | undefined;
    creatorUserId!: number | undefined;
    createName!: string | undefined;
    id!: number | undefined;

    constructor(data?: IMessageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.retailerCode = data["retailerCode"];
            this.fromUserID = data["fromUserID"];
            this.content = data["content"];
            this.status = data["status"];
            this.messageType = data["messageType"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.createName = data["createName"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): MessageDto {
        data = typeof data === 'object' ? data : {};
        let result = new MessageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["retailerCode"] = this.retailerCode;
        data["fromUserID"] = this.fromUserID;
        data["content"] = this.content;
        data["status"] = this.status;
        data["messageType"] = this.messageType;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["createName"] = this.createName;
        data["id"] = this.id;
        return data;
    }
}

export interface IMessageDto {
    retailerCode: string | undefined;
    fromUserID: string | undefined;
    content: string | undefined;
    status: string | undefined;
    messageType: string | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    createName: string | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfGetSocialSurveyAnswerForViewDto implements IPagedResultDtoOfGetSocialSurveyAnswerForViewDto {
    totalCount!: number | undefined;
    items!: GetSocialSurveyAnswerForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetSocialSurveyAnswerForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetSocialSurveyAnswerForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetSocialSurveyAnswerForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetSocialSurveyAnswerForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetSocialSurveyAnswerForViewDto {
    totalCount: number | undefined;
    items: GetSocialSurveyAnswerForViewDto[] | undefined;
}

export class GetSocialSurveyAnswerForViewDto implements IGetSocialSurveyAnswerForViewDto {
    surveyAnswer!: SocialSurveyAnswerDto | undefined;

    constructor(data?: IGetSocialSurveyAnswerForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.surveyAnswer = data["surveyAnswer"] ? SocialSurveyAnswerDto.fromJS(data["surveyAnswer"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSocialSurveyAnswerForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetSocialSurveyAnswerForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyAnswer"] = this.surveyAnswer ? this.surveyAnswer.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetSocialSurveyAnswerForViewDto {
    surveyAnswer: SocialSurveyAnswerDto | undefined;
}

export class SocialSurveyAnswerDto implements ISocialSurveyAnswerDto {
    questionCode!: string | undefined;
    content!: string | undefined;
    imageLink!: string | undefined;
    surveyCode!: string | undefined;
    answerCode!: string | undefined;
    id!: number | undefined;

    constructor(data?: ISocialSurveyAnswerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.questionCode = data["questionCode"];
            this.content = data["content"];
            this.imageLink = data["imageLink"];
            this.surveyCode = data["surveyCode"];
            this.answerCode = data["answerCode"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SocialSurveyAnswerDto {
        data = typeof data === 'object' ? data : {};
        let result = new SocialSurveyAnswerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["questionCode"] = this.questionCode;
        data["content"] = this.content;
        data["imageLink"] = this.imageLink;
        data["surveyCode"] = this.surveyCode;
        data["answerCode"] = this.answerCode;
        data["id"] = this.id;
        return data;
    }
}

export interface ISocialSurveyAnswerDto {
    questionCode: string | undefined;
    content: string | undefined;
    imageLink: string | undefined;
    surveyCode: string | undefined;
    answerCode: string | undefined;
    id: number | undefined;
}

export class GetSocialSurveyAnswerForEditOutput implements IGetSocialSurveyAnswerForEditOutput {
    surveyAnswer!: CreateOrEditSocialSurveyAnswerDto | undefined;

    constructor(data?: IGetSocialSurveyAnswerForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.surveyAnswer = data["surveyAnswer"] ? CreateOrEditSocialSurveyAnswerDto.fromJS(data["surveyAnswer"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSocialSurveyAnswerForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetSocialSurveyAnswerForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyAnswer"] = this.surveyAnswer ? this.surveyAnswer.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetSocialSurveyAnswerForEditOutput {
    surveyAnswer: CreateOrEditSocialSurveyAnswerDto | undefined;
}

export class CreateOrEditSocialSurveyAnswerDto implements ICreateOrEditSocialSurveyAnswerDto {
    questionCode!: string | undefined;
    content!: string | undefined;
    imageLink!: string | undefined;
    surveyCode!: string | undefined;
    answerCode!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditSocialSurveyAnswerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.questionCode = data["questionCode"];
            this.content = data["content"];
            this.imageLink = data["imageLink"];
            this.surveyCode = data["surveyCode"];
            this.answerCode = data["answerCode"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditSocialSurveyAnswerDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditSocialSurveyAnswerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["questionCode"] = this.questionCode;
        data["content"] = this.content;
        data["imageLink"] = this.imageLink;
        data["surveyCode"] = this.surveyCode;
        data["answerCode"] = this.answerCode;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditSocialSurveyAnswerDto {
    questionCode: string | undefined;
    content: string | undefined;
    imageLink: string | undefined;
    surveyCode: string | undefined;
    answerCode: string | undefined;
    id: number | undefined;
}

export class SocialSurveyFileDto implements ISocialSurveyFileDto {
    fileName!: string;
    fileType!: string;
    fileToken!: string;

    constructor(data?: ISocialSurveyFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.fileName = data["fileName"];
            this.fileType = data["fileType"];
            this.fileToken = data["fileToken"];
        }
    }

    static fromJS(data: any): SocialSurveyFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new SocialSurveyFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["fileType"] = this.fileType;
        data["fileToken"] = this.fileToken;
        return data;
    }
}

export interface ISocialSurveyFileDto {
    fileName: string;
    fileType: string;
    fileToken: string;
}

export class PagedResultDtoOfGetSocialSurveyInfoForViewDto implements IPagedResultDtoOfGetSocialSurveyInfoForViewDto {
    totalCount!: number | undefined;
    items!: GetSocialSurveyInfoForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetSocialSurveyInfoForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetSocialSurveyInfoForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetSocialSurveyInfoForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetSocialSurveyInfoForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetSocialSurveyInfoForViewDto {
    totalCount: number | undefined;
    items: GetSocialSurveyInfoForViewDto[] | undefined;
}

export class GetSocialSurveyInfoForViewDto implements IGetSocialSurveyInfoForViewDto {
    surveyInfo!: SocialSurveyInfoDto | undefined;
    numberOfResponse!: number | undefined;

    constructor(data?: IGetSocialSurveyInfoForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.surveyInfo = data["surveyInfo"] ? SocialSurveyInfoDto.fromJS(data["surveyInfo"]) : <any>undefined;
            this.numberOfResponse = data["numberOfResponse"];
        }
    }

    static fromJS(data: any): GetSocialSurveyInfoForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetSocialSurveyInfoForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyInfo"] = this.surveyInfo ? this.surveyInfo.toJSON() : <any>undefined;
        data["numberOfResponse"] = this.numberOfResponse;
        return data;
    }
}

export interface IGetSocialSurveyInfoForViewDto {
    surveyInfo: SocialSurveyInfoDto | undefined;
    numberOfResponse: number | undefined;
}

export class SocialSurveyInfoDto implements ISocialSurveyInfoDto {
    code!: string | undefined;
    name!: string | undefined;
    status!: string | undefined;
    targetAudienceID!: number | undefined;
    description!: string | undefined;
    imageLink!: string | undefined;
    isImmediately!: boolean | undefined;
    effectiveFrom!: moment.Moment | undefined;
    effectiveTo!: moment.Moment | undefined;
    occurType!: string | undefined;
    cron!: string | undefined;
    publishTime!: moment.Moment | undefined;
    nameUnSign!: string | undefined;
    targetAudienceType!: string | undefined;
    referenceID!: number | undefined;
    delayTime!: number | undefined;
    id!: number | undefined;

    constructor(data?: ISocialSurveyInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.name = data["name"];
            this.status = data["status"];
            this.targetAudienceID = data["targetAudienceID"];
            this.description = data["description"];
            this.imageLink = data["imageLink"];
            this.isImmediately = data["isImmediately"];
            this.effectiveFrom = data["effectiveFrom"] ? moment(data["effectiveFrom"].toString()) : <any>undefined;
            this.effectiveTo = data["effectiveTo"] ? moment(data["effectiveTo"].toString()) : <any>undefined;
            this.occurType = data["occurType"];
            this.cron = data["cron"];
            this.publishTime = data["publishTime"] ? moment(data["publishTime"].toString()) : <any>undefined;
            this.nameUnSign = data["nameUnSign"];
            this.targetAudienceType = data["targetAudienceType"];
            this.referenceID = data["referenceID"];
            this.delayTime = data["delayTime"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SocialSurveyInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new SocialSurveyInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["status"] = this.status;
        data["targetAudienceID"] = this.targetAudienceID;
        data["description"] = this.description;
        data["imageLink"] = this.imageLink;
        data["isImmediately"] = this.isImmediately;
        data["effectiveFrom"] = this.effectiveFrom ? this.effectiveFrom.toISOString() : <any>undefined;
        data["effectiveTo"] = this.effectiveTo ? this.effectiveTo.toISOString() : <any>undefined;
        data["occurType"] = this.occurType;
        data["cron"] = this.cron;
        data["publishTime"] = this.publishTime ? this.publishTime.toISOString() : <any>undefined;
        data["nameUnSign"] = this.nameUnSign;
        data["targetAudienceType"] = this.targetAudienceType;
        data["referenceID"] = this.referenceID;
        data["delayTime"] = this.delayTime;
        data["id"] = this.id;
        return data;
    }
}

export interface ISocialSurveyInfoDto {
    code: string | undefined;
    name: string | undefined;
    status: string | undefined;
    targetAudienceID: number | undefined;
    description: string | undefined;
    imageLink: string | undefined;
    isImmediately: boolean | undefined;
    effectiveFrom: moment.Moment | undefined;
    effectiveTo: moment.Moment | undefined;
    occurType: string | undefined;
    cron: string | undefined;
    publishTime: moment.Moment | undefined;
    nameUnSign: string | undefined;
    targetAudienceType: string | undefined;
    referenceID: number | undefined;
    delayTime: number | undefined;
    id: number | undefined;
}

export class GetSocialSurveyInfoForEditOutput implements IGetSocialSurveyInfoForEditOutput {
    surveyInfo!: CreateOrEditSocialSurveyInfoDto | undefined;

    constructor(data?: IGetSocialSurveyInfoForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.surveyInfo = data["surveyInfo"] ? CreateOrEditSocialSurveyInfoDto.fromJS(data["surveyInfo"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSocialSurveyInfoForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetSocialSurveyInfoForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyInfo"] = this.surveyInfo ? this.surveyInfo.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetSocialSurveyInfoForEditOutput {
    surveyInfo: CreateOrEditSocialSurveyInfoDto | undefined;
}

export class CreateOrEditSocialSurveyInfoDto implements ICreateOrEditSocialSurveyInfoDto {
    code!: string | undefined;
    name!: string | undefined;
    status!: string | undefined;
    targetAudienceID!: number | undefined;
    description!: string | undefined;
    imageLink!: string | undefined;
    isImmediately!: boolean | undefined;
    effectiveFrom!: moment.Moment | undefined;
    effectiveTo!: moment.Moment | undefined;
    occurType!: string | undefined;
    cron!: string | undefined;
    publishTime!: moment.Moment | undefined;
    nameUnSign!: string | undefined;
    targetAudienceType!: string | undefined;
    referenceID!: number | undefined;
    delayTime!: number | undefined;
    surveyQuestionDto!: CreateOrEditSocialSurveyQuestionDto | undefined;
    surveyAnswerListDto!: CreateOrEditSocialSurveyAnswerDto[] | undefined;
    communicationName!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditSocialSurveyInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.name = data["name"];
            this.status = data["status"];
            this.targetAudienceID = data["targetAudienceID"];
            this.description = data["description"];
            this.imageLink = data["imageLink"];
            this.isImmediately = data["isImmediately"];
            this.effectiveFrom = data["effectiveFrom"] ? moment(data["effectiveFrom"].toString()) : <any>undefined;
            this.effectiveTo = data["effectiveTo"] ? moment(data["effectiveTo"].toString()) : <any>undefined;
            this.occurType = data["occurType"];
            this.cron = data["cron"];
            this.publishTime = data["publishTime"] ? moment(data["publishTime"].toString()) : <any>undefined;
            this.nameUnSign = data["nameUnSign"];
            this.targetAudienceType = data["targetAudienceType"];
            this.referenceID = data["referenceID"];
            this.delayTime = data["delayTime"];
            this.surveyQuestionDto = data["surveyQuestionDto"] ? CreateOrEditSocialSurveyQuestionDto.fromJS(data["surveyQuestionDto"]) : <any>undefined;
            if (data["surveyAnswerListDto"] && data["surveyAnswerListDto"].constructor === Array) {
                this.surveyAnswerListDto = [];
                for (let item of data["surveyAnswerListDto"])
                    this.surveyAnswerListDto.push(CreateOrEditSocialSurveyAnswerDto.fromJS(item));
            }
            this.communicationName = data["communicationName"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditSocialSurveyInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditSocialSurveyInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["status"] = this.status;
        data["targetAudienceID"] = this.targetAudienceID;
        data["description"] = this.description;
        data["imageLink"] = this.imageLink;
        data["isImmediately"] = this.isImmediately;
        data["effectiveFrom"] = this.effectiveFrom ? this.effectiveFrom.toISOString() : <any>undefined;
        data["effectiveTo"] = this.effectiveTo ? this.effectiveTo.toISOString() : <any>undefined;
        data["occurType"] = this.occurType;
        data["cron"] = this.cron;
        data["publishTime"] = this.publishTime ? this.publishTime.toISOString() : <any>undefined;
        data["nameUnSign"] = this.nameUnSign;
        data["targetAudienceType"] = this.targetAudienceType;
        data["referenceID"] = this.referenceID;
        data["delayTime"] = this.delayTime;
        data["surveyQuestionDto"] = this.surveyQuestionDto ? this.surveyQuestionDto.toJSON() : <any>undefined;
        if (this.surveyAnswerListDto && this.surveyAnswerListDto.constructor === Array) {
            data["surveyAnswerListDto"] = [];
            for (let item of this.surveyAnswerListDto)
                data["surveyAnswerListDto"].push(item.toJSON());
        }
        data["communicationName"] = this.communicationName;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditSocialSurveyInfoDto {
    code: string | undefined;
    name: string | undefined;
    status: string | undefined;
    targetAudienceID: number | undefined;
    description: string | undefined;
    imageLink: string | undefined;
    isImmediately: boolean | undefined;
    effectiveFrom: moment.Moment | undefined;
    effectiveTo: moment.Moment | undefined;
    occurType: string | undefined;
    cron: string | undefined;
    publishTime: moment.Moment | undefined;
    nameUnSign: string | undefined;
    targetAudienceType: string | undefined;
    referenceID: number | undefined;
    delayTime: number | undefined;
    surveyQuestionDto: CreateOrEditSocialSurveyQuestionDto | undefined;
    surveyAnswerListDto: CreateOrEditSocialSurveyAnswerDto[] | undefined;
    communicationName: string | undefined;
    id: number | undefined;
}

export class CreateOrEditSocialSurveyQuestionDto implements ICreateOrEditSocialSurveyQuestionDto {
    code!: string | undefined;
    content!: string | undefined;
    surveyCode!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditSocialSurveyQuestionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.content = data["content"];
            this.surveyCode = data["surveyCode"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditSocialSurveyQuestionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditSocialSurveyQuestionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["content"] = this.content;
        data["surveyCode"] = this.surveyCode;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditSocialSurveyQuestionDto {
    code: string | undefined;
    content: string | undefined;
    surveyCode: string | undefined;
    id: number | undefined;
}

export class SocialSurveyInfoAgrs implements ISocialSurveyInfoAgrs {
    surveyId!: number | undefined;
    code!: string | undefined;
    name!: string | undefined;
    status!: string | undefined;
    targetAudienceId!: number | undefined;
    targetAudienceName!: string | undefined;
    description!: string | undefined;
    imageLink!: string | undefined;
    isImmediately!: boolean | undefined;
    effectiveFrom!: moment.Moment | undefined;
    effectiveTo!: moment.Moment | undefined;
    cron!: string | undefined;
    occurType!: string | undefined;
    publishTime!: moment.Moment | undefined;
    targetAudienceType!: string | undefined;
    surveyQuestion!: SocialSurveyQuestionArgs | undefined;
    surveyAnswers!: SocialSurveyAnswerArgs[] | undefined;
    tableName!: string | undefined;
    filePath!: string | undefined;
    fileName!: string | undefined;
    userId!: number | undefined;
    tenantId!: number | undefined;
    currentLanguage!: string | undefined;
    apiUrl!: string | undefined;

    constructor(data?: ISocialSurveyInfoAgrs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.surveyId = data["surveyId"];
            this.code = data["code"];
            this.name = data["name"];
            this.status = data["status"];
            this.targetAudienceId = data["targetAudienceId"];
            this.targetAudienceName = data["targetAudienceName"];
            this.description = data["description"];
            this.imageLink = data["imageLink"];
            this.isImmediately = data["isImmediately"];
            this.effectiveFrom = data["effectiveFrom"] ? moment(data["effectiveFrom"].toString()) : <any>undefined;
            this.effectiveTo = data["effectiveTo"] ? moment(data["effectiveTo"].toString()) : <any>undefined;
            this.cron = data["cron"];
            this.occurType = data["occurType"];
            this.publishTime = data["publishTime"] ? moment(data["publishTime"].toString()) : <any>undefined;
            this.targetAudienceType = data["targetAudienceType"];
            this.surveyQuestion = data["surveyQuestion"] ? SocialSurveyQuestionArgs.fromJS(data["surveyQuestion"]) : <any>undefined;
            if (data["surveyAnswers"] && data["surveyAnswers"].constructor === Array) {
                this.surveyAnswers = [];
                for (let item of data["surveyAnswers"])
                    this.surveyAnswers.push(SocialSurveyAnswerArgs.fromJS(item));
            }
            this.tableName = data["tableName"];
            this.filePath = data["filePath"];
            this.fileName = data["fileName"];
            this.userId = data["userId"];
            this.tenantId = data["tenantId"];
            this.currentLanguage = data["currentLanguage"];
            this.apiUrl = data["apiUrl"];
        }
    }

    static fromJS(data: any): SocialSurveyInfoAgrs {
        data = typeof data === 'object' ? data : {};
        let result = new SocialSurveyInfoAgrs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyId"] = this.surveyId;
        data["code"] = this.code;
        data["name"] = this.name;
        data["status"] = this.status;
        data["targetAudienceId"] = this.targetAudienceId;
        data["targetAudienceName"] = this.targetAudienceName;
        data["description"] = this.description;
        data["imageLink"] = this.imageLink;
        data["isImmediately"] = this.isImmediately;
        data["effectiveFrom"] = this.effectiveFrom ? this.effectiveFrom.toISOString() : <any>undefined;
        data["effectiveTo"] = this.effectiveTo ? this.effectiveTo.toISOString() : <any>undefined;
        data["cron"] = this.cron;
        data["occurType"] = this.occurType;
        data["publishTime"] = this.publishTime ? this.publishTime.toISOString() : <any>undefined;
        data["targetAudienceType"] = this.targetAudienceType;
        data["surveyQuestion"] = this.surveyQuestion ? this.surveyQuestion.toJSON() : <any>undefined;
        if (this.surveyAnswers && this.surveyAnswers.constructor === Array) {
            data["surveyAnswers"] = [];
            for (let item of this.surveyAnswers)
                data["surveyAnswers"].push(item.toJSON());
        }
        data["tableName"] = this.tableName;
        data["filePath"] = this.filePath;
        data["fileName"] = this.fileName;
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["currentLanguage"] = this.currentLanguage;
        data["apiUrl"] = this.apiUrl;
        return data;
    }
}

export interface ISocialSurveyInfoAgrs {
    surveyId: number | undefined;
    code: string | undefined;
    name: string | undefined;
    status: string | undefined;
    targetAudienceId: number | undefined;
    targetAudienceName: string | undefined;
    description: string | undefined;
    imageLink: string | undefined;
    isImmediately: boolean | undefined;
    effectiveFrom: moment.Moment | undefined;
    effectiveTo: moment.Moment | undefined;
    cron: string | undefined;
    occurType: string | undefined;
    publishTime: moment.Moment | undefined;
    targetAudienceType: string | undefined;
    surveyQuestion: SocialSurveyQuestionArgs | undefined;
    surveyAnswers: SocialSurveyAnswerArgs[] | undefined;
    tableName: string | undefined;
    filePath: string | undefined;
    fileName: string | undefined;
    userId: number | undefined;
    tenantId: number | undefined;
    currentLanguage: string | undefined;
    apiUrl: string | undefined;
}

export class SocialSurveyQuestionArgs implements ISocialSurveyQuestionArgs {
    questionId!: number | undefined;
    surveyCode!: string | undefined;
    code!: string | undefined;
    content!: string | undefined;

    constructor(data?: ISocialSurveyQuestionArgs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.questionId = data["questionId"];
            this.surveyCode = data["surveyCode"];
            this.code = data["code"];
            this.content = data["content"];
        }
    }

    static fromJS(data: any): SocialSurveyQuestionArgs {
        data = typeof data === 'object' ? data : {};
        let result = new SocialSurveyQuestionArgs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["questionId"] = this.questionId;
        data["surveyCode"] = this.surveyCode;
        data["code"] = this.code;
        data["content"] = this.content;
        return data;
    }
}

export interface ISocialSurveyQuestionArgs {
    questionId: number | undefined;
    surveyCode: string | undefined;
    code: string | undefined;
    content: string | undefined;
}

export class SocialSurveyAnswerArgs implements ISocialSurveyAnswerArgs {
    answerId!: number | undefined;
    surveyCode!: string | undefined;
    questionCode!: string | undefined;
    content!: string | undefined;
    imageLink!: string | undefined;

    constructor(data?: ISocialSurveyAnswerArgs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.answerId = data["answerId"];
            this.surveyCode = data["surveyCode"];
            this.questionCode = data["questionCode"];
            this.content = data["content"];
            this.imageLink = data["imageLink"];
        }
    }

    static fromJS(data: any): SocialSurveyAnswerArgs {
        data = typeof data === 'object' ? data : {};
        let result = new SocialSurveyAnswerArgs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["answerId"] = this.answerId;
        data["surveyCode"] = this.surveyCode;
        data["questionCode"] = this.questionCode;
        data["content"] = this.content;
        data["imageLink"] = this.imageLink;
        return data;
    }
}

export interface ISocialSurveyAnswerArgs {
    answerId: number | undefined;
    surveyCode: string | undefined;
    questionCode: string | undefined;
    content: string | undefined;
    imageLink: string | undefined;
}

export class GetSocialSurveyTargetAudienceForViewDto implements IGetSocialSurveyTargetAudienceForViewDto {
    surveyTargetAudience!: SocialSurveyTargetAudienceDto | undefined;

    constructor(data?: IGetSocialSurveyTargetAudienceForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.surveyTargetAudience = data["surveyTargetAudience"] ? SocialSurveyTargetAudienceDto.fromJS(data["surveyTargetAudience"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSocialSurveyTargetAudienceForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetSocialSurveyTargetAudienceForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyTargetAudience"] = this.surveyTargetAudience ? this.surveyTargetAudience.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetSocialSurveyTargetAudienceForViewDto {
    surveyTargetAudience: SocialSurveyTargetAudienceDto | undefined;
}

export class SocialSurveyTargetAudienceDto implements ISocialSurveyTargetAudienceDto {
    targetAudienceName!: string | undefined;
    description!: string | undefined;
    status!: string | undefined;
    id!: number | undefined;

    constructor(data?: ISocialSurveyTargetAudienceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.targetAudienceName = data["targetAudienceName"];
            this.description = data["description"];
            this.status = data["status"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SocialSurveyTargetAudienceDto {
        data = typeof data === 'object' ? data : {};
        let result = new SocialSurveyTargetAudienceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["targetAudienceName"] = this.targetAudienceName;
        data["description"] = this.description;
        data["status"] = this.status;
        data["id"] = this.id;
        return data;
    }
}

export interface ISocialSurveyTargetAudienceDto {
    targetAudienceName: string | undefined;
    description: string | undefined;
    status: string | undefined;
    id: number | undefined;
}

export class GetAllSurveyInfosForExcelInputExt implements IGetAllSurveyInfosForExcelInputExt {
    filter!: string | undefined;
    codeFilter!: string | undefined;
    nameFilter!: string | undefined;
    statusFilter!: string | undefined;
    maxTargetAudienceIDFilter!: number | undefined;
    minTargetAudienceIDFilter!: number | undefined;
    descriptionFilter!: string | undefined;
    imageLinkFilter!: string | undefined;
    isImmediatelyFilter!: number | undefined;
    maxEffectiveFromFilter!: moment.Moment | undefined;
    minEffectiveFromFilter!: moment.Moment | undefined;
    maxEffectiveToFilter!: moment.Moment | undefined;
    minEffectiveToFilter!: moment.Moment | undefined;
    occurTypeFilter!: string | undefined;
    cronFilter!: string | undefined;
    maxPublishTimeFilter!: moment.Moment | undefined;
    minPublishTimeFilter!: moment.Moment | undefined;
    sorting!: string | undefined;
    skipCount!: number | undefined;
    maxResultCount!: number | undefined;

    constructor(data?: IGetAllSurveyInfosForExcelInputExt) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.filter = data["filter"];
            this.codeFilter = data["codeFilter"];
            this.nameFilter = data["nameFilter"];
            this.statusFilter = data["statusFilter"];
            this.maxTargetAudienceIDFilter = data["maxTargetAudienceIDFilter"];
            this.minTargetAudienceIDFilter = data["minTargetAudienceIDFilter"];
            this.descriptionFilter = data["descriptionFilter"];
            this.imageLinkFilter = data["imageLinkFilter"];
            this.isImmediatelyFilter = data["isImmediatelyFilter"];
            this.maxEffectiveFromFilter = data["maxEffectiveFromFilter"] ? moment(data["maxEffectiveFromFilter"].toString()) : <any>undefined;
            this.minEffectiveFromFilter = data["minEffectiveFromFilter"] ? moment(data["minEffectiveFromFilter"].toString()) : <any>undefined;
            this.maxEffectiveToFilter = data["maxEffectiveToFilter"] ? moment(data["maxEffectiveToFilter"].toString()) : <any>undefined;
            this.minEffectiveToFilter = data["minEffectiveToFilter"] ? moment(data["minEffectiveToFilter"].toString()) : <any>undefined;
            this.occurTypeFilter = data["occurTypeFilter"];
            this.cronFilter = data["cronFilter"];
            this.maxPublishTimeFilter = data["maxPublishTimeFilter"] ? moment(data["maxPublishTimeFilter"].toString()) : <any>undefined;
            this.minPublishTimeFilter = data["minPublishTimeFilter"] ? moment(data["minPublishTimeFilter"].toString()) : <any>undefined;
            this.sorting = data["sorting"];
            this.skipCount = data["skipCount"];
            this.maxResultCount = data["maxResultCount"];
        }
    }

    static fromJS(data: any): GetAllSurveyInfosForExcelInputExt {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllSurveyInfosForExcelInputExt();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        data["codeFilter"] = this.codeFilter;
        data["nameFilter"] = this.nameFilter;
        data["statusFilter"] = this.statusFilter;
        data["maxTargetAudienceIDFilter"] = this.maxTargetAudienceIDFilter;
        data["minTargetAudienceIDFilter"] = this.minTargetAudienceIDFilter;
        data["descriptionFilter"] = this.descriptionFilter;
        data["imageLinkFilter"] = this.imageLinkFilter;
        data["isImmediatelyFilter"] = this.isImmediatelyFilter;
        data["maxEffectiveFromFilter"] = this.maxEffectiveFromFilter ? this.maxEffectiveFromFilter.toISOString() : <any>undefined;
        data["minEffectiveFromFilter"] = this.minEffectiveFromFilter ? this.minEffectiveFromFilter.toISOString() : <any>undefined;
        data["maxEffectiveToFilter"] = this.maxEffectiveToFilter ? this.maxEffectiveToFilter.toISOString() : <any>undefined;
        data["minEffectiveToFilter"] = this.minEffectiveToFilter ? this.minEffectiveToFilter.toISOString() : <any>undefined;
        data["occurTypeFilter"] = this.occurTypeFilter;
        data["cronFilter"] = this.cronFilter;
        data["maxPublishTimeFilter"] = this.maxPublishTimeFilter ? this.maxPublishTimeFilter.toISOString() : <any>undefined;
        data["minPublishTimeFilter"] = this.minPublishTimeFilter ? this.minPublishTimeFilter.toISOString() : <any>undefined;
        data["sorting"] = this.sorting;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data;
    }
}

export interface IGetAllSurveyInfosForExcelInputExt {
    filter: string | undefined;
    codeFilter: string | undefined;
    nameFilter: string | undefined;
    statusFilter: string | undefined;
    maxTargetAudienceIDFilter: number | undefined;
    minTargetAudienceIDFilter: number | undefined;
    descriptionFilter: string | undefined;
    imageLinkFilter: string | undefined;
    isImmediatelyFilter: number | undefined;
    maxEffectiveFromFilter: moment.Moment | undefined;
    minEffectiveFromFilter: moment.Moment | undefined;
    maxEffectiveToFilter: moment.Moment | undefined;
    minEffectiveToFilter: moment.Moment | undefined;
    occurTypeFilter: string | undefined;
    cronFilter: string | undefined;
    maxPublishTimeFilter: moment.Moment | undefined;
    minPublishTimeFilter: moment.Moment | undefined;
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;
}

export class MessageResultSocialSurvey implements IMessageResultSocialSurvey {
    errors!: MessageErrorSocialSurvey[] | undefined;
    successes!: MessageSuccessSocialSurvey[] | undefined;

    constructor(data?: IMessageResultSocialSurvey) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["errors"] && data["errors"].constructor === Array) {
                this.errors = [];
                for (let item of data["errors"])
                    this.errors.push(MessageErrorSocialSurvey.fromJS(item));
            }
            if (data["successes"] && data["successes"].constructor === Array) {
                this.successes = [];
                for (let item of data["successes"])
                    this.successes.push(MessageSuccessSocialSurvey.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MessageResultSocialSurvey {
        data = typeof data === 'object' ? data : {};
        let result = new MessageResultSocialSurvey();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.errors && this.errors.constructor === Array) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        if (this.successes && this.successes.constructor === Array) {
            data["successes"] = [];
            for (let item of this.successes)
                data["successes"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMessageResultSocialSurvey {
    errors: MessageErrorSocialSurvey[] | undefined;
    successes: MessageSuccessSocialSurvey[] | undefined;
}

export class MessageErrorSocialSurvey implements IMessageErrorSocialSurvey {
    id!: string | undefined;
    message!: string | undefined;

    constructor(data?: IMessageErrorSocialSurvey) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.message = data["message"];
        }
    }

    static fromJS(data: any): MessageErrorSocialSurvey {
        data = typeof data === 'object' ? data : {};
        let result = new MessageErrorSocialSurvey();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["message"] = this.message;
        return data;
    }
}

export interface IMessageErrorSocialSurvey {
    id: string | undefined;
    message: string | undefined;
}

export class MessageSuccessSocialSurvey implements IMessageSuccessSocialSurvey {
    id!: string | undefined;
    message!: string | undefined;

    constructor(data?: IMessageSuccessSocialSurvey) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.message = data["message"];
        }
    }

    static fromJS(data: any): MessageSuccessSocialSurvey {
        data = typeof data === 'object' ? data : {};
        let result = new MessageSuccessSocialSurvey();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["message"] = this.message;
        return data;
    }
}

export interface IMessageSuccessSocialSurvey {
    id: string | undefined;
    message: string | undefined;
}

export class PagedResultDtoOfGetSocialSurveyResponseForViewDto implements IPagedResultDtoOfGetSocialSurveyResponseForViewDto {
    totalCount!: number | undefined;
    items!: GetSocialSurveyResponseForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetSocialSurveyResponseForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetSocialSurveyResponseForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetSocialSurveyResponseForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetSocialSurveyResponseForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetSocialSurveyResponseForViewDto {
    totalCount: number | undefined;
    items: GetSocialSurveyResponseForViewDto[] | undefined;
}

export class GetSocialSurveyResponseForViewDto implements IGetSocialSurveyResponseForViewDto {
    surveyResponse!: SocialSurveyResponseDto | undefined;

    constructor(data?: IGetSocialSurveyResponseForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.surveyResponse = data["surveyResponse"] ? SocialSurveyResponseDto.fromJS(data["surveyResponse"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSocialSurveyResponseForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetSocialSurveyResponseForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyResponse"] = this.surveyResponse ? this.surveyResponse.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetSocialSurveyResponseForViewDto {
    surveyResponse: SocialSurveyResponseDto | undefined;
}

export class SocialSurveyResponseDto implements ISocialSurveyResponseDto {
    surveyCode!: string | undefined;
    channel!: string | undefined;
    memberName!: string | undefined;
    phone!: string | undefined;
    zaloChatID!: string | undefined;
    email!: string | undefined;
    facebookID!: string | undefined;
    memberCode!: string | undefined;
    content!: string | undefined;
    subject!: string | undefined;
    outletCode!: string | undefined;
    questionCode!: string | undefined;
    answerCode!: string | undefined;
    messageID!: string | undefined;
    questionContent!: string | undefined;
    lastModificationTime!: moment.Moment | undefined;
    creationTime!: moment.Moment | undefined;
    id!: number | undefined;

    constructor(data?: ISocialSurveyResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.surveyCode = data["surveyCode"];
            this.channel = data["channel"];
            this.memberName = data["memberName"];
            this.phone = data["phone"];
            this.zaloChatID = data["zaloChatID"];
            this.email = data["email"];
            this.facebookID = data["facebookID"];
            this.memberCode = data["memberCode"];
            this.content = data["content"];
            this.subject = data["subject"];
            this.outletCode = data["outletCode"];
            this.questionCode = data["questionCode"];
            this.answerCode = data["answerCode"];
            this.messageID = data["messageID"];
            this.questionContent = data["questionContent"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SocialSurveyResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new SocialSurveyResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyCode"] = this.surveyCode;
        data["channel"] = this.channel;
        data["memberName"] = this.memberName;
        data["phone"] = this.phone;
        data["zaloChatID"] = this.zaloChatID;
        data["email"] = this.email;
        data["facebookID"] = this.facebookID;
        data["memberCode"] = this.memberCode;
        data["content"] = this.content;
        data["subject"] = this.subject;
        data["outletCode"] = this.outletCode;
        data["questionCode"] = this.questionCode;
        data["answerCode"] = this.answerCode;
        data["messageID"] = this.messageID;
        data["questionContent"] = this.questionContent;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface ISocialSurveyResponseDto {
    surveyCode: string | undefined;
    channel: string | undefined;
    memberName: string | undefined;
    phone: string | undefined;
    zaloChatID: string | undefined;
    email: string | undefined;
    facebookID: string | undefined;
    memberCode: string | undefined;
    content: string | undefined;
    subject: string | undefined;
    outletCode: string | undefined;
    questionCode: string | undefined;
    answerCode: string | undefined;
    messageID: string | undefined;
    questionContent: string | undefined;
    lastModificationTime: moment.Moment | undefined;
    creationTime: moment.Moment | undefined;
    id: number | undefined;
}

export class GetAllSurveyResponsesForInputExt implements IGetAllSurveyResponsesForInputExt {
    surveyId!: number | undefined;
    keywords!: string | undefined;
    sorting!: string | undefined;
    skipCount!: number | undefined;
    maxResultCount!: number | undefined;

    constructor(data?: IGetAllSurveyResponsesForInputExt) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.surveyId = data["surveyId"];
            this.keywords = data["keywords"];
            this.sorting = data["sorting"];
            this.skipCount = data["skipCount"];
            this.maxResultCount = data["maxResultCount"];
        }
    }

    static fromJS(data: any): GetAllSurveyResponsesForInputExt {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllSurveyResponsesForInputExt();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyId"] = this.surveyId;
        data["keywords"] = this.keywords;
        data["sorting"] = this.sorting;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data;
    }
}

export interface IGetAllSurveyResponsesForInputExt {
    surveyId: number | undefined;
    keywords: string | undefined;
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;
}

export class PagedResultDtoOfGetSocialSurveyQuestionForViewDto implements IPagedResultDtoOfGetSocialSurveyQuestionForViewDto {
    totalCount!: number | undefined;
    items!: GetSocialSurveyQuestionForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetSocialSurveyQuestionForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetSocialSurveyQuestionForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetSocialSurveyQuestionForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetSocialSurveyQuestionForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetSocialSurveyQuestionForViewDto {
    totalCount: number | undefined;
    items: GetSocialSurveyQuestionForViewDto[] | undefined;
}

export class GetSocialSurveyQuestionForViewDto implements IGetSocialSurveyQuestionForViewDto {
    surveyQuestion!: SocialSurveyQuestionDto | undefined;

    constructor(data?: IGetSocialSurveyQuestionForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.surveyQuestion = data["surveyQuestion"] ? SocialSurveyQuestionDto.fromJS(data["surveyQuestion"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSocialSurveyQuestionForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetSocialSurveyQuestionForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyQuestion"] = this.surveyQuestion ? this.surveyQuestion.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetSocialSurveyQuestionForViewDto {
    surveyQuestion: SocialSurveyQuestionDto | undefined;
}

export class SocialSurveyQuestionDto implements ISocialSurveyQuestionDto {
    code!: string | undefined;
    content!: string | undefined;
    surveyCode!: string | undefined;
    id!: number | undefined;

    constructor(data?: ISocialSurveyQuestionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.content = data["content"];
            this.surveyCode = data["surveyCode"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SocialSurveyQuestionDto {
        data = typeof data === 'object' ? data : {};
        let result = new SocialSurveyQuestionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["content"] = this.content;
        data["surveyCode"] = this.surveyCode;
        data["id"] = this.id;
        return data;
    }
}

export interface ISocialSurveyQuestionDto {
    code: string | undefined;
    content: string | undefined;
    surveyCode: string | undefined;
    id: number | undefined;
}

export class GetSocialSurveyQuestionForEditOutput implements IGetSocialSurveyQuestionForEditOutput {
    surveyQuestion!: CreateOrEditSocialSurveyQuestionDto | undefined;

    constructor(data?: IGetSocialSurveyQuestionForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.surveyQuestion = data["surveyQuestion"] ? CreateOrEditSocialSurveyQuestionDto.fromJS(data["surveyQuestion"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSocialSurveyQuestionForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetSocialSurveyQuestionForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyQuestion"] = this.surveyQuestion ? this.surveyQuestion.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetSocialSurveyQuestionForEditOutput {
    surveyQuestion: CreateOrEditSocialSurveyQuestionDto | undefined;
}

export class GetSocialSurveyQuestionCustomForViewDto implements IGetSocialSurveyQuestionCustomForViewDto {
    surveyQuestion!: SocialSurveyQuestionCustomDto | undefined;

    constructor(data?: IGetSocialSurveyQuestionCustomForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.surveyQuestion = data["surveyQuestion"] ? SocialSurveyQuestionCustomDto.fromJS(data["surveyQuestion"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSocialSurveyQuestionCustomForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetSocialSurveyQuestionCustomForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyQuestion"] = this.surveyQuestion ? this.surveyQuestion.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetSocialSurveyQuestionCustomForViewDto {
    surveyQuestion: SocialSurveyQuestionCustomDto | undefined;
}

export class SocialSurveyQuestionCustomDto implements ISocialSurveyQuestionCustomDto {
    imageHalf_Link!: string | undefined;
    content!: string | undefined;
    surveyCode!: string | undefined;
    id!: number | undefined;

    constructor(data?: ISocialSurveyQuestionCustomDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.imageHalf_Link = data["imageHalf_Link"];
            this.content = data["content"];
            this.surveyCode = data["surveyCode"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SocialSurveyQuestionCustomDto {
        data = typeof data === 'object' ? data : {};
        let result = new SocialSurveyQuestionCustomDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["imageHalf_Link"] = this.imageHalf_Link;
        data["content"] = this.content;
        data["surveyCode"] = this.surveyCode;
        data["id"] = this.id;
        return data;
    }
}

export interface ISocialSurveyQuestionCustomDto {
    imageHalf_Link: string | undefined;
    content: string | undefined;
    surveyCode: string | undefined;
    id: number | undefined;
}

export class GetSocialSurveyResponseForEditOutput implements IGetSocialSurveyResponseForEditOutput {
    surveyResponse!: CreateOrEditSocialSurveyResponseDto | undefined;

    constructor(data?: IGetSocialSurveyResponseForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.surveyResponse = data["surveyResponse"] ? CreateOrEditSocialSurveyResponseDto.fromJS(data["surveyResponse"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSocialSurveyResponseForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetSocialSurveyResponseForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyResponse"] = this.surveyResponse ? this.surveyResponse.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetSocialSurveyResponseForEditOutput {
    surveyResponse: CreateOrEditSocialSurveyResponseDto | undefined;
}

export class CreateOrEditSocialSurveyResponseDto implements ICreateOrEditSocialSurveyResponseDto {
    surveyCode!: string | undefined;
    channel!: string | undefined;
    memberName!: string | undefined;
    phone!: string | undefined;
    zaloChatID!: string | undefined;
    email!: string | undefined;
    facebookID!: string | undefined;
    memberCode!: string | undefined;
    content!: string | undefined;
    subject!: string | undefined;
    outletCode!: string | undefined;
    questionCode!: string | undefined;
    answerCode!: string | undefined;
    messageID!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditSocialSurveyResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.surveyCode = data["surveyCode"];
            this.channel = data["channel"];
            this.memberName = data["memberName"];
            this.phone = data["phone"];
            this.zaloChatID = data["zaloChatID"];
            this.email = data["email"];
            this.facebookID = data["facebookID"];
            this.memberCode = data["memberCode"];
            this.content = data["content"];
            this.subject = data["subject"];
            this.outletCode = data["outletCode"];
            this.questionCode = data["questionCode"];
            this.answerCode = data["answerCode"];
            this.messageID = data["messageID"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditSocialSurveyResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditSocialSurveyResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyCode"] = this.surveyCode;
        data["channel"] = this.channel;
        data["memberName"] = this.memberName;
        data["phone"] = this.phone;
        data["zaloChatID"] = this.zaloChatID;
        data["email"] = this.email;
        data["facebookID"] = this.facebookID;
        data["memberCode"] = this.memberCode;
        data["content"] = this.content;
        data["subject"] = this.subject;
        data["outletCode"] = this.outletCode;
        data["questionCode"] = this.questionCode;
        data["answerCode"] = this.answerCode;
        data["messageID"] = this.messageID;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditSocialSurveyResponseDto {
    surveyCode: string | undefined;
    channel: string | undefined;
    memberName: string | undefined;
    phone: string | undefined;
    zaloChatID: string | undefined;
    email: string | undefined;
    facebookID: string | undefined;
    memberCode: string | undefined;
    content: string | undefined;
    subject: string | undefined;
    outletCode: string | undefined;
    questionCode: string | undefined;
    answerCode: string | undefined;
    messageID: string | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfGetSocialSurveyTargetAudienceDetailForViewDto implements IPagedResultDtoOfGetSocialSurveyTargetAudienceDetailForViewDto {
    totalCount!: number | undefined;
    items!: GetSocialSurveyTargetAudienceDetailForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetSocialSurveyTargetAudienceDetailForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetSocialSurveyTargetAudienceDetailForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetSocialSurveyTargetAudienceDetailForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetSocialSurveyTargetAudienceDetailForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetSocialSurveyTargetAudienceDetailForViewDto {
    totalCount: number | undefined;
    items: GetSocialSurveyTargetAudienceDetailForViewDto[] | undefined;
}

export class GetSocialSurveyTargetAudienceDetailForViewDto implements IGetSocialSurveyTargetAudienceDetailForViewDto {
    surveyTargetAudienceDetail!: SocialSurveyTargetAudienceDetailDto | undefined;

    constructor(data?: IGetSocialSurveyTargetAudienceDetailForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.surveyTargetAudienceDetail = data["surveyTargetAudienceDetail"] ? SocialSurveyTargetAudienceDetailDto.fromJS(data["surveyTargetAudienceDetail"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSocialSurveyTargetAudienceDetailForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetSocialSurveyTargetAudienceDetailForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyTargetAudienceDetail"] = this.surveyTargetAudienceDetail ? this.surveyTargetAudienceDetail.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetSocialSurveyTargetAudienceDetailForViewDto {
    surveyTargetAudienceDetail: SocialSurveyTargetAudienceDetailDto | undefined;
}

export class SocialSurveyTargetAudienceDetailDto implements ISocialSurveyTargetAudienceDetailDto {
    surveyTargetAudienceID!: number | undefined;
    name!: string | undefined;
    phone!: string | undefined;
    zaloChatID!: string | undefined;
    email!: string | undefined;
    facebookID!: string | undefined;
    memberCode!: string | undefined;
    communicationLanguage!: string | undefined;
    communicationChannel!: string | undefined;
    outletCode!: string | undefined;
    id!: number | undefined;

    constructor(data?: ISocialSurveyTargetAudienceDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.surveyTargetAudienceID = data["surveyTargetAudienceID"];
            this.name = data["name"];
            this.phone = data["phone"];
            this.zaloChatID = data["zaloChatID"];
            this.email = data["email"];
            this.facebookID = data["facebookID"];
            this.memberCode = data["memberCode"];
            this.communicationLanguage = data["communicationLanguage"];
            this.communicationChannel = data["communicationChannel"];
            this.outletCode = data["outletCode"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SocialSurveyTargetAudienceDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new SocialSurveyTargetAudienceDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyTargetAudienceID"] = this.surveyTargetAudienceID;
        data["name"] = this.name;
        data["phone"] = this.phone;
        data["zaloChatID"] = this.zaloChatID;
        data["email"] = this.email;
        data["facebookID"] = this.facebookID;
        data["memberCode"] = this.memberCode;
        data["communicationLanguage"] = this.communicationLanguage;
        data["communicationChannel"] = this.communicationChannel;
        data["outletCode"] = this.outletCode;
        data["id"] = this.id;
        return data;
    }
}

export interface ISocialSurveyTargetAudienceDetailDto {
    surveyTargetAudienceID: number | undefined;
    name: string | undefined;
    phone: string | undefined;
    zaloChatID: string | undefined;
    email: string | undefined;
    facebookID: string | undefined;
    memberCode: string | undefined;
    communicationLanguage: string | undefined;
    communicationChannel: string | undefined;
    outletCode: string | undefined;
    id: number | undefined;
}

export class GetSocialSurveyTargetAudienceDetailForEditOutput implements IGetSocialSurveyTargetAudienceDetailForEditOutput {
    surveyTargetAudienceDetail!: CreateOrEditSocialSurveyTargetAudienceDetailDto | undefined;

    constructor(data?: IGetSocialSurveyTargetAudienceDetailForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.surveyTargetAudienceDetail = data["surveyTargetAudienceDetail"] ? CreateOrEditSocialSurveyTargetAudienceDetailDto.fromJS(data["surveyTargetAudienceDetail"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSocialSurveyTargetAudienceDetailForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetSocialSurveyTargetAudienceDetailForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyTargetAudienceDetail"] = this.surveyTargetAudienceDetail ? this.surveyTargetAudienceDetail.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetSocialSurveyTargetAudienceDetailForEditOutput {
    surveyTargetAudienceDetail: CreateOrEditSocialSurveyTargetAudienceDetailDto | undefined;
}

export class CreateOrEditSocialSurveyTargetAudienceDetailDto implements ICreateOrEditSocialSurveyTargetAudienceDetailDto {
    surveyTargetAudienceID!: number | undefined;
    name!: string | undefined;
    phone!: string | undefined;
    zaloChatID!: string | undefined;
    email!: string | undefined;
    facebookID!: string | undefined;
    memberCode!: string | undefined;
    communicationLanguage!: string | undefined;
    communicationChannel!: string | undefined;
    outletCode!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditSocialSurveyTargetAudienceDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.surveyTargetAudienceID = data["surveyTargetAudienceID"];
            this.name = data["name"];
            this.phone = data["phone"];
            this.zaloChatID = data["zaloChatID"];
            this.email = data["email"];
            this.facebookID = data["facebookID"];
            this.memberCode = data["memberCode"];
            this.communicationLanguage = data["communicationLanguage"];
            this.communicationChannel = data["communicationChannel"];
            this.outletCode = data["outletCode"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditSocialSurveyTargetAudienceDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditSocialSurveyTargetAudienceDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyTargetAudienceID"] = this.surveyTargetAudienceID;
        data["name"] = this.name;
        data["phone"] = this.phone;
        data["zaloChatID"] = this.zaloChatID;
        data["email"] = this.email;
        data["facebookID"] = this.facebookID;
        data["memberCode"] = this.memberCode;
        data["communicationLanguage"] = this.communicationLanguage;
        data["communicationChannel"] = this.communicationChannel;
        data["outletCode"] = this.outletCode;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditSocialSurveyTargetAudienceDetailDto {
    surveyTargetAudienceID: number | undefined;
    name: string | undefined;
    phone: string | undefined;
    zaloChatID: string | undefined;
    email: string | undefined;
    facebookID: string | undefined;
    memberCode: string | undefined;
    communicationLanguage: string | undefined;
    communicationChannel: string | undefined;
    outletCode: string | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfGetSocialSurveyTargetAudienceForViewDto implements IPagedResultDtoOfGetSocialSurveyTargetAudienceForViewDto {
    totalCount!: number | undefined;
    items!: GetSocialSurveyTargetAudienceForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetSocialSurveyTargetAudienceForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetSocialSurveyTargetAudienceForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetSocialSurveyTargetAudienceForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetSocialSurveyTargetAudienceForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetSocialSurveyTargetAudienceForViewDto {
    totalCount: number | undefined;
    items: GetSocialSurveyTargetAudienceForViewDto[] | undefined;
}

export class GetSocialSurveyTargetAudienceForEditOutput implements IGetSocialSurveyTargetAudienceForEditOutput {
    surveyTargetAudience!: CreateOrEditSocialSurveyTargetAudienceDto | undefined;

    constructor(data?: IGetSocialSurveyTargetAudienceForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.surveyTargetAudience = data["surveyTargetAudience"] ? CreateOrEditSocialSurveyTargetAudienceDto.fromJS(data["surveyTargetAudience"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSocialSurveyTargetAudienceForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetSocialSurveyTargetAudienceForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyTargetAudience"] = this.surveyTargetAudience ? this.surveyTargetAudience.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetSocialSurveyTargetAudienceForEditOutput {
    surveyTargetAudience: CreateOrEditSocialSurveyTargetAudienceDto | undefined;
}

export class CreateOrEditSocialSurveyTargetAudienceDto implements ICreateOrEditSocialSurveyTargetAudienceDto {
    targetAudienceName!: string | undefined;
    description!: string | undefined;
    status!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditSocialSurveyTargetAudienceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.targetAudienceName = data["targetAudienceName"];
            this.description = data["description"];
            this.status = data["status"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditSocialSurveyTargetAudienceDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditSocialSurveyTargetAudienceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["targetAudienceName"] = this.targetAudienceName;
        data["description"] = this.description;
        data["status"] = this.status;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditSocialSurveyTargetAudienceDto {
    targetAudienceName: string | undefined;
    description: string | undefined;
    status: string | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfGetSpecialSettingForView implements IPagedResultDtoOfGetSpecialSettingForView {
    totalCount!: number | undefined;
    items!: GetSpecialSettingForView[] | undefined;

    constructor(data?: IPagedResultDtoOfGetSpecialSettingForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetSpecialSettingForView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetSpecialSettingForView {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetSpecialSettingForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetSpecialSettingForView {
    totalCount: number | undefined;
    items: GetSpecialSettingForView[] | undefined;
}

export class GetSpecialSettingForView implements IGetSpecialSettingForView {
    specialSetting!: SpecialSettingDto | undefined;

    constructor(data?: IGetSpecialSettingForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.specialSetting = data["specialSetting"] ? SpecialSettingDto.fromJS(data["specialSetting"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSpecialSettingForView {
        data = typeof data === 'object' ? data : {};
        let result = new GetSpecialSettingForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["specialSetting"] = this.specialSetting ? this.specialSetting.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetSpecialSettingForView {
    specialSetting: SpecialSettingDto | undefined;
}

export class SpecialSettingDto implements ISpecialSettingDto {
    code!: string | undefined;
    name!: string | undefined;
    type!: SpecialSettingDtoType | undefined;
    description!: string | undefined;
    coinValue!: number | undefined;
    pointValue!: number | undefined;
    effectiveFrom!: moment.Moment | undefined;
    effectiveTo!: moment.Moment | undefined;
    date!: moment.Moment | undefined;
    cron!: string | undefined;
    occurType!: SpecialSettingDtoOccurType | undefined;
    isActive!: boolean | undefined;
    timeZone!: string | undefined;
    campaignId!: number | undefined;
    targetAudienceId!: number | undefined;
    targetAudience!: SettingParamDto | undefined;
    targetAudienceCode!: string | undefined;
    id!: number | undefined;

    constructor(data?: ISpecialSettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.name = data["name"];
            this.type = data["type"];
            this.description = data["description"];
            this.coinValue = data["coinValue"];
            this.pointValue = data["pointValue"];
            this.effectiveFrom = data["effectiveFrom"] ? moment(data["effectiveFrom"].toString()) : <any>undefined;
            this.effectiveTo = data["effectiveTo"] ? moment(data["effectiveTo"].toString()) : <any>undefined;
            this.date = data["date"] ? moment(data["date"].toString()) : <any>undefined;
            this.cron = data["cron"];
            this.occurType = data["occurType"];
            this.isActive = data["isActive"];
            this.timeZone = data["timeZone"];
            this.campaignId = data["campaignId"];
            this.targetAudienceId = data["targetAudienceId"];
            this.targetAudience = data["targetAudience"] ? SettingParamDto.fromJS(data["targetAudience"]) : <any>undefined;
            this.targetAudienceCode = data["targetAudienceCode"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SpecialSettingDto {
        data = typeof data === 'object' ? data : {};
        let result = new SpecialSettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["type"] = this.type;
        data["description"] = this.description;
        data["coinValue"] = this.coinValue;
        data["pointValue"] = this.pointValue;
        data["effectiveFrom"] = this.effectiveFrom ? this.effectiveFrom.toISOString() : <any>undefined;
        data["effectiveTo"] = this.effectiveTo ? this.effectiveTo.toISOString() : <any>undefined;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["cron"] = this.cron;
        data["occurType"] = this.occurType;
        data["isActive"] = this.isActive;
        data["timeZone"] = this.timeZone;
        data["campaignId"] = this.campaignId;
        data["targetAudienceId"] = this.targetAudienceId;
        data["targetAudience"] = this.targetAudience ? this.targetAudience.toJSON() : <any>undefined;
        data["targetAudienceCode"] = this.targetAudienceCode;
        data["id"] = this.id;
        return data;
    }
}

export interface ISpecialSettingDto {
    code: string | undefined;
    name: string | undefined;
    type: SpecialSettingDtoType | undefined;
    description: string | undefined;
    coinValue: number | undefined;
    pointValue: number | undefined;
    effectiveFrom: moment.Moment | undefined;
    effectiveTo: moment.Moment | undefined;
    date: moment.Moment | undefined;
    cron: string | undefined;
    occurType: SpecialSettingDtoOccurType | undefined;
    isActive: boolean | undefined;
    timeZone: string | undefined;
    campaignId: number | undefined;
    targetAudienceId: number | undefined;
    targetAudience: SettingParamDto | undefined;
    targetAudienceCode: string | undefined;
    id: number | undefined;
}

export class GetSpecialSettingForEditOutput implements IGetSpecialSettingForEditOutput {
    specialSetting!: CreateOrEditSpecialSettingDto | undefined;

    constructor(data?: IGetSpecialSettingForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.specialSetting = data["specialSetting"] ? CreateOrEditSpecialSettingDto.fromJS(data["specialSetting"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSpecialSettingForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetSpecialSettingForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["specialSetting"] = this.specialSetting ? this.specialSetting.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetSpecialSettingForEditOutput {
    specialSetting: CreateOrEditSpecialSettingDto | undefined;
}

export class PagedResultDtoOfGetSubmittedSOForViewDto implements IPagedResultDtoOfGetSubmittedSOForViewDto {
    totalCount!: number | undefined;
    items!: GetSubmittedSOForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetSubmittedSOForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetSubmittedSOForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetSubmittedSOForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetSubmittedSOForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetSubmittedSOForViewDto {
    totalCount: number | undefined;
    items: GetSubmittedSOForViewDto[] | undefined;
}

export class GetSubmittedSOForViewDto implements IGetSubmittedSOForViewDto {
    submittedSO!: SubmittedSODto | undefined;

    constructor(data?: IGetSubmittedSOForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.submittedSO = data["submittedSO"] ? SubmittedSODto.fromJS(data["submittedSO"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSubmittedSOForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetSubmittedSOForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["submittedSO"] = this.submittedSO ? this.submittedSO.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetSubmittedSOForViewDto {
    submittedSO: SubmittedSODto | undefined;
}

export class SubmittedSODto implements ISubmittedSODto {
    chatID!: string | undefined;
    memberCode!: string | undefined;
    phone!: string | undefined;
    postingDate!: moment.Moment | undefined;
    soCode!: string | undefined;
    status!: string | undefined;
    topupAmount!: number | undefined;
    id!: number | undefined;

    constructor(data?: ISubmittedSODto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.chatID = data["chatID"];
            this.memberCode = data["memberCode"];
            this.phone = data["phone"];
            this.postingDate = data["postingDate"] ? moment(data["postingDate"].toString()) : <any>undefined;
            this.soCode = data["soCode"];
            this.status = data["status"];
            this.topupAmount = data["topupAmount"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SubmittedSODto {
        data = typeof data === 'object' ? data : {};
        let result = new SubmittedSODto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["chatID"] = this.chatID;
        data["memberCode"] = this.memberCode;
        data["phone"] = this.phone;
        data["postingDate"] = this.postingDate ? this.postingDate.toISOString() : <any>undefined;
        data["soCode"] = this.soCode;
        data["status"] = this.status;
        data["topupAmount"] = this.topupAmount;
        data["id"] = this.id;
        return data;
    }
}

export interface ISubmittedSODto {
    chatID: string | undefined;
    memberCode: string | undefined;
    phone: string | undefined;
    postingDate: moment.Moment | undefined;
    soCode: string | undefined;
    status: string | undefined;
    topupAmount: number | undefined;
    id: number | undefined;
}

export class GetSubmittedSOForEditOutput implements IGetSubmittedSOForEditOutput {
    submittedSO!: CreateOrEditSubmittedSODto | undefined;

    constructor(data?: IGetSubmittedSOForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.submittedSO = data["submittedSO"] ? CreateOrEditSubmittedSODto.fromJS(data["submittedSO"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSubmittedSOForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetSubmittedSOForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["submittedSO"] = this.submittedSO ? this.submittedSO.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetSubmittedSOForEditOutput {
    submittedSO: CreateOrEditSubmittedSODto | undefined;
}

export class CreateOrEditSubmittedSODto implements ICreateOrEditSubmittedSODto {
    chatID!: string | undefined;
    memberCode!: string | undefined;
    phone!: string | undefined;
    postingDate!: moment.Moment | undefined;
    soCode!: string | undefined;
    status!: string | undefined;
    topupAmount!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditSubmittedSODto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.chatID = data["chatID"];
            this.memberCode = data["memberCode"];
            this.phone = data["phone"];
            this.postingDate = data["postingDate"] ? moment(data["postingDate"].toString()) : <any>undefined;
            this.soCode = data["soCode"];
            this.status = data["status"];
            this.topupAmount = data["topupAmount"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditSubmittedSODto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditSubmittedSODto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["chatID"] = this.chatID;
        data["memberCode"] = this.memberCode;
        data["phone"] = this.phone;
        data["postingDate"] = this.postingDate ? this.postingDate.toISOString() : <any>undefined;
        data["soCode"] = this.soCode;
        data["status"] = this.status;
        data["topupAmount"] = this.topupAmount;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditSubmittedSODto {
    chatID: string | undefined;
    memberCode: string | undefined;
    phone: string | undefined;
    postingDate: moment.Moment | undefined;
    soCode: string | undefined;
    status: string | undefined;
    topupAmount: number | undefined;
    id: number | undefined;
}

export class PurchaseTransactionDtoExt implements IPurchaseTransactionDtoExt {
    purchaseTransaction!: PurchaseTransactionDto | undefined;
    submittedSO!: SubmittedSOIntegrationDto | undefined;
    customerPhone!: string | undefined;
    tenantId!: number | undefined;

    constructor(data?: IPurchaseTransactionDtoExt) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.purchaseTransaction = data["purchaseTransaction"] ? PurchaseTransactionDto.fromJS(data["purchaseTransaction"]) : <any>undefined;
            this.submittedSO = data["submittedSO"] ? SubmittedSOIntegrationDto.fromJS(data["submittedSO"]) : <any>undefined;
            this.customerPhone = data["customerPhone"];
            this.tenantId = data["tenantId"];
        }
    }

    static fromJS(data: any): PurchaseTransactionDtoExt {
        data = typeof data === 'object' ? data : {};
        let result = new PurchaseTransactionDtoExt();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["purchaseTransaction"] = this.purchaseTransaction ? this.purchaseTransaction.toJSON() : <any>undefined;
        data["submittedSO"] = this.submittedSO ? this.submittedSO.toJSON() : <any>undefined;
        data["customerPhone"] = this.customerPhone;
        data["tenantId"] = this.tenantId;
        return data;
    }
}

export interface IPurchaseTransactionDtoExt {
    purchaseTransaction: PurchaseTransactionDto | undefined;
    submittedSO: SubmittedSOIntegrationDto | undefined;
    customerPhone: string | undefined;
    tenantId: number | undefined;
}

export class SubmittedSOIntegrationDto implements ISubmittedSOIntegrationDto {
    chatID!: string | undefined;
    memberCode!: string | undefined;
    phone!: string | undefined;
    postingDate!: moment.Moment | undefined;
    soCode!: string | undefined;
    status!: string | undefined;
    tenantId!: number | undefined;
    topupAmount!: number | undefined;
    promotionMasterCode!: string | undefined;

    constructor(data?: ISubmittedSOIntegrationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.chatID = data["chatID"];
            this.memberCode = data["memberCode"];
            this.phone = data["phone"];
            this.postingDate = data["postingDate"] ? moment(data["postingDate"].toString()) : <any>undefined;
            this.soCode = data["soCode"];
            this.status = data["status"];
            this.tenantId = data["tenantId"];
            this.topupAmount = data["topupAmount"];
            this.promotionMasterCode = data["promotionMasterCode"];
        }
    }

    static fromJS(data: any): SubmittedSOIntegrationDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubmittedSOIntegrationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["chatID"] = this.chatID;
        data["memberCode"] = this.memberCode;
        data["phone"] = this.phone;
        data["postingDate"] = this.postingDate ? this.postingDate.toISOString() : <any>undefined;
        data["soCode"] = this.soCode;
        data["status"] = this.status;
        data["tenantId"] = this.tenantId;
        data["topupAmount"] = this.topupAmount;
        data["promotionMasterCode"] = this.promotionMasterCode;
        return data;
    }
}

export interface ISubmittedSOIntegrationDto {
    chatID: string | undefined;
    memberCode: string | undefined;
    phone: string | undefined;
    postingDate: moment.Moment | undefined;
    soCode: string | undefined;
    status: string | undefined;
    tenantId: number | undefined;
    topupAmount: number | undefined;
    promotionMasterCode: string | undefined;
}

export class PagedResultDtoOfGetSurveyAnswerForViewDto implements IPagedResultDtoOfGetSurveyAnswerForViewDto {
    totalCount!: number | undefined;
    items!: GetSurveyAnswerForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetSurveyAnswerForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetSurveyAnswerForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetSurveyAnswerForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetSurveyAnswerForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetSurveyAnswerForViewDto {
    totalCount: number | undefined;
    items: GetSurveyAnswerForViewDto[] | undefined;
}

export class GetSurveyAnswerForViewDto implements IGetSurveyAnswerForViewDto {
    surveyAnswer!: SurveyAnswerDto | undefined;

    constructor(data?: IGetSurveyAnswerForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.surveyAnswer = data["surveyAnswer"] ? SurveyAnswerDto.fromJS(data["surveyAnswer"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSurveyAnswerForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetSurveyAnswerForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyAnswer"] = this.surveyAnswer ? this.surveyAnswer.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetSurveyAnswerForViewDto {
    surveyAnswer: SurveyAnswerDto | undefined;
}

export class SurveyAnswerDto implements ISurveyAnswerDto {
    questionCode!: string | undefined;
    contentVN!: string | undefined;
    imageLink!: string | undefined;
    surveyCode!: string | undefined;
    answerCode!: string | undefined;
    contentEN!: string | undefined;
    id!: number | undefined;

    constructor(data?: ISurveyAnswerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.questionCode = data["questionCode"];
            this.contentVN = data["contentVN"];
            this.imageLink = data["imageLink"];
            this.surveyCode = data["surveyCode"];
            this.answerCode = data["answerCode"];
            this.contentEN = data["contentEN"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SurveyAnswerDto {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyAnswerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["questionCode"] = this.questionCode;
        data["contentVN"] = this.contentVN;
        data["imageLink"] = this.imageLink;
        data["surveyCode"] = this.surveyCode;
        data["answerCode"] = this.answerCode;
        data["contentEN"] = this.contentEN;
        data["id"] = this.id;
        return data;
    }
}

export interface ISurveyAnswerDto {
    questionCode: string | undefined;
    contentVN: string | undefined;
    imageLink: string | undefined;
    surveyCode: string | undefined;
    answerCode: string | undefined;
    contentEN: string | undefined;
    id: number | undefined;
}

export class GetSurveyAnswerForEditOutput implements IGetSurveyAnswerForEditOutput {
    surveyAnswer!: CreateOrEditSurveyAnswerDto | undefined;

    constructor(data?: IGetSurveyAnswerForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.surveyAnswer = data["surveyAnswer"] ? CreateOrEditSurveyAnswerDto.fromJS(data["surveyAnswer"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSurveyAnswerForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetSurveyAnswerForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyAnswer"] = this.surveyAnswer ? this.surveyAnswer.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetSurveyAnswerForEditOutput {
    surveyAnswer: CreateOrEditSurveyAnswerDto | undefined;
}

export class CreateOrEditSurveyAnswerDto implements ICreateOrEditSurveyAnswerDto {
    questionCode!: string | undefined;
    contentVN!: string | undefined;
    imageLink!: string | undefined;
    surveyCode!: string | undefined;
    answerCode!: string | undefined;
    contentEN!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditSurveyAnswerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.questionCode = data["questionCode"];
            this.contentVN = data["contentVN"];
            this.imageLink = data["imageLink"];
            this.surveyCode = data["surveyCode"];
            this.answerCode = data["answerCode"];
            this.contentEN = data["contentEN"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditSurveyAnswerDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditSurveyAnswerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["questionCode"] = this.questionCode;
        data["contentVN"] = this.contentVN;
        data["imageLink"] = this.imageLink;
        data["surveyCode"] = this.surveyCode;
        data["answerCode"] = this.answerCode;
        data["contentEN"] = this.contentEN;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditSurveyAnswerDto {
    questionCode: string | undefined;
    contentVN: string | undefined;
    imageLink: string | undefined;
    surveyCode: string | undefined;
    answerCode: string | undefined;
    contentEN: string | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfGetSurveyInfoForViewDto implements IPagedResultDtoOfGetSurveyInfoForViewDto {
    totalCount!: number | undefined;
    items!: GetSurveyInfoForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetSurveyInfoForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetSurveyInfoForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetSurveyInfoForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetSurveyInfoForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetSurveyInfoForViewDto {
    totalCount: number | undefined;
    items: GetSurveyInfoForViewDto[] | undefined;
}

export class GetSurveyInfoForViewDto implements IGetSurveyInfoForViewDto {
    surveyInfo!: SurveyInfoDto | undefined;
    status!: string | undefined;

    constructor(data?: IGetSurveyInfoForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.surveyInfo = data["surveyInfo"] ? SurveyInfoDto.fromJS(data["surveyInfo"]) : <any>undefined;
            this.status = data["status"];
        }
    }

    static fromJS(data: any): GetSurveyInfoForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetSurveyInfoForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyInfo"] = this.surveyInfo ? this.surveyInfo.toJSON() : <any>undefined;
        data["status"] = this.status;
        return data;
    }
}

export interface IGetSurveyInfoForViewDto {
    surveyInfo: SurveyInfoDto | undefined;
    status: string | undefined;
}

export class SurveyInfoDto implements ISurveyInfoDto {
    code!: string | undefined;
    name!: string | undefined;
    status!: string | undefined;
    targetAudienceID!: number | undefined;
    descriptionVN!: string | undefined;
    imageLink!: string | undefined;
    isImmediately!: boolean | undefined;
    effectiveFrom!: moment.Moment | undefined;
    effectiveTo!: moment.Moment | undefined;
    occurType!: string | undefined;
    cron!: string | undefined;
    publishTime!: moment.Moment | undefined;
    channel!: string | undefined;
    descriptionEN!: string | undefined;
    targetAudienceType!: string | undefined;
    lastModificationTime!: moment.Moment | undefined;
    creationTime!: moment.Moment | undefined;
    id!: number | undefined;

    constructor(data?: ISurveyInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.name = data["name"];
            this.status = data["status"];
            this.targetAudienceID = data["targetAudienceID"];
            this.descriptionVN = data["descriptionVN"];
            this.imageLink = data["imageLink"];
            this.isImmediately = data["isImmediately"];
            this.effectiveFrom = data["effectiveFrom"] ? moment(data["effectiveFrom"].toString()) : <any>undefined;
            this.effectiveTo = data["effectiveTo"] ? moment(data["effectiveTo"].toString()) : <any>undefined;
            this.occurType = data["occurType"];
            this.cron = data["cron"];
            this.publishTime = data["publishTime"] ? moment(data["publishTime"].toString()) : <any>undefined;
            this.channel = data["channel"];
            this.descriptionEN = data["descriptionEN"];
            this.targetAudienceType = data["targetAudienceType"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SurveyInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["status"] = this.status;
        data["targetAudienceID"] = this.targetAudienceID;
        data["descriptionVN"] = this.descriptionVN;
        data["imageLink"] = this.imageLink;
        data["isImmediately"] = this.isImmediately;
        data["effectiveFrom"] = this.effectiveFrom ? this.effectiveFrom.toISOString() : <any>undefined;
        data["effectiveTo"] = this.effectiveTo ? this.effectiveTo.toISOString() : <any>undefined;
        data["occurType"] = this.occurType;
        data["cron"] = this.cron;
        data["publishTime"] = this.publishTime ? this.publishTime.toISOString() : <any>undefined;
        data["channel"] = this.channel;
        data["descriptionEN"] = this.descriptionEN;
        data["targetAudienceType"] = this.targetAudienceType;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface ISurveyInfoDto {
    code: string | undefined;
    name: string | undefined;
    status: string | undefined;
    targetAudienceID: number | undefined;
    descriptionVN: string | undefined;
    imageLink: string | undefined;
    isImmediately: boolean | undefined;
    effectiveFrom: moment.Moment | undefined;
    effectiveTo: moment.Moment | undefined;
    occurType: string | undefined;
    cron: string | undefined;
    publishTime: moment.Moment | undefined;
    channel: string | undefined;
    descriptionEN: string | undefined;
    targetAudienceType: string | undefined;
    lastModificationTime: moment.Moment | undefined;
    creationTime: moment.Moment | undefined;
    id: number | undefined;
}

export class GetSurveyInfoForEditOutput implements IGetSurveyInfoForEditOutput {
    surveyInfo!: CreateOrEditSurveyInfoDto | undefined;

    constructor(data?: IGetSurveyInfoForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.surveyInfo = data["surveyInfo"] ? CreateOrEditSurveyInfoDto.fromJS(data["surveyInfo"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSurveyInfoForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetSurveyInfoForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyInfo"] = this.surveyInfo ? this.surveyInfo.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetSurveyInfoForEditOutput {
    surveyInfo: CreateOrEditSurveyInfoDto | undefined;
}

export class CreateOrEditSurveyInfoDto implements ICreateOrEditSurveyInfoDto {
    code!: string | undefined;
    name!: string | undefined;
    status!: string | undefined;
    targetAudienceID!: number | undefined;
    descriptionVN!: string | undefined;
    imageLink!: string | undefined;
    isImmediately!: boolean | undefined;
    effectiveFrom!: moment.Moment | undefined;
    effectiveTo!: moment.Moment | undefined;
    occurType!: string | undefined;
    cron!: string | undefined;
    publishTime!: moment.Moment | undefined;
    channel!: string | undefined;
    descriptionEN!: string | undefined;
    targetAudienceType!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditSurveyInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.name = data["name"];
            this.status = data["status"];
            this.targetAudienceID = data["targetAudienceID"];
            this.descriptionVN = data["descriptionVN"];
            this.imageLink = data["imageLink"];
            this.isImmediately = data["isImmediately"];
            this.effectiveFrom = data["effectiveFrom"] ? moment(data["effectiveFrom"].toString()) : <any>undefined;
            this.effectiveTo = data["effectiveTo"] ? moment(data["effectiveTo"].toString()) : <any>undefined;
            this.occurType = data["occurType"];
            this.cron = data["cron"];
            this.publishTime = data["publishTime"] ? moment(data["publishTime"].toString()) : <any>undefined;
            this.channel = data["channel"];
            this.descriptionEN = data["descriptionEN"];
            this.targetAudienceType = data["targetAudienceType"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditSurveyInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditSurveyInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["status"] = this.status;
        data["targetAudienceID"] = this.targetAudienceID;
        data["descriptionVN"] = this.descriptionVN;
        data["imageLink"] = this.imageLink;
        data["isImmediately"] = this.isImmediately;
        data["effectiveFrom"] = this.effectiveFrom ? this.effectiveFrom.toISOString() : <any>undefined;
        data["effectiveTo"] = this.effectiveTo ? this.effectiveTo.toISOString() : <any>undefined;
        data["occurType"] = this.occurType;
        data["cron"] = this.cron;
        data["publishTime"] = this.publishTime ? this.publishTime.toISOString() : <any>undefined;
        data["channel"] = this.channel;
        data["descriptionEN"] = this.descriptionEN;
        data["targetAudienceType"] = this.targetAudienceType;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditSurveyInfoDto {
    code: string | undefined;
    name: string | undefined;
    status: string | undefined;
    targetAudienceID: number | undefined;
    descriptionVN: string | undefined;
    imageLink: string | undefined;
    isImmediately: boolean | undefined;
    effectiveFrom: moment.Moment | undefined;
    effectiveTo: moment.Moment | undefined;
    occurType: string | undefined;
    cron: string | undefined;
    publishTime: moment.Moment | undefined;
    channel: string | undefined;
    descriptionEN: string | undefined;
    targetAudienceType: string | undefined;
    id: number | undefined;
}

export class GetAllSurveyInfosInput implements IGetAllSurveyInfosInput {
    filter!: string | undefined;
    codeFilter!: string | undefined;
    nameFilter!: string | undefined;
    statusFilter!: string | undefined;
    maxTargetAudienceIDFilter!: number | undefined;
    minTargetAudienceIDFilter!: number | undefined;
    descriptionVNFilter!: string | undefined;
    imageLinkFilter!: string | undefined;
    isImmediatelyFilter!: number | undefined;
    maxEffectiveFromFilter!: moment.Moment | undefined;
    minEffectiveFromFilter!: moment.Moment | undefined;
    maxEffectiveToFilter!: moment.Moment | undefined;
    minEffectiveToFilter!: moment.Moment | undefined;
    occurTypeFilter!: string | undefined;
    cronFilter!: string | undefined;
    maxPublishTimeFilter!: moment.Moment | undefined;
    minPublishTimeFilter!: moment.Moment | undefined;
    channelFilter!: string | undefined;
    descriptionENFilter!: string | undefined;
    targetAudienceTypeFilter!: string | undefined;
    sorting!: string | undefined;
    skipCount!: number | undefined;
    maxResultCount!: number | undefined;

    constructor(data?: IGetAllSurveyInfosInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.filter = data["filter"];
            this.codeFilter = data["codeFilter"];
            this.nameFilter = data["nameFilter"];
            this.statusFilter = data["statusFilter"];
            this.maxTargetAudienceIDFilter = data["maxTargetAudienceIDFilter"];
            this.minTargetAudienceIDFilter = data["minTargetAudienceIDFilter"];
            this.descriptionVNFilter = data["descriptionVNFilter"];
            this.imageLinkFilter = data["imageLinkFilter"];
            this.isImmediatelyFilter = data["isImmediatelyFilter"];
            this.maxEffectiveFromFilter = data["maxEffectiveFromFilter"] ? moment(data["maxEffectiveFromFilter"].toString()) : <any>undefined;
            this.minEffectiveFromFilter = data["minEffectiveFromFilter"] ? moment(data["minEffectiveFromFilter"].toString()) : <any>undefined;
            this.maxEffectiveToFilter = data["maxEffectiveToFilter"] ? moment(data["maxEffectiveToFilter"].toString()) : <any>undefined;
            this.minEffectiveToFilter = data["minEffectiveToFilter"] ? moment(data["minEffectiveToFilter"].toString()) : <any>undefined;
            this.occurTypeFilter = data["occurTypeFilter"];
            this.cronFilter = data["cronFilter"];
            this.maxPublishTimeFilter = data["maxPublishTimeFilter"] ? moment(data["maxPublishTimeFilter"].toString()) : <any>undefined;
            this.minPublishTimeFilter = data["minPublishTimeFilter"] ? moment(data["minPublishTimeFilter"].toString()) : <any>undefined;
            this.channelFilter = data["channelFilter"];
            this.descriptionENFilter = data["descriptionENFilter"];
            this.targetAudienceTypeFilter = data["targetAudienceTypeFilter"];
            this.sorting = data["sorting"];
            this.skipCount = data["skipCount"];
            this.maxResultCount = data["maxResultCount"];
        }
    }

    static fromJS(data: any): GetAllSurveyInfosInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllSurveyInfosInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        data["codeFilter"] = this.codeFilter;
        data["nameFilter"] = this.nameFilter;
        data["statusFilter"] = this.statusFilter;
        data["maxTargetAudienceIDFilter"] = this.maxTargetAudienceIDFilter;
        data["minTargetAudienceIDFilter"] = this.minTargetAudienceIDFilter;
        data["descriptionVNFilter"] = this.descriptionVNFilter;
        data["imageLinkFilter"] = this.imageLinkFilter;
        data["isImmediatelyFilter"] = this.isImmediatelyFilter;
        data["maxEffectiveFromFilter"] = this.maxEffectiveFromFilter ? this.maxEffectiveFromFilter.toISOString() : <any>undefined;
        data["minEffectiveFromFilter"] = this.minEffectiveFromFilter ? this.minEffectiveFromFilter.toISOString() : <any>undefined;
        data["maxEffectiveToFilter"] = this.maxEffectiveToFilter ? this.maxEffectiveToFilter.toISOString() : <any>undefined;
        data["minEffectiveToFilter"] = this.minEffectiveToFilter ? this.minEffectiveToFilter.toISOString() : <any>undefined;
        data["occurTypeFilter"] = this.occurTypeFilter;
        data["cronFilter"] = this.cronFilter;
        data["maxPublishTimeFilter"] = this.maxPublishTimeFilter ? this.maxPublishTimeFilter.toISOString() : <any>undefined;
        data["minPublishTimeFilter"] = this.minPublishTimeFilter ? this.minPublishTimeFilter.toISOString() : <any>undefined;
        data["channelFilter"] = this.channelFilter;
        data["descriptionENFilter"] = this.descriptionENFilter;
        data["targetAudienceTypeFilter"] = this.targetAudienceTypeFilter;
        data["sorting"] = this.sorting;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data;
    }
}

export interface IGetAllSurveyInfosInput {
    filter: string | undefined;
    codeFilter: string | undefined;
    nameFilter: string | undefined;
    statusFilter: string | undefined;
    maxTargetAudienceIDFilter: number | undefined;
    minTargetAudienceIDFilter: number | undefined;
    descriptionVNFilter: string | undefined;
    imageLinkFilter: string | undefined;
    isImmediatelyFilter: number | undefined;
    maxEffectiveFromFilter: moment.Moment | undefined;
    minEffectiveFromFilter: moment.Moment | undefined;
    maxEffectiveToFilter: moment.Moment | undefined;
    minEffectiveToFilter: moment.Moment | undefined;
    occurTypeFilter: string | undefined;
    cronFilter: string | undefined;
    maxPublishTimeFilter: moment.Moment | undefined;
    minPublishTimeFilter: moment.Moment | undefined;
    channelFilter: string | undefined;
    descriptionENFilter: string | undefined;
    targetAudienceTypeFilter: string | undefined;
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;
}

export class CreateOrEditSurveyInforCustomDto implements ICreateOrEditSurveyInforCustomDto {
    surveyInfor!: CreateOrEditSurveyInfoDto | undefined;
    importSurveyTargetAudience!: ImportSurveyTargetAudienceDto | undefined;
    questions!: GetSurveyQuestionForEditOutput[] | undefined;
    deletedQuestions!: number[] | undefined;
    deletedAnswers!: number[] | undefined;

    constructor(data?: ICreateOrEditSurveyInforCustomDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.surveyInfor = data["surveyInfor"] ? CreateOrEditSurveyInfoDto.fromJS(data["surveyInfor"]) : <any>undefined;
            this.importSurveyTargetAudience = data["importSurveyTargetAudience"] ? ImportSurveyTargetAudienceDto.fromJS(data["importSurveyTargetAudience"]) : <any>undefined;
            if (data["questions"] && data["questions"].constructor === Array) {
                this.questions = [];
                for (let item of data["questions"])
                    this.questions.push(GetSurveyQuestionForEditOutput.fromJS(item));
            }
            if (data["deletedQuestions"] && data["deletedQuestions"].constructor === Array) {
                this.deletedQuestions = [];
                for (let item of data["deletedQuestions"])
                    this.deletedQuestions.push(item);
            }
            if (data["deletedAnswers"] && data["deletedAnswers"].constructor === Array) {
                this.deletedAnswers = [];
                for (let item of data["deletedAnswers"])
                    this.deletedAnswers.push(item);
            }
        }
    }

    static fromJS(data: any): CreateOrEditSurveyInforCustomDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditSurveyInforCustomDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyInfor"] = this.surveyInfor ? this.surveyInfor.toJSON() : <any>undefined;
        data["importSurveyTargetAudience"] = this.importSurveyTargetAudience ? this.importSurveyTargetAudience.toJSON() : <any>undefined;
        if (this.questions && this.questions.constructor === Array) {
            data["questions"] = [];
            for (let item of this.questions)
                data["questions"].push(item.toJSON());
        }
        if (this.deletedQuestions && this.deletedQuestions.constructor === Array) {
            data["deletedQuestions"] = [];
            for (let item of this.deletedQuestions)
                data["deletedQuestions"].push(item);
        }
        if (this.deletedAnswers && this.deletedAnswers.constructor === Array) {
            data["deletedAnswers"] = [];
            for (let item of this.deletedAnswers)
                data["deletedAnswers"].push(item);
        }
        return data;
    }
}

export interface ICreateOrEditSurveyInforCustomDto {
    surveyInfor: CreateOrEditSurveyInfoDto | undefined;
    importSurveyTargetAudience: ImportSurveyTargetAudienceDto | undefined;
    questions: GetSurveyQuestionForEditOutput[] | undefined;
    deletedQuestions: number[] | undefined;
    deletedAnswers: number[] | undefined;
}

export class ImportSurveyTargetAudienceDto implements IImportSurveyTargetAudienceDto {
    fileName!: string | undefined;
    targetAudienceName!: string | undefined;

    constructor(data?: IImportSurveyTargetAudienceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.fileName = data["fileName"];
            this.targetAudienceName = data["targetAudienceName"];
        }
    }

    static fromJS(data: any): ImportSurveyTargetAudienceDto {
        data = typeof data === 'object' ? data : {};
        let result = new ImportSurveyTargetAudienceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["targetAudienceName"] = this.targetAudienceName;
        return data;
    }
}

export interface IImportSurveyTargetAudienceDto {
    fileName: string | undefined;
    targetAudienceName: string | undefined;
}

export class GetSurveyQuestionForEditOutput implements IGetSurveyQuestionForEditOutput {
    surveyQuestion!: CreateOrEditSurveyQuestionDto | undefined;
    surveyAnswers!: CreateOrEditSurveyAnswerDto[] | undefined;

    constructor(data?: IGetSurveyQuestionForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.surveyQuestion = data["surveyQuestion"] ? CreateOrEditSurveyQuestionDto.fromJS(data["surveyQuestion"]) : <any>undefined;
            if (data["surveyAnswers"] && data["surveyAnswers"].constructor === Array) {
                this.surveyAnswers = [];
                for (let item of data["surveyAnswers"])
                    this.surveyAnswers.push(CreateOrEditSurveyAnswerDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetSurveyQuestionForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetSurveyQuestionForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyQuestion"] = this.surveyQuestion ? this.surveyQuestion.toJSON() : <any>undefined;
        if (this.surveyAnswers && this.surveyAnswers.constructor === Array) {
            data["surveyAnswers"] = [];
            for (let item of this.surveyAnswers)
                data["surveyAnswers"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetSurveyQuestionForEditOutput {
    surveyQuestion: CreateOrEditSurveyQuestionDto | undefined;
    surveyAnswers: CreateOrEditSurveyAnswerDto[] | undefined;
}

export class CreateOrEditSurveyQuestionDto implements ICreateOrEditSurveyQuestionDto {
    code!: string | undefined;
    contentVN!: string | undefined;
    surveyCode!: string | undefined;
    questionType!: string | undefined;
    ordering!: number | undefined;
    contentEN!: string | undefined;
    attachImage!: boolean | undefined;
    imageNone_Link!: string | undefined;
    imageHaft_Link!: string | undefined;
    image_Full_Link!: string | undefined;
    minvalue!: number | undefined;
    maxvalue!: number | undefined;
    stepPass!: number | undefined;
    required!: boolean | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditSurveyQuestionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.contentVN = data["contentVN"];
            this.surveyCode = data["surveyCode"];
            this.questionType = data["questionType"];
            this.ordering = data["ordering"];
            this.contentEN = data["contentEN"];
            this.attachImage = data["attachImage"];
            this.imageNone_Link = data["imageNone_Link"];
            this.imageHaft_Link = data["imageHaft_Link"];
            this.image_Full_Link = data["image_Full_Link"];
            this.minvalue = data["minvalue"];
            this.maxvalue = data["maxvalue"];
            this.stepPass = data["stepPass"];
            this.required = data["required"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditSurveyQuestionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditSurveyQuestionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["contentVN"] = this.contentVN;
        data["surveyCode"] = this.surveyCode;
        data["questionType"] = this.questionType;
        data["ordering"] = this.ordering;
        data["contentEN"] = this.contentEN;
        data["attachImage"] = this.attachImage;
        data["imageNone_Link"] = this.imageNone_Link;
        data["imageHaft_Link"] = this.imageHaft_Link;
        data["image_Full_Link"] = this.image_Full_Link;
        data["minvalue"] = this.minvalue;
        data["maxvalue"] = this.maxvalue;
        data["stepPass"] = this.stepPass;
        data["required"] = this.required;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditSurveyQuestionDto {
    code: string | undefined;
    contentVN: string | undefined;
    surveyCode: string | undefined;
    questionType: string | undefined;
    ordering: number | undefined;
    contentEN: string | undefined;
    attachImage: boolean | undefined;
    imageNone_Link: string | undefined;
    imageHaft_Link: string | undefined;
    image_Full_Link: string | undefined;
    minvalue: number | undefined;
    maxvalue: number | undefined;
    stepPass: number | undefined;
    required: boolean | undefined;
    id: number | undefined;
}

export class SurveyForViewDto implements ISurveyForViewDto {
    surveyCode!: string | undefined;
    surveyName!: string | undefined;
    fromDate!: moment.Moment | undefined;
    toDate!: moment.Moment | undefined;
    imageLink!: string | undefined;
    channelType!: string | undefined;
    status!: string | undefined;
    totalQuestion!: number | undefined;
    descriptionVN!: string | undefined;
    descriptionEN!: string | undefined;
    questions!: SurveyQuestionForView[] | undefined;

    constructor(data?: ISurveyForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.surveyCode = data["surveyCode"];
            this.surveyName = data["surveyName"];
            this.fromDate = data["fromDate"] ? moment(data["fromDate"].toString()) : <any>undefined;
            this.toDate = data["toDate"] ? moment(data["toDate"].toString()) : <any>undefined;
            this.imageLink = data["imageLink"];
            this.channelType = data["channelType"];
            this.status = data["status"];
            this.totalQuestion = data["totalQuestion"];
            this.descriptionVN = data["descriptionVN"];
            this.descriptionEN = data["descriptionEN"];
            if (data["questions"] && data["questions"].constructor === Array) {
                this.questions = [];
                for (let item of data["questions"])
                    this.questions.push(SurveyQuestionForView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SurveyForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyCode"] = this.surveyCode;
        data["surveyName"] = this.surveyName;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data["imageLink"] = this.imageLink;
        data["channelType"] = this.channelType;
        data["status"] = this.status;
        data["totalQuestion"] = this.totalQuestion;
        data["descriptionVN"] = this.descriptionVN;
        data["descriptionEN"] = this.descriptionEN;
        if (this.questions && this.questions.constructor === Array) {
            data["questions"] = [];
            for (let item of this.questions)
                data["questions"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISurveyForViewDto {
    surveyCode: string | undefined;
    surveyName: string | undefined;
    fromDate: moment.Moment | undefined;
    toDate: moment.Moment | undefined;
    imageLink: string | undefined;
    channelType: string | undefined;
    status: string | undefined;
    totalQuestion: number | undefined;
    descriptionVN: string | undefined;
    descriptionEN: string | undefined;
    questions: SurveyQuestionForView[] | undefined;
}

export class SurveyQuestionForView implements ISurveyQuestionForView {
    questionCode!: string | undefined;
    contentEN!: string | undefined;
    contentVN!: string | undefined;
    questionType!: string | undefined;
    ordering!: number | undefined;
    attachImage!: boolean | undefined;
    imageHaft_Link!: string | undefined;
    imageNone_Link!: string | undefined;
    image_Full_Link!: string | undefined;
    maxvalue!: number | undefined;
    minvalue!: number | undefined;
    stepPass!: number | undefined;
    required!: boolean | undefined;
    answers!: SurveyAnswerForClientDto[] | undefined;

    constructor(data?: ISurveyQuestionForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.questionCode = data["questionCode"];
            this.contentEN = data["contentEN"];
            this.contentVN = data["contentVN"];
            this.questionType = data["questionType"];
            this.ordering = data["ordering"];
            this.attachImage = data["attachImage"];
            this.imageHaft_Link = data["imageHaft_Link"];
            this.imageNone_Link = data["imageNone_Link"];
            this.image_Full_Link = data["image_Full_Link"];
            this.maxvalue = data["maxvalue"];
            this.minvalue = data["minvalue"];
            this.stepPass = data["stepPass"];
            this.required = data["required"];
            if (data["answers"] && data["answers"].constructor === Array) {
                this.answers = [];
                for (let item of data["answers"])
                    this.answers.push(SurveyAnswerForClientDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SurveyQuestionForView {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyQuestionForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["questionCode"] = this.questionCode;
        data["contentEN"] = this.contentEN;
        data["contentVN"] = this.contentVN;
        data["questionType"] = this.questionType;
        data["ordering"] = this.ordering;
        data["attachImage"] = this.attachImage;
        data["imageHaft_Link"] = this.imageHaft_Link;
        data["imageNone_Link"] = this.imageNone_Link;
        data["image_Full_Link"] = this.image_Full_Link;
        data["maxvalue"] = this.maxvalue;
        data["minvalue"] = this.minvalue;
        data["stepPass"] = this.stepPass;
        data["required"] = this.required;
        if (this.answers && this.answers.constructor === Array) {
            data["answers"] = [];
            for (let item of this.answers)
                data["answers"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISurveyQuestionForView {
    questionCode: string | undefined;
    contentEN: string | undefined;
    contentVN: string | undefined;
    questionType: string | undefined;
    ordering: number | undefined;
    attachImage: boolean | undefined;
    imageHaft_Link: string | undefined;
    imageNone_Link: string | undefined;
    image_Full_Link: string | undefined;
    maxvalue: number | undefined;
    minvalue: number | undefined;
    stepPass: number | undefined;
    required: boolean | undefined;
    answers: SurveyAnswerForClientDto[] | undefined;
}

export class SurveyAnswerForClientDto implements ISurveyAnswerForClientDto {
    answerCode!: string | undefined;
    contentEN!: string | undefined;
    contentVN!: string | undefined;
    image!: string | undefined;

    constructor(data?: ISurveyAnswerForClientDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.answerCode = data["answerCode"];
            this.contentEN = data["contentEN"];
            this.contentVN = data["contentVN"];
            this.image = data["image"];
        }
    }

    static fromJS(data: any): SurveyAnswerForClientDto {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyAnswerForClientDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["answerCode"] = this.answerCode;
        data["contentEN"] = this.contentEN;
        data["contentVN"] = this.contentVN;
        data["image"] = this.image;
        return data;
    }
}

export interface ISurveyAnswerForClientDto {
    answerCode: string | undefined;
    contentEN: string | undefined;
    contentVN: string | undefined;
    image: string | undefined;
}

export class SurveyForSubmit implements ISurveyForSubmit {
    surveyCode!: string | undefined;
    channelType!: string | undefined;
    memberCode!: string | undefined;
    memberName!: string | undefined;
    outletCode!: string | undefined;
    chatId!: string | undefined;
    email!: string | undefined;
    facebookId!: string | undefined;
    totalQuestion!: number | undefined;
    phone!: string | undefined;
    beatPlanResultId!: number | undefined;
    questions!: SurveyQuestionForSubmit[] | undefined;

    constructor(data?: ISurveyForSubmit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.surveyCode = data["surveyCode"];
            this.channelType = data["channelType"];
            this.memberCode = data["memberCode"];
            this.memberName = data["memberName"];
            this.outletCode = data["outletCode"];
            this.chatId = data["chatId"];
            this.email = data["email"];
            this.facebookId = data["facebookId"];
            this.totalQuestion = data["totalQuestion"];
            this.phone = data["phone"];
            this.beatPlanResultId = data["beatPlanResultId"];
            if (data["questions"] && data["questions"].constructor === Array) {
                this.questions = [];
                for (let item of data["questions"])
                    this.questions.push(SurveyQuestionForSubmit.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SurveyForSubmit {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyForSubmit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyCode"] = this.surveyCode;
        data["channelType"] = this.channelType;
        data["memberCode"] = this.memberCode;
        data["memberName"] = this.memberName;
        data["outletCode"] = this.outletCode;
        data["chatId"] = this.chatId;
        data["email"] = this.email;
        data["facebookId"] = this.facebookId;
        data["totalQuestion"] = this.totalQuestion;
        data["phone"] = this.phone;
        data["beatPlanResultId"] = this.beatPlanResultId;
        if (this.questions && this.questions.constructor === Array) {
            data["questions"] = [];
            for (let item of this.questions)
                data["questions"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISurveyForSubmit {
    surveyCode: string | undefined;
    channelType: string | undefined;
    memberCode: string | undefined;
    memberName: string | undefined;
    outletCode: string | undefined;
    chatId: string | undefined;
    email: string | undefined;
    facebookId: string | undefined;
    totalQuestion: number | undefined;
    phone: string | undefined;
    beatPlanResultId: number | undefined;
    questions: SurveyQuestionForSubmit[] | undefined;
}

export class SurveyQuestionForSubmit implements ISurveyQuestionForSubmit {
    questionCode!: string | undefined;
    content!: string | undefined;
    questionType!: string | undefined;
    answers!: SurveyAnswerForSubmit[] | undefined;

    constructor(data?: ISurveyQuestionForSubmit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.questionCode = data["questionCode"];
            this.content = data["content"];
            this.questionType = data["questionType"];
            if (data["answers"] && data["answers"].constructor === Array) {
                this.answers = [];
                for (let item of data["answers"])
                    this.answers.push(SurveyAnswerForSubmit.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SurveyQuestionForSubmit {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyQuestionForSubmit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["questionCode"] = this.questionCode;
        data["content"] = this.content;
        data["questionType"] = this.questionType;
        if (this.answers && this.answers.constructor === Array) {
            data["answers"] = [];
            for (let item of this.answers)
                data["answers"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISurveyQuestionForSubmit {
    questionCode: string | undefined;
    content: string | undefined;
    questionType: string | undefined;
    answers: SurveyAnswerForSubmit[] | undefined;
}

export class SurveyAnswerForSubmit implements ISurveyAnswerForSubmit {
    answerCode!: string | undefined;
    content!: string | undefined;
    imageLinks!: string[] | undefined;

    constructor(data?: ISurveyAnswerForSubmit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.answerCode = data["answerCode"];
            this.content = data["content"];
            if (data["imageLinks"] && data["imageLinks"].constructor === Array) {
                this.imageLinks = [];
                for (let item of data["imageLinks"])
                    this.imageLinks.push(item);
            }
        }
    }

    static fromJS(data: any): SurveyAnswerForSubmit {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyAnswerForSubmit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["answerCode"] = this.answerCode;
        data["content"] = this.content;
        if (this.imageLinks && this.imageLinks.constructor === Array) {
            data["imageLinks"] = [];
            for (let item of this.imageLinks)
                data["imageLinks"].push(item);
        }
        return data;
    }
}

export interface ISurveyAnswerForSubmit {
    answerCode: string | undefined;
    content: string | undefined;
    imageLinks: string[] | undefined;
}

export class SubmitSurveyResponse implements ISubmitSurveyResponse {
    isGame!: boolean | undefined;

    constructor(data?: ISubmitSurveyResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isGame = data["isGame"];
        }
    }

    static fromJS(data: any): SubmitSurveyResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SubmitSurveyResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isGame"] = this.isGame;
        return data;
    }
}

export interface ISubmitSurveyResponse {
    isGame: boolean | undefined;
}

export class PagedResultDtoOfGetSurveyQuestionForViewDto implements IPagedResultDtoOfGetSurveyQuestionForViewDto {
    totalCount!: number | undefined;
    items!: GetSurveyQuestionForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetSurveyQuestionForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetSurveyQuestionForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetSurveyQuestionForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetSurveyQuestionForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetSurveyQuestionForViewDto {
    totalCount: number | undefined;
    items: GetSurveyQuestionForViewDto[] | undefined;
}

export class GetSurveyQuestionForViewDto implements IGetSurveyQuestionForViewDto {
    surveyQuestion!: SurveyQuestionDto | undefined;

    constructor(data?: IGetSurveyQuestionForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.surveyQuestion = data["surveyQuestion"] ? SurveyQuestionDto.fromJS(data["surveyQuestion"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSurveyQuestionForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetSurveyQuestionForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyQuestion"] = this.surveyQuestion ? this.surveyQuestion.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetSurveyQuestionForViewDto {
    surveyQuestion: SurveyQuestionDto | undefined;
}

export class SurveyQuestionDto implements ISurveyQuestionDto {
    code!: string | undefined;
    contentVN!: string | undefined;
    surveyCode!: string | undefined;
    questionType!: string | undefined;
    ordering!: number | undefined;
    contentEN!: string | undefined;
    attachImage!: boolean | undefined;
    imageNone_Link!: string | undefined;
    imageHaft_Link!: string | undefined;
    image_Full_Link!: string | undefined;
    minvalue!: number | undefined;
    maxvalue!: number | undefined;
    stepPass!: number | undefined;
    required!: boolean | undefined;
    id!: number | undefined;

    constructor(data?: ISurveyQuestionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.contentVN = data["contentVN"];
            this.surveyCode = data["surveyCode"];
            this.questionType = data["questionType"];
            this.ordering = data["ordering"];
            this.contentEN = data["contentEN"];
            this.attachImage = data["attachImage"];
            this.imageNone_Link = data["imageNone_Link"];
            this.imageHaft_Link = data["imageHaft_Link"];
            this.image_Full_Link = data["image_Full_Link"];
            this.minvalue = data["minvalue"];
            this.maxvalue = data["maxvalue"];
            this.stepPass = data["stepPass"];
            this.required = data["required"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SurveyQuestionDto {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyQuestionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["contentVN"] = this.contentVN;
        data["surveyCode"] = this.surveyCode;
        data["questionType"] = this.questionType;
        data["ordering"] = this.ordering;
        data["contentEN"] = this.contentEN;
        data["attachImage"] = this.attachImage;
        data["imageNone_Link"] = this.imageNone_Link;
        data["imageHaft_Link"] = this.imageHaft_Link;
        data["image_Full_Link"] = this.image_Full_Link;
        data["minvalue"] = this.minvalue;
        data["maxvalue"] = this.maxvalue;
        data["stepPass"] = this.stepPass;
        data["required"] = this.required;
        data["id"] = this.id;
        return data;
    }
}

export interface ISurveyQuestionDto {
    code: string | undefined;
    contentVN: string | undefined;
    surveyCode: string | undefined;
    questionType: string | undefined;
    ordering: number | undefined;
    contentEN: string | undefined;
    attachImage: boolean | undefined;
    imageNone_Link: string | undefined;
    imageHaft_Link: string | undefined;
    image_Full_Link: string | undefined;
    minvalue: number | undefined;
    maxvalue: number | undefined;
    stepPass: number | undefined;
    required: boolean | undefined;
    id: number | undefined;
}

export class GetSurveyResponseForViewDto implements IGetSurveyResponseForViewDto {
    surveyResponse!: SurveyResponseDto | undefined;
    surveyName!: string | undefined;

    constructor(data?: IGetSurveyResponseForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.surveyResponse = data["surveyResponse"] ? SurveyResponseDto.fromJS(data["surveyResponse"]) : <any>undefined;
            this.surveyName = data["surveyName"];
        }
    }

    static fromJS(data: any): GetSurveyResponseForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetSurveyResponseForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyResponse"] = this.surveyResponse ? this.surveyResponse.toJSON() : <any>undefined;
        data["surveyName"] = this.surveyName;
        return data;
    }
}

export interface IGetSurveyResponseForViewDto {
    surveyResponse: SurveyResponseDto | undefined;
    surveyName: string | undefined;
}

export class SurveyResponseDto implements ISurveyResponseDto {
    surveyCode!: string | undefined;
    channel!: string | undefined;
    memberName!: string | undefined;
    phone!: string | undefined;
    zaloChatID!: string | undefined;
    email!: string | undefined;
    facebookID!: string | undefined;
    memberCode!: string | undefined;
    questionContent!: string | undefined;
    subject!: string | undefined;
    outletCode!: string | undefined;
    questionCode!: string | undefined;
    answerContent!: string | undefined;
    messageID!: string | undefined;
    questionType!: string | undefined;
    ordering!: number | undefined;
    imageLink!: string | undefined;
    creationTime!: moment.Moment | undefined;
    imageList!: string[] | undefined;
    answerCode!: string | undefined;
    id!: number | undefined;

    constructor(data?: ISurveyResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.surveyCode = data["surveyCode"];
            this.channel = data["channel"];
            this.memberName = data["memberName"];
            this.phone = data["phone"];
            this.zaloChatID = data["zaloChatID"];
            this.email = data["email"];
            this.facebookID = data["facebookID"];
            this.memberCode = data["memberCode"];
            this.questionContent = data["questionContent"];
            this.subject = data["subject"];
            this.outletCode = data["outletCode"];
            this.questionCode = data["questionCode"];
            this.answerContent = data["answerContent"];
            this.messageID = data["messageID"];
            this.questionType = data["questionType"];
            this.ordering = data["ordering"];
            this.imageLink = data["imageLink"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            if (data["imageList"] && data["imageList"].constructor === Array) {
                this.imageList = [];
                for (let item of data["imageList"])
                    this.imageList.push(item);
            }
            this.answerCode = data["answerCode"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SurveyResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyCode"] = this.surveyCode;
        data["channel"] = this.channel;
        data["memberName"] = this.memberName;
        data["phone"] = this.phone;
        data["zaloChatID"] = this.zaloChatID;
        data["email"] = this.email;
        data["facebookID"] = this.facebookID;
        data["memberCode"] = this.memberCode;
        data["questionContent"] = this.questionContent;
        data["subject"] = this.subject;
        data["outletCode"] = this.outletCode;
        data["questionCode"] = this.questionCode;
        data["answerContent"] = this.answerContent;
        data["messageID"] = this.messageID;
        data["questionType"] = this.questionType;
        data["ordering"] = this.ordering;
        data["imageLink"] = this.imageLink;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        if (this.imageList && this.imageList.constructor === Array) {
            data["imageList"] = [];
            for (let item of this.imageList)
                data["imageList"].push(item);
        }
        data["answerCode"] = this.answerCode;
        data["id"] = this.id;
        return data;
    }
}

export interface ISurveyResponseDto {
    surveyCode: string | undefined;
    channel: string | undefined;
    memberName: string | undefined;
    phone: string | undefined;
    zaloChatID: string | undefined;
    email: string | undefined;
    facebookID: string | undefined;
    memberCode: string | undefined;
    questionContent: string | undefined;
    subject: string | undefined;
    outletCode: string | undefined;
    questionCode: string | undefined;
    answerContent: string | undefined;
    messageID: string | undefined;
    questionType: string | undefined;
    ordering: number | undefined;
    imageLink: string | undefined;
    creationTime: moment.Moment | undefined;
    imageList: string[] | undefined;
    answerCode: string | undefined;
    id: number | undefined;
}

export class SurveyResponseFileDto implements ISurveyResponseFileDto {
    fileName!: string;
    fileType!: string;
    fileToken!: string;

    constructor(data?: ISurveyResponseFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.fileName = data["fileName"];
            this.fileType = data["fileType"];
            this.fileToken = data["fileToken"];
        }
    }

    static fromJS(data: any): SurveyResponseFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyResponseFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["fileType"] = this.fileType;
        data["fileToken"] = this.fileToken;
        return data;
    }
}

export interface ISurveyResponseFileDto {
    fileName: string;
    fileType: string;
    fileToken: string;
}

export class PagedResultDtoOfGetSurveyResponseForViewDto implements IPagedResultDtoOfGetSurveyResponseForViewDto {
    totalCount!: number | undefined;
    items!: GetSurveyResponseForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetSurveyResponseForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetSurveyResponseForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetSurveyResponseForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetSurveyResponseForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetSurveyResponseForViewDto {
    totalCount: number | undefined;
    items: GetSurveyResponseForViewDto[] | undefined;
}

export class GetSurveyResponseForEditOutput implements IGetSurveyResponseForEditOutput {
    surveyResponse!: CreateOrEditSurveyResponseDto | undefined;

    constructor(data?: IGetSurveyResponseForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.surveyResponse = data["surveyResponse"] ? CreateOrEditSurveyResponseDto.fromJS(data["surveyResponse"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSurveyResponseForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetSurveyResponseForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyResponse"] = this.surveyResponse ? this.surveyResponse.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetSurveyResponseForEditOutput {
    surveyResponse: CreateOrEditSurveyResponseDto | undefined;
}

export class CreateOrEditSurveyResponseDto implements ICreateOrEditSurveyResponseDto {
    surveyCode!: string;
    channel!: string | undefined;
    memberName!: string | undefined;
    phone!: string | undefined;
    zaloChatID!: string | undefined;
    email!: string | undefined;
    facebookID!: string | undefined;
    memberCode!: string | undefined;
    questionContent!: string | undefined;
    subject!: string | undefined;
    outletCode!: string | undefined;
    questionCode!: string | undefined;
    answerContent!: string | undefined;
    messageID!: string | undefined;
    questionType!: string | undefined;
    ordering!: number | undefined;
    imageLink!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditSurveyResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.surveyCode = data["surveyCode"];
            this.channel = data["channel"];
            this.memberName = data["memberName"];
            this.phone = data["phone"];
            this.zaloChatID = data["zaloChatID"];
            this.email = data["email"];
            this.facebookID = data["facebookID"];
            this.memberCode = data["memberCode"];
            this.questionContent = data["questionContent"];
            this.subject = data["subject"];
            this.outletCode = data["outletCode"];
            this.questionCode = data["questionCode"];
            this.answerContent = data["answerContent"];
            this.messageID = data["messageID"];
            this.questionType = data["questionType"];
            this.ordering = data["ordering"];
            this.imageLink = data["imageLink"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditSurveyResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditSurveyResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyCode"] = this.surveyCode;
        data["channel"] = this.channel;
        data["memberName"] = this.memberName;
        data["phone"] = this.phone;
        data["zaloChatID"] = this.zaloChatID;
        data["email"] = this.email;
        data["facebookID"] = this.facebookID;
        data["memberCode"] = this.memberCode;
        data["questionContent"] = this.questionContent;
        data["subject"] = this.subject;
        data["outletCode"] = this.outletCode;
        data["questionCode"] = this.questionCode;
        data["answerContent"] = this.answerContent;
        data["messageID"] = this.messageID;
        data["questionType"] = this.questionType;
        data["ordering"] = this.ordering;
        data["imageLink"] = this.imageLink;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditSurveyResponseDto {
    surveyCode: string;
    channel: string | undefined;
    memberName: string | undefined;
    phone: string | undefined;
    zaloChatID: string | undefined;
    email: string | undefined;
    facebookID: string | undefined;
    memberCode: string | undefined;
    questionContent: string | undefined;
    subject: string | undefined;
    outletCode: string | undefined;
    questionCode: string | undefined;
    answerContent: string | undefined;
    messageID: string | undefined;
    questionType: string | undefined;
    ordering: number | undefined;
    imageLink: string | undefined;
    id: number | undefined;
}

export class GetListSurveyResponseInput implements IGetListSurveyResponseInput {
    surveyCode!: string | undefined;
    filter!: string | undefined;
    memberNameFilter!: string | undefined;
    memberCodeFilter!: string | undefined;
    fromDate!: moment.Moment | undefined;
    toDate!: moment.Moment | undefined;
    sorting!: string | undefined;
    skipCount!: number | undefined;
    maxResultCount!: number | undefined;

    constructor(data?: IGetListSurveyResponseInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.surveyCode = data["surveyCode"];
            this.filter = data["filter"];
            this.memberNameFilter = data["memberNameFilter"];
            this.memberCodeFilter = data["memberCodeFilter"];
            this.fromDate = data["fromDate"] ? moment(data["fromDate"].toString()) : <any>undefined;
            this.toDate = data["toDate"] ? moment(data["toDate"].toString()) : <any>undefined;
            this.sorting = data["sorting"];
            this.skipCount = data["skipCount"];
            this.maxResultCount = data["maxResultCount"];
        }
    }

    static fromJS(data: any): GetListSurveyResponseInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetListSurveyResponseInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyCode"] = this.surveyCode;
        data["filter"] = this.filter;
        data["memberNameFilter"] = this.memberNameFilter;
        data["memberCodeFilter"] = this.memberCodeFilter;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data["sorting"] = this.sorting;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data;
    }
}

export interface IGetListSurveyResponseInput {
    surveyCode: string | undefined;
    filter: string | undefined;
    memberNameFilter: string | undefined;
    memberCodeFilter: string | undefined;
    fromDate: moment.Moment | undefined;
    toDate: moment.Moment | undefined;
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;
}

export class GetSurveyResponseDetailDto implements IGetSurveyResponseDetailDto {
    surveyResponses!: SurveyResponseDto[] | undefined;
    memberCode!: string | undefined;
    memberName!: string | undefined;
    surveyCode!: string | undefined;
    surveyName!: string | undefined;
    submitDate!: moment.Moment | undefined;

    constructor(data?: IGetSurveyResponseDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["surveyResponses"] && data["surveyResponses"].constructor === Array) {
                this.surveyResponses = [];
                for (let item of data["surveyResponses"])
                    this.surveyResponses.push(SurveyResponseDto.fromJS(item));
            }
            this.memberCode = data["memberCode"];
            this.memberName = data["memberName"];
            this.surveyCode = data["surveyCode"];
            this.surveyName = data["surveyName"];
            this.submitDate = data["submitDate"] ? moment(data["submitDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSurveyResponseDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetSurveyResponseDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.surveyResponses && this.surveyResponses.constructor === Array) {
            data["surveyResponses"] = [];
            for (let item of this.surveyResponses)
                data["surveyResponses"].push(item.toJSON());
        }
        data["memberCode"] = this.memberCode;
        data["memberName"] = this.memberName;
        data["surveyCode"] = this.surveyCode;
        data["surveyName"] = this.surveyName;
        data["submitDate"] = this.submitDate ? this.submitDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGetSurveyResponseDetailDto {
    surveyResponses: SurveyResponseDto[] | undefined;
    memberCode: string | undefined;
    memberName: string | undefined;
    surveyCode: string | undefined;
    surveyName: string | undefined;
    submitDate: moment.Moment | undefined;
}

export class CreateOrEditSurveyInput implements ICreateOrEditSurveyInput {
    name!: string | undefined;
    status!: string | undefined;
    fromDate!: moment.Moment | undefined;
    toDate!: moment.Moment | undefined;
    objectCollectionId!: string | undefined;
    creatorName!: string | undefined;
    lastModifierName!: string | undefined;
    listObjectCollectionValueId!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditSurveyInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.status = data["status"];
            this.fromDate = data["fromDate"] ? moment(data["fromDate"].toString()) : <any>undefined;
            this.toDate = data["toDate"] ? moment(data["toDate"].toString()) : <any>undefined;
            this.objectCollectionId = data["objectCollectionId"];
            this.creatorName = data["creatorName"];
            this.lastModifierName = data["lastModifierName"];
            this.listObjectCollectionValueId = data["listObjectCollectionValueId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditSurveyInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditSurveyInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["status"] = this.status;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data["objectCollectionId"] = this.objectCollectionId;
        data["creatorName"] = this.creatorName;
        data["lastModifierName"] = this.lastModifierName;
        data["listObjectCollectionValueId"] = this.listObjectCollectionValueId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditSurveyInput {
    name: string | undefined;
    status: string | undefined;
    fromDate: moment.Moment | undefined;
    toDate: moment.Moment | undefined;
    objectCollectionId: string | undefined;
    creatorName: string | undefined;
    lastModifierName: string | undefined;
    listObjectCollectionValueId: string | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfSurveyResultDetailDto implements IPagedResultDtoOfSurveyResultDetailDto {
    totalCount!: number | undefined;
    items!: SurveyResultDetailDto[] | undefined;

    constructor(data?: IPagedResultDtoOfSurveyResultDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(SurveyResultDetailDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfSurveyResultDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfSurveyResultDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfSurveyResultDetailDto {
    totalCount: number | undefined;
    items: SurveyResultDetailDto[] | undefined;
}

export class SurveyResultDetailDto implements ISurveyResultDetailDto {
    surveyResultId!: number | undefined;
    value!: string | undefined;
    questionType!: string | undefined;
    id!: number | undefined;

    constructor(data?: ISurveyResultDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.surveyResultId = data["surveyResultId"];
            this.value = data["value"];
            this.questionType = data["questionType"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SurveyResultDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyResultDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyResultId"] = this.surveyResultId;
        data["value"] = this.value;
        data["questionType"] = this.questionType;
        data["id"] = this.id;
        return data;
    }
}

export interface ISurveyResultDetailDto {
    surveyResultId: number | undefined;
    value: string | undefined;
    questionType: string | undefined;
    id: number | undefined;
}

export class SurveyInput implements ISurveyInput {
    objectCollectionId!: number | undefined;
    status!: string | undefined;
    name!: string | undefined;
    surveyQuestion!: SurveyQuestionInput[] | undefined;

    constructor(data?: ISurveyInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.objectCollectionId = data["objectCollectionId"];
            this.status = data["status"];
            this.name = data["name"];
            if (data["surveyQuestion"] && data["surveyQuestion"].constructor === Array) {
                this.surveyQuestion = [];
                for (let item of data["surveyQuestion"])
                    this.surveyQuestion.push(SurveyQuestionInput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SurveyInput {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["objectCollectionId"] = this.objectCollectionId;
        data["status"] = this.status;
        data["name"] = this.name;
        if (this.surveyQuestion && this.surveyQuestion.constructor === Array) {
            data["surveyQuestion"] = [];
            for (let item of this.surveyQuestion)
                data["surveyQuestion"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISurveyInput {
    objectCollectionId: number | undefined;
    status: string | undefined;
    name: string | undefined;
    surveyQuestion: SurveyQuestionInput[] | undefined;
}

export class SurveyQuestionInput implements ISurveyQuestionInput {
    surveyId!: number | undefined;
    question!: string | undefined;
    questionType!: string | undefined;
    defaultValue!: string | undefined;

    constructor(data?: ISurveyQuestionInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.surveyId = data["surveyId"];
            this.question = data["question"];
            this.questionType = data["questionType"];
            this.defaultValue = data["defaultValue"];
        }
    }

    static fromJS(data: any): SurveyQuestionInput {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyQuestionInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyId"] = this.surveyId;
        data["question"] = this.question;
        data["questionType"] = this.questionType;
        data["defaultValue"] = this.defaultValue;
        return data;
    }
}

export interface ISurveyQuestionInput {
    surveyId: number | undefined;
    question: string | undefined;
    questionType: string | undefined;
    defaultValue: string | undefined;
}

export class PagedResultDtoOfGetSurveySettingForViewDto implements IPagedResultDtoOfGetSurveySettingForViewDto {
    totalCount!: number | undefined;
    items!: GetSurveySettingForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetSurveySettingForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetSurveySettingForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetSurveySettingForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetSurveySettingForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetSurveySettingForViewDto {
    totalCount: number | undefined;
    items: GetSurveySettingForViewDto[] | undefined;
}

export class GetSurveySettingForViewDto implements IGetSurveySettingForViewDto {
    surveySetting!: SurveySettingDto | undefined;

    constructor(data?: IGetSurveySettingForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.surveySetting = data["surveySetting"] ? SurveySettingDto.fromJS(data["surveySetting"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSurveySettingForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetSurveySettingForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveySetting"] = this.surveySetting ? this.surveySetting.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetSurveySettingForViewDto {
    surveySetting: SurveySettingDto | undefined;
}

export class SurveySettingDto implements ISurveySettingDto {
    surveyName!: string | undefined;
    surveyMonkeyCode!: string | undefined;
    effectiveFrom!: moment.Moment | undefined;
    effectiveTo!: moment.Moment | undefined;
    status!: string | undefined;
    description!: string | undefined;
    imageLink!: string | undefined;
    surveyNameUnsign!: string | undefined;
    creationTime!: moment.Moment | undefined;
    id!: number | undefined;

    constructor(data?: ISurveySettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.surveyName = data["surveyName"];
            this.surveyMonkeyCode = data["surveyMonkeyCode"];
            this.effectiveFrom = data["effectiveFrom"] ? moment(data["effectiveFrom"].toString()) : <any>undefined;
            this.effectiveTo = data["effectiveTo"] ? moment(data["effectiveTo"].toString()) : <any>undefined;
            this.status = data["status"];
            this.description = data["description"];
            this.imageLink = data["imageLink"];
            this.surveyNameUnsign = data["surveyNameUnsign"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SurveySettingDto {
        data = typeof data === 'object' ? data : {};
        let result = new SurveySettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyName"] = this.surveyName;
        data["surveyMonkeyCode"] = this.surveyMonkeyCode;
        data["effectiveFrom"] = this.effectiveFrom ? this.effectiveFrom.toISOString() : <any>undefined;
        data["effectiveTo"] = this.effectiveTo ? this.effectiveTo.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["description"] = this.description;
        data["imageLink"] = this.imageLink;
        data["surveyNameUnsign"] = this.surveyNameUnsign;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface ISurveySettingDto {
    surveyName: string | undefined;
    surveyMonkeyCode: string | undefined;
    effectiveFrom: moment.Moment | undefined;
    effectiveTo: moment.Moment | undefined;
    status: string | undefined;
    description: string | undefined;
    imageLink: string | undefined;
    surveyNameUnsign: string | undefined;
    creationTime: moment.Moment | undefined;
    id: number | undefined;
}

export class GetSurveySettingForEditOutput implements IGetSurveySettingForEditOutput {
    surveySetting!: CreateOrEditSurveySettingDto | undefined;

    constructor(data?: IGetSurveySettingForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.surveySetting = data["surveySetting"] ? CreateOrEditSurveySettingDto.fromJS(data["surveySetting"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSurveySettingForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetSurveySettingForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveySetting"] = this.surveySetting ? this.surveySetting.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetSurveySettingForEditOutput {
    surveySetting: CreateOrEditSurveySettingDto | undefined;
}

export class CreateOrEditSurveySettingDto implements ICreateOrEditSurveySettingDto {
    surveyName!: string | undefined;
    surveyMonkeyCode!: string | undefined;
    effectiveFrom!: moment.Moment | undefined;
    effectiveTo!: moment.Moment | undefined;
    status!: string | undefined;
    description!: string | undefined;
    imageLink!: string | undefined;
    surveyNameUnsign!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditSurveySettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.surveyName = data["surveyName"];
            this.surveyMonkeyCode = data["surveyMonkeyCode"];
            this.effectiveFrom = data["effectiveFrom"] ? moment(data["effectiveFrom"].toString()) : <any>undefined;
            this.effectiveTo = data["effectiveTo"] ? moment(data["effectiveTo"].toString()) : <any>undefined;
            this.status = data["status"];
            this.description = data["description"];
            this.imageLink = data["imageLink"];
            this.surveyNameUnsign = data["surveyNameUnsign"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditSurveySettingDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditSurveySettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyName"] = this.surveyName;
        data["surveyMonkeyCode"] = this.surveyMonkeyCode;
        data["effectiveFrom"] = this.effectiveFrom ? this.effectiveFrom.toISOString() : <any>undefined;
        data["effectiveTo"] = this.effectiveTo ? this.effectiveTo.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["description"] = this.description;
        data["imageLink"] = this.imageLink;
        data["surveyNameUnsign"] = this.surveyNameUnsign;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditSurveySettingDto {
    surveyName: string | undefined;
    surveyMonkeyCode: string | undefined;
    effectiveFrom: moment.Moment | undefined;
    effectiveTo: moment.Moment | undefined;
    status: string | undefined;
    description: string | undefined;
    imageLink: string | undefined;
    surveyNameUnsign: string | undefined;
    id: number | undefined;
}

export class GetAllSurveySettingsInput implements IGetAllSurveySettingsInput {
    filter!: string | undefined;
    surveyNameFilter!: string | undefined;
    surveyMonkeyCodeFilter!: string | undefined;
    maxEffectiveFromFilter!: moment.Moment | undefined;
    minEffectiveFromFilter!: moment.Moment | undefined;
    maxEffectiveToFilter!: moment.Moment | undefined;
    minEffectiveToFilter!: moment.Moment | undefined;
    statusFilter!: string | undefined;
    descriptionFilter!: string | undefined;
    imageLinkFilter!: string | undefined;
    surveyNameUnsignFilter!: string | undefined;
    sorting!: string | undefined;
    skipCount!: number | undefined;
    maxResultCount!: number | undefined;

    constructor(data?: IGetAllSurveySettingsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.filter = data["filter"];
            this.surveyNameFilter = data["surveyNameFilter"];
            this.surveyMonkeyCodeFilter = data["surveyMonkeyCodeFilter"];
            this.maxEffectiveFromFilter = data["maxEffectiveFromFilter"] ? moment(data["maxEffectiveFromFilter"].toString()) : <any>undefined;
            this.minEffectiveFromFilter = data["minEffectiveFromFilter"] ? moment(data["minEffectiveFromFilter"].toString()) : <any>undefined;
            this.maxEffectiveToFilter = data["maxEffectiveToFilter"] ? moment(data["maxEffectiveToFilter"].toString()) : <any>undefined;
            this.minEffectiveToFilter = data["minEffectiveToFilter"] ? moment(data["minEffectiveToFilter"].toString()) : <any>undefined;
            this.statusFilter = data["statusFilter"];
            this.descriptionFilter = data["descriptionFilter"];
            this.imageLinkFilter = data["imageLinkFilter"];
            this.surveyNameUnsignFilter = data["surveyNameUnsignFilter"];
            this.sorting = data["sorting"];
            this.skipCount = data["skipCount"];
            this.maxResultCount = data["maxResultCount"];
        }
    }

    static fromJS(data: any): GetAllSurveySettingsInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllSurveySettingsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        data["surveyNameFilter"] = this.surveyNameFilter;
        data["surveyMonkeyCodeFilter"] = this.surveyMonkeyCodeFilter;
        data["maxEffectiveFromFilter"] = this.maxEffectiveFromFilter ? this.maxEffectiveFromFilter.toISOString() : <any>undefined;
        data["minEffectiveFromFilter"] = this.minEffectiveFromFilter ? this.minEffectiveFromFilter.toISOString() : <any>undefined;
        data["maxEffectiveToFilter"] = this.maxEffectiveToFilter ? this.maxEffectiveToFilter.toISOString() : <any>undefined;
        data["minEffectiveToFilter"] = this.minEffectiveToFilter ? this.minEffectiveToFilter.toISOString() : <any>undefined;
        data["statusFilter"] = this.statusFilter;
        data["descriptionFilter"] = this.descriptionFilter;
        data["imageLinkFilter"] = this.imageLinkFilter;
        data["surveyNameUnsignFilter"] = this.surveyNameUnsignFilter;
        data["sorting"] = this.sorting;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data;
    }
}

export interface IGetAllSurveySettingsInput {
    filter: string | undefined;
    surveyNameFilter: string | undefined;
    surveyMonkeyCodeFilter: string | undefined;
    maxEffectiveFromFilter: moment.Moment | undefined;
    minEffectiveFromFilter: moment.Moment | undefined;
    maxEffectiveToFilter: moment.Moment | undefined;
    minEffectiveToFilter: moment.Moment | undefined;
    statusFilter: string | undefined;
    descriptionFilter: string | undefined;
    imageLinkFilter: string | undefined;
    surveyNameUnsignFilter: string | undefined;
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;
}

export class GetSurveyResultInput implements IGetSurveyResultInput {
    filter!: string | undefined;
    surveyUserFilter!: string | undefined;
    sorting!: string | undefined;
    skipCount!: number | undefined;
    maxResultCount!: number | undefined;

    constructor(data?: IGetSurveyResultInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.filter = data["filter"];
            this.surveyUserFilter = data["surveyUserFilter"];
            this.sorting = data["sorting"];
            this.skipCount = data["skipCount"];
            this.maxResultCount = data["maxResultCount"];
        }
    }

    static fromJS(data: any): GetSurveyResultInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetSurveyResultInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        data["surveyUserFilter"] = this.surveyUserFilter;
        data["sorting"] = this.sorting;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data;
    }
}

export interface IGetSurveyResultInput {
    filter: string | undefined;
    surveyUserFilter: string | undefined;
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;
}

export class PagedResultDtoOfGetSurveyResultForViewDto implements IPagedResultDtoOfGetSurveyResultForViewDto {
    totalCount!: number | undefined;
    items!: GetSurveyResultForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetSurveyResultForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetSurveyResultForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetSurveyResultForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetSurveyResultForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetSurveyResultForViewDto {
    totalCount: number | undefined;
    items: GetSurveyResultForViewDto[] | undefined;
}

export class GetSurveyResultForViewDto implements IGetSurveyResultForViewDto {
    surveyResult!: SurveyResultHeaderDto | undefined;
    surveyResultDetailDtos!: SurveysResultDetailDto[] | undefined;

    constructor(data?: IGetSurveyResultForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.surveyResult = data["surveyResult"] ? SurveyResultHeaderDto.fromJS(data["surveyResult"]) : <any>undefined;
            if (data["surveyResultDetailDtos"] && data["surveyResultDetailDtos"].constructor === Array) {
                this.surveyResultDetailDtos = [];
                for (let item of data["surveyResultDetailDtos"])
                    this.surveyResultDetailDtos.push(SurveysResultDetailDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetSurveyResultForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetSurveyResultForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyResult"] = this.surveyResult ? this.surveyResult.toJSON() : <any>undefined;
        if (this.surveyResultDetailDtos && this.surveyResultDetailDtos.constructor === Array) {
            data["surveyResultDetailDtos"] = [];
            for (let item of this.surveyResultDetailDtos)
                data["surveyResultDetailDtos"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetSurveyResultForViewDto {
    surveyResult: SurveyResultHeaderDto | undefined;
    surveyResultDetailDtos: SurveysResultDetailDto[] | undefined;
}

export class SurveyResultHeaderDto implements ISurveyResultHeaderDto {
    surveyMonkeyCode!: string | undefined;
    surveyTransactionCode!: string | undefined;
    surveyUser!: string | undefined;
    startDate!: moment.Moment | undefined;
    surveyTime!: number | undefined;
    status!: string | undefined;
    id!: number | undefined;

    constructor(data?: ISurveyResultHeaderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.surveyMonkeyCode = data["surveyMonkeyCode"];
            this.surveyTransactionCode = data["surveyTransactionCode"];
            this.surveyUser = data["surveyUser"];
            this.startDate = data["startDate"] ? moment(data["startDate"].toString()) : <any>undefined;
            this.surveyTime = data["surveyTime"];
            this.status = data["status"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SurveyResultHeaderDto {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyResultHeaderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyMonkeyCode"] = this.surveyMonkeyCode;
        data["surveyTransactionCode"] = this.surveyTransactionCode;
        data["surveyUser"] = this.surveyUser;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["surveyTime"] = this.surveyTime;
        data["status"] = this.status;
        data["id"] = this.id;
        return data;
    }
}

export interface ISurveyResultHeaderDto {
    surveyMonkeyCode: string | undefined;
    surveyTransactionCode: string | undefined;
    surveyUser: string | undefined;
    startDate: moment.Moment | undefined;
    surveyTime: number | undefined;
    status: string | undefined;
    id: number | undefined;
}

export class SurveysResultDetailDto implements ISurveysResultDetailDto {
    questionCode!: string | undefined;
    questionDescription!: string | undefined;
    timeSpend!: number | undefined;
    answerDescription!: string | undefined;
    id!: number | undefined;

    constructor(data?: ISurveysResultDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.questionCode = data["questionCode"];
            this.questionDescription = data["questionDescription"];
            this.timeSpend = data["timeSpend"];
            this.answerDescription = data["answerDescription"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SurveysResultDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new SurveysResultDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["questionCode"] = this.questionCode;
        data["questionDescription"] = this.questionDescription;
        data["timeSpend"] = this.timeSpend;
        data["answerDescription"] = this.answerDescription;
        data["id"] = this.id;
        return data;
    }
}

export interface ISurveysResultDetailDto {
    questionCode: string | undefined;
    questionDescription: string | undefined;
    timeSpend: number | undefined;
    answerDescription: string | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfGetSurveyTargetAudienceDetailForViewDto implements IPagedResultDtoOfGetSurveyTargetAudienceDetailForViewDto {
    totalCount!: number | undefined;
    items!: GetSurveyTargetAudienceDetailForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetSurveyTargetAudienceDetailForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetSurveyTargetAudienceDetailForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetSurveyTargetAudienceDetailForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetSurveyTargetAudienceDetailForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetSurveyTargetAudienceDetailForViewDto {
    totalCount: number | undefined;
    items: GetSurveyTargetAudienceDetailForViewDto[] | undefined;
}

export class GetSurveyTargetAudienceDetailForViewDto implements IGetSurveyTargetAudienceDetailForViewDto {
    surveyTargetAudienceDetail!: SurveyTargetAudienceDetailDto | undefined;

    constructor(data?: IGetSurveyTargetAudienceDetailForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.surveyTargetAudienceDetail = data["surveyTargetAudienceDetail"] ? SurveyTargetAudienceDetailDto.fromJS(data["surveyTargetAudienceDetail"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSurveyTargetAudienceDetailForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetSurveyTargetAudienceDetailForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyTargetAudienceDetail"] = this.surveyTargetAudienceDetail ? this.surveyTargetAudienceDetail.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetSurveyTargetAudienceDetailForViewDto {
    surveyTargetAudienceDetail: SurveyTargetAudienceDetailDto | undefined;
}

export class SurveyTargetAudienceDetailDto implements ISurveyTargetAudienceDetailDto {
    surveyTargetAudienceID!: number | undefined;
    name!: string | undefined;
    phone!: string | undefined;
    zaloChatID!: string | undefined;
    email!: string | undefined;
    facebookID!: string | undefined;
    memberCode!: string | undefined;
    communicationLanguage!: string | undefined;
    communicationChannel!: string | undefined;
    outletCode!: string | undefined;
    id!: number | undefined;

    constructor(data?: ISurveyTargetAudienceDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.surveyTargetAudienceID = data["surveyTargetAudienceID"];
            this.name = data["name"];
            this.phone = data["phone"];
            this.zaloChatID = data["zaloChatID"];
            this.email = data["email"];
            this.facebookID = data["facebookID"];
            this.memberCode = data["memberCode"];
            this.communicationLanguage = data["communicationLanguage"];
            this.communicationChannel = data["communicationChannel"];
            this.outletCode = data["outletCode"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SurveyTargetAudienceDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyTargetAudienceDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyTargetAudienceID"] = this.surveyTargetAudienceID;
        data["name"] = this.name;
        data["phone"] = this.phone;
        data["zaloChatID"] = this.zaloChatID;
        data["email"] = this.email;
        data["facebookID"] = this.facebookID;
        data["memberCode"] = this.memberCode;
        data["communicationLanguage"] = this.communicationLanguage;
        data["communicationChannel"] = this.communicationChannel;
        data["outletCode"] = this.outletCode;
        data["id"] = this.id;
        return data;
    }
}

export interface ISurveyTargetAudienceDetailDto {
    surveyTargetAudienceID: number | undefined;
    name: string | undefined;
    phone: string | undefined;
    zaloChatID: string | undefined;
    email: string | undefined;
    facebookID: string | undefined;
    memberCode: string | undefined;
    communicationLanguage: string | undefined;
    communicationChannel: string | undefined;
    outletCode: string | undefined;
    id: number | undefined;
}

export class GetSurveyTargetAudienceDetailForEditOutput implements IGetSurveyTargetAudienceDetailForEditOutput {
    surveyTargetAudienceDetail!: CreateOrEditSurveyTargetAudienceDetailDto | undefined;

    constructor(data?: IGetSurveyTargetAudienceDetailForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.surveyTargetAudienceDetail = data["surveyTargetAudienceDetail"] ? CreateOrEditSurveyTargetAudienceDetailDto.fromJS(data["surveyTargetAudienceDetail"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSurveyTargetAudienceDetailForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetSurveyTargetAudienceDetailForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyTargetAudienceDetail"] = this.surveyTargetAudienceDetail ? this.surveyTargetAudienceDetail.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetSurveyTargetAudienceDetailForEditOutput {
    surveyTargetAudienceDetail: CreateOrEditSurveyTargetAudienceDetailDto | undefined;
}

export class CreateOrEditSurveyTargetAudienceDetailDto implements ICreateOrEditSurveyTargetAudienceDetailDto {
    surveyTargetAudienceID!: number | undefined;
    name!: string | undefined;
    phone!: string | undefined;
    zaloChatID!: string | undefined;
    email!: string | undefined;
    facebookID!: string | undefined;
    memberCode!: string | undefined;
    communicationLanguage!: string | undefined;
    communicationChannel!: string | undefined;
    outletCode!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditSurveyTargetAudienceDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.surveyTargetAudienceID = data["surveyTargetAudienceID"];
            this.name = data["name"];
            this.phone = data["phone"];
            this.zaloChatID = data["zaloChatID"];
            this.email = data["email"];
            this.facebookID = data["facebookID"];
            this.memberCode = data["memberCode"];
            this.communicationLanguage = data["communicationLanguage"];
            this.communicationChannel = data["communicationChannel"];
            this.outletCode = data["outletCode"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditSurveyTargetAudienceDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditSurveyTargetAudienceDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyTargetAudienceID"] = this.surveyTargetAudienceID;
        data["name"] = this.name;
        data["phone"] = this.phone;
        data["zaloChatID"] = this.zaloChatID;
        data["email"] = this.email;
        data["facebookID"] = this.facebookID;
        data["memberCode"] = this.memberCode;
        data["communicationLanguage"] = this.communicationLanguage;
        data["communicationChannel"] = this.communicationChannel;
        data["outletCode"] = this.outletCode;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditSurveyTargetAudienceDetailDto {
    surveyTargetAudienceID: number | undefined;
    name: string | undefined;
    phone: string | undefined;
    zaloChatID: string | undefined;
    email: string | undefined;
    facebookID: string | undefined;
    memberCode: string | undefined;
    communicationLanguage: string | undefined;
    communicationChannel: string | undefined;
    outletCode: string | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfGetSurveyTargetAudienceForViewDto implements IPagedResultDtoOfGetSurveyTargetAudienceForViewDto {
    totalCount!: number | undefined;
    items!: GetSurveyTargetAudienceForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetSurveyTargetAudienceForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetSurveyTargetAudienceForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetSurveyTargetAudienceForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetSurveyTargetAudienceForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetSurveyTargetAudienceForViewDto {
    totalCount: number | undefined;
    items: GetSurveyTargetAudienceForViewDto[] | undefined;
}

export class GetSurveyTargetAudienceForViewDto implements IGetSurveyTargetAudienceForViewDto {
    surveyTargetAudience!: SurveyTargetAudienceDto | undefined;

    constructor(data?: IGetSurveyTargetAudienceForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.surveyTargetAudience = data["surveyTargetAudience"] ? SurveyTargetAudienceDto.fromJS(data["surveyTargetAudience"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSurveyTargetAudienceForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetSurveyTargetAudienceForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyTargetAudience"] = this.surveyTargetAudience ? this.surveyTargetAudience.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetSurveyTargetAudienceForViewDto {
    surveyTargetAudience: SurveyTargetAudienceDto | undefined;
}

export class SurveyTargetAudienceDto implements ISurveyTargetAudienceDto {
    targetAudienceName!: string | undefined;
    description!: string | undefined;
    status!: string | undefined;
    id!: number | undefined;

    constructor(data?: ISurveyTargetAudienceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.targetAudienceName = data["targetAudienceName"];
            this.description = data["description"];
            this.status = data["status"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SurveyTargetAudienceDto {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyTargetAudienceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["targetAudienceName"] = this.targetAudienceName;
        data["description"] = this.description;
        data["status"] = this.status;
        data["id"] = this.id;
        return data;
    }
}

export interface ISurveyTargetAudienceDto {
    targetAudienceName: string | undefined;
    description: string | undefined;
    status: string | undefined;
    id: number | undefined;
}

export class GetSurveyTargetAudienceForEditOutput implements IGetSurveyTargetAudienceForEditOutput {
    surveyTargetAudience!: CreateOrEditSurveyTargetAudienceDto | undefined;

    constructor(data?: IGetSurveyTargetAudienceForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.surveyTargetAudience = data["surveyTargetAudience"] ? CreateOrEditSurveyTargetAudienceDto.fromJS(data["surveyTargetAudience"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSurveyTargetAudienceForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetSurveyTargetAudienceForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyTargetAudience"] = this.surveyTargetAudience ? this.surveyTargetAudience.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetSurveyTargetAudienceForEditOutput {
    surveyTargetAudience: CreateOrEditSurveyTargetAudienceDto | undefined;
}

export class CreateOrEditSurveyTargetAudienceDto implements ICreateOrEditSurveyTargetAudienceDto {
    targetAudienceName!: string | undefined;
    description!: string | undefined;
    status!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditSurveyTargetAudienceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.targetAudienceName = data["targetAudienceName"];
            this.description = data["description"];
            this.status = data["status"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditSurveyTargetAudienceDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditSurveyTargetAudienceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["targetAudienceName"] = this.targetAudienceName;
        data["description"] = this.description;
        data["status"] = this.status;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditSurveyTargetAudienceDto {
    targetAudienceName: string | undefined;
    description: string | undefined;
    status: string | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfGetSurveyTicketDetailForViewDto implements IPagedResultDtoOfGetSurveyTicketDetailForViewDto {
    totalCount!: number | undefined;
    items!: GetSurveyTicketDetailForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetSurveyTicketDetailForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetSurveyTicketDetailForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetSurveyTicketDetailForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetSurveyTicketDetailForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetSurveyTicketDetailForViewDto {
    totalCount: number | undefined;
    items: GetSurveyTicketDetailForViewDto[] | undefined;
}

export class GetSurveyTicketDetailForViewDto implements IGetSurveyTicketDetailForViewDto {
    surveyTicketDetail!: SurveyTicketDetailDto | undefined;

    constructor(data?: IGetSurveyTicketDetailForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.surveyTicketDetail = data["surveyTicketDetail"] ? SurveyTicketDetailDto.fromJS(data["surveyTicketDetail"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSurveyTicketDetailForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetSurveyTicketDetailForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyTicketDetail"] = this.surveyTicketDetail ? this.surveyTicketDetail.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetSurveyTicketDetailForViewDto {
    surveyTicketDetail: SurveyTicketDetailDto | undefined;
}

export class SurveyTicketDetailDto implements ISurveyTicketDetailDto {
    surveyTransactionCode!: string | undefined;
    questionCode!: string | undefined;
    questionDescription!: string | undefined;
    answerID!: string | undefined;
    answerDescription!: string | undefined;
    timeSpend!: number | undefined;
    id!: number | undefined;

    constructor(data?: ISurveyTicketDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.surveyTransactionCode = data["surveyTransactionCode"];
            this.questionCode = data["questionCode"];
            this.questionDescription = data["questionDescription"];
            this.answerID = data["answerID"];
            this.answerDescription = data["answerDescription"];
            this.timeSpend = data["timeSpend"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SurveyTicketDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyTicketDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyTransactionCode"] = this.surveyTransactionCode;
        data["questionCode"] = this.questionCode;
        data["questionDescription"] = this.questionDescription;
        data["answerID"] = this.answerID;
        data["answerDescription"] = this.answerDescription;
        data["timeSpend"] = this.timeSpend;
        data["id"] = this.id;
        return data;
    }
}

export interface ISurveyTicketDetailDto {
    surveyTransactionCode: string | undefined;
    questionCode: string | undefined;
    questionDescription: string | undefined;
    answerID: string | undefined;
    answerDescription: string | undefined;
    timeSpend: number | undefined;
    id: number | undefined;
}

export class GetSurveyTicketDetailForEditOutput implements IGetSurveyTicketDetailForEditOutput {
    surveyTicketDetail!: CreateOrEditSurveyTicketDetailDto | undefined;

    constructor(data?: IGetSurveyTicketDetailForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.surveyTicketDetail = data["surveyTicketDetail"] ? CreateOrEditSurveyTicketDetailDto.fromJS(data["surveyTicketDetail"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSurveyTicketDetailForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetSurveyTicketDetailForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyTicketDetail"] = this.surveyTicketDetail ? this.surveyTicketDetail.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetSurveyTicketDetailForEditOutput {
    surveyTicketDetail: CreateOrEditSurveyTicketDetailDto | undefined;
}

export class CreateOrEditSurveyTicketDetailDto implements ICreateOrEditSurveyTicketDetailDto {
    surveyTransactionCode!: string | undefined;
    questionCode!: string | undefined;
    questionDescription!: string | undefined;
    answerID!: string | undefined;
    answerDescription!: string | undefined;
    timeSpend!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditSurveyTicketDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.surveyTransactionCode = data["surveyTransactionCode"];
            this.questionCode = data["questionCode"];
            this.questionDescription = data["questionDescription"];
            this.answerID = data["answerID"];
            this.answerDescription = data["answerDescription"];
            this.timeSpend = data["timeSpend"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditSurveyTicketDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditSurveyTicketDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyTransactionCode"] = this.surveyTransactionCode;
        data["questionCode"] = this.questionCode;
        data["questionDescription"] = this.questionDescription;
        data["answerID"] = this.answerID;
        data["answerDescription"] = this.answerDescription;
        data["timeSpend"] = this.timeSpend;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditSurveyTicketDetailDto {
    surveyTransactionCode: string | undefined;
    questionCode: string | undefined;
    questionDescription: string | undefined;
    answerID: string | undefined;
    answerDescription: string | undefined;
    timeSpend: number | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfGetSurveyTicketHeaderForViewDto implements IPagedResultDtoOfGetSurveyTicketHeaderForViewDto {
    totalCount!: number | undefined;
    items!: GetSurveyTicketHeaderForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetSurveyTicketHeaderForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetSurveyTicketHeaderForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetSurveyTicketHeaderForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetSurveyTicketHeaderForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetSurveyTicketHeaderForViewDto {
    totalCount: number | undefined;
    items: GetSurveyTicketHeaderForViewDto[] | undefined;
}

export class GetSurveyTicketHeaderForViewDto implements IGetSurveyTicketHeaderForViewDto {
    surveyTicketHeader!: SurveyTicketHeaderDto | undefined;

    constructor(data?: IGetSurveyTicketHeaderForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.surveyTicketHeader = data["surveyTicketHeader"] ? SurveyTicketHeaderDto.fromJS(data["surveyTicketHeader"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSurveyTicketHeaderForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetSurveyTicketHeaderForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyTicketHeader"] = this.surveyTicketHeader ? this.surveyTicketHeader.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetSurveyTicketHeaderForViewDto {
    surveyTicketHeader: SurveyTicketHeaderDto | undefined;
}

export class SurveyTicketHeaderDto implements ISurveyTicketHeaderDto {
    surveyTransactionCode!: string | undefined;
    surveyMonkeyCode!: string | undefined;
    surveyUser!: string | undefined;
    startDate!: moment.Moment | undefined;
    surveyTime!: number | undefined;
    status!: string | undefined;
    referenceCode!: string | undefined;
    id!: number | undefined;

    constructor(data?: ISurveyTicketHeaderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.surveyTransactionCode = data["surveyTransactionCode"];
            this.surveyMonkeyCode = data["surveyMonkeyCode"];
            this.surveyUser = data["surveyUser"];
            this.startDate = data["startDate"] ? moment(data["startDate"].toString()) : <any>undefined;
            this.surveyTime = data["surveyTime"];
            this.status = data["status"];
            this.referenceCode = data["referenceCode"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SurveyTicketHeaderDto {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyTicketHeaderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyTransactionCode"] = this.surveyTransactionCode;
        data["surveyMonkeyCode"] = this.surveyMonkeyCode;
        data["surveyUser"] = this.surveyUser;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["surveyTime"] = this.surveyTime;
        data["status"] = this.status;
        data["referenceCode"] = this.referenceCode;
        data["id"] = this.id;
        return data;
    }
}

export interface ISurveyTicketHeaderDto {
    surveyTransactionCode: string | undefined;
    surveyMonkeyCode: string | undefined;
    surveyUser: string | undefined;
    startDate: moment.Moment | undefined;
    surveyTime: number | undefined;
    status: string | undefined;
    referenceCode: string | undefined;
    id: number | undefined;
}

export class GetSurveyTicketHeaderForEditOutput implements IGetSurveyTicketHeaderForEditOutput {
    surveyTicketHeader!: CreateOrEditSurveyTicketHeaderDto | undefined;

    constructor(data?: IGetSurveyTicketHeaderForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.surveyTicketHeader = data["surveyTicketHeader"] ? CreateOrEditSurveyTicketHeaderDto.fromJS(data["surveyTicketHeader"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSurveyTicketHeaderForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetSurveyTicketHeaderForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyTicketHeader"] = this.surveyTicketHeader ? this.surveyTicketHeader.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetSurveyTicketHeaderForEditOutput {
    surveyTicketHeader: CreateOrEditSurveyTicketHeaderDto | undefined;
}

export class CreateOrEditSurveyTicketHeaderDto implements ICreateOrEditSurveyTicketHeaderDto {
    surveyTransactionCode!: string | undefined;
    surveyMonkeyCode!: string | undefined;
    surveyUser!: string | undefined;
    startDate!: moment.Moment | undefined;
    surveyTime!: number | undefined;
    status!: string | undefined;
    referenceCode!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditSurveyTicketHeaderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.surveyTransactionCode = data["surveyTransactionCode"];
            this.surveyMonkeyCode = data["surveyMonkeyCode"];
            this.surveyUser = data["surveyUser"];
            this.startDate = data["startDate"] ? moment(data["startDate"].toString()) : <any>undefined;
            this.surveyTime = data["surveyTime"];
            this.status = data["status"];
            this.referenceCode = data["referenceCode"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditSurveyTicketHeaderDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditSurveyTicketHeaderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyTransactionCode"] = this.surveyTransactionCode;
        data["surveyMonkeyCode"] = this.surveyMonkeyCode;
        data["surveyUser"] = this.surveyUser;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["surveyTime"] = this.surveyTime;
        data["status"] = this.status;
        data["referenceCode"] = this.referenceCode;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditSurveyTicketHeaderDto {
    surveyTransactionCode: string | undefined;
    surveyMonkeyCode: string | undefined;
    surveyUser: string | undefined;
    startDate: moment.Moment | undefined;
    surveyTime: number | undefined;
    status: string | undefined;
    referenceCode: string | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfGetSurveyTransactionForViewDto implements IPagedResultDtoOfGetSurveyTransactionForViewDto {
    totalCount!: number | undefined;
    items!: GetSurveyTransactionForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetSurveyTransactionForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetSurveyTransactionForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetSurveyTransactionForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetSurveyTransactionForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetSurveyTransactionForViewDto {
    totalCount: number | undefined;
    items: GetSurveyTransactionForViewDto[] | undefined;
}

export class GetSurveyTransactionForViewDto implements IGetSurveyTransactionForViewDto {
    surveyTransaction!: SurveyTransactionDto | undefined;

    constructor(data?: IGetSurveyTransactionForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.surveyTransaction = data["surveyTransaction"] ? SurveyTransactionDto.fromJS(data["surveyTransaction"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSurveyTransactionForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetSurveyTransactionForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyTransaction"] = this.surveyTransaction ? this.surveyTransaction.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetSurveyTransactionForViewDto {
    surveyTransaction: SurveyTransactionDto | undefined;
}

export class SurveyTransactionDto implements ISurveyTransactionDto {
    surveyCode!: string | undefined;
    channel!: string | undefined;
    memberName!: string | undefined;
    phone!: string | undefined;
    zaloChatID!: string | undefined;
    email!: string | undefined;
    facebookID!: string | undefined;
    memberCode!: string | undefined;
    content!: string | undefined;
    subject!: string | undefined;
    outletCode!: string | undefined;
    questionCode!: string | undefined;
    answerCode!: string | undefined;
    messageID!: string | undefined;
    id!: number | undefined;

    constructor(data?: ISurveyTransactionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.surveyCode = data["surveyCode"];
            this.channel = data["channel"];
            this.memberName = data["memberName"];
            this.phone = data["phone"];
            this.zaloChatID = data["zaloChatID"];
            this.email = data["email"];
            this.facebookID = data["facebookID"];
            this.memberCode = data["memberCode"];
            this.content = data["content"];
            this.subject = data["subject"];
            this.outletCode = data["outletCode"];
            this.questionCode = data["questionCode"];
            this.answerCode = data["answerCode"];
            this.messageID = data["messageID"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SurveyTransactionDto {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyTransactionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyCode"] = this.surveyCode;
        data["channel"] = this.channel;
        data["memberName"] = this.memberName;
        data["phone"] = this.phone;
        data["zaloChatID"] = this.zaloChatID;
        data["email"] = this.email;
        data["facebookID"] = this.facebookID;
        data["memberCode"] = this.memberCode;
        data["content"] = this.content;
        data["subject"] = this.subject;
        data["outletCode"] = this.outletCode;
        data["questionCode"] = this.questionCode;
        data["answerCode"] = this.answerCode;
        data["messageID"] = this.messageID;
        data["id"] = this.id;
        return data;
    }
}

export interface ISurveyTransactionDto {
    surveyCode: string | undefined;
    channel: string | undefined;
    memberName: string | undefined;
    phone: string | undefined;
    zaloChatID: string | undefined;
    email: string | undefined;
    facebookID: string | undefined;
    memberCode: string | undefined;
    content: string | undefined;
    subject: string | undefined;
    outletCode: string | undefined;
    questionCode: string | undefined;
    answerCode: string | undefined;
    messageID: string | undefined;
    id: number | undefined;
}

export class GetSurveyTransactionForEditOutput implements IGetSurveyTransactionForEditOutput {
    surveyTransaction!: CreateOrEditSurveyTransactionDto | undefined;

    constructor(data?: IGetSurveyTransactionForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.surveyTransaction = data["surveyTransaction"] ? CreateOrEditSurveyTransactionDto.fromJS(data["surveyTransaction"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSurveyTransactionForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetSurveyTransactionForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyTransaction"] = this.surveyTransaction ? this.surveyTransaction.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetSurveyTransactionForEditOutput {
    surveyTransaction: CreateOrEditSurveyTransactionDto | undefined;
}

export class CreateOrEditSurveyTransactionDto implements ICreateOrEditSurveyTransactionDto {
    surveyCode!: string | undefined;
    channel!: string | undefined;
    memberName!: string | undefined;
    phone!: string | undefined;
    zaloChatID!: string | undefined;
    email!: string | undefined;
    facebookID!: string | undefined;
    memberCode!: string | undefined;
    content!: string | undefined;
    subject!: string | undefined;
    outletCode!: string | undefined;
    questionCode!: string | undefined;
    answerCode!: string | undefined;
    messageID!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditSurveyTransactionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.surveyCode = data["surveyCode"];
            this.channel = data["channel"];
            this.memberName = data["memberName"];
            this.phone = data["phone"];
            this.zaloChatID = data["zaloChatID"];
            this.email = data["email"];
            this.facebookID = data["facebookID"];
            this.memberCode = data["memberCode"];
            this.content = data["content"];
            this.subject = data["subject"];
            this.outletCode = data["outletCode"];
            this.questionCode = data["questionCode"];
            this.answerCode = data["answerCode"];
            this.messageID = data["messageID"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditSurveyTransactionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditSurveyTransactionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyCode"] = this.surveyCode;
        data["channel"] = this.channel;
        data["memberName"] = this.memberName;
        data["phone"] = this.phone;
        data["zaloChatID"] = this.zaloChatID;
        data["email"] = this.email;
        data["facebookID"] = this.facebookID;
        data["memberCode"] = this.memberCode;
        data["content"] = this.content;
        data["subject"] = this.subject;
        data["outletCode"] = this.outletCode;
        data["questionCode"] = this.questionCode;
        data["answerCode"] = this.answerCode;
        data["messageID"] = this.messageID;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditSurveyTransactionDto {
    surveyCode: string | undefined;
    channel: string | undefined;
    memberName: string | undefined;
    phone: string | undefined;
    zaloChatID: string | undefined;
    email: string | undefined;
    facebookID: string | undefined;
    memberCode: string | undefined;
    content: string | undefined;
    subject: string | undefined;
    outletCode: string | undefined;
    questionCode: string | undefined;
    answerCode: string | undefined;
    messageID: string | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfGetSuspendTransactionForView implements IPagedResultDtoOfGetSuspendTransactionForView {
    totalCount!: number | undefined;
    items!: GetSuspendTransactionForView[] | undefined;

    constructor(data?: IPagedResultDtoOfGetSuspendTransactionForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetSuspendTransactionForView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetSuspendTransactionForView {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetSuspendTransactionForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetSuspendTransactionForView {
    totalCount: number | undefined;
    items: GetSuspendTransactionForView[] | undefined;
}

export class GetSuspendTransactionForView implements IGetSuspendTransactionForView {
    suspendTransaction!: SuspendTransactionDto | undefined;

    constructor(data?: IGetSuspendTransactionForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.suspendTransaction = data["suspendTransaction"] ? SuspendTransactionDto.fromJS(data["suspendTransaction"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSuspendTransactionForView {
        data = typeof data === 'object' ? data : {};
        let result = new GetSuspendTransactionForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["suspendTransaction"] = this.suspendTransaction ? this.suspendTransaction.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetSuspendTransactionForView {
    suspendTransaction: SuspendTransactionDto | undefined;
}

export class SuspendTransactionDto implements ISuspendTransactionDto {
    memberCode!: string | undefined;
    suspendedMonth!: moment.Moment | undefined;
    isActive!: boolean | undefined;
    id!: number | undefined;

    constructor(data?: ISuspendTransactionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberCode = data["memberCode"];
            this.suspendedMonth = data["suspendedMonth"] ? moment(data["suspendedMonth"].toString()) : <any>undefined;
            this.isActive = data["isActive"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SuspendTransactionDto {
        data = typeof data === 'object' ? data : {};
        let result = new SuspendTransactionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberCode"] = this.memberCode;
        data["suspendedMonth"] = this.suspendedMonth ? this.suspendedMonth.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        data["id"] = this.id;
        return data;
    }
}

export interface ISuspendTransactionDto {
    memberCode: string | undefined;
    suspendedMonth: moment.Moment | undefined;
    isActive: boolean | undefined;
    id: number | undefined;
}

export class GetSuspendTransactionForEditOutput implements IGetSuspendTransactionForEditOutput {
    suspendTransaction!: CreateOrEditSuspendTransactionDto | undefined;

    constructor(data?: IGetSuspendTransactionForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.suspendTransaction = data["suspendTransaction"] ? CreateOrEditSuspendTransactionDto.fromJS(data["suspendTransaction"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSuspendTransactionForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetSuspendTransactionForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["suspendTransaction"] = this.suspendTransaction ? this.suspendTransaction.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetSuspendTransactionForEditOutput {
    suspendTransaction: CreateOrEditSuspendTransactionDto | undefined;
}

export class CreateOrEditSuspendTransactionDto implements ICreateOrEditSuspendTransactionDto {
    memberCode!: string | undefined;
    suspendedMonth!: moment.Moment | undefined;
    isActive!: boolean | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditSuspendTransactionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberCode = data["memberCode"];
            this.suspendedMonth = data["suspendedMonth"] ? moment(data["suspendedMonth"].toString()) : <any>undefined;
            this.isActive = data["isActive"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditSuspendTransactionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditSuspendTransactionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberCode"] = this.memberCode;
        data["suspendedMonth"] = this.suspendedMonth ? this.suspendedMonth.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditSuspendTransactionDto {
    memberCode: string | undefined;
    suspendedMonth: moment.Moment | undefined;
    isActive: boolean | undefined;
    id: number | undefined;
}

export class SalesTrackingEventData implements ISalesTrackingEventData {
    maxParallelism!: number | undefined;
    numberOfWorkers!: number | undefined;
    tenantId!: number | undefined;
    userId!: number | undefined;
    eventTime!: moment.Moment | undefined;
    eventSource!: any | undefined;

    constructor(data?: ISalesTrackingEventData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.maxParallelism = data["maxParallelism"];
            this.numberOfWorkers = data["numberOfWorkers"];
            this.tenantId = data["tenantId"];
            this.userId = data["userId"];
            this.eventTime = data["eventTime"] ? moment(data["eventTime"].toString()) : <any>undefined;
            this.eventSource = data["eventSource"];
        }
    }

    static fromJS(data: any): SalesTrackingEventData {
        data = typeof data === 'object' ? data : {};
        let result = new SalesTrackingEventData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxParallelism"] = this.maxParallelism;
        data["numberOfWorkers"] = this.numberOfWorkers;
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["eventTime"] = this.eventTime ? this.eventTime.toISOString() : <any>undefined;
        data["eventSource"] = this.eventSource;
        return data;
    }
}

export interface ISalesTrackingEventData {
    maxParallelism: number | undefined;
    numberOfWorkers: number | undefined;
    tenantId: number | undefined;
    userId: number | undefined;
    eventTime: moment.Moment | undefined;
    eventSource: any | undefined;
}

export class PagedResultDtoOfGetSystemSettingForView implements IPagedResultDtoOfGetSystemSettingForView {
    totalCount!: number | undefined;
    items!: GetSystemSettingForView[] | undefined;

    constructor(data?: IPagedResultDtoOfGetSystemSettingForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetSystemSettingForView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetSystemSettingForView {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetSystemSettingForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetSystemSettingForView {
    totalCount: number | undefined;
    items: GetSystemSettingForView[] | undefined;
}

export class GetSystemSettingForView implements IGetSystemSettingForView {
    systemSetting!: SystemSettingDto | undefined;

    constructor(data?: IGetSystemSettingForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.systemSetting = data["systemSetting"] ? SystemSettingDto.fromJS(data["systemSetting"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSystemSettingForView {
        data = typeof data === 'object' ? data : {};
        let result = new GetSystemSettingForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["systemSetting"] = this.systemSetting ? this.systemSetting.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetSystemSettingForView {
    systemSetting: SystemSettingDto | undefined;
}

export class SystemSettingDto implements ISystemSettingDto {
    code!: string | undefined;
    validCoinDuration!: number | undefined;
    type!: SystemSettingDtoType | undefined;
    cutOffMonth!: number | undefined;
    baselineCron!: string | undefined;
    isActive!: boolean | undefined;
    validCoinType!: SystemSettingDtoValidCoinType | undefined;
    startPeriod!: moment.Moment | undefined;
    periodDuration!: number | undefined;
    savingPeriodStartMonth!: moment.Moment | undefined;
    savingPeriodDuration!: number | undefined;
    id!: number | undefined;

    constructor(data?: ISystemSettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.validCoinDuration = data["validCoinDuration"];
            this.type = data["type"];
            this.cutOffMonth = data["cutOffMonth"];
            this.baselineCron = data["baselineCron"];
            this.isActive = data["isActive"];
            this.validCoinType = data["validCoinType"];
            this.startPeriod = data["startPeriod"] ? moment(data["startPeriod"].toString()) : <any>undefined;
            this.periodDuration = data["periodDuration"];
            this.savingPeriodStartMonth = data["savingPeriodStartMonth"] ? moment(data["savingPeriodStartMonth"].toString()) : <any>undefined;
            this.savingPeriodDuration = data["savingPeriodDuration"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SystemSettingDto {
        data = typeof data === 'object' ? data : {};
        let result = new SystemSettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["validCoinDuration"] = this.validCoinDuration;
        data["type"] = this.type;
        data["cutOffMonth"] = this.cutOffMonth;
        data["baselineCron"] = this.baselineCron;
        data["isActive"] = this.isActive;
        data["validCoinType"] = this.validCoinType;
        data["startPeriod"] = this.startPeriod ? this.startPeriod.toISOString() : <any>undefined;
        data["periodDuration"] = this.periodDuration;
        data["savingPeriodStartMonth"] = this.savingPeriodStartMonth ? this.savingPeriodStartMonth.toISOString() : <any>undefined;
        data["savingPeriodDuration"] = this.savingPeriodDuration;
        data["id"] = this.id;
        return data;
    }
}

export interface ISystemSettingDto {
    code: string | undefined;
    validCoinDuration: number | undefined;
    type: SystemSettingDtoType | undefined;
    cutOffMonth: number | undefined;
    baselineCron: string | undefined;
    isActive: boolean | undefined;
    validCoinType: SystemSettingDtoValidCoinType | undefined;
    startPeriod: moment.Moment | undefined;
    periodDuration: number | undefined;
    savingPeriodStartMonth: moment.Moment | undefined;
    savingPeriodDuration: number | undefined;
    id: number | undefined;
}

export class GetSystemSettingForEditOutput implements IGetSystemSettingForEditOutput {
    systemSetting!: CreateOrEditSystemSettingDto | undefined;

    constructor(data?: IGetSystemSettingForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.systemSetting = data["systemSetting"] ? CreateOrEditSystemSettingDto.fromJS(data["systemSetting"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSystemSettingForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetSystemSettingForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["systemSetting"] = this.systemSetting ? this.systemSetting.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetSystemSettingForEditOutput {
    systemSetting: CreateOrEditSystemSettingDto | undefined;
}

export class CreateOrEditSystemSettingDto implements ICreateOrEditSystemSettingDto {
    code!: string;
    validCoinDuration!: number | undefined;
    type!: CreateOrEditSystemSettingDtoType | undefined;
    cutOffMonth!: number | undefined;
    isActive!: boolean | undefined;
    lastUpdateByName!: string | undefined;
    savingPeriodDuration!: number | undefined;
    savingPeriodStartMonth!: moment.Moment | undefined;
    coinExpirationSetting!: CreateOrEditCoinExpirationSettingDto | undefined;
    isDeleted!: boolean | undefined;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: moment.Moment | undefined;
    creatorUserId!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditSystemSettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.validCoinDuration = data["validCoinDuration"];
            this.type = data["type"];
            this.cutOffMonth = data["cutOffMonth"];
            this.isActive = data["isActive"];
            this.lastUpdateByName = data["lastUpdateByName"];
            this.savingPeriodDuration = data["savingPeriodDuration"];
            this.savingPeriodStartMonth = data["savingPeriodStartMonth"] ? moment(data["savingPeriodStartMonth"].toString()) : <any>undefined;
            this.coinExpirationSetting = data["coinExpirationSetting"] ? CreateOrEditCoinExpirationSettingDto.fromJS(data["coinExpirationSetting"]) : <any>undefined;
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditSystemSettingDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditSystemSettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["validCoinDuration"] = this.validCoinDuration;
        data["type"] = this.type;
        data["cutOffMonth"] = this.cutOffMonth;
        data["isActive"] = this.isActive;
        data["lastUpdateByName"] = this.lastUpdateByName;
        data["savingPeriodDuration"] = this.savingPeriodDuration;
        data["savingPeriodStartMonth"] = this.savingPeriodStartMonth ? this.savingPeriodStartMonth.toISOString() : <any>undefined;
        data["coinExpirationSetting"] = this.coinExpirationSetting ? this.coinExpirationSetting.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditSystemSettingDto {
    code: string;
    validCoinDuration: number | undefined;
    type: CreateOrEditSystemSettingDtoType | undefined;
    cutOffMonth: number | undefined;
    isActive: boolean | undefined;
    lastUpdateByName: string | undefined;
    savingPeriodDuration: number | undefined;
    savingPeriodStartMonth: moment.Moment | undefined;
    coinExpirationSetting: CreateOrEditCoinExpirationSettingDto | undefined;
    isDeleted: boolean | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfGetTagForView implements IPagedResultDtoOfGetTagForView {
    totalCount!: number | undefined;
    items!: GetTagForView[] | undefined;

    constructor(data?: IPagedResultDtoOfGetTagForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetTagForView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetTagForView {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetTagForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetTagForView {
    totalCount: number | undefined;
    items: GetTagForView[] | undefined;
}

export class GetTagForView implements IGetTagForView {
    tag!: TagDto | undefined;

    constructor(data?: IGetTagForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tag = data["tag"] ? TagDto.fromJS(data["tag"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetTagForView {
        data = typeof data === 'object' ? data : {};
        let result = new GetTagForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tag"] = this.tag ? this.tag.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetTagForView {
    tag: TagDto | undefined;
}

export class TagDto implements ITagDto {
    value!: string | undefined;
    id!: number | undefined;

    constructor(data?: ITagDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.value = data["value"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): TagDto {
        data = typeof data === 'object' ? data : {};
        let result = new TagDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["id"] = this.id;
        return data;
    }
}

export interface ITagDto {
    value: string | undefined;
    id: number | undefined;
}

export class GetTagForEditOutput implements IGetTagForEditOutput {
    tag!: CreateOrEditTagDto | undefined;

    constructor(data?: IGetTagForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tag = data["tag"] ? CreateOrEditTagDto.fromJS(data["tag"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetTagForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetTagForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tag"] = this.tag ? this.tag.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetTagForEditOutput {
    tag: CreateOrEditTagDto | undefined;
}

export class CreateOrEditTagDto implements ICreateOrEditTagDto {
    value!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditTagDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.value = data["value"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditTagDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditTagDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditTagDto {
    value: string | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfGetTargetAudienceDetailForViewDto implements IPagedResultDtoOfGetTargetAudienceDetailForViewDto {
    totalCount!: number | undefined;
    items!: GetTargetAudienceDetailForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetTargetAudienceDetailForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetTargetAudienceDetailForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetTargetAudienceDetailForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetTargetAudienceDetailForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetTargetAudienceDetailForViewDto {
    totalCount: number | undefined;
    items: GetTargetAudienceDetailForViewDto[] | undefined;
}

export class GetTargetAudienceDetailForViewDto implements IGetTargetAudienceDetailForViewDto {
    targetAudienceDetail!: TargetAudienceDetailDto | undefined;

    constructor(data?: IGetTargetAudienceDetailForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.targetAudienceDetail = data["targetAudienceDetail"] ? TargetAudienceDetailDto.fromJS(data["targetAudienceDetail"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetTargetAudienceDetailForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetTargetAudienceDetailForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["targetAudienceDetail"] = this.targetAudienceDetail ? this.targetAudienceDetail.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetTargetAudienceDetailForViewDto {
    targetAudienceDetail: TargetAudienceDetailDto | undefined;
}

export class TargetAudienceDetailDto implements ITargetAudienceDetailDto {
    conditionType!: string | undefined;
    conditionName!: string | undefined;
    operator!: string | undefined;
    valueFrom!: string | undefined;
    valueTo!: string | undefined;
    valueFromNumber!: number | undefined;
    valueToNumber!: number | undefined;
    valueFromDate!: moment.Moment | undefined;
    valueToDate!: moment.Moment | undefined;
    targetAudienceID!: number | undefined;
    id!: number | undefined;

    constructor(data?: ITargetAudienceDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.conditionType = data["conditionType"];
            this.conditionName = data["conditionName"];
            this.operator = data["operator"];
            this.valueFrom = data["valueFrom"];
            this.valueTo = data["valueTo"];
            this.valueFromNumber = data["valueFromNumber"];
            this.valueToNumber = data["valueToNumber"];
            this.valueFromDate = data["valueFromDate"] ? moment(data["valueFromDate"].toString()) : <any>undefined;
            this.valueToDate = data["valueToDate"] ? moment(data["valueToDate"].toString()) : <any>undefined;
            this.targetAudienceID = data["targetAudienceID"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): TargetAudienceDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new TargetAudienceDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["conditionType"] = this.conditionType;
        data["conditionName"] = this.conditionName;
        data["operator"] = this.operator;
        data["valueFrom"] = this.valueFrom;
        data["valueTo"] = this.valueTo;
        data["valueFromNumber"] = this.valueFromNumber;
        data["valueToNumber"] = this.valueToNumber;
        data["valueFromDate"] = this.valueFromDate ? this.valueFromDate.toISOString() : <any>undefined;
        data["valueToDate"] = this.valueToDate ? this.valueToDate.toISOString() : <any>undefined;
        data["targetAudienceID"] = this.targetAudienceID;
        data["id"] = this.id;
        return data;
    }
}

export interface ITargetAudienceDetailDto {
    conditionType: string | undefined;
    conditionName: string | undefined;
    operator: string | undefined;
    valueFrom: string | undefined;
    valueTo: string | undefined;
    valueFromNumber: number | undefined;
    valueToNumber: number | undefined;
    valueFromDate: moment.Moment | undefined;
    valueToDate: moment.Moment | undefined;
    targetAudienceID: number | undefined;
    id: number | undefined;
}

export class GetTargetAudienceDetailForEditOutput implements IGetTargetAudienceDetailForEditOutput {
    targetAudienceDetail!: CreateOrEditTargetAudienceDetailDto | undefined;

    constructor(data?: IGetTargetAudienceDetailForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.targetAudienceDetail = data["targetAudienceDetail"] ? CreateOrEditTargetAudienceDetailDto.fromJS(data["targetAudienceDetail"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetTargetAudienceDetailForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetTargetAudienceDetailForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["targetAudienceDetail"] = this.targetAudienceDetail ? this.targetAudienceDetail.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetTargetAudienceDetailForEditOutput {
    targetAudienceDetail: CreateOrEditTargetAudienceDetailDto | undefined;
}

export class CreateOrEditTargetAudienceDetailDto implements ICreateOrEditTargetAudienceDetailDto {
    conditionType!: string | undefined;
    conditionName!: string | undefined;
    operator!: string | undefined;
    valueFrom!: string | undefined;
    valueTo!: string | undefined;
    valueFromNumber!: number | undefined;
    valueToNumber!: number | undefined;
    valueFromDate!: moment.Moment | undefined;
    valueToDate!: moment.Moment | undefined;
    targetAudienceID!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditTargetAudienceDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.conditionType = data["conditionType"];
            this.conditionName = data["conditionName"];
            this.operator = data["operator"];
            this.valueFrom = data["valueFrom"];
            this.valueTo = data["valueTo"];
            this.valueFromNumber = data["valueFromNumber"];
            this.valueToNumber = data["valueToNumber"];
            this.valueFromDate = data["valueFromDate"] ? moment(data["valueFromDate"].toString()) : <any>undefined;
            this.valueToDate = data["valueToDate"] ? moment(data["valueToDate"].toString()) : <any>undefined;
            this.targetAudienceID = data["targetAudienceID"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditTargetAudienceDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditTargetAudienceDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["conditionType"] = this.conditionType;
        data["conditionName"] = this.conditionName;
        data["operator"] = this.operator;
        data["valueFrom"] = this.valueFrom;
        data["valueTo"] = this.valueTo;
        data["valueFromNumber"] = this.valueFromNumber;
        data["valueToNumber"] = this.valueToNumber;
        data["valueFromDate"] = this.valueFromDate ? this.valueFromDate.toISOString() : <any>undefined;
        data["valueToDate"] = this.valueToDate ? this.valueToDate.toISOString() : <any>undefined;
        data["targetAudienceID"] = this.targetAudienceID;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditTargetAudienceDetailDto {
    conditionType: string | undefined;
    conditionName: string | undefined;
    operator: string | undefined;
    valueFrom: string | undefined;
    valueTo: string | undefined;
    valueFromNumber: number | undefined;
    valueToNumber: number | undefined;
    valueFromDate: moment.Moment | undefined;
    valueToDate: moment.Moment | undefined;
    targetAudienceID: number | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfGetTargetAudienceHeaderForViewDto implements IPagedResultDtoOfGetTargetAudienceHeaderForViewDto {
    totalCount!: number | undefined;
    items!: GetTargetAudienceHeaderForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetTargetAudienceHeaderForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetTargetAudienceHeaderForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetTargetAudienceHeaderForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetTargetAudienceHeaderForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetTargetAudienceHeaderForViewDto {
    totalCount: number | undefined;
    items: GetTargetAudienceHeaderForViewDto[] | undefined;
}

export class GetTargetAudienceHeaderForViewDto implements IGetTargetAudienceHeaderForViewDto {
    targetAudienceHeader!: TargetAudienceHeaderDto | undefined;
    totalUser!: number | undefined;

    constructor(data?: IGetTargetAudienceHeaderForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.targetAudienceHeader = data["targetAudienceHeader"] ? TargetAudienceHeaderDto.fromJS(data["targetAudienceHeader"]) : <any>undefined;
            this.totalUser = data["totalUser"];
        }
    }

    static fromJS(data: any): GetTargetAudienceHeaderForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetTargetAudienceHeaderForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["targetAudienceHeader"] = this.targetAudienceHeader ? this.targetAudienceHeader.toJSON() : <any>undefined;
        data["totalUser"] = this.totalUser;
        return data;
    }
}

export interface IGetTargetAudienceHeaderForViewDto {
    targetAudienceHeader: TargetAudienceHeaderDto | undefined;
    totalUser: number | undefined;
}

export class TargetAudienceHeaderDto implements ITargetAudienceHeaderDto {
    targetAudienceName!: string | undefined;
    description!: string | undefined;
    status!: string | undefined;
    applyForMembership!: boolean | undefined;
    selectTOP!: boolean | undefined;
    conditionTOPSorting!: string | undefined;
    quantityTOPGroup!: number | undefined;
    targetAudienceNameUnsign!: string | undefined;
    isFixedList!: boolean | undefined;
    numberOfMember!: number | undefined;
    scheduleTime!: number | undefined;
    lastRunTime!: moment.Moment | undefined;
    nextRunTime!: moment.Moment | undefined;
    runStatus!: string | undefined;
    creationTime!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;
    id!: number | undefined;

    constructor(data?: ITargetAudienceHeaderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.targetAudienceName = data["targetAudienceName"];
            this.description = data["description"];
            this.status = data["status"];
            this.applyForMembership = data["applyForMembership"];
            this.selectTOP = data["selectTOP"];
            this.conditionTOPSorting = data["conditionTOPSorting"];
            this.quantityTOPGroup = data["quantityTOPGroup"];
            this.targetAudienceNameUnsign = data["targetAudienceNameUnsign"];
            this.isFixedList = data["isFixedList"];
            this.numberOfMember = data["numberOfMember"];
            this.scheduleTime = data["scheduleTime"];
            this.lastRunTime = data["lastRunTime"] ? moment(data["lastRunTime"].toString()) : <any>undefined;
            this.nextRunTime = data["nextRunTime"] ? moment(data["nextRunTime"].toString()) : <any>undefined;
            this.runStatus = data["runStatus"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): TargetAudienceHeaderDto {
        data = typeof data === 'object' ? data : {};
        let result = new TargetAudienceHeaderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["targetAudienceName"] = this.targetAudienceName;
        data["description"] = this.description;
        data["status"] = this.status;
        data["applyForMembership"] = this.applyForMembership;
        data["selectTOP"] = this.selectTOP;
        data["conditionTOPSorting"] = this.conditionTOPSorting;
        data["quantityTOPGroup"] = this.quantityTOPGroup;
        data["targetAudienceNameUnsign"] = this.targetAudienceNameUnsign;
        data["isFixedList"] = this.isFixedList;
        data["numberOfMember"] = this.numberOfMember;
        data["scheduleTime"] = this.scheduleTime;
        data["lastRunTime"] = this.lastRunTime ? this.lastRunTime.toISOString() : <any>undefined;
        data["nextRunTime"] = this.nextRunTime ? this.nextRunTime.toISOString() : <any>undefined;
        data["runStatus"] = this.runStatus;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface ITargetAudienceHeaderDto {
    targetAudienceName: string | undefined;
    description: string | undefined;
    status: string | undefined;
    applyForMembership: boolean | undefined;
    selectTOP: boolean | undefined;
    conditionTOPSorting: string | undefined;
    quantityTOPGroup: number | undefined;
    targetAudienceNameUnsign: string | undefined;
    isFixedList: boolean | undefined;
    numberOfMember: number | undefined;
    scheduleTime: number | undefined;
    lastRunTime: moment.Moment | undefined;
    nextRunTime: moment.Moment | undefined;
    runStatus: string | undefined;
    creationTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    id: number | undefined;
}

export class GetTargetAudienceHeaderForEditOutput implements IGetTargetAudienceHeaderForEditOutput {
    targetAudienceHeader!: CreateOrEditTargetAudienceHeaderDto | undefined;
    targetAudienceDetail!: CreateOrEditTargetAudienceDetailDto[] | undefined;
    divitionConditionValueName!: string | undefined;
    departmentConditionValueName!: string | undefined;
    classConditionValueName!: string | undefined;
    brandConditionValueName!: string | undefined;
    paymentMethodConditionValueName!: string | undefined;

    constructor(data?: IGetTargetAudienceHeaderForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.targetAudienceHeader = data["targetAudienceHeader"] ? CreateOrEditTargetAudienceHeaderDto.fromJS(data["targetAudienceHeader"]) : <any>undefined;
            if (data["targetAudienceDetail"] && data["targetAudienceDetail"].constructor === Array) {
                this.targetAudienceDetail = [];
                for (let item of data["targetAudienceDetail"])
                    this.targetAudienceDetail.push(CreateOrEditTargetAudienceDetailDto.fromJS(item));
            }
            this.divitionConditionValueName = data["divitionConditionValueName"];
            this.departmentConditionValueName = data["departmentConditionValueName"];
            this.classConditionValueName = data["classConditionValueName"];
            this.brandConditionValueName = data["brandConditionValueName"];
            this.paymentMethodConditionValueName = data["paymentMethodConditionValueName"];
        }
    }

    static fromJS(data: any): GetTargetAudienceHeaderForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetTargetAudienceHeaderForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["targetAudienceHeader"] = this.targetAudienceHeader ? this.targetAudienceHeader.toJSON() : <any>undefined;
        if (this.targetAudienceDetail && this.targetAudienceDetail.constructor === Array) {
            data["targetAudienceDetail"] = [];
            for (let item of this.targetAudienceDetail)
                data["targetAudienceDetail"].push(item.toJSON());
        }
        data["divitionConditionValueName"] = this.divitionConditionValueName;
        data["departmentConditionValueName"] = this.departmentConditionValueName;
        data["classConditionValueName"] = this.classConditionValueName;
        data["brandConditionValueName"] = this.brandConditionValueName;
        data["paymentMethodConditionValueName"] = this.paymentMethodConditionValueName;
        return data;
    }
}

export interface IGetTargetAudienceHeaderForEditOutput {
    targetAudienceHeader: CreateOrEditTargetAudienceHeaderDto | undefined;
    targetAudienceDetail: CreateOrEditTargetAudienceDetailDto[] | undefined;
    divitionConditionValueName: string | undefined;
    departmentConditionValueName: string | undefined;
    classConditionValueName: string | undefined;
    brandConditionValueName: string | undefined;
    paymentMethodConditionValueName: string | undefined;
}

export class CreateOrEditTargetAudienceHeaderDto implements ICreateOrEditTargetAudienceHeaderDto {
    targetAudienceName!: string | undefined;
    description!: string | undefined;
    status!: string | undefined;
    applyForMembership!: boolean | undefined;
    selectTOP!: boolean | undefined;
    conditionTOPSorting!: string | undefined;
    quantityTOPGroup!: number | undefined;
    targetAudienceNameUnsign!: string | undefined;
    isFixedList!: boolean | undefined;
    numberOfMember!: number | undefined;
    scheduleTime!: number | undefined;
    lastRunTime!: moment.Moment | undefined;
    nextRunTime!: moment.Moment | undefined;
    runStatus!: string | undefined;
    lastModificationTime!: moment.Moment | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditTargetAudienceHeaderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.targetAudienceName = data["targetAudienceName"];
            this.description = data["description"];
            this.status = data["status"];
            this.applyForMembership = data["applyForMembership"];
            this.selectTOP = data["selectTOP"];
            this.conditionTOPSorting = data["conditionTOPSorting"];
            this.quantityTOPGroup = data["quantityTOPGroup"];
            this.targetAudienceNameUnsign = data["targetAudienceNameUnsign"];
            this.isFixedList = data["isFixedList"];
            this.numberOfMember = data["numberOfMember"];
            this.scheduleTime = data["scheduleTime"];
            this.lastRunTime = data["lastRunTime"] ? moment(data["lastRunTime"].toString()) : <any>undefined;
            this.nextRunTime = data["nextRunTime"] ? moment(data["nextRunTime"].toString()) : <any>undefined;
            this.runStatus = data["runStatus"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditTargetAudienceHeaderDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditTargetAudienceHeaderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["targetAudienceName"] = this.targetAudienceName;
        data["description"] = this.description;
        data["status"] = this.status;
        data["applyForMembership"] = this.applyForMembership;
        data["selectTOP"] = this.selectTOP;
        data["conditionTOPSorting"] = this.conditionTOPSorting;
        data["quantityTOPGroup"] = this.quantityTOPGroup;
        data["targetAudienceNameUnsign"] = this.targetAudienceNameUnsign;
        data["isFixedList"] = this.isFixedList;
        data["numberOfMember"] = this.numberOfMember;
        data["scheduleTime"] = this.scheduleTime;
        data["lastRunTime"] = this.lastRunTime ? this.lastRunTime.toISOString() : <any>undefined;
        data["nextRunTime"] = this.nextRunTime ? this.nextRunTime.toISOString() : <any>undefined;
        data["runStatus"] = this.runStatus;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditTargetAudienceHeaderDto {
    targetAudienceName: string | undefined;
    description: string | undefined;
    status: string | undefined;
    applyForMembership: boolean | undefined;
    selectTOP: boolean | undefined;
    conditionTOPSorting: string | undefined;
    quantityTOPGroup: number | undefined;
    targetAudienceNameUnsign: string | undefined;
    isFixedList: boolean | undefined;
    numberOfMember: number | undefined;
    scheduleTime: number | undefined;
    lastRunTime: moment.Moment | undefined;
    nextRunTime: moment.Moment | undefined;
    runStatus: string | undefined;
    lastModificationTime: moment.Moment | undefined;
    id: number | undefined;
}

export class CreateOrEditTargetAudienceDtoCustom implements ICreateOrEditTargetAudienceDtoCustom {
    header!: CreateOrEditTargetAudienceHeaderDto | undefined;
    details!: CreateOrEditTargetAudienceDetailDto[] | undefined;

    constructor(data?: ICreateOrEditTargetAudienceDtoCustom) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.header = data["header"] ? CreateOrEditTargetAudienceHeaderDto.fromJS(data["header"]) : <any>undefined;
            if (data["details"] && data["details"].constructor === Array) {
                this.details = [];
                for (let item of data["details"])
                    this.details.push(CreateOrEditTargetAudienceDetailDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOrEditTargetAudienceDtoCustom {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditTargetAudienceDtoCustom();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["header"] = this.header ? this.header.toJSON() : <any>undefined;
        if (this.details && this.details.constructor === Array) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateOrEditTargetAudienceDtoCustom {
    header: CreateOrEditTargetAudienceHeaderDto | undefined;
    details: CreateOrEditTargetAudienceDetailDto[] | undefined;
}

export class GetAllTargetAudienceHeadersInput implements IGetAllTargetAudienceHeadersInput {
    filter!: string | undefined;
    targetAudienceNameFilter!: string | undefined;
    descriptionFilter!: string | undefined;
    statusFilter!: string | undefined;
    applyForMembershipFilter!: number | undefined;
    selectTOPFilter!: number | undefined;
    conditionTOPSortingFilter!: string | undefined;
    maxQuantityTOPGroupFilter!: number | undefined;
    minQuantityTOPGroupFilter!: number | undefined;
    targetAudienceNameUnsignFilter!: string | undefined;
    isFixedListFilter!: number | undefined;
    maxNumberOfMemberFilter!: number | undefined;
    minNumberOfMemberFilter!: number | undefined;
    maxScheduleTimeFilter!: number | undefined;
    minScheduleTimeFilter!: number | undefined;
    maxLastRunTimeFilter!: moment.Moment | undefined;
    minLastRunTimeFilter!: moment.Moment | undefined;
    maxNextRunTimeFilter!: moment.Moment | undefined;
    minNextRunTimeFilter!: moment.Moment | undefined;
    runStatusFilter!: string | undefined;
    idFilter!: string | undefined;
    sorting!: string | undefined;
    skipCount!: number | undefined;
    maxResultCount!: number | undefined;

    constructor(data?: IGetAllTargetAudienceHeadersInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.filter = data["filter"];
            this.targetAudienceNameFilter = data["targetAudienceNameFilter"];
            this.descriptionFilter = data["descriptionFilter"];
            this.statusFilter = data["statusFilter"];
            this.applyForMembershipFilter = data["applyForMembershipFilter"];
            this.selectTOPFilter = data["selectTOPFilter"];
            this.conditionTOPSortingFilter = data["conditionTOPSortingFilter"];
            this.maxQuantityTOPGroupFilter = data["maxQuantityTOPGroupFilter"];
            this.minQuantityTOPGroupFilter = data["minQuantityTOPGroupFilter"];
            this.targetAudienceNameUnsignFilter = data["targetAudienceNameUnsignFilter"];
            this.isFixedListFilter = data["isFixedListFilter"];
            this.maxNumberOfMemberFilter = data["maxNumberOfMemberFilter"];
            this.minNumberOfMemberFilter = data["minNumberOfMemberFilter"];
            this.maxScheduleTimeFilter = data["maxScheduleTimeFilter"];
            this.minScheduleTimeFilter = data["minScheduleTimeFilter"];
            this.maxLastRunTimeFilter = data["maxLastRunTimeFilter"] ? moment(data["maxLastRunTimeFilter"].toString()) : <any>undefined;
            this.minLastRunTimeFilter = data["minLastRunTimeFilter"] ? moment(data["minLastRunTimeFilter"].toString()) : <any>undefined;
            this.maxNextRunTimeFilter = data["maxNextRunTimeFilter"] ? moment(data["maxNextRunTimeFilter"].toString()) : <any>undefined;
            this.minNextRunTimeFilter = data["minNextRunTimeFilter"] ? moment(data["minNextRunTimeFilter"].toString()) : <any>undefined;
            this.runStatusFilter = data["runStatusFilter"];
            this.idFilter = data["idFilter"];
            this.sorting = data["sorting"];
            this.skipCount = data["skipCount"];
            this.maxResultCount = data["maxResultCount"];
        }
    }

    static fromJS(data: any): GetAllTargetAudienceHeadersInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllTargetAudienceHeadersInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        data["targetAudienceNameFilter"] = this.targetAudienceNameFilter;
        data["descriptionFilter"] = this.descriptionFilter;
        data["statusFilter"] = this.statusFilter;
        data["applyForMembershipFilter"] = this.applyForMembershipFilter;
        data["selectTOPFilter"] = this.selectTOPFilter;
        data["conditionTOPSortingFilter"] = this.conditionTOPSortingFilter;
        data["maxQuantityTOPGroupFilter"] = this.maxQuantityTOPGroupFilter;
        data["minQuantityTOPGroupFilter"] = this.minQuantityTOPGroupFilter;
        data["targetAudienceNameUnsignFilter"] = this.targetAudienceNameUnsignFilter;
        data["isFixedListFilter"] = this.isFixedListFilter;
        data["maxNumberOfMemberFilter"] = this.maxNumberOfMemberFilter;
        data["minNumberOfMemberFilter"] = this.minNumberOfMemberFilter;
        data["maxScheduleTimeFilter"] = this.maxScheduleTimeFilter;
        data["minScheduleTimeFilter"] = this.minScheduleTimeFilter;
        data["maxLastRunTimeFilter"] = this.maxLastRunTimeFilter ? this.maxLastRunTimeFilter.toISOString() : <any>undefined;
        data["minLastRunTimeFilter"] = this.minLastRunTimeFilter ? this.minLastRunTimeFilter.toISOString() : <any>undefined;
        data["maxNextRunTimeFilter"] = this.maxNextRunTimeFilter ? this.maxNextRunTimeFilter.toISOString() : <any>undefined;
        data["minNextRunTimeFilter"] = this.minNextRunTimeFilter ? this.minNextRunTimeFilter.toISOString() : <any>undefined;
        data["runStatusFilter"] = this.runStatusFilter;
        data["idFilter"] = this.idFilter;
        data["sorting"] = this.sorting;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data;
    }
}

export interface IGetAllTargetAudienceHeadersInput {
    filter: string | undefined;
    targetAudienceNameFilter: string | undefined;
    descriptionFilter: string | undefined;
    statusFilter: string | undefined;
    applyForMembershipFilter: number | undefined;
    selectTOPFilter: number | undefined;
    conditionTOPSortingFilter: string | undefined;
    maxQuantityTOPGroupFilter: number | undefined;
    minQuantityTOPGroupFilter: number | undefined;
    targetAudienceNameUnsignFilter: string | undefined;
    isFixedListFilter: number | undefined;
    maxNumberOfMemberFilter: number | undefined;
    minNumberOfMemberFilter: number | undefined;
    maxScheduleTimeFilter: number | undefined;
    minScheduleTimeFilter: number | undefined;
    maxLastRunTimeFilter: moment.Moment | undefined;
    minLastRunTimeFilter: moment.Moment | undefined;
    maxNextRunTimeFilter: moment.Moment | undefined;
    minNextRunTimeFilter: moment.Moment | undefined;
    runStatusFilter: string | undefined;
    idFilter: string | undefined;
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;
}

export class SegmentationAgrs implements ISegmentationAgrs {
    targetAudienceHeaderId!: number | undefined;
    targetAudienceHeaderName!: string | undefined;
    memberCode!: string | undefined;
    userId!: number | undefined;
    tenantId!: number | undefined;

    constructor(data?: ISegmentationAgrs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.targetAudienceHeaderId = data["targetAudienceHeaderId"];
            this.targetAudienceHeaderName = data["targetAudienceHeaderName"];
            this.memberCode = data["memberCode"];
            this.userId = data["userId"];
            this.tenantId = data["tenantId"];
        }
    }

    static fromJS(data: any): SegmentationAgrs {
        data = typeof data === 'object' ? data : {};
        let result = new SegmentationAgrs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["targetAudienceHeaderId"] = this.targetAudienceHeaderId;
        data["targetAudienceHeaderName"] = this.targetAudienceHeaderName;
        data["memberCode"] = this.memberCode;
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        return data;
    }
}

export interface ISegmentationAgrs {
    targetAudienceHeaderId: number | undefined;
    targetAudienceHeaderName: string | undefined;
    memberCode: string | undefined;
    userId: number | undefined;
    tenantId: number | undefined;
}

export class GetTargetAudienceByCodeForView implements IGetTargetAudienceByCodeForView {
    listResult!: TargetAudienceByCodeForView[] | undefined;

    constructor(data?: IGetTargetAudienceByCodeForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["listResult"] && data["listResult"].constructor === Array) {
                this.listResult = [];
                for (let item of data["listResult"])
                    this.listResult.push(TargetAudienceByCodeForView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetTargetAudienceByCodeForView {
        data = typeof data === 'object' ? data : {};
        let result = new GetTargetAudienceByCodeForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.listResult && this.listResult.constructor === Array) {
            data["listResult"] = [];
            for (let item of this.listResult)
                data["listResult"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetTargetAudienceByCodeForView {
    listResult: TargetAudienceByCodeForView[] | undefined;
}

export class TargetAudienceByCodeForView implements ITargetAudienceByCodeForView {
    code!: string | undefined;
    name!: string | undefined;

    constructor(data?: ITargetAudienceByCodeForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.name = data["name"];
        }
    }

    static fromJS(data: any): TargetAudienceByCodeForView {
        data = typeof data === 'object' ? data : {};
        let result = new TargetAudienceByCodeForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        return data;
    }
}

export interface ITargetAudienceByCodeForView {
    code: string | undefined;
    name: string | undefined;
}

export class GetTargetAudienceLevel implements IGetTargetAudienceLevel {
    listCode!: string | undefined;
    listName!: string | undefined;
    level!: number | undefined;
    item!: TargetAudienceInfo | undefined;

    constructor(data?: IGetTargetAudienceLevel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.listCode = data["listCode"];
            this.listName = data["listName"];
            this.level = data["level"];
            this.item = data["item"] ? TargetAudienceInfo.fromJS(data["item"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetTargetAudienceLevel {
        data = typeof data === 'object' ? data : {};
        let result = new GetTargetAudienceLevel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["listCode"] = this.listCode;
        data["listName"] = this.listName;
        data["level"] = this.level;
        data["item"] = this.item ? this.item.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetTargetAudienceLevel {
    listCode: string | undefined;
    listName: string | undefined;
    level: number | undefined;
    item: TargetAudienceInfo | undefined;
}

export class TargetAudienceInfo implements ITargetAudienceInfo {
    code!: string | undefined;
    name!: string | undefined;
    parentCode!: string | undefined;

    constructor(data?: ITargetAudienceInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.name = data["name"];
            this.parentCode = data["parentCode"];
        }
    }

    static fromJS(data: any): TargetAudienceInfo {
        data = typeof data === 'object' ? data : {};
        let result = new TargetAudienceInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["parentCode"] = this.parentCode;
        return data;
    }
}

export interface ITargetAudienceInfo {
    code: string | undefined;
    name: string | undefined;
    parentCode: string | undefined;
}

export class PagedResultDtoOfGetTargetAudienceUserForViewDto implements IPagedResultDtoOfGetTargetAudienceUserForViewDto {
    totalCount!: number | undefined;
    items!: GetTargetAudienceUserForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetTargetAudienceUserForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetTargetAudienceUserForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetTargetAudienceUserForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetTargetAudienceUserForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetTargetAudienceUserForViewDto {
    totalCount: number | undefined;
    items: GetTargetAudienceUserForViewDto[] | undefined;
}

export class GetTargetAudienceUserForViewDto implements IGetTargetAudienceUserForViewDto {
    targetAudienceUser!: TargetAudienceUserDto | undefined;

    constructor(data?: IGetTargetAudienceUserForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.targetAudienceUser = data["targetAudienceUser"] ? TargetAudienceUserDto.fromJS(data["targetAudienceUser"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetTargetAudienceUserForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetTargetAudienceUserForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["targetAudienceUser"] = this.targetAudienceUser ? this.targetAudienceUser.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetTargetAudienceUserForViewDto {
    targetAudienceUser: TargetAudienceUserDto | undefined;
}

export class TargetAudienceUserDto implements ITargetAudienceUserDto {
    name!: string | undefined;
    phone!: string | undefined;
    zaloChatID!: string | undefined;
    email!: string | undefined;
    facebookID!: string | undefined;
    memberCode!: string | undefined;
    communicationLanguage!: string | undefined;
    nameUnSign!: string | undefined;
    targetAudienceID!: number | undefined;
    id!: number | undefined;

    constructor(data?: ITargetAudienceUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.phone = data["phone"];
            this.zaloChatID = data["zaloChatID"];
            this.email = data["email"];
            this.facebookID = data["facebookID"];
            this.memberCode = data["memberCode"];
            this.communicationLanguage = data["communicationLanguage"];
            this.nameUnSign = data["nameUnSign"];
            this.targetAudienceID = data["targetAudienceID"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): TargetAudienceUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new TargetAudienceUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["phone"] = this.phone;
        data["zaloChatID"] = this.zaloChatID;
        data["email"] = this.email;
        data["facebookID"] = this.facebookID;
        data["memberCode"] = this.memberCode;
        data["communicationLanguage"] = this.communicationLanguage;
        data["nameUnSign"] = this.nameUnSign;
        data["targetAudienceID"] = this.targetAudienceID;
        data["id"] = this.id;
        return data;
    }
}

export interface ITargetAudienceUserDto {
    name: string | undefined;
    phone: string | undefined;
    zaloChatID: string | undefined;
    email: string | undefined;
    facebookID: string | undefined;
    memberCode: string | undefined;
    communicationLanguage: string | undefined;
    nameUnSign: string | undefined;
    targetAudienceID: number | undefined;
    id: number | undefined;
}

export class GetTargetAudienceUserForEditOutput implements IGetTargetAudienceUserForEditOutput {
    targetAudienceUser!: CreateOrEditTargetAudienceUserDto | undefined;

    constructor(data?: IGetTargetAudienceUserForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.targetAudienceUser = data["targetAudienceUser"] ? CreateOrEditTargetAudienceUserDto.fromJS(data["targetAudienceUser"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetTargetAudienceUserForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetTargetAudienceUserForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["targetAudienceUser"] = this.targetAudienceUser ? this.targetAudienceUser.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetTargetAudienceUserForEditOutput {
    targetAudienceUser: CreateOrEditTargetAudienceUserDto | undefined;
}

export class CreateOrEditTargetAudienceUserDto implements ICreateOrEditTargetAudienceUserDto {
    name!: string | undefined;
    phone!: string | undefined;
    zaloChatID!: string | undefined;
    email!: string | undefined;
    facebookID!: string | undefined;
    memberCode!: string | undefined;
    communicationLanguage!: string | undefined;
    nameUnSign!: string | undefined;
    targetAudienceID!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditTargetAudienceUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.phone = data["phone"];
            this.zaloChatID = data["zaloChatID"];
            this.email = data["email"];
            this.facebookID = data["facebookID"];
            this.memberCode = data["memberCode"];
            this.communicationLanguage = data["communicationLanguage"];
            this.nameUnSign = data["nameUnSign"];
            this.targetAudienceID = data["targetAudienceID"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditTargetAudienceUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditTargetAudienceUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["phone"] = this.phone;
        data["zaloChatID"] = this.zaloChatID;
        data["email"] = this.email;
        data["facebookID"] = this.facebookID;
        data["memberCode"] = this.memberCode;
        data["communicationLanguage"] = this.communicationLanguage;
        data["nameUnSign"] = this.nameUnSign;
        data["targetAudienceID"] = this.targetAudienceID;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditTargetAudienceUserDto {
    name: string | undefined;
    phone: string | undefined;
    zaloChatID: string | undefined;
    email: string | undefined;
    facebookID: string | undefined;
    memberCode: string | undefined;
    communicationLanguage: string | undefined;
    nameUnSign: string | undefined;
    targetAudienceID: number | undefined;
    id: number | undefined;
}

export class GetAllTargetAudienceUsersInput implements IGetAllTargetAudienceUsersInput {
    filter!: string | undefined;
    nameFilter!: string | undefined;
    phoneFilter!: string | undefined;
    zaloChatIDFilter!: string | undefined;
    emailFilter!: string | undefined;
    facebookIDFilter!: string | undefined;
    memberCodeFilter!: string | undefined;
    communicationLanguageFilter!: string | undefined;
    nameUnSignFilter!: string | undefined;
    maxTargetAudienceIDFilter!: number | undefined;
    minTargetAudienceIDFilter!: number | undefined;
    targetAudienceHeaderIdFilter!: string | undefined;
    idFilter!: string | undefined;
    sorting!: string | undefined;
    skipCount!: number | undefined;
    maxResultCount!: number | undefined;

    constructor(data?: IGetAllTargetAudienceUsersInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.filter = data["filter"];
            this.nameFilter = data["nameFilter"];
            this.phoneFilter = data["phoneFilter"];
            this.zaloChatIDFilter = data["zaloChatIDFilter"];
            this.emailFilter = data["emailFilter"];
            this.facebookIDFilter = data["facebookIDFilter"];
            this.memberCodeFilter = data["memberCodeFilter"];
            this.communicationLanguageFilter = data["communicationLanguageFilter"];
            this.nameUnSignFilter = data["nameUnSignFilter"];
            this.maxTargetAudienceIDFilter = data["maxTargetAudienceIDFilter"];
            this.minTargetAudienceIDFilter = data["minTargetAudienceIDFilter"];
            this.targetAudienceHeaderIdFilter = data["targetAudienceHeaderIdFilter"];
            this.idFilter = data["idFilter"];
            this.sorting = data["sorting"];
            this.skipCount = data["skipCount"];
            this.maxResultCount = data["maxResultCount"];
        }
    }

    static fromJS(data: any): GetAllTargetAudienceUsersInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllTargetAudienceUsersInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        data["nameFilter"] = this.nameFilter;
        data["phoneFilter"] = this.phoneFilter;
        data["zaloChatIDFilter"] = this.zaloChatIDFilter;
        data["emailFilter"] = this.emailFilter;
        data["facebookIDFilter"] = this.facebookIDFilter;
        data["memberCodeFilter"] = this.memberCodeFilter;
        data["communicationLanguageFilter"] = this.communicationLanguageFilter;
        data["nameUnSignFilter"] = this.nameUnSignFilter;
        data["maxTargetAudienceIDFilter"] = this.maxTargetAudienceIDFilter;
        data["minTargetAudienceIDFilter"] = this.minTargetAudienceIDFilter;
        data["targetAudienceHeaderIdFilter"] = this.targetAudienceHeaderIdFilter;
        data["idFilter"] = this.idFilter;
        data["sorting"] = this.sorting;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data;
    }
}

export interface IGetAllTargetAudienceUsersInput {
    filter: string | undefined;
    nameFilter: string | undefined;
    phoneFilter: string | undefined;
    zaloChatIDFilter: string | undefined;
    emailFilter: string | undefined;
    facebookIDFilter: string | undefined;
    memberCodeFilter: string | undefined;
    communicationLanguageFilter: string | undefined;
    nameUnSignFilter: string | undefined;
    maxTargetAudienceIDFilter: number | undefined;
    minTargetAudienceIDFilter: number | undefined;
    targetAudienceHeaderIdFilter: string | undefined;
    idFilter: string | undefined;
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;
}

export class SegmentationExportArgs implements ISegmentationExportArgs {
    targetAudienceHeaderIdFilter!: string | undefined;
    nameFilter!: string | undefined;
    memberCodeFilter!: string | undefined;
    phoneFilter!: string | undefined;
    emailFilter!: string | undefined;
    filter!: string | undefined;
    tableName!: string | undefined;
    filePath!: string | undefined;
    fileName!: string | undefined;
    userId!: number | undefined;
    tenantId!: number | undefined;
    currentLanguage!: string | undefined;
    apiUrl!: string | undefined;

    constructor(data?: ISegmentationExportArgs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.targetAudienceHeaderIdFilter = data["targetAudienceHeaderIdFilter"];
            this.nameFilter = data["nameFilter"];
            this.memberCodeFilter = data["memberCodeFilter"];
            this.phoneFilter = data["phoneFilter"];
            this.emailFilter = data["emailFilter"];
            this.filter = data["filter"];
            this.tableName = data["tableName"];
            this.filePath = data["filePath"];
            this.fileName = data["fileName"];
            this.userId = data["userId"];
            this.tenantId = data["tenantId"];
            this.currentLanguage = data["currentLanguage"];
            this.apiUrl = data["apiUrl"];
        }
    }

    static fromJS(data: any): SegmentationExportArgs {
        data = typeof data === 'object' ? data : {};
        let result = new SegmentationExportArgs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["targetAudienceHeaderIdFilter"] = this.targetAudienceHeaderIdFilter;
        data["nameFilter"] = this.nameFilter;
        data["memberCodeFilter"] = this.memberCodeFilter;
        data["phoneFilter"] = this.phoneFilter;
        data["emailFilter"] = this.emailFilter;
        data["filter"] = this.filter;
        data["tableName"] = this.tableName;
        data["filePath"] = this.filePath;
        data["fileName"] = this.fileName;
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["currentLanguage"] = this.currentLanguage;
        data["apiUrl"] = this.apiUrl;
        return data;
    }
}

export interface ISegmentationExportArgs {
    targetAudienceHeaderIdFilter: string | undefined;
    nameFilter: string | undefined;
    memberCodeFilter: string | undefined;
    phoneFilter: string | undefined;
    emailFilter: string | undefined;
    filter: string | undefined;
    tableName: string | undefined;
    filePath: string | undefined;
    fileName: string | undefined;
    userId: number | undefined;
    tenantId: number | undefined;
    currentLanguage: string | undefined;
    apiUrl: string | undefined;
}

export class PagedResultDtoOfGetTaskAnswerForViewDto implements IPagedResultDtoOfGetTaskAnswerForViewDto {
    totalCount!: number | undefined;
    items!: GetTaskAnswerForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetTaskAnswerForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetTaskAnswerForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetTaskAnswerForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetTaskAnswerForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetTaskAnswerForViewDto {
    totalCount: number | undefined;
    items: GetTaskAnswerForViewDto[] | undefined;
}

export class GetTaskAnswerForViewDto implements IGetTaskAnswerForViewDto {
    taskAnswer!: TaskAnswerDto | undefined;

    constructor(data?: IGetTaskAnswerForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.taskAnswer = data["taskAnswer"] ? TaskAnswerDto.fromJS(data["taskAnswer"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetTaskAnswerForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetTaskAnswerForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskAnswer"] = this.taskAnswer ? this.taskAnswer.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetTaskAnswerForViewDto {
    taskAnswer: TaskAnswerDto | undefined;
}

export class TaskAnswerDto implements ITaskAnswerDto {
    questionCode!: string | undefined;
    contentVN!: string | undefined;
    imageLink!: string | undefined;
    taskCode!: string | undefined;
    answerCode!: string | undefined;
    contentEN!: string | undefined;
    id!: number | undefined;

    constructor(data?: ITaskAnswerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.questionCode = data["questionCode"];
            this.contentVN = data["contentVN"];
            this.imageLink = data["imageLink"];
            this.taskCode = data["taskCode"];
            this.answerCode = data["answerCode"];
            this.contentEN = data["contentEN"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): TaskAnswerDto {
        data = typeof data === 'object' ? data : {};
        let result = new TaskAnswerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["questionCode"] = this.questionCode;
        data["contentVN"] = this.contentVN;
        data["imageLink"] = this.imageLink;
        data["taskCode"] = this.taskCode;
        data["answerCode"] = this.answerCode;
        data["contentEN"] = this.contentEN;
        data["id"] = this.id;
        return data;
    }
}

export interface ITaskAnswerDto {
    questionCode: string | undefined;
    contentVN: string | undefined;
    imageLink: string | undefined;
    taskCode: string | undefined;
    answerCode: string | undefined;
    contentEN: string | undefined;
    id: number | undefined;
}

export class GetTaskAnswerForEditOutput implements IGetTaskAnswerForEditOutput {
    taskAnswer!: CreateOrEditTaskAnswerDto | undefined;

    constructor(data?: IGetTaskAnswerForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.taskAnswer = data["taskAnswer"] ? CreateOrEditTaskAnswerDto.fromJS(data["taskAnswer"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetTaskAnswerForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetTaskAnswerForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskAnswer"] = this.taskAnswer ? this.taskAnswer.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetTaskAnswerForEditOutput {
    taskAnswer: CreateOrEditTaskAnswerDto | undefined;
}

export class CreateOrEditTaskAnswerDto implements ICreateOrEditTaskAnswerDto {
    questionCode!: string | undefined;
    contentVN!: string | undefined;
    imageLink!: string | undefined;
    taskCode!: string | undefined;
    answerCode!: string | undefined;
    contentEN!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditTaskAnswerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.questionCode = data["questionCode"];
            this.contentVN = data["contentVN"];
            this.imageLink = data["imageLink"];
            this.taskCode = data["taskCode"];
            this.answerCode = data["answerCode"];
            this.contentEN = data["contentEN"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditTaskAnswerDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditTaskAnswerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["questionCode"] = this.questionCode;
        data["contentVN"] = this.contentVN;
        data["imageLink"] = this.imageLink;
        data["taskCode"] = this.taskCode;
        data["answerCode"] = this.answerCode;
        data["contentEN"] = this.contentEN;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditTaskAnswerDto {
    questionCode: string | undefined;
    contentVN: string | undefined;
    imageLink: string | undefined;
    taskCode: string | undefined;
    answerCode: string | undefined;
    contentEN: string | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfGetTaskInfoForViewDto implements IPagedResultDtoOfGetTaskInfoForViewDto {
    totalCount!: number | undefined;
    items!: GetTaskInfoForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetTaskInfoForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetTaskInfoForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetTaskInfoForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetTaskInfoForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetTaskInfoForViewDto {
    totalCount: number | undefined;
    items: GetTaskInfoForViewDto[] | undefined;
}

export class GetTaskInfoForViewDto implements IGetTaskInfoForViewDto {
    taskInfo!: TaskInfoDto | undefined;
    status!: string | undefined;

    constructor(data?: IGetTaskInfoForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.taskInfo = data["taskInfo"] ? TaskInfoDto.fromJS(data["taskInfo"]) : <any>undefined;
            this.status = data["status"];
        }
    }

    static fromJS(data: any): GetTaskInfoForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetTaskInfoForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskInfo"] = this.taskInfo ? this.taskInfo.toJSON() : <any>undefined;
        data["status"] = this.status;
        return data;
    }
}

export interface IGetTaskInfoForViewDto {
    taskInfo: TaskInfoDto | undefined;
    status: string | undefined;
}

export class TaskInfoDto implements ITaskInfoDto {
    code!: string | undefined;
    name!: string | undefined;
    status!: string | undefined;
    targetAudienceID!: number | undefined;
    descriptionVN!: string | undefined;
    imageLink!: string | undefined;
    isImmediately!: boolean | undefined;
    effectiveFrom!: moment.Moment | undefined;
    effectiveTo!: moment.Moment | undefined;
    occurType!: string | undefined;
    cron!: string | undefined;
    publishTime!: moment.Moment | undefined;
    channel!: string | undefined;
    descriptionEN!: string | undefined;
    targetAudienceType!: string | undefined;
    lastModificationTime!: moment.Moment | undefined;
    creationTime!: moment.Moment | undefined;
    id!: number | undefined;

    constructor(data?: ITaskInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.name = data["name"];
            this.status = data["status"];
            this.targetAudienceID = data["targetAudienceID"];
            this.descriptionVN = data["descriptionVN"];
            this.imageLink = data["imageLink"];
            this.isImmediately = data["isImmediately"];
            this.effectiveFrom = data["effectiveFrom"] ? moment(data["effectiveFrom"].toString()) : <any>undefined;
            this.effectiveTo = data["effectiveTo"] ? moment(data["effectiveTo"].toString()) : <any>undefined;
            this.occurType = data["occurType"];
            this.cron = data["cron"];
            this.publishTime = data["publishTime"] ? moment(data["publishTime"].toString()) : <any>undefined;
            this.channel = data["channel"];
            this.descriptionEN = data["descriptionEN"];
            this.targetAudienceType = data["targetAudienceType"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): TaskInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new TaskInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["status"] = this.status;
        data["targetAudienceID"] = this.targetAudienceID;
        data["descriptionVN"] = this.descriptionVN;
        data["imageLink"] = this.imageLink;
        data["isImmediately"] = this.isImmediately;
        data["effectiveFrom"] = this.effectiveFrom ? this.effectiveFrom.toISOString() : <any>undefined;
        data["effectiveTo"] = this.effectiveTo ? this.effectiveTo.toISOString() : <any>undefined;
        data["occurType"] = this.occurType;
        data["cron"] = this.cron;
        data["publishTime"] = this.publishTime ? this.publishTime.toISOString() : <any>undefined;
        data["channel"] = this.channel;
        data["descriptionEN"] = this.descriptionEN;
        data["targetAudienceType"] = this.targetAudienceType;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface ITaskInfoDto {
    code: string | undefined;
    name: string | undefined;
    status: string | undefined;
    targetAudienceID: number | undefined;
    descriptionVN: string | undefined;
    imageLink: string | undefined;
    isImmediately: boolean | undefined;
    effectiveFrom: moment.Moment | undefined;
    effectiveTo: moment.Moment | undefined;
    occurType: string | undefined;
    cron: string | undefined;
    publishTime: moment.Moment | undefined;
    channel: string | undefined;
    descriptionEN: string | undefined;
    targetAudienceType: string | undefined;
    lastModificationTime: moment.Moment | undefined;
    creationTime: moment.Moment | undefined;
    id: number | undefined;
}

export class GetTaskInfoForEditOutput implements IGetTaskInfoForEditOutput {
    taskInfo!: CreateOrEditTaskInfoDto | undefined;

    constructor(data?: IGetTaskInfoForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.taskInfo = data["taskInfo"] ? CreateOrEditTaskInfoDto.fromJS(data["taskInfo"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetTaskInfoForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetTaskInfoForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskInfo"] = this.taskInfo ? this.taskInfo.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetTaskInfoForEditOutput {
    taskInfo: CreateOrEditTaskInfoDto | undefined;
}

export class CreateOrEditTaskInfoDto implements ICreateOrEditTaskInfoDto {
    code!: string | undefined;
    name!: string | undefined;
    status!: string | undefined;
    targetAudienceID!: number | undefined;
    descriptionVN!: string | undefined;
    imageLink!: string | undefined;
    isImmediately!: boolean | undefined;
    effectiveFrom!: moment.Moment | undefined;
    effectiveTo!: moment.Moment | undefined;
    occurType!: string | undefined;
    cron!: string | undefined;
    publishTime!: moment.Moment | undefined;
    channel!: string | undefined;
    descriptionEN!: string | undefined;
    targetAudienceType!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditTaskInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.name = data["name"];
            this.status = data["status"];
            this.targetAudienceID = data["targetAudienceID"];
            this.descriptionVN = data["descriptionVN"];
            this.imageLink = data["imageLink"];
            this.isImmediately = data["isImmediately"];
            this.effectiveFrom = data["effectiveFrom"] ? moment(data["effectiveFrom"].toString()) : <any>undefined;
            this.effectiveTo = data["effectiveTo"] ? moment(data["effectiveTo"].toString()) : <any>undefined;
            this.occurType = data["occurType"];
            this.cron = data["cron"];
            this.publishTime = data["publishTime"] ? moment(data["publishTime"].toString()) : <any>undefined;
            this.channel = data["channel"];
            this.descriptionEN = data["descriptionEN"];
            this.targetAudienceType = data["targetAudienceType"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditTaskInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditTaskInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["status"] = this.status;
        data["targetAudienceID"] = this.targetAudienceID;
        data["descriptionVN"] = this.descriptionVN;
        data["imageLink"] = this.imageLink;
        data["isImmediately"] = this.isImmediately;
        data["effectiveFrom"] = this.effectiveFrom ? this.effectiveFrom.toISOString() : <any>undefined;
        data["effectiveTo"] = this.effectiveTo ? this.effectiveTo.toISOString() : <any>undefined;
        data["occurType"] = this.occurType;
        data["cron"] = this.cron;
        data["publishTime"] = this.publishTime ? this.publishTime.toISOString() : <any>undefined;
        data["channel"] = this.channel;
        data["descriptionEN"] = this.descriptionEN;
        data["targetAudienceType"] = this.targetAudienceType;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditTaskInfoDto {
    code: string | undefined;
    name: string | undefined;
    status: string | undefined;
    targetAudienceID: number | undefined;
    descriptionVN: string | undefined;
    imageLink: string | undefined;
    isImmediately: boolean | undefined;
    effectiveFrom: moment.Moment | undefined;
    effectiveTo: moment.Moment | undefined;
    occurType: string | undefined;
    cron: string | undefined;
    publishTime: moment.Moment | undefined;
    channel: string | undefined;
    descriptionEN: string | undefined;
    targetAudienceType: string | undefined;
    id: number | undefined;
}

export class GetTaskListDto implements IGetTaskListDto {
    id!: number | undefined;
    taskResultId!: number | undefined;
    taskResultHeaderId!: number | undefined;
    taskResultDetailId!: number | undefined;
    questionType!: string | undefined;
    visitPlanResultId!: number | undefined;
    questionContent!: string | undefined;
    answerContent!: string | undefined;
    resultContent!: string | undefined;
    status!: string | undefined;
    reason!: string | undefined;
    actionId!: number | undefined;
    department!: string | undefined;
    ordering!: number | undefined;
    imageNone_Link!: string | undefined;
    imageHaft_Link!: string | undefined;
    image_Full_Link!: string | undefined;
    minvalue!: number | undefined;
    maxvalue!: number | undefined;
    stepPass!: number | undefined;
    required!: boolean | undefined;
    creatorName!: string | undefined;
    memberCode!: string | undefined;
    memberName!: string | undefined;
    taskCode!: string | undefined;
    creationTime!: moment.Moment | undefined;
    taskMasterCode!: string | undefined;
    level!: number | undefined;
    questionCode!: string | undefined;
    creatorUserId!: number | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;

    constructor(data?: IGetTaskListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.taskResultId = data["taskResultId"];
            this.taskResultHeaderId = data["taskResultHeaderId"];
            this.taskResultDetailId = data["taskResultDetailId"];
            this.questionType = data["questionType"];
            this.visitPlanResultId = data["visitPlanResultId"];
            this.questionContent = data["questionContent"];
            this.answerContent = data["answerContent"];
            this.resultContent = data["resultContent"];
            this.status = data["status"];
            this.reason = data["reason"];
            this.actionId = data["actionId"];
            this.department = data["department"];
            this.ordering = data["ordering"];
            this.imageNone_Link = data["imageNone_Link"];
            this.imageHaft_Link = data["imageHaft_Link"];
            this.image_Full_Link = data["image_Full_Link"];
            this.minvalue = data["minvalue"];
            this.maxvalue = data["maxvalue"];
            this.stepPass = data["stepPass"];
            this.required = data["required"];
            this.creatorName = data["creatorName"];
            this.memberCode = data["memberCode"];
            this.memberName = data["memberName"];
            this.taskCode = data["taskCode"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.taskMasterCode = data["taskMasterCode"];
            this.level = data["level"];
            this.questionCode = data["questionCode"];
            this.creatorUserId = data["creatorUserId"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
        }
    }

    static fromJS(data: any): GetTaskListDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetTaskListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["taskResultId"] = this.taskResultId;
        data["taskResultHeaderId"] = this.taskResultHeaderId;
        data["taskResultDetailId"] = this.taskResultDetailId;
        data["questionType"] = this.questionType;
        data["visitPlanResultId"] = this.visitPlanResultId;
        data["questionContent"] = this.questionContent;
        data["answerContent"] = this.answerContent;
        data["resultContent"] = this.resultContent;
        data["status"] = this.status;
        data["reason"] = this.reason;
        data["actionId"] = this.actionId;
        data["department"] = this.department;
        data["ordering"] = this.ordering;
        data["imageNone_Link"] = this.imageNone_Link;
        data["imageHaft_Link"] = this.imageHaft_Link;
        data["image_Full_Link"] = this.image_Full_Link;
        data["minvalue"] = this.minvalue;
        data["maxvalue"] = this.maxvalue;
        data["stepPass"] = this.stepPass;
        data["required"] = this.required;
        data["creatorName"] = this.creatorName;
        data["memberCode"] = this.memberCode;
        data["memberName"] = this.memberName;
        data["taskCode"] = this.taskCode;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["taskMasterCode"] = this.taskMasterCode;
        data["level"] = this.level;
        data["questionCode"] = this.questionCode;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        return data;
    }
}

export interface IGetTaskListDto {
    id: number | undefined;
    taskResultId: number | undefined;
    taskResultHeaderId: number | undefined;
    taskResultDetailId: number | undefined;
    questionType: string | undefined;
    visitPlanResultId: number | undefined;
    questionContent: string | undefined;
    answerContent: string | undefined;
    resultContent: string | undefined;
    status: string | undefined;
    reason: string | undefined;
    actionId: number | undefined;
    department: string | undefined;
    ordering: number | undefined;
    imageNone_Link: string | undefined;
    imageHaft_Link: string | undefined;
    image_Full_Link: string | undefined;
    minvalue: number | undefined;
    maxvalue: number | undefined;
    stepPass: number | undefined;
    required: boolean | undefined;
    creatorName: string | undefined;
    memberCode: string | undefined;
    memberName: string | undefined;
    taskCode: string | undefined;
    creationTime: moment.Moment | undefined;
    taskMasterCode: string | undefined;
    level: number | undefined;
    questionCode: string | undefined;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
}

export class UpdateTaskListDto implements IUpdateTaskListDto {
    taskResultHeaderId!: number | undefined;
    taskResultDetailId!: number | undefined;
    resultContent!: string | undefined;
    status!: string | undefined;
    reason!: string | undefined;
    visitPlanResultId!: number | undefined;
    questionContent!: string | undefined;

    constructor(data?: IUpdateTaskListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.taskResultHeaderId = data["taskResultHeaderId"];
            this.taskResultDetailId = data["taskResultDetailId"];
            this.resultContent = data["resultContent"];
            this.status = data["status"];
            this.reason = data["reason"];
            this.visitPlanResultId = data["visitPlanResultId"];
            this.questionContent = data["questionContent"];
        }
    }

    static fromJS(data: any): UpdateTaskListDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTaskListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskResultHeaderId"] = this.taskResultHeaderId;
        data["taskResultDetailId"] = this.taskResultDetailId;
        data["resultContent"] = this.resultContent;
        data["status"] = this.status;
        data["reason"] = this.reason;
        data["visitPlanResultId"] = this.visitPlanResultId;
        data["questionContent"] = this.questionContent;
        return data;
    }
}

export interface IUpdateTaskListDto {
    taskResultHeaderId: number | undefined;
    taskResultDetailId: number | undefined;
    resultContent: string | undefined;
    status: string | undefined;
    reason: string | undefined;
    visitPlanResultId: number | undefined;
    questionContent: string | undefined;
}

export class PagedResultDtoOfGetTaskResultListDto implements IPagedResultDtoOfGetTaskResultListDto {
    totalCount!: number | undefined;
    items!: GetTaskResultListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetTaskResultListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetTaskResultListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetTaskResultListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetTaskResultListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetTaskResultListDto {
    totalCount: number | undefined;
    items: GetTaskResultListDto[] | undefined;
}

export class GetTaskResultListDto implements IGetTaskResultListDto {
    header!: GetTaskListDto | undefined;
    details!: GetTaskListDto[] | undefined;

    constructor(data?: IGetTaskResultListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.header = data["header"] ? GetTaskListDto.fromJS(data["header"]) : <any>undefined;
            if (data["details"] && data["details"].constructor === Array) {
                this.details = [];
                for (let item of data["details"])
                    this.details.push(GetTaskListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetTaskResultListDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetTaskResultListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["header"] = this.header ? this.header.toJSON() : <any>undefined;
        if (this.details && this.details.constructor === Array) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetTaskResultListDto {
    header: GetTaskListDto | undefined;
    details: GetTaskListDto[] | undefined;
}

export class TaskDetailExportDto implements ITaskDetailExportDto {
    name!: string | undefined;
    value!: string | undefined;

    constructor(data?: ITaskDetailExportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.value = data["value"];
        }
    }

    static fromJS(data: any): TaskDetailExportDto {
        data = typeof data === 'object' ? data : {};
        let result = new TaskDetailExportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }
}

export interface ITaskDetailExportDto {
    name: string | undefined;
    value: string | undefined;
}

export class GetAllTaskInfosInput implements IGetAllTaskInfosInput {
    filter!: string | undefined;
    codeFilter!: string | undefined;
    nameFilter!: string | undefined;
    statusFilter!: string | undefined;
    maxTargetAudienceIDFilter!: number | undefined;
    minTargetAudienceIDFilter!: number | undefined;
    descriptionVNFilter!: string | undefined;
    imageLinkFilter!: string | undefined;
    isImmediatelyFilter!: number | undefined;
    maxEffectiveFromFilter!: moment.Moment | undefined;
    minEffectiveFromFilter!: moment.Moment | undefined;
    maxEffectiveToFilter!: moment.Moment | undefined;
    minEffectiveToFilter!: moment.Moment | undefined;
    occurTypeFilter!: string | undefined;
    cronFilter!: string | undefined;
    maxPublishTimeFilter!: moment.Moment | undefined;
    minPublishTimeFilter!: moment.Moment | undefined;
    channelFilter!: string | undefined;
    descriptionENFilter!: string | undefined;
    targetAudienceTypeFilter!: string | undefined;
    sorting!: string | undefined;
    skipCount!: number | undefined;
    maxResultCount!: number | undefined;

    constructor(data?: IGetAllTaskInfosInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.filter = data["filter"];
            this.codeFilter = data["codeFilter"];
            this.nameFilter = data["nameFilter"];
            this.statusFilter = data["statusFilter"];
            this.maxTargetAudienceIDFilter = data["maxTargetAudienceIDFilter"];
            this.minTargetAudienceIDFilter = data["minTargetAudienceIDFilter"];
            this.descriptionVNFilter = data["descriptionVNFilter"];
            this.imageLinkFilter = data["imageLinkFilter"];
            this.isImmediatelyFilter = data["isImmediatelyFilter"];
            this.maxEffectiveFromFilter = data["maxEffectiveFromFilter"] ? moment(data["maxEffectiveFromFilter"].toString()) : <any>undefined;
            this.minEffectiveFromFilter = data["minEffectiveFromFilter"] ? moment(data["minEffectiveFromFilter"].toString()) : <any>undefined;
            this.maxEffectiveToFilter = data["maxEffectiveToFilter"] ? moment(data["maxEffectiveToFilter"].toString()) : <any>undefined;
            this.minEffectiveToFilter = data["minEffectiveToFilter"] ? moment(data["minEffectiveToFilter"].toString()) : <any>undefined;
            this.occurTypeFilter = data["occurTypeFilter"];
            this.cronFilter = data["cronFilter"];
            this.maxPublishTimeFilter = data["maxPublishTimeFilter"] ? moment(data["maxPublishTimeFilter"].toString()) : <any>undefined;
            this.minPublishTimeFilter = data["minPublishTimeFilter"] ? moment(data["minPublishTimeFilter"].toString()) : <any>undefined;
            this.channelFilter = data["channelFilter"];
            this.descriptionENFilter = data["descriptionENFilter"];
            this.targetAudienceTypeFilter = data["targetAudienceTypeFilter"];
            this.sorting = data["sorting"];
            this.skipCount = data["skipCount"];
            this.maxResultCount = data["maxResultCount"];
        }
    }

    static fromJS(data: any): GetAllTaskInfosInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllTaskInfosInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        data["codeFilter"] = this.codeFilter;
        data["nameFilter"] = this.nameFilter;
        data["statusFilter"] = this.statusFilter;
        data["maxTargetAudienceIDFilter"] = this.maxTargetAudienceIDFilter;
        data["minTargetAudienceIDFilter"] = this.minTargetAudienceIDFilter;
        data["descriptionVNFilter"] = this.descriptionVNFilter;
        data["imageLinkFilter"] = this.imageLinkFilter;
        data["isImmediatelyFilter"] = this.isImmediatelyFilter;
        data["maxEffectiveFromFilter"] = this.maxEffectiveFromFilter ? this.maxEffectiveFromFilter.toISOString() : <any>undefined;
        data["minEffectiveFromFilter"] = this.minEffectiveFromFilter ? this.minEffectiveFromFilter.toISOString() : <any>undefined;
        data["maxEffectiveToFilter"] = this.maxEffectiveToFilter ? this.maxEffectiveToFilter.toISOString() : <any>undefined;
        data["minEffectiveToFilter"] = this.minEffectiveToFilter ? this.minEffectiveToFilter.toISOString() : <any>undefined;
        data["occurTypeFilter"] = this.occurTypeFilter;
        data["cronFilter"] = this.cronFilter;
        data["maxPublishTimeFilter"] = this.maxPublishTimeFilter ? this.maxPublishTimeFilter.toISOString() : <any>undefined;
        data["minPublishTimeFilter"] = this.minPublishTimeFilter ? this.minPublishTimeFilter.toISOString() : <any>undefined;
        data["channelFilter"] = this.channelFilter;
        data["descriptionENFilter"] = this.descriptionENFilter;
        data["targetAudienceTypeFilter"] = this.targetAudienceTypeFilter;
        data["sorting"] = this.sorting;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data;
    }
}

export interface IGetAllTaskInfosInput {
    filter: string | undefined;
    codeFilter: string | undefined;
    nameFilter: string | undefined;
    statusFilter: string | undefined;
    maxTargetAudienceIDFilter: number | undefined;
    minTargetAudienceIDFilter: number | undefined;
    descriptionVNFilter: string | undefined;
    imageLinkFilter: string | undefined;
    isImmediatelyFilter: number | undefined;
    maxEffectiveFromFilter: moment.Moment | undefined;
    minEffectiveFromFilter: moment.Moment | undefined;
    maxEffectiveToFilter: moment.Moment | undefined;
    minEffectiveToFilter: moment.Moment | undefined;
    occurTypeFilter: string | undefined;
    cronFilter: string | undefined;
    maxPublishTimeFilter: moment.Moment | undefined;
    minPublishTimeFilter: moment.Moment | undefined;
    channelFilter: string | undefined;
    descriptionENFilter: string | undefined;
    targetAudienceTypeFilter: string | undefined;
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;
}

export class CreateOrEditTaskInforCustomDto implements ICreateOrEditTaskInforCustomDto {
    taskInfor!: CreateOrEditTaskInfoDto | undefined;
    importTaskTargetAudience!: ImportTaskTargetAudienceDto | undefined;
    questions!: GetTaskQuestionForEditOutput[] | undefined;
    deletedQuestions!: number[] | undefined;
    deletedAnswers!: number[] | undefined;

    constructor(data?: ICreateOrEditTaskInforCustomDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.taskInfor = data["taskInfor"] ? CreateOrEditTaskInfoDto.fromJS(data["taskInfor"]) : <any>undefined;
            this.importTaskTargetAudience = data["importTaskTargetAudience"] ? ImportTaskTargetAudienceDto.fromJS(data["importTaskTargetAudience"]) : <any>undefined;
            if (data["questions"] && data["questions"].constructor === Array) {
                this.questions = [];
                for (let item of data["questions"])
                    this.questions.push(GetTaskQuestionForEditOutput.fromJS(item));
            }
            if (data["deletedQuestions"] && data["deletedQuestions"].constructor === Array) {
                this.deletedQuestions = [];
                for (let item of data["deletedQuestions"])
                    this.deletedQuestions.push(item);
            }
            if (data["deletedAnswers"] && data["deletedAnswers"].constructor === Array) {
                this.deletedAnswers = [];
                for (let item of data["deletedAnswers"])
                    this.deletedAnswers.push(item);
            }
        }
    }

    static fromJS(data: any): CreateOrEditTaskInforCustomDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditTaskInforCustomDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskInfor"] = this.taskInfor ? this.taskInfor.toJSON() : <any>undefined;
        data["importTaskTargetAudience"] = this.importTaskTargetAudience ? this.importTaskTargetAudience.toJSON() : <any>undefined;
        if (this.questions && this.questions.constructor === Array) {
            data["questions"] = [];
            for (let item of this.questions)
                data["questions"].push(item.toJSON());
        }
        if (this.deletedQuestions && this.deletedQuestions.constructor === Array) {
            data["deletedQuestions"] = [];
            for (let item of this.deletedQuestions)
                data["deletedQuestions"].push(item);
        }
        if (this.deletedAnswers && this.deletedAnswers.constructor === Array) {
            data["deletedAnswers"] = [];
            for (let item of this.deletedAnswers)
                data["deletedAnswers"].push(item);
        }
        return data;
    }
}

export interface ICreateOrEditTaskInforCustomDto {
    taskInfor: CreateOrEditTaskInfoDto | undefined;
    importTaskTargetAudience: ImportTaskTargetAudienceDto | undefined;
    questions: GetTaskQuestionForEditOutput[] | undefined;
    deletedQuestions: number[] | undefined;
    deletedAnswers: number[] | undefined;
}

export class ImportTaskTargetAudienceDto implements IImportTaskTargetAudienceDto {
    fileName!: string | undefined;
    targetAudienceName!: string | undefined;

    constructor(data?: IImportTaskTargetAudienceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.fileName = data["fileName"];
            this.targetAudienceName = data["targetAudienceName"];
        }
    }

    static fromJS(data: any): ImportTaskTargetAudienceDto {
        data = typeof data === 'object' ? data : {};
        let result = new ImportTaskTargetAudienceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["targetAudienceName"] = this.targetAudienceName;
        return data;
    }
}

export interface IImportTaskTargetAudienceDto {
    fileName: string | undefined;
    targetAudienceName: string | undefined;
}

export class GetTaskQuestionForEditOutput implements IGetTaskQuestionForEditOutput {
    taskQuestion!: CreateOrEditTaskQuestionDto | undefined;
    taskAnswers!: CreateOrEditTaskAnswerDto[] | undefined;

    constructor(data?: IGetTaskQuestionForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.taskQuestion = data["taskQuestion"] ? CreateOrEditTaskQuestionDto.fromJS(data["taskQuestion"]) : <any>undefined;
            if (data["taskAnswers"] && data["taskAnswers"].constructor === Array) {
                this.taskAnswers = [];
                for (let item of data["taskAnswers"])
                    this.taskAnswers.push(CreateOrEditTaskAnswerDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetTaskQuestionForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetTaskQuestionForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskQuestion"] = this.taskQuestion ? this.taskQuestion.toJSON() : <any>undefined;
        if (this.taskAnswers && this.taskAnswers.constructor === Array) {
            data["taskAnswers"] = [];
            for (let item of this.taskAnswers)
                data["taskAnswers"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetTaskQuestionForEditOutput {
    taskQuestion: CreateOrEditTaskQuestionDto | undefined;
    taskAnswers: CreateOrEditTaskAnswerDto[] | undefined;
}

export class CreateOrEditTaskQuestionDto implements ICreateOrEditTaskQuestionDto {
    code!: string | undefined;
    contentVN!: string | undefined;
    taskCode!: string | undefined;
    questionType!: string | undefined;
    ordering!: number | undefined;
    contentEN!: string | undefined;
    attachImage!: boolean | undefined;
    imageNone_Link!: string | undefined;
    imageHaft_Link!: string | undefined;
    image_Full_Link!: string | undefined;
    minvalue!: number | undefined;
    maxvalue!: number | undefined;
    stepPass!: number | undefined;
    required!: boolean | undefined;
    department!: string | undefined;
    actionId!: number | undefined;
    taskMasterCode!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditTaskQuestionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.contentVN = data["contentVN"];
            this.taskCode = data["taskCode"];
            this.questionType = data["questionType"];
            this.ordering = data["ordering"];
            this.contentEN = data["contentEN"];
            this.attachImage = data["attachImage"];
            this.imageNone_Link = data["imageNone_Link"];
            this.imageHaft_Link = data["imageHaft_Link"];
            this.image_Full_Link = data["image_Full_Link"];
            this.minvalue = data["minvalue"];
            this.maxvalue = data["maxvalue"];
            this.stepPass = data["stepPass"];
            this.required = data["required"];
            this.department = data["department"];
            this.actionId = data["actionId"];
            this.taskMasterCode = data["taskMasterCode"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditTaskQuestionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditTaskQuestionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["contentVN"] = this.contentVN;
        data["taskCode"] = this.taskCode;
        data["questionType"] = this.questionType;
        data["ordering"] = this.ordering;
        data["contentEN"] = this.contentEN;
        data["attachImage"] = this.attachImage;
        data["imageNone_Link"] = this.imageNone_Link;
        data["imageHaft_Link"] = this.imageHaft_Link;
        data["image_Full_Link"] = this.image_Full_Link;
        data["minvalue"] = this.minvalue;
        data["maxvalue"] = this.maxvalue;
        data["stepPass"] = this.stepPass;
        data["required"] = this.required;
        data["department"] = this.department;
        data["actionId"] = this.actionId;
        data["taskMasterCode"] = this.taskMasterCode;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditTaskQuestionDto {
    code: string | undefined;
    contentVN: string | undefined;
    taskCode: string | undefined;
    questionType: string | undefined;
    ordering: number | undefined;
    contentEN: string | undefined;
    attachImage: boolean | undefined;
    imageNone_Link: string | undefined;
    imageHaft_Link: string | undefined;
    image_Full_Link: string | undefined;
    minvalue: number | undefined;
    maxvalue: number | undefined;
    stepPass: number | undefined;
    required: boolean | undefined;
    department: string | undefined;
    actionId: number | undefined;
    taskMasterCode: string | undefined;
    id: number | undefined;
}

export class TaskForViewDto implements ITaskForViewDto {
    taskCode!: string | undefined;
    taskName!: string | undefined;
    fromDate!: moment.Moment | undefined;
    toDate!: moment.Moment | undefined;
    imageLink!: string | undefined;
    channelType!: string | undefined;
    status!: string | undefined;
    totalQuestion!: number | undefined;
    descriptionVN!: string | undefined;
    descriptionEN!: string | undefined;
    questions!: TaskQuestionForView[] | undefined;

    constructor(data?: ITaskForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.taskCode = data["taskCode"];
            this.taskName = data["taskName"];
            this.fromDate = data["fromDate"] ? moment(data["fromDate"].toString()) : <any>undefined;
            this.toDate = data["toDate"] ? moment(data["toDate"].toString()) : <any>undefined;
            this.imageLink = data["imageLink"];
            this.channelType = data["channelType"];
            this.status = data["status"];
            this.totalQuestion = data["totalQuestion"];
            this.descriptionVN = data["descriptionVN"];
            this.descriptionEN = data["descriptionEN"];
            if (data["questions"] && data["questions"].constructor === Array) {
                this.questions = [];
                for (let item of data["questions"])
                    this.questions.push(TaskQuestionForView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TaskForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new TaskForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskCode"] = this.taskCode;
        data["taskName"] = this.taskName;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data["imageLink"] = this.imageLink;
        data["channelType"] = this.channelType;
        data["status"] = this.status;
        data["totalQuestion"] = this.totalQuestion;
        data["descriptionVN"] = this.descriptionVN;
        data["descriptionEN"] = this.descriptionEN;
        if (this.questions && this.questions.constructor === Array) {
            data["questions"] = [];
            for (let item of this.questions)
                data["questions"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITaskForViewDto {
    taskCode: string | undefined;
    taskName: string | undefined;
    fromDate: moment.Moment | undefined;
    toDate: moment.Moment | undefined;
    imageLink: string | undefined;
    channelType: string | undefined;
    status: string | undefined;
    totalQuestion: number | undefined;
    descriptionVN: string | undefined;
    descriptionEN: string | undefined;
    questions: TaskQuestionForView[] | undefined;
}

export class TaskQuestionForView implements ITaskQuestionForView {
    questionCode!: string | undefined;
    contentEN!: string | undefined;
    contentVN!: string | undefined;
    questionType!: string | undefined;
    ordering!: number | undefined;
    attachImage!: boolean | undefined;
    imageHaft_Link!: string | undefined;
    imageNone_Link!: string | undefined;
    image_Full_Link!: string | undefined;
    maxvalue!: number | undefined;
    minvalue!: number | undefined;
    stepPass!: number | undefined;
    required!: boolean | undefined;
    answers!: TaskAnswerForClientDto[] | undefined;

    constructor(data?: ITaskQuestionForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.questionCode = data["questionCode"];
            this.contentEN = data["contentEN"];
            this.contentVN = data["contentVN"];
            this.questionType = data["questionType"];
            this.ordering = data["ordering"];
            this.attachImage = data["attachImage"];
            this.imageHaft_Link = data["imageHaft_Link"];
            this.imageNone_Link = data["imageNone_Link"];
            this.image_Full_Link = data["image_Full_Link"];
            this.maxvalue = data["maxvalue"];
            this.minvalue = data["minvalue"];
            this.stepPass = data["stepPass"];
            this.required = data["required"];
            if (data["answers"] && data["answers"].constructor === Array) {
                this.answers = [];
                for (let item of data["answers"])
                    this.answers.push(TaskAnswerForClientDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TaskQuestionForView {
        data = typeof data === 'object' ? data : {};
        let result = new TaskQuestionForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["questionCode"] = this.questionCode;
        data["contentEN"] = this.contentEN;
        data["contentVN"] = this.contentVN;
        data["questionType"] = this.questionType;
        data["ordering"] = this.ordering;
        data["attachImage"] = this.attachImage;
        data["imageHaft_Link"] = this.imageHaft_Link;
        data["imageNone_Link"] = this.imageNone_Link;
        data["image_Full_Link"] = this.image_Full_Link;
        data["maxvalue"] = this.maxvalue;
        data["minvalue"] = this.minvalue;
        data["stepPass"] = this.stepPass;
        data["required"] = this.required;
        if (this.answers && this.answers.constructor === Array) {
            data["answers"] = [];
            for (let item of this.answers)
                data["answers"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITaskQuestionForView {
    questionCode: string | undefined;
    contentEN: string | undefined;
    contentVN: string | undefined;
    questionType: string | undefined;
    ordering: number | undefined;
    attachImage: boolean | undefined;
    imageHaft_Link: string | undefined;
    imageNone_Link: string | undefined;
    image_Full_Link: string | undefined;
    maxvalue: number | undefined;
    minvalue: number | undefined;
    stepPass: number | undefined;
    required: boolean | undefined;
    answers: TaskAnswerForClientDto[] | undefined;
}

export class TaskAnswerForClientDto implements ITaskAnswerForClientDto {
    answerCode!: string | undefined;
    contentEN!: string | undefined;
    contentVN!: string | undefined;
    image!: string | undefined;

    constructor(data?: ITaskAnswerForClientDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.answerCode = data["answerCode"];
            this.contentEN = data["contentEN"];
            this.contentVN = data["contentVN"];
            this.image = data["image"];
        }
    }

    static fromJS(data: any): TaskAnswerForClientDto {
        data = typeof data === 'object' ? data : {};
        let result = new TaskAnswerForClientDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["answerCode"] = this.answerCode;
        data["contentEN"] = this.contentEN;
        data["contentVN"] = this.contentVN;
        data["image"] = this.image;
        return data;
    }
}

export interface ITaskAnswerForClientDto {
    answerCode: string | undefined;
    contentEN: string | undefined;
    contentVN: string | undefined;
    image: string | undefined;
}

export class TaskForSubmit implements ITaskForSubmit {
    taskCode!: string | undefined;
    channelType!: string | undefined;
    memberCode!: string | undefined;
    memberName!: string | undefined;
    outletCode!: string | undefined;
    chatId!: string | undefined;
    email!: string | undefined;
    facebookId!: string | undefined;
    totalQuestion!: number | undefined;
    phone!: string | undefined;
    questions!: TaskQuestionForSubmit[] | undefined;

    constructor(data?: ITaskForSubmit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.taskCode = data["taskCode"];
            this.channelType = data["channelType"];
            this.memberCode = data["memberCode"];
            this.memberName = data["memberName"];
            this.outletCode = data["outletCode"];
            this.chatId = data["chatId"];
            this.email = data["email"];
            this.facebookId = data["facebookId"];
            this.totalQuestion = data["totalQuestion"];
            this.phone = data["phone"];
            if (data["questions"] && data["questions"].constructor === Array) {
                this.questions = [];
                for (let item of data["questions"])
                    this.questions.push(TaskQuestionForSubmit.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TaskForSubmit {
        data = typeof data === 'object' ? data : {};
        let result = new TaskForSubmit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskCode"] = this.taskCode;
        data["channelType"] = this.channelType;
        data["memberCode"] = this.memberCode;
        data["memberName"] = this.memberName;
        data["outletCode"] = this.outletCode;
        data["chatId"] = this.chatId;
        data["email"] = this.email;
        data["facebookId"] = this.facebookId;
        data["totalQuestion"] = this.totalQuestion;
        data["phone"] = this.phone;
        if (this.questions && this.questions.constructor === Array) {
            data["questions"] = [];
            for (let item of this.questions)
                data["questions"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITaskForSubmit {
    taskCode: string | undefined;
    channelType: string | undefined;
    memberCode: string | undefined;
    memberName: string | undefined;
    outletCode: string | undefined;
    chatId: string | undefined;
    email: string | undefined;
    facebookId: string | undefined;
    totalQuestion: number | undefined;
    phone: string | undefined;
    questions: TaskQuestionForSubmit[] | undefined;
}

export class TaskQuestionForSubmit implements ITaskQuestionForSubmit {
    questionCode!: string | undefined;
    content!: string | undefined;
    questionType!: string | undefined;
    answers!: TaskAnswerForSubmit[] | undefined;

    constructor(data?: ITaskQuestionForSubmit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.questionCode = data["questionCode"];
            this.content = data["content"];
            this.questionType = data["questionType"];
            if (data["answers"] && data["answers"].constructor === Array) {
                this.answers = [];
                for (let item of data["answers"])
                    this.answers.push(TaskAnswerForSubmit.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TaskQuestionForSubmit {
        data = typeof data === 'object' ? data : {};
        let result = new TaskQuestionForSubmit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["questionCode"] = this.questionCode;
        data["content"] = this.content;
        data["questionType"] = this.questionType;
        if (this.answers && this.answers.constructor === Array) {
            data["answers"] = [];
            for (let item of this.answers)
                data["answers"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITaskQuestionForSubmit {
    questionCode: string | undefined;
    content: string | undefined;
    questionType: string | undefined;
    answers: TaskAnswerForSubmit[] | undefined;
}

export class TaskAnswerForSubmit implements ITaskAnswerForSubmit {
    answerCode!: string | undefined;
    content!: string | undefined;
    imageLinks!: string[] | undefined;

    constructor(data?: ITaskAnswerForSubmit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.answerCode = data["answerCode"];
            this.content = data["content"];
            if (data["imageLinks"] && data["imageLinks"].constructor === Array) {
                this.imageLinks = [];
                for (let item of data["imageLinks"])
                    this.imageLinks.push(item);
            }
        }
    }

    static fromJS(data: any): TaskAnswerForSubmit {
        data = typeof data === 'object' ? data : {};
        let result = new TaskAnswerForSubmit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["answerCode"] = this.answerCode;
        data["content"] = this.content;
        if (this.imageLinks && this.imageLinks.constructor === Array) {
            data["imageLinks"] = [];
            for (let item of this.imageLinks)
                data["imageLinks"].push(item);
        }
        return data;
    }
}

export interface ITaskAnswerForSubmit {
    answerCode: string | undefined;
    content: string | undefined;
    imageLinks: string[] | undefined;
}

export class SubmitTaskResponse implements ISubmitTaskResponse {
    isGame!: boolean | undefined;

    constructor(data?: ISubmitTaskResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isGame = data["isGame"];
        }
    }

    static fromJS(data: any): SubmitTaskResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SubmitTaskResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isGame"] = this.isGame;
        return data;
    }
}

export interface ISubmitTaskResponse {
    isGame: boolean | undefined;
}

export class PagedResultDtoOfGetTaskInfoForView implements IPagedResultDtoOfGetTaskInfoForView {
    totalCount!: number | undefined;
    items!: GetTaskInfoForView[] | undefined;

    constructor(data?: IPagedResultDtoOfGetTaskInfoForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetTaskInfoForView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetTaskInfoForView {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetTaskInfoForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetTaskInfoForView {
    totalCount: number | undefined;
    items: GetTaskInfoForView[] | undefined;
}

export class GetTaskInfoForView implements IGetTaskInfoForView {
    taskInfo!: TaskInfoDto | undefined;

    constructor(data?: IGetTaskInfoForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.taskInfo = data["taskInfo"] ? TaskInfoDto.fromJS(data["taskInfo"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetTaskInfoForView {
        data = typeof data === 'object' ? data : {};
        let result = new GetTaskInfoForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskInfo"] = this.taskInfo ? this.taskInfo.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetTaskInfoForView {
    taskInfo: TaskInfoDto | undefined;
}

export class PagedResultDtoOfGetTaskTargetaudienceForView implements IPagedResultDtoOfGetTaskTargetaudienceForView {
    totalCount!: number | undefined;
    items!: GetTaskTargetaudienceForView[] | undefined;

    constructor(data?: IPagedResultDtoOfGetTaskTargetaudienceForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetTaskTargetaudienceForView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetTaskTargetaudienceForView {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetTaskTargetaudienceForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetTaskTargetaudienceForView {
    totalCount: number | undefined;
    items: GetTaskTargetaudienceForView[] | undefined;
}

export class GetTaskTargetaudienceForView implements IGetTaskTargetaudienceForView {
    taskTargetaudience!: TaskTargetaudienceDto | undefined;

    constructor(data?: IGetTaskTargetaudienceForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.taskTargetaudience = data["taskTargetaudience"] ? TaskTargetaudienceDto.fromJS(data["taskTargetaudience"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetTaskTargetaudienceForView {
        data = typeof data === 'object' ? data : {};
        let result = new GetTaskTargetaudienceForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskTargetaudience"] = this.taskTargetaudience ? this.taskTargetaudience.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetTaskTargetaudienceForView {
    taskTargetaudience: TaskTargetaudienceDto | undefined;
}

export class TaskTargetaudienceDto implements ITaskTargetaudienceDto {
    targetaudienceName!: string | undefined;
    description!: string | undefined;
    status!: string | undefined;
    nameUnSign!: string | undefined;
    id!: number | undefined;

    constructor(data?: ITaskTargetaudienceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.targetaudienceName = data["targetaudienceName"];
            this.description = data["description"];
            this.status = data["status"];
            this.nameUnSign = data["nameUnSign"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): TaskTargetaudienceDto {
        data = typeof data === 'object' ? data : {};
        let result = new TaskTargetaudienceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["targetaudienceName"] = this.targetaudienceName;
        data["description"] = this.description;
        data["status"] = this.status;
        data["nameUnSign"] = this.nameUnSign;
        data["id"] = this.id;
        return data;
    }
}

export interface ITaskTargetaudienceDto {
    targetaudienceName: string | undefined;
    description: string | undefined;
    status: string | undefined;
    nameUnSign: string | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfGetTaskQuestionForViewDto implements IPagedResultDtoOfGetTaskQuestionForViewDto {
    totalCount!: number | undefined;
    items!: GetTaskQuestionForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetTaskQuestionForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetTaskQuestionForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetTaskQuestionForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetTaskQuestionForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetTaskQuestionForViewDto {
    totalCount: number | undefined;
    items: GetTaskQuestionForViewDto[] | undefined;
}

export class GetTaskQuestionForViewDto implements IGetTaskQuestionForViewDto {
    taskQuestion!: TaskQuestionDto | undefined;

    constructor(data?: IGetTaskQuestionForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.taskQuestion = data["taskQuestion"] ? TaskQuestionDto.fromJS(data["taskQuestion"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetTaskQuestionForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetTaskQuestionForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskQuestion"] = this.taskQuestion ? this.taskQuestion.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetTaskQuestionForViewDto {
    taskQuestion: TaskQuestionDto | undefined;
}

export class TaskQuestionDto implements ITaskQuestionDto {
    code!: string | undefined;
    contentVN!: string | undefined;
    taskCode!: string | undefined;
    questionType!: string | undefined;
    ordering!: number | undefined;
    contentEN!: string | undefined;
    attachImage!: boolean | undefined;
    imageNone_Link!: string | undefined;
    imageHaft_Link!: string | undefined;
    image_Full_Link!: string | undefined;
    minvalue!: number | undefined;
    maxvalue!: number | undefined;
    stepPass!: number | undefined;
    required!: boolean | undefined;
    department!: string | undefined;
    actionId!: number | undefined;
    taskMasterCode!: string | undefined;
    id!: number | undefined;

    constructor(data?: ITaskQuestionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.contentVN = data["contentVN"];
            this.taskCode = data["taskCode"];
            this.questionType = data["questionType"];
            this.ordering = data["ordering"];
            this.contentEN = data["contentEN"];
            this.attachImage = data["attachImage"];
            this.imageNone_Link = data["imageNone_Link"];
            this.imageHaft_Link = data["imageHaft_Link"];
            this.image_Full_Link = data["image_Full_Link"];
            this.minvalue = data["minvalue"];
            this.maxvalue = data["maxvalue"];
            this.stepPass = data["stepPass"];
            this.required = data["required"];
            this.department = data["department"];
            this.actionId = data["actionId"];
            this.taskMasterCode = data["taskMasterCode"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): TaskQuestionDto {
        data = typeof data === 'object' ? data : {};
        let result = new TaskQuestionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["contentVN"] = this.contentVN;
        data["taskCode"] = this.taskCode;
        data["questionType"] = this.questionType;
        data["ordering"] = this.ordering;
        data["contentEN"] = this.contentEN;
        data["attachImage"] = this.attachImage;
        data["imageNone_Link"] = this.imageNone_Link;
        data["imageHaft_Link"] = this.imageHaft_Link;
        data["image_Full_Link"] = this.image_Full_Link;
        data["minvalue"] = this.minvalue;
        data["maxvalue"] = this.maxvalue;
        data["stepPass"] = this.stepPass;
        data["required"] = this.required;
        data["department"] = this.department;
        data["actionId"] = this.actionId;
        data["taskMasterCode"] = this.taskMasterCode;
        data["id"] = this.id;
        return data;
    }
}

export interface ITaskQuestionDto {
    code: string | undefined;
    contentVN: string | undefined;
    taskCode: string | undefined;
    questionType: string | undefined;
    ordering: number | undefined;
    contentEN: string | undefined;
    attachImage: boolean | undefined;
    imageNone_Link: string | undefined;
    imageHaft_Link: string | undefined;
    image_Full_Link: string | undefined;
    minvalue: number | undefined;
    maxvalue: number | undefined;
    stepPass: number | undefined;
    required: boolean | undefined;
    department: string | undefined;
    actionId: number | undefined;
    taskMasterCode: string | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfGetTaskResponseForViewDto implements IPagedResultDtoOfGetTaskResponseForViewDto {
    totalCount!: number | undefined;
    items!: GetTaskResponseForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetTaskResponseForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetTaskResponseForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetTaskResponseForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetTaskResponseForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetTaskResponseForViewDto {
    totalCount: number | undefined;
    items: GetTaskResponseForViewDto[] | undefined;
}

export class GetTaskResponseForViewDto implements IGetTaskResponseForViewDto {
    taskResponse!: TaskResponseDto | undefined;
    taskName!: string | undefined;

    constructor(data?: IGetTaskResponseForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.taskResponse = data["taskResponse"] ? TaskResponseDto.fromJS(data["taskResponse"]) : <any>undefined;
            this.taskName = data["taskName"];
        }
    }

    static fromJS(data: any): GetTaskResponseForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetTaskResponseForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskResponse"] = this.taskResponse ? this.taskResponse.toJSON() : <any>undefined;
        data["taskName"] = this.taskName;
        return data;
    }
}

export interface IGetTaskResponseForViewDto {
    taskResponse: TaskResponseDto | undefined;
    taskName: string | undefined;
}

export class TaskResponseDto implements ITaskResponseDto {
    taskCode!: string | undefined;
    channel!: string | undefined;
    memberName!: string | undefined;
    phone!: string | undefined;
    zaloChatID!: string | undefined;
    email!: string | undefined;
    facebookID!: string | undefined;
    memberCode!: string | undefined;
    questionContent!: string | undefined;
    subject!: string | undefined;
    outletCode!: string | undefined;
    questionCode!: string | undefined;
    answerContent!: string | undefined;
    messageID!: string | undefined;
    questionType!: string | undefined;
    ordering!: number | undefined;
    imageLink!: string | undefined;
    creationTime!: moment.Moment | undefined;
    imageList!: string[] | undefined;
    answerCode!: string | undefined;
    id!: number | undefined;

    constructor(data?: ITaskResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.taskCode = data["taskCode"];
            this.channel = data["channel"];
            this.memberName = data["memberName"];
            this.phone = data["phone"];
            this.zaloChatID = data["zaloChatID"];
            this.email = data["email"];
            this.facebookID = data["facebookID"];
            this.memberCode = data["memberCode"];
            this.questionContent = data["questionContent"];
            this.subject = data["subject"];
            this.outletCode = data["outletCode"];
            this.questionCode = data["questionCode"];
            this.answerContent = data["answerContent"];
            this.messageID = data["messageID"];
            this.questionType = data["questionType"];
            this.ordering = data["ordering"];
            this.imageLink = data["imageLink"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            if (data["imageList"] && data["imageList"].constructor === Array) {
                this.imageList = [];
                for (let item of data["imageList"])
                    this.imageList.push(item);
            }
            this.answerCode = data["answerCode"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): TaskResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new TaskResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskCode"] = this.taskCode;
        data["channel"] = this.channel;
        data["memberName"] = this.memberName;
        data["phone"] = this.phone;
        data["zaloChatID"] = this.zaloChatID;
        data["email"] = this.email;
        data["facebookID"] = this.facebookID;
        data["memberCode"] = this.memberCode;
        data["questionContent"] = this.questionContent;
        data["subject"] = this.subject;
        data["outletCode"] = this.outletCode;
        data["questionCode"] = this.questionCode;
        data["answerContent"] = this.answerContent;
        data["messageID"] = this.messageID;
        data["questionType"] = this.questionType;
        data["ordering"] = this.ordering;
        data["imageLink"] = this.imageLink;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        if (this.imageList && this.imageList.constructor === Array) {
            data["imageList"] = [];
            for (let item of this.imageList)
                data["imageList"].push(item);
        }
        data["answerCode"] = this.answerCode;
        data["id"] = this.id;
        return data;
    }
}

export interface ITaskResponseDto {
    taskCode: string | undefined;
    channel: string | undefined;
    memberName: string | undefined;
    phone: string | undefined;
    zaloChatID: string | undefined;
    email: string | undefined;
    facebookID: string | undefined;
    memberCode: string | undefined;
    questionContent: string | undefined;
    subject: string | undefined;
    outletCode: string | undefined;
    questionCode: string | undefined;
    answerContent: string | undefined;
    messageID: string | undefined;
    questionType: string | undefined;
    ordering: number | undefined;
    imageLink: string | undefined;
    creationTime: moment.Moment | undefined;
    imageList: string[] | undefined;
    answerCode: string | undefined;
    id: number | undefined;
}

export class GetTaskResponseForEditOutput implements IGetTaskResponseForEditOutput {
    taskResponse!: CreateOrEditTaskResponseDto | undefined;

    constructor(data?: IGetTaskResponseForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.taskResponse = data["taskResponse"] ? CreateOrEditTaskResponseDto.fromJS(data["taskResponse"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetTaskResponseForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetTaskResponseForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskResponse"] = this.taskResponse ? this.taskResponse.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetTaskResponseForEditOutput {
    taskResponse: CreateOrEditTaskResponseDto | undefined;
}

export class CreateOrEditTaskResponseDto implements ICreateOrEditTaskResponseDto {
    taskCode!: string | undefined;
    channel!: string | undefined;
    memberName!: string | undefined;
    phone!: string | undefined;
    zaloChatID!: string | undefined;
    email!: string | undefined;
    facebookID!: string | undefined;
    memberCode!: string | undefined;
    questionContent!: string | undefined;
    subject!: string | undefined;
    outletCode!: string | undefined;
    questionCode!: string | undefined;
    answerContent!: string | undefined;
    messageID!: string | undefined;
    questionType!: string | undefined;
    ordering!: number | undefined;
    imageLink!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditTaskResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.taskCode = data["taskCode"];
            this.channel = data["channel"];
            this.memberName = data["memberName"];
            this.phone = data["phone"];
            this.zaloChatID = data["zaloChatID"];
            this.email = data["email"];
            this.facebookID = data["facebookID"];
            this.memberCode = data["memberCode"];
            this.questionContent = data["questionContent"];
            this.subject = data["subject"];
            this.outletCode = data["outletCode"];
            this.questionCode = data["questionCode"];
            this.answerContent = data["answerContent"];
            this.messageID = data["messageID"];
            this.questionType = data["questionType"];
            this.ordering = data["ordering"];
            this.imageLink = data["imageLink"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditTaskResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditTaskResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskCode"] = this.taskCode;
        data["channel"] = this.channel;
        data["memberName"] = this.memberName;
        data["phone"] = this.phone;
        data["zaloChatID"] = this.zaloChatID;
        data["email"] = this.email;
        data["facebookID"] = this.facebookID;
        data["memberCode"] = this.memberCode;
        data["questionContent"] = this.questionContent;
        data["subject"] = this.subject;
        data["outletCode"] = this.outletCode;
        data["questionCode"] = this.questionCode;
        data["answerContent"] = this.answerContent;
        data["messageID"] = this.messageID;
        data["questionType"] = this.questionType;
        data["ordering"] = this.ordering;
        data["imageLink"] = this.imageLink;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditTaskResponseDto {
    taskCode: string | undefined;
    channel: string | undefined;
    memberName: string | undefined;
    phone: string | undefined;
    zaloChatID: string | undefined;
    email: string | undefined;
    facebookID: string | undefined;
    memberCode: string | undefined;
    questionContent: string | undefined;
    subject: string | undefined;
    outletCode: string | undefined;
    questionCode: string | undefined;
    answerContent: string | undefined;
    messageID: string | undefined;
    questionType: string | undefined;
    ordering: number | undefined;
    imageLink: string | undefined;
    id: number | undefined;
}

export class GetListTaskResponseInput implements IGetListTaskResponseInput {
    taskCode!: string | undefined;
    filter!: string | undefined;
    memberNameFilter!: string | undefined;
    memberCodeFilter!: string | undefined;
    fromDate!: moment.Moment | undefined;
    toDate!: moment.Moment | undefined;
    sorting!: string | undefined;
    skipCount!: number | undefined;
    maxResultCount!: number | undefined;

    constructor(data?: IGetListTaskResponseInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.taskCode = data["taskCode"];
            this.filter = data["filter"];
            this.memberNameFilter = data["memberNameFilter"];
            this.memberCodeFilter = data["memberCodeFilter"];
            this.fromDate = data["fromDate"] ? moment(data["fromDate"].toString()) : <any>undefined;
            this.toDate = data["toDate"] ? moment(data["toDate"].toString()) : <any>undefined;
            this.sorting = data["sorting"];
            this.skipCount = data["skipCount"];
            this.maxResultCount = data["maxResultCount"];
        }
    }

    static fromJS(data: any): GetListTaskResponseInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetListTaskResponseInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskCode"] = this.taskCode;
        data["filter"] = this.filter;
        data["memberNameFilter"] = this.memberNameFilter;
        data["memberCodeFilter"] = this.memberCodeFilter;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data["sorting"] = this.sorting;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data;
    }
}

export interface IGetListTaskResponseInput {
    taskCode: string | undefined;
    filter: string | undefined;
    memberNameFilter: string | undefined;
    memberCodeFilter: string | undefined;
    fromDate: moment.Moment | undefined;
    toDate: moment.Moment | undefined;
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;
}

export class GetTaskResponseDetailDto implements IGetTaskResponseDetailDto {
    taskResponses!: TaskResponseDto[] | undefined;
    memberCode!: string | undefined;
    memberName!: string | undefined;
    taskCode!: string | undefined;
    taskName!: string | undefined;
    submitDate!: moment.Moment | undefined;

    constructor(data?: IGetTaskResponseDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["taskResponses"] && data["taskResponses"].constructor === Array) {
                this.taskResponses = [];
                for (let item of data["taskResponses"])
                    this.taskResponses.push(TaskResponseDto.fromJS(item));
            }
            this.memberCode = data["memberCode"];
            this.memberName = data["memberName"];
            this.taskCode = data["taskCode"];
            this.taskName = data["taskName"];
            this.submitDate = data["submitDate"] ? moment(data["submitDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetTaskResponseDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetTaskResponseDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.taskResponses && this.taskResponses.constructor === Array) {
            data["taskResponses"] = [];
            for (let item of this.taskResponses)
                data["taskResponses"].push(item.toJSON());
        }
        data["memberCode"] = this.memberCode;
        data["memberName"] = this.memberName;
        data["taskCode"] = this.taskCode;
        data["taskName"] = this.taskName;
        data["submitDate"] = this.submitDate ? this.submitDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGetTaskResponseDetailDto {
    taskResponses: TaskResponseDto[] | undefined;
    memberCode: string | undefined;
    memberName: string | undefined;
    taskCode: string | undefined;
    taskName: string | undefined;
    submitDate: moment.Moment | undefined;
}

export class PagedResultDtoOfGetTaskTargetAudienceDetailForViewDto implements IPagedResultDtoOfGetTaskTargetAudienceDetailForViewDto {
    totalCount!: number | undefined;
    items!: GetTaskTargetAudienceDetailForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetTaskTargetAudienceDetailForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetTaskTargetAudienceDetailForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetTaskTargetAudienceDetailForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetTaskTargetAudienceDetailForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetTaskTargetAudienceDetailForViewDto {
    totalCount: number | undefined;
    items: GetTaskTargetAudienceDetailForViewDto[] | undefined;
}

export class GetTaskTargetAudienceDetailForViewDto implements IGetTaskTargetAudienceDetailForViewDto {
    taskTargetAudienceDetail!: TaskTargetAudienceDetailDto | undefined;

    constructor(data?: IGetTaskTargetAudienceDetailForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.taskTargetAudienceDetail = data["taskTargetAudienceDetail"] ? TaskTargetAudienceDetailDto.fromJS(data["taskTargetAudienceDetail"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetTaskTargetAudienceDetailForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetTaskTargetAudienceDetailForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskTargetAudienceDetail"] = this.taskTargetAudienceDetail ? this.taskTargetAudienceDetail.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetTaskTargetAudienceDetailForViewDto {
    taskTargetAudienceDetail: TaskTargetAudienceDetailDto | undefined;
}

export class TaskTargetAudienceDetailDto implements ITaskTargetAudienceDetailDto {
    taskTargetAudienceID!: number | undefined;
    name!: string | undefined;
    phone!: string | undefined;
    zaloChatID!: string | undefined;
    email!: string | undefined;
    facebookID!: string | undefined;
    memberCode!: string | undefined;
    communicationLanguage!: string | undefined;
    communicationChannel!: string | undefined;
    outletCode!: string | undefined;
    id!: number | undefined;

    constructor(data?: ITaskTargetAudienceDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.taskTargetAudienceID = data["taskTargetAudienceID"];
            this.name = data["name"];
            this.phone = data["phone"];
            this.zaloChatID = data["zaloChatID"];
            this.email = data["email"];
            this.facebookID = data["facebookID"];
            this.memberCode = data["memberCode"];
            this.communicationLanguage = data["communicationLanguage"];
            this.communicationChannel = data["communicationChannel"];
            this.outletCode = data["outletCode"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): TaskTargetAudienceDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new TaskTargetAudienceDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskTargetAudienceID"] = this.taskTargetAudienceID;
        data["name"] = this.name;
        data["phone"] = this.phone;
        data["zaloChatID"] = this.zaloChatID;
        data["email"] = this.email;
        data["facebookID"] = this.facebookID;
        data["memberCode"] = this.memberCode;
        data["communicationLanguage"] = this.communicationLanguage;
        data["communicationChannel"] = this.communicationChannel;
        data["outletCode"] = this.outletCode;
        data["id"] = this.id;
        return data;
    }
}

export interface ITaskTargetAudienceDetailDto {
    taskTargetAudienceID: number | undefined;
    name: string | undefined;
    phone: string | undefined;
    zaloChatID: string | undefined;
    email: string | undefined;
    facebookID: string | undefined;
    memberCode: string | undefined;
    communicationLanguage: string | undefined;
    communicationChannel: string | undefined;
    outletCode: string | undefined;
    id: number | undefined;
}

export class GetTaskTargetAudienceDetailForEditOutput implements IGetTaskTargetAudienceDetailForEditOutput {
    taskTargetAudienceDetail!: CreateOrEditTaskTargetAudienceDetailDto | undefined;

    constructor(data?: IGetTaskTargetAudienceDetailForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.taskTargetAudienceDetail = data["taskTargetAudienceDetail"] ? CreateOrEditTaskTargetAudienceDetailDto.fromJS(data["taskTargetAudienceDetail"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetTaskTargetAudienceDetailForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetTaskTargetAudienceDetailForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskTargetAudienceDetail"] = this.taskTargetAudienceDetail ? this.taskTargetAudienceDetail.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetTaskTargetAudienceDetailForEditOutput {
    taskTargetAudienceDetail: CreateOrEditTaskTargetAudienceDetailDto | undefined;
}

export class CreateOrEditTaskTargetAudienceDetailDto implements ICreateOrEditTaskTargetAudienceDetailDto {
    taskTargetAudienceID!: number | undefined;
    name!: string | undefined;
    phone!: string | undefined;
    zaloChatID!: string | undefined;
    email!: string | undefined;
    facebookID!: string | undefined;
    memberCode!: string | undefined;
    communicationLanguage!: string | undefined;
    communicationChannel!: string | undefined;
    outletCode!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditTaskTargetAudienceDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.taskTargetAudienceID = data["taskTargetAudienceID"];
            this.name = data["name"];
            this.phone = data["phone"];
            this.zaloChatID = data["zaloChatID"];
            this.email = data["email"];
            this.facebookID = data["facebookID"];
            this.memberCode = data["memberCode"];
            this.communicationLanguage = data["communicationLanguage"];
            this.communicationChannel = data["communicationChannel"];
            this.outletCode = data["outletCode"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditTaskTargetAudienceDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditTaskTargetAudienceDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskTargetAudienceID"] = this.taskTargetAudienceID;
        data["name"] = this.name;
        data["phone"] = this.phone;
        data["zaloChatID"] = this.zaloChatID;
        data["email"] = this.email;
        data["facebookID"] = this.facebookID;
        data["memberCode"] = this.memberCode;
        data["communicationLanguage"] = this.communicationLanguage;
        data["communicationChannel"] = this.communicationChannel;
        data["outletCode"] = this.outletCode;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditTaskTargetAudienceDetailDto {
    taskTargetAudienceID: number | undefined;
    name: string | undefined;
    phone: string | undefined;
    zaloChatID: string | undefined;
    email: string | undefined;
    facebookID: string | undefined;
    memberCode: string | undefined;
    communicationLanguage: string | undefined;
    communicationChannel: string | undefined;
    outletCode: string | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfGetTaskTargetAudienceForViewDto implements IPagedResultDtoOfGetTaskTargetAudienceForViewDto {
    totalCount!: number | undefined;
    items!: GetTaskTargetAudienceForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetTaskTargetAudienceForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetTaskTargetAudienceForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetTaskTargetAudienceForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetTaskTargetAudienceForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetTaskTargetAudienceForViewDto {
    totalCount: number | undefined;
    items: GetTaskTargetAudienceForViewDto[] | undefined;
}

export class GetTaskTargetAudienceForViewDto implements IGetTaskTargetAudienceForViewDto {
    taskTargetAudience!: TaskTargetAudienceDto | undefined;

    constructor(data?: IGetTaskTargetAudienceForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.taskTargetAudience = data["taskTargetAudience"] ? TaskTargetAudienceDto.fromJS(data["taskTargetAudience"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetTaskTargetAudienceForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetTaskTargetAudienceForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskTargetAudience"] = this.taskTargetAudience ? this.taskTargetAudience.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetTaskTargetAudienceForViewDto {
    taskTargetAudience: TaskTargetAudienceDto | undefined;
}

export class TaskTargetAudienceDto implements ITaskTargetAudienceDto {
    targetAudienceName!: string | undefined;
    description!: string | undefined;
    status!: string | undefined;
    id!: number | undefined;

    constructor(data?: ITaskTargetAudienceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.targetAudienceName = data["targetAudienceName"];
            this.description = data["description"];
            this.status = data["status"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): TaskTargetAudienceDto {
        data = typeof data === 'object' ? data : {};
        let result = new TaskTargetAudienceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["targetAudienceName"] = this.targetAudienceName;
        data["description"] = this.description;
        data["status"] = this.status;
        data["id"] = this.id;
        return data;
    }
}

export interface ITaskTargetAudienceDto {
    targetAudienceName: string | undefined;
    description: string | undefined;
    status: string | undefined;
    id: number | undefined;
}

export class GetTaskTargetAudienceForEditOutput implements IGetTaskTargetAudienceForEditOutput {
    taskTargetAudience!: CreateOrEditTaskTargetAudienceDto | undefined;

    constructor(data?: IGetTaskTargetAudienceForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.taskTargetAudience = data["taskTargetAudience"] ? CreateOrEditTaskTargetAudienceDto.fromJS(data["taskTargetAudience"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetTaskTargetAudienceForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetTaskTargetAudienceForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskTargetAudience"] = this.taskTargetAudience ? this.taskTargetAudience.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetTaskTargetAudienceForEditOutput {
    taskTargetAudience: CreateOrEditTaskTargetAudienceDto | undefined;
}

export class CreateOrEditTaskTargetAudienceDto implements ICreateOrEditTaskTargetAudienceDto {
    targetAudienceName!: string | undefined;
    description!: string | undefined;
    status!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditTaskTargetAudienceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.targetAudienceName = data["targetAudienceName"];
            this.description = data["description"];
            this.status = data["status"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditTaskTargetAudienceDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditTaskTargetAudienceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["targetAudienceName"] = this.targetAudienceName;
        data["description"] = this.description;
        data["status"] = this.status;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditTaskTargetAudienceDto {
    targetAudienceName: string | undefined;
    description: string | undefined;
    status: string | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfGetTempCoinBaselineForViewDto implements IPagedResultDtoOfGetTempCoinBaselineForViewDto {
    totalCount!: number | undefined;
    items!: GetTempCoinBaselineForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetTempCoinBaselineForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetTempCoinBaselineForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetTempCoinBaselineForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetTempCoinBaselineForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetTempCoinBaselineForViewDto {
    totalCount: number | undefined;
    items: GetTempCoinBaselineForViewDto[] | undefined;
}

export class GetTempCoinBaselineForViewDto implements IGetTempCoinBaselineForViewDto {
    tempCoinBaseline!: TempCoinBaselineDto | undefined;

    constructor(data?: IGetTempCoinBaselineForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tempCoinBaseline = data["tempCoinBaseline"] ? TempCoinBaselineDto.fromJS(data["tempCoinBaseline"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetTempCoinBaselineForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetTempCoinBaselineForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tempCoinBaseline"] = this.tempCoinBaseline ? this.tempCoinBaseline.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetTempCoinBaselineForViewDto {
    tempCoinBaseline: TempCoinBaselineDto | undefined;
}

export class TempCoinBaselineDto implements ITempCoinBaselineDto {
    coin!: number | undefined;
    memberCode!: string | undefined;
    baselineData!: string | undefined;
    source!: string | undefined;
    consumerID!: number | undefined;
    availableFrom!: moment.Moment | undefined;
    availableTo!: moment.Moment | undefined;
    isSync!: boolean | undefined;
    id!: number | undefined;

    constructor(data?: ITempCoinBaselineDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.coin = data["coin"];
            this.memberCode = data["memberCode"];
            this.baselineData = data["baselineData"];
            this.source = data["source"];
            this.consumerID = data["consumerID"];
            this.availableFrom = data["availableFrom"] ? moment(data["availableFrom"].toString()) : <any>undefined;
            this.availableTo = data["availableTo"] ? moment(data["availableTo"].toString()) : <any>undefined;
            this.isSync = data["isSync"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): TempCoinBaselineDto {
        data = typeof data === 'object' ? data : {};
        let result = new TempCoinBaselineDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["coin"] = this.coin;
        data["memberCode"] = this.memberCode;
        data["baselineData"] = this.baselineData;
        data["source"] = this.source;
        data["consumerID"] = this.consumerID;
        data["availableFrom"] = this.availableFrom ? this.availableFrom.toISOString() : <any>undefined;
        data["availableTo"] = this.availableTo ? this.availableTo.toISOString() : <any>undefined;
        data["isSync"] = this.isSync;
        data["id"] = this.id;
        return data;
    }
}

export interface ITempCoinBaselineDto {
    coin: number | undefined;
    memberCode: string | undefined;
    baselineData: string | undefined;
    source: string | undefined;
    consumerID: number | undefined;
    availableFrom: moment.Moment | undefined;
    availableTo: moment.Moment | undefined;
    isSync: boolean | undefined;
    id: number | undefined;
}

export class GetTempCoinBaselineForEditOutput implements IGetTempCoinBaselineForEditOutput {
    tempCoinBaseline!: CreateOrEditTempCoinBaselineDto | undefined;

    constructor(data?: IGetTempCoinBaselineForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tempCoinBaseline = data["tempCoinBaseline"] ? CreateOrEditTempCoinBaselineDto.fromJS(data["tempCoinBaseline"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetTempCoinBaselineForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetTempCoinBaselineForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tempCoinBaseline"] = this.tempCoinBaseline ? this.tempCoinBaseline.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetTempCoinBaselineForEditOutput {
    tempCoinBaseline: CreateOrEditTempCoinBaselineDto | undefined;
}

export class CreateOrEditTempCoinBaselineDto implements ICreateOrEditTempCoinBaselineDto {
    coin!: number | undefined;
    memberCode!: string | undefined;
    baselineData!: string | undefined;
    source!: string | undefined;
    consumerID!: number | undefined;
    availableFrom!: moment.Moment | undefined;
    availableTo!: moment.Moment | undefined;
    isSync!: boolean | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditTempCoinBaselineDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.coin = data["coin"];
            this.memberCode = data["memberCode"];
            this.baselineData = data["baselineData"];
            this.source = data["source"];
            this.consumerID = data["consumerID"];
            this.availableFrom = data["availableFrom"] ? moment(data["availableFrom"].toString()) : <any>undefined;
            this.availableTo = data["availableTo"] ? moment(data["availableTo"].toString()) : <any>undefined;
            this.isSync = data["isSync"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditTempCoinBaselineDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditTempCoinBaselineDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["coin"] = this.coin;
        data["memberCode"] = this.memberCode;
        data["baselineData"] = this.baselineData;
        data["source"] = this.source;
        data["consumerID"] = this.consumerID;
        data["availableFrom"] = this.availableFrom ? this.availableFrom.toISOString() : <any>undefined;
        data["availableTo"] = this.availableTo ? this.availableTo.toISOString() : <any>undefined;
        data["isSync"] = this.isSync;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditTempCoinBaselineDto {
    coin: number | undefined;
    memberCode: string | undefined;
    baselineData: string | undefined;
    source: string | undefined;
    consumerID: number | undefined;
    availableFrom: moment.Moment | undefined;
    availableTo: moment.Moment | undefined;
    isSync: boolean | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfGetTempInvoiceTransactionForViewDto implements IPagedResultDtoOfGetTempInvoiceTransactionForViewDto {
    totalCount!: number | undefined;
    items!: GetTempInvoiceTransactionForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetTempInvoiceTransactionForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetTempInvoiceTransactionForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetTempInvoiceTransactionForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetTempInvoiceTransactionForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetTempInvoiceTransactionForViewDto {
    totalCount: number | undefined;
    items: GetTempInvoiceTransactionForViewDto[] | undefined;
}

export class GetTempInvoiceTransactionForViewDto implements IGetTempInvoiceTransactionForViewDto {
    tempInvoiceTransaction!: TempInvoiceTransactionDto | undefined;

    constructor(data?: IGetTempInvoiceTransactionForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tempInvoiceTransaction = data["tempInvoiceTransaction"] ? TempInvoiceTransactionDto.fromJS(data["tempInvoiceTransaction"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetTempInvoiceTransactionForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetTempInvoiceTransactionForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tempInvoiceTransaction"] = this.tempInvoiceTransaction ? this.tempInvoiceTransaction.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetTempInvoiceTransactionForViewDto {
    tempInvoiceTransaction: TempInvoiceTransactionDto | undefined;
}

export class TempInvoiceTransactionDto implements ITempInvoiceTransactionDto {
    disT_CD!: string | undefined;
    cusT_CD!: string | undefined;
    slsmaN_CD!: string | undefined;
    inV_NO!: string | undefined;
    inV_KEY!: string | undefined;
    sO_NO!: string | undefined;
    sO_KEY!: string | undefined;
    tinV_NO!: string | undefined;
    whS_CD!: string | undefined;
    inV_TYPE!: string | undefined;
    inV_IND!: string | undefined;
    billtO_CD!: string | undefined;
    shiptO_CD!: string | undefined;
    disT_TAX_ID!: string | undefined;
    cusT_TAXREGNO!: string | undefined;
    cusT_MUNICIPALNO!: string | undefined;
    subdisT_IND!: string | undefined;
    cusT_TYPE!: string | undefined;
    pO_NO!: string | undefined;
    sO_DT!: moment.Moment | undefined;
    inV_DT!: moment.Moment | undefined;
    creatE_DT!: moment.Moment | undefined;
    deliverY_DT!: moment.Moment | undefined;
    bU_CD!: string | undefined;
    invterM_CD!: string | undefined;
    inV_STATUS!: string | undefined;
    reF_NO!: string | undefined;
    taX_INV_NO!: string | undefined;
    grosS_TTL!: number | undefined;
    neT_TTL!: number | undefined;
    neT_TTL_TAX!: number | undefined;
    adJ_AMT!: number | undefined;
    taxablE_AMT!: number | undefined;
    taxablE_AMT_FOC!: number | undefined;
    nontaxablE_AMT!: number | undefined;
    taX_PERC1!: number | undefined;
    taX_PERC2!: number | undefined;
    taX_PERC3!: number | undefined;
    taX_TTL1!: number | undefined;
    taX_TTL2!: number | undefined;
    taX_TTL3!: number | undefined;
    taX_TTL!: number | undefined;
    prC_TAX_TTL1!: number | undefined;
    prC_TAX_TTL2!: number | undefined;
    prC_TAX_TTL3!: number | undefined;
    prC_TAX_TTL!: number | undefined;
    cusT_DISC_PERC!: number | undefined;
    cusT_DISC_AMT!: number | undefined;
    prD_DISC_TTL!: number | undefined;
    claiM_DISC!: number | undefined;
    disT_DISC!: number | undefined;
    promO_DISC!: number | undefined;
    slS_DISC!: number | undefined;
    casH_DISC!: number | undefined;
    cusT_GRP_DISC!: number | undefined;
    adD_TAX_AMT!: number | undefined;
    remark!: string | undefined;
    upldW_STATUS!: string | undefined;
    svR_UPLDW_DT!: moment.Moment | undefined;
    createD_BY!: string | undefined;
    svR_CLIENT!: string | undefined;
    hhT_SUBMIT_DT!: moment.Moment | undefined;
    visiT_KEY!: string | undefined;
    prN_NO!: number | undefined;
    prN_NO_TAX!: number | undefined;
    picklisT_IND!: boolean | undefined;
    npclaiM_IND!: boolean | undefined;
    spclaiM_IND!: boolean | undefined;
    dE_IND!: string | undefined;
    dE_DT!: moment.Moment | undefined;
    exT_IND!: string | undefined;
    fulL_REVERSAL_IND!: string | undefined;
    version!: number | undefined;
    syncversion!: moment.Moment | undefined;
    ind!: string | undefined;
    prN_DO_NO!: number | undefined;
    erP_IND!: boolean | undefined;
    agenT_CD!: string | undefined;
    dW_DT!: moment.Moment | undefined;
    inV_DISC_TTL!: number | undefined;
    prD_CD!: string | undefined;
    prD_SLSTYPE!: string | undefined;
    prD_INDEX!: number | undefined;
    uoM_CD1!: string | undefined;
    uoM_CD2!: string | undefined;
    uoM_CD3!: string | undefined;
    taX_IND!: boolean | undefined;
    prC_TAX_IND!: string | undefined;
    deF_UOM_CD!: string | undefined;
    prD_QTY1!: number | undefined;
    prD_QTY2!: number | undefined;
    prD_QTY3!: number | undefined;
    mrp!: number | undefined;
    cp!: number | undefined;
    prD_LISTPRC!: number | undefined;
    uoM_LISTPRC1!: number | undefined;
    uoM_LISTPRC2!: number | undefined;
    uoM_LISTPRC3!: number | undefined;
    prC_TAX_PERC1!: number | undefined;
    prC_TAX_PERC2!: number | undefined;
    prC_TAX_PERC3!: number | undefined;
    prC_TAX_AMT1!: number | undefined;
    prC_TAX_AMT2!: number | undefined;
    prC_TAX_AMT3!: number | undefined;
    prC_TAX_AMT!: number | undefined;
    prD_DISC!: number | undefined;
    grosS_AMT!: number | undefined;
    promO_DISC_DTL!: number | undefined;
    disT_PROMO_DISC!: number | undefined;
    hQ_PROMO_DISC!: number | undefined;
    slS_DISC_DTL!: number | undefined;
    cusT_GRP_DISC_DTL!: number | undefined;
    casH_DISC_PERC!: number | undefined;
    casH_DISC_DTL!: number | undefined;
    uniT_TAX!: number | undefined;
    neT_AMT!: number | undefined;
    neT_AMT_TAX!: number | undefined;
    neT_AMT_FOC!: number | undefined;
    cusT_DISC_DTL!: number | undefined;
    taX_PERC1_DTL!: number | undefined;
    taX_PERC2_DTL!: number | undefined;
    taX_PERC3_DTL!: number | undefined;
    taX_AMT1!: number | undefined;
    taX_AMT2!: number | undefined;
    taX_AMT3!: number | undefined;
    taX_AMT!: number | undefined;
    adD_TAX_PERC!: number | undefined;
    adD_TAX_AMT_DTL!: number | undefined;
    purchasE_RATE!: number | undefined;
    disT_DISC_DTL!: number | undefined;
    uoM_CONV_FACTOR_SML1!: number | undefined;
    uoM_CONV_FACTOR_SML2!: number | undefined;
    uoM_CONV_FACTOR_SML3!: number | undefined;
    inD_DTL!: string | undefined;
    parenT_PRD!: string | undefined;
    parenT_UOM!: string | undefined;
    mY_TAX_CD!: string | undefined;
    pricE_ERROR!: number | undefined;
    msL_IND!: string | undefined;
    inV_DISC!: number | undefined;
    id!: number | undefined;

    constructor(data?: ITempInvoiceTransactionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.disT_CD = data["disT_CD"];
            this.cusT_CD = data["cusT_CD"];
            this.slsmaN_CD = data["slsmaN_CD"];
            this.inV_NO = data["inV_NO"];
            this.inV_KEY = data["inV_KEY"];
            this.sO_NO = data["sO_NO"];
            this.sO_KEY = data["sO_KEY"];
            this.tinV_NO = data["tinV_NO"];
            this.whS_CD = data["whS_CD"];
            this.inV_TYPE = data["inV_TYPE"];
            this.inV_IND = data["inV_IND"];
            this.billtO_CD = data["billtO_CD"];
            this.shiptO_CD = data["shiptO_CD"];
            this.disT_TAX_ID = data["disT_TAX_ID"];
            this.cusT_TAXREGNO = data["cusT_TAXREGNO"];
            this.cusT_MUNICIPALNO = data["cusT_MUNICIPALNO"];
            this.subdisT_IND = data["subdisT_IND"];
            this.cusT_TYPE = data["cusT_TYPE"];
            this.pO_NO = data["pO_NO"];
            this.sO_DT = data["sO_DT"] ? moment(data["sO_DT"].toString()) : <any>undefined;
            this.inV_DT = data["inV_DT"] ? moment(data["inV_DT"].toString()) : <any>undefined;
            this.creatE_DT = data["creatE_DT"] ? moment(data["creatE_DT"].toString()) : <any>undefined;
            this.deliverY_DT = data["deliverY_DT"] ? moment(data["deliverY_DT"].toString()) : <any>undefined;
            this.bU_CD = data["bU_CD"];
            this.invterM_CD = data["invterM_CD"];
            this.inV_STATUS = data["inV_STATUS"];
            this.reF_NO = data["reF_NO"];
            this.taX_INV_NO = data["taX_INV_NO"];
            this.grosS_TTL = data["grosS_TTL"];
            this.neT_TTL = data["neT_TTL"];
            this.neT_TTL_TAX = data["neT_TTL_TAX"];
            this.adJ_AMT = data["adJ_AMT"];
            this.taxablE_AMT = data["taxablE_AMT"];
            this.taxablE_AMT_FOC = data["taxablE_AMT_FOC"];
            this.nontaxablE_AMT = data["nontaxablE_AMT"];
            this.taX_PERC1 = data["taX_PERC1"];
            this.taX_PERC2 = data["taX_PERC2"];
            this.taX_PERC3 = data["taX_PERC3"];
            this.taX_TTL1 = data["taX_TTL1"];
            this.taX_TTL2 = data["taX_TTL2"];
            this.taX_TTL3 = data["taX_TTL3"];
            this.taX_TTL = data["taX_TTL"];
            this.prC_TAX_TTL1 = data["prC_TAX_TTL1"];
            this.prC_TAX_TTL2 = data["prC_TAX_TTL2"];
            this.prC_TAX_TTL3 = data["prC_TAX_TTL3"];
            this.prC_TAX_TTL = data["prC_TAX_TTL"];
            this.cusT_DISC_PERC = data["cusT_DISC_PERC"];
            this.cusT_DISC_AMT = data["cusT_DISC_AMT"];
            this.prD_DISC_TTL = data["prD_DISC_TTL"];
            this.claiM_DISC = data["claiM_DISC"];
            this.disT_DISC = data["disT_DISC"];
            this.promO_DISC = data["promO_DISC"];
            this.slS_DISC = data["slS_DISC"];
            this.casH_DISC = data["casH_DISC"];
            this.cusT_GRP_DISC = data["cusT_GRP_DISC"];
            this.adD_TAX_AMT = data["adD_TAX_AMT"];
            this.remark = data["remark"];
            this.upldW_STATUS = data["upldW_STATUS"];
            this.svR_UPLDW_DT = data["svR_UPLDW_DT"] ? moment(data["svR_UPLDW_DT"].toString()) : <any>undefined;
            this.createD_BY = data["createD_BY"];
            this.svR_CLIENT = data["svR_CLIENT"];
            this.hhT_SUBMIT_DT = data["hhT_SUBMIT_DT"] ? moment(data["hhT_SUBMIT_DT"].toString()) : <any>undefined;
            this.visiT_KEY = data["visiT_KEY"];
            this.prN_NO = data["prN_NO"];
            this.prN_NO_TAX = data["prN_NO_TAX"];
            this.picklisT_IND = data["picklisT_IND"];
            this.npclaiM_IND = data["npclaiM_IND"];
            this.spclaiM_IND = data["spclaiM_IND"];
            this.dE_IND = data["dE_IND"];
            this.dE_DT = data["dE_DT"] ? moment(data["dE_DT"].toString()) : <any>undefined;
            this.exT_IND = data["exT_IND"];
            this.fulL_REVERSAL_IND = data["fulL_REVERSAL_IND"];
            this.version = data["version"];
            this.syncversion = data["syncversion"] ? moment(data["syncversion"].toString()) : <any>undefined;
            this.ind = data["ind"];
            this.prN_DO_NO = data["prN_DO_NO"];
            this.erP_IND = data["erP_IND"];
            this.agenT_CD = data["agenT_CD"];
            this.dW_DT = data["dW_DT"] ? moment(data["dW_DT"].toString()) : <any>undefined;
            this.inV_DISC_TTL = data["inV_DISC_TTL"];
            this.prD_CD = data["prD_CD"];
            this.prD_SLSTYPE = data["prD_SLSTYPE"];
            this.prD_INDEX = data["prD_INDEX"];
            this.uoM_CD1 = data["uoM_CD1"];
            this.uoM_CD2 = data["uoM_CD2"];
            this.uoM_CD3 = data["uoM_CD3"];
            this.taX_IND = data["taX_IND"];
            this.prC_TAX_IND = data["prC_TAX_IND"];
            this.deF_UOM_CD = data["deF_UOM_CD"];
            this.prD_QTY1 = data["prD_QTY1"];
            this.prD_QTY2 = data["prD_QTY2"];
            this.prD_QTY3 = data["prD_QTY3"];
            this.mrp = data["mrp"];
            this.cp = data["cp"];
            this.prD_LISTPRC = data["prD_LISTPRC"];
            this.uoM_LISTPRC1 = data["uoM_LISTPRC1"];
            this.uoM_LISTPRC2 = data["uoM_LISTPRC2"];
            this.uoM_LISTPRC3 = data["uoM_LISTPRC3"];
            this.prC_TAX_PERC1 = data["prC_TAX_PERC1"];
            this.prC_TAX_PERC2 = data["prC_TAX_PERC2"];
            this.prC_TAX_PERC3 = data["prC_TAX_PERC3"];
            this.prC_TAX_AMT1 = data["prC_TAX_AMT1"];
            this.prC_TAX_AMT2 = data["prC_TAX_AMT2"];
            this.prC_TAX_AMT3 = data["prC_TAX_AMT3"];
            this.prC_TAX_AMT = data["prC_TAX_AMT"];
            this.prD_DISC = data["prD_DISC"];
            this.grosS_AMT = data["grosS_AMT"];
            this.promO_DISC_DTL = data["promO_DISC_DTL"];
            this.disT_PROMO_DISC = data["disT_PROMO_DISC"];
            this.hQ_PROMO_DISC = data["hQ_PROMO_DISC"];
            this.slS_DISC_DTL = data["slS_DISC_DTL"];
            this.cusT_GRP_DISC_DTL = data["cusT_GRP_DISC_DTL"];
            this.casH_DISC_PERC = data["casH_DISC_PERC"];
            this.casH_DISC_DTL = data["casH_DISC_DTL"];
            this.uniT_TAX = data["uniT_TAX"];
            this.neT_AMT = data["neT_AMT"];
            this.neT_AMT_TAX = data["neT_AMT_TAX"];
            this.neT_AMT_FOC = data["neT_AMT_FOC"];
            this.cusT_DISC_DTL = data["cusT_DISC_DTL"];
            this.taX_PERC1_DTL = data["taX_PERC1_DTL"];
            this.taX_PERC2_DTL = data["taX_PERC2_DTL"];
            this.taX_PERC3_DTL = data["taX_PERC3_DTL"];
            this.taX_AMT1 = data["taX_AMT1"];
            this.taX_AMT2 = data["taX_AMT2"];
            this.taX_AMT3 = data["taX_AMT3"];
            this.taX_AMT = data["taX_AMT"];
            this.adD_TAX_PERC = data["adD_TAX_PERC"];
            this.adD_TAX_AMT_DTL = data["adD_TAX_AMT_DTL"];
            this.purchasE_RATE = data["purchasE_RATE"];
            this.disT_DISC_DTL = data["disT_DISC_DTL"];
            this.uoM_CONV_FACTOR_SML1 = data["uoM_CONV_FACTOR_SML1"];
            this.uoM_CONV_FACTOR_SML2 = data["uoM_CONV_FACTOR_SML2"];
            this.uoM_CONV_FACTOR_SML3 = data["uoM_CONV_FACTOR_SML3"];
            this.inD_DTL = data["inD_DTL"];
            this.parenT_PRD = data["parenT_PRD"];
            this.parenT_UOM = data["parenT_UOM"];
            this.mY_TAX_CD = data["mY_TAX_CD"];
            this.pricE_ERROR = data["pricE_ERROR"];
            this.msL_IND = data["msL_IND"];
            this.inV_DISC = data["inV_DISC"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): TempInvoiceTransactionDto {
        data = typeof data === 'object' ? data : {};
        let result = new TempInvoiceTransactionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["disT_CD"] = this.disT_CD;
        data["cusT_CD"] = this.cusT_CD;
        data["slsmaN_CD"] = this.slsmaN_CD;
        data["inV_NO"] = this.inV_NO;
        data["inV_KEY"] = this.inV_KEY;
        data["sO_NO"] = this.sO_NO;
        data["sO_KEY"] = this.sO_KEY;
        data["tinV_NO"] = this.tinV_NO;
        data["whS_CD"] = this.whS_CD;
        data["inV_TYPE"] = this.inV_TYPE;
        data["inV_IND"] = this.inV_IND;
        data["billtO_CD"] = this.billtO_CD;
        data["shiptO_CD"] = this.shiptO_CD;
        data["disT_TAX_ID"] = this.disT_TAX_ID;
        data["cusT_TAXREGNO"] = this.cusT_TAXREGNO;
        data["cusT_MUNICIPALNO"] = this.cusT_MUNICIPALNO;
        data["subdisT_IND"] = this.subdisT_IND;
        data["cusT_TYPE"] = this.cusT_TYPE;
        data["pO_NO"] = this.pO_NO;
        data["sO_DT"] = this.sO_DT ? this.sO_DT.toISOString() : <any>undefined;
        data["inV_DT"] = this.inV_DT ? this.inV_DT.toISOString() : <any>undefined;
        data["creatE_DT"] = this.creatE_DT ? this.creatE_DT.toISOString() : <any>undefined;
        data["deliverY_DT"] = this.deliverY_DT ? this.deliverY_DT.toISOString() : <any>undefined;
        data["bU_CD"] = this.bU_CD;
        data["invterM_CD"] = this.invterM_CD;
        data["inV_STATUS"] = this.inV_STATUS;
        data["reF_NO"] = this.reF_NO;
        data["taX_INV_NO"] = this.taX_INV_NO;
        data["grosS_TTL"] = this.grosS_TTL;
        data["neT_TTL"] = this.neT_TTL;
        data["neT_TTL_TAX"] = this.neT_TTL_TAX;
        data["adJ_AMT"] = this.adJ_AMT;
        data["taxablE_AMT"] = this.taxablE_AMT;
        data["taxablE_AMT_FOC"] = this.taxablE_AMT_FOC;
        data["nontaxablE_AMT"] = this.nontaxablE_AMT;
        data["taX_PERC1"] = this.taX_PERC1;
        data["taX_PERC2"] = this.taX_PERC2;
        data["taX_PERC3"] = this.taX_PERC3;
        data["taX_TTL1"] = this.taX_TTL1;
        data["taX_TTL2"] = this.taX_TTL2;
        data["taX_TTL3"] = this.taX_TTL3;
        data["taX_TTL"] = this.taX_TTL;
        data["prC_TAX_TTL1"] = this.prC_TAX_TTL1;
        data["prC_TAX_TTL2"] = this.prC_TAX_TTL2;
        data["prC_TAX_TTL3"] = this.prC_TAX_TTL3;
        data["prC_TAX_TTL"] = this.prC_TAX_TTL;
        data["cusT_DISC_PERC"] = this.cusT_DISC_PERC;
        data["cusT_DISC_AMT"] = this.cusT_DISC_AMT;
        data["prD_DISC_TTL"] = this.prD_DISC_TTL;
        data["claiM_DISC"] = this.claiM_DISC;
        data["disT_DISC"] = this.disT_DISC;
        data["promO_DISC"] = this.promO_DISC;
        data["slS_DISC"] = this.slS_DISC;
        data["casH_DISC"] = this.casH_DISC;
        data["cusT_GRP_DISC"] = this.cusT_GRP_DISC;
        data["adD_TAX_AMT"] = this.adD_TAX_AMT;
        data["remark"] = this.remark;
        data["upldW_STATUS"] = this.upldW_STATUS;
        data["svR_UPLDW_DT"] = this.svR_UPLDW_DT ? this.svR_UPLDW_DT.toISOString() : <any>undefined;
        data["createD_BY"] = this.createD_BY;
        data["svR_CLIENT"] = this.svR_CLIENT;
        data["hhT_SUBMIT_DT"] = this.hhT_SUBMIT_DT ? this.hhT_SUBMIT_DT.toISOString() : <any>undefined;
        data["visiT_KEY"] = this.visiT_KEY;
        data["prN_NO"] = this.prN_NO;
        data["prN_NO_TAX"] = this.prN_NO_TAX;
        data["picklisT_IND"] = this.picklisT_IND;
        data["npclaiM_IND"] = this.npclaiM_IND;
        data["spclaiM_IND"] = this.spclaiM_IND;
        data["dE_IND"] = this.dE_IND;
        data["dE_DT"] = this.dE_DT ? this.dE_DT.toISOString() : <any>undefined;
        data["exT_IND"] = this.exT_IND;
        data["fulL_REVERSAL_IND"] = this.fulL_REVERSAL_IND;
        data["version"] = this.version;
        data["syncversion"] = this.syncversion ? this.syncversion.toISOString() : <any>undefined;
        data["ind"] = this.ind;
        data["prN_DO_NO"] = this.prN_DO_NO;
        data["erP_IND"] = this.erP_IND;
        data["agenT_CD"] = this.agenT_CD;
        data["dW_DT"] = this.dW_DT ? this.dW_DT.toISOString() : <any>undefined;
        data["inV_DISC_TTL"] = this.inV_DISC_TTL;
        data["prD_CD"] = this.prD_CD;
        data["prD_SLSTYPE"] = this.prD_SLSTYPE;
        data["prD_INDEX"] = this.prD_INDEX;
        data["uoM_CD1"] = this.uoM_CD1;
        data["uoM_CD2"] = this.uoM_CD2;
        data["uoM_CD3"] = this.uoM_CD3;
        data["taX_IND"] = this.taX_IND;
        data["prC_TAX_IND"] = this.prC_TAX_IND;
        data["deF_UOM_CD"] = this.deF_UOM_CD;
        data["prD_QTY1"] = this.prD_QTY1;
        data["prD_QTY2"] = this.prD_QTY2;
        data["prD_QTY3"] = this.prD_QTY3;
        data["mrp"] = this.mrp;
        data["cp"] = this.cp;
        data["prD_LISTPRC"] = this.prD_LISTPRC;
        data["uoM_LISTPRC1"] = this.uoM_LISTPRC1;
        data["uoM_LISTPRC2"] = this.uoM_LISTPRC2;
        data["uoM_LISTPRC3"] = this.uoM_LISTPRC3;
        data["prC_TAX_PERC1"] = this.prC_TAX_PERC1;
        data["prC_TAX_PERC2"] = this.prC_TAX_PERC2;
        data["prC_TAX_PERC3"] = this.prC_TAX_PERC3;
        data["prC_TAX_AMT1"] = this.prC_TAX_AMT1;
        data["prC_TAX_AMT2"] = this.prC_TAX_AMT2;
        data["prC_TAX_AMT3"] = this.prC_TAX_AMT3;
        data["prC_TAX_AMT"] = this.prC_TAX_AMT;
        data["prD_DISC"] = this.prD_DISC;
        data["grosS_AMT"] = this.grosS_AMT;
        data["promO_DISC_DTL"] = this.promO_DISC_DTL;
        data["disT_PROMO_DISC"] = this.disT_PROMO_DISC;
        data["hQ_PROMO_DISC"] = this.hQ_PROMO_DISC;
        data["slS_DISC_DTL"] = this.slS_DISC_DTL;
        data["cusT_GRP_DISC_DTL"] = this.cusT_GRP_DISC_DTL;
        data["casH_DISC_PERC"] = this.casH_DISC_PERC;
        data["casH_DISC_DTL"] = this.casH_DISC_DTL;
        data["uniT_TAX"] = this.uniT_TAX;
        data["neT_AMT"] = this.neT_AMT;
        data["neT_AMT_TAX"] = this.neT_AMT_TAX;
        data["neT_AMT_FOC"] = this.neT_AMT_FOC;
        data["cusT_DISC_DTL"] = this.cusT_DISC_DTL;
        data["taX_PERC1_DTL"] = this.taX_PERC1_DTL;
        data["taX_PERC2_DTL"] = this.taX_PERC2_DTL;
        data["taX_PERC3_DTL"] = this.taX_PERC3_DTL;
        data["taX_AMT1"] = this.taX_AMT1;
        data["taX_AMT2"] = this.taX_AMT2;
        data["taX_AMT3"] = this.taX_AMT3;
        data["taX_AMT"] = this.taX_AMT;
        data["adD_TAX_PERC"] = this.adD_TAX_PERC;
        data["adD_TAX_AMT_DTL"] = this.adD_TAX_AMT_DTL;
        data["purchasE_RATE"] = this.purchasE_RATE;
        data["disT_DISC_DTL"] = this.disT_DISC_DTL;
        data["uoM_CONV_FACTOR_SML1"] = this.uoM_CONV_FACTOR_SML1;
        data["uoM_CONV_FACTOR_SML2"] = this.uoM_CONV_FACTOR_SML2;
        data["uoM_CONV_FACTOR_SML3"] = this.uoM_CONV_FACTOR_SML3;
        data["inD_DTL"] = this.inD_DTL;
        data["parenT_PRD"] = this.parenT_PRD;
        data["parenT_UOM"] = this.parenT_UOM;
        data["mY_TAX_CD"] = this.mY_TAX_CD;
        data["pricE_ERROR"] = this.pricE_ERROR;
        data["msL_IND"] = this.msL_IND;
        data["inV_DISC"] = this.inV_DISC;
        data["id"] = this.id;
        return data;
    }
}

export interface ITempInvoiceTransactionDto {
    disT_CD: string | undefined;
    cusT_CD: string | undefined;
    slsmaN_CD: string | undefined;
    inV_NO: string | undefined;
    inV_KEY: string | undefined;
    sO_NO: string | undefined;
    sO_KEY: string | undefined;
    tinV_NO: string | undefined;
    whS_CD: string | undefined;
    inV_TYPE: string | undefined;
    inV_IND: string | undefined;
    billtO_CD: string | undefined;
    shiptO_CD: string | undefined;
    disT_TAX_ID: string | undefined;
    cusT_TAXREGNO: string | undefined;
    cusT_MUNICIPALNO: string | undefined;
    subdisT_IND: string | undefined;
    cusT_TYPE: string | undefined;
    pO_NO: string | undefined;
    sO_DT: moment.Moment | undefined;
    inV_DT: moment.Moment | undefined;
    creatE_DT: moment.Moment | undefined;
    deliverY_DT: moment.Moment | undefined;
    bU_CD: string | undefined;
    invterM_CD: string | undefined;
    inV_STATUS: string | undefined;
    reF_NO: string | undefined;
    taX_INV_NO: string | undefined;
    grosS_TTL: number | undefined;
    neT_TTL: number | undefined;
    neT_TTL_TAX: number | undefined;
    adJ_AMT: number | undefined;
    taxablE_AMT: number | undefined;
    taxablE_AMT_FOC: number | undefined;
    nontaxablE_AMT: number | undefined;
    taX_PERC1: number | undefined;
    taX_PERC2: number | undefined;
    taX_PERC3: number | undefined;
    taX_TTL1: number | undefined;
    taX_TTL2: number | undefined;
    taX_TTL3: number | undefined;
    taX_TTL: number | undefined;
    prC_TAX_TTL1: number | undefined;
    prC_TAX_TTL2: number | undefined;
    prC_TAX_TTL3: number | undefined;
    prC_TAX_TTL: number | undefined;
    cusT_DISC_PERC: number | undefined;
    cusT_DISC_AMT: number | undefined;
    prD_DISC_TTL: number | undefined;
    claiM_DISC: number | undefined;
    disT_DISC: number | undefined;
    promO_DISC: number | undefined;
    slS_DISC: number | undefined;
    casH_DISC: number | undefined;
    cusT_GRP_DISC: number | undefined;
    adD_TAX_AMT: number | undefined;
    remark: string | undefined;
    upldW_STATUS: string | undefined;
    svR_UPLDW_DT: moment.Moment | undefined;
    createD_BY: string | undefined;
    svR_CLIENT: string | undefined;
    hhT_SUBMIT_DT: moment.Moment | undefined;
    visiT_KEY: string | undefined;
    prN_NO: number | undefined;
    prN_NO_TAX: number | undefined;
    picklisT_IND: boolean | undefined;
    npclaiM_IND: boolean | undefined;
    spclaiM_IND: boolean | undefined;
    dE_IND: string | undefined;
    dE_DT: moment.Moment | undefined;
    exT_IND: string | undefined;
    fulL_REVERSAL_IND: string | undefined;
    version: number | undefined;
    syncversion: moment.Moment | undefined;
    ind: string | undefined;
    prN_DO_NO: number | undefined;
    erP_IND: boolean | undefined;
    agenT_CD: string | undefined;
    dW_DT: moment.Moment | undefined;
    inV_DISC_TTL: number | undefined;
    prD_CD: string | undefined;
    prD_SLSTYPE: string | undefined;
    prD_INDEX: number | undefined;
    uoM_CD1: string | undefined;
    uoM_CD2: string | undefined;
    uoM_CD3: string | undefined;
    taX_IND: boolean | undefined;
    prC_TAX_IND: string | undefined;
    deF_UOM_CD: string | undefined;
    prD_QTY1: number | undefined;
    prD_QTY2: number | undefined;
    prD_QTY3: number | undefined;
    mrp: number | undefined;
    cp: number | undefined;
    prD_LISTPRC: number | undefined;
    uoM_LISTPRC1: number | undefined;
    uoM_LISTPRC2: number | undefined;
    uoM_LISTPRC3: number | undefined;
    prC_TAX_PERC1: number | undefined;
    prC_TAX_PERC2: number | undefined;
    prC_TAX_PERC3: number | undefined;
    prC_TAX_AMT1: number | undefined;
    prC_TAX_AMT2: number | undefined;
    prC_TAX_AMT3: number | undefined;
    prC_TAX_AMT: number | undefined;
    prD_DISC: number | undefined;
    grosS_AMT: number | undefined;
    promO_DISC_DTL: number | undefined;
    disT_PROMO_DISC: number | undefined;
    hQ_PROMO_DISC: number | undefined;
    slS_DISC_DTL: number | undefined;
    cusT_GRP_DISC_DTL: number | undefined;
    casH_DISC_PERC: number | undefined;
    casH_DISC_DTL: number | undefined;
    uniT_TAX: number | undefined;
    neT_AMT: number | undefined;
    neT_AMT_TAX: number | undefined;
    neT_AMT_FOC: number | undefined;
    cusT_DISC_DTL: number | undefined;
    taX_PERC1_DTL: number | undefined;
    taX_PERC2_DTL: number | undefined;
    taX_PERC3_DTL: number | undefined;
    taX_AMT1: number | undefined;
    taX_AMT2: number | undefined;
    taX_AMT3: number | undefined;
    taX_AMT: number | undefined;
    adD_TAX_PERC: number | undefined;
    adD_TAX_AMT_DTL: number | undefined;
    purchasE_RATE: number | undefined;
    disT_DISC_DTL: number | undefined;
    uoM_CONV_FACTOR_SML1: number | undefined;
    uoM_CONV_FACTOR_SML2: number | undefined;
    uoM_CONV_FACTOR_SML3: number | undefined;
    inD_DTL: string | undefined;
    parenT_PRD: string | undefined;
    parenT_UOM: string | undefined;
    mY_TAX_CD: string | undefined;
    pricE_ERROR: number | undefined;
    msL_IND: string | undefined;
    inV_DISC: number | undefined;
    id: number | undefined;
}

export class GetTempInvoiceTransactionForEditOutput implements IGetTempInvoiceTransactionForEditOutput {
    tempInvoiceTransaction!: CreateOrEditTempInvoiceTransactionDto | undefined;

    constructor(data?: IGetTempInvoiceTransactionForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tempInvoiceTransaction = data["tempInvoiceTransaction"] ? CreateOrEditTempInvoiceTransactionDto.fromJS(data["tempInvoiceTransaction"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetTempInvoiceTransactionForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetTempInvoiceTransactionForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tempInvoiceTransaction"] = this.tempInvoiceTransaction ? this.tempInvoiceTransaction.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetTempInvoiceTransactionForEditOutput {
    tempInvoiceTransaction: CreateOrEditTempInvoiceTransactionDto | undefined;
}

export class CreateOrEditTempInvoiceTransactionDto implements ICreateOrEditTempInvoiceTransactionDto {
    disT_CD!: string | undefined;
    cusT_CD!: string | undefined;
    slsmaN_CD!: string | undefined;
    inV_NO!: string | undefined;
    inV_KEY!: string | undefined;
    sO_NO!: string | undefined;
    sO_KEY!: string | undefined;
    tinV_NO!: string | undefined;
    whS_CD!: string | undefined;
    inV_TYPE!: string | undefined;
    inV_IND!: string | undefined;
    billtO_CD!: string | undefined;
    shiptO_CD!: string | undefined;
    disT_TAX_ID!: string | undefined;
    cusT_TAXREGNO!: string | undefined;
    cusT_MUNICIPALNO!: string | undefined;
    subdisT_IND!: string | undefined;
    cusT_TYPE!: string | undefined;
    pO_NO!: string | undefined;
    sO_DT!: moment.Moment | undefined;
    inV_DT!: moment.Moment | undefined;
    creatE_DT!: moment.Moment | undefined;
    deliverY_DT!: moment.Moment | undefined;
    bU_CD!: string | undefined;
    invterM_CD!: string | undefined;
    inV_STATUS!: string | undefined;
    reF_NO!: string | undefined;
    taX_INV_NO!: string | undefined;
    grosS_TTL!: number | undefined;
    neT_TTL!: number | undefined;
    neT_TTL_TAX!: number | undefined;
    adJ_AMT!: number | undefined;
    taxablE_AMT!: number | undefined;
    taxablE_AMT_FOC!: number | undefined;
    nontaxablE_AMT!: number | undefined;
    taX_PERC1!: number | undefined;
    taX_PERC2!: number | undefined;
    taX_PERC3!: number | undefined;
    taX_TTL1!: number | undefined;
    taX_TTL2!: number | undefined;
    taX_TTL3!: number | undefined;
    taX_TTL!: number | undefined;
    prC_TAX_TTL1!: number | undefined;
    prC_TAX_TTL2!: number | undefined;
    prC_TAX_TTL3!: number | undefined;
    prC_TAX_TTL!: number | undefined;
    cusT_DISC_PERC!: number | undefined;
    cusT_DISC_AMT!: number | undefined;
    prD_DISC_TTL!: number | undefined;
    claiM_DISC!: number | undefined;
    disT_DISC!: number | undefined;
    promO_DISC!: number | undefined;
    slS_DISC!: number | undefined;
    casH_DISC!: number | undefined;
    cusT_GRP_DISC!: number | undefined;
    adD_TAX_AMT!: number | undefined;
    remark!: string | undefined;
    upldW_STATUS!: string | undefined;
    svR_UPLDW_DT!: moment.Moment | undefined;
    createD_BY!: string | undefined;
    svR_CLIENT!: string | undefined;
    hhT_SUBMIT_DT!: moment.Moment | undefined;
    visiT_KEY!: string | undefined;
    prN_NO!: number | undefined;
    prN_NO_TAX!: number | undefined;
    picklisT_IND!: boolean | undefined;
    npclaiM_IND!: boolean | undefined;
    spclaiM_IND!: boolean | undefined;
    dE_IND!: string | undefined;
    dE_DT!: moment.Moment | undefined;
    exT_IND!: string | undefined;
    fulL_REVERSAL_IND!: string | undefined;
    version!: number | undefined;
    syncversion!: moment.Moment | undefined;
    ind!: string | undefined;
    prN_DO_NO!: number | undefined;
    erP_IND!: boolean | undefined;
    agenT_CD!: string | undefined;
    dW_DT!: moment.Moment | undefined;
    inV_DISC_TTL!: number | undefined;
    prD_CD!: string | undefined;
    prD_SLSTYPE!: string | undefined;
    prD_INDEX!: number | undefined;
    uoM_CD1!: string | undefined;
    uoM_CD2!: string | undefined;
    uoM_CD3!: string | undefined;
    taX_IND!: boolean | undefined;
    prC_TAX_IND!: string | undefined;
    deF_UOM_CD!: string | undefined;
    prD_QTY1!: number | undefined;
    prD_QTY2!: number | undefined;
    prD_QTY3!: number | undefined;
    mrp!: number | undefined;
    cp!: number | undefined;
    prD_LISTPRC!: number | undefined;
    uoM_LISTPRC1!: number | undefined;
    uoM_LISTPRC2!: number | undefined;
    uoM_LISTPRC3!: number | undefined;
    prC_TAX_PERC1!: number | undefined;
    prC_TAX_PERC2!: number | undefined;
    prC_TAX_PERC3!: number | undefined;
    prC_TAX_AMT1!: number | undefined;
    prC_TAX_AMT2!: number | undefined;
    prC_TAX_AMT3!: number | undefined;
    prC_TAX_AMT!: number | undefined;
    prD_DISC!: number | undefined;
    grosS_AMT!: number | undefined;
    promO_DISC_DTL!: number | undefined;
    disT_PROMO_DISC!: number | undefined;
    hQ_PROMO_DISC!: number | undefined;
    slS_DISC_DTL!: number | undefined;
    cusT_GRP_DISC_DTL!: number | undefined;
    casH_DISC_PERC!: number | undefined;
    casH_DISC_DTL!: number | undefined;
    uniT_TAX!: number | undefined;
    neT_AMT!: number | undefined;
    neT_AMT_TAX!: number | undefined;
    neT_AMT_FOC!: number | undefined;
    cusT_DISC_DTL!: number | undefined;
    taX_PERC1_DTL!: number | undefined;
    taX_PERC2_DTL!: number | undefined;
    taX_PERC3_DTL!: number | undefined;
    taX_AMT1!: number | undefined;
    taX_AMT2!: number | undefined;
    taX_AMT3!: number | undefined;
    taX_AMT!: number | undefined;
    adD_TAX_PERC!: number | undefined;
    adD_TAX_AMT_DTL!: number | undefined;
    purchasE_RATE!: number | undefined;
    disT_DISC_DTL!: number | undefined;
    uoM_CONV_FACTOR_SML1!: number | undefined;
    uoM_CONV_FACTOR_SML2!: number | undefined;
    uoM_CONV_FACTOR_SML3!: number | undefined;
    inD_DTL!: string | undefined;
    parenT_PRD!: string | undefined;
    parenT_UOM!: string | undefined;
    mY_TAX_CD!: string | undefined;
    pricE_ERROR!: number | undefined;
    msL_IND!: string | undefined;
    inV_DISC!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditTempInvoiceTransactionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.disT_CD = data["disT_CD"];
            this.cusT_CD = data["cusT_CD"];
            this.slsmaN_CD = data["slsmaN_CD"];
            this.inV_NO = data["inV_NO"];
            this.inV_KEY = data["inV_KEY"];
            this.sO_NO = data["sO_NO"];
            this.sO_KEY = data["sO_KEY"];
            this.tinV_NO = data["tinV_NO"];
            this.whS_CD = data["whS_CD"];
            this.inV_TYPE = data["inV_TYPE"];
            this.inV_IND = data["inV_IND"];
            this.billtO_CD = data["billtO_CD"];
            this.shiptO_CD = data["shiptO_CD"];
            this.disT_TAX_ID = data["disT_TAX_ID"];
            this.cusT_TAXREGNO = data["cusT_TAXREGNO"];
            this.cusT_MUNICIPALNO = data["cusT_MUNICIPALNO"];
            this.subdisT_IND = data["subdisT_IND"];
            this.cusT_TYPE = data["cusT_TYPE"];
            this.pO_NO = data["pO_NO"];
            this.sO_DT = data["sO_DT"] ? moment(data["sO_DT"].toString()) : <any>undefined;
            this.inV_DT = data["inV_DT"] ? moment(data["inV_DT"].toString()) : <any>undefined;
            this.creatE_DT = data["creatE_DT"] ? moment(data["creatE_DT"].toString()) : <any>undefined;
            this.deliverY_DT = data["deliverY_DT"] ? moment(data["deliverY_DT"].toString()) : <any>undefined;
            this.bU_CD = data["bU_CD"];
            this.invterM_CD = data["invterM_CD"];
            this.inV_STATUS = data["inV_STATUS"];
            this.reF_NO = data["reF_NO"];
            this.taX_INV_NO = data["taX_INV_NO"];
            this.grosS_TTL = data["grosS_TTL"];
            this.neT_TTL = data["neT_TTL"];
            this.neT_TTL_TAX = data["neT_TTL_TAX"];
            this.adJ_AMT = data["adJ_AMT"];
            this.taxablE_AMT = data["taxablE_AMT"];
            this.taxablE_AMT_FOC = data["taxablE_AMT_FOC"];
            this.nontaxablE_AMT = data["nontaxablE_AMT"];
            this.taX_PERC1 = data["taX_PERC1"];
            this.taX_PERC2 = data["taX_PERC2"];
            this.taX_PERC3 = data["taX_PERC3"];
            this.taX_TTL1 = data["taX_TTL1"];
            this.taX_TTL2 = data["taX_TTL2"];
            this.taX_TTL3 = data["taX_TTL3"];
            this.taX_TTL = data["taX_TTL"];
            this.prC_TAX_TTL1 = data["prC_TAX_TTL1"];
            this.prC_TAX_TTL2 = data["prC_TAX_TTL2"];
            this.prC_TAX_TTL3 = data["prC_TAX_TTL3"];
            this.prC_TAX_TTL = data["prC_TAX_TTL"];
            this.cusT_DISC_PERC = data["cusT_DISC_PERC"];
            this.cusT_DISC_AMT = data["cusT_DISC_AMT"];
            this.prD_DISC_TTL = data["prD_DISC_TTL"];
            this.claiM_DISC = data["claiM_DISC"];
            this.disT_DISC = data["disT_DISC"];
            this.promO_DISC = data["promO_DISC"];
            this.slS_DISC = data["slS_DISC"];
            this.casH_DISC = data["casH_DISC"];
            this.cusT_GRP_DISC = data["cusT_GRP_DISC"];
            this.adD_TAX_AMT = data["adD_TAX_AMT"];
            this.remark = data["remark"];
            this.upldW_STATUS = data["upldW_STATUS"];
            this.svR_UPLDW_DT = data["svR_UPLDW_DT"] ? moment(data["svR_UPLDW_DT"].toString()) : <any>undefined;
            this.createD_BY = data["createD_BY"];
            this.svR_CLIENT = data["svR_CLIENT"];
            this.hhT_SUBMIT_DT = data["hhT_SUBMIT_DT"] ? moment(data["hhT_SUBMIT_DT"].toString()) : <any>undefined;
            this.visiT_KEY = data["visiT_KEY"];
            this.prN_NO = data["prN_NO"];
            this.prN_NO_TAX = data["prN_NO_TAX"];
            this.picklisT_IND = data["picklisT_IND"];
            this.npclaiM_IND = data["npclaiM_IND"];
            this.spclaiM_IND = data["spclaiM_IND"];
            this.dE_IND = data["dE_IND"];
            this.dE_DT = data["dE_DT"] ? moment(data["dE_DT"].toString()) : <any>undefined;
            this.exT_IND = data["exT_IND"];
            this.fulL_REVERSAL_IND = data["fulL_REVERSAL_IND"];
            this.version = data["version"];
            this.syncversion = data["syncversion"] ? moment(data["syncversion"].toString()) : <any>undefined;
            this.ind = data["ind"];
            this.prN_DO_NO = data["prN_DO_NO"];
            this.erP_IND = data["erP_IND"];
            this.agenT_CD = data["agenT_CD"];
            this.dW_DT = data["dW_DT"] ? moment(data["dW_DT"].toString()) : <any>undefined;
            this.inV_DISC_TTL = data["inV_DISC_TTL"];
            this.prD_CD = data["prD_CD"];
            this.prD_SLSTYPE = data["prD_SLSTYPE"];
            this.prD_INDEX = data["prD_INDEX"];
            this.uoM_CD1 = data["uoM_CD1"];
            this.uoM_CD2 = data["uoM_CD2"];
            this.uoM_CD3 = data["uoM_CD3"];
            this.taX_IND = data["taX_IND"];
            this.prC_TAX_IND = data["prC_TAX_IND"];
            this.deF_UOM_CD = data["deF_UOM_CD"];
            this.prD_QTY1 = data["prD_QTY1"];
            this.prD_QTY2 = data["prD_QTY2"];
            this.prD_QTY3 = data["prD_QTY3"];
            this.mrp = data["mrp"];
            this.cp = data["cp"];
            this.prD_LISTPRC = data["prD_LISTPRC"];
            this.uoM_LISTPRC1 = data["uoM_LISTPRC1"];
            this.uoM_LISTPRC2 = data["uoM_LISTPRC2"];
            this.uoM_LISTPRC3 = data["uoM_LISTPRC3"];
            this.prC_TAX_PERC1 = data["prC_TAX_PERC1"];
            this.prC_TAX_PERC2 = data["prC_TAX_PERC2"];
            this.prC_TAX_PERC3 = data["prC_TAX_PERC3"];
            this.prC_TAX_AMT1 = data["prC_TAX_AMT1"];
            this.prC_TAX_AMT2 = data["prC_TAX_AMT2"];
            this.prC_TAX_AMT3 = data["prC_TAX_AMT3"];
            this.prC_TAX_AMT = data["prC_TAX_AMT"];
            this.prD_DISC = data["prD_DISC"];
            this.grosS_AMT = data["grosS_AMT"];
            this.promO_DISC_DTL = data["promO_DISC_DTL"];
            this.disT_PROMO_DISC = data["disT_PROMO_DISC"];
            this.hQ_PROMO_DISC = data["hQ_PROMO_DISC"];
            this.slS_DISC_DTL = data["slS_DISC_DTL"];
            this.cusT_GRP_DISC_DTL = data["cusT_GRP_DISC_DTL"];
            this.casH_DISC_PERC = data["casH_DISC_PERC"];
            this.casH_DISC_DTL = data["casH_DISC_DTL"];
            this.uniT_TAX = data["uniT_TAX"];
            this.neT_AMT = data["neT_AMT"];
            this.neT_AMT_TAX = data["neT_AMT_TAX"];
            this.neT_AMT_FOC = data["neT_AMT_FOC"];
            this.cusT_DISC_DTL = data["cusT_DISC_DTL"];
            this.taX_PERC1_DTL = data["taX_PERC1_DTL"];
            this.taX_PERC2_DTL = data["taX_PERC2_DTL"];
            this.taX_PERC3_DTL = data["taX_PERC3_DTL"];
            this.taX_AMT1 = data["taX_AMT1"];
            this.taX_AMT2 = data["taX_AMT2"];
            this.taX_AMT3 = data["taX_AMT3"];
            this.taX_AMT = data["taX_AMT"];
            this.adD_TAX_PERC = data["adD_TAX_PERC"];
            this.adD_TAX_AMT_DTL = data["adD_TAX_AMT_DTL"];
            this.purchasE_RATE = data["purchasE_RATE"];
            this.disT_DISC_DTL = data["disT_DISC_DTL"];
            this.uoM_CONV_FACTOR_SML1 = data["uoM_CONV_FACTOR_SML1"];
            this.uoM_CONV_FACTOR_SML2 = data["uoM_CONV_FACTOR_SML2"];
            this.uoM_CONV_FACTOR_SML3 = data["uoM_CONV_FACTOR_SML3"];
            this.inD_DTL = data["inD_DTL"];
            this.parenT_PRD = data["parenT_PRD"];
            this.parenT_UOM = data["parenT_UOM"];
            this.mY_TAX_CD = data["mY_TAX_CD"];
            this.pricE_ERROR = data["pricE_ERROR"];
            this.msL_IND = data["msL_IND"];
            this.inV_DISC = data["inV_DISC"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditTempInvoiceTransactionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditTempInvoiceTransactionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["disT_CD"] = this.disT_CD;
        data["cusT_CD"] = this.cusT_CD;
        data["slsmaN_CD"] = this.slsmaN_CD;
        data["inV_NO"] = this.inV_NO;
        data["inV_KEY"] = this.inV_KEY;
        data["sO_NO"] = this.sO_NO;
        data["sO_KEY"] = this.sO_KEY;
        data["tinV_NO"] = this.tinV_NO;
        data["whS_CD"] = this.whS_CD;
        data["inV_TYPE"] = this.inV_TYPE;
        data["inV_IND"] = this.inV_IND;
        data["billtO_CD"] = this.billtO_CD;
        data["shiptO_CD"] = this.shiptO_CD;
        data["disT_TAX_ID"] = this.disT_TAX_ID;
        data["cusT_TAXREGNO"] = this.cusT_TAXREGNO;
        data["cusT_MUNICIPALNO"] = this.cusT_MUNICIPALNO;
        data["subdisT_IND"] = this.subdisT_IND;
        data["cusT_TYPE"] = this.cusT_TYPE;
        data["pO_NO"] = this.pO_NO;
        data["sO_DT"] = this.sO_DT ? this.sO_DT.toISOString() : <any>undefined;
        data["inV_DT"] = this.inV_DT ? this.inV_DT.toISOString() : <any>undefined;
        data["creatE_DT"] = this.creatE_DT ? this.creatE_DT.toISOString() : <any>undefined;
        data["deliverY_DT"] = this.deliverY_DT ? this.deliverY_DT.toISOString() : <any>undefined;
        data["bU_CD"] = this.bU_CD;
        data["invterM_CD"] = this.invterM_CD;
        data["inV_STATUS"] = this.inV_STATUS;
        data["reF_NO"] = this.reF_NO;
        data["taX_INV_NO"] = this.taX_INV_NO;
        data["grosS_TTL"] = this.grosS_TTL;
        data["neT_TTL"] = this.neT_TTL;
        data["neT_TTL_TAX"] = this.neT_TTL_TAX;
        data["adJ_AMT"] = this.adJ_AMT;
        data["taxablE_AMT"] = this.taxablE_AMT;
        data["taxablE_AMT_FOC"] = this.taxablE_AMT_FOC;
        data["nontaxablE_AMT"] = this.nontaxablE_AMT;
        data["taX_PERC1"] = this.taX_PERC1;
        data["taX_PERC2"] = this.taX_PERC2;
        data["taX_PERC3"] = this.taX_PERC3;
        data["taX_TTL1"] = this.taX_TTL1;
        data["taX_TTL2"] = this.taX_TTL2;
        data["taX_TTL3"] = this.taX_TTL3;
        data["taX_TTL"] = this.taX_TTL;
        data["prC_TAX_TTL1"] = this.prC_TAX_TTL1;
        data["prC_TAX_TTL2"] = this.prC_TAX_TTL2;
        data["prC_TAX_TTL3"] = this.prC_TAX_TTL3;
        data["prC_TAX_TTL"] = this.prC_TAX_TTL;
        data["cusT_DISC_PERC"] = this.cusT_DISC_PERC;
        data["cusT_DISC_AMT"] = this.cusT_DISC_AMT;
        data["prD_DISC_TTL"] = this.prD_DISC_TTL;
        data["claiM_DISC"] = this.claiM_DISC;
        data["disT_DISC"] = this.disT_DISC;
        data["promO_DISC"] = this.promO_DISC;
        data["slS_DISC"] = this.slS_DISC;
        data["casH_DISC"] = this.casH_DISC;
        data["cusT_GRP_DISC"] = this.cusT_GRP_DISC;
        data["adD_TAX_AMT"] = this.adD_TAX_AMT;
        data["remark"] = this.remark;
        data["upldW_STATUS"] = this.upldW_STATUS;
        data["svR_UPLDW_DT"] = this.svR_UPLDW_DT ? this.svR_UPLDW_DT.toISOString() : <any>undefined;
        data["createD_BY"] = this.createD_BY;
        data["svR_CLIENT"] = this.svR_CLIENT;
        data["hhT_SUBMIT_DT"] = this.hhT_SUBMIT_DT ? this.hhT_SUBMIT_DT.toISOString() : <any>undefined;
        data["visiT_KEY"] = this.visiT_KEY;
        data["prN_NO"] = this.prN_NO;
        data["prN_NO_TAX"] = this.prN_NO_TAX;
        data["picklisT_IND"] = this.picklisT_IND;
        data["npclaiM_IND"] = this.npclaiM_IND;
        data["spclaiM_IND"] = this.spclaiM_IND;
        data["dE_IND"] = this.dE_IND;
        data["dE_DT"] = this.dE_DT ? this.dE_DT.toISOString() : <any>undefined;
        data["exT_IND"] = this.exT_IND;
        data["fulL_REVERSAL_IND"] = this.fulL_REVERSAL_IND;
        data["version"] = this.version;
        data["syncversion"] = this.syncversion ? this.syncversion.toISOString() : <any>undefined;
        data["ind"] = this.ind;
        data["prN_DO_NO"] = this.prN_DO_NO;
        data["erP_IND"] = this.erP_IND;
        data["agenT_CD"] = this.agenT_CD;
        data["dW_DT"] = this.dW_DT ? this.dW_DT.toISOString() : <any>undefined;
        data["inV_DISC_TTL"] = this.inV_DISC_TTL;
        data["prD_CD"] = this.prD_CD;
        data["prD_SLSTYPE"] = this.prD_SLSTYPE;
        data["prD_INDEX"] = this.prD_INDEX;
        data["uoM_CD1"] = this.uoM_CD1;
        data["uoM_CD2"] = this.uoM_CD2;
        data["uoM_CD3"] = this.uoM_CD3;
        data["taX_IND"] = this.taX_IND;
        data["prC_TAX_IND"] = this.prC_TAX_IND;
        data["deF_UOM_CD"] = this.deF_UOM_CD;
        data["prD_QTY1"] = this.prD_QTY1;
        data["prD_QTY2"] = this.prD_QTY2;
        data["prD_QTY3"] = this.prD_QTY3;
        data["mrp"] = this.mrp;
        data["cp"] = this.cp;
        data["prD_LISTPRC"] = this.prD_LISTPRC;
        data["uoM_LISTPRC1"] = this.uoM_LISTPRC1;
        data["uoM_LISTPRC2"] = this.uoM_LISTPRC2;
        data["uoM_LISTPRC3"] = this.uoM_LISTPRC3;
        data["prC_TAX_PERC1"] = this.prC_TAX_PERC1;
        data["prC_TAX_PERC2"] = this.prC_TAX_PERC2;
        data["prC_TAX_PERC3"] = this.prC_TAX_PERC3;
        data["prC_TAX_AMT1"] = this.prC_TAX_AMT1;
        data["prC_TAX_AMT2"] = this.prC_TAX_AMT2;
        data["prC_TAX_AMT3"] = this.prC_TAX_AMT3;
        data["prC_TAX_AMT"] = this.prC_TAX_AMT;
        data["prD_DISC"] = this.prD_DISC;
        data["grosS_AMT"] = this.grosS_AMT;
        data["promO_DISC_DTL"] = this.promO_DISC_DTL;
        data["disT_PROMO_DISC"] = this.disT_PROMO_DISC;
        data["hQ_PROMO_DISC"] = this.hQ_PROMO_DISC;
        data["slS_DISC_DTL"] = this.slS_DISC_DTL;
        data["cusT_GRP_DISC_DTL"] = this.cusT_GRP_DISC_DTL;
        data["casH_DISC_PERC"] = this.casH_DISC_PERC;
        data["casH_DISC_DTL"] = this.casH_DISC_DTL;
        data["uniT_TAX"] = this.uniT_TAX;
        data["neT_AMT"] = this.neT_AMT;
        data["neT_AMT_TAX"] = this.neT_AMT_TAX;
        data["neT_AMT_FOC"] = this.neT_AMT_FOC;
        data["cusT_DISC_DTL"] = this.cusT_DISC_DTL;
        data["taX_PERC1_DTL"] = this.taX_PERC1_DTL;
        data["taX_PERC2_DTL"] = this.taX_PERC2_DTL;
        data["taX_PERC3_DTL"] = this.taX_PERC3_DTL;
        data["taX_AMT1"] = this.taX_AMT1;
        data["taX_AMT2"] = this.taX_AMT2;
        data["taX_AMT3"] = this.taX_AMT3;
        data["taX_AMT"] = this.taX_AMT;
        data["adD_TAX_PERC"] = this.adD_TAX_PERC;
        data["adD_TAX_AMT_DTL"] = this.adD_TAX_AMT_DTL;
        data["purchasE_RATE"] = this.purchasE_RATE;
        data["disT_DISC_DTL"] = this.disT_DISC_DTL;
        data["uoM_CONV_FACTOR_SML1"] = this.uoM_CONV_FACTOR_SML1;
        data["uoM_CONV_FACTOR_SML2"] = this.uoM_CONV_FACTOR_SML2;
        data["uoM_CONV_FACTOR_SML3"] = this.uoM_CONV_FACTOR_SML3;
        data["inD_DTL"] = this.inD_DTL;
        data["parenT_PRD"] = this.parenT_PRD;
        data["parenT_UOM"] = this.parenT_UOM;
        data["mY_TAX_CD"] = this.mY_TAX_CD;
        data["pricE_ERROR"] = this.pricE_ERROR;
        data["msL_IND"] = this.msL_IND;
        data["inV_DISC"] = this.inV_DISC;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditTempInvoiceTransactionDto {
    disT_CD: string | undefined;
    cusT_CD: string | undefined;
    slsmaN_CD: string | undefined;
    inV_NO: string | undefined;
    inV_KEY: string | undefined;
    sO_NO: string | undefined;
    sO_KEY: string | undefined;
    tinV_NO: string | undefined;
    whS_CD: string | undefined;
    inV_TYPE: string | undefined;
    inV_IND: string | undefined;
    billtO_CD: string | undefined;
    shiptO_CD: string | undefined;
    disT_TAX_ID: string | undefined;
    cusT_TAXREGNO: string | undefined;
    cusT_MUNICIPALNO: string | undefined;
    subdisT_IND: string | undefined;
    cusT_TYPE: string | undefined;
    pO_NO: string | undefined;
    sO_DT: moment.Moment | undefined;
    inV_DT: moment.Moment | undefined;
    creatE_DT: moment.Moment | undefined;
    deliverY_DT: moment.Moment | undefined;
    bU_CD: string | undefined;
    invterM_CD: string | undefined;
    inV_STATUS: string | undefined;
    reF_NO: string | undefined;
    taX_INV_NO: string | undefined;
    grosS_TTL: number | undefined;
    neT_TTL: number | undefined;
    neT_TTL_TAX: number | undefined;
    adJ_AMT: number | undefined;
    taxablE_AMT: number | undefined;
    taxablE_AMT_FOC: number | undefined;
    nontaxablE_AMT: number | undefined;
    taX_PERC1: number | undefined;
    taX_PERC2: number | undefined;
    taX_PERC3: number | undefined;
    taX_TTL1: number | undefined;
    taX_TTL2: number | undefined;
    taX_TTL3: number | undefined;
    taX_TTL: number | undefined;
    prC_TAX_TTL1: number | undefined;
    prC_TAX_TTL2: number | undefined;
    prC_TAX_TTL3: number | undefined;
    prC_TAX_TTL: number | undefined;
    cusT_DISC_PERC: number | undefined;
    cusT_DISC_AMT: number | undefined;
    prD_DISC_TTL: number | undefined;
    claiM_DISC: number | undefined;
    disT_DISC: number | undefined;
    promO_DISC: number | undefined;
    slS_DISC: number | undefined;
    casH_DISC: number | undefined;
    cusT_GRP_DISC: number | undefined;
    adD_TAX_AMT: number | undefined;
    remark: string | undefined;
    upldW_STATUS: string | undefined;
    svR_UPLDW_DT: moment.Moment | undefined;
    createD_BY: string | undefined;
    svR_CLIENT: string | undefined;
    hhT_SUBMIT_DT: moment.Moment | undefined;
    visiT_KEY: string | undefined;
    prN_NO: number | undefined;
    prN_NO_TAX: number | undefined;
    picklisT_IND: boolean | undefined;
    npclaiM_IND: boolean | undefined;
    spclaiM_IND: boolean | undefined;
    dE_IND: string | undefined;
    dE_DT: moment.Moment | undefined;
    exT_IND: string | undefined;
    fulL_REVERSAL_IND: string | undefined;
    version: number | undefined;
    syncversion: moment.Moment | undefined;
    ind: string | undefined;
    prN_DO_NO: number | undefined;
    erP_IND: boolean | undefined;
    agenT_CD: string | undefined;
    dW_DT: moment.Moment | undefined;
    inV_DISC_TTL: number | undefined;
    prD_CD: string | undefined;
    prD_SLSTYPE: string | undefined;
    prD_INDEX: number | undefined;
    uoM_CD1: string | undefined;
    uoM_CD2: string | undefined;
    uoM_CD3: string | undefined;
    taX_IND: boolean | undefined;
    prC_TAX_IND: string | undefined;
    deF_UOM_CD: string | undefined;
    prD_QTY1: number | undefined;
    prD_QTY2: number | undefined;
    prD_QTY3: number | undefined;
    mrp: number | undefined;
    cp: number | undefined;
    prD_LISTPRC: number | undefined;
    uoM_LISTPRC1: number | undefined;
    uoM_LISTPRC2: number | undefined;
    uoM_LISTPRC3: number | undefined;
    prC_TAX_PERC1: number | undefined;
    prC_TAX_PERC2: number | undefined;
    prC_TAX_PERC3: number | undefined;
    prC_TAX_AMT1: number | undefined;
    prC_TAX_AMT2: number | undefined;
    prC_TAX_AMT3: number | undefined;
    prC_TAX_AMT: number | undefined;
    prD_DISC: number | undefined;
    grosS_AMT: number | undefined;
    promO_DISC_DTL: number | undefined;
    disT_PROMO_DISC: number | undefined;
    hQ_PROMO_DISC: number | undefined;
    slS_DISC_DTL: number | undefined;
    cusT_GRP_DISC_DTL: number | undefined;
    casH_DISC_PERC: number | undefined;
    casH_DISC_DTL: number | undefined;
    uniT_TAX: number | undefined;
    neT_AMT: number | undefined;
    neT_AMT_TAX: number | undefined;
    neT_AMT_FOC: number | undefined;
    cusT_DISC_DTL: number | undefined;
    taX_PERC1_DTL: number | undefined;
    taX_PERC2_DTL: number | undefined;
    taX_PERC3_DTL: number | undefined;
    taX_AMT1: number | undefined;
    taX_AMT2: number | undefined;
    taX_AMT3: number | undefined;
    taX_AMT: number | undefined;
    adD_TAX_PERC: number | undefined;
    adD_TAX_AMT_DTL: number | undefined;
    purchasE_RATE: number | undefined;
    disT_DISC_DTL: number | undefined;
    uoM_CONV_FACTOR_SML1: number | undefined;
    uoM_CONV_FACTOR_SML2: number | undefined;
    uoM_CONV_FACTOR_SML3: number | undefined;
    inD_DTL: string | undefined;
    parenT_PRD: string | undefined;
    parenT_UOM: string | undefined;
    mY_TAX_CD: string | undefined;
    pricE_ERROR: number | undefined;
    msL_IND: string | undefined;
    inV_DISC: number | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfGetTemplateForViewDto implements IPagedResultDtoOfGetTemplateForViewDto {
    totalCount!: number | undefined;
    items!: GetTemplateForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetTemplateForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetTemplateForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetTemplateForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetTemplateForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetTemplateForViewDto {
    totalCount: number | undefined;
    items: GetTemplateForViewDto[] | undefined;
}

export class GetTemplateForViewDto implements IGetTemplateForViewDto {
    template!: TemplateDto | undefined;

    constructor(data?: IGetTemplateForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.template = data["template"] ? TemplateDto.fromJS(data["template"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetTemplateForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetTemplateForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["template"] = this.template ? this.template.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetTemplateForViewDto {
    template: TemplateDto | undefined;
}

export class TemplateDto implements ITemplateDto {
    templateName!: string | undefined;
    type!: string | undefined;
    sender!: string | undefined;
    channelCode!: string | undefined;
    contentVN!: string | undefined;
    contentEN!: string | undefined;
    titleVN!: string | undefined;
    titleEN!: string | undefined;
    actions!: string | undefined;
    items!: string | undefined;
    status!: string | undefined;
    templateNameUnSign!: string | undefined;
    id!: number | undefined;

    constructor(data?: ITemplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.templateName = data["templateName"];
            this.type = data["type"];
            this.sender = data["sender"];
            this.channelCode = data["channelCode"];
            this.contentVN = data["contentVN"];
            this.contentEN = data["contentEN"];
            this.titleVN = data["titleVN"];
            this.titleEN = data["titleEN"];
            this.actions = data["actions"];
            this.items = data["items"];
            this.status = data["status"];
            this.templateNameUnSign = data["templateNameUnSign"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): TemplateDto {
        data = typeof data === 'object' ? data : {};
        let result = new TemplateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["templateName"] = this.templateName;
        data["type"] = this.type;
        data["sender"] = this.sender;
        data["channelCode"] = this.channelCode;
        data["contentVN"] = this.contentVN;
        data["contentEN"] = this.contentEN;
        data["titleVN"] = this.titleVN;
        data["titleEN"] = this.titleEN;
        data["actions"] = this.actions;
        data["items"] = this.items;
        data["status"] = this.status;
        data["templateNameUnSign"] = this.templateNameUnSign;
        data["id"] = this.id;
        return data;
    }
}

export interface ITemplateDto {
    templateName: string | undefined;
    type: string | undefined;
    sender: string | undefined;
    channelCode: string | undefined;
    contentVN: string | undefined;
    contentEN: string | undefined;
    titleVN: string | undefined;
    titleEN: string | undefined;
    actions: string | undefined;
    items: string | undefined;
    status: string | undefined;
    templateNameUnSign: string | undefined;
    id: number | undefined;
}

export class GetTemplateForEditOutput implements IGetTemplateForEditOutput {
    template!: CreateOrEditTemplateDto | undefined;

    constructor(data?: IGetTemplateForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.template = data["template"] ? CreateOrEditTemplateDto.fromJS(data["template"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetTemplateForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetTemplateForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["template"] = this.template ? this.template.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetTemplateForEditOutput {
    template: CreateOrEditTemplateDto | undefined;
}

export class CreateOrEditTemplateDto implements ICreateOrEditTemplateDto {
    templateName!: string | undefined;
    type!: string | undefined;
    sender!: string | undefined;
    channelCode!: string | undefined;
    contentVN!: string | undefined;
    contentEN!: string | undefined;
    titleVN!: string | undefined;
    titleEN!: string | undefined;
    actions!: string | undefined;
    items!: string | undefined;
    status!: string | undefined;
    templateNameUnSign!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditTemplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.templateName = data["templateName"];
            this.type = data["type"];
            this.sender = data["sender"];
            this.channelCode = data["channelCode"];
            this.contentVN = data["contentVN"];
            this.contentEN = data["contentEN"];
            this.titleVN = data["titleVN"];
            this.titleEN = data["titleEN"];
            this.actions = data["actions"];
            this.items = data["items"];
            this.status = data["status"];
            this.templateNameUnSign = data["templateNameUnSign"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditTemplateDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditTemplateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["templateName"] = this.templateName;
        data["type"] = this.type;
        data["sender"] = this.sender;
        data["channelCode"] = this.channelCode;
        data["contentVN"] = this.contentVN;
        data["contentEN"] = this.contentEN;
        data["titleVN"] = this.titleVN;
        data["titleEN"] = this.titleEN;
        data["actions"] = this.actions;
        data["items"] = this.items;
        data["status"] = this.status;
        data["templateNameUnSign"] = this.templateNameUnSign;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditTemplateDto {
    templateName: string | undefined;
    type: string | undefined;
    sender: string | undefined;
    channelCode: string | undefined;
    contentVN: string | undefined;
    contentEN: string | undefined;
    titleVN: string | undefined;
    titleEN: string | undefined;
    actions: string | undefined;
    items: string | undefined;
    status: string | undefined;
    templateNameUnSign: string | undefined;
    id: number | undefined;
}

export class GetAllTemplatesInput implements IGetAllTemplatesInput {
    filter!: string | undefined;
    templateNameFilter!: string | undefined;
    typeFilter!: string | undefined;
    senderFilter!: string | undefined;
    channelCodeFilter!: string | undefined;
    contentVNFilter!: string | undefined;
    contentENFilter!: string | undefined;
    titleVNFilter!: string | undefined;
    titleENFilter!: string | undefined;
    actionsFilter!: string | undefined;
    itemsFilter!: string | undefined;
    statusFilter!: string | undefined;
    templateNameUnSignFilter!: string | undefined;
    titleVN!: string | undefined;
    titleEN!: string | undefined;
    sorting!: string | undefined;
    skipCount!: number | undefined;
    maxResultCount!: number | undefined;

    constructor(data?: IGetAllTemplatesInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.filter = data["filter"];
            this.templateNameFilter = data["templateNameFilter"];
            this.typeFilter = data["typeFilter"];
            this.senderFilter = data["senderFilter"];
            this.channelCodeFilter = data["channelCodeFilter"];
            this.contentVNFilter = data["contentVNFilter"];
            this.contentENFilter = data["contentENFilter"];
            this.titleVNFilter = data["titleVNFilter"];
            this.titleENFilter = data["titleENFilter"];
            this.actionsFilter = data["actionsFilter"];
            this.itemsFilter = data["itemsFilter"];
            this.statusFilter = data["statusFilter"];
            this.templateNameUnSignFilter = data["templateNameUnSignFilter"];
            this.titleVN = data["titleVN"];
            this.titleEN = data["titleEN"];
            this.sorting = data["sorting"];
            this.skipCount = data["skipCount"];
            this.maxResultCount = data["maxResultCount"];
        }
    }

    static fromJS(data: any): GetAllTemplatesInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllTemplatesInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        data["templateNameFilter"] = this.templateNameFilter;
        data["typeFilter"] = this.typeFilter;
        data["senderFilter"] = this.senderFilter;
        data["channelCodeFilter"] = this.channelCodeFilter;
        data["contentVNFilter"] = this.contentVNFilter;
        data["contentENFilter"] = this.contentENFilter;
        data["titleVNFilter"] = this.titleVNFilter;
        data["titleENFilter"] = this.titleENFilter;
        data["actionsFilter"] = this.actionsFilter;
        data["itemsFilter"] = this.itemsFilter;
        data["statusFilter"] = this.statusFilter;
        data["templateNameUnSignFilter"] = this.templateNameUnSignFilter;
        data["titleVN"] = this.titleVN;
        data["titleEN"] = this.titleEN;
        data["sorting"] = this.sorting;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data;
    }
}

export interface IGetAllTemplatesInput {
    filter: string | undefined;
    templateNameFilter: string | undefined;
    typeFilter: string | undefined;
    senderFilter: string | undefined;
    channelCodeFilter: string | undefined;
    contentVNFilter: string | undefined;
    contentENFilter: string | undefined;
    titleVNFilter: string | undefined;
    titleENFilter: string | undefined;
    actionsFilter: string | undefined;
    itemsFilter: string | undefined;
    statusFilter: string | undefined;
    templateNameUnSignFilter: string | undefined;
    titleVN: string | undefined;
    titleEN: string | undefined;
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;
}

export class PagedResultDtoOfGetTempMappingGEOForViewDto implements IPagedResultDtoOfGetTempMappingGEOForViewDto {
    totalCount!: number | undefined;
    items!: GetTempMappingGEOForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetTempMappingGEOForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetTempMappingGEOForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetTempMappingGEOForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetTempMappingGEOForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetTempMappingGEOForViewDto {
    totalCount: number | undefined;
    items: GetTempMappingGEOForViewDto[] | undefined;
}

export class GetTempMappingGEOForViewDto implements IGetTempMappingGEOForViewDto {
    tempMappingGEO!: TempMappingGEODto | undefined;

    constructor(data?: IGetTempMappingGEOForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tempMappingGEO = data["tempMappingGEO"] ? TempMappingGEODto.fromJS(data["tempMappingGEO"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetTempMappingGEOForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetTempMappingGEOForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tempMappingGEO"] = this.tempMappingGEO ? this.tempMappingGEO.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetTempMappingGEOForViewDto {
    tempMappingGEO: TempMappingGEODto | undefined;
}

export class TempMappingGEODto implements ITempMappingGEODto {
    poS_ID!: string | undefined;
    nodE_ID!: string | undefined;
    startDate!: moment.Moment | undefined;
    endDate!: moment.Moment | undefined;
    note1!: string | undefined;
    note2!: string | undefined;
    id!: number | undefined;

    constructor(data?: ITempMappingGEODto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.poS_ID = data["poS_ID"];
            this.nodE_ID = data["nodE_ID"];
            this.startDate = data["startDate"] ? moment(data["startDate"].toString()) : <any>undefined;
            this.endDate = data["endDate"] ? moment(data["endDate"].toString()) : <any>undefined;
            this.note1 = data["note1"];
            this.note2 = data["note2"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): TempMappingGEODto {
        data = typeof data === 'object' ? data : {};
        let result = new TempMappingGEODto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["poS_ID"] = this.poS_ID;
        data["nodE_ID"] = this.nodE_ID;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["note1"] = this.note1;
        data["note2"] = this.note2;
        data["id"] = this.id;
        return data;
    }
}

export interface ITempMappingGEODto {
    poS_ID: string | undefined;
    nodE_ID: string | undefined;
    startDate: moment.Moment | undefined;
    endDate: moment.Moment | undefined;
    note1: string | undefined;
    note2: string | undefined;
    id: number | undefined;
}

export class GetTempMappingGEOForEditOutput implements IGetTempMappingGEOForEditOutput {
    tempMappingGEO!: CreateOrEditTempMappingGEODto | undefined;

    constructor(data?: IGetTempMappingGEOForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tempMappingGEO = data["tempMappingGEO"] ? CreateOrEditTempMappingGEODto.fromJS(data["tempMappingGEO"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetTempMappingGEOForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetTempMappingGEOForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tempMappingGEO"] = this.tempMappingGEO ? this.tempMappingGEO.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetTempMappingGEOForEditOutput {
    tempMappingGEO: CreateOrEditTempMappingGEODto | undefined;
}

export class CreateOrEditTempMappingGEODto implements ICreateOrEditTempMappingGEODto {
    poS_ID!: string | undefined;
    nodE_ID!: string | undefined;
    startDate!: moment.Moment | undefined;
    endDate!: moment.Moment | undefined;
    note1!: string | undefined;
    note2!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditTempMappingGEODto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.poS_ID = data["poS_ID"];
            this.nodE_ID = data["nodE_ID"];
            this.startDate = data["startDate"] ? moment(data["startDate"].toString()) : <any>undefined;
            this.endDate = data["endDate"] ? moment(data["endDate"].toString()) : <any>undefined;
            this.note1 = data["note1"];
            this.note2 = data["note2"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditTempMappingGEODto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditTempMappingGEODto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["poS_ID"] = this.poS_ID;
        data["nodE_ID"] = this.nodE_ID;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["note1"] = this.note1;
        data["note2"] = this.note2;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditTempMappingGEODto {
    poS_ID: string | undefined;
    nodE_ID: string | undefined;
    startDate: moment.Moment | undefined;
    endDate: moment.Moment | undefined;
    note1: string | undefined;
    note2: string | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfTenantListDto implements IPagedResultDtoOfTenantListDto {
    totalCount!: number | undefined;
    items!: TenantListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfTenantListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(TenantListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfTenantListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfTenantListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfTenantListDto {
    totalCount: number | undefined;
    items: TenantListDto[] | undefined;
}

export class TenantListDto implements ITenantListDto {
    tenancyName!: string | undefined;
    name!: string | undefined;
    editionDisplayName!: string | undefined;
    connectionString!: string | undefined;
    isActive!: boolean | undefined;
    creationTime!: moment.Moment | undefined;
    subscriptionEndDateUtc!: moment.Moment | undefined;
    editionId!: number | undefined;
    isInTrialPeriod!: boolean | undefined;
    id!: number | undefined;

    constructor(data?: ITenantListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenancyName = data["tenancyName"];
            this.name = data["name"];
            this.editionDisplayName = data["editionDisplayName"];
            this.connectionString = data["connectionString"];
            this.isActive = data["isActive"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.subscriptionEndDateUtc = data["subscriptionEndDateUtc"] ? moment(data["subscriptionEndDateUtc"].toString()) : <any>undefined;
            this.editionId = data["editionId"];
            this.isInTrialPeriod = data["isInTrialPeriod"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): TenantListDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["editionDisplayName"] = this.editionDisplayName;
        data["connectionString"] = this.connectionString;
        data["isActive"] = this.isActive;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["subscriptionEndDateUtc"] = this.subscriptionEndDateUtc ? this.subscriptionEndDateUtc.toISOString() : <any>undefined;
        data["editionId"] = this.editionId;
        data["isInTrialPeriod"] = this.isInTrialPeriod;
        data["id"] = this.id;
        return data;
    }
}

export interface ITenantListDto {
    tenancyName: string | undefined;
    name: string | undefined;
    editionDisplayName: string | undefined;
    connectionString: string | undefined;
    isActive: boolean | undefined;
    creationTime: moment.Moment | undefined;
    subscriptionEndDateUtc: moment.Moment | undefined;
    editionId: number | undefined;
    isInTrialPeriod: boolean | undefined;
    id: number | undefined;
}

export class CreateTenantInput implements ICreateTenantInput {
    tenancyName!: string;
    name!: string;
    adminEmailAddress!: string;
    adminPassword!: string | undefined;
    connectionString!: string | undefined;
    shouldChangePasswordOnNextLogin!: boolean | undefined;
    sendActivationEmail!: boolean | undefined;
    editionId!: number | undefined;
    isActive!: boolean | undefined;
    subscriptionEndDateUtc!: moment.Moment | undefined;
    isInTrialPeriod!: boolean | undefined;
    timeZone!: string | undefined;

    constructor(data?: ICreateTenantInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenancyName = data["tenancyName"];
            this.name = data["name"];
            this.adminEmailAddress = data["adminEmailAddress"];
            this.adminPassword = data["adminPassword"];
            this.connectionString = data["connectionString"];
            this.shouldChangePasswordOnNextLogin = data["shouldChangePasswordOnNextLogin"];
            this.sendActivationEmail = data["sendActivationEmail"];
            this.editionId = data["editionId"];
            this.isActive = data["isActive"];
            this.subscriptionEndDateUtc = data["subscriptionEndDateUtc"] ? moment(data["subscriptionEndDateUtc"].toString()) : <any>undefined;
            this.isInTrialPeriod = data["isInTrialPeriod"];
            this.timeZone = data["timeZone"];
        }
    }

    static fromJS(data: any): CreateTenantInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTenantInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["adminEmailAddress"] = this.adminEmailAddress;
        data["adminPassword"] = this.adminPassword;
        data["connectionString"] = this.connectionString;
        data["shouldChangePasswordOnNextLogin"] = this.shouldChangePasswordOnNextLogin;
        data["sendActivationEmail"] = this.sendActivationEmail;
        data["editionId"] = this.editionId;
        data["isActive"] = this.isActive;
        data["subscriptionEndDateUtc"] = this.subscriptionEndDateUtc ? this.subscriptionEndDateUtc.toISOString() : <any>undefined;
        data["isInTrialPeriod"] = this.isInTrialPeriod;
        data["timeZone"] = this.timeZone;
        return data;
    }
}

export interface ICreateTenantInput {
    tenancyName: string;
    name: string;
    adminEmailAddress: string;
    adminPassword: string | undefined;
    connectionString: string | undefined;
    shouldChangePasswordOnNextLogin: boolean | undefined;
    sendActivationEmail: boolean | undefined;
    editionId: number | undefined;
    isActive: boolean | undefined;
    subscriptionEndDateUtc: moment.Moment | undefined;
    isInTrialPeriod: boolean | undefined;
    timeZone: string | undefined;
}

export class TenantEditDto implements ITenantEditDto {
    tenancyName!: string;
    name!: string;
    connectionString!: string | undefined;
    editionId!: number | undefined;
    isActive!: boolean | undefined;
    subscriptionEndDateUtc!: moment.Moment | undefined;
    isInTrialPeriod!: boolean | undefined;
    timeZone!: string | undefined;
    id!: number | undefined;

    constructor(data?: ITenantEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenancyName = data["tenancyName"];
            this.name = data["name"];
            this.connectionString = data["connectionString"];
            this.editionId = data["editionId"];
            this.isActive = data["isActive"];
            this.subscriptionEndDateUtc = data["subscriptionEndDateUtc"] ? moment(data["subscriptionEndDateUtc"].toString()) : <any>undefined;
            this.isInTrialPeriod = data["isInTrialPeriod"];
            this.timeZone = data["timeZone"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): TenantEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["connectionString"] = this.connectionString;
        data["editionId"] = this.editionId;
        data["isActive"] = this.isActive;
        data["subscriptionEndDateUtc"] = this.subscriptionEndDateUtc ? this.subscriptionEndDateUtc.toISOString() : <any>undefined;
        data["isInTrialPeriod"] = this.isInTrialPeriod;
        data["timeZone"] = this.timeZone;
        data["id"] = this.id;
        return data;
    }
}

export interface ITenantEditDto {
    tenancyName: string;
    name: string;
    connectionString: string | undefined;
    editionId: number | undefined;
    isActive: boolean | undefined;
    subscriptionEndDateUtc: moment.Moment | undefined;
    isInTrialPeriod: boolean | undefined;
    timeZone: string | undefined;
    id: number | undefined;
}

export class GetTenantFeaturesEditOutput implements IGetTenantFeaturesEditOutput {
    featureValues!: NameValueDto[] | undefined;
    features!: FlatFeatureDto[] | undefined;

    constructor(data?: IGetTenantFeaturesEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["featureValues"] && data["featureValues"].constructor === Array) {
                this.featureValues = [];
                for (let item of data["featureValues"])
                    this.featureValues.push(NameValueDto.fromJS(item));
            }
            if (data["features"] && data["features"].constructor === Array) {
                this.features = [];
                for (let item of data["features"])
                    this.features.push(FlatFeatureDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetTenantFeaturesEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetTenantFeaturesEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.featureValues && this.featureValues.constructor === Array) {
            data["featureValues"] = [];
            for (let item of this.featureValues)
                data["featureValues"].push(item.toJSON());
        }
        if (this.features && this.features.constructor === Array) {
            data["features"] = [];
            for (let item of this.features)
                data["features"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetTenantFeaturesEditOutput {
    featureValues: NameValueDto[] | undefined;
    features: FlatFeatureDto[] | undefined;
}

export class UpdateTenantFeaturesInput implements IUpdateTenantFeaturesInput {
    id!: number | undefined;
    featureValues!: NameValueDto[];

    constructor(data?: IUpdateTenantFeaturesInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.featureValues = [];
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            if (data["featureValues"] && data["featureValues"].constructor === Array) {
                this.featureValues = [];
                for (let item of data["featureValues"])
                    this.featureValues.push(NameValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateTenantFeaturesInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTenantFeaturesInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (this.featureValues && this.featureValues.constructor === Array) {
            data["featureValues"] = [];
            for (let item of this.featureValues)
                data["featureValues"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateTenantFeaturesInput {
    id: number | undefined;
    featureValues: NameValueDto[];
}

export class GetMemberActivityOutput implements IGetMemberActivityOutput {
    memberActivities!: MemberActivity[] | undefined;

    constructor(data?: IGetMemberActivityOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["memberActivities"] && data["memberActivities"].constructor === Array) {
                this.memberActivities = [];
                for (let item of data["memberActivities"])
                    this.memberActivities.push(MemberActivity.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMemberActivityOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetMemberActivityOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.memberActivities && this.memberActivities.constructor === Array) {
            data["memberActivities"] = [];
            for (let item of this.memberActivities)
                data["memberActivities"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetMemberActivityOutput {
    memberActivities: MemberActivity[] | undefined;
}

export class MemberActivity implements IMemberActivity {
    name!: string | undefined;
    earnings!: string | undefined;
    cases!: number | undefined;
    closed!: number | undefined;
    rate!: string | undefined;

    constructor(data?: IMemberActivity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.earnings = data["earnings"];
            this.cases = data["cases"];
            this.closed = data["closed"];
            this.rate = data["rate"];
        }
    }

    static fromJS(data: any): MemberActivity {
        data = typeof data === 'object' ? data : {};
        let result = new MemberActivity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["earnings"] = this.earnings;
        data["cases"] = this.cases;
        data["closed"] = this.closed;
        data["rate"] = this.rate;
        return data;
    }
}

export interface IMemberActivity {
    name: string | undefined;
    earnings: string | undefined;
    cases: number | undefined;
    closed: number | undefined;
    rate: string | undefined;
}

export class GetDashboardDataOutput implements IGetDashboardDataOutput {
    totalProfit!: number | undefined;
    newFeedbacks!: number | undefined;
    newOrders!: number | undefined;
    newUsers!: number | undefined;
    salesSummary!: SalesSummaryData[] | undefined;
    totalSales!: number | undefined;
    revenue!: number | undefined;
    expenses!: number | undefined;
    growth!: number | undefined;
    transactionPercent!: number | undefined;
    newVisitPercent!: number | undefined;
    bouncePercent!: number | undefined;
    dailySales!: number[] | undefined;
    profitShares!: number[] | undefined;

    constructor(data?: IGetDashboardDataOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalProfit = data["totalProfit"];
            this.newFeedbacks = data["newFeedbacks"];
            this.newOrders = data["newOrders"];
            this.newUsers = data["newUsers"];
            if (data["salesSummary"] && data["salesSummary"].constructor === Array) {
                this.salesSummary = [];
                for (let item of data["salesSummary"])
                    this.salesSummary.push(SalesSummaryData.fromJS(item));
            }
            this.totalSales = data["totalSales"];
            this.revenue = data["revenue"];
            this.expenses = data["expenses"];
            this.growth = data["growth"];
            this.transactionPercent = data["transactionPercent"];
            this.newVisitPercent = data["newVisitPercent"];
            this.bouncePercent = data["bouncePercent"];
            if (data["dailySales"] && data["dailySales"].constructor === Array) {
                this.dailySales = [];
                for (let item of data["dailySales"])
                    this.dailySales.push(item);
            }
            if (data["profitShares"] && data["profitShares"].constructor === Array) {
                this.profitShares = [];
                for (let item of data["profitShares"])
                    this.profitShares.push(item);
            }
        }
    }

    static fromJS(data: any): GetDashboardDataOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetDashboardDataOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalProfit"] = this.totalProfit;
        data["newFeedbacks"] = this.newFeedbacks;
        data["newOrders"] = this.newOrders;
        data["newUsers"] = this.newUsers;
        if (this.salesSummary && this.salesSummary.constructor === Array) {
            data["salesSummary"] = [];
            for (let item of this.salesSummary)
                data["salesSummary"].push(item.toJSON());
        }
        data["totalSales"] = this.totalSales;
        data["revenue"] = this.revenue;
        data["expenses"] = this.expenses;
        data["growth"] = this.growth;
        data["transactionPercent"] = this.transactionPercent;
        data["newVisitPercent"] = this.newVisitPercent;
        data["bouncePercent"] = this.bouncePercent;
        if (this.dailySales && this.dailySales.constructor === Array) {
            data["dailySales"] = [];
            for (let item of this.dailySales)
                data["dailySales"].push(item);
        }
        if (this.profitShares && this.profitShares.constructor === Array) {
            data["profitShares"] = [];
            for (let item of this.profitShares)
                data["profitShares"].push(item);
        }
        return data;
    }
}

export interface IGetDashboardDataOutput {
    totalProfit: number | undefined;
    newFeedbacks: number | undefined;
    newOrders: number | undefined;
    newUsers: number | undefined;
    salesSummary: SalesSummaryData[] | undefined;
    totalSales: number | undefined;
    revenue: number | undefined;
    expenses: number | undefined;
    growth: number | undefined;
    transactionPercent: number | undefined;
    newVisitPercent: number | undefined;
    bouncePercent: number | undefined;
    dailySales: number[] | undefined;
    profitShares: number[] | undefined;
}

export class SalesSummaryData implements ISalesSummaryData {
    period!: string | undefined;
    sales!: number | undefined;
    profit!: number | undefined;

    constructor(data?: ISalesSummaryData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.period = data["period"];
            this.sales = data["sales"];
            this.profit = data["profit"];
        }
    }

    static fromJS(data: any): SalesSummaryData {
        data = typeof data === 'object' ? data : {};
        let result = new SalesSummaryData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["period"] = this.period;
        data["sales"] = this.sales;
        data["profit"] = this.profit;
        return data;
    }
}

export interface ISalesSummaryData {
    period: string | undefined;
    sales: number | undefined;
    profit: number | undefined;
}

export class GetSalesSummaryOutput implements IGetSalesSummaryOutput {
    salesSummary!: SalesSummaryData[] | undefined;

    constructor(data?: IGetSalesSummaryOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["salesSummary"] && data["salesSummary"].constructor === Array) {
                this.salesSummary = [];
                for (let item of data["salesSummary"])
                    this.salesSummary.push(SalesSummaryData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetSalesSummaryOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetSalesSummaryOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.salesSummary && this.salesSummary.constructor === Array) {
            data["salesSummary"] = [];
            for (let item of this.salesSummary)
                data["salesSummary"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetSalesSummaryOutput {
    salesSummary: SalesSummaryData[] | undefined;
}

export class GetRegionalStatsOutput implements IGetRegionalStatsOutput {
    stats!: RegionalStatCountry[] | undefined;

    constructor(data?: IGetRegionalStatsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["stats"] && data["stats"].constructor === Array) {
                this.stats = [];
                for (let item of data["stats"])
                    this.stats.push(RegionalStatCountry.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetRegionalStatsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetRegionalStatsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.stats && this.stats.constructor === Array) {
            data["stats"] = [];
            for (let item of this.stats)
                data["stats"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetRegionalStatsOutput {
    stats: RegionalStatCountry[] | undefined;
}

export class RegionalStatCountry implements IRegionalStatCountry {
    countryName!: string | undefined;
    sales!: number | undefined;
    change!: number[] | undefined;
    averagePrice!: number | undefined;
    totalPrice!: number | undefined;

    constructor(data?: IRegionalStatCountry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.countryName = data["countryName"];
            this.sales = data["sales"];
            if (data["change"] && data["change"].constructor === Array) {
                this.change = [];
                for (let item of data["change"])
                    this.change.push(item);
            }
            this.averagePrice = data["averagePrice"];
            this.totalPrice = data["totalPrice"];
        }
    }

    static fromJS(data: any): RegionalStatCountry {
        data = typeof data === 'object' ? data : {};
        let result = new RegionalStatCountry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryName"] = this.countryName;
        data["sales"] = this.sales;
        if (this.change && this.change.constructor === Array) {
            data["change"] = [];
            for (let item of this.change)
                data["change"].push(item);
        }
        data["averagePrice"] = this.averagePrice;
        data["totalPrice"] = this.totalPrice;
        return data;
    }
}

export interface IRegionalStatCountry {
    countryName: string | undefined;
    sales: number | undefined;
    change: number[] | undefined;
    averagePrice: number | undefined;
    totalPrice: number | undefined;
}

export class GetGeneralStatsOutput implements IGetGeneralStatsOutput {
    transactionPercent!: number | undefined;
    newVisitPercent!: number | undefined;
    bouncePercent!: number | undefined;

    constructor(data?: IGetGeneralStatsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.transactionPercent = data["transactionPercent"];
            this.newVisitPercent = data["newVisitPercent"];
            this.bouncePercent = data["bouncePercent"];
        }
    }

    static fromJS(data: any): GetGeneralStatsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeneralStatsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionPercent"] = this.transactionPercent;
        data["newVisitPercent"] = this.newVisitPercent;
        data["bouncePercent"] = this.bouncePercent;
        return data;
    }
}

export interface IGetGeneralStatsOutput {
    transactionPercent: number | undefined;
    newVisitPercent: number | undefined;
    bouncePercent: number | undefined;
}

export class RegisterTenantInput implements IRegisterTenantInput {
    tenancyName!: string;
    name!: string;
    adminEmailAddress!: string;
    adminPassword!: string | undefined;
    captchaResponse!: string | undefined;
    subscriptionStartType!: RegisterTenantInputSubscriptionStartType | undefined;
    gateway!: RegisterTenantInputGateway | undefined;
    editionId!: number | undefined;
    paymentId!: string | undefined;

    constructor(data?: IRegisterTenantInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenancyName = data["tenancyName"];
            this.name = data["name"];
            this.adminEmailAddress = data["adminEmailAddress"];
            this.adminPassword = data["adminPassword"];
            this.captchaResponse = data["captchaResponse"];
            this.subscriptionStartType = data["subscriptionStartType"];
            this.gateway = data["gateway"];
            this.editionId = data["editionId"];
            this.paymentId = data["paymentId"];
        }
    }

    static fromJS(data: any): RegisterTenantInput {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterTenantInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["adminEmailAddress"] = this.adminEmailAddress;
        data["adminPassword"] = this.adminPassword;
        data["captchaResponse"] = this.captchaResponse;
        data["subscriptionStartType"] = this.subscriptionStartType;
        data["gateway"] = this.gateway;
        data["editionId"] = this.editionId;
        data["paymentId"] = this.paymentId;
        return data;
    }
}

export interface IRegisterTenantInput {
    tenancyName: string;
    name: string;
    adminEmailAddress: string;
    adminPassword: string | undefined;
    captchaResponse: string | undefined;
    subscriptionStartType: RegisterTenantInputSubscriptionStartType | undefined;
    gateway: RegisterTenantInputGateway | undefined;
    editionId: number | undefined;
    paymentId: string | undefined;
}

export class RegisterTenantOutput implements IRegisterTenantOutput {
    tenantId!: number | undefined;
    tenancyName!: string | undefined;
    name!: string | undefined;
    userName!: string | undefined;
    emailAddress!: string | undefined;
    isTenantActive!: boolean | undefined;
    isActive!: boolean | undefined;
    isEmailConfirmationRequired!: boolean | undefined;

    constructor(data?: IRegisterTenantOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.tenancyName = data["tenancyName"];
            this.name = data["name"];
            this.userName = data["userName"];
            this.emailAddress = data["emailAddress"];
            this.isTenantActive = data["isTenantActive"];
            this.isActive = data["isActive"];
            this.isEmailConfirmationRequired = data["isEmailConfirmationRequired"];
        }
    }

    static fromJS(data: any): RegisterTenantOutput {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterTenantOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["isTenantActive"] = this.isTenantActive;
        data["isActive"] = this.isActive;
        data["isEmailConfirmationRequired"] = this.isEmailConfirmationRequired;
        return data;
    }
}

export interface IRegisterTenantOutput {
    tenantId: number | undefined;
    tenancyName: string | undefined;
    name: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    isTenantActive: boolean | undefined;
    isActive: boolean | undefined;
    isEmailConfirmationRequired: boolean | undefined;
}

export class EditionsSelectOutput implements IEditionsSelectOutput {
    allFeatures!: FlatFeatureSelectDto[] | undefined;
    editionsWithFeatures!: EditionWithFeaturesDto[] | undefined;
    tenantEditionId!: number | undefined;

    constructor(data?: IEditionsSelectOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["allFeatures"] && data["allFeatures"].constructor === Array) {
                this.allFeatures = [];
                for (let item of data["allFeatures"])
                    this.allFeatures.push(FlatFeatureSelectDto.fromJS(item));
            }
            if (data["editionsWithFeatures"] && data["editionsWithFeatures"].constructor === Array) {
                this.editionsWithFeatures = [];
                for (let item of data["editionsWithFeatures"])
                    this.editionsWithFeatures.push(EditionWithFeaturesDto.fromJS(item));
            }
            this.tenantEditionId = data["tenantEditionId"];
        }
    }

    static fromJS(data: any): EditionsSelectOutput {
        data = typeof data === 'object' ? data : {};
        let result = new EditionsSelectOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.allFeatures && this.allFeatures.constructor === Array) {
            data["allFeatures"] = [];
            for (let item of this.allFeatures)
                data["allFeatures"].push(item.toJSON());
        }
        if (this.editionsWithFeatures && this.editionsWithFeatures.constructor === Array) {
            data["editionsWithFeatures"] = [];
            for (let item of this.editionsWithFeatures)
                data["editionsWithFeatures"].push(item.toJSON());
        }
        data["tenantEditionId"] = this.tenantEditionId;
        return data;
    }
}

export interface IEditionsSelectOutput {
    allFeatures: FlatFeatureSelectDto[] | undefined;
    editionsWithFeatures: EditionWithFeaturesDto[] | undefined;
    tenantEditionId: number | undefined;
}

export class FlatFeatureSelectDto implements IFlatFeatureSelectDto {
    parentName!: string | undefined;
    name!: string | undefined;
    displayName!: string | undefined;
    description!: string | undefined;
    defaultValue!: string | undefined;
    inputType!: IInputType | undefined;
    textHtmlColor!: string | undefined;

    constructor(data?: IFlatFeatureSelectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.parentName = data["parentName"];
            this.name = data["name"];
            this.displayName = data["displayName"];
            this.description = data["description"];
            this.defaultValue = data["defaultValue"];
            this.inputType = data["inputType"] ? IInputType.fromJS(data["inputType"]) : <any>undefined;
            this.textHtmlColor = data["textHtmlColor"];
        }
    }

    static fromJS(data: any): FlatFeatureSelectDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlatFeatureSelectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentName"] = this.parentName;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["defaultValue"] = this.defaultValue;
        data["inputType"] = this.inputType ? this.inputType.toJSON() : <any>undefined;
        data["textHtmlColor"] = this.textHtmlColor;
        return data;
    }
}

export interface IFlatFeatureSelectDto {
    parentName: string | undefined;
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    defaultValue: string | undefined;
    inputType: IInputType | undefined;
    textHtmlColor: string | undefined;
}

export class EditionWithFeaturesDto implements IEditionWithFeaturesDto {
    edition!: EditionSelectDto | undefined;
    featureValues!: NameValueDto[] | undefined;

    constructor(data?: IEditionWithFeaturesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.edition = data["edition"] ? EditionSelectDto.fromJS(data["edition"]) : <any>undefined;
            if (data["featureValues"] && data["featureValues"].constructor === Array) {
                this.featureValues = [];
                for (let item of data["featureValues"])
                    this.featureValues.push(NameValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EditionWithFeaturesDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditionWithFeaturesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["edition"] = this.edition ? this.edition.toJSON() : <any>undefined;
        if (this.featureValues && this.featureValues.constructor === Array) {
            data["featureValues"] = [];
            for (let item of this.featureValues)
                data["featureValues"].push(item.toJSON());
        }
        return data;
    }
}

export interface IEditionWithFeaturesDto {
    edition: EditionSelectDto | undefined;
    featureValues: NameValueDto[] | undefined;
}

export class IInputType implements IIInputType {
    name!: string | undefined;
    attributes!: { [key: string]: any; } | undefined;
    validator!: IValueValidator | undefined;

    constructor(data?: IIInputType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            if (data["attributes"]) {
                this.attributes = {};
                for (let key in data["attributes"]) {
                    if (data["attributes"].hasOwnProperty(key))
                        this.attributes[key] = data["attributes"][key];
                }
            }
            this.validator = data["validator"] ? IValueValidator.fromJS(data["validator"]) : <any>undefined;
        }
    }

    static fromJS(data: any): IInputType {
        data = typeof data === 'object' ? data : {};
        let result = new IInputType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (this.attributes) {
            data["attributes"] = {};
            for (let key in this.attributes) {
                if (this.attributes.hasOwnProperty(key))
                    data["attributes"][key] = this.attributes[key];
            }
        }
        data["validator"] = this.validator ? this.validator.toJSON() : <any>undefined;
        return data;
    }
}

export interface IIInputType {
    name: string | undefined;
    attributes: { [key: string]: any; } | undefined;
    validator: IValueValidator | undefined;
}

export class TenantSettingsEditDto implements ITenantSettingsEditDto {
    general!: GeneralSettingsEditDto | undefined;
    userManagement!: TenantUserManagementSettingsEditDto;
    email!: EmailSettingsEditDto | undefined;
    ldap!: LdapSettingsEditDto | undefined;
    security!: SecuritySettingsEditDto;
    billing!: TenantBillingSettingsEditDto | undefined;

    constructor(data?: ITenantSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.userManagement = new TenantUserManagementSettingsEditDto();
            this.security = new SecuritySettingsEditDto();
        }
    }

    init(data?: any) {
        if (data) {
            this.general = data["general"] ? GeneralSettingsEditDto.fromJS(data["general"]) : <any>undefined;
            this.userManagement = data["userManagement"] ? TenantUserManagementSettingsEditDto.fromJS(data["userManagement"]) : new TenantUserManagementSettingsEditDto();
            this.email = data["email"] ? EmailSettingsEditDto.fromJS(data["email"]) : <any>undefined;
            this.ldap = data["ldap"] ? LdapSettingsEditDto.fromJS(data["ldap"]) : <any>undefined;
            this.security = data["security"] ? SecuritySettingsEditDto.fromJS(data["security"]) : new SecuritySettingsEditDto();
            this.billing = data["billing"] ? TenantBillingSettingsEditDto.fromJS(data["billing"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TenantSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["general"] = this.general ? this.general.toJSON() : <any>undefined;
        data["userManagement"] = this.userManagement ? this.userManagement.toJSON() : <any>undefined;
        data["email"] = this.email ? this.email.toJSON() : <any>undefined;
        data["ldap"] = this.ldap ? this.ldap.toJSON() : <any>undefined;
        data["security"] = this.security ? this.security.toJSON() : <any>undefined;
        data["billing"] = this.billing ? this.billing.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITenantSettingsEditDto {
    general: GeneralSettingsEditDto | undefined;
    userManagement: TenantUserManagementSettingsEditDto;
    email: EmailSettingsEditDto | undefined;
    ldap: LdapSettingsEditDto | undefined;
    security: SecuritySettingsEditDto;
    billing: TenantBillingSettingsEditDto | undefined;
}

export class TenantUserManagementSettingsEditDto implements ITenantUserManagementSettingsEditDto {
    allowSelfRegistration!: boolean | undefined;
    isNewRegisteredUserActiveByDefault!: boolean | undefined;
    isEmailConfirmationRequiredForLogin!: boolean | undefined;
    useCaptchaOnRegistration!: boolean | undefined;

    constructor(data?: ITenantUserManagementSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.allowSelfRegistration = data["allowSelfRegistration"];
            this.isNewRegisteredUserActiveByDefault = data["isNewRegisteredUserActiveByDefault"];
            this.isEmailConfirmationRequiredForLogin = data["isEmailConfirmationRequiredForLogin"];
            this.useCaptchaOnRegistration = data["useCaptchaOnRegistration"];
        }
    }

    static fromJS(data: any): TenantUserManagementSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantUserManagementSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allowSelfRegistration"] = this.allowSelfRegistration;
        data["isNewRegisteredUserActiveByDefault"] = this.isNewRegisteredUserActiveByDefault;
        data["isEmailConfirmationRequiredForLogin"] = this.isEmailConfirmationRequiredForLogin;
        data["useCaptchaOnRegistration"] = this.useCaptchaOnRegistration;
        return data;
    }
}

export interface ITenantUserManagementSettingsEditDto {
    allowSelfRegistration: boolean | undefined;
    isNewRegisteredUserActiveByDefault: boolean | undefined;
    isEmailConfirmationRequiredForLogin: boolean | undefined;
    useCaptchaOnRegistration: boolean | undefined;
}

export class LdapSettingsEditDto implements ILdapSettingsEditDto {
    isModuleEnabled!: boolean | undefined;
    isEnabled!: boolean | undefined;
    domain!: string | undefined;
    userName!: string | undefined;
    password!: string | undefined;

    constructor(data?: ILdapSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isModuleEnabled = data["isModuleEnabled"];
            this.isEnabled = data["isEnabled"];
            this.domain = data["domain"];
            this.userName = data["userName"];
            this.password = data["password"];
        }
    }

    static fromJS(data: any): LdapSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new LdapSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isModuleEnabled"] = this.isModuleEnabled;
        data["isEnabled"] = this.isEnabled;
        data["domain"] = this.domain;
        data["userName"] = this.userName;
        data["password"] = this.password;
        return data;
    }
}

export interface ILdapSettingsEditDto {
    isModuleEnabled: boolean | undefined;
    isEnabled: boolean | undefined;
    domain: string | undefined;
    userName: string | undefined;
    password: string | undefined;
}

export class TenantBillingSettingsEditDto implements ITenantBillingSettingsEditDto {
    legalName!: string | undefined;
    address!: string | undefined;
    taxVatNo!: string | undefined;

    constructor(data?: ITenantBillingSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.legalName = data["legalName"];
            this.address = data["address"];
            this.taxVatNo = data["taxVatNo"];
        }
    }

    static fromJS(data: any): TenantBillingSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantBillingSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["legalName"] = this.legalName;
        data["address"] = this.address;
        data["taxVatNo"] = this.taxVatNo;
        return data;
    }
}

export interface ITenantBillingSettingsEditDto {
    legalName: string | undefined;
    address: string | undefined;
    taxVatNo: string | undefined;
}

export class GetAllTerminalMastersInput implements IGetAllTerminalMastersInput {
    filter!: string | undefined;
    userNameFilter!: string | undefined;
    passwordFilter!: string | undefined;
    statusFilter!: string | undefined;
    referenceCodeFilter!: string | undefined;
    terminalCodeFilter!: string | undefined;
    terminalNameFilter!: string | undefined;
    terminalNameUnsignFilter!: string | undefined;
    fullSalesRegionFilter!: string | undefined;
    productHierarchyLV1Filter!: string | undefined;
    productHierarchyLV2Filter!: string | undefined;
    productHierarchyLV3Filter!: string | undefined;
    productHierarchyLV4Filter!: string | undefined;
    productHierarchyLV5Filter!: string | undefined;
    idFilter!: number | undefined;
    sorting!: string | undefined;
    skipCount!: number | undefined;
    maxResultCount!: number | undefined;

    constructor(data?: IGetAllTerminalMastersInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.filter = data["filter"];
            this.userNameFilter = data["userNameFilter"];
            this.passwordFilter = data["passwordFilter"];
            this.statusFilter = data["statusFilter"];
            this.referenceCodeFilter = data["referenceCodeFilter"];
            this.terminalCodeFilter = data["terminalCodeFilter"];
            this.terminalNameFilter = data["terminalNameFilter"];
            this.terminalNameUnsignFilter = data["terminalNameUnsignFilter"];
            this.fullSalesRegionFilter = data["fullSalesRegionFilter"];
            this.productHierarchyLV1Filter = data["productHierarchyLV1Filter"];
            this.productHierarchyLV2Filter = data["productHierarchyLV2Filter"];
            this.productHierarchyLV3Filter = data["productHierarchyLV3Filter"];
            this.productHierarchyLV4Filter = data["productHierarchyLV4Filter"];
            this.productHierarchyLV5Filter = data["productHierarchyLV5Filter"];
            this.idFilter = data["idFilter"];
            this.sorting = data["sorting"];
            this.skipCount = data["skipCount"];
            this.maxResultCount = data["maxResultCount"];
        }
    }

    static fromJS(data: any): GetAllTerminalMastersInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllTerminalMastersInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        data["userNameFilter"] = this.userNameFilter;
        data["passwordFilter"] = this.passwordFilter;
        data["statusFilter"] = this.statusFilter;
        data["referenceCodeFilter"] = this.referenceCodeFilter;
        data["terminalCodeFilter"] = this.terminalCodeFilter;
        data["terminalNameFilter"] = this.terminalNameFilter;
        data["terminalNameUnsignFilter"] = this.terminalNameUnsignFilter;
        data["fullSalesRegionFilter"] = this.fullSalesRegionFilter;
        data["productHierarchyLV1Filter"] = this.productHierarchyLV1Filter;
        data["productHierarchyLV2Filter"] = this.productHierarchyLV2Filter;
        data["productHierarchyLV3Filter"] = this.productHierarchyLV3Filter;
        data["productHierarchyLV4Filter"] = this.productHierarchyLV4Filter;
        data["productHierarchyLV5Filter"] = this.productHierarchyLV5Filter;
        data["idFilter"] = this.idFilter;
        data["sorting"] = this.sorting;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data;
    }
}

export interface IGetAllTerminalMastersInput {
    filter: string | undefined;
    userNameFilter: string | undefined;
    passwordFilter: string | undefined;
    statusFilter: string | undefined;
    referenceCodeFilter: string | undefined;
    terminalCodeFilter: string | undefined;
    terminalNameFilter: string | undefined;
    terminalNameUnsignFilter: string | undefined;
    fullSalesRegionFilter: string | undefined;
    productHierarchyLV1Filter: string | undefined;
    productHierarchyLV2Filter: string | undefined;
    productHierarchyLV3Filter: string | undefined;
    productHierarchyLV4Filter: string | undefined;
    productHierarchyLV5Filter: string | undefined;
    idFilter: number | undefined;
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;
}

export class PagedResultDtoOfGetTerminalMasterForViewDto implements IPagedResultDtoOfGetTerminalMasterForViewDto {
    totalCount!: number | undefined;
    items!: GetTerminalMasterForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetTerminalMasterForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetTerminalMasterForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetTerminalMasterForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetTerminalMasterForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetTerminalMasterForViewDto {
    totalCount: number | undefined;
    items: GetTerminalMasterForViewDto[] | undefined;
}

export class GetTerminalMasterForViewDto implements IGetTerminalMasterForViewDto {
    terminalMaster!: TerminalMasterDto | undefined;

    constructor(data?: IGetTerminalMasterForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.terminalMaster = data["terminalMaster"] ? TerminalMasterDto.fromJS(data["terminalMaster"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetTerminalMasterForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetTerminalMasterForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["terminalMaster"] = this.terminalMaster ? this.terminalMaster.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetTerminalMasterForViewDto {
    terminalMaster: TerminalMasterDto | undefined;
}

export class TerminalMasterDto implements ITerminalMasterDto {
    userName!: string | undefined;
    password!: string | undefined;
    status!: string | undefined;
    referenceCode!: string | undefined;
    terminalCode!: string | undefined;
    terminalName!: string | undefined;
    terminalNameUnsign!: string | undefined;
    fullSalesRegion!: string | undefined;
    productHierarchyLV1!: string | undefined;
    productHierarchyLV2!: string | undefined;
    productHierarchyLV3!: string | undefined;
    productHierarchyLV4!: string | undefined;
    productHierarchyLV5!: string | undefined;
    creationTime!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;
    detailValue!: string | undefined;
    id!: number | undefined;

    constructor(data?: ITerminalMasterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userName = data["userName"];
            this.password = data["password"];
            this.status = data["status"];
            this.referenceCode = data["referenceCode"];
            this.terminalCode = data["terminalCode"];
            this.terminalName = data["terminalName"];
            this.terminalNameUnsign = data["terminalNameUnsign"];
            this.fullSalesRegion = data["fullSalesRegion"];
            this.productHierarchyLV1 = data["productHierarchyLV1"];
            this.productHierarchyLV2 = data["productHierarchyLV2"];
            this.productHierarchyLV3 = data["productHierarchyLV3"];
            this.productHierarchyLV4 = data["productHierarchyLV4"];
            this.productHierarchyLV5 = data["productHierarchyLV5"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.detailValue = data["detailValue"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): TerminalMasterDto {
        data = typeof data === 'object' ? data : {};
        let result = new TerminalMasterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["password"] = this.password;
        data["status"] = this.status;
        data["referenceCode"] = this.referenceCode;
        data["terminalCode"] = this.terminalCode;
        data["terminalName"] = this.terminalName;
        data["terminalNameUnsign"] = this.terminalNameUnsign;
        data["fullSalesRegion"] = this.fullSalesRegion;
        data["productHierarchyLV1"] = this.productHierarchyLV1;
        data["productHierarchyLV2"] = this.productHierarchyLV2;
        data["productHierarchyLV3"] = this.productHierarchyLV3;
        data["productHierarchyLV4"] = this.productHierarchyLV4;
        data["productHierarchyLV5"] = this.productHierarchyLV5;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["detailValue"] = this.detailValue;
        data["id"] = this.id;
        return data;
    }
}

export interface ITerminalMasterDto {
    userName: string | undefined;
    password: string | undefined;
    status: string | undefined;
    referenceCode: string | undefined;
    terminalCode: string | undefined;
    terminalName: string | undefined;
    terminalNameUnsign: string | undefined;
    fullSalesRegion: string | undefined;
    productHierarchyLV1: string | undefined;
    productHierarchyLV2: string | undefined;
    productHierarchyLV3: string | undefined;
    productHierarchyLV4: string | undefined;
    productHierarchyLV5: string | undefined;
    creationTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    detailValue: string | undefined;
    id: number | undefined;
}

export class CreateOrEditTerminalMasterDto implements ICreateOrEditTerminalMasterDto {
    userName!: string | undefined;
    password!: string | undefined;
    status!: string | undefined;
    referenceCode!: string | undefined;
    terminalCode!: string | undefined;
    terminalName!: string | undefined;
    terminalNameUnsign!: string | undefined;
    fullSalesRegion!: string | undefined;
    productHierarchyLV1!: string | undefined;
    productHierarchyLV2!: string | undefined;
    productHierarchyLV3!: string | undefined;
    productHierarchyLV4!: string | undefined;
    productHierarchyLV5!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditTerminalMasterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userName = data["userName"];
            this.password = data["password"];
            this.status = data["status"];
            this.referenceCode = data["referenceCode"];
            this.terminalCode = data["terminalCode"];
            this.terminalName = data["terminalName"];
            this.terminalNameUnsign = data["terminalNameUnsign"];
            this.fullSalesRegion = data["fullSalesRegion"];
            this.productHierarchyLV1 = data["productHierarchyLV1"];
            this.productHierarchyLV2 = data["productHierarchyLV2"];
            this.productHierarchyLV3 = data["productHierarchyLV3"];
            this.productHierarchyLV4 = data["productHierarchyLV4"];
            this.productHierarchyLV5 = data["productHierarchyLV5"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditTerminalMasterDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditTerminalMasterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["password"] = this.password;
        data["status"] = this.status;
        data["referenceCode"] = this.referenceCode;
        data["terminalCode"] = this.terminalCode;
        data["terminalName"] = this.terminalName;
        data["terminalNameUnsign"] = this.terminalNameUnsign;
        data["fullSalesRegion"] = this.fullSalesRegion;
        data["productHierarchyLV1"] = this.productHierarchyLV1;
        data["productHierarchyLV2"] = this.productHierarchyLV2;
        data["productHierarchyLV3"] = this.productHierarchyLV3;
        data["productHierarchyLV4"] = this.productHierarchyLV4;
        data["productHierarchyLV5"] = this.productHierarchyLV5;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditTerminalMasterDto {
    userName: string | undefined;
    password: string | undefined;
    status: string | undefined;
    referenceCode: string | undefined;
    terminalCode: string | undefined;
    terminalName: string | undefined;
    terminalNameUnsign: string | undefined;
    fullSalesRegion: string | undefined;
    productHierarchyLV1: string | undefined;
    productHierarchyLV2: string | undefined;
    productHierarchyLV3: string | undefined;
    productHierarchyLV4: string | undefined;
    productHierarchyLV5: string | undefined;
    id: number | undefined;
}

export class MessageResult implements IMessageResult {
    isSuccess!: boolean | undefined;
    errors!: MessageError[] | undefined;

    constructor(data?: IMessageResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isSuccess = data["isSuccess"];
            if (data["errors"] && data["errors"].constructor === Array) {
                this.errors = [];
                for (let item of data["errors"])
                    this.errors.push(MessageError.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MessageResult {
        data = typeof data === 'object' ? data : {};
        let result = new MessageResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        if (this.errors && this.errors.constructor === Array) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMessageResult {
    isSuccess: boolean | undefined;
    errors: MessageError[] | undefined;
}

export class MessageError implements IMessageError {
    message!: string | undefined;
    propertyName!: string | undefined;
    count!: number | undefined;

    constructor(data?: IMessageError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.message = data["message"];
            this.propertyName = data["propertyName"];
            this.count = data["count"];
        }
    }

    static fromJS(data: any): MessageError {
        data = typeof data === 'object' ? data : {};
        let result = new MessageError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["propertyName"] = this.propertyName;
        data["count"] = this.count;
        return data;
    }
}

export interface IMessageError {
    message: string | undefined;
    propertyName: string | undefined;
    count: number | undefined;
}

export class GetAllTerminalMastersForExcelInput implements IGetAllTerminalMastersForExcelInput {
    filter!: string | undefined;
    userNameFilter!: string | undefined;
    passwordFilter!: string | undefined;
    statusFilter!: string | undefined;
    referenceCodeFilter!: string | undefined;
    terminalCodeFilter!: string | undefined;
    terminalNameFilter!: string | undefined;
    terminalNameUnsignFilter!: string | undefined;
    fullSalesRegionFilter!: string | undefined;
    productHierarchyLV1Filter!: string | undefined;
    productHierarchyLV2Filter!: string | undefined;
    productHierarchyLV3Filter!: string | undefined;
    productHierarchyLV4Filter!: string | undefined;
    productHierarchyLV5Filter!: string | undefined;
    idFilter!: number | undefined;

    constructor(data?: IGetAllTerminalMastersForExcelInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.filter = data["filter"];
            this.userNameFilter = data["userNameFilter"];
            this.passwordFilter = data["passwordFilter"];
            this.statusFilter = data["statusFilter"];
            this.referenceCodeFilter = data["referenceCodeFilter"];
            this.terminalCodeFilter = data["terminalCodeFilter"];
            this.terminalNameFilter = data["terminalNameFilter"];
            this.terminalNameUnsignFilter = data["terminalNameUnsignFilter"];
            this.fullSalesRegionFilter = data["fullSalesRegionFilter"];
            this.productHierarchyLV1Filter = data["productHierarchyLV1Filter"];
            this.productHierarchyLV2Filter = data["productHierarchyLV2Filter"];
            this.productHierarchyLV3Filter = data["productHierarchyLV3Filter"];
            this.productHierarchyLV4Filter = data["productHierarchyLV4Filter"];
            this.productHierarchyLV5Filter = data["productHierarchyLV5Filter"];
            this.idFilter = data["idFilter"];
        }
    }

    static fromJS(data: any): GetAllTerminalMastersForExcelInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllTerminalMastersForExcelInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        data["userNameFilter"] = this.userNameFilter;
        data["passwordFilter"] = this.passwordFilter;
        data["statusFilter"] = this.statusFilter;
        data["referenceCodeFilter"] = this.referenceCodeFilter;
        data["terminalCodeFilter"] = this.terminalCodeFilter;
        data["terminalNameFilter"] = this.terminalNameFilter;
        data["terminalNameUnsignFilter"] = this.terminalNameUnsignFilter;
        data["fullSalesRegionFilter"] = this.fullSalesRegionFilter;
        data["productHierarchyLV1Filter"] = this.productHierarchyLV1Filter;
        data["productHierarchyLV2Filter"] = this.productHierarchyLV2Filter;
        data["productHierarchyLV3Filter"] = this.productHierarchyLV3Filter;
        data["productHierarchyLV4Filter"] = this.productHierarchyLV4Filter;
        data["productHierarchyLV5Filter"] = this.productHierarchyLV5Filter;
        data["idFilter"] = this.idFilter;
        return data;
    }
}

export interface IGetAllTerminalMastersForExcelInput {
    filter: string | undefined;
    userNameFilter: string | undefined;
    passwordFilter: string | undefined;
    statusFilter: string | undefined;
    referenceCodeFilter: string | undefined;
    terminalCodeFilter: string | undefined;
    terminalNameFilter: string | undefined;
    terminalNameUnsignFilter: string | undefined;
    fullSalesRegionFilter: string | undefined;
    productHierarchyLV1Filter: string | undefined;
    productHierarchyLV2Filter: string | undefined;
    productHierarchyLV3Filter: string | undefined;
    productHierarchyLV4Filter: string | undefined;
    productHierarchyLV5Filter: string | undefined;
    idFilter: number | undefined;
}

export class GetValueComboboxTerminalMaster implements IGetValueComboboxTerminalMaster {
    hierarchyL1!: Hierarchy[] | undefined;
    hierarchyL2!: Hierarchy[] | undefined;
    hierarchyL3!: Hierarchy[] | undefined;
    hierarchyL4!: Hierarchy[] | undefined;
    hierarchyL5!: Hierarchy[] | undefined;

    constructor(data?: IGetValueComboboxTerminalMaster) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["hierarchyL1"] && data["hierarchyL1"].constructor === Array) {
                this.hierarchyL1 = [];
                for (let item of data["hierarchyL1"])
                    this.hierarchyL1.push(Hierarchy.fromJS(item));
            }
            if (data["hierarchyL2"] && data["hierarchyL2"].constructor === Array) {
                this.hierarchyL2 = [];
                for (let item of data["hierarchyL2"])
                    this.hierarchyL2.push(Hierarchy.fromJS(item));
            }
            if (data["hierarchyL3"] && data["hierarchyL3"].constructor === Array) {
                this.hierarchyL3 = [];
                for (let item of data["hierarchyL3"])
                    this.hierarchyL3.push(Hierarchy.fromJS(item));
            }
            if (data["hierarchyL4"] && data["hierarchyL4"].constructor === Array) {
                this.hierarchyL4 = [];
                for (let item of data["hierarchyL4"])
                    this.hierarchyL4.push(Hierarchy.fromJS(item));
            }
            if (data["hierarchyL5"] && data["hierarchyL5"].constructor === Array) {
                this.hierarchyL5 = [];
                for (let item of data["hierarchyL5"])
                    this.hierarchyL5.push(Hierarchy.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetValueComboboxTerminalMaster {
        data = typeof data === 'object' ? data : {};
        let result = new GetValueComboboxTerminalMaster();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.hierarchyL1 && this.hierarchyL1.constructor === Array) {
            data["hierarchyL1"] = [];
            for (let item of this.hierarchyL1)
                data["hierarchyL1"].push(item.toJSON());
        }
        if (this.hierarchyL2 && this.hierarchyL2.constructor === Array) {
            data["hierarchyL2"] = [];
            for (let item of this.hierarchyL2)
                data["hierarchyL2"].push(item.toJSON());
        }
        if (this.hierarchyL3 && this.hierarchyL3.constructor === Array) {
            data["hierarchyL3"] = [];
            for (let item of this.hierarchyL3)
                data["hierarchyL3"].push(item.toJSON());
        }
        if (this.hierarchyL4 && this.hierarchyL4.constructor === Array) {
            data["hierarchyL4"] = [];
            for (let item of this.hierarchyL4)
                data["hierarchyL4"].push(item.toJSON());
        }
        if (this.hierarchyL5 && this.hierarchyL5.constructor === Array) {
            data["hierarchyL5"] = [];
            for (let item of this.hierarchyL5)
                data["hierarchyL5"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetValueComboboxTerminalMaster {
    hierarchyL1: Hierarchy[] | undefined;
    hierarchyL2: Hierarchy[] | undefined;
    hierarchyL3: Hierarchy[] | undefined;
    hierarchyL4: Hierarchy[] | undefined;
    hierarchyL5: Hierarchy[] | undefined;
}

export class Hierarchy implements IHierarchy {
    id!: number | undefined;
    parentCode!: string | undefined;
    detailCode!: string | undefined;
    level!: number | undefined;
    detailValue!: string | undefined;

    constructor(data?: IHierarchy) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.parentCode = data["parentCode"];
            this.detailCode = data["detailCode"];
            this.level = data["level"];
            this.detailValue = data["detailValue"];
        }
    }

    static fromJS(data: any): Hierarchy {
        data = typeof data === 'object' ? data : {};
        let result = new Hierarchy();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["parentCode"] = this.parentCode;
        data["detailCode"] = this.detailCode;
        data["level"] = this.level;
        data["detailValue"] = this.detailValue;
        return data;
    }
}

export interface IHierarchy {
    id: number | undefined;
    parentCode: string | undefined;
    detailCode: string | undefined;
    level: number | undefined;
    detailValue: string | undefined;
}

export class MasterDetailForSelectDto implements IMasterDetailForSelectDto {
    masterCode!: string | undefined;
    detailCode!: string | undefined;
    parentCode!: string | undefined;
    nodePath!: string | undefined;
    ordinal!: number | undefined;
    status!: string | undefined;
    detailValueNumber!: number | undefined;
    level!: number | undefined;
    detailValue!: string | undefined;
    detailValueUnSign!: string | undefined;
    creationTime!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;
    id!: number | undefined;

    constructor(data?: IMasterDetailForSelectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.masterCode = data["masterCode"];
            this.detailCode = data["detailCode"];
            this.parentCode = data["parentCode"];
            this.nodePath = data["nodePath"];
            this.ordinal = data["ordinal"];
            this.status = data["status"];
            this.detailValueNumber = data["detailValueNumber"];
            this.level = data["level"];
            this.detailValue = data["detailValue"];
            this.detailValueUnSign = data["detailValueUnSign"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): MasterDetailForSelectDto {
        data = typeof data === 'object' ? data : {};
        let result = new MasterDetailForSelectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["masterCode"] = this.masterCode;
        data["detailCode"] = this.detailCode;
        data["parentCode"] = this.parentCode;
        data["nodePath"] = this.nodePath;
        data["ordinal"] = this.ordinal;
        data["status"] = this.status;
        data["detailValueNumber"] = this.detailValueNumber;
        data["level"] = this.level;
        data["detailValue"] = this.detailValue;
        data["detailValueUnSign"] = this.detailValueUnSign;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IMasterDetailForSelectDto {
    masterCode: string | undefined;
    detailCode: string | undefined;
    parentCode: string | undefined;
    nodePath: string | undefined;
    ordinal: number | undefined;
    status: string | undefined;
    detailValueNumber: number | undefined;
    level: number | undefined;
    detailValue: string | undefined;
    detailValueUnSign: string | undefined;
    creationTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    id: number | undefined;
}

export class TerminalMasterImportAgrs implements ITerminalMasterImportAgrs {
    masterDetailIntegration!: MasterDetailIntegrationDto[] | undefined;
    tableName!: string | undefined;
    filePath!: string | undefined;
    fileName!: string | undefined;
    userId!: number | undefined;
    tenantId!: number | undefined;
    currentLanguage!: string | undefined;
    apiUrl!: string | undefined;

    constructor(data?: ITerminalMasterImportAgrs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["masterDetailIntegration"] && data["masterDetailIntegration"].constructor === Array) {
                this.masterDetailIntegration = [];
                for (let item of data["masterDetailIntegration"])
                    this.masterDetailIntegration.push(MasterDetailIntegrationDto.fromJS(item));
            }
            this.tableName = data["tableName"];
            this.filePath = data["filePath"];
            this.fileName = data["fileName"];
            this.userId = data["userId"];
            this.tenantId = data["tenantId"];
            this.currentLanguage = data["currentLanguage"];
            this.apiUrl = data["apiUrl"];
        }
    }

    static fromJS(data: any): TerminalMasterImportAgrs {
        data = typeof data === 'object' ? data : {};
        let result = new TerminalMasterImportAgrs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.masterDetailIntegration && this.masterDetailIntegration.constructor === Array) {
            data["masterDetailIntegration"] = [];
            for (let item of this.masterDetailIntegration)
                data["masterDetailIntegration"].push(item.toJSON());
        }
        data["tableName"] = this.tableName;
        data["filePath"] = this.filePath;
        data["fileName"] = this.fileName;
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["currentLanguage"] = this.currentLanguage;
        data["apiUrl"] = this.apiUrl;
        return data;
    }
}

export interface ITerminalMasterImportAgrs {
    masterDetailIntegration: MasterDetailIntegrationDto[] | undefined;
    tableName: string | undefined;
    filePath: string | undefined;
    fileName: string | undefined;
    userId: number | undefined;
    tenantId: number | undefined;
    currentLanguage: string | undefined;
    apiUrl: string | undefined;
}

export class MasterDetailIntegrationDto implements IMasterDetailIntegrationDto {
    tenantId!: number | undefined;
    masterCode!: string | undefined;
    detailCode!: string | undefined;
    parentCode!: string | undefined;
    nodePath!: string | undefined;
    ordinal!: number | undefined;
    status!: string | undefined;
    detailValueNumber!: number | undefined;
    level!: number | undefined;
    detailValue!: string | undefined;
    detailValueUnSign!: string | undefined;
    creationTime!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;
    isDeleted!: boolean | undefined;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    creatorUserId!: number | undefined;
    id!: number | undefined;

    constructor(data?: IMasterDetailIntegrationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.masterCode = data["masterCode"];
            this.detailCode = data["detailCode"];
            this.parentCode = data["parentCode"];
            this.nodePath = data["nodePath"];
            this.ordinal = data["ordinal"];
            this.status = data["status"];
            this.detailValueNumber = data["detailValueNumber"];
            this.level = data["level"];
            this.detailValue = data["detailValue"];
            this.detailValueUnSign = data["detailValueUnSign"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): MasterDetailIntegrationDto {
        data = typeof data === 'object' ? data : {};
        let result = new MasterDetailIntegrationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["masterCode"] = this.masterCode;
        data["detailCode"] = this.detailCode;
        data["parentCode"] = this.parentCode;
        data["nodePath"] = this.nodePath;
        data["ordinal"] = this.ordinal;
        data["status"] = this.status;
        data["detailValueNumber"] = this.detailValueNumber;
        data["level"] = this.level;
        data["detailValue"] = this.detailValue;
        data["detailValueUnSign"] = this.detailValueUnSign;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IMasterDetailIntegrationDto {
    tenantId: number | undefined;
    masterCode: string | undefined;
    detailCode: string | undefined;
    parentCode: string | undefined;
    nodePath: string | undefined;
    ordinal: number | undefined;
    status: string | undefined;
    detailValueNumber: number | undefined;
    level: number | undefined;
    detailValue: string | undefined;
    detailValueUnSign: string | undefined;
    creationTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    isDeleted: boolean | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class GetTerminalMasterForEditOutput implements IGetTerminalMasterForEditOutput {
    terminalMaster!: CreateOrEditTerminalMasterDto | undefined;

    constructor(data?: IGetTerminalMasterForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.terminalMaster = data["terminalMaster"] ? CreateOrEditTerminalMasterDto.fromJS(data["terminalMaster"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetTerminalMasterForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetTerminalMasterForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["terminalMaster"] = this.terminalMaster ? this.terminalMaster.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetTerminalMasterForEditOutput {
    terminalMaster: CreateOrEditTerminalMasterDto | undefined;
}

export class ListResultDtoOfNameValueDto implements IListResultDtoOfNameValueDto {
    items!: NameValueDto[] | undefined;

    constructor(data?: IListResultDtoOfNameValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(NameValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfNameValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfNameValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListResultDtoOfNameValueDto {
    items: NameValueDto[] | undefined;
}

export class AuthenticateModel implements IAuthenticateModel {
    userNameOrEmailAddress!: string;
    password!: string;
    twoFactorVerificationCode!: string | undefined;
    rememberClient!: boolean | undefined;
    twoFactorRememberClientToken!: string | undefined;
    singleSignIn!: boolean | undefined;
    returnUrl!: string | undefined;

    constructor(data?: IAuthenticateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userNameOrEmailAddress = data["userNameOrEmailAddress"];
            this.password = data["password"];
            this.twoFactorVerificationCode = data["twoFactorVerificationCode"];
            this.rememberClient = data["rememberClient"];
            this.twoFactorRememberClientToken = data["twoFactorRememberClientToken"];
            this.singleSignIn = data["singleSignIn"];
            this.returnUrl = data["returnUrl"];
        }
    }

    static fromJS(data: any): AuthenticateModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userNameOrEmailAddress"] = this.userNameOrEmailAddress;
        data["password"] = this.password;
        data["twoFactorVerificationCode"] = this.twoFactorVerificationCode;
        data["rememberClient"] = this.rememberClient;
        data["twoFactorRememberClientToken"] = this.twoFactorRememberClientToken;
        data["singleSignIn"] = this.singleSignIn;
        data["returnUrl"] = this.returnUrl;
        return data;
    }
}

export interface IAuthenticateModel {
    userNameOrEmailAddress: string;
    password: string;
    twoFactorVerificationCode: string | undefined;
    rememberClient: boolean | undefined;
    twoFactorRememberClientToken: string | undefined;
    singleSignIn: boolean | undefined;
    returnUrl: string | undefined;
}

export class AuthenticateResultModel implements IAuthenticateResultModel {
    accessToken!: string | undefined;
    encryptedAccessToken!: string | undefined;
    expireInSeconds!: number | undefined;
    shouldResetPassword!: boolean | undefined;
    passwordResetCode!: string | undefined;
    userId!: number | undefined;
    userName!: string | undefined;
    requiresTwoFactorVerification!: boolean | undefined;
    twoFactorAuthProviders!: string[] | undefined;
    twoFactorRememberClientToken!: string | undefined;
    returnUrl!: string | undefined;

    constructor(data?: IAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.accessToken = data["accessToken"];
            this.encryptedAccessToken = data["encryptedAccessToken"];
            this.expireInSeconds = data["expireInSeconds"];
            this.shouldResetPassword = data["shouldResetPassword"];
            this.passwordResetCode = data["passwordResetCode"];
            this.userId = data["userId"];
            this.userName = data["userName"];
            this.requiresTwoFactorVerification = data["requiresTwoFactorVerification"];
            if (data["twoFactorAuthProviders"] && data["twoFactorAuthProviders"].constructor === Array) {
                this.twoFactorAuthProviders = [];
                for (let item of data["twoFactorAuthProviders"])
                    this.twoFactorAuthProviders.push(item);
            }
            this.twoFactorRememberClientToken = data["twoFactorRememberClientToken"];
            this.returnUrl = data["returnUrl"];
        }
    }

    static fromJS(data: any): AuthenticateResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        data["shouldResetPassword"] = this.shouldResetPassword;
        data["passwordResetCode"] = this.passwordResetCode;
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["requiresTwoFactorVerification"] = this.requiresTwoFactorVerification;
        if (this.twoFactorAuthProviders && this.twoFactorAuthProviders.constructor === Array) {
            data["twoFactorAuthProviders"] = [];
            for (let item of this.twoFactorAuthProviders)
                data["twoFactorAuthProviders"].push(item);
        }
        data["twoFactorRememberClientToken"] = this.twoFactorRememberClientToken;
        data["returnUrl"] = this.returnUrl;
        return data;
    }
}

export interface IAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number | undefined;
    shouldResetPassword: boolean | undefined;
    passwordResetCode: string | undefined;
    userId: number | undefined;
    userName: string | undefined;
    requiresTwoFactorVerification: boolean | undefined;
    twoFactorAuthProviders: string[] | undefined;
    twoFactorRememberClientToken: string | undefined;
    returnUrl: string | undefined;
}

export class AuthenticateExtModel implements IAuthenticateExtModel {
    userNameOrEmailAddress!: string;
    password!: string;
    loginVia!: string;
    mobileAppSecretKey!: string;
    appType!: string | undefined;
    emailAddress!: string | undefined;
    deviceId!: string | undefined;
    phoneNumer!: string | undefined;
    twoFactorVerificationCode!: string | undefined;
    rememberClient!: boolean | undefined;
    twoFactorRememberClientToken!: string | undefined;
    singleSignIn!: boolean | undefined;
    returnUrl!: string | undefined;

    constructor(data?: IAuthenticateExtModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userNameOrEmailAddress = data["userNameOrEmailAddress"];
            this.password = data["password"];
            this.loginVia = data["loginVia"];
            this.mobileAppSecretKey = data["mobileAppSecretKey"];
            this.appType = data["appType"];
            this.emailAddress = data["emailAddress"];
            this.deviceId = data["deviceId"];
            this.phoneNumer = data["phoneNumer"];
            this.twoFactorVerificationCode = data["twoFactorVerificationCode"];
            this.rememberClient = data["rememberClient"];
            this.twoFactorRememberClientToken = data["twoFactorRememberClientToken"];
            this.singleSignIn = data["singleSignIn"];
            this.returnUrl = data["returnUrl"];
        }
    }

    static fromJS(data: any): AuthenticateExtModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateExtModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userNameOrEmailAddress"] = this.userNameOrEmailAddress;
        data["password"] = this.password;
        data["loginVia"] = this.loginVia;
        data["mobileAppSecretKey"] = this.mobileAppSecretKey;
        data["appType"] = this.appType;
        data["emailAddress"] = this.emailAddress;
        data["deviceId"] = this.deviceId;
        data["phoneNumer"] = this.phoneNumer;
        data["twoFactorVerificationCode"] = this.twoFactorVerificationCode;
        data["rememberClient"] = this.rememberClient;
        data["twoFactorRememberClientToken"] = this.twoFactorRememberClientToken;
        data["singleSignIn"] = this.singleSignIn;
        data["returnUrl"] = this.returnUrl;
        return data;
    }
}

export interface IAuthenticateExtModel {
    userNameOrEmailAddress: string;
    password: string;
    loginVia: string;
    mobileAppSecretKey: string;
    appType: string | undefined;
    emailAddress: string | undefined;
    deviceId: string | undefined;
    phoneNumer: string | undefined;
    twoFactorVerificationCode: string | undefined;
    rememberClient: boolean | undefined;
    twoFactorRememberClientToken: string | undefined;
    singleSignIn: boolean | undefined;
    returnUrl: string | undefined;
}

export class EmergencyAccountLockModel implements IEmergencyAccountLockModel {
    userName!: string | undefined;
    lockType!: string | undefined;
    serectKey!: string | undefined;

    constructor(data?: IEmergencyAccountLockModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userName = data["userName"];
            this.lockType = data["lockType"];
            this.serectKey = data["serectKey"];
        }
    }

    static fromJS(data: any): EmergencyAccountLockModel {
        data = typeof data === 'object' ? data : {};
        let result = new EmergencyAccountLockModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["lockType"] = this.lockType;
        data["serectKey"] = this.serectKey;
        return data;
    }
}

export interface IEmergencyAccountLockModel {
    userName: string | undefined;
    lockType: string | undefined;
    serectKey: string | undefined;
}

export class SendTwoFactorAuthCodeModel implements ISendTwoFactorAuthCodeModel {
    userId!: number | undefined;
    provider!: string;

    constructor(data?: ISendTwoFactorAuthCodeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userId = data["userId"];
            this.provider = data["provider"];
        }
    }

    static fromJS(data: any): SendTwoFactorAuthCodeModel {
        data = typeof data === 'object' ? data : {};
        let result = new SendTwoFactorAuthCodeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["provider"] = this.provider;
        return data;
    }
}

export interface ISendTwoFactorAuthCodeModel {
    userId: number | undefined;
    provider: string;
}

export class ImpersonatedAuthenticateResultModel implements IImpersonatedAuthenticateResultModel {
    accessToken!: string | undefined;
    encryptedAccessToken!: string | undefined;
    expireInSeconds!: number | undefined;

    constructor(data?: IImpersonatedAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.accessToken = data["accessToken"];
            this.encryptedAccessToken = data["encryptedAccessToken"];
            this.expireInSeconds = data["expireInSeconds"];
        }
    }

    static fromJS(data: any): ImpersonatedAuthenticateResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new ImpersonatedAuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        return data;
    }
}

export interface IImpersonatedAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number | undefined;
}

export class SwitchedAccountAuthenticateResultModel implements ISwitchedAccountAuthenticateResultModel {
    accessToken!: string | undefined;
    encryptedAccessToken!: string | undefined;
    expireInSeconds!: number | undefined;

    constructor(data?: ISwitchedAccountAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.accessToken = data["accessToken"];
            this.encryptedAccessToken = data["encryptedAccessToken"];
            this.expireInSeconds = data["expireInSeconds"];
        }
    }

    static fromJS(data: any): SwitchedAccountAuthenticateResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new SwitchedAccountAuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        return data;
    }
}

export interface ISwitchedAccountAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number | undefined;
}

export class ExternalLoginProviderInfoModel implements IExternalLoginProviderInfoModel {
    name!: string | undefined;
    clientId!: string | undefined;
    additionalParams!: { [key: string]: string; } | undefined;

    constructor(data?: IExternalLoginProviderInfoModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.clientId = data["clientId"];
            if (data["additionalParams"]) {
                this.additionalParams = {};
                for (let key in data["additionalParams"]) {
                    if (data["additionalParams"].hasOwnProperty(key))
                        this.additionalParams[key] = data["additionalParams"][key];
                }
            }
        }
    }

    static fromJS(data: any): ExternalLoginProviderInfoModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalLoginProviderInfoModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["clientId"] = this.clientId;
        if (this.additionalParams) {
            data["additionalParams"] = {};
            for (let key in this.additionalParams) {
                if (this.additionalParams.hasOwnProperty(key))
                    data["additionalParams"][key] = this.additionalParams[key];
            }
        }
        return data;
    }
}

export interface IExternalLoginProviderInfoModel {
    name: string | undefined;
    clientId: string | undefined;
    additionalParams: { [key: string]: string; } | undefined;
}

export class ExternalAuthenticateModel implements IExternalAuthenticateModel {
    authProvider!: string;
    providerKey!: string;
    providerAccessCode!: string;
    returnUrl!: string | undefined;
    singleSignIn!: boolean | undefined;

    constructor(data?: IExternalAuthenticateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.authProvider = data["authProvider"];
            this.providerKey = data["providerKey"];
            this.providerAccessCode = data["providerAccessCode"];
            this.returnUrl = data["returnUrl"];
            this.singleSignIn = data["singleSignIn"];
        }
    }

    static fromJS(data: any): ExternalAuthenticateModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalAuthenticateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authProvider"] = this.authProvider;
        data["providerKey"] = this.providerKey;
        data["providerAccessCode"] = this.providerAccessCode;
        data["returnUrl"] = this.returnUrl;
        data["singleSignIn"] = this.singleSignIn;
        return data;
    }
}

export interface IExternalAuthenticateModel {
    authProvider: string;
    providerKey: string;
    providerAccessCode: string;
    returnUrl: string | undefined;
    singleSignIn: boolean | undefined;
}

export class ExternalAuthenticateResultModel implements IExternalAuthenticateResultModel {
    accessToken!: string | undefined;
    encryptedAccessToken!: string | undefined;
    expireInSeconds!: number | undefined;
    waitingForActivation!: boolean | undefined;
    returnUrl!: string | undefined;

    constructor(data?: IExternalAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.accessToken = data["accessToken"];
            this.encryptedAccessToken = data["encryptedAccessToken"];
            this.expireInSeconds = data["expireInSeconds"];
            this.waitingForActivation = data["waitingForActivation"];
            this.returnUrl = data["returnUrl"];
        }
    }

    static fromJS(data: any): ExternalAuthenticateResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalAuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        data["waitingForActivation"] = this.waitingForActivation;
        data["returnUrl"] = this.returnUrl;
        return data;
    }
}

export interface IExternalAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number | undefined;
    waitingForActivation: boolean | undefined;
    returnUrl: string | undefined;
}

export class AuthenticateResponeDTO implements IAuthenticateResponeDTO {
    isSuccess!: boolean | undefined;
    data!: AuthenticateResultModel | undefined;
    error!: AuthenticateError | undefined;

    constructor(data?: IAuthenticateResponeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isSuccess = data["isSuccess"];
            this.data = data["data"] ? AuthenticateResultModel.fromJS(data["data"]) : <any>undefined;
            this.error = data["error"] ? AuthenticateError.fromJS(data["error"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AuthenticateResponeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateResponeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAuthenticateResponeDTO {
    isSuccess: boolean | undefined;
    data: AuthenticateResultModel | undefined;
    error: AuthenticateError | undefined;
}

export class AuthenticateError implements IAuthenticateError {
    code!: number | undefined;
    message!: string | undefined;
    details!: string | undefined;

    constructor(data?: IAuthenticateError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.message = data["message"];
            this.details = data["details"];
        }
    }

    static fromJS(data: any): AuthenticateError {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["message"] = this.message;
        data["details"] = this.details;
        return data;
    }
}

export interface IAuthenticateError {
    code: number | undefined;
    message: string | undefined;
    details: string | undefined;
}

export class TransferDtoInput implements ITransferDtoInput {
    fromMemberCode!: string | undefined;
    toMemberCode!: string | undefined;
    date!: moment.Moment | undefined;
    value!: number | undefined;

    constructor(data?: ITransferDtoInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.fromMemberCode = data["fromMemberCode"];
            this.toMemberCode = data["toMemberCode"];
            this.date = data["date"] ? moment(data["date"].toString()) : <any>undefined;
            this.value = data["value"];
        }
    }

    static fromJS(data: any): TransferDtoInput {
        data = typeof data === 'object' ? data : {};
        let result = new TransferDtoInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fromMemberCode"] = this.fromMemberCode;
        data["toMemberCode"] = this.toMemberCode;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["value"] = this.value;
        return data;
    }
}

export interface ITransferDtoInput {
    fromMemberCode: string | undefined;
    toMemberCode: string | undefined;
    date: moment.Moment | undefined;
    value: number | undefined;
}

export class PagedResultDtoOfGetTransactionCoinBaseLineForView implements IPagedResultDtoOfGetTransactionCoinBaseLineForView {
    totalCount!: number | undefined;
    items!: GetTransactionCoinBaseLineForView[] | undefined;

    constructor(data?: IPagedResultDtoOfGetTransactionCoinBaseLineForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetTransactionCoinBaseLineForView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetTransactionCoinBaseLineForView {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetTransactionCoinBaseLineForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetTransactionCoinBaseLineForView {
    totalCount: number | undefined;
    items: GetTransactionCoinBaseLineForView[] | undefined;
}

export class GetTransactionCoinBaseLineForView implements IGetTransactionCoinBaseLineForView {
    transactionCoinBaseLine!: TransactionCoinBaseLineDto | undefined;

    constructor(data?: IGetTransactionCoinBaseLineForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.transactionCoinBaseLine = data["transactionCoinBaseLine"] ? TransactionCoinBaseLineDto.fromJS(data["transactionCoinBaseLine"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetTransactionCoinBaseLineForView {
        data = typeof data === 'object' ? data : {};
        let result = new GetTransactionCoinBaseLineForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionCoinBaseLine"] = this.transactionCoinBaseLine ? this.transactionCoinBaseLine.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetTransactionCoinBaseLineForView {
    transactionCoinBaseLine: TransactionCoinBaseLineDto | undefined;
}

export class TransactionCoinBaseLineDto implements ITransactionCoinBaseLineDto {
    id!: number | undefined;

    constructor(data?: ITransactionCoinBaseLineDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
        }
    }

    static fromJS(data: any): TransactionCoinBaseLineDto {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionCoinBaseLineDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface ITransactionCoinBaseLineDto {
    id: number | undefined;
}

export class GetTransactionCoinBaseLineForEditOutput implements IGetTransactionCoinBaseLineForEditOutput {
    transactionCoinBaseLine!: CreateOrEditTransactionCoinBaseLineDto | undefined;

    constructor(data?: IGetTransactionCoinBaseLineForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.transactionCoinBaseLine = data["transactionCoinBaseLine"] ? CreateOrEditTransactionCoinBaseLineDto.fromJS(data["transactionCoinBaseLine"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetTransactionCoinBaseLineForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetTransactionCoinBaseLineForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionCoinBaseLine"] = this.transactionCoinBaseLine ? this.transactionCoinBaseLine.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetTransactionCoinBaseLineForEditOutput {
    transactionCoinBaseLine: CreateOrEditTransactionCoinBaseLineDto | undefined;
}

export class CreateOrEditTransactionCoinBaseLineDto implements ICreateOrEditTransactionCoinBaseLineDto {
    memberCode!: string;
    month!: number | undefined;
    coin!: number | undefined;
    isDeleted!: boolean | undefined;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: moment.Moment | undefined;
    creatorUserId!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditTransactionCoinBaseLineDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberCode = data["memberCode"];
            this.month = data["month"];
            this.coin = data["coin"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditTransactionCoinBaseLineDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditTransactionCoinBaseLineDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberCode"] = this.memberCode;
        data["month"] = this.month;
        data["coin"] = this.coin;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditTransactionCoinBaseLineDto {
    memberCode: string;
    month: number | undefined;
    coin: number | undefined;
    isDeleted: boolean | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfGetTransactionDetailForView implements IPagedResultDtoOfGetTransactionDetailForView {
    totalCount!: number | undefined;
    items!: GetTransactionDetailForView[] | undefined;

    constructor(data?: IPagedResultDtoOfGetTransactionDetailForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetTransactionDetailForView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetTransactionDetailForView {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetTransactionDetailForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetTransactionDetailForView {
    totalCount: number | undefined;
    items: GetTransactionDetailForView[] | undefined;
}

export class GetTransactionDetailForView implements IGetTransactionDetailForView {
    transactionDetail!: TransactionDetailDto | undefined;

    constructor(data?: IGetTransactionDetailForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.transactionDetail = data["transactionDetail"] ? TransactionDetailDto.fromJS(data["transactionDetail"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetTransactionDetailForView {
        data = typeof data === 'object' ? data : {};
        let result = new GetTransactionDetailForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionDetail"] = this.transactionDetail ? this.transactionDetail.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetTransactionDetailForView {
    transactionDetail: TransactionDetailDto | undefined;
}

export class TransactionDetailDto implements ITransactionDetailDto {
    tenantId!: number | undefined;
    transactionCode!: string | undefined;
    productCode!: string | undefined;
    productCategorySettingCode!: string | undefined;
    productSettingCode!: string | undefined;
    coin!: number | undefined;
    point!: number | undefined;
    detailLineInfo!: string | undefined;
    fullDeptCode!: string | undefined;
    fullClassCode!: string | undefined;
    quantity!: number | undefined;
    unitPrice!: number | undefined;
    amountBeforeTax!: number | undefined;
    amountIncludeTax!: number | undefined;
    calcAmount!: number | undefined;
    taxAmount!: number | undefined;
    productCategorySettingPointRatio!: number | undefined;
    productCategorySettingCoinRatio!: number | undefined;
    productSettingPoint!: number | undefined;
    productSettingCoin!: number | undefined;
    source!: string | undefined;
    id!: number | undefined;

    constructor(data?: ITransactionDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.transactionCode = data["transactionCode"];
            this.productCode = data["productCode"];
            this.productCategorySettingCode = data["productCategorySettingCode"];
            this.productSettingCode = data["productSettingCode"];
            this.coin = data["coin"];
            this.point = data["point"];
            this.detailLineInfo = data["detailLineInfo"];
            this.fullDeptCode = data["fullDeptCode"];
            this.fullClassCode = data["fullClassCode"];
            this.quantity = data["quantity"];
            this.unitPrice = data["unitPrice"];
            this.amountBeforeTax = data["amountBeforeTax"];
            this.amountIncludeTax = data["amountIncludeTax"];
            this.calcAmount = data["calcAmount"];
            this.taxAmount = data["taxAmount"];
            this.productCategorySettingPointRatio = data["productCategorySettingPointRatio"];
            this.productCategorySettingCoinRatio = data["productCategorySettingCoinRatio"];
            this.productSettingPoint = data["productSettingPoint"];
            this.productSettingCoin = data["productSettingCoin"];
            this.source = data["source"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): TransactionDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["transactionCode"] = this.transactionCode;
        data["productCode"] = this.productCode;
        data["productCategorySettingCode"] = this.productCategorySettingCode;
        data["productSettingCode"] = this.productSettingCode;
        data["coin"] = this.coin;
        data["point"] = this.point;
        data["detailLineInfo"] = this.detailLineInfo;
        data["fullDeptCode"] = this.fullDeptCode;
        data["fullClassCode"] = this.fullClassCode;
        data["quantity"] = this.quantity;
        data["unitPrice"] = this.unitPrice;
        data["amountBeforeTax"] = this.amountBeforeTax;
        data["amountIncludeTax"] = this.amountIncludeTax;
        data["calcAmount"] = this.calcAmount;
        data["taxAmount"] = this.taxAmount;
        data["productCategorySettingPointRatio"] = this.productCategorySettingPointRatio;
        data["productCategorySettingCoinRatio"] = this.productCategorySettingCoinRatio;
        data["productSettingPoint"] = this.productSettingPoint;
        data["productSettingCoin"] = this.productSettingCoin;
        data["source"] = this.source;
        data["id"] = this.id;
        return data;
    }
}

export interface ITransactionDetailDto {
    tenantId: number | undefined;
    transactionCode: string | undefined;
    productCode: string | undefined;
    productCategorySettingCode: string | undefined;
    productSettingCode: string | undefined;
    coin: number | undefined;
    point: number | undefined;
    detailLineInfo: string | undefined;
    fullDeptCode: string | undefined;
    fullClassCode: string | undefined;
    quantity: number | undefined;
    unitPrice: number | undefined;
    amountBeforeTax: number | undefined;
    amountIncludeTax: number | undefined;
    calcAmount: number | undefined;
    taxAmount: number | undefined;
    productCategorySettingPointRatio: number | undefined;
    productCategorySettingCoinRatio: number | undefined;
    productSettingPoint: number | undefined;
    productSettingCoin: number | undefined;
    source: string | undefined;
    id: number | undefined;
}

export class GetTransactionDetailForEditOutput implements IGetTransactionDetailForEditOutput {
    transactionDetail!: CreateOrEditTransactionDetailDto | undefined;

    constructor(data?: IGetTransactionDetailForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.transactionDetail = data["transactionDetail"] ? CreateOrEditTransactionDetailDto.fromJS(data["transactionDetail"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetTransactionDetailForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetTransactionDetailForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionDetail"] = this.transactionDetail ? this.transactionDetail.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetTransactionDetailForEditOutput {
    transactionDetail: CreateOrEditTransactionDetailDto | undefined;
}

export class CreateOrEditTransactionDetailDto implements ICreateOrEditTransactionDetailDto {
    transactionCode!: string;
    productCode!: string;
    productCategorySettingCode!: string | undefined;
    productSettingCode!: string | undefined;
    coin!: number | undefined;
    point!: number | undefined;
    detailLineInfo!: string | undefined;
    fullDeptCode!: string | undefined;
    fullClassCode!: string | undefined;
    quantity!: number | undefined;
    unitPrice!: number | undefined;
    amountBeforeTax!: number | undefined;
    amountIncludeTax!: number | undefined;
    calcAmount!: number | undefined;
    taxAmount!: number | undefined;
    productCategorySettingPointRatio!: number | undefined;
    productCategorySettingCoinRatio!: number | undefined;
    productSettingPoint!: number | undefined;
    productSettingCoin!: number | undefined;
    isDeleted!: boolean | undefined;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: moment.Moment | undefined;
    creatorUserId!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditTransactionDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.transactionCode = data["transactionCode"];
            this.productCode = data["productCode"];
            this.productCategorySettingCode = data["productCategorySettingCode"];
            this.productSettingCode = data["productSettingCode"];
            this.coin = data["coin"];
            this.point = data["point"];
            this.detailLineInfo = data["detailLineInfo"];
            this.fullDeptCode = data["fullDeptCode"];
            this.fullClassCode = data["fullClassCode"];
            this.quantity = data["quantity"];
            this.unitPrice = data["unitPrice"];
            this.amountBeforeTax = data["amountBeforeTax"];
            this.amountIncludeTax = data["amountIncludeTax"];
            this.calcAmount = data["calcAmount"];
            this.taxAmount = data["taxAmount"];
            this.productCategorySettingPointRatio = data["productCategorySettingPointRatio"];
            this.productCategorySettingCoinRatio = data["productCategorySettingCoinRatio"];
            this.productSettingPoint = data["productSettingPoint"];
            this.productSettingCoin = data["productSettingCoin"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditTransactionDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditTransactionDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionCode"] = this.transactionCode;
        data["productCode"] = this.productCode;
        data["productCategorySettingCode"] = this.productCategorySettingCode;
        data["productSettingCode"] = this.productSettingCode;
        data["coin"] = this.coin;
        data["point"] = this.point;
        data["detailLineInfo"] = this.detailLineInfo;
        data["fullDeptCode"] = this.fullDeptCode;
        data["fullClassCode"] = this.fullClassCode;
        data["quantity"] = this.quantity;
        data["unitPrice"] = this.unitPrice;
        data["amountBeforeTax"] = this.amountBeforeTax;
        data["amountIncludeTax"] = this.amountIncludeTax;
        data["calcAmount"] = this.calcAmount;
        data["taxAmount"] = this.taxAmount;
        data["productCategorySettingPointRatio"] = this.productCategorySettingPointRatio;
        data["productCategorySettingCoinRatio"] = this.productCategorySettingCoinRatio;
        data["productSettingPoint"] = this.productSettingPoint;
        data["productSettingCoin"] = this.productSettingCoin;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditTransactionDetailDto {
    transactionCode: string;
    productCode: string;
    productCategorySettingCode: string | undefined;
    productSettingCode: string | undefined;
    coin: number | undefined;
    point: number | undefined;
    detailLineInfo: string | undefined;
    fullDeptCode: string | undefined;
    fullClassCode: string | undefined;
    quantity: number | undefined;
    unitPrice: number | undefined;
    amountBeforeTax: number | undefined;
    amountIncludeTax: number | undefined;
    calcAmount: number | undefined;
    taxAmount: number | undefined;
    productCategorySettingPointRatio: number | undefined;
    productCategorySettingCoinRatio: number | undefined;
    productSettingPoint: number | undefined;
    productSettingCoin: number | undefined;
    isDeleted: boolean | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class GetOrderDetailAsyncDto implements IGetOrderDetailAsyncDto {
    transactionDto!: TransactionDto | undefined;
    listTransactionDetailDto!: TransactionDetailDto[] | undefined;
    listProductDto!: ProductDto[] | undefined;

    constructor(data?: IGetOrderDetailAsyncDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.transactionDto = data["transactionDto"] ? TransactionDto.fromJS(data["transactionDto"]) : <any>undefined;
            if (data["listTransactionDetailDto"] && data["listTransactionDetailDto"].constructor === Array) {
                this.listTransactionDetailDto = [];
                for (let item of data["listTransactionDetailDto"])
                    this.listTransactionDetailDto.push(TransactionDetailDto.fromJS(item));
            }
            if (data["listProductDto"] && data["listProductDto"].constructor === Array) {
                this.listProductDto = [];
                for (let item of data["listProductDto"])
                    this.listProductDto.push(ProductDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetOrderDetailAsyncDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetOrderDetailAsyncDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionDto"] = this.transactionDto ? this.transactionDto.toJSON() : <any>undefined;
        if (this.listTransactionDetailDto && this.listTransactionDetailDto.constructor === Array) {
            data["listTransactionDetailDto"] = [];
            for (let item of this.listTransactionDetailDto)
                data["listTransactionDetailDto"].push(item.toJSON());
        }
        if (this.listProductDto && this.listProductDto.constructor === Array) {
            data["listProductDto"] = [];
            for (let item of this.listProductDto)
                data["listProductDto"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetOrderDetailAsyncDto {
    transactionDto: TransactionDto | undefined;
    listTransactionDetailDto: TransactionDetailDto[] | undefined;
    listProductDto: ProductDto[] | undefined;
}

export class TransactionDto implements ITransactionDto {
    actionRuleCoin!: number | undefined;
    actionRulePoint!: number | undefined;
    actionRuleSettingCode!: string | undefined;
    approver!: string | undefined;
    baseCoinRatio!: number | undefined;
    basePointRatio!: number | undefined;
    baseSettingCode!: string | undefined;
    businessTime!: moment.Moment | undefined;
    code!: string | undefined;
    coin!: number | undefined;
    description!: string | undefined;
    distributorCode!: string | undefined;
    eventCoinRatio!: number | undefined;
    eventPointRatio!: number | undefined;
    eventSettingCode!: string | undefined;
    fullChannelTypeCode!: string | undefined;
    fullMemberTypeCode!: string | undefined;
    fullRegionCode!: string | undefined;
    fullSalesRegionCode!: string | undefined;
    memberCode!: string | undefined;
    originalOrders!: string | undefined;
    originalOrdersTime!: moment.Moment | undefined;
    plusCoin!: number | undefined;
    plusPoint!: number | undefined;
    point!: number | undefined;
    rankCode!: string | undefined;
    rankCoinRatio!: number | undefined;
    rankPointRatio!: number | undefined;
    rankSettingCode!: string | undefined;
    rankTypeCode!: string | undefined;
    ratioCoin!: number | undefined;
    ratioPoint!: number | undefined;
    reason!: string | undefined;
    referralSettingCode!: string | undefined;
    requestDate!: moment.Moment | undefined;
    senioritySettingCode!: string | undefined;
    source!: string | undefined;
    specialSettingCode!: string | undefined;
    standardMemberCode!: string | undefined;
    terminalNo!: string | undefined;
    totalAmountBeforeTax!: number | undefined;
    totalAmountIncludeTax!: number | undefined;
    totalCalcAmount!: number | undefined;
    totalDetailLine!: number | undefined;
    totalTaxAmount!: number | undefined;
    usedCoin!: number | undefined;
    totalAmountIssuePoint!: number | undefined;
    totalAmountIssueCoin!: number | undefined;
    lastUpdateByName!: string | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: moment.Moment | undefined;
    id!: number | undefined;

    constructor(data?: ITransactionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.actionRuleCoin = data["actionRuleCoin"];
            this.actionRulePoint = data["actionRulePoint"];
            this.actionRuleSettingCode = data["actionRuleSettingCode"];
            this.approver = data["approver"];
            this.baseCoinRatio = data["baseCoinRatio"];
            this.basePointRatio = data["basePointRatio"];
            this.baseSettingCode = data["baseSettingCode"];
            this.businessTime = data["businessTime"] ? moment(data["businessTime"].toString()) : <any>undefined;
            this.code = data["code"];
            this.coin = data["coin"];
            this.description = data["description"];
            this.distributorCode = data["distributorCode"];
            this.eventCoinRatio = data["eventCoinRatio"];
            this.eventPointRatio = data["eventPointRatio"];
            this.eventSettingCode = data["eventSettingCode"];
            this.fullChannelTypeCode = data["fullChannelTypeCode"];
            this.fullMemberTypeCode = data["fullMemberTypeCode"];
            this.fullRegionCode = data["fullRegionCode"];
            this.fullSalesRegionCode = data["fullSalesRegionCode"];
            this.memberCode = data["memberCode"];
            this.originalOrders = data["originalOrders"];
            this.originalOrdersTime = data["originalOrdersTime"] ? moment(data["originalOrdersTime"].toString()) : <any>undefined;
            this.plusCoin = data["plusCoin"];
            this.plusPoint = data["plusPoint"];
            this.point = data["point"];
            this.rankCode = data["rankCode"];
            this.rankCoinRatio = data["rankCoinRatio"];
            this.rankPointRatio = data["rankPointRatio"];
            this.rankSettingCode = data["rankSettingCode"];
            this.rankTypeCode = data["rankTypeCode"];
            this.ratioCoin = data["ratioCoin"];
            this.ratioPoint = data["ratioPoint"];
            this.reason = data["reason"];
            this.referralSettingCode = data["referralSettingCode"];
            this.requestDate = data["requestDate"] ? moment(data["requestDate"].toString()) : <any>undefined;
            this.senioritySettingCode = data["senioritySettingCode"];
            this.source = data["source"];
            this.specialSettingCode = data["specialSettingCode"];
            this.standardMemberCode = data["standardMemberCode"];
            this.terminalNo = data["terminalNo"];
            this.totalAmountBeforeTax = data["totalAmountBeforeTax"];
            this.totalAmountIncludeTax = data["totalAmountIncludeTax"];
            this.totalCalcAmount = data["totalCalcAmount"];
            this.totalDetailLine = data["totalDetailLine"];
            this.totalTaxAmount = data["totalTaxAmount"];
            this.usedCoin = data["usedCoin"];
            this.totalAmountIssuePoint = data["totalAmountIssuePoint"];
            this.totalAmountIssueCoin = data["totalAmountIssueCoin"];
            this.lastUpdateByName = data["lastUpdateByName"];
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): TransactionDto {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["actionRuleCoin"] = this.actionRuleCoin;
        data["actionRulePoint"] = this.actionRulePoint;
        data["actionRuleSettingCode"] = this.actionRuleSettingCode;
        data["approver"] = this.approver;
        data["baseCoinRatio"] = this.baseCoinRatio;
        data["basePointRatio"] = this.basePointRatio;
        data["baseSettingCode"] = this.baseSettingCode;
        data["businessTime"] = this.businessTime ? this.businessTime.toISOString() : <any>undefined;
        data["code"] = this.code;
        data["coin"] = this.coin;
        data["description"] = this.description;
        data["distributorCode"] = this.distributorCode;
        data["eventCoinRatio"] = this.eventCoinRatio;
        data["eventPointRatio"] = this.eventPointRatio;
        data["eventSettingCode"] = this.eventSettingCode;
        data["fullChannelTypeCode"] = this.fullChannelTypeCode;
        data["fullMemberTypeCode"] = this.fullMemberTypeCode;
        data["fullRegionCode"] = this.fullRegionCode;
        data["fullSalesRegionCode"] = this.fullSalesRegionCode;
        data["memberCode"] = this.memberCode;
        data["originalOrders"] = this.originalOrders;
        data["originalOrdersTime"] = this.originalOrdersTime ? this.originalOrdersTime.toISOString() : <any>undefined;
        data["plusCoin"] = this.plusCoin;
        data["plusPoint"] = this.plusPoint;
        data["point"] = this.point;
        data["rankCode"] = this.rankCode;
        data["rankCoinRatio"] = this.rankCoinRatio;
        data["rankPointRatio"] = this.rankPointRatio;
        data["rankSettingCode"] = this.rankSettingCode;
        data["rankTypeCode"] = this.rankTypeCode;
        data["ratioCoin"] = this.ratioCoin;
        data["ratioPoint"] = this.ratioPoint;
        data["reason"] = this.reason;
        data["referralSettingCode"] = this.referralSettingCode;
        data["requestDate"] = this.requestDate ? this.requestDate.toISOString() : <any>undefined;
        data["senioritySettingCode"] = this.senioritySettingCode;
        data["source"] = this.source;
        data["specialSettingCode"] = this.specialSettingCode;
        data["standardMemberCode"] = this.standardMemberCode;
        data["terminalNo"] = this.terminalNo;
        data["totalAmountBeforeTax"] = this.totalAmountBeforeTax;
        data["totalAmountIncludeTax"] = this.totalAmountIncludeTax;
        data["totalCalcAmount"] = this.totalCalcAmount;
        data["totalDetailLine"] = this.totalDetailLine;
        data["totalTaxAmount"] = this.totalTaxAmount;
        data["usedCoin"] = this.usedCoin;
        data["totalAmountIssuePoint"] = this.totalAmountIssuePoint;
        data["totalAmountIssueCoin"] = this.totalAmountIssueCoin;
        data["lastUpdateByName"] = this.lastUpdateByName;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface ITransactionDto {
    actionRuleCoin: number | undefined;
    actionRulePoint: number | undefined;
    actionRuleSettingCode: string | undefined;
    approver: string | undefined;
    baseCoinRatio: number | undefined;
    basePointRatio: number | undefined;
    baseSettingCode: string | undefined;
    businessTime: moment.Moment | undefined;
    code: string | undefined;
    coin: number | undefined;
    description: string | undefined;
    distributorCode: string | undefined;
    eventCoinRatio: number | undefined;
    eventPointRatio: number | undefined;
    eventSettingCode: string | undefined;
    fullChannelTypeCode: string | undefined;
    fullMemberTypeCode: string | undefined;
    fullRegionCode: string | undefined;
    fullSalesRegionCode: string | undefined;
    memberCode: string | undefined;
    originalOrders: string | undefined;
    originalOrdersTime: moment.Moment | undefined;
    plusCoin: number | undefined;
    plusPoint: number | undefined;
    point: number | undefined;
    rankCode: string | undefined;
    rankCoinRatio: number | undefined;
    rankPointRatio: number | undefined;
    rankSettingCode: string | undefined;
    rankTypeCode: string | undefined;
    ratioCoin: number | undefined;
    ratioPoint: number | undefined;
    reason: string | undefined;
    referralSettingCode: string | undefined;
    requestDate: moment.Moment | undefined;
    senioritySettingCode: string | undefined;
    source: string | undefined;
    specialSettingCode: string | undefined;
    standardMemberCode: string | undefined;
    terminalNo: string | undefined;
    totalAmountBeforeTax: number | undefined;
    totalAmountIncludeTax: number | undefined;
    totalCalcAmount: number | undefined;
    totalDetailLine: number | undefined;
    totalTaxAmount: number | undefined;
    usedCoin: number | undefined;
    totalAmountIssuePoint: number | undefined;
    totalAmountIssueCoin: number | undefined;
    lastUpdateByName: string | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfGetTransactionPointBaseLineForView implements IPagedResultDtoOfGetTransactionPointBaseLineForView {
    totalCount!: number | undefined;
    items!: GetTransactionPointBaseLineForView[] | undefined;

    constructor(data?: IPagedResultDtoOfGetTransactionPointBaseLineForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetTransactionPointBaseLineForView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetTransactionPointBaseLineForView {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetTransactionPointBaseLineForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetTransactionPointBaseLineForView {
    totalCount: number | undefined;
    items: GetTransactionPointBaseLineForView[] | undefined;
}

export class GetTransactionPointBaseLineForView implements IGetTransactionPointBaseLineForView {
    transactionPointBaseLine!: TransactionPointBaseLineDto | undefined;

    constructor(data?: IGetTransactionPointBaseLineForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.transactionPointBaseLine = data["transactionPointBaseLine"] ? TransactionPointBaseLineDto.fromJS(data["transactionPointBaseLine"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetTransactionPointBaseLineForView {
        data = typeof data === 'object' ? data : {};
        let result = new GetTransactionPointBaseLineForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionPointBaseLine"] = this.transactionPointBaseLine ? this.transactionPointBaseLine.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetTransactionPointBaseLineForView {
    transactionPointBaseLine: TransactionPointBaseLineDto | undefined;
}

export class TransactionPointBaseLineDto implements ITransactionPointBaseLineDto {
    id!: number | undefined;

    constructor(data?: ITransactionPointBaseLineDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
        }
    }

    static fromJS(data: any): TransactionPointBaseLineDto {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionPointBaseLineDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface ITransactionPointBaseLineDto {
    id: number | undefined;
}

export class GetTransactionPointBaseLineForEditOutput implements IGetTransactionPointBaseLineForEditOutput {
    transactionPointBaseLine!: CreateOrEditTransactionPointBaseLineDto | undefined;

    constructor(data?: IGetTransactionPointBaseLineForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.transactionPointBaseLine = data["transactionPointBaseLine"] ? CreateOrEditTransactionPointBaseLineDto.fromJS(data["transactionPointBaseLine"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetTransactionPointBaseLineForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetTransactionPointBaseLineForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionPointBaseLine"] = this.transactionPointBaseLine ? this.transactionPointBaseLine.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetTransactionPointBaseLineForEditOutput {
    transactionPointBaseLine: CreateOrEditTransactionPointBaseLineDto | undefined;
}

export class CreateOrEditTransactionPointBaseLineDto implements ICreateOrEditTransactionPointBaseLineDto {
    memberCode!: string;
    month!: number | undefined;
    point!: number | undefined;
    isDeleted!: boolean | undefined;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: moment.Moment | undefined;
    creatorUserId!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditTransactionPointBaseLineDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberCode = data["memberCode"];
            this.month = data["month"];
            this.point = data["point"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditTransactionPointBaseLineDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditTransactionPointBaseLineDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberCode"] = this.memberCode;
        data["month"] = this.month;
        data["point"] = this.point;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditTransactionPointBaseLineDto {
    memberCode: string;
    month: number | undefined;
    point: number | undefined;
    isDeleted: boolean | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfGetTransactionForViewDto implements IPagedResultDtoOfGetTransactionForViewDto {
    totalCount!: number | undefined;
    items!: GetTransactionForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetTransactionForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetTransactionForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetTransactionForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetTransactionForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetTransactionForViewDto {
    totalCount: number | undefined;
    items: GetTransactionForViewDto[] | undefined;
}

export class GetTransactionForViewDto implements IGetTransactionForViewDto {
    transaction!: TransactionDto | undefined;

    constructor(data?: IGetTransactionForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.transaction = data["transaction"] ? TransactionDto.fromJS(data["transaction"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetTransactionForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetTransactionForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transaction"] = this.transaction ? this.transaction.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetTransactionForViewDto {
    transaction: TransactionDto | undefined;
}

export class GetTransactionForEditOutput implements IGetTransactionForEditOutput {
    transaction!: CreateOrEditTransactionDto | undefined;

    constructor(data?: IGetTransactionForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.transaction = data["transaction"] ? CreateOrEditTransactionDto.fromJS(data["transaction"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetTransactionForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetTransactionForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transaction"] = this.transaction ? this.transaction.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetTransactionForEditOutput {
    transaction: CreateOrEditTransactionDto | undefined;
}

export class CreateOrEditTransactionDto implements ICreateOrEditTransactionDto {
    actionRuleCoin!: number | undefined;
    actionRulePoint!: number | undefined;
    actionRuleSettingCode!: string | undefined;
    approver!: string | undefined;
    baseCoinRatio!: number | undefined;
    basePointRatio!: number | undefined;
    baseSettingCode!: string | undefined;
    businessTime!: moment.Moment | undefined;
    code!: string;
    coin!: number | undefined;
    description!: string | undefined;
    distributorCode!: string | undefined;
    eventCoinRatio!: number | undefined;
    eventPointRatio!: number | undefined;
    eventSettingCode!: string | undefined;
    fullChannelTypeCode!: string | undefined;
    fullMemberTypeCode!: string | undefined;
    fullRegionCode!: string | undefined;
    fullSalesRegionCode!: string | undefined;
    memberCode!: string;
    originalOrders!: string | undefined;
    originalOrdersTime!: moment.Moment | undefined;
    plusCoin!: number | undefined;
    plusPoint!: number | undefined;
    point!: number | undefined;
    rankCode!: string | undefined;
    rankCoinRatio!: number | undefined;
    rankPointRatio!: number | undefined;
    rankSettingCode!: string | undefined;
    rankTypeCode!: string | undefined;
    ratioCoin!: number | undefined;
    ratioPoint!: number | undefined;
    reason!: string;
    referralSettingCode!: string | undefined;
    requestDate!: moment.Moment | undefined;
    senioritySettingCode!: string | undefined;
    source!: string | undefined;
    specialSettingCode!: string | undefined;
    standardMemberCode!: string | undefined;
    terminalNo!: string | undefined;
    totalAmountBeforeTax!: number | undefined;
    totalAmountIncludeTax!: number | undefined;
    totalCalcAmount!: number | undefined;
    totalDetailLine!: number | undefined;
    totalTaxAmount!: number | undefined;
    usedCoin!: number | undefined;
    totalAmountIssuePoint!: number | undefined;
    totalAmountIssueCoin!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditTransactionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.actionRuleCoin = data["actionRuleCoin"];
            this.actionRulePoint = data["actionRulePoint"];
            this.actionRuleSettingCode = data["actionRuleSettingCode"];
            this.approver = data["approver"];
            this.baseCoinRatio = data["baseCoinRatio"];
            this.basePointRatio = data["basePointRatio"];
            this.baseSettingCode = data["baseSettingCode"];
            this.businessTime = data["businessTime"] ? moment(data["businessTime"].toString()) : <any>undefined;
            this.code = data["code"];
            this.coin = data["coin"];
            this.description = data["description"];
            this.distributorCode = data["distributorCode"];
            this.eventCoinRatio = data["eventCoinRatio"];
            this.eventPointRatio = data["eventPointRatio"];
            this.eventSettingCode = data["eventSettingCode"];
            this.fullChannelTypeCode = data["fullChannelTypeCode"];
            this.fullMemberTypeCode = data["fullMemberTypeCode"];
            this.fullRegionCode = data["fullRegionCode"];
            this.fullSalesRegionCode = data["fullSalesRegionCode"];
            this.memberCode = data["memberCode"];
            this.originalOrders = data["originalOrders"];
            this.originalOrdersTime = data["originalOrdersTime"] ? moment(data["originalOrdersTime"].toString()) : <any>undefined;
            this.plusCoin = data["plusCoin"];
            this.plusPoint = data["plusPoint"];
            this.point = data["point"];
            this.rankCode = data["rankCode"];
            this.rankCoinRatio = data["rankCoinRatio"];
            this.rankPointRatio = data["rankPointRatio"];
            this.rankSettingCode = data["rankSettingCode"];
            this.rankTypeCode = data["rankTypeCode"];
            this.ratioCoin = data["ratioCoin"];
            this.ratioPoint = data["ratioPoint"];
            this.reason = data["reason"];
            this.referralSettingCode = data["referralSettingCode"];
            this.requestDate = data["requestDate"] ? moment(data["requestDate"].toString()) : <any>undefined;
            this.senioritySettingCode = data["senioritySettingCode"];
            this.source = data["source"];
            this.specialSettingCode = data["specialSettingCode"];
            this.standardMemberCode = data["standardMemberCode"];
            this.terminalNo = data["terminalNo"];
            this.totalAmountBeforeTax = data["totalAmountBeforeTax"];
            this.totalAmountIncludeTax = data["totalAmountIncludeTax"];
            this.totalCalcAmount = data["totalCalcAmount"];
            this.totalDetailLine = data["totalDetailLine"];
            this.totalTaxAmount = data["totalTaxAmount"];
            this.usedCoin = data["usedCoin"];
            this.totalAmountIssuePoint = data["totalAmountIssuePoint"];
            this.totalAmountIssueCoin = data["totalAmountIssueCoin"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditTransactionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditTransactionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["actionRuleCoin"] = this.actionRuleCoin;
        data["actionRulePoint"] = this.actionRulePoint;
        data["actionRuleSettingCode"] = this.actionRuleSettingCode;
        data["approver"] = this.approver;
        data["baseCoinRatio"] = this.baseCoinRatio;
        data["basePointRatio"] = this.basePointRatio;
        data["baseSettingCode"] = this.baseSettingCode;
        data["businessTime"] = this.businessTime ? this.businessTime.toISOString() : <any>undefined;
        data["code"] = this.code;
        data["coin"] = this.coin;
        data["description"] = this.description;
        data["distributorCode"] = this.distributorCode;
        data["eventCoinRatio"] = this.eventCoinRatio;
        data["eventPointRatio"] = this.eventPointRatio;
        data["eventSettingCode"] = this.eventSettingCode;
        data["fullChannelTypeCode"] = this.fullChannelTypeCode;
        data["fullMemberTypeCode"] = this.fullMemberTypeCode;
        data["fullRegionCode"] = this.fullRegionCode;
        data["fullSalesRegionCode"] = this.fullSalesRegionCode;
        data["memberCode"] = this.memberCode;
        data["originalOrders"] = this.originalOrders;
        data["originalOrdersTime"] = this.originalOrdersTime ? this.originalOrdersTime.toISOString() : <any>undefined;
        data["plusCoin"] = this.plusCoin;
        data["plusPoint"] = this.plusPoint;
        data["point"] = this.point;
        data["rankCode"] = this.rankCode;
        data["rankCoinRatio"] = this.rankCoinRatio;
        data["rankPointRatio"] = this.rankPointRatio;
        data["rankSettingCode"] = this.rankSettingCode;
        data["rankTypeCode"] = this.rankTypeCode;
        data["ratioCoin"] = this.ratioCoin;
        data["ratioPoint"] = this.ratioPoint;
        data["reason"] = this.reason;
        data["referralSettingCode"] = this.referralSettingCode;
        data["requestDate"] = this.requestDate ? this.requestDate.toISOString() : <any>undefined;
        data["senioritySettingCode"] = this.senioritySettingCode;
        data["source"] = this.source;
        data["specialSettingCode"] = this.specialSettingCode;
        data["standardMemberCode"] = this.standardMemberCode;
        data["terminalNo"] = this.terminalNo;
        data["totalAmountBeforeTax"] = this.totalAmountBeforeTax;
        data["totalAmountIncludeTax"] = this.totalAmountIncludeTax;
        data["totalCalcAmount"] = this.totalCalcAmount;
        data["totalDetailLine"] = this.totalDetailLine;
        data["totalTaxAmount"] = this.totalTaxAmount;
        data["usedCoin"] = this.usedCoin;
        data["totalAmountIssuePoint"] = this.totalAmountIssuePoint;
        data["totalAmountIssueCoin"] = this.totalAmountIssueCoin;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditTransactionDto {
    actionRuleCoin: number | undefined;
    actionRulePoint: number | undefined;
    actionRuleSettingCode: string | undefined;
    approver: string | undefined;
    baseCoinRatio: number | undefined;
    basePointRatio: number | undefined;
    baseSettingCode: string | undefined;
    businessTime: moment.Moment | undefined;
    code: string;
    coin: number | undefined;
    description: string | undefined;
    distributorCode: string | undefined;
    eventCoinRatio: number | undefined;
    eventPointRatio: number | undefined;
    eventSettingCode: string | undefined;
    fullChannelTypeCode: string | undefined;
    fullMemberTypeCode: string | undefined;
    fullRegionCode: string | undefined;
    fullSalesRegionCode: string | undefined;
    memberCode: string;
    originalOrders: string | undefined;
    originalOrdersTime: moment.Moment | undefined;
    plusCoin: number | undefined;
    plusPoint: number | undefined;
    point: number | undefined;
    rankCode: string | undefined;
    rankCoinRatio: number | undefined;
    rankPointRatio: number | undefined;
    rankSettingCode: string | undefined;
    rankTypeCode: string | undefined;
    ratioCoin: number | undefined;
    ratioPoint: number | undefined;
    reason: string;
    referralSettingCode: string | undefined;
    requestDate: moment.Moment | undefined;
    senioritySettingCode: string | undefined;
    source: string | undefined;
    specialSettingCode: string | undefined;
    standardMemberCode: string | undefined;
    terminalNo: string | undefined;
    totalAmountBeforeTax: number | undefined;
    totalAmountIncludeTax: number | undefined;
    totalCalcAmount: number | undefined;
    totalDetailLine: number | undefined;
    totalTaxAmount: number | undefined;
    usedCoin: number | undefined;
    totalAmountIssuePoint: number | undefined;
    totalAmountIssueCoin: number | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfGetPointHistoryForView implements IPagedResultDtoOfGetPointHistoryForView {
    totalCount!: number | undefined;
    items!: GetPointHistoryForView[] | undefined;

    constructor(data?: IPagedResultDtoOfGetPointHistoryForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetPointHistoryForView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetPointHistoryForView {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetPointHistoryForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetPointHistoryForView {
    totalCount: number | undefined;
    items: GetPointHistoryForView[] | undefined;
}

export class GetPointHistoryForView implements IGetPointHistoryForView {
    transaction!: GetPointHistoryOutput | undefined;

    constructor(data?: IGetPointHistoryForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.transaction = data["transaction"] ? GetPointHistoryOutput.fromJS(data["transaction"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetPointHistoryForView {
        data = typeof data === 'object' ? data : {};
        let result = new GetPointHistoryForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transaction"] = this.transaction ? this.transaction.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetPointHistoryForView {
    transaction: GetPointHistoryOutput | undefined;
}

export class GetPointHistoryOutput implements IGetPointHistoryOutput {
    tenantId!: number | undefined;
    code!: string | undefined;
    creationTime!: moment.Moment | undefined;
    memberCode!: string | undefined;
    reason!: string | undefined;
    requestDate!: moment.Moment | undefined;
    coin!: number | undefined;
    point!: number | undefined;
    rankCode!: string | undefined;
    standardMemberCode!: string | undefined;
    rankTypeCode!: string | undefined;
    businessTime!: moment.Moment | undefined;
    originalOrdersTime!: moment.Moment | undefined;
    originalOrders!: string | undefined;
    totalCalcAmount!: number | undefined;
    description!: string | undefined;
    source!: string | undefined;
    storeName!: string | undefined;
    storeAddress!: string | undefined;
    totalAmountIssuePoint!: number | undefined;
    totalAmountIssueCoin!: number | undefined;

    constructor(data?: IGetPointHistoryOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.code = data["code"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.memberCode = data["memberCode"];
            this.reason = data["reason"];
            this.requestDate = data["requestDate"] ? moment(data["requestDate"].toString()) : <any>undefined;
            this.coin = data["coin"];
            this.point = data["point"];
            this.rankCode = data["rankCode"];
            this.standardMemberCode = data["standardMemberCode"];
            this.rankTypeCode = data["rankTypeCode"];
            this.businessTime = data["businessTime"] ? moment(data["businessTime"].toString()) : <any>undefined;
            this.originalOrdersTime = data["originalOrdersTime"] ? moment(data["originalOrdersTime"].toString()) : <any>undefined;
            this.originalOrders = data["originalOrders"];
            this.totalCalcAmount = data["totalCalcAmount"];
            this.description = data["description"];
            this.source = data["source"];
            this.storeName = data["storeName"];
            this.storeAddress = data["storeAddress"];
            this.totalAmountIssuePoint = data["totalAmountIssuePoint"];
            this.totalAmountIssueCoin = data["totalAmountIssueCoin"];
        }
    }

    static fromJS(data: any): GetPointHistoryOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetPointHistoryOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["code"] = this.code;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["memberCode"] = this.memberCode;
        data["reason"] = this.reason;
        data["requestDate"] = this.requestDate ? this.requestDate.toISOString() : <any>undefined;
        data["coin"] = this.coin;
        data["point"] = this.point;
        data["rankCode"] = this.rankCode;
        data["standardMemberCode"] = this.standardMemberCode;
        data["rankTypeCode"] = this.rankTypeCode;
        data["businessTime"] = this.businessTime ? this.businessTime.toISOString() : <any>undefined;
        data["originalOrdersTime"] = this.originalOrdersTime ? this.originalOrdersTime.toISOString() : <any>undefined;
        data["originalOrders"] = this.originalOrders;
        data["totalCalcAmount"] = this.totalCalcAmount;
        data["description"] = this.description;
        data["source"] = this.source;
        data["storeName"] = this.storeName;
        data["storeAddress"] = this.storeAddress;
        data["totalAmountIssuePoint"] = this.totalAmountIssuePoint;
        data["totalAmountIssueCoin"] = this.totalAmountIssueCoin;
        return data;
    }
}

export interface IGetPointHistoryOutput {
    tenantId: number | undefined;
    code: string | undefined;
    creationTime: moment.Moment | undefined;
    memberCode: string | undefined;
    reason: string | undefined;
    requestDate: moment.Moment | undefined;
    coin: number | undefined;
    point: number | undefined;
    rankCode: string | undefined;
    standardMemberCode: string | undefined;
    rankTypeCode: string | undefined;
    businessTime: moment.Moment | undefined;
    originalOrdersTime: moment.Moment | undefined;
    originalOrders: string | undefined;
    totalCalcAmount: number | undefined;
    description: string | undefined;
    source: string | undefined;
    storeName: string | undefined;
    storeAddress: string | undefined;
    totalAmountIssuePoint: number | undefined;
    totalAmountIssueCoin: number | undefined;
}

export class GetTransactionsTransferCoinInput implements IGetTransactionsTransferCoinInput {
    requestMemberCode!: string;
    receiveMemberCode!: string;
    date!: string;
    transferCoinAmount!: number;
    transactionCode!: string;

    constructor(data?: IGetTransactionsTransferCoinInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.requestMemberCode = data["requestMemberCode"];
            this.receiveMemberCode = data["receiveMemberCode"];
            this.date = data["date"];
            this.transferCoinAmount = data["transferCoinAmount"];
            this.transactionCode = data["transactionCode"];
        }
    }

    static fromJS(data: any): GetTransactionsTransferCoinInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetTransactionsTransferCoinInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestMemberCode"] = this.requestMemberCode;
        data["receiveMemberCode"] = this.receiveMemberCode;
        data["date"] = this.date;
        data["transferCoinAmount"] = this.transferCoinAmount;
        data["transactionCode"] = this.transactionCode;
        return data;
    }
}

export interface IGetTransactionsTransferCoinInput {
    requestMemberCode: string;
    receiveMemberCode: string;
    date: string;
    transferCoinAmount: number;
    transactionCode: string;
}

export class GetTransactionsTransferCoinOutput implements IGetTransactionsTransferCoinOutput {
    memberCode!: string | undefined;
    totalCoin!: number | undefined;
    adjustedCoin!: number | undefined;

    constructor(data?: IGetTransactionsTransferCoinOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberCode = data["memberCode"];
            this.totalCoin = data["totalCoin"];
            this.adjustedCoin = data["adjustedCoin"];
        }
    }

    static fromJS(data: any): GetTransactionsTransferCoinOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetTransactionsTransferCoinOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberCode"] = this.memberCode;
        data["totalCoin"] = this.totalCoin;
        data["adjustedCoin"] = this.adjustedCoin;
        return data;
    }
}

export interface IGetTransactionsTransferCoinOutput {
    memberCode: string | undefined;
    totalCoin: number | undefined;
    adjustedCoin: number | undefined;
}

export class GetTransactionsRevokeCoinInput implements IGetTransactionsRevokeCoinInput {
    memberCode!: string;
    description!: string | undefined;
    reasonCode!: string;
    transactionCode!: string;

    constructor(data?: IGetTransactionsRevokeCoinInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberCode = data["memberCode"];
            this.description = data["description"];
            this.reasonCode = data["reasonCode"];
            this.transactionCode = data["transactionCode"];
        }
    }

    static fromJS(data: any): GetTransactionsRevokeCoinInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetTransactionsRevokeCoinInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberCode"] = this.memberCode;
        data["description"] = this.description;
        data["reasonCode"] = this.reasonCode;
        data["transactionCode"] = this.transactionCode;
        return data;
    }
}

export interface IGetTransactionsRevokeCoinInput {
    memberCode: string;
    description: string | undefined;
    reasonCode: string;
    transactionCode: string;
}

export class GetTransactionsRevokeCoinOutput implements IGetTransactionsRevokeCoinOutput {
    memberCode!: string | undefined;
    totalCoin!: number | undefined;
    adjustedCoin!: number | undefined;

    constructor(data?: IGetTransactionsRevokeCoinOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberCode = data["memberCode"];
            this.totalCoin = data["totalCoin"];
            this.adjustedCoin = data["adjustedCoin"];
        }
    }

    static fromJS(data: any): GetTransactionsRevokeCoinOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetTransactionsRevokeCoinOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberCode"] = this.memberCode;
        data["totalCoin"] = this.totalCoin;
        data["adjustedCoin"] = this.adjustedCoin;
        return data;
    }
}

export interface IGetTransactionsRevokeCoinOutput {
    memberCode: string | undefined;
    totalCoin: number | undefined;
    adjustedCoin: number | undefined;
}

export class PagedResultDtoOfGetTransactionForView implements IPagedResultDtoOfGetTransactionForView {
    totalCount!: number | undefined;
    items!: GetTransactionForView[] | undefined;

    constructor(data?: IPagedResultDtoOfGetTransactionForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetTransactionForView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetTransactionForView {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetTransactionForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetTransactionForView {
    totalCount: number | undefined;
    items: GetTransactionForView[] | undefined;
}

export class GetTransactionForView implements IGetTransactionForView {
    transaction!: TransactionDto | undefined;

    constructor(data?: IGetTransactionForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.transaction = data["transaction"] ? TransactionDto.fromJS(data["transaction"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetTransactionForView {
        data = typeof data === 'object' ? data : {};
        let result = new GetTransactionForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transaction"] = this.transaction ? this.transaction.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetTransactionForView {
    transaction: TransactionDto | undefined;
}

export class PagedResultDtoOfTransactionDetailByDayView implements IPagedResultDtoOfTransactionDetailByDayView {
    totalCount!: number | undefined;
    items!: TransactionDetailByDayView[] | undefined;

    constructor(data?: IPagedResultDtoOfTransactionDetailByDayView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(TransactionDetailByDayView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfTransactionDetailByDayView {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfTransactionDetailByDayView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfTransactionDetailByDayView {
    totalCount: number | undefined;
    items: TransactionDetailByDayView[] | undefined;
}

export class TransactionDetailByDayView implements ITransactionDetailByDayView {
    orderDate!: moment.Moment | undefined;
    totalAmount!: number | undefined;
    transactionHeaders!: TransactionHeaderByDayDto[] | undefined;

    constructor(data?: ITransactionDetailByDayView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.orderDate = data["orderDate"] ? moment(data["orderDate"].toString()) : <any>undefined;
            this.totalAmount = data["totalAmount"];
            if (data["transactionHeaders"] && data["transactionHeaders"].constructor === Array) {
                this.transactionHeaders = [];
                for (let item of data["transactionHeaders"])
                    this.transactionHeaders.push(TransactionHeaderByDayDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TransactionDetailByDayView {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionDetailByDayView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderDate"] = this.orderDate ? this.orderDate.toISOString() : <any>undefined;
        data["totalAmount"] = this.totalAmount;
        if (this.transactionHeaders && this.transactionHeaders.constructor === Array) {
            data["transactionHeaders"] = [];
            for (let item of this.transactionHeaders)
                data["transactionHeaders"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITransactionDetailByDayView {
    orderDate: moment.Moment | undefined;
    totalAmount: number | undefined;
    transactionHeaders: TransactionHeaderByDayDto[] | undefined;
}

export class TransactionHeaderByDayDto implements ITransactionHeaderByDayDto {
    orderCode!: string | undefined;
    transactionDetails!: TransactionDetailByDayDto[] | undefined;

    constructor(data?: ITransactionHeaderByDayDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.orderCode = data["orderCode"];
            if (data["transactionDetails"] && data["transactionDetails"].constructor === Array) {
                this.transactionDetails = [];
                for (let item of data["transactionDetails"])
                    this.transactionDetails.push(TransactionDetailByDayDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TransactionHeaderByDayDto {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionHeaderByDayDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderCode"] = this.orderCode;
        if (this.transactionDetails && this.transactionDetails.constructor === Array) {
            data["transactionDetails"] = [];
            for (let item of this.transactionDetails)
                data["transactionDetails"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITransactionHeaderByDayDto {
    orderCode: string | undefined;
    transactionDetails: TransactionDetailByDayDto[] | undefined;
}

export class TransactionDetailByDayDto implements ITransactionDetailByDayDto {
    productName!: string | undefined;
    quantity!: number | undefined;
    amount!: number | undefined;

    constructor(data?: ITransactionDetailByDayDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.productName = data["productName"];
            this.quantity = data["quantity"];
            this.amount = data["amount"];
        }
    }

    static fromJS(data: any): TransactionDetailByDayDto {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionDetailByDayDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productName"] = this.productName;
        data["quantity"] = this.quantity;
        data["amount"] = this.amount;
        return data;
    }
}

export interface ITransactionDetailByDayDto {
    productName: string | undefined;
    quantity: number | undefined;
    amount: number | undefined;
}

export class UiCustomizationSettingsEditDto implements IUiCustomizationSettingsEditDto {
    layout!: UiCustomizationLayoutSettingsEditDto | undefined;
    header!: UiCustomizationHeaderSettingsEditDto | undefined;
    menu!: UiCustomizationMenuSettingsEditDto | undefined;
    footer!: UiCustomizationFooterSettingsEditDto | undefined;

    constructor(data?: IUiCustomizationSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.layout = data["layout"] ? UiCustomizationLayoutSettingsEditDto.fromJS(data["layout"]) : <any>undefined;
            this.header = data["header"] ? UiCustomizationHeaderSettingsEditDto.fromJS(data["header"]) : <any>undefined;
            this.menu = data["menu"] ? UiCustomizationMenuSettingsEditDto.fromJS(data["menu"]) : <any>undefined;
            this.footer = data["footer"] ? UiCustomizationFooterSettingsEditDto.fromJS(data["footer"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UiCustomizationSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new UiCustomizationSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["layout"] = this.layout ? this.layout.toJSON() : <any>undefined;
        data["header"] = this.header ? this.header.toJSON() : <any>undefined;
        data["menu"] = this.menu ? this.menu.toJSON() : <any>undefined;
        data["footer"] = this.footer ? this.footer.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUiCustomizationSettingsEditDto {
    layout: UiCustomizationLayoutSettingsEditDto | undefined;
    header: UiCustomizationHeaderSettingsEditDto | undefined;
    menu: UiCustomizationMenuSettingsEditDto | undefined;
    footer: UiCustomizationFooterSettingsEditDto | undefined;
}

export class UiCustomizationLayoutSettingsEditDto implements IUiCustomizationLayoutSettingsEditDto {
    layoutType!: string | undefined;
    contentSkin!: string | undefined;
    theme!: string | undefined;

    constructor(data?: IUiCustomizationLayoutSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.layoutType = data["layoutType"];
            this.contentSkin = data["contentSkin"];
            this.theme = data["theme"];
        }
    }

    static fromJS(data: any): UiCustomizationLayoutSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new UiCustomizationLayoutSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["layoutType"] = this.layoutType;
        data["contentSkin"] = this.contentSkin;
        data["theme"] = this.theme;
        return data;
    }
}

export interface IUiCustomizationLayoutSettingsEditDto {
    layoutType: string | undefined;
    contentSkin: string | undefined;
    theme: string | undefined;
}

export class UiCustomizationHeaderSettingsEditDto implements IUiCustomizationHeaderSettingsEditDto {
    desktopFixedHeader!: boolean | undefined;
    desktopMinimizeMode!: string | undefined;
    mobileFixedHeader!: boolean | undefined;
    headerSkin!: string | undefined;
    displaySubmenuArrowDesktop!: boolean | undefined;

    constructor(data?: IUiCustomizationHeaderSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.desktopFixedHeader = data["desktopFixedHeader"];
            this.desktopMinimizeMode = data["desktopMinimizeMode"];
            this.mobileFixedHeader = data["mobileFixedHeader"];
            this.headerSkin = data["headerSkin"];
            this.displaySubmenuArrowDesktop = data["displaySubmenuArrowDesktop"];
        }
    }

    static fromJS(data: any): UiCustomizationHeaderSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new UiCustomizationHeaderSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["desktopFixedHeader"] = this.desktopFixedHeader;
        data["desktopMinimizeMode"] = this.desktopMinimizeMode;
        data["mobileFixedHeader"] = this.mobileFixedHeader;
        data["headerSkin"] = this.headerSkin;
        data["displaySubmenuArrowDesktop"] = this.displaySubmenuArrowDesktop;
        return data;
    }
}

export interface IUiCustomizationHeaderSettingsEditDto {
    desktopFixedHeader: boolean | undefined;
    desktopMinimizeMode: string | undefined;
    mobileFixedHeader: boolean | undefined;
    headerSkin: string | undefined;
    displaySubmenuArrowDesktop: boolean | undefined;
}

export class UiCustomizationMenuSettingsEditDto implements IUiCustomizationMenuSettingsEditDto {
    position!: string | undefined;
    asideSkin!: string | undefined;
    fixedAside!: boolean | undefined;
    allowAsideMinimizing!: boolean | undefined;
    defaultMinimizedAside!: boolean | undefined;
    allowAsideHiding!: boolean | undefined;
    defaultHiddenAside!: boolean | undefined;
    submenuToggle!: string | undefined;
    dropdownSubmenuSkin!: string | undefined;
    dropdownSubmenuArrow!: boolean | undefined;

    constructor(data?: IUiCustomizationMenuSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.position = data["position"];
            this.asideSkin = data["asideSkin"];
            this.fixedAside = data["fixedAside"];
            this.allowAsideMinimizing = data["allowAsideMinimizing"];
            this.defaultMinimizedAside = data["defaultMinimizedAside"];
            this.allowAsideHiding = data["allowAsideHiding"];
            this.defaultHiddenAside = data["defaultHiddenAside"];
            this.submenuToggle = data["submenuToggle"];
            this.dropdownSubmenuSkin = data["dropdownSubmenuSkin"];
            this.dropdownSubmenuArrow = data["dropdownSubmenuArrow"];
        }
    }

    static fromJS(data: any): UiCustomizationMenuSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new UiCustomizationMenuSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["position"] = this.position;
        data["asideSkin"] = this.asideSkin;
        data["fixedAside"] = this.fixedAside;
        data["allowAsideMinimizing"] = this.allowAsideMinimizing;
        data["defaultMinimizedAside"] = this.defaultMinimizedAside;
        data["allowAsideHiding"] = this.allowAsideHiding;
        data["defaultHiddenAside"] = this.defaultHiddenAside;
        data["submenuToggle"] = this.submenuToggle;
        data["dropdownSubmenuSkin"] = this.dropdownSubmenuSkin;
        data["dropdownSubmenuArrow"] = this.dropdownSubmenuArrow;
        return data;
    }
}

export interface IUiCustomizationMenuSettingsEditDto {
    position: string | undefined;
    asideSkin: string | undefined;
    fixedAside: boolean | undefined;
    allowAsideMinimizing: boolean | undefined;
    defaultMinimizedAside: boolean | undefined;
    allowAsideHiding: boolean | undefined;
    defaultHiddenAside: boolean | undefined;
    submenuToggle: string | undefined;
    dropdownSubmenuSkin: string | undefined;
    dropdownSubmenuArrow: boolean | undefined;
}

export class UiCustomizationFooterSettingsEditDto implements IUiCustomizationFooterSettingsEditDto {
    fixedFooter!: boolean | undefined;

    constructor(data?: IUiCustomizationFooterSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.fixedFooter = data["fixedFooter"];
        }
    }

    static fromJS(data: any): UiCustomizationFooterSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new UiCustomizationFooterSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fixedFooter"] = this.fixedFooter;
        return data;
    }
}

export interface IUiCustomizationFooterSettingsEditDto {
    fixedFooter: boolean | undefined;
}

export class PagedResultDtoOfGetUnavailableGiftForViewDto implements IPagedResultDtoOfGetUnavailableGiftForViewDto {
    totalCount!: number | undefined;
    items!: GetUnavailableGiftForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetUnavailableGiftForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetUnavailableGiftForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetUnavailableGiftForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetUnavailableGiftForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetUnavailableGiftForViewDto {
    totalCount: number | undefined;
    items: GetUnavailableGiftForViewDto[] | undefined;
}

export class GetUnavailableGiftForViewDto implements IGetUnavailableGiftForViewDto {
    unavailableGift!: UnavailableGiftDto | undefined;

    constructor(data?: IGetUnavailableGiftForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unavailableGift = data["unavailableGift"] ? UnavailableGiftDto.fromJS(data["unavailableGift"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetUnavailableGiftForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetUnavailableGiftForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unavailableGift"] = this.unavailableGift ? this.unavailableGift.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetUnavailableGiftForViewDto {
    unavailableGift: UnavailableGiftDto | undefined;
}

export class UnavailableGiftDto implements IUnavailableGiftDto {
    giftCampaignCode!: string | undefined;
    outletCode!: string | undefined;
    outletName!: string | undefined;
    zaloChatID!: string | undefined;
    publishDate!: moment.Moment | undefined;
    requestDate!: moment.Moment | undefined;
    giftMasterCode!: string | undefined;
    giftCode!: string | undefined;
    status!: string | undefined;
    transactionID!: string | undefined;
    id!: number | undefined;

    constructor(data?: IUnavailableGiftDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.giftCampaignCode = data["giftCampaignCode"];
            this.outletCode = data["outletCode"];
            this.outletName = data["outletName"];
            this.zaloChatID = data["zaloChatID"];
            this.publishDate = data["publishDate"] ? moment(data["publishDate"].toString()) : <any>undefined;
            this.requestDate = data["requestDate"] ? moment(data["requestDate"].toString()) : <any>undefined;
            this.giftMasterCode = data["giftMasterCode"];
            this.giftCode = data["giftCode"];
            this.status = data["status"];
            this.transactionID = data["transactionID"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): UnavailableGiftDto {
        data = typeof data === 'object' ? data : {};
        let result = new UnavailableGiftDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["giftCampaignCode"] = this.giftCampaignCode;
        data["outletCode"] = this.outletCode;
        data["outletName"] = this.outletName;
        data["zaloChatID"] = this.zaloChatID;
        data["publishDate"] = this.publishDate ? this.publishDate.toISOString() : <any>undefined;
        data["requestDate"] = this.requestDate ? this.requestDate.toISOString() : <any>undefined;
        data["giftMasterCode"] = this.giftMasterCode;
        data["giftCode"] = this.giftCode;
        data["status"] = this.status;
        data["transactionID"] = this.transactionID;
        data["id"] = this.id;
        return data;
    }
}

export interface IUnavailableGiftDto {
    giftCampaignCode: string | undefined;
    outletCode: string | undefined;
    outletName: string | undefined;
    zaloChatID: string | undefined;
    publishDate: moment.Moment | undefined;
    requestDate: moment.Moment | undefined;
    giftMasterCode: string | undefined;
    giftCode: string | undefined;
    status: string | undefined;
    transactionID: string | undefined;
    id: number | undefined;
}

export class GetUnavailableGiftForEditOutput implements IGetUnavailableGiftForEditOutput {
    unavailableGift!: CreateOrEditUnavailableGiftDto | undefined;

    constructor(data?: IGetUnavailableGiftForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unavailableGift = data["unavailableGift"] ? CreateOrEditUnavailableGiftDto.fromJS(data["unavailableGift"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetUnavailableGiftForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetUnavailableGiftForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unavailableGift"] = this.unavailableGift ? this.unavailableGift.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetUnavailableGiftForEditOutput {
    unavailableGift: CreateOrEditUnavailableGiftDto | undefined;
}

export class CreateOrEditUnavailableGiftDto implements ICreateOrEditUnavailableGiftDto {
    giftCampaignCode!: string | undefined;
    outletCode!: string | undefined;
    outletName!: string | undefined;
    zaloChatID!: string | undefined;
    publishDate!: moment.Moment | undefined;
    requestDate!: moment.Moment | undefined;
    giftMasterCode!: string | undefined;
    giftCode!: string | undefined;
    status!: string | undefined;
    transactionID!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditUnavailableGiftDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.giftCampaignCode = data["giftCampaignCode"];
            this.outletCode = data["outletCode"];
            this.outletName = data["outletName"];
            this.zaloChatID = data["zaloChatID"];
            this.publishDate = data["publishDate"] ? moment(data["publishDate"].toString()) : <any>undefined;
            this.requestDate = data["requestDate"] ? moment(data["requestDate"].toString()) : <any>undefined;
            this.giftMasterCode = data["giftMasterCode"];
            this.giftCode = data["giftCode"];
            this.status = data["status"];
            this.transactionID = data["transactionID"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditUnavailableGiftDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditUnavailableGiftDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["giftCampaignCode"] = this.giftCampaignCode;
        data["outletCode"] = this.outletCode;
        data["outletName"] = this.outletName;
        data["zaloChatID"] = this.zaloChatID;
        data["publishDate"] = this.publishDate ? this.publishDate.toISOString() : <any>undefined;
        data["requestDate"] = this.requestDate ? this.requestDate.toISOString() : <any>undefined;
        data["giftMasterCode"] = this.giftMasterCode;
        data["giftCode"] = this.giftCode;
        data["status"] = this.status;
        data["transactionID"] = this.transactionID;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditUnavailableGiftDto {
    giftCampaignCode: string | undefined;
    outletCode: string | undefined;
    outletName: string | undefined;
    zaloChatID: string | undefined;
    publishDate: moment.Moment | undefined;
    requestDate: moment.Moment | undefined;
    giftMasterCode: string | undefined;
    giftCode: string | undefined;
    status: string | undefined;
    transactionID: string | undefined;
    id: number | undefined;
}

export class SendGiftGotitInput implements ISendGiftGotitInput {
    giftCampaignCode!: string | undefined;
    giftMasterCode!: string | undefined;
    targetAudienceID!: number | undefined;
    outletCode!: string | undefined;
    status!: string | undefined;
    voucherLink!: string | undefined;

    constructor(data?: ISendGiftGotitInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.giftCampaignCode = data["giftCampaignCode"];
            this.giftMasterCode = data["giftMasterCode"];
            this.targetAudienceID = data["targetAudienceID"];
            this.outletCode = data["outletCode"];
            this.status = data["status"];
            this.voucherLink = data["voucherLink"];
        }
    }

    static fromJS(data: any): SendGiftGotitInput {
        data = typeof data === 'object' ? data : {};
        let result = new SendGiftGotitInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["giftCampaignCode"] = this.giftCampaignCode;
        data["giftMasterCode"] = this.giftMasterCode;
        data["targetAudienceID"] = this.targetAudienceID;
        data["outletCode"] = this.outletCode;
        data["status"] = this.status;
        data["voucherLink"] = this.voucherLink;
        return data;
    }
}

export interface ISendGiftGotitInput {
    giftCampaignCode: string | undefined;
    giftMasterCode: string | undefined;
    targetAudienceID: number | undefined;
    outletCode: string | undefined;
    status: string | undefined;
    voucherLink: string | undefined;
}

export class PagedResultDtoOfGetUnavailableVoucherForViewDto implements IPagedResultDtoOfGetUnavailableVoucherForViewDto {
    totalCount!: number | undefined;
    items!: GetUnavailableVoucherForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetUnavailableVoucherForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetUnavailableVoucherForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetUnavailableVoucherForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetUnavailableVoucherForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetUnavailableVoucherForViewDto {
    totalCount: number | undefined;
    items: GetUnavailableVoucherForViewDto[] | undefined;
}

export class GetUnavailableVoucherForViewDto implements IGetUnavailableVoucherForViewDto {
    unavailableVoucher!: UnavailableVoucherDto | undefined;

    constructor(data?: IGetUnavailableVoucherForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unavailableVoucher = data["unavailableVoucher"] ? UnavailableVoucherDto.fromJS(data["unavailableVoucher"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetUnavailableVoucherForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetUnavailableVoucherForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unavailableVoucher"] = this.unavailableVoucher ? this.unavailableVoucher.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetUnavailableVoucherForViewDto {
    unavailableVoucher: UnavailableVoucherDto | undefined;
}

export class UnavailableVoucherDto implements IUnavailableVoucherDto {
    voucherCode!: string | undefined;
    redemptionUser!: string | undefined;
    voucherGroupCode!: string | undefined;
    terminalID!: number | undefined;
    terminalTime!: moment.Moment | undefined;
    redemptionTime!: moment.Moment | undefined;
    issuedTime!: moment.Moment | undefined;
    status!: string | undefined;
    triggerEvent!: string | undefined;
    eventFilter!: string | undefined;
    referenceCode!: string | undefined;
    maxSlipPrint!: number | undefined;
    currentSlipPrint!: number | undefined;
    voucherUser!: string | undefined;
    id!: number | undefined;

    constructor(data?: IUnavailableVoucherDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.voucherCode = data["voucherCode"];
            this.redemptionUser = data["redemptionUser"];
            this.voucherGroupCode = data["voucherGroupCode"];
            this.terminalID = data["terminalID"];
            this.terminalTime = data["terminalTime"] ? moment(data["terminalTime"].toString()) : <any>undefined;
            this.redemptionTime = data["redemptionTime"] ? moment(data["redemptionTime"].toString()) : <any>undefined;
            this.issuedTime = data["issuedTime"] ? moment(data["issuedTime"].toString()) : <any>undefined;
            this.status = data["status"];
            this.triggerEvent = data["triggerEvent"];
            this.eventFilter = data["eventFilter"];
            this.referenceCode = data["referenceCode"];
            this.maxSlipPrint = data["maxSlipPrint"];
            this.currentSlipPrint = data["currentSlipPrint"];
            this.voucherUser = data["voucherUser"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): UnavailableVoucherDto {
        data = typeof data === 'object' ? data : {};
        let result = new UnavailableVoucherDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["voucherCode"] = this.voucherCode;
        data["redemptionUser"] = this.redemptionUser;
        data["voucherGroupCode"] = this.voucherGroupCode;
        data["terminalID"] = this.terminalID;
        data["terminalTime"] = this.terminalTime ? this.terminalTime.toISOString() : <any>undefined;
        data["redemptionTime"] = this.redemptionTime ? this.redemptionTime.toISOString() : <any>undefined;
        data["issuedTime"] = this.issuedTime ? this.issuedTime.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["triggerEvent"] = this.triggerEvent;
        data["eventFilter"] = this.eventFilter;
        data["referenceCode"] = this.referenceCode;
        data["maxSlipPrint"] = this.maxSlipPrint;
        data["currentSlipPrint"] = this.currentSlipPrint;
        data["voucherUser"] = this.voucherUser;
        data["id"] = this.id;
        return data;
    }
}

export interface IUnavailableVoucherDto {
    voucherCode: string | undefined;
    redemptionUser: string | undefined;
    voucherGroupCode: string | undefined;
    terminalID: number | undefined;
    terminalTime: moment.Moment | undefined;
    redemptionTime: moment.Moment | undefined;
    issuedTime: moment.Moment | undefined;
    status: string | undefined;
    triggerEvent: string | undefined;
    eventFilter: string | undefined;
    referenceCode: string | undefined;
    maxSlipPrint: number | undefined;
    currentSlipPrint: number | undefined;
    voucherUser: string | undefined;
    id: number | undefined;
}

export class GetUnavailableVoucherForEditOutput implements IGetUnavailableVoucherForEditOutput {
    unavailableVoucher!: CreateOrEditUnavailableVoucherDto | undefined;

    constructor(data?: IGetUnavailableVoucherForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unavailableVoucher = data["unavailableVoucher"] ? CreateOrEditUnavailableVoucherDto.fromJS(data["unavailableVoucher"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetUnavailableVoucherForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetUnavailableVoucherForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unavailableVoucher"] = this.unavailableVoucher ? this.unavailableVoucher.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetUnavailableVoucherForEditOutput {
    unavailableVoucher: CreateOrEditUnavailableVoucherDto | undefined;
}

export class CreateOrEditUnavailableVoucherDto implements ICreateOrEditUnavailableVoucherDto {
    voucherCode!: string | undefined;
    redemptionUser!: string | undefined;
    voucherGroupCode!: string | undefined;
    terminalID!: number | undefined;
    terminalTime!: moment.Moment | undefined;
    redemptionTime!: moment.Moment | undefined;
    issuedTime!: moment.Moment | undefined;
    status!: string | undefined;
    triggerEvent!: string | undefined;
    eventFilter!: string | undefined;
    referenceCode!: string | undefined;
    maxSlipPrint!: number | undefined;
    currentSlipPrint!: number | undefined;
    voucherUser!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditUnavailableVoucherDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.voucherCode = data["voucherCode"];
            this.redemptionUser = data["redemptionUser"];
            this.voucherGroupCode = data["voucherGroupCode"];
            this.terminalID = data["terminalID"];
            this.terminalTime = data["terminalTime"] ? moment(data["terminalTime"].toString()) : <any>undefined;
            this.redemptionTime = data["redemptionTime"] ? moment(data["redemptionTime"].toString()) : <any>undefined;
            this.issuedTime = data["issuedTime"] ? moment(data["issuedTime"].toString()) : <any>undefined;
            this.status = data["status"];
            this.triggerEvent = data["triggerEvent"];
            this.eventFilter = data["eventFilter"];
            this.referenceCode = data["referenceCode"];
            this.maxSlipPrint = data["maxSlipPrint"];
            this.currentSlipPrint = data["currentSlipPrint"];
            this.voucherUser = data["voucherUser"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditUnavailableVoucherDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditUnavailableVoucherDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["voucherCode"] = this.voucherCode;
        data["redemptionUser"] = this.redemptionUser;
        data["voucherGroupCode"] = this.voucherGroupCode;
        data["terminalID"] = this.terminalID;
        data["terminalTime"] = this.terminalTime ? this.terminalTime.toISOString() : <any>undefined;
        data["redemptionTime"] = this.redemptionTime ? this.redemptionTime.toISOString() : <any>undefined;
        data["issuedTime"] = this.issuedTime ? this.issuedTime.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["triggerEvent"] = this.triggerEvent;
        data["eventFilter"] = this.eventFilter;
        data["referenceCode"] = this.referenceCode;
        data["maxSlipPrint"] = this.maxSlipPrint;
        data["currentSlipPrint"] = this.currentSlipPrint;
        data["voucherUser"] = this.voucherUser;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditUnavailableVoucherDto {
    voucherCode: string | undefined;
    redemptionUser: string | undefined;
    voucherGroupCode: string | undefined;
    terminalID: number | undefined;
    terminalTime: moment.Moment | undefined;
    redemptionTime: moment.Moment | undefined;
    issuedTime: moment.Moment | undefined;
    status: string | undefined;
    triggerEvent: string | undefined;
    eventFilter: string | undefined;
    referenceCode: string | undefined;
    maxSlipPrint: number | undefined;
    currentSlipPrint: number | undefined;
    voucherUser: string | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfGetUpdateProfileRequestHistoryForViewDto implements IPagedResultDtoOfGetUpdateProfileRequestHistoryForViewDto {
    totalCount!: number | undefined;
    items!: GetUpdateProfileRequestHistoryForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetUpdateProfileRequestHistoryForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetUpdateProfileRequestHistoryForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetUpdateProfileRequestHistoryForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetUpdateProfileRequestHistoryForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetUpdateProfileRequestHistoryForViewDto {
    totalCount: number | undefined;
    items: GetUpdateProfileRequestHistoryForViewDto[] | undefined;
}

export class GetUpdateProfileRequestHistoryForViewDto implements IGetUpdateProfileRequestHistoryForViewDto {
    updateProfileRequestHistory!: UpdateProfileRequestHistoryDto | undefined;

    constructor(data?: IGetUpdateProfileRequestHistoryForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.updateProfileRequestHistory = data["updateProfileRequestHistory"] ? UpdateProfileRequestHistoryDto.fromJS(data["updateProfileRequestHistory"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetUpdateProfileRequestHistoryForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetUpdateProfileRequestHistoryForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["updateProfileRequestHistory"] = this.updateProfileRequestHistory ? this.updateProfileRequestHistory.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetUpdateProfileRequestHistoryForViewDto {
    updateProfileRequestHistory: UpdateProfileRequestHistoryDto | undefined;
}

export class UpdateProfileRequestHistoryDto implements IUpdateProfileRequestHistoryDto {
    memberCode!: string | undefined;
    name!: string | undefined;
    phone!: string | undefined;
    lng!: string | undefined;
    lat!: string | undefined;
    email!: string | undefined;
    gender!: string | undefined;
    birthday!: number | undefined;
    registrationDate!: number | undefined;
    pid!: string | undefined;
    sourceID!: string | undefined;
    receiveAds!: boolean | undefined;
    rankCode!: string | undefined;
    rankValidDate!: number | undefined;
    currentPoint!: number | undefined;
    nationalityCode!: string | undefined;
    occupationCode!: string | undefined;
    hobby!: string | undefined;
    address!: string | undefined;
    ward!: string | undefined;
    district!: string | undefined;
    province!: string | undefined;
    domain!: string | undefined;
    country!: string | undefined;
    status!: string | undefined;
    lastActivityTime!: moment.Moment | undefined;
    lastPurchaseTime!: moment.Moment | undefined;
    communicationLanguage!: string | undefined;
    notes!: string | undefined;
    rankPropose!: string | undefined;
    pinCode!: string | undefined;
    nameUnSign!: string | undefined;
    avatar!: string | undefined;
    workingPermit!: boolean | undefined;
    customerCode!: string | undefined;
    interestOf!: string | undefined;
    isInterestCobrand!: boolean | undefined;
    memberCard!: string | undefined;
    isForeigner!: boolean | undefined;
    isSynced!: boolean | undefined;
    referralCode!: string | undefined;
    accumulationPoint!: number | undefined;
    outletCode!: string | undefined;
    zaloName!: string | undefined;
    distributorCode!: string | undefined;
    distributorName!: string | undefined;
    regionCode!: string | undefined;
    targetRevenue!: number | undefined;
    actualRevenue!: number | undefined;
    bonus!: number | undefined;
    missingRevenue!: number | undefined;
    revenueUpdateDate!: number | undefined;
    note1!: string | undefined;
    note2!: string | undefined;
    note3!: string | undefined;
    note4!: string | undefined;
    note5!: string | undefined;
    salesChannel!: string | undefined;
    supervisorCode!: string | undefined;
    supervisorName!: string | undefined;
    phoneFirstDate!: moment.Moment | undefined;
    lockUpdatePhone!: boolean | undefined;
    browserCode!: string | undefined;
    deviceNameCode!: string | undefined;
    typeOfDeviceCode!: string | undefined;
    salesmanCode!: string | undefined;
    consumerID!: number | undefined;
    lockUpdateChatID!: boolean | undefined;
    currentCoin!: number | undefined;
    pointToKeepRank!: number | undefined;
    pointToNextRank!: number | undefined;
    expiringCoin!: number | undefined;
    expiringCoinDate!: moment.Moment | undefined;
    lockUpdateProfile!: boolean | undefined;
    outletType!: string | undefined;
    password!: string | undefined;
    accumulationPointSellIn!: number | undefined;
    accumulationPointSellOut!: number | undefined;
    businessType!: string | undefined;
    warehouseAddress!: string | undefined;
    bossName!: string | undefined;
    anniversaryDate!: moment.Moment | undefined;
    taxCode!: string | undefined;
    identificationCardNumber!: string | undefined;
    bankAccountNumber!: string | undefined;
    bankBranchName!: string | undefined;
    bankAccountName!: string | undefined;
    bankName!: string | undefined;
    creationTime!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;
    communicationChannels!: SocialMemberChannelInfo[] | undefined;
    communicationChannelsString!: string | undefined;
    rankName!: string | undefined;
    outletTypeName!: string | undefined;
    nationalityName!: string | undefined;
    chatId!: string | undefined;
    businessCertification!: string | undefined;
    businessCertificationback!: string | undefined;
    userId!: number | undefined;
    userName!: string | undefined;
    identificationCardFrontImage!: string | undefined;
    identificationCardBackImage!: string | undefined;
    storeArea!: number | undefined;
    employeeQuantity!: number | undefined;
    verifyStatus!: string | undefined;
    requestCode!: string | undefined;
    legalPersonalName!: string | undefined;
    legalPersonal!: string | undefined;
    taxAddress!: string | undefined;
    storeType!: string | undefined;
    id!: number | undefined;

    constructor(data?: IUpdateProfileRequestHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberCode = data["memberCode"];
            this.name = data["name"];
            this.phone = data["phone"];
            this.lng = data["lng"];
            this.lat = data["lat"];
            this.email = data["email"];
            this.gender = data["gender"];
            this.birthday = data["birthday"];
            this.registrationDate = data["registrationDate"];
            this.pid = data["pid"];
            this.sourceID = data["sourceID"];
            this.receiveAds = data["receiveAds"];
            this.rankCode = data["rankCode"];
            this.rankValidDate = data["rankValidDate"];
            this.currentPoint = data["currentPoint"];
            this.nationalityCode = data["nationalityCode"];
            this.occupationCode = data["occupationCode"];
            this.hobby = data["hobby"];
            this.address = data["address"];
            this.ward = data["ward"];
            this.district = data["district"];
            this.province = data["province"];
            this.domain = data["domain"];
            this.country = data["country"];
            this.status = data["status"];
            this.lastActivityTime = data["lastActivityTime"] ? moment(data["lastActivityTime"].toString()) : <any>undefined;
            this.lastPurchaseTime = data["lastPurchaseTime"] ? moment(data["lastPurchaseTime"].toString()) : <any>undefined;
            this.communicationLanguage = data["communicationLanguage"];
            this.notes = data["notes"];
            this.rankPropose = data["rankPropose"];
            this.pinCode = data["pinCode"];
            this.nameUnSign = data["nameUnSign"];
            this.avatar = data["avatar"];
            this.workingPermit = data["workingPermit"];
            this.customerCode = data["customerCode"];
            this.interestOf = data["interestOf"];
            this.isInterestCobrand = data["isInterestCobrand"];
            this.memberCard = data["memberCard"];
            this.isForeigner = data["isForeigner"];
            this.isSynced = data["isSynced"];
            this.referralCode = data["referralCode"];
            this.accumulationPoint = data["accumulationPoint"];
            this.outletCode = data["outletCode"];
            this.zaloName = data["zaloName"];
            this.distributorCode = data["distributorCode"];
            this.distributorName = data["distributorName"];
            this.regionCode = data["regionCode"];
            this.targetRevenue = data["targetRevenue"];
            this.actualRevenue = data["actualRevenue"];
            this.bonus = data["bonus"];
            this.missingRevenue = data["missingRevenue"];
            this.revenueUpdateDate = data["revenueUpdateDate"];
            this.note1 = data["note1"];
            this.note2 = data["note2"];
            this.note3 = data["note3"];
            this.note4 = data["note4"];
            this.note5 = data["note5"];
            this.salesChannel = data["salesChannel"];
            this.supervisorCode = data["supervisorCode"];
            this.supervisorName = data["supervisorName"];
            this.phoneFirstDate = data["phoneFirstDate"] ? moment(data["phoneFirstDate"].toString()) : <any>undefined;
            this.lockUpdatePhone = data["lockUpdatePhone"];
            this.browserCode = data["browserCode"];
            this.deviceNameCode = data["deviceNameCode"];
            this.typeOfDeviceCode = data["typeOfDeviceCode"];
            this.salesmanCode = data["salesmanCode"];
            this.consumerID = data["consumerID"];
            this.lockUpdateChatID = data["lockUpdateChatID"];
            this.currentCoin = data["currentCoin"];
            this.pointToKeepRank = data["pointToKeepRank"];
            this.pointToNextRank = data["pointToNextRank"];
            this.expiringCoin = data["expiringCoin"];
            this.expiringCoinDate = data["expiringCoinDate"] ? moment(data["expiringCoinDate"].toString()) : <any>undefined;
            this.lockUpdateProfile = data["lockUpdateProfile"];
            this.outletType = data["outletType"];
            this.password = data["password"];
            this.accumulationPointSellIn = data["accumulationPointSellIn"];
            this.accumulationPointSellOut = data["accumulationPointSellOut"];
            this.businessType = data["businessType"];
            this.warehouseAddress = data["warehouseAddress"];
            this.bossName = data["bossName"];
            this.anniversaryDate = data["anniversaryDate"] ? moment(data["anniversaryDate"].toString()) : <any>undefined;
            this.taxCode = data["taxCode"];
            this.identificationCardNumber = data["identificationCardNumber"];
            this.bankAccountNumber = data["bankAccountNumber"];
            this.bankBranchName = data["bankBranchName"];
            this.bankAccountName = data["bankAccountName"];
            this.bankName = data["bankName"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            if (data["communicationChannels"] && data["communicationChannels"].constructor === Array) {
                this.communicationChannels = [];
                for (let item of data["communicationChannels"])
                    this.communicationChannels.push(SocialMemberChannelInfo.fromJS(item));
            }
            this.communicationChannelsString = data["communicationChannelsString"];
            this.rankName = data["rankName"];
            this.outletTypeName = data["outletTypeName"];
            this.nationalityName = data["nationalityName"];
            this.chatId = data["chatId"];
            this.businessCertification = data["businessCertification"];
            this.businessCertificationback = data["businessCertificationback"];
            this.userId = data["userId"];
            this.userName = data["userName"];
            this.identificationCardFrontImage = data["identificationCardFrontImage"];
            this.identificationCardBackImage = data["identificationCardBackImage"];
            this.storeArea = data["storeArea"];
            this.employeeQuantity = data["employeeQuantity"];
            this.verifyStatus = data["verifyStatus"];
            this.requestCode = data["requestCode"];
            this.legalPersonalName = data["legalPersonalName"];
            this.legalPersonal = data["legalPersonal"];
            this.taxAddress = data["taxAddress"];
            this.storeType = data["storeType"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): UpdateProfileRequestHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProfileRequestHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberCode"] = this.memberCode;
        data["name"] = this.name;
        data["phone"] = this.phone;
        data["lng"] = this.lng;
        data["lat"] = this.lat;
        data["email"] = this.email;
        data["gender"] = this.gender;
        data["birthday"] = this.birthday;
        data["registrationDate"] = this.registrationDate;
        data["pid"] = this.pid;
        data["sourceID"] = this.sourceID;
        data["receiveAds"] = this.receiveAds;
        data["rankCode"] = this.rankCode;
        data["rankValidDate"] = this.rankValidDate;
        data["currentPoint"] = this.currentPoint;
        data["nationalityCode"] = this.nationalityCode;
        data["occupationCode"] = this.occupationCode;
        data["hobby"] = this.hobby;
        data["address"] = this.address;
        data["ward"] = this.ward;
        data["district"] = this.district;
        data["province"] = this.province;
        data["domain"] = this.domain;
        data["country"] = this.country;
        data["status"] = this.status;
        data["lastActivityTime"] = this.lastActivityTime ? this.lastActivityTime.toISOString() : <any>undefined;
        data["lastPurchaseTime"] = this.lastPurchaseTime ? this.lastPurchaseTime.toISOString() : <any>undefined;
        data["communicationLanguage"] = this.communicationLanguage;
        data["notes"] = this.notes;
        data["rankPropose"] = this.rankPropose;
        data["pinCode"] = this.pinCode;
        data["nameUnSign"] = this.nameUnSign;
        data["avatar"] = this.avatar;
        data["workingPermit"] = this.workingPermit;
        data["customerCode"] = this.customerCode;
        data["interestOf"] = this.interestOf;
        data["isInterestCobrand"] = this.isInterestCobrand;
        data["memberCard"] = this.memberCard;
        data["isForeigner"] = this.isForeigner;
        data["isSynced"] = this.isSynced;
        data["referralCode"] = this.referralCode;
        data["accumulationPoint"] = this.accumulationPoint;
        data["outletCode"] = this.outletCode;
        data["zaloName"] = this.zaloName;
        data["distributorCode"] = this.distributorCode;
        data["distributorName"] = this.distributorName;
        data["regionCode"] = this.regionCode;
        data["targetRevenue"] = this.targetRevenue;
        data["actualRevenue"] = this.actualRevenue;
        data["bonus"] = this.bonus;
        data["missingRevenue"] = this.missingRevenue;
        data["revenueUpdateDate"] = this.revenueUpdateDate;
        data["note1"] = this.note1;
        data["note2"] = this.note2;
        data["note3"] = this.note3;
        data["note4"] = this.note4;
        data["note5"] = this.note5;
        data["salesChannel"] = this.salesChannel;
        data["supervisorCode"] = this.supervisorCode;
        data["supervisorName"] = this.supervisorName;
        data["phoneFirstDate"] = this.phoneFirstDate ? this.phoneFirstDate.toISOString() : <any>undefined;
        data["lockUpdatePhone"] = this.lockUpdatePhone;
        data["browserCode"] = this.browserCode;
        data["deviceNameCode"] = this.deviceNameCode;
        data["typeOfDeviceCode"] = this.typeOfDeviceCode;
        data["salesmanCode"] = this.salesmanCode;
        data["consumerID"] = this.consumerID;
        data["lockUpdateChatID"] = this.lockUpdateChatID;
        data["currentCoin"] = this.currentCoin;
        data["pointToKeepRank"] = this.pointToKeepRank;
        data["pointToNextRank"] = this.pointToNextRank;
        data["expiringCoin"] = this.expiringCoin;
        data["expiringCoinDate"] = this.expiringCoinDate ? this.expiringCoinDate.toISOString() : <any>undefined;
        data["lockUpdateProfile"] = this.lockUpdateProfile;
        data["outletType"] = this.outletType;
        data["password"] = this.password;
        data["accumulationPointSellIn"] = this.accumulationPointSellIn;
        data["accumulationPointSellOut"] = this.accumulationPointSellOut;
        data["businessType"] = this.businessType;
        data["warehouseAddress"] = this.warehouseAddress;
        data["bossName"] = this.bossName;
        data["anniversaryDate"] = this.anniversaryDate ? this.anniversaryDate.toISOString() : <any>undefined;
        data["taxCode"] = this.taxCode;
        data["identificationCardNumber"] = this.identificationCardNumber;
        data["bankAccountNumber"] = this.bankAccountNumber;
        data["bankBranchName"] = this.bankBranchName;
        data["bankAccountName"] = this.bankAccountName;
        data["bankName"] = this.bankName;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        if (this.communicationChannels && this.communicationChannels.constructor === Array) {
            data["communicationChannels"] = [];
            for (let item of this.communicationChannels)
                data["communicationChannels"].push(item.toJSON());
        }
        data["communicationChannelsString"] = this.communicationChannelsString;
        data["rankName"] = this.rankName;
        data["outletTypeName"] = this.outletTypeName;
        data["nationalityName"] = this.nationalityName;
        data["chatId"] = this.chatId;
        data["businessCertification"] = this.businessCertification;
        data["businessCertificationback"] = this.businessCertificationback;
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["identificationCardFrontImage"] = this.identificationCardFrontImage;
        data["identificationCardBackImage"] = this.identificationCardBackImage;
        data["storeArea"] = this.storeArea;
        data["employeeQuantity"] = this.employeeQuantity;
        data["verifyStatus"] = this.verifyStatus;
        data["requestCode"] = this.requestCode;
        data["legalPersonalName"] = this.legalPersonalName;
        data["legalPersonal"] = this.legalPersonal;
        data["taxAddress"] = this.taxAddress;
        data["storeType"] = this.storeType;
        data["id"] = this.id;
        return data;
    }
}

export interface IUpdateProfileRequestHistoryDto {
    memberCode: string | undefined;
    name: string | undefined;
    phone: string | undefined;
    lng: string | undefined;
    lat: string | undefined;
    email: string | undefined;
    gender: string | undefined;
    birthday: number | undefined;
    registrationDate: number | undefined;
    pid: string | undefined;
    sourceID: string | undefined;
    receiveAds: boolean | undefined;
    rankCode: string | undefined;
    rankValidDate: number | undefined;
    currentPoint: number | undefined;
    nationalityCode: string | undefined;
    occupationCode: string | undefined;
    hobby: string | undefined;
    address: string | undefined;
    ward: string | undefined;
    district: string | undefined;
    province: string | undefined;
    domain: string | undefined;
    country: string | undefined;
    status: string | undefined;
    lastActivityTime: moment.Moment | undefined;
    lastPurchaseTime: moment.Moment | undefined;
    communicationLanguage: string | undefined;
    notes: string | undefined;
    rankPropose: string | undefined;
    pinCode: string | undefined;
    nameUnSign: string | undefined;
    avatar: string | undefined;
    workingPermit: boolean | undefined;
    customerCode: string | undefined;
    interestOf: string | undefined;
    isInterestCobrand: boolean | undefined;
    memberCard: string | undefined;
    isForeigner: boolean | undefined;
    isSynced: boolean | undefined;
    referralCode: string | undefined;
    accumulationPoint: number | undefined;
    outletCode: string | undefined;
    zaloName: string | undefined;
    distributorCode: string | undefined;
    distributorName: string | undefined;
    regionCode: string | undefined;
    targetRevenue: number | undefined;
    actualRevenue: number | undefined;
    bonus: number | undefined;
    missingRevenue: number | undefined;
    revenueUpdateDate: number | undefined;
    note1: string | undefined;
    note2: string | undefined;
    note3: string | undefined;
    note4: string | undefined;
    note5: string | undefined;
    salesChannel: string | undefined;
    supervisorCode: string | undefined;
    supervisorName: string | undefined;
    phoneFirstDate: moment.Moment | undefined;
    lockUpdatePhone: boolean | undefined;
    browserCode: string | undefined;
    deviceNameCode: string | undefined;
    typeOfDeviceCode: string | undefined;
    salesmanCode: string | undefined;
    consumerID: number | undefined;
    lockUpdateChatID: boolean | undefined;
    currentCoin: number | undefined;
    pointToKeepRank: number | undefined;
    pointToNextRank: number | undefined;
    expiringCoin: number | undefined;
    expiringCoinDate: moment.Moment | undefined;
    lockUpdateProfile: boolean | undefined;
    outletType: string | undefined;
    password: string | undefined;
    accumulationPointSellIn: number | undefined;
    accumulationPointSellOut: number | undefined;
    businessType: string | undefined;
    warehouseAddress: string | undefined;
    bossName: string | undefined;
    anniversaryDate: moment.Moment | undefined;
    taxCode: string | undefined;
    identificationCardNumber: string | undefined;
    bankAccountNumber: string | undefined;
    bankBranchName: string | undefined;
    bankAccountName: string | undefined;
    bankName: string | undefined;
    creationTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    communicationChannels: SocialMemberChannelInfo[] | undefined;
    communicationChannelsString: string | undefined;
    rankName: string | undefined;
    outletTypeName: string | undefined;
    nationalityName: string | undefined;
    chatId: string | undefined;
    businessCertification: string | undefined;
    businessCertificationback: string | undefined;
    userId: number | undefined;
    userName: string | undefined;
    identificationCardFrontImage: string | undefined;
    identificationCardBackImage: string | undefined;
    storeArea: number | undefined;
    employeeQuantity: number | undefined;
    verifyStatus: string | undefined;
    requestCode: string | undefined;
    legalPersonalName: string | undefined;
    legalPersonal: string | undefined;
    taxAddress: string | undefined;
    storeType: string | undefined;
    id: number | undefined;
}

export class GetUpdateProfileRequestHistoryForEditOutput implements IGetUpdateProfileRequestHistoryForEditOutput {
    updateProfileRequestHistory!: CreateOrEditUpdateProfileRequestHistoryDto | undefined;
    itemChange!: string[] | undefined;

    constructor(data?: IGetUpdateProfileRequestHistoryForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.updateProfileRequestHistory = data["updateProfileRequestHistory"] ? CreateOrEditUpdateProfileRequestHistoryDto.fromJS(data["updateProfileRequestHistory"]) : <any>undefined;
            if (data["itemChange"] && data["itemChange"].constructor === Array) {
                this.itemChange = [];
                for (let item of data["itemChange"])
                    this.itemChange.push(item);
            }
        }
    }

    static fromJS(data: any): GetUpdateProfileRequestHistoryForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetUpdateProfileRequestHistoryForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["updateProfileRequestHistory"] = this.updateProfileRequestHistory ? this.updateProfileRequestHistory.toJSON() : <any>undefined;
        if (this.itemChange && this.itemChange.constructor === Array) {
            data["itemChange"] = [];
            for (let item of this.itemChange)
                data["itemChange"].push(item);
        }
        return data;
    }
}

export interface IGetUpdateProfileRequestHistoryForEditOutput {
    updateProfileRequestHistory: CreateOrEditUpdateProfileRequestHistoryDto | undefined;
    itemChange: string[] | undefined;
}

export class CreateOrEditUpdateProfileRequestHistoryDto implements ICreateOrEditUpdateProfileRequestHistoryDto {
    memberCode!: string | undefined;
    name!: string | undefined;
    phone!: string | undefined;
    lng!: string | undefined;
    lat!: string | undefined;
    email!: string | undefined;
    gender!: string | undefined;
    birthday!: number | undefined;
    registrationDate!: number | undefined;
    pid!: string | undefined;
    sourceID!: string | undefined;
    receiveAds!: boolean | undefined;
    rankCode!: string | undefined;
    rankValidDate!: number | undefined;
    currentPoint!: number | undefined;
    nationalityCode!: string | undefined;
    occupationCode!: string | undefined;
    hobby!: string | undefined;
    address!: string | undefined;
    ward!: string | undefined;
    district!: string | undefined;
    province!: string | undefined;
    country!: string | undefined;
    status!: string | undefined;
    lastActivityTime!: moment.Moment | undefined;
    lastPurchaseTime!: moment.Moment | undefined;
    communicationLanguage!: string | undefined;
    notes!: string | undefined;
    rankPropose!: string | undefined;
    pinCode!: string | undefined;
    nameUnSign!: string | undefined;
    avatar!: string | undefined;
    workingPermit!: boolean | undefined;
    customerCode!: string | undefined;
    interestOf!: string | undefined;
    isInterestCobrand!: boolean | undefined;
    memberCard!: string | undefined;
    isForeigner!: boolean | undefined;
    isSynced!: boolean | undefined;
    referralCode!: string | undefined;
    accumulationPoint!: number | undefined;
    outletCode!: string | undefined;
    zaloName!: string | undefined;
    distributorCode!: string | undefined;
    distributorName!: string | undefined;
    regionCode!: string | undefined;
    targetRevenue!: number | undefined;
    actualRevenue!: number | undefined;
    bonus!: number | undefined;
    missingRevenue!: number | undefined;
    revenueUpdateDate!: number | undefined;
    note1!: string | undefined;
    note2!: string | undefined;
    note3!: string | undefined;
    note4!: string | undefined;
    note5!: string | undefined;
    salesChannel!: string | undefined;
    supervisorCode!: string | undefined;
    supervisorName!: string | undefined;
    phoneFirstDate!: moment.Moment | undefined;
    lockUpdatePhone!: boolean | undefined;
    browserCode!: string | undefined;
    deviceNameCode!: string | undefined;
    typeOfDeviceCode!: string | undefined;
    salesmanCode!: string | undefined;
    consumerID!: number | undefined;
    lockUpdateChatID!: boolean | undefined;
    currentCoin!: number | undefined;
    pointToKeepRank!: number | undefined;
    pointToNextRank!: number | undefined;
    expiringCoin!: number | undefined;
    expiringCoinDate!: moment.Moment | undefined;
    lockUpdateProfile!: boolean | undefined;
    outletType!: string | undefined;
    password!: string | undefined;
    userNameOrEmailAddress!: string | undefined;
    warehouseAddress!: string | undefined;
    businessType!: string | undefined;
    accumulationPointSellIn!: number | undefined;
    accumulationPointSellOut!: number | undefined;
    sapCode!: string | undefined;
    bankAccountNumber!: string | undefined;
    bankAccountName!: string | undefined;
    bankName!: string | undefined;
    bankBranchName!: string | undefined;
    bossName!: string | undefined;
    anniversaryDate!: moment.Moment | undefined;
    taxCode!: string | undefined;
    identificationCardNumber!: string | undefined;
    identificationCardFrontImage!: string | undefined;
    identificationCardBackImage!: string | undefined;
    accountCode!: string | undefined;
    referrerCode!: string | undefined;
    communicationChannels!: SocialMemberChannelInfo[] | undefined;
    chatId!: string | undefined;
    salesmanName!: string | undefined;
    salesmanPhone!: string | undefined;
    lastModificationTime!: moment.Moment | undefined;
    rankName!: string | undefined;
    organizationUnits!: number[] | undefined;
    businessCertification!: string | undefined;
    businessCertificationback!: string | undefined;
    provinceName!: string | undefined;
    districtName!: string | undefined;
    legalPersonalName!: string | undefined;
    legalPersonal!: string | undefined;
    taxAddress!: string | undefined;
    createdFrom!: string | undefined;
    verifyStatus!: string | undefined;
    storeArea!: number | undefined;
    employeeQuantity!: number | undefined;
    requestCode!: string | undefined;
    storeType!: string | undefined;
    deptCode!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditUpdateProfileRequestHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberCode = data["memberCode"];
            this.name = data["name"];
            this.phone = data["phone"];
            this.lng = data["lng"];
            this.lat = data["lat"];
            this.email = data["email"];
            this.gender = data["gender"];
            this.birthday = data["birthday"];
            this.registrationDate = data["registrationDate"];
            this.pid = data["pid"];
            this.sourceID = data["sourceID"];
            this.receiveAds = data["receiveAds"];
            this.rankCode = data["rankCode"];
            this.rankValidDate = data["rankValidDate"];
            this.currentPoint = data["currentPoint"];
            this.nationalityCode = data["nationalityCode"];
            this.occupationCode = data["occupationCode"];
            this.hobby = data["hobby"];
            this.address = data["address"];
            this.ward = data["ward"];
            this.district = data["district"];
            this.province = data["province"];
            this.country = data["country"];
            this.status = data["status"];
            this.lastActivityTime = data["lastActivityTime"] ? moment(data["lastActivityTime"].toString()) : <any>undefined;
            this.lastPurchaseTime = data["lastPurchaseTime"] ? moment(data["lastPurchaseTime"].toString()) : <any>undefined;
            this.communicationLanguage = data["communicationLanguage"];
            this.notes = data["notes"];
            this.rankPropose = data["rankPropose"];
            this.pinCode = data["pinCode"];
            this.nameUnSign = data["nameUnSign"];
            this.avatar = data["avatar"];
            this.workingPermit = data["workingPermit"];
            this.customerCode = data["customerCode"];
            this.interestOf = data["interestOf"];
            this.isInterestCobrand = data["isInterestCobrand"];
            this.memberCard = data["memberCard"];
            this.isForeigner = data["isForeigner"];
            this.isSynced = data["isSynced"];
            this.referralCode = data["referralCode"];
            this.accumulationPoint = data["accumulationPoint"];
            this.outletCode = data["outletCode"];
            this.zaloName = data["zaloName"];
            this.distributorCode = data["distributorCode"];
            this.distributorName = data["distributorName"];
            this.regionCode = data["regionCode"];
            this.targetRevenue = data["targetRevenue"];
            this.actualRevenue = data["actualRevenue"];
            this.bonus = data["bonus"];
            this.missingRevenue = data["missingRevenue"];
            this.revenueUpdateDate = data["revenueUpdateDate"];
            this.note1 = data["note1"];
            this.note2 = data["note2"];
            this.note3 = data["note3"];
            this.note4 = data["note4"];
            this.note5 = data["note5"];
            this.salesChannel = data["salesChannel"];
            this.supervisorCode = data["supervisorCode"];
            this.supervisorName = data["supervisorName"];
            this.phoneFirstDate = data["phoneFirstDate"] ? moment(data["phoneFirstDate"].toString()) : <any>undefined;
            this.lockUpdatePhone = data["lockUpdatePhone"];
            this.browserCode = data["browserCode"];
            this.deviceNameCode = data["deviceNameCode"];
            this.typeOfDeviceCode = data["typeOfDeviceCode"];
            this.salesmanCode = data["salesmanCode"];
            this.consumerID = data["consumerID"];
            this.lockUpdateChatID = data["lockUpdateChatID"];
            this.currentCoin = data["currentCoin"];
            this.pointToKeepRank = data["pointToKeepRank"];
            this.pointToNextRank = data["pointToNextRank"];
            this.expiringCoin = data["expiringCoin"];
            this.expiringCoinDate = data["expiringCoinDate"] ? moment(data["expiringCoinDate"].toString()) : <any>undefined;
            this.lockUpdateProfile = data["lockUpdateProfile"];
            this.outletType = data["outletType"];
            this.password = data["password"];
            this.userNameOrEmailAddress = data["userNameOrEmailAddress"];
            this.warehouseAddress = data["warehouseAddress"];
            this.businessType = data["businessType"];
            this.accumulationPointSellIn = data["accumulationPointSellIn"];
            this.accumulationPointSellOut = data["accumulationPointSellOut"];
            this.sapCode = data["sapCode"];
            this.bankAccountNumber = data["bankAccountNumber"];
            this.bankAccountName = data["bankAccountName"];
            this.bankName = data["bankName"];
            this.bankBranchName = data["bankBranchName"];
            this.bossName = data["bossName"];
            this.anniversaryDate = data["anniversaryDate"] ? moment(data["anniversaryDate"].toString()) : <any>undefined;
            this.taxCode = data["taxCode"];
            this.identificationCardNumber = data["identificationCardNumber"];
            this.identificationCardFrontImage = data["identificationCardFrontImage"];
            this.identificationCardBackImage = data["identificationCardBackImage"];
            this.accountCode = data["accountCode"];
            this.referrerCode = data["referrerCode"];
            if (data["communicationChannels"] && data["communicationChannels"].constructor === Array) {
                this.communicationChannels = [];
                for (let item of data["communicationChannels"])
                    this.communicationChannels.push(SocialMemberChannelInfo.fromJS(item));
            }
            this.chatId = data["chatId"];
            this.salesmanName = data["salesmanName"];
            this.salesmanPhone = data["salesmanPhone"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.rankName = data["rankName"];
            if (data["organizationUnits"] && data["organizationUnits"].constructor === Array) {
                this.organizationUnits = [];
                for (let item of data["organizationUnits"])
                    this.organizationUnits.push(item);
            }
            this.businessCertification = data["businessCertification"];
            this.businessCertificationback = data["businessCertificationback"];
            this.provinceName = data["provinceName"];
            this.districtName = data["districtName"];
            this.legalPersonalName = data["legalPersonalName"];
            this.legalPersonal = data["legalPersonal"];
            this.taxAddress = data["taxAddress"];
            this.createdFrom = data["createdFrom"];
            this.verifyStatus = data["verifyStatus"];
            this.storeArea = data["storeArea"];
            this.employeeQuantity = data["employeeQuantity"];
            this.requestCode = data["requestCode"];
            this.storeType = data["storeType"];
            this.deptCode = data["deptCode"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditUpdateProfileRequestHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditUpdateProfileRequestHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberCode"] = this.memberCode;
        data["name"] = this.name;
        data["phone"] = this.phone;
        data["lng"] = this.lng;
        data["lat"] = this.lat;
        data["email"] = this.email;
        data["gender"] = this.gender;
        data["birthday"] = this.birthday;
        data["registrationDate"] = this.registrationDate;
        data["pid"] = this.pid;
        data["sourceID"] = this.sourceID;
        data["receiveAds"] = this.receiveAds;
        data["rankCode"] = this.rankCode;
        data["rankValidDate"] = this.rankValidDate;
        data["currentPoint"] = this.currentPoint;
        data["nationalityCode"] = this.nationalityCode;
        data["occupationCode"] = this.occupationCode;
        data["hobby"] = this.hobby;
        data["address"] = this.address;
        data["ward"] = this.ward;
        data["district"] = this.district;
        data["province"] = this.province;
        data["country"] = this.country;
        data["status"] = this.status;
        data["lastActivityTime"] = this.lastActivityTime ? this.lastActivityTime.toISOString() : <any>undefined;
        data["lastPurchaseTime"] = this.lastPurchaseTime ? this.lastPurchaseTime.toISOString() : <any>undefined;
        data["communicationLanguage"] = this.communicationLanguage;
        data["notes"] = this.notes;
        data["rankPropose"] = this.rankPropose;
        data["pinCode"] = this.pinCode;
        data["nameUnSign"] = this.nameUnSign;
        data["avatar"] = this.avatar;
        data["workingPermit"] = this.workingPermit;
        data["customerCode"] = this.customerCode;
        data["interestOf"] = this.interestOf;
        data["isInterestCobrand"] = this.isInterestCobrand;
        data["memberCard"] = this.memberCard;
        data["isForeigner"] = this.isForeigner;
        data["isSynced"] = this.isSynced;
        data["referralCode"] = this.referralCode;
        data["accumulationPoint"] = this.accumulationPoint;
        data["outletCode"] = this.outletCode;
        data["zaloName"] = this.zaloName;
        data["distributorCode"] = this.distributorCode;
        data["distributorName"] = this.distributorName;
        data["regionCode"] = this.regionCode;
        data["targetRevenue"] = this.targetRevenue;
        data["actualRevenue"] = this.actualRevenue;
        data["bonus"] = this.bonus;
        data["missingRevenue"] = this.missingRevenue;
        data["revenueUpdateDate"] = this.revenueUpdateDate;
        data["note1"] = this.note1;
        data["note2"] = this.note2;
        data["note3"] = this.note3;
        data["note4"] = this.note4;
        data["note5"] = this.note5;
        data["salesChannel"] = this.salesChannel;
        data["supervisorCode"] = this.supervisorCode;
        data["supervisorName"] = this.supervisorName;
        data["phoneFirstDate"] = this.phoneFirstDate ? this.phoneFirstDate.toISOString() : <any>undefined;
        data["lockUpdatePhone"] = this.lockUpdatePhone;
        data["browserCode"] = this.browserCode;
        data["deviceNameCode"] = this.deviceNameCode;
        data["typeOfDeviceCode"] = this.typeOfDeviceCode;
        data["salesmanCode"] = this.salesmanCode;
        data["consumerID"] = this.consumerID;
        data["lockUpdateChatID"] = this.lockUpdateChatID;
        data["currentCoin"] = this.currentCoin;
        data["pointToKeepRank"] = this.pointToKeepRank;
        data["pointToNextRank"] = this.pointToNextRank;
        data["expiringCoin"] = this.expiringCoin;
        data["expiringCoinDate"] = this.expiringCoinDate ? this.expiringCoinDate.toISOString() : <any>undefined;
        data["lockUpdateProfile"] = this.lockUpdateProfile;
        data["outletType"] = this.outletType;
        data["password"] = this.password;
        data["userNameOrEmailAddress"] = this.userNameOrEmailAddress;
        data["warehouseAddress"] = this.warehouseAddress;
        data["businessType"] = this.businessType;
        data["accumulationPointSellIn"] = this.accumulationPointSellIn;
        data["accumulationPointSellOut"] = this.accumulationPointSellOut;
        data["sapCode"] = this.sapCode;
        data["bankAccountNumber"] = this.bankAccountNumber;
        data["bankAccountName"] = this.bankAccountName;
        data["bankName"] = this.bankName;
        data["bankBranchName"] = this.bankBranchName;
        data["bossName"] = this.bossName;
        data["anniversaryDate"] = this.anniversaryDate ? this.anniversaryDate.toISOString() : <any>undefined;
        data["taxCode"] = this.taxCode;
        data["identificationCardNumber"] = this.identificationCardNumber;
        data["identificationCardFrontImage"] = this.identificationCardFrontImage;
        data["identificationCardBackImage"] = this.identificationCardBackImage;
        data["accountCode"] = this.accountCode;
        data["referrerCode"] = this.referrerCode;
        if (this.communicationChannels && this.communicationChannels.constructor === Array) {
            data["communicationChannels"] = [];
            for (let item of this.communicationChannels)
                data["communicationChannels"].push(item.toJSON());
        }
        data["chatId"] = this.chatId;
        data["salesmanName"] = this.salesmanName;
        data["salesmanPhone"] = this.salesmanPhone;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["rankName"] = this.rankName;
        if (this.organizationUnits && this.organizationUnits.constructor === Array) {
            data["organizationUnits"] = [];
            for (let item of this.organizationUnits)
                data["organizationUnits"].push(item);
        }
        data["businessCertification"] = this.businessCertification;
        data["businessCertificationback"] = this.businessCertificationback;
        data["provinceName"] = this.provinceName;
        data["districtName"] = this.districtName;
        data["legalPersonalName"] = this.legalPersonalName;
        data["legalPersonal"] = this.legalPersonal;
        data["taxAddress"] = this.taxAddress;
        data["createdFrom"] = this.createdFrom;
        data["verifyStatus"] = this.verifyStatus;
        data["storeArea"] = this.storeArea;
        data["employeeQuantity"] = this.employeeQuantity;
        data["requestCode"] = this.requestCode;
        data["storeType"] = this.storeType;
        data["deptCode"] = this.deptCode;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditUpdateProfileRequestHistoryDto {
    memberCode: string | undefined;
    name: string | undefined;
    phone: string | undefined;
    lng: string | undefined;
    lat: string | undefined;
    email: string | undefined;
    gender: string | undefined;
    birthday: number | undefined;
    registrationDate: number | undefined;
    pid: string | undefined;
    sourceID: string | undefined;
    receiveAds: boolean | undefined;
    rankCode: string | undefined;
    rankValidDate: number | undefined;
    currentPoint: number | undefined;
    nationalityCode: string | undefined;
    occupationCode: string | undefined;
    hobby: string | undefined;
    address: string | undefined;
    ward: string | undefined;
    district: string | undefined;
    province: string | undefined;
    country: string | undefined;
    status: string | undefined;
    lastActivityTime: moment.Moment | undefined;
    lastPurchaseTime: moment.Moment | undefined;
    communicationLanguage: string | undefined;
    notes: string | undefined;
    rankPropose: string | undefined;
    pinCode: string | undefined;
    nameUnSign: string | undefined;
    avatar: string | undefined;
    workingPermit: boolean | undefined;
    customerCode: string | undefined;
    interestOf: string | undefined;
    isInterestCobrand: boolean | undefined;
    memberCard: string | undefined;
    isForeigner: boolean | undefined;
    isSynced: boolean | undefined;
    referralCode: string | undefined;
    accumulationPoint: number | undefined;
    outletCode: string | undefined;
    zaloName: string | undefined;
    distributorCode: string | undefined;
    distributorName: string | undefined;
    regionCode: string | undefined;
    targetRevenue: number | undefined;
    actualRevenue: number | undefined;
    bonus: number | undefined;
    missingRevenue: number | undefined;
    revenueUpdateDate: number | undefined;
    note1: string | undefined;
    note2: string | undefined;
    note3: string | undefined;
    note4: string | undefined;
    note5: string | undefined;
    salesChannel: string | undefined;
    supervisorCode: string | undefined;
    supervisorName: string | undefined;
    phoneFirstDate: moment.Moment | undefined;
    lockUpdatePhone: boolean | undefined;
    browserCode: string | undefined;
    deviceNameCode: string | undefined;
    typeOfDeviceCode: string | undefined;
    salesmanCode: string | undefined;
    consumerID: number | undefined;
    lockUpdateChatID: boolean | undefined;
    currentCoin: number | undefined;
    pointToKeepRank: number | undefined;
    pointToNextRank: number | undefined;
    expiringCoin: number | undefined;
    expiringCoinDate: moment.Moment | undefined;
    lockUpdateProfile: boolean | undefined;
    outletType: string | undefined;
    password: string | undefined;
    userNameOrEmailAddress: string | undefined;
    warehouseAddress: string | undefined;
    businessType: string | undefined;
    accumulationPointSellIn: number | undefined;
    accumulationPointSellOut: number | undefined;
    sapCode: string | undefined;
    bankAccountNumber: string | undefined;
    bankAccountName: string | undefined;
    bankName: string | undefined;
    bankBranchName: string | undefined;
    bossName: string | undefined;
    anniversaryDate: moment.Moment | undefined;
    taxCode: string | undefined;
    identificationCardNumber: string | undefined;
    identificationCardFrontImage: string | undefined;
    identificationCardBackImage: string | undefined;
    accountCode: string | undefined;
    referrerCode: string | undefined;
    communicationChannels: SocialMemberChannelInfo[] | undefined;
    chatId: string | undefined;
    salesmanName: string | undefined;
    salesmanPhone: string | undefined;
    lastModificationTime: moment.Moment | undefined;
    rankName: string | undefined;
    organizationUnits: number[] | undefined;
    businessCertification: string | undefined;
    businessCertificationback: string | undefined;
    provinceName: string | undefined;
    districtName: string | undefined;
    legalPersonalName: string | undefined;
    legalPersonal: string | undefined;
    taxAddress: string | undefined;
    createdFrom: string | undefined;
    verifyStatus: string | undefined;
    storeArea: number | undefined;
    employeeQuantity: number | undefined;
    requestCode: string | undefined;
    storeType: string | undefined;
    deptCode: string | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfGetUploadedInvoiceForViewDto implements IPagedResultDtoOfGetUploadedInvoiceForViewDto {
    totalCount!: number | undefined;
    items!: GetUploadedInvoiceForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetUploadedInvoiceForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetUploadedInvoiceForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetUploadedInvoiceForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetUploadedInvoiceForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetUploadedInvoiceForViewDto {
    totalCount: number | undefined;
    items: GetUploadedInvoiceForViewDto[] | undefined;
}

export class GetUploadedInvoiceForViewDto implements IGetUploadedInvoiceForViewDto {
    uploadedInvoice!: UploadedInvoiceDto | undefined;

    constructor(data?: IGetUploadedInvoiceForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.uploadedInvoice = data["uploadedInvoice"] ? UploadedInvoiceDto.fromJS(data["uploadedInvoice"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetUploadedInvoiceForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetUploadedInvoiceForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uploadedInvoice"] = this.uploadedInvoice ? this.uploadedInvoice.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetUploadedInvoiceForViewDto {
    uploadedInvoice: UploadedInvoiceDto | undefined;
}

export class UploadedInvoiceDto implements IUploadedInvoiceDto {
    chatID!: string | undefined;
    memberCode!: string | undefined;
    phone!: string | undefined;
    postingDate!: moment.Moment | undefined;
    referenceID!: string | undefined;
    imageLink!: string | undefined;
    imageThumbnailLink!: string | undefined;
    ocrData!: string | undefined;
    status!: string | undefined;
    id!: number | undefined;

    constructor(data?: IUploadedInvoiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.chatID = data["chatID"];
            this.memberCode = data["memberCode"];
            this.phone = data["phone"];
            this.postingDate = data["postingDate"] ? moment(data["postingDate"].toString()) : <any>undefined;
            this.referenceID = data["referenceID"];
            this.imageLink = data["imageLink"];
            this.imageThumbnailLink = data["imageThumbnailLink"];
            this.ocrData = data["ocrData"];
            this.status = data["status"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): UploadedInvoiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new UploadedInvoiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["chatID"] = this.chatID;
        data["memberCode"] = this.memberCode;
        data["phone"] = this.phone;
        data["postingDate"] = this.postingDate ? this.postingDate.toISOString() : <any>undefined;
        data["referenceID"] = this.referenceID;
        data["imageLink"] = this.imageLink;
        data["imageThumbnailLink"] = this.imageThumbnailLink;
        data["ocrData"] = this.ocrData;
        data["status"] = this.status;
        data["id"] = this.id;
        return data;
    }
}

export interface IUploadedInvoiceDto {
    chatID: string | undefined;
    memberCode: string | undefined;
    phone: string | undefined;
    postingDate: moment.Moment | undefined;
    referenceID: string | undefined;
    imageLink: string | undefined;
    imageThumbnailLink: string | undefined;
    ocrData: string | undefined;
    status: string | undefined;
    id: number | undefined;
}

export class GetUploadedInvoiceForEditOutput implements IGetUploadedInvoiceForEditOutput {
    uploadedInvoice!: CreateOrEditUploadedInvoiceDto | undefined;

    constructor(data?: IGetUploadedInvoiceForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.uploadedInvoice = data["uploadedInvoice"] ? CreateOrEditUploadedInvoiceDto.fromJS(data["uploadedInvoice"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetUploadedInvoiceForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetUploadedInvoiceForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uploadedInvoice"] = this.uploadedInvoice ? this.uploadedInvoice.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetUploadedInvoiceForEditOutput {
    uploadedInvoice: CreateOrEditUploadedInvoiceDto | undefined;
}

export class CreateOrEditUploadedInvoiceDto implements ICreateOrEditUploadedInvoiceDto {
    chatID!: string | undefined;
    memberCode!: string | undefined;
    phone!: string | undefined;
    postingDate!: moment.Moment | undefined;
    referenceID!: string | undefined;
    imageLink!: string | undefined;
    imageThumbnailLink!: string | undefined;
    ocrData!: string | undefined;
    status!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditUploadedInvoiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.chatID = data["chatID"];
            this.memberCode = data["memberCode"];
            this.phone = data["phone"];
            this.postingDate = data["postingDate"] ? moment(data["postingDate"].toString()) : <any>undefined;
            this.referenceID = data["referenceID"];
            this.imageLink = data["imageLink"];
            this.imageThumbnailLink = data["imageThumbnailLink"];
            this.ocrData = data["ocrData"];
            this.status = data["status"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditUploadedInvoiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditUploadedInvoiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["chatID"] = this.chatID;
        data["memberCode"] = this.memberCode;
        data["phone"] = this.phone;
        data["postingDate"] = this.postingDate ? this.postingDate.toISOString() : <any>undefined;
        data["referenceID"] = this.referenceID;
        data["imageLink"] = this.imageLink;
        data["imageThumbnailLink"] = this.imageThumbnailLink;
        data["ocrData"] = this.ocrData;
        data["status"] = this.status;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditUploadedInvoiceDto {
    chatID: string | undefined;
    memberCode: string | undefined;
    phone: string | undefined;
    postingDate: moment.Moment | undefined;
    referenceID: string | undefined;
    imageLink: string | undefined;
    imageThumbnailLink: string | undefined;
    ocrData: string | undefined;
    status: string | undefined;
    id: number | undefined;
}

export class GMODataForEdit implements IGMODataForEdit {
    referenceID!: string | undefined;
    status!: string | undefined;
    checkSum!: string | undefined;

    constructor(data?: IGMODataForEdit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.referenceID = data["referenceID"];
            this.status = data["status"];
            this.checkSum = data["checkSum"];
        }
    }

    static fromJS(data: any): GMODataForEdit {
        data = typeof data === 'object' ? data : {};
        let result = new GMODataForEdit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["referenceID"] = this.referenceID;
        data["status"] = this.status;
        data["checkSum"] = this.checkSum;
        return data;
    }
}

export interface IGMODataForEdit {
    referenceID: string | undefined;
    status: string | undefined;
    checkSum: string | undefined;
}

export class HandleEventUserSendSOCodeDto implements IHandleEventUserSendSOCodeDto {
    memberCode!: string | undefined;
    soCode!: string | undefined;
    checkSum!: string | undefined;

    constructor(data?: IHandleEventUserSendSOCodeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberCode = data["memberCode"];
            this.soCode = data["soCode"];
            this.checkSum = data["checkSum"];
        }
    }

    static fromJS(data: any): HandleEventUserSendSOCodeDto {
        data = typeof data === 'object' ? data : {};
        let result = new HandleEventUserSendSOCodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberCode"] = this.memberCode;
        data["soCode"] = this.soCode;
        data["checkSum"] = this.checkSum;
        return data;
    }
}

export interface IHandleEventUserSendSOCodeDto {
    memberCode: string | undefined;
    soCode: string | undefined;
    checkSum: string | undefined;
}

export class PagedResultDtoOfUserListDto implements IPagedResultDtoOfUserListDto {
    totalCount!: number | undefined;
    items!: UserListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfUserListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(UserListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfUserListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfUserListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfUserListDto {
    totalCount: number | undefined;
    items: UserListDto[] | undefined;
}

export class UserListDto implements IUserListDto {
    name!: string | undefined;
    surname!: string | undefined;
    userName!: string | undefined;
    emailAddress!: string | undefined;
    phoneNumber!: string | undefined;
    profilePictureId!: string | undefined;
    isEmailConfirmed!: boolean | undefined;
    manageUser!: number | undefined;
    regionCode!: string | undefined;
    authorizationMicrosoft!: boolean | undefined;
    roles!: UserListRoleDto[] | undefined;
    lastLoginTime!: moment.Moment | undefined;
    isActive!: boolean | undefined;
    creationTime!: moment.Moment | undefined;
    id!: number | undefined;

    constructor(data?: IUserListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.surname = data["surname"];
            this.userName = data["userName"];
            this.emailAddress = data["emailAddress"];
            this.phoneNumber = data["phoneNumber"];
            this.profilePictureId = data["profilePictureId"];
            this.isEmailConfirmed = data["isEmailConfirmed"];
            this.manageUser = data["manageUser"];
            this.regionCode = data["regionCode"];
            this.authorizationMicrosoft = data["authorizationMicrosoft"];
            if (data["roles"] && data["roles"].constructor === Array) {
                this.roles = [];
                for (let item of data["roles"])
                    this.roles.push(UserListRoleDto.fromJS(item));
            }
            this.lastLoginTime = data["lastLoginTime"] ? moment(data["lastLoginTime"].toString()) : <any>undefined;
            this.isActive = data["isActive"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): UserListDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        data["profilePictureId"] = this.profilePictureId;
        data["isEmailConfirmed"] = this.isEmailConfirmed;
        data["manageUser"] = this.manageUser;
        data["regionCode"] = this.regionCode;
        data["authorizationMicrosoft"] = this.authorizationMicrosoft;
        if (this.roles && this.roles.constructor === Array) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        data["lastLoginTime"] = this.lastLoginTime ? this.lastLoginTime.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IUserListDto {
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    phoneNumber: string | undefined;
    profilePictureId: string | undefined;
    isEmailConfirmed: boolean | undefined;
    manageUser: number | undefined;
    regionCode: string | undefined;
    authorizationMicrosoft: boolean | undefined;
    roles: UserListRoleDto[] | undefined;
    lastLoginTime: moment.Moment | undefined;
    isActive: boolean | undefined;
    creationTime: moment.Moment | undefined;
    id: number | undefined;
}

export class UserListRoleDto implements IUserListRoleDto {
    roleId!: number | undefined;
    roleName!: string | undefined;

    constructor(data?: IUserListRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.roleId = data["roleId"];
            this.roleName = data["roleName"];
        }
    }

    static fromJS(data: any): UserListRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserListRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleId"] = this.roleId;
        data["roleName"] = this.roleName;
        return data;
    }
}

export interface IUserListRoleDto {
    roleId: number | undefined;
    roleName: string | undefined;
}

export class GetUserForEditOutput implements IGetUserForEditOutput {
    profilePictureId!: string | undefined;
    user!: UserEditDto | undefined;
    roles!: UserRoleDto[] | undefined;
    allOrganizationUnits!: OrganizationUnitDto[] | undefined;
    memberedOrganizationUnits!: string[] | undefined;
    timezone!: string | undefined;

    constructor(data?: IGetUserForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.profilePictureId = data["profilePictureId"];
            this.user = data["user"] ? UserEditDto.fromJS(data["user"]) : <any>undefined;
            if (data["roles"] && data["roles"].constructor === Array) {
                this.roles = [];
                for (let item of data["roles"])
                    this.roles.push(UserRoleDto.fromJS(item));
            }
            if (data["allOrganizationUnits"] && data["allOrganizationUnits"].constructor === Array) {
                this.allOrganizationUnits = [];
                for (let item of data["allOrganizationUnits"])
                    this.allOrganizationUnits.push(OrganizationUnitDto.fromJS(item));
            }
            if (data["memberedOrganizationUnits"] && data["memberedOrganizationUnits"].constructor === Array) {
                this.memberedOrganizationUnits = [];
                for (let item of data["memberedOrganizationUnits"])
                    this.memberedOrganizationUnits.push(item);
            }
            this.timezone = data["timezone"];
        }
    }

    static fromJS(data: any): GetUserForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profilePictureId"] = this.profilePictureId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        if (this.roles && this.roles.constructor === Array) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        if (this.allOrganizationUnits && this.allOrganizationUnits.constructor === Array) {
            data["allOrganizationUnits"] = [];
            for (let item of this.allOrganizationUnits)
                data["allOrganizationUnits"].push(item.toJSON());
        }
        if (this.memberedOrganizationUnits && this.memberedOrganizationUnits.constructor === Array) {
            data["memberedOrganizationUnits"] = [];
            for (let item of this.memberedOrganizationUnits)
                data["memberedOrganizationUnits"].push(item);
        }
        data["timezone"] = this.timezone;
        return data;
    }
}

export interface IGetUserForEditOutput {
    profilePictureId: string | undefined;
    user: UserEditDto | undefined;
    roles: UserRoleDto[] | undefined;
    allOrganizationUnits: OrganizationUnitDto[] | undefined;
    memberedOrganizationUnits: string[] | undefined;
    timezone: string | undefined;
}

export class UserEditDto implements IUserEditDto {
    id!: number | undefined;
    name!: string;
    surname!: string;
    userName!: string;
    emailAddress!: string;
    phoneNumber!: string | undefined;
    password!: string | undefined;
    isActive!: boolean | undefined;
    shouldChangePasswordOnNextLogin!: boolean | undefined;
    isTwoFactorEnabled!: boolean | undefined;
    isLockoutEnabled!: boolean | undefined;
    manageUser!: number | undefined;
    regionCode!: string | undefined;
    authorizationMicrosoft!: boolean | undefined;

    constructor(data?: IUserEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.surname = data["surname"];
            this.userName = data["userName"];
            this.emailAddress = data["emailAddress"];
            this.phoneNumber = data["phoneNumber"];
            this.password = data["password"];
            this.isActive = data["isActive"];
            this.shouldChangePasswordOnNextLogin = data["shouldChangePasswordOnNextLogin"];
            this.isTwoFactorEnabled = data["isTwoFactorEnabled"];
            this.isLockoutEnabled = data["isLockoutEnabled"];
            this.manageUser = data["manageUser"];
            this.regionCode = data["regionCode"];
            this.authorizationMicrosoft = data["authorizationMicrosoft"];
        }
    }

    static fromJS(data: any): UserEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        data["password"] = this.password;
        data["isActive"] = this.isActive;
        data["shouldChangePasswordOnNextLogin"] = this.shouldChangePasswordOnNextLogin;
        data["isTwoFactorEnabled"] = this.isTwoFactorEnabled;
        data["isLockoutEnabled"] = this.isLockoutEnabled;
        data["manageUser"] = this.manageUser;
        data["regionCode"] = this.regionCode;
        data["authorizationMicrosoft"] = this.authorizationMicrosoft;
        return data;
    }
}

export interface IUserEditDto {
    id: number | undefined;
    name: string;
    surname: string;
    userName: string;
    emailAddress: string;
    phoneNumber: string | undefined;
    password: string | undefined;
    isActive: boolean | undefined;
    shouldChangePasswordOnNextLogin: boolean | undefined;
    isTwoFactorEnabled: boolean | undefined;
    isLockoutEnabled: boolean | undefined;
    manageUser: number | undefined;
    regionCode: string | undefined;
    authorizationMicrosoft: boolean | undefined;
}

export class UserRoleDto implements IUserRoleDto {
    roleId!: number | undefined;
    roleName!: string | undefined;
    roleDisplayName!: string | undefined;
    isAssigned!: boolean | undefined;

    constructor(data?: IUserRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.roleId = data["roleId"];
            this.roleName = data["roleName"];
            this.roleDisplayName = data["roleDisplayName"];
            this.isAssigned = data["isAssigned"];
        }
    }

    static fromJS(data: any): UserRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleId"] = this.roleId;
        data["roleName"] = this.roleName;
        data["roleDisplayName"] = this.roleDisplayName;
        data["isAssigned"] = this.isAssigned;
        return data;
    }
}

export interface IUserRoleDto {
    roleId: number | undefined;
    roleName: string | undefined;
    roleDisplayName: string | undefined;
    isAssigned: boolean | undefined;
}

export class GetUserPermissionsForEditOutput implements IGetUserPermissionsForEditOutput {
    permissions!: FlatPermissionDto[] | undefined;
    grantedPermissionNames!: string[] | undefined;

    constructor(data?: IGetUserPermissionsForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["permissions"] && data["permissions"].constructor === Array) {
                this.permissions = [];
                for (let item of data["permissions"])
                    this.permissions.push(FlatPermissionDto.fromJS(item));
            }
            if (data["grantedPermissionNames"] && data["grantedPermissionNames"].constructor === Array) {
                this.grantedPermissionNames = [];
                for (let item of data["grantedPermissionNames"])
                    this.grantedPermissionNames.push(item);
            }
        }
    }

    static fromJS(data: any): GetUserPermissionsForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserPermissionsForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.permissions && this.permissions.constructor === Array) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item.toJSON());
        }
        if (this.grantedPermissionNames && this.grantedPermissionNames.constructor === Array) {
            data["grantedPermissionNames"] = [];
            for (let item of this.grantedPermissionNames)
                data["grantedPermissionNames"].push(item);
        }
        return data;
    }
}

export interface IGetUserPermissionsForEditOutput {
    permissions: FlatPermissionDto[] | undefined;
    grantedPermissionNames: string[] | undefined;
}

export class GetUserPermissionsViewOnlyOutput implements IGetUserPermissionsViewOnlyOutput {
    grantedPermissionNames!: string[] | undefined;

    constructor(data?: IGetUserPermissionsViewOnlyOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["grantedPermissionNames"] && data["grantedPermissionNames"].constructor === Array) {
                this.grantedPermissionNames = [];
                for (let item of data["grantedPermissionNames"])
                    this.grantedPermissionNames.push(item);
            }
        }
    }

    static fromJS(data: any): GetUserPermissionsViewOnlyOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserPermissionsViewOnlyOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.grantedPermissionNames && this.grantedPermissionNames.constructor === Array) {
            data["grantedPermissionNames"] = [];
            for (let item of this.grantedPermissionNames)
                data["grantedPermissionNames"].push(item);
        }
        return data;
    }
}

export interface IGetUserPermissionsViewOnlyOutput {
    grantedPermissionNames: string[] | undefined;
}

export class EntityDtoOfInt64 implements IEntityDtoOfInt64 {
    id!: number | undefined;

    constructor(data?: IEntityDtoOfInt64) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EntityDtoOfInt64 {
        data = typeof data === 'object' ? data : {};
        let result = new EntityDtoOfInt64();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IEntityDtoOfInt64 {
    id: number | undefined;
}

export class UpdateUserPermissionsInput implements IUpdateUserPermissionsInput {
    id!: number | undefined;
    grantedPermissionNames!: string[];

    constructor(data?: IUpdateUserPermissionsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.grantedPermissionNames = [];
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            if (data["grantedPermissionNames"] && data["grantedPermissionNames"].constructor === Array) {
                this.grantedPermissionNames = [];
                for (let item of data["grantedPermissionNames"])
                    this.grantedPermissionNames.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateUserPermissionsInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserPermissionsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (this.grantedPermissionNames && this.grantedPermissionNames.constructor === Array) {
            data["grantedPermissionNames"] = [];
            for (let item of this.grantedPermissionNames)
                data["grantedPermissionNames"].push(item);
        }
        return data;
    }
}

export interface IUpdateUserPermissionsInput {
    id: number | undefined;
    grantedPermissionNames: string[];
}

export class CreateOrUpdateUserInput implements ICreateOrUpdateUserInput {
    user!: UserEditDto;
    assignedRoleNames!: string[];
    sendActivationEmail!: boolean | undefined;
    setRandomPassword!: boolean | undefined;
    organizationUnits!: number[] | undefined;
    timezone!: string | undefined;

    constructor(data?: ICreateOrUpdateUserInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.user = new UserEditDto();
            this.assignedRoleNames = [];
        }
    }

    init(data?: any) {
        if (data) {
            this.user = data["user"] ? UserEditDto.fromJS(data["user"]) : new UserEditDto();
            if (data["assignedRoleNames"] && data["assignedRoleNames"].constructor === Array) {
                this.assignedRoleNames = [];
                for (let item of data["assignedRoleNames"])
                    this.assignedRoleNames.push(item);
            }
            this.sendActivationEmail = data["sendActivationEmail"];
            this.setRandomPassword = data["setRandomPassword"];
            if (data["organizationUnits"] && data["organizationUnits"].constructor === Array) {
                this.organizationUnits = [];
                for (let item of data["organizationUnits"])
                    this.organizationUnits.push(item);
            }
            this.timezone = data["timezone"];
        }
    }

    static fromJS(data: any): CreateOrUpdateUserInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateUserInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        if (this.assignedRoleNames && this.assignedRoleNames.constructor === Array) {
            data["assignedRoleNames"] = [];
            for (let item of this.assignedRoleNames)
                data["assignedRoleNames"].push(item);
        }
        data["sendActivationEmail"] = this.sendActivationEmail;
        data["setRandomPassword"] = this.setRandomPassword;
        if (this.organizationUnits && this.organizationUnits.constructor === Array) {
            data["organizationUnits"] = [];
            for (let item of this.organizationUnits)
                data["organizationUnits"].push(item);
        }
        data["timezone"] = this.timezone;
        return data;
    }
}

export interface ICreateOrUpdateUserInput {
    user: UserEditDto;
    assignedRoleNames: string[];
    sendActivationEmail: boolean | undefined;
    setRandomPassword: boolean | undefined;
    organizationUnits: number[] | undefined;
    timezone: string | undefined;
}

export class LinkToUserInput implements ILinkToUserInput {
    tenancyName!: string | undefined;
    usernameOrEmailAddress!: string;
    password!: string;

    constructor(data?: ILinkToUserInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenancyName = data["tenancyName"];
            this.usernameOrEmailAddress = data["usernameOrEmailAddress"];
            this.password = data["password"];
        }
    }

    static fromJS(data: any): LinkToUserInput {
        data = typeof data === 'object' ? data : {};
        let result = new LinkToUserInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["usernameOrEmailAddress"] = this.usernameOrEmailAddress;
        data["password"] = this.password;
        return data;
    }
}

export interface ILinkToUserInput {
    tenancyName: string | undefined;
    usernameOrEmailAddress: string;
    password: string;
}

export class PagedResultDtoOfLinkedUserDto implements IPagedResultDtoOfLinkedUserDto {
    totalCount!: number | undefined;
    items!: LinkedUserDto[] | undefined;

    constructor(data?: IPagedResultDtoOfLinkedUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(LinkedUserDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfLinkedUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfLinkedUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfLinkedUserDto {
    totalCount: number | undefined;
    items: LinkedUserDto[] | undefined;
}

export class LinkedUserDto implements ILinkedUserDto {
    tenantId!: number | undefined;
    tenancyName!: string | undefined;
    username!: string | undefined;
    lastLoginTime!: moment.Moment | undefined;
    id!: number | undefined;

    constructor(data?: ILinkedUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.tenancyName = data["tenancyName"];
            this.username = data["username"];
            this.lastLoginTime = data["lastLoginTime"] ? moment(data["lastLoginTime"].toString()) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): LinkedUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new LinkedUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["tenancyName"] = this.tenancyName;
        data["username"] = this.username;
        data["lastLoginTime"] = this.lastLoginTime ? this.lastLoginTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface ILinkedUserDto {
    tenantId: number | undefined;
    tenancyName: string | undefined;
    username: string | undefined;
    lastLoginTime: moment.Moment | undefined;
    id: number | undefined;
}

export class ListResultDtoOfLinkedUserDto implements IListResultDtoOfLinkedUserDto {
    items!: LinkedUserDto[] | undefined;

    constructor(data?: IListResultDtoOfLinkedUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(LinkedUserDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfLinkedUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfLinkedUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListResultDtoOfLinkedUserDto {
    items: LinkedUserDto[] | undefined;
}

export class UnlinkUserInput implements IUnlinkUserInput {
    tenantId!: number | undefined;
    userId!: number | undefined;

    constructor(data?: IUnlinkUserInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.userId = data["userId"];
        }
    }

    static fromJS(data: any): UnlinkUserInput {
        data = typeof data === 'object' ? data : {};
        let result = new UnlinkUserInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        return data;
    }
}

export interface IUnlinkUserInput {
    tenantId: number | undefined;
    userId: number | undefined;
}

export class ListResultDtoOfUserLoginAttemptDto implements IListResultDtoOfUserLoginAttemptDto {
    items!: UserLoginAttemptDto[] | undefined;

    constructor(data?: IListResultDtoOfUserLoginAttemptDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(UserLoginAttemptDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfUserLoginAttemptDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfUserLoginAttemptDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListResultDtoOfUserLoginAttemptDto {
    items: UserLoginAttemptDto[] | undefined;
}

export class UserLoginAttemptDto implements IUserLoginAttemptDto {
    tenancyName!: string | undefined;
    userNameOrEmail!: string | undefined;
    clientIpAddress!: string | undefined;
    clientName!: string | undefined;
    browserInfo!: string | undefined;
    result!: string | undefined;
    creationTime!: moment.Moment | undefined;

    constructor(data?: IUserLoginAttemptDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenancyName = data["tenancyName"];
            this.userNameOrEmail = data["userNameOrEmail"];
            this.clientIpAddress = data["clientIpAddress"];
            this.clientName = data["clientName"];
            this.browserInfo = data["browserInfo"];
            this.result = data["result"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UserLoginAttemptDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserLoginAttemptDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["userNameOrEmail"] = this.userNameOrEmail;
        data["clientIpAddress"] = this.clientIpAddress;
        data["clientName"] = this.clientName;
        data["browserInfo"] = this.browserInfo;
        data["result"] = this.result;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IUserLoginAttemptDto {
    tenancyName: string | undefined;
    userNameOrEmail: string | undefined;
    clientIpAddress: string | undefined;
    clientName: string | undefined;
    browserInfo: string | undefined;
    result: string | undefined;
    creationTime: moment.Moment | undefined;
}

export class PagedResultDtoOfGetUserLoginForViewDto implements IPagedResultDtoOfGetUserLoginForViewDto {
    totalCount!: number | undefined;
    items!: GetUserLoginForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetUserLoginForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetUserLoginForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetUserLoginForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetUserLoginForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetUserLoginForViewDto {
    totalCount: number | undefined;
    items: GetUserLoginForViewDto[] | undefined;
}

export class GetUserLoginForViewDto implements IGetUserLoginForViewDto {
    userLogin!: UserLoginDto | undefined;

    constructor(data?: IGetUserLoginForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userLogin = data["userLogin"] ? UserLoginDto.fromJS(data["userLogin"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetUserLoginForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserLoginForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userLogin"] = this.userLogin ? this.userLogin.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetUserLoginForViewDto {
    userLogin: UserLoginDto | undefined;
}

export class UserLoginDto implements IUserLoginDto {
    memberCode!: string | undefined;
    name!: string | undefined;
    phone!: string | undefined;
    email!: string | undefined;
    facebookID!: string | undefined;
    googleID!: string | undefined;
    id!: number | undefined;

    constructor(data?: IUserLoginDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberCode = data["memberCode"];
            this.name = data["name"];
            this.phone = data["phone"];
            this.email = data["email"];
            this.facebookID = data["facebookID"];
            this.googleID = data["googleID"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): UserLoginDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserLoginDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberCode"] = this.memberCode;
        data["name"] = this.name;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["facebookID"] = this.facebookID;
        data["googleID"] = this.googleID;
        data["id"] = this.id;
        return data;
    }
}

export interface IUserLoginDto {
    memberCode: string | undefined;
    name: string | undefined;
    phone: string | undefined;
    email: string | undefined;
    facebookID: string | undefined;
    googleID: string | undefined;
    id: number | undefined;
}

export class GetUserLoginForEditOutput implements IGetUserLoginForEditOutput {
    userLogin!: CreateOrEditUserLoginDto | undefined;

    constructor(data?: IGetUserLoginForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userLogin = data["userLogin"] ? CreateOrEditUserLoginDto.fromJS(data["userLogin"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetUserLoginForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserLoginForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userLogin"] = this.userLogin ? this.userLogin.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetUserLoginForEditOutput {
    userLogin: CreateOrEditUserLoginDto | undefined;
}

export class CreateOrEditUserLoginDto implements ICreateOrEditUserLoginDto {
    memberCode!: string | undefined;
    name!: string | undefined;
    phone!: string | undefined;
    email!: string | undefined;
    facebookID!: string | undefined;
    googleID!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditUserLoginDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberCode = data["memberCode"];
            this.name = data["name"];
            this.phone = data["phone"];
            this.email = data["email"];
            this.facebookID = data["facebookID"];
            this.googleID = data["googleID"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditUserLoginDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditUserLoginDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberCode"] = this.memberCode;
        data["name"] = this.name;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["facebookID"] = this.facebookID;
        data["googleID"] = this.googleID;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditUserLoginDto {
    memberCode: string | undefined;
    name: string | undefined;
    phone: string | undefined;
    email: string | undefined;
    facebookID: string | undefined;
    googleID: string | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfGetUserSessionTrackingForViewDto implements IPagedResultDtoOfGetUserSessionTrackingForViewDto {
    totalCount!: number | undefined;
    items!: GetUserSessionTrackingForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetUserSessionTrackingForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetUserSessionTrackingForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetUserSessionTrackingForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetUserSessionTrackingForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetUserSessionTrackingForViewDto {
    totalCount: number | undefined;
    items: GetUserSessionTrackingForViewDto[] | undefined;
}

export class GetUserSessionTrackingForViewDto implements IGetUserSessionTrackingForViewDto {
    userSessionTracking!: UserSessionTrackingDto | undefined;

    constructor(data?: IGetUserSessionTrackingForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userSessionTracking = data["userSessionTracking"] ? UserSessionTrackingDto.fromJS(data["userSessionTracking"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetUserSessionTrackingForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserSessionTrackingForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userSessionTracking"] = this.userSessionTracking ? this.userSessionTracking.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetUserSessionTrackingForViewDto {
    userSessionTracking: UserSessionTrackingDto | undefined;
}

export class UserSessionTrackingDto implements IUserSessionTrackingDto {
    userName!: string | undefined;
    startTime!: moment.Moment | undefined;
    endTime!: moment.Moment | undefined;
    terminalCode!: string | undefined;
    terminalName!: string | undefined;
    id!: number | undefined;

    constructor(data?: IUserSessionTrackingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userName = data["userName"];
            this.startTime = data["startTime"] ? moment(data["startTime"].toString()) : <any>undefined;
            this.endTime = data["endTime"] ? moment(data["endTime"].toString()) : <any>undefined;
            this.terminalCode = data["terminalCode"];
            this.terminalName = data["terminalName"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): UserSessionTrackingDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserSessionTrackingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["terminalCode"] = this.terminalCode;
        data["terminalName"] = this.terminalName;
        data["id"] = this.id;
        return data;
    }
}

export interface IUserSessionTrackingDto {
    userName: string | undefined;
    startTime: moment.Moment | undefined;
    endTime: moment.Moment | undefined;
    terminalCode: string | undefined;
    terminalName: string | undefined;
    id: number | undefined;
}

export class GetUserSessionTrackingForEditOutput implements IGetUserSessionTrackingForEditOutput {
    userSessionTracking!: CreateOrEditUserSessionTrackingDto | undefined;

    constructor(data?: IGetUserSessionTrackingForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userSessionTracking = data["userSessionTracking"] ? CreateOrEditUserSessionTrackingDto.fromJS(data["userSessionTracking"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetUserSessionTrackingForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserSessionTrackingForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userSessionTracking"] = this.userSessionTracking ? this.userSessionTracking.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetUserSessionTrackingForEditOutput {
    userSessionTracking: CreateOrEditUserSessionTrackingDto | undefined;
}

export class CreateOrEditUserSessionTrackingDto implements ICreateOrEditUserSessionTrackingDto {
    userName!: string | undefined;
    startTime!: moment.Moment | undefined;
    endTime!: moment.Moment | undefined;
    terminalCode!: string | undefined;
    terminalName!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditUserSessionTrackingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userName = data["userName"];
            this.startTime = data["startTime"] ? moment(data["startTime"].toString()) : <any>undefined;
            this.endTime = data["endTime"] ? moment(data["endTime"].toString()) : <any>undefined;
            this.terminalCode = data["terminalCode"];
            this.terminalName = data["terminalName"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditUserSessionTrackingDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditUserSessionTrackingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["terminalCode"] = this.terminalCode;
        data["terminalName"] = this.terminalName;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditUserSessionTrackingDto {
    userName: string | undefined;
    startTime: moment.Moment | undefined;
    endTime: moment.Moment | undefined;
    terminalCode: string | undefined;
    terminalName: string | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfGetVendorSettingForViewDto implements IPagedResultDtoOfGetVendorSettingForViewDto {
    totalCount!: number | undefined;
    items!: GetVendorSettingForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetVendorSettingForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetVendorSettingForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetVendorSettingForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetVendorSettingForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetVendorSettingForViewDto {
    totalCount: number | undefined;
    items: GetVendorSettingForViewDto[] | undefined;
}

export class GetVendorSettingForViewDto implements IGetVendorSettingForViewDto {
    vendorSetting!: VendorSettingDto | undefined;

    constructor(data?: IGetVendorSettingForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.vendorSetting = data["vendorSetting"] ? VendorSettingDto.fromJS(data["vendorSetting"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetVendorSettingForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetVendorSettingForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vendorSetting"] = this.vendorSetting ? this.vendorSetting.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetVendorSettingForViewDto {
    vendorSetting: VendorSettingDto | undefined;
}

export class VendorSettingDto implements IVendorSettingDto {
    code!: string | undefined;
    name!: string | undefined;
    description!: string | undefined;
    apiLink!: string | undefined;
    tokenKey!: string | undefined;
    status!: string | undefined;
    vendorType!: string | undefined;
    apiVersion!: string | undefined;
    extraData!: string | undefined;
    id!: number | undefined;

    constructor(data?: IVendorSettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.name = data["name"];
            this.description = data["description"];
            this.apiLink = data["apiLink"];
            this.tokenKey = data["tokenKey"];
            this.status = data["status"];
            this.vendorType = data["vendorType"];
            this.apiVersion = data["apiVersion"];
            this.extraData = data["extraData"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): VendorSettingDto {
        data = typeof data === 'object' ? data : {};
        let result = new VendorSettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["description"] = this.description;
        data["apiLink"] = this.apiLink;
        data["tokenKey"] = this.tokenKey;
        data["status"] = this.status;
        data["vendorType"] = this.vendorType;
        data["apiVersion"] = this.apiVersion;
        data["extraData"] = this.extraData;
        data["id"] = this.id;
        return data;
    }
}

export interface IVendorSettingDto {
    code: string | undefined;
    name: string | undefined;
    description: string | undefined;
    apiLink: string | undefined;
    tokenKey: string | undefined;
    status: string | undefined;
    vendorType: string | undefined;
    apiVersion: string | undefined;
    extraData: string | undefined;
    id: number | undefined;
}

export class GetVendorSettingForEditOutput implements IGetVendorSettingForEditOutput {
    vendorSetting!: CreateOrEditVendorSettingDto | undefined;

    constructor(data?: IGetVendorSettingForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.vendorSetting = data["vendorSetting"] ? CreateOrEditVendorSettingDto.fromJS(data["vendorSetting"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetVendorSettingForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetVendorSettingForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vendorSetting"] = this.vendorSetting ? this.vendorSetting.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetVendorSettingForEditOutput {
    vendorSetting: CreateOrEditVendorSettingDto | undefined;
}

export class CreateOrEditVendorSettingDto implements ICreateOrEditVendorSettingDto {
    code!: string;
    name!: string | undefined;
    description!: string | undefined;
    apiLink!: string | undefined;
    tokenKey!: string | undefined;
    status!: string | undefined;
    vendorType!: string | undefined;
    apiVersion!: string | undefined;
    extraData!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditVendorSettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.name = data["name"];
            this.description = data["description"];
            this.apiLink = data["apiLink"];
            this.tokenKey = data["tokenKey"];
            this.status = data["status"];
            this.vendorType = data["vendorType"];
            this.apiVersion = data["apiVersion"];
            this.extraData = data["extraData"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditVendorSettingDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditVendorSettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["description"] = this.description;
        data["apiLink"] = this.apiLink;
        data["tokenKey"] = this.tokenKey;
        data["status"] = this.status;
        data["vendorType"] = this.vendorType;
        data["apiVersion"] = this.apiVersion;
        data["extraData"] = this.extraData;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditVendorSettingDto {
    code: string;
    name: string | undefined;
    description: string | undefined;
    apiLink: string | undefined;
    tokenKey: string | undefined;
    status: string | undefined;
    vendorType: string | undefined;
    apiVersion: string | undefined;
    extraData: string | undefined;
    id: number | undefined;
}

export class MessageResultVendorSetting implements IMessageResultVendorSetting {
    isSuccess!: boolean | undefined;
    errors!: MessageErrorVendorSetting[] | undefined;

    constructor(data?: IMessageResultVendorSetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isSuccess = data["isSuccess"];
            if (data["errors"] && data["errors"].constructor === Array) {
                this.errors = [];
                for (let item of data["errors"])
                    this.errors.push(MessageErrorVendorSetting.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MessageResultVendorSetting {
        data = typeof data === 'object' ? data : {};
        let result = new MessageResultVendorSetting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        if (this.errors && this.errors.constructor === Array) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMessageResultVendorSetting {
    isSuccess: boolean | undefined;
    errors: MessageErrorVendorSetting[] | undefined;
}

export class MessageErrorVendorSetting implements IMessageErrorVendorSetting {
    message!: string | undefined;
    propertyName!: string | undefined;
    count!: number | undefined;

    constructor(data?: IMessageErrorVendorSetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.message = data["message"];
            this.propertyName = data["propertyName"];
            this.count = data["count"];
        }
    }

    static fromJS(data: any): MessageErrorVendorSetting {
        data = typeof data === 'object' ? data : {};
        let result = new MessageErrorVendorSetting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["propertyName"] = this.propertyName;
        data["count"] = this.count;
        return data;
    }
}

export interface IMessageErrorVendorSetting {
    message: string | undefined;
    propertyName: string | undefined;
    count: number | undefined;
}

export class PagedResultDtoOfGetVideoForViewDto implements IPagedResultDtoOfGetVideoForViewDto {
    totalCount!: number | undefined;
    items!: GetVideoForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetVideoForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetVideoForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetVideoForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetVideoForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetVideoForViewDto {
    totalCount: number | undefined;
    items: GetVideoForViewDto[] | undefined;
}

export class GetVideoForViewDto implements IGetVideoForViewDto {
    video!: VideoDto | undefined;

    constructor(data?: IGetVideoForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.video = data["video"] ? VideoDto.fromJS(data["video"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetVideoForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetVideoForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["video"] = this.video ? this.video.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetVideoForViewDto {
    video: VideoDto | undefined;
}

export class VideoDto implements IVideoDto {
    code!: string | undefined;
    nameVN!: string | undefined;
    nameEN!: string | undefined;
    descriptionVN!: string | undefined;
    descriptionEN!: string | undefined;
    videoLink!: string | undefined;
    avatar!: string | undefined;
    linkAvatar!: string | undefined;
    status!: string | undefined;
    fromDate!: moment.Moment | undefined;
    toDate!: moment.Moment | undefined;
    tags!: string | undefined;
    isOnApp!: boolean | undefined;
    ordinal!: number | undefined;
    lastUpdateByName!: string | undefined;
    lastModifierUserId!: number | undefined;
    lastModificationTime!: moment.Moment | undefined;
    id!: number | undefined;

    constructor(data?: IVideoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.nameVN = data["nameVN"];
            this.nameEN = data["nameEN"];
            this.descriptionVN = data["descriptionVN"];
            this.descriptionEN = data["descriptionEN"];
            this.videoLink = data["videoLink"];
            this.avatar = data["avatar"];
            this.linkAvatar = data["linkAvatar"];
            this.status = data["status"];
            this.fromDate = data["fromDate"] ? moment(data["fromDate"].toString()) : <any>undefined;
            this.toDate = data["toDate"] ? moment(data["toDate"].toString()) : <any>undefined;
            this.tags = data["tags"];
            this.isOnApp = data["isOnApp"];
            this.ordinal = data["ordinal"];
            this.lastUpdateByName = data["lastUpdateByName"];
            this.lastModifierUserId = data["lastModifierUserId"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): VideoDto {
        data = typeof data === 'object' ? data : {};
        let result = new VideoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["nameVN"] = this.nameVN;
        data["nameEN"] = this.nameEN;
        data["descriptionVN"] = this.descriptionVN;
        data["descriptionEN"] = this.descriptionEN;
        data["videoLink"] = this.videoLink;
        data["avatar"] = this.avatar;
        data["linkAvatar"] = this.linkAvatar;
        data["status"] = this.status;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data["tags"] = this.tags;
        data["isOnApp"] = this.isOnApp;
        data["ordinal"] = this.ordinal;
        data["lastUpdateByName"] = this.lastUpdateByName;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IVideoDto {
    code: string | undefined;
    nameVN: string | undefined;
    nameEN: string | undefined;
    descriptionVN: string | undefined;
    descriptionEN: string | undefined;
    videoLink: string | undefined;
    avatar: string | undefined;
    linkAvatar: string | undefined;
    status: string | undefined;
    fromDate: moment.Moment | undefined;
    toDate: moment.Moment | undefined;
    tags: string | undefined;
    isOnApp: boolean | undefined;
    ordinal: number | undefined;
    lastUpdateByName: string | undefined;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    id: number | undefined;
}

export class GetVideoForEditOutput implements IGetVideoForEditOutput {
    video!: CreateOrEditVideoDto | undefined;

    constructor(data?: IGetVideoForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.video = data["video"] ? CreateOrEditVideoDto.fromJS(data["video"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetVideoForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetVideoForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["video"] = this.video ? this.video.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetVideoForEditOutput {
    video: CreateOrEditVideoDto | undefined;
}

export class CreateOrEditVideoDto implements ICreateOrEditVideoDto {
    code!: string | undefined;
    nameVN!: string | undefined;
    nameEN!: string | undefined;
    descriptionVN!: string | undefined;
    descriptionEN!: string | undefined;
    videoLink!: string | undefined;
    avatar!: string | undefined;
    linkAvatar!: string | undefined;
    status!: string | undefined;
    fromDate!: moment.Moment | undefined;
    toDate!: moment.Moment | undefined;
    tags!: string | undefined;
    isOnApp!: boolean | undefined;
    ordinal!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditVideoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.nameVN = data["nameVN"];
            this.nameEN = data["nameEN"];
            this.descriptionVN = data["descriptionVN"];
            this.descriptionEN = data["descriptionEN"];
            this.videoLink = data["videoLink"];
            this.avatar = data["avatar"];
            this.linkAvatar = data["linkAvatar"];
            this.status = data["status"];
            this.fromDate = data["fromDate"] ? moment(data["fromDate"].toString()) : <any>undefined;
            this.toDate = data["toDate"] ? moment(data["toDate"].toString()) : <any>undefined;
            this.tags = data["tags"];
            this.isOnApp = data["isOnApp"];
            this.ordinal = data["ordinal"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditVideoDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditVideoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["nameVN"] = this.nameVN;
        data["nameEN"] = this.nameEN;
        data["descriptionVN"] = this.descriptionVN;
        data["descriptionEN"] = this.descriptionEN;
        data["videoLink"] = this.videoLink;
        data["avatar"] = this.avatar;
        data["linkAvatar"] = this.linkAvatar;
        data["status"] = this.status;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data["tags"] = this.tags;
        data["isOnApp"] = this.isOnApp;
        data["ordinal"] = this.ordinal;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditVideoDto {
    code: string | undefined;
    nameVN: string | undefined;
    nameEN: string | undefined;
    descriptionVN: string | undefined;
    descriptionEN: string | undefined;
    videoLink: string | undefined;
    avatar: string | undefined;
    linkAvatar: string | undefined;
    status: string | undefined;
    fromDate: moment.Moment | undefined;
    toDate: moment.Moment | undefined;
    tags: string | undefined;
    isOnApp: boolean | undefined;
    ordinal: number | undefined;
    id: number | undefined;
}

export class DeleteVideoDto implements IDeleteVideoDto {
    ids!: number[] | undefined;

    constructor(data?: IDeleteVideoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["ids"] && data["ids"].constructor === Array) {
                this.ids = [];
                for (let item of data["ids"])
                    this.ids.push(item);
            }
        }
    }

    static fromJS(data: any): DeleteVideoDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteVideoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.ids && this.ids.constructor === Array) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        return data;
    }
}

export interface IDeleteVideoDto {
    ids: number[] | undefined;
}

export class PagedResultDtoOfGetAllVideosViewDto implements IPagedResultDtoOfGetAllVideosViewDto {
    totalCount!: number | undefined;
    items!: GetAllVideosViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetAllVideosViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetAllVideosViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetAllVideosViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetAllVideosViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetAllVideosViewDto {
    totalCount: number | undefined;
    items: GetAllVideosViewDto[] | undefined;
}

export class GetAllVideosViewDto implements IGetAllVideosViewDto {
    video!: GetAllVideosDto | undefined;

    constructor(data?: IGetAllVideosViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.video = data["video"] ? GetAllVideosDto.fromJS(data["video"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetAllVideosViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllVideosViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["video"] = this.video ? this.video.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetAllVideosViewDto {
    video: GetAllVideosDto | undefined;
}

export class GetAllVideosDto implements IGetAllVideosDto {
    videoCode!: string | undefined;
    videoNameVN!: string | undefined;
    videoNameEN!: string | undefined;
    linkVideo!: string | undefined;
    previewPicture!: string | undefined;
    tags!: string | undefined;

    constructor(data?: IGetAllVideosDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.videoCode = data["videoCode"];
            this.videoNameVN = data["videoNameVN"];
            this.videoNameEN = data["videoNameEN"];
            this.linkVideo = data["linkVideo"];
            this.previewPicture = data["previewPicture"];
            this.tags = data["tags"];
        }
    }

    static fromJS(data: any): GetAllVideosDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllVideosDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["videoCode"] = this.videoCode;
        data["videoNameVN"] = this.videoNameVN;
        data["videoNameEN"] = this.videoNameEN;
        data["linkVideo"] = this.linkVideo;
        data["previewPicture"] = this.previewPicture;
        data["tags"] = this.tags;
        return data;
    }
}

export interface IGetAllVideosDto {
    videoCode: string | undefined;
    videoNameVN: string | undefined;
    videoNameEN: string | undefined;
    linkVideo: string | undefined;
    previewPicture: string | undefined;
    tags: string | undefined;
}

export class PagedResultDtoOfGetVisitPlanDetailForViewDto implements IPagedResultDtoOfGetVisitPlanDetailForViewDto {
    totalCount!: number | undefined;
    items!: GetVisitPlanDetailForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetVisitPlanDetailForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetVisitPlanDetailForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetVisitPlanDetailForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetVisitPlanDetailForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetVisitPlanDetailForViewDto {
    totalCount: number | undefined;
    items: GetVisitPlanDetailForViewDto[] | undefined;
}

export class GetVisitPlanDetailForViewDto implements IGetVisitPlanDetailForViewDto {
    visitPlanDetail!: VisitPlanDetailDto | undefined;

    constructor(data?: IGetVisitPlanDetailForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.visitPlanDetail = data["visitPlanDetail"] ? VisitPlanDetailDto.fromJS(data["visitPlanDetail"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetVisitPlanDetailForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetVisitPlanDetailForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["visitPlanDetail"] = this.visitPlanDetail ? this.visitPlanDetail.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetVisitPlanDetailForViewDto {
    visitPlanDetail: VisitPlanDetailDto | undefined;
}

export class VisitPlanDetailDto implements IVisitPlanDetailDto {
    disT_CD!: string | undefined;
    slsmaN_CD!: string | undefined;
    cyclE_CD!: string | undefined;
    visiT_DT!: moment.Moment | undefined;
    cusT_CD!: string | undefined;
    visiT_WEEK!: number | undefined;
    duplicatE_IND!: string | undefined;
    upldW_STATUS!: string | undefined;
    svR_UPLDW_DT!: moment.Moment | undefined;
    version!: number | undefined;
    syncoperation!: string | undefined;
    syncversion!: moment.Moment | undefined;
    syncflag!: string | undefined;
    routE_CUST_SEQ!: number | undefined;
    actuaL_SEQ!: number | undefined;
    rS_IND!: string | undefined;
    id!: number | undefined;

    constructor(data?: IVisitPlanDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.disT_CD = data["disT_CD"];
            this.slsmaN_CD = data["slsmaN_CD"];
            this.cyclE_CD = data["cyclE_CD"];
            this.visiT_DT = data["visiT_DT"] ? moment(data["visiT_DT"].toString()) : <any>undefined;
            this.cusT_CD = data["cusT_CD"];
            this.visiT_WEEK = data["visiT_WEEK"];
            this.duplicatE_IND = data["duplicatE_IND"];
            this.upldW_STATUS = data["upldW_STATUS"];
            this.svR_UPLDW_DT = data["svR_UPLDW_DT"] ? moment(data["svR_UPLDW_DT"].toString()) : <any>undefined;
            this.version = data["version"];
            this.syncoperation = data["syncoperation"];
            this.syncversion = data["syncversion"] ? moment(data["syncversion"].toString()) : <any>undefined;
            this.syncflag = data["syncflag"];
            this.routE_CUST_SEQ = data["routE_CUST_SEQ"];
            this.actuaL_SEQ = data["actuaL_SEQ"];
            this.rS_IND = data["rS_IND"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): VisitPlanDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new VisitPlanDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["disT_CD"] = this.disT_CD;
        data["slsmaN_CD"] = this.slsmaN_CD;
        data["cyclE_CD"] = this.cyclE_CD;
        data["visiT_DT"] = this.visiT_DT ? this.visiT_DT.toISOString() : <any>undefined;
        data["cusT_CD"] = this.cusT_CD;
        data["visiT_WEEK"] = this.visiT_WEEK;
        data["duplicatE_IND"] = this.duplicatE_IND;
        data["upldW_STATUS"] = this.upldW_STATUS;
        data["svR_UPLDW_DT"] = this.svR_UPLDW_DT ? this.svR_UPLDW_DT.toISOString() : <any>undefined;
        data["version"] = this.version;
        data["syncoperation"] = this.syncoperation;
        data["syncversion"] = this.syncversion ? this.syncversion.toISOString() : <any>undefined;
        data["syncflag"] = this.syncflag;
        data["routE_CUST_SEQ"] = this.routE_CUST_SEQ;
        data["actuaL_SEQ"] = this.actuaL_SEQ;
        data["rS_IND"] = this.rS_IND;
        data["id"] = this.id;
        return data;
    }
}

export interface IVisitPlanDetailDto {
    disT_CD: string | undefined;
    slsmaN_CD: string | undefined;
    cyclE_CD: string | undefined;
    visiT_DT: moment.Moment | undefined;
    cusT_CD: string | undefined;
    visiT_WEEK: number | undefined;
    duplicatE_IND: string | undefined;
    upldW_STATUS: string | undefined;
    svR_UPLDW_DT: moment.Moment | undefined;
    version: number | undefined;
    syncoperation: string | undefined;
    syncversion: moment.Moment | undefined;
    syncflag: string | undefined;
    routE_CUST_SEQ: number | undefined;
    actuaL_SEQ: number | undefined;
    rS_IND: string | undefined;
    id: number | undefined;
}

export class GetVisitPlanDetailForEditOutput implements IGetVisitPlanDetailForEditOutput {
    visitPlanDetail!: CreateOrEditVisitPlanDetailDto | undefined;

    constructor(data?: IGetVisitPlanDetailForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.visitPlanDetail = data["visitPlanDetail"] ? CreateOrEditVisitPlanDetailDto.fromJS(data["visitPlanDetail"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetVisitPlanDetailForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetVisitPlanDetailForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["visitPlanDetail"] = this.visitPlanDetail ? this.visitPlanDetail.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetVisitPlanDetailForEditOutput {
    visitPlanDetail: CreateOrEditVisitPlanDetailDto | undefined;
}

export class CreateOrEditVisitPlanDetailDto implements ICreateOrEditVisitPlanDetailDto {
    disT_CD!: string | undefined;
    slsmaN_CD!: string | undefined;
    cyclE_CD!: string | undefined;
    visiT_DT!: moment.Moment | undefined;
    cusT_CD!: string | undefined;
    visiT_WEEK!: number | undefined;
    duplicatE_IND!: string | undefined;
    upldW_STATUS!: string | undefined;
    svR_UPLDW_DT!: moment.Moment | undefined;
    version!: number | undefined;
    syncoperation!: string | undefined;
    syncversion!: moment.Moment | undefined;
    syncflag!: string | undefined;
    routE_CUST_SEQ!: number | undefined;
    actuaL_SEQ!: number | undefined;
    rS_IND!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditVisitPlanDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.disT_CD = data["disT_CD"];
            this.slsmaN_CD = data["slsmaN_CD"];
            this.cyclE_CD = data["cyclE_CD"];
            this.visiT_DT = data["visiT_DT"] ? moment(data["visiT_DT"].toString()) : <any>undefined;
            this.cusT_CD = data["cusT_CD"];
            this.visiT_WEEK = data["visiT_WEEK"];
            this.duplicatE_IND = data["duplicatE_IND"];
            this.upldW_STATUS = data["upldW_STATUS"];
            this.svR_UPLDW_DT = data["svR_UPLDW_DT"] ? moment(data["svR_UPLDW_DT"].toString()) : <any>undefined;
            this.version = data["version"];
            this.syncoperation = data["syncoperation"];
            this.syncversion = data["syncversion"] ? moment(data["syncversion"].toString()) : <any>undefined;
            this.syncflag = data["syncflag"];
            this.routE_CUST_SEQ = data["routE_CUST_SEQ"];
            this.actuaL_SEQ = data["actuaL_SEQ"];
            this.rS_IND = data["rS_IND"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditVisitPlanDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditVisitPlanDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["disT_CD"] = this.disT_CD;
        data["slsmaN_CD"] = this.slsmaN_CD;
        data["cyclE_CD"] = this.cyclE_CD;
        data["visiT_DT"] = this.visiT_DT ? this.visiT_DT.toISOString() : <any>undefined;
        data["cusT_CD"] = this.cusT_CD;
        data["visiT_WEEK"] = this.visiT_WEEK;
        data["duplicatE_IND"] = this.duplicatE_IND;
        data["upldW_STATUS"] = this.upldW_STATUS;
        data["svR_UPLDW_DT"] = this.svR_UPLDW_DT ? this.svR_UPLDW_DT.toISOString() : <any>undefined;
        data["version"] = this.version;
        data["syncoperation"] = this.syncoperation;
        data["syncversion"] = this.syncversion ? this.syncversion.toISOString() : <any>undefined;
        data["syncflag"] = this.syncflag;
        data["routE_CUST_SEQ"] = this.routE_CUST_SEQ;
        data["actuaL_SEQ"] = this.actuaL_SEQ;
        data["rS_IND"] = this.rS_IND;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditVisitPlanDetailDto {
    disT_CD: string | undefined;
    slsmaN_CD: string | undefined;
    cyclE_CD: string | undefined;
    visiT_DT: moment.Moment | undefined;
    cusT_CD: string | undefined;
    visiT_WEEK: number | undefined;
    duplicatE_IND: string | undefined;
    upldW_STATUS: string | undefined;
    svR_UPLDW_DT: moment.Moment | undefined;
    version: number | undefined;
    syncoperation: string | undefined;
    syncversion: moment.Moment | undefined;
    syncflag: string | undefined;
    routE_CUST_SEQ: number | undefined;
    actuaL_SEQ: number | undefined;
    rS_IND: string | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfGetVoucherBudgetForViewDto implements IPagedResultDtoOfGetVoucherBudgetForViewDto {
    totalCount!: number | undefined;
    items!: GetVoucherBudgetForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetVoucherBudgetForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetVoucherBudgetForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetVoucherBudgetForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetVoucherBudgetForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetVoucherBudgetForViewDto {
    totalCount: number | undefined;
    items: GetVoucherBudgetForViewDto[] | undefined;
}

export class GetVoucherBudgetForViewDto implements IGetVoucherBudgetForViewDto {
    voucherBudget!: VoucherBudgetDto | undefined;

    constructor(data?: IGetVoucherBudgetForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.voucherBudget = data["voucherBudget"] ? VoucherBudgetDto.fromJS(data["voucherBudget"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetVoucherBudgetForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetVoucherBudgetForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["voucherBudget"] = this.voucherBudget ? this.voucherBudget.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetVoucherBudgetForViewDto {
    voucherBudget: VoucherBudgetDto | undefined;
}

export class VoucherBudgetDto implements IVoucherBudgetDto {
    voucherGroupCode!: string | undefined;
    voucherGroupName!: string | undefined;
    maxRedeemQuantity!: number | undefined;
    maxGrantQuantity!: number | undefined;
    grantedQuantity!: number | undefined;
    remainGrantQuantity!: number | undefined;
    redeemedQuantity!: number | undefined;
    remainRedeemQuantity!: number | undefined;
    id!: number | undefined;

    constructor(data?: IVoucherBudgetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.voucherGroupCode = data["voucherGroupCode"];
            this.voucherGroupName = data["voucherGroupName"];
            this.maxRedeemQuantity = data["maxRedeemQuantity"];
            this.maxGrantQuantity = data["maxGrantQuantity"];
            this.grantedQuantity = data["grantedQuantity"];
            this.remainGrantQuantity = data["remainGrantQuantity"];
            this.redeemedQuantity = data["redeemedQuantity"];
            this.remainRedeemQuantity = data["remainRedeemQuantity"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): VoucherBudgetDto {
        data = typeof data === 'object' ? data : {};
        let result = new VoucherBudgetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["voucherGroupCode"] = this.voucherGroupCode;
        data["voucherGroupName"] = this.voucherGroupName;
        data["maxRedeemQuantity"] = this.maxRedeemQuantity;
        data["maxGrantQuantity"] = this.maxGrantQuantity;
        data["grantedQuantity"] = this.grantedQuantity;
        data["remainGrantQuantity"] = this.remainGrantQuantity;
        data["redeemedQuantity"] = this.redeemedQuantity;
        data["remainRedeemQuantity"] = this.remainRedeemQuantity;
        data["id"] = this.id;
        return data;
    }
}

export interface IVoucherBudgetDto {
    voucherGroupCode: string | undefined;
    voucherGroupName: string | undefined;
    maxRedeemQuantity: number | undefined;
    maxGrantQuantity: number | undefined;
    grantedQuantity: number | undefined;
    remainGrantQuantity: number | undefined;
    redeemedQuantity: number | undefined;
    remainRedeemQuantity: number | undefined;
    id: number | undefined;
}

export class GetVoucherBudgetForEditOutput implements IGetVoucherBudgetForEditOutput {
    voucherBudget!: CreateOrEditVoucherBudgetDto | undefined;

    constructor(data?: IGetVoucherBudgetForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.voucherBudget = data["voucherBudget"] ? CreateOrEditVoucherBudgetDto.fromJS(data["voucherBudget"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetVoucherBudgetForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetVoucherBudgetForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["voucherBudget"] = this.voucherBudget ? this.voucherBudget.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetVoucherBudgetForEditOutput {
    voucherBudget: CreateOrEditVoucherBudgetDto | undefined;
}

export class CreateOrEditVoucherBudgetDto implements ICreateOrEditVoucherBudgetDto {
    voucherGroupCode!: string | undefined;
    voucherGroupName!: string | undefined;
    maxRedeemQuantity!: number | undefined;
    maxGrantQuantity!: number | undefined;
    grantedQuantity!: number | undefined;
    remainGrantQuantity!: number | undefined;
    redeemedQuantity!: number | undefined;
    remainRedeemQuantity!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditVoucherBudgetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.voucherGroupCode = data["voucherGroupCode"];
            this.voucherGroupName = data["voucherGroupName"];
            this.maxRedeemQuantity = data["maxRedeemQuantity"];
            this.maxGrantQuantity = data["maxGrantQuantity"];
            this.grantedQuantity = data["grantedQuantity"];
            this.remainGrantQuantity = data["remainGrantQuantity"];
            this.redeemedQuantity = data["redeemedQuantity"];
            this.remainRedeemQuantity = data["remainRedeemQuantity"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditVoucherBudgetDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditVoucherBudgetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["voucherGroupCode"] = this.voucherGroupCode;
        data["voucherGroupName"] = this.voucherGroupName;
        data["maxRedeemQuantity"] = this.maxRedeemQuantity;
        data["maxGrantQuantity"] = this.maxGrantQuantity;
        data["grantedQuantity"] = this.grantedQuantity;
        data["remainGrantQuantity"] = this.remainGrantQuantity;
        data["redeemedQuantity"] = this.redeemedQuantity;
        data["remainRedeemQuantity"] = this.remainRedeemQuantity;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditVoucherBudgetDto {
    voucherGroupCode: string | undefined;
    voucherGroupName: string | undefined;
    maxRedeemQuantity: number | undefined;
    maxGrantQuantity: number | undefined;
    grantedQuantity: number | undefined;
    remainGrantQuantity: number | undefined;
    redeemedQuantity: number | undefined;
    remainRedeemQuantity: number | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfGetVoucherGroupForViewDto implements IPagedResultDtoOfGetVoucherGroupForViewDto {
    totalCount!: number | undefined;
    items!: GetVoucherGroupForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetVoucherGroupForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetVoucherGroupForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetVoucherGroupForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetVoucherGroupForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetVoucherGroupForViewDto {
    totalCount: number | undefined;
    items: GetVoucherGroupForViewDto[] | undefined;
}

export class GetVoucherGroupForViewDto implements IGetVoucherGroupForViewDto {
    voucherGroup!: VoucherGroupDto | undefined;
    publisherMaster!: PublisherMasterDto | undefined;
    voucherBudget!: VoucherBudgetDto | undefined;

    constructor(data?: IGetVoucherGroupForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.voucherGroup = data["voucherGroup"] ? VoucherGroupDto.fromJS(data["voucherGroup"]) : <any>undefined;
            this.publisherMaster = data["publisherMaster"] ? PublisherMasterDto.fromJS(data["publisherMaster"]) : <any>undefined;
            this.voucherBudget = data["voucherBudget"] ? VoucherBudgetDto.fromJS(data["voucherBudget"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetVoucherGroupForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetVoucherGroupForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["voucherGroup"] = this.voucherGroup ? this.voucherGroup.toJSON() : <any>undefined;
        data["publisherMaster"] = this.publisherMaster ? this.publisherMaster.toJSON() : <any>undefined;
        data["voucherBudget"] = this.voucherBudget ? this.voucherBudget.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetVoucherGroupForViewDto {
    voucherGroup: VoucherGroupDto | undefined;
    publisherMaster: PublisherMasterDto | undefined;
    voucherBudget: VoucherBudgetDto | undefined;
}

export class VoucherGroupDto implements IVoucherGroupDto {
    voucherGroupCode!: string | undefined;
    voucherGroupName!: string | undefined;
    publisherCode!: string | undefined;
    pointPrice!: number | undefined;
    currencyPrice!: number | undefined;
    applyFor!: string | undefined;
    titleVN!: string | undefined;
    titleEN!: string | undefined;
    descriptionVN!: string | undefined;
    descriptionEN!: string | undefined;
    imageLink!: string | undefined;
    template!: string | undefined;
    grantStartTime!: moment.Moment | undefined;
    grantEndTime!: moment.Moment | undefined;
    billCalculationType!: string | undefined;
    billTotal!: number | undefined;
    grantApplyType!: string | undefined;
    grantAppliedLocation!: string | undefined;
    grantAppliedStore!: string | undefined;
    grantAppliedProdLV1!: string | undefined;
    grantAppliedProdLV2!: string | undefined;
    grantAppliedProdLV3!: string | undefined;
    grantAppliedProdLV4!: string | undefined;
    grantAppliedProdLV5!: string | undefined;
    grantAppliedProduct!: string | undefined;
    redemptionApplyType!: string | undefined;
    redemptionApplyLocation!: string | undefined;
    redemptionApplyStore!: string | undefined;
    redemptionAppliedProdLV1!: string | undefined;
    redemptionAppliedProdLV2!: string | undefined;
    redemptionAppliedProdLV3!: string | undefined;
    redemptionAppliedProdLV4!: string | undefined;
    redemptionAppliedProdLV5!: string | undefined;
    redemptionAppliedProduct!: string | undefined;
    redemptionStartTime!: moment.Moment | undefined;
    redemptionEndTIme!: moment.Moment | undefined;
    redemptionType!: string | undefined;
    discountAmount!: number | undefined;
    discountRate!: number | undefined;
    giftCode!: string | undefined;
    minPurchaseAmount!: number | undefined;
    maxDiscountAmount!: number | undefined;
    qtyGrantPerPerson!: number | undefined;
    acceptedEvent!: string | undefined;
    grantMsgTemplateType!: string | undefined;
    grantMsgTemplateID!: string | undefined;
    grantMsgTemplateContentVN!: string | undefined;
    grantMsgTemplateContentEN!: string | undefined;
    redemptionMsgTemplateType!: string | undefined;
    redemptionMsgTemplateID!: string | undefined;
    redemptionMsgTemplateContentVN!: string | undefined;
    redemptionMsgTemplateContentEN!: string | undefined;
    status!: string | undefined;
    voucherGroupNameUnsign!: string | undefined;
    grantNotificationChannel!: string | undefined;
    redemptionNotificationChannel!: string | undefined;
    triggerEvent!: string | undefined;
    eventFilter!: string | undefined;
    isDaily!: boolean | undefined;
    cron!: string | undefined;
    triggerType!: string | undefined;
    triggerDate!: moment.Moment | undefined;
    minBillAmount!: number | undefined;
    qtyRedeemPerPerson!: number | undefined;
    rewardTargetAudienceID!: number | undefined;
    targetAudienceType!: string | undefined;
    isEditable!: boolean | undefined;
    maxDayForPO!: number | undefined;
    referralRewardReceiver!: string | undefined;
    isGranted!: boolean | undefined;
    lastModificationTime!: moment.Moment | undefined;
    creationTime!: moment.Moment | undefined;
    id!: number | undefined;

    constructor(data?: IVoucherGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.voucherGroupCode = data["voucherGroupCode"];
            this.voucherGroupName = data["voucherGroupName"];
            this.publisherCode = data["publisherCode"];
            this.pointPrice = data["pointPrice"];
            this.currencyPrice = data["currencyPrice"];
            this.applyFor = data["applyFor"];
            this.titleVN = data["titleVN"];
            this.titleEN = data["titleEN"];
            this.descriptionVN = data["descriptionVN"];
            this.descriptionEN = data["descriptionEN"];
            this.imageLink = data["imageLink"];
            this.template = data["template"];
            this.grantStartTime = data["grantStartTime"] ? moment(data["grantStartTime"].toString()) : <any>undefined;
            this.grantEndTime = data["grantEndTime"] ? moment(data["grantEndTime"].toString()) : <any>undefined;
            this.billCalculationType = data["billCalculationType"];
            this.billTotal = data["billTotal"];
            this.grantApplyType = data["grantApplyType"];
            this.grantAppliedLocation = data["grantAppliedLocation"];
            this.grantAppliedStore = data["grantAppliedStore"];
            this.grantAppliedProdLV1 = data["grantAppliedProdLV1"];
            this.grantAppliedProdLV2 = data["grantAppliedProdLV2"];
            this.grantAppliedProdLV3 = data["grantAppliedProdLV3"];
            this.grantAppliedProdLV4 = data["grantAppliedProdLV4"];
            this.grantAppliedProdLV5 = data["grantAppliedProdLV5"];
            this.grantAppliedProduct = data["grantAppliedProduct"];
            this.redemptionApplyType = data["redemptionApplyType"];
            this.redemptionApplyLocation = data["redemptionApplyLocation"];
            this.redemptionApplyStore = data["redemptionApplyStore"];
            this.redemptionAppliedProdLV1 = data["redemptionAppliedProdLV1"];
            this.redemptionAppliedProdLV2 = data["redemptionAppliedProdLV2"];
            this.redemptionAppliedProdLV3 = data["redemptionAppliedProdLV3"];
            this.redemptionAppliedProdLV4 = data["redemptionAppliedProdLV4"];
            this.redemptionAppliedProdLV5 = data["redemptionAppliedProdLV5"];
            this.redemptionAppliedProduct = data["redemptionAppliedProduct"];
            this.redemptionStartTime = data["redemptionStartTime"] ? moment(data["redemptionStartTime"].toString()) : <any>undefined;
            this.redemptionEndTIme = data["redemptionEndTIme"] ? moment(data["redemptionEndTIme"].toString()) : <any>undefined;
            this.redemptionType = data["redemptionType"];
            this.discountAmount = data["discountAmount"];
            this.discountRate = data["discountRate"];
            this.giftCode = data["giftCode"];
            this.minPurchaseAmount = data["minPurchaseAmount"];
            this.maxDiscountAmount = data["maxDiscountAmount"];
            this.qtyGrantPerPerson = data["qtyGrantPerPerson"];
            this.acceptedEvent = data["acceptedEvent"];
            this.grantMsgTemplateType = data["grantMsgTemplateType"];
            this.grantMsgTemplateID = data["grantMsgTemplateID"];
            this.grantMsgTemplateContentVN = data["grantMsgTemplateContentVN"];
            this.grantMsgTemplateContentEN = data["grantMsgTemplateContentEN"];
            this.redemptionMsgTemplateType = data["redemptionMsgTemplateType"];
            this.redemptionMsgTemplateID = data["redemptionMsgTemplateID"];
            this.redemptionMsgTemplateContentVN = data["redemptionMsgTemplateContentVN"];
            this.redemptionMsgTemplateContentEN = data["redemptionMsgTemplateContentEN"];
            this.status = data["status"];
            this.voucherGroupNameUnsign = data["voucherGroupNameUnsign"];
            this.grantNotificationChannel = data["grantNotificationChannel"];
            this.redemptionNotificationChannel = data["redemptionNotificationChannel"];
            this.triggerEvent = data["triggerEvent"];
            this.eventFilter = data["eventFilter"];
            this.isDaily = data["isDaily"];
            this.cron = data["cron"];
            this.triggerType = data["triggerType"];
            this.triggerDate = data["triggerDate"] ? moment(data["triggerDate"].toString()) : <any>undefined;
            this.minBillAmount = data["minBillAmount"];
            this.qtyRedeemPerPerson = data["qtyRedeemPerPerson"];
            this.rewardTargetAudienceID = data["rewardTargetAudienceID"];
            this.targetAudienceType = data["targetAudienceType"];
            this.isEditable = data["isEditable"];
            this.maxDayForPO = data["maxDayForPO"];
            this.referralRewardReceiver = data["referralRewardReceiver"];
            this.isGranted = data["isGranted"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): VoucherGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new VoucherGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["voucherGroupCode"] = this.voucherGroupCode;
        data["voucherGroupName"] = this.voucherGroupName;
        data["publisherCode"] = this.publisherCode;
        data["pointPrice"] = this.pointPrice;
        data["currencyPrice"] = this.currencyPrice;
        data["applyFor"] = this.applyFor;
        data["titleVN"] = this.titleVN;
        data["titleEN"] = this.titleEN;
        data["descriptionVN"] = this.descriptionVN;
        data["descriptionEN"] = this.descriptionEN;
        data["imageLink"] = this.imageLink;
        data["template"] = this.template;
        data["grantStartTime"] = this.grantStartTime ? this.grantStartTime.toISOString() : <any>undefined;
        data["grantEndTime"] = this.grantEndTime ? this.grantEndTime.toISOString() : <any>undefined;
        data["billCalculationType"] = this.billCalculationType;
        data["billTotal"] = this.billTotal;
        data["grantApplyType"] = this.grantApplyType;
        data["grantAppliedLocation"] = this.grantAppliedLocation;
        data["grantAppliedStore"] = this.grantAppliedStore;
        data["grantAppliedProdLV1"] = this.grantAppliedProdLV1;
        data["grantAppliedProdLV2"] = this.grantAppliedProdLV2;
        data["grantAppliedProdLV3"] = this.grantAppliedProdLV3;
        data["grantAppliedProdLV4"] = this.grantAppliedProdLV4;
        data["grantAppliedProdLV5"] = this.grantAppliedProdLV5;
        data["grantAppliedProduct"] = this.grantAppliedProduct;
        data["redemptionApplyType"] = this.redemptionApplyType;
        data["redemptionApplyLocation"] = this.redemptionApplyLocation;
        data["redemptionApplyStore"] = this.redemptionApplyStore;
        data["redemptionAppliedProdLV1"] = this.redemptionAppliedProdLV1;
        data["redemptionAppliedProdLV2"] = this.redemptionAppliedProdLV2;
        data["redemptionAppliedProdLV3"] = this.redemptionAppliedProdLV3;
        data["redemptionAppliedProdLV4"] = this.redemptionAppliedProdLV4;
        data["redemptionAppliedProdLV5"] = this.redemptionAppliedProdLV5;
        data["redemptionAppliedProduct"] = this.redemptionAppliedProduct;
        data["redemptionStartTime"] = this.redemptionStartTime ? this.redemptionStartTime.toISOString() : <any>undefined;
        data["redemptionEndTIme"] = this.redemptionEndTIme ? this.redemptionEndTIme.toISOString() : <any>undefined;
        data["redemptionType"] = this.redemptionType;
        data["discountAmount"] = this.discountAmount;
        data["discountRate"] = this.discountRate;
        data["giftCode"] = this.giftCode;
        data["minPurchaseAmount"] = this.minPurchaseAmount;
        data["maxDiscountAmount"] = this.maxDiscountAmount;
        data["qtyGrantPerPerson"] = this.qtyGrantPerPerson;
        data["acceptedEvent"] = this.acceptedEvent;
        data["grantMsgTemplateType"] = this.grantMsgTemplateType;
        data["grantMsgTemplateID"] = this.grantMsgTemplateID;
        data["grantMsgTemplateContentVN"] = this.grantMsgTemplateContentVN;
        data["grantMsgTemplateContentEN"] = this.grantMsgTemplateContentEN;
        data["redemptionMsgTemplateType"] = this.redemptionMsgTemplateType;
        data["redemptionMsgTemplateID"] = this.redemptionMsgTemplateID;
        data["redemptionMsgTemplateContentVN"] = this.redemptionMsgTemplateContentVN;
        data["redemptionMsgTemplateContentEN"] = this.redemptionMsgTemplateContentEN;
        data["status"] = this.status;
        data["voucherGroupNameUnsign"] = this.voucherGroupNameUnsign;
        data["grantNotificationChannel"] = this.grantNotificationChannel;
        data["redemptionNotificationChannel"] = this.redemptionNotificationChannel;
        data["triggerEvent"] = this.triggerEvent;
        data["eventFilter"] = this.eventFilter;
        data["isDaily"] = this.isDaily;
        data["cron"] = this.cron;
        data["triggerType"] = this.triggerType;
        data["triggerDate"] = this.triggerDate ? this.triggerDate.toISOString() : <any>undefined;
        data["minBillAmount"] = this.minBillAmount;
        data["qtyRedeemPerPerson"] = this.qtyRedeemPerPerson;
        data["rewardTargetAudienceID"] = this.rewardTargetAudienceID;
        data["targetAudienceType"] = this.targetAudienceType;
        data["isEditable"] = this.isEditable;
        data["maxDayForPO"] = this.maxDayForPO;
        data["referralRewardReceiver"] = this.referralRewardReceiver;
        data["isGranted"] = this.isGranted;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IVoucherGroupDto {
    voucherGroupCode: string | undefined;
    voucherGroupName: string | undefined;
    publisherCode: string | undefined;
    pointPrice: number | undefined;
    currencyPrice: number | undefined;
    applyFor: string | undefined;
    titleVN: string | undefined;
    titleEN: string | undefined;
    descriptionVN: string | undefined;
    descriptionEN: string | undefined;
    imageLink: string | undefined;
    template: string | undefined;
    grantStartTime: moment.Moment | undefined;
    grantEndTime: moment.Moment | undefined;
    billCalculationType: string | undefined;
    billTotal: number | undefined;
    grantApplyType: string | undefined;
    grantAppliedLocation: string | undefined;
    grantAppliedStore: string | undefined;
    grantAppliedProdLV1: string | undefined;
    grantAppliedProdLV2: string | undefined;
    grantAppliedProdLV3: string | undefined;
    grantAppliedProdLV4: string | undefined;
    grantAppliedProdLV5: string | undefined;
    grantAppliedProduct: string | undefined;
    redemptionApplyType: string | undefined;
    redemptionApplyLocation: string | undefined;
    redemptionApplyStore: string | undefined;
    redemptionAppliedProdLV1: string | undefined;
    redemptionAppliedProdLV2: string | undefined;
    redemptionAppliedProdLV3: string | undefined;
    redemptionAppliedProdLV4: string | undefined;
    redemptionAppliedProdLV5: string | undefined;
    redemptionAppliedProduct: string | undefined;
    redemptionStartTime: moment.Moment | undefined;
    redemptionEndTIme: moment.Moment | undefined;
    redemptionType: string | undefined;
    discountAmount: number | undefined;
    discountRate: number | undefined;
    giftCode: string | undefined;
    minPurchaseAmount: number | undefined;
    maxDiscountAmount: number | undefined;
    qtyGrantPerPerson: number | undefined;
    acceptedEvent: string | undefined;
    grantMsgTemplateType: string | undefined;
    grantMsgTemplateID: string | undefined;
    grantMsgTemplateContentVN: string | undefined;
    grantMsgTemplateContentEN: string | undefined;
    redemptionMsgTemplateType: string | undefined;
    redemptionMsgTemplateID: string | undefined;
    redemptionMsgTemplateContentVN: string | undefined;
    redemptionMsgTemplateContentEN: string | undefined;
    status: string | undefined;
    voucherGroupNameUnsign: string | undefined;
    grantNotificationChannel: string | undefined;
    redemptionNotificationChannel: string | undefined;
    triggerEvent: string | undefined;
    eventFilter: string | undefined;
    isDaily: boolean | undefined;
    cron: string | undefined;
    triggerType: string | undefined;
    triggerDate: moment.Moment | undefined;
    minBillAmount: number | undefined;
    qtyRedeemPerPerson: number | undefined;
    rewardTargetAudienceID: number | undefined;
    targetAudienceType: string | undefined;
    isEditable: boolean | undefined;
    maxDayForPO: number | undefined;
    referralRewardReceiver: string | undefined;
    isGranted: boolean | undefined;
    lastModificationTime: moment.Moment | undefined;
    creationTime: moment.Moment | undefined;
    id: number | undefined;
}

export class GetVoucherGroupForEditOutput implements IGetVoucherGroupForEditOutput {
    voucherGroup!: CreateOrEditVoucherGroupDto | undefined;
    voucherBudget!: CreateOrEditVoucherBudgetDto | undefined;
    targetImportInformation!: RewardTargetAudienceImportInformation | undefined;
    voucherPattern!: CreateOrEditVoucherPatternDto | undefined;

    constructor(data?: IGetVoucherGroupForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.voucherGroup = data["voucherGroup"] ? CreateOrEditVoucherGroupDto.fromJS(data["voucherGroup"]) : <any>undefined;
            this.voucherBudget = data["voucherBudget"] ? CreateOrEditVoucherBudgetDto.fromJS(data["voucherBudget"]) : <any>undefined;
            this.targetImportInformation = data["targetImportInformation"] ? RewardTargetAudienceImportInformation.fromJS(data["targetImportInformation"]) : <any>undefined;
            this.voucherPattern = data["voucherPattern"] ? CreateOrEditVoucherPatternDto.fromJS(data["voucherPattern"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetVoucherGroupForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetVoucherGroupForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["voucherGroup"] = this.voucherGroup ? this.voucherGroup.toJSON() : <any>undefined;
        data["voucherBudget"] = this.voucherBudget ? this.voucherBudget.toJSON() : <any>undefined;
        data["targetImportInformation"] = this.targetImportInformation ? this.targetImportInformation.toJSON() : <any>undefined;
        data["voucherPattern"] = this.voucherPattern ? this.voucherPattern.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetVoucherGroupForEditOutput {
    voucherGroup: CreateOrEditVoucherGroupDto | undefined;
    voucherBudget: CreateOrEditVoucherBudgetDto | undefined;
    targetImportInformation: RewardTargetAudienceImportInformation | undefined;
    voucherPattern: CreateOrEditVoucherPatternDto | undefined;
}

export class CreateOrEditVoucherGroupDto implements ICreateOrEditVoucherGroupDto {
    voucherGroupCode!: string | undefined;
    voucherGroupName!: string | undefined;
    publisherCode!: string | undefined;
    pointPrice!: number | undefined;
    currencyPrice!: number | undefined;
    applyFor!: string | undefined;
    titleVN!: string | undefined;
    titleEN!: string | undefined;
    descriptionVN!: string | undefined;
    descriptionEN!: string | undefined;
    imageLink!: string | undefined;
    template!: string | undefined;
    grantStartTime!: moment.Moment | undefined;
    grantEndTime!: moment.Moment | undefined;
    billCalculationType!: string | undefined;
    billTotal!: number | undefined;
    grantApplyType!: string | undefined;
    grantAppliedLocation!: string | undefined;
    grantAppliedStore!: string | undefined;
    grantAppliedProdLV1!: string | undefined;
    grantAppliedProdLV2!: string | undefined;
    grantAppliedProdLV3!: string | undefined;
    grantAppliedProdLV4!: string | undefined;
    grantAppliedProdLV5!: string | undefined;
    grantAppliedProduct!: string | undefined;
    redemptionApplyType!: string | undefined;
    redemptionApplyLocation!: string | undefined;
    redemptionApplyStore!: string | undefined;
    redemptionAppliedProdLV1!: string | undefined;
    redemptionAppliedProdLV2!: string | undefined;
    redemptionAppliedProdLV3!: string | undefined;
    redemptionAppliedProdLV4!: string | undefined;
    redemptionAppliedProdLV5!: string | undefined;
    redemptionAppliedProduct!: string | undefined;
    redemptionStartTime!: moment.Moment | undefined;
    redemptionEndTIme!: moment.Moment | undefined;
    redemptionType!: string | undefined;
    discountAmount!: number | undefined;
    discountRate!: number | undefined;
    giftCode!: string | undefined;
    minPurchaseAmount!: number | undefined;
    maxDiscountAmount!: number | undefined;
    qtyGrantPerPerson!: number | undefined;
    acceptedEvent!: string | undefined;
    grantMsgTemplateType!: string | undefined;
    grantMsgTemplateID!: string | undefined;
    grantMsgTemplateContentVN!: string | undefined;
    grantMsgTemplateContentEN!: string | undefined;
    redemptionMsgTemplateType!: string | undefined;
    redemptionMsgTemplateID!: string | undefined;
    redemptionMsgTemplateContentVN!: string | undefined;
    redemptionMsgTemplateContentEN!: string | undefined;
    status!: string | undefined;
    voucherGroupNameUnsign!: string | undefined;
    grantNotificationChannel!: string | undefined;
    redemptionNotificationChannel!: string | undefined;
    triggerEvent!: string | undefined;
    eventFilter!: string | undefined;
    isDaily!: boolean | undefined;
    cron!: string | undefined;
    triggerType!: string | undefined;
    triggerDate!: moment.Moment | undefined;
    minBillAmount!: number | undefined;
    qtyRedeemPerPerson!: number | undefined;
    rewardTargetAudienceID!: number | undefined;
    targetAudienceType!: string | undefined;
    isEditable!: boolean | undefined;
    maxDayForPO!: number | undefined;
    referralRewardReceiver!: string | undefined;
    isGranted!: boolean | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditVoucherGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.voucherGroupCode = data["voucherGroupCode"];
            this.voucherGroupName = data["voucherGroupName"];
            this.publisherCode = data["publisherCode"];
            this.pointPrice = data["pointPrice"];
            this.currencyPrice = data["currencyPrice"];
            this.applyFor = data["applyFor"];
            this.titleVN = data["titleVN"];
            this.titleEN = data["titleEN"];
            this.descriptionVN = data["descriptionVN"];
            this.descriptionEN = data["descriptionEN"];
            this.imageLink = data["imageLink"];
            this.template = data["template"];
            this.grantStartTime = data["grantStartTime"] ? moment(data["grantStartTime"].toString()) : <any>undefined;
            this.grantEndTime = data["grantEndTime"] ? moment(data["grantEndTime"].toString()) : <any>undefined;
            this.billCalculationType = data["billCalculationType"];
            this.billTotal = data["billTotal"];
            this.grantApplyType = data["grantApplyType"];
            this.grantAppliedLocation = data["grantAppliedLocation"];
            this.grantAppliedStore = data["grantAppliedStore"];
            this.grantAppliedProdLV1 = data["grantAppliedProdLV1"];
            this.grantAppliedProdLV2 = data["grantAppliedProdLV2"];
            this.grantAppliedProdLV3 = data["grantAppliedProdLV3"];
            this.grantAppliedProdLV4 = data["grantAppliedProdLV4"];
            this.grantAppliedProdLV5 = data["grantAppliedProdLV5"];
            this.grantAppliedProduct = data["grantAppliedProduct"];
            this.redemptionApplyType = data["redemptionApplyType"];
            this.redemptionApplyLocation = data["redemptionApplyLocation"];
            this.redemptionApplyStore = data["redemptionApplyStore"];
            this.redemptionAppliedProdLV1 = data["redemptionAppliedProdLV1"];
            this.redemptionAppliedProdLV2 = data["redemptionAppliedProdLV2"];
            this.redemptionAppliedProdLV3 = data["redemptionAppliedProdLV3"];
            this.redemptionAppliedProdLV4 = data["redemptionAppliedProdLV4"];
            this.redemptionAppliedProdLV5 = data["redemptionAppliedProdLV5"];
            this.redemptionAppliedProduct = data["redemptionAppliedProduct"];
            this.redemptionStartTime = data["redemptionStartTime"] ? moment(data["redemptionStartTime"].toString()) : <any>undefined;
            this.redemptionEndTIme = data["redemptionEndTIme"] ? moment(data["redemptionEndTIme"].toString()) : <any>undefined;
            this.redemptionType = data["redemptionType"];
            this.discountAmount = data["discountAmount"];
            this.discountRate = data["discountRate"];
            this.giftCode = data["giftCode"];
            this.minPurchaseAmount = data["minPurchaseAmount"];
            this.maxDiscountAmount = data["maxDiscountAmount"];
            this.qtyGrantPerPerson = data["qtyGrantPerPerson"];
            this.acceptedEvent = data["acceptedEvent"];
            this.grantMsgTemplateType = data["grantMsgTemplateType"];
            this.grantMsgTemplateID = data["grantMsgTemplateID"];
            this.grantMsgTemplateContentVN = data["grantMsgTemplateContentVN"];
            this.grantMsgTemplateContentEN = data["grantMsgTemplateContentEN"];
            this.redemptionMsgTemplateType = data["redemptionMsgTemplateType"];
            this.redemptionMsgTemplateID = data["redemptionMsgTemplateID"];
            this.redemptionMsgTemplateContentVN = data["redemptionMsgTemplateContentVN"];
            this.redemptionMsgTemplateContentEN = data["redemptionMsgTemplateContentEN"];
            this.status = data["status"];
            this.voucherGroupNameUnsign = data["voucherGroupNameUnsign"];
            this.grantNotificationChannel = data["grantNotificationChannel"];
            this.redemptionNotificationChannel = data["redemptionNotificationChannel"];
            this.triggerEvent = data["triggerEvent"];
            this.eventFilter = data["eventFilter"];
            this.isDaily = data["isDaily"];
            this.cron = data["cron"];
            this.triggerType = data["triggerType"];
            this.triggerDate = data["triggerDate"] ? moment(data["triggerDate"].toString()) : <any>undefined;
            this.minBillAmount = data["minBillAmount"];
            this.qtyRedeemPerPerson = data["qtyRedeemPerPerson"];
            this.rewardTargetAudienceID = data["rewardTargetAudienceID"];
            this.targetAudienceType = data["targetAudienceType"];
            this.isEditable = data["isEditable"];
            this.maxDayForPO = data["maxDayForPO"];
            this.referralRewardReceiver = data["referralRewardReceiver"];
            this.isGranted = data["isGranted"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditVoucherGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditVoucherGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["voucherGroupCode"] = this.voucherGroupCode;
        data["voucherGroupName"] = this.voucherGroupName;
        data["publisherCode"] = this.publisherCode;
        data["pointPrice"] = this.pointPrice;
        data["currencyPrice"] = this.currencyPrice;
        data["applyFor"] = this.applyFor;
        data["titleVN"] = this.titleVN;
        data["titleEN"] = this.titleEN;
        data["descriptionVN"] = this.descriptionVN;
        data["descriptionEN"] = this.descriptionEN;
        data["imageLink"] = this.imageLink;
        data["template"] = this.template;
        data["grantStartTime"] = this.grantStartTime ? this.grantStartTime.toISOString() : <any>undefined;
        data["grantEndTime"] = this.grantEndTime ? this.grantEndTime.toISOString() : <any>undefined;
        data["billCalculationType"] = this.billCalculationType;
        data["billTotal"] = this.billTotal;
        data["grantApplyType"] = this.grantApplyType;
        data["grantAppliedLocation"] = this.grantAppliedLocation;
        data["grantAppliedStore"] = this.grantAppliedStore;
        data["grantAppliedProdLV1"] = this.grantAppliedProdLV1;
        data["grantAppliedProdLV2"] = this.grantAppliedProdLV2;
        data["grantAppliedProdLV3"] = this.grantAppliedProdLV3;
        data["grantAppliedProdLV4"] = this.grantAppliedProdLV4;
        data["grantAppliedProdLV5"] = this.grantAppliedProdLV5;
        data["grantAppliedProduct"] = this.grantAppliedProduct;
        data["redemptionApplyType"] = this.redemptionApplyType;
        data["redemptionApplyLocation"] = this.redemptionApplyLocation;
        data["redemptionApplyStore"] = this.redemptionApplyStore;
        data["redemptionAppliedProdLV1"] = this.redemptionAppliedProdLV1;
        data["redemptionAppliedProdLV2"] = this.redemptionAppliedProdLV2;
        data["redemptionAppliedProdLV3"] = this.redemptionAppliedProdLV3;
        data["redemptionAppliedProdLV4"] = this.redemptionAppliedProdLV4;
        data["redemptionAppliedProdLV5"] = this.redemptionAppliedProdLV5;
        data["redemptionAppliedProduct"] = this.redemptionAppliedProduct;
        data["redemptionStartTime"] = this.redemptionStartTime ? this.redemptionStartTime.toISOString() : <any>undefined;
        data["redemptionEndTIme"] = this.redemptionEndTIme ? this.redemptionEndTIme.toISOString() : <any>undefined;
        data["redemptionType"] = this.redemptionType;
        data["discountAmount"] = this.discountAmount;
        data["discountRate"] = this.discountRate;
        data["giftCode"] = this.giftCode;
        data["minPurchaseAmount"] = this.minPurchaseAmount;
        data["maxDiscountAmount"] = this.maxDiscountAmount;
        data["qtyGrantPerPerson"] = this.qtyGrantPerPerson;
        data["acceptedEvent"] = this.acceptedEvent;
        data["grantMsgTemplateType"] = this.grantMsgTemplateType;
        data["grantMsgTemplateID"] = this.grantMsgTemplateID;
        data["grantMsgTemplateContentVN"] = this.grantMsgTemplateContentVN;
        data["grantMsgTemplateContentEN"] = this.grantMsgTemplateContentEN;
        data["redemptionMsgTemplateType"] = this.redemptionMsgTemplateType;
        data["redemptionMsgTemplateID"] = this.redemptionMsgTemplateID;
        data["redemptionMsgTemplateContentVN"] = this.redemptionMsgTemplateContentVN;
        data["redemptionMsgTemplateContentEN"] = this.redemptionMsgTemplateContentEN;
        data["status"] = this.status;
        data["voucherGroupNameUnsign"] = this.voucherGroupNameUnsign;
        data["grantNotificationChannel"] = this.grantNotificationChannel;
        data["redemptionNotificationChannel"] = this.redemptionNotificationChannel;
        data["triggerEvent"] = this.triggerEvent;
        data["eventFilter"] = this.eventFilter;
        data["isDaily"] = this.isDaily;
        data["cron"] = this.cron;
        data["triggerType"] = this.triggerType;
        data["triggerDate"] = this.triggerDate ? this.triggerDate.toISOString() : <any>undefined;
        data["minBillAmount"] = this.minBillAmount;
        data["qtyRedeemPerPerson"] = this.qtyRedeemPerPerson;
        data["rewardTargetAudienceID"] = this.rewardTargetAudienceID;
        data["targetAudienceType"] = this.targetAudienceType;
        data["isEditable"] = this.isEditable;
        data["maxDayForPO"] = this.maxDayForPO;
        data["referralRewardReceiver"] = this.referralRewardReceiver;
        data["isGranted"] = this.isGranted;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditVoucherGroupDto {
    voucherGroupCode: string | undefined;
    voucherGroupName: string | undefined;
    publisherCode: string | undefined;
    pointPrice: number | undefined;
    currencyPrice: number | undefined;
    applyFor: string | undefined;
    titleVN: string | undefined;
    titleEN: string | undefined;
    descriptionVN: string | undefined;
    descriptionEN: string | undefined;
    imageLink: string | undefined;
    template: string | undefined;
    grantStartTime: moment.Moment | undefined;
    grantEndTime: moment.Moment | undefined;
    billCalculationType: string | undefined;
    billTotal: number | undefined;
    grantApplyType: string | undefined;
    grantAppliedLocation: string | undefined;
    grantAppliedStore: string | undefined;
    grantAppliedProdLV1: string | undefined;
    grantAppliedProdLV2: string | undefined;
    grantAppliedProdLV3: string | undefined;
    grantAppliedProdLV4: string | undefined;
    grantAppliedProdLV5: string | undefined;
    grantAppliedProduct: string | undefined;
    redemptionApplyType: string | undefined;
    redemptionApplyLocation: string | undefined;
    redemptionApplyStore: string | undefined;
    redemptionAppliedProdLV1: string | undefined;
    redemptionAppliedProdLV2: string | undefined;
    redemptionAppliedProdLV3: string | undefined;
    redemptionAppliedProdLV4: string | undefined;
    redemptionAppliedProdLV5: string | undefined;
    redemptionAppliedProduct: string | undefined;
    redemptionStartTime: moment.Moment | undefined;
    redemptionEndTIme: moment.Moment | undefined;
    redemptionType: string | undefined;
    discountAmount: number | undefined;
    discountRate: number | undefined;
    giftCode: string | undefined;
    minPurchaseAmount: number | undefined;
    maxDiscountAmount: number | undefined;
    qtyGrantPerPerson: number | undefined;
    acceptedEvent: string | undefined;
    grantMsgTemplateType: string | undefined;
    grantMsgTemplateID: string | undefined;
    grantMsgTemplateContentVN: string | undefined;
    grantMsgTemplateContentEN: string | undefined;
    redemptionMsgTemplateType: string | undefined;
    redemptionMsgTemplateID: string | undefined;
    redemptionMsgTemplateContentVN: string | undefined;
    redemptionMsgTemplateContentEN: string | undefined;
    status: string | undefined;
    voucherGroupNameUnsign: string | undefined;
    grantNotificationChannel: string | undefined;
    redemptionNotificationChannel: string | undefined;
    triggerEvent: string | undefined;
    eventFilter: string | undefined;
    isDaily: boolean | undefined;
    cron: string | undefined;
    triggerType: string | undefined;
    triggerDate: moment.Moment | undefined;
    minBillAmount: number | undefined;
    qtyRedeemPerPerson: number | undefined;
    rewardTargetAudienceID: number | undefined;
    targetAudienceType: string | undefined;
    isEditable: boolean | undefined;
    maxDayForPO: number | undefined;
    referralRewardReceiver: string | undefined;
    isGranted: boolean | undefined;
    id: number | undefined;
}

export class RewardTargetAudienceImportInformation implements IRewardTargetAudienceImportInformation {
    fileName!: string | undefined;
    targetAudienceName!: string | undefined;

    constructor(data?: IRewardTargetAudienceImportInformation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.fileName = data["fileName"];
            this.targetAudienceName = data["targetAudienceName"];
        }
    }

    static fromJS(data: any): RewardTargetAudienceImportInformation {
        data = typeof data === 'object' ? data : {};
        let result = new RewardTargetAudienceImportInformation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["targetAudienceName"] = this.targetAudienceName;
        return data;
    }
}

export interface IRewardTargetAudienceImportInformation {
    fileName: string | undefined;
    targetAudienceName: string | undefined;
}

export class CreateOrEditVoucherPatternDto implements ICreateOrEditVoucherPatternDto {
    patternCode!: string | undefined;
    patternName!: string | undefined;
    prefix!: string | undefined;
    charSet!: string | undefined;
    lengthAutoGenString!: string | undefined;
    postfix!: string | undefined;
    voucherGroupCode!: string | undefined;
    notes!: string | undefined;
    status!: string | undefined;
    patternNameUnsign!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditVoucherPatternDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.patternCode = data["patternCode"];
            this.patternName = data["patternName"];
            this.prefix = data["prefix"];
            this.charSet = data["charSet"];
            this.lengthAutoGenString = data["lengthAutoGenString"];
            this.postfix = data["postfix"];
            this.voucherGroupCode = data["voucherGroupCode"];
            this.notes = data["notes"];
            this.status = data["status"];
            this.patternNameUnsign = data["patternNameUnsign"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditVoucherPatternDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditVoucherPatternDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patternCode"] = this.patternCode;
        data["patternName"] = this.patternName;
        data["prefix"] = this.prefix;
        data["charSet"] = this.charSet;
        data["lengthAutoGenString"] = this.lengthAutoGenString;
        data["postfix"] = this.postfix;
        data["voucherGroupCode"] = this.voucherGroupCode;
        data["notes"] = this.notes;
        data["status"] = this.status;
        data["patternNameUnsign"] = this.patternNameUnsign;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditVoucherPatternDto {
    patternCode: string | undefined;
    patternName: string | undefined;
    prefix: string | undefined;
    charSet: string | undefined;
    lengthAutoGenString: string | undefined;
    postfix: string | undefined;
    voucherGroupCode: string | undefined;
    notes: string | undefined;
    status: string | undefined;
    patternNameUnsign: string | undefined;
    id: number | undefined;
}

export class SearchVoucherGroupInput implements ISearchVoucherGroupInput {
    publisherName!: string | undefined;
    targetAudienceCodeFilter!: string | undefined;
    filter!: string | undefined;
    voucherGroupCodeFilter!: string | undefined;
    voucherGroupNameFilter!: string | undefined;
    publisherCodeFilter!: string | undefined;
    maxPointPriceFilter!: number | undefined;
    minPointPriceFilter!: number | undefined;
    maxCurrencyPriceFilter!: number | undefined;
    minCurrencyPriceFilter!: number | undefined;
    applyForFilter!: string | undefined;
    titleVNFilter!: string | undefined;
    titleENFilter!: string | undefined;
    descriptionVNFilter!: string | undefined;
    descriptionENFilter!: string | undefined;
    imageLinkFilter!: string | undefined;
    templateFilter!: string | undefined;
    maxGrantStartTimeFilter!: moment.Moment | undefined;
    minGrantStartTimeFilter!: moment.Moment | undefined;
    maxGrantEndTimeFilter!: moment.Moment | undefined;
    minGrantEndTimeFilter!: moment.Moment | undefined;
    billCalculationTypeFilter!: string | undefined;
    maxBillTotalFilter!: number | undefined;
    minBillTotalFilter!: number | undefined;
    grantApplyTypeFilter!: string | undefined;
    grantAppliedLocationFilter!: string | undefined;
    grantAppliedStoreFilter!: string | undefined;
    grantAppliedProdLV1Filter!: string | undefined;
    grantAppliedProdLV2Filter!: string | undefined;
    grantAppliedProdLV3Filter!: string | undefined;
    grantAppliedProdLV4Filter!: string | undefined;
    grantAppliedProdLV5Filter!: string | undefined;
    grantAppliedProductFilter!: string | undefined;
    redemptionApplyTypeFilter!: string | undefined;
    redemptionApplyLocationFilter!: string | undefined;
    redemptionApplyStoreFilter!: string | undefined;
    redemptionAppliedProdLV1Filter!: string | undefined;
    redemptionAppliedProdLV2Filter!: string | undefined;
    redemptionAppliedProdLV3Filter!: string | undefined;
    redemptionAppliedProdLV4Filter!: string | undefined;
    redemptionAppliedProdLV5Filter!: string | undefined;
    redemptionAppliedProductFilter!: string | undefined;
    maxRedemptionStartTimeFilter!: moment.Moment | undefined;
    minRedemptionStartTimeFilter!: moment.Moment | undefined;
    maxRedemptionEndTImeFilter!: moment.Moment | undefined;
    minRedemptionEndTImeFilter!: moment.Moment | undefined;
    redemptionTypeFilter!: string | undefined;
    maxDiscountAmountFilter!: number | undefined;
    minDiscountAmountFilter!: number | undefined;
    maxDiscountRateFilter!: number | undefined;
    minDiscountRateFilter!: number | undefined;
    giftCodeFilter!: string | undefined;
    maxMinPurchaseAmountFilter!: number | undefined;
    minMinPurchaseAmountFilter!: number | undefined;
    maxMaxDiscountAmountFilter!: number | undefined;
    minMaxDiscountAmountFilter!: number | undefined;
    maxQtyGrantPerPersonFilter!: number | undefined;
    minQtyGrantPerPersonFilter!: number | undefined;
    acceptedEventFilter!: string | undefined;
    grantMsgTemplateTypeFilter!: string | undefined;
    grantMsgTemplateIDFilter!: string | undefined;
    grantMsgTemplateContentVNFilter!: string | undefined;
    grantMsgTemplateContentENFilter!: string | undefined;
    redemptionMsgTemplateTypeFilter!: string | undefined;
    redemptionMsgTemplateIDFilter!: string | undefined;
    redemptionMsgTemplateContentVNFilter!: string | undefined;
    redemptionMsgTemplateContentENFilter!: string | undefined;
    statusFilter!: string | undefined;
    voucherGroupNameUnsignFilter!: string | undefined;
    grantNotificationChannelFilter!: string | undefined;
    redemptionNotificationChannelFilter!: string | undefined;
    triggerEventFilter!: string | undefined;
    eventFilterFilter!: string | undefined;
    isDailyFilter!: number | undefined;
    cronFilter!: string | undefined;
    triggerTypeFilter!: string | undefined;
    maxTriggerDateFilter!: moment.Moment | undefined;
    minTriggerDateFilter!: moment.Moment | undefined;
    maxMinBillAmountFilter!: number | undefined;
    minMinBillAmountFilter!: number | undefined;
    maxQtyRedeemPerPersonFilter!: number | undefined;
    minQtyRedeemPerPersonFilter!: number | undefined;
    maxRewardTargetAudienceIDFilter!: number | undefined;
    minRewardTargetAudienceIDFilter!: number | undefined;
    targetAudienceTypeFilter!: string | undefined;
    isEditableFilter!: number | undefined;
    maxMaxDayForPOFilter!: number | undefined;
    minMaxDayForPOFilter!: number | undefined;
    referralRewardReceiverFilter!: string | undefined;
    isGrantedFilter!: number | undefined;
    sorting!: string | undefined;
    skipCount!: number | undefined;
    maxResultCount!: number | undefined;

    constructor(data?: ISearchVoucherGroupInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.publisherName = data["publisherName"];
            this.targetAudienceCodeFilter = data["targetAudienceCodeFilter"];
            this.filter = data["filter"];
            this.voucherGroupCodeFilter = data["voucherGroupCodeFilter"];
            this.voucherGroupNameFilter = data["voucherGroupNameFilter"];
            this.publisherCodeFilter = data["publisherCodeFilter"];
            this.maxPointPriceFilter = data["maxPointPriceFilter"];
            this.minPointPriceFilter = data["minPointPriceFilter"];
            this.maxCurrencyPriceFilter = data["maxCurrencyPriceFilter"];
            this.minCurrencyPriceFilter = data["minCurrencyPriceFilter"];
            this.applyForFilter = data["applyForFilter"];
            this.titleVNFilter = data["titleVNFilter"];
            this.titleENFilter = data["titleENFilter"];
            this.descriptionVNFilter = data["descriptionVNFilter"];
            this.descriptionENFilter = data["descriptionENFilter"];
            this.imageLinkFilter = data["imageLinkFilter"];
            this.templateFilter = data["templateFilter"];
            this.maxGrantStartTimeFilter = data["maxGrantStartTimeFilter"] ? moment(data["maxGrantStartTimeFilter"].toString()) : <any>undefined;
            this.minGrantStartTimeFilter = data["minGrantStartTimeFilter"] ? moment(data["minGrantStartTimeFilter"].toString()) : <any>undefined;
            this.maxGrantEndTimeFilter = data["maxGrantEndTimeFilter"] ? moment(data["maxGrantEndTimeFilter"].toString()) : <any>undefined;
            this.minGrantEndTimeFilter = data["minGrantEndTimeFilter"] ? moment(data["minGrantEndTimeFilter"].toString()) : <any>undefined;
            this.billCalculationTypeFilter = data["billCalculationTypeFilter"];
            this.maxBillTotalFilter = data["maxBillTotalFilter"];
            this.minBillTotalFilter = data["minBillTotalFilter"];
            this.grantApplyTypeFilter = data["grantApplyTypeFilter"];
            this.grantAppliedLocationFilter = data["grantAppliedLocationFilter"];
            this.grantAppliedStoreFilter = data["grantAppliedStoreFilter"];
            this.grantAppliedProdLV1Filter = data["grantAppliedProdLV1Filter"];
            this.grantAppliedProdLV2Filter = data["grantAppliedProdLV2Filter"];
            this.grantAppliedProdLV3Filter = data["grantAppliedProdLV3Filter"];
            this.grantAppliedProdLV4Filter = data["grantAppliedProdLV4Filter"];
            this.grantAppliedProdLV5Filter = data["grantAppliedProdLV5Filter"];
            this.grantAppliedProductFilter = data["grantAppliedProductFilter"];
            this.redemptionApplyTypeFilter = data["redemptionApplyTypeFilter"];
            this.redemptionApplyLocationFilter = data["redemptionApplyLocationFilter"];
            this.redemptionApplyStoreFilter = data["redemptionApplyStoreFilter"];
            this.redemptionAppliedProdLV1Filter = data["redemptionAppliedProdLV1Filter"];
            this.redemptionAppliedProdLV2Filter = data["redemptionAppliedProdLV2Filter"];
            this.redemptionAppliedProdLV3Filter = data["redemptionAppliedProdLV3Filter"];
            this.redemptionAppliedProdLV4Filter = data["redemptionAppliedProdLV4Filter"];
            this.redemptionAppliedProdLV5Filter = data["redemptionAppliedProdLV5Filter"];
            this.redemptionAppliedProductFilter = data["redemptionAppliedProductFilter"];
            this.maxRedemptionStartTimeFilter = data["maxRedemptionStartTimeFilter"] ? moment(data["maxRedemptionStartTimeFilter"].toString()) : <any>undefined;
            this.minRedemptionStartTimeFilter = data["minRedemptionStartTimeFilter"] ? moment(data["minRedemptionStartTimeFilter"].toString()) : <any>undefined;
            this.maxRedemptionEndTImeFilter = data["maxRedemptionEndTImeFilter"] ? moment(data["maxRedemptionEndTImeFilter"].toString()) : <any>undefined;
            this.minRedemptionEndTImeFilter = data["minRedemptionEndTImeFilter"] ? moment(data["minRedemptionEndTImeFilter"].toString()) : <any>undefined;
            this.redemptionTypeFilter = data["redemptionTypeFilter"];
            this.maxDiscountAmountFilter = data["maxDiscountAmountFilter"];
            this.minDiscountAmountFilter = data["minDiscountAmountFilter"];
            this.maxDiscountRateFilter = data["maxDiscountRateFilter"];
            this.minDiscountRateFilter = data["minDiscountRateFilter"];
            this.giftCodeFilter = data["giftCodeFilter"];
            this.maxMinPurchaseAmountFilter = data["maxMinPurchaseAmountFilter"];
            this.minMinPurchaseAmountFilter = data["minMinPurchaseAmountFilter"];
            this.maxMaxDiscountAmountFilter = data["maxMaxDiscountAmountFilter"];
            this.minMaxDiscountAmountFilter = data["minMaxDiscountAmountFilter"];
            this.maxQtyGrantPerPersonFilter = data["maxQtyGrantPerPersonFilter"];
            this.minQtyGrantPerPersonFilter = data["minQtyGrantPerPersonFilter"];
            this.acceptedEventFilter = data["acceptedEventFilter"];
            this.grantMsgTemplateTypeFilter = data["grantMsgTemplateTypeFilter"];
            this.grantMsgTemplateIDFilter = data["grantMsgTemplateIDFilter"];
            this.grantMsgTemplateContentVNFilter = data["grantMsgTemplateContentVNFilter"];
            this.grantMsgTemplateContentENFilter = data["grantMsgTemplateContentENFilter"];
            this.redemptionMsgTemplateTypeFilter = data["redemptionMsgTemplateTypeFilter"];
            this.redemptionMsgTemplateIDFilter = data["redemptionMsgTemplateIDFilter"];
            this.redemptionMsgTemplateContentVNFilter = data["redemptionMsgTemplateContentVNFilter"];
            this.redemptionMsgTemplateContentENFilter = data["redemptionMsgTemplateContentENFilter"];
            this.statusFilter = data["statusFilter"];
            this.voucherGroupNameUnsignFilter = data["voucherGroupNameUnsignFilter"];
            this.grantNotificationChannelFilter = data["grantNotificationChannelFilter"];
            this.redemptionNotificationChannelFilter = data["redemptionNotificationChannelFilter"];
            this.triggerEventFilter = data["triggerEventFilter"];
            this.eventFilterFilter = data["eventFilterFilter"];
            this.isDailyFilter = data["isDailyFilter"];
            this.cronFilter = data["cronFilter"];
            this.triggerTypeFilter = data["triggerTypeFilter"];
            this.maxTriggerDateFilter = data["maxTriggerDateFilter"] ? moment(data["maxTriggerDateFilter"].toString()) : <any>undefined;
            this.minTriggerDateFilter = data["minTriggerDateFilter"] ? moment(data["minTriggerDateFilter"].toString()) : <any>undefined;
            this.maxMinBillAmountFilter = data["maxMinBillAmountFilter"];
            this.minMinBillAmountFilter = data["minMinBillAmountFilter"];
            this.maxQtyRedeemPerPersonFilter = data["maxQtyRedeemPerPersonFilter"];
            this.minQtyRedeemPerPersonFilter = data["minQtyRedeemPerPersonFilter"];
            this.maxRewardTargetAudienceIDFilter = data["maxRewardTargetAudienceIDFilter"];
            this.minRewardTargetAudienceIDFilter = data["minRewardTargetAudienceIDFilter"];
            this.targetAudienceTypeFilter = data["targetAudienceTypeFilter"];
            this.isEditableFilter = data["isEditableFilter"];
            this.maxMaxDayForPOFilter = data["maxMaxDayForPOFilter"];
            this.minMaxDayForPOFilter = data["minMaxDayForPOFilter"];
            this.referralRewardReceiverFilter = data["referralRewardReceiverFilter"];
            this.isGrantedFilter = data["isGrantedFilter"];
            this.sorting = data["sorting"];
            this.skipCount = data["skipCount"];
            this.maxResultCount = data["maxResultCount"];
        }
    }

    static fromJS(data: any): SearchVoucherGroupInput {
        data = typeof data === 'object' ? data : {};
        let result = new SearchVoucherGroupInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["publisherName"] = this.publisherName;
        data["targetAudienceCodeFilter"] = this.targetAudienceCodeFilter;
        data["filter"] = this.filter;
        data["voucherGroupCodeFilter"] = this.voucherGroupCodeFilter;
        data["voucherGroupNameFilter"] = this.voucherGroupNameFilter;
        data["publisherCodeFilter"] = this.publisherCodeFilter;
        data["maxPointPriceFilter"] = this.maxPointPriceFilter;
        data["minPointPriceFilter"] = this.minPointPriceFilter;
        data["maxCurrencyPriceFilter"] = this.maxCurrencyPriceFilter;
        data["minCurrencyPriceFilter"] = this.minCurrencyPriceFilter;
        data["applyForFilter"] = this.applyForFilter;
        data["titleVNFilter"] = this.titleVNFilter;
        data["titleENFilter"] = this.titleENFilter;
        data["descriptionVNFilter"] = this.descriptionVNFilter;
        data["descriptionENFilter"] = this.descriptionENFilter;
        data["imageLinkFilter"] = this.imageLinkFilter;
        data["templateFilter"] = this.templateFilter;
        data["maxGrantStartTimeFilter"] = this.maxGrantStartTimeFilter ? this.maxGrantStartTimeFilter.toISOString() : <any>undefined;
        data["minGrantStartTimeFilter"] = this.minGrantStartTimeFilter ? this.minGrantStartTimeFilter.toISOString() : <any>undefined;
        data["maxGrantEndTimeFilter"] = this.maxGrantEndTimeFilter ? this.maxGrantEndTimeFilter.toISOString() : <any>undefined;
        data["minGrantEndTimeFilter"] = this.minGrantEndTimeFilter ? this.minGrantEndTimeFilter.toISOString() : <any>undefined;
        data["billCalculationTypeFilter"] = this.billCalculationTypeFilter;
        data["maxBillTotalFilter"] = this.maxBillTotalFilter;
        data["minBillTotalFilter"] = this.minBillTotalFilter;
        data["grantApplyTypeFilter"] = this.grantApplyTypeFilter;
        data["grantAppliedLocationFilter"] = this.grantAppliedLocationFilter;
        data["grantAppliedStoreFilter"] = this.grantAppliedStoreFilter;
        data["grantAppliedProdLV1Filter"] = this.grantAppliedProdLV1Filter;
        data["grantAppliedProdLV2Filter"] = this.grantAppliedProdLV2Filter;
        data["grantAppliedProdLV3Filter"] = this.grantAppliedProdLV3Filter;
        data["grantAppliedProdLV4Filter"] = this.grantAppliedProdLV4Filter;
        data["grantAppliedProdLV5Filter"] = this.grantAppliedProdLV5Filter;
        data["grantAppliedProductFilter"] = this.grantAppliedProductFilter;
        data["redemptionApplyTypeFilter"] = this.redemptionApplyTypeFilter;
        data["redemptionApplyLocationFilter"] = this.redemptionApplyLocationFilter;
        data["redemptionApplyStoreFilter"] = this.redemptionApplyStoreFilter;
        data["redemptionAppliedProdLV1Filter"] = this.redemptionAppliedProdLV1Filter;
        data["redemptionAppliedProdLV2Filter"] = this.redemptionAppliedProdLV2Filter;
        data["redemptionAppliedProdLV3Filter"] = this.redemptionAppliedProdLV3Filter;
        data["redemptionAppliedProdLV4Filter"] = this.redemptionAppliedProdLV4Filter;
        data["redemptionAppliedProdLV5Filter"] = this.redemptionAppliedProdLV5Filter;
        data["redemptionAppliedProductFilter"] = this.redemptionAppliedProductFilter;
        data["maxRedemptionStartTimeFilter"] = this.maxRedemptionStartTimeFilter ? this.maxRedemptionStartTimeFilter.toISOString() : <any>undefined;
        data["minRedemptionStartTimeFilter"] = this.minRedemptionStartTimeFilter ? this.minRedemptionStartTimeFilter.toISOString() : <any>undefined;
        data["maxRedemptionEndTImeFilter"] = this.maxRedemptionEndTImeFilter ? this.maxRedemptionEndTImeFilter.toISOString() : <any>undefined;
        data["minRedemptionEndTImeFilter"] = this.minRedemptionEndTImeFilter ? this.minRedemptionEndTImeFilter.toISOString() : <any>undefined;
        data["redemptionTypeFilter"] = this.redemptionTypeFilter;
        data["maxDiscountAmountFilter"] = this.maxDiscountAmountFilter;
        data["minDiscountAmountFilter"] = this.minDiscountAmountFilter;
        data["maxDiscountRateFilter"] = this.maxDiscountRateFilter;
        data["minDiscountRateFilter"] = this.minDiscountRateFilter;
        data["giftCodeFilter"] = this.giftCodeFilter;
        data["maxMinPurchaseAmountFilter"] = this.maxMinPurchaseAmountFilter;
        data["minMinPurchaseAmountFilter"] = this.minMinPurchaseAmountFilter;
        data["maxMaxDiscountAmountFilter"] = this.maxMaxDiscountAmountFilter;
        data["minMaxDiscountAmountFilter"] = this.minMaxDiscountAmountFilter;
        data["maxQtyGrantPerPersonFilter"] = this.maxQtyGrantPerPersonFilter;
        data["minQtyGrantPerPersonFilter"] = this.minQtyGrantPerPersonFilter;
        data["acceptedEventFilter"] = this.acceptedEventFilter;
        data["grantMsgTemplateTypeFilter"] = this.grantMsgTemplateTypeFilter;
        data["grantMsgTemplateIDFilter"] = this.grantMsgTemplateIDFilter;
        data["grantMsgTemplateContentVNFilter"] = this.grantMsgTemplateContentVNFilter;
        data["grantMsgTemplateContentENFilter"] = this.grantMsgTemplateContentENFilter;
        data["redemptionMsgTemplateTypeFilter"] = this.redemptionMsgTemplateTypeFilter;
        data["redemptionMsgTemplateIDFilter"] = this.redemptionMsgTemplateIDFilter;
        data["redemptionMsgTemplateContentVNFilter"] = this.redemptionMsgTemplateContentVNFilter;
        data["redemptionMsgTemplateContentENFilter"] = this.redemptionMsgTemplateContentENFilter;
        data["statusFilter"] = this.statusFilter;
        data["voucherGroupNameUnsignFilter"] = this.voucherGroupNameUnsignFilter;
        data["grantNotificationChannelFilter"] = this.grantNotificationChannelFilter;
        data["redemptionNotificationChannelFilter"] = this.redemptionNotificationChannelFilter;
        data["triggerEventFilter"] = this.triggerEventFilter;
        data["eventFilterFilter"] = this.eventFilterFilter;
        data["isDailyFilter"] = this.isDailyFilter;
        data["cronFilter"] = this.cronFilter;
        data["triggerTypeFilter"] = this.triggerTypeFilter;
        data["maxTriggerDateFilter"] = this.maxTriggerDateFilter ? this.maxTriggerDateFilter.toISOString() : <any>undefined;
        data["minTriggerDateFilter"] = this.minTriggerDateFilter ? this.minTriggerDateFilter.toISOString() : <any>undefined;
        data["maxMinBillAmountFilter"] = this.maxMinBillAmountFilter;
        data["minMinBillAmountFilter"] = this.minMinBillAmountFilter;
        data["maxQtyRedeemPerPersonFilter"] = this.maxQtyRedeemPerPersonFilter;
        data["minQtyRedeemPerPersonFilter"] = this.minQtyRedeemPerPersonFilter;
        data["maxRewardTargetAudienceIDFilter"] = this.maxRewardTargetAudienceIDFilter;
        data["minRewardTargetAudienceIDFilter"] = this.minRewardTargetAudienceIDFilter;
        data["targetAudienceTypeFilter"] = this.targetAudienceTypeFilter;
        data["isEditableFilter"] = this.isEditableFilter;
        data["maxMaxDayForPOFilter"] = this.maxMaxDayForPOFilter;
        data["minMaxDayForPOFilter"] = this.minMaxDayForPOFilter;
        data["referralRewardReceiverFilter"] = this.referralRewardReceiverFilter;
        data["isGrantedFilter"] = this.isGrantedFilter;
        data["sorting"] = this.sorting;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data;
    }
}

export interface ISearchVoucherGroupInput {
    publisherName: string | undefined;
    targetAudienceCodeFilter: string | undefined;
    filter: string | undefined;
    voucherGroupCodeFilter: string | undefined;
    voucherGroupNameFilter: string | undefined;
    publisherCodeFilter: string | undefined;
    maxPointPriceFilter: number | undefined;
    minPointPriceFilter: number | undefined;
    maxCurrencyPriceFilter: number | undefined;
    minCurrencyPriceFilter: number | undefined;
    applyForFilter: string | undefined;
    titleVNFilter: string | undefined;
    titleENFilter: string | undefined;
    descriptionVNFilter: string | undefined;
    descriptionENFilter: string | undefined;
    imageLinkFilter: string | undefined;
    templateFilter: string | undefined;
    maxGrantStartTimeFilter: moment.Moment | undefined;
    minGrantStartTimeFilter: moment.Moment | undefined;
    maxGrantEndTimeFilter: moment.Moment | undefined;
    minGrantEndTimeFilter: moment.Moment | undefined;
    billCalculationTypeFilter: string | undefined;
    maxBillTotalFilter: number | undefined;
    minBillTotalFilter: number | undefined;
    grantApplyTypeFilter: string | undefined;
    grantAppliedLocationFilter: string | undefined;
    grantAppliedStoreFilter: string | undefined;
    grantAppliedProdLV1Filter: string | undefined;
    grantAppliedProdLV2Filter: string | undefined;
    grantAppliedProdLV3Filter: string | undefined;
    grantAppliedProdLV4Filter: string | undefined;
    grantAppliedProdLV5Filter: string | undefined;
    grantAppliedProductFilter: string | undefined;
    redemptionApplyTypeFilter: string | undefined;
    redemptionApplyLocationFilter: string | undefined;
    redemptionApplyStoreFilter: string | undefined;
    redemptionAppliedProdLV1Filter: string | undefined;
    redemptionAppliedProdLV2Filter: string | undefined;
    redemptionAppliedProdLV3Filter: string | undefined;
    redemptionAppliedProdLV4Filter: string | undefined;
    redemptionAppliedProdLV5Filter: string | undefined;
    redemptionAppliedProductFilter: string | undefined;
    maxRedemptionStartTimeFilter: moment.Moment | undefined;
    minRedemptionStartTimeFilter: moment.Moment | undefined;
    maxRedemptionEndTImeFilter: moment.Moment | undefined;
    minRedemptionEndTImeFilter: moment.Moment | undefined;
    redemptionTypeFilter: string | undefined;
    maxDiscountAmountFilter: number | undefined;
    minDiscountAmountFilter: number | undefined;
    maxDiscountRateFilter: number | undefined;
    minDiscountRateFilter: number | undefined;
    giftCodeFilter: string | undefined;
    maxMinPurchaseAmountFilter: number | undefined;
    minMinPurchaseAmountFilter: number | undefined;
    maxMaxDiscountAmountFilter: number | undefined;
    minMaxDiscountAmountFilter: number | undefined;
    maxQtyGrantPerPersonFilter: number | undefined;
    minQtyGrantPerPersonFilter: number | undefined;
    acceptedEventFilter: string | undefined;
    grantMsgTemplateTypeFilter: string | undefined;
    grantMsgTemplateIDFilter: string | undefined;
    grantMsgTemplateContentVNFilter: string | undefined;
    grantMsgTemplateContentENFilter: string | undefined;
    redemptionMsgTemplateTypeFilter: string | undefined;
    redemptionMsgTemplateIDFilter: string | undefined;
    redemptionMsgTemplateContentVNFilter: string | undefined;
    redemptionMsgTemplateContentENFilter: string | undefined;
    statusFilter: string | undefined;
    voucherGroupNameUnsignFilter: string | undefined;
    grantNotificationChannelFilter: string | undefined;
    redemptionNotificationChannelFilter: string | undefined;
    triggerEventFilter: string | undefined;
    eventFilterFilter: string | undefined;
    isDailyFilter: number | undefined;
    cronFilter: string | undefined;
    triggerTypeFilter: string | undefined;
    maxTriggerDateFilter: moment.Moment | undefined;
    minTriggerDateFilter: moment.Moment | undefined;
    maxMinBillAmountFilter: number | undefined;
    minMinBillAmountFilter: number | undefined;
    maxQtyRedeemPerPersonFilter: number | undefined;
    minQtyRedeemPerPersonFilter: number | undefined;
    maxRewardTargetAudienceIDFilter: number | undefined;
    minRewardTargetAudienceIDFilter: number | undefined;
    targetAudienceTypeFilter: string | undefined;
    isEditableFilter: number | undefined;
    maxMaxDayForPOFilter: number | undefined;
    minMaxDayForPOFilter: number | undefined;
    referralRewardReceiverFilter: string | undefined;
    isGrantedFilter: number | undefined;
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;
}

export class VoucherSettingAdvanceSearchModel implements IVoucherSettingAdvanceSearchModel {
    publishers!: ComboboxDataModel[] | undefined;
    applyFors!: string[] | undefined;
    redemptionTypes!: string[] | undefined;
    billCalculationTypes!: string[] | undefined;
    voucherGrantConditionApplyFors!: string[] | undefined;
    voucherRedemptionConditionMaxQuantitys!: string[] | undefined;
    voucherNotificationTemplateTypes!: string[] | undefined;
    targetAudienceTypes!: string[] | undefined;
    rewardNotificationChannel!: string[] | undefined;
    referalRewardReceiver!: string[] | undefined;

    constructor(data?: IVoucherSettingAdvanceSearchModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["publishers"] && data["publishers"].constructor === Array) {
                this.publishers = [];
                for (let item of data["publishers"])
                    this.publishers.push(ComboboxDataModel.fromJS(item));
            }
            if (data["applyFors"] && data["applyFors"].constructor === Array) {
                this.applyFors = [];
                for (let item of data["applyFors"])
                    this.applyFors.push(item);
            }
            if (data["redemptionTypes"] && data["redemptionTypes"].constructor === Array) {
                this.redemptionTypes = [];
                for (let item of data["redemptionTypes"])
                    this.redemptionTypes.push(item);
            }
            if (data["billCalculationTypes"] && data["billCalculationTypes"].constructor === Array) {
                this.billCalculationTypes = [];
                for (let item of data["billCalculationTypes"])
                    this.billCalculationTypes.push(item);
            }
            if (data["voucherGrantConditionApplyFors"] && data["voucherGrantConditionApplyFors"].constructor === Array) {
                this.voucherGrantConditionApplyFors = [];
                for (let item of data["voucherGrantConditionApplyFors"])
                    this.voucherGrantConditionApplyFors.push(item);
            }
            if (data["voucherRedemptionConditionMaxQuantitys"] && data["voucherRedemptionConditionMaxQuantitys"].constructor === Array) {
                this.voucherRedemptionConditionMaxQuantitys = [];
                for (let item of data["voucherRedemptionConditionMaxQuantitys"])
                    this.voucherRedemptionConditionMaxQuantitys.push(item);
            }
            if (data["voucherNotificationTemplateTypes"] && data["voucherNotificationTemplateTypes"].constructor === Array) {
                this.voucherNotificationTemplateTypes = [];
                for (let item of data["voucherNotificationTemplateTypes"])
                    this.voucherNotificationTemplateTypes.push(item);
            }
            if (data["targetAudienceTypes"] && data["targetAudienceTypes"].constructor === Array) {
                this.targetAudienceTypes = [];
                for (let item of data["targetAudienceTypes"])
                    this.targetAudienceTypes.push(item);
            }
            if (data["rewardNotificationChannel"] && data["rewardNotificationChannel"].constructor === Array) {
                this.rewardNotificationChannel = [];
                for (let item of data["rewardNotificationChannel"])
                    this.rewardNotificationChannel.push(item);
            }
            if (data["referalRewardReceiver"] && data["referalRewardReceiver"].constructor === Array) {
                this.referalRewardReceiver = [];
                for (let item of data["referalRewardReceiver"])
                    this.referalRewardReceiver.push(item);
            }
        }
    }

    static fromJS(data: any): VoucherSettingAdvanceSearchModel {
        data = typeof data === 'object' ? data : {};
        let result = new VoucherSettingAdvanceSearchModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.publishers && this.publishers.constructor === Array) {
            data["publishers"] = [];
            for (let item of this.publishers)
                data["publishers"].push(item.toJSON());
        }
        if (this.applyFors && this.applyFors.constructor === Array) {
            data["applyFors"] = [];
            for (let item of this.applyFors)
                data["applyFors"].push(item);
        }
        if (this.redemptionTypes && this.redemptionTypes.constructor === Array) {
            data["redemptionTypes"] = [];
            for (let item of this.redemptionTypes)
                data["redemptionTypes"].push(item);
        }
        if (this.billCalculationTypes && this.billCalculationTypes.constructor === Array) {
            data["billCalculationTypes"] = [];
            for (let item of this.billCalculationTypes)
                data["billCalculationTypes"].push(item);
        }
        if (this.voucherGrantConditionApplyFors && this.voucherGrantConditionApplyFors.constructor === Array) {
            data["voucherGrantConditionApplyFors"] = [];
            for (let item of this.voucherGrantConditionApplyFors)
                data["voucherGrantConditionApplyFors"].push(item);
        }
        if (this.voucherRedemptionConditionMaxQuantitys && this.voucherRedemptionConditionMaxQuantitys.constructor === Array) {
            data["voucherRedemptionConditionMaxQuantitys"] = [];
            for (let item of this.voucherRedemptionConditionMaxQuantitys)
                data["voucherRedemptionConditionMaxQuantitys"].push(item);
        }
        if (this.voucherNotificationTemplateTypes && this.voucherNotificationTemplateTypes.constructor === Array) {
            data["voucherNotificationTemplateTypes"] = [];
            for (let item of this.voucherNotificationTemplateTypes)
                data["voucherNotificationTemplateTypes"].push(item);
        }
        if (this.targetAudienceTypes && this.targetAudienceTypes.constructor === Array) {
            data["targetAudienceTypes"] = [];
            for (let item of this.targetAudienceTypes)
                data["targetAudienceTypes"].push(item);
        }
        if (this.rewardNotificationChannel && this.rewardNotificationChannel.constructor === Array) {
            data["rewardNotificationChannel"] = [];
            for (let item of this.rewardNotificationChannel)
                data["rewardNotificationChannel"].push(item);
        }
        if (this.referalRewardReceiver && this.referalRewardReceiver.constructor === Array) {
            data["referalRewardReceiver"] = [];
            for (let item of this.referalRewardReceiver)
                data["referalRewardReceiver"].push(item);
        }
        return data;
    }
}

export interface IVoucherSettingAdvanceSearchModel {
    publishers: ComboboxDataModel[] | undefined;
    applyFors: string[] | undefined;
    redemptionTypes: string[] | undefined;
    billCalculationTypes: string[] | undefined;
    voucherGrantConditionApplyFors: string[] | undefined;
    voucherRedemptionConditionMaxQuantitys: string[] | undefined;
    voucherNotificationTemplateTypes: string[] | undefined;
    targetAudienceTypes: string[] | undefined;
    rewardNotificationChannel: string[] | undefined;
    referalRewardReceiver: string[] | undefined;
}

export class ComboboxDataModel implements IComboboxDataModel {
    text!: string | undefined;
    value!: any | undefined;

    constructor(data?: IComboboxDataModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.text = data["text"];
            this.value = data["value"];
        }
    }

    static fromJS(data: any): ComboboxDataModel {
        data = typeof data === 'object' ? data : {};
        let result = new ComboboxDataModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text;
        data["value"] = this.value;
        return data;
    }
}

export interface IComboboxDataModel {
    text: string | undefined;
    value: any | undefined;
}

export class EventDefinition implements IEventDefinition {
    name!: string | undefined;
    eventData!: string | undefined;
    applyFor!: string | undefined;

    constructor(data?: IEventDefinition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.eventData = data["eventData"];
            this.applyFor = data["applyFor"];
        }
    }

    static fromJS(data: any): EventDefinition {
        data = typeof data === 'object' ? data : {};
        let result = new EventDefinition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["eventData"] = this.eventData;
        data["applyFor"] = this.applyFor;
        return data;
    }
}

export interface IEventDefinition {
    name: string | undefined;
    eventData: string | undefined;
    applyFor: string | undefined;
}

export class PagedResultDtoOfGetVoucherPatternForViewDto implements IPagedResultDtoOfGetVoucherPatternForViewDto {
    totalCount!: number | undefined;
    items!: GetVoucherPatternForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetVoucherPatternForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetVoucherPatternForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetVoucherPatternForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetVoucherPatternForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetVoucherPatternForViewDto {
    totalCount: number | undefined;
    items: GetVoucherPatternForViewDto[] | undefined;
}

export class GetVoucherPatternForViewDto implements IGetVoucherPatternForViewDto {
    voucherPattern!: VoucherPatternDto | undefined;

    constructor(data?: IGetVoucherPatternForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.voucherPattern = data["voucherPattern"] ? VoucherPatternDto.fromJS(data["voucherPattern"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetVoucherPatternForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetVoucherPatternForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["voucherPattern"] = this.voucherPattern ? this.voucherPattern.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetVoucherPatternForViewDto {
    voucherPattern: VoucherPatternDto | undefined;
}

export class VoucherPatternDto implements IVoucherPatternDto {
    patternName!: string | undefined;
    prefix!: string | undefined;
    charSet!: string | undefined;
    lengthAutoGenString!: string | undefined;
    postfix!: string | undefined;
    voucherGroupCode!: string | undefined;
    voucherGroupName!: string | undefined;
    notes!: string | undefined;
    status!: string | undefined;
    patternCode!: string | undefined;
    patternNameUnsign!: string | undefined;
    id!: number | undefined;

    constructor(data?: IVoucherPatternDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.patternName = data["patternName"];
            this.prefix = data["prefix"];
            this.charSet = data["charSet"];
            this.lengthAutoGenString = data["lengthAutoGenString"];
            this.postfix = data["postfix"];
            this.voucherGroupCode = data["voucherGroupCode"];
            this.voucherGroupName = data["voucherGroupName"];
            this.notes = data["notes"];
            this.status = data["status"];
            this.patternCode = data["patternCode"];
            this.patternNameUnsign = data["patternNameUnsign"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): VoucherPatternDto {
        data = typeof data === 'object' ? data : {};
        let result = new VoucherPatternDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patternName"] = this.patternName;
        data["prefix"] = this.prefix;
        data["charSet"] = this.charSet;
        data["lengthAutoGenString"] = this.lengthAutoGenString;
        data["postfix"] = this.postfix;
        data["voucherGroupCode"] = this.voucherGroupCode;
        data["voucherGroupName"] = this.voucherGroupName;
        data["notes"] = this.notes;
        data["status"] = this.status;
        data["patternCode"] = this.patternCode;
        data["patternNameUnsign"] = this.patternNameUnsign;
        data["id"] = this.id;
        return data;
    }
}

export interface IVoucherPatternDto {
    patternName: string | undefined;
    prefix: string | undefined;
    charSet: string | undefined;
    lengthAutoGenString: string | undefined;
    postfix: string | undefined;
    voucherGroupCode: string | undefined;
    voucherGroupName: string | undefined;
    notes: string | undefined;
    status: string | undefined;
    patternCode: string | undefined;
    patternNameUnsign: string | undefined;
    id: number | undefined;
}

export class GetVoucherPatternForEditOutput implements IGetVoucherPatternForEditOutput {
    voucherPattern!: CreateOrEditVoucherPatternDto | undefined;

    constructor(data?: IGetVoucherPatternForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.voucherPattern = data["voucherPattern"] ? CreateOrEditVoucherPatternDto.fromJS(data["voucherPattern"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetVoucherPatternForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetVoucherPatternForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["voucherPattern"] = this.voucherPattern ? this.voucherPattern.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetVoucherPatternForEditOutput {
    voucherPattern: CreateOrEditVoucherPatternDto | undefined;
}

export class GetVoucherGroupForPatternDto implements IGetVoucherGroupForPatternDto {
    voucherGroup!: VoucherGroup | undefined;
    maxGrantQuantity!: number | undefined;

    constructor(data?: IGetVoucherGroupForPatternDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.voucherGroup = data["voucherGroup"] ? VoucherGroup.fromJS(data["voucherGroup"]) : <any>undefined;
            this.maxGrantQuantity = data["maxGrantQuantity"];
        }
    }

    static fromJS(data: any): GetVoucherGroupForPatternDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetVoucherGroupForPatternDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["voucherGroup"] = this.voucherGroup ? this.voucherGroup.toJSON() : <any>undefined;
        data["maxGrantQuantity"] = this.maxGrantQuantity;
        return data;
    }
}

export interface IGetVoucherGroupForPatternDto {
    voucherGroup: VoucherGroup | undefined;
    maxGrantQuantity: number | undefined;
}

export class VoucherGroup implements IVoucherGroup {
    tenantId!: number | undefined;
    voucherGroupCode!: string | undefined;
    voucherGroupName!: string | undefined;
    publisherCode!: string | undefined;
    pointPrice!: number | undefined;
    currencyPrice!: number | undefined;
    applyFor!: string | undefined;
    titleVN!: string | undefined;
    titleEN!: string | undefined;
    descriptionVN!: string | undefined;
    descriptionEN!: string | undefined;
    imageLink!: string | undefined;
    template!: string | undefined;
    grantStartTime!: moment.Moment | undefined;
    grantEndTime!: moment.Moment | undefined;
    billCalculationType!: string | undefined;
    billTotal!: number | undefined;
    grantApplyType!: string | undefined;
    grantAppliedLocation!: string | undefined;
    grantAppliedStore!: string | undefined;
    grantAppliedProdLV1!: string | undefined;
    grantAppliedProdLV2!: string | undefined;
    grantAppliedProdLV3!: string | undefined;
    grantAppliedProdLV4!: string | undefined;
    grantAppliedProdLV5!: string | undefined;
    grantAppliedProduct!: string | undefined;
    redemptionApplyType!: string | undefined;
    redemptionApplyLocation!: string | undefined;
    redemptionApplyStore!: string | undefined;
    redemptionAppliedProdLV1!: string | undefined;
    redemptionAppliedProdLV2!: string | undefined;
    redemptionAppliedProdLV3!: string | undefined;
    redemptionAppliedProdLV4!: string | undefined;
    redemptionAppliedProdLV5!: string | undefined;
    redemptionAppliedProduct!: string | undefined;
    redemptionStartTime!: moment.Moment | undefined;
    redemptionEndTIme!: moment.Moment | undefined;
    redemptionType!: string | undefined;
    discountAmount!: number | undefined;
    discountRate!: number | undefined;
    giftCode!: string | undefined;
    minPurchaseAmount!: number | undefined;
    maxDiscountAmount!: number | undefined;
    qtyGrantPerPerson!: number | undefined;
    acceptedEvent!: string | undefined;
    grantMsgTemplateType!: string | undefined;
    grantMsgTemplateID!: string | undefined;
    grantMsgTemplateContentVN!: string | undefined;
    grantMsgTemplateContentEN!: string | undefined;
    redemptionMsgTemplateType!: string | undefined;
    redemptionMsgTemplateID!: string | undefined;
    redemptionMsgTemplateContentVN!: string | undefined;
    redemptionMsgTemplateContentEN!: string | undefined;
    status!: string | undefined;
    voucherGroupNameUnsign!: string | undefined;
    grantNotificationChannel!: string | undefined;
    redemptionNotificationChannel!: string | undefined;
    triggerEvent!: string | undefined;
    eventFilter!: string | undefined;
    isDaily!: boolean | undefined;
    cron!: string | undefined;
    triggerType!: string | undefined;
    triggerDate!: moment.Moment | undefined;
    minBillAmount!: number | undefined;
    qtyRedeemPerPerson!: number | undefined;
    rewardTargetAudienceID!: number | undefined;
    targetAudienceType!: string | undefined;
    isEditable!: boolean | undefined;
    maxDayForPO!: number | undefined;
    referralRewardReceiver!: string | undefined;
    isGranted!: boolean | undefined;
    isDeleted!: boolean | undefined;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: moment.Moment | undefined;
    creatorUserId!: number | undefined;
    id!: number | undefined;

    constructor(data?: IVoucherGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.voucherGroupCode = data["voucherGroupCode"];
            this.voucherGroupName = data["voucherGroupName"];
            this.publisherCode = data["publisherCode"];
            this.pointPrice = data["pointPrice"];
            this.currencyPrice = data["currencyPrice"];
            this.applyFor = data["applyFor"];
            this.titleVN = data["titleVN"];
            this.titleEN = data["titleEN"];
            this.descriptionVN = data["descriptionVN"];
            this.descriptionEN = data["descriptionEN"];
            this.imageLink = data["imageLink"];
            this.template = data["template"];
            this.grantStartTime = data["grantStartTime"] ? moment(data["grantStartTime"].toString()) : <any>undefined;
            this.grantEndTime = data["grantEndTime"] ? moment(data["grantEndTime"].toString()) : <any>undefined;
            this.billCalculationType = data["billCalculationType"];
            this.billTotal = data["billTotal"];
            this.grantApplyType = data["grantApplyType"];
            this.grantAppliedLocation = data["grantAppliedLocation"];
            this.grantAppliedStore = data["grantAppliedStore"];
            this.grantAppliedProdLV1 = data["grantAppliedProdLV1"];
            this.grantAppliedProdLV2 = data["grantAppliedProdLV2"];
            this.grantAppliedProdLV3 = data["grantAppliedProdLV3"];
            this.grantAppliedProdLV4 = data["grantAppliedProdLV4"];
            this.grantAppliedProdLV5 = data["grantAppliedProdLV5"];
            this.grantAppliedProduct = data["grantAppliedProduct"];
            this.redemptionApplyType = data["redemptionApplyType"];
            this.redemptionApplyLocation = data["redemptionApplyLocation"];
            this.redemptionApplyStore = data["redemptionApplyStore"];
            this.redemptionAppliedProdLV1 = data["redemptionAppliedProdLV1"];
            this.redemptionAppliedProdLV2 = data["redemptionAppliedProdLV2"];
            this.redemptionAppliedProdLV3 = data["redemptionAppliedProdLV3"];
            this.redemptionAppliedProdLV4 = data["redemptionAppliedProdLV4"];
            this.redemptionAppliedProdLV5 = data["redemptionAppliedProdLV5"];
            this.redemptionAppliedProduct = data["redemptionAppliedProduct"];
            this.redemptionStartTime = data["redemptionStartTime"] ? moment(data["redemptionStartTime"].toString()) : <any>undefined;
            this.redemptionEndTIme = data["redemptionEndTIme"] ? moment(data["redemptionEndTIme"].toString()) : <any>undefined;
            this.redemptionType = data["redemptionType"];
            this.discountAmount = data["discountAmount"];
            this.discountRate = data["discountRate"];
            this.giftCode = data["giftCode"];
            this.minPurchaseAmount = data["minPurchaseAmount"];
            this.maxDiscountAmount = data["maxDiscountAmount"];
            this.qtyGrantPerPerson = data["qtyGrantPerPerson"];
            this.acceptedEvent = data["acceptedEvent"];
            this.grantMsgTemplateType = data["grantMsgTemplateType"];
            this.grantMsgTemplateID = data["grantMsgTemplateID"];
            this.grantMsgTemplateContentVN = data["grantMsgTemplateContentVN"];
            this.grantMsgTemplateContentEN = data["grantMsgTemplateContentEN"];
            this.redemptionMsgTemplateType = data["redemptionMsgTemplateType"];
            this.redemptionMsgTemplateID = data["redemptionMsgTemplateID"];
            this.redemptionMsgTemplateContentVN = data["redemptionMsgTemplateContentVN"];
            this.redemptionMsgTemplateContentEN = data["redemptionMsgTemplateContentEN"];
            this.status = data["status"];
            this.voucherGroupNameUnsign = data["voucherGroupNameUnsign"];
            this.grantNotificationChannel = data["grantNotificationChannel"];
            this.redemptionNotificationChannel = data["redemptionNotificationChannel"];
            this.triggerEvent = data["triggerEvent"];
            this.eventFilter = data["eventFilter"];
            this.isDaily = data["isDaily"];
            this.cron = data["cron"];
            this.triggerType = data["triggerType"];
            this.triggerDate = data["triggerDate"] ? moment(data["triggerDate"].toString()) : <any>undefined;
            this.minBillAmount = data["minBillAmount"];
            this.qtyRedeemPerPerson = data["qtyRedeemPerPerson"];
            this.rewardTargetAudienceID = data["rewardTargetAudienceID"];
            this.targetAudienceType = data["targetAudienceType"];
            this.isEditable = data["isEditable"];
            this.maxDayForPO = data["maxDayForPO"];
            this.referralRewardReceiver = data["referralRewardReceiver"];
            this.isGranted = data["isGranted"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): VoucherGroup {
        data = typeof data === 'object' ? data : {};
        let result = new VoucherGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["voucherGroupCode"] = this.voucherGroupCode;
        data["voucherGroupName"] = this.voucherGroupName;
        data["publisherCode"] = this.publisherCode;
        data["pointPrice"] = this.pointPrice;
        data["currencyPrice"] = this.currencyPrice;
        data["applyFor"] = this.applyFor;
        data["titleVN"] = this.titleVN;
        data["titleEN"] = this.titleEN;
        data["descriptionVN"] = this.descriptionVN;
        data["descriptionEN"] = this.descriptionEN;
        data["imageLink"] = this.imageLink;
        data["template"] = this.template;
        data["grantStartTime"] = this.grantStartTime ? this.grantStartTime.toISOString() : <any>undefined;
        data["grantEndTime"] = this.grantEndTime ? this.grantEndTime.toISOString() : <any>undefined;
        data["billCalculationType"] = this.billCalculationType;
        data["billTotal"] = this.billTotal;
        data["grantApplyType"] = this.grantApplyType;
        data["grantAppliedLocation"] = this.grantAppliedLocation;
        data["grantAppliedStore"] = this.grantAppliedStore;
        data["grantAppliedProdLV1"] = this.grantAppliedProdLV1;
        data["grantAppliedProdLV2"] = this.grantAppliedProdLV2;
        data["grantAppliedProdLV3"] = this.grantAppliedProdLV3;
        data["grantAppliedProdLV4"] = this.grantAppliedProdLV4;
        data["grantAppliedProdLV5"] = this.grantAppliedProdLV5;
        data["grantAppliedProduct"] = this.grantAppliedProduct;
        data["redemptionApplyType"] = this.redemptionApplyType;
        data["redemptionApplyLocation"] = this.redemptionApplyLocation;
        data["redemptionApplyStore"] = this.redemptionApplyStore;
        data["redemptionAppliedProdLV1"] = this.redemptionAppliedProdLV1;
        data["redemptionAppliedProdLV2"] = this.redemptionAppliedProdLV2;
        data["redemptionAppliedProdLV3"] = this.redemptionAppliedProdLV3;
        data["redemptionAppliedProdLV4"] = this.redemptionAppliedProdLV4;
        data["redemptionAppliedProdLV5"] = this.redemptionAppliedProdLV5;
        data["redemptionAppliedProduct"] = this.redemptionAppliedProduct;
        data["redemptionStartTime"] = this.redemptionStartTime ? this.redemptionStartTime.toISOString() : <any>undefined;
        data["redemptionEndTIme"] = this.redemptionEndTIme ? this.redemptionEndTIme.toISOString() : <any>undefined;
        data["redemptionType"] = this.redemptionType;
        data["discountAmount"] = this.discountAmount;
        data["discountRate"] = this.discountRate;
        data["giftCode"] = this.giftCode;
        data["minPurchaseAmount"] = this.minPurchaseAmount;
        data["maxDiscountAmount"] = this.maxDiscountAmount;
        data["qtyGrantPerPerson"] = this.qtyGrantPerPerson;
        data["acceptedEvent"] = this.acceptedEvent;
        data["grantMsgTemplateType"] = this.grantMsgTemplateType;
        data["grantMsgTemplateID"] = this.grantMsgTemplateID;
        data["grantMsgTemplateContentVN"] = this.grantMsgTemplateContentVN;
        data["grantMsgTemplateContentEN"] = this.grantMsgTemplateContentEN;
        data["redemptionMsgTemplateType"] = this.redemptionMsgTemplateType;
        data["redemptionMsgTemplateID"] = this.redemptionMsgTemplateID;
        data["redemptionMsgTemplateContentVN"] = this.redemptionMsgTemplateContentVN;
        data["redemptionMsgTemplateContentEN"] = this.redemptionMsgTemplateContentEN;
        data["status"] = this.status;
        data["voucherGroupNameUnsign"] = this.voucherGroupNameUnsign;
        data["grantNotificationChannel"] = this.grantNotificationChannel;
        data["redemptionNotificationChannel"] = this.redemptionNotificationChannel;
        data["triggerEvent"] = this.triggerEvent;
        data["eventFilter"] = this.eventFilter;
        data["isDaily"] = this.isDaily;
        data["cron"] = this.cron;
        data["triggerType"] = this.triggerType;
        data["triggerDate"] = this.triggerDate ? this.triggerDate.toISOString() : <any>undefined;
        data["minBillAmount"] = this.minBillAmount;
        data["qtyRedeemPerPerson"] = this.qtyRedeemPerPerson;
        data["rewardTargetAudienceID"] = this.rewardTargetAudienceID;
        data["targetAudienceType"] = this.targetAudienceType;
        data["isEditable"] = this.isEditable;
        data["maxDayForPO"] = this.maxDayForPO;
        data["referralRewardReceiver"] = this.referralRewardReceiver;
        data["isGranted"] = this.isGranted;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IVoucherGroup {
    tenantId: number | undefined;
    voucherGroupCode: string | undefined;
    voucherGroupName: string | undefined;
    publisherCode: string | undefined;
    pointPrice: number | undefined;
    currencyPrice: number | undefined;
    applyFor: string | undefined;
    titleVN: string | undefined;
    titleEN: string | undefined;
    descriptionVN: string | undefined;
    descriptionEN: string | undefined;
    imageLink: string | undefined;
    template: string | undefined;
    grantStartTime: moment.Moment | undefined;
    grantEndTime: moment.Moment | undefined;
    billCalculationType: string | undefined;
    billTotal: number | undefined;
    grantApplyType: string | undefined;
    grantAppliedLocation: string | undefined;
    grantAppliedStore: string | undefined;
    grantAppliedProdLV1: string | undefined;
    grantAppliedProdLV2: string | undefined;
    grantAppliedProdLV3: string | undefined;
    grantAppliedProdLV4: string | undefined;
    grantAppliedProdLV5: string | undefined;
    grantAppliedProduct: string | undefined;
    redemptionApplyType: string | undefined;
    redemptionApplyLocation: string | undefined;
    redemptionApplyStore: string | undefined;
    redemptionAppliedProdLV1: string | undefined;
    redemptionAppliedProdLV2: string | undefined;
    redemptionAppliedProdLV3: string | undefined;
    redemptionAppliedProdLV4: string | undefined;
    redemptionAppliedProdLV5: string | undefined;
    redemptionAppliedProduct: string | undefined;
    redemptionStartTime: moment.Moment | undefined;
    redemptionEndTIme: moment.Moment | undefined;
    redemptionType: string | undefined;
    discountAmount: number | undefined;
    discountRate: number | undefined;
    giftCode: string | undefined;
    minPurchaseAmount: number | undefined;
    maxDiscountAmount: number | undefined;
    qtyGrantPerPerson: number | undefined;
    acceptedEvent: string | undefined;
    grantMsgTemplateType: string | undefined;
    grantMsgTemplateID: string | undefined;
    grantMsgTemplateContentVN: string | undefined;
    grantMsgTemplateContentEN: string | undefined;
    redemptionMsgTemplateType: string | undefined;
    redemptionMsgTemplateID: string | undefined;
    redemptionMsgTemplateContentVN: string | undefined;
    redemptionMsgTemplateContentEN: string | undefined;
    status: string | undefined;
    voucherGroupNameUnsign: string | undefined;
    grantNotificationChannel: string | undefined;
    redemptionNotificationChannel: string | undefined;
    triggerEvent: string | undefined;
    eventFilter: string | undefined;
    isDaily: boolean | undefined;
    cron: string | undefined;
    triggerType: string | undefined;
    triggerDate: moment.Moment | undefined;
    minBillAmount: number | undefined;
    qtyRedeemPerPerson: number | undefined;
    rewardTargetAudienceID: number | undefined;
    targetAudienceType: string | undefined;
    isEditable: boolean | undefined;
    maxDayForPO: number | undefined;
    referralRewardReceiver: string | undefined;
    isGranted: boolean | undefined;
    isDeleted: boolean | undefined;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
    id: number | undefined;
}

export class ConditionFilterVoucherReport implements IConditionFilterVoucherReport {
    publisherName!: string[] | undefined;
    targetAudienceName!: string[] | undefined;

    constructor(data?: IConditionFilterVoucherReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["publisherName"] && data["publisherName"].constructor === Array) {
                this.publisherName = [];
                for (let item of data["publisherName"])
                    this.publisherName.push(item);
            }
            if (data["targetAudienceName"] && data["targetAudienceName"].constructor === Array) {
                this.targetAudienceName = [];
                for (let item of data["targetAudienceName"])
                    this.targetAudienceName.push(item);
            }
        }
    }

    static fromJS(data: any): ConditionFilterVoucherReport {
        data = typeof data === 'object' ? data : {};
        let result = new ConditionFilterVoucherReport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.publisherName && this.publisherName.constructor === Array) {
            data["publisherName"] = [];
            for (let item of this.publisherName)
                data["publisherName"].push(item);
        }
        if (this.targetAudienceName && this.targetAudienceName.constructor === Array) {
            data["targetAudienceName"] = [];
            for (let item of this.targetAudienceName)
                data["targetAudienceName"].push(item);
        }
        return data;
    }
}

export interface IConditionFilterVoucherReport {
    publisherName: string[] | undefined;
    targetAudienceName: string[] | undefined;
}

export class VoucherReportInput implements IVoucherReportInput {
    voucherFilter!: string | undefined;
    voucherGroupNameFilter!: string | undefined;
    redemptionTypeFilter!: string | undefined;
    grantStartTimeFilter!: moment.Moment | undefined;
    redemptionStartTimeFilter!: moment.Moment | undefined;
    publisherNameFilter!: string | undefined;
    applyForFilter!: string | undefined;
    targetAudienceNameFilter!: string | undefined;
    sorting!: string | undefined;
    skipCount!: number | undefined;
    maxResultCount!: number | undefined;

    constructor(data?: IVoucherReportInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.voucherFilter = data["voucherFilter"];
            this.voucherGroupNameFilter = data["voucherGroupNameFilter"];
            this.redemptionTypeFilter = data["redemptionTypeFilter"];
            this.grantStartTimeFilter = data["grantStartTimeFilter"] ? moment(data["grantStartTimeFilter"].toString()) : <any>undefined;
            this.redemptionStartTimeFilter = data["redemptionStartTimeFilter"] ? moment(data["redemptionStartTimeFilter"].toString()) : <any>undefined;
            this.publisherNameFilter = data["publisherNameFilter"];
            this.applyForFilter = data["applyForFilter"];
            this.targetAudienceNameFilter = data["targetAudienceNameFilter"];
            this.sorting = data["sorting"];
            this.skipCount = data["skipCount"];
            this.maxResultCount = data["maxResultCount"];
        }
    }

    static fromJS(data: any): VoucherReportInput {
        data = typeof data === 'object' ? data : {};
        let result = new VoucherReportInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["voucherFilter"] = this.voucherFilter;
        data["voucherGroupNameFilter"] = this.voucherGroupNameFilter;
        data["redemptionTypeFilter"] = this.redemptionTypeFilter;
        data["grantStartTimeFilter"] = this.grantStartTimeFilter ? this.grantStartTimeFilter.toISOString() : <any>undefined;
        data["redemptionStartTimeFilter"] = this.redemptionStartTimeFilter ? this.redemptionStartTimeFilter.toISOString() : <any>undefined;
        data["publisherNameFilter"] = this.publisherNameFilter;
        data["applyForFilter"] = this.applyForFilter;
        data["targetAudienceNameFilter"] = this.targetAudienceNameFilter;
        data["sorting"] = this.sorting;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data;
    }
}

export interface IVoucherReportInput {
    voucherFilter: string | undefined;
    voucherGroupNameFilter: string | undefined;
    redemptionTypeFilter: string | undefined;
    grantStartTimeFilter: moment.Moment | undefined;
    redemptionStartTimeFilter: moment.Moment | undefined;
    publisherNameFilter: string | undefined;
    applyForFilter: string | undefined;
    targetAudienceNameFilter: string | undefined;
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;
}

export class PagedResultDtoOfVoucherReportForViewDto implements IPagedResultDtoOfVoucherReportForViewDto {
    totalCount!: number | undefined;
    items!: VoucherReportForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfVoucherReportForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(VoucherReportForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfVoucherReportForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfVoucherReportForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfVoucherReportForViewDto {
    totalCount: number | undefined;
    items: VoucherReportForViewDto[] | undefined;
}

export class VoucherReportForViewDto implements IVoucherReportForViewDto {
    voucherReport!: VoucherReportDto | undefined;

    constructor(data?: IVoucherReportForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.voucherReport = data["voucherReport"] ? VoucherReportDto.fromJS(data["voucherReport"]) : <any>undefined;
        }
    }

    static fromJS(data: any): VoucherReportForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new VoucherReportForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["voucherReport"] = this.voucherReport ? this.voucherReport.toJSON() : <any>undefined;
        return data;
    }
}

export interface IVoucherReportForViewDto {
    voucherReport: VoucherReportDto | undefined;
}

export class VoucherReportDto implements IVoucherReportDto {
    voucherName!: string | undefined;
    publisher!: string | undefined;
    appliedfor!: string | undefined;
    targetAudience!: string | undefined;
    grantStartTime!: moment.Moment | undefined;
    grantperiod!: moment.Moment | undefined;
    redemptionStartTime!: moment.Moment | undefined;
    redemptionPeriod!: moment.Moment | undefined;
    redemptionType!: string | undefined;
    budget!: number | undefined;
    used!: number | undefined;
    id!: number | undefined;
    voucherNameUnsign!: string | undefined;
    voucherGroupCode!: string | undefined;
    discountAmount!: number | undefined;
    discountRate!: number | undefined;

    constructor(data?: IVoucherReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.voucherName = data["voucherName"];
            this.publisher = data["publisher"];
            this.appliedfor = data["appliedfor"];
            this.targetAudience = data["targetAudience"];
            this.grantStartTime = data["grantStartTime"] ? moment(data["grantStartTime"].toString()) : <any>undefined;
            this.grantperiod = data["grantperiod"] ? moment(data["grantperiod"].toString()) : <any>undefined;
            this.redemptionStartTime = data["redemptionStartTime"] ? moment(data["redemptionStartTime"].toString()) : <any>undefined;
            this.redemptionPeriod = data["redemptionPeriod"] ? moment(data["redemptionPeriod"].toString()) : <any>undefined;
            this.redemptionType = data["redemptionType"];
            this.budget = data["budget"];
            this.used = data["used"];
            this.id = data["id"];
            this.voucherNameUnsign = data["voucherNameUnsign"];
            this.voucherGroupCode = data["voucherGroupCode"];
            this.discountAmount = data["discountAmount"];
            this.discountRate = data["discountRate"];
        }
    }

    static fromJS(data: any): VoucherReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new VoucherReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["voucherName"] = this.voucherName;
        data["publisher"] = this.publisher;
        data["appliedfor"] = this.appliedfor;
        data["targetAudience"] = this.targetAudience;
        data["grantStartTime"] = this.grantStartTime ? this.grantStartTime.toISOString() : <any>undefined;
        data["grantperiod"] = this.grantperiod ? this.grantperiod.toISOString() : <any>undefined;
        data["redemptionStartTime"] = this.redemptionStartTime ? this.redemptionStartTime.toISOString() : <any>undefined;
        data["redemptionPeriod"] = this.redemptionPeriod ? this.redemptionPeriod.toISOString() : <any>undefined;
        data["redemptionType"] = this.redemptionType;
        data["budget"] = this.budget;
        data["used"] = this.used;
        data["id"] = this.id;
        data["voucherNameUnsign"] = this.voucherNameUnsign;
        data["voucherGroupCode"] = this.voucherGroupCode;
        data["discountAmount"] = this.discountAmount;
        data["discountRate"] = this.discountRate;
        return data;
    }
}

export interface IVoucherReportDto {
    voucherName: string | undefined;
    publisher: string | undefined;
    appliedfor: string | undefined;
    targetAudience: string | undefined;
    grantStartTime: moment.Moment | undefined;
    grantperiod: moment.Moment | undefined;
    redemptionStartTime: moment.Moment | undefined;
    redemptionPeriod: moment.Moment | undefined;
    redemptionType: string | undefined;
    budget: number | undefined;
    used: number | undefined;
    id: number | undefined;
    voucherNameUnsign: string | undefined;
    voucherGroupCode: string | undefined;
    discountAmount: number | undefined;
    discountRate: number | undefined;
}

export class VoucherReportDetailInput implements IVoucherReportDetailInput {
    voucherReportGroup!: string | undefined;
    voucherFilter!: string | undefined;
    voucherNameFilter!: string | undefined;
    voucherCodeFilter!: string | undefined;
    voucherUserFilter!: string | undefined;
    terminalCodeFilter!: string | undefined;
    terminalNameFilter!: string | undefined;
    redemptionTimeFrom!: moment.Moment | undefined;
    redemptionTimeTo!: moment.Moment | undefined;
    statusFilter!: string | undefined;
    redemptionTypeFilter!: string | undefined;
    sorting!: string | undefined;
    skipCount!: number | undefined;
    maxResultCount!: number | undefined;

    constructor(data?: IVoucherReportDetailInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.voucherReportGroup = data["voucherReportGroup"];
            this.voucherFilter = data["voucherFilter"];
            this.voucherNameFilter = data["voucherNameFilter"];
            this.voucherCodeFilter = data["voucherCodeFilter"];
            this.voucherUserFilter = data["voucherUserFilter"];
            this.terminalCodeFilter = data["terminalCodeFilter"];
            this.terminalNameFilter = data["terminalNameFilter"];
            this.redemptionTimeFrom = data["redemptionTimeFrom"] ? moment(data["redemptionTimeFrom"].toString()) : <any>undefined;
            this.redemptionTimeTo = data["redemptionTimeTo"] ? moment(data["redemptionTimeTo"].toString()) : <any>undefined;
            this.statusFilter = data["statusFilter"];
            this.redemptionTypeFilter = data["redemptionTypeFilter"];
            this.sorting = data["sorting"];
            this.skipCount = data["skipCount"];
            this.maxResultCount = data["maxResultCount"];
        }
    }

    static fromJS(data: any): VoucherReportDetailInput {
        data = typeof data === 'object' ? data : {};
        let result = new VoucherReportDetailInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["voucherReportGroup"] = this.voucherReportGroup;
        data["voucherFilter"] = this.voucherFilter;
        data["voucherNameFilter"] = this.voucherNameFilter;
        data["voucherCodeFilter"] = this.voucherCodeFilter;
        data["voucherUserFilter"] = this.voucherUserFilter;
        data["terminalCodeFilter"] = this.terminalCodeFilter;
        data["terminalNameFilter"] = this.terminalNameFilter;
        data["redemptionTimeFrom"] = this.redemptionTimeFrom ? this.redemptionTimeFrom.toISOString() : <any>undefined;
        data["redemptionTimeTo"] = this.redemptionTimeTo ? this.redemptionTimeTo.toISOString() : <any>undefined;
        data["statusFilter"] = this.statusFilter;
        data["redemptionTypeFilter"] = this.redemptionTypeFilter;
        data["sorting"] = this.sorting;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data;
    }
}

export interface IVoucherReportDetailInput {
    voucherReportGroup: string | undefined;
    voucherFilter: string | undefined;
    voucherNameFilter: string | undefined;
    voucherCodeFilter: string | undefined;
    voucherUserFilter: string | undefined;
    terminalCodeFilter: string | undefined;
    terminalNameFilter: string | undefined;
    redemptionTimeFrom: moment.Moment | undefined;
    redemptionTimeTo: moment.Moment | undefined;
    statusFilter: string | undefined;
    redemptionTypeFilter: string | undefined;
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;
}

export class PagedResultDtoOfVoucherReportDetailForViewDto implements IPagedResultDtoOfVoucherReportDetailForViewDto {
    totalCount!: number | undefined;
    items!: VoucherReportDetailForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfVoucherReportDetailForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(VoucherReportDetailForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfVoucherReportDetailForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfVoucherReportDetailForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfVoucherReportDetailForViewDto {
    totalCount: number | undefined;
    items: VoucherReportDetailForViewDto[] | undefined;
}

export class VoucherReportDetailForViewDto implements IVoucherReportDetailForViewDto {
    voucherReport!: VoucherReportDetail | undefined;

    constructor(data?: IVoucherReportDetailForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.voucherReport = data["voucherReport"] ? VoucherReportDetail.fromJS(data["voucherReport"]) : <any>undefined;
        }
    }

    static fromJS(data: any): VoucherReportDetailForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new VoucherReportDetailForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["voucherReport"] = this.voucherReport ? this.voucherReport.toJSON() : <any>undefined;
        return data;
    }
}

export interface IVoucherReportDetailForViewDto {
    voucherReport: VoucherReportDetail | undefined;
}

export class VoucherReportDetail implements IVoucherReportDetail {
    voucherCode!: string | undefined;
    voucherName!: string | undefined;
    memberCode!: string | undefined;
    terminalCode!: string | undefined;
    terminalName!: string | undefined;
    redemptionTime!: moment.Moment | undefined;
    status!: string | undefined;
    redemptionType!: string | undefined;
    id!: number | undefined;

    constructor(data?: IVoucherReportDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.voucherCode = data["voucherCode"];
            this.voucherName = data["voucherName"];
            this.memberCode = data["memberCode"];
            this.terminalCode = data["terminalCode"];
            this.terminalName = data["terminalName"];
            this.redemptionTime = data["redemptionTime"] ? moment(data["redemptionTime"].toString()) : <any>undefined;
            this.status = data["status"];
            this.redemptionType = data["redemptionType"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): VoucherReportDetail {
        data = typeof data === 'object' ? data : {};
        let result = new VoucherReportDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["voucherCode"] = this.voucherCode;
        data["voucherName"] = this.voucherName;
        data["memberCode"] = this.memberCode;
        data["terminalCode"] = this.terminalCode;
        data["terminalName"] = this.terminalName;
        data["redemptionTime"] = this.redemptionTime ? this.redemptionTime.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["redemptionType"] = this.redemptionType;
        data["id"] = this.id;
        return data;
    }
}

export interface IVoucherReportDetail {
    voucherCode: string | undefined;
    voucherName: string | undefined;
    memberCode: string | undefined;
    terminalCode: string | undefined;
    terminalName: string | undefined;
    redemptionTime: moment.Moment | undefined;
    status: string | undefined;
    redemptionType: string | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfGetVoucherTransactionLogForViewDto implements IPagedResultDtoOfGetVoucherTransactionLogForViewDto {
    totalCount!: number | undefined;
    items!: GetVoucherTransactionLogForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetVoucherTransactionLogForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetVoucherTransactionLogForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetVoucherTransactionLogForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetVoucherTransactionLogForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetVoucherTransactionLogForViewDto {
    totalCount: number | undefined;
    items: GetVoucherTransactionLogForViewDto[] | undefined;
}

export class GetVoucherTransactionLogForViewDto implements IGetVoucherTransactionLogForViewDto {
    voucherTransactionLog!: VoucherTransactionLogDto | undefined;

    constructor(data?: IGetVoucherTransactionLogForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.voucherTransactionLog = data["voucherTransactionLog"] ? VoucherTransactionLogDto.fromJS(data["voucherTransactionLog"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetVoucherTransactionLogForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetVoucherTransactionLogForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["voucherTransactionLog"] = this.voucherTransactionLog ? this.voucherTransactionLog.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetVoucherTransactionLogForViewDto {
    voucherTransactionLog: VoucherTransactionLogDto | undefined;
}

export class VoucherTransactionLogDto implements IVoucherTransactionLogDto {
    voucherCode!: string | undefined;
    voucherUser!: string | undefined;
    voucherGroupCode!: string | undefined;
    patternCode!: string | undefined;
    publisherCode!: string | undefined;
    terminalID!: number | undefined;
    terminalTime!: moment.Moment | undefined;
    redemptionTime!: moment.Moment | undefined;
    issuedTime!: moment.Moment | undefined;
    redemptionStartTime!: moment.Moment | undefined;
    redemptionEndTime!: moment.Moment | undefined;
    notes!: string | undefined;
    status!: string | undefined;
    referenceCode!: string | undefined;
    maxPaperPrint!: number | undefined;
    maxSlipPrint!: number | undefined;
    currentPaperPrint!: number | undefined;
    currentSlipPrint!: number | undefined;
    triggerEvent!: string | undefined;
    eventFilter!: string | undefined;
    transactionStatus!: string | undefined;
    transactionType!: string | undefined;
    message!: string | undefined;
    id!: number | undefined;

    constructor(data?: IVoucherTransactionLogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.voucherCode = data["voucherCode"];
            this.voucherUser = data["voucherUser"];
            this.voucherGroupCode = data["voucherGroupCode"];
            this.patternCode = data["patternCode"];
            this.publisherCode = data["publisherCode"];
            this.terminalID = data["terminalID"];
            this.terminalTime = data["terminalTime"] ? moment(data["terminalTime"].toString()) : <any>undefined;
            this.redemptionTime = data["redemptionTime"] ? moment(data["redemptionTime"].toString()) : <any>undefined;
            this.issuedTime = data["issuedTime"] ? moment(data["issuedTime"].toString()) : <any>undefined;
            this.redemptionStartTime = data["redemptionStartTime"] ? moment(data["redemptionStartTime"].toString()) : <any>undefined;
            this.redemptionEndTime = data["redemptionEndTime"] ? moment(data["redemptionEndTime"].toString()) : <any>undefined;
            this.notes = data["notes"];
            this.status = data["status"];
            this.referenceCode = data["referenceCode"];
            this.maxPaperPrint = data["maxPaperPrint"];
            this.maxSlipPrint = data["maxSlipPrint"];
            this.currentPaperPrint = data["currentPaperPrint"];
            this.currentSlipPrint = data["currentSlipPrint"];
            this.triggerEvent = data["triggerEvent"];
            this.eventFilter = data["eventFilter"];
            this.transactionStatus = data["transactionStatus"];
            this.transactionType = data["transactionType"];
            this.message = data["message"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): VoucherTransactionLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new VoucherTransactionLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["voucherCode"] = this.voucherCode;
        data["voucherUser"] = this.voucherUser;
        data["voucherGroupCode"] = this.voucherGroupCode;
        data["patternCode"] = this.patternCode;
        data["publisherCode"] = this.publisherCode;
        data["terminalID"] = this.terminalID;
        data["terminalTime"] = this.terminalTime ? this.terminalTime.toISOString() : <any>undefined;
        data["redemptionTime"] = this.redemptionTime ? this.redemptionTime.toISOString() : <any>undefined;
        data["issuedTime"] = this.issuedTime ? this.issuedTime.toISOString() : <any>undefined;
        data["redemptionStartTime"] = this.redemptionStartTime ? this.redemptionStartTime.toISOString() : <any>undefined;
        data["redemptionEndTime"] = this.redemptionEndTime ? this.redemptionEndTime.toISOString() : <any>undefined;
        data["notes"] = this.notes;
        data["status"] = this.status;
        data["referenceCode"] = this.referenceCode;
        data["maxPaperPrint"] = this.maxPaperPrint;
        data["maxSlipPrint"] = this.maxSlipPrint;
        data["currentPaperPrint"] = this.currentPaperPrint;
        data["currentSlipPrint"] = this.currentSlipPrint;
        data["triggerEvent"] = this.triggerEvent;
        data["eventFilter"] = this.eventFilter;
        data["transactionStatus"] = this.transactionStatus;
        data["transactionType"] = this.transactionType;
        data["message"] = this.message;
        data["id"] = this.id;
        return data;
    }
}

export interface IVoucherTransactionLogDto {
    voucherCode: string | undefined;
    voucherUser: string | undefined;
    voucherGroupCode: string | undefined;
    patternCode: string | undefined;
    publisherCode: string | undefined;
    terminalID: number | undefined;
    terminalTime: moment.Moment | undefined;
    redemptionTime: moment.Moment | undefined;
    issuedTime: moment.Moment | undefined;
    redemptionStartTime: moment.Moment | undefined;
    redemptionEndTime: moment.Moment | undefined;
    notes: string | undefined;
    status: string | undefined;
    referenceCode: string | undefined;
    maxPaperPrint: number | undefined;
    maxSlipPrint: number | undefined;
    currentPaperPrint: number | undefined;
    currentSlipPrint: number | undefined;
    triggerEvent: string | undefined;
    eventFilter: string | undefined;
    transactionStatus: string | undefined;
    transactionType: string | undefined;
    message: string | undefined;
    id: number | undefined;
}

export class GetVoucherTransactionLogForEditOutput implements IGetVoucherTransactionLogForEditOutput {
    voucherTransactionLog!: CreateOrEditVoucherTransactionLogDto | undefined;

    constructor(data?: IGetVoucherTransactionLogForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.voucherTransactionLog = data["voucherTransactionLog"] ? CreateOrEditVoucherTransactionLogDto.fromJS(data["voucherTransactionLog"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetVoucherTransactionLogForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetVoucherTransactionLogForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["voucherTransactionLog"] = this.voucherTransactionLog ? this.voucherTransactionLog.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetVoucherTransactionLogForEditOutput {
    voucherTransactionLog: CreateOrEditVoucherTransactionLogDto | undefined;
}

export class CreateOrEditVoucherTransactionLogDto implements ICreateOrEditVoucherTransactionLogDto {
    voucherCode!: string | undefined;
    voucherUser!: string | undefined;
    voucherGroupCode!: string | undefined;
    patternCode!: string | undefined;
    publisherCode!: string | undefined;
    terminalID!: number | undefined;
    terminalTime!: moment.Moment | undefined;
    redemptionTime!: moment.Moment | undefined;
    issuedTime!: moment.Moment | undefined;
    redemptionStartTime!: moment.Moment | undefined;
    redemptionEndTime!: moment.Moment | undefined;
    notes!: string | undefined;
    status!: string | undefined;
    referenceCode!: string | undefined;
    maxPaperPrint!: number | undefined;
    maxSlipPrint!: number | undefined;
    currentPaperPrint!: number | undefined;
    currentSlipPrint!: number | undefined;
    triggerEvent!: string | undefined;
    eventFilter!: string | undefined;
    transactionStatus!: string | undefined;
    transactionType!: string | undefined;
    message!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditVoucherTransactionLogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.voucherCode = data["voucherCode"];
            this.voucherUser = data["voucherUser"];
            this.voucherGroupCode = data["voucherGroupCode"];
            this.patternCode = data["patternCode"];
            this.publisherCode = data["publisherCode"];
            this.terminalID = data["terminalID"];
            this.terminalTime = data["terminalTime"] ? moment(data["terminalTime"].toString()) : <any>undefined;
            this.redemptionTime = data["redemptionTime"] ? moment(data["redemptionTime"].toString()) : <any>undefined;
            this.issuedTime = data["issuedTime"] ? moment(data["issuedTime"].toString()) : <any>undefined;
            this.redemptionStartTime = data["redemptionStartTime"] ? moment(data["redemptionStartTime"].toString()) : <any>undefined;
            this.redemptionEndTime = data["redemptionEndTime"] ? moment(data["redemptionEndTime"].toString()) : <any>undefined;
            this.notes = data["notes"];
            this.status = data["status"];
            this.referenceCode = data["referenceCode"];
            this.maxPaperPrint = data["maxPaperPrint"];
            this.maxSlipPrint = data["maxSlipPrint"];
            this.currentPaperPrint = data["currentPaperPrint"];
            this.currentSlipPrint = data["currentSlipPrint"];
            this.triggerEvent = data["triggerEvent"];
            this.eventFilter = data["eventFilter"];
            this.transactionStatus = data["transactionStatus"];
            this.transactionType = data["transactionType"];
            this.message = data["message"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditVoucherTransactionLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditVoucherTransactionLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["voucherCode"] = this.voucherCode;
        data["voucherUser"] = this.voucherUser;
        data["voucherGroupCode"] = this.voucherGroupCode;
        data["patternCode"] = this.patternCode;
        data["publisherCode"] = this.publisherCode;
        data["terminalID"] = this.terminalID;
        data["terminalTime"] = this.terminalTime ? this.terminalTime.toISOString() : <any>undefined;
        data["redemptionTime"] = this.redemptionTime ? this.redemptionTime.toISOString() : <any>undefined;
        data["issuedTime"] = this.issuedTime ? this.issuedTime.toISOString() : <any>undefined;
        data["redemptionStartTime"] = this.redemptionStartTime ? this.redemptionStartTime.toISOString() : <any>undefined;
        data["redemptionEndTime"] = this.redemptionEndTime ? this.redemptionEndTime.toISOString() : <any>undefined;
        data["notes"] = this.notes;
        data["status"] = this.status;
        data["referenceCode"] = this.referenceCode;
        data["maxPaperPrint"] = this.maxPaperPrint;
        data["maxSlipPrint"] = this.maxSlipPrint;
        data["currentPaperPrint"] = this.currentPaperPrint;
        data["currentSlipPrint"] = this.currentSlipPrint;
        data["triggerEvent"] = this.triggerEvent;
        data["eventFilter"] = this.eventFilter;
        data["transactionStatus"] = this.transactionStatus;
        data["transactionType"] = this.transactionType;
        data["message"] = this.message;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditVoucherTransactionLogDto {
    voucherCode: string | undefined;
    voucherUser: string | undefined;
    voucherGroupCode: string | undefined;
    patternCode: string | undefined;
    publisherCode: string | undefined;
    terminalID: number | undefined;
    terminalTime: moment.Moment | undefined;
    redemptionTime: moment.Moment | undefined;
    issuedTime: moment.Moment | undefined;
    redemptionStartTime: moment.Moment | undefined;
    redemptionEndTime: moment.Moment | undefined;
    notes: string | undefined;
    status: string | undefined;
    referenceCode: string | undefined;
    maxPaperPrint: number | undefined;
    maxSlipPrint: number | undefined;
    currentPaperPrint: number | undefined;
    currentSlipPrint: number | undefined;
    triggerEvent: string | undefined;
    eventFilter: string | undefined;
    transactionStatus: string | undefined;
    transactionType: string | undefined;
    message: string | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfGetVoucherTransactionForViewDto implements IPagedResultDtoOfGetVoucherTransactionForViewDto {
    totalCount!: number | undefined;
    items!: GetVoucherTransactionForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetVoucherTransactionForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetVoucherTransactionForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetVoucherTransactionForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetVoucherTransactionForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetVoucherTransactionForViewDto {
    totalCount: number | undefined;
    items: GetVoucherTransactionForViewDto[] | undefined;
}

export class GetVoucherTransactionForViewDto implements IGetVoucherTransactionForViewDto {
    voucherTransaction!: VoucherTransactionDto | undefined;
    voucherSetting!: VoucherDetailSettingDto | undefined;
    voucherBudget!: VoucherBudgetDto | undefined;

    constructor(data?: IGetVoucherTransactionForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.voucherTransaction = data["voucherTransaction"] ? VoucherTransactionDto.fromJS(data["voucherTransaction"]) : <any>undefined;
            this.voucherSetting = data["voucherSetting"] ? VoucherDetailSettingDto.fromJS(data["voucherSetting"]) : <any>undefined;
            this.voucherBudget = data["voucherBudget"] ? VoucherBudgetDto.fromJS(data["voucherBudget"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetVoucherTransactionForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetVoucherTransactionForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["voucherTransaction"] = this.voucherTransaction ? this.voucherTransaction.toJSON() : <any>undefined;
        data["voucherSetting"] = this.voucherSetting ? this.voucherSetting.toJSON() : <any>undefined;
        data["voucherBudget"] = this.voucherBudget ? this.voucherBudget.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetVoucherTransactionForViewDto {
    voucherTransaction: VoucherTransactionDto | undefined;
    voucherSetting: VoucherDetailSettingDto | undefined;
    voucherBudget: VoucherBudgetDto | undefined;
}

export class VoucherTransactionDto implements IVoucherTransactionDto {
    voucherCode!: string | undefined;
    voucherUser!: string | undefined;
    voucherGroupCode!: string | undefined;
    patternCode!: string | undefined;
    publisherCode!: string | undefined;
    issuedTime!: moment.Moment | undefined;
    redemptionStartTime!: moment.Moment | undefined;
    redemptionEndTime!: moment.Moment | undefined;
    notes!: string | undefined;
    status!: string | undefined;
    referenceCode!: string | undefined;
    maxPaperPrint!: number | undefined;
    currentPaperPrint!: number | undefined;
    triggerEvent!: string | undefined;
    eventFilter!: string | undefined;
    id!: number | undefined;

    constructor(data?: IVoucherTransactionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.voucherCode = data["voucherCode"];
            this.voucherUser = data["voucherUser"];
            this.voucherGroupCode = data["voucherGroupCode"];
            this.patternCode = data["patternCode"];
            this.publisherCode = data["publisherCode"];
            this.issuedTime = data["issuedTime"] ? moment(data["issuedTime"].toString()) : <any>undefined;
            this.redemptionStartTime = data["redemptionStartTime"] ? moment(data["redemptionStartTime"].toString()) : <any>undefined;
            this.redemptionEndTime = data["redemptionEndTime"] ? moment(data["redemptionEndTime"].toString()) : <any>undefined;
            this.notes = data["notes"];
            this.status = data["status"];
            this.referenceCode = data["referenceCode"];
            this.maxPaperPrint = data["maxPaperPrint"];
            this.currentPaperPrint = data["currentPaperPrint"];
            this.triggerEvent = data["triggerEvent"];
            this.eventFilter = data["eventFilter"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): VoucherTransactionDto {
        data = typeof data === 'object' ? data : {};
        let result = new VoucherTransactionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["voucherCode"] = this.voucherCode;
        data["voucherUser"] = this.voucherUser;
        data["voucherGroupCode"] = this.voucherGroupCode;
        data["patternCode"] = this.patternCode;
        data["publisherCode"] = this.publisherCode;
        data["issuedTime"] = this.issuedTime ? this.issuedTime.toISOString() : <any>undefined;
        data["redemptionStartTime"] = this.redemptionStartTime ? this.redemptionStartTime.toISOString() : <any>undefined;
        data["redemptionEndTime"] = this.redemptionEndTime ? this.redemptionEndTime.toISOString() : <any>undefined;
        data["notes"] = this.notes;
        data["status"] = this.status;
        data["referenceCode"] = this.referenceCode;
        data["maxPaperPrint"] = this.maxPaperPrint;
        data["currentPaperPrint"] = this.currentPaperPrint;
        data["triggerEvent"] = this.triggerEvent;
        data["eventFilter"] = this.eventFilter;
        data["id"] = this.id;
        return data;
    }
}

export interface IVoucherTransactionDto {
    voucherCode: string | undefined;
    voucherUser: string | undefined;
    voucherGroupCode: string | undefined;
    patternCode: string | undefined;
    publisherCode: string | undefined;
    issuedTime: moment.Moment | undefined;
    redemptionStartTime: moment.Moment | undefined;
    redemptionEndTime: moment.Moment | undefined;
    notes: string | undefined;
    status: string | undefined;
    referenceCode: string | undefined;
    maxPaperPrint: number | undefined;
    currentPaperPrint: number | undefined;
    triggerEvent: string | undefined;
    eventFilter: string | undefined;
    id: number | undefined;
}

export class VoucherDetailSettingDto implements IVoucherDetailSettingDto {
    publisherName!: string | undefined;
    voucherGroupName!: string | undefined;
    redemptionType!: string | undefined;
    discountAmount!: number | undefined;
    discountRate!: number | undefined;
    maxQuantityRedemp!: number | undefined;
    imageLink!: string | undefined;
    maxDiscountAmount!: number | undefined;
    minPurchaseAmount!: number | undefined;
    redemptionApplyLocation!: string | undefined;
    redemptionAppllyProdLV4!: string | undefined;
    titleVN!: string | undefined;
    titleEN!: string | undefined;
    apllyLocation!: string | undefined;
    applyDepartment!: string | undefined;
    applyBrand!: string | undefined;
    descriptionVN!: string | undefined;
    descriptionEN!: string | undefined;
    pointPrice!: number | undefined;
    currencyPrice!: number | undefined;

    constructor(data?: IVoucherDetailSettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.publisherName = data["publisherName"];
            this.voucherGroupName = data["voucherGroupName"];
            this.redemptionType = data["redemptionType"];
            this.discountAmount = data["discountAmount"];
            this.discountRate = data["discountRate"];
            this.maxQuantityRedemp = data["maxQuantityRedemp"];
            this.imageLink = data["imageLink"];
            this.maxDiscountAmount = data["maxDiscountAmount"];
            this.minPurchaseAmount = data["minPurchaseAmount"];
            this.redemptionApplyLocation = data["redemptionApplyLocation"];
            this.redemptionAppllyProdLV4 = data["redemptionAppllyProdLV4"];
            this.titleVN = data["titleVN"];
            this.titleEN = data["titleEN"];
            this.apllyLocation = data["apllyLocation"];
            this.applyDepartment = data["applyDepartment"];
            this.applyBrand = data["applyBrand"];
            this.descriptionVN = data["descriptionVN"];
            this.descriptionEN = data["descriptionEN"];
            this.pointPrice = data["pointPrice"];
            this.currencyPrice = data["currencyPrice"];
        }
    }

    static fromJS(data: any): VoucherDetailSettingDto {
        data = typeof data === 'object' ? data : {};
        let result = new VoucherDetailSettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["publisherName"] = this.publisherName;
        data["voucherGroupName"] = this.voucherGroupName;
        data["redemptionType"] = this.redemptionType;
        data["discountAmount"] = this.discountAmount;
        data["discountRate"] = this.discountRate;
        data["maxQuantityRedemp"] = this.maxQuantityRedemp;
        data["imageLink"] = this.imageLink;
        data["maxDiscountAmount"] = this.maxDiscountAmount;
        data["minPurchaseAmount"] = this.minPurchaseAmount;
        data["redemptionApplyLocation"] = this.redemptionApplyLocation;
        data["redemptionAppllyProdLV4"] = this.redemptionAppllyProdLV4;
        data["titleVN"] = this.titleVN;
        data["titleEN"] = this.titleEN;
        data["apllyLocation"] = this.apllyLocation;
        data["applyDepartment"] = this.applyDepartment;
        data["applyBrand"] = this.applyBrand;
        data["descriptionVN"] = this.descriptionVN;
        data["descriptionEN"] = this.descriptionEN;
        data["pointPrice"] = this.pointPrice;
        data["currencyPrice"] = this.currencyPrice;
        return data;
    }
}

export interface IVoucherDetailSettingDto {
    publisherName: string | undefined;
    voucherGroupName: string | undefined;
    redemptionType: string | undefined;
    discountAmount: number | undefined;
    discountRate: number | undefined;
    maxQuantityRedemp: number | undefined;
    imageLink: string | undefined;
    maxDiscountAmount: number | undefined;
    minPurchaseAmount: number | undefined;
    redemptionApplyLocation: string | undefined;
    redemptionAppllyProdLV4: string | undefined;
    titleVN: string | undefined;
    titleEN: string | undefined;
    apllyLocation: string | undefined;
    applyDepartment: string | undefined;
    applyBrand: string | undefined;
    descriptionVN: string | undefined;
    descriptionEN: string | undefined;
    pointPrice: number | undefined;
    currencyPrice: number | undefined;
}

export class GetVoucherTransactionForEditOutput implements IGetVoucherTransactionForEditOutput {
    voucherTransaction!: CreateOrEditVoucherTransactionDto | undefined;

    constructor(data?: IGetVoucherTransactionForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.voucherTransaction = data["voucherTransaction"] ? CreateOrEditVoucherTransactionDto.fromJS(data["voucherTransaction"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetVoucherTransactionForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetVoucherTransactionForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["voucherTransaction"] = this.voucherTransaction ? this.voucherTransaction.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetVoucherTransactionForEditOutput {
    voucherTransaction: CreateOrEditVoucherTransactionDto | undefined;
}

export class CreateOrEditVoucherTransactionDto implements ICreateOrEditVoucherTransactionDto {
    voucherCode!: string | undefined;
    voucherUser!: string | undefined;
    voucherGroupCode!: string | undefined;
    patternCode!: string | undefined;
    publisherCode!: string | undefined;
    issuedTime!: moment.Moment | undefined;
    redemptionStartTime!: moment.Moment | undefined;
    redemptionEndTime!: moment.Moment | undefined;
    notes!: string | undefined;
    status!: string | undefined;
    referenceCode!: string | undefined;
    maxPaperPrint!: number | undefined;
    currentPaperPrint!: number | undefined;
    triggerEvent!: string | undefined;
    eventFilter!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditVoucherTransactionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.voucherCode = data["voucherCode"];
            this.voucherUser = data["voucherUser"];
            this.voucherGroupCode = data["voucherGroupCode"];
            this.patternCode = data["patternCode"];
            this.publisherCode = data["publisherCode"];
            this.issuedTime = data["issuedTime"] ? moment(data["issuedTime"].toString()) : <any>undefined;
            this.redemptionStartTime = data["redemptionStartTime"] ? moment(data["redemptionStartTime"].toString()) : <any>undefined;
            this.redemptionEndTime = data["redemptionEndTime"] ? moment(data["redemptionEndTime"].toString()) : <any>undefined;
            this.notes = data["notes"];
            this.status = data["status"];
            this.referenceCode = data["referenceCode"];
            this.maxPaperPrint = data["maxPaperPrint"];
            this.currentPaperPrint = data["currentPaperPrint"];
            this.triggerEvent = data["triggerEvent"];
            this.eventFilter = data["eventFilter"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditVoucherTransactionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditVoucherTransactionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["voucherCode"] = this.voucherCode;
        data["voucherUser"] = this.voucherUser;
        data["voucherGroupCode"] = this.voucherGroupCode;
        data["patternCode"] = this.patternCode;
        data["publisherCode"] = this.publisherCode;
        data["issuedTime"] = this.issuedTime ? this.issuedTime.toISOString() : <any>undefined;
        data["redemptionStartTime"] = this.redemptionStartTime ? this.redemptionStartTime.toISOString() : <any>undefined;
        data["redemptionEndTime"] = this.redemptionEndTime ? this.redemptionEndTime.toISOString() : <any>undefined;
        data["notes"] = this.notes;
        data["status"] = this.status;
        data["referenceCode"] = this.referenceCode;
        data["maxPaperPrint"] = this.maxPaperPrint;
        data["currentPaperPrint"] = this.currentPaperPrint;
        data["triggerEvent"] = this.triggerEvent;
        data["eventFilter"] = this.eventFilter;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditVoucherTransactionDto {
    voucherCode: string | undefined;
    voucherUser: string | undefined;
    voucherGroupCode: string | undefined;
    patternCode: string | undefined;
    publisherCode: string | undefined;
    issuedTime: moment.Moment | undefined;
    redemptionStartTime: moment.Moment | undefined;
    redemptionEndTime: moment.Moment | undefined;
    notes: string | undefined;
    status: string | undefined;
    referenceCode: string | undefined;
    maxPaperPrint: number | undefined;
    currentPaperPrint: number | undefined;
    triggerEvent: string | undefined;
    eventFilter: string | undefined;
    id: number | undefined;
}

export class GetVoucherDetailForAppDto implements IGetVoucherDetailForAppDto {
    voucherSetting!: VoucherDetailSettingDto | undefined;
    voucherBudget!: VoucherBudgetDto | undefined;
    voucherTransaction!: VoucherInformationForApp | undefined;

    constructor(data?: IGetVoucherDetailForAppDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.voucherSetting = data["voucherSetting"] ? VoucherDetailSettingDto.fromJS(data["voucherSetting"]) : <any>undefined;
            this.voucherBudget = data["voucherBudget"] ? VoucherBudgetDto.fromJS(data["voucherBudget"]) : <any>undefined;
            this.voucherTransaction = data["voucherTransaction"] ? VoucherInformationForApp.fromJS(data["voucherTransaction"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetVoucherDetailForAppDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetVoucherDetailForAppDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["voucherSetting"] = this.voucherSetting ? this.voucherSetting.toJSON() : <any>undefined;
        data["voucherBudget"] = this.voucherBudget ? this.voucherBudget.toJSON() : <any>undefined;
        data["voucherTransaction"] = this.voucherTransaction ? this.voucherTransaction.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetVoucherDetailForAppDto {
    voucherSetting: VoucherDetailSettingDto | undefined;
    voucherBudget: VoucherBudgetDto | undefined;
    voucherTransaction: VoucherInformationForApp | undefined;
}

export class VoucherInformationForApp implements IVoucherInformationForApp {
    voucherCode!: string | undefined;
    voucherUser!: string | undefined;
    voucherGroupCode!: string | undefined;
    patternCode!: string | undefined;
    publisherCode!: string | undefined;
    issuedTime!: moment.Moment | undefined;
    redemptionStartTime!: moment.Moment | undefined;
    redemptionEndTime!: moment.Moment | undefined;
    notes!: string | undefined;
    status!: string | undefined;
    referenceCode!: string | undefined;
    maxSlipPrint!: number | undefined;
    currentSlipPrint!: number | undefined;
    triggerEvent!: string | undefined;
    eventFilter!: string | undefined;

    constructor(data?: IVoucherInformationForApp) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.voucherCode = data["voucherCode"];
            this.voucherUser = data["voucherUser"];
            this.voucherGroupCode = data["voucherGroupCode"];
            this.patternCode = data["patternCode"];
            this.publisherCode = data["publisherCode"];
            this.issuedTime = data["issuedTime"] ? moment(data["issuedTime"].toString()) : <any>undefined;
            this.redemptionStartTime = data["redemptionStartTime"] ? moment(data["redemptionStartTime"].toString()) : <any>undefined;
            this.redemptionEndTime = data["redemptionEndTime"] ? moment(data["redemptionEndTime"].toString()) : <any>undefined;
            this.notes = data["notes"];
            this.status = data["status"];
            this.referenceCode = data["referenceCode"];
            this.maxSlipPrint = data["maxSlipPrint"];
            this.currentSlipPrint = data["currentSlipPrint"];
            this.triggerEvent = data["triggerEvent"];
            this.eventFilter = data["eventFilter"];
        }
    }

    static fromJS(data: any): VoucherInformationForApp {
        data = typeof data === 'object' ? data : {};
        let result = new VoucherInformationForApp();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["voucherCode"] = this.voucherCode;
        data["voucherUser"] = this.voucherUser;
        data["voucherGroupCode"] = this.voucherGroupCode;
        data["patternCode"] = this.patternCode;
        data["publisherCode"] = this.publisherCode;
        data["issuedTime"] = this.issuedTime ? this.issuedTime.toISOString() : <any>undefined;
        data["redemptionStartTime"] = this.redemptionStartTime ? this.redemptionStartTime.toISOString() : <any>undefined;
        data["redemptionEndTime"] = this.redemptionEndTime ? this.redemptionEndTime.toISOString() : <any>undefined;
        data["notes"] = this.notes;
        data["status"] = this.status;
        data["referenceCode"] = this.referenceCode;
        data["maxSlipPrint"] = this.maxSlipPrint;
        data["currentSlipPrint"] = this.currentSlipPrint;
        data["triggerEvent"] = this.triggerEvent;
        data["eventFilter"] = this.eventFilter;
        return data;
    }
}

export interface IVoucherInformationForApp {
    voucherCode: string | undefined;
    voucherUser: string | undefined;
    voucherGroupCode: string | undefined;
    patternCode: string | undefined;
    publisherCode: string | undefined;
    issuedTime: moment.Moment | undefined;
    redemptionStartTime: moment.Moment | undefined;
    redemptionEndTime: moment.Moment | undefined;
    notes: string | undefined;
    status: string | undefined;
    referenceCode: string | undefined;
    maxSlipPrint: number | undefined;
    currentSlipPrint: number | undefined;
    triggerEvent: string | undefined;
    eventFilter: string | undefined;
}

export class PagedResultDtoOfVoucherAppListModel implements IPagedResultDtoOfVoucherAppListModel {
    totalCount!: number | undefined;
    items!: VoucherAppListModel[] | undefined;

    constructor(data?: IPagedResultDtoOfVoucherAppListModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(VoucherAppListModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfVoucherAppListModel {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfVoucherAppListModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfVoucherAppListModel {
    totalCount: number | undefined;
    items: VoucherAppListModel[] | undefined;
}

export class VoucherAppListModel implements IVoucherAppListModel {
    imageLink!: string | undefined;
    voucherCode!: string | undefined;
    id!: number | undefined;
    titleVN!: string | undefined;
    titleEN!: string | undefined;
    status!: string | undefined;
    redemptionStartTime!: moment.Moment | undefined;
    redemptionEndTIme!: moment.Moment | undefined;
    pointPrice!: number | undefined;
    currencyPrice!: number | undefined;

    constructor(data?: IVoucherAppListModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.imageLink = data["imageLink"];
            this.voucherCode = data["voucherCode"];
            this.id = data["id"];
            this.titleVN = data["titleVN"];
            this.titleEN = data["titleEN"];
            this.status = data["status"];
            this.redemptionStartTime = data["redemptionStartTime"] ? moment(data["redemptionStartTime"].toString()) : <any>undefined;
            this.redemptionEndTIme = data["redemptionEndTIme"] ? moment(data["redemptionEndTIme"].toString()) : <any>undefined;
            this.pointPrice = data["pointPrice"];
            this.currencyPrice = data["currencyPrice"];
        }
    }

    static fromJS(data: any): VoucherAppListModel {
        data = typeof data === 'object' ? data : {};
        let result = new VoucherAppListModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["imageLink"] = this.imageLink;
        data["voucherCode"] = this.voucherCode;
        data["id"] = this.id;
        data["titleVN"] = this.titleVN;
        data["titleEN"] = this.titleEN;
        data["status"] = this.status;
        data["redemptionStartTime"] = this.redemptionStartTime ? this.redemptionStartTime.toISOString() : <any>undefined;
        data["redemptionEndTIme"] = this.redemptionEndTIme ? this.redemptionEndTIme.toISOString() : <any>undefined;
        data["pointPrice"] = this.pointPrice;
        data["currencyPrice"] = this.currencyPrice;
        return data;
    }
}

export interface IVoucherAppListModel {
    imageLink: string | undefined;
    voucherCode: string | undefined;
    id: number | undefined;
    titleVN: string | undefined;
    titleEN: string | undefined;
    status: string | undefined;
    redemptionStartTime: moment.Moment | undefined;
    redemptionEndTIme: moment.Moment | undefined;
    pointPrice: number | undefined;
    currencyPrice: number | undefined;
}

export class VoucherRedemptionInput implements IVoucherRedemptionInput {
    voucherCode!: string | undefined;
    memberCode!: string | undefined;
    invoiceTotalAmount!: number | undefined;
    location!: string | undefined;
    deviceId!: string | undefined;
    userName!: string | undefined;

    constructor(data?: IVoucherRedemptionInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.voucherCode = data["voucherCode"];
            this.memberCode = data["memberCode"];
            this.invoiceTotalAmount = data["invoiceTotalAmount"];
            this.location = data["location"];
            this.deviceId = data["deviceId"];
            this.userName = data["userName"];
        }
    }

    static fromJS(data: any): VoucherRedemptionInput {
        data = typeof data === 'object' ? data : {};
        let result = new VoucherRedemptionInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["voucherCode"] = this.voucherCode;
        data["memberCode"] = this.memberCode;
        data["invoiceTotalAmount"] = this.invoiceTotalAmount;
        data["location"] = this.location;
        data["deviceId"] = this.deviceId;
        data["userName"] = this.userName;
        return data;
    }
}

export interface IVoucherRedemptionInput {
    voucherCode: string | undefined;
    memberCode: string | undefined;
    invoiceTotalAmount: number | undefined;
    location: string | undefined;
    deviceId: string | undefined;
    userName: string | undefined;
}

export class RedeemVoucherOutput implements IRedeemVoucherOutput {
    redemptionType!: string | undefined;
    value!: number | undefined;

    constructor(data?: IRedeemVoucherOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.redemptionType = data["redemptionType"];
            this.value = data["value"];
        }
    }

    static fromJS(data: any): RedeemVoucherOutput {
        data = typeof data === 'object' ? data : {};
        let result = new RedeemVoucherOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["redemptionType"] = this.redemptionType;
        data["value"] = this.value;
        return data;
    }
}

export interface IRedeemVoucherOutput {
    redemptionType: string | undefined;
    value: number | undefined;
}

export class VoucherPrintInformationDto implements IVoucherPrintInformationDto {
    maxQuantity!: number | undefined;
    remainQuantity!: number | undefined;
    printedQuantity!: number | undefined;

    constructor(data?: IVoucherPrintInformationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.maxQuantity = data["maxQuantity"];
            this.remainQuantity = data["remainQuantity"];
            this.printedQuantity = data["printedQuantity"];
        }
    }

    static fromJS(data: any): VoucherPrintInformationDto {
        data = typeof data === 'object' ? data : {};
        let result = new VoucherPrintInformationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxQuantity"] = this.maxQuantity;
        data["remainQuantity"] = this.remainQuantity;
        data["printedQuantity"] = this.printedQuantity;
        return data;
    }
}

export interface IVoucherPrintInformationDto {
    maxQuantity: number | undefined;
    remainQuantity: number | undefined;
    printedQuantity: number | undefined;
}

export class PagedResultDtoOfGetVoucherUserForViewDto implements IPagedResultDtoOfGetVoucherUserForViewDto {
    totalCount!: number | undefined;
    items!: GetVoucherUserForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetVoucherUserForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetVoucherUserForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetVoucherUserForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetVoucherUserForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetVoucherUserForViewDto {
    totalCount: number | undefined;
    items: GetVoucherUserForViewDto[] | undefined;
}

export class GetVoucherUserForViewDto implements IGetVoucherUserForViewDto {
    voucherUser!: VoucherUserDto | undefined;
    rewardTargetAudienceTargetAudienceName!: string | undefined;

    constructor(data?: IGetVoucherUserForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.voucherUser = data["voucherUser"] ? VoucherUserDto.fromJS(data["voucherUser"]) : <any>undefined;
            this.rewardTargetAudienceTargetAudienceName = data["rewardTargetAudienceTargetAudienceName"];
        }
    }

    static fromJS(data: any): GetVoucherUserForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetVoucherUserForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["voucherUser"] = this.voucherUser ? this.voucherUser.toJSON() : <any>undefined;
        data["rewardTargetAudienceTargetAudienceName"] = this.rewardTargetAudienceTargetAudienceName;
        return data;
    }
}

export interface IGetVoucherUserForViewDto {
    voucherUser: VoucherUserDto | undefined;
    rewardTargetAudienceTargetAudienceName: string | undefined;
}

export class VoucherUserDto implements IVoucherUserDto {
    name!: string | undefined;
    phone!: string | undefined;
    zaloChatID!: string | undefined;
    email!: string | undefined;
    facebookID!: string | undefined;
    memberCode!: string | undefined;
    communicationLanguage!: string | undefined;
    communicationChannels!: string | undefined;
    targetAudienceLinkID!: number | undefined;
    rewardTargetAudienceID!: number | undefined;
    id!: number | undefined;

    constructor(data?: IVoucherUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.phone = data["phone"];
            this.zaloChatID = data["zaloChatID"];
            this.email = data["email"];
            this.facebookID = data["facebookID"];
            this.memberCode = data["memberCode"];
            this.communicationLanguage = data["communicationLanguage"];
            this.communicationChannels = data["communicationChannels"];
            this.targetAudienceLinkID = data["targetAudienceLinkID"];
            this.rewardTargetAudienceID = data["rewardTargetAudienceID"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): VoucherUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new VoucherUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["phone"] = this.phone;
        data["zaloChatID"] = this.zaloChatID;
        data["email"] = this.email;
        data["facebookID"] = this.facebookID;
        data["memberCode"] = this.memberCode;
        data["communicationLanguage"] = this.communicationLanguage;
        data["communicationChannels"] = this.communicationChannels;
        data["targetAudienceLinkID"] = this.targetAudienceLinkID;
        data["rewardTargetAudienceID"] = this.rewardTargetAudienceID;
        data["id"] = this.id;
        return data;
    }
}

export interface IVoucherUserDto {
    name: string | undefined;
    phone: string | undefined;
    zaloChatID: string | undefined;
    email: string | undefined;
    facebookID: string | undefined;
    memberCode: string | undefined;
    communicationLanguage: string | undefined;
    communicationChannels: string | undefined;
    targetAudienceLinkID: number | undefined;
    rewardTargetAudienceID: number | undefined;
    id: number | undefined;
}

export class GetVoucherUserForEditOutput implements IGetVoucherUserForEditOutput {
    voucherUser!: CreateOrEditVoucherUserDto | undefined;
    rewardTargetAudienceTargetAudienceName!: string | undefined;

    constructor(data?: IGetVoucherUserForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.voucherUser = data["voucherUser"] ? CreateOrEditVoucherUserDto.fromJS(data["voucherUser"]) : <any>undefined;
            this.rewardTargetAudienceTargetAudienceName = data["rewardTargetAudienceTargetAudienceName"];
        }
    }

    static fromJS(data: any): GetVoucherUserForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetVoucherUserForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["voucherUser"] = this.voucherUser ? this.voucherUser.toJSON() : <any>undefined;
        data["rewardTargetAudienceTargetAudienceName"] = this.rewardTargetAudienceTargetAudienceName;
        return data;
    }
}

export interface IGetVoucherUserForEditOutput {
    voucherUser: CreateOrEditVoucherUserDto | undefined;
    rewardTargetAudienceTargetAudienceName: string | undefined;
}

export class CreateOrEditVoucherUserDto implements ICreateOrEditVoucherUserDto {
    name!: string | undefined;
    phone!: string | undefined;
    zaloChatID!: string | undefined;
    email!: string | undefined;
    facebookID!: string | undefined;
    memberCode!: string | undefined;
    communicationLanguage!: string | undefined;
    communicationChannels!: string | undefined;
    targetAudienceLinkID!: number | undefined;
    rewardTargetAudienceID!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditVoucherUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.phone = data["phone"];
            this.zaloChatID = data["zaloChatID"];
            this.email = data["email"];
            this.facebookID = data["facebookID"];
            this.memberCode = data["memberCode"];
            this.communicationLanguage = data["communicationLanguage"];
            this.communicationChannels = data["communicationChannels"];
            this.targetAudienceLinkID = data["targetAudienceLinkID"];
            this.rewardTargetAudienceID = data["rewardTargetAudienceID"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditVoucherUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditVoucherUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["phone"] = this.phone;
        data["zaloChatID"] = this.zaloChatID;
        data["email"] = this.email;
        data["facebookID"] = this.facebookID;
        data["memberCode"] = this.memberCode;
        data["communicationLanguage"] = this.communicationLanguage;
        data["communicationChannels"] = this.communicationChannels;
        data["targetAudienceLinkID"] = this.targetAudienceLinkID;
        data["rewardTargetAudienceID"] = this.rewardTargetAudienceID;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrEditVoucherUserDto {
    name: string | undefined;
    phone: string | undefined;
    zaloChatID: string | undefined;
    email: string | undefined;
    facebookID: string | undefined;
    memberCode: string | undefined;
    communicationLanguage: string | undefined;
    communicationChannels: string | undefined;
    targetAudienceLinkID: number | undefined;
    rewardTargetAudienceID: number | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfRewardTargetAudienceLookupTableDto implements IPagedResultDtoOfRewardTargetAudienceLookupTableDto {
    totalCount!: number | undefined;
    items!: RewardTargetAudienceLookupTableDto[] | undefined;

    constructor(data?: IPagedResultDtoOfRewardTargetAudienceLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(RewardTargetAudienceLookupTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfRewardTargetAudienceLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfRewardTargetAudienceLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfRewardTargetAudienceLookupTableDto {
    totalCount: number | undefined;
    items: RewardTargetAudienceLookupTableDto[] | undefined;
}

export class RewardTargetAudienceLookupTableDto implements IRewardTargetAudienceLookupTableDto {
    id!: number | undefined;
    displayName!: string | undefined;

    constructor(data?: IRewardTargetAudienceLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): RewardTargetAudienceLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new RewardTargetAudienceLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IRewardTargetAudienceLookupTableDto {
    id: number | undefined;
    displayName: string | undefined;
}

export class WebHookDto implements IWebHookDto {
    webHookUri!: string;
    secret!: string | undefined;
    description!: string | undefined;
    headers!: HeaderItem[] | undefined;
    events!: string[] | undefined;

    constructor(data?: IWebHookDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.webHookUri = data["webHookUri"];
            this.secret = data["secret"];
            this.description = data["description"];
            if (data["headers"] && data["headers"].constructor === Array) {
                this.headers = [];
                for (let item of data["headers"])
                    this.headers.push(HeaderItem.fromJS(item));
            }
            if (data["events"] && data["events"].constructor === Array) {
                this.events = [];
                for (let item of data["events"])
                    this.events.push(item);
            }
        }
    }

    static fromJS(data: any): WebHookDto {
        data = typeof data === 'object' ? data : {};
        let result = new WebHookDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["webHookUri"] = this.webHookUri;
        data["secret"] = this.secret;
        data["description"] = this.description;
        if (this.headers && this.headers.constructor === Array) {
            data["headers"] = [];
            for (let item of this.headers)
                data["headers"].push(item.toJSON());
        }
        if (this.events && this.events.constructor === Array) {
            data["events"] = [];
            for (let item of this.events)
                data["events"].push(item);
        }
        return data;
    }
}

export interface IWebHookDto {
    webHookUri: string;
    secret: string | undefined;
    description: string | undefined;
    headers: HeaderItem[] | undefined;
    events: string[] | undefined;
}

export class HeaderItem implements IHeaderItem {
    key!: string | undefined;
    value!: string | undefined;

    constructor(data?: IHeaderItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.key = data["key"];
            this.value = data["value"];
        }
    }

    static fromJS(data: any): HeaderItem {
        data = typeof data === 'object' ? data : {};
        let result = new HeaderItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value;
        return data;
    }
}

export interface IHeaderItem {
    key: string | undefined;
    value: string | undefined;
}

export class PublishWebHookDto implements IPublishWebHookDto {
    code!: string | undefined;
    quantity!: number | undefined;

    constructor(data?: IPublishWebHookDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.quantity = data["quantity"];
        }
    }

    static fromJS(data: any): PublishWebHookDto {
        data = typeof data === 'object' ? data : {};
        let result = new PublishWebHookDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["quantity"] = this.quantity;
        return data;
    }
}

export interface IPublishWebHookDto {
    code: string | undefined;
    quantity: number | undefined;
}

export class WebHookDataItem implements IWebHookDataItem {
    webHookUri!: string;
    secret!: string | undefined;
    description!: string | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastUpdateByName!: string | undefined;
    lastModifierUserId!: number | undefined;
    events!: string[] | undefined;
    eventFilters!: { [key: string]: any; } | undefined;
    httpHeaders!: { [key: string]: string; } | undefined;

    constructor(data?: IWebHookDataItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.webHookUri = data["webHookUri"];
            this.secret = data["secret"];
            this.description = data["description"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastUpdateByName = data["lastUpdateByName"];
            this.lastModifierUserId = data["lastModifierUserId"];
            if (data["events"] && data["events"].constructor === Array) {
                this.events = [];
                for (let item of data["events"])
                    this.events.push(item);
            }
            if (data["eventFilters"]) {
                this.eventFilters = {};
                for (let key in data["eventFilters"]) {
                    if (data["eventFilters"].hasOwnProperty(key))
                        this.eventFilters[key] = data["eventFilters"][key];
                }
            }
            if (data["httpHeaders"]) {
                this.httpHeaders = {};
                for (let key in data["httpHeaders"]) {
                    if (data["httpHeaders"].hasOwnProperty(key))
                        this.httpHeaders[key] = data["httpHeaders"][key];
                }
            }
        }
    }

    static fromJS(data: any): WebHookDataItem {
        data = typeof data === 'object' ? data : {};
        let result = new WebHookDataItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["webHookUri"] = this.webHookUri;
        data["secret"] = this.secret;
        data["description"] = this.description;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastUpdateByName"] = this.lastUpdateByName;
        data["lastModifierUserId"] = this.lastModifierUserId;
        if (this.events && this.events.constructor === Array) {
            data["events"] = [];
            for (let item of this.events)
                data["events"].push(item);
        }
        if (this.eventFilters) {
            data["eventFilters"] = {};
            for (let key in this.eventFilters) {
                if (this.eventFilters.hasOwnProperty(key))
                    data["eventFilters"][key] = this.eventFilters[key];
            }
        }
        if (this.httpHeaders) {
            data["httpHeaders"] = {};
            for (let key in this.httpHeaders) {
                if (this.httpHeaders.hasOwnProperty(key))
                    data["httpHeaders"][key] = this.httpHeaders[key];
            }
        }
        return data;
    }
}

export interface IWebHookDataItem {
    webHookUri: string;
    secret: string | undefined;
    description: string | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastUpdateByName: string | undefined;
    lastModifierUserId: number | undefined;
    events: string[] | undefined;
    eventFilters: { [key: string]: any; } | undefined;
    httpHeaders: { [key: string]: string; } | undefined;
}

export class GetLatestWebLogsOutput implements IGetLatestWebLogsOutput {
    latestWebLogLines!: string[] | undefined;

    constructor(data?: IGetLatestWebLogsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["latestWebLogLines"] && data["latestWebLogLines"].constructor === Array) {
                this.latestWebLogLines = [];
                for (let item of data["latestWebLogLines"])
                    this.latestWebLogLines.push(item);
            }
        }
    }

    static fromJS(data: any): GetLatestWebLogsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetLatestWebLogsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.latestWebLogLines && this.latestWebLogLines.constructor === Array) {
            data["latestWebLogLines"] = [];
            for (let item of this.latestWebLogLines)
                data["latestWebLogLines"].push(item);
        }
        return data;
    }
}

export interface IGetLatestWebLogsOutput {
    latestWebLogLines: string[] | undefined;
}

export enum IncomeStatisticsDateInterval {
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export enum IncomeStatisticsDateInterval2 {
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export enum State {
    _0 = 0,
    _1 = 1,
}

export enum TypeFilter {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
}

export enum State2 {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export enum Type {
    _0 = 0,
    _1 = 1,
}

export enum Type2 {
    _0 = 0,
    _1 = 1,
}

export enum Classify {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export enum TypeFilterSpecialSetting {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export enum TypeFilterSpecialSetting2 {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export enum SalesSummaryDatePeriod {
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export enum SalesSummaryDatePeriod2 {
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export enum DefaultTimezoneScope {
    _1 = 1,
    _2 = 2,
    _4 = 4,
    _7 = 7,
}

export enum IsTenantAvailableOutputState {
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export enum ActionRuleDtoType {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export enum CreateOrEditActionRuleDtoType {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export enum EntityChangeListDtoChangeType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export enum CreateOrEditSpecialSettingDtoType {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export enum CreateOrEditSpecialSettingDtoOccurType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export enum CreateOrEditProductCategoryDetailSettingDtoType {
    _1 = 1,
    _2 = 2,
}

export enum FriendDtoState {
    _1 = 1,
    _2 = 2,
}

export enum ChatMessageDtoSide {
    _1 = 1,
    _2 = 2,
}

export enum ChatMessageDtoReadState {
    _1 = 1,
    _2 = 2,
}

export enum ChatMessageDtoReceiverReadState {
    _1 = 1,
    _2 = 2,
}

export enum UserNotificationState {
    _0 = 0,
    _1 = 1,
}

export enum TenantNotificationSeverity {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export class AdditionalData implements IAdditionalData {
    paypal!: { [key: string]: string; } | undefined;

    constructor(data?: IAdditionalData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["Paypal"]) {
                this.paypal = {};
                for (let key in data["Paypal"]) {
                    if (data["Paypal"].hasOwnProperty(key))
                        this.paypal[key] = data["Paypal"][key];
                }
            }
        }
    }

    static fromJS(data: any): AdditionalData {
        data = typeof data === 'object' ? data : {};
        let result = new AdditionalData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.paypal) {
            data["Paypal"] = {};
            for (let key in this.paypal) {
                if (this.paypal.hasOwnProperty(key))
                    data["Paypal"][key] = this.paypal[key];
            }
        }
        return data;
    }
}

export interface IAdditionalData {
    paypal: { [key: string]: string; } | undefined;
}

export enum CreatePaymentDtoEditionPaymentType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export enum CreatePaymentDtoPaymentPeriodType {
    _30 = 30,
    _365 = 365,
}

export enum CreatePaymentDtoSubscriptionPaymentGatewayType {
    _1 = 1,
}

export enum CancelPaymentDtoGateway {
    _1 = 1,
}

export enum ExecutePaymentDtoGateway {
    _1 = 1,
}

export enum ExecutePaymentDtoEditionPaymentType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export enum ExecutePaymentDtoPaymentPeriodType {
    _30 = 30,
    _365 = 365,
}

export enum PeriodTimeHistoryDtoType {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
}

export enum CreateOrEditPeriodTimeHistoryDtoType {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
}

export enum GetPeriodTimeHistoryByFilterType {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
}

export enum ProductCategoryDetailDtoType {
    _1 = 1,
    _2 = 2,
}

export enum QuartzJobDtoStatus {
    _0 = 0,
    _1 = 1,
}

export enum QuartzJobDtoLastRunState {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export enum QuartzHistoryDtoState {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export enum GetAllQuestByGroupDtoQuestGroupType {
    _0 = 0,
    _1 = 1,
}

export enum QuestGroupDtoType {
    _0 = 0,
    _1 = 1,
}

export enum CreateOrEditQuestGroupDtoType {
    _0 = 0,
    _1 = 1,
}

export enum ComponentRulerDtoType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
    _8 = 8,
    _9 = 9,
    _10 = 10,
}

export enum CreateOrEditSAPSerialInputClassify {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export enum GetListSAPSerialResponseClassify {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export enum GetSAPSerialInputClassify {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export enum TenantLoginInfoDtoPaymentPeriodType {
    _30 = 30,
    _365 = 365,
}

export enum SpecialSettingDtoType {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export enum SpecialSettingDtoOccurType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export enum SystemSettingDtoType {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export enum SystemSettingDtoValidCoinType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export enum CreateOrEditSystemSettingDtoType {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export enum RegisterTenantInputSubscriptionStartType {
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export enum RegisterTenantInputGateway {
    _1 = 1,
}

export class SwaggerException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = function () {
                observer.next(this.result);
                observer.complete();
            }
            reader.readAsText(blob);
        }
    });
}

export class PagedResultDtoOfGetProductForTree implements IPagedResultDtoOfGetProductForTree {
    totalCount!: number | undefined;
    items!: GetProductForTree[] | undefined;

    constructor(data?: IPagedResultDtoOfGetProductForTree) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(item);
            }
        }
    }
}

export interface IPagedResultDtoOfGetProductForTree {
    totalCount: number | undefined;
    items: GetProductForTree[] | undefined;
}

export class GetProductForTree implements IGetProductForTree {
    product!: NodeProductDto | undefined;

    constructor(data?: IGetProductForTree) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }
}

export interface IGetProductForTree {
    product: NodeProductDto | undefined;
}

export class NodeProductDto implements INodeProductDto {
    productCode!: string | undefined;
    productName!: string | undefined;
    hierarchyL1!: string | undefined;
    hierarchyL2!: string | undefined;
    hierarchyL3!: string | undefined;
    hierarchyL4!: string | undefined;
    hierarchyL5!: string | undefined;
    status!: string | undefined;
    description!: string | undefined;

    constructor(data?: INodeProductDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.productCode = data["productCode"];
            this.productName = data["productName1"];
            this.hierarchyL1 = data["hierarchyL1"];
            this.hierarchyL2 = data["hierarchyL2"];
            this.hierarchyL3 = data["hierarchyL3"];
            this.hierarchyL4 = data["hierarchyL4"];
            this.hierarchyL5 = data["hierarchyL5"];
            this.status = data["status"];
            this.description = data["description"];
        }
    }
}

export interface INodeProductDto {
    productCode: string | undefined;
    productName: string | undefined;
    hierarchyL1: string | undefined;
    hierarchyL2: string | undefined;
    hierarchyL3: string | undefined;
    hierarchyL4: string | undefined;
    hierarchyL5: string | undefined;
    description: string | undefined;
    status: string | undefined;
}
